/**
 * react-ziggeo - Ziggeo's react component for easy react application deployment
 * @version v4.6.0
 * @author Ziggeo Inc
 * @link https://ziggeo.com
 * @license Apache-2.0
 * @version of Ziggeo ~2.39.16
 */
(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"));else if (typeof define === 'function' && define.amd) define(["react"], factory);else if (typeof exports === 'object') exports["ReactZiggeo"] = factory(require("react"));else root["ReactZiggeo"] = factory(root["React"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_50__) {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/
      var installedModules = {};
      /******/
      /******/ // The require function
      /******/
      function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/
        };
        /******/
        /******/ // Execute the module function
        /******/
        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/
        module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/
        return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/
      __webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/
      __webpack_require__.c = installedModules;
      /******/
      /******/ // identity function for calling harmony imports with the correct context
      /******/
      __webpack_require__.i = function (value) {
        return value;
      };
      /******/
      /******/ // define getter function for harmony exports
      /******/
      __webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            /******/configurable: false,
            /******/enumerable: true,
            /******/get: getter
            /******/
          });
          /******/
        }
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/
      __webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ? /******/function getDefault() {
          return module['default'];
        } : /******/function getModuleExports() {
          return module;
        };
        /******/
        __webpack_require__.d(getter, 'a', getter);
        /******/
        return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/
      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/
      __webpack_require__.p = "/static/";
      /******/
      /******/ // Load entry module and return exports
      /******/
      return __webpack_require__(__webpack_require__.s = 335);
      /******/
    }
    /************************************************************************/
    /******/([/* 0 */
    /***/function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var core = __webpack_require__(7);
      var hide = __webpack_require__(14);
      var redefine = __webpack_require__(11);
      var ctx = __webpack_require__(19);
      var PROTOTYPE = 'prototype';
      var $export = function $export(type, name, source) {
        var IS_FORCED = type & $export.F;
        var IS_GLOBAL = type & $export.G;
        var IS_STATIC = type & $export.S;
        var IS_PROTO = type & $export.P;
        var IS_BIND = type & $export.B;
        var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
        var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
        var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
        var key, own, out, exp;
        if (IS_GLOBAL) source = name;
        for (key in source) {
          // contains in native
          own = !IS_FORCED && target && target[key] !== undefined;
          // export native or passed
          out = (own ? target : source)[key];
          // bind timers to global for call from export context
          exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
          // extend global
          if (target) redefine(target, key, out, type & $export.U);
          // export
          if (exports[key] != out) hide(exports, key, exp);
          if (IS_PROTO && expProto[key] != out) expProto[key] = out;
        }
      };
      global.core = core;
      // type bitmap
      $export.F = 1; // forced
      $export.G = 2; // global
      $export.S = 4; // static
      $export.P = 8; // proto
      $export.B = 16; // bind
      $export.W = 32; // wrap
      $export.U = 64; // safe
      $export.R = 128; // real proto method for `library`
      module.exports = $export;

      /***/
    }, /* 1 */
    /***/function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(4);
      module.exports = function (it) {
        if (!isObject(it)) throw TypeError(it + ' is not an object!');
        return it;
      };

      /***/
    }, /* 2 */
    /***/function (module, exports) {
      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };

      /***/
    }, /* 3 */
    /***/function (module, exports) {
      // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
      var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
      // eslint-disable-next-line no-new-func
      : Function('return this')();
      if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

      /***/
    }, /* 4 */
    /***/function (module, exports) {
      module.exports = function (it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
      };

      /***/
    }, /* 5 */
    /***/function (module, exports, __webpack_require__) {
      var store = __webpack_require__(61)('wks');
      var uid = __webpack_require__(36);
      var Symbol = __webpack_require__(3).Symbol;
      var USE_SYMBOL = typeof Symbol == 'function';
      var $exports = module.exports = function (name) {
        return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
      };
      $exports.store = store;

      /***/
    }, /* 6 */
    /***/function (module, exports, __webpack_require__) {
      // 7.1.15 ToLength
      var toInteger = __webpack_require__(22);
      var min = Math.min;
      module.exports = function (it) {
        return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
      };

      /***/
    }, /* 7 */
    /***/function (module, exports) {
      var core = module.exports = {
        version: '2.6.12'
      };
      if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

      /***/
    }, /* 8 */
    /***/function (module, exports, __webpack_require__) {
      // Thank's IE8 for his funny defineProperty
      module.exports = !__webpack_require__(2)(function () {
        return Object.defineProperty({}, 'a', {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });

      /***/
    }, /* 9 */
    /***/function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(1);
      var IE8_DOM_DEFINE = __webpack_require__(102);
      var toPrimitive = __webpack_require__(27);
      var dP = Object.defineProperty;
      exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
          return dP(O, P, Attributes);
        } catch (e) {/* empty */}
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
      };

      /***/
    }, /* 10 */
    /***/function (module, exports, __webpack_require__) {
      // 7.1.13 ToObject(argument)
      var defined = __webpack_require__(24);
      module.exports = function (it) {
        return Object(defined(it));
      };

      /***/
    }, /* 11 */
    /***/function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var hide = __webpack_require__(14);
      var has = __webpack_require__(13);
      var SRC = __webpack_require__(36)('src');
      var $toString = __webpack_require__(167);
      var TO_STRING = 'toString';
      var TPL = ('' + $toString).split(TO_STRING);
      __webpack_require__(7).inspectSource = function (it) {
        return $toString.call(it);
      };
      (module.exports = function (O, key, val, safe) {
        var isFunction = typeof val == 'function';
        if (isFunction) has(val, 'name') || hide(val, 'name', key);
        if (O[key] === val) return;
        if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
        if (O === global) {
          O[key] = val;
        } else if (!safe) {
          delete O[key];
          hide(O, key, val);
        } else if (O[key]) {
          O[key] = val;
        } else {
          hide(O, key, val);
        }
        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
      })(Function.prototype, TO_STRING, function toString() {
        return typeof this == 'function' && this[SRC] || $toString.call(this);
      });

      /***/
    }, /* 12 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var fails = __webpack_require__(2);
      var defined = __webpack_require__(24);
      var quot = /"/g;
      // B.2.3.2.1 CreateHTML(string, tag, attribute, value)
      var createHTML = function createHTML(string, tag, attribute, value) {
        var S = String(defined(string));
        var p1 = '<' + tag;
        if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
        return p1 + '>' + S + '</' + tag + '>';
      };
      module.exports = function (NAME, exec) {
        var O = {};
        O[NAME] = exec(createHTML);
        $export($export.P + $export.F * fails(function () {
          var test = ''[NAME]('"');
          return test !== test.toLowerCase() || test.split('"').length > 3;
        }), 'String', O);
      };

      /***/
    }, /* 13 */
    /***/function (module, exports) {
      var hasOwnProperty = {}.hasOwnProperty;
      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };

      /***/
    }, /* 14 */
    /***/function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(9);
      var createDesc = __webpack_require__(34);
      module.exports = __webpack_require__(8) ? function (object, key, value) {
        return dP.f(object, key, createDesc(1, value));
      } : function (object, key, value) {
        object[key] = value;
        return object;
      };

      /***/
    }, /* 15 */
    /***/function (module, exports, __webpack_require__) {
      // to indexed object, toObject with fallback for non-array-like ES3 strings
      var IObject = __webpack_require__(46);
      var defined = __webpack_require__(24);
      module.exports = function (it) {
        return IObject(defined(it));
      };

      /***/
    }, /* 16 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var fails = __webpack_require__(2);
      module.exports = function (method, arg) {
        return !!method && fails(function () {
          // eslint-disable-next-line no-useless-call
          arg ? method.call(null, function () {/* empty */}, 1) : method.call(null);
        });
      };

      /***/
    }, /* 17 */
    /***/function (module, exports) {
      module.exports = function (it) {
        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
        return it;
      };

      /***/
    }, /* 18 */
    /***/function (module, exports, __webpack_require__) {
      // 0 -> Array#forEach
      // 1 -> Array#map
      // 2 -> Array#filter
      // 3 -> Array#some
      // 4 -> Array#every
      // 5 -> Array#find
      // 6 -> Array#findIndex
      var ctx = __webpack_require__(19);
      var IObject = __webpack_require__(46);
      var toObject = __webpack_require__(10);
      var toLength = __webpack_require__(6);
      var asc = __webpack_require__(98);
      module.exports = function (TYPE, $create) {
        var IS_MAP = TYPE == 1;
        var IS_FILTER = TYPE == 2;
        var IS_SOME = TYPE == 3;
        var IS_EVERY = TYPE == 4;
        var IS_FIND_INDEX = TYPE == 6;
        var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
        var create = $create || asc;
        return function ($this, callbackfn, that) {
          var O = toObject($this);
          var self = IObject(O);
          var f = ctx(callbackfn, that, 3);
          var length = toLength(self.length);
          var index = 0;
          var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
          var val, res;
          for (; length > index; index++) if (NO_HOLES || index in self) {
            val = self[index];
            res = f(val, index, O);
            if (TYPE) {
              if (IS_MAP) result[index] = res; // map
              else if (res) switch (TYPE) {
                case 3:
                  return true;
                // some
                case 5:
                  return val;
                // find
                case 6:
                  return index;
                // findIndex
                case 2:
                  result.push(val);
                // filter
              } else if (IS_EVERY) return false; // every
            }
          }

          return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
        };
      };

      /***/
    }, /* 19 */
    /***/function (module, exports, __webpack_require__) {
      // optional / simple context binding
      var aFunction = __webpack_require__(17);
      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;
        switch (length) {
          case 1:
            return function (a) {
              return fn.call(that, a);
            };
          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };
          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }
        return function /* ...args */
        () {
          return fn.apply(that, arguments);
        };
      };

      /***/
    }, /* 20 */
    /***/function (module, exports, __webpack_require__) {
      var pIE = __webpack_require__(47);
      var createDesc = __webpack_require__(34);
      var toIObject = __webpack_require__(15);
      var toPrimitive = __webpack_require__(27);
      var has = __webpack_require__(13);
      var IE8_DOM_DEFINE = __webpack_require__(102);
      var gOPD = Object.getOwnPropertyDescriptor;
      exports.f = __webpack_require__(8) ? gOPD : function getOwnPropertyDescriptor(O, P) {
        O = toIObject(O);
        P = toPrimitive(P, true);
        if (IE8_DOM_DEFINE) try {
          return gOPD(O, P);
        } catch (e) {/* empty */}
        if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
      };

      /***/
    }, /* 21 */
    /***/function (module, exports, __webpack_require__) {
      // most Object methods by ES6 should accept primitives
      var $export = __webpack_require__(0);
      var core = __webpack_require__(7);
      var fails = __webpack_require__(2);
      module.exports = function (KEY, exec) {
        var fn = (core.Object || {})[KEY] || Object[KEY];
        var exp = {};
        exp[KEY] = exec(fn);
        $export($export.S + $export.F * fails(function () {
          fn(1);
        }), 'Object', exp);
      };

      /***/
    }, /* 22 */
    /***/function (module, exports) {
      // 7.1.4 ToInteger
      var ceil = Math.ceil;
      var floor = Math.floor;
      module.exports = function (it) {
        return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
      };

      /***/
    }, /* 23 */
    /***/function (module, exports) {
      var toString = {}.toString;
      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };

      /***/
    }, /* 24 */
    /***/function (module, exports) {
      // 7.2.1 RequireObjectCoercible(argument)
      module.exports = function (it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
      };

      /***/
    }, /* 25 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      if (__webpack_require__(8)) {
        var LIBRARY = __webpack_require__(29);
        var global = __webpack_require__(3);
        var fails = __webpack_require__(2);
        var $export = __webpack_require__(0);
        var $typed = __webpack_require__(62);
        var $buffer = __webpack_require__(88);
        var ctx = __webpack_require__(19);
        var anInstance = __webpack_require__(38);
        var propertyDesc = __webpack_require__(34);
        var hide = __webpack_require__(14);
        var redefineAll = __webpack_require__(40);
        var toInteger = __webpack_require__(22);
        var toLength = __webpack_require__(6);
        var toIndex = __webpack_require__(121);
        var toAbsoluteIndex = __webpack_require__(35);
        var toPrimitive = __webpack_require__(27);
        var has = __webpack_require__(13);
        var classof = __webpack_require__(45);
        var isObject = __webpack_require__(4);
        var toObject = __webpack_require__(10);
        var isArrayIter = __webpack_require__(75);
        var create = __webpack_require__(30);
        var getPrototypeOf = __webpack_require__(32);
        var gOPN = __webpack_require__(31).f;
        var getIterFn = __webpack_require__(90);
        var uid = __webpack_require__(36);
        var wks = __webpack_require__(5);
        var createArrayMethod = __webpack_require__(18);
        var createArrayIncludes = __webpack_require__(52);
        var speciesConstructor = __webpack_require__(48);
        var ArrayIterators = __webpack_require__(91);
        var Iterators = __webpack_require__(39);
        var $iterDetect = __webpack_require__(58);
        var setSpecies = __webpack_require__(41);
        var arrayFill = __webpack_require__(68);
        var arrayCopyWithin = __webpack_require__(96);
        var $DP = __webpack_require__(9);
        var $GOPD = __webpack_require__(20);
        var dP = $DP.f;
        var gOPD = $GOPD.f;
        var RangeError = global.RangeError;
        var TypeError = global.TypeError;
        var Uint8Array = global.Uint8Array;
        var ARRAY_BUFFER = 'ArrayBuffer';
        var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
        var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
        var PROTOTYPE = 'prototype';
        var ArrayProto = Array[PROTOTYPE];
        var $ArrayBuffer = $buffer.ArrayBuffer;
        var $DataView = $buffer.DataView;
        var arrayForEach = createArrayMethod(0);
        var arrayFilter = createArrayMethod(2);
        var arraySome = createArrayMethod(3);
        var arrayEvery = createArrayMethod(4);
        var arrayFind = createArrayMethod(5);
        var arrayFindIndex = createArrayMethod(6);
        var arrayIncludes = createArrayIncludes(true);
        var arrayIndexOf = createArrayIncludes(false);
        var arrayValues = ArrayIterators.values;
        var arrayKeys = ArrayIterators.keys;
        var arrayEntries = ArrayIterators.entries;
        var arrayLastIndexOf = ArrayProto.lastIndexOf;
        var arrayReduce = ArrayProto.reduce;
        var arrayReduceRight = ArrayProto.reduceRight;
        var arrayJoin = ArrayProto.join;
        var arraySort = ArrayProto.sort;
        var arraySlice = ArrayProto.slice;
        var arrayToString = ArrayProto.toString;
        var arrayToLocaleString = ArrayProto.toLocaleString;
        var ITERATOR = wks('iterator');
        var TAG = wks('toStringTag');
        var TYPED_CONSTRUCTOR = uid('typed_constructor');
        var DEF_CONSTRUCTOR = uid('def_constructor');
        var ALL_CONSTRUCTORS = $typed.CONSTR;
        var TYPED_ARRAY = $typed.TYPED;
        var VIEW = $typed.VIEW;
        var WRONG_LENGTH = 'Wrong length!';
        var $map = createArrayMethod(1, function (O, length) {
          return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
        });
        var LITTLE_ENDIAN = fails(function () {
          // eslint-disable-next-line no-undef
          return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
        });
        var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
          new Uint8Array(1).set({});
        });
        var toOffset = function toOffset(it, BYTES) {
          var offset = toInteger(it);
          if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
          return offset;
        };
        var validate = function validate(it) {
          if (isObject(it) && TYPED_ARRAY in it) return it;
          throw TypeError(it + ' is not a typed array!');
        };
        var allocate = function allocate(C, length) {
          if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
            throw TypeError('It is not a typed array constructor!');
          }
          return new C(length);
        };
        var speciesFromList = function speciesFromList(O, list) {
          return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
        };
        var fromList = function fromList(C, list) {
          var index = 0;
          var length = list.length;
          var result = allocate(C, length);
          while (length > index) result[index] = list[index++];
          return result;
        };
        var addGetter = function addGetter(it, key, internal) {
          dP(it, key, {
            get: function get() {
              return this._d[internal];
            }
          });
        };
        var $from = function from(source /* , mapfn, thisArg */) {
          var O = toObject(source);
          var aLen = arguments.length;
          var mapfn = aLen > 1 ? arguments[1] : undefined;
          var mapping = mapfn !== undefined;
          var iterFn = getIterFn(O);
          var i, length, values, result, step, iterator;
          if (iterFn != undefined && !isArrayIter(iterFn)) {
            for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
              values.push(step.value);
            }
            O = values;
          }
          if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
          for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
            result[i] = mapping ? mapfn(O[i], i) : O[i];
          }
          return result;
        };
        var $of = function of( /* ...items */
        ) {
          var index = 0;
          var length = arguments.length;
          var result = allocate(this, length);
          while (length > index) result[index] = arguments[index++];
          return result;
        };

        // iOS Safari 6.x fails here
        var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
          arrayToLocaleString.call(new Uint8Array(1));
        });
        var $toLocaleString = function toLocaleString() {
          return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
        };
        var proto = {
          copyWithin: function copyWithin(target, start /* , end */) {
            return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
          },
          every: function every(callbackfn /* , thisArg */) {
            return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          fill: function fill(value /* , start, end */) {
            // eslint-disable-line no-unused-vars
            return arrayFill.apply(validate(this), arguments);
          },
          filter: function filter(callbackfn /* , thisArg */) {
            return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
          },
          find: function find(predicate /* , thisArg */) {
            return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
          },
          findIndex: function findIndex(predicate /* , thisArg */) {
            return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
          },
          forEach: function forEach(callbackfn /* , thisArg */) {
            arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          indexOf: function indexOf(searchElement /* , fromIndex */) {
            return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
          },
          includes: function includes(searchElement /* , fromIndex */) {
            return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
          },
          join: function join(separator) {
            // eslint-disable-line no-unused-vars
            return arrayJoin.apply(validate(this), arguments);
          },
          lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) {
            // eslint-disable-line no-unused-vars
            return arrayLastIndexOf.apply(validate(this), arguments);
          },
          map: function map(mapfn /* , thisArg */) {
            return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          reduce: function reduce(callbackfn /* , initialValue */) {
            // eslint-disable-line no-unused-vars
            return arrayReduce.apply(validate(this), arguments);
          },
          reduceRight: function reduceRight(callbackfn /* , initialValue */) {
            // eslint-disable-line no-unused-vars
            return arrayReduceRight.apply(validate(this), arguments);
          },
          reverse: function reverse() {
            var that = this;
            var length = validate(that).length;
            var middle = Math.floor(length / 2);
            var index = 0;
            var value;
            while (index < middle) {
              value = that[index];
              that[index++] = that[--length];
              that[length] = value;
            }
            return that;
          },
          some: function some(callbackfn /* , thisArg */) {
            return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          sort: function sort(comparefn) {
            return arraySort.call(validate(this), comparefn);
          },
          subarray: function subarray(begin, end) {
            var O = validate(this);
            var length = O.length;
            var $begin = toAbsoluteIndex(begin, length);
            return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
          }
        };
        var $slice = function slice(start, end) {
          return speciesFromList(this, arraySlice.call(validate(this), start, end));
        };
        var $set = function set(arrayLike /* , offset */) {
          validate(this);
          var offset = toOffset(arguments[1], 1);
          var length = this.length;
          var src = toObject(arrayLike);
          var len = toLength(src.length);
          var index = 0;
          if (len + offset > length) throw RangeError(WRONG_LENGTH);
          while (index < len) this[offset + index] = src[index++];
        };
        var $iterators = {
          entries: function entries() {
            return arrayEntries.call(validate(this));
          },
          keys: function keys() {
            return arrayKeys.call(validate(this));
          },
          values: function values() {
            return arrayValues.call(validate(this));
          }
        };
        var isTAIndex = function isTAIndex(target, key) {
          return isObject(target) && target[TYPED_ARRAY] && typeof key != 'symbol' && key in target && String(+key) == String(key);
        };
        var $getDesc = function getOwnPropertyDescriptor(target, key) {
          return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
        };
        var $setDesc = function defineProperty(target, key, desc) {
          if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set')
          // TODO: add validation descriptor w/o calling accessors
          && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
            target[key] = desc.value;
            return target;
          }
          return dP(target, key, desc);
        };
        if (!ALL_CONSTRUCTORS) {
          $GOPD.f = $getDesc;
          $DP.f = $setDesc;
        }
        $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
          getOwnPropertyDescriptor: $getDesc,
          defineProperty: $setDesc
        });
        if (fails(function () {
          arrayToString.call({});
        })) {
          arrayToString = arrayToLocaleString = function toString() {
            return arrayJoin.call(this);
          };
        }
        var $TypedArrayPrototype$ = redefineAll({}, proto);
        redefineAll($TypedArrayPrototype$, $iterators);
        hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
        redefineAll($TypedArrayPrototype$, {
          slice: $slice,
          set: $set,
          constructor: function constructor() {/* noop */},
          toString: arrayToString,
          toLocaleString: $toLocaleString
        });
        addGetter($TypedArrayPrototype$, 'buffer', 'b');
        addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
        addGetter($TypedArrayPrototype$, 'byteLength', 'l');
        addGetter($TypedArrayPrototype$, 'length', 'e');
        dP($TypedArrayPrototype$, TAG, {
          get: function get() {
            return this[TYPED_ARRAY];
          }
        });

        // eslint-disable-next-line max-statements
        module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
          CLAMPED = !!CLAMPED;
          var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
          var GETTER = 'get' + KEY;
          var SETTER = 'set' + KEY;
          var TypedArray = global[NAME];
          var Base = TypedArray || {};
          var TAC = TypedArray && getPrototypeOf(TypedArray);
          var FORCED = !TypedArray || !$typed.ABV;
          var O = {};
          var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
          var getter = function getter(that, index) {
            var data = that._d;
            return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
          };
          var setter = function setter(that, index, value) {
            var data = that._d;
            if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
            data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
          };
          var addElement = function addElement(that, index) {
            dP(that, index, {
              get: function get() {
                return getter(this, index);
              },
              set: function set(value) {
                return setter(this, index, value);
              },
              enumerable: true
            });
          };
          if (FORCED) {
            TypedArray = wrapper(function (that, data, $offset, $length) {
              anInstance(that, TypedArray, NAME, '_d');
              var index = 0;
              var offset = 0;
              var buffer, byteLength, length, klass;
              if (!isObject(data)) {
                length = toIndex(data);
                byteLength = length * BYTES;
                buffer = new $ArrayBuffer(byteLength);
              } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
                buffer = data;
                offset = toOffset($offset, BYTES);
                var $len = data.byteLength;
                if ($length === undefined) {
                  if ($len % BYTES) throw RangeError(WRONG_LENGTH);
                  byteLength = $len - offset;
                  if (byteLength < 0) throw RangeError(WRONG_LENGTH);
                } else {
                  byteLength = toLength($length) * BYTES;
                  if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
                }
                length = byteLength / BYTES;
              } else if (TYPED_ARRAY in data) {
                return fromList(TypedArray, data);
              } else {
                return $from.call(TypedArray, data);
              }
              hide(that, '_d', {
                b: buffer,
                o: offset,
                l: byteLength,
                e: length,
                v: new $DataView(buffer)
              });
              while (index < length) addElement(that, index++);
            });
            TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
            hide(TypedArrayPrototype, 'constructor', TypedArray);
          } else if (!fails(function () {
            TypedArray(1);
          }) || !fails(function () {
            new TypedArray(-1); // eslint-disable-line no-new
          }) || !$iterDetect(function (iter) {
            new TypedArray(); // eslint-disable-line no-new
            new TypedArray(null); // eslint-disable-line no-new
            new TypedArray(1.5); // eslint-disable-line no-new
            new TypedArray(iter); // eslint-disable-line no-new
          }, true)) {
            TypedArray = wrapper(function (that, data, $offset, $length) {
              anInstance(that, TypedArray, NAME);
              var klass;
              // `ws` module bug, temporarily remove validation length for Uint8Array
              // https://github.com/websockets/ws/pull/645
              if (!isObject(data)) return new Base(toIndex(data));
              if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
                return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
              }
              if (TYPED_ARRAY in data) return fromList(TypedArray, data);
              return $from.call(TypedArray, data);
            });
            arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
              if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
            });
            TypedArray[PROTOTYPE] = TypedArrayPrototype;
            if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
          }
          var $nativeIterator = TypedArrayPrototype[ITERATOR];
          var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
          var $iterator = $iterators.values;
          hide(TypedArray, TYPED_CONSTRUCTOR, true);
          hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
          hide(TypedArrayPrototype, VIEW, true);
          hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
          if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
            dP(TypedArrayPrototype, TAG, {
              get: function get() {
                return NAME;
              }
            });
          }
          O[NAME] = TypedArray;
          $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
          $export($export.S, NAME, {
            BYTES_PER_ELEMENT: BYTES
          });
          $export($export.S + $export.F * fails(function () {
            Base.of.call(TypedArray, 1);
          }), NAME, {
            from: $from,
            of: $of
          });
          if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
          $export($export.P, NAME, proto);
          setSpecies(NAME);
          $export($export.P + $export.F * FORCED_SET, NAME, {
            set: $set
          });
          $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
          if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
          $export($export.P + $export.F * fails(function () {
            new TypedArray(1).slice();
          }), NAME, {
            slice: $slice
          });
          $export($export.P + $export.F * (fails(function () {
            return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
          }) || !fails(function () {
            TypedArrayPrototype.toLocaleString.call([1, 2]);
          })), NAME, {
            toLocaleString: $toLocaleString
          });
          Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
          if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
        };
      } else module.exports = function () {/* empty */};

      /***/
    }, /* 26 */
    /***/function (module, exports, __webpack_require__) {
      var META = __webpack_require__(36)('meta');
      var isObject = __webpack_require__(4);
      var has = __webpack_require__(13);
      var setDesc = __webpack_require__(9).f;
      var id = 0;
      var isExtensible = Object.isExtensible || function () {
        return true;
      };
      var FREEZE = !__webpack_require__(2)(function () {
        return isExtensible(Object.preventExtensions({}));
      });
      var setMeta = function setMeta(it) {
        setDesc(it, META, {
          value: {
            i: 'O' + ++id,
            // object ID
            w: {} // weak collections IDs
          }
        });
      };

      var fastKey = function fastKey(it, create) {
        // return primitive with prefix
        if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
        if (!has(it, META)) {
          // can't set metadata to uncaught frozen object
          if (!isExtensible(it)) return 'F';
          // not necessary to add metadata
          if (!create) return 'E';
          // add missing metadata
          setMeta(it);
          // return object ID
        }
        return it[META].i;
      };
      var getWeak = function getWeak(it, create) {
        if (!has(it, META)) {
          // can't set metadata to uncaught frozen object
          if (!isExtensible(it)) return true;
          // not necessary to add metadata
          if (!create) return false;
          // add missing metadata
          setMeta(it);
          // return hash weak collections IDs
        }
        return it[META].w;
      };
      // add metadata on freeze-family methods calling
      var onFreeze = function onFreeze(it) {
        if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
        return it;
      };
      var meta = module.exports = {
        KEY: META,
        NEED: false,
        fastKey: fastKey,
        getWeak: getWeak,
        onFreeze: onFreeze
      };

      /***/
    }, /* 27 */
    /***/function (module, exports, __webpack_require__) {
      // 7.1.1 ToPrimitive(input [, PreferredType])
      var isObject = __webpack_require__(4);
      // instead of the ES6 spec version, we didn't implement @@toPrimitive case
      // and the second argument - flag - preferred type is a string
      module.exports = function (it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
      };

      /***/
    }, /* 28 */
    /***/function (module, exports, __webpack_require__) {
      // 22.1.3.31 Array.prototype[@@unscopables]
      var UNSCOPABLES = __webpack_require__(5)('unscopables');
      var ArrayProto = Array.prototype;
      if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(14)(ArrayProto, UNSCOPABLES, {});
      module.exports = function (key) {
        ArrayProto[UNSCOPABLES][key] = true;
      };

      /***/
    }, /* 29 */
    /***/function (module, exports) {
      module.exports = false;

      /***/
    }, /* 30 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
      var anObject = __webpack_require__(1);
      var dPs = __webpack_require__(111);
      var enumBugKeys = __webpack_require__(71);
      var IE_PROTO = __webpack_require__(82)('IE_PROTO');
      var Empty = function Empty() {/* empty */};
      var PROTOTYPE = 'prototype';

      // Create object with fake `null` prototype: use iframe Object with cleared prototype
      var _createDict = function createDict() {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = __webpack_require__(70)('iframe');
        var i = enumBugKeys.length;
        var lt = '<';
        var gt = '>';
        var iframeDocument;
        iframe.style.display = 'none';
        __webpack_require__(73).appendChild(iframe);
        iframe.src = 'javascript:'; // eslint-disable-line no-script-url
        // createDict = iframe.contentWindow.Object;
        // html.removeChild(iframe);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
        iframeDocument.close();
        _createDict = iframeDocument.F;
        while (i--) delete _createDict[PROTOTYPE][enumBugKeys[i]];
        return _createDict();
      };
      module.exports = Object.create || function create(O, Properties) {
        var result;
        if (O !== null) {
          Empty[PROTOTYPE] = anObject(O);
          result = new Empty();
          Empty[PROTOTYPE] = null;
          // add "__proto__" for Object.getPrototypeOf polyfill
          result[IE_PROTO] = O;
        } else result = _createDict();
        return Properties === undefined ? result : dPs(result, Properties);
      };

      /***/
    }, /* 31 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
      var $keys = __webpack_require__(113);
      var hiddenKeys = __webpack_require__(71).concat('length', 'prototype');
      exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return $keys(O, hiddenKeys);
      };

      /***/
    }, /* 32 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
      var has = __webpack_require__(13);
      var toObject = __webpack_require__(10);
      var IE_PROTO = __webpack_require__(82)('IE_PROTO');
      var ObjectProto = Object.prototype;
      module.exports = Object.getPrototypeOf || function (O) {
        O = toObject(O);
        if (has(O, IE_PROTO)) return O[IE_PROTO];
        if (typeof O.constructor == 'function' && O instanceof O.constructor) {
          return O.constructor.prototype;
        }
        return O instanceof Object ? ObjectProto : null;
      };

      /***/
    }, /* 33 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.14 / 15.2.3.14 Object.keys(O)
      var $keys = __webpack_require__(113);
      var enumBugKeys = __webpack_require__(71);
      module.exports = Object.keys || function keys(O) {
        return $keys(O, enumBugKeys);
      };

      /***/
    }, /* 34 */
    /***/function (module, exports) {
      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        };
      };

      /***/
    }, /* 35 */
    /***/function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(22);
      var max = Math.max;
      var min = Math.min;
      module.exports = function (index, length) {
        index = toInteger(index);
        return index < 0 ? max(index + length, 0) : min(index, length);
      };

      /***/
    }, /* 36 */
    /***/function (module, exports) {
      var id = 0;
      var px = Math.random();
      module.exports = function (key) {
        return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
      };

      /***/
    }, /* 37 */
    /***/function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(4);
      module.exports = function (it, TYPE) {
        if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
        return it;
      };

      /***/
    }, /* 38 */
    /***/function (module, exports) {
      module.exports = function (it, Constructor, name, forbiddenField) {
        if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
          throw TypeError(name + ': incorrect invocation!');
        }
        return it;
      };

      /***/
    }, /* 39 */
    /***/function (module, exports) {
      module.exports = {};

      /***/
    }, /* 40 */
    /***/function (module, exports, __webpack_require__) {
      var redefine = __webpack_require__(11);
      module.exports = function (target, src, safe) {
        for (var key in src) redefine(target, key, src[key], safe);
        return target;
      };

      /***/
    }, /* 41 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var global = __webpack_require__(3);
      var dP = __webpack_require__(9);
      var DESCRIPTORS = __webpack_require__(8);
      var SPECIES = __webpack_require__(5)('species');
      module.exports = function (KEY) {
        var C = global[KEY];
        if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
          configurable: true,
          get: function get() {
            return this;
          }
        });
      };

      /***/
    }, /* 42 */
    /***/function (module, exports, __webpack_require__) {
      var def = __webpack_require__(9).f;
      var has = __webpack_require__(13);
      var TAG = __webpack_require__(5)('toStringTag');
      module.exports = function (it, tag, stat) {
        if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
          configurable: true,
          value: tag
        });
      };

      /***/
    }, /* 43 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var defined = __webpack_require__(24);
      var fails = __webpack_require__(2);
      var spaces = __webpack_require__(86);
      var space = '[' + spaces + ']';
      var non = "\u200B\x85";
      var ltrim = RegExp('^' + space + space + '*');
      var rtrim = RegExp(space + space + '*$');
      var exporter = function exporter(KEY, exec, ALIAS) {
        var exp = {};
        var FORCE = fails(function () {
          return !!spaces[KEY]() || non[KEY]() != non;
        });
        var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
        if (ALIAS) exp[ALIAS] = fn;
        $export($export.P + $export.F * FORCE, 'String', exp);
      };

      // 1 -> String#trimLeft
      // 2 -> String#trimRight
      // 3 -> String#trim
      var trim = exporter.trim = function (string, TYPE) {
        string = String(defined(string));
        if (TYPE & 1) string = string.replace(ltrim, '');
        if (TYPE & 2) string = string.replace(rtrim, '');
        return string;
      };
      module.exports = exporter;

      /***/
    }, /* 44 */
    /***/function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "g", function () {
        return ziggeoRecorderAttributesPropTypes;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "j", function () {
        return ziggeoPlayerAttributesPropTypes;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "a", function () {
        return ziggeoAudioRecorderAttributesPropTypes;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "h", function () {
        return ziggeoAudioPlayerAttributesPropTypes;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "c", function () {
        return ziggeoRecorderEmbeddingEventsPropTypes;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "i", function () {
        return ziggeoPlayerEmbeddingEventsPropTypes;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "d", function () {
        return ziggeoCommonEmbeddingEventsPropTypes;
      });
      /* unused harmony export ziggeoMethods */
      /* unused harmony export ziggeoApiEventsPropTypes */
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "f", function () {
        return reactCustomOptions;
      });
      /* unused harmony export ziggeoApplicationEvents */
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "e", function () {
        return ziggeoRecorderApplicationOptions;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "b", function () {
        return ziggeoPlayerApplicationOptions;
      });
      /* unused harmony export screenRecorderOptions */
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(126);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
      // ####################### Player/Recorder Attributes #############################
      // When using HTML embed methods, all parameters should be prefixed with ziggeo-
      // https://ziggeo.com/docs/sdks/javascript/browser-integration/parameters#javascript-revision=v1-r29&javascript-version=v2

      var ziggeoRecorderAttributesPropTypes = {
        // Presentational parameters
        'width': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'height': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'responsive': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'faceoutline': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'skipinitial': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'skipinitialonrerecord': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'picksnapshots': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'countdown': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'stream-width': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'stream-height': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'nofullscreen': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'snapshotmax': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'gallerysnapshots': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'localplayback': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'stretch': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'stretchwidth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'stretchheight': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'theme': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'themecolor': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'autorecord': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'primaryrecord': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'flip-camera': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        "flipscreen": __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        // Will affect as true, if flip-camera also set as true
        'early-rerecord': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'sharevideo': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
        'transcript-language': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'allowtexttrackupload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'uploadlocales': __WEBPACK_IMPORTED_MODULE_0_prop_types__["array"],
        'audio-test-mandatory': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'playermodeifexists': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'rerecordableifexists': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'preview-effect-profile': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'popup-width': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'popup-height': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'snapshotfrommobilecapture': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        // Security parameters
        'server-auth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'client-auth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'expiration-days': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        // Video management parameters
        'recordingwidth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'recordingheight': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'minuploadingwidth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'maxuploadingwidth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'minuploadingheight': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'maxuploadingheight': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'video': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'auto-crop': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'auto-pad': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        '_key': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        "rtmpstreamtype": __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        "rtmpmicrophonecodec": __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'timelimit': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'timeminlimit': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'video-profile': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"])]),
        'effect-profile': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"])]),
        'meta-profile': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"])]),
        'cpu-friendly': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'enforce-duration': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'noaudio': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'source': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'framerate': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'framerate-warning': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'snapshottype': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'videobitrate': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'audiobitrate': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'microphone-volume': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'custom-covershots': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'selectfirstcovershotonskip': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'picksnapshotmandatory': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'pausable': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'snapshotfromuploader': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'allowmultistreams': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'multistreamreversable': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'multistreamdraggable': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'multistreamresizeable': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'addstreamproportional': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'addstreampositionx': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'addstreampositiony': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'addstreampositionwidth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'addstreampositionheight': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'addstreamminwidth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'addstreamminheight': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'fullscreenmandatory': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'fittodimensions': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        // Data parameters
        'tags': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
        'custom-data': __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
        'title': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'description': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        // Operational parameters
        'manual_upload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'rerecordable': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'allowupload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'allowscreen': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'allowrecord': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'display-timer': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'force-overwrite': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'autoplay': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'recordings': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'allowedextensions': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
        'application': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        //	oneOfType([object, string]),
        'filesizelimit': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'flashincognitosupport': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'simulate': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'allowcustomupload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'manual-upload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'camerafacefront': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'createthumbnails': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'skipseconds': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'showsettingsmenu': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        // As a property show/hide from users
        'hidevolumebar': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'recordermode': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'forceflash': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'noflash': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'manualsubmit': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'initialseek': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'playfullscreenonmobile': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'playwhenvisible': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'playonclick': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'disableseeking': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'disablepause': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'pauseonplay': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'onlyaudio': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'airplay': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'chromecast': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'preload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'delete-old-streams': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'lazy-application': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'allowcancel': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'orientation': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'popup': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'popup-stretch': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        // Form and HTML parameters
        'input-bind': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'form-accept': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
      };
      var ziggeoPlayerAttributesPropTypes = {
        // Presentational parameters
        'width': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'height': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'responsive': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'skipinitial': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'picksnapshots': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'countdown': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'stream-width': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'stream-height': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'nofullscreen': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'localplayback': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'theme': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'themecolor': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'sharevideo': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
        'loop': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'loopall': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'volume': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'showduration': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'uploadlocales': __WEBPACK_IMPORTED_MODULE_0_prop_types__["array"],
        'allowtexttrackupload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'audio-transcription-as-subtitles': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'playlist': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["array"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'popup': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'popup-stretch': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'popup-width': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'popup-height': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        // Security parameters
        'server-auth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'client-auth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'stretch': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'hideoninactivity': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'hidebarafter': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        // in milliseconds
        'preventinteraction': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'stretchwidth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'stretchheight': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        // Video management parameters
        'video': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
        'stream': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        '_key': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'effect-profile': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"])]),
        'video-profile': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"])]),
        'noaudio': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'poster': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'source': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'framerate': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'videobitrate': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'audiobitrate': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        // Data parameters
        'tags': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
        'custom-data': __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
        'title': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'description': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        // Operational parameters
        'allowpip': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]]),
        // Disable Picture-In-Picture by default, Has to be boolean. Need present func also because of Ziggeo internally used as function
        'autoplay': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'application': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        // oneOfType([object, string]),
        'flashincognitosupport': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'forceflash': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'noflash': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'initialseek': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'playfullscreenonmobile': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'playwhenvisible': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'playonclick': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'disableseeking': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'disablepause': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'pauseonplay': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'onlyaudio': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'airplay': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'chromecast': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'preload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'lazy-application': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'preroll': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'vast': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]),
        // Form and HTML parameters
        'input-bind': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'form-accept': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"] // // handle special cases
        // handleVideo: function(props, propName, componentName) {
        //     if( (props['video'] === undefined || props['video'].length < 1) &&
        //         (props['video-profile'] === undefined || props['video-profile'].length < 1)
        //     ) {
        //         return new Error(
        //             'Please provide with video or video-profile token to component' +
        //             ' `' + componentName + '`. Validation failed'
        //         )
        //     }
        // },
      };

      var ziggeoAudioRecorderAttributesPropTypes = {
        // Presentational parameters
        'width': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'height': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'responsive': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'skipinitial': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'skipinitialonrerecord': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'countdown': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'nofullscreen': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'localplayback': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'theme': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'themecolor': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'autorecord': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'primaryrecord': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'early-rerecord': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'transcript-language': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'allowtexttrackupload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'uploadlocales': __WEBPACK_IMPORTED_MODULE_0_prop_types__["array"],
        'audio-test-mandatory': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'playermodeifexists': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'rerecordableifexists': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'popup-width': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'popup-height': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        // Security parameters
        'server-auth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'client-auth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'expiration-days': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        // Video management parameters
        'audio': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        '_key': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        "rtmpstreamtype": __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        "rtmpmicrophonecodec": __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'timelimit': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'timeminlimit': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'audio-profile': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"])]),
        'effect-profile': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"])]),
        'meta-profile': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"])]),
        'enforce-duration': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'source': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'audiobitrate': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'microphone-volume': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'pausable': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        // Data parameters
        'tags': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
        'custom-data': __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
        'title': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'description': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        // Operational parameters
        'manual_upload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'rerecordable': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'allowupload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'allowrecord': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'display-timer': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'force-overwrite': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'autoplay': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'recordings': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'allowedextensions': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
        'application': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        //	oneOfType([object, string]),
        'filesizelimit': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'simulate': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'allowcustomupload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'manual-upload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'skipseconds': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'showsettingsmenu': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        // As a property show/hide from users
        'hidevolumebar': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'recordermode': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'manualsubmit': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'initialseek': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'playwhenvisible': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'playonclick': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'disableseeking': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'disablepause': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'pauseonplay': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'airplay': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'chromecast': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'preload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'delete-old-streams': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'lazy-application': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'allowcancel': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'popup': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        // Form and HTML parameters
        'input-bind': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'form-accept': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
      };
      var ziggeoAudioPlayerAttributesPropTypes = {
        // Presentational parameters
        'width': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'height': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'skipinitial': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'countdown': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'localplayback': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'theme': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'themecolor': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'loop': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'loopall': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'volume': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'showduration': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'uploadlocales': __WEBPACK_IMPORTED_MODULE_0_prop_types__["array"],
        'allowtexttrackupload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'audio-transcription-as-subtitles': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'playlist': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["array"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'popup': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'popup-width': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        'popup-height': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        // Security parameters
        'server-auth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'client-auth': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'hideoninactivity': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'hidebarafter': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        // in milliseconds
        'preventinteraction': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        // Audio management parameters
        'audio': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
        '_key': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'effect-profile': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"])]),
        'source': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'audiobitrate': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]),
        // Data parameters
        'tags': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]),
        'custom-data': __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
        'title': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'description': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        // Operational parameters
        'autoplay': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'application': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        // oneOfType([object, string]),
        'flashincognitosupport': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'forceflash': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'noflash': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'initialseek': __WEBPACK_IMPORTED_MODULE_0_prop_types__["number"],
        'playwhenvisible': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'playonclick': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'disableseeking': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'disablepause': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'pauseonplay': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'airplay': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'chromecast': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'preload': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'lazy-application': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'preroll': __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        'vast': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]),
        // Form and HTML parameters
        'input-bind': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        'form-accept': __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
      }; // #######################  DEFAULTS  ##################################
      // #######################  EMBEDDING EVENTS #############################
      // Javascript Embed Recorder Events
      // https://ziggeo.com/docs/sdks/javascript/browser-interaction/application-embedding-events#javascript-revision=v1-r29
      // application.embed_event.on..

      var ziggeoRecorderEmbeddingEventsPropTypes = {
        onPlaying: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onPaused: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEnded: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onSeek: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onManuallySubmitted: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onRecordingProgress: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onUploaded: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onUploadSelected: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onUploading: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onRerecord: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onCountdown: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onProgress: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onUploadProgress: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onProcessing: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onProcessed: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onAccessForbidden: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onAccessGranted: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onCameraUnresponsive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onVerified: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onNoCamera: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onNoMicrophone: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onRef: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]
      };
      var ziggeoPlayerEmbeddingEventsPropTypes = {
        onPlaying: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onPaused: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEnded: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onSeek: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onReadyToPlay: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onRef: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]
      };
      var ziggeoCommonEmbeddingEventsPropTypes = {
        onAttached: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onRecording: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onLoaded: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onError: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]
      }; // #######################  ZIGGEO METHODS  ##############################
      // Methods
      // https://ziggeo.com/docs/sdks/javascript/browser-interaction/methods#javascript-revision=v1-r29&javascript-version=v2

      var ziggeoMethods = {
        play: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        record: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        upload: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        rerecord: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        stop: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        stopRecord: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        hidePopup: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        reset: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        lightLevel: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        soundLevel: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        averageFrameRate: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        isRecording: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        width: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        height: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        isFlash: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        videoWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        videoHeight: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        destroy: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]
      }; // #######################    ##############################
      // Common Events
      // https://ziggeo.com/docs/sdks/javascript/browser-interaction/events#javascript-revision=v1-r29&javascript-version=v2

      var ziggeoApiEventsPropTypes = {
        onEventPlay: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventPause: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventStop: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventErrorPlayer: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventSubmitted: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventPlayerSeek: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventManuallySubmitted: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventUploaded: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventUploadSelected: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventRecording: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventUploading: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventFinished: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventDiscarded: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventErrorRecorder: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventCountdown: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventElapsed: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventUploadProgress: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventProcessingProgress: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventReadyToRecord: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventReadyToPlay: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventAccessForbidden: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventAccessGranted: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventAccessRevoked: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onEventRecorderProcessed: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]
      }; // #######################  React Common Options  ##############################

      var reactCustomOptions = {
        preventReRenderOnUpdate: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        updateInstance: __WEBPACK_IMPORTED_MODULE_0_prop_types__["any"]
      }; // ####################### Application Events #############################
      // application.embed_event.on..

      var ziggeoApplicationEvents = {
        onError: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
        onReady: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]
      };
      var ziggeoRecorderApplicationOptions = {
        // application options
        webrtc_streaming: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        webrtc_streaming_if_necessary: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        webrtc_on_mobile: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        auth: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        debug: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        testing_application: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        // screenoptions
        chrome_extension_id: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        chrome_extension_install_link: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        opera_extension_id: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"],
        opera_extension_install_link: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
      };
      var ziggeoPlayerApplicationOptions = {
        // application options
        debug: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        testing_application: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"],
        auth: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"]
      };
      var screenRecorderOptions = {};

      /***/
    }, /* 45 */
    /***/function (module, exports, __webpack_require__) {
      // getting tag from 19.1.3.6 Object.prototype.toString()
      var cof = __webpack_require__(23);
      var TAG = __webpack_require__(5)('toStringTag');
      // ES3 wrong here
      var ARG = cof(function () {
        return arguments;
      }()) == 'Arguments';

      // fallback for IE11 Script Access Denied error
      var tryGet = function tryGet(it, key) {
        try {
          return it[key];
        } catch (e) {/* empty */}
      };
      module.exports = function (it) {
        var O, T, B;
        return it === undefined ? 'Undefined' : it === null ? 'Null'
        // @@toStringTag case
        : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
        // builtinTag case
        : ARG ? cof(O)
        // ES3 arguments fallback
        : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
      };

      /***/
    }, /* 46 */
    /***/function (module, exports, __webpack_require__) {
      // fallback for non-array-like ES3 and non-enumerable old V8 strings
      var cof = __webpack_require__(23);
      // eslint-disable-next-line no-prototype-builtins
      module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
        return cof(it) == 'String' ? it.split('') : Object(it);
      };

      /***/
    }, /* 47 */
    /***/function (module, exports) {
      exports.f = {}.propertyIsEnumerable;

      /***/
    }, /* 48 */
    /***/function (module, exports, __webpack_require__) {
      // 7.3.20 SpeciesConstructor(O, defaultConstructor)
      var anObject = __webpack_require__(1);
      var aFunction = __webpack_require__(17);
      var SPECIES = __webpack_require__(5)('species');
      module.exports = function (O, D) {
        var C = anObject(O).constructor;
        var S;
        return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
      };

      /***/
    }, /* 49 */
    /***/function (module, exports) {
      // shim for using process in browser
      var process = module.exports = {};

      // cached from whatever global is present so that test runners that stub it
      // don't break things.  But we need to wrap it in a try catch in case it is
      // wrapped in strict mode code which doesn't define any globals.  It's inside a
      // function because try/catches deoptimize in certain engines.

      var cachedSetTimeout;
      var cachedClearTimeout;
      function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
      }
      function defaultClearTimeout() {
        throw new Error('clearTimeout has not been defined');
      }
      (function () {
        try {
          if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
          } else {
            cachedSetTimeout = defaultSetTimout;
          }
        } catch (e) {
          cachedSetTimeout = defaultSetTimout;
        }
        try {
          if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
          } else {
            cachedClearTimeout = defaultClearTimeout;
          }
        } catch (e) {
          cachedClearTimeout = defaultClearTimeout;
        }
      })();
      function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
        }
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
        }
        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
          }
        }
      }
      function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
        }
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
        }
        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
          }
        }
      }
      var queue = [];
      var draining = false;
      var currentQueue;
      var queueIndex = -1;
      function cleanUpNextTick() {
        if (!draining || !currentQueue) {
          return;
        }
        draining = false;
        if (currentQueue.length) {
          queue = currentQueue.concat(queue);
        } else {
          queueIndex = -1;
        }
        if (queue.length) {
          drainQueue();
        }
      }
      function drainQueue() {
        if (draining) {
          return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;
        var len = queue.length;
        while (len) {
          currentQueue = queue;
          queue = [];
          while (++queueIndex < len) {
            if (currentQueue) {
              currentQueue[queueIndex].run();
            }
          }
          queueIndex = -1;
          len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
      }
      process.nextTick = function (fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
          }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
        }
      };

      // v8 likes predictible objects
      function Item(fun, array) {
        this.fun = fun;
        this.array = array;
      }
      Item.prototype.run = function () {
        this.fun.apply(null, this.array);
      };
      process.title = 'browser';
      process.browser = true;
      process.env = {};
      process.argv = [];
      process.version = ''; // empty string to avoid regexp issues
      process.versions = {};
      function noop() {}
      process.on = noop;
      process.addListener = noop;
      process.once = noop;
      process.off = noop;
      process.removeListener = noop;
      process.removeAllListeners = noop;
      process.emit = noop;
      process.prependListener = noop;
      process.prependOnceListener = noop;
      process.listeners = function (name) {
        return [];
      };
      process.binding = function (name) {
        throw new Error('process.binding is not supported');
      };
      process.cwd = function () {
        return '/';
      };
      process.chdir = function (dir) {
        throw new Error('process.chdir is not supported');
      };
      process.umask = function () {
        return 0;
      };

      /***/
    }, /* 50 */
    /***/function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_50__;

      /***/
    }, /* 51 */
    /***/function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(50);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(44);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(126);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
      function _extends() {
        _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        return _extends.apply(this, arguments);
      }
      function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
      }
      function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
      }
      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      }
      function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
          for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }
      function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
          var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
          for (i = 0; i < sourceSymbolKeys.length; i++) {
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
          }
        }
        return target;
      }
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          target[key] = source[key];
        }
        return target;
      }
      var withZiggeoApplication = function withZiggeoApplication(WrappedComponent) {
        return function (_ref) {
          var apiKey = _ref.apiKey,
            flashUrl = _ref.flashUrl,
            locale = _ref.locale,
            mediaLocales = _ref.mediaLocales,
            restProps = _objectWithoutProperties(_ref, ["apiKey", "flashUrl", "locale", "mediaLocales"]);
          var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
            _useState2 = _slicedToArray(_useState, 2),
            app = _useState2[0],
            setApp = _useState2[1];
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
            try {
              if (!app) initApplication();
            } catch (e) {
              console.error(e);
            }
            return function () {// NOTE: DON'T DESTROY APPLICATION ITSELF
              // Will receive error 'Cannot read property 'urls' of undefined'
              // if (app) app.destroy();
            };
          }, [app]);
          var initApplication = function initApplication() {
            // Set locale
            if (typeof locale !== "undefined") ZiggeoApi.V2.Locale.setLocale(locale);
            if (mediaLocales) {
              if (Array.isArray(mediaLocales)) mediaLocales.map(function (config) {
                var register = config.register,
                  languages = config.languages,
                  priority = config.priority;
                if (register) {
                  if (Array.isArray(languages)) {
                    var language_args = [];
                    languages.map(function (l, i) {
                      language_args.push("language:".concat(l));
                      if (i === languages.length - 1) {
                        return ZiggeoApi.V2.Locale.mediaLocale.register(register, language_args, priority || 10);
                      }
                    });
                  } else {
                    return ZiggeoApi.V2.Locale.mediaLocale.register(register, priority || 10);
                  }
                }
              });else console.warn('mediaLocales has to be an Array, please read documentation for more details.');
            } // Set external flash player

            if (typeof flashUrl !== "undefined") ZiggeoApi.V2.Config.set("flash", flashUrl);
            setApp(ZiggeoApi.V2.Application.instanceByToken(apiKey, applicationOptions()));
          };
          var applicationOptions = function applicationOptions() {
            return Object.keys(restProps).filter(function (k) {
              return __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ziggeoRecorderApplicationOptions */][k];
            }).reduce(function (attr, k) {
              attr[k] = restProps[k];
              return attr;
            }, {});
          };
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, restProps, {
            app: app
          }));
        };
      };
      withZiggeoApplication.prototype = {
        apiKey: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"].isRequired
      };
      /* harmony default export */
      __webpack_exports__["a"] = withZiggeoApplication;

      /***/
    }, /* 52 */
    /***/function (module, exports, __webpack_require__) {
      // false -> Array#indexOf
      // true  -> Array#includes
      var toIObject = __webpack_require__(15);
      var toLength = __webpack_require__(6);
      var toAbsoluteIndex = __webpack_require__(35);
      module.exports = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value;
          // Array#includes uses SameValueZero equality algorithm
          // eslint-disable-next-line no-self-compare
          if (IS_INCLUDES && el != el) while (length > index) {
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
            // Array#indexOf ignores holes, Array#includes - not
          } else for (; length > index; index++) if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
          }
          return !IS_INCLUDES && -1;
        };
      };

      /***/
    }, /* 53 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var global = __webpack_require__(3);
      var $export = __webpack_require__(0);
      var redefine = __webpack_require__(11);
      var redefineAll = __webpack_require__(40);
      var meta = __webpack_require__(26);
      var forOf = __webpack_require__(56);
      var anInstance = __webpack_require__(38);
      var isObject = __webpack_require__(4);
      var fails = __webpack_require__(2);
      var $iterDetect = __webpack_require__(58);
      var setToStringTag = __webpack_require__(42);
      var inheritIfRequired = __webpack_require__(74);
      module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
        var Base = global[NAME];
        var C = Base;
        var ADDER = IS_MAP ? 'set' : 'add';
        var proto = C && C.prototype;
        var O = {};
        var fixMethod = function fixMethod(KEY) {
          var fn = proto[KEY];
          redefine(proto, KEY, KEY == 'delete' ? function (a) {
            return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
          } : KEY == 'has' ? function has(a) {
            return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
          } : KEY == 'get' ? function get(a) {
            return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
          } : KEY == 'add' ? function add(a) {
            fn.call(this, a === 0 ? 0 : a);
            return this;
          } : function set(a, b) {
            fn.call(this, a === 0 ? 0 : a, b);
            return this;
          });
        };
        if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
          new C().entries().next();
        }))) {
          // create collection constructor
          C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
          redefineAll(C.prototype, methods);
          meta.NEED = true;
        } else {
          var instance = new C();
          // early implementations not supports chaining
          var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
          // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
          var THROWS_ON_PRIMITIVES = fails(function () {
            instance.has(1);
          });
          // most early implementations doesn't supports iterables, most modern - not close it correctly
          var ACCEPT_ITERABLES = $iterDetect(function (iter) {
            new C(iter);
          }); // eslint-disable-line no-new
          // for early implementations -0 and +0 not the same
          var BUGGY_ZERO = !IS_WEAK && fails(function () {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new C();
            var index = 5;
            while (index--) $instance[ADDER](index, index);
            return !$instance.has(-0);
          });
          if (!ACCEPT_ITERABLES) {
            C = wrapper(function (target, iterable) {
              anInstance(target, C, NAME);
              var that = inheritIfRequired(new Base(), target, C);
              if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
              return that;
            });
            C.prototype = proto;
            proto.constructor = C;
          }
          if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
          }
          if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
          // weak collections should not contains .clear method
          if (IS_WEAK && proto.clear) delete proto.clear;
        }
        setToStringTag(C, NAME);
        O[NAME] = C;
        $export($export.G + $export.W + $export.F * (C != Base), O);
        if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
        return C;
      };

      /***/
    }, /* 54 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      __webpack_require__(124);
      var redefine = __webpack_require__(11);
      var hide = __webpack_require__(14);
      var fails = __webpack_require__(2);
      var defined = __webpack_require__(24);
      var wks = __webpack_require__(5);
      var regexpExec = __webpack_require__(80);
      var SPECIES = wks('species');
      var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
        // #replace needs built-in support for named groups.
        // #match works fine because it just return the exec results, even if it has
        // a "grops" property.
        var re = /./;
        re.exec = function () {
          var result = [];
          result.groups = {
            a: '7'
          };
          return result;
        };
        return ''.replace(re, '$<a>') !== '7';
      });
      var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function () {
        // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
        var re = /(?:)/;
        var originalExec = re.exec;
        re.exec = function () {
          return originalExec.apply(this, arguments);
        };
        var result = 'ab'.split(re);
        return result.length === 2 && result[0] === 'a' && result[1] === 'b';
      }();
      module.exports = function (KEY, length, exec) {
        var SYMBOL = wks(KEY);
        var DELEGATES_TO_SYMBOL = !fails(function () {
          // String methods call symbol-named RegEp methods
          var O = {};
          O[SYMBOL] = function () {
            return 7;
          };
          return ''[KEY](O) != 7;
        });
        var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
          // Symbol-named RegExp methods call .exec
          var execCalled = false;
          var re = /a/;
          re.exec = function () {
            execCalled = true;
            return null;
          };
          if (KEY === 'split') {
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[SPECIES] = function () {
              return re;
            };
          }
          re[SYMBOL]('');
          return !execCalled;
        }) : undefined;
        if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
          var nativeRegExpMethod = /./[SYMBOL];
          var fns = exec(defined, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
            if (regexp.exec === regexpExec) {
              if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                  done: true,
                  value: nativeRegExpMethod.call(regexp, str, arg2)
                };
              }
              return {
                done: true,
                value: nativeMethod.call(str, regexp, arg2)
              };
            }
            return {
              done: false
            };
          });
          var strfn = fns[0];
          var rxfn = fns[1];
          redefine(String.prototype, KEY, strfn);
          hide(RegExp.prototype, SYMBOL, length == 2
          // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
          // 21.2.5.11 RegExp.prototype[@@split](string, limit)
          ? function (string, arg) {
            return rxfn.call(string, this, arg);
          }
          // 21.2.5.6 RegExp.prototype[@@match](string)
          // 21.2.5.9 RegExp.prototype[@@search](string)
          : function (string) {
            return rxfn.call(string, this);
          });
        }
      };

      /***/
    }, /* 55 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 21.2.5.3 get RegExp.prototype.flags
      var anObject = __webpack_require__(1);
      module.exports = function () {
        var that = anObject(this);
        var result = '';
        if (that.global) result += 'g';
        if (that.ignoreCase) result += 'i';
        if (that.multiline) result += 'm';
        if (that.unicode) result += 'u';
        if (that.sticky) result += 'y';
        return result;
      };

      /***/
    }, /* 56 */
    /***/function (module, exports, __webpack_require__) {
      var ctx = __webpack_require__(19);
      var call = __webpack_require__(105);
      var isArrayIter = __webpack_require__(75);
      var anObject = __webpack_require__(1);
      var toLength = __webpack_require__(6);
      var getIterFn = __webpack_require__(90);
      var BREAK = {};
      var RETURN = {};
      var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
        var iterFn = ITERATOR ? function () {
          return iterable;
        } : getIterFn(iterable);
        var f = ctx(fn, that, entries ? 2 : 1);
        var index = 0;
        var length, step, iterator, result;
        if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
        // fast case for arrays with default iterator
        if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
          result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
          if (result === BREAK || result === RETURN) return result;
        } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
          result = call(iterator, f, step.value, entries);
          if (result === BREAK || result === RETURN) return result;
        }
      };
      exports.BREAK = BREAK;
      exports.RETURN = RETURN;

      /***/
    }, /* 57 */
    /***/function (module, exports, __webpack_require__) {
      // 7.2.2 IsArray(argument)
      var cof = __webpack_require__(23);
      module.exports = Array.isArray || function isArray(arg) {
        return cof(arg) == 'Array';
      };

      /***/
    }, /* 58 */
    /***/function (module, exports, __webpack_require__) {
      var ITERATOR = __webpack_require__(5)('iterator');
      var SAFE_CLOSING = false;
      try {
        var riter = [7][ITERATOR]();
        riter['return'] = function () {
          SAFE_CLOSING = true;
        };
        // eslint-disable-next-line no-throw-literal
        Array.from(riter, function () {
          throw 2;
        });
      } catch (e) {/* empty */}
      module.exports = function (exec, skipClosing) {
        if (!skipClosing && !SAFE_CLOSING) return false;
        var safe = false;
        try {
          var arr = [7];
          var iter = arr[ITERATOR]();
          iter.next = function () {
            return {
              done: safe = true
            };
          };
          arr[ITERATOR] = function () {
            return iter;
          };
          exec(arr);
        } catch (e) {/* empty */}
        return safe;
      };

      /***/
    }, /* 59 */
    /***/function (module, exports) {
      exports.f = Object.getOwnPropertySymbols;

      /***/
    }, /* 60 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var classof = __webpack_require__(45);
      var builtinExec = RegExp.prototype.exec;

      // `RegExpExec` abstract operation
      // https://tc39.github.io/ecma262/#sec-regexpexec
      module.exports = function (R, S) {
        var exec = R.exec;
        if (typeof exec === 'function') {
          var result = exec.call(R, S);
          if (typeof result !== 'object') {
            throw new TypeError('RegExp exec method returned something other than an Object or null');
          }
          return result;
        }
        if (classof(R) !== 'RegExp') {
          throw new TypeError('RegExp#exec called on incompatible receiver');
        }
        return builtinExec.call(R, S);
      };

      /***/
    }, /* 61 */
    /***/function (module, exports, __webpack_require__) {
      var core = __webpack_require__(7);
      var global = __webpack_require__(3);
      var SHARED = '__core-js_shared__';
      var store = global[SHARED] || (global[SHARED] = {});
      (module.exports = function (key, value) {
        return store[key] || (store[key] = value !== undefined ? value : {});
      })('versions', []).push({
        version: core.version,
        mode: __webpack_require__(29) ? 'pure' : 'global',
        copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
      });

      /***/
    }, /* 62 */
    /***/function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var hide = __webpack_require__(14);
      var uid = __webpack_require__(36);
      var TYPED = uid('typed_array');
      var VIEW = uid('view');
      var ABV = !!(global.ArrayBuffer && global.DataView);
      var CONSTR = ABV;
      var i = 0;
      var l = 9;
      var Typed;
      var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');
      while (i < l) {
        if (Typed = global[TypedArrayConstructors[i++]]) {
          hide(Typed.prototype, TYPED, true);
          hide(Typed.prototype, VIEW, true);
        } else CONSTR = false;
      }
      module.exports = {
        ABV: ABV,
        CONSTR: CONSTR,
        TYPED: TYPED,
        VIEW: VIEW
      };

      /***/
    }, /* 63 */
    /***/function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var navigator = global.navigator;
      module.exports = navigator && navigator.userAgent || '';

      /***/
    }, /* 64 */
    /***/function (module, exports, __webpack_require__) {
      // Thank's IE8 for his funny defineProperty
      module.exports = !__webpack_require__(94)(function () {
        return Object.defineProperty({}, 'a', {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });

      /***/
    }, /* 65 */
    /***/function (module, exports) {
      // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
      var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
      // eslint-disable-next-line no-new-func
      : Function('return this')();
      if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

      /***/
    }, /* 66 */
    /***/function (module, exports) {
      module.exports = function (it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
      };

      /***/
    }, /* 67 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var at = __webpack_require__(83)(true);

      // `AdvanceStringIndex` abstract operation
      // https://tc39.github.io/ecma262/#sec-advancestringindex
      module.exports = function (S, index, unicode) {
        return index + (unicode ? at(S, index).length : 1);
      };

      /***/
    }, /* 68 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
      var toObject = __webpack_require__(10);
      var toAbsoluteIndex = __webpack_require__(35);
      var toLength = __webpack_require__(6);
      module.exports = function fill(value /* , start = 0, end = @length */) {
        var O = toObject(this);
        var length = toLength(O.length);
        var aLen = arguments.length;
        var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
        var end = aLen > 2 ? arguments[2] : undefined;
        var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
        while (endPos > index) O[index++] = value;
        return O;
      };

      /***/
    }, /* 69 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $defineProperty = __webpack_require__(9);
      var createDesc = __webpack_require__(34);
      module.exports = function (object, index, value) {
        if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
      };

      /***/
    }, /* 70 */
    /***/function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(4);
      var document = __webpack_require__(3).document;
      // typeof document.createElement is 'object' in old IE
      var is = isObject(document) && isObject(document.createElement);
      module.exports = function (it) {
        return is ? document.createElement(it) : {};
      };

      /***/
    }, /* 71 */
    /***/function (module, exports) {
      // IE 8- don't enum bug keys
      module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

      /***/
    }, /* 72 */
    /***/function (module, exports, __webpack_require__) {
      var MATCH = __webpack_require__(5)('match');
      module.exports = function (KEY) {
        var re = /./;
        try {
          '/./'[KEY](re);
        } catch (e) {
          try {
            re[MATCH] = false;
            return !'/./'[KEY](re);
          } catch (f) {/* empty */}
        }
        return true;
      };

      /***/
    }, /* 73 */
    /***/function (module, exports, __webpack_require__) {
      var document = __webpack_require__(3).document;
      module.exports = document && document.documentElement;

      /***/
    }, /* 74 */
    /***/function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(4);
      var setPrototypeOf = __webpack_require__(81).set;
      module.exports = function (that, target, C) {
        var S = target.constructor;
        var P;
        if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
          setPrototypeOf(that, P);
        }
        return that;
      };

      /***/
    }, /* 75 */
    /***/function (module, exports, __webpack_require__) {
      // check on default Array iterator
      var Iterators = __webpack_require__(39);
      var ITERATOR = __webpack_require__(5)('iterator');
      var ArrayProto = Array.prototype;
      module.exports = function (it) {
        return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
      };

      /***/
    }, /* 76 */
    /***/function (module, exports, __webpack_require__) {
      // 7.2.8 IsRegExp(argument)
      var isObject = __webpack_require__(4);
      var cof = __webpack_require__(23);
      var MATCH = __webpack_require__(5)('match');
      module.exports = function (it) {
        var isRegExp;
        return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
      };

      /***/
    }, /* 77 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var LIBRARY = __webpack_require__(29);
      var $export = __webpack_require__(0);
      var redefine = __webpack_require__(11);
      var hide = __webpack_require__(14);
      var Iterators = __webpack_require__(39);
      var $iterCreate = __webpack_require__(106);
      var setToStringTag = __webpack_require__(42);
      var getPrototypeOf = __webpack_require__(32);
      var ITERATOR = __webpack_require__(5)('iterator');
      var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
      var FF_ITERATOR = '@@iterator';
      var KEYS = 'keys';
      var VALUES = 'values';
      var returnThis = function returnThis() {
        return this;
      };
      module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
        $iterCreate(Constructor, NAME, next);
        var getMethod = function getMethod(kind) {
          if (!BUGGY && kind in proto) return proto[kind];
          switch (kind) {
            case KEYS:
              return function keys() {
                return new Constructor(this, kind);
              };
            case VALUES:
              return function values() {
                return new Constructor(this, kind);
              };
          }
          return function entries() {
            return new Constructor(this, kind);
          };
        };
        var TAG = NAME + ' Iterator';
        var DEF_VALUES = DEFAULT == VALUES;
        var VALUES_BUG = false;
        var proto = Base.prototype;
        var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
        var $default = $native || getMethod(DEFAULT);
        var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
        var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
        var methods, key, IteratorPrototype;
        // Fix native
        if ($anyNative) {
          IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
          if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            setToStringTag(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
          }
        }
        // fix Array#{values, @@iterator}.name in V8 / FF
        if (DEF_VALUES && $native && $native.name !== VALUES) {
          VALUES_BUG = true;
          $default = function values() {
            return $native.call(this);
          };
        }
        // Define iterator
        if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
          hide(proto, ITERATOR, $default);
        }
        // Plug for library
        Iterators[NAME] = $default;
        Iterators[TAG] = returnThis;
        if (DEFAULT) {
          methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
          };
          if (FORCED) for (key in methods) {
            if (!(key in proto)) redefine(proto, key, methods[key]);
          } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
        }
        return methods;
      };

      /***/
    }, /* 78 */
    /***/function (module, exports) {
      // 20.2.2.14 Math.expm1(x)
      var $expm1 = Math.expm1;
      module.exports = !$expm1
      // Old FF bug
      || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
      // Tor Browser bug
      || $expm1(-2e-17) != -2e-17 ? function expm1(x) {
        return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
      } : $expm1;

      /***/
    }, /* 79 */
    /***/function (module, exports) {
      // 20.2.2.28 Math.sign(x)
      module.exports = Math.sign || function sign(x) {
        // eslint-disable-next-line no-self-compare
        return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
      };

      /***/
    }, /* 80 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var regexpFlags = __webpack_require__(55);
      var nativeExec = RegExp.prototype.exec;
      // This always refers to the native implementation, because the
      // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
      // which loads this file before patching the method.
      var nativeReplace = String.prototype.replace;
      var patchedExec = nativeExec;
      var LAST_INDEX = 'lastIndex';
      var UPDATES_LAST_INDEX_WRONG = function () {
        var re1 = /a/,
          re2 = /b*/g;
        nativeExec.call(re1, 'a');
        nativeExec.call(re2, 'a');
        return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
      }();

      // nonparticipating capturing group, copied from es5-shim's String#split patch.
      var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
      var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
      if (PATCH) {
        patchedExec = function exec(str) {
          var re = this;
          var lastIndex, reCopy, match, i;
          if (NPCG_INCLUDED) {
            reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
          }
          if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
          match = nativeExec.call(re, str);
          if (UPDATES_LAST_INDEX_WRONG && match) {
            re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
          }
          if (NPCG_INCLUDED && match && match.length > 1) {
            // Fix browsers whose `exec` methods don't consistently return `undefined`
            // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
            // eslint-disable-next-line no-loop-func
            nativeReplace.call(match[0], reCopy, function () {
              for (i = 1; i < arguments.length - 2; i++) {
                if (arguments[i] === undefined) match[i] = undefined;
              }
            });
          }
          return match;
        };
      }
      module.exports = patchedExec;

      /***/
    }, /* 81 */
    /***/function (module, exports, __webpack_require__) {
      // Works with __proto__ only. Old v8 can't work with null proto objects.
      /* eslint-disable no-proto */
      var isObject = __webpack_require__(4);
      var anObject = __webpack_require__(1);
      var check = function check(O, proto) {
        anObject(O);
        if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
      };
      module.exports = {
        set: Object.setPrototypeOf || ('__proto__' in {} ?
        // eslint-disable-line
        function (test, buggy, set) {
          try {
            set = __webpack_require__(19)(Function.call, __webpack_require__(20).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
          } catch (e) {
            buggy = true;
          }
          return function setPrototypeOf(O, proto) {
            check(O, proto);
            if (buggy) O.__proto__ = proto;else set(O, proto);
            return O;
          };
        }({}, false) : undefined),
        check: check
      };

      /***/
    }, /* 82 */
    /***/function (module, exports, __webpack_require__) {
      var shared = __webpack_require__(61)('keys');
      var uid = __webpack_require__(36);
      module.exports = function (key) {
        return shared[key] || (shared[key] = uid(key));
      };

      /***/
    }, /* 83 */
    /***/function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(22);
      var defined = __webpack_require__(24);
      // true  -> String#at
      // false -> String#codePointAt
      module.exports = function (TO_STRING) {
        return function (that, pos) {
          var s = String(defined(that));
          var i = toInteger(pos);
          var l = s.length;
          var a, b;
          if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
          a = s.charCodeAt(i);
          return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
        };
      };

      /***/
    }, /* 84 */
    /***/function (module, exports, __webpack_require__) {
      // helper for String#{startsWith, endsWith, includes}
      var isRegExp = __webpack_require__(76);
      var defined = __webpack_require__(24);
      module.exports = function (that, searchString, NAME) {
        if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
        return String(defined(that));
      };

      /***/
    }, /* 85 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var toInteger = __webpack_require__(22);
      var defined = __webpack_require__(24);
      module.exports = function repeat(count) {
        var str = String(defined(this));
        var res = '';
        var n = toInteger(count);
        if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
        for (; n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
        return res;
      };

      /***/
    }, /* 86 */
    /***/function (module, exports) {
      module.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003" + "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

      /***/
    }, /* 87 */
    /***/function (module, exports, __webpack_require__) {
      var ctx = __webpack_require__(19);
      var invoke = __webpack_require__(103);
      var html = __webpack_require__(73);
      var cel = __webpack_require__(70);
      var global = __webpack_require__(3);
      var process = global.process;
      var setTask = global.setImmediate;
      var clearTask = global.clearImmediate;
      var MessageChannel = global.MessageChannel;
      var Dispatch = global.Dispatch;
      var counter = 0;
      var queue = {};
      var ONREADYSTATECHANGE = 'onreadystatechange';
      var defer, channel, port;
      var run = function run() {
        var id = +this;
        // eslint-disable-next-line no-prototype-builtins
        if (queue.hasOwnProperty(id)) {
          var fn = queue[id];
          delete queue[id];
          fn();
        }
      };
      var listener = function listener(event) {
        run.call(event.data);
      };
      // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
      if (!setTask || !clearTask) {
        setTask = function setImmediate(fn) {
          var args = [];
          var i = 1;
          while (arguments.length > i) args.push(arguments[i++]);
          queue[++counter] = function () {
            // eslint-disable-next-line no-new-func
            invoke(typeof fn == 'function' ? fn : Function(fn), args);
          };
          defer(counter);
          return counter;
        };
        clearTask = function clearImmediate(id) {
          delete queue[id];
        };
        // Node.js 0.8-
        if (__webpack_require__(23)(process) == 'process') {
          defer = function defer(id) {
            process.nextTick(ctx(run, id, 1));
          };
          // Sphere (JS game engine) Dispatch API
        } else if (Dispatch && Dispatch.now) {
          defer = function defer(id) {
            Dispatch.now(ctx(run, id, 1));
          };
          // Browsers with MessageChannel, includes WebWorkers
        } else if (MessageChannel) {
          channel = new MessageChannel();
          port = channel.port2;
          channel.port1.onmessage = listener;
          defer = ctx(port.postMessage, port, 1);
          // Browsers with postMessage, skip WebWorkers
          // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
        } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
          defer = function defer(id) {
            global.postMessage(id + '', '*');
          };
          global.addEventListener('message', listener, false);
          // IE8-
        } else if (ONREADYSTATECHANGE in cel('script')) {
          defer = function defer(id) {
            html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
              html.removeChild(this);
              run.call(id);
            };
          };
          // Rest old browsers
        } else {
          defer = function defer(id) {
            setTimeout(ctx(run, id, 1), 0);
          };
        }
      }
      module.exports = {
        set: setTask,
        clear: clearTask
      };

      /***/
    }, /* 88 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var global = __webpack_require__(3);
      var DESCRIPTORS = __webpack_require__(8);
      var LIBRARY = __webpack_require__(29);
      var $typed = __webpack_require__(62);
      var hide = __webpack_require__(14);
      var redefineAll = __webpack_require__(40);
      var fails = __webpack_require__(2);
      var anInstance = __webpack_require__(38);
      var toInteger = __webpack_require__(22);
      var toLength = __webpack_require__(6);
      var toIndex = __webpack_require__(121);
      var gOPN = __webpack_require__(31).f;
      var dP = __webpack_require__(9).f;
      var arrayFill = __webpack_require__(68);
      var setToStringTag = __webpack_require__(42);
      var ARRAY_BUFFER = 'ArrayBuffer';
      var DATA_VIEW = 'DataView';
      var PROTOTYPE = 'prototype';
      var WRONG_LENGTH = 'Wrong length!';
      var WRONG_INDEX = 'Wrong index!';
      var $ArrayBuffer = global[ARRAY_BUFFER];
      var $DataView = global[DATA_VIEW];
      var Math = global.Math;
      var RangeError = global.RangeError;
      // eslint-disable-next-line no-shadow-restricted-names
      var Infinity = global.Infinity;
      var BaseBuffer = $ArrayBuffer;
      var abs = Math.abs;
      var pow = Math.pow;
      var floor = Math.floor;
      var log = Math.log;
      var LN2 = Math.LN2;
      var BUFFER = 'buffer';
      var BYTE_LENGTH = 'byteLength';
      var BYTE_OFFSET = 'byteOffset';
      var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
      var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
      var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

      // IEEE754 conversions based on https://github.com/feross/ieee754
      function packIEEE754(value, mLen, nBytes) {
        var buffer = new Array(nBytes);
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
        var i = 0;
        var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
        var e, m, c;
        value = abs(value);
        // eslint-disable-next-line no-self-compare
        if (value != value || value === Infinity) {
          // eslint-disable-next-line no-self-compare
          m = value != value ? 1 : 0;
          e = eMax;
        } else {
          e = floor(log(value) / LN2);
          if (value * (c = pow(2, -e)) < 1) {
            e--;
            c *= 2;
          }
          if (e + eBias >= 1) {
            value += rt / c;
          } else {
            value += rt * pow(2, 1 - eBias);
          }
          if (value * c >= 2) {
            e++;
            c /= 2;
          }
          if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
          } else if (e + eBias >= 1) {
            m = (value * c - 1) * pow(2, mLen);
            e = e + eBias;
          } else {
            m = value * pow(2, eBias - 1) * pow(2, mLen);
            e = 0;
          }
        }
        for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
        e = e << mLen | m;
        eLen += mLen;
        for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
        buffer[--i] |= s * 128;
        return buffer;
      }
      function unpackIEEE754(buffer, mLen, nBytes) {
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var nBits = eLen - 7;
        var i = nBytes - 1;
        var s = buffer[i--];
        var e = s & 127;
        var m;
        s >>= 7;
        for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
        m = e & (1 << -nBits) - 1;
        e >>= -nBits;
        nBits += mLen;
        for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
        if (e === 0) {
          e = 1 - eBias;
        } else if (e === eMax) {
          return m ? NaN : s ? -Infinity : Infinity;
        } else {
          m = m + pow(2, mLen);
          e = e - eBias;
        }
        return (s ? -1 : 1) * m * pow(2, e - mLen);
      }
      function unpackI32(bytes) {
        return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
      }
      function packI8(it) {
        return [it & 0xff];
      }
      function packI16(it) {
        return [it & 0xff, it >> 8 & 0xff];
      }
      function packI32(it) {
        return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
      }
      function packF64(it) {
        return packIEEE754(it, 52, 8);
      }
      function packF32(it) {
        return packIEEE754(it, 23, 4);
      }
      function addGetter(C, key, internal) {
        dP(C[PROTOTYPE], key, {
          get: function get() {
            return this[internal];
          }
        });
      }
      function get(view, bytes, index, isLittleEndian) {
        var numIndex = +index;
        var intIndex = toIndex(numIndex);
        if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
        var store = view[$BUFFER]._b;
        var start = intIndex + view[$OFFSET];
        var pack = store.slice(start, start + bytes);
        return isLittleEndian ? pack : pack.reverse();
      }
      function set(view, bytes, index, conversion, value, isLittleEndian) {
        var numIndex = +index;
        var intIndex = toIndex(numIndex);
        if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
        var store = view[$BUFFER]._b;
        var start = intIndex + view[$OFFSET];
        var pack = conversion(+value);
        for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
      }
      if (!$typed.ABV) {
        $ArrayBuffer = function ArrayBuffer(length) {
          anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
          var byteLength = toIndex(length);
          this._b = arrayFill.call(new Array(byteLength), 0);
          this[$LENGTH] = byteLength;
        };
        $DataView = function DataView(buffer, byteOffset, byteLength) {
          anInstance(this, $DataView, DATA_VIEW);
          anInstance(buffer, $ArrayBuffer, DATA_VIEW);
          var bufferLength = buffer[$LENGTH];
          var offset = toInteger(byteOffset);
          if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
          byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
          if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
          this[$BUFFER] = buffer;
          this[$OFFSET] = offset;
          this[$LENGTH] = byteLength;
        };
        if (DESCRIPTORS) {
          addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
          addGetter($DataView, BUFFER, '_b');
          addGetter($DataView, BYTE_LENGTH, '_l');
          addGetter($DataView, BYTE_OFFSET, '_o');
        }
        redefineAll($DataView[PROTOTYPE], {
          getInt8: function getInt8(byteOffset) {
            return get(this, 1, byteOffset)[0] << 24 >> 24;
          },
          getUint8: function getUint8(byteOffset) {
            return get(this, 1, byteOffset)[0];
          },
          getInt16: function getInt16(byteOffset /* , littleEndian */) {
            var bytes = get(this, 2, byteOffset, arguments[1]);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
          },
          getUint16: function getUint16(byteOffset /* , littleEndian */) {
            var bytes = get(this, 2, byteOffset, arguments[1]);
            return bytes[1] << 8 | bytes[0];
          },
          getInt32: function getInt32(byteOffset /* , littleEndian */) {
            return unpackI32(get(this, 4, byteOffset, arguments[1]));
          },
          getUint32: function getUint32(byteOffset /* , littleEndian */) {
            return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
          },
          getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
            return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
          },
          getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
            return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
          },
          setInt8: function setInt8(byteOffset, value) {
            set(this, 1, byteOffset, packI8, value);
          },
          setUint8: function setUint8(byteOffset, value) {
            set(this, 1, byteOffset, packI8, value);
          },
          setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
            set(this, 2, byteOffset, packI16, value, arguments[2]);
          },
          setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
            set(this, 2, byteOffset, packI16, value, arguments[2]);
          },
          setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
            set(this, 4, byteOffset, packI32, value, arguments[2]);
          },
          setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
            set(this, 4, byteOffset, packI32, value, arguments[2]);
          },
          setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
            set(this, 4, byteOffset, packF32, value, arguments[2]);
          },
          setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
            set(this, 8, byteOffset, packF64, value, arguments[2]);
          }
        });
      } else {
        if (!fails(function () {
          $ArrayBuffer(1);
        }) || !fails(function () {
          new $ArrayBuffer(-1); // eslint-disable-line no-new
        }) || fails(function () {
          new $ArrayBuffer(); // eslint-disable-line no-new
          new $ArrayBuffer(1.5); // eslint-disable-line no-new
          new $ArrayBuffer(NaN); // eslint-disable-line no-new
          return $ArrayBuffer.name != ARRAY_BUFFER;
        })) {
          $ArrayBuffer = function ArrayBuffer(length) {
            anInstance(this, $ArrayBuffer);
            return new BaseBuffer(toIndex(length));
          };
          var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
          for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
            if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
          }
          if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
        }
        // iOS Safari 7.x bug
        var view = new $DataView(new $ArrayBuffer(2));
        var $setInt8 = $DataView[PROTOTYPE].setInt8;
        view.setInt8(0, 2147483648);
        view.setInt8(1, 2147483649);
        if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
          setInt8: function setInt8(byteOffset, value) {
            $setInt8.call(this, byteOffset, value << 24 >> 24);
          },
          setUint8: function setUint8(byteOffset, value) {
            $setInt8.call(this, byteOffset, value << 24 >> 24);
          }
        }, true);
      }
      setToStringTag($ArrayBuffer, ARRAY_BUFFER);
      setToStringTag($DataView, DATA_VIEW);
      hide($DataView[PROTOTYPE], $typed.VIEW, true);
      exports[ARRAY_BUFFER] = $ArrayBuffer;
      exports[DATA_VIEW] = $DataView;

      /***/
    }, /* 89 */
    /***/function (module, exports, __webpack_require__) {
      exports.f = __webpack_require__(5);

      /***/
    }, /* 90 */
    /***/function (module, exports, __webpack_require__) {
      var classof = __webpack_require__(45);
      var ITERATOR = __webpack_require__(5)('iterator');
      var Iterators = __webpack_require__(39);
      module.exports = __webpack_require__(7).getIteratorMethod = function (it) {
        if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
      };

      /***/
    }, /* 91 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var addToUnscopables = __webpack_require__(28);
      var step = __webpack_require__(107);
      var Iterators = __webpack_require__(39);
      var toIObject = __webpack_require__(15);

      // 22.1.3.4 Array.prototype.entries()
      // 22.1.3.13 Array.prototype.keys()
      // 22.1.3.29 Array.prototype.values()
      // 22.1.3.30 Array.prototype[@@iterator]()
      module.exports = __webpack_require__(77)(Array, 'Array', function (iterated, kind) {
        this._t = toIObject(iterated); // target
        this._i = 0; // next index
        this._k = kind; // kind
        // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
      }, function () {
        var O = this._t;
        var kind = this._k;
        var index = this._i++;
        if (!O || index >= O.length) {
          this._t = undefined;
          return step(1);
        }
        if (kind == 'keys') return step(0, index);
        if (kind == 'values') return step(0, O[index]);
        return step(0, [index, O[index]]);
      }, 'values');

      // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
      Iterators.Arguments = Iterators.Array;
      addToUnscopables('keys');
      addToUnscopables('values');
      addToUnscopables('entries');

      /***/
    }, /* 92 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
      module.exports = ReactPropTypesSecret;

      /***/
    }, /* 93 */
    /***/function (module, exports) {
      var core = module.exports = {
        version: '2.6.12'
      };
      if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

      /***/
    }, /* 94 */
    /***/function (module, exports) {
      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };

      /***/
    }, /* 95 */
    /***/function (module, exports, __webpack_require__) {
      var cof = __webpack_require__(23);
      module.exports = function (it, msg) {
        if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
        return +it;
      };

      /***/
    }, /* 96 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
      var toObject = __webpack_require__(10);
      var toAbsoluteIndex = __webpack_require__(35);
      var toLength = __webpack_require__(6);
      module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
        var O = toObject(this);
        var len = toLength(O.length);
        var to = toAbsoluteIndex(target, len);
        var from = toAbsoluteIndex(start, len);
        var end = arguments.length > 2 ? arguments[2] : undefined;
        var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
        var inc = 1;
        if (from < to && to < from + count) {
          inc = -1;
          from += count - 1;
          to += count - 1;
        }
        while (count-- > 0) {
          if (from in O) O[to] = O[from];else delete O[to];
          to += inc;
          from += inc;
        }
        return O;
      };

      /***/
    }, /* 97 */
    /***/function (module, exports, __webpack_require__) {
      var aFunction = __webpack_require__(17);
      var toObject = __webpack_require__(10);
      var IObject = __webpack_require__(46);
      var toLength = __webpack_require__(6);
      module.exports = function (that, callbackfn, aLen, memo, isRight) {
        aFunction(callbackfn);
        var O = toObject(that);
        var self = IObject(O);
        var length = toLength(O.length);
        var index = isRight ? length - 1 : 0;
        var i = isRight ? -1 : 1;
        if (aLen < 2) for (;;) {
          if (index in self) {
            memo = self[index];
            index += i;
            break;
          }
          index += i;
          if (isRight ? index < 0 : length <= index) {
            throw TypeError('Reduce of empty array with no initial value');
          }
        }
        for (; isRight ? index >= 0 : length > index; index += i) if (index in self) {
          memo = callbackfn(memo, self[index], index, O);
        }
        return memo;
      };

      /***/
    }, /* 98 */
    /***/function (module, exports, __webpack_require__) {
      // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
      var speciesConstructor = __webpack_require__(162);
      module.exports = function (original, length) {
        return new (speciesConstructor(original))(length);
      };

      /***/
    }, /* 99 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var aFunction = __webpack_require__(17);
      var isObject = __webpack_require__(4);
      var invoke = __webpack_require__(103);
      var arraySlice = [].slice;
      var factories = {};
      var construct = function construct(F, len, args) {
        if (!(len in factories)) {
          for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
          // eslint-disable-next-line no-new-func
          factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
        }
        return factories[len](F, args);
      };
      module.exports = Function.bind || function bind(that /* , ...args */) {
        var fn = aFunction(this);
        var partArgs = arraySlice.call(arguments, 1);
        var bound = function bound( /* args... */
        ) {
          var args = partArgs.concat(arraySlice.call(arguments));
          return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
        };
        if (isObject(fn.prototype)) bound.prototype = fn.prototype;
        return bound;
      };

      /***/
    }, /* 100 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var dP = __webpack_require__(9).f;
      var create = __webpack_require__(30);
      var redefineAll = __webpack_require__(40);
      var ctx = __webpack_require__(19);
      var anInstance = __webpack_require__(38);
      var forOf = __webpack_require__(56);
      var $iterDefine = __webpack_require__(77);
      var step = __webpack_require__(107);
      var setSpecies = __webpack_require__(41);
      var DESCRIPTORS = __webpack_require__(8);
      var fastKey = __webpack_require__(26).fastKey;
      var validate = __webpack_require__(37);
      var SIZE = DESCRIPTORS ? '_s' : 'size';
      var getEntry = function getEntry(that, key) {
        // fast case
        var index = fastKey(key);
        var entry;
        if (index !== 'F') return that._i[index];
        // frozen object case
        for (entry = that._f; entry; entry = entry.n) {
          if (entry.k == key) return entry;
        }
      };
      module.exports = {
        getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
          var C = wrapper(function (that, iterable) {
            anInstance(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = create(null); // index
            that._f = undefined; // first entry
            that._l = undefined; // last entry
            that[SIZE] = 0; // size
            if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
          });
          redefineAll(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
              for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
                entry.r = true;
                if (entry.p) entry.p = entry.p.n = undefined;
                delete data[entry.i];
              }
              that._f = that._l = undefined;
              that[SIZE] = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            'delete': function _delete(key) {
              var that = validate(this, NAME);
              var entry = getEntry(that, key);
              if (entry) {
                var next = entry.n;
                var prev = entry.p;
                delete that._i[entry.i];
                entry.r = true;
                if (prev) prev.n = next;
                if (next) next.p = prev;
                if (that._f == entry) that._f = next;
                if (that._l == entry) that._l = prev;
                that[SIZE]--;
              }
              return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn /* , that = undefined */) {
              validate(this, NAME);
              var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
              var entry;
              while (entry = entry ? entry.n : this._f) {
                f(entry.v, entry.k, this);
                // revert to the last existing entry
                while (entry && entry.r) entry = entry.p;
              }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
              return !!getEntry(validate(this, NAME), key);
            }
          });
          if (DESCRIPTORS) dP(C.prototype, 'size', {
            get: function get() {
              return validate(this, NAME)[SIZE];
            }
          });
          return C;
        },
        def: function def(that, key, value) {
          var entry = getEntry(that, key);
          var prev, index;
          // change existing entry
          if (entry) {
            entry.v = value;
            // create new entry
          } else {
            that._l = entry = {
              i: index = fastKey(key, true),
              // <- index
              k: key,
              // <- key
              v: value,
              // <- value
              p: prev = that._l,
              // <- previous entry
              n: undefined,
              // <- next entry
              r: false // <- removed
            };

            if (!that._f) that._f = entry;
            if (prev) prev.n = entry;
            that[SIZE]++;
            // add to index
            if (index !== 'F') that._i[index] = entry;
          }
          return that;
        },
        getEntry: getEntry,
        setStrong: function setStrong(C, NAME, IS_MAP) {
          // add .keys, .values, .entries, [@@iterator]
          // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
          $iterDefine(C, NAME, function (iterated, kind) {
            this._t = validate(iterated, NAME); // target
            this._k = kind; // kind
            this._l = undefined; // previous
          }, function () {
            var that = this;
            var kind = that._k;
            var entry = that._l;
            // revert to the last existing entry
            while (entry && entry.r) entry = entry.p;
            // get next entry
            if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
              // or finish the iteration
              that._t = undefined;
              return step(1);
            }
            // return step by kind
            if (kind == 'keys') return step(0, entry.k);
            if (kind == 'values') return step(0, entry.v);
            return step(0, [entry.k, entry.v]);
          }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

          // add [@@species], 23.1.2.2, 23.2.2.2
          setSpecies(NAME);
        }
      };

      /***/
    }, /* 101 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var redefineAll = __webpack_require__(40);
      var getWeak = __webpack_require__(26).getWeak;
      var anObject = __webpack_require__(1);
      var isObject = __webpack_require__(4);
      var anInstance = __webpack_require__(38);
      var forOf = __webpack_require__(56);
      var createArrayMethod = __webpack_require__(18);
      var $has = __webpack_require__(13);
      var validate = __webpack_require__(37);
      var arrayFind = createArrayMethod(5);
      var arrayFindIndex = createArrayMethod(6);
      var id = 0;

      // fallback for uncaught frozen keys
      var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
        return that._l || (that._l = new UncaughtFrozenStore());
      };
      var UncaughtFrozenStore = function UncaughtFrozenStore() {
        this.a = [];
      };
      var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
        return arrayFind(store.a, function (it) {
          return it[0] === key;
        });
      };
      UncaughtFrozenStore.prototype = {
        get: function get(key) {
          var entry = findUncaughtFrozen(this, key);
          if (entry) return entry[1];
        },
        has: function has(key) {
          return !!findUncaughtFrozen(this, key);
        },
        set: function set(key, value) {
          var entry = findUncaughtFrozen(this, key);
          if (entry) entry[1] = value;else this.a.push([key, value]);
        },
        'delete': function _delete(key) {
          var index = arrayFindIndex(this.a, function (it) {
            return it[0] === key;
          });
          if (~index) this.a.splice(index, 1);
          return !!~index;
        }
      };
      module.exports = {
        getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
          var C = wrapper(function (that, iterable) {
            anInstance(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = id++; // collection id
            that._l = undefined; // leak store for uncaught frozen objects
            if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
          });
          redefineAll(C.prototype, {
            // 23.3.3.2 WeakMap.prototype.delete(key)
            // 23.4.3.3 WeakSet.prototype.delete(value)
            'delete': function _delete(key) {
              if (!isObject(key)) return false;
              var data = getWeak(key);
              if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
              return data && $has(data, this._i) && delete data[this._i];
            },
            // 23.3.3.4 WeakMap.prototype.has(key)
            // 23.4.3.4 WeakSet.prototype.has(value)
            has: function has(key) {
              if (!isObject(key)) return false;
              var data = getWeak(key);
              if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
              return data && $has(data, this._i);
            }
          });
          return C;
        },
        def: function def(that, key, value) {
          var data = getWeak(anObject(key), true);
          if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
          return that;
        },
        ufstore: uncaughtFrozenStore
      };

      /***/
    }, /* 102 */
    /***/function (module, exports, __webpack_require__) {
      module.exports = !__webpack_require__(8) && !__webpack_require__(2)(function () {
        return Object.defineProperty(__webpack_require__(70)('div'), 'a', {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });

      /***/
    }, /* 103 */
    /***/function (module, exports) {
      // fast apply, http://jsperf.lnkit.com/fast-apply/5
      module.exports = function (fn, args, that) {
        var un = that === undefined;
        switch (args.length) {
          case 0:
            return un ? fn() : fn.call(that);
          case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
          case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
          case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
          case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
        }
        return fn.apply(that, args);
      };

      /***/
    }, /* 104 */
    /***/function (module, exports, __webpack_require__) {
      // 20.1.2.3 Number.isInteger(number)
      var isObject = __webpack_require__(4);
      var floor = Math.floor;
      module.exports = function isInteger(it) {
        return !isObject(it) && isFinite(it) && floor(it) === it;
      };

      /***/
    }, /* 105 */
    /***/function (module, exports, __webpack_require__) {
      // call something on iterator step with safe closing on error
      var anObject = __webpack_require__(1);
      module.exports = function (iterator, fn, value, entries) {
        try {
          return entries ? fn(anObject(value)[0], value[1]) : fn(value);
          // 7.4.6 IteratorClose(iterator, completion)
        } catch (e) {
          var ret = iterator['return'];
          if (ret !== undefined) anObject(ret.call(iterator));
          throw e;
        }
      };

      /***/
    }, /* 106 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var create = __webpack_require__(30);
      var descriptor = __webpack_require__(34);
      var setToStringTag = __webpack_require__(42);
      var IteratorPrototype = {};

      // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
      __webpack_require__(14)(IteratorPrototype, __webpack_require__(5)('iterator'), function () {
        return this;
      });
      module.exports = function (Constructor, NAME, next) {
        Constructor.prototype = create(IteratorPrototype, {
          next: descriptor(1, next)
        });
        setToStringTag(Constructor, NAME + ' Iterator');
      };

      /***/
    }, /* 107 */
    /***/function (module, exports) {
      module.exports = function (done, value) {
        return {
          value: value,
          done: !!done
        };
      };

      /***/
    }, /* 108 */
    /***/function (module, exports) {
      // 20.2.2.20 Math.log1p(x)
      module.exports = Math.log1p || function log1p(x) {
        return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
      };

      /***/
    }, /* 109 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 25.4.1.5 NewPromiseCapability(C)
      var aFunction = __webpack_require__(17);
      function PromiseCapability(C) {
        var resolve, reject;
        this.promise = new C(function ($$resolve, $$reject) {
          if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
          resolve = $$resolve;
          reject = $$reject;
        });
        this.resolve = aFunction(resolve);
        this.reject = aFunction(reject);
      }
      module.exports.f = function (C) {
        return new PromiseCapability(C);
      };

      /***/
    }, /* 110 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 19.1.2.1 Object.assign(target, source, ...)
      var DESCRIPTORS = __webpack_require__(8);
      var getKeys = __webpack_require__(33);
      var gOPS = __webpack_require__(59);
      var pIE = __webpack_require__(47);
      var toObject = __webpack_require__(10);
      var IObject = __webpack_require__(46);
      var $assign = Object.assign;

      // should work with symbols and should have deterministic property order (V8 bug)
      module.exports = !$assign || __webpack_require__(2)(function () {
        var A = {};
        var B = {};
        // eslint-disable-next-line no-undef
        var S = Symbol();
        var K = 'abcdefghijklmnopqrst';
        A[S] = 7;
        K.split('').forEach(function (k) {
          B[k] = k;
        });
        return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
      }) ? function assign(target, source) {
        // eslint-disable-line no-unused-vars
        var T = toObject(target);
        var aLen = arguments.length;
        var index = 1;
        var getSymbols = gOPS.f;
        var isEnum = pIE.f;
        while (aLen > index) {
          var S = IObject(arguments[index++]);
          var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
          var length = keys.length;
          var j = 0;
          var key;
          while (length > j) {
            key = keys[j++];
            if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
          }
        }
        return T;
      } : $assign;

      /***/
    }, /* 111 */
    /***/function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(9);
      var anObject = __webpack_require__(1);
      var getKeys = __webpack_require__(33);
      module.exports = __webpack_require__(8) ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = getKeys(Properties);
        var length = keys.length;
        var i = 0;
        var P;
        while (length > i) dP.f(O, P = keys[i++], Properties[P]);
        return O;
      };

      /***/
    }, /* 112 */
    /***/function (module, exports, __webpack_require__) {
      // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
      var toIObject = __webpack_require__(15);
      var gOPN = __webpack_require__(31).f;
      var toString = {}.toString;
      var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
      var getWindowNames = function getWindowNames(it) {
        try {
          return gOPN(it);
        } catch (e) {
          return windowNames.slice();
        }
      };
      module.exports.f = function getOwnPropertyNames(it) {
        return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
      };

      /***/
    }, /* 113 */
    /***/function (module, exports, __webpack_require__) {
      var has = __webpack_require__(13);
      var toIObject = __webpack_require__(15);
      var arrayIndexOf = __webpack_require__(52)(false);
      var IE_PROTO = __webpack_require__(82)('IE_PROTO');
      module.exports = function (object, names) {
        var O = toIObject(object);
        var i = 0;
        var result = [];
        var key;
        for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
        // Don't enum bug & hidden keys
        while (names.length > i) if (has(O, key = names[i++])) {
          ~arrayIndexOf(result, key) || result.push(key);
        }
        return result;
      };

      /***/
    }, /* 114 */
    /***/function (module, exports, __webpack_require__) {
      var DESCRIPTORS = __webpack_require__(8);
      var getKeys = __webpack_require__(33);
      var toIObject = __webpack_require__(15);
      var isEnum = __webpack_require__(47).f;
      module.exports = function (isEntries) {
        return function (it) {
          var O = toIObject(it);
          var keys = getKeys(O);
          var length = keys.length;
          var i = 0;
          var result = [];
          var key;
          while (length > i) {
            key = keys[i++];
            if (!DESCRIPTORS || isEnum.call(O, key)) {
              result.push(isEntries ? [key, O[key]] : O[key]);
            }
          }
          return result;
        };
      };

      /***/
    }, /* 115 */
    /***/function (module, exports, __webpack_require__) {
      // all object keys, includes non-enumerable and symbols
      var gOPN = __webpack_require__(31);
      var gOPS = __webpack_require__(59);
      var anObject = __webpack_require__(1);
      var Reflect = __webpack_require__(3).Reflect;
      module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
        var keys = gOPN.f(anObject(it));
        var getSymbols = gOPS.f;
        return getSymbols ? keys.concat(getSymbols(it)) : keys;
      };

      /***/
    }, /* 116 */
    /***/function (module, exports, __webpack_require__) {
      var $parseFloat = __webpack_require__(3).parseFloat;
      var $trim = __webpack_require__(43).trim;
      module.exports = 1 / $parseFloat(__webpack_require__(86) + '-0') !== -Infinity ? function parseFloat(str) {
        var string = $trim(String(str), 3);
        var result = $parseFloat(string);
        return result === 0 && string.charAt(0) == '-' ? -0 : result;
      } : $parseFloat;

      /***/
    }, /* 117 */
    /***/function (module, exports, __webpack_require__) {
      var $parseInt = __webpack_require__(3).parseInt;
      var $trim = __webpack_require__(43).trim;
      var ws = __webpack_require__(86);
      var hex = /^[-+]?0[xX]/;
      module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
        var string = $trim(String(str), 3);
        return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
      } : $parseInt;

      /***/
    }, /* 118 */
    /***/function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(1);
      var isObject = __webpack_require__(4);
      var newPromiseCapability = __webpack_require__(109);
      module.exports = function (C, x) {
        anObject(C);
        if (isObject(x) && x.constructor === C) return x;
        var promiseCapability = newPromiseCapability.f(C);
        var resolve = promiseCapability.resolve;
        resolve(x);
        return promiseCapability.promise;
      };

      /***/
    }, /* 119 */
    /***/function (module, exports) {
      // 7.2.9 SameValue(x, y)
      module.exports = Object.is || function is(x, y) {
        // eslint-disable-next-line no-self-compare
        return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
      };

      /***/
    }, /* 120 */
    /***/function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-string-pad-start-end
      var toLength = __webpack_require__(6);
      var repeat = __webpack_require__(85);
      var defined = __webpack_require__(24);
      module.exports = function (that, maxLength, fillString, left) {
        var S = String(defined(that));
        var stringLength = S.length;
        var fillStr = fillString === undefined ? ' ' : String(fillString);
        var intMaxLength = toLength(maxLength);
        if (intMaxLength <= stringLength || fillStr == '') return S;
        var fillLen = intMaxLength - stringLength;
        var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
        if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
        return left ? stringFiller + S : S + stringFiller;
      };

      /***/
    }, /* 121 */
    /***/function (module, exports, __webpack_require__) {
      // https://tc39.github.io/ecma262/#sec-toindex
      var toInteger = __webpack_require__(22);
      var toLength = __webpack_require__(6);
      module.exports = function (it) {
        if (it === undefined) return 0;
        var number = toInteger(it);
        var length = toLength(number);
        if (number !== length) throw RangeError('Wrong length!');
        return length;
      };

      /***/
    }, /* 122 */
    /***/function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var core = __webpack_require__(7);
      var LIBRARY = __webpack_require__(29);
      var wksExt = __webpack_require__(89);
      var defineProperty = __webpack_require__(9).f;
      module.exports = function (name) {
        var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
        if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
          value: wksExt.f(name)
        });
      };

      /***/
    }, /* 123 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var LIBRARY = __webpack_require__(29);
      var global = __webpack_require__(3);
      var ctx = __webpack_require__(19);
      var classof = __webpack_require__(45);
      var $export = __webpack_require__(0);
      var isObject = __webpack_require__(4);
      var aFunction = __webpack_require__(17);
      var anInstance = __webpack_require__(38);
      var forOf = __webpack_require__(56);
      var speciesConstructor = __webpack_require__(48);
      var task = __webpack_require__(87).set;
      var microtask = __webpack_require__(169)();
      var newPromiseCapabilityModule = __webpack_require__(109);
      var perform = __webpack_require__(170);
      var userAgent = __webpack_require__(63);
      var promiseResolve = __webpack_require__(118);
      var PROMISE = 'Promise';
      var TypeError = global.TypeError;
      var process = global.process;
      var versions = process && process.versions;
      var v8 = versions && versions.v8 || '';
      var $Promise = global[PROMISE];
      var isNode = classof(process) == 'process';
      var empty = function empty() {/* empty */};
      var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
      var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
      var USE_NATIVE = !!function () {
        try {
          // correct subclassing with @@species support
          var promise = $Promise.resolve(1);
          var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
            exec(empty, empty);
          };
          // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
          return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise
          // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
          // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
          // we can't detect it synchronously, so just check versions
          && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
        } catch (e) {/* empty */}
      }();

      // helpers
      var isThenable = function isThenable(it) {
        var then;
        return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
      };
      var notify = function notify(promise, isReject) {
        if (promise._n) return;
        promise._n = true;
        var chain = promise._c;
        microtask(function () {
          var value = promise._v;
          var ok = promise._s == 1;
          var i = 0;
          var run = function run(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
              if (handler) {
                if (!ok) {
                  if (promise._h == 2) onHandleUnhandled(promise);
                  promise._h = 1;
                }
                if (handler === true) result = value;else {
                  if (domain) domain.enter();
                  result = handler(value); // may throw
                  if (domain) {
                    domain.exit();
                    exited = true;
                  }
                }
                if (result === reaction.promise) {
                  reject(TypeError('Promise-chain cycle'));
                } else if (then = isThenable(result)) {
                  then.call(result, resolve, reject);
                } else resolve(result);
              } else reject(value);
            } catch (e) {
              if (domain && !exited) domain.exit();
              reject(e);
            }
          };
          while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
          promise._c = [];
          promise._n = false;
          if (isReject && !promise._h) onUnhandled(promise);
        });
      };
      var onUnhandled = function onUnhandled(promise) {
        task.call(global, function () {
          var value = promise._v;
          var unhandled = isUnhandled(promise);
          var result, handler, console;
          if (unhandled) {
            result = perform(function () {
              if (isNode) {
                process.emit('unhandledRejection', value, promise);
              } else if (handler = global.onunhandledrejection) {
                handler({
                  promise: promise,
                  reason: value
                });
              } else if ((console = global.console) && console.error) {
                console.error('Unhandled promise rejection', value);
              }
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = isNode || isUnhandled(promise) ? 2 : 1;
          }
          promise._a = undefined;
          if (unhandled && result.e) throw result.v;
        });
      };
      var isUnhandled = function isUnhandled(promise) {
        return promise._h !== 1 && (promise._a || promise._c).length === 0;
      };
      var onHandleUnhandled = function onHandleUnhandled(promise) {
        task.call(global, function () {
          var handler;
          if (isNode) {
            process.emit('rejectionHandled', promise);
          } else if (handler = global.onrejectionhandled) {
            handler({
              promise: promise,
              reason: promise._v
            });
          }
        });
      };
      var $reject = function $reject(value) {
        var promise = this;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise; // unwrap
        promise._v = value;
        promise._s = 2;
        if (!promise._a) promise._a = promise._c.slice();
        notify(promise, true);
      };
      var $resolve = function $resolve(value) {
        var promise = this;
        var then;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise; // unwrap
        try {
          if (promise === value) throw TypeError("Promise can't be resolved itself");
          if (then = isThenable(value)) {
            microtask(function () {
              var wrapper = {
                _w: promise,
                _d: false
              }; // wrap
              try {
                then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
              } catch (e) {
                $reject.call(wrapper, e);
              }
            });
          } else {
            promise._v = value;
            promise._s = 1;
            notify(promise, false);
          }
        } catch (e) {
          $reject.call({
            _w: promise,
            _d: false
          }, e); // wrap
        }
      };

      // constructor polyfill
      if (!USE_NATIVE) {
        // 25.4.3.1 Promise(executor)
        $Promise = function Promise(executor) {
          anInstance(this, $Promise, PROMISE, '_h');
          aFunction(executor);
          Internal.call(this);
          try {
            executor(ctx($resolve, this, 1), ctx($reject, this, 1));
          } catch (err) {
            $reject.call(this, err);
          }
        };
        // eslint-disable-next-line no-unused-vars
        Internal = function Promise(executor) {
          this._c = []; // <- awaiting reactions
          this._a = undefined; // <- checked in isUnhandled reactions
          this._s = 0; // <- state
          this._d = false; // <- done
          this._v = undefined; // <- value
          this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
          this._n = false; // <- notify
        };

        Internal.prototype = __webpack_require__(40)($Promise.prototype, {
          // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
          then: function then(onFulfilled, onRejected) {
            var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = isNode ? process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) notify(this, false);
            return reaction.promise;
          },
          // 25.4.5.1 Promise.prototype.catch(onRejected)
          'catch': function _catch(onRejected) {
            return this.then(undefined, onRejected);
          }
        });
        OwnPromiseCapability = function OwnPromiseCapability() {
          var promise = new Internal();
          this.promise = promise;
          this.resolve = ctx($resolve, promise, 1);
          this.reject = ctx($reject, promise, 1);
        };
        newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
          return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
        };
      }
      $export($export.G + $export.W + $export.F * !USE_NATIVE, {
        Promise: $Promise
      });
      __webpack_require__(42)($Promise, PROMISE);
      __webpack_require__(41)(PROMISE);
      Wrapper = __webpack_require__(7)[PROMISE];

      // statics
      $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
        // 25.4.4.5 Promise.reject(r)
        reject: function reject(r) {
          var capability = newPromiseCapability(this);
          var $$reject = capability.reject;
          $$reject(r);
          return capability.promise;
        }
      });
      $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
        // 25.4.4.6 Promise.resolve(x)
        resolve: function resolve(x) {
          return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
        }
      });
      $export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(58)(function (iter) {
        $Promise.all(iter)['catch'](empty);
      })), PROMISE, {
        // 25.4.4.1 Promise.all(iterable)
        all: function all(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var resolve = capability.resolve;
          var reject = capability.reject;
          var result = perform(function () {
            var values = [];
            var index = 0;
            var remaining = 1;
            forOf(iterable, false, function (promise) {
              var $index = index++;
              var alreadyCalled = false;
              values.push(undefined);
              remaining++;
              C.resolve(promise).then(function (value) {
                if (alreadyCalled) return;
                alreadyCalled = true;
                values[$index] = value;
                --remaining || resolve(values);
              }, reject);
            });
            --remaining || resolve(values);
          });
          if (result.e) reject(result.v);
          return capability.promise;
        },
        // 25.4.4.4 Promise.race(iterable)
        race: function race(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var reject = capability.reject;
          var result = perform(function () {
            forOf(iterable, false, function (promise) {
              C.resolve(promise).then(capability.resolve, reject);
            });
          });
          if (result.e) reject(result.v);
          return capability.promise;
        }
      });

      /***/
    }, /* 124 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var regexpExec = __webpack_require__(80);
      __webpack_require__(0)({
        target: 'RegExp',
        proto: true,
        forced: regexpExec !== /./.exec
      }, {
        exec: regexpExec
      });

      /***/
    }, /* 125 */
    /***/function (module, exports, __webpack_require__) {
      // 21.2.5.3 get RegExp.prototype.flags()
      if (__webpack_require__(8) && /./g.flags != 'g') __webpack_require__(9).f(RegExp.prototype, 'flags', {
        configurable: true,
        get: __webpack_require__(55)
      });

      /***/
    }, /* 126 */
    /***/function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */(function (process) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        *
        * This source code is licensed under the MIT license found in the
        * LICENSE file in the root directory of this source tree.
        */

        if (process.env.NODE_ENV !== 'production') {
          var ReactIs = __webpack_require__(127);

          // By explicitly using `prop-types` you are opting into new development behavior.
          // http://fb.me/prop-types-in-prod
          var throwOnDirectAccess = true;
          module.exports = __webpack_require__(325)(ReactIs.isElement, throwOnDirectAccess);
        } else {
          // By explicitly using `prop-types` you are opting into new production behavior.
          // http://fb.me/prop-types-in-prod
          module.exports = __webpack_require__(324)();
        }

        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(49));

      /***/
    }, /* 127 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      /* WEBPACK VAR INJECTION */
      (function (process) {
        if (process.env.NODE_ENV === 'production') {
          module.exports = __webpack_require__(327);
        } else {
          module.exports = __webpack_require__(326);
        }

        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(49));

      /***/
    }, /* 128 */
    /***/function (module, exports) {
      var g;

      // This works in non-strict mode
      g = function () {
        return this;
      }();
      try {
        // This works if eval is allowed (see CSP)
        g = g || Function("return this")() || (1, eval)("this");
      } catch (e) {
        // This works if the window reference is available
        if (typeof window === "object") g = window;
      }

      // g can still be undefined, but nothing to do about it...
      // We return undefined, instead of nothing here, so it's
      // easier to handle this case. if(!global) { ...}

      module.exports = g;

      /***/
    }, /* 129 */
    /***/function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      Object.defineProperty(__webpack_exports__, "__esModule", {
        value: true
      });
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0__require_babel_polyfill__ = __webpack_require__(136);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_1_ziggeo_client_sdk_build_ziggeo_css__ = __webpack_require__(330);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_1_ziggeo_client_sdk_build_ziggeo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ziggeo_client_sdk_build_ziggeo_css__);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_2_ziggeo_client_sdk_build_ziggeo_js__ = __webpack_require__(334);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_2_ziggeo_client_sdk_build_ziggeo_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ziggeo_client_sdk_build_ziggeo_js__);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_3__components_ZiggeoPlayer__ = __webpack_require__(134);
      /* harmony reexport (binding) */
      __webpack_require__.d(__webpack_exports__, "ZiggeoPlayer", function () {
        return __WEBPACK_IMPORTED_MODULE_3__components_ZiggeoPlayer__["a"];
      });
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_4__components_ZiggeoAudioPlayer__ = __webpack_require__(132);
      /* harmony reexport (binding) */
      __webpack_require__.d(__webpack_exports__, "ZiggeoAudioPlayer", function () {
        return __WEBPACK_IMPORTED_MODULE_4__components_ZiggeoAudioPlayer__["a"];
      });
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_5__components_ZiggeoRecorder__ = __webpack_require__(135);
      /* harmony reexport (binding) */
      __webpack_require__.d(__webpack_exports__, "ZiggeoRecorder", function () {
        return __WEBPACK_IMPORTED_MODULE_5__components_ZiggeoRecorder__["a"];
      });
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_6__components_ZiggeoAudioRecorder__ = __webpack_require__(133);
      /* harmony reexport (binding) */
      __webpack_require__.d(__webpack_exports__, "ZiggeoAudioRecorder", function () {
        return __WEBPACK_IMPORTED_MODULE_6__components_ZiggeoAudioRecorder__["a"];
      });

      /***/
    }, /* 130 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      __webpack_require__(131);
      var _global = _interopRequireDefault(__webpack_require__(149));
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          "default": obj
        };
      }
      if (_global["default"]._babelPolyfill && typeof console !== "undefined" && console.warn) {
        console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
      }
      _global["default"]._babelPolyfill = true;

      /***/
    }, /* 131 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      __webpack_require__(137);
      __webpack_require__(139);
      __webpack_require__(138);
      __webpack_require__(145);
      __webpack_require__(144);
      __webpack_require__(147);
      __webpack_require__(146);
      __webpack_require__(148);
      __webpack_require__(141);
      __webpack_require__(142);
      __webpack_require__(140);
      __webpack_require__(143);
      __webpack_require__(319);
      __webpack_require__(328);

      /***/
    }, /* 132 */
    /***/function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(50);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_1__withZiggeoApplication__ = __webpack_require__(51);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(44);
      function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          if (enumerableOnly) {
            symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
          }
          keys.push.apply(keys, symbols);
        }
        return keys;
      }
      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i] != null ? arguments[i] : {};
          if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
              _defineProperty(target, key, source[key]);
            });
          } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
          } else {
            ownKeys(Object(source)).forEach(function (key) {
              Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
          }
        }
        return target;
      }
      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }
        return obj;
      }
      function _extends() {
        _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        return _extends.apply(this, arguments);
      }
      function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
      }
      function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
      }
      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      }
      function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
          for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }
      function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
          var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
          for (i = 0; i < sourceSymbolKeys.length; i++) {
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
          }
        }
        return target;
      }
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          target[key] = source[key];
        }
        return target;
      }
      var ZiggeoAudioPlayer = function ZiggeoAudioPlayer(_ref) {
        var app = _ref.app,
          props = _objectWithoutProperties(_ref, ["app"]);
        var updateInstance = props.updateInstance;
        var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState2 = _slicedToArray(_useState, 2),
          player = _useState2[0],
          setPlayer = _useState2[1];
        var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState4 = _slicedToArray(_useState3, 2),
          attributes = _useState4[0],
          setAttributes = _useState4[1];
        var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState6 = _slicedToArray(_useState5, 2),
          elementProps = _useState6[0],
          setElementProps = _useState6[1];
        var playerElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
          if (attributes && player && updateInstance) {
            setAttributes(null);
          }
        }, [updateInstance]);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
          if (!attributes) {
            setAttributes(ziggeoAttributes());
            setElementProps(ziggeoElementProps());
          }
          if (playerElement && attributes) {
            setPlayer(new ZiggeoApi.V2.AudioPlayer({
              element: playerElement.current,
              attrs: attributes
            }));
          }
        }, [attributes]);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
          if (player) {
            player.activate();
            Object.entries(ziggeoEvents).forEach(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                event = _ref3[0],
                func = _ref3[1];
              player.on(event, func.bind(ZiggeoAudioPlayer, player.get()));
            });
            props.onRef(player);
          }
          return function () {
            if (player) {
              props.onRef(null);
              player.destroy();
            }
          };
        }, [player]);
        /**
         * Set all props defined by user
         * @returns {{}}
         */

        var ziggeoAttributes = function ziggeoAttributes() {
          return Object.keys(props).filter(function (k) {
            return __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* ziggeoAudioPlayerAttributesPropTypes */][k];
          }).reduce(function (attr, k) {
            attr[k.replace(/^_/g, '')] = props[k];
            return attr;
          }, {});
        };
        /**
         * Include props which are not related to Ziggeo
         * @returns {{}}
         */

        var ziggeoElementProps = function ziggeoElementProps() {
          return Object.keys(props).filter(function (k) {
            return !ZiggeoAudioPlayer.propTypes[k];
          }).reduce(function (attr, k) {
            attr[k] = props[k];
            return attr;
          }, {});
        };
        /**
         * Add Related Events
         * @type {{}}
         */

        var ziggeoEvents = Object.keys(Object.assign(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ziggeoPlayerEmbeddingEventsPropTypes */], __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* ziggeoCommonEmbeddingEventsPropTypes */])).reduce(function (memo, propName) {
          var eventName = propName.replace(/([A-Z])/g, '_$1').toLowerCase().slice(3).replace(/(recorder_|player_)/g, '');
          memo[eventName] = function () {
            props[propName].apply(props, arguments);
          };
          return memo;
        }, {}); // Delegate ziggeo attrs to the player

        var playerInstance = function playerInstance() {
          return player;
        };
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
          ref: playerElement,
          app: app
        }, elementProps));
      };
      ZiggeoAudioPlayer.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* ziggeoAudioPlayerAttributesPropTypes */]), __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ziggeoPlayerEmbeddingEventsPropTypes */]), __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* ziggeoCommonEmbeddingEventsPropTypes */]), __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* ziggeoPlayerApplicationOptions */]), __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* reactCustomOptions */]);
      ZiggeoAudioPlayer.defaultProps = _objectSpread({
        // Presentational parameters
        'width': 640,
        'height': 480,
        'theme': 'default',
        'themecolor': 'default',
        'hidebarafter': 5000,
        // in milliseconds
        'skipseconds': 5,
        // in seconds
        // only react related options
        'preventReRenderOnUpdate': true
      }, Object.keys(Object.assign(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ziggeoPlayerEmbeddingEventsPropTypes */], __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* ziggeoCommonEmbeddingEventsPropTypes */])).reduce(function (defaults, event) {
        defaults[event] = function () {};
        return defaults;
      }, {}));
      /* harmony default export */
      __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__withZiggeoApplication__["a" /* default */])(ZiggeoAudioPlayer);

      /***/
    }, /* 133 */
    /***/function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(50);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(44);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_2__withZiggeoApplication__ = __webpack_require__(51);
      function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          if (enumerableOnly) {
            symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
          }
          keys.push.apply(keys, symbols);
        }
        return keys;
      }
      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i] != null ? arguments[i] : {};
          if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
              _defineProperty(target, key, source[key]);
            });
          } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
          } else {
            ownKeys(Object(source)).forEach(function (key) {
              Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
          }
        }
        return target;
      }
      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }
        return obj;
      }
      function _extends() {
        _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        return _extends.apply(this, arguments);
      }
      function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
      }
      function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
      }
      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      }
      function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
          for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }
      function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
          var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
          for (i = 0; i < sourceSymbolKeys.length; i++) {
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
          }
        }
        return target;
      }
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          target[key] = source[key];
        }
        return target;
      }

      /* globals ZiggeoApi */

      var ZiggeoAudioRecorder = function ZiggeoAudioRecorder(_ref) {
        var app = _ref.app,
          props = _objectWithoutProperties(_ref, ["app"]);
        var updateInstance = props.updateInstance;
        var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState2 = _slicedToArray(_useState, 2),
          recorder = _useState2[0],
          setRecorder = _useState2[1];
        var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState4 = _slicedToArray(_useState3, 2),
          attributes = _useState4[0],
          setAttributes = _useState4[1];
        var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState6 = _slicedToArray(_useState5, 2),
          elementProps = _useState6[0],
          setElementProps = _useState6[1];
        var recorderElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
          if (attributes && recorder && updateInstance) {
            setAttributes(null);
          }
        }, [updateInstance]);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
          if (!attributes) {
            setAttributes(ziggeoAttributes());
            setElementProps(ziggeoElementProps());
          }
          if (recorderElement && attributes) {
            setRecorder(new ZiggeoApi.V2.AudioRecorder({
              element: recorderElement.current,
              attrs: attributes
            }));
          }
        }, [attributes, recorderElement]);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
          if (recorder) {
            recorder.activate();
            Object.entries(ziggeoEvents).forEach(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                event = _ref3[0],
                func = _ref3[1];
              recorder.on(event, func.bind(ZiggeoAudioRecorder, recorder.get()));
            });
            props.onRef(recorder);
          }
          return function () {
            if (recorder) {
              props.onRef(null);
              recorder.destroy();
            }
          };
        }, [recorder]);
        /**
         * Set all props defined by user
         * @returns {{}}
         */

        var ziggeoAttributes = function ziggeoAttributes() {
          return Object.keys(props).filter(function (k) {
            return Object.assign(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ziggeoAudioRecorderAttributesPropTypes */], __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ziggeoPlayerApplicationOptions */])[k];
          }).reduce(function (attr, k) {
            attr[k.replace(/^_/g, '')] = props[k];
            return attr;
          }, {});
        };
        /**
         * Include props which are not related to Ziggeo
         * @returns {{}}
         */

        var ziggeoElementProps = function ziggeoElementProps() {
          return Object.keys(props).filter(function (k) {
            return !ZiggeoAudioRecorder.propTypes[k];
          }).reduce(function (attr, k) {
            attr[k] = props[k];
            return attr;
          }, {});
        };
        /**
         * Add Related Events
         * @type {{}}
         */

        var ziggeoEvents = Object.keys(Object.assign(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ziggeoRecorderEmbeddingEventsPropTypes */], __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* ziggeoCommonEmbeddingEventsPropTypes */])).reduce(function (memo, propName) {
          var eventName = propName.replace(/([A-Z])/g, '_$1').toLowerCase().slice(3).replace(/(recorder_|player_)/g, '');
          memo[eventName] = function () {
            props[propName].apply(props, arguments);
          };
          return memo;
        }, {});
        /**
         *
         * @returns AudioPlayer Instance
         */

        var recorderInstance = function recorderInstance() {
          return recorder;
        };
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
          ref: recorderElement,
          app: app
        }, elementProps));
      };
      ZiggeoAudioRecorder.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ziggeoAudioRecorderAttributesPropTypes */]), __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ziggeoRecorderEmbeddingEventsPropTypes */]), __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* ziggeoCommonEmbeddingEventsPropTypes */]), __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ziggeoRecorderApplicationOptions */]), __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* reactCustomOptions */]);
      ZiggeoAudioRecorder.defaultProps = _objectSpread({
        // Presentational parameters
        'width': 640,
        'height': 480,
        'countdown': 3,
        'theme': 'default',
        'themecolor': 'default',
        'primaryrecord': true,
        // Video management parameters
        'audiobitrate': 'auto',
        'microphone-volume': 1,
        // Operational parameters
        'allowupload': true,
        'allowrecord': true,
        'force-overwrite': true,
        'allowcustomupload': true,
        'recordermode': true,
        // only react related options
        'preventReRenderOnUpdate': true,
        'display-timer': true,
        'rtmpmicrophonecodec': 'speex',
        'transcript-language': 'en-US',
        // application settings
        webrtc_streaming: false,
        webrtc_streaming_if_necessary: false,
        webrtc_on_mobile: false,
        auth: false,
        debug: false,
        testing_application: false
      }, Object.keys(Object.assign(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ziggeoRecorderEmbeddingEventsPropTypes */], __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* ziggeoCommonEmbeddingEventsPropTypes */])).reduce(function (defaults, event) {
        defaults[event] = function () {};
        return defaults;
      }, {}));
      /* harmony default export */
      __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__withZiggeoApplication__["a" /* default */])(ZiggeoAudioRecorder);

      /***/
    }, /* 134 */
    /***/function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(50);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_1__withZiggeoApplication__ = __webpack_require__(51);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(44);
      function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          if (enumerableOnly) {
            symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
          }
          keys.push.apply(keys, symbols);
        }
        return keys;
      }
      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i] != null ? arguments[i] : {};
          if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
              _defineProperty(target, key, source[key]);
            });
          } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
          } else {
            ownKeys(Object(source)).forEach(function (key) {
              Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
          }
        }
        return target;
      }
      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }
        return obj;
      }
      function _extends() {
        _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        return _extends.apply(this, arguments);
      }
      function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
      }
      function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
      }
      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      }
      function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
          for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }
      function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
          var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
          for (i = 0; i < sourceSymbolKeys.length; i++) {
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
          }
        }
        return target;
      }
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          target[key] = source[key];
        }
        return target;
      }
      var ZiggeoPlayer = function ZiggeoPlayer(_ref) {
        var app = _ref.app,
          props = _objectWithoutProperties(_ref, ["app"]);
        var updateInstance = props.updateInstance;
        var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState2 = _slicedToArray(_useState, 2),
          player = _useState2[0],
          setPlayer = _useState2[1];
        var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState4 = _slicedToArray(_useState3, 2),
          attributes = _useState4[0],
          setAttributes = _useState4[1];
        var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState6 = _slicedToArray(_useState5, 2),
          elementProps = _useState6[0],
          setElementProps = _useState6[1];
        var playerElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
          if (attributes && player && updateInstance) {
            setAttributes(null);
          }
        }, [updateInstance]);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
          if (!attributes) {
            setAttributes(ziggeoAttributes());
            setElementProps(ziggeoElementProps());
          }
          if (playerElement && attributes) {
            setPlayer(new ZiggeoApi.V2.Player({
              element: playerElement.current,
              attrs: attributes
            }));
          }
        }, [attributes]);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
          if (player) {
            player.activate();
            Object.entries(ziggeoEvents).forEach(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                event = _ref3[0],
                func = _ref3[1];
              player.on(event, func.bind(ZiggeoPlayer, player.get()));
            });
            props.onRef(player);
          }
          return function () {
            if (player) {
              props.onRef(null);
              player.destroy();
            }
          };
        }, [player]);
        /**
         * Set all props defined by user
         * @returns {{}}
         */

        var ziggeoAttributes = function ziggeoAttributes() {
          return Object.keys(props).filter(function (k) {
            return __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* ziggeoPlayerAttributesPropTypes */][k];
          }).reduce(function (attr, k) {
            attr[k.replace(/^_/g, '')] = props[k];
            return attr;
          }, {});
        };
        /**
         * Include props which are not related to Ziggeo
         * @returns {{}}
         */

        var ziggeoElementProps = function ziggeoElementProps() {
          return Object.keys(props).filter(function (k) {
            return !ZiggeoPlayer.propTypes[k];
          }).reduce(function (attr, k) {
            attr[k] = props[k];
            return attr;
          }, {});
        };
        /**
         * Add Related Events
         * @type {{}}
         */

        var ziggeoEvents = Object.keys(Object.assign(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ziggeoPlayerEmbeddingEventsPropTypes */], __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* ziggeoCommonEmbeddingEventsPropTypes */])).reduce(function (memo, propName) {
          var eventName = propName.replace(/([A-Z])/g, '_$1').toLowerCase().slice(3).replace(/(recorder_|player_)/g, '');
          memo[eventName] = function () {
            props[propName].apply(props, arguments);
          };
          return memo;
        }, {}); // Delegate ziggeo attrs to the player

        var playerInstance = function playerInstance() {
          return player;
        };
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
          ref: playerElement,
          app: app
        }, elementProps));
      };
      ZiggeoPlayer.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* ziggeoPlayerAttributesPropTypes */]), __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ziggeoPlayerEmbeddingEventsPropTypes */]), __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* ziggeoCommonEmbeddingEventsPropTypes */]), __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* ziggeoPlayerApplicationOptions */]), __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* reactCustomOptions */]);
      ZiggeoPlayer.defaultProps = _objectSpread({
        // Presentational parameters
        'width': 640,
        'height': 480,
        'picksnapshots': true,
        'theme': 'default',
        'themecolor': 'default',
        'hidebarafter': 5000,
        // in milliseconds
        'skipseconds': 5,
        // in seconds
        // only react related options
        'preventReRenderOnUpdate': true
      }, Object.keys(Object.assign(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* ziggeoPlayerEmbeddingEventsPropTypes */], __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* ziggeoCommonEmbeddingEventsPropTypes */])).reduce(function (defaults, event) {
        defaults[event] = function () {};
        return defaults;
      }, {}));
      /* harmony default export */
      __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__withZiggeoApplication__["a" /* default */])(ZiggeoPlayer);

      /***/
    }, /* 135 */
    /***/function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(50);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(44);
      /* harmony import */
      var __WEBPACK_IMPORTED_MODULE_2__withZiggeoApplication__ = __webpack_require__(51);
      function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          if (enumerableOnly) {
            symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
          }
          keys.push.apply(keys, symbols);
        }
        return keys;
      }
      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i] != null ? arguments[i] : {};
          if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
              _defineProperty(target, key, source[key]);
            });
          } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
          } else {
            ownKeys(Object(source)).forEach(function (key) {
              Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
          }
        }
        return target;
      }
      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }
        return obj;
      }
      function _extends() {
        _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        return _extends.apply(this, arguments);
      }
      function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
      }
      function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
      }
      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      }
      function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
          for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }
      function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
          var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
          for (i = 0; i < sourceSymbolKeys.length; i++) {
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
          }
        }
        return target;
      }
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          target[key] = source[key];
        }
        return target;
      }

      /* globals ZiggeoApi */

      var ZiggeoRecorder = function ZiggeoRecorder(_ref) {
        var app = _ref.app,
          props = _objectWithoutProperties(_ref, ["app"]);
        var updateInstance = props.updateInstance;
        var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState2 = _slicedToArray(_useState, 2),
          recorder = _useState2[0],
          setRecorder = _useState2[1];
        var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState4 = _slicedToArray(_useState3, 2),
          attributes = _useState4[0],
          setAttributes = _useState4[1];
        var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState6 = _slicedToArray(_useState5, 2),
          elementProps = _useState6[0],
          setElementProps = _useState6[1];
        var recorderElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
          if (attributes && recorder && updateInstance) {
            setAttributes(null);
          }
        }, [updateInstance]);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
          if (!attributes) {
            setAttributes(ziggeoAttributes());
            setElementProps(ziggeoElementProps());
          }
          if (recorderElement && attributes) {
            setRecorder(new ZiggeoApi.V2.Recorder({
              element: recorderElement.current,
              attrs: attributes
            }));
          }
        }, [attributes, recorderElement]);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
          if (recorder) {
            recorder.activate();
            Object.entries(ziggeoEvents).forEach(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                event = _ref3[0],
                func = _ref3[1];
              recorder.on(event, func.bind(ZiggeoRecorder, recorder.get()));
            });
            props.onRef(recorder);
          }
          return function () {
            if (recorder) {
              props.onRef(null);
              recorder.destroy();
            }
          };
        }, [recorder]);
        /**
         * Set all props defined by user
         * @returns {{}}
         */

        var ziggeoAttributes = function ziggeoAttributes() {
          return Object.keys(props).filter(function (k) {
            return Object.assign(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* ziggeoRecorderAttributesPropTypes */], __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ziggeoPlayerApplicationOptions */])[k];
          }).reduce(function (attr, k) {
            attr[k.replace(/^_/g, '')] = props[k];
            return attr;
          }, {});
        };
        /**
         * Include props which are not related to Ziggeo
         * @returns {{}}
         */

        var ziggeoElementProps = function ziggeoElementProps() {
          return Object.keys(props).filter(function (k) {
            return !ZiggeoRecorder.propTypes[k];
          }).reduce(function (attr, k) {
            attr[k] = props[k];
            return attr;
          }, {});
        };
        /**
         * Add Related Events
         * @type {{}}
         */

        var ziggeoEvents = Object.keys(Object.assign(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ziggeoRecorderEmbeddingEventsPropTypes */], __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* ziggeoCommonEmbeddingEventsPropTypes */])).reduce(function (memo, propName) {
          var eventName = propName.replace(/([A-Z])/g, '_$1').toLowerCase().slice(3).replace(/(recorder_|player_)/g, '');
          memo[eventName] = function () {
            props[propName].apply(props, arguments);
          };
          return memo;
        }, {});
        /**
         *
         * @returns Player Instance
         */

        var recorderInstance = function recorderInstance() {
          return recorder;
        };
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
          ref: recorderElement,
          app: app
        }, elementProps));
      };
      ZiggeoRecorder.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* ziggeoRecorderAttributesPropTypes */]), __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ziggeoRecorderEmbeddingEventsPropTypes */]), __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* ziggeoCommonEmbeddingEventsPropTypes */]), __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ziggeoRecorderApplicationOptions */]), __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* reactCustomOptions */]);
      ZiggeoRecorder.defaultProps = _objectSpread({
        // Presentational parameters
        'width': 640,
        'height': 480,
        'picksnapshots': true,
        'countdown': 3,
        'snapshotmax': 15,
        'gallerysnapshots': 3,
        'theme': 'default',
        'themecolor': 'default',
        'primaryrecord': true,
        // Video management parameters
        'recordingwidth': 640,
        'recordingheight': 480,
        'framerate': 25,
        'videobitrate': 'auto',
        'audiobitrate': 'auto',
        'microphone-volume': 1,
        // Operational parameters
        'allowupload': true,
        'allowrecord': true,
        'force-overwrite': true,
        'allowcustomupload': true,
        'recordermode': true,
        'cpu-friendly': false,
        // only react related options
        'preventReRenderOnUpdate': true,
        'display-timer': true,
        'rtmpstreamtype': 'mp4',
        'rtmpmicrophonecodec': 'speex',
        'transcript-language': 'en-US',
        'multistreamreversable': true,
        'multistreamdraggable': true,
        'addstreamproportional': true,
        'addstreampositionx': 5,
        'addstreampositiony': 5,
        'addstreampositionwidth': 120,
        'addstreampositionheight': 95,
        'addstreamminwidth': 120,
        'addstreamminheight': 95,
        // application settings
        webrtc_streaming: false,
        webrtc_streaming_if_necessary: false,
        webrtc_on_mobile: false,
        auth: false,
        debug: false,
        testing_application: false,
        // screen configuration for Ziggeo extension
        "allowscreen": false,
        chrome_extension_id: "meoefjkcilgjlkibnjjlfdgphacbeglk",
        chrome_extension_install_link: "https://chrome.google.com/webstore/detail/meoefjkcilgjlkibnjjlfdgphacbeglk",
        opera_extension_id: "dnnolmnenehhgplebjhbcmfdbaabkepm",
        opera_extension_install_link: "https://addons.opera.com/en/extensions/details/3d46d4c36fefe97e76622c54b2eb6ea1d5406767"
      }, Object.keys(Object.assign(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ziggeoRecorderEmbeddingEventsPropTypes */], __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* ziggeoCommonEmbeddingEventsPropTypes */])).reduce(function (defaults, event) {
        defaults[event] = function () {};
        return defaults;
      }, {}));
      /* harmony default export */
      __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__withZiggeoApplication__["a" /* default */])(ZiggeoRecorder); // const doesUpdateRequire = (prevProps, nextProps) => {
      //   // const oldApiKey = prevProps['apiKey'];
      //   // const { apiKey } = nextProps;
      //   const { preventReRenderOnUpdate } = nextProps || true;
      //   return !preventReRenderOnUpdate;
      // };
      // export default withZiggeoApplication(React.memo(ZiggeoRecorder, doesUpdateRequire));

      /***/
    }, /* 136 */
    /***/function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      /* WEBPACK VAR INJECTION */
      (function (global) {
        /* unused harmony default export */var _unused_webpack_default_export = function () {
          if (typeof window !== 'undefined' && !window._babelPolyfill || typeof global !== 'undefined' && !global._babelPolyfill) {
            __webpack_require__(130);
          }
        }();
        /* WEBPACK VAR INJECTION */
      }).call(__webpack_exports__, __webpack_require__(128));

      /***/
    }, /* 137 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(291);
      __webpack_require__(230);
      __webpack_require__(232);
      __webpack_require__(231);
      __webpack_require__(234);
      __webpack_require__(236);
      __webpack_require__(241);
      __webpack_require__(235);
      __webpack_require__(233);
      __webpack_require__(243);
      __webpack_require__(242);
      __webpack_require__(238);
      __webpack_require__(239);
      __webpack_require__(237);
      __webpack_require__(229);
      __webpack_require__(240);
      __webpack_require__(244);
      __webpack_require__(245);
      __webpack_require__(196);
      __webpack_require__(198);
      __webpack_require__(197);
      __webpack_require__(247);
      __webpack_require__(246);
      __webpack_require__(217);
      __webpack_require__(227);
      __webpack_require__(228);
      __webpack_require__(218);
      __webpack_require__(219);
      __webpack_require__(220);
      __webpack_require__(221);
      __webpack_require__(222);
      __webpack_require__(223);
      __webpack_require__(224);
      __webpack_require__(225);
      __webpack_require__(226);
      __webpack_require__(200);
      __webpack_require__(201);
      __webpack_require__(202);
      __webpack_require__(203);
      __webpack_require__(204);
      __webpack_require__(205);
      __webpack_require__(206);
      __webpack_require__(207);
      __webpack_require__(208);
      __webpack_require__(209);
      __webpack_require__(210);
      __webpack_require__(211);
      __webpack_require__(212);
      __webpack_require__(213);
      __webpack_require__(214);
      __webpack_require__(215);
      __webpack_require__(216);
      __webpack_require__(278);
      __webpack_require__(283);
      __webpack_require__(290);
      __webpack_require__(281);
      __webpack_require__(273);
      __webpack_require__(274);
      __webpack_require__(279);
      __webpack_require__(284);
      __webpack_require__(286);
      __webpack_require__(269);
      __webpack_require__(270);
      __webpack_require__(271);
      __webpack_require__(272);
      __webpack_require__(275);
      __webpack_require__(276);
      __webpack_require__(277);
      __webpack_require__(280);
      __webpack_require__(282);
      __webpack_require__(285);
      __webpack_require__(287);
      __webpack_require__(288);
      __webpack_require__(289);
      __webpack_require__(191);
      __webpack_require__(193);
      __webpack_require__(192);
      __webpack_require__(195);
      __webpack_require__(194);
      __webpack_require__(180);
      __webpack_require__(178);
      __webpack_require__(184);
      __webpack_require__(181);
      __webpack_require__(187);
      __webpack_require__(189);
      __webpack_require__(177);
      __webpack_require__(183);
      __webpack_require__(174);
      __webpack_require__(188);
      __webpack_require__(172);
      __webpack_require__(186);
      __webpack_require__(185);
      __webpack_require__(179);
      __webpack_require__(182);
      __webpack_require__(171);
      __webpack_require__(173);
      __webpack_require__(176);
      __webpack_require__(175);
      __webpack_require__(190);
      __webpack_require__(91);
      __webpack_require__(262);
      __webpack_require__(124);
      __webpack_require__(267);
      __webpack_require__(125);
      __webpack_require__(263);
      __webpack_require__(264);
      __webpack_require__(265);
      __webpack_require__(266);
      __webpack_require__(123);
      __webpack_require__(199);
      __webpack_require__(268);
      __webpack_require__(303);
      __webpack_require__(304);
      __webpack_require__(292);
      __webpack_require__(293);
      __webpack_require__(298);
      __webpack_require__(301);
      __webpack_require__(302);
      __webpack_require__(296);
      __webpack_require__(299);
      __webpack_require__(297);
      __webpack_require__(300);
      __webpack_require__(294);
      __webpack_require__(295);
      __webpack_require__(248);
      __webpack_require__(249);
      __webpack_require__(250);
      __webpack_require__(251);
      __webpack_require__(252);
      __webpack_require__(255);
      __webpack_require__(253);
      __webpack_require__(254);
      __webpack_require__(256);
      __webpack_require__(257);
      __webpack_require__(258);
      __webpack_require__(259);
      __webpack_require__(261);
      __webpack_require__(260);
      module.exports = __webpack_require__(7);

      /***/
    }, /* 138 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(305);
      module.exports = __webpack_require__(7).Array.flatMap;

      /***/
    }, /* 139 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(306);
      module.exports = __webpack_require__(7).Array.includes;

      /***/
    }, /* 140 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(307);
      module.exports = __webpack_require__(7).Object.entries;

      /***/
    }, /* 141 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(308);
      module.exports = __webpack_require__(7).Object.getOwnPropertyDescriptors;

      /***/
    }, /* 142 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(309);
      module.exports = __webpack_require__(7).Object.values;

      /***/
    }, /* 143 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      __webpack_require__(123);
      __webpack_require__(310);
      module.exports = __webpack_require__(7).Promise['finally'];

      /***/
    }, /* 144 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(311);
      module.exports = __webpack_require__(7).String.padEnd;

      /***/
    }, /* 145 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(312);
      module.exports = __webpack_require__(7).String.padStart;

      /***/
    }, /* 146 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(314);
      module.exports = __webpack_require__(7).String.trimRight;

      /***/
    }, /* 147 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(313);
      module.exports = __webpack_require__(7).String.trimLeft;

      /***/
    }, /* 148 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(315);
      module.exports = __webpack_require__(89).f('asyncIterator');

      /***/
    }, /* 149 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(161);
      module.exports = __webpack_require__(93).global;

      /***/
    }, /* 150 */
    /***/function (module, exports) {
      module.exports = function (it) {
        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
        return it;
      };

      /***/
    }, /* 151 */
    /***/function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(66);
      module.exports = function (it) {
        if (!isObject(it)) throw TypeError(it + ' is not an object!');
        return it;
      };

      /***/
    }, /* 152 */
    /***/function (module, exports, __webpack_require__) {
      // optional / simple context binding
      var aFunction = __webpack_require__(150);
      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;
        switch (length) {
          case 1:
            return function (a) {
              return fn.call(that, a);
            };
          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };
          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }
        return function /* ...args */
        () {
          return fn.apply(that, arguments);
        };
      };

      /***/
    }, /* 153 */
    /***/function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(66);
      var document = __webpack_require__(65).document;
      // typeof document.createElement is 'object' in old IE
      var is = isObject(document) && isObject(document.createElement);
      module.exports = function (it) {
        return is ? document.createElement(it) : {};
      };

      /***/
    }, /* 154 */
    /***/function (module, exports, __webpack_require__) {
      var global = __webpack_require__(65);
      var core = __webpack_require__(93);
      var ctx = __webpack_require__(152);
      var hide = __webpack_require__(156);
      var has = __webpack_require__(155);
      var PROTOTYPE = 'prototype';
      var $export = function $export(type, name, source) {
        var IS_FORCED = type & $export.F;
        var IS_GLOBAL = type & $export.G;
        var IS_STATIC = type & $export.S;
        var IS_PROTO = type & $export.P;
        var IS_BIND = type & $export.B;
        var IS_WRAP = type & $export.W;
        var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
        var expProto = exports[PROTOTYPE];
        var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
        var key, own, out;
        if (IS_GLOBAL) source = name;
        for (key in source) {
          // contains in native
          own = !IS_FORCED && target && target[key] !== undefined;
          if (own && has(exports, key)) continue;
          // export native or passed
          out = own ? target[key] : source[key];
          // prevent global pollution for namespaces
          exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
          // bind timers to global for call from export context
          : IS_BIND && own ? ctx(out, global)
          // wrap global constructors for prevent change them in library
          : IS_WRAP && target[key] == out ? function (C) {
            var F = function F(a, b, c) {
              if (this instanceof C) {
                switch (arguments.length) {
                  case 0:
                    return new C();
                  case 1:
                    return new C(a);
                  case 2:
                    return new C(a, b);
                }
                return new C(a, b, c);
              }
              return C.apply(this, arguments);
            };
            F[PROTOTYPE] = C[PROTOTYPE];
            return F;
            // make static versions for prototype methods
          }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
          // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
          if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
          }
        }
      };
      // type bitmap
      $export.F = 1; // forced
      $export.G = 2; // global
      $export.S = 4; // static
      $export.P = 8; // proto
      $export.B = 16; // bind
      $export.W = 32; // wrap
      $export.U = 64; // safe
      $export.R = 128; // real proto method for `library`
      module.exports = $export;

      /***/
    }, /* 155 */
    /***/function (module, exports) {
      var hasOwnProperty = {}.hasOwnProperty;
      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };

      /***/
    }, /* 156 */
    /***/function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(158);
      var createDesc = __webpack_require__(159);
      module.exports = __webpack_require__(64) ? function (object, key, value) {
        return dP.f(object, key, createDesc(1, value));
      } : function (object, key, value) {
        object[key] = value;
        return object;
      };

      /***/
    }, /* 157 */
    /***/function (module, exports, __webpack_require__) {
      module.exports = !__webpack_require__(64) && !__webpack_require__(94)(function () {
        return Object.defineProperty(__webpack_require__(153)('div'), 'a', {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });

      /***/
    }, /* 158 */
    /***/function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(151);
      var IE8_DOM_DEFINE = __webpack_require__(157);
      var toPrimitive = __webpack_require__(160);
      var dP = Object.defineProperty;
      exports.f = __webpack_require__(64) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
          return dP(O, P, Attributes);
        } catch (e) {/* empty */}
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
      };

      /***/
    }, /* 159 */
    /***/function (module, exports) {
      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        };
      };

      /***/
    }, /* 160 */
    /***/function (module, exports, __webpack_require__) {
      // 7.1.1 ToPrimitive(input [, PreferredType])
      var isObject = __webpack_require__(66);
      // instead of the ES6 spec version, we didn't implement @@toPrimitive case
      // and the second argument - flag - preferred type is a string
      module.exports = function (it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
      };

      /***/
    }, /* 161 */
    /***/function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-global
      var $export = __webpack_require__(154);
      $export($export.G, {
        global: __webpack_require__(65)
      });

      /***/
    }, /* 162 */
    /***/function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(4);
      var isArray = __webpack_require__(57);
      var SPECIES = __webpack_require__(5)('species');
      module.exports = function (original) {
        var C;
        if (isArray(original)) {
          C = original.constructor;
          // cross-realm fallback
          if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
          if (isObject(C)) {
            C = C[SPECIES];
            if (C === null) C = undefined;
          }
        }
        return C === undefined ? Array : C;
      };

      /***/
    }, /* 163 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
      var fails = __webpack_require__(2);
      var getTime = Date.prototype.getTime;
      var $toISOString = Date.prototype.toISOString;
      var lz = function lz(num) {
        return num > 9 ? num : '0' + num;
      };

      // PhantomJS / old WebKit has a broken implementations
      module.exports = fails(function () {
        return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
      }) || !fails(function () {
        $toISOString.call(new Date(NaN));
      }) ? function toISOString() {
        if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
        var d = this;
        var y = d.getUTCFullYear();
        var m = d.getUTCMilliseconds();
        var s = y < 0 ? '-' : y > 9999 ? '+' : '';
        return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) + 'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) + ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
      } : $toISOString;

      /***/
    }, /* 164 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var anObject = __webpack_require__(1);
      var toPrimitive = __webpack_require__(27);
      var NUMBER = 'number';
      module.exports = function (hint) {
        if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
        return toPrimitive(anObject(this), hint != NUMBER);
      };

      /***/
    }, /* 165 */
    /***/function (module, exports, __webpack_require__) {
      // all enumerable object keys, includes symbols
      var getKeys = __webpack_require__(33);
      var gOPS = __webpack_require__(59);
      var pIE = __webpack_require__(47);
      module.exports = function (it) {
        var result = getKeys(it);
        var getSymbols = gOPS.f;
        if (getSymbols) {
          var symbols = getSymbols(it);
          var isEnum = pIE.f;
          var i = 0;
          var key;
          while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
        }
        return result;
      };

      /***/
    }, /* 166 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
      var isArray = __webpack_require__(57);
      var isObject = __webpack_require__(4);
      var toLength = __webpack_require__(6);
      var ctx = __webpack_require__(19);
      var IS_CONCAT_SPREADABLE = __webpack_require__(5)('isConcatSpreadable');
      function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
        var targetIndex = start;
        var sourceIndex = 0;
        var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
        var element, spreadable;
        while (sourceIndex < sourceLen) {
          if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            spreadable = false;
            if (isObject(element)) {
              spreadable = element[IS_CONCAT_SPREADABLE];
              spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
            }
            if (spreadable && depth > 0) {
              targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
            } else {
              if (targetIndex >= 0x1fffffffffffff) throw TypeError();
              target[targetIndex] = element;
            }
            targetIndex++;
          }
          sourceIndex++;
        }
        return targetIndex;
      }
      module.exports = flattenIntoArray;

      /***/
    }, /* 167 */
    /***/function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(61)('native-function-to-string', Function.toString);

      /***/
    }, /* 168 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.16 Math.fround(x)
      var sign = __webpack_require__(79);
      var pow = Math.pow;
      var EPSILON = pow(2, -52);
      var EPSILON32 = pow(2, -23);
      var MAX32 = pow(2, 127) * (2 - EPSILON32);
      var MIN32 = pow(2, -126);
      var roundTiesToEven = function roundTiesToEven(n) {
        return n + 1 / EPSILON - 1 / EPSILON;
      };
      module.exports = Math.fround || function fround(x) {
        var $abs = Math.abs(x);
        var $sign = sign(x);
        var a, result;
        if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
        a = (1 + EPSILON32 / EPSILON) * $abs;
        result = a - (a - $abs);
        // eslint-disable-next-line no-self-compare
        if (result > MAX32 || result != result) return $sign * Infinity;
        return $sign * result;
      };

      /***/
    }, /* 169 */
    /***/function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var macrotask = __webpack_require__(87).set;
      var Observer = global.MutationObserver || global.WebKitMutationObserver;
      var process = global.process;
      var Promise = global.Promise;
      var isNode = __webpack_require__(23)(process) == 'process';
      module.exports = function () {
        var head, last, notify;
        var flush = function flush() {
          var parent, fn;
          if (isNode && (parent = process.domain)) parent.exit();
          while (head) {
            fn = head.fn;
            head = head.next;
            try {
              fn();
            } catch (e) {
              if (head) notify();else last = undefined;
              throw e;
            }
          }
          last = undefined;
          if (parent) parent.enter();
        };

        // Node.js
        if (isNode) {
          notify = function notify() {
            process.nextTick(flush);
          };
          // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
        } else if (Observer && !(global.navigator && global.navigator.standalone)) {
          var toggle = true;
          var node = document.createTextNode('');
          new Observer(flush).observe(node, {
            characterData: true
          }); // eslint-disable-line no-new
          notify = function notify() {
            node.data = toggle = !toggle;
          };
          // environments with maybe non-completely correct, but existent Promise
        } else if (Promise && Promise.resolve) {
          // Promise.resolve without an argument throws an error in LG WebOS 2
          var promise = Promise.resolve(undefined);
          notify = function notify() {
            promise.then(flush);
          };
          // for other environments - macrotask based on:
          // - setImmediate
          // - MessageChannel
          // - window.postMessag
          // - onreadystatechange
          // - setTimeout
        } else {
          notify = function notify() {
            // strange IE + webpack dev server bug - use .call(global)
            macrotask.call(global, flush);
          };
        }
        return function (fn) {
          var task = {
            fn: fn,
            next: undefined
          };
          if (last) last.next = task;
          if (!head) {
            head = task;
            notify();
          }
          last = task;
        };
      };

      /***/
    }, /* 170 */
    /***/function (module, exports) {
      module.exports = function (exec) {
        try {
          return {
            e: false,
            v: exec()
          };
        } catch (e) {
          return {
            e: true,
            v: e
          };
        }
      };

      /***/
    }, /* 171 */
    /***/function (module, exports, __webpack_require__) {
      // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
      var $export = __webpack_require__(0);
      $export($export.P, 'Array', {
        copyWithin: __webpack_require__(96)
      });
      __webpack_require__(28)('copyWithin');

      /***/
    }, /* 172 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var $every = __webpack_require__(18)(4);
      $export($export.P + $export.F * !__webpack_require__(16)([].every, true), 'Array', {
        // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
        every: function every(callbackfn /* , thisArg */) {
          return $every(this, callbackfn, arguments[1]);
        }
      });

      /***/
    }, /* 173 */
    /***/function (module, exports, __webpack_require__) {
      // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
      var $export = __webpack_require__(0);
      $export($export.P, 'Array', {
        fill: __webpack_require__(68)
      });
      __webpack_require__(28)('fill');

      /***/
    }, /* 174 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var $filter = __webpack_require__(18)(2);
      $export($export.P + $export.F * !__webpack_require__(16)([].filter, true), 'Array', {
        // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
        filter: function filter(callbackfn /* , thisArg */) {
          return $filter(this, callbackfn, arguments[1]);
        }
      });

      /***/
    }, /* 175 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
      var $export = __webpack_require__(0);
      var $find = __webpack_require__(18)(6);
      var KEY = 'findIndex';
      var forced = true;
      // Shouldn't skip holes
      if (KEY in []) Array(1)[KEY](function () {
        forced = false;
      });
      $export($export.P + $export.F * forced, 'Array', {
        findIndex: function findIndex(callbackfn /* , that = undefined */) {
          return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
      });
      __webpack_require__(28)(KEY);

      /***/
    }, /* 176 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
      var $export = __webpack_require__(0);
      var $find = __webpack_require__(18)(5);
      var KEY = 'find';
      var forced = true;
      // Shouldn't skip holes
      if (KEY in []) Array(1)[KEY](function () {
        forced = false;
      });
      $export($export.P + $export.F * forced, 'Array', {
        find: function find(callbackfn /* , that = undefined */) {
          return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
      });
      __webpack_require__(28)(KEY);

      /***/
    }, /* 177 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var $forEach = __webpack_require__(18)(0);
      var STRICT = __webpack_require__(16)([].forEach, true);
      $export($export.P + $export.F * !STRICT, 'Array', {
        // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
        forEach: function forEach(callbackfn /* , thisArg */) {
          return $forEach(this, callbackfn, arguments[1]);
        }
      });

      /***/
    }, /* 178 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var ctx = __webpack_require__(19);
      var $export = __webpack_require__(0);
      var toObject = __webpack_require__(10);
      var call = __webpack_require__(105);
      var isArrayIter = __webpack_require__(75);
      var toLength = __webpack_require__(6);
      var createProperty = __webpack_require__(69);
      var getIterFn = __webpack_require__(90);
      $export($export.S + $export.F * !__webpack_require__(58)(function (iter) {
        Array.from(iter);
      }), 'Array', {
        // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
        from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
          var O = toObject(arrayLike);
          var C = typeof this == 'function' ? this : Array;
          var aLen = arguments.length;
          var mapfn = aLen > 1 ? arguments[1] : undefined;
          var mapping = mapfn !== undefined;
          var index = 0;
          var iterFn = getIterFn(O);
          var length, result, step, iterator;
          if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
          // if object isn't iterable or it's array with default iterator - use simple case
          if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
            for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
              createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
            }
          } else {
            length = toLength(O.length);
            for (result = new C(length); length > index; index++) {
              createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
            }
          }
          result.length = index;
          return result;
        }
      });

      /***/
    }, /* 179 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var $indexOf = __webpack_require__(52)(false);
      var $native = [].indexOf;
      var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
      $export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(16)($native)), 'Array', {
        // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
        indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
          return NEGATIVE_ZERO
          // convert -0 to +0
          ? $native.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments[1]);
        }
      });

      /***/
    }, /* 180 */
    /***/function (module, exports, __webpack_require__) {
      // 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
      var $export = __webpack_require__(0);
      $export($export.S, 'Array', {
        isArray: __webpack_require__(57)
      });

      /***/
    }, /* 181 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 22.1.3.13 Array.prototype.join(separator)
      var $export = __webpack_require__(0);
      var toIObject = __webpack_require__(15);
      var arrayJoin = [].join;

      // fallback for not array-like strings
      $export($export.P + $export.F * (__webpack_require__(46) != Object || !__webpack_require__(16)(arrayJoin)), 'Array', {
        join: function join(separator) {
          return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
        }
      });

      /***/
    }, /* 182 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var toIObject = __webpack_require__(15);
      var toInteger = __webpack_require__(22);
      var toLength = __webpack_require__(6);
      var $native = [].lastIndexOf;
      var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
      $export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(16)($native)), 'Array', {
        // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
        lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
          // convert -0 to +0
          if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
          var O = toIObject(this);
          var length = toLength(O.length);
          var index = length - 1;
          if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
          if (index < 0) index = length + index;
          for (; index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
          return -1;
        }
      });

      /***/
    }, /* 183 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var $map = __webpack_require__(18)(1);
      $export($export.P + $export.F * !__webpack_require__(16)([].map, true), 'Array', {
        // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
        map: function map(callbackfn /* , thisArg */) {
          return $map(this, callbackfn, arguments[1]);
        }
      });

      /***/
    }, /* 184 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var createProperty = __webpack_require__(69);

      // WebKit Array.of isn't generic
      $export($export.S + $export.F * __webpack_require__(2)(function () {
        function F() {/* empty */}
        return !(Array.of.call(F) instanceof F);
      }), 'Array', {
        // 22.1.2.3 Array.of( ...items)
        of: function of( /* ...args */
        ) {
          var index = 0;
          var aLen = arguments.length;
          var result = new (typeof this == 'function' ? this : Array)(aLen);
          while (aLen > index) createProperty(result, index, arguments[index++]);
          result.length = aLen;
          return result;
        }
      });

      /***/
    }, /* 185 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var $reduce = __webpack_require__(97);
      $export($export.P + $export.F * !__webpack_require__(16)([].reduceRight, true), 'Array', {
        // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
        reduceRight: function reduceRight(callbackfn /* , initialValue */) {
          return $reduce(this, callbackfn, arguments.length, arguments[1], true);
        }
      });

      /***/
    }, /* 186 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var $reduce = __webpack_require__(97);
      $export($export.P + $export.F * !__webpack_require__(16)([].reduce, true), 'Array', {
        // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
        reduce: function reduce(callbackfn /* , initialValue */) {
          return $reduce(this, callbackfn, arguments.length, arguments[1], false);
        }
      });

      /***/
    }, /* 187 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var html = __webpack_require__(73);
      var cof = __webpack_require__(23);
      var toAbsoluteIndex = __webpack_require__(35);
      var toLength = __webpack_require__(6);
      var arraySlice = [].slice;

      // fallback for not array-like ES3 strings and DOM objects
      $export($export.P + $export.F * __webpack_require__(2)(function () {
        if (html) arraySlice.call(html);
      }), 'Array', {
        slice: function slice(begin, end) {
          var len = toLength(this.length);
          var klass = cof(this);
          end = end === undefined ? len : end;
          if (klass == 'Array') return arraySlice.call(this, begin, end);
          var start = toAbsoluteIndex(begin, len);
          var upTo = toAbsoluteIndex(end, len);
          var size = toLength(upTo - start);
          var cloned = new Array(size);
          var i = 0;
          for (; i < size; i++) cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
          return cloned;
        }
      });

      /***/
    }, /* 188 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var $some = __webpack_require__(18)(3);
      $export($export.P + $export.F * !__webpack_require__(16)([].some, true), 'Array', {
        // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
        some: function some(callbackfn /* , thisArg */) {
          return $some(this, callbackfn, arguments[1]);
        }
      });

      /***/
    }, /* 189 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var aFunction = __webpack_require__(17);
      var toObject = __webpack_require__(10);
      var fails = __webpack_require__(2);
      var $sort = [].sort;
      var test = [1, 2, 3];
      $export($export.P + $export.F * (fails(function () {
        // IE8-
        test.sort(undefined);
      }) || !fails(function () {
        // V8 bug
        test.sort(null);
        // Old WebKit
      }) || !__webpack_require__(16)($sort)), 'Array', {
        // 22.1.3.25 Array.prototype.sort(comparefn)
        sort: function sort(comparefn) {
          return comparefn === undefined ? $sort.call(toObject(this)) : $sort.call(toObject(this), aFunction(comparefn));
        }
      });

      /***/
    }, /* 190 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(41)('Array');

      /***/
    }, /* 191 */
    /***/function (module, exports, __webpack_require__) {
      // 20.3.3.1 / 15.9.4.4 Date.now()
      var $export = __webpack_require__(0);
      $export($export.S, 'Date', {
        now: function now() {
          return new Date().getTime();
        }
      });

      /***/
    }, /* 192 */
    /***/function (module, exports, __webpack_require__) {
      // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
      var $export = __webpack_require__(0);
      var toISOString = __webpack_require__(163);

      // PhantomJS / old WebKit has a broken implementations
      $export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
        toISOString: toISOString
      });

      /***/
    }, /* 193 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var toObject = __webpack_require__(10);
      var toPrimitive = __webpack_require__(27);
      $export($export.P + $export.F * __webpack_require__(2)(function () {
        return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
          toISOString: function toISOString() {
            return 1;
          }
        }) !== 1;
      }), 'Date', {
        // eslint-disable-next-line no-unused-vars
        toJSON: function toJSON(key) {
          var O = toObject(this);
          var pv = toPrimitive(O);
          return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
        }
      });

      /***/
    }, /* 194 */
    /***/function (module, exports, __webpack_require__) {
      var TO_PRIMITIVE = __webpack_require__(5)('toPrimitive');
      var proto = Date.prototype;
      if (!(TO_PRIMITIVE in proto)) __webpack_require__(14)(proto, TO_PRIMITIVE, __webpack_require__(164));

      /***/
    }, /* 195 */
    /***/function (module, exports, __webpack_require__) {
      var DateProto = Date.prototype;
      var INVALID_DATE = 'Invalid Date';
      var TO_STRING = 'toString';
      var $toString = DateProto[TO_STRING];
      var getTime = DateProto.getTime;
      if (new Date(NaN) + '' != INVALID_DATE) {
        __webpack_require__(11)(DateProto, TO_STRING, function toString() {
          var value = getTime.call(this);
          // eslint-disable-next-line no-self-compare
          return value === value ? $toString.call(this) : INVALID_DATE;
        });
      }

      /***/
    }, /* 196 */
    /***/function (module, exports, __webpack_require__) {
      // 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
      var $export = __webpack_require__(0);
      $export($export.P, 'Function', {
        bind: __webpack_require__(99)
      });

      /***/
    }, /* 197 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var isObject = __webpack_require__(4);
      var getPrototypeOf = __webpack_require__(32);
      var HAS_INSTANCE = __webpack_require__(5)('hasInstance');
      var FunctionProto = Function.prototype;
      // 19.2.3.6 Function.prototype[@@hasInstance](V)
      if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(9).f(FunctionProto, HAS_INSTANCE, {
        value: function value(O) {
          if (typeof this != 'function' || !isObject(O)) return false;
          if (!isObject(this.prototype)) return O instanceof this;
          // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
          while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
          return false;
        }
      });

      /***/
    }, /* 198 */
    /***/function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(9).f;
      var FProto = Function.prototype;
      var nameRE = /^\s*function ([^ (]*)/;
      var NAME = 'name';

      // 19.2.4.2 name
      NAME in FProto || __webpack_require__(8) && dP(FProto, NAME, {
        configurable: true,
        get: function get() {
          try {
            return ('' + this).match(nameRE)[1];
          } catch (e) {
            return '';
          }
        }
      });

      /***/
    }, /* 199 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var strong = __webpack_require__(100);
      var validate = __webpack_require__(37);
      var MAP = 'Map';

      // 23.1 Map Objects
      module.exports = __webpack_require__(53)(MAP, function (get) {
        return function Map() {
          return get(this, arguments.length > 0 ? arguments[0] : undefined);
        };
      }, {
        // 23.1.3.6 Map.prototype.get(key)
        get: function get(key) {
          var entry = strong.getEntry(validate(this, MAP), key);
          return entry && entry.v;
        },
        // 23.1.3.9 Map.prototype.set(key, value)
        set: function set(key, value) {
          return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
        }
      }, strong, true);

      /***/
    }, /* 200 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.3 Math.acosh(x)
      var $export = __webpack_require__(0);
      var log1p = __webpack_require__(108);
      var sqrt = Math.sqrt;
      var $acosh = Math.acosh;
      $export($export.S + $export.F * !($acosh
      // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
      && Math.floor($acosh(Number.MAX_VALUE)) == 710
      // Tor Browser bug: Math.acosh(Infinity) -> NaN
      && $acosh(Infinity) == Infinity), 'Math', {
        acosh: function acosh(x) {
          return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
        }
      });

      /***/
    }, /* 201 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.5 Math.asinh(x)
      var $export = __webpack_require__(0);
      var $asinh = Math.asinh;
      function asinh(x) {
        return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
      }

      // Tor Browser bug: Math.asinh(0) -> -0
      $export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {
        asinh: asinh
      });

      /***/
    }, /* 202 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.7 Math.atanh(x)
      var $export = __webpack_require__(0);
      var $atanh = Math.atanh;

      // Tor Browser bug: Math.atanh(-0) -> 0
      $export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
        atanh: function atanh(x) {
          return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
        }
      });

      /***/
    }, /* 203 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.9 Math.cbrt(x)
      var $export = __webpack_require__(0);
      var sign = __webpack_require__(79);
      $export($export.S, 'Math', {
        cbrt: function cbrt(x) {
          return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
        }
      });

      /***/
    }, /* 204 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.11 Math.clz32(x)
      var $export = __webpack_require__(0);
      $export($export.S, 'Math', {
        clz32: function clz32(x) {
          return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
        }
      });

      /***/
    }, /* 205 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.12 Math.cosh(x)
      var $export = __webpack_require__(0);
      var exp = Math.exp;
      $export($export.S, 'Math', {
        cosh: function cosh(x) {
          return (exp(x = +x) + exp(-x)) / 2;
        }
      });

      /***/
    }, /* 206 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.14 Math.expm1(x)
      var $export = __webpack_require__(0);
      var $expm1 = __webpack_require__(78);
      $export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {
        expm1: $expm1
      });

      /***/
    }, /* 207 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.16 Math.fround(x)
      var $export = __webpack_require__(0);
      $export($export.S, 'Math', {
        fround: __webpack_require__(168)
      });

      /***/
    }, /* 208 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
      var $export = __webpack_require__(0);
      var abs = Math.abs;
      $export($export.S, 'Math', {
        hypot: function hypot(value1, value2) {
          // eslint-disable-line no-unused-vars
          var sum = 0;
          var i = 0;
          var aLen = arguments.length;
          var larg = 0;
          var arg, div;
          while (i < aLen) {
            arg = abs(arguments[i++]);
            if (larg < arg) {
              div = larg / arg;
              sum = sum * div * div + 1;
              larg = arg;
            } else if (arg > 0) {
              div = arg / larg;
              sum += div * div;
            } else sum += arg;
          }
          return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
        }
      });

      /***/
    }, /* 209 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.18 Math.imul(x, y)
      var $export = __webpack_require__(0);
      var $imul = Math.imul;

      // some WebKit versions fails with big numbers, some has wrong arity
      $export($export.S + $export.F * __webpack_require__(2)(function () {
        return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
      }), 'Math', {
        imul: function imul(x, y) {
          var UINT16 = 0xffff;
          var xn = +x;
          var yn = +y;
          var xl = UINT16 & xn;
          var yl = UINT16 & yn;
          return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
        }
      });

      /***/
    }, /* 210 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.21 Math.log10(x)
      var $export = __webpack_require__(0);
      $export($export.S, 'Math', {
        log10: function log10(x) {
          return Math.log(x) * Math.LOG10E;
        }
      });

      /***/
    }, /* 211 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.20 Math.log1p(x)
      var $export = __webpack_require__(0);
      $export($export.S, 'Math', {
        log1p: __webpack_require__(108)
      });

      /***/
    }, /* 212 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.22 Math.log2(x)
      var $export = __webpack_require__(0);
      $export($export.S, 'Math', {
        log2: function log2(x) {
          return Math.log(x) / Math.LN2;
        }
      });

      /***/
    }, /* 213 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.28 Math.sign(x)
      var $export = __webpack_require__(0);
      $export($export.S, 'Math', {
        sign: __webpack_require__(79)
      });

      /***/
    }, /* 214 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.30 Math.sinh(x)
      var $export = __webpack_require__(0);
      var expm1 = __webpack_require__(78);
      var exp = Math.exp;

      // V8 near Chromium 38 has a problem with very small numbers
      $export($export.S + $export.F * __webpack_require__(2)(function () {
        return !Math.sinh(-2e-17) != -2e-17;
      }), 'Math', {
        sinh: function sinh(x) {
          return Math.abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
        }
      });

      /***/
    }, /* 215 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.33 Math.tanh(x)
      var $export = __webpack_require__(0);
      var expm1 = __webpack_require__(78);
      var exp = Math.exp;
      $export($export.S, 'Math', {
        tanh: function tanh(x) {
          var a = expm1(x = +x);
          var b = expm1(-x);
          return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
        }
      });

      /***/
    }, /* 216 */
    /***/function (module, exports, __webpack_require__) {
      // 20.2.2.34 Math.trunc(x)
      var $export = __webpack_require__(0);
      $export($export.S, 'Math', {
        trunc: function trunc(it) {
          return (it > 0 ? Math.floor : Math.ceil)(it);
        }
      });

      /***/
    }, /* 217 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var global = __webpack_require__(3);
      var has = __webpack_require__(13);
      var cof = __webpack_require__(23);
      var inheritIfRequired = __webpack_require__(74);
      var toPrimitive = __webpack_require__(27);
      var fails = __webpack_require__(2);
      var gOPN = __webpack_require__(31).f;
      var gOPD = __webpack_require__(20).f;
      var dP = __webpack_require__(9).f;
      var $trim = __webpack_require__(43).trim;
      var NUMBER = 'Number';
      var $Number = global[NUMBER];
      var Base = $Number;
      var proto = $Number.prototype;
      // Opera ~12 has broken Object#toString
      var BROKEN_COF = cof(__webpack_require__(30)(proto)) == NUMBER;
      var TRIM = ('trim' in String.prototype);

      // 7.1.3 ToNumber(argument)
      var toNumber = function toNumber(argument) {
        var it = toPrimitive(argument, false);
        if (typeof it == 'string' && it.length > 2) {
          it = TRIM ? it.trim() : $trim(it, 3);
          var first = it.charCodeAt(0);
          var third, radix, maxCode;
          if (first === 43 || first === 45) {
            third = it.charCodeAt(2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
          } else if (first === 48) {
            switch (it.charCodeAt(1)) {
              case 66:
              case 98:
                radix = 2;
                maxCode = 49;
                break;
              // fast equal /^0b[01]+$/i
              case 79:
              case 111:
                radix = 8;
                maxCode = 55;
                break;
              // fast equal /^0o[0-7]+$/i
              default:
                return +it;
            }
            for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
              code = digits.charCodeAt(i);
              // parseInt parses a string to a first unavailable symbol
              // but ToNumber should return NaN if a string contains unavailable symbols
              if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
          }
        }
        return +it;
      };
      if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
        $Number = function Number(value) {
          var it = arguments.length < 1 ? 0 : value;
          var that = this;
          return that instanceof $Number
          // check on 1..constructor(foo) case
          && (BROKEN_COF ? fails(function () {
            proto.valueOf.call(that);
          }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
        };
        for (var keys = __webpack_require__(8) ? gOPN(Base) : (
          // ES3:
          'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
          // ES6 (in case, if modules with ES6 Number statics required before):
          'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
          if (has(Base, key = keys[j]) && !has($Number, key)) {
            dP($Number, key, gOPD(Base, key));
          }
        }
        $Number.prototype = proto;
        proto.constructor = $Number;
        __webpack_require__(11)(global, NUMBER, $Number);
      }

      /***/
    }, /* 218 */
    /***/function (module, exports, __webpack_require__) {
      // 20.1.2.1 Number.EPSILON
      var $export = __webpack_require__(0);
      $export($export.S, 'Number', {
        EPSILON: Math.pow(2, -52)
      });

      /***/
    }, /* 219 */
    /***/function (module, exports, __webpack_require__) {
      // 20.1.2.2 Number.isFinite(number)
      var $export = __webpack_require__(0);
      var _isFinite = __webpack_require__(3).isFinite;
      $export($export.S, 'Number', {
        isFinite: function isFinite(it) {
          return typeof it == 'number' && _isFinite(it);
        }
      });

      /***/
    }, /* 220 */
    /***/function (module, exports, __webpack_require__) {
      // 20.1.2.3 Number.isInteger(number)
      var $export = __webpack_require__(0);
      $export($export.S, 'Number', {
        isInteger: __webpack_require__(104)
      });

      /***/
    }, /* 221 */
    /***/function (module, exports, __webpack_require__) {
      // 20.1.2.4 Number.isNaN(number)
      var $export = __webpack_require__(0);
      $export($export.S, 'Number', {
        isNaN: function isNaN(number) {
          // eslint-disable-next-line no-self-compare
          return number != number;
        }
      });

      /***/
    }, /* 222 */
    /***/function (module, exports, __webpack_require__) {
      // 20.1.2.5 Number.isSafeInteger(number)
      var $export = __webpack_require__(0);
      var isInteger = __webpack_require__(104);
      var abs = Math.abs;
      $export($export.S, 'Number', {
        isSafeInteger: function isSafeInteger(number) {
          return isInteger(number) && abs(number) <= 0x1fffffffffffff;
        }
      });

      /***/
    }, /* 223 */
    /***/function (module, exports, __webpack_require__) {
      // 20.1.2.6 Number.MAX_SAFE_INTEGER
      var $export = __webpack_require__(0);
      $export($export.S, 'Number', {
        MAX_SAFE_INTEGER: 0x1fffffffffffff
      });

      /***/
    }, /* 224 */
    /***/function (module, exports, __webpack_require__) {
      // 20.1.2.10 Number.MIN_SAFE_INTEGER
      var $export = __webpack_require__(0);
      $export($export.S, 'Number', {
        MIN_SAFE_INTEGER: -0x1fffffffffffff
      });

      /***/
    }, /* 225 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var $parseFloat = __webpack_require__(116);
      // 20.1.2.12 Number.parseFloat(string)
      $export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {
        parseFloat: $parseFloat
      });

      /***/
    }, /* 226 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var $parseInt = __webpack_require__(117);
      // 20.1.2.13 Number.parseInt(string, radix)
      $export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {
        parseInt: $parseInt
      });

      /***/
    }, /* 227 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var toInteger = __webpack_require__(22);
      var aNumberValue = __webpack_require__(95);
      var repeat = __webpack_require__(85);
      var $toFixed = 1.0.toFixed;
      var floor = Math.floor;
      var data = [0, 0, 0, 0, 0, 0];
      var ERROR = 'Number.toFixed: incorrect invocation!';
      var ZERO = '0';
      var multiply = function multiply(n, c) {
        var i = -1;
        var c2 = c;
        while (++i < 6) {
          c2 += n * data[i];
          data[i] = c2 % 1e7;
          c2 = floor(c2 / 1e7);
        }
      };
      var divide = function divide(n) {
        var i = 6;
        var c = 0;
        while (--i >= 0) {
          c += data[i];
          data[i] = floor(c / n);
          c = c % n * 1e7;
        }
      };
      var numToString = function numToString() {
        var i = 6;
        var s = '';
        while (--i >= 0) {
          if (s !== '' || i === 0 || data[i] !== 0) {
            var t = String(data[i]);
            s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
          }
        }
        return s;
      };
      var pow = function pow(x, n, acc) {
        return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
      };
      var log = function log(x) {
        var n = 0;
        var x2 = x;
        while (x2 >= 4096) {
          n += 12;
          x2 /= 4096;
        }
        while (x2 >= 2) {
          n += 1;
          x2 /= 2;
        }
        return n;
      };
      $export($export.P + $export.F * (!!$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !__webpack_require__(2)(function () {
        // V8 ~ Android 4.3-
        $toFixed.call({});
      })), 'Number', {
        toFixed: function toFixed(fractionDigits) {
          var x = aNumberValue(this, ERROR);
          var f = toInteger(fractionDigits);
          var s = '';
          var m = ZERO;
          var e, z, j, k;
          if (f < 0 || f > 20) throw RangeError(ERROR);
          // eslint-disable-next-line no-self-compare
          if (x != x) return 'NaN';
          if (x <= -1e21 || x >= 1e21) return String(x);
          if (x < 0) {
            s = '-';
            x = -x;
          }
          if (x > 1e-21) {
            e = log(x * pow(2, 69, 1)) - 69;
            z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
              multiply(0, z);
              j = f;
              while (j >= 7) {
                multiply(1e7, 0);
                j -= 7;
              }
              multiply(pow(10, j, 1), 0);
              j = e - 1;
              while (j >= 23) {
                divide(1 << 23);
                j -= 23;
              }
              divide(1 << j);
              multiply(1, 1);
              divide(2);
              m = numToString();
            } else {
              multiply(0, z);
              multiply(1 << -e, 0);
              m = numToString() + repeat.call(ZERO, f);
            }
          }
          if (f > 0) {
            k = m.length;
            m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
          } else {
            m = s + m;
          }
          return m;
        }
      });

      /***/
    }, /* 228 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var $fails = __webpack_require__(2);
      var aNumberValue = __webpack_require__(95);
      var $toPrecision = 1.0.toPrecision;
      $export($export.P + $export.F * ($fails(function () {
        // IE7-
        return $toPrecision.call(1, undefined) !== '1';
      }) || !$fails(function () {
        // V8 ~ Android 4.3-
        $toPrecision.call({});
      })), 'Number', {
        toPrecision: function toPrecision(precision) {
          var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
          return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
        }
      });

      /***/
    }, /* 229 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.3.1 Object.assign(target, source)
      var $export = __webpack_require__(0);
      $export($export.S + $export.F, 'Object', {
        assign: __webpack_require__(110)
      });

      /***/
    }, /* 230 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
      $export($export.S, 'Object', {
        create: __webpack_require__(30)
      });

      /***/
    }, /* 231 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
      $export($export.S + $export.F * !__webpack_require__(8), 'Object', {
        defineProperties: __webpack_require__(111)
      });

      /***/
    }, /* 232 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
      $export($export.S + $export.F * !__webpack_require__(8), 'Object', {
        defineProperty: __webpack_require__(9).f
      });

      /***/
    }, /* 233 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.5 Object.freeze(O)
      var isObject = __webpack_require__(4);
      var meta = __webpack_require__(26).onFreeze;
      __webpack_require__(21)('freeze', function ($freeze) {
        return function freeze(it) {
          return $freeze && isObject(it) ? $freeze(meta(it)) : it;
        };
      });

      /***/
    }, /* 234 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
      var toIObject = __webpack_require__(15);
      var $getOwnPropertyDescriptor = __webpack_require__(20).f;
      __webpack_require__(21)('getOwnPropertyDescriptor', function () {
        return function getOwnPropertyDescriptor(it, key) {
          return $getOwnPropertyDescriptor(toIObject(it), key);
        };
      });

      /***/
    }, /* 235 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.7 Object.getOwnPropertyNames(O)
      __webpack_require__(21)('getOwnPropertyNames', function () {
        return __webpack_require__(112).f;
      });

      /***/
    }, /* 236 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.9 Object.getPrototypeOf(O)
      var toObject = __webpack_require__(10);
      var $getPrototypeOf = __webpack_require__(32);
      __webpack_require__(21)('getPrototypeOf', function () {
        return function getPrototypeOf(it) {
          return $getPrototypeOf(toObject(it));
        };
      });

      /***/
    }, /* 237 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.11 Object.isExtensible(O)
      var isObject = __webpack_require__(4);
      __webpack_require__(21)('isExtensible', function ($isExtensible) {
        return function isExtensible(it) {
          return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
        };
      });

      /***/
    }, /* 238 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.12 Object.isFrozen(O)
      var isObject = __webpack_require__(4);
      __webpack_require__(21)('isFrozen', function ($isFrozen) {
        return function isFrozen(it) {
          return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
        };
      });

      /***/
    }, /* 239 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.13 Object.isSealed(O)
      var isObject = __webpack_require__(4);
      __webpack_require__(21)('isSealed', function ($isSealed) {
        return function isSealed(it) {
          return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
        };
      });

      /***/
    }, /* 240 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.3.10 Object.is(value1, value2)
      var $export = __webpack_require__(0);
      $export($export.S, 'Object', {
        is: __webpack_require__(119)
      });

      /***/
    }, /* 241 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.14 Object.keys(O)
      var toObject = __webpack_require__(10);
      var $keys = __webpack_require__(33);
      __webpack_require__(21)('keys', function () {
        return function keys(it) {
          return $keys(toObject(it));
        };
      });

      /***/
    }, /* 242 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.15 Object.preventExtensions(O)
      var isObject = __webpack_require__(4);
      var meta = __webpack_require__(26).onFreeze;
      __webpack_require__(21)('preventExtensions', function ($preventExtensions) {
        return function preventExtensions(it) {
          return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
        };
      });

      /***/
    }, /* 243 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.2.17 Object.seal(O)
      var isObject = __webpack_require__(4);
      var meta = __webpack_require__(26).onFreeze;
      __webpack_require__(21)('seal', function ($seal) {
        return function seal(it) {
          return $seal && isObject(it) ? $seal(meta(it)) : it;
        };
      });

      /***/
    }, /* 244 */
    /***/function (module, exports, __webpack_require__) {
      // 19.1.3.19 Object.setPrototypeOf(O, proto)
      var $export = __webpack_require__(0);
      $export($export.S, 'Object', {
        setPrototypeOf: __webpack_require__(81).set
      });

      /***/
    }, /* 245 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 19.1.3.6 Object.prototype.toString()
      var classof = __webpack_require__(45);
      var test = {};
      test[__webpack_require__(5)('toStringTag')] = 'z';
      if (test + '' != '[object z]') {
        __webpack_require__(11)(Object.prototype, 'toString', function toString() {
          return '[object ' + classof(this) + ']';
        }, true);
      }

      /***/
    }, /* 246 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var $parseFloat = __webpack_require__(116);
      // 18.2.4 parseFloat(string)
      $export($export.G + $export.F * (parseFloat != $parseFloat), {
        parseFloat: $parseFloat
      });

      /***/
    }, /* 247 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var $parseInt = __webpack_require__(117);
      // 18.2.5 parseInt(string, radix)
      $export($export.G + $export.F * (parseInt != $parseInt), {
        parseInt: $parseInt
      });

      /***/
    }, /* 248 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
      var $export = __webpack_require__(0);
      var aFunction = __webpack_require__(17);
      var anObject = __webpack_require__(1);
      var rApply = (__webpack_require__(3).Reflect || {}).apply;
      var fApply = Function.apply;
      // MS Edge argumentsList argument is optional
      $export($export.S + $export.F * !__webpack_require__(2)(function () {
        rApply(function () {/* empty */});
      }), 'Reflect', {
        apply: function apply(target, thisArgument, argumentsList) {
          var T = aFunction(target);
          var L = anObject(argumentsList);
          return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
        }
      });

      /***/
    }, /* 249 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
      var $export = __webpack_require__(0);
      var create = __webpack_require__(30);
      var aFunction = __webpack_require__(17);
      var anObject = __webpack_require__(1);
      var isObject = __webpack_require__(4);
      var fails = __webpack_require__(2);
      var bind = __webpack_require__(99);
      var rConstruct = (__webpack_require__(3).Reflect || {}).construct;

      // MS Edge supports only 2 arguments and argumentsList argument is optional
      // FF Nightly sets third argument as `new.target`, but does not create `this` from it
      var NEW_TARGET_BUG = fails(function () {
        function F() {/* empty */}
        return !(rConstruct(function () {/* empty */}, [], F) instanceof F);
      });
      var ARGS_BUG = !fails(function () {
        rConstruct(function () {/* empty */});
      });
      $export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
        construct: function construct(Target, args /* , newTarget */) {
          aFunction(Target);
          anObject(args);
          var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
          if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
          if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch (args.length) {
              case 0:
                return new Target();
              case 1:
                return new Target(args[0]);
              case 2:
                return new Target(args[0], args[1]);
              case 3:
                return new Target(args[0], args[1], args[2]);
              case 4:
                return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [null];
            $args.push.apply($args, args);
            return new (bind.apply(Target, $args))();
          }
          // with altered newTarget, not support built-in constructors
          var proto = newTarget.prototype;
          var instance = create(isObject(proto) ? proto : Object.prototype);
          var result = Function.apply.call(Target, instance, args);
          return isObject(result) ? result : instance;
        }
      });

      /***/
    }, /* 250 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
      var dP = __webpack_require__(9);
      var $export = __webpack_require__(0);
      var anObject = __webpack_require__(1);
      var toPrimitive = __webpack_require__(27);

      // MS Edge has broken Reflect.defineProperty - throwing instead of returning false
      $export($export.S + $export.F * __webpack_require__(2)(function () {
        // eslint-disable-next-line no-undef
        Reflect.defineProperty(dP.f({}, 1, {
          value: 1
        }), 1, {
          value: 2
        });
      }), 'Reflect', {
        defineProperty: function defineProperty(target, propertyKey, attributes) {
          anObject(target);
          propertyKey = toPrimitive(propertyKey, true);
          anObject(attributes);
          try {
            dP.f(target, propertyKey, attributes);
            return true;
          } catch (e) {
            return false;
          }
        }
      });

      /***/
    }, /* 251 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.4 Reflect.deleteProperty(target, propertyKey)
      var $export = __webpack_require__(0);
      var gOPD = __webpack_require__(20).f;
      var anObject = __webpack_require__(1);
      $export($export.S, 'Reflect', {
        deleteProperty: function deleteProperty(target, propertyKey) {
          var desc = gOPD(anObject(target), propertyKey);
          return desc && !desc.configurable ? false : delete target[propertyKey];
        }
      });

      /***/
    }, /* 252 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 26.1.5 Reflect.enumerate(target)
      var $export = __webpack_require__(0);
      var anObject = __webpack_require__(1);
      var Enumerate = function Enumerate(iterated) {
        this._t = anObject(iterated); // target
        this._i = 0; // next index
        var keys = this._k = []; // keys
        var key;
        for (key in iterated) keys.push(key);
      };
      __webpack_require__(106)(Enumerate, 'Object', function () {
        var that = this;
        var keys = that._k;
        var key;
        do {
          if (that._i >= keys.length) return {
            value: undefined,
            done: true
          };
        } while (!((key = keys[that._i++]) in that._t));
        return {
          value: key,
          done: false
        };
      });
      $export($export.S, 'Reflect', {
        enumerate: function enumerate(target) {
          return new Enumerate(target);
        }
      });

      /***/
    }, /* 253 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
      var gOPD = __webpack_require__(20);
      var $export = __webpack_require__(0);
      var anObject = __webpack_require__(1);
      $export($export.S, 'Reflect', {
        getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
          return gOPD.f(anObject(target), propertyKey);
        }
      });

      /***/
    }, /* 254 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.8 Reflect.getPrototypeOf(target)
      var $export = __webpack_require__(0);
      var getProto = __webpack_require__(32);
      var anObject = __webpack_require__(1);
      $export($export.S, 'Reflect', {
        getPrototypeOf: function getPrototypeOf(target) {
          return getProto(anObject(target));
        }
      });

      /***/
    }, /* 255 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.6 Reflect.get(target, propertyKey [, receiver])
      var gOPD = __webpack_require__(20);
      var getPrototypeOf = __webpack_require__(32);
      var has = __webpack_require__(13);
      var $export = __webpack_require__(0);
      var isObject = __webpack_require__(4);
      var anObject = __webpack_require__(1);
      function get(target, propertyKey /* , receiver */) {
        var receiver = arguments.length < 3 ? target : arguments[2];
        var desc, proto;
        if (anObject(target) === receiver) return target[propertyKey];
        if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
        if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
      }
      $export($export.S, 'Reflect', {
        get: get
      });

      /***/
    }, /* 256 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.9 Reflect.has(target, propertyKey)
      var $export = __webpack_require__(0);
      $export($export.S, 'Reflect', {
        has: function has(target, propertyKey) {
          return propertyKey in target;
        }
      });

      /***/
    }, /* 257 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.10 Reflect.isExtensible(target)
      var $export = __webpack_require__(0);
      var anObject = __webpack_require__(1);
      var $isExtensible = Object.isExtensible;
      $export($export.S, 'Reflect', {
        isExtensible: function isExtensible(target) {
          anObject(target);
          return $isExtensible ? $isExtensible(target) : true;
        }
      });

      /***/
    }, /* 258 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.11 Reflect.ownKeys(target)
      var $export = __webpack_require__(0);
      $export($export.S, 'Reflect', {
        ownKeys: __webpack_require__(115)
      });

      /***/
    }, /* 259 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.12 Reflect.preventExtensions(target)
      var $export = __webpack_require__(0);
      var anObject = __webpack_require__(1);
      var $preventExtensions = Object.preventExtensions;
      $export($export.S, 'Reflect', {
        preventExtensions: function preventExtensions(target) {
          anObject(target);
          try {
            if ($preventExtensions) $preventExtensions(target);
            return true;
          } catch (e) {
            return false;
          }
        }
      });

      /***/
    }, /* 260 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.14 Reflect.setPrototypeOf(target, proto)
      var $export = __webpack_require__(0);
      var setProto = __webpack_require__(81);
      if (setProto) $export($export.S, 'Reflect', {
        setPrototypeOf: function setPrototypeOf(target, proto) {
          setProto.check(target, proto);
          try {
            setProto.set(target, proto);
            return true;
          } catch (e) {
            return false;
          }
        }
      });

      /***/
    }, /* 261 */
    /***/function (module, exports, __webpack_require__) {
      // 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
      var dP = __webpack_require__(9);
      var gOPD = __webpack_require__(20);
      var getPrototypeOf = __webpack_require__(32);
      var has = __webpack_require__(13);
      var $export = __webpack_require__(0);
      var createDesc = __webpack_require__(34);
      var anObject = __webpack_require__(1);
      var isObject = __webpack_require__(4);
      function set(target, propertyKey, V /* , receiver */) {
        var receiver = arguments.length < 4 ? target : arguments[3];
        var ownDesc = gOPD.f(anObject(target), propertyKey);
        var existingDescriptor, proto;
        if (!ownDesc) {
          if (isObject(proto = getPrototypeOf(target))) {
            return set(proto, propertyKey, V, receiver);
          }
          ownDesc = createDesc(0);
        }
        if (has(ownDesc, 'value')) {
          if (ownDesc.writable === false || !isObject(receiver)) return false;
          if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
            if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
            existingDescriptor.value = V;
            dP.f(receiver, propertyKey, existingDescriptor);
          } else dP.f(receiver, propertyKey, createDesc(0, V));
          return true;
        }
        return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
      }
      $export($export.S, 'Reflect', {
        set: set
      });

      /***/
    }, /* 262 */
    /***/function (module, exports, __webpack_require__) {
      var global = __webpack_require__(3);
      var inheritIfRequired = __webpack_require__(74);
      var dP = __webpack_require__(9).f;
      var gOPN = __webpack_require__(31).f;
      var isRegExp = __webpack_require__(76);
      var $flags = __webpack_require__(55);
      var $RegExp = global.RegExp;
      var Base = $RegExp;
      var proto = $RegExp.prototype;
      var re1 = /a/g;
      var re2 = /a/g;
      // "new" creates a new object, old webkit buggy here
      var CORRECT_NEW = new $RegExp(re1) !== re1;
      if (__webpack_require__(8) && (!CORRECT_NEW || __webpack_require__(2)(function () {
        re2[__webpack_require__(5)('match')] = false;
        // RegExp constructor can alter flags and IsRegExp works correct with @@match
        return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
      }))) {
        $RegExp = function RegExp(p, f) {
          var tiRE = this instanceof $RegExp;
          var piRE = isRegExp(p);
          var fiU = f === undefined;
          return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f), tiRE ? this : proto, $RegExp);
        };
        var proxy = function proxy(key) {
          key in $RegExp || dP($RegExp, key, {
            configurable: true,
            get: function get() {
              return Base[key];
            },
            set: function set(it) {
              Base[key] = it;
            }
          });
        };
        for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
        proto.constructor = $RegExp;
        $RegExp.prototype = proto;
        __webpack_require__(11)(global, 'RegExp', $RegExp);
      }
      __webpack_require__(41)('RegExp');

      /***/
    }, /* 263 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var anObject = __webpack_require__(1);
      var toLength = __webpack_require__(6);
      var advanceStringIndex = __webpack_require__(67);
      var regExpExec = __webpack_require__(60);

      // @@match logic
      __webpack_require__(54)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
        return [
        // `String.prototype.match` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.match
        function match(regexp) {
          var O = defined(this);
          var fn = regexp == undefined ? undefined : regexp[MATCH];
          return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
        function (regexp) {
          var res = maybeCallNative($match, regexp, this);
          if (res.done) return res.value;
          var rx = anObject(regexp);
          var S = String(this);
          if (!rx.global) return regExpExec(rx, S);
          var fullUnicode = rx.unicode;
          rx.lastIndex = 0;
          var A = [];
          var n = 0;
          var result;
          while ((result = regExpExec(rx, S)) !== null) {
            var matchStr = String(result[0]);
            A[n] = matchStr;
            if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
            n++;
          }
          return n === 0 ? null : A;
        }];
      });

      /***/
    }, /* 264 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var anObject = __webpack_require__(1);
      var toObject = __webpack_require__(10);
      var toLength = __webpack_require__(6);
      var toInteger = __webpack_require__(22);
      var advanceStringIndex = __webpack_require__(67);
      var regExpExec = __webpack_require__(60);
      var max = Math.max;
      var min = Math.min;
      var floor = Math.floor;
      var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
      var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
      var maybeToString = function maybeToString(it) {
        return it === undefined ? it : String(it);
      };

      // @@replace logic
      __webpack_require__(54)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
        return [
        // `String.prototype.replace` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
          var O = defined(this);
          var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
          return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
        function (regexp, replaceValue) {
          var res = maybeCallNative($replace, regexp, this, replaceValue);
          if (res.done) return res.value;
          var rx = anObject(regexp);
          var S = String(this);
          var functionalReplace = typeof replaceValue === 'function';
          if (!functionalReplace) replaceValue = String(replaceValue);
          var global = rx.global;
          if (global) {
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
          }
          var results = [];
          while (true) {
            var result = regExpExec(rx, S);
            if (result === null) break;
            results.push(result);
            if (!global) break;
            var matchStr = String(result[0]);
            if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
          }
          var accumulatedResult = '';
          var nextSourcePosition = 0;
          for (var i = 0; i < results.length; i++) {
            result = results[i];
            var matched = String(result[0]);
            var position = max(min(toInteger(result.index), S.length), 0);
            var captures = [];
            // NOTE: This is equivalent to
            //   captures = result.slice(1).map(maybeToString)
            // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
            // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
            // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
            for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
            var namedCaptures = result.groups;
            if (functionalReplace) {
              var replacerArgs = [matched].concat(captures, position, S);
              if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
              var replacement = String(replaceValue.apply(undefined, replacerArgs));
            } else {
              replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
            }
            if (position >= nextSourcePosition) {
              accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
              nextSourcePosition = position + matched.length;
            }
          }
          return accumulatedResult + S.slice(nextSourcePosition);
        }];

        // https://tc39.github.io/ecma262/#sec-getsubstitution
        function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
          var tailPos = position + matched.length;
          var m = captures.length;
          var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
          if (namedCaptures !== undefined) {
            namedCaptures = toObject(namedCaptures);
            symbols = SUBSTITUTION_SYMBOLS;
          }
          return $replace.call(replacement, symbols, function (match, ch) {
            var capture;
            switch (ch.charAt(0)) {
              case '$':
                return '$';
              case '&':
                return matched;
              case '`':
                return str.slice(0, position);
              case "'":
                return str.slice(tailPos);
              case '<':
                capture = namedCaptures[ch.slice(1, -1)];
                break;
              default:
                // \d\d?
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                  var f = floor(n / 10);
                  if (f === 0) return match;
                  if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                  return match;
                }
                capture = captures[n - 1];
            }
            return capture === undefined ? '' : capture;
          });
        }
      });

      /***/
    }, /* 265 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var anObject = __webpack_require__(1);
      var sameValue = __webpack_require__(119);
      var regExpExec = __webpack_require__(60);

      // @@search logic
      __webpack_require__(54)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
        return [
        // `String.prototype.search` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.search
        function search(regexp) {
          var O = defined(this);
          var fn = regexp == undefined ? undefined : regexp[SEARCH];
          return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
        function (regexp) {
          var res = maybeCallNative($search, regexp, this);
          if (res.done) return res.value;
          var rx = anObject(regexp);
          var S = String(this);
          var previousLastIndex = rx.lastIndex;
          if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
          var result = regExpExec(rx, S);
          if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
          return result === null ? -1 : result.index;
        }];
      });

      /***/
    }, /* 266 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var isRegExp = __webpack_require__(76);
      var anObject = __webpack_require__(1);
      var speciesConstructor = __webpack_require__(48);
      var advanceStringIndex = __webpack_require__(67);
      var toLength = __webpack_require__(6);
      var callRegExpExec = __webpack_require__(60);
      var regexpExec = __webpack_require__(80);
      var fails = __webpack_require__(2);
      var $min = Math.min;
      var $push = [].push;
      var $SPLIT = 'split';
      var LENGTH = 'length';
      var LAST_INDEX = 'lastIndex';
      var MAX_UINT32 = 0xffffffff;

      // babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
      var SUPPORTS_Y = !fails(function () {
        RegExp(MAX_UINT32, 'y');
      });

      // @@split logic
      __webpack_require__(54)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
        var internalSplit;
        if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
          // based on es5-shim implementation, need to rework it
          internalSplit = function internalSplit(separator, limit) {
            var string = String(this);
            if (separator === undefined && limit === 0) return [];
            // If `separator` is not a regex, use native split
            if (!isRegExp(separator)) return $split.call(string, separator, limit);
            var output = [];
            var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
            var lastLastIndex = 0;
            var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
            // Make `global` and avoid `lastIndex` issues by working with a copy
            var separatorCopy = new RegExp(separator.source, flags + 'g');
            var match, lastIndex, lastLength;
            while (match = regexpExec.call(separatorCopy, string)) {
              lastIndex = separatorCopy[LAST_INDEX];
              if (lastIndex > lastLastIndex) {
                output.push(string.slice(lastLastIndex, match.index));
                if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
                lastLength = match[0][LENGTH];
                lastLastIndex = lastIndex;
                if (output[LENGTH] >= splitLimit) break;
              }
              if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
            }

            if (lastLastIndex === string[LENGTH]) {
              if (lastLength || !separatorCopy.test('')) output.push('');
            } else output.push(string.slice(lastLastIndex));
            return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
          };
          // Chakra, V8
        } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
          internalSplit = function internalSplit(separator, limit) {
            return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
          };
        } else {
          internalSplit = $split;
        }
        return [
        // `String.prototype.split` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
          var O = defined(this);
          var splitter = separator == undefined ? undefined : separator[SPLIT];
          return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function (regexp, limit) {
          var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
          if (res.done) return res.value;
          var rx = anObject(regexp);
          var S = String(this);
          var C = speciesConstructor(rx, RegExp);
          var unicodeMatching = rx.unicode;
          var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (SUPPORTS_Y ? 'y' : 'g');

          // ^(? + rx + ) is needed, in combination with some S slicing, to
          // simulate the 'y' flag.
          var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
          var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
          if (lim === 0) return [];
          if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
          var p = 0;
          var q = 0;
          var A = [];
          while (q < S.length) {
            splitter.lastIndex = SUPPORTS_Y ? q : 0;
            var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
            var e;
            if (z === null || (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
              q = advanceStringIndex(S, q, unicodeMatching);
            } else {
              A.push(S.slice(p, q));
              if (A.length === lim) return A;
              for (var i = 1; i <= z.length - 1; i++) {
                A.push(z[i]);
                if (A.length === lim) return A;
              }
              q = p = e;
            }
          }
          A.push(S.slice(p));
          return A;
        }];
      });

      /***/
    }, /* 267 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      __webpack_require__(125);
      var anObject = __webpack_require__(1);
      var $flags = __webpack_require__(55);
      var DESCRIPTORS = __webpack_require__(8);
      var TO_STRING = 'toString';
      var $toString = /./[TO_STRING];
      var define = function define(fn) {
        __webpack_require__(11)(RegExp.prototype, TO_STRING, fn, true);
      };

      // 21.2.5.14 RegExp.prototype.toString()
      if (__webpack_require__(2)(function () {
        return $toString.call({
          source: 'a',
          flags: 'b'
        }) != '/a/b';
      })) {
        define(function toString() {
          var R = anObject(this);
          return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
        });
        // FF44- RegExp#toString has a wrong name
      } else if ($toString.name != TO_STRING) {
        define(function toString() {
          return $toString.call(this);
        });
      }

      /***/
    }, /* 268 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var strong = __webpack_require__(100);
      var validate = __webpack_require__(37);
      var SET = 'Set';

      // 23.2 Set Objects
      module.exports = __webpack_require__(53)(SET, function (get) {
        return function Set() {
          return get(this, arguments.length > 0 ? arguments[0] : undefined);
        };
      }, {
        // 23.2.3.1 Set.prototype.add(value)
        add: function add(value) {
          return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
        }
      }, strong);

      /***/
    }, /* 269 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.2 String.prototype.anchor(name)
      __webpack_require__(12)('anchor', function (createHTML) {
        return function anchor(name) {
          return createHTML(this, 'a', 'name', name);
        };
      });

      /***/
    }, /* 270 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.3 String.prototype.big()
      __webpack_require__(12)('big', function (createHTML) {
        return function big() {
          return createHTML(this, 'big', '', '');
        };
      });

      /***/
    }, /* 271 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.4 String.prototype.blink()
      __webpack_require__(12)('blink', function (createHTML) {
        return function blink() {
          return createHTML(this, 'blink', '', '');
        };
      });

      /***/
    }, /* 272 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.5 String.prototype.bold()
      __webpack_require__(12)('bold', function (createHTML) {
        return function bold() {
          return createHTML(this, 'b', '', '');
        };
      });

      /***/
    }, /* 273 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var $at = __webpack_require__(83)(false);
      $export($export.P, 'String', {
        // 21.1.3.3 String.prototype.codePointAt(pos)
        codePointAt: function codePointAt(pos) {
          return $at(this, pos);
        }
      });

      /***/
    }, /* 274 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
      var $export = __webpack_require__(0);
      var toLength = __webpack_require__(6);
      var context = __webpack_require__(84);
      var ENDS_WITH = 'endsWith';
      var $endsWith = ''[ENDS_WITH];
      $export($export.P + $export.F * __webpack_require__(72)(ENDS_WITH), 'String', {
        endsWith: function endsWith(searchString /* , endPosition = @length */) {
          var that = context(this, searchString, ENDS_WITH);
          var endPosition = arguments.length > 1 ? arguments[1] : undefined;
          var len = toLength(that.length);
          var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
          var search = String(searchString);
          return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
        }
      });

      /***/
    }, /* 275 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.6 String.prototype.fixed()
      __webpack_require__(12)('fixed', function (createHTML) {
        return function fixed() {
          return createHTML(this, 'tt', '', '');
        };
      });

      /***/
    }, /* 276 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.7 String.prototype.fontcolor(color)
      __webpack_require__(12)('fontcolor', function (createHTML) {
        return function fontcolor(color) {
          return createHTML(this, 'font', 'color', color);
        };
      });

      /***/
    }, /* 277 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.8 String.prototype.fontsize(size)
      __webpack_require__(12)('fontsize', function (createHTML) {
        return function fontsize(size) {
          return createHTML(this, 'font', 'size', size);
        };
      });

      /***/
    }, /* 278 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var toAbsoluteIndex = __webpack_require__(35);
      var fromCharCode = String.fromCharCode;
      var $fromCodePoint = String.fromCodePoint;

      // length should be 1, old FF problem
      $export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
        // 21.1.2.2 String.fromCodePoint(...codePoints)
        fromCodePoint: function fromCodePoint(x) {
          // eslint-disable-line no-unused-vars
          var res = [];
          var aLen = arguments.length;
          var i = 0;
          var code;
          while (aLen > i) {
            code = +arguments[i++];
            if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
            res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
          }
          return res.join('');
        }
      });

      /***/
    }, /* 279 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 21.1.3.7 String.prototype.includes(searchString, position = 0)
      var $export = __webpack_require__(0);
      var context = __webpack_require__(84);
      var INCLUDES = 'includes';
      $export($export.P + $export.F * __webpack_require__(72)(INCLUDES), 'String', {
        includes: function includes(searchString /* , position = 0 */) {
          return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
        }
      });

      /***/
    }, /* 280 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.9 String.prototype.italics()
      __webpack_require__(12)('italics', function (createHTML) {
        return function italics() {
          return createHTML(this, 'i', '', '');
        };
      });

      /***/
    }, /* 281 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $at = __webpack_require__(83)(true);

      // 21.1.3.27 String.prototype[@@iterator]()
      __webpack_require__(77)(String, 'String', function (iterated) {
        this._t = String(iterated); // target
        this._i = 0; // next index
        // 21.1.5.2.1 %StringIteratorPrototype%.next()
      }, function () {
        var O = this._t;
        var index = this._i;
        var point;
        if (index >= O.length) return {
          value: undefined,
          done: true
        };
        point = $at(O, index);
        this._i += point.length;
        return {
          value: point,
          done: false
        };
      });

      /***/
    }, /* 282 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.10 String.prototype.link(url)
      __webpack_require__(12)('link', function (createHTML) {
        return function link(url) {
          return createHTML(this, 'a', 'href', url);
        };
      });

      /***/
    }, /* 283 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var toIObject = __webpack_require__(15);
      var toLength = __webpack_require__(6);
      $export($export.S, 'String', {
        // 21.1.2.4 String.raw(callSite, ...substitutions)
        raw: function raw(callSite) {
          var tpl = toIObject(callSite.raw);
          var len = toLength(tpl.length);
          var aLen = arguments.length;
          var res = [];
          var i = 0;
          while (len > i) {
            res.push(String(tpl[i++]));
            if (i < aLen) res.push(String(arguments[i]));
          }
          return res.join('');
        }
      });

      /***/
    }, /* 284 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      $export($export.P, 'String', {
        // 21.1.3.13 String.prototype.repeat(count)
        repeat: __webpack_require__(85)
      });

      /***/
    }, /* 285 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.11 String.prototype.small()
      __webpack_require__(12)('small', function (createHTML) {
        return function small() {
          return createHTML(this, 'small', '', '');
        };
      });

      /***/
    }, /* 286 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 21.1.3.18 String.prototype.startsWith(searchString [, position ])
      var $export = __webpack_require__(0);
      var toLength = __webpack_require__(6);
      var context = __webpack_require__(84);
      var STARTS_WITH = 'startsWith';
      var $startsWith = ''[STARTS_WITH];
      $export($export.P + $export.F * __webpack_require__(72)(STARTS_WITH), 'String', {
        startsWith: function startsWith(searchString /* , position = 0 */) {
          var that = context(this, searchString, STARTS_WITH);
          var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
          var search = String(searchString);
          return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
        }
      });

      /***/
    }, /* 287 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.12 String.prototype.strike()
      __webpack_require__(12)('strike', function (createHTML) {
        return function strike() {
          return createHTML(this, 'strike', '', '');
        };
      });

      /***/
    }, /* 288 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.13 String.prototype.sub()
      __webpack_require__(12)('sub', function (createHTML) {
        return function sub() {
          return createHTML(this, 'sub', '', '');
        };
      });

      /***/
    }, /* 289 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // B.2.3.14 String.prototype.sup()
      __webpack_require__(12)('sup', function (createHTML) {
        return function sup() {
          return createHTML(this, 'sup', '', '');
        };
      });

      /***/
    }, /* 290 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // 21.1.3.25 String.prototype.trim()
      __webpack_require__(43)('trim', function ($trim) {
        return function trim() {
          return $trim(this, 3);
        };
      });

      /***/
    }, /* 291 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // ECMAScript 6 symbols shim
      var global = __webpack_require__(3);
      var has = __webpack_require__(13);
      var DESCRIPTORS = __webpack_require__(8);
      var $export = __webpack_require__(0);
      var redefine = __webpack_require__(11);
      var META = __webpack_require__(26).KEY;
      var $fails = __webpack_require__(2);
      var shared = __webpack_require__(61);
      var setToStringTag = __webpack_require__(42);
      var uid = __webpack_require__(36);
      var wks = __webpack_require__(5);
      var wksExt = __webpack_require__(89);
      var wksDefine = __webpack_require__(122);
      var enumKeys = __webpack_require__(165);
      var isArray = __webpack_require__(57);
      var anObject = __webpack_require__(1);
      var isObject = __webpack_require__(4);
      var toObject = __webpack_require__(10);
      var toIObject = __webpack_require__(15);
      var toPrimitive = __webpack_require__(27);
      var createDesc = __webpack_require__(34);
      var _create = __webpack_require__(30);
      var gOPNExt = __webpack_require__(112);
      var $GOPD = __webpack_require__(20);
      var $GOPS = __webpack_require__(59);
      var $DP = __webpack_require__(9);
      var $keys = __webpack_require__(33);
      var gOPD = $GOPD.f;
      var dP = $DP.f;
      var gOPN = gOPNExt.f;
      var $Symbol = global.Symbol;
      var $JSON = global.JSON;
      var _stringify = $JSON && $JSON.stringify;
      var PROTOTYPE = 'prototype';
      var HIDDEN = wks('_hidden');
      var TO_PRIMITIVE = wks('toPrimitive');
      var isEnum = {}.propertyIsEnumerable;
      var SymbolRegistry = shared('symbol-registry');
      var AllSymbols = shared('symbols');
      var OPSymbols = shared('op-symbols');
      var ObjectProto = Object[PROTOTYPE];
      var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
      var QObject = global.QObject;
      // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
      var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

      // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
      var setSymbolDesc = DESCRIPTORS && $fails(function () {
        return _create(dP({}, 'a', {
          get: function get() {
            return dP(this, 'a', {
              value: 7
            }).a;
          }
        })).a != 7;
      }) ? function (it, key, D) {
        var protoDesc = gOPD(ObjectProto, key);
        if (protoDesc) delete ObjectProto[key];
        dP(it, key, D);
        if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
      } : dP;
      var wrap = function wrap(tag) {
        var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
        sym._k = tag;
        return sym;
      };
      var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
        return typeof it == 'symbol';
      } : function (it) {
        return it instanceof $Symbol;
      };
      var $defineProperty = function defineProperty(it, key, D) {
        if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
        anObject(it);
        key = toPrimitive(key, true);
        anObject(D);
        if (has(AllSymbols, key)) {
          if (!D.enumerable) {
            if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
            it[HIDDEN][key] = true;
          } else {
            if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
            D = _create(D, {
              enumerable: createDesc(0, false)
            });
          }
          return setSymbolDesc(it, key, D);
        }
        return dP(it, key, D);
      };
      var $defineProperties = function defineProperties(it, P) {
        anObject(it);
        var keys = enumKeys(P = toIObject(P));
        var i = 0;
        var l = keys.length;
        var key;
        while (l > i) $defineProperty(it, key = keys[i++], P[key]);
        return it;
      };
      var $create = function create(it, P) {
        return P === undefined ? _create(it) : $defineProperties(_create(it), P);
      };
      var $propertyIsEnumerable = function propertyIsEnumerable(key) {
        var E = isEnum.call(this, key = toPrimitive(key, true));
        if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
        return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
      };
      var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
        it = toIObject(it);
        key = toPrimitive(key, true);
        if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
        var D = gOPD(it, key);
        if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
        return D;
      };
      var $getOwnPropertyNames = function getOwnPropertyNames(it) {
        var names = gOPN(toIObject(it));
        var result = [];
        var i = 0;
        var key;
        while (names.length > i) {
          if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
        }
        return result;
      };
      var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
        var IS_OP = it === ObjectProto;
        var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
        var result = [];
        var i = 0;
        var key;
        while (names.length > i) {
          if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
        }
        return result;
      };

      // 19.4.1.1 Symbol([description])
      if (!USE_NATIVE) {
        $Symbol = function Symbol() {
          if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
          var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
          var $set = function $set(value) {
            if (this === ObjectProto) $set.call(OPSymbols, value);
            if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
            setSymbolDesc(this, tag, createDesc(1, value));
          };
          if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
            configurable: true,
            set: $set
          });
          return wrap(tag);
        };
        redefine($Symbol[PROTOTYPE], 'toString', function toString() {
          return this._k;
        });
        $GOPD.f = $getOwnPropertyDescriptor;
        $DP.f = $defineProperty;
        __webpack_require__(31).f = gOPNExt.f = $getOwnPropertyNames;
        __webpack_require__(47).f = $propertyIsEnumerable;
        $GOPS.f = $getOwnPropertySymbols;
        if (DESCRIPTORS && !__webpack_require__(29)) {
          redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
        }
        wksExt.f = function (name) {
          return wrap(wks(name));
        };
      }
      $export($export.G + $export.W + $export.F * !USE_NATIVE, {
        Symbol: $Symbol
      });
      for (var es6Symbols =
        // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
        'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) wks(es6Symbols[j++]);
      for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
      $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
        // 19.4.2.1 Symbol.for(key)
        'for': function _for(key) {
          return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
        },
        // 19.4.2.5 Symbol.keyFor(sym)
        keyFor: function keyFor(sym) {
          if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
          for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
        },
        useSetter: function useSetter() {
          setter = true;
        },
        useSimple: function useSimple() {
          setter = false;
        }
      });
      $export($export.S + $export.F * !USE_NATIVE, 'Object', {
        // 19.1.2.2 Object.create(O [, Properties])
        create: $create,
        // 19.1.2.4 Object.defineProperty(O, P, Attributes)
        defineProperty: $defineProperty,
        // 19.1.2.3 Object.defineProperties(O, Properties)
        defineProperties: $defineProperties,
        // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
        // 19.1.2.7 Object.getOwnPropertyNames(O)
        getOwnPropertyNames: $getOwnPropertyNames,
        // 19.1.2.8 Object.getOwnPropertySymbols(O)
        getOwnPropertySymbols: $getOwnPropertySymbols
      });

      // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
      // https://bugs.chromium.org/p/v8/issues/detail?id=3443
      var FAILS_ON_PRIMITIVES = $fails(function () {
        $GOPS.f(1);
      });
      $export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
          return $GOPS.f(toObject(it));
        }
      });

      // 24.3.2 JSON.stringify(value [, replacer [, space]])
      $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
        var S = $Symbol();
        // MS Edge converts symbol values to JSON as {}
        // WebKit converts symbol values to JSON as null
        // V8 throws on boxed symbols
        return _stringify([S]) != '[null]' || _stringify({
          a: S
        }) != '{}' || _stringify(Object(S)) != '{}';
      })), 'JSON', {
        stringify: function stringify(it) {
          var args = [it];
          var i = 1;
          var replacer, $replacer;
          while (arguments.length > i) args.push(arguments[i++]);
          $replacer = replacer = args[1];
          if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
          if (!isArray(replacer)) replacer = function replacer(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!isSymbol(value)) return value;
          };
          args[1] = replacer;
          return _stringify.apply($JSON, args);
        }
      });

      // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
      $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(14)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
      // 19.4.3.5 Symbol.prototype[@@toStringTag]
      setToStringTag($Symbol, 'Symbol');
      // 20.2.1.9 Math[@@toStringTag]
      setToStringTag(Math, 'Math', true);
      // 24.3.3 JSON[@@toStringTag]
      setToStringTag(global.JSON, 'JSON', true);

      /***/
    }, /* 292 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var $export = __webpack_require__(0);
      var $typed = __webpack_require__(62);
      var buffer = __webpack_require__(88);
      var anObject = __webpack_require__(1);
      var toAbsoluteIndex = __webpack_require__(35);
      var toLength = __webpack_require__(6);
      var isObject = __webpack_require__(4);
      var ArrayBuffer = __webpack_require__(3).ArrayBuffer;
      var speciesConstructor = __webpack_require__(48);
      var $ArrayBuffer = buffer.ArrayBuffer;
      var $DataView = buffer.DataView;
      var $isView = $typed.ABV && ArrayBuffer.isView;
      var $slice = $ArrayBuffer.prototype.slice;
      var VIEW = $typed.VIEW;
      var ARRAY_BUFFER = 'ArrayBuffer';
      $export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {
        ArrayBuffer: $ArrayBuffer
      });
      $export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
        // 24.1.3.1 ArrayBuffer.isView(arg)
        isView: function isView(it) {
          return $isView && $isView(it) || isObject(it) && VIEW in it;
        }
      });
      $export($export.P + $export.U + $export.F * __webpack_require__(2)(function () {
        return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
      }), ARRAY_BUFFER, {
        // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
        slice: function slice(start, end) {
          if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
          var len = anObject(this).byteLength;
          var first = toAbsoluteIndex(start, len);
          var fin = toAbsoluteIndex(end === undefined ? len : end, len);
          var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
          var viewS = new $DataView(this);
          var viewT = new $DataView(result);
          var index = 0;
          while (first < fin) {
            viewT.setUint8(index++, viewS.getUint8(first++));
          }
          return result;
        }
      });
      __webpack_require__(41)(ARRAY_BUFFER);

      /***/
    }, /* 293 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      $export($export.G + $export.W + $export.F * !__webpack_require__(62).ABV, {
        DataView: __webpack_require__(88).DataView
      });

      /***/
    }, /* 294 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(25)('Float32', 4, function (init) {
        return function Float32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    }, /* 295 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(25)('Float64', 8, function (init) {
        return function Float64Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    }, /* 296 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(25)('Int16', 2, function (init) {
        return function Int16Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    }, /* 297 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(25)('Int32', 4, function (init) {
        return function Int32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    }, /* 298 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(25)('Int8', 1, function (init) {
        return function Int8Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    }, /* 299 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(25)('Uint16', 2, function (init) {
        return function Uint16Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    }, /* 300 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(25)('Uint32', 4, function (init) {
        return function Uint32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    }, /* 301 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(25)('Uint8', 1, function (init) {
        return function Uint8Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      });

      /***/
    }, /* 302 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(25)('Uint8', 1, function (init) {
        return function Uint8ClampedArray(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      }, true);

      /***/
    }, /* 303 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var global = __webpack_require__(3);
      var each = __webpack_require__(18)(0);
      var redefine = __webpack_require__(11);
      var meta = __webpack_require__(26);
      var assign = __webpack_require__(110);
      var weak = __webpack_require__(101);
      var isObject = __webpack_require__(4);
      var validate = __webpack_require__(37);
      var NATIVE_WEAK_MAP = __webpack_require__(37);
      var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
      var WEAK_MAP = 'WeakMap';
      var getWeak = meta.getWeak;
      var isExtensible = Object.isExtensible;
      var uncaughtFrozenStore = weak.ufstore;
      var InternalMap;
      var wrapper = function wrapper(get) {
        return function WeakMap() {
          return get(this, arguments.length > 0 ? arguments[0] : undefined);
        };
      };
      var methods = {
        // 23.3.3.3 WeakMap.prototype.get(key)
        get: function get(key) {
          if (isObject(key)) {
            var data = getWeak(key);
            if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
            return data ? data[this._i] : undefined;
          }
        },
        // 23.3.3.5 WeakMap.prototype.set(key, value)
        set: function set(key, value) {
          return weak.def(validate(this, WEAK_MAP), key, value);
        }
      };

      // 23.3 WeakMap Objects
      var $WeakMap = module.exports = __webpack_require__(53)(WEAK_MAP, wrapper, methods, weak, true, true);

      // IE11 WeakMap frozen keys fix
      if (NATIVE_WEAK_MAP && IS_IE11) {
        InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
        assign(InternalMap.prototype, methods);
        meta.NEED = true;
        each(['delete', 'has', 'get', 'set'], function (key) {
          var proto = $WeakMap.prototype;
          var method = proto[key];
          redefine(proto, key, function (a, b) {
            // store frozen objects on internal weakmap shim
            if (isObject(a) && !isExtensible(a)) {
              if (!this._f) this._f = new InternalMap();
              var result = this._f[key](a, b);
              return key == 'set' ? this : result;
              // store all the rest on native weakmap
            }
            return method.call(this, a, b);
          });
        });
      }

      /***/
    }, /* 304 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      var weak = __webpack_require__(101);
      var validate = __webpack_require__(37);
      var WEAK_SET = 'WeakSet';

      // 23.4 WeakSet Objects
      __webpack_require__(53)(WEAK_SET, function (get) {
        return function WeakSet() {
          return get(this, arguments.length > 0 ? arguments[0] : undefined);
        };
      }, {
        // 23.4.3.1 WeakSet.prototype.add(value)
        add: function add(value) {
          return weak.def(validate(this, WEAK_SET), value, true);
        }
      }, weak, false, true);

      /***/
    }, /* 305 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
      var $export = __webpack_require__(0);
      var flattenIntoArray = __webpack_require__(166);
      var toObject = __webpack_require__(10);
      var toLength = __webpack_require__(6);
      var aFunction = __webpack_require__(17);
      var arraySpeciesCreate = __webpack_require__(98);
      $export($export.P, 'Array', {
        flatMap: function flatMap(callbackfn /* , thisArg */) {
          var O = toObject(this);
          var sourceLen, A;
          aFunction(callbackfn);
          sourceLen = toLength(O.length);
          A = arraySpeciesCreate(O, 0);
          flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
          return A;
        }
      });
      __webpack_require__(28)('flatMap');

      /***/
    }, /* 306 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/tc39/Array.prototype.includes
      var $export = __webpack_require__(0);
      var $includes = __webpack_require__(52)(true);
      $export($export.P, 'Array', {
        includes: function includes(el /* , fromIndex = 0 */) {
          return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
        }
      });
      __webpack_require__(28)('includes');

      /***/
    }, /* 307 */
    /***/function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-object-values-entries
      var $export = __webpack_require__(0);
      var $entries = __webpack_require__(114)(true);
      $export($export.S, 'Object', {
        entries: function entries(it) {
          return $entries(it);
        }
      });

      /***/
    }, /* 308 */
    /***/function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-object-getownpropertydescriptors
      var $export = __webpack_require__(0);
      var ownKeys = __webpack_require__(115);
      var toIObject = __webpack_require__(15);
      var gOPD = __webpack_require__(20);
      var createProperty = __webpack_require__(69);
      $export($export.S, 'Object', {
        getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
          var O = toIObject(object);
          var getDesc = gOPD.f;
          var keys = ownKeys(O);
          var result = {};
          var i = 0;
          var key, desc;
          while (keys.length > i) {
            desc = getDesc(O, key = keys[i++]);
            if (desc !== undefined) createProperty(result, key, desc);
          }
          return result;
        }
      });

      /***/
    }, /* 309 */
    /***/function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-object-values-entries
      var $export = __webpack_require__(0);
      var $values = __webpack_require__(114)(false);
      $export($export.S, 'Object', {
        values: function values(it) {
          return $values(it);
        }
      });

      /***/
    }, /* 310 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/tc39/proposal-promise-finally
      var $export = __webpack_require__(0);
      var core = __webpack_require__(7);
      var global = __webpack_require__(3);
      var speciesConstructor = __webpack_require__(48);
      var promiseResolve = __webpack_require__(118);
      $export($export.P + $export.R, 'Promise', {
        'finally': function _finally(onFinally) {
          var C = speciesConstructor(this, core.Promise || global.Promise);
          var isFunction = typeof onFinally == 'function';
          return this.then(isFunction ? function (x) {
            return promiseResolve(C, onFinally()).then(function () {
              return x;
            });
          } : onFinally, isFunction ? function (e) {
            return promiseResolve(C, onFinally()).then(function () {
              throw e;
            });
          } : onFinally);
        }
      });

      /***/
    }, /* 311 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/tc39/proposal-string-pad-start-end
      var $export = __webpack_require__(0);
      var $pad = __webpack_require__(120);
      var userAgent = __webpack_require__(63);

      // https://github.com/zloirock/core-js/issues/280
      var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
      $export($export.P + $export.F * WEBKIT_BUG, 'String', {
        padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
          return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
        }
      });

      /***/
    }, /* 312 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/tc39/proposal-string-pad-start-end
      var $export = __webpack_require__(0);
      var $pad = __webpack_require__(120);
      var userAgent = __webpack_require__(63);

      // https://github.com/zloirock/core-js/issues/280
      var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
      $export($export.P + $export.F * WEBKIT_BUG, 'String', {
        padStart: function padStart(maxLength /* , fillString = ' ' */) {
          return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
        }
      });

      /***/
    }, /* 313 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/sebmarkbage/ecmascript-string-left-right-trim
      __webpack_require__(43)('trimLeft', function ($trim) {
        return function trimLeft() {
          return $trim(this, 1);
        };
      }, 'trimStart');

      /***/
    }, /* 314 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/sebmarkbage/ecmascript-string-left-right-trim
      __webpack_require__(43)('trimRight', function ($trim) {
        return function trimRight() {
          return $trim(this, 2);
        };
      }, 'trimEnd');

      /***/
    }, /* 315 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(122)('asyncIterator');

      /***/
    }, /* 316 */
    /***/function (module, exports, __webpack_require__) {
      var $iterators = __webpack_require__(91);
      var getKeys = __webpack_require__(33);
      var redefine = __webpack_require__(11);
      var global = __webpack_require__(3);
      var hide = __webpack_require__(14);
      var Iterators = __webpack_require__(39);
      var wks = __webpack_require__(5);
      var ITERATOR = wks('iterator');
      var TO_STRING_TAG = wks('toStringTag');
      var ArrayValues = Iterators.Array;
      var DOMIterables = {
        CSSRuleList: true,
        // TODO: Not spec compliant, should be false.
        CSSStyleDeclaration: false,
        CSSValueList: false,
        ClientRectList: false,
        DOMRectList: false,
        DOMStringList: false,
        DOMTokenList: true,
        DataTransferItemList: false,
        FileList: false,
        HTMLAllCollection: false,
        HTMLCollection: false,
        HTMLFormElement: false,
        HTMLSelectElement: false,
        MediaList: true,
        // TODO: Not spec compliant, should be false.
        MimeTypeArray: false,
        NamedNodeMap: false,
        NodeList: true,
        PaintRequestList: false,
        Plugin: false,
        PluginArray: false,
        SVGLengthList: false,
        SVGNumberList: false,
        SVGPathSegList: false,
        SVGPointList: false,
        SVGStringList: false,
        SVGTransformList: false,
        SourceBufferList: false,
        StyleSheetList: true,
        // TODO: Not spec compliant, should be false.
        TextTrackCueList: false,
        TextTrackList: false,
        TouchList: false
      };
      for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
        var NAME = collections[i];
        var explicit = DOMIterables[NAME];
        var Collection = global[NAME];
        var proto = Collection && Collection.prototype;
        var key;
        if (proto) {
          if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
          if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
          Iterators[NAME] = ArrayValues;
          if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
        }
      }

      /***/
    }, /* 317 */
    /***/function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(0);
      var $task = __webpack_require__(87);
      $export($export.G + $export.B, {
        setImmediate: $task.set,
        clearImmediate: $task.clear
      });

      /***/
    }, /* 318 */
    /***/function (module, exports, __webpack_require__) {
      // ie9- setTimeout & setInterval additional parameters fix
      var global = __webpack_require__(3);
      var $export = __webpack_require__(0);
      var userAgent = __webpack_require__(63);
      var slice = [].slice;
      var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
      var wrap = function wrap(set) {
        return function (fn, time /* , ...args */) {
          var boundArgs = arguments.length > 2;
          var args = boundArgs ? slice.call(arguments, 2) : false;
          return set(boundArgs ? function () {
            // eslint-disable-next-line no-new-func
            (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
          } : fn, time);
        };
      };
      $export($export.G + $export.B + $export.F * MSIE, {
        setTimeout: wrap(global.setTimeout),
        setInterval: wrap(global.setInterval)
      });

      /***/
    }, /* 319 */
    /***/function (module, exports, __webpack_require__) {
      __webpack_require__(318);
      __webpack_require__(317);
      __webpack_require__(316);
      module.exports = __webpack_require__(7);

      /***/
    }, /* 320 */
    /***/function (module, exports, __webpack_require__) {
      exports = module.exports = __webpack_require__(321)();
      // imports

      // module
      exports.push([module.i, "/*!\nziggeo-client-sdk - v2.39.16 - 2022-01-24\nCopyright (c) Ziggeo\nClosed Source Software License.\n*//*!\nbetajs-media-components - v0.0.291 - 2022-01-08\nCopyright (c) Ziggeo,Oliver Friedmann,Rashad Aliyev\nApache-2.0 Software License.\n*/@font-face{font-family:bjsmc;src:url(" + __webpack_require__(332) + ") format(\"eot\") local(\"bjsmc\")}@font-face{font-family:bjsmc;src:url(data:application/octet-stream;base64,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) format(\"embedded-opentype\"),url(data:application/octet-stream;base64,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) format(\"woff\"),url(data:application/octet-stream;base64,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) format(\"truetype\")}.ba-commoncss-icon-volume-off:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E800\"}.ba-commoncss-icon-volume-down:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E801\"}.ba-commoncss-icon-volume-up:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E802\"}.ba-commoncss-icon-resize-full:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E803\"}.ba-commoncss-icon-ccw:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E804\"}.ba-commoncss-icon-play:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E805\"}.ba-commoncss-icon-pause:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E806\"}.ba-commoncss-icon-videocam:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E807\"}.ba-commoncss-icon-upload:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E808\"}.ba-commoncss-icon-left-open:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E809\"}.ba-commoncss-icon-right-open:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E80A\"}.ba-commoncss-icon-cog:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E80B\"}.ba-commoncss-icon-mic:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E80C\"}.ba-commoncss-icon-mute:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E80D\"}.ba-commoncss-icon-lightbulb:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E80E\"}.ba-commoncss-icon-resize-small:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E80F\"}.ba-commoncss-icon-resize-minimize:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E810\"}.ba-commoncss-icon-record:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E811\"}.ba-commoncss-icon-record-core:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E812\"}.ba-commoncss-icon-up-dir:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E813\"}.ba-commoncss-icon-cancel:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E814\"}.ba-commoncss-icon-cc:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E815\"}.ba-commoncss-icon-clock:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E816\"}.ba-commoncss-icon-check:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E817\"}.ba-commoncss-icon-arrows-cw:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E818\"}.ba-commoncss-icon-plus:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E819\"}.ba-commoncss-icon-picture:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E81A\"}.ba-commoncss-icon-twitter:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F099\"}.ba-commoncss-icon-facebook:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F09A\"}.ba-commoncss-icon-gplus-squared:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F0D4\"}.ba-commoncss-icon-gplus:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F0D5\"}.ba-commoncss-icon-angle-left:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F104\"}.ba-commoncss-icon-angle-right:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F105\"}.ba-commoncss-icon-angle-up:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F106\"}.ba-commoncss-icon-angle-down:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F107\"}.ba-commoncss-icon-crop:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F125\"}.ba-commoncss-icon-share:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F130\"}.ba-commoncss-icon-resize-full-alt:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F131\"}.ba-commoncss-icon-play-circled:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F144\"}.ba-commoncss-icon-subtitle:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F20A\"}.ba-commoncss-icon-facebook-official:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F230\"}.ba-commoncss-icon-television:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F26C\"}.ba-commoncss-icon-twitter-squared:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\F304\"}.ba-commoncss-icon-facebook:before{color:#3b5998}.ba-commoncss-icon-facebook-official:before{color:#3b5998}.ba-commoncss-icon-twitter:before{color:#1da1f2}.ba-commoncss-icon-twitter-squared:before{color:#1da1f2}.ba-commoncss-icon-gplus:before{color:#dd4b39}.ba-commoncss-icon-gplus-squared:before{color:#dd4b39}.ba-imageviewer-overlay div[tabindex]{transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;-webkit-transition:all .3s ease-in-out;-o-transition:all .3s ease-in-out;-ms-transition:all .3s ease-in-out}.ba-imageviewer-overlay div[tabindex]:focus{-moz-box-shadow:0 0 0 2px #1b8fcc;-webkit-box-shadow:0 0 0 2px #1b8fcc;box-shadow:0 0 0 2px #1b8fcc;outline:0;-moz-outline-style:none}.ba-imageviewer-overlay div[tabindex]:focus:hover,.ba-imageviewer-overlay div[tabindex]:hover{box-shadow:none}.ba-videoplayer-ie8 .ba-imageviewer-overlay{height:100%}.ba-imageviewer-image-viewer-wrapper{position:absolute;width:100%;height:100%;z-index:1005}.ba-imageviewer-image-viewer-expanded{-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);left:50%;position:fixed;top:50%;width:100%;z-index:1003}.ba-imageviewer-close-button,.ba-imageviewer-title{background-color:#777;background-color:rgba(0,0,0,.7);-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-o-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);box-sizing:content-box;color:#eee;padding:8px;position:fixed;z-index:99999}.ba-imageviewer-title{bottom:3%;left:50%}.ba-imageviewer-close-button{-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;cursor:pointer;font-size:22px;right:3%}.ba-imageviewer-close-button:before{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;content:\"\\E814\"}.ba-imageviewer-fullscreen-view .ba-imageviewer-overlay{background-color:#000;bottom:0;height:100%;position:fixed;top:0;width:100%;z-index:1001}.ba-player-adslot{left:0;right:0;top:0;bottom:0;background-color:#333;background-color:rgba(0,0,0,.8);color:#fff;position:absolute}.ba-player-ad-click-tracker{left:0;right:0;top:0;bottom:0}.ba-player-ad-dashboard{position:absolute;left:0;right:0;bottom:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;height:100%;opacity:.9;overflow:hidden}.ba-player-ad-controlbar{background-color:#333;background-color:rgba(0,0,0,.8);position:absolute;bottom:0;height:40px;width:100%}.ba-player-ad-leftbutton-container{float:left;width:40px;height:100%;cursor:pointer;box-sizing:content-box}.ba-videoplayer-noie8 .ba-player-ad-rightbutton-container{float:right;width:40px;height:100%;cursor:pointer;box-sizing:content-box}.ba-videoplayer-ie8 .ba-player-ad-rightbutton-container{float:right;width:40px;height:50%;cursor:pointer;box-sizing:content-box}.ba-videoplayer-noie8 .ba-player-ad-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;color:#fff;font-size:13px}.ba-videoplayer-ie8 .ba-player-ad-button-inner{margin-top:12px;text-align:center;color:#fff;font-size:13px}.ba-player-ad-button-inner{cursor:pointer}.ba-player-ad-time-container{float:left;width:auto;height:100%;text-align:center;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:13px;color:#fff;box-sizing:content-box}.ba-videoplayer-ie8 .ba-player-ad-time-container{margin-top:11px}.ba-player-ad-time-value{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;float:left;width:auto;padding:0 15px}.ba-videoplayer-noie8 .ba-player-ad-volumebar{float:right;width:60px;height:100%;margin-right:12px}.ba-videoplayer-ie8 .ba-player-ad-volumebar{float:right;width:60px;height:50%;margin-top:16px;margin-right:12px}.ba-player-ad-volumebar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;cursor:pointer;background-color:#878787;height:6px}.ba-player-ad-volumebar-position{border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;position:absolute;left:0;background-color:#fff;height:100%}.ba-player-skipbutton-container{transition:all .3s ease-in-out .2s;-moz-transition:all .3s ease-in-out .2s;-webkit-transition:all .3s ease-in-out .2s;-o-transition:all .3s ease-in-out .2s;-ms-transition:all .3s ease-in-out .2s;-moz-opacity:.4;-khtml-opacity:.4;opacity:.4;background:#020202;font-size:12px;bottom:80px;color:#ececec;cursor:pointer;overflow:hidden;position:absolute;padding:10px 0;right:0;text-align:center;min-width:100px}.ba-player-skipbutton{text-align:center;margin:0;padding:0}.ba-player-skipbutton-container:hover{-moz-opacity:.7;-khtml-opacity:.7;opacity:.7;transition:all .3s ease-in-out .2s;-moz-transition:all .3s ease-in-out .2s;-webkit-transition:all .3s ease-in-out .2s;-o-transition:all .3s ease-in-out .2s;-ms-transition:all .3s ease-in-out .2s}.ba-player-red-color .ba-commoncss-icon-pause,.ba-player-red-color .ba-commoncss-icon-play,.ba-player-red-color .ba-commoncss-icon-resize-full,.ba-player-red-color .ba-commoncss-icon-resize-small,.ba-player-red-color .ba-commoncss-icon-share:before,.ba-player-red-color .ba-commoncss-icon-volume-down,.ba-player-red-color .ba-commoncss-icon-volume-up,.ba-player-red-color .ba-commoncss-options-popup .ba-commoncss-options-list .ba-commoncss-options-list-item,.ba-player-red-color .ba-player-button-inactive .ba-commoncss-icon-subtitle,.ba-player-red-color .ba-player-cue-content,.ba-player-red-color .ba-player-socials-list .ba-player-button-inner,.ba-player-red-color .ba-player-toggle-share-container,.ba-player-red-color .ba-settings-overlay-inner{color:#eb6a74}.ba-player-red-color .ba-player-button-active{background-color:#eb6a74}.ba-player-red-color .ba-player-airplay-container svg path{fill:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-playbutton-container{border-color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-playbutton-button::after{color:#eb6a74}.ba-player-blue-color .ba-commoncss-icon-pause,.ba-player-blue-color .ba-commoncss-icon-play,.ba-player-blue-color .ba-commoncss-icon-resize-full,.ba-player-blue-color .ba-commoncss-icon-resize-small,.ba-player-blue-color .ba-commoncss-icon-share:before,.ba-player-blue-color .ba-commoncss-icon-volume-down,.ba-player-blue-color .ba-commoncss-icon-volume-up,.ba-player-blue-color .ba-commoncss-options-popup .ba-commoncss-options-list .ba-commoncss-options-list-item,.ba-player-blue-color .ba-player-button-inactive .ba-commoncss-icon-subtitle,.ba-player-blue-color .ba-player-cue-content,.ba-player-blue-color .ba-player-socials-list .ba-player-button-inner,.ba-player-blue-color .ba-player-toggle-share-container,.ba-player-blue-color .ba-settings-overlay-inner{color:#2a74eb}.ba-player-blue-color .ba-player-button-active{background-color:#2a74eb}.ba-player-blue-color .ba-player-airplay-container svg path{fill:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-playbutton-container{border-color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-playbutton-button::after{color:#2a74eb}.ba-player-green-color .ba-commoncss-icon-pause,.ba-player-green-color .ba-commoncss-icon-play,.ba-player-green-color .ba-commoncss-icon-resize-full,.ba-player-green-color .ba-commoncss-icon-resize-small,.ba-player-green-color .ba-commoncss-icon-share:before,.ba-player-green-color .ba-commoncss-icon-volume-down,.ba-player-green-color .ba-commoncss-icon-volume-up,.ba-player-green-color .ba-commoncss-options-popup .ba-commoncss-options-list .ba-commoncss-options-list-item,.ba-player-green-color .ba-player-button-inactive .ba-commoncss-icon-subtitle,.ba-player-green-color .ba-player-cue-content,.ba-player-green-color .ba-player-socials-list .ba-player-button-inner,.ba-player-green-color .ba-player-toggle-share-container,.ba-player-green-color .ba-settings-overlay-inner{color:#5daa96}.ba-player-green-color .ba-player-button-active{background-color:#5daa96}.ba-player-green-color .ba-player-airplay-container svg path{fill:#5daa96}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-playbutton-container{border-color:#5daa96}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-playbutton-button::after{color:#5daa96}.ba-player-fullscreen-view video::-webkit-media-controls-overlay-enclosure{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-enclosure{display:none}.ba-player-fullscreen-view video::-webkit-media-controls{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-panel{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-play-button{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-current-time-display{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-time-remaining-display{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-timeline{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-mute-button{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-volume-slider{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-fullscreen-button{display:none}.ba-player-fullscreen-view video::-internal-media-controls-download-button{display:none}.ba-player-fullscreen-view video::-moz-list-bullet,.ba-player-fullscreen-view video::-moz-list-number{display:none}.ba-player-fullscreen-view video::-moz-meter-bar{display:none}.ba-player-fullscreen-view video:fullscreen:not(:root){display:none}.ba-player-fullscreen-view.ba-player-common-browser .ba-videoplayer-overlay{z-index:2147483647}.ba-player-fullscreen-view.ba-player-firefox-browser video{position:relative;min-height:100%;min-width:100%;z-index:0}.ba-player-loader-container{-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);position:absolute;top:50%;left:50%}.ba-player-loader-loader:before{content:\"\";display:block;padding-top:100%}.ba-player-loader-loader{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);position:relative;width:100%;font-size:5px;box-sizing:content-box;border-top:.6em solid;border-top-color:#999;border-top-color:rgba(255,255,255,.2);border-right:.6em solid;border-right-color:#999;border-right-color:rgba(255,255,255,.2);border-bottom:.6em solid;border-bottom-color:#999;border-bottom-color:rgba(255,255,255,.2);border-left:.6em solid #fff;-webkit-animation:ba-player-loader-load8 1.1s infinite linear;-moz-animation:ba-player-loader-load8 1.1s infinite linear;animation:ba-player-loader-load8 1.1s infinite linear}.ba-player-loader-loader,.ba-player-loader-loader:after{border-radius:50%;width:10em;height:10em}@-webkit-keyframes ba-player-loader-load8{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes ba-player-loader-load8{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.ba-videoplayer-noie8 .ba-player-playbutton-container{-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);border:.6em solid;border-color:#999;border-color:rgba(255,255,255,.6);position:absolute;top:50%;left:50%;transition:all .25s ease-in-out;-moz-transition:all .25s ease-in-out;-webkit-transition:all .25s ease-in-out;-o-transition:all .25s ease-in-out;-ms-transition:all .25s ease-in-out;-moz-box-shadow:0 0 22px #000;-webkit-box-shadow:0 0 22px #000;box-shadow:0 0 22px #000;border-radius:50%;box-sizing:content-box;cursor:pointer;font-size:5px;height:10em;text-align:center;width:10em}.ba-videoplayer-noie8 .ba-player-playbutton-container:focus{outline:0;border-radius:50%;border-color:#1b8fcc;-moz-box-shadow:0 0 0 2px #1b8fcc;-webkit-box-shadow:0 0 0 2px #1b8fcc;box-shadow:0 0 0 2px #1b8fcc}.ba-videoplayer-noie8 .ba-player-playbutton-container:focus:hover{border:none}.ba-videoplayer-noie8 .ba-player-playbutton-container:hover{-moz-box-shadow:0 0 22px #eee;-webkit-box-shadow:0 0 22px #eee;box-shadow:0 0 22px #eee}.ba-videoplayer-noie8 .ba-player-playbutton-container:hover .ba-player-playbutton-button::after{text-shadow:0 0 4px #eee}.ba-videoplayer-noie8 .ba-player-playbutton-button::after{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;text-shadow:0 0 4px #000;transition:all .25s ease-in-out;-moz-transition:all .25s ease-in-out;-webkit-transition:all .25s ease-in-out;-o-transition:all .25s ease-in-out;-ms-transition:all .25s ease-in-out;content:\"\\E805\";color:#eee;font-size:4.6em}.ba-videoplayer-noie8 .ba-player-playbutton-button::after{line-height:2.3em;margin-left:.1em;width:100%}.ba-player-rerecord-bar{position:absolute;left:0;right:0;bottom:0;background-color:#979797;background-color:rgba(0,0,0,.4)}.ba-player-rerecord-backbar{position:absolute;left:0;right:0;bottom:0;height:48px;opacity:.5}.ba-player-rerecord-frontbar{position:relative;left:0;right:0;bottom:0;height:48px;overflow:hidden;padding-left:16px;padding-right:16px;text-align:center}.ba-player-rerecord-button-container{display:inline-block}.ba-player-rerecord-button{background-color:#000;border-radius:0;color:#eee;cursor:pointer;font-family:sans-serif;font-weight:300;font-size:12px;height:48px;padding:0;padding-left:16px;padding-right:16px;line-height:48px;letter-spacing:.1em}.ba-videoplayer-overlay div[tabindex]{transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;-webkit-transition:all .3s ease-in-out;-o-transition:all .3s ease-in-out;-ms-transition:all .3s ease-in-out}.ba-videoplayer-overlay div[tabindex]:focus{-moz-box-shadow:0 0 0 2px #1b8fcc;-webkit-box-shadow:0 0 0 2px #1b8fcc;box-shadow:0 0 0 2px #1b8fcc;outline:0;-moz-outline-style:none}.ba-videoplayer-overlay div[tabindex]:focus:hover,.ba-videoplayer-overlay div[tabindex]:hover{box-shadow:none}.ba-videoplayer-container .ba-videoplayer-overlay .ba-player-dashboard-hidden{opacity:0}.ba-videoplayer-container .ba-videoplayer-overlay .ba-player-dashboard-hidden *{cursor:none}.ba-videoplayer-poster-container,.ba-videoplayer-video-container{background-color:#000}.ba-videoplayer-poster-container,.ba-videoplayer-poster-container img,.ba-videoplayer-video-container,.ba-videoplayer-video-container video{position:absolute;left:0;right:0;top:0;bottom:0;width:100%;height:100%}.ba-videoplayer-video-placeholder{background-color:#e9e9e9;background-image:linear-gradient(#ddd,#e9e9e9);position:absolute;height:100%;width:100%;top:0;left:0;z-index:10}.ba-videoplayer-video-placeholder::after{position:absolute;height:100%;width:100%;content:\"\";-webkit-transform:translateX(-100%);-moz-transform:translateX(-100%);-o-transform:translateX(-100%);-ms-transform:translateX(-100%);transform:translateX(-100%);background:linear-gradient(90deg,transparent,rgba(255,255,255,.6),transparent);animation:ba-videoplayer-loading 1.5s infinite}@keyframes ba-videoplayer-loading{100%{transform:translateX(100%)}}.ba-audioplayer-container .ba-audioplayer-overlay .ba-player-dashboard-hidden{opacity:0}.ba-audioplayer-container .ba-audioplayer-overlay .ba-player-dashboard-hidden *{cursor:none}.ba-videoplayer-overlay,.ba-videoplayer-player-toggle-overlay{position:absolute;left:0;right:0;top:0;bottom:0;overflow:hidden}.ba-player-airplay-container{cursor:pointer;padding-top:4px}.ba-player-airplay-container svg path{fill:#fff}.ba-player-button-inactive{background-color:transparent}.ba-player-button-inactive .ba-commoncss-icon-subtitle{color:#fff}.ba-player-button-active{background:#000}.ba-player-button-active .ba-commoncss-icon-subtitle{color:#eee}.ba-player-share-action-container{transition:all .3s ease-in-out .2s;-moz-transition:all .3s ease-in-out .2s;-webkit-transition:all .3s ease-in-out .2s;-o-transition:all .3s ease-in-out .2s;-ms-transition:all .3s ease-in-out .2s;position:absolute;right:-45px;top:50px;width:90px}.ba-player-share-action-container .ba-player-button-inner{-webkit-transform:translateY(0);-moz-transform:translateY(0);-o-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);top:0}.ba-player-share-action-container:hover{-webkit-transform:translate(-45px,0);-moz-transform:translate(-45px,0);-o-transform:translate(-45px,0);-ms-transform:translate(-45px,0);transform:translate(-45px,0)}.ba-player-toggle-share-container{background-color:#979797;background-color:rgba(0,0,0,.3);border-bottom-left-radius:5px;border-top-left-radius:5px;color:#fff;float:left;font-size:14px;line-height:45px;text-align:center;width:45px}.ba-player-social-buttons-container{float:right;width:45px}.ba-player-socials-list{background-color:#979797;background-color:rgba(0,0,0,.3);list-style:none;margin:0;padding:0;text-align:center}.ba-player-socials-list>li{cursor:pointer;font-size:14px;width:45px;line-height:45px}.ba-player-socials-list .ba-player-button-inner{color:#eee}.ba-player-text-tracks-overlay{position:absolute;left:0;right:0;bottom:33px;transition:bottom .5s ease-in-out;-moz-transition:bottom .5s ease-in-out;-webkit-transition:bottom .5s ease-in-out;-o-transition:bottom .5s ease-in-out;-ms-transition:bottom .5s ease-in-out}.ba-player-back-arrow-pointer-container{margin-bottom:5px}.ba-player-back-arrow-pointer-container .ba-player-back-arrow-pointer{cursor:pointer;font-size:12px;margin:0 0 10px}.ba-player-cue-content{position:relative;margin:auto;background:#2c2c2c;color:#eee;text-align:center;padding-top:7px;padding-bottom:7px;width:60%}.ba-commoncss-tracks-selector-list-visible{visibility:visible;opacity:1;transition:visibility 0s,opacity .2s linear}.ba-commoncss-tracks-selector-list-hidden{visibility:hidden;opacity:0;transition:visibility 0s,opacity .2s linear}.ba-recorder-controlbar-right-section{float:right}.ba-recorder-controlbar-left-section{float:left}.ba-recorder-overlay .ba-commoncss-icon-state-good{color:#9f9}.ba-recorder-overlay .ba-commoncss-icon-state-bad{color:#f99}.ba-recorder-overlay .ba-videorecorder-settings li{padding:5px 8px}.ba-recorder-overlay .ba-videorecorder-settings li:last-child{padding-bottom:0}.ba-videorecorder-timer-container{cursor:default}.ba-videorecorder-add-stream{cursor:pointer}.ba-recorder-loader-container{-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);position:absolute;top:50%;left:50%}.ba-recorder-loader-loader:before{content:\"\";display:block;padding-top:100%}.ba-recorder-loader-loader{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);position:relative;width:100%;font-size:5px;box-sizing:content-box;border-top:1.1em solid;border-top-color:#999;border-top-color:rgba(225,225,225,.2);border-right:1.1em solid;border-right-color:#999;border-right-color:rgba(225,225,225,.2);border-bottom:1.1em solid;border-bottom-color:#999;border-bottom-color:rgba(225,225,225,.2);border-left:1.1em solid #ddd;-webkit-animation:ba-recorder-loader-load8 1.1s infinite linear;-moz-animation:ba-recorder-loader-load8 1.1s infinite linear;animation:ba-recorder-loader-load8 1.1s infinite linear}.ba-recorder-loader-loader,.ba-recorder-loader-loader:after{border-radius:50%;width:10em;height:10em}.ba-recorder-loader-label{-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);position:absolute;top:50%;left:50%;font-size:40px;color:#fff}@-webkit-keyframes ba-recorder-loader-load8{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes ba-recorder-loader-load8{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.ba-recorder-message-container{opacity:1;display:table;height:100%;width:100%}.ba-recorder-message-container .ba-recorder-top-inner-message-container{display:table-cell;vertical-align:middle}.ba-recorder-message-container .ba-recorder-top-inner-message-container.ba-recorder-short-message .ba-recorder-first-inner-message-container{background-color:#7f7f7f;background-color:rgba(255,255,255,.3);-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;position:relative;margin:0 auto;height:162px;width:162px;z-index:4}.ba-recorder-message-container .ba-recorder-top-inner-message-container.ba-recorder-short-message .ba-recorder-first-inner-message-container .ba-recorder-second-inner-message-container{background-color:#b2b2b2;background-color:rgba(255,255,255,.5);-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;height:138px;position:relative;left:12px;top:12px;width:138px;z-index:6}.ba-recorder-message-container .ba-recorder-top-inner-message-container.ba-recorder-short-message .ba-recorder-first-inner-message-container .ba-recorder-second-inner-message-container .ba-recorder-third-inner-message-container{background-color:#e5e5e5;background-color:rgba(255,255,255,.7);-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;height:114px;position:relative;left:12px;top:12px;width:114px;z-index:8}.ba-recorder-message-container .ba-recorder-top-inner-message-container.ba-recorder-short-message .ba-recorder-first-inner-message-container .ba-recorder-second-inner-message-container .ba-recorder-third-inner-message-container .ba-recorder-fourth-inner-message-container{background-color:#eee;display:table;-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;height:90px;left:12px;position:relative;top:12px;width:90px;z-index:10}.ba-recorder-message-container .ba-recorder-top-inner-message-container.ba-recorder-long-message .ba-recorder-first-inner-message-container{background-color:#fff;background-color:rgba(255,255,255,.9);box-sizing:border-box;padding:5px;position:relative;margin:0 auto;width:80%;overflow:hidden}.ba-recorder-message-message{color:#000;display:table-cell;font-size:15px;font-weight:300;letter-spacing:.1em;text-align:center;vertical-align:middle}.ba-recorder-message-message ul{list-style:none;padding-left:0}.ba-recorder-message-message a{border-bottom-style:dashed;border-bottom-width:1px;color:#000;text-decoration:none}.ba-recorder-message-message a:hover{border-bottom-style:solid}.ba-recorder-overlay div[tabindex]{transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;-webkit-transition:all .3s ease-in-out;-o-transition:all .3s ease-in-out;-ms-transition:all .3s ease-in-out}.ba-recorder-overlay div[tabindex]:focus{-moz-box-shadow:0 0 0 2px #1b8fcc;-webkit-box-shadow:0 0 0 2px #1b8fcc;box-shadow:0 0 0 2px #1b8fcc;outline:0;-moz-outline-style:none}.ba-recorder-overlay div[tabindex]:focus:hover,.ba-recorder-overlay div[tabindex]:hover{box-shadow:none}.ba-commoncss-settings-menu{background-color:#0a0a0a;background-color:rgba(28,28,28,.9);text-shadow:0 0 2px rgba(0,0,0,.5);border-radius:2px;min-width:150px;overflow:hidden;position:absolute;right:5px;bottom:43px}.ba-commoncss-settings-menu-overlay{display:table;width:100%}.ba-commoncss-settings-menu-item{box-sizing:content-box;cursor:pointer;display:table-row;line-height:1.3em;padding:0 4px;outline:0;height:32px}.ba-commoncss-settings-menu-item:hover{background-color:#777;background-color:rgba(255,255,255,.1)}.ba-commoncss-settings-menu-item>div{font-family:sans-serif,Arial;font-size:.9em;color:#fafafa;display:table-cell;vertical-align:middle;padding:0 15px}.ba-commoncss-settings-menu-item>.ba-commoncss-setting-option-value{text-align:right}.ba-commoncss-settings-menu-item .ba-commoncss-setting-menu-icon{font-size:.9em;width:100%;text-align:right}.ba-commoncss-settings-menu-item .ba-commoncss-setting-option-value:after{content:\"\\203A\";padding-left:2px}.ba-commoncss-setting-menu-options-title,.ba-commoncss-settings-menu-options-item{box-sizing:content-box;cursor:pointer;display:block;line-height:1.3em;padding:5px 10px;text-align:center}.ba-commoncss-setting-menu-options-title>div,.ba-commoncss-settings-menu-options-item>div{color:#fafafa;font-family:sans-serif,Arial;font-size:.8em;font-weight:100}.ba-commoncss-setting-menu-options-title:hover,.ba-commoncss-settings-menu-options-item:hover{background-color:#777;background-color:rgba(255,255,255,.1)}.ba-commoncss-setting-menu-options-title{border-bottom:1px solid;border-bottom-color:#ccc;border-bottom-color:rgba(255,255,255,.3)}.ba-commoncss-setting-menu-options-title:before{color:#fafafa;content:\"\\2039\";float:left;line-height:1.2em;padding-right:10px}@keyframes ba-commoncss-fade-in{0%{opacity:0}100%{opacity:1}}@keyframes ba-commoncss-fade-in-up{0%{opacity:0}100%{transform:translateY(0);opacity:1}}.ba-commoncss-sticky{position:fixed!important;height:auto!important;min-height:initial!important;max-width:360px;bottom:20px;right:20px;animation:ba-commoncss-fade-in .75s ease forwards}.ba-commoncss-fade-up{transform:translateY(100%);animation:ba-commoncss-fade-in-up .75s ease forwards}@media (max-width:980px){.ba-commoncss-sticky{max-width:50%}}.ba-commoncss-full-width{width:100%}.ba-commoncss-half-width{width:50%}.ba-commoncss-text-center{text-align:center}.ba-commoncss-text-right{text-align:right}.ba-commoncss-text-left{text-align:left}.ba-commoncss-pull-right{float:right}.ba-commoncss-disabled,.ba-commoncss-disabled *{cursor:not-allowed;-moz-opacity:.5;-khtml-opacity:.5;opacity:.5}.ba-commoncss-accent-color{color:#8cf}.ba-commoncss-accent-color-bg{background-color:#8cf}.ba-commoncss-accent-color-border{border-color:#8cf}.ba-commoncss-text-info{color:#5dbb96}.ba-commoncss-text-error{color:#dd4b39}.ba-commoncss-clickable{cursor:pointer}.ba-commoncss-crop-fit{object-fit:cover}.ba-commoncss-pad-fit{object-fit:contain}.ba-commoncss-original-fit{object-fit:none}.ba-commoncss-message-container{position:relative;margin:auto;margin-top:10px;max-width:90%;text-align:center}.ba-commoncss-message-container ul{list-style:none;padding:0;margin:0}.ba-commoncss-message-container ul li{padding:4px 10px;margin-bottom:2px}.ba-commoncss-message-warning{color:#0a0a0a;background-color:#f1d44f}.ba-commoncss-message-success{color:#0a0a0a;background-color:#9ebc9f}.ba-commoncss-message-error{color:#fff;background-color:#ff6256}.ba-commoncss-action-button{cursor:pointer;float:right;text-align:right}.ba-commoncss-open-next>.ba-commoncss-inner-icon,.ba-commoncss-open-next>.ba-commoncss-inner-text,.ba-commoncss-open-previous>.ba-commoncss-inner-icon,.ba-commoncss-open-previous>.ba-commoncss-inner-text{font-family:\"Open Sans\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-size:14px;line-height:1.5em;display:inline-block;vertical-align:middle}.ba-commoncss-open-next>.ba-commoncss-inner-icon,.ba-commoncss-open-previous>.ba-commoncss-inner-icon{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;color:#eee;position:relative}.ba-commoncss-open-next>.ba-commoncss-inner-icon:after{content:\"\\F105\";left:5px}.ba-commoncss-open-previous>.ba-commoncss-inner-icon{float:left;line-height:1.5}.ba-commoncss-open-previous>.ba-commoncss-inner-icon:before{content:\"\\F104\";right:5px}.ba-commoncss-button{color:#333;background-color:#fff;border-radius:0;padding:5px 10px;font-size:14px;line-height:1.42857143;text-align:center;white-space:nowrap;cursor:pointer}.ba-commoncss-form .ba-commoncss-form-input.ba-commoncss-select-field{border:1px solid #ccc;cursor:pointer;min-width:130px;min-height:25px;overflow:hidden}.ba-commoncss-form .ba-commoncss-form-input.ba-commoncss-select-field select{background-color:#555;background-color:rgba(0,0,0,.7);border:none;box-sizing:border-box;box-shadow:none;cursor:pointer;padding:5px 8px;position:relative;width:100%;z-index:1;-moz-appearance:none;-webkit-appearance:none}.ba-commoncss-form .ba-commoncss-form-input.ba-commoncss-select-field select:focus{outline:0}.ba-commoncss-form .ba-commoncss-form-input.ba-commoncss-select-field:after{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);content:\"\\F107\";color:#eee;position:absolute;right:15px;top:50%}.ba-commoncss-form .ba-commoncss-form-input input[type=file]{-moz-opacity:0;-khtml-opacity:0;opacity:0;bottom:0;cursor:pointer;left:0;position:absolute;z-index:100}.ba-commoncss-form .ba-commoncss-form-input input[type=file]::-webkit-file-upload-button{cursor:pointer}.ba-commoncss-form .ba-commoncss-form-input.ba-commoncss-error{border:1px solid #dd4b39}.ba-commoncss-form .ba-commoncss-form-input input[type=submit]{background:#2c2c2c;color:#ccc}.ba-commoncss-form .ba-commoncss-form-input input{width:100%;box-sizing:border-box;padding:5px 10px}.ba-commoncss-options-popup{background-color:#555;background-color:rgba(0,0,0,.7);transition:opacity .2s ease-in-out;-moz-transition:opacity .2s ease-in-out;-webkit-transition:opacity .2s ease-in-out;-o-transition:opacity .2s ease-in-out;-ms-transition:opacity .2s ease-in-out;box-sizing:border-box;bottom:3px;min-width:140px;overflow:hidden;position:absolute;right:5px;z-index:10}.ba-commoncss-options-popup .ba-commoncss-options-list{padding:0;margin:0;width:100%}.ba-commoncss-options-popup .ba-commoncss-options-list .ba-commoncss-options-list-item{outline:0;-moz-outline-style:none;box-sizing:border-box;cursor:pointer;color:#eee;display:list-item;font-weight:200;letter-spacing:.03em;padding:5px 10px;white-space:nowrap;width:100%}.ba-commoncss-options-popup .ba-commoncss-options-list .ba-commoncss-options-list-item>.ba-commoncss-inner-text{font-family:\"Open Sans\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-size:14px;float:left}.ba-commoncss-options-popup .ba-commoncss-options-list .ba-commoncss-options-list-item.ba-commoncss-inner-icon{margin:0;padding:5px 0 5px 10px}.ba-commoncss-options-popup .ba-commoncss-options-list .ba-commoncss-options-list-item:hover{background-color:#555;background-color:rgba(255,255,255,.1)}.ba-commoncss-options-list-visible{visibility:visible;opacity:1;transition:visibility 0s,opacity .5s linear}.ba-commoncss-options-list-visible.ba-commoncss-button{background-color:#979797;color:#eee;margin-top:5px}.ba-commoncss-options-list-hidden{visibility:hidden;opacity:0;transition:visibility 0s,opacity .5s linear;display:none}.ba-commoncss-options-list-hidden.ba-commoncss-button{background-color:#979797;color:#eee;margin-top:5px}.ba-commoncss-form .ba-commoncss-form-input.ba-commoncss-disabled input{cursor:not-allowed;-moz-opacity:.5;-khtml-opacity:.5;opacity:.5}.ba-commoncss-form .ba-commoncss-form-input.ba-commoncss-disabled input[type=file]{-moz-opacity:0;-khtml-opacity:0;opacity:0}.ba-commoncss-form .ba-commoncss-form-input.ba-commoncss-select-field{margin-bottom:7px}.ba-commoncss-form .ba-commoncss-form-input.ba-commoncss-select-field select{color:#eee}.ba-commoncss-form .ba-commoncss-form-input.ba-commoncss-select-field:after{position:relative;right:30px;top:10px}.ba-commoncss-icon-right-open:before{margin-right:0}.ba-commoncss-icon-left-open:before{margin-left:0}.ba-player-red-color .ba-videoplayer-button-inner,.ba-player-red-color .ba-videoplayer-title{color:#eb6a74}.ba-player-red-color .ba-videoplayer-playbutton-duration,.ba-player-red-color .ba-videoplayer-primary-button,.ba-player-red-color .ba-videoplayer-progressbar-position,.ba-player-red-color .ba-videoplayer-rerecord-button,.ba-player-red-color .ba-videoplayer-volumebar-position{background-color:#eb6a74}.ba-player-red-color .ba-videoplayer-volumebar-inner{background-color:#7f7f7f;background-color:rgba(255,255,255,.3)}.ba-player-blue-color .ba-videoplayer-button-inner,.ba-player-blue-color .ba-videoplayer-title{color:#2a74eb}.ba-player-blue-color .ba-videoplayer-playbutton-duration,.ba-player-blue-color .ba-videoplayer-primary-button,.ba-player-blue-color .ba-videoplayer-progressbar-position,.ba-player-blue-color .ba-videoplayer-rerecord-button,.ba-player-blue-color .ba-videoplayer-volumebar-position{background-color:#2a74eb}.ba-player-blue-color .ba-videoplayer-volumebar-inner{background-color:#7f7f7f;background-color:rgba(255,255,255,.3)}.ba-player-green-color .ba-videoplayer-button-inner,.ba-player-green-color .ba-videoplayer-title{color:#5daa96}.ba-player-green-color .ba-videoplayer-playbutton-duration,.ba-player-green-color .ba-videoplayer-primary-button,.ba-player-green-color .ba-videoplayer-progressbar-position,.ba-player-green-color .ba-videoplayer-rerecord-button,.ba-player-green-color .ba-videoplayer-volumebar-position{background-color:#5daa96}.ba-player-green-color .ba-videoplayer-volumebar-inner{background-color:#7f7f7f;background-color:rgba(255,255,255,.3)}.ba-player-dashboard{position:absolute;left:0;right:0;bottom:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out}.ba-videoplayer-progressbar{cursor:pointer;transition:height .1s ease-in-out;-moz-transition:height .1s ease-in-out;-webkit-transition:height .1s ease-in-out;-o-transition:height .1s ease-in-out;-ms-transition:height .1s ease-in-out;height:9px;background-color:#999}.ba-videoplayer-progressbar-chapters .ba-videoplayer-chapters-list-container{display:block;list-style:none;margin:0;padding:0;position:absolute;width:100%}.ba-videoplayer-progressbar-chapters .ba-videoplayer-chapters-list-item{background:#0f0f0f;cursor:pointer;height:10px;position:absolute;top:-.5px;width:3px;z-index:10}.ba-videoplayer-progressbar-chapters .ba-videoplayer-chapters-item-text{background:#ccc;bottom:15px;font-size:11px;left:-60px;min-width:120px;opacity:.7;padding:3px;position:absolute;text-align:center}.ba-videoplayer-progressbar.ba-player-disabled,.ba-videoplayer-progressbar.ba-player-disabled .ba-videoplayer-progressbar-cache,.ba-videoplayer-progressbar.ba-player-disabled .ba-videoplayer-progressbar-inner,.ba-videoplayer-progressbar.ba-player-disabled .ba-videoplayer-progressbar-position{cursor:not-allowed}.ba-videoplayer-progressbar-small{height:3px}.ba-videoplayer-progressbar-small .ba-videoplayer-progressbar-chapters .ba-videoplayer-chapters-list-item{height:3.5px;top:-.25px}.ba-videoplayer-progressbar-position{transition:height .1s ease-in-out;-moz-transition:height .1s ease-in-out;-webkit-transition:height .1s ease-in-out;-o-transition:height .1s ease-in-out;-ms-transition:height .1s ease-in-out;position:absolute;background-color:#8cf;height:9px}.ba-videoplayer-progressbar-small .ba-videoplayer-progressbar-position{height:3px;left:-7px}.ba-videoplayer-progressbar-cache{position:absolute;left:0;transition:height .1s ease-in-out;-moz-transition:height .1s ease-in-out;-webkit-transition:height .1s ease-in-out;-o-transition:height .1s ease-in-out;-ms-transition:height .1s ease-in-out;background-color:#eee;height:9px}.ba-videoplayer-progressbar-small .ba-videoplayer-progressbar-cache{height:3px}.ba-videoplayer-progressbar-button{-moz-border-radius:5px;-webkit-border-radius:5px;border-radius:5px;background-color:#fff;box-sizing:content-box;border:1px solid #999;position:absolute;right:-5px;top:-2px;width:11px;height:11px;z-index:20}.ba-videoplayer-progressbar-marker{background-color:#fff;border:1px solid #999;box-sizing:content-box;position:absolute;width:6.75px;top:-4px;height:17px}.ba-videoplayer-progressbar-small .ba-videoplayer-progressbar-button{display:none}.ba-videoplayer-backbar{position:absolute;left:0;right:0;bottom:0;height:30px;background-color:#000;opacity:.7}.ba-videoplayer-controlbar{position:relative;left:0;right:0;bottom:0;height:30px;overflow:hidden}.ba-videoplayer-leftbutton-container{float:left;width:50px;height:100%;cursor:pointer}.ba-videoplayer-rightbutton-container{cursor:pointer;padding:0 8px}.ba-videoplayer-noie8 .ba-videoplayer-rightbutton-container{float:right;width:auto;height:100%}.ba-videoplayer-ie8 .ba-videoplayer-rightbutton-container{float:right;width:auto;height:1px}.ba-videoplayer-noie8 .ba-videoplayer-cast-button-container{line-height:40px;width:auto}.ba-videoplayer-cast-button-container button{-moz-opacity:.7;-khtml-opacity:.7;opacity:.7;background:0 0;border:none;cursor:pointer;width:32px}.ba-player-airplay-container,.ba-videoplayer-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;color:#fff;font-size:14px}.ba-videoplayer-button-text{font-family:Arial;font-weight:700}.ba-videoplayer-ie8 .ba-videoplayer-button-inner{margin-top:6px}.ba-videoplayer-noie8 .ba-videoplayer-time-container{float:left;width:95px;height:100%;text-align:center;font-family:Arial,sans-serif;font-size:13px;color:#fff}.ba-videoplayer-ie8 .ba-videoplayer-time-container{float:left;width:95px;height:50%;text-align:center;font-family:Arial,sans-serif;font-size:13px;color:#fff;margin-top:6px}.ba-videoplayer-time-value{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;float:left;width:40px}.ba-videoplayer-time-sep{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;float:left;width:15px}.ba-videoplayer-noie8 .ba-videoplayer-volumebar{float:right;width:100px;height:100%;margin-left:8px;margin-right:13px}.ba-videoplayer-ie8 .ba-videoplayer-volumebar{float:right;width:100px;height:50%;margin-top:10px;margin-right:15px}.ba-videoplayer-volumebar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-top-left-radius:4px;border-top-right-radius:4px;cursor:pointer;background-color:#999;height:8px}.ba-videoplayer-volumebar-position{border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-top-left-radius:4px;border-top-right-radius:4px;position:absolute;left:0;background-color:#8cf;height:100%}.ba-videoplayer-volumebar-button{-moz-border-radius:6px;-webkit-border-radius:6px;border-radius:6px;cursor:pointer;background-color:#fff;box-sizing:content-box;border:1px solid #999;position:absolute;right:-6px;top:-2px;z-index:1;width:11px;height:11px}.ba-videoplayer-title{color:#fff;font-family:sans-serif,Arial;font-weight:300;font-size:12px;float:left;letter-spacing:.1em;line-height:30px;margin:0 0 0 10px}.ba-videoplayer-seeking-thumb-container{position:absolute;padding:3px 4px;background-color:#fff;bottom:45px;left:5px;text-align:center}.ba-videoplayer-seeking-thumb-container>span{font-size:.6em;color:#2c2c2c}.ba-player-device-type-mobile .ba-videoplayer-leftbutton-container{float:left;width:40px;height:100%}.ba-player-size-medium .ba-videoplayer-time-sep{width:5px}.ba-player-size-medium.ba-videoplayer-noie8 .ba-videoplayer-time-container{float:left;width:85px;height:100%}.ba-player-size-medium.ba-videoplayer-noie8 .ba-videoplayer-volumebar{float:right;width:60px;height:100%}.ba-player-size-small.ba-videoplayer-noie8 .ba-videoplayer-time-container{float:left;width:40px;height:100%}.ba-player-size-small .ba-videoplayer-time-sep,.ba-player-size-small .ba-videoplayer-time-total-duration{display:none}.ba-player-size-small.ba-videoplayer-noie8 .ba-videoplayer-volumebar{float:right;width:45px;height:100%}.ba-player-fullscreen-view video::-webkit-media-controls-overlay-enclosure{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-enclosure{display:none}.ba-player-fullscreen-view video::-webkit-media-controls{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-panel{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-play-button{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-current-time-display{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-time-remaining-display{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-timeline{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-mute-button{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-volume-slider{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-fullscreen-button{display:none}.ba-player-fullscreen-view video::-internal-media-controls-download-button{display:none}.ba-player-fullscreen-view video::-moz-list-bullet,.ba-player-fullscreen-view video::-moz-list-number{display:none}.ba-player-fullscreen-view video::-moz-meter-bar{display:none}.ba-player-fullscreen-view video:fullscreen:not(:root){display:none}.ba-player-fullscreen-view video,.ba-player-fullscreen-view>div{height:100%}.ba-player-fullscreen-view .ba-videoplayer-dashboard{bottom:0}.ba-player-fullscreen-view .ba-videoplayer-title-block{top:0}.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-dashboard,.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-title-block{position:fixed;z-index:100}.ba-videoplayer-container.ba-player-fullscreen-view{min-width:100%;position:absolute;min-height:fit-content}.ba-videoplayer-container.ba-player-fullscreen-view>.ba-videoplayer-overlay{position:fixed}.ba-videoplayer-message-container{position:absolute;left:0;right:0;top:0;bottom:0;background-color:#000;opacity:.75}.ba-videoplayer-message-message{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);color:#fff;position:absolute;left:5px;right:5px;top:50%;text-align:center}.ba-videoplayer-noie8 .ba-videoplayer-playbutton-container{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:15%}.ba-videoplayer-noie8 .ba-videoplayer-playbutton-container:focus{outline:0;border-radius:50%;border-color:#1b8fcc;-moz-box-shadow:0 0 0 2px #1b8fcc;-webkit-box-shadow:0 0 0 2px #1b8fcc;box-shadow:0 0 0 2px #1b8fcc}.ba-videoplayer-noie8 .ba-videoplayer-playbutton-container:focus:active,.ba-videoplayer-noie8 .ba-videoplayer-playbutton-container:focus:hover{border:none}.ba-videoplayer-noie8 .ba-videoplayer-playbutton-button{transition:opacity .25 ease-in-out;-moz-transition:opacity .25 ease-in-out;-webkit-transition:opacity .25 ease-in-out;-o-transition:opacity .25 ease-in-out;-ms-transition:opacity .25 ease-in-out;background-color:transparent;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB5PSIwcHgiIHg9IjBweCIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDQwIDQwIj48Zz48cGF0aCBmaWxsPSJncmF5IiBkPSJtMzcuMyAxMGMtNS41LTkuNi0xNy43LTEyLjgtMjcuMy03LjNzLTEyLjggMTcuNy03LjMgMjcuMyAxNy44IDEyLjggMjcuMyA3LjNjOS42LTUuNSAxMi44LTE3LjcgNy4zLTI3LjN6IiAvPjxwYXRoIGZpbGw9IndoaXRlIiBkPSJtMzcuMyAxMGMtNS41LTkuNi0xNy43LTEyLjgtMjcuMy03LjNzLTEyLjggMTcuNy03LjMgMjcuMyAxNy44IDEyLjggMjcuMyA3LjNjOS42LTUuNSAxMi44LTE3LjcgNy4zLTI3LjN6bS05LjMgMjMuOWMtNy43IDQuNC0xNy40IDEuOC0yMS45LTUuOS00LjQtNy42LTEuNy0xNy40IDUuOS0yMS45IDcuNy00LjQgMTcuNC0xLjggMjEuOSA1LjkgNC40IDcuNyAxLjggMTcuNC01LjkgMjEuOXptLTAuOC0xNC43bC0xMC41LTYuMWMtMS4yLTAuNC0xLjQtMC4yLTEuNyAxbDAuMSAxMi4xYzAuMiAxLjIgMC42IDEuNCAxLjcgMWwxMC40LTZjMC45LTAuNyAwLjktMS4zIDAtMnoiLz48L2c+PC9zdmc+Cg==);background-origin:padding-box;background-repeat:no-repeat;background-size:contain;cursor:pointer;display:block;opacity:.75;padding-top:100%;position:relative;width:100%}.ba-videoplayer-noie8 .ba-videoplayer-playbutton-button:hover{opacity:.9}.ba-videoplayer-ie8 .ba-videoplayer-playbutton-button{position:absolute;left:0;right:0;top:0;bottom:0;background-color:transparent;background-image:url(data:image/png;base64,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);background-repeat:no-repeat;cursor:pointer;height:64px;margin:auto;width:64px}.ba-videoplayer-rerecord-bar{position:absolute;left:0;right:0;bottom:0}.ba-videoplayer-rerecord-backbar{position:absolute;left:0;right:0;bottom:0;height:32px;background-color:#000;opacity:.1}.ba-videoplayer-rerecord-frontbar{position:relative;left:0;right:0;bottom:0;height:32px;overflow:hidden;padding-left:16px;padding-right:16px;display:flex;justify-content:center}.ba-videoplayer-rerecord-button-container{height:100%;cursor:pointer;padding-left:8px;padding-right:8px;display:inline-block;position:relative}.ba-videoplayer-rerecord-button{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;border-radius:2px;padding:4px;padding-left:8px;padding-right:8px;background-color:#8cf;color:#fff;font-family:Arial,sans-serif;font-weight:400;font-size:14px}.ba-videoplayer-playbutton-duration{background-color:gray;color:#fff;font-family:Arial,sans-serif;font-weight:400;font-size:14px;float:right;margin:5px;padding:2px}.ba-videoplayer-container{display:inline-block;position:relative;overflow:hidden;z-index:1}.ba-videoplayer-video{background-color:#000;display:block}.ba-videoplayer-container video::-webkit-media-controls-start-playback-button{display:none;-webkit-appearance:none;-moz-appearance:none}.ba-player-disabled{cursor:not-allowed;-moz-opacity:.5;-khtml-opacity:.5;opacity:.5}.ba-player-disabled *{cursor:not-allowed}.ba-videoplayer-primary-button{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;border-radius:2px;padding:4px;padding-left:8px;padding-right:8px;background-color:#8cf;color:#fff;font-family:Arial,sans-serif;font-weight:400;font-size:14px}.ba-videoplayer-topmessage-container{position:absolute;left:0;right:0;top:0}.ba-videoplayer-topmessage-message{position:absolute;left:0;right:0;top:0;font-family:Arial,sans-serif;font-size:16px;font-weight:400;color:#fff;padding:8px;text-align:center}.ba-videoplayer-topmessage-background{background-color:#000;height:32px;opacity:.1;position:absolute;width:100%}.ba-videoplayer-container .ba-player-text-tracks-overlay{position:absolute;left:0;right:0;bottom:39px;transition:bottom .5s ease-in-out;-moz-transition:bottom .5s ease-in-out;-webkit-transition:bottom .5s ease-in-out;-o-transition:bottom .5s ease-in-out;-ms-transition:bottom .5s ease-in-out}.ba-videoplayer-container .ba-player-text-tracks-overlay .ba-commoncss-options-popup{bottom:2px;right:0}.ba-videoplayer-container .ba-player-track-dashboard-hidden.ba-player-text-tracks-overlay{bottom:5px}.ba-videorecorder-chooser-container{position:absolute;left:0;right:0;top:0;bottom:0;background-color:#fdfdfd}.ba-videorecorder-chooser-file{position:absolute;-moz-opacity:0;-khtml-opacity:0;opacity:0;width:100%;height:100%;cursor:pointer;left:0;top:0;z-index:100}.ba-videorecorder-chooser-file::-webkit-file-upload-button{cursor:pointer}.ba-videorecorder-chooser-button-container{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);text-align:center}.ba-videorecorder-chooser-button-0,.ba-videorecorder-chooser-button-2{cursor:pointer;-moz-border-radius:4px;-webkit-border-radius:4px;border-radius:4px;background-color:#8cf;color:#fff;padding:12px;padding-left:32px;padding-right:32px;font-family:Arial,sans-serif;font-size:14px;text-align:center;position:relative;white-space:nowrap}.ba-videorecorder-chooser-button-1,.ba-videorecorder-chooser-button-3{cursor:pointer;color:#8cf;font-family:Arial,sans-serif;font-size:14px;text-align:center;padding:8px;position:relative;white-space:nowrap}.ba-recorder-red-color .ba-commoncss-accent-color,.ba-recorder-red-color .ba-videorecorder-button-inner,.ba-recorder-red-color .ba-videorecorder-chooser-button-1,.ba-recorder-red-color .ba-videorecorder-chooser-button-3,.ba-recorder-red-color .ba-videorecorder-loader-label{color:#eb6a74}.ba-recorder-red-color .ba-commoncss-accent-color-bg,.ba-recorder-red-color .ba-videorecorder-button-primary,.ba-recorder-red-color .ba-videorecorder-chooser-button-0,.ba-recorder-red-color .ba-videorecorder-chooser-button-2,.ba-recorder-red-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-red-color .ba-videorecorder-imagegallery-rightbutton{background-color:#eb6a74}.ba-recorder-red-color .ba-commoncss-accent-color-border,.ba-recorder-red-color .ba-videorecorder-imagegallery-image:hover,.ba-recorder-red-color .ba-videorecorder-settings input[type=radio]:checked+span{border-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-message-message a{color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-imagegallery-button-inner{color:#fff}.ba-recorder-blue-color .ba-commoncss-accent-color,.ba-recorder-blue-color .ba-videorecorder-button-inner,.ba-recorder-blue-color .ba-videorecorder-chooser-button-1,.ba-recorder-blue-color .ba-videorecorder-chooser-button-3,.ba-recorder-blue-color .ba-videorecorder-loader-label{color:#2a74eb}.ba-recorder-blue-color .ba-commoncss-accent-color-bg,.ba-recorder-blue-color .ba-videorecorder-button-primary,.ba-recorder-blue-color .ba-videorecorder-chooser-button-0,.ba-recorder-blue-color .ba-videorecorder-chooser-button-2,.ba-recorder-blue-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-blue-color .ba-videorecorder-imagegallery-rightbutton{background-color:#2a74eb}.ba-recorder-blue-color .ba-commoncss-accent-color-border,.ba-recorder-blue-color .ba-videorecorder-imagegallery-image:hover,.ba-recorder-blue-color .ba-videorecorder-settings input[type=radio]:checked+span{border-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-message-message a{color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-imagegallery-button-inner{color:#fff}.ba-recorder-green-color .ba-commoncss-accent-color,.ba-recorder-green-color .ba-videorecorder-button-inner,.ba-recorder-green-color .ba-videorecorder-chooser-button-1,.ba-recorder-green-color .ba-videorecorder-chooser-button-3,.ba-recorder-green-color .ba-videorecorder-loader-label{color:#5daa96}.ba-recorder-green-color .ba-commoncss-accent-color-bg,.ba-recorder-green-color .ba-videorecorder-button-primary,.ba-recorder-green-color .ba-videorecorder-chooser-button-0,.ba-recorder-green-color .ba-videorecorder-chooser-button-2,.ba-recorder-green-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-green-color .ba-videorecorder-imagegallery-rightbutton{background-color:#5daa96}.ba-recorder-green-color .ba-commoncss-accent-color-border,.ba-recorder-green-color .ba-videorecorder-imagegallery-image:hover,.ba-recorder-green-color .ba-videorecorder-settings input[type=radio]:checked+span{border-color:#5daa96}.ba-recorder-green-color .ba-videorecorder-message-message a{color:#5daa96}.ba-recorder-green-color .ba-videorecorder-imagegallery-button-inner{color:#fff}.ba-videorecorder-dashboard{position:absolute;left:0;right:0;bottom:0}.ba-videorecorder-dashboard .ba-commoncss-icon-state-good{color:#0f0}.ba-videorecorder-dashboard .ba-commoncss-icon-state-bad{color:red}.ba-videorecorder-backbar{position:absolute;left:0;right:0;bottom:0;height:32px;background-color:#000;opacity:.1}.ba-videorecorder-controlbar{position:relative;left:0;right:0;bottom:0;height:32px;overflow:hidden;padding-left:16px;padding-right:16px}.ba-videorecorder-label-container{position:absolute;left:0;right:0;top:0}.ba-videorecorder-label-label{position:absolute;left:0;right:0;top:0;font-family:Arial,sans-serif;font-size:16px;font-weight:400;color:#fff;padding:7px;text-align:center}.ba-videorecorder-recording-indication{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;background:red;width:12px;height:12px;margin-left:12px;margin-right:12px;border-radius:12px}.ba-videorecorder-rightbutton-container{float:right;height:100%;cursor:pointer;padding-left:8px;padding-right:8px}.ba-videorecorder-centerbutton-container{-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-o-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);cursor:pointer;display:inline-block;position:relative;left:50%;height:100%;padding-left:8px;padding-right:8px;z-index:10}.ba-videorecorder-lefticon-container{float:left;height:100%}.ba-videorecorder-leftbutton-container{float:left;height:100%;cursor:pointer}.ba-videorecorder-button-primary{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;border-radius:2px;margin-left:10px;margin-right:10px;padding:4px;padding-left:8px;padding-right:8px;background-color:#8cf;color:#fff;font-family:Arial,sans-serif;font-weight:400;font-size:14px;border:none}.ba-videorecorder-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;color:#fff;cursor:pointer;font-size:14px;margin-left:4px;margin-right:4px;padding:3px;border:1px solid #fff;border-radius:2px}.ba-commoncss-icon-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;color:#fff;font-size:14px;margin-left:4px;margin-right:4px;padding:3px;padding-left:3px;padding-right:3px;border:1px solid #fff;border-radius:2px}.ba-videorecorder-button-selected{border:1px solid #8cf;color:#8cf;background-color:#fff}.ba-player-size-small .ba-videorecorder-lefticon-container{display:none}.ba-videorecorder-imagegallery-leftbutton{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);position:absolute;margin-left:10px;margin-right:10px;top:50%;left:0;width:20px;height:20px}.ba-videorecorder-imagegallery-rightbutton{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);position:absolute;margin-left:10px;margin-right:10px;top:50%;right:0;width:20px;height:20px}.ba-videorecorder-imagegallery-container{position:absolute;top:0;bottom:0;left:40px;right:40px}.ba-videorecorder-imagegallery-image{z-index:2;position:absolute;box-sizing:border-box;cursor:pointer;border:2px solid gray}.ba-videorecorder-imagegallery-image:hover{border:2px solid #fff}.ba-videorecorder-imagegallery-image-compat{cursor:pointer;background:#fff;opacity:.01;width:100%;height:100%}.ba-videorecorder-imagegallery-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;color:#ccc;font-size:14px}.ba-videorecorder-message-container{position:absolute;left:0;right:0;top:0;bottom:0;background-color:#000;opacity:.75}ba-videorecorder-message[ba-message=\"\"],ba-videorecorder-message[ba-message=null]{display:none}.ba-videorecorder-message-message{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);color:#fff;position:absolute;left:5px;right:5px;top:50%;text-align:center}.ba-videorecorder-message-message ul{list-style:none;padding-left:0}.ba-videorecorder-message-message a{border-bottom-style:dashed;border-bottom-width:1px;color:#fff;text-decoration:none}.ba-videorecorder-message-message a:hover{border-bottom-style:solid}.ba-videorecorder-container{display:inline-block;position:relative;background-color:#000;overflow:hidden}.ba-recorder-overlay{position:absolute;left:0;right:0;top:0;bottom:0}.ba-videorecorder-video{width:100%;height:100%;display:block;background-color:#000}.ba-videorecorder-norecorder{background-color:#000}.ba-videorecorder-container video::-webkit-media-controls-start-playback-button{display:none;-webkit-appearance:none;-moz-appearance:none}.ba-videorecorder-videorecorder-player{display:block;width:100%;height:100%}div.ba-videorecorder-disabled{cursor:not-allowed;-moz-opacity:.5;-khtml-opacity:.5;opacity:.5}div.ba-videorecorder-disabled *{cursor:not-allowed}.ba-videorecorder-settings{position:absolute;left:0;bottom:32px;color:#fff;margin:4px;padding:4px}.ba-videorecorder-settings-backbar{position:absolute;left:0;right:0;top:0;bottom:0;border-radius:4px;background-color:#000;opacity:.25;border:1px solid #fff}.ba-videorecorder-settings-front{position:relative;left:0;right:0;top:0;bottom:0;font-family:Arial,sans-serif;font-size:12px;max-height:14em;overflow:scroll}.ba-videorecorder-settings hr{background-color:#fff;border:none;height:1px;margin:2px;margin-left:8px;margin-right:8px}.ba-videorecorder-settings ul{margin:0;padding:0}.ba-videorecorder-settings li{list-style-type:none;padding:2px;text-align:left}.ba-videorecorder-settings label{cursor:pointer}.ba-videorecorder-settings input[type=radio]{display:none}.ba-videorecorder-settings span{cursor:pointer;width:4px;height:4px;background-color:#fff;border:3px solid #fff;border-radius:4px;margin:1px;box-sizing:content-box;top:2px;display:inline-block;position:relative}.ba-videorecorder-settings input[type=radio]:checked+span{border:3px solid #8cf;margin-right:5px}.ba-videorecorder-topmessage-container{position:absolute;left:0;right:0;top:0}.ba-videorecorder-topmessage-message{position:absolute;left:0;right:0;top:0;font-family:Arial,sans-serif;font-size:16px;font-weight:400;color:#fff;padding:8px;text-align:center}.ba-videorecorder-topmessage-background{background-color:#000;opacity:.1;width:100%;height:32px;position:absolute}ba-videorecorder-trimmer .ba-videorecorder-trimmer-container .ba-commoncss-accent-color{color:#8cf}ba-videorecorder-trimmer{position:absolute;bottom:20px;left:20px;right:20px}.ba-videorecorder-trimmer-container{display:flex;justify-content:space-between;padding:5px;background-color:rgba(50,50,50,.5)}.ba-videorecorder-trimmer-container button{background:0 0;border:none;cursor:pointer}.ba-videorecorder-trimmer-container .ba-commoncss-disabled{cursor:not-allowed}.ba-videorecorder-trimmer-container .ba-videorecorder-trimmer-button{border-radius:3px;margin:2px}.ba-videorecorder-trimmer-button-play{font-size:19px}.ba-videorecorder-trimmer-container .ba-videorecorder-trimmer-button-play i:before{font-size:unset;margin:unset}.ba-videorecorder-trimmer-right-button-container{display:flex;flex-direction:column}.ba-videorecorder-trimmer-container .ba-videorecorder-trimmer-button-trim{background-color:#8cf;color:#fff}.ba-videorecorder-trimmer-button.ba-commoncss-disabled{background-color:#333;color:#555}.ba-videorecorder-trimmer-container .ba-videorecorder-trimmer-button-skip{background-color:#777;color:#fff}.ba-videorecorder-trimmer-progress-bar{flex:1;position:relative;background-color:#000;height:34px;margin:0 13px}.ba-videorecorder-trimmer-playhead{position:absolute;height:100%;width:1px;box-shadow:0 0 2px 0 rgba(0,0,0,.25);background-color:red}.ba-videorecorder-trimmer-selection{position:absolute;border-style:solid;border-width:2px 8px;border-radius:2px;top:-2px;height:100%;box-shadow:inset 2px 2px 2px rgba(0,0,0,.15),2px 2px 2px rgba(0,0,0,.15)}.ba-videorecorder-trimmer-snapshots{height:100%;width:100%;position:absolute;overflow:hidden;display:flex}.ba-imageviewer-red-color .ba-imageviewer-button-inner,.ba-imageviewer-red-color .ba-imageviewer-image-title{color:#eb6a74}.ba-imageviewer-red-color .ba-imageviewer-rerecord-button{background-color:#eb6a74}.ba-imageviewer-blue-color .ba-imageviewer-button-inner,.ba-imageviewer-blue-color .ba-imageviewer-image-title{color:#2a74eb}.ba-imageviewer-blue-color .ba-imageviewer-rerecord-button{background-color:#2a74eb}.ba-imageviewer-green-color .ba-imageviewer-button-inner,.ba-imageviewer-green-color .ba-imageviewer-image-title{color:#5daa96}.ba-imageviewer-green-color .ba-imageviewer-rerecord-button{background-color:#5daa96}.ba-imageviewer-dashboard{position:absolute;left:0;right:0;bottom:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out}.ba-imageviewer-dashboard-hidden{opacity:0}.ba-imageviewer-backbar{position:absolute;left:0;right:0;bottom:0;height:30px;background-color:#000;opacity:.7}.ba-imageviewer-controlbar{position:relative;left:0;right:0;bottom:0;height:30px;overflow:hidden}.ba-imageviewer-leftbutton-container{float:left;width:50px;height:100%;cursor:pointer}.ba-imageviewer-rightbutton-container{cursor:pointer;padding:0 8px}.ba-imageviewer-noie8 .ba-imageviewer-rightbutton-container{float:right;width:auto;height:100%}.ba-imageviewer-ie8 .ba-imageviewer-rightbutton-container{float:right;width:auto;height:0}.ba-imageviewer-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;color:#fff;font-size:14px}.ba-imageviewer-button-text{font-family:Arial;font-weight:700}.ba-imageviewer-ie8 .ba-imageviewer-button-inner{margin-top:6px}.ba-imageviewer-image-title{color:#fff;font-family:sans-serif,Arial;font-weight:300;font-size:12px;float:left;letter-spacing:.1em;line-height:30px;margin:0 0 0 10px}.ba-imageviewer-fullscreen-view .ba-imageviewer-controlbar{bottom:0;position:fixed;width:100%;z-index:1010}.ba-imageviewer-message-container{position:absolute;left:0;right:0;top:0;bottom:0;background-color:#000;opacity:.75}.ba-imageviewer-message-message{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);color:#fff;position:absolute;left:5px;right:5px;top:50%;text-align:center}.ba-imageviewer-topmessage-container{position:absolute;left:0;right:0;top:0}.ba-imageviewer-topmessage-message{position:absolute;left:0;right:0;top:0;font-family:Arial,sans-serif;font-size:16px;font-weight:400;color:#fff;padding:8px;text-align:center}.ba-imageviewer-topmessage-background{background-color:#000;height:32px;opacity:.1;position:absolute;width:100%}.ba-imageviewer-container{display:inline-block;position:relative;overflow:hidden}.ba-imageviewer-overlay{position:absolute;left:0;right:0;top:0;bottom:0}.ba-imageviewer-image{width:100%;display:block}.ba-imageviewer-stretch-height .ba-imageviewer-container,.ba-imageviewer-stretch-width .ba-imageviewer-container{height:100%;overflow:hidden;position:relative;max-width:100%;max-height:100%;width:100%}.ba-imageviewer-stretch-height .ba-imageviewer-image{position:absolute;transform:translate(-50%,-50%);top:50%;left:50%;min-height:100%;min-width:100%;width:auto}.ba-imageviewer-stretch-width .ba-imageviewer-image{position:absolute;transform:translate(-50%,-50%);top:50%;left:50%;min-height:100%;min-width:100%;width:auto}.ba-imageviewer-stretch-height,.ba-imageviewer-stretch-width{display:inline-block;height:100%;width:100%}.ba-imageviewer-disabled{cursor:not-allowed;-moz-opacity:.5;-khtml-opacity:.5;opacity:.5}.ba-imageviewer-disabled *{cursor:not-allowed}.ba-player-red-color .ba-audioplayer-button-inner>i,.ba-player-red-color .ba-audioplayer-dashboard,.ba-player-red-color .ba-audioplayer-title{color:#eb6a74}.ba-player-red-color .ba-audioplayer-progressbar-position,.ba-player-red-color .ba-audioplayer-rerecord-button,.ba-player-red-color .ba-audioplayer-volumebar-position{background-color:#eb6a74}.ba-player-red-color .ba-audioplayer-volumebar-inner{background-color:#979797;background-color:rgba(255,255,255,.3)}.ba-player-blue-color .ba-audioplayer-button-inner>i,.ba-player-blue-color .ba-audioplayer-dashboard,.ba-player-blue-color .ba-audioplayer-title{color:#2a74eb}.ba-player-blue-color .ba-audioplayer-progressbar-position,.ba-player-blue-color .ba-audioplayer-rerecord-button,.ba-player-blue-color .ba-audioplayer-volumebar-position{background-color:#2a74eb}.ba-player-blue-color .ba-audioplayer-volumebar-inner{background-color:#979797;background-color:rgba(255,255,255,.3)}.ba-player-green-color .ba-audioplayer-button-inner>i,.ba-player-green-color .ba-audioplayer-dashboard,.ba-player-green-color .ba-audioplayer-title{color:#5daa96}.ba-player-green-color .ba-audioplayer-progressbar-position,.ba-player-green-color .ba-audioplayer-rerecord-button,.ba-player-green-color .ba-audioplayer-volumebar-position{background-color:#5daa96}.ba-player-green-color .ba-audioplayer-volumebar-inner{background-color:#979797;background-color:rgba(255,255,255,.3)}.ba-audioplayer-container{box-sizing:border-box;height:45px;min-height:45px;min-width:320px}.ba-audioplayer-audio-canvas{display:none;position:absolute;bottom:30px;background-color:#000}.ba-audioplayer-dashboard{position:absolute;left:0;right:0;bottom:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out}.ba-audioplayer-progressbar{cursor:pointer;transition:height .1s ease-in-out;-moz-transition:height .1s ease-in-out;-webkit-transition:height .1s ease-in-out;-o-transition:height .1s ease-in-out;-ms-transition:height .1s ease-in-out;height:9px;background-color:#999}.ba-audioplayer-progressbar-inner.ba-player-disabled,.ba-audioplayer-progressbar-inner.ba-player-disabled .ba-audioplayer-progressbar-cache,.ba-audioplayer-progressbar-inner.ba-player-disabled .ba-audioplayer-progressbar-position{cursor:not-allowed}.ba-audioplayer-progressbar-small{height:3px}.ba-audioplayer-progressbar-position{position:absolute;left:0;transition:height .1s ease-in-out;-moz-transition:height .1s ease-in-out;-webkit-transition:height .1s ease-in-out;-o-transition:height .1s ease-in-out;-ms-transition:height .1s ease-in-out;background-color:#8cf;height:9px}.ba-audioplayer-progressbar-small .ba-audioplayer-progressbar-position{height:3px}.ba-audioplayer-progressbar-cache{position:absolute;left:0;transition:height .1s ease-in-out;-moz-transition:height .1s ease-in-out;-webkit-transition:height .1s ease-in-out;-o-transition:height .1s ease-in-out;-ms-transition:height .1s ease-in-out;background-color:#eee;height:9px}.ba-audioplayer-progressbar-small .ba-audioplayer-progressbar-cache{height:3px}.ba-audioplayer-progressbar-button{-moz-border-radius:5px;-webkit-border-radius:5px;border-radius:5px;background-color:#fff;box-sizing:content-box;border:1px solid #999;position:absolute;right:-5px;top:-2px;z-index:1;width:11px;height:11px}.ba-audioplayer-progressbar-small .ba-audioplayer-progressbar-button{display:none}.ba-audioplayer-backbar{position:absolute;left:0;right:0;bottom:0;height:30px;background-color:#000;opacity:.7}.ba-audioplayer-controlbar{position:relative;left:0;right:0;bottom:0;height:30px;overflow:hidden}.ba-audioplayer-leftbutton-container{float:left;width:50px;height:100%;cursor:pointer}.ba-audioplayer-rightbutton-container{cursor:pointer;padding:0 8px}.ba-audioplayer-noie8 .ba-audioplayer-rightbutton-container{float:right;width:auto;height:100%}.ba-audioplayer-ie8 .ba-audioplayer-rightbutton-container{float:right;width:auto;height:0}.ba-audioplayer-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;display:inline-flex;color:#fff;font-size:14px}.ba-audioplayer-leftbutton-container .ba-audioplayer-button-inner{left:25%}.ba-audioplayer-button-text{font-family:Arial;font-weight:700}.ba-audioplayer-ie8 .ba-audioplayer-button-inner{margin-top:6px}.ba-audioplayer-noie8 .ba-audioplayer-time-container{float:left;width:95px;height:100%;text-align:center;font-family:Arial,sans-serif;font-size:13px;color:#fff}.ba-audioplayer-ie8 .ba-audioplayer-time-container{float:left;width:95px;height:50%;text-align:center;font-family:Arial,sans-serif;font-size:13px;color:#fff;margin-top:6px}.ba-audioplayer-time-value{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;float:left;width:40px}.ba-audioplayer-time-sep{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;float:left;width:15px}.ba-audioplayer-noie8 .ba-audioplayer-volumebar{margin-left:8px;margin-right:13px}.ba-audioplayer-noie8 .ba-audioplayer-volumebar{float:right;width:100px;height:100%}.ba-audioplayer-ie8 .ba-audioplayer-volumebar{float:right;width:100px;height:50%;margin-top:10px;margin-right:15px}.ba-audioplayer-volumebar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-top-left-radius:4px;border-top-right-radius:4px;cursor:pointer;background-color:#999;height:8px}.ba-audioplayer-volumebar-position{border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-top-left-radius:4px;border-top-right-radius:4px;position:absolute;left:0;background-color:#8cf;height:100%}.ba-audioplayer-volumebar-button{-moz-border-radius:6px;-webkit-border-radius:6px;border-radius:6px;cursor:pointer;background-color:#fff;box-sizing:content-box;border:1px solid #999;position:absolute;right:-6px;top:-2px;z-index:1;width:11px;height:11px}.ba-audioplayer-title{color:#fff;font-family:sans-serif,Arial;font-weight:300;font-size:12px;float:left;letter-spacing:.1em;line-height:30px;margin:0 0 0 10px}.ba-audioplayer-message-container{position:absolute;left:0;right:0;top:0;bottom:0;background-color:#000;opacity:.75}.ba-audioplayer-message-message{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);color:#fff;position:absolute;left:5px;right:5px;top:50%;text-align:center}.ba-audioplayer-container{background-color:#000;display:inline-block;padding-bottom:39px;position:relative;overflow:hidden}.ba-audioplayer-container canvas{position:absolute}.ba-audioplayer-audio{width:100%;display:block}.ba-audioplayer-container audio::-webkit-media-controls-start-playback-button{display:none;-webkit-appearance:none;-moz-appearance:none}.ba-player-disabled{cursor:not-allowed;-moz-opacity:.5;-khtml-opacity:.5;opacity:.5}.ba-player-disabled *{cursor:not-allowed}.ba-audiorecorder{padding-bottom:32px}.ba-popup-helper-overlay-background{background-color:#fff;opacity:.85;position:fixed;left:0;top:0;right:0;bottom:0;z-index:10000;cursor:default}.ba-popup-helper-overlay{background-color:#000;opacity:1;z-index:10001;padding:4px 4px 0 4px;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);margin-right:-50%;position:fixed}.ba-popup-helper-overlay-inner{width:100%;height:100%}.ba-popup-helper-overlay-body{overflow:hidden}/*!\nbetajs-media-components - v0.0.291 - 2022-01-08\nCopyright (c) Ziggeo,Oliver Friedmann,Rashad Aliyev\nApache-2.0 Software License.\n*/.ba-player-red-color.ba-player-theme-modern .ba-player-button-inactive .ba-commoncss-icon-subtitle{color:#eb6a74;background-color:transparent}.ba-player-red-color.ba-player-theme-modern .ba-player-theme-modern-rightbutton-container.ba-commoncss-settings-visible{background-color:#eb6a74}.ba-player-red-color .ba-player-theme-modern-button-inner,.ba-player-red-color .ba-player-theme-modern-title{color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-theme-modern-button-inner,.ba-player-red-color.ba-videoplayer-noie8 .ba-player-theme-modern-playbutton-button::after{color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-theme-modern-playbutton-container{border-color:#eb6a74}.ba-player-red-color .ba-player-button-active,.ba-player-red-color .ba-player-theme-modern-playbutton-duration,.ba-player-red-color .ba-player-theme-modern-progressbar-position,.ba-player-red-color .ba-player-theme-modern-rerecord-button,.ba-player-red-color .ba-player-theme-modern-volumebar-position{background-color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-theme-modern-share-action-container .ba-player-theme-modern-button-inner{color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-theme-modern-rightbutton-container.ba-player-airplay-container svg path{fill:#eb6a74}.ba-player-blue-color.ba-player-theme-modern .ba-player-button-inactive .ba-commoncss-icon-subtitle{color:#2a74eb;background-color:transparent}.ba-player-blue-color.ba-player-theme-modern .ba-player-theme-modern-rightbutton-container.ba-commoncss-settings-visible{background-color:#2a74eb}.ba-player-blue-color .ba-player-theme-modern-button-inner,.ba-player-blue-color .ba-player-theme-modern-title{color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-theme-modern-button-inner,.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-theme-modern-playbutton-button::after{color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-theme-modern-playbutton-container{border-color:#2a74eb}.ba-player-blue-color .ba-player-button-active,.ba-player-blue-color .ba-player-theme-modern-playbutton-duration,.ba-player-blue-color .ba-player-theme-modern-progressbar-position,.ba-player-blue-color .ba-player-theme-modern-rerecord-button,.ba-player-blue-color .ba-player-theme-modern-volumebar-position{background-color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-theme-modern-share-action-container .ba-player-theme-modern-button-inner{color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-theme-modern-rightbutton-container.ba-player-airplay-container svg path{fill:#2a74eb}.ba-player-green-color.ba-player-theme-modern .ba-player-button-inactive .ba-commoncss-icon-subtitle{color:#5da894;background-color:transparent}.ba-player-green-color.ba-player-theme-modern .ba-player-theme-modern-rightbutton-container.ba-commoncss-settings-visible{background-color:#5da894}.ba-player-green-color .ba-player-theme-modern-button-inner,.ba-player-green-color .ba-player-theme-modern-title{color:#5da894}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-theme-modern-button-inner,.ba-player-green-color.ba-videoplayer-noie8 .ba-player-theme-modern-playbutton-button::after{color:#5da894}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-theme-modern-playbutton-container{border-color:#5da894}.ba-player-green-color .ba-player-button-active,.ba-player-green-color .ba-player-theme-modern-playbutton-duration,.ba-player-green-color .ba-player-theme-modern-progressbar-position,.ba-player-green-color .ba-player-theme-modern-rerecord-button,.ba-player-green-color .ba-player-theme-modern-volumebar-position{background-color:#5da894}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-theme-modern-share-action-container .ba-player-theme-modern-button-inner{color:#5da894}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-theme-modern-rightbutton-container.ba-player-airplay-container svg path{fill:#5da894}.ba-player-theme-modern-dashboard{position:absolute;left:0;right:0;bottom:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;background-color:#ecebed;height:40px;opacity:.9;overflow:hidden;font-family:Arial,sans-serif}.ba-player-theme-modern-dashboard .ba-player-theme-modern-rightbutton-container.ba-player-airplay-container{height:28px;padding:12px 10px 0 10px;width:auto;box-sizing:border-box}.ba-player-theme-modern-dashboard .ba-player-theme-modern-rightbutton-container.ba-player-airplay-container svg path{fill:#000}.ba-player-theme-modern-dashboard .ba-player-button-active .ba-player-theme-modern-settings-button{color:#ecebed}.ba-player-theme-modern-leftbutton-container{float:left;width:40px;height:100%;cursor:pointer;box-sizing:content-box;border-right:1px solid #dbdbdb}.ba-videoplayer-noie8 .ba-player-theme-modern-rightbutton-container{float:right;width:40px;height:100%;cursor:pointer;box-sizing:content-box;border-left:1px solid #dbdbdb}.ba-videoplayer-ie8 .ba-player-theme-modern-rightbutton-container{float:right;width:40px;height:50%;cursor:pointer;box-sizing:content-box;border-left:1px solid #dbdbdb}.ba-player-theme-modern .ba-player-button-inactive .ba-commoncss-icon-subtitle,.ba-videoplayer-noie8 .ba-player-theme-modern-button-inner{cursor:pointer;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;color:#000;font-size:13px}.ba-videoplayer-ie8 .ba-player-theme-modern-button-inner{cursor:pointer;margin-top:12px;text-align:center;color:#000;font-size:13px}.ba-player-theme-modern-time-container{float:left;width:100px;height:100%;text-align:center;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:13px;color:#666;box-sizing:content-box;border-right:1px solid #dbdbdb}.ba-videoplayer-ie8 .ba-player-theme-modern-time-container{margin-top:11px}.ba-player-theme-modern-time-value{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;float:left;width:100px}.ba-videoplayer-noie8 .ba-player-theme-modern-volumebar{float:right;width:60px;height:100%;margin-right:12px}.ba-videoplayer-ie8 .ba-player-theme-modern-volumebar{float:right;width:60px;height:50%;margin-top:16px;margin-right:12px}.ba-player-theme-modern-volumebar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;cursor:pointer;background-color:#878787;height:6px}.ba-player-theme-modern-volumebar-position{border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;position:absolute;left:0;background-color:#000;height:100%}.ba-videoplayer-noie8 .ba-player-theme-modern-progressbar{overflow:hidden;height:100%;padding-left:12px;padding-right:12px}.ba-videoplayer-ie8 .ba-player-theme-modern-progressbar{overflow:hidden;height:50%;padding-left:12px;padding-right:12px;margin-right:40px;margin-top:6px}.ba-player-theme-modern-progressbar-cache{position:absolute;left:0;border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;cursor:pointer;background-color:#bbb;height:6px}.ba-player-theme-modern-progressbar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;cursor:pointer;background-color:#878787;height:6px;overflow:hidden}.ba-player-theme-modern-progressbar.ba-player-disabled,.ba-player-theme-modern-progressbar.ba-player-disabled .ba-player-theme-modern-progressbar-cache,.ba-player-theme-modern-progressbar.ba-player-disabled .ba-player-theme-modern-progressbar-inner,.ba-player-theme-modern-progressbar.ba-player-disabled .ba-player-theme-modern-progressbar-position{cursor:not-allowed}.ba-player-theme-modern-progressbar-position{border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;background-color:#000;position:absolute;height:100%}.ba-player-theme-modern-progressbar-marker{position:absolute;background-color:#000;height:100%}.ba-player-theme-modern-button-text{font-family:Arial;font-weight:700}.ba-videoplayer-ie8 .ba-player-theme-modern-title-container{display:none}.ba-player-theme-modern-title-container{position:absolute;left:0;right:0;top:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;width:100%}.ba-player-theme-modern-title-container>p{color:#666;background-color:#ecebed;background-color:rgba(255,255,255,.7);position:relative;margin:auto;height:30px;line-height:30px;text-align:center}.ba-player-size-small .ba-player-theme-modern-time-container{display:none}.ba-player-size-small .ba-player-theme-modern-volumebar{display:none}.ba-player-theme-modern-cast-button-container button{-moz-opacity:.7;-khtml-opacity:.7;opacity:.7;background:0 0;border:none;cursor:pointer;padding:11px 10px 0 10px}.ba-settings-overlay-inner{bottom:41px}.ba-player-size-medium .ba-player-theme-modern-time-value>span,.ba-player-size-medium.ba-videoplayer-noie8 .ba-player-theme-modern-volumebar{display:none}.ba-player-size-medium .ba-player-theme-modern-time-container,.ba-player-size-medium .ba-player-theme-modern-time-value{width:50px}.ba-player-theme-modern-rightbutton-container.ba-player-theme-modern-primary-button-container{width:auto}.ba-player-theme-modern-primary-button{padding:0 10px}.ba-player-fullscreen-view video::-webkit-media-controls-overlay-enclosure{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-enclosure{display:none}.ba-player-fullscreen-view video::-webkit-media-controls{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-panel{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-play-button{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-current-time-display{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-time-remaining-display{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-timeline{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-mute-button{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-volume-slider{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-fullscreen-button{display:none}.ba-player-fullscreen-view video::-internal-media-controls-download-button{display:none}.ba-player-fullscreen-view video::-moz-list-bullet,.ba-player-fullscreen-view video::-moz-list-number{display:none}.ba-player-fullscreen-view video::-moz-meter-bar{display:none}.ba-player-fullscreen-view video:fullscreen:not(:root){display:none}.ba-player-fullscreen-view .ba-videoplayer-dashboard{bottom:0}.ba-player-fullscreen-view .ba-videoplayer-title-block{top:0}.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-dashboard,.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-title-block{position:fixed;z-index:100}.ba-videoplayer-container.ba-player-fullscreen-view{min-width:100%;position:absolute;min-height:fit-content}.ba-videoplayer-container.ba-player-fullscreen-view>.ba-videoplayer-overlay{position:fixed}.ba-player-theme-modern.ba-videoplayer-container .ba-player-text-tracks-overlay{position:absolute;left:0;right:0;bottom:42px;transition:bottom .5s ease-in-out;-moz-transition:bottom .5s ease-in-out;-webkit-transition:bottom .5s ease-in-out;-o-transition:bottom .5s ease-in-out;-ms-transition:bottom .5s ease-in-out}.ba-player-theme-modern.ba-videoplayer-container .ba-player-text-tracks-overlay .ba-commoncss-options-popup{bottom:0}.ba-player-theme-modern.ba-videoplayer-container .ba-player-track-dashboard-hidden.ba-player-text-tracks-overlay{bottom:5px}.ba-recorder-theme-modern .ba-videorecorder-chooser-icon-container{margin:16px;color:#979797;font-size:32px}.ba-recorder-theme-modern .ba-videorecorder-chooser-button-0,.ba-recorder-theme-modern .ba-videorecorder-chooser-button-2{background-color:#979797}.ba-recorder-theme-modern .ba-videorecorder-chooser-button-1,.ba-recorder-theme-modern .ba-videorecorder-chooser-button-3{color:#979797}.ba-recorder-red-color.ba-recorder-theme-modern .ba-videorecorder-button-inner:hover,.ba-recorder-red-color.ba-recorder-theme-modern .ba-videorecorder-button-selected{color:#eb6a74}.ba-recorder-red-color.ba-recorder-theme-modern .ba-videorecorder-button-primary{background-color:#eb6a74}.ba-recorder-red-color.ba-recorder-theme-modern .ba-videorecorder-settings input[type=radio]:checked+span{border-color:#eb6a74}.ba-recorder-red-color .ba-recorder-loader-label,.ba-recorder-red-color .ba-videorecorder-chooser-button-1,.ba-recorder-red-color .ba-videorecorder-chooser-button-3,.ba-recorder-red-color .ba-videorecorder-chooser-icon-container{color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-chooser-button-0,.ba-recorder-red-color .ba-videorecorder-chooser-button-2,.ba-recorder-red-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-red-color .ba-videorecorder-imagegallery-rightbutton{background-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-button-selected,.ba-recorder-red-color .ba-videorecorder-imagegallery-image:hover{border-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-message-message a{color:#eb6a74}.ba-recorder-blue-color.ba-recorder-theme-modern .ba-videorecorder-button-inner:hover,.ba-recorder-blue-color.ba-recorder-theme-modern .ba-videorecorder-button-selected{color:#2a74eb}.ba-recorder-blue-color.ba-recorder-theme-modern .ba-videorecorder-button-primary{background-color:#2a74eb}.ba-recorder-blue-color.ba-recorder-theme-modern .ba-videorecorder-settings input[type=radio]:checked+span{border-color:#2a74eb}.ba-recorder-blue-color .ba-recorder-loader-label,.ba-recorder-blue-color .ba-videorecorder-chooser-button-1,.ba-recorder-blue-color .ba-videorecorder-chooser-button-3,.ba-recorder-blue-color .ba-videorecorder-chooser-icon-container{color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-chooser-button-0,.ba-recorder-blue-color .ba-videorecorder-chooser-button-2,.ba-recorder-blue-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-blue-color .ba-videorecorder-imagegallery-rightbutton{background-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-button-selected,.ba-recorder-blue-color .ba-videorecorder-imagegallery-image:hover{border-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-message-message a{color:#2a74eb}.ba-recorder-green-color.ba-recorder-theme-modern .ba-videorecorder-button-inner:hover,.ba-recorder-green-color.ba-recorder-theme-modern .ba-videorecorder-button-selected{color:#5dbb96}.ba-recorder-green-color.ba-recorder-theme-modern .ba-videorecorder-button-primary{background-color:#5dbb96}.ba-recorder-green-color.ba-recorder-theme-modern .ba-videorecorder-settings input[type=radio]:checked+span{border-color:#5dbb96}.ba-recorder-green-color .ba-recorder-loader-label,.ba-recorder-green-color .ba-videorecorder-chooser-button-1,.ba-recorder-green-color .ba-videorecorder-chooser-button-3,.ba-recorder-green-color .ba-videorecorder-chooser-icon-container{color:#5dbb96}.ba-recorder-green-color .ba-videorecorder-chooser-button-0,.ba-recorder-green-color .ba-videorecorder-chooser-button-2,.ba-recorder-green-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-green-color .ba-videorecorder-imagegallery-rightbutton{background-color:#5dbb96}.ba-recorder-green-color .ba-videorecorder-button-selected,.ba-recorder-green-color .ba-videorecorder-imagegallery-image:hover{border-color:#5dbb96}.ba-recorder-green-color .ba-videorecorder-message-message a{color:#5dbb96}.ba-recorder-theme-modern .ba-videorecorder-backbar{position:absolute;left:0;right:0;bottom:0;height:48px;background-color:#000;opacity:.5}.ba-recorder-theme-modern .ba-videorecorder-controlbar{position:relative;left:0;right:0;bottom:0;height:48px;overflow:hidden;padding-left:16px;padding-right:16px}.ba-recorder-theme-modern .ba-videorecorder-label-label{position:absolute;left:0;right:0;top:0;font-family:Arial,sans-serif;font-size:15px;font-weight:700;color:#fff;padding:15px;text-align:center}.ba-recorder-theme-modern .ba-videorecorder-button-primary{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;border-radius:3px;margin-left:5px;margin-right:5px;padding:8px;padding-left:16px;padding-right:16px;background-color:#979797;color:#fff;font-family:Arial,sans-serif;font-weight:700;font-size:14px;border:none}.ba-recorder-theme-modern .ba-videorecorder-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;color:#fff;cursor:pointer;font-size:20px;margin-left:5px;margin-right:5px;padding:3px;border:1px solid #fff;border-radius:4px}.ba-recorder-theme-modern .ba-commoncss-icon-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;color:#fff;font-size:20px;margin-left:5px;margin-right:5px;padding:3px;padding-left:6px;padding-right:6px;border:1px solid #fff;border-radius:4px}.ba-recorder-theme-modern .ba-videorecorder-button-selected{border:1px solid #979797;color:#979797;background-color:#fff}.ba-recorder-theme-modern.ba-videorecorder-size-small .ba-videorecorder-leftbutton-container{width:40px}.ba-recorder-theme-modern.ba-videorecorder-size-small .ba-videorecorder-leftbutton-container .ba-videorecorder-button-inner{font-size:17px}.ba-recorder-theme-modern.ba-videorecorder-size-small .ba-videorecorder-lefticon-container{width:45px}.ba-recorder-theme-modern.ba-videorecorder-size-small .ba-videorecorder-lefticon-container .ba-commoncss-icon-inner{font-size:17px}.ba-recorder-theme-modern .ba-videorecorder-imagegallery-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;color:#fff;font-size:13px;background-color:#000;opacity:.5;padding:4px;border-radius:3px}.ba-recorder-theme-modern .ba-videorecorder-imagegallery-leftbutton .ba-videorecorder-imagegallery-button-inner{padding-left:2px}.ba-recorder-theme-modern .ba-videorecorder-imagegallery-leftbutton{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);position:absolute;margin-left:14px;margin-right:14px;top:50%;left:0;width:24px;height:24px}.ba-recorder-theme-modern .ba-videorecorder-imagegallery-rightbutton{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);position:absolute;margin-left:14px;margin-right:14px;top:50%;right:0;width:24px;height:24px}.ba-recorder-theme-modern .ba-videorecorder-imagegallery-container{position:absolute;top:0;bottom:0;left:52px;right:52px}.ba-recorder-theme-modern .ba-videorecorder-settings{position:absolute;left:0;bottom:48px;color:#fff;margin:4px;padding:4px}.ba-recorder-theme-modern .ba-videorecorder-settings-backbar{position:absolute;left:0;right:0;top:0;bottom:0;border-radius:3px;background-color:#000;opacity:.5;border:none}.ba-recorder-theme-modern .ba-videorecorder-settings hr{border-top:none;border-bottom-color:#fff;margin:2px;margin-left:48px;margin-right:48px}.ba-recorder-theme-modern .ba-videorecorder-settings li{list-style-type:none;padding:8px}.ba-recorder-theme-modern .ba-videorecorder-settings input[type=radio]:checked+span{border:3px solid #979797}.ba-recorder-theme-modern .ba-videorecorder-topmessage-message{position:absolute;left:0;right:0;top:0;font-family:Arial,sans-serif;font-size:15px;font-weight:700;color:#fff;padding:8.5px;text-align:center}.ba-recorder-theme-modern .ba-videorecorder-topmessage-background{background-color:#000;opacity:.3;width:100%;height:32px;position:absolute}.ba-imageviewer-theme-modern-red-color .ba-imageviewer-title,.ba-imageviewer-theme-modern-red-color.ba-imageviewer-ie8 .ba-imageviewer-button-inner,.ba-imageviewer-theme-modern-red-color.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#eb6a74}.ba-imageviewer-theme-modern-red-color .ba-imageviewer-rerecord-button{background-color:#eb6a74}.ba-imageviewer-theme-modern-blue-color .ba-imageviewer-title,.ba-imageviewer-theme-modern-blue-color.ba-imageviewer-ie8 .ba-imageviewer-button-inner,.ba-imageviewer-theme-modern-blue-color.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#2a74eb}.ba-imageviewer-theme-modern-blue-color .ba-imageviewer-rerecord-button{background-color:#2a74eb}.ba-imageviewer-theme-modern-green-color .ba-imageviewer-title,.ba-imageviewer-theme-modern-green-color.ba-imageviewer-ie8 .ba-imageviewer-button-inner,.ba-imageviewer-theme-modern-green-color.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#5da894}.ba-imageviewer-theme-modern-green-color .ba-imageviewer-rerecord-button{background-color:#5da894}.ba-imageviewer-theme-modern .ba-imageviewer-dashboard{position:absolute;left:0;right:0;bottom:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;background-color:#ecebed;height:40px;opacity:.9;overflow:hidden}.ba-imageviewer-theme-modern .ba-imageviewer-dashboard-hidden{opacity:0}.ba-imageviewer-theme-modern .ba-imageviewer-leftbutton-container{float:left;width:40px;height:100%;cursor:pointer;box-sizing:content-box;border-right:1px solid #dbdbdb}.ba-imageviewer-theme-modern.ba-imageviewer-noie8 .ba-imageviewer-rightbutton-container{float:right;width:40px;height:100%;cursor:pointer;box-sizing:content-box;border-left:1px solid #dbdbdb}.ba-imageviewer-theme-modern.ba-imageviewer-ie8 .ba-imageviewer-rightbutton-container{float:right;width:40px;height:50%;cursor:pointer;box-sizing:content-box;border-left:1px solid #dbdbdb}.ba-imageviewer-theme-modern.ba-imageviewer-noie8 .ba-imageviewer-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;color:#000;font-size:13px}.ba-imageviewer-theme-modern.ba-imageviewer-ie8 .ba-imageviewer-button-inner{margin-top:12px;text-align:center;color:#000;font-size:13px}.ba-imageviewer-theme-modern .ba-imageviewer-button-inner{cursor:pointer}.ba-imageviewer-theme-modern .ba-imageviewer-button-text{font-family:Arial;font-weight:700}.ba-imageviewer-theme-modern.ba-imageviewer-ie8 .ba-imageviewer-image-title-container{display:none}.ba-imageviewer-theme-modern .ba-imageviewer-image-title-container{position:absolute;left:0;right:0;top:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;width:100%}.ba-imageviewer-theme-modern .ba-imageviewer-image-title-container>p{color:#666;background-color:#ecebed;background-color:rgba(255,255,255,.7);position:relative;margin:auto;height:30px;line-height:30px;text-align:center}.ba-imageviewer-fullscreen-view.ba-imageviewer-theme-modern .ba-imageviewer-dashboard,.ba-imageviewer-fullscreen-view.ba-imageviewer-theme-modern .ba-imageviewer-image-title-container{position:fixed;width:100%;z-index:1005}.ba-imageviewer-fullscreen-view.ba-imageviewer-theme-modern .ba-imageviewer-dashboard{bottom:0}.ba-imageviewer-fullscreen-view.ba-imageviewer-theme-modern .ba-imageviewer-image-title-container{top:0}.ba-audioplayer-container{box-sizing:border-box;min-width:320px}.ba-audioplayer-container.ba-player-has-title{min-height:70px}.ba-audioplayer-container.ba-player-no-title{min-height:40px}.ba-audioplayer-container.ba-player-theme-modern.ba-player-size-small .ba-player-theme-modern-time-container{display:block}.ba-audioplayer-container.ba-player-theme-modern .ba-player-size-small .ba-player-theme-modern-volumebar,.ba-audioplayer-container.ba-player-theme-modern.ba-player-size-medium .ba-player-theme-modern-volumebar{display:block}.ba-audioplayer-container.ba-player-theme-modern .ba-player-size-small .ba-player-theme-modern-volume-button-container,.ba-audioplayer-container.ba-player-theme-modern.ba-player-size-medium .ba-player-theme-modern-volume-button-container{display:block}.ba-player-theme-modern-dashboard{position:absolute;left:0;right:0;bottom:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;background-color:#ecebed;border-top:1px solid #dbdbdb;box-sizing:content-box;height:40px;opacity:.9;overflow:hidden}.ba-audioplayer-noie8 .ba-player-theme-modern-rightbutton-container{float:right;width:40px;height:100%;cursor:pointer;box-sizing:content-box;border-left:1px solid #dbdbdb}.ba-audioplayer-ie8 .ba-player-theme-modern-rightbutton-container{float:right;width:40px;height:50%;cursor:pointer;box-sizing:content-box;border-left:1px solid #dbdbdb}.ba-audioplayer-noie8 .ba-player-theme-modern-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;color:#000;font-size:13px}.ba-audioplayer-ie8 .ba-player-theme-modern-button-inner{margin-top:12px;text-align:center;color:#000;font-size:13px}.ba-audioplayer-ie8 .ba-player-theme-modern-time-container{margin-top:11px}.ba-audioplayer-noie8 .ba-player-theme-modern-volumebar{float:right;width:60px;height:100%;margin-right:12px}.ba-audioplayer-ie8 .ba-player-theme-modern-volumebar{float:right;width:60px;height:50%;margin-top:16px;margin-right:12px}.ba-audioplayer-noie8 .ba-player-theme-modern-progressbar{overflow:hidden;height:100%;padding-left:12px;padding-right:12px}.ba-audioplayer-ie8 .ba-player-theme-modern-progressbar{overflow:hidden;height:50%;padding-left:12px;padding-right:12px;margin-right:40px;margin-top:6px}.ba-audioplayer-ie8 .ba-player-theme-modern-title-container{display:none}/*!\nbetajs-media-components - v0.0.291 - 2022-01-08\nCopyright (c) Ziggeo,Oliver Friedmann,Rashad Aliyev\nApache-2.0 Software License.\n*/.ba-player-red-color .ba-player-cube-theme-button-inner>i,.ba-player-red-color .ba-player-cube-theme-dashboard,.ba-player-red-color .ba-player-cube-theme-title{color:#eb6a74}.ba-player-red-color .ba-player-button-active .ba-player-cube-theme-button-inner>i{color:#eee}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-cube-theme-playbutton-container{border-color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-cube-theme-playbutton-button::after{color:#eb6a74}.ba-player-red-color .ba-player-button-active,.ba-player-red-color .ba-player-cube-theme-playbutton-duration,.ba-player-red-color .ba-player-cube-theme-primary-button,.ba-player-red-color .ba-player-cube-theme-progressbar-position,.ba-player-red-color .ba-player-cube-theme-rerecord-button,.ba-player-red-color .ba-player-cube-theme-stream-label,.ba-player-red-color .ba-player-cube-theme-volumebar-position{background-color:#eb6a74}.ba-player-red-color .ba-player-cube-theme-playbutton-button{border-left-color:#eb6a74}.ba-player-red-color .ba-player-cube-theme-volumebar-inner{background-color:#979797;background-color:rgba(255,255,255,.3)}.ba-player-blue-color .ba-player-cube-theme-button-inner>i,.ba-player-blue-color .ba-player-cube-theme-dashboard,.ba-player-blue-color .ba-player-cube-theme-title{color:#2a74eb}.ba-player-blue-color .ba-player-button-active .ba-player-cube-theme-button-inner>i{color:#eee}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-cube-theme-playbutton-container{border-color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-cube-theme-playbutton-button::after{color:#2a74eb}.ba-player-blue-color .ba-player-button-active,.ba-player-blue-color .ba-player-cube-theme-playbutton-duration,.ba-player-blue-color .ba-player-cube-theme-primary-button,.ba-player-blue-color .ba-player-cube-theme-progressbar-position,.ba-player-blue-color .ba-player-cube-theme-rerecord-button,.ba-player-blue-color .ba-player-cube-theme-stream-label,.ba-player-blue-color .ba-player-cube-theme-volumebar-position{background-color:#2a74eb}.ba-player-blue-color .ba-player-cube-theme-playbutton-button{border-left-color:#2a74eb}.ba-player-blue-color .ba-player-cube-theme-volumebar-inner{background-color:#979797;background-color:rgba(255,255,255,.3)}.ba-player-green-color .ba-player-cube-theme-button-inner>i,.ba-player-green-color .ba-player-cube-theme-dashboard,.ba-player-green-color .ba-player-cube-theme-title{color:#5daa96}.ba-player-green-color .ba-player-button-active .ba-player-cube-theme-button-inner>i{color:#eee}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-cube-theme-playbutton-container{border-color:#5daa96}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-cube-theme-playbutton-button::after{color:#5daa96}.ba-player-green-color .ba-player-button-active,.ba-player-green-color .ba-player-cube-theme-playbutton-duration,.ba-player-green-color .ba-player-cube-theme-primary-button,.ba-player-green-color .ba-player-cube-theme-progressbar-position,.ba-player-green-color .ba-player-cube-theme-rerecord-button,.ba-player-green-color .ba-player-cube-theme-stream-label,.ba-player-green-color .ba-player-cube-theme-volumebar-position{background-color:#5daa96}.ba-player-green-color .ba-player-cube-theme-playbutton-button{border-left-color:#5daa96}.ba-player-green-color .ba-player-cube-theme-volumebar-inner{background-color:#979797;background-color:rgba(255,255,255,.3)}.ba-player-cube-theme .ba-settings-overlay-inner{bottom:40px}.ba-player-cube-theme-dashboard{position:absolute;left:0;right:0;bottom:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;background-color:#4f4f4f;background-color:rgba(0,0,0,.6);color:#eee;font-size:13px;height:40px;opacity:.9;overflow:hidden}.ba-player-cube-theme-dashboard .ba-player-airplay-container{padding-top:2px}.ba-videoplayer-ie8 .ba-player-cube-theme-title-block{display:none}.ba-videoplayer-noie8 .ba-player-cube-theme-title-block{position:absolute;left:0;right:0;top:0;background-color:#4f4f4f;background-color:rgba(0,0,0,.6);transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out}.ba-player-cube-theme-title{color:#eee;font-family:sans-serif;font-weight:300;font-size:12px;letter-spacing:.1em;margin:0;padding:10px 15px}.ba-player-airplay-container,.ba-player-cube-theme-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;color:#eee;font-size:13px}.ba-player-cube-theme-volumebar{float:left;width:60px;height:40px;margin-right:10px}.ba-player-cube-theme-volumebar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;cursor:pointer;background-color:#979797;height:6px}.ba-videoplayer-ie8 .ba-player-cube-theme-volumebar-inner{margin-top:-2px}.ba-player-cube-theme-volumebar-position{border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;position:absolute;left:0;background-color:#eee;height:100%}.ba-player-cube-theme-left-block{float:left}.ba-player-cube-theme-center-block{float:left}.ba-player-cube-theme-right-block{float:right}.ba-player-cube-theme-right-block .ba-commoncss-icon-resize-full,.ba-player-cube-theme-right-block .ba-commoncss-icon-volume-down,.ba-player-cube-theme-right-block .ba-commoncss-icon-volume-up{color:#979797}.ba-player-cube-theme-button-container{float:left;width:40px;height:40px;line-height:40px;text-align:center}.ba-player-cube-theme-timer-container{background-color:#b2b2b2;background-color:rgba(0,0,0,.35);color:#eee;letter-spacing:.1em;width:98px;font-weight:300;font-size:.9em}.ba-player-cube-theme-timer-container>div:first-child{margin-left:4px}.ba-player-cube-theme-timer-container>div{float:left;width:45px}.ba-player-cube-theme-timer-container>p{float:left;margin:0;width:4px}.ba-player-cube-theme-stream-label{background-color:#000;color:#eee;display:inline-block;font-weight:300;font-size:.8em;height:25px;letter-spacing:.1em;line-height:24px;padding:0 3px;text-align:center;width:auto}.ba-player-cube-theme-stream-label>span{display:inline-block;padding-left:2px;line-height:25px}.ba-videoplayer-noie8 .ba-player-cube-theme-progressbar{overflow:hidden;height:100%}.ba-videoplayer-ie8 .ba-player-cube-theme-progressbar{overflow:hidden}.ba-player-cube-theme-progressbar-cache{position:absolute;left:0;cursor:pointer;background-color:transparent;height:40px}.ba-player-cube-theme-progressbar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;background-color:transparent;height:40px}.ba-player-cube-theme-progressbar.ba-player-disabled,.ba-player-cube-theme-progressbar.ba-player-disabled .ba-player-cube-theme-progressbar-cache,.ba-player-cube-theme-progressbar.ba-player-disabled .ba-player-cube-theme-progressbar-inner,.ba-player-cube-theme-progressbar.ba-player-disabled .ba-player-cube-theme-progressbar-position{cursor:not-allowed}.ba-player-cube-theme-progressbar-position{background-color:#eee;position:absolute;height:100%}.ba-player-cube-theme-progressbar-button{display:none}.ba-player-cube-theme-progressbar-marker{position:absolute;height:40px;width:10px;background-color:#000}.ba-player-cube-theme-cast-button-container button{-moz-opacity:.7;-khtml-opacity:.7;opacity:.7;background:0 0;border:none;cursor:pointer;box-sizing:border-box;padding:11px 6px 0 5px;width:32px}.ba-player-cube-theme-primary-button{color:#eee;background-color:#979797}.ba-player-size-small .ba-player-cube-theme-button-container{width:35px}.ba-player-device-type-mobile .ba-player-cube-theme-timer-container{width:45px}.ba-player-device-type-mobile .ba-player-cube-theme-volumebar{width:40px}.ba-player-fullscreen-view video::-webkit-media-controls-overlay-enclosure{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-enclosure{display:none}.ba-player-fullscreen-view video::-webkit-media-controls{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-panel{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-play-button{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-current-time-display{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-time-remaining-display{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-timeline{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-mute-button{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-volume-slider{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-fullscreen-button{display:none}.ba-player-fullscreen-view video::-internal-media-controls-download-button{display:none}.ba-player-fullscreen-view video::-moz-list-bullet,.ba-player-fullscreen-view video::-moz-list-number{display:none}.ba-player-fullscreen-view video::-moz-meter-bar{display:none}.ba-player-fullscreen-view video:fullscreen:not(:root){display:none}.ba-player-fullscreen-view .ba-player-cube-theme-dashboard{bottom:0}.ba-player-fullscreen-view .ba-videoplayer-title-block{top:0}.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-dashboard,.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-title-block{position:fixed;z-index:100}.ba-videoplayer-container.ba-player-fullscreen-view{min-width:100%;position:absolute;min-height:fit-content}.ba-videoplayer-container.ba-player-fullscreen-view>.ba-player-overlay{position:fixed}.ba-player-cube-theme.ba-videoplayer-container .ba-player-text-tracks-overlay{position:absolute;left:0;right:0;bottom:42px;transition:bottom .5s ease-in-out;-moz-transition:bottom .5s ease-in-out;-webkit-transition:bottom .5s ease-in-out;-o-transition:bottom .5s ease-in-out;-ms-transition:bottom .5s ease-in-out}.ba-player-cube-theme.ba-videoplayer-container .ba-player-text-tracks-overlay .ba-commoncss-options-popup{bottom:-2px;right:0}.ba-player-cube-theme.ba-videoplayer-container .ba-player-track-dashboard-hidden.ba-player-text-tracks-overlay{bottom:5px}.ba-recorder-theme-cube .ba-videorecorder-chooser-container{background-color:#eee;z-index:1}.ba-recorder-theme-cube .ba-videorecorder-chooser-icon-container{color:#000;font-size:32px;margin:16px}.ba-recorder-theme-cube .ba-videorecorder-chooser-button-0,.ba-recorder-theme-cube .ba-videorecorder-chooser-button-1,.ba-recorder-theme-cube .ba-videorecorder-chooser-button-2,.ba-recorder-theme-cube .ba-videorecorder-chooser-button-3{line-height:20px;min-width:10em;margin:2px 0;padding:6px 8px}.ba-recorder-theme-cube .ba-videorecorder-chooser-button-0,.ba-recorder-theme-cube .ba-videorecorder-chooser-button-2{-moz-border-radius:0;-webkit-border-radius:0;border-radius:0;background-color:#000}.ba-recorder-theme-cube .ba-videorecorder-chooser-button-1,.ba-recorder-theme-cube .ba-videorecorder-chooser-button-3{background-color:#666;color:#eee;margin-top:2px}.ba-recorder-red-color .ba-recorder-theme-cube-dashboard .ba-videorecorder-button-primary{background-color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-cube-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-red-color .ba-recorder-theme-cube-dashboard .ba-videorecorder-button-selected{color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-cube-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{background-color:#eb6a74;border-color:#eb6a74}.ba-recorder-red-color .ba-recorder-loader-label,.ba-recorder-red-color .ba-videorecorder-chooser-icon-container{color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-chooser-button-0,.ba-recorder-red-color .ba-videorecorder-chooser-button-2,.ba-recorder-red-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-red-color .ba-videorecorder-imagegallery-rightbutton{background-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-imagegallery-image:hover{border-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-message-message a{color:#eb6a74}.ba-recorder-blue-color .ba-recorder-theme-cube-dashboard .ba-videorecorder-button-primary{background-color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-cube-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-blue-color .ba-recorder-theme-cube-dashboard .ba-videorecorder-button-selected{color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-cube-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{background-color:#2a74eb;border-color:#2a74eb}.ba-recorder-blue-color .ba-recorder-loader-label,.ba-recorder-blue-color .ba-videorecorder-chooser-icon-container{color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-chooser-button-0,.ba-recorder-blue-color .ba-videorecorder-chooser-button-2,.ba-recorder-blue-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-blue-color .ba-videorecorder-imagegallery-rightbutton{background-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-imagegallery-image:hover{border-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-message-message a{color:#2a74eb}.ba-recorder-green-color .ba-recorder-theme-cube-dashboard .ba-videorecorder-button-primary{background-color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-cube-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-green-color .ba-recorder-theme-cube-dashboard .ba-videorecorder-button-selected{color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-cube-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{background-color:#5daa96;border-color:#5daa96}.ba-recorder-green-color .ba-recorder-loader-label,.ba-recorder-green-color .ba-videorecorder-chooser-icon-container{color:#5daa96}.ba-recorder-green-color .ba-videorecorder-chooser-button-0,.ba-recorder-green-color .ba-videorecorder-chooser-button-2,.ba-recorder-green-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-green-color .ba-videorecorder-imagegallery-rightbutton{background-color:#5daa96}.ba-recorder-green-color .ba-videorecorder-imagegallery-image:hover{border-color:#5daa96}.ba-recorder-green-color .ba-videorecorder-message-message a{color:#5daa96}.ba-recorder-theme-cube.ba-videorecorder-container .ba-recorder-overlay{top:0}.ba-recorder-theme-cube-dashboard{position:absolute;left:0;right:0;top:0;bottom:0;height:100%}.ba-recorder-theme-cube-dashboard .ba-videorecorder-controlbar{background-color:#979797;background-color:rgba(0,0,0,.4);position:absolute;left:0;right:0;bottom:0;height:50px;padding:0}.ba-recorder-theme-cube-dashboard .ba-videorecorder-button{border:none;-moz-box-shadow:inset -1px 0 0 #666;-webkit-box-shadow:inset -1px 0 0 #666;box-shadow:inset -1px 0 0 #666;color:#eee;cursor:pointer;float:left;height:50px;line-height:50px;text-align:center;width:50px}.ba-recorder-theme-cube-dashboard .ba-videorecorder-button-inner{border:none;border-radius:50%;color:#eee;cursor:pointer;font-size:inherit;height:100%;margin:0;padding:0;width:100%}.ba-recorder-theme-cube-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-theme-cube-dashboard .ba-videorecorder-button-selected{color:#979797}.ba-recorder-theme-cube-dashboard .ba-videorecorder-indicator-container{border:none;color:#eee;cursor:pointer;float:left;height:50px;line-height:50px;text-align:center;width:50px}.ba-recorder-theme-cube-dashboard .ba-videorecorder-indicator-container .ba-videorecorder-recording-indication{margin:0;left:50%}.ba-recorder-theme-cube-dashboard .ba-videorecorder-rightbutton-container{padding:0}.ba-recorder-theme-cube-dashboard .ba-videorecorder-settings-front{position:absolute;left:0;right:0;bottom:0;max-height:initial;overflow:auto}.ba-recorder-theme-cube-dashboard .ba-videorecorder-settings{bottom:50px;max-height:14em;overflow:scroll;margin:5px;padding:0}.ba-recorder-theme-cube-dashboard .ba-videorecorder-settings .ba-videorecorder-add-stream,.ba-recorder-theme-cube-dashboard .ba-videorecorder-settings label{font-family:sans-serif;font-weight:300;font-size:12px}.ba-recorder-theme-cube-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{border:3px solid #000}.ba-recorder-theme-cube-dashboard .ba-videorecorder-button-primary{background-color:#000;border:none;border-radius:0;color:#eee;display:inline-block;font-family:sans-serif;font-weight:300;font-size:12px;margin:0;padding:0 25px;min-width:3em;position:relative;left:0;right:0;top:0;bottom:0;-webkit-transform:translate(0,0);-moz-transform:translate(0,0);-o-transform:translate(0,0);-ms-transform:translate(0,0);transform:translate(0,0);z-index:10;height:50px;line-height:50px}.ba-recorder-theme-cube-dashboard .ba-videorecorder-settings-button{background-color:#eee;cursor:pointer;margin:15px 0 0 15px}.ba-recorder-theme-cube-dashboard .ba-videorecorder-settings label{color:#eee}.ba-recorder-theme-cube-dashboard .ba-videorecorder-bubble-info{background-color:#fff;background-color:rgba(0,0,0,.4);-moz-border-radius:4px;-webkit-border-radius:4px;border-radius:4px;display:inline-block;padding:12px 0;line-height:1.2;position:relative}.ba-recorder-theme-cube-dashboard .ba-videorecorder-bubble-info:before{border-top:9px solid;border-top-color:#fff;border-top-color:rgba(0,0,0,.4);border-left:6px solid transparent;border-right:6px solid transparent;content:\"\";height:0;left:10px;position:absolute;right:100%;top:100%;width:0}.ba-recorder-theme-cube-dashboard .ba-videorecorder-bubble-info{border-radius:0}.ba-recorder-theme-cube-dashboard .ba-videorecorder-controlbar-center-section{position:absolute;left:0;text-align:center;width:100%}.ba-recorder-theme-cube-dashboard .ba-videorecorder-button-container{display:inline-block}.ba-recorder-theme-cube-dashboard .ba-videorecorder-label-container{text-align:center;width:100%}.ba-recorder-theme-cube-dashboard .ba-videorecorder-label-container .ba-videorecorder-button-primary{background:0 0;border-right:1px solid;border-right-color:#191919;border-right-color:rgba(255,255,255,.1);border-left:1px solid;border-left-color:#191919;border-left-color:rgba(255,255,255,.1);color:#eee;cursor:default}.ba-recorder-theme-cube-dashboard .ba-videorecorder-stop-button-container{text-align:right;bottom:0;left:auto;position:absolute;right:0;top:auto}.ba-recorder-theme-cube.ba-videorecorder-container .ba-videorecorder-imagegallery-container{left:50px;right:50px}.ba-recorder-overlay img,.ba-videorecorder-imagegallery-image{border:none;border-radius:0}.ba-videorecorderimagegallery-image:hover{border:2px solid #fff}.ba-videorecorder-imagegallery-leftbutton,.ba-videorecorder-imagegallery-rightbutton{border-radius:0;background-color:#979797;background-color:rgba(0,0,0,.4);height:30px;width:30px;z-index:10}.ba-recorder-theme-cube .ba-videorecorder-topmessage-message{color:#eee;display:inline-block;font-family:sans-serif;font-size:12px;font-weight:300;padding:7px 15px;position:relative;margin:15px 0 3px}.ba-recorder-theme-cube .ba-videorecorder-topmessage-background{background:0 0}.ba-imageviewer-cube-theme-red-color .ba-imageviewer-button-inner,.ba-imageviewer-cube-theme-red-color .ba-imageviewer-dashboard,.ba-imageviewer-cube-theme-red-color .ba-imageviewer-image-title,.ba-imageviewer-cube-theme-red-color .ba-imageviewer-right-block .ba-commoncss-icon-resize-full,.ba-imageviewer-cube-theme-red-color .ba-imageviewer-right-block .ba-commoncss-icon-resize-small{color:#eb6a74}.ba-imageviewer-cube-theme-red-color .ba-imageviewer-rerecord-button{background-color:#eb6a74}.ba-imageviewer-cube-theme-blue-color .ba-imageviewer-button-inner,.ba-imageviewer-cube-theme-blue-color .ba-imageviewer-dashboard,.ba-imageviewer-cube-theme-blue-color .ba-imageviewer-image-title,.ba-imageviewer-cube-theme-blue-color .ba-imageviewer-right-block .ba-commoncss-icon-resize-full,.ba-imageviewer-cube-theme-blue-color .ba-imageviewer-right-block .ba-commoncss-icon-resize-small{color:#2a74eb}.ba-imageviewer-cube-theme-blue-color .ba-imageviewer-rerecord-button{background-color:#2a74eb}.ba-imageviewer-cube-theme-green-color .ba-imageviewer-button-inner,.ba-imageviewer-cube-theme-green-color .ba-imageviewer-dashboard,.ba-imageviewer-cube-theme-green-color .ba-imageviewer-image-title,.ba-imageviewer-cube-theme-green-color .ba-imageviewer-right-block .ba-commoncss-icon-resize-full,.ba-imageviewer-cube-theme-green-color .ba-imageviewer-right-block .ba-commoncss-icon-resize-small{color:#5daa96}.ba-imageviewer-cube-theme-green-color .ba-imageviewer-rerecord-button{background-color:#5daa96}.ba-imageviewer-cube-theme .ba-imageviewer-dashboard{position:absolute;left:0;right:0;bottom:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;background-color:#4f4f4f;background-color:rgba(0,0,0,.6);color:#eee;font-size:13px;height:40px;opacity:.9;overflow:hidden}.ba-imageviewer-cube-theme .ba-imageviewer-dashboard-hidden{opacity:0}.ba-imageviewer-cube-theme.ba-imageviewer-ie8 .ba-imageviewer-image-title-block{display:none}.ba-imageviewer-cube-theme.ba-imageviewer-noie8 .ba-imageviewer-image-title-block{position:absolute;left:0;right:0;top:0;background-color:#4f4f4f;background-color:rgba(0,0,0,.6);transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out}.ba-imageviewer-cube-theme .ba-imageviewer-image-title{color:#eee;font-family:sans-serif;font-weight:300;font-size:12px;letter-spacing:.1em;margin:0;padding:10px 15px}.ba-imageviewer-cube-theme .ba-imageviewer-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;color:#eee;font-size:13px}.ba-imageviewer-cube-theme .ba-imageviewer-left-block{float:left}.ba-imageviewer-cube-theme .ba-imageviewer-center-block{float:left}.ba-imageviewer-cube-theme .ba-imageviewer-right-block{float:right}.ba-imageviewer-cube-theme .ba-imageviewer-right-block .ba-commoncss-icon-resize-full{color:#979797}.ba-imageviewer-cube-theme .ba-imageviewer-button-container{float:left;width:40px;height:40px;line-height:40px;text-align:center}.ba-imageviewer-cube-theme .ba-imageviewer-timer-container{background-color:#b2b2b2;background-color:rgba(0,0,0,.35);color:#eee;cursor:default;letter-spacing:.1em;width:90px;font-weight:300;font-size:.9em}.ba-imageviewer-cube-theme .ba-imageviewer-timer-container>div:first-child{margin-left:4px}.ba-imageviewer-cube-theme .ba-imageviewer-timer-container>div{float:left;width:40px}.ba-imageviewer-cube-theme .ba-imageviewer-timer-container>p{float:left;margin:0;width:4px}.ba-imageviewer-fullscreen-view.ba-imageviewer-cube-theme .ba-imageviewer-dashboard,.ba-imageviewer-fullscreen-view.ba-imageviewer-cube-theme .ba-imageviewer-image-title-block{position:fixed;width:100%;z-index:1005}.ba-imageviewer-fullscreen-view.ba-imageviewer-cube-theme .ba-imageviewer-dashboard{bottom:0}.ba-imageviewer-fullscreen-view.ba-imageviewer-cube-theme .ba-imageviewer-image-title-block{top:0}.ba-player-cube-theme-audio-canvas{display:none;position:absolute;bottom:40px;background-color:#000}.ba-audioplayer-container .ba-player-cube-theme-dashboard .ba-player-normal-view{background-color:#020202;border:1px solid #eee;box-sizing:border-box;min-height:70px;min-width:320px;height:70px}.ba-audioplayer-noie8 .ba-player-cube-theme-title-block{position:absolute;left:0;right:0;top:0;background-color:#4f4f4f;background-color:rgba(0,0,0,.6);transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;min-height:30px}.ba-player-cube-theme-center-block{float:left}.ba-player-cube-theme-center-block .ba-player-cube-theme-progress-bar-container{position:absolute;width:100%}.ba-audioplayer-noie8 .ba-player-cube-theme-progressbar{overflow:hidden;height:100%}.ba-audioplayer-ie8 .ba-player-cube-theme-progressbar{overflow:hidden}.ba-player-cube-theme-progressbar.ba-player-disabled,.ba-player-cube-theme-progressbar.ba-player-disabled .ba-player-cube-theme-progressbar-cache,.ba-player-cube-theme-progressbar.ba-player-disabled .ba-player-cube-theme-progressbar-inner,.ba-player-cube-theme-progressbar.ba-player-disabled .ba-player-cube-theme-progressbar-position{cursor:not-allowed}/*!\nbetajs-media-components - v0.0.291 - 2022-01-08\nCopyright (c) Ziggeo,Oliver Friedmann,Rashad Aliyev\nApache-2.0 Software License.\n*/.ba-player-red-color .ba-player-elevate-theme-button-inner i,.ba-player-red-color .ba-player-elevate-theme-button-inner.ba-player-elevate-theme-primary-button,.ba-player-red-color .ba-player-elevate-theme-dashboard .ba-player-button-inactive .ba-commoncss-icon-subtitle{color:#eb6a74}.ba-player-red-color .ba-player-elevate-theme-dashboard .ba-player-button-active .ba-commoncss-icon-subtitle{color:#eee}.ba-player-red-color .ba-player-elevate-theme-playbutton-duration,.ba-player-red-color .ba-player-elevate-theme-progressbar-button,.ba-player-red-color .ba-player-elevate-theme-progressbar-position,.ba-player-red-color .ba-player-elevate-theme-rerecord-button,.ba-player-red-color .ba-player-elevate-theme-stream-label-container .ba-player-elevate-theme-stream-label,.ba-player-red-color .ba-player-elevate-theme-volumebar-position{background-color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-elevate-theme-playbutton-container{border-color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-elevate-theme-playbutton-button::after{color:#eb6a74}.ba-player-red-color .ba-player-elevate-theme-volumebar-inner{background-color:#cecece;background-color:rgba(0,0,0,.3)}.ba-player-blue-color .ba-player-elevate-theme-button-inner i,.ba-player-blue-color .ba-player-elevate-theme-button-inner.ba-player-elevate-theme-primary-button,.ba-player-blue-color .ba-player-elevate-theme-dashboard .ba-player-button-inactive .ba-commoncss-icon-subtitle{color:#2a74eb}.ba-player-blue-color .ba-player-elevate-theme-dashboard .ba-player-button-active .ba-commoncss-icon-subtitle{color:#eee}.ba-player-blue-color .ba-player-elevate-theme-playbutton-duration,.ba-player-blue-color .ba-player-elevate-theme-progressbar-button,.ba-player-blue-color .ba-player-elevate-theme-progressbar-position,.ba-player-blue-color .ba-player-elevate-theme-rerecord-button,.ba-player-blue-color .ba-player-elevate-theme-stream-label-container .ba-player-elevate-theme-stream-label,.ba-player-blue-color .ba-player-elevate-theme-volumebar-position{background-color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-elevate-theme-playbutton-container{border-color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-elevate-theme-playbutton-button::after{color:#2a74eb}.ba-player-blue-color .ba-player-elevate-theme-volumebar-inner{background-color:#cecece;background-color:rgba(0,0,0,.3)}.ba-player-green-color .ba-player-elevate-theme-button-inner i,.ba-player-green-color .ba-player-elevate-theme-button-inner.ba-player-elevate-theme-primary-button,.ba-player-green-color .ba-player-elevate-theme-dashboard .ba-player-button-inactive .ba-commoncss-icon-subtitle{color:#5daa96}.ba-player-green-color .ba-player-elevate-theme-dashboard .ba-player-button-active .ba-commoncss-icon-subtitle{color:#eee}.ba-player-green-color .ba-player-elevate-theme-playbutton-duration,.ba-player-green-color .ba-player-elevate-theme-progressbar-button,.ba-player-green-color .ba-player-elevate-theme-progressbar-position,.ba-player-green-color .ba-player-elevate-theme-rerecord-button,.ba-player-green-color .ba-player-elevate-theme-stream-label-container .ba-player-elevate-theme-stream-label,.ba-player-green-color .ba-player-elevate-theme-volumebar-position{background-color:#5daa96}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-elevate-theme-playbutton-container{border-color:#5daa96}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-elevate-theme-playbutton-button::after{color:#5daa96}.ba-player-green-color .ba-player-elevate-theme-volumebar-inner{background-color:#cecece;background-color:rgba(0,0,0,.3)}.ba-player-elevate-theme{font-family:Helvetica Neue,Helvetica,Arial,sans-serif}.ba-player-elevate-theme .ba-commoncss-icon-pause,.ba-player-elevate-theme .ba-commoncss-icon-play{color:#000}.ba-player-elevate-theme .ba-commoncss-icon-pause,.ba-player-elevate-theme .ba-commoncss-icon-play,.ba-player-elevate-theme .ba-commoncss-icon-resize-full,.ba-player-elevate-theme .ba-commoncss-icon-volume-down,.ba-player-elevate-theme .ba-commoncss-icon-volume-up{display:inline-block}.ba-player-elevate-theme .ba-commoncss-icon-pause:before,.ba-player-elevate-theme .ba-commoncss-icon-play:before,.ba-player-elevate-theme .ba-commoncss-icon-resize-full:before,.ba-player-elevate-theme .ba-commoncss-icon-volume-down:before,.ba-player-elevate-theme .ba-commoncss-icon-volume-up:before{font-size:11px;margin:0;line-height:inherit}.ba-player-elevate-theme .ba-commoncss-settings-menu{bottom:72px}.ba-player-elevate-theme.ba-videoplayer-ie8 .ba-commoncss-icon-volume-down:before{font-size:12px}.ba-player-elevate-theme .ba-settings-overlay-inner{bottom:50px;right:2.5%}.ba-player-elevate-theme .ba-commoncss-settings-visible .ba-player-elevate-theme-button-inner{color:#eee}.ba-player-elevate-theme .ba-commoncss-icon-volume-up{color:#666}.ba-player-elevate-theme .ba-commoncss-icon-resize-full{color:#666}.ba-player-elevate-theme .ba-videoplayer-seeking-thumb-container{bottom:70px}.ba-player-elevate-theme-dashboard{transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;position:absolute;left:2.5%;bottom:10px;width:95%;opacity:.75;overflow:hidden;z-index:1}.ba-player-elevate-theme-dashboard .ba-player-airplay-container,.ba-player-elevate-theme-dashboard .ba-player-button-active .ba-player-elevate-theme-button-inner{padding-top:2px}.ba-player-elevate-theme-dashboard .ba-player-button-inactive .ba-commoncss-icon-subtitle{color:#000}.ba-player-elevate-theme-top-block{padding-top:15px;width:100%;clear:both}.ba-videoplayer-ie8 .ba-player-elevate-theme-top-block{padding-top:0;padding-bottom:5px}.ba-player-elevate-theme-bottom-block{background-color:#eee;clear:both;height:32px;overflow:hidden;width:100%}.ba-player-elevate-theme-left-block{float:left}.ba-player-elevate-theme-left-block>div{border-right:1px solid #666;box-sizing:content-box;float:left;font-size:13px;color:#000;line-height:31px;text-align:center;width:40px}.ba-player-elevate-theme-center-block{float:left;padding:0 10px}.ba-player-elevate-theme-right-block{float:right}.ba-player-elevate-theme-right-block>div{border-left:1px solid #666;box-sizing:content-box;float:right;line-height:32px;text-align:center}.ba-player-elevate-theme-right-block>div:first-child{float:left;line-height:31px}.ba-player-elevate-theme-top-right-block{float:right}.ba-player-elevate-theme-top-right-block .ba-player-elevate-theme-time-value{text-align:right}.ba-player-elevate-theme-button-container{width:40px;text-align:center}.ba-videoplayer-noie8 .ba-player-elevate-theme-button-inner{color:#000;font-size:13px}.ba-videoplayer-ie8 .ba-player-elevate-theme-button-inner{color:#000;font-size:13px;margin-left:3px}.ba-player-elevate-theme-button-inner{cursor:pointer}.ba-player-elevate-theme-time-container{float:left;width:40px;height:100%;position:relative;top:10px;text-align:center;font-size:11px;box-sizing:content-box;border:none}.ba-videoplayer-ie8 .ba-player-elevate-theme-time-container{top:7px}.ba-player-elevate-theme-time-value{color:#fff;text-shadow:0 0 4px #000;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;float:left;font-size:11px;width:40px;letter-spacing:.1em}.ba-videoplayer-noie8 .ba-player-elevate-theme-volumebar{float:right;width:60px;height:100%;margin-right:12px}.ba-videoplayer-ie8 .ba-player-elevate-theme-volumebar{float:right;width:60px;height:50%}.ba-player-elevate-theme-progressbar{overflow:hidden;height:100%}.ba-player-elevate-theme-progressbar{padding:10px 0 5px}.ba-player-elevate-theme-progressbar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;-moz-border-radius:2px;-webkit-border-radius:2px;border-radius:2px;cursor:pointer;background-color:#eee;box-sizing:border-box;height:8px}.ba-player-elevate-theme-progressbar.ba-player-disabled .ba-player-elevate-theme-progressbar-cache,.ba-player-elevate-theme-progressbar.ba-player-disabled .ba-player-elevate-theme-progressbar-inner,.ba-player-elevate-theme-progressbar.ba-player-disabled .ba-player-elevate-theme-progressbar-position{cursor:not-allowed}.ba-player-elevate-theme-progressbar-cache{position:absolute;left:0;border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;cursor:pointer;background-color:#eee;height:8px}.ba-player-elevate-theme-progressbar-position{background-color:#000;left:-8px;position:absolute;height:100%}.ba-player-elevate-theme-progressbar-button{-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;box-sizing:content-box;display:inline-block;position:absolute;right:-15px;top:-4px;z-index:1;background-color:#000;border:4px solid #666;height:8px;width:8px}.ba-player-elevate-theme-progressbar-marker{box-sizing:content-box;display:inline-block;position:absolute;right:-15px;top:-4px;z-index:1;background-color:#000;height:16px;width:4px}.ba-player-elevate-theme-button-text{font-family:sans-serif;font-weight:400;font-size:10px}.ba-player-size-small .ba-player-elevate-theme-center-block,.ba-player-size-small .ba-player-elevate-theme-time-container{display:none}.ba-player-size-medium .ba-player-elevate-theme-volumebar{display:none}.ba-player-size-medium .ba-player-elevate-theme-right-time-container{display:none}.ba-player-elevate-theme-title-block>p{font-size:11px;color:#000;line-height:32px;margin:0}.ba-player-elevate-theme-title-block>p>span{color:#2c2c2c;font-weight:700;font-size:1em}.ba-player-elevate-theme-stream-label-container .ba-player-elevate-theme-stream-label{cursor:pointer;background-color:#000;color:#eee;padding:3px}.ba-player-elevate-theme-left-block .ba-player-elevate-theme-volumebar{float:left;height:32px;width:60px}.ba-player-elevate-theme-volumebar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;cursor:pointer;background-color:#666;height:6px;margin:0 5px}.ba-videoplayer-ie8 .ba-player-elevate-theme-volumebar-inner{margin-top:-3px}.ba-player-elevate-theme-volumebar-position{border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;position:absolute;left:0;background-color:#000;height:100%}.ba-player-elevate-theme-top-left-block{float:left}.ba-player-size-small .ba-player-elevate-theme-volumebar{display:none}.ba-player-size-small .ba-player-elevate-theme-dashboard{width:100%;left:0}.ba-player-elevate-theme-button-inner,.ba-player-elevate-theme-left-block .ba-player-elevate-theme-volumebar,.ba-player-elevate-theme-title-block>p{padding-top:1px}.ba-player-elevate-theme-cast-button-container button{-moz-opacity:.7;-khtml-opacity:.7;opacity:.7;background:0 0;border:none;cursor:pointer;padding-top:7px;width:32px}.ba-player-elevate-theme-primary-button{padding:0 10px}.ba-player-elevate-theme-primary-button-container{width:auto}.ba-player-fullscreen-view .ba-videoplayer-dashboard{width:95%;bottom:0}.ba-player-fullscreen-view .ba-videoplayer-title-block{top:0}.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-dashboard,.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-title-block{position:fixed;z-index:100}.ba-player-elevate-theme.ba-videoplayer-container .ba-player-text-tracks-overlay{position:absolute;left:0;right:0;bottom:64px;transition:bottom .5s ease-in-out;-moz-transition:bottom .5s ease-in-out;-webkit-transition:bottom .5s ease-in-out;-o-transition:bottom .5s ease-in-out;-ms-transition:bottom .5s ease-in-out}.ba-player-elevate-theme.ba-videoplayer-container .ba-player-text-tracks-overlay .ba-commoncss-options-popup{bottom:-14px;right:2.5%}.ba-player-elevate-theme.ba-videoplayer-container .ba-player-track-dashboard-hidden.ba-player-text-tracks-overlay{bottom:5px}.ba-recorder-theme-elevate .ba-videorecorder-chooser-container{background-color:#eee;z-index:1}.ba-recorder-theme-elevate .ba-videorecorder-chooser-icon-container{color:#000;font-size:32px;margin:16px}.ba-recorder-theme-elevate .ba-videorecorder-chooser-button-0,.ba-recorder-theme-elevate .ba-videorecorder-chooser-button-2{background-color:#000}.ba-recorder-theme-elevate .ba-videorecorder-chooser-button-0,.ba-recorder-theme-elevate .ba-videorecorder-chooser-button-1,.ba-recorder-theme-elevate .ba-videorecorder-chooser-button-2,.ba-recorder-theme-elevate .ba-videorecorder-chooser-button-3{line-height:20px;min-width:10em;padding:6px 8px}.ba-recorder-theme-elevate .ba-videorecorder-chooser-button-0,.ba-recorder-theme-elevate .ba-videorecorder-chooser-button-2{-moz-border-radius:2px;-webkit-border-radius:2px;border-radius:2px;border:1px solid #000}.ba-recorder-theme-elevate .ba-videorecorder-chooser-button-1,.ba-recorder-theme-elevate .ba-videorecorder-chooser-button-3{-moz-border-radius:2px;-webkit-border-radius:2px;border-radius:2px;background-color:#eee;color:#666;border:1px solid #666;margin:2px 0}.ba-recorder-theme-elevate .ba-commoncss-icon-record:before{font-size:.8em}.ba-recorder-theme-elevate .ba-commoncss-icon-upload:before{font-size:.9em}.ba-recorder-red-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-circle-selected,.ba-recorder-red-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-red-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-selected{color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-primary{background-color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings span{border-color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{border-color:#eb6a74;background-color:#000}.ba-recorder-red-color .ba-recorder-loader-label,.ba-recorder-red-color .ba-videorecorder-loader-label,.ba-recorder-red-color .ba-videorecorder-message-message{color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-chooser-button-0,.ba-recorder-red-color .ba-videorecorder-chooser-button-2,.ba-recorder-red-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-red-color .ba-videorecorder-imagegallery-rightbutton{background-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-chooser-button-0,.ba-recorder-red-color .ba-videorecorder-chooser-button-2,.ba-recorder-red-color .ba-videorecorder-imagegallery-image:hover{border-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-message-message a{color:#eb6a74}.ba-recorder-blue-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-circle-selected,.ba-recorder-blue-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-blue-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-selected{color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-primary{background-color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings span{border-color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{border-color:#2a74eb;background-color:#000}.ba-recorder-blue-color .ba-recorder-loader-label,.ba-recorder-blue-color .ba-videorecorder-loader-label,.ba-recorder-blue-color .ba-videorecorder-message-message{color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-chooser-button-0,.ba-recorder-blue-color .ba-videorecorder-chooser-button-2,.ba-recorder-blue-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-blue-color .ba-videorecorder-imagegallery-rightbutton{background-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-chooser-button-0,.ba-recorder-blue-color .ba-videorecorder-chooser-button-2,.ba-recorder-blue-color .ba-videorecorder-imagegallery-image:hover{border-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-message-message a{color:#2a74eb}.ba-recorder-green-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-circle-selected,.ba-recorder-green-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-green-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-selected{color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-primary{background-color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings span{border-color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{border-color:#5daa96;background-color:#000}.ba-recorder-green-color .ba-recorder-loader-label,.ba-recorder-green-color .ba-videorecorder-loader-label,.ba-recorder-green-color .ba-videorecorder-message-message{color:#5daa96}.ba-recorder-green-color .ba-videorecorder-chooser-button-0,.ba-recorder-green-color .ba-videorecorder-chooser-button-2,.ba-recorder-green-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-green-color .ba-videorecorder-imagegallery-rightbutton{background-color:#5daa96}.ba-recorder-green-color .ba-videorecorder-chooser-button-0,.ba-recorder-green-color .ba-videorecorder-chooser-button-2,.ba-recorder-green-color .ba-videorecorder-imagegallery-image:hover{border-color:#5daa96}.ba-recorder-green-color .ba-videorecorder-message-message a{color:#5daa96}.ba-recorder-theme-elevate.ba-videorecorder-container .ba-videorecorder-video{background-color:#000}.ba-recorder-theme-elevate-dashboard{position:absolute;left:0;right:0;top:0;bottom:0;height:100%}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings-left-sidebar{display:table;height:100%;text-align:center;bottom:0;left:0;position:absolute;right:auto;top:0;width:55px}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings-left-sidebar .ba-videorecorder-controlbar-left-section{display:table-cell;vertical-align:middle}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings-left-sidebar .ba-videorecorder-controlbar-left-section .ba-videorecorder-circle-button-container{margin:2px auto}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-controlbar-middle-section .ba-videorecorder-timer-container{display:table;cursor:default;height:100%;position:absolute;width:100%}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-controlbar-middle-section .ba-videorecorder-timer-container .ba-videorecorder-label-container{display:table-cell;float:none;position:relative;text-align:center;vertical-align:middle;width:auto}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-controlbar-middle-section .ba-videorecorder-timer-container .ba-videorecorder-label-container .ba-videorecorder-button-primary{margin:0;padding:7px 16px}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-controlbar{position:absolute;left:0;right:0;bottom:0;height:55px;padding:0 10px}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-long-rounded-button{-moz-border-radius:18px;-webkit-border-radius:18px;border-radius:18px;display:inline-block}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-long-rounded-button>p{font-family:sans-serif;font-size:12px;padding:7px;margin:0}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-circle-button{background-color:#979797;background-color:rgba(0,0,0,.4);-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;color:#eee;display:inline-block;height:40px;line-height:40px;text-align:center;width:40px}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-circle-selected,.ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-selected{color:#000;cursor:pointer}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-inner{background-color:#eee;border-radius:50%;color:#666;opacity:.65;cursor:pointer;border:none;font-size:inherit;margin:0;padding:0}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-inner i:before{line-height:inherit}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-indicator-container{position:absolute;top:50%}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings{position:inherit}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings .ba-videorecorder-add-stream,.ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings label{font-family:sans-serif;font-weight:300;font-size:12px}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings hr{border-bottom-color:#000}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{border:3px solid #000;background-color:#000}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings span{background-color:#eee;border-color:#979797}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings .ba-videorecorder-circle-button{margin:6px 0}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-primary{-moz-border-radius:18px;-webkit-border-radius:18px;border-radius:18px;display:inline-block;background-color:#000;font-family:sans-serif;font-weight:300;font-size:12px;margin-top:6px;min-width:3em;padding:10px 16px;position:relative;left:0;right:0;top:0;bottom:0;-webkit-transform:translate(0,0);-moz-transform:translate(0,0);-o-transform:translate(0,0);-ms-transform:translate(0,0);transform:translate(0,0);z-index:10}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings-button{background-color:#eee;cursor:pointer;margin:15px 0 0 15px}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-settings-button>p{color:#666}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-bubble-info{background-color:#fff;background-color:#fff;-moz-border-radius:16px;-webkit-border-radius:16px;border-radius:16px;display:inline-block;padding:9px 0;line-height:1.2;min-width:280px;position:relative;max-height:10em;overflow:scroll;left:60px}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-bubble-info:before{border-right:9px solid;border-right-color:#fff;border-right-color:#fff;border-bottom:6px solid transparent;border-top:6px solid transparent;content:\"\";height:0;top:13px;position:absolute;left:-9px;width:0}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-bubble-info li{color:#666;text-align:left}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-bubble-info{position:absolute}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-controlbar-center-section{position:absolute;left:0;text-align:center;width:100%}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-button-container{display:inline-block}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-label-container{float:left;text-align:right;width:50%;opacity:.25}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-label-container .ba-videorecorder-button-primary{background-color:#eee;color:#666}.ba-recorder-theme-elevate-dashboard .ba-videorecorder-stop-button-container{text-align:center}.ba-recorder-theme-elevate.ba-videorecorder-container .ba-videorecorder-imagegallery-container{left:50px;right:50px}.ba-recorder-overlay img,.ba-videorecorder-imagegallery-image{border:none;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px}.ba-videorecorder-imagegallery-image:hover{border:2px solid #fff}.ba-videorecorder-imagegallery-leftbutton,.ba-videorecorder-imagegallery-rightbutton{border-radius:50%;background-color:#fff;height:30px;width:30px;z-index:10}.ba-videorecorder-imagegallery-button-inner{color:#666}.ba-recorder-theme-elevate .ba-videorecorder-topmessage-container{text-align:center}.ba-recorder-theme-elevate .ba-videorecorder-topmessage-message{color:#eee;display:inline-block;font-family:sans-serif;font-size:12px;font-weight:300;padding:7px;position:relative;top:12px}.ba-recorder-theme-elevate .ba-videorecorder-topmessage-background{background:0 0}.ba-imageviewer-elevate-theme-red-color .ba-commoncss-icon-resize-full,.ba-imageviewer-elevate-theme-red-color .ba-commoncss-icon-resize-small,.ba-imageviewer-elevate-theme-red-color .ba-imageviewer-button-inner,.ba-imageviewer-elevate-theme-red-color.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#eb6a74}.ba-imageviewer-elevate-theme-red-color .ba-imageviewer-rerecord-button{background-color:#eb6a74}.ba-imageviewer-elevate-theme-blue-color .ba-commoncss-icon-resize-full,.ba-imageviewer-elevate-theme-blue-color .ba-commoncss-icon-resize-small,.ba-imageviewer-elevate-theme-blue-color .ba-imageviewer-button-inner,.ba-imageviewer-elevate-theme-blue-color.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#2a74eb}.ba-imageviewer-elevate-theme-blue-color .ba-imageviewer-rerecord-button{background-color:#2a74eb}.ba-imageviewer-elevate-theme-green-color .ba-commoncss-icon-resize-full,.ba-imageviewer-elevate-theme-green-color .ba-commoncss-icon-resize-small,.ba-imageviewer-elevate-theme-green-color .ba-imageviewer-button-inner,.ba-imageviewer-elevate-theme-green-color.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#5daa96}.ba-imageviewer-elevate-theme-green-color .ba-imageviewer-rerecord-button{background-color:#5daa96}.ba-imageviewer-elevate-theme .ba-commoncss-icon-resize-full{color:#666;display:inline-block}.ba-imageviewer-elevate-theme .ba-commoncss-icon-resize-full:before{font-size:11px;margin:0;line-height:inherit}.ba-imageviewer-elevate-theme .ba-imageviewer-dashboard{transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;position:absolute;left:2.5%;bottom:10px;width:95%;opacity:.75;overflow:hidden;z-index:1}.ba-imageviewer-elevate-theme .ba-imageviewer-dashboard-hidden{opacity:0}.ba-imageviewer-elevate-theme .ba-imageviewer-top-block{padding-top:15px;width:100%;clear:both}.ba-imageviewer-elevate-theme.ba-imageviewer-ie8 .ba-imageviewer-top-block{padding-top:0;padding-bottom:5px}.ba-imageviewer-elevate-theme .ba-imageviewer-bottom-block{background-color:#eee;clear:both;height:32px;overflow:hidden;width:100%}.ba-imageviewer-elevate-theme .ba-imageviewer-left-block{float:left}.ba-imageviewer-elevate-theme .ba-imageviewer-left-block>div{-moz-box-shadow:inset -1px 0 0 #666;-webkit-box-shadow:inset -1px 0 0 #666;box-shadow:inset -1px 0 0 #666;float:left;font-size:13px;color:#000;line-height:31px;text-align:center;width:40px}.ba-imageviewer-elevate-theme .ba-imageviewer-center-block{float:left;padding:0 10px}.ba-imageviewer-elevate-theme .ba-imageviewer-right-block{float:right}.ba-imageviewer-elevate-theme .ba-imageviewer-right-block>div{-moz-box-shadow:inset 1px 0 0 #666;-webkit-box-shadow:inset 1px 0 0 #666;box-shadow:inset 1px 0 0 #666;float:right;line-height:32px;text-align:center}.ba-imageviewer-elevate-theme .ba-imageviewer-right-block>div:first-child{float:left;line-height:31px}.ba-imageviewer-elevate-theme .ba-imageviewer-top-right-block{float:right}.ba-imageviewer-elevate-theme .ba-imageviewer-top-right-block .ba-imageviewer-time-value{text-align:right}.ba-imageviewer-elevate-theme .ba-imageviewer-button-container{width:40px;text-align:center}.ba-imageviewer-elevate-theme.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#000;font-size:13px}.ba-imageviewer-elevate-theme.ba-imageviewer-ie8 .ba-imageviewer-button-inner{color:#000;font-size:13px;margin-left:3px}.ba-imageviewer-elevate-theme .ba-imageviewer-button-inner{cursor:pointer}.ba-imageviewer-elevate-theme .ba-imageviewer-button-text{font-family:sans-serif;font-weight:400;font-size:10px}.ba-imageviewer-elevate-theme.ba-imageviewer-size-small .ba-imageviewer-center-block{display:none}.ba-imageviewer-elevate-theme .ba-imageviewer-image-title-block>p{font-size:11px;color:#000;line-height:32px;margin:0}.ba-imageviewer-elevate-theme .ba-imageviewer-image-title-block>p>span{color:#2c2c2c;font-weight:700;font-size:1em}.ba-imageviewer-elevate-theme .ba-imageviewer-top-left-block{float:left}.ba-imageviewer-elevate-theme.ba-imageviewer-noie8 .ba-imageviewer-full-screen-btn-inner{padding-left:4px}.ba-imageviewer-elevate-theme.ba-imageviewer-size-small .ba-imageviewer-dashboard{width:100%}.ba-imageviewer-elevate-theme .ba-imageviewer-button-inner,.ba-imageviewer-elevate-theme .ba-imageviewer-image-title-block>p{padding-top:1px}.ba-imageviewer-fullscreen-view.ba-imageviewer-elevate-theme .ba-imageviewer-dashboard{bottom:0;position:fixed;right:2.5%;width:95%;z-index:1010}.ba-audioplayer-container.ba-player-elevate-theme.ba-player-normal-view{border:1px solid;border-color:#555;border-color:transparent;min-height:80px;min-width:320px}.ba-audioplayer-container.ba-player-elevate-theme.ba-player-size-medium .ba-player-elevate-theme-right-time-container,.ba-audioplayer-container.ba-player-elevate-theme.ba-player-size-medium .ba-player-elevate-theme-volume-button-container,.ba-audioplayer-container.ba-player-elevate-theme.ba-player-size-small .ba-player-elevate-theme-center-block,.ba-audioplayer-container.ba-player-elevate-theme.ba-player-size-small .ba-player-elevate-theme-time-container,.ba-audioplayer-container.ba-player-elevate-theme.ba-player-size-small .ba-player-elevate-theme-volume-button-container,.ba-audioplayer-container.ba-player-elevate-theme.ba-player-size-small .ba-player-elevate-theme-volumebar{display:block}.ba-player-elevate-theme-dashboard{padding:3px;z-index:10}.ba-player-elevate-theme-visual-effect-applied .ba-player-elevate-theme-dashboard{position:absolute;bottom:0;width:95%}.ba-player-elevate-theme-audio-canvas{display:none;position:absolute;background-color:#000}.ba-player-elevate-theme-visual-effect-applied .ba-audioplayer-overlay{background:#000}.ba-player-elevate-theme-top-block{padding-top:8px}.ba-player-elevate-theme-bottom-block{border:1px solid;border-color:#555;border-color:rgba(0,0,0,.8);box-sizing:content-box}.ba-player-elevate-theme-title-block>p{font-size:11px;color:#000;line-height:32px;margin:0}.ba-player-elevate-theme-title-block>p>span{color:#2c2c2c;font-weight:700;font-size:1em}/*!\nbetajs-media-components - v0.0.291 - 2022-01-08\nCopyright (c) Ziggeo,Oliver Friedmann,Rashad Aliyev\nApache-2.0 Software License.\n*/.ba-player-red-color .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container .ba-player-minimalist-theme-button-inner,.ba-player-red-color .ba-player-minimalist-theme-title p{color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-minimalist-theme-playbutton-container{border-color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-minimalist-theme-playbutton-button::after{color:#eb6a74}.ba-player-red-color .ba-player-minimalist-theme-right-button-container.ba-commoncss-settings-visible .ba-commoncss-icon-cog,.ba-player-red-color .ba-player-minimalist-theme-right-button-container.ba-player-button-active .ba-commoncss-icon-subtitle{color:#eb6a74}.ba-player-red-color .ba-player-minimalist-theme-right-button-container .ba-player-minimalist-theme-primary-button,.ba-player-red-color .ba-player-minimalist-theme-right-button-container.ba-commoncss-settings-hidden,.ba-player-red-color .ba-player-minimalist-theme-right-button-container.ba-player-button-inactive{background-color:#eb6a74}.ba-player-red-color .ba-player-minimalist-theme-right-button-container.ba-player-button-inactive .ba-commoncss-icon-subtitle{color:#eee}.ba-player-red-color .ba-player-minimalist-theme-playbutton-duration,.ba-player-red-color .ba-player-minimalist-theme-progressbar-button,.ba-player-red-color .ba-player-minimalist-theme-progressbar-position,.ba-player-red-color .ba-player-minimalist-theme-rerecord-button,.ba-player-red-color .ba-player-minimalist-theme-stream-label,.ba-player-red-color .ba-player-minimalist-theme-time-container,.ba-player-red-color .ba-player-minimalist-theme-volumebar-position{background-color:#eb6a74}.ba-player-blue-color .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container .ba-player-minimalist-theme-button-inner,.ba-player-blue-color .ba-player-minimalist-theme-title p{color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-minimalist-theme-playbutton-container{border-color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-minimalist-theme-playbutton-button::after{color:#2a74eb}.ba-player-blue-color .ba-player-minimalist-theme-right-button-container.ba-commoncss-settings-visible .ba-commoncss-icon-cog,.ba-player-blue-color .ba-player-minimalist-theme-right-button-container.ba-player-button-active .ba-commoncss-icon-subtitle{color:#2a74eb}.ba-player-blue-color .ba-player-minimalist-theme-right-button-container .ba-player-minimalist-theme-primary-button,.ba-player-blue-color .ba-player-minimalist-theme-right-button-container.ba-commoncss-settings-hidden,.ba-player-blue-color .ba-player-minimalist-theme-right-button-container.ba-player-button-inactive{background-color:#2a74eb}.ba-player-blue-color .ba-player-minimalist-theme-right-button-container.ba-player-button-inactive .ba-commoncss-icon-subtitle{color:#eee}.ba-player-blue-color .ba-player-minimalist-theme-playbutton-duration,.ba-player-blue-color .ba-player-minimalist-theme-progressbar-button,.ba-player-blue-color .ba-player-minimalist-theme-progressbar-position,.ba-player-blue-color .ba-player-minimalist-theme-rerecord-button,.ba-player-blue-color .ba-player-minimalist-theme-stream-label,.ba-player-blue-color .ba-player-minimalist-theme-time-container,.ba-player-blue-color .ba-player-minimalist-theme-volumebar-position{background-color:#2a74eb}.ba-player-green-color .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container .ba-player-minimalist-theme-button-inner,.ba-player-green-color .ba-player-minimalist-theme-title p{color:#5daa96}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-minimalist-theme-playbutton-container{border-color:#5daa96}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-minimalist-theme-playbutton-button::after{color:#5daa96}.ba-player-green-color .ba-player-minimalist-theme-right-button-container.ba-commoncss-settings-visible .ba-commoncss-icon-cog,.ba-player-green-color .ba-player-minimalist-theme-right-button-container.ba-player-button-active .ba-commoncss-icon-subtitle{color:#5daa96}.ba-player-green-color .ba-player-minimalist-theme-right-button-container .ba-player-minimalist-theme-primary-button,.ba-player-green-color .ba-player-minimalist-theme-right-button-container.ba-commoncss-settings-hidden,.ba-player-green-color .ba-player-minimalist-theme-right-button-container.ba-player-button-inactive{background-color:#5daa96}.ba-player-green-color .ba-player-minimalist-theme-right-button-container.ba-player-button-inactive .ba-commoncss-icon-subtitle{color:#eee}.ba-player-green-color .ba-player-minimalist-theme-playbutton-duration,.ba-player-green-color .ba-player-minimalist-theme-progressbar-button,.ba-player-green-color .ba-player-minimalist-theme-progressbar-position,.ba-player-green-color .ba-player-minimalist-theme-rerecord-button,.ba-player-green-color .ba-player-minimalist-theme-stream-label,.ba-player-green-color .ba-player-minimalist-theme-time-container,.ba-player-green-color .ba-player-minimalist-theme-volumebar-position{background-color:#5daa96}.ba-player-minimalist-theme{font-family:sans-serif}.ba-player-minimalist-theme .ba-settings-overlay-inner{right:4%}.ba-player-minimalist-theme-dashboard{transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;height:100%;overflow:hidden;padding:0 4%}.ba-player-minimalist-theme-dashboard .ba-player-airplay-container{bottom:13px;left:5px;padding-top:2px;position:relative}.ba-player-minimalist-theme-dashboard .ba-player-airplay-container svg path{text-shadow:0 0 4px #000}.ba-player-minimalist-theme-button-container{font-family:sans-serif;font-weight:300;display:inline-block;width:40px;color:#eee}.ba-player-minimalist-theme-button-container[data-selector=button-icon-pause]:focus i.ba-commoncss-icon-play,.ba-player-minimalist-theme-button-container[data-selector=button-icon-play]:focus i.ba-commoncss-icon-play{outline:1px solid #8bc2f9}.ba-player-minimalist-theme-button-container[data-selector=button-icon-pause]:focus i.ba-commoncss-icon-play:active,.ba-player-minimalist-theme-button-container[data-selector=button-icon-pause]:focus i.ba-commoncss-icon-play:hover,.ba-player-minimalist-theme-button-container[data-selector=button-icon-play]:focus i.ba-commoncss-icon-play:active,.ba-player-minimalist-theme-button-container[data-selector=button-icon-play]:focus i.ba-commoncss-icon-play:hover{border:none}.ba-player-minimalist-theme-controlbar-header{background-color:#ddd;background-color:rgba(0,0,0,.3);height:40px;left:0;letter-spacing:.05rem;line-height:25px;padding:0;position:absolute;text-align:left;width:100%}.ba-player-minimalist-theme-controlbar-header .ba-player-minimalist-theme-right-block{line-height:40px;position:absolute;right:4%;z-index:100}.ba-videoplayer-ie8 .ba-player-minimalist-theme-controlbar-header{display:none}.ba-player-minimalist-theme-controlbar-header-title-block{position:relative;width:100%;z-index:10}.ba-videoplayer-ie8 .ba-player-minimalist-theme-controlbar-header .ba-player-minimalist-theme-right-block{position:relative}.ba-videoplayer-ie8 .ba-player-minimalist-theme-controlbar-header-title-block{left:50px}.ba-player-minimalist-theme-title p{color:#eee;font-family:sans-serif;font-size:12px;font-weight:300;letter-spacing:.1em;line-height:40px;margin:0;padding:0 0 0 4%;text-align:left}.ba-videoplayer-noie8 .ba-player-minimalist-theme-controlbar-header .ba-player-minimalist-theme-button-inner{text-align:right;-webkit-transform:translateY(0);-moz-transform:translateY(0);-o-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.ba-videoplayer-noie8 .ba-player-minimalist-theme-topmessage-container .ba-player-minimalist-theme-rightbutton-container{width:25px;padding-top:5px}.ba-player-minimalist-theme-controlbar-header .ba-player-minimalist-theme-button-container{width:20px}.ba-player-minimalist-theme-controlbar-footer{position:relative;height:100%}.ba-player-minimalist-theme-controlbar-top-block{height:100%}.ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container{position:relative;margin:0 auto;height:100%;width:100%}.ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container .ba-player-minimalist-theme-button-inner{color:#e5e5e5;color:rgba(255,255,255,.6);text-shadow:0 0 4px #000;font-size:2.5em}.ba-videoplayer-ie8 .ba-player-minimalist-theme-controlbar-top-block{height:100%}.ba-videoplayer-ie8 .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container{top:45%}.ba-videoplayer-noie8 .ba-videoplayer-overlay .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-inner{transition:opacity .3s ease;-moz-transition:opacity .3s ease;-webkit-transition:opacity .3s ease;-o-transition:opacity .3s ease;-ms-transition:opacity .3s ease;opacity:0}.ba-videoplayer-noie8 .ba-videoplayer-overlay:hover .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-inner{transition:opacity .2s ease;-moz-transition:opacity .2s ease;-webkit-transition:opacity .2s ease;-o-transition:opacity .2s ease;-ms-transition:opacity .2s ease;opacity:.6}.ba-videoplayer-ie8 .ba-videoplayer-overlay{height:100%}.ba-videoplayer-ie8 .ba-videoplayer-overlay .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-inner{-moz-opacity:0;-khtml-opacity:0;opacity:0}.ba-videoplayer-ie8 .ba-videoplayer-overlay:hover .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-inner{-moz-opacity:.6;-khtml-opacity:.6;opacity:.6}.ba-player-minimalist-theme-button-inner{cursor:pointer;z-index:100;position:relative}.ba-player-minimalist-theme-right-block{float:right}.ba-videoplayer-noie8 .ba-player-minimalist-theme-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center}.ba-videoplayer-ie8 .ba-player-minimalist-theme-button-inner{margin-top:12px;text-align:center;font-size:13px;margin-left:3px}.ba-player-minimalist-theme-button-inner{color:#eee;font-size:13px}.ba-player-minimalist-theme-controlbar-middle-block{position:relative;bottom:45px}.ba-player-minimalist-theme-progressbar{overflow:hidden;height:15px}.ba-player-minimalist-theme-progressbar-cache{position:absolute;left:0;cursor:pointer;background-color:#b2b2b2;background-color:rgba(255,255,255,.3);height:4px}.ba-player-minimalist-theme-progressbar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;cursor:pointer;background-color:#eee;height:4px}.ba-player-minimalist-theme-progressbar.ba-player-disabled.ba-player-minimalist-theme-progressbar-cache,.ba-player-minimalist-theme-progressbar.ba-player-disabled.ba-player-minimalist-theme-progressbar-inner,.ba-player-minimalist-theme-progressbar.ba-player-disabled.ba-player-minimalist-theme-progressbar-position{cursor:not-allowed}.ba-player-minimalist-theme-progressbar-position{background-color:#979797;position:absolute;left:-3px;height:100%}.ba-player-minimalist-theme-progressbar-button{-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;background-color:#979797;box-sizing:content-box;border:none;position:absolute;right:-7px;top:-2px;z-index:1;width:8px;height:8px}.ba-player-minimalist-theme-progressbar-marker{position:absolute;top:-2px;height:8px;width:4px;background-color:#000}.ba-player-minimalist-theme-controlbar-bottom-block{position:relative;bottom:40px}.ba-player-minimalist-theme-player-rerecord{position:relative;top:5px}.ba-player-minimalist-theme-time-container{color:#b2b2b2;color:rgba(255,255,255,.7);background-color:#676f76;float:left;font-size:.8em;letter-spacing:.1em;margin-right:15px;padding:1px 3px;margin-top:-1px;opacity:.75;width:auto}.ba-player-minimalist-theme-time-container>div{float:left}.ba-player-minimalist-theme-time-container>div:first-child{color:#eee}.ba-player-minimalist-theme-time-container>p{float:left;margin:0 3px}.ba-player-minimalist-theme-stream-label{margin-top:15px;font-size:.7em;display:inline-block;padding:4px 3px 3px 4px;background-color:#979797;color:#fff;opacity:.75}.csstheme-size-small .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container .ba-player-minimalist-theme-button-inner{font-size:1.25em}.ba-player-minimalist-theme-volumebar{float:right;height:40px;margin-left:10px;position:relative;width:60px;z-index:10}.ba-player-minimalist-theme-volumebar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;cursor:pointer;background-color:#979797;height:6px}.ba-player-minimalist-theme-volumebar-position{border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;position:absolute;left:0;background-color:#eee;height:100%}.ba-player-size-medium .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container .ba-player-minimalist-theme-button-inner{font-size:2em}.ba-player-size-small .ba-player-minimalist-theme-volumebar{display:none}.ba-player-size-small .ba-player-minimalist-theme-controlbar-header{top:7px}.ba-player-size-small .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container .ba-player-minimalist-theme-button-inner{font-size:1.8em}.ba-player-size-small .ba-player-minimalist-theme-controlbar-middle-block{bottom:40px}.ba-player-size-small .ba-player-minimalist-theme-controlbar-bottom-block{bottom:38px}.ba-player-size-small .ba-player-minimalist-theme-time-container{font-size:.7em}.ba-player-minimalist-theme-cast-button-container button{text-shadow:0 0 4px #000;-moz-opacity:.7;-khtml-opacity:.7;opacity:.7;background:0 0;border:none;bottom:9px;cursor:pointer;left:5px;padding:0;position:relative;width:20px}.ba-player-minimalist-theme-right-button-container{cursor:pointer;bottom:4px;float:right;padding:1px 4px 2px;position:relative;margin-left:7px}.ba-player-minimalist-theme-right-button-container .ba-player-minimalist-theme-button-inner{line-height:40px;height:40px;width:40px}.ba-player-minimalist-theme-right-button-container .ba-commoncss-icon-cog,.ba-player-minimalist-theme-right-button-container .ba-commoncss-icon-subtitle{color:#eee;font-size:.8em}.ba-player-minimalist-theme-right-button-container.ba-commoncss-settings-visible,.ba-player-minimalist-theme-right-button-container.ba-player-button-active{background-color:#020202;opacity:.75}.ba-player-minimalist-theme-right-button-container.ba-commoncss-settings-hidden,.ba-player-minimalist-theme-right-button-container.ba-player-button-inactive{background-color:#979797;opacity:.75}.ba-player-minimalist-theme-primary-button-container{width:auto}.ba-player-minimalist-theme-primary-button-container>.ba-player-minimalist-theme-primary-button{height:auto;transform:none;padding:3px;line-height:normal;background-color:#979797}.ba-player-fullscreen-view video::-webkit-media-controls-overlay-enclosure{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-enclosure{display:none}.ba-player-fullscreen-view video::-webkit-media-controls{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-panel{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-play-button{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-current-time-display{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-time-remaining-display{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-timeline{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-mute-button{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-volume-slider{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-fullscreen-button{display:none}.ba-player-fullscreen-view video::-internal-media-controls-download-button{display:none}.ba-player-fullscreen-view video::-moz-list-bullet,.ba-player-fullscreen-view video::-moz-list-number{display:none}.ba-player-fullscreen-view video::-moz-meter-bar{display:none}.ba-player-fullscreen-view video:fullscreen:not(:root){display:none}.ba-player-fullscreen-view .ba-videoplayer-dashboard{bottom:0}.ba-player-fullscreen-view .ba-videoplayer-title-block{top:0}.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-dashboard,.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-title-block{z-index:100}.ba-player-fullscreen-view.ba-player-size-small .ba-videoplayer-controlbar-header{top:0}.ba-player-fullscreen-view.ba-player-size-small .ba-videoplayer-volumebar{display:block}.ba-videoplayer-container.ba-player-fullscreen-view{min-width:100%;position:absolute;min-height:fit-content}.ba-videoplayer-container.ba-player-fullscreen-view>.ba-videoplayer-overlay{position:fixed}.ba-videoplayer-noie8 .ba-videoplayer-topmessage-message .css-rightbutton-container{width:21px}.ba-videoplayer-topmessage-background{background-color:transparent;position:relative;height:40px}.ba-videoplayer-topmessage-message{line-height:25px;padding:0;text-align:left;font-size:.65rem;letter-spacing:.05rem;font-weight:300}.ba-videoplayer-topmessage-message{margin:0 2.5%}.ba-videoplayer-topmessage-message .ba-videoplayer-right-block{height:50px;line-height:50px}.ba-videoplayer-noie8 .ba-videoplayer-topmessage-message .ba-videoplayer-button-inner{-webkit-transform:translateY(0);-moz-transform:translateY(0);-o-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.ba-videoplayer-noie8 .ba-videoplayer-topmessage-container .ba-videoplayer-rightbutton-container{width:25px}.ba-videoplayer-topmessage-message .ba-videoplayer-button-container{width:20px}.ba-player-minimalist-theme.ba-videoplayer-container .ba-player-text-tracks-overlay{position:absolute;left:0;right:0;bottom:42px;transition:bottom .5s ease-in-out;-moz-transition:bottom .5s ease-in-out;-webkit-transition:bottom .5s ease-in-out;-o-transition:bottom .5s ease-in-out;-ms-transition:bottom .5s ease-in-out}.ba-player-minimalist-theme.ba-videoplayer-container .ba-player-text-tracks-overlay .ba-commoncss-options-popup{bottom:0;right:4%}.ba-player-minimalist-theme.ba-videoplayer-container .ba-player-track-dashboard-hidden.ba-player-text-tracks-overlay{bottom:5px}.ba-recorder-theme-minimalist .ba-commoncss-message-text{-moz-border-radius:50px;-webkit-border-radius:50px;border-radius:50px}.ba-recorder-theme-minimalist .ba-videorecorder-chooser-container{background-color:#eee;z-index:1}.ba-recorder-theme-minimalist .ba-videorecorder-chooser-icon-container{color:#000;font-size:32px;margin:16px}.ba-recorder-theme-minimalist .ba-videorecorder-chooser-button-0,.ba-recorder-theme-minimalist .ba-videorecorder-chooser-button-1,.ba-recorder-theme-minimalist .ba-videorecorder-chooser-button-2,.ba-recorder-theme-minimalist .ba-videorecorder-chooser-button-3{-moz-border-radius:50px;-webkit-border-radius:50px;border-radius:50px;line-height:20px;min-width:10em;padding:6px 8px}.ba-recorder-theme-minimalist .ba-videorecorder-chooser-button-0,.ba-recorder-theme-minimalist .ba-videorecorder-chooser-button-2{background-color:#000}.ba-recorder-theme-minimalist .ba-videorecorder-chooser-button-1,.ba-recorder-theme-minimalist .ba-videorecorder-chooser-button-3{background-color:#b2b2b2;background-color:rgba(255,255,255,.4);color:#666;margin-top:2px}.ba-recorder-theme-minimalist .ba-commoncss-icon-record:before{font-size:.8em}.ba-recorder-theme-minimalist .ba-commoncss-icon-upload:before{font-size:.9em}.ba-recorder-red-color .ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-primary{background-color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-red-color .ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-selected{color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{border-color:#eb6a74;background-color:#eb6a74}.ba-recorder-red-color .ba-recorder-loader-label,.ba-recorder-red-color .ba-videorecorder-button-circle-selected{color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-chooser-button-0,.ba-recorder-red-color .ba-videorecorder-chooser-button-2,.ba-recorder-red-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-red-color .ba-videorecorder-imagegallery-rightbutton{background-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-imagegallery-image:hover{border-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-message-message a{color:#eb6a74}.ba-recorder-blue-color .ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-primary{background-color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-blue-color .ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-selected{color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{border-color:#2a74eb;background-color:#2a74eb}.ba-recorder-blue-color .ba-recorder-loader-label,.ba-recorder-blue-color .ba-videorecorder-button-circle-selected{color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-chooser-button-0,.ba-recorder-blue-color .ba-videorecorder-chooser-button-2,.ba-recorder-blue-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-blue-color .ba-videorecorder-imagegallery-rightbutton{background-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-imagegallery-image:hover{border-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-message-message a{color:#2a74eb}.ba-recorder-green-color .ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-primary{background-color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-green-color .ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-selected{color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{border-color:#5daa96;background-color:#5daa96}.ba-recorder-green-color .ba-recorder-loader-label,.ba-recorder-green-color .ba-videorecorder-button-circle-selected{color:#5daa96}.ba-recorder-green-color .ba-videorecorder-chooser-button-0,.ba-recorder-green-color .ba-videorecorder-chooser-button-2,.ba-recorder-green-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-green-color .ba-videorecorder-imagegallery-rightbutton{background-color:#5daa96}.ba-recorder-green-color .ba-videorecorder-imagegallery-image:hover{border-color:#5daa96}.ba-recorder-green-color .ba-videorecorder-message-message a{color:#5daa96}.ba-recorder-theme-minimalist.ba-videorecorder-container .ba-videorecorder-video{background-color:#000}.ba-recorder-theme-minimalist-dashboard{position:absolute;left:0;right:0;top:0;bottom:0;height:100%}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings-left-sidebar{display:table;height:100%;text-align:center;bottom:0;left:0;position:absolute;right:auto;top:0;width:55px}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings-left-sidebar .ba-videorecorder-controlbar-left-section{display:table-cell;vertical-align:middle}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings-left-sidebar .ba-videorecorder-controlbar-left-section .ba-videorecorder-circle-button-container{margin:2px auto}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-controlbar-middle-section .ba-videorecorder-timer-container{display:table;cursor:default;height:100%;position:absolute;width:100%}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-controlbar-middle-section .ba-videorecorder-timer-container .ba-videorecorder-label-container{display:table-cell;float:none;position:relative;text-align:center;vertical-align:middle;width:auto}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-controlbar-middle-section .ba-videorecorder-timer-container .ba-videorecorder-label-container .ba-videorecorder-button-primary{margin:0;padding:7px 16px}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-controlbar{position:absolute;left:0;right:0;bottom:0;height:55px;padding:0 10px}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-long-rounded-button{-moz-border-radius:18px;-webkit-border-radius:18px;border-radius:18px;display:inline-block}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-long-rounded-button>p{font-family:sans-serif;font-size:12px;padding:7px;margin:0}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-circle-button{background-color:#979797;background-color:rgba(0,0,0,.4);-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;color:#eee;display:inline-block;height:40px;line-height:40px;text-align:center;width:40px}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-circle-selected,.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-selected{color:#000;cursor:pointer}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-inner{border:none;cursor:pointer;font-size:inherit;margin:0;padding:0;width:100%}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-inner i:before{line-height:inherit}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings{position:inherit}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings .ba-videorecorder-add-stream,.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings label{font-family:sans-serif;font-weight:300;font-size:12px}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{border:3px solid #eee;background-color:#000}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings .ba-videorecorder-circle-button{margin:6px 0}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-primary{-moz-border-radius:18px;-webkit-border-radius:18px;border-radius:18px;background-color:#000;display:inline-block;font-family:sans-serif;font-weight:300;font-size:12px;margin-top:6px;min-width:3em;padding:10px 16px;position:relative;left:0;right:0;top:0;bottom:0;-webkit-transform:translate(0,0);-moz-transform:translate(0,0);-o-transform:translate(0,0);-ms-transform:translate(0,0);transform:translate(0,0);z-index:10}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings-button{background:#eee;cursor:pointer;margin:15px 0 0 15px}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-settings-button>p{color:#979797}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-bubble-info-container{background-color:#7f7f7f;background-color:rgba(0,0,0,.5);-moz-border-radius:16px;-webkit-border-radius:16px;border-radius:16px;display:inline-block;padding:9px 0;line-height:1.2;min-width:280px;position:relative;left:60px}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-bubble-info-container:before{border-right:9px solid;border-right-color:#7f7f7f;border-right-color:rgba(0,0,0,.5);border-bottom:6px solid transparent;border-top:6px solid transparent;content:\"\";height:0;top:13px;position:absolute;left:-9px;width:0}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-bubble-info-container{position:absolute}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-bubble-info{max-height:10em;overflow:scroll}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-bubble-info li{text-align:left}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-controlbar-center-section{position:absolute;left:0;text-align:center;width:100%}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-button-container{display:inline-block}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-label-container{float:left;text-align:right;width:50%;opacity:.25}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-label-container .ba-videorecorder-button-primary{color:#eee;background-color:#979797;background-color:rgba(0,0,0,.4)}.ba-recorder-theme-minimalist-dashboard .ba-videorecorder-stop-button-container{text-align:center}.ba-recorder-theme-minimalist.ba-videorecorder-container .ba-videorecorder-imagegallery-container{left:50px;right:50px}.ba-recorder-overlay img,.ba-videorecorder-imagegallery-image{border:none;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px}.ba-videorecorder-imagegallery-image:hover{border:2px solid;border-color:#b2b2b2;border-color:rgba(0,0,0,.4)}.ba-videorecorder-imagegallery-leftbutton,.ba-videorecorder-imagegallery-rightbutton{border-radius:50%;background-color:#4c4c4c;height:30px;width:30px;z-index:10}.ba-recorder-theme-minimalist .ba-videorecorder-topmessage-container{text-align:center}.ba-recorder-theme-minimalist .ba-videorecorder-topmessage-message{background-color:#666;background-color:rgba(255,255,255,.4);-moz-border-radius:18px;-webkit-border-radius:18px;border-radius:18px;color:#eee;display:inline-block;font-family:sans-serif;font-size:12px;font-weight:300;padding:7px;position:relative;top:12px;z-index:10}.ba-recorder-theme-minimalist .ba-videorecorder-topmessage-background{background:0 0}.ba-imageviewer-minimalist-theme-red-color .ba-imageviewer-button-inner,.ba-imageviewer-minimalist-theme-red-color .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-container .ba-imageviewer-button-inner,.ba-imageviewer-minimalist-theme-red-color .ba-imageviewer-right-block .ba-commoncss-icon-resize-full,.ba-imageviewer-minimalist-theme-red-color .ba-imageviewer-right-block .ba-commoncss-icon-resize-small,.ba-imageviewer-minimalist-theme-red-color .ba-imageviewer-title p{color:#eb6a74}.ba-imageviewer-minimalist-theme-red-color .ba-imageviewer-rerecord-button{background-color:#eb6a74}.ba-imageviewer-minimalist-theme-blue-color .ba-imageviewer-button-inner,.ba-imageviewer-minimalist-theme-blue-color .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-container .ba-imageviewer-button-inner,.ba-imageviewer-minimalist-theme-blue-color .ba-imageviewer-right-block .ba-commoncss-icon-resize-full,.ba-imageviewer-minimalist-theme-blue-color .ba-imageviewer-right-block .ba-commoncss-icon-resize-small,.ba-imageviewer-minimalist-theme-blue-color .ba-imageviewer-title p{color:#2a74eb}.ba-imageviewer-minimalist-theme-blue-color .ba-imageviewer-rerecord-button{background-color:#2a74eb}.ba-imageviewer-minimalist-theme-green-color .ba-imageviewer-button-inner,.ba-imageviewer-minimalist-theme-green-color .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-container .ba-imageviewer-button-inner,.ba-imageviewer-minimalist-theme-green-color .ba-imageviewer-right-block .ba-commoncss-icon-resize-full,.ba-imageviewer-minimalist-theme-green-color .ba-imageviewer-right-block .ba-commoncss-icon-resize-small,.ba-imageviewer-minimalist-theme-green-color .ba-imageviewer-title p{color:#5daa96}.ba-imageviewer-minimalist-theme-green-color .ba-imageviewer-rerecord-button{background-color:#5daa96}.ba-imageviewer-minimalist-theme{display:block}.ba-imageviewer-minimalist-theme .ba-imageviewer-dashboard{transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;height:100%;overflow:hidden;padding:0 4%}.ba-imageviewer-minimalist-theme .ba-imageviewer-dashboard-hidden{opacity:0}.ba-imageviewer-minimalist-theme .ba-imageviewer-button-container{font-family:sans-serif;font-weight:300;display:inline-block;width:40px;color:#eee}.ba-imageviewer-minimalist-theme .ba-imageviewer-controlbar-header{background-color:#ddd;background-color:rgba(0,0,0,.3);height:40px;left:0;letter-spacing:.05rem;line-height:25px;padding:0;position:absolute;text-align:left;width:100%}.ba-imageviewer-minimalist-theme .ba-imageviewer-controlbar-header .ba-imageviewer-right-block{line-height:40px;position:absolute;right:4%;z-index:100}.ba-imageviewer-minimalist-theme.ba-imageviewer-ie8 .ba-imageviewer-controlbar-header{display:none}.ba-imageviewer-minimalist-theme .ba-imageviewer-controlbar-header-title-block{position:relative;width:100%;z-index:10}.ba-imageviewer-minimalist-theme.ba-imageviewer-ie8 .ba-imageviewer-controlbar-header .ba-imageviewer-right-block{position:relative}.ba-imageviewer-minimalist-theme.ba-imageviewer-ie8 .ba-imageviewer-controlbar-header-title-block{left:50px}.ba-imageviewer-minimalist-theme .ba-imageviewer-title p{color:#eee;font-family:sans-serif;font-size:12px;font-weight:300;letter-spacing:.1em;line-height:40px;margin:0;padding:0 0 0 15px;text-align:left}.ba-imageviewer-minimalist-theme.ba-imageviewer-noie8 .ba-imageviewer-controlbar-header .ba-imageviewer-button-inner{text-align:right;-webkit-transform:translateY(0);-moz-transform:translateY(0);-o-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.ba-imageviewer-minimalist-theme.ba-imageviewer-noie8 .ba-imageviewer-topmessage-container .ba-imageviewer-rightbutton-container{width:25px;padding-top:5px}.ba-imageviewer-minimalist-theme .ba-imageviewer-controlbar-header .ba-imageviewer-button-container{width:20px}.ba-imageviewer-minimalist-theme .ba-imageviewer-controlbar-footer{position:relative;height:100%}.ba-imageviewer-minimalist-theme .ba-imageviewer-controlbar-top-block{height:100%}.ba-imageviewer-minimalist-theme .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-container{position:relative;margin:0 auto;height:100%;width:100%}.ba-imageviewer-minimalist-theme .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-container .ba-imageviewer-button-inner{color:#e5e5e5;color:rgba(255,255,255,.6);text-shadow:0 0 4px #000;font-size:2.5em}.ba-imageviewer-minimalist-theme.ba-imageviewer-ie8 .ba-imageviewer-controlbar-top-block{height:100%}.ba-imageviewer-minimalist-theme.ba-imageviewer-ie8 .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-container{top:45%}.ba-imageviewer-minimalist-theme.ba-imageviewer-noie8 .ba-imageviewer-overlay .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-inner{transition:opacity .3s ease;-moz-transition:opacity .3s ease;-webkit-transition:opacity .3s ease;-o-transition:opacity .3s ease;-ms-transition:opacity .3s ease;opacity:0}.ba-imageviewer-minimalist-theme.ba-imageviewer-noie8 .ba-imageviewer-overlay:hover .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-inner{transition:opacity .2s ease;-moz-transition:opacity .2s ease;-webkit-transition:opacity .2s ease;-o-transition:opacity .2s ease;-ms-transition:opacity .2s ease;opacity:.6}.ba-imageviewer-minimalist-theme.ba-imageviewer-ie8 .ba-imageviewer-overlay{height:100%}.ba-imageviewer-minimalist-theme.ba-imageviewer-ie8 .ba-imageviewer-overlay .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-inner{-moz-opacity:0;-khtml-opacity:0;opacity:0}.ba-imageviewer-minimalist-theme.ba-imageviewer-ie8 .ba-imageviewer-overlay:hover .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-inner{-moz-opacity:.6;-khtml-opacity:.6;opacity:.6}.ba-imageviewer-minimalist-theme .ba-imageviewer-button-inner{cursor:pointer;z-index:100;position:relative}.ba-imageviewer-minimalist-theme .ba-imageviewer-right-block{float:right}.ba-imageviewer-minimalist-theme.ba-imageviewer-noie8 .ba-imageviewer-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center}.ba-imageviewer-minimalist-theme.ba-imageviewer-ie8 .ba-imageviewer-button-inner{margin-top:12px;text-align:center;font-size:13px;margin-left:3px}.ba-imageviewer-minimalist-theme .ba-imageviewer-button-inner{color:#eee;font-size:13px}.ba-imageviewer-minimalist-theme .ba-imageviewer-controlbar-middle-block{position:relative;bottom:45px}.ba-imageviewer-minimalist-theme .ba-imageviewer-controlbar-bottom-block{position:relative;bottom:40px}.ba-imageviewer-minimalist-theme .ba-imageviewer-player-rerecord{position:relative;top:5px}.ba-imageviewer-minimalist-theme.ba-imageviewer-size-small .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-container .ba-imageviewer-button-inner{font-size:1.25em}.ba-imageviewer-minimalist-theme.ba-imageviewer-size-medium .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-container .ba-imageviewer-button-inner{font-size:2em}.ba-imageviewer-minimalist-theme.ba-imageviewer-size-small .ba-imageviewer-controlbar-header{top:7px}.ba-imageviewer-minimalist-theme.ba-imageviewer-size-small .ba-imageviewer-controlbar-top-block .ba-imageviewer-button-container .ba-imageviewer-button-inner{font-size:1.8em}.ba-imageviewer-minimalist-theme.ba-imageviewer-size-small .ba-imageviewer-controlbar-middle-block{bottom:40px}.ba-imageviewer-minimalist-theme.ba-imageviewer-size-small .ba-imageviewer-controlbar-bottom-block{bottom:38px}.ba-imageviewer-minimalist-theme.ba-imageviewer-size-small .ba-imageviewer-time-container{font-size:.7em}.ba-imageviewer-fullscreen-view.ba-imageviewer-minimalist-theme .ba-imageviewer-controlbar-header{position:fixed;top:0;width:100%;z-index:1005}.ba-imageviewer-minimalist-theme.ba-imageviewer-noie8 .ba-imageviewer-topmessage-message .css-rightbutton-container{width:21px}.ba-imageviewer-minimalist-theme .ba-imageviewer-topmessage-background{background-color:transparent;position:relative;height:40px}.ba-imageviewer-minimalist-theme .ba-imageviewer-topmessage-message{line-height:25px;padding:0;text-align:left;font-size:.65rem;letter-spacing:.05rem;font-weight:300}.ba-imageviewer-minimalist-theme .ba-imageviewer-topmessage-message{margin:0 2.5%}.ba-imageviewer-minimalist-theme .ba-imageviewer-topmessage-message .ba-imageviewer-right-block{height:50px;line-height:50px}.ba-imageviewer-minimalist-theme.ba-imageviewer-noie8 .ba-imageviewer-topmessage-message .ba-imageviewer-button-inner{-webkit-transform:translateY(0);-moz-transform:translateY(0);-o-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.ba-imageviewer-minimalist-theme.ba-imageviewer-noie8 .ba-imageviewer-topmessage-container .ba-imageviewer-rightbutton-container{width:25px}.ba-imageviewer-minimalist-theme .ba-imageviewer-topmessage-message .ba-imageviewer-button-container{width:20px}.ba-audioplayer-container{box-sizing:border-box;border:1px solid #eee;height:140px;min-height:140px;min-width:320px}.ba-player-minimalist-theme.ba-audioplayer-container .ba-audioplayer-overlay{z-index:10}.ba-player-minimalist-theme.ba-audioplayer-container .ba-player-size-medium .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container .ba-player-minimalist-theme-button-inner{font-size:2em}.ba-player-minimalist-theme.ba-audioplayer-container .ba-player-size-small .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container .ba-player-minimalist-theme-button-inner{font-size:1.25em}.ba-player-minimalist-theme.ba-audioplayer-container .ba-player-size-small .ba-player-minimalist-theme-volumebar{display:none}.ba-player-minimalist-theme.ba-audioplayer-container .ba-player-size-small .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container .ba-player-minimalist-theme-button-inner{font-size:1.8em}.ba-player-minimalist-theme.ba-audioplayer-container .ba-player-size-small .ba-player-minimalist-theme-controlbar-middle-block{bottom:40px}.ba-player-minimalist-theme.ba-audioplayer-container .ba-player-size-small .ba-player-minimalist-theme-controlbar-bottom-block{bottom:38px}.ba-player-minimalist-theme.ba-audioplayer-container .ba-player-size-small .ba-player-minimalist-theme-time-container{font-size:.7em}.ba-player-minimalist-theme-dashboard{position:absolute;left:0;right:0;bottom:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;opacity:.9;height:100%;overflow:hidden;padding:0 4%}.ba-player-minimalist-theme-audio-canvas{display:none;position:absolute;background-color:#000}.ba-player-minimalist-theme-visual-effect-applied .ba-audioplayer-overlay{background:#000}.ba-player-minimalist-theme-visual-effect-applied .ba-player-minimalist-theme-controlbar-middle-block{z-index:10}.ba-audioplayer-noie8 .ba-player-minimalist-theme-controlbar-header .ba-player-minimalist-theme-button-inner{text-align:right;-webkit-transform:translateY(0);-moz-transform:translateY(0);-o-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.ba-audioplayer-ie8 .ba-player-minimalist-theme-controlbar-top-block{height:100%}.ba-audioplayer-ie8 .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-container{top:45%}.ba-audioplayer-noie8 .ba-audioplayer-overlay .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-inner{transition:opacity .3s ease;-moz-transition:opacity .3s ease;-webkit-transition:opacity .3s ease;-o-transition:opacity .3s ease;-ms-transition:opacity .3s ease;opacity:1}.ba-audioplayer-ie8 .ba-audioplayer-overlay{height:100%}.ba-audioplayer-ie8 .ba-audioplayer-overlay .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-inner{-moz-opacity:0;-khtml-opacity:0;opacity:0}.ba-audioplayer-ie8 .ba-audioplayer-overlay:hover .ba-player-minimalist-theme-controlbar-top-block .ba-player-minimalist-theme-button-inner{-moz-opacity:.6;-khtml-opacity:.6;opacity:.6}.ba-audioplayer-noie8 .ba-player-minimalist-theme-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center}.ba-audioplayer-ie8 .ba-player-minimalist-theme-button-inner{margin-top:12px;text-align:center;font-size:13px;margin-left:3px}.ba-player-minimalist-theme-button-inner{color:#eee;font-size:13px}.ba-player-minimalist-theme-controlbar-middle-block{position:relative;bottom:45px}.ba-player-minimalist-theme-controlbar-bottom-block{position:relative;bottom:40px}.ba-player-minimalist-theme-player-rerecord{position:relative;top:5px}/*!\nbetajs-media-components - v0.0.291 - 2022-01-08\nCopyright (c) Ziggeo,Oliver Friedmann,Rashad Aliyev\nApache-2.0 Software License.\n*/.ba-player-red-color .ba-player-theatre-theme-button-inner i,.ba-player-red-color .ba-player-theatre-theme-button-inner.ba-player-theatre-theme-primary-button,.ba-player-red-color .ba-player-theatre-theme-title,.ba-player-red-color.ba-player-theatre-theme .ba-commoncss-settings-hidden i,.ba-player-red-color.ba-player-theatre-theme .ba-player-button-inactive i{color:#eb6a74}.ba-player-red-color .ba-commoncss-settings-visible,.ba-player-red-color .ba-player-button-active,.ba-player-red-color .ba-player-theatre-theme-playbutton-duration,.ba-player-red-color .ba-player-theatre-theme-progressbar-position,.ba-player-red-color .ba-player-theatre-theme-rerecord-button,.ba-player-red-color .ba-player-theatre-theme-stream-label-container .ba-player-theatre-theme-stream-label,.ba-player-red-color .ba-player-theatre-theme-volumebar-position{background-color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-container{border-color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-button::after{color:#eb6a74}.ba-player-red-color .ba-player-theatre-theme-volumebar-inner{background-color:#7f7f7f;background-color:rgba(255,255,255,.3)}.ba-player-red-color .ba-commoncss-accent-color,.ba-player-red-color .ba-commoncss-settings-visible i,.ba-player-red-color .ba-player-button-active i{color:#eee}.ba-player-blue-color .ba-player-theatre-theme-button-inner i,.ba-player-blue-color .ba-player-theatre-theme-button-inner.ba-player-theatre-theme-primary-button,.ba-player-blue-color .ba-player-theatre-theme-title,.ba-player-blue-color.ba-player-theatre-theme .ba-commoncss-settings-hidden i,.ba-player-blue-color.ba-player-theatre-theme .ba-player-button-inactive i{color:#2a74eb}.ba-player-blue-color .ba-commoncss-settings-visible,.ba-player-blue-color .ba-player-button-active,.ba-player-blue-color .ba-player-theatre-theme-playbutton-duration,.ba-player-blue-color .ba-player-theatre-theme-progressbar-position,.ba-player-blue-color .ba-player-theatre-theme-rerecord-button,.ba-player-blue-color .ba-player-theatre-theme-stream-label-container .ba-player-theatre-theme-stream-label,.ba-player-blue-color .ba-player-theatre-theme-volumebar-position{background-color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-container{border-color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-button::after{color:#2a74eb}.ba-player-blue-color .ba-player-theatre-theme-volumebar-inner{background-color:#7f7f7f;background-color:rgba(255,255,255,.3)}.ba-player-blue-color .ba-commoncss-accent-color,.ba-player-blue-color .ba-commoncss-settings-visible i,.ba-player-blue-color .ba-player-button-active i{color:#eee}.ba-player-green-color .ba-player-theatre-theme-button-inner i,.ba-player-green-color .ba-player-theatre-theme-button-inner.ba-player-theatre-theme-primary-button,.ba-player-green-color .ba-player-theatre-theme-title,.ba-player-green-color.ba-player-theatre-theme .ba-commoncss-settings-hidden i,.ba-player-green-color.ba-player-theatre-theme .ba-player-button-inactive i{color:#5daa96}.ba-player-green-color .ba-commoncss-settings-visible,.ba-player-green-color .ba-player-button-active,.ba-player-green-color .ba-player-theatre-theme-playbutton-duration,.ba-player-green-color .ba-player-theatre-theme-progressbar-position,.ba-player-green-color .ba-player-theatre-theme-rerecord-button,.ba-player-green-color .ba-player-theatre-theme-stream-label-container .ba-player-theatre-theme-stream-label,.ba-player-green-color .ba-player-theatre-theme-volumebar-position{background-color:#5daa96}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-container{border-color:#5daa96}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-button::after{color:#5daa96}.ba-player-green-color .ba-player-theatre-theme-volumebar-inner{background-color:#7f7f7f;background-color:rgba(255,255,255,.3)}.ba-player-green-color .ba-commoncss-accent-color,.ba-player-green-color .ba-commoncss-settings-visible i,.ba-player-green-color .ba-player-button-active i{color:#eee}.ba-player-theatre-theme{font-family:Arial,sans-serif}.ba-player-theatre-theme .ba-commoncss-icon-pause,.ba-player-theatre-theme .ba-commoncss-icon-play{color:#000}.ba-player-theatre-theme .ba-commoncss-icon-volume-down,.ba-player-theatre-theme .ba-commoncss-icon-volume-up{color:#666}.ba-player-theatre-theme .ba-commoncss-icon-volume-off{color:#000}.ba-player-theatre-theme .ba-commoncss-icon-resize-full{color:#666}.ba-player-theatre-theme .ba-commoncss-settings-hidden i,.ba-player-theatre-theme .ba-player-button-inactive i{color:#666}.ba-player-theatre-theme .ba-commoncss-settings-menu{right:12.5%}.ba-videoplayer-container .ba-player-theatre-theme-dashboard{transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;background-color:#eee;box-sizing:border-box;bottom:15px;border:1px solid #666;height:28px;left:12.5%;opacity:.75;position:absolute;width:75%}.ba-videoplayer-container .ba-player-theatre-theme-dashboard .ba-player-airplay-container{padding:2px 7px 0 3px}.ba-videoplayer-container .ba-player-theatre-theme-dashboard .ba-player-airplay-container svg path{fill:#666}.ba-videoplayer-container .ba-player-dashboard-hidden{opacity:0}.ba-player-theatre-theme-left-block{float:left;padding-left:5px}.ba-player-theatre-theme-left-block>div{float:left;height:28px;line-height:29px}.ba-player-theatre-theme-left-block>div:last-child{float:right}.ba-videoplayer-ie8 .ba-player-theatre-theme-left-block>div{line-height:28px}.ba-player-theatre-theme-center-block{float:left}.ba-player-theatre-theme-right-block{float:right}.ba-player-theatre-theme-right-block>div{float:right;height:25px;line-height:25px;text-align:center}.ba-player-theatre-theme-right-block>div:first-child{line-height:25px;width:30px}.ba-player-theatre-theme-right-block>div:last-child{float:left;line-height:31px}.ba-player-theatre-theme-right-block .ba-player-theatre-theme-time-value{text-align:left}.ba-player-theatre-theme-title-container{position:absolute;left:0;right:0;top:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;width:100%}.ba-player-theatre-theme-title-container>p{background-color:#eee;background-color:rgba(255,255,255,.4);position:relative;margin:auto;height:28px;line-height:28px;top:15px;text-align:center;color:#020202;width:75%}.ba-player-theatre-theme-leftbutton-container{float:left;width:40px;height:100%;cursor:pointer;box-sizing:content-box;border:none;text-align:center;line-height:2}.ba-videoplayer-noie8 .ba-player-theatre-theme-rightbutton-container{float:right;width:40px;height:100%;cursor:pointer;box-sizing:content-box;border:none}.ba-videoplayer-ie8 .ba-player-theatre-theme-rightbutton-container{float:right;width:40px;height:50%;cursor:pointer;box-sizing:content-box;border:none}.ba-videoplayer-noie8 .ba-player-theatre-theme-button-inner{color:#666;font-size:13px}.ba-videoplayer-ie8 .ba-player-theatre-theme-button-inner{color:#000;font-size:13px;margin-left:3px}.ba-player-theatre-theme-button-inner{cursor:pointer;position:relative}.ba-player-theatre-theme-time-container{float:left;width:40px;height:100%;text-align:center;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:11px;color:#666;box-sizing:content-box;border:none}.ba-player-theatre-theme-time-value{float:left;font-size:11px;width:40px;letter-spacing:.1em}.ba-videoplayer-noie8 .ba-player-theatre-theme-time-value{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center}.ba-videoplayer-noie8 .ba-player-theatre-theme-volumebar{float:left;margin-right:120px;width:7px}.ba-player-theatre-theme-volumebar{visibility:hidden;opacity:0;transition:visibility 0s,opacity .5s linear;background-color:#eee;box-sizing:content-box;bottom:27px;height:60px;margin:0 auto;padding:5px;position:absolute;width:auto}.ba-player-theatre-theme-volume-icon-container:hover .ba-player-theatre-theme-volumebar,.ba-player-theatre-theme-volumebar:hover{visibility:visible;opacity:1;transition:visibility 0s,opacity .2s linear}.ba-player-theatre-theme-volume-icon-container{padding:0 2px}.ba-videoplayer-ie8 .ba-player-theatre-theme-volumebar{float:right;width:7px;height:50%;margin-right:120px}.ba-player-theatre-theme-volumebar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;border-bottom-left-radius:30px;border-bottom-right-radius:30px;border-top-left-radius:30px;border-top-right-radius:30px;cursor:pointer;background-color:#ccc;height:60px;width:7px}.ba-player-theatre-theme-volumebar-position{border-bottom-left-radius:30px;border-bottom-right-radius:30px;border-top-left-radius:30px;border-top-right-radius:30px;position:absolute;bottom:0;background-color:#000;width:100%}.ba-player-theatre-theme-progressbar{box-sizing:border-box;height:100%;overflow:hidden;position:relative;padding:0 13px 0 6px}.ba-player-theatre-theme-progressbar-inner{cursor:pointer;height:10px;background-color:#ccc}.ba-videoplayer-noie8 .ba-player-theatre-theme-progressbar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center}.ba-videoplayer-ie8 .ba-player-theatre-theme-progressbar-inner{margin-top:9px}.ba-videoplayer-ie8 .ba-player-theatre-theme-progressbar-position{height:10px}.ba-player-theatre-theme-progressbar.ba-player-disabled .ba-player-theatre-theme-progressbar-cache,.ba-player-theatre-theme-progressbar.ba-player-disabled .ba-player-theatre-theme-progressbar-inner{cursor:not-allowed}.ba-player-theatre-theme-progressbar-cache{position:absolute;left:0;cursor:pointer;background-color:#ccc;height:10px}.ba-player-theatre-theme-progressbar-position{background-color:#000;position:absolute;height:100%}.ba-player-theatre-theme-progressbar-button{display:none}.ba-player-theatre-theme-progressbar-marker{position:absolute;top:-2px;height:15px;width:5px;background-color:#000}.ba-player-theatre-theme-button-text{font-weight:400;font-size:10px}.ba-videoplayer-ie8 .ba-player-theatre-theme-volumebar{display:none}.ba-player-size-small .ba-player-theatre-theme-time-container{display:none}.ba-player-size-small .ba-player-theatre-theme-right-time-container{display:none}.ba-player-theatre-theme-stream-label-container{text-align:right;margin-right:3px}.ba-player-theatre-theme-stream-label-container .ba-player-theatre-theme-stream-label{cursor:pointer;background-color:#000;color:#eee;padding:5px}.ba-videoplayer-noie8 .ba-player-theatre-theme-full-screen-btn-inner{text-align:left;padding:0 5px}.ba-player-theatre-theme-cast-button-container button{-moz-opacity:.7;-khtml-opacity:.7;opacity:.7;background:0 0;border:none;cursor:pointer;padding-top:4px;width:32px}.ba-videoplayer-noie8 .ba-player-theatre-theme-cc-button-container{width:30px}.ba-commoncss-settings-visible .ba-player-theatre-theme-settings-button-inner{color:#eee}.ba-player-theatre-theme-cc-button-container,.ba-player-theatre-theme-settings-button-container{padding:1px 1px 0 0}.ba-player-theatre-theme .ba-settings-overlay-inner{bottom:45px;right:12.5%}.ba-player-device-type-mobile.ba-videoplayer-container .ba-player-theatre-theme-dashboard{left:2.5%;width:95%}.ba-player-device-type-mobile.ba-player-theatre-theme .ba-settings-overlay-inner{right:2.5%}.ba-player-fullscreen-view .ba-videoplayer-dashboard{bottom:0}.ba-player-fullscreen-view .ba-videoplayer-title-block{top:0}.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-dashboard,.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-title-block{position:fixed;z-index:100}.ba-videoplayer-container.ba-player-fullscreen-view{min-width:100%;position:absolute;min-height:fit-content}.ba-videoplayer-container.ba-player-fullscreen-view>.ba-videoplayer-overlay{position:fixed}.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-container{-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);border:.6em solid;border-color:#999;border-color:rgba(255,255,255,.6);position:absolute;top:50%;left:50%;transition:all .25s ease-in-out;-moz-transition:all .25s ease-in-out;-webkit-transition:all .25s ease-in-out;-o-transition:all .25s ease-in-out;-ms-transition:all .25s ease-in-out;-moz-box-shadow:0 0 22px #000;-webkit-box-shadow:0 0 22px #000;box-shadow:0 0 22px #000;border-radius:50%;box-sizing:content-box;cursor:pointer;font-size:5px;height:10em;text-align:center;width:10em}.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-container:focus{outline:0;border-radius:50%;border-color:#1b8fcc;-moz-box-shadow:0 0 0 2px #1b8fcc;-webkit-box-shadow:0 0 0 2px #1b8fcc;box-shadow:0 0 0 2px #1b8fcc}.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-container:focus:active,.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-container:focus:hover{border:none}.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-container:hover{-moz-box-shadow:0 0 22px #eee;-webkit-box-shadow:0 0 22px #eee;box-shadow:0 0 22px #eee}.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-container:hover .ba-player-theatre-theme-playbutton-button::after{text-shadow:0 0 4px #eee}.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-button::after{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;text-shadow:0 0 4px #000;transition:all .25s ease-in-out;-moz-transition:all .25s ease-in-out;-webkit-transition:all .25s ease-in-out;-o-transition:all .25s ease-in-out;-ms-transition:all .25s ease-in-out;content:\"\\E805\";color:#eee;font-size:4.6em}.ba-videoplayer-noie8 .ba-player-theatre-theme-playbutton-button::after{line-height:2.3em;margin-left:.1em;width:100%}.ba-player-theatre-theme-rerecord-bar{position:absolute;left:0;right:0;bottom:0;background-color:#eee}.ba-player-theatre-theme-rerecord-backbar{position:absolute;left:0;right:0;bottom:0;height:50px;background-color:#eee;opacity:1}.ba-player-theatre-theme-rerecord-frontbar{position:relative;left:0;right:0;bottom:0;height:50px;overflow:hidden;padding-left:16px;padding-right:16px;text-align:center}.ba-player-theatre-theme-rerecord-button-container{display:inline-block}.ba-player-theatre-theme-rerecord-button{background-color:#000;border-radius:0;color:#eee;cursor:pointer;font-family:sans-serif;font-weight:300;font-size:12px;height:50px;padding:0;padding-left:16px;padding-right:16px;line-height:50px;letter-spacing:.1em}.ba-player-theatre-theme.ba-videoplayer-container .ba-player-text-tracks-overlay{position:absolute;left:0;right:0;bottom:45px;transition:bottom .5s ease-in-out;-moz-transition:bottom .5s ease-in-out;-webkit-transition:bottom .5s ease-in-out;-o-transition:bottom .5s ease-in-out;-ms-transition:bottom .5s ease-in-out}.ba-player-theatre-theme.ba-videoplayer-container .ba-player-text-tracks-overlay .ba-commoncss-options-popup{bottom:0;right:12.5%}.ba-player-theatre-theme.ba-videoplayer-container .ba-player-track-dashboard-hidden.ba-player-text-tracks-overlay{bottom:5px}.ba-recorder-theme-theatre .ba-commoncss-message-text{-moz-border-radius:15px;-webkit-border-radius:15px;border-radius:15px}.ba-recorder-theme-theatre .ba-videorecorder-chooser-container{background-color:#eee}.ba-recorder-theme-theatre .ba-videorecorder-chooser-icon-container{color:#000;font-size:32px;margin:16px}.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-0,.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-1,.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-2,.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-3{-moz-border-radius:15px;-webkit-border-radius:15px;border-radius:15px;line-height:20px;min-width:10em;padding:6px 8px}.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-0,.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-2{background-color:#fff;color:#333;border:1px solid #333}.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-1,.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-3{border:1px solid #999;color:#979797;margin:2px 0}.ba-recorder-theme-theatre .ba-commoncss-icon-record:before{font-size:.8em}.ba-recorder-theme-theatre .ba-commoncss-icon-upload:before{font-size:.9em}.ba-recorder-red-color .ba-recorder-theme-theatre-dashboard .ba-commoncss-accent-color,.ba-recorder-red-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-inner,.ba-recorder-red-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-red-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-selected,.ba-recorder-red-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-stop-button-container .ba-videorecorder-button{color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-theatre-dashboard .ba-commoncss-accent-color-border,.ba-recorder-red-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-selected{border-color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-theatre-dashboard .ba-commoncss-accent-color-bg,.ba-recorder-red-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-primary{background-color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{background-color:#eb6a74;border-color:#eb6a74}.ba-recorder-red-color.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-0,.ba-recorder-red-color.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-2{color:#fff}.ba-recorder-red-color.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-1,.ba-recorder-red-color.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-3{background-color:#fff}.ba-recorder-red-color .ba-recorder-loader-label{color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-chooser-button-0,.ba-recorder-red-color .ba-videorecorder-chooser-button-2,.ba-recorder-red-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-red-color .ba-videorecorder-imagegallery-rightbutton{background-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-chooser-button-0,.ba-recorder-red-color .ba-videorecorder-chooser-button-2,.ba-recorder-red-color .ba-videorecorder-imagegallery-image:hover{border-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-message-message a{color:#eb6a74}.ba-recorder-blue-color .ba-recorder-theme-theatre-dashboard .ba-commoncss-accent-color,.ba-recorder-blue-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-inner,.ba-recorder-blue-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-blue-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-selected,.ba-recorder-blue-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-stop-button-container .ba-videorecorder-button{color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-theatre-dashboard .ba-commoncss-accent-color-border,.ba-recorder-blue-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-selected{border-color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-theatre-dashboard .ba-commoncss-accent-color-bg,.ba-recorder-blue-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-primary{background-color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{background-color:#2a74eb;border-color:#2a74eb}.ba-recorder-blue-color.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-0,.ba-recorder-blue-color.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-2{color:#fff}.ba-recorder-blue-color.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-1,.ba-recorder-blue-color.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-3{background-color:#fff}.ba-recorder-blue-color .ba-recorder-loader-label{color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-chooser-button-0,.ba-recorder-blue-color .ba-videorecorder-chooser-button-2,.ba-recorder-blue-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-blue-color .ba-videorecorder-imagegallery-rightbutton{background-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-chooser-button-0,.ba-recorder-blue-color .ba-videorecorder-chooser-button-2,.ba-recorder-blue-color .ba-videorecorder-imagegallery-image:hover{border-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-message-message a{color:#2a74eb}.ba-recorder-green-color .ba-recorder-theme-theatre-dashboard .ba-commoncss-accent-color,.ba-recorder-green-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-inner,.ba-recorder-green-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-green-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-selected,.ba-recorder-green-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-stop-button-container .ba-videorecorder-button{color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-theatre-dashboard .ba-commoncss-accent-color-border,.ba-recorder-green-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-selected{border-color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-theatre-dashboard .ba-commoncss-accent-color-bg,.ba-recorder-green-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-primary{background-color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-theatre-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{background-color:#5daa96;border-color:#5daa96}.ba-recorder-green-color.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-0,.ba-recorder-green-color.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-2{color:#fff}.ba-recorder-green-color.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-1,.ba-recorder-green-color.ba-recorder-theme-theatre .ba-videorecorder-chooser-button-3{background-color:#fff}.ba-recorder-green-color .ba-recorder-loader-label{color:#5daa96}.ba-recorder-green-color .ba-videorecorder-chooser-button-0,.ba-recorder-green-color .ba-videorecorder-chooser-button-2,.ba-recorder-green-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-green-color .ba-videorecorder-imagegallery-rightbutton{background-color:#5daa96}.ba-recorder-green-color .ba-videorecorder-chooser-button-0,.ba-recorder-green-color .ba-videorecorder-chooser-button-2,.ba-recorder-green-color .ba-videorecorder-imagegallery-image:hover{border-color:#5daa96}.ba-recorder-green-color .ba-videorecorder-message-message a{color:#5daa96}.ba-recorder-theme-theatre.ba-videorecorder-container .ba-videorecorder-video{background-color:#000}.ba-recorder-theme-theatre.ba-videorecorder-container .ba-recorder-overlay{top:0}.ba-recorder-theme-theatre-dashboard{position:absolute;left:0;right:0;top:0;bottom:0;height:100%;opacity:.75}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-controlbar{background-color:#eee;position:absolute;left:0;right:0;bottom:0;height:50px;padding:0}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-button{background-color:#fff;border:none;border-right:1px solid #979797;box-sizing:border-box;color:#eee;cursor:pointer;float:left;height:50px;line-height:50px;text-align:center;width:50px}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-inner{border:none;cursor:pointer;color:#666;font-size:inherit;height:100%;margin:0;padding:0;width:100%}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-inner:hover{background-color:#eee;color:#000}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-selected{background-color:#000;color:#eee}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-indicator-container{height:50px;line-height:50px;padding-left:10px}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-rightbutton-container{padding:0}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-settings-front{position:absolute;left:0;right:0;bottom:0;max-height:initial;overflow:auto}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-settings{bottom:50px;max-height:14em;overflow:scroll;margin:5px;padding:0}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-settings .ba-videorecorder-add-stream,.ba-recorder-theme-theatre-dashboard .ba-videorecorder-settings label{font-family:sans-serif;font-weight:300;font-size:12px;color:#979797}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-settings hr{background-color:#979797;height:2px}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{border:3px solid #979797;background-color:#000}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-settings span{border-color:#979797;background-color:#979797}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-primary{background-color:#000;border:none;border-radius:0;color:#eee;display:inline-block;font-family:sans-serif;font-weight:300;font-size:12px;margin:0;padding:0 25px;min-width:3em;position:relative;left:0;right:0;top:0;bottom:0;-webkit-transform:translate(0,0);-moz-transform:translate(0,0);-o-transform:translate(0,0);-ms-transform:translate(0,0);transform:translate(0,0);z-index:10;height:50px;line-height:50px}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-settings-button{background-color:#eee;cursor:pointer;margin:15px 0 0 15px}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-settings label{color:#979797}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-bubble-info{background-color:#fff;background-color:#fff;-moz-border-radius:4px;-webkit-border-radius:4px;border-radius:4px;display:inline-block;padding:12px 0;line-height:1.2;position:relative}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-bubble-info:before{border-top:9px solid;border-top-color:#fff;border-top-color:#fff;border-left:6px solid transparent;border-right:6px solid transparent;content:\"\";height:0;left:10px;position:absolute;right:100%;top:100%;width:0}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-controlbar-center-section{position:absolute;left:0;text-align:center;width:100%}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-button-container{display:inline-block}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-label-container{text-align:center;width:100%}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-label-container .ba-videorecorder-button-primary{background-color:inherit;border-left:1px solid #979797;border-right:1px solid #979797;color:#979797;cursor:default}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-stop-button-container{text-align:right;bottom:0;left:auto;position:absolute;right:0;top:auto}.ba-recorder-theme-theatre-dashboard .ba-videorecorder-stop-button-container .ba-videorecorder-button{color:#000}.ba-recorder-theme-theatre.ba-videorecorder-container .ba-videorecorder-imagegallery-container{left:50px;right:50px}.ba-videorecorder-imagegallery-image img{border:none;border-radius:0}.ba-videorecorderimagegallery-image:hover{border:2px solid #fff}.ba-videorecorder-imagegallery-leftbutton,.ba-videorecorder-imagegallery-rightbutton{border-radius:0;background-color:#979797;background-color:rgba(0,0,0,.4);height:30px;width:30px;z-index:10}.ba-recorder-theme-theatre .ba-videorecorder-topmessage-message{color:#eee;display:inline-block;font-family:sans-serif;font-size:12px;font-weight:300;padding:7px;position:relative;margin:15px 0 3px}.ba-recorder-theme-theatre .ba-videorecorder-topmessage-background{background:0 0}.ba-imageviewer-theatre-theme-red-color .ba-commoncss-icon-resize-full,.ba-imageviewer-theatre-theme-red-color .ba-imageviewer-button-inner,.ba-imageviewer-theatre-theme-red-color .ba-imageviewer-image-title,.ba-imageviewer-theatre-theme-red-color.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#eb6a74}.ba-imageviewer-theatre-theme-red-color .ba-imageviewer-rerecord-button{background-color:#eb6a74}.ba-imageviewer-theatre-theme-blue-color .ba-commoncss-icon-resize-full,.ba-imageviewer-theatre-theme-blue-color .ba-imageviewer-button-inner,.ba-imageviewer-theatre-theme-blue-color .ba-imageviewer-image-title,.ba-imageviewer-theatre-theme-blue-color.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#2a74eb}.ba-imageviewer-theatre-theme-blue-color .ba-imageviewer-rerecord-button{background-color:#2a74eb}.ba-imageviewer-theatre-theme-green-color .ba-commoncss-icon-resize-full,.ba-imageviewer-theatre-theme-green-color .ba-imageviewer-button-inner,.ba-imageviewer-theatre-theme-green-color .ba-imageviewer-image-title,.ba-imageviewer-theatre-theme-green-color.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#5daa96}.ba-imageviewer-theatre-theme-green-color .ba-imageviewer-rerecord-button{background-color:#5daa96}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-commoncss-icon-resize-full{color:#666}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-dashboard{transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;background-color:#eee;box-sizing:border-box;bottom:15px;border:1px solid #666;height:28px;left:12.5%;opacity:.75;position:absolute;width:75%}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-dashboard-hidden{opacity:0}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-left-block{float:left;padding-left:5px}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-left-block>div{float:left;height:28px;line-height:29px}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-left-block>div:last-child{float:right}.ba-imageviewer-container.ba-imageviewer-theatre-theme.ba-imageviewer-ie8 .ba-imageviewer-left-block>div{line-height:28px}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-center-block{float:left}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-right-block{float:right;padding-right:6px}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-right-block>div{float:right;height:25px;line-height:25px;text-align:center}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-right-block>div:first-child{line-height:28px}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-right-block>div:last-child{float:left;line-height:31px}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-right-block .ba-imageviewer-time-value{text-align:left}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-image-title-container{position:absolute;left:0;right:0;top:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;width:100%}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-image-title-container>p{background-color:#eee;background-color:rgba(255,255,255,.4);position:relative;margin:auto;height:28px;line-height:28px;top:15px;text-align:center;color:#020202;width:75%}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-leftbutton-container{float:left;width:40px;height:100%;cursor:pointer;box-sizing:content-box;border:none;text-align:center;line-height:2}.ba-imageviewer-container.ba-imageviewer-theatre-theme.ba-imageviewer-noie8 .ba-imageviewer-rightbutton-container{float:right;width:40px;height:100%;cursor:pointer;box-sizing:content-box;border:none}.ba-imageviewer-container.ba-imageviewer-theatre-theme.ba-imageviewer-ie8 .ba-imageviewer-rightbutton-container{float:right;width:40px;height:50%;cursor:pointer;box-sizing:content-box;border:none}.ba-imageviewer-container.ba-imageviewer-theatre-theme.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#000;font-size:13px}.ba-imageviewer-container.ba-imageviewer-theatre-theme.ba-imageviewer-ie8 .ba-imageviewer-button-inner{color:#000;font-size:13px;margin-left:3px}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-button-inner{cursor:pointer;position:relative}.ba-imageviewer-container.ba-imageviewer-theatre-theme .ba-imageviewer-button-text{font-family:Arial,sans-serif;font-weight:400;font-size:10px}.ba-imageviewer-container.ba-imageviewer-theatre-theme.ba-imageviewer-noie8 .ba-imageviewer-full-screen-btn-inner{text-align:left}.ba-imageviewer-fullscreen-view.ba-imageviewer-theatre-theme .ba-imageviewer-dashboard,.ba-imageviewer-fullscreen-view.ba-imageviewer-theatre-theme .ba-imageviewer-image-title-container{position:fixed;right:12.5%;z-index:1005}.ba-imageviewer-fullscreen-view.ba-imageviewer-theatre-theme .ba-imageviewer-dashboard{bottom:0;width:75%}.ba-imageviewer-fullscreen-view.ba-imageviewer-theatre-theme .ba-imageviewer-image-title-container{top:0}.ba-audioplayer-container.ba-player-theatre-theme{box-sizing:border-box;border:1px solid #eee;height:58px;min-height:58px;min-width:320px}.ba-audioplayer-container.ba-player-theatre-theme.ba-player-no-title{height:28px;min-height:28px}.ba-audioplayer-container.ba-player-theatre-theme .ba-player-theatre-theme-dashboard{transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;background-color:#eee;bottom:0;height:28px;position:absolute;width:100%}.ba-audioplayer-container.ba-player-theatre-theme .ba-player-theatre-theme-right-block>div{height:28px;line-height:28px;width:40px}.ba-audioplayer-container.ba-player-theatre-theme.ba-player-size-small .ba-player-theatre-theme-time-container{display:block}.ba-audioplayer-container.ba-player-theatre-theme.ba-audioplayer-ie8 .ba-player-theatre-theme-volumebar,.ba-audioplayer-container.ba-player-theatre-theme.ba-player-size-medium .ba-player-theatre-theme-volumebar,.ba-audioplayer-container.ba-player-theatre-theme.ba-player-size-small .ba-player-theatre-theme-volumebar{display:block}.ba-audioplayer-container.ba-player-theatre-theme.ba-player-size-medium .ba-player-theatre-theme-volume-button-container,.ba-audioplayer-container.ba-player-theatre-theme.ba-player-size-small .ba-player-theatre-theme-volume-button-container{display:block}.ba-audioplayer-container.ba-player-theatre-theme.ba-player-size-medium .ba-player-theatre-theme-right-time-container{display:block}.ba-audioplayer-ie8 .ba-player-theatre-theme-left-block>div{line-height:28px}.ba-player-theatre-theme-title-container{position:absolute;left:0;right:0;top:0;transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;width:100%}.ba-player-theatre-theme-title-container>p{background-color:#eee;background-color:rgba(255,255,255,.4);position:relative;margin:auto;height:28px;line-height:28px;text-align:center;color:#979797}.ba-audioplayer-noie8 .ba-player-theatre-theme-rightbutton-container{float:right;width:40px;height:100%;cursor:pointer;box-sizing:content-box;border:none}.ba-audioplayer-ie8 .ba-player-theatre-theme-rightbutton-container{float:right;width:40px;height:50%;cursor:pointer;box-sizing:content-box;border:none}.ba-audioplayer-noie8 .ba-player-theatre-theme-button-inner{color:#000;font-size:13px}.ba-audioplayer-ie8 .ba-player-theatre-theme-button-inner{color:#000;font-size:13px;margin-left:3px}.ba-audioplayer-noie8 .ba-player-theatre-theme-time-value{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center}.ba-audioplayer-noie8 .ba-player-theatre-theme-volumebar{float:left;margin-right:120px;width:7px}.ba-audioplayer-ie8 .ba-player-theatre-theme-volumebar{float:right;width:7px;height:50%;margin-right:120px}.ba-audioplayer-noie8 .ba-player-theatre-theme-progressbar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center}.ba-audioplayer-ie8 .ba-player-theatre-theme-progressbar-inner{margin-top:9px}.ba-audioplayer-ie8 .ba-player-theatre-theme-progressbar-position{height:10px}/*!\nbetajs-media-components - v0.0.291 - 2022-01-08\nCopyright (c) Ziggeo,Oliver Friedmann,Rashad Aliyev\nApache-2.0 Software License.\n*/.ba-player-red-color .ba-player-space-theme-button-inner,.ba-player-red-color .ba-player-space-theme-title>p{color:#eb6a74}.ba-player-red-color .ba-player-button-active,.ba-player-red-color .ba-player-space-theme-primary-button,.ba-player-red-color.ba-videoplayer-ie8 .ba-player-space-theme-stream-label-container,.ba-player-red-color.ba-videoplayer-noie8 .ba-player-space-theme-stream-label-container{color:#eee;background-color:#eb6a74}.ba-player-red-color .ba-player-space-theme-playbutton-duration,.ba-player-red-color .ba-player-space-theme-progressbar-button,.ba-player-red-color .ba-player-space-theme-progressbar-position,.ba-player-red-color .ba-player-space-theme-rerecord-button,.ba-player-red-color .ba-player-space-theme-stream-label-container .ba-player-space-theme-stream-label,.ba-player-red-color .ba-player-space-theme-volumebar-position{background-color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-container{border-color:#eb6a74}.ba-player-red-color.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-button::after{color:#eb6a74}.ba-player-red-color .ba-player-space-theme-progressbar-cache{background-color:#4c4c4c;background-color:rgba(255,255,255,.6)}.ba-player-red-color .ba-player-space-theme-progressbar-inner,.ba-player-red-color .ba-player-space-theme-volumebar-inner{background-color:#7f7f7f;background-color:rgba(255,255,255,.3)}.ba-player-blue-color .ba-player-space-theme-button-inner,.ba-player-blue-color .ba-player-space-theme-title>p{color:#2a74eb}.ba-player-blue-color .ba-player-button-active,.ba-player-blue-color .ba-player-space-theme-primary-button,.ba-player-blue-color.ba-videoplayer-ie8 .ba-player-space-theme-stream-label-container,.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-space-theme-stream-label-container{color:#eee;background-color:#2a74eb}.ba-player-blue-color .ba-player-space-theme-playbutton-duration,.ba-player-blue-color .ba-player-space-theme-progressbar-button,.ba-player-blue-color .ba-player-space-theme-progressbar-position,.ba-player-blue-color .ba-player-space-theme-rerecord-button,.ba-player-blue-color .ba-player-space-theme-stream-label-container .ba-player-space-theme-stream-label,.ba-player-blue-color .ba-player-space-theme-volumebar-position{background-color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-container{border-color:#2a74eb}.ba-player-blue-color.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-button::after{color:#2a74eb}.ba-player-blue-color .ba-player-space-theme-progressbar-cache{background-color:#4c4c4c;background-color:rgba(255,255,255,.6)}.ba-player-blue-color .ba-player-space-theme-progressbar-inner,.ba-player-blue-color .ba-player-space-theme-volumebar-inner{background-color:#7f7f7f;background-color:rgba(255,255,255,.3)}.ba-player-green-color .ba-player-space-theme-button-inner,.ba-player-green-color .ba-player-space-theme-title>p{color:#5daa96}.ba-player-green-color .ba-player-button-active,.ba-player-green-color .ba-player-space-theme-primary-button,.ba-player-green-color.ba-videoplayer-ie8 .ba-player-space-theme-stream-label-container,.ba-player-green-color.ba-videoplayer-noie8 .ba-player-space-theme-stream-label-container{color:#eee;background-color:#5daa96}.ba-player-green-color .ba-player-space-theme-playbutton-duration,.ba-player-green-color .ba-player-space-theme-progressbar-button,.ba-player-green-color .ba-player-space-theme-progressbar-position,.ba-player-green-color .ba-player-space-theme-rerecord-button,.ba-player-green-color .ba-player-space-theme-stream-label-container .ba-player-space-theme-stream-label,.ba-player-green-color .ba-player-space-theme-volumebar-position{background-color:#5daa96}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-container{border-color:#5daa96}.ba-player-green-color.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-button::after{color:#5daa96}.ba-player-green-color .ba-player-space-theme-progressbar-cache{background-color:#4c4c4c;background-color:rgba(255,255,255,.6)}.ba-player-green-color .ba-player-space-theme-progressbar-inner,.ba-player-green-color .ba-player-space-theme-volumebar-inner{background-color:#7f7f7f;background-color:rgba(255,255,255,.3)}.ba-player-space-theme-dashboard{font-family:sans-serif}.ba-player-space-theme-dashboard .ba-player-airplay-container{box-sizing:content-box;padding:12px 0 0 6px}.ba-player-space-theme-title-container{position:absolute;left:0;right:0;top:0;background-color:#cecece;background-color:rgba(0,0,0,.2);transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;box-sizing:border-box;font-size:.65rem;font-weight:300;height:32px;letter-spacing:.05rem;line-height:32px;padding:0 12px;text-align:center}.ba-videoplayer-ie8 .ba-player-space-theme-title-container .ba-player-space-theme-button-inner{margin-top:0}.ba-player-space-theme-controlbar-footer{position:absolute;left:0;right:0;bottom:0;background-color:#cecece;background-color:rgba(0,0,0,.4);transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;box-sizing:content-box;height:40px;padding:0 0 0 5px}.ba-videoplayer-ie8 .ba-player-space-theme-controlbar-footer,.ba-videoplayer-ie8 .ba-player-space-theme-title-container{opacity:.8}.ba-videoplayer-noie8 .ba-player-space-theme-title-container .css-rightbutton-container{width:21px}.ba-player-space-theme-title-container-background{position:relative;height:40px}.ba-player-space-theme-title{float:left;color:#eee}.ba-player-space-theme-title>p{margin:0;font-size:12px}.ba-videoplayer-noie8 .ba-player-space-theme-title-container .ba-player-space-theme-button-inner{-webkit-transform:translateY(0);-moz-transform:translateY(0);-o-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.ba-player-space-theme-leftbutton-container{float:left;width:30px;height:100%;cursor:pointer;box-sizing:content-box;border:none;margin-right:10px}.ba-videoplayer-noie8 .ba-player-space-theme-rightbutton-container{float:right;width:auto;height:100%;cursor:pointer;box-sizing:content-box;border:none}.ba-videoplayer-ie8 .ba-player-space-theme-rightbutton-container{float:right;width:auto;height:50%;cursor:pointer;box-sizing:content-box;border:none}.ba-player-space-theme-rightbutton-container{margin:0 5px}.ba-player-space-theme-right-time-container{padding-right:10px}.ba-player-space-theme-button-inner{cursor:pointer;color:#eee;font-size:13px;border-radius:3px}.ba-videoplayer-noie8 .ba-player-space-theme-controlbar-footer .ba-player-space-theme-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center}.ba-videoplayer-ie8 .ba-player-space-theme-button-inner{height:auto;margin-top:14px;margin-left:3px;text-align:center}.ba-player-space-theme-time-container{float:left;width:100px;height:100%;text-align:center;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:13px;color:#eee;box-sizing:content-box;border:none}.ba-videoplayer-ie8 .ba-player-space-theme-time-container{height:auto;margin-top:15px}.ba-player-space-theme-time-value{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;float:left;width:100px;font-size:10px}.ba-videoplayer-noie8 .ba-player-space-theme-volumebar{float:right;width:60px;height:100%}.ba-videoplayer-ie8 .ba-player-space-theme-volumebar{float:right;width:60px;height:50%;margin-top:14px;margin-right:12px}.ba-player-space-theme-volumebar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;cursor:pointer;background-color:#666;height:6px}.ba-player-space-theme-volumebar-position{border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;position:absolute;left:0;background-color:#eee;height:100%}.ba-videoplayer-noie8 .ba-player-space-theme-progressbar{overflow:hidden;height:100%;padding-left:6px;padding-right:6px}.ba-videoplayer-ie8 .ba-player-space-theme-progressbar{overflow:hidden;height:50%;padding-left:12px;padding-right:12px;margin-right:30px;margin-top:10px}.ba-player-space-theme-progressbar-cache{position:absolute;left:0;border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;cursor:pointer;background-color:#eee;height:3px}.ba-player-space-theme-progressbar-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;cursor:pointer;background-color:#979797;height:3px}.ba-player-space-theme-progressbar.ba-player-disabled .ba-player-space-theme-progressbar-cache,.ba-player-space-theme-progressbar.ba-player-disabled .ba-player-space-theme-progressbar-inner{cursor:not-allowed}.ba-player-space-theme-progressbar-position{border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-top-left-radius:3px;border-top-right-radius:3px;background-color:#000;position:absolute;height:3px}.ba-player-space-theme-progressbar-button{-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;background-color:#000;box-sizing:content-box;border:none;position:absolute;top:-2px;z-index:1;width:10px;height:10px}.ba-player-space-theme-progressbar-marker{position:absolute;background-color:#000;top:-4px;height:12px;width:5px}.ba-player-space-theme-button-text{font-family:Arial;font-weight:400;font-size:10px}.ba-player-space-theme-time-container{font-size:.7rem;width:50px}.ba-player-space-theme-time-value{font-weight:300;letter-spacing:.2em;width:50px}.ba-player-size-small .ba-player-space-theme-time-container{display:none}.ba-player-size-small .ba-player-space-theme-volumebar{display:none}.ba-player-space-theme-stream-label-container{background-color:#979797;box-sizing:border-box;padding:2px 4px}.ba-player-space-theme-stream-label-container .ba-player-space-theme-stream-label{line-height:16px;background-color:#979797}.ba-videoplayer-noie8 .ba-player-space-theme-full-screen-btn-inner{text-align:left;padding-left:4px}.ba-videoplayer-noie8 .ba-player-space-theme-cast-button-container{margin:0}.ba-videoplayer-noie8 .ba-player-space-theme-cast-button-container button{-moz-opacity:.7;-khtml-opacity:.7;opacity:.7;background:0 0;border:none;cursor:pointer;box-sizing:border-box;padding:11px 2px 0 10px;width:32px}.ba-player-space-theme-cc-button-container,.ba-player-space-theme-settings-button-container{padding:0 10px;margin:0}.ba-settings-overlay-inner{bottom:40px}.ba-player-space-theme-primary-button{background-color:#fff;color:#000;padding:5px}.ba-player-fullscreen-view video::-webkit-media-controls-overlay-enclosure{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-enclosure{display:none}.ba-player-fullscreen-view video::-webkit-media-controls{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-panel{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-play-button{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-current-time-display{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-time-remaining-display{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-timeline{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-mute-button{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-volume-slider{display:none}.ba-player-fullscreen-view video::-webkit-media-controls-fullscreen-button{display:none}.ba-player-fullscreen-view video::-internal-media-controls-download-button{display:none}.ba-player-fullscreen-view video::-moz-list-bullet,.ba-player-fullscreen-view video::-moz-list-number{display:none}.ba-player-fullscreen-view video::-moz-meter-bar{display:none}.ba-player-fullscreen-view video:fullscreen:not(:root){display:none}.ba-player-fullscreen-view .ba-videoplayer-dashboard{bottom:0}.ba-player-fullscreen-view .ba-videoplayer-title-block{top:0}.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-dashboard,.ba-player-fullscreen-view.ba-player-firefox-browser .ba-videoplayer-title-block{position:fixed;z-index:100}.ba-videoplayer-container.ba-player-fullscreen-view{min-width:100%;position:absolute;min-height:fit-content}.ba-videoplayer-container.ba-player-fullscreen-view>.ba-videoplayer-overlay{position:fixed}.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-container{-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);border:.6em solid;border-color:#999;border-color:rgba(255,255,255,.6);position:absolute;top:50%;left:50%;transition:all .25s ease-in-out;-moz-transition:all .25s ease-in-out;-webkit-transition:all .25s ease-in-out;-o-transition:all .25s ease-in-out;-ms-transition:all .25s ease-in-out;-moz-box-shadow:0 0 22px #000;-webkit-box-shadow:0 0 22px #000;box-shadow:0 0 22px #000;border-radius:50%;box-sizing:content-box;cursor:pointer;font-size:5px;height:10em;text-align:center;width:10em}.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-container:focus{outline:0;border-radius:50%;border-color:#1b8fcc;-moz-box-shadow:0 0 0 2px #1b8fcc;-webkit-box-shadow:0 0 0 2px #1b8fcc;box-shadow:0 0 0 2px #1b8fcc}.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-container:focus:active,.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-container:focus:hover{border:none}.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-container:hover{-moz-box-shadow:0 0 22px #eee;-webkit-box-shadow:0 0 22px #eee;box-shadow:0 0 22px #eee}.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-container:hover .ba-player-space-theme-playbutton-button::after{text-shadow:0 0 4px #eee}.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-button::after{font-family:bjsmc;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;text-shadow:0 0 4px #000;transition:all .25s ease-in-out;-moz-transition:all .25s ease-in-out;-webkit-transition:all .25s ease-in-out;-o-transition:all .25s ease-in-out;-ms-transition:all .25s ease-in-out;content:\"\\E805\";color:#eee;font-size:4.6em}.ba-videoplayer-noie8 .ba-player-space-theme-playbutton-button::after{line-height:2.3em;margin-left:.1em;width:100%}.ba-player-space-theme-rerecord-bar{position:absolute;left:0;right:0;bottom:0}.ba-player-space-theme-rerecord-backbar{position:absolute;left:0;right:0;bottom:0;height:48px;background-color:#000;opacity:.5}.ba-player-space-theme-rerecord-frontbar{position:relative;left:0;right:0;bottom:0;height:48px;overflow:hidden;padding-left:16px;padding-right:16px}.ba-player-space-theme-rerecord-button-container{height:100%;cursor:pointer;padding-left:8px;padding-right:8px;display:inline-block;position:relative;left:50%;transform:translateX(-50%)}.ba-player-space-theme-rerecord-button{background-color:#000;border-radius:18px;color:#eee;cursor:pointer;font-family:sans-serif;font-weight:300;font-size:11px;padding:8px;padding-left:16px;padding-right:16px;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center;letter-spacing:.1em}.ba-player-space-theme.ba-videoplayer-noie8 .ba-videoplayer-topmessage-container .ba-player-space-theme-rightbutton-container{width:25px}.ba-player-space-theme.ba-videoplayer-noie8 .ba-videoplayer-topmessage-message .ba-videoplayer-button-inner{-webkit-transform:translateY(0);-moz-transform:translateY(0);-o-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.ba-player-space-theme.ba-videoplayer-noie8 .ba-videoplayer-topmessage-container .ba-videoplayer-rightbutton-container{width:25px}.ba-player-space-theme .ba-videoplayer-topmessage-background{position:relative;height:40px}.ba-player-space-theme .ba-videoplayer-topmessage-message{padding:0;padding-left:20px;padding-right:15px;line-height:40px;text-align:left;font-size:.65rem;letter-spacing:.05rem;font-weight:300}.ba-player-space-theme .ba-videoplayer-title{float:left}.ba-player-space-theme .ba-videoplayer-share-button-container{margin-right:5px}.ba-player-space-theme.ba-videoplayer-container .ba-player-text-tracks-overlay{position:absolute;left:0;right:0;bottom:42px;transition:bottom .5s ease-in-out;-moz-transition:bottom .5s ease-in-out;-webkit-transition:bottom .5s ease-in-out;-o-transition:bottom .5s ease-in-out;-ms-transition:bottom .5s ease-in-out}.ba-player-space-theme.ba-videoplayer-container .ba-player-text-tracks-overlay .ba-commoncss-options-popup{right:0;bottom:1px}.ba-player-space-theme.ba-videoplayer-container .ba-player-track-dashboard-hidden.ba-player-text-tracks-overlay{bottom:5px}.ba-recorder-theme-space .ba-commoncss-message-text{-moz-border-radius:50px;-webkit-border-radius:50px;border-radius:50px}.ba-recorder-theme-space .ba-videorecorder-chooser-container{background-color:#eee;z-index:1}.ba-recorder-theme-space .ba-videorecorder-chooser-icon-container{color:#000;font-size:32px;margin:16px}.ba-recorder-theme-space .ba-videorecorder-chooser-button-0,.ba-recorder-theme-space .ba-videorecorder-chooser-button-1,.ba-recorder-theme-space .ba-videorecorder-chooser-button-2,.ba-recorder-theme-space .ba-videorecorder-chooser-button-3{-moz-border-radius:50px;-webkit-border-radius:50px;border-radius:50px;line-height:20px;min-width:10em;padding:6px 8px}.ba-recorder-theme-space .ba-videorecorder-chooser-button-0,.ba-recorder-theme-space .ba-videorecorder-chooser-button-2{background-color:#000;border:1px solid #000}.ba-recorder-theme-space .ba-videorecorder-chooser-button-1,.ba-recorder-theme-space .ba-videorecorder-chooser-button-3{border:1px solid #666;color:#666;font-size:14px;margin:2px 0}.ba-recorder-red-color .ba-recorder-theme-space-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-red-color .ba-recorder-theme-space-dashboard .ba-videorecorder-button-selected{color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-space-dashboard .ba-videorecorder-button-primary{background-color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-space-dashboard .ba-videorecorder-button-selected{border-color:#eb6a74}.ba-recorder-red-color .ba-recorder-theme-space-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{background-color:#eb6a74;border-color:#eb6a74}.ba-recorder-red-color .ba-recorder-loader-label,.ba-recorder-red-color .ba-videorecorder-button-circle-selected,.ba-recorder-red-color .ba-videorecorder-button-inner:hover,.ba-recorder-red-color .ba-videorecorder-chooser-button-1,.ba-recorder-red-color .ba-videorecorder-chooser-button-3,.ba-recorder-red-color .ba-videorecorder-chooser-icon-container{color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-chooser-button-0,.ba-recorder-red-color .ba-videorecorder-chooser-button-2,.ba-recorder-red-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-red-color .ba-videorecorder-imagegallery-rightbutton{background-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-chooser-button-0,.ba-recorder-red-color .ba-videorecorder-chooser-button-2,.ba-recorder-red-color .ba-videorecorder-imagegallery-image:hover{border-color:#eb6a74}.ba-recorder-red-color .ba-videorecorder-message-message a{color:#eb6a74}.ba-recorder-blue-color .ba-recorder-theme-space-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-blue-color .ba-recorder-theme-space-dashboard .ba-videorecorder-button-selected{color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-space-dashboard .ba-videorecorder-button-primary{background-color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-space-dashboard .ba-videorecorder-button-selected{border-color:#2a74eb}.ba-recorder-blue-color .ba-recorder-theme-space-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{background-color:#2a74eb;border-color:#2a74eb}.ba-recorder-blue-color .ba-recorder-loader-label,.ba-recorder-blue-color .ba-videorecorder-button-circle-selected,.ba-recorder-blue-color .ba-videorecorder-button-inner:hover,.ba-recorder-blue-color .ba-videorecorder-chooser-button-1,.ba-recorder-blue-color .ba-videorecorder-chooser-button-3,.ba-recorder-blue-color .ba-videorecorder-chooser-icon-container{color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-chooser-button-0,.ba-recorder-blue-color .ba-videorecorder-chooser-button-2,.ba-recorder-blue-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-blue-color .ba-videorecorder-imagegallery-rightbutton{background-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-chooser-button-0,.ba-recorder-blue-color .ba-videorecorder-chooser-button-2,.ba-recorder-blue-color .ba-videorecorder-imagegallery-image:hover{border-color:#2a74eb}.ba-recorder-blue-color .ba-videorecorder-message-message a{color:#2a74eb}.ba-recorder-green-color .ba-recorder-theme-space-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-green-color .ba-recorder-theme-space-dashboard .ba-videorecorder-button-selected{color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-space-dashboard .ba-videorecorder-button-primary{background-color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-space-dashboard .ba-videorecorder-button-selected{border-color:#5daa96}.ba-recorder-green-color .ba-recorder-theme-space-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{background-color:#5daa96;border-color:#5daa96}.ba-recorder-green-color .ba-recorder-loader-label,.ba-recorder-green-color .ba-videorecorder-button-circle-selected,.ba-recorder-green-color .ba-videorecorder-button-inner:hover,.ba-recorder-green-color .ba-videorecorder-chooser-button-1,.ba-recorder-green-color .ba-videorecorder-chooser-button-3,.ba-recorder-green-color .ba-videorecorder-chooser-icon-container{color:#5daa96}.ba-recorder-green-color .ba-videorecorder-chooser-button-0,.ba-recorder-green-color .ba-videorecorder-chooser-button-2,.ba-recorder-green-color .ba-videorecorder-imagegallery-leftbutton,.ba-recorder-green-color .ba-videorecorder-imagegallery-rightbutton{background-color:#5daa96}.ba-recorder-green-color .ba-videorecorder-chooser-button-0,.ba-recorder-green-color .ba-videorecorder-chooser-button-2,.ba-recorder-green-color .ba-videorecorder-imagegallery-image:hover{border-color:#5daa96}.ba-recorder-green-color .ba-videorecorder-message-message a{color:#5daa96}.ba-recorder-theme-space.ba-videorecorder-container .ba-videorecorder-video{background-color:#000}.ba-recorder-theme-space-dashboard{position:absolute;left:0;right:0;top:0;bottom:0;height:100%}.ba-recorder-theme-space-dashboard .ba-videorecorder-controlbar{position:absolute;left:0;right:0;bottom:0;height:55px;padding:0 10px}.ba-recorder-theme-space-dashboard .ba-videorecorder-controlbar .ba-videorecorder-rightbutton-container.ba-videorecorder-pause-button-container{position:absolute;right:10px}.ba-recorder-theme-space-dashboard .ba-videorecorder-controlbar-left-section{float:left}.ba-recorder-theme-space-dashboard .ba-videorecorder-controlbar-left-section .ba-videorecorder-circle-button{margin-right:7px}.ba-recorder-theme-space-dashboard .ba-videorecorder-long-rounded-button{-moz-border-radius:18px;-webkit-border-radius:18px;border-radius:18px;display:inline-block}.ba-recorder-theme-space-dashboard .ba-videorecorder-long-rounded-button>p{font-family:sans-serif;font-size:12px;padding:15px;margin:0}.ba-recorder-theme-space-dashboard .ba-videorecorder-circle-button{background-color:#979797;background-color:rgba(0,0,0,.4);-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;color:#fff;float:left;height:40px;line-height:40px;text-align:center;width:40px}.ba-recorder-theme-space-dashboard .ba-videorecorder-button-circle-selected,.ba-recorder-theme-space-dashboard .ba-videorecorder-button-inner:hover,.ba-recorder-theme-space-dashboard .ba-videorecorder-button-selected{background-color:#eee;border-radius:50%;color:#000;cursor:pointer}.ba-recorder-theme-space-dashboard .ba-videorecorder-button-inner{border:none;cursor:pointer;font-size:inherit;height:100%;margin:0;padding:0;width:100%}.ba-recorder-theme-space-dashboard .ba-videorecorder-indicator-container{height:40px;line-height:40px}.ba-recorder-theme-space-dashboard .ba-videorecorder-settings-front{position:absolute;left:0;right:0;bottom:0;max-height:initial;overflow:auto}.ba-recorder-theme-space-dashboard .ba-videorecorder-settings{bottom:55px;max-height:14em;overflow:scroll;margin:5px;padding:0}.ba-recorder-theme-space-dashboard .ba-videorecorder-settings .ba-videorecorder-add-stream,.ba-recorder-theme-space-dashboard .ba-videorecorder-settings label{font-family:sans-serif;font-weight:300;font-size:12px}.ba-recorder-theme-space-dashboard .ba-videorecorder-settings input[type=radio]:checked+span{border:3px solid #fff;background-color:#000}.ba-recorder-theme-space-dashboard .ba-videorecorder-button-primary{-moz-border-radius:18px;-webkit-border-radius:18px;border-radius:18px;position:relative;left:0;right:0;top:0;bottom:0;-webkit-transform:translate(0,0);-moz-transform:translate(0,0);-o-transform:translate(0,0);-ms-transform:translate(0,0);transform:translate(0,0);background-color:#000;display:inline-block;font-family:sans-serif;font-weight:300;font-size:12px;margin:6px 5px 0;min-width:3em;padding:8px 16px;z-index:10}.ba-recorder-theme-space-dashboard .ba-videorecorder-settings-button{background-color:#eee;cursor:pointer;margin:15px 0 0 15px}.ba-recorder-theme-space-dashboard .ba-videorecorder-settings-button>p{color:#979797}.ba-recorder-theme-space-dashboard .ba-videorecorder-bubble-info{background-color:#7f7f7f;background-color:rgba(0,0,0,.5);-moz-border-radius:4px;-webkit-border-radius:4px;border-radius:4px;display:inline-block;padding:12px 0;line-height:1.2;position:relative}.ba-recorder-theme-space-dashboard .ba-videorecorder-bubble-info:before{border-top:9px solid;border-top-color:#7f7f7f;border-top-color:rgba(0,0,0,.5);border-left:6px solid transparent;border-right:6px solid transparent;content:\"\";height:0;left:16px;position:absolute;right:100%;top:100%;width:0}.ba-recorder-theme-space-dashboard .ba-videorecorder-controlbar-center-section{position:absolute;left:0;text-align:right;width:50%}.ba-recorder-theme-space-dashboard .ba-videorecorder-button-container{display:inline-block}.ba-recorder-theme-space-dashboard .ba-videorecorder-label-container{float:left;text-align:right;width:50%}.ba-recorder-theme-space-dashboard .ba-videorecorder-label-container .ba-videorecorder-button-primary{color:#fff;background-color:#979797;background-color:rgba(0,0,0,.4)}.ba-recorder-theme-space-dashboard .ba-videorecorder-stop-button-container{float:right;text-align:left;width:50%}.ba-recorder-theme-space-dashboard .ba-commoncss-icon-cog{position:relative;top:1px}.ba-recorder-theme-space.ba-videorecorder-container .ba-videorecorder-imagegallery-container{left:50px;right:50px}.ba-recorder-overlay img,.ba-videorecorder-imagegallery-image{border:none;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px}.ba-videorecorderimagegallery-image:hover{border:2px solid #fff}.ba-videorecorder-imagegallery-leftbutton,.ba-videorecorder-imagegallery-rightbutton{border-radius:50%;background-color:#979797;background-color:rgba(0,0,0,.4);height:30px;width:30px;z-index:10}.ba-recorder-theme-space .ba-videorecorder-topmessage-message{background-color:#eee;-moz-border-radius:18px;-webkit-border-radius:18px;border-radius:18px;color:#979797;opacity:.75;display:inline-block;font-family:sans-serif;font-size:12px;font-weight:300;padding:6px;position:relative;margin:15px 0 0 15px}.ba-recorder-theme-space .ba-videorecorder-topmessage-background{background:0 0}.ba-imageviewer-space-theme-red-color .ba-imageviewer-title>p,.ba-imageviewer-space-theme-red-color.ba-imageviewer-ie8 .ba-imageviewer-button-inner,.ba-imageviewer-space-theme-red-color.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#eb6a74}.ba-imageviewer-space-theme-red-color .ba-imageviewer-rerecord-button{background-color:#eb6a74}.ba-imageviewer-space-theme-blue-color .ba-imageviewer-title>p,.ba-imageviewer-space-theme-blue-color.ba-imageviewer-ie8 .ba-imageviewer-button-inner,.ba-imageviewer-space-theme-blue-color.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#2a74eb}.ba-imageviewer-space-theme-blue-color .ba-imageviewer-rerecord-button{background-color:#2a74eb}.ba-imageviewer-space-theme-green-color .ba-imageviewer-title>p,.ba-imageviewer-space-theme-green-color.ba-imageviewer-ie8 .ba-imageviewer-button-inner,.ba-imageviewer-space-theme-green-color.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#5daa96}.ba-imageviewer-space-theme-green-color .ba-imageviewer-rerecord-button{background-color:#5daa96}.ba-imageviewer-space-theme .ba-imageviewer-image-title-container{position:absolute;left:0;right:0;top:0;background-color:#cecece;background-color:rgba(0,0,0,.2);transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;box-sizing:border-box;font-size:.65rem;font-weight:300;height:32px;letter-spacing:.05rem;line-height:32px;padding:0 3px 0 12px;text-align:center}.ba-imageviewer-space-theme.ba-imageviewer-ie8 .ba-imageviewer-image-title-container .ba-imageviewer-button-inner{margin-top:0}.ba-imageviewer-space-theme .ba-imageviewer-controlbar-footer{position:absolute;left:0;right:0;bottom:0;background-color:#cecece;background-color:rgba(0,0,0,.4);transition:opacity .5s ease-in-out;-moz-transition:opacity .5s ease-in-out;-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;-ms-transition:opacity .5s ease-in-out;height:40px;padding:0 5px}.ba-imageviewer-space-theme.ba-imageviewer-ie8 .ba-imageviewer-controlbar-footer,.ba-imageviewer-space-theme.ba-imageviewer-ie8 .ba-imageviewer-image-title-container{opacity:.8}.ba-imageviewer-space-theme .ba-imageviewer-dashboard-hidden{opacity:0}.ba-imageviewer-space-theme.ba-imageviewer-noie8 .ba-imageviewer-image-title-container .css-rightbutton-container{width:21px}.ba-imageviewer-space-theme .ba-imageviewer-image-title-container-background{position:relative;height:40px}.ba-imageviewer-space-theme .ba-imageviewer-title{float:left;color:#eee}.ba-imageviewer-space-theme .ba-imageviewer-title>p{margin:0;font-size:12px;font-family:sans-serif}.ba-imageviewer-space-theme.ba-imageviewer-noie8 .ba-imageviewer-image-title-container .ba-imageviewer-button-inner{-webkit-transform:translateY(0);-moz-transform:translateY(0);-o-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.ba-imageviewer-space-theme.ba-imageviewer-noie8 .ba-imageviewer-topmessage-container .ba-imageviewer-rightbutton-container{width:25px}.ba-imageviewer-space-theme .ba-imageviewer-leftbutton-container{float:left;width:30px;height:100%;cursor:pointer;box-sizing:content-box;border:none;margin-right:10px}.ba-imageviewer-space-theme.ba-imageviewer-noie8 .ba-imageviewer-rightbutton-container{float:right;width:auto;height:100%;cursor:pointer;box-sizing:content-box;border:none}.ba-imageviewer-space-theme.ba-imageviewer-ie8 .ba-imageviewer-rightbutton-container{float:right;width:auto;height:50%;cursor:pointer;box-sizing:content-box;border:none}.ba-imageviewer-space-theme .ba-imageviewer-rightbutton-container{margin:0 5px}.ba-imageviewer-space-theme .ba-imageviewer-right-time-container{padding-right:10px}.ba-imageviewer-space-theme.ba-imageviewer-noie8 .ba-imageviewer-button-inner{color:#eee;font-size:13px}.ba-imageviewer-space-theme .ba-imageviewer-button-inner{cursor:pointer}.ba-imageviewer-space-theme.ba-imageviewer-noie8 .ba-imageviewer-controlbar-footer .ba-imageviewer-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center}.ba-imageviewer-space-theme.ba-imageviewer-ie8 .ba-imageviewer-button-inner{color:#eee;font-size:13px;height:auto;margin-top:14px;margin-left:3px;text-align:center}.ba-imageviewer-space-theme .ba-imageviewer-button-text{font-family:Arial,sans-serif;font-weight:400;font-size:10px}.ba-imageviewer-space-theme.ba-imageviewer-noie8 .ba-imageviewer-full-screen-btn-inner{text-align:left;padding-left:4px}.ba-imageviewer-fullscreen-view.ba-imageviewer-space-theme .ba-imageviewer-dashboard,.ba-imageviewer-fullscreen-view.ba-imageviewer-space-theme .ba-imageviewer-image-title-container{position:fixed;width:100%;z-index:1010}.ba-imageviewer-fullscreen-view.ba-imageviewer-space-theme .ba-imageviewer-dashboard{bottom:0}.ba-imageviewer-fullscreen-view.ba-imageviewer-space-theme .ba-imageviewer-image-title-container{top:0}.ba-imageviewer-space-theme.ba-imageviewer-noie8 .ba-imageviewer-topmessage-message .css-rightbutton-container{width:21px}.ba-imageviewer-space-theme .ba-imageviewer-topmessage-background{position:relative;height:40px}.ba-imageviewer-space-theme .ba-imageviewer-topmessage-message{padding:0;padding-left:20px;padding-right:15px;line-height:40px;text-align:left;font-size:.65rem;letter-spacing:.05rem;font-weight:300}.ba-imageviewer-space-theme .ba-imageviewer-title{float:left}.ba-imageviewer-space-theme.ba-imageviewer-noie8 .ba-imageviewer-topmessage-message .ba-imageviewer-button-inner{-webkit-transform:translateY(0);-moz-transform:translateY(0);-o-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}.ba-imageviewer-space-theme.ba-imageviewer-noie8 .ba-imageviewer-topmessage-container .ba-imageviewer-rightbutton-container{width:25px}.ba-audioplayer-container{box-sizing:border-box;border:1px solid #eee;height:73px;min-height:73px;min-width:320px}.ba-audioplayer-container.ba-player-space-theme .ba-player-space-theme-progressbar-button{-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;background-color:#eee;box-sizing:content-box;border:none;position:absolute;right:-5px;top:-2.5px;z-index:1;width:8px;height:8px}.ba-audioplayer-container.ba-player-space-theme.ba-player-size-medium .ba-player-space-theme-time-container,.ba-audioplayer-container.ba-player-space-theme.ba-player-size-small .ba-player-space-theme-time-container{display:block}.ba-audioplayer-container.ba-player-space-theme.ba-player-size-medium .ba-player-space-theme-volumebar,.ba-audioplayer-container.ba-player-space-theme.ba-player-size-small .ba-player-space-theme-volumebar{display:block}.ba-audioplayer-container.ba-player-space-theme.ba-player-size-medium .ba-player-space-theme-volume-button-container,.ba-audioplayer-container.ba-player-space-theme.ba-player-size-small .ba-player-space-theme-volume-button-container{display:block}.ba-audioplayer-ie8 .ba-player-space-theme-title-container .ba-player-space-theme-button-inner{margin-top:0}.ba-audioplayer-ie8 .ba-player-space-theme-controlbar-footer,.ba-audioplayer-ie8 .ba-player-space-theme-title-container{opacity:.8}.ba-audioplayer-noie8 .ba-player-space-theme-title-container .css-rightbutton-container{width:21px}.ba-audioplayer-noie8 .ba-player-space-theme-rightbutton-container{float:right;width:auto;height:100%;cursor:pointer;box-sizing:content-box;border:none}.ba-audioplayer-ie8 .ba-player-space-theme-rightbutton-container{float:right;width:auto;height:50%;cursor:pointer;box-sizing:content-box;border:none}.ba-audioplayer-noie8 .ba-player-space-theme-button-inner{color:#eee;font-size:13px}.ba-audioplayer-noie8 .ba-player-space-theme-controlbar-footer .ba-player-space-theme-button-inner{-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-o-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);top:50%;position:relative;text-align:center}.ba-audioplayer-ie8 .ba-player-space-theme-button-inner{color:#eee;font-size:13px;height:auto;margin-top:14px;margin-left:3px;text-align:center}.ba-audioplayer-noie8 .ba-player-space-theme-volumebar{float:right;width:60px;height:100%;margin-right:12px}.ba-audioplayer-ie8 .ba-player-space-theme-volumebar{float:right;width:60px;height:50%;margin-top:14px;margin-right:12px}.ba-audioplayer-noie8 .ba-player-space-theme-progressbar{overflow:hidden;height:100%;padding-left:6px;padding-right:6px}.ba-audioplayer-ie8 .ba-player-space-theme-progressbar{overflow:hidden;height:50%;padding-left:12px;padding-right:12px;margin-right:30px;margin-top:10px}.ziggeo-v2-testing{height:24px;background-image:url(" + __webpack_require__(331) + ");background-size:contain;background-repeat:no-repeat;background-position:center center;position:absolute;bottom:46px;left:0;right:0}", ""]);

      // exports

      /***/
    }, /* 321 */
    /***/function (module, exports) {
      /*
      	MIT License http://www.opensource.org/licenses/mit-license.php
      	Author Tobias Koppers @sokra
      */
      // css base code, injected by the css-loader
      module.exports = function () {
        var list = [];

        // return the list of modules as css string
        list.toString = function toString() {
          var result = [];
          for (var i = 0; i < this.length; i++) {
            var item = this[i];
            if (item[2]) {
              result.push("@media " + item[2] + "{" + item[1] + "}");
            } else {
              result.push(item[1]);
            }
          }
          return result.join("");
        };

        // import a list of modules into the list
        list.i = function (modules, mediaQuery) {
          if (typeof modules === "string") modules = [[null, modules, ""]];
          var alreadyImportedModules = {};
          for (var i = 0; i < this.length; i++) {
            var id = this[i][0];
            if (typeof id === "number") alreadyImportedModules[id] = true;
          }
          for (i = 0; i < modules.length; i++) {
            var item = modules[i];
            // skip already imported module
            // this implementation is not 100% perfect for weird media query combinations
            //  when a module is imported multiple times with different media queries.
            //  I hope this will never occur (Hey this way we have smaller bundles)
            if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
              if (mediaQuery && !item[2]) {
                item[2] = mediaQuery;
              } else if (mediaQuery) {
                item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
              }
              list.push(item);
            }
          }
        };
        return list;
      };

      /***/
    }, /* 322 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */

      /* eslint-disable no-unused-vars */
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var propIsEnumerable = Object.prototype.propertyIsEnumerable;
      function toObject(val) {
        if (val === null || val === undefined) {
          throw new TypeError('Object.assign cannot be called with null or undefined');
        }
        return Object(val);
      }
      function shouldUseNative() {
        try {
          if (!Object.assign) {
            return false;
          }

          // Detect buggy property enumeration order in older V8 versions.

          // https://bugs.chromium.org/p/v8/issues/detail?id=4118
          var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
          test1[5] = 'de';
          if (Object.getOwnPropertyNames(test1)[0] === '5') {
            return false;
          }

          // https://bugs.chromium.org/p/v8/issues/detail?id=3056
          var test2 = {};
          for (var i = 0; i < 10; i++) {
            test2['_' + String.fromCharCode(i)] = i;
          }
          var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
            return test2[n];
          });
          if (order2.join('') !== '0123456789') {
            return false;
          }

          // https://bugs.chromium.org/p/v8/issues/detail?id=3056
          var test3 = {};
          'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
            test3[letter] = letter;
          });
          if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
            return false;
          }
          return true;
        } catch (err) {
          // We don't expect any of the above to throw, but better to be safe.
          return false;
        }
      }
      module.exports = shouldUseNative() ? Object.assign : function (target, source) {
        var from;
        var to = toObject(target);
        var symbols;
        for (var s = 1; s < arguments.length; s++) {
          from = Object(arguments[s]);
          for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
              to[key] = from[key];
            }
          }
          if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for (var i = 0; i < symbols.length; i++) {
              if (propIsEnumerable.call(from, symbols[i])) {
                to[symbols[i]] = from[symbols[i]];
              }
            }
          }
        }
        return to;
      };

      /***/
    }, /* 323 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      /* WEBPACK VAR INJECTION */
      (function (process) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        *
        * This source code is licensed under the MIT license found in the
        * LICENSE file in the root directory of this source tree.
        */

        var printWarning = function printWarning() {};
        if (process.env.NODE_ENV !== 'production') {
          var ReactPropTypesSecret = __webpack_require__(92);
          var loggedTypeFailures = {};
          var has = Function.call.bind(Object.prototype.hasOwnProperty);
          printWarning = function printWarning(text) {
            var message = 'Warning: ' + text;
            if (typeof console !== 'undefined') {
              console.error(message);
            }
            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message);
            } catch (x) {}
          };
        }

        /**
         * Assert that the values match with the type specs.
         * Error messages are memorized and will only be shown once.
         *
         * @param {object} typeSpecs Map of name to a ReactPropType
         * @param {object} values Runtime values that need to be type-checked
         * @param {string} location e.g. "prop", "context", "child context"
         * @param {string} componentName Name of the component for error messages.
         * @param {?Function} getStack Returns the component stack.
         * @private
         */
        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
          if (process.env.NODE_ENV !== 'production') {
            for (var typeSpecName in typeSpecs) {
              if (has(typeSpecs, typeSpecName)) {
                var error;
                // Prop type validation may throw. In case they do, we don't want to
                // fail the render phase where it didn't fail before. So we log it.
                // After these have been cleaned up, we'll let them throw.
                try {
                  // This is intentionally an invariant that gets caught. It's the same
                  // behavior as without this statement except with a better message.
                  if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
                    err.name = 'Invariant Violation';
                    throw err;
                  }
                  error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                } catch (ex) {
                  error = ex;
                }
                if (error && !(error instanceof Error)) {
                  printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
                }
                if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                  // Only monitor this failure once because there tends to be a lot of the
                  // same error.
                  loggedTypeFailures[error.message] = true;
                  var stack = getStack ? getStack() : '';
                  printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
                }
              }
            }
          }
        }

        /**
         * Resets warning cache when testing.
         *
         * @private
         */
        checkPropTypes.resetWarningCache = function () {
          if (process.env.NODE_ENV !== 'production') {
            loggedTypeFailures = {};
          }
        };
        module.exports = checkPropTypes;

        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(49));

      /***/
    }, /* 324 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      var ReactPropTypesSecret = __webpack_require__(92);
      function emptyFunction() {}
      function emptyFunctionWithReset() {}
      emptyFunctionWithReset.resetWarningCache = emptyFunction;
      module.exports = function () {
        function shim(props, propName, componentName, location, propFullName, secret) {
          if (secret === ReactPropTypesSecret) {
            // It is still safe when called from React.
            return;
          }
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        }
        ;
        shim.isRequired = shim;
        function getShim() {
          return shim;
        }
        ;
        // Important!
        // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
        var ReactPropTypes = {
          array: shim,
          bool: shim,
          func: shim,
          number: shim,
          object: shim,
          string: shim,
          symbol: shim,
          any: shim,
          arrayOf: getShim,
          element: shim,
          elementType: shim,
          instanceOf: getShim,
          node: shim,
          objectOf: getShim,
          oneOf: getShim,
          oneOfType: getShim,
          shape: getShim,
          exact: getShim,
          checkPropTypes: emptyFunctionWithReset,
          resetWarningCache: emptyFunction
        };
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
      };

      /***/
    }, /* 325 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      /* WEBPACK VAR INJECTION */
      (function (process) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        *
        * This source code is licensed under the MIT license found in the
        * LICENSE file in the root directory of this source tree.
        */

        var ReactIs = __webpack_require__(127);
        var assign = __webpack_require__(322);
        var ReactPropTypesSecret = __webpack_require__(92);
        var checkPropTypes = __webpack_require__(323);
        var has = Function.call.bind(Object.prototype.hasOwnProperty);
        var printWarning = function printWarning() {};
        if (process.env.NODE_ENV !== 'production') {
          printWarning = function printWarning(text) {
            var message = 'Warning: ' + text;
            if (typeof console !== 'undefined') {
              console.error(message);
            }
            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message);
            } catch (x) {}
          };
        }
        function emptyFunctionThatReturnsNull() {
          return null;
        }
        module.exports = function (isValidElement, throwOnDirectAccess) {
          /* global Symbol */
          var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
          var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

          /**
           * Returns the iterator method function contained on the iterable object.
           *
           * Be sure to invoke the function with the iterable as context:
           *
           *     var iteratorFn = getIteratorFn(myIterable);
           *     if (iteratorFn) {
           *       var iterator = iteratorFn.call(myIterable);
           *       ...
           *     }
           *
           * @param {?object} maybeIterable
           * @return {?function}
           */
          function getIteratorFn(maybeIterable) {
            var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
            if (typeof iteratorFn === 'function') {
              return iteratorFn;
            }
          }

          /**
           * Collection of methods that allow declaration and validation of props that are
           * supplied to React components. Example usage:
           *
           *   var Props = require('ReactPropTypes');
           *   var MyArticle = React.createClass({
           *     propTypes: {
           *       // An optional string prop named "description".
           *       description: Props.string,
           *
           *       // A required enum prop named "category".
           *       category: Props.oneOf(['News','Photos']).isRequired,
           *
           *       // A prop named "dialog" that requires an instance of Dialog.
           *       dialog: Props.instanceOf(Dialog).isRequired
           *     },
           *     render: function() { ... }
           *   });
           *
           * A more formal specification of how these methods are used:
           *
           *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
           *   decl := ReactPropTypes.{type}(.isRequired)?
           *
           * Each and every declaration produces a function with the same signature. This
           * allows the creation of custom validation functions. For example:
           *
           *  var MyLink = React.createClass({
           *    propTypes: {
           *      // An optional string or URI prop named "href".
           *      href: function(props, propName, componentName) {
           *        var propValue = props[propName];
           *        if (propValue != null && typeof propValue !== 'string' &&
           *            !(propValue instanceof URI)) {
           *          return new Error(
           *            'Expected a string or an URI for ' + propName + ' in ' +
           *            componentName
           *          );
           *        }
           *      }
           *    },
           *    render: function() {...}
           *  });
           *
           * @internal
           */

          var ANONYMOUS = '<<anonymous>>';

          // Important!
          // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
          var ReactPropTypes = {
            array: createPrimitiveTypeChecker('array'),
            bool: createPrimitiveTypeChecker('boolean'),
            func: createPrimitiveTypeChecker('function'),
            number: createPrimitiveTypeChecker('number'),
            object: createPrimitiveTypeChecker('object'),
            string: createPrimitiveTypeChecker('string'),
            symbol: createPrimitiveTypeChecker('symbol'),
            any: createAnyTypeChecker(),
            arrayOf: createArrayOfTypeChecker,
            element: createElementTypeChecker(),
            elementType: createElementTypeTypeChecker(),
            instanceOf: createInstanceTypeChecker,
            node: createNodeChecker(),
            objectOf: createObjectOfTypeChecker,
            oneOf: createEnumTypeChecker,
            oneOfType: createUnionTypeChecker,
            shape: createShapeTypeChecker,
            exact: createStrictShapeTypeChecker
          };

          /**
           * inlined Object.is polyfill to avoid requiring consumers ship their own
           * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
           */
          /*eslint-disable no-self-compare*/
          function is(x, y) {
            // SameValue algorithm
            if (x === y) {
              // Steps 1-5, 7-10
              // Steps 6.b-6.e: +0 != -0
              return x !== 0 || 1 / x === 1 / y;
            } else {
              // Step 6.a: NaN == NaN
              return x !== x && y !== y;
            }
          }
          /*eslint-enable no-self-compare*/

          /**
           * We use an Error-like object for backward compatibility as people may call
           * PropTypes directly and inspect their output. However, we don't use real
           * Errors anymore. We don't inspect their stack anyway, and creating them
           * is prohibitively expensive if they are created too often, such as what
           * happens in oneOfType() for any type before the one that matched.
           */
          function PropTypeError(message) {
            this.message = message;
            this.stack = '';
          }
          // Make `instanceof Error` still work for returned errors.
          PropTypeError.prototype = Error.prototype;
          function createChainableTypeChecker(validate) {
            if (process.env.NODE_ENV !== 'production') {
              var manualPropTypeCallCache = {};
              var manualPropTypeWarningCount = 0;
            }
            function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
              componentName = componentName || ANONYMOUS;
              propFullName = propFullName || propName;
              if (secret !== ReactPropTypesSecret) {
                if (throwOnDirectAccess) {
                  // New behavior only for users of `prop-types` package
                  var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
                  err.name = 'Invariant Violation';
                  throw err;
                } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
                  // Old behavior for people using React.PropTypes
                  var cacheKey = componentName + ':' + propName;
                  if (!manualPropTypeCallCache[cacheKey] &&
                  // Avoid spamming the console because they are often not actionable except for lib authors
                  manualPropTypeWarningCount < 3) {
                    printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                    manualPropTypeCallCache[cacheKey] = true;
                    manualPropTypeWarningCount++;
                  }
                }
              }
              if (props[propName] == null) {
                if (isRequired) {
                  if (props[propName] === null) {
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                  }
                  return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
              } else {
                return validate(props, propName, componentName, location, propFullName);
              }
            }
            var chainedCheckType = checkType.bind(null, false);
            chainedCheckType.isRequired = checkType.bind(null, true);
            return chainedCheckType;
          }
          function createPrimitiveTypeChecker(expectedType) {
            function validate(props, propName, componentName, location, propFullName, secret) {
              var propValue = props[propName];
              var propType = getPropType(propValue);
              if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createAnyTypeChecker() {
            return createChainableTypeChecker(emptyFunctionThatReturnsNull);
          }
          function createArrayOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
              if (typeof typeChecker !== 'function') {
                return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
              }
              var propValue = props[propName];
              if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
              }
              for (var i = 0; i < propValue.length; i++) {
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
                if (error instanceof Error) {
                  return error;
                }
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createElementTypeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createElementTypeTypeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              if (!ReactIs.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createInstanceTypeChecker(expectedClass) {
            function validate(props, propName, componentName, location, propFullName) {
              if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createEnumTypeChecker(expectedValues) {
            if (!Array.isArray(expectedValues)) {
              if (process.env.NODE_ENV !== 'production') {
                if (arguments.length > 1) {
                  printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                } else {
                  printWarning('Invalid argument supplied to oneOf, expected an array.');
                }
              }
              return emptyFunctionThatReturnsNull;
            }
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              for (var i = 0; i < expectedValues.length; i++) {
                if (is(propValue, expectedValues[i])) {
                  return null;
                }
              }
              var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') {
                  return String(value);
                }
                return value;
              });
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
            }
            return createChainableTypeChecker(validate);
          }
          function createObjectOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
              if (typeof typeChecker !== 'function') {
                return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
              }
              var propValue = props[propName];
              var propType = getPropType(propValue);
              if (propType !== 'object') {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
              }
              for (var key in propValue) {
                if (has(propValue, key)) {
                  var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                  if (error instanceof Error) {
                    return error;
                  }
                }
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createUnionTypeChecker(arrayOfTypeCheckers) {
            if (!Array.isArray(arrayOfTypeCheckers)) {
              process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
              return emptyFunctionThatReturnsNull;
            }
            for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
              var checker = arrayOfTypeCheckers[i];
              if (typeof checker !== 'function') {
                printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return emptyFunctionThatReturnsNull;
              }
            }
            function validate(props, propName, componentName, location, propFullName) {
              for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                var checker = arrayOfTypeCheckers[i];
                if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
                  return null;
                }
              }
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
            }
            return createChainableTypeChecker(validate);
          }
          function createNodeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              if (!isNode(props[propName])) {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              var propType = getPropType(propValue);
              if (propType !== 'object') {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
              }
              for (var key in shapeTypes) {
                var checker = shapeTypes[key];
                if (!checker) {
                  continue;
                }
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                if (error) {
                  return error;
                }
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function createStrictShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              var propType = getPropType(propValue);
              if (propType !== 'object') {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
              }
              // We need to check all keys in case some are required but missing from
              // props.
              var allKeys = assign({}, props[propName], shapeTypes);
              for (var key in allKeys) {
                var checker = shapeTypes[key];
                if (!checker) {
                  return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                }
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                if (error) {
                  return error;
                }
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }
          function isNode(propValue) {
            switch (typeof propValue) {
              case 'number':
              case 'string':
              case 'undefined':
                return true;
              case 'boolean':
                return !propValue;
              case 'object':
                if (Array.isArray(propValue)) {
                  return propValue.every(isNode);
                }
                if (propValue === null || isValidElement(propValue)) {
                  return true;
                }
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                  var iterator = iteratorFn.call(propValue);
                  var step;
                  if (iteratorFn !== propValue.entries) {
                    while (!(step = iterator.next()).done) {
                      if (!isNode(step.value)) {
                        return false;
                      }
                    }
                  } else {
                    // Iterator will provide entry [k,v] tuples rather than values.
                    while (!(step = iterator.next()).done) {
                      var entry = step.value;
                      if (entry) {
                        if (!isNode(entry[1])) {
                          return false;
                        }
                      }
                    }
                  }
                } else {
                  return false;
                }
                return true;
              default:
                return false;
            }
          }
          function isSymbol(propType, propValue) {
            // Native Symbol.
            if (propType === 'symbol') {
              return true;
            }

            // falsy value can't be a Symbol
            if (!propValue) {
              return false;
            }

            // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
            if (propValue['@@toStringTag'] === 'Symbol') {
              return true;
            }

            // Fallback for non-spec compliant Symbols which are polyfilled.
            if (typeof Symbol === 'function' && propValue instanceof Symbol) {
              return true;
            }
            return false;
          }

          // Equivalent of `typeof` but with special handling for array and regexp.
          function getPropType(propValue) {
            var propType = typeof propValue;
            if (Array.isArray(propValue)) {
              return 'array';
            }
            if (propValue instanceof RegExp) {
              // Old webkits (at least until Android 4.0) return 'function' rather than
              // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
              // passes PropTypes.object.
              return 'object';
            }
            if (isSymbol(propType, propValue)) {
              return 'symbol';
            }
            return propType;
          }

          // This handles more types than `getPropType`. Only used for error messages.
          // See `createPrimitiveTypeChecker`.
          function getPreciseType(propValue) {
            if (typeof propValue === 'undefined' || propValue === null) {
              return '' + propValue;
            }
            var propType = getPropType(propValue);
            if (propType === 'object') {
              if (propValue instanceof Date) {
                return 'date';
              } else if (propValue instanceof RegExp) {
                return 'regexp';
              }
            }
            return propType;
          }

          // Returns a string that is postfixed to a warning about an invalid type.
          // For example, "undefined" or "of type array"
          function getPostfixForTypeWarning(value) {
            var type = getPreciseType(value);
            switch (type) {
              case 'array':
              case 'object':
                return 'an ' + type;
              case 'boolean':
              case 'date':
              case 'regexp':
                return 'a ' + type;
              default:
                return type;
            }
          }

          // Returns class name of the object, if any.
          function getClassName(propValue) {
            if (!propValue.constructor || !propValue.constructor.name) {
              return ANONYMOUS;
            }
            return propValue.constructor.name;
          }
          ReactPropTypes.checkPropTypes = checkPropTypes;
          ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
          ReactPropTypes.PropTypes = ReactPropTypes;
          return ReactPropTypes;
        };

        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(49));

      /***/
    }, /* 326 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      /* WEBPACK VAR INJECTION */
      (function (process) {
        /** @license React v16.13.1
        * react-is.development.js
        *
        * Copyright (c) Facebook, Inc. and its affiliates.
        *
        * This source code is licensed under the MIT license found in the
        * LICENSE file in the root directory of this source tree.
        */

        if (process.env.NODE_ENV !== "production") {
          (function () {
            'use strict';

            // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
            // nor polyfill, then a plain number is used for performance.
            var hasSymbol = typeof Symbol === 'function' && Symbol.for;
            var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
            var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
            var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
            var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
            var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
            var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
            var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
            // (unstable) APIs that have been removed. Can we remove the symbols?

            var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
            var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
            var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
            var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
            var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
            var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
            var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
            var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
            var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
            var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
            var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
            function isValidElementType(type) {
              return typeof type === 'string' || typeof type === 'function' ||
              // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
              type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
            }
            function typeOf(object) {
              if (typeof object === 'object' && object !== null) {
                var $$typeof = object.$$typeof;
                switch ($$typeof) {
                  case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch (type) {
                      case REACT_ASYNC_MODE_TYPE:
                      case REACT_CONCURRENT_MODE_TYPE:
                      case REACT_FRAGMENT_TYPE:
                      case REACT_PROFILER_TYPE:
                      case REACT_STRICT_MODE_TYPE:
                      case REACT_SUSPENSE_TYPE:
                        return type;
                      default:
                        var $$typeofType = type && type.$$typeof;
                        switch ($$typeofType) {
                          case REACT_CONTEXT_TYPE:
                          case REACT_FORWARD_REF_TYPE:
                          case REACT_LAZY_TYPE:
                          case REACT_MEMO_TYPE:
                          case REACT_PROVIDER_TYPE:
                            return $$typeofType;
                          default:
                            return $$typeof;
                        }
                    }
                  case REACT_PORTAL_TYPE:
                    return $$typeof;
                }
              }
              return undefined;
            } // AsyncMode is deprecated along with isAsyncMode

            var AsyncMode = REACT_ASYNC_MODE_TYPE;
            var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
            var ContextConsumer = REACT_CONTEXT_TYPE;
            var ContextProvider = REACT_PROVIDER_TYPE;
            var Element = REACT_ELEMENT_TYPE;
            var ForwardRef = REACT_FORWARD_REF_TYPE;
            var Fragment = REACT_FRAGMENT_TYPE;
            var Lazy = REACT_LAZY_TYPE;
            var Memo = REACT_MEMO_TYPE;
            var Portal = REACT_PORTAL_TYPE;
            var Profiler = REACT_PROFILER_TYPE;
            var StrictMode = REACT_STRICT_MODE_TYPE;
            var Suspense = REACT_SUSPENSE_TYPE;
            var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

            function isAsyncMode(object) {
              {
                if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                  hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

                  console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
                }
              }
              return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
            }
            function isConcurrentMode(object) {
              return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
            }
            function isContextConsumer(object) {
              return typeOf(object) === REACT_CONTEXT_TYPE;
            }
            function isContextProvider(object) {
              return typeOf(object) === REACT_PROVIDER_TYPE;
            }
            function isElement(object) {
              return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
            }
            function isForwardRef(object) {
              return typeOf(object) === REACT_FORWARD_REF_TYPE;
            }
            function isFragment(object) {
              return typeOf(object) === REACT_FRAGMENT_TYPE;
            }
            function isLazy(object) {
              return typeOf(object) === REACT_LAZY_TYPE;
            }
            function isMemo(object) {
              return typeOf(object) === REACT_MEMO_TYPE;
            }
            function isPortal(object) {
              return typeOf(object) === REACT_PORTAL_TYPE;
            }
            function isProfiler(object) {
              return typeOf(object) === REACT_PROFILER_TYPE;
            }
            function isStrictMode(object) {
              return typeOf(object) === REACT_STRICT_MODE_TYPE;
            }
            function isSuspense(object) {
              return typeOf(object) === REACT_SUSPENSE_TYPE;
            }
            exports.AsyncMode = AsyncMode;
            exports.ConcurrentMode = ConcurrentMode;
            exports.ContextConsumer = ContextConsumer;
            exports.ContextProvider = ContextProvider;
            exports.Element = Element;
            exports.ForwardRef = ForwardRef;
            exports.Fragment = Fragment;
            exports.Lazy = Lazy;
            exports.Memo = Memo;
            exports.Portal = Portal;
            exports.Profiler = Profiler;
            exports.StrictMode = StrictMode;
            exports.Suspense = Suspense;
            exports.isAsyncMode = isAsyncMode;
            exports.isConcurrentMode = isConcurrentMode;
            exports.isContextConsumer = isContextConsumer;
            exports.isContextProvider = isContextProvider;
            exports.isElement = isElement;
            exports.isForwardRef = isForwardRef;
            exports.isFragment = isFragment;
            exports.isLazy = isLazy;
            exports.isMemo = isMemo;
            exports.isPortal = isPortal;
            exports.isProfiler = isProfiler;
            exports.isStrictMode = isStrictMode;
            exports.isSuspense = isSuspense;
            exports.isValidElementType = isValidElementType;
            exports.typeOf = typeOf;
          })();
        }

        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(49));

      /***/
    }, /* 327 */
    /***/function (module, exports, __webpack_require__) {
      "use strict";

      /** @license React v16.13.1
       * react-is.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      var b = "function" === typeof Symbol && Symbol.for,
        c = b ? Symbol.for("react.element") : 60103,
        d = b ? Symbol.for("react.portal") : 60106,
        e = b ? Symbol.for("react.fragment") : 60107,
        f = b ? Symbol.for("react.strict_mode") : 60108,
        g = b ? Symbol.for("react.profiler") : 60114,
        h = b ? Symbol.for("react.provider") : 60109,
        k = b ? Symbol.for("react.context") : 60110,
        l = b ? Symbol.for("react.async_mode") : 60111,
        m = b ? Symbol.for("react.concurrent_mode") : 60111,
        n = b ? Symbol.for("react.forward_ref") : 60112,
        p = b ? Symbol.for("react.suspense") : 60113,
        q = b ? Symbol.for("react.suspense_list") : 60120,
        r = b ? Symbol.for("react.memo") : 60115,
        t = b ? Symbol.for("react.lazy") : 60116,
        v = b ? Symbol.for("react.block") : 60121,
        w = b ? Symbol.for("react.fundamental") : 60117,
        x = b ? Symbol.for("react.responder") : 60118,
        y = b ? Symbol.for("react.scope") : 60119;
      function z(a) {
        if ("object" === typeof a && null !== a) {
          var u = a.$$typeof;
          switch (u) {
            case c:
              switch (a = a.type, a) {
                case l:
                case m:
                case e:
                case g:
                case f:
                case p:
                  return a;
                default:
                  switch (a = a && a.$$typeof, a) {
                    case k:
                    case n:
                    case t:
                    case r:
                    case h:
                      return a;
                    default:
                      return u;
                  }
              }
            case d:
              return u;
          }
        }
      }
      function A(a) {
        return z(a) === m;
      }
      exports.AsyncMode = l;
      exports.ConcurrentMode = m;
      exports.ContextConsumer = k;
      exports.ContextProvider = h;
      exports.Element = c;
      exports.ForwardRef = n;
      exports.Fragment = e;
      exports.Lazy = t;
      exports.Memo = r;
      exports.Portal = d;
      exports.Profiler = g;
      exports.StrictMode = f;
      exports.Suspense = p;
      exports.isAsyncMode = function (a) {
        return A(a) || z(a) === l;
      };
      exports.isConcurrentMode = A;
      exports.isContextConsumer = function (a) {
        return z(a) === k;
      };
      exports.isContextProvider = function (a) {
        return z(a) === h;
      };
      exports.isElement = function (a) {
        return "object" === typeof a && null !== a && a.$$typeof === c;
      };
      exports.isForwardRef = function (a) {
        return z(a) === n;
      };
      exports.isFragment = function (a) {
        return z(a) === e;
      };
      exports.isLazy = function (a) {
        return z(a) === t;
      };
      exports.isMemo = function (a) {
        return z(a) === r;
      };
      exports.isPortal = function (a) {
        return z(a) === d;
      };
      exports.isProfiler = function (a) {
        return z(a) === g;
      };
      exports.isStrictMode = function (a) {
        return z(a) === f;
      };
      exports.isSuspense = function (a) {
        return z(a) === p;
      };
      exports.isValidElementType = function (a) {
        return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
      };
      exports.typeOf = z;

      /***/
    }, /* 328 */
    /***/function (module, exports, __webpack_require__) {
      /**
       * Copyright (c) 2014-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var runtime = function (exports) {
        "use strict";

        var Op = Object.prototype;
        var hasOwn = Op.hasOwnProperty;
        var undefined; // More compressible than void 0.
        var $Symbol = typeof Symbol === "function" ? Symbol : {};
        var iteratorSymbol = $Symbol.iterator || "@@iterator";
        var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
        var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
        function define(obj, key, value) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
          return obj[key];
        }
        try {
          // IE 8 has a broken Object.defineProperty that only works on DOM objects.
          define({}, "");
        } catch (err) {
          define = function define(obj, key, value) {
            return obj[key] = value;
          };
        }
        function wrap(innerFn, outerFn, self, tryLocsList) {
          // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
          var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
          var generator = Object.create(protoGenerator.prototype);
          var context = new Context(tryLocsList || []);

          // The ._invoke method unifies the implementations of the .next,
          // .throw, and .return methods.
          generator._invoke = makeInvokeMethod(innerFn, self, context);
          return generator;
        }
        exports.wrap = wrap;

        // Try/catch helper to minimize deoptimizations. Returns a completion
        // record like context.tryEntries[i].completion. This interface could
        // have been (and was previously) designed to take a closure to be
        // invoked without arguments, but in all the cases we care about we
        // already have an existing method we want to call, so there's no need
        // to create a new function object. We can even get away with assuming
        // the method takes exactly one argument, since that happens to be true
        // in every case, so we don't have to touch the arguments object. The
        // only additional allocation required is the completion record, which
        // has a stable shape and so hopefully should be cheap to allocate.
        function tryCatch(fn, obj, arg) {
          try {
            return {
              type: "normal",
              arg: fn.call(obj, arg)
            };
          } catch (err) {
            return {
              type: "throw",
              arg: err
            };
          }
        }
        var GenStateSuspendedStart = "suspendedStart";
        var GenStateSuspendedYield = "suspendedYield";
        var GenStateExecuting = "executing";
        var GenStateCompleted = "completed";

        // Returning this object from the innerFn has the same effect as
        // breaking out of the dispatch switch statement.
        var ContinueSentinel = {};

        // Dummy constructor functions that we use as the .constructor and
        // .constructor.prototype properties for functions that return Generator
        // objects. For full spec compliance, you may wish to configure your
        // minifier not to mangle the names of these two functions.
        function Generator() {}
        function GeneratorFunction() {}
        function GeneratorFunctionPrototype() {}

        // This is a polyfill for %IteratorPrototype% for environments that
        // don't natively support it.
        var IteratorPrototype = {};
        IteratorPrototype[iteratorSymbol] = function () {
          return this;
        };
        var getProto = Object.getPrototypeOf;
        var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
        if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
          // This environment has a native %IteratorPrototype%; use it instead
          // of the polyfill.
          IteratorPrototype = NativeIteratorPrototype;
        }
        var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
        GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
        GeneratorFunctionPrototype.constructor = GeneratorFunction;
        GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");

        // Helper for defining the .next, .throw, and .return methods of the
        // Iterator interface in terms of a single ._invoke method.
        function defineIteratorMethods(prototype) {
          ["next", "throw", "return"].forEach(function (method) {
            define(prototype, method, function (arg) {
              return this._invoke(method, arg);
            });
          });
        }
        exports.isGeneratorFunction = function (genFun) {
          var ctor = typeof genFun === "function" && genFun.constructor;
          return ctor ? ctor === GeneratorFunction ||
          // For the native GeneratorFunction constructor, the best we can
          // do is to check its .name property.
          (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
        };
        exports.mark = function (genFun) {
          if (Object.setPrototypeOf) {
            Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
          } else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
          }
          genFun.prototype = Object.create(Gp);
          return genFun;
        };

        // Within the body of any async function, `await x` is transformed to
        // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
        // `hasOwn.call(value, "__await")` to determine if the yielded value is
        // meant to be awaited.
        exports.awrap = function (arg) {
          return {
            __await: arg
          };
        };
        function AsyncIterator(generator, PromiseImpl) {
          function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") {
              reject(record.arg);
            } else {
              var result = record.arg;
              var value = result.value;
              if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                return PromiseImpl.resolve(value.__await).then(function (value) {
                  invoke("next", value, resolve, reject);
                }, function (err) {
                  invoke("throw", err, resolve, reject);
                });
              }
              return PromiseImpl.resolve(value).then(function (unwrapped) {
                // When a yielded Promise is resolved, its final value becomes
                // the .value of the Promise<{value,done}> result for the
                // current iteration.
                result.value = unwrapped;
                resolve(result);
              }, function (error) {
                // If a rejected Promise was yielded, throw the rejection back
                // into the async generator function so it can be handled there.
                return invoke("throw", error, resolve, reject);
              });
            }
          }
          var previousPromise;
          function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
              return new PromiseImpl(function (resolve, reject) {
                invoke(method, arg, resolve, reject);
              });
            }
            return previousPromise =
            // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
            // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
          }

          // Define the unified helper method that is used to implement .next,
          // .throw, and .return (see defineIteratorMethods).
          this._invoke = enqueue;
        }
        defineIteratorMethods(AsyncIterator.prototype);
        AsyncIterator.prototype[asyncIteratorSymbol] = function () {
          return this;
        };
        exports.AsyncIterator = AsyncIterator;

        // Note that simple async functions are implemented on top of
        // AsyncIterator objects; they just return a Promise for the value of
        // the final result produced by the iterator.
        exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
          if (PromiseImpl === void 0) PromiseImpl = Promise;
          var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
          return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
          : iter.next().then(function (result) {
            return result.done ? result.value : iter.next();
          });
        };
        function makeInvokeMethod(innerFn, self, context) {
          var state = GenStateSuspendedStart;
          return function invoke(method, arg) {
            if (state === GenStateExecuting) {
              throw new Error("Generator is already running");
            }
            if (state === GenStateCompleted) {
              if (method === "throw") {
                throw arg;
              }

              // Be forgiving, per 25.3.3.3.3 of the spec:
              // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
              return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while (true) {
              var delegate = context.delegate;
              if (delegate) {
                var delegateResult = maybeInvokeDelegate(delegate, context);
                if (delegateResult) {
                  if (delegateResult === ContinueSentinel) continue;
                  return delegateResult;
                }
              }
              if (context.method === "next") {
                // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
              } else if (context.method === "throw") {
                if (state === GenStateSuspendedStart) {
                  state = GenStateCompleted;
                  throw context.arg;
                }
                context.dispatchException(context.arg);
              } else if (context.method === "return") {
                context.abrupt("return", context.arg);
              }
              state = GenStateExecuting;
              var record = tryCatch(innerFn, self, context);
              if (record.type === "normal") {
                // If an exception is thrown from innerFn, we leave state ===
                // GenStateExecuting and loop back for another invocation.
                state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                if (record.arg === ContinueSentinel) {
                  continue;
                }
                return {
                  value: record.arg,
                  done: context.done
                };
              } else if (record.type === "throw") {
                state = GenStateCompleted;
                // Dispatch the exception by looping back around to the
                // context.dispatchException(context.arg) call above.
                context.method = "throw";
                context.arg = record.arg;
              }
            }
          };
        }

        // Call delegate.iterator[context.method](context.arg) and handle the
        // result, either by returning a { value, done } result from the
        // delegate iterator, or by modifying context.method and context.arg,
        // setting context.delegate to null, and returning the ContinueSentinel.
        function maybeInvokeDelegate(delegate, context) {
          var method = delegate.iterator[context.method];
          if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;
            if (context.method === "throw") {
              // Note: ["return"] must be used for ES3 parsing compatibility.
              if (delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") {
                  // If maybeInvokeDelegate(context) changed context.method from
                  // "return" to "throw", let that override the TypeError below.
                  return ContinueSentinel;
                }
              }
              context.method = "throw";
              context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
          }
          var record = tryCatch(method, delegate.iterator, context.arg);
          if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
          }
          var info = record.arg;
          if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
          }
          if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;

            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;

            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
              context.method = "next";
              context.arg = undefined;
            }
          } else {
            // Re-yield the result returned by the delegate method.
            return info;
          }

          // The delegate iterator is finished, so forget it and continue with
          // the outer generator.
          context.delegate = null;
          return ContinueSentinel;
        }

        // Define Generator.prototype.{next,throw,return} in terms of the
        // unified ._invoke helper method.
        defineIteratorMethods(Gp);
        define(Gp, toStringTagSymbol, "Generator");

        // A Generator should always return itself as the iterator object when the
        // @@iterator function is called on it. Some browsers' implementations of the
        // iterator prototype chain incorrectly implement this, causing the Generator
        // object to not be returned from this call. This ensures that doesn't happen.
        // See https://github.com/facebook/regenerator/issues/274 for more details.
        Gp[iteratorSymbol] = function () {
          return this;
        };
        Gp.toString = function () {
          return "[object Generator]";
        };
        function pushTryEntry(locs) {
          var entry = {
            tryLoc: locs[0]
          };
          if (1 in locs) {
            entry.catchLoc = locs[1];
          }
          if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
          }
          this.tryEntries.push(entry);
        }
        function resetTryEntry(entry) {
          var record = entry.completion || {};
          record.type = "normal";
          delete record.arg;
          entry.completion = record;
        }
        function Context(tryLocsList) {
          // The root entry object (effectively a try statement without a catch
          // or a finally block) gives us a place to store values thrown from
          // locations where there is no enclosing try statement.
          this.tryEntries = [{
            tryLoc: "root"
          }];
          tryLocsList.forEach(pushTryEntry, this);
          this.reset(true);
        }
        exports.keys = function (object) {
          var keys = [];
          for (var key in object) {
            keys.push(key);
          }
          keys.reverse();

          // Rather than returning an object with a next method, we keep
          // things simple and return the next function itself.
          return function next() {
            while (keys.length) {
              var key = keys.pop();
              if (key in object) {
                next.value = key;
                next.done = false;
                return next;
              }
            }

            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
          };
        };
        function values(iterable) {
          if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) {
              return iteratorMethod.call(iterable);
            }
            if (typeof iterable.next === "function") {
              return iterable;
            }
            if (!isNaN(iterable.length)) {
              var i = -1,
                next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }
                  next.value = undefined;
                  next.done = true;
                  return next;
                };
              return next.next = next;
            }
          }

          // Return an iterator with no values.
          return {
            next: doneResult
          };
        }
        exports.values = values;
        function doneResult() {
          return {
            value: undefined,
            done: true
          };
        }
        Context.prototype = {
          constructor: Context,
          reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
              for (var name in this) {
                // Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                  this[name] = undefined;
                }
              }
            }
          },
          stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") {
              throw rootRecord.arg;
            }
            return this.rval;
          },
          dispatchException: function dispatchException(exception) {
            if (this.done) {
              throw exception;
            }
            var context = this;
            function handle(loc, caught) {
              record.type = "throw";
              record.arg = exception;
              context.next = loc;
              if (caught) {
                // If the dispatched exception was caught by a catch block,
                // then let that catch block handle the exception normally.
                context.method = "next";
                context.arg = undefined;
              }
              return !!caught;
            }
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              var record = entry.completion;
              if (entry.tryLoc === "root") {
                // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
              }
              if (entry.tryLoc <= this.prev) {
                var hasCatch = hasOwn.call(entry, "catchLoc");
                var hasFinally = hasOwn.call(entry, "finallyLoc");
                if (hasCatch && hasFinally) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  } else if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else if (hasCatch) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  }
                } else if (hasFinally) {
                  if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else {
                  throw new Error("try statement without catch or finally");
                }
              }
            }
          },
          abrupt: function abrupt(type, arg) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                var finallyEntry = entry;
                break;
              }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
              // Ignore the finally entry if control is not jumping to a
              // location outside the try/catch block.
              finallyEntry = null;
            }
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
              this.method = "next";
              this.next = finallyEntry.finallyLoc;
              return ContinueSentinel;
            }
            return this.complete(record);
          },
          complete: function complete(record, afterLoc) {
            if (record.type === "throw") {
              throw record.arg;
            }
            if (record.type === "break" || record.type === "continue") {
              this.next = record.arg;
            } else if (record.type === "return") {
              this.rval = this.arg = record.arg;
              this.method = "return";
              this.next = "end";
            } else if (record.type === "normal" && afterLoc) {
              this.next = afterLoc;
            }
            return ContinueSentinel;
          },
          finish: function finish(finallyLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.finallyLoc === finallyLoc) {
                this.complete(entry.completion, entry.afterLoc);
                resetTryEntry(entry);
                return ContinueSentinel;
              }
            }
          },
          "catch": function _catch(tryLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.tryLoc === tryLoc) {
                var record = entry.completion;
                if (record.type === "throw") {
                  var thrown = record.arg;
                  resetTryEntry(entry);
                }
                return thrown;
              }
            }

            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
              iterator: values(iterable),
              resultName: resultName,
              nextLoc: nextLoc
            };
            if (this.method === "next") {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              this.arg = undefined;
            }
            return ContinueSentinel;
          }
        };

        // Regardless of whether this script is executing as a CommonJS module
        // or not, return the runtime object so that we can declare the variable
        // regeneratorRuntime in the outer scope, which allows this module to be
        // injected easily by `bin/regenerator --include-runtime script.js`.
        return exports;
      }(
      // If this script is executing as a CommonJS module, use module.exports
      // as the regeneratorRuntime namespace. Otherwise create a new empty
      // object. Either way, the resulting object will be used to initialize
      // the regeneratorRuntime variable at the top of this file.
      true ? module.exports : {});
      try {
        regeneratorRuntime = runtime;
      } catch (accidentalStrictMode) {
        // This module should not be running in strict mode, so the above
        // assignment should always work unless something is misconfigured. Just
        // in case runtime.js accidentally runs in strict mode, we can escape
        // strict mode using a global Function call. This could conceivably fail
        // if a Content Security Policy forbids using Function, but in that case
        // the proper solution is to fix the accidental strict mode problem. If
        // you've misconfigured your bundler to force strict mode and applied a
        // CSP to forbid Function, and you're not willing to fix either of those
        // problems, please detail your unique predicament in a GitHub issue.
        Function("r", "regeneratorRuntime = r")(runtime);
      }

      /***/
    }, /* 329 */
    /***/function (module, exports) {
      /*
      	MIT License http://www.opensource.org/licenses/mit-license.php
      	Author Tobias Koppers @sokra
      */
      var stylesInDom = {},
        memoize = function memoize(fn) {
          var memo;
          return function () {
            if (typeof memo === "undefined") memo = fn.apply(this, arguments);
            return memo;
          };
        },
        isOldIE = memoize(function () {
          return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
        }),
        getHeadElement = memoize(function () {
          return document.head || document.getElementsByTagName("head")[0];
        }),
        singletonElement = null,
        singletonCounter = 0,
        styleElementsInsertedAtTop = [];
      module.exports = function (list, options) {
        if (typeof DEBUG !== "undefined" && DEBUG) {
          if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
        }
        options = options || {};
        // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
        // tags it will allow on a page
        if (typeof options.singleton === "undefined") options.singleton = isOldIE();

        // By default, add <style> tags to the bottom of <head>.
        if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
        var styles = listToStyles(list);
        addStylesToDom(styles, options);
        return function update(newList) {
          var mayRemove = [];
          for (var i = 0; i < styles.length; i++) {
            var item = styles[i];
            var domStyle = stylesInDom[item.id];
            domStyle.refs--;
            mayRemove.push(domStyle);
          }
          if (newList) {
            var newStyles = listToStyles(newList);
            addStylesToDom(newStyles, options);
          }
          for (var i = 0; i < mayRemove.length; i++) {
            var domStyle = mayRemove[i];
            if (domStyle.refs === 0) {
              for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
              delete stylesInDom[domStyle.id];
            }
          }
        };
      };
      function addStylesToDom(styles, options) {
        for (var i = 0; i < styles.length; i++) {
          var item = styles[i];
          var domStyle = stylesInDom[item.id];
          if (domStyle) {
            domStyle.refs++;
            for (var j = 0; j < domStyle.parts.length; j++) {
              domStyle.parts[j](item.parts[j]);
            }
            for (; j < item.parts.length; j++) {
              domStyle.parts.push(addStyle(item.parts[j], options));
            }
          } else {
            var parts = [];
            for (var j = 0; j < item.parts.length; j++) {
              parts.push(addStyle(item.parts[j], options));
            }
            stylesInDom[item.id] = {
              id: item.id,
              refs: 1,
              parts: parts
            };
          }
        }
      }
      function listToStyles(list) {
        var styles = [];
        var newStyles = {};
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          var id = item[0];
          var css = item[1];
          var media = item[2];
          var sourceMap = item[3];
          var part = {
            css: css,
            media: media,
            sourceMap: sourceMap
          };
          if (!newStyles[id]) styles.push(newStyles[id] = {
            id: id,
            parts: [part]
          });else newStyles[id].parts.push(part);
        }
        return styles;
      }
      function insertStyleElement(options, styleElement) {
        var head = getHeadElement();
        var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
        if (options.insertAt === "top") {
          if (!lastStyleElementInsertedAtTop) {
            head.insertBefore(styleElement, head.firstChild);
          } else if (lastStyleElementInsertedAtTop.nextSibling) {
            head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
          } else {
            head.appendChild(styleElement);
          }
          styleElementsInsertedAtTop.push(styleElement);
        } else if (options.insertAt === "bottom") {
          head.appendChild(styleElement);
        } else {
          throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
        }
      }
      function removeStyleElement(styleElement) {
        styleElement.parentNode.removeChild(styleElement);
        var idx = styleElementsInsertedAtTop.indexOf(styleElement);
        if (idx >= 0) {
          styleElementsInsertedAtTop.splice(idx, 1);
        }
      }
      function createStyleElement(options) {
        var styleElement = document.createElement("style");
        styleElement.type = "text/css";
        insertStyleElement(options, styleElement);
        return styleElement;
      }
      function createLinkElement(options) {
        var linkElement = document.createElement("link");
        linkElement.rel = "stylesheet";
        insertStyleElement(options, linkElement);
        return linkElement;
      }
      function addStyle(obj, options) {
        var styleElement, update, remove;
        if (options.singleton) {
          var styleIndex = singletonCounter++;
          styleElement = singletonElement || (singletonElement = createStyleElement(options));
          update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
          remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
        } else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
          styleElement = createLinkElement(options);
          update = updateLink.bind(null, styleElement);
          remove = function remove() {
            removeStyleElement(styleElement);
            if (styleElement.href) URL.revokeObjectURL(styleElement.href);
          };
        } else {
          styleElement = createStyleElement(options);
          update = applyToTag.bind(null, styleElement);
          remove = function remove() {
            removeStyleElement(styleElement);
          };
        }
        update(obj);
        return function updateStyle(newObj) {
          if (newObj) {
            if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
            update(obj = newObj);
          } else {
            remove();
          }
        };
      }
      var replaceText = function () {
        var textStore = [];
        return function (index, replacement) {
          textStore[index] = replacement;
          return textStore.filter(Boolean).join('\n');
        };
      }();
      function applyToSingletonTag(styleElement, index, remove, obj) {
        var css = remove ? "" : obj.css;
        if (styleElement.styleSheet) {
          styleElement.styleSheet.cssText = replaceText(index, css);
        } else {
          var cssNode = document.createTextNode(css);
          var childNodes = styleElement.childNodes;
          if (childNodes[index]) styleElement.removeChild(childNodes[index]);
          if (childNodes.length) {
            styleElement.insertBefore(cssNode, childNodes[index]);
          } else {
            styleElement.appendChild(cssNode);
          }
        }
      }
      function applyToTag(styleElement, obj) {
        var css = obj.css;
        var media = obj.media;
        if (media) {
          styleElement.setAttribute("media", media);
        }
        if (styleElement.styleSheet) {
          styleElement.styleSheet.cssText = css;
        } else {
          while (styleElement.firstChild) {
            styleElement.removeChild(styleElement.firstChild);
          }
          styleElement.appendChild(document.createTextNode(css));
        }
      }
      function updateLink(linkElement, obj) {
        var css = obj.css;
        var sourceMap = obj.sourceMap;
        if (sourceMap) {
          // http://stackoverflow.com/a/26603875
          css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
        }
        var blob = new Blob([css], {
          type: "text/css"
        });
        var oldSrc = linkElement.href;
        linkElement.href = URL.createObjectURL(blob);
        if (oldSrc) URL.revokeObjectURL(oldSrc);
      }

      /***/
    }, /* 330 */
    /***/function (module, exports, __webpack_require__) {
      // style-loader: Adds some css to the DOM by adding a <style> tag

      // load the styles
      var content = __webpack_require__(320);
      if (typeof content === 'string') content = [[module.i, content, '']];
      // add the styles to the DOM
      var update = __webpack_require__(329)(content, {});
      if (content.locals) module.exports = content.locals;
      // Hot Module Replacement
      if (false) {
        // When the styles change, update the <style> tags
        if (!content.locals) {
          module.hot.accept("!!../../css-loader/index.js!./ziggeo.css", function () {
            var newContent = require("!!../../css-loader/index.js!./ziggeo.css");
            if (typeof newContent === 'string') newContent = [[module.id, newContent, '']];
            update(newContent);
          });
        }
        // When the module is disposed, remove the <style> tags
        module.hot.dispose(function () {
          update();
        });
      }

      /***/
    }, /* 331 */
    /***/function (module, exports) {
      module.exports = "data:image/png;base64,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";

      /***/
    }, /* 332 */
    /***/function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__.p + "7931a455ff01e1a2f95b669a9283c6a7.eot";

      /***/
    }, /* 333 */
    /***/function (module, exports) {
      module.exports = function (module) {
        if (!module.webpackPolyfill) {
          module.deprecate = function () {};
          module.paths = [];
          // module.parent = undefined by default
          if (!module.children) module.children = [];
          Object.defineProperty(module, "loaded", {
            enumerable: true,
            get: function get() {
              return module.l;
            }
          });
          Object.defineProperty(module, "id", {
            enumerable: true,
            get: function get() {
              return module.i;
            }
          });
          module.webpackPolyfill = 1;
        }
        return module;
      };

      /***/
    }, /* 334 */
    /***/function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */(function (global, module) {
        /*!
        ziggeo-client-sdk - v2.39.16 - 2022-01-24
        Copyright (c) Ziggeo
        Closed Source Software License.
        */

        "object" != typeof JSON && (JSON = {}), function () {
          "use strict";

          var rx_one = /^[\],:{}\s]*$/,
            rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,
            rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
            rx_four = /(?:^|:|,)(?:\s*\[)+/g,
            rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
            rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
            gap,
            indent,
            meta,
            rep;
          function f(e) {
            return e < 10 ? "0" + e : e;
          }
          function this_value() {
            return this.valueOf();
          }
          function quote(e) {
            return rx_escapable.lastIndex = 0, rx_escapable.test(e) ? '"' + e.replace(rx_escapable, function (e) {
              var t = meta[e];
              return "string" == typeof t ? t : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + e + '"';
          }
          function str(e, t) {
            var i,
              r,
              o,
              a,
              n,
              s = gap,
              x = t[e];
            switch (x && "object" == typeof x && "function" == typeof x.toJSON && (x = x.toJSON(e)), "function" == typeof rep && (x = rep.call(t, e, x)), typeof x) {
              case "string":
                return quote(x);
              case "number":
                return isFinite(x) ? String(x) : "null";
              case "boolean":
              case "null":
                return String(x);
              case "object":
                if (!x) return "null";
                if (gap += indent, n = [], "[object Array]" === Object.prototype.toString.apply(x)) {
                  for (a = x.length, i = 0; i < a; i += 1) n[i] = str(i, x) || "null";
                  return o = 0 === n.length ? "[]" : gap ? "[\n" + gap + n.join(",\n" + gap) + "\n" + s + "]" : "[" + n.join(",") + "]", gap = s, o;
                }
                if (rep && "object" == typeof rep) for (a = rep.length, i = 0; i < a; i += 1) "string" == typeof rep[i] && (o = str(r = rep[i], x)) && n.push(quote(r) + (gap ? ": " : ":") + o);else for (r in x) Object.prototype.hasOwnProperty.call(x, r) && (o = str(r, x)) && n.push(quote(r) + (gap ? ": " : ":") + o);
                return o = 0 === n.length ? "{}" : gap ? "{\n" + gap + n.join(",\n" + gap) + "\n" + s + "}" : "{" + n.join(",") + "}", gap = s, o;
            }
          }
          "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function () {
            return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null;
          }, Boolean.prototype.toJSON = this_value, Number.prototype.toJSON = this_value, String.prototype.toJSON = this_value), "function" != typeof JSON.stringify && (meta = {
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            '"': '\\"',
            "\\": "\\\\"
          }, JSON.stringify = function (e, t, i) {
            var r;
            if (indent = gap = "", "number" == typeof i) for (r = 0; r < i; r += 1) indent += " ";else "string" == typeof i && (indent = i);
            if ((rep = t) && "function" != typeof t && ("object" != typeof t || "number" != typeof t.length)) throw new Error("JSON.stringify");
            return str("", {
              "": e
            });
          }), "function" != typeof JSON.parse && (JSON.parse = function (text, reviver) {
            var j;
            function walk(e, t) {
              var i,
                r,
                o = e[t];
              if (o && "object" == typeof o) for (i in o) Object.prototype.hasOwnProperty.call(o, i) && ((r = walk(o, i)) !== undefined ? o[i] = r : delete o[i]);
              return reviver.call(e, t, o);
            }
            if (text = String(text), rx_dangerous.lastIndex = 0, rx_dangerous.test(text) && (text = text.replace(rx_dangerous, function (e) {
              return "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
            })), rx_one.test(text.replace(rx_two, "@").replace(rx_three, "]").replace(rx_four, ""))) return j = eval("(" + text + ")"), "function" == typeof reviver ? walk({
              "": j
            }, "") : j;
            throw new SyntaxError("JSON.parse");
          });
        }(), function () {
          this && (this.forEach || (this.forEach = function (e) {
            var t, i;
            if (null === this) throw new TypeError("this is null or not defined");
            var r,
              o = Object(this),
              a = o.length >>> 0;
            if ("function" != typeof e) throw new TypeError(e + " is not a function");
            for (1 < arguments.length && (t = arguments[1]), i = 0; i < a;) {
              i in o && (r = o[i], e.call(t, r, i, o)), i++;
            }
          }), this.filter || (this.filter = function (e, t) {
            if ("function" !== (typeof e).toLowerCase() || !this) throw new TypeError();
            var i = this.length >>> 0,
              r = new Array(i),
              o = this,
              a = 0,
              n = -1;
            if (t === undefined) for (; ++n != i;) n in this && e(o[n], n, o) && (r[a++] = o[n]);else for (; ++n != i;) n in this && e.call(t, o[n], n, o) && (r[a++] = o[n]);
            return r.length = a, r;
          }), this.map || (this.map = function (e) {
            var t, i, r;
            if (null === this) throw new TypeError("this is null or not defined");
            var o,
              a,
              n = Object(this),
              s = n.length >>> 0;
            if ("function" != typeof e) throw new TypeError(e + " is not a function");
            for (1 < arguments.length && (t = arguments[1]), i = new Array(s), r = 0; r < s;) {
              r in n && (o = n[r], a = e.call(t, o, r, n), i[r] = a), r++;
            }
            return i;
          }), this.reduce || (this.reduce = function (e) {
            if (null === this) throw new TypeError("Array.prototype.reduce called on null or undefined");
            if ("function" != typeof e) throw new TypeError(e + " is not a function");
            var t,
              i = Object(this),
              r = i.length >>> 0,
              o = 0;
            if (2 <= arguments.length) t = arguments[1];else {
              for (; o < r && !(o in i);) o++;
              if (r <= o) throw new TypeError("Reduce of empty array with no initial value");
              t = i[o++];
            }
            for (; o < r;) o in i && (t = e(t, i[o], o, i)), o++;
            return t;
          }), this.some || (this.some = function (e) {
            if (null === this) throw new TypeError("Array.prototype.some called on null or undefined");
            if ("function" != typeof e) throw new TypeError();
            for (var t = Object(this), i = t.length >>> 0, r = 2 <= arguments.length ? arguments[1] : void 0, o = 0; o < i; o++) if (o in t && e.call(r, t[o], o, t)) return !0;
            return !1;
          }), this.indexOf || (this.indexOf = function (e, t) {
            var i;
            if (null === this) throw new TypeError('"this" is null or not defined');
            var r = Object(this),
              o = r.length >>> 0;
            if (0 == o) return -1;
            var a = 0 | t;
            if (o <= a) return -1;
            for (i = Math.max(0 <= a ? a : o - Math.abs(a), 0); i < o;) {
              if (i in r && r[i] === e) return i;
              i++;
            }
            return -1;
          }), this.lastIndexOf || (this.lastIndexOf = function (e) {
            if (null == this) throw new TypeError();
            var t,
              i,
              r = Object(this),
              o = r.length >>> 0;
            if (0 == o) return -1;
            for (t = o - 1, 1 < arguments.length && ((t = Number(arguments[1])) != t ? t = 0 : 0 !== t && t != 1 / 0 && t != -1 / 0 && (t = (0 < t || -1) * Math.floor(Math.abs(t)))), i = 0 <= t ? Math.min(t, o - 1) : o - Math.abs(t); 0 <= i; i--) if (i in r && r[i] === e) return i;
            return -1;
          }), this.every || (this.every = function (e, t) {
            var i, r;
            if (null === this) throw new TypeError("this is null or not defined");
            var o = Object(this),
              a = o.length >>> 0;
            if ("function" != typeof e) throw new TypeError();
            for (1 < arguments.length && (i = t), r = 0; r < a;) {
              if (r in o) {
                var n = o[r];
                if (!e.call(i, n, r, o)) return !1;
              }
              r++;
            }
            return !0;
          }), this.reduceRight || (this.reduceRight = function (e) {
            if (null == this) throw new TypeError("Array.prototype.reduce called on null or undefined");
            if ("function" != typeof e) throw new TypeError(e + " is not a function");
            var t,
              i = Object(this),
              r = (i.length >>> 0) - 1;
            if (2 <= arguments.length) t = arguments[1];else {
              for (; 0 <= r && !(r in i);) r--;
              if (r < 0) throw new TypeError("Reduce of empty array with no initial value");
              t = i[r--];
            }
            for (; 0 <= r; r--) r in i && (t = e(t, i[r], r, i));
            return t;
          }), this.find || (this.find = function (e) {
            if (null === this) throw new TypeError('"this" is null or not defined');
            var t = Object(this),
              i = t.length >>> 0;
            if ("function" != typeof e) throw new TypeError("predicate must be a function");
            for (var r = arguments[1], o = 0; o < i;) {
              var a = t[o];
              if (e.call(r, a, o, t)) return a;
              o++;
            }
            return undefined;
          }), Array.isArray || (Array.isArray = function (e) {
            return "[object Array]" === Object.prototype.toString.call(e);
          }), this.includes || (this.includes = function (e, t) {
            if (null == this) throw new TypeError('"this" is null or not defined');
            var i = Object(this),
              r = i.length >>> 0;
            if (0 == r) return !1;
            var o,
              a,
              n = 0 | t,
              s = Math.max(0 <= n ? n : r - Math.abs(n), 0);
            for (; s < r;) {
              if ((o = i[s]) === (a = e) || "number" == typeof o && "number" == typeof a && isNaN(o) && isNaN(a)) return !0;
              s++;
            }
            return !1;
          }));
        }.call(function () {
          try {
            return Array.prototype;
          } catch (e) {
            return null;
          }
        }.call(this)), function () {
          this.Map === undefined && (this.Map = function () {
            this.clear();
          }, this.Map.prototype.set = function (e, t) {
            var i;
            return e in this.__data ? this.__data[e].value = t : (i = {
              key: e,
              value: t,
              prev: this.__last,
              next: null
            }, this.__data[e] = i, this.__last ? this.__last.next = i : this.__first = i, this.__last = i, this.size++), this;
          }, this.Map.prototype.get = function (e) {
            return e in this.__data ? this.__data[e].value : undefined;
          }, this.Map.prototype.has = function (e) {
            return e in this.__data;
          }, this.Map.prototype["delete"] = function (e) {
            var t = this.__data[e];
            return t && (delete this.__data[e], this.size--, t.prev ? t.prev.next = t.next : this.__first = t.next, t.next ? t.next.prev = t.prev : this.__last = t.prev), this;
          }, this.Map.prototype.clear = function () {
            return this.__data = {}, this.__first = null, this.__last = null, this.size = 0, this;
          }, this.Map.prototype.keys = function () {
            return {
              current: this.__first,
              next: function next() {
                var e = this.current;
                return e ? (this.current = e.next, {
                  done: !1,
                  value: e.key
                }) : {
                  done: !0
                };
              }
            };
          }, this.Map.prototype.values = function () {
            return {
              current: this.__first,
              next: function next() {
                var e = this.current;
                return e ? (this.current = e.next, {
                  done: !1,
                  value: e.value
                }) : {
                  done: !0
                };
              }
            };
          }, this.Map.prototype.entries = function () {
            return {
              current: this.__first,
              next: function next() {
                var e = this.current;
                return e ? (this.current = e.next, {
                  done: !1,
                  value: [e.key, e.value]
                }) : {
                  done: !0
                };
              }
            };
          }, this.Map.prototype.forEach = function (e, t) {
            for (var i = this.__first; i;) e.call(t, i.value, i.key, this), i = i.next;
            return this;
          });
        }.call(function () {
          try {
            return window;
          } catch (e) {
            try {
              return global;
            } catch (e) {
              return self;
            }
          }
        }.call(this)), function () {
          this && (this.preventDefault = this.preventDefault || function () {
            this.returnValue = !1;
          }, this.stopPropagation = this.stopPropagation || function () {
            this.cancelBubble = !0;
          });
        }.call(function () {
          try {
            return Event.prototype;
          } catch (e) {
            return null;
          }
        }.call(this)), function () {
          var n;
          this && (n = {
            DOMContentLoaded: {
              event: "onreadystatechange",
              wrapper: function wrapper(t) {
                return function (e) {
                  "complete" == document.readyState && t(e);
                };
              }
            }
          }, this.addEventListener = this.addEventListener || function (e, t, i) {
            var r = this,
              o = function o(e) {
                e.target = e.srcElement || r, e.currentTarget = r, "undefined" != typeof t.handleEvent ? t.handleEvent(e) : t.call(r, e);
              };
            n[e] && (o = n[e].wrapper(o)), this.attachEvent("on" + (n[e] ? n[e].event : e), o);
            try {
              this.__eventlisteners = this.__eventlisteners || {}, this.__eventlisteners[e] = this.__eventlisteners[e] || [], this.__eventlisteners[e].push({
                listener: t,
                wrapper: o
              });
            } catch (a) {
              t.__eventwrapper = o;
            }
          }, this.removeEventListener = this.removeEventListener || function (e, t, i) {
            try {
              if (this.__eventlisteners && this.__eventlisteners[e]) for (var r = 0; r < this.__eventlisteners[e].length; ++r) if (this.__eventlisteners[e][r].listener === t) return this.detachEvent("on" + (n[e] ? n[e].event : e), this.__eventlisteners[e][r].wrapper), void this.__eventlisteners[e].splice(r, 1);
            } catch (o) {}
            try {
              t.__eventwrapper && this.detachEvent("on" + (n[e] ? n[e].event : e), t.__eventwrapper);
            } catch (o) {}
          }, this.dispatchEvent = this.dispatchEvent || function (e) {
            var t = e.type,
              i = "on" + t;
            try {
              return this.fireEvent(i, e);
            } catch (a) {
              var r = Element;
              try {
                r = HTMLElement;
              } catch (a) {}
              if (i in r.prototype) throw a;
              if (this.__eventlisteners && this.__eventlisteners[t]) for (var o = 0; o < this.__eventlisteners[t].length; ++o) this.__eventlisteners[t][o].wrapper.call(this, e);
            }
          });
        }.call(function () {
          try {
            return Element.prototype;
          } catch (e) {
            return null;
          }
        }.call(this)), function () {
          this && (this.addEventListener = this.addEventListener || Element.prototype.addEventListener, this.removeEventListener = this.removeEventListener || Element.prototype.removeEventListener, this.dispatchEvent = this.dispatchEvent || Element.prototype.dispatchEvent);
        }.call(function () {
          try {
            return HTMLDocument.prototype;
          } catch (e) {
            return null;
          }
        }.call(this)), function () {
          this && (this.addEventListener = this.addEventListener || Element.prototype.addEventListener, this.removeEventListener = this.removeEventListener || Element.prototype.removeEventListener, this.dispatchEvent = this.dispatchEvent || Element.prototype.dispatchEvent);
        }.call(function () {
          try {
            return Window.prototype;
          } catch (e) {
            return null;
          }
        }.call(this)), function () {
          this && Object.defineProperty && Object.getOwnPropertyDescriptor && !Object.getOwnPropertyDescriptor(this, "outerHTML") && Object.defineProperty(this, "outerHTML", {
            get: function get() {
              var e = document.createElement("div");
              e.appendChild(this.cloneNode(!0));
              var t = e.innerHTML;
              return e.remove && e.remove(), t;
            }
          });
        }.call(function () {
          try {
            return Element.prototype;
          } catch (e) {
            return null;
          }
        }.call(this)), function () {
          this && (this.forEach || (this.forEach = function (e, t) {
            t = t || window;
            for (var i = 0; i < this.length; i++) e.call(t, this[i], i, this);
          }));
        }.call(function () {
          try {
            return NodeList.prototype;
          } catch (e) {
            return null;
          }
        }.call(this)), function () {
          this && (this.trim || (this.trim = function () {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
          }));
        }.call(function () {
          try {
            return String.prototype;
          } catch (e) {
            return null;
          }
        }.call(this)), function () {
          var oldScoped = null;
          try {
            "Scoped" in window && (oldScoped = window.Scoped.detach(!0));
          } catch (e) {}
          var Scoped = function () {
            var h = function () {
                return {
                  get: function get(e) {
                    return "undefined" != typeof window ? e ? window[e] : window : "undefined" != typeof global ? e ? global[e] : global : "undefined" != typeof self ? e ? self[e] : self : undefined;
                  },
                  set: function set(e, t) {
                    return "undefined" != typeof window && (window[e] = t), "undefined" != typeof global && (global[e] = t), "undefined" != typeof self && (self[e] = t), t;
                  },
                  getPath: function getPath(e) {
                    if (!e) return this.get();
                    var t = e.split(".");
                    if (1 == t.length) return this.get(e);
                    for (var i = this.get(t[0]), r = 1; r < t.length; ++r) {
                      if (!i) return i;
                      i = i[t[r]];
                    }
                    return i;
                  },
                  setPath: function setPath(e, t) {
                    var i = e.split(".");
                    if (1 == i.length) return this.set(e, t);
                    for (var r = this.get(i[0]) || this.set(i[0], {}), o = 1; o < i.length - 1; ++o) i[o] in r || (r[i[o]] = {}), r = r[i[o]];
                    return r[i[i.length - 1]] = t;
                  }
                };
              }.call(this),
              p = function () {
                return {
                  method: function method(e, t) {
                    return function () {
                      return t.apply(e, arguments);
                    };
                  },
                  extend: function extend(e, t) {
                    for (var i in e = e || {}, t = t || {}) e[i] = t[i];
                    return e;
                  },
                  typeOf: function typeOf(e) {
                    return "[object Array]" === Object.prototype.toString.call(e) ? "array" : typeof e;
                  },
                  isEmpty: function isEmpty(e) {
                    if (null == e) return !0;
                    if ("array" == this.typeOf(e)) return 0 === e.length;
                    if ("object" != typeof e) return !1;
                    for (var t in e) return !1;
                    return !0;
                  },
                  matchArgs: function matchArgs(e, t) {
                    var i = 0,
                      r = {};
                    for (var o in t) !0 === t[o] || this.typeOf(e[i]) == t[o] ? (r[o] = e[i], i++) : "undefined" == this.typeOf(e[i]) && i++;
                    return r;
                  },
                  stringify: function stringify(e) {
                    return "function" == this.typeOf(e) ? "" + e : JSON.stringify(e);
                  }
                };
              }.call(this),
              n = function () {
                return {
                  __namespace: "Scoped",
                  __revert: null,
                  upgrade: function upgrade(e) {
                    var t = h.get(e || n.__namespace);
                    if (t && "object" === p.typeOf(t) && t.guid === this.guid && "string" === p.typeOf(t.version)) {
                      if (!1 === this.upgradable || !1 === t.upgradable) return t;
                      for (var i = this.version.split("."), r = t.version.split("."), o = !1, a = 0; a < Math.min(i.length, r.length) && (o = parseInt(i[a], 10) > parseInt(r[a], 10), i[a] === r[a]); ++a);
                      return o ? this.attach(e) : t;
                    }
                    return this.attach(e);
                  },
                  attach: function attach(t) {
                    t && (n.__namespace = t);
                    var i = h.get(n.__namespace);
                    if (i === this) return this;
                    if (n.__revert = i) try {
                      var r = i.__exportScoped();
                      this.__exportBackup = this.__exportScoped(), this.__importScoped(r);
                    } catch (e) {}
                    return h.set(n.__namespace, this), this;
                  },
                  detach: function detach(e) {
                    return e && h.set(n.__namespace, null), "undefined" != typeof n.__revert && h.set(n.__namespace, n.__revert), delete n.__revert, n.__exportBackup && this.__importScoped(n.__exportBackup), this;
                  },
                  exports: function exports(e, t, i) {
                    return "object" == typeof (e = e || (true ? module : null)) && e && "exports" in e && (i || e.exports === this || !e.exports || p.isEmpty(e.exports)) && (e.exports = t || this), this;
                  }
                };
              }.call(this);
            function b(t) {
              var n = {
                tree: "boolean" == typeof t.tree && t.tree,
                global: "boolean" == typeof t.global && t.global,
                root: "object" == typeof t.root ? t.root : {}
              };
              function o(e) {
                return {
                  route: "string" == typeof e.route ? e.route : null,
                  parent: "object" == typeof e.parent ? e.parent : null,
                  ready: "boolean" == typeof e.ready && e.ready,
                  children: {},
                  watchers: [],
                  data: {},
                  lazy: []
                };
              }
              var s = o({
                ready: !0
              });
              if (n.tree) if (n.global) {
                try {
                  window && (s.data = window);
                } catch (e) {}
                try {
                  global && (s.data = global);
                } catch (e) {}
                try {
                  self && (s.data = self);
                } catch (e) {}
              } else s.data = n.root;
              function x(e) {
                if (!e.ready) if (!e.parent || e.parent.ready) {
                  if (e.route && e.parent && e.route in e.parent.data) {
                    e.data = e.parent.data[e.route], e.ready = !0;
                    for (var t = 0; t < e.watchers.length; ++t) e.watchers[t].callback.call(e.watchers[t].context || this, e.data);
                    for (var i in e.watchers = [], e.children) x(e.children[i]);
                  }
                } else x(e.parent);
              }
              function r(e, t) {
                if ("object" == typeof t && e.ready) for (var i in t) e.data[i] = t[i];else e.data = t;
                if ("object" == typeof t) for (var r in t) e.children[r] && (e.children[r].data = t[r]);
                for (var o in !function a(e) {
                  if (!e.ready) {
                    e.parent && !e.parent.ready && a(e.parent), e.ready = !0, e.parent && n.tree && "object" == typeof e.parent.data && (e.parent.data[e.route] = e.data);
                    for (var t = 0; t < e.watchers.length; ++t) e.watchers[t].callback.call(e.watchers[t].context || this, e.data);
                    e.watchers = [];
                  }
                }(e), e.children) x(e.children[o]);
              }
              function c(e) {
                if (!e) return s;
                for (var t = e.split("."), i = s, r = 0; r < t.length; ++r) t[r] in i.children ? i = i.children[t[r]] : (i.children[t[r]] = o({
                  parent: i,
                  route: t[r]
                }), x(i = i.children[t[r]]));
                return i;
              }
              return {
                extend: function extend(e, t) {
                  r(c(e), t);
                },
                set: function set(e, t) {
                  var i = c(e);
                  i.data && function (e) {
                    if (e.ready && e.data) for (var t in e.data) delete e.data[t];
                  }(i), r(i, t);
                },
                get: function get(e) {
                  var t = c(e);
                  return t.ready ? t.data : null;
                },
                lazy: function lazy(e, t, i) {
                  var r = c(e);
                  r.ready ? t(i || this, r.data) : r.lazy.push({
                    callback: t,
                    context: i
                  });
                },
                digest: function digest(e) {
                  x(c(e));
                },
                obtain: function obtain(e, t, i) {
                  !function (e, t, i) {
                    var _r;
                    e.ready ? t.call(i || this, e.data) : (e.watchers.push({
                      callback: t,
                      context: i
                    }), 0 < e.lazy.length && (_r = function r(e) {
                      var t;
                      0 < e.lazy.length && ((t = e.lazy.shift()).callback.call(t.context || this, e.data), _r(e));
                    })(e));
                  }(c(e), t, i);
                },
                unresolvedWatchers: function unresolvedWatchers(e) {
                  return function a(e, t, i) {
                    for (var r in i = i || [], !(e = e || s).ready && 0 === e.lazy.length && 0 < e.watchers.length && i.push(t), e.children) {
                      var o = e.children[r];
                      i = a(o, (t ? t + "." : "") + o.route, i);
                    }
                    return i;
                  }(c(e), e);
                },
                __export: function __export() {
                  return {
                    options: n,
                    nsRoot: s
                  };
                },
                __import: function __import(e) {
                  n = e.options, s = e.nsRoot;
                }
              };
            }
            var t = b({
                tree: !0,
                global: !0
              }),
              i = b({
                tree: !0
              }),
              r = function m(e, t, i, r) {
                var o = null,
                  a = [],
                  n = t,
                  s = i,
                  x = r,
                  c = b({
                    tree: !0
                  }),
                  d = b({
                    tree: !1
                  }),
                  l = {
                    global: {
                      namespace: x
                    },
                    root: {
                      namespace: s
                    },
                    local: {
                      namespace: c
                    },
                    "default": {
                      namespace: d
                    },
                    parent: {
                      namespace: n
                    },
                    scope: {
                      namespace: c,
                      readonly: !1
                    }
                  },
                  u = function u(a, n, s) {
                    var x = p.matchArgs(a, {
                        options: "object",
                        namespaceLocator: !0,
                        dependencies: "array",
                        hiddenDependencies: "array",
                        callback: !0,
                        context: "object"
                      }),
                      e = p.extend({
                        lazy: this.options.lazy
                      }, x.options || {}),
                      c = this.resolve(x.namespaceLocator),
                      t = function t() {
                        this.require(x.dependencies, x.hiddenDependencies, function () {
                          for (var e = [], t = 0; t < arguments.length; ++t) e.push(arguments[t]);
                          if (e[e.length - 1].ns = c, this.options.compile) {
                            for (var i = [], r = 0; r < a.length; ++r) i.push(p.stringify(a[r]));
                            this.compiled += this.options.ident + "." + n + "(" + i.join(", ") + ");\n\n";
                          }
                          this.options.dependencies && (this.dependencies[c.path] = this.dependencies[c.path] || {}, x.dependencies && x.dependencies.forEach(function (e) {
                            this.dependencies[c.path][this.resolve(e).path] = !0;
                          }, this), x.hiddenDependencies && x.hiddenDependencies.forEach(function (e) {
                            this.dependencies[c.path][this.resolve(e).path] = !0;
                          }, this));
                          var o = this.options.compile ? {} : x.callback.apply(x.context || this, e);
                          s.call(this, c, o);
                        }, this);
                      };
                    return e.lazy ? c.namespace.lazy(c.path, t, this) : t.apply(this), this;
                  };
                return {
                  getGlobal: p.method(h, h.getPath),
                  setGlobal: p.method(h, h.setPath),
                  options: {
                    lazy: !1,
                    ident: "Scoped",
                    compile: !1,
                    dependencies: !1
                  },
                  compiled: "",
                  dependencies: {},
                  nextScope: function nextScope() {
                    return o = o || m(0, c, s, x);
                  },
                  subScope: function subScope() {
                    var e = this.nextScope();
                    return a.push(e), o = null, e;
                  },
                  binding: function binding(e, t, i) {
                    var r;
                    return l[e] && l[e].readonly || (r = "string" != p.typeOf(t) ? {
                      namespace: b({
                        tree: !0,
                        root: t
                      }),
                      path: null
                    } : this.resolve(t), l[e] = p.extend(i, r)), this;
                  },
                  resolve: function resolve(e) {
                    var t = e.split(":");
                    if (1 == t.length) throw "The locator '" + t[0] + "' requires a namespace.";
                    var i = l[t[0]];
                    if (!i) throw "The namespace '" + t[0] + "' has not been defined (yet).";
                    return {
                      namespace: i.namespace,
                      path: i.path && t[1] ? i.path + "." + t[1] : i.path || t[1]
                    };
                  },
                  define: function define() {
                    return u.call(this, arguments, "define", function (e, t) {
                      if (e.namespace.get(e.path)) throw "Scoped namespace " + e.path + " has already been defined. Use extend to extend an existing namespace instead";
                      e.namespace.set(e.path, t);
                    });
                  },
                  assumeVersion: function assumeVersion() {
                    var a = p.matchArgs(arguments, {
                        assumption: !0,
                        dependencies: "array",
                        callback: !0,
                        context: "object",
                        error: "string"
                      }),
                      e = a.dependencies || [];
                    e.unshift(a.assumption), this.require(e, function () {
                      var e = arguments,
                        t = e[0].replace(/[^\d\.]/g, "");
                      e[0] = t.split(".");
                      for (var i = 0; i < e[0].length; ++i) e[0][i] = parseInt(e[0][i], 10);
                      if ("function" === p.typeOf(a.callback)) {
                        if (!a.callback.apply(a.context || this, a)) throw "Scoped Assumption '" + a.assumption + "' failed, value is " + t + (a.error ? ", but assuming " + a.error : "");
                      } else for (var r = (a.callback + "").replace(/[^\d\.]/g, "").split("."), o = 0; o < Math.min(e[0].length, r.length); ++o) if (parseInt(r[o], 10) > e[0][o]) throw "Scoped Version Assumption '" + a.assumption + "' failed, value is " + t + ", but assuming at least " + a.callback;
                    });
                  },
                  extend: function extend() {
                    return u.call(this, arguments, "extend", function (e, t) {
                      e.namespace.extend(e.path, t);
                    });
                  },
                  require: function require() {
                    var t = p.matchArgs(arguments, {
                      dependencies: "array",
                      hiddenDependencies: "array",
                      callback: "function",
                      context: "object"
                    });
                    t.callback = t.callback || function () {};
                    var e = t.dependencies || [],
                      i = e.concat(t.hiddenDependencies || []),
                      r = i.length,
                      o = [],
                      a = {};
                    if (r) for (var n = function n(e) {
                        this.i < o.length && (o[this.i] = e), 0 == --r && (o.push(a), t.callback.apply(t.context || this.ctx, o));
                      }, s = 0; s < i.length; ++s) {
                      var x = this.resolve(i[s]);
                      s < e.length && o.push(null), x.namespace.obtain(x.path, n, {
                        ctx: this,
                        i: s
                      });
                    } else o.push(a), t.callback.apply(t.context || this, o);
                    return this;
                  },
                  digest: function digest(e) {
                    var t = this.resolve(e);
                    return t.namespace.digest(t.path), this;
                  },
                  unresolved: function unresolved(e) {
                    var t = this.resolve(e);
                    return t.namespace.unresolvedWatchers(t.path);
                  },
                  __export: function __export() {
                    return {
                      parentNamespace: n.__export(),
                      rootNamespace: s.__export(),
                      globalNamespace: x.__export(),
                      localNamespace: c.__export(),
                      privateNamespace: d.__export()
                    };
                  },
                  __import: function __import(e) {
                    n.__import(e.parentNamespace), s.__import(e.rootNamespace), x.__import(e.globalNamespace), c.__import(e.localNamespace), d.__import(e.privateNamespace);
                  }
                };
              }(0, i, i, t),
              o = p.extend(r, function () {
                return {
                  guid: "4b6878ee-cb6a-46b3-94ac-27d91f58d666",
                  version: "0.0.22",
                  upgradable: !0,
                  upgrade: n.upgrade,
                  attach: n.attach,
                  detach: n.detach,
                  exports: n.exports,
                  __exportScoped: function __exportScoped() {
                    return {
                      globalNamespace: t.__export(),
                      rootNamespace: i.__export(),
                      rootScope: r.__export()
                    };
                  },
                  __importScoped: function __importScoped(e) {
                    t.__import(e.globalNamespace), i.__import(e.rootNamespace), r.__import(e.rootScope);
                  }
                };
              }.call(this));
            return (o = o.upgrade()).exports(), o;
          }.call(this);
          (function () {
            var h = this.subScope();
            h.binding("module", "root:BetaJS"), h.define("module:", function () {
              return {
                guid: "71366f7a-7da3-4e55-9a0b-ea0e4e2a9e79",
                version: "1.0.233",
                datetime: 1636237273138
              };
            }), h.define("module:Types", function () {
              return {
                is_object_instance: function is_object_instance(e) {
                  return this.is_object(e) && !this.is_null(e);
                },
                is_object: function is_object(e) {
                  return "object" == typeof e;
                },
                is_array: function is_array(e) {
                  return Array.isArray(e);
                },
                is_undefined: function is_undefined(e) {
                  return void 0 === e;
                },
                is_null: function is_null(e) {
                  return null === e;
                },
                is_none: function is_none(e) {
                  return this.is_undefined(e) || this.is_null(e);
                },
                is_defined: function is_defined(e) {
                  return void 0 !== e;
                },
                is_empty: function is_empty(e) {
                  return this.is_none(e) || this.is_array(e) && 0 === e.length || this.is_object(e) && this.is_empty_object(e);
                },
                is_empty_object: function is_empty_object(e) {
                  for (var t in e) return !1;
                  return !0;
                },
                is_string: function is_string(e) {
                  return "string" == typeof e;
                },
                is_function: function is_function(e) {
                  return "function" == typeof e;
                },
                is_boolean: function is_boolean(e) {
                  return "boolean" == typeof e;
                },
                compare: function compare(e, t) {
                  if (this.is_boolean(e) && this.is_boolean(t)) return e === t ? 0 : e ? 1 : -1;
                  if (this.is_array(e) && this.is_array(t)) {
                    for (var i = e.length, r = t.length, o = Math.min(i, r), a = 0; a < o; ++a) {
                      var n = this.compare(e[a], t[a]);
                      if (0 !== n) return n;
                    }
                    return i === r ? 0 : r < i ? 1 : -1;
                  }
                  return e.localeCompare(t);
                },
                parseBool: function parseBool(e) {
                  return this.is_boolean(e) ? e : "true" === e || "" === e || "false" !== e && null;
                },
                parseArray: function parseArray(e) {
                  return this.is_string(e) ? e.split(",") : e;
                },
                type_of: function type_of(e) {
                  return this.is_array(e) ? "array" : typeof e;
                },
                isNumber: function isNumber(e) {
                  return "number" == typeof e;
                },
                parseInt: function (_parseInt) {
                  function parseInt(_x) {
                    return _parseInt.apply(this, arguments);
                  }
                  parseInt.toString = function () {
                    return _parseInt.toString();
                  };
                  return parseInt;
                }(function (e) {
                  return this.isNumber(e) ? e : parseInt(e, 10);
                }),
                parseFloat: function (_parseFloat) {
                  function parseFloat(_x2) {
                    return _parseFloat.apply(this, arguments);
                  }
                  parseFloat.toString = function () {
                    return _parseFloat.toString();
                  };
                  return parseFloat;
                }(function (e) {
                  return this.isNumber(e) ? e : parseFloat(e);
                }),
                parseDateTime: function parseDateTime(e) {
                  if ("number" == typeof e || this.is_none(e)) return e;
                  "object" == typeof e && (e = e.toString());
                  var t = new Date(e);
                  return isNaN(t.getTime()) ? parseInt(e, 10) : t.getTime();
                },
                parseType: function parseType(e, t) {
                  switch (t.toLowerCase()) {
                    case "bool":
                    case "boolean":
                      return this.parseBool(e);
                    case "int":
                    case "integer":
                    case "number":
                      return this.parseInt(e);
                    case "date":
                    case "time":
                    case "datetime":
                      return this.parseDateTime(e);
                    case "float":
                    case "double":
                      return this.parseFloat(e);
                    case "array":
                      return this.parseArray(e);
                    case "jsonarray":
                      return "string" == typeof e ? JSON.parse(e) : e;
                    case "object":
                    case "json":
                      return "string" == typeof e ? JSON.parse(e) : e;
                    case "id":
                      return "object" == typeof e && e ? e.toString() : e;
                    default:
                      return e;
                  }
                },
                parseTypes: function parseTypes(e, t) {
                  var i = {};
                  for (var r in e) i[r] = r in t ? this.parseType(e[r], t[r]) : e[r];
                  return i;
                },
                objectType: function objectType(e) {
                  if (!this.is_object(e)) return null;
                  var t = e.toString().match(/\[object (.*)\]/);
                  return t ? t[1] : null;
                },
                is_pure_object: function is_pure_object(e) {
                  return this.is_object(e) && ("[object]" === e.toString().toLowerCase() || "[object object]" === e.toString().toLowerCase());
                },
                typefy: function (_typefy) {
                  function typefy(_x3) {
                    return _typefy.apply(this, arguments);
                  }
                  typefy.toString = function () {
                    return _typefy.toString();
                  };
                  return typefy;
                }(function (e) {
                  var i = function i(t) {
                    var e = t.length;
                    return ["'", '"'].forEach(function (e) {
                      0 === t.indexOf(e) && t.lastIndexOf(e) === t.length - e.length && (t = t.substring(e.length, t.length - 2 * e.length + 1));
                    }), (t = t.trim()).length < e ? i(t) : t;
                  };
                  switch (typeof e) {
                    case "object":
                      if (Array.isArray(e)) return e.map(typefy);
                      for (var t in e) e[t] = typefy(e[t]);
                      return e;
                    case "string":
                      return "true" === (e = i(e)) || "false" !== e && (parseInt(e, 10) + "" === e ? parseInt(e, 10) : e);
                    default:
                      return e;
                  }
                })
              };
            }), h.define("module:Time", [], function () {
              return {
                __components: {
                  year: {
                    set: function set(e, t) {
                      e.setUTCFullYear(t);
                    },
                    get: function get(e) {
                      return e.getUTCFullYear();
                    }
                  },
                  month: {
                    set: function set(e, t) {
                      e.setUTCMonth(t);
                    },
                    get: function get(e) {
                      return e.getUTCMonth();
                    }
                  },
                  day: {
                    dependencies: {
                      weekday: !0
                    },
                    set: function set(e, t) {
                      e.setUTCDate(t + 1);
                    },
                    get: function get(e) {
                      return e.getUTCDate() - 1;
                    },
                    milliseconds: 864e5
                  },
                  weekday: {
                    dependencies: {
                      day: !0,
                      month: !0,
                      year: !0
                    },
                    set: function set(e, t) {
                      e.setUTCDate(e.getUTCDate() + t - e.getUTCDay());
                    },
                    get: function get(e) {
                      return e.getUTCDay();
                    }
                  },
                  hour: {
                    set: function set(e, t) {
                      e.setUTCHours(t);
                    },
                    get: function get(e) {
                      return e.getUTCHours();
                    },
                    max: 23,
                    milliseconds: 36e5
                  },
                  minute: {
                    set: function set(e, t) {
                      e.setUTCMinutes(t);
                    },
                    get: function get(e) {
                      return e.getUTCMinutes();
                    },
                    max: 59,
                    milliseconds: 6e4
                  },
                  second: {
                    set: function set(e, t) {
                      e.setUTCSeconds(t);
                    },
                    get: function get(e) {
                      return e.getUTCSeconds();
                    },
                    max: 59,
                    milliseconds: 1e3
                  },
                  millisecond: {
                    set: function set(e, t) {
                      e.setUTCMilliseconds(t);
                    },
                    get: function get(e) {
                      return e.getUTCMilliseconds();
                    },
                    max: 999,
                    milliseconds: 1
                  }
                },
                getTimezoneOffset: function getTimezoneOffset(e) {
                  return this.__timezoneOffset !== undefined ? this.__timezoneOffset : e ? new Date(e).getTimezoneOffset() : new Date().getTimezoneOffset();
                },
                setTimezoneOffset: function setTimezoneOffset(e) {
                  this.__timezoneOffset = e;
                },
                timezoneBias: function timezoneBias(e, t) {
                  return !0 === e && (e = this.getTimezoneOffset(t)), null != e && !1 !== e || (e = 0), 60 * e * 1e3;
                },
                timeToDate: function timeToDate(e, t) {
                  return new Date(e + this.timezoneBias(t, e));
                },
                dateToTime: function dateToTime(e, t) {
                  return e.getTime() - this.timezoneBias(t, e.getTime());
                },
                timeToTimezoneBasedDate: function timeToTimezoneBasedDate(e, t) {
                  return new Date(e - this.timezoneBias(t, e));
                },
                timezoneBasedDateToTime: function timezoneBasedDateToTime(e, t) {
                  return e.getTime() + this.timezoneBias(t, e.getTime());
                },
                decodeTime: function decodeTime(e, t) {
                  var i = this.timeToTimezoneBasedDate(e || this.now(), t),
                    r = {};
                  for (var o in this.__components) r[o] = this.__components[o].get(i);
                  return r;
                },
                encodeTime: function encodeTime(e, t) {
                  return this.updateTime(this.now(), e, t);
                },
                encodePeriod: function encodePeriod(e) {
                  return this.incrementTime(0, e);
                },
                updateTime: function updateTime(e, t, i) {
                  var r = this.timeToTimezoneBasedDate(e, i);
                  for (var o in t) this.__components[o].set(r, t[o]);
                  return this.timezoneBasedDateToTime(r, i);
                },
                now: function now(e) {
                  return this.dateToTime(new Date(), e);
                },
                uniqueAtLeastNow: function uniqueAtLeastNow(e, t) {
                  var i = this.now(t);
                  return this.__unique_at_least_now && this.__unique_at_least_now >= i && (i = this.__unique_at_least_now + (e || 1)), this.__unique_at_least_now = i;
                },
                perfNow: function perfNow() {
                  return "undefined" == typeof performance ? new Date().getTime() : performance.now();
                },
                incrementTime: function incrementTime(e, t) {
                  var i = this.timeToDate(e);
                  for (var r in t) this.__components[r].set(i, this.__components[r].get(i) + t[r]);
                  return this.dateToTime(i);
                },
                floorTime: function floorTime(e, t, i) {
                  var r = this.timeToTimezoneBasedDate(e, i),
                    o = !1;
                  for (var a in this.__components) {
                    var n = this.__components[a];
                    !(o = o || a == t) || n.dependencies && n.dependencies[t] || n.set(r, 0);
                  }
                  return this.timezoneBasedDateToTime(r, i);
                },
                ago: function ago(e, t) {
                  return this.now(t) - e;
                },
                timeComponent: function timeComponent(e, t, i) {
                  return Math[i || "floor"](e / this.__components[t].milliseconds);
                },
                timeComponentGet: function timeComponentGet(e, t, i) {
                  return this.__components[t].get(this.timeToTimezoneBasedDate(e, i));
                },
                timeModulo: function timeModulo(e, t, i) {
                  return this.timeComponent(e, t, i) % (this.__components[t].max + 1);
                }
              };
            }), h.define("module:Functions", ["module:Time", "module:Types"], function (x, s) {
              return {
                getStackTrace: function getStackTrace(e) {
                  for (var t = new Error().stack.split("\n"); 0 < t.length && "error" === t[0].trim().toLowerCase();) t.shift();
                  return e ? t.slice(e) : t;
                },
                as_method: function as_method(e, t) {
                  return function () {
                    return e.apply(t, arguments);
                  };
                },
                global_method: function global_method(e) {
                  var t = h.getGlobal(e);
                  return t ? this.as_method(t, h.getGlobal()) : t;
                },
                once: function once(e) {
                  var t = !1,
                    i = !1;
                  return function () {
                    return i || (i = !0, t = e.apply(this, arguments), e = null), t;
                  };
                },
                getArguments: function getArguments(e, t) {
                  return Array.prototype.slice.call(e, t || 0);
                },
                matchArgs: function matchArgs(e, t, i) {
                  arguments.length < 3 && (i = t, t = 0);
                  var r = t,
                    o = {};
                  for (var a in i) {
                    var n = i[a];
                    !0 === n ? n = {
                      required: !0
                    } : "string" == typeof n && (n = {
                      type: n
                    }), n.required || n.type && s.type_of(e[r]) == n.type ? (o[a] = e[r], r++) : n.def && (o[a] = s.is_function(n.def) ? n.def(o) : n.def);
                  }
                  return o;
                },
                newClassFunc: function newClassFunc(i) {
                  return function () {
                    var e = arguments;
                    function t() {
                      return i.apply(this, e);
                    }
                    return t.prototype = i.prototype, new t();
                  };
                },
                newClass: function newClass(e) {
                  return this.newClassFunc(e).apply(this, this.getArguments(arguments, 1));
                },
                callWithin: function callWithin(e, t) {
                  return s.is_string(t) && (t = e[t]), t.apply(e, this.getArguments(arguments, 2));
                },
                throttle: function throttle(t, i) {
                  var r,
                    o,
                    a = 0;
                  return function () {
                    var e = x.now();
                    if (o = this, r = arguments, a + i - e <= 0) return a = e, t.apply(o, r);
                  };
                },
                debounce: function debounce(t, i, r) {
                  var o,
                    a,
                    n,
                    s = function s() {
                      var e = x.now() - lastCall;
                      e < i ? n = setTimeout(s, i - e) : (n = null, r || t.apply(a, o));
                    };
                  return function () {
                    a = this, o = arguments, lastCall = x.now(), n || (n = setTimeout(s, i), r && t.apply(this, arguments));
                  };
                }
              };
            }), h.define("module:Objs", ["module:Types", "module:Functions"], function (s, i) {
              return {
                ithKey: function ithKey(e, t) {
                  for (var i in t = t || 0, e) {
                    if (t <= 0) return i;
                    --t;
                  }
                  return null;
                },
                ithValue: function ithValue(e, t) {
                  for (var i in t = t || 0, e) {
                    if (t <= 0) return e[i];
                    --t;
                  }
                  return null;
                },
                valueByIndex: function valueByIndex(e, t) {
                  return s.is_array(e) ? e[t || 0] : this.ithValue(e, t);
                },
                keyByIndex: function keyByIndex(e, t) {
                  return s.is_array(e) ? t || 0 : this.ithKey(e, t);
                },
                count: function count(e) {
                  if (s.is_array(e)) return e.length;
                  var t = 0;
                  for (var i in e) t++;
                  return t;
                },
                clone: function clone(e, t) {
                  return e && t && 0 !== t ? s.is_array(e) ? e.slice(0) : s.is_object(e) ? this.extend({}, e, t - 1) : e : e;
                },
                acyclic_clone: function acyclic_clone(e) {
                  if (null === e || !s.is_object(e)) return e;
                  var t = "__acyclic_cloned";
                  if (e[t]) return e[t];
                  var i = {};
                  for (var r in e[t] = i, e) r !== t && (i[r] = this.acyclic_clone(e[r]));
                  return delete e[t], i;
                },
                extend: function extend(e, t, i) {
                  if (e = e || {}, t) for (var r in t) e[r] = this.clone(t[r], i);
                  return e;
                },
                multi_extend: function multi_extend() {
                  var e,
                    t = i.getArguments(arguments);
                  for (s.is_object(t[t.length - 1]) || (e = t[t.length - 1], t.pop()); 1 < t.length;) t[1] = this.extend(t[0], t[1], e), t.shift();
                  return t[0];
                },
                weak_extend: function weak_extend(e, t, i) {
                  if (e = e || {}, t) for (var r in t) r in e || (e[r] = this.clone(t[r], i));
                  return e;
                },
                tree_extend: function tree_extend(e, t, i) {
                  if (e = e || {}, t) for (var r in t) r in e && s.is_object(e[r]) && s.is_object(t[r]) && !s.is_array(e[r]) && !s.is_array(t[r]) ? e[r] = this.tree_extend(e[r], t[r], i) : e[r] = this.clone(t[r], i);
                  return e;
                },
                keys: function keys(e, t) {
                  var i = null,
                    r = null;
                  if (s.is_undefined(t)) {
                    for (r in i = [], e) i.push(r);
                    return i;
                  }
                  for (r in i = {}, e) i[r] = t;
                  return i;
                },
                subset_of: function subset_of(e, t) {
                  for (var i in e = s.is_array(e) ? this.objectify(e) : e, t = s.is_array(t) ? this.objectify(t) : t, e) if (e[i] != t[i]) return !1;
                  return !0;
                },
                superset_of: function superset_of(e, t) {
                  return this.subset_of(t, e);
                },
                pairArrayToObject: function pairArrayToObject(e) {
                  for (var t = {}, i = 0; i < e.length / 2; i += 2) t[e[i]] = e[i + 1];
                  return t;
                },
                pairsToObject: function pairsToObject() {
                  for (var e = {}, t = 0; t < arguments.length; ++t) e[arguments[t][0]] = arguments[t][1];
                  return e;
                },
                inverseKeyValue: function inverseKeyValue(e) {
                  var i = {};
                  return this.iter(e, function (e, t) {
                    i[e] = t;
                  }), i;
                },
                exists: function exists(e, t, i) {
                  var r = !1;
                  return this.iter(e, function () {
                    return !(r = r || t.apply(this, arguments));
                  }, i), r;
                },
                all: function all(e, t, i) {
                  var r = !0;
                  return this.iter(e, function () {
                    return r = r && t.apply(this, arguments);
                  }, i), r;
                },
                peek: function peek(e) {
                  if (s.is_array(e)) return 0 < e.length ? e[0] : null;
                  for (var t in e) return e[t];
                  return null;
                },
                poll: function poll(e) {
                  if (s.is_array(e)) return e.shift();
                  for (var t in e) {
                    var i = e[t];
                    return delete e[t], i;
                  }
                  return null;
                },
                iter: function iter(e, t, i) {
                  var r = null;
                  if (s.is_array(e)) {
                    for (var o = 0; o < e.length; ++o) if (r = i ? t.apply(i, [e[o], o]) : t(e[o], o), s.is_defined(r) && !r) return !1;
                  } else for (var a in e) if (r = i ? t.apply(i, [e[a], a]) : t(e[a], a), s.is_defined(r) && !r) return !1;
                  return !0;
                },
                intersect: function intersect(e, t) {
                  var i = {};
                  for (var r in e) r in t && (i[r] = e[r]);
                  return i;
                },
                keyEquals: function keyEquals(e, t) {
                  for (var i in e) if (!(i in t)) return !1;
                  for (i in t) if (!(i in e)) return !1;
                  return !0;
                },
                splitObject: function splitObject(e, i, t) {
                  var r = {},
                    o = {};
                  return this.iter(e, function (e, t) {
                    i.apply(this, arguments) ? r[t] = e : o[t] = e;
                  }, t), [r, o];
                },
                diff: function diff(e, t) {
                  var i = {};
                  for (var r in e) r in t && e[r] === t[r] || (i[r] = e[r]);
                  return i;
                },
                contains_key: function contains_key(e, t) {
                  return s.is_array(e) ? s.is_defined(e[t]) : t in e;
                },
                contains_value: function contains_value(e, t) {
                  if (s.is_array(e)) {
                    for (var i = 0; i < e.length; ++i) if (e[i] === t) return !0;
                  } else for (var r in e) if (e[r] === t) return !0;
                  return !1;
                },
                map: function map(e, t, i) {
                  var r = null;
                  if (i = i || this, s.is_array(e)) {
                    r = [];
                    for (var o = 0; o < e.length; ++o) r.push(t.call(i, e[o], o));
                    return r;
                  }
                  for (var a in r = {}, e) r[a] = t.call(i, e[a], a);
                  return r;
                },
                keyMap: function keyMap(e, t, i) {
                  for (var r in result = {}, i = i || this, e) result[t.call(i, e[r], r)] = e[r];
                  return result;
                },
                bidirectionalMap: function bidirectionalMap(e) {
                  var r = {};
                  return this.iter(e, function (e, t) {
                    if (s.is_array(e)) for (var i = 0; i < e.length; ++i) r[e[i]] = t;else r[e] = t;
                    r[t] = e;
                  }), r;
                },
                values: function values(e) {
                  var t = [];
                  for (var i in e) t.push(e[i]);
                  return t;
                },
                flatten: function flatten(e) {
                  var t = [];
                  return e.forEach(function (e) {
                    t = t.concat(s.is_array(e) ? e : [e]);
                  }), t;
                },
                treeValues: function treeValues(e) {
                  return e && s.is_array(e) ? this.flatten(e.map(this.treeValues, this)) : e && s.is_object(e) ? this.treeValues(this.values(e)) : [e];
                },
                uniqueValues: function uniqueValues(e) {
                  var t = {};
                  return this.filter(e, function (e) {
                    return !(e in t) && (t[e] = !0);
                  });
                },
                filter: function filter(e, t, i) {
                  if (t = t || function (e) {
                    return !!e;
                  }, s.is_array(e)) return e.filter(t, i);
                  var r = {};
                  for (var o in e) (i ? t.apply(i, [e[o], o]) : t(e[o], o)) && (r[o] = e[o]);
                  return r;
                },
                equals: function equals(e, t, i) {
                  var r = null;
                  if (i && 0 < i) {
                    for (r in e) if (!(r in t && this.equals(e[r], t[r], i - 1))) return !1;
                    for (r in t) if (!(r in e)) return !1;
                    return !0;
                  }
                  return e == t;
                },
                objectify: function objectify(e, t, i) {
                  var r = {},
                    o = s.is_function(t);
                  s.is_undefined(t) && (t = !0);
                  for (var a = 0; a < e.length; ++a) r[e[a]] = o ? t.apply(i || this, [e[a], a]) : t;
                  return r;
                },
                arrayify: function arrayify(e, i, t) {
                  var r = [];
                  return this.iter(e, function (e, t) {
                    r.push(i.call(this, e, t));
                  }, t), r;
                },
                objectBy: function objectBy() {
                  for (var e = {}, t = arguments.length / 2, i = 0; i < t; ++i) e[arguments[2 * i]] = arguments[2 * i + 1];
                  return e;
                },
                specialize: function specialize(e, t, i) {
                  var r = {},
                    o = i ? e : t;
                  for (var a in o) a in e && e[a] == t[a] || (r[a] = t[a]);
                  return r;
                },
                merge: function merge(e, t, i) {
                  e = e || {}, t = t || {};
                  var r = {},
                    o = this.extend(this.keys(e, !0), this.keys(t, !0));
                  for (var a in o) {
                    var n = a in i ? i[a] : "primary";
                    "primary" == n || "secondary" == n ? (a in t || a in e) && (r[a] = "primary" == n ? a in t ? t[a] : e[a] : a in e ? e[a] : t[a]) : s.is_function(n) ? r[a] = n(e[a], t[a]) : s.is_object(n) && (r[a] = this.merge(e[a], t[a], n));
                  }
                  return r;
                },
                tree_merge: function tree_merge(e, t) {
                  e = e || {}, t = t || {};
                  var i = {},
                    r = this.extend(this.keys(e, !0), this.keys(t, !0));
                  for (var o in r) s.is_object(t[o]) && e[o] ? i[o] = this.tree_merge(e[o], t[o]) : i[o] = o in t ? t[o] : e[o];
                  return i;
                },
                serializeFlatJSON: function serializeFlatJSON(e, i) {
                  var r = [];
                  return s.is_array(e) && e ? e.forEach(function (e) {
                    r = r.concat(this.serializeFlatJSON(e, i + "[]"));
                  }, this) : s.is_object(e) && e ? this.iter(e, function (e, t) {
                    r = r.concat(this.serializeFlatJSON(e, i ? i + "[" + t + "]" : t));
                  }, this) : r = [{
                    key: i,
                    value: e
                  }], r;
                },
                objectToArray: function objectToArray(e, i, t) {
                  var r = [];
                  return this.iter(e, function (e, t) {
                    r.push(i.call(this, t, e));
                  }, t), r;
                },
                initArray: function initArray(e, t, i) {
                  for (var r = [], o = 0; o < e; ++o) r.push(t.call(i || this, o));
                  return r;
                },
                customMerge: function customMerge(e, t, i, r) {
                  var o = {};
                  for (var a in e) o[a] = a in t ? i.call(r, a, e[a], t[a]) : e[a];
                  for (var n in t) n in e || (o[n] = t[n]);
                  return o;
                },
                indexizeArray: function indexizeArray(e, t) {
                  var i = {};
                  return e.forEach(function (e) {
                    i[e[t]] = e;
                  }), i;
                },
                filterOutValues: function filterOutValues(e, t) {
                  return this.filter(e, function (e) {
                    return !t.includes(e);
                  });
                },
                mergeSortedArrays: function mergeSortedArrays(e, t, i) {
                  i = i || function (e, t) {
                    return t < e ? 1 : e < t ? -1 : 0;
                  };
                  var r = [],
                    o = 0;
                  for (e.forEach(function (e) {
                    for (; o < t.length && 0 < i(e, t[o]);) r.push(t[o]), o++;
                    for (r.push(e); o < t.length && 0 === i(e, t[o]);) o++;
                  }); o < t.length;) r.push(t[o]), o++;
                  return r;
                },
                getObjKeyByValue: function getObjKeyByValue(e, t) {
                  for (var i in e) if (e.hasOwnProperty(i) && e[i] === t) return i;
                }
              };
            }), h.define("module:Ids", ["module:Types", "module:Objs"], function (i, r) {
              return {
                __uniqueId: 0,
                uniqueId: function uniqueId(e) {
                  return (e || "") + this.__uniqueId++;
                },
                objectId: function objectId(e, t) {
                  return e ? (t !== undefined ? e.__cid = t : e.__cid || (e.__cid = this.uniqueId("cid_")), e.__cid) : undefined;
                },
                uniqueKey: function uniqueKey(e, t) {
                  return t && 0 < t && (i.is_object(e) || i.is_array(e)) ? JSON.stringify(r.map(e, function (e) {
                    return this.uniqueKey(e, t - 1);
                  }, this)) : null !== e && i.is_object(e) || i.is_array(e) || i.is_function(e) ? this.objectId(e) : e;
                }
              };
            }), h.define("module:Class", ["module:Types", "module:Objs", "module:Functions", "module:Ids"], function (l, u, r, i) {
              var t = function t() {};
              return t.extend = function (e, t, i, r) {
                t = t || [], l.is_array(t) || (t = [t]), i = i || [], l.is_array(i) || (i = [i]), r = r || [], l.is_array(r) || (r = [r]);
                var o,
                  a = this;
                t = u.map(t, function (e) {
                  return l.is_function(e) && (e = e(a.prototype)), e;
                }), u.iter(t, function (e) {
                  e.hasOwnProperty("constructor") && (o = e.constructor);
                });
                var n = l.is_defined(o);
                n || (o = function o() {
                  a.prototype.constructor.apply(this, arguments);
                }), u.extend(o, a), u.iter(i, function (e) {
                  e = l.is_function(e) ? e(a) : e;
                  var t = o._extender;
                  u.extend(o, e), e._extender && (o._extender = u.extend(u.clone(t, 1), e._extender));
                });
                var s = {};
                if (a.__class_statics_keys) for (var x in a.__class_statics_keys) o[x] = u.clone(a[x], 1);
                u.iter(r, function (e) {
                  u.extend(o, e), u.extend(s, u.keys(e, !0));
                }), a.__class_statics_keys && u.extend(s, a.__class_statics_keys), o.__class_statics_keys = s, o.parent = a, o.children = [], o.extend = this.extend, a.children || (a.children = []), a.children.push(o);
                var c = function c() {};
                c.prototype = a.prototype, o.prototype = new c(), o.prototype.cls = o;
                var d = (e = u.extend({}, l.is_string(e) ? {
                  classname: e,
                  register: !0
                } : e)).classname;
                return e.scoped && (d = e.scoped.ns.path), (o.classname = d) && e.register && h.setGlobal(d, o), o.__notifications = {}, o.__implements = {}, a.__notifications && u.extend(o.__notifications, a.__notifications, 1), a.__implements && u.extend(o.__implements, a.__implements, 1), u.iter(t, function (e) {
                  for (var t in e) o.prototype[t] = o._extender && t in o._extender ? o._extender[t](o.prototype[t], e[t]) : e[t];
                  if ("constructor" in e && (o.prototype.constructor = e.constructor), e._notifications) for (var i in e._notifications) o.__notifications[i] || (o.__notifications[i] = []), o.__notifications[i].push(e._notifications[i]);
                  e._implements && u.iter(l.is_string(e._implements) ? [e._implements] : e._implements, function (e) {
                    o.__implements[e] = !0;
                  });
                }), delete o.prototype._notifications, delete o.prototype._implements, n || (o.prototype.constructor = function () {
                  a.prototype.constructor.apply(this, arguments);
                }), o;
              }, u.extend(t, {
                classname: "Class",
                __class_guid: "0f5499f9-f0d1-4c6c-a561-ef026a1eee05",
                __notifications: {},
                ancestor_of: function ancestor_of(e) {
                  return this == e || this != t && this.parent.ancestor_of(e);
                },
                is_class: function is_class(e) {
                  return e && l.is_object(e) && "__class_guid" in e && e.__class_guid == this.__class_guid;
                },
                is_class_instance: function is_class_instance(e) {
                  return e && l.is_object(e) && "__class_instance_guid" in e && e.__class_instance_guid == this.prototype.__class_instance_guid;
                },
                is_pure_json: function is_pure_json(e) {
                  return e && l.is_object(e) && !this.is_class_instance(e) && l.is_pure_object(e);
                },
                is_instance_of: function is_instance_of(e) {
                  return e && this.is_class_instance(e) && e.instance_of(this);
                },
                define: function define(t, e) {
                  var i = r.getArguments(arguments, 2);
                  return l.is_object(t) ? h.define(e, [], function (e) {
                    return i.unshift({
                      scoped: e
                    }), t.extend.apply(t, i);
                  }) : h.define(e, [t], function (e, t) {
                    return i.unshift({
                      scoped: t
                    }), e.extend.apply(e, i);
                  });
                },
                abstractFunction: function abstractFunction() {
                  throw "AbstractFunction";
                },
                _inherited: function _inherited(e, t) {
                  return e.parent[t].apply(this, Array.prototype.slice.apply(arguments, [2]));
                }
              }), t.prototype.__class_instance_guid = "e6b0ed30-80ee-4b28-af02-7d52430ba45f", t.prototype.constructor = function () {
                this._notify("construct");
              }, t.prototype.destroy = function () {
                this._notify("destroy"), this.__auto_destroy_list && this.__auto_destroy_list.forEach(function (e) {
                  "destroy" in e && e.weakDestroy();
                }, this), this.__auto_decrease_ref_list && this.__auto_decrease_ref_list.forEach(function (e) {
                  "decreaseRef" in e && e.decreaseRef(this);
                }, this);
                var e = this.cid();
                for (var t in this) delete this[t];
                i.objectId(this, e), this.destroy = this.__destroyedDestroy;
              }, t.prototype.destroyed = function () {
                return this.destroy === this.__destroyedDestroy;
              }, t.prototype.weakDestroy = function () {
                if (!this.destroyed()) {
                  if (this.__gc) return void this.__gc.queue(this);
                  this.destroy();
                }
              }, t.prototype.__destroyedDestroy = function () {
                throw "Trying to destroy destroyed object " + this.cid() + ": " + this.cls.classname + ".";
              }, t.prototype.recursionProtection = function (t, i) {
                if (this.__recursionProtection = this.__recursionProtection || {}, this.__recursionProtection[t]) return undefined;
                this.__recursionProtection[t] = !0;
                try {
                  var r = i.apply(this);
                  return this && this.__recursionProtection && delete this.__recursionProtection[t], r;
                } catch (e) {
                  throw this && this.__recursionProtection && delete this.__recursionProtection[t], e;
                }
              }, t.prototype.enableGc = function (e) {
                return this.supportsGc && (this.__gc = e), this;
              }, t.prototype.dependDestroy = function (e) {
                if (!e.destroyed()) return this.__gc && e.enableGc(), e.weakDestroy(), this;
              }, t.prototype.cid = function () {
                return i.objectId(this);
              }, (t.prototype.cls = t).prototype.as_method = function (e) {
                return r.as_method(this[e], this);
              }, t.prototype.auto_destroy = function (e, t) {
                if (e) {
                  this.__auto_destroy_list || (this.__auto_destroy_list = []);
                  var i = e;
                  l.is_array(i) || (i = [i]);
                  for (var r = 0; r < i.length; ++r) this.__auto_destroy_list.push(i[r]);
                }
                return t ? this : e;
              }, t.prototype.auto_decrease_ref = function (e, t) {
                if (e) {
                  this.__auto_decrease_ref_list || (this.__auto_decrease_ref_list = []);
                  var i = e;
                  l.is_array(i) || (i = [i]);
                  for (var r = 0; r < i.length; ++r) this.__auto_decrease_ref_list.push(i[r]);
                }
                return t ? this : e;
              }, t.prototype._notify = function (i) {
                var r;
                this.cls.__notifications && (r = Array.prototype.slice.call(arguments, 1), u.iter(this.cls.__notifications[i], function (e) {
                  var t = l.is_function(e) ? e : this[e];
                  if (!t) throw this.cls.classname + ": Could not find " + i + " notification handler " + e;
                  t.apply(this, r);
                }, this));
              }, t.prototype.impl = function (e) {
                return !(!this.cls.__implements || !this.cls.__implements[l.is_string(e) ? e : e._implements]);
              }, t.prototype.instance_of = function (e) {
                return this.cls.ancestor_of(e);
              }, t.prototype.increaseRef = function (e, t) {
                return this.__referenceCount = this.__referenceCount || 0, this.__referenceCount++, this.__referenceObjects = this.__referenceObjects || {}, e && (this.__referenceObjects[e.cid()] ? this.__referenceCount-- : this.__referenceObjects[e.cid()] = e, t && e.auto_decrease_ref(this)), this;
              }, t.prototype.decreaseRef = function (e) {
                return this.__referenceCount = this.__referenceCount || 0, this.__referenceCount--, this.__referenceObjects = this.__referenceObjects || {}, e && (this.__referenceObjects[e.cid()] ? delete this.__referenceObjects[e.cid()] : this.__referenceCount++), this.__referenceCount <= 0 && l.is_empty(this.__referenceObjects) && this.weakDestroy(), this;
              }, t.prototype.inspect = function () {
                return {
                  header: {
                    cid: this.cid(),
                    classname: this.cls.classname,
                    destroyed: this.destroyed()
                  },
                  attributes: {
                    attributes_public: u.filter(this, function (e, t) {
                      return !l.is_function(e) && 0 !== t.indexOf("_");
                    }, this),
                    attributes_protected: u.filter(this, function (e, t) {
                      return !l.is_function(e) && 0 === t.indexOf("_") && 0 !== t.indexOf("__");
                    }, this),
                    attributes_private: u.filter(this, function (e, t) {
                      return !l.is_function(e) && 0 === t.indexOf("__");
                    }, this)
                  },
                  methods: {
                    methods_public: u.filter(this, function (e, t) {
                      return l.is_function(e) && 0 !== t.indexOf("_");
                    }, this),
                    methods_protected: u.filter(this, function (e, t) {
                      return l.is_function(e) && 0 === t.indexOf("_") && 0 !== t.indexOf("__");
                    }, this),
                    method_private: u.filter(this, function (e, t) {
                      return l.is_function(e) && 0 === t.indexOf("__");
                    }, this)
                  }
                };
              }, t.prototype._auto_destroy = function (e) {
                return this.auto_destroy(e);
              }, t.prototype._inherited = function (e, t) {
                return e.parent.prototype[t].apply(this, Array.prototype.slice.apply(arguments, [2]));
              }, t;
            }), h.define("module:Async", ["module:Types", "module:Functions", "module:Time"], function (t, a, n) {
              var r = function r(e) {
                  return clearTimeout(e);
                },
                o = a.global_method("clearImmediate") || a.global_method("cancelAnimationFrame") || a.global_method("webkitCancelAnimationFrame") || a.global_method("mozCancelAnimationFrame") || r,
                s = a.global_method("setImmediate") || a.global_method("requestAnimationFrame") || a.global_method("webkitRequestAnimationFrame") || a.global_method("mozRequestAnimationFrame") || function (e) {
                  return setTimeout(e, 0);
                },
                x = {},
                c = 1,
                i = {
                  waitFor: function waitFor() {
                    var t = a.matchArgs(arguments, {
                        condition: !0,
                        conditionCtx: "object",
                        callback: !0,
                        callbackCtx: "object",
                        interval: "number",
                        timeoutCallback: "function",
                        timeoutCallbackCtx: "object",
                        timeout: "number"
                      }),
                      i = function i() {
                        try {
                          return !!t.condition.apply(t.conditionCtx || t.callbackCtx || this);
                        } catch (e) {
                          return !1;
                        }
                      },
                      r = n.now();
                    if (!i()) {
                      var o = setInterval(function () {
                        i() ? (clearInterval(o), t.callback.apply(t.callbackCtx || this)) : t.timeout && n.now() - r >= t.timeout && (clearInterval(o), t.timeoutCallback && t.timeoutCallback.apply(t.timeoutCallbackCtx || t.callbackCtx || this));
                      }, t.interval || 1);
                      return o;
                    }
                    t.callback.apply(t.callbackCtx || this);
                  },
                  asyncify: function asyncify(e) {
                    return function () {
                      i.eventually(e, this);
                    };
                  },
                  eventually: function eventually() {
                    var e = a.matchArgs(arguments, {
                      func: !0,
                      params: "array",
                      context: "object",
                      time: "number"
                    });
                    e.time = e.time || 0;
                    var t = {},
                      i = function i() {
                        t.clear(t.handle), e.func.apply(e.context || this, e.params || []);
                      };
                    return 0 < e.time ? (t.clear = r, t.handle = setTimeout(i, e.time)) : (t.clear = o, t.handle = s(i)), t;
                  },
                  clearEventually: function clearEventually(e) {
                    e && e.clear && e.handle && e.clear(e.handle);
                  },
                  eventuallyOnce: function eventuallyOnce(e, t, i) {
                    var r = {
                      func: e,
                      params: t,
                      context: i
                    };
                    for (var o in x) {
                      var a = x[o];
                      if (a.func === e && a.params === t && a.context === i) return;
                    }
                    var n = ++c;
                    return x[n] = r, this.eventually(function () {
                      delete x[n], e.apply(i || this, t || []);
                    }, this);
                  }
                };
              return i;
            }), h.define("module:Promise", ["module:Types", "module:Functions", "module:Async", "module:Objs"], function (o, s, x, t) {
              var c = {
                Promise: function Promise(e, t, i) {
                  this.__value = t || e === undefined ? null : e, this.__error = t || null, this.__isFinished = i, this.__hasError = !!t, this.__resultPromise = null, this.__callbacks = [];
                },
                fromNativePromise: function fromNativePromise(e) {
                  var t = this.create();
                  return e.then(function (e) {
                    t.asyncSuccess(e);
                  })["catch"](function (e) {
                    t.asyncError(e);
                  }), t;
                },
                create: function create(e, t) {
                  return new this.Promise(e, t, 0 < arguments.length);
                },
                value: function value(e) {
                  return this.is(e) ? e : new this.Promise(e, null, !0);
                },
                eventualValue: function eventualValue(e) {
                  var t = new this.Promise();
                  return x.eventually(function () {
                    t.asyncSuccess(e);
                  }), t;
                },
                error: function error(e) {
                  return this.is(e) ? e : new this.Promise(null, e, !0);
                },
                box: function box(t, i, r) {
                  if (t && "then" in t && "catch" in t) {
                    var o = this.create();
                    return t.then(o.asyncSuccessFunc()), t["catch"](o.asyncErrorFunc()), o;
                  }
                  try {
                    var a = t.apply(i || this, r || []);
                    return this.is(a) ? a : this.value(a);
                  } catch (e) {
                    return this.error(e);
                  }
                },
                tryCatch: function tryCatch(t, i) {
                  try {
                    return this.value(t.apply(i || this));
                  } catch (e) {
                    return this.error(e);
                  }
                },
                funcCallback: function funcCallback(e, t) {
                  var i = [];
                  o.is_function(e) ? (i = s.getArguments(arguments, 1), t = e, e = this) : i = s.getArguments(arguments, 2);
                  var r = this.create();
                  return i.push(r.asyncCallbackFunc()), t.apply(e, i), r;
                },
                and: function and(e) {
                  var t = this.create();
                  return t.__promises = [], t.__successCount = 0, t.__values = [], t.__errorPromise = null, t.and = function (e) {
                    if (e = e || [], this.__ended) return this;
                    o.is_array(e) || (e = [e]);
                    for (var t = function t(e, _t) {
                        e ? this.promise.__errorPromise = this.promise.__promises[this.idx] : (this.promise.__successCount++, this.promise.__values[this.idx] = _t), this.promise.results();
                      }, i = 0; i < e.length; ++i) {
                      var r = this.__promises.length;
                      this.__promises.push(e[i]), this.__values.push(null), e[i].isFinished() ? e[i].hasValue() ? (this.__successCount++, this.__values[r] = e[i].value()) : this.__errorPromise = e[i] : e[i].callback(t, {
                        promise: this,
                        idx: r
                      });
                    }
                    return this;
                  }, t.end = function () {
                    return this.__ended || (this.__ended = !0, this.results()), this;
                  }, t.results = function () {
                    return this.__ended && this.__errorPromise ? this.asyncError(this.__errorPromise.err(), this.__errorPromise) : this.__ended && this.__successCount == this.__promises.length && this.asyncSuccess(this.__values), this;
                  }, t.successUnfold = function (e, t, i) {
                    return this.success(function () {
                      return e.apply(t, arguments);
                    }, t, i);
                  }, t.and(e), t;
                },
                conditional: function conditional(e, t, i) {
                  return e ? t() : this.value(i);
                },
                func: function func(o) {
                  for (var a = s.getArguments(arguments, 1), e = [], t = 0; t < a.length; ++t) this.is(a[t]) && e.push(a[t]);
                  var n = this.create();
                  return this.and(e).end().success(function (e) {
                    for (var t = [], i = 0; i < a.length; ++i) t[i] = this.is(a[i]) ? a[i].value() : a[i];
                    var r = o.apply(this, t);
                    this.is(r) ? r.forwardCallback(n) : n.asyncSuccess(r);
                  }, this).forwardError(n), n;
                },
                methodArgs: function methodArgs(e, t, i) {
                  return i.unshift(function () {
                    return t.apply(e, arguments);
                  }), this.func.apply(this, i);
                },
                method: function method(e, t) {
                  return this.methodArgs(e, t, s.getArguments(arguments, 2));
                },
                newClass: function newClass(e) {
                  var t = s.getArguments(arguments, 1);
                  return t.unshift(s.newClassFunc(e)), this.func.apply(this, t);
                },
                is: function is(e) {
                  return e && o.is_object(e) && e.classGuid == this.Promise.prototype.classGuid;
                },
                resilience: function resilience(t, i, r, o, e) {
                  return e && (t = this.delayPromiseMethod(t, e)), t.apply(i, o).mapError(function (e) {
                    return 0 === r ? e : this.resilience(t, i, r - 1, o);
                  }, this);
                },
                delayPromiseMethod: function delayPromiseMethod(i, r) {
                  var o = this;
                  return function () {
                    var e = o.create(),
                      t = s.getArguments(arguments);
                    return x.eventually(function () {
                      i.apply(this, t).forwardCallback(e);
                    }, this, r), e;
                  };
                },
                waitFor: function waitFor(e, t, i, r) {
                  var o,
                    a,
                    n = this.create();
                  return r && (a = setTimeout(function () {
                    o && clearInterval(o), n.asyncError(!0);
                  }, r)), o = x.waitFor(e, t, function () {
                    a && clearTimeout(a), n.asyncSuccess(!0);
                  }, i), n;
                },
                exclusiveExecution: function exclusiveExecution(r, o) {
                  var a = null,
                    n = [];
                  return function () {
                    var e,
                      t = arguments,
                      i = null;
                    return (i = a ? (e = c.create(), n.push(e), e.mapSuccess(function () {
                      return r.apply(this, t);
                    }, o)) : a = r.apply(o, t)).callback(function () {
                      a = null, 0 < n.length && (a = n.shift()).asyncSuccess(!0);
                    }), i;
                  };
                },
                aggregateExecution: function aggregateExecution(o, a, n, s) {
                  var x = {};
                  return function () {
                    var e,
                      t = arguments,
                      i = n ? n(t) : JSON.stringify(t),
                      r = x[i];
                    return r || (e = !0, r = o.apply(a, t).callback(function () {
                      e = !1, delete x[i];
                    }).mapSuccess(function (e) {
                      return s ? s(e) : e;
                    }), e && (x[i] = r)), r;
                  };
                }
              };
              return t.extend(c.Promise.prototype, {
                classGuid: "7e3ed52f-22da-4e9c-95a4-e9bb877a3935",
                success: function success(e, t, i) {
                  return this.callback(e, t, i, "success");
                },
                asuccess: function asuccess(e, t, i) {
                  return this.success(x.asyncify(e), t, i);
                },
                valueify: function valueify(t, i) {
                  return this.success(function (e) {
                    t[i] = e;
                  });
                },
                error: function error(e, t, i) {
                  return this.callback(e, t, i, "error");
                },
                callback: function callback(e, t, i, r) {
                  "end" in this && this.end();
                  var o = {
                    type: r || "callback",
                    func: e,
                    options: i || {},
                    context: t
                  };
                  return this.__isFinished ? this.triggerResult(o) : this.__callbacks.push(o), this;
                },
                timeout: function timeout(e, t, i) {
                  var r = x.eventually(t, i, e);
                  return this.callback(function () {
                    x.clearEventually(r);
                  });
                },
                timeoutError: function timeoutError(e, t) {
                  return e ? this.timeout(e, function () {
                    this.asyncError(t);
                  }, this) : this;
                },
                triggerResult: function triggerResult(e) {
                  if (!this.__isFinished) return this;
                  if (e) "success" != e.type || this.__hasError ? "error" == e.type && this.__hasError ? e.func.call(e.context || this, this.__error, this.__resultPromise || this) : "callback" == e.type && e.func.call(e.context || this, this.__error, this.__value, this.__resultPromise || this) : e.func.call(e.context || this, this.__value, this.__resultPromise || this);else {
                    var t = this.__callbacks;
                    this.__callbacks = [];
                    for (var i = 0; i < t.length; ++i) this.triggerResult(t[i]);
                  }
                  return this;
                },
                value: function value() {
                  return this.__value;
                },
                err: function err() {
                  return this.__error;
                },
                isFinished: function isFinished() {
                  return this.__isFinished;
                },
                hasValue: function hasValue() {
                  return this.__isFinished && !this.__hasError;
                },
                hasError: function hasError() {
                  return this.__isFinished && this.__hasError;
                },
                asyncSuccess: function asyncSuccess(e, t) {
                  return this.__isFinished ? this : (this.__resultPromise = t, this.__error = null, this.__isFinished = !0, this.__hasError = !1, this.__value = e, this.triggerResult());
                },
                asyncError: function asyncError(e, t) {
                  return this.__isFinished ? this : (this.__resultPromise = t, this.__isFinished = !0, this.__hasError = !0, this.__error = e, this.__value = null, this.triggerResult());
                },
                asyncCallback: function asyncCallback(e, t, i) {
                  return e ? this.asyncError(e, i) : this.asyncSuccess(t, i);
                },
                forwardSuccess: function forwardSuccess(e) {
                  return this.success(e.asyncSuccess, e), this;
                },
                forwardError: function forwardError(e) {
                  return this.error(e.asyncError, e), this;
                },
                forwardCallback: function forwardCallback(e) {
                  return this.callback(e.asyncCallback, e), this;
                },
                asyncCallbackFunc: function asyncCallbackFunc() {
                  return s.as_method(this.asyncCallback, this);
                },
                asyncSuccessFunc: function asyncSuccessFunc() {
                  return s.as_method(this.asyncSuccess, this);
                },
                asyncErrorFunc: function asyncErrorFunc() {
                  return s.as_method(this.asyncError, this);
                },
                mapSuccess: function mapSuccess(o, a) {
                  var n = c.create();
                  return this.forwardError(n).success(function (t, i) {
                    try {
                      var r = o.call(a || n, t, i);
                      c.is(r) ? r.forwardCallback(n) : n.asyncSuccess(r);
                    } catch (e) {
                      this.__callbacks.every(function (e) {
                        return "success" === e.type;
                      }) && console.warn(e), n.asyncError(e);
                    }
                  }), n;
                },
                mapASuccess: function mapASuccess(i, r) {
                  return this.mapSuccess(function (e) {
                    var t = c.create();
                    return x.eventually(function () {
                      c.box(i, r, [e]).forwardCallback(t);
                    }), t;
                  });
                },
                mapError: function mapError(r, o) {
                  var a = c.create();
                  return this.forwardSuccess(a).error(function (e, t) {
                    var i = r.call(o || a, e, t);
                    c.is(i) ? i.forwardCallback(a) : a.asyncError(i);
                  }), a;
                },
                mapCallback: function mapCallback(o, a) {
                  var n = c.create();
                  return this.callback(function (e, t, i) {
                    var r = o.call(a || n, e, t, i);
                    c.is(r) ? r.forwardCallback(n) : n.asyncCallback(e ? r : e, e ? t : r, i);
                  }), n;
                },
                and: function and(e) {
                  return c.and(this).and(e);
                },
                toNativePromise: function toNativePromise() {
                  var e = this;
                  return new Promise(function (i, r) {
                    e.callback(function (e, t) {
                      e ? r(e) : i(t);
                    });
                  });
                }
              }), c;
            }), h.define("module:Classes.OptimisticConditionalInstance", ["module:Class", "module:Objs", "module:Promise"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    i.constructor.call(this), this._transitionals = {};
                  },
                  _initializer: function _initializer() {},
                  _initialize: function _initialize() {
                    return this._initializer().success(function () {
                      this._afterInitialize();
                    }, this);
                  },
                  transitionals: function transitionals() {
                    return this._transitionals;
                  },
                  _afterInitialize: function _afterInitialize() {}
                };
              }, {}, {
                __registry: [],
                register: function register(e, t) {
                  this.__registry.push({
                    cls: e,
                    priority: t
                  });
                },
                create: function create(a) {
                  var n = i.create(),
                    s = t.clone(this.__registry, 1),
                    x = {},
                    c = function c() {
                      if (s.length) {
                        for (var e = -1, t = -1, i = 0; i < s.length; ++i) s[i].priority > e && (e = s[i].priority, t = i);
                        var r = s[t].cls;
                        s.splice(t, 1);
                        var o = new r(a, x);
                        o._initialize().error(function () {
                          x = o.transitionals(), o.destroy(), c.call(this);
                        }, this).success(function () {
                          n.asyncSuccess(o);
                        });
                      } else n.asyncError(!0);
                    };
                  return c.call(this), n;
                }
              });
            }), h.define("module:Timers.Timer", ["module:Class", "module:Objs", "module:Time"], function (e, i, r, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), e = i.extend({
                      once: !1,
                      start: !0,
                      fire: null,
                      context: this,
                      destroy_on_fire: !1,
                      destroy_on_stop: !1,
                      real_time: !1,
                      duration: null,
                      fire_max: null,
                      immediate: !1
                    }, e), this.__immediate = e.immediate, this.__delay = e.delay, this.__destroy_on_fire = e.destroy_on_fire, this.__destroy_on_stop = e.destroy_on_stop, this.__once = e.once, this.__fire = e.fire, this.__context = e.context, this.__started = !1, this.__real_time = e.real_time, this.__end_time = null !== e.duration ? r.now() + e.duration : null, this.__fire_max = e.fire_max, e.start && this.start();
                  },
                  destroy: function destroy() {
                    this.stop(), t.destroy.call(this);
                  },
                  fire_count: function fire_count() {
                    return this.__fire_count;
                  },
                  duration: function duration() {
                    return r.now() - this.__start_time;
                  },
                  fire: function fire() {
                    if (this.__once && (this.__started = !1), this.__fire && (this.__fire.call(this.__context, this), this.__fire_count++, this.__real_time && !this.__destroy_on_fire && !this.__once)) for (; (this.__fire_count + 1) * this.__delay <= r.now() - this.__start_time;) this.__fire.call(this.__context, this), this.__fire_count++;
                    (null !== this.__end_time && r.now() + this.__delay > this.__end_time || null !== this.__fire_max && this.__fire_max <= this.__fire_count) && this.stop(), this.__destroy_on_fire && this.weakDestroy();
                  },
                  stop: function stop() {
                    return this.__started && ((this.__once ? clearTimeout : clearInterval)(this.__timer), this.__started = !1, this.__destroy_on_stop && this.weakDestroy()), this;
                  },
                  start: function start() {
                    if (this.__started) return this;
                    var e = this;
                    return this.__start_time = r.now(), this.__fire_count = 0, this.__once ? this.__timer = setTimeout(function () {
                      e.fire();
                    }, this.__delay) : this.__timer = setInterval(function () {
                      e.fire();
                    }, this.__delay), this.__started = !0, this.__immediate && this.fire(), this;
                  },
                  restart: function restart() {
                    return this.stop(), this.start(), this;
                  }
                };
              });
            }), h.define("module:Iterators.Iterator", ["module:Class", "module:Functions", "module:Async", "module:Promise"], function (e, t, o, a, i) {
              return e.extend({
                scoped: i
              }, function (e) {
                return {
                  hasNext: function hasNext() {
                    return !1;
                  },
                  next: function next() {
                    return null;
                  },
                  nextOrNull: function nextOrNull() {
                    return this.hasNext() ? this.next() : null;
                  },
                  asArray: function asArray(e) {
                    for (var t = []; this.hasNext();) t.push(this.next());
                    return e || this.weakDestroy(), t;
                  },
                  iterate: function iterate(e, t, i) {
                    for (; this.hasNext();) {
                      if (!1 === e.call(t || this, this.next())) break;
                    }
                    i || this.weakDestroy();
                  },
                  asyncIterate: function asyncIterate(e, t, i) {
                    if (!this.hasNext()) return this.destroy(), a.value(!0);
                    if (!1 === e.call(t || this, this.next())) return a.value(!0);
                    var r = a.create();
                    return o.eventually(function () {
                      this.asyncIterate(e, t, i).forwardCallback(r);
                    }, this, i), r;
                  }
                };
              });
            }), h.define("module:Iterators.ArrayIterator", ["module:Iterators.Iterator"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.__array = e, this.__i = 0;
                  },
                  hasNext: function hasNext() {
                    return this.__i < this.__array.length;
                  },
                  next: function next() {
                    var e = this.__array[this.__i];
                    return this.__i++, e;
                  }
                };
              }, {
                byIterate: function byIterate(e, t) {
                  var i = [];
                  return e.call(t || this, function (e) {
                    i.push(e);
                  }, this), new this(i);
                }
              });
            }), h.define("module:Lists.AbstractList", ["module:Class", "module:Objs", "module:Types", "module:Iterators.ArrayIterator"], function (e, i, o, r, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  _add: function _add(e) {},
                  _remove: function _remove(e) {},
                  _get: function _get(e) {},
                  _iterate: function _iterate(e, t) {},
                  get_ident: function get_ident(i) {
                    var r = null;
                    return this._iterate(function (e, t) {
                      return e != i || (r = t, !1);
                    }), r;
                  },
                  exists: function exists(e) {
                    return e && null !== this.get_ident(e);
                  },
                  _ident_changed: function _ident_changed(e, t) {},
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.__count = 0, e && i.iter(e, function (e) {
                      this.add(e);
                    }, this);
                  },
                  add: function add(e) {
                    var t = this._add(e);
                    return o.is_defined(t) && this.__count++, t;
                  },
                  count: function count() {
                    return this.__count;
                  },
                  clear: function clear() {
                    this._iterate(function (e, t) {
                      return this.remove_by_ident(t), !0;
                    }, this);
                  },
                  remove_by_ident: function remove_by_ident(e) {
                    var t = this._remove(e);
                    return o.is_defined(t) && this.__count--, t;
                  },
                  remove: function remove(e) {
                    return this.remove_by_ident(this.get_ident(e));
                  },
                  remove_by_filter: function remove_by_filter(i) {
                    this._iterate(function (e, t) {
                      return i(e) && this.remove_by_ident(t), !0;
                    }, this);
                  },
                  get: function get(e) {
                    return this._get(e);
                  },
                  iterate: function iterate(r, e) {
                    this._iterate(function (e, t) {
                      var i = r.call(this, e, t);
                      return !o.is_defined(i) || i;
                    }, e);
                  },
                  iterator: function iterator() {
                    return r.byIterate(this.iterate, this);
                  }
                };
              });
            }), h.define("module:Lists.LinkedList", ["module:Lists.AbstractList"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  __first: null,
                  __last: null,
                  _add: function _add(e) {
                    return this.__last = {
                      obj: e,
                      prev: this.__last,
                      next: null
                    }, this.__first ? this.__last.prev.next = this.__last : this.__first = this.__last, this.__last;
                  },
                  _remove: function _remove(e) {
                    return e.next ? e.next.prev = e.prev : this.__last = e.prev, e.prev ? e.prev.next = e.next : this.__first = e.next, e.obj;
                  },
                  _get: function _get(e) {
                    return e.obj;
                  },
                  _iterate: function _iterate(e, t) {
                    for (var i = this.__first; i;) {
                      var r = i,
                        i = i.next;
                      if (!e.apply(t || this, [r.obj, r])) return;
                    }
                  }
                };
              });
            }), h.define("module:Events.EventsMixin", ["module:Timers.Timer", "module:Async", "module:Lists.LinkedList", "module:Functions", "module:Types", "module:Objs"], function (o, i, x, n, t, a) {
              return {
                _implements: "3d63b44f-c9f0-4aa7-b39e-7cbf195122b4",
                _notifications: {
                  construct: function construct() {
                    this.__suspendedEvents = 0, this.__suspendedEventsQueue = [];
                  },
                  destroy: function destroy() {
                    this.off(null, null, null);
                  }
                },
                EVENT_SPLITTER: /\s+/,
                __create_event_object: function __create_event_object(e, t, i) {
                  var r = {
                    callback: e,
                    context: t
                  };
                  return (i = i || {}).eventually && (r.eventually = i.eventually), i.off_on_destroyed && (r.off_on_destroyed = i.off_on_destroyed), i.min_delay && (r.min_delay = new o({
                    delay: i.min_delay,
                    once: !0,
                    start: !1,
                    context: this,
                    fire: function fire() {
                      r.max_delay && r.max_delay.stop(), this.__invokeCallback(r);
                    }
                  })), i.max_delay && (r.max_delay = new o({
                    delay: i.max_delay,
                    once: !0,
                    start: !1,
                    context: this,
                    fire: function fire() {
                      r.min_delay && r.min_delay.stop(), this.__invokeCallback(r);
                    }
                  })), i.norecursion && (r.no_recursion = !0), r;
                },
                __destroy_event_object: function __destroy_event_object(e) {
                  e.min_delay && e.min_delay.destroy(), e.max_delay && e.max_delay.destroy();
                },
                __invokeCallback: function __invokeCallback(e, t) {
                  if (e.off_on_destroyed && e.context && e.context.destroyed()) this.off(null, null, e);else if (!e.no_recursion || !e.in_recursion) {
                    e.in_recursion = !0;
                    try {
                      this._invokeCallback(e.callback, e.context || this, t || e.params);
                    } finally {
                      e.in_recursion = !1;
                    }
                  }
                },
                _invokeCallback: function _invokeCallback(e, t, i) {
                  e.apply(t, i);
                },
                __call_event_object: function __call_event_object(e, t) {
                  e.min_delay && e.min_delay.restart(), e.max_delay && e.max_delay.start(), e.min_delay || e.max_delay ? e.params = t : e.eventually ? i.eventually(function () {
                    this.__invokeCallback(e, t);
                  }, this, !0 === e.eventually ? 0 : e.eventually) : this.__invokeCallback(e, t);
                },
                on: function on(e, t, i, r) {
                  var o;
                  for (this.__events_mixin_events = this.__events_mixin_events || {}, e = e.split(this.EVENT_SPLITTER); o = e.shift();) {
                    this.__events_mixin_events[o] || this._notify("register_event", o), this.__events_mixin_events[o] = this.__events_mixin_events[o] || new x();
                    var a = this.__create_event_object(t, i, r);
                    if (this.__events_mixin_events[o].add(a), this.__events_mixin_persistent_events && this.__events_mixin_persistent_events[o]) for (var n = this.__events_mixin_persistent_events[o], s = 0; s < n.length; ++s) this.__call_event_object(a, n[s]);
                    r && r.initcall && this.__call_event_object(a, []);
                  }
                  return this;
                },
                off: function off(e, i, r) {
                  return this.__events_mixin_events = this.__events_mixin_events || {}, e ? (e = e.split(this.EVENT_SPLITTER), a.iter(e, function (e) {
                    this.__events_mixin_events[e] && (this.__events_mixin_events[e].remove_by_filter(function (e) {
                      var t = !(i && e.callback != i || r && e.context != r);
                      return t && this.__destroy_event_object && this.__destroy_event_object(e), t;
                    }), 0 === this.__events_mixin_events[e].count() && (this.__events_mixin_events[e].destroy(), delete this.__events_mixin_events[e], this._notify("unregister_event", e)));
                  }, this)) : a.iter(this.__events_mixin_events, function (e, t) {
                    e.remove_by_filter(function (e) {
                      var t = !(i && e.callback != i || r && e.context != r);
                      return t && this.__destroy_event_object && this.__destroy_event_object(e), t;
                    }), 0 === e.count() && (e.destroy(), delete this.__events_mixin_events[t], this._notify("unregister_event", t));
                  }, this), this;
                },
                once: function once(e, t, i, r) {
                  var o = this,
                    a = n.once(function () {
                      o.off(e, a), t.apply(this, arguments);
                    });
                  return a._callback = t, this.on(e, a, i, r);
                },
                trigger: function trigger(e) {
                  if (0 < this.__suspendedEvents) return this.__suspendedEventsQueue.push(arguments), this;
                  var i = this;
                  e = e.split(this.EVENT_SPLITTER);
                  var r = n.getArguments(arguments, 1);
                  return this.__events_mixin_events && a.iter(e, function (t) {
                    this.__events_mixin_events[t] && this.__events_mixin_events[t].iterate(function (e) {
                      i.__call_event_object(e, r);
                    }), this.__events_mixin_events && "all" in this.__events_mixin_events && this.__events_mixin_events.all.iterate(function (e) {
                      i.__call_event_object(e, [t].concat(r));
                    });
                  }, this), this;
                },
                triggerAsync: function triggerAsync() {
                  var e = this,
                    t = n.getArguments(arguments),
                    i = setTimeout(function () {
                      clearTimeout(i), e.trigger.apply(e, t);
                    }, 0);
                  return this;
                },
                persistentTrigger: function persistentTrigger(e) {
                  var t = n.getArguments(arguments, 1);
                  return this.__events_mixin_persistent_events = this.__events_mixin_persistent_events || [], a.iter(e.split(this.EVENT_SPLITTER), function (e) {
                    this.__events_mixin_persistent_events[e] = this.__events_mixin_persistent_events[e] || [], this.__events_mixin_persistent_events[e].push(t);
                  }, this), this.trigger.apply(this, arguments), this;
                },
                delegateEvents: function delegateEvents(e, i, r, o) {
                  return o = o || [], r = r ? r + ":" : "", null === e ? i.on("all", function (e) {
                    var t = n.getArguments(arguments, 1);
                    this.trigger.apply(this, [r + e].concat(o).concat(t));
                  }, this) : (t.is_array(e) || (e = [e]), a.iter(e, function (t) {
                    i.on(t, function () {
                      var e = n.getArguments(arguments);
                      this.trigger.apply(this, [r + t].concat(o).concat(e));
                    }, this);
                  }, this)), this;
                },
                _eventChain: function _eventChain() {},
                chainedTrigger: function chainedTrigger(e, t) {
                  var i;
                  return t = a.extend({
                    source: this,
                    bubbles: !0
                  }, t), this.trigger(e, t), !t.bubbles || (i = this._eventChain()) && i.chainedTrigger && i.chainedTrigger(e, t), this;
                },
                suspendEvents: function suspendEvents() {
                  return this.__suspendedEvents++, this;
                },
                resumeEvents: function resumeEvents() {
                  return this.__suspendedEvents--, 0 !== this.__suspendedEvents || (a.iter(this.__suspendedEventsQueue, function (e) {
                    this.trigger.apply(this, e);
                  }, this), this.__suspendedEventsQueue = []), this;
                }
              };
            }), h.define("module:Strings", ["module:Objs"], function (n) {
              return {
                format: function format(e) {
                  var i = Array.prototype.slice.call(arguments, 1);
                  return e.replace(/{(\d+)}/g, function (e, t) {
                    return "undefined" != typeof i[t] ? i[t] : e;
                  });
                },
                ucFirst: function ucFirst(e) {
                  return (e += "").charAt(0).toUpperCase() + e.substr(1);
                },
                regexEscape: function regexEscape(e) {
                  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
                },
                asteriskPatternToRegex: function asteriskPatternToRegex(e) {
                  return e.replace(/[-\/\\^$+?.()|[\]{}]/g, "\\$&").replace(/\*/g, ".*");
                },
                padLeft: function padLeft(e, t, i) {
                  for (; e.length < i;) e = t + e;
                  return e;
                },
                padZeros: function padZeros(e, t) {
                  return this.padLeft(e + "", "0", t);
                },
                nl2br: function nl2br(e) {
                  return (e + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1<br />$2");
                },
                htmlentities: function htmlentities(e) {
                  return (e + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
                },
                JS_ESCAPES: {
                  "'": "'",
                  "\\": "\\",
                  "\r": "r",
                  "\n": "n",
                  "\t": "t",
                  "\u2028": "u2028",
                  "\u2029": "u2029"
                },
                JS_ESCAPER_REGEX: function JS_ESCAPER_REGEX() {
                  return this.JS_ESCAPER_REGEX_CACHED || (this.JS_ESCAPER_REGEX_CACHED = new RegExp(n.keys(this.JS_ESCAPES).join("|"), "g")), this.JS_ESCAPER_REGEX_CACHED;
                },
                js_escape: function js_escape(e) {
                  var t = this;
                  return e.replace(this.JS_ESCAPER_REGEX(), function (e) {
                    return "\\" + t.JS_ESCAPES[e];
                  });
                },
                starts_with: function starts_with(e, t) {
                  return e.substring(0, t.length) == t;
                },
                ends_with: function ends_with(e, t) {
                  return -1 !== e.indexOf(t, e.length - t.length);
                },
                strip_start: function strip_start(e, t) {
                  return this.starts_with(e, t) ? e.substring(t.length) : e;
                },
                strip_end: function strip_end(e, t) {
                  return this.ends_with(e, t) ? e.substring(0, e.length - t.length) : e;
                },
                last_after: function last_after(e, t) {
                  return this.splitLast(e, t).tail;
                },
                first_after: function first_after(e, t) {
                  return e.substring(e.indexOf(t) + 1, e.length);
                },
                EMAIL_ADDRESS_REGEX: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                STRICT_URL_REGEX: /^\w+:\/\/[^\s]+$/,
                PERMISSIVE_URL_REGEX: /^[\w\.]+\.(com|de|co\.uk|fr|net|org|edu)[^\s]*$/,
                is_email_address: function is_email_address(e) {
                  return this.EMAIL_ADDRESS_REGEX.test(e);
                },
                STRIP_HTML_TAGS: ["script", "style", "head"],
                STRIP_HTML_REGEX: /<\/?([a-z][a-z0-9]*)\b[^>]*>?/gi,
                STRIP_HTML_COMMENT_REGEX: /<![^>]*>/gi,
                strip_html: function strip_html(e) {
                  for (var t = e, i = 0; i < this.STRIP_HTML_TAGS.length; ++i) t = t.replace(new RegExp("<" + this.STRIP_HTML_TAGS[i] + ".*</" + this.STRIP_HTML_TAGS[i] + ">", "i"), "");
                  return t = t.replace(this.STRIP_HTML_REGEX, "").replace(this.STRIP_HTML_COMMENT_REGEX, "");
                },
                nltrim: function nltrim(e) {
                  for (var t = e.replace(/\t/g, "  ").split("\n"), i = null, r = 0, r = 0; r < t.length; ++r) {
                    for (var o = 0; o < t[r].length && " " == t[r].charAt(o);) ++o;
                    o < t[r].length && (i = null === i ? o : Math.min(o, i));
                  }
                  for (r = 0; r < t.length; ++r) t[r] = t[r].substring(i);
                  return t.join("\n").trim();
                },
                replaceAll: function replaceAll(e, t, i) {
                  for (; 0 <= e.indexOf(t);) e = e.replace(t, i);
                  return e;
                },
                capitalize: function capitalize(e) {
                  return e.replace(/\w\S*/g, function (e) {
                    return e.charAt(0).toUpperCase() + e.substr(1).toLowerCase();
                  });
                },
                pascalCase: function pascalCase(e) {
                  return e.replace(/[A-Z][a-z0-9]/g, function (e) {
                    return " " + e;
                  }).replace(/[A-Za-z0-9]+/g, function (e) {
                    return e.charAt(0).toUpperCase() + e.substr(1).toLowerCase();
                  }).replace(/[-_\s]/g, "");
                },
                camelCase: function camelCase(e) {
                  var t = this.pascalCase(e);
                  return t.charAt(0).toLowerCase() + t.substr(1);
                },
                trainCase: function trainCase(e) {
                  return this.pascalCase(e).replace(/[A-Z]/g, function (e) {
                    return "-" + e;
                  }).substring(1);
                },
                snakeCase: function snakeCase(e) {
                  return this.trainCase(e).replace(/-/g, "_").toLowerCase();
                },
                kebabCase: function kebabCase(e) {
                  return this.trainCase(e).toLowerCase();
                },
                email_get_name: function email_get_name(e) {
                  var t = (e = e || "").split("<");
                  return (!(e = t[0].trim()) || t.length < 2) && (e = (t = t[t.length - 1].split("@"))[0].trim()), e = e.replace(/['"]/g, "").replace(/[\\._@]/g, " "), this.capitalize(e);
                },
                email_get_email: function email_get_email(e) {
                  var t = (e = e || "").split("<");
                  return e = t[0].trim(), 1 < t.length && (e = (t = t[1].split(">"))[0].trim()), e = e.replace(/'/g, "").replace(/"/g, "").trim();
                },
                email_get_salutatory_name: function email_get_salutatory_name(e) {
                  return this.email_get_name(e || "").split(" ")[0];
                },
                splitFirst: function splitFirst(e, t) {
                  var i = e.indexOf(t);
                  return {
                    head: 0 <= i ? e.substring(0, i) : e,
                    tail: 0 <= i ? e.substring(i + t.length) : ""
                  };
                },
                splitLast: function splitLast(e, t) {
                  var i = e.lastIndexOf(t);
                  return {
                    head: 0 <= i ? e.substring(0, i) : "",
                    tail: 0 <= i ? e.substring(i + t.length) : e
                  };
                },
                regexReplaceGroups: function regexReplaceGroups(e, t) {
                  for (var i = /\(.*?\)/, r = function r(e) {
                      return o || e.substring(1, e.length - 1);
                    }; 0 < t.length;) {
                    var o = t.shift();
                    e = e.replace(i, r);
                  }
                  return e;
                },
                namedCaptureRegex: function namedCaptureRegex(e) {
                  var o = {},
                    a = 0,
                    i = new RegExp(e.replace(/\([^)]+\)/gi, function (e) {
                      var t;
                      return "?" != e.charAt(1) && 0 < e.indexOf(":") && (t = e.indexOf(":"), o[e.substring(1, t)] = a, e = "(" + e.substring(t + 1, e.length - 1) + ")"), a++, e;
                    })),
                    r = function r(t) {
                      return n.map(o, function (e) {
                        return t[e + 1];
                      });
                    };
                  return {
                    regex: i,
                    map: r,
                    exec: function exec(e) {
                      var t = i.exec(e);
                      return t ? r(t) : null;
                    },
                    mapBack: function mapBack(e) {
                      for (var t = [], i = 0; i < a; ++i) t.push(null);
                      for (var r in e) r in o && (t[o[r]] = e[r]);
                      return t;
                    }
                  };
                },
                ordinalSuffix: function ordinalSuffix(e) {
                  var t = e % 10,
                    i = e % 100;
                  return 1 == t && 11 != i ? e + "st" : 2 == t && 12 != i ? e + "nd" : 3 == t && 13 != i ? e + "rd" : e + "th";
                },
                __cachedRegExp: {},
                cachedRegExp: function cachedRegExp(e, t) {
                  return t = t || "", this.__cachedRegExp[e] || (this.__cachedRegExp[e] = {}), this.__cachedRegExp[e][t] || (this.__cachedRegExp[e][t] = new RegExp(e, t)), this.__cachedRegExp[e][t];
                },
                IP_ADDRESS_REGEXP: /^\d+\.\d+\.\d+\.\d+$/,
                isIPAddress: function isIPAddress(e) {
                  return this.IP_ADDRESS_REGEXP.test(e);
                },
                NORMALIZE_SEARCH_TEXT_MAPS: {
                  "\\u00dc": "Ue",
                  "\\u00fc": "ue",
                  "\\u00c4": "Ae",
                  "\\u00e4": "ae",
                  "\\u00d6": "Oe",
                  "\\u00f6": "oe",
                  "\\u00df": "ss",
                  "\\W": " ",
                  "\\s+": " "
                },
                NORMALIZE_SEARCH_TEXT_MAPS_REGEX: function NORMALIZE_SEARCH_TEXT_MAPS_REGEX() {
                  return this.NORMALIZE_SEARCH_TEXT_MAPS_CACHED || (this.NORMALIZE_SEARCH_TEXT_MAPS_CACHED = [], n.iter(this.NORMALIZE_SEARCH_TEXT_MAPS, function (e, t) {
                    this.NORMALIZE_SEARCH_TEXT_MAPS_CACHED.push({
                      search: new RegExp(t, "g"),
                      replace: e
                    });
                  }, this)), this.NORMALIZE_SEARCH_TEXT_MAPS_CACHED;
                },
                normalizeSearchText: function normalizeSearchText(t) {
                  return n.iter(this.NORMALIZE_SEARCH_TEXT_MAPS_REGEX(), function (e) {
                    t = t.replace(e.search, e.replace);
                  }), t.trim();
                }
              };
            }), h.define("module:Classes.ConditionalInstance", ["module:Class", "module:Objs"], function (e, r, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this._options = this.cls._initializeOptions(e);
                  }
                };
              }, {
                _initializeOptions: function _initializeOptions(e) {
                  return e;
                },
                supported: function supported(e) {
                  return !1;
                }
              }, {
                __registry: [],
                register: function register(e, t) {
                  this.__registry.push({
                    cls: e,
                    priority: t
                  });
                },
                match: function match(t) {
                  t = this._initializeOptions(t);
                  var i = null;
                  return r.iter(this.__registry, function (e) {
                    (!i || i.priority < e.priority) && e.cls.supported(t) && (i = e);
                  }, this), i;
                },
                create: function create(e) {
                  var t = this.match(e);
                  return t ? new t.cls(e) : null;
                },
                anySupport: function anySupport(e) {
                  return null !== this.match(e);
                }
              });
            }), h.define("module:Properties.ObservableMixin", [], function () {
              return {
                __observable_guid: "48994ac3-7e0b-4ed5-8995-f146215dc795",
                get: function get(e) {},
                hasKey: function hasKey(e) {}
              };
            }), h.define("module:Objs.Scopes", ["module:Types"], function (a) {
              return {
                has: function has(e, t) {
                  for (var i = e ? e.split(".") : [], r = 0; r < i.length; ++r) {
                    if (!t || !a.is_object(t)) return !1;
                    t = t[i[r]];
                  }
                  return a.is_defined(t);
                },
                get: function get(e, t) {
                  for (var i = e ? e.split(".") : [], r = 0; r < i.length; ++r) {
                    if (!t || !a.is_object(t)) return null;
                    t = t[i[r]];
                  }
                  return t;
                },
                set: function set(e, t, i) {
                  if (e) {
                    for (var r = e.split("."), o = 0; o < r.length - 1; ++o) r[o] in i && a.is_object(i[r[o]]) || (i[r[o]] = {}), i = i[r[o]];
                    i[r[r.length - 1]] = t;
                  }
                },
                unset: function unset(e, t) {
                  if (e) {
                    for (var i = e.split("."), r = 0; r < i.length - 1; ++r) {
                      if (!t || !a.is_object(t)) return;
                      t = t[i[r]];
                    }
                    delete t[i[i.length - 1]];
                  }
                },
                touch: function touch(e, t) {
                  if (!e) return t;
                  for (var i = e.split("."), r = 0; r < i.length; ++r) i[r] in t && a.is_object(t) || (t[i[r]] = {}), t = t[i[r]];
                  return t[i[i.length - 1]];
                }
              };
            }), h.define("module:Properties.PropertiesMixin", ["module:Objs.Scopes", "module:Objs", "module:Strings", "module:Types", "module:Functions"], function (o, d, l, u, x) {
              return {
                __properties_guid: "ec816b66-7284-43b1-a945-0600c6abfde3",
                _notifications: {
                  construct: function construct() {
                    this.__properties = {
                      data: {},
                      watchers: {
                        children: {},
                        eventCount: 0,
                        parent: null,
                        key: null
                      },
                      computed: {},
                      bindings: {}
                    }, d.iter(this.materializes, function (e) {
                      this.materializeAttr(e);
                    }, this);
                  },
                  destroy: function destroy() {
                    d.iter(this.__properties.bindings, function (e, t) {
                      this.unbind(t);
                    }, this), d.iter(this.__properties.computed, function (e, t) {
                      this.uncompute(t);
                    }, this), this.trigger("destroy");
                  },
                  register_event: function register_event(t) {
                    d.iter(["change", "unset", "deepchange", "deepunset", "strongdeepchange", "strongchange"], function (e) {
                      l.starts_with(t, e + ":") && this.__registerWatcher(l.strip_start(t, e + ":"), e);
                    }, this);
                  },
                  unregister_event: function unregister_event(t) {
                    d.iter(["change", "unset", "deepchange", "deepunset", "strongdeepchange", "strongchange"], function (e) {
                      l.starts_with(t, e + ":") && this.__unregisterWatcher(l.strip_start(t, e + ":"), e);
                    }, this);
                  }
                },
                __registerWatcher: function __registerWatcher(e, t) {
                  for (var i = e ? e.split(".") : [], r = this.__properties.watchers, o = 0; o < i.length; ++o) i[o] in r.children || (r.children[i[o]] = {
                    parent: r,
                    eventCount: 0,
                    children: {},
                    key: i[o]
                  }), r = r.children[i[o]];
                  r.eventCount++;
                },
                __unregisterWatcher: function __unregisterWatcher(e, t) {
                  for (var i = e ? e.split(".") : [], r = this.__properties.watchers, o = 0; o < i.length; ++o) r = r && r.children[i[o]];
                  if (r) for (r.eventCount--; r.eventCount <= 0 && u.is_empty(r.children) && r.parent;) {
                    var a = r.parent;
                    delete a.children[r.key], r = a;
                  }
                },
                __unsetChanged: function __unsetChanged(e, t) {
                  this.trigger("unset", e, t);
                  for (var i = e ? e.split(".") : [], r = this.__properties.watchers, o = "", a = e, n = 0; n < i.length; ++n) {
                    if (0 < r.eventCount && this.trigger("deepunset:" + o, t, a), !(i[n] in r.children)) return this;
                    r = r.children[i[n]], o = o ? o + "." + i[n] : i[n], a = l.first_after(a, ".");
                  }
                  function s(e, i, r) {
                    u.is_undefined(r) || (0 < e.eventCount && this.trigger("unset:" + i, r), d.iter(e.children, function (e, t) {
                      s.call(this, e, i ? i + "." + t : t, r[t]);
                    }, this));
                  }
                  return s.call(this, r, e, t), this;
                },
                __setChanged: function __setChanged(e, t, i, a) {
                  if (this.trigger("change", e, t, i), this._afterSet(e, t), !this.destroyed()) {
                    for (var r = e ? e.split(".") : [], o = this.__properties.watchers, n = "", s = e, x = 0; x < r.length; ++x) {
                      if (0 < o.eventCount && (a || this.trigger("strongdeepchange:" + n, t, i, s), this.trigger("deepchange:" + n, t, i, s)), !(r[x] in o.children)) return;
                      o = o.children[r[x]], n = n ? n + "." + r[x] : r[x], s = l.first_after(s, ".");
                    }
                    c.call(this, o, e, t, i);
                  }
                  function c(e, i, r, o) {
                    r != o && (0 < e.eventCount && (a || this.trigger("strongchange:" + i, r, o), this.trigger("change:" + i, r, o)), d.iter(e.children, function (e, t) {
                      c.call(this, e, i ? i + "." + t : t, u.is_object(r) && r ? r[t] : null, u.is_object(o) && o ? o[t] : null);
                    }, this));
                  }
                },
                materializes: [],
                _resolveProps: function _resolveProps(e) {
                  for (var t = {
                      props: this,
                      key: e
                    }, i = this.data(); e;) {
                    if (!i || !u.is_object(i)) return t;
                    if (i.__properties_guid === this.__properties_guid) return i._resolveProps(e);
                    var r = l.splitFirst(e, ".");
                    if (!(r.head in i)) return t;
                    e = r.tail, i = i[r.head];
                  }
                  return t;
                },
                _canSet: function _canSet(e, t) {
                  return !0;
                },
                _beforeSet: function _beforeSet(e, t, i) {
                  return t;
                },
                _afterSet: function _afterSet(e, t) {},
                getProp: function getProp(e) {
                  var t = this._resolveProps(e);
                  return t.props.get(t.key);
                },
                setProp: function setProp(e, t) {
                  var i = this._resolveProps(e);
                  return i.props.set(i.key, t), this;
                },
                uncomputeProp: function uncomputeProp(e) {
                  var t = this._resolveProps(e);
                  return t.props.uncompute(t.key);
                },
                computeProp: function computeProp(e, t) {
                  var i = this._resolveProps(e),
                    r = x.getArguments(arguments);
                  return r[0] = i.key, i.props.compute.apply(i.props.compute, r);
                },
                get: function get(e) {
                  return o.get(e, this.__properties.data);
                },
                has: function has(e) {
                  return o.has(e, this.__properties.data);
                },
                hasKey: function hasKey(e) {
                  return this.has(e);
                },
                setAll: function setAll(e) {
                  for (var t in e) this.set(t, e[t]);
                  return this;
                },
                keys: function keys(e) {
                  return d.keys(this.__properties.data, e);
                },
                data: function data() {
                  return this.__properties.data;
                },
                getAll: function getAll() {
                  return d.clone(this.__properties.data, 1);
                },
                clone: function clone() {
                  return new this.cls(this.getAll());
                },
                iterate: function iterate(e, t) {
                  return d.iter(this.getAll(), e, t), this;
                },
                materializeAttr: function materializeAttr(t) {
                  return this[t] = function (e) {
                    if (0 === arguments.length) return this.get(t);
                    this.set(t, e);
                  }, this;
                },
                uncompute: function uncompute(e) {
                  return e in this.__properties.computed && (d.iter(this.__properties.computed[e].dependencies, function (e) {
                    e.properties.off("change:" + e.key, null, e), e.value && !e.value.destroyed() && e.value.off("change update", null, e);
                  }, this), delete this.__properties.computed[e]), this;
                },
                bicompute: function bicompute(t, i, r, o) {
                  r.call(this);
                  var a = !1;
                  return [[t, r], [i, o]].forEach(function (i) {
                    i[0].forEach(function (t) {
                      this.on("change:" + t, function () {
                        if (!a) try {
                          a = !0, i[1].call(this), a = !1;
                        } catch (e) {
                          throw a = !1, e;
                        }
                      }, this);
                    }, this);
                  }, this), this;
                },
                compute: function compute(t, i) {
                  var r = x.matchArgs(arguments, 2, {
                    setter: "function",
                    context: {
                      type: "object",
                      def: this
                    },
                    dependencies: !0
                  });
                  this.uncompute(t);
                  var o = [];
                  d.iter(r.dependencies, function (e) {
                    u.is_string(e) ? o.push({
                      properties: this,
                      key: e
                    }) : o.push({
                      properties: e[0],
                      key: e[1]
                    });
                  }, this);
                  var a = {
                    ignore: 0,
                    func: i,
                    context: r.context,
                    setter: r.setter,
                    dependencies: o
                  };
                  this.__properties.computed[t] = a;
                  var n = this;
                  function s() {
                    var e;
                    0 < a.ignore || (e = d.map(o, function (e) {
                      return e.properties.get(e.key);
                    }), n.set(t, i.apply(r.context, e)));
                  }
                  return d.iter(o, function (i) {
                    var e = i.properties.get(i.key);
                    e && "object" == typeof e && "on" in e && "off" in e && "trigger" in e && (i.value = e).on("change update", function () {
                      s();
                    }, i), i.properties.on("change:" + i.key, function (e, t) {
                      i.value = null, t && "object" == typeof t && "on" in t && "off" in t && "trigger" in t && t.off("change update", null, i), e && "object" == typeof e && "on" in e && "off" in e && "trigger" in e && (i.value = e).on("change update", function () {
                        s();
                      }, i), s();
                    }, i);
                  }, this), s(), this;
                },
                unbind: function unbind(e, t) {
                  if (e in this.__properties.bindings) {
                    for (var i = this.__properties.bindings[e].length - 1; 0 <= i; --i) {
                      var r = this.__properties.bindings[e][i];
                      t && t != r || (r.left && r.properties.off(null, null, r), r.right && this.off(null, null, r), this.__properties.bindings[e].splice(i, 1), i--);
                    }
                    0 === this.__properties.bindings[e].length && delete this.__properties.bindings[e];
                  }
                  return this;
                },
                bind: function bind(r, e, t) {
                  var o = {
                    key: (t = d.extend({
                      secondKey: r,
                      left: !0,
                      right: !0,
                      deep: !1
                    }, t)).secondKey,
                    left: t.left,
                    right: t.right,
                    deep: t.deep,
                    properties: e
                  };
                  this.__properties.bindings[r] = this.__properties.bindings[r] || [], this.__properties.bindings[r].push(o);
                  var a = this;
                  return o.left && (o.properties.on("strongchange:" + o.key, function (e) {
                    a.set(r, e);
                  }, o), o.properties.on("unset:" + o.key, function (e) {
                    a.unset(r);
                  }, o), o.deep && (o.properties.on("strongdeepchange:" + o.key, function (e, t, i) {
                    a.get(r ? r + "." + i : i) === e ? a.__setChanged(r ? r + "." + i : i, e, t, !0) : a.set(r ? r + "." + i : i, e);
                  }, o), o.properties.on("deepunset:" + o.key, function (e, t) {
                    a.has(r ? r + "." + t : t) ? a.unset(r ? r + "." + t : t) : a.__unsetChanged(r ? r + "." + t : t, e);
                  }, o)), o.right && this.has(r) || this.set(r, o.properties.get(o.key)), "" === r && d.iter(o.properties.data(), function (e, t) {
                    this.set(t, e);
                  }, this)), o.right && (this.on("strongchange:" + r, function (e) {
                    o.properties.set(o.key, e);
                  }, o), this.on("unset:" + r, function (e) {
                    o.properties.unset(o.key);
                  }, o), o.deep && (this.on("strongdeepchange:" + r, function (e, t, i) {
                    o.properties.get(o.key ? o.key + "." + i : i) === e ? o.properties.__setChanged(o.key ? o.key + "." + i : i, e, t, !0) : o.properties.set(o.key ? o.key + "." + i : i, e);
                  }, o), this.on("deepunset:" + r, function (e, t) {
                    o.properties.has(o.key ? o.key + "." + t : t) ? o.properties.unset(o.key ? o.key + "." + t : t) : o.properties.__unsetChanged(o.key ? o.key + "." + t : t, e);
                  }, o)), o.left && !this.has(r) || o.properties.set(o.key, this.get(r)), "" === r && d.iter(this.data(), function (e, t) {
                    o.properties.set(t, e);
                  }, this)), o.properties.on("destroy", function () {
                    a.destroyed() || a.unbind(r);
                  }, o), this;
                },
                unset: function unset(e) {
                  var t;
                  return this.has(e) && (t = this.get(e), o.unset(e, this.__properties.data), this.__unsetChanged(e, t)), this;
                },
                set: function set(e, t, i) {
                  if (u.is_object(t) && t && t.guid == this.__properties_guid) return t.properties && this.bind(e, t.properties, {
                    secondKey: t.key
                  }), t.func && this.compute(e, t.func, t.dependencies), this;
                  var r = this.get(e);
                  return r !== (t = this._beforeSet(e, t, r)) ? (o.set(e, t, this.__properties.data), this.__setChanged(e, t, r)) : i && (this.trigger("change", e, t, r, !0), this.trigger("change:" + e, t, r, !0)), this;
                },
                binding: function binding(e) {
                  return {
                    guid: this.__properties_guid,
                    properties: this,
                    key: e
                  };
                },
                computed: function computed(e, t) {
                  return {
                    guid: this.__properties_guid,
                    func: e,
                    dependencies: t
                  };
                },
                pid: function pid() {
                  return this.cid();
                },
                isSubsetOf: function isSubsetOf(e) {
                  return d.subset_of(this.data(), e.data ? e.data() : e);
                },
                isSupersetOf: function isSupersetOf(e) {
                  return d.superset_of(this.data(), e.data ? e.data() : e);
                },
                getProxy: function getProxy() {
                  var r = this;
                  return new Proxy(this.__properties.data, {
                    get: function get(e, t, i) {
                      return r.get(t);
                    },
                    set: function set(e, t, i) {
                      r.set(t, i);
                    }
                  });
                }
              };
            }), h.define("module:Properties.Properties", ["module:Class", "module:Objs", "module:Events.EventsMixin", "module:Properties.ObservableMixin", "module:Properties.PropertiesMixin"], function (e, r, t, i, o, a) {
              return e.extend({
                scoped: a
              }, [t, i, o, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    i.constructor.call(this), e && this.setAll(e), t && r.iter(t, function (e) {
                      this.materializeAttr(e);
                    }, this);
                  }
                };
              }]);
            }), h.define("module:Comparators", ["module:Types", "module:Properties.Properties"], function (a, n) {
              return {
                byObject: function byObject(o) {
                  var a = this;
                  return function (e, t) {
                    for (var i in o) {
                      var r = 0;
                      if (0 !== (r = n.is_class_instance(e) && n.is_class_instance(t) ? a.byValue(e.get(i) || null, t.get(i) || null) : a.byValue(e[i] || null, t[i] || null))) return r * o[i];
                    }
                    return 0;
                  };
                },
                byValue: function byValue(e, t) {
                  return a.is_string(e) ? e.localeCompare(t) : e < t ? -1 : t < e ? 1 : 0;
                },
                deepEqual: function deepEqual(e, t, i) {
                  if (0 === i) return !0;
                  if (1 === i) return e === t;
                  if (a.is_array(e) && a.is_array(t)) {
                    if (e.length !== t.length) return !1;
                    for (var r = 0; r < e.length; ++r) if (!this.deepEqual(e[r], t[r], i - 1)) return !1;
                    return !0;
                  }
                  if (a.is_object(e) && a.is_object(t)) {
                    if (!e || !t) return e === t;
                    for (var o in e) if (!this.deepEqual(e[o], t[o], i - 1)) return !1;
                    for (o in t) if (!(o in e)) return !1;
                    return !0;
                  }
                  return e === t;
                },
                listEqual: function listEqual(e, t) {
                  return this.deepEqual(e, t, 2);
                }
              };
            }), h.define("module:Exceptions.Exception", ["module:Class", "module:Comparators"], function (t, r, i) {
              return t.extend({
                scoped: i
              }, function (i) {
                return {
                  constructor: function constructor(t) {
                    i.constructor.call(this), this.__message = t;
                    try {
                      throw new Error();
                    } catch (e) {
                      this.__stack = e.stack;
                    }
                  },
                  assert: function assert(e) {
                    if (!this.instance_of(e)) throw this;
                    return this;
                  },
                  message: function message() {
                    return this.__message;
                  },
                  stack: function stack() {
                    return this.__stack;
                  },
                  toString: function toString() {
                    return this.message();
                  },
                  format: function format() {
                    return this.cls.classname + ": " + this.toString();
                  },
                  json: function json() {
                    return {
                      classname: this.cls.classname,
                      message: this.message(),
                      stack: this.stack()
                    };
                  },
                  equals: function equals(e) {
                    return e && this.cls === e.cls && r.deepEqual(this.json(), e.json(), -1);
                  }
                };
              }, {
                ensure: function ensure(e) {
                  if (!this.is_instance_of(e)) throw "Unasserted Exception " + e;
                  return e;
                }
              });
            }), h.define("module:Ajax.AjaxException", ["module:Exceptions.Exception"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  status_code: function status_code() {
                    return 500;
                  }
                };
              });
            }), h.define("module:Ajax.NoCandidateAjaxException", ["module:Ajax.AjaxException"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {};
              });
            }), h.define("module:Ajax.ReturnDataParseException", ["module:Ajax.AjaxException"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    i.constructor.call(this, "Could not decode data with type " + t), this.__decodeType = t, this.__data = e;
                  }
                };
              });
            }), h.define("module:Ajax.RequestException", ["module:Ajax.AjaxException", "module:Objs"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, function (r) {
                return {
                  constructor: function constructor(e, t, i) {
                    r.constructor.call(this, e + ": " + t), this.__status_code = e, this.__status_text = t, this.__data = i;
                  },
                  status_code: function status_code() {
                    return this.__status_code;
                  },
                  status_text: function status_text() {
                    return this.__status_text;
                  },
                  data: function data() {
                    return this.__data;
                  },
                  json: function json() {
                    return t.extend({
                      data: this.data(),
                      status_code: this.status_code(),
                      status_text: this.status_text()
                    }, r.json.call(this));
                  }
                };
              });
            }), h.define("module:Ajax.TimeoutException", ["module:Ajax.AjaxException"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {};
              });
            }), h.define("module:Sort", ["module:Comparators", "module:Types", "module:Objs"], function (o, b, m) {
              return {
                sort_object: function sort_object(e, i) {
                  var t = [];
                  for (var r in e) t.push({
                    key: r,
                    value: e[r]
                  });
                  t.sort(function (e, t) {
                    return i(e.key, t.key, e.value, t.value);
                  });
                  for (var o = {}, a = 0; a < t.length; ++a) o[t[a].key] = t[a].value;
                  return o;
                },
                deep_sort: function deep_sort(e, t) {
                  if (t = t || o.byValue, b.is_array(e)) {
                    for (var i = 0; i < e.length; ++i) e[i] = this.deep_sort(e[i], t);
                    return e.sort(t);
                  }
                  if (b.is_object(e)) {
                    for (var r in e) e[r] = this.deep_sort(e[r], t);
                    return this.sort_object(e, t);
                  }
                  return e;
                },
                dependency_sort: function dependency_sort(e, t, i, r) {
                  for (var o = b.is_string(t) ? function (e) {
                      return e[t];
                    } : t, a = b.is_string(i) ? function (e) {
                      return e[i];
                    } : i, n = b.is_string(r) ? function (e) {
                      return e[r];
                    } : r, s = e.length, x = [], c = {}, d = {}, l = 0, l = 0; l < s; ++l) {
                    d[l] = !0;
                    var u = o(e[l], l);
                    c[u] = l, x.push({
                      before: {},
                      after: {}
                    });
                  }
                  for (l = 0; l < s; ++l) m.iter(a(e[l], l) || [], function (i) {
                    return function (e) {
                      var t = c[e];
                      b.is_defined(t) && (x[i].before[t] = !0, x[t].after[i] = !0);
                    };
                  }(l)), m.iter(n(e[l]) || [], function (i) {
                    return function (e) {
                      var t = c[e];
                      b.is_defined(t) && (x[i].after[t] = !0, x[t].before[i] = !0);
                    };
                  }(l));
                  for (var h = []; !b.is_empty(d);) for (l in d) if (b.is_empty(x[l].after)) for (var p in delete d[l], h.push(e[l]), x[l].before) delete x[p].after[l];
                  return h;
                }
              };
            }), h.define("module:Net.Uri", ["module:Objs", "module:Types", "module:Strings", "module:Sort"], function (o, a, r, i) {
              var n = /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
                s = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
                x = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
                c = /(?:^|&)([^&=]*)=?([^&]*)/g;
              return {
                build: function build(e) {
                  var t = "";
                  return e.protocol && (t += e.protocol + "://"), e.username && (t += e.username + ":"), e.password && (t += e.password + "@"), t += e.server, e.port && (t += ":" + e.port), e.path && (t += "/" + e.path), t;
                },
                encodeUriParams: function encodeUriParams(e, i, t) {
                  i = i || "";
                  var r = [];
                  return t ? o.iter(o.serializeFlatJSON(e), function (e) {
                    r.push(i + e.key + "=" + encodeURIComponent(e.value));
                  }, this) : o.iter(e, function (e, t) {
                    a.is_object(e) ? r = r.concat(this.encodeUriParams(e, i + t + "_")) : r.push(i + t + "=" + encodeURIComponent(e));
                  }, this), r.join("&");
                },
                decodeUriParams: function decodeUriParams(e) {
                  var i = {};
                  return e.split("&").forEach(function (e) {
                    var t = r.splitFirst(e, "=");
                    i[t.head] = decodeURIComponent(t.tail);
                  }), i;
                },
                appendUriParams: function appendUriParams(e, t, i) {
                  return a.is_empty(t) ? e : e + (-1 != e.indexOf("?") ? "&" : "?") + this.encodeUriParams(t, i);
                },
                parse: function parse(e, t) {
                  for (var i = (t ? n : s).exec(e), r = {}, o = 0; o < x.length; ++o) r[x[o]] = i[o] || "";
                  return r.queryKey = {}, r[x[12]].replace(c, function (e, t, i) {
                    t && (r.queryKey[t] = i);
                  }), r;
                },
                isCrossDomainUri: function isCrossDomainUri(e, t) {
                  return !(t.indexOf("//") < 0) && (e.indexOf("//") < 0 || (e = this.parse(e.toLowerCase()), t = this.parse(t.toLowerCase()), "file" === e.protocol || "file" === t.protocol ? e.protocol === t.protocol : e.host !== t.host || e.port !== t.port));
                },
                normalizeUri: function normalizeUri(e) {
                  var t = e.indexOf("?");
                  return 0 <= t ? e.substring(0, t) + "?" + this.encodeUriParams(i.sort_object(this.decodeUriParams(e.substring(t + 1)), function (e, t) {
                    return e.localeCompare(t);
                  })) : e;
                }
              };
            }), h.define("module:Net.HttpHeader", function () {
              return {
                HTTP_STATUS_OK: 200,
                HTTP_STATUS_CREATED: 201,
                HTTP_STATUS_BAD_REQUEST: 400,
                HTTP_STATUS_UNAUTHORIZED: 401,
                HTTP_STATUS_PAYMENT_REQUIRED: 402,
                HTTP_STATUS_FORBIDDEN: 403,
                HTTP_STATUS_NOT_FOUND: 404,
                HTTP_STATUS_PRECONDITION_FAILED: 412,
                HTTP_STATUS_INTERNAL_SERVER_ERROR: 500,
                HTTP_STATUS_GATEWAY_TIMEOUT: 504,
                STRINGS: {
                  0: "Unknown Error",
                  200: "OK",
                  201: "Created",
                  400: "Bad Request",
                  401: "Unauthorized",
                  402: "Payment Required",
                  403: "Forbidden",
                  404: "Not found",
                  412: "Precondition Failed",
                  500: "Internal Server Error",
                  504: "Gateway timeout"
                },
                format: function format(e, t) {
                  var i = this.STRINGS[e in this.STRINGS ? e : 0];
                  return t ? e + " " + i : i;
                },
                isSuccessStatus: function isSuccessStatus(e) {
                  return e >= this.HTTP_STATUS_OK && e < 300;
                }
              };
            }), h.define("module:Ajax.Support", ["module:Ajax.NoCandidateAjaxException", "module:Ajax.ReturnDataParseException", "module:Ajax.RequestException", "module:Ajax.TimeoutException", "module:Promise", "module:Objs", "module:Types", "module:Net.Uri", "module:Net.HttpHeader", "module:Async", "module:Time"], function (c, a, d, t, l, i, r, o, n, u, s) {
              return {
                __registry: [],
                register: function register(e, t) {
                  this.__registry.push({
                    descriptor: e,
                    priority: t
                  });
                },
                unwrapStatus: function unwrapStatus(t, i) {
                  var r = t.status || n.HTTP_STATUS_INTERNAL_SERVER_ERROR;
                  if (n.isSuccessStatus(r)) return t.responseText;
                  var o = t.statusText || n.format(r),
                    a = t.responseText;
                  try {
                    a = this.parseReturnData(t.responseText, i);
                  } catch (e) {}
                  throw new d(r, o, a);
                },
                parseReturnData: function parseReturnData(e, t) {
                  return "json" === t && r.is_string(e) ? JSON.parse(e) : e;
                },
                promiseReturnData: function promiseReturnData(t, i, r, o) {
                  if (i.wrapStatus) {
                    try {
                      r = this.parseReturnData(r, "json");
                    } catch (e) {
                      return void t.asyncError(new a(r, o));
                    }
                    try {
                      r = this.unwrapStatus(r, o);
                    } catch (e) {
                      return void t.asyncError(e);
                    }
                  }
                  try {
                    t.asyncSuccess(this.parseReturnData(r, o));
                  } catch (e) {
                    t.asyncError(new a(r, o));
                  }
                },
                promiseRequestException: function promiseRequestException(t, i, r, o, a) {
                  r = r || n.format(i);
                  try {
                    t.asyncError(new d(i, r, this.parseReturnData(o, a)));
                  } catch (e) {
                    t.asyncError(new d(i, r, o));
                  }
                },
                promiseTimeoutException: function promiseTimeoutException(e) {
                  e.asyncError(new t(status, status_text, data));
                },
                preprocess: function preprocess(e) {
                  return (e = i.extend({
                    method: "GET",
                    mapMethodsKey: "_method",
                    wrapStatus: !1,
                    wrapStatusParam: null,
                    context: this,
                    query: {},
                    jsonp: undefined,
                    noCache: undefined,
                    noCacheParam: null,
                    signingFunction: null,
                    signUrl: !1,
                    postmessage: undefined,
                    contentType: "urlencoded",
                    resilience: 1,
                    resilience_filter: null,
                    resilience_delay: 1e3,
                    resilience_min_status: null,
                    cors: !1,
                    sendContentType: !0,
                    corscreds: !1,
                    forceJsonp: !1,
                    forcePostmessage: !1
                  }, e)).params && (e.query = i.extend(e.query, e.params), delete e.params), r.is_empty(e.query) || (e.query = i.filter(e.query, function (e) {
                    return null !== e && e !== undefined;
                  })), e.method = e.method.toUpperCase(), e.methodSupportsPayload = "POST" === e.method || "PATCH" === e.method || "PUT" === e.method, e.baseUri && (e.uri = e.uri ? e.baseUri + e.uri : e.baseUri), delete e.baseUri, e.mapMethods && e.method in e.mapMethods && (e.uri = o.appendUriParams(e.uri, i.objectBy(e.mapMethodsKey, e.method)), e.method = e.mapMethods[e.method]), e.wrapStatus && e.wrapStatusParam && (e.uri = o.appendUriParams(e.uri, i.objectBy(e.wrapStatusParam, "true"))), e.noCache && e.noCacheParam && (e.uri = o.appendUriParams(e.uri, i.objectBy(e.noCacheParam, s.now()))), delete e.mapMethods, delete e.mapMethodsKey, "urlencoded" !== e.contentType || r.is_empty(e.data) || (e.data = i.filter(e.data, function (e) {
                    return null !== e && e !== undefined;
                  })), e.isCorsRequest = "undefined" != typeof document && o.isCrossDomainUri(document.location.href, e.uri), e;
                },
                finalizeUri: function finalizeUri(e, t) {
                  return e.signUrl && e.signingFunction ? e.signingFunction(e, t) : t;
                },
                create: function create(t) {
                  t = t || {};
                  var i = null;
                  return this.__registry.forEach(function (e) {
                    (!i || i.priority < e.priority) && e.descriptor.supports.call(e.descriptor.context || e.descriptor, t) && (i = e);
                  }, this), i ? i.descriptor.create(t) : l.error(new c());
                },
                execute: function execute(r, o, a, n) {
                  r = this.preprocess(r);
                  var s = null;
                  if (this.__registry.forEach(function (e) {
                    (!s || s.priority < e.priority) && e.descriptor.supports.call(e.descriptor.context || e.descriptor, r) && (s = e);
                  }, this), !s) return l.error(new c(r));
                  var x = function x(t) {
                    var e = s.descriptor.execute.call(s.descriptor.context || s.descriptor, r, o, a, n);
                    if (!t || t <= 1) return e;
                    var i = l.create();
                    return e.forwardSuccess(i).error(function (e) {
                      if (d.is_class_instance(e)) {
                        if (r.resilience_filter && r.resilience_filter(e)) return void i.asyncError(e);
                        if (r.resilience_min_status && e.status_code() < r.resilience_min_status) return void i.asyncError(e);
                      }
                      u.eventually(function () {
                        x(t - 1).forwardCallback(i);
                      }, r.resilience_delay);
                    }), i;
                  };
                  return x(r.resilience);
                }
              };
            }), h.define("module:Tokens", function () {
              return {
                generate_token: function generate_token(e) {
                  void 0 === e && (e = 16);
                  for (var t = ""; t.length < e;) t += Math.random().toString(36).substr(2);
                  return t.substr(0, e);
                },
                simple_hash: function simple_hash(e) {
                  if (0 == e.length) return 0;
                  for (var t = 0, i = 0; i < e.length; ++i) t = (t << 5) - t + e.charCodeAt(i), t &= t;
                  return Math.abs(t);
                }
              };
            }), h.define("module:Scheduling.Helper", [], function () {
              return {
                schedulable: function schedulable(e, t, i, r) {
                  i ? i.schedulable(r || this, e, t) : e.call(r || this, Infinity);
                }
              };
            }), h.define("module:Events.ListenMixin", ["module:Ids", "module:Objs", "module:Types"], function (o, r, a) {
              return {
                _notifications: {
                  destroy: "listenOff"
                },
                listenOn: function listenOn(e, t, i, r) {
                  return this.__listen_mixin_listen || (this.__listen_mixin_listen = {}), a.is_array(e) || (e = [e]), e.forEach(function (e) {
                    (this.__listen_mixin_listen[o.objectId(e)] = e).on(t, i, this, r);
                  }, this), this;
                },
                listenOnce: function listenOnce(e, t, i, r) {
                  return this.__listen_mixin_listen || (this.__listen_mixin_listen = {}), a.is_array(e) || (e = [e]), e.forEach(function (e) {
                    (this.__listen_mixin_listen[o.objectId(e)] = e).once(t, i, this, r);
                  }, this), this;
                },
                listenOff: function listenOff(e, t, i) {
                  return this.__listen_mixin_listen && (a.is_array(e) || (e = [e]), e.forEach(function (e) {
                    e && !e.destroyed() ? (e.off(t, i, this), t || i || delete this.__listen_mixin_listen[o.objectId(e)]) : r.iter(this.__listen_mixin_listen, function (e) {
                      e && "off" in e && !e.destroyed() && e.off(t, i, this), t || i || delete this.__listen_mixin_listen[o.objectId(e)];
                    }, this);
                  }, this)), this;
                }
              };
            }), h.define("module:Classes.Taggable", ["module:Objs"], function (t) {
              return {
                hasTag: function hasTag(e) {
                  return this.__tags && e in this.__tags;
                },
                getTags: function getTags() {
                  return Object.keys(this.__tags || {});
                },
                removeTag: function removeTag(e) {
                  return this.__tags && (delete this.__tags[e], this._notify("tags-changed")), this;
                },
                removeTags: function removeTags(e) {
                  return t.iter(e, this.removeTag, this), this;
                },
                addTag: function addTag(e) {
                  return this.__tags = this.__tags || {}, this.__tags[e] = !0, this._notify("tags-changed"), this;
                },
                addTags: function addTags(e) {
                  return t.iter(e, this.addTag, this), this;
                },
                tagIntersect: function tagIntersect(e) {
                  return t.filter(e, this.hasTag, this);
                }
              };
            }), h.define("module:Classes.StringTable", ["module:Class", "module:Classes.Taggable", "module:Functions", "module:Objs"], function (e, t, r, o, i) {
              return e.extend({
                scoped: i
              }, [t, function (e) {
                return {
                  _notifications: {
                    "tags-changed": function tagsChanged() {
                      this.__cache = {};
                    }
                  },
                  constructor: function constructor() {
                    e.constructor.call(this), this.__cache = {}, this.__strings = {};
                  },
                  __resolveKey: function __resolveKey(e, t) {
                    return t && (e = t + "." + e), e = e.replace(/[^\.]+\.</g, "");
                  },
                  __betterMatch: function __betterMatch(e, t) {
                    var i = this.tagIntersect(e.tags).length - this.tagIntersect(t.tags).length;
                    return 0 !== i || 0 !== (i = e.priority - t.priority) ? 0 < i : 0 < (i = t.tags.length - e.tags.length);
                  },
                  register: function register() {
                    var i = r.matchArgs(arguments, {
                      strings: !0,
                      prefix: "string",
                      tags: "array",
                      priority: "number"
                    });
                    return o.iter(i.strings, function (e, t) {
                      t = this.__resolveKey(t, i.prefix), this.__strings[t] = this.__strings[t] || [], this.__strings[t].push({
                        value: e,
                        tags: i.tags || [],
                        priority: i.priority || 0
                      }), delete this.__cache[t];
                    }, this), this;
                  },
                  get: function get(e, t) {
                    if ((e = this.__resolveKey(e, t)) in this.__cache) return this.__cache[e];
                    if (!(e in this.__strings)) return null;
                    var i = null;
                    return o.iter(this.__strings[e], function (e) {
                      i && !this.__betterMatch(e, i) || (i = e);
                    }, this), this.__cache[e] = i.value, i.value;
                  },
                  all: function all() {
                    return o.map(this.__strings, function (e, t) {
                      return this.get(t);
                    }, this);
                  }
                };
              }]);
            }), h.define("module:Classes.LocaleMixin", function () {
              return {
                _clearLocale: function _clearLocale() {},
                _setLocale: function _setLocale(e) {},
                getLocale: function getLocale() {
                  return this.__locale;
                },
                clearLocale: function clearLocale() {
                  this._clearLocale(), this.__locale = null;
                },
                setLocale: function setLocale(e) {
                  this.clearLocale(), this.__locale = e, this._setLocale(e);
                },
                isLocaleSet: function isLocaleSet() {
                  return !!this.__locale;
                },
                setWeakLocale: function setWeakLocale(e) {
                  this.isLocaleSet() || this.setLocale(e);
                }
              };
            }), h.define("module:Classes.LocaleTable", ["module:Classes.StringTable", "module:Classes.LocaleMixin"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, [t, {
                _localeTags: function _localeTags(e) {
                  if (!e) return null;
                  var t = [];
                  return t.push("language:" + e), 0 < e.indexOf("-") && t.push("language:" + e.substring(0, e.indexOf("-"))), t;
                },
                _clearLocale: function _clearLocale() {
                  this.removeTags(this._localeTags(this.getLocale()));
                },
                _setLocale: function _setLocale(e) {
                  this.addTags(this._localeTags(e));
                }
              }]);
            }), h.define("module:Maths", [], function () {
              return {
                discreteCeil: function discreteCeil(e, t, i) {
                  var r = Math.ceil(e / t) * t;
                  return i && i < r ? 0 : r;
                },
                clamp: function clamp(e, t, i) {
                  return void 0 === t && (t = -Infinity), void 0 === i && (i = Infinity), e < t ? t : i < e ? i : e;
                },
                range: function range(e, t, i) {
                  var r = [],
                    o = e,
                    a = e <= t ? 1 : -1;
                  if ((0 <= (i = i || a) ? 1 : -1) != a || 0 === i) return r;
                  for (; e < t ? o <= t : t <= o;) r.push(o), o += i;
                  return r;
                }
              };
            }), h.define("module:Classes.ObjectIdScopeMixin", function () {
              return {
                __objects: {},
                get: function get(e) {
                  return this.__objects[e];
                }
              };
            }), h.define("module:Classes.ObjectIdScope", ["module:Class", "module:Classes.ObjectIdScopeMixin"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, t, function (e) {
                return {
                  singleton: function singleton() {
                    return this.__singleton || (this.__singleton = new this()), this.__singleton;
                  }
                };
              });
            }), h.define("module:Classes.ObjectIdMixin", ["module:Classes.ObjectIdScope"], function (e) {
              return {
                _notifications: {
                  construct: "__register_object_id",
                  destroy: "__unregister_object_id"
                },
                __object_id_scope: function __object_id_scope() {
                  return this.object_id_scope || (this.object_id_scope = e.singleton()), this.object_id_scope;
                },
                __register_object_id: function __register_object_id() {
                  this.__object_id_scope().__objects[this.cid()] = this;
                },
                __unregister_object_id: function __unregister_object_id() {
                  delete this.__object_id_scope().__objects[this.cid()];
                }
              };
            }), h.define("module:Lists.ArrayList", ["module:Lists.AbstractList", "module:Ids", "module:Objs"], function (e, t, o, i) {
              return e.extend({
                scoped: i
              }, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    this.__idToIndex = {}, this.__items = [], "compare" in (t = t || {}) && (this._compare = t.compare), "get_ident" in t && (this._get_ident = t.get_ident), i.constructor.call(this, e);
                  },
                  set_compare: function set_compare(e) {
                    (this._compare = e) && this.sort();
                  },
                  get_compare: function get_compare() {
                    return this._compare;
                  },
                  sort: function sort(e) {
                    if (e = e || this._compare) {
                      this.__items.sort(e);
                      for (var t = 0; t < this.__items.length; ++t) this.__ident_changed(this.__items[t], t);
                      this._sorted();
                    }
                  },
                  _sorted: function _sorted() {},
                  re_index: function re_index(e) {
                    if (!this._compare) return e;
                    for (var t = this.__items.length - 1, i = this.__items[e], r = e; r < t && 0 < this._compare(this.__items[r], this.__items[r + 1]);) this.__items[r] = this.__items[r + 1], this.__ident_changed(this.__items[r], r), this.__items[r + 1] = i, ++r;
                    if (r == e) for (; 0 < r && this._compare(this.__items[r], this.__items[r - 1]) < 0;) this.__items[r] = this.__items[r - 1], this.__ident_changed(this.__items[r], r), this.__items[r - 1] = i, --r;
                    return r != e && (this.__ident_changed(i, r), this._re_indexed(i)), r;
                  },
                  _re_indexed: function _re_indexed(e) {},
                  __objectId: function __objectId(e) {
                    return this._get_ident ? this._get_ident(e) : t.objectId(e);
                  },
                  _add: function _add(e) {
                    var t = this.__items.length;
                    this.__items.push(e);
                    var i = this.re_index(t);
                    return this.__idToIndex[this.__objectId(e)] = i;
                  },
                  _remove: function _remove(e) {
                    for (var t = this.__items[e], i = e + 1; i < this.__items.length; ++i) this.__items[i - 1] = this.__items[i], this.__ident_changed(this.__items[i - 1], i - 1);
                    return this.__items.pop(), delete this.__idToIndex[this.__objectId(t)], t;
                  },
                  _get: function _get(e) {
                    return this.__items[e];
                  },
                  _iterate: function _iterate(e, t) {
                    for (var i = o.clone(this.__items, 1), r = 0; r < i.length; ++r) e.apply(t || this, [i[r], this.get_ident(i[r])]);
                  },
                  __ident_changed: function __ident_changed(e, t) {
                    this.__idToIndex[this.__objectId(e)] = t, this._ident_changed(e, t);
                  },
                  get_ident: function get_ident(e) {
                    var t = this.__objectId(e);
                    return t in this.__idToIndex ? this.__idToIndex[t] : null;
                  },
                  ident_by_id: function ident_by_id(e) {
                    return this.__idToIndex[e];
                  }
                };
              });
            }), h.define("module:Iterators.MappedIterator", ["module:Iterators.Iterator"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (r) {
                return {
                  constructor: function constructor(e, t, i) {
                    r.constructor.call(this), this.__iterator = e, this.__map = t, this.__context = i || this;
                  },
                  hasNext: function hasNext() {
                    return this.__iterator.hasNext();
                  },
                  next: function next() {
                    return this.hasNext() ? this.__map.call(this.__context, this.__iterator.next()) : null;
                  }
                };
              });
            }), h.define("module:Iterators.ConcatIterator", ["module:Iterators.Iterator"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.__iterators = e, this.__current = null;
                  },
                  __ensure: function __ensure() {
                    for (; (!this.__current || !this.__current.hasNext()) && this.__iterators.hasNext();) this.__current = this.__iterators.next();
                    return this.__current;
                  },
                  hasNext: function hasNext() {
                    var e = this.__ensure();
                    return e && e.hasNext();
                  },
                  next: function next() {
                    return this.__ensure().next();
                  }
                };
              });
            }), h.define("module:Iterators.FilteredIterator", ["module:Iterators.Iterator"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (r) {
                return {
                  constructor: function constructor(e, t, i) {
                    r.constructor.call(this), this.__iterator = e, this.__filter = t, this.__context = i || this, this.__next = null;
                  },
                  hasNext: function hasNext() {
                    return this.__crawl(), null !== this.__next;
                  },
                  next: function next() {
                    this.__crawl();
                    var e = this.__next;
                    return this.__next = null, e;
                  },
                  __crawl: function __crawl() {
                    for (; !this.__next && this.__iterator.hasNext();) {
                      var e = this.__iterator.next();
                      this.__filter_func(e) && (this.__next = e);
                    }
                  },
                  __filter_func: function __filter_func(e) {
                    return this.__filter.apply(this.__context, [e]);
                  }
                };
              });
            }), h.define("module:Iterators.ObjectValuesIterator", ["module:Iterators.ArrayIterator", "module:Objs"], function (e, i, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, i.values(e));
                  }
                };
              });
            }), h.define("module:Collections.Collection", ["module:Class", "module:Events.EventsMixin", "module:Objs", "module:Functions", "module:Lists.ArrayList", "module:Ids", "module:Properties.ObservableMixin", "module:Properties.Properties", "module:Iterators.ArrayIterator", "module:Iterators.MappedIterator", "module:Iterators.ConcatIterator", "module:Iterators.FilteredIterator", "module:Iterators.ObjectValuesIterator", "module:Types", "module:Promise"], function (s, e, o, a, n, t, i, x, c, d, l, u, h, p, b, r) {
              return s.extend({
                scoped: r
              }, [e, i, function (r) {
                return {
                  constructor: function constructor(e) {
                    r.constructor.call(this), p.is_array(e) && (e = {
                      objects: e
                    }), e = e || {}, this.bulk_operations = 0, this.__indices = {}, e.release_references && (this.__release_references = !0);
                    var t = {};
                    "compare" in e && (t.compare = e.compare), t.get_ident = a.as_method(this.get_ident, this), this.__data = new n([], t);
                    var i = this;
                    this.__data._ident_changed = function (e, t) {
                      i._index_changed(e, t);
                    }, this.__data._re_indexed = function (e) {
                      i._re_indexed(e);
                    }, this.__data._sorted = function () {
                      i._sorted();
                    }, "objects" in e && this.add_objects(e.objects), e.indices && o.iter(e.indices, this.add_secondary_index, this), e.uniqueness && (this.__uniqueness = e.uniqueness), e.progressiveUniqueness && (this.__progressiveUniqueness = e.progressiveUniqueness);
                  },
                  get: function get(e) {
                    switch (e) {
                      case "observable_count":
                        return this.count();
                    }
                    return undefined;
                  },
                  hasKey: function hasKey(e) {
                    switch (e) {
                      case "observable_count":
                        return !0;
                    }
                    return !1;
                  },
                  add_secondary_index: function add_secondary_index(i) {
                    return this.__indices[i] = {}, this.iterate(function (e) {
                      var t = e.get(i);
                      this.__indices[i][t] = this.__indices[i][t] || {}, this.__indices[i][t][this.get_ident(e)] = e;
                    }, this), this;
                  },
                  get_by_secondary_index: function get_by_secondary_index(e, t, i) {
                    return i ? o.ithValue(this.__indices[e][t]) : this.__indices[e][t];
                  },
                  get_ident: function get_ident(e) {
                    return t.objectId(e);
                  },
                  set_compare: function set_compare(e) {
                    return this.trigger("set_compare", e), this.__data.set_compare(e), this;
                  },
                  get_compare: function get_compare() {
                    return this.__data.get_compare();
                  },
                  __load_item: function __load_item(r) {
                    "on" in r && r.on("change", function (e, t, i) {
                      this._object_changed(r, e, t, i);
                    }, this), this.__release_references && r.increaseRef(this);
                  },
                  __unload_item: function __unload_item(e) {
                    "off" in e && e.off(null, null, this), this.__release_references && e.decreaseRef(this);
                  },
                  destroy: function destroy() {
                    this.__data.iterate(this.__unload_item, this), this.__data.destroy(), this.trigger("destroy"), r.destroy.call(this);
                  },
                  count: function count() {
                    return this.__data.count();
                  },
                  _index_changed: function _index_changed(e, t) {
                    this.trigger("index", e, t);
                  },
                  _re_indexed: function _re_indexed(e) {
                    this.trigger("reindexed", e);
                  },
                  _sorted: function _sorted() {
                    this.trigger("sorted");
                  },
                  _object_changed: function _object_changed(e, t, i, r) {
                    this.trigger("update"), this.trigger("change", e, t, i, r), this.trigger("change:" + t, e, i, r), this.__data.re_index(this.getIndex(e));
                  },
                  add: function add(r) {
                    var e;
                    if (s.is_class_instance(r) || (r = new x(r)), this.__progressiveUniqueness && this.__indices[this.__progressiveUniqueness] && (e = this.get_by_secondary_index(this.__progressiveUniqueness, r.get(this.__progressiveUniqueness), !0)) && e !== r && this.remove(e), this.exists(r)) return null;
                    var t = this.__data.add(r);
                    return null !== t && (o.iter(this.__indices, function (e, t) {
                      var i = r.get(t);
                      e[i] = e[i] || {}, e[i][this.get_ident(r)] = r;
                    }, this), this.trigger("add", r), this.trigger("update"), this.trigger("change:observable_count", this.count()), this.__load_item(r)), t;
                  },
                  bulkOperationInProgress: function bulkOperationInProgress() {
                    return 0 < this.bulk_operations;
                  },
                  replace_objects: function replace_objects(e, t) {
                    if (this.destroyed()) return this;
                    this.bulk_operations++;
                    var a = [],
                      n = {};
                    if (o.iter(e, function (e) {
                      var t = s.is_class_instance(e),
                        i = t ? e : new x(e),
                        r = this.get_ident(i);
                      n[r] = !0;
                      var o = this.getById(r);
                      o ? t || (i.destroy(), o.setAll(e)) : a.push(i);
                    }, this), !t) {
                      for (var i = this.iterator(); i.hasNext();) {
                        var r = i.next();
                        n[this.get_ident(r)] || (this.remove(r), 0 < a.length && this.add(a.shift()));
                      }
                      i.destroy();
                    }
                    for (; 0 < a.length;) this.add(a.shift());
                    return this.bulk_operations--, this.trigger("replaced-objects"), this;
                  },
                  add_objects: function add_objects(e, t) {
                    var i = 0;
                    return o.iter(e, function (e) {
                      this.add(e) && i++;
                    }, this), t ? this : i;
                  },
                  exists: function exists(e) {
                    return !!this.__data.exists(e) || !!this.__uniqueness && (this.__indices[this.__uniqueness] ? !!this.get_by_secondary_index(this.__uniqueness, e.get(this.__uniqueness), !0) : !!this.queryOne(o.objectBy(this.__uniqueness, e.get(this.__uniqueness))));
                  },
                  remove: function remove(r) {
                    if (!this.exists(r)) return null;
                    o.iter(this.__indices, function (e, t) {
                      var i = r.get(t);
                      e[i] && (delete e[i][this.get_ident(r)], p.is_empty(e[i]) && delete e[i]);
                    }, this);
                    var e = this.__data.remove(r);
                    return this.trigger("remove", r), this.trigger("change:observable_count", this.count()), this.__unload_item(r), this.trigger("update"), e;
                  },
                  getByIndex: function getByIndex(e) {
                    return this.__data.get(e);
                  },
                  getById: function getById(e) {
                    return this.__data.get(this.__data.ident_by_id(e));
                  },
                  getIndex: function getIndex(e) {
                    return this.__data.get_ident(e);
                  },
                  iterate: function iterate(e, t) {
                    return this.__data.iterate(e, t), this;
                  },
                  has: function has(t, e) {
                    var i = !1;
                    return this.iterate(function (e) {
                      i = i || t.call(this, e);
                    }, e), i;
                  },
                  forall: function forall(t, e) {
                    var i = !0;
                    return this.iterate(function (e) {
                      i = i && t.call(this, e);
                    }, e), i;
                  },
                  iterator: function iterator() {
                    return c.byIterate(this.iterate, this);
                  },
                  iterateSecondaryIndexValue: function iterateSecondaryIndexValue(t, e) {
                    return p.is_array(e) ? new l(new d(new c(e), function (e) {
                      return this.iterateSecondaryIndexValue(t, e);
                    }, this)) : new h(this.__indices[t][e]);
                  },
                  query: function query(t) {
                    var e = null;
                    for (var i in this.__indices) if (i in t) {
                      e = this.iterateSecondaryIndexValue(i, t[i]), delete t[i];
                      break;
                    }
                    return new u(e || this.iterator(), function (e) {
                      return e.isSupersetOf(t);
                    });
                  },
                  queryOne: function queryOne(e) {
                    return this.query(e).next();
                  },
                  clear: function clear() {
                    return this.iterate(function (e) {
                      this.remove(e);
                    }, this), this;
                  },
                  increase_forwards: function increase_forwards(e) {
                    return b.error(!0);
                  },
                  increase_backwards: function increase_backwards(e) {
                    return b.error(!0);
                  },
                  first: function first() {
                    return this.getByIndex(0);
                  },
                  last: function last() {
                    return this.getByIndex(this.count() - 1);
                  },
                  allSet: function allSet(t, i) {
                    return this.iterate(function (e) {
                      e.set(t, i);
                    }), this;
                  },
                  allSetAll: function allSetAll(t) {
                    return this.iterate(function (e) {
                      e.setAll(t);
                    }), this;
                  },
                  asJSON: function asJSON() {
                    var t = [];
                    return this.iterate(function (e) {
                      t.push(e.data());
                    }), t;
                  }
                };
              }]);
            }), h.define("module:Events.Events", ["module:Class", "module:Events.EventsMixin"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, t);
            }), h.define("module:Trees.TreeNavigator", function () {
              return {
                nodeRoot: function nodeRoot() {},
                nodeId: function nodeId(e) {},
                nodeParent: function nodeParent(e) {},
                nodeChildren: function nodeChildren(e) {},
                nodeWatch: function nodeWatch(e, t, i) {},
                nodeUnwatch: function nodeUnwatch(e, t, i) {},
                nodeData: function nodeData(e) {}
              };
            }), h.define("module:Parser.LexerException", ["module:Exceptions.Exception"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    i.constructor.call(this, "Lexer error: Unrecognized identifier at " + e.length + "."), this.__head = e, this.__tail = t;
                  }
                };
              });
            }), h.define("module:Parser.Lexer", ["module:Class", "module:Types", "module:Objs", "module:Parser.LexerException"], function (e, c, d, l, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.__patterns = [], d.iter(e, function (e, t) {
                      this.__patterns.push({
                        regex: new RegExp("^" + t, "m"),
                        data: c.is_string(e) ? {
                          token: e
                        } : e
                      });
                    }, this);
                  },
                  lex: function lex(e) {
                    for (var t = [], i = "", r = e; r;) {
                      for (var o = null, a = null, n = 0; n < this.__patterns.length; ++n) if (o = this.__patterns[n].regex.exec(r)) {
                        a = d.clone(this.__patterns[n].data, 1);
                        break;
                      }
                      if (!o) throw new l(i, r);
                      if (i += o[0], r = r.substring(o[0].length), a) {
                        for (var s in a) if (c.is_string(a[s])) for (var x = 0; x < o.length; ++x) a[s] = a[s].replace("$" + x, o[x]);
                        t.push(a);
                      }
                    }
                    return t;
                  }
                };
              });
            }), h.define("module:Trees.TreeQueryObject", ["module:Class", "module:Events.EventsMixin", "module:Objs", "module:Types"], function (e, t, x, o, i) {
              return e.extend({
                scoped: i
              }, [t, function (r) {
                return {
                  constructor: function constructor(e, t, i) {
                    r.constructor.call(this), this.__navigator = e, this.__node = t, this.__query = i, this.__result = {}, this.__partials = {}, this.__ids = 0, this.__register(t, 0, {});
                  },
                  destroy: function destroy() {
                    x.iter(this.__partials, function (t) {
                      x.iter(t.partials, function (e) {
                        this.__navigator.nodeUnwatch(t.node, null, e);
                      }, this);
                    }, this), r.destroy.call(this);
                  },
                  result: function result() {
                    var t = [];
                    return x.iter(this.__result, function (e) {
                      t.push(e.node);
                    }), t;
                  },
                  __register: function __register(e, t) {
                    var i = this.__navigator.nodeId(e);
                    this.__partials[i] || (this.__partials[i] = {
                      node: e,
                      partials: {}
                    });
                    var r = this.__partials[i];
                    this.__ids++;
                    for (var o = {
                        owner: r,
                        id: this.__ids,
                        query_index_start: t,
                        query_index_next: t,
                        query_index_last: t,
                        partial_match: !1,
                        partial_final: t >= this.__query.length,
                        partial_data: !1,
                        partial_children: !1,
                        partial_parent: !1,
                        partial_star: !1,
                        parent: null,
                        deps: {}
                      }, a = (r.partials[o.id] = o).query_index_start; a < this.__query.length; ++a) {
                      if ("Selector" != this.__query[a].token) {
                        "Up" == this.__query[a].token ? o.partial_parent = !0 : "Down" == this.__query[a].token && (o.partial_children = !0), o.partial_star = !this.__query[a].single, o.partial_star || (o.query_index_next = a + 1);
                        break;
                      }
                      o.partial_data = !0, o.query_index_next = a + 1, o.partial_final = a + 1 == this.__query.length;
                    }
                    o.query_index_last = o.partial_star ? o.query_index_next + 1 : o.query_index_next;
                    var n = this;
                    return this.__navigator.nodeWatch(e, function (e, t) {
                      "data" == e && o.partial_data && n.__update(o), "remove" == e && n.__unregisterPartial(o), "addChild" == e && o.partial_children && o.partial_match && n.__addDependentPartial(o, t);
                    }, o), this.__update(o), o;
                  },
                  __unregisterPartial: function __unregisterPartial(e) {
                    var t = e.owner,
                      i = t.node,
                      r = this.__navigator.nodeId(i);
                    e.partial_final && this.__result[r] && (this.__result[r].count--, this.__result[r].count <= 0 && (delete this.__result[r], this.trigger("remove", i), this.trigger("change"))), x.iter(e.deps, this.__unregisterPartial, this), e.parent && delete e.parent.deps[e.id], this.__navigator.nodeUnwatch(i, null, e), delete t.partials[e.id], o.is_empty(t.partials) && delete this.__partials[r];
                  },
                  __addDependentPartial: function __addDependentPartial(t, e) {
                    var i = [];
                    i.push(this.__register(e, t.query_index_next)), t.partial_star && i.push(this.__register(e, t.query_index_next + 1)), x.iter(i, function (e) {
                      (t.deps[e.id] = e).parent = t;
                    }, this);
                  },
                  __update: function __update(t) {
                    for (var e, i = !0, r = t.owner.node, o = this.__navigator.nodeId(r), a = this.__navigator.nodeData(r), n = t.query_index_start; n < t.query_index_last; ++n) {
                      var s = this.__query[n];
                      if ("Selector" != s.token) break;
                      if (a[s.key] != s.value) {
                        i = !1;
                        break;
                      }
                    }
                    i != t.partial_match && ((t.partial_match = i) ? t.partial_final ? this.__result[o] ? this.__result[o].count++ : (this.__result[o] = {
                      node: r,
                      count: 1
                    }, this.trigger("add", r), this.trigger("change")) : t.partial_parent ? (e = this.__navigator.nodeParent(r)) && this.__addDependentPartial(t, e) : t.partial_children && x.iter(this.__navigator.nodeChildren(r), function (e) {
                      this.__addDependentPartial(t, e);
                    }, this) : (t.partial_final && (this.__result[o].count--, this.__result[o].count <= 0 && (delete this.__result[o], this.trigger("remove", r), this.trigger("change"))), x.iter(t.deps, this.__unregisterPartial, this)));
                  }
                };
              }]);
            }), h.define("module:Trees.TreeQueryEngine", ["module:Class", "module:Parser.Lexer", "module:Trees.TreeQueryObject"], function (e, i, r, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.__navigator = e, this.__lexer = this._auto_destroy(new i({
                      "<\\+": {
                        token: "Up"
                      },
                      "<": {
                        token: "Up",
                        single: !0
                      },
                      ">\\+": {
                        token: "Down"
                      },
                      ">": {
                        token: "Down",
                        single: !0
                      },
                      "\\[s*([a-zA-Z]+)s*=s*'([^']*)'s*\\]": {
                        token: "Selector",
                        key: "$1",
                        value: "$2"
                      },
                      '\\[s*([a-zA-Z]+)s*=s*"([^\']*)"s*\\]': {
                        token: "Selector",
                        key: "$1",
                        value: "$2"
                      },
                      s: null
                    }));
                  },
                  query: function query(e, t) {
                    return new r(this.__navigator, e, this.__lexer.lex(t));
                  }
                };
              });
            }), h.define("module:JavaScript", ["module:Objs"], function (r) {
              return {
                STRING_SINGLE_QUOTATION_REGEX: /'[^']*'/g,
                STRING_DOUBLE_QUOTATION_REGEX: /"[^"]*"/g,
                PROPER_IDENTIFIER_REGEX: /^[a-zA-Z_][a-zA-Z_0-9]*$/,
                IDENTIFIER_REGEX: /[a-zA-Z_][a-zA-Z_0-9]*/g,
                IDENTIFIER_SCOPE_REGEX: /[a-zA-Z_][a-zA-Z_0-9\.]*/g,
                RESERVED: r.objectify(["if", "then", "else", "return", "var"], !0),
                isReserved: function isReserved(e) {
                  return e in this.RESERVED;
                },
                isIdentifier: function isIdentifier(e) {
                  return !this.isReserved(e);
                },
                isProperIdentifier: function isProperIdentifier(e) {
                  return this.isIdentifier(e) && this.PROPER_IDENTIFIER_REGEX.test(e);
                },
                removeStrings: function removeStrings(e) {
                  return e.replace(this.STRING_SINGLE_QUOTATION_REGEX, "").replace(this.STRING_DOUBLE_QUOTATION_REGEX, "");
                },
                extractIdentifiers: function extractIdentifiers(e, t) {
                  var i = t ? this.IDENTIFIER_SCOPE_REGEX : this.IDENTIFIER_REGEX;
                  return e = this.removeStrings(e), r.filter(e.match(i), this.isIdentifier, this);
                },
                extractFunctionParameterNames: function extractFunctionParameterNames(e) {
                  return e.toString().match(/function \((.*)\).*/)[1].replace(/\s*/g, "").split(",");
                }
              };
            }), h.define("module:Classes.SharedObjectFactory", ["module:Class"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (r) {
                return {
                  constructor: function constructor(e, t, i) {
                    r.constructor.call(this), this.__createCallback = e, this.__createContext = t, this.__createArgs = i || [], this.__object = null;
                  },
                  destroy: function destroy() {
                    this.__object && !this.__object.destroyed() && this.__object.destroy(), r.destroy.call(this);
                  },
                  value: function value() {
                    return this.__object && !this.__object.destroyed() ? this.__object : null;
                  },
                  isAcquired: function isAcquired() {
                    return !!this.value();
                  },
                  acquire: function acquire(e, t) {
                    return this.__object && !this.__object.destroyed() || (this.__object = this.__createCallback.apply(this.__createContext || this, this.__createArgs)), this.__object.increaseRef(e, t), this.__object;
                  },
                  release: function release(e, t) {
                    e && e === this.__object && !e.destroyed() && e.decreaseRef(e);
                  }
                };
              });
            }), h.define("module:Classes.ClassRegistry", ["module:Class", "module:Types", "module:Functions", "module:Objs"], function (e, r, t, o, i) {
              return e.extend({
                scoped: i
              }, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    i.constructor.call(this), this._classes = r.is_array(e) ? e : [e || {}], this._lowercase = t;
                  },
                  _sanitize: function _sanitize(e) {
                    return this._lowercase ? e.toLowerCase() : e;
                  },
                  register: function register(e, t) {
                    return this._classes[this._classes.length - 1][this._sanitize(e)] = t, this;
                  },
                  get: function get(e) {
                    if (!r.is_string(e)) return e;
                    e = this._sanitize(e);
                    for (var t = this._classes.length - 1; 0 <= t; --t) if (e in this._classes[t]) return this._classes[t][e];
                    return null;
                  },
                  create: function create(e) {
                    return t.newClassFunc(this.get(e)).apply(this, t.getArguments(arguments, 1));
                  },
                  classes: function classes() {
                    var t = {};
                    return o.iter(this._classes, function (e) {
                      t = o.extend(t, e);
                    }), t;
                  }
                };
              });
            }), h.define("module:Exceptions.ExceptionThrower", ["module:Class"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  throwException: function throwException(e) {
                    return this._throwException(e), this;
                  },
                  _throwException: function _throwException(e) {
                    throw e;
                  }
                };
              });
            }), h.define("module:Exceptions.AsyncExceptionThrower", ["module:Exceptions.ExceptionThrower", "module:Async"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, function (e) {
                return {
                  _throwException: function _throwException(e) {
                    t.eventually(function () {
                      throw e;
                    });
                  }
                };
              });
            }), h.define("module:Loggers.Logger", ["module:Class", "module:Objs", "module:Functions"], function (e, o, i, t) {
              var r = e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), e = e || {}, this.__listeners = {}, this.__augments = {}, this.__tags = e.tags || [], o.iter(e.listeners, this.addListener, this);
                  },
                  addAugment: function addAugment(e, t) {
                    return this.__augments[e.cid()] = {
                      augment: e,
                      prefix: t
                    }, this;
                  },
                  removeAugment: function removeAugment(e) {
                    return delete this.__augments[e.cid()], this;
                  },
                  addListener: function addListener(e) {
                    return this.__listeners[e.cid()] = e, this;
                  },
                  removeListener: function removeListener(e) {
                    return delete this.__listeners[e.cid()], this;
                  },
                  log: function log() {
                    return this.message(this, {
                      type: "log",
                      args: i.getArguments(arguments, 0)
                    });
                  },
                  logf: function logf() {
                    return i.as_method(this.log, this);
                  },
                  warn: function warn() {
                    return this.message(this, {
                      type: "warn",
                      args: i.getArguments(arguments, 0)
                    });
                  },
                  error: function error() {
                    return this.message(this, {
                      type: "error",
                      args: i.getArguments(arguments, 0)
                    });
                  },
                  taggedlog: function taggedlog(e) {
                    return this.message(this, {
                      type: "log",
                      tags: e,
                      args: i.getArguments(arguments, 1)
                    });
                  },
                  taggedwarn: function taggedwarn(e) {
                    return this.message(this, {
                      type: "warn",
                      tags: e,
                      args: i.getArguments(arguments, 1)
                    });
                  },
                  taggederror: function taggederror(e) {
                    return this.message(this, {
                      type: "error",
                      tags: e,
                      args: i.getArguments(arguments, 1)
                    });
                  },
                  message: function message(t, i, r) {
                    return r = r || 0, i.tags = this.__tags.concat(i.tags || []), i.augments = i.augments || [], o.iter(this.__augments, function (e) {
                      i.augments.push((e.prefix ? e.prefix + ":" : "") + e.augment.augmentMessage(t, i, r));
                    }, this), o.iter(this.__listeners, function (e) {
                      e.message(this, i, r + 1);
                    }, this), this;
                  },
                  tag: function tag() {
                    return new r({
                      tags: i.getArguments(arguments),
                      listeners: [this]
                    });
                  }
                };
              }, {
                global: function global() {
                  return this.__global || (this.__global = new r()), this.__global;
                }
              });
              return r;
            }), h.define("module:Loggers.LoggableMixin", ["module:Loggers.Logger", "module:Objs", "module:Functions"], function (e) {
              return {
                baseLogger: function baseLogger() {
                  return this._baseLogger || (this._baseLogger = e.global()), this._baseLogger;
                },
                logger: function logger() {
                  return this._logger || (this._logger = this.baseLogger().tag(this.cls.classname, this.cid())), this._logger;
                }
              };
            }), h.define("module:TimeFormat", ["module:Time", "module:Strings", "module:Objs"], function (x, i, c) {
              return {
                formatMappings: {
                  HH: function HH(e) {
                    return i.padZeros(x.timeModulo(e, "hour", "floor"), 2);
                  },
                  H: function H(e) {
                    return x.timeModulo(e, "hour", "floor");
                  },
                  "h+": function h(e) {
                    return x.timeComponent(e, "hour", "floor");
                  },
                  hh: function hh(e) {
                    var t = 0 === (t = x.timeModulo(e, "hour", "floor")) ? 12 : 12 < t ? t - 12 : t;
                    return i.padZeros(t, " ", 2);
                  },
                  h: function h(e) {
                    var t = x.timeModulo(e, "hour", "floor");
                    return t = 0 === t ? 12 : 12 < t ? t - 12 : t;
                  },
                  "M+": function M(e) {
                    return x.timeComponent(e, "minute", "floor");
                  },
                  MM: function MM(e) {
                    return i.padZeros(x.timeModulo(e, "minute", "floor"), 2);
                  },
                  M: function M(e) {
                    return x.timeModulo(e, "minute", "floor");
                  },
                  "s+": function s(e) {
                    return x.timeComponent(e, "second", "floor");
                  },
                  ss: function ss(e) {
                    return i.padZeros(x.timeModulo(e, "second", "floor"), 2);
                  },
                  s: function s(e) {
                    return x.timeModulo(e, "second", "floor");
                  },
                  mmm: function mmm(e) {
                    return new Date(e).toUTCString().split(" ")[2];
                  },
                  mm: function mm(e) {
                    return i.padZeros(x.timeComponentGet(e, "month") + 1, 2);
                  },
                  m: function m(e) {
                    return x.timeComponentGet(e, "month") + 1;
                  },
                  "d+": function d(e) {
                    return x.timeComponent(e, "day", "floor");
                  },
                  dddd: function dddd(e) {
                    return new Date(e).toUTCString().substring(0, 3) + ({
                      2: "s",
                      3: "nes",
                      4: "rs",
                      6: "ur"
                    }[x.timeComponentGet(e, "weekday")] || "") + "day";
                  },
                  ddd: function ddd(e) {
                    return new Date(e).toUTCString().substring(0, 3);
                  },
                  dd: function dd(e) {
                    return i.padZeros(x.timeComponentGet(e, "day") + 1, 2);
                  },
                  d: function d(e) {
                    return x.timeComponentGet(e, "day") + 1;
                  },
                  yyyy: function yyyy(e) {
                    return x.timeComponentGet(e, "year");
                  },
                  yy: function yy(e) {
                    return x.timeComponentGet(e, "year") % 100;
                  },
                  "l+": function l(e) {
                    return e.getTime();
                  },
                  l: function l(e) {
                    return x.timeComponentGet(e, "millisecond");
                  },
                  L: function L(e) {
                    return Math.floor(x.timeComponentGet(e, "millisecond") / 10);
                  },
                  tt: function tt(e) {
                    return x.timeModulo(e, "hour", "floor") < 12 ? "am" : "pm";
                  },
                  t: function t(e) {
                    return x.timeModulo(e, "hour", "floor") < 12 ? "a" : "p";
                  },
                  TT: function TT(e) {
                    return x.timeModulo(e, "hour", "floor") < 12 ? "AM" : "PM";
                  },
                  T: function T(e) {
                    return x.timeModulo(e, "hour", "floor") < 12 ? "A" : "P";
                  },
                  o: function o(e, t) {
                    return (0 < (t = Math.floor(t / 1e3 / 60)) ? "-" : "+") + i.padZeros(100 * Math.floor(Math.abs(t) / 60) + Math.abs(t) % 60, 4);
                  }
                },
                ELAPSED_HOURS_MINUTES_SECONDS: "h+:MM:ss",
                ELAPSED_MINUTES_SECONDS: "M+:ss",
                FULL_YEAR: "yyyy",
                LETTER_MONTH: "mmm",
                LETTER_MONTH_AND_DAY: "mmm d",
                WEEKDAY: "ddd",
                HOURS_MINUTES_TT: "hh:MM tt",
                format: function format(e, t, i) {
                  t = t || x.now();
                  var r = x.timeToTimezoneBasedDate(t, i),
                    o = x.timezoneBias(i, t),
                    a = e,
                    n = [];
                  c.iter(this.formatMappings, function (e, t) {
                    var i;
                    0 <= a.indexOf(t) && (i = n.length, n.push(e(r, o)), a = a.replace(t, "$" + i + "$"));
                  }, this);
                  for (var s = 0; s < n.length; ++s) a = a.replace("$" + s + "$", n[s]);
                  return a;
                },
                monthString: function monthString(e) {
                  return this.format("mmm", x.encodePeriod({
                    month: e
                  }));
                },
                weekdayString: function weekdayString(e) {
                  return this.format("ddd", x.encodePeriod({
                    weekday: e
                  }));
                },
                weekNumber: function weekNumber(e, t) {
                  var i = new Date(e + x.timezoneBias(t, e)),
                    r = new Date(Date.UTC(i.getFullYear(), i.getMonth(), i.getDate())),
                    o = r.getUTCDay() || 7;
                  r.setUTCDate(r.getUTCDate() + 4 - o);
                  var a = new Date(Date.UTC(r.getUTCFullYear(), 0, 1));
                  return Math.ceil(((r - a) / 864e5 + 1) / 7);
                },
                formatRelativeMostSignificant: function formatRelativeMostSignificant(e, t, i) {
                  if (e === Infinity) return "Someday";
                  t = t || x.now();
                  var r = x.decodeTime(e, i),
                    o = x.decodeTime(t, i);
                  return r.year === o.year && r.month === o.month && r.day === o.day - 1 ? "Yesterday " + this.format("hh:MM tt", e, i) : r.year === o.year && r.month === o.month && r.day === o.day ? "Today " + this.format("hh:MM tt", e, i) : r.year === o.year && r.month === o.month && r.day === o.day + 1 ? "Tomorrow " + this.format("hh:MM tt", e, i) : Math.abs(t - e) < 6048e5 && r.weekday !== o.weekday ? this.format("dddd", e, i) : r.year === o.year && r.month + 1 >= o.month || r.year + 1 === o.year && r.month + 1 >= o.month + 12 - 1 ? this.format("mmm d", e, i) : r.year === o.year || r.year + 1 === o.year && r.month > o.month ? this.format("mmm", e, i) : this.format("yyyy", e, i);
                }
              };
            }), h.define("module:Collections.FilteredCollection", ["module:Collections.Collection"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (r) {
                return {
                  constructor: function constructor(e, t) {
                    this.__parent = e, delete (t = t || {}).objects, t.compare = t.compare || e.get_compare(), r.constructor.call(this, t), this.__parent.on("add", this.add, this), this.__parent.on("remove", this.__selfRemove, this), this.__parent.on("change", this.add, this), this.setFilter(t.filter, t.context);
                  },
                  filter: function filter(e) {
                    return !this.__filter || this.__filter.call(this.__filterContext || this, e);
                  },
                  setFilter: function setFilter(e, t) {
                    this.__filterContext = t, this.__filter = e, this.iterate(function (e) {
                      this.filter(e) || this.__selfRemove(e);
                    }, this), this.__parent.iterate(function (e) {
                      return !this.exists(e) && this.filter(e) && this.__selfAdd(e), !0;
                    }, this);
                  },
                  _object_changed: function _object_changed(e, t, i) {
                    r._object_changed.call(this, e, t, i), this.filter(e) || this.__selfRemove(e);
                  },
                  destroy: function destroy() {
                    this.__parent.off(null, null, this), r.destroy.call(this);
                  },
                  __selfAdd: function __selfAdd(e) {
                    return r.add.call(this, e);
                  },
                  add: function add(e) {
                    if (this.exists(e) || !this.filter(e)) return null;
                    var t = this.__selfAdd(e);
                    return this.__parent.add(e), t;
                  },
                  __selfRemove: function __selfRemove(e) {
                    return r.remove.call(this, e);
                  },
                  remove: function remove(e) {
                    return this.exists(e) && this.__selfRemove(e) ? this.__parent.remove(e) : null;
                  }
                };
              });
            }), h.define("module:States.State", ["module:Class", "module:Types", "module:Strings", "module:Async", "module:Objs"], function (e, n, t, i, s, r) {
              return e.extend({
                scoped: r
              }, function (a) {
                return {
                  _locals: [],
                  _persistents: [],
                  _defaults: {},
                  _clonedDefaults: {},
                  _white_list: null,
                  _starting: !1,
                  _started: !1,
                  _stopped: !1,
                  _transitioning: !1,
                  __next_state: null,
                  __suspended: 0,
                  constructor: function constructor(i, e, t) {
                    a.constructor.call(this), this.host = i, this.transitionals = t, e = s.extend(s.extend(s.clone(this._clonedDefaults || {}, -1), s.clone(this._defaults || {}, 1)), e), this._locals = n.is_function(this._locals) ? this._locals() : this._locals;
                    for (var r = {}, o = 0; o < this._locals.length; ++o) this["_" + this._locals[o]] = e[this._locals[o]], r[this._locals[o]] = !0;
                    for (this._persistents = n.is_function(this._persistents) ? this._persistents() : this._persistents, o = 0; o < this._persistents.length; ++o) this["_" + this._persistents[o]] = e[this._persistents[o]], r[this._locals[o]] = !0;
                    i.suspendEvents(), this.__hostArgs = {}, s.iter(e, function (e, t) {
                      r[t] || (this.__hostArgs[t] = !0, i.set(t, e));
                    }, this), i.resumeEvents();
                  },
                  allAttr: function allAttr() {
                    var t = s.clone(this.host.data(), 1);
                    return s.iter(this._locals, function (e) {
                      t[e] = this["_" + e];
                    }, this), s.iter(this._persistents, function (e) {
                      t[e] = this["_" + e];
                    }, this), t;
                  },
                  state_name: function state_name() {
                    return t.last_after(this.cls.classname, ".");
                  },
                  description: function description() {
                    return this.state_name();
                  },
                  start: function start() {
                    return this._starting || (this._starting = !0, this.host._start(this), this._start(), this.host && (this.host._afterStart(this), this._started = !0)), this;
                  },
                  end: function end() {
                    return this._stopped || (this._stopped = !0, this._end(), this.host._end(this), this.host._afterEnd(this), this.destroy()), this;
                  },
                  eventualNext: function eventualNext(e, t, i) {
                    this.suspend();
                    var r = this.next(e, t, i);
                    return this.eventualResume(), r;
                  },
                  next: function next(e, t, i) {
                    if (!this._starting || this._stopped || this.__next_state) return null;
                    t = t || {};
                    for (var r = 0; r < this._persistents.length; ++r) this._persistents[r] in t || (t[this._persistents[r]] = this["_" + this._persistents[r]]);
                    var o = this.host._createState(e, t, i);
                    return this.can_transition_to(o) ? (this._started || (this.host._afterStart(this), this._started = !0), this.__next_state = o, this._transitioning = !0, this._transition(), this.__suspended <= 0 && this.__next(), o) : (o.destroy(), null);
                  },
                  weakSame: function weakSame(e, t, i) {
                    var r = !0;
                    e !== this.state_name() && (r = !1);
                    var o = this.allAttr();
                    return s.iter(t, function (e, t) {
                      o[t] !== e && (r = !1);
                    }, this), r;
                  },
                  weakNext: function weakNext(e, t, i) {
                    return this.weakSame.apply(this, arguments) ? this : this.next.apply(this, arguments);
                  },
                  __next: function __next() {
                    var i = this.host,
                      r = this.__next_state;
                    i._next(r);
                    var e = this.__hostArgs;
                    this.end(), r.start(), i.suspendEvents(), (r = i.state()) && !r.destroyed() && (s.iter(e, function (e, t) {
                      r.__hostArgs[t] || i.unset(t);
                    }, this), i.resumeEvents(), i._afterNext(r));
                  },
                  _transition: function _transition() {},
                  suspend: function suspend() {
                    return this.__suspended++, this;
                  },
                  eventualResume: function eventualResume() {
                    return i.eventually(this.resume, this), this;
                  },
                  resume: function resume() {
                    return this.__suspended--, 0 === this.__suspended && !this._stopped && this.__next_state && this.__next(), this;
                  },
                  can_transition_to: function can_transition_to(e) {
                    return this.host && this.host._can_transition_to(e) && this._can_transition_to(e);
                  },
                  _start: function _start() {},
                  _end: function _end() {},
                  _can_transition_to: function _can_transition_to(e) {
                    return !n.is_array(this._white_list) || s.contains_value(this._white_list, e.state_name());
                  }
                };
              }, {
                _extender: {
                  _defaults: function _defaults(e, t) {
                    return s.extend(s.clone(e, 1), t);
                  }
                }
              });
            }), h.define("module:States.Host", ["module:Properties.Properties", "module:Events.EventsMixin", "module:States.State", "module:Types", "module:Strings", "module:Classes.ClassRegistry"], function (e, t, a, n, s, x, i) {
              return e.extend({
                scoped: i
              }, [t, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), e = e || {}, this._stateRegistry = e.stateRegistry, this._baseState = e.baseState, this._enabled = !0;
                  },
                  initialize: function initialize(e, t) {
                    var i, r;
                    return this._stateRegistry || (r = null, r = n.is_string(e) && 0 <= e.indexOf(".") ? (e = (i = s.splitLast(e, ".")).tail, i.head) : n.is_string(e) ? s.splitLast(this.cls.classname, ".").head : s.splitLast(e.classname, ".").head, this._stateRegistry = this._auto_destroy(new x(h.getGlobal(r)))), this._createState(e, t).start(), this._baseState = this._baseState || this._state.cls, this;
                  },
                  _createState: function _createState(e, t, i) {
                    return this._stateRegistry.create(e, this, t || {}, i || {});
                  },
                  finalize: function finalize() {
                    return this._state && this._state.end(), this._state = null, this;
                  },
                  destroy: function destroy() {
                    this.finalize(), t.destroy.call(this);
                  },
                  enable: function enable() {
                    return this._enabled = !0, this;
                  },
                  disable: function disable() {
                    return this._enabled = !1, this;
                  },
                  state: function state() {
                    return this._state;
                  },
                  state_name: function state_name() {
                    return this.state().state_name();
                  },
                  next: function next() {
                    return this.state() ? this.state().next.apply(this.state(), arguments) : this.initialize.apply(this, arguments);
                  },
                  weakNext: function weakNext() {
                    return this.state() ? this.state().weakNext.apply(this.state(), arguments) : this.initialize.apply(this, arguments);
                  },
                  _start: function _start(e) {
                    this._stateEvent(e, "before_start"), this._state = e, this.set("name", e.state_name());
                  },
                  _afterStart: function _afterStart(e) {
                    this._stateEvent(e, "start");
                  },
                  _end: function _end(e) {
                    this._stateEvent(e, "end"), this._state = null;
                  },
                  _afterEnd: function _afterEnd(e) {
                    this._stateEvent(e, "after_end");
                  },
                  _next: function _next(e) {
                    this._stateEvent(e, "next");
                  },
                  _afterNext: function _afterNext(e) {
                    this._stateEvent(e, "after_next");
                  },
                  _can_transition_to: function _can_transition_to(e) {
                    return this._enabled;
                  },
                  _stateEvent: function _stateEvent(e, t) {
                    this.trigger("event", t, e.state_name(), e.description()), this.trigger(t, e.state_name(), e.description()), this.trigger(t + ":" + e.state_name(), e.description());
                  },
                  register: function register(e, t, i) {
                    n.is_string(t) || (i = t, t = null), this._stateRegistry || (this._stateRegistry = this._auto_destroy(new x(s.splitLast(this.cls.classname).head)));
                    var r = this._baseState ? s.splitLast(this._baseState.classname, ".").head + "." + e : 0 <= e.indexOf(".") ? e : null,
                      o = (this._stateRegistry.get(t) || this._baseState || a).extend(r, i);
                    return r || (o.classname = e), this._stateRegistry.register(s.last_after(e, "."), o), this;
                  }
                };
              }]);
            }), h.define("module:Ajax.AbstractAjaxWrapper", ["module:Class", "module:Objs"], function (e, o, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.options = e;
                  },
                  execute: function execute(e, t, i, r) {
                    return this._execute(o.extend(o.clone(this.options, 1), e), t, i, r);
                  },
                  _execute: function _execute(e, t, i, r) {
                    throw "Not implemented";
                  }
                };
              });
            }), h.define("module:Ajax.AjaxWrapper", ["module:Ajax.AbstractAjaxWrapper", "module:Ajax.Support"], function (e, o, t) {
              return e.extend({
                scoped: t
              }, {
                _execute: function _execute(e, t, i, r) {
                  return o.execute(e, t, i, r);
                }
              });
            }), h.define("module:Net.Cookies", ["module:Objs", "module:Types"], function (x, c) {
              return {
                getCookielikeValue: function getCookielikeValue(e, t) {
                  return e = e || "", decodeURIComponent(e.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(t).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
                },
                createCookielikeValue: function createCookielikeValue(e, t, i, r, o, a, n) {
                  if (!e || /^(?:expires|max\-age|path|domain|secure)$/i.test(e)) return null;
                  var s = [];
                  return s.push([encodeURIComponent(e), encodeURIComponent(t)]), i && (i === Infinity ? s.push(["expires", "Fri, 31 Dec 9999 23:59:59 GMT"]) : "number" == typeof i ? s.push(["max-age", i]) : "object" == typeof i ? s.push(["expires", i.toUTCString()]) : s.push(["expires", i])), o && s.push(["domain", o]), r && s.push(["path", r]), a && s.push("secure"), n = n || "None", s.push("SameSite", n), x.map(s, function (e) {
                    return c.is_array(e) ? e.join("=") : e;
                  }).join("; ");
                },
                removeCookielikeValue: function removeCookielikeValue(e, t, i, r) {
                  return this.createCookielikeValue(e, t, new Date(0), i, r);
                },
                hasCookielikeValue: function hasCookielikeValue(e, t) {
                  return new RegExp("(?:^|;\\s*)" + encodeURIComponent(t).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(e);
                },
                keysCookielike: function keysCookielike(e) {
                  var t = e.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
                  return x.map(t, decodeURIComponent);
                }
              };
            }), h.define("module:Classes.LocaleAggregator", ["module:Class", "module:Classes.LocaleMixin", "module:Objs"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, [t, function (e) {
                return {
                  constructor: function constructor() {
                    e.constructor.call(this), this.__locales = [];
                  },
                  register: function register(e) {
                    this.__locales.push(e);
                  },
                  _clearLocale: function _clearLocale() {
                    i.iter(this.__locales, function (e) {
                      e.clearLocale();
                    }, this);
                  },
                  _setLocale: function _setLocale(t) {
                    i.iter(this.__locales, function (e) {
                      e.setLocale(t);
                    }, this);
                  }
                };
              }]);
            }), h.define("module:MediaTypes", ["module:Objs", "module:Types"], function (i, t) {
              return {
                getExtension: function getExtension(e) {
                  var t = this.getExtensions(e);
                  return t && i.peek(t);
                },
                getExtensions: function getExtensions(e) {
                  return t.is_string(e) && 0 != e.length && this._getAll()[e.split(";")[0].toLowerCase()] || !1;
                },
                getType: function getType(e) {
                  return t.is_string(e) && this._getAll()[e.split(".").pop().toLowerCase()] || !1;
                },
                _getAll: function _getAll() {
                  return this._DB || (this._DB = i.bidirectionalMap(this._types)), this._DB;
                },
                _types: {
                  "audio/midi": ["midi", "mid", "kar"],
                  "audio/mpeg": ["mp3"],
                  "audio/ogg": ["ogg"],
                  "audio/webm": ["weba"],
                  "audio/x-aac": ["aac"],
                  "audio/x-flac": ["flac"],
                  "audio/x-m4a": ["m4a"],
                  "audio/x-realaudio": ["ra"],
                  "audio/x-wav": ["wav"],
                  "audio/x-ms-wma": ["wma"],
                  "image/gif": ["gif"],
                  "image/jpeg": ["jpeg", "jpg"],
                  "image/png": ["png"],
                  "image/svg+xml": ["svg", "svgz"],
                  "image/tiff": ["tif", "tiff"],
                  "image/vnd.wap.wbmp": ["wbmp"],
                  "image/webp": ["webp"],
                  "image/x-icon": ["ico"],
                  "image/x-jng": ["jng"],
                  "image/x-ms-bmp": ["bmp"],
                  "video/3gpp": ["3gpp", "3gp"],
                  "video/3gpp2": ["3g2"],
                  "video/mp2t": ["ts"],
                  "video/mp4": ["mp4"],
                  "video/mpeg": ["mpeg", "mpg"],
                  "video/quicktime": ["mov"],
                  "video/webm": ["webm"],
                  "video/x-flv": ["flv"],
                  "video/x-m4v": ["m4v"],
                  "video/x-matroska": ["mkv", "mk3d", "mks"],
                  "video/x-mng": ["mng"],
                  "video/x-ms-asf": ["asx", "asf"],
                  "video/x-ms-wmv": ["wmv"],
                  "video/x-msvideo": ["avi"]
                }
              };
            });
          }).call(Scoped), function () {
            var t = this.subScope();
            t.binding("base", "root:BetaJS"), t.binding("module", "root:BetaJS.Browser"), t.define("module:FlashDetect", ["base:Class"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (n) {
                return {
                  constructor: function constructor() {
                    if (n.constructor.call(this), this.__version = null, navigator.plugins && 0 < navigator.plugins.length) {
                      var e = "application/x-shockwave-flash",
                        t = navigator.mimeTypes;
                      t && t[e] && t[e].enabledPlugin && t[e].enabledPlugin.description && (this.__version = this.parseVersion(t[e].enabledPlugin.description));
                    } else if (-1 == navigator.appVersion.indexOf("Mac") && "execScript" in window) for (var i = 0; i < this.__activeXDetectRules.length; i++) try {
                      var r = new ActiveXObject(this.__activeXDetectRules[i].name),
                        o = this.__activeXDetectRules[i].version(r);
                      if (o) {
                        this.__version = this.parseActiveXVersion(o);
                        break;
                      }
                    } catch (a) {}
                  },
                  parseVersion: function parseVersion(e) {
                    var t = e.split(/ +/),
                      i = t[2].split(/\./),
                      r = t[3];
                    return {
                      raw: e,
                      major: parseInt(i[0], 10),
                      minor: parseInt(i[1], 10),
                      revisionStr: r,
                      revision: parseInt(r.replace(/[a-zA-Z]/g, ""), 10)
                    };
                  },
                  parseActiveXVersion: function parseActiveXVersion(e) {
                    var t = e.split(",");
                    return {
                      raw: e,
                      major: parseInt(t[0].split(" ")[1], 10),
                      minor: parseInt(t[1], 10),
                      revision: parseInt(t[2], 10),
                      revisionStr: t[2]
                    };
                  },
                  version: function version() {
                    return this.__version;
                  },
                  installed: function installed() {
                    return null !== this.__version;
                  },
                  supported: function supported() {
                    var e = navigator.userAgent;
                    return this.installed() || !(-1 != e.indexOf("iPhone") || -1 != e.indexOf("iPod") || -1 != e.indexOf("iPad"));
                  },
                  majorAtLeast: function majorAtLeast(e) {
                    return this.installed() && this.version().major >= e;
                  },
                  minorAtLeast: function minorAtLeast(e) {
                    return this.installed() && this.version().minor >= e;
                  },
                  revisionAtLeast: function revisionAtLeast(e) {
                    return this.installed() && this.version().revision >= e;
                  },
                  versionAtLeast: function versionAtLeast(e) {
                    if (!this.installed()) return !1;
                    for (var t = [this.version().major, this.version().minor, this.version().revision], i = Math.min(t.length, arguments.length), r = 0; r < i; r++) if (t[r] != arguments[r]) return arguments[r] < t[r];
                    return !0;
                  },
                  __activeXDetectRules: [{
                    name: "ShockwaveFlash.ShockwaveFlash.7",
                    version: function version(e) {
                      try {
                        return e.GetVariable("$version");
                      } catch (t) {
                        return null;
                      }
                    }
                  }, {
                    name: "ShockwaveFlash.ShockwaveFlash.6",
                    version: function version(e) {
                      try {
                        e.AllowScriptAccess = "always";
                        try {
                          return e.GetVariable("$version");
                        } catch (t) {
                          return null;
                        }
                      } catch (t) {
                        return "6,0,21";
                      }
                    }
                  }, {
                    name: "ShockwaveFlash.ShockwaveFlash",
                    version: function version(e) {
                      try {
                        return e.GetVariable("$version");
                      } catch (t) {
                        return null;
                      }
                    }
                  }]
                };
              });
            }), t.define("module:Info", ["base:Objs", "module:FlashDetect"], function (r, t) {
              return {
                __navigator: null,
                getNavigator: function getNavigator() {
                  return this.__navigator || (this.__navigator = {
                    appCodeName: navigator.appCodeName,
                    appName: navigator.appName,
                    appVersion: navigator.appVersion,
                    cookieEnabled: navigator.cookieEnabled,
                    onLine: navigator.onLine,
                    platform: navigator.platform,
                    userAgent: navigator.userAgent,
                    window_chrome: "undefined" != typeof window && "chrome" in window,
                    window_opera: "undefined" != typeof window && "opera" in window,
                    language: navigator.language || navigator.userLanguage || "",
                    isTouchable: this.isTouchable()
                  }), this.__navigator;
                },
                __cache: {},
                __cached: function __cached(e, t, i) {
                  var r;
                  return e in this.__cache && !i || (r = this.getNavigator(), this.__cache[e] = t.call(this, r, r.userAgent, r.userAgent.toLowerCase())), this.__cache[e];
                },
                setNavigator: function setNavigator(e) {
                  this.__navigator = e, this.__cache = {};
                },
                language: function language() {
                  return this.__cached("language", function (e) {
                    return e.language;
                  });
                },
                flash: function flash(e) {
                  return this.__cached("flash", function () {
                    return new t();
                  }, e);
                },
                isiOS: function isiOS() {
                  return this.__cached("isiOS", function (e, t) {
                    if (this.isInternetExplorer() || this.isIEMobile()) return !1;
                    var i = [t];
                    e.platform && i.push(e.platform);
                    var r = ["iPhone", "iPod", "iPad"];
                    return i.some(function (t) {
                      return r.some(function (e) {
                        return -1 != t.indexOf(e);
                      });
                    }) || e.platform && "MacIntel" === e.platform && e.isTouchable;
                  });
                },
                isEdge: function isEdge() {
                  return this.__cached("isEdge", function (e, t) {
                    return -1 != t.indexOf("Edge");
                  });
                },
                isCordova: function isCordova() {
                  return "undefined" != typeof window && (!!window.cordova || !!window._cordovaNative) || 0 === document.location.href.indexOf("file:///android_asset/www") || 0 === document.location.href.indexOf("file:///var/mobile/Containers/Bundle/Application");
                },
                isLocalCordova: function isLocalCordova() {
                  return this.__cached("isLocalCordova", function () {
                    return this.isCordova() && 0 !== document.location.href.indexOf("http");
                  });
                },
                isChrome: function isChrome() {
                  return this.__cached("isChrome", function (e, t) {
                    return (e.window_chrome || -1 != t.indexOf("CriOS")) && !this.isOpera() && !this.isEdge();
                  });
                },
                isChromium: function isChromium() {
                  return this.__cached("isChromium", function (e, t, i) {
                    return !this.isChrome() && this.isAndroid() && 0 <= i.indexOf("linux");
                  });
                },
                isChromiumBased: function isChromiumBased() {
                  return this.__cached("isChromiumBased", function () {
                    return this.isChrome() || this.isChromium();
                  });
                },
                isOpera: function isOpera() {
                  return this.__cached("isOpera", function (e, t) {
                    return e.window_opera || 0 <= t.indexOf(" OPR/") || 0 <= t.indexOf("OPiOS") || 0 <= t.indexOf("Opera");
                  });
                },
                isAndroid: function isAndroid() {
                  return this.__cached("isAndroid", function (e, t, i) {
                    return -1 != i.indexOf("android");
                  });
                },
                isWebOS: function isWebOS() {
                  return this.__cached("isWebOS", function (e, t, i) {
                    return -1 != i.indexOf("webos");
                  });
                },
                isWindowsPhone: function isWindowsPhone() {
                  return this.__cached("isWindowsPhone", function (e, t, i) {
                    return -1 != i.indexOf("windows phone");
                  });
                },
                isBlackberry: function isBlackberry() {
                  return this.__cached("isBlackberry", function (e, t, i) {
                    return -1 != i.indexOf("blackberry");
                  });
                },
                iOSversion: function iOSversion() {
                  return this.__cached("iOSversion", function (e) {
                    if (!this.isiOS()) return !1;
                    var t = e.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                    return {
                      major: parseInt(t[1], 10),
                      minor: parseInt(t[2], 10),
                      revision: parseInt(t[3] || 0, 10)
                    };
                  });
                },
                androidVersion: function androidVersion() {
                  return this.__cached("androidVersion", function (e) {
                    if (!this.isAndroid()) return !1;
                    var t = e.userAgent.match(/Android (\d+)\.(\d+)\.?(\d+)?/);
                    return {
                      major: parseInt(t[1], 10),
                      minor: parseInt(t[2], 10),
                      revision: parseInt(t[3] || 0, 10)
                    };
                  });
                },
                isMobile: function isMobile() {
                  return this.__cached("isMobile", function () {
                    return this.isiOS() || this.isAndroid() || this.isWebOS() || this.isWindowsPhone() || this.isBlackberry();
                  });
                },
                isDesktop: function isDesktop() {
                  return this.__cached("isDesktop", function () {
                    return !this.isMobile();
                  });
                },
                isInternetExplorer: function isInternetExplorer() {
                  return this.__cached("isInternetExplorer", function () {
                    return !this.isIEMobile() && null !== this.internetExplorerVersion();
                  });
                },
                isIEMobile: function isIEMobile() {
                  return this.__cached("isIEMobile", function (e, t, i) {
                    return 0 <= i.indexOf("iemobile");
                  });
                },
                isFirefox: function isFirefox() {
                  return this.__cached("isFirefox", function (e, t, i) {
                    return -1 != i.indexOf("firefox") || -1 != i.indexOf("fxios");
                  });
                },
                isSafari: function isSafari() {
                  return this.__cached("isSafari", function (e, t, i) {
                    if (!(this.isChrome() || this.isOpera() || this.isEdge() || this.isFirefox() || -1 == i.indexOf("safari") || this.isAndroid())) return !0;
                    if (this.isiOS() && -1 != t.indexOf("Macintosh") && e.platform) {
                      if ("iPad" === e.platform) return !0;
                      if (e.isTouchable && "MacIntel" === e.platform) return !0;
                    }
                    return !1;
                  });
                },
                isWindows: function isWindows() {
                  return this.__cached("isWindows", function (e) {
                    return -1 != e.appVersion.toLowerCase().indexOf("win") && !this.isWindowsPhone();
                  });
                },
                isMacOS: function isMacOS() {
                  return this.__cached("isMacOS", function (e) {
                    return !this.isiOS() && -1 != e.appVersion.toLowerCase().indexOf("mac");
                  });
                },
                isUnix: function isUnix() {
                  return this.__cached("isUnix", function (e) {
                    return -1 != e.appVersion.toLowerCase().indexOf("x11");
                  });
                },
                isLinux: function isLinux() {
                  return this.__cached("isLinux", function (e) {
                    return !this.isAndroid() && -1 != e.appVersion.toLowerCase().indexOf("linux");
                  });
                },
                isTouchable: function isTouchable() {
                  return "undefined" != typeof window && "ontouchstart" in window || 0 < navigator.maxTouchPoints || 0 < navigator.msMaxTouchPoints;
                },
                isScreenRecorderSupported: function isScreenRecorderSupported() {
                  return !("undefined" == typeof navigator.mediaDevices || !(this.isChrome() || this.isFirefox() || this.isOpera() || this.isEdge()) || this.isMobile() || "undefined" == typeof navigator.mediaDevices.getDisplayMedia);
                },
                internetExplorerVersion: function internetExplorerVersion() {
                  return this.__cached("internetExplorerVersion", function (e, t) {
                    if ("Microsoft Internet Explorer" == e.appName) {
                      var i = new RegExp("MSIE ([0-9]+)").exec(t);
                      if (i) return i[1];
                    } else if ("Netscape" == e.appName) {
                      var r = new RegExp("Trident/.*rv:([0-9]+)").exec(e.userAgent);
                      if (r) return parseFloat(r[1]);
                    }
                    return null;
                  });
                },
                chromeVersion: function chromeVersion() {
                  return this.__cached("chromeVersion", function (e, t) {
                    var i = /(Chrome|CriOS)\/(\d+\.\d+)[^\d]/gi.exec(t);
                    return i ? parseFloat(i[2]) : null;
                  });
                },
                operaVersion: function operaVersion() {
                  return this.__cached("operaVersion", function (e, t) {
                    var i = /OPR\/(\d+\.\d+)[^\d]/gi.exec(t);
                    return i ? parseFloat(i[1]) : null;
                  });
                },
                safariVersion: function safariVersion() {
                  return this.__cached("safariVersion", function (e, t) {
                    var i = /Version\/(\d+\.\d+)[^\d]/gi.exec(t);
                    return i ? parseFloat(i[1]) : null;
                  });
                },
                firefoxVersion: function firefoxVersion() {
                  return this.__cached("firefoxVersion", function (e, t) {
                    var i = /Firefox\/(\d+\.\d+)/gi.exec(t);
                    return i ? parseFloat(i[1]) : null;
                  });
                },
                edgeVersion: function edgeVersion() {
                  return this.__cached("edgeVersion", function (e, t) {
                    var i = /Edg\/(\d+\.\d+)|Edge\/(\d+\.\d+)/gi.exec(t);
                    return i ? parseFloat(i[1]) : null;
                  });
                },
                inIframe: function inIframe() {
                  try {
                    return "undefined" != typeof window && window.self !== window.top;
                  } catch (e) {
                    return !0;
                  }
                },
                __devicesMap: {
                  mobile: {
                    format: "Mobile",
                    check: function check() {
                      return this.isMobile();
                    }
                  },
                  desktop: {
                    format: "Desktop",
                    check: function check() {
                      return this.isDesktop();
                    }
                  }
                },
                __obtainMatch: function __obtainMatch(e, t) {
                  var i = null;
                  return r.iter(e, function (e, t) {
                    if (e.check.apply(this)) {
                      if (i) return i = null, !1;
                      delete (i = r.clone(e, 1)).check, i.key = t;
                    }
                  }, this), i || t;
                },
                getDevice: function getDevice() {
                  return this.__cached("getDevice", function () {
                    return this.__obtainMatch(this.__devicesMap, {
                      key: "unknown",
                      format: "Unknown Device"
                    });
                  });
                },
                formatDevice: function formatDevice() {
                  return this.getDevice().format;
                },
                __osMap: {
                  macosx: {
                    format: "Mac OS-X",
                    check: function check() {
                      return this.isMacOS();
                    }
                  },
                  windows: {
                    format: "Windows",
                    check: function check() {
                      return this.isWindows();
                    }
                  },
                  unix: {
                    format: "Unix",
                    check: function check() {
                      return this.isUnix();
                    }
                  },
                  linux: {
                    format: "Linux",
                    check: function check() {
                      return this.isLinux();
                    }
                  },
                  ios: {
                    format: "iOS",
                    check: function check() {
                      return this.isiOS();
                    },
                    version: function version() {
                      return this.iOSversion().major + "." + this.iOSversion().minor + "." + this.iOSversion().revision;
                    }
                  },
                  android: {
                    format: "Android",
                    check: function check() {
                      return this.isAndroid();
                    }
                  },
                  webos: {
                    format: "WebOS",
                    check: function check() {
                      return this.isWebOS();
                    }
                  },
                  windowsphone: {
                    format: "Windows Phone",
                    check: function check() {
                      return this.isWindowsPhone();
                    }
                  },
                  blackberry: {
                    format: "Blackberry",
                    check: function check() {
                      return this.isBlackberry();
                    }
                  }
                },
                getOS: function getOS() {
                  return this.__cached("getOS", function () {
                    return this.__obtainMatch(this.__osMap, {
                      key: "unknown",
                      format: "Unknown Operating System"
                    });
                  });
                },
                formatOS: function formatOS() {
                  return this.getOS().format;
                },
                formatOSVersion: function formatOSVersion() {
                  return this.getOS().version ? this.getOS().version.apply(this) : "";
                },
                __browserMap: {
                  chrome: {
                    format: "Chrome",
                    check: function check() {
                      return this.isChrome();
                    },
                    version: function version() {
                      return this.chromeVersion();
                    }
                  },
                  chromium: {
                    format: "Chromium",
                    check: function check() {
                      return this.isChromium();
                    }
                  },
                  opera: {
                    format: "Opera",
                    check: function check() {
                      return this.isOpera();
                    },
                    version: function version() {
                      return this.operaVersion();
                    }
                  },
                  internetexplorer: {
                    format: "Internet Explorer",
                    check: function check() {
                      return this.isInternetExplorer();
                    },
                    version: function version() {
                      return this.internetExplorerVersion();
                    }
                  },
                  firefox: {
                    format: "Firefox",
                    check: function check() {
                      return this.isFirefox();
                    },
                    version: function version() {
                      return this.firefoxVersion();
                    }
                  },
                  safari: {
                    format: "Safari",
                    check: function check() {
                      return this.isSafari();
                    },
                    version: function version() {
                      return this.safariVersion();
                    }
                  },
                  webos: {
                    format: "WebOS",
                    check: function check() {
                      return this.isWebOS();
                    }
                  },
                  blackberry: {
                    format: "Blackberry",
                    check: function check() {
                      return this.isBlackberry();
                    }
                  },
                  edge: {
                    format: "Edge",
                    check: function check() {
                      return this.isEdge();
                    }
                  },
                  iemobile: {
                    format: "IE Mobile",
                    check: function check() {
                      return this.isIEMobile();
                    }
                  }
                },
                getBrowser: function getBrowser() {
                  return this.__cached("getBrowser", function () {
                    return this.__obtainMatch(this.__browserMap, {
                      key: "unknown",
                      format: "Unknown Browser"
                    });
                  });
                },
                formatBrowser: function formatBrowser() {
                  return this.getBrowser().format;
                },
                formatBrowserVersion: function formatBrowserVersion() {
                  return this.getBrowser().version ? this.getBrowser().version.apply(this) : "";
                },
                formatFlash: function formatFlash() {
                  return this.flash().installed() ? "Flash " + this.flash().version().raw : this.flash().supported() ? "Flash not installed but supported" : "Flash not supported";
                }
              };
            }), t.define("module:Dom", ["base:Types", "base:Objs", "module:Info", "base:Async"], function (s, c, x, a) {
              var d = {
                  tr: ["table", "tbody"],
                  td: ["table", "tbody", "tr"],
                  th: ["table", "thead", "tr"]
                },
                i = ["click", "mousedown", "mouseup", "touchstart", "touchend", "keydown", "keyup", "keypress"],
                r = [],
                o = !1,
                n = function n() {
                  r.forEach(function (e) {
                    e.callback.call(e.context || this);
                  }), o = !(r = []), i.forEach(function (e) {
                    window.removeEventListener(e, n);
                  });
                };
              return {
                ready: function ready(e, t) {
                  var i, r, _o;
                  "complete" === document.readyState || "loading" !== document.readyState && !document.documentElement.doScroll ? a.eventually(e, t) : (i = !1, r = null, _o = function o() {
                    clearInterval(r), document.removeEventListener("DOMContentLoaded", _o), window.removeEventListener("load", _o), i || (i = !0, e.apply(t || this));
                  }, document.addEventListener("DOMContentLoaded", _o), window.addEventListener("load", _o), r = setInterval(function () {
                    "complete" !== document.readyState && ("loading" === document.readyState || document.documentElement.doScroll) || _o();
                  }, 10));
                },
                userInteraction: function userInteraction(e, t) {
                  r.push({
                    callback: e,
                    context: t
                  }), o || (o = !0, i.forEach(function (e) {
                    window.addEventListener(e, n);
                  }));
                },
                isTabHidden: function isTabHidden() {
                  return document.hidden || document.webkitHidden || document.mozHidden || document.msHidden;
                },
                elementsByTemplate: function elementsByTemplate(i) {
                  i = i.trim();
                  var r = x.isInternetExplorer() && x.internetExplorerVersion() < 9,
                    o = [];
                  c.iter(d, function (e, t) {
                    0 === i.indexOf("<" + t) && (o = e, r = !1);
                  });
                  var e = [o.map(function (e) {
                      return "<" + e + ">";
                    }).join(""), r ? "<br/>" : "", i, o.map(function (e) {
                      return "</" + e + ">";
                    }).join("")].join(""),
                    t = document.createElement("div");
                  t.innerHTML = e, o.forEach(function () {
                    t = t.children[0];
                  });
                  for (var a = [], n = r ? 1 : 0; n < t.children.length; ++n) a.push(t.children[n]);
                  return r && (a = a.filter(function (e) {
                    return !(0 === e.tagName.indexOf("/") && 0 <= i.toLowerCase().indexOf("<" + e.tagName.toLowerCase()));
                  })), a;
                },
                elementByTemplate: function elementByTemplate(e, t) {
                  var i = this.elementsByTemplate(e);
                  if (1 === i.length) return i[0];
                  if (0 === i.length || !t) return null;
                  var r = document.createElement("div");
                  return i.forEach(r.appendChild, r), r;
                },
                changeTag: function changeTag(e, t) {
                  for (var i = document.createElement(t), r = 0; r < e.attributes.length; ++r) {
                    var o = e.attributes[r];
                    i.setAttribute(o.nodeName, "value" in o ? o.value : o.nodeValue);
                  }
                  for (; e.firstChild;) i.appendChild(e.firstChild);
                  return e.parentNode && e.parentNode.replaceChild(i, e), i;
                },
                traverseNext: function traverseNext(e, t) {
                  return (e = this.unbox(e)).firstChild && !t ? e.firstChild : e.parentNode ? e.nextSibling ? e.nextSibling : this.traverseNext(e.parentNode, !0) : null;
                },
                splitNode: function splitNode(e, t, i) {
                  return t = t || 0, (i = i || (e.wholeText ? e.wholeText.length : 0)) < (e.wholeText ? e.wholeText.length : 0) && e.splitText(i), 0 < t && (e = e.splitText(t)), e;
                },
                __FULLSCREEN_EVENTS: ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"],
                __FULLSCREEN_METHODS: ["requestFullscreen", "webkitRequestFullscreen", "mozRequestFullScreen", "msRequestFullscreen", "webkitEnterFullScreen"],
                __FULLSCREEN_ATTRS: ["fullscreenElement", "webkitFullscreenElement", "mozFullScreenElement", "msFullscreenElement"],
                __FULLSCREEN_EXIT_METHODS: ["exitFullscreen", "mozCancelFullScreen", "webkitExitFullscreen", "msExitFullscreen"],
                elementSupportsFullscreen: function elementSupportsFullscreen(t) {
                  return t && this.__FULLSCREEN_METHODS.some(function (e) {
                    return e in t;
                  });
                },
                elementEnterFullscreen: function elementEnterFullscreen(t) {
                  var i = !1;
                  this.__FULLSCREEN_METHODS.forEach(function (e) {
                    !i && e in t && (t[e].call(t), i = !0);
                  });
                },
                documentExitFullscreen: function documentExitFullscreen() {
                  this.__FULLSCREEN_EXIT_METHODS.forEach(function (e) {
                    document[e] && document[e]();
                  });
                },
                elementIsFullscreen: function elementIsFullscreen(t) {
                  return this.__FULLSCREEN_ATTRS.some(function (e) {
                    return document[e] === t;
                  });
                },
                elementOnFullscreenChange: function elementOnFullscreenChange(t, e, i) {
                  var r = this,
                    o = function o() {
                      e.call(i || this, t, r.elementIsFullscreen(t));
                    };
                  return this.__FULLSCREEN_EVENTS.forEach(function (e) {
                    t.addEventListener(e, o, !1);
                  }), o;
                },
                elementOffFullscreenChange: function elementOffFullscreenChange(t, i) {
                  this.__FULLSCREEN_EVENTS.forEach(function (e) {
                    t.removeEventListener(e, i, !1);
                  });
                },
                __PIP_EVENTS: ["enterpictureinpicture", "leavepictureinpicture"],
                browserSupportsPIP: function browserSupportsPIP(e) {
                  return e = e || HTMLVideoElement.prototype || {}, "pictureInPictureEnabled" in document || !!(x.isMacOS() && 9 <= x.safariVersion()) && !(!e.webkitSupportsPresentationMode || "function" != typeof e.webkitSetPresentationMode);
                },
                videoElementEnterPIPMode: function videoElementEnterPIPMode(e) {
                  if (e && e instanceof HTMLVideoElement) {
                    if (e = e || HTMLVideoElement.prototype || {}, "pictureInPictureElement" in document && !document.pictureInPictureElement && "function" == typeof e.requestPictureInPicture) try {
                      e.requestPictureInPicture();
                    } catch (t) {
                      console.warn(t);
                    }
                    x.isMacOS() && 9 <= x.safariVersion() && "function" == typeof e.webkitSetPresentationMode && e.webkitSetPresentationMode("picture-in-picture");
                  }
                },
                videoElementExitPIPMode: function videoElementExitPIPMode(e) {
                  if (e = e || HTMLVideoElement.prototype || {}, "pictureInPictureElement" in document && document.pictureInPictureElement && "function" == typeof document.exitPictureInPicture) try {
                    document.exitPictureInPicture();
                  } catch (t) {
                    console.warn(t);
                  }
                  x.isMacOS() && 9 <= x.safariVersion() && "function" == typeof e.webkitSetPresentationMode && e.webkitSetPresentationMode("inline");
                },
                videoIsInPIPMode: function videoIsInPIPMode(e) {
                  return "pictureInPictureElement" in document ? !!document.pictureInPictureElement : x.isMacOS() && 9 <= x.safariVersion() ? "picture-in-picture" === e.webkitPresentationMode : void 0;
                },
                videoAddPIPChangeListeners: function videoAddPIPChangeListeners(t, e, i) {
                  if (!(t && t instanceof HTMLVideoElement)) return null;
                  var r = this,
                    o = function o() {
                      e.call(i || this, t, r.videoIsInPIPMode(t));
                    };
                  return this.__PIP_EVENTS.forEach(function (e) {
                    t.addEventListener(e, o, !1);
                  }), o;
                },
                videoRemovePIPChangeListeners: function videoRemovePIPChangeListeners(t) {
                  if (!(t && t instanceof HTMLVideoElement)) return null;
                  this.__PIP_EVENTS.forEach(function (e) {
                    t.removeEventListener(e, t);
                  });
                },
                entitiesToUnicode: function entitiesToUnicode(e) {
                  return !e || !s.is_string(e) || e.indexOf("&") < 0 ? e : e.split(">").map(function (e) {
                    return e.split("<").map(function (e) {
                      var t = document.createElement("span");
                      return t.innerHTML = e, e = t.textContent || t.innerText, t.remove && t.remove(), e;
                    }).join("<");
                  }).join(">");
                },
                unbox: function unbox(e) {
                  return s.is_string(e) && (e = document.querySelector(e)), !e || e.nodeType ? e : e.get(0);
                },
                triggerDomEvent: function triggerDomEvent(t, i, r, o) {
                  t = this.unbox(t);
                  var a,
                    n = "on" + (i = i.toLowerCase()),
                    s = null,
                    x = !1;
                  t[n] && (s = t[n], t[n] = function () {
                    x || (x = !0, s.apply(this, arguments));
                  });
                  try {
                    try {
                      a = o ? new CustomEvent(i, o) : new Event(i);
                    } catch (e) {
                      try {
                        o ? (a = document.createEvent("CustomEvent")).initCustomEvent(i, o.bubbles || !1, o.cancelable || !1, o.detail || !1) : (a = document.createEvent("Event")).initEvent(i, !1, !1);
                      } catch (e) {
                        (a = document.createEventObject()).type = i;
                      }
                    }
                    c.extend(a, r), t.dispatchEvent(a), s && (x || s.call(t, a), t[n] = s);
                  } catch (e) {
                    throw s && (t[n] = s), e;
                  }
                },
                elementOffset: function elementOffset(e) {
                  var t,
                    i = 0,
                    r = 0;
                  return (e = this.unbox(e)).getBoundingClientRect && (i = (t = e.getBoundingClientRect()).top, r = t.left - (document.body.getBoundingClientRect ? document.body.getBoundingClientRect().left : 0)), docElem = document.documentElement, {
                    top: i + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
                    left: r + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0)
                  };
                },
                getRelativeCoordinates: function getRelativeCoordinates(e, t) {
                  for (var i = e.pageX, r = e.pageY, o = {
                      left: t.offsetLeft,
                      top: t.offsetTop
                    }, a = t.offsetParent; null != a;) o.left += a.offsetLeft, o.top += a.offsetTop, a = a.offsetParent;
                  return {
                    x: i - o.left,
                    y: r - o.top
                  };
                },
                elementDimensions: function elementDimensions(t) {
                  var i;
                  if ((t = this.unbox(t)) && window.getComputedStyle) {
                    try {
                      i = window.getComputedStyle(t);
                    } catch (e) {}
                    if (i && (r = parseInt(i.width, 10), a = parseInt(i.height, 10), r && a)) return {
                      width: r,
                      height: a
                    };
                  }
                  if (t && t.currentStyle && (i = t.currentStyle, r = t.clientWidth - parseInt(i.paddingLeft || 0, 10) - parseInt(i.paddingRight || 0, 10), a = t.clientHeight - parseInt(i.paddingTop || 0, 10) - parseInt(i.paddingTop || 0, 10), r && a)) return {
                    width: r,
                    height: a
                  };
                  if (t && t.getBoundingClientRect) {
                    var r,
                      o = t.getBoundingClientRect(),
                      a = o.bottom - o.top;
                    return {
                      width: r = o.right - o.left,
                      height: a
                    };
                  }
                  return {
                    width: 0,
                    height: 0
                  };
                },
                childContainingElement: function childContainingElement(e, t) {
                  for (e = this.unbox(e), t = this.unbox(t); t.parentNode != e;) {
                    if (t == document.body) return null;
                    t = t.parentNode;
                  }
                  return t;
                },
                elementBoundingBox: function elementBoundingBox(e) {
                  var t = this.elementOffset(e),
                    i = this.elementDimensions(e);
                  return {
                    left: t.left,
                    top: t.top,
                    right: t.left + i.width - 1,
                    bottom: t.top + i.height - 1
                  };
                },
                pointWithinElement: function pointWithinElement(e, t, i) {
                  var r = this.elementBoundingBox(i);
                  return r.left <= e && e <= r.right && r.top <= t && t <= r.bottom;
                },
                elementFromPoint: function elementFromPoint(e, t, i, r) {
                  i = i || [], s.is_array(i) || (i = [i]);
                  for (var o = [], a = 0; a < i.length; ++a) i[a] = this.unbox(i[a]), o.push(i[a].style.zIndex), i[a].style.zIndex = -1;
                  for (var n = document.elementFromPoint(e - window.pageXOffset, t - window.pageYOffset), a = 0; a < i.length; ++a) i[a].style.zIndex = o[a];
                  for (; n && r && n.parentNode !== r;) n = n.parentNode;
                  return n;
                },
                elementAddClass: function elementAddClass(e, t) {
                  e.className ? this.elementHasClass(e, t) || (e.className = e.className + " " + t) : e.className = t;
                },
                elementHasClass: function elementHasClass(e, t) {
                  return e.className.split(" ").some(function (e) {
                    return e === t;
                  });
                },
                elementRemoveClass: function elementRemoveClass(e, t) {
                  e.className = e.className.split(" ").filter(function (e) {
                    return e !== t;
                  }).join(" ");
                },
                elementInsertBefore: function elementInsertBefore(e, t) {
                  t.parentNode.insertBefore(e, t);
                },
                elementInsertAfter: function elementInsertAfter(e, t) {
                  t.nextSibling ? t.parentNode.insertBefore(e, t.nextSibling) : t.parentNode.appendChild(e);
                },
                elementInsertAt: function elementInsertAt(e, t, i) {
                  i >= t.children.length ? t.appendChild(e) : t.insertBefore(e, t.children[Math.max(0, i)]);
                },
                elementIndex: function elementIndex(e) {
                  for (var t = 0; e.previousElementSibling;) t++, e = e.previousElementSibling;
                  return t;
                },
                elementPrependChild: function elementPrependChild(e, t) {
                  0 < e.children.length ? e.insertBefore(t, e.firstChild) : e.appendChild(t);
                },
                elementFindClosestParent: function elementFindClosestParent(e, t, i) {
                  for (var r = null; e;) {
                    if (-1 < e.className.indexOf(t)) {
                      r = e;
                      break;
                    }
                    if (i && -1 < e.className.indexOf(i)) break;
                    e = e.parentElement;
                  }
                  return r;
                },
                elementReplaceClasses: function elementReplaceClasses(e, t, i) {
                  this.elementHasClass(e, t) && (this.elementRemoveClass(e, t), this.elementAddClass(e, i));
                },
                isElementVisible: function isElementVisible(e, t) {
                  t = t || .8;
                  var i = this.elementOffset(e),
                    r = i.left,
                    o = i.top,
                    a = e.offsetWidth,
                    n = e.offsetHeight,
                    s = r + a,
                    x = o + n;
                  return t < Math.max(0, Math.min(a, window.pageXOffset + window.innerWidth - r, s - window.pageXOffset)) * Math.max(0, Math.min(n, window.pageYOffset + window.innerHeight - o, x - window.pageYOffset)) / (a * n);
                },
                keyboardUnfocus: function keyboardUnfocus() {
                  document.activeElement && document.activeElement.blur();
                },
                passiveEventsSupported: function passiveEventsSupported() {
                  return x.isiOS();
                },
                containerStickyBottom: function containerStickyBottom(i) {
                  var r = i.scrollHeight,
                    o = !1,
                    e = new MutationObserver(function () {
                      var e, t;
                      o || (o = !0, e = i.scrollHeight, (t = r) < (r = e) && (i.scrollTop = i.scrollTop + e - t), o = !1);
                    });
                  return e.observe(i, {
                    childList: !0,
                    subtree: !0,
                    attributes: !0,
                    characterData: !0
                  }), e;
                },
                isInputLikeElement: function isInputLikeElement(e) {
                  return "TEXTAREA" === e.nodeName || "INPUT" === e.nodeName;
                },
                copyStringToClipboard: function copyStringToClipboard(e) {
                  var t = document.createElement("input");
                  t.style.display = "none", document.body.appendChild(t), t.value = e, this.copyInputValueToClipboard(t), document.body.removeChild(t);
                },
                copyInputValueToClipboard: function copyInputValueToClipboard(e) {
                  if (document.body.createTextRange) {
                    var t = document.body.createTextRange();
                    return t.moveToElementText(e), t.select(), t.execCommand("Copy");
                  }
                  if (window.getSelection && document.createRange) {
                    var i = e.contentEditable,
                      r = e.readOnly;
                    e.contentEditable = !0, e.readOnly = !1;
                    var o = document.createRange();
                    o.selectNodeContents(e);
                    var a = window.getSelection();
                    return a.removeAllRanges(), a.addRange(o), this.isInputLikeElement(e) && e.select(), x.isiOS() && e.setSelectionRange(0, 999999), e.contentEditable = i, e.readOnly = r, document.execCommand("copy");
                  }
                  return !1;
                }
              };
            }), t.define("module:Events", ["base:Class", "base:Objs", "base:Functions", "module:Dom"], function (e, t, n, s, i) {
              return e.extend({
                scoped: i
              }, function (e) {
                return {
                  constructor: function constructor() {
                    e.constructor.call(this), this.__callbacks = {};
                  },
                  destroy: function destroy() {
                    this.clear(), e.destroy.call(this);
                  },
                  on: function on(i, e, r, o, a) {
                    return e.split(" ").forEach(function (e) {
                      var t;
                      e && (t = n.as_method(r, o || i), i.addEventListener(e, t, !(!a || !s.passiveEventsSupported()) && a), this.__callbacks[e] = this.__callbacks[e] || [], this.__callbacks[e].push({
                        element: i,
                        callback_function: t,
                        callback: r,
                        context: o
                      }));
                    }, this), this;
                  },
                  off: function off(o, e, a, n) {
                    return e.split(" ").forEach(function (e) {
                      if (e) {
                        var t = this.__callbacks[e];
                        if (t) for (var i = 0; i < t.length;) {
                          var r = t[i];
                          o && o !== r.element || a && a !== r.callback || n && n !== r.context ? ++i : (r.element.removeEventListener(e, r.callback_function, !1), t[i] = t[t.length - 1], t.pop());
                        }
                      }
                    }, this), this;
                  },
                  clear: function clear() {
                    t.iter(this.__callbacks, function (e, t) {
                      e.forEach(function (e) {
                        e.element.removeEventListener(t, e.callback_function, !1);
                      });
                    }), this.__callbacks = {};
                  }
                };
              });
            }), t.define("module:Upload.FileUploader", ["base:Classes.ConditionalInstance", "base:Events.EventsMixin", "base:Objs", "base:Types", "base:Async", "base:Promise"], function (t, i, r, o, a, n, s) {
              return t.extend({
                scoped: s
              }, [i, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e), this._uploaded = 0, this._state = "idle";
                  },
                  _setState: function _setState(e, t, i) {
                    this._state = e, this.trigger(e, t, i), this.trigger("state", e, t, i);
                  },
                  state: function state() {
                    return this._state;
                  },
                  data: function data() {
                    return this._data;
                  },
                  progress: function progress() {
                    return {
                      uploaded: this._uploaded,
                      total: this._total
                    };
                  },
                  reset: function reset() {
                    "error" === this.state() && (this._setState("idle"), delete this._data, this._uploaded = 0, delete this._total, delete this._request);
                  },
                  upload: function upload() {
                    return "idle" !== this.state() || (this._setState("uploading"), this.__upload()), this;
                  },
                  __upload: function __upload() {
                    this._upload(), this._options.resilience--;
                  },
                  _upload: function _upload() {},
                  _progressCallback: function _progressCallback(e, t) {
                    "uploading" === this.state() && (this._uploaded = e, this._total = t, this.trigger("progress", e, t));
                  },
                  _successCallback: function _successCallback(e) {
                    "uploading" === this.state() && (this._data = e, this._setState("success", e, this._request));
                  },
                  _errorCallback: function _errorCallback(t) {
                    if ("uploading" === this.state()) {
                      try {
                        t.data && (t = t.data()), o.is_string(t) && (t = JSON.parse(t));
                      } catch (e) {}
                      0 < this._options.resilience && (!this._options.resilienceCheck || this._options.resilienceCheck(t)) ? a.eventually(function () {
                        this.__upload();
                      }, this, this._options.resilience_delay) : this._options.essential ? (this._data = t, this._setState("error", t, this._request)) : this._successCallback({});
                    }
                  },
                  uploadedBytes: function uploadedBytes() {
                    return this._uploaded;
                  },
                  totalBytes: function totalBytes() {
                    return this._total ? this._total : this._options.source ? !this._options.isBlob && this._options.source.files && this._options.source.files[0] ? this._options.source.files[0].size : this._options.source.size || 0 : 0;
                  }
                };
              }], {
                _initializeOptions: function _initializeOptions(e) {
                  return e = e || {}, r.extend({
                    method: "POST",
                    serverSupportChunked: !1,
                    serverSupportPostMessage: !1,
                    isBlob: "undefined" != typeof window.Blob && e.source instanceof window.Blob,
                    resilience: 1,
                    resilience_delay: 1e3,
                    essential: !0,
                    data: {}
                  }, e);
                }
              });
            }), t.define("module:Upload.FormDataFileUploader", ["module:Upload.FileUploader", "module:Info", "base:Ajax.Support", "base:Objs", "base:Types"], function (t, i, r, o, a, n) {
              return t.extend({
                scoped: n
              }, {
                _upload: function _upload() {
                  var e = o.clone(a.is_empty(this._options.data) ? {} : this._options.data, 1);
                  return e.file = this._options.isBlob ? this._options.source : this._options.source.files[0], this._request = r.create(), r.execute({
                    method: this._options.method,
                    uri: this._options.url,
                    decodeType: "text",
                    data: e,
                    noFormData: this._options.noFormData
                  }, this._progressCallback, this, this._request).success(this._successCallback, this).error(this._errorCallback, this);
                }
              }, {
                supported: function supported(t) {
                  if (i.isInternetExplorer() && i.internetExplorerVersion() <= 9 || i.isCordova() && ("localURL" in t.source || "fullPath" in t.source)) return !1;
                  try {
                    new window.FormData();
                  } catch (e) {
                    return !1;
                  }
                  return !0;
                }
              });
            }), t.define("module:Upload.FormIframeFileUploader", ["module:Upload.FileUploader", "base:Net.Uri", "base:Objs", "base:Async"], function (t, p, b, m, i) {
              return t.extend({
                scoped: i
              }, {
                _upload: function _upload() {
                  var r = this,
                    o = document.createElement("iframe"),
                    t = "upload-iframe-" + this.cid();
                  o.id = t, o.name = t, o.style.display = "none";
                  var a = document.createElement("form");
                  a.method = this._options.method, a.target = t, a.style.display = "none", document.body.appendChild(o), document.body.appendChild(a);
                  var n = this._options.source.parent;
                  a.appendChild(this._options.source), this._options.source.name || (this._options.source.name = "file"), b.iter(this._options.data, function (e, t) {
                    var i = document.createElement("input");
                    i.type = "hidden", i.name = t, i.value = e, a.appendChild(i);
                  }, this);
                  var s = !("postMessage" in window),
                    i = null,
                    x = function x(e) {
                      i(e.data);
                    };
                  o.onerror = function () {
                    s && (window.postMessage = null), window.removeEventListener("message", x, !1), n && n.appendChild(r._options.source), document.body.removeChild(a), document.body.removeChild(o), r._errorCallback();
                  };
                  var c = this._options.serverPostMessageKey || "_postmessage",
                    d = this._options.serverPostMessageIdKey || "_postmessageid",
                    l = this.cid(),
                    u = this._options.serverSupportPostMessageId,
                    h = {};
                  h[c] = !0, u && (h[d] = l), a.action = p.appendUriParams(this._options.url, h), a.encoding = a.enctype = "multipart/form-data", i = function i(t) {
                    try {
                      var i = JSON.parse(t);
                      if (u && i[d] !== l) return;
                      s && (window.postMessage = null), n && n.appendChild(r._options.source), document.body.removeChild(a), document.body.removeChild(o), r._successCallback(i), m.eventually(function () {
                        window.removeEventListener("message", x, !1);
                      });
                    } catch (e) {}
                  }, window.addEventListener("message", x, !1), s && (window.postMessage = i), a.submit();
                }
              }, {
                supported: function supported(e) {
                  return !e.isBlob && e.serverSupportPostMessage;
                }
              });
            }), t.define("module:Upload.CordovaFileUploader", ["module:Upload.FileUploader", "module:Info", "base:Promise", "base:Ajax.Support", "base:Objs"], function (e, r, o, a, n, t) {
              return e.extend({
                scoped: t
              }, {
                _acquirePermission: function _acquirePermission() {
                  var t,
                    i = o.create();
                  return r.isAndroid() ? (t = cordova.plugins.permissions).checkPermission(t.READ_EXTERNAL_STORAGE, function (e) {
                    e.hasPermission ? i.asyncSuccess(!0) : t.requestPermission(t.READ_EXTERNAL_STORAGE, function (e) {
                      e.hasPermission ? i.asyncSuccess(!0) : i.asyncError("Access to storage was not granted");
                    }, function () {
                      i.asyncError("Could not request storage permission");
                    });
                  }, function () {
                    i.asyncError("Could not check storage permission");
                  }) : i.asyncSuccess(!0), i;
                },
                _upload: function _upload() {
                  return this._acquirePermission().mapSuccess(function () {
                    return window.resolveLocalFileSystemURL ? this._uploadWithLocalFileSystem() : this._uploadWithPlugin();
                  }, this);
                },
                _uploadWithPlugin: function _uploadWithPlugin() {
                  var t = this,
                    e = this._options.source.fullPath.split(":")[1],
                    i = new window.FileUploadOptions();
                  i.fileKey = "file", i.fileName = e.substr(e.lastIndexOf("/") + 1), i.mimeType = this._options.source.type, i.httpMethod = this._options.method, i.params = this._options.data, new window.FileTransfer().upload(e, this._options.url, function (e) {
                    t._successCallback(e);
                  }, function (e) {
                    t._errorCallback(e);
                  }, i);
                },
                _uploadWithLocalFileSystem: function _uploadWithLocalFileSystem() {
                  var i = this,
                    e = this._options.source.fullPath;
                  window.resolveLocalFileSystemURL(e, function (e) {
                    e.file(function (e) {
                      var t = new FileReader();
                      t.onloadend = function () {
                        var e = new Blob([new Uint8Array(this.result)], {
                            type: i._options.source.type
                          }),
                          t = n.clone(i._options.data || {}, 1);
                        return t.file = e, a.execute({
                          method: i._options.method,
                          uri: i._options.url,
                          decodeType: "text",
                          data: t
                        }, i._progressCallback, i).success(i._successCallback, i).error(i._errorCallback, i);
                      }, t.readAsArrayBuffer(e);
                    }, function (e) {
                      i._errorCallback(e);
                    });
                  }, function (e) {
                    i._errorCallback(e);
                  });
                }
              }, {
                supported: function supported(e) {
                  return !(!navigator.device || !navigator.device.capture || !navigator.device.capture.captureVideo || !(window.resolveLocalFileSystemURL || window.FileTransfer && window.FileUploadOptions) || e.isBlob || !("localURL" in e.source || "fullPath" in e.source));
                }
              });
            }), t.define("module:Upload.MultiUploader", ["module:Upload.FileUploader", "base:Objs"], function (e, o, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e), this._uploaders = {}, this._uploadLimit = this._options.uploadLimit || 5, this._uploadingCount = 0, this._end = !this._options.manualEnd;
                  },
                  end: function end() {
                    this._end = !0, this._updateState();
                  },
                  addUploader: function addUploader(e) {
                    return (this._uploaders[e.cid()] = e).on("state", this._updateState, this), e.on("progress", this._updateProgress, this), "uploading" === this.state() && ("error" === e.state() && e.reset(), "idle" === e.state() && this._uploadingCount < this._uploadLimit && (this._uploadingCount++, e.upload())), this;
                  },
                  _upload: function _upload() {
                    o.iter(this._uploaders, function (e) {
                      "error" === e.state() && e.reset(), "idle" === e.state() && this._uploadingCount < this._uploadLimit && (this._uploadingCount++, e.upload());
                    }, this), this._updateState();
                  },
                  _updateState: function _updateState() {
                    var i, t, r;
                    "uploading" === this.state() && (this._uploadingCount = 0, i = !1, t = 0, o.iter(this._uploaders, function (e) {
                      switch (e.state()) {
                        case "uploading":
                          this._uploadingCount++;
                          break;
                        case "error":
                          i = !0;
                          break;
                        case "idle":
                          t++;
                      }
                    }, this), 0 < t && this._uploadingCount < this._uploadLimit && o.iter(this._uploaders, function (e) {
                      this._uploadingCount < this._uploadLimit && "idle" === e.state() && (e.upload(), t--, this._uploadingCount++);
                    }, this), 0 < this._uploadingCount || this._end && (r = [], o.iter(this._uploaders, function (e) {
                      var t = i && "error" === e.state() || !i && "success" === e.state() ? e.data() : undefined;
                      r.push(t);
                    }, this), 0 < i ? this._errorCallback(r) : this._successCallback(r)));
                  },
                  _updateProgress: function _updateProgress() {
                    "uploading" === this.state() && this._progressCallback(this.uploadedBytes(), this.totalBytes());
                  },
                  uploadedBytes: function uploadedBytes() {
                    var t = 0;
                    return o.iter(this._uploaders, function (e) {
                      t += e.uploadedBytes();
                    }, this), t;
                  },
                  totalBytes: function totalBytes() {
                    var t = 0;
                    return o.iter(this._uploaders, function (e) {
                      t += e.totalBytes();
                    }, this), t;
                  }
                };
              });
            }), t.define("module:Blobs", ["base:Promise"], function (o) {
              return {
                createBlobByArrayBufferView: function createBlobByArrayBufferView(e, t, i, r) {
                  try {
                    return new window.Blob([new DataView(e, t, i)], {
                      type: r
                    });
                  } catch (a) {
                    try {
                      return new window.Blob([new Uint8Array(e, t, i)], {
                        type: r
                      });
                    } catch (n) {
                      var o = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder)();
                      return o.append(e.slice(t, t + i)), o.getBlob(r);
                    }
                  }
                },
                loadFileIntoArrayBuffer: function loadFileIntoArrayBuffer(e) {
                  var t = o.create();
                  try {
                    var i = new FileReader();
                    i.onloadend = function (e) {
                      t.asyncSuccess(e.target.result);
                    }, i.readAsArrayBuffer(e.files ? e.files[0] : e);
                  } catch (r) {
                    t.asyncError(r);
                  }
                  return t;
                },
                loadFileIntoString: function loadFileIntoString(e) {
                  var t = o.create();
                  try {
                    var i = new FileReader();
                    i.onloadend = function (e) {
                      t.asyncSuccess(e.target.result);
                    }, i.readAsText(e.files ? e.files[0] : e);
                  } catch (r) {
                    t.asyncError(r);
                  }
                  return t;
                }
              };
            }), t.define("module:Upload.ChunkedFileUploader", ["module:Upload.FileUploader", "module:Upload.MultiUploader", "module:Blobs", "base:Promise", "base:Objs", "base:Tokens", "base:Ajax.Support"], function (s, i, x, e, c, r, d, t) {
              return s.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e), this._multiUploader = new i({
                      uploadLimit: this._options.uploadLimit
                    }), this._options.identifierParameter = this._options.identifierParameter || "identifier", this._options.chunks = c.extend({
                      size: 1e6,
                      chunkNumberParameter: "chunknumber"
                    }, this._options.chunks), this._options.assembly = c.extend({
                      fileNameParameter: "filename",
                      totalSizeParameter: "totalsize",
                      chunkNumberParameter: "chunknumber",
                      fileTypeParameter: "filetype",
                      ajaxOptions: null
                    }, this._options.assembly);
                  },
                  destroy: function destroy() {
                    this._multiUploader.destroy(), t.destroy.call(this);
                  },
                  reset: function reset() {
                    t.reset.call(this), this._multiUploader.destroy(), this._multiUploader = new i({
                      uploadLimit: this._options.uploadLimit
                    });
                  },
                  __generateIdentifier: function __generateIdentifier() {
                    return r.generate_token();
                  },
                  _upload: function _upload() {
                    var a = this.__generateIdentifier(),
                      n = this._options.isBlob ? this._options.source : this._options.source.files[0];
                    x.loadFileIntoArrayBuffer(n).success(function (e) {
                      for (var t = 0; t * this._options.chunks.size < n.size;) {
                        var i = {};
                        i[this._options.chunks.chunkNumberParameter] = t + 1, i[this._options.identifierParameter] = a;
                        var r = t * this._options.chunks.size,
                          o = Math.min(this._options.chunks.size, n.size - r);
                        this._multiUploader.addUploader(this._multiUploader.auto_destroy(s.create({
                          url: this._options.chunks.url || this._options.url,
                          source: x.createBlobByArrayBufferView(e, r, o, n.type),
                          data: c.extend(i, this._options.data)
                        }))), t++;
                      }
                      this._multiUploader.on("error", function (e) {
                        this._errorCallback(e);
                      }, this).on("progress", function (e, t) {
                        this._progressCallback(e, t);
                      }, this).on("success", function () {
                        var e = {};
                        e[this._options.identifierParameter] = a, e[this._options.assembly.fileNameParameter] = n.name || "blob", e[this._options.assembly.totalSizeParameter] = n.size, e[this._options.assembly.chunkNumberParameter] = t, e[this._options.assembly.fileTypeParameter] = n.type, d.execute(c.extend({
                          method: this._options.method,
                          uri: this._options.assembly.url || this._options.url,
                          data: c.extend(e, this._options.data)
                        }, this._options.assembly.ajaxOptions)).success(function () {
                          this._successCallback();
                        }, this).error(function (e) {
                          this._errorCallback(e);
                        }, this);
                      }, this), this._multiUploader.upload();
                    }, this);
                  }
                };
              }, {
                supported: function supported(e) {
                  return "undefined" != typeof window.Blob && "undefined" != typeof FileReader && "undefined" != typeof DataView && e.serverSupportsChunked;
                }
              });
            }), t.extend("module:Upload.FileUploader", ["module:Upload.FileUploader", "module:Upload.FormDataFileUploader", "module:Upload.FormIframeFileUploader", "module:Upload.CordovaFileUploader", "module:Upload.ChunkedFileUploader"], function (e, t, i, r, o) {
              return e.register(t, 2), e.register(i, 1), e.register(r, 4), e.register(o, 5), {};
            }), t.define("module:Loader", ["base:Ajax.Support", "module:Info"], function (r, o) {
              return {
                loadScript: function loadScript(e, t, i) {
                  var r = !1,
                    o = document.getElementsByTagName("head")[0],
                    a = document.createElement("script");
                  a.src = e, a.onload = a.onreadystatechange = function () {
                    r || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (r = !0, a.onload = a.onreadystatechange = null, t && t.call(i || this, e));
                  }, o.appendChild(a);
                },
                loadStyles: function loadStyles(e, t, i) {
                  var r = !1,
                    o = document.getElementsByTagName("head")[0],
                    a = document.createElement("link");
                  a.rel = "stylesheet", a.href = e, a.onload = a.onreadystatechange = function () {
                    r || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (r = !0, a.onload = a.onreadystatechange = null, t && t.call(i || this, e));
                  }, o.appendChild(a);
                },
                inlineStyles: function inlineStyles(e) {
                  var t = document.getElementsByTagName("head")[0],
                    i = document.createElement("style");
                  return o.isInternetExplorer() && o.internetExplorerVersion() < 9 ? (i.setAttribute("type", "text/css"), i.styleSheet.cssText = e) : i.textContent = e, t.appendChild(i), i;
                },
                loadHtml: function loadHtml(t, i, e) {
                  r.execute({
                    uri: t,
                    decodeType: "html"
                  }).success(function (e) {
                    i.call(this, e, t);
                  }, e);
                },
                findScript: function findScript(e) {
                  for (var t = 0; t < document.scripts.length; ++t) if (0 <= document.scripts[t].src.toLowerCase().indexOf(e.toLowerCase())) return document.scripts[t];
                  return null;
                },
                loadByIframe: function loadByIframe(r, o, a) {
                  var n = document.createElement("iframe");
                  r.visible ? (n.style.border = "none", n.style.width = "1px", n.style.height = "1px") : n.style.display = "none";
                  var t = function t() {
                    var t = null,
                      i = null;
                    try {
                      i = (t = n.contentDocument.body).textContent || t.innerText;
                    } catch (e) {}
                    o.call(a || this, i, t, n), r.remove && document.body.removeChild(n);
                  };
                  n.attachEvent ? n.attachEvent("onload", t) : n.onload = t, n.src = r.url, document.body.appendChild(n);
                }
              };
            }), t.define("module:Upload.CustomUploader", ["module:Upload.FileUploader"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                _upload: function _upload() {
                  this.trigger("upload", this._options);
                },
                progressCallback: function progressCallback(e, t) {
                  this._progressCallback(e, t);
                },
                successCallback: function successCallback(e) {
                  this._successCallback(e);
                },
                errorCallback: function errorCallback(e) {
                  this._errorCallback(e);
                }
              });
            }), t.define("module:DomMutation.NodeRemoveObserver", ["base:Classes.ConditionalInstance", "base:Events.EventsMixin"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, [t, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this._node = e;
                  },
                  _nodeRemoved: function _nodeRemoved(e) {
                    e === this._node && this.trigger("node-removed");
                  }
                };
              }]);
            }), t.define("module:DomMutation.MutationObserverNodeRemoveObserver", ["module:DomMutation.NodeRemoveObserver", "base:Objs"], function (t, r, i) {
              return t.extend({
                scoped: i
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e);
                    var i = this;
                    this._observer = new window.MutationObserver(function (e) {
                      r.iter(e, function (e) {
                        for (var t = 0; t < e.removedNodes.length; ++t) i._nodeRemoved(e.removedNodes[t]);
                      });
                    }), this._observer.observe(e.parentNode, {
                      childList: !0
                    });
                  },
                  destroy: function destroy() {
                    this._observer.disconnect(), t.destroy.call(this);
                  }
                };
              }, {
                supported: function supported(t) {
                  try {
                    return !!window.MutationObserver;
                  } catch (e) {
                    return !1;
                  }
                }
              });
            }), t.define("module:DomMutation.DOMNodeRemovedNodeRemoveObserver", ["module:DomMutation.NodeRemoveObserver", "module:Info", "module:Events"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e), this.auto_destroy(new i()).on(document, "DOMNodeRemoved", function (e) {
                      this._nodeRemoved(e.target);
                    }, this);
                  }
                };
              }, {
                supported: function supported(e) {
                  return !t.isInternetExplorer() || 9 <= t.internetExplorerVersion();
                }
              });
            }), t.define("module:DomMutation.TimerNodeRemoveObserver", ["module:DomMutation.NodeRemoveObserver", "base:Timers.Timer"], function (e, i, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e), this._timer = new i({
                      context: this,
                      fire: this._fire,
                      delay: 100
                    });
                  },
                  destroy: function destroy() {
                    this._timer.weakDestroy(), t.destroy.call(this);
                  },
                  _fire: function _fire() {
                    this._node.parentElement || (this._timer.stop(), this._nodeRemoved(this._node));
                  }
                };
              }, {
                supported: function supported(e) {
                  return !0;
                }
              });
            }), t.extend("module:DomMutation.NodeRemoveObserver", ["module:DomMutation.NodeRemoveObserver", "module:DomMutation.MutationObserverNodeRemoveObserver", "module:DomMutation.DOMNodeRemovedNodeRemoveObserver", "module:DomMutation.TimerNodeRemoveObserver"], function (e, t, i, r) {
              return e.register(t, 3), e.register(i, 2), e.register(r, 1), {};
            }), t.define("module:Geometry", [], function () {
              return {
                padFitBoxInBox: function padFitBoxInBox(e, t, i, r) {
                  var o = e / t,
                    a = i / r,
                    n = a < o ? i / e : r / t;
                  return {
                    scale: n,
                    offsetX: o < a ? (i - e * n) / 2 : 0,
                    offsetY: a < o ? (r - t * n) / 2 : 0
                  };
                }
              };
            }), t.define("module:Hotkeys", ["base:Objs"], function (d) {
              return {
                SHIFT_NUMS: {
                  "`": "~",
                  1: "!",
                  2: "@",
                  3: "#",
                  4: "$",
                  5: "%",
                  6: "^",
                  7: "&",
                  8: "*",
                  9: "(",
                  0: ")",
                  "-": "_",
                  "=": "+",
                  ";": ":",
                  "'": '"',
                  ",": "<",
                  ".": ">",
                  "/": "?",
                  "\\": "|"
                },
                SPECIAL_KEYS: {
                  esc: 27,
                  escape: 27,
                  tab: 9,
                  space: 32,
                  "return": 13,
                  enter: 13,
                  backspace: 8,
                  scrolllock: 145,
                  scroll_lock: 145,
                  scroll: 145,
                  capslock: 20,
                  caps_lock: 20,
                  caps: 20,
                  numlock: 144,
                  num_lock: 144,
                  num: 144,
                  pause: 19,
                  "break": 19,
                  insert: 45,
                  home: 36,
                  "delete": 46,
                  end: 35,
                  pageup: 33,
                  page_up: 33,
                  pu: 33,
                  pagedown: 34,
                  page_down: 34,
                  pd: 34,
                  left: 37,
                  up: 38,
                  right: 39,
                  down: 40,
                  f1: 112,
                  f2: 113,
                  f3: 114,
                  f4: 115,
                  f5: 116,
                  f6: 117,
                  f7: 118,
                  f8: 119,
                  f9: 120,
                  f10: 121,
                  f11: 122,
                  f12: 123
                },
                MODIFIERS: ["ctrl", "alt", "shift", "meta"],
                keyCodeToCharacter: function keyCodeToCharacter(e) {
                  return 188 == e ? "," : 190 == e ? "." : String.fromCharCode(e).toLowerCase();
                },
                handleKeyEvent: function handleKeyEvent(e, t, i) {
                  i = d.extend({
                    disable_in_input: !1,
                    keycode: !1
                  }, i);
                  var r = e.toLowerCase().split("+");
                  if (i.disable_in_input) {
                    var o = t.target || t.srcElement || null;
                    if (o && 3 == o.nodeType && (o = o.parentNode), o && ("INPUT" == o.tagName || "TEXTAREA" == o.tagName)) return !1;
                  }
                  var a = t.keyCode || t.which || 0,
                    n = this.keyCodeToCharacter(a),
                    s = 0,
                    x = {};
                  d.iter(this.MODIFIERS, function (e) {
                    x[e] = {
                      pressed: t[e + "Key"],
                      wanted: !1
                    };
                  }, this), d.iter(r, function (e) {
                    e in x ? (x[e].wanted = !0, s++) : 1 < e.length ? this.SPECIAL_KEYS[e] == a && s++ : i.keycode ? i.keycode == a && s++ : (n == e || t.shiftKey && this.SHIFT_NUMS[n] == e) && s++;
                  }, this);
                  var c = e.toLowerCase().split("^");
                  return 1 < c.length && d.iter(c, function (e) {
                    1 < e.length && t.keyCode === this.SPECIAL_KEYS[e] && (32 === a && t.preventDefault(), this.SPECIAL_KEYS[e] == a && s++);
                  }, this), s == r.length && d.all(x, function (e) {
                    return e.wanted == e.pressed;
                  });
                },
                register: function register(t, i, r, o) {
                  o = d.extend({
                    type: "keyup",
                    propagate: !1,
                    disable_in_input: !1,
                    target: document,
                    keycode: !1
                  }, o);
                  var a = this,
                    e = function e(_e2) {
                      a.handleKeyEvent(t, _e2, o) && (o.propagate || (_e2.preventDefault(), _e2.stopPropagation()), i.call(r || this, _e2));
                    };
                  return o.target.addEventListener(o.type, e, !1), {
                    target: o.target,
                    type: o.type,
                    func: e
                  };
                },
                unregister: function unregister(e) {
                  e.target.removeEventListener(e.type, e.func, !1);
                }
              };
            }), t.define("module:Ajax.IframePostmessageAjax", ["base:Ajax.Support", "base:Net.Uri", "base:Net.HttpHeader", "base:Promise", "base:Types", "base:Ajax.RequestException", "base:Tokens", "base:Objs"], function (d, l, e, u, h, t, p, b) {
              var m = 1,
                i = {
                  supports: function supports(e) {
                    return !!e.postmessage;
                  },
                  execute: function execute(t) {
                    var i = "postmessage_" + p.generate_token() + "_" + m++,
                      e = b.objectBy(t.postmessage, i),
                      e = b.extend(e, t.query),
                      r = l.appendUriParams(t.uri, e),
                      o = document.createElement("iframe");
                    o.id = i, o.name = i, o.style.display = "none";
                    var a = document.createElement("form");
                    a.method = t.method, a.target = i, r = d.finalizeUri(t, r), a.action = r, a.style.display = "none";
                    var n = u.create();
                    document.body.appendChild(o), document.body.appendChild(a), b.iter(t.data, function (e, t) {
                      var i = document.createElement("input");
                      i.type = "hidden", i.name = t, i.value = h.is_array(e) || h.is_object(e) ? JSON.stringify(e) : e, a.appendChild(i);
                    }, this);
                    var s = !("postMessage" in window),
                      x = null,
                      c = function c(e) {
                        x(e.data);
                      },
                      x = function x(e) {
                        "string" == typeof e && (e = JSON.parse(e)), i in e && (e = e[i], s && (window.postMessage = null), window.removeEventListener("message", c, !1), document.body.removeChild(a), document.body.removeChild(o), d.promiseReturnData(n, t, e, "json"));
                      };
                    return o.onerror = function () {
                      s && (window.postMessage = null), window.removeEventListener("message", c, !1), document.body.removeChild(a), document.body.removeChild(o);
                    }, window.addEventListener("message", c, !1), s && (window.postMessage = x), a.submit(), n;
                  }
                };
              return d.register(i, 4), i;
            }), t.define("module:Ajax.JsonpScriptAjax", ["base:Ajax.Support", "base:Net.Uri", "base:Net.HttpHeader", "base:Promise", "base:Types", "base:Ajax.RequestException", "base:Tokens", "base:Objs", "base:Async", "module:Info"], function (d, l, u, h, t, i, p, b, m, g) {
              var v = 1,
                r = {
                  supports: function supports(e) {
                    return !!e.jsonp && "GET" === e.method;
                  },
                  execute: function execute(i) {
                    var r = "jsonp_" + p.generate_token() + "_" + v++,
                      t = b.objectBy(i.jsonp, r),
                      t = b.extend(t, i.query);
                    t = b.extend(t, i.data);
                    var o = l.appendUriParams(i.uri, t),
                      a = !1;
                    window[r] = function (t) {
                      if (!a) {
                        a = !0;
                        try {
                          delete window[r];
                        } catch (e) {
                          window[r] = undefined;
                        }
                        d.promiseReturnData(n, i, t, "json");
                      }
                    };
                    var n = h.create(),
                      s = document.getElementsByTagName("head")[0],
                      x = document.createElement("script"),
                      c = !1;
                    return x.onerror = function (e) {
                      e && (e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0), a || (a = !0, d.promiseRequestException(n, u.HTTP_STATUS_BAD_REQUEST, u.format(u.HTTP_STATUS_BAD_REQUEST), null, "json"));
                    }, x.onload = x.onreadystatechange = function () {
                      c || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (c = !0, x.onload = x.onreadystatechange = null, s.removeChild(x), g.isInternetExplorer() && g.internetExplorerVersion() < 9 && m.eventually(function () {
                        a || x.onerror();
                      }));
                    }, o = d.finalizeUri(i, o), x.src = o, s.appendChild(x), n;
                  }
                };
              return d.register(r, 5), r;
            }), t.define("module:Ajax.XDomainRequestAjax", ["base:Ajax.Support", "base:Net.Uri", "base:Net.HttpHeader", "base:Promise", "base:Types", "base:Ajax.RequestException", "module:Info", "base:Async", "base:Ids"], function (o, a, n, s, x, e, t, c, d) {
              var l = {
                __requests: {},
                supports: function supports(e) {
                  return !!window.XDomainRequest && !e.forceJsonp && !e.forcePostmessage && !!e.isCorsRequest && !(!t.isInternetExplorer() || 9 < t.internetExplorerVersion());
                },
                execute: function execute(e) {
                  var t = a.appendUriParams(e.uri, e.query || {});
                  "GET" === e.method && (t = a.appendUriParams(t, e.data || {}));
                  var i = s.create(),
                    r = new XDomainRequest();
                  return (l.__requests[d.objectId(r)] = r).onload = function () {
                    o.promiseReturnData(i, e, r.responseText, "json"), delete l.__requests[d.objectId(r)];
                  }, r.ontimeout = function () {
                    o.promiseRequestException(i, n.HTTP_STATUS_GATEWAY_TIMEOUT, n.format(n.HTTP_STATUS_GATEWAY_TIMEOUT), null, "json"), delete l.__requests[d.objectId(r)];
                  }, r.onerror = function () {
                    o.promiseRequestException(i, n.HTTP_STATUS_BAD_REQUEST, n.format(n.HTTP_STATUS_BAD_REQUEST), null, "json"), delete l.__requests[d.objectId(r)];
                  }, t = o.finalizeUri(e, t), r.open(e.method, t), c.eventually(function () {
                    "GET" === e.method || x.is_empty(e.data) ? r.send() : "json" === e.contentType ? r.send(JSON.stringify(e.data)) : r.send(a.encodeUriParams(e.data, undefined, !0));
                  }, this), i;
                }
              };
              return o.register(l, 9), l;
            }), t.define("module:Ajax.XmlHttpRequestAjax", ["base:Ajax.Support", "base:Net.Uri", "base:Net.HttpHeader", "base:Promise", "base:Types", "base:Objs", "base:Ajax.RequestException", "module:Info"], function (x, c, d, l, u, h, t, p) {
              var i = {
                supports: function supports(t) {
                  if ("undefined" == typeof window) return !0;
                  if (!window.XMLHttpRequest) return !1;
                  if (t.forceJsonp || t.forcePostmessage) return !1;
                  if (p.isInternetExplorer() && p.internetExplorerVersion() < 10 && t.isCorsRequest) return !1;
                  try {
                    h.iter(t.data, function (e) {
                      ("undefined" != typeof window.Blob && e instanceof window.Blob || "undefined" != typeof File && e instanceof File) && (t.requireFormData = !0);
                    }), t.requireFormData && new window.FormData();
                  } catch (e) {
                    t.requireFormData = !1;
                  }
                  return !0;
                },
                create: function create() {
                  return new XMLHttpRequest();
                },
                execute: function execute(e, t, i, r) {
                  var o = c.appendUriParams(e.uri, e.query || {});
                  e.methodSupportsPayload || (o = c.appendUriParams(o, e.data || {}));
                  var a = l.create();
                  (r = r || this.create()).onreadystatechange = function () {
                    4 === r.readyState && (d.isSuccessStatus(r.status) || 0 === r.status && r.responseText ? x.promiseReturnData(a, e, "binary" === e.contentType ? r.response : "xml" === e.contentType ? r.responseXML : r.responseText, e.decodeType || "json") : x.promiseRequestException(a, r.status, r.statusText, r.responseText, e.decodeType || "json"));
                  }, t && ((r.upload || r).onprogress = function (e) {
                    e.lengthComputable && t.call(i || this, e.loaded, e.total);
                  }), o = x.finalizeUri(e, o);
                  var n,
                    s = c.parse(o);
                  return p.isFirefox() && s.user && s.password && (o = o.replace(s.user + ":" + s.password + "@", "")), r.open(e.method, o, !0), e.corscreds && (r.withCredentials = !0), e.bearer && r.setRequestHeader("Authorization", "Bearer " + e.bearer), e.accept && r.setRequestHeader("Accept", e.accept), "binary" === e.contentType && (r.responseType = "blob"), (s.user || s.password) && r.setRequestHeader("Authorization", "Basic " + btoa(s.user + ":" + s.password)), e.methodSupportsPayload && !u.is_empty(e.data) ? e.noFormData ? r.send(e.data.file) : e.requireFormData ? (n = new window.FormData(), h.iter(e.data, function (e, t) {
                    n.append(t, e);
                  }, this), r.send(n)) : "json" === e.contentType ? (e.sendContentType && r.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), r.send(JSON.stringify(e.data))) : "xml" === e.contentType ? (r.overrideMimeType("application/xml"), r.send(JSON.stringify(e.data))) : (e.sendContentType && r.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), r.send(c.encodeUriParams(e.data, undefined, !0))) : r.send(), a;
                }
              };
              return x.register(i, 10), i;
            }), t.define("module:Cookies", ["base:Net.Cookies"], function (s) {
              return {
                get: function get(e) {
                  return s.getCookielikeValue(document.cookie, e);
                },
                set: function set(e, t, i, r, o, a, n) {
                  document.cookie = s.createCookielikeValue(e, t, i, r, o, a, n);
                },
                remove: function remove(e, t, i, r) {
                  document.cookie = s.removeCookielikeValue(e, t, i, r);
                },
                has: function has(e) {
                  return s.hasCookielikeValue(document.cookie, e);
                },
                keys: function keys() {
                  return s.keysCookielike(document.cookie);
                }
              };
            }), t.define("module:DomMutation.NodeInsertObserver", ["base:Classes.ConditionalInstance", "base:Events.EventsMixin"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, [t, function (e) {
                return {
                  _nodeInserted: function _nodeInserted(e, t) {
                    if (t) for (var i = 0; i < e.childNodes.length; ++i) this._nodeInserted(e.childNodes[i], t);
                    this._options.parent && e.parentNode !== this._options.parent || this._options.root && !this._options.root.contains(e) || this._options.filter && !this._options.filter.call(this._options.context || this, e) || this.trigger("node-inserted", e);
                  }
                };
              }]);
            }), t.define("module:DomMutation.MutationObserverNodeInsertObserver", ["module:DomMutation.NodeInsertObserver", "base:Objs"], function (t, r, i) {
              return t.extend({
                scoped: i
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    e = e || {}, t.constructor.call(this, e);
                    var i = this;
                    this._observer = new window.MutationObserver(function (e) {
                      r.iter(e, function (e) {
                        for (var t = 0; t < e.addedNodes.length; ++t) i._nodeInserted(e.addedNodes[t], !0);
                      });
                    }), this._observer.observe(this._options.root || this._options.parent || document.body, {
                      childList: !0,
                      subtree: !this._options.parent
                    });
                  },
                  destroy: function destroy() {
                    this._observer.disconnect(), t.destroy.call(this);
                  }
                };
              }, {
                supported: function supported(t) {
                  try {
                    return !!window.MutationObserver;
                  } catch (e) {
                    return !1;
                  }
                }
              });
            }), t.define("module:DomMutation.DOMNodeInsertedNodeInsertObserver", ["module:DomMutation.NodeInsertObserver", "module:Events"], function (e, i, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    e = e || {}, t.constructor.call(this, e), this.auto_destroy(new i()).on(document, "DOMNodeInserted", function (e) {
                      this._nodeInserted(e.target, !0);
                    }, this);
                  }
                };
              }, {
                supported: function supported(e) {
                  return !0;
                }
              });
            }), t.extend("module:DomMutation.NodeInsertObserver", ["module:DomMutation.NodeInsertObserver", "module:DomMutation.MutationObserverNodeInsertObserver", "module:DomMutation.DOMNodeInsertedNodeInsertObserver"], function (e, t, i) {
              return e.register(t, 3), e.register(i, 2), {};
            });
          }.call(Scoped), function () {
            var t = this.subScope();
            t.binding("base", "root:BetaJS"), t.binding("browser", "root:BetaJS.Browser"), t.binding("module", "root:BetaJS.Media"), t.define("module:", function () {
              return {
                guid: "8475efdb-dd7e-402e-9f50-36c76945a692",
                version: "0.0.181",
                datetime: 1641674393831
              };
            }), t.define("module:AudioPlayer.AudioPlayerWrapper", ["base:Classes.OptimisticConditionalInstance", "base:Events.EventsMixin", "base:Types", "base:Objs", "base:Promise", "base:Strings", "browser:Events"], function (e, t, a, n, i, s, x, r) {
              return e.extend({
                scoped: r
              }, [t, function (o) {
                return {
                  constructor: function constructor(e, t) {
                    o.constructor.call(this);
                    var i = (e = n.extend(n.clone(e || {}, 1), t)).source || e.sources || [];
                    a.is_string(i) ? i = i.split(" ") : a.is_array(i) || (i = [i]);
                    var r = [];
                    n.iter(i, function (e) {
                      var t;
                      a.is_string(e) ? e = {
                        src: e.trim()
                      } : "undefined" != typeof Blob && e instanceof Blob && (e = {
                        src: e
                      }), e.ext && !e.type && (e.type = "audio/" + e.ext), !e.ext && e.type && (e.ext = s.last_after(e.type, "/")), e.ext || e.type || !a.is_string(e.src) || 0 <= (t = s.splitFirst(e.src, "?").head).indexOf(".") && (e.ext = s.last_after(t, "."), e.type = "audio/" + e.ext), e.ext && (e.ext = e.ext.toLowerCase()), e.type && (e.type = e.type.toLowerCase()), "undefined" != typeof Blob && e.src instanceof Blob && (e.src = (window.URL || window.webkitURL).createObjectURL(e.src)), r.push(e);
                    }, this), this._sources = r, this._element = e.element, this._preload = e.preload || !1, this._reloadonplay = e.reloadonplay || !1, this._options = e, this._loop = e.loop || !1, this._loaded = !1, this._error = 0, this._domEvents = new x();
                  },
                  destroy: function destroy() {
                    this._domEvents.destroy(), o.destroy.call(this);
                  },
                  sources: function sources() {
                    return this._sources;
                  },
                  loaded: function loaded() {
                    return this._loaded;
                  },
                  buffered: function buffered() {},
                  _eventLoaded: function _eventLoaded() {
                    this._loaded = !0, this.trigger("loaded");
                  },
                  _eventLoadedMetaData: function _eventLoadedMetaData(e) {
                    this._hasMetadata = !0, this.trigger("loadedmetadata", e.target);
                  },
                  _eventPlaying: function _eventPlaying() {
                    this._loaded || this._eventLoaded(), this.trigger("playing");
                  },
                  _eventPaused: function _eventPaused() {
                    this.trigger("paused");
                  },
                  _eventEnded: function _eventEnded() {
                    this._loop && this.play(), this.trigger("ended");
                  },
                  _eventError: function _eventError(e) {
                    this._error = e, this.trigger("error", e);
                  },
                  duration: function duration() {
                    return this._element.duration;
                  },
                  position: function position() {
                    return this._element.currentTime;
                  },
                  error: function error() {
                    return this._error;
                  },
                  play: function play() {
                    this._reloadonplay && this._element.load(), this._reloadonplay = !1;
                    var e = this._element.play();
                    if (e) return i.fromNativePromise(e);
                  },
                  pause: function pause() {
                    this._element.pause();
                  },
                  setPosition: function setPosition(e) {
                    this._element.currentTime = e;
                  },
                  muted: function muted() {
                    return this._element.muted;
                  },
                  setMuted: function setMuted(e) {
                    this._element.muted = e;
                  },
                  volume: function volume() {
                    return this._element.volume;
                  },
                  setVolume: function setVolume(e) {
                    this._element.volume = e;
                  }
                };
              }], {
                ERROR_NO_PLAYABLE_SOURCE: 1
              });
            }), t.define("module:AudioPlayer.Html5AudioPlayerWrapper", ["module:AudioPlayer.AudioPlayerWrapper", "browser:Info", "base:Promise", "base:Objs", "base:Timers.Timer", "base:Strings", "base:Async", "browser:Dom", "browser:Events"], function (t, h, p, b, m, g, r, v, f, i) {
              return t.extend({
                scoped: i
              }, function (t) {
                return {
                  _initialize: function _initialize() {
                    if (this._options.nohtml5) return p.error(!0);
                    if (this._sources.length < 1) return p.error(!0);
                    if (h.isInternetExplorer() && h.internetExplorerVersion() < 9) return p.error(!0);
                    var i = p.create();
                    this._element.innerHTML = "";
                    var t,
                      r,
                      o = this.sources(),
                      a = h.isInternetExplorer() && 9 == h.internetExplorerVersion() || h.isWindowsPhone();
                    "audio" !== this._element.tagName.toLowerCase() ? (this._element = v.changeTag(this._element, "audio"), this._transitionals.element = this._element) : a && (t = g.splitLast(this._element.outerHTML, "</audio>").head, b.iter(o, function (e) {
                      t += "<source" + (e.type ? " type='" + e.type + "'" : "") + " src='" + e.src + "' />";
                    }), t += "</audio>", r = v.elementByTemplate(t), v.elementInsertAfter(r, this._element), this._element.parentNode.removeChild(this._element), this._element = r, this._transitionals.element = this._element), h.isSafari() && h.safariVersion() < 6 && (this._element.src = o[0].src, this._preload = !0);
                    this._domEvents.on(this._element, "loadevent", function () {
                      this._element.networkState !== this._element.NETWORK_NO_SOURCE ? i.asyncSuccess(!0) : i.asyncError(!0);
                    }, this), this._loaded = !1, this._domEvents.on(this._element, "canplay", this._eventLoaded, this), this._domEvents.on(this._element, "loadedmetadata", this._eventLoadedMetaData, this);
                    var n = 10,
                      s = new m({
                        context: this,
                        fire: function fire() {
                          this._element.networkState === this._element.NETWORK_NO_SOURCE ? --n <= 0 && i.asyncError(!0) : (this._element.networkState === this._element.NETWORK_IDLE || this._element.networkState === this._element.NETWORK_LOADING && (h.isEdge() || h.isInternetExplorer() || h.isFirefox() && 0 === o[0].src.indexOf("blob:"))) && i.asyncSuccess(!0);
                        },
                        delay: 50
                      });
                    this._element.preload = this._preload ? "auto" : "none";
                    var x = 0,
                      c = new f();
                    if (a) for (var d = this._element.getElementsByTagName("SOURCE"), l = function l() {
                        ++x === o.length && i.asyncError(!0);
                      }, u = 0; u < d.length; ++u) c.on(d[u], "error", l);else b.iter(o, function (e) {
                      var t = document.createElement("source");
                      e.type && (t.type = e.type), this._element.appendChild(t), c.on(t, "error", function () {
                        ++x === o.length && i.asyncError(!0);
                      }), t.src = e.src;
                    }, this);
                    i.callback(function () {
                      c.weakDestroy(), s.destroy();
                    }, this), i.success(function () {
                      this._setup();
                    }, this);
                    try {
                      h.isChrome() || this._element.load();
                    } catch (e) {}
                    return i;
                  },
                  destroy: function destroy() {
                    (!h.isInternetExplorer() || 8 < h.internetExplorerVersion()) && (this._element.innerHTML = ""), t.destroy.call(this);
                  },
                  _setup: function _setup() {
                    this._domEvents.on(this._element, "playing", this._eventPlaying, this), this._domEvents.on(this._element, "pause", this._eventPaused, this), this._domEvents.on(this._element, "ended", this._eventEnded, this);
                    for (var e = this._element.getElementsByTagName("SOURCE"), t = function t() {
                        this._eventError(this.cls.ERROR_NO_PLAYABLE_SOURCE);
                      }, i = 0; i < e.length; ++i) this._domEvents.on(e[i], "error", t, this);
                    h.isSafari() && (5 < h.safariVersion() || h.safariVersion() < 9) && this._element.networkState === this._element.NETWORK_LOADING && r.eventually(function () {
                      this.destroyed() || this._element.networkState !== this._element.NETWORK_LOADING || 0 !== this._element.buffered.length || this._eventError(this.cls.ERROR_NO_PLAYABLE_SOURCE);
                    }, this, 1e4);
                  },
                  buffered: function buffered() {
                    return this._element.buffered.end(0);
                  },
                  play: function play() {
                    return t.play.call(this);
                  },
                  pause: function pause() {
                    this._element.pause();
                  },
                  setPosition: function setPosition(e) {
                    this._element.currentTime = e;
                  },
                  muted: function muted() {
                    return this._element.muted;
                  },
                  setMuted: function setMuted(e) {
                    this._element.muted = e;
                  },
                  volume: function volume() {
                    return this._element.volume;
                  },
                  setVolume: function setVolume(e) {
                    this._element.volume = e;
                  }
                };
              });
            }), t.extend("module:AudioPlayer.AudioPlayerWrapper", ["module:AudioPlayer.AudioPlayerWrapper", "module:AudioPlayer.Html5AudioPlayerWrapper"], function (e, t) {
              return e.register(t, 2), {};
            }), t.define("module:AudioRecorder.AudioRecorderWrapper", ["base:Classes.ConditionalInstance", "base:Events.EventsMixin", "base:Objs", "base:Promise"], function (e, t, i, r, o) {
              return e.extend({
                scoped: o
              }, [t, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e), this._element = this._options.element, this.ready = r.create();
                  },
                  destroy: function destroy() {
                    t.destroy.call(this);
                  },
                  bindMedia: function bindMedia() {
                    return this._bindMedia();
                  },
                  _bindMedia: function _bindMedia() {},
                  unbindMedia: function unbindMedia() {
                    return this._unbindMedia();
                  },
                  _unbindMedia: function _unbindMedia() {},
                  softwareDependencies: function softwareDependencies() {
                    return this._softwareDependencies();
                  },
                  _softwareDependencies: function _softwareDependencies() {},
                  soundLevel: function soundLevel() {},
                  testSoundLevel: function testSoundLevel(e) {},
                  getVolumeGain: function getVolumeGain() {},
                  setVolumeGain: function setVolumeGain(e) {},
                  enumerateDevices: function enumerateDevices() {},
                  currentDevices: function currentDevices() {},
                  setCurrentDevices: function setCurrentDevices(e) {},
                  startRecord: function startRecord(e) {},
                  pauseRecord: function pauseRecord() {},
                  resumeRecord: function resumeRecord() {},
                  stopRecord: function stopRecord(e) {},
                  canPause: function canPause() {
                    return !1;
                  },
                  isWebrtcStreaming: function isWebrtcStreaming() {
                    return !1;
                  },
                  supportsLocalPlayback: function supportsLocalPlayback() {
                    return !1;
                  },
                  localPlaybackSource: function localPlaybackSource() {
                    return null;
                  },
                  recordDelay: function recordDelay(e) {
                    return 0;
                  }
                };
              }], {
                _initializeOptions: function _initializeOptions(e) {
                  return i.extend({
                    recordVideo: !1,
                    recordAudio: !0
                  }, e);
                }
              });
            }), t.define("module:Encoding.WaveEncoder.Support", ["base:Promise", "base:Scheduling.Helper"], function (u, h) {
              return {
                dumpInputBuffer: function dumpInputBuffer(e, t, i, r) {
                  return {
                    left: new Float32Array(e.getChannelData(0)),
                    right: 1 < t ? new Float32Array(e.getChannelData(1)) : null,
                    offset: r || 0,
                    endOffset: i
                  };
                },
                waveChannelTransform: function waveChannelTransform(e, t, i, r) {
                  var o = u.create(),
                    a = 32767 * (t || 1),
                    n = e.offset,
                    s = e.endOffset,
                    x = e.left,
                    c = e.right,
                    d = new Int16Array((s - n) * (c ? 2 : 1)),
                    l = 0;
                  return h.schedulable(function (e) {
                    for (; 0 < e;) {
                      if (e--, s <= n) return o.asyncSuccess(d), !0;
                      d[l] = x[n] * a, l++, c && (d[l] = c[n] * a, l++), n++;
                    }
                    return !1;
                  }, 100, i, r), o;
                },
                generateHeader: function generateHeader(e, t, i, r) {
                  r = r || new ArrayBuffer(44);
                  var o = new DataView(r);
                  return o.writeUTFBytes = function (e, t) {
                    for (var i = 0; i < t.length; i++) this.setUint8(e + i, t.charCodeAt(i));
                  }, o.writeUTFBytes(0, "RIFF"), o.setUint32(4, 44 + e, !0), o.writeUTFBytes(8, "WAVE"), o.writeUTFBytes(12, "fmt "), o.setUint32(16, 16, !0), o.setUint16(20, 1, !0), o.setUint16(22, t, !0), o.setUint32(24, i, !0), o.setUint32(28, 4 * i, !0), o.setUint16(32, 2 * t, !0), o.setUint16(34, 16, !0), o.writeUTFBytes(36, "data"), o.setUint32(40, e, !0), r;
                }
              };
            }), t.define("module:Encoding.WebmEncoder.Support", ["base:Promise", "base:Scheduling.Helper", "base:Types"], function (e, t, i) {
              return {
                parseWebP: function parseWebP(e) {
                  for (var t = e.RIFF[0].WEBP[0], i = t.indexOf("\x9d\x01*"), r = 0, o = []; r < 4; r++) o[r] = t.charCodeAt(i + 3 + r);
                  return {
                    width: 16383 & (o[1] << 8 | o[0]),
                    height: 16383 & (o[3] << 8 | o[2]),
                    data: t,
                    riff: e
                  };
                },
                parseRIFF: function parseRIFF(e) {
                  for (var t = 0, i = {}, r = function r(e) {
                      var t = e.charCodeAt(0).toString(2);
                      return new Array(8 - t.length + 1).join("0") + t;
                    }; t < e.length;) {
                    var o = e.substr(t, 4),
                      a = parseInt(e.substr(t + 4, 4).split("").map(r).join(""), 2),
                      n = e.substr(t + 4 + 4, a);
                    t += 8 + a, i[o] = i[o] || [], "RIFF" == o || "LIST" == o ? i[o].push(this.parseRIFF(n)) : i[o].push(n);
                  }
                  return i;
                },
                isBlankFrame: function isBlankFrame(e, t, i, r) {
                  if ("function" == typeof Array.prototype.some) return !e.getContext("2d").getImageData(0, 0, e.width, e.height).data.some(function (e) {
                    return 0 !== e;
                  });
                  var o = document.createElement("canvas");
                  o.width = e.width, o.height = e.height;
                  var a = o.getContext("2d"),
                    n = 0,
                    s = 0,
                    x = 0,
                    c = Math.sqrt(Math.pow(255, 2) + Math.pow(255, 2) + Math.pow(255, 2)),
                    d = i && 0 <= i && i <= 1 ? i : 0,
                    l = r && 0 <= r && r <= 1 ? r : 0,
                    u = new Image();
                  u.src = t.image, a.drawImage(u, 0, 0, e.width, e.height);
                  for (var h = a.getImageData(0, 0, e.width, e.height), p = 0, b = h.data.length, m = h.data.length / 4, g = 0; g < b; g += 4) {
                    var v = h.data[g],
                      f = h.data[g + 1],
                      y = h.data[g + 2];
                    Math.sqrt(Math.pow(v - n, 2) + Math.pow(f - s, 2) + Math.pow(y - x, 2)) <= c * d && p++;
                  }
                  return m - p <= m * l;
                },
                makeSimpleBlock: function makeSimpleBlock(e) {
                  var t = 0;
                  if (e.keyframe && (t |= 128), e.invisible && (t |= 8), e.lacing && (t |= e.lacing << 1), e.discardable && (t |= 1), 127 < e.trackNum) throw "TrackNumber > 127 not supported";
                  return [128 | e.trackNum, e.timecode >> 8, 255 & e.timecode, t].map(function (e) {
                    return String.fromCharCode(e);
                  }).join("") + e.frame;
                },
                generateEBMLHeader: function generateEBMLHeader(e, t, i) {
                  var r;
                  return [{
                    id: 440786851,
                    data: [{
                      data: 1,
                      id: 17030
                    }, {
                      data: 1,
                      id: 17143
                    }, {
                      data: 4,
                      id: 17138
                    }, {
                      data: 8,
                      id: 17139
                    }, {
                      data: "webm",
                      id: 17026
                    }, {
                      data: 2,
                      id: 17031
                    }, {
                      data: 2,
                      id: 17029
                    }]
                  }, {
                    id: 408125543,
                    data: [{
                      id: 357149030,
                      data: [{
                        data: 1e6,
                        id: 2807729
                      }, {
                        data: "whammy",
                        id: 19840
                      }, {
                        data: "whammy",
                        id: 22337
                      }, {
                        data: (r = e, [].slice.call(new Uint8Array(new Float64Array([r]).buffer), 0).map(function (e) {
                          return String.fromCharCode(e);
                        }).reverse().join("")),
                        id: 17545
                      }]
                    }, {
                      id: 374648427,
                      data: [{
                        id: 174,
                        data: [{
                          data: 1,
                          id: 215
                        }, {
                          data: 1,
                          id: 25541
                        }, {
                          data: 0,
                          id: 156
                        }, {
                          data: "und",
                          id: 2274716
                        }, {
                          data: "V_VP8",
                          id: 134
                        }, {
                          data: "VP8",
                          id: 2459272
                        }, {
                          data: 1,
                          id: 131
                        }, {
                          id: 224,
                          data: [{
                            data: t,
                            id: 176
                          }, {
                            data: i,
                            id: 186
                          }]
                        }]
                      }]
                    }]
                  }];
                },
                __numToBuffer: function __numToBuffer(e) {
                  for (var t = []; 0 < e;) t.push(255 & e), e >>= 8;
                  return new Uint8Array(t.reverse());
                },
                __strToBuffer: function __strToBuffer(e) {
                  return new Uint8Array(e.split("").map(function (e) {
                    return e.charCodeAt(0);
                  }));
                },
                __bitsToBuffer: function __bitsToBuffer(e) {
                  var t = [];
                  e = (e.length % 8 ? new Array(9 - e.length % 8).join("0") : "") + e;
                  for (var i = 0; i < e.length; i += 8) t.push(parseInt(e.substr(i, 8), 2));
                  return new Uint8Array(t);
                },
                serializeEBML: function serializeEBML(e) {
                  if (!i.is_array(e)) return e;
                  var x = [];
                  return e.forEach(function (e) {
                    var t = e.data,
                      i = typeof t;
                    "object" == i ? t = this.serializeEBML(t) : "number" == i ? t = this.__bitsToBuffer(t.toString(2)) : "string" == i && (t = this.__strToBuffer(t));
                    var r = t.size || t.byteLength || t.length,
                      o = Math.ceil(Math.ceil(Math.log(r) / Math.log(2)) / 8),
                      a = r.toString(2),
                      n = new Array(7 * o + 7 + 1 - a.length).join("0") + a,
                      s = new Array(o).join("0") + "1" + n;
                    x.push(this.__numToBuffer(e.id)), x.push(this.__bitsToBuffer(s)), x.push(t);
                  }, this), new Blob(x, {
                    type: "video/webm"
                  });
                },
                makeTimecodeDataBlock: function makeTimecodeDataBlock(e, t) {
                  return {
                    data: this.makeSimpleBlock({
                      discardable: 0,
                      frame: e.slice(4),
                      invisible: 0,
                      keyframe: 1,
                      lacing: 0,
                      trackNum: 1,
                      timecode: Math.round(t)
                    }),
                    id: 163
                  };
                },
                makeCluster: function makeCluster(e, t) {
                  return e.unshift({
                    data: t,
                    id: 231
                  }), {
                    id: 524531317,
                    data: e
                  };
                }
              };
            }), t.define("module:ImageRecorder.ImageRecorderWrapper", ["base:Classes.ConditionalInstance", "base:Events.EventsMixin", "base:Objs", "base:Promise"], function (e, t, i, r, o) {
              return e.extend({
                scoped: o
              }, [t, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e), this._element = this._options.element, this.ready = r.create();
                  },
                  destroy: function destroy() {
                    t.destroy.call(this);
                  },
                  bindMedia: function bindMedia() {
                    return this._bindMedia();
                  },
                  _bindMedia: function _bindMedia() {},
                  unbindMedia: function unbindMedia() {
                    return this._unbindMedia();
                  },
                  _unbindMedia: function _unbindMedia() {},
                  softwareDependencies: function softwareDependencies() {
                    return this._softwareDependencies();
                  },
                  _softwareDependencies: function _softwareDependencies() {},
                  cameraWidth: function cameraWidth() {
                    return this._options.recordingWidth;
                  },
                  cameraHeight: function cameraHeight() {
                    return this._options.recordingHeight;
                  },
                  lightLevel: function lightLevel() {},
                  blankLevel: function blankLevel() {},
                  deltaCoefficient: function deltaCoefficient() {},
                  enumerateDevices: function enumerateDevices() {},
                  currentDevices: function currentDevices() {},
                  setCurrentDevices: function setCurrentDevices(e) {},
                  setCameraFace: function setCameraFace(e) {},
                  getCameraFacingMode: function getCameraFacingMode() {},
                  createSnapshot: function createSnapshot() {},
                  removeSnapshot: function removeSnapshot(e) {},
                  createSnapshotDisplay: function createSnapshotDisplay(e, t, i, r, o, a) {},
                  updateSnapshotDisplay: function updateSnapshotDisplay(e, t, i, r, o, a) {},
                  removeSnapshotDisplay: function removeSnapshotDisplay(e) {},
                  createSnapshotUploader: function createSnapshotUploader(e, t, i) {},
                  snapshotToLocalPoster: function snapshotToLocalPoster(e) {
                    return null;
                  }
                };
              }], {
                _initializeOptions: function _initializeOptions(e) {
                  return i.extend({
                    recordingWidth: 640,
                    recordingHeight: 480
                  }, e);
                }
              });
            }), t.define("module:Player.Broadcasting", ["base:Class", "browser:Loader", "browser:Events"], function (e, i, r, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.apply(this), this.player = e.player, this.googleCast = {}, this.airplay = {}, this.options = e.commonOptions, this.googleCast.initialOptions = e.castOptions, this.airplayOptions = e.airplayOptions, this.player.on("pause-google-cast", function () {
                      this._googleCastRemotePause();
                    }, this), this.player.on("play-google-cast", function () {
                      this._googleCastRemotePlay();
                    }, this), this.player.on("google-cast-seeking", function (e) {
                      this._seekToGoogleCast(e);
                    }, this), this.player.on("change-google-cast-volume", function (e) {
                      e = Math.min(1, e), this._changeGoogleCastVolume(e);
                    }, this);
                  },
                  attachAirplayEvent: function attachAirplayEvent(e) {
                    this._airplayEvent = this.auto_destroy(new r()), this._airplayEvent.on(e, "webkitplaybacktargetavailabilitychanged", function (e) {
                      switch (e.availability) {
                        case "available":
                          return this.player._broadcastingState.airplayConnected = !0;
                        default:
                          return !1;
                      }
                    }, this);
                  },
                  attachGoggleCast: function attachGoggleCast() {
                    var t = this;
                    window.__onGCastApiAvailable = function (e) {
                      e && t._initializeCastApi();
                    }, i.loadScript("https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1", function () {});
                  },
                  _initializeCastApi: function _initializeCastApi() {
                    var e = this;
                    e.player.trigger("cast-available", !0);
                    var t = this.googleCast.initialOptions,
                      i = {},
                      r = [chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID, "41A5ADFD", "8AA2B3F9", "DE815B4F"],
                      o = [chrome.cast.AutoJoinPolicy.PAGE_SCOPED, chrome.cast.AutoJoinPolicy.TAB_AND_ORIGIN_SCOPED, chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED];
                    i.autoJoinPolicy = o[1], i.receiverApplicationId = this.options.chromecastReceiverAppId || r[2], cast.framework.CastContext.getInstance().setOptions(i);
                    var a = new cast.framework.RemotePlayer();
                    a.title = this.options.title, a.canControlVolume = t.canControlVolume, a.canPause = t.canPause, a.canSeek = t.canSeek, a.duration = t.duration, a.imageUrl = t.imageUrl, a.isConnected = t.isConnected, a.isMuted = t.isMuted, a.isPaused = t.isPaused, a.title = this.options.title, a.displayName = t.displayName;
                    var n = new cast.framework.RemotePlayerController(a);
                    n.addEventListener(cast.framework.RemotePlayerEventType.IS_CONNECTED_CHANGED, function () {
                      cast && cast.framework && (a.isConnected ? e._setupCastRemotePlayer(a, n) : e._destroyCastRemotePlayer(a, n));
                    });
                  },
                  _setupCastRemotePlayer: function _setupCastRemotePlayer(i, t) {
                    var r = this,
                      o = this.player,
                      e = (this.castOptions, o._sources),
                      a = o._element.currentSrc,
                      n = e[0].type,
                      s = cast.framework.CastContext.getInstance().getCurrentSession(),
                      x = new chrome.cast.media.MediaInfo(a, n);
                    x.metadata = new chrome.cast.media.GenericMediaMetadata(), x.metadata.metadataType = chrome.cast.media.MetadataType.GENERIC, x.metadata.title = this.options.title, x.metadata.images = [{
                      url: this.options.poster
                    }];
                    var c = new chrome.cast.media.LoadRequest(x);
                    this.googleCast.castRemotePlayer = i, this.googleCast.castRemotePlayerController = t, this.googleCast.castMediaInfo = x, (this.googleCast.castSession = s).loadMedia(c).then(function () {
                      o._broadcastingState.googleCastConnected = !0, o.trigger("cast-loaded", i, t);
                      var e = r.options.currentPosition;
                      0 < e && r._seekToGoogleCast(e), t.addEventListener(cast.framework.RemotePlayerEventType.IS_PAUSED_CHANGED, function () {
                        o.trigger("cast-playpause", i.isPaused);
                      }), t.addEventListener(cast.framework.RemotePlayerEventType.CURRENT_TIME_CHANGED, function () {
                        var e = r._getGoogleCastCurrentMediaTime(i),
                          t = r._getGoogleCastMediaDuration(i);
                        o.trigger("cast-time-changed", e, t);
                      });
                    }, function (e) {
                      console.warn("Remote media load error : " + r._googleCastPlayerErrorMessages(e));
                    });
                  },
                  _destroyCastRemotePlayer: function _destroyCastRemotePlayer(e, t) {
                    var i = this.player,
                      r = this._getGoogleCastCurrentMediaTime(e);
                    e.savedPlayerState && !e.isConnected && (r = e.savedPlayerState.currentTime), i._broadcastingState.googleCastConnected && 0 < r && i.trigger("proceed-when-ending-googlecast", r), this.player._broadcastingState.googleCastConnected = !1;
                  },
                  _getGoogleCastRemotePlayer: function _getGoogleCastRemotePlayer() {
                    if (this.player._broadcastingState.googleCastConnected) return this.googleCast.castRemotePlayer;
                  },
                  _getGoogleCastRemotePlayerController: function _getGoogleCastRemotePlayerController() {
                    if (this.player._broadcastingState.googleCastConnected) return this.googleCast.castRemotePlayerController;
                  },
                  _getGoogleCastMediaInfo: function _getGoogleCastMediaInfo() {
                    if (this.player._broadcastingState.googleCastConnected) return this.googleCast.castMediaInfo;
                  },
                  _getGoogleCastCurrentSession: function _getGoogleCastCurrentSession() {
                    if (this.player._broadcastingState.googleCastConnected) return this.googleCast.castSession;
                  },
                  _getGoogleCastCurrentMediaTime: function _getGoogleCastCurrentMediaTime(e) {
                    if (this.player._broadcastingState.googleCastConnected) return e.currentTime;
                  },
                  _getGoogleCastMediaDuration: function _getGoogleCastMediaDuration(e) {
                    if (this.player._broadcastingState.googleCastConnected) return e.duration;
                  },
                  _googleCastRemotePlay: function _googleCastRemotePlay() {
                    if (this.player._broadcastingState.googleCastConnected) {
                      var e = this._getGoogleCastRemotePlayer(),
                        t = this._getGoogleCastRemotePlayerController();
                      return "PAUSED" === e.playerState && t.playOrPause(), e;
                    }
                    return !1;
                  },
                  _googleCastRemotePause: function _googleCastRemotePause() {
                    if (this.player._broadcastingState.googleCastConnected) {
                      var e = this._getGoogleCastRemotePlayer(),
                        t = this._getGoogleCastRemotePlayerController();
                      return "PLAYING" === e.playerState && t.playOrPause(), e;
                    }
                    return !1;
                  },
                  _seekToGoogleCast: function _seekToGoogleCast(e) {
                    var t = this._getGoogleCastRemotePlayer(),
                      i = this._getGoogleCastRemotePlayerController();
                    t.currentTime = e, i.seek();
                  },
                  _changeGoogleCastVolume: function _changeGoogleCastVolume(e) {
                    var t = this._getGoogleCastRemotePlayerController();
                    this._getGoogleCastRemotePlayer().volumeLevel = e, t.setVolumeLevel();
                  },
                  _googleCastPlayerErrorMessages: function _googleCastPlayerErrorMessages(e) {
                    switch (e.code) {
                      case chrome.cast.ErrorCode.API_NOT_INITIALIZED:
                        return "The API is not initialized." + (e.description ? " :" + e.description : "");
                      case chrome.cast.ErrorCode.CANCEL:
                        return "The operation was canceled by the user" + (e.description ? " :" + e.description : "");
                      case chrome.cast.ErrorCode.CHANNEL_ERROR:
                        return "A channel to the receiver is not available." + (e.description ? " :" + e.description : "");
                      case chrome.cast.ErrorCode.EXTENSION_MISSING:
                        return "The Cast extension is not available." + (e.description ? " :" + e.description : "");
                      case chrome.cast.ErrorCode.INVALID_PARAMETER:
                        return "The parameters to the operation were not valid." + (e.description ? " :" + e.description : "");
                      case chrome.cast.ErrorCode.RECEIVER_UNAVAILABLE:
                        return "No receiver was compatible with the session request." + (e.description ? " :" + e.description : "");
                      case chrome.cast.ErrorCode.SESSION_ERROR:
                        return "A session could not be created, or a session was invalid." + (e.description ? " :" + e.description : "");
                      case chrome.cast.ErrorCode.TIMEOUT:
                        return "The operation timed out." + (e.description ? " :" + e.description : "");
                    }
                  },
                  lookForAirplayDevices: function lookForAirplayDevices(e) {
                    return e.webkitShowPlaybackTargetPicker();
                  }
                };
              });
            }), t.define("module:Player.Support", ["base:Promise", "base:Objs"], function (c, d) {
              return {
                resolutionToLabel: function resolutionToLabel(e, t) {
                  return t < 300 ? "SD" : t < 400 ? "360p" : t < 500 ? "480p" : "HD";
                },
                elementFileInfo: function elementFileInfo(t, i, r, o) {
                  try {
                    var a = document.createElement(t);
                    d.iter(r, function (e, t) {
                      a[t] = e;
                    });
                    var n = c.create(),
                      s = !1,
                      x = setTimeout(function () {
                        s = !0, a.error != undefined ? n.asyncError(a.error) : n.asyncError("Timeout");
                      }, 1e3);
                    return a[i] = function () {
                      s || (clearTimeout(x), n.asyncSuccess(a));
                    }, a.src = (window.URL || window.webkitURL).createObjectURL(o), n;
                  } catch (e) {
                    return c.error(e);
                  }
                },
                videoFileInfo: function videoFileInfo(e) {
                  return this.elementFileInfo("video", "onloadeddata", {
                    volume: 0,
                    muted: !0,
                    preload: !0
                  }, e).mapSuccess(function (e) {
                    return {
                      width: e.videoWidth,
                      height: e.videoHeight,
                      duration: e.duration
                    };
                  }).mapError(function (e) {
                    return e;
                  });
                },
                audioFileInfo: function audioFileInfo(e) {
                  return this.elementFileInfo("audio", "onloadeddata", {
                    volume: 0,
                    muted: !0,
                    preload: !0
                  }, e).mapSuccess(function (e) {
                    return {
                      duration: e.duration
                    };
                  });
                },
                imageFileInfo: function imageFileInfo(e) {
                  return this.elementFileInfo("img", "onload", {}, e).mapSuccess(function (e) {
                    return {
                      width: e.width,
                      height: e.height
                    };
                  });
                }
              };
            }), t.define("module:Player.VideoPlayerWrapper", ["base:Classes.OptimisticConditionalInstance", "base:Events.EventsMixin", "base:Types", "base:Objs", "base:Strings", "browser:Events"], function (t, i, a, n, s, x, r) {
              return t.extend({
                scoped: r
              }, [i, function (o) {
                return {
                  constructor: function constructor(e, t) {
                    o.constructor.call(this), e = n.extend(n.clone(e || {}, 1), t), this._poster = e.poster || null;
                    var i = e.source || e.sources || [];
                    a.is_string(i) ? i = i.split(" ") : a.is_array(i) || (i = [i]), this._onlyAudio = !1, "undefined" != typeof e.onlyaudio && (this._onlyAudio = e.onlyaudio);
                    var r = [];
                    n.iter(i, function (e) {
                      var t;
                      a.is_string(e) ? e = {
                        src: e.trim()
                      } : "undefined" != typeof Blob && e instanceof Blob && (e = {
                        src: e
                      }), e.ext && !e.type && (e.type = "video/" + e.ext), !e.ext && e.type && (e.ext = s.last_after(e.type, "/")), e.ext || e.type || !a.is_string(e.src) || 0 <= (t = s.splitFirst(e.src, "?").head).indexOf(".") && (e.ext = s.last_after(t, "."), e.type = "video/" + e.ext), e.ext && (e.ext = e.ext.toLowerCase()), e.type && (e.type = e.type.toLowerCase());
                      var i = null;
                      "undefined" != typeof e.audiosrc && (i = e.audiosrc), "undefined" != typeof Blob && e.src instanceof Blob && (e.src = this._onlyAudio && i ? (window.URL || window.webkitURL).createObjectURL(i) : (window.URL || window.webkitURL).createObjectURL(e.src)), "undefined" != typeof Blob && e.audiosrc instanceof Blob && (e.audiosrc = (window.URL || window.webkitURL).createObjectURL(e.audiosrc)), r.push(e);
                    }, this), this._sources = r, this._element = e.element, this._preload = e.preload || !1, this._reloadonplay = e.reloadonplay || !1, this._options = e, this._loop = e.loop || !1, this._fullscreenedElement = e.fullscreenedElement, this._preloadMetadata = e.loadmetadata || !1, this._loaded = !1, this._postererror = !1, this._error = 0, this._domEvents = new x(), this._broadcastingState = {
                      googleCastConnected: !1,
                      airplayConnected: !1
                    };
                  },
                  destroy: function destroy() {
                    this._domEvents.destroy(), o.destroy.call(this);
                  },
                  poster: function poster() {
                    return this._poster;
                  },
                  sources: function sources() {
                    return this._sources;
                  },
                  loaded: function loaded() {
                    return this._loaded;
                  },
                  postererror: function postererror() {
                    return this._postererror;
                  },
                  buffered: function buffered() {},
                  _eventLoaded: function _eventLoaded(e) {
                    this._loaded = !0, this.trigger("loaded");
                  },
                  _eventLoadedMetaData: function _eventLoadedMetaData(e) {
                    this._hasMetadata = !0, this.trigger("loadedmetadata", e);
                  },
                  _eventPosterLoaded: function _eventPosterLoaded(e) {
                    this.trigger("posterloaded", e);
                  },
                  _eventPlaying: function _eventPlaying() {
                    this._loaded || this._eventLoaded(), this.trigger("playing");
                  },
                  _eventPaused: function _eventPaused() {
                    this.duration() && this.duration() === this.position() || this.trigger("paused");
                  },
                  _eventEnded: function _eventEnded() {
                    this.trigger("ended");
                  },
                  _eventError: function _eventError(e) {
                    this._error = e, this.trigger("error", e);
                  },
                  _eventPosterError: function _eventPosterError() {
                    this._postererror = !0, this.trigger("postererror");
                  },
                  supportsFullscreen: function supportsFullscreen() {
                    return !1;
                  },
                  duration: function duration() {
                    return this._element.duration;
                  },
                  position: function position() {
                    return this._element.currentTime;
                  },
                  enterFullscreen: function enterFullscreen() {},
                  exitFullscreen: function exitFullscreen() {},
                  isFullscreen: function isFullscreen() {
                    return !1;
                  },
                  supportsPIP: function supportsPIP() {
                    return !1;
                  },
                  enterPIPMode: function enterPIPMode() {},
                  exitPIPMode: function exitPIPMode() {},
                  isInPIPMode: function isInPIPMode() {
                    return !1;
                  },
                  error: function error() {
                    return this._error;
                  },
                  play: function play() {
                    this._reloadonplay && this._element.load(), this._reloadonplay = !1;
                    try {
                      var t = this._element.play();
                      t["catch"] && t["catch"](function () {});
                    } catch (e) {}
                  },
                  pause: function pause() {
                    this._element.pause();
                  },
                  setPosition: function setPosition(e) {
                    this._element.currentTime = e;
                  },
                  muted: function muted() {
                    return this._element.muted;
                  },
                  setMuted: function setMuted(e) {
                    this._element.muted = e;
                  },
                  volume: function volume() {
                    return this._element.volume;
                  },
                  setVolume: function setVolume(e) {
                    this._element.volume = e;
                  },
                  videoWidth: function videoWidth() {},
                  videoHeight: function videoHeight() {},
                  createSnapshotPromise: function createSnapshotPromise(e) {}
                };
              }], {
                ERROR_NO_PLAYABLE_SOURCE: 1
              });
            }), t.define("module:Player.Html5VideoPlayerWrapper", ["module:Player.VideoPlayerWrapper", "browser:Info", "base:Promise", "base:Objs", "base:Timers.Timer", "base:Strings", "base:Async", "browser:Dom", "browser:Events"], function (t, b, m, g, v, f, n, y, _, i) {
              return t.extend({
                scoped: i
              }, function (t) {
                return {
                  _initialize: function _initialize() {
                    if (this._options.nohtml5) return m.error(!0);
                    if (this._sources.length < 1) return m.error(!0);
                    if (b.isInternetExplorer() && b.internetExplorerVersion() < 9) return m.error(!0);
                    var r = m.create();
                    this._element.innerHTML = "";
                    var t,
                      i,
                      o = this.sources(),
                      a = 0 === o[0].src.indexOf("blob:") && o[0].src,
                      n = b.isInternetExplorer() && 9 == b.internetExplorerVersion() || b.isWindowsPhone();
                    "video" !== this._element.tagName.toLowerCase() ? (this._element = y.changeTag(this._element, "video"), this._transitionals.element = this._element) : n && (t = f.splitLast(this._element.outerHTML, "</video>").head, g.iter(o, function (e) {
                      t += "<source" + (e.type ? " type='" + e.type + "'" : "") + " src='" + e.src + "' />";
                    }), t += "</video>", i = y.elementByTemplate(t), y.elementInsertAfter(i, this._element), this._element.parentNode.removeChild(this._element), this._element = i, this._transitionals.element = this._element), b.isSafari() && b.safariVersion() < 6 && (this._element.src = o[0].src, this._preload = !0);
                    this._domEvents.on(this._element, "loadevent", function () {
                      this._element.networkState !== this._element.NETWORK_NO_SOURCE ? r.asyncSuccess(!0) : r.asyncError(!0);
                    }, this);
                    var s = 10,
                      x = new v({
                        context: this,
                        fire: function fire() {
                          this._element.networkState === this._element.NETWORK_NO_SOURCE ? --s <= 0 && r.asyncError(!0) : (this._element.networkState === this._element.NETWORK_IDLE || this._element.networkState === this._element.NETWORK_LOADING && (b.isEdge() || b.isInternetExplorer() || b.isFirefox() && a)) && r.asyncSuccess(!0);
                        },
                        delay: 50
                      }),
                      c = this._preloadMetadata ? "metadata" : "none";
                    this._element.preload = this._preload ? "auto" : c;
                    var d = 0;
                    this._audioElement = null;
                    var l = new _();
                    if (a) this._element.src = a;else if (n) for (var u = this._element.getElementsByTagName("SOURCE"), h = function h() {
                        ++d === o.length && r.asyncError(!0);
                      }, p = 0; p < u.length; ++p) l.on(u[p], "error", h);else g.iter(o, function (e) {
                      var t,
                        i = document.createElement("source");
                      e.type && (i.type = e.type), this._element.appendChild(i), l.on(i, "error", function () {
                        ++d === o.length && r.asyncError(!0);
                      }), i.src = e.src, e.audiosrc && (this._audioElement || (this._audioElement = document.createElement("audio"), y.elementInsertAfter(this._audioElement, this._element)), t = document.createElement("source"), e.type && (t.type = e.type), this._audioElement.appendChild(t), t.src = e.audiosrc);
                    }, this);
                    this.poster() && (this._element.poster = this.posterURL()), r.callback(function () {
                      l.weakDestroy(), x.destroy();
                    }, this), r.success(function () {
                      this._setup();
                    }, this);
                    try {
                      b.isChrome() || this._element.load();
                    } catch (e) {}
                    return r;
                  },
                  posterURL: function posterURL() {
                    var e = this.poster();
                    return e && "undefined" != typeof Blob && e instanceof Blob ? (window.URL || window.webkitURL).createObjectURL(e) : e;
                  },
                  destroy: function destroy() {
                    this._audioElement && this._audioElement.remove(), this.supportsFullscreen() && this.__fullscreenListener && y.elementOffFullscreenChange(this._element, this.__fullscreenListener), this.supportsPIP() && this.__pipListener && y.videoRemovePIPChangeListeners(this._element, this.__pipListener), (!b.isInternetExplorer() || 8 < b.internetExplorerVersion()) && (this._element.innerHTML = ""), t.destroy.call(this);
                  },
                  _eventEnded: function _eventEnded() {
                    this._loop && this.play(), t._eventEnded.call(this);
                  },
                  _setup: function _setup() {
                    this._loaded = !1, this._domEvents.on(this._element, "canplay", this._eventLoaded, this), this._domEvents.on(this._element, "loadedmetadata", this._eventLoadedMetaData, this), this._domEvents.on(this._element, "playing", this._eventPlaying, this), this._domEvents.on(this._element, "pause", this._eventPaused, this), this._domEvents.on(this._element, "ended", this._eventEnded, this);
                    for (var e, t, i = this, r = this._element.getElementsByTagName("SOURCE"), o = function o() {
                        this._eventError(this.cls.ERROR_NO_PLAYABLE_SOURCE);
                      }, a = 0; a < r.length; ++a) this._domEvents.on(r[a], "error", o, this);
                    this.poster() && ((e = new Image()).onerror = function () {
                      delete i._element.poster, delete i._element.preload, i._eventPosterError();
                    }, e.src = this.posterURL(), e.onload = function () {
                      i.__imageWidth = e.width, i.__imageHeight = e.height, i._eventPosterLoaded(this);
                    }), b.isSafari() && (5 < b.safariVersion() || b.safariVersion() < 9) && this._element.networkState === this._element.NETWORK_LOADING && n.eventually(function () {
                      this.destroyed() || this._element.networkState !== this._element.NETWORK_LOADING || 0 !== this._element.buffered.length || this._eventError(this.cls.ERROR_NO_PLAYABLE_SOURCE);
                    }, this, 1e4), this.supportsFullscreen() && (this.__videoClassBackup = "", t = this._fullscreenedElement || this._element, this.__fullscreenListener = y.elementOnFullscreenChange(t, function (e, t) {
                      this.trigger("fullscreen-change", t), t ? (this.__videoClassBackup = this._element.className, this._element.className = "") : (this._element.className = this.__videoClassBackup, this.__videoClassBackup = "");
                    }, this)), this.supportsPIP() && "pictureInPictureElement" in document && (this.__pipListener = y.videoAddPIPChangeListeners(this._element, function (e, t) {
                      this.trigger("pip-mode-change", e, t);
                    }, this));
                  },
                  buffered: function buffered() {
                    return this._element.buffered.end(0);
                  },
                  _fullscreenElement: function _fullscreenElement(e) {
                    return b.isChromiumBased() && !b.isMobile() ? e || this._element.parentNode : b.isFirefox() ? e || this._element.parentElement : e || this._element;
                  },
                  supportsFullscreen: function supportsFullscreen(e) {
                    return y.elementSupportsFullscreen(this._fullscreenElement(e));
                  },
                  enterFullscreen: function enterFullscreen(e) {
                    y.elementEnterFullscreen(this._fullscreenElement(e));
                  },
                  exitFullscreen: function exitFullscreen() {
                    y.documentExitFullscreen();
                  },
                  isFullscreen: function isFullscreen(e) {
                    return y.elementIsFullscreen(this._fullscreenElement(e));
                  },
                  supportsPIP: function supportsPIP() {
                    return y.browserSupportsPIP(this._element);
                  },
                  enterPIPMode: function enterPIPMode(e) {
                    y.videoElementEnterPIPMode(this._element);
                  },
                  exitPIPMode: function exitPIPMode() {
                    y.videoElementExitPIPMode(this._element);
                  },
                  isInPIPMode: function isInPIPMode() {
                    return y.videoIsInPIPMode(this._element);
                  },
                  videoWidth: function videoWidth() {
                    return this._element.width || this.__imageWidth || NaN;
                  },
                  videoHeight: function videoHeight() {
                    return this._element.height || this.__imageHeight || NaN;
                  },
                  play: function play() {
                    t.play.call(this), this._audioElement && (this._reloadonplay && this._audioElement.load(), this._audioElement.play());
                  },
                  pause: function pause() {
                    this._element.pause(), this._audioElement && this._audioElement.pause();
                  },
                  setPosition: function setPosition(e) {
                    this._element.currentTime = e, this._audioElement && (this._audioElement.currentTime = e);
                  },
                  setSpeed: function setSpeed(e) {
                    e < .5 && 4 < e ? console.warn("Maximum allowed speed range is from 0.5 to 4.0") : (this._element.playbackRate = e, this._audioElement && (this._audioElement.playbackRate = e));
                  },
                  muted: function muted() {
                    return (this._audioElement ? this._audioElement : this._element).muted;
                  },
                  setMuted: function setMuted(e) {
                    (this._audioElement ? this._audioElement : this._element).muted = e;
                  },
                  volume: function volume() {
                    return (this._audioElement ? this._audioElement : this._element).volume;
                  },
                  setVolume: function setVolume(e) {
                    (this._audioElement ? this._audioElement : this._element).volume = e;
                  },
                  createSnapshotPromise: function createSnapshotPromise(e) {
                    var t,
                      i,
                      r = this._element,
                      o = document.createElement("canvas"),
                      a = o.getContext("2d");
                    if (o.width = r.videoWidth, o.height = r.videoHeight, a.drawImage(r, 0, 0, o.width, o.height), i = (t = o).getContext("2d"), new Uint32Array(i.getImageData(0, 0, t.width, t.height).data.buffer).some(function (e) {
                      return 0 !== e;
                    })) {
                      var n = m.create();
                      return o.toBlob(function (e) {
                        n.asyncSuccess(e);
                      }, e), n;
                    }
                    return m.error(!0);
                  }
                };
              });
            }), t.extend("module:Player.VideoPlayerWrapper", ["module:Player.VideoPlayerWrapper", "module:Player.Html5VideoPlayerWrapper"], function (e, t) {
              return e.register(t, 2), {};
            }), t.define("module:Recorder.PixelSampleMixin", [], function () {
              return {
                lightLevel: function lightLevel(e) {
                  e = e || 100;
                  var r = 0;
                  return this._pixelSample(e, function (e, t, i) {
                    r += e + t + i;
                  }), r / (3 * e);
                },
                blankLevel: function blankLevel(e) {
                  e = e || 100;
                  var r = 0;
                  return this._pixelSample(e, function (e, t, i) {
                    r += Math.pow(e, 2) + Math.pow(t, 2) + Math.pow(i, 2);
                  }), Math.sqrt(r / (3 * e));
                },
                _materializePixelSample: function _materializePixelSample(e) {
                  var r = [];
                  return this._pixelSample(e, function (e, t, i) {
                    r.push([e, t, i]);
                  }), r;
                },
                deltaCoefficient: function deltaCoefficient(e) {
                  e = e || 100;
                  var t = this._materializePixelSample(e);
                  if (!this.__deltaSample) return this.__deltaSample = t, null;
                  for (var i = 0, r = 0; r < t.length; ++r) for (var o = 0; o < 3; ++o) i += Math.pow(t[r][o] - this.__deltaSample[r][o], 2);
                  return this.__deltaSample = t, Math.sqrt(i / (3 * e));
                }
              };
            }), t.define("module:Recorder.VideoRecorderWrapper", ["base:Classes.ConditionalInstance", "base:Events.EventsMixin", "base:Objs", "base:Promise"], function (e, t, i, r, o) {
              return e.extend({
                scoped: o
              }, [t, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e), this._element = this._options.element, this.ready = r.create();
                  },
                  destroy: function destroy() {
                    t.destroy.call(this);
                  },
                  bindMedia: function bindMedia() {
                    return this._bindMedia();
                  },
                  _bindMedia: function _bindMedia() {},
                  unbindMedia: function unbindMedia() {
                    return this._unbindMedia();
                  },
                  _unbindMedia: function _unbindMedia() {},
                  softwareDependencies: function softwareDependencies() {
                    return this._softwareDependencies();
                  },
                  _softwareDependencies: function _softwareDependencies() {},
                  cameraWidth: function cameraWidth() {
                    return this._options.recordingWidth;
                  },
                  cameraHeight: function cameraHeight() {
                    return this._options.recordingHeight;
                  },
                  lightLevel: function lightLevel() {},
                  soundLevel: function soundLevel() {},
                  testSoundLevel: function testSoundLevel(e) {},
                  blankLevel: function blankLevel() {},
                  deltaCoefficient: function deltaCoefficient() {},
                  getVolumeGain: function getVolumeGain() {},
                  setVolumeGain: function setVolumeGain(e) {},
                  enumerateDevices: function enumerateDevices() {},
                  currentDevices: function currentDevices() {},
                  setCurrentDevices: function setCurrentDevices(e) {},
                  setCameraFace: function setCameraFace(e) {},
                  getCameraFacingMode: function getCameraFacingMode() {},
                  addMultiStream: function addMultiStream(e, t) {},
                  updateMultiStreamPosition: function updateMultiStreamPosition(e, t, i, r) {},
                  reverseCameraScreens: function reverseCameraScreens() {},
                  createSnapshot: function createSnapshot() {},
                  removeSnapshot: function removeSnapshot(e) {},
                  createSnapshotDisplay: function createSnapshotDisplay(e, t, i, r, o, a) {},
                  updateSnapshotDisplay: function updateSnapshotDisplay(e, t, i, r, o, a) {},
                  removeSnapshotDisplay: function removeSnapshotDisplay(e) {},
                  createSnapshotUploader: function createSnapshotUploader(e, t, i) {},
                  startRecord: function startRecord(e) {},
                  pauseRecord: function pauseRecord() {},
                  resumeRecord: function resumeRecord() {},
                  stopRecord: function stopRecord(e) {},
                  errorHandler: function errorHandler(e) {},
                  isWebrtcStreaming: function isWebrtcStreaming() {
                    return !1;
                  },
                  canPause: function canPause() {
                    return !1;
                  },
                  supportsLocalPlayback: function supportsLocalPlayback() {
                    return !1;
                  },
                  supportsCameraFace: function supportsCameraFace() {
                    return !1;
                  },
                  snapshotToLocalPoster: function snapshotToLocalPoster(e) {
                    return null;
                  },
                  localPlaybackSource: function localPlaybackSource() {
                    return null;
                  },
                  averageFrameRate: function averageFrameRate() {
                    return null;
                  },
                  recordDelay: function recordDelay(e) {
                    return 0;
                  }
                };
              }], {
                _initializeOptions: function _initializeOptions(e) {
                  return i.extend({
                    recordingWidth: 640,
                    recordingHeight: 480,
                    recordVideo: !0,
                    recordAudio: !0
                  }, e);
                }
              });
            }), t.define("module:WebRTC.Support", ["base:Promise", "base:Objs", "browser:Info", "browser:Dom", "base:Time"], function (h, p, b, x, m) {
              return {
                canvasSupportsImageFormat: function canvasSupportsImageFormat(t) {
                  try {
                    var i = document.createElement("canvas").toDataURL(t);
                    i.indexOf(";");
                    return -1 != i.substring(0, i.indexOf(";")).indexOf(t);
                  } catch (e) {
                    return !1;
                  }
                },
                getGlobals: function getGlobals() {
                  var e = null,
                    t = null,
                    t = navigator.mediaDevices && navigator.mediaDevices.getUserMedia ? (e = navigator.mediaDevices.getUserMedia, navigator.mediaDevices) : (e = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia, navigator),
                    i = window.URL || window.webkitURL,
                    r = window.MediaRecorder,
                    o = window.AudioContext || window.webkitAudioContext;
                  o && x.userInteraction(function () {
                    this.__globals && (this.__globals.audioContext = new o());
                  }, this);
                  var a = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection,
                    n = window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCIceCandidate,
                    s = window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription;
                  return {
                    getUserMedia: e,
                    getUserMediaCtx: t,
                    URL: i,
                    MediaRecorder: r,
                    AudioContext: o,
                    audioContextScriptProcessor: function audioContextScriptProcessor() {
                      return (this.createScriptProcessor || this.createJavaScriptNode).apply(this, arguments);
                    },
                    webpSupport: this.canvasSupportsImageFormat("image/webp"),
                    RTCPeerConnection: a,
                    RTCIceCandidate: n,
                    RTCSessionDescription: s,
                    WebSocket: window.WebSocket,
                    supportedConstraints: navigator.mediaDevices && navigator.mediaDevices.getSupportedConstraints ? navigator.mediaDevices.getSupportedConstraints() : {}
                  };
                },
                globals: function globals() {
                  return this.__globals || (this.__globals = this.getGlobals()), this.__globals;
                },
                userMediaSupported: function userMediaSupported() {
                  return !!this.globals().getUserMedia;
                },
                enumerateMediaSources: function enumerateMediaSources() {
                  var t = h.create(),
                    i = function i(e) {
                      var i = {
                        audio: {},
                        audioCount: 0,
                        video: {},
                        videoCount: 0
                      };
                      p.iter(e, function (e) {
                        var t;
                        0 === e.kind.indexOf("video") && (i.videoCount++, "undefined" != typeof e.getCapabilities && (t = e.getCapabilities()), i.video[e.id || e.deviceId] = {
                          id: e.id || e.deviceId,
                          label: e.label,
                          capabilities: t
                        }), 0 === e.kind.indexOf("audio") && (i.audioCount++, "undefined" != typeof e.getCapabilities && (t = e.getCapabilities()), i.audio[e.id || e.deviceId] = {
                          id: e.id || e.deviceId,
                          label: e.label,
                          capabilities: t
                        });
                      }), t.asyncSuccess(i);
                    };
                  try {
                    navigator.mediaDevices && navigator.mediaDevices.enumerateDevices ? navigator.mediaDevices.enumerateDevices().then(i) : MediaStreamTrack && MediaStreamTrack.getSources ? MediaStreamTrack.getSources(i) : t.asyncError("Unsupported");
                  } catch (e) {
                    t.asyncError(e);
                  }
                  return t;
                },
                streamQueryResolution: function streamQueryResolution(e) {
                  var t = h.create(),
                    i = this.bindStreamToVideo(e);
                  return i.addEventListener("playing", function () {
                    setTimeout(function () {
                      t.asyncSuccess({
                        stream: e,
                        width: i.videoWidth,
                        height: i.videoHeight
                      }), i.remove();
                    }, 500);
                  }), t;
                },
                chromeExtensionMessage: function chromeExtensionMessage(e, t) {
                  var i = h.create();
                  return chrome.runtime.sendMessage(e, t, i.asyncSuccessFunc()), i;
                },
                chromeExtensionExtract: function chromeExtensionExtract(e) {
                  var t = {};
                  return b.isChrome() ? (t.extensionId = e.chromeExtensionId, t.extensionInstallLink = e.chromeExtensionInstallLink) : b.isOpera() && (t.extensionId = e.operaExtensionId, t.extensionInstallLink = e.operaExtensionInstallLink), t;
                },
                userMedia: function userMedia(t) {
                  var i = h.create(),
                    r = this.globals().getUserMedia.call(this.globals().getUserMediaCtx, t, function (e) {
                      i.asyncSuccess(e);
                    }, function (e) {
                      i.asyncError(e);
                    });
                  try {
                    r.then && r.then(function (e) {
                      i.asyncSuccess(e);
                    }), r["catch"] && r["catch"](function (e) {
                      i.asyncError(e);
                    });
                  } catch (e) {}
                  return i;
                },
                userMedia2: function userMedia2(r) {
                  var i,
                    o = {};
                  if (r.audio && (o.audio = r.audio), r.screen && !r.video && (r.video = {}), !r.video) return this.userMedia(o);
                  if (r.screen && (r.video.width = r.video.width || window.innerWidth || document.body.clientWidth, r.video.height = r.video.height || window.innerHeight || document.body.clientHeight), b.isiOS()) return o.video = {}, r.video.width && (o.video.width = r.video.width), r.video.height && (o.video.height = r.video.height), r.video.frameRate && (o.video.frameRate = r.video.frameRate), r.video.cameraFaceFront !== undefined && (o.video.facingMode = {
                    exact: r.video.cameraFaceFront ? "user" : "environment"
                  }), this.userMedia(o);
                  if (r.screen && "undefined" != typeof navigator.mediaDevices.getDisplayMedia) {
                    i = h.create();
                    var a = this,
                      n = "boolean" != typeof r.audio || r.audio;
                    "undefined" == typeof r.video.resizeMode && (r.video.resizeMode = "none");
                    var t = {
                      cursor: "motion",
                      resizeMode: r.video.resizeMode,
                      displaySurface: "application"
                    };
                    0 < parseInt(r.video.width, 10) && (t.width = parseInt(r.video.width, 10)), 0 < parseInt(r.video.height, 10) && (t.height = parseInt(r.video.height, 10));
                    var s = navigator.mediaDevices.getDisplayMedia({
                      video: t,
                      audio: n
                    });
                    return s.then(function (t) {
                      t.getAudioTracks().length < 1 && n ? a.userMedia({
                        video: !1,
                        audio: !0
                      }).mapError(function (e) {
                        i.asyncSuccess(t);
                      }).mapSuccess(function (e) {
                        i.asyncSuccess(new MediaStream([t.getTracks()[0], e.getAudioTracks()[0]]));
                      }) : i.asyncSuccess(t);
                    }), s["catch"](function (e) {
                      i.asyncError(e);
                    }), i;
                  }
                  if (b.isFirefox()) return o.video = {}, !r.screen || (o.video.mediaSource = "screen", navigator.mediaDevices && navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().mediaSource) ? (!r.video.aspectRatio || r.video.width && r.video.height || (r.video.width ? r.video.height = Math.round(r.video.width / r.video.aspectRatio) : r.video.height && (r.video.width = Math.round(r.video.height * r.video.aspectRatio))), r.video.width && (o.video.width = {
                    ideal: r.video.width
                  }), r.video.height && (o.video.height = {
                    ideal: r.video.height
                  }), r.video.frameRate && (o.video.frameRate = {
                    ideal: r.video.frameRate
                  }), r.video.sourceId && (o.video.sourceId = r.video.sourceId), r.video.cameraFaceFront !== undefined && b.isMobile() && (o.video.facingMode = {
                    exact: r.video.cameraFaceFront ? "user" : "environment"
                  }), this.userMedia(o)) : h.error("This browser does not support screen recording.");
                  if (b.isEdge() && r.screen) {
                    if (navigator.getDisplayMedia) {
                      i = h.create();
                      var x = navigator.getDisplayMedia({
                        video: !0
                      });
                      return x.then(i.asyncSuccessFunc()), x["catch"](i.asyncErrorFunc()), i;
                    }
                    return h.error("This browser does not support screen recording.");
                  }
                  b.isAndroid() ? o.video = {} : o.video = {
                    mandatory: {}
                  };
                  var c = r.video.aspectRatio ? r.video.aspectRatio : r.video.width && r.video.height ? r.video.width / r.video.height : null;
                  "undefined" != typeof o.video.mandatory ? (r.video.width && (o.video.mandatory.minWidth = r.video.width, o.video.mandatory.maxWidth = r.video.width), !r.video.width && r.video.height && (o.video.mandatory.minHeight = r.video.height, o.video.mandatory.maxHeight = r.video.height), r.video.frameRate && (o.video.mandatory.minFrameRate = r.video.frameRate, o.video.mandatory.maxFrameRate = r.video.frameRate), r.video.sourceId && (o.video.mandatory.sourceId = r.video.sourceId)) : (r.video.cameraFaceFront !== undefined && b.isMobile() && (o.video.facingMode = {
                    exact: r.video.cameraFaceFront ? "user" : "environment"
                  }), r.video.width && (o.video.width = r.video.width), !r.video.width && r.video.height && (o.video.height = r.video.height), r.video.frameRate && (o.video.frameRate = r.video.frameRate), r.video.sourceId && (o.video.deviceId = r.video.sourceId)), c && ("undefined" != typeof o.video.mandatory ? (o.video.mandatory.minAspectRatio = c, o.video.mandatory.maxAspectRatio = c) : r.video.aspectRatio || (o.video.aspectRatio = c));
                  var d = function d(s) {
                    var x = "undefined" != typeof o.video.mandatory ? o.video.mandatory : o.video;
                    return this.userMedia(o).mapError(function (e) {
                      if (s--, "ConstraintNotSatisfiedError" !== e.name && "OverconstrainedError" !== e.name) return e;
                      var n = (e.constraintName || e.constraint).toLowerCase();
                      return p.iter(x, function (e, t) {
                        var i,
                          r,
                          o,
                          a = t.toLowerCase();
                        0 <= a.indexOf(n) && (i = 0 < a.indexOf("aspect"), r = 0 === a.indexOf("min") ? -1 : 1, o = Math.max(0, x[t] * (1 + r / 10)), x[t] = i ? o : Math.round(o), s < 0 && (delete x[t], s = 100));
                      }, this), d.call(this, s);
                    }, this);
                  };
                  if (r.screen) {
                    var l = this.chromeExtensionExtract(r.screen).extensionId;
                    if (!l) return h.error("This browser does not support screen recording.");
                    var u = m.now();
                    return this.chromeExtensionMessage(l, {
                      type: "ping",
                      data: u
                    }).mapSuccess(function (t) {
                      return i = h.create(), t && "success" === t.type && t.data === u ? (i.asyncSuccess(!0), i.mapSuccess(function () {
                        return this.chromeExtensionMessage(l, {
                          type: "acquire",
                          sources: ["window", "screen", "tab"],
                          url: window.self !== window.top ? window.location.href : null
                        }).mapSuccess(function (t) {
                          return t && "success" === t.type ? (o.video.mandatory.chromeMediaSource = "desktop", o.video.mandatory.chromeMediaSourceId = t.streamId, delete o.audio, d.call(this, 100).mapSuccess(function (i) {
                            return r.audio ? this.userMedia({
                              audio: !0
                            }).mapError(function () {
                              return h.value(i);
                            }).mapSuccess(function (t) {
                              try {
                                return new MediaStream([i.getVideoTracks()[0], t.getAudioTracks()[0]]);
                              } catch (e) {
                                return i;
                              }
                            }) : i;
                          }, this)) : h.error("Could not acquire permission to access screen.");
                        }, this);
                      }, this)) : h.error("This browser does not support screen recording.");
                    }, this);
                  }
                  return d.call(this, 100);
                },
                stopUserMediaStream: function stopUserMediaStream(t, i) {
                  var r = !1;
                  try {
                    t.getTracks && t.getTracks().forEach(function (e) {
                      e.stop(), r = !0;
                    }), 0 < i.length && p.iter(i, function (e) {
                      e.stop(), r = !0;
                    }, this);
                  } catch (e) {}
                  try {
                    !r && t.stop && t.stop();
                  } catch (e) {}
                },
                bindStreamToVideo: function bindStreamToVideo(e, t, i) {
                  return (t = t || document.createElement("video")).volume = 0, t.muted = !0, "mozSrcObject" in t ? t.mozSrcObject = e : "srcObject" in t ? t.srcObject = e : t.src = this.globals().URL.createObjectURL(e), i ? (t.style["-moz-transform"] = "scale(-1, 1)", t.style["-webkit-transform"] = "scale(-1, 1)", t.style["-o-transform"] = "scale(-1, 1)", t.style.transform = "scale(-1, 1)", t.style.filter = "FlipH") : (delete t.style["-moz-transform"], delete t.style["-webkit-transform"], delete t.style["-o-transform"], delete t.style.transform, delete t.style.filter), t.autoplay = !0, t.play(), t;
                },
                dataURItoBlob: function dataURItoBlob(e) {
                  if ("" !== e) {
                    for (var t = atob(e.split(",")[1]), i = e.split(",")[0].split(":")[1].split(";")[0], r = new ArrayBuffer(t.length), o = new Uint8Array(r), a = 0; a < t.length; a++) o[a] = t.charCodeAt(a);
                    var n = new DataView(r);
                    return new Blob([n], {
                      type: i
                    });
                  }
                },
                errorHandler: function errorHandler(e) {
                  switch (e) {
                    case "NotReadableError":
                    case "TrackStartError":
                      return {
                        key: "device-already-in-use",
                        message: "Web camera or microphone are already in use",
                        userLevel: !0
                      };
                    case "NotFoundError":
                    case "DevicesNotFoundError":
                      return {
                        key: "missing-track",
                        message: "Required audio or video track is missing",
                        userLevel: !0
                      };
                    case "OverconstrainedError":
                    case "ConstraintNotSatisfiedError":
                      return {
                        key: "constrains-error",
                        message: "Constraints can not be satisfied by available devices",
                        userLevel: !1
                      };
                    case "NotAllowedError":
                    case "PermissionDeniedError":
                      return {
                        key: "browser-permission-denied",
                        message: "Permission denied by browser, please grant access to proceed",
                        userLevel: !0
                      };
                    case "TypeError":
                      return {
                        key: "empty-constraints",
                        message: "Empty constraints object",
                        userLevel: !1
                      };
                    default:
                      return {
                        key: "unknown-error",
                        message: "Unknown Error",
                        userLevel: !1
                      };
                  }
                }
              };
            }), t.define("module:Recorder.Support", ["module:WebRTC.Support", "browser:Upload.FileUploader", "browser:Upload.CustomUploader", "browser:Dom", "browser:Events", "browser:Info", "base:Promise", "base:Objs"], function (c, r, e, x, u, p, h, o) {
              return {
                createSnapshot: function createSnapshot(e, t, i, r, o, a, n, s) {
                  var x = this._createSnapshot(e, t, i, r, o, a, n, s);
                  return x ? c.dataURItoBlob(x) : x;
                },
                createSnapshotFromSource: function createSnapshotFromSource(e, t, i, r, o, a, n, s, x) {
                  var c = h.create(),
                    d = document.createElement("video");
                  d.src = e;
                  var l = new u();
                  return l.on(d, "loadedmetadata", function () {
                    d.currentTime = i || 0;
                  }), l.on(d, "seeked", function () {
                    window.requestAnimationFrame(function () {
                      window.requestAnimationFrame(function () {
                        var e = this.createSnapshot(t, d, r, o, a, n, s, x);
                        e ? c.asyncSuccess(e) : c.asyncError("Could not capture snapshot");
                      }.bind(this));
                    }.bind(this)), l.destroy();
                  }, this), l.on(d, "error", function () {
                    c.asyncError("Could not load video to capture snapshot"), l.destroy();
                  }), d.load(), c;
                },
                _createSnapshot: function _createSnapshot(e, t, i, r, o, a, n, s) {
                  a = a || 0, n = n || 0, s = s || 1, i = i || !1;
                  var x = document.createElement("canvas");
                  x.width = o || t.videoWidth || t.clientWidth, x.height = r || t.videoHeight || t.clientHeight;
                  var c = 1 < +(x.width / x.height) ? "landscape" : "portrait",
                    d = p.isSafari() || p.isMobile() && p.isiOS(),
                    l = "portrait" == c && i && (p.isFirefox() || d),
                    u = x.getContext("2d");
                  l && 1 !== this.__detectVerticalSquash(t, x.width, x.height) ? this.__rotateToPortrait(t, x, u) : u.drawImage(t, a, n, x.width, x.height);
                  var h = x.toDataURL(e, s);
                  return this.__isCanvasBlank(x) ? null : h;
                },
                __rotateToPortrait: function __rotateToPortrait(e, t, i) {
                  var r = Math.abs(t.height - t.width),
                    o = t.width > t.height ? t.width : t.height;
                  t.height = t.width = o, i.drawImage(e, 0, 0, t.height, t.width), i.clearRect(0, 0, t.width, t.height), i.save(), t.width -= r, i.translate(t.width / 2, t.height / 2), i.rotate(Math.PI / 180 * 90), p.isFirefox() ? i.drawImage(e, -t.height / 2, -t.width / 2, t.height, t.width) : i.drawImage(e, -t.height / 2, -t.width / 2, t.height, t.width + r), i.restore();
                },
                __isCanvasBlank: function __isCanvasBlank(e) {
                  return !e.getContext("2d").getImageData(0, 0, e.width, e.height).data.some(function (e) {
                    return 0 !== e;
                  });
                },
                __detectVerticalSquash: function __detectVerticalSquash(e, t, i) {
                  t || e.naturalWidth || e.width;
                  var r = i || e.naturalHeight || e.height,
                    o = document.createElement("canvas");
                  o.width = 1, o.height = r;
                  var a = o.getContext("2d");
                  a.drawImage(e, 0, 0);
                  for (var n = a.getImageData(0, 0, 1, r).data, s = 0, x = r, c = r; s < c;) {
                    0 === n[4 * (c - 1) + 3] ? x = c : s = c, c = x + s >> 1;
                  }
                  var d = c / r;
                  return 0 == d ? 1 : d;
                },
                removeSnapshot: function removeSnapshot(e) {},
                removeSnapshotDisplay: function removeSnapshotDisplay(e) {
                  e.remove();
                },
                createSnapshotDisplay: function createSnapshotDisplay(e, t, i, r, o, a) {
                  var n = c.globals().URL.createObjectURL(t),
                    s = document.createElement("img");
                  return s.style.position = "absolute", this.updateSnapshotDisplay(t, s, i, r, o, a), s.src = n, "video" === e.tagName.toLowerCase() ? x.elementInsertAfter(s, e) : x.elementPrependChild(e, s), s;
                },
                snapshotMetaData: function snapshotMetaData(e) {
                  var o = h.create(),
                    t = c.globals().URL.createObjectURL(e),
                    a = new Image();
                  return a.src = t, a.onload = function (e) {
                    var t = a.naturalHeight || a.height,
                      i = a.naturalWidth || a.width,
                      r = +(i / t).toFixed(2);
                    o.asyncSuccess({
                      width: i,
                      height: t,
                      orientation: 1 < r ? "landscape" : "portrait",
                      ratio: r
                    });
                  }, o;
                },
                updateSnapshotDisplay: function updateSnapshotDisplay(e, t, i, r, o, a) {
                  t.style.left = i + "px", t.style.top = r + "px", t.style.width = o + "px", t.style.height = a + "px";
                },
                createSnapshotUploader: function createSnapshotUploader(e, t, i) {
                  return r.create(o.extend({
                    source: e
                  }, i));
                }
              };
            }), t.define("module:WebRTC.AudioAnalyser", ["base:Class", "browser:Info", "module:WebRTC.Support"], function (e, o, i, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this._audioContext = i.globals().audioContext, this._analyserNode = this._audioContext.createAnalyser.call(this._audioContext), this._analyserNode.fftSize = 32, 0 < e.getAudioTracks().length && (this._audioInput = this._audioContext.createMediaStreamSource(e), this._audioInput.connect(this._analyserNode));
                  },
                  destroy: function destroy() {
                    this._analyserNode.disconnect(), delete this._analyserNode, t.destroy.call(this);
                  },
                  soundLevel: function soundLevel() {
                    if (!this._audioInput) return 0;
                    var e = this._analyserNode.fftSize,
                      t = new Uint8Array(e);
                    this._analyserNode.getByteTimeDomainData(t);
                    for (var i = 0, r = 0; r < e; r++) i = Math.max(i, Math.abs(t[r] / 128));
                    return o.isMobile() && (o.isFirefox() || o.isAndroid()) ? i + .1 : i;
                  }
                };
              }, {
                supported: function supported() {
                  return !(!i.globals().AudioContext || !i.globals().audioContext || o.isSafari() || o.isiOS());
                }
              });
            }), t.define("module:WebRTC.AudioRecorder", ["base:Class", "base:Events.EventsMixin", "base:Objs", "base:Promise", "base:Functions", "module:WebRTC.Support", "module:Encoding.WaveEncoder.Support"], function (e, t, r, o, a, n, s, i) {
              return e.extend({
                scoped: i
              }, [t, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    i.constructor.call(this), this._channels = [], this._recordingLength = 0, this._options = r.extend({
                      audioChannels: 2,
                      bufferSize: 16384,
                      sampleRate: 44100
                    }, t), this._stream = e, this._started = !1, this._stopped = !1, this._volumeGainValue = 1;
                  },
                  _audioProcess: function _audioProcess(e) {
                    this._started && (this._channels.push(s.dumpInputBuffer(e.inputBuffer, this._options.audioChannels, this._actualBufferSize)), this._recordingLength += this._actualBufferSize);
                  },
                  destroy: function destroy() {
                    this.stop(), i.destroy.call(this);
                  },
                  getVolumeGain: function getVolumeGain() {
                    return this._volumeGainValue;
                  },
                  setVolumeGain: function setVolumeGain(e) {
                    this._volumeGainValue = e, this._volumeGain && (this._volumeGain.value.gain = e);
                  },
                  __initializeContext: function __initializeContext() {
                    var e = n.globals().AudioContext;
                    this._audioContext = new e(), this._actualSampleRate = this._audioContext.sampleRate || this._options.sampleRate, this._volumeGain = this._audioContext.createGain(), this._volumeGain.gain.value = this._volumeGainValue, this._audioInput = this._audioContext.createMediaStreamSource(this._stream), this._audioInput.connect(this._volumeGain), this._scriptProcessor = n.globals().audioContextScriptProcessor.call(this._audioContext, this._options.bufferSize, this._options.audioChannels, this._options.audioChannels), this._actualBufferSize = this._scriptProcessor.bufferSize, this._scriptProcessor.onaudioprocess = a.as_method(this._audioProcess, this), this._volumeGain.connect(this._scriptProcessor), this._scriptProcessor.connect(this._audioContext.destination);
                  },
                  __finalizeContext: function __finalizeContext() {
                    this._scriptProcessor.disconnect(), this._volumeGain.disconnect(), this._audioInput.disconnect(), this._scriptProcessor.onaudioprocess = null, this._audioContext.close(), delete this._scriptProcessor, delete this._volumeGain, delete this._audioInput, delete this._audioContext;
                  },
                  start: function start() {
                    return this._started || (this.__initializeContext(), this._startContextTime = this._audioContext.currentTime, this._started = !0, this._stopped = !1, this._recordingLength = 0, this._channels = [], this.trigger("started")), o.value(!0);
                  },
                  stop: function stop() {
                    this._started && !this._stopped && (this._stopContextTime = this._audioContext.currentTime, this._stopped = !0, this.trigger("stopped"), this.__finalizeContext(), this._started = !1, this._generateData());
                  },
                  _generateData: function _generateData() {
                    var t = 44,
                      e = this._recordingLength * this._options.audioChannels * 2 + 44,
                      i = new ArrayBuffer(e),
                      r = new DataView(i);
                    s.generateHeader(e, this._options.audioChannels, this._actualSampleRate, i), this._channels.forEach(function (e) {
                      s.waveChannelTransform(e, 1).value().forEach(function (e) {
                        r.setInt16(t, e, !0), t += 2;
                      });
                    }), this._data = new Blob([r], {
                      type: "audio/wav"
                    }), this._recordingLength = 0, this.trigger("data", this._data);
                  }
                };
              }], {
                supported: function supported() {
                  return !!n.globals().AudioContext;
                }
              });
            }), t.define("module:WebRTC.MediaRecorder", ["base:Class", "base:Events.EventsMixin", "base:Functions", "base:Promise", "browser:Info", "module:WebRTC.Support", "base:Async"], function (t, i, n, r, s, x, o, a) {
              return t.extend({
                scoped: a
              }, [i, function (a) {
                return {
                  constructor: function constructor(t, i) {
                    i = i || {}, a.constructor.call(this), this._stream = t, this._started = !1;
                    var r = x.globals().MediaRecorder,
                      o = {
                        mimeType: ""
                      };
                    try {
                      i.audioonly ? r.isTypeSupported("audio/mp3") ? o = {
                        mimeType: "audio/mp3"
                      } : r.isTypeSupported("audio/ogg;codecs=opus") && (o = {
                        mimeType: "audio/ogg;codecs=opus"
                      }) : "undefined" == typeof r.isTypeSupported ? o = {
                        mimeType: "video/webm"
                      } : r.isTypeSupported("video/webm;codecs=vp9") && !i.cpuFriendly ? o = {
                        mimeType: "video/webm;codecs=vp9"
                      } : r.isTypeSupported("video/webm;codecs=vp8") ? o = {
                        mimeType: "video/webm;codecs=vp8" + (s.isFirefox() && 71 <= s.firefoxVersion() ? ",opus" : "")
                      } : r.isTypeSupported("video/webm") ? o = {
                        mimeType: "video/webm"
                      } : r.isTypeSupported("video/webm;codecs=vp9") ? o = {
                        mimeType: "video/webm;codecs=vp9"
                      } : r.isTypeSupported("video/mp4") && (o = {
                        mimeType: "video/mp4"
                      });
                    } catch (e) {
                      o = {};
                    }
                    i.videoBitrate && (o.videoBitsPerSecond = 1e3 * i.videoBitrate), i.audioBitrate && (o.audioBitsPerSecond = 1e3 * i.audioBitrate), this.__audioonly = i.audioonly, this.__mediaRecorderOptions = o, this._mediaRecorder = new r(t, o), this._mediaRecorder.ondataavailable = n.as_method(this._dataAvailable, this), this._mediaRecorder.onstop = n.as_method(this._dataStop, this), this._mediaRecorder.onpause = n.as_method(this._hasPaused, this), this._mediaRecorder.onresume = n.as_method(this._hasResumed, this), this._mediaRecorder.onstart = n.as_method(this._recorderStarted, this), this._mediaRecorder.onerror = n.as_method(this.onErrorMethod, this);
                  },
                  _recorderStarted: function _recorderStarted(e) {
                    this._started = !0, this.trigger("started"), this._startRecPromise.asyncSuccess();
                  },
                  onErrorMethod: function onErrorMethod(e) {
                    this._startRecPromise.asyncError(e), this.trigger("error", e);
                  },
                  destroy: function destroy() {
                    this.stop(), a.destroy.call(this);
                  },
                  start: function start() {
                    return this._started ? r.value(!0) : (this._startRecPromise = r.create(), this._chunks = [], this._mediaRecorder.start(10), !s.isSafari() || "onstart" in MediaRecorder.prototype || (this._started = !0, this.trigger("started"), o.eventually(function () {
                      "recording" === this._mediaRecorder.state ? this._startRecPromise.asyncSuccess() : this._startRecPromise.asyncError("Could not start recording");
                    }, this, 1e3)), this._startRecPromise);
                  },
                  pause: function pause() {
                    !this._paused && this._started && (this._paused = !0, this._mediaRecorder.pause(), this.trigger("pause"));
                  },
                  _hasPaused: function _hasPaused() {
                    this.trigger("paused");
                  },
                  resume: function resume() {
                    this._paused && this._started && (this._paused = !1, this._mediaRecorder.resume(), this.trigger("resume"));
                  },
                  _hasResumed: function _hasResumed() {
                    this.trigger("resumed");
                  },
                  stop: function stop() {
                    this._started && (this._started = !1, this._mediaRecorder.stop(), this.trigger("stopped"));
                  },
                  _dataAvailable: function _dataAvailable(e) {
                    e.data && 0 < e.data.size && this._chunks.push(e.data);
                  },
                  _dataStop: function _dataStop(e) {
                    var t, i;
                    this._data = new Blob(this._chunks, {
                      type: this.__mediaRecorderOptions.mimeType.split(";")[0] || (this.__audioonly ? "audio/ogg" : "video/webm")
                    }), this._chunks = [], s.isFirefox() ? (t = this, (i = new FileReader()).onload = function () {
                      t._data = new Blob([this.result], {
                        type: t._data.type
                      }), t.trigger("data", t._data);
                    }, i.readAsArrayBuffer(this._data)) : this.trigger("data", this._data);
                  }
                };
              }], {
                supported: function supported() {
                  return !!x.globals().MediaRecorder && (0 === document.location.href.indexOf("https://") || "localhost" === document.location.hostname || !s.isOpera() && !s.isChrome()) && !(s.isOpera() && s.operaVersion() < 44) && !(s.isChrome() && s.chromeVersion() < 57);
                }
              });
            }), t.define("module:WebRTC.PeerRecorder", ["base:Class", "base:Events.EventsMixin", "base:Functions", "base:Objs", "base:Promise", "base:Async", "browser:Info", "module:WebRTC.Support"], function (e, t, o, s, a, n, x, c, i) {
              return e.extend({
                scoped: i
              }, [t, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    i.constructor.call(this), this._stream = e, !t.videoBitrate && t.recorderWidth && t.recorderHeight && (t.videoBitrate = Math.round(t.recorderWidth * t.recorderHeight / 250)), this._videoBitrate = t.videoBitrate || 1024, this._audioBitrate = t.audioBitrate || 256, this._videoFrameRate = t.framerate, this._audioonly = t.audioonly, this._started = !1;
                  },
                  destroy: function destroy() {
                    this.stop(), i.destroy.call(this);
                  },
                  start: function start(e) {
                    if (this._started) return a.value(!0);
                    this._wssUrl = e.wssUrl, this._streamInfo = e.streamInfo, this._userData = e.userData || {}, this._delay = e.delay || 0, this._started = !0, this._wsConnection = new (c.globals().WebSocket)(this._wssUrl), this._wsConnection.binaryType = "arraybuffer", this._wsConnection.onopen = o.as_method(this._wsOnOpen, this), this._wsConnection.onmessage = o.as_method(this._wsOnMessage, this), this._wsConnection.onclose = o.as_method(this._wsOnClose, this), this._wsConnection.onerror = this._errorCallback("WS_CONNECTION");
                    var t = a.create(),
                      i = {},
                      r = this;
                    return this.on("started", function () {
                      r.off(null, null, i), t.asyncSuccess(!0);
                    }, i).on("error", function (e) {
                      r.off(null, null, i), t.asyncError(e);
                    }, i), t;
                  },
                  stop: function stop() {
                    this._started && (this._started = !1, this._peerConnection && this._peerConnection.close(), this._peerConnection = null, this._wsConnection && this._wsConnection.close(), this._wsConnection = null, this.trigger("stopped"));
                  },
                  _wsOnOpen: function _wsOnOpen() {
                    this._peerConnection = new (c.globals().RTCPeerConnection)({
                      iceServers: []
                    }), this._stream.getTracks && this._peerConnection.addTrack ? s.iter(this._stream.getTracks(), function (e) {
                      this._peerConnection.addTrack(e, this._stream);
                    }, this) : this._peerConnection.addStream(this._stream);
                    var e = this._peerConnection.createOffer();
                    e.then(o.as_method(this._offerGotDescription, this)), e["catch"](this._errorCallback("PEER_CREATE_OFFER"));
                  },
                  _wsOnMessage: function _wsOnMessage(e) {
                    var t,
                      i = JSON.parse(e.data),
                      r = parseInt(i.status, 10);
                    i.command;
                    200 !== r ? this._error("MESSAGE_ERROR", {
                      status: r,
                      description: i.statusDescription
                    }) : (i.sdp !== undefined && ((t = this._peerConnection.setRemoteDescription(new (c.globals().RTCSessionDescription)(i.sdp))).then(function () {}), t["catch"](this._errorCallback("PEER_REMOTE_DESCRIPTION"))), i.iceCandidates && s.iter(i.iceCandidates, function (e) {
                      this._peerConnection.addIceCandidate(new (c.globals().RTCIceCandidate)(e));
                    }, this), n.eventually(function () {
                      this.trigger("started");
                    }, this, this._delay)), this._wsConnection && this._wsConnection.close(), this._wsConnection = null;
                  },
                  _offerGotDescription: function _offerGotDescription(e) {
                    var t = {};
                    return this._audioBitrate && (t.audioBitrate = Number(this._audioBitrate)), this._videoBitrate && !this._audioonly && (t.videoBitrate = Number(this._videoBitrate)), this._videoFrameRate && !this._audioonly && (t.videoFrameRate = Number(this._videoFrameRate)), e.sdp = this._enhanceSDP(e.sdp, t), this._peerConnection.setLocalDescription(e).then(o.as_method(function () {
                      this._wsConnection.send(JSON.stringify({
                        direction: "publish",
                        command: "sendOffer",
                        streamInfo: this._streamInfo,
                        sdp: e,
                        userData: this._userData
                      }));
                    }, this))["catch"](this._errorCallback("Peer Local Description"));
                  },
                  _enhanceSDP: function _enhanceSDP(e, r) {
                    var t = e.split(/\r\n/),
                      o = "header",
                      a = !1,
                      n = "";
                    return s.iter(t, function (e) {
                      var t, i;
                      e.length <= 0 || (n += e + "\r\n", 0 === e.indexOf("m=audio") ? a = !(o = "audio") : 0 === e.indexOf("m=video") ? a = !(o = "video") : 0 === e.indexOf("a=rtpmap") && (a = !(o = "bandwidth")), 0 !== e.indexOf("i=") && 0 !== e.indexOf("c=") && (a || (0 === "audio".localeCompare(o) ? r.audioBitrate !== undefined && (n += "b=AS:" + r.audioBitrate + "\r\n", n += "b=TIAS:" + 1024 * r.audioBitrate + "\r\n") : 0 === "video".localeCompare(o) ? r.videoBitrate !== undefined && (n += "b=AS:" + r.videoBitrate + "\r\n", n += "b=CT:" + r.videoBitrate + "\r\n", r.videoFrameRate !== undefined && (n += "a=framerate:" + r.videoFrameRate + "\r\n")) : 0 !== "bandwidth".localeCompare(o) || !x.isChrome() || null !== (i = this._getRTPMapID(e)) && (t = i[2].toLowerCase(), 0 !== "vp9".localeCompare(t) && 0 !== "vp8".localeCompare(t) && 0 !== "h264".localeCompare(t) && 0 !== "red".localeCompare(t) && 0 !== "ulpfec".localeCompare(t) && 0 !== "rtx".localeCompare(t) || r.videoBitrate !== undefined && (n += "a=fmtp:" + i[1] + " x-google-min-bitrate=" + r.videoBitrate + ";x-google-max-bitrate=" + r.videoBitrate + "\r\n"), 0 !== "opus".localeCompare(t) && 0 !== "isac".localeCompare(t) && 0 !== "g722".localeCompare(t) && 0 !== "pcmu".localeCompare(t) && 0 !== "pcma".localeCompare(t) && 0 !== "cn".localeCompare(t) || r.audioBitrate !== undefined && (n += "a=fmtp:" + i[1] + " x-google-min-bitrate=" + r.audioBitrate + ";x-google-max-bitrate=" + r.audioBitrate + "\r\n")), a = !0)));
                    }, this), n;
                  },
                  _getRTPMapID: function _getRTPMapID(e) {
                    var t = new RegExp("a=rtpmap:(\\d+) (\\w+)/(\\d+)"),
                      i = e.match(t);
                    return i && 3 <= i.length ? i : null;
                  },
                  _wsOnClose: function _wsOnClose() {},
                  _error: function _error(e, t) {
                    this.trigger("error", e + " " + t.toString(), t), this.stop();
                  },
                  _errorCallback: function _errorCallback(t) {
                    return o.as_method(function (e) {
                      this._error(t, e);
                    }, this);
                  }
                };
              }], {
                supported: function supported() {
                  if (x.isEdge()) return !1;
                  if (x.isSafari() && x.safariVersion() < 11) return !1;
                  if (0 !== document.location.href.indexOf("https://") && "localhost" !== document.location.hostname) {
                    if (x.isChrome() && 47 <= x.chromeVersion()) return !1;
                    if (x.isOpera() && 34 <= x.operaVersion()) return !1;
                  }
                  return c.globals().RTCPeerConnection && c.globals().RTCIceCandidate && c.globals().RTCSessionDescription && c.globals().WebSocket;
                }
              });
            }), t.define("module:WebRTC.RecorderWrapper", ["base:Classes.ConditionalInstance", "base:Events.EventsMixin", "base:Objs", "base:Async", "base:Promise", "base:Time", "module:WebRTC.Support", "module:Recorder.Support", "module:Recorder.PixelSampleMixin", "browser:Events"], function (t, i, l, d, r, o, u, a, n, s, x) {
              return t.extend({
                scoped: x
              }, [i, n, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e), this._video = e.video, this._localPlaybackRequested = e.localPlaybackRequested, this._recording = !1, this._bound = !1, this._hasAudio = !1, this._hasVideo = !1, this._screen = e.screen, this._resizeMode = e.resizeMode, this._flip = !!e.flip, this._screen && !e.flipscreen && (this._flip = !1), this._videoTrackSettings = {
                      slippedFromOrigin: {
                        height: 1,
                        width: 1
                      }
                    }, this._options.fittodimensions && (null === this._screen ? (this._initCanvasStreamSettings(), this._prepareRecorderStreamCanvas(!0)) : this._options.fittodimensions = !1);
                  },
                  _getConstraints: function _getConstraints() {
                    return {
                      audio: !!this._options.recordAudio && {
                        deviceId: this._options.audioId
                      },
                      video: !!this._options.recordVideo && {
                        frameRate: this._options.framerate,
                        sourceId: this._options.videoId,
                        width: this._options.recordResolution.width,
                        height: this._options.recordResolution.height,
                        cameraFaceFront: this._options.cameraFaceFront,
                        resizeMode: this._resizeMode
                      },
                      screen: this._screen
                    };
                  },
                  addNewSingleStream: function addNewSingleStream(e, t) {
                    var i, r;
                    this._initCanvasStreamSettings();
                    var o,
                      a = !0,
                      n = this._options.video.aspectRatio,
                      s = t.positionX || 0,
                      x = t.positionY || 0,
                      c = t.width || .2 * this._options.recordResolution.width || 120;
                    return (o = t.height) || (o = n ? Math.floor(c * n) : Math.floor(c / 1.33), a = !1), r = {
                      video: i = {
                        frameRate: this._options.framerate,
                        sourceId: e.id,
                        cameraFaceFront: this._options.cameraFaceFront
                      }
                    }, this._prepareRecorderStreamCanvas(), this._multiStreamConstraints = r, this.__addedStreamOptions = l.tree_merge(i, {
                      positionX: s,
                      positionY: x,
                      width: c,
                      height: o,
                      isTrueHeight: a
                    }), this.addNewMediaStream();
                  },
                  updateMultiStreamPosition: function updateMultiStreamPosition(e, t, i, r) {
                    this.__addedStreamOptions.positionX = e || this.__addedStreamOptions.positionX, this.__addedStreamOptions.positionY = t || this.__addedStreamOptions.positionY, this.__addedStreamOptions.width = i || this.__addedStreamOptions.width, this.__addedStreamOptions.height = r || this.__addedStreamOptions.height;
                  },
                  addNewMediaStream: function addNewMediaStream() {
                    var t = r.create();
                    return this._canvasStreams.length < 1 && this._canvasStreams.push(this._stream), u.userMedia2(this._multiStreamConstraints, this).success(function (e) {
                      this._canvasStreams.push(e), this._buildVideoElementsArray(t), this.on("stream-canvas-drawn", function () {
                        return t.asyncSuccess();
                      }, this);
                    }, this);
                  },
                  recordDelay: function recordDelay(e) {
                    return 0;
                  },
                  stream: function stream() {
                    return this._stream;
                  },
                  isWebrtcStreaming: function isWebrtcStreaming() {
                    return !1;
                  },
                  canPause: function canPause() {
                    return !1;
                  },
                  bindMedia: function bindMedia() {
                    if (!this._bound) return u.userMedia2(this._getConstraints()).success(function (e) {
                      var t, i, r, o, a, n;
                      this._options && (this._hasAudio = this._options.recordAudio && 0 < e.getAudioTracks().length, this._hasVideo = this._options.recordVideo && 0 < e.getVideoTracks().length, i = t = o = null, r = e.getVideoTracks()[0] || {}, this._hasVideo && "function" == typeof r.getSettings && (o = r.getSettings(), "undefined" != typeof r.onended && this.auto_destroy(new s()).on(r, "ended", function (e) {
                        this.trigger("mainvideostreamended");
                      }, this)), this._hasVideo && "function" == typeof r.getCapabilities && o && (i = r.getCapabilities(), t = this._getConstraints().video, i.width.max && i.height.max && this.__checkAndApplyCorrectConstraints(r, i, t, e)), o && t && this._options.fittodimensions && (a = t.width / t.height, n = o.width / o.height, Math.abs(a - n) <= .1 && (this._options.fittodimensions = !1)), this._options.fittodimensions && o ? (this._canvasStreams.push(e), this.__initialVideoTrackSettings || this.__calculateVideoTrackSettings(o, this._video, !0), this._videoTrackSettings.capabilities = i, this._videoTrackSettings.constrainsts = this._getConstraints().video, this._buildVideoElementsArray()) : (this._bound = !0, this._stream = e, this._setLocalTrackSettings(e), u.bindStreamToVideo(e, this._video, this._flip), this.trigger("bound", e), this._boundMedia()));
                    }, this);
                  },
                  selectCamera: function selectCamera(e) {
                    this._options.videoId = e, this._bound && (this.unbindMedia(), this.bindMedia(), this.trigger("rebound"));
                  },
                  selectMicrophone: function selectMicrophone(e) {
                    this._options.audioId = e, this._bound && (this.unbindMedia(), this.bindMedia(), this.trigger("rebound"));
                  },
                  selectCameraFace: function selectCameraFace(e) {
                    this._options.cameraFaceFront = e, this._bound && (this.unbindMedia(), this.bindMedia(), this.trigger("rebound"));
                  },
                  getCameraFacingMode: function getCameraFacingMode() {
                    return !0 === this._options.cameraFaceFront ? "user" : !1 === this._options.cameraFaceFront ? "environment" : undefined;
                  },
                  startRecord: function startRecord(e) {
                    if (this._recording) return r.value(!0);
                    this._recording = !0;
                    var t = this._startRecord(e);
                    return t.success(function () {
                      this._pausedDuration = 0, this._startTime = o.now();
                    }, this), t;
                  },
                  pauseRecord: function pauseRecord() {
                    this.canPause() && !this._paused && (this._paused = !0, this._recorder.once("paused", function () {
                      this.trigger("paused"), this.__pauseStartTime = o.now();
                    }, this), this._recorder.pause());
                  },
                  resumeRecord: function resumeRecord() {
                    this.canPause() && this._paused && (this._paused = !1, this._recorder.once("resumed", function () {
                      this.trigger("resumed"), this._pausedDuration += o.now() - this.__pauseStartTime, delete this.__pauseStartTime;
                    }, this), this._recorder.resume());
                  },
                  stopRecord: function stopRecord() {
                    this._recording && (this._recording = !1, this._stopRecord(), this._stopTime = o.now());
                  },
                  duration: function duration() {
                    return (this._recording || !this._stopTime ? o.now() : this._stopTime) - this._startTime - this._pausedDuration - (this.__pauseStartTime !== undefined ? o.now() - this.__pauseStartTime : 0);
                  },
                  unbindMedia: function unbindMedia() {
                    this._bound && !this._recording && (u.stopUserMediaStream(this._stream, this._sourceTracks), this._bound = !1, this.trigger("unbound"), this._unboundMedia());
                  },
                  createSnapshot: function createSnapshot(e) {
                    return a.createSnapshot(e, this._video);
                  },
                  _pixelSample: function _pixelSample(e, t, i) {
                    e = e || 100;
                    var r = this._video.videoWidth || this._video.clientWidth,
                      o = this._video.videoHeight || this._video.clientHeight,
                      a = Math.ceil(Math.sqrt(r / o * e)),
                      n = Math.ceil(Math.sqrt(o / r * e)),
                      s = document.createElement("canvas");
                    s.width = a, s.height = n;
                    var x = s.getContext("2d");
                    x.drawImage(this._video, 0, 0, a, n);
                    for (var c = 0; c < e; ++c) {
                      var d = c % a,
                        l = Math.floor(c / a),
                        u = x.getImageData(d, l, 1, 1).data;
                      t.call(i || this, u[0], u[1], u[2]);
                    }
                  },
                  _initCanvasStreamSettings: function _initCanvasStreamSettings() {
                    this._canvasStreams = [], this._videoElements = [], this._audioInputs = [], this._sourceTracks = [], this._multiStreamConstraints = {}, this._drawingStream = !1;
                  },
                  _prepareRecorderStreamCanvas: function _prepareRecorderStreamCanvas(e) {
                    var t, i;
                    this.__recorderStreamCanvas && this.__recorderStreamCtx || (t = this._videoTrackSettings.height || this._video.clientHeight || this._video.videoHeight, i = this._videoTrackSettings.width || this._video.clientWidth || this._video.videoWidth, "undefined" == typeof this.__recorderStreamCanvas && (this.__recorderStreamCanvas = document.createElement("canvas")), this.__recorderStreamCanvas.setAttribute("width", i), this.__recorderStreamCanvas.setAttribute("height", t), this.__recorderStreamCanvas.setAttribute("style", "position:fixed; left: 200%; pointer-events: none"), this.__recorderStreamCtx = this.__recorderStreamCanvas.getContext("2d"), this._drawerSetting = {
                      fittodimensions: e || !1,
                      streamsReversed: !1,
                      isMultiStream: !1
                    });
                  },
                  _setLocalTrackSettings: function _setLocalTrackSettings(e) {
                    var t, i;
                    void 0 !== e.getVideoTracks() && e.getVideoTracks()[0] && ((t = this)._videoTrack = e.getVideoTracks()[0], this._options.getDisplayMediaSupported ? "undefined" != typeof this._videoTrack.getSettings && (i = this._videoTrack.getSettings(), "undefined" == typeof this._videoTrackSettings.videoInnerFrame && (this._videoTrackSettings = l.extend(i, this._videoTrackSettings)), this._video.onloadedmetadata = function (e) {
                      t.__calculateVideoTrackSettings(i, e.target, !0);
                    }) : ("undefined" == typeof this._resizeMode && (this._resizeMode = "none"), this._videoTrack.applyConstraints({
                      resizeMode: this._resizeMode
                    }).then(function () {
                      "undefined" != typeof t._videoTrack.getSettings && (t._videoTrackSettings = l.extend(i, t._videoTrackSettings));
                    }))), "undefined" != typeof e.getAudioTracks && e.getAudioTracks()[0] && (this._audioTrack = e.getAudioTracks()[0], void 0 !== this._audioTrack.getSettings() && (this._audioTrackSettings = this._audioTrack.getSettings()));
                  },
                  __checkAndApplyCorrectConstraints: function __checkAndApplyCorrectConstraints(e, t, i) {
                    var r = t.width.max,
                      o = t.height.max;
                    if (i.width > r || i.height > o) {
                      var a,
                        n,
                        s,
                        x,
                        c = r / o,
                        d = i.width / i.height;
                      return t.aspectRatio.min && t.aspectRatio.max ? (d = i.width / i.height, s = t.aspectRatio.min, x = t.aspectRatio.max, 1 < d && x < d ? d = x : d < 1 && d < s && (d = s)) : d = c, i.width > r && i.height > o ? (a = 1 < d ? r : o * d, o < (n = 1 < d ? r / d : o) && 1 < d && (a = (n = o) / d), r < a && d < 1 && (n = (a = r) / d)) : i.width > r ? (n = 1 < d ? r / d : Math.min(o, i.height), a = 1 < d ? r : n * d) : i.height > o && (a = 1 < d ? Math.min(r, i.width) : o * d, n = 1 < d ? a / d : o), {
                        width: a,
                        height: n
                      };
                    }
                  },
                  __calculateVideoTrackSettings: function __calculateVideoTrackSettings(e, t, i) {
                    t = t || this._video;
                    var r = e.aspectRatio || e.width / e.height;
                    if (!isNaN(r)) {
                      var o = t.offsetWidth,
                        a = t.offsetHeight,
                        n = o <= a * r ? o : Math.round(a * r),
                        s = a * r < o ? a : Math.round(o / r),
                        x = e.width > n ? e.width / n : n / e.width,
                        c = e.height > s ? e.height / s : s / e.height,
                        d = l.extend(e, {
                          videoElement: {
                            width: o,
                            height: a
                          },
                          videoInnerFrame: {
                            width: n,
                            height: s
                          },
                          slippedFromOrigin: {
                            width: x,
                            height: c
                          }
                        });
                      return i && (this.__initialVideoTrackSettings = d), this._videoTrackSettings = d;
                    }
                  },
                  _buildVideoElementsArray: function _buildVideoElementsArray(o) {
                    this.__multiStreamVideoSettings = {
                      isMainStream: !0,
                      mainStream: {},
                      smallStream: {}
                    }, l.iter(this._canvasStreams, function (t, e) {
                      var i = t.getTracks(),
                        r = !1;
                      l.iter(i, function (e) {
                        this._sourceTracks.push(e), "video" === e.kind && (this._videoTrack && (r = e.id !== this._videoTrack.id, this._drawerSetting.isMultiStream = !0), this._videoElements.push(this._arraySingleVideoElement(this.__addedStreamOptions, t, r, e))), "audio" === e.kind && this._audioInputs.push(e);
                      }, this), this._videoElements.length + this._audioInputs.length === i.length && this._startDrawRecorderToCanvas(t), d.eventually(function () {
                        if (!this._drawingStream) return !!o && o.asyncError({
                          message: "Could not be able to get required tracks"
                        });
                      }, this, 1e3);
                    }, this);
                  },
                  _startDrawRecorderToCanvas: function _startDrawRecorderToCanvas(t) {
                    try {
                      var i,
                        r,
                        o,
                        a,
                        n,
                        s,
                        x,
                        c,
                        d,
                        l = t.getVideoTracks()[0].getSettings();
                      l.aspectRatio && .1 < Math.abs(l.aspectRatio - this._videoTrackSettings.aspectRatio) && (this._videoTrackSettings.aspectRatio = l.aspectRatio, this.__calculateVideoTrackSettings(l, null, !0), this.__recorderStreamCanvas.setAttribute("width", l.width), this.__recorderStreamCanvas.setAttribute("height", l.height)), this._drawingStream = !0, this._drawerSetting.fittodimensions && "undefined" != typeof this._videoTrackSettings.videoInnerFrame && (i = {}, r = this._videoTrackSettings.width, o = this._videoTrackSettings.height, a = (this.__recorderStreamCanvas.width = r) / (this.__recorderStreamCanvas.height = o), n = this._videoTrackSettings.videoInnerFrame, s = this._videoTrackSettings.videoElement, c = (x = this._videoTrackSettings.constrainsts).width / x.height, d = n.width === s.width, .1 <= Math.abs(a - c) && (d ? (i.ch = Math.round(r / c), i.ch > o && (d = !1)) : (i.cw = 1 < a ? Math.round(o * c) : Math.round(o / c), i.cw > r && (d = !0)), d ? (i.cw = r, i.ch = Math.round(r / c), i.cx = 0, i.cy = (o - i.ch) / 2, i.w = i.cw, i.h = i.ch, i.x = 0, i.y = (o - i.h) / 2) : (i.ch = o, i.cw = 1 < a ? Math.round(o * c) : Math.round(o / c), i.cy = 0, i.cx = (r - i.cw) / 2, i.w = i.cw, i.h = i.ch, i.y = 0, i.x = (r - i.w) / 2)), this.__cropSettings = i), this._drawTracksToCanvas(), this._startCanvasStreaming();
                    } catch (e) {
                      console.warn(e);
                    }
                  },
                  _drawTracksToCanvas: function _drawTracksToCanvas() {
                    if (this._drawingStream) {
                      var e = this._videoElements.length,
                        t = !1;
                      "undefined" != typeof this._drawerSetting && this._drawerSetting.streamsReversed && (t = !0);
                      for (var i = 0; i < this._videoElements.length; i++) {
                        var r,
                          o,
                          a,
                          n,
                          s,
                          x,
                          c = this._videoElements[i];
                        this._drawerSetting.fittodimensions ? (a = (o = this.__cropSettings).w, n = o.h, s = o.x, x = o.y, this.__recorderStreamCtx.drawImage(c, o.cx, o.cy, o.cw, o.ch, s, x, a, n)) : (s = (r = 0 !== i ? this.__addedStreamOptions : {}).positionX || 0, x = r.positionY || 0, c.__multistreamElement ? (a = t ? this._drawerSetting.smallStreamWidth : r.width || 360, n = t ? this._drawerSetting.smallStreamHeight : r.height || 240) : t ? (s = this._drawerSetting.positionX, x = this._drawerSetting.positionY, a = this._drawerSetting.width, n = this._drawerSetting.height, this.__multiStreamVideoSettings.mainStream && 0 < l.keys(this.__multiStreamVideoSettings.mainStream).length && (this.__recorderStreamCtx.fillStyle = "#000000", this.__recorderStreamCtx.fillRect(0, 0, this.__recorderStreamCanvas.width, this.__recorderStreamCanvas.height), this.__recorderStreamCtx.restore())) : (a = this.__recorderStreamCanvas.width || r.width || 360, n = this.__recorderStreamCanvas.height || r.height || 240), this.__recorderStreamCtx.drawImage(c, s, x, a, n)), 0 === --e && d.eventually(this._drawTracksToCanvas, this, 20);
                      }
                    }
                  },
                  reverseVideos: function reverseVideos() {
                    var e = this.__multiStreamVideoSettings.isMainStream;
                    this.__multiStreamVideoSettings.isMainStream = !e;
                    var t,
                      i,
                      r,
                      o,
                      a,
                      n,
                      s,
                      x,
                      c = this.__multiStreamVideoSettings.mainStream.settings,
                      d = this.__multiStreamVideoSettings.smallStream.settings;
                    if (e ? (s = d.aspectRatio, x = this._videoTrackSettings.aspectRatio || this._videoTrackSettings.width / this._videoTrackSettings.height, this._videoTrackSettings.videoElement.width === this._videoTrackSettings.videoInnerFrame.width ? (r = (o = c.streamHeight) * s, n = (a = d.videoWidth) / x) : (o = (r = c.streamWidth) / s, a = (n = d.videoHeight) * x), t = (c.streamWidth - r) / 2, i = (c.streamHeight - o) / 2, this._drawerSetting = {
                      streamsReversed: !0,
                      width: r,
                      height: o,
                      positionX: t,
                      positionY: i,
                      smallStreamHeight: n,
                      smallStreamWidth: a
                    }) : (this._drawerSetting.streamsReversed = !1, a = d.videoWidth, n = d.videoHeight), this._drawingStream) for (var l, u = document.createElement("video"), h = 0; h < this._videoElements.length; h++) {
                      u.srcObject ? u.srcObject && (this._videoElements[h].srcObject = u.srcObject, this._videoElements[h].load(), this._videoElements[h].oncanplay = function () {
                        this.play();
                      }, l = {
                        width: a,
                        height: n
                      }, e ? this.__calculateVideoTrackSettings(l) : this._videoTrackSettings = this.__initialVideoTrackSettings, this.trigger("multistream-camera-switched", l, e), u.remove()) : (u.srcObject = this._videoElements[h].srcObject, this._videoElements[h].srcObject = this._videoElements[h + 1].srcObject, this._videoElements[h].load(), this._videoElements[h].oncanplay = function () {
                        this.play();
                      });
                    }
                  },
                  _startCanvasStreaming: function _startCanvasStreaming() {
                    var e = this.__recorderStreamCanvas.captureStream(25);
                    this._audioInputs[0] && e.addTrack(this._audioInputs[0]), this._stream = e, u.bindStreamToVideo(e, this._video, this._flip), this.trigger("bound", e), this.trigger("stream-canvas-drawn"), this._setLocalTrackSettings(e), this._boundMedia(e);
                  },
                  _arraySingleVideoElement: function _arraySingleVideoElement(e, t, a, n) {
                    var s,
                      x = this,
                      i = u.bindStreamToVideo(t);
                    (a = a || !1) ? (i.__multistreamElement = !0, i.width = this.__addedStreamOptions.width || e.width || 360, i.height = this.__addedStreamOptions.height || e.height || 240) : (s = x._videoTrackSettings.videoInnerFrame, x._videoTrackSettings.aspectRatio);
                    var c = x._videoTrackSettings.slippedFromOrigin;
                    return i.muted = !0, i.volume = 0, i.oncanplay = function () {
                      var e = n.getSettings(),
                        t = this.width,
                        i = this.height,
                        r = a ? e.aspectRatio || e.width / e.height : r;
                      "undefined" != typeof x.__addedStreamOptions && !x.__addedStreamOptions._isTrueHeight && a && r && (i = 1 < r ? (t / r).toFixed(2) : (t * r).toFixed(2), x.__addedStreamOptions.height = i, x.updateMultiStreamPosition());
                      var o = {
                        track: n,
                        isMainScreen: a,
                        settings: {
                          videoWidth: a ? t : x._videoTrackSettings.videoElement.width,
                          videoHeight: a ? i : x._videoTrackSettings.videoElement.height,
                          streamWidth: a ? e.width : x._videoTrackSettings.width,
                          streamHeight: a ? e.height : x._videoTrackSettings.height,
                          visibleWidth: a ? t / c.width : s.width,
                          visibleHeight: a ? i / c.height : s.height,
                          deviceId: e.deviceId,
                          aspectRatio: r
                        }
                      };
                      a ? x.__multiStreamVideoSettings.smallStream = o : x.__multiStreamVideoSettings.mainStream = o, this.play();
                    }, i;
                  },
                  _boundMedia: function _boundMedia() {},
                  _unboundMedia: function _unboundMedia() {},
                  _startRecord: function _startRecord(e) {},
                  _stopRecord: function _stopRecord() {},
                  _error: function _error(e, t) {
                    this.trigger("error", e, t);
                  },
                  getVolumeGain: function getVolumeGain() {},
                  setVolumeGain: function setVolumeGain(e) {},
                  _dataAvailable: function _dataAvailable(e, t, i) {
                    this.destroyed() || this.trigger("data", e, t, i);
                  },
                  destroy: function destroy() {
                    this.stopRecord(), this.unbindMedia(), t.destroy.call(this);
                  },
                  averageFrameRate: function averageFrameRate() {
                    return null;
                  }
                };
              }], {
                _initializeOptions: function _initializeOptions(e) {
                  return l.extend({
                    recordAudio: !0,
                    recordVideo: !0,
                    recordResolution: {
                      width: 320,
                      height: 200
                    }
                  }, e);
                },
                supported: function supported(e) {
                  return !!u.globals().getUserMedia && !!u.globals().URL;
                }
              });
            }), t.define("module:AudioRecorder.WebRTCAudioRecorderWrapper", ["module:AudioRecorder.AudioRecorderWrapper", "module:WebRTC.RecorderWrapper", "module:WebRTC.Support", "module:WebRTC.AudioAnalyser", "browser:Dom", "browser:Info", "base:Time", "base:Objs", "browser:Upload.FileUploader", "browser:Upload.MultiUploader", "base:Promise"], function (e, i, r, o, a, t, n, s, x, c, d, l) {
              return e.extend({
                scoped: l
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e), "audio" !== this._element.tagName.toLowerCase() && (this._element = a.changeTag(this._element, "audio")), this._recorder = i.create({
                      video: this._element,
                      recordVideo: !1,
                      recordAudio: this._options.recordAudio,
                      audioBitrate: this._options.audioBitrate,
                      webrtcStreaming: this._options.webrtcStreaming,
                      webrtcStreamingIfNecessary: this._options.webrtcStreamingIfNecessary,
                      localPlaybackRequested: this._options.localPlaybackRequested
                    }), this._recorder.on("bound", function () {
                      this._analyser && this.testSoundLevel(!0);
                    }, this), this._recorder.on("error", function (e, t) {
                      this.trigger("error", e, t);
                    }, this), this.ready.asyncSuccess(!0);
                  },
                  destroy: function destroy() {
                    this._analyser && this._analyser.weakDestroy(), this._recorder.destroy(), t.destroy.call(this);
                  },
                  recordDelay: function recordDelay(e) {
                    return this._recorder.recordDelay(e);
                  },
                  _bindMedia: function _bindMedia() {
                    return this._recorder.bindMedia();
                  },
                  _unbindMedia: function _unbindMedia() {
                    return this._recorder.unbindMedia();
                  },
                  getVolumeGain: function getVolumeGain() {
                    return this._recorder.getVolumeGain();
                  },
                  setVolumeGain: function setVolumeGain(e) {
                    this._recorder.setVolumeGain(e);
                  },
                  soundLevel: function soundLevel() {
                    return !this._analyser && this._recorder && this._recorder.stream() && (this._analyser = new o(this._recorder.stream())), this._analyser ? this._analyser.soundLevel() : 0;
                  },
                  isWebrtcStreaming: function isWebrtcStreaming() {
                    return this._recorder.isWebrtcStreaming();
                  },
                  testSoundLevel: function testSoundLevel(e) {
                    this._analyser && (this._analyser.weakDestroy(), delete this._analyser), e && (this._analyser = new o(this._recorder.stream()));
                  },
                  currentDevices: function currentDevices() {
                    return {
                      audio: this._currentAudio
                    };
                  },
                  enumerateDevices: function enumerateDevices() {
                    return r.enumerateMediaSources().success(function (e) {
                      this._currentAudio || (this._currentAudio = s.ithKey(e.audio));
                    }, this);
                  },
                  setCurrentDevices: function setCurrentDevices(e) {
                    e && e.audio && this._recorder.selectMicrophone(e.audio);
                  },
                  canPause: function canPause() {
                    return this._recorder.canPause();
                  },
                  startRecord: function startRecord(e) {
                    return this.__localPlaybackSource = null, this._recorder.startRecord(e);
                  },
                  pauseRecord: function pauseRecord() {
                    return this._recorder.pauseRecord();
                  },
                  resumeRecord: function resumeRecord() {
                    return this._recorder.resumeRecord();
                  },
                  stopRecord: function stopRecord(o) {
                    var a = d.create();
                    return this._recorder.once("data", function (e, t, i) {
                      this.__localPlaybackSource = {
                        src: t || e
                      };
                      var r = new c();
                      this._options.simulate || i || e && r.addUploader(x.create(s.extend({
                        source: t || e
                      }, o.audio))), a.asyncSuccess(r);
                    }, this), this._recorder.stopRecord(), a;
                  },
                  supportsLocalPlayback: function supportsLocalPlayback() {
                    return !!this.__localPlaybackSource.src;
                  },
                  localPlaybackSource: function localPlaybackSource() {
                    return this.__localPlaybackSource;
                  },
                  _softwareDependencies: function _softwareDependencies() {
                    return d.value(!0);
                  }
                };
              }, {
                supported: function supported(e) {
                  return !!i.anySupport(e);
                }
              });
            }), t.extend("module:AudioRecorder.AudioRecorderWrapper", ["module:AudioRecorder.AudioRecorderWrapper", "module:AudioRecorder.WebRTCAudioRecorderWrapper"], function (e, t) {
              return e.register(t, 2), {};
            }), t.define("module:ImageRecorder.WebRTCImageRecorderWrapper", ["module:ImageRecorder.ImageRecorderWrapper", "module:WebRTC.RecorderWrapper", "module:WebRTC.Support", "browser:Dom", "browser:Info", "base:Time", "base:Objs", "browser:Upload.FileUploader", "browser:Upload.MultiUploader", "base:Promise"], function (e, i, x, c, r, o, a, n, t, s, d) {
              return e.extend({
                scoped: d
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e), "video" !== this._element.tagName.toLowerCase() && (this._element = c.changeTag(this._element, "video")), this._recorder = i.create({
                      video: this._element,
                      flip: !!this._options.flip,
                      recordVideo: !0,
                      recordAudio: !1,
                      recordResolution: {
                        width: this._options.recordingWidth,
                        height: this._options.recordingHeight
                      },
                      videoBitrate: this._options.videoBitrate,
                      screen: this._options.screen
                    }), this._recorder.on("error", function (e, t) {
                      this.trigger("error", e, t);
                    }, this), this.ready.asyncSuccess(!0);
                  },
                  destroy: function destroy() {
                    this._recorder.destroy(), t.destroy.call(this);
                  },
                  _bindMedia: function _bindMedia() {
                    return this._recorder.bindMedia();
                  },
                  _unbindMedia: function _unbindMedia() {
                    return this._recorder.unbindMedia();
                  },
                  lightLevel: function lightLevel() {
                    return this._recorder.lightLevel();
                  },
                  blankLevel: function blankLevel() {
                    return this._recorder.blankLevel();
                  },
                  deltaCoefficient: function deltaCoefficient() {
                    return this._recorder.deltaCoefficient();
                  },
                  currentDevices: function currentDevices() {
                    return {
                      video: this._currentVideo
                    };
                  },
                  enumerateDevices: function enumerateDevices() {
                    return x.enumerateMediaSources().success(function (e) {
                      this._currentVideo || (this._currentVideo = a.ithKey(e.video));
                    }, this);
                  },
                  setCurrentDevices: function setCurrentDevices(e) {
                    e && e.video && this._recorder.selectCamera(e.video);
                  },
                  setCameraFace: function setCameraFace(e) {
                    r.isMobile() && this._recorder.selectCameraFace(e);
                  },
                  getCameraFacingMode: function getCameraFacingMode() {
                    if (r.isMobile()) return this._recorder.getCameraFacingMode();
                  },
                  createSnapshot: function createSnapshot(e) {
                    return this._recorder.createSnapshot(e);
                  },
                  removeSnapshot: function removeSnapshot(e) {},
                  createSnapshotDisplay: function createSnapshotDisplay(e, t, i, r, o, a) {
                    var n = x.globals().URL.createObjectURL(t),
                      s = document.createElement("img");
                    return s.style.position = "absolute", this.updateSnapshotDisplay(t, s, i, r, o, a), s.src = n, c.elementPrependChild(e, s), s;
                  },
                  updateSnapshotDisplay: function updateSnapshotDisplay(e, t, i, r, o, a) {
                    t.style.left = i + "px", t.style.top = r + "px", t.style.width = o + "px", t.style.height = a + "px";
                  },
                  removeSnapshotDisplay: function removeSnapshotDisplay(e) {
                    e.remove();
                  },
                  createSnapshotUploader: function createSnapshotUploader(e, t, i) {
                    return n.create(a.extend({
                      source: e
                    }, i));
                  },
                  snapshotToLocalPoster: function snapshotToLocalPoster(e) {
                    return e;
                  },
                  _softwareDependencies: function _softwareDependencies() {
                    if (!this._options.screen || x.globals().supportedConstraints.mediaSource) return s.value(!0);
                    var e = x.chromeExtensionExtract(this._options.screen),
                      t = [{
                        title: "Screen Recorder Extension",
                        execute: function execute() {
                          window.open(e.extensionInstallLink);
                        }
                      }],
                      i = o.now();
                    return x.chromeExtensionMessage(e.extensionId, {
                      type: "ping",
                      data: i
                    }).mapError(function () {
                      return t;
                    }).mapSuccess(function (e) {
                      return !(!e || "success" !== e.type || e.data !== i) || s.error(t);
                    });
                  }
                };
              }, {
                supported: function supported(e) {
                  return !!i.anySupport(e) && (!e.screen || !!(x.globals().supportedConstraints.mediaSource && r.isFirefox() && 55 < r.firefoxVersion()) || !(!r.isChrome() || !e.screen.chromeExtensionId) || !(!r.isOpera() || !e.screen.operaExtensionId));
                }
              });
            }), t.extend("module:ImageRecorder.ImageRecorderWrapper", ["module:ImageRecorder.ImageRecorderWrapper", "module:ImageRecorder.WebRTCImageRecorderWrapper"], function (e, t) {
              return e.register(t, 2), {};
            }), t.define("module:Recorder.WebRTCVideoRecorderWrapper", ["module:Recorder.VideoRecorderWrapper", "module:WebRTC.RecorderWrapper", "module:WebRTC.Support", "module:WebRTC.AudioAnalyser", "browser:Dom", "browser:Info", "base:Time", "base:Objs", "base:Timers.Timer", "base:Comparators", "browser:Upload.FileUploader", "browser:Upload.MultiUploader", "base:Promise"], function (e, i, x, r, c, o, a, s, n, d, l, u, h, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this, e), "video" !== this._element.tagName.toLowerCase() && (this._element = c.changeTag(this._element, "video")), this._recorder = i.create({
                      video: this._element,
                      flip: !!this._options.flip,
                      flipscreen: !!this._options.flipscreen,
                      framerate: this._options.framerate,
                      recordVideo: this._options.recordVideo,
                      recordFakeVideo: !this._options.recordVideo,
                      recordAudio: this._options.recordAudio,
                      recordResolution: {
                        width: this._options.recordingWidth,
                        height: this._options.recordingHeight
                      },
                      resizeMode: this._options.resizeMode,
                      videoBitrate: this._options.videoBitrate,
                      audioBitrate: this._options.audioBitrate,
                      webrtcStreaming: this._options.webrtcStreaming,
                      webrtcStreamingIfNecessary: this._options.webrtcStreamingIfNecessary,
                      localPlaybackRequested: this._options.localPlaybackRequested,
                      screen: this._options.screen,
                      getDisplayMediaSupported: "undefined" != typeof navigator.mediaDevices.getDisplayMedia,
                      fittodimensions: this._options.fittodimensions,
                      cpuFriendly: this._options.cpuFriendly
                    }), this._recorder.on("bound", function () {
                      this._analyser && this.testSoundLevel(!0);
                    }, this), this._recorder.on("error", function (e, t) {
                      this.trigger("error", e, t);
                    }, this), this._recorder.on("mainvideostreamended", function () {
                      this.trigger("mainvideostreamended");
                    }, this), this.ready.asyncSuccess(!0);
                  },
                  destroy: function destroy() {
                    this._analyser && this._analyser.weakDestroy(), this._recorder.destroy(), t.destroy.call(this);
                  },
                  recordDelay: function recordDelay(e) {
                    return this._recorder.recordDelay(e);
                  },
                  _bindMedia: function _bindMedia() {
                    return this._recorder.bindMedia();
                  },
                  _unbindMedia: function _unbindMedia() {
                    return this._recorder.unbindMedia();
                  },
                  lightLevel: function lightLevel() {
                    return this._recorder.lightLevel();
                  },
                  blankLevel: function blankLevel() {
                    return this._recorder.blankLevel();
                  },
                  getVolumeGain: function getVolumeGain() {
                    return this._recorder.getVolumeGain();
                  },
                  setVolumeGain: function setVolumeGain(e) {
                    this._recorder.setVolumeGain(e);
                  },
                  deltaCoefficient: function deltaCoefficient() {
                    return this._recorder.deltaCoefficient();
                  },
                  isWebrtcStreaming: function isWebrtcStreaming() {
                    return this._recorder.isWebrtcStreaming();
                  },
                  canPause: function canPause() {
                    return this._recorder.canPause();
                  },
                  soundLevel: function soundLevel() {
                    return !this._analyser && this._recorder && this._recorder.stream() && r.supported() && (this._analyser = new r(this._recorder.stream())), this._analyser ? this._analyser.soundLevel() : 1.1;
                  },
                  testSoundLevel: function testSoundLevel(e) {
                    this._analyser && (this._analyser.weakDestroy(), delete this._analyser), e && r.supported() && (this._analyser = new r(this._recorder.stream()));
                  },
                  currentDevices: function currentDevices() {
                    return {
                      video: this._currentVideo,
                      audio: this._currentAudio
                    };
                  },
                  enumerateDevices: function enumerateDevices() {
                    return x.enumerateMediaSources().success(function (e) {
                      this._detectCurrentDeviceId(e.video, e.videoCount, !0), this._detectCurrentDeviceId(e.audio, e.audioCount, !1);
                      var t = this.auto_destroy(new n({
                        start: !0,
                        delay: 100,
                        context: this,
                        destroy_on_stop: !0,
                        fire: function fire() {
                          this._currentVideo && this._currentAudio && (this.trigger("currentdevicesdetected", {
                            video: this._currentVideo,
                            audio: this._currentAudio
                          }), t.stop());
                        }
                      }));
                    }, this);
                  },
                  addMultiStream: function addMultiStream(e, t) {
                    return this._recorder.addNewSingleStream(e, t);
                  },
                  updateMultiStreamPosition: function updateMultiStreamPosition(e, t, i, r) {
                    return this._recorder.updateMultiStreamPosition(e, t, i, r);
                  },
                  reverseCameraScreens: function reverseCameraScreens() {
                    return this._recorder.reverseVideos();
                  },
                  setCurrentDevices: function setCurrentDevices(e) {
                    e && e.video && this._recorder.selectCamera(e.video), e && e.audio && this._recorder.selectMicrophone(e.audio);
                  },
                  setCameraFace: function setCameraFace(e) {
                    o.isMobile() && this._recorder.selectCameraFace(e);
                  },
                  getCameraFacingMode: function getCameraFacingMode() {
                    if (o.isMobile()) return this._recorder.getCameraFacingMode();
                  },
                  createSnapshot: function createSnapshot(e) {
                    return this._recorder.createSnapshot(e);
                  },
                  removeSnapshot: function removeSnapshot(e) {},
                  createSnapshotDisplay: function createSnapshotDisplay(e, t, i, r, o, a) {
                    var n = x.globals().URL.createObjectURL(t),
                      s = document.createElement("img");
                    return s.style.position = "absolute", this.updateSnapshotDisplay(t, s, i, r, o, a), s.src = n, "video" === e.tagName.toLowerCase() ? c.elementInsertAfter(s, e) : c.elementPrependChild(e, s), s;
                  },
                  updateSnapshotDisplay: function updateSnapshotDisplay(e, t, i, r, o, a) {
                    t.style.left = i + "px", t.style.top = r + "px", t.style.width = o + "px", t.style.height = a + "px";
                  },
                  removeSnapshotDisplay: function removeSnapshotDisplay(e) {
                    e.remove();
                  },
                  createSnapshotUploader: function createSnapshotUploader(e, t, i) {
                    return l.create(s.extend({
                      source: e
                    }, i));
                  },
                  startRecord: function startRecord(e) {
                    return this.__localPlaybackSource = null, this._recorder.startRecord(e);
                  },
                  pauseRecord: function pauseRecord() {
                    return this._recorder.pauseRecord();
                  },
                  resumeRecord: function resumeRecord() {
                    return this._recorder.resumeRecord();
                  },
                  stopRecord: function stopRecord(o) {
                    var a = h.create();
                    return this._recorder.once("data", function (e, t, i) {
                      this.__localPlaybackSource = {
                        src: e,
                        audiosrc: t
                      };
                      var r = new u();
                      this._options.simulate || i || (e && r.addUploader(l.create(s.extend({
                        source: e
                      }, o.video))), t && r.addUploader(l.create(s.extend({
                        source: t
                      }, o.audio)))), a.asyncSuccess(r);
                    }, this), this._recorder.stopRecord(), a;
                  },
                  supportsLocalPlayback: function supportsLocalPlayback() {
                    return !(o.isSafari() && this.isWebrtcStreaming() || !this.__localPlaybackSource.src);
                  },
                  supportsCameraFace: function supportsCameraFace() {
                    return o.isMobile();
                  },
                  snapshotToLocalPoster: function snapshotToLocalPoster(e) {
                    return e;
                  },
                  localPlaybackSource: function localPlaybackSource() {
                    return this.__localPlaybackSource;
                  },
                  averageFrameRate: function averageFrameRate() {
                    return this._recorder.averageFrameRate();
                  },
                  _softwareDependencies: function _softwareDependencies() {
                    if (!this._options.screen || this._options.screen && "undefined" != typeof navigator.mediaDevices.getDisplayMedia || x.globals().supportedConstraints.mediaSource) return h.value(!0);
                    var e = x.chromeExtensionExtract(this._options.screen),
                      t = [{
                        title: "Screen Recorder Extension",
                        execute: function execute() {
                          window.open(e.extensionInstallLink);
                        }
                      }],
                      i = a.now();
                    return x.chromeExtensionMessage(e.extensionId, {
                      type: "ping",
                      data: i
                    }).mapError(function () {
                      return t;
                    }).mapSuccess(function (e) {
                      return !(!e || "success" !== e.type || e.data !== i) || h.error(t);
                    });
                  },
                  _detectCurrentDeviceId: function _detectCurrentDeviceId(i, r, o) {
                    var a,
                      n,
                      e = o ? (a = this._recorder._videoTrack, this._recorder._videoTrackSettings) : (a = this._recorder._audioTrack, this._recorder._audioTrackSettings);
                    return e && a ? e.deviceId && i[e.deviceId] ? (o ? this._currentVideo = i[e.deviceId].id : this._currentAudio = i[e.deviceId].id, i[e.deviceId].id) : a.label ? (n = 1, void s.iter(i, function (e, t) {
                      return 0 === d.byValue(e.label, a.label) ? (o ? this._currentVideo = t : this._currentAudio = t, t) : r <= n ? (o ? this._currentVideo = s.ithKey(i) : this._currentAudio = s.ithKey(i), s.ithKey(i)) : void n++;
                    }, this)) : (o ? this._currentVideo = s.ithKey(i) : this._currentAudio = s.ithKey(i), s.ithKey(i)) : (o ? this._currentVideo = s.ithKey(i) : this._currentAudio = s.ithKey(i), s.ithKey(i));
                  },
                  errorHandler: function errorHandler(e) {
                    return x.errorHandler(e);
                  }
                };
              }, {
                supported: function supported(e) {
                  return !!i.anySupport(e) && (!e.screen || !(!(o.isChrome() || o.isFirefox() || o.isOpera() || o.isSafari() && x.globals().MediaRecorder) || "undefined" == typeof navigator.mediaDevices.getDisplayMedia) || !!(x.globals().supportedConstraints.mediaSource && o.isFirefox() && 55 < o.firefoxVersion()) || !(!o.isChrome() || !e.screen.chromeExtensionId) || !(!o.isOpera() || !e.screen.operaExtensionId));
                }
              });
            }), t.extend("module:Recorder.WebRTCVideoRecorderWrapper", ["module:Recorder.VideoRecorderWrapper", "module:Recorder.WebRTCVideoRecorderWrapper"], function (e, t) {
              return e.register(t, 2), {};
            }), t.define("module:WebRTC.PeerRecorderWrapper", ["module:WebRTC.RecorderWrapper", "module:WebRTC.PeerRecorder", "module:WebRTC.MediaRecorder", "browser:Info", "base:Async"], function (e, i, t, r, o, a) {
              return e.extend({
                scoped: a
              }, {
                _boundMedia: function _boundMedia() {
                  this._recorder = new i(this._stream, {
                    recorderWidth: this._options.recordResolution.width,
                    recorderHeight: this._options.recordResolution.height,
                    videoBitrate: this._options.videoBitrate,
                    audioBitrate: this._options.audioBitrate,
                    framerate: this._options.framerate,
                    audioonly: !this._options.recordVideo
                  }), this._localPlaybackRequested && t.supported() && (this.__localMediaRecorder = new t(this._stream)), this._recorder.on("error", this._error, this);
                },
                _unboundMedia: function _unboundMedia() {
                  this._recorder.destroy(), this.__localMediaRecorder && this.__localMediaRecorder.weakDestroy();
                },
                _startRecord: function _startRecord(e) {
                  return this.__localMediaRecorder && this.__localMediaRecorder.start(), this._recorder.start(e.webrtcStreaming);
                },
                isWebrtcStreaming: function isWebrtcStreaming() {
                  return !0;
                },
                _stopRecord: function _stopRecord() {
                  this._recorder.stop();
                  var t = null;
                  this.__localMediaRecorder && (this.__localMediaRecorder.once("data", function (e) {
                    t = e;
                  }), this.__localMediaRecorder.stop()), o.eventually(function () {
                    this._dataAvailable(t, null, !0);
                  }, this, this.__stopDelay || this._options.webrtcStreaming.stopDelay || 0);
                },
                recordDelay: function recordDelay(e) {
                  return this.__stopDelay = e.webrtcStreaming.stopDelay, e.webrtcStreaming.delay || 0;
                },
                getVolumeGain: function getVolumeGain() {},
                setVolumeGain: function setVolumeGain(e) {},
                averageFrameRate: function averageFrameRate() {
                  return null;
                }
              }, function (t) {
                return {
                  supported: function supported(e) {
                    return !!t.supported.call(this, e) && (!e.screen || !r.isFirefox()) && e.webrtcStreaming && i.supported();
                  }
                };
              });
            }), t.define("module:WebRTC.PeerRecorderWrapperIfNecessary", ["module:WebRTC.PeerRecorderWrapper", "base:Objs"], function (e, i, t) {
              return e.extend({
                scoped: t
              }, {}, function (t) {
                return {
                  supported: function supported(e) {
                    return e.webrtcStreamingIfNecessary && ((e = i.clone(e, 1)).webrtcStreamingIfNecessary = !1, e.webrtcStreaming = !0), t.supported.call(this, e);
                  }
                };
              });
            }), t.define("module:WebRTC.MediaRecorderWrapper", ["module:WebRTC.RecorderWrapper", "module:WebRTC.MediaRecorder"], function (e, i, t) {
              return e.extend({
                scoped: t
              }, {
                _boundMedia: function _boundMedia(e) {
                  e = e || this._stream, this._recorder = new i(e, {
                    videoBitrate: this._options.videoBitrate,
                    audioBitrate: this._options.audioBitrate,
                    audioonly: !this._options.recordVideo,
                    cpuFriendly: this._options.cpuFriendly
                  }), this._recorder.on("data", function (e) {
                    this._dataAvailable(e);
                  }, this);
                },
                _unboundMedia: function _unboundMedia() {
                  this._recorder.destroy(), this._drawingStream && this._initCanvasStreamSettings();
                },
                _startRecord: function _startRecord() {
                  return this._recorder.start();
                },
                _stopRecord: function _stopRecord() {
                  this._recorder.stop();
                },
                canPause: function canPause() {
                  return !0;
                },
                getVolumeGain: function getVolumeGain() {},
                setVolumeGain: function setVolumeGain(e) {},
                averageFrameRate: function averageFrameRate() {
                  return null;
                }
              }, function (t) {
                return {
                  supported: function supported(e) {
                    return !!t.supported.call(this, e) && !e.recordFakeVideo && i.supported();
                  }
                };
              });
            }), t.define("module:WebRTC.WhammyRecorder", ["base:Class", "base:Events.EventsMixin", "base:Objs", "base:Time", "base:Functions", "base:Promise", "base:Async", "module:WebRTC.Support", "module:Encoding.WebmEncoder.Support"], function (e, t, r, o, i, a, n, s, c, x) {
              return e.extend({
                scoped: x
              }, [t, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    i.constructor.call(this), this._stream = e, this._options = r.extend({
                      recordWidth: 320,
                      recordHeight: 240,
                      quality: undefined,
                      video: null,
                      framerate: null
                    }, t), this._started = !1;
                  },
                  destroy: function destroy() {
                    this._started = !1, this.trigger("stopped"), i.destroy.call(this);
                  },
                  start: function start() {
                    return this._started || (this._started = !0, this._options.video && (this._options.recordWidth = this._options.video.videoWidth || this._options.video.clientWidth, this._options.recordHeight = this._options.video.videoHeight || this._options.video.clientHeight), this._video = document.createElement("video"), this._video.width = this._options.recordWidth || 80, this._video.height = this._options.recordHeight || 60, this._stream && s.bindStreamToVideo(this._stream, this._video), this._canvas = document.createElement("canvas"), this._canvas.width = this._options.recordWidth || 80, this._canvas.height = this._options.recordHeight || 60, this._context = this._canvas.getContext("2d"), this._frames = [], this._lastTime = o.now(), this._startTime = this._lastTime, this.trigger("started"), n.eventually(this._process, [], this)), a.value(!0);
                  },
                  stop: function stop() {
                    this._started && (this._started = !1, this.trigger("stopped"), this._generateData());
                  },
                  _process: function _process() {
                    var e, t, i;
                    this._started && (t = (e = o.now()) - this._lastTime, this._lastTime = e, this._context.drawImage(this._video, 0, 0, this._canvas.width, this._canvas.height), this._frames.push({
                      duration: t,
                      image: this._stream ? this._canvas.toDataURL("image/webp", this._options.quality) : "data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAADQAwCdASpQADwAPpFIoUylpCMiIagAsBIJaQAADHThw4cOHDhwrAAA/vhNAAAAAAA="
                    }), i = this._options.framerate ? 1e3 / this._options.framerate : 10, n.eventually(this._process, [], this, Math.max(1, i - (o.now() - e))));
                  },
                  averageFrameRate: function averageFrameRate() {
                    return 0 < this._frames.length ? this._frames.length / (o.now() - this._startTime) * 1e3 : null;
                  },
                  _generateData: function _generateData() {
                    this._frames.length && (this._data = this.__compile(this._stream ? this.__dropBlackFrames(this._canvas, this._frames) : this._frames), this.trigger("data", this._data));
                  },
                  __compile: function __compile(e) {
                    var i = 0,
                      r = null,
                      o = null,
                      a = [],
                      n = 0,
                      s = null,
                      x = null;
                    e.forEach(function (e) {
                      s || (s = [], x = 0);
                      var t = c.parseWebP(c.parseRIFF(atob(e.image.slice(23))));
                      s.push(c.serializeEBML(c.makeTimecodeDataBlock(t.data, x))), x += e.duration, i += e.duration, r = r || t.width, o = o || t.height, 3e4 <= x && (a.push(c.serializeEBML(c.makeCluster(s, n))), n = i, s = null, x = 0);
                    }, this), s && a.push(c.serializeEBML(c.makeCluster(s, n)));
                    var t = c.generateEBMLHeader(i, r, o);
                    return t[1].data = t[1].data.concat(a), c.serializeEBML(t);
                  },
                  __dropBlackFrames: function __dropBlackFrames(e, t, i, r) {
                    for (var o = 0; o < t.length && c.isBlankFrame(e, t[o], i, r);) o++;
                    return t.slice(o);
                  },
                  createSnapshot: function createSnapshot(e) {
                    return this._context.drawImage(this._video, 0, 0, this._canvas.width, this._canvas.height), this._canvas.toDataURL(e);
                  }
                };
              }], {
                supported: function supported(e) {
                  return e || s.globals().webpSupport;
                }
              });
            }), t.define("module:WebRTC.WhammyAudioRecorderWrapper", ["module:WebRTC.RecorderWrapper", "module:WebRTC.AudioRecorder", "module:WebRTC.WhammyRecorder", "browser:Info", "base:Promise"], function (e, i, r, o, t, a) {
              return e.extend({
                scoped: a
              }, {
                _createSnapshot: function _createSnapshot(e) {
                  return this._whammyRecorder.createSnapshot(e);
                },
                _boundMedia: function _boundMedia() {
                  this._videoBlob = null, this._audioBlob = null, this._hasVideo ? this._whammyRecorder = new r(this._stream, {
                    video: this._video,
                    framerate: this._options.framerate
                  }) : this._whammyRecorder = new r(null, {
                    framerate: this._options.framerate
                  }), this._hasAudio && (this._audioRecorder = new i(this._stream), this._audioRecorder.on("data", function (e) {
                    this._audioBlob = e, !this._videoBlob && this._hasVideo || this._dataAvailable(this._videoBlob, this._audioBlob);
                  }, this)), this._whammyRecorder.on("data", function (e) {
                    this._videoBlob = e, !this._audioBlob && this._hasAudio || this._dataAvailable(this._videoBlob, this._audioBlob);
                  }, this);
                },
                _unboundMedia: function _unboundMedia() {
                  this._hasAudio && this._audioRecorder.destroy(), this._whammyRecorder.destroy();
                },
                _startRecord: function _startRecord() {
                  var e = [];
                  return e.push(this._whammyRecorder.start()), this._hasAudio && e.push(this._audioRecorder.start()), t.and(e);
                },
                _stopRecord: function _stopRecord() {
                  this._whammyRecorder.stop(), this._hasAudio && this._audioRecorder.stop();
                },
                getVolumeGain: function getVolumeGain() {
                  return this._audioRecorder ? this._audioRecorder.getVolumeGain() : 1;
                },
                setVolumeGain: function setVolumeGain(e) {
                  this._audioRecorder && this._audioRecorder.setVolumeGain(e);
                },
                averageFrameRate: function averageFrameRate() {
                  return this._whammyRecorder.averageFrameRate();
                }
              }, function (t) {
                return {
                  supported: function supported(e) {
                    if (!t.supported.call(this, e)) return !1;
                    if (0 !== document.location.href.indexOf("https://") && "localhost" !== document.location.hostname) {
                      if (o.isChrome() && 47 <= o.chromeVersion()) return !1;
                      if (o.isOpera() && 34 <= o.operaVersion()) return !1;
                    }
                    return i.supported() && r.supported(!e.recordVideo);
                  }
                };
              });
            }), t.extend("module:WebRTC.RecorderWrapper", ["module:WebRTC.RecorderWrapper", "module:WebRTC.PeerRecorderWrapper", "module:WebRTC.MediaRecorderWrapper", "module:WebRTC.WhammyAudioRecorderWrapper", "module:WebRTC.PeerRecorderWrapperIfNecessary"], function (e, t, i, r, o) {
              return e.register(t, 4), e.register(i, 3), e.register(r, 2), e.register(o, 1), {};
            });
          }.call(Scoped), function () {
            var t = this.subScope();
            t.binding("base", "root:BetaJS"), t.binding("browser", "root:BetaJS.Browser"), t.binding("module", "root:BetaJS.Dynamics"), t.define("module:Data.ScopeManager", ["base:Class", "base:Trees.TreeNavigator", "base:Classes.ObjectIdScopeMixin", "base:Trees.TreeQueryEngine"], function (e, t, i, r, o) {
              return e.extend({
                scoped: o
              }, [t, i, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.__root = e, this.__watchers = [], this.__query = this._auto_destroy(new r(this));
                  },
                  nodeRoot: function nodeRoot() {
                    return this.__root;
                  },
                  nodeId: function nodeId(e) {
                    return e.cid();
                  },
                  nodeParent: function nodeParent(e) {
                    return e.__parent;
                  },
                  nodeChildren: function nodeChildren(e) {
                    return e.__children;
                  },
                  nodeData: function nodeData(e) {
                    return e.data();
                  },
                  nodeWatch: function nodeWatch(e, t, i) {
                    e.on("data", function () {
                      t.call(i, "data");
                    }, i), e.on("add", function (e) {
                      t.call(i, "addChild", e);
                    }, i), e.on("destroy", function () {
                      t.call(i, "remove");
                    }, i);
                  },
                  nodeUnwatch: function nodeUnwatch(e, t, i) {
                    e.off(null, null, i);
                  },
                  query: function query(e, t) {
                    return this.__query.query(e, t);
                  }
                };
              }]);
            }), t.define("module:Data.AbstractMultiScope", ["base:Class", "base:Events.EventsMixin", "base:Events.ListenMixin", "base:Properties.ObservableMixin"], function (e, t, i, r, o) {
              return e.extend({
                scoped: o
              }, [t, i, r, function (t) {
                return {
                  constructor: function constructor() {
                    t.constructor.call(this);
                    for (var e = this.iterator(); e.hasNext();) this.delegateEvents(null, e.next());
                  },
                  destroy: function destroy() {
                    for (var e = this.iterator(); e.hasNext();) e.next().off(null, null, this);
                    t.destroy.call(this);
                  },
                  set: function set(e, t) {
                    for (var i = this.iterator(); i.hasNext();) i.next().set(e, t);
                    return this;
                  },
                  get: function get(e) {
                    var t = this.iterator();
                    return t.hasNext() ? t.next().get(e) : null;
                  },
                  hasKey: function hasKey(e) {
                    for (var t = this.iterator(); t.hasNext();) if (t.next().hasKey(e)) return !0;
                    return !1;
                  },
                  setProp: function setProp(e, t) {
                    for (var i = this.iterator(); i.hasNext();) i.next().setProp(e, t);
                    return this;
                  },
                  getProp: function getProp(e) {
                    var t = this.iterator();
                    return t.hasNext() ? t.next().getProp(e) : null;
                  },
                  define: function define(e, t) {
                    for (var i = this.iterator(); i.hasNext();) i.next().define(e, t);
                    return this;
                  },
                  call: function call(e) {
                    return this.execute.apply(this, arguments);
                  },
                  execute: function execute(e) {
                    for (var t = this.iterator(), i = null; t.hasNext();) var r = t.next(), o = r.execute.apply(r, arguments), i = i || o;
                    return i;
                  },
                  materialize: function materialize(e) {
                    return e ? this.iterator().next() : this.iterator().asArray();
                  },
                  iterator: function iterator() {
                    throw "Abstract";
                  },
                  _addScope: function _addScope(e) {
                    return this.delegateEvents(null, e), this.trigger("addscope", e), this;
                  },
                  _removeScope: function _removeScope(e) {
                    return e.off(null, null, this), this.trigger("removescope", e), this;
                  }
                };
              }]);
            }), t.define("module:Data.MultiScope", ["module:Data.AbstractMultiScope", "base:Iterators.ArrayIterator"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, function (r) {
                return {
                  constructor: function constructor(e, t, i) {
                    this.__owner = e, this.__base = t, this.__queryStr = i, this.__query = this.auto_destroy(this.__owner.__manager.query(this.__owner, i)), r.constructor.call(this), this.__query.on("add", this._addScope, this), this.__query.on("remove", this._removeScope, this);
                  },
                  iterator: function iterator() {
                    return new t(this.__query.result());
                  },
                  parent: function parent() {
                    return this.__owner.scope(this.__base, this.__queryStr + "<");
                  },
                  root: function root() {
                    return this.__owner.root();
                  },
                  children: function children() {
                    return this.__owner.scope(this.__base, this.__queryStr + ">");
                  },
                  scope: function scope(e, t) {
                    return arguments.length < 2 && (t = this.__queryStr + e, e = this.__base), this.__owner.scope(e, t);
                  },
                  freeze: function freeze() {
                    this.__query.off("add", null, this);
                  }
                };
              });
            }), t.define("module:Data.ManualMultiScope", ["module:Data.AbstractMultiScope"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    this.__iteratorCallback = e, this.__iteratorContext = t, i.constructor.call(this);
                  },
                  iterator: function iterator() {
                    return this.__iteratorCallback.call(this.__iteratorContext);
                  },
                  addScope: function addScope(e) {
                    return this._addScope(e);
                  },
                  removeScope: function removeScope(e) {
                    return this._removeScope(e);
                  }
                };
              });
            }), t.define("module:Data.Friendgroup", ["base:Class", "base:Types", "base:Objs", "base:Iterators.ObjectValuesIterator", "module:Data.ManualMultiScope"], function (e, i, r, o, a, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.parent = e, this._registeredScopes = {}, this._watchScopes = {};
                  },
                  destroy: function destroy() {
                    r.iter(this._watchScopes, function (e) {
                      e.weakDestroy();
                    }), t.destroy.call(this);
                  },
                  registerScope: function registerScope(e, t) {
                    this._registeredScopes[t] = this._registeredScopes[t] || {}, this._registeredScopes[t][e.cid()] = e, this._watchScopes[t] && this._watchScopes[t].addScope(e);
                  },
                  unregisterScope: function unregisterScope(e, t) {
                    delete this._registeredScopes[t][e.cid()], i.is_empty(this._registeredScopes[t]) && delete this._registeredScopes[t], this._watchScopes[t] && this._watchScopes[t].removeScope(e);
                  },
                  watchScope: function watchScope(e, t) {
                    return this._watchScopes[t] || (this._watchScopes[t] = new a(function () {
                      return this.iterateScopes(t);
                    }, this)), this._watchScopes[t].increaseRef(e), this._watchScopes[t];
                  },
                  unwatchScope: function unwatchScope(e, t) {
                    return this._watchScopes[t] && (this._watchScopes[t].decreaseRef(e), this._watchScopes[t].destroyed() && delete this._watchScopes[t]), this;
                  },
                  iterateScopes: function iterateScopes(e) {
                    return this._registeredScopes[e] || !this.parent ? new o(this._registeredScopes[e] || {}) : this.parent.iterateScopes(e);
                  }
                };
              });
            }), t.define("module:Data.Scope", ["base:Class", "base:Events.EventsMixin", "base:Events.ListenMixin", "base:Classes.ObjectIdMixin", "base:Functions", "base:Types", "base:Strings", "base:Objs", "base:Ids", "base:Properties.Properties", "base:Collections.Collection", "base:Events.Events", "base:Properties.ObservableMixin", "module:Data.ScopeManager", "module:Data.MultiScope", "module:Data.AbstractMultiScope", "module:Data.Friendgroup"], function (r, t, i, o, a, n, s, x, c, d, l, u, h, p, b, m, g, v) {
              return r.extend({
                scoped: v
              }, [t, i, o, h, function (t) {
                return {
                  constructor: function constructor(i) {
                    (i = x.extend({
                      functions: {},
                      data: {},
                      parent: null,
                      scopes: {},
                      bind: {},
                      attrs: {},
                      extendables: [],
                      collections: {},
                      computed: {},
                      events: {},
                      channels: {},
                      registerchannels: [],
                      friends: {}
                    }, i)).bindings && (i.bind = x.extend(i.bind, i.bindings)), this._channels = {}, this.__channelCache = {};
                    var e = i.parent;
                    this.__manager = e ? e.__manager : this._auto_destroy(new p(this)), t.constructor.call(this), this.__parent = e, this.__root = e ? e.root() : this, this.__children = {}, this.__extendables = x.objectify(i.extendables), this.__properties = i.properties || new d(), this.__properties.increaseRef(this), this.__properties.on("change", function (e, t, i) {
                      this.trigger("change:" + e, t, i);
                    }, this), this.__functions = x.map(i.functions, function (e) {
                      return n.is_string(e) ? a.as_method(this[e], this) : e;
                    }, this), this.__scopes = {}, this.__data = i.data, x.iter(n.is_function(i.attrs) ? i.attrs.call(this) : i.attrs, function (e, t) {
                      this.__properties.has(t) || this.set(t, e);
                    }, this), this.setAll(), x.iter(n.is_function(i.collections) ? i.collections.call(this) : i.collections, function (e, t) {
                      n.is_array(i.collections) && (t = e, e = []), (!this.__properties.has(t) || r.is_instance_of(this.__properties.get(t)) && this.__properties.get(t).destroyed()) && this.set(t, this.auto_destroy(new l({
                        objects: e,
                        release_references: !0
                      })));
                    }, this), e && e.__add(this), this.scopes = x.map(i.scopes, function (e) {
                      return this.scope(e);
                    }, this), x.iter(i.bind, function (e, t) {
                      var i = e.indexOf(":");
                      this.bind(this.scope(e.substring(0, i)), t, {
                        secondKey: e.substring(i + 1)
                      });
                    }, this), x.iter(i.computed, function (e, t) {
                      var i = s.splitFirst(t, ":");
                      this.__properties.compute(i.head, e, this, i.tail.split(","));
                    }, this), x.iter(i.events, function (e, t) {
                      this.on(t, e, this);
                    }, this), x.iter(i.registerchannels, this.registerChannel, this), x.iter(i.channels, function (e, t) {
                      var i = s.splitFirst(t, ":");
                      this.channel(i.head) && this.listenOn(this.channel(i.head), i.tail, e, this);
                    }, this), this.friendgroup || !e ? this.friendgroup = this.auto_destroy(new g(e ? e.friendgroup : null)) : this.friendgroup = e.friendgroup, this.friends = {}, this.__friends = i.friends, x.iter(this.__friends, function (e, t) {
                      this.friends[t] = this.friendgroup.watchScope(this, e);
                    }, this);
                  },
                  friendgroup: !1,
                  destroy: function destroy() {
                    this.trigger("destroy"), x.iter(this.__friends, function (e) {
                      this.friendgroup.unwatchScope(this, e);
                    }, this), x.iter(this.__scopes, function (e) {
                      e.destroy();
                    }), x.iter(this.__children, function (e) {
                      e.destroy();
                    }), this.__properties.decreaseRef(this), this.__parent && this.__parent.__remove(this), t.destroy.call(this);
                  },
                  __object_id_scope: function __object_id_scope() {
                    return this.__manager;
                  },
                  __add: function __add(e) {
                    this.__children[e.cid()] = e, this.trigger("add", e);
                  },
                  __remove: function __remove(e) {
                    this.trigger("remove", e), delete this.__children[e.cid()];
                  },
                  data: function data(e, t) {
                    return 0 === arguments.length ? this.__data : 1 === arguments.length ? this.__data[e] : (this.__data[e] = t, this.trigger("data", e, t), this);
                  },
                  set: function set(e, t, i) {
                    return this.destroyed() || (e in this.__extendables && (t = x.tree_extend(this.__properties.get(e) || {}, t)), this.__properties.set(e, t, i)), this;
                  },
                  setAll: function setAll(e) {
                    return this.__properties.setAll(e), this;
                  },
                  hasKey: function hasKey(e) {
                    return this.__properties.hasKey(e);
                  },
                  get: function get(e) {
                    return this.__properties.get(e);
                  },
                  setProp: function setProp(e, t) {
                    return this.__properties.setProp(e, t), this;
                  },
                  getProp: function getProp(e) {
                    return this.__properties.getProp(e);
                  },
                  flipProp: function flipProp(e) {
                    return this.setProp(e, !this.getProp(e));
                  },
                  define: function define(e, t, i) {
                    return this.__functions[e] = a.as_method(t, i || this), this;
                  },
                  call: function call(e) {
                    return this.execute.apply(this, arguments);
                  },
                  execute: function execute(t) {
                    var i = a.getArguments(arguments, 1);
                    try {
                      return n.is_string(t) ? this.__functions[t].apply(this, i) : t.apply(this, i);
                    } catch (e) {
                      return console.error(e), this.handle_call_exception(t, i, e);
                    }
                  },
                  handle_call_exception: function handle_call_exception(e, t, i) {
                    throw i;
                  },
                  parent: function parent() {
                    return this.__parent;
                  },
                  _eventChain: function _eventChain() {
                    return this.parent();
                  },
                  registerChannel: function registerChannel(e) {
                    this._channels[e] = this.auto_destroy(new u());
                  },
                  channel: function channel(e) {
                    var t;
                    return e in this.__channelCache || (t = null, this._channels[e] ? t = this._channels[e] : this.__parent && (t = this.__parent.channel(e)), this.__channelCache[e] = t), this.__channelCache[e];
                  },
                  root: function root() {
                    return this.__root;
                  },
                  children: function children() {
                    return this.scope(">");
                  },
                  properties: function properties() {
                    return this.__properties;
                  },
                  compute: function compute(e, t, i) {
                    this.properties().compute(e, t, this, i);
                  },
                  scope: function scope(e, t) {
                    if (arguments.length < 2 && (t = e, e = this), !t) return e;
                    if (e && e.instance_of(b) && (e = e.iterator().next()), !e) return e;
                    var i = c.objectId(e) + "_" + t;
                    return this.__scopes[i] || (this.__scopes[i] = new b(this, e, t)), this.__scopes[i];
                  },
                  bind: function bind(e, t, i) {
                    if (e.instance_of(m)) {
                      for (var r = e.iterator(); r.hasNext();) this.properties().bind(t, r.next().properties(), i);
                      e.on("addscope", function (e) {
                        this.properties().bind(t, e.properties(), i);
                      }, this), e.on("removescope", function (e) {
                        this.properties().unbind(t, e.properties());
                      }, this);
                    } else this.properties().bind(t, e.properties(), i);
                  }
                };
              }], {
                _extender: {
                  functions: function functions(e, t) {
                    return x.extend(x.clone(e, 1), t);
                  },
                  friends: function friends(e, t) {
                    return x.extend(x.clone(e, 1), t);
                  }
                }
              });
            }), t.define("module:Parser", ["base:Types", "base:Objs", "base:JavaScript"], function (a, c, d) {
              return {
                __cache: {},
                __functions: {},
                secureMode: !1,
                compileFunction: function compileFunction(t) {
                  if (!((t = t.trim()) in this.__functions)) {
                    if (this.secureMode) throw "Dynamics Secure Mode prevents creation of function code '" + t + "'.";
                    try {
                      this.__functions[t] = new Function("obj", "with (obj) { return " + t + "; }");
                    } catch (e) {
                      console.warn("Cannot compile `" + t + "` : " + e), this.__functions[t] = function () {
                        return {};
                      };
                    }
                  }
                  return this.__functions[t];
                },
                registerFunctions: function registerFunctions(e) {
                  this.__functions = c.extend(this.__functions, e);
                },
                parseText: function parseText(e) {
                  if (!e) return null;
                  for (var t = []; e;) {
                    var i = e.indexOf("{{"),
                      r = null;
                    if (0 === i) {
                      for (i = e.indexOf("}}"); i + 2 < e.length && "}" == e.charAt(i + 2);) i++;
                      0 <= i ? (i += 2, r = this.parseCode(e.substring(2, i - 2))) : i = e.length;
                    } else i < 0 && (i = e.length);
                    t.push(r || e.substring(0, i)), e = e.substring(i);
                  }
                  if (1 == t.length) return a.is_string(t[0]) ? null : t[0];
                  var o = {};
                  return c.iter(t, function (e) {
                    a.is_string(e) || c.iter(e.dependencies, function (e) {
                      o[e] = !0;
                    });
                  }), {
                    func: function func(i) {
                      var r = null;
                      return c.iter(t, function (e) {
                        var t = a.is_string(e) ? e : e.func(i);
                        r = null === r ? t : r + t;
                      }), r;
                    },
                    dependencies: c.keys(o)
                  };
                },
                parseCode: function parseCode(e) {
                  var t,
                    i,
                    r,
                    o,
                    a,
                    n,
                    s,
                    x = this.__cache[e];
                  return x || (o = r = i = t = !1, "?" === (a = e).charAt(0) && (o = !0, a = a.substring(1)), "=" === a.charAt(0) ? (t = !0, a = a.substring(1)) : "-" === a.charAt(0) ? (i = !0, a = a.substring(1)) : "*" === a.charAt(0) && (r = !0, a = a.substring(1)), s = null, 0 <= (n = a.lastIndexOf("::")) && (s = a.substring(0, n).trim(), a = a.substring(n + 2)), x = {
                    bidirectional: t,
                    hidden: o,
                    html: i,
                    noentities: r,
                    args: s,
                    variable: t ? a : null,
                    func: this.compileFunction(a),
                    dependencies: c.keys(c.objectify(d.extractIdentifiers(a, !0)))
                  }, this.__cache[e] = x), c.clone(x, 1);
                }
              };
            }), t.define("module:Data.Mesh", ["base:Class", "base:Events.EventsMixin", "base:Properties.ObservableMixin", "base:Objs", "base:Types", "base:Strings", "base:Ids", "base:Functions", "base:Classes.SharedObjectFactory"], function (e, t, x, d, c, l, o, a, u, i) {
              return e.extend({
                scoped: i
              }, [t, function (r) {
                return {
                  constructor: function constructor(e, t, i) {
                    r.constructor.call(this), this.__environment = e, this.__defaults = i, this.__context = t, this.__watchers = {}, this.__acquiredProperties = {};
                  },
                  destroy: function destroy() {
                    d.iter(this.__watchers, function (e) {
                      this.__destroyWatcher(e);
                    }, this), d.iter(this.__acquiredProperties, function (e) {
                      e.decreaseRef(this);
                    }, this), r.destroy.call(this);
                  },
                  watch: function watch(e, t, i) {
                    d.iter(e, function (e) {
                      this.__createWatcher(e).cbs[o.objectId(i)] = {
                        callback: t,
                        context: i
                      };
                    }, this);
                  },
                  unwatch: function unwatch(e, i) {
                    e ? d.iter(e, function (e) {
                      var t = this.__createWatcher(e, !0);
                      t && (delete t.cbs[o.objectId(i)], this.__destroyWatcher(t, !0));
                    }, this) : i && d.iter(this.__watchers, function (e) {
                      delete e.cbs[o.objectId(i)], this.__destroyWatcher(e, !0);
                    }, this);
                  },
                  __destroyWatcher: function __destroyWatcher(e, t) {
                    c.is_string(e) && (e = this.__watchers[e]), e && (!t || c.is_empty(e.cbs) && c.is_empty(e.children)) && (d.iter(e.children, this.__destroyWatcher, this), this.__unbindWatcher(e), e.parent && delete e.parent.children[e.key], delete this.__watchers[e.expression], e.parent && c.is_empty(e.parent.cbs) && c.is_empty(e.parent.children) && this.__destroyWatcher(e.parent));
                  },
                  __createWatcher: function __createWatcher(e, t) {
                    if ((o = this.__watchers[e]) || t) return o;
                    var i = l.splitLast(e, "."),
                      r = i.head ? this.__createWatcher(i.head) : null,
                      o = {
                        cbs: {},
                        parent: r,
                        key: i.tail,
                        expression: e,
                        children: {},
                        properties: null,
                        propertiesPrefix: null
                      };
                    return r && (r.children[i.tail] = o), this.__watchers[e] = o, this.__bindWatcher(o), o;
                  },
                  __unbindWatcher: function __unbindWatcher(e) {
                    e.properties && e.properties.off(null, null, e), d.iter(e.children, this.__unbindWatcher, this);
                  },
                  __bindWatcher: function __bindWatcher(r) {
                    for (var e, t, o, i, a = null, n = this.__environment.length - 1; 0 <= n; --n) {
                      var s = this.__environment[n];
                      if ((a = this._navigate(s, r.expression)).properties && !a.tail) break;
                      a = null;
                    }
                    null === a && (e = this.__defaults.watch || this.__environment[0], (a = this._navigate(e, r.expression)).properties || x.__observable_guid !== e.__observable_guid || (a.properties = e), a.properties || (a = null)), null !== a && (r.properties = a.properties, t = a.head + (a.head && a.tail ? "." : "") + a.tail, r.propertiesPrefix = t, o = this, r.properties.on("change:" + r.propertiesPrefix, function (e, t, i) {
                      d.iter(r.children, o.__unbindWatcher, o), d.iter(r.children, o.__bindWatcher, o), r.value == e && !i || (r.value = e, d.iter(r.cbs, function (e) {
                        e.callback.apply(e.context);
                      }, o));
                    }, r), (i = r.properties.get(t)) != r.value && (r.value = i, d.iter(r.cbs, function (e) {
                      e.callback.apply(e.context);
                    }, this)), d.iter(r.children, this.__bindWatcher, this));
                  },
                  read: function read(e) {
                    for (var t = this.__environment.length - 1; 0 <= t; --t) {
                      var i = this._read(this.__environment[t], e);
                      if (i) return c.is_function(i.value) ? a.as_method(i.value, i.context) : i.value;
                    }
                    return null;
                  },
                  write: function write(e, t) {
                    for (var i = this.__environment.length - 1; 0 <= i; --i) if (this._write(this.__environment[i], e, t, !1)) return;
                    this._write(this.__defaults.write || this.__environment[0], e, t, !0);
                  },
                  execute: function execute(e, t, i, r) {
                    var o = {},
                      a = [];
                    d.iter(e, function (e) {
                      var t = this.read(e);
                      null === t && l.splitFirst(e, ".").head in window || (a.push(e), o[e] = t);
                    }, this);
                    var n = this.__expand(o),
                      s = t.call(this.__context, n);
                    if (!i) {
                      var x = this.__collapse(n, a);
                      for (var c in x) c in o && o[c] == x[c] || this.write(c, x[c]);
                    }
                    return r || !u.is_instance_of(s) || s.destroyed() || (s = s.acquire(this), this.__acquiredProperties[s.cid()] = s), s;
                  },
                  _sub_navigate: function _sub_navigate(e, t, i, r, o) {
                    var a = {
                      properties: e,
                      head: t,
                      tail: i,
                      parent: r,
                      current: o
                    };
                    if (!i || !o || !c.is_object(o)) return a;
                    var n = l.splitFirst(i, "."),
                      s = t ? t + "." + n.head : n.head;
                    return u.is_instance_of(o) && !o.destroyed() && (o = o.acquire(this), this.__acquiredProperties[o.cid()] = o), x.__observable_guid !== o.__observable_guid || o.destroyed() ? n.head in o ? this._sub_navigate(e, s, n.tail, o, o[n.head]) : a : o.hasKey(n.head) ? this._sub_navigate(o, n.head, n.tail, o, o.get(n.head)) : n.head in o ? this._sub_navigate(e, s, n.tail, o, o[n.head]) : {
                      properties: o,
                      head: n.head,
                      tail: n.tail,
                      parent: o,
                      current: null
                    };
                  },
                  _navigate: function _navigate(e, t) {
                    return this._sub_navigate(null, "", t, null, e);
                  },
                  _read: function _read(e, t) {
                    var i = this._navigate(e, t);
                    return i.tail ? null : {
                      value: i.current,
                      context: i.parent == e ? this.__context : i.parent
                    };
                  },
                  _write: function _write(e, t, i, r) {
                    var o = this._navigate(e, t);
                    if (o.tail && !r) return !1;
                    var a = o.tail.split(".");
                    if (o.properties) o.properties.set(o.head + (o.head && o.tail ? "." : "") + o.tail, i);else {
                      for (var n = o.current, s = 0; s < a.length - 1; ++s) n[a[s]] = {}, n = n[a[s]];
                      n[a[a.length - 1]] = i;
                    }
                    return !0;
                  },
                  __expand: function __expand(e) {
                    var a = {};
                    return d.iter(e, function (e, t) {
                      for (var i = a, r = t.split("."), o = 0; o < r.length - 1; ++o) r[o] in i && c.is_object(i[r[o]]) && null !== i[r[o]] || (i[r[o]] = {}), i = i[r[o]];
                      i[r[r.length - 1]] = e;
                    }), a;
                  },
                  __collapse: function __collapse(o, e) {
                    var a = {};
                    return d.iter(e, function (e) {
                      for (var t = e.split("."), i = o, r = 0; r < t.length; ++r) i = i[t[r]];
                      a[e] = i;
                    }), a;
                  }
                };
              }]);
            }), t.define("module:Registries", ["base:Classes.ClassRegistry", "base:Exceptions.AsyncExceptionThrower", "browser:Dom", "base:Strings"], function (e, i, a, r) {
              return {
                handler: new e({}, !0),
                partial: new e({}, !0),
                prefixes: {
                  ba: !0
                },
                prefixNormalize: function prefixNormalize(e, t) {
                  var i = r.splitFirst(e || "", "-");
                  return this.prefixes[i.head] ? i.tail : e;
                },
                templates: {
                  cache: {},
                  create: function create(e) {
                    e = e.trim();
                    var t = this.cache[e];
                    return t || (t = 0 === e.indexOf("<") ? a.elementsByTemplate(e) : [document.createTextNode(e)], this.cache[e] = t), t.map(function (e) {
                      return e.cloneNode(!0);
                    });
                  }
                },
                throwException: function throwException(e) {
                  try {
                    this.exceptionThrower || (this.exceptionThrower = new i()), this.exceptionThrower.throwException(e);
                  } catch (t) {}
                },
                handlerCache: {
                  cache: {},
                  cacheDom: null,
                  suspend: function suspend(e, t) {
                    t = a.unbox(t), this.cacheDom || (this.cacheDom = document.createElement("div"), this.cacheDom.setAttribute("ba-ignore", ""), this.cacheDom.style.display = "none", document.body.appendChild(this.cacheDom));
                    var i = e.data("tagname");
                    this.cache[i] = this.cache[i] || [];
                    for (var r = [], o = 0; o < t.children.length; ++o) r.push(t.children[o]);
                    this.cache[i].push({
                      handler: e,
                      elements: r
                    }), r.forEach(function (e) {
                      this.cacheDom.appendChild(e);
                    }, this);
                  },
                  resume: function resume(e, t, i) {
                    if (t = a.unbox(t), !this.cache[e] || 0 === this.cache[e].length) return null;
                    var r = this.cache[e].shift();
                    return t.innerHTML = "", r.elements.forEach(function (e) {
                      t.appendChild(e);
                    }), r.handler._handlerInitialize({
                      parentHandler: i,
                      parentElement: t
                    }), r.handler;
                  }
                }
              };
            }), t.define("module:Exceptions.TagHandlerException", ["base:Exceptions.Exception"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    i.constructor.call(this, e + " is expecting a tag handler, but no registered tag handler for " + t + " has been found.");
                  }
                };
              });
            }), t.define("module:Handlers.Attr", ["base:Class", "module:Exceptions.TagHandlerException", "module:Parser", "base:Types", "base:Objs", "base:Async", "base:Strings", "module:Registries", "browser:Dom", "browser:Events"], function (i, e, a, r, n, s, x, c, d, t, o) {
              return i.extend({
                scoped: o
              }, function (o) {
                return {
                  constructor: function constructor(e, t, i) {
                    var r;
                    o.constructor.call(this), this._dataNode = i || e, this._node = e, this._tagHandler = null, this._attrName = t.name, this._isEvent = 0 === this._attrName.indexOf("on"), this._updatable = !this._isEvent, this._attrValue = t.value, this._dyn = a.parseText(this._attrValue), this._dyn && (r = this)._dataNode.mesh().watch(this._dyn.dependencies, function () {
                      r.__updateAttr();
                    }, this), this.updateElement(e.element(), t);
                  },
                  destroy: function destroy() {
                    this._partial && this._partial.destroy(), this._dyn && this._dataNode.mesh().unwatch(this._dyn.dependencies, this), o.destroy.call(this);
                  },
                  __inputVal: function __inputVal(e, t) {
                    var i = "checkbox" === e.type || "radio" === e.type ? "checked" : "value";
                    return 1 < arguments.length && (t = null === t || t === undefined ? "" : t, "select-one" === e.type ? s.eventually(function () {
                      e[i] = t;
                    }) : e[i] = t), e[i];
                  },
                  _events: function _events() {
                    return this.__events || (this.__events = this.auto_destroy(new t())), this.__events;
                  },
                  updateElement: function updateElement(e, t) {
                    this._element = e, t = t || e.attributes[this._attrName], this._attribute = t;
                    var i = x.splitFirst(this._attrName, ":");
                    this._partialCls = c.partial.get(i.head), this._partial && (this._partial.destroy(), this._partial = null), this.__updateAttr(), this._partialCls && (this._partial = c.partial.create(i.head, this._node, this._dyn ? this._dyn.args : {}, this._attrValue, i.tail), this._partial.cls.meta.value_hidden && (this._attribute.value = "")), this._dyn && (this._dyn.bidirectional && "value" == this._attrName && this._events().on(this._element, "change keyup keypress keydown blur focus update input", function () {
                      this._dataNode.mesh().write(this._dyn.variable, this.__inputVal(this._element));
                    }, this), this._isEvent && (this._attribute.value = "", this._events().on(this._element, this._attrName.substring(2), function () {
                      var e = this._node._locals.domEvent;
                      this._node._locals.domEvent = arguments, this._node.__executeDyn(this._dyn), this._node && this._node._locals && (this._node._locals.domEvent = e);
                    }, this)));
                  },
                  __updateAttr: function __updateAttr() {
                    var e, t, i;
                    this._updatable && (e = this._attrValue, !this._dyn || this._partialCls && this._partialCls.manualExecute || (e = this._dataNode.__executeDyn(this._dyn, !1, !this._partialCls)), e == this._attrValue && !r.is_array(e) || !e && !this._attrValue || (t = this._attrValue, this._attrValue = e, this._partial && this._partial.cls.meta.value_hidden || (null === (i = this._dyn.noentities ? e : d.entitiesToUnicode(e)) && "class" === this._attrName && (i = ""), this._dyn.hidden || (this._attribute.value = i)), this._partial && this._partial.change(e, t), "value" === this._attrName && this._element.value !== e && this.__inputVal(this._element, e), this._tagHandler && this._dyn && !this._partial && this._tagHandler.properties().setProp(c.prefixNormalize(this._attrName), e)));
                  },
                  bindTagHandler: function bindTagHandler(e) {
                    var t;
                    this.unbindTagHandler(this._tagHandler), this._tagHandler = e, this._partial ? this._partial && this._partial.bindTagHandler(e) : (t = c.prefixNormalize(this._attrName)) && (this._tagHandler.setArgumentAttr(t, i.is_pure_json(this._attrValue) ? n.clone(this._attrValue, 1) : this._attrValue), this._dyn && this._dyn.bidirectional && (i.is_pure_json(this._attrValue) ? this._tagHandler.properties().bind(t, this._node._handler.properties(), {
                      deep: !0,
                      left: !0,
                      right: !0,
                      secondKey: this._dyn.variable
                    }) : 0 <= t.indexOf(".") ? this._tagHandler.on("dynamic-activated", function () {
                      this._tagHandler.defaultMesh().watch([t], function () {
                        this._dataNode.mesh().write(this._dyn.variable, this._tagHandler.defaultMesh().read(t));
                      }, this);
                    }, this) : this._tagHandler.properties().on("change:" + t, function (e) {
                      this._dataNode.mesh().write(this._dyn.variable, e);
                    }, this)));
                  },
                  prepareTagHandler: function prepareTagHandler(e) {
                    this._partial && this._partial.prepareTagHandler(e);
                  },
                  unbindTagHandler: function unbindTagHandler(e) {
                    this._partial && this._partial.unbindTagHandler(e), this._tagHandler && (this._tagHandler.properties().off(null, null, this), this._tagHandler.off("dynamic-activated", null, this), this._tagHandler.defaultMesh().unwatch(undefined, this)), this._tagHandler = null;
                  },
                  activate: function activate() {
                    if (this._partial) {
                      if (this._partial.cls.meta.requires_tag_handler && !this._tagHandler) return void c.throwException(new e(this._partial.cls.classname, this._node.tag()));
                      this._partial.activate();
                    }
                  },
                  deactivate: function deactivate() {
                    this._partial && this._partial.deactivate();
                  }
                };
              });
            }), t.define("module:Handlers.Node", ["base:Class", "base:Events.EventsMixin", "base:Ids", "browser:Dom", "browser:Info", "module:Parser", "module:Data.Mesh", "base:Objs", "base:Types", "module:Registries", "module:Handlers.Attr"], function (t, i, x, o, a, c, d, l, r, n, u, s) {
              var h = t.extend({
                scoped: s
              }, [i, function (s) {
                return {
                  constructor: function constructor(t, i, r, o) {
                    s.constructor.call(this), this._handler = t, (this._parent = i) && (i._children[x.objectId(this)] = this), this._element = r;
                    try {
                      r && (r.dynnodehandler = this);
                    } catch (e) {}
                    if (this._tag = r.tagName ? r.tagName.toLowerCase() : "", 0 <= this._tag.indexOf(":") && (this._tag = this._tag.substring(this._tag.indexOf(":") + 1)), this._dynTag = c.parseText(this._tag), this._tagHandler = null, this._template = r.outerHTML, this._innerTemplate = r.innerHTML, this._locals = o || {}, this._active = !0, this._dyn = null, this._children = {}, this._locked = !0, this._attrs = {}, this._expandChildren = !0, this._touchedInner = !1, this._mesh = new d([window, this.properties(), this._locals, this._handler.functions, this._handler.friends || {}, this._handler._mesh_extend], this._handler, {
                      read: this.properties(),
                      write: this.properties(),
                      watch: this.properties()
                    }), this._element.attributes) {
                      for (var a = [], n = 0; n < this._element.attributes.length; ++n) a.push(this._element.attributes[n]);
                      l.iter(a, this._registerAttr, this);
                    }
                    this._locked = !1, this._active = !this._active, this._active ? this.deactivate() : this.activate();
                  },
                  destroy: function destroy() {
                    l.iter(this._attrs, function (e) {
                      e.destroy();
                    }), this._removeChildren(), this._tagHandler && !this._tagHandler.destroyed() && (this._tagHandler.cacheable && this._tagHandler.cls.cacheable ? n.handlerCache.suspend(this._tagHandler, this._element) : this._tagHandler.weakDestroy()), this._dyn && this.properties().off(null, null, this._dyn), this._parent && delete this._parent._children[x.objectId(this)], this._mesh.destroy(), s.destroy.call(this);
                  },
                  _registerAttr: function _registerAttr(e) {
                    e.name in this._attrs ? this._attrs[e.name].updateAttribute(e) : this._attrs[e.name] = new u(this, e);
                  },
                  tag: function tag() {
                    return this._tag;
                  },
                  element: function element() {
                    return this._element;
                  },
                  __dynOff: function __dynOff(e) {
                    this._mesh.unwatch(e.dependencies, e);
                  },
                  __dynOn: function __dynOn(e, t) {
                    var i = this;
                    this._mesh.watch(e.dependencies, function () {
                      t.apply(i);
                    }, e);
                  },
                  mesh: function mesh() {
                    return this._mesh;
                  },
                  __executeDyn: function __executeDyn(e, t, i) {
                    return r.is_object(e) ? this._mesh.execute(e.dependencies, e.func, t, i) : e;
                  },
                  __tagValue: function __tagValue() {
                    return this._dynTag ? this.__executeDyn(this._dynTag, !0) : this._tag;
                  },
                  __unregisterTagHandler: function __unregisterTagHandler() {
                    this._tagHandler && (l.iter(this._attrs, function (e) {
                      e.unbindTagHandler(this._tagHandler);
                    }, this), this.off(null, null, this._tagHandler), this._tagHandler.cacheable && this._tagHandler.cls.cacheable ? n.handlerCache.suspend(this._tagHandler, this._element) : this._tagHandler.weakDestroy(), this._tagHandler = null, l.iter(this._handler.getInheritableAttributes(this.__tagValue()), function (e) {
                      this._attrs[e.name].weakDestroy(), delete this._attrs[e.name];
                    }, this));
                  },
                  __registerTagHandler: function __registerTagHandler() {
                    this.__unregisterTagHandler();
                    var e,
                      t = this.__tagValue();
                    if (t) {
                      if (this._dynTag && this._element.tagName.toLowerCase() != t.toLowerCase() && (this._element = o.changeTag(this._element, t), l.iter(this._attrs, function (e) {
                        e.updateElement(this._element);
                      }, this)), !n.handler.get(t)) return !1;
                      a.isInternetExplorer() && a.internetExplorerVersion() < 9 && (e = this._element === this._handler.activeElement(), this._element = o.changeTag(this._element, t), l.iter(this._attrs, function (e) {
                        e.updateElement(this._element);
                      }, this), e && this._handler._updateActiveElement(this._element));
                      var i = {
                        parentElement: this._element,
                        parentHandler: this._handler,
                        autobind: !1,
                        cacheable: !1,
                        tagName: t
                      };
                      if (l.iter(this._handler.getInheritableAttributes(this.__tagValue()), function (e) {
                        this._attrs[e.name] = new u(e.node, e);
                      }, this), l.iter(this._attrs, function (e) {
                        e.prepareTagHandler(i);
                      }, this), !i.ignoreTagHandler) return i.cacheable && (this._tagHandler = n.handlerCache.resume(t, this._element, this._handler)), this._tagHandler || (this._tagHandler = n.handler.create(t, i)), l.iter(this._handler.inheritables, function (e) {
                        this._tagHandler.set(e, this._handler.get(e));
                      }, this), l.iter(this._attrs, function (e) {
                        e.bindTagHandler(this._tagHandler);
                      }, this), this._tagHandler.activate(), !0;
                    }
                  },
                  activate: function activate() {
                    if (!this._locked && !this._active) {
                      if (this._locked = !0, this._active = !0, this._dynTag && this.__dynOn(this._dynTag, function () {
                        this.__registerTagHandler();
                      }), !this.__registerTagHandler() && this._expandChildren) {
                        this._restoreInnerTemplate && (this._element.innerHTML = this._innerTemplate), this._touchedInner = !0, 3 == this._element.nodeType && (this._dyn = c.parseText(this._element.textContent || this._element.innerText || this._element.nodeValue), this._dyn && this.__dynOn(this._dyn, function () {
                          this.__updateDyn();
                        })), this.__updateDyn(!0);
                        for (var e = 0; e < this._element.childNodes.length; ++e) this._element.childNodes[e]["ba-handled"] || this._registerChild(this._element.childNodes[e]);
                      }
                      l.iter(this._attrs, function (e) {
                        e.activate();
                      }), this._locked = !1;
                    }
                  },
                  __updateDyn: function __updateDyn(e) {
                    var t, i, r;
                    this._dyn && (t = this.__executeDyn(this._dyn), !e && t == this._dyn.value || (this._dyn.value = t, i = null, this._dyn.html && (i = o.elementByTemplate(t, !0)) && ((this._htmlElement || this._element).replaceWith(i), this._htmlElement = i), i || (t = null === t ? "" : t, r = this._dyn.noentities ? t : o.entitiesToUnicode(t), "textContent" in this._element && (this._element.textContent = r), "innerText" in this._element && (this._element.innerText = r), a.isInternetExplorer() && a.internetExplorerVersion() < 9 && "data" in this._element && (this._element.data = r))));
                  },
                  _registerChild: function _registerChild(e, t) {
                    return new h(this._handler, this, e, l.extend(l.clone(this._locals, 1), t));
                  },
                  _removeChildren: function _removeChildren() {
                    l.iter(this._children, function (e) {
                      e && e.weakDestroy();
                    });
                  },
                  deactivate: function deactivate() {
                    this._active && (this._active = !1, this._locked || (this._locked = !0, l.iter(this._attrs, function (e) {
                      e.deactivate();
                    }), this._removeChildren(), this._dynTag && this.__dynOff(this._dynTag), this.__unregisterTagHandler(), this._dyn && (this.__dynOff(this._dyn), this._dyn = null), this._touchedInner && (this._element.innerHTML = ""), this._restoreInnerTemplate = !0, this._locked = !1));
                  },
                  properties: function properties() {
                    return this._handler.properties();
                  }
                };
              }]);
              return h;
            }), t.define("module:Handlers.HandlerNameRegistry", ["base:Class", "base:Objs"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, function (e) {
                return {
                  __handlers: {},
                  destroy: function destroy() {
                    t.iter(this.__handlers, function (e, t) {
                      this.unregister(t);
                    }, this), e.destroy.call(this);
                  },
                  register: function register(e, t) {
                    this.unregister(t), (this.__handlers[t] = e).on("destroy", function () {
                      this.unregister(t);
                    }, this);
                  },
                  unregister: function unregister(e) {
                    var t;
                    e in this.__handlers && (t = this.__handlers[e], delete this.__handlers[e], t.destroyed() || t.off(null, null, this));
                  },
                  get: function get(e) {
                    return this.__handlers[e];
                  }
                };
              });
            }), t.define("module:Handlers.HandlerMixin", ["base:Objs", "base:Strings", "base:Functions", "base:Types", "browser:Loader", "module:Handlers.Node", "module:Registries", "module:Handlers.HandlerNameRegistry", "browser:DomMutation.NodeRemoveObserver", "browser:Dom"], function (i, r, t, o, a, n, s, x, c, d) {
              return {
                _notifications: {
                  construct: "__handlerConstruct",
                  destroy: "__handlerDestruct"
                },
                __handlerConstruct: function __handlerConstruct() {
                  this._inheritableAttributes = {}, this.__activated = !1, this._mesh_extend = {
                    string: t.as_method(this.string, this),
                    stringUnicode: t.as_method(this.stringUnicode, this)
                  };
                },
                __handlerDestruct: function __handlerDestruct() {
                  i.iter(this.__rootNodes, function (e) {
                    var t = e.element();
                    e.destroy(), this.remove_on_destroy && (t.innerHTML = "");
                  }, this);
                },
                template: null,
                templateUrl: null,
                string: function string(e) {
                  return this.cls.string ? this.cls.string(e) : this.parent() ? this.parent().string(e) : e;
                },
                stringUnicode: function stringUnicode(e) {
                  return this.cls.stringUnicode ? this.cls.stringUnicode(e) : this.parent() ? this.parent().stringUnicode(e) : e;
                },
                remove_on_destroy: !1,
                _handlerInitialize: function _handlerInitialize(e) {
                  (e = e || {}).name_registry && (this.__nameRegistry = this.auto_destroy(new x())), this.__types = e.types || {}, this._parentHandler = e.parentHandler || null, this._parentElement = e.parentElement, this._argumentAttrs = {}, this.template = e.template || this.template, this.templateUrl = e.templateUrl || this.templateUrl, this.templateUrl && (this.templateUrl = r.replaceAll(this.templateUrl, "%", r.last_after(this.cls.classname || "", ".").toLowerCase())), this.__elements = e.element ? [d.unbox(e.element)] : [];
                  var t = d.unbox(e.element ? e.element : this._parentElement);
                  if (!t) throw this.cls.classname + " requires an existing DOM element to attach to.";
                  this.initialContent = t.innerHTML, this.__activeElement = e.element ? d.unbox(e.element) : d.unbox(this._parentElement), e.remove_observe && (this.__removeObserver = this.auto_destroy(c.create(this.__activeElement)), this.__removeObserver.on("node-removed", function () {
                    this.weakDestroy();
                  }, this)), this.__activeElement.dynamicshandler = this;
                },
                _handlerInitializeTemplate: function _handlerInitializeTemplate(e, t) {
                  var i = s.templates.create(e);
                  0 < this.__elements.length ? (this.__activeElement = this.__elements[0], this.__elements[0].innerHTML = "", i.forEach(function (e) {
                    this.__elements[0].appendChild(e);
                  }, this)) : t ? (this.__activeElement = d.unbox(t), this.__elements = i, this.__activeElement.innerHTML = "", i.forEach(function (e) {
                    this.__activeElement.appendChild(e);
                  }, this)) : (this.__elements = i, this.__activeElement = this.__elements[0].parentNode);
                },
                nameRegistry: function nameRegistry() {
                  return this.__nameRegistry || (this.parent() ? this.parent().nameRegistry() : null);
                },
                byName: function byName(e) {
                  return this.nameRegistry().get(e);
                },
                __assocs: {},
                addAssoc: function addAssoc(e, t) {
                  this.__assocs[e] = t;
                },
                removeAssoc: function removeAssoc(e) {
                  delete this.__assocs[e];
                },
                activated: function activated() {
                  return this.__activated;
                },
                assoc: function assoc(e) {
                  return this.byName(this.__assocs[e] || e);
                },
                setArgumentAttr: function setArgumentAttr(e, t) {
                  e in this.__extendables && (t = i.tree_extend(this.properties().get(e) || {}, t)), this.__types[e] && (t = o.parseType(t, this.__types[e])), this.properties().setProp(e, t), this._argumentAttrs[e] = !0;
                },
                isArgumentAttr: function isArgumentAttr(e) {
                  return !!this._argumentAttrs[e];
                },
                activeElement: function activeElement() {
                  return this.__activeElement;
                },
                element: function element() {
                  return this.__elements;
                },
                _updateActiveElement: function _updateActiveElement(e) {
                  this.__activeElement = d.unbox(e), this.__removeObserver && (this.__removeObserver.weakDestroy(), this.__removeObserver = this.auto_destroy(c.create(this.__activeElement)), this.__removeObserver.on("node-removed", function () {
                    this.weakDestroy();
                  }, this));
                },
                _deferActivate: function _deferActivate() {
                  return !1;
                },
                activate: function activate() {
                  if (!this._deferActivate() && !this.__activated) {
                    if (this.__activated = !0, this.template) this._handlerInitializeTemplate(this.template, this._parentElement);else if (this.templateUrl) return this.__activated = !1, void a.loadHtml(this.templateUrl, function (e) {
                      this.templateUrl = null, this.template = e, this.activate();
                    }, this);
                    if (this._notify("_activate"), this.__rootNodes = [], this.__elements.forEach(function (e) {
                      this.__rootNodes.push(new n(this, null, e));
                    }, this), this._preAfterActivate(this.__activeElement), this._afterActivate(this.__activeElement), this.__activeElement.dynamicshandlerpromise) {
                      this.__activeElement.dynamicshandlerpromise.forEach(function (e) {
                        e.asyncSuccess(this.__activeElement.dynamicshandler);
                      }, this), this.__activeElement.dynamicshandlerpromise = null;
                      try {
                        delete this.__activeElement.dynamicshandlerpromise;
                      } catch (e) {}
                    }
                    this.trigger("dynamic-activated");
                  }
                },
                _afterActivate: function _afterActivate(e) {},
                defaultMesh: function defaultMesh() {
                  return this.__rootNodes[0].mesh();
                },
                registerInheritableAttribute: function registerInheritableAttribute(e, t, i, r) {
                  e = s.prefixNormalize(e, !0), this._inheritableAttributes[e] = this._inheritableAttributes[e] || {}, this._inheritableAttributes[e][t] = {
                    value: i,
                    name: t,
                    node: r
                  };
                },
                unregisterInheritableAttribute: function unregisterInheritableAttribute(e, t) {
                  e = s.prefixNormalize(e, !0), this._inheritableAttributes[e] && (delete this._inheritableAttributes[e][t], o.is_empty(this._inheritableAttributes[e]) && delete this._inheritableAttributes[e]);
                },
                getInheritableAttributes: function getInheritableAttributes(e) {
                  return e = s.prefixNormalize(e, !0), i.values(this._inheritableAttributes[e]);
                }
              };
            }), t.define("module:Exceptions.DynamicsCallException", ["base:Exceptions.Exception"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (o) {
                return {
                  constructor: function constructor(e, t, i, r) {
                    o.constructor.call(this, "Dynamics Exception in '" + e + "' calling method '" + t + "' : " + r);
                  }
                };
              });
            }), t.define("module:Dynamic", ["module:Data.Scope", "module:Parser", "module:Handlers.HandlerMixin", "module:Exceptions.DynamicsCallException", "base:Objs", "base:Strings", "base:Types", "base:Functions", "base:Promise", "base:Events.Events", "base:Loggers.LoggableMixin", "module:Registries", "browser:Dom", "browser:Events", "base:Class"], function (e, t, i, r, o, a, n, s, x, c, d, l, u, h, p, b) {
              var m = e.extend({
                scoped: b
              }, [i, d, function (t) {
                return {
                  supportsGc: !0,
                  proxyAttrs: !1,
                  _notifications: {
                    _activate: "__createActivate"
                  },
                  constructor: function constructor(i) {
                    if (this.initial = this.initial || {}, i = o.extend(o.clone(this.initial, 1), i), this.domevents = o.extend(this.domevents, i.domevents), this.windowevents = o.extend(this.windowevents, i.windowevents), o.iter(this.cls.__initialForward, function (e) {
                      e in this && (e in i ? n.is_object(this[e]) && n.is_object(i[e]) && (i[e] = o.extend(o.clone(this[e], 1), i[e])) : i[e] = this[e]);
                    }, this), i.typedAttrs && i.types && o.iter(i.typedAttrs, function (e, t) {
                      i.attrs[t] = i.types[t] ? n.parseType(e, i.types[t]) : e;
                    }), this.__dispose = i.dispose, o.iter(this.object_functions, function (t) {
                      this[t] = function () {
                        var e = s.getArguments(arguments);
                        return e.unshift(t), this.execute.apply(this, e);
                      };
                    }, this), !i.parent && i.parentHandler) for (var e = i.parentHandler; e && !i.parent;) i.parent = e.instance_of(m) ? e : null, e = e._parentHandler;
                    t.constructor.call(this, i), i.bindAttrs && o.iter(i.bindAttrs, function (e, t) {
                      this.properties().bind(t, e, {
                        secondKey: t
                      });
                    }, this), this.__references = i.references, o.iter(this.__references, function (e) {
                      this.on("change:" + e, function (e, t) {
                        t && p.is_class_instance(t) && !t.destroyed() && t.decreaseRef(this), e && p.is_class_instance(e) && !e.destroyed() && e.increaseRef(this);
                      }, this);
                      var t = this.get(e);
                      t && p.is_class_instance(t) && !t.destroyed() && t.increaseRef(this);
                    }, this), this._channels.global = this.cls.__globalEvents, i.tagName && (this._tagName = i.tagName, this.data("tagname", this._tagName)), this.functions = this.__functions, this._handlerInitialize(i), this.__createActivate = i.create || function () {}, this.dom_events = {}, this.window_events = {}, this.__domEvents = new h(), this.inheritables = (this.parent() ? this.parent().inheritables : []).concat(this.inheritables || []), this.friendgroup.registerScope(this, this.cls.registeredName()), this.friendgroup && this.parent() && this.parent().friendgroup !== this.friendgroup && this.parent().friendgroup.registerScope(this, this.cls.registeredName()), "proxyAttrs" in i && (this.proxyAttrs = i.proxyAttrs), this.proxyAttrs && (this.attrs = this.properties().getProxy());
                  },
                  handle_call_exception: function handle_call_exception(e, t, i) {
                    return l.throwException(new r(this.cls.classname, e, t, i)), null;
                  },
                  hierarchyName: function hierarchyName() {
                    return (this.parent() ? this.parent().hierarchyName() + " > " : "") + this.cls.registeredName();
                  },
                  _preAfterActivate: function _preAfterActivate(n) {
                    this.__domEvents.clear();
                    var s = this;
                    o.iter(this.domevents, function (t, e) {
                      var i = e.split(" "),
                        r = [n];
                      1 < i.length && (r = n.querySelectorAll(i[1]));
                      for (var o = function o(e) {
                          s.execute(t, e, this);
                        }, a = 0; a < r.length; ++a) this.__domEvents.on(r[a], i[0], o);
                    }, this), o.iter(this.windowevents, function (t, e) {
                      this.__domEvents.on(window, e, function (e) {
                        s.execute(t, e, this);
                      });
                    }, this);
                  },
                  destroy: function destroy() {
                    this.friendgroup && this.parent() && this.parent().friendgroup !== this.friendgroup && this.parent().friendgroup.unregisterScope(this, this.cls.registeredName()), this.friendgroup.unregisterScope(this, this.cls.registeredName()), this.free && this.free(), o.iter(this.__references, function (e) {
                      var t = this.get(e);
                      t && p.is_class_instance(t) && !t.destroyed() && t.decreaseRef(this);
                    }, this), o.iter(this.__dispose, function (e) {
                      var t = this.get(e);
                      this.set(e, null), t && t.weakDestroy && t.weakDestroy();
                    }, this), this.__domEvents.destroy(), t.destroy.call(this);
                  }
                };
              }], {
                __initialForward: ["functions", "attrs", "extendables", "collections", "template", "create", "scopes", "bindings", "computed", "types", "events", "dispose", "channels", "registerchannels", "references", "friends"],
                __globalEvents: new c(),
                canonicName: function canonicName() {
                  return this.classname ? a.last_after(this.classname, ".").toLowerCase() : "";
                },
                registeredName: function registeredName() {
                  return this.__registeredName || "ba-" + this.canonicName();
                },
                findByElement: function findByElement(e) {
                  return (e = e && u.unbox(e)) && e.dynamicshandler ? e.dynamicshandler : null;
                },
                findByElementPromise: function findByElementPromise(e) {
                  if (!e) return null;
                  if (!(e = u.unbox(e))) return null;
                  if (e.dynamicshandler) return x.value(e.dynamicshandler);
                  e.dynamicshandlerpromise = e.dynamicshandlerpromise || [];
                  var t = x.create();
                  return e.dynamicshandlerpromise.push(t), t;
                },
                register: function register(e, t) {
                  return t = t || l.handler, this.__registeredName = e || this.registeredName(), t.register(this.__registeredName, this), this;
                },
                registerFunctions: function registerFunctions(e) {
                  return t.registerFunctions(e), this;
                },
                activate: function activate(e) {
                  var t = new this(e || {
                    element: document.body,
                    name_registry: !0
                  });
                  return t.activate(), t;
                },
                attachStringTable: function attachStringTable(e) {
                  return this.__stringTable = e, this;
                },
                addStrings: function addStrings(e) {
                  return this.__stringTable.register(e, this.registeredName()), this;
                },
                string: function string(e) {
                  var t = null;
                  return this.__stringTable && (t = this.__stringTable.get(e, this.registeredName())), !t && this.parent.string && (t = this.parent.string(e)), t;
                },
                stringUnicode: function stringUnicode(e) {
                  var t = null;
                  return this.__stringTable && (t = this.__stringTable.get(e, this.registeredName())), !t && this.parent.string && (t = this.parent.string(e)), u.entitiesToUnicode(t);
                },
                _extender: {
                  events: function events(e, t) {
                    return o.extend(o.clone(e, 1), t);
                  },
                  types: function types(e, t) {
                    return o.extend(o.clone(e, 1), t);
                  },
                  registerchannels: function registerchannels(e, t) {
                    return o.extend(o.clone(e, 1), t);
                  },
                  channels: function channels(e, t) {
                    return o.extend(o.clone(e, 1), t);
                  },
                  attrs: function attrs(e, t) {
                    return n.is_function(e) ? n.is_function(t) ? function () {
                      return o.extend(e.call(this), t.call(this));
                    } : function () {
                      return o.extend(e.call(this), t);
                    } : n.is_function(t) ? function () {
                      return o.extend(o.clone(e, 1), t.call(this));
                    } : o.extend(o.clone(e, 1), t);
                  },
                  inheritables: function inheritables(e, t) {
                    return (e || []).concat(t || []);
                  },
                  dispose: function dispose(e, t) {
                    return (e || []).concat(t || []);
                  },
                  references: function references(e, t) {
                    return (e || []).concat(t || []);
                  }
                }
              });
              return m;
            }), t.define("module:Handlers.Partial", ["base:Class", "base:JavaScript", "base:Functions", "base:Strings", "module:Parser", "module:Registries"], function (e, r, a, n, i, o, t) {
              return e.extend({
                scoped: t
              }, function (o) {
                return {
                  constructor: function constructor(e, t, i, r) {
                    o.constructor.call(this), this._node = e, this._args = t, this._value = i, this._active = !1, this._postfix = r;
                  },
                  change: function change(e, t) {
                    this._value = e, this._change(e, t), this._apply(e, t);
                  },
                  activate: function activate() {
                    this._active || (this._active = !0, this._activate(), this._apply(this._value, null));
                  },
                  deactivate: function deactivate() {
                    this._active && (this._active = !1, this._deactivate());
                  },
                  bindTagHandler: function bindTagHandler(e) {},
                  unbindTagHandler: function unbindTagHandler(e) {},
                  prepareTagHandler: function prepareTagHandler(e) {},
                  _change: function _change(e, t) {},
                  _activate: function _activate() {},
                  _deactivate: function _deactivate() {},
                  _apply: function _apply(e, t) {},
                  _execute: function _execute(e) {
                    e = e || this._value;
                    var t = i.parseText(e) || i.parseCode(e);
                    this._node.__executeDyn(t);
                  },
                  _valueExecute: function _valueExecute(e) {
                    var t = this._value.trim(),
                      i = t;
                    n.starts_with(i, "{{") && n.ends_with(i, "}}") && (i = n.strip_end(n.strip_start(i, "{{"), "}}")), r.isProperIdentifier(i) ? ((e = a.getArguments(e)).unshift(i), this._node._handler.execute.apply(this._node._handler, e)) : this._execute(t);
                  }
                };
              }, {
                meta: {},
                canonicName: function canonicName() {
                  return this.classname ? n.last_after(this.classname, ".").toLowerCase() : "";
                },
                registeredName: function registeredName() {
                  return this.__registeredName || "ba-" + this.canonicName();
                },
                register: function register(e, t) {
                  t = t || o.partial, this.__registeredName = e || this.registeredName(), t.register(this.__registeredName, this);
                }
              });
            }), t.define("module:Partials.ClickPartial", ["module:Handlers.Partial", "browser:Events"], function (e, o, t) {
              var i = e.extend({
                scoped: t
              }, function (r) {
                return {
                  constructor: function constructor(e, t, i) {
                    r.constructor.apply(this, arguments), this.auto_destroy(new o()).on(this._node.element(), "click", function (e) {
                      e.stopPropagation(), this.executeAction();
                    }, this);
                  },
                  executeAction: function executeAction() {
                    this._execute();
                  }
                };
              }, {
                manualExecute: !0
              });
              return i.register("ba-click"), i;
            }), t.define("module:Partials.RepeatPartial", ["module:Handlers.Partial", "base:Promise", "base:Properties.Properties", "base:Collections.Collection", "base:Collections.FilteredCollection", "base:Objs", "module:Parser", "module:Registries"], function (t, a, i, r, o, s, x, c, n) {
              var d = t.extend({
                scoped: n
              }, function (n) {
                return {
                  constructor: function constructor(t, i, r) {
                    n.constructor.apply(this, arguments), this.__alwaysReindexNewItems = !1, this.__registered = !1, 1 < (i = i.split("::")).length && (this.__dynOpts = x.parseCode(i[0].trim()));
                    var o,
                      a = (i = (i = i[i.length - 1]).split("~"))[0].trim().split(".");
                    this.__repeatArg = a[0], this.__indexArg = a[1], this._destroyCollection = !1, this._releaseValueCollection = !1, 1 < i.length && (this.__repeatFilter = x.parseCode(i[1].trim()), o = this, t.mesh().watch(this.__repeatFilter.dependencies, function () {
                      o.__filterChanged();
                    }, this.__repeatFilter)), t._expandChildren = !1;
                    try {
                      t._element.innerHTML = "";
                    } catch (e) {}
                  },
                  destroy: function destroy() {
                    this.__unregister(), this.__repeatFilter && this._node.mesh().unwatch(this.__repeatFilter.dependencies, this.__repeatFilter), n.destroy.call(this);
                  },
                  _activate: function _activate() {
                    this.__register(), this.__dynOpts && (this.__dynOptsCache = this._node.mesh().execute(this.__dynOpts.dependencies, this.__dynOpts.func));
                  },
                  _deactivate: function _deactivate() {
                    this.__unregister();
                  },
                  __filterChanged: function __filterChanged() {
                    this._active && this._collection.setFilter(this.__filterFunc, this);
                  },
                  _change: function _change(e, t) {
                    this.__register(e);
                  },
                  __filterFunc: function __filterFunc(t) {
                    var i = this.__repeatFilter;
                    if (!i) return !0;
                    var r = this;
                    return this._node.mesh().execute(i.dependencies, function (e) {
                      return e[r.__repeatArg] = r._isArray ? t.get("value") : t.data(), r.__indexArg && (e[r.__indexArg] = r._collection.getIndex(t)), i.func.call(this, e);
                    }, !0);
                  },
                  _iterateCollection: function _iterateCollection(e) {
                    this._collection.iterate(e, this);
                  },
                  __register: function __register() {
                    this.__unregister(), r.is_instance_of(this._value) && this._value.destroyed() || (this._isArray = !r.is_instance_of(this._value), this._releaseValueCollection = !r.is_instance_of(this._value), this._valueCollection = this._releaseValueCollection ? new r({
                      objects: s.map(this._value, function (e) {
                        return new i({
                          value: e
                        });
                      }),
                      release_references: !0
                    }) : this._value, this._destroyCollection = !!this.__repeatFilter, this._collection = this._destroyCollection ? new o(this._valueCollection, {
                      filter: this.__filterFunc,
                      context: this
                    }) : this._valueCollection, this._collectionChildren = {}, this._iterateCollection(this.__addItem), this._collection.on("add", this.__addItem, this), this._collection.on("remove", function (e) {
                      this.__removeItem(e, this._collection.bulkOperationInProgress());
                    }, this), this._collection.on("reindexed", function (e) {
                      var t;
                      this._collection.count() < 2 || (0 === (t = this._collection.getIndex(e)) ? this._prependItem(this._collection.getByIndex(1), e) : this._appendItem(this._collection.getByIndex(t - 1), e));
                    }, this));
                  },
                  __unregister: function __unregister() {
                    this._collection && !this._collection.destroyed() && this._iterateCollection(function (e) {
                      this.__removeItem(e, !0);
                    }, this);
                    var e = this._node._element;
                    this._node._removeChildren(), e.innerHTML = "", this._collection && !this._collection.destroyed() && this._collection.off(null, null, this), this._valueCollection && !this._valueCollection.destroyed() && this._valueCollection.off(null, null, this), this._destroyCollection && this._collection && this._collection.weakDestroy(), this._releaseValueCollection && this._valueCollection && !this._valueCollection.destroyed() && this._valueCollection.decreaseRef(), this._valueCollection = null, this._collection = null;
                  },
                  __addItem: function __addItem(e) {
                    var t, i, r;
                    this._collectionChildren[e.cid()] || (t = {}, this.__repeatArg && (t[this.__repeatArg] = this._isArray ? e.get("value") : e), this.__indexArg && (t[this.__indexArg] = this._collection.getIndex(e)), i = [], this._newItemElements().forEach(function (e) {
                      i.push(this._node._registerChild(e, t));
                    }, this), this._collectionChildren[e.cid()] = {
                      item: e,
                      nodes: i
                    }, (r = this._collection.getIndex(e)) < this._collection.count() - 1 ? this._prependItem(this._collection.getByIndex(r + 1), e) : this.__alwaysReindexNewItems && 1 < this._collection.count() && this._appendItem(this._collection.getByIndex(r - 1), e));
                  },
                  __removeItem: function __removeItem(r, o) {
                    this._collectionChildren[r.cid()] && (s.iter(this._collectionChildren[r.cid()].nodes, function (e) {
                      var t = e.element(),
                        i = a.create();
                      this.__dynOptsCache && this.__dynOptsCache.onremove && !o ? this.__dynOptsCache.onremove.call(this._handler, r, t).forwardCallback(i) : i.asyncSuccess(!0), i.success(function () {
                        e.weakDestroy(), t.parentNode && t.parentNode.removeChild(t);
                      });
                    }, this), delete this._collectionChildren[r.cid()]);
                  },
                  _itemData: function _itemData(e) {
                    return this._collectionChildren[e.cid()];
                  },
                  _itemDataElements: function _itemDataElements(e) {
                    var t = this._itemData(e);
                    if (!t) return null;
                    var i = [];
                    return s.iter(t.nodes, function (e) {
                      i.push(e.element());
                    }), i;
                  },
                  _prependItem: function _prependItem(e, t) {
                    var i = this._itemDataElements(e),
                      r = this._itemDataElements(t);
                    i && r && s.iter(r, function (e) {
                      e.parentNode.insertBefore(e, i[0]);
                    });
                  },
                  _appendItem: function _appendItem(e, t) {
                    var i,
                      r = this._itemDataElements(e),
                      o = this._itemDataElements(t);
                    r && o && (i = r[r.length - 1], s.iter(o, function (e) {
                      i.parentNode.insertBefore(e, i.nextSibling), i = e;
                    }));
                  },
                  _newItemElements: function _newItemElements() {
                    var e = c.templates.create(this._node._innerTemplate),
                      t = this._node.element();
                    return e.forEach(function (e) {
                      t.appendChild(e);
                    }), e;
                  }
                };
              });
              return d.register("ba-repeat"), d;
            }), t.define("module:Partials.RepeatElementPartial", ["module:Partials.RepeatPartial", "base:Collections.Collection", "base:Collections.FilteredCollection", "base:Objs", "module:Parser", "base:Properties.Properties", "browser:Dom"], function (e, t, i, r, o, a, n, s) {
              var x = e.extend({
                scoped: s
              }, function (o) {
                return {
                  constructor: function constructor(e, t, i) {
                    o.constructor.apply(this, arguments);
                    var r = n.elementByTemplate(e._template);
                    r.removeAttribute("ba-repeat-element"), this.__filteredTemplate = r.outerHTML.trim(), this.__alwaysReindexNewItems = !0;
                  },
                  _activate: function _activate() {
                    this._node.element().style.display = "none", o._activate.call(this);
                  },
                  _iterateCollection: function _iterateCollection(e) {
                    for (var t = this._collection.iterator().asArray(), i = t.length - 1; 0 <= i; --i) e.call(this, t[i]);
                  },
                  _newItemElements: function _newItemElements() {
                    var e = n.elementByTemplate(this.__filteredTemplate);
                    return this._node.element().parentNode.insertBefore(e, this._node.element().nextSibling), e["ba-handled"] = !0, [e];
                  },
                  prepareTagHandler: function prepareTagHandler(e) {
                    e.ignoreTagHandler = !0;
                  }
                };
              });
              return x.register("ba-repeat-element"), x;
            }), t.define("module:Partials.StylesPartial", ["module:Handlers.Partial", "base:Objs"], function (e, t, i) {
              var r = e.extend({
                scoped: i
              }, {
                _apply: function _apply(i) {
                  var r = this._node._element.style;
                  t.iter(this.__previousValue, function (e, t) {
                    t in i || r.removeProperty(t);
                  }), t.extend(r, i), this.__previousValue = t.clone(i, 1);
                }
              });
              return r.register("ba-styles"), r;
            }), t.define("module:Partials.ShowPartial", ["module:Handlers.Partial"], function (e, t) {
              var i = e.extend({
                scoped: t
              }, function (r) {
                return {
                  constructor: function constructor(e, t, i) {
                    r.constructor.apply(this, arguments), this.__oldDisplay = undefined, this.__readOldDisplay = !1, this.__hidden = !1, i || this.__hide();
                  },
                  __hide: function __hide() {
                    this.__hidden || (this.__hidden = !0, this.__readOldDisplay || (this.__oldDisplay = this._node._element.style.display, this.__readOldDisplay = !0), this._node._element.style.display = "none");
                  },
                  __show: function __show() {
                    this.__hidden && (this.__hidden = !1, this._node._element.style.display = this.__oldDisplay && "none" !== this.__oldDisplay ? this.__oldDisplay : "");
                  },
                  _apply: function _apply(e) {
                    e ? this.__show() : this.__hide();
                  }
                };
              });
              return i.register("ba-show"), i;
            }), t.define("module:Partials.IfPartial", ["module:Partials.ShowPartial"], function (e, t) {
              var i = e.extend({
                scoped: t
              }, function (r) {
                return {
                  constructor: function constructor(e, t, i) {
                    r.constructor.apply(this, arguments), i || e.deactivate();
                  },
                  _apply: function _apply(e) {
                    r._apply.call(this, e), e ? this._node.activate() : this._node.deactivate();
                  }
                };
              });
              return i.register("ba-if"), i;
            }), t.define("module:Partials.EventPartial", ["module:Handlers.Partial", "base:Functions"], function (e, r, t) {
              var i = e.extend({
                scoped: t
              }, {
                bindTagHandler: function bindTagHandler(e) {
                  var t = this._postfix.trim(),
                    i = 0 === t.indexOf("~");
                  i && (t = t.substring(1)), e.on(t, function () {
                    var e;
                    i ? ((e = r.getArguments(arguments)).unshift(this._value || t), this._node._handler.trigger.apply(this._node._handler, e)) : this._valueExecute(arguments);
                  }, this);
                }
              }, {
                manualExecute: !0
              });
              return i.register("ba-event"), i;
            }), t.define("module:Partials.OnPartial", ["module:Handlers.Partial", "browser:Events"], function (e, a, t) {
              var i = e.extend({
                scoped: t
              }, function (o) {
                return {
                  constructor: function constructor(e, t, i, r) {
                    o.constructor.apply(this, arguments), this.auto_destroy(new a()).on(this._node._element, r.trim(), function () {
                      this._execute(i.trim());
                    }, this);
                  }
                };
              }, {
                manualExecute: !0
              });
              return i.register("ba-on"), i;
            }), t.define("module:Partials.TogglePartial", ["module:Handlers.Partial"], function (e, t) {
              var i = {
                  readonly: "readOnly",
                  playsinline: "playsInline"
                },
                r = e.extend({
                  scoped: t
                }, function (o) {
                  return {
                    constructor: function constructor(e, t, i, r) {
                      o.constructor.apply(this, arguments), this._apply(i);
                    },
                    _apply: function _apply(e) {
                      this._node.element()[i[this._postfix] || this._postfix] = e ? this._postfix : null;
                    }
                  };
                });
              return r.register("ba-toggle"), r;
            }), t.define("module:Partials.TemplatePartial", ["module:Handlers.Partial"], function (e, t) {
              var i = e.extend({
                scoped: t
              }, {
                bindTagHandler: function bindTagHandler(e) {
                  this._value && (e.template = this._value);
                }
              }, {
                meta: {
                  requires_tag_handler: !0,
                  value_hidden: !0
                }
              });
              return i.register("ba-template"), i;
            }), t.define("module:Partials.HotkeyPartial", ["module:Handlers.Partial", "browser:Events", "browser:Hotkeys"], function (e, n, s, t) {
              var i = e.extend({
                scoped: t
              }, function (a) {
                return {
                  constructor: function constructor(e, t, i) {
                    a.constructor.apply(this, arguments);
                    var r = this.auto_destroy(new n()),
                      o = this._postfix;
                    r.on(this._node._element, "keydown", function (e) {
                      s.handleKeyEvent(o, e) && this._valueExecute([e]);
                    }, this);
                  }
                };
              }, {
                manualExecute: !0
              });
              return i.register("ba-hotkey"), i;
            }), t.define("module:Partials.DataPartial", ["module:Handlers.Partial"], function (e, t) {
              var i = e.extend({
                scoped: t
              }, {
                _apply: function _apply(e) {
                  this._node._tagHandler.data(this._postfix, e);
                },
                bindTagHandler: function bindTagHandler(e) {
                  this._apply(this._value);
                }
              }, {
                meta: {
                  requires_tag_handler: !0
                }
              });
              return i.register("ba-data"), i;
            }), t.define("module:Partials.AttrsPartial", ["module:Handlers.Partial", "base:Objs", "base:Class"], function (e, i, r, t) {
              var o = e.extend({
                scoped: t
              }, {
                _apply: function _apply(e) {
                  if (this._active) {
                    var t = this._node._tagHandler ? this._node._tagHandler.properties() : this._node.properties();
                    for (var i in e) t.set(i, e[i]);
                  }
                },
                bindTagHandler: function bindTagHandler(e) {
                  for (var t in this._value) e.setArgumentAttr(t, r.is_pure_json(this._value[t]) ? i.clone(this._value[t], 1) : this._value[t]);
                }
              });
              return o.register("ba-attrs"), o;
            }), t.define("module:DomObserver", ["base:Class", "base:Objs", "browser:DomMutation.NodeInsertObserver", "module:Registries", "module:Dynamic", "browser:Dom"], function (e, i, r, o, a, n, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), e = e || {}, this.__initialRoot = e.root, this.__persistent_dynamics = !!e.persistent_dynamics, this.__allowed_dynamics = e.allowed_dynamics ? i.objectify(e.allowed_dynamics) : null, this.__forbidden_dynamics = e.forbidden_dynamics ? i.objectify(e.forbidden_dynamics) : null, this.__ignore_existing = e.ignore_existing, this.__dynamics = {}, this.__enabled = !1, "enabled" in e && !e.enabled || this.enable();
                  },
                  enable: function enable() {
                    this.__enabled || (this.__enabled = !0, this.__root = n.unbox(this.__initialRoot || document.body), this.__ignore_existing || i.iter(o.handler.classes(), this.__registerExisting, this), this.__observer = r.create({
                      root: this.__root,
                      filter: this.__observerFilter,
                      context: this
                    }), this.__observer.on("node-inserted", this.__nodeInserted, this));
                  },
                  disable: function disable() {
                    this.__enabled && (this.__enabled = !1, this.__observer.weakDestroy());
                  },
                  __registerExisting: function __registerExisting(e, t) {
                    if ((!this.__forbidden_dynamics || !this.__forbidden_dynamics[t]) && (!this.__allowed_dynamics || this.__allowed_dynamics[t])) for (var i = this.__root.getElementsByTagName(t.toUpperCase()), r = 0; r < i.length; ++r) {
                      var o = i[r];
                      o.dynamicshandler || this.__nodeInserted(o);
                    }
                  },
                  addAllowedDynamic: function addAllowedDynamic(e) {
                    this.__allowed_dynamics = this.__allowed_dynamics || {}, this.__allowed_dynamics[e] = !0;
                    var t = o.handler.classes()[e];
                    this.__enabled && !this.__ignore_existing && t && this.__registerExisting(t, e);
                  },
                  destroy: function destroy() {
                    this.disable(), i.iter(this.__dynamics, function (e) {
                      e.off(null, null, this), this.__persistent_dynamics || e.weakDestroy();
                    }, this), t.destroy.call(this);
                  },
                  __observerFilter: function __observerFilter(e) {
                    if (e.dynamicshandler || !e.tagName) return !1;
                    var t = e.tagName.toLowerCase();
                    return !!o.handler.get(t) && (!this.__forbidden_dynamics || !this.__forbidden_dynamics[t]) && !(this.__allowed_dynamics && !this.__allowed_dynamics[t]);
                  },
                  __nodeInserted: function __nodeInserted(e) {
                    var t = new a({
                      element: e,
                      remove_observe: !0
                    });
                    (this.__dynamics[t.cid()] = t).on("destroy", function () {
                      delete this.__dynamics[t.cid()];
                    }, this), t.activate();
                  }
                };
              }, {
                __singleton: null,
                activate: function activate(e) {
                  this.__singleton || (this.__singleton = new this(e));
                }
              });
            });
          }.call(Scoped), function () {
            var Scoped = this.subScope();
            Scoped.binding("base", "root:BetaJS"), Scoped.binding("browser", "root:BetaJS.Browser"), Scoped.binding("dynamics", "root:BetaJS.Dynamics"), Scoped.binding("media", "root:BetaJS.Media"), Scoped.binding("module", "root:BetaJS.MediaComponents"), Scoped.define("module:", function () {
              return {
                guid: "7a20804e-be62-4982-91c6-98eb096d2e70",
                version: "0.0.291",
                datetime: 1641674518724
              };
            }), Scoped.define("module:Ads.AbstractVideoAdProvider", ["base:Class"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this._options = e;
                  },
                  options: function options() {
                    return this._options;
                  },
                  _newPrerollAd: function _newPrerollAd(e) {},
                  newPrerollAd: function newPrerollAd(e) {
                    return this._newPrerollAd(e);
                  },
                  register: function register(e) {
                    this.cls.registry[e] = this;
                  }
                };
              }, {
                registry: {}
              });
            }), Scoped.define("module:Ads.AbstractPrerollAd", ["base:Class", "base:Events.EventsMixin"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, [t, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    i.constructor.call(this), this._provider = e, this._options = t;
                  },
                  executeAd: function executeAd(e) {
                    this._options.adElement.style.display = "", this._executeAd(e);
                  },
                  _adFinished: function _adFinished() {
                    this._options.adElement.style.display = "none", this.trigger("finished");
                  },
                  _adSkipped: function _adSkipped() {
                    this._options.adElement.style.display = "none", this.trigger("adskipped");
                  }
                };
              }]);
            }), Scoped.define("module:Ads.AdSensePrerollAd", ["module:Ads.AbstractPrerollAd"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (r) {
                return {
                  constructor: function constructor(e, t) {
                    r.constructor.call(this, e, t), this._adDisplayContainer = new google.ima.AdDisplayContainer(this._options.adElement, this._options.videoElement), this._adDisplayContainer.initialize(), this._adsLoader = new google.ima.AdsLoader(this._adDisplayContainer);
                    var i = this;
                    this._adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, function () {
                      i._adError();
                    }, !1), this._adsLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, function () {
                      i._adLoaded.apply(i, arguments);
                    }, !1), this._adsRequest = new google.ima.AdsRequest(), this._adsRequest.adTagUrl = this._provider.options().adTagUrl;
                  },
                  _executeAd: function _executeAd(e) {
                    this._adsRequest.linearAdSlotWidth = e.width, this._adsRequest.linearAdSlotHeight = e.height, this._adsLoader.requestAds(this._adsRequest);
                  },
                  _adError: function _adError() {
                    this._adsManager && this._adsManager.destroy(), this._adFinished();
                  },
                  _adLoaded: function _adLoaded(e) {
                    this._adsManager = e.getAdsManager(this._options.videoElement);
                    try {
                      this._adsManager.init(this._adsRequest.linearAdSlotWidth, this._adsRequest.linearAdSlotHeight, google.ima.ViewMode.NORMAL), this._adsManager.start();
                    } catch (i) {}
                    var t = this;
                    this._adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, function () {
                      t._adError();
                    }, !1), this._adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, function () {
                      t._adFinished();
                    }), this._adsManager.addEventListener(google.ima.AdEvent.Type.SKIPPED, function () {
                      t._adSkipped();
                    });
                  }
                };
              });
            }), Scoped.define("module:Ads.AdSenseVideoAdProvider", ["module:Ads.AbstractVideoAdProvider", "module:Ads.AdSensePrerollAd"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, {
                _newPrerollAd: function _newPrerollAd(e) {
                  return new t(this, e);
                }
              });
            }), Scoped.define("module:Ads.VAST.Ad", ["base:Class", "base:Objs", "base:Events.EventsMixin"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, [i, function (e) {
                return {
                  constructor: function constructor() {
                    e.constructor.call(this), this.id = null, this.sequence = null, this.system = null, this.title = null, this.description = null, this.advertiser = null, this.pricing = null, this.survey = null, this.errorURLTemplates = [], this.impressionURLTemplates = [], this.creatives = [], this.extensions = [], this.trackingEvents = {}, this.availableTrackingEvents = ["creativeView", "start", "firstQuartile", "midpoint", "thirdQuartile", "complete", "rewind", "skip", "closeLinear", "close", "mute", "unmute", "pause", "resume", "playerExpand", "playerCollapse", "acceptInvitationLinear", "timeSpentViewing", "otherAdInteraction", "progress", "acceptInvitation", "adExpand", "adCollapse", "minimize", "overlayViewDuration", "fullscreen", "exitFullscreen", "clickthrough"], t.iter(this.availableTrackingEvents, function (e) {
                      this.trackingEvents[e] = null;
                    }, this);
                  }
                };
              }], {
                isNumeric: function isNumeric(e) {
                  return !isNaN(parseFloat(e)) && isFinite(e);
                },
                trackAd: function trackAd(e, t) {
                  for (var i, r, o = this.resolveURLTemplates(e, t), a = [], n = 0, s = o.length; n < s; n++) i = o[n], "undefined" != typeof window && null !== window && (r = new Image(), a.push(r.src = i));
                  return a;
                },
                resolveURLTemplates: function resolveURLTemplates(e, t) {
                  var i,
                    r,
                    o,
                    a,
                    n,
                    s,
                    x,
                    c = [];
                  for ((t = t || {}).ASSETURI && (t.ASSETURI = this.encodeURIComponentRFC3986(t.ASSETURI)), t.CONTENTPLAYHEAD && (t.CONTENTPLAYHEAD = this.encodeURIComponentRFC3986(t.CONTENTPLAYHEAD)), t.ERRORCODE && !/^[0-9]{3}$/.test(t.ERRORCODE) && (t.ERRORCODE = 900), t.CACHEBUSTING = this.leftpad(Math.round(1e8 * Math.random()).toString()), t.TIMESTAMP = this.encodeURIComponentRFC3986(new Date().toISOString()), t.RANDOM = t.random = t.CACHEBUSTING, i = 0, o = e.length; i < o; i++) if (s = e[i]) {
                    for (r in t) x = t[r], a = "[" + r + "]", n = "%%" + r + "%%", s = (s = s.replace(a, x)).replace(n, x);
                    c.push(s);
                  }
                  return c;
                },
                leftpad: function leftpad(r) {
                  return r.length < 8 ? function () {
                    for (var e = [], t = 0, i = 8 - r.length; 0 <= i ? t < i : i < t; 0 <= i ? t++ : t--) e.push("0");
                    return e;
                  }().join("") + r : r;
                },
                encodeURIComponentRFC3986: function encodeURIComponentRFC3986(e) {
                  return encodeURIComponent(e).replace(/[!'()*]/g, function (e) {
                    return "%" + e.charCodeAt(0).toString(16);
                  });
                },
                storage: function () {
                  var i, e;
                  try {
                    e = "undefined" != typeof window && null !== window ? window.localStorage || window.sessionStorage : null;
                  } catch (r) {
                    e = null;
                  }
                  return null !== e && !function (e) {
                    var t, i;
                    try {
                      if (t = "__VAST__", i = e.getItem(t), e.setItem(t, t), e.getItem(t) !== t) return !0;
                      i ? e.setItem(t, i) : e.removeItem(t);
                    } catch (r) {
                      return !0;
                    }
                    return !1;
                  }(e) || (i = {}, e = {
                    length: 0,
                    getItem: function getItem(e) {
                      return i[e];
                    },
                    setItem: function setItem(e, t) {
                      i[e] = t, this.length = Object.keys(i).length;
                    },
                    removeItem: function removeItem(e) {
                      delete i[e], this.length = Object.keys(i).length;
                    },
                    clear: function clear() {
                      i = {}, this.length = 0;
                    }
                  }), e;
                }()
              });
            }), Scoped.define("module:Ads.VAST.Response", ["module:Ads.VAST.Ad"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  constructor: function constructor() {
                    this.ads = [], this.errorURLTemplates = [];
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.CompanionAd", ["module:Ads.VAST.Ad"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  constructor: function constructor() {
                    e.constructor.call(this), this.id = null, this.width = 0, this.height = 0, this.type = null, this.staticResource = null, this.htmlRecource = null, this.iframeResource = null, this.altText = null, this.companionClickThroughURLTemplate = null, this.companionClickTrackingURLTemplates = [];
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.Creative", ["module:Ads.VAST.Ad"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), null === e && (e = {}), this.id = e.id || null, this.adId = e.adId || null, this.sequence = e.sequence || null, this.apiFramework = e.apiFramework || null;
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.CreativeLinear", ["module:Ads.VAST.Ad"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  constructor: function constructor() {
                    e.constructor.call(this), this.type = "linear", this.duration = 0, this.skipDelay = null, this.mediaFiles = [], this.videoClickThroughURLTemplate = null, this.videoClickTrackingURLTemplates = [], this.videoCustomClickURLTemplates = [], this.adParameters = null, this.icons = [];
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.CreativeNonLinear", ["module:Ads.VAST.Ad"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  constructor: function constructor() {
                    e.constructor.call(this), this.type = "nonlinear", this.variations = [];
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.AdExtension", ["module:Ads.VAST.Ad"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  constructor: function constructor() {
                    e.constructor.call(this), this.attributes = {}, this.children = [];
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.AdExtensionChild", ["module:Ads.VAST.Ad"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  constructor: function constructor() {
                    e.constructor.call(this), this.name = null, this.value = null, this.attributes = {};
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.Icon", ["module:Ads.VAST.Ad"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  constructor: function constructor() {
                    e.constructor.call(this), this.program = null, this.height = 0, this.width = 0, this.xPosition = 0, this.yPosition = 0, this.apiFramework = null, this.offset = null, this.duration = 0, this.type = null, this.staticResource = null, this.htmlResource = null, this.iframeResource = null, this.iconClickThroughURLTemplate = null, this.iconClickTrackingURLTemplates = [], this.iconViewTrackingURLTemplate = null;
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.MediaFile", ["module:Ads.VAST.Ad"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  constructor: function constructor(e) {
                    this.id = null, this.fileURL = null, this.deliveryType = "progressive", this.mimeType = null, this.codec = null, this.bitrate = 0, this.minBitrate = 0, this.maxBitrate = 0, this.width = 0, this.height = 0, this.apiFramework = null, this.scalable = null, this.maintainAspectRatio = null;
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.CreativeCompanion", ["module:Ads.VAST.Ad"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  constructor: function constructor(e) {
                    e.constructor.call(this), this.type = "companion", this.variations = [];
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.NonLinear", ["module:Ads.VAST.Ad"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  constructor: function constructor() {
                    e.constructor.call(this), this.id = null, this.width = 0, this.height = 0, this.expandedWidth = 0, this.expandedHeight = 0, this.scalable = !0, this.maintainAspectRatio = !0, this.minSuggestedDuration = 0, this.apiFramework = "static", this.type = null, this.staticResource = null, this.htmlResource = null, this.iframeResource = null, this.nonlinearClickThroughURLTemplate = null, this.nonlinearClickTrackingURLTemplates = [], this.adParameters = null;
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.Parser", ["module:Ads.VAST.Ad", "base:Ajax.Support", "module:Ads.VAST.Response", "module:Ads.VAST.CreativeLinear", "module:Ads.VAST.MediaFile", "module:Ads.VAST.CreativeCompanion", "module:Ads.VAST.CreativeNonLinear", "module:Ads.VAST.CompanionAd", "module:Ads.VAST.AdExtension", "module:Ads.VAST.AdExtensionChild", "module:Ads.VAST.NonLinear"], function (m, s, g, se, xe, U, M, L, _, E, I, e) {
              return m.extend({
                scoped: e
              }, function (e) {
                return {
                  constructor: function constructor() {
                    e.constructor.call(this), this.URLTemplateFilters = [];
                  },
                  _indexOf: function _indexOf(e) {
                    for (var t = 0, i = this.length; t < i; t++) if (t in this && this[t] === e) return t;
                    return -1;
                  },
                  addURLTemplateFilter: function addURLTemplateFilter(e) {
                    "function" == typeof e && URLTemplateFilters.push(e);
                  },
                  removeURLTemplateFilter: function removeURLTemplateFilter() {
                    return URLTemplateFilters.pop();
                  },
                  countURLTemplateFilters: function countURLTemplateFilters() {
                    return URLTemplateFilters.length;
                  },
                  clearUrlTemplateFilters: function clearUrlTemplateFilters() {
                    return URLTemplateFilters = [], URLTemplateFilters;
                  },
                  parse: function parse(e, t, i) {
                    return i || ("function" == typeof t && (i = t), t = {}), this._parse(e, null, t, function (e, t) {
                      return i(e, t);
                    });
                  },
                  track: function track(e, t) {
                    return m.trackAd(e, t);
                  },
                  _parse: function _parse(t, i, r, o) {
                    var e, a, n;
                    for (o || ("function" == typeof r && (o = r), r = {}), a = 0, n = this.URLTemplateFilters.length; a < n; a++) e = URLTemplateFilters[a], t = e(t);
                    return null === i && (i = []), i.push(t), s.execute({
                      uri: t,
                      contentType: "xml",
                      decodeType: "xml"
                    }).error(function (e) {
                      o(e, null);
                    }).success(function (e) {
                      return this.parseXmlDocument(t, i, r, e, o);
                    }, this);
                  },
                  __indexOf: [].indexOf || function (e) {
                    for (var t = 0, i = this.length; t < i; t++) if (t in this && this[t] === e) return t;
                    return -1;
                  },
                  parseXmlDocument: function parseXmlDocument(e, t, i, r, n) {
                    var s,
                      o,
                      a,
                      x,
                      c,
                      d,
                      l,
                      u,
                      h,
                      p,
                      b = this,
                      m = new g();
                    if (null === (null !== r ? r.documentElement : void 0) || "VAST" !== r.documentElement.nodeName) return n(new Error("Invalid VAST XMLDocument"));
                    for (a = 0, c = (h = r.documentElement.childNodes).length; a < c; a++) "Error" === (u = h[a]).nodeName && m.errorURLTemplates.push(this.parseNodeText(u));
                    for (x = 0, d = (p = r.documentElement.childNodes).length; x < d; x++) "Ad" === (u = p[x]).nodeName && (null !== (s = this.parseAdElement(u)) ? m.ads.push(s) : this.track(m.errorURLTemplates, {
                      ERRORCODE: 101,
                      ERRORMESSAGE: "VAST schema validation error."
                    }));
                    for (o = function o(e, t) {
                      var i, r, o, a;
                      if (null === e && (e = null), null === t && (t = !1), m) {
                        for (o = !0, i = 0, r = (a = m.ads).length; i < r; i++) {
                          if ((s = a[i]).nextWrapperURL) return;
                          0 < s.creatives.length && (o = !1);
                        }
                        return o && (t || b.track(m.errorURLTemplates, {
                          ERRORCODE: 303,
                          ERRORMESSAGE: "No VAST response after one or more Wrappers (No creatives)"
                        })), 0 === m.ads.length && (m = null), n(e, m);
                      }
                    }, l = m.ads.length; l--;) (s = m.ads[l]).nextWrapperURL && this._handleComplete.call(this, s, e, m, t, i, o);
                    return o();
                  },
                  _handleComplete: function _handleComplete(x, e, c, t, i, d) {
                    var r;
                    return t.length > (i.wrapperLimit ? i.wrapperLimit : 9) || (r = x.nextWrapperURL, 0 <= this.__indexOf.call(t, r)) ? (this.track(x.errorURLTemplates, {
                      ERRORCODE: 302,
                      ERRORMESSAGE: "Wrapper limit reached, as defined by the video player. Too many Wrapper responses have been received with no InLine response."
                    }), c.ads.splice(c.ads.indexOf(x), 1), void d(new Error("Wrapper limit reached, as defined by the video player"))) : (e && (x.nextWrapperURL = this.resolveVastAdTagURI(x.nextWrapperURL, e)), this._parse(x.nextWrapperURL, t, i, function (e, t) {
                      var i,
                        r,
                        o,
                        a,
                        n,
                        s = !1;
                      if (e) this.track(x.errorURLTemplates, {
                        ERRORCODE: 301,
                        ERRORMESSAGE: "Timeout of VAST URI provided in Wrapper element, or of VAST URI provided in a subsequent Wrapper element. (URI was either unavailable or reached a timeout as defined by the video player.)"
                      }), c.ads.splice(c.ads.indexOf(x), 1), s = !0;else if (t) for (c.errorURLTemplates = c.errorURLTemplates.concat(t.errorURLTemplates), i = c.ads.indexOf(x), c.ads.splice(i, 1), r = 0, o = (a = t.ads).length; r < o; r++) n = a[r], this.mergeWrapperAdData(n, x), c.ads.splice(++i, 0, n);else this.track(x.errorURLTemplates, {
                        ERRORCODE: 303,
                        ERRORMESSAGE: "No VAST response after one or more Wrappers"
                      }), c.ads.splice(c.ads.indexOf(x), 1), s = !0;
                      return delete x.nextWrapperURL, d(e, s);
                    }));
                  },
                  resolveVastAdTagURI: function resolveVastAdTagURI(e, t) {
                    return 0 === e.indexOf("//") ? "" + location.protocol + e : -1 === e.indexOf("://") ? t.slice(0, t.lastIndexOf("/")) + "/" + e : e;
                  },
                  mergeWrapperAdData: function mergeWrapperAdData(e, t) {
                    var i, r, o, a, n, s, x, c, d, l, u, h, p, b, m, g, v, f, y, _;
                    for (e.errorURLTemplates = t.errorURLTemplates.concat(e.errorURLTemplates), e.impressionURLTemplates = t.impressionURLTemplates.concat(e.impressionURLTemplates), e.extensions = t.extensions.concat(e.extensions), o = 0, x = (u = e.creatives).length; o < x; o++) if (i = u[o], null !== (null !== (h = t.trackingEvents) ? h[i.type] : void 0)) for (r in p = t.trackingEvents[i.type]) _ = p[r], i.trackingEvents[r] ? (void 0)[r] = i.trackingEvents[r] : (void 0)[r] = [], i.trackingEvents[r] = i.trackingEvents[r].concat(_);
                    if (null !== (b = t.videoClickTrackingURLTemplates) && b.length) for (a = 0, c = (m = e.creatives).length; a < c; a++) "linear" === (i = m[a]).type && (i.videoClickTrackingURLTemplates = i.videoClickTrackingURLTemplates.concat(t.videoClickTrackingURLTemplates));
                    if ((g = t.videoCustomClickURLTemplates) && g.length) for (n = 0, d = (v = e.creatives).length; n < d; n++) "linear" === (i = v[n]).type && (i.videoCustomClickURLTemplates = i.videoCustomClickURLTemplates.concat(t.videoCustomClickURLTemplates));
                    if (t.videoClickThroughURLTemplate) {
                      for (y = [], s = 0, l = (f = e.creatives).length; s < l; s++) "linear" === (i = f[s]).type && null === i.videoClickThroughURLTemplate ? y.push(i.videoClickThroughURLTemplate = t.videoClickThroughURLTemplate) : y.push(void 0);
                      return y;
                    }
                  },
                  childByName: function childByName(e, t) {
                    for (var i, r = e.childNodes, o = 0, a = r.length; o < a; o++) if ((i = r[o]).nodeName === t) return i;
                  },
                  childsByName: function childsByName(e, t) {
                    for (var i, r = [], o = e.childNodes, a = 0, n = o.length; a < n; a++) (i = o[a]).nodeName === t && r.push(i);
                    return r;
                  },
                  parseAdElement: function parseAdElement(e) {
                    for (var t, i, r = e.childNodes, o = 0, a = r.length; o < a; o++) if ("Wrapper" === (i = (t = r[o]).nodeName) || "InLine" === i) {
                      if (this.copyNodeAttribute("id", e, t), this.copyNodeAttribute("sequence", e, t), "Wrapper" === t.nodeName) return this.parseWrapperElement(t);
                      if ("InLine" === t.nodeName) return this.parseInLineElement(t);
                    }
                  },
                  parseWrapperElement: function parseWrapperElement(e) {
                    var t,
                      i,
                      r,
                      o,
                      a,
                      n,
                      s,
                      x,
                      c,
                      d,
                      l,
                      u,
                      h,
                      p,
                      b,
                      m,
                      g,
                      v,
                      f,
                      y = this.parseInLineElement(e),
                      _ = this.childByName(e, "VASTAdTagURI");
                    for (_ ? y.nextWrapperURL = this.parseNodeText(_) : (_ = this.childByName(e, "VASTAdTagURL")) && (y.nextWrapperURL = this.parseNodeText(this.childByName(_, "URL"))), i = 0, s = (u = y.creatives).length; i < s; i++) if ("linear" === (h = (f = u[i]).type) || "nonlinear" === h) {
                      if (f.trackingEvents) for (t in y.trackingEvents = y.trackingEvents ? y.trackingEvents : {}, (void 0)[l = f.type] = y.trackingEvents[l] ? y.trackingEvents[l] : {}, p = f.trackingEvents) if (null !== (v = p[t])) for ((void 0)[t] = y.trackingEvents[f.type][t] ? y.trackingEvents[f.type][t] : [], o = 0, x = v.length; o < x; o++) g = v[o], y.trackingEvents[f.type][t].push(g);
                      if (f.videoClickTrackingURLTemplates) for (y.videoClickTrackingURLTemplates = y.videoClickTrackingURLTemplates || [], a = 0, c = (b = f.videoClickTrackingURLTemplates).length; a < c; a++) r = b[a], y.videoClickTrackingURLTemplates.push(r);
                      if (f.videoClickThroughURLTemplate && (y.videoClickThroughURLTemplate = f.videoClickThroughURLTemplate), f.videoCustomClickURLTemplates) for (y.videoCustomClickURLTemplates = y.videoCustomClickURLTemplates || [], n = 0, d = (m = f.videoCustomClickURLTemplates).length; n < d; n++) r = m[n], y.videoCustomClickURLTemplates.push(r);
                    }
                    if (y.nextWrapperURL) return y;
                  },
                  parseInLineElement: function parseInLineElement(e) {
                    var t,
                      i,
                      r,
                      o,
                      a,
                      n,
                      s,
                      x,
                      c,
                      d,
                      l,
                      u,
                      h,
                      p,
                      b = new m();
                    for (b.id = e.getAttribute("id") || null, b.sequence = e.getAttribute("sequence") || null, a = 0, x = (u = e.childNodes).length; a < x; a++) switch ((l = u[a]).nodeName) {
                      case "Error":
                        b.errorURLTemplates.push(this.parseNodeText(l));
                        break;
                      case "Impression":
                        b.impressionURLTemplates.push(this.parseNodeText(l));
                        break;
                      case "Creatives":
                        for (n = 0, c = (h = this.childsByName(l, "Creative")).length; n < c; n++) for (i = {
                          id: (r = h[n]).getAttribute("id") || null,
                          adId: this.parseCreativeAdIdAttribute(r),
                          sequence: r.getAttribute("sequence") || null,
                          apiFramework: r.getAttribute("apiFramework") || null
                        }, s = 0, d = (p = r.childNodes).length; s < d; s++) switch ((o = p[s]).nodeName) {
                          case "Linear":
                            (t = this.parseCreativeLinearElement(o, i)) && b.creatives.push(t);
                            break;
                          case "NonLinearAds":
                            (t = this.parseNonLinear(o, i)) && b.creatives.push(t);
                            break;
                          case "CompanionAds":
                            (t = this.parseCompanionAd(o, i)) && b.creatives.push(t);
                        }
                        break;
                      case "Extensions":
                        this.parseExtension(b.extensions, this.childsByName(l, "Extension"));
                        break;
                      case "AdSystem":
                        b.system = {
                          value: this.parseNodeText(l),
                          version: l.getAttribute("version") || null
                        };
                        break;
                      case "AdTitle":
                        b.title = this.parseNodeText(l);
                        break;
                      case "Description":
                        b.description = this.parseNodeText(l);
                        break;
                      case "Advertiser":
                        b.advertiser = this.parseNodeText(l);
                        break;
                      case "Pricing":
                        b.pricing = {
                          value: this.parseNodeText(l),
                          model: l.getAttribute("model") || null,
                          currency: l.getAttribute("currency") || null
                        };
                        break;
                      case "Survey":
                        b.survey = this.parseNodeText(l);
                    }
                    return b;
                  },
                  parseExtension: function parseExtension(e, t) {
                    for (var i, r, o, a, n, s, x, c, d, l, u, h, p, b, m, g, v = [], f = 0, y = t.length; f < y; f++) {
                      if (n = t[f], r = new _(), n.attributes) for (x = 0, l = (p = n.attributes).length; x < l; x++) s = p[x], r.attributes[s.nodeName] = s.nodeValue;
                      for (c = 0, u = (b = n.childNodes).length; c < u; c++) if (i = b[c], g = this.parseNodeText(i), "#comment" !== i.nodeName && "" !== g) {
                        if ((o = new E()).name = i.nodeName, o.value = g, i.attributes) for (d = 0, h = (m = i.attributes).length; d < h; d++) a = m[d], o.attributes[a.nodeName] = a.nodeValue;
                        r.children.push(o);
                      }
                      v.push(e.push(r));
                    }
                    return v;
                  },
                  parseCreativeLinearElement: function parseCreativeLinearElement(e, t) {
                    var i,
                      r,
                      o,
                      a,
                      n,
                      s,
                      x,
                      c,
                      d,
                      l,
                      u,
                      h,
                      p,
                      b,
                      m,
                      g,
                      v,
                      f,
                      y,
                      _,
                      E,
                      k,
                      w,
                      C,
                      j,
                      B,
                      F,
                      A,
                      D,
                      S,
                      z,
                      T,
                      P,
                      R,
                      M,
                      I,
                      V,
                      U,
                      L,
                      O,
                      q,
                      N,
                      H,
                      W,
                      K,
                      G,
                      Y,
                      Z,
                      X,
                      J,
                      Q,
                      $,
                      ee,
                      te,
                      ie,
                      re,
                      oe,
                      ae,
                      ne = new se(t);
                    if (ne.duration = this.parseDuration(this.parseNodeText(this.childByName(e, "Duration"))), -1 === ne.duration && "Wrapper" !== e.parentNode.parentNode.parentNode.nodeName) return null;
                    if (null === (ee = e.getAttribute("skipoffset")) ? ne.skipDelay = null : "%" === ee.charAt(ee.length - 1) ? (V = parseInt(ee, 10), ne.skipDelay = ne.duration * (V / 100)) : ne.skipDelay = this.parseDuration(ee), ae = this.childByName(e, "VideoClicks")) {
                      for (ne.videoClickThroughURLTemplate = this.parseNodeText(this.childByName(ae, "ClickThrough")), x = 0, v = (O = this.childsByName(ae, "ClickTracking")).length; x < v; x++) o = O[x], ne.videoClickTrackingURLTemplates.push(this.parseNodeText(o));
                      for (b = 0, f = (q = this.childsByName(ae, "CustomClick")).length; b < f; b++) a = q[b], ne.videoCustomClickURLTemplates.push(this.parseNodeText(a));
                    }
                    for ((i = this.childByName(e, "AdParameters")) && (ne.adParameters = this.parseNodeText(i)), m = 0, _ = (H = this.childsByName(e, "TrackingEvents")).length; m < _; m++) for (re = H[m], g = 0, E = (W = this.childsByName(re, "Tracking")).length; g < E; g++) if (n = (ie = W[g]).getAttribute("event"), oe = this.parseNodeText(ie), n && oe) {
                      if ("progress" === n) {
                        if (!(M = ie.getAttribute("offset"))) continue;
                        n = "%" === M.charAt(M.length - 1) ? "progress-" + M : "progress-" + Math.round(this.parseDuration(M));
                      }
                      null === (r = ne.trackingEvents)[n] && (r[n] = []), ne.trackingEvents[n] && ne.trackingEvents[n].push(oe);
                    }
                    for (A = 0, k = (K = this.childsByName(e, "MediaFiles")).length; A < k; A++) for (T = K[A], P = 0, w = (G = this.childsByName(T, "MediaFile")).length; P < w; P++) z = G[P], (S = new xe()).id = z.getAttribute("id"), S.fileURL = this.parseNodeText(z), S.deliveryType = z.getAttribute("delivery"), S.codec = z.getAttribute("codec"), S.mimeType = z.getAttribute("type"), S.apiFramework = z.getAttribute("apiFramework"), S.bitrate = parseInt(z.getAttribute("bitrate") || 0, 10), S.minBitrate = parseInt(z.getAttribute("minBitrate") || 0, 10), S.maxBitrate = parseInt(z.getAttribute("maxBitrate") || 0, 10), S.width = parseInt(z.getAttribute("width") || 0, 10), S.height = parseInt(z.getAttribute("height") || 0, 10), ($ = z.getAttribute("scalable")) && "string" == typeof $ && ("true" === ($ = $.toLowerCase()) ? S.scalable = !0 : "false" === $ && (S.scalable = !1)), (D = z.getAttribute("maintainAspectRatio")) && "string" == typeof D && ("true" === (D = D.toLowerCase()) ? S.maintainAspectRatio = !0 : "false" === D && (S.maintainAspectRatio = !1)), ne.mediaFiles.push(S);
                    if (h = this.childByName(e, "Icons")) for (R = 0, C = (Y = this.childsByName(h, "Icon")).length; R < C; R++) {
                      for (u = Y[R], (c = new VASTIcon()).program = u.getAttribute("program"), c.height = parseInt(u.getAttribute("height") || 0, 10), c.width = parseInt(u.getAttribute("width") || 0, 10), c.xPosition = this.parseXPosition(u.getAttribute("xPosition")), c.yPosition = this.parseYPosition(u.getAttribute("yPosition")), c.apiFramework = u.getAttribute("apiFramework"), c.offset = this.parseDuration(u.getAttribute("offset")), c.duration = this.parseDuration(u.getAttribute("duration")), I = 0, j = (Z = this.childsByName(u, "HTMLResource")).length; I < j; I++) s = Z[I], c.type = s.getAttribute("creativeType") || "text/html", c.htmlResource = this.parseNodeText(s);
                      for (U = 0, B = (X = this.childsByName(u, "IFrameResource")).length; U < B; U++) p = X[U], c.type = p.getAttribute("creativeType") || 0, c.iframeResource = this.parseNodeText(p);
                      for (L = 0, F = (J = this.childsByName(u, "StaticResource")).length; L < F; L++) te = J[L], c.type = te.getAttribute("creativeType") || 0, c.staticResource = this.parseNodeText(te);
                      if (l = this.childByName(u, "IconClicks")) for (c.iconClickThroughURLTemplate = this.parseNodeText(this.childByName(l, "IconClickThrough")), Q = 0, y = (N = this.childsByName(l, "IconClickTracking")).length; Q < y; Q++) d = N[Q], c.iconClickTrackingURLTemplates.push(this.parseNodeText(d));
                      c.iconViewTrackingURLTemplate = this.parseNodeText(this.childByName(u, "IconViewTracking")), ne.icons.push(c);
                    }
                    return ne;
                  },
                  parseNonLinear: function parseNonLinear(e, t) {
                    for (var i, r, o, a, n, s, x, c, d, l, u, h, p, b, m, g, v, f, y, _, E, k, w, C, j, B, F, A, D, S, z = new M(t), T = this.childsByName(e, "TrackingEvents"), P = 0, R = T.length; P < R; P++) for (D = T[P], x = 0, l = (E = this.childsByName(D, "Tracking")).length; x < l; x++) a = (A = E[x]).getAttribute("event"), S = this.parseNodeText(A), a && S && (null === (r = z.trackingEvents)[a] && (r[a] = []), z.trackingEvents[a] && null !== S && z.trackingEvents[a].push(S));
                    for (c = 0, u = (k = this.childsByName(e, "NonLinear")).length; c < u; c++) {
                      for (y = k[c], (f = new I()).id = y.getAttribute("id") || null, f.width = y.getAttribute("width"), f.height = y.getAttribute("height"), f.expandedWidth = y.getAttribute("expandedWidth"), f.expandedHeight = y.getAttribute("expandedHeight"), f.scalable = this.parseBoolean(y.getAttribute("scalable")), f.maintainAspectRatio = this.parseBoolean(y.getAttribute("maintainAspectRatio")), f.minSuggestedDuration = this.parseDuration(y.getAttribute("minSuggestedDuration")), f.apiFramework = y.getAttribute("apiFramework"), d = 0, h = (w = this.childsByName(y, "HTMLResource")).length; d < h; d++) n = w[d], f.type = n.getAttribute("creativeType") || "text/html", f.htmlResource = this.parseNodeText(n);
                      for (g = 0, p = (C = this.childsByName(y, "IFrameResource")).length; g < p; g++) s = C[g], f.type = s.getAttribute("creativeType") || 0, f.iframeResource = this.parseNodeText(s);
                      for (v = 0, b = (j = this.childsByName(y, "StaticResource")).length; v < b; v++) F = j[v], f.type = F.getAttribute("creativeType") || 0, f.staticResource = this.parseNodeText(F);
                      for ((i = this.childByName(y, "AdParameters")) && (f.adParameters = this.parseNodeText(i)), f.nonlinearClickThroughURLTemplate = this.parseNodeText(this.childByName(y, "NonLinearClickThrough")), _ = 0, m = (B = this.childsByName(y, "NonLinearClickTracking")).length; _ < m; _++) o = B[_], f.nonlinearClickTrackingURLTemplates.push(this.parseNodeText(o));
                      z.variations.push(f);
                    }
                    return z;
                  },
                  parseCompanionAd: function parseCompanionAd(e, t) {
                    for (var i, r, o, a, n, s, x, c, d, l, u, h, p, b, m, g, v, f, y, _, E, k, w, C, j, B, F, A, D, S, z, T, P, R = new U(t), M = this.childsByName(e, "Companion"), I = 0, V = M.length; I < V; I++) {
                      for (n = M[I], (a = new L()).id = n.getAttribute("id") || null, a.width = n.getAttribute("width"), a.height = n.getAttribute("height"), a.companionClickTrackingURLTemplates = [], d = 0, h = (w = this.childsByName(n, "HTMLResource")).length; d < h; d++) x = w[d], a.type = x.getAttribute("creativeType") || "text/html", a.htmlResource = this.parseNodeText(x);
                      for (l = 0, p = (C = this.childsByName(n, "IFrameResource")).length; l < p; l++) c = C[l], a.type = c.getAttribute("creativeType") || 0, a.iframeResource = this.parseNodeText(c);
                      for (u = 0, b = (j = this.childsByName(n, "StaticResource")).length; u < b; u++) {
                        for (S = j[u], a.type = S.getAttribute("creativeType") || 0, y = 0, m = (B = this.childsByName(n, "AltText")).length; y < m; y++) r = B[y], a.altText = this.parseNodeText(r);
                        a.staticResource = this.parseNodeText(S);
                      }
                      for (_ = 0, g = (F = this.childsByName(n, "TrackingEvents")).length; _ < g; _++) for (T = F[_], E = 0, v = (A = this.childsByName(T, "Tracking")).length; E < v; E++) s = (z = A[E]).getAttribute("event"), P = this.parseNodeText(z), s && P && (null === (i = a.trackingEvents)[s] && (i[s] = []), a.trackingEvents[s].push(P));
                      for (k = 0, f = (D = this.childsByName(n, "CompanionClickTracking")).length; k < f; k++) o = D[k], a.companionClickTrackingURLTemplates.push(this.parseNodeText(o));
                      a.companionClickThroughURLTemplate = this.parseNodeText(this.childByName(n, "CompanionClickThrough")), a.companionClickTrackingURLTemplate = this.parseNodeText(this.childByName(n, "CompanionClickTracking")), R.variations.push(a);
                    }
                    return R;
                  },
                  parseDuration: function parseDuration(e) {
                    var t, i, r, o, a;
                    return e ? m.isNumeric(e) ? parseInt(e, 10) : 3 !== (t = e.split(":")).length ? -1 : (a = t[2].split("."), o = parseInt(a[0], 10), 2 === a.length && (o += parseFloat("0." + a[1])), r = parseInt(60 * t[1], 10), i = parseInt(60 * t[0] * 60, 10), isNaN(i) || isNaN(r) || isNaN(o) || 3600 < r || 60 < o ? -1 : i + r + o) : -1;
                  },
                  parseXPosition: function parseXPosition(e) {
                    return "left" === e || "right" === e ? e : parseInt(e || 0, 10);
                  },
                  parseYPosition: function parseYPosition(e) {
                    return "top" === e || "bottom" === e ? e : parseInt(e || 0, 10);
                  },
                  parseBoolean: function parseBoolean(e) {
                    return "true" === e || "TRUE" === e || "1" === e;
                  },
                  parseNodeText: function parseNodeText(e) {
                    return e && (e.textContent || e.text || "").trim();
                  },
                  copyNodeAttribute: function copyNodeAttribute(e, t, i) {
                    var r = t.getAttribute(e);
                    if (r) return i.setAttribute(e, r);
                  },
                  parseCreativeAdIdAttribute: function parseCreativeAdIdAttribute(e) {
                    return e.getAttribute("AdID") || e.getAttribute("adID") || e.getAttribute("adId") || null;
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.Client", ["module:Ads.VAST.Ad", "module:Ads.VAST.Parser", "base:Objs"], function (r, n, s, e) {
              return r.extend({
                scoped: e
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    var i;
                    t.constructor.call(this), this.cappingFreeLunch = 0, this.cappingMinimumTimeInterval = 6e4, this.lastSuccessfullAd = +new Date(), this.options = {
                      withCredentials: !1,
                      timeout: 1e3
                    }, i = Object.defineProperty, s.iter(["lastSuccessfullAd", "totalCalls", "totalCallsTimeout"], function (t) {
                      i(this, t, {
                        get: function get() {
                          return r.storage.getItem(t);
                        },
                        set: function set(e) {
                          return r.storage.setItem(t, e);
                        },
                        configurable: !1,
                        enumerable: !0
                      });
                    }, this), null === this.lastSuccessfullAd && (this.lastSuccessfullAd = 0), null === this.totalCalls && (this.totalCalls = 0), null === this.totalCallsTimeout && (this.totalCallsTimeout = 0);
                  },
                  getAd: function getAd(e, t, i) {
                    var r,
                      o = +new Date();
                    i || "function" == typeof t && (i = t), r = s.extend(this.options, t);
                    var a = new n();
                    if (this.totalCallsTimeout < o ? (this.totalCalls = 1, this.totalCallsTimeout = 36e5 + o) : this.totalCalls++, !(this.cappingFreeLunch >= this.totalCalls)) {
                      if (o - this.lastSuccessfullAd < 0) this.lastSuccessfullAd = 0;else if (o - this.lastSuccessfullAd < this.cappingMinimumTimeInterval) return void i(new Error("VAST call cancelled - (" + this.cappingMinimumTimeInterval + ")ms minimum interval reached"), null);
                      return a.parse(e, r, function (e, t) {
                        if (!e) return i(null, t);
                        i(e, null);
                      });
                    }
                    i(new Error("VAST call canceled - FreeLunch capping not reached yet " + this.totalCalls), null);
                  }
                };
              });
            }), Scoped.define("module:Ads.VAST.Tracker", ["module:Ads.VAST.Ad", "module:Ads.VAST.CreativeLinear", "module:Ads.VAST.NonLinear", "module:Ads.VAST.CompanionAd", "module:Ads.VAST.Client", "base:Events.ListenMixin"], function (r, s, x, c, d, e, t) {
              return r.extend({
                scoped: t
              }, [e, function (n) {
                return {
                  constructor: function constructor(e, t, i) {
                    var r, o, a;
                    for (r in n.constructor.call(this, e, t, i), this.ad = e, this.creative = t, this.variation = i || null, this.muted = !1, this.impressed = !1, this.skipable = !1, this.skipDelayDefault = -1, this.emitAlwaysEvents = ["creativeView", "start", "firstQuartile", "midpoint", "thirdQuartile", "complete", "rewind", "skip", "closeLinear", "close"], a = t ? t.trackingEvents : {}) (o = a[r]) && (this.trackingEvents[r] = o.slice(0));
                    t instanceof s ? (this.setAdDuration(this.creative.duration), this.skipDelay = t.skipDelay, this.linear = !0, this.clickThroughURLTemplate = t.videoClickThroughURLTemplate, this.clickTrackingURLTemplate = t.videoClickTrackingURLTemplate) : (this.skipDelay = -1, this.linear = !1, this.variation && (this.variation instanceof x ? (this.clickThroughURLTemplate = this.variation.nonlinearClickThroughURLTemplate, this.clickTrackingURLTemplates = this.variation.nonlinearClickTrackingURLTemplates) : this.variation instanceof c && (this.clickThroughURLTemplate = this.variation.companionClickThroughURLTemplate, this.clickTrackingURLTemplates = this.variation.companionClickTrackingURLTemplates))), this.on("adstart", function () {
                      d.lastSuccessfullAd = +new Date();
                    });
                  },
                  setAdDuration: function setAdDuration(e) {
                    return this.assetDuration = e, this.quartiles = {
                      firstQuartile: Math.round(25 * this.assetDuration) / 100,
                      midpoint: Math.round(50 * this.assetDuration) / 100,
                      thirdQuartile: Math.round(75 * this.assetDuration) / 100
                    }, this.quartiles;
                  },
                  setAdProgress: function setAdProgress(e) {
                    var t,
                      i,
                      r,
                      o,
                      a,
                      n,
                      s,
                      x,
                      c = null === this.skipDelay ? this.skipDelayDefault : this.skipDelay;
                    if (-1 === c || this.skipable || (e < c ? this.trigger("adskip-countdown", c - e) : (this.skipable = !0, this.trigger("adskip-countdown", 0))), this.linear && 0 < this.assetDuration) {
                      if (i = [], 0 < e) for (n in i.push("start"), a = Math.round(e / this.assetDuration * 100), i.push("progress-" + a + "%"), i.push("progress-" + Math.round(e)), s = this.quartiles) (x = s[n]) <= e && e <= x + 1 && i.push(n);
                      for (r = 0, o = i.length; r < o; r++) null !== (t = i[r]) && this.track(t, !0);
                      e < this.progress && this.track("rewind");
                    }
                    return this.progress = e;
                  },
                  setAdMuted: function setAdMuted(e) {
                    return this.muted !== e && this.track(e ? "mute" : "unmute"), this.muted = e;
                  },
                  setAdPaused: function setAdPaused(e) {
                    return this.paused !== e && this.track(e ? "pause" : "resume"), this.paused = e;
                  },
                  setAdFullscreen: function setAdFullscreen(e) {
                    return this.fullscreen !== e && this.track(e ? "fullscreen" : "exitFullscreen"), this.fullscreen = e;
                  },
                  setAdExpand: function setAdExpand(e) {
                    return this.expanded !== e && this.track(e ? "expand" : "collapse"), this.expanded = e;
                  },
                  setAdSkipDelay: function setAdSkipDelay(e) {
                    if ("number" == typeof e) return this.skipDelay = e;
                  },
                  loadAd: function loadAd() {
                    if (!this.impressed) return this.impressed = !0, this.trackAdURLs(this.ad.impressionURLTemplates), this.track("creativeView");
                  },
                  errorAdWithCode: function errorAdWithCode(e) {
                    return this.trackAdURLs(this.ad.errorURLTemplates, {
                      ERRORCODE: e
                    });
                  },
                  errorAdWithCodeAndMessage: function errorAdWithCodeAndMessage(e, t) {
                    return this.trackAdURLs(this.ad.errorURLTemplates, {
                      ERRORCODE: e,
                      ERRORMESSAGE: t
                    });
                  },
                  completeAd: function completeAd() {
                    return this.track("complete");
                  },
                  closeAd: function closeAd() {
                    return this.track(this.linear ? "closeLinear" : "close");
                  },
                  stopAd: function stopAd() {},
                  skipAd: function skipAd() {
                    return this.track("skip"), this.trackingEvents = [], this.trackingEvents;
                  },
                  clickAd: function clickAd() {
                    var e, t, i;
                    if (null !== (t = this.clickTrackingURLTemplates) && t.length && this.trackAdURLs(this.clickTrackingURLTemplates), null !== this.clickThroughURLTemplate) return this.linear && (i = {
                      CONTENTPLAYHEAD: this.adProgressFormated()
                    }), e = r.resolveURLTemplates([this.clickThroughURLTemplate], i)[0], this.trigger("clickthrough", e);
                  },
                  track: function track(e, t) {
                    var i, r;
                    t = t || !1, "closeLinear" === e && !this.trackingEvents[e] && this.trackingEvents.close && (e = "close"), r = this.trackingEvents[e], i = this.emitAlwaysEvents.indexOf(e), r ? (this.trigger(e, ""), this.trackAdURLs(r)) : -1 !== i && this.trigger(e, ""), !0 === t && (delete this.trackingEvents[e], delete this.trackingEvents[e], -1 < i && this.emitAlwaysEvents.splice(i, 1));
                  },
                  trackAdURLs: function trackAdURLs(e, t) {
                    var i;
                    return t = t || {}, this.linear && (null !== (null !== (i = this.creative.mediaFiles[0]) ? i.fileURL : void 0) && (t.ASSETURI = this.creative.mediaFiles[0].fileURL), t.CONTENTPLAYHEAD = this.adProgressFormated()), r.trackAd(e, t);
                  },
                  adProgressFormated: function adProgressFormated() {
                    var e,
                      t,
                      i = parseInt(this.progress, 10),
                      r = i / 3600;
                    return r.length < 2 && (r = "0" + r), (e = i / 60 % 60).length < 2 && (e = "0" + e), (t = i % 60).length < 2 && (t = "0" + e), r + ":" + e + ":" + t + "." + parseInt(100 * (this.progress - i), 10);
                  }
                };
              }]);
            }), Scoped.define("module:Ads.VAST.VAST", ["base:Class", "module:Ads.VAST.Client", "module:Ads.VAST.Tracker", "module:Ads.VAST.Ad", "base:Objs", "base:Promise", "base:Events.EventsMixin", "base:Types"], function (e, n, s, x, c, d, t, l, i) {
              return e.extend({
                scoped: i
              }, [t, function (a) {
                return {
                  constructor: function constructor(e, t) {
                    var i, r, o;
                    a.constructor.call(this), e = l.is_array(e) ? e : [e], this.vastServerResponses = [], this.timeout = 5e3, this.adPodTimeout = 100, this.companion = undefined, this.sources = [], this.companion = {}, o = this, r = d.create(), i = this.auto_destroy(new n(e)), c.iter(e, function (e) {
                      e.adServer ? (e.skipAfter && (o.skipAdAfter = e.skipAfter), i.getAd(e.adServer, t, function (e, t) {
                        var i;
                        e ? (i = "Error occurred during loading provided link. " + e, r.asyncError({
                          message: i
                        })) : (o.vastServerResponses.push(t), r.asyncSuccess(o.vastServerResponses));
                      })) : r.asyncError({
                        message: "Video Ad options are not correct, asServer are required"
                      });
                    }, this), r.success(function (e) {
                      this.executeAd(e[0]);
                    }, this), r.error(function (e) {
                      this.trigger("adresponseerror", e);
                    }, this);
                  },
                  executeAd: function executeAd(e) {
                    var t, i, r, o, a, n;
                    if (e) for (i = 0; i < e.ads.length; i++) {
                      for (t = e.ads[i], r = 0; r < t.creatives.length; r++) {
                        if (n = a = !1, "linear" === (o = t.creatives[r]).type && !a && (0 < o.skipDelay && (this.skipAdAfter = o.skipDelay), o.mediaFiles.length)) {
                          if (this.sources = this.createSourceObjects(o.mediaFiles), !this.sources.length) return void this.trigger("adcanceled");
                          this.vastTracker = new s(t, o), a = !0;
                        }
                        "companion" !== o.type || n || (this.companion = o, n = !0);
                      }
                      if (this.vastTracker) {
                        this.persistentTrigger("vastready");
                        break;
                      }
                      x.trackAd(t.errorURLTemplates, {
                        ERRORCODE: 403
                      });
                    }
                    this.vastTracker || this.persistentTrigger("adcanceled");
                  },
                  createSourceObjects: function createSourceObjects(e) {
                    for (var t, i, r = [], o = 0, a = e.length; o < a; o++) i = {
                      type: (t = e[o]).mimeType,
                      src: t.fileURL
                    }, this._canPlaySource(i) && (r[o] = {
                      type: t.mimeType,
                      src: t.fileURL,
                      width: t.width,
                      height: t.height
                    });
                    return r;
                  },
                  _canPlaySource: function _canPlaySource(e) {
                    var t,
                      i = ["application/vnd.apple.mpegurl", "video/3gpp", "video/mp4", "video/mpeg", "video/ogg", "video/quicktime", "video/webm", "video/x-m4v", "video/ms-asf", "video/x-ms-wmv", "video/x-msvideo"];
                    if (e.type) t = e.type;else {
                      if (!e.src) return !1;
                      t = "video/" + this._ext(e.src);
                    }
                    return c.contains_value(i, t);
                  },
                  _ext: function _ext(e) {
                    return (e = e.substr(1 + e.lastIndexOf("/")).split("?")[0]).split("#")[0].substr(e.lastIndexOf("."));
                  }
                };
              }]);
            }), Scoped.define("module:Ads.VastPrerollAd", ["module:Ads.AbstractPrerollAd", "module:Ads.VAST.VAST"], function (e, r, t) {
              return e.extend({
                scoped: t
              }, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    i.constructor.call(this, e, t), this._vast = new r(this._provider.options(), {}), this._vast.once("adresponseerror", function (e) {}, this);
                  },
                  _executeAd: function _executeAd(e) {
                    this._adplayer = new BetaJS.MediaComponents.VideoPlayer.Dynamics.Adplayer({
                      element: this._options.adElement,
                      attrs: {
                        css: this._options.dynamic.get("css")
                      }
                    }), this._adplayer._vast = this._vast, (this._adplayer._preroll = this)._adplayer.activate();
                  },
                  _adFinished: function _adFinished() {
                    this._options.adElement.style.display = "none", this.trigger("finished");
                  },
                  _adSkipped: function _adSkipped() {
                    this._options.adElement.style.display = "none", this.trigger("adskipped");
                  }
                };
              });
            }), Scoped.define("module:Ads.VastVideoAdProvider", ["module:Ads.AbstractVideoAdProvider", "module:Ads.VastPrerollAd"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, {
                _newPrerollAd: function _newPrerollAd(e) {
                  return new t(this, e);
                }
              });
            }), Scoped.define("module:Assets", ["base:Classes.LocaleTable", "browser:Info"], function (e, t) {
              var i = new e();
              return i.setWeakLocale(t.language()), {
                strings: i,
                playerthemes: {},
                recorderthemes: {},
                imageviewerthemes: {},
                imagecapturethemes: {},
                audioplayerthemes: {},
                audiorecorderthemes: {}
              };
            }), Scoped.extend("module:Assets", ["module:Assets"], function (e) {
              var t = {
                "language:ar": {
                  "ba-videoplayer-playbutton.tooltip": "&#x627;&#x646;&#x642;&#x631; &#x644;&#x62A;&#x634;&#x63A;&#x64A;&#x644; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648;.",
                  "ba-videoplayer-playbutton.rerecord": "&#x627;&#x639;&#x62F; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;",
                  "ba-videoplayer-playbutton.submit-video": "&#x62A;&#x623;&#x643;&#x64A;&#x62F; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648;",
                  "ba-videoplayer-loader.tooltip": "&#x62C;&#x627;&#x631; &#x62A;&#x62D;&#x645;&#x64A;&#x644; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; ...",
                  "ba-videoplayer-controlbar.change-resolution": "&#x62A;&#x63A;&#x64A;&#x64A;&#x631; &#x627;&#x644;&#x62F;&#x642;&#x629;",
                  "ba-videoplayer-controlbar.video-progress": "&#x62A;&#x642;&#x62F;&#x645; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648;",
                  "ba-videoplayer-controlbar.rerecord-video": "&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648;&#x61F;",
                  "ba-videoplayer-controlbar.submit-video": "&#x62A;&#x623;&#x643;&#x64A;&#x62F; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648;",
                  "ba-videoplayer-controlbar.play-video": "&#x634;&#x63A;&#x644; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648;",
                  "ba-videoplayer-controlbar.pause-video": "&#x625;&#x64A;&#x642;&#x627;&#x641; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x645;&#x624;&#x642;&#x62A;&#x627;",
                  "ba-videoplayer-controlbar.elapsed-time": "&#x627;&#x644;&#x648;&#x642;&#x62A; &#x627;&#x644;&#x645;&#x646;&#x642;&#x636;&#x64A;",
                  "ba-videoplayer-controlbar.total-time": "&#x637;&#x648;&#x644; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x627;&#x644;&#x643;&#x644;&#x64A;",
                  "ba-videoplayer-controlbar.fullscreen-video": "&#x639;&#x631;&#x636; &#x645;&#x644;&#x621; &#x627;&#x644;&#x634;&#x627;&#x634;&#x629;",
                  "ba-videoplayer-controlbar.volume-button": "&#x62A;&#x639;&#x64A;&#x64A;&#x646; &#x645;&#x633;&#x62A;&#x648;&#x649; &#x627;&#x644;&#x635;&#x648;&#x62A;",
                  "ba-videoplayer-controlbar.volume-mute": "&#x643;&#x62A;&#x645; &#x627;&#x644;&#x635;&#x648;&#x62A;",
                  "ba-videoplayer-controlbar.volume-unmute": "&#x625;&#x644;&#x63A;&#x627;&#x621; &#x643;&#x62A;&#x645; &#x627;&#x644;&#x635;&#x648;&#x62A;",
                  "ba-videoplayer.video-error": "&#x644;&#x642;&#x62F; &#x62D;&#x62F;&#x62B; &#x62E;&#x637;&#x623;&#x60C; &#x631;&#x62C;&#x627;&#x621; &#x623;&#x639;&#x62F; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629; &#x644;&#x627;&#x62D;&#x642;&#x627;. &#x627;&#x646;&#x642;&#x631; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-videorecorder-chooser.record-video": "&#x62A;&#x633;&#x62C;&#x64A;&#x644; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648;",
                  "ba-videorecorder-chooser.upload-video": "&#x631;&#x641;&#x639; &#x641;&#x64A;&#x62F;&#x64A;&#x648;",
                  "ba-videorecorder-controlbar.settings": "&#x625;&#x639;&#x62F;&#x627;&#x62F;&#x627;&#x62A;",
                  "ba-videorecorder-controlbar.camerahealthy": "&#x627;&#x644;&#x625;&#x636;&#x627;&#x621;&#x629; &#x62C;&#x64A;&#x62F;&#x629;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "&#x627;&#x644;&#x625;&#x636;&#x627;&#x621;&#x629; &#x644;&#x64A;&#x633;&#x62A; &#x627;&#x644;&#x623;&#x645;&#x62B;&#x644;",
                  "ba-videorecorder-controlbar.microphonehealthy": "&#x627;&#x644;&#x635;&#x648;&#x62A; &#x62C;&#x64A;&#x62F;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "&#x644;&#x627; &#x64A;&#x645;&#x643;&#x646; &#x627;&#x644;&#x62A;&#x642;&#x627;&#x637; &#x623;&#x64A; &#x635;&#x648;&#x62A;",
                  "ba-videorecorder-controlbar.record": "&#x633;&#x62C;&#x644;",
                  "ba-videorecorder-controlbar.record-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x644;&#x62A;&#x633;&#x62C;&#x64A;&#x644;.",
                  "ba-videorecorder-controlbar.rerecord": "&#x627;&#x639;&#x62F; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x644;&#x625;&#x639;&#x627;&#x62F;&#x629;.",
                  "ba-videorecorder-controlbar.upload-covershot": "&#x631;&#x641;&#x639; &#x635;&#x648;&#x631;&#x629; &#x627;&#x644;&#x648;&#x627;&#x62C;&#x647;&#x629;.",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x62A;&#x62D;&#x645;&#x64A;&#x644; &#x644;&#x642;&#x637;&#x629; &#x645;&#x62E;&#x635;&#x635;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-videorecorder-controlbar.stop": "&#x62A;&#x648;&#x642;&#x641;",
                  "ba-videorecorder-controlbar.stop-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x644;&#x62A;&#x648;&#x642;&#x641;.",
                  "ba-videorecorder-controlbar.skip": "&#x62A;&#x62E;&#x637;&#x649;",
                  "ba-videorecorder-controlbar.skip-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x644;&#x62A;&#x62E;&#x637;&#x64A;.",
                  "ba-videorecorder.recorder-error": "&#x644;&#x642;&#x62F; &#x62D;&#x62F;&#x62B; &#x62E;&#x637;&#x623;&#x60C; &#x631;&#x62C;&#x627;&#x621; &#x623;&#x639;&#x62F; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629; &#x644;&#x627;&#x62D;&#x642;&#x627;. &#x627;&#x646;&#x642;&#x631; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-videorecorder.attach-error": "&#x644;&#x645; &#x646;&#x62A;&#x645;&#x643;&#x646; &#x645;&#x646; &#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x648;&#x627;&#x62C;&#x647;&#x629; &#x627;&#x644;&#x643;&#x627;&#x645;&#x64A;&#x631;&#x627;. &#x627;&#x639;&#x62A;&#x645;&#x627;&#x62F;&#x627; &#x639;&#x644;&#x649; &#x627;&#x644;&#x62C;&#x647;&#x627;&#x632; &#x648;&#x627;&#x644;&#x645;&#x62A;&#x635;&#x641;&#x62D;&#x60C; &#x642;&#x62F; &#x62A;&#x62D;&#x62A;&#x627;&#x62C; &#x625;&#x644;&#x649; &#x62A;&#x62B;&#x628;&#x64A;&#x62A; &#x641;&#x644;&#x627;&#x634; &#x623;&#x648; &#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x627;&#x644;&#x635;&#x641;&#x62D;&#x629; &#x639;&#x628;&#x631; &#x645;&#x62A;&#x635;&#x641;&#x62D; &#x627;&#x62E;&#x631;.",
                  "ba-videorecorder.access-forbidden": "&#x62A;&#x645; &#x62D;&#x638;&#x631; &#x627;&#x644;&#x62F;&#x62E;&#x648;&#x644; &#x625;&#x644;&#x649; &#x627;&#x644;&#x643;&#x627;&#x645;&#x64A;&#x631;&#x627;. &#x627;&#x646;&#x642;&#x631; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;",
                  "ba-videorecorder.pick-covershot": "&#x627;&#x62E;&#x62A;&#x64A;&#x627;&#x631; &#x635;&#x648;&#x631;&#x629; &#x627;&#x644;&#x648;&#x627;&#x62C;&#x647;&#x629;.",
                  "ba-videorecorder.uploading": "&#x62C;&#x627;&#x631;&#x64A; &#x627;&#x644;&#x631;&#x641;&#x639;",
                  "ba-videorecorder.uploading-failed": "&#x641;&#x634;&#x644; &#x641;&#x64A; &#x627;&#x644;&#x631;&#x641;&#x639; - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-videorecorder.verifying": "&#x62C;&#x627;&#x631;&#x64A; &#x627;&#x644;&#x62A;&#x62D;&#x642;&#x642;",
                  "ba-videorecorder.verifying-failed": "&#x641;&#x634;&#x644; &#x639;&#x645;&#x644;&#x64A;&#x629; &#x627;&#x644;&#x62A;&#x62D;&#x642;&#x642; - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-videorecorder.rerecord-confirm": "&#x62A;&#x622;&#x643;&#x64A;&#x62F; &#x627;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648;&#x61F;",
                  "ba-videorecorder.video_file_too_large": "&#x645;&#x644;&#x641; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x643;&#x628;&#x64A;&#x631; &#x62C;&#x62F;&#x627; (%s) - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629; &#x628;&#x627;&#x633;&#x62A;&#x62E;&#x62F;&#x627;&#x645; &#x645;&#x644;&#x641; &#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x623;&#x635;&#x63A;&#x631;.",
                  "ba-videorecorder.unsupported_video_type": "&#x635;&#x64A;&#x63A;&#x629; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x63A;&#x64A;&#x631; &#x645;&#x62F;&#x639;&#x648;&#x645;&#x629; :%s - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "&#x627;&#x644;&#x62E;&#x631;&#x648;&#x62C; &#x645;&#x646; &#x627;&#x644;&#x634;&#x627;&#x634;&#x629; &#x627;&#x644;&#x643;&#x627;&#x645;&#x644;&#x629;",
                  "ba-videoplayer-share.share": "&#x634;&#x627;&#x631;&#x643; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648;",
                  "ba-videorecorder-chooser.record-screen": "&#x633;&#x62C;&#x644; &#x627;&#x644;&#x634;&#x627;&#x634;&#x629;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "&#x625;&#x64A;&#x642;&#x627;&#x641; &#x645;&#x624;&#x642;&#x62A; &#x63A;&#x64A;&#x631; &#x645;&#x62A;&#x648;&#x627;&#x641;&#x642;",
                  "ba-videorecorder-chooser.record-audio": "&#x62A;&#x633;&#x62C;&#x64A;&#x644; &#x635;&#x648;&#x62A;&#x64A;",
                  "ba-videorecorder-controlbar.stop-available-after": "&#x627;&#x644;&#x62D;&#x62F; &#x627;&#x644;&#x623;&#x62F;&#x646;&#x649; &#x644;&#x648;&#x642;&#x62A; &#x627;&#x644;&#x62A;&#x633;&#x62C;&#x64A;&#x644; &#x647;&#x648;%d &#x62B;&#x627;&#x646;&#x64A;&#x629;",
                  "ba-videorecorder-controlbar.cancel": "&#x625;&#x644;&#x63A;&#x627;&#x621;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x644;&#x625;&#x644;&#x63A;&#x627;&#x621;.",
                  "ba-videorecorder.cancel-confirm": "&#x647;&#x644; &#x62A;&#x631;&#x64A;&#x62F; &#x62D;&#x642;&#x627; &#x625;&#x644;&#x63A;&#x627;&#x621; &#x62A;&#x62D;&#x645;&#x64A;&#x644; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648;&#x61F;",
                  "ba-videoplayer-adslot.elapsed-time": "&#x648;&#x642;&#x62A; &#x625;&#x644;&#x627;&#x633;&#x628;&#x62F;",
                  "ba-videoplayer-adslot.volume-button": "&#x62A;&#x639;&#x64A;&#x64A;&#x646; &#x645;&#x633;&#x62A;&#x648;&#x649; &#x627;&#x644;&#x635;&#x648;&#x62A;",
                  "ba-videoplayer-adslot.volume-mute": "&#x635;&#x648;&#x62A; &#x645;&#x646;&#x62E;&#x641;&#x636;",
                  "ba-videoplayer-adslot.volume-unmute": "&#x625;&#x644;&#x63A;&#x627;&#x621; &#x635;&#x648;&#x62A; &#x627;&#x644;&#x635;&#x648;&#x62A;",
                  "ba-videoplayer-adslot.ad-will-end-after": "&#x633;&#x64A;&#x646;&#x62A;&#x647;&#x64A; &#x627;&#x644;&#x625;&#x639;&#x644;&#x627;&#x646; &#x628;&#x639;&#x62F;%s",
                  "ba-videoplayer-adslot.can-skip-after": "&#x62A;&#x62E;&#x637;&#x64A; &#x628;&#x639;&#x62F;%d",
                  "ba-videoplayer-adslot.skip-ad": "&#x62A;&#x62C;&#x627;&#x647;&#x644; &#x627;&#x644;&#x627;&#x639;&#x644;&#x627;&#x646;&#x627;&#x62A;",
                  "ba-videorecorder.software-required": "&#x64A;&#x631;&#x62C;&#x649; &#x627;&#x644;&#x646;&#x642;&#x631; &#x623;&#x62F;&#x646;&#x627;&#x647; &#x644;&#x62A;&#x62B;&#x628;&#x64A;&#x62A; / &#x62A;&#x641;&#x639;&#x64A;&#x644; &#x627;&#x644;&#x645;&#x62A;&#x637;&#x644;&#x628;&#x627;&#x62A; &#x627;&#x644;&#x62A;&#x627;&#x644;&#x64A;&#x629; &#x645;&#x646; &#x623;&#x62C;&#x644; &#x627;&#x644;&#x645;&#x636;&#x64A; &#x642;&#x62F;&#x645;&#x627;.",
                  "ba-videorecorder.software-waiting": "&#x641;&#x64A; &#x627;&#x646;&#x62A;&#x638;&#x627;&#x631; &#x627;&#x644;&#x645;&#x62A;&#x637;&#x644;&#x628;&#x627;&#x62A; &#x644;&#x64A;&#x62A;&#x645; &#x62A;&#x62B;&#x628;&#x64A;&#x62A;&#x647;&#x627; / &#x62A;&#x641;&#x639;&#x64A;&#x644;&#x647;&#x627;. &#x642;&#x62F; &#x62A;&#x62D;&#x62A;&#x627;&#x62C; &#x625;&#x644;&#x649; &#x62A;&#x62D;&#x62F;&#x64A;&#x62B; &#x627;&#x644;&#x635;&#x641;&#x62D;&#x629; &#x628;&#x639;&#x62F; &#x627;&#x644;&#x627;&#x646;&#x62A;&#x647;&#x627;&#x621;.",
                  "ba-videoplayer-controlbar.close-tracks": "&#x625;&#x63A;&#x644;&#x627;&#x642; CC",
                  "ba-videoplayer-controlbar.show-tracks": "&#x639;&#x631;&#x636; CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "&#x62A;&#x62D;&#x645;&#x64A;&#x644; &#x645;&#x644;&#x641;&#x627;&#x62A; &#x627;&#x644;&#x646;&#x635; &#x627;&#x644;&#x645;&#x633;&#x627;&#x631;",
                  "ba-videoplayer-tracks.select-text-track-language": "&#x644;&#x63A;&#x629; &#x627;&#x644;&#x62A;&#x631;&#x62C;&#x645;&#x629;",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x62D;&#x62F;&#x62F; &#x623;&#x648;&#x644;&#x627;&#x64B; &#x627;&#x644;&#x644;&#x63A;&#x629;",
                  "ba-videoplayer-tracks.select-text-track-file": "&#x627;&#x646;&#x642;&#x631; &#x644;&#x62A;&#x62D;&#x62F;&#x64A;&#x62F; &#x627;&#x644;&#x645;&#x644;&#x641;",
                  "ba-videoplayer-tracks.back": "&#x627;&#x644;&#x649; &#x627;&#x644;&#x62E;&#x644;&#x641;",
                  "ba-videorecorder.framerate-warning": "&#x645;&#x639;&#x62F;&#x644; &#x639;&#x631;&#x636; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x645;&#x646;&#x62E;&#x641;&#x636; &#x62C;&#x62F;&#x64B;&#x627;. &#x646;&#x648;&#x635;&#x64A; &#x628;&#x625;&#x63A;&#x644;&#x627;&#x642; &#x62C;&#x645;&#x64A;&#x639; &#x627;&#x644;&#x628;&#x631;&#x627;&#x645;&#x62C; &#x627;&#x644;&#x623;&#x62E;&#x631;&#x649; &#x648;&#x639;&#x644;&#x627;&#x645;&#x627;&#x62A; &#x62A;&#x628;&#x648;&#x64A;&#x628; &#x627;&#x644;&#x645;&#x62A;&#x635;&#x641;&#x62D; &#x623;&#x648; &#x627;&#x633;&#x62A;&#x62E;&#x62F;&#x627;&#x645; &#x62C;&#x647;&#x627;&#x632; &#x643;&#x645;&#x628;&#x64A;&#x648;&#x62A;&#x631; &#x623;&#x633;&#x631;&#x639;.",
                  "ba-videorecorder.upload-error-duration": "&#x644;&#x627; &#x64A;&#x62A;&#x648;&#x627;&#x641;&#x642; &#x637;&#x648;&#x644; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x627;&#x644;&#x630;&#x64A; &#x62A;&#x645; &#x62A;&#x62D;&#x645;&#x64A;&#x644;&#x647; &#x645;&#x639; &#x627;&#x644;&#x645;&#x62A;&#x637;&#x644;&#x628;&#x627;&#x62A; - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-videorecorder.resolution-constraint-error": "&#x627;&#x644;&#x645;&#x644;&#x641; &#x627;&#x644;&#x630;&#x64A; &#x62D;&#x62F;&#x62F;&#x62A;&#x647; &#x644;&#x627; &#x64A;&#x62A;&#x637;&#x627;&#x628;&#x642; &#x645;&#x639; &#x627;&#x644;&#x62F;&#x642;&#x629; &#x627;&#x644;&#x645;&#x637;&#x644;&#x648;&#x628;&#x629; - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-videorecorder.orientation-portrait-required": "&#x64A;&#x631;&#x62C;&#x649; &#x62A;&#x62F;&#x648;&#x64A;&#x631; &#x62C;&#x647;&#x627;&#x632;&#x643; &#x644;&#x644;&#x62A;&#x633;&#x62C;&#x64A;&#x644; &#x641;&#x64A; &#x627;&#x644;&#x648;&#x636;&#x639; &#x627;&#x644;&#x631;&#x623;&#x633;&#x64A;.",
                  "ba-videorecorder.orientation-landscape-required": "&#x64A;&#x631;&#x62C;&#x649; &#x62A;&#x62F;&#x648;&#x64A;&#x631; &#x62C;&#x647;&#x627;&#x632;&#x643; &#x644;&#x644;&#x62A;&#x633;&#x62C;&#x64A;&#x644; &#x641;&#x64A; &#x627;&#x644;&#x648;&#x636;&#x639; &#x627;&#x644;&#x623;&#x641;&#x642;&#x64A;.",
                  "ba-imageviewer-controlbar.rerecord-image": "&#x625;&#x639;&#x627;&#x62F;&#x629;&#x61F;",
                  "ba-imageviewer-controlbar.submit-image": "&#x62A;&#x624;&#x643;&#x62F;",
                  "ba-imageviewer-controlbar.fullscreen-image": "&#x623;&#x62F;&#x62E;&#x644; &#x645;&#x644;&#x621; &#x627;&#x644;&#x634;&#x627;&#x634;&#x629;",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "&#x627;&#x644;&#x62E;&#x631;&#x648;&#x62C; &#x645;&#x646; &#x627;&#x644;&#x634;&#x627;&#x634;&#x629; &#x627;&#x644;&#x643;&#x627;&#x645;&#x644;&#x629;",
                  "ba-imageviewer.image-error": "&#x644;&#x642;&#x62F; &#x62D;&#x62F;&#x62B; &#x62E;&#x637;&#x623;&#x60C; &#x631;&#x62C;&#x627;&#x621; &#x623;&#x639;&#x62F; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629; &#x644;&#x627;&#x62D;&#x642;&#x627;. &#x627;&#x646;&#x642;&#x631; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-imagecapture-chooser.image-capture": "&#x627;&#x644;&#x62A;&#x642;&#x627;&#x637; &#x627;&#x644;&#x635;&#x648;&#x631;&#x629;",
                  "ba-imagecapture-chooser.upload-image": "&#x62A;&#x62D;&#x645;&#x64A;&#x644; &#x627;&#x644;&#x635;&#x648;&#x631;",
                  "ba-imagecapture-controlbar.settings": "&#x625;&#x639;&#x62F;&#x627;&#x62F;&#x627;&#x62A;",
                  "ba-imagecapture-controlbar.camerahealthy": "&#x627;&#x644;&#x625;&#x636;&#x627;&#x621;&#x629; &#x62C;&#x64A;&#x62F;&#x629;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "&#x627;&#x644;&#x625;&#x636;&#x627;&#x621;&#x629; &#x644;&#x64A;&#x633;&#x62A; &#x627;&#x644;&#x623;&#x645;&#x62B;&#x644;",
                  "ba-imagecapture-controlbar.record": "&#x623;&#x633;&#x631;",
                  "ba-imagecapture-controlbar.record-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x627;&#x644;&#x62A;&#x642;&#x627;&#x637;.",
                  "ba-imagecapture-controlbar.rerecord": "&#x641;&#x639;&#x644; &#x62B;&#x627;&#x646;&#x64A;&#x629;",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x644;&#x625;&#x639;&#x627;&#x62F;&#x629;.",
                  "ba-imagecapture-controlbar.cancel": "&#x625;&#x644;&#x63A;&#x627;&#x621;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x644;&#x625;&#x644;&#x63A;&#x627;&#x621;.",
                  "ba-audioplayer-controlbar.audio-progress": "&#x62A;&#x642;&#x62F;&#x645;",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#x625;&#x639;&#x627;&#x62F;&#x629;&#x61F;",
                  "ba-audioplayer-controlbar.submit-audio": "&#x62A;&#x624;&#x643;&#x62F;",
                  "ba-audioplayer-controlbar.play-audio": "&#x644;&#x639;&#x628;",
                  "ba-audioplayer-controlbar.pause-audio": "&#x648;&#x642;&#x641;&#x629;",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "&#x648;&#x642;&#x641;&#x629; &#x63A;&#x64A;&#x631; &#x645;&#x639;&#x62A;&#x645;&#x62F;",
                  "ba-audioplayer-controlbar.elapsed-time": "&#x627;&#x644;&#x648;&#x642;&#x62A; &#x627;&#x644;&#x645;&#x646;&#x642;&#x636;&#x64A;",
                  "ba-audioplayer-controlbar.total-time": "&#x627;&#x644;&#x637;&#x648;&#x644; &#x627;&#x644;&#x643;&#x644;&#x64A;",
                  "ba-audioplayer-controlbar.volume-button": "&#x636;&#x628;&#x637; &#x627;&#x644;&#x62D;&#x62C;&#x645;",
                  "ba-audioplayer-controlbar.volume-mute": "&#x635;&#x648;&#x62A; &#x645;&#x646;&#x62E;&#x641;&#x636;",
                  "ba-audioplayer-controlbar.volume-unmute": "&#x635;&#x648;&#x62A; &#x63A;&#x64A;&#x631; &#x635;&#x648;&#x62A;&#x64A;",
                  "ba-audioplayer-loader.tooltip": "&#x62C;&#x627;&#x631; &#x627;&#x644;&#x62A;&#x62D;&#x645;&#x64A;&#x644;...",
                  "ba-audioplayer.audio-error": "&#x644;&#x642;&#x62F; &#x62D;&#x62F;&#x62B; &#x62E;&#x637;&#x623;&#x60C; &#x631;&#x62C;&#x627;&#x621; &#x623;&#x639;&#x62F; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629; &#x644;&#x627;&#x62D;&#x642;&#x627;. &#x627;&#x646;&#x642;&#x631; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-audiorecorder-chooser.record-audio": "&#x62A;&#x633;&#x62C;&#x64A;&#x644; &#x635;&#x648;&#x62A;&#x64A;",
                  "ba-audiorecorder-chooser.upload-audio": "&#x62A;&#x62D;&#x645;&#x64A;&#x644; &#x627;&#x644;&#x635;&#x648;&#x62A;",
                  "ba-audiorecorder-controlbar.settings": "&#x625;&#x639;&#x62F;&#x627;&#x62F;&#x627;&#x62A;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "&#x627;&#x644;&#x635;&#x648;&#x62A; &#x62C;&#x64A;&#x62F;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "&#x644;&#x627; &#x64A;&#x645;&#x643;&#x646; &#x627;&#x644;&#x62A;&#x642;&#x627;&#x637; &#x623;&#x64A; &#x635;&#x648;&#x62A;",
                  "ba-audiorecorder-controlbar.record": "&#x633;&#x62C;&#x644;",
                  "ba-audiorecorder-controlbar.record-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x644;&#x62A;&#x633;&#x62C;&#x64A;&#x644;.",
                  "ba-audiorecorder-controlbar.rerecord": "&#x641;&#x639;&#x644; &#x62B;&#x627;&#x646;&#x64A;&#x629;",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x644;&#x625;&#x639;&#x627;&#x62F;&#x629;.",
                  "ba-audiorecorder-controlbar.stop": "&#x62A;&#x648;&#x642;&#x641;",
                  "ba-audiorecorder-controlbar.stop-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x644;&#x62A;&#x648;&#x642;&#x641;.",
                  "ba-audiorecorder-controlbar.stop-available-after": "&#x627;&#x644;&#x62D;&#x62F; &#x627;&#x644;&#x623;&#x62F;&#x646;&#x649; &#x644;&#x645;&#x62F;&#x629; &#x627;&#x644;&#x62A;&#x633;&#x62C;&#x64A;&#x644; &#x647;&#x648;%d &#x62B;&#x627;&#x646;&#x64A;&#x629;",
                  "ba-audiorecorder-controlbar.cancel": "&#x625;&#x644;&#x63A;&#x627;&#x621;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "&#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x644;&#x625;&#x644;&#x63A;&#x627;&#x621;.",
                  "ba-videoplayer-controlbar.player-speed": "&#x633;&#x631;&#x639;&#x629; &#x627;&#x644;&#x644;&#x627;&#x639;&#x628;",
                  "ba-videoplayer-controlbar.settings": "&#x627;&#x644;&#x625;&#x639;&#x62F;&#x627;&#x62F;&#x627;&#x62A;",
                  "ba-videoplayer-controlbar.airplay": "&#x627;&#x644;&#x628;&#x62B;",
                  "ba-videoplayer-controlbar.airplay-icon": "&#x623;&#x64A;&#x642;&#x648;&#x646;&#x629; &#x627;&#x644;&#x628;&#x62B;.",
                  "ba-videoplayer.all-settings": "&#x62C;&#x645;&#x64A;&#x639; &#x627;&#x644;&#x625;&#x639;&#x62F;&#x627;&#x62F;&#x627;&#x62A;",
                  "ba-videoplayer.player-speed": "&#x633;&#x631;&#x639;&#x629; &#x627;&#x644;&#x644;&#x627;&#x639;&#x628;",
                  "ba-videoplayer.full-screen": "&#x634;&#x627;&#x634;&#x629; &#x643;&#x627;&#x645;&#x644;&#x629;",
                  "ba-videorecorder-controlbar.add-stream": "&#x625;&#x636;&#x627;&#x641;&#x629; &#x62A;&#x64A;&#x627;&#x631;",
                  "ba-videorecorder.switch-camera": "&#x62A;&#x628;&#x62F;&#x64A;&#x644; &#x627;&#x644;&#x643;&#x627;&#x645;&#x64A;&#x631;&#x627;",
                  "ba-videorecorder.prepare-covershot": "&#x625;&#x639;&#x62F;&#x627;&#x62F; covershots",
                  "ba-videorecorder.prepare-thumbnails": "&#x625;&#x639;&#x62F;&#x627;&#x62F; &#x62A;&#x633;&#x639;&#x649; &#x627;&#x644;&#x635;&#x648;&#x631; &#x627;&#x644;&#x645;&#x635;&#x63A;&#x631;&#x629;",
                  "ba-videorecorder.adding-new-stream": "&#x645;&#x636;&#x64A;&#x641;&#x627; &#x62A;&#x64A;&#x627;&#x631; &#x62C;&#x62F;&#x64A;&#x62F;",
                  "ba-imagecapture.recorder-error": "&#x644;&#x642;&#x62F; &#x62D;&#x62F;&#x62B; &#x62E;&#x637;&#x623;&#x60C; &#x631;&#x62C;&#x627;&#x621; &#x623;&#x639;&#x62F; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629; &#x644;&#x627;&#x62D;&#x642;&#x627;. &#x627;&#x646;&#x642;&#x631; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-imagecapture.attach-error": "&#x644;&#x645; &#x646;&#x62A;&#x645;&#x643;&#x646; &#x645;&#x646; &#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x648;&#x627;&#x62C;&#x647;&#x629; &#x627;&#x644;&#x648;&#x633;&#x627;&#x626;&#x637;. &#x627;&#x639;&#x62A;&#x645;&#x627;&#x62F;&#x64B;&#x627; &#x639;&#x644;&#x649; &#x627;&#x644;&#x62C;&#x647;&#x627;&#x632; &#x648;&#x627;&#x644;&#x645;&#x633;&#x62A;&#x639;&#x631;&#x636; &#x60C; &#x642;&#x62F; &#x62A;&#x62D;&#x62A;&#x627;&#x62C; &#x625;&#x644;&#x649; &#x62A;&#x62B;&#x628;&#x64A;&#x62A; Flash &#x623;&#x648; &#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x627;&#x644;&#x635;&#x641;&#x62D;&#x629; &#x639;&#x628;&#x631; &#x637;&#x628;&#x642;&#x629; &#x627;&#x644;&#x645;&#x642;&#x627;&#x628;&#x633; &#x627;&#x644;&#x622;&#x645;&#x646;&#x629;.",
                  "ba-imagecapture.software-required": "&#x64A;&#x631;&#x62C;&#x649; &#x627;&#x644;&#x646;&#x642;&#x631; &#x623;&#x62F;&#x646;&#x627;&#x647; &#x644;&#x62A;&#x62B;&#x628;&#x64A;&#x62A; / &#x62A;&#x641;&#x639;&#x64A;&#x644; &#x627;&#x644;&#x645;&#x62A;&#x637;&#x644;&#x628;&#x627;&#x62A; &#x627;&#x644;&#x62A;&#x627;&#x644;&#x64A;&#x629; &#x645;&#x646; &#x623;&#x62C;&#x644; &#x627;&#x644;&#x645;&#x62A;&#x627;&#x628;&#x639;&#x629;.",
                  "ba-imagecapture.software-waiting": "&#x641;&#x64A; &#x627;&#x646;&#x62A;&#x638;&#x627;&#x631; &#x627;&#x644;&#x645;&#x62A;&#x637;&#x644;&#x628;&#x627;&#x62A; &#x644;&#x64A;&#x62A;&#x645; &#x62A;&#x62B;&#x628;&#x64A;&#x62A;&#x647;&#x627; / &#x62A;&#x641;&#x639;&#x64A;&#x644;&#x647;&#x627;. &#x642;&#x62F; &#x62A;&#x62D;&#x62A;&#x627;&#x62C; &#x625;&#x644;&#x649; &#x62A;&#x62D;&#x62F;&#x64A;&#x62B; &#x627;&#x644;&#x635;&#x641;&#x62D;&#x629; &#x628;&#x639;&#x62F; &#x627;&#x644;&#x627;&#x646;&#x62A;&#x647;&#x627;&#x621;.",
                  "ba-imagecapture.access-forbidden": "&#x62A;&#x645; &#x645;&#x646;&#x639; &#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x648;&#x633;&#x627;&#x626;&#x644; &#x627;&#x644;&#x625;&#x639;&#x644;&#x627;&#x645;. &#x627;&#x646;&#x642;&#x631; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-imagecapture.uploading": "&#x62A;&#x62D;&#x645;&#x64A;&#x644;",
                  "ba-imagecapture.uploading-failed": "&#x641;&#x634;&#x644; &#x627;&#x644;&#x62A;&#x62D;&#x645;&#x64A;&#x644; - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-imagecapture.upload-error-duration": "&#x637;&#x648;&#x644; &#x627;&#x644;&#x635;&#x648;&#x631;&#x629; &#x627;&#x644;&#x62A;&#x64A; &#x62A;&#x645; &#x62A;&#x62D;&#x645;&#x64A;&#x644;&#x647;&#x627; &#x644;&#x627; &#x64A;&#x644;&#x628;&#x64A; &#x627;&#x644;&#x645;&#x62A;&#x637;&#x644;&#x628;&#x627;&#x62A; - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-imagecapture.resolution-constraint-error": "&#x627;&#x644;&#x645;&#x644;&#x641; &#x627;&#x644;&#x630;&#x64A; &#x62D;&#x62F;&#x62F;&#x62A;&#x647; &#x644;&#x627; &#x64A;&#x62A;&#x637;&#x627;&#x628;&#x642; &#x645;&#x639; &#x627;&#x644;&#x62F;&#x642;&#x629; &#x627;&#x644;&#x645;&#x637;&#x644;&#x648;&#x628;&#x629; - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-imagecapture.verifying": "&#x627;&#x644;&#x62A;&#x62D;&#x642;&#x642;",
                  "ba-imagecapture.verifying-failed": "&#x641;&#x634;&#x644; &#x627;&#x644;&#x62A;&#x62D;&#x642;&#x642; - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-imagecapture.rerecord-confirm": "&#x647;&#x644; &#x62A;&#x631;&#x64A;&#x62F; &#x62D;&#x642;&#x64B;&#x627; &#x627;&#x633;&#x62A;&#x639;&#x627;&#x62F;&#x629; &#x635;&#x648;&#x631;&#x62A;&#x643;&#x61F;",
                  "ba-imagecapture.image_file_too_large": "&#x645;&#x644;&#x641; &#x627;&#x644;&#x635;&#x648;&#x631;&#x629; &#x627;&#x644;&#x62E;&#x627;&#x635; &#x628;&#x643; &#x643;&#x628;&#x64A;&#x631; &#x62C;&#x62F;&#x64B;&#x627; (%s) - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629; &#x628;&#x627;&#x633;&#x62A;&#x62E;&#x62F;&#x627;&#x645; &#x645;&#x644;&#x641; &#x635;&#x648;&#x631;&#x629; &#x623;&#x635;&#x63A;&#x631;.",
                  "ba-imagecapture.unsupported_image_type": "&#x627;&#x644;&#x631;&#x62C;&#x627;&#x621; &#x627;&#x644;&#x62A;&#x62D;&#x645;&#x64A;&#x644;:%s - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-imagecapture.orientation-portrait-required": "&#x64A;&#x631;&#x62C;&#x649; &#x62A;&#x62F;&#x648;&#x64A;&#x631; &#x62C;&#x647;&#x627;&#x632;&#x643; &#x644;&#x62A;&#x633;&#x62C;&#x64A;&#x644; &#x641;&#x64A; &#x648;&#x636;&#x639; &#x639;&#x645;&#x648;&#x62F;&#x64A;.",
                  "ba-imagecapture.orientation-landscape-required": "&#x64A;&#x631;&#x62C;&#x649; &#x62A;&#x62F;&#x648;&#x64A;&#x631; &#x62C;&#x647;&#x627;&#x632;&#x643; &#x644;&#x644;&#x62A;&#x633;&#x62C;&#x64A;&#x644; &#x641;&#x64A; &#x648;&#x636;&#x639; &#x623;&#x641;&#x642;&#x64A;.",
                  "ba-audiorecorder.recorder-error": "&#x644;&#x642;&#x62F; &#x62D;&#x62F;&#x62B; &#x62E;&#x637;&#x623;&#x60C; &#x631;&#x62C;&#x627;&#x621; &#x623;&#x639;&#x62F; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629; &#x644;&#x627;&#x62D;&#x642;&#x627;. &#x627;&#x646;&#x642;&#x631; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-audiorecorder.attach-error": "&#x644;&#x645; &#x646;&#x62A;&#x645;&#x643;&#x646; &#x645;&#x646; &#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x648;&#x627;&#x62C;&#x647;&#x629; &#x627;&#x644;&#x648;&#x633;&#x627;&#x626;&#x637;. &#x627;&#x639;&#x62A;&#x645;&#x627;&#x62F;&#x64B;&#x627; &#x639;&#x644;&#x649; &#x627;&#x644;&#x62C;&#x647;&#x627;&#x632; &#x648;&#x627;&#x644;&#x645;&#x633;&#x62A;&#x639;&#x631;&#x636; &#x60C; &#x642;&#x62F; &#x62A;&#x62D;&#x62A;&#x627;&#x62C; &#x625;&#x644;&#x649; &#x62A;&#x62B;&#x628;&#x64A;&#x62A; Flash &#x623;&#x648; &#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x627;&#x644;&#x635;&#x641;&#x62D;&#x629; &#x639;&#x628;&#x631; &#x637;&#x628;&#x642;&#x629; &#x627;&#x644;&#x645;&#x642;&#x627;&#x628;&#x633; &#x627;&#x644;&#x622;&#x645;&#x646;&#x629;.",
                  "ba-audiorecorder.software-required": "&#x64A;&#x631;&#x62C;&#x649; &#x627;&#x644;&#x646;&#x642;&#x631; &#x623;&#x62F;&#x646;&#x627;&#x647; &#x644;&#x62A;&#x62B;&#x628;&#x64A;&#x62A; / &#x62A;&#x641;&#x639;&#x64A;&#x644; &#x627;&#x644;&#x645;&#x62A;&#x637;&#x644;&#x628;&#x627;&#x62A; &#x627;&#x644;&#x62A;&#x627;&#x644;&#x64A;&#x629; &#x645;&#x646; &#x623;&#x62C;&#x644; &#x627;&#x644;&#x645;&#x62A;&#x627;&#x628;&#x639;&#x629;.",
                  "ba-audiorecorder.software-waiting": "&#x641;&#x64A; &#x627;&#x646;&#x62A;&#x638;&#x627;&#x631; &#x627;&#x644;&#x645;&#x62A;&#x637;&#x644;&#x628;&#x627;&#x62A; &#x644;&#x64A;&#x62A;&#x645; &#x62A;&#x62B;&#x628;&#x64A;&#x62A;&#x647;&#x627; / &#x62A;&#x641;&#x639;&#x64A;&#x644;&#x647;&#x627;. &#x642;&#x62F; &#x62A;&#x62D;&#x62A;&#x627;&#x62C; &#x625;&#x644;&#x649; &#x62A;&#x62D;&#x62F;&#x64A;&#x62B; &#x627;&#x644;&#x635;&#x641;&#x62D;&#x629; &#x628;&#x639;&#x62F; &#x627;&#x644;&#x627;&#x646;&#x62A;&#x647;&#x627;&#x621;.",
                  "ba-audiorecorder.access-forbidden": "&#x62A;&#x645; &#x645;&#x646;&#x639; &#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x648;&#x633;&#x627;&#x626;&#x644; &#x627;&#x644;&#x625;&#x639;&#x644;&#x627;&#x645;. &#x627;&#x646;&#x642;&#x631; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-audiorecorder.uploading": "&#x62A;&#x62D;&#x645;&#x64A;&#x644;",
                  "ba-audiorecorder.uploading-failed": "&#x641;&#x634;&#x644; &#x627;&#x644;&#x62A;&#x62D;&#x645;&#x64A;&#x644; - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-audiorecorder.upload-error-duration": "&#x637;&#x648;&#x644; &#x627;&#x644;&#x635;&#x648;&#x62A; &#x627;&#x644;&#x630;&#x64A; &#x62A;&#x645; &#x62A;&#x62D;&#x645;&#x64A;&#x644;&#x647; &#x644;&#x627; &#x64A;&#x644;&#x628;&#x64A; &#x627;&#x644;&#x645;&#x62A;&#x637;&#x644;&#x628;&#x627;&#x62A; - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-audiorecorder.verifying": "&#x627;&#x644;&#x62A;&#x62D;&#x642;&#x642;",
                  "ba-audiorecorder.verifying-failed": "&#x641;&#x634;&#x644; &#x627;&#x644;&#x62A;&#x62D;&#x642;&#x642; - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-audiorecorder.rerecord-confirm": "&#x647;&#x644; &#x62A;&#x631;&#x64A;&#x62F; &#x62D;&#x642;&#x64B;&#x627; &#x625;&#x639;&#x627;&#x62F;&#x629; &#x635;&#x648;&#x62A;&#x643;&#x61F;",
                  "ba-audiorecorder.cancel-confirm": "&#x647;&#x644; &#x62A;&#x631;&#x64A;&#x62F; &#x62D;&#x642;&#x64B;&#x627; &#x625;&#x644;&#x63A;&#x627;&#x621; &#x62A;&#x62D;&#x645;&#x64A;&#x644; &#x627;&#x644;&#x635;&#x648;&#x62A; &#x627;&#x644;&#x62E;&#x627;&#x635; &#x628;&#x643;&#x61F;",
                  "ba-audiorecorder.audio_file_too_large": "&#x645;&#x644;&#x641; &#x627;&#x644;&#x635;&#x648;&#x62A; &#x627;&#x644;&#x62E;&#x627;&#x635; &#x628;&#x643; &#x643;&#x628;&#x64A;&#x631; &#x62C;&#x62F;&#x64B;&#x627; (%s) - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629; &#x628;&#x627;&#x633;&#x62A;&#x62E;&#x62F;&#x627;&#x645; &#x645;&#x644;&#x641; &#x635;&#x648;&#x62A;&#x64A; &#x623;&#x635;&#x63A;&#x631;.",
                  "ba-audiorecorder.unsupported_audio_type": "&#x627;&#x644;&#x631;&#x62C;&#x627;&#x621; &#x627;&#x644;&#x62A;&#x62D;&#x645;&#x64A;&#x644;:%s - &#x627;&#x646;&#x642;&#x631; &#x647;&#x646;&#x627; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ba-common-settingsmenu.tooltip": "&#x627;&#x646;&#x642;&#x631; &#x644;&#x644;&#x639;&#x628;.",
                  "ba-common-settingsmenu.setting-menu": "&#x62C;&#x645;&#x64A;&#x639; &#x627;&#x644;&#x625;&#x639;&#x62F;&#x627;&#x62F;&#x627;&#x62A;",
                  "ba-common-settingsmenu.source-quality": "&#x62C;&#x648;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x635;&#x62F;&#x631;",
                  "ba-common-settingsmenu.player-speed": "&#x633;&#x631;&#x639;&#x629; &#x627;&#x644;&#x644;&#x627;&#x639;&#x628;",
                  "ba-common-settingsmenu.set-menu-option": "&#x62A;&#x639;&#x64A;&#x64A;&#x646; &#x627;&#x644;&#x62E;&#x64A;&#x627;&#x631;",
                  "ba-common-settingsmenu.submit-video": "&#x62A;&#x623;&#x643;&#x64A;&#x62F; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648;",
                  "ba-common-settingsmenu.picture-in-picture": "&#x635;&#x648;&#x631; &#x641;&#x64A; &#x635;&#x648;&#x631;",
                  "ba-common-settingsmenu.exit-fullscreen-video": "&#x627;&#x644;&#x62E;&#x631;&#x648;&#x62C; &#x645;&#x646; &#x627;&#x644;&#x634;&#x627;&#x634;&#x629; &#x627;&#x644;&#x643;&#x627;&#x645;&#x644;&#x629;",
                  "ba-common-settingsmenu.fullscreen-video": "&#x623;&#x62F;&#x62E;&#x644; &#x645;&#x644;&#x621; &#x627;&#x644;&#x634;&#x627;&#x634;&#x629;",
                  "ba-videorecorder-chooser.multi-stream": "&#x645;&#x62A;&#x639;&#x62F;&#x62F; &#x62A;&#x64A;&#x627;&#x631;",
                  "ba-videorecorder-controlbar.pause-recorder": "&#x645;&#x633;&#x62C;&#x644; &#x648;&#x642;&#x641;&#x629;",
                  "ba-videorecorder-controlbar.resume-recorder": "&#x645;&#x633;&#x62C;&#x644; &#x627;&#x644;&#x633;&#x64A;&#x631;&#x629; &#x627;&#x644;&#x630;&#x627;&#x62A;&#x64A;&#x629;",
                  "ba-videorecorder.missing-track": "&#x645;&#x633;&#x627;&#x631; &#x627;&#x644;&#x635;&#x648;&#x62A; &#x623;&#x648; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x627;&#x644;&#x645;&#x637;&#x644;&#x648;&#x628; &#x645;&#x641;&#x642;&#x648;&#x62F;",
                  "ba-videorecorder.device-already-in-use": "&#x648;&#x627;&#x62D;&#x62F; &#x639;&#x644;&#x649; &#x627;&#x644;&#x623;&#x642;&#x644; &#x645;&#x646; &#x623;&#x62C;&#x647;&#x632;&#x629; &#x627;&#x644;&#x625;&#x62F;&#x62E;&#x627;&#x644; &#x627;&#x644;&#x62E;&#x627;&#x635;&#x629; &#x628;&#x643; &#x642;&#x64A;&#x62F; &#x627;&#x644;&#x627;&#x633;&#x62A;&#x62E;&#x62F;&#x627;&#x645; &#x628;&#x627;&#x644;&#x641;&#x639;&#x644;",
                  "ba-videorecorder.browser-permission-denied": "&#x62A;&#x645; &#x631;&#x641;&#x636; &#x627;&#x644;&#x625;&#x630;&#x646; &#x639;&#x646; &#x637;&#x631;&#x64A;&#x642; &#x627;&#x644;&#x645;&#x62A;&#x635;&#x641;&#x62D; &#x60C; &#x64A;&#x631;&#x62C;&#x649; &#x645;&#x646;&#x62D; &#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x648;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x62A;&#x62D;&#x645;&#x64A;&#x644; &#x627;&#x644;&#x635;&#x641;&#x62D;&#x629;",
                  "ba-audioplayer.all-settings": "&#x62C;&#x645;&#x64A;&#x639; &#x627;&#x644;&#x625;&#x639;&#x62F;&#x627;&#x62F;&#x627;&#x62A;",
                  "ba-videoplayer-controlbar.remaining-time": "&#x627;&#x644;&#x648;&#x642;&#x62A; &#x627;&#x644;&#x645;&#x62A;&#x628;&#x642;&#x64A;",
                  "ba-videoplayer-controlbar.select-frame": "&#x64A;&#x62E;&#x62A;&#x627;&#x631;",
                  "ba-videoplayer-controlbar.trim-video": "&#x62A;&#x642;&#x644;&#x64A;&#x645;",
                  "ba-videoplayer-playbutton.trim": "&#x62A;&#x642;&#x644;&#x64A;&#x645;",
                  "ba-videoplayer-playbutton.skip": "&#x64A;&#x62A;&#x62E;&#x637;&#x649;",
                  "ba-videorecorder-imagegallery.upload-covershot": "&#x62A;&#x62D;&#x645;&#x64A;&#x644; &#x627;&#x644;&#x63A;&#x644;&#x627;&#x641;",
                  "ba-videorecorder.pick-covershot-frame": "&#x62D;&#x62F;&#x62F; &#x625;&#x637;&#x627;&#x631;&#x64B;&#x627; &#x644;&#x627;&#x633;&#x62A;&#x62E;&#x62F;&#x627;&#x645;&#x647; &#x643;&#x635;&#x648;&#x631;&#x629; &#x63A;&#x644;&#x627;&#x641;.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "&#x645;&#x633;&#x62C;&#x644; &#x627;&#x644;&#x634;&#x627;&#x634;&#x629; &#x63A;&#x64A;&#x631; &#x645;&#x62F;&#x639;&#x648;&#x645; &#x639;&#x644;&#x649; &#x647;&#x630;&#x627; &#x627;&#x644;&#x62C;&#x647;&#x627;&#x632;",
                  "ba-videorecorder.trim-prompt": "&#x647;&#x644; &#x62A;&#x631;&#x64A;&#x62F; &#x62A;&#x642;&#x644;&#x64A;&#x645; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x627;&#x644;&#x62E;&#x627;&#x635; &#x628;&#x643;&#x61F;",
                  "ba-videorecorder.trim-video": "&#x62D;&#x631;&#x643; &#x639;&#x644;&#x627;&#x645;&#x62A;&#x64A; &#x627;&#x644;&#x628;&#x62F;&#x627;&#x64A;&#x629; &#x648;&#x627;&#x644;&#x646;&#x647;&#x627;&#x64A;&#x629; &#x644;&#x642;&#x635; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x627;&#x644;&#x62E;&#x627;&#x635; &#x628;&#x643;",
                  "ba-videorecorder.wait-for-trim": "&#x641;&#x64A; &#x627;&#x646;&#x62A;&#x638;&#x627;&#x631; &#x623;&#x645;&#x631; &#x627;&#x644;&#x642;&#x637;&#x639; ...",
                  "ba-videorecorder-controlbar.no-video-source": "&#x645;&#x635;&#x62F;&#x631; &#x625;&#x62F;&#x62E;&#x627;&#x644; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x627;&#x644;&#x625;&#x636;&#x627;&#x641;&#x64A; &#x645;&#x641;&#x642;&#x648;&#x62F;",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x62A;&#x645; &#x62A;&#x62D;&#x62F;&#x64A;&#x62F; &#x62A;&#x64A;&#x627;&#x631; &#x625;&#x636;&#x627;&#x641;&#x64A; &#x628;&#x627;&#x644;&#x641;&#x639;&#x644;",
                  "ba-videorecorder.uploading-src-error": "&#x62A;&#x639;&#x630;&#x631; &#x62A;&#x634;&#x63A;&#x64A;&#x644; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x627;&#x644;&#x622;&#x646; &#x60C; &#x644;&#x627; &#x64A;&#x632;&#x627;&#x644; &#x627;&#x644;&#x62A;&#x62D;&#x645;&#x64A;&#x644; &#x642;&#x64A;&#x62F; &#x627;&#x644;&#x62A;&#x642;&#x62F;&#x645;",
                  "ba-audiorecorder-controlbar.pause-recorder": "&#x645;&#x633;&#x62C;&#x644; &#x648;&#x642;&#x641;&#x629;",
                  "ba-audiorecorder-controlbar.resume-recorder": "&#x645;&#x633;&#x62C;&#x644; &#x627;&#x644;&#x633;&#x64A;&#x631;&#x629; &#x627;&#x644;&#x630;&#x627;&#x62A;&#x64A;&#x629;"
                },
                "language:az": {
                  "ba-videoplayer-playbutton.tooltip": "Videoya baxmaq &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-videoplayer-playbutton.rerecord": "Yenid&#x259;n yazmaq",
                  "ba-videoplayer-playbutton.submit-video": "Videonu t&#x259;sdiq et",
                  "ba-videoplayer-loader.tooltip": "Video y&#xFC;kl&#x259;nir ...",
                  "ba-videoplayer-controlbar.change-resolution": "G&#xF6;r&#xFC;nt&#xFC;n&#xFC;n keyfiyy&#x259;tini d&#x259;yi&#x15F;",
                  "ba-videoplayer-controlbar.video-progress": "Videonun davamiyy&#x259;ti",
                  "ba-videoplayer-controlbar.rerecord-video": "Video yenid&#x259;n yaz&#x131;ls&#x131;n?",
                  "ba-videoplayer-controlbar.submit-video": "Videonu t&#x259;sdiq et",
                  "ba-videoplayer-controlbar.play-video": "Videonu g&#xF6;st&#x259;r",
                  "ba-videoplayer-controlbar.pause-video": "Videonu dayand&#x131;r",
                  "ba-videoplayer-controlbar.elapsed-time": "Ke&#xE7;&#x259;n vaxt",
                  "ba-videoplayer-controlbar.total-time": "Videonu tam uzunlu&#x11F;u",
                  "ba-videoplayer-controlbar.fullscreen-video": "Tam ekran edin",
                  "ba-videoplayer-controlbar.volume-button": "S&#x259;s d&#xFC;ym&#x259;si",
                  "ba-videoplayer-controlbar.volume-mute": "S&#x259;ssiz et",
                  "ba-videoplayer-controlbar.volume-unmute": "S&#x259;sli et",
                  "ba-videoplayer.video-error": "X&#x259;ta ba&#x15F; vermi&#x15F;dir. Xahi&#x15F; edirik bir az sonra yenid&#x259;n c&#x259;hd edin. Yenid&#x259;n yoxlamaq &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-videorecorder-chooser.record-video": "Videonu yaz",
                  "ba-videorecorder-chooser.upload-video": "Videonu y&#xFC;kl&#x259;",
                  "ba-videorecorder-controlbar.settings": "Ayarlar",
                  "ba-videorecorder-controlbar.camerahealthy": "&#x130;&#x15F;&#x131;qland&#x131;rma yax&#x15F;&#x131;d&#x131;r",
                  "ba-videorecorder-controlbar.cameraunhealthy": "&#x130;&#x15F;&#x131;qland&#x131;rma optimal deyil",
                  "ba-videorecorder-controlbar.microphonehealthy": "S&#x259;s yax&#x15F;&#x131; e&#x15F;idilir",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Mikrofonun s&#x259;si e&#x15F;idilmir",
                  "ba-videorecorder-controlbar.record": "Yazmaq",
                  "ba-videorecorder-controlbar.record-tooltip": "Videonu yazmaq &#xFC;&#xE7;&#xFC;n bas&#x131;n",
                  "ba-videorecorder-controlbar.rerecord": "Videonu yenid&#x259;n yaz",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Yenid&#x259;n yazmaq &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-videorecorder-controlbar.upload-covershot": "Y&#xFC;kl&#x259;",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#xDC;zl&#xFC;k &#x15F;&#x259;kli y&#xFC;kl&#x259;m&#x259;k &#xFC;&#xE7;&#xFC;n bas&#x131;n",
                  "ba-videorecorder-controlbar.stop": "Dayand&#x131;rmaq",
                  "ba-videorecorder-controlbar.stop-tooltip": "Dayand&#x131;rmaq &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-videorecorder-controlbar.skip": "N&#x259;z&#x259;r&#x259; alma",
                  "ba-videorecorder-controlbar.skip-tooltip": "N&#x259;z&#x259;r&#x259; almadan ke&#xE7;m&#x259;k &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-videorecorder.recorder-error": "X&#x259;ta ba&#x15F; verdi. Xahi&#x15F; edirik bir az sonra yenid&#x259;n c&#x259;hd edin. Yenid&#x259;n yoxlamaq &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-videorecorder.attach-error": "Kamera g&#xF6;r&#xFC;nt&#xFC;s&#xFC;n&#xFC; &#x259;ld&#x259; etm&#x259;k m&#xFC;mk&#xFC;n olmad&#x131;. Sizin istifad&#x259; etdiyiniz cihazdan v&#x259; brauzerd&#x259;n as&#x131;l&#x131; olaraq siz ya Flash proqram&#x131; y&#xFC;kl&#x259;nm&#x259;li v&#x259; ya veb s&#x259;hif&#x259;y&#x259; SSL il&#x259; daxil olmal&#x131;s&#x131;z.",
                  "ba-videorecorder.access-forbidden": "Kamera g&#xF6;r&#xFC;nt&#xFC;s&#xFC;n&#x259; icaz&#x259; verilm&#x259;di. Yenid&#x259;n yoxlamaq &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-videorecorder.pick-covershot": "&#xDC;zl&#xFC;k &#x15F;&#x259;klini se&#xE7;in.",
                  "ba-videorecorder.uploading": "Y&#xFC;kl&#x259;nir",
                  "ba-videorecorder.uploading-failed": "Y&#xFC;kl&#x259;nm&#x259; zaman&#x131; x&#x259;ta ba&#x15F; verdi, t&#x259;krar etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya bas&#x131;n.",
                  "ba-videorecorder.verifying": "Yoxlama",
                  "ba-videorecorder.verifying-failed": "Yoxlama u&#x11F;ursuzluqla bitdi - t&#x259;krar &#xFC;&#xE7;&#xFC;n buraya bas&#x131;n.",
                  "ba-videorecorder.rerecord-confirm": "Siz, h&#x259;qiq&#x259;t&#x259;n, videonu yenid&#x259;n yazmaq ist&#x259;yirsiniz?",
                  "ba-videorecorder.video_file_too_large": "Sizin video fayl&#x131;n h&#x259;cmi (%s) &#xE7;ox b&#xF6;y&#xFC;kd&#xFC;r - ki&#xE7;ik h&#x259;cmli video fayl il&#x259; yenid&#x259;n c&#x259;hd &#xFC;&#xE7;&#xFC;n buraya bas&#x131;n.",
                  "ba-videorecorder.unsupported_video_type": "Y&#xFC;kl&#x259;yin: %s - yenid&#x259;n yoxlamaq &#xFC;&#xE7;&#xFC;n buraya bas&#x131;n.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Tam ekran rejimind&#x259;n &#xE7;&#x131;x&#x131;&#x15F;",
                  "ba-videoplayer-share.share": "Videonu payla&#x15F;",
                  "ba-videorecorder-chooser.record-screen": "S&#x259;s ekran&#x131;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pauza d&#x259;st&#x259;kl&#x259;nmir",
                  "ba-videorecorder-chooser.record-audio": "Record Audio",
                  "ba-videorecorder-controlbar.stop-available-after": "Minimum qeydiyyatdan ke&#xE7;m&#x259; m&#xFC;dd&#x259;ti %d saniy&#x259;dir",
                  "ba-videorecorder-controlbar.cancel": "L&#x259;&#x11F;v et",
                  "ba-videorecorder-controlbar.cancel-tooltip": "L&#x259;&#x11F;v etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya bas&#x131;n.",
                  "ba-videorecorder.cancel-confirm": "Video y&#xFC;kl&#x259;m&#x259;yini h&#x259;qiq&#x259;t&#x259;n l&#x259;&#x11F;v etm&#x259;k ist&#x259;yirsiniz?",
                  "ba-videoplayer-adslot.elapsed-time": "Ke&#xE7;&#x259;n vaxt",
                  "ba-videoplayer-adslot.volume-button": "H&#x259;cmi se&#xE7;in",
                  "ba-videoplayer-adslot.volume-mute": "S&#x259;s s&#x259;si",
                  "ba-videoplayer-adslot.volume-unmute": "S&#x259;sin s&#x259;sl&#x259;ndirilm&#x259;si",
                  "ba-videoplayer-adslot.ad-will-end-after": "Reklam %s sonra sona &#xE7;atacaq",
                  "ba-videoplayer-adslot.can-skip-after": "%d sonra atlay&#x131;n",
                  "ba-videoplayer-adslot.skip-ad": "Reklam&#x131; atlay&#x131;n",
                  "ba-videorecorder.software-required": "Davam etm&#x259;k &#xFC;&#xE7;&#xFC;n a&#x15F;a&#x11F;&#x131;dak&#x131; t&#x259;l&#x259;bl&#x259;ri qurmaq / aktivl&#x259;&#x15F;dirm&#x259;k &#xFC;&#xE7;&#xFC;n a&#x15F;a&#x11F;&#x131;ya bas&#x131;n.",
                  "ba-videorecorder.software-waiting": "Qurulacaq / aktivl&#x259;&#x15F;diril&#x259;c&#x259;k t&#x259;l&#x259;bl&#x259;ri g&#xF6;zl&#x259;yir&#x259;m. Tamamland&#x131;qdan sonra s&#x259;hif&#x259;ni yenil&#x259;m&#x259;k laz&#x131;md&#x131;r.",
                  "ba-videoplayer-controlbar.close-tracks": "CC&#x27;yi ba&#x11F;lay&#x131;n",
                  "ba-videoplayer-controlbar.show-tracks": "CC g&#xF6;st&#x259;r",
                  "ba-videoplayer-tracks.upload-text-tracks": "Track m&#x259;tn fayllar&#x131;n&#x131; y&#xFC;kl&#x259;yin",
                  "ba-videoplayer-tracks.select-text-track-language": "Altyaz&#x131; dili",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x18F;vv&#x259;lc&#x259;d&#x259;n yerli se&#xE7;in",
                  "ba-videoplayer-tracks.select-text-track-file": "Fayl se&#xE7;m&#x259;k &#xFC;&#xE7;&#xFC;n bas&#x131;n",
                  "ba-videoplayer-tracks.back": "geri",
                  "ba-videorecorder.framerate-warning": "Video &#xE7;&#x259;r&#xE7;iv&#x259;si d&#x259;r&#x259;c&#x259;si &#xE7;ox a&#x15F;a&#x11F;&#x131;d&#x131;r. B&#xFC;t&#xFC;n dig&#x259;r proqramlar&#x131; v&#x259; brauzer ni&#x15F;anlar&#x131;n&#x131; ba&#x11F;lamaq v&#x259; ya daha s&#xFC;r&#x259;tli bir komp&#xFC;ter istifad&#x259; etm&#x259;k &#xFC;&#xE7;&#xFC;n g&#x259;lir.",
                  "ba-videorecorder.upload-error-duration": "Y&#xFC;kl&#x259;nmi&#x15F; videonun uzunlu&#x11F;u t&#x259;l&#x259;bl&#x259;r&#x259; cavab vermir - yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya vurun.",
                  "ba-videorecorder.resolution-constraint-error": "Se&#xE7;diyiniz fayl laz&#x131;mi q&#x259;tnam&#x259;y&#x259; uy&#x11F;un deyil - yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya vurun.",
                  "ba-videorecorder.orientation-portrait-required": "Portret rejimind&#x259; qeyd etm&#x259;k &#xFC;&#xE7;&#xFC;n cihaz&#x131;n&#x131;z&#x131; d&#xF6;nd&#x259;rin.",
                  "ba-videorecorder.orientation-landscape-required": "Land&#x15F;aft rejimind&#x259; qeyd etm&#x259;k &#xFC;&#xE7;&#xFC;n cihaz&#x131;n&#x131;z&#x131; d&#xF6;nd&#x259;rin.",
                  "ba-imageviewer-controlbar.rerecord-image": "Redo?",
                  "ba-imageviewer-controlbar.submit-image": "T&#x259;sdiq edin",
                  "ba-imageviewer-controlbar.fullscreen-image": "Tam ekrana daxil olun",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Tam ekrandan &#xE7;&#x131;x&#x131;n",
                  "ba-imageviewer.image-error": "X&#x259;ta ba&#x15F; verdi. Xahi&#x15F; edirik bir az sonra yenid&#x259;n c&#x259;hd edin. Yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-imagecapture-chooser.image-capture": "&#x15E;&#x259;kil &#xE7;&#x259;kin",
                  "ba-imagecapture-chooser.upload-image": "&#x15E;&#x259;kil y&#xFC;kl&#x259;yin",
                  "ba-imagecapture-controlbar.settings": "Ayarlar",
                  "ba-imagecapture-controlbar.camerahealthy": "&#x130;&#x15F;&#x131;qland&#x131;rma yax&#x15F;&#x131;d&#x131;r",
                  "ba-imagecapture-controlbar.cameraunhealthy": "&#x130;&#x15F;&#x131;qland&#x131;rma optimal deyil",
                  "ba-imagecapture-controlbar.record": "Capture",
                  "ba-imagecapture-controlbar.record-tooltip": "Tutmaq &#xFC;&#xE7;&#xFC;n bura vurun.",
                  "ba-imagecapture-controlbar.rerecord": "Redo",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Yenid&#x259;n yerin&#x259; yetirm&#x259;k &#xFC;&#xE7;&#xFC;n buraya bas&#x131;n.",
                  "ba-imagecapture-controlbar.cancel": "L&#x259;&#x11F;v et",
                  "ba-imagecapture-controlbar.cancel-tooltip": "L&#x259;&#x11F;v etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya bas&#x131;n.",
                  "ba-audioplayer-controlbar.audio-progress": "T&#x259;r&#x259;qqi",
                  "ba-audioplayer-controlbar.rerecord-audio": "Redo?",
                  "ba-audioplayer-controlbar.submit-audio": "T&#x259;sdiq edin",
                  "ba-audioplayer-controlbar.play-audio": "Oynamaq",
                  "ba-audioplayer-controlbar.pause-audio": "Pauza",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pauza d&#x259;st&#x259;kl&#x259;nmir",
                  "ba-audioplayer-controlbar.elapsed-time": "Ke&#xE7;&#x259;n vaxt",
                  "ba-audioplayer-controlbar.total-time": "&#xDC;mumi uzunlu&#x11F;u",
                  "ba-audioplayer-controlbar.volume-button": "H&#x259;cmi se&#xE7;in",
                  "ba-audioplayer-controlbar.volume-mute": "S&#x259;s s&#x259;si",
                  "ba-audioplayer-controlbar.volume-unmute": "S&#x259;sin s&#x259;sl&#x259;ndirilm&#x259;si",
                  "ba-audioplayer-loader.tooltip": "Y&#xFC;kl&#x259;nir ...",
                  "ba-audioplayer.audio-error": "X&#x259;ta ba&#x15F; verdi. Xahi&#x15F; edirik bir az sonra yenid&#x259;n c&#x259;hd edin. Yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-audiorecorder-chooser.record-audio": "Record Audio",
                  "ba-audiorecorder-chooser.upload-audio": "Audio y&#xFC;kl&#x259;",
                  "ba-audiorecorder-controlbar.settings": "Ayarlar",
                  "ba-audiorecorder-controlbar.microphonehealthy": "S&#x259;s yax&#x15F;&#x131;d&#x131;r",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "He&#xE7; bir s&#x259;s ala bilmir",
                  "ba-audiorecorder-controlbar.record": "Record",
                  "ba-audiorecorder-controlbar.record-tooltip": "Qeyd etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya vurun.",
                  "ba-audiorecorder-controlbar.rerecord": "Redo",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Yenid&#x259;n yerin&#x259; yetirm&#x259;k &#xFC;&#xE7;&#xFC;n buraya bas&#x131;n.",
                  "ba-audiorecorder-controlbar.stop": "Dur",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Durmaq &#xFC;&#xE7;&#xFC;n bura vurun.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Minimum qeydiyyatdan ke&#xE7;m&#x259; m&#xFC;dd&#x259;ti %d saniy&#x259;dir",
                  "ba-audiorecorder-controlbar.cancel": "L&#x259;&#x11F;v et",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "L&#x259;&#x11F;v etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya bas&#x131;n.",
                  "ba-videoplayer-controlbar.player-speed": "Oyun&#xE7;u s&#xFC;r&#x259;ti",
                  "ba-videoplayer-controlbar.settings": "Ayarlar",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay simgesi.",
                  "ba-videoplayer.all-settings": "B&#xFC;t&#xFC;n parametrl&#x259;r",
                  "ba-videoplayer.player-speed": "Oyun&#xE7;u s&#xFC;r&#x259;ti",
                  "ba-videoplayer.full-screen": "Tam ekran",
                  "ba-videorecorder-controlbar.add-stream": "Stream et",
                  "ba-videorecorder.switch-camera": "Kameran&#x131; d&#x259;yi&#x15F;in",
                  "ba-videorecorder.prepare-covershot": "&#x15E;i&#x15F;irtm&#x259;l&#x259;rin haz&#x131;rlanmas&#x131;",
                  "ba-videorecorder.prepare-thumbnails": "Ki&#xE7;ik axtarma&#x11F;a haz&#x131;rla&#x15F;maq",
                  "ba-videorecorder.adding-new-stream": "Yeni ax&#x131;n &#x259;lav&#x259; et",
                  "ba-imagecapture.recorder-error": "X&#x259;ta ba&#x15F; verdi. Xahi&#x15F; edirik bir az sonra yenid&#x259;n c&#x259;hd edin. Yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-imagecapture.attach-error": "Media medias&#x131;na daxil ola bilm&#x259;di. Qur&#x11F;u v&#x259; brauzerd&#x259;n as&#x131;l&#x131; olaraq, Flash-u y&#xFC;kl&#x259;m&#x259;k v&#x259; ya SSL vasit&#x259;sil&#x259; s&#x259;hif&#x259;y&#x259; daxil olman&#x131;z t&#x259;l&#x259;b oluna bil&#x259;r.",
                  "ba-imagecapture.software-required": "Davam etm&#x259;k &#xFC;&#xE7;&#xFC;n a&#x15F;a&#x11F;&#x131;dak&#x131; t&#x259;l&#x259;bl&#x259;ri qurmaq / aktivl&#x259;&#x15F;dirm&#x259;k &#xFC;&#xE7;&#xFC;n a&#x15F;a&#x11F;&#x131;ya bas&#x131;n.",
                  "ba-imagecapture.software-waiting": "Qurulacaq / aktivl&#x259;&#x15F;diril&#x259;c&#x259;k t&#x259;l&#x259;bl&#x259;ri g&#xF6;zl&#x259;yir&#x259;m. Tamamland&#x131;qdan sonra s&#x259;hif&#x259;ni yenil&#x259;m&#x259;k laz&#x131;md&#x131;r.",
                  "ba-imagecapture.access-forbidden": "K&#x130;V-&#x259; giri&#x15F; qada&#x11F;and&#x131;r. Yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-imagecapture.uploading": "Y&#xFC;kl&#x259;nm&#x259;",
                  "ba-imagecapture.uploading-failed": "Y&#xFC;kl&#x259;nm&#x259; ba&#x15F;ar&#x131;s&#x131;z oldu - yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n bura vurun.",
                  "ba-imagecapture.upload-error-duration": "Y&#xFC;kl&#x259;n&#x259;n g&#xF6;r&#xFC;nt&#xFC;n&#xFC;n uzunlu&#x11F;u t&#x259;l&#x259;bl&#x259;ri &#xF6;d&#x259;mir - yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya vurun.",
                  "ba-imagecapture.resolution-constraint-error": "Se&#xE7;diyiniz fayl, laz&#x131;mi q&#x259;tnam&#x259; il&#x259; uy&#x11F;un g&#x259;lmir - yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n bura vurun.",
                  "ba-imagecapture.verifying": "T&#x259;sdiql&#x259;m&#x259;",
                  "ba-imagecapture.verifying-failed": "Do&#x11F;ru yoxlan&#x131;ld&#x131; - yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya vurun.",
                  "ba-imagecapture.rerecord-confirm": "H&#x259;qiq&#x259;t&#x259;n resminizi b&#x259;rpa etm&#x259;k ist&#x259;yirsiniz?",
                  "ba-imagecapture.image_file_too_large": "Resim fayl&#x131;n&#x131;z &#xE7;ox b&#xF6;y&#xFC;kd&#xFC;r (%s) - daha ki&#xE7;ik bir g&#xF6;r&#xFC;nt&#xFC; fayl&#x131; il&#x259; yenid&#x259;n s&#x131;nanmaq &#xFC;&#xE7;&#xFC;n buraya vurun.",
                  "ba-imagecapture.unsupported_image_type": "Xahi&#x15F; edirik y&#xFC;kl&#x259;yin: %s - yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya vurun.",
                  "ba-imagecapture.orientation-portrait-required": "Portret rejimind&#x259; qeyd etm&#x259;k &#xFC;&#xE7;&#xFC;n cihaz&#x131;n&#x131;z&#x131; d&#xF6;nd&#x259;rin.",
                  "ba-imagecapture.orientation-landscape-required": "Land&#x15F;aft rejimind&#x259; qeyd etm&#x259;k &#xFC;&#xE7;&#xFC;n cihaz&#x131;n&#x131;z&#x131; d&#xF6;nd&#x259;rin.",
                  "ba-audiorecorder.recorder-error": "X&#x259;ta ba&#x15F; verdi. Xahi&#x15F; edirik bir az sonra yenid&#x259;n c&#x259;hd edin. Yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-audiorecorder.attach-error": "Media medias&#x131;na daxil ola bilm&#x259;di. Qur&#x11F;u v&#x259; brauzerd&#x259;n as&#x131;l&#x131; olaraq, Flash-u y&#xFC;kl&#x259;m&#x259;k v&#x259; ya SSL vasit&#x259;sil&#x259; s&#x259;hif&#x259;y&#x259; daxil olman&#x131;z t&#x259;l&#x259;b oluna bil&#x259;r.",
                  "ba-audiorecorder.software-required": "Davam etm&#x259;k &#xFC;&#xE7;&#xFC;n a&#x15F;a&#x11F;&#x131;dak&#x131; t&#x259;l&#x259;bl&#x259;ri qurmaq / aktivl&#x259;&#x15F;dirm&#x259;k &#xFC;&#xE7;&#xFC;n a&#x15F;a&#x11F;&#x131;ya bas&#x131;n.",
                  "ba-audiorecorder.software-waiting": "Qurulacaq / aktivl&#x259;&#x15F;diril&#x259;c&#x259;k t&#x259;l&#x259;bl&#x259;ri g&#xF6;zl&#x259;yir&#x259;m. Tamamland&#x131;qdan sonra s&#x259;hif&#x259;ni yenil&#x259;m&#x259;k laz&#x131;md&#x131;r.",
                  "ba-audiorecorder.access-forbidden": "K&#x130;V-&#x259; giri&#x15F; qada&#x11F;and&#x131;r. Yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n bas&#x131;n.",
                  "ba-audiorecorder.uploading": "Y&#xFC;kl&#x259;nm&#x259;",
                  "ba-audiorecorder.uploading-failed": "Y&#xFC;kl&#x259;nm&#x259; ba&#x15F;ar&#x131;s&#x131;z oldu - yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n bura vurun.",
                  "ba-audiorecorder.upload-error-duration": "Y&#xFC;kl&#x259;n&#x259;n audio uzunlu&#x11F;u t&#x259;l&#x259;bl&#x259;r&#x259; cavab vermir - yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya vurun.",
                  "ba-audiorecorder.verifying": "T&#x259;sdiql&#x259;m&#x259;",
                  "ba-audiorecorder.verifying-failed": "Do&#x11F;ru yoxlan&#x131;ld&#x131; - yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya vurun.",
                  "ba-audiorecorder.rerecord-confirm": "H&#x259;qiq&#x259;t&#x259;n s&#x259;sinizi t&#x259;krarlamaq ist&#x259;yirsiniz?",
                  "ba-audiorecorder.cancel-confirm": "H&#x259;qiq&#x259;t&#x259;n, audio y&#xFC;kl&#x259;m&#x259;ni l&#x259;&#x11F;v etm&#x259;k ist&#x259;yirsiniz?",
                  "ba-audiorecorder.audio_file_too_large": "Sizin audio fayl&#x131;n&#x131;z &#xE7;ox b&#xF6;y&#xFC;kd&#xFC;r (%s) - daha ki&#xE7;ik bir audio fayl&#x131; il&#x259; yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya vurun.",
                  "ba-audiorecorder.unsupported_audio_type": "Xahi&#x15F; edirik y&#xFC;kl&#x259;yin: %s - yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n buraya vurun.",
                  "ba-common-settingsmenu.tooltip": "Oynamaq &#xFC;&#xE7;&#xFC;n vurun.",
                  "ba-common-settingsmenu.setting-menu": "B&#xFC;t&#xFC;n parametrl&#x259;r",
                  "ba-common-settingsmenu.source-quality": "M&#x259;nb&#x259; keyfiyy&#x259;ti",
                  "ba-common-settingsmenu.player-speed": "Oyun&#xE7;u s&#xFC;r&#x259;ti",
                  "ba-common-settingsmenu.set-menu-option": "Se&#xE7;imi se&#xE7;in",
                  "ba-common-settingsmenu.submit-video": "Videonu t&#x259;sdiq edin",
                  "ba-common-settingsmenu.picture-in-picture": "&#x15E;&#x259;kild&#x259; &#x15F;&#x259;kil",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Tam ekrandan &#xE7;&#x131;x&#x131;n",
                  "ba-common-settingsmenu.fullscreen-video": "Tam ekrana daxil olun",
                  "ba-videorecorder-chooser.multi-stream": "&#xC7;ox ax&#x131;n",
                  "ba-videorecorder-controlbar.pause-recorder": "Yaz&#x131;c&#x131;y&#x131; dayand&#x131;r&#x131;n",
                  "ba-videorecorder-controlbar.resume-recorder": "Yaz&#x131;c&#x131;ya davam edin",
                  "ba-videorecorder.missing-track": "T&#x259;l&#x259;b olunan s&#x259;s v&#x259; ya video par&#xE7;as&#x131; yoxdur",
                  "ba-videorecorder.device-already-in-use": "Giri&#x15F; cihazlar&#x131;n&#x131;zdan &#x259;n az&#x131; biri art&#x131;q istifad&#x259;d&#x259;dir",
                  "ba-videorecorder.browser-permission-denied": "Brauzer t&#x259;r&#x259;find&#x259;n icaz&#x259; r&#x259;dd edildi, z&#x259;hm&#x259;t olmasa giri&#x15F; verin v&#x259; s&#x259;hif&#x259;ni yenid&#x259;n y&#xFC;kl&#x259;yin",
                  "ba-audioplayer.all-settings": "B&#xFC;t&#xFC;n parametrl&#x259;r",
                  "ba-videoplayer-controlbar.remaining-time": "Qalan vaxt",
                  "ba-videoplayer-controlbar.select-frame": "Se&#xE7;in",
                  "ba-videoplayer-controlbar.trim-video": "K&#x259;sin",
                  "ba-videoplayer-playbutton.trim": "K&#x259;sin",
                  "ba-videoplayer-playbutton.skip": "Ke&#xE7;",
                  "ba-videorecorder-imagegallery.upload-covershot": "Qapa&#x11F;&#x131; y&#xFC;kl&#x259;yin",
                  "ba-videorecorder.pick-covershot-frame": "&#xD6;rt&#xFC;k &#x15F;&#x259;klind&#x259; istifad&#x259; etm&#x259;k &#xFC;&#xE7;&#xFC;n bir &#xE7;&#x259;r&#xE7;iv&#x259; se&#xE7;in.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Ekran qeyd cihaz&#x131; bu cihazda d&#x259;st&#x259;kl&#x259;nmir",
                  "ba-videorecorder.trim-prompt": "Videonuzu k&#x259;sm&#x259;k ist&#x259;yirsiniz?",
                  "ba-videorecorder.trim-video": "Videonuzu d&#xFC;z&#x259;ltm&#x259;k &#xFC;&#xE7;&#xFC;n ba&#x15F;lan&#x11F;&#x131;c v&#x259; bitm&#x259; i&#x15F;ar&#x259;l&#x259;rini h&#x259;r&#x259;k&#x259;t etdirin",
                  "ba-videorecorder.wait-for-trim": "K&#x259;sm&#x259; &#x259;mri g&#xF6;zl&#x259;nilir ...",
                  "ba-videorecorder-controlbar.no-video-source": "&#x18F;lav&#x259; video giri&#x15F; m&#x259;nb&#x259;yi yoxdur",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x18F;lav&#x259; ax&#x131;n art&#x131;q se&#xE7;ilib",
                  "ba-videorecorder.uploading-src-error": "Videonu indi oxutmaq m&#xFC;mk&#xFC;n deyil, y&#xFC;kl&#x259;m&#x259; h&#x259;l&#x259; d&#x259; davam edir",
                  "ba-audiorecorder-controlbar.pause-recorder": "Yaz&#x131;c&#x131;y&#x131; durdurun",
                  "ba-audiorecorder-controlbar.resume-recorder": "Recume Recume"
                },
                "language:bg": {
                  "ba-videoplayer-playbutton.tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x438;&#x433;&#x440;&#x430;&#x44F;&#x442; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;.",
                  "ba-videoplayer-playbutton.rerecord": "&#x440;&#x435;&#x43C;&#x43E;&#x43D;&#x442;&#x438;&#x440;&#x430;&#x43C;",
                  "ba-videoplayer-playbutton.submit-video": "&#x41F;&#x43E;&#x442;&#x432;&#x44A;&#x440;&#x436;&#x434;&#x430;&#x432;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-loader.tooltip": "&#x417;&#x430;&#x440;&#x435;&#x436;&#x434;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E; ...",
                  "ba-videoplayer-controlbar.change-resolution": "&#x41F;&#x440;&#x43E;&#x43C;&#x44F;&#x43D;&#x430; &#x43D;&#x430; &#x440;&#x430;&#x437;&#x434;&#x435;&#x43B;&#x438;&#x442;&#x435;&#x43B;&#x43D;&#x430;&#x442;&#x430; &#x441;&#x43F;&#x43E;&#x441;&#x43E;&#x431;&#x43D;&#x43E;&#x441;&#x442;",
                  "ba-videoplayer-controlbar.video-progress": "&#x43F;&#x440;&#x43E;&#x433;&#x440;&#x435;&#x441; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.rerecord-video": "&#x412;&#x44A;&#x437;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x44F;&#x432;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;?",
                  "ba-videoplayer-controlbar.submit-video": "&#x41F;&#x43E;&#x442;&#x432;&#x44A;&#x440;&#x436;&#x434;&#x430;&#x432;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.play-video": "&#x432;&#x44A;&#x437;&#x43F;&#x440;&#x43E;&#x438;&#x437;&#x432;&#x435;&#x436;&#x434;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.pause-video": "Pause &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.elapsed-time": "&#x418;&#x437;&#x43C;&#x438;&#x43D;&#x430;&#x43B;&#x43E;&#x442;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435;",
                  "ba-videoplayer-controlbar.total-time": "&#x41E;&#x431;&#x449;&#x430; &#x434;&#x44A;&#x43B;&#x436;&#x438;&#x43D;&#x430; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.fullscreen-video": "&#x412;&#x44A;&#x432;&#x435;&#x434;&#x435;&#x442;&#x435; &#x446;&#x44F;&#x43B; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-videoplayer-controlbar.volume-button": "Set &#x43E;&#x431;&#x435;&#x43C;",
                  "ba-videoplayer-controlbar.volume-mute": "Mute &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer-controlbar.volume-unmute": "&#x438;&#x437;&#x43A;&#x43B;&#x44E;&#x447;&#x432;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x437;&#x432;&#x443;&#x43A;&#x430;",
                  "ba-videoplayer.video-error": "&#x412;&#x44A;&#x437;&#x43D;&#x438;&#x43A;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;. &#x41C;&#x43E;&#x43B;&#x44F;, &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x439;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;-&#x43A;&#x44A;&#x441;&#x43D;&#x43E;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-videorecorder-chooser.record-video": "&#x417;&#x430;&#x43F;&#x438;&#x448;&#x435;&#x442;&#x435; &#x432;&#x430;&#x448;&#x438;&#x442;&#x435; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-chooser.upload-video": "&#x41A;&#x430;&#x447;&#x438; &#x412;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-controlbar.settings": "&#x41D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-videorecorder-controlbar.camerahealthy": "&#x41E;&#x441;&#x432;&#x435;&#x442;&#x43B;&#x435;&#x43D;&#x438;&#x435;&#x442;&#x43E; &#x435; &#x434;&#x43E;&#x431;&#x440;&#x43E;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "&#x41E;&#x441;&#x432;&#x435;&#x442;&#x43B;&#x435;&#x43D;&#x438;&#x435; &#x43D;&#x435; &#x435; &#x43E;&#x43F;&#x442;&#x438;&#x43C;&#x430;&#x43B;&#x43D;&#x43E;",
                  "ba-videorecorder-controlbar.microphonehealthy": "&#x417;&#x432;&#x443;&#x43A;&#x44A;&#x442; &#x435; &#x434;&#x43E;&#x431;&#x44A;&#x440;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x432;&#x437;&#x435;&#x43C;&#x435;&#x442;&#x435; &#x432;&#x441;&#x435;&#x43A;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videorecorder-controlbar.record": "&#x440;&#x435;&#x43A;&#x43E;&#x440;&#x434;",
                  "ba-videorecorder-controlbar.record-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x437;&#x430;&#x43F;&#x438;&#x448;&#x435;&#x442;&#x435;.",
                  "ba-videorecorder-controlbar.rerecord": "&#x440;&#x435;&#x43C;&#x43E;&#x43D;&#x442;&#x438;&#x440;&#x430;&#x43C;",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x440;&#x435;&#x43C;&#x43E;&#x43D;&#x442;&#x438;&#x440;&#x430;&#x43C;.",
                  "ba-videorecorder-controlbar.upload-covershot": "&#x41A;&#x430;&#x447;&#x438;",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43A;&#x430;&#x447;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x442;&#x440;&#x435;&#x431;&#x438;&#x442;&#x435;&#x43B;&#x441;&#x43A;&#x438; &#x43F;&#x43E;&#x43A;&#x440;&#x438;&#x442;&#x438;&#x435; &#x443;&#x434;&#x430;&#x440;",
                  "ba-videorecorder-controlbar.stop": "&#x421;&#x43F;&#x440;&#x438; &#x441;&#x435;",
                  "ba-videorecorder-controlbar.stop-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x441;&#x43F;&#x440;&#x435;.",
                  "ba-videorecorder-controlbar.skip": "&#x43F;&#x43E;&#x434;&#x441;&#x43A;&#x430;&#x447;&#x430;&#x43C;",
                  "ba-videorecorder-controlbar.skip-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x43D;&#x435;&#x442;&#x435;.",
                  "ba-videorecorder.recorder-error": "&#x412;&#x44A;&#x437;&#x43D;&#x438;&#x43A;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;. &#x41C;&#x43E;&#x43B;&#x44F;, &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x439;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;-&#x43A;&#x44A;&#x441;&#x43D;&#x43E;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-videorecorder.attach-error": "&#x41D;&#x438;&#x435; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x43F;&#x43E;&#x43B;&#x443;&#x447;&#x438;&#x442;&#x435; &#x434;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x434;&#x43E; &#x438;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x439;&#x441;&#x430; &#x43D;&#x430; &#x43A;&#x430;&#x43C;&#x435;&#x440;&#x430;&#x442;&#x430;. &#x412; &#x437;&#x430;&#x432;&#x438;&#x441;&#x438;&#x43C;&#x43E;&#x441;&#x442; &#x43E;&#x442; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E;&#x442;&#x43E; &#x438; &#x431;&#x440;&#x430;&#x443;&#x437;&#x44A;&#x440;&#x430;, &#x43C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x441;&#x435; &#x43D;&#x430;&#x43B;&#x43E;&#x436;&#x438; &#x434;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; Flash &#x438;&#x43B;&#x438; &#x434;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x434;&#x43E; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430; &#x447;&#x440;&#x435;&#x437; SSL.",
                  "ba-videorecorder.access-forbidden": "&#x414;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x434;&#x43E; &#x43A;&#x430;&#x43C;&#x435;&#x440;&#x430;&#x442;&#x430; &#x435; &#x437;&#x430;&#x431;&#x440;&#x430;&#x43D;&#x435;&#x43D;&#x43E;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-videorecorder.pick-covershot": "&#x418;&#x437;&#x431;&#x435;&#x440;&#x435;&#x442;&#x435; covershot.",
                  "ba-videorecorder.uploading": "&#x41A;&#x430;&#x447;&#x432;&#x430;&#x43D;&#x435;",
                  "ba-videorecorder.uploading-failed": "&#x41A;&#x430;&#x447;&#x432;&#x430; &#x441;&#x435; &#x43F;&#x440;&#x43E;&#x432;&#x430;&#x43B;&#x438; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-videorecorder.verifying": "&#x41F;&#x440;&#x43E;&#x432;&#x435;&#x440;&#x43A;&#x430;",
                  "ba-videorecorder.verifying-failed": "&#x423;&#x434;&#x43E;&#x441;&#x442;&#x43E;&#x432;&#x435;&#x440;&#x44F;&#x432;&#x430;&#x43D;&#x435;&#x442;&#x43E; &#x441;&#x435; &#x43F;&#x440;&#x43E;&#x432;&#x430;&#x43B;&#x438; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-videorecorder.rerecord-confirm": "&#x41D;&#x430;&#x438;&#x441;&#x442;&#x438;&#x43D;&#x430; &#x43B;&#x438; &#x438;&#x441;&#x43A;&#x430;&#x442;&#x435; &#x434;&#x430; &#x440;&#x435;&#x43C;&#x43E;&#x43D;&#x442;&#x438;&#x440;&#x430;&#x43C; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x441;&#x438;?",
                  "ba-videorecorder.video_file_too_large": "&#x412;&#x430;&#x448;&#x438;&#x44F;&#x442; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x444;&#x430;&#x439;&#x43B; &#x435; &#x442;&#x432;&#x44A;&#x440;&#x434;&#x435; &#x433;&#x43E;&#x43B;&#x44F;&#x43C; (%s) - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E; &#x441; &#x43F;&#x43E;-&#x43C;&#x430;&#x43B;&#x44A;&#x43A; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x444;&#x430;&#x439;&#x43B;.",
                  "ba-videorecorder.unsupported_video_type": "&#x41C;&#x43E;&#x43B;&#x44F;, &#x43A;&#x430;&#x447;&#x435;&#x442;&#x435;: %s - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "&#x418;&#x437;&#x43B;&#x438;&#x437;&#x430;&#x43D;&#x435; &#x43E;&#x442; &#x446;&#x44F;&#x43B; &#x200B;&#x200B;&#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-videoplayer-share.share": "&#x421;&#x43F;&#x43E;&#x434;&#x435;&#x43B;&#x44F;&#x43D;&#x435; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x43A;&#x43B;&#x438;&#x43F;",
                  "ba-videorecorder-chooser.record-screen": "&#x415;&#x43A;&#x440;&#x430;&#x43D; &#x437;&#x430; &#x437;&#x430;&#x43F;&#x438;&#x441;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "&#x41F;&#x430;&#x443;&#x437;&#x430;&#x442;&#x430; &#x43D;&#x435; &#x441;&#x435; &#x43F;&#x43E;&#x434;&#x434;&#x44A;&#x440;&#x436;&#x430;",
                  "ba-videorecorder-chooser.record-audio": "&#x417;&#x430;&#x43F;&#x438;&#x441;&#x432;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x430;&#x443;&#x434;&#x438;&#x43E;",
                  "ba-videorecorder-controlbar.stop-available-after": "&#x41C;&#x438;&#x43D;&#x438;&#x43C;&#x430;&#x43B;&#x43D;&#x43E;&#x442;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435; &#x437;&#x430; &#x437;&#x430;&#x43F;&#x438;&#x441; &#x435; %d &#x441;&#x435;&#x43A;&#x443;&#x43D;&#x434;&#x438;",
                  "ba-videorecorder-controlbar.cancel": "&#x41E;&#x442;&#x43A;&#x430;&#x437;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x442;&#x43C;&#x435;&#x43D;&#x438;&#x442;&#x435;.",
                  "ba-videorecorder.cancel-confirm": "&#x41D;&#x430;&#x438;&#x441;&#x442;&#x438;&#x43D;&#x430; &#x43B;&#x438; &#x438;&#x441;&#x43A;&#x430;&#x442;&#x435; &#x434;&#x430; &#x430;&#x43D;&#x443;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; &#x43A;&#x430;&#x447;&#x432;&#x430;&#x43D;&#x435;&#x442;&#x43E; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x43A;&#x43B;&#x438;&#x43F;&#x430; &#x441;&#x438;?",
                  "ba-videoplayer-adslot.elapsed-time": "&#x418;&#x437;&#x43C;&#x438;&#x43D;&#x430;&#x43B;&#x43E;&#x442;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435;",
                  "ba-videoplayer-adslot.volume-button": "&#x417;&#x430;&#x434;&#x430;&#x439;&#x442;&#x435; &#x441;&#x438;&#x43B;&#x430; &#x43D;&#x430; &#x437;&#x432;&#x443;&#x43A;&#x430;",
                  "ba-videoplayer-adslot.volume-mute": "&#x421;&#x43F;&#x438;&#x440;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x437;&#x432;&#x443;&#x43A;&#x430;",
                  "ba-videoplayer-adslot.volume-unmute": "&#x417;&#x430;&#x433;&#x43B;&#x443;&#x448;&#x430;&#x432;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x437;&#x432;&#x443;&#x43A;&#x430;",
                  "ba-videoplayer-adslot.ad-will-end-after": "&#x420;&#x435;&#x43A;&#x43B;&#x430;&#x43C;&#x430;&#x442;&#x430; &#x449;&#x435; &#x43F;&#x440;&#x438;&#x43A;&#x43B;&#x44E;&#x447;&#x438; &#x441;&#x43B;&#x435;&#x434; %s",
                  "ba-videoplayer-adslot.can-skip-after": "&#x41F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x43D;&#x435;&#x442;&#x435; &#x441;&#x43B;&#x435;&#x434; %d",
                  "ba-videoplayer-adslot.skip-ad": "&#x41F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x431;&#x44F;&#x432;&#x430;",
                  "ba-videorecorder.software-required": "&#x41C;&#x43E;&#x43B;&#x44F;, &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43F;&#x43E;-&#x434;&#x43E;&#x43B;&#x443;, &#x437;&#x430; &#x434;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x442;&#x435; &#x441;&#x43B;&#x435;&#x434;&#x43D;&#x438;&#x442;&#x435; &#x438;&#x437;&#x438;&#x441;&#x43A;&#x432;&#x430;&#x43D;&#x438;&#x44F;, &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x434;&#x44A;&#x43B;&#x436;&#x438;&#x442;&#x435;.",
                  "ba-videorecorder.software-waiting": "&#x418;&#x437;&#x447;&#x430;&#x43A;&#x432;&#x430;&#x43D;&#x435; &#x437;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x43D;&#x435; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x438;&#x437;&#x438;&#x441;&#x43A;&#x432;&#x430;&#x43D;&#x438;&#x44F;&#x442;&#x430;. &#x41C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x441;&#x435; &#x43D;&#x430;&#x43B;&#x43E;&#x436;&#x438; &#x434;&#x430; &#x43E;&#x43F;&#x440;&#x435;&#x441;&#x43D;&#x438;&#x442;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430; &#x441;&#x43B;&#x435;&#x434; &#x437;&#x430;&#x432;&#x44A;&#x440;&#x448;&#x432;&#x430;&#x43D;&#x435;.",
                  "ba-videoplayer-controlbar.close-tracks": "&#x417;&#x430;&#x442;&#x432;&#x43E;&#x440;&#x435;&#x442;&#x435; CC",
                  "ba-videoplayer-controlbar.show-tracks": "&#x41F;&#x43E;&#x43A;&#x430;&#x436;&#x435;&#x442;&#x435; CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "&#x41A;&#x430;&#x447;&#x432;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x442;&#x435;&#x43A;&#x441;&#x442;&#x43E;&#x432;&#x438; &#x444;&#x430;&#x439;&#x43B;&#x43E;&#x432;&#x435; &#x43D;&#x430; &#x442;&#x435;&#x43A;&#x441;&#x442;&#x43E;&#x432;&#x435;",
                  "ba-videoplayer-tracks.select-text-track-language": "&#x415;&#x437;&#x438;&#x43A; &#x43D;&#x430; &#x441;&#x443;&#x431;&#x442;&#x438;&#x442;&#x440;&#x438;&#x442;&#x435;",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x41F;&#x44A;&#x440;&#x432;&#x43E; &#x438;&#x437;&#x431;&#x435;&#x440;&#x435;&#x442;&#x435; &#x43B;&#x43E;&#x43A;&#x430;&#x43B;",
                  "ba-videoplayer-tracks.select-text-track-file": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x438;&#x437;&#x431;&#x435;&#x440;&#x435;&#x442;&#x435; &#x444;&#x430;&#x439;&#x43B;",
                  "ba-videoplayer-tracks.back": "&#x43E;&#x431;&#x440;&#x430;&#x442;&#x43D;&#x43E;",
                  "ba-videorecorder.framerate-warning": "&#x421;&#x43A;&#x43E;&#x440;&#x43E;&#x441;&#x442;&#x442;&#x430; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x43A;&#x430;&#x43C;&#x435;&#x440;&#x430;&#x442;&#x430; &#x435; &#x43C;&#x43D;&#x43E;&#x433;&#x43E; &#x43D;&#x438;&#x441;&#x43A;&#x430;. &#x41F;&#x440;&#x435;&#x43F;&#x43E;&#x440;&#x44A;&#x447;&#x432;&#x430;&#x43C;&#x435; &#x434;&#x430; &#x437;&#x430;&#x442;&#x432;&#x43E;&#x440;&#x438;&#x442;&#x435; &#x432;&#x441;&#x438;&#x447;&#x43A;&#x438; &#x434;&#x440;&#x443;&#x433;&#x438; &#x43F;&#x440;&#x43E;&#x433;&#x440;&#x430;&#x43C;&#x438; &#x438; &#x440;&#x430;&#x437;&#x434;&#x435;&#x43B;&#x438; &#x432; &#x431;&#x440;&#x430;&#x443;&#x437;&#x44A;&#x440;&#x430; &#x438;&#x43B;&#x438; &#x434;&#x430; &#x438;&#x437;&#x43F;&#x43E;&#x43B;&#x437;&#x432;&#x430;&#x442;&#x435; &#x43F;&#x43E;-&#x431;&#x44A;&#x440;&#x437; &#x43A;&#x43E;&#x43C;&#x43F;&#x44E;&#x442;&#x44A;&#x440;.",
                  "ba-videorecorder.upload-error-duration": "&#x41F;&#x440;&#x43E;&#x434;&#x44A;&#x43B;&#x436;&#x438;&#x442;&#x435;&#x43B;&#x43D;&#x43E;&#x441;&#x442;&#x442;&#x430; &#x43D;&#x430; &#x43A;&#x430;&#x447;&#x435;&#x43D;&#x438;&#x44F; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x43A;&#x43B;&#x438;&#x43F; &#x43D;&#x435; &#x43E;&#x442;&#x433;&#x43E;&#x432;&#x430;&#x440;&#x44F; &#x43D;&#x430; &#x438;&#x437;&#x438;&#x441;&#x43A;&#x432;&#x430;&#x43D;&#x438;&#x44F;&#x442;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-videorecorder.resolution-constraint-error": "&#x418;&#x437;&#x431;&#x440;&#x430;&#x43D;&#x438;&#x44F;&#x442; &#x43E;&#x442; &#x432;&#x430;&#x441; &#x444;&#x430;&#x439;&#x43B; &#x43D;&#x435; &#x441;&#x44A;&#x43E;&#x442;&#x432;&#x435;&#x442;&#x441;&#x442;&#x432;&#x430; &#x43D;&#x430; &#x438;&#x437;&#x438;&#x441;&#x43A;&#x432;&#x430;&#x43D;&#x430;&#x442;&#x430; &#x440;&#x435;&#x437;&#x43E;&#x43B;&#x44E;&#x446;&#x438;&#x44F; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-videorecorder.orientation-portrait-required": "&#x41C;&#x43E;&#x43B;&#x44F;, &#x437;&#x430;&#x432;&#x44A;&#x440;&#x442;&#x435;&#x442;&#x435; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E;&#x442;&#x43E; &#x441;&#x438;, &#x437;&#x430; &#x434;&#x430; &#x433;&#x43E; &#x437;&#x430;&#x43F;&#x438;&#x448;&#x435;&#x442;&#x435; &#x432; &#x43F;&#x43E;&#x440;&#x442;&#x440;&#x435;&#x442;&#x435;&#x43D; &#x440;&#x435;&#x436;&#x438;&#x43C;.",
                  "ba-videorecorder.orientation-landscape-required": "&#x41C;&#x43E;&#x43B;&#x44F;, &#x437;&#x430;&#x432;&#x44A;&#x440;&#x442;&#x435;&#x442;&#x435; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E;&#x442;&#x43E; &#x441;&#x438;, &#x437;&#x430; &#x434;&#x430; &#x433;&#x43E; &#x437;&#x430;&#x43F;&#x438;&#x448;&#x435;&#x442;&#x435; &#x432; &#x440;&#x435;&#x436;&#x438;&#x43C; &#x43D;&#x430; &#x43F;&#x435;&#x439;&#x437;&#x430;&#x436;.",
                  "ba-imageviewer-controlbar.rerecord-image": "&#x412;&#x44A;&#x437;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x44F;&#x432;&#x430;&#x43D;&#x435;?",
                  "ba-imageviewer-controlbar.submit-image": "&#x43F;&#x43E;&#x442;&#x432;&#x44A;&#x440;&#x436;&#x434;&#x430;&#x432;&#x430;&#x43C;",
                  "ba-imageviewer-controlbar.fullscreen-image": "&#x412;&#x44A;&#x432;&#x435;&#x434;&#x435;&#x442;&#x435; &#x446;&#x435;&#x43B;&#x438;&#x44F; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "&#x418;&#x437;&#x43B;&#x438;&#x437;&#x430;&#x43D;&#x435; &#x43E;&#x442; &#x446;&#x44F;&#x43B; &#x200B;&#x200B;&#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-imageviewer.image-error": "&#x412;&#x44A;&#x437;&#x43D;&#x438;&#x43A;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;. &#x41C;&#x43E;&#x43B;&#x44F;, &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x439;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;-&#x43A;&#x44A;&#x441;&#x43D;&#x43E;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture-chooser.image-capture": "&#x417;&#x430;&#x441;&#x43D;&#x435;&#x43C;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435;",
                  "ba-imagecapture-chooser.upload-image": "&#x41A;&#x430;&#x447;&#x438; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435;",
                  "ba-imagecapture-controlbar.settings": "&#x41D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-imagecapture-controlbar.camerahealthy": "&#x41E;&#x441;&#x432;&#x435;&#x442;&#x43B;&#x435;&#x43D;&#x438;&#x435;&#x442;&#x43E; &#x435; &#x434;&#x43E;&#x431;&#x440;&#x43E;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "&#x41E;&#x441;&#x432;&#x435;&#x442;&#x43B;&#x435;&#x43D;&#x438;&#x435;&#x442;&#x43E; &#x43D;&#x435; &#x435; &#x43E;&#x43F;&#x442;&#x438;&#x43C;&#x430;&#x43B;&#x43D;&#x43E;",
                  "ba-imagecapture-controlbar.record": "&#x423;&#x43B;&#x430;&#x432;&#x44F;&#x43D;&#x435;",
                  "ba-imagecapture-controlbar.record-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x437;&#x430;&#x441;&#x43D;&#x435;&#x43C;&#x435;&#x442;&#x435;.",
                  "ba-imagecapture-controlbar.rerecord": "&#x440;&#x435;&#x43C;&#x43E;&#x43D;&#x442;&#x438;&#x440;&#x430;&#x43C;",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x435;.",
                  "ba-imagecapture-controlbar.cancel": "&#x41E;&#x442;&#x43A;&#x430;&#x437;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x442;&#x43C;&#x435;&#x43D;&#x438;&#x442;&#x435;.",
                  "ba-audioplayer-controlbar.audio-progress": "&#x43F;&#x440;&#x43E;&#x433;&#x440;&#x435;&#x441;",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#x412;&#x44A;&#x437;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x44F;&#x432;&#x430;&#x43D;&#x435;?",
                  "ba-audioplayer-controlbar.submit-audio": "&#x43F;&#x43E;&#x442;&#x432;&#x44A;&#x440;&#x436;&#x434;&#x430;&#x432;&#x430;&#x43C;",
                  "ba-audioplayer-controlbar.play-audio": "&#x438;&#x433;&#x440;&#x430;&#x44F;",
                  "ba-audioplayer-controlbar.pause-audio": "&#x43F;&#x430;&#x443;&#x437;&#x430;",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "&#x41F;&#x430;&#x443;&#x437;&#x430;&#x442;&#x430; &#x43D;&#x435; &#x441;&#x435; &#x43F;&#x43E;&#x434;&#x434;&#x44A;&#x440;&#x436;&#x430;",
                  "ba-audioplayer-controlbar.elapsed-time": "&#x418;&#x437;&#x43C;&#x438;&#x43D;&#x430;&#x43B;&#x43E;&#x442;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435;",
                  "ba-audioplayer-controlbar.total-time": "&#x41E;&#x431;&#x449;&#x430; &#x434;&#x44A;&#x43B;&#x436;&#x438;&#x43D;&#x430;",
                  "ba-audioplayer-controlbar.volume-button": "&#x417;&#x430;&#x434;&#x430;&#x439;&#x442;&#x435; &#x441;&#x438;&#x43B;&#x430; &#x43D;&#x430; &#x437;&#x432;&#x443;&#x43A;&#x430;",
                  "ba-audioplayer-controlbar.volume-mute": "&#x421;&#x43F;&#x438;&#x440;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x437;&#x432;&#x443;&#x43A;&#x430;",
                  "ba-audioplayer-controlbar.volume-unmute": "&#x417;&#x430;&#x433;&#x43B;&#x443;&#x448;&#x430;&#x432;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x437;&#x432;&#x443;&#x43A;&#x430;",
                  "ba-audioplayer-loader.tooltip": "&#x417;&#x430;&#x440;&#x435;&#x436;&#x434;&#x430;&#x43D;&#x435;...",
                  "ba-audioplayer.audio-error": "&#x412;&#x44A;&#x437;&#x43D;&#x438;&#x43A;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;. &#x41C;&#x43E;&#x43B;&#x44F;, &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x439;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;-&#x43A;&#x44A;&#x441;&#x43D;&#x43E;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-audiorecorder-chooser.record-audio": "&#x417;&#x430;&#x43F;&#x438;&#x441;&#x432;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x430;&#x443;&#x434;&#x438;&#x43E;",
                  "ba-audiorecorder-chooser.upload-audio": "&#x41A;&#x430;&#x447;&#x435;&#x442;&#x435; &#x430;&#x443;&#x434;&#x438;&#x43E;",
                  "ba-audiorecorder-controlbar.settings": "&#x41D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "&#x417;&#x432;&#x443;&#x43A;&#x44A;&#x442; &#x435; &#x434;&#x43E;&#x431;&#x44A;&#x440;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x441;&#x435; &#x447;&#x443;&#x435; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audiorecorder-controlbar.record": "&#x440;&#x435;&#x43A;&#x43E;&#x440;&#x434;",
                  "ba-audiorecorder-controlbar.record-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x437;&#x430;&#x43F;&#x438;&#x448;&#x435;&#x442;&#x435;.",
                  "ba-audiorecorder-controlbar.rerecord": "&#x440;&#x435;&#x43C;&#x43E;&#x43D;&#x442;&#x438;&#x440;&#x430;&#x43C;",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x435;.",
                  "ba-audiorecorder-controlbar.stop": "&#x421;&#x43F;&#x440;&#x438; &#x441;&#x435;",
                  "ba-audiorecorder-controlbar.stop-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x441;&#x43F;&#x440;&#x435;&#x442;&#x435;.",
                  "ba-audiorecorder-controlbar.stop-available-after": "&#x41C;&#x438;&#x43D;&#x438;&#x43C;&#x430;&#x43B;&#x43D;&#x43E;&#x442;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435; &#x437;&#x430; &#x437;&#x430;&#x43F;&#x438;&#x441; &#x435; %d &#x441;&#x435;&#x43A;&#x443;&#x43D;&#x434;&#x438;",
                  "ba-audiorecorder-controlbar.cancel": "&#x41E;&#x442;&#x43A;&#x430;&#x437;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x442;&#x43C;&#x435;&#x43D;&#x438;&#x442;&#x435;.",
                  "ba-videoplayer-controlbar.player-speed": "&#x421;&#x43A;&#x43E;&#x440;&#x43E;&#x441;&#x442; &#x43D;&#x430; &#x438;&#x433;&#x440;&#x430;&#x447;&#x430;",
                  "ba-videoplayer-controlbar.settings": "&#x41D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "&#x418;&#x43A;&#x43E;&#x43D;&#x430; &#x43D;&#x430; &#x435;&#x444;&#x438;&#x440;&#x430;.",
                  "ba-videoplayer.all-settings": "&#x412;&#x441;&#x438;&#x447;&#x43A;&#x438; &#x43D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-videoplayer.player-speed": "&#x421;&#x43A;&#x43E;&#x440;&#x43E;&#x441;&#x442; &#x43D;&#x430; &#x438;&#x433;&#x440;&#x430;&#x447;&#x430;",
                  "ba-videoplayer.full-screen": "&#x426;&#x44F;&#x43B; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-videorecorder-controlbar.add-stream": "&#x414;&#x43E;&#x431;&#x430;&#x432;&#x435;&#x442;&#x435; &#x41F;&#x43E;&#x442;&#x43E;&#x43A;",
                  "ba-videorecorder.switch-camera": "&#x41F;&#x440;&#x435;&#x432;&#x43A;&#x43B;&#x44E;&#x447;&#x432;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x43A;&#x430;&#x43C;&#x435;&#x440;&#x430;&#x442;&#x430;",
                  "ba-videorecorder.prepare-covershot": "&#x41F;&#x43E;&#x434;&#x433;&#x43E;&#x442;&#x43E;&#x432;&#x43A;&#x430; &#x437;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x43A;&#x438;",
                  "ba-videorecorder.prepare-thumbnails": "&#x41F;&#x43E;&#x434;&#x433;&#x43E;&#x442;&#x43E;&#x432;&#x43A;&#x430; &#x437;&#x430; &#x442;&#x44A;&#x440;&#x441;&#x435;&#x43D;&#x435; &#x43D;&#x430; &#x43C;&#x438;&#x43D;&#x438;&#x430;&#x442;&#x44E;&#x440;&#x438;",
                  "ba-videorecorder.adding-new-stream": "&#x414;&#x43E;&#x431;&#x430;&#x432;&#x44F;&#x43D;&#x435; &#x43D;&#x430; &#x43D;&#x43E;&#x432; &#x43F;&#x43E;&#x442;&#x43E;&#x43A;",
                  "ba-imagecapture.recorder-error": "&#x412;&#x44A;&#x437;&#x43D;&#x438;&#x43A;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;. &#x41C;&#x43E;&#x43B;&#x44F;, &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x439;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;-&#x43A;&#x44A;&#x441;&#x43D;&#x43E;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.attach-error": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x430;&#x445;&#x43C;&#x435; &#x434;&#x430; &#x43E;&#x441;&#x44A;&#x449;&#x435;&#x441;&#x442;&#x432;&#x438;&#x43C; &#x434;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x434;&#x43E; &#x43C;&#x435;&#x434;&#x438;&#x439;&#x43D;&#x438;&#x44F; &#x438;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x439;&#x441;. &#x412; &#x437;&#x430;&#x432;&#x438;&#x441;&#x438;&#x43C;&#x43E;&#x441;&#x442; &#x43E;&#x442; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E;&#x442;&#x43E; &#x438; &#x431;&#x440;&#x430;&#x443;&#x437;&#x44A;&#x440;&#x430; &#x43C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x441;&#x435; &#x43D;&#x430;&#x43B;&#x43E;&#x436;&#x438; &#x434;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; Flash &#x438;&#x43B;&#x438; &#x434;&#x430; &#x432;&#x43B;&#x435;&#x437;&#x435;&#x442;&#x435; &#x432; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430; &#x447;&#x440;&#x435;&#x437; SSL.",
                  "ba-imagecapture.software-required": "&#x41C;&#x43E;&#x43B;&#x44F;, &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43F;&#x43E;-&#x434;&#x43E;&#x43B;&#x443;, &#x437;&#x430; &#x434;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x442;&#x435; &#x441;&#x43B;&#x435;&#x434;&#x43D;&#x438;&#x442;&#x435; &#x438;&#x437;&#x438;&#x441;&#x43A;&#x432;&#x430;&#x43D;&#x438;&#x44F;, &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x434;&#x44A;&#x43B;&#x436;&#x438;&#x442;&#x435;.",
                  "ba-imagecapture.software-waiting": "&#x418;&#x437;&#x447;&#x430;&#x43A;&#x432;&#x430;&#x43D;&#x435; &#x437;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x43D;&#x435; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x438;&#x437;&#x438;&#x441;&#x43A;&#x432;&#x430;&#x43D;&#x438;&#x44F;&#x442;&#x430;. &#x41C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x441;&#x435; &#x43D;&#x430;&#x43B;&#x43E;&#x436;&#x438; &#x434;&#x430; &#x43E;&#x431;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430; &#x441;&#x43B;&#x435;&#x434; &#x437;&#x430;&#x432;&#x44A;&#x440;&#x448;&#x432;&#x430;&#x43D;&#x435;.",
                  "ba-imagecapture.access-forbidden": "&#x414;&#x43E;&#x441;&#x442;&#x44A;&#x43F;&#x44A;&#x442; &#x434;&#x43E; &#x43C;&#x435;&#x434;&#x438;&#x438;&#x442;&#x435; &#x435; &#x437;&#x430;&#x431;&#x440;&#x430;&#x43D;&#x435;&#x43D;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.uploading": "&#x41A;&#x430;&#x447;&#x432;&#x430;&#x43D;&#x435;",
                  "ba-imagecapture.uploading-failed": "&#x41D;&#x435;&#x443;&#x441;&#x43F;&#x435;&#x448;&#x43D;&#x43E; &#x43A;&#x430;&#x447;&#x432;&#x430;&#x43D;&#x435; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.upload-error-duration": "&#x414;&#x44A;&#x43B;&#x436;&#x438;&#x43D;&#x430;&#x442;&#x430; &#x43D;&#x430; &#x43A;&#x430;&#x447;&#x435;&#x43D;&#x43E;&#x442;&#x43E; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435; &#x43D;&#x435; &#x43E;&#x442;&#x433;&#x43E;&#x432;&#x430;&#x440;&#x44F; &#x43D;&#x430; &#x438;&#x437;&#x438;&#x441;&#x43A;&#x432;&#x430;&#x43D;&#x438;&#x44F;&#x442;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.resolution-constraint-error": "&#x418;&#x437;&#x431;&#x440;&#x430;&#x43D;&#x438;&#x44F;&#x442; &#x43E;&#x442; &#x432;&#x430;&#x441; &#x444;&#x430;&#x439;&#x43B; &#x43D;&#x435; &#x441;&#x44A;&#x43E;&#x442;&#x432;&#x435;&#x442;&#x441;&#x442;&#x432;&#x430; &#x43D;&#x430; &#x438;&#x437;&#x438;&#x441;&#x43A;&#x432;&#x430;&#x43D;&#x430;&#x442;&#x430; &#x440;&#x435;&#x437;&#x43E;&#x43B;&#x44E;&#x446;&#x438;&#x44F; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.verifying": "&#x41F;&#x440;&#x43E;&#x432;&#x435;&#x440;&#x43A;&#x430;",
                  "ba-imagecapture.verifying-failed": "&#x41F;&#x440;&#x43E;&#x432;&#x435;&#x440;&#x43A;&#x430;&#x442;&#x430; &#x435; &#x43D;&#x435;&#x443;&#x441;&#x43F;&#x435;&#x448;&#x43D;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.rerecord-confirm": "&#x41D;&#x430;&#x438;&#x441;&#x442;&#x438;&#x43D;&#x430; &#x43B;&#x438; &#x438;&#x441;&#x43A;&#x430;&#x442;&#x435; &#x434;&#x430; &#x432;&#x44A;&#x437;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x435; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435;&#x442;&#x43E; &#x441;&#x438;?",
                  "ba-imagecapture.image_file_too_large": "&#x412;&#x430;&#x448;&#x438;&#x44F;&#x442; &#x444;&#x430;&#x439;&#x43B; &#x441; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435; &#x435; &#x442;&#x432;&#x44A;&#x440;&#x434;&#x435; &#x433;&#x43E;&#x43B;&#x44F;&#x43C; (%s) - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E; &#x441; &#x43F;&#x43E;-&#x43C;&#x430;&#x43B;&#x44A;&#x43A; &#x444;&#x430;&#x439;&#x43B; &#x441; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435;.",
                  "ba-imagecapture.unsupported_image_type": "&#x41C;&#x43E;&#x43B;&#x44F;, &#x43A;&#x430;&#x447;&#x435;&#x442;&#x435;: %s - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.orientation-portrait-required": "&#x417;&#x430;&#x432;&#x44A;&#x440;&#x442;&#x435;&#x442;&#x435; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E;&#x442;&#x43E;, &#x437;&#x430; &#x434;&#x430; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x432;&#x430;&#x442;&#x435; &#x432; &#x43F;&#x43E;&#x440;&#x442;&#x440;&#x435;&#x442;&#x435;&#x43D; &#x440;&#x435;&#x436;&#x438;&#x43C;.",
                  "ba-imagecapture.orientation-landscape-required": "&#x417;&#x430;&#x432;&#x44A;&#x440;&#x442;&#x435;&#x442;&#x435; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E;&#x442;&#x43E;, &#x437;&#x430; &#x434;&#x430; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x432;&#x430;&#x442;&#x435; &#x432; &#x43F;&#x435;&#x439;&#x437;&#x430;&#x436;&#x435;&#x43D; &#x440;&#x435;&#x436;&#x438;&#x43C;.",
                  "ba-audiorecorder.recorder-error": "&#x412;&#x44A;&#x437;&#x43D;&#x438;&#x43A;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;. &#x41C;&#x43E;&#x43B;&#x44F;, &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x439;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;-&#x43A;&#x44A;&#x441;&#x43D;&#x43E;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-audiorecorder.attach-error": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x430;&#x445;&#x43C;&#x435; &#x434;&#x430; &#x43E;&#x441;&#x44A;&#x449;&#x435;&#x441;&#x442;&#x432;&#x438;&#x43C; &#x434;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x434;&#x43E; &#x43C;&#x435;&#x434;&#x438;&#x439;&#x43D;&#x438;&#x44F; &#x438;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x439;&#x441;. &#x412; &#x437;&#x430;&#x432;&#x438;&#x441;&#x438;&#x43C;&#x43E;&#x441;&#x442; &#x43E;&#x442; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E;&#x442;&#x43E; &#x438; &#x431;&#x440;&#x430;&#x443;&#x437;&#x44A;&#x440;&#x430; &#x43C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x441;&#x435; &#x43D;&#x430;&#x43B;&#x43E;&#x436;&#x438; &#x434;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; Flash &#x438;&#x43B;&#x438; &#x434;&#x430; &#x432;&#x43B;&#x435;&#x437;&#x435;&#x442;&#x435; &#x432; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430; &#x447;&#x440;&#x435;&#x437; SSL.",
                  "ba-audiorecorder.software-required": "&#x41C;&#x43E;&#x43B;&#x44F;, &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43F;&#x43E;-&#x434;&#x43E;&#x43B;&#x443;, &#x437;&#x430; &#x434;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x442;&#x435; &#x441;&#x43B;&#x435;&#x434;&#x43D;&#x438;&#x442;&#x435; &#x438;&#x437;&#x438;&#x441;&#x43A;&#x432;&#x430;&#x43D;&#x438;&#x44F;, &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x434;&#x44A;&#x43B;&#x436;&#x438;&#x442;&#x435;.",
                  "ba-audiorecorder.software-waiting": "&#x418;&#x437;&#x447;&#x430;&#x43A;&#x432;&#x430;&#x43D;&#x435; &#x437;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x43D;&#x435; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x438;&#x437;&#x438;&#x441;&#x43A;&#x432;&#x430;&#x43D;&#x438;&#x44F;&#x442;&#x430;. &#x41C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x441;&#x435; &#x43D;&#x430;&#x43B;&#x43E;&#x436;&#x438; &#x434;&#x430; &#x43E;&#x431;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430; &#x441;&#x43B;&#x435;&#x434; &#x437;&#x430;&#x432;&#x44A;&#x440;&#x448;&#x432;&#x430;&#x43D;&#x435;.",
                  "ba-audiorecorder.access-forbidden": "&#x414;&#x43E;&#x441;&#x442;&#x44A;&#x43F;&#x44A;&#x442; &#x434;&#x43E; &#x43C;&#x435;&#x434;&#x438;&#x438;&#x442;&#x435; &#x435; &#x437;&#x430;&#x431;&#x440;&#x430;&#x43D;&#x435;&#x43D;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-audiorecorder.uploading": "&#x41A;&#x430;&#x447;&#x432;&#x430;&#x43D;&#x435;",
                  "ba-audiorecorder.uploading-failed": "&#x41D;&#x435;&#x443;&#x441;&#x43F;&#x435;&#x448;&#x43D;&#x43E; &#x43A;&#x430;&#x447;&#x432;&#x430;&#x43D;&#x435; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-audiorecorder.upload-error-duration": "&#x414;&#x44A;&#x43B;&#x436;&#x438;&#x43D;&#x430;&#x442;&#x430; &#x43D;&#x430; &#x43A;&#x430;&#x447;&#x435;&#x43D;&#x438;&#x44F; &#x437;&#x432;&#x443;&#x43A; &#x43D;&#x435; &#x43E;&#x442;&#x433;&#x43E;&#x432;&#x430;&#x440;&#x44F; &#x43D;&#x430; &#x438;&#x437;&#x438;&#x441;&#x43A;&#x432;&#x430;&#x43D;&#x438;&#x44F;&#x442;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-audiorecorder.verifying": "&#x41F;&#x440;&#x43E;&#x432;&#x435;&#x440;&#x43A;&#x430;",
                  "ba-audiorecorder.verifying-failed": "&#x41F;&#x440;&#x43E;&#x432;&#x435;&#x440;&#x43A;&#x430;&#x442;&#x430; &#x435; &#x43D;&#x435;&#x443;&#x441;&#x43F;&#x435;&#x448;&#x43D;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-audiorecorder.rerecord-confirm": "&#x41D;&#x430;&#x438;&#x441;&#x442;&#x438;&#x43D;&#x430; &#x43B;&#x438; &#x438;&#x441;&#x43A;&#x430;&#x442;&#x435; &#x434;&#x430; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x435; &#x430;&#x443;&#x434;&#x438;&#x43E;&#x442;&#x43E; &#x441;&#x438;?",
                  "ba-audiorecorder.cancel-confirm": "&#x41D;&#x430;&#x438;&#x441;&#x442;&#x438;&#x43D;&#x430; &#x43B;&#x438; &#x438;&#x441;&#x43A;&#x430;&#x442;&#x435; &#x434;&#x430; &#x430;&#x43D;&#x443;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; &#x43A;&#x430;&#x447;&#x432;&#x430;&#x43D;&#x435;&#x442;&#x43E; &#x43D;&#x430; &#x437;&#x432;&#x443;&#x43A;?",
                  "ba-audiorecorder.audio_file_too_large": "&#x410;&#x443;&#x434;&#x438;&#x43E;&#x444;&#x430;&#x439;&#x43B;&#x44A;&#x442; &#x432;&#x438; &#x435; &#x442;&#x432;&#x44A;&#x440;&#x434;&#x435; &#x433;&#x43E;&#x43B;&#x44F;&#x43C; (%s) - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E; &#x441; &#x43F;&#x43E;-&#x43C;&#x430;&#x43B;&#x44A;&#x43A; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x444;&#x430;&#x439;&#x43B;.",
                  "ba-audiorecorder.unsupported_audio_type": "&#x41C;&#x43E;&#x43B;&#x44F;, &#x43A;&#x430;&#x447;&#x435;&#x442;&#x435;: %s - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-common-settingsmenu.tooltip": "&#x429;&#x440;&#x430;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x438;&#x433;&#x440;&#x430;&#x435;&#x442;&#x435;.",
                  "ba-common-settingsmenu.setting-menu": "&#x412;&#x441;&#x438;&#x447;&#x43A;&#x438; &#x43D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-common-settingsmenu.source-quality": "&#x41A;&#x430;&#x447;&#x435;&#x441;&#x442;&#x432;&#x43E; &#x43D;&#x430; &#x438;&#x437;&#x442;&#x43E;&#x447;&#x43D;&#x438;&#x43A;&#x430;",
                  "ba-common-settingsmenu.player-speed": "&#x421;&#x43A;&#x43E;&#x440;&#x43E;&#x441;&#x442; &#x43D;&#x430; &#x438;&#x433;&#x440;&#x430;&#x447;&#x430;",
                  "ba-common-settingsmenu.set-menu-option": "&#x417;&#x430;&#x434;&#x430;&#x439;&#x442;&#x435; &#x43E;&#x43F;&#x446;&#x438;&#x44F;",
                  "ba-common-settingsmenu.submit-video": "&#x41F;&#x43E;&#x442;&#x432;&#x44A;&#x440;&#x434;&#x435;&#x442;&#x435; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x43A;&#x43B;&#x438;&#x43F;&#x430;",
                  "ba-common-settingsmenu.picture-in-picture": "&#x41A;&#x430;&#x440;&#x442;&#x438;&#x43D;&#x430; &#x432; &#x43A;&#x430;&#x440;&#x442;&#x438;&#x43D;&#x430;",
                  "ba-common-settingsmenu.exit-fullscreen-video": "&#x418;&#x437;&#x43B;&#x435;&#x437;&#x442;&#x435; &#x43E;&#x442; &#x446;&#x44F;&#x43B; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-common-settingsmenu.fullscreen-video": "&#x412;&#x44A;&#x432;&#x435;&#x434;&#x435;&#x442;&#x435; &#x446;&#x44F;&#x43B; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-videorecorder-chooser.multi-stream": "Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "&#x41F;&#x430;&#x443;&#x437;&#x430; &#x43D;&#x430; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x432;&#x430;&#x449;&#x43E;&#x442;&#x43E; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E;",
                  "ba-videorecorder-controlbar.resume-recorder": "&#x420;&#x435;&#x43A;&#x43E;&#x440;&#x434;&#x435;&#x440; &#x437;&#x430; &#x432;&#x44A;&#x437;&#x43E;&#x431;&#x43D;&#x43E;&#x432;&#x44F;&#x432;&#x430;&#x43D;&#x435;",
                  "ba-videorecorder.missing-track": "&#x41B;&#x438;&#x43F;&#x441;&#x432;&#x430; &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x43E;&#x434;&#x438;&#x43C;&#x430;&#x442;&#x430; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x438;&#x43B;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x43F;&#x435;&#x441;&#x435;&#x43D;",
                  "ba-videorecorder.device-already-in-use": "&#x41F;&#x43E;&#x43D;&#x435; &#x435;&#x434;&#x43D;&#x43E; &#x43E;&#x442; &#x432;&#x430;&#x448;&#x438;&#x442;&#x435; &#x432;&#x445;&#x43E;&#x434;&#x43D;&#x438; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x430; &#x432;&#x435;&#x447;&#x435; &#x441;&#x435; &#x438;&#x437;&#x43F;&#x43E;&#x43B;&#x437;&#x432;&#x430;",
                  "ba-videorecorder.browser-permission-denied": "&#x420;&#x430;&#x437;&#x440;&#x435;&#x448;&#x435;&#x43D;&#x438;&#x435;&#x442;&#x43E; &#x435; &#x43E;&#x442;&#x43A;&#x430;&#x437;&#x430;&#x43D;&#x43E; &#x43E;&#x442; &#x431;&#x440;&#x430;&#x443;&#x437;&#x44A;&#x440;&#x430;, &#x43C;&#x43E;&#x43B;&#x44F;, &#x43F;&#x440;&#x435;&#x434;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435; &#x434;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x438; &#x43F;&#x440;&#x435;&#x437;&#x430;&#x440;&#x435;&#x434;&#x435;&#x442;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430;",
                  "ba-audioplayer.all-settings": "&#x412;&#x441;&#x438;&#x447;&#x43A;&#x438; &#x43D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-videoplayer-controlbar.remaining-time": "&#x41E;&#x441;&#x442;&#x430;&#x432;&#x430;&#x449;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435;",
                  "ba-videoplayer-controlbar.select-frame": "&#x418;&#x437;&#x431;&#x435;&#x440;&#x435;&#x442;&#x435;",
                  "ba-videoplayer-controlbar.trim-video": "&#x41F;&#x43E;&#x434;&#x441;&#x442;&#x440;&#x438;&#x433;&#x432;&#x430;&#x43D;&#x435;",
                  "ba-videoplayer-playbutton.trim": "&#x41F;&#x43E;&#x434;&#x441;&#x442;&#x440;&#x438;&#x433;&#x432;&#x430;&#x43D;&#x435;",
                  "ba-videoplayer-playbutton.skip": "&#x41F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x43D;&#x435;&#x442;&#x435;",
                  "ba-videorecorder-imagegallery.upload-covershot": "&#x41A;&#x430;&#x447;&#x432;&#x430;&#x43D;&#x435; &#x43D;&#x430; &#x43A;&#x43E;&#x440;&#x438;&#x446;&#x430;&#x442;&#x430;",
                  "ba-videorecorder.pick-covershot-frame": "&#x418;&#x437;&#x431;&#x435;&#x440;&#x435;&#x442;&#x435; &#x440;&#x430;&#x43C;&#x43A;&#x430;, &#x43A;&#x43E;&#x44F;&#x442;&#x43E; &#x434;&#x430; &#x438;&#x437;&#x43F;&#x43E;&#x43B;&#x437;&#x432;&#x430;&#x442;&#x435; &#x43A;&#x430;&#x442;&#x43E; &#x441;&#x43D;&#x438;&#x43C;&#x43A;&#x430; &#x43D;&#x430; &#x43A;&#x43E;&#x440;&#x438;&#x446;&#x430;&#x442;&#x430;.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "&#x422;&#x43E;&#x432;&#x430; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E; &#x43D;&#x435; &#x43F;&#x43E;&#x434;&#x434;&#x44A;&#x440;&#x436;&#x430; &#x435;&#x43A;&#x440;&#x430;&#x43D;&#x435;&#x43D; &#x440;&#x435;&#x43A;&#x43E;&#x440;&#x434;&#x435;&#x440;",
                  "ba-videorecorder.trim-prompt": "&#x418;&#x441;&#x43A;&#x430;&#x442;&#x435; &#x43B;&#x438; &#x434;&#x430; &#x43E;&#x442;&#x440;&#x435;&#x436;&#x435;&#x442;&#x435; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x43A;&#x43B;&#x438;&#x43F;&#x430; &#x441;&#x438;?",
                  "ba-videorecorder.trim-video": "&#x41F;&#x440;&#x435;&#x43C;&#x435;&#x441;&#x442;&#x435;&#x442;&#x435; &#x43C;&#x430;&#x440;&#x43A;&#x435;&#x440;&#x438;&#x442;&#x435; &#x437;&#x430; &#x43D;&#x430;&#x447;&#x430;&#x43B;&#x43E; &#x438; &#x43A;&#x440;&#x430;&#x439;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x442;&#x440;&#x435;&#x436;&#x435;&#x442;&#x435; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x43A;&#x43B;&#x438;&#x43F;&#x430; &#x441;&#x438;",
                  "ba-videorecorder.wait-for-trim": "&#x418;&#x437;&#x447;&#x430;&#x43A;&#x432;&#x430; &#x441;&#x435; &#x43A;&#x43E;&#x43C;&#x430;&#x43D;&#x434;&#x430; &#x437;&#x430; &#x43E;&#x442;&#x440;&#x44F;&#x437;&#x432;&#x430;&#x43D;&#x435; ...",
                  "ba-videorecorder-controlbar.no-video-source": "&#x41B;&#x438;&#x43F;&#x441;&#x432;&#x430; &#x434;&#x43E;&#x43F;&#x44A;&#x43B;&#x43D;&#x438;&#x442;&#x435;&#x43B;&#x435;&#x43D; &#x438;&#x437;&#x442;&#x43E;&#x447;&#x43D;&#x438;&#x43A; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x432;&#x445;&#x43E;&#x434;",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x414;&#x43E;&#x43F;&#x44A;&#x43B;&#x43D;&#x438;&#x442;&#x435;&#x43B;&#x435;&#x43D; &#x43F;&#x43E;&#x442;&#x43E;&#x43A; &#x432;&#x435;&#x447;&#x435; &#x435; &#x438;&#x437;&#x431;&#x440;&#x430;&#x43D;",
                  "ba-videorecorder.uploading-src-error": "&#x412;&#x438;&#x434;&#x435;&#x43E;&#x43A;&#x43B;&#x438;&#x43F;&#x44A;&#x442; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x441;&#x435; &#x432;&#x44A;&#x437;&#x43F;&#x440;&#x43E;&#x438;&#x437;&#x432;&#x435;&#x434;&#x435;, &#x43A;&#x430;&#x447;&#x432;&#x430;&#x43D;&#x435;&#x442;&#x43E; &#x43F;&#x440;&#x43E;&#x434;&#x44A;&#x43B;&#x436;&#x430;&#x432;&#x430;",
                  "ba-audiorecorder-controlbar.pause-recorder": "&#x41F;&#x430;&#x443;&#x437;&#x430; &#x43D;&#x430; &#x440;&#x435;&#x43A;&#x43E;&#x440;&#x434;&#x435;&#x440;&#x430;",
                  "ba-audiorecorder-controlbar.resume-recorder": "&#x417;&#x430;&#x43F;&#x438;&#x441;&#x432;&#x430;&#x449; &#x440;&#x435;&#x437;&#x44E;&#x43C;&#x435;"
                },
                "language:cat": {
                  "ba-videoplayer-playbutton.tooltip": "Feu clic per veure el v&#xED;deo.",
                  "ba-videoplayer-playbutton.rerecord": "refer",
                  "ba-videoplayer-playbutton.submit-video": "confirmar v&#xED;deo",
                  "ba-videoplayer-loader.tooltip": "Carregant v&#xED;deo ...",
                  "ba-videoplayer-controlbar.change-resolution": "Canviar la resoluci&#xF3;",
                  "ba-videoplayer-controlbar.video-progress": "el progr&#xE9;s de v&#xED;deo",
                  "ba-videoplayer-controlbar.rerecord-video": "Torneu a fer el v&#xED;deo?",
                  "ba-videoplayer-controlbar.submit-video": "confirmar v&#xED;deo",
                  "ba-videoplayer-controlbar.play-video": "reproducci&#xF3; de v&#xED;deo",
                  "ba-videoplayer-controlbar.pause-video": "pausa de v&#xED;deo",
                  "ba-videoplayer-controlbar.elapsed-time": "Temps transcorregut",
                  "ba-videoplayer-controlbar.total-time": "Durada total de v&#xED;deo",
                  "ba-videoplayer-controlbar.fullscreen-video": "Introdu&#xEF;u a pantalla completa",
                  "ba-videoplayer-controlbar.volume-button": "volum de s&#xE8;ries",
                  "ba-videoplayer-controlbar.volume-mute": "silenciar so",
                  "ba-videoplayer-controlbar.volume-unmute": "activar so",
                  "ba-videoplayer.video-error": "Hi ha hagut un error. Siusplau, torni a intentar-ho m&#xE9;s tard. Feu clic per tornar a intentar-ho.",
                  "ba-videorecorder-chooser.record-video": "Gravar el v&#xED;deo",
                  "ba-videorecorder-chooser.upload-video": "Pujar v&#xED;deo",
                  "ba-videorecorder-controlbar.settings": "ajustos",
                  "ba-videorecorder-controlbar.camerahealthy": "La il&#xB7;luminaci&#xF3; &#xE9;s bona",
                  "ba-videorecorder-controlbar.cameraunhealthy": "La il&#xB7;luminaci&#xF3; no &#xE9;s &#xF2;ptima",
                  "ba-videorecorder-controlbar.microphonehealthy": "El so &#xE9;s bo",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "No es pot recollir qualsevol so",
                  "ba-videorecorder-controlbar.record": "registre",
                  "ba-videorecorder-controlbar.record-tooltip": "Feu clic aqu&#xED; per gravar.",
                  "ba-videorecorder-controlbar.rerecord": "refer",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Cliqueu aqu&#xED; per fer de nou.",
                  "ba-videorecorder-controlbar.upload-covershot": "Pujar",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Feu clic aqu&#xED; per pujar foto de portada personalitzada",
                  "ba-videorecorder-controlbar.stop": "aturar",
                  "ba-videorecorder-controlbar.stop-tooltip": "Feu clic aqu&#xED; per aturar.",
                  "ba-videorecorder-controlbar.skip": "Omet",
                  "ba-videorecorder-controlbar.skip-tooltip": "Feu clic aqu&#xED; per saltar.",
                  "ba-videorecorder.recorder-error": "Hi ha hagut un error. Siusplau, torni a intentar-ho m&#xE9;s tard. Feu clic per tornar a intentar-ho.",
                  "ba-videorecorder.attach-error": "No hem pogut accedir a la interf&#xED;cie de la c&#xE0;mera. En funci&#xF3; del dispositiu i del navegador, &#xE9;s possible que hagi de instal &#xB7; lar Flash o accedir a la p&#xE0;gina a trav&#xE9;s de SSL.",
                  "ba-videorecorder.access-forbidden": "Estava prohibit l&#x27;acc&#xE9;s a la c&#xE0;mera. Feu clic per tornar a intentar-ho.",
                  "ba-videorecorder.pick-covershot": "Tria una covershot.",
                  "ba-videorecorder.uploading": "pujant",
                  "ba-videorecorder.uploading-failed": "C&#xE0;rrega fallat - fer clic aqu&#xED; per tornar a intentar-ho.",
                  "ba-videorecorder.verifying": "verificant",
                  "ba-videorecorder.verifying-failed": "fallat la verificaci&#xF3; de - fer clic aqu&#xED; per tornar a intentar-ho.",
                  "ba-videorecorder.rerecord-confirm": "De veritat vol tornar a fer el v&#xED;deo?",
                  "ba-videorecorder.video_file_too_large": "L&#x27;arxiu de v&#xED;deo &#xE9;s massa gran (%s) - fer clic aqu&#xED; per tornar a intentar-ho amb un arxiu de v&#xED;deo m&#xE9;s petita.",
                  "ba-videorecorder.unsupported_video_type": "Si us plau, puja: %s - fer clic aqu&#xED; per tornar a intentar-ho.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Surt de la pantalla completa",
                  "ba-videoplayer-share.share": "compartir v&#xED;deo",
                  "ba-videorecorder-chooser.record-screen": "Pantalla de registre",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pausa no &#xE9;s compatible",
                  "ba-videorecorder-chooser.record-audio": "Enregistrament d&#x27;&#xE0;udio",
                  "ba-videorecorder-controlbar.stop-available-after": "El temps d&#x27;enregistrament m&#xED;nim &#xE9;s %d segons",
                  "ba-videorecorder-controlbar.cancel": "Cancel &#xB7; lar",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Feu clic aqu&#xED; per cancel&#xB7;lar.",
                  "ba-videorecorder.cancel-confirm": "Realment vols cancel&#xB7;lar la c&#xE0;rrega del teu v&#xED;deo?",
                  "ba-videoplayer-adslot.elapsed-time": "Temps transcorregut",
                  "ba-videoplayer-adslot.volume-button": "Estableix el volum",
                  "ba-videoplayer-adslot.volume-mute": "Silenciar el so",
                  "ba-videoplayer-adslot.volume-unmute": "Silenciar el so",
                  "ba-videoplayer-adslot.ad-will-end-after": "L&#x27;anunci finalitzar&#xE0; despr&#xE9;s de %s",
                  "ba-videoplayer-adslot.can-skip-after": "Passa despr&#xE9;s de %d",
                  "ba-videoplayer-adslot.skip-ad": "Saltar anunci",
                  "ba-videorecorder.software-required": "Feu clic a sota per instal&#xB7;lar / activar els requisits seg&#xFC;ents per continuar.",
                  "ba-videorecorder.software-waiting": "Esperant que s&#x27;instal&#xB7;lin / activin els requisits. &#xC9;s possible que h&#xE0;giu d&#x27;actualitzar la p&#xE0;gina una vegada finalitzada.",
                  "ba-videoplayer-controlbar.close-tracks": "Tanca CC",
                  "ba-videoplayer-controlbar.show-tracks": "Mostra CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Penja fitxers de text de la pista",
                  "ba-videoplayer-tracks.select-text-track-language": "Llenguatge de subt&#xED;tols",
                  "ba-videoplayer-tracks.info-select-locale-first": "Primer seleccioneu la configuraci&#xF3; regional",
                  "ba-videoplayer-tracks.select-text-track-file": "Feu clic per seleccionar el fitxer",
                  "ba-videoplayer-tracks.back": "esquena",
                  "ba-videorecorder.framerate-warning": "La velocitat de marc de v&#xED;deo &#xE9;s molt baixa. Recomanem tancar tots els altres programes i pestanyes del navegador o utilitzar una computadora m&#xE9;s r&#xE0;pida.",
                  "ba-videorecorder.upload-error-duration": "La durada del v&#xED;deo carregat no compleix els requisits: feu clic aqu&#xED; per tornar-ho a provar.",
                  "ba-videorecorder.resolution-constraint-error": "El fitxer que heu seleccionat no coincideix amb la resoluci&#xF3; necess&#xE0;ria: feu clic aqu&#xED; per tornar-ho a provar.",
                  "ba-videorecorder.orientation-portrait-required": "Gireu el dispositiu per gravar en mode vertical.",
                  "ba-videorecorder.orientation-landscape-required": "Gireu el dispositiu per gravar en mode horitzontal.",
                  "ba-imageviewer-controlbar.rerecord-image": "Redo?",
                  "ba-imageviewer-controlbar.submit-image": "Confirma",
                  "ba-imageviewer-controlbar.fullscreen-image": "Introdu&#xEF;u la pantalla completa",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Sortir de pantalla completa",
                  "ba-imageviewer.image-error": "Hi ha hagut un error. Siusplau, torni a intentar-ho m&#xE9;s tard. Feu clic per tornar-ho a intentar.",
                  "ba-imagecapture-chooser.image-capture": "Imatge de captura",
                  "ba-imagecapture-chooser.upload-image": "Penja la imatge",
                  "ba-imagecapture-controlbar.settings": "Configuraci&#xF3;",
                  "ba-imagecapture-controlbar.camerahealthy": "La il&#xB7;luminaci&#xF3; &#xE9;s bona",
                  "ba-imagecapture-controlbar.cameraunhealthy": "La il&#xB7;luminaci&#xF3; no &#xE9;s &#xF2;ptima",
                  "ba-imagecapture-controlbar.record": "Captura",
                  "ba-imagecapture-controlbar.record-tooltip": "Feu clic aqu&#xED; per capturar.",
                  "ba-imagecapture-controlbar.rerecord": "Redo",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Feu clic aqu&#xED; per tornar a fer-ho.",
                  "ba-imagecapture-controlbar.cancel": "Cancel &#xB7; lar",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Feu clic aqu&#xED; per cancel&#xB7;lar.",
                  "ba-audioplayer-controlbar.audio-progress": "Progr&#xE9;s, progressar",
                  "ba-audioplayer-controlbar.rerecord-audio": "Redo?",
                  "ba-audioplayer-controlbar.submit-audio": "Confirma",
                  "ba-audioplayer-controlbar.play-audio": "Jugar",
                  "ba-audioplayer-controlbar.pause-audio": "Pausa",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pausa no &#xE9;s compatible",
                  "ba-audioplayer-controlbar.elapsed-time": "Temps transcorregut",
                  "ba-audioplayer-controlbar.total-time": "Durada total de",
                  "ba-audioplayer-controlbar.volume-button": "Estableix el volum",
                  "ba-audioplayer-controlbar.volume-mute": "Silenciar el so",
                  "ba-audioplayer-controlbar.volume-unmute": "Silenciar el so",
                  "ba-audioplayer-loader.tooltip": "S&#x27;est&#xE0; carregant ...",
                  "ba-audioplayer.audio-error": "Hi ha hagut un error. Siusplau, torni a intentar-ho m&#xE9;s tard. Feu clic per tornar-ho a intentar.",
                  "ba-audiorecorder-chooser.record-audio": "Enregistrament d&#x27;&#xE0;udio",
                  "ba-audiorecorder-chooser.upload-audio": "Penja l&#x27;&#xE0;udio",
                  "ba-audiorecorder-controlbar.settings": "Configuraci&#xF3;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "El so &#xE9;s bo",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "No es pot recuperar cap so",
                  "ba-audiorecorder-controlbar.record": "Registre",
                  "ba-audiorecorder-controlbar.record-tooltip": "Feu clic aqu&#xED; per registrar.",
                  "ba-audiorecorder-controlbar.rerecord": "Redo",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Feu clic aqu&#xED; per tornar a fer-ho.",
                  "ba-audiorecorder-controlbar.stop": "Aturar",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Feu clic aqu&#xED; per aturar.",
                  "ba-audiorecorder-controlbar.stop-available-after": "El temps d&#x27;enregistrament m&#xED;nim &#xE9;s %d segons",
                  "ba-audiorecorder-controlbar.cancel": "Cancel &#xB7; lar",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Feu clic aqu&#xED; per cancel&#xB7;lar.",
                  "ba-videoplayer-controlbar.player-speed": "Velocitat del jugador",
                  "ba-videoplayer-controlbar.settings": "Configuraci&#xF3;",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Icona Airplay.",
                  "ba-videoplayer.all-settings": "Tots els par&#xE0;metres",
                  "ba-videoplayer.player-speed": "Velocitat del jugador",
                  "ba-videoplayer.full-screen": "Pantalla completa",
                  "ba-videorecorder-controlbar.add-stream": "Afegeix corrent",
                  "ba-videorecorder.switch-camera": "Canvia la c&#xE0;mera",
                  "ba-videorecorder.prepare-covershot": "Preparaci&#xF3; de captures de pantalla",
                  "ba-videorecorder.prepare-thumbnails": "Preparant la cerca de miniatures",
                  "ba-videorecorder.adding-new-stream": "Addici&#xF3; de corrent nova",
                  "ba-imagecapture.recorder-error": "Hi ha hagut un error. Siusplau, torni a intentar-ho m&#xE9;s tard. Feu clic per tornar a provar.",
                  "ba-imagecapture.attach-error": "No hem pogut accedir a la interf&#xED;cie multim&#xE8;dia. Depenent del dispositiu i del navegador, &#xE9;s possible que hagueu d&#x27;instal&#xB7;lar Flash o accedir a la p&#xE0;gina mitjan&#xE7;ant SSL.",
                  "ba-imagecapture.software-required": "Per continuar, feu clic a continuaci&#xF3; per instal&#xB7;lar / activar els seg&#xFC;ents requisits.",
                  "ba-imagecapture.software-waiting": "S&#x2019;espera que s&#x2019;instal&#xB7;lin / activin els requisits. Potser haureu d&#x2019;actualitzar la p&#xE0;gina un cop finalitzada.",
                  "ba-imagecapture.access-forbidden": "L&#x2019;acc&#xE9;s als mitjans de comunicaci&#xF3; estava prohibit. Feu clic per tornar a provar.",
                  "ba-imagecapture.uploading": "C&#xE0;rrega",
                  "ba-imagecapture.uploading-failed": "Ha fallat la c&#xE0;rrega: feu clic aqu&#xED; per tornar-ho a provar.",
                  "ba-imagecapture.upload-error-duration": "La longitud de la imatge carregada no compleix els requisits: feu clic aqu&#xED; per tornar-ho a provar.",
                  "ba-imagecapture.resolution-constraint-error": "El fitxer que heu seleccionat no coincideix amb la resoluci&#xF3; necess&#xE0;ria: feu clic aqu&#xED; per tornar-ho a provar.",
                  "ba-imagecapture.verifying": "Verificaci&#xF3;",
                  "ba-imagecapture.verifying-failed": "Verificaci&#xF3; fallida: feu clic aqu&#xED; per tornar-ho a provar.",
                  "ba-imagecapture.rerecord-confirm": "Segur que voleu reprendre la vostra imatge?",
                  "ba-imagecapture.image_file_too_large": "El vostre fitxer d&#x27;imatge &#xE9;s massa gran (%s): feu clic aqu&#xED; per tornar-ho a provar amb un fitxer d&#x27;imatge m&#xE9;s petit.",
                  "ba-imagecapture.unsupported_image_type": "Pengeu: %s: feu clic aqu&#xED; per tornar-ho a provar.",
                  "ba-imagecapture.orientation-portrait-required": "Gireu el dispositiu per gravar en mode vertical.",
                  "ba-imagecapture.orientation-landscape-required": "Gireu el dispositiu per gravar en mode horitzontal.",
                  "ba-audiorecorder.recorder-error": "Hi ha hagut un error. Siusplau, torni a intentar-ho m&#xE9;s tard. Feu clic per tornar a provar.",
                  "ba-audiorecorder.attach-error": "No hem pogut accedir a la interf&#xED;cie multim&#xE8;dia. Depenent del dispositiu i del navegador, &#xE9;s possible que hagueu d&#x27;instal&#xB7;lar Flash o accedir a la p&#xE0;gina mitjan&#xE7;ant SSL.",
                  "ba-audiorecorder.software-required": "Per continuar, feu clic a continuaci&#xF3; per instal&#xB7;lar / activar els seg&#xFC;ents requisits.",
                  "ba-audiorecorder.software-waiting": "S&#x2019;espera que s&#x2019;instal&#xB7;lin / activin els requisits. Potser haureu d&#x2019;actualitzar la p&#xE0;gina un cop finalitzada.",
                  "ba-audiorecorder.access-forbidden": "L&#x2019;acc&#xE9;s als mitjans de comunicaci&#xF3; estava prohibit. Feu clic per tornar a provar.",
                  "ba-audiorecorder.uploading": "C&#xE0;rrega",
                  "ba-audiorecorder.uploading-failed": "Ha fallat la c&#xE0;rrega: feu clic aqu&#xED; per tornar-ho a provar.",
                  "ba-audiorecorder.upload-error-duration": "La durada de l&#x2019;&#xE0;udio carregat no compleix els requisits: feu clic aqu&#xED; per tornar-ho a provar.",
                  "ba-audiorecorder.verifying": "Verificaci&#xF3;",
                  "ba-audiorecorder.verifying-failed": "Verificaci&#xF3; fallida: feu clic aqu&#xED; per tornar-ho a provar.",
                  "ba-audiorecorder.rerecord-confirm": "Esteu segur que voleu referir l&#x2019;&#xE0;udio?",
                  "ba-audiorecorder.cancel-confirm": "Segur que voleu cancel&#xB7;lar la c&#xE0;rrega d&#x2019;&#xE0;udio?",
                  "ba-audiorecorder.audio_file_too_large": "El vostre fitxer d&#x2019;&#xE0;udio &#xE9;s massa gran (%s): feu clic aqu&#xED; per tornar-ho a provar amb un fitxer d&#x2019;&#xE0;udio m&#xE9;s petit.",
                  "ba-audiorecorder.unsupported_audio_type": "Pengeu: %s: feu clic aqu&#xED; per tornar-ho a provar.",
                  "ba-common-settingsmenu.tooltip": "Feu clic per jugar.",
                  "ba-common-settingsmenu.setting-menu": "Tots els par&#xE0;metres",
                  "ba-common-settingsmenu.source-quality": "Qualitat de la font",
                  "ba-common-settingsmenu.player-speed": "Velocitat del jugador",
                  "ba-common-settingsmenu.set-menu-option": "Estableix l&#x27;opci&#xF3;",
                  "ba-common-settingsmenu.submit-video": "Confirmeu el v&#xED;deo",
                  "ba-common-settingsmenu.picture-in-picture": "Imatge en imatge",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Surt de la pantalla completa",
                  "ba-common-settingsmenu.fullscreen-video": "Introdu&#xEF;u la pantalla completa",
                  "ba-videorecorder-chooser.multi-stream": "Multitransmissi&#xF3;",
                  "ba-videorecorder-controlbar.pause-recorder": "Grava en pausa",
                  "ba-videorecorder-controlbar.resume-recorder": "Repr&#xE8;n la gravadora",
                  "ba-videorecorder.missing-track": "Falta la pista d&#x2019;&#xE0;udio o v&#xED;deo requerida",
                  "ba-videorecorder.device-already-in-use": "Almenys un dels vostres dispositius d&#x27;entrada ja est&#xE0; en &#xFA;s",
                  "ba-videorecorder.browser-permission-denied": "El navegador ha denegat el perm&#xED;s, concediu acc&#xE9;s i torneu a carregar la p&#xE0;gina",
                  "ba-audioplayer.all-settings": "Tots els par&#xE0;metres",
                  "ba-videoplayer-controlbar.remaining-time": "Temps restant",
                  "ba-videoplayer-controlbar.select-frame": "Seleccioneu",
                  "ba-videoplayer-controlbar.trim-video": "Retallar",
                  "ba-videoplayer-playbutton.trim": "Retallar",
                  "ba-videoplayer-playbutton.skip": "Omet",
                  "ba-videorecorder-imagegallery.upload-covershot": "Carrega la portada",
                  "ba-videorecorder.pick-covershot-frame": "Seleccioneu un marc per utilitzar-lo com a captura de pantalla.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "La gravadora de pantalla no &#xE9;s compatible amb aquest dispositiu",
                  "ba-videorecorder.trim-prompt": "Voleu retallar el vostre v&#xED;deo?",
                  "ba-videorecorder.trim-video": "Mou els marcadors d&#x2019;inici i de finalitzaci&#xF3; per retallar el v&#xED;deo",
                  "ba-videorecorder.wait-for-trim": "S&#x27;est&#xE0; esperant l&#x27;ordre de retallada ...",
                  "ba-videorecorder-controlbar.no-video-source": "Falta una font d&#x2019;entrada de v&#xED;deo addicional",
                  "ba-videorecorder-controlbar.stream-already-selected": "Ja s&#x27;ha seleccionat un flux addicional",
                  "ba-videorecorder.uploading-src-error": "Ara no es pot reproduir el v&#xED;deo; la c&#xE0;rrega encara est&#xE0; en curs",
                  "ba-audiorecorder-controlbar.pause-recorder": "Grava en pausa",
                  "ba-audiorecorder-controlbar.resume-recorder": "Repr&#xE8;n la gravadora"
                },
                "language:cs": {
                  "ba-videoplayer-playbutton.tooltip": "Klikn&#x11B;te pro p&#x159;ehr&#xE1;n&#xED;.",
                  "ba-videoplayer-playbutton.rerecord": "P&#x159;ed&#x11B;lat",
                  "ba-videoplayer-playbutton.submit-video": "Potvr&#x10F;te video",
                  "ba-videoplayer-loader.tooltip": "Na&#x10D;&#xED;t&#xE1;n&#xED;...",
                  "ba-videoplayer-controlbar.change-resolution": "Zm&#x11B;nit rozli&#x161;en&#xED;",
                  "ba-videoplayer-controlbar.video-progress": "Pokrok",
                  "ba-videoplayer-controlbar.rerecord-video": "P&#x159;ed&#x11B;lat?",
                  "ba-videoplayer-controlbar.submit-video": "Potvrdit",
                  "ba-videoplayer-controlbar.play-video": "Hr&#xE1;t si",
                  "ba-videoplayer-controlbar.pause-video": "Pauza",
                  "ba-videoplayer-controlbar.elapsed-time": "Uplynul&#xFD; &#x10D;as",
                  "ba-videoplayer-controlbar.total-time": "Celkov&#xE1; d&#xE9;lka",
                  "ba-videoplayer-controlbar.fullscreen-video": "P&#x159;ejd&#x11B;te na celou obrazovku",
                  "ba-videoplayer-controlbar.volume-button": "Nastavte hlasitost",
                  "ba-videoplayer-controlbar.volume-mute": "Ztlumit zvuk",
                  "ba-videoplayer-controlbar.volume-unmute": "Zapnout zvuk",
                  "ba-videoplayer.video-error": "Vyskytla se chyba. Zkuste to pros&#xED;m pozd&#x11B;ji. Kliknut&#xED;m to zkuste znovu.",
                  "ba-videorecorder-chooser.record-video": "Nahr&#xE1;t video",
                  "ba-videorecorder-chooser.upload-video": "Nahr&#xE1;t video",
                  "ba-videorecorder-controlbar.settings": "Nastaven&#xED;",
                  "ba-videorecorder-controlbar.camerahealthy": "Osv&#x11B;tlen&#xED; je dobr&#xE9;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Osv&#x11B;tlen&#xED; nen&#xED; optim&#xE1;ln&#xED;",
                  "ba-videorecorder-controlbar.microphonehealthy": "Zvuk je dobr&#xFD;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Nelze zachytit &#x17E;&#xE1;dn&#xFD; zvuk",
                  "ba-videorecorder-controlbar.record": "Z&#xE1;znam",
                  "ba-videorecorder-controlbar.record-tooltip": "Klepnut&#xED;m sem spust&#xED;te nahr&#xE1;v&#xE1;n&#xED;.",
                  "ba-videorecorder-controlbar.rerecord": "P&#x159;ed&#x11B;lat",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Klikn&#x11B;te znovu pro opakov&#xE1;n&#xED;.",
                  "ba-videorecorder-controlbar.upload-covershot": "Nahrajte ob&#xE1;lku",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Kliknut&#xED;m sem nahrajete vlastn&#xED; sn&#xED;mek ob&#xE1;lky",
                  "ba-videorecorder-controlbar.stop": "Stop",
                  "ba-videorecorder-controlbar.stop-tooltip": "Kliknut&#xED;m sem zastav&#xED;te.",
                  "ba-videorecorder-controlbar.skip": "P&#x159;esko&#x10D;it",
                  "ba-videorecorder-controlbar.skip-tooltip": "Kliknut&#xED;m sem p&#x159;esko&#x10D;&#xED;te.",
                  "ba-videorecorder.recorder-error": "Vyskytla se chyba. Zkuste to pros&#xED;m pozd&#x11B;ji. Kliknut&#xED;m to zkuste znovu.",
                  "ba-videorecorder.attach-error": "Nelze z&#xED;skat p&#x159;&#xED;stup k medi&#xE1;ln&#xED;mu rozhran&#xED;. V z&#xE1;vislosti na za&#x159;&#xED;zen&#xED; a prohl&#xED;&#x17E;e&#x10D;i mo&#x17E;n&#xE1; budete muset nainstalovat Flash nebo p&#x159;istupovat na str&#xE1;nku pomoc&#xED; SSL.",
                  "ba-videorecorder.access-forbidden": "P&#x159;&#xED;stup k m&#xE9;di&#xED;m byl zak&#xE1;z&#xE1;n. Kliknut&#xED;m to zkuste znovu.",
                  "ba-videorecorder.pick-covershot": "Vyberte si kryc&#xED; sn&#xED;mek.",
                  "ba-videorecorder.uploading": "Nahr&#xE1;v&#xE1;m",
                  "ba-videorecorder.uploading-failed": "Nahr&#xE1;v&#xE1;n&#xED; se nezda&#x159;ilo - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-videorecorder.verifying": "Ov&#x11B;&#x159;en&#xED;",
                  "ba-videorecorder.verifying-failed": "Ov&#x11B;&#x159;en&#xED; se nezda&#x159;ilo - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-videorecorder.rerecord-confirm": "Opravdu chcete sv&#xE9; video zopakovat?",
                  "ba-videorecorder.video_file_too_large": "V&#xE1;&#x161; video soubor je p&#x159;&#xED;li&#x161; velk&#xFD; (%s) - kliknut&#xED;m sem to zkuste znovu s men&#x161;&#xED;m video souborem.",
                  "ba-videorecorder.unsupported_video_type": "Nahrajte pros&#xED;m: %s - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Ukon&#x10D;it re&#x17E;im cel&#xE9; obrazovky",
                  "ba-videoplayer-share.share": "Sd&#xED;lejte m&#xE9;dia",
                  "ba-videorecorder-chooser.record-screen": "Z&#xE1;znamov&#xE1; obrazovka",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pauza nen&#xED; podporov&#xE1;na",
                  "ba-videorecorder-chooser.record-audio": "Z&#xE1;znam zvuku",
                  "ba-videorecorder-controlbar.stop-available-after": "Minim&#xE1;ln&#xED; doba z&#xE1;znamu je %d sekund",
                  "ba-videorecorder-controlbar.cancel": "zru&#x161;en&#xED;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Kliknut&#xED;m sem akci zru&#x161;&#xED;te.",
                  "ba-videorecorder.cancel-confirm": "Opravdu chcete zru&#x161;it nahr&#xE1;v&#xE1;n&#xED; videa?",
                  "ba-videoplayer-adslot.elapsed-time": "Uplynul&#xFD; &#x10D;as",
                  "ba-videoplayer-adslot.volume-button": "Nastavte hlasitost",
                  "ba-videoplayer-adslot.volume-mute": "Ztlumit zvuk",
                  "ba-videoplayer-adslot.volume-unmute": "Zapnout zvuk",
                  "ba-videoplayer-adslot.ad-will-end-after": "Reklama skon&#x10D;&#xED; po %s",
                  "ba-videoplayer-adslot.can-skip-after": "P&#x159;esko&#x10D;it po %d",
                  "ba-videoplayer-adslot.skip-ad": "P&#x159;esko&#x10D;it reklamu",
                  "ba-videorecorder.software-required": "Chcete-li pokra&#x10D;ovat, klikn&#x11B;te n&#xED;&#x17E;e a nainstalujte / aktivujte n&#xE1;sleduj&#xED;c&#xED; po&#x17E;adavky.",
                  "ba-videorecorder.software-waiting": "&#x10C;ek&#xE1;n&#xED; na instalaci / aktivaci po&#x17E;adavk&#x16F;. Po dokon&#x10D;en&#xED; mo&#x17E;n&#xE1; budete muset str&#xE1;nku obnovit.",
                  "ba-videoplayer-controlbar.close-tracks": "Zav&#x159;&#xED;t CC",
                  "ba-videoplayer-controlbar.show-tracks": "Zobrazit CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Nahrajte textov&#xE9; soubory stopy",
                  "ba-videoplayer-tracks.select-text-track-language": "Jazyk titulk&#x16F;",
                  "ba-videoplayer-tracks.info-select-locale-first": "Nejprve vyberte n&#xE1;rodn&#xED; prost&#x159;ed&#xED;",
                  "ba-videoplayer-tracks.select-text-track-file": "Klepnut&#xED;m vyberte soubor",
                  "ba-videoplayer-tracks.back": "zadn&#xED;",
                  "ba-videorecorder.framerate-warning": "Sn&#xED;mkov&#xE1; frekvence videa je velmi n&#xED;zk&#xE1;. Doporu&#x10D;ujeme zav&#x159;&#xED;t v&#x161;echny ostatn&#xED; programy a karty prohl&#xED;&#x17E;e&#x10D;e nebo pou&#x17E;&#xED;t rychlej&#x161;&#xED; po&#x10D;&#xED;ta&#x10D;.",
                  "ba-videorecorder.upload-error-duration": "D&#xE9;lka nahran&#xE9;ho videa nespl&#x148;uje po&#x17E;adavky - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-videorecorder.resolution-constraint-error": "Soubor, kter&#xFD; jste vybrali, neodpov&#xED;d&#xE1; po&#x17E;adovan&#xE9;mu rozli&#x161;en&#xED; - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-videorecorder.orientation-portrait-required": "Chcete-li nahr&#xE1;vat v re&#x17E;imu na v&#xFD;&#x161;ku, oto&#x10D;te za&#x159;&#xED;zen&#xED;.",
                  "ba-videorecorder.orientation-landscape-required": "Chcete-li nahr&#xE1;vat v re&#x17E;imu na &#x161;&#xED;&#x159;ku, oto&#x10D;te za&#x159;&#xED;zen&#xED;.",
                  "ba-imageviewer-controlbar.rerecord-image": "P&#x159;ed&#x11B;lat?",
                  "ba-imageviewer-controlbar.submit-image": "Potvrdit",
                  "ba-imageviewer-controlbar.fullscreen-image": "P&#x159;ejd&#x11B;te na celou obrazovku",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Ukon&#x10D;it re&#x17E;im cel&#xE9; obrazovky",
                  "ba-imageviewer.image-error": "Vyskytla se chyba. Zkuste to pros&#xED;m pozd&#x11B;ji. Kliknut&#xED;m to zkuste znovu.",
                  "ba-imagecapture-chooser.image-capture": "Zachy&#x165;te obr&#xE1;zek",
                  "ba-imagecapture-chooser.upload-image": "Nahr&#xE1;t obr&#xE1;zek",
                  "ba-imagecapture-controlbar.settings": "Nastaven&#xED;",
                  "ba-imagecapture-controlbar.camerahealthy": "Osv&#x11B;tlen&#xED; je dobr&#xE9;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Osv&#x11B;tlen&#xED; nen&#xED; optim&#xE1;ln&#xED;",
                  "ba-imagecapture-controlbar.record": "Zachy&#x165;te",
                  "ba-imagecapture-controlbar.record-tooltip": "Kliknut&#xED;m sem po&#x159;&#xED;d&#xED;te sn&#xED;mek.",
                  "ba-imagecapture-controlbar.rerecord": "P&#x159;ed&#x11B;lat",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Klikn&#x11B;te znovu pro opakov&#xE1;n&#xED;.",
                  "ba-imagecapture-controlbar.cancel": "zru&#x161;en&#xED;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Kliknut&#xED;m sem akci zru&#x161;&#xED;te.",
                  "ba-audioplayer-controlbar.audio-progress": "Pokrok",
                  "ba-audioplayer-controlbar.rerecord-audio": "P&#x159;ed&#x11B;lat?",
                  "ba-audioplayer-controlbar.submit-audio": "Potvrdit",
                  "ba-audioplayer-controlbar.play-audio": "Hr&#xE1;t si",
                  "ba-audioplayer-controlbar.pause-audio": "Pauza",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pauza nen&#xED; podporov&#xE1;na",
                  "ba-audioplayer-controlbar.elapsed-time": "Uplynul&#xFD; &#x10D;as",
                  "ba-audioplayer-controlbar.total-time": "Celkov&#xE1; d&#xE9;lka",
                  "ba-audioplayer-controlbar.volume-button": "Nastavte hlasitost",
                  "ba-audioplayer-controlbar.volume-mute": "Ztlumit zvuk",
                  "ba-audioplayer-controlbar.volume-unmute": "Zapnout zvuk",
                  "ba-audioplayer-loader.tooltip": "Na&#x10D;&#xED;t&#xE1;n&#xED;...",
                  "ba-audioplayer.audio-error": "Vyskytla se chyba. Zkuste to pros&#xED;m pozd&#x11B;ji. Kliknut&#xED;m to zkuste znovu.",
                  "ba-audiorecorder-chooser.record-audio": "Z&#xE1;znam zvuku",
                  "ba-audiorecorder-chooser.upload-audio": "Nahr&#xE1;t zvuk",
                  "ba-audiorecorder-controlbar.settings": "Nastaven&#xED;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Zvuk je dobr&#xFD;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Nelze zachytit &#x17E;&#xE1;dn&#xFD; zvuk",
                  "ba-audiorecorder-controlbar.record": "Z&#xE1;znam",
                  "ba-audiorecorder-controlbar.record-tooltip": "Klepnut&#xED;m sem spust&#xED;te nahr&#xE1;v&#xE1;n&#xED;.",
                  "ba-audiorecorder-controlbar.rerecord": "P&#x159;ed&#x11B;lat",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Klikn&#x11B;te znovu pro opakov&#xE1;n&#xED;.",
                  "ba-audiorecorder-controlbar.stop": "Stop",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Kliknut&#xED;m sem zastav&#xED;te.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Minim&#xE1;ln&#xED; doba z&#xE1;znamu je %d sekund",
                  "ba-audiorecorder-controlbar.cancel": "zru&#x161;en&#xED;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Kliknut&#xED;m sem akci zru&#x161;&#xED;te.",
                  "ba-videoplayer-controlbar.player-speed": "Rychlost hr&#xE1;&#x10D;e",
                  "ba-videoplayer-controlbar.settings": "Nastaven&#xED;",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Ikona Airplay.",
                  "ba-videoplayer.all-settings": "V&#x161;echna nastaven&#xED;",
                  "ba-videoplayer.player-speed": "Rychlost hr&#xE1;&#x10D;e",
                  "ba-videoplayer.full-screen": "Cel&#xE1; obrazovka",
                  "ba-videorecorder-controlbar.add-stream": "P&#x159;idat stream",
                  "ba-videorecorder.switch-camera": "P&#x159;epnout kameru",
                  "ba-videorecorder.prepare-covershot": "P&#x159;&#xED;prava pokus&#x16F;",
                  "ba-videorecorder.prepare-thumbnails": "P&#x159;&#xED;prava hled&#xE1;n&#xED; miniatur",
                  "ba-videorecorder.adding-new-stream": "P&#x159;id&#xE1;n&#xED; nov&#xE9;ho streamu",
                  "ba-imagecapture.recorder-error": "Vyskytla se chyba. Zkuste to pros&#xED;m pozd&#x11B;ji. Kliknut&#xED;m to zkuste znovu.",
                  "ba-imagecapture.attach-error": "Nelze z&#xED;skat p&#x159;&#xED;stup k medi&#xE1;ln&#xED;mu rozhran&#xED;. V z&#xE1;vislosti na za&#x159;&#xED;zen&#xED; a prohl&#xED;&#x17E;e&#x10D;i mo&#x17E;n&#xE1; budete muset nainstalovat Flash nebo p&#x159;istupovat na str&#xE1;nku pomoc&#xED; SSL.",
                  "ba-imagecapture.software-required": "Chcete-li pokra&#x10D;ovat, klikn&#x11B;te n&#xED;&#x17E;e a nainstalujte / aktivujte n&#xE1;sleduj&#xED;c&#xED; po&#x17E;adavky.",
                  "ba-imagecapture.software-waiting": "&#x10C;ek&#xE1;n&#xED; na instalaci / aktivaci po&#x17E;adavk&#x16F;. Po dokon&#x10D;en&#xED; mo&#x17E;n&#xE1; budete muset str&#xE1;nku obnovit.",
                  "ba-imagecapture.access-forbidden": "P&#x159;&#xED;stup k m&#xE9;di&#xED;m byl zak&#xE1;z&#xE1;n. Kliknut&#xED;m to zkuste znovu.",
                  "ba-imagecapture.uploading": "Nahr&#xE1;v&#xE1;m",
                  "ba-imagecapture.uploading-failed": "Nahr&#xE1;v&#xE1;n&#xED; se nezda&#x159;ilo - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-imagecapture.upload-error-duration": "D&#xE9;lka nahran&#xE9;ho obr&#xE1;zku nespl&#x148;uje po&#x17E;adavky - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-imagecapture.resolution-constraint-error": "Soubor, kter&#xFD; jste vybrali, neodpov&#xED;d&#xE1; po&#x17E;adovan&#xE9;mu rozli&#x161;en&#xED; - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-imagecapture.verifying": "Ov&#x11B;&#x159;en&#xED;",
                  "ba-imagecapture.verifying-failed": "Ov&#x11B;&#x159;en&#xED; se nezda&#x159;ilo - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-imagecapture.rerecord-confirm": "Opravdu chcete znovu po&#x159;&#xED;dit sv&#x16F;j obr&#xE1;zek?",
                  "ba-imagecapture.image_file_too_large": "V&#xE1;&#x161; obrazov&#xFD; soubor je p&#x159;&#xED;li&#x161; velk&#xFD; (%s) - kliknut&#xED;m sem to zkuste znovu s men&#x161;&#xED;m obrazov&#xFD;m souborem.",
                  "ba-imagecapture.unsupported_image_type": "Nahrajte pros&#xED;m: %s - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-imagecapture.orientation-portrait-required": "Chcete-li nahr&#xE1;vat v re&#x17E;imu na v&#xFD;&#x161;ku, oto&#x10D;te za&#x159;&#xED;zen&#xED;.",
                  "ba-imagecapture.orientation-landscape-required": "Chcete-li nahr&#xE1;vat v re&#x17E;imu na &#x161;&#xED;&#x159;ku, oto&#x10D;te za&#x159;&#xED;zen&#xED;.",
                  "ba-audiorecorder.recorder-error": "Vyskytla se chyba. Zkuste to pros&#xED;m pozd&#x11B;ji. Kliknut&#xED;m to zkuste znovu.",
                  "ba-audiorecorder.attach-error": "Nelze z&#xED;skat p&#x159;&#xED;stup k medi&#xE1;ln&#xED;mu rozhran&#xED;. V z&#xE1;vislosti na za&#x159;&#xED;zen&#xED; a prohl&#xED;&#x17E;e&#x10D;i mo&#x17E;n&#xE1; budete muset nainstalovat Flash nebo p&#x159;istupovat na str&#xE1;nku pomoc&#xED; SSL.",
                  "ba-audiorecorder.software-required": "Chcete-li pokra&#x10D;ovat, klikn&#x11B;te n&#xED;&#x17E;e a nainstalujte / aktivujte n&#xE1;sleduj&#xED;c&#xED; po&#x17E;adavky.",
                  "ba-audiorecorder.software-waiting": "&#x10C;ek&#xE1;n&#xED; na instalaci / aktivaci po&#x17E;adavk&#x16F;. Po dokon&#x10D;en&#xED; mo&#x17E;n&#xE1; budete muset str&#xE1;nku obnovit.",
                  "ba-audiorecorder.access-forbidden": "P&#x159;&#xED;stup k m&#xE9;di&#xED;m byl zak&#xE1;z&#xE1;n. Kliknut&#xED;m to zkuste znovu.",
                  "ba-audiorecorder.uploading": "Nahr&#xE1;v&#xE1;m",
                  "ba-audiorecorder.uploading-failed": "Nahr&#xE1;v&#xE1;n&#xED; se nezda&#x159;ilo - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-audiorecorder.upload-error-duration": "D&#xE9;lka nahran&#xE9;ho zvuku nespl&#x148;uje po&#x17E;adavky - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-audiorecorder.verifying": "Ov&#x11B;&#x159;en&#xED;",
                  "ba-audiorecorder.verifying-failed": "Ov&#x11B;&#x159;en&#xED; se nezda&#x159;ilo - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-audiorecorder.rerecord-confirm": "Opravdu chcete p&#x159;ed&#x11B;lat zvuk?",
                  "ba-audiorecorder.cancel-confirm": "Opravdu chcete zru&#x161;it nahr&#xE1;v&#xE1;n&#xED; zvuku?",
                  "ba-audiorecorder.audio_file_too_large": "V&#xE1;&#x161; zvukov&#xFD; soubor je p&#x159;&#xED;li&#x161; velk&#xFD; (%s) - kliknut&#xED;m sem to zkuste znovu s men&#x161;&#xED;m zvukov&#xFD;m souborem.",
                  "ba-audiorecorder.unsupported_audio_type": "Nahrajte pros&#xED;m: %s - kliknut&#xED;m sem to zkuste znovu.",
                  "ba-common-settingsmenu.tooltip": "Klikn&#x11B;te pro p&#x159;ehr&#xE1;n&#xED;.",
                  "ba-common-settingsmenu.setting-menu": "V&#x161;echna nastaven&#xED;",
                  "ba-common-settingsmenu.source-quality": "Kvalita zdroje",
                  "ba-common-settingsmenu.player-speed": "Rychlost hr&#xE1;&#x10D;e",
                  "ba-common-settingsmenu.set-menu-option": "Nastavit mo&#x17E;nost",
                  "ba-common-settingsmenu.submit-video": "Potvr&#x10F;te video",
                  "ba-common-settingsmenu.picture-in-picture": "Obraz v obraze",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Ukon&#x10D;it re&#x17E;im cel&#xE9; obrazovky",
                  "ba-common-settingsmenu.fullscreen-video": "P&#x159;ejd&#x11B;te na celou obrazovku",
                  "ba-videorecorder-chooser.multi-stream": "Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Pozastavit z&#xE1;znam",
                  "ba-videorecorder-controlbar.resume-recorder": "Obnovte z&#xE1;znam",
                  "ba-videorecorder.missing-track": "Chyb&#xED; po&#x17E;adovan&#xE1; zvukov&#xE1; nebo obrazov&#xE1; stopa",
                  "ba-videorecorder.device-already-in-use": "Alespo&#x148; jedno z va&#x161;ich vstupn&#xED;ch za&#x159;&#xED;zen&#xED; se ji&#x17E; pou&#x17E;&#xED;v&#xE1;",
                  "ba-videorecorder.browser-permission-denied": "Prohl&#xED;&#x17E;e&#x10D; zam&#xED;tl opr&#xE1;vn&#x11B;n&#xED;, ud&#x11B;lejte pros&#xED;m p&#x159;&#xED;stup a znovu na&#x10D;t&#x11B;te str&#xE1;nku",
                  "ba-audioplayer.all-settings": "V&#x161;echna nastaven&#xED;",
                  "ba-videoplayer-controlbar.remaining-time": "Zb&#xFD;vaj&#xED;c&#xED; &#x10D;as",
                  "ba-videoplayer-controlbar.select-frame": "Vybrat",
                  "ba-videoplayer-controlbar.trim-video": "O&#x159;&#xED;znout",
                  "ba-videoplayer-playbutton.trim": "O&#x159;&#xED;znout",
                  "ba-videoplayer-playbutton.skip": "P&#x159;esko&#x10D;it",
                  "ba-videorecorder-imagegallery.upload-covershot": "Nahrajte ob&#xE1;lku",
                  "ba-videorecorder.pick-covershot-frame": "Vyberte sn&#xED;mek, kter&#xFD; chcete pou&#x17E;&#xED;t jako kryc&#xED; sn&#xED;mek.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Rekord&#xE9;r obrazovky nen&#xED; na tomto za&#x159;&#xED;zen&#xED; podporov&#xE1;n",
                  "ba-videorecorder.trim-prompt": "Chcete video o&#x159;&#xED;znout?",
                  "ba-videorecorder.trim-video": "Posunut&#xED;m po&#x10D;&#xE1;te&#x10D;n&#xED;ch a koncov&#xFD;ch zna&#x10D;ek o&#x159;&#xED;zn&#x11B;te video",
                  "ba-videorecorder.wait-for-trim": "&#x10C;ek&#xE1;n&#xED; na p&#x159;&#xED;kaz o&#x159;&#xED;znut&#xED; ...",
                  "ba-videorecorder-controlbar.no-video-source": "Chyb&#xED; dal&#x161;&#xED; zdroj vstupu videa",
                  "ba-videorecorder-controlbar.stream-already-selected": "Dal&#x161;&#xED; stream ji&#x17E; byl vybr&#xE1;n",
                  "ba-videorecorder.uploading-src-error": "Nyn&#xED; nelze p&#x159;ehr&#xE1;t video, nahr&#xE1;v&#xE1;n&#xED; st&#xE1;le prob&#xED;h&#xE1;",
                  "ba-audiorecorder-controlbar.pause-recorder": "Pozastavit rekord&#xE9;r",
                  "ba-audiorecorder-controlbar.resume-recorder": "Obnovit z&#xE1;znamn&#xED;k"
                },
                "language:da": {
                  "ba-videoplayer-playbutton.tooltip": "Klik for at afspille video.",
                  "ba-videoplayer-playbutton.rerecord": "redo",
                  "ba-videoplayer-playbutton.submit-video": "Bekr&#xE6;ft video",
                  "ba-videoplayer-loader.tooltip": "Indl&#xE6;ser video ...",
                  "ba-videoplayer-controlbar.change-resolution": "Skift opl&#xF8;sning",
                  "ba-videoplayer-controlbar.video-progress": "fremskridt Video",
                  "ba-videoplayer-controlbar.rerecord-video": "Redo video?",
                  "ba-videoplayer-controlbar.submit-video": "Bekr&#xE6;ft video",
                  "ba-videoplayer-controlbar.play-video": "Afspil video",
                  "ba-videoplayer-controlbar.pause-video": "Pause video",
                  "ba-videoplayer-controlbar.elapsed-time": "Forl&#xF8;bet tid",
                  "ba-videoplayer-controlbar.total-time": "Samlet l&#xE6;ngde af video",
                  "ba-videoplayer-controlbar.fullscreen-video": "Indtast fullscreen",
                  "ba-videoplayer-controlbar.volume-button": "Indstil lydstyrke",
                  "ba-videoplayer-controlbar.volume-mute": "Sl&#xE5; lyden",
                  "ba-videoplayer-controlbar.volume-unmute": "Sl&#xE5; lyden til",
                  "ba-videoplayer.video-error": "Der opstod en fejl. Pr&#xF8;v venligst igen senere. Klik for at pr&#xF8;ve igen.",
                  "ba-videorecorder-chooser.record-video": "Optag din video",
                  "ba-videorecorder-chooser.upload-video": "Upload video",
                  "ba-videorecorder-controlbar.settings": "Indstillinger",
                  "ba-videorecorder-controlbar.camerahealthy": "Belysning er god",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Belysning er ikke optimal",
                  "ba-videorecorder-controlbar.microphonehealthy": "Lyden er god",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Kan ikke afhente nogen lyd",
                  "ba-videorecorder-controlbar.record": "Optag",
                  "ba-videorecorder-controlbar.record-tooltip": "Klik her for at optage.",
                  "ba-videorecorder-controlbar.rerecord": "redo",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Klik her for at gentage.",
                  "ba-videorecorder-controlbar.upload-covershot": "Upload",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Klik her for at uploade brugerdefinerede d&#xE6;kning shot",
                  "ba-videorecorder-controlbar.stop": "Stop",
                  "ba-videorecorder-controlbar.stop-tooltip": "Klik her for at stoppe.",
                  "ba-videorecorder-controlbar.skip": "Spring over",
                  "ba-videorecorder-controlbar.skip-tooltip": "Klik her for at springe.",
                  "ba-videorecorder.recorder-error": "Der opstod en fejl. Pr&#xF8;v venligst igen senere. Klik for at pr&#xF8;ve igen.",
                  "ba-videorecorder.attach-error": "Vi kunne ikke f&#xE5; adgang til kameraet interface. Afh&#xE6;ngigt af enheden og browseren, skal du muligvis installere Flash eller adgang til siden via SSL.",
                  "ba-videorecorder.access-forbidden": "Adgang til kameraet var forbudt. Klik for at pr&#xF8;ve igen.",
                  "ba-videorecorder.pick-covershot": "V&#xE6;lg en covershot.",
                  "ba-videorecorder.uploading": "Upload",
                  "ba-videorecorder.uploading-failed": "Upload mislykkedes - klik her for at pr&#xF8;ve igen.",
                  "ba-videorecorder.verifying": "Bekr&#xE6;ftelse",
                  "ba-videorecorder.verifying-failed": "mislykkedes verificering - klik her for at pr&#xF8;ve igen.",
                  "ba-videorecorder.rerecord-confirm": "&#xD8;nsker du virkelig at optage en ny video?",
                  "ba-videorecorder.video_file_too_large": "Din video filen er for stor (%s) - klik her for at pr&#xF8;ve igen med et mindre videofil.",
                  "ba-videorecorder.unsupported_video_type": "upload venligst: %s - klik her for at pr&#xF8;ve igen.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Afslut fuldsk&#xE6;rm",
                  "ba-videoplayer-share.share": "Del video",
                  "ba-videorecorder-chooser.record-screen": "Optagelsessk&#xE6;rm",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pause ikke underst&#xF8;ttet",
                  "ba-videorecorder-chooser.record-audio": "Optag lyd",
                  "ba-videorecorder-controlbar.stop-available-after": "Mindste optagetid er %d sekunder",
                  "ba-videorecorder-controlbar.cancel": "Afbestille",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Klik her for at annullere.",
                  "ba-videorecorder.cancel-confirm": "Vil du virkelig annullere din video upload?",
                  "ba-videoplayer-adslot.elapsed-time": "Forl&#xF8;bet tid",
                  "ba-videoplayer-adslot.volume-button": "Indstil lydstyrke",
                  "ba-videoplayer-adslot.volume-mute": "D&#xE6;mp lyd",
                  "ba-videoplayer-adslot.volume-unmute": "Sluk lyden",
                  "ba-videoplayer-adslot.ad-will-end-after": "Annoncen slutter efter %s",
                  "ba-videoplayer-adslot.can-skip-after": "Spring over efter %d",
                  "ba-videoplayer-adslot.skip-ad": "Spring annoncen over",
                  "ba-videorecorder.software-required": "Klik nedenfor for at installere / aktivere f&#xF8;lgende krav for at forts&#xE6;tte.",
                  "ba-videorecorder.software-waiting": "Venter p&#xE5; de krav, der skal installeres / aktiveres. Du skal m&#xE5;ske opdatere siden efter f&#xE6;rdigg&#xF8;relsen.",
                  "ba-videoplayer-controlbar.close-tracks": "Luk CC",
                  "ba-videoplayer-controlbar.show-tracks": "Vis CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Upload spor tekstfiler",
                  "ba-videoplayer-tracks.select-text-track-language": "Undertekstsprog",
                  "ba-videoplayer-tracks.info-select-locale-first": "V&#xE6;lg f&#xF8;rst lokalitet",
                  "ba-videoplayer-tracks.select-text-track-file": "Klik for at v&#xE6;lge fil",
                  "ba-videoplayer-tracks.back": "tilbage",
                  "ba-videorecorder.framerate-warning": "Videorammerhastigheden er meget lav. Vi anbefaler at lukke alle andre programmer og browser faner eller at bruge en hurtigere computer.",
                  "ba-videorecorder.upload-error-duration": "L&#xE6;ngden p&#xE5; den uploadede video opfylder ikke kravene - klik her for at pr&#xF8;ve igen.",
                  "ba-videorecorder.resolution-constraint-error": "Filen du har valgt stemmer ikke overens med den kr&#xE6;vede opl&#xF8;sning - klik her for at pr&#xF8;ve igen.",
                  "ba-videorecorder.orientation-portrait-required": "Venligst drej din enhed for at optage i st&#xE5;ende tilstand.",
                  "ba-videorecorder.orientation-landscape-required": "Venligst drej din enhed for at optage i liggende tilstand.",
                  "ba-imageviewer-controlbar.rerecord-image": "Redo?",
                  "ba-imageviewer-controlbar.submit-image": "Bekr&#xE6;fte",
                  "ba-imageviewer-controlbar.fullscreen-image": "Indtast fuldsk&#xE6;rm",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Afslut fuldsk&#xE6;rm",
                  "ba-imageviewer.image-error": "Der opstod en fejl. Pr&#xF8;v venligst igen senere. Klik for at pr&#xF8;ve igen.",
                  "ba-imagecapture-chooser.image-capture": "Capture Image",
                  "ba-imagecapture-chooser.upload-image": "Upload billede",
                  "ba-imagecapture-controlbar.settings": "Indstillinger",
                  "ba-imagecapture-controlbar.camerahealthy": "Belysning er god",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Belysning er ikke optimal",
                  "ba-imagecapture-controlbar.record": "Fange",
                  "ba-imagecapture-controlbar.record-tooltip": "Klik her for at fange.",
                  "ba-imagecapture-controlbar.rerecord": "redo",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Klik her for at gentage.",
                  "ba-imagecapture-controlbar.cancel": "Afbestille",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Klik her for at annullere.",
                  "ba-audioplayer-controlbar.audio-progress": "Fremskridt",
                  "ba-audioplayer-controlbar.rerecord-audio": "Redo?",
                  "ba-audioplayer-controlbar.submit-audio": "Bekr&#xE6;fte",
                  "ba-audioplayer-controlbar.play-audio": "Spille",
                  "ba-audioplayer-controlbar.pause-audio": "Pause",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pause ikke underst&#xF8;ttet",
                  "ba-audioplayer-controlbar.elapsed-time": "Forl&#xF8;bet tid",
                  "ba-audioplayer-controlbar.total-time": "Total l&#xE6;ngde p&#xE5;",
                  "ba-audioplayer-controlbar.volume-button": "Indstil lydstyrke",
                  "ba-audioplayer-controlbar.volume-mute": "D&#xE6;mp lyd",
                  "ba-audioplayer-controlbar.volume-unmute": "Sluk lyden",
                  "ba-audioplayer-loader.tooltip": "Indl&#xE6;ser...",
                  "ba-audioplayer.audio-error": "Der opstod en fejl. Pr&#xF8;v venligst igen senere. Klik for at pr&#xF8;ve igen.",
                  "ba-audiorecorder-chooser.record-audio": "Optag lyd",
                  "ba-audiorecorder-chooser.upload-audio": "Upload lyd",
                  "ba-audiorecorder-controlbar.settings": "Indstillinger",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Lyden er god",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Kan ikke hente nogen lyd",
                  "ba-audiorecorder-controlbar.record": "Optage",
                  "ba-audiorecorder-controlbar.record-tooltip": "Klik her for at optage.",
                  "ba-audiorecorder-controlbar.rerecord": "redo",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Klik her for at gentage.",
                  "ba-audiorecorder-controlbar.stop": "Hold op",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Klik her for at stoppe.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Mindste optagetid er %d sekunder",
                  "ba-audiorecorder-controlbar.cancel": "Afbestille",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Klik her for at annullere.",
                  "ba-videoplayer-controlbar.player-speed": "Spillerhastighed",
                  "ba-videoplayer-controlbar.settings": "Indstillinger",
                  "ba-videoplayer-controlbar.airplay": "airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay ikon.",
                  "ba-videoplayer.all-settings": "Alle indstillinger",
                  "ba-videoplayer.player-speed": "Spillerhastighed",
                  "ba-videoplayer.full-screen": "Fuld sk&#xE6;rm",
                  "ba-videorecorder-controlbar.add-stream": "Tilf&#xF8;j Stream",
                  "ba-videorecorder.switch-camera": "Skift kamera",
                  "ba-videorecorder.prepare-covershot": "Forbereder coverhots",
                  "ba-videorecorder.prepare-thumbnails": "Forbereder s&#xF8;ger miniaturer",
                  "ba-videorecorder.adding-new-stream": "Tilf&#xF8;jelse af ny str&#xF8;m",
                  "ba-imagecapture.recorder-error": "Der opstod en fejl. Pr&#xF8;v venligst igen senere. Klik for at pr&#xF8;ve igen.",
                  "ba-imagecapture.attach-error": "Vi kunne ikke f&#xE5; adgang til medieinterfacet. Afh&#xE6;ngigt af enhed og browser skal du muligvis installere Flash eller f&#xE5; adgang til siden via SSL.",
                  "ba-imagecapture.software-required": "Klik nedenfor for at installere / aktivere f&#xF8;lgende krav for at forts&#xE6;tte.",
                  "ba-imagecapture.software-waiting": "Venter p&#xE5; de krav, der skal installeres / aktiveres. Du skal m&#xE5;ske opdatere siden efter f&#xE6;rdigg&#xF8;relsen.",
                  "ba-imagecapture.access-forbidden": "Adgang til medierne var forbudt. Klik for at pr&#xF8;ve igen.",
                  "ba-imagecapture.uploading": "Upload",
                  "ba-imagecapture.uploading-failed": "Uploading mislykkedes - klik her for at pr&#xF8;ve igen.",
                  "ba-imagecapture.upload-error-duration": "L&#xE6;ngde p&#xE5; det uploadede billede opfylder ikke kravene - klik her for at pr&#xF8;ve igen.",
                  "ba-imagecapture.resolution-constraint-error": "Filen du har valgt stemmer ikke overens med den kr&#xE6;vede opl&#xF8;sning - klik her for at pr&#xF8;ve igen.",
                  "ba-imagecapture.verifying": "Bekr&#xE6;ftelse",
                  "ba-imagecapture.verifying-failed": "Bekr&#xE6;ftelse mislykkedes - klik her for at pr&#xF8;ve igen.",
                  "ba-imagecapture.rerecord-confirm": "Vil du virkelig genoptage dit billede?",
                  "ba-imagecapture.image_file_too_large": "Din billedfil er for stor (%s) - klik her for at pr&#xF8;ve igen med en mindre billedfil.",
                  "ba-imagecapture.unsupported_image_type": "Upload venligst: %s - klik her for at pr&#xF8;ve igen.",
                  "ba-imagecapture.orientation-portrait-required": "Venligst drej din enhed for at optage i st&#xE5;ende tilstand.",
                  "ba-imagecapture.orientation-landscape-required": "Venligst drej din enhed for at optage i liggende tilstand.",
                  "ba-audiorecorder.recorder-error": "Der opstod en fejl. Pr&#xF8;v venligst igen senere. Klik for at pr&#xF8;ve igen.",
                  "ba-audiorecorder.attach-error": "Vi kunne ikke f&#xE5; adgang til medieinterfacet. Afh&#xE6;ngigt af enhed og browser skal du muligvis installere Flash eller f&#xE5; adgang til siden via SSL.",
                  "ba-audiorecorder.software-required": "Klik nedenfor for at installere / aktivere f&#xF8;lgende krav for at forts&#xE6;tte.",
                  "ba-audiorecorder.software-waiting": "Venter p&#xE5; de krav, der skal installeres / aktiveres. Du skal m&#xE5;ske opdatere siden efter f&#xE6;rdigg&#xF8;relsen.",
                  "ba-audiorecorder.access-forbidden": "Adgang til medierne var forbudt. Klik for at pr&#xF8;ve igen.",
                  "ba-audiorecorder.uploading": "Upload",
                  "ba-audiorecorder.uploading-failed": "Uploading mislykkedes - klik her for at pr&#xF8;ve igen.",
                  "ba-audiorecorder.upload-error-duration": "L&#xE6;ngden p&#xE5; den uploadede lyd opfylder ikke kravene - klik her for at pr&#xF8;ve igen.",
                  "ba-audiorecorder.verifying": "Bekr&#xE6;ftelse",
                  "ba-audiorecorder.verifying-failed": "Bekr&#xE6;ftelse mislykkedes - klik her for at pr&#xF8;ve igen.",
                  "ba-audiorecorder.rerecord-confirm": "Vil du virkelig lave din lyd igen?",
                  "ba-audiorecorder.cancel-confirm": "Vil du virkelig annullere din lydopload?",
                  "ba-audiorecorder.audio_file_too_large": "Din lydfil er for stor (%s) - klik her for at pr&#xF8;ve igen med en mindre lydfil.",
                  "ba-audiorecorder.unsupported_audio_type": "Upload venligst: %s - klik her for at pr&#xF8;ve igen.",
                  "ba-common-settingsmenu.tooltip": "Klik for at spille.",
                  "ba-common-settingsmenu.setting-menu": "Alle indstillinger",
                  "ba-common-settingsmenu.source-quality": "Kildekvalitet",
                  "ba-common-settingsmenu.player-speed": "Spillerens hastighed",
                  "ba-common-settingsmenu.set-menu-option": "Indstil mulighed",
                  "ba-common-settingsmenu.submit-video": "Bekr&#xE6;ft video",
                  "ba-common-settingsmenu.picture-in-picture": "Billede i billede",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Afslut fuldsk&#xE6;rm",
                  "ba-common-settingsmenu.fullscreen-video": "G&#xE5; ind i fuld sk&#xE6;rm",
                  "ba-videorecorder-chooser.multi-stream": "Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Pause optager",
                  "ba-videorecorder-controlbar.resume-recorder": "Genoptag optager",
                  "ba-videorecorder.missing-track": "P&#xE5;kr&#xE6;vet lyd- eller videospor mangler",
                  "ba-videorecorder.device-already-in-use": "Mindst en af dine inputenheder er allerede i brug",
                  "ba-videorecorder.browser-permission-denied": "Tilladelse n&#xE6;gtet af browseren, giv venligst adgang og genindl&#xE6;s siden",
                  "ba-audioplayer.all-settings": "Alle indstillinger",
                  "ba-videoplayer-controlbar.remaining-time": "Resterende tid",
                  "ba-videoplayer-controlbar.select-frame": "V&#xE6;lg",
                  "ba-videoplayer-controlbar.trim-video": "Trimme",
                  "ba-videoplayer-playbutton.trim": "Trimme",
                  "ba-videoplayer-playbutton.skip": "Springe",
                  "ba-videorecorder-imagegallery.upload-covershot": "Upload d&#xE6;kning",
                  "ba-videorecorder.pick-covershot-frame": "V&#xE6;lg en ramme, der skal bruges som forsidebillede.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Screen recorder underst&#xF8;ttes ikke p&#xE5; denne enhed",
                  "ba-videorecorder.trim-prompt": "Vil du trimme din video?",
                  "ba-videorecorder.trim-video": "Flyt start- og slutmark&#xF8;rerne for at trimme din video",
                  "ba-videorecorder.wait-for-trim": "Venter p&#xE5; trimkommando ...",
                  "ba-videorecorder-controlbar.no-video-source": "Mangler yderligere videoindgangskilde",
                  "ba-videorecorder-controlbar.stream-already-selected": "Yderligere str&#xF8;m er allerede valgt",
                  "ba-videorecorder.uploading-src-error": "Kan ikke afspille video nu, og upload er stadig i gang",
                  "ba-audiorecorder-controlbar.pause-recorder": "Pause optager",
                  "ba-audiorecorder-controlbar.resume-recorder": "Genoptag optager"
                },
                "language:de": {
                  "ba-videoplayer-playbutton.tooltip": "Hier klicken um Wiedergabe zu starten.",
                  "ba-videoplayer-playbutton.rerecord": "Video neu aufnehmen",
                  "ba-videoplayer-playbutton.submit-video": "Video akzeptieren",
                  "ba-videoplayer-loader.tooltip": "Video wird geladen...",
                  "ba-videoplayer-controlbar.change-resolution": "Aufl&#xF6;sung anpassen",
                  "ba-videoplayer-controlbar.video-progress": "Videofortschritt",
                  "ba-videoplayer-controlbar.rerecord-video": "Video erneut aufnehmen?",
                  "ba-videoplayer-controlbar.submit-video": "Video akzeptieren",
                  "ba-videoplayer-controlbar.play-video": "Video wiedergeben",
                  "ba-videoplayer-controlbar.pause-video": "Video pausieren",
                  "ba-videoplayer-controlbar.elapsed-time": "Vergangene Zeit",
                  "ba-videoplayer-controlbar.total-time": "L&#xE4;nge des Videos",
                  "ba-videoplayer-controlbar.fullscreen-video": "Vollbildmodus",
                  "ba-videoplayer-controlbar.volume-button": "Lautst&#xE4;rke regulieren",
                  "ba-videoplayer-controlbar.volume-mute": "Ton abstellen",
                  "ba-videoplayer-controlbar.volume-unmute": "Ton wieder aktivieren",
                  "ba-videoplayer.video-error": "Es ist ein Fehler aufgetreten, bitte versuchen Sie es sp&#xE4;ter noch einmal. Hier klicken, um es noch einmal zu probieren.",
                  "ba-videorecorder-chooser.record-video": "Video aufnehmen",
                  "ba-videorecorder-chooser.upload-video": "Video hochladen",
                  "ba-videorecorder-controlbar.settings": "Einstellungen",
                  "ba-videorecorder-controlbar.camerahealthy": "Gute Beleuchtung",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Beleuchtung nicht optimal",
                  "ba-videorecorder-controlbar.microphonehealthy": "Soundqualit&#xE4;t einwandfrei",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Mikrofon bis jetzt stumm",
                  "ba-videorecorder-controlbar.record": "Video aufnehmen",
                  "ba-videorecorder-controlbar.record-tooltip": "Hier klicken um Aufnahme zu starten.",
                  "ba-videorecorder-controlbar.rerecord": "Video neu aufnehmen",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Hier klicken um Video erneut aufzunehmen.",
                  "ba-videorecorder-controlbar.upload-covershot": "Hochladen",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Hier klicken um einen Covershot hochzuladen.",
                  "ba-videorecorder-controlbar.stop": "Aufnahme stoppen",
                  "ba-videorecorder-controlbar.stop-tooltip": "Hier klicken um Aufnahme zu stoppen.",
                  "ba-videorecorder-controlbar.skip": "&#xDC;berspringen",
                  "ba-videorecorder-controlbar.skip-tooltip": "Hier klicken um zu &#xDC;berspringen.",
                  "ba-videorecorder.recorder-error": "Es ist ein Fehler aufgetreten, bitte versuchen Sie es sp&#xE4;ter noch einmal. Hier klicken, um es noch einmal zu probieren.",
                  "ba-videorecorder.attach-error": "Wir konnten nicht auf das Medieninterface zugreifen. Je nach Browser und Ger&#xE4;t muss m&#xF6;glicherweise Flash installiert oder die Seite &#xFC;ber SSL geladen werden.",
                  "ba-videorecorder.access-forbidden": "Zugriff auf das Medieninterface wurde verweigert. Hier klicken, um es noch einmal zu probieren.",
                  "ba-videorecorder.pick-covershot": "Bitte w&#xE4;hlen Sie einen Covershot aus.",
                  "ba-videorecorder.uploading": "Hochladen",
                  "ba-videorecorder.uploading-failed": "Hochladen fehlgeschlagen. Hier klicken, um es noch einmal zu probieren.",
                  "ba-videorecorder.verifying": "Verifizieren",
                  "ba-videorecorder.verifying-failed": "Verifizierung fehlgeschlagen. Hier klicken, um es noch einmal zu probieren.",
                  "ba-videorecorder.rerecord-confirm": "M&#xF6;chten Sie Ihr Video wirklich noch einmal aufnehmen?",
                  "ba-videorecorder.video_file_too_large": "Die angegebene Videodatei ist zu gro&#xDF; (%s). Hier klicken, um eine kleinere Videodatei hochzuladen.",
                  "ba-videorecorder.unsupported_video_type": "Bitte laden Sie Dateien des folgenden Typs hoch: %s. Hier klicken, um es noch einmal zu probieren.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Den Vollbildmous verlassen",
                  "ba-videoplayer-share.share": "Video teilen",
                  "ba-videorecorder-chooser.record-screen": "Bildschirm aufnehmen",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pause wird nicht unterst&#xFC;tzt",
                  "ba-videorecorder-chooser.record-audio": "Ton aufnehmen",
                  "ba-videorecorder-controlbar.stop-available-after": "Die minimale Aufnahmezeit ist %d Sekunden",
                  "ba-videorecorder-controlbar.cancel": "Stornieren",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Klicken Sie hier, um abzubrechen.",
                  "ba-videorecorder.cancel-confirm": "M&#xF6;chten Sie Ihren Video-Upload wirklich abbrechen?",
                  "ba-videoplayer-adslot.elapsed-time": "Elased Zeit",
                  "ba-videoplayer-adslot.volume-button": "Lautst&#xE4;rke einstellen",
                  "ba-videoplayer-adslot.volume-mute": "Ton stummschalten",
                  "ba-videoplayer-adslot.volume-unmute": "Ton nicht h&#xF6;ren",
                  "ba-videoplayer-adslot.ad-will-end-after": "Die Anzeige endet nach %s",
                  "ba-videoplayer-adslot.can-skip-after": "&#xDC;berspringen nach %d",
                  "ba-videoplayer-adslot.skip-ad": "&#xDC;berspringen",
                  "ba-videorecorder.software-required": "Bitte klicken Sie hier, um die folgenden Voraussetzungen zu installieren bzw. zu aktivieren.",
                  "ba-videorecorder.software-waiting": "Warte auf Abschluss der Installation bzw. der Aktivierung. M&#xF6;glicherweise m&#xFC;ssen Sie die Seite nach dem Abschluss aktualisieren.",
                  "ba-videoplayer-controlbar.close-tracks": "Schlie&#xDF;en CC",
                  "ba-videoplayer-controlbar.show-tracks": "Zeig CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Hochladen von Textdateien",
                  "ba-videoplayer-tracks.select-text-track-language": "Untertitelsprache",
                  "ba-videoplayer-tracks.info-select-locale-first": "W&#xE4;hlen Sie zuerst das Gebietsschema aus",
                  "ba-videoplayer-tracks.select-text-track-file": "Klicken Sie, um eine Datei auszuw&#xE4;hlen",
                  "ba-videoplayer-tracks.back": "zur&#xFC;ck",
                  "ba-videorecorder.framerate-warning": "Die Videobildrate ist sehr niedrig. Wir empfehlen, alle anderen Programme und Browser-Tabs zu schlie&#xDF;en oder einen schnelleren Computer zu verwenden.",
                  "ba-videorecorder.upload-error-duration": "Die L&#xE4;nge des hochgeladenen Videos entspricht nicht den Anforderungen. Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-videorecorder.resolution-constraint-error": "Die von Ihnen ausgew&#xE4;hlte Datei stimmt nicht mit der erforderlichen Aufl&#xF6;sung &#xFC;berein - klicken Sie hier, um es erneut zu versuchen.",
                  "ba-videorecorder.orientation-portrait-required": "Bitte drehen Sie Ihr Ger&#xE4;t, um im Hochformat aufzunehmen.",
                  "ba-videorecorder.orientation-landscape-required": "Bitte drehen Sie Ihr Ger&#xE4;t, um im Querformat aufzunehmen.",
                  "ba-imageviewer-controlbar.rerecord-image": "Wiederholen?",
                  "ba-imageviewer-controlbar.submit-image": "Best&#xE4;tigen",
                  "ba-imageviewer-controlbar.fullscreen-image": "Vollbildmodus aktivieren",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Vollbildmodus beenden",
                  "ba-imageviewer.image-error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es sp&#xE4;ter erneut. Klicken Sie, um es erneut zu versuchen.",
                  "ba-imagecapture-chooser.image-capture": "Bild aufnehmen",
                  "ba-imagecapture-chooser.upload-image": "Bild hochladen",
                  "ba-imagecapture-controlbar.settings": "die Einstellungen",
                  "ba-imagecapture-controlbar.camerahealthy": "Die Beleuchtung ist gut",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Die Beleuchtung ist nicht optimal",
                  "ba-imagecapture-controlbar.record": "Erfassung",
                  "ba-imagecapture-controlbar.record-tooltip": "Klicken Sie hier, um zu erfassen.",
                  "ba-imagecapture-controlbar.rerecord": "Wiederholen",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Klicken Sie hier, um den Vorgang zu wiederholen.",
                  "ba-imagecapture-controlbar.cancel": "Stornieren",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Klicken Sie hier, um abzubrechen.",
                  "ba-audioplayer-controlbar.audio-progress": "Fortschritt",
                  "ba-audioplayer-controlbar.rerecord-audio": "Wiederholen?",
                  "ba-audioplayer-controlbar.submit-audio": "Best&#xE4;tigen",
                  "ba-audioplayer-controlbar.play-audio": "abspielen",
                  "ba-audioplayer-controlbar.pause-audio": "Pause",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pause wird nicht unterst&#xFC;tzt",
                  "ba-audioplayer-controlbar.elapsed-time": "Elased Zeit",
                  "ba-audioplayer-controlbar.total-time": "Gesamtl&#xE4;nge von",
                  "ba-audioplayer-controlbar.volume-button": "Lautst&#xE4;rke einstellen",
                  "ba-audioplayer-controlbar.volume-mute": "Ton stummschalten",
                  "ba-audioplayer-controlbar.volume-unmute": "Ton nicht h&#xF6;ren",
                  "ba-audioplayer-loader.tooltip": "Wird geladen...",
                  "ba-audioplayer.audio-error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es sp&#xE4;ter erneut. Klicken Sie, um es erneut zu versuchen.",
                  "ba-audiorecorder-chooser.record-audio": "Ton aufnehmen",
                  "ba-audiorecorder-chooser.upload-audio": "Audio hochladen",
                  "ba-audiorecorder-controlbar.settings": "die Einstellungen",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Sound ist gut",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Kann keinen Ton aufnehmen",
                  "ba-audiorecorder-controlbar.record": "Aufzeichnung",
                  "ba-audiorecorder-controlbar.record-tooltip": "Klicken Sie hier, um aufzunehmen.",
                  "ba-audiorecorder-controlbar.rerecord": "Wiederholen",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Klicken Sie hier, um den Vorgang zu wiederholen.",
                  "ba-audiorecorder-controlbar.stop": "Halt",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Klicken Sie hier, um zu stoppen.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Die minimale Aufnahmezeit ist %d Sekunden",
                  "ba-audiorecorder-controlbar.cancel": "Stornieren",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Klicken Sie hier, um abzubrechen.",
                  "ba-videoplayer-controlbar.player-speed": "Wiedergabegeschwindigkeit",
                  "ba-videoplayer-controlbar.settings": "Einstellungen",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay-Symbol",
                  "ba-videoplayer.all-settings": "Einstellungen",
                  "ba-videoplayer.player-speed": "Wiedergabegeschwindigkeit",
                  "ba-videoplayer.full-screen": "Vollbild",
                  "ba-videorecorder-controlbar.add-stream": "Quelle hinzuf&#xFC;gen",
                  "ba-videorecorder.switch-camera": "Kamera wechseln",
                  "ba-videorecorder.prepare-covershot": "Covershots vorbereiten",
                  "ba-videorecorder.prepare-thumbnails": "Thumbnails vorbereiten",
                  "ba-videorecorder.adding-new-stream": "Neue Quelle hinzuf&#xFC;gen",
                  "ba-imagecapture.recorder-error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es sp&#xE4;ter erneut. Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-imagecapture.attach-error": "Wir konnten nicht auf die Medienschnittstelle zugreifen. Je nach Ger&#xE4;t und Browser m&#xFC;ssen Sie m&#xF6;glicherweise Flash installieren oder &#xFC;ber SSL auf die Seite zugreifen.",
                  "ba-imagecapture.software-required": "Klicken Sie unten, um die folgenden Voraussetzungen zu installieren / aktivieren, um fortzufahren.",
                  "ba-imagecapture.software-waiting": "Warten auf die Installation / Aktivierung der Anforderungen. M&#xF6;glicherweise m&#xFC;ssen Sie die Seite nach Abschluss aktualisieren.",
                  "ba-imagecapture.access-forbidden": "Der Zugang zu den Medien war verboten. Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-imagecapture.uploading": "Hochladen",
                  "ba-imagecapture.uploading-failed": "Hochladen fehlgeschlagen - Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-imagecapture.upload-error-duration": "Die L&#xE4;nge des hochgeladenen Bildes entspricht nicht den Anforderungen. Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-imagecapture.resolution-constraint-error": "Die ausgew&#xE4;hlte Datei entspricht nicht der erforderlichen Aufl&#xF6;sung. Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-imagecapture.verifying": "&#xDC;berpr&#xFC;fung",
                  "ba-imagecapture.verifying-failed": "&#xDC;berpr&#xFC;fung fehlgeschlagen - Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-imagecapture.rerecord-confirm": "M&#xF6;chten Sie Ihr Bild wirklich neu aufnehmen?",
                  "ba-imagecapture.image_file_too_large": "Ihre Bilddatei ist zu gro&#xDF; (%s). Klicken Sie hier, um es mit einer kleineren Bilddatei erneut zu versuchen.",
                  "ba-imagecapture.unsupported_image_type": "Bitte hochladen: %s - Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-imagecapture.orientation-portrait-required": "Bitte drehen Sie Ihr Ger&#xE4;t, um im Hochformat aufzunehmen.",
                  "ba-imagecapture.orientation-landscape-required": "Bitte drehen Sie Ihr Ger&#xE4;t, um im Querformat aufzunehmen.",
                  "ba-audiorecorder.recorder-error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es sp&#xE4;ter erneut. Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-audiorecorder.attach-error": "Wir konnten nicht auf die Medienschnittstelle zugreifen. Je nach Ger&#xE4;t und Browser m&#xFC;ssen Sie m&#xF6;glicherweise Flash installieren oder &#xFC;ber SSL auf die Seite zugreifen.",
                  "ba-audiorecorder.software-required": "Klicken Sie unten, um die folgenden Voraussetzungen zu installieren / aktivieren, um fortzufahren.",
                  "ba-audiorecorder.software-waiting": "Warten auf die Installation / Aktivierung der Anforderungen. M&#xF6;glicherweise m&#xFC;ssen Sie die Seite nach Abschluss aktualisieren.",
                  "ba-audiorecorder.access-forbidden": "Der Zugang zu den Medien war verboten. Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-audiorecorder.uploading": "Hochladen",
                  "ba-audiorecorder.uploading-failed": "Hochladen fehlgeschlagen - Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-audiorecorder.upload-error-duration": "Die L&#xE4;nge des hochgeladenen Audios entspricht nicht den Anforderungen. Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-audiorecorder.verifying": "&#xDC;berpr&#xFC;fung",
                  "ba-audiorecorder.verifying-failed": "&#xDC;berpr&#xFC;fung fehlgeschlagen - Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-audiorecorder.rerecord-confirm": "M&#xF6;chten Sie Ihr Audio wirklich wiederholen?",
                  "ba-audiorecorder.cancel-confirm": "M&#xF6;chten Sie Ihren Audio-Upload wirklich abbrechen?",
                  "ba-audiorecorder.audio_file_too_large": "Ihre Audiodatei ist zu gro&#xDF; (%s) - Klicken Sie hier, um es mit einer kleineren Audiodatei erneut zu versuchen.",
                  "ba-audiorecorder.unsupported_audio_type": "Bitte hochladen: %s - Klicken Sie hier, um es erneut zu versuchen.",
                  "ba-common-settingsmenu.tooltip": "Hier klicken um Wiedergabe zu starten.",
                  "ba-common-settingsmenu.setting-menu": "Einstellungen",
                  "ba-common-settingsmenu.source-quality": "Quellqualit&#xE4;t",
                  "ba-common-settingsmenu.player-speed": "Wiedergabegeschwindigkeit",
                  "ba-common-settingsmenu.set-menu-option": "Option einstellen",
                  "ba-common-settingsmenu.submit-video": "Video best&#xE4;tigen",
                  "ba-common-settingsmenu.picture-in-picture": "Bild im Bild",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Vollbildmous verlassen",
                  "ba-common-settingsmenu.fullscreen-video": "Vollbildmodus",
                  "ba-videorecorder-chooser.multi-stream": "Mehrfach-Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Aufnahme pausieren",
                  "ba-videorecorder-controlbar.resume-recorder": "Aufnahme fortsetzen",
                  "ba-videorecorder.missing-track": "Die erforderliche Audio- oder Videospur fehlt",
                  "ba-videorecorder.device-already-in-use": "Mindestens eines Ihrer Eingabeger&#xE4;te ist bereits in Gebrauch",
                  "ba-videorecorder.browser-permission-denied": "Zugriff wurde vom Browser verweigert, bitte erteilen Sie die Erlaubnis und laden Sie die Seite neu",
                  "ba-audioplayer.all-settings": "Einstellungen",
                  "ba-videoplayer-controlbar.remaining-time": "Verbleibende Zeit",
                  "ba-videoplayer-controlbar.select-frame": "W&#xE4;hlen",
                  "ba-videoplayer-controlbar.trim-video": "Trimmen",
                  "ba-videoplayer-playbutton.trim": "Trimmen",
                  "ba-videoplayer-playbutton.skip": "&#xDC;berspringen",
                  "ba-videorecorder-imagegallery.upload-covershot": "Cover hochladen",
                  "ba-videorecorder.pick-covershot-frame": "W&#xE4;hlen Sie ein Bild aus, das als Covershot verwendet werden soll.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Bildschirmaufnahme wird auf diesem Ger&#xE4;t nicht unterst&#xFC;tzt",
                  "ba-videorecorder.trim-prompt": "M&#xF6;chten Sie Ihr Video trimmen?",
                  "ba-videorecorder.trim-video": "Verschieben Sie die Start- und Endmarkierungen, um Ihr Video zu trimmen",
                  "ba-videorecorder.wait-for-trim": "Warten auf Trimmbefehl...",
                  "ba-videorecorder-controlbar.no-video-source": "Fehlende zus&#xE4;tzliche Videoeingangsquelle",
                  "ba-videorecorder-controlbar.stream-already-selected": "Zus&#xE4;tzlicher Stream wurde bereits ausgew&#xE4;hlt",
                  "ba-videorecorder.uploading-src-error": "Video kann jetzt nicht wiedergegeben werden, Upload l&#xE4;uft noch",
                  "ba-audiorecorder-controlbar.pause-recorder": "Recorder pausieren",
                  "ba-audiorecorder-controlbar.resume-recorder": "Lebenslauf-Recorder"
                },
                "language:el": {
                  "ba-videoplayer-playbutton.tooltip": "&#x39A;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3B1;&#x3C1;&#x3B1;&#x3B3;&#x3C9;&#x3B3;&#x3AE;.",
                  "ba-videoplayer-playbutton.rerecord": "&#x395;&#x3C0;&#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3B7;&#x3C8;&#x3B7;",
                  "ba-videoplayer-playbutton.submit-video": "&#x395;&#x3C0;&#x3B9;&#x3B2;&#x3B5;&#x3B2;&#x3B1;&#x3B9;&#x3CE;&#x3C3;&#x3C4;&#x3B5; &#x3C4;&#x3BF; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF;",
                  "ba-videoplayer-loader.tooltip": "&#x3A6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7;...",
                  "ba-videoplayer-controlbar.change-resolution": "&#x391;&#x3BB;&#x3BB;&#x3B1;&#x3B3;&#x3AE; &#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3C5;&#x3C3;&#x3B7;&#x3C2;",
                  "ba-videoplayer-controlbar.video-progress": "&#x3A0;&#x3C1;&#x3CC;&#x3BF;&#x3B4;&#x3BF;&#x3C2;",
                  "ba-videoplayer-controlbar.rerecord-video": "&#x395;&#x3C0;&#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3B7;&#x3C8;&#x3B7;;",
                  "ba-videoplayer-controlbar.submit-video": "&#x395;&#x3C0;&#x3B9;&#x3B2;&#x3B5;&#x3B2;&#x3B1;&#x3AF;&#x3C9;&#x3C3;&#x3B7;",
                  "ba-videoplayer-controlbar.play-video": "&#x391;&#x3BD;&#x3B1;&#x3C0;&#x3B1;&#x3C1;&#x3B1;&#x3B3;&#x3C9;&#x3B3;&#x3AE;",
                  "ba-videoplayer-controlbar.pause-video": "&#x3A0;&#x3C1;&#x3BF;&#x3C3;&#x3C9;&#x3C1;&#x3B9;&#x3BD;&#x3AE; &#x3C0;&#x3B1;&#x3CD;&#x3C3;&#x3B7;",
                  "ba-videoplayer-controlbar.elapsed-time": "&#x3A7;&#x3C1;&#x3CC;&#x3BD;&#x3BF;&#x3C2; &#x3C0;&#x3BF;&#x3C5; &#x3C0;&#x3B1;&#x3C1;&#x3AE;&#x3BB;&#x3B8;&#x3B5;",
                  "ba-videoplayer-controlbar.total-time": "&#x3A3;&#x3C5;&#x3BD;&#x3BF;&#x3BB;&#x3B9;&#x3BA;&#x3AE; &#x3B4;&#x3B9;&#x3AC;&#x3C1;&#x3BA;&#x3B5;&#x3B9;&#x3B1; &#x3C4;&#x3BF;&#x3C5;",
                  "ba-videoplayer-controlbar.fullscreen-video": "&#x39C;&#x3B5;&#x3C4;&#x3AC;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3B5; &#x3C0;&#x3BB;&#x3AE;&#x3C1;&#x3B7; &#x3BF;&#x3B8;&#x3CC;&#x3BD;&#x3B7;",
                  "ba-videoplayer-controlbar.volume-button": "&#x39F;&#x3C1;&#x3B9;&#x3C3;&#x3BC;&#x3CC;&#x3C2; &#x3AD;&#x3BD;&#x3C4;&#x3B1;&#x3C3;&#x3B7;&#x3C2;",
                  "ba-videoplayer-controlbar.volume-mute": "&#x3A3;&#x3AF;&#x3B3;&#x3B1;&#x3C3;&#x3B7; &#x3AE;&#x3C7;&#x3BF;&#x3C5;",
                  "ba-videoplayer-controlbar.volume-unmute": "&#x391;&#x3BD;&#x3B1;&#x3AF;&#x3C1;&#x3B5;&#x3C3;&#x3B7; &#x3C3;&#x3AF;&#x3B3;&#x3B1;&#x3C3;&#x3B7;&#x3C2; &#x3AE;&#x3C7;&#x3BF;&#x3C5;",
                  "ba-videoplayer.video-error": "&#x3A3;&#x3C5;&#x3BD;&#x3AD;&#x3B2;&#x3B7; &#x3BA;&#x3AC;&#x3C0;&#x3BF;&#x3B9;&#x3BF; &#x3BB;&#x3AC;&#x3B8;&#x3BF;&#x3C2;, &#x3C0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3B1;&#x3BB;&#x3BF;&#x3CD;&#x3BC;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3C4;&#x3B5; &#x3B1;&#x3C1;&#x3B3;&#x3CC;&#x3C4;&#x3B5;&#x3C1;&#x3B1;. &#x39A;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3BE;&#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5;.",
                  "ba-videorecorder-chooser.record-video": "&#x395;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF;",
                  "ba-videorecorder-chooser.upload-video": "&#x39C;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF;",
                  "ba-videorecorder-controlbar.settings": "&#x3A1;&#x3C5;&#x3B8;&#x3BC;&#x3AF;&#x3C3;&#x3B5;&#x3B9;&#x3C2;",
                  "ba-videorecorder-controlbar.camerahealthy": "&#x39F; &#x3C6;&#x3C9;&#x3C4;&#x3B9;&#x3C3;&#x3BC;&#x3CC;&#x3C2; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3BA;&#x3B1;&#x3BB;&#x3CC;&#x3C2;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "&#x39F; &#x3C6;&#x3C9;&#x3C4;&#x3B9;&#x3C3;&#x3BC;&#x3CC;&#x3C2; &#x3B4;&#x3B5;&#x3BD; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3B9;&#x3BA;&#x3B1;&#x3BD;&#x3BF;&#x3C0;&#x3BF;&#x3B9;&#x3B7;&#x3C4;&#x3B9;&#x3BA;&#x3CC;&#x3C2;",
                  "ba-videorecorder-controlbar.microphonehealthy": "&#x39F; &#x3AE;&#x3C7;&#x3BF;&#x3C2; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3BA;&#x3B1;&#x3BB;&#x3CC;&#x3C2;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "&#x394;&#x3B5;&#x3BD; &#x3B1;&#x3BA;&#x3BF;&#x3CD;&#x3B3;&#x3B5;&#x3C4;&#x3B1;&#x3B9; &#x3BA;&#x3B1;&#x3B8;&#x3CC;&#x3BB;&#x3BF;&#x3C5; &#x3AE;&#x3C7;&#x3BF;&#x3C2;",
                  "ba-videorecorder-controlbar.record": "&#x395;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE;",
                  "ba-videorecorder-controlbar.record-tooltip": "&#x39A;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE;.",
                  "ba-videorecorder-controlbar.rerecord": "&#x395;&#x3C0;&#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3B7;&#x3C8;&#x3B7;",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "&#x39A;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3B7;&#x3C8;&#x3B7;.",
                  "ba-videorecorder-controlbar.upload-covershot": "&#x39C;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7;",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#x39A;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3BC;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3BF;&#x3C1;&#x3C4;&#x3CE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BC;&#x3AF;&#x3B1; &#x3B4;&#x3B9;&#x3BA;&#x3AE; &#x3C3;&#x3B1;&#x3C2; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1; &#x3B5;&#x3C0;&#x3B9;&#x3C3;&#x3BA;&#x3CC;&#x3C0;&#x3B7;&#x3C3;&#x3B7;&#x3C2;",
                  "ba-videorecorder-controlbar.stop": "&#x394;&#x3B9;&#x3B1;&#x3BA;&#x3BF;&#x3C0;&#x3AE;",
                  "ba-videorecorder-controlbar.stop-tooltip": "&#x39A;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3B4;&#x3B9;&#x3B1;&#x3BA;&#x3BF;&#x3C0;&#x3AE;.",
                  "ba-videorecorder-controlbar.skip": "&#x3A0;&#x3B1;&#x3C1;&#x3AC;&#x3BB;&#x3B5;&#x3B9;&#x3C8;&#x3B7;",
                  "ba-videorecorder-controlbar.skip-tooltip": "&#x39A;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3C0;&#x3B1;&#x3C1;&#x3AC;&#x3BB;&#x3B5;&#x3B9;&#x3C8;&#x3B7;.",
                  "ba-videorecorder.recorder-error": "&#x3A3;&#x3C5;&#x3BD;&#x3AD;&#x3B2;&#x3B7; &#x3BA;&#x3AC;&#x3C0;&#x3BF;&#x3B9;&#x3BF; &#x3BB;&#x3AC;&#x3B8;&#x3BF;&#x3C2;, &#x3C0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3B1;&#x3BB;&#x3BF;&#x3CD;&#x3BC;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3C4;&#x3B5; &#x3B1;&#x3C1;&#x3B3;&#x3CC;&#x3C4;&#x3B5;&#x3C1;&#x3B1;. &#x39A;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3BE;&#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5;.",
                  "ba-videorecorder.attach-error": "&#x394;&#x3B5;&#x3BD; &#x3BC;&#x3C0;&#x3BF;&#x3C1;&#x3AD;&#x3C3;&#x3B1;&#x3BC;&#x3B5; &#x3BD;&#x3B1; &#x3B1;&#x3C0;&#x3BF;&#x3BA;&#x3C4;&#x3AE;&#x3C3;&#x3BF;&#x3C5;&#x3BC;&#x3B5; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3C4;&#x3B7;&#x3BD; &#x3BA;&#x3AC;&#x3BC;&#x3B5;&#x3C1;&#x3B1;. &#x391;&#x3BD;&#x3AC;&#x3BB;&#x3BF;&#x3B3;&#x3B1; &#x3BC;&#x3B5; &#x3C4;&#x3B7; &#x3C3;&#x3C5;&#x3C3;&#x3BA;&#x3B5;&#x3C5;&#x3AE; &#x3BA;&#x3B1;&#x3B9; &#x3C4;&#x3BF;&#x3BD; browser &#x3C0;&#x3BF;&#x3C5; &#x3C7;&#x3C1;&#x3B7;&#x3C3;&#x3B9;&#x3BC;&#x3BF;&#x3C0;&#x3BF;&#x3B9;&#x3B5;&#x3AF;&#x3C4;&#x3B5;, &#x3BC;&#x3C0;&#x3BF;&#x3C1;&#x3B5;&#x3AF; &#x3BD;&#x3B1; &#x3C7;&#x3C1;&#x3B5;&#x3B9;&#x3B1;&#x3C3;&#x3C4;&#x3B5;&#x3AF; &#x3BD;&#x3B1; &#x3B5;&#x3B3;&#x3BA;&#x3B1;&#x3C4;&#x3B1;&#x3C3;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3BF; Flash &#x3AE; &#x3BD;&#x3B1; &#x3BC;&#x3C0;&#x3B5;&#x3AF;&#x3C4;&#x3B5; &#x3C3;&#x3C4;&#x3B7; &#x3C3;&#x3B5;&#x3BB;&#x3AF;&#x3B4;&#x3B1; &#x3BC;&#x3AD;&#x3C3;&#x3C9; SSL.",
                  "ba-videorecorder.access-forbidden": "&#x394;&#x3B5;&#x3BD; &#x3B5;&#x3C0;&#x3B9;&#x3C4;&#x3C1;&#x3AC;&#x3C0;&#x3B7;&#x3BA;&#x3B5; &#x3B7; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3C4;&#x3B7;&#x3BD; &#x3BA;&#x3AC;&#x3BC;&#x3B5;&#x3C1;&#x3B1;. &#x39A;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3BE;&#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3C4;&#x3B5;.",
                  "ba-videorecorder.pick-covershot": "&#x395;&#x3C0;&#x3B9;&#x3BB;&#x3AD;&#x3BE;&#x3C4;&#x3B5; &#x3BC;&#x3B9;&#x3B1; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1; &#x3B5;&#x3C0;&#x3B9;&#x3C3;&#x3BA;&#x3CC;&#x3C0;&#x3B7;&#x3C3;&#x3B7;&#x3C2;.",
                  "ba-videorecorder.uploading": "&#x39C;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7;",
                  "ba-videorecorder.uploading-failed": "&#x397; &#x3BC;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7; &#x3B1;&#x3C0;&#x3AD;&#x3C4;&#x3C5;&#x3C7;&#x3B5; - &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3BE;&#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5;.",
                  "ba-videorecorder.verifying": "&#x395;&#x3C0;&#x3B9;&#x3B2;&#x3B5;&#x3B2;&#x3B1;&#x3AF;&#x3C9;&#x3C3;&#x3B7;",
                  "ba-videorecorder.verifying-failed": "&#x397; &#x3B5;&#x3C0;&#x3B9;&#x3B2;&#x3B5;&#x3B2;&#x3B1;&#x3AF;&#x3C9;&#x3C3;&#x3B7; &#x3B1;&#x3C0;&#x3AD;&#x3C4;&#x3C5;&#x3C7;&#x3B5;- &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3BE;&#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5;.",
                  "ba-videorecorder.rerecord-confirm": "&#x3A3;&#x3AF;&#x3B3;&#x3BF;&#x3BF;&#x3C5;&#x3C1;&#x3B1; &#x3B8;&#x3AD;&#x3BB;&#x3B5;&#x3C4;&#x3B5; &#x3BD;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3B1;&#x3BB;&#x3AC;&#x3B2;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3B7; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF;-&#x3BB;&#x3AE;&#x3C8;&#x3B7;;",
                  "ba-videorecorder.video_file_too_large": "&#x3A4;&#x3BF; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3C0;&#x3BF;&#x3BB;&#x3CD; &#x3BC;&#x3B5;&#x3B3;&#x3AC;&#x3BB;&#x3BF; (%s) - &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3BE;&#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BC;&#x3B5; &#x3AD;&#x3BD;&#x3B1; &#x3BC;&#x3B5;&#x3B3;&#x3B1;&#x3BB;&#x3CD;&#x3C4;&#x3B5;&#x3C1;&#x3BF;  &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF;.",
                  "ba-videorecorder.unsupported_video_type": "&#x3A0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3B1;&#x3BB;&#x3BF;&#x3CD;&#x3BC;&#x3B5; &#x3BC;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3BF;&#x3C1;&#x3C4;&#x3CE;&#x3C3;&#x3C4;&#x3B5;: %s - &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3BE;&#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5;.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "&#x388;&#x3BE;&#x3BF;&#x3B4;&#x3BF;&#x3C2; &#x3B1;&#x3C0;&#x3CC; &#x3C0;&#x3BB;&#x3AE;&#x3C1;&#x3B7; &#x3BF;&#x3B8;&#x3CC;&#x3BD;&#x3B7;",
                  "ba-videoplayer-share.share": "&#x394;&#x3B9;&#x3B1;&#x3BC;&#x3BF;&#x3B9;&#x3C1;&#x3B1;&#x3C3;&#x3BC;&#x3CC;&#x3C2;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "&#x397; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C9;&#x3C1;&#x3B9;&#x3BD;&#x3AE; &#x3C0;&#x3B1;&#x3CD;&#x3C3;&#x3B7; &#x3B4;&#x3B5;&#x3BD; &#x3C5;&#x3C0;&#x3BF;&#x3C3;&#x3B7;&#x3C1;&#x3AF;&#x3B6;&#x3B5;&#x3C4;&#x3B1;&#x3B9;",
                  "ba-videorecorder-chooser.record-audio": "&#x395;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE; &#x3AE;&#x3C7;&#x3BF;&#x3C5;",
                  "ba-videorecorder-chooser.record-screen": "&#x39F;&#x3B8;&#x3CC;&#x3BD;&#x3B7; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE;&#x3C2;",
                  "ba-videorecorder-controlbar.stop-available-after": "&#x39F; &#x3B5;&#x3BB;&#x3AC;&#x3C7;&#x3B9;&#x3C3;&#x3C4;&#x3BF;&#x3C2; &#x3C7;&#x3C1;&#x3CC;&#x3BD;&#x3BF;&#x3C2; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE;&#x3C2; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; %d &#x3B4;&#x3B5;&#x3C5;&#x3C4;&#x3B5;&#x3C1;&#x3CC;&#x3BB;&#x3B5;&#x3C0;&#x3C4;&#x3B1;",
                  "ba-videorecorder-controlbar.cancel": "&#x39C;&#x3B1;&#x3C4;&#x3B1;&#x3AF;&#x3C9;&#x3C3;&#x3B7;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3B1;&#x3BA;&#x3CD;&#x3C1;&#x3C9;&#x3C3;&#x3B7;.",
                  "ba-videorecorder.cancel-confirm": "&#x398;&#x3AD;&#x3BB;&#x3B5;&#x3C4;&#x3B5; &#x3C0;&#x3C1;&#x3B1;&#x3B3;&#x3BC;&#x3B1;&#x3C4;&#x3B9;&#x3BA;&#x3AC; &#x3BD;&#x3B1; &#x3B1;&#x3BA;&#x3C5;&#x3C1;&#x3CE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3B7; &#x3BC;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7; &#x3C4;&#x3BF;&#x3C5; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3CC; &#x3C3;&#x3B1;&#x3C2;;",
                  "ba-videoplayer-adslot.elapsed-time": "&#x3A7;&#x3C1;&#x3CC;&#x3BD;&#x3BF;&#x3C2; &#x3C0;&#x3BF;&#x3C5; &#x3C0;&#x3B1;&#x3C1;&#x3AE;&#x3BB;&#x3B8;&#x3B5;",
                  "ba-videoplayer-adslot.volume-button": "&#x3A1;&#x3CD;&#x3B8;&#x3BC;&#x3B9;&#x3C3;&#x3B7; &#x3AD;&#x3BD;&#x3C4;&#x3B1;&#x3C3;&#x3B7;&#x3C2;",
                  "ba-videoplayer-adslot.volume-mute": "&#x3A3;&#x3AF;&#x3B3;&#x3B1;&#x3C3;&#x3B7; &#x3AE;&#x3C7;&#x3BF;&#x3C5;",
                  "ba-videoplayer-adslot.volume-unmute": "&#x3A3;&#x3AF;&#x3B3;&#x3B1;&#x3C3;&#x3B7; &#x3AE;&#x3C7;&#x3BF;&#x3C5;",
                  "ba-videoplayer-adslot.ad-will-end-after": "&#x397; &#x3B4;&#x3B9;&#x3B1;&#x3C6;&#x3AE;&#x3BC;&#x3B9;&#x3C3;&#x3B7; &#x3B8;&#x3B1; &#x3BB;&#x3AE;&#x3BE;&#x3B5;&#x3B9; &#x3BC;&#x3B5;&#x3C4;&#x3AC; &#x3C4;&#x3BF; %s",
                  "ba-videoplayer-adslot.can-skip-after": "&#x3A0;&#x3B1;&#x3C1;&#x3AC;&#x3BB;&#x3B5;&#x3B9;&#x3C8;&#x3B7; &#x3BC;&#x3B5;&#x3C4;&#x3AC; &#x3C4;&#x3BF; %d",
                  "ba-videoplayer-adslot.skip-ad": "&#x3A0;&#x3B1;&#x3C1;&#x3AC;&#x3BA;&#x3B1;&#x3BC;&#x3C8;&#x3B7; &#x3B4;&#x3B9;&#x3B1;&#x3C6;&#x3AE;&#x3BC;&#x3B9;&#x3C3;&#x3B7;&#x3C2;",
                  "ba-videorecorder.software-required": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3C0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3AC;&#x3C4;&#x3C9; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3B5;&#x3B3;&#x3BA;&#x3B1;&#x3C4;&#x3B1;&#x3C3;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; / &#x3B5;&#x3BD;&#x3B5;&#x3C1;&#x3B3;&#x3BF;&#x3C0;&#x3BF;&#x3B9;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3B9;&#x3C2; &#x3B1;&#x3BA;&#x3CC;&#x3BB;&#x3BF;&#x3C5;&#x3B8;&#x3B5;&#x3C2; &#x3B1;&#x3C0;&#x3B1;&#x3B9;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3B9;&#x3C2; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C7;&#x3C9;&#x3C1;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5;.",
                  "ba-videorecorder.software-waiting": "&#x391;&#x3BD;&#x3B1;&#x3BC;&#x3BF;&#x3BD;&#x3AE; &#x3B3;&#x3B9;&#x3B1; &#x3C4;&#x3B7;&#x3BD; &#x3B5;&#x3B3;&#x3BA;&#x3B1;&#x3C4;&#x3AC;&#x3C3;&#x3C4;&#x3B1;&#x3C3;&#x3B7; / &#x3B5;&#x3BD;&#x3B5;&#x3C1;&#x3B3;&#x3BF;&#x3C0;&#x3BF;&#x3AF;&#x3B7;&#x3C3;&#x3B7; &#x3C4;&#x3C9;&#x3BD; &#x3B1;&#x3C0;&#x3B1;&#x3B9;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3C9;&#x3BD;. &#x38A;&#x3C3;&#x3C9;&#x3C2; &#x3C7;&#x3C1;&#x3B5;&#x3B9;&#x3B1;&#x3C3;&#x3C4;&#x3B5;&#x3AF; &#x3BD;&#x3B1; &#x3B1;&#x3BD;&#x3B1;&#x3BD;&#x3B5;&#x3CE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3B7; &#x3C3;&#x3B5;&#x3BB;&#x3AF;&#x3B4;&#x3B1; &#x3BC;&#x3B5;&#x3C4;&#x3AC; &#x3C4;&#x3B7;&#x3BD; &#x3BF;&#x3BB;&#x3BF;&#x3BA;&#x3BB;&#x3AE;&#x3C1;&#x3C9;&#x3C3;&#x3B7;.",
                  "ba-videoplayer-controlbar.close-tracks": "&#x39A;&#x3BB;&#x3B5;&#x3AF;&#x3C3;&#x3B9;&#x3BC;&#x3BF; CC",
                  "ba-videoplayer-controlbar.show-tracks": "&#x395;&#x3BC;&#x3C6;&#x3AC;&#x3BD;&#x3B9;&#x3C3;&#x3B7; CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "&#x391;&#x3BD;&#x3B5;&#x3B2;&#x3AC;&#x3C3;&#x3C4;&#x3B5; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3B1; &#x3BA;&#x3B5;&#x3B9;&#x3BC;&#x3AD;&#x3BD;&#x3BF;&#x3C5; &#x3BA;&#x3BF;&#x3BC;&#x3BC;&#x3B1;&#x3C4;&#x3B9;&#x3BF;&#x3CD;",
                  "ba-videoplayer-tracks.select-text-track-language": "&#x393;&#x3BB;&#x3CE;&#x3C3;&#x3C3;&#x3B1; &#x3C5;&#x3C0;&#x3BF;&#x3C4;&#x3AF;&#x3C4;&#x3BB;&#x3C9;&#x3BD;",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x3A0;&#x3C1;&#x3CE;&#x3C4;&#x3B1; &#x3B5;&#x3C0;&#x3B9;&#x3BB;&#x3AD;&#x3BE;&#x3C4;&#x3B5; &#x3C4;&#x3BF;&#x3C0;&#x3B9;&#x3BA;&#x3AD;&#x3C2; &#x3C1;&#x3C5;&#x3B8;&#x3BC;&#x3AF;&#x3C3;&#x3B5;&#x3B9;&#x3C2;",
                  "ba-videoplayer-tracks.select-text-track-file": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3B5;&#x3C0;&#x3B9;&#x3BB;&#x3AD;&#x3BE;&#x3B5;&#x3C4;&#x3B5; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF;",
                  "ba-videoplayer-tracks.back": "&#x3C0;&#x3AF;&#x3C3;&#x3C9;",
                  "ba-videorecorder.framerate-warning": "&#x39F; &#x3C1;&#x3C5;&#x3B8;&#x3BC;&#x3CC;&#x3C2; &#x3BA;&#x3B1;&#x3C1;&#x3AD; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3C0;&#x3BF;&#x3BB;&#x3CD; &#x3C7;&#x3B1;&#x3BC;&#x3B7;&#x3BB;&#x3CC;&#x3C2;. &#x3A3;&#x3B1;&#x3C2; &#x3C3;&#x3C5;&#x3BD;&#x3B9;&#x3C3;&#x3C4;&#x3BF;&#x3CD;&#x3BC;&#x3B5; &#x3BD;&#x3B1; &#x3BA;&#x3BB;&#x3B5;&#x3AF;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3CC;&#x3BB;&#x3B1; &#x3C4;&#x3B1; &#x3AC;&#x3BB;&#x3BB;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3B3;&#x3C1;&#x3AC;&#x3BC;&#x3BC;&#x3B1;&#x3C4;&#x3B1; &#x3BA;&#x3B1;&#x3B9; &#x3C4;&#x3B9;&#x3C2; &#x3BA;&#x3B1;&#x3C1;&#x3C4;&#x3AD;&#x3BB;&#x3B5;&#x3C2; &#x3C4;&#x3BF;&#x3C5; &#x3C0;&#x3C1;&#x3BF;&#x3B3;&#x3C1;&#x3AC;&#x3BC;&#x3BC;&#x3B1;&#x3C4;&#x3BF;&#x3C2; &#x3C0;&#x3B5;&#x3C1;&#x3B9;&#x3AE;&#x3B3;&#x3B7;&#x3C3;&#x3B7;&#x3C2; &#x3AE; &#x3BD;&#x3B1; &#x3C7;&#x3C1;&#x3B7;&#x3C3;&#x3B9;&#x3BC;&#x3BF;&#x3C0;&#x3BF;&#x3B9;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3AD;&#x3BD;&#x3B1;&#x3BD; &#x3B3;&#x3C1;&#x3B7;&#x3B3;&#x3BF;&#x3C1;&#x3CC;&#x3C4;&#x3B5;&#x3C1;&#x3BF; &#x3C5;&#x3C0;&#x3BF;&#x3BB;&#x3BF;&#x3B3;&#x3B9;&#x3C3;&#x3C4;&#x3AE;.",
                  "ba-videorecorder.upload-error-duration": "&#x3A4;&#x3BF; &#x3BC;&#x3AE;&#x3BA;&#x3BF;&#x3C2; &#x3C4;&#x3BF;&#x3C5; &#x3BC;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3BF;&#x3C1;&#x3C4;&#x3C9;&#x3BC;&#x3AD;&#x3BD;&#x3BF;&#x3C5; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF; &#x3B4;&#x3B5;&#x3BD; &#x3C0;&#x3BB;&#x3B7;&#x3C1;&#x3BF;&#x3AF; &#x3C4;&#x3B9;&#x3C2; &#x3B1;&#x3C0;&#x3B1;&#x3B9;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3B9;&#x3C2; - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;.",
                  "ba-videorecorder.resolution-constraint-error": "&#x3A4;&#x3BF; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF; &#x3C0;&#x3BF;&#x3C5; &#x3B5;&#x3C0;&#x3B9;&#x3BB;&#x3AD;&#x3BE;&#x3B1;&#x3C4;&#x3B5; &#x3B4;&#x3B5;&#x3BD; &#x3C4;&#x3B1;&#x3B9;&#x3C1;&#x3B9;&#x3AC;&#x3B6;&#x3B5;&#x3B9; &#x3BC;&#x3B5; &#x3C4;&#x3B7;&#x3BD; &#x3B1;&#x3C0;&#x3B1;&#x3B9;&#x3C4;&#x3BF;&#x3CD;&#x3BC;&#x3B5;&#x3BD;&#x3B7; &#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3C5;&#x3C3;&#x3B7; - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;.",
                  "ba-videorecorder.orientation-portrait-required": "&#x3A0;&#x3B5;&#x3C1;&#x3B9;&#x3C3;&#x3C4;&#x3C1;&#x3AD;&#x3C8;&#x3C4;&#x3B5; &#x3C4;&#x3B7; &#x3C3;&#x3C5;&#x3C3;&#x3BA;&#x3B5;&#x3C5;&#x3AE; &#x3C3;&#x3B1;&#x3C2; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE; &#x3C3;&#x3B5; &#x3BA;&#x3B1;&#x3C4;&#x3B1;&#x3BA;&#x3CC;&#x3C1;&#x3C5;&#x3C6;&#x3B7; &#x3BB;&#x3B5;&#x3B9;&#x3C4;&#x3BF;&#x3C5;&#x3C1;&#x3B3;&#x3AF;&#x3B1;.",
                  "ba-videorecorder.orientation-landscape-required": "&#x3A0;&#x3B5;&#x3C1;&#x3B9;&#x3C3;&#x3C4;&#x3C1;&#x3AD;&#x3C8;&#x3C4;&#x3B5; &#x3C4;&#x3B7; &#x3C3;&#x3C5;&#x3C3;&#x3BA;&#x3B5;&#x3C5;&#x3AE; &#x3C3;&#x3B1;&#x3C2; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE; &#x3C3;&#x3B5; &#x3BF;&#x3C1;&#x3B9;&#x3B6;&#x3CC;&#x3BD;&#x3C4;&#x3B9;&#x3B1; &#x3BB;&#x3B5;&#x3B9;&#x3C4;&#x3BF;&#x3C5;&#x3C1;&#x3B3;&#x3AF;&#x3B1;.",
                  "ba-imageviewer-controlbar.rerecord-image": "&#x39E;&#x3B1;&#x3BD;&#x3B1;&#x3BA;&#x3AC;&#x3BD;&#x3C9;?",
                  "ba-imageviewer-controlbar.submit-image": "&#x395;&#x3C0;&#x3B9;&#x3B2;&#x3B5;&#x3B2;&#x3B1;&#x3B9;&#x3CE;&#x3BD;&#x3C9;",
                  "ba-imageviewer-controlbar.fullscreen-image": "&#x395;&#x3B9;&#x3C3;&#x3B1;&#x3B3;&#x3AC;&#x3B3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3B7;&#x3BD; &#x3C0;&#x3BB;&#x3AE;&#x3C1;&#x3B7; &#x3BF;&#x3B8;&#x3CC;&#x3BD;&#x3B7;",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "&#x388;&#x3BE;&#x3BF;&#x3B4;&#x3BF;&#x3C2; &#x3B1;&#x3C0;&#x3CC; &#x3C0;&#x3BB;&#x3AE;&#x3C1;&#x3B7; &#x3BF;&#x3B8;&#x3CC;&#x3BD;&#x3B7;",
                  "ba-imageviewer.image-error": "&#x395;&#x3BC;&#x3C6;&#x3B1;&#x3BD;&#x3AF;&#x3C3;&#x3C4;&#x3B7;&#x3BA;&#x3B5; &#x3BA;&#x3AC;&#x3C0;&#x3BF;&#x3B9;&#x3BF; &#x3C3;&#x3C6;&#x3AC;&#x3BB;&#x3BC;&#x3B1;. &#x3A0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3B1;&#x3BB;&#x3CE; &#x3B4;&#x3BF;&#x3BA;&#x3B9;&#x3BC;&#x3AC;&#x3C3;&#x3C4;&#x3B5; &#x3B1;&#x3C1;&#x3B3;&#x3CC;&#x3C4;&#x3B5;&#x3C1;&#x3B1;. &#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3B7;&#x3C8;&#x3B7;.",
                  "ba-imagecapture-chooser.image-capture": "&#x39B;&#x3AE;&#x3C8;&#x3B7; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1;&#x3C2;",
                  "ba-imagecapture-chooser.upload-image": "&#x39C;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1;&#x3C2;",
                  "ba-imagecapture-controlbar.settings": "&#x3A1;&#x3C5;&#x3B8;&#x3BC;&#x3AF;&#x3C3;&#x3B5;&#x3B9;&#x3C2;",
                  "ba-imagecapture-controlbar.camerahealthy": "&#x39F; &#x3C6;&#x3C9;&#x3C4;&#x3B9;&#x3C3;&#x3BC;&#x3CC;&#x3C2; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3BA;&#x3B1;&#x3BB;&#x3CC;&#x3C2;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "&#x39F; &#x3C6;&#x3C9;&#x3C4;&#x3B9;&#x3C3;&#x3BC;&#x3CC;&#x3C2; &#x3B4;&#x3B5;&#x3BD; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3B2;&#x3AD;&#x3BB;&#x3C4;&#x3B9;&#x3C3;&#x3C4;&#x3BF;&#x3C2;",
                  "ba-imagecapture-controlbar.record": "&#x3A0;&#x3B9;&#x3AC;&#x3BD;&#x3C9;",
                  "ba-imagecapture-controlbar.record-tooltip": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BB;&#x3AE;&#x3C8;&#x3B7;.",
                  "ba-imagecapture-controlbar.rerecord": "&#x39E;&#x3B1;&#x3BD;&#x3B1;&#x3BA;&#x3AC;&#x3BD;&#x3C9;",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3B7;&#x3C8;&#x3B7;.",
                  "ba-imagecapture-controlbar.cancel": "&#x39C;&#x3B1;&#x3C4;&#x3B1;&#x3AF;&#x3C9;&#x3C3;&#x3B7;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3B1;&#x3BA;&#x3CD;&#x3C1;&#x3C9;&#x3C3;&#x3B7;.",
                  "ba-audioplayer-controlbar.audio-progress": "&#x3A0;&#x3C1;&#x3CC;&#x3BF;&#x3B4;&#x3BF;&#x3C2;",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#x39E;&#x3B1;&#x3BD;&#x3B1;&#x3BA;&#x3AC;&#x3BD;&#x3C9;?",
                  "ba-audioplayer-controlbar.submit-audio": "&#x395;&#x3C0;&#x3B9;&#x3B2;&#x3B5;&#x3B2;&#x3B1;&#x3B9;&#x3CE;&#x3BD;&#x3C9;",
                  "ba-audioplayer-controlbar.play-audio": "&#x3A0;&#x3B1;&#x3AF;&#x3B6;&#x3C9;",
                  "ba-audioplayer-controlbar.pause-audio": "&#x3A0;&#x3B1;&#x3CD;&#x3C3;&#x3B7;",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "&#x397; &#x3C0;&#x3B1;&#x3CD;&#x3C3;&#x3B7; &#x3B4;&#x3B5;&#x3BD; &#x3C5;&#x3C0;&#x3BF;&#x3C3;&#x3C4;&#x3B7;&#x3C1;&#x3AF;&#x3B6;&#x3B5;&#x3C4;&#x3B1;&#x3B9;",
                  "ba-audioplayer-controlbar.elapsed-time": "&#x3A7;&#x3C1;&#x3CC;&#x3BD;&#x3BF;&#x3C2; &#x3C0;&#x3BF;&#x3C5; &#x3C0;&#x3B1;&#x3C1;&#x3AE;&#x3BB;&#x3B8;&#x3B5;",
                  "ba-audioplayer-controlbar.total-time": "&#x3A3;&#x3C5;&#x3BD;&#x3BF;&#x3BB;&#x3B9;&#x3BA;&#x3CC; &#x3BC;&#x3AE;&#x3BA;&#x3BF;&#x3C2;",
                  "ba-audioplayer-controlbar.volume-button": "&#x3A1;&#x3CD;&#x3B8;&#x3BC;&#x3B9;&#x3C3;&#x3B7; &#x3AD;&#x3BD;&#x3C4;&#x3B1;&#x3C3;&#x3B7;&#x3C2;",
                  "ba-audioplayer-controlbar.volume-mute": "&#x3A3;&#x3AF;&#x3B3;&#x3B1;&#x3C3;&#x3B7; &#x3AE;&#x3C7;&#x3BF;&#x3C5;",
                  "ba-audioplayer-controlbar.volume-unmute": "&#x3A3;&#x3AF;&#x3B3;&#x3B1;&#x3C3;&#x3B7; &#x3AE;&#x3C7;&#x3BF;&#x3C5;",
                  "ba-audioplayer-loader.tooltip": "&#x3A6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7;...",
                  "ba-audioplayer.audio-error": "&#x395;&#x3BC;&#x3C6;&#x3B1;&#x3BD;&#x3AF;&#x3C3;&#x3C4;&#x3B7;&#x3BA;&#x3B5; &#x3BA;&#x3AC;&#x3C0;&#x3BF;&#x3B9;&#x3BF; &#x3C3;&#x3C6;&#x3AC;&#x3BB;&#x3BC;&#x3B1;. &#x3A0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3B1;&#x3BB;&#x3CE; &#x3B4;&#x3BF;&#x3BA;&#x3B9;&#x3BC;&#x3AC;&#x3C3;&#x3C4;&#x3B5; &#x3B1;&#x3C1;&#x3B3;&#x3CC;&#x3C4;&#x3B5;&#x3C1;&#x3B1;. &#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3B7;&#x3C8;&#x3B7;.",
                  "ba-audiorecorder-chooser.record-audio": "&#x395;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE; &#x3AE;&#x3C7;&#x3BF;&#x3C5;",
                  "ba-audiorecorder-chooser.upload-audio": "&#x39C;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7; &#x3AE;&#x3C7;&#x3BF;&#x3C5;",
                  "ba-audiorecorder-controlbar.settings": "&#x3A1;&#x3C5;&#x3B8;&#x3BC;&#x3AF;&#x3C3;&#x3B5;&#x3B9;&#x3C2;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "&#x39F; &#x3AE;&#x3C7;&#x3BF;&#x3C2; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3BA;&#x3B1;&#x3BB;&#x3CC;&#x3C2;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "&#x394;&#x3B5;&#x3BD; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3B4;&#x3C5;&#x3BD;&#x3B1;&#x3C4;&#x3AE; &#x3B7; &#x3BB;&#x3AE;&#x3C8;&#x3B7; &#x3AE;&#x3C7;&#x3BF;&#x3C5;",
                  "ba-audiorecorder-controlbar.record": "&#x3A1;&#x3B5;&#x3BA;&#x3CC;&#x3C1;",
                  "ba-audiorecorder-controlbar.record-tooltip": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE;.",
                  "ba-audiorecorder-controlbar.rerecord": "&#x39E;&#x3B1;&#x3BD;&#x3B1;&#x3BA;&#x3AC;&#x3BD;&#x3C9;",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3B7;&#x3C8;&#x3B7;.",
                  "ba-audiorecorder-controlbar.stop": "&#x39D;&#x3B1; &#x3C3;&#x3C4;&#x3B1;&#x3BC;&#x3B1;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3B9;",
                  "ba-audiorecorder-controlbar.stop-tooltip": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C3;&#x3C4;&#x3B1;&#x3BC;&#x3B1;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5;.",
                  "ba-audiorecorder-controlbar.stop-available-after": "&#x39F; &#x3B5;&#x3BB;&#x3AC;&#x3C7;&#x3B9;&#x3C3;&#x3C4;&#x3BF;&#x3C2; &#x3C7;&#x3C1;&#x3CC;&#x3BD;&#x3BF;&#x3C2; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE;&#x3C2; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; %d &#x3B4;&#x3B5;&#x3C5;&#x3C4;&#x3B5;&#x3C1;&#x3CC;&#x3BB;&#x3B5;&#x3C0;&#x3C4;&#x3B1;",
                  "ba-audiorecorder-controlbar.cancel": "&#x39C;&#x3B1;&#x3C4;&#x3B1;&#x3AF;&#x3C9;&#x3C3;&#x3B7;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3B1;&#x3BA;&#x3CD;&#x3C1;&#x3C9;&#x3C3;&#x3B7;.",
                  "ba-videoplayer-controlbar.player-speed": "&#x3A4;&#x3B1;&#x3C7;&#x3CD;&#x3C4;&#x3B7;&#x3C4;&#x3B1; &#x3C0;&#x3B1;&#x3AF;&#x3BA;&#x3C4;&#x3B7;",
                  "ba-videoplayer-controlbar.settings": "&#x3A1;&#x3C5;&#x3B8;&#x3BC;&#x3AF;&#x3C3;&#x3B5;&#x3B9;&#x3C2;",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "&#x395;&#x3B9;&#x3BA;&#x3BF;&#x3BD;&#x3AF;&#x3B4;&#x3B9;&#x3BF; Airplay.",
                  "ba-videoplayer.all-settings": "&#x38C;&#x3BB;&#x3B5;&#x3C2; &#x3BF;&#x3B9; &#x3C1;&#x3C5;&#x3B8;&#x3BC;&#x3AF;&#x3C3;&#x3B5;&#x3B9;&#x3C2;",
                  "ba-videoplayer.player-speed": "&#x3A4;&#x3B1;&#x3C7;&#x3CD;&#x3C4;&#x3B7;&#x3C4;&#x3B1; &#x3C0;&#x3B1;&#x3AF;&#x3BA;&#x3C4;&#x3B7;",
                  "ba-videoplayer.full-screen": "&#x3A0;&#x39B;&#x397;&#x3A1;&#x397;&#x3A3; &#x39F;&#x398;&#x39F;&#x39D;&#x397;",
                  "ba-videorecorder-controlbar.add-stream": "&#x3A0;&#x3C1;&#x3BF;&#x3C3;&#x3B8;&#x3AE;&#x3BA;&#x3B7; &#x3C1;&#x3BF;&#x3AE;&#x3C2;",
                  "ba-videorecorder.switch-camera": "&#x395;&#x3BD;&#x3B1;&#x3BB;&#x3BB;&#x3B1;&#x3B3;&#x3AE; &#x3BA;&#x3AC;&#x3BC;&#x3B5;&#x3C1;&#x3B1;&#x3C2;",
                  "ba-videorecorder.prepare-covershot": "&#x3A0;&#x3C1;&#x3BF;&#x3B5;&#x3C4;&#x3BF;&#x3B9;&#x3BC;&#x3B1;&#x3C3;&#x3AF;&#x3B1; &#x3B5;&#x3BE;&#x3CE;&#x3C6;&#x3C5;&#x3BB;&#x3BB;&#x3C9;&#x3BD;",
                  "ba-videorecorder.prepare-thumbnails": "&#x3A0;&#x3C1;&#x3BF;&#x3B5;&#x3C4;&#x3BF;&#x3B9;&#x3BC;&#x3B1;&#x3C3;&#x3AF;&#x3B1; &#x3B1;&#x3BD;&#x3B1;&#x3B6;&#x3AE;&#x3C4;&#x3B7;&#x3C3;&#x3B7;&#x3C2; &#x3BC;&#x3B9;&#x3BA;&#x3C1;&#x3BF;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3B9;&#x3CE;&#x3BD;",
                  "ba-videorecorder.adding-new-stream": "&#x3A0;&#x3C1;&#x3BF;&#x3C3;&#x3B8;&#x3AE;&#x3BA;&#x3B7; &#x3BD;&#x3AD;&#x3B1;&#x3C2; &#x3C1;&#x3BF;&#x3AE;&#x3C2;",
                  "ba-imagecapture.recorder-error": "&#x395;&#x3BC;&#x3C6;&#x3B1;&#x3BD;&#x3AF;&#x3C3;&#x3C4;&#x3B7;&#x3BA;&#x3B5; &#x3BA;&#x3AC;&#x3C0;&#x3BF;&#x3B9;&#x3BF; &#x3C3;&#x3C6;&#x3AC;&#x3BB;&#x3BC;&#x3B1;. &#x3A0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3B1;&#x3BB;&#x3CE; &#x3B4;&#x3BF;&#x3BA;&#x3B9;&#x3BC;&#x3AC;&#x3C3;&#x3C4;&#x3B5; &#x3B1;&#x3C1;&#x3B3;&#x3CC;&#x3C4;&#x3B5;&#x3C1;&#x3B1;. &#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3B7;&#x3C8;&#x3B7;.",
                  "ba-imagecapture.attach-error": "&#x394;&#x3B5;&#x3BD; &#x3AE;&#x3C4;&#x3B1;&#x3BD; &#x3B4;&#x3C5;&#x3BD;&#x3B1;&#x3C4;&#x3AE; &#x3B7; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3C4;&#x3B7; &#x3B4;&#x3B9;&#x3B5;&#x3C0;&#x3B1;&#x3C6;&#x3AE; &#x3C0;&#x3BF;&#x3BB;&#x3C5;&#x3BC;&#x3AD;&#x3C3;&#x3C9;&#x3BD;. &#x391;&#x3BD;&#x3AC;&#x3BB;&#x3BF;&#x3B3;&#x3B1; &#x3BC;&#x3B5; &#x3C4;&#x3B7; &#x3C3;&#x3C5;&#x3C3;&#x3BA;&#x3B5;&#x3C5;&#x3AE; &#x3BA;&#x3B1;&#x3B9; &#x3C4;&#x3BF; &#x3C0;&#x3C1;&#x3CC;&#x3B3;&#x3C1;&#x3B1;&#x3BC;&#x3BC;&#x3B1; &#x3C0;&#x3B5;&#x3C1;&#x3B9;&#x3AE;&#x3B3;&#x3B7;&#x3C3;&#x3B7;&#x3C2;, &#x3AF;&#x3C3;&#x3C9;&#x3C2; &#x3C7;&#x3C1;&#x3B5;&#x3B9;&#x3B1;&#x3C3;&#x3C4;&#x3B5;&#x3AF; &#x3BD;&#x3B1; &#x3B5;&#x3B3;&#x3BA;&#x3B1;&#x3C4;&#x3B1;&#x3C3;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3BF; Flash &#x3AE; &#x3BD;&#x3B1; &#x3B1;&#x3C0;&#x3BF;&#x3BA;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3C4;&#x3B7; &#x3C3;&#x3B5;&#x3BB;&#x3AF;&#x3B4;&#x3B1; &#x3BC;&#x3AD;&#x3C3;&#x3C9; SSL.",
                  "ba-imagecapture.software-required": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3C0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3AC;&#x3C4;&#x3C9; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3B5;&#x3B3;&#x3BA;&#x3B1;&#x3C4;&#x3B1;&#x3C3;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; / &#x3B5;&#x3BD;&#x3B5;&#x3C1;&#x3B3;&#x3BF;&#x3C0;&#x3BF;&#x3B9;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3B9;&#x3C2; &#x3B1;&#x3BA;&#x3CC;&#x3BB;&#x3BF;&#x3C5;&#x3B8;&#x3B5;&#x3C2; &#x3B1;&#x3C0;&#x3B1;&#x3B9;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3B9;&#x3C2; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C7;&#x3C9;&#x3C1;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5;.",
                  "ba-imagecapture.software-waiting": "&#x391;&#x3BD;&#x3B1;&#x3BC;&#x3BF;&#x3BD;&#x3AE; &#x3B3;&#x3B9;&#x3B1; &#x3C4;&#x3B7;&#x3BD; &#x3B5;&#x3B3;&#x3BA;&#x3B1;&#x3C4;&#x3AC;&#x3C3;&#x3C4;&#x3B1;&#x3C3;&#x3B7; / &#x3B5;&#x3BD;&#x3B5;&#x3C1;&#x3B3;&#x3BF;&#x3C0;&#x3BF;&#x3AF;&#x3B7;&#x3C3;&#x3B7; &#x3C4;&#x3C9;&#x3BD; &#x3B1;&#x3C0;&#x3B1;&#x3B9;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3C9;&#x3BD;. &#x38A;&#x3C3;&#x3C9;&#x3C2; &#x3C7;&#x3C1;&#x3B5;&#x3B9;&#x3B1;&#x3C3;&#x3C4;&#x3B5;&#x3AF; &#x3BD;&#x3B1; &#x3B1;&#x3BD;&#x3B1;&#x3BD;&#x3B5;&#x3CE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3B7; &#x3C3;&#x3B5;&#x3BB;&#x3AF;&#x3B4;&#x3B1; &#x3BC;&#x3B5;&#x3C4;&#x3AC; &#x3C4;&#x3B7;&#x3BD; &#x3BF;&#x3BB;&#x3BF;&#x3BA;&#x3BB;&#x3AE;&#x3C1;&#x3C9;&#x3C3;&#x3B7;.",
                  "ba-imagecapture.access-forbidden": "&#x391;&#x3C0;&#x3B1;&#x3B3;&#x3BF;&#x3C1;&#x3B5;&#x3CD;&#x3C4;&#x3B7;&#x3BA;&#x3B5; &#x3B7; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3C4;&#x3B1; &#x3BC;&#x3AD;&#x3C3;&#x3B1; &#x3B5;&#x3BD;&#x3B7;&#x3BC;&#x3AD;&#x3C1;&#x3C9;&#x3C3;&#x3B7;&#x3C2;. &#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3B7;&#x3C8;&#x3B7;.",
                  "ba-imagecapture.uploading": "&#x39C;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7;",
                  "ba-imagecapture.uploading-failed": "&#x397; &#x3BC;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7; &#x3B1;&#x3C0;&#x3AD;&#x3C4;&#x3C5;&#x3C7;&#x3B5; - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;.",
                  "ba-imagecapture.upload-error-duration": "&#x3A4;&#x3BF; &#x3BC;&#x3AE;&#x3BA;&#x3BF;&#x3C2; &#x3C4;&#x3B7;&#x3C2; &#x3BC;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3BF;&#x3C1;&#x3C4;&#x3C9;&#x3BC;&#x3AD;&#x3BD;&#x3B7;&#x3C2; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1;&#x3C2; &#x3B4;&#x3B5;&#x3BD; &#x3C0;&#x3BB;&#x3B7;&#x3C1;&#x3BF;&#x3AF; &#x3C4;&#x3B9;&#x3C2; &#x3B1;&#x3C0;&#x3B1;&#x3B9;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3B9;&#x3C2; - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;.",
                  "ba-imagecapture.resolution-constraint-error": "&#x3A4;&#x3BF; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF; &#x3C0;&#x3BF;&#x3C5; &#x3B5;&#x3C0;&#x3B9;&#x3BB;&#x3AD;&#x3BE;&#x3B1;&#x3C4;&#x3B5; &#x3B4;&#x3B5;&#x3BD; &#x3C4;&#x3B1;&#x3B9;&#x3C1;&#x3B9;&#x3AC;&#x3B6;&#x3B5;&#x3B9; &#x3BC;&#x3B5; &#x3C4;&#x3B7;&#x3BD; &#x3B1;&#x3C0;&#x3B1;&#x3B9;&#x3C4;&#x3BF;&#x3CD;&#x3BC;&#x3B5;&#x3BD;&#x3B7; &#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3C5;&#x3C3;&#x3B7; - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;.",
                  "ba-imagecapture.verifying": "&#x395;&#x3C0;&#x3B1;&#x3BB;&#x3AE;&#x3B8;&#x3B5;&#x3C5;&#x3C3;&#x3B7;",
                  "ba-imagecapture.verifying-failed": "&#x397; &#x3B5;&#x3C0;&#x3B1;&#x3BB;&#x3AE;&#x3B8;&#x3B5;&#x3C5;&#x3C3;&#x3B7; &#x3B1;&#x3C0;&#x3AD;&#x3C4;&#x3C5;&#x3C7;&#x3B5; - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;.",
                  "ba-imagecapture.rerecord-confirm": "&#x398;&#x3AD;&#x3BB;&#x3B5;&#x3C4;&#x3B5; &#x3C0;&#x3C1;&#x3B1;&#x3B3;&#x3BC;&#x3B1;&#x3C4;&#x3B9;&#x3BA;&#x3AC; &#x3BD;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3B1;&#x3BB;&#x3AC;&#x3B2;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3B7;&#x3BD; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1; &#x3C3;&#x3B1;&#x3C2;;",
                  "ba-imagecapture.image_file_too_large": "&#x3A4;&#x3BF; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1;&#x3C2; &#x3C3;&#x3B1;&#x3C2; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3C0;&#x3BF;&#x3BB;&#x3CD; &#x3BC;&#x3B5;&#x3B3;&#x3AC;&#x3BB;&#x3BF; (%s) - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC; &#x3BC;&#x3B5; &#x3AD;&#x3BD;&#x3B1; &#x3BC;&#x3B9;&#x3BA;&#x3C1;&#x3CC;&#x3C4;&#x3B5;&#x3C1;&#x3BF; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1;&#x3C2;.",
                  "ba-imagecapture.unsupported_image_type": "&#x39C;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3BF;&#x3C1;&#x3C4;&#x3CE;&#x3C3;&#x3C4;&#x3B5;: %s - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;.",
                  "ba-imagecapture.orientation-portrait-required": "&#x3A0;&#x3B5;&#x3C1;&#x3B9;&#x3C3;&#x3C4;&#x3C1;&#x3AD;&#x3C8;&#x3C4;&#x3B5; &#x3C4;&#x3B7; &#x3C3;&#x3C5;&#x3C3;&#x3BA;&#x3B5;&#x3C5;&#x3AE; &#x3C3;&#x3B1;&#x3C2; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE; &#x3C3;&#x3B5; &#x3BA;&#x3B1;&#x3C4;&#x3B1;&#x3BA;&#x3CC;&#x3C1;&#x3C5;&#x3C6;&#x3B7; &#x3BB;&#x3B5;&#x3B9;&#x3C4;&#x3BF;&#x3C5;&#x3C1;&#x3B3;&#x3AF;&#x3B1;.",
                  "ba-imagecapture.orientation-landscape-required": "&#x3A0;&#x3B5;&#x3C1;&#x3B9;&#x3C3;&#x3C4;&#x3C1;&#x3AD;&#x3C8;&#x3C4;&#x3B5; &#x3C4;&#x3B7; &#x3C3;&#x3C5;&#x3C3;&#x3BA;&#x3B5;&#x3C5;&#x3AE; &#x3C3;&#x3B1;&#x3C2; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE; &#x3C3;&#x3B5; &#x3BF;&#x3C1;&#x3B9;&#x3B6;&#x3CC;&#x3BD;&#x3C4;&#x3B9;&#x3B1; &#x3BB;&#x3B5;&#x3B9;&#x3C4;&#x3BF;&#x3C5;&#x3C1;&#x3B3;&#x3AF;&#x3B1;.",
                  "ba-audiorecorder.recorder-error": "&#x395;&#x3BC;&#x3C6;&#x3B1;&#x3BD;&#x3AF;&#x3C3;&#x3C4;&#x3B7;&#x3BA;&#x3B5; &#x3BA;&#x3AC;&#x3C0;&#x3BF;&#x3B9;&#x3BF; &#x3C3;&#x3C6;&#x3AC;&#x3BB;&#x3BC;&#x3B1;. &#x3A0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3B1;&#x3BB;&#x3CE; &#x3B4;&#x3BF;&#x3BA;&#x3B9;&#x3BC;&#x3AC;&#x3C3;&#x3C4;&#x3B5; &#x3B1;&#x3C1;&#x3B3;&#x3CC;&#x3C4;&#x3B5;&#x3C1;&#x3B1;. &#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3B7;&#x3C8;&#x3B7;.",
                  "ba-audiorecorder.attach-error": "&#x394;&#x3B5;&#x3BD; &#x3AE;&#x3C4;&#x3B1;&#x3BD; &#x3B4;&#x3C5;&#x3BD;&#x3B1;&#x3C4;&#x3AE; &#x3B7; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3C4;&#x3B7; &#x3B4;&#x3B9;&#x3B5;&#x3C0;&#x3B1;&#x3C6;&#x3AE; &#x3C0;&#x3BF;&#x3BB;&#x3C5;&#x3BC;&#x3AD;&#x3C3;&#x3C9;&#x3BD;. &#x391;&#x3BD;&#x3AC;&#x3BB;&#x3BF;&#x3B3;&#x3B1; &#x3BC;&#x3B5; &#x3C4;&#x3B7; &#x3C3;&#x3C5;&#x3C3;&#x3BA;&#x3B5;&#x3C5;&#x3AE; &#x3BA;&#x3B1;&#x3B9; &#x3C4;&#x3BF; &#x3C0;&#x3C1;&#x3CC;&#x3B3;&#x3C1;&#x3B1;&#x3BC;&#x3BC;&#x3B1; &#x3C0;&#x3B5;&#x3C1;&#x3B9;&#x3AE;&#x3B3;&#x3B7;&#x3C3;&#x3B7;&#x3C2;, &#x3AF;&#x3C3;&#x3C9;&#x3C2; &#x3C7;&#x3C1;&#x3B5;&#x3B9;&#x3B1;&#x3C3;&#x3C4;&#x3B5;&#x3AF; &#x3BD;&#x3B1; &#x3B5;&#x3B3;&#x3BA;&#x3B1;&#x3C4;&#x3B1;&#x3C3;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3BF; Flash &#x3AE; &#x3BD;&#x3B1; &#x3B1;&#x3C0;&#x3BF;&#x3BA;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3C4;&#x3B7; &#x3C3;&#x3B5;&#x3BB;&#x3AF;&#x3B4;&#x3B1; &#x3BC;&#x3AD;&#x3C3;&#x3C9; SSL.",
                  "ba-audiorecorder.software-required": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3C0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3AC;&#x3C4;&#x3C9; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3B5;&#x3B3;&#x3BA;&#x3B1;&#x3C4;&#x3B1;&#x3C3;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; / &#x3B5;&#x3BD;&#x3B5;&#x3C1;&#x3B3;&#x3BF;&#x3C0;&#x3BF;&#x3B9;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3B9;&#x3C2; &#x3B1;&#x3BA;&#x3CC;&#x3BB;&#x3BF;&#x3C5;&#x3B8;&#x3B5;&#x3C2; &#x3B1;&#x3C0;&#x3B1;&#x3B9;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3B9;&#x3C2; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C7;&#x3C9;&#x3C1;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5;.",
                  "ba-audiorecorder.software-waiting": "&#x391;&#x3BD;&#x3B1;&#x3BC;&#x3BF;&#x3BD;&#x3AE; &#x3B3;&#x3B9;&#x3B1; &#x3C4;&#x3B7;&#x3BD; &#x3B5;&#x3B3;&#x3BA;&#x3B1;&#x3C4;&#x3AC;&#x3C3;&#x3C4;&#x3B1;&#x3C3;&#x3B7; / &#x3B5;&#x3BD;&#x3B5;&#x3C1;&#x3B3;&#x3BF;&#x3C0;&#x3BF;&#x3AF;&#x3B7;&#x3C3;&#x3B7; &#x3C4;&#x3C9;&#x3BD; &#x3B1;&#x3C0;&#x3B1;&#x3B9;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3C9;&#x3BD;. &#x38A;&#x3C3;&#x3C9;&#x3C2; &#x3C7;&#x3C1;&#x3B5;&#x3B9;&#x3B1;&#x3C3;&#x3C4;&#x3B5;&#x3AF; &#x3BD;&#x3B1; &#x3B1;&#x3BD;&#x3B1;&#x3BD;&#x3B5;&#x3CE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3B7; &#x3C3;&#x3B5;&#x3BB;&#x3AF;&#x3B4;&#x3B1; &#x3BC;&#x3B5;&#x3C4;&#x3AC; &#x3C4;&#x3B7;&#x3BD; &#x3BF;&#x3BB;&#x3BF;&#x3BA;&#x3BB;&#x3AE;&#x3C1;&#x3C9;&#x3C3;&#x3B7;.",
                  "ba-audiorecorder.access-forbidden": "&#x391;&#x3C0;&#x3B1;&#x3B3;&#x3BF;&#x3C1;&#x3B5;&#x3CD;&#x3C4;&#x3B7;&#x3BA;&#x3B5; &#x3B7; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3C4;&#x3B1; &#x3BC;&#x3AD;&#x3C3;&#x3B1; &#x3B5;&#x3BD;&#x3B7;&#x3BC;&#x3AD;&#x3C1;&#x3C9;&#x3C3;&#x3B7;&#x3C2;. &#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3AC;&#x3BB;&#x3B7;&#x3C8;&#x3B7;.",
                  "ba-audiorecorder.uploading": "&#x39C;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7;",
                  "ba-audiorecorder.uploading-failed": "&#x397; &#x3BC;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7; &#x3B1;&#x3C0;&#x3AD;&#x3C4;&#x3C5;&#x3C7;&#x3B5; - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;.",
                  "ba-audiorecorder.upload-error-duration": "&#x3A4;&#x3BF; &#x3BC;&#x3AE;&#x3BA;&#x3BF;&#x3C2; &#x3C4;&#x3BF;&#x3C5; &#x3BC;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3BF;&#x3C1;&#x3C4;&#x3C9;&#x3BC;&#x3AD;&#x3BD;&#x3BF;&#x3C5; &#x3AE;&#x3C7;&#x3BF;&#x3C5; &#x3B4;&#x3B5;&#x3BD; &#x3C0;&#x3BB;&#x3B7;&#x3C1;&#x3BF;&#x3AF; &#x3C4;&#x3B9;&#x3C2; &#x3B1;&#x3C0;&#x3B1;&#x3B9;&#x3C4;&#x3AE;&#x3C3;&#x3B5;&#x3B9;&#x3C2; - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;.",
                  "ba-audiorecorder.verifying": "&#x395;&#x3C0;&#x3B1;&#x3BB;&#x3AE;&#x3B8;&#x3B5;&#x3C5;&#x3C3;&#x3B7;",
                  "ba-audiorecorder.verifying-failed": "&#x397; &#x3B5;&#x3C0;&#x3B1;&#x3BB;&#x3AE;&#x3B8;&#x3B5;&#x3C5;&#x3C3;&#x3B7; &#x3B1;&#x3C0;&#x3AD;&#x3C4;&#x3C5;&#x3C7;&#x3B5; - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;.",
                  "ba-audiorecorder.rerecord-confirm": "&#x398;&#x3AD;&#x3BB;&#x3B5;&#x3C4;&#x3B5; &#x3C0;&#x3C1;&#x3B1;&#x3B3;&#x3BC;&#x3B1;&#x3C4;&#x3B9;&#x3BA;&#x3AC; &#x3BD;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3B1;&#x3BB;&#x3AC;&#x3B2;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3BF;&#x3BD; &#x3AE;&#x3C7;&#x3BF; &#x3C3;&#x3B1;&#x3C2;;",
                  "ba-audiorecorder.cancel-confirm": "&#x398;&#x3AD;&#x3BB;&#x3B5;&#x3C4;&#x3B5; &#x3C0;&#x3C1;&#x3B1;&#x3B3;&#x3BC;&#x3B1;&#x3C4;&#x3B9;&#x3BA;&#x3AC; &#x3BD;&#x3B1; &#x3B1;&#x3BA;&#x3C5;&#x3C1;&#x3CE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3B7; &#x3BC;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7; &#x3AE;&#x3C7;&#x3BF;&#x3C5;;",
                  "ba-audiorecorder.audio_file_too_large": "&#x3A4;&#x3BF; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF; &#x3AE;&#x3C7;&#x3BF;&#x3C5; &#x3C3;&#x3B1;&#x3C2; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3C0;&#x3BF;&#x3BB;&#x3CD; &#x3BC;&#x3B5;&#x3B3;&#x3AC;&#x3BB;&#x3BF; (%s) - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3B4;&#x3BF;&#x3BA;&#x3B9;&#x3BC;&#x3AC;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC; &#x3BC;&#x3B5; &#x3AD;&#x3BD;&#x3B1; &#x3BC;&#x3B9;&#x3BA;&#x3C1;&#x3CC;&#x3C4;&#x3B5;&#x3C1;&#x3BF; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF; &#x3AE;&#x3C7;&#x3BF;&#x3C5;.",
                  "ba-audiorecorder.unsupported_audio_type": "&#x39C;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3BF;&#x3C1;&#x3C4;&#x3CE;&#x3C3;&#x3C4;&#x3B5;: %s - &#x3BA;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B5;&#x3B4;&#x3CE; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;.",
                  "ba-common-settingsmenu.tooltip": "&#x39A;&#x3AC;&#x3BD;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3B1;&#x3AF;&#x3BE;&#x3B5;&#x3C4;&#x3B5;.",
                  "ba-common-settingsmenu.setting-menu": "&#x38C;&#x3BB;&#x3B5;&#x3C2; &#x3BF;&#x3B9; &#x3C1;&#x3C5;&#x3B8;&#x3BC;&#x3AF;&#x3C3;&#x3B5;&#x3B9;&#x3C2;",
                  "ba-common-settingsmenu.source-quality": "&#x3A0;&#x3BF;&#x3B9;&#x3CC;&#x3C4;&#x3B7;&#x3C4;&#x3B1; &#x3C0;&#x3B7;&#x3B3;&#x3AE;&#x3C2;",
                  "ba-common-settingsmenu.player-speed": "&#x3A4;&#x3B1;&#x3C7;&#x3CD;&#x3C4;&#x3B7;&#x3C4;&#x3B1; &#x3C0;&#x3B1;&#x3AF;&#x3BA;&#x3C4;&#x3B7;",
                  "ba-common-settingsmenu.set-menu-option": "&#x39F;&#x3C1;&#x3AF;&#x3C3;&#x3C4;&#x3B5; &#x3C4;&#x3B7;&#x3BD; &#x3B5;&#x3C0;&#x3B9;&#x3BB;&#x3BF;&#x3B3;&#x3AE;",
                  "ba-common-settingsmenu.submit-video": "&#x395;&#x3C0;&#x3B9;&#x3B2;&#x3B5;&#x3B2;&#x3B1;&#x3AF;&#x3C9;&#x3C3;&#x3B7; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF;",
                  "ba-common-settingsmenu.picture-in-picture": "&#x395;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1; &#x3C3;&#x3B5; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1;",
                  "ba-common-settingsmenu.exit-fullscreen-video": "&#x388;&#x3BE;&#x3BF;&#x3B4;&#x3BF;&#x3C2; &#x3B1;&#x3C0;&#x3CC; &#x3C0;&#x3BB;&#x3AE;&#x3C1;&#x3B7; &#x3BF;&#x3B8;&#x3CC;&#x3BD;&#x3B7;",
                  "ba-common-settingsmenu.fullscreen-video": "&#x395;&#x3B9;&#x3C3;&#x3B1;&#x3B3;&#x3AC;&#x3B3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3B7;&#x3BD; &#x3C0;&#x3BB;&#x3AE;&#x3C1;&#x3B7; &#x3BF;&#x3B8;&#x3CC;&#x3BD;&#x3B7;",
                  "ba-videorecorder-chooser.multi-stream": "&#x3A0;&#x3BF;&#x3BB;&#x3BB;&#x3B1;&#x3C0;&#x3BB;&#x3AE; &#x3C1;&#x3BF;&#x3AE;",
                  "ba-videorecorder-controlbar.pause-recorder": "&#x3A0;&#x3B1;&#x3CD;&#x3C3;&#x3B7; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE;&#x3C2;",
                  "ba-videorecorder-controlbar.resume-recorder": "&#x3A3;&#x3C5;&#x3BD;&#x3AD;&#x3C7;&#x3B9;&#x3C3;&#x3B7; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE;&#x3C2;",
                  "ba-videorecorder.missing-track": "&#x39B;&#x3B5;&#x3AF;&#x3C0;&#x3B5;&#x3B9; &#x3C4;&#x3BF; &#x3B1;&#x3C0;&#x3B1;&#x3B9;&#x3C4;&#x3BF;&#x3CD;&#x3BC;&#x3B5;&#x3BD;&#x3BF; &#x3BA;&#x3BF;&#x3BC;&#x3BC;&#x3AC;&#x3C4;&#x3B9; &#x3AE;&#x3C7;&#x3BF;&#x3C5; &#x3AE; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF;",
                  "ba-videorecorder.device-already-in-use": "&#x3A4;&#x3BF;&#x3C5;&#x3BB;&#x3AC;&#x3C7;&#x3B9;&#x3C3;&#x3C4;&#x3BF;&#x3BD; &#x3BC;&#x3AF;&#x3B1; &#x3B1;&#x3C0;&#x3CC; &#x3C4;&#x3B9;&#x3C2; &#x3C3;&#x3C5;&#x3C3;&#x3BA;&#x3B5;&#x3C5;&#x3AD;&#x3C2; &#x3B5;&#x3B9;&#x3C3;&#x3CC;&#x3B4;&#x3BF;&#x3C5; &#x3C3;&#x3B1;&#x3C2; &#x3C7;&#x3C1;&#x3B7;&#x3C3;&#x3B9;&#x3BC;&#x3BF;&#x3C0;&#x3BF;&#x3B9;&#x3B5;&#x3AF;&#x3C4;&#x3B1;&#x3B9; &#x3AE;&#x3B4;&#x3B7;",
                  "ba-videorecorder.browser-permission-denied": "&#x394;&#x3B5;&#x3BD; &#x3B5;&#x3C0;&#x3B9;&#x3C4;&#x3C1;&#x3AD;&#x3C0;&#x3B5;&#x3C4;&#x3B1;&#x3B9; &#x3B7; &#x3AC;&#x3B4;&#x3B5;&#x3B9;&#x3B1; &#x3B1;&#x3C0;&#x3CC; &#x3C4;&#x3BF; &#x3C0;&#x3C1;&#x3CC;&#x3B3;&#x3C1;&#x3B1;&#x3BC;&#x3BC;&#x3B1; &#x3C0;&#x3B5;&#x3C1;&#x3B9;&#x3AE;&#x3B3;&#x3B7;&#x3C3;&#x3B7;&#x3C2;, &#x3C0;&#x3B1;&#x3C1;&#x3B1;&#x3C7;&#x3C9;&#x3C1;&#x3AE;&#x3C3;&#x3C4;&#x3B5; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3BA;&#x3B1;&#x3B9; &#x3C6;&#x3BF;&#x3C1;&#x3C4;&#x3CE;&#x3C3;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC; &#x3C4;&#x3B7; &#x3C3;&#x3B5;&#x3BB;&#x3AF;&#x3B4;&#x3B1;",
                  "ba-audioplayer.all-settings": "&#x38C;&#x3BB;&#x3B5;&#x3C2; &#x3BF;&#x3B9; &#x3C1;&#x3C5;&#x3B8;&#x3BC;&#x3AF;&#x3C3;&#x3B5;&#x3B9;&#x3C2;",
                  "ba-videoplayer-controlbar.remaining-time": "&#x3A7;&#x3C1;&#x3CC;&#x3BD;&#x3BF;&#x3C2; &#x3C0;&#x3BF;&#x3C5; &#x3B1;&#x3C0;&#x3BF;&#x3BC;&#x3AD;&#x3BD;&#x3B5;&#x3B9;",
                  "ba-videoplayer-controlbar.select-frame": "&#x395;&#x3C0;&#x3B9;&#x3BB;&#x3AD;&#x3B3;&#x3C9;",
                  "ba-videoplayer-controlbar.trim-video": "&#x3A4;&#x3B1;&#x3BA;&#x3C4;&#x3BF;&#x3C0;&#x3BF;&#x3AF;&#x3B7;&#x3C3;&#x3B7;",
                  "ba-videoplayer-playbutton.trim": "&#x3A4;&#x3B1;&#x3BA;&#x3C4;&#x3BF;&#x3C0;&#x3BF;&#x3AF;&#x3B7;&#x3C3;&#x3B7;",
                  "ba-videoplayer-playbutton.skip": "&#x3A0;&#x3B1;&#x3C1;&#x3B1;&#x3BB;&#x3B5;&#x3AF;&#x3C0;&#x3C9;",
                  "ba-videorecorder-imagegallery.upload-covershot": "&#x39C;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7; &#x3B5;&#x3BE;&#x3C9;&#x3C6;&#x3CD;&#x3BB;&#x3BB;&#x3BF;&#x3C5;",
                  "ba-videorecorder.pick-covershot-frame": "&#x395;&#x3C0;&#x3B9;&#x3BB;&#x3AD;&#x3BE;&#x3C4;&#x3B5; &#x3AD;&#x3BD;&#x3B1; &#x3C0;&#x3BB;&#x3B1;&#x3AF;&#x3C3;&#x3B9;&#x3BF; &#x3B3;&#x3B9;&#x3B1; &#x3C7;&#x3C1;&#x3AE;&#x3C3;&#x3B7; &#x3C9;&#x3C2; &#x3BA;&#x3AC;&#x3BB;&#x3C5;&#x3C8;&#x3B7;.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "&#x397; &#x3C3;&#x3C5;&#x3C3;&#x3BA;&#x3B5;&#x3C5;&#x3AE; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE;&#x3C2; &#x3BF;&#x3B8;&#x3CC;&#x3BD;&#x3B7;&#x3C2; &#x3B4;&#x3B5;&#x3BD; &#x3C5;&#x3C0;&#x3BF;&#x3C3;&#x3C4;&#x3B7;&#x3C1;&#x3AF;&#x3B6;&#x3B5;&#x3C4;&#x3B1;&#x3B9; &#x3C3;&#x3B5; &#x3B1;&#x3C5;&#x3C4;&#x3AE;&#x3BD; &#x3C4;&#x3B7; &#x3C3;&#x3C5;&#x3C3;&#x3BA;&#x3B5;&#x3C5;&#x3AE;",
                  "ba-videorecorder.trim-prompt": "&#x398;&#x3AD;&#x3BB;&#x3B5;&#x3C4;&#x3B5; &#x3BD;&#x3B1; &#x3BA;&#x3CC;&#x3C8;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3BF; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3CC; &#x3C3;&#x3B1;&#x3C2;;",
                  "ba-videorecorder.trim-video": "&#x39C;&#x3B5;&#x3C4;&#x3B1;&#x3BA;&#x3B9;&#x3BD;&#x3AE;&#x3C3;&#x3C4;&#x3B5; &#x3C4;&#x3BF;&#x3C5;&#x3C2; &#x3B4;&#x3B5;&#x3AF;&#x3BA;&#x3C4;&#x3B5;&#x3C2; &#x3AD;&#x3BD;&#x3B1;&#x3C1;&#x3BE;&#x3B7;&#x3C2; &#x3BA;&#x3B1;&#x3B9; &#x3C4;&#x3AD;&#x3BB;&#x3BF;&#x3C5;&#x3C2; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3BA;&#x3CC;&#x3C8;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3BF; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3CC; &#x3C3;&#x3B1;&#x3C2;",
                  "ba-videorecorder.wait-for-trim": "&#x391;&#x3BD;&#x3B1;&#x3BC;&#x3BF;&#x3BD;&#x3AE; &#x3B3;&#x3B9;&#x3B1; &#x3B5;&#x3BD;&#x3C4;&#x3BF;&#x3BB;&#x3AE; &#x3C0;&#x3B5;&#x3C1;&#x3B9;&#x3BA;&#x3BF;&#x3C0;&#x3AE;&#x3C2; ...",
                  "ba-videorecorder-controlbar.no-video-source": "&#x39B;&#x3B5;&#x3AF;&#x3C0;&#x3B5;&#x3B9; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B8;&#x3B5;&#x3C4;&#x3B7; &#x3C0;&#x3B7;&#x3B3;&#x3AE; &#x3B5;&#x3B9;&#x3C3;&#x3CC;&#x3B4;&#x3BF;&#x3C5; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF;",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x397; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B8;&#x3B5;&#x3C4;&#x3B7; &#x3C1;&#x3BF;&#x3AE; &#x3AD;&#x3C7;&#x3B5;&#x3B9; &#x3AE;&#x3B4;&#x3B7; &#x3B5;&#x3C0;&#x3B9;&#x3BB;&#x3B5;&#x3B3;&#x3B5;&#x3AF;",
                  "ba-videorecorder.uploading-src-error": "&#x394;&#x3B5;&#x3BD; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3B4;&#x3C5;&#x3BD;&#x3B1;&#x3C4;&#x3AE; &#x3B7; &#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3B1;&#x3C1;&#x3B1;&#x3B3;&#x3C9;&#x3B3;&#x3AE; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF; &#x3C4;&#x3CE;&#x3C1;&#x3B1;, &#x3B7; &#x3BC;&#x3B5;&#x3C4;&#x3B1;&#x3C6;&#x3CC;&#x3C1;&#x3C4;&#x3C9;&#x3C3;&#x3B7; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3B1;&#x3BA;&#x3CC;&#x3BC;&#x3B1; &#x3C3;&#x3B5; &#x3B5;&#x3BE;&#x3AD;&#x3BB;&#x3B9;&#x3BE;&#x3B7;",
                  "ba-audiorecorder-controlbar.pause-recorder": "&#x3A0;&#x3B1;&#x3CD;&#x3C3;&#x3B7; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE;&#x3C2;",
                  "ba-audiorecorder-controlbar.resume-recorder": "&#x3A3;&#x3C5;&#x3BD;&#x3AD;&#x3C7;&#x3B9;&#x3C3;&#x3B7; &#x3B5;&#x3B3;&#x3B3;&#x3C1;&#x3B1;&#x3C6;&#x3AE;&#x3C2;"
                },
                "language:es": {
                  "ba-videoplayer-playbutton.tooltip": "Haga clic para ver el video.",
                  "ba-videoplayer-playbutton.rerecord": "Regrabar",
                  "ba-videoplayer-playbutton.submit-video": "Confirmar video",
                  "ba-videoplayer-loader.tooltip": "Cargando...",
                  "ba-videoplayer-controlbar.change-resolution": "Cambiar la resoluci&#xF3;n",
                  "ba-videoplayer-controlbar.video-progress": "Progreso de video",
                  "ba-videoplayer-controlbar.rerecord-video": "Regrabar video?",
                  "ba-videoplayer-controlbar.submit-video": "Confirmar",
                  "ba-videoplayer-controlbar.play-video": "Reproducir",
                  "ba-videoplayer-controlbar.pause-video": "Pausar",
                  "ba-videoplayer-controlbar.elapsed-time": "Tiempo transcurrido",
                  "ba-videoplayer-controlbar.total-time": "Duraci&#xF3;n total",
                  "ba-videoplayer-controlbar.fullscreen-video": "Ingresar a pantalla completa",
                  "ba-videoplayer-controlbar.volume-button": "Establecer volumen",
                  "ba-videoplayer-controlbar.volume-mute": "Silenciar sonido",
                  "ba-videoplayer-controlbar.volume-unmute": "Activar sonido",
                  "ba-videoplayer.video-error": "&#x27;Se produjo un error, por favor intente de nuevo m&#xE1;s tarde. Haga clic para volver a intentarlo.&#x27;",
                  "ba-videorecorder-chooser.record-video": "Grabar video",
                  "ba-videorecorder-chooser.upload-video": "Subir video",
                  "ba-videorecorder-controlbar.settings": "Ajustes",
                  "ba-videorecorder-controlbar.camerahealthy": "La iluminaci&#xF3;n es buena",
                  "ba-videorecorder-controlbar.cameraunhealthy": "La iluminaci&#xF3;n no es &#xF3;ptima",
                  "ba-videorecorder-controlbar.microphonehealthy": "El sonido es bueno",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Problemas con sonido",
                  "ba-videorecorder-controlbar.record": "Grabar",
                  "ba-videorecorder-controlbar.record-tooltip": "Haga clic aqu&#xED; para grabar.",
                  "ba-videorecorder-controlbar.rerecord": "Rehacer",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Haga clic aqu&#xED; para rehacer.",
                  "ba-videorecorder-controlbar.upload-covershot": "Subir foto de portada",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Haga clic aqu&#xED; para subir foto de portada personalizada",
                  "ba-videorecorder-controlbar.stop": "Detener",
                  "ba-videorecorder-controlbar.stop-tooltip": "Haga clic aqu&#xED; para detener.",
                  "ba-videorecorder-controlbar.skip": "Omitir",
                  "ba-videorecorder-controlbar.skip-tooltip": "Haga clic aqu&#xED; para omitir.",
                  "ba-videorecorder.recorder-error": "&#x27;Se produjo un error, por favor intente de nuevo m&#xE1;s tarde. Haga clic para volver a intentarlo.&#x27;",
                  "ba-videorecorder.attach-error": "No hemos podido acceder a la interfaz de la c&#xE1;mara. Dependiendo del dispositivo y del navegador, es posible que tenga que instalar Flash o acceder a la p&#xE1;gina a trav&#xE9;s de SSL.",
                  "ba-videorecorder.access-forbidden": "Acceso denegado a la c&#xE1;mara. Haga clic para volver a intentarlo.",
                  "ba-videorecorder.pick-covershot": "Elige una foto de portada.",
                  "ba-videorecorder.uploading": "Subiendo",
                  "ba-videorecorder.uploading-failed": "La subida ha fallado - hacer clic aqu&#xED; para volver a intentarlo.",
                  "ba-videorecorder.verifying": "Verificando",
                  "ba-videorecorder.verifying-failed": "Fall&#xF3; la verificaci&#xF3;n - hacer clic aqu&#xED; para volver a intentarlo.",
                  "ba-videorecorder.rerecord-confirm": "&#xBF;Est&#xE1; seguro que quiere volver a hacer el video?",
                  "ba-videorecorder.video_file_too_large": "El archivo de video es demasiado grande (%s) - hacer clic aqu&#xED; para volver a intentarlo con un archivo de video m&#xE1;s peque&#xF1;o.",
                  "ba-videorecorder.unsupported_video_type": "Por favor, sube: %s - haz clic aqu&#xED; para volver a intentarlo.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Salir de pantalla completa",
                  "ba-videoplayer-share.share": "Compartir video",
                  "ba-videorecorder-chooser.record-screen": "Grabar pantalla",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pausa no admitida",
                  "ba-videorecorder-chooser.record-audio": "Grabar audio",
                  "ba-videorecorder-controlbar.stop-available-after": "El tiempo de grabaci&#xF3;n m&#xED;nimo es %d segundos",
                  "ba-videorecorder-controlbar.cancel": "Cancelar",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Haga clic aqu&#xED; para cancelar.",
                  "ba-videorecorder.cancel-confirm": "&#xBF;Realmente quieres cancelar tu carga de video?",
                  "ba-videoplayer-adslot.elapsed-time": "Tiempo transcurrido",
                  "ba-videoplayer-adslot.volume-button": "Establecer volumen",
                  "ba-videoplayer-adslot.volume-mute": "Silenciar sonido",
                  "ba-videoplayer-adslot.volume-unmute": "Activar sonido",
                  "ba-videoplayer-adslot.ad-will-end-after": "El anuncio finalizar&#xE1; en %s",
                  "ba-videoplayer-adslot.can-skip-after": "Omitir despu&#xE9;s de %d",
                  "ba-videoplayer-adslot.skip-ad": "Omitir anuncio",
                  "ba-videorecorder.software-required": "Haga click a continuaci&#xF3;n para instalar / activar los siguientes requisitos y as&#xED; poder continuar.",
                  "ba-videorecorder.software-waiting": "Esperando a que se instalen / activen los requisitos. Es posible que deba actualizar la p&#xE1;gina al finalizar.",
                  "ba-videoplayer-controlbar.close-tracks": "Cerrar CC",
                  "ba-videoplayer-controlbar.show-tracks": "Mostrar CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Cargar archivos de pista de texto",
                  "ba-videoplayer-tracks.select-text-track-language": "Idioma de subt&#xED;tulos",
                  "ba-videoplayer-tracks.info-select-locale-first": "Primero seleccione la configuraci&#xF3;n regional",
                  "ba-videoplayer-tracks.select-text-track-file": "Haga clic para seleccionar el archivo",
                  "ba-videoplayer-tracks.back": "atr&#xE1;s",
                  "ba-videorecorder.framerate-warning": "La velocidad de cuadros de video es muy baja. Recomendamos cerrar todos los dem&#xE1;s programas y pesta&#xF1;as del navegador o utilizar una computadora m&#xE1;s r&#xE1;pida.",
                  "ba-videorecorder.upload-error-duration": "La duraci&#xF3;n del video subido no cumple con los requisitos: haga clic aqu&#xED; para volver a intentarlo.",
                  "ba-videorecorder.resolution-constraint-error": "El archivo que ha seleccionado no coincide con la resoluci&#xF3;n requerida; haga clic aqu&#xED; para volver a intentarlo.",
                  "ba-videorecorder.orientation-portrait-required": "Por favor, gire su dispositivo para grabar en modo vertical.",
                  "ba-videorecorder.orientation-landscape-required": "Por favor, gire su dispositivo para grabar en modo horizontal.",
                  "ba-imageviewer-controlbar.rerecord-image": "&#xBF;Rehacer?",
                  "ba-imageviewer-controlbar.submit-image": "Confirmar",
                  "ba-imageviewer-controlbar.fullscreen-image": "Ingrese a pantalla completa",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Salir de pantalla completa",
                  "ba-imageviewer.image-error": "&#x27;Se produjo un error, int&#xE9;ntalo de nuevo m&#xE1;s tarde. Haga clic para volver a intentar.&#x27;",
                  "ba-imagecapture-chooser.image-capture": "Capturar imagen",
                  "ba-imagecapture-chooser.upload-image": "Cargar imagen",
                  "ba-imagecapture-controlbar.settings": "Ajustes",
                  "ba-imagecapture-controlbar.camerahealthy": "La iluminaci&#xF3;n es buena",
                  "ba-imagecapture-controlbar.cameraunhealthy": "La iluminaci&#xF3;n no es &#xF3;ptima",
                  "ba-imagecapture-controlbar.record": "Capturar",
                  "ba-imagecapture-controlbar.record-tooltip": "Haga clic aqu&#xED; para capturar.",
                  "ba-imagecapture-controlbar.rerecord": "Rehacer",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Haga clic aqu&#xED; para rehacer.",
                  "ba-imagecapture-controlbar.cancel": "Cancelar",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Haga clic aqu&#xED; para cancelar.",
                  "ba-audioplayer-controlbar.audio-progress": "Progreso",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#xBF;Rehacer?",
                  "ba-audioplayer-controlbar.submit-audio": "Confirmar",
                  "ba-audioplayer-controlbar.play-audio": "Reproducir",
                  "ba-audioplayer-controlbar.pause-audio": "Pausa",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pausa no admitida",
                  "ba-audioplayer-controlbar.elapsed-time": "Tiempo transcurrido",
                  "ba-audioplayer-controlbar.total-time": "Duraci&#xF3;n total",
                  "ba-audioplayer-controlbar.volume-button": "Establecer volumen",
                  "ba-audioplayer-controlbar.volume-mute": "Silenciar sonido",
                  "ba-audioplayer-controlbar.volume-unmute": "Activar sonido",
                  "ba-audioplayer-loader.tooltip": "Cargando...",
                  "ba-audioplayer.audio-error": "&#x27;Se produjo un error, int&#xE9;ntalo de nuevo m&#xE1;s tarde. Haga clic para volver a intentar.&#x27;",
                  "ba-audiorecorder-chooser.record-audio": "Grabar audio",
                  "ba-audiorecorder-chooser.upload-audio": "Subir audio",
                  "ba-audiorecorder-controlbar.settings": "Ajustes",
                  "ba-audiorecorder-controlbar.microphonehealthy": "El sonido es bueno",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "No se pudo captar ning&#xFA;n sonido",
                  "ba-audiorecorder-controlbar.record": "Grabar",
                  "ba-audiorecorder-controlbar.record-tooltip": "Haga clic aqu&#xED; para grabar.",
                  "ba-audiorecorder-controlbar.rerecord": "Rehacer",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Haga clic aqu&#xED; para rehacer.",
                  "ba-audiorecorder-controlbar.stop": "Detener",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Haga clic aqu&#xED; para detenerse.",
                  "ba-audiorecorder-controlbar.stop-available-after": "El tiempo de grabaci&#xF3;n m&#xED;nimo es %d segundos",
                  "ba-audiorecorder-controlbar.cancel": "Cancelar",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Haga clic aqu&#xED; para cancelar.",
                  "ba-videoplayer-controlbar.player-speed": "Velocidad de reproducci&#xF3;n",
                  "ba-videoplayer-controlbar.settings": "Ajustes",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "&#xCD;cono de Airplay",
                  "ba-videoplayer.all-settings": "Todos los ajustes",
                  "ba-videoplayer.player-speed": "Velocidad de reproducci&#xF3;n",
                  "ba-videoplayer.full-screen": "Pantalla completa",
                  "ba-videorecorder-controlbar.add-stream": "A&#xF1;adir Stream",
                  "ba-videorecorder.switch-camera": "Cambiar de c&#xE1;mara",
                  "ba-videorecorder.prepare-covershot": "Preparando portadas",
                  "ba-videorecorder.prepare-thumbnails": "Preparando b&#xFA;squeda de miniaturas",
                  "ba-videorecorder.adding-new-stream": "A&#xF1;adiendo nueva secuencia",
                  "ba-imagecapture.recorder-error": "&#x27;Ha ocurrido un error, por favor intente de nuevo m&#xE1;s tarde. Haga clic para volver a intentarlo.&#x27;",
                  "ba-imagecapture.attach-error": "No pudimos acceder a la interfaz multimedia. Seg&#xFA;n el dispositivo y el navegador, es posible que deba instalar Flash o acceder a la p&#xE1;gina a trav&#xE9;s de SSL.",
                  "ba-imagecapture.software-required": "Haga clic a continuaci&#xF3;n para instalar / activar los siguientes requisitos para continuar.",
                  "ba-imagecapture.software-waiting": "Esperando a que los requisitos sean instalados / activados. Es posible que necesite actualizar la p&#xE1;gina al finalizar.",
                  "ba-imagecapture.access-forbidden": "El acceso a los medios de comunicaci&#xF3;n est&#xE1; denegado. Haga clic para volver a intentarlo.",
                  "ba-imagecapture.uploading": "Subiendo",
                  "ba-imagecapture.uploading-failed": "Fall&#xF3; la carga - haga clic aqu&#xED; para volver a intentarlo.",
                  "ba-imagecapture.upload-error-duration": "La longitud de la imagen cargada no cumple con los requisitos - haga clic aqu&#xED; para volver a intentarlo.",
                  "ba-imagecapture.resolution-constraint-error": "El archivo que ha seleccionado no coincide con la resoluci&#xF3;n requerida - haga clic aqu&#xED; para volver a intentarlo.",
                  "ba-imagecapture.verifying": "Verificando",
                  "ba-imagecapture.verifying-failed": "Verificaci&#xF3;n fallida - haga clic aqu&#xED; para volver a intentarlo.",
                  "ba-imagecapture.rerecord-confirm": "&#xBF;De verdad quieres volver a tomar tu imagen?",
                  "ba-imagecapture.image_file_too_large": "Su archivo de imagen es demasiado grande (%s): haga clic aqu&#xED; para volver a intentarlo con un archivo de imagen m&#xE1;s peque&#xF1;o.",
                  "ba-imagecapture.unsupported_image_type": "Por favor suba: %s - haga clic aqu&#xED; para volver a intentarlo.",
                  "ba-imagecapture.orientation-portrait-required": "Por favor, gire su dispositivo para grabar en modo retrato.",
                  "ba-imagecapture.orientation-landscape-required": "Por favor, gire su dispositivo para grabar en modo horizontal.",
                  "ba-audiorecorder.recorder-error": "Ha ocurrido un error, por favor intente de nuevo m&#xE1;s tarde. Haga clic para volver a intentarlo.",
                  "ba-audiorecorder.attach-error": "No pudimos acceder a la interfaz multimedia. Seg&#xFA;n el dispositivo y el navegador, es posible que deba instalar Flash o acceder a la p&#xE1;gina a trav&#xE9;s de SSL.",
                  "ba-audiorecorder.software-required": "Haga clic debajo para instalar / activar los siguientes requisitos para continuar.",
                  "ba-audiorecorder.software-waiting": "Esperando a que los requisitos sean instalados / activados. Es posible que necesite actualizar la p&#xE1;gina despu&#xE9;s de finalizar.",
                  "ba-audiorecorder.access-forbidden": "El acceso a los medios de comunicaci&#xF3;n est&#xE1; denegado. Haga clic para volver a intentarlo.",
                  "ba-audiorecorder.uploading": "Subiendo",
                  "ba-audiorecorder.uploading-failed": "Fall&#xF3; la carga - haga clic aqu&#xED; para volver a intentarlo.",
                  "ba-audiorecorder.upload-error-duration": "La duraci&#xF3;n del audio cargado no cumple con los requisitos; haga clic aqu&#xED; para volver a intentarlo.",
                  "ba-audiorecorder.verifying": "Verificando",
                  "ba-audiorecorder.verifying-failed": "Verificaci&#xF3;n fallida - haga clic aqu&#xED; para volver a intentarlo.",
                  "ba-audiorecorder.rerecord-confirm": "&#xBF;Realmente quieres rehacer tu audio?",
                  "ba-audiorecorder.cancel-confirm": "&#xBF;Realmente quieres cancelar tu carga de audio?",
                  "ba-audiorecorder.audio_file_too_large": "Su archivo de audio es demasiado grande (%s) - haga clic aqu&#xED; para volver a intentarlo con un archivo de audio m&#xE1;s peque&#xF1;o.",
                  "ba-audiorecorder.unsupported_audio_type": "Por favor suba: %s - haga clic aqu&#xED; para volver a intentarlo.",
                  "ba-common-settingsmenu.tooltip": "Haga clic para reproducir.",
                  "ba-common-settingsmenu.setting-menu": "Todos los ajustes",
                  "ba-common-settingsmenu.source-quality": "Calidad",
                  "ba-common-settingsmenu.player-speed": "Velocidad de reproducci&#xF3;n",
                  "ba-common-settingsmenu.set-menu-option": "Establecer opci&#xF3;n",
                  "ba-common-settingsmenu.submit-video": "Confirmar video",
                  "ba-common-settingsmenu.picture-in-picture": "Picture in picture",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Salir de pantalla completa",
                  "ba-common-settingsmenu.fullscreen-video": "Pantalla completa",
                  "ba-videorecorder-chooser.multi-stream": "Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Pausar grabaci&#xF3;n",
                  "ba-videorecorder-controlbar.resume-recorder": "Resumir grabaci&#xF3;n",
                  "ba-videorecorder.missing-track": "Pista de audio o video requerida",
                  "ba-videorecorder.device-already-in-use": "Por lo menos uno de sus dispositivos de entrada se encuentra en uso",
                  "ba-videorecorder.browser-permission-denied": "Permiso denegado por el navegador, por favor conceda acceso y recargue la p&#xE1;gina",
                  "ba-audioplayer.all-settings": "Todos los ajustes",
                  "ba-videoplayer-controlbar.remaining-time": "Tiempo restante",
                  "ba-videoplayer-controlbar.select-frame": "Seleccione",
                  "ba-videoplayer-controlbar.trim-video": "Podar",
                  "ba-videoplayer-playbutton.trim": "Podar",
                  "ba-videoplayer-playbutton.skip": "Saltar",
                  "ba-videorecorder-imagegallery.upload-covershot": "Subir portada",
                  "ba-videorecorder.pick-covershot-frame": "Seleccione un fotograma para usarlo como foto de portada.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "La grabadora de pantalla no es compatible con este dispositivo",
                  "ba-videorecorder.trim-prompt": "&#xBF;Quieres recortar tu video?",
                  "ba-videorecorder.trim-video": "Mueva los marcadores de inicio y fin para recortar su video",
                  "ba-videorecorder.wait-for-trim": "Esperando el comando de recorte ...",
                  "ba-videorecorder-controlbar.no-video-source": "Falta una fuente de entrada de video adicional",
                  "ba-videorecorder-controlbar.stream-already-selected": "Ya se ha seleccionado una transmisi&#xF3;n adicional",
                  "ba-videorecorder.uploading-src-error": "No se puede reproducir el video ahora, la carga a&#xFA;n est&#xE1; en progreso",
                  "ba-audiorecorder-controlbar.pause-recorder": "Pausar grabadora",
                  "ba-audiorecorder-controlbar.resume-recorder": "Reanudar grabadora"
                },
                "language:fi": {
                  "ba-videoplayer-playbutton.tooltip": "Toista video.",
                  "ba-videoplayer-playbutton.rerecord": "Uudelleen",
                  "ba-videoplayer-playbutton.submit-video": "Vahvista video",
                  "ba-videoplayer-loader.tooltip": "Ladataan videota ...",
                  "ba-videoplayer-controlbar.change-resolution": "Muuta resoluutiota",
                  "ba-videoplayer-controlbar.video-progress": "Video edistyminen",
                  "ba-videoplayer-controlbar.rerecord-video": "Uudestaan?",
                  "ba-videoplayer-controlbar.submit-video": "Vahvista video",
                  "ba-videoplayer-controlbar.play-video": "Toista video",
                  "ba-videoplayer-controlbar.pause-video": "Tauko",
                  "ba-videoplayer-controlbar.elapsed-time": "Kulunut aika",
                  "ba-videoplayer-controlbar.total-time": "Kokonaispituus",
                  "ba-videoplayer-controlbar.fullscreen-video": "Kokon&#xE4;ytt&#xF6;",
                  "ba-videoplayer-controlbar.volume-button": "&#xC4;&#xE4;nenvoimakkuus",
                  "ba-videoplayer-controlbar.volume-mute": "&#xC4;&#xE4;nenmykistys",
                  "ba-videoplayer-controlbar.volume-unmute": "Poista mykistys",
                  "ba-videoplayer.video-error": "Tapahtui virhe, yrit&#xE4; my&#xF6;hemmin uudelleen. Yrit&#xE4; uudelleen klikkaamalla.",
                  "ba-videorecorder-chooser.record-video": "Nauhoita video",
                  "ba-videorecorder-chooser.upload-video": "Lataa video",
                  "ba-videorecorder-controlbar.settings": "Asetukset",
                  "ba-videorecorder-controlbar.camerahealthy": "Valaistus on riitt&#xE4;v&#xE4;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Valaistus ei ole optimaalinen",
                  "ba-videorecorder-controlbar.microphonehealthy": "&#xC4;&#xE4;nitys toimii",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "&#xC4;&#xE4;ni ei tallennu, tarkista mikrofoniasetus",
                  "ba-videorecorder-controlbar.record": "Nauhoita",
                  "ba-videorecorder-controlbar.record-tooltip": "Aloita videon nauhoitus.",
                  "ba-videorecorder-controlbar.rerecord": "Uudelleen",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Paina aloittaaksesi uudelleen.",
                  "ba-videorecorder-controlbar.upload-covershot": "Lataa",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Paina t&#xE4;st&#xE4; lataaksesi aloituskuvan",
                  "ba-videorecorder-controlbar.stop": "Stop",
                  "ba-videorecorder-controlbar.stop-tooltip": "Lopeta nauhoitus painamalla t&#xE4;st&#xE4;.",
                  "ba-videorecorder-controlbar.skip": "Ohita",
                  "ba-videorecorder-controlbar.skip-tooltip": "Paina t&#xE4;st&#xE4; ohittaaksesi.",
                  "ba-videorecorder.recorder-error": "Tapahtui virhe, yrit&#xE4; my&#xF6;hemmin uudelleen. Yrit&#xE4; uudelleen klikkaamalla.",
                  "ba-videorecorder.attach-error": "Emme voineet k&#xE4;ytt&#xE4;&#xE4; kamera-rajapintaa. Laitteesta ja selaimesta riippuen, sinun on ehk&#xE4; asennettava Flash tai k&#xE4;ytett&#xE4;v&#xE4; sivun kautta SSL.",
                  "ba-videorecorder.access-forbidden": "P&#xE4;&#xE4;sy kameraan oli kielletty. Yrit&#xE4; uudelleen klikkaamalla.",
                  "ba-videorecorder.pick-covershot": "Valitse aloituskuva.",
                  "ba-videorecorder.uploading": "Ladataan",
                  "ba-videorecorder.uploading-failed": "Lataaminen ep&#xE4;onnistui - klikkaa t&#xE4;st&#xE4; ja yrit&#xE4; uudelleen.",
                  "ba-videorecorder.verifying": "Tarkistetaan",
                  "ba-videorecorder.verifying-failed": "Varmentaa ep&#xE4;onnistui - klikkaa t&#xE4;st&#xE4; ja yrit&#xE4; uudelleen.",
                  "ba-videorecorder.rerecord-confirm": "Haluatko todella tehd&#xE4; uudelleen videon?",
                  "ba-videorecorder.video_file_too_large": "Videotiedosto on liian suuri (%s) - klikkaa t&#xE4;st&#xE4; yritt&#xE4;&#xE4;ksesi uudelleen pienemm&#xE4;ll&#xE4; videotiedostolla.",
                  "ba-videorecorder.unsupported_video_type": "Lataa: %s - klikkaa t&#xE4;st&#xE4; yrit&#xE4;&#xE4;ksesi uudelleen.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Poistu kokon&#xE4;yt&#xF6;lt&#xE4;",
                  "ba-videoplayer-share.share": "Jaa video",
                  "ba-videorecorder-chooser.record-screen": "Ruudunkaappaus",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Tauko ei ole tuettu",
                  "ba-videorecorder-chooser.record-audio": "&#xC4;&#xE4;nit&#xE4; &#xE4;&#xE4;nt&#xE4;",
                  "ba-videorecorder-controlbar.stop-available-after": "Minimi tallennusaika on %d sekuntia",
                  "ba-videorecorder-controlbar.cancel": "Peruuta",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Peruuta napsauttamalla t&#xE4;t&#xE4;.",
                  "ba-videorecorder.cancel-confirm": "Haluatko todella peruuttaa videon l&#xE4;hett&#xE4;misen?",
                  "ba-videoplayer-adslot.elapsed-time": "Kulunut aika",
                  "ba-videoplayer-adslot.volume-button": "Aseta &#xE4;&#xE4;nenvoimakkuus",
                  "ba-videoplayer-adslot.volume-mute": "Mykist&#xE4; &#xE4;&#xE4;ni",
                  "ba-videoplayer-adslot.volume-unmute": "Palauta &#xE4;&#xE4;ni",
                  "ba-videoplayer-adslot.ad-will-end-after": "Mainos p&#xE4;&#xE4;ttyy %s: n j&#xE4;lkeen",
                  "ba-videoplayer-adslot.can-skip-after": "Ohita %d j&#xE4;lkeen",
                  "ba-videoplayer-adslot.skip-ad": "Ohita mainos",
                  "ba-videorecorder.software-required": "Napsauta alla olevaa asentaaksesi / aktivoi seuraavat vaatimukset jatkaaksesi.",
                  "ba-videorecorder.software-waiting": "Odottaa, ett&#xE4; vaatimukset asennetaan / aktivoidaan. Sinun on ehk&#xE4; p&#xE4;ivitett&#xE4;v&#xE4; sivusi lopuksi.",
                  "ba-videoplayer-controlbar.close-tracks": "Sulje CC",
                  "ba-videoplayer-controlbar.show-tracks": "N&#xE4;yt&#xE4; CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Lataa tekstitiedostoja",
                  "ba-videoplayer-tracks.select-text-track-language": "Tekstityskieli",
                  "ba-videoplayer-tracks.info-select-locale-first": "Valitse ensin sijainti",
                  "ba-videoplayer-tracks.select-text-track-file": "Paina valitaksesi tiedoston",
                  "ba-videoplayer-tracks.back": "takaisin",
                  "ba-videorecorder.framerate-warning": "Videon frame-rate on hyvin alhainen. Suosittelemme kaikkien muiden ohjelmien ja selainv&#xE4;lilehtien sulkemista tai nopeamman tietokoneen k&#xE4;ytt&#xF6;&#xE4;.",
                  "ba-videorecorder.upload-error-duration": "L&#xE4;hetetyn videon pituus ei t&#xE4;yt&#xE4; vaatimuksia - klikkaa t&#xE4;st&#xE4; yritt&#xE4;&#xE4;ksesi uudelleen.",
                  "ba-videorecorder.resolution-constraint-error": "Valitsemasi tiedosto ei vastaa vaadittua tarkkuutta - napsauta t&#xE4;t&#xE4; uudelleen yritt&#xE4;&#xE4;ksesi.",
                  "ba-videorecorder.orientation-portrait-required": "Kierr&#xE4; laitetta pystyasentoon.",
                  "ba-videorecorder.orientation-landscape-required": "Kierr&#xE4; laitetta nauhoittaaksesi vaakasuunnassa.",
                  "ba-imageviewer-controlbar.rerecord-image": "Uudelleen?",
                  "ba-imageviewer-controlbar.submit-image": "Vahvista",
                  "ba-imageviewer-controlbar.fullscreen-image": "Siirry kokon&#xE4;ytt&#xF6;&#xF6;n",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Poistu kokon&#xE4;yt&#xF6;st&#xE4;",
                  "ba-imageviewer.image-error": "Tapahtui virhe. Yrit&#xE4; my&#xF6;hemmin uudelleen. Paina ja aloita uudelleen.",
                  "ba-imagecapture-chooser.image-capture": "Kuvan kaappaus",
                  "ba-imagecapture-chooser.upload-image": "L&#xE4;het&#xE4; kuva",
                  "ba-imagecapture-controlbar.settings": "Asetukset",
                  "ba-imagecapture-controlbar.camerahealthy": "Valaistus on riitt&#xE4;v&#xE4;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Valaistus ei ole optimaalinen",
                  "ba-imagecapture-controlbar.record": "Kaappaus",
                  "ba-imagecapture-controlbar.record-tooltip": "Paina t&#xE4;st&#xE4; kaapataksesi.",
                  "ba-imagecapture-controlbar.rerecord": "Tee uudelleen",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Paina t&#xE4;st&#xE4; tehd&#xE4;ksesi uudelleen.",
                  "ba-imagecapture-controlbar.cancel": "Peruuttaa",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Peruuta painamalla t&#xE4;t&#xE4;.",
                  "ba-audioplayer-controlbar.audio-progress": "Edistyminen",
                  "ba-audioplayer-controlbar.rerecord-audio": "Uudelleen?",
                  "ba-audioplayer-controlbar.submit-audio": "Vahvista",
                  "ba-audioplayer-controlbar.play-audio": "Toista",
                  "ba-audioplayer-controlbar.pause-audio": "Tauko",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Tauko ei ole mahdollinen",
                  "ba-audioplayer-controlbar.elapsed-time": "Kulunut aika",
                  "ba-audioplayer-controlbar.total-time": "Kokonaispituus",
                  "ba-audioplayer-controlbar.volume-button": "Aseta &#xE4;&#xE4;nenvoimakkuus",
                  "ba-audioplayer-controlbar.volume-mute": "Mykist&#xE4; &#xE4;&#xE4;ni",
                  "ba-audioplayer-controlbar.volume-unmute": "Palauta &#xE4;&#xE4;ni",
                  "ba-audioplayer-loader.tooltip": "Ladataan...",
                  "ba-audioplayer.audio-error": "Tapahtui virhe. Yrit&#xE4; my&#xF6;hemmin uudelleen. Paina yritt&#xE4;&#xE4;ksesi uudelleen.",
                  "ba-audiorecorder-chooser.record-audio": "&#xC4;&#xE4;nit&#xE4; &#xE4;&#xE4;nt&#xE4;",
                  "ba-audiorecorder-chooser.upload-audio": "L&#xE4;het&#xE4; &#xE4;&#xE4;nitiedosto",
                  "ba-audiorecorder-controlbar.settings": "Asetukset",
                  "ba-audiorecorder-controlbar.microphonehealthy": "&#xC4;&#xE4;ni on hyv&#xE4;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "&#xC4;&#xE4;nitys ei toimi",
                  "ba-audiorecorder-controlbar.record": "Nauhoita",
                  "ba-audiorecorder-controlbar.record-tooltip": "Paina nauhoittaaksesi.",
                  "ba-audiorecorder-controlbar.rerecord": "Tee uudelleen",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Paina t&#xE4;st&#xE4; tehd&#xE4;ksesi uudelleen.",
                  "ba-audiorecorder-controlbar.stop": "Stop",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Napsauta t&#xE4;st&#xE4; lopettaaksesi.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Minimi tallennusaika on %d sekuntia",
                  "ba-audiorecorder-controlbar.cancel": "Peruuttaa",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Peruuta napsauttamalla t&#xE4;t&#xE4;.",
                  "ba-videoplayer-controlbar.player-speed": "Toiston nopeus",
                  "ba-videoplayer-controlbar.settings": "Asetukset",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay-kuvake.",
                  "ba-videoplayer.all-settings": "Kaikki asetukset",
                  "ba-videoplayer.player-speed": "Toiston nopeus",
                  "ba-videoplayer.full-screen": "Kokon&#xE4;ytt&#xF6;",
                  "ba-videorecorder-controlbar.add-stream": "Lis&#xE4;&#xE4; Stream",
                  "ba-videorecorder.switch-camera": "Vaihda kamera",
                  "ba-videorecorder.prepare-covershot": "Aloituskuvan valmistelu",
                  "ba-videorecorder.prepare-thumbnails": "Pienoiskuvien etsiminen",
                  "ba-videorecorder.adding-new-stream": "Streamin lis&#xE4;&#xE4;minen",
                  "ba-imagecapture.recorder-error": "Tapahtui virhe, yrit&#xE4; my&#xF6;hemmin uudelleen. Paina yritt&#xE4;&#xE4;ksesi uudelleen.",
                  "ba-imagecapture.attach-error": "Emme voineet k&#xE4;ytt&#xE4;&#xE4; mediarajapintaa. Laitteesta ja selaimesta riippuen sinun on ehk&#xE4; asennettava Flash tai avattava sivu SSL:n kautta.",
                  "ba-imagecapture.software-required": "Klikkaa asentaaksesi / aktivoidaksesi seuraavat vaatimukset jatkaaksesi.",
                  "ba-imagecapture.software-waiting": "Odotetaan, ett&#xE4; vaatimukset asennetaan / aktivoidaan. Saatat joutua p&#xE4;ivitt&#xE4;m&#xE4;&#xE4;n sivun valmistumisen j&#xE4;lkeen.",
                  "ba-imagecapture.access-forbidden": "P&#xE4;&#xE4;sy tiedotusv&#xE4;lineisiin oli kielletty. Napsauta uudelleen yritt&#xE4;&#xE4;ksesi.",
                  "ba-imagecapture.uploading": "lataaminen",
                  "ba-imagecapture.uploading-failed": "Lataaminen ep&#xE4;onnistui - yrit&#xE4; uudelleen napsauttamalla t&#xE4;t&#xE4;.",
                  "ba-imagecapture.upload-error-duration": "L&#xE4;hetetyn kuvan pituus ei t&#xE4;yt&#xE4; vaatimuksia - yrit&#xE4; uudelleen napsauttamalla t&#xE4;t&#xE4;.",
                  "ba-imagecapture.resolution-constraint-error": "Valitsemasi tiedosto ei vastaa vaadittua tarkkuutta - yrit&#xE4; uudelleen napsauttamalla t&#xE4;t&#xE4;.",
                  "ba-imagecapture.verifying": "Tarkistetaan",
                  "ba-imagecapture.verifying-failed": "Vahvistaminen ep&#xE4;onnistui - yrit&#xE4; uudelleen napsauttamalla t&#xE4;t&#xE4;.",
                  "ba-imagecapture.rerecord-confirm": "Haluatko todella ottaa kuvan uudelleen?",
                  "ba-imagecapture.image_file_too_large": "Kuvatiedosto on liian suuri (%s) - napsauta t&#xE4;t&#xE4;, jos haluat kokeilla uudelleen pienemp&#xE4;&#xE4; kuvatiedostoa.",
                  "ba-imagecapture.unsupported_image_type": "L&#xE4;het&#xE4;: %s - napsauta t&#xE4;t&#xE4;, jos haluat yritt&#xE4;&#xE4; uudelleen.",
                  "ba-imagecapture.orientation-portrait-required": "K&#xE4;&#xE4;nn&#xE4; laitetta tallentaaksesi muotokuvaustilassa.",
                  "ba-imagecapture.orientation-landscape-required": "Kierr&#xE4; laitetta kuvaamaan vaakasuunnassa.",
                  "ba-audiorecorder.recorder-error": "Tapahtui virhe, yrit&#xE4; my&#xF6;hemmin uudelleen. Napsauta uudelleen yritt&#xE4;&#xE4;ksesi.",
                  "ba-audiorecorder.attach-error": "Emme voineet k&#xE4;ytt&#xE4;&#xE4; mediarajapintaa. Laitteesta ja selaimesta riippuen sinun on ehk&#xE4; asennettava Flash tai avattava sivu SSL: n kautta.",
                  "ba-audiorecorder.software-required": "Klikkaa alla asentaaksesi / aktivoidaksesi seuraavat vaatimukset jatkaaksesi.",
                  "ba-audiorecorder.software-waiting": "Odotetaan ett&#xE4; vaatimukset asennetaan / aktivoidaan. Saatat joutua p&#xE4;ivitt&#xE4;m&#xE4;&#xE4;n sivun valmistumisen j&#xE4;lkeen.",
                  "ba-audiorecorder.access-forbidden": "P&#xE4;&#xE4;sy mediatiedostoon oli ev&#xE4;tty. Napsauta yritt&#xE4;&#xE4;ksesi uudelleen.",
                  "ba-audiorecorder.uploading": "Ladataan",
                  "ba-audiorecorder.uploading-failed": "Lataaminen ep&#xE4;onnistui - yrit&#xE4; uudelleen napsauttamalla t&#xE4;t&#xE4;.",
                  "ba-audiorecorder.upload-error-duration": "L&#xE4;hetetyn &#xE4;&#xE4;nityksen pituus ei t&#xE4;yt&#xE4; vaatimuksia - yrit&#xE4; uudelleen napsauttamalla t&#xE4;t&#xE4;.",
                  "ba-audiorecorder.verifying": "Tarkistetaan",
                  "ba-audiorecorder.verifying-failed": "Vahvistaminen ep&#xE4;onnistui - yrit&#xE4; uudelleen napsauttamalla t&#xE4;t&#xE4;.",
                  "ba-audiorecorder.rerecord-confirm": "Haluatko todella nauhoittaa uudelleen?",
                  "ba-audiorecorder.cancel-confirm": "Haluatko todella peruuttaa &#xE4;&#xE4;nilatauksen?",
                  "ba-audiorecorder.audio_file_too_large": "&#xC4;&#xE4;nitiedosto on liian suuri (%s) - napsauta t&#xE4;t&#xE4;, jos haluat kokeilla uudelleen pienemp&#xE4;&#xE4; &#xE4;&#xE4;nitiedostoa.",
                  "ba-audiorecorder.unsupported_audio_type": "L&#xE4;het&#xE4;: %s - napsauta t&#xE4;t&#xE4;, jos haluat yritt&#xE4;&#xE4; uudelleen.",
                  "ba-common-settingsmenu.tooltip": "Klikkaa pelataksesi.",
                  "ba-common-settingsmenu.setting-menu": "Kaikki asetukset",
                  "ba-common-settingsmenu.source-quality": "L&#xE4;hteen laatu",
                  "ba-common-settingsmenu.player-speed": "Pelaajan nopeus",
                  "ba-common-settingsmenu.set-menu-option": "Aseta vaihtoehto",
                  "ba-common-settingsmenu.submit-video": "Vahvista video",
                  "ba-common-settingsmenu.picture-in-picture": "Kuva kuvassa",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Poistu koko n&#xE4;yt&#xF6;st&#xE4;",
                  "ba-common-settingsmenu.fullscreen-video": "Siirry koko n&#xE4;ytt&#xF6;&#xF6;n",
                  "ba-videorecorder-chooser.multi-stream": "Monivirta",
                  "ba-videorecorder-controlbar.pause-recorder": "Keskeyt&#xE4; tallennin",
                  "ba-videorecorder-controlbar.resume-recorder": "Jatka tallenninta",
                  "ba-videorecorder.missing-track": "Vaadittu &#xE4;&#xE4;ni- tai videoraita puuttuu",
                  "ba-videorecorder.device-already-in-use": "Ainakin yksi sy&#xF6;tt&#xF6;laitteistasi on jo k&#xE4;yt&#xF6;ss&#xE4;",
                  "ba-videorecorder.browser-permission-denied": "Selain ei my&#xF6;nt&#xE4;nyt lupaa. Anna k&#xE4;ytt&#xF6;oikeus ja lataa sivu uudelleen",
                  "ba-audioplayer.all-settings": "Kaikki asetukset",
                  "ba-videoplayer-controlbar.remaining-time": "J&#xE4;ljell&#xE4; oleva aika",
                  "ba-videoplayer-controlbar.select-frame": "Valitse",
                  "ba-videoplayer-controlbar.trim-video": "Trimmata",
                  "ba-videoplayer-playbutton.trim": "Trimmata",
                  "ba-videoplayer-playbutton.skip": "Ohita",
                  "ba-videorecorder-imagegallery.upload-covershot": "L&#xE4;het&#xE4; kansi",
                  "ba-videorecorder.pick-covershot-frame": "Valitse kehys, jota k&#xE4;ytet&#xE4;&#xE4;n kansikuvana.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "N&#xE4;yt&#xF6;n tallenninta ei tueta t&#xE4;ss&#xE4; laitteessa",
                  "ba-videorecorder.trim-prompt": "Haluatko leikata videosi?",
                  "ba-videorecorder.trim-video": "Leikkaa videota siirt&#xE4;m&#xE4;ll&#xE4; aloitus- ja lopetusmerkkej&#xE4;",
                  "ba-videorecorder.wait-for-trim": "Odotetaan leikkauskomentoa ...",
                  "ba-videorecorder-controlbar.no-video-source": "Lis&#xE4;videon tulol&#xE4;hde puuttuu",
                  "ba-videorecorder-controlbar.stream-already-selected": "Lis&#xE4;virta on jo valittu",
                  "ba-videorecorder.uploading-src-error": "Videon toistaminen ei onnistu, lataaminen on edelleen kesken",
                  "ba-audiorecorder-controlbar.pause-recorder": "Keskeyt&#xE4; tallennin",
                  "ba-audiorecorder-controlbar.resume-recorder": "Jatka tallenninta"
                },
                "language:fr": {
                  "ba-videoplayer-playbutton.tooltip": "Cliquez ici pour voir la vid&#xE9;o.",
                  "ba-videoplayer-playbutton.rerecord": "Recommencer",
                  "ba-videoplayer-playbutton.submit-video": "Confirmer vid&#xE9;o",
                  "ba-videoplayer-loader.tooltip": "Chargement...",
                  "ba-videoplayer-controlbar.change-resolution": "Modifier la r&#xE9;solution",
                  "ba-videoplayer-controlbar.video-progress": "Progr&#xE8;s",
                  "ba-videoplayer-controlbar.rerecord-video": "Recommencer la vid&#xE9;o?",
                  "ba-videoplayer-controlbar.submit-video": "Valider",
                  "ba-videoplayer-controlbar.play-video": "Lecture",
                  "ba-videoplayer-controlbar.pause-video": "Pause",
                  "ba-videoplayer-controlbar.elapsed-time": "Temps &#xE9;coul&#xE9; ou expir&#xE9;",
                  "ba-videoplayer-controlbar.total-time": "Dur&#xE9;e totale de la vid&#xE9;o",
                  "ba-videoplayer-controlbar.fullscreen-video": "Passer en mode plein &#xE9;cran",
                  "ba-videoplayer-controlbar.volume-button": "Ajuster le volume",
                  "ba-videoplayer-controlbar.volume-mute": "Silencieux",
                  "ba-videoplayer-controlbar.volume-unmute": "Silencieux d&#xE9;sactiv&#xE9;",
                  "ba-videoplayer.video-error": "Une erreur s&#x2019;est produite, r&#xE9;essayez ult&#xE9;rieurement. Cliquez ici pour r&#xE9;essayer.",
                  "ba-videorecorder-chooser.record-video": "Enregistrer votre vid&#xE9;o",
                  "ba-videorecorder-chooser.upload-video": "T&#xE9;l&#xE9;charger votre vid&#xE9;o",
                  "ba-videorecorder-controlbar.settings": "R&#xE9;glages",
                  "ba-videorecorder-controlbar.camerahealthy": "Bon &#xE9;clairage",
                  "ba-videorecorder-controlbar.cameraunhealthy": "L&#x2019;&#xE9;clairage n&#x2019;est pas ideal",
                  "ba-videorecorder-controlbar.microphonehealthy": "Bonne acoustique",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "L&#x2019;acoustique n&#x27;est pas id&#xE9;ale",
                  "ba-videorecorder-controlbar.record": "Enregistrer",
                  "ba-videorecorder-controlbar.record-tooltip": "Cliquez ici pour enregistrer.",
                  "ba-videorecorder-controlbar.rerecord": "Recommencer",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Cliquez ici pour recommencer.",
                  "ba-videorecorder-controlbar.upload-covershot": "T&#xE9;l&#xE9;charger couverture",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Cliquez ici pour t&#xE9;l&#xE9;charger une couverture personnalis&#xE9;e.",
                  "ba-videorecorder-controlbar.stop": "Arr&#xEA;ter",
                  "ba-videorecorder-controlbar.stop-tooltip": "Cliquez ici pour arr&#xEA;ter.",
                  "ba-videorecorder-controlbar.skip": "Sauter",
                  "ba-videorecorder-controlbar.skip-tooltip": "Cliquez ici pour sauter.",
                  "ba-videorecorder.recorder-error": "Une erreur s&#x2019;est produite, r&#xE9;essayez ult&#xE9;rieurement. Cliquez ici pour r&#xE9;essayer.",
                  "ba-videorecorder.attach-error": "Nous n&#x27;avons pas pu acc&#xE9;der &#xE0; l&#x27;interface multim&#xE9;dia. Selon le p&#xE9;riph&#xE9;rique et le navigateur, vous devrez peut-&#xEA;tre installer Flash ou acc&#xE9;der &#xE0; la page via SSL.",
                  "ba-videorecorder.access-forbidden": "L&#x2019;acc&#xE8;s &#xE0; l&#x2019;appareil est interdit. Cliquez pour recommencer.",
                  "ba-videorecorder.pick-covershot": "Choisissez une couverture.",
                  "ba-videorecorder.uploading": "T&#xE9;l&#xE9;chargement",
                  "ba-videorecorder.uploading-failed": "&#xC9;chec du T&#xE9;l&#xE9;chargement - Cliquez ici pour recommencer ou r&#xE9;essayer.",
                  "ba-videorecorder.verifying": "V&#xE9;rification",
                  "ba-videorecorder.verifying-failed": "V&#xE9;rification &#xE9;chou&#xE9;e - Cliquez ici pour recommencer ou r&#xE9;essayer.",
                  "ba-videorecorder.rerecord-confirm": "Souhaitez vous r&#xE9;ellement recommencer la vid&#xE9;o?",
                  "ba-videorecorder.video_file_too_large": "La taille de votre fichier est trop grande (%s) - Cliquez ici pour r&#xE9;essayer avec un fichier plus petit.",
                  "ba-videorecorder.unsupported_video_type": "S&#x2019;il vous pla&#xEE;t, t&#xE9;l&#xE9;chargez %s - cliquez ici pour r&#xE9;essayer.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Quitter le mode plein &#xE9;cran",
                  "ba-videoplayer-share.share": "Partager la vid&#xE9;o",
                  "ba-videorecorder-chooser.record-screen": "Enregistrer l&#x27;&#xE9;cran",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pause non prise en charge",
                  "ba-videorecorder-chooser.record-audio": "Enregistrement audio",
                  "ba-videorecorder-controlbar.stop-available-after": "La dur&#xE9;e d&#x27;enregistrement minimale est de %d secondes",
                  "ba-videorecorder-controlbar.cancel": "Annuler",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Cliquez ici pour annuler.",
                  "ba-videorecorder.cancel-confirm": "Voulez-vous vraiment annuler votre t&#xE9;l&#xE9;chargement de vid&#xE9;o?",
                  "ba-videoplayer-adslot.elapsed-time": "Temps &#xE9;coul&#xE9;",
                  "ba-videoplayer-adslot.volume-button": "D&#xE9;finir le volume",
                  "ba-videoplayer-adslot.volume-mute": "Son muet",
                  "ba-videoplayer-adslot.volume-unmute": "Activer le son",
                  "ba-videoplayer-adslot.ad-will-end-after": "L&#x27;annonce se termine apr&#xE8;s %s",
                  "ba-videoplayer-adslot.can-skip-after": "Passer apr&#xE8;s %d",
                  "ba-videoplayer-adslot.skip-ad": "Passer l&#x27;annonce",
                  "ba-videorecorder.software-required": "Veuillez cliquer ci-dessous pour installer / activer les d&#xE9;pendances suivantes afin de continuer.",
                  "ba-videorecorder.software-waiting": "Attendre que les exigences soient install&#xE9;es / activ&#xE9;es. Vous devrez peut-&#xEA;tre actualiser la page apr&#xE8;s l&#x27;ach&#xE8;vement.",
                  "ba-videoplayer-controlbar.close-tracks": "Fermer sous-titrage",
                  "ba-videoplayer-controlbar.show-tracks": "Montrer sous-titrage",
                  "ba-videoplayer-tracks.upload-text-tracks": "T&#xE9;l&#xE9;charger des fichiers texte de piste",
                  "ba-videoplayer-tracks.select-text-track-language": "Langue des sous-titres",
                  "ba-videoplayer-tracks.info-select-locale-first": "S&#xE9;lectionnez d&#x27;abord les param&#xE8;tres r&#xE9;gionaux",
                  "ba-videoplayer-tracks.select-text-track-file": "Cliquez pour s&#xE9;lectionner un fichier",
                  "ba-videoplayer-tracks.back": "retour",
                  "ba-videorecorder.framerate-warning": "Le taux de trame vid&#xE9;o est tr&#xE8;s faible. Nous vous recommandons de fermer tous les autres programmes et les onglets du navigateur ou d&#x27;utiliser un ordinateur plus rapide.",
                  "ba-videorecorder.upload-error-duration": "La longueur de la vid&#xE9;o t&#xE9;l&#xE9;charg&#xE9;e ne r&#xE9;pond pas aux exigences - cliquez ici pour r&#xE9;essayer.",
                  "ba-videorecorder.resolution-constraint-error": "Le fichier que vous avez s&#xE9;lectionn&#xE9; ne correspond pas &#xE0; la r&#xE9;solution requise - cliquez ici pour r&#xE9;essayer.",
                  "ba-videorecorder.orientation-portrait-required": "Veuillez faire pivoter votre appareil pour enregistrer en mode portrait.",
                  "ba-videorecorder.orientation-landscape-required": "Veuillez faire pivoter votre appareil pour enregistrer en mode paysage.",
                  "ba-imageviewer-controlbar.rerecord-image": "Refaire?",
                  "ba-imageviewer-controlbar.submit-image": "Confirmer",
                  "ba-imageviewer-controlbar.fullscreen-image": "Passer en mode plein &#xE9;cran",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Quitter le mode plein &#xE9;cran",
                  "ba-imageviewer.image-error": "Une erreur est survenue, veuillez r&#xE9;essayer plus tard. Cliquez pour r&#xE9;essayer.",
                  "ba-imagecapture-chooser.image-capture": "Capture d&#x27;image",
                  "ba-imagecapture-chooser.upload-image": "T&#xE9;l&#xE9;charger une image",
                  "ba-imagecapture-controlbar.settings": "Param&#xE8;tres",
                  "ba-imagecapture-controlbar.camerahealthy": "L&#x27;&#xE9;clairage est bon",
                  "ba-imagecapture-controlbar.cameraunhealthy": "L&#x27;&#xE9;clairage n&#x27;est pas optimal",
                  "ba-imagecapture-controlbar.record": "Capturer",
                  "ba-imagecapture-controlbar.record-tooltip": "Cliquez ici pour capturer.",
                  "ba-imagecapture-controlbar.rerecord": "Refaire",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Cliquez ici pour refaire",
                  "ba-imagecapture-controlbar.cancel": "Annuler",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Cliquez ici pour annuler.",
                  "ba-audioplayer-controlbar.audio-progress": "Progression",
                  "ba-audioplayer-controlbar.rerecord-audio": "Refaire?",
                  "ba-audioplayer-controlbar.submit-audio": "Confirmer",
                  "ba-audioplayer-controlbar.play-audio": "Jouer",
                  "ba-audioplayer-controlbar.pause-audio": "Pause",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pause non support&#xE9;e",
                  "ba-audioplayer-controlbar.elapsed-time": "Temps &#xE9;coul&#xE9;",
                  "ba-audioplayer-controlbar.total-time": "Longueur totale de",
                  "ba-audioplayer-controlbar.volume-button": "R&#xE9;gler le volume",
                  "ba-audioplayer-controlbar.volume-mute": "Son muet",
                  "ba-audioplayer-controlbar.volume-unmute": "Activer le son",
                  "ba-audioplayer-loader.tooltip": "Chargement...",
                  "ba-audioplayer.audio-error": "Une erreur est survenue, veuillez r&#xE9;essayer plus tard. Cliquez pour r&#xE9;essayer.",
                  "ba-audiorecorder-chooser.record-audio": "Enregistrement audio",
                  "ba-audiorecorder-chooser.upload-audio": "T&#xE9;l&#xE9;charger l&#x27;audio",
                  "ba-audiorecorder-controlbar.settings": "Param&#xE8;tres",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Le son est bon",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Impossible de capter un son",
                  "ba-audiorecorder-controlbar.record": "Record",
                  "ba-audiorecorder-controlbar.record-tooltip": "Cliquez ici pour enregistrer.",
                  "ba-audiorecorder-controlbar.rerecord": "Refaire",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Cliquez ici pour refaire",
                  "ba-audiorecorder-controlbar.stop": "Arr&#xEA;ter",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Cliquez ici pour arr&#xEA;ter.",
                  "ba-audiorecorder-controlbar.stop-available-after": "La dur&#xE9;e d&#x27;enregistrement minimale est de %d secondes",
                  "ba-audiorecorder-controlbar.cancel": "Annuler",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Cliquez ici pour annuler.",
                  "ba-videoplayer-controlbar.player-speed": "Vitesse du lecteur",
                  "ba-videoplayer-controlbar.settings": "R&#xE9;glages",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Ic&#xF4;ne airplay.",
                  "ba-videoplayer.all-settings": "Tous les r&#xE9;glages",
                  "ba-videoplayer.player-speed": "Vitesse du joueur",
                  "ba-videoplayer.full-screen": "Plein &#xE9;cran",
                  "ba-videorecorder-controlbar.add-stream": "Ajouter un flux",
                  "ba-videorecorder.switch-camera": "Changer de cam&#xE9;ra",
                  "ba-videorecorder.prepare-covershot": "Pr&#xE9;paration des couvertures",
                  "ba-videorecorder.prepare-thumbnails": "Pr&#xE9;parer la recherche de vignettes",
                  "ba-videorecorder.adding-new-stream": "Ajout d&#x27;un nouveau flux",
                  "ba-imagecapture.recorder-error": "Une erreur est survenue, veuillez r&#xE9;essayer plus tard. Cliquez pour r&#xE9;essayer.",
                  "ba-imagecapture.attach-error": "Nous n&#x27;avons pas pu acc&#xE9;der &#xE0; l&#x27;interface multim&#xE9;dia. Selon le p&#xE9;riph&#xE9;rique et le navigateur, vous devrez peut-&#xEA;tre installer Flash ou acc&#xE9;der &#xE0; la page via SSL.",
                  "ba-imagecapture.software-required": "Veuillez cliquer ci-dessous pour installer / activer les d&#xE9;pendances suivantes afin de continuer.",
                  "ba-imagecapture.software-waiting": "En attente des d&#xE9;pendances &#xE0; installer / activer. Vous devrez peut-&#xEA;tre actualiser la page une fois l&#x2019;op&#xE9;ration termin&#xE9;e.",
                  "ba-imagecapture.access-forbidden": "L&#x27;acc&#xE8;s au m&#xE9;dia &#xE9;tait interdit. Cliquez pour r&#xE9;essayer.",
                  "ba-imagecapture.uploading": "T&#xE9;l&#xE9;chargement",
                  "ba-imagecapture.uploading-failed": "&#xC9;chec du t&#xE9;l&#xE9;chargement - cliquez ici pour r&#xE9;essayer.",
                  "ba-imagecapture.upload-error-duration": "La longueur de l&#x27;image t&#xE9;l&#xE9;charg&#xE9;e ne r&#xE9;pond pas aux exigences - cliquez ici pour r&#xE9;essayer.",
                  "ba-imagecapture.resolution-constraint-error": "Le fichier que vous avez s&#xE9;lectionn&#xE9; ne correspond pas &#xE0; la r&#xE9;solution requise - cliquez ici pour r&#xE9;essayer.",
                  "ba-imagecapture.verifying": "V&#xE9;rification",
                  "ba-imagecapture.verifying-failed": "V&#xE9;rification &#xE9;chou&#xE9;e - cliquez ici pour r&#xE9;essayer.",
                  "ba-imagecapture.rerecord-confirm": "Voulez-vous vraiment reprendre votre image?",
                  "ba-imagecapture.image_file_too_large": "Votre fichier image est trop volumineux (%s) - cliquez ici pour essayer &#xE0; nouveau avec un fichier image plus petit.",
                  "ba-imagecapture.unsupported_image_type": "Veuillez t&#xE9;l&#xE9;charger : %s - cliquez ici pour r&#xE9;essayer.",
                  "ba-imagecapture.orientation-portrait-required": "Veuillez faire pivoter votre appareil pour enregistrer en mode portrait.",
                  "ba-imagecapture.orientation-landscape-required": "Veuillez faire pivoter votre appareil pour enregistrer en mode paysage.",
                  "ba-audiorecorder.recorder-error": "Une erreur est survenue, veuillez r&#xE9;essayer plus tard. Cliquez pour r&#xE9;essayer.",
                  "ba-audiorecorder.attach-error": "Nous n&#x27;avons pas pu acc&#xE9;der &#xE0; l&#x27;interface multim&#xE9;dia. Selon le p&#xE9;riph&#xE9;rique et le navigateur, vous devrez peut-&#xEA;tre installer Flash ou acc&#xE9;der &#xE0; la page via SSL.",
                  "ba-audiorecorder.software-required": "Veuillez cliquer ci-dessous pour installer / activer les d&#xE9;pendances suivantes afin de continuer.",
                  "ba-audiorecorder.software-waiting": "En attente des d&#xE9;pendances &#xE0; installer / activer. Vous devrez peut-&#xEA;tre actualiser la page une fois l&#x2019;op&#xE9;ration termin&#xE9;e.",
                  "ba-audiorecorder.access-forbidden": "L&#x27;acc&#xE8;s aux m&#xE9;dias &#xE9;tait interdit. Cliquez pour r&#xE9;essayer.",
                  "ba-audiorecorder.uploading": "T&#xE9;l&#xE9;chargement",
                  "ba-audiorecorder.uploading-failed": "&#xC9;chec du t&#xE9;l&#xE9;chargement - cliquez ici pour r&#xE9;essayer.",
                  "ba-audiorecorder.upload-error-duration": "La longueur de l&#x27;audio t&#xE9;l&#xE9;charg&#xE9; ne r&#xE9;pond pas aux exigences - cliquez ici pour r&#xE9;essayer.",
                  "ba-audiorecorder.verifying": "V&#xE9;rification",
                  "ba-audiorecorder.verifying-failed": "V&#xE9;rification &#xE9;chou&#xE9;e - cliquez ici pour r&#xE9;essayer.",
                  "ba-audiorecorder.rerecord-confirm": "Voulez-vous vraiment refaire votre audio?",
                  "ba-audiorecorder.cancel-confirm": "Voulez-vous vraiment annuler votre t&#xE9;l&#xE9;chargement audio?",
                  "ba-audiorecorder.audio_file_too_large": "Votre fichier audio est trop volumineux (%s) - cliquez ici pour essayer &#xE0; nouveau avec un fichier audio plus petit.",
                  "ba-audiorecorder.unsupported_audio_type": "Veuillez t&#xE9;l&#xE9;charger : %s - cliquez ici pour r&#xE9;essayer.",
                  "ba-common-settingsmenu.tooltip": "Cliquez ici pour voir la vid&#xE9;o",
                  "ba-common-settingsmenu.setting-menu": "Tous les r&#xE9;glages",
                  "ba-common-settingsmenu.source-quality": "Qualit&#xE9; source",
                  "ba-common-settingsmenu.player-speed": "Vitesse du lecteur",
                  "ba-common-settingsmenu.set-menu-option": "Configurer l&#x27;option",
                  "ba-common-settingsmenu.submit-video": "Confirmer vid&#xE9;o",
                  "ba-common-settingsmenu.picture-in-picture": "Image dans l&#x27;image",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Quitter le mode plein &#xE9;cran",
                  "ba-common-settingsmenu.fullscreen-video": "Passer en mode plein &#xE9;cran",
                  "ba-videorecorder-chooser.multi-stream": "Flux multiples",
                  "ba-videorecorder-controlbar.pause-recorder": "Mettre l&#x27;enregistrement en pause",
                  "ba-videorecorder-controlbar.resume-recorder": "Continuer l&#x27;enregistrement",
                  "ba-videorecorder.missing-track": "La piste audio ou vid&#xE9;o requise est manquante",
                  "ba-videorecorder.device-already-in-use": "Au moins un de vos p&#xE9;riph&#xE9;riques d&#x27;entr&#xE9;e est d&#xE9;j&#xE0; utilis&#xE9;",
                  "ba-videorecorder.browser-permission-denied": "Autorisation refus&#xE9;e par le navigateur, veuillez accorder l&#x27;acc&#xE8;s et recharger la page",
                  "ba-audioplayer.all-settings": "Tous les r&#xE9;glages",
                  "ba-videoplayer-controlbar.remaining-time": "Temps restant",
                  "ba-videoplayer-controlbar.select-frame": "S&#xE9;lectionner",
                  "ba-videoplayer-controlbar.trim-video": "Garniture",
                  "ba-videoplayer-playbutton.trim": "Garniture",
                  "ba-videoplayer-playbutton.skip": "Sauter",
                  "ba-videorecorder-imagegallery.upload-covershot": "T&#xE9;l&#xE9;charger la couverture",
                  "ba-videorecorder.pick-covershot-frame": "S&#xE9;lectionnez une image &#xE0; utiliser comme couverture.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "L&#x27;enregistreur d&#x27;&#xE9;cran n&#x27;est pas pris en charge sur cet appareil",
                  "ba-videorecorder.trim-prompt": "Voulez-vous d&#xE9;couper votre vid&#xE9;o&#xA0;?",
                  "ba-videorecorder.trim-video": "D&#xE9;placez les marqueurs de d&#xE9;but et de fin pour d&#xE9;couper votre vid&#xE9;o",
                  "ba-videorecorder.wait-for-trim": "En attente de la commande de rognage...",
                  "ba-videorecorder-controlbar.no-video-source": "Source d&#x27;entr&#xE9;e vid&#xE9;o suppl&#xE9;mentaire manquante",
                  "ba-videorecorder-controlbar.stream-already-selected": "Un flux suppl&#xE9;mentaire a d&#xE9;j&#xE0; &#xE9;t&#xE9; s&#xE9;lectionn&#xE9;",
                  "ba-videorecorder.uploading-src-error": "Impossible de lire la vid&#xE9;o maintenant, le t&#xE9;l&#xE9;chargement est toujours en cours",
                  "ba-audiorecorder-controlbar.pause-recorder": "Suspendre l&#x27;enregistreur",
                  "ba-audiorecorder-controlbar.resume-recorder": "Enregistreur de CV"
                },
                "language:hi": {
                  "ba-videoplayer-playbutton.tooltip": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x91A;&#x932;&#x93E;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videoplayer-playbutton.rerecord": "&#x92B;&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x92A;&#x941;&#x928;&#x903; &#x930;&#x93F;&#x915;&#x949;&#x93F;&#x921; &#x915;&#x93F;",
                  "ba-videoplayer-playbutton.submit-video": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x91C;&#x92E;&#x93E; &#x915;&#x93F;",
                  "ba-videoplayer-loader.tooltip": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x932;&#x94B;&#x921; &#x939;&#x94B; &#x930;&#x939;&#x93E; &#x939;&#x948; ...",
                  "ba-videoplayer-controlbar.change-resolution": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; - &#x93F;&#x947;&#x938;&#x94B;&#x932;&#x941;&#x936;&#x928; &#x92C;&#x926;&#x932;&#x94B;",
                  "ba-videoplayer-controlbar.video-progress": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x92C;&#x922;&#x93C; &#x93F;&#x939;&#x93E; &#x939;",
                  "ba-videoplayer-controlbar.rerecord-video": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x92A;&#x941;&#x928;&#x903; &#x930;&#x93F;&#x915;&#x949;&#x93F;&#x921; &#x915;&#x93F;",
                  "ba-videoplayer-controlbar.submit-video": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x91C;&#x92E;&#x93E; &#x915;&#x93F;",
                  "ba-videoplayer-controlbar.play-video": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x91A;&#x932;&#x93E;&#x90F;&#x902;",
                  "ba-videoplayer-controlbar.pause-video": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x930;&#x94B;&#x915;&#x947;&#x902;",
                  "ba-videoplayer-controlbar.elapsed-time": "&#x92C;&#x940;&#x924;&#x93E; &#x939;&#x941;&#x906; &#x938;&#x92E;&#x92F;",
                  "ba-videoplayer-controlbar.total-time": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x915;&#x940; &#x915;&#x941;&#x932; &#x932;&#x902;&#x92C;&#x93E;&#x908;",
                  "ba-videoplayer-controlbar.fullscreen-video": "&#x92A;&#x942;&#x930;&#x94D;&#x923; &#x938;&#x94D;&#x915;&#x94D;&#x930;&#x940;&#x928; &#x926;&#x930;&#x94D;&#x91C; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videoplayer-controlbar.volume-button": "&#x92E;&#x93E;&#x924;&#x94D;&#x930;&#x93E; &#x938;&#x947;&#x91F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videoplayer-controlbar.volume-mute": "&#x927;&#x94D;&#x935;&#x928;&#x93F; &#x92E;&#x94D;&#x92F;&#x942;&#x91F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videoplayer-controlbar.volume-unmute": "&#x927;&#x94D;&#x935;&#x928;&#x93F; &#x915;&#x94B; &#x905;&#x928;&#x92E;&#x94D;&#x92F;&#x942;&#x91F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videoplayer.video-error": "&#x905; &#x93E;&#x924;  &#x941;&#x921;&#x93F; | &#x92A;&#x941;&#x928;&#x903;  &#x92F;&#x93E;&#x938; &#x915;&#x93F;&#x928;&#x947; &#x915;&#x947; &#x921;&#x932;&#x90F;  &#x93F;&#x915; &#x915;&#x93F;",
                  "ba-videorecorder-chooser.record-video": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921; &#x915;&#x930;&#x94B;",
                  "ba-videorecorder-chooser.upload-video": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder-controlbar.settings": "&#x938;&#x947;&#x91F;&#x93F;&#x902;&#x917;&#x94D;&#x938;",
                  "ba-videorecorder-controlbar.camerahealthy": "&#x92A;&#x94D;&#x930;&#x915;&#x93E;&#x936; &#x905;&#x91A;&#x94D;&#x91B;&#x93E; &#x939;&#x948;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "&#x92A;&#x94D;&#x930;&#x915;&#x93E;&#x936; &#x907;&#x937;&#x94D;&#x91F;&#x924;&#x92E; &#x928;&#x939;&#x940;&#x902; &#x939;&#x948;",
                  "ba-videorecorder-controlbar.microphonehealthy": "&#x927;&#x94D;&#x935;&#x928;&#x93F; &#x905;&#x91A;&#x94D;&#x91B;&#x940; &#x939;&#x948;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "&#x915;&#x94B;&#x908; &#x92D;&#x940; &#x906;&#x935;&#x93E;&#x91C; &#x928;&#x939;&#x940;&#x902; &#x909;&#x920;&#x93E; &#x938;&#x915;&#x924;&#x93E;",
                  "ba-videorecorder-controlbar.record": "&#x930;&#x93F;&#x915;&#x949;&#x93F;&#x921;",
                  "ba-videorecorder-controlbar.record-tooltip": "&#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-videorecorder-controlbar.rerecord": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x92A;&#x941;&#x928;&#x903; &#x930;&#x93F;&#x915;&#x949;&#x93F;&#x921; &#x915;&#x93F;",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "&#x92B;&#x93F;&#x930; &#x938;&#x947; &#x915;&#x930;&#x947;&#x902; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-videorecorder-controlbar.upload-covershot": "&#x905;&#x92A;&#x932;&#x94B;&#x921;",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#x915;&#x938;&#x94D;&#x91F;&#x92E; &#x915;&#x935;&#x930; &#x936;&#x949;&#x91F; &#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder-controlbar.stop": "&#x930;&#x941;&#x915;&#x947;&#x902;",
                  "ba-videorecorder-controlbar.stop-tooltip": "&#x930;&#x94B;&#x915;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder-controlbar.skip": "&#x91B;&#x94B;&#x921;&#x93C;&#x947;&#x902;",
                  "ba-videorecorder-controlbar.skip-tooltip": "&#x91B;&#x94B;&#x921;&#x93C;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-videorecorder.recorder-error": "&#x90F;&#x915; &#x924;&#x94D;&#x930;&#x941;&#x91F;&#x93F; &#x918;&#x91F;&#x93F;&#x924; &#x939;&#x941;&#x908; &#x939;&#x948;, &#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x92C;&#x93E;&#x926; &#x92E;&#x947;&#x902; &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x947;&#x902;&#x964; &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder.attach-error": "&#x939;&#x92E; &#x915;&#x948;&#x92E;&#x930;&#x947; &#x915;&#x947; &#x907;&#x902;&#x91F;&#x930;&#x92B;&#x93C;&#x947;&#x938; &#x924;&#x915; &#x92A;&#x939;&#x941;&#x902;&#x91A; &#x928;&#x939;&#x940;&#x902; &#x938;&#x915;&#x947;&#x964; &#x921;&#x93F;&#x935;&#x93E;&#x907;&#x938; &#x914;&#x930; &#x92C;&#x94D;&#x930;&#x93E;&#x909;&#x91C;&#x93C;&#x930; &#x915;&#x947; &#x906;&#x927;&#x93E;&#x930; &#x92A;&#x930;, &#x906;&#x92A;&#x915;&#x94B; &#x92B;&#x94D;&#x932;&#x948;&#x936; &#x907;&#x902;&#x938;&#x94D;&#x91F;&#x949;&#x932; &#x915;&#x930;&#x928;&#x93E; &#x92F;&#x93E; &#x92A;&#x943;&#x937;&#x94D;&#x920; &#x92A;&#x930; &#x90F;&#x938;&#x90F;&#x938;&#x90F;&#x932; &#x915;&#x947; &#x92E;&#x93E;&#x927;&#x94D;&#x92F;&#x92E; &#x938;&#x947; &#x92A;&#x94D;&#x930;&#x935;&#x947;&#x936; &#x915;&#x930;&#x928;&#x93E; &#x92A;&#x921;&#x93C; &#x938;&#x915;&#x924;&#x93E; &#x939;&#x948;",
                  "ba-videorecorder.access-forbidden": "&#x915;&#x948;&#x92E;&#x930;&#x947; &#x924;&#x915; &#x92A;&#x939;&#x941;&#x902;&#x91A; &#x92E;&#x928;&#x93E;&#x908; &#x917;&#x908; &#x925;&#x940; &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder.pick-covershot": "&#x936;&#x949;&#x93F;&#x921;&#x915;&#x93F; &#x915;&#x93E; &#x91A;&#x941;&#x928;&#x93E;&#x935; &#x915;&#x940;&#x921;&#x91C;&#x90F;",
                  "ba-videorecorder.uploading": "&#x905;&#x92A;&#x932;&#x94B;&#x921; &#x939;&#x94B; &#x930;&#x939;&#x93E; &#x939;&#x948;",
                  "ba-videorecorder.uploading-failed": "&#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x930;&#x928;&#x93E; &#x935;&#x93F;&#x92B;&#x932; - &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-videorecorder.verifying": "&#x91C;&#x93E; &#x91A; &#x91C;&#x93E;&#x93F;&#x940; &#x939;&#x948;",
                  "ba-videorecorder.verifying-failed": "&#x938;&#x924;&#x94D;&#x92F;&#x93E;&#x92A;&#x928; &#x935;&#x93F;&#x92B;&#x932; - &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-videorecorder.rerecord-confirm": "&#x915;&#x94D;&#x92F;&#x93E; &#x906;&#x92A; &#x935;&#x93E;&#x938;&#x94D;&#x924;&#x935; &#x92E;&#x947;&#x902; &#x905;&#x92A;&#x928;&#x947; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x915;&#x94B; &#x92B;&#x93F;&#x930; &#x938;&#x947; &#x915;&#x930;&#x928;&#x93E; &#x91A;&#x93E;&#x939;&#x924;&#x947; &#x939;&#x948;&#x902;?",
                  "ba-videorecorder.video_file_too_large": "&#x906;&#x92A;&#x915;&#x940; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x92C;&#x939;&#x941;&#x924; &#x92C;&#x921;&#x93C;&#x940; &#x939;&#x948; (%s) - &#x90F;&#x915; &#x91B;&#x94B;&#x91F;&#x947; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x915;&#x947; &#x938;&#x93E;&#x925; &#x92B;&#x93F;&#x930; &#x938;&#x947; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder.unsupported_video_type": "&#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x930;&#x947;&#x902;: %s - &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "&#x92A;&#x942;&#x930;&#x94D;&#x923; &#x938;&#x94D;&#x915;&#x94D;&#x930;&#x940;&#x928; &#x938;&#x947; &#x92C;&#x93E;&#x939;&#x930; &#x928;&#x93F;&#x915;&#x932;&#x947;&#x902;",
                  "ba-videoplayer-share.share": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x936;&#x947;&#x92F;&#x930; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder-chooser.record-screen": "&#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921; &#x938;&#x94D;&#x915;&#x94D;&#x930;&#x940;&#x928;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "&#x930;&#x94B;&#x915;&#x947;&#x902; &#x938;&#x92E;&#x930;&#x94D;&#x925;&#x93F;&#x924; &#x928;&#x939;&#x940;&#x902; &#x939;&#x948;",
                  "ba-videorecorder-chooser.record-audio": "&#x927;&#x94D;&#x935;&#x928;&#x93F; &#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder-controlbar.stop-available-after": "&#x928;&#x94D;&#x92F;&#x942;&#x928;&#x924;&#x92E; &#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921;&#x93F;&#x902;&#x917; &#x938;&#x92E;&#x92F; %d &#x938;&#x947;&#x915;&#x902;&#x921; &#x939;&#x948;",
                  "ba-videorecorder-controlbar.cancel": "&#x930;&#x926;&#x94D;&#x926; &#x915;&#x930;&#x928;&#x93E;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "&#x930;&#x926;&#x94D;&#x926; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder.cancel-confirm": "&#x915;&#x94D;&#x92F;&#x93E; &#x906;&#x92A; &#x935;&#x93E;&#x915;&#x908; &#x905;&#x92A;&#x928;&#x93E; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x905;&#x92A;&#x932;&#x94B;&#x921; &#x930;&#x926;&#x94D;&#x926; &#x915;&#x930;&#x928;&#x93E; &#x91A;&#x93E;&#x939;&#x924;&#x947; &#x939;&#x948;&#x902;?",
                  "ba-videoplayer-adslot.elapsed-time": "&#x92C;&#x940;&#x924;&#x93E; &#x939;&#x941;&#x906; &#x938;&#x92E;&#x92F;",
                  "ba-videoplayer-adslot.volume-button": "&#x92E;&#x93E;&#x924;&#x94D;&#x930;&#x93E; &#x938;&#x947;&#x91F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videoplayer-adslot.volume-mute": "&#x927;&#x94D;&#x935;&#x928;&#x93F; &#x92E;&#x94D;&#x92F;&#x942;&#x91F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videoplayer-adslot.volume-unmute": "&#x927;&#x94D;&#x935;&#x928;&#x93F; &#x915;&#x94B; &#x905;&#x928;&#x92E;&#x94D;&#x92F;&#x942;&#x91F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videoplayer-adslot.ad-will-end-after": "&#x935;&#x93F;&#x91C;&#x94D;&#x91E;&#x93E;&#x92A;&#x928; %s &#x915;&#x947; &#x92C;&#x93E;&#x926; &#x938;&#x92E;&#x93E;&#x92A;&#x94D;&#x924; &#x939;&#x94B; &#x91C;&#x93E;&#x90F;&#x917;&#x93E;",
                  "ba-videoplayer-adslot.can-skip-after": "%d &#x915;&#x947; &#x92C;&#x93E;&#x926; &#x91B;&#x94B;&#x921;&#x93C;&#x947;&#x902;",
                  "ba-videoplayer-adslot.skip-ad": "&#x935;&#x93F;&#x91C;&#x94D;&#x91E;&#x93E;&#x92A;&#x928; &#x938;&#x947; &#x906;&#x917;&#x947; &#x92C;&#x922;&#x93C;&#x947;&#x902;",
                  "ba-videorecorder.software-required": "&#x906;&#x917;&#x947; &#x92C;&#x922;&#x93C;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x928;&#x93F;&#x92E;&#x94D;&#x928;&#x932;&#x93F;&#x916;&#x93F;&#x924; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E;&#x913;&#x902; &#x915;&#x94B; &#x938;&#x94D;&#x925;&#x93E;&#x92A;&#x93F;&#x924; / &#x938;&#x915;&#x94D;&#x930;&#x93F;&#x92F; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x928;&#x940;&#x91A;&#x947; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-videorecorder.software-waiting": "&#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E;&#x913;&#x902; &#x915;&#x94B; &#x938;&#x94D;&#x925;&#x93E;&#x92A;&#x93F;&#x924; / &#x938;&#x915;&#x94D;&#x930;&#x93F;&#x92F; &#x915;&#x930;&#x928;&#x947; &#x915;&#x940; &#x92A;&#x94D;&#x930;&#x924;&#x940;&#x915;&#x94D;&#x937;&#x93E; &#x915;&#x930; &#x930;&#x939;&#x93E; &#x939;&#x948; &#x906;&#x92A;&#x915;&#x94B; &#x92A;&#x942;&#x930;&#x93E; &#x939;&#x94B;&#x928;&#x947; &#x915;&#x947; &#x92C;&#x93E;&#x926; &#x92A;&#x943;&#x937;&#x94D;&#x920; &#x915;&#x94B; &#x930;&#x940;&#x92B;&#x93C;&#x94D;&#x930;&#x947;&#x936; &#x915;&#x930;&#x928;&#x93E; &#x92A;&#x921;&#x93C; &#x938;&#x915;&#x924;&#x93E; &#x939;&#x948;",
                  "ba-videoplayer-controlbar.close-tracks": "&#x938;&#x940;&#x938;&#x940; &#x92C;&#x902;&#x926; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videoplayer-controlbar.show-tracks": "&#x938;&#x940;&#x938;&#x940; &#x926;&#x93F;&#x916;&#x93E;&#x913;",
                  "ba-videoplayer-tracks.upload-text-tracks": "&#x91F;&#x94D;&#x930;&#x948;&#x915; &#x91F;&#x947;&#x915;&#x94D;&#x938;&#x94D;&#x91F; &#x92B;&#x93E;&#x907;&#x932; &#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videoplayer-tracks.select-text-track-language": "&#x909;&#x92A;&#x936;&#x940;&#x930;&#x94D;&#x937;&#x915; &#x92D;&#x93E;&#x937;&#x93E;",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x92A;&#x939;&#x932;&#x947; &#x932;&#x94B;&#x915;&#x947;&#x932; &#x915;&#x93E; &#x91A;&#x92F;&#x928; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videoplayer-tracks.select-text-track-file": "&#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x915;&#x93E; &#x91A;&#x92F;&#x928; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videoplayer-tracks.back": "&#x935;&#x93E;&#x92A;&#x938;",
                  "ba-videorecorder.framerate-warning": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x92B;&#x94D;&#x930;&#x947;&#x92E; &#x926;&#x930; &#x92C;&#x939;&#x941;&#x924; &#x915;&#x92E; &#x939;&#x948;&#x964; &#x939;&#x92E; &#x938;&#x92D;&#x940; &#x905;&#x928;&#x94D;&#x92F; &#x915;&#x93E;&#x930;&#x94D;&#x92F;&#x915;&#x94D;&#x930;&#x92E;&#x94B;&#x902; &#x914;&#x930; &#x92C;&#x94D;&#x930;&#x93E;&#x909;&#x91C;&#x93C;&#x930; &#x91F;&#x948;&#x92C; &#x915;&#x94B; &#x92C;&#x902;&#x926; &#x915;&#x930;&#x928;&#x947; &#x92F;&#x93E; &#x90F;&#x915; &#x924;&#x947;&#x91C;&#x93C; &#x915;&#x902;&#x92A;&#x94D;&#x92F;&#x942;&#x91F;&#x930; &#x915;&#x93E; &#x909;&#x92A;&#x92F;&#x94B;&#x917; &#x915;&#x930;&#x928;&#x947; &#x915;&#x940; &#x938;&#x932;&#x93E;&#x939; &#x926;&#x947;&#x924;&#x947; &#x939;&#x948;&#x902;&#x964;",
                  "ba-videorecorder.upload-error-duration": "&#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x93F;&#x90F; &#x917;&#x90F; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x915;&#x940; &#x932;&#x902;&#x92C;&#x93E;&#x908; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E;&#x913;&#x902; &#x915;&#x94B; &#x92A;&#x942;&#x930;&#x93E; &#x928;&#x939;&#x940;&#x902; &#x915;&#x930;&#x924;&#x940; &#x939;&#x948; - &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-videorecorder.resolution-constraint-error": "&#x906;&#x92A;&#x915;&#x947; &#x926;&#x94D;&#x935;&#x93E;&#x930;&#x93E; &#x91A;&#x941;&#x928;&#x940; &#x917;&#x908; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915; &#x938;&#x902;&#x915;&#x932;&#x94D;&#x92A; &#x938;&#x947; &#x92E;&#x947;&#x932; &#x928;&#x939;&#x940;&#x902; &#x916;&#x93E;&#x924;&#x940; &#x939;&#x948; - &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-videorecorder.orientation-portrait-required": "&#x92A;&#x94B;&#x930;&#x94D;&#x91F;&#x94D;&#x930;&#x947;&#x91F; &#x92E;&#x94B;&#x921; &#x92E;&#x947;&#x902; &#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x905;&#x92A;&#x928;&#x947; &#x921;&#x93F;&#x935;&#x93E;&#x907;&#x938; &#x915;&#x94B; &#x918;&#x941;&#x92E;&#x93E;&#x90F;&#x902;&#x964;",
                  "ba-videorecorder.orientation-landscape-required": "&#x932;&#x948;&#x902;&#x921;&#x938;&#x94D;&#x915;&#x947;&#x92A; &#x92E;&#x94B;&#x921; &#x92E;&#x947;&#x902; &#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x905;&#x92A;&#x928;&#x947; &#x921;&#x93F;&#x935;&#x93E;&#x907;&#x938; &#x915;&#x94B; &#x918;&#x941;&#x92E;&#x93E;&#x90F;&#x902;&#x964;",
                  "ba-imageviewer-controlbar.rerecord-image": "&#x92B;&#x93F;&#x930; &#x938;&#x947; &#x915;&#x930;&#x947;&#x902;?",
                  "ba-imageviewer-controlbar.submit-image": "&#x915;&#x940; &#x92A;&#x941;&#x937;&#x94D;&#x91F;&#x93F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-imageviewer-controlbar.fullscreen-image": "&#x92A;&#x942;&#x930;&#x94D;&#x923; &#x938;&#x94D;&#x915;&#x94D;&#x930;&#x940;&#x928; &#x926;&#x930;&#x94D;&#x91C; &#x915;&#x930;&#x947;&#x902;",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "&#x92A;&#x942;&#x930;&#x94D;&#x923; &#x938;&#x94D;&#x915;&#x94D;&#x930;&#x940;&#x928; &#x938;&#x947; &#x92C;&#x93E;&#x939;&#x930; &#x928;&#x93F;&#x915;&#x932;&#x947;&#x902;",
                  "ba-imageviewer.image-error": "&#x90F;&#x915; &#x924;&#x94D;&#x930;&#x941;&#x91F;&#x93F; &#x918;&#x91F;&#x93F;&#x924; &#x939;&#x941;&#x908; &#x939;&#x948;, &#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x92C;&#x93E;&#x926; &#x92E;&#x947;&#x902; &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x947;&#x902;&#x964; &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-imagecapture-chooser.image-capture": "&#x91B;&#x935;&#x93F; &#x915;&#x948;&#x92A;&#x94D;&#x91A;&#x930; &#x915;&#x930;&#x947;&#x902;",
                  "ba-imagecapture-chooser.upload-image": "&#x924;&#x938;&#x94D;&#x935;&#x940;&#x930; &#x921;&#x93E;&#x932;&#x93F;&#x92F;&#x947;",
                  "ba-imagecapture-controlbar.settings": "&#x938;&#x947;&#x91F;&#x93F;&#x902;&#x917;&#x94D;&#x938;",
                  "ba-imagecapture-controlbar.camerahealthy": "&#x92A;&#x94D;&#x930;&#x915;&#x93E;&#x936; &#x905;&#x91A;&#x94D;&#x91B;&#x93E; &#x939;&#x948;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "&#x92A;&#x94D;&#x930;&#x915;&#x93E;&#x936; &#x907;&#x937;&#x94D;&#x91F;&#x924;&#x92E; &#x928;&#x939;&#x940;&#x902; &#x939;&#x948;",
                  "ba-imagecapture-controlbar.record": "&#x915;&#x92C;&#x94D;&#x91C;&#x93E;",
                  "ba-imagecapture-controlbar.record-tooltip": "&#x915;&#x92C;&#x94D;&#x91C;&#x93E; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-imagecapture-controlbar.rerecord": "&#x92B;&#x93F;&#x930; &#x938;&#x947; &#x915;&#x930;&#x928;&#x93E;",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "&#x92B;&#x93F;&#x930; &#x938;&#x947; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-imagecapture-controlbar.cancel": "&#x930;&#x926;&#x94D;&#x926; &#x915;&#x930;&#x928;&#x93E;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "&#x930;&#x926;&#x94D;&#x926; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-audioplayer-controlbar.audio-progress": "&#x92A;&#x94D;&#x930;&#x917;&#x924;&#x93F;",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#x92B;&#x93F;&#x930; &#x938;&#x947; &#x915;&#x930;&#x947;&#x902;?",
                  "ba-audioplayer-controlbar.submit-audio": "&#x915;&#x940; &#x92A;&#x941;&#x937;&#x94D;&#x91F;&#x93F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-audioplayer-controlbar.play-audio": "&#x92A;&#x94D;&#x932;&#x947;",
                  "ba-audioplayer-controlbar.pause-audio": "&#x920;&#x939;&#x930;&#x93E;&#x935;",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "&#x930;&#x94B;&#x915;&#x947;&#x902; &#x938;&#x92E;&#x930;&#x94D;&#x925;&#x93F;&#x924; &#x928;&#x939;&#x940;&#x902; &#x939;&#x948;",
                  "ba-audioplayer-controlbar.elapsed-time": "&#x92C;&#x940;&#x924;&#x93E; &#x939;&#x941;&#x906; &#x938;&#x92E;&#x92F;",
                  "ba-audioplayer-controlbar.total-time": "&#x915;&#x940; &#x915;&#x941;&#x932; &#x932;&#x902;&#x92C;&#x93E;&#x908;",
                  "ba-audioplayer-controlbar.volume-button": "&#x935;&#x949;&#x932;&#x94D;&#x92F;&#x942;&#x92E; &#x938;&#x947;&#x91F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-audioplayer-controlbar.volume-mute": "&#x927;&#x94D;&#x935;&#x928;&#x93F; &#x92E;&#x94D;&#x92F;&#x942;&#x91F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-audioplayer-controlbar.volume-unmute": "&#x927;&#x94D;&#x935;&#x928;&#x93F; &#x905;&#x928;&#x92E;&#x94D;&#x92F;&#x942;&#x91F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-audioplayer-loader.tooltip": "&#x932;&#x94B;&#x921; &#x939;&#x94B; &#x930;&#x939;&#x93E; &#x939;&#x948;...",
                  "ba-audioplayer.audio-error": "&#x90F;&#x915; &#x924;&#x94D;&#x930;&#x941;&#x91F;&#x93F; &#x918;&#x91F;&#x93F;&#x924; &#x939;&#x941;&#x908; &#x939;&#x948;, &#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x92C;&#x93E;&#x926; &#x92E;&#x947;&#x902; &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x947;&#x902;&#x964; &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-audiorecorder-chooser.record-audio": "&#x927;&#x94D;&#x935;&#x928;&#x93F; &#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921; &#x915;&#x930;&#x947;&#x902;",
                  "ba-audiorecorder-chooser.upload-audio": "&#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x930;&#x947;&#x902;",
                  "ba-audiorecorder-controlbar.settings": "&#x938;&#x947;&#x91F;&#x93F;&#x902;&#x917;&#x94D;&#x938;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "&#x927;&#x94D;&#x935;&#x928;&#x93F; &#x905;&#x91A;&#x94D;&#x91B;&#x940; &#x939;&#x948;&#x902;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "&#x915;&#x94B;&#x908; &#x906;&#x935;&#x93E;&#x91C; &#x928;&#x939;&#x940;&#x902; &#x909;&#x920;&#x93E; &#x938;&#x915;&#x924;&#x947; &#x939;&#x948;&#x902;",
                  "ba-audiorecorder-controlbar.record": "&#x905;&#x92D;&#x93F;&#x932;&#x947;&#x916;",
                  "ba-audiorecorder-controlbar.record-tooltip": "&#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-audiorecorder-controlbar.rerecord": "&#x92B;&#x93F;&#x930; &#x938;&#x947; &#x915;&#x930;&#x928;&#x93E;",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "&#x92B;&#x93F;&#x930; &#x938;&#x947; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-audiorecorder-controlbar.stop": "&#x930;&#x941;&#x915;&#x947;&#x902;",
                  "ba-audiorecorder-controlbar.stop-tooltip": "&#x930;&#x94B;&#x915;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-audiorecorder-controlbar.stop-available-after": "&#x928;&#x94D;&#x92F;&#x942;&#x928;&#x924;&#x92E; &#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921;&#x93F;&#x902;&#x917; &#x938;&#x92E;&#x92F; %d &#x938;&#x947;&#x915;&#x947;&#x902;&#x921; &#x939;&#x948;",
                  "ba-audiorecorder-controlbar.cancel": "&#x930;&#x926;&#x94D;&#x926; &#x915;&#x930;&#x928;&#x93E;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "&#x930;&#x926;&#x94D;&#x926; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-videoplayer-controlbar.player-speed": "&#x916;&#x93F;&#x932;&#x93E;&#x921;&#x93C;&#x940; &#x915;&#x940; &#x917;&#x924;&#x93F;",
                  "ba-videoplayer-controlbar.settings": "&#x938;&#x947;&#x91F;&#x93F;&#x902;&#x917;&#x94D;&#x938;",
                  "ba-videoplayer-controlbar.airplay": "&#x90F;&#x92F;&#x930;&#x92A;&#x94D;&#x932;&#x947;",
                  "ba-videoplayer-controlbar.airplay-icon": "&#x90F;&#x92F;&#x930;&#x92A;&#x94D;&#x932;&#x947; &#x906;&#x907;&#x915;&#x928;&#x964;",
                  "ba-videoplayer.all-settings": "&#x938;&#x92D;&#x940; &#x938;&#x947;&#x91F;&#x93F;&#x902;&#x917;&#x94D;&#x938;",
                  "ba-videoplayer.player-speed": "&#x916;&#x93F;&#x932;&#x93E;&#x921;&#x93C;&#x940; &#x915;&#x940; &#x917;&#x924;&#x93F;",
                  "ba-videoplayer.full-screen": "&#x92A;&#x942;&#x930;&#x94D;&#x923; &#x938;&#x94D;&#x915;&#x94D;&#x930;&#x940;&#x928;",
                  "ba-videorecorder-controlbar.add-stream": "&#x938;&#x94D;&#x91F;&#x94D;&#x930;&#x940;&#x92E; &#x91C;&#x94B;&#x921;&#x93C;&#x947;&#x902;",
                  "ba-videorecorder.switch-camera": "&#x915;&#x948;&#x92E;&#x930;&#x93E; &#x938;&#x94D;&#x935;&#x93F;&#x91A; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder.prepare-covershot": "&#x915;&#x935;&#x930;&#x936;&#x949;&#x91F; &#x924;&#x948;&#x92F;&#x93E;&#x930; &#x915;&#x930;&#x928;&#x93E;",
                  "ba-videorecorder.prepare-thumbnails": "&#x925;&#x92E;&#x94D;&#x92C;&#x93F;&#x902;&#x917; &#x915;&#x940; &#x924;&#x948;&#x92F;&#x93E;&#x930;&#x940; &#x915;&#x930;&#x928;&#x93E;",
                  "ba-videorecorder.adding-new-stream": "&#x928;&#x908; &#x938;&#x94D;&#x91F;&#x94D;&#x930;&#x940;&#x92E; &#x91C;&#x94B;&#x921;&#x93C;&#x928;&#x93E;",
                  "ba-imagecapture.recorder-error": "&#x90F;&#x915; &#x924;&#x94D;&#x930;&#x941;&#x91F;&#x93F; &#x918;&#x91F;&#x93F;&#x924; &#x939;&#x941;&#x908; &#x939;&#x948;, &#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x92C;&#x93E;&#x926; &#x92E;&#x947;&#x902; &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x947;&#x902;&#x964; &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-imagecapture.attach-error": "&#x939;&#x92E; &#x92E;&#x940;&#x921;&#x93F;&#x92F;&#x93E; &#x907;&#x902;&#x91F;&#x930;&#x92B;&#x93C;&#x947;&#x938; &#x915;&#x93E; &#x909;&#x92A;&#x92F;&#x94B;&#x917; &#x928;&#x939;&#x940;&#x902; &#x915;&#x930; &#x938;&#x915;&#x947;&#x964; &#x921;&#x93F;&#x935;&#x93E;&#x907;&#x938; &#x914;&#x930; &#x92C;&#x94D;&#x930;&#x93E;&#x909;&#x91C;&#x93C;&#x930; &#x915;&#x947; &#x906;&#x927;&#x93E;&#x930; &#x92A;&#x930;, &#x906;&#x92A;&#x915;&#x94B; &#x90F;&#x938;&#x90F;&#x938;&#x90F;&#x932; &#x915;&#x947; &#x92E;&#x93E;&#x927;&#x94D;&#x92F;&#x92E; &#x938;&#x947; &#x92B;&#x94D;&#x932;&#x948;&#x936; &#x938;&#x94D;&#x925;&#x93E;&#x92A;&#x93F;&#x924; &#x915;&#x930;&#x928;&#x947; &#x92F;&#x93E; &#x92A;&#x943;&#x937;&#x94D;&#x920; &#x924;&#x915; &#x92A;&#x939;&#x941;&#x902;&#x91A;&#x928;&#x947; &#x915;&#x940; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E; &#x939;&#x94B; &#x938;&#x915;&#x924;&#x940; &#x939;&#x948;&#x964;",
                  "ba-imagecapture.software-required": "&#x906;&#x917;&#x947; &#x92C;&#x922;&#x93C;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x928;&#x93F;&#x92E;&#x94D;&#x928; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E;&#x913;&#x902; &#x915;&#x94B; &#x938;&#x94D;&#x925;&#x93E;&#x92A;&#x93F;&#x924; / &#x938;&#x915;&#x94D;&#x930;&#x93F;&#x92F; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x928;&#x940;&#x91A;&#x947; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-imagecapture.software-waiting": "&#x938;&#x94D;&#x925;&#x93E;&#x92A;&#x93F;&#x924; / &#x938;&#x915;&#x94D;&#x930;&#x93F;&#x92F; &#x939;&#x94B;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E;&#x913;&#x902; &#x915;&#x940; &#x92A;&#x94D;&#x930;&#x924;&#x940;&#x915;&#x94D;&#x937;&#x93E; &#x915;&#x930; &#x930;&#x939;&#x93E; &#x939;&#x948;&#x964; &#x92A;&#x942;&#x930;&#x93E; &#x939;&#x94B;&#x928;&#x947; &#x915;&#x947; &#x92C;&#x93E;&#x926; &#x906;&#x92A;&#x915;&#x94B; &#x92A;&#x943;&#x937;&#x94D;&#x920; &#x915;&#x94B; &#x930;&#x93F;&#x92B;&#x94D;&#x930;&#x947;&#x936; &#x915;&#x930;&#x928;&#x947; &#x915;&#x940; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E; &#x939;&#x94B; &#x938;&#x915;&#x924;&#x940; &#x939;&#x948;&#x964;",
                  "ba-imagecapture.access-forbidden": "&#x92E;&#x940;&#x921;&#x93F;&#x92F;&#x93E; &#x924;&#x915; &#x92A;&#x939;&#x941;&#x902;&#x91A; &#x915;&#x940; &#x92E;&#x928;&#x93E;&#x939;&#x940; &#x925;&#x940;&#x964; &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-imagecapture.uploading": "&#x905;&#x92A;&#x932;&#x94B;&#x921; &#x939;&#x94B; &#x930;&#x939;&#x93E; &#x939;&#x948;",
                  "ba-imagecapture.uploading-failed": "&#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x930;&#x928;&#x93E; &#x935;&#x93F;&#x92B;&#x932; - &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-imagecapture.upload-error-duration": "&#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x940; &#x917;&#x908; &#x91B;&#x935;&#x93F; &#x915;&#x940; &#x932;&#x902;&#x92C;&#x93E;&#x908; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E;&#x913;&#x902; &#x915;&#x94B; &#x92A;&#x942;&#x930;&#x93E; &#x928;&#x939;&#x940;&#x902; &#x915;&#x930;&#x924;&#x940; &#x939;&#x948; - &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-imagecapture.resolution-constraint-error": "&#x906;&#x92A;&#x915;&#x947; &#x926;&#x94D;&#x935;&#x93E;&#x930;&#x93E; &#x91A;&#x92F;&#x928;&#x93F;&#x924; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915; &#x930;&#x93F;&#x91C;&#x93C;&#x949;&#x932;&#x94D;&#x92F;&#x942;&#x936;&#x928; &#x938;&#x947; &#x92E;&#x947;&#x932; &#x928;&#x939;&#x940;&#x902; &#x916;&#x93E;&#x924;&#x940; &#x939;&#x948; - &#x92B;&#x93F;&#x930; &#x938;&#x947; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-imagecapture.verifying": "&#x938;&#x924;&#x94D;&#x92F;&#x93E;&#x92A;&#x93F;&#x924; &#x915;&#x93F;&#x92F;&#x93E; &#x91C;&#x93E; &#x930;&#x939;&#x93E;",
                  "ba-imagecapture.verifying-failed": "&#x938;&#x924;&#x94D;&#x92F;&#x93E;&#x92A;&#x93F;&#x924; &#x915;&#x930;&#x928;&#x93E; &#x935;&#x93F;&#x92B;&#x932; - &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-imagecapture.rerecord-confirm": "&#x915;&#x94D;&#x92F;&#x93E; &#x906;&#x92A; &#x935;&#x93E;&#x938;&#x94D;&#x924;&#x935; &#x92E;&#x947;&#x902; &#x905;&#x92A;&#x928;&#x940; &#x91B;&#x935;&#x93F; &#x915;&#x94B; &#x92B;&#x93F;&#x930; &#x938;&#x947; &#x92C;&#x928;&#x93E;&#x928;&#x93E; &#x91A;&#x93E;&#x939;&#x924;&#x947; &#x939;&#x948;&#x902;?",
                  "ba-imagecapture.image_file_too_large": "&#x906;&#x92A;&#x915;&#x940; &#x91B;&#x935;&#x93F; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x92C;&#x939;&#x941;&#x924; &#x92C;&#x921;&#x93C;&#x940; &#x939;&#x948; (%s) - &#x90F;&#x915; &#x91B;&#x94B;&#x91F;&#x940; &#x91B;&#x935;&#x93F; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x915;&#x947; &#x938;&#x93E;&#x925; &#x92B;&#x93F;&#x930; &#x938;&#x947; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-imagecapture.unsupported_image_type": "&#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x930;&#x947;&#x902;: %s - &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-imagecapture.orientation-portrait-required": "&#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x92A;&#x94B;&#x930;&#x94D;&#x91F;&#x94D;&#x930;&#x947;&#x91F; &#x92E;&#x94B;&#x921; &#x92E;&#x947;&#x902; &#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x905;&#x92A;&#x928;&#x947; &#x921;&#x93F;&#x935;&#x93E;&#x907;&#x938; &#x915;&#x94B; &#x918;&#x941;&#x92E;&#x93E;&#x90F;&#x902;&#x964;",
                  "ba-imagecapture.orientation-landscape-required": "&#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x905;&#x92A;&#x928;&#x947; &#x921;&#x93F;&#x935;&#x93E;&#x907;&#x938; &#x915;&#x94B; &#x932;&#x948;&#x902;&#x921;&#x938;&#x94D;&#x915;&#x947;&#x92A; &#x92E;&#x94B;&#x921; &#x92E;&#x947;&#x902; &#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x918;&#x941;&#x92E;&#x93E;&#x90F;&#x902;&#x964;",
                  "ba-audiorecorder.recorder-error": "&#x90F;&#x915; &#x924;&#x94D;&#x930;&#x941;&#x91F;&#x93F; &#x918;&#x91F;&#x93F;&#x924; &#x939;&#x941;&#x908; &#x939;&#x948;, &#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x92C;&#x93E;&#x926; &#x92E;&#x947;&#x902; &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x947;&#x902;&#x964; &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-audiorecorder.attach-error": "&#x939;&#x92E; &#x92E;&#x940;&#x921;&#x93F;&#x92F;&#x93E; &#x907;&#x902;&#x91F;&#x930;&#x92B;&#x93C;&#x947;&#x938; &#x915;&#x93E; &#x909;&#x92A;&#x92F;&#x94B;&#x917; &#x928;&#x939;&#x940;&#x902; &#x915;&#x930; &#x938;&#x915;&#x947;&#x964; &#x921;&#x93F;&#x935;&#x93E;&#x907;&#x938; &#x914;&#x930; &#x92C;&#x94D;&#x930;&#x93E;&#x909;&#x91C;&#x93C;&#x930; &#x915;&#x947; &#x906;&#x927;&#x93E;&#x930; &#x92A;&#x930;, &#x906;&#x92A;&#x915;&#x94B; &#x90F;&#x938;&#x90F;&#x938;&#x90F;&#x932; &#x915;&#x947; &#x92E;&#x93E;&#x927;&#x94D;&#x92F;&#x92E; &#x938;&#x947; &#x92B;&#x94D;&#x932;&#x948;&#x936; &#x938;&#x94D;&#x925;&#x93E;&#x92A;&#x93F;&#x924; &#x915;&#x930;&#x928;&#x947; &#x92F;&#x93E; &#x92A;&#x943;&#x937;&#x94D;&#x920; &#x924;&#x915; &#x92A;&#x939;&#x941;&#x902;&#x91A;&#x928;&#x947; &#x915;&#x940; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E; &#x939;&#x94B; &#x938;&#x915;&#x924;&#x940; &#x939;&#x948;&#x964;",
                  "ba-audiorecorder.software-required": "&#x906;&#x917;&#x947; &#x92C;&#x922;&#x93C;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x928;&#x93F;&#x92E;&#x94D;&#x928; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E;&#x913;&#x902; &#x915;&#x94B; &#x938;&#x94D;&#x925;&#x93E;&#x92A;&#x93F;&#x924; / &#x938;&#x915;&#x94D;&#x930;&#x93F;&#x92F; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x928;&#x940;&#x91A;&#x947; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-audiorecorder.software-waiting": "&#x938;&#x94D;&#x925;&#x93E;&#x92A;&#x93F;&#x924; / &#x938;&#x915;&#x94D;&#x930;&#x93F;&#x92F; &#x939;&#x94B;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E;&#x913;&#x902; &#x915;&#x940; &#x92A;&#x94D;&#x930;&#x924;&#x940;&#x915;&#x94D;&#x937;&#x93E; &#x915;&#x930; &#x930;&#x939;&#x93E; &#x939;&#x948;&#x964; &#x92A;&#x942;&#x930;&#x93E; &#x939;&#x94B;&#x928;&#x947; &#x915;&#x947; &#x92C;&#x93E;&#x926; &#x906;&#x92A;&#x915;&#x94B; &#x92A;&#x943;&#x937;&#x94D;&#x920; &#x915;&#x94B; &#x930;&#x93F;&#x92B;&#x94D;&#x930;&#x947;&#x936; &#x915;&#x930;&#x928;&#x947; &#x915;&#x940; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E; &#x939;&#x94B; &#x938;&#x915;&#x924;&#x940; &#x939;&#x948;&#x964;",
                  "ba-audiorecorder.access-forbidden": "&#x92E;&#x940;&#x921;&#x93F;&#x92F;&#x93E; &#x924;&#x915; &#x92A;&#x939;&#x941;&#x902;&#x91A; &#x915;&#x940; &#x92E;&#x928;&#x93E;&#x939;&#x940; &#x925;&#x940;&#x964; &#x92A;&#x941;&#x928;&#x903; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-audiorecorder.uploading": "&#x905;&#x92A;&#x932;&#x94B;&#x921; &#x939;&#x94B; &#x930;&#x939;&#x93E; &#x939;&#x948;",
                  "ba-audiorecorder.uploading-failed": "&#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x930;&#x928;&#x93E; &#x935;&#x93F;&#x92B;&#x932; - &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-audiorecorder.upload-error-duration": "&#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x93F;&#x90F; &#x917;&#x90F; &#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x915;&#x940; &#x932;&#x902;&#x92C;&#x93E;&#x908; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E;&#x913;&#x902; &#x915;&#x94B; &#x92A;&#x942;&#x930;&#x93E; &#x928;&#x939;&#x940;&#x902; &#x915;&#x930;&#x924;&#x940; &#x939;&#x948; - &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-audiorecorder.verifying": "&#x938;&#x924;&#x94D;&#x92F;&#x93E;&#x92A;&#x93F;&#x924; &#x915;&#x93F;&#x92F;&#x93E; &#x91C;&#x93E; &#x930;&#x939;&#x93E;",
                  "ba-audiorecorder.verifying-failed": "&#x938;&#x924;&#x94D;&#x92F;&#x93E;&#x92A;&#x93F;&#x924; &#x915;&#x930;&#x928;&#x93E; &#x935;&#x93F;&#x92B;&#x932; - &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-audiorecorder.rerecord-confirm": "&#x915;&#x94D;&#x92F;&#x93E; &#x906;&#x92A; &#x935;&#x93E;&#x938;&#x94D;&#x924;&#x935; &#x92E;&#x947;&#x902; &#x905;&#x92A;&#x928;&#x947; &#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x915;&#x94B; &#x92B;&#x93F;&#x930; &#x938;&#x947; &#x915;&#x930;&#x928;&#x93E; &#x91A;&#x93E;&#x939;&#x924;&#x947; &#x939;&#x948;&#x902;?",
                  "ba-audiorecorder.cancel-confirm": "&#x915;&#x94D;&#x92F;&#x93E; &#x906;&#x92A; &#x935;&#x93E;&#x938;&#x94D;&#x924;&#x935; &#x92E;&#x947;&#x902; &#x905;&#x92A;&#x928;&#x947; &#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x94B; &#x930;&#x926;&#x94D;&#x926; &#x915;&#x930;&#x928;&#x93E; &#x91A;&#x93E;&#x939;&#x924;&#x947; &#x939;&#x948;&#x902;?",
                  "ba-audiorecorder.audio_file_too_large": "&#x906;&#x92A;&#x915;&#x940; &#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x92C;&#x939;&#x941;&#x924; &#x92C;&#x921;&#x93C;&#x940; &#x939;&#x948; (%s) - &#x90F;&#x915; &#x91B;&#x94B;&#x91F;&#x940; &#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x915;&#x947; &#x938;&#x93E;&#x925; &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-audiorecorder.unsupported_audio_type": "&#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x930;&#x947;&#x902;: %s - &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92F;&#x939;&#x93E;&#x902; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-common-settingsmenu.tooltip": "&#x91A;&#x932;&#x93E;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-common-settingsmenu.setting-menu": "&#x938;&#x92D;&#x940; &#x938;&#x947;&#x91F;&#x93F;&#x902;&#x917;&#x94D;&#x938;",
                  "ba-common-settingsmenu.source-quality": "&#x938;&#x94D;&#x930;&#x94B;&#x924; &#x915;&#x940; &#x917;&#x941;&#x923;&#x935;&#x924;&#x94D;&#x924;&#x93E;",
                  "ba-common-settingsmenu.player-speed": "&#x916;&#x93F;&#x932;&#x93E;&#x921;&#x93C;&#x940; &#x915;&#x940; &#x917;&#x924;&#x93F;",
                  "ba-common-settingsmenu.set-menu-option": "&#x935;&#x93F;&#x915;&#x932;&#x94D;&#x92A; &#x938;&#x947;&#x91F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-common-settingsmenu.submit-video": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x915;&#x940; &#x92A;&#x941;&#x937;&#x94D;&#x91F;&#x93F; &#x915;&#x930;&#x947;&#x902;",
                  "ba-common-settingsmenu.picture-in-picture": "&#x91A;&#x93F;&#x924;&#x94D;&#x930; &#x92E;&#x947;&#x902; &#x91A;&#x93F;&#x924;&#x94D;&#x930;",
                  "ba-common-settingsmenu.exit-fullscreen-video": "&#x92A;&#x942;&#x930;&#x94D;&#x923; &#x938;&#x94D;&#x915;&#x94D;&#x930;&#x940;&#x928; &#x938;&#x947; &#x92C;&#x93E;&#x939;&#x930; &#x928;&#x93F;&#x915;&#x932;&#x947;&#x902;",
                  "ba-common-settingsmenu.fullscreen-video": "&#x92A;&#x942;&#x930;&#x94D;&#x923; &#x938;&#x94D;&#x915;&#x94D;&#x930;&#x940;&#x928; &#x926;&#x930;&#x94D;&#x91C; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder-chooser.multi-stream": "&#x92E;&#x932;&#x94D;&#x91F;&#x940; &#x938;&#x94D;&#x91F;&#x94D;&#x930;&#x940;&#x92E;",
                  "ba-videorecorder-controlbar.pause-recorder": "&#x935;&#x93F;&#x930;&#x93E;&#x92E; &#x926;&#x947;&#x928;&#x947; &#x935;&#x93E;&#x932;&#x93E;",
                  "ba-videorecorder-controlbar.resume-recorder": "&#x92B;&#x93F;&#x930; &#x938;&#x947; &#x936;&#x941;&#x930;&#x942; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder.missing-track": "&#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915; &#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x92F;&#x93E; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x91F;&#x94D;&#x930;&#x948;&#x915; &#x917;&#x93E;&#x92F;&#x92C; &#x939;&#x948;",
                  "ba-videorecorder.device-already-in-use": "&#x906;&#x92A;&#x915;&#x93E; &#x915;&#x92E; &#x938;&#x947; &#x915;&#x92E; &#x90F;&#x915; &#x907;&#x928;&#x92A;&#x941;&#x91F; &#x921;&#x93F;&#x935;&#x93E;&#x907;&#x938; &#x92A;&#x939;&#x932;&#x947; &#x938;&#x947; &#x939;&#x940; &#x909;&#x92A;&#x92F;&#x94B;&#x917; &#x92E;&#x947;&#x902; &#x939;&#x948;",
                  "ba-videorecorder.browser-permission-denied": "&#x92C;&#x94D;&#x930;&#x93E;&#x909;&#x91C;&#x93C;&#x930; &#x926;&#x94D;&#x935;&#x93E;&#x930;&#x93E; &#x905;&#x928;&#x941;&#x92E;&#x924;&#x93F; &#x938;&#x947; &#x907;&#x928;&#x915;&#x93E;&#x930; &#x915;&#x93F;&#x92F;&#x93E; &#x917;&#x92F;&#x93E; &#x939;&#x948;, &#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x92A;&#x939;&#x941;&#x901;&#x91A; &#x914;&#x930; &#x92A;&#x941;&#x928;&#x903; &#x932;&#x94B;&#x921; &#x92A;&#x943;&#x937;&#x94D;&#x920; &#x92A;&#x94D;&#x930;&#x926;&#x93E;&#x928; &#x915;&#x930;&#x947;&#x902;",
                  "ba-audioplayer.all-settings": "&#x938;&#x92D;&#x940; &#x938;&#x947;&#x91F;&#x93F;&#x902;&#x917;&#x94D;&#x938;",
                  "ba-videoplayer-controlbar.remaining-time": "&#x936;&#x947;&#x937; &#x938;&#x92E;&#x92F;",
                  "ba-videoplayer-controlbar.select-frame": "&#x91A;&#x941;&#x928;&#x924;&#x947; &#x939;&#x948;&#x902;",
                  "ba-videoplayer-controlbar.trim-video": "&#x91F;&#x94D;&#x930;&#x93F;&#x92E;",
                  "ba-videoplayer-playbutton.trim": "&#x91F;&#x94D;&#x930;&#x93F;&#x92E;",
                  "ba-videoplayer-playbutton.skip": "&#x91B;&#x94B;&#x921;&#x93C;&#x947;&#x902;",
                  "ba-videorecorder-imagegallery.upload-covershot": "&#x915;&#x935;&#x930; &#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder.pick-covershot-frame": "&#x915;&#x935;&#x930;&#x936;&#x949;&#x91F; &#x915;&#x947; &#x930;&#x942;&#x92A; &#x92E;&#x947;&#x902; &#x909;&#x92A;&#x92F;&#x94B;&#x917; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x90F;&#x915; &#x92B;&#x94D;&#x930;&#x947;&#x92E; &#x915;&#x93E; &#x91A;&#x92F;&#x928; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ba-videorecorder.screen-recorder-is-not-supported": "&#x907;&#x938; &#x921;&#x93F;&#x935;&#x93E;&#x907;&#x938; &#x92A;&#x930; &#x938;&#x94D;&#x915;&#x94D;&#x930;&#x940;&#x928; &#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921;&#x930; &#x938;&#x92E;&#x930;&#x94D;&#x925;&#x93F;&#x924; &#x928;&#x939;&#x940;&#x902; &#x939;&#x948;",
                  "ba-videorecorder.trim-prompt": "&#x915;&#x94D;&#x92F;&#x93E; &#x906;&#x92A; &#x905;&#x92A;&#x928;&#x93E; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x91F;&#x94D;&#x930;&#x93F;&#x92E; &#x915;&#x930;&#x928;&#x93E; &#x91A;&#x93E;&#x939;&#x924;&#x947; &#x939;&#x948;&#x902;?",
                  "ba-videorecorder.trim-video": "&#x905;&#x92A;&#x928;&#x947; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x915;&#x94B; &#x91F;&#x94D;&#x930;&#x93F;&#x92E; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x92A;&#x94D;&#x930;&#x93E;&#x930;&#x902;&#x92D; &#x914;&#x930; &#x938;&#x92E;&#x93E;&#x92A;&#x94D;&#x924;&#x93F; &#x92E;&#x93E;&#x930;&#x94D;&#x915;&#x930;&#x94B;&#x902; &#x915;&#x94B; &#x938;&#x94D;&#x925;&#x93E;&#x928;&#x93E;&#x902;&#x924;&#x930;&#x93F;&#x924; &#x915;&#x930;&#x947;&#x902;",
                  "ba-videorecorder.wait-for-trim": "&#x91F;&#x94D;&#x930;&#x93F;&#x92E; &#x915;&#x92E;&#x93E;&#x902;&#x921; &#x915;&#x940; &#x92A;&#x94D;&#x930;&#x924;&#x940;&#x915;&#x94D;&#x937;&#x93E; &#x915;&#x940; &#x91C;&#x93E; &#x930;&#x939;&#x940; &#x939;&#x948;...",
                  "ba-videorecorder-controlbar.no-video-source": "&#x905;&#x924;&#x93F;&#x930;&#x93F;&#x915;&#x94D;&#x924; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x907;&#x928;&#x92A;&#x941;&#x91F; &#x938;&#x94D;&#x930;&#x94B;&#x924; &#x917;&#x941;&#x92E; &#x939;&#x948;",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x905;&#x924;&#x93F;&#x930;&#x93F;&#x915;&#x94D;&#x924; &#x938;&#x94D;&#x91F;&#x94D;&#x930;&#x940;&#x92E; &#x92A;&#x939;&#x932;&#x947; &#x939;&#x940; &#x91A;&#x941;&#x928;&#x940; &#x91C;&#x93E; &#x91A;&#x941;&#x915;&#x940; &#x939;&#x948;",
                  "ba-videorecorder.uploading-src-error": "&#x905;&#x92D;&#x940; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x935;&#x93E;&#x92A;&#x938; &#x91A;&#x932;&#x93E;&#x928;&#x947; &#x92E;&#x947;&#x902; &#x905;&#x938;&#x92E;&#x930;&#x94D;&#x925;, &#x905;&#x92A;&#x932;&#x94B;&#x921; &#x915;&#x930;&#x928;&#x93E; &#x905;&#x92D;&#x940; &#x92D;&#x940; &#x92A;&#x94D;&#x930;&#x917;&#x924;&#x93F; &#x92A;&#x930; &#x939;&#x948;",
                  "ba-audiorecorder-controlbar.pause-recorder": "&#x930;&#x94B;&#x915;&#x947;&#x902; &#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921;&#x930;",
                  "ba-audiorecorder-controlbar.resume-recorder": "&#x930;&#x93F;&#x91C;&#x94D;&#x92F;&#x942;&#x92E;&#x947; &#x930;&#x93F;&#x915;&#x949;&#x930;&#x94D;&#x921;&#x930;"
                },
                "language:hr": {
                  "ba-videoplayer-playbutton.tooltip": "Kliknite za reprodukciju video zapisa.",
                  "ba-videoplayer-playbutton.rerecord": "preurediti",
                  "ba-videoplayer-playbutton.submit-video": "Potvrda videa",
                  "ba-videoplayer-loader.tooltip": "U&#x10D;itavanje videa ...",
                  "ba-videoplayer-controlbar.change-resolution": "Promjena razlu&#x10D;ivosti",
                  "ba-videoplayer-controlbar.video-progress": "napredak Video",
                  "ba-videoplayer-controlbar.rerecord-video": "Ponovi video?",
                  "ba-videoplayer-controlbar.submit-video": "Potvrda videa",
                  "ba-videoplayer-controlbar.play-video": "Reprodukcija videozapisa",
                  "ba-videoplayer-controlbar.pause-video": "Pauza Video",
                  "ba-videoplayer-controlbar.elapsed-time": "Proteklo vrijeme",
                  "ba-videoplayer-controlbar.total-time": "Ukupna du&#x17E;ina videa",
                  "ba-videoplayer-controlbar.fullscreen-video": "Idi na puni zaslon",
                  "ba-videoplayer-controlbar.volume-button": "Set volumen",
                  "ba-videoplayer-controlbar.volume-mute": "Bez zvuka",
                  "ba-videoplayer-controlbar.volume-unmute": "Vrati zvuk",
                  "ba-videoplayer.video-error": "Do&#x161;lo je do pogre&#x161;ke. Molimo poku&#x161;ajte ponovno kasnije. Kliknite za ponovni poku&#x161;aj.",
                  "ba-videorecorder-chooser.record-video": "Snimanje videa",
                  "ba-videorecorder-chooser.upload-video": "Dodaj video",
                  "ba-videorecorder-controlbar.settings": "Postavke",
                  "ba-videorecorder-controlbar.camerahealthy": "Rasvjeta je dobra",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Rasvjeta nije optimalno",
                  "ba-videorecorder-controlbar.microphonehealthy": "Zvuk je dobar",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "ne mo&#x17E;e podi&#x107;i bilo koji zvuk",
                  "ba-videorecorder-controlbar.record": "Snimiti",
                  "ba-videorecorder-controlbar.record-tooltip": "Kliknite ovdje za snimanje.",
                  "ba-videorecorder-controlbar.rerecord": "preurediti",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Kliknite ovdje ponoviti.",
                  "ba-videorecorder-controlbar.upload-covershot": "Postavi",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Kliknite ovdje kako biste poslali prilago&#x111;ene cover metak",
                  "ba-videorecorder-controlbar.stop": "Stop",
                  "ba-videorecorder-controlbar.stop-tooltip": "Kliknite ovdje da se zaustavi.",
                  "ba-videorecorder-controlbar.skip": "Presko&#x10D;iti",
                  "ba-videorecorder-controlbar.skip-tooltip": "Kliknite ovdje presko&#x10D;iti.",
                  "ba-videorecorder.recorder-error": "Do&#x161;lo je do pogre&#x161;ke. Molimo poku&#x161;ajte ponovno kasnije. Kliknite za ponovni poku&#x161;aj.",
                  "ba-videorecorder.attach-error": "Nismo mogli pristupiti su&#x10D;elju fotoaparata. Ovisno o ure&#x111;aju i preglednika, mo&#x17E;da &#x107;ete morati instalirati Flash ili pristupiti stranici putem SSL-a.",
                  "ba-videorecorder.access-forbidden": "Pristup kameri je zabranjeno. Kliknite za ponovni poku&#x161;aj.",
                  "ba-videorecorder.pick-covershot": "Izaberite covershot.",
                  "ba-videorecorder.uploading": "Prijenos",
                  "ba-videorecorder.uploading-failed": "Prijenos nije uspio - kliknite ovdje za ponovni poku&#x161;aj.",
                  "ba-videorecorder.verifying": "Potvr&#x111;ivanje",
                  "ba-videorecorder.verifying-failed": "Potvr&#x111;ivanje nije uspjelo - kliknite ovdje za ponovni poku&#x161;aj.",
                  "ba-videorecorder.rerecord-confirm": "Da li zaista &#x17E;elite ponoviti svoj video?",
                  "ba-videorecorder.video_file_too_large": "Va&#x161; video datoteka je prevelika (%s) - kliknite ovdje kako bi poku&#x161;ali ponovno s manjim video datoteka.",
                  "ba-videorecorder.unsupported_video_type": "Prenesite: %s - kliknite ovdje za ponovni poku&#x161;aj.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Iza&#x111;ite iz cijelog zaslona",
                  "ba-videoplayer-share.share": "Dijeljenje videozapisa",
                  "ba-videorecorder-chooser.record-screen": "Zaslon za snimanje",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pauza nije podr&#x17E;ana",
                  "ba-videorecorder-chooser.record-audio": "Snimanje zvuka",
                  "ba-videorecorder-controlbar.stop-available-after": "Minimalno vrijeme snimanja je %d sekundi",
                  "ba-videorecorder-controlbar.cancel": "Otkazati",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Kliknite ovdje kako biste odustali.",
                  "ba-videorecorder.cancel-confirm": "&#x17D;elite li zaista odustati od prijenosa videozapisa?",
                  "ba-videoplayer-adslot.elapsed-time": "Proteklo vrijeme",
                  "ba-videoplayer-adslot.volume-button": "Postavite glasno&#x107;u",
                  "ba-videoplayer-adslot.volume-mute": "Isklju&#x10D;ite zvuk",
                  "ba-videoplayer-adslot.volume-unmute": "Uklju&#x10D;i zvuk",
                  "ba-videoplayer-adslot.ad-will-end-after": "Oglas zavr&#x161;ava nakon %s",
                  "ba-videoplayer-adslot.can-skip-after": "Presko&#x10D;i nakon %d",
                  "ba-videoplayer-adslot.skip-ad": "Presko&#x10D;ite oglas",
                  "ba-videorecorder.software-required": "Kliknite dolje da biste instalirali / aktivirali sljede&#x107;e uvjete kako biste nastavili.",
                  "ba-videorecorder.software-waiting": "&#x10C;eka se postavljanje / aktiviranje zahtjeva. Mo&#x17E;da &#x107;ete morati osvje&#x17E;iti stranicu nakon zavr&#x161;etka.",
                  "ba-videoplayer-controlbar.close-tracks": "Zatvori CC",
                  "ba-videoplayer-controlbar.show-tracks": "Prika&#x17E;i CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Prenesite tekstne datoteke zapisa",
                  "ba-videoplayer-tracks.select-text-track-language": "Jezik podnaslova",
                  "ba-videoplayer-tracks.info-select-locale-first": "Prvo odaberite mjesto",
                  "ba-videoplayer-tracks.select-text-track-file": "Kliknite za odabir datoteke",
                  "ba-videoplayer-tracks.back": "le&#x111;a",
                  "ba-videorecorder.framerate-warning": "Brzina videozapisa je vrlo niska. Preporu&#x10D;ujemo zatvaranje svih ostalih programa i kartica preglednika ili kori&#x161;tenje br&#x17E;eg ra&#x10D;unala.",
                  "ba-videorecorder.upload-error-duration": "Duljina prijenosa videozapisa ne zadovoljava uvjete - kliknite ovdje kako biste poku&#x161;ali ponovno.",
                  "ba-videorecorder.resolution-constraint-error": "Odabrana datoteka ne odgovara potrebnoj rezoluciji - kliknite ovdje kako biste poku&#x161;ali ponovno.",
                  "ba-videorecorder.orientation-portrait-required": "Zakrenite ure&#x111;aj za snimanje u portretnom na&#x10D;inu rada.",
                  "ba-videorecorder.orientation-landscape-required": "Zakrenite ure&#x111;aj da snimate u pejza&#x17E;nom na&#x10D;inu rada.",
                  "ba-imageviewer-controlbar.rerecord-image": "Ponovi?",
                  "ba-imageviewer-controlbar.submit-image": "potvrditi",
                  "ba-imageviewer-controlbar.fullscreen-image": "Unesite puni zaslon",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Izlaz iz cijelog zaslona",
                  "ba-imageviewer.image-error": "Do&#x161;lo je do pogre&#x161;ke. Molimo poku&#x161;ajte ponovno kasnije. Kliknite za ponovni poku&#x161;aj.",
                  "ba-imagecapture-chooser.image-capture": "Snimite sliku",
                  "ba-imagecapture-chooser.upload-image": "U&#x10D;itaj sliku",
                  "ba-imagecapture-controlbar.settings": "postavke",
                  "ba-imagecapture-controlbar.camerahealthy": "Rasvjeta je dobra",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Rasvjeta nije optimalna",
                  "ba-imagecapture-controlbar.record": "Uhvatiti",
                  "ba-imagecapture-controlbar.record-tooltip": "Kliknite ovdje za snimanje.",
                  "ba-imagecapture-controlbar.rerecord": "preurediti",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Kliknite ovdje za ponavljanje.",
                  "ba-imagecapture-controlbar.cancel": "Otkazati",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Kliknite ovdje kako biste odustali.",
                  "ba-audioplayer-controlbar.audio-progress": "Napredak",
                  "ba-audioplayer-controlbar.rerecord-audio": "Ponovi?",
                  "ba-audioplayer-controlbar.submit-audio": "potvrditi",
                  "ba-audioplayer-controlbar.play-audio": "igra",
                  "ba-audioplayer-controlbar.pause-audio": "Pauza",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pauza nije podr&#x17E;ana",
                  "ba-audioplayer-controlbar.elapsed-time": "Proteklo vrijeme",
                  "ba-audioplayer-controlbar.total-time": "Ukupna duljina",
                  "ba-audioplayer-controlbar.volume-button": "Postavite glasno&#x107;u",
                  "ba-audioplayer-controlbar.volume-mute": "Isklju&#x10D;ite zvuk",
                  "ba-audioplayer-controlbar.volume-unmute": "Uklju&#x10D;i zvuk",
                  "ba-audioplayer-loader.tooltip": "U&#x10D;itavam...",
                  "ba-audioplayer.audio-error": "Do&#x161;lo je do pogre&#x161;ke. Molimo poku&#x161;ajte ponovno kasnije. Kliknite za ponovni poku&#x161;aj.",
                  "ba-audiorecorder-chooser.record-audio": "Snimanje zvuka",
                  "ba-audiorecorder-chooser.upload-audio": "Prijenos zvuka",
                  "ba-audiorecorder-controlbar.settings": "postavke",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Zvuk je dobar",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Ne mogu podi&#x107;i zvuk",
                  "ba-audiorecorder-controlbar.record": "Snimiti",
                  "ba-audiorecorder-controlbar.record-tooltip": "Kliknite ovdje za snimanje.",
                  "ba-audiorecorder-controlbar.rerecord": "preurediti",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Kliknite ovdje za ponavljanje.",
                  "ba-audiorecorder-controlbar.stop": "Stop",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Kliknite ovdje da biste prestali.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Minimalno vrijeme snimanja je %d sekundi",
                  "ba-audiorecorder-controlbar.cancel": "Otkazati",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Kliknite ovdje kako biste odustali.",
                  "ba-videoplayer-controlbar.player-speed": "Brzina igra&#x10D;a",
                  "ba-videoplayer-controlbar.settings": "postavke",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Ikona Airplay.",
                  "ba-videoplayer.all-settings": "Sve postavke",
                  "ba-videoplayer.player-speed": "Brzina igra&#x10D;a",
                  "ba-videoplayer.full-screen": "Puni zaslon",
                  "ba-videorecorder-controlbar.add-stream": "Dodaj tok",
                  "ba-videorecorder.switch-camera": "Promijenite kameru",
                  "ba-videorecorder.prepare-covershot": "Priprema snimke",
                  "ba-videorecorder.prepare-thumbnails": "Priprema za tra&#x17E;enje sli&#x10D;ica",
                  "ba-videorecorder.adding-new-stream": "Dodavanje novog toka",
                  "ba-imagecapture.recorder-error": "Do&#x161;lo je do pogre&#x161;ke. Molimo poku&#x161;ajte ponovno kasnije. Kliknite za ponovni poku&#x161;aj.",
                  "ba-imagecapture.attach-error": "Nismo mogli pristupiti su&#x10D;elju medija. Ovisno o ure&#x111;aju i pregledniku, mo&#x17E;da &#x107;ete morati instalirati Flash ili pristupiti stranici putem SSL-a.",
                  "ba-imagecapture.software-required": "Da biste nastavili, kliknite ispod kako biste instalirali / aktivirali sljede&#x107;e zahtjeve.",
                  "ba-imagecapture.software-waiting": "&#x10C;eka se instaliranje / aktiviranje zahtjeva. Mo&#x17E;da &#x107;ete morati osvje&#x17E;iti stranicu nakon dovr&#x161;etka.",
                  "ba-imagecapture.access-forbidden": "Pristup medijima bio je zabranjen. Kliknite za ponovni poku&#x161;aj.",
                  "ba-imagecapture.uploading": "Prijenos",
                  "ba-imagecapture.uploading-failed": "U&#x10D;itavanje nije uspjelo - kliknite ovdje za ponovni poku&#x161;aj.",
                  "ba-imagecapture.upload-error-duration": "Duljina prenesene slike ne ispunjava uvjete - kliknite ovdje za ponovni poku&#x161;aj.",
                  "ba-imagecapture.resolution-constraint-error": "Odabrana datoteka ne odgovara tra&#x17E;enoj razlu&#x10D;ivosti - kliknite ovdje za ponovni poku&#x161;aj.",
                  "ba-imagecapture.verifying": "Provjera",
                  "ba-imagecapture.verifying-failed": "Potvr&#x111;ivanje nije uspjelo - kliknite ovdje za ponovni poku&#x161;aj.",
                  "ba-imagecapture.rerecord-confirm": "&#x17D;elite li doista ponovno uzeti sliku?",
                  "ba-imagecapture.image_file_too_large": "Va&#x161;a je slikovna datoteka prevelika (%s) - kliknite ovdje da biste poku&#x161;ali ponovno s manjom slikovnom datotekom.",
                  "ba-imagecapture.unsupported_image_type": "Prenesite: %s - kliknite ovdje za ponovni poku&#x161;aj.",
                  "ba-imagecapture.orientation-portrait-required": "Okre&#x107;ite ure&#x111;aj da biste snimali u portretnom na&#x10D;inu.",
                  "ba-imagecapture.orientation-landscape-required": "Rotirajte ure&#x111;aj da biste snimali u pejza&#x17E;nom na&#x10D;inu.",
                  "ba-audiorecorder.recorder-error": "Do&#x161;lo je do pogre&#x161;ke. Molimo poku&#x161;ajte ponovno kasnije. Kliknite za ponovni poku&#x161;aj.",
                  "ba-audiorecorder.attach-error": "Nismo mogli pristupiti su&#x10D;elju medija. Ovisno o ure&#x111;aju i pregledniku, mo&#x17E;da &#x107;ete morati instalirati Flash ili pristupiti stranici putem SSL-a.",
                  "ba-audiorecorder.software-required": "Da biste nastavili, kliknite ispod kako biste instalirali / aktivirali sljede&#x107;e zahtjeve.",
                  "ba-audiorecorder.software-waiting": "&#x10C;eka se instaliranje / aktiviranje zahtjeva. Mo&#x17E;da &#x107;ete morati osvje&#x17E;iti stranicu nakon dovr&#x161;etka.",
                  "ba-audiorecorder.access-forbidden": "Pristup medijima bio je zabranjen. Kliknite za ponovni poku&#x161;aj.",
                  "ba-audiorecorder.uploading": "Prijenos",
                  "ba-audiorecorder.uploading-failed": "U&#x10D;itavanje nije uspjelo - kliknite ovdje za ponovni poku&#x161;aj.",
                  "ba-audiorecorder.upload-error-duration": "Duljina prenesenog zvuka ne zadovoljava zahtjeve - kliknite ovdje za ponovni poku&#x161;aj.",
                  "ba-audiorecorder.verifying": "Provjera",
                  "ba-audiorecorder.verifying-failed": "Potvr&#x111;ivanje nije uspjelo - kliknite ovdje za ponovni poku&#x161;aj.",
                  "ba-audiorecorder.rerecord-confirm": "&#x17D;elite li zaista ponoviti zvuk?",
                  "ba-audiorecorder.cancel-confirm": "&#x17D;elite li zaista otkazati prijenos zvuka?",
                  "ba-audiorecorder.audio_file_too_large": "Va&#x161;a je audio datoteka prevelika (%s) - kliknite ovdje da biste poku&#x161;ali ponovno s manjom audio datotekom.",
                  "ba-audiorecorder.unsupported_audio_type": "Prenesite: %s - kliknite ovdje za ponovni poku&#x161;aj.",
                  "ba-common-settingsmenu.tooltip": "Kliknite za reprodukciju.",
                  "ba-common-settingsmenu.setting-menu": "Sve postavke",
                  "ba-common-settingsmenu.source-quality": "Kvaliteta izvora",
                  "ba-common-settingsmenu.player-speed": "Brzina igra&#x10D;a",
                  "ba-common-settingsmenu.set-menu-option": "Postavite opciju",
                  "ba-common-settingsmenu.submit-video": "Potvrdite video",
                  "ba-common-settingsmenu.picture-in-picture": "Slika u slici",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Izlaz iz cijelog zaslona",
                  "ba-common-settingsmenu.fullscreen-video": "U&#x111;ite u cijeli zaslon",
                  "ba-videorecorder-chooser.multi-stream": "Vi&#x161;estruki tok",
                  "ba-videorecorder-controlbar.pause-recorder": "Pauzirajte snima&#x10D;",
                  "ba-videorecorder-controlbar.resume-recorder": "Snima&#x10D; &#x17E;ivotopisa",
                  "ba-videorecorder.missing-track": "Nedostaje potreban audio ili video zapis",
                  "ba-videorecorder.device-already-in-use": "Barem jedan od va&#x161;ih ulaznih ure&#x111;aja ve&#x107; se koristi",
                  "ba-videorecorder.browser-permission-denied": "Dozvola odbijena od strane preglednika, odobrite pristup i ponovno u&#x10D;itajte stranicu",
                  "ba-audioplayer.all-settings": "Sve postavke",
                  "ba-videoplayer-controlbar.remaining-time": "Preostalo vrijeme",
                  "ba-videoplayer-controlbar.select-frame": "Odaberi",
                  "ba-videoplayer-controlbar.trim-video": "Obre&#x17E;ite",
                  "ba-videoplayer-playbutton.trim": "Obre&#x17E;ite",
                  "ba-videoplayer-playbutton.skip": "Presko&#x10D;iti",
                  "ba-videorecorder-imagegallery.upload-covershot": "Prenesi naslovnicu",
                  "ba-videorecorder.pick-covershot-frame": "Odaberite okvir koji &#x107;ete koristiti kao snimku naslovnice.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Snima&#x10D; zaslona nije podr&#x17E;an na ovom ure&#x111;aju",
                  "ba-videorecorder.trim-prompt": "&#x17D;elite li obrezati svoj videozapis?",
                  "ba-videorecorder.trim-video": "Pomaknite oznake po&#x10D;etka i kraja da biste obrezali videozapis",
                  "ba-videorecorder.wait-for-trim": "&#x10C;eka se naredba trim ...",
                  "ba-videorecorder-controlbar.no-video-source": "Nedostaje dodatni video ulaz",
                  "ba-videorecorder-controlbar.stream-already-selected": "Dodatni tok ve&#x107; je odabran",
                  "ba-videorecorder.uploading-src-error": "Videozapis se sada ne mo&#x17E;e reproducirati, prijenos je jo&#x161; u tijeku",
                  "ba-audiorecorder-controlbar.pause-recorder": "Zaustavi snima&#x10D;",
                  "ba-audiorecorder-controlbar.resume-recorder": "Snima&#x10D; &#x17E;ivotopisa"
                },
                "language:hu": {
                  "ba-videoplayer-playbutton.tooltip": "Kattintson ide a vide&#xF3; lej&#xE1;tsz&#xE1;s&#xE1;hoz.",
                  "ba-videoplayer-playbutton.rerecord": "&#xDA;jra",
                  "ba-videoplayer-playbutton.submit-video": "Er&#x151;s&#xED;tse vide&#xF3;",
                  "ba-videoplayer-loader.tooltip": "Vide&#xF3; bet&#xF6;lt&#xE9;se ...",
                  "ba-videoplayer-controlbar.change-resolution": "a felbont&#xE1;s m&#xF3;dos&#xED;t&#xE1;sa",
                  "ba-videoplayer-controlbar.video-progress": "vide&#xF3; halad&#xE1;s",
                  "ba-videoplayer-controlbar.rerecord-video": "&#xDA;jra vide&#xF3;t?",
                  "ba-videoplayer-controlbar.submit-video": "Er&#x151;s&#xED;tse vide&#xF3;",
                  "ba-videoplayer-controlbar.play-video": "vide&#xF3; lej&#xE1;tsz&#xE1;sa",
                  "ba-videoplayer-controlbar.pause-video": "sz&#xFC;net vide&#xF3;",
                  "ba-videoplayer-controlbar.elapsed-time": "Eltelt id&#x151;",
                  "ba-videoplayer-controlbar.total-time": "Teljes hossza vide&#xF3;",
                  "ba-videoplayer-controlbar.fullscreen-video": "a teljes k&#xE9;perny&#x151;s",
                  "ba-videoplayer-controlbar.volume-button": "&#xC1;ll&#xED;tsa be a hanger&#x151;t",
                  "ba-videoplayer-controlbar.volume-mute": "hang eln&#xE9;m&#xED;t&#xE1;sa",
                  "ba-videoplayer-controlbar.volume-unmute": "Unmute hang",
                  "ba-videoplayer.video-error": "Hiba t&#xF6;rt&#xE9;nt. K&#xE9;rj&#xFC;k, pr&#xF3;b&#xE1;lkozzon k&#xE9;s&#x151;bb. Kattintson ide &#xFA;jra.",
                  "ba-videorecorder-chooser.record-video": "A vide&#xF3; r&#xF6;gz&#xED;t&#xE9;s&#xE9;nek",
                  "ba-videorecorder-chooser.upload-video": "Vide&#xF3; felt&#xF6;lt&#xE9;se",
                  "ba-videorecorder-controlbar.settings": "Be&#xE1;ll&#xED;t&#xE1;sok",
                  "ba-videorecorder-controlbar.camerahealthy": "Vil&#xE1;g&#xED;t&#xE1;s j&#xF3;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Vil&#xE1;g&#xED;t&#xE1;s nem optim&#xE1;lis",
                  "ba-videorecorder-controlbar.microphonehealthy": "Hang j&#xF3;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Nem lehet felvenni minden hang",
                  "ba-videorecorder-controlbar.record": "Rekord",
                  "ba-videorecorder-controlbar.record-tooltip": "Kattintson ide, hogy r&#xF6;gz&#xED;ti.",
                  "ba-videorecorder-controlbar.rerecord": "&#xDA;jra",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Kattintson ide, hogy &#xFA;jra.",
                  "ba-videorecorder-controlbar.upload-covershot": "Felt&#xF6;lt&#xE9;s",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Kattintson ide felt&#xF6;lthet&#x151; egyedi fed&#xE9;l l&#xF6;v&#xE9;s",
                  "ba-videorecorder-controlbar.stop": "&#xC1;llj meg",
                  "ba-videorecorder-controlbar.stop-tooltip": "Kattintson ide, hogy hagyja abba.",
                  "ba-videorecorder-controlbar.skip": "Skip",
                  "ba-videorecorder-controlbar.skip-tooltip": "Kattintson ide, hogy kihagyja.",
                  "ba-videorecorder.recorder-error": "Hiba t&#xF6;rt&#xE9;nt. K&#xE9;rj&#xFC;k, pr&#xF3;b&#xE1;lkozzon k&#xE9;s&#x151;bb. Kattintson ide &#xFA;jra.",
                  "ba-videorecorder.attach-error": "Nem tudtuk el&#xE9;rni a kamera interface. Att&#xF3;l f&#xFC;gg&#x151;en, hogy a k&#xE9;sz&#xFC;l&#xE9;k &#xE9;s a b&#xF6;ng&#xE9;sz&#x151;ben, akkor telep&#xED;tenie kell a Flash vagy el&#xE9;rni az oldalt SSL.",
                  "ba-videorecorder.access-forbidden": "Hozz&#xE1;f&#xE9;r&#xE9;s a kamera tilos volt. Kattintson ide &#xFA;jra.",
                  "ba-videorecorder.pick-covershot": "V&#xE1;lassz egy covershot.",
                  "ba-videorecorder.uploading": "Felt&#xF6;lt&#xE9;s",
                  "ba-videorecorder.uploading-failed": "Felt&#xF6;lt&#xE9;s sikertelen - ide kattintva &#xFA;jra.",
                  "ba-videorecorder.verifying": "ellen&#x151;rz&#xE9;se",
                  "ba-videorecorder.verifying-failed": "Ellen&#x151;rz&#xE9;s&#xE9;&#xE9;rt sikertelen - ide kattintva &#xFA;jra.",
                  "ba-videorecorder.rerecord-confirm": "T&#xE9;nyleg azt akarja ism&#xE9;telni a vide&#xF3;?",
                  "ba-videorecorder.video_file_too_large": "A vide&#xF3; f&#xE1;jl t&#xFA;l nagy (%s) - ide kattintva pr&#xF3;b&#xE1;lkozzon &#xFA;jra egy kisebb video f&#xE1;jlt.",
                  "ba-videorecorder.unsupported_video_type": "K&#xE9;rj&#xFC;k, t&#xF6;lts&#xF6;n fel: %s - ide kattintva &#xFA;jra.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Kil&#xE9;p&#xE9;s a teljes k&#xE9;perny&#x151;s",
                  "ba-videoplayer-share.share": "Vide&#xF3; megoszt&#xE1;sa",
                  "ba-videorecorder-chooser.record-screen": "Felv&#xE9;tel k&#xE9;perny&#x151;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "A sz&#xFC;neteltet&#xE9;s nem t&#xE1;mogatott",
                  "ba-videorecorder-chooser.record-audio": "Hang r&#xF6;gz&#xED;t&#xE9;se",
                  "ba-videorecorder-controlbar.stop-available-after": "A minim&#xE1;lis felv&#xE9;teli id&#x151; %d m&#xE1;sodperc",
                  "ba-videorecorder-controlbar.cancel": "Megsz&#xFC;nteti",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Kattintson ide a lemond&#xE1;shoz.",
                  "ba-videorecorder.cancel-confirm": "T&#xE9;nyleg t&#xF6;r&#xF6;lni szeretn&#xE9; a vide&#xF3; felt&#xF6;lt&#xE9;s&#xE9;t?",
                  "ba-videoplayer-adslot.elapsed-time": "Elkelt id&#x151;",
                  "ba-videoplayer-adslot.volume-button": "&#xC1;ll&#xED;tsa be a hanger&#x151;t",
                  "ba-videoplayer-adslot.volume-mute": "Eln&#xE9;m&#xED;tja a hangot",
                  "ba-videoplayer-adslot.volume-unmute": "Csengessen a hang",
                  "ba-videoplayer-adslot.ad-will-end-after": "A hirdet&#xE9;s a %s ut&#xE1;n befejez&#x151;dik",
                  "ba-videoplayer-adslot.can-skip-after": "Ugr&#xE1;s a %d ut&#xE1;n",
                  "ba-videoplayer-adslot.skip-ad": "Hirdet&#xE9;s &#xE1;tugr&#xE1;sa",
                  "ba-videorecorder.software-required": "K&#xE9;rj&#xFC;k, kattintson az al&#xE1;bbi gombra a k&#xF6;vetkez&#x151; k&#xF6;vetelm&#xE9;nyek telep&#xED;t&#xE9;s&#xE9;hez / aktiv&#xE1;l&#xE1;s&#xE1;hoz a folytat&#xE1;shoz.",
                  "ba-videorecorder.software-waiting": "V&#xE1;rakoz&#xE1;s a telep&#xED;t&#xE9;s / aktiv&#xE1;l&#xE1;s k&#xF6;vetelm&#xE9;nyeire. Lehet, hogy friss&#xED;tenie kell az oldalt befejez&#xE9;se ut&#xE1;n.",
                  "ba-videoplayer-controlbar.close-tracks": "K&#xF6;zeli CC",
                  "ba-videoplayer-controlbar.show-tracks": "CC mutat&#xE1;sa",
                  "ba-videoplayer-tracks.upload-text-tracks": "P&#xE1;lya sz&#xF6;veges f&#xE1;jlok felt&#xF6;lt&#xE9;se",
                  "ba-videoplayer-tracks.select-text-track-language": "Felirat nyelve",
                  "ba-videoplayer-tracks.info-select-locale-first": "El&#x151;sz&#xF6;r v&#xE1;lassza a helyi be&#xE1;ll&#xED;t&#xE1;st",
                  "ba-videoplayer-tracks.select-text-track-file": "Kattintson a f&#xE1;jl kiv&#xE1;laszt&#xE1;s&#xE1;hoz",
                  "ba-videoplayer-tracks.back": "h&#xE1;t",
                  "ba-videorecorder.framerate-warning": "A vide&#xF3; k&#xE9;par&#xE1;nya nagyon alacsony. Javasoljuk, hogy z&#xE1;rja be az &#xF6;sszes t&#xF6;bbi programot &#xE9;s b&#xF6;ng&#xE9;sz&#x151;lapot, vagy gyorsabb sz&#xE1;m&#xED;t&#xF3;g&#xE9;pet haszn&#xE1;ljon.",
                  "ba-videorecorder.upload-error-duration": "A felt&#xF6;lt&#xF6;tt vide&#xF3; hossza nem felel meg a k&#xF6;vetelm&#xE9;nyeknek - kattintson ide &#xFA;jrapr&#xF3;b&#xE1;lkoz&#xE1;shoz.",
                  "ba-videorecorder.resolution-constraint-error": "A kiv&#xE1;lasztott f&#xE1;jl nem egyezik meg a sz&#xFC;ks&#xE9;ges felbont&#xE1;ssal - kattintson ide &#xFA;jrapr&#xF3;b&#xE1;lkoz&#xE1;shoz.",
                  "ba-videorecorder.orientation-portrait-required": "Forgassa el a k&#xE9;sz&#xFC;l&#xE9;ket &#xE1;ll&#xF3;k&#xE9;p r&#xF6;gz&#xED;t&#xE9;s&#xE9;hez.",
                  "ba-videorecorder.orientation-landscape-required": "Forgassa el a k&#xE9;sz&#xFC;l&#xE9;ket fekv&#x151; m&#xF3;dban t&#xF6;rt&#xE9;n&#x151; r&#xF6;gz&#xED;t&#xE9;shez.",
                  "ba-imageviewer-controlbar.rerecord-image": "&#xDA;jra?",
                  "ba-imageviewer-controlbar.submit-image": "meger&#x151;s&#xED;t",
                  "ba-imageviewer-controlbar.fullscreen-image": "L&#xE9;pjen be a teljes k&#xE9;perny&#x151;re",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Kil&#xE9;p&#xE9;s a teljes k&#xE9;perny&#x151;r&#x151;l",
                  "ba-imageviewer.image-error": "Hiba t&#xF6;rt&#xE9;nt. K&#xE9;rj&#xFC;k, pr&#xF3;b&#xE1;lkozzon k&#xE9;s&#x151;bb. Kattintson &#xFA;jra az &#xFA;jrapr&#xF3;b&#xE1;l&#xE1;shoz.",
                  "ba-imagecapture-chooser.image-capture": "K&#xE9;p r&#xF6;gz&#xED;t&#xE9;se",
                  "ba-imagecapture-chooser.upload-image": "K&#xE9;p felt&#xF6;lt&#xE9;se",
                  "ba-imagecapture-controlbar.settings": "Be&#xE1;ll&#xED;t&#xE1;sok",
                  "ba-imagecapture-controlbar.camerahealthy": "A vil&#xE1;g&#xED;t&#xE1;s j&#xF3;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "A vil&#xE1;g&#xED;t&#xE1;s nem optim&#xE1;lis",
                  "ba-imagecapture-controlbar.record": "Elfog",
                  "ba-imagecapture-controlbar.record-tooltip": "Kattintson ide a r&#xF6;gz&#xED;t&#xE9;shez.",
                  "ba-imagecapture-controlbar.rerecord": "&#xDA;jra",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Kattintson ide &#xFA;jra.",
                  "ba-imagecapture-controlbar.cancel": "Megsz&#xFC;nteti",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Kattintson ide a lemond&#xE1;shoz.",
                  "ba-audioplayer-controlbar.audio-progress": "El&#x151;rehalad",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#xDA;jra?",
                  "ba-audioplayer-controlbar.submit-audio": "meger&#x151;s&#xED;t",
                  "ba-audioplayer-controlbar.play-audio": "J&#xE1;t&#xE9;k",
                  "ba-audioplayer-controlbar.pause-audio": "Sz&#xFC;net",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "A sz&#xFC;neteltet&#xE9;s nem t&#xE1;mogatott",
                  "ba-audioplayer-controlbar.elapsed-time": "Elkelt id&#x151;",
                  "ba-audioplayer-controlbar.total-time": "Teljes hossza",
                  "ba-audioplayer-controlbar.volume-button": "&#xC1;ll&#xED;tsa be a hanger&#x151;t",
                  "ba-audioplayer-controlbar.volume-mute": "Eln&#xE9;m&#xED;tja a hangot",
                  "ba-audioplayer-controlbar.volume-unmute": "Csengessen a hang",
                  "ba-audioplayer-loader.tooltip": "Bet&#xF6;lt&#xE9;s...",
                  "ba-audioplayer.audio-error": "Hiba t&#xF6;rt&#xE9;nt. K&#xE9;rj&#xFC;k, pr&#xF3;b&#xE1;lkozzon k&#xE9;s&#x151;bb. Kattintson &#xFA;jra az &#xFA;jrapr&#xF3;b&#xE1;l&#xE1;shoz.",
                  "ba-audiorecorder-chooser.record-audio": "Hang r&#xF6;gz&#xED;t&#xE9;se",
                  "ba-audiorecorder-chooser.upload-audio": "Hang felt&#xF6;lt&#xE9;se",
                  "ba-audiorecorder-controlbar.settings": "Be&#xE1;ll&#xED;t&#xE1;sok",
                  "ba-audiorecorder-controlbar.microphonehealthy": "A hang j&#xF3;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Nem hallhat&#xF3; hang",
                  "ba-audiorecorder-controlbar.record": "Rekord",
                  "ba-audiorecorder-controlbar.record-tooltip": "Kattintson ide a felv&#xE9;telhez.",
                  "ba-audiorecorder-controlbar.rerecord": "&#xDA;jra",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Kattintson ide &#xFA;jra.",
                  "ba-audiorecorder-controlbar.stop": "&#xC1;llj meg",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Kattintson ide a le&#xE1;ll&#xED;t&#xE1;shoz.",
                  "ba-audiorecorder-controlbar.stop-available-after": "A minim&#xE1;lis felv&#xE9;teli id&#x151; %d m&#xE1;sodperc",
                  "ba-audiorecorder-controlbar.cancel": "Megsz&#xFC;nteti",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Kattintson ide a lemond&#xE1;shoz.",
                  "ba-videoplayer-controlbar.player-speed": "J&#xE1;t&#xE9;kos sebess&#xE9;ge",
                  "ba-videoplayer-controlbar.settings": "Be&#xE1;ll&#xED;t&#xE1;sok",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay ikonra.",
                  "ba-videoplayer.all-settings": "Minden be&#xE1;ll&#xED;t&#xE1;s",
                  "ba-videoplayer.player-speed": "J&#xE1;t&#xE9;kos sebess&#xE9;ge",
                  "ba-videoplayer.full-screen": "Teljes k&#xE9;perny&#x151;",
                  "ba-videorecorder-controlbar.add-stream": "Adja hozz&#xE1; az adatfolyamot",
                  "ba-videorecorder.switch-camera": "Kapcsolja be a kamer&#xE1;t",
                  "ba-videorecorder.prepare-covershot": "Coverhots k&#xE9;sz&#xED;t&#xE9;se",
                  "ba-videorecorder.prepare-thumbnails": "A miniat&#x171;r&#xF6;k keres&#xE9;s&#xE9;nek el&#x151;k&#xE9;sz&#xED;t&#xE9;se",
                  "ba-videorecorder.adding-new-stream": "&#xDA;j adatfolyam hozz&#xE1;ad&#xE1;sa",
                  "ba-imagecapture.recorder-error": "Hiba t&#xF6;rt&#xE9;nt. Pr&#xF3;b&#xE1;lja &#xFA;jra k&#xE9;s&#x151;bb. Kattintson az &#xFA;jrapr&#xF3;b&#xE1;lkoz&#xE1;sra.",
                  "ba-imagecapture.attach-error": "Nem tudtuk el&#xE9;rni a m&#xE9;dia interf&#xE9;szt. Az eszk&#xF6;zt&#x151;l &#xE9;s a b&#xF6;ng&#xE9;sz&#x151;t&#x151;l f&#xFC;gg&#x151;en el&#x151;fordulhat, hogy telep&#xED;tenie kell a Flash-et vagy az SSL-en kereszt&#xFC;l az oldalt.",
                  "ba-imagecapture.software-required": "Az al&#xE1;bbi k&#xF6;vetelm&#xE9;nyek telep&#xED;t&#xE9;s&#xE9;hez / aktiv&#xE1;l&#xE1;s&#xE1;hoz kattintson az al&#xE1;bbi gombra.",
                  "ba-imagecapture.software-waiting": "V&#xE1;rakoz&#xE1;s a k&#xF6;vetelm&#xE9;nyek telep&#xED;t&#xE9;s&#xE9;re / aktiv&#xE1;l&#xE1;s&#xE1;ra. Lehet, hogy a befejez&#xE9;s ut&#xE1;n friss&#xED;tenie kell az oldalt.",
                  "ba-imagecapture.access-forbidden": "Tilos a m&#xE9;di&#xE1;hoz val&#xF3; hozz&#xE1;f&#xE9;r&#xE9;s. Kattintson az &#xFA;jrapr&#xF3;b&#xE1;lkoz&#xE1;sra.",
                  "ba-imagecapture.uploading": "Felt&#xF6;lt&#xE9;s",
                  "ba-imagecapture.uploading-failed": "A felt&#xF6;lt&#xE9;s sikertelen - kattintson ide, hogy &#xFA;jra pr&#xF3;b&#xE1;lkozzon.",
                  "ba-imagecapture.upload-error-duration": "A felt&#xF6;lt&#xF6;tt k&#xE9;p hossza nem felel meg a k&#xF6;vetelm&#xE9;nyeknek - kattintson ide az &#xFA;jrapr&#xF3;b&#xE1;lkoz&#xE1;shoz.",
                  "ba-imagecapture.resolution-constraint-error": "A kiv&#xE1;lasztott f&#xE1;jl nem egyezik meg a sz&#xFC;ks&#xE9;ges felbont&#xE1;ssal - kattintson ide, hogy &#xFA;jra pr&#xF3;b&#xE1;lkozzon.",
                  "ba-imagecapture.verifying": "ellen&#x151;rz&#xE9;se",
                  "ba-imagecapture.verifying-failed": "Sikertelen ellen&#x151;rz&#xE9;s - kattintson ide, hogy &#xFA;jra pr&#xF3;b&#xE1;lkozzon.",
                  "ba-imagecapture.rerecord-confirm": "T&#xE9;nyleg meg akarja ism&#xE9;telni a k&#xE9;pet?",
                  "ba-imagecapture.image_file_too_large": "A k&#xE9;pf&#xE1;jl t&#xFA;l nagy (%s) - kattintson ide, ha megpr&#xF3;b&#xE1;l egy kisebb k&#xE9;pf&#xE1;jl haszn&#xE1;lat&#xE1;val.",
                  "ba-imagecapture.unsupported_image_type": "K&#xE9;rj&#xFC;k, t&#xF6;ltse fel: %s - kattintson ide, hogy &#xFA;jra pr&#xF3;b&#xE1;lkozzon.",
                  "ba-imagecapture.orientation-portrait-required": "K&#xE9;rj&#xFC;k, forgassa el a k&#xE9;sz&#xFC;l&#xE9;ket, hogy portr&#xE9; m&#xF3;dban r&#xF6;gz&#xED;tse.",
                  "ba-imagecapture.orientation-landscape-required": "K&#xE9;rj&#xFC;k, forgassa el a k&#xE9;sz&#xFC;l&#xE9;ket, hogy t&#xE1;jol&#xE1;st k&#xE9;sz&#xED;tsen.",
                  "ba-audiorecorder.recorder-error": "Hiba t&#xF6;rt&#xE9;nt. Pr&#xF3;b&#xE1;lja &#xFA;jra k&#xE9;s&#x151;bb. Kattintson az &#xFA;jrapr&#xF3;b&#xE1;lkoz&#xE1;sra.",
                  "ba-audiorecorder.attach-error": "Nem tudtuk el&#xE9;rni a m&#xE9;dia interf&#xE9;szt. Az eszk&#xF6;zt&#x151;l &#xE9;s a b&#xF6;ng&#xE9;sz&#x151;t&#x151;l f&#xFC;gg&#x151;en el&#x151;fordulhat, hogy telep&#xED;tenie kell a Flash-et vagy az SSL-en kereszt&#xFC;l az oldalt.",
                  "ba-audiorecorder.software-required": "Az al&#xE1;bbi k&#xF6;vetelm&#xE9;nyek telep&#xED;t&#xE9;s&#xE9;hez / aktiv&#xE1;l&#xE1;s&#xE1;hoz kattintson az al&#xE1;bbi gombra.",
                  "ba-audiorecorder.software-waiting": "V&#xE1;rakoz&#xE1;s a k&#xF6;vetelm&#xE9;nyek telep&#xED;t&#xE9;s&#xE9;re / aktiv&#xE1;l&#xE1;s&#xE1;ra. Lehet, hogy a befejez&#xE9;s ut&#xE1;n friss&#xED;tenie kell az oldalt.",
                  "ba-audiorecorder.access-forbidden": "Tilos a m&#xE9;di&#xE1;hoz val&#xF3; hozz&#xE1;f&#xE9;r&#xE9;s. Kattintson az &#xFA;jrapr&#xF3;b&#xE1;lkoz&#xE1;sra.",
                  "ba-audiorecorder.uploading": "Felt&#xF6;lt&#xE9;s",
                  "ba-audiorecorder.uploading-failed": "A felt&#xF6;lt&#xE9;s sikertelen - kattintson ide, hogy &#xFA;jra pr&#xF3;b&#xE1;lkozzon.",
                  "ba-audiorecorder.upload-error-duration": "A felt&#xF6;lt&#xF6;tt hang hossza nem felel meg a k&#xF6;vetelm&#xE9;nyeknek - kattintson ide az &#xFA;jrapr&#xF3;b&#xE1;lkoz&#xE1;shoz.",
                  "ba-audiorecorder.verifying": "ellen&#x151;rz&#xE9;se",
                  "ba-audiorecorder.verifying-failed": "Sikertelen ellen&#x151;rz&#xE9;s - kattintson ide, hogy &#xFA;jra pr&#xF3;b&#xE1;lkozzon.",
                  "ba-audiorecorder.rerecord-confirm": "T&#xE9;nyleg meg szeretn&#xE9; &#xFA;j&#xED;tani a hangj&#xE1;t?",
                  "ba-audiorecorder.cancel-confirm": "T&#xE9;nyleg t&#xF6;r&#xF6;lni szeretn&#xE9; a hangfelv&#xE9;tel&#xE9;t?",
                  "ba-audiorecorder.audio_file_too_large": "A hangf&#xE1;jl t&#xFA;l nagy (%s) - kattints ide, ha megpr&#xF3;b&#xE1;lsz &#xFA;jra egy kisebb hangf&#xE1;jl seg&#xED;ts&#xE9;g&#xE9;vel.",
                  "ba-audiorecorder.unsupported_audio_type": "K&#xE9;rj&#xFC;k, t&#xF6;ltse fel: %s - kattintson ide, hogy &#xFA;jra pr&#xF3;b&#xE1;lkozzon.",
                  "ba-common-settingsmenu.tooltip": "Kattintson a j&#xE1;t&#xE9;k elkezd&#xE9;s&#xE9;hez.",
                  "ba-common-settingsmenu.setting-menu": "Minden be&#xE1;ll&#xED;t&#xE1;s",
                  "ba-common-settingsmenu.source-quality": "Forr&#xE1;s min&#x151;s&#xE9;ge",
                  "ba-common-settingsmenu.player-speed": "J&#xE1;t&#xE9;kos sebess&#xE9;ge",
                  "ba-common-settingsmenu.set-menu-option": "Be&#xE1;ll&#xED;t&#xE1;s opci&#xF3;",
                  "ba-common-settingsmenu.submit-video": "Vide&#xF3; meger&#x151;s&#xED;t&#xE9;se",
                  "ba-common-settingsmenu.picture-in-picture": "K&#xE9;p a k&#xE9;pen",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Kil&#xE9;p&#xE9;s a teljes k&#xE9;perny&#x151;s k&#xE9;perny&#x151;r&#x151;l",
                  "ba-common-settingsmenu.fullscreen-video": "L&#xE9;pjen be teljes k&#xE9;perny&#x151;sre",
                  "ba-videorecorder-chooser.multi-stream": "T&#xF6;bb adatfolyam",
                  "ba-videorecorder-controlbar.pause-recorder": "A felvev&#x151; sz&#xFC;neteltet&#xE9;se",
                  "ba-videorecorder-controlbar.resume-recorder": "Felv&#xE9;tel folytat&#xE1;sa",
                  "ba-videorecorder.missing-track": "Hi&#xE1;nyzik a sz&#xFC;ks&#xE9;ges audio vagy video s&#xE1;v",
                  "ba-videorecorder.device-already-in-use": "Legal&#xE1;bb az egyik beviteli eszk&#xF6;z m&#xE1;r haszn&#xE1;latban van",
                  "ba-videorecorder.browser-permission-denied": "Az enged&#xE9;lyt a b&#xF6;ng&#xE9;sz&#x151; megtagadta. K&#xE9;rj&#xFC;k, adjon hozz&#xE1;f&#xE9;r&#xE9;st &#xE9;s t&#xF6;ltse be &#xFA;jra az oldalt",
                  "ba-audioplayer.all-settings": "Minden be&#xE1;ll&#xED;t&#xE1;s",
                  "ba-videoplayer-controlbar.remaining-time": "H&#xE1;tral&#xE9;v&#x151; id&#x151;",
                  "ba-videoplayer-controlbar.select-frame": "V&#xE1;lassza a lehet&#x151;s&#xE9;get",
                  "ba-videoplayer-controlbar.trim-video": "V&#xE1;g&#xE1;s",
                  "ba-videoplayer-playbutton.trim": "V&#xE1;g&#xE1;s",
                  "ba-videoplayer-playbutton.skip": "Ugr&#xE1;s",
                  "ba-videorecorder-imagegallery.upload-covershot": "Bor&#xED;t&#xF3; felt&#xF6;lt&#xE9;se",
                  "ba-videorecorder.pick-covershot-frame": "V&#xE1;lasszon ki egy k&#xE9;pet, amelyet fed&#x151;k&#xE9;pk&#xE9;nt haszn&#xE1;lni szeretne.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Ez a k&#xE9;sz&#xFC;l&#xE9;k nem t&#xE1;mogatja a k&#xE9;perny&#x151;felvev&#x151;t",
                  "ba-videorecorder.trim-prompt": "Le akarja v&#xE1;gni a vide&#xF3;dat?",
                  "ba-videorecorder.trim-video": "Mozgassa a kezd&#x151; &#xE9;s a befejez&#x151; jelz&#x151;t a vide&#xF3; v&#xE1;g&#xE1;s&#xE1;hoz",
                  "ba-videorecorder.wait-for-trim": "V&#xE1;rakoz&#xE1;s a trim parancsra ...",
                  "ba-videorecorder-controlbar.no-video-source": "Hi&#xE1;nyzik a tov&#xE1;bbi vide&#xF3; bemeneti forr&#xE1;s",
                  "ba-videorecorder-controlbar.stream-already-selected": "Tov&#xE1;bbi adatfolyam m&#xE1;r kiv&#xE1;lasztva",
                  "ba-videorecorder.uploading-src-error": "A vide&#xF3;t most nem lehet lej&#xE1;tszani, a felt&#xF6;lt&#xE9;s m&#xE9;g folyamatban van",
                  "ba-audiorecorder-controlbar.pause-recorder": "Sz&#xFC;neteltesse a felvev&#x151;t",
                  "ba-audiorecorder-controlbar.resume-recorder": "Felv&#xE9;tel folytat&#xE1;sa"
                },
                "language:id": {
                  "ba-videoplayer-playbutton.tooltip": "Klik untuk memutar video.",
                  "ba-videoplayer-playbutton.rerecord": "Mengulangi",
                  "ba-videoplayer-playbutton.submit-video": "Konfirmasi video",
                  "ba-videoplayer-loader.tooltip": "Memuat video ...",
                  "ba-videoplayer-controlbar.change-resolution": "Ubah resolusi",
                  "ba-videoplayer-controlbar.video-progress": "Kemajuan video",
                  "ba-videoplayer-controlbar.rerecord-video": "Redo video?",
                  "ba-videoplayer-controlbar.submit-video": "Konfirmasi video",
                  "ba-videoplayer-controlbar.play-video": "Putar video",
                  "ba-videoplayer-controlbar.pause-video": "Jeda video",
                  "ba-videoplayer-controlbar.elapsed-time": "Waktu berlalu",
                  "ba-videoplayer-controlbar.total-time": "Panjang video total",
                  "ba-videoplayer-controlbar.fullscreen-video": "Memasuki layar penuh",
                  "ba-videoplayer-controlbar.volume-button": "Setel volume",
                  "ba-videoplayer-controlbar.volume-mute": "Bisu terdengar",
                  "ba-videoplayer-controlbar.volume-unmute": "Suarakan suara",
                  "ba-videoplayer.video-error": "Terjadi kesalahan, coba lagi nanti. Klik untuk mencoba lagi.",
                  "ba-videorecorder-chooser.record-video": "Merekam video",
                  "ba-videorecorder-chooser.upload-video": "Upload Video",
                  "ba-videorecorder-controlbar.settings": "Pengaturan",
                  "ba-videorecorder-controlbar.camerahealthy": "Pencahayaan itu bagus",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Pencahayaan tidak optimal",
                  "ba-videorecorder-controlbar.microphonehealthy": "Suara bagus",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Tidak bisa mengambil suara apapun",
                  "ba-videorecorder-controlbar.record": "Merekam",
                  "ba-videorecorder-controlbar.record-tooltip": "Klik di sini untuk merekam.",
                  "ba-videorecorder-controlbar.rerecord": "Mengulangi",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Klik di sini untuk mengulang.",
                  "ba-videorecorder-controlbar.upload-covershot": "Upload",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Klik di sini untuk mengunggah tangkapan sampul khusus",
                  "ba-videorecorder-controlbar.stop": "Berhenti",
                  "ba-videorecorder-controlbar.stop-tooltip": "Klik di sini untuk berhenti.",
                  "ba-videorecorder-controlbar.skip": "Melewatkan",
                  "ba-videorecorder-controlbar.skip-tooltip": "Klik di sini untuk melompat.",
                  "ba-videorecorder.recorder-error": "Terjadi kesalahan, coba lagi nanti. Klik untuk mencoba lagi.",
                  "ba-videorecorder.attach-error": "Kami tidak dapat mengakses antarmuka kamera. Bergantung pada perangkat dan browser, Anda mungkin perlu menginstal Flash atau mengakses halaman melalui SSL.",
                  "ba-videorecorder.access-forbidden": "Akses ke kamera dilarang. Klik untuk mencoba lagi.",
                  "ba-videorecorder.pick-covershot": "Pilih sebuah coverhot.",
                  "ba-videorecorder.uploading": "Mengunggah",
                  "ba-videorecorder.uploading-failed": "Mengunggah gagal - klik di sini untuk mencoba lagi.",
                  "ba-videorecorder.verifying": "Memverifikasi",
                  "ba-videorecorder.verifying-failed": "Verifikasi gagal - klik di sini untuk mencoba lagi.",
                  "ba-videorecorder.rerecord-confirm": "Apakah Anda benar-benar ingin mengulang video Anda?",
                  "ba-videorecorder.video_file_too_large": "File video Anda terlalu besar (%s) - klik di sini untuk mencoba lagi dengan file video yang lebih kecil.",
                  "ba-videorecorder.unsupported_video_type": "Silakan upload: %s - klik di sini untuk mencoba lagi.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Keluar dari layar penuh",
                  "ba-videoplayer-share.share": "Berbagi video",
                  "ba-videorecorder-chooser.record-screen": "Layar rekam",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Jeda tidak didukung",
                  "ba-videorecorder-chooser.record-audio": "Suara rekaman",
                  "ba-videorecorder-controlbar.stop-available-after": "Waktu perekaman minimum adalah %d detik",
                  "ba-videorecorder-controlbar.cancel": "Membatalkan",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Klik disini untuk membatalkan",
                  "ba-videorecorder.cancel-confirm": "Apakah Anda benar-benar ingin membatalkan upload video Anda?",
                  "ba-videoplayer-adslot.elapsed-time": "Waktu berlalu",
                  "ba-videoplayer-adslot.volume-button": "Setel volume",
                  "ba-videoplayer-adslot.volume-mute": "Bisu terdengar",
                  "ba-videoplayer-adslot.volume-unmute": "Suarakan suara",
                  "ba-videoplayer-adslot.ad-will-end-after": "Iklan akan berakhir setelah %s",
                  "ba-videoplayer-adslot.can-skip-after": "Lewati setelah %d",
                  "ba-videoplayer-adslot.skip-ad": "Melewatkan iklan",
                  "ba-videorecorder.software-required": "Silahkan klik di bawah ini untuk menginstal / mengaktifkan persyaratan berikut agar bisa melanjutkan.",
                  "ba-videorecorder.software-waiting": "Menunggu persyaratan untuk dipasang / diaktifkan. Anda mungkin perlu menyegarkan halaman setelah selesai.",
                  "ba-videoplayer-controlbar.close-tracks": "Tutup CC",
                  "ba-videoplayer-controlbar.show-tracks": "Tampilkan CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Unggah file teks lagu",
                  "ba-videoplayer-tracks.select-text-track-language": "Bahasa Subtitle",
                  "ba-videoplayer-tracks.info-select-locale-first": "Pertama pilih lokal",
                  "ba-videoplayer-tracks.select-text-track-file": "Klik untuk memilih file",
                  "ba-videoplayer-tracks.back": "kembali",
                  "ba-videorecorder.framerate-warning": "Kecepatan frame video sangat rendah. Kami sarankan untuk menutup semua program lain dan tab browser atau menggunakan komputer yang lebih cepat.",
                  "ba-videorecorder.upload-error-duration": "Panjang video yang diunggah tidak memenuhi persyaratan - klik di sini untuk mencoba lagi.",
                  "ba-videorecorder.resolution-constraint-error": "File yang Anda pilih tidak sesuai dengan resolusi yang diperlukan - klik di sini untuk mencoba lagi.",
                  "ba-videorecorder.orientation-portrait-required": "Silakan putar perangkat Anda untuk merekam dalam mode potret.",
                  "ba-videorecorder.orientation-landscape-required": "Silakan putar perangkat Anda untuk merekam dalam mode lansekap.",
                  "ba-imageviewer-controlbar.rerecord-image": "Mengulangi?",
                  "ba-imageviewer-controlbar.submit-image": "Memastikan",
                  "ba-imageviewer-controlbar.fullscreen-image": "Memasuki layar penuh",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Keluar dari layar penuh",
                  "ba-imageviewer.image-error": "Terjadi kesalahan, coba lagi nanti. Klik untuk mencoba lagi.",
                  "ba-imagecapture-chooser.image-capture": "Capture Image",
                  "ba-imagecapture-chooser.upload-image": "Unggah Gambar",
                  "ba-imagecapture-controlbar.settings": "Pengaturan",
                  "ba-imagecapture-controlbar.camerahealthy": "Pencahayaan bagus",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Pencahayaan tidak optimal",
                  "ba-imagecapture-controlbar.record": "Menangkap",
                  "ba-imagecapture-controlbar.record-tooltip": "Klik di sini untuk menangkap.",
                  "ba-imagecapture-controlbar.rerecord": "Mengulangi",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Klik di sini untuk mengulang.",
                  "ba-imagecapture-controlbar.cancel": "Membatalkan",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Klik di sini untuk membatalkan.",
                  "ba-audioplayer-controlbar.audio-progress": "Kemajuan",
                  "ba-audioplayer-controlbar.rerecord-audio": "Mengulangi?",
                  "ba-audioplayer-controlbar.submit-audio": "Memastikan",
                  "ba-audioplayer-controlbar.play-audio": "Bermain",
                  "ba-audioplayer-controlbar.pause-audio": "Berhenti sebentar",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Jeda tidak didukung",
                  "ba-audioplayer-controlbar.elapsed-time": "Waktu berlalu",
                  "ba-audioplayer-controlbar.total-time": "Panjang total",
                  "ba-audioplayer-controlbar.volume-button": "Setel volume",
                  "ba-audioplayer-controlbar.volume-mute": "Bungkam suara",
                  "ba-audioplayer-controlbar.volume-unmute": "Bunyikan suara",
                  "ba-audioplayer-loader.tooltip": "Pemuatan...",
                  "ba-audioplayer.audio-error": "Terjadi kesalahan, coba lagi nanti. Klik untuk mencoba lagi.",
                  "ba-audiorecorder-chooser.record-audio": "Suara rekaman",
                  "ba-audiorecorder-chooser.upload-audio": "Unggah Audio",
                  "ba-audiorecorder-controlbar.settings": "Pengaturan",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Suara itu bagus",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Tidak dapat mengambil suara apa pun",
                  "ba-audiorecorder-controlbar.record": "Merekam",
                  "ba-audiorecorder-controlbar.record-tooltip": "Klik di sini untuk merekam.",
                  "ba-audiorecorder-controlbar.rerecord": "Mengulangi",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Klik di sini untuk mengulang.",
                  "ba-audiorecorder-controlbar.stop": "Berhenti",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Klik di sini untuk berhenti.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Waktu perekaman minimum adalah %d detik",
                  "ba-audiorecorder-controlbar.cancel": "Membatalkan",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Klik di sini untuk membatalkan.",
                  "ba-videoplayer-controlbar.player-speed": "Kecepatan pemain",
                  "ba-videoplayer-controlbar.settings": "Pengaturan",
                  "ba-videoplayer-controlbar.airplay": "Diputar",
                  "ba-videoplayer-controlbar.airplay-icon": "Ikon Airplay.",
                  "ba-videoplayer.all-settings": "Semua pengaturan",
                  "ba-videoplayer.player-speed": "Kecepatan pemain",
                  "ba-videoplayer.full-screen": "Layar penuh",
                  "ba-videorecorder-controlbar.add-stream": "Tambahkan Stream",
                  "ba-videorecorder.switch-camera": "Ganti kamera",
                  "ba-videorecorder.prepare-covershot": "Mempersiapkan tangkapan layar",
                  "ba-videorecorder.prepare-thumbnails": "Mempersiapkan thumbnail pencarian",
                  "ba-videorecorder.adding-new-stream": "Menambahkan Stream Baru",
                  "ba-imagecapture.recorder-error": "Terjadi kesalahan, coba lagi nanti. Klik untuk mencoba lagi.",
                  "ba-imagecapture.attach-error": "Kami tidak dapat mengakses antarmuka media. Bergantung pada perangkat dan browser, Anda mungkin perlu menginstal Flash atau mengakses halaman melalui SSL.",
                  "ba-imagecapture.software-required": "Silakan klik di bawah ini untuk menginstal / mengaktifkan persyaratan berikut untuk melanjutkan.",
                  "ba-imagecapture.software-waiting": "Menunggu persyaratan untuk diinstal / diaktifkan. Anda mungkin perlu menyegarkan halaman setelah selesai.",
                  "ba-imagecapture.access-forbidden": "Akses ke media dilarang. Klik untuk mencoba lagi.",
                  "ba-imagecapture.uploading": "Mengunggah",
                  "ba-imagecapture.uploading-failed": "Gagal mengunggah - klik di sini untuk mencoba lagi.",
                  "ba-imagecapture.upload-error-duration": "Panjang gambar yang diunggah tidak memenuhi persyaratan - klik di sini untuk mencoba lagi.",
                  "ba-imagecapture.resolution-constraint-error": "File yang Anda pilih tidak cocok dengan resolusi yang diperlukan - klik di sini untuk mencoba lagi.",
                  "ba-imagecapture.verifying": "Memverifikasi",
                  "ba-imagecapture.verifying-failed": "Verifikasi gagal - klik di sini untuk mencoba lagi.",
                  "ba-imagecapture.rerecord-confirm": "Apakah Anda benar-benar ingin mengambil kembali gambar Anda?",
                  "ba-imagecapture.image_file_too_large": "File gambar Anda terlalu besar (%s) - klik di sini untuk mencoba lagi dengan file gambar yang lebih kecil.",
                  "ba-imagecapture.unsupported_image_type": "Harap unggah: %s - klik di sini untuk mencoba lagi.",
                  "ba-imagecapture.orientation-portrait-required": "Harap putar perangkat Anda untuk merekam dalam mode potret.",
                  "ba-imagecapture.orientation-landscape-required": "Harap putar perangkat Anda untuk merekam dalam mode lansekap.",
                  "ba-audiorecorder.recorder-error": "Terjadi kesalahan, coba lagi nanti. Klik untuk mencoba lagi.",
                  "ba-audiorecorder.attach-error": "Kami tidak dapat mengakses antarmuka media. Bergantung pada perangkat dan browser, Anda mungkin perlu menginstal Flash atau mengakses halaman melalui SSL.",
                  "ba-audiorecorder.software-required": "Silakan klik di bawah ini untuk menginstal / mengaktifkan persyaratan berikut untuk melanjutkan.",
                  "ba-audiorecorder.software-waiting": "Menunggu persyaratan untuk diinstal / diaktifkan. Anda mungkin perlu menyegarkan halaman setelah selesai.",
                  "ba-audiorecorder.access-forbidden": "Akses ke media dilarang. Klik untuk mencoba lagi.",
                  "ba-audiorecorder.uploading": "Mengunggah",
                  "ba-audiorecorder.uploading-failed": "Gagal mengunggah - klik di sini untuk mencoba lagi.",
                  "ba-audiorecorder.upload-error-duration": "Panjang audio yang diunggah tidak memenuhi persyaratan - klik di sini untuk mencoba lagi.",
                  "ba-audiorecorder.verifying": "Memverifikasi",
                  "ba-audiorecorder.verifying-failed": "Verifikasi gagal - klik di sini untuk mencoba lagi.",
                  "ba-audiorecorder.rerecord-confirm": "Apakah Anda benar-benar ingin mengulang audio Anda?",
                  "ba-audiorecorder.cancel-confirm": "Apakah Anda benar-benar ingin membatalkan upload audio Anda?",
                  "ba-audiorecorder.audio_file_too_large": "File audio Anda terlalu besar (%s) - klik di sini untuk mencoba lagi dengan file audio yang lebih kecil.",
                  "ba-audiorecorder.unsupported_audio_type": "Harap unggah: %s - klik di sini untuk mencoba lagi.",
                  "ba-common-settingsmenu.tooltip": "Klik untuk main.",
                  "ba-common-settingsmenu.setting-menu": "Semua pengaturan",
                  "ba-common-settingsmenu.source-quality": "Kualitas sumber",
                  "ba-common-settingsmenu.player-speed": "Kecepatan pemain",
                  "ba-common-settingsmenu.set-menu-option": "Atur opsi",
                  "ba-common-settingsmenu.submit-video": "Konfirmasikan video",
                  "ba-common-settingsmenu.picture-in-picture": "Gambar di dalam gambar",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Keluar dari layar penuh",
                  "ba-common-settingsmenu.fullscreen-video": "Memasuki layar penuh",
                  "ba-videorecorder-chooser.multi-stream": "Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Jeda Perekam",
                  "ba-videorecorder-controlbar.resume-recorder": "Lanjutkan Perekam",
                  "ba-videorecorder.missing-track": "Trek audio atau video yang diperlukan tidak ada",
                  "ba-videorecorder.device-already-in-use": "Setidaknya satu dari perangkat input Anda sudah digunakan",
                  "ba-videorecorder.browser-permission-denied": "Izin ditolak oleh browser, berikan akses dan muat ulang halaman",
                  "ba-audioplayer.all-settings": "Semua pengaturan",
                  "ba-videoplayer-controlbar.remaining-time": "Waktu yang tersisa",
                  "ba-videoplayer-controlbar.select-frame": "Pilih",
                  "ba-videoplayer-controlbar.trim-video": "Memangkas",
                  "ba-videoplayer-playbutton.trim": "Memangkas",
                  "ba-videoplayer-playbutton.skip": "Melewatkan",
                  "ba-videorecorder-imagegallery.upload-covershot": "Unggah Sampul",
                  "ba-videorecorder.pick-covershot-frame": "Pilih bingkai untuk digunakan sebagai foto sampul.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Perekam layar tidak didukung pada perangkat ini",
                  "ba-videorecorder.trim-prompt": "Apakah Anda ingin memangkas video Anda?",
                  "ba-videorecorder.trim-video": "Pindahkan penanda awal dan akhir untuk memangkas video Anda",
                  "ba-videorecorder.wait-for-trim": "Menunggu perintah trim...",
                  "ba-videorecorder-controlbar.no-video-source": "Tidak ada sumber input video tambahan",
                  "ba-videorecorder-controlbar.stream-already-selected": "Aliran tambahan telah dipilih",
                  "ba-videorecorder.uploading-src-error": "Tidak dapat memutar video sekarang, pengunggahan masih berlangsung",
                  "ba-audiorecorder-controlbar.pause-recorder": "Jeda Perekam",
                  "ba-audiorecorder-controlbar.resume-recorder": "Perekam Lanjutkan"
                },
                "language:it": {
                  "ba-videoplayer-playbutton.tooltip": "Clicca per riprodurre il video.",
                  "ba-videoplayer-playbutton.rerecord": "Riprova",
                  "ba-videoplayer-playbutton.submit-video": "Conferma il video",
                  "ba-videoplayer-loader.tooltip": "Caricamento video...",
                  "ba-videoplayer-controlbar.change-resolution": "Cambia la risoluzione",
                  "ba-videoplayer-controlbar.video-progress": "Progresso video",
                  "ba-videoplayer-controlbar.rerecord-video": "Riprova?",
                  "ba-videoplayer-controlbar.submit-video": "Conferma il video",
                  "ba-videoplayer-controlbar.play-video": "Guarda il video",
                  "ba-videoplayer-controlbar.pause-video": "Pausa",
                  "ba-videoplayer-controlbar.elapsed-time": "Tempo trascorso",
                  "ba-videoplayer-controlbar.total-time": "Lunghezza totale del video",
                  "ba-videoplayer-controlbar.fullscreen-video": "Entra a schermo intero",
                  "ba-videoplayer-controlbar.volume-button": "Imposta il volume",
                  "ba-videoplayer-controlbar.volume-mute": "Muta l&#x27;audio",
                  "ba-videoplayer-controlbar.volume-unmute": "Riattiva l&#x27;audio",
                  "ba-videoplayer.video-error": "Si &#xE8; verificato un errore, riprova pi&#xF9; tardi. Fai clic per riprovare.",
                  "ba-videorecorder-chooser.record-video": "Registra video",
                  "ba-videorecorder-chooser.upload-video": "Carica video",
                  "ba-videorecorder-controlbar.settings": "Impostazioni",
                  "ba-videorecorder-controlbar.camerahealthy": "L&#x27;illuminazione &#xE8; buona",
                  "ba-videorecorder-controlbar.cameraunhealthy": "L&#x27;illuminazione non &#xE8; ottimale",
                  "ba-videorecorder-controlbar.microphonehealthy": "Il suono &#xE8; buono",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Non riesco a sentire alcun suono",
                  "ba-videorecorder-controlbar.record": "Registra",
                  "ba-videorecorder-controlbar.record-tooltip": "Clicca qui per registrare.",
                  "ba-videorecorder-controlbar.rerecord": "Riprova",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Clicca qui per riprovare.",
                  "ba-videorecorder-controlbar.upload-covershot": "Carica foto di copertina",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Clicca qui per caricare una foto di copertina personalizzata",
                  "ba-videorecorder-controlbar.stop": "Stop",
                  "ba-videorecorder-controlbar.stop-tooltip": "Clicca qui per fermare.",
                  "ba-videorecorder-controlbar.skip": "Salta",
                  "ba-videorecorder-controlbar.skip-tooltip": "Clicca qui per saltare.",
                  "ba-videorecorder.recorder-error": "Si &#xE8; verificato un errore, riprova pi&#xF9; tardi. Fare clic per riprovare.",
                  "ba-videorecorder.attach-error": "Non siamo riusciti ad accedere all&#x27;interfaccia multimediale. A seconda del dispositivo e del browser, potrebbe essere necessario installare Flash o accedere alla pagina tramite SSL.",
                  "ba-videorecorder.access-forbidden": "L&#x27;accesso alla camera era proibito. Fare clic per riprovare.",
                  "ba-videorecorder.pick-covershot": "Scegli una foto di copertina.",
                  "ba-videorecorder.uploading": "Caricamento",
                  "ba-videorecorder.uploading-failed": "Caricamento fallito - clicca qui per riprovare.",
                  "ba-videorecorder.verifying": "Verifica",
                  "ba-videorecorder.verifying-failed": "Verifica non riuscita - clicca qui per riprovare.",
                  "ba-videorecorder.rerecord-confirm": "Vuoi davvero rifare il video?",
                  "ba-videorecorder.video_file_too_large": "Il file video &#xE8; troppo grande (%s) - clicca qui per provare di nuovo con un file video pi&#xF9; piccolo.",
                  "ba-videorecorder.unsupported_video_type": "Per favore carica: %s - clicca qui per riprovare.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Esci dalla modalit&#xE0; a schermo intero",
                  "ba-videoplayer-share.share": "Condividi il video",
                  "ba-videorecorder-chooser.record-screen": "Registra schermo",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pausa non supportata",
                  "ba-videorecorder-chooser.record-audio": "Registra audio",
                  "ba-videorecorder-controlbar.stop-available-after": "Il tempo di registrazione minimo &#xE8; %d secondi",
                  "ba-videorecorder-controlbar.cancel": "Annulla",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Clicca qui per annullare.",
                  "ba-videorecorder.cancel-confirm": "Vuoi veramente annullare il tuo caricamento video?",
                  "ba-videoplayer-adslot.elapsed-time": "Tempo trascorso",
                  "ba-videoplayer-adslot.volume-button": "Imposta il volume",
                  "ba-videoplayer-adslot.volume-mute": "Muta l&#x27;audio",
                  "ba-videoplayer-adslot.volume-unmute": "Riattiva l&#x27;audio",
                  "ba-videoplayer-adslot.ad-will-end-after": "L&#x27;annuncio terminer&#xE0; dopo %s",
                  "ba-videoplayer-adslot.can-skip-after": "Salta dopo %d",
                  "ba-videoplayer-adslot.skip-ad": "Salta annuncio",
                  "ba-videorecorder.software-required": "Clicca qui sotto per installare / attivare i seguenti requisiti per procedere.",
                  "ba-videorecorder.software-waiting": "Aspettando che i requisiti siano installati / attivati. Potrebbe essere necessario aggiornare la pagina dopo il completamento.",
                  "ba-videoplayer-controlbar.close-tracks": "Chiudi sottotitoli",
                  "ba-videoplayer-controlbar.show-tracks": "Mostra sottotitoli",
                  "ba-videoplayer-tracks.upload-text-tracks": "Carica file sottotitoli",
                  "ba-videoplayer-tracks.select-text-track-language": "Lingua sottotitoli",
                  "ba-videoplayer-tracks.info-select-locale-first": "Prima seleziona la lingua",
                  "ba-videoplayer-tracks.select-text-track-file": "Clicca per selezionare il file",
                  "ba-videoplayer-tracks.back": "indietro",
                  "ba-videorecorder.framerate-warning": "Il frame rate video &#xE8; molto basso. Ti consigliamo di chiudere tutti gli altri programmi e le schede del browser o di utilizzare un computer pi&#xF9; veloce.",
                  "ba-videorecorder.upload-error-duration": "La lunghezza del video caricato non soddisfa i requisiti: fai clic qui per riprovare.",
                  "ba-videorecorder.resolution-constraint-error": "Il file che hai selezionato non corrisponde alla risoluzione richiesta: fai clic qui per riprovare.",
                  "ba-videorecorder.orientation-portrait-required": "Si prega di ruotare il dispositivo per registrare in modalit&#xE0; verticale.",
                  "ba-videorecorder.orientation-landscape-required": "Si prega di ruotare il dispositivo per registrare in modalit&#xE0; orizzontale.",
                  "ba-imageviewer-controlbar.rerecord-image": "Riprova?",
                  "ba-imageviewer-controlbar.submit-image": "Conferma",
                  "ba-imageviewer-controlbar.fullscreen-image": "Entra a schermo intero",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Esci dalla modalit&#xE0; a schermo intero",
                  "ba-imageviewer.image-error": "Si &#xE8; verificato un errore, riprova pi&#xF9; tardi. Clicca per riprovare.",
                  "ba-imagecapture-chooser.image-capture": "Cattura immagine",
                  "ba-imagecapture-chooser.upload-image": "Carica immagine",
                  "ba-imagecapture-controlbar.settings": "Impostazioni",
                  "ba-imagecapture-controlbar.camerahealthy": "L&#x27;illuminazione &#xE8; buona",
                  "ba-imagecapture-controlbar.cameraunhealthy": "L&#x27;illuminazione non &#xE8; ottimale",
                  "ba-imagecapture-controlbar.record": "Cattura",
                  "ba-imagecapture-controlbar.record-tooltip": "Clicca qui per catturare.",
                  "ba-imagecapture-controlbar.rerecord": "Riprova",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Clicca qui per riprovare.",
                  "ba-imagecapture-controlbar.cancel": "Annulla",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Clicca qui per annullare.",
                  "ba-audioplayer-controlbar.audio-progress": "Progresso",
                  "ba-audioplayer-controlbar.rerecord-audio": "Riprova?",
                  "ba-audioplayer-controlbar.submit-audio": "Conferma",
                  "ba-audioplayer-controlbar.play-audio": "Riproduci",
                  "ba-audioplayer-controlbar.pause-audio": "Pausa",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pausa non supportata",
                  "ba-audioplayer-controlbar.elapsed-time": "Tempo trascorso",
                  "ba-audioplayer-controlbar.total-time": "Lunghezza totale di",
                  "ba-audioplayer-controlbar.volume-button": "Imposta il volume",
                  "ba-audioplayer-controlbar.volume-mute": "Muta l&#x27;audio",
                  "ba-audioplayer-controlbar.volume-unmute": "Riattiva l&#x27;audio",
                  "ba-audioplayer-loader.tooltip": "Caricamento in corso...",
                  "ba-audioplayer.audio-error": "Si &#xE8; verificato un errore, riprova pi&#xF9; tardi. Clicca per riprovare.",
                  "ba-audiorecorder-chooser.record-audio": "Registra audio",
                  "ba-audiorecorder-chooser.upload-audio": "Carica audio",
                  "ba-audiorecorder-controlbar.settings": "Impostazioni",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Il suono &#xE8; buono",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Non riesco a sentire alcun suono",
                  "ba-audiorecorder-controlbar.record": "Registra",
                  "ba-audiorecorder-controlbar.record-tooltip": "Clicca qui per registrare.",
                  "ba-audiorecorder-controlbar.rerecord": "Riprova",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Clicca qui per riprovare.",
                  "ba-audiorecorder-controlbar.stop": "Stop",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Clicca qui per interrompere.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Il tempo di registrazione minimo &#xE8; %d secondi",
                  "ba-audiorecorder-controlbar.cancel": "Annulla",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Clicca qui per cancellare.",
                  "ba-videoplayer-controlbar.player-speed": "Velocit&#xE0; di riproduzione",
                  "ba-videoplayer-controlbar.settings": "Impostazioni",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Icona Airplay.",
                  "ba-videoplayer.all-settings": "Tutte le impostazioni",
                  "ba-videoplayer.player-speed": "Velocit&#xE0; di riproduzione",
                  "ba-videoplayer.full-screen": "A schermo intero",
                  "ba-videorecorder-controlbar.add-stream": "Aggiungi flusso",
                  "ba-videorecorder.switch-camera": "Cambia fotocamera",
                  "ba-videorecorder.prepare-covershot": "Preparazione delle foto di copertina",
                  "ba-videorecorder.prepare-thumbnails": "Preparazione delle miniature di ricerca",
                  "ba-videorecorder.adding-new-stream": "Aggiunta di un nuovo flusso",
                  "ba-imagecapture.recorder-error": "Si &#xE8; verificato un errore, riprova pi&#xF9; tardi. Clicca per riprovare.",
                  "ba-imagecapture.attach-error": "Non siamo riusciti ad accedere all&#x27;interfaccia multimediale. A seconda del dispositivo e del browser, potrebbe essere necessario installare Flash o accedere alla pagina tramite SSL.",
                  "ba-imagecapture.software-required": "Clicca qui sotto per installare / attivare i seguenti requisiti per procedere.",
                  "ba-imagecapture.software-waiting": "In attesa che i requisiti siano installati / attivati. Potrebbe essere necessario aggiornare la pagina dopo il completamento.",
                  "ba-imagecapture.access-forbidden": "L&#x27;accesso ai media era proibito. Clicca per riprovare.",
                  "ba-imagecapture.uploading": "Caricamento",
                  "ba-imagecapture.uploading-failed": "Caricamento fallito: fai clic qui per riprovare.",
                  "ba-imagecapture.upload-error-duration": "La lunghezza dell&#x27;immagine caricata non soddisfa i requisiti: fai clic qui per riprovare.",
                  "ba-imagecapture.resolution-constraint-error": "Il file che hai selezionato non corrisponde alla risoluzione richiesta: fai clic qui per riprovare.",
                  "ba-imagecapture.verifying": "Verifica",
                  "ba-imagecapture.verifying-failed": "Verifica fallita - clicca qui per riprovare.",
                  "ba-imagecapture.rerecord-confirm": "Vuoi veramente riprovare a scattare la tua immagine?",
                  "ba-imagecapture.image_file_too_large": "Il tuo file immagine &#xE8; troppo grande (%s) - clicca qui per riprovare con un file immagine pi&#xF9; piccolo.",
                  "ba-imagecapture.unsupported_image_type": "Per favore carica: %s - fai clic qui per riprovare.",
                  "ba-imagecapture.orientation-portrait-required": "Si prega di ruotare il dispositivo per registrare in modalit&#xE0; verticale.",
                  "ba-imagecapture.orientation-landscape-required": "Si prega di ruotare il dispositivo per registrare in modalit&#xE0; orizzontale.",
                  "ba-audiorecorder.recorder-error": "Si &#xE8; verificato un errore, riprova pi&#xF9; tardi. Clicca per riprovare.",
                  "ba-audiorecorder.attach-error": "Non siamo riusciti ad accedere all&#x27;interfaccia multimediale. A seconda del dispositivo e del browser, potrebbe essere necessario installare Flash o accedere alla pagina tramite SSL.",
                  "ba-audiorecorder.software-required": "Clicca qui sotto per installare / attivare i seguenti requisiti per procedere.",
                  "ba-audiorecorder.software-waiting": "In attesa che i requisiti siano installati / attivati. Potrebbe essere necessario aggiornare la pagina dopo il completamento.",
                  "ba-audiorecorder.access-forbidden": "L&#x27;accesso ai media era proibito. Clicca per riprovare.",
                  "ba-audiorecorder.uploading": "Caricamento",
                  "ba-audiorecorder.uploading-failed": "Caricamento fallito: fai clic qui per riprovare.",
                  "ba-audiorecorder.upload-error-duration": "La lunghezza dell&#x27;audio caricato non soddisfa i requisiti: fai clic qui per riprovare.",
                  "ba-audiorecorder.verifying": "Verifica",
                  "ba-audiorecorder.verifying-failed": "Verifica fallita - clicca qui per riprovare.",
                  "ba-audiorecorder.rerecord-confirm": "Vuoi veramente riprovare a registrare il tuo audio?",
                  "ba-audiorecorder.cancel-confirm": "Vuoi veramente cancellare il tuo caricamento audio?",
                  "ba-audiorecorder.audio_file_too_large": "Il tuo file audio &#xE8; troppo grande (%s) - fai clic qui per riprovare con un file audio pi&#xF9; piccolo.",
                  "ba-audiorecorder.unsupported_audio_type": "Carica: %s - fai clic qui per riprovare.",
                  "ba-common-settingsmenu.tooltip": "Clicca per riprodurre.",
                  "ba-common-settingsmenu.setting-menu": "Tutte le impostazioni",
                  "ba-common-settingsmenu.source-quality": "Qualit&#xE0; della fonte",
                  "ba-common-settingsmenu.player-speed": "Velocit&#xE0; di riproduzione",
                  "ba-common-settingsmenu.set-menu-option": "Imposta opzione",
                  "ba-common-settingsmenu.submit-video": "Conferma il video",
                  "ba-common-settingsmenu.picture-in-picture": "Immagine nell&#x27;immagine",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Esci dalla modalit&#xE0; a schermo intero",
                  "ba-common-settingsmenu.fullscreen-video": "Entra a schermo intero",
                  "ba-videorecorder-chooser.multi-stream": "Flusso multiplo",
                  "ba-videorecorder-controlbar.pause-recorder": "Metti in pausa la registrazione",
                  "ba-videorecorder-controlbar.resume-recorder": "Riprendi la registrazione",
                  "ba-videorecorder.missing-track": "Audio o video non disponibile",
                  "ba-videorecorder.device-already-in-use": "Almeno uno dei tuoi dispositivi di input &#xE8; gi&#xE0; in uso",
                  "ba-videorecorder.browser-permission-denied": "Autorizzazione negata dal browser, concedi l&#x27;accesso e ricarica la pagina",
                  "ba-audioplayer.all-settings": "Tutte le impostazioni",
                  "ba-videoplayer-controlbar.remaining-time": "Tempo rimanente",
                  "ba-videoplayer-controlbar.select-frame": "Seleziona",
                  "ba-videoplayer-controlbar.trim-video": "Taglia",
                  "ba-videoplayer-playbutton.trim": "Taglia",
                  "ba-videoplayer-playbutton.skip": "Salta",
                  "ba-videorecorder-imagegallery.upload-covershot": "Carica copertina",
                  "ba-videorecorder.pick-covershot-frame": "Seleziona una cornice da usare come foto di copertina.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Il registratore dello schermo non &#xE8; supportato su questo dispositivo",
                  "ba-videorecorder.trim-prompt": "Vuoi tagliare il tuo video?",
                  "ba-videorecorder.trim-video": "Sposta gli indicatori di inizio e fine per tagliare il tuo video",
                  "ba-videorecorder.wait-for-trim": "In attesa del comando di ritaglio...",
                  "ba-videorecorder-controlbar.no-video-source": "Fonte di ingresso video aggiuntiva mancante",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#xC8; gi&#xE0; stato selezionato un flusso aggiuntivo",
                  "ba-videorecorder.uploading-src-error": "Impossibile riprodurre il video ora, il caricamento &#xE8; ancora in corso",
                  "ba-audiorecorder-controlbar.pause-recorder": "Pausa registratore",
                  "ba-audiorecorder-controlbar.resume-recorder": "Riprendi registratore"
                },
                "language:ja": {
                  "ba-videoplayer-playbutton.tooltip": "&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x751F;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-videoplayer-playbutton.rerecord": "&#x518D;&#x9332;&#x753B;",
                  "ba-videoplayer-playbutton.submit-video": "&#x30D3;&#x30C7;&#x30AA;&#x3092;&#x78BA;&#x8A8D;&#x3059;&#x308B;",
                  "ba-videoplayer-loader.tooltip": "&#x8AAD;&#x307F;&#x8FBC;&#x3093;&#x3067;&#x3044;&#x307E;&#x3059;...",
                  "ba-videoplayer-controlbar.change-resolution": "&#x89E3;&#x50CF;&#x5EA6;&#x3092;&#x5909;&#x66F4;&#x3059;&#x308B;",
                  "ba-videoplayer-controlbar.video-progress": "&#x9032;&#x6357;",
                  "ba-videoplayer-controlbar.rerecord-video": "&#x518D;&#x9332;&#x753B;&#xFF1F;",
                  "ba-videoplayer-controlbar.submit-video": "&#x78BA;&#x8A8D;",
                  "ba-videoplayer-controlbar.play-video": "&#x518D;&#x751F;&#x3059;&#x308B;",
                  "ba-videoplayer-controlbar.pause-video": "&#x4E00;&#x6642;&#x505C;&#x6B62;",
                  "ba-videoplayer-controlbar.elapsed-time": "&#x7D4C;&#x904E;&#x6642;&#x9593;",
                  "ba-videoplayer-controlbar.total-time": "&#x5408;&#x8A08;&#x6642;&#x9593;",
                  "ba-videoplayer-controlbar.fullscreen-video": "&#x5168;&#x753B;&#x9762;&#x8868;&#x793A;&#x306B;&#x3059;&#x308B;",
                  "ba-videoplayer-controlbar.volume-button": "&#x30DC;&#x30EA;&#x30E5;&#x30FC;&#x30E0;&#x3092;&#x8A2D;&#x5B9A;&#x3059;&#x308B;",
                  "ba-videoplayer-controlbar.volume-mute": "&#x30DF;&#x30E5;&#x30FC;&#x30C8;",
                  "ba-videoplayer-controlbar.volume-unmute": "&#x30DF;&#x30E5;&#x30FC;&#x30C8;&#x89E3;&#x9664;",
                  "ba-videoplayer.video-error": "&#x30A8;&#x30E9;&#x30FC;&#x304C;&#x767A;&#x751F;&#x3057;&#x307E;&#x3057;&#x305F;&#x3002;&#x3057;&#x3070;&#x3089;&#x304F;&#x3057;&#x3066;&#x304B;&#x3089;&#x3082;&#x3046;&#x4E00;&#x5EA6;&#x304A;&#x8A66;&#x3057;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-videorecorder-chooser.record-video": "&#x9332;&#x753B;",
                  "ba-videorecorder-chooser.upload-video": "&#x52D5;&#x753B;&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;",
                  "ba-videorecorder-controlbar.settings": "&#x8A2D;&#x5B9A;",
                  "ba-videorecorder-controlbar.camerahealthy": "&#x7167;&#x660E;&#x306F;&#x826F;&#x597D;&#x3067;&#x3059;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "&#x7167;&#x660E;&#x304C;&#x6700;&#x9069;&#x3067;&#x306F;&#x3042;&#x308A;&#x307E;&#x305B;&#x3093;",
                  "ba-videorecorder-controlbar.microphonehealthy": "&#x97F3;&#x58F0;&#x306F;&#x826F;&#x597D;&#x3067;&#x3059;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "&#x97F3;&#x58F0;&#x3092;&#x8A8D;&#x8B58;&#x3067;&#x304D;&#x307E;&#x305B;&#x3093;",
                  "ba-videorecorder-controlbar.record": "&#x9332;&#x753B;&#x958B;&#x59CB;",
                  "ba-videorecorder-controlbar.record-tooltip": "&#x9332;&#x753B;&#x958B;&#x59CB;&#x3059;&#x308B;&#x306B;&#x306F;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder-controlbar.rerecord": "&#x518D;&#x9332;&#x753B;",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "&#x518D;&#x9332;&#x753B;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder-controlbar.upload-covershot": "&#x30AB;&#x30D0;&#x30FC;&#x3092;&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#x30AB;&#x30B9;&#x30BF;&#x30E0;&#x30AB;&#x30D0;&#x30FC;&#x30B7;&#x30E7;&#x30C3;&#x30C8;&#x3092;&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;",
                  "ba-videorecorder-controlbar.stop": "&#x505C;&#x6B62;",
                  "ba-videorecorder-controlbar.stop-tooltip": "&#x505C;&#x6B62;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder-controlbar.skip": "&#x30B9;&#x30AD;&#x30C3;&#x30D7;",
                  "ba-videorecorder-controlbar.skip-tooltip": "&#x30B9;&#x30AD;&#x30C3;&#x30D7;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder.recorder-error": "&#x30A8;&#x30E9;&#x30FC;&#x304C;&#x767A;&#x751F;&#x3057;&#x307E;&#x3057;&#x305F;&#x3002;&#x3057;&#x3070;&#x3089;&#x304F;&#x3057;&#x3066;&#x304B;&#x3089;&#x3082;&#x3046;&#x4E00;&#x5EA6;&#x304A;&#x8A66;&#x3057;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-videorecorder.attach-error": "&#x30E1;&#x30C7;&#x30A3;&#x30A2;&#x30A4;&#x30F3;&#x30BF;&#x30FC;&#x30D5;&#x30A7;&#x30A4;&#x30B9;&#x306B;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x3067;&#x304D;&#x307E;&#x305B;&#x3093;&#x3067;&#x3057;&#x305F;&#x3002;&#x30C7;&#x30D0;&#x30A4;&#x30B9;&#x3068;&#x30D6;&#x30E9;&#x30A6;&#x30B6;&#x306B;&#x3088;&#x3063;&#x3066;&#x306F;&#x3001;Flash&#x3092;&#x30A4;&#x30F3;&#x30B9;&#x30C8;&#x30FC;&#x30EB;&#x3059;&#x308B;&#x304B;&#x3001;SSL&#x7D4C;&#x7531;&#x3067;&#x30DA;&#x30FC;&#x30B8;&#x306B;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x3059;&#x308B;&#x5FC5;&#x8981;&#x304C;&#x3042;&#x308B;&#x5834;&#x5408;&#x304C;&#x3042;&#x308A;&#x307E;&#x3059;&#x3002;",
                  "ba-videorecorder.access-forbidden": "&#x30E1;&#x30C7;&#x30A3;&#x30A2;&#x3078;&#x306E;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x304C;&#x3067;&#x304D;&#x307E;&#x305B;&#x3093;&#x3002;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-videorecorder.pick-covershot": "&#x30AB;&#x30D0;&#x30FC;&#x30B7;&#x30E7;&#x30C3;&#x30C8;&#x3092;&#x9078;&#x3093;&#x3067;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder.uploading": "&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;",
                  "ba-videorecorder.uploading-failed": "&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x306B;&#x5931;&#x6557;&#x3057;&#x307E;&#x3057;&#x305F;-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder.verifying": "&#x691C;&#x8A3C;&#x4E2D;",
                  "ba-videorecorder.verifying-failed": "&#x691C;&#x8A3C;&#x306B;&#x5931;&#x6557;&#x3057;&#x307E;&#x3057;&#x305F;-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder.rerecord-confirm": "&#x672C;&#x5F53;&#x306B;&#x518D;&#x9332;&#x753B;&#x3057;&#x307E;&#x3059;&#x304B;&#xFF1F;",
                  "ba-videorecorder.video_file_too_large": "&#x30D3;&#x30C7;&#x30AA;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x304C;&#x5927;&#x304D;&#x3059;&#x304E;&#x307E;&#x3059;(%s)-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x3001;&#x5C0F;&#x3055;&#x3044;&#x30D3;&#x30C7;&#x30AA;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x3067;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder.unsupported_video_type": "&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#xFF1A;%s -&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "&#x5168;&#x753B;&#x9762;&#x8868;&#x793A;&#x3092;&#x7D42;&#x4E86;",
                  "ba-videoplayer-share.share": "&#x30E1;&#x30C7;&#x30A3;&#x30A2;&#x3092;&#x5171;&#x6709;&#x3059;&#x308B;",
                  "ba-videorecorder-chooser.record-screen": "&#x753B;&#x9762;&#x9332;&#x753B;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "&#x4E00;&#x6642;&#x505C;&#x6B62;&#x306F;&#x30B5;&#x30DD;&#x30FC;&#x30C8;&#x3055;&#x308C;&#x3066;&#x3044;&#x307E;&#x305B;&#x3093;",
                  "ba-videorecorder-chooser.record-audio": "&#x30EC;&#x30B3;&#x30FC;&#x30C9;&#x30AA;&#x30FC;&#x30C7;&#x30A3;&#x30AA;",
                  "ba-videorecorder-controlbar.stop-available-after": "&#x6700;&#x77ED;&#x3067;&#x3082;%d&#x79D2;&#x306F;&#x9332;&#x753B;&#x304C;&#x5FC5;&#x8981;&#x3067;&#x3059;",
                  "ba-videorecorder-controlbar.cancel": "&#x30AD;&#x30E3;&#x30F3;&#x30BB;&#x30EB;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "&#x30AD;&#x30E3;&#x30F3;&#x30BB;&#x30EB;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder.cancel-confirm": "&#x30D3;&#x30C7;&#x30AA;&#x306E;&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x3092;&#x672C;&#x5F53;&#x306B;&#x30AD;&#x30E3;&#x30F3;&#x30BB;&#x30EB;&#x3057;&#x307E;&#x3059;&#x304B;&#xFF1F;",
                  "ba-videoplayer-adslot.elapsed-time": "&#x7D4C;&#x904E;&#x6642;&#x9593;",
                  "ba-videoplayer-adslot.volume-button": "&#x30DC;&#x30EA;&#x30E5;&#x30FC;&#x30E0;&#x3092;&#x8A2D;&#x5B9A;&#x3059;&#x308B;",
                  "ba-videoplayer-adslot.volume-mute": "&#x30DF;&#x30E5;&#x30FC;&#x30C8;",
                  "ba-videoplayer-adslot.volume-unmute": "&#x30DF;&#x30E5;&#x30FC;&#x30C8;&#x89E3;&#x9664;",
                  "ba-videoplayer-adslot.ad-will-end-after": "&#x5E83;&#x544A;&#x306F;%s&#x5F8C;&#x306B;&#x7D42;&#x4E86;&#x3057;&#x307E;&#x3059;",
                  "ba-videoplayer-adslot.can-skip-after": "(%d)&#x306E;&#x5F8C;&#x306B;&#x30B9;&#x30AD;&#x30C3;&#x30D7;",
                  "ba-videoplayer-adslot.skip-ad": "&#x5E83;&#x544A;&#x3092;&#x30B9;&#x30AD;&#x30C3;&#x30D7;",
                  "ba-videorecorder.software-required": "&#x7D9A;&#x884C;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x4EE5;&#x4E0B;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x6B21;&#x306E;&#x8981;&#x4EF6;&#x3092;&#x30A4;&#x30F3;&#x30B9;&#x30C8;&#x30FC;&#x30EB;/&#x30A2;&#x30AF;&#x30C6;&#x30A3;&#x30D6;&#x5316;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder.software-waiting": "&#x8981;&#x4EF6;&#x304C;&#x30A4;&#x30F3;&#x30B9;&#x30C8;&#x30FC;&#x30EB;/&#x30A2;&#x30AF;&#x30C6;&#x30A3;&#x30D6;&#x5316;&#x3055;&#x308C;&#x308B;&#x306E;&#x3092;&#x5F85;&#x3063;&#x3066;&#x3044;&#x307E;&#x3059;&#x3002;&#x5B8C;&#x4E86;&#x5F8C;&#x306B;&#x30DA;&#x30FC;&#x30B8;&#x3092;&#x66F4;&#x65B0;&#x3059;&#x308B;&#x5FC5;&#x8981;&#x304C;&#x3042;&#x308B;&#x5834;&#x5408;&#x304C;&#x3042;&#x308A;&#x307E;&#x3059;&#x3002;",
                  "ba-videoplayer-controlbar.close-tracks": "CC&#x3092;&#x9589;&#x3058;&#x308B;",
                  "ba-videoplayer-controlbar.show-tracks": "CC&#x3092;&#x8868;&#x793A;",
                  "ba-videoplayer-tracks.upload-text-tracks": "&#x30C8;&#x30E9;&#x30C3;&#x30AF;&#x30C6;&#x30AD;&#x30B9;&#x30C8;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x3092;&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x3059;&#x308B;",
                  "ba-videoplayer-tracks.select-text-track-language": "&#x5B57;&#x5E55;&#x8A00;&#x8A9E;",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x6700;&#x521D;&#x306B;&#x30ED;&#x30B1;&#x30FC;&#x30EB;&#x3092;&#x9078;&#x629E;&#x3057;&#x307E;&#x3059;",
                  "ba-videoplayer-tracks.select-text-track-file": "&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x3092;&#x9078;&#x629E;",
                  "ba-videoplayer-tracks.back": "&#x30D0;&#x30C3;&#x30AF;",
                  "ba-videorecorder.framerate-warning": "&#x30D3;&#x30C7;&#x30AA;&#x306E;&#x30D5;&#x30EC;&#x30FC;&#x30E0;&#x30EC;&#x30FC;&#x30C8;&#x306F;&#x975E;&#x5E38;&#x306B;&#x4F4E;&#x3044;&#x3067;&#x3059;&#x3002;&#x4ED6;&#x306E;&#x3059;&#x3079;&#x3066;&#x306E;&#x30D7;&#x30ED;&#x30B0;&#x30E9;&#x30E0;&#x3068;&#x30D6;&#x30E9;&#x30A6;&#x30B6;&#x30BF;&#x30D6;&#x3092;&#x9589;&#x3058;&#x308B;&#x304B;&#x3001;&#x3088;&#x308A;&#x9AD8;&#x901F;&#x306A;&#x30B3;&#x30F3;&#x30D4;&#x30E5;&#x30FC;&#x30BF;&#x3092;&#x4F7F;&#x7528;&#x3059;&#x308B;&#x3053;&#x3068;&#x3092;&#x304A;&#x52E7;&#x3081;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-videorecorder.upload-error-duration": "&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x3055;&#x308C;&#x305F;&#x30D3;&#x30C7;&#x30AA;&#x306E;&#x9577;&#x3055;&#x304C;&#x8981;&#x4EF6;&#x3092;&#x6E80;&#x305F;&#x3057;&#x3066;&#x3044;&#x307E;&#x305B;&#x3093;-&#x518D;&#x8A66;&#x884C;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder.resolution-constraint-error": "&#x9078;&#x629E;&#x3057;&#x305F;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x304C;&#x5FC5;&#x8981;&#x306A;&#x89E3;&#x50CF;&#x5EA6;&#x3068;&#x4E00;&#x81F4;&#x3057;&#x307E;&#x305B;&#x3093;-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder.orientation-portrait-required": "&#x30DD;&#x30FC;&#x30C8;&#x30EC;&#x30FC;&#x30C8;&#x30E2;&#x30FC;&#x30C9;&#x3067;&#x8A18;&#x9332;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x30C7;&#x30D0;&#x30A4;&#x30B9;&#x3092;&#x56DE;&#x8EE2;&#x3055;&#x305B;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videorecorder.orientation-landscape-required": "&#x6A2A;&#x5411;&#x304D;&#x30E2;&#x30FC;&#x30C9;&#x3067;&#x8A18;&#x9332;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x30C7;&#x30D0;&#x30A4;&#x30B9;&#x3092;&#x56DE;&#x8EE2;&#x3055;&#x305B;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-imageviewer-controlbar.rerecord-image": "&#x3084;&#x308A;&#x76F4;&#x3057;&#xFF1F;",
                  "ba-imageviewer-controlbar.submit-image": "&#x78BA;&#x8A8D;",
                  "ba-imageviewer-controlbar.fullscreen-image": "&#x5168;&#x753B;&#x9762;&#x8868;&#x793A;&#x306B;&#x3059;&#x308B;",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "&#x5168;&#x753B;&#x9762;&#x8868;&#x793A;&#x3092;&#x7D42;&#x4E86;",
                  "ba-imageviewer.image-error": "&#x30A8;&#x30E9;&#x30FC;&#x304C;&#x767A;&#x751F;&#x3057;&#x307E;&#x3057;&#x305F;&#x3002;&#x3057;&#x3070;&#x3089;&#x304F;&#x3057;&#x3066;&#x304B;&#x3089;&#x3082;&#x3046;&#x4E00;&#x5EA6;&#x304A;&#x8A66;&#x3057;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-imagecapture-chooser.image-capture": "&#x753B;&#x50CF;&#x3092;&#x30AD;&#x30E3;&#x30D7;&#x30C1;&#x30E3;&#x3059;&#x308B;",
                  "ba-imagecapture-chooser.upload-image": "&#x753B;&#x50CF;&#x3092;&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;",
                  "ba-imagecapture-controlbar.settings": "&#x8A2D;&#x5B9A;",
                  "ba-imagecapture-controlbar.camerahealthy": "&#x7167;&#x660E;&#x306F;&#x826F;&#x597D;&#x3067;&#x3059;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "&#x7167;&#x660E;&#x304C;&#x6700;&#x9069;&#x3067;&#x306F;&#x3042;&#x308A;&#x307E;&#x305B;&#x3093;",
                  "ba-imagecapture-controlbar.record": "&#x30AD;&#x30E3;&#x30D7;&#x30C1;&#x30E3;&#x30FC;",
                  "ba-imagecapture-controlbar.record-tooltip": "&#x30AD;&#x30E3;&#x30D7;&#x30C1;&#x30E3;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-imagecapture-controlbar.rerecord": "&#x3084;&#x308A;&#x76F4;&#x3057;",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "&#x3084;&#x308A;&#x76F4;&#x3059;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-imagecapture-controlbar.cancel": "&#x30AD;&#x30E3;&#x30F3;&#x30BB;&#x30EB;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "&#x30AD;&#x30E3;&#x30F3;&#x30BB;&#x30EB;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-audioplayer-controlbar.audio-progress": "&#x9032;&#x6357;",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#x3084;&#x308A;&#x76F4;&#x3057;&#xFF1F;",
                  "ba-audioplayer-controlbar.submit-audio": "&#x78BA;&#x8A8D;",
                  "ba-audioplayer-controlbar.play-audio": "&#x6F14;&#x594F;&#x3059;&#x308B;",
                  "ba-audioplayer-controlbar.pause-audio": "&#x4E00;&#x6642;&#x505C;&#x6B62;",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "&#x4E00;&#x6642;&#x505C;&#x6B62;&#x306F;&#x30B5;&#x30DD;&#x30FC;&#x30C8;&#x3055;&#x308C;&#x3066;&#x3044;&#x307E;&#x305B;&#x3093;",
                  "ba-audioplayer-controlbar.elapsed-time": "&#x7D4C;&#x904E;&#x6642;&#x9593;",
                  "ba-audioplayer-controlbar.total-time": "&#x306E;&#x5168;&#x9577;",
                  "ba-audioplayer-controlbar.volume-button": "&#x30DC;&#x30EA;&#x30E5;&#x30FC;&#x30E0;&#x3092;&#x8A2D;&#x5B9A;&#x3059;&#x308B;",
                  "ba-audioplayer-controlbar.volume-mute": "&#x30DF;&#x30E5;&#x30FC;&#x30C8;",
                  "ba-audioplayer-controlbar.volume-unmute": "&#x30DF;&#x30E5;&#x30FC;&#x30C8;&#x89E3;&#x9664;",
                  "ba-audioplayer-loader.tooltip": "&#x8AAD;&#x307F;&#x8FBC;&#x3093;&#x3067;&#x3044;&#x307E;&#x3059;...",
                  "ba-audioplayer.audio-error": "&#x30A8;&#x30E9;&#x30FC;&#x304C;&#x767A;&#x751F;&#x3057;&#x307E;&#x3057;&#x305F;&#x3002;&#x3057;&#x3070;&#x3089;&#x304F;&#x3057;&#x3066;&#x304B;&#x3089;&#x3082;&#x3046;&#x4E00;&#x5EA6;&#x304A;&#x8A66;&#x3057;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-audiorecorder-chooser.record-audio": "&#x30EC;&#x30B3;&#x30FC;&#x30C9;&#x30AA;&#x30FC;&#x30C7;&#x30A3;&#x30AA;",
                  "ba-audiorecorder-chooser.upload-audio": "&#x30AA;&#x30FC;&#x30C7;&#x30A3;&#x30AA;&#x306E;&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;",
                  "ba-audiorecorder-controlbar.settings": "&#x8A2D;&#x5B9A;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "&#x97F3;&#x58F0;&#x306F;&#x826F;&#x597D;&#x3067;&#x3059;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "&#x97F3;&#x58F0;&#x3092;&#x8A8D;&#x8B58;&#x3067;&#x304D;&#x307E;&#x305B;&#x3093;",
                  "ba-audiorecorder-controlbar.record": "&#x9332;&#x97F3;",
                  "ba-audiorecorder-controlbar.record-tooltip": "&#x9332;&#x97F3;&#x3059;&#x308B;&#x306B;&#x306F;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-audiorecorder-controlbar.rerecord": "&#x3084;&#x308A;&#x76F4;&#x3057;",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "&#x3084;&#x308A;&#x76F4;&#x3059;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-audiorecorder-controlbar.stop": "&#x505C;&#x6B62;",
                  "ba-audiorecorder-controlbar.stop-tooltip": "&#x505C;&#x6B62;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-audiorecorder-controlbar.stop-available-after": "&#x6700;&#x77ED;&#x3067;&#x3082;%d&#x79D2;&#x306F;&#x9332;&#x97F3;&#x304C;&#x5FC5;&#x8981;&#x3067;&#x3059;",
                  "ba-audiorecorder-controlbar.cancel": "&#x30AD;&#x30E3;&#x30F3;&#x30BB;&#x30EB;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "&#x30AD;&#x30E3;&#x30F3;&#x30BB;&#x30EB;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-videoplayer-controlbar.player-speed": "&#x518D;&#x751F;&#x901F;&#x5EA6;",
                  "ba-videoplayer-controlbar.settings": "&#x8A2D;&#x5B9A;",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay&#x30A2;&#x30A4;&#x30B3;&#x30F3;&#x3002;",
                  "ba-videoplayer.all-settings": "&#x3059;&#x3079;&#x3066;&#x306E;&#x8A2D;&#x5B9A;",
                  "ba-videoplayer.player-speed": "&#x518D;&#x751F;&#x901F;&#x5EA6;",
                  "ba-videoplayer.full-screen": "&#x5168;&#x753B;&#x9762;&#x8868;&#x793A;",
                  "ba-videorecorder-controlbar.add-stream": "&#x30B9;&#x30C8;&#x30EA;&#x30FC;&#x30E0;&#x3092;&#x8FFD;&#x52A0;",
                  "ba-videorecorder.switch-camera": "&#x30AB;&#x30E1;&#x30E9;&#x3092;&#x5207;&#x308A;&#x66FF;&#x3048;&#x308B;",
                  "ba-videorecorder.prepare-covershot": "&#x30AB;&#x30D0;&#x30FC;&#x30B7;&#x30E7;&#x30C3;&#x30C8;&#x306E;&#x6E96;&#x5099;",
                  "ba-videorecorder.prepare-thumbnails": "&#x30B5;&#x30E0;&#x30CD;&#x30A4;&#x30EB;&#x3092;&#x63A2;&#x3059;&#x6E96;&#x5099;",
                  "ba-videorecorder.adding-new-stream": "&#x65B0;&#x3057;&#x3044;&#x30B9;&#x30C8;&#x30EA;&#x30FC;&#x30E0;&#x306E;&#x8FFD;&#x52A0;",
                  "ba-imagecapture.recorder-error": "&#x30A8;&#x30E9;&#x30FC;&#x304C;&#x767A;&#x751F;&#x3057;&#x307E;&#x3057;&#x305F;&#x3002;&#x3057;&#x3070;&#x3089;&#x304F;&#x3057;&#x3066;&#x304B;&#x3089;&#x3082;&#x3046;&#x4E00;&#x5EA6;&#x304A;&#x8A66;&#x3057;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-imagecapture.attach-error": "&#x30E1;&#x30C7;&#x30A3;&#x30A2;&#x30A4;&#x30F3;&#x30BF;&#x30FC;&#x30D5;&#x30A7;&#x30A4;&#x30B9;&#x306B;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x3067;&#x304D;&#x307E;&#x305B;&#x3093;&#x3067;&#x3057;&#x305F;&#x3002;&#x30C7;&#x30D0;&#x30A4;&#x30B9;&#x3068;&#x30D6;&#x30E9;&#x30A6;&#x30B6;&#x306B;&#x3088;&#x3063;&#x3066;&#x306F;&#x3001;Flash&#x3092;&#x30A4;&#x30F3;&#x30B9;&#x30C8;&#x30FC;&#x30EB;&#x3059;&#x308B;&#x304B;&#x3001;SSL&#x7D4C;&#x7531;&#x3067;&#x30DA;&#x30FC;&#x30B8;&#x306B;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x3059;&#x308B;&#x5FC5;&#x8981;&#x304C;&#x3042;&#x308B;&#x5834;&#x5408;&#x304C;&#x3042;&#x308A;&#x307E;&#x3059;&#x3002;",
                  "ba-imagecapture.software-required": "&#x7D9A;&#x884C;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x4EE5;&#x4E0B;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x6B21;&#x306E;&#x8981;&#x4EF6;&#x3092;&#x30A4;&#x30F3;&#x30B9;&#x30C8;&#x30FC;&#x30EB;/&#x30A2;&#x30AF;&#x30C6;&#x30A3;&#x30D6;&#x5316;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-imagecapture.software-waiting": "&#x8981;&#x4EF6;&#x304C;&#x30A4;&#x30F3;&#x30B9;&#x30C8;&#x30FC;&#x30EB;/&#x30A2;&#x30AF;&#x30C6;&#x30A3;&#x30D6;&#x5316;&#x3055;&#x308C;&#x308B;&#x306E;&#x3092;&#x5F85;&#x3063;&#x3066;&#x3044;&#x307E;&#x3059;&#x3002;&#x5B8C;&#x4E86;&#x5F8C;&#x306B;&#x30DA;&#x30FC;&#x30B8;&#x3092;&#x66F4;&#x65B0;&#x3059;&#x308B;&#x5FC5;&#x8981;&#x304C;&#x3042;&#x308B;&#x5834;&#x5408;&#x304C;&#x3042;&#x308A;&#x307E;&#x3059;&#x3002;",
                  "ba-imagecapture.access-forbidden": "&#x30E1;&#x30C7;&#x30A3;&#x30A2;&#x3078;&#x306E;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x306F;&#x7981;&#x6B62;&#x3055;&#x308C;&#x3066;&#x3044;&#x307E;&#x3057;&#x305F;&#x3002;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-imagecapture.uploading": "&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;",
                  "ba-imagecapture.uploading-failed": "&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x306B;&#x5931;&#x6557;&#x3057;&#x307E;&#x3057;&#x305F;-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-imagecapture.upload-error-duration": "&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x3055;&#x308C;&#x305F;&#x753B;&#x50CF;&#x306E;&#x9577;&#x3055;&#x304C;&#x8981;&#x4EF6;&#x3092;&#x6E80;&#x305F;&#x3057;&#x3066;&#x3044;&#x307E;&#x305B;&#x3093;-&#x518D;&#x8A66;&#x884C;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-imagecapture.resolution-constraint-error": "&#x9078;&#x629E;&#x3057;&#x305F;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x304C;&#x5FC5;&#x8981;&#x306A;&#x89E3;&#x50CF;&#x5EA6;&#x3068;&#x4E00;&#x81F4;&#x3057;&#x307E;&#x305B;&#x3093;-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-imagecapture.verifying": "&#x78BA;&#x8A8D;&#x4E2D;",
                  "ba-imagecapture.verifying-failed": "&#x78BA;&#x8A8D;&#x306B;&#x5931;&#x6557;&#x3057;&#x307E;&#x3057;&#x305F;-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-imagecapture.rerecord-confirm": "&#x672C;&#x5F53;&#x306B;&#x81EA;&#x5206;&#x306E;&#x753B;&#x50CF;&#x3092;&#x64AE;&#x308A;&#x76F4;&#x3057;&#x305F;&#x3044;&#x3067;&#x3059;&#x304B;&#xFF1F;",
                  "ba-imagecapture.image_file_too_large": "&#x753B;&#x50CF;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x304C;&#x5927;&#x304D;&#x3059;&#x304E;&#x307E;&#x3059;&#xFF08;%s&#xFF09;-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x3001;&#x5C0F;&#x3055;&#x3044;&#x753B;&#x50CF;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x3067;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-imagecapture.unsupported_image_type": "&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#xFF1A;%s-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-imagecapture.orientation-portrait-required": "&#x30DD;&#x30FC;&#x30C8;&#x30EC;&#x30FC;&#x30C8;&#x30E2;&#x30FC;&#x30C9;&#x3067;&#x8A18;&#x9332;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x30C7;&#x30D0;&#x30A4;&#x30B9;&#x3092;&#x56DE;&#x8EE2;&#x3055;&#x305B;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-imagecapture.orientation-landscape-required": "&#x6A2A;&#x5411;&#x304D;&#x30E2;&#x30FC;&#x30C9;&#x3067;&#x8A18;&#x9332;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x30C7;&#x30D0;&#x30A4;&#x30B9;&#x3092;&#x56DE;&#x8EE2;&#x3055;&#x305B;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-audiorecorder.recorder-error": "&#x30A8;&#x30E9;&#x30FC;&#x304C;&#x767A;&#x751F;&#x3057;&#x307E;&#x3057;&#x305F;&#x3002;&#x3057;&#x3070;&#x3089;&#x304F;&#x3057;&#x3066;&#x304B;&#x3089;&#x3082;&#x3046;&#x4E00;&#x5EA6;&#x304A;&#x8A66;&#x3057;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-audiorecorder.attach-error": "&#x30E1;&#x30C7;&#x30A3;&#x30A2;&#x30A4;&#x30F3;&#x30BF;&#x30FC;&#x30D5;&#x30A7;&#x30A4;&#x30B9;&#x306B;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x3067;&#x304D;&#x307E;&#x305B;&#x3093;&#x3067;&#x3057;&#x305F;&#x3002;&#x30C7;&#x30D0;&#x30A4;&#x30B9;&#x3068;&#x30D6;&#x30E9;&#x30A6;&#x30B6;&#x306B;&#x3088;&#x3063;&#x3066;&#x306F;&#x3001;Flash&#x3092;&#x30A4;&#x30F3;&#x30B9;&#x30C8;&#x30FC;&#x30EB;&#x3059;&#x308B;&#x304B;&#x3001;SSL&#x7D4C;&#x7531;&#x3067;&#x30DA;&#x30FC;&#x30B8;&#x306B;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x3059;&#x308B;&#x5FC5;&#x8981;&#x304C;&#x3042;&#x308B;&#x5834;&#x5408;&#x304C;&#x3042;&#x308A;&#x307E;&#x3059;&#x3002;",
                  "ba-audiorecorder.software-required": "&#x7D9A;&#x884C;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x4EE5;&#x4E0B;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x6B21;&#x306E;&#x8981;&#x4EF6;&#x3092;&#x30A4;&#x30F3;&#x30B9;&#x30C8;&#x30FC;&#x30EB;/&#x30A2;&#x30AF;&#x30C6;&#x30A3;&#x30D6;&#x5316;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-audiorecorder.software-waiting": "&#x8981;&#x4EF6;&#x304C;&#x30A4;&#x30F3;&#x30B9;&#x30C8;&#x30FC;&#x30EB;/&#x30A2;&#x30AF;&#x30C6;&#x30A3;&#x30D6;&#x5316;&#x3055;&#x308C;&#x308B;&#x306E;&#x3092;&#x5F85;&#x3063;&#x3066;&#x3044;&#x307E;&#x3059;&#x3002;&#x5B8C;&#x4E86;&#x5F8C;&#x306B;&#x30DA;&#x30FC;&#x30B8;&#x3092;&#x66F4;&#x65B0;&#x3059;&#x308B;&#x5FC5;&#x8981;&#x304C;&#x3042;&#x308B;&#x5834;&#x5408;&#x304C;&#x3042;&#x308A;&#x307E;&#x3059;&#x3002;",
                  "ba-audiorecorder.access-forbidden": "&#x30E1;&#x30C7;&#x30A3;&#x30A2;&#x3078;&#x306E;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x306F;&#x7981;&#x6B62;&#x3055;&#x308C;&#x3066;&#x3044;&#x307E;&#x3057;&#x305F;&#x3002;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-audiorecorder.uploading": "&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;",
                  "ba-audiorecorder.uploading-failed": "&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x306B;&#x5931;&#x6557;&#x3057;&#x307E;&#x3057;&#x305F;-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-audiorecorder.upload-error-duration": "&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x3055;&#x308C;&#x305F;&#x30AA;&#x30FC;&#x30C7;&#x30A3;&#x30AA;&#x306E;&#x9577;&#x3055;&#x304C;&#x8981;&#x4EF6;&#x3092;&#x6E80;&#x305F;&#x3057;&#x3066;&#x3044;&#x307E;&#x305B;&#x3093;-&#x518D;&#x8A66;&#x884C;&#x3059;&#x308B;&#x306B;&#x306F;&#x3001;&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-audiorecorder.verifying": "&#x78BA;&#x8A8D;&#x4E2D;",
                  "ba-audiorecorder.verifying-failed": "&#x78BA;&#x8A8D;&#x306B;&#x5931;&#x6557;&#x3057;&#x307E;&#x3057;&#x305F;-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-audiorecorder.rerecord-confirm": "&#x672C;&#x5F53;&#x306B;&#x30AA;&#x30FC;&#x30C7;&#x30A3;&#x30AA;&#x3092;&#x3084;&#x308A;&#x76F4;&#x3057;&#x305F;&#x3044;&#x3067;&#x3059;&#x304B;&#xFF1F;",
                  "ba-audiorecorder.cancel-confirm": "&#x672C;&#x5F53;&#x306B;&#x30AA;&#x30FC;&#x30C7;&#x30A3;&#x30AA;&#x306E;&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x3092;&#x30AD;&#x30E3;&#x30F3;&#x30BB;&#x30EB;&#x3057;&#x307E;&#x3059;&#x304B;&#xFF1F;",
                  "ba-audiorecorder.audio_file_too_large": "&#x30AA;&#x30FC;&#x30C7;&#x30A3;&#x30AA;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x304C;&#x5927;&#x304D;&#x3059;&#x304E;&#x307E;&#x3059;&#xFF08;%s&#xFF09;-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x3001;&#x5C0F;&#x3055;&#x3044;&#x30AA;&#x30FC;&#x30C7;&#x30A3;&#x30AA;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x3067;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-audiorecorder.unsupported_audio_type": "&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#xFF1A;%s-&#x3053;&#x3053;&#x3092;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ba-common-settingsmenu.tooltip": "&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x751F;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-common-settingsmenu.setting-menu": "&#x3059;&#x3079;&#x3066;&#x306E;&#x8A2D;&#x5B9A;",
                  "ba-common-settingsmenu.source-quality": "&#x30BD;&#x30FC;&#x30B9;&#x54C1;&#x8CEA;",
                  "ba-common-settingsmenu.player-speed": "&#x518D;&#x751F;&#x901F;&#x5EA6;",
                  "ba-common-settingsmenu.set-menu-option": "&#x30AA;&#x30D7;&#x30B7;&#x30E7;&#x30F3;&#x3092;&#x8A2D;&#x5B9A;",
                  "ba-common-settingsmenu.submit-video": "&#x30D3;&#x30C7;&#x30AA;&#x3092;&#x78BA;&#x8A8D;&#x3059;&#x308B;",
                  "ba-common-settingsmenu.picture-in-picture": "&#x30D4;&#x30AF;&#x30C1;&#x30E3;&#x30FC;&#x30A4;&#x30F3;&#x30D4;&#x30AF;&#x30C1;&#x30E3;&#x30FC;",
                  "ba-common-settingsmenu.exit-fullscreen-video": "&#x5168;&#x753B;&#x9762;&#x8868;&#x793A;&#x3092;&#x7D42;&#x4E86;",
                  "ba-common-settingsmenu.fullscreen-video": "&#x5168;&#x753B;&#x9762;&#x8868;&#x793A;&#x306B;&#x3059;&#x308B;",
                  "ba-videorecorder-chooser.multi-stream": "&#x30DE;&#x30EB;&#x30C1;&#x30B9;&#x30C8;&#x30EA;&#x30FC;&#x30E0;",
                  "ba-videorecorder-controlbar.pause-recorder": "&#x30EC;&#x30B3;&#x30FC;&#x30C0;&#x30FC;&#x306E;&#x4E00;&#x6642;&#x505C;&#x6B62;",
                  "ba-videorecorder-controlbar.resume-recorder": "&#x30EC;&#x30B8;&#x30E5;&#x30E1;&#x30EC;&#x30B3;&#x30FC;&#x30C0;&#x30FC;",
                  "ba-videorecorder.missing-track": "&#x5FC5;&#x8981;&#x306A;&#x30AA;&#x30FC;&#x30C7;&#x30A3;&#x30AA;&#x307E;&#x305F;&#x306F;&#x30D3;&#x30C7;&#x30AA;&#x30C8;&#x30E9;&#x30C3;&#x30AF;&#x304C;&#x3042;&#x308A;&#x307E;&#x305B;&#x3093;",
                  "ba-videorecorder.device-already-in-use": "&#x5165;&#x529B;&#x30C7;&#x30D0;&#x30A4;&#x30B9;&#x306E;&#x5C11;&#x306A;&#x304F;&#x3068;&#x3082;1&#x3064;&#x304C;&#x3059;&#x3067;&#x306B;&#x4F7F;&#x7528;&#x3055;&#x308C;&#x3066;&#x3044;&#x307E;&#x3059;",
                  "ba-videorecorder.browser-permission-denied": "&#x30D6;&#x30E9;&#x30A6;&#x30B6;&#x306B;&#x3088;&#x3063;&#x3066;&#x62D2;&#x5426;&#x3055;&#x308C;&#x307E;&#x3057;&#x305F;&#x3002;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x3092;&#x8A31;&#x53EF;&#x3057;&#x3066;&#x30DA;&#x30FC;&#x30B8;&#x3092;&#x30EA;&#x30ED;&#x30FC;&#x30C9;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;",
                  "ba-audioplayer.all-settings": "&#x3059;&#x3079;&#x3066;&#x306E;&#x8A2D;&#x5B9A;",
                  "ba-videoplayer-controlbar.remaining-time": "&#x6B8B;&#x308A;&#x6642;&#x9593;",
                  "ba-videoplayer-controlbar.select-frame": "&#x9078;&#x629E;&#x3059;&#x308B;",
                  "ba-videoplayer-controlbar.trim-video": "&#x30C8;&#x30EA;&#x30E0;",
                  "ba-videoplayer-playbutton.trim": "&#x30C8;&#x30EA;&#x30E0;",
                  "ba-videoplayer-playbutton.skip": "&#x30B9;&#x30AD;&#x30C3;&#x30D7;",
                  "ba-videorecorder-imagegallery.upload-covershot": "&#x30AB;&#x30D0;&#x30FC;&#x3092;&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;",
                  "ba-videorecorder.pick-covershot-frame": "&#x30AB;&#x30D0;&#x30FC;&#x30B7;&#x30E7;&#x30C3;&#x30C8;&#x3068;&#x3057;&#x3066;&#x4F7F;&#x7528;&#x3059;&#x308B;&#x30D5;&#x30EC;&#x30FC;&#x30E0;&#x3092;&#x9078;&#x629E;&#x3057;&#x307E;&#x3059;&#x3002;",
                  "ba-videorecorder.screen-recorder-is-not-supported": "&#x30B9;&#x30AF;&#x30EA;&#x30FC;&#x30F3;&#x30EC;&#x30B3;&#x30FC;&#x30C0;&#x30FC;&#x306F;&#x3053;&#x306E;&#x30C7;&#x30D0;&#x30A4;&#x30B9;&#x3067;&#x306F;&#x30B5;&#x30DD;&#x30FC;&#x30C8;&#x3055;&#x308C;&#x3066;&#x3044;&#x307E;&#x305B;&#x3093;",
                  "ba-videorecorder.trim-prompt": "&#x30D3;&#x30C7;&#x30AA;&#x3092;&#x30C8;&#x30EA;&#x30DF;&#x30F3;&#x30B0;&#x3057;&#x307E;&#x3059;&#x304B;&#xFF1F;",
                  "ba-videorecorder.trim-video": "&#x958B;&#x59CB;&#x30DE;&#x30FC;&#x30AB;&#x30FC;&#x3068;&#x7D42;&#x4E86;&#x30DE;&#x30FC;&#x30AB;&#x30FC;&#x3092;&#x79FB;&#x52D5;&#x3057;&#x3066;&#x3001;&#x30D3;&#x30C7;&#x30AA;&#x3092;&#x30C8;&#x30EA;&#x30DF;&#x30F3;&#x30B0;&#x3057;&#x307E;&#x3059;",
                  "ba-videorecorder.wait-for-trim": "&#x30C8;&#x30EA;&#x30E0;&#x30B3;&#x30DE;&#x30F3;&#x30C9;&#x3092;&#x5F85;&#x3063;&#x3066;&#x3044;&#x307E;&#x3059;...",
                  "ba-videorecorder-controlbar.no-video-source": "&#x8FFD;&#x52A0;&#x306E;&#x30D3;&#x30C7;&#x30AA;&#x5165;&#x529B;&#x30BD;&#x30FC;&#x30B9;&#x304C;&#x3042;&#x308A;&#x307E;&#x305B;&#x3093;",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x8FFD;&#x52A0;&#x306E;&#x30B9;&#x30C8;&#x30EA;&#x30FC;&#x30E0;&#x306F;&#x3059;&#x3067;&#x306B;&#x9078;&#x629E;&#x3055;&#x308C;&#x3066;&#x3044;&#x307E;&#x3059;",
                  "ba-videorecorder.uploading-src-error": "&#x73FE;&#x5728;&#x52D5;&#x753B;&#x3092;&#x518D;&#x751F;&#x3067;&#x304D;&#x307E;&#x305B;&#x3093;&#x3002;&#x30A2;&#x30C3;&#x30D7;&#x30ED;&#x30FC;&#x30C9;&#x306F;&#x307E;&#x3060;&#x9032;&#x884C;&#x4E2D;&#x3067;&#x3059;",
                  "ba-audiorecorder-controlbar.pause-recorder": "&#x30EC;&#x30B3;&#x30FC;&#x30C0;&#x30FC;&#x306E;&#x4E00;&#x6642;&#x505C;&#x6B62;",
                  "ba-audiorecorder-controlbar.resume-recorder": "&#x30EC;&#x30B8;&#x30E5;&#x30E1;&#x30EC;&#x30B3;&#x30FC;&#x30C0;&#x30FC;"
                },
                "language:mk": {
                  "ba-videoplayer-playbutton.tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x437;&#x430; &#x434;&#x430; &#x438;&#x433;&#x440;&#x430;&#x442;&#x435;.",
                  "ba-videoplayer-playbutton.rerecord": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;",
                  "ba-videoplayer-playbutton.submit-video": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x435;&#x442;&#x435; &#x433;&#x43E; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x442;&#x43E;",
                  "ba-videoplayer-loader.tooltip": "&#x421;&#x435; &#x432;&#x447;&#x438;&#x442;&#x443;&#x432;&#x430; ...",
                  "ba-videoplayer-controlbar.change-resolution": "&#x41F;&#x440;&#x43E;&#x43C;&#x435;&#x43D;&#x435;&#x442;&#x435; &#x458;&#x430; &#x440;&#x435;&#x437;&#x43E;&#x43B;&#x443;&#x446;&#x438;&#x458;&#x430;&#x442;&#x430;",
                  "ba-videoplayer-controlbar.video-progress": "&#x41D;&#x430;&#x43F;&#x440;&#x435;&#x434;&#x43E;&#x43A;",
                  "ba-videoplayer-controlbar.rerecord-video": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;?",
                  "ba-videoplayer-controlbar.submit-video": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x438;",
                  "ba-videoplayer-controlbar.play-video": "&#x418;&#x433;&#x440;&#x430;&#x458;",
                  "ba-videoplayer-controlbar.pause-video": "&#x41F;&#x430;&#x443;&#x437;&#x430;",
                  "ba-videoplayer-controlbar.elapsed-time": "&#x41F;&#x43E;&#x43C;&#x438;&#x43D;&#x430;&#x442;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435;",
                  "ba-videoplayer-controlbar.total-time": "&#x412;&#x43A;&#x443;&#x43F;&#x43D;&#x430; &#x434;&#x43E;&#x43B;&#x436;&#x438;&#x43D;&#x430; &#x43D;&#x430;",
                  "ba-videoplayer-controlbar.fullscreen-video": "&#x412;&#x43D;&#x435;&#x441;&#x435;&#x442;&#x435; &#x446;&#x435;&#x43B; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-videoplayer-controlbar.volume-button": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435; &#x458;&#x430; &#x458;&#x430;&#x447;&#x438;&#x43D;&#x430;&#x442;&#x430; &#x43D;&#x430; &#x437;&#x432;&#x443;&#x43A;&#x43E;&#x442;",
                  "ba-videoplayer-controlbar.volume-mute": "&#x41D;&#x435;&#x43C;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer-controlbar.volume-unmute": "&#x41D;&#x435;&#x43C;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer.video-error": "&#x41D;&#x430;&#x441;&#x442;&#x430;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;, &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x441;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E; &#x43F;&#x43E;&#x434;&#x43E;&#x446;&#x43D;&#x430;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-videorecorder-chooser.record-video": "&#x421;&#x43D;&#x438;&#x43C;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-chooser.upload-video": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-controlbar.settings": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x43A;&#x438;",
                  "ba-videorecorder-controlbar.camerahealthy": "&#x41E;&#x441;&#x432;&#x435;&#x442;&#x43B;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E; &#x435; &#x434;&#x43E;&#x431;&#x440;&#x43E;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "&#x41E;&#x441;&#x432;&#x435;&#x442;&#x43B;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E; &#x43D;&#x435; &#x435; &#x43E;&#x43F;&#x442;&#x438;&#x43C;&#x430;&#x43B;&#x43D;&#x43E;",
                  "ba-videorecorder-controlbar.microphonehealthy": "&#x417;&#x432;&#x443;&#x43A;&#x43E;&#x442; &#x435; &#x434;&#x43E;&#x431;&#x430;&#x440;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x430;&#x43C; &#x434;&#x430; &#x441;&#x43E;&#x431;&#x435;&#x440;&#x430;&#x43C; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videorecorder-controlbar.record": "&#x421;&#x43D;&#x438;&#x43C;&#x438;",
                  "ba-videorecorder-controlbar.record-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x438;&#x442;&#x435;.",
                  "ba-videorecorder-controlbar.rerecord": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43D;&#x430;&#x43F;&#x440;&#x430;&#x432;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-videorecorder-controlbar.upload-covershot": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435; &#x43A;&#x43E;&#x440;&#x438;&#x446;&#x430;",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x438;&#x442;&#x435; &#x43F;&#x440;&#x438;&#x43B;&#x430;&#x433;&#x43E;&#x434;&#x435;&#x43D;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x43A;&#x430; &#x43E;&#x434; &#x43A;&#x43E;&#x440;&#x438;&#x446;&#x430;&#x442;&#x430;",
                  "ba-videorecorder-controlbar.stop": "&#x417;&#x430;&#x441;&#x442;&#x430;&#x43D;&#x438;",
                  "ba-videorecorder-controlbar.stop-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x437;&#x430;&#x43F;&#x440;&#x435;&#x442;&#x435;.",
                  "ba-videorecorder-controlbar.skip": "&#x41F;&#x440;&#x435;&#x441;&#x43A;&#x43E;&#x43A;&#x43D;&#x438;",
                  "ba-videorecorder-controlbar.skip-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x435;&#x441;&#x43A;&#x43E;&#x43A;&#x43D;&#x435;&#x442;&#x435;.",
                  "ba-videorecorder.recorder-error": "&#x41D;&#x430;&#x441;&#x442;&#x430;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;, &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x441;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E; &#x43F;&#x43E;&#x434;&#x43E;&#x446;&#x43D;&#x430;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-videorecorder.attach-error": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x432;&#x43C;&#x435; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x43C;&#x435; &#x434;&#x43E; &#x43C;&#x435;&#x434;&#x438;&#x443;&#x43C;&#x441;&#x43A;&#x438;&#x43E;&#x442; &#x438;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x458;&#x441;. &#x412;&#x43E; &#x437;&#x430;&#x432;&#x438;&#x441;&#x43D;&#x43E;&#x441;&#x442; &#x43E;&#x434; &#x443;&#x440;&#x435;&#x434;&#x43E;&#x442; &#x438; &#x43F;&#x440;&#x435;&#x43B;&#x438;&#x441;&#x442;&#x443;&#x432;&#x430;&#x447;&#x43E;&#x442;, &#x43C;&#x43E;&#x436;&#x435;&#x431;&#x438; &#x45C;&#x435; &#x442;&#x440;&#x435;&#x431;&#x430; &#x434;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; Flash &#x438;&#x43B;&#x438; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x442;&#x435; &#x43D;&#x430; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430; &#x43F;&#x440;&#x435;&#x43A;&#x443; SSL.",
                  "ba-videorecorder.access-forbidden": "&#x417;&#x430;&#x431;&#x440;&#x430;&#x43D;&#x435;&#x442; &#x435; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x43E;&#x442; &#x434;&#x43E; &#x43C;&#x435;&#x434;&#x438;&#x443;&#x43C;&#x438;&#x442;&#x435;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-videorecorder.pick-covershot": "&#x418;&#x437;&#x431;&#x435;&#x440;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x440;&#x438;&#x432;&#x43A;&#x430;.",
                  "ba-videorecorder.uploading": "&#x421;&#x435; &#x43F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x443;&#x432;&#x430;",
                  "ba-videorecorder.uploading-failed": "&#x412;&#x447;&#x438;&#x442;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E; &#x43D;&#x435; &#x443;&#x441;&#x43F;&#x435;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-videorecorder.verifying": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x443;&#x432;&#x430;&#x45A;&#x435;",
                  "ba-videorecorder.verifying-failed": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x430;&#x442;&#x430; &#x43D;&#x435; &#x443;&#x441;&#x43F;&#x435;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-videorecorder.rerecord-confirm": "&#x414;&#x430;&#x43B;&#x438; &#x43D;&#x430;&#x432;&#x438;&#x441;&#x442;&#x438;&#x43D;&#x430; &#x441;&#x430;&#x43A;&#x430;&#x442;&#x435; &#x434;&#x430; &#x433;&#x43E; &#x43D;&#x430;&#x43F;&#x440;&#x430;&#x432;&#x438;&#x442;&#x435; &#x432;&#x430;&#x448;&#x435;&#x442;&#x43E; &#x432;&#x438;&#x434;&#x435;&#x43E;?",
                  "ba-videorecorder.video_file_too_large": "&#x412;&#x430;&#x448;&#x430;&#x442;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430; &#x435; &#x43F;&#x440;&#x435;&#x433;&#x43E;&#x43B;&#x435;&#x43C;&#x430; (%s) - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E; &#x441;&#x43E; &#x43F;&#x43E;&#x43C;&#x430;&#x43B;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;-&#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430;.",
                  "ba-videorecorder.unsupported_video_type": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435;: %s - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "&#x418;&#x437;&#x43B;&#x435;&#x437;&#x435;&#x442;&#x435; &#x43E;&#x434; &#x446;&#x435;&#x43B; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-videoplayer-share.share": "&#x421;&#x43F;&#x43E;&#x434;&#x435;&#x43B;&#x438; &#x43C;&#x435;&#x434;&#x438;&#x443;&#x43C;&#x438;",
                  "ba-videorecorder-chooser.record-screen": "&#x415;&#x43A;&#x440;&#x430;&#x43D; &#x437;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x45A;&#x435;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "&#x41F;&#x430;&#x443;&#x437;&#x430;&#x442;&#x430; &#x43D;&#x435; &#x435; &#x43F;&#x43E;&#x434;&#x434;&#x440;&#x436;&#x430;&#x43D;&#x430;",
                  "ba-videorecorder-chooser.record-audio": "&#x421;&#x43D;&#x438;&#x43C;&#x438; &#x430;&#x443;&#x434;&#x438;&#x43E;",
                  "ba-videorecorder-controlbar.stop-available-after": "&#x41C;&#x438;&#x43D;&#x438;&#x43C;&#x430;&#x43B;&#x43D;&#x43E;&#x442;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435; &#x43D;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x45A;&#x435; &#x435; %d &#x441;&#x435;&#x43A;&#x443;&#x43D;&#x434;&#x438;",
                  "ba-videorecorder-controlbar.cancel": "&#x41E;&#x442;&#x43A;&#x430;&#x436;&#x438;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x43E;&#x442;&#x43A;&#x430;&#x436;&#x435;&#x442;&#x435;.",
                  "ba-videorecorder.cancel-confirm": "&#x414;&#x430;&#x43B;&#x438; &#x43D;&#x430;&#x432;&#x438;&#x441;&#x442;&#x438;&#x43D;&#x430; &#x441;&#x430;&#x43A;&#x430;&#x442;&#x435; &#x434;&#x430; &#x433;&#x43E; &#x43E;&#x442;&#x43A;&#x430;&#x436;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x442;&#x43E;?",
                  "ba-videoplayer-adslot.elapsed-time": "&#x41F;&#x43E;&#x43C;&#x438;&#x43D;&#x430;&#x442;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435;",
                  "ba-videoplayer-adslot.volume-button": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435; &#x458;&#x430; &#x458;&#x430;&#x447;&#x438;&#x43D;&#x430;&#x442;&#x430; &#x43D;&#x430; &#x437;&#x432;&#x443;&#x43A;&#x43E;&#x442;",
                  "ba-videoplayer-adslot.volume-mute": "&#x41D;&#x435;&#x43C;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer-adslot.volume-unmute": "&#x41D;&#x435;&#x43C;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer-adslot.ad-will-end-after": "&#x41E;&#x433;&#x43B;&#x430;&#x441;&#x43E;&#x442; &#x45C;&#x435; &#x437;&#x430;&#x432;&#x440;&#x448;&#x438; &#x43F;&#x43E; %s",
                  "ba-videoplayer-adslot.can-skip-after": "&#x41F;&#x440;&#x435;&#x441;&#x43A;&#x43E;&#x43A;&#x43D;&#x438; &#x43F;&#x43E; %d",
                  "ba-videoplayer-adslot.skip-ad": "&#x41F;&#x440;&#x435;&#x441;&#x43A;&#x43E;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x440;&#x435;&#x43A;&#x43B;&#x430;&#x43C;&#x430;",
                  "ba-videorecorder.software-required": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x434;&#x43E;&#x43B;&#x443; &#x437;&#x430; &#x434;&#x430; &#x433;&#x438; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x442;&#x435; &#x441;&#x43B;&#x435;&#x434;&#x43D;&#x438;&#x432;&#x435; &#x431;&#x430;&#x440;&#x430;&#x45A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x434;&#x43E;&#x43B;&#x436;&#x438;&#x442;&#x435;.",
                  "ba-videorecorder.software-waiting": "&#x427;&#x435;&#x43A;&#x430;&#x458;&#x45C;&#x438; &#x434;&#x430; &#x441;&#x435; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x430;&#x442; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x430;&#x442; &#x431;&#x430;&#x440;&#x430;&#x45A;&#x430;&#x442;&#x430;. &#x41C;&#x43E;&#x436;&#x435;&#x431;&#x438; &#x45C;&#x435; &#x442;&#x440;&#x435;&#x431;&#x430; &#x434;&#x430; &#x458;&#x430; &#x43E;&#x441;&#x432;&#x435;&#x436;&#x438;&#x442;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430; &#x43F;&#x43E; &#x437;&#x430;&#x432;&#x440;&#x448;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E;.",
                  "ba-videoplayer-controlbar.close-tracks": "&#x417;&#x430;&#x442;&#x432;&#x43E;&#x440;&#x438; CC",
                  "ba-videoplayer-controlbar.show-tracks": "&#x41F;&#x43E;&#x43A;&#x430;&#x436;&#x438; CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x438; &#x441;&#x43E; &#x442;&#x435;&#x43A;&#x441;&#x442; &#x437;&#x430; &#x43F;&#x435;&#x441;&#x43D;&#x430;",
                  "ba-videoplayer-tracks.select-text-track-language": "&#x408;&#x430;&#x437;&#x438;&#x43A; &#x43D;&#x430; &#x43F;&#x440;&#x435;&#x432;&#x43E;&#x434;",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x41F;&#x440;&#x432;&#x43E; &#x438;&#x437;&#x431;&#x435;&#x440;&#x435;&#x442;&#x435; &#x43B;&#x43E;&#x43A;&#x430;&#x446;&#x438;&#x458;&#x430;",
                  "ba-videoplayer-tracks.select-text-track-file": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x437;&#x430; &#x434;&#x430; &#x438;&#x437;&#x431;&#x435;&#x440;&#x435;&#x442;&#x435; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430;",
                  "ba-videoplayer-tracks.back": "&#x43D;&#x430;&#x437;&#x430;&#x434;",
                  "ba-videorecorder.framerate-warning": "&#x421;&#x442;&#x430;&#x43F;&#x43A;&#x430;&#x442;&#x430; &#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x440;&#x430;&#x43C;&#x43A;&#x438; &#x435; &#x43C;&#x43D;&#x43E;&#x433;&#x443; &#x43C;&#x430;&#x43B;&#x430;. &#x41F;&#x440;&#x435;&#x43F;&#x43E;&#x440;&#x430;&#x447;&#x443;&#x432;&#x430;&#x43C;&#x435; &#x434;&#x430; &#x433;&#x438; &#x437;&#x430;&#x442;&#x432;&#x43E;&#x440;&#x438;&#x442;&#x435; &#x441;&#x438;&#x442;&#x435; &#x434;&#x440;&#x443;&#x433;&#x438; &#x43F;&#x440;&#x43E;&#x433;&#x440;&#x430;&#x43C;&#x438; &#x438; &#x458;&#x430;&#x437;&#x438;&#x447;&#x438;&#x45A;&#x430; &#x43D;&#x430; &#x43F;&#x440;&#x435;&#x43B;&#x438;&#x441;&#x442;&#x443;&#x432;&#x430;&#x447;&#x438; &#x438;&#x43B;&#x438; &#x434;&#x430; &#x43A;&#x43E;&#x440;&#x438;&#x441;&#x442;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x431;&#x440;&#x437; &#x43A;&#x43E;&#x43C;&#x43F;&#x458;&#x443;&#x442;&#x435;&#x440;.",
                  "ba-videorecorder.upload-error-duration": "&#x414;&#x43E;&#x43B;&#x436;&#x438;&#x43D;&#x430;&#x442;&#x430; &#x43D;&#x430; &#x43F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x43D;&#x43E;&#x442;&#x43E; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x43D;&#x435; &#x433;&#x438; &#x438;&#x441;&#x43F;&#x43E;&#x43B;&#x43D;&#x443;&#x432;&#x430; &#x443;&#x441;&#x43B;&#x43E;&#x432;&#x438;&#x442;&#x435; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-videorecorder.resolution-constraint-error": "&#x414;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430;&#x442;&#x430; &#x448;&#x442;&#x43E; &#x458;&#x430; &#x438;&#x437;&#x431;&#x440;&#x430;&#x432;&#x442;&#x435; &#x43D;&#x435; &#x43E;&#x434;&#x433;&#x43E;&#x432;&#x430;&#x440;&#x430; &#x43D;&#x430; &#x43F;&#x43E;&#x442;&#x440;&#x435;&#x431;&#x43D;&#x430;&#x442;&#x430; &#x440;&#x435;&#x437;&#x43E;&#x43B;&#x443;&#x446;&#x438;&#x458;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-videorecorder.orientation-portrait-required": "&#x417;&#x430;&#x432;&#x440;&#x442;&#x435;&#x442;&#x435; &#x433;&#x43E; &#x443;&#x440;&#x435;&#x434;&#x43E;&#x442; &#x437;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x45A;&#x435; &#x432;&#x43E; &#x440;&#x435;&#x436;&#x438;&#x43C; &#x43D;&#x430; &#x43F;&#x43E;&#x440;&#x442;&#x440;&#x435;&#x442;.",
                  "ba-videorecorder.orientation-landscape-required": "&#x417;&#x430;&#x432;&#x440;&#x442;&#x435;&#x442;&#x435; &#x433;&#x43E; &#x443;&#x440;&#x435;&#x434;&#x43E;&#x442; &#x437;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x45A;&#x435; &#x432;&#x43E; &#x440;&#x435;&#x436;&#x438;&#x43C; &#x43D;&#x430; &#x43F;&#x435;&#x458;&#x437;&#x430;&#x436;.",
                  "ba-imageviewer-controlbar.rerecord-image": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;?",
                  "ba-imageviewer-controlbar.submit-image": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x438;",
                  "ba-imageviewer-controlbar.fullscreen-image": "&#x412;&#x43D;&#x435;&#x441;&#x435;&#x442;&#x435; &#x446;&#x435;&#x43B; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "&#x418;&#x437;&#x43B;&#x435;&#x437;&#x435;&#x442;&#x435; &#x43E;&#x434; &#x446;&#x435;&#x43B; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-imageviewer.image-error": "&#x41D;&#x430;&#x441;&#x442;&#x430;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;, &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x441;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E; &#x43F;&#x43E;&#x434;&#x43E;&#x446;&#x43D;&#x430;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-imagecapture-chooser.image-capture": "&#x421;&#x43D;&#x438;&#x43C;&#x438; &#x441;&#x43B;&#x438;&#x43A;&#x430;",
                  "ba-imagecapture-chooser.upload-image": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435; &#x441;&#x43B;&#x438;&#x43A;&#x430;",
                  "ba-imagecapture-controlbar.settings": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x43A;&#x438;",
                  "ba-imagecapture-controlbar.camerahealthy": "&#x41E;&#x441;&#x432;&#x435;&#x442;&#x43B;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E; &#x435; &#x434;&#x43E;&#x431;&#x440;&#x43E;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "&#x41E;&#x441;&#x432;&#x435;&#x442;&#x43B;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E; &#x43D;&#x435; &#x435; &#x43E;&#x43F;&#x442;&#x438;&#x43C;&#x430;&#x43B;&#x43D;&#x43E;",
                  "ba-imagecapture-controlbar.record": "&#x424;&#x430;&#x442;&#x438;",
                  "ba-imagecapture-controlbar.record-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x438;&#x442;&#x435;.",
                  "ba-imagecapture-controlbar.rerecord": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43D;&#x430;&#x43F;&#x440;&#x430;&#x432;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-imagecapture-controlbar.cancel": "&#x41E;&#x442;&#x43A;&#x430;&#x436;&#x438;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x43E;&#x442;&#x43A;&#x430;&#x436;&#x435;&#x442;&#x435;.",
                  "ba-audioplayer-controlbar.audio-progress": "&#x41D;&#x430;&#x43F;&#x440;&#x435;&#x434;&#x43E;&#x43A;",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;?",
                  "ba-audioplayer-controlbar.submit-audio": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x438;",
                  "ba-audioplayer-controlbar.play-audio": "&#x418;&#x433;&#x440;&#x430;&#x458;",
                  "ba-audioplayer-controlbar.pause-audio": "&#x41F;&#x430;&#x443;&#x437;&#x430;",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "&#x41F;&#x430;&#x443;&#x437;&#x430;&#x442;&#x430; &#x43D;&#x435; &#x435; &#x43F;&#x43E;&#x434;&#x434;&#x440;&#x436;&#x430;&#x43D;&#x430;",
                  "ba-audioplayer-controlbar.elapsed-time": "&#x41F;&#x43E;&#x43C;&#x438;&#x43D;&#x430;&#x442;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435;",
                  "ba-audioplayer-controlbar.total-time": "&#x412;&#x43A;&#x443;&#x43F;&#x43D;&#x430; &#x434;&#x43E;&#x43B;&#x436;&#x438;&#x43D;&#x430; &#x43D;&#x430;",
                  "ba-audioplayer-controlbar.volume-button": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435; &#x458;&#x430; &#x458;&#x430;&#x447;&#x438;&#x43D;&#x430;&#x442;&#x430; &#x43D;&#x430; &#x437;&#x432;&#x443;&#x43A;&#x43E;&#x442;",
                  "ba-audioplayer-controlbar.volume-mute": "&#x41D;&#x435;&#x43C;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audioplayer-controlbar.volume-unmute": "&#x41D;&#x435;&#x43C;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audioplayer-loader.tooltip": "&#x421;&#x435; &#x432;&#x447;&#x438;&#x442;&#x443;&#x432;&#x430; ...",
                  "ba-audioplayer.audio-error": "&#x41D;&#x430;&#x441;&#x442;&#x430;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;, &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x441;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E; &#x43F;&#x43E;&#x434;&#x43E;&#x446;&#x43D;&#x430;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-audiorecorder-chooser.record-audio": "&#x421;&#x43D;&#x438;&#x43C;&#x438; &#x430;&#x443;&#x434;&#x438;&#x43E;",
                  "ba-audiorecorder-chooser.upload-audio": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435; &#x430;&#x443;&#x434;&#x438;&#x43E;",
                  "ba-audiorecorder-controlbar.settings": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x43A;&#x438;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "&#x417;&#x432;&#x443;&#x43A;&#x43E;&#x442; &#x435; &#x434;&#x43E;&#x431;&#x430;&#x440;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x430;&#x43C; &#x434;&#x430; &#x441;&#x43E;&#x431;&#x435;&#x440;&#x430;&#x43C; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audiorecorder-controlbar.record": "&#x421;&#x43D;&#x438;&#x43C;&#x438;",
                  "ba-audiorecorder-controlbar.record-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x438;&#x442;&#x435;.",
                  "ba-audiorecorder-controlbar.rerecord": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43D;&#x430;&#x43F;&#x440;&#x430;&#x432;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-audiorecorder-controlbar.stop": "&#x417;&#x430;&#x441;&#x442;&#x430;&#x43D;&#x438;",
                  "ba-audiorecorder-controlbar.stop-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x437;&#x430;&#x43F;&#x440;&#x435;&#x442;&#x435;.",
                  "ba-audiorecorder-controlbar.stop-available-after": "&#x41C;&#x438;&#x43D;&#x438;&#x43C;&#x430;&#x43B;&#x43D;&#x43E;&#x442;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435; &#x43D;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x45A;&#x435; &#x435; %d &#x441;&#x435;&#x43A;&#x443;&#x43D;&#x434;&#x438;",
                  "ba-audiorecorder-controlbar.cancel": "&#x41E;&#x442;&#x43A;&#x430;&#x436;&#x438;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x43E;&#x442;&#x43A;&#x430;&#x436;&#x435;&#x442;&#x435;.",
                  "ba-videoplayer-controlbar.player-speed": "&#x411;&#x440;&#x437;&#x438;&#x43D;&#x430; &#x43D;&#x430; &#x43F;&#x43B;&#x435;&#x435;&#x440;&#x43E;&#x442;",
                  "ba-videoplayer-controlbar.settings": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x43A;&#x438;",
                  "ba-videoplayer-controlbar.airplay": "&#x412;&#x43E;&#x437;&#x434;&#x443;&#x448;&#x43D;&#x430; &#x438;&#x433;&#x440;&#x430;",
                  "ba-videoplayer-controlbar.airplay-icon": "&#x418;&#x43A;&#x43E;&#x43D;&#x430; &#x437;&#x430; &#x432;&#x43E;&#x437;&#x434;&#x443;&#x448;&#x43D;&#x430; &#x438;&#x433;&#x440;&#x430;.",
                  "ba-videoplayer.all-settings": "&#x421;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x43A;&#x438;",
                  "ba-videoplayer.player-speed": "&#x411;&#x440;&#x437;&#x438;&#x43D;&#x430; &#x43D;&#x430; &#x43F;&#x43B;&#x435;&#x435;&#x440;&#x43E;&#x442;",
                  "ba-videoplayer.full-screen": "&#x426;&#x435;&#x43B; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-videorecorder-controlbar.add-stream": "&#x414;&#x43E;&#x434;&#x430;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x442;&#x43E;&#x43A;",
                  "ba-videorecorder.switch-camera": "&#x41F;&#x440;&#x435;&#x444;&#x440;&#x43B;&#x435;&#x442;&#x435; &#x458;&#x430; &#x43A;&#x430;&#x43C;&#x435;&#x440;&#x430;&#x442;&#x430;",
                  "ba-videorecorder.prepare-covershot": "&#x41F;&#x43E;&#x434;&#x433;&#x43E;&#x442;&#x432;&#x443;&#x432;&#x430;&#x45A;&#x435; &#x43F;&#x43E;&#x43A;&#x440;&#x438;&#x432;&#x43A;&#x438;",
                  "ba-videorecorder.prepare-thumbnails": "&#x421;&#x435; &#x43F;&#x43E;&#x434;&#x433;&#x43E;&#x442;&#x432;&#x443;&#x432;&#x430; &#x431;&#x430;&#x440;&#x430;&#x45A;&#x435; &#x43D;&#x430; &#x441;&#x43B;&#x438;&#x43A;&#x438;&#x447;&#x43A;&#x438;",
                  "ba-videorecorder.adding-new-stream": "&#x414;&#x43E;&#x434;&#x430;&#x432;&#x430;&#x45A;&#x435; &#x43D;&#x43E;&#x432; &#x442;&#x435;&#x43A;",
                  "ba-imagecapture.recorder-error": "&#x41D;&#x430;&#x441;&#x442;&#x430;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;, &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x441;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E; &#x43F;&#x43E;&#x434;&#x43E;&#x446;&#x43D;&#x430;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-imagecapture.attach-error": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x432;&#x43C;&#x435; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x43C;&#x435; &#x434;&#x43E; &#x43C;&#x435;&#x434;&#x438;&#x443;&#x43C;&#x441;&#x43A;&#x438;&#x43E;&#x442; &#x438;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x458;&#x441;. &#x412;&#x43E; &#x437;&#x430;&#x432;&#x438;&#x441;&#x43D;&#x43E;&#x441;&#x442; &#x43E;&#x434; &#x443;&#x440;&#x435;&#x434;&#x43E;&#x442; &#x438; &#x43F;&#x440;&#x435;&#x43B;&#x438;&#x441;&#x442;&#x443;&#x432;&#x430;&#x447;&#x43E;&#x442;, &#x43C;&#x43E;&#x436;&#x435;&#x431;&#x438; &#x45C;&#x435; &#x442;&#x440;&#x435;&#x431;&#x430; &#x434;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; Flash &#x438;&#x43B;&#x438; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x442;&#x435; &#x43D;&#x430; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430; &#x43F;&#x440;&#x435;&#x43A;&#x443; SSL.",
                  "ba-imagecapture.software-required": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x434;&#x43E;&#x43B;&#x443; &#x437;&#x430; &#x434;&#x430; &#x433;&#x438; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x442;&#x435; &#x441;&#x43B;&#x435;&#x434;&#x43D;&#x438;&#x432;&#x435; &#x431;&#x430;&#x440;&#x430;&#x45A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x434;&#x43E;&#x43B;&#x436;&#x438;&#x442;&#x435;.",
                  "ba-imagecapture.software-waiting": "&#x427;&#x435;&#x43A;&#x430;&#x458;&#x45C;&#x438; &#x434;&#x430; &#x441;&#x435; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x430;&#x442; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x430;&#x442; &#x431;&#x430;&#x440;&#x430;&#x45A;&#x430;&#x442;&#x430;. &#x41C;&#x43E;&#x436;&#x435;&#x431;&#x438; &#x45C;&#x435; &#x442;&#x440;&#x435;&#x431;&#x430; &#x434;&#x430; &#x458;&#x430; &#x43E;&#x441;&#x432;&#x435;&#x436;&#x438;&#x442;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430; &#x43F;&#x43E; &#x437;&#x430;&#x432;&#x440;&#x448;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E;.",
                  "ba-imagecapture.access-forbidden": "&#x417;&#x430;&#x431;&#x440;&#x430;&#x43D;&#x435;&#x442; &#x435; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x43E;&#x442; &#x434;&#x43E; &#x43C;&#x435;&#x434;&#x438;&#x443;&#x43C;&#x438;&#x442;&#x435;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-imagecapture.uploading": "&#x421;&#x435; &#x43F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x443;&#x432;&#x430;",
                  "ba-imagecapture.uploading-failed": "&#x412;&#x447;&#x438;&#x442;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E; &#x43D;&#x435; &#x443;&#x441;&#x43F;&#x435;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-imagecapture.upload-error-duration": "&#x414;&#x43E;&#x43B;&#x436;&#x438;&#x43D;&#x430;&#x442;&#x430; &#x43D;&#x430; &#x43F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x43D;&#x430;&#x442;&#x430; &#x441;&#x43B;&#x438;&#x43A;&#x430; &#x43D;&#x435; &#x433;&#x438; &#x438;&#x441;&#x43F;&#x43E;&#x43B;&#x43D;&#x443;&#x432;&#x430; &#x443;&#x441;&#x43B;&#x43E;&#x432;&#x438;&#x442;&#x435; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-imagecapture.resolution-constraint-error": "&#x414;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430;&#x442;&#x430; &#x448;&#x442;&#x43E; &#x458;&#x430; &#x438;&#x437;&#x431;&#x440;&#x430;&#x432;&#x442;&#x435; &#x43D;&#x435; &#x43E;&#x434;&#x433;&#x43E;&#x432;&#x430;&#x440;&#x430; &#x43D;&#x430; &#x43F;&#x43E;&#x442;&#x440;&#x435;&#x431;&#x43D;&#x430;&#x442;&#x430; &#x440;&#x435;&#x437;&#x43E;&#x43B;&#x443;&#x446;&#x438;&#x458;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-imagecapture.verifying": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x443;&#x432;&#x430;&#x45A;&#x435;",
                  "ba-imagecapture.verifying-failed": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x430;&#x442;&#x430; &#x43D;&#x435; &#x443;&#x441;&#x43F;&#x435;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-imagecapture.rerecord-confirm": "&#x414;&#x430;&#x43B;&#x438; &#x43D;&#x430;&#x432;&#x438;&#x441;&#x442;&#x438;&#x43D;&#x430; &#x441;&#x430;&#x43A;&#x430;&#x442;&#x435; &#x434;&#x430; &#x458;&#x430; &#x43F;&#x43E;&#x432;&#x440;&#x430;&#x442;&#x438;&#x442;&#x435; &#x432;&#x430;&#x448;&#x430;&#x442;&#x430; &#x441;&#x43B;&#x438;&#x43A;&#x430;?",
                  "ba-imagecapture.image_file_too_large": "&#x412;&#x430;&#x448;&#x430;&#x442;&#x430; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430; &#x441;&#x43E; &#x441;&#x43B;&#x438;&#x43A;&#x430; &#x435; &#x43F;&#x440;&#x435;&#x433;&#x43E;&#x43B;&#x435;&#x43C;&#x430; (%s) - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E; &#x441;&#x43E; &#x43F;&#x43E;&#x43C;&#x430;&#x43B;&#x430; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430; &#x441;&#x43E; &#x441;&#x43B;&#x438;&#x43A;&#x430;.",
                  "ba-imagecapture.unsupported_image_type": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435;: %s - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-imagecapture.orientation-portrait-required": "&#x417;&#x430;&#x432;&#x440;&#x442;&#x435;&#x442;&#x435; &#x433;&#x43E; &#x443;&#x440;&#x435;&#x434;&#x43E;&#x442; &#x437;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x45A;&#x435; &#x432;&#x43E; &#x440;&#x435;&#x436;&#x438;&#x43C; &#x43D;&#x430; &#x43F;&#x43E;&#x440;&#x442;&#x440;&#x435;&#x442;.",
                  "ba-imagecapture.orientation-landscape-required": "&#x417;&#x430;&#x432;&#x440;&#x442;&#x435;&#x442;&#x435; &#x433;&#x43E; &#x443;&#x440;&#x435;&#x434;&#x43E;&#x442; &#x437;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x45A;&#x435; &#x432;&#x43E; &#x440;&#x435;&#x436;&#x438;&#x43C; &#x43D;&#x430; &#x43F;&#x435;&#x458;&#x437;&#x430;&#x436;.",
                  "ba-audiorecorder.recorder-error": "&#x41D;&#x430;&#x441;&#x442;&#x430;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;, &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x441;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E; &#x43F;&#x43E;&#x434;&#x43E;&#x446;&#x43D;&#x430;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-audiorecorder.attach-error": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x432;&#x43C;&#x435; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x43C;&#x435; &#x434;&#x43E; &#x43C;&#x435;&#x434;&#x438;&#x443;&#x43C;&#x441;&#x43A;&#x438;&#x43E;&#x442; &#x438;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x458;&#x441;. &#x412;&#x43E; &#x437;&#x430;&#x432;&#x438;&#x441;&#x43D;&#x43E;&#x441;&#x442; &#x43E;&#x434; &#x443;&#x440;&#x435;&#x434;&#x43E;&#x442; &#x438; &#x43F;&#x440;&#x435;&#x43B;&#x438;&#x441;&#x442;&#x443;&#x432;&#x430;&#x447;&#x43E;&#x442;, &#x43C;&#x43E;&#x436;&#x435;&#x431;&#x438; &#x45C;&#x435; &#x442;&#x440;&#x435;&#x431;&#x430; &#x434;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; Flash &#x438;&#x43B;&#x438; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x442;&#x435; &#x43D;&#x430; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430; &#x43F;&#x440;&#x435;&#x43A;&#x443; SSL.",
                  "ba-audiorecorder.software-required": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x434;&#x43E;&#x43B;&#x443; &#x437;&#x430; &#x434;&#x430; &#x433;&#x438; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x442;&#x435; &#x441;&#x43B;&#x435;&#x434;&#x43D;&#x438;&#x432;&#x435; &#x431;&#x430;&#x440;&#x430;&#x45A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x434;&#x43E;&#x43B;&#x436;&#x438;&#x442;&#x435;.",
                  "ba-audiorecorder.software-waiting": "&#x427;&#x435;&#x43A;&#x430;&#x458;&#x45C;&#x438; &#x434;&#x430; &#x441;&#x435; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x430;&#x442; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x430;&#x442; &#x431;&#x430;&#x440;&#x430;&#x45A;&#x430;&#x442;&#x430;. &#x41C;&#x43E;&#x436;&#x435;&#x431;&#x438; &#x45C;&#x435; &#x442;&#x440;&#x435;&#x431;&#x430; &#x434;&#x430; &#x458;&#x430; &#x43E;&#x441;&#x432;&#x435;&#x436;&#x438;&#x442;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430; &#x43F;&#x43E; &#x437;&#x430;&#x432;&#x440;&#x448;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E;.",
                  "ba-audiorecorder.access-forbidden": "&#x417;&#x430;&#x431;&#x440;&#x430;&#x43D;&#x435;&#x442; &#x435; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x43E;&#x442; &#x434;&#x43E; &#x43C;&#x435;&#x434;&#x438;&#x443;&#x43C;&#x438;&#x442;&#x435;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x437;&#x430; &#x434;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-audiorecorder.uploading": "&#x421;&#x435; &#x43F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x443;&#x432;&#x430;",
                  "ba-audiorecorder.uploading-failed": "&#x412;&#x447;&#x438;&#x442;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E; &#x43D;&#x435; &#x443;&#x441;&#x43F;&#x435;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-audiorecorder.upload-error-duration": "&#x414;&#x43E;&#x43B;&#x436;&#x438;&#x43D;&#x430;&#x442;&#x430; &#x43D;&#x430; &#x43F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x43D;&#x43E;&#x442;&#x43E; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x43D;&#x435; &#x433;&#x438; &#x438;&#x441;&#x43F;&#x43E;&#x43B;&#x43D;&#x443;&#x432;&#x430; &#x443;&#x441;&#x43B;&#x43E;&#x432;&#x438;&#x442;&#x435; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-audiorecorder.verifying": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x443;&#x432;&#x430;&#x45A;&#x435;",
                  "ba-audiorecorder.verifying-failed": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x430;&#x442;&#x430; &#x43D;&#x435; &#x443;&#x441;&#x43F;&#x435;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-audiorecorder.rerecord-confirm": "&#x414;&#x430;&#x43B;&#x438; &#x43D;&#x430;&#x432;&#x438;&#x441;&#x442;&#x438;&#x43D;&#x430; &#x441;&#x430;&#x43A;&#x430;&#x442;&#x435; &#x434;&#x430; &#x433;&#x43E; &#x43D;&#x430;&#x43F;&#x440;&#x430;&#x432;&#x438;&#x442;&#x435; &#x432;&#x430;&#x448;&#x435;&#x442;&#x43E; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x43F;&#x43E;&#x440;&#x430;&#x43A;&#x430;?",
                  "ba-audiorecorder.cancel-confirm": "&#x414;&#x430;&#x43B;&#x438; &#x43D;&#x430;&#x432;&#x438;&#x441;&#x442;&#x438;&#x43D;&#x430; &#x441;&#x430;&#x43A;&#x430;&#x442;&#x435; &#x434;&#x430; &#x433;&#x43E; &#x43E;&#x442;&#x43A;&#x430;&#x436;&#x435;&#x442;&#x435; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x43F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E;?",
                  "ba-audiorecorder.audio_file_too_large": "&#x412;&#x430;&#x448;&#x430;&#x442;&#x430; &#x430;&#x443;&#x434;&#x438;&#x43E;-&#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430; &#x435; &#x43F;&#x440;&#x435;&#x433;&#x43E;&#x43B;&#x435;&#x43C;&#x430; (%s) - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x438;&#x434;&#x435;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E; &#x441;&#x43E; &#x43F;&#x43E;&#x43C;&#x430;&#x43B;&#x430; &#x430;&#x443;&#x434;&#x438;&#x43E;-&#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430;.",
                  "ba-audiorecorder.unsupported_audio_type": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435;: %s - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x442;&#x443;&#x43A;&#x430; &#x437;&#x430; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E;.",
                  "ba-common-settingsmenu.tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x437;&#x430; &#x434;&#x430; &#x438;&#x433;&#x440;&#x430;&#x442;&#x435;.",
                  "ba-common-settingsmenu.setting-menu": "&#x421;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x43A;&#x438;",
                  "ba-common-settingsmenu.source-quality": "&#x41A;&#x432;&#x430;&#x43B;&#x438;&#x442;&#x435;&#x442; &#x43D;&#x430; &#x438;&#x437;&#x432;&#x43E;&#x440;&#x43E;&#x442;",
                  "ba-common-settingsmenu.player-speed": "&#x411;&#x440;&#x437;&#x438;&#x43D;&#x430; &#x43D;&#x430; &#x43F;&#x43B;&#x435;&#x435;&#x440;&#x43E;&#x442;",
                  "ba-common-settingsmenu.set-menu-option": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435; &#x43E;&#x43F;&#x446;&#x438;&#x458;&#x430;",
                  "ba-common-settingsmenu.submit-video": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x435;&#x442;&#x435; &#x433;&#x43E; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x442;&#x43E;",
                  "ba-common-settingsmenu.picture-in-picture": "&#x421;&#x43B;&#x438;&#x43A;&#x430; &#x43D;&#x430; &#x441;&#x43B;&#x438;&#x43A;&#x430;",
                  "ba-common-settingsmenu.exit-fullscreen-video": "&#x418;&#x437;&#x43B;&#x435;&#x437;&#x435;&#x442;&#x435; &#x43E;&#x434; &#x446;&#x435;&#x43B; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-common-settingsmenu.fullscreen-video": "&#x412;&#x43D;&#x435;&#x441;&#x435;&#x442;&#x435; &#x446;&#x435;&#x43B; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-videorecorder-chooser.multi-stream": "&#x41C;&#x443;&#x43B;&#x442;&#x438;-&#x43F;&#x43E;&#x442;&#x43E;&#x43A;",
                  "ba-videorecorder-controlbar.pause-recorder": "&#x41F;&#x430;&#x443;&#x437;&#x430; &#x43D;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x447;&#x43E;&#x442;",
                  "ba-videorecorder-controlbar.resume-recorder": "&#x41F;&#x440;&#x43E;&#x434;&#x43E;&#x43B;&#x436;&#x438; &#x420;&#x435;&#x43A;&#x43E;&#x440;&#x434;&#x435;&#x440;",
                  "ba-videorecorder.missing-track": "&#x41D;&#x435;&#x434;&#x43E;&#x441;&#x442;&#x430;&#x441;&#x443;&#x432;&#x430; &#x43F;&#x43E;&#x442;&#x440;&#x435;&#x431;&#x43D;&#x430;&#x442;&#x430; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x438;&#x43B;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E;-&#x442;&#x440;&#x430;&#x43A;&#x430;",
                  "ba-videorecorder.device-already-in-use": "&#x411;&#x430;&#x440;&#x435;&#x43C; &#x435;&#x434;&#x435;&#x43D; &#x43E;&#x434; &#x432;&#x430;&#x448;&#x438;&#x442;&#x435; &#x432;&#x43B;&#x435;&#x437;&#x43D;&#x438; &#x443;&#x440;&#x435;&#x434;&#x438; &#x432;&#x435;&#x45C;&#x435; &#x441;&#x435; &#x43A;&#x43E;&#x440;&#x438;&#x441;&#x442;&#x438;",
                  "ba-videorecorder.browser-permission-denied": "&#x414;&#x43E;&#x437;&#x432;&#x43E;&#x43B;&#x430;&#x442;&#x430; &#x435; &#x43E;&#x434;&#x431;&#x438;&#x435;&#x43D;&#x430; &#x43E;&#x434; &#x43F;&#x440;&#x435;&#x43B;&#x438;&#x441;&#x442;&#x443;&#x432;&#x430;&#x447;&#x43E;&#x442;, &#x434;&#x43E;&#x434;&#x435;&#x43B;&#x435;&#x442;&#x435; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F; &#x438; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x43D;&#x43E; &#x432;&#x447;&#x438;&#x442;&#x430;&#x458;&#x442;&#x435; &#x458;&#x430; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;&#x442;&#x430;",
                  "ba-audioplayer.all-settings": "&#x421;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x43A;&#x438;",
                  "ba-videoplayer-controlbar.remaining-time": "&#x41F;&#x440;&#x435;&#x43E;&#x441;&#x442;&#x430;&#x43D;&#x430;&#x442;&#x43E;&#x442;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435;",
                  "ba-videoplayer-controlbar.select-frame": "&#x418;&#x437;&#x431;&#x435;&#x440;&#x435;&#x442;&#x435;",
                  "ba-videoplayer-controlbar.trim-video": "&#x41D;&#x430;&#x43C;&#x430;&#x43B;&#x438;",
                  "ba-videoplayer-playbutton.trim": "&#x41D;&#x430;&#x43C;&#x430;&#x43B;&#x438;",
                  "ba-videoplayer-playbutton.skip": "&#x41F;&#x440;&#x435;&#x441;&#x43A;&#x43E;&#x43A;&#x43D;&#x438;",
                  "ba-videorecorder-imagegallery.upload-covershot": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x435;&#x442;&#x435; &#x43A;&#x43E;&#x440;&#x438;&#x446;&#x430;",
                  "ba-videorecorder.pick-covershot-frame": "&#x418;&#x437;&#x431;&#x435;&#x440;&#x435;&#x442;&#x435; &#x440;&#x430;&#x43C;&#x43A;&#x430; &#x448;&#x442;&#x43E; &#x45C;&#x435; &#x458;&#x430; &#x43A;&#x43E;&#x440;&#x438;&#x441;&#x442;&#x438;&#x442;&#x435; &#x43A;&#x430;&#x43A;&#x43E; &#x43F;&#x43E;&#x43A;&#x440;&#x438;&#x432;&#x43A;&#x430;.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "&#x421;&#x43D;&#x438;&#x43C;&#x430;&#x447;&#x43E;&#x442; &#x43D;&#x430; &#x435;&#x43A;&#x440;&#x430;&#x43D;&#x43E;&#x442; &#x43D;&#x435; &#x435; &#x43F;&#x43E;&#x434;&#x434;&#x440;&#x436;&#x430;&#x43D; &#x43D;&#x430; &#x43E;&#x432;&#x43E;&#x458; &#x443;&#x440;&#x435;&#x434;",
                  "ba-videorecorder.trim-prompt": "&#x414;&#x430;&#x43B;&#x438; &#x441;&#x430;&#x43A;&#x430;&#x442;&#x435; &#x434;&#x430; &#x433;&#x43E; &#x438;&#x441;&#x435;&#x447;&#x435;&#x442;&#x435; &#x432;&#x430;&#x448;&#x435;&#x442;&#x43E; &#x432;&#x438;&#x434;&#x435;&#x43E;?",
                  "ba-videorecorder.trim-video": "&#x41F;&#x43E;&#x43C;&#x435;&#x441;&#x442;&#x435;&#x442;&#x435; &#x433;&#x438; &#x43E;&#x437;&#x43D;&#x430;&#x43A;&#x438;&#x442;&#x435; &#x437;&#x430; &#x43F;&#x43E;&#x447;&#x435;&#x442;&#x43E;&#x43A; &#x438; &#x43A;&#x440;&#x430;&#x458; &#x437;&#x430; &#x434;&#x430; &#x433;&#x43E; &#x438;&#x441;&#x435;&#x447;&#x435;&#x442;&#x435; &#x432;&#x430;&#x448;&#x435;&#x442;&#x43E; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder.wait-for-trim": "&#x421;&#x435; &#x447;&#x435;&#x43A;&#x430; &#x43A;&#x43E;&#x43C;&#x430;&#x43D;&#x434;&#x430;&#x442;&#x430; &#x437;&#x430; &#x442;&#x440;&#x438;&#x43C; ...",
                  "ba-videorecorder-controlbar.no-video-source": "&#x41D;&#x435;&#x434;&#x43E;&#x441;&#x442;&#x430;&#x441;&#x443;&#x432;&#x430; &#x434;&#x43E;&#x43F;&#x43E;&#x43B;&#x43D;&#x438;&#x442;&#x435;&#x43B;&#x435;&#x43D; &#x438;&#x437;&#x432;&#x43E;&#x440; &#x437;&#x430; &#x432;&#x43D;&#x435;&#x441;&#x443;&#x432;&#x430;&#x45A;&#x435; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x414;&#x43E;&#x43F;&#x43E;&#x43B;&#x43D;&#x438;&#x442;&#x435;&#x43B;&#x435;&#x43D; &#x442;&#x435;&#x43A; &#x432;&#x435;&#x45C;&#x435; &#x435; &#x438;&#x437;&#x431;&#x440;&#x430;&#x43D;",
                  "ba-videorecorder.uploading-src-error": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x441;&#x435; &#x440;&#x435;&#x43F;&#x440;&#x43E;&#x434;&#x443;&#x446;&#x438;&#x440;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x441;&#x435;&#x433;&#x430;, &#x43F;&#x440;&#x438;&#x43A;&#x430;&#x447;&#x443;&#x432;&#x430;&#x45A;&#x435;&#x442;&#x43E; &#x435; &#x441;&#x435;&#x443;&#x448;&#x442;&#x435; &#x432;&#x43E; &#x442;&#x435;&#x43A;",
                  "ba-audiorecorder-controlbar.pause-recorder": "&#x41F;&#x430;&#x443;&#x437;&#x438;&#x440;&#x430;&#x458;&#x442;&#x435; &#x433;&#x43E; &#x440;&#x435;&#x43A;&#x43E;&#x440;&#x434;&#x435;&#x440;&#x43E;&#x442;",
                  "ba-audiorecorder-controlbar.resume-recorder": "&#x420;&#x435;&#x437;&#x438;&#x43C;&#x435; &#x43D;&#x430; &#x440;&#x435;&#x437;&#x438;&#x43C;&#x435;"
                },
                "language:nl": {
                  "ba-videoplayer-playbutton.tooltip": "Klik om video af te spelen.",
                  "ba-videoplayer-playbutton.rerecord": "Opnieuw",
                  "ba-videoplayer-playbutton.submit-video": "Bevestigen",
                  "ba-videoplayer-loader.tooltip": "Laden...",
                  "ba-videoplayer-controlbar.change-resolution": "Resolutie veranderen",
                  "ba-videoplayer-controlbar.video-progress": "Vooruitgang",
                  "ba-videoplayer-controlbar.rerecord-video": "Opnieuw opnemen?",
                  "ba-videoplayer-controlbar.submit-video": "Bevestigen",
                  "ba-videoplayer-controlbar.play-video": "Afspelen",
                  "ba-videoplayer-controlbar.pause-video": "Pauze",
                  "ba-videoplayer-controlbar.elapsed-time": "Verstreken tijd",
                  "ba-videoplayer-controlbar.total-time": "De totale lengte van de video",
                  "ba-videoplayer-controlbar.fullscreen-video": "Volledig scherm",
                  "ba-videoplayer-controlbar.volume-button": "Volume instellen",
                  "ba-videoplayer-controlbar.volume-mute": "Geluid dempen",
                  "ba-videoplayer-controlbar.volume-unmute": "Geluid inschakelen",
                  "ba-videoplayer.video-error": "Er is een fout opgetreden, probeer het later opnieuw. Klik hier om opnieuw te proberen.",
                  "ba-videorecorder-chooser.record-video": "Video opnemen",
                  "ba-videorecorder-chooser.upload-video": "Video uploaden",
                  "ba-videorecorder-controlbar.settings": "Instellingen",
                  "ba-videorecorder-controlbar.camerahealthy": "Verlichting is goed",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Verlichting is niet optimaal",
                  "ba-videorecorder-controlbar.microphonehealthy": "Het geluid is goed",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Geluid is niet optimaal",
                  "ba-videorecorder-controlbar.record": "Opnemen",
                  "ba-videorecorder-controlbar.record-tooltip": "Klik hier om te registreren.",
                  "ba-videorecorder-controlbar.rerecord": "Opnieuw opnemen",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Opnieuw opnemen",
                  "ba-videorecorder-controlbar.upload-covershot": "Video uploaden",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Klik hier om je aangepaste cover te uploaden",
                  "ba-videorecorder-controlbar.stop": "Stop",
                  "ba-videorecorder-controlbar.stop-tooltip": "Klik hier om te stoppen.",
                  "ba-videorecorder-controlbar.skip": "Overslaan",
                  "ba-videorecorder-controlbar.skip-tooltip": "Klik hier om over te slaan.",
                  "ba-videorecorder.recorder-error": "Er is een fout opgetreden, probeer het later opnieuw. Klik hier om opnieuw te proberen.",
                  "ba-videorecorder.attach-error": "We konden geen toegang krijgen tot de camera. Afhankelijk van het apparaat en de browser, moet u misschien Flash installeren of toegang tot de pagina via SSL.",
                  "ba-videorecorder.access-forbidden": "De toegang tot de camera was verboden. Klik hier om opnieuw te proberen.",
                  "ba-videorecorder.pick-covershot": "Kies een covershot.",
                  "ba-videorecorder.uploading": "Uploaden",
                  "ba-videorecorder.uploading-failed": "Uploaden mislukt - klik hier om opnieuw te proberen.",
                  "ba-videorecorder.verifying": "Verifi&#xEB;ren",
                  "ba-videorecorder.verifying-failed": "Verificatie mislukt - klik hier om opnieuw te proberen.",
                  "ba-videorecorder.rerecord-confirm": "Wil je echt je video opnieuw opnemen?",
                  "ba-videorecorder.video_file_too_large": "Uw video bestand is te groot (%s) - klik hier om opnieuw te proberen met een kleiner bestand.",
                  "ba-videorecorder.unsupported_video_type": "Upload: %s - klik hier om opnieuw te proberen.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Verlaat volledig scherm",
                  "ba-videoplayer-share.share": "Video Helen",
                  "ba-videorecorder-chooser.record-screen": "Scherm opnemen",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pauzeren niet ondersteund",
                  "ba-videorecorder-chooser.record-audio": "Geluid opnemen",
                  "ba-videorecorder-controlbar.stop-available-after": "Minimale opnametijd is %d seconden",
                  "ba-videorecorder-controlbar.cancel": "Annuleren",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Klik hier om te annuleren.",
                  "ba-videorecorder.cancel-confirm": "Wil je je upload echt annuleren?",
                  "ba-videoplayer-adslot.elapsed-time": "Verstreken tijd",
                  "ba-videoplayer-adslot.volume-button": "Volume",
                  "ba-videoplayer-adslot.volume-mute": "Geluid dempen",
                  "ba-videoplayer-adslot.volume-unmute": "Geluid inschakelen",
                  "ba-videoplayer-adslot.ad-will-end-after": "Advertentie eindigt na %s",
                  "ba-videoplayer-adslot.can-skip-after": "Skip na %d",
                  "ba-videoplayer-adslot.skip-ad": "Advertentie overslaan",
                  "ba-videorecorder.software-required": "Klik hieronder om de volgende vereisten te installeren / activeren om door te gaan.",
                  "ba-videorecorder.software-waiting": "Wacht tot de vereisten zijn ge&#xEF;nstalleerd / geactiveerd. Mogelijk moet u de pagina na voltooiing vernieuwen.",
                  "ba-videoplayer-controlbar.close-tracks": "Sluit CC",
                  "ba-videoplayer-controlbar.show-tracks": "Toon CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Uploadtekstbestanden uploaden",
                  "ba-videoplayer-tracks.select-text-track-language": "Taal ondertitels",
                  "ba-videoplayer-tracks.info-select-locale-first": "Selecteer eerst locale",
                  "ba-videoplayer-tracks.select-text-track-file": "Klik om bestand te selecteren",
                  "ba-videoplayer-tracks.back": "terug",
                  "ba-videorecorder.framerate-warning": "De videoframesnelheid is erg laag. We raden aan om alle andere programma&#x27;s en browsertabs te sluiten of om een &#x200B;&#x200B;snellere computer te gebruiken.",
                  "ba-videorecorder.upload-error-duration": "De lengte van de ge&#xFC;ploade video voldoet niet aan de vereisten. Klik hier om opnieuw te proberen.",
                  "ba-videorecorder.resolution-constraint-error": "Het bestand dat je hebt geselecteerd komt niet overeen met de vereiste resolutie - klik hier om het opnieuw te proberen.",
                  "ba-videorecorder.orientation-portrait-required": "Draai uw apparaat om op te nemen in staande modus.",
                  "ba-videorecorder.orientation-landscape-required": "Draai je apparaat om in de liggende modus op te nemen.",
                  "ba-imageviewer-controlbar.rerecord-image": "Opnieuw doen?",
                  "ba-imageviewer-controlbar.submit-image": "Bevestigen",
                  "ba-imageviewer-controlbar.fullscreen-image": "Voer het volledige scherm in",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Verlaat volledig scherm",
                  "ba-imageviewer.image-error": "Er is een fout opgetreden. Probeer het later opnieuw. Klik om opnieuw te proberen.",
                  "ba-imagecapture-chooser.image-capture": "Capture Image",
                  "ba-imagecapture-chooser.upload-image": "Afbeelding uploaden",
                  "ba-imagecapture-controlbar.settings": "instellingen",
                  "ba-imagecapture-controlbar.camerahealthy": "Verlichting is goed",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Verlichting is niet optimaal",
                  "ba-imagecapture-controlbar.record": "Gevangen nemen",
                  "ba-imagecapture-controlbar.record-tooltip": "Klik hier om vast te leggen.",
                  "ba-imagecapture-controlbar.rerecord": "Opnieuw doen",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Klik hier om opnieuw te doen.",
                  "ba-imagecapture-controlbar.cancel": "Annuleer",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Klik hier om te annuleren.",
                  "ba-audioplayer-controlbar.audio-progress": "Vooruitgang",
                  "ba-audioplayer-controlbar.rerecord-audio": "Opnieuw doen?",
                  "ba-audioplayer-controlbar.submit-audio": "Bevestigen",
                  "ba-audioplayer-controlbar.play-audio": "Spelen",
                  "ba-audioplayer-controlbar.pause-audio": "Pauze",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pauzeren niet ondersteund",
                  "ba-audioplayer-controlbar.elapsed-time": "Verstreken tijd",
                  "ba-audioplayer-controlbar.total-time": "Totale lengte van",
                  "ba-audioplayer-controlbar.volume-button": "Volume instellen",
                  "ba-audioplayer-controlbar.volume-mute": "Geluid dempen",
                  "ba-audioplayer-controlbar.volume-unmute": "Geluid dempen",
                  "ba-audioplayer-loader.tooltip": "Bezig met laden...",
                  "ba-audioplayer.audio-error": "Er is een fout opgetreden. Probeer het later opnieuw. Klik om opnieuw te proberen.",
                  "ba-audiorecorder-chooser.record-audio": "Geluid opnemen",
                  "ba-audiorecorder-chooser.upload-audio": "Upload audio",
                  "ba-audiorecorder-controlbar.settings": "instellingen",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Geluid is goed",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Kan geen geluid oppikken",
                  "ba-audiorecorder-controlbar.record": "Record",
                  "ba-audiorecorder-controlbar.record-tooltip": "Klik hier om op te nemen.",
                  "ba-audiorecorder-controlbar.rerecord": "Opnieuw doen",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Klik hier om opnieuw te doen.",
                  "ba-audiorecorder-controlbar.stop": "Hou op",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Klik hier om te stoppen.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Minimale opnametijd is %d seconden",
                  "ba-audiorecorder-controlbar.cancel": "Annuleer",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Klik hier om te annuleren.",
                  "ba-videoplayer-controlbar.player-speed": "Snelheid van de speler",
                  "ba-videoplayer-controlbar.settings": "instellingen",
                  "ba-videoplayer-controlbar.airplay": "airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay-pictogram.",
                  "ba-videoplayer.all-settings": "Alle instellingen",
                  "ba-videoplayer.player-speed": "Snelheid van de speler",
                  "ba-videoplayer.full-screen": "Volledig scherm",
                  "ba-videorecorder-controlbar.add-stream": "Stream toevoegen",
                  "ba-videorecorder.switch-camera": "Schakel camera",
                  "ba-videorecorder.prepare-covershot": "Dekkinghots voorbereiden",
                  "ba-videorecorder.prepare-thumbnails": "Voorbereiden op het zoeken naar miniaturen",
                  "ba-videorecorder.adding-new-stream": "Nieuwe stream toevoegen",
                  "ba-imagecapture.recorder-error": "Er is een fout opgetreden. Probeer het later opnieuw. Klik om opnieuw te proberen.",
                  "ba-imagecapture.attach-error": "We hadden geen toegang tot de media-interface. Afhankelijk van het apparaat en de browser, moet u mogelijk Flash installeren of de pagina openen via SSL.",
                  "ba-imagecapture.software-required": "Klik hieronder om de volgende vereisten te installeren / activeren om door te gaan.",
                  "ba-imagecapture.software-waiting": "Wacht tot de vereisten zijn ge&#xEF;nstalleerd / geactiveerd. Mogelijk moet u de pagina na voltooiing vernieuwen.",
                  "ba-imagecapture.access-forbidden": "Toegang tot de media was verboden. Klik om opnieuw te proberen.",
                  "ba-imagecapture.uploading": "uploaden",
                  "ba-imagecapture.uploading-failed": "Uploaden mislukt - klik hier om het opnieuw te proberen.",
                  "ba-imagecapture.upload-error-duration": "De lengte van de ge&#xFC;ploade afbeelding voldoet niet aan de vereisten. Klik hier om opnieuw te proberen.",
                  "ba-imagecapture.resolution-constraint-error": "Het bestand dat u heeft geselecteerd komt niet overeen met de vereiste resolutie - klik hier om het opnieuw te proberen.",
                  "ba-imagecapture.verifying": "Het verifi&#xEB;ren",
                  "ba-imagecapture.verifying-failed": "Verifi&#xEB;ren mislukt - klik hier om het opnieuw te proberen.",
                  "ba-imagecapture.rerecord-confirm": "Wil je echt je foto opnieuw maken?",
                  "ba-imagecapture.image_file_too_large": "Uw afbeeldingsbestand is te groot (%s) - klik hier om het opnieuw te proberen met een kleiner afbeeldingsbestand.",
                  "ba-imagecapture.unsupported_image_type": "Upload alstublieft: %s - klik hier om het opnieuw te proberen.",
                  "ba-imagecapture.orientation-portrait-required": "Draai uw apparaat om op te nemen in staande modus.",
                  "ba-imagecapture.orientation-landscape-required": "Draai je apparaat om op te nemen in liggende modus.",
                  "ba-audiorecorder.recorder-error": "Er is een fout opgetreden. Probeer het later opnieuw. Klik om opnieuw te proberen.",
                  "ba-audiorecorder.attach-error": "We hadden geen toegang tot de media-interface. Afhankelijk van het apparaat en de browser, moet u mogelijk Flash installeren of de pagina openen via SSL.",
                  "ba-audiorecorder.software-required": "Klik hieronder om de volgende vereisten te installeren / activeren om door te gaan.",
                  "ba-audiorecorder.software-waiting": "Wacht tot de vereisten zijn ge&#xEF;nstalleerd / geactiveerd. Mogelijk moet u de pagina na voltooiing vernieuwen.",
                  "ba-audiorecorder.access-forbidden": "Toegang tot de media was verboden. Klik om opnieuw te proberen.",
                  "ba-audiorecorder.uploading": "uploaden",
                  "ba-audiorecorder.uploading-failed": "Uploaden mislukt - klik hier om het opnieuw te proberen.",
                  "ba-audiorecorder.upload-error-duration": "De lengte van de ge&#xFC;ploade audio voldoet niet aan de vereisten. Klik hier om opnieuw te proberen.",
                  "ba-audiorecorder.verifying": "Het verifi&#xEB;ren",
                  "ba-audiorecorder.verifying-failed": "Verifi&#xEB;ren mislukt - klik hier om het opnieuw te proberen.",
                  "ba-audiorecorder.rerecord-confirm": "Wil je je audio echt opnieuw spelen?",
                  "ba-audiorecorder.cancel-confirm": "Wil je echt je audio-upload annuleren?",
                  "ba-audiorecorder.audio_file_too_large": "Je audiobestand is te groot (%s) - klik hier om het opnieuw te proberen met een kleiner audiobestand.",
                  "ba-audiorecorder.unsupported_audio_type": "Upload alstublieft: %s - klik hier om het opnieuw te proberen.",
                  "ba-common-settingsmenu.tooltip": "Klik om te spelen.",
                  "ba-common-settingsmenu.setting-menu": "Alle instellingen",
                  "ba-common-settingsmenu.source-quality": "Bronkwaliteit",
                  "ba-common-settingsmenu.player-speed": "Speler snelheid",
                  "ba-common-settingsmenu.set-menu-option": "Optie instellen",
                  "ba-common-settingsmenu.submit-video": "Bevestig video",
                  "ba-common-settingsmenu.picture-in-picture": "Foto in foto",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Verlaat volledig scherm",
                  "ba-common-settingsmenu.fullscreen-video": "Volledig scherm openen",
                  "ba-videorecorder-chooser.multi-stream": "Multi-stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Pauzeer de recorder",
                  "ba-videorecorder-controlbar.resume-recorder": "Hervat de recorder",
                  "ba-videorecorder.missing-track": "Vereiste audio- of videotrack ontbreekt",
                  "ba-videorecorder.device-already-in-use": "Minstens een van uw invoerapparaten is al in gebruik",
                  "ba-videorecorder.browser-permission-denied": "Toestemming geweigerd door browser, geef toegang en laad de pagina opnieuw",
                  "ba-audioplayer.all-settings": "Alle instellingen",
                  "ba-videoplayer-controlbar.remaining-time": "Overgebleven tijd",
                  "ba-videoplayer-controlbar.select-frame": "Selecteer",
                  "ba-videoplayer-controlbar.trim-video": "Trimmen",
                  "ba-videoplayer-playbutton.trim": "Trimmen",
                  "ba-videoplayer-playbutton.skip": "Overspringen",
                  "ba-videorecorder-imagegallery.upload-covershot": "Omslag uploaden",
                  "ba-videorecorder.pick-covershot-frame": "Selecteer een frame om als covershot te gebruiken.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Schermrecorder wordt niet ondersteund op dit apparaat",
                  "ba-videorecorder.trim-prompt": "Wil je je video inkorten?",
                  "ba-videorecorder.trim-video": "Verplaats de begin- en eindmarkeringen om je video bij te snijden",
                  "ba-videorecorder.wait-for-trim": "Wachten op trimcommando...",
                  "ba-videorecorder-controlbar.no-video-source": "Ontbrekende extra video-invoerbron",
                  "ba-videorecorder-controlbar.stream-already-selected": "Extra stream is al geselecteerd",
                  "ba-videorecorder.uploading-src-error": "Kan de video nu niet afspelen, het uploaden is nog bezig",
                  "ba-audiorecorder-controlbar.pause-recorder": "Recorder pauzeren",
                  "ba-audiorecorder-controlbar.resume-recorder": "Recorder hervatten"
                },
                "language:no": {
                  "ba-videoplayer-playbutton.tooltip": "Klikk for &#xE5; spille video.",
                  "ba-videoplayer-playbutton.rerecord": "Gj&#xF8;re om",
                  "ba-videoplayer-playbutton.submit-video": "bekreft video",
                  "ba-videoplayer-loader.tooltip": "Laster video ...",
                  "ba-videoplayer-controlbar.change-resolution": "Endre oppl&#xF8;sning",
                  "ba-videoplayer-controlbar.video-progress": "video fremgang",
                  "ba-videoplayer-controlbar.rerecord-video": "Gj&#xF8;r om videoen?",
                  "ba-videoplayer-controlbar.submit-video": "bekreft video",
                  "ba-videoplayer-controlbar.play-video": "spill video",
                  "ba-videoplayer-controlbar.pause-video": "pause video",
                  "ba-videoplayer-controlbar.elapsed-time": "Forl&#xF8;pt tid",
                  "ba-videoplayer-controlbar.total-time": "Total lengde p&#xE5; video",
                  "ba-videoplayer-controlbar.fullscreen-video": "Skriv fullskjerm",
                  "ba-videoplayer-controlbar.volume-button": "Still inn volum",
                  "ba-videoplayer-controlbar.volume-mute": "lyd",
                  "ba-videoplayer-controlbar.volume-unmute": "lyd",
                  "ba-videoplayer.video-error": "En feil oppstod. Vennligst pr&#xF8;v igjen senere. Klikk for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-videorecorder-chooser.record-video": "Spill av video",
                  "ba-videorecorder-chooser.upload-video": "Last opp video",
                  "ba-videorecorder-controlbar.settings": "innstillinger",
                  "ba-videorecorder-controlbar.camerahealthy": "Belysning er god",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Belysning er ikke optimal",
                  "ba-videorecorder-controlbar.microphonehealthy": "Lyden er god",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Kan ikke plukke opp noen lyd",
                  "ba-videorecorder-controlbar.record": "Ta opp",
                  "ba-videorecorder-controlbar.record-tooltip": "Klikk her for &#xE5; spille inn.",
                  "ba-videorecorder-controlbar.rerecord": "Gj&#xF8;re om",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Klikk her for &#xE5; gj&#xF8;re om.",
                  "ba-videorecorder-controlbar.upload-covershot": "Laste opp",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Klikk her for &#xE5; laste opp egendefinerte dekke skudd",
                  "ba-videorecorder-controlbar.stop": "Stoppe",
                  "ba-videorecorder-controlbar.stop-tooltip": "Klikk her for &#xE5; stoppe.",
                  "ba-videorecorder-controlbar.skip": "Hopp",
                  "ba-videorecorder-controlbar.skip-tooltip": "Klikk her for &#xE5; hoppe.",
                  "ba-videorecorder.recorder-error": "En feil oppstod. Vennligst pr&#xF8;v igjen senere. Klikk for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-videorecorder.attach-error": "Vi kunne ikke f&#xE5; tilgang til kameraet grensesnitt. Avhengig av enheten og nettleser, kan det hende du m&#xE5; installere Flash eller tilgang til siden via SSL.",
                  "ba-videorecorder.access-forbidden": "Tilgang til kameraet ble forbudt. Klikk for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-videorecorder.pick-covershot": "Plukk en covershot.",
                  "ba-videorecorder.uploading": "Laster opp",
                  "ba-videorecorder.uploading-failed": "Opplasting mislyktes - klikk her for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-videorecorder.verifying": "Bekrefter",
                  "ba-videorecorder.verifying-failed": "Bekrefter mislyktes - klikk her for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-videorecorder.rerecord-confirm": "Har du virkelig &#xF8;nsker &#xE5; gj&#xF8;re om videoen?",
                  "ba-videorecorder.video_file_too_large": "Videofilen er for stor (%s) - klikk her for &#xE5; pr&#xF8;ve p&#xE5; nytt med en mindre videofil.",
                  "ba-videorecorder.unsupported_video_type": "Last opp: %s - klikk her for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Avslutt fullskjerm",
                  "ba-videoplayer-share.share": "Del video",
                  "ba-videorecorder-chooser.record-screen": "Opptaksskjerm",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pause ikke st&#xF8;ttet",
                  "ba-videorecorder-chooser.record-audio": "Ta opp lyd",
                  "ba-videorecorder-controlbar.stop-available-after": "Minimum opptakstid er %d sekunder",
                  "ba-videorecorder-controlbar.cancel": "Avbryt",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Klikk her for &#xE5; avbryte.",
                  "ba-videorecorder.cancel-confirm": "Vil du virkelig slette videoopplasting?",
                  "ba-videoplayer-adslot.elapsed-time": "Forl&#xF8;pt tid",
                  "ba-videoplayer-adslot.volume-button": "Angi volum",
                  "ba-videoplayer-adslot.volume-mute": "Dempe lyd",
                  "ba-videoplayer-adslot.volume-unmute": "Sl&#xE5; av lyden",
                  "ba-videoplayer-adslot.ad-will-end-after": "Annonsen slutter etter %s",
                  "ba-videoplayer-adslot.can-skip-after": "Hopp over etter %d",
                  "ba-videoplayer-adslot.skip-ad": "Hopp over annonse",
                  "ba-videorecorder.software-required": "Vennligst klikk nedenfor for &#xE5; installere / aktivere f&#xF8;lgende krav for &#xE5; fortsette.",
                  "ba-videorecorder.software-waiting": "Venter p&#xE5; kravene som skal installeres / aktiveres. Du m&#xE5; kanskje oppdatere siden etter ferdigstillelse.",
                  "ba-videoplayer-controlbar.close-tracks": "Lukk CC",
                  "ba-videoplayer-controlbar.show-tracks": "Vis CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Last opp tekstfilfiler",
                  "ba-videoplayer-tracks.select-text-track-language": "Undertekst Spr&#xE5;k",
                  "ba-videoplayer-tracks.info-select-locale-first": "Velg f&#xF8;rst spr&#xE5;k",
                  "ba-videoplayer-tracks.select-text-track-file": "Klikk for &#xE5; velge fil",
                  "ba-videoplayer-tracks.back": "tilbake",
                  "ba-videorecorder.framerate-warning": "Videorammen er sv&#xE6;rt lav. Vi anbefaler at du lukker alle andre programmer og nettleserfliker eller bruker en raskere datamaskin.",
                  "ba-videorecorder.upload-error-duration": "Lengden p&#xE5; den opplastede videoen oppfyller ikke kravene - klikk her for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-videorecorder.resolution-constraint-error": "Filen du har valgt stemmer ikke overens med &#xF8;nsket oppl&#xF8;sning - klikk her for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-videorecorder.orientation-portrait-required": "Vennligst roter enheten til &#xE5; ta opp i st&#xE5;ende modus.",
                  "ba-videorecorder.orientation-landscape-required": "Vennligst roter enheten til &#xE5; ta opp i liggende modus.",
                  "ba-imageviewer-controlbar.rerecord-image": "Gj&#xF8;re om?",
                  "ba-imageviewer-controlbar.submit-image": "Bekrefte",
                  "ba-imageviewer-controlbar.fullscreen-image": "Skriv inn fullskjerm",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Avslutt fullskjerm",
                  "ba-imageviewer.image-error": "En feil oppstod. Vennligst pr&#xF8;v igjen senere. Klikk for &#xE5; pr&#xF8;ve igjen.",
                  "ba-imagecapture-chooser.image-capture": "Capture Image",
                  "ba-imagecapture-chooser.upload-image": "Last opp bilde",
                  "ba-imagecapture-controlbar.settings": "innstillinger",
                  "ba-imagecapture-controlbar.camerahealthy": "Belysning er bra",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Belysning er ikke optimal",
                  "ba-imagecapture-controlbar.record": "Capture",
                  "ba-imagecapture-controlbar.record-tooltip": "Klikk her for &#xE5; fange.",
                  "ba-imagecapture-controlbar.rerecord": "Gj&#xF8;re om",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Klikk her for &#xE5; gjenta.",
                  "ba-imagecapture-controlbar.cancel": "Avbryt",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Klikk her for &#xE5; avbryte.",
                  "ba-audioplayer-controlbar.audio-progress": "Framgang",
                  "ba-audioplayer-controlbar.rerecord-audio": "Gj&#xF8;re om?",
                  "ba-audioplayer-controlbar.submit-audio": "Bekrefte",
                  "ba-audioplayer-controlbar.play-audio": "Spille",
                  "ba-audioplayer-controlbar.pause-audio": "Pause",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pause ikke st&#xF8;ttet",
                  "ba-audioplayer-controlbar.elapsed-time": "Forl&#xF8;pt tid",
                  "ba-audioplayer-controlbar.total-time": "Total lengde p&#xE5;",
                  "ba-audioplayer-controlbar.volume-button": "Angi volum",
                  "ba-audioplayer-controlbar.volume-mute": "Dempe lyd",
                  "ba-audioplayer-controlbar.volume-unmute": "Sl&#xE5; av lyden",
                  "ba-audioplayer-loader.tooltip": "Laster ...",
                  "ba-audioplayer.audio-error": "En feil oppstod. Vennligst pr&#xF8;v igjen senere. Klikk for &#xE5; pr&#xF8;ve igjen.",
                  "ba-audiorecorder-chooser.record-audio": "Ta opp lyd",
                  "ba-audiorecorder-chooser.upload-audio": "Last opp lyd",
                  "ba-audiorecorder-controlbar.settings": "innstillinger",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Lyden er god",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Kan ikke hente lyd",
                  "ba-audiorecorder-controlbar.record": "Ta opp",
                  "ba-audiorecorder-controlbar.record-tooltip": "Klikk her for &#xE5; spille inn.",
                  "ba-audiorecorder-controlbar.rerecord": "Gj&#xF8;re om",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Klikk her for &#xE5; gjenta.",
                  "ba-audiorecorder-controlbar.stop": "Stoppe",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Klikk her for &#xE5; stoppe.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Minimum opptakstid er %d sekunder",
                  "ba-audiorecorder-controlbar.cancel": "Avbryt",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Klikk her for &#xE5; avbryte.",
                  "ba-videoplayer-controlbar.player-speed": "Spillerens hastighet",
                  "ba-videoplayer-controlbar.settings": "innstillinger",
                  "ba-videoplayer-controlbar.airplay": "airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay-ikon.",
                  "ba-videoplayer.all-settings": "Alle innstillinger",
                  "ba-videoplayer.player-speed": "Spillerens hastighet",
                  "ba-videoplayer.full-screen": "Full skjerm",
                  "ba-videorecorder-controlbar.add-stream": "Legg til str&#xF8;m",
                  "ba-videorecorder.switch-camera": "Bytt kamera",
                  "ba-videorecorder.prepare-covershot": "Forbereder deksler",
                  "ba-videorecorder.prepare-thumbnails": "Forbereder s&#xF8;ker miniatyrbilder",
                  "ba-videorecorder.adding-new-stream": "Legger til ny str&#xF8;m",
                  "ba-imagecapture.recorder-error": "En feil oppstod. Vennligst pr&#xF8;v igjen senere. Klikk for &#xE5; pr&#xF8;ve igjen.",
                  "ba-imagecapture.attach-error": "Vi kunne ikke f&#xE5; tilgang til mediegrensesnittet. Avhengig av enhet og nettleser, m&#xE5; du kanskje installere Flash eller f&#xE5; tilgang til siden via SSL.",
                  "ba-imagecapture.software-required": "Vennligst klikk nedenfor for &#xE5; installere / aktivere f&#xF8;lgende krav for &#xE5; fortsette.",
                  "ba-imagecapture.software-waiting": "Venter p&#xE5; kravene som skal installeres / aktiveres. Du m&#xE5; kanskje oppdatere siden etter ferdigstillelse.",
                  "ba-imagecapture.access-forbidden": "Tilgang til media var forbudt. Klikk for &#xE5; pr&#xF8;ve igjen.",
                  "ba-imagecapture.uploading": "Laster opp",
                  "ba-imagecapture.uploading-failed": "Opplasting mislyktes - klikk her for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-imagecapture.upload-error-duration": "Lengden p&#xE5; det opplastede bildet oppfyller ikke kravene - klikk her for &#xE5; pr&#xF8;ve igjen.",
                  "ba-imagecapture.resolution-constraint-error": "Filen du har valgt stemmer ikke overens med &#xF8;nsket oppl&#xF8;sning - klikk her for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-imagecapture.verifying": "Bekrefter",
                  "ba-imagecapture.verifying-failed": "Bekreftelse mislyktes - klikk her for &#xE5; pr&#xF8;ve igjen.",
                  "ba-imagecapture.rerecord-confirm": "Vil du virkelig gjenta bildet ditt?",
                  "ba-imagecapture.image_file_too_large": "Bildefilen din er for stor (%s) - klikk her for &#xE5; pr&#xF8;ve igjen med en mindre bildefil.",
                  "ba-imagecapture.unsupported_image_type": "Vennligst last opp: %s - klikk her for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-imagecapture.orientation-portrait-required": "Vennligst roter enheten din for &#xE5; ta opp i st&#xE5;ende modus.",
                  "ba-imagecapture.orientation-landscape-required": "Vennligst roter enheten til &#xE5; ta opp i liggende modus.",
                  "ba-audiorecorder.recorder-error": "En feil oppstod. Vennligst pr&#xF8;v igjen senere. Klikk for &#xE5; pr&#xF8;ve igjen.",
                  "ba-audiorecorder.attach-error": "Vi kunne ikke f&#xE5; tilgang til mediegrensesnittet. Avhengig av enhet og nettleser, m&#xE5; du kanskje installere Flash eller f&#xE5; tilgang til siden via SSL.",
                  "ba-audiorecorder.software-required": "Vennligst klikk nedenfor for &#xE5; installere / aktivere f&#xF8;lgende krav for &#xE5; fortsette.",
                  "ba-audiorecorder.software-waiting": "Venter p&#xE5; kravene som skal installeres / aktiveres. Du m&#xE5; kanskje oppdatere siden etter ferdigstillelse.",
                  "ba-audiorecorder.access-forbidden": "Tilgang til media var forbudt. Klikk for &#xE5; pr&#xF8;ve igjen.",
                  "ba-audiorecorder.uploading": "Laster opp",
                  "ba-audiorecorder.uploading-failed": "Opplasting mislyktes - klikk her for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-audiorecorder.upload-error-duration": "Lengden p&#xE5; den opplastede lyden oppfyller ikke kravene - klikk her for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-audiorecorder.verifying": "Bekrefter",
                  "ba-audiorecorder.verifying-failed": "Bekreftelse mislyktes - klikk her for &#xE5; pr&#xF8;ve igjen.",
                  "ba-audiorecorder.rerecord-confirm": "Vil du virkelig gjenta lyden din?",
                  "ba-audiorecorder.cancel-confirm": "Vil du virkelig slette lydopplasting?",
                  "ba-audiorecorder.audio_file_too_large": "Lydfilen din er for stor (%s) - klikk her for &#xE5; pr&#xF8;ve igjen med en mindre lydfil.",
                  "ba-audiorecorder.unsupported_audio_type": "Vennligst last opp: %s - klikk her for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ba-common-settingsmenu.tooltip": "Klikk for &#xE5; spille.",
                  "ba-common-settingsmenu.setting-menu": "Alle innstillinger",
                  "ba-common-settingsmenu.source-quality": "Kildekvalitet",
                  "ba-common-settingsmenu.player-speed": "Spillerens hastighet",
                  "ba-common-settingsmenu.set-menu-option": "Still inn alternativ",
                  "ba-common-settingsmenu.submit-video": "Bekreft video",
                  "ba-common-settingsmenu.picture-in-picture": "Bilde i bilde",
                  "ba-common-settingsmenu.exit-fullscreen-video": "G&#xE5; ut av fullskjerm",
                  "ba-common-settingsmenu.fullscreen-video": "G&#xE5; inn i fullskjerm",
                  "ba-videorecorder-chooser.multi-stream": "Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Pause opptaker",
                  "ba-videorecorder-controlbar.resume-recorder": "Gjenoppta opptaker",
                  "ba-videorecorder.missing-track": "N&#xF8;dvendig lyd- eller videospor mangler",
                  "ba-videorecorder.device-already-in-use": "Minst en av inngangsenhetene dine er allerede i bruk",
                  "ba-videorecorder.browser-permission-denied": "Tillatelse nektet av nettleseren. Vennligst gi tilgang og last inn siden p&#xE5; nytt",
                  "ba-audioplayer.all-settings": "Alle innstillinger",
                  "ba-videoplayer-controlbar.remaining-time": "Gjenv&#xE6;rende tid",
                  "ba-videoplayer-controlbar.select-frame": "&#xC5; velge",
                  "ba-videoplayer-controlbar.trim-video": "Listverk",
                  "ba-videoplayer-playbutton.trim": "Listverk",
                  "ba-videoplayer-playbutton.skip": "Hopp over",
                  "ba-videorecorder-imagegallery.upload-covershot": "Last opp deksel",
                  "ba-videorecorder.pick-covershot-frame": "Velg en ramme som skal brukes som forsidebilde.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Skjermopptaker st&#xF8;ttes ikke p&#xE5; denne enheten",
                  "ba-videorecorder.trim-prompt": "Vil du trimme videoen din?",
                  "ba-videorecorder.trim-video": "Flytt start- og sluttmark&#xF8;rene for &#xE5; trimme videoen",
                  "ba-videorecorder.wait-for-trim": "Venter p&#xE5; trimkommando ...",
                  "ba-videorecorder-controlbar.no-video-source": "Mangler ytterligere videoinngangskilde",
                  "ba-videorecorder-controlbar.stream-already-selected": "Ytterligere str&#xF8;m er allerede valgt",
                  "ba-videorecorder.uploading-src-error": "Kan ikke spille av video n&#xE5;. Opplasting p&#xE5;g&#xE5;r fortsatt",
                  "ba-audiorecorder-controlbar.pause-recorder": "Pause opptaker",
                  "ba-audiorecorder-controlbar.resume-recorder": "Fortsett opptaker"
                },
                "language:pl": {
                  "ba-videoplayer-playbutton.tooltip": "Kliknij, aby odtworzy&#x107; film.",
                  "ba-videoplayer-playbutton.rerecord": "Pon&#xF3;w",
                  "ba-videoplayer-playbutton.submit-video": "Potwierd&#x17A; wideo",
                  "ba-videoplayer-loader.tooltip": "&#x141;adowanie...",
                  "ba-videoplayer-controlbar.change-resolution": "Zmie&#x144; rozdzielczo&#x15B;&#x107;",
                  "ba-videoplayer-controlbar.video-progress": "Post&#x119;p wideo",
                  "ba-videoplayer-controlbar.rerecord-video": "Nagra&#x107; ponownie?",
                  "ba-videoplayer-controlbar.submit-video": "Potwierd&#x17A; wideo",
                  "ba-videoplayer-controlbar.play-video": "Odtw&#xF3;rz",
                  "ba-videoplayer-controlbar.pause-video": "Zatrzymaj",
                  "ba-videoplayer-controlbar.elapsed-time": "czas trwania",
                  "ba-videoplayer-controlbar.total-time": "Ca&#x142;kowita d&#x142;ugo&#x15B;&#x107; wideo",
                  "ba-videoplayer-controlbar.fullscreen-video": "Tryb pe&#x142;noekranowy",
                  "ba-videoplayer-controlbar.volume-button": "Ustaw g&#x142;o&#x15B;no&#x15B;&#x107;",
                  "ba-videoplayer-controlbar.volume-mute": "Wycisz d&#x17A;wi&#x119;k",
                  "ba-videoplayer-controlbar.volume-unmute": "W&#x142;&#x105;cz d&#x17A;wi&#x119;k",
                  "ba-videoplayer.video-error": "Wyst&#x105;pi&#x142; b&#x142;&#x105;d. Prosz&#x119; spr&#xF3;bowa&#x107; p&#xF3;&#x17A;niej. Kliknij, aby ponowi&#x107; pr&#xF3;b&#x119;.",
                  "ba-videorecorder-chooser.record-video": "Nagraj wideo",
                  "ba-videorecorder-chooser.upload-video": "Prze&#x15B;lij wideo",
                  "ba-videorecorder-controlbar.settings": "Ustawienia",
                  "ba-videorecorder-controlbar.camerahealthy": "O&#x15B;wietlenie jest dobre",
                  "ba-videorecorder-controlbar.cameraunhealthy": "O&#x15B;wietlenie nie jest optymalne",
                  "ba-videorecorder-controlbar.microphonehealthy": "D&#x17A;wi&#x119;k jest dobry",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Nie mo&#x17C;na odebra&#x107; &#x17C;adnego d&#x17A;wi&#x119;ku",
                  "ba-videorecorder-controlbar.record": "Nagraj",
                  "ba-videorecorder-controlbar.record-tooltip": "Kliknij tutaj, aby rozpocz&#x105;&#x107; nagranie.",
                  "ba-videorecorder-controlbar.rerecord": "Pon&#xF3;w",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Kliknij tutaj, aby ponowi&#x107;.",
                  "ba-videorecorder-controlbar.upload-covershot": "Wy&#x15B;lij plik ok&#x142;adki",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Kliknij tu aby przes&#x142;a&#x107; niestandardowy plik ok&#x142;adki",
                  "ba-videorecorder-controlbar.stop": "Zatrzymaj",
                  "ba-videorecorder-controlbar.stop-tooltip": "Kliknij tutaj, aby zatrzyma&#x107;.",
                  "ba-videorecorder-controlbar.skip": "Pomi&#x144;",
                  "ba-videorecorder-controlbar.skip-tooltip": "Kliknij tutaj, aby pomin&#x105;&#x107;.",
                  "ba-videorecorder.recorder-error": "Wyst&#x105;pi&#x142; b&#x142;&#x105;d. Prosz&#x119; spr&#xF3;bowa&#x107; p&#xF3;&#x17A;niej. Kliknij, aby ponowi&#x107; pr&#xF3;b&#x119;.",
                  "ba-videorecorder.attach-error": "Nie uzyskano dost&#x119;pu do interfejsu aparatu. W zale&#x17C;no&#x15B;ci od urz&#x105;dzenia i przegl&#x105;darki, mo&#x17C;e by&#x107; konieczne zainstalowanie Flash lub  wej&#x15B;cie na stron&#x119; za po&#x15B;rednictwem protoko&#x142;u SSL.",
                  "ba-videorecorder.access-forbidden": "Dost&#x119;p do kamery zosta&#x142; zabroniony. Kliknij, aby ponowi&#x107; pr&#xF3;b&#x119;.",
                  "ba-videorecorder.pick-covershot": "Wybierz plik ok&#x142;adki.",
                  "ba-videorecorder.uploading": "Przesy&#x142;anie",
                  "ba-videorecorder.uploading-failed": "Przesy&#x142;anie nie powiod&#x142;o si&#x119; - kliknij tutaj, aby ponowi&#x107; pr&#xF3;b&#x119;.",
                  "ba-videorecorder.verifying": "Weryfikacja",
                  "ba-videorecorder.verifying-failed": "Sprawdzanie poprawno&#x15B;ci nie powiod&#x142;o si&#x119; - kliknij tutaj, aby ponowi&#x107; pr&#xF3;b&#x119;.",
                  "ba-videorecorder.rerecord-confirm": "Czy na pewno chcesz ponowi&#x107; nagranie?",
                  "ba-videorecorder.video_file_too_large": "Plik wideo jest zbyt du&#x17C;a (%s) - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie z mniejszym plikiem wideo.",
                  "ba-videorecorder.unsupported_video_type": "Prosz&#x119; przes&#x142;a&#x107;: %s - kliknij tutaj, aby ponowi&#x107; pr&#xF3;b&#x119;.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Zamknij pe&#x142;ny ekran",
                  "ba-videoplayer-share.share": "Udost&#x119;pnij film",
                  "ba-videorecorder-chooser.record-screen": "Nagraj ekran",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Wstrzymanie nie jest obs&#x142;ugiwane",
                  "ba-videorecorder-chooser.record-audio": "Nagraj d&#x17A;wi&#x119;k",
                  "ba-videorecorder-controlbar.stop-available-after": "Minimalny czas nagrywania to %d sekund",
                  "ba-videorecorder-controlbar.cancel": "Anuluj",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Kliknij tutaj, aby anulowa&#x107;.",
                  "ba-videorecorder.cancel-confirm": "Czy na pewno chcesz anulowa&#x107; przesy&#x142;anie wideo?",
                  "ba-videoplayer-adslot.elapsed-time": "czas trwania",
                  "ba-videoplayer-adslot.volume-button": "Ustaw g&#x142;o&#x15B;no&#x15B;&#x107;",
                  "ba-videoplayer-adslot.volume-mute": "Wycisz d&#x17A;wi&#x119;k",
                  "ba-videoplayer-adslot.volume-unmute": "W&#x142;&#x105;cz d&#x17A;wi&#x119;k",
                  "ba-videoplayer-adslot.ad-will-end-after": "Reklama zako&#x144;czy si&#x119; po %s",
                  "ba-videoplayer-adslot.can-skip-after": "Pomi&#x144; za %d",
                  "ba-videoplayer-adslot.skip-ad": "Pomi&#x144; reklam&#x119;",
                  "ba-videorecorder.software-required": "Kliknij poni&#x17C;ej, aby zainstalowa&#x107; / aktywowa&#x107; nast&#x119;puj&#x105;ce wymagania, aby kontynuowa&#x107;.",
                  "ba-videorecorder.software-waiting": "Oczekiwanie na zainstalowanie / aktywacj&#x119; wymaga&#x144;. Po zako&#x144;czeniu mo&#x17C;e by&#x107; konieczne od&#x15B;wie&#x17C;enie strony.",
                  "ba-videoplayer-controlbar.close-tracks": "Zamknij CC",
                  "ba-videoplayer-controlbar.show-tracks": "Poka&#x17C; CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Prze&#x15B;lij pliki tekstowe &#x15B;cie&#x17C;ki d&#x17A;wi&#x119;kowej",
                  "ba-videoplayer-tracks.select-text-track-language": "J&#x119;zyk napis&#xF3;w",
                  "ba-videoplayer-tracks.info-select-locale-first": "Najpierw wybierz ustawienia lokalne",
                  "ba-videoplayer-tracks.select-text-track-file": "Kliknij, aby wybra&#x107; plik",
                  "ba-videoplayer-tracks.back": "Cofnij",
                  "ba-videorecorder.framerate-warning": "Szybko&#x15B;&#x107; klatek wideo jest bardzo niska. Zalecamy zamkni&#x119;cie wszystkich innych program&#xF3;w i kart przegl&#x105;darki lub u&#x17C;ycie szybszego komputera.",
                  "ba-videorecorder.upload-error-duration": "D&#x142;ugo&#x15B;&#x107; przes&#x142;anego filmu nie spe&#x142;nia wymaga&#x144; - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-videorecorder.resolution-constraint-error": "Wybrany plik nie pasuje do wymaganej rozdzielczo&#x15B;ci - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-videorecorder.orientation-portrait-required": "Obr&#xF3;&#x107; urz&#x105;dzenie, aby nagrywa&#x107; w trybie portretu.",
                  "ba-videorecorder.orientation-landscape-required": "Obr&#xF3;&#x107; urz&#x105;dzenie, aby nagrywa&#x107; w trybie poziomym.",
                  "ba-imageviewer-controlbar.rerecord-image": "Ponowi&#x107;?",
                  "ba-imageviewer-controlbar.submit-image": "Potwierdza&#x107;",
                  "ba-imageviewer-controlbar.fullscreen-image": "Pe&#x142;ny ekran",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Wy&#x142;&#x105;cz tryb pe&#x142;noekranowy",
                  "ba-imageviewer.image-error": "Wyst&#x105;pi&#x142; b&#x142;&#x105;d. Prosz&#x119; spr&#xF3;bowa&#x107; p&#xF3;&#x17A;niej. Kliknij, aby spr&#xF3;bowa&#x107; jeszcze raz.",
                  "ba-imagecapture-chooser.image-capture": "Zr&#xF3;b zdj&#x119;cie",
                  "ba-imagecapture-chooser.upload-image": "Za&#x142;aduj obraz",
                  "ba-imagecapture-controlbar.settings": "Ustawienia",
                  "ba-imagecapture-controlbar.camerahealthy": "O&#x15B;wietlenie jest dobre",
                  "ba-imagecapture-controlbar.cameraunhealthy": "O&#x15B;wietlenie nie jest optymalne",
                  "ba-imagecapture-controlbar.record": "Uchwy&#x107;",
                  "ba-imagecapture-controlbar.record-tooltip": "Kliknij tutaj, aby uchwyci&#x107;.",
                  "ba-imagecapture-controlbar.rerecord": "Pon&#xF3;w",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Kliknij tutaj, aby ponowi&#x107;.",
                  "ba-imagecapture-controlbar.cancel": "Anuluj",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Kliknij tutaj, aby anulowa&#x107;.",
                  "ba-audioplayer-controlbar.audio-progress": "Post&#x119;p",
                  "ba-audioplayer-controlbar.rerecord-audio": "Ponowi&#x107;?",
                  "ba-audioplayer-controlbar.submit-audio": "Potwierd&#x17A;",
                  "ba-audioplayer-controlbar.play-audio": "Uruchom",
                  "ba-audioplayer-controlbar.pause-audio": "Zatrzymaj",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Wstrzymanie nie jest obs&#x142;ugiwane",
                  "ba-audioplayer-controlbar.elapsed-time": "Czas trwania",
                  "ba-audioplayer-controlbar.total-time": "Ca&#x142;kowita d&#x142;ugo&#x15B;&#x107;",
                  "ba-audioplayer-controlbar.volume-button": "Ustaw g&#x142;o&#x15B;no&#x15B;&#x107;",
                  "ba-audioplayer-controlbar.volume-mute": "Wycisz d&#x17A;wi&#x119;k",
                  "ba-audioplayer-controlbar.volume-unmute": "W&#x142;&#x105;cz d&#x17A;wi&#x119;k",
                  "ba-audioplayer-loader.tooltip": "&#x141;adowanie...",
                  "ba-audioplayer.audio-error": "Wyst&#x105;pi&#x142; b&#x142;&#x105;d. Prosz&#x119; spr&#xF3;bowa&#x107; p&#xF3;&#x17A;niej. Kliknij, aby spr&#xF3;bowa&#x107; jeszcze raz.",
                  "ba-audiorecorder-chooser.record-audio": "Nagraj d&#x17A;wi&#x119;k",
                  "ba-audiorecorder-chooser.upload-audio": "Prze&#x15B;lij audio",
                  "ba-audiorecorder-controlbar.settings": "Ustawienia",
                  "ba-audiorecorder-controlbar.microphonehealthy": "D&#x17A;wi&#x119;k jest dobry",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Nie mo&#x17C;na odebra&#x107; &#x17C;adnego d&#x17A;wi&#x119;ku",
                  "ba-audiorecorder-controlbar.record": "Nagraj",
                  "ba-audiorecorder-controlbar.record-tooltip": "Kliknij tutaj, aby nagra&#x107;.",
                  "ba-audiorecorder-controlbar.rerecord": "Pon&#xF3;w",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Kliknij tutaj, aby ponowi&#x107;.",
                  "ba-audiorecorder-controlbar.stop": "Zatrzymaj",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Kliknij tutaj, aby zatrzyma&#x107;.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Minimalny czas nagrywania to %d sekund",
                  "ba-audiorecorder-controlbar.cancel": "Anuluj",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Kliknij tutaj, aby anulowa&#x107;.",
                  "ba-videoplayer-controlbar.player-speed": "Pr&#x119;dko&#x15B;&#x107; odtwarzania",
                  "ba-videoplayer-controlbar.settings": "Ustawienia",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Ikona Airplay.",
                  "ba-videoplayer.all-settings": "Wszystkie ustawienia",
                  "ba-videoplayer.player-speed": "Pr&#x119;dko&#x15B;&#x107; odtwarzania",
                  "ba-videoplayer.full-screen": "Pe&#x142;ny ekran",
                  "ba-videorecorder-controlbar.add-stream": "Dodaj strumie&#x144;",
                  "ba-videorecorder.switch-camera": "Prze&#x142;&#x105;cz aparat",
                  "ba-videorecorder.prepare-covershot": "Przygotowywanie plik&#xF3;w ok&#x142;adki",
                  "ba-videorecorder.prepare-thumbnails": "Przygotowanie do szukania miniatur",
                  "ba-videorecorder.adding-new-stream": "Dodawanie nowego streamu",
                  "ba-imagecapture.recorder-error": "Wyst&#x105;pi&#x142; b&#x142;&#x105;d. Prosz&#x119; spr&#xF3;bowa&#x107; p&#xF3;&#x17A;niej. Kliknij, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-imagecapture.attach-error": "Nie mo&#x17C;na uzyska&#x107; dost&#x119;pu do interfejsu multimedialnego. W zale&#x17C;no&#x15B;ci od urz&#x105;dzenia i przegl&#x105;darki mo&#x17C;e by&#x107; konieczne zainstalowanie Flasha lub  uzyskanie dost&#x119;pu do strony przez SSL.",
                  "ba-imagecapture.software-required": "Kliknij poni&#x17C;ej, aby zainstalowa&#x107; / aktywowa&#x107; nast&#x119;puj&#x105;ce wymagania, aby kontynuowa&#x107;.",
                  "ba-imagecapture.software-waiting": "Oczekiwanie na zainstalowanie / aktywacj&#x119; wymaga&#x144;. Mo&#x17C;e by&#x107; konieczne od&#x15B;wie&#x17C;enie strony po zako&#x144;czeniu.",
                  "ba-imagecapture.access-forbidden": "Dost&#x119;p do medi&#xF3;w zosta&#x142; zabroniony. Kliknij, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-imagecapture.uploading": "Przesy&#x142;anie",
                  "ba-imagecapture.uploading-failed": "Przesy&#x142;anie nie powiod&#x142;o si&#x119; - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-imagecapture.upload-error-duration": "D&#x142;ugo&#x15B;&#x107; przes&#x142;anego obrazu nie spe&#x142;nia wymaga&#x144; - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-imagecapture.resolution-constraint-error": "Wybrany plik nie odpowiada wymaganej rozdzielczo&#x15B;ci - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-imagecapture.verifying": "Weryfikacja",
                  "ba-imagecapture.verifying-failed": "Weryfikacja nie powiod&#x142;a si&#x119; - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-imagecapture.rerecord-confirm": "Czy na pewno chcesz ponowi&#x107; dodawanie obrazu?",
                  "ba-imagecapture.image_file_too_large": "Tw&#xF3;j plik obrazu jest za du&#x17C;y (%s) - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie z mniejszym plikiem obrazu.",
                  "ba-imagecapture.unsupported_image_type": "Prze&#x15B;lij: %s - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-imagecapture.orientation-portrait-required": "Obr&#xF3;&#x107; urz&#x105;dzenie, aby nagrywa&#x107; w trybie pionowym.",
                  "ba-imagecapture.orientation-landscape-required": "Obr&#xF3;&#x107; urz&#x105;dzenie, aby nagrywa&#x107; w trybie poziomym.",
                  "ba-audiorecorder.recorder-error": "Wyst&#x105;pi&#x142; b&#x142;&#x105;d. Prosz&#x119; spr&#xF3;bowa&#x107; p&#xF3;&#x17A;niej. Kliknij, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-audiorecorder.attach-error": "Nie mo&#x17C;na uzyska&#x107; dost&#x119;pu do interfejsu multimedialnego. W zale&#x17C;no&#x15B;ci od urz&#x105;dzenia i przegl&#x105;darki mo&#x17C;e by&#x107; konieczne zainstalowanie Flasha lub  uzyskanie dost&#x119;pu do strony przez SSL.",
                  "ba-audiorecorder.software-required": "Kliknij poni&#x17C;ej, aby zainstalowa&#x107; / aktywowa&#x107; nast&#x119;puj&#x105;ce wymagania, aby kontynuowa&#x107;.",
                  "ba-audiorecorder.software-waiting": "Oczekiwanie na zainstalowanie / aktywacj&#x119; wymaga&#x144;. Mo&#x17C;e by&#x107; konieczne od&#x15B;wie&#x17C;enie strony po zako&#x144;czeniu.",
                  "ba-audiorecorder.access-forbidden": "Dost&#x119;p do medi&#xF3;w zosta&#x142; zabroniony. Kliknij, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-audiorecorder.uploading": "Przesy&#x142;anie",
                  "ba-audiorecorder.uploading-failed": "Przesy&#x142;anie nie powiod&#x142;o si&#x119; - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-audiorecorder.upload-error-duration": "D&#x142;ugo&#x15B;&#x107; przes&#x142;anego d&#x17A;wi&#x119;ku nie spe&#x142;nia wymaga&#x144; - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-audiorecorder.verifying": "Weryfikacja",
                  "ba-audiorecorder.verifying-failed": "Weryfikacja nie powiod&#x142;a si&#x119; - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-audiorecorder.rerecord-confirm": "Czy na pewno chcesz nadpisa&#x107; przes&#x142;any d&#x17A;wi&#x119;k?",
                  "ba-audiorecorder.cancel-confirm": "Czy na pewno chcesz anulowa&#x107; przesy&#x142;anie d&#x17A;wi&#x119;ku?",
                  "ba-audiorecorder.audio_file_too_large": "Tw&#xF3;j plik audio jest za du&#x17C;y (%s) - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie z mniejszym plikiem audio.",
                  "ba-audiorecorder.unsupported_audio_type": "Prze&#x15B;lij: %s - kliknij tutaj, aby spr&#xF3;bowa&#x107; ponownie.",
                  "ba-common-settingsmenu.tooltip": "Kliknij, aby uruchomi&#x107;",
                  "ba-common-settingsmenu.setting-menu": "Ustawienia",
                  "ba-common-settingsmenu.source-quality": "Jako&#x15B;&#x107; &#x17A;r&#xF3;d&#x142;a",
                  "ba-common-settingsmenu.player-speed": "Szybko&#x15B;&#x107; odtwarzania",
                  "ba-common-settingsmenu.set-menu-option": "Ustaw",
                  "ba-common-settingsmenu.submit-video": "Potwierd&#x17A; wideo",
                  "ba-common-settingsmenu.picture-in-picture": "Obraz w obrazie",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Wyjd&#x17A; z trybu pe&#x142;noekranowego",
                  "ba-common-settingsmenu.fullscreen-video": "Tryb pe&#x142;noekranowy",
                  "ba-videorecorder-chooser.multi-stream": "Multi-Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Zatrzymaj nagrywanie",
                  "ba-videorecorder-controlbar.resume-recorder": "Wzn&#xF3;w nagrywanie",
                  "ba-videorecorder.missing-track": "Nie znaleziono wymaganej &#x15B;cie&#x17C;ki d&#x17A;wi&#x119;kowej lub pliku wideo",
                  "ba-videorecorder.device-already-in-use": "Przynajmniej jedno z twoich urz&#x105;dze&#x144; wej&#x15B;cia jest ju&#x17C; w u&#x17C;yciu",
                  "ba-videorecorder.browser-permission-denied": "Odmowa dost&#x119;pu przez przegl&#x105;dark&#x119;. Nadaj uprawnienia i od&#x15B;wie&#x17C;",
                  "ba-audioplayer.all-settings": "Ustawiemia",
                  "ba-videoplayer-controlbar.remaining-time": "Pozosta&#x142;y czas",
                  "ba-videoplayer-controlbar.select-frame": "Wybierz",
                  "ba-videoplayer-controlbar.trim-video": "Trym",
                  "ba-videoplayer-playbutton.trim": "Trym",
                  "ba-videoplayer-playbutton.skip": "Pomin&#x105;&#x107;",
                  "ba-videorecorder-imagegallery.upload-covershot": "Prze&#x15B;lij ok&#x142;adk&#x119;",
                  "ba-videorecorder.pick-covershot-frame": "Wybierz ramk&#x119;, kt&#xF3;rej chcesz u&#x17C;y&#x107; jako zrzutu ekranu.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Rejestrator ekranu nie jest obs&#x142;ugiwany na tym urz&#x105;dzeniu",
                  "ba-videorecorder.trim-prompt": "Czy chcesz przyci&#x105;&#x107; sw&#xF3;j film?",
                  "ba-videorecorder.trim-video": "Przesu&#x144; znaczniki pocz&#x105;tku i ko&#x144;ca, aby przyci&#x105;&#x107; film",
                  "ba-videorecorder.wait-for-trim": "Oczekiwanie na polecenie przyci&#x119;cia...",
                  "ba-videorecorder-controlbar.no-video-source": "Brakuje dodatkowego &#x17A;r&#xF3;d&#x142;a wej&#x15B;cia wideo",
                  "ba-videorecorder-controlbar.stream-already-selected": "Dodatkowy strumie&#x144; zosta&#x142; ju&#x17C; wybrany",
                  "ba-videorecorder.uploading-src-error": "Nie mo&#x17C;na teraz odtworzy&#x107; filmu, przesy&#x142;anie jest nadal w toku",
                  "ba-audiorecorder-controlbar.pause-recorder": "Wstrzymaj rejestrator",
                  "ba-audiorecorder-controlbar.resume-recorder": "Rejestrator CV"
                },
                "language:pt-br": {
                  "ba-videoplayer-playbutton.tooltip": "Clique para reproduzir v&#xED;deo.",
                  "ba-videoplayer-playbutton.rerecord": "Regravar",
                  "ba-videoplayer-playbutton.submit-video": "confirmar v&#xED;deo",
                  "ba-videoplayer-loader.tooltip": "Carregando v&#xED;deo...",
                  "ba-videoplayer-controlbar.change-resolution": "alterar resolu&#xE7;&#xE3;o",
                  "ba-videoplayer-controlbar.video-progress": "Progresso",
                  "ba-videoplayer-controlbar.rerecord-video": "Regravar v&#xED;deo?",
                  "ba-videoplayer-controlbar.submit-video": "confirmar v&#xED;deo",
                  "ba-videoplayer-controlbar.play-video": "reproduzir v&#xED;deo",
                  "ba-videoplayer-controlbar.pause-video": "pausar v&#xED;deo",
                  "ba-videoplayer-controlbar.elapsed-time": "tempo decorrido",
                  "ba-videoplayer-controlbar.total-time": "tempo total do v&#xED;deo",
                  "ba-videoplayer-controlbar.fullscreen-video": "Exibir em tela cheia",
                  "ba-videoplayer-controlbar.volume-button": "definir volume",
                  "ba-videoplayer-controlbar.volume-mute": "silenciar &#xE1;udio",
                  "ba-videoplayer-controlbar.volume-unmute": "ativar o &#xE1;udio",
                  "ba-videoplayer.video-error": "Ocorreu um erro. Por favor tente novamente mais tarde. Clique para tentar novamente.",
                  "ba-videorecorder-chooser.record-video": "Gravar v&#xED;deo",
                  "ba-videorecorder-chooser.upload-video": "Enviar v&#xED;deo",
                  "ba-videorecorder-controlbar.settings": "Configura&#xE7;&#xF5;es",
                  "ba-videorecorder-controlbar.camerahealthy": "Ilumina&#xE7;&#xE3;o est&#xE1; boa",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Ilumina&#xE7;&#xE3;o n&#xE3;o &#xE9; ideal",
                  "ba-videorecorder-controlbar.microphonehealthy": "O &#xE1;udio est&#xE1; bom",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "N&#xE3;o &#xE9; poss&#xED;vel captar nenhum som",
                  "ba-videorecorder-controlbar.record": "Gravar",
                  "ba-videorecorder-controlbar.record-tooltip": "Clique aqui para gravar.",
                  "ba-videorecorder-controlbar.rerecord": "Regravar",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Clique aqui para regravar.",
                  "ba-videorecorder-controlbar.upload-covershot": "Envio",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Clique aqui para enviar imagem personalizada de capa",
                  "ba-videorecorder-controlbar.stop": "Pare",
                  "ba-videorecorder-controlbar.stop-tooltip": "Clique aqui para parar a grava&#xE7;&#xE3;o.",
                  "ba-videorecorder-controlbar.skip": "Pular",
                  "ba-videorecorder-controlbar.skip-tooltip": "Clique aqui para pular.",
                  "ba-videorecorder.recorder-error": "Ocorreu um erro. Por favor tente novamente mais tarde. Clique para tentar novamente.",
                  "ba-videorecorder.attach-error": "N&#xE3;o foi poss&#xED;vel acessar a interface da c&#xE2;mera. Dependendo do dispositivo e navegador pode ser necess&#xE1;rio instalar o Flash ou acessar a p&#xE1;gina atrav&#xE9;s de SSL.",
                  "ba-videorecorder.access-forbidden": "N&#xE3;o foi autorizado acesso &#xE0; c&#xE2;mera. Clique para tentar novamente.",
                  "ba-videorecorder.pick-covershot": "Escolha uma imagem de capa.",
                  "ba-videorecorder.uploading": "Enviando",
                  "ba-videorecorder.uploading-failed": "Upload falhou - clique aqui para tentar novamente.",
                  "ba-videorecorder.verifying": "Verificando",
                  "ba-videorecorder.verifying-failed": "Verifica&#xE7;&#xE3;o falhou - clique aqui para tentar novamente.",
                  "ba-videorecorder.rerecord-confirm": "Voc&#xEA; realmente deseja regravar o v&#xED;deo?",
                  "ba-videorecorder.video_file_too_large": "O arquivo de v&#xED;deo &#xE9; muito grande (%s) - clique aqui para tentar novamente com um arquivo de v&#xED;deo menor.",
                  "ba-videorecorder.unsupported_video_type": "Fa&#xE7;a o upload: %s - clique aqui para tentar novamente.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Sair da tela cheia",
                  "ba-videoplayer-share.share": "Compartilhar v&#xED;deo",
                  "ba-videorecorder-chooser.record-screen": "Tela de grava&#xE7;&#xE3;o",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pausa n&#xE3;o suportada",
                  "ba-videorecorder-chooser.record-audio": "Gravar &#xE1;udio",
                  "ba-videorecorder-controlbar.stop-available-after": "O tempo m&#xED;nimo de grava&#xE7;&#xE3;o &#xE9; %d segundos",
                  "ba-videorecorder-controlbar.cancel": "Cancelar",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Clique aqui para cancelar.",
                  "ba-videorecorder.cancel-confirm": "Voc&#xEA; deseja realmente cancelar o upload de seu v&#xED;deo?",
                  "ba-videoplayer-adslot.elapsed-time": "Tempo Decorrido",
                  "ba-videoplayer-adslot.volume-button": "Definir volume",
                  "ba-videoplayer-adslot.volume-mute": "Silenciar &#xE1;udio",
                  "ba-videoplayer-adslot.volume-unmute": "Ativar &#xE1;udio",
                  "ba-videoplayer-adslot.ad-will-end-after": "O an&#xFA;ncio terminar&#xE1; ap&#xF3;s %s",
                  "ba-videoplayer-adslot.can-skip-after": "Pular ap&#xF3;s %d",
                  "ba-videoplayer-adslot.skip-ad": "Pular An&#xFA;ncio",
                  "ba-videorecorder.software-required": "Clique abaixo para instalar / ativar os seguintes requisitos para prosseguir.",
                  "ba-videorecorder.software-waiting": "Esperando que os requisitos sejam instalados / ativados. Talvez seja necess&#xE1;rio atualizar a p&#xE1;gina ap&#xF3;s a conclus&#xE3;o.",
                  "ba-videoplayer-controlbar.close-tracks": "Fechar CC",
                  "ba-videoplayer-controlbar.show-tracks": "Mostrar CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Enviar legenda",
                  "ba-videoplayer-tracks.select-text-track-language": "Idioma das legendas",
                  "ba-videoplayer-tracks.info-select-locale-first": "Primeiro selecione a localiza&#xE7;&#xE3;o",
                  "ba-videoplayer-tracks.select-text-track-file": "Clique para selecionar o arquivo",
                  "ba-videoplayer-tracks.back": "voltar",
                  "ba-videorecorder.framerate-warning": "A taxa de frames por segundo do v&#xED;deo &#xE9; muito baixa. Recomendamos fechar todos os outros programas e guias do navegador ou usar um computador mais r&#xE1;pido.",
                  "ba-videorecorder.upload-error-duration": "A dura&#xE7;&#xE3;o do v&#xED;deo enviado n&#xE3;o atende aos requisitos. Clique aqui para tentar novamente.",
                  "ba-videorecorder.resolution-constraint-error": "O arquivo que voc&#xEA; selecionou n&#xE3;o corresponde &#xE0; resolu&#xE7;&#xE3;o necess&#xE1;ria - clique aqui para tentar novamente.",
                  "ba-videorecorder.orientation-portrait-required": "Por favor, gire seu dispositivo para gravar no modo retrato.",
                  "ba-videorecorder.orientation-landscape-required": "Por favor, gire seu dispositivo para gravar no modo paisagem.",
                  "ba-imageviewer-controlbar.rerecord-image": "Refazer",
                  "ba-imageviewer-controlbar.submit-image": "confirmar",
                  "ba-imageviewer-controlbar.fullscreen-image": "Entrar em tela cheia",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Sair da tela cheia",
                  "ba-imageviewer.image-error": "Ocorreu um erro. Por favor tente novamente mais tarde. Clique para tentar novamente.",
                  "ba-imagecapture-chooser.image-capture": "Capturar imagem",
                  "ba-imagecapture-chooser.upload-image": "Enviar Imagem",
                  "ba-imagecapture-controlbar.settings": "Configura&#xE7;&#xF5;es",
                  "ba-imagecapture-controlbar.camerahealthy": "Ilumina&#xE7;&#xE3;o est&#xE1; boa",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Ilumina&#xE7;&#xE3;o n&#xE3;o &#xE9; ideal",
                  "ba-imagecapture-controlbar.record": "Capturar",
                  "ba-imagecapture-controlbar.record-tooltip": "Clique aqui para capturar.",
                  "ba-imagecapture-controlbar.rerecord": "Refazer",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Clique aqui para refazer.",
                  "ba-imagecapture-controlbar.cancel": "Cancelar",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Clique aqui para cancelar.",
                  "ba-audioplayer-controlbar.audio-progress": "Progresso",
                  "ba-audioplayer-controlbar.rerecord-audio": "Refazer",
                  "ba-audioplayer-controlbar.submit-audio": "confirmar",
                  "ba-audioplayer-controlbar.play-audio": "Tocar &#xE1;udio",
                  "ba-audioplayer-controlbar.pause-audio": "Pausar &#xE1;udio",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pausa n&#xE3;o suportada",
                  "ba-audioplayer-controlbar.elapsed-time": "Tempo decorrido",
                  "ba-audioplayer-controlbar.total-time": "tempo total do &#xE1;udio",
                  "ba-audioplayer-controlbar.volume-button": "Definir volume",
                  "ba-audioplayer-controlbar.volume-mute": "Silenciar &#xE1;udio",
                  "ba-audioplayer-controlbar.volume-unmute": "Ativar &#xE1;udio",
                  "ba-audioplayer-loader.tooltip": "Carregando...",
                  "ba-audioplayer.audio-error": "Ocorreu um erro. Por favor tente novamente mais tarde. Clique para tentar novamente.",
                  "ba-audiorecorder-chooser.record-audio": "Gravar audio",
                  "ba-audiorecorder-chooser.upload-audio": "Carregar &#xE1;udio",
                  "ba-audiorecorder-controlbar.settings": "Configura&#xE7;&#xF5;es",
                  "ba-audiorecorder-controlbar.microphonehealthy": "O &#xE1;udio est&#xE1; bom",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "N&#xE3;o &#xE9; poss&#xED;vel captar nenhum som",
                  "ba-audiorecorder-controlbar.record": "Gravar",
                  "ba-audiorecorder-controlbar.record-tooltip": "Clique aqui para gravar.",
                  "ba-audiorecorder-controlbar.rerecord": "Refazer",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Clique aqui para refazer.",
                  "ba-audiorecorder-controlbar.stop": "Pare",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Clique aqui para parar a grava&#xE7;&#xE3;o.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Tempo m&#xED;nimo de grava&#xE7;&#xE3;o &#xE9; de %d segundos",
                  "ba-audiorecorder-controlbar.cancel": "Cancelar",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Clique aqui para cancelar.",
                  "ba-videoplayer-controlbar.player-speed": "Velocidade de reprodu&#xE7;&#xE3;o",
                  "ba-videoplayer-controlbar.settings": "Defini&#xE7;&#xF5;es",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "&#xCD;cone de airplay.",
                  "ba-videoplayer.all-settings": "Todas as configura&#xE7;&#xF5;es",
                  "ba-videoplayer.player-speed": "Velocidade de reprodu&#xE7;&#xE3;o",
                  "ba-videoplayer.full-screen": "Tela cheia",
                  "ba-videorecorder-controlbar.add-stream": "Adicionar stream",
                  "ba-videorecorder.switch-camera": "Alternar c&#xE2;mera",
                  "ba-videorecorder.prepare-covershot": "Preparando imagens de capa",
                  "ba-videorecorder.prepare-thumbnails": "Preparando miniaturas em busca",
                  "ba-videorecorder.adding-new-stream": "Adicionando Novo Stream",
                  "ba-imagecapture.recorder-error": "Ocorreu um erro. Por favor tente novamente mais tarde. Clique para tentar novamente.",
                  "ba-imagecapture.attach-error": "N&#xE3;o conseguimos acessar a interface de m&#xED;dia. Dependendo do dispositivo e do navegador, talvez seja necess&#xE1;rio instalar o Flash ou acessar a p&#xE1;gina via SSL.",
                  "ba-imagecapture.software-required": "Por favor, clique abaixo para instalar / ativar os seguintes requisitos para prosseguir.",
                  "ba-imagecapture.software-waiting": "Aguardando que os requisitos sejam instalados / ativados. Pode ser necess&#xE1;rio atualizar a p&#xE1;gina ap&#xF3;s a conclus&#xE3;o.",
                  "ba-imagecapture.access-forbidden": "O acesso &#xE0; m&#xED;dia foi proibido. Clique para tentar novamente.",
                  "ba-imagecapture.uploading": "Upload",
                  "ba-imagecapture.uploading-failed": "O upload falhou - clique aqui para tentar novamente.",
                  "ba-imagecapture.upload-error-duration": "O comprimento da imagem enviada n&#xE3;o atende aos requisitos. Clique aqui para tentar novamente.",
                  "ba-imagecapture.resolution-constraint-error": "O arquivo que voc&#xEA; selecionou n&#xE3;o corresponde &#xE0; resolu&#xE7;&#xE3;o necess&#xE1;ria - clique aqui para tentar novamente.",
                  "ba-imagecapture.verifying": "Verificando",
                  "ba-imagecapture.verifying-failed": "Verifica&#xE7;&#xE3;o falhou - clique aqui para tentar novamente.",
                  "ba-imagecapture.rerecord-confirm": "Voc&#xEA; realmente quer refazer sua imagem?",
                  "ba-imagecapture.image_file_too_large": "Seu arquivo de imagem &#xE9; muito grande (%s) - clique aqui para tentar novamente com um arquivo de imagem menor.",
                  "ba-imagecapture.unsupported_image_type": "Por favor, envie: %s - clique aqui para tentar novamente.",
                  "ba-imagecapture.orientation-portrait-required": "Por favor, gire seu dispositivo para gravar no modo retrato.",
                  "ba-imagecapture.orientation-landscape-required": "Por favor, gire seu dispositivo para gravar no modo paisagem.",
                  "ba-audiorecorder.recorder-error": "Ocorreu um erro. Por favor tente novamente mais tarde. Clique para tentar novamente.",
                  "ba-audiorecorder.attach-error": "N&#xE3;o conseguimos acessar a interface de m&#xED;dia. Dependendo do dispositivo e do navegador talvez seja necess&#xE1;rio instalar o Flash ou acessar a p&#xE1;gina via SSL.",
                  "ba-audiorecorder.software-required": "Por favor, clique abaixo para instalar / ativar os seguintes requisitos para prosseguir.",
                  "ba-audiorecorder.software-waiting": "Aguardando que os requisitos sejam instalados / ativados. Pode ser necess&#xE1;rio atualizar a p&#xE1;gina ap&#xF3;s a conclus&#xE3;o.",
                  "ba-audiorecorder.access-forbidden": "O acesso &#xE0; m&#xED;dia foi proibido. Clique para tentar novamente.",
                  "ba-audiorecorder.uploading": "Enviando",
                  "ba-audiorecorder.uploading-failed": "O upload falhou - clique aqui para tentar novamente.",
                  "ba-audiorecorder.upload-error-duration": "A dura&#xE7;&#xE3;o do &#xE1;udio enviado n&#xE3;o atende aos requisitos. Clique aqui para tentar novamente.",
                  "ba-audiorecorder.verifying": "Verificando",
                  "ba-audiorecorder.verifying-failed": "Verifica&#xE7;&#xE3;o falhou - clique aqui para tentar novamente.",
                  "ba-audiorecorder.rerecord-confirm": "Voc&#xEA; realmente quer refazer seu &#xE1;udio?",
                  "ba-audiorecorder.cancel-confirm": "Voc&#xEA; realmente quer cancelar o envio do seu &#xE1;udio?",
                  "ba-audiorecorder.audio_file_too_large": "Seu arquivo de &#xE1;udio &#xE9; muito grande (%s) - clique aqui para tentar novamente com um arquivo de &#xE1;udio menor.",
                  "ba-audiorecorder.unsupported_audio_type": "Por favor, envie: %s - clique aqui para tentar novamente.",
                  "ba-common-settingsmenu.tooltip": "Clique para jogar.",
                  "ba-common-settingsmenu.setting-menu": "Todas as configura&#xE7;&#xF5;es",
                  "ba-common-settingsmenu.source-quality": "Qualidade da fonte",
                  "ba-common-settingsmenu.player-speed": "Velocidade do jogador",
                  "ba-common-settingsmenu.set-menu-option": "Definir op&#xE7;&#xE3;o",
                  "ba-common-settingsmenu.submit-video": "Confirme o v&#xED;deo",
                  "ba-common-settingsmenu.picture-in-picture": "Imagem na imagem",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Sair da tela inteira",
                  "ba-common-settingsmenu.fullscreen-video": "Entrar em tela cheia",
                  "ba-videorecorder-chooser.multi-stream": "Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Pausar gravador",
                  "ba-videorecorder-controlbar.resume-recorder": "Retomar gravador",
                  "ba-videorecorder.missing-track": "Falta trilha de &#xE1;udio ou v&#xED;deo necess&#xE1;ria",
                  "ba-videorecorder.device-already-in-use": "Pelo menos um de seus dispositivos de entrada j&#xE1; est&#xE1; em uso",
                  "ba-videorecorder.browser-permission-denied": "Permiss&#xE3;o negada pelo navegador, conceda acesso e recarregue a p&#xE1;gina",
                  "ba-audioplayer.all-settings": "Todas as configura&#xE7;&#xF5;es",
                  "ba-videoplayer-controlbar.remaining-time": "Tempo restante",
                  "ba-videoplayer-controlbar.select-frame": "Selecione",
                  "ba-videoplayer-controlbar.trim-video": "Aparar",
                  "ba-videoplayer-playbutton.trim": "Aparar",
                  "ba-videoplayer-playbutton.skip": "Pular",
                  "ba-videorecorder-imagegallery.upload-covershot": "Carregar capa",
                  "ba-videorecorder.pick-covershot-frame": "Selecione um quadro para usar como cobertura.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "O gravador de tela n&#xE3;o &#xE9; compat&#xED;vel com este dispositivo",
                  "ba-videorecorder.trim-prompt": "Voc&#xEA; quer cortar seu v&#xED;deo?",
                  "ba-videorecorder.trim-video": "Mova os marcadores de in&#xED;cio e fim para cortar seu v&#xED;deo",
                  "ba-videorecorder.wait-for-trim": "Esperando pelo comando de corte ...",
                  "ba-videorecorder-controlbar.no-video-source": "Fonte de entrada de v&#xED;deo adicional ausente",
                  "ba-videorecorder-controlbar.stream-already-selected": "Stream adicional j&#xE1; foi selecionado",
                  "ba-videorecorder.uploading-src-error": "N&#xE3;o &#xE9; poss&#xED;vel reproduzir o v&#xED;deo agora, o upload ainda est&#xE1; em andamento",
                  "ba-audiorecorder-controlbar.pause-recorder": "Pausar gravador",
                  "ba-audiorecorder-controlbar.resume-recorder": "Retomar gravador"
                },
                "language:pt": {
                  "ba-videoplayer-playbutton.tooltip": "Clique para reproduzir",
                  "ba-videoplayer-playbutton.rerecord": "Repetir",
                  "ba-videoplayer-playbutton.submit-video": "Enviar v&#xED;deo",
                  "ba-videoplayer-loader.tooltip": "A Carregar...",
                  "ba-videoplayer-controlbar.change-resolution": "Alterar resolu&#xE7;&#xE3;o",
                  "ba-videoplayer-controlbar.video-progress": "Progresso",
                  "ba-videoplayer-controlbar.rerecord-video": "Repetir?",
                  "ba-videoplayer-controlbar.submit-video": "Confirmar",
                  "ba-videoplayer-controlbar.play-video": "Ver V&#xED;deo",
                  "ba-videoplayer-controlbar.pause-video": "Pausa",
                  "ba-videoplayer-controlbar.elapsed-time": "Tempo decorrido",
                  "ba-videoplayer-controlbar.total-time": "Tempo Total",
                  "ba-videoplayer-controlbar.fullscreen-video": "Modo ecr&#xE3; inteiro",
                  "ba-videoplayer-controlbar.volume-button": "Definir volume",
                  "ba-videoplayer-controlbar.volume-mute": "Silenciar Som",
                  "ba-videoplayer-controlbar.volume-unmute": "Ativar Som",
                  "ba-videoplayer.video-error": "Ocorreu um erro. Por favor tente de novo mais tarde. Clique para tentar novamente.",
                  "ba-videorecorder-chooser.record-video": "Gravar V&#xED;deo",
                  "ba-videorecorder-chooser.upload-video": "Enviar V&#xED;deo",
                  "ba-videorecorder-controlbar.settings": "Configura&#xE7;&#xF5;es",
                  "ba-videorecorder-controlbar.camerahealthy": "A ilumina&#xE7;&#xE3;o est&#xE1; boa",
                  "ba-videorecorder-controlbar.cameraunhealthy": "A ilumina&#xE7;&#xE3;o n&#xE3;o &#xE9; ideal",
                  "ba-videorecorder-controlbar.microphonehealthy": "O som est&#xE1; bom",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "N&#xE3;o foi poss&#xED;vel ouvir nenhum som",
                  "ba-videorecorder-controlbar.record": "Gravar",
                  "ba-videorecorder-controlbar.record-tooltip": "Clique aqui para gravar",
                  "ba-videorecorder-controlbar.rerecord": "Repetir",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Clique aqui para repetir",
                  "ba-videorecorder-controlbar.upload-covershot": "Enviar",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Clique aqui para enviar a captura de capa personalizada",
                  "ba-videorecorder-controlbar.stop": "Parar",
                  "ba-videorecorder-controlbar.stop-tooltip": "Clique aqui para parar",
                  "ba-videorecorder-controlbar.skip": "Ignorar",
                  "ba-videorecorder-controlbar.skip-tooltip": "Clique aqui para ignorar",
                  "ba-videorecorder.recorder-error": "Ocorreu um erro. Por favor tente novamente mais tarde. Clique para tentar novamente.",
                  "ba-videorecorder.attach-error": "N&#xE3;o conseguimos aceder &#xE0; c&#xE2;mara. Dependendo do dispositivo e do navegador, pode ser necess&#xE1;rio instalar o Flash ou aceder &#xE0; p&#xE1;gina via SSL.",
                  "ba-videorecorder.access-forbidden": "O acesso &#xE0; c&#xE2;mara foi pro&#xED;bido. Clique para tentar novamente.",
                  "ba-videorecorder.pick-covershot": "Escolha uma capa personalizada",
                  "ba-videorecorder.uploading": "A enviar",
                  "ba-videorecorder.uploading-failed": "O envio falhou - clique para tentar de novo",
                  "ba-videorecorder.verifying": "A verificar",
                  "ba-videorecorder.verifying-failed": "A verifica&#xE7;&#xE3;o falhou - clique para tentar de novo",
                  "ba-videorecorder.rerecord-confirm": "Quer mesmo repetir o seu v&#xED;deo?",
                  "ba-videorecorder.video_file_too_large": "O seu v&#xED;deo &#xE9; demasiado grande (%s) - clique para tentar de novo com um v&#xED;deo mais pequeno.",
                  "ba-videorecorder.unsupported_video_type": "Por favor, envie: %s - clique para tentar de novo.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Sair do modo ecr&#xE3; inteiro",
                  "ba-videoplayer-share.share": "Partilhar a grava&#xE7;&#xE3;o",
                  "ba-videoplayer-controlbar.pause-video-disabled": "A pausa n&#xE3;o &#xE9; suportada",
                  "ba-videorecorder-chooser.record-audio": "Gravar &#xC1;udio",
                  "ba-videorecorder-chooser.record-screen": "Captura de ecr&#xE3;",
                  "ba-videorecorder-controlbar.stop-available-after": "O tempo m&#xED;nimo de grava&#xE7;&#xE3;o &#xE9; %d segundos",
                  "ba-videorecorder-controlbar.cancel": "Cancelar",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Clique aqui para cancelar.",
                  "ba-videorecorder.cancel-confirm": "Voc&#xEA; deseja realmente cancelar o upload de seu v&#xED;deo?",
                  "ba-videoplayer-adslot.elapsed-time": "Tempo Decorrido",
                  "ba-videoplayer-adslot.volume-button": "Definir volume",
                  "ba-videoplayer-adslot.volume-mute": "Silenciar Som",
                  "ba-videoplayer-adslot.volume-unmute": "Ativar Som",
                  "ba-videoplayer-adslot.ad-will-end-after": "O an&#xFA;ncio terminar&#xE1; ap&#xF3;s %s",
                  "ba-videoplayer-adslot.can-skip-after": "Ignorar ap&#xF3;s %d",
                  "ba-videoplayer-adslot.skip-ad": "Saltar An&#xFA;ncio",
                  "ba-videorecorder.software-required": "Clique abaixo para instalar / ativar os seguintes requisitos para prosseguir.",
                  "ba-videorecorder.software-waiting": "Esperando que os requisitos sejam instalados / ativados. Talvez seja necess&#xE1;rio atualizar a p&#xE1;gina ap&#xF3;s a conclus&#xE3;o.",
                  "ba-videoplayer-controlbar.close-tracks": "Fechar CC",
                  "ba-videoplayer-controlbar.show-tracks": "Mostrar CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Carregar arquivos de texto da faixa",
                  "ba-videoplayer-tracks.select-text-track-language": "Idioma das legendas",
                  "ba-videoplayer-tracks.info-select-locale-first": "Primeiro selecione o local",
                  "ba-videoplayer-tracks.select-text-track-file": "Clique para selecionar o arquivo",
                  "ba-videoplayer-tracks.back": "voltar",
                  "ba-videorecorder.framerate-warning": "A taxa de quadros do v&#xED;deo &#xE9; muito baixa. Recomendamos fechar todos os outros programas e guias do navegador ou usar um computador mais r&#xE1;pido.",
                  "ba-videorecorder.upload-error-duration": "A dura&#xE7;&#xE3;o do v&#xED;deo enviado n&#xE3;o atende aos requisitos. Clique aqui para tentar novamente.",
                  "ba-videorecorder.resolution-constraint-error": "O arquivo que voc&#xEA; selecionou n&#xE3;o corresponde &#xE0; resolu&#xE7;&#xE3;o necess&#xE1;ria - clique aqui para tentar novamente.",
                  "ba-videorecorder.orientation-portrait-required": "Por favor, gire o seu dispositivo para gravar no modo retrato.",
                  "ba-videorecorder.orientation-landscape-required": "Por favor, gire o seu dispositivo para gravar no modo paisagem.",
                  "ba-imageviewer-controlbar.rerecord-image": "Refazer",
                  "ba-imageviewer-controlbar.submit-image": "confirmar",
                  "ba-imageviewer-controlbar.fullscreen-image": "Entrar em ecr&#xE3; inteiro",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Sair de ecr&#xE3; inteiro",
                  "ba-imageviewer.image-error": "Ocorreu um erro. Por favor tente novamente mais tarde. Clique para tentar novamente.",
                  "ba-imagecapture-chooser.image-capture": "Capturar imagem",
                  "ba-imagecapture-chooser.upload-image": "Enviar Imagem",
                  "ba-imagecapture-controlbar.settings": "Configura&#xE7;&#xF5;es",
                  "ba-imagecapture-controlbar.camerahealthy": "Ilumina&#xE7;&#xE3;o est&#xE1; boa",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Ilumina&#xE7;&#xE3;o n&#xE3;o &#xE9; ideal",
                  "ba-imagecapture-controlbar.record": "Capturar",
                  "ba-imagecapture-controlbar.record-tooltip": "Clique aqui para capturar.",
                  "ba-imagecapture-controlbar.rerecord": "Refazer",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Clique aqui para refazer.",
                  "ba-imagecapture-controlbar.cancel": "Cancelar",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Clique aqui para cancelar.",
                  "ba-audioplayer-controlbar.audio-progress": "Progresso",
                  "ba-audioplayer-controlbar.rerecord-audio": "Refazer",
                  "ba-audioplayer-controlbar.submit-audio": "confirmar",
                  "ba-audioplayer-controlbar.play-audio": "Tocar",
                  "ba-audioplayer-controlbar.pause-audio": "Pausar",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pausa n&#xE3;o suportada",
                  "ba-audioplayer-controlbar.elapsed-time": "Tempo decorrido",
                  "ba-audioplayer-controlbar.total-time": "Tempo total",
                  "ba-audioplayer-controlbar.volume-button": "Definir volume",
                  "ba-audioplayer-controlbar.volume-mute": "Som mudo",
                  "ba-audioplayer-controlbar.volume-unmute": "Ativar som",
                  "ba-audioplayer-loader.tooltip": "Carregando...",
                  "ba-audioplayer.audio-error": "Ocorreu um erro. Por favor tente novamente mais tarde. Clique para tentar novamente.",
                  "ba-audiorecorder-chooser.record-audio": "Gravar audio",
                  "ba-audiorecorder-chooser.upload-audio": "Carregar &#xE1;udio",
                  "ba-audiorecorder-controlbar.settings": "Configura&#xE7;&#xF5;es",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Som est&#xE1; bom",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "N&#xE3;o &#xE9; poss&#xED;vel captar nenhum som",
                  "ba-audiorecorder-controlbar.record": "Gravar",
                  "ba-audiorecorder-controlbar.record-tooltip": "Clique aqui para gravar.",
                  "ba-audiorecorder-controlbar.rerecord": "Refazer",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Clique aqui para refazer.",
                  "ba-audiorecorder-controlbar.stop": "Pare",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Clique aqui para parar.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Tempo m&#xED;nimo de grava&#xE7;&#xE3;o &#xE9; de %d segundos",
                  "ba-audiorecorder-controlbar.cancel": "Cancelar",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Clique aqui para cancelar.",
                  "ba-videoplayer-controlbar.player-speed": "Velocidade de reprodu&#xE7;&#xE3;o",
                  "ba-videoplayer-controlbar.settings": "Defini&#xE7;&#xF5;es",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "&#xCD;cone de airplay.",
                  "ba-videoplayer.all-settings": "Todas as configura&#xE7;&#xF5;es",
                  "ba-videoplayer.player-speed": "Velocidade de reprodu&#xE7;&#xE3;o",
                  "ba-videoplayer.full-screen": "Modo ecr&#xE3; inteiro",
                  "ba-videorecorder-controlbar.add-stream": "Adicionar stream",
                  "ba-videorecorder.switch-camera": "Alternar c&#xE2;mera",
                  "ba-videorecorder.prepare-covershot": "Preparando covershots",
                  "ba-videorecorder.prepare-thumbnails": "Preparando a busca de miniaturas",
                  "ba-videorecorder.adding-new-stream": "Adicionando Novo Stream",
                  "ba-imagecapture.recorder-error": "Ocorreu um erro. Por favor tente novamente mais tarde. Clique para tentar novamente.",
                  "ba-imagecapture.attach-error": "N&#xE3;o conseguimos acessar a interface de m&#xED;dia. Dependendo do dispositivo e do navegador, talvez seja necess&#xE1;rio instalar o Flash ou acessar a p&#xE1;gina via SSL.",
                  "ba-imagecapture.software-required": "Por favor, clique abaixo para instalar / ativar os seguintes requisitos para prosseguir.",
                  "ba-imagecapture.software-waiting": "Aguardando que os requisitos sejam instalados / ativados. Pode ser necess&#xE1;rio atualizar a p&#xE1;gina ap&#xF3;s a conclus&#xE3;o.",
                  "ba-imagecapture.access-forbidden": "O acesso &#xE0; m&#xED;dia foi proibido. Clique para tentar novamente.",
                  "ba-imagecapture.uploading": "Enviando",
                  "ba-imagecapture.uploading-failed": "O upload falhou - clique aqui para tentar novamente.",
                  "ba-imagecapture.upload-error-duration": "O comprimento da imagem enviada n&#xE3;o atende aos requisitos. Clique aqui para tentar novamente.",
                  "ba-imagecapture.resolution-constraint-error": "O arquivo que voc&#xEA; selecionou n&#xE3;o corresponde &#xE0; resolu&#xE7;&#xE3;o necess&#xE1;ria - clique aqui para tentar novamente.",
                  "ba-imagecapture.verifying": "Verificando",
                  "ba-imagecapture.verifying-failed": "Verifica&#xE7;&#xE3;o falhou - clique aqui para tentar novamente.",
                  "ba-imagecapture.rerecord-confirm": "Voc&#xEA; realmente quer refazer sua imagem?",
                  "ba-imagecapture.image_file_too_large": "Seu arquivo de imagem &#xE9; muito grande (%s) - clique aqui para tentar novamente com um arquivo de imagem menor.",
                  "ba-imagecapture.unsupported_image_type": "Carregue por favor: %s - clique aqui para tentar novamente.",
                  "ba-imagecapture.orientation-portrait-required": "Por favor, gire o seu dispositivo para gravar no modo retrato.",
                  "ba-imagecapture.orientation-landscape-required": "Por favor, gire o seu dispositivo para gravar no modo paisagem.",
                  "ba-audiorecorder.recorder-error": "Ocorreu um erro. Por favor tente novamente mais tarde. Clique para tentar novamente.",
                  "ba-audiorecorder.attach-error": "N&#xE3;o conseguimos acessar a interface de m&#xED;dia. Dependendo do dispositivo e do navegador, talvez seja necess&#xE1;rio instalar o Flash ou acessar a p&#xE1;gina via SSL.",
                  "ba-audiorecorder.software-required": "Por favor, clique abaixo para instalar / ativar os seguintes requisitos para prosseguir.",
                  "ba-audiorecorder.software-waiting": "Aguardando que os requisitos sejam instalados / ativados. Pode ser necess&#xE1;rio atualizar a p&#xE1;gina ap&#xF3;s a conclus&#xE3;o.",
                  "ba-audiorecorder.access-forbidden": "O acesso &#xE0; m&#xED;dia foi proibido. Clique para tentar novamente.",
                  "ba-audiorecorder.uploading": "Upload",
                  "ba-audiorecorder.uploading-failed": "O upload falhou - clique aqui para tentar novamente.",
                  "ba-audiorecorder.upload-error-duration": "O comprimento do &#xE1;udio enviado n&#xE3;o atende aos requisitos. Clique aqui para tentar novamente.",
                  "ba-audiorecorder.verifying": "Verificando",
                  "ba-audiorecorder.verifying-failed": "Verificando falhou - clique aqui para tentar novamente.",
                  "ba-audiorecorder.rerecord-confirm": "Voc&#xEA; realmente quer refazer o seu &#xE1;udio?",
                  "ba-audiorecorder.cancel-confirm": "Voc&#xEA; realmente quer cancelar o seu upload de &#xE1;udio?",
                  "ba-audiorecorder.audio_file_too_large": "Seu arquivo de &#xE1;udio &#xE9; muito grande (%s) - clique aqui para tentar novamente com um arquivo de &#xE1;udio menor.",
                  "ba-audiorecorder.unsupported_audio_type": "Carregue por favor: %s - clique aqui para tentar novamente.",
                  "ba-common-settingsmenu.tooltip": "Clique para reproduzir.",
                  "ba-common-settingsmenu.setting-menu": "Todas as configura&#xE7;&#xF5;es",
                  "ba-common-settingsmenu.source-quality": "Qualidade da fonte",
                  "ba-common-settingsmenu.player-speed": "Velocidade de reprodu&#xE7;&#xE3;o",
                  "ba-common-settingsmenu.set-menu-option": "Definir op&#xE7;&#xE3;o",
                  "ba-common-settingsmenu.submit-video": "Confirmar v&#xED;deo",
                  "ba-common-settingsmenu.picture-in-picture": "Picture in picture",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Sair do modo ecr&#xE3; inteiro",
                  "ba-common-settingsmenu.fullscreen-video": "Entrar em modo ecr&#xE3; inteiro",
                  "ba-videorecorder-chooser.multi-stream": "Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Pausar gravador",
                  "ba-videorecorder-controlbar.resume-recorder": "Resumir gravador",
                  "ba-videorecorder.missing-track": "Falta a pista de &#xE1;udio ou v&#xED;deo necess&#xE1;ria",
                  "ba-videorecorder.device-already-in-use": "Pelo menos um dos seus dispositivos de entrada est&#xE1; em uso",
                  "ba-videorecorder.browser-permission-denied": "Permiss&#xE3;o negada pelo navegador, por favor conceda acesso e recarregue a p&#xE1;gina",
                  "ba-audioplayer.all-settings": "Todas as configura&#xE7;&#xF5;es",
                  "ba-videoplayer-controlbar.remaining-time": "Tempo restante",
                  "ba-videoplayer-controlbar.select-frame": "Selecione",
                  "ba-videoplayer-controlbar.trim-video": "Aparar",
                  "ba-videoplayer-playbutton.trim": "Aparar",
                  "ba-videoplayer-playbutton.skip": "Pular",
                  "ba-videorecorder-imagegallery.upload-covershot": "Carregar capa",
                  "ba-videorecorder.pick-covershot-frame": "Selecione um quadro para usar como cobertura.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "O gravador de tela n&#xE3;o &#xE9; compat&#xED;vel com este dispositivo",
                  "ba-videorecorder.trim-prompt": "Voc&#xEA; quer cortar seu v&#xED;deo?",
                  "ba-videorecorder.trim-video": "Mova os marcadores de in&#xED;cio e fim para cortar seu v&#xED;deo",
                  "ba-videorecorder.wait-for-trim": "Esperando pelo comando de corte ...",
                  "ba-videorecorder-controlbar.no-video-source": "Fonte de entrada de v&#xED;deo adicional ausente",
                  "ba-videorecorder-controlbar.stream-already-selected": "Stream adicional j&#xE1; foi selecionado",
                  "ba-videorecorder.uploading-src-error": "N&#xE3;o &#xE9; poss&#xED;vel reproduzir o v&#xED;deo agora, o upload ainda est&#xE1; em andamento",
                  "ba-audiorecorder-controlbar.pause-recorder": "Pausar gravador",
                  "ba-audiorecorder-controlbar.resume-recorder": "Retomar gravador"
                },
                "language:ro": {
                  "ba-videoplayer-playbutton.tooltip": "Click aici pentru a reda video.",
                  "ba-videoplayer-playbutton.rerecord": "&#xCE;nregistreaz&#x103; din nou",
                  "ba-videoplayer-playbutton.submit-video": "confirm&#x103; film",
                  "ba-videoplayer-loader.tooltip": "Se &#xEE;ncarc&#x103; videoclipul ...",
                  "ba-videoplayer-controlbar.change-resolution": "Schimba&#x21B;i rezolu&#x21B;ia",
                  "ba-videoplayer-controlbar.video-progress": "progresul video",
                  "ba-videoplayer-controlbar.rerecord-video": "Reface&#x21B;i video?",
                  "ba-videoplayer-controlbar.submit-video": "confirm&#x103; film",
                  "ba-videoplayer-controlbar.play-video": "Ruleaz&#x103; video",
                  "ba-videoplayer-controlbar.pause-video": "Pauz&#x103; video",
                  "ba-videoplayer-controlbar.elapsed-time": "timp scurs",
                  "ba-videoplayer-controlbar.total-time": "Lungimea total&#x103; a videoclipului",
                  "ba-videoplayer-controlbar.fullscreen-video": "M&#x103;re&#x219;te pe tot ecranul",
                  "ba-videoplayer-controlbar.volume-button": "reglajul volumului",
                  "ba-videoplayer-controlbar.volume-mute": "opre&#x219;te sunet",
                  "ba-videoplayer-controlbar.volume-unmute": "repornirea sunetului",
                  "ba-videoplayer.video-error": "A ap&#x103;rut o eroare, v&#x103; rug&#x103;m s&#x103; &#xEE;ncerca&#x21B;i din nou mai t&#xE2;rziu. Click aici pentru a &#xEE;ncerca din nou.",
                  "ba-videorecorder-chooser.record-video": "&#xCE;nregistrarea Dvs. video",
                  "ba-videorecorder-chooser.upload-video": "&#xCE;ncarc&#x103; film",
                  "ba-videorecorder-controlbar.settings": "set&#x103;rile",
                  "ba-videorecorder-controlbar.camerahealthy": "Lumina este optim&#x103;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Lumina nu este optim&#x103;",
                  "ba-videorecorder-controlbar.microphonehealthy": "Sunetul este bun",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Sunetul nu poate fi &#xEE;nregistrat",
                  "ba-videorecorder-controlbar.record": "&#xCE;nregistreaz&#x103;",
                  "ba-videorecorder-controlbar.record-tooltip": "Apasa aici pentru a &#xEE;nregistra.",
                  "ba-videorecorder-controlbar.rerecord": "&#xCE;nregistreaz&#x103; din nou",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Apasa aici pentru a reface.",
                  "ba-videorecorder-controlbar.upload-covershot": "&#xCE;nc&#x103;rca&#x21B;i",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Apasa aici pentru a &#xEE;nc&#x103;rca o copert&#x103; personalizat&#x103;",
                  "ba-videorecorder-controlbar.stop": "Stop",
                  "ba-videorecorder-controlbar.stop-tooltip": "Apasa aici pentru a opri.",
                  "ba-videorecorder-controlbar.skip": "sari",
                  "ba-videorecorder-controlbar.skip-tooltip": "Apasa aici pentru a s&#x103;ri peste.",
                  "ba-videorecorder.recorder-error": "A ap&#x103;rut o eroare, v&#x103; rug&#x103;m s&#x103; &#xEE;ncerca&#x21B;i din nou mai t&#xE2;rziu. Click aici pentru a &#xEE;ncerca din nou.",
                  "ba-videorecorder.attach-error": "Nu am putut accesa interfa&#x21B;a camerei. &#xCE;n func&#x21B;ie de dispozitiv &#x219;i de browser-ul folosit, poate fi necesar s&#x103; instala&#x21B;i Flash sau accesa pagina prin SSL.",
                  "ba-videorecorder.access-forbidden": "Accesul la camera a fost interzis. Click aici pentru a &#xEE;ncerca din nou.",
                  "ba-videorecorder.pick-covershot": "Alege o copert&#x103;.",
                  "ba-videorecorder.uploading": "Se &#xEE;ncarc&#x103;",
                  "ba-videorecorder.uploading-failed": "&#xCE;nc&#x103;rcarea nu a reu&#x219;it - clic aici pentru a &#xEE;ncerca din nou.",
                  "ba-videorecorder.verifying": "Se verific&#x103;",
                  "ba-videorecorder.verifying-failed": "Verificarea nu a reu&#x219;it - clic aici pentru a &#xEE;ncerca din nou.",
                  "ba-videorecorder.rerecord-confirm": "Sunte&#x21B;i sigur c&#x103; vre&#x21B;i s&#x103; reface&#x21B;i videoclipul?",
                  "ba-videorecorder.video_file_too_large": "Fi&#x219;ierul dvs. video este prea mare (%s) - click aici pentru a &#xEE;ncerca din nou cu un fi&#x219;ier video mai mic.",
                  "ba-videorecorder.unsupported_video_type": "V&#x103; rug&#x103;m s&#x103; &#xEE;nc&#x103;rca&#x21B;i: %s - clic aici pentru a &#xEE;ncerca din nou.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Ie&#x219;i&#x21B;i din ecranul complet",
                  "ba-videoplayer-share.share": "Distribui&#x21B;i videoclipul",
                  "ba-videorecorder-chooser.record-screen": "Ecranul de &#xEE;nregistrare",
                  "ba-videoplayer-controlbar.pause-video-disabled": "&#xCE;ntreruperea nu este acceptat&#x103;",
                  "ba-videorecorder-chooser.record-audio": "&#xCE;nregistreaz&#x103; audio",
                  "ba-videorecorder-controlbar.stop-available-after": "Durata minim&#x103; de &#xEE;nregistrare este %d secunde",
                  "ba-videorecorder-controlbar.cancel": "Anulare",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Face&#x21B;i clic aici pentru a anula.",
                  "ba-videorecorder.cancel-confirm": "Chiar vrei s&#x103; anulezi &#xEE;nc&#x103;rcarea videoclipului?",
                  "ba-videoplayer-adslot.elapsed-time": "Timp scurs",
                  "ba-videoplayer-adslot.volume-button": "Seta&#x21B;i volumul",
                  "ba-videoplayer-adslot.volume-mute": "Opri&#x21B;i sunetul",
                  "ba-videoplayer-adslot.volume-unmute": "Debloca&#x21B;i sunetul",
                  "ba-videoplayer-adslot.ad-will-end-after": "Anun&#x21B;ul se va &#xEE;ncheia dup&#x103; %s",
                  "ba-videoplayer-adslot.can-skip-after": "S&#x103;ri&#x21B;i dup&#x103; %d",
                  "ba-videoplayer-adslot.skip-ad": "&#x218;terge&#x21B;i anun&#x21B;ul",
                  "ba-videorecorder.software-required": "Face&#x21B;i clic mai jos pentru a instala / activa urm&#x103;toarele cerin&#x21B;e pentru a continua.",
                  "ba-videorecorder.software-waiting": "Se a&#x219;teapt&#x103; ca cerin&#x21B;ele s&#x103; fie instalate / activate. Poate fi necesar s&#x103; actualiza&#x21B;i pagina dup&#x103; finalizare.",
                  "ba-videoplayer-controlbar.close-tracks": "&#xCE;nchide&#x21B;i CC",
                  "ba-videoplayer-controlbar.show-tracks": "Ar&#x103;ta&#x21B;i CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "&#xCE;nc&#x103;rca&#x21B;i fi&#x219;iere text",
                  "ba-videoplayer-tracks.select-text-track-language": "Limba pentru subtitrare",
                  "ba-videoplayer-tracks.info-select-locale-first": "Mai &#xEE;nt&#xE2;i selecta&#x21B;i localizarea",
                  "ba-videoplayer-tracks.select-text-track-file": "Face&#x21B;i clic pentru a selecta fi&#x219;ierul",
                  "ba-videoplayer-tracks.back": "&#xEE;napoi",
                  "ba-videorecorder.framerate-warning": "Rata cadrelor video este foarte sc&#x103;zut&#x103;. V&#x103; recomand&#x103;m s&#x103; &#xEE;nchide&#x21B;i toate celelalte programe &#x219;i filele browserului sau s&#x103; utiliza&#x21B;i un computer mai rapid.",
                  "ba-videorecorder.upload-error-duration": "Durata videoclipului &#xEE;nc&#x103;rcat nu &#xEE;ndepline&#x219;te cerin&#x21B;ele - face&#x21B;i clic aici pentru a &#xEE;ncerca din nou.",
                  "ba-videorecorder.resolution-constraint-error": "Fi&#x219;ierul pe care l-a&#x21B;i selectat nu corespunde rezolu&#x21B;iei cerute - face&#x21B;i clic aici pentru a &#xEE;ncerca din nou.",
                  "ba-videorecorder.orientation-portrait-required": "Rote&#x219;te dispozitivul pentru a &#xEE;nregistra &#xEE;n modul portret.",
                  "ba-videorecorder.orientation-landscape-required": "Rote&#x219;te dispozitivul pentru a &#xEE;nregistra &#xEE;n modul peisaj.",
                  "ba-imageviewer-controlbar.rerecord-image": "Re-inregistreaza?",
                  "ba-imageviewer-controlbar.submit-image": "Confirma",
                  "ba-imageviewer-controlbar.fullscreen-image": "M&#x103;re&#x219;te pe &#xEE;ntre ecranul",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Ie&#x219;i&#x21B;i de pe ecranul complet",
                  "ba-imageviewer.image-error": "A ap&#x103;rut o eroare, &#xEE;ncerca&#x21B;i din nou mai t&#xE2;rziu. Face&#x21B;i clic pentru a re&#xEE;ncerca.",
                  "ba-imagecapture-chooser.image-capture": "Captura&#x21B;i imaginea",
                  "ba-imagecapture-chooser.upload-image": "Incarca imaginea",
                  "ba-imagecapture-controlbar.settings": "Set&#x103;ri",
                  "ba-imagecapture-controlbar.camerahealthy": "Lumina este bun&#x103;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Lumina nu este optim&#x103;",
                  "ba-imagecapture-controlbar.record": "Captur&#x103;",
                  "ba-imagecapture-controlbar.record-tooltip": "Face&#x21B;i clic aici pentru a captura.",
                  "ba-imagecapture-controlbar.rerecord": "A reface",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Face&#x21B;i clic aici pentru a reveni.",
                  "ba-imagecapture-controlbar.cancel": "Anulare",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Face&#x21B;i clic aici pentru a anula.",
                  "ba-audioplayer-controlbar.audio-progress": "progres",
                  "ba-audioplayer-controlbar.rerecord-audio": "Re-inregistreaza?",
                  "ba-audioplayer-controlbar.submit-audio": "Confirma",
                  "ba-audioplayer-controlbar.play-audio": "Ruleaz&#x103;",
                  "ba-audioplayer-controlbar.pause-audio": "Pauz&#x103;",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "&#xCE;ntreruperea nu este acceptat&#x103;",
                  "ba-audioplayer-controlbar.elapsed-time": "Timp scurs",
                  "ba-audioplayer-controlbar.total-time": "Lungimea total&#x103;",
                  "ba-audioplayer-controlbar.volume-button": "Seta&#x21B;i volumul",
                  "ba-audioplayer-controlbar.volume-mute": "Opri&#x21B;i sunetul",
                  "ba-audioplayer-controlbar.volume-unmute": "Debloca&#x21B;i sunetul",
                  "ba-audioplayer-loader.tooltip": "Se incarca...",
                  "ba-audioplayer.audio-error": "A ap&#x103;rut o eroare, &#xEE;ncerca&#x21B;i din nou mai t&#xE2;rziu. Face&#x21B;i clic pentru a re&#xEE;ncerca.",
                  "ba-audiorecorder-chooser.record-audio": "&#xCE;nregistreaz&#x103; audio",
                  "ba-audiorecorder-chooser.upload-audio": "&#xCE;nc&#x103;rca&#x21B;i audio",
                  "ba-audiorecorder-controlbar.settings": "Set&#x103;ri",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Sunetul este bun",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Sunetul nu este bun",
                  "ba-audiorecorder-controlbar.record": "&#xCE;nregistreaz&#x103;",
                  "ba-audiorecorder-controlbar.record-tooltip": "Face&#x21B;i clic aici pentru a &#xEE;nregistra.",
                  "ba-audiorecorder-controlbar.rerecord": "&#xCE;nregistreaz&#x103; din nou",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Face&#x21B;i clic aici pentru a reveni.",
                  "ba-audiorecorder-controlbar.stop": "Stop",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Face&#x21B;i clic aici pentru a opri.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Durata minim&#x103; de &#xEE;nregistrare este %d secunde",
                  "ba-audiorecorder-controlbar.cancel": "Anulare",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Face&#x21B;i clic aici pentru a anula.",
                  "ba-videoplayer-controlbar.player-speed": "Viteza de rulare",
                  "ba-videoplayer-controlbar.settings": "Set&#x103;ri",
                  "ba-videoplayer-controlbar.airplay": "AirPlay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay icon.",
                  "ba-videoplayer.all-settings": "Toate set&#x103;rile",
                  "ba-videoplayer.player-speed": "Viteza de rulare",
                  "ba-videoplayer.full-screen": "Ecran complet",
                  "ba-videorecorder-controlbar.add-stream": "Ad&#x103;uga&#x21B;i un flux",
                  "ba-videorecorder.switch-camera": "Porni&#x21B;i camera",
                  "ba-videorecorder.prepare-covershot": "Preg&#x103;te&#x219;te coperta",
                  "ba-videorecorder.prepare-thumbnails": "Preg&#x103;te&#x219;te miniaturi",
                  "ba-videorecorder.adding-new-stream": "Ad&#x103;ugarea fluxului nou",
                  "ba-imagecapture.recorder-error": "A ap&#x103;rut o eroare, &#xEE;ncerca&#x21B;i din nou mai t&#xE2;rziu. Face&#x21B;i clic pentru a re&#xEE;ncerca.",
                  "ba-imagecapture.attach-error": "Nu am putut accesa interfa&#x21B;a media. &#xCE;n func&#x21B;ie de dispozitiv &#x219;i browser, este posibil s&#x103; fie nevoie s&#x103; instala&#x21B;i Flash sau s&#x103; accesa&#x21B;i pagina prin SSL.",
                  "ba-imagecapture.software-required": "Face&#x21B;i clic mai jos pentru a instala / activa urm&#x103;toarele cerin&#x21B;e pentru a continua.",
                  "ba-imagecapture.software-waiting": "Se a&#x219;teapt&#x103; ca cerin&#x21B;ele s&#x103; fie instalate / activate. Poate fi necesar s&#x103; actualiza&#x21B;i pagina dup&#x103; finalizare.",
                  "ba-imagecapture.access-forbidden": "Accesul la mass-media a fost interzis. Face&#x21B;i clic pentru a re&#xEE;ncerca.",
                  "ba-imagecapture.uploading": "Se &#xEE;ncarc&#x103;",
                  "ba-imagecapture.uploading-failed": "&#xCE;nc&#x103;rcarea a e&#x219;uat - face&#x21B;i clic aici pentru a re&#xEE;ncerca.",
                  "ba-imagecapture.upload-error-duration": "M&#x103;rimea imaginii &#xEE;nc&#x103;rcate nu &#xEE;ndepline&#x219;te cerin&#x21B;ele - face&#x21B;i clic aici pentru a re&#xEE;ncerca.",
                  "ba-imagecapture.resolution-constraint-error": "Fi&#x219;ierul pe care l-a&#x21B;i selectat nu corespunde rezolu&#x21B;iei dorite - face&#x21B;i clic aici pentru a &#xEE;ncerca din nou.",
                  "ba-imagecapture.verifying": "Verificare",
                  "ba-imagecapture.verifying-failed": "Verificare e&#x219;uat&#x103; - face&#x21B;i clic aici pentru a re&#xEE;ncerca.",
                  "ba-imagecapture.rerecord-confirm": "Dori&#x21B;i s&#x103; reface&#x21B;i imaginea?",
                  "ba-imagecapture.image_file_too_large": "Fi&#x219;ierul imagine este prea mare (%s) - face&#x21B;i clic aici pentru a &#xEE;ncerca din nou cu un fi&#x219;ier imagine mai mic.",
                  "ba-imagecapture.unsupported_image_type": "&#xCE;nc&#x103;rca&#x21B;i: %s - face&#x21B;i clic aici pentru a re&#xEE;ncerca.",
                  "ba-imagecapture.orientation-portrait-required": "Rote&#x219;te dispozitivul pentru a &#xEE;nregistra &#xEE;n modul portret.",
                  "ba-imagecapture.orientation-landscape-required": "Rote&#x219;te dispozitivul pentru a &#xEE;nregistra &#xEE;n modul peisaj.",
                  "ba-audiorecorder.recorder-error": "A ap&#x103;rut o eroare, &#xEE;ncerca&#x21B;i din nou mai t&#xE2;rziu. Face&#x21B;i clic pentru a re&#xEE;ncerca.",
                  "ba-audiorecorder.attach-error": "Nu am putut accesa interfa&#x21B;a media. &#xCE;n func&#x21B;ie de dispozitiv &#x219;i browser, este posibil s&#x103; fie nevoie s&#x103; instala&#x21B;i Flash sau s&#x103; accesa&#x21B;i pagina prin SSL.",
                  "ba-audiorecorder.software-required": "Face&#x21B;i clic mai jos pentru a instala / activa urm&#x103;toarele cerin&#x21B;e pentru a continua.",
                  "ba-audiorecorder.software-waiting": "Se a&#x219;teapt&#x103; ca cerin&#x21B;ele s&#x103; fie instalate / activate. Poate fi necesar s&#x103; actualiza&#x21B;i pagina dup&#x103; finalizare.",
                  "ba-audiorecorder.access-forbidden": "Accesul la mass-media a fost interzis. Face&#x21B;i clic pentru a re&#xEE;ncerca.",
                  "ba-audiorecorder.uploading": "Se &#xEE;ncarc&#x103;",
                  "ba-audiorecorder.uploading-failed": "&#xCE;nc&#x103;rcarea a e&#x219;uat - face&#x21B;i clic aici pentru a re&#xEE;ncerca.",
                  "ba-audiorecorder.upload-error-duration": "Dimensiunea fi&#x219;ierului de sunet &#xEE;nc&#x103;rcat nu &#xEE;ndepline&#x219;te cerin&#x21B;ele - face&#x21B;i clic aici pentru a &#xEE;ncerca din nou.",
                  "ba-audiorecorder.verifying": "Verificare",
                  "ba-audiorecorder.verifying-failed": "Verificare e&#x219;uat&#x103; - face&#x21B;i clic aici pentru a re&#xEE;ncerca.",
                  "ba-audiorecorder.rerecord-confirm": "Dori&#x21B;i s&#x103; re&#xEE;nregistra&#x21B;i sunetul?",
                  "ba-audiorecorder.cancel-confirm": "Dori&#x21B;i s&#x103; anula&#x21B;i &#xEE;nc&#x103;rcarea audio?",
                  "ba-audiorecorder.audio_file_too_large": "Fi&#x219;ierul dvs. audio este prea mare (%s) - face&#x21B;i clic aici pentru a &#xEE;ncerca din nou cu un fi&#x219;ier audio mai mic.",
                  "ba-audiorecorder.unsupported_audio_type": "&#xCE;nc&#x103;rca&#x21B;i: %s - face&#x21B;i clic aici pentru a re&#xEE;ncerca.",
                  "ba-common-settingsmenu.tooltip": "Face&#x21B;i clic pentru a juca.",
                  "ba-common-settingsmenu.setting-menu": "Toate set&#x103;rile",
                  "ba-common-settingsmenu.source-quality": "Calitatea sursei",
                  "ba-common-settingsmenu.player-speed": "Viteza de redare",
                  "ba-common-settingsmenu.set-menu-option": "Seta&#x21B;i op&#x21B;iunea",
                  "ba-common-settingsmenu.submit-video": "Confirma&#x21B;i videoclipul",
                  "ba-common-settingsmenu.picture-in-picture": "Imagine &#xEE;n imagine",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Ie&#x219;i&#x21B;i din modul ecran complet",
                  "ba-common-settingsmenu.fullscreen-video": "Afi&#x219;eaz&#x103; pe ecran complet",
                  "ba-videorecorder-chooser.multi-stream": "Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Pauz&#x103; &#xEE;nregistrare",
                  "ba-videorecorder-controlbar.resume-recorder": "Relua&#x21B;i &#xEE;nregistrarea",
                  "ba-videorecorder.missing-track": "Fi&#x219;ierul audio sau video necesar lipse&#x219;te",
                  "ba-videorecorder.device-already-in-use": "Cel pu&#x21B;in unul dintre dispozitivele dvs. este deja utilizat",
                  "ba-videorecorder.browser-permission-denied": "Permisiunea refuzat&#x103; de browser, v&#x103; rug&#x103;m s&#x103; acorda&#x21B;i acces &#x219;i s&#x103; re&#xEE;nc&#x103;rca&#x21B;i pagina",
                  "ba-audioplayer.all-settings": "Toate set&#x103;rile",
                  "ba-videoplayer-controlbar.remaining-time": "Timp r&#x103;mas",
                  "ba-videoplayer-controlbar.select-frame": "Selecta&#x21B;i",
                  "ba-videoplayer-controlbar.trim-video": "Tunde",
                  "ba-videoplayer-playbutton.trim": "Tunde",
                  "ba-videoplayer-playbutton.skip": "Ocolire",
                  "ba-videorecorder-imagegallery.upload-covershot": "&#xCE;nc&#x103;rca&#x21B;i coperta",
                  "ba-videorecorder.pick-covershot-frame": "Selecta&#x21B;i un cadru pe care s&#x103; &#xEE;l utiliza&#x21B;i ca imagine de acoperire.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "&#xCE;nregistratorul de ecran nu este acceptat pe acest dispozitiv",
                  "ba-videorecorder.trim-prompt": "Dori&#x21B;i s&#x103; t&#x103;ia&#x21B;i videoclipul?",
                  "ba-videorecorder.trim-video": "Muta&#x21B;i marcajele de &#xEE;nceput &#x219;i sf&#xE2;r&#x219;it pentru a t&#x103;ia videoclipul",
                  "ba-videorecorder.wait-for-trim": "Se a&#x219;teapt&#x103; comanda de t&#x103;iere ...",
                  "ba-videorecorder-controlbar.no-video-source": "Lipse&#x219;te o surs&#x103; de intrare video suplimentar&#x103;",
                  "ba-videorecorder-controlbar.stream-already-selected": "Fluxul suplimentar a fost deja selectat",
                  "ba-videorecorder.uploading-src-error": "Imposibil de redat videoclipul acum, &#xEE;nc&#x103;rcarea este &#xEE;nc&#x103; &#xEE;n desf&#x103;&#x219;urare",
                  "ba-audiorecorder-controlbar.pause-recorder": "Pauz&#x103; Recorder",
                  "ba-audiorecorder-controlbar.resume-recorder": "Relua&#x21B;i &#xEE;nregistratorul"
                },
                "language:ru": {
                  "ba-videoplayer-playbutton.tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x432;&#x43E;&#x441;&#x43F;&#x440;&#x43E;&#x438;&#x437;&#x432;&#x435;&#x441;&#x442;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E;.",
                  "ba-videoplayer-playbutton.rerecord": "&#x41F;&#x435;&#x440;&#x435;&#x437;&#x430;&#x43F;&#x438;&#x441;&#x430;&#x442;&#x44C;",
                  "ba-videoplayer-loader.tooltip": "&#x417;&#x430;&#x433;&#x440;&#x443;&#x437;&#x43A;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E; ...",
                  "ba-videoplayer-controlbar.change-resolution": "&#x418;&#x437;&#x43C;&#x435;&#x43D;&#x438;&#x442;&#x44C; &#x440;&#x430;&#x437;&#x440;&#x435;&#x448;&#x435;&#x43D;&#x438;&#x435;",
                  "ba-videoplayer-controlbar.video-progress": "&#x425;&#x43E;&#x434; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.rerecord-video": "&#x41F;&#x435;&#x440;&#x435;&#x437;&#x430;&#x43F;&#x438;&#x441;&#x430;&#x442;&#x44C; &#x432;&#x438;&#x434;&#x435;&#x43E;?",
                  "ba-videoplayer-controlbar.play-video": "&#x41F;&#x440;&#x43E;&#x438;&#x433;&#x440;&#x430;&#x442;&#x44C; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.pause-video": "&#x41F;&#x440;&#x438;&#x43E;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.elapsed-time": "&#x41F;&#x440;&#x43E;&#x439;&#x434;&#x435;&#x43D;&#x43D;&#x43E;&#x435; &#x432;&#x440;&#x435;&#x43C;&#x44F;",
                  "ba-videoplayer-controlbar.total-time": "&#x41E;&#x431;&#x449;&#x430;&#x44F; &#x434;&#x43B;&#x438;&#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.fullscreen-video": "&#x41F;&#x43E;&#x43B;&#x43D;&#x43E;&#x44D;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x44B;&#x439; &#x440;&#x435;&#x436;&#x438;&#x43C;",
                  "ba-videoplayer-controlbar.volume-button": "&#x413;&#x440;&#x43E;&#x43C;&#x43A;&#x43E;&#x441;&#x442;&#x44C;",
                  "ba-videoplayer-controlbar.volume-mute": "&#x41E;&#x442;&#x43A;&#x43B;&#x44E;&#x447;&#x438;&#x442;&#x44C; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer-controlbar.volume-unmute": "&#x412;&#x43A;&#x43B;&#x44E;&#x447;&#x438;&#x442;&#x44C; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer.video-error": "&#x41F;&#x440;&#x43E;&#x438;&#x437;&#x43E;&#x448;&#x43B;&#x430; &#x43E;&#x448;&#x438;&#x431;&#x43A;&#x430;. &#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443; &#x43F;&#x43E;&#x437;&#x436;&#x435;. &#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-videorecorder-chooser.record-video": "&#x417;&#x430;&#x43F;&#x438;&#x448;&#x438;&#x442;&#x435; &#x441;&#x432;&#x43E;&#x435; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-chooser.upload-video": "&#x417;&#x430;&#x433;&#x440;&#x443;&#x437;&#x438;&#x442;&#x44C; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-controlbar.settings": "&#x41D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-videorecorder-controlbar.camerahealthy": "&#x41E;&#x441;&#x432;&#x435;&#x449;&#x435;&#x43D;&#x438;&#x435; &#x445;&#x43E;&#x440;&#x43E;&#x448;&#x435;&#x435;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "&#x421;&#x43B;&#x430;&#x431;&#x43E;&#x435; &#x43E;&#x441;&#x432;&#x435;&#x449;&#x435;&#x43D;&#x438;&#x435;",
                  "ba-videorecorder-controlbar.microphonehealthy": "&#x417;&#x432;&#x443;&#x43A; &#x445;&#x43E;&#x440;&#x43E;&#x448;&#x438;&#x439;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "&#x41D;&#x435;&#x432;&#x43E;&#x437;&#x43C;&#x43E;&#x436;&#x43D;&#x43E; &#x43F;&#x43E;&#x43B;&#x443;&#x447;&#x438;&#x442;&#x44C; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videorecorder-controlbar.record": "&#x417;&#x430;&#x43F;&#x438;&#x441;&#x44C;",
                  "ba-videorecorder-controlbar.record-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x430;&#x442;&#x44C;.",
                  "ba-videorecorder-controlbar.stop": "&#x421;&#x442;&#x43E;&#x43F;",
                  "ba-videorecorder-controlbar.stop-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43E;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C;.",
                  "ba-videorecorder-controlbar.skip": "&#x41F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x442;&#x438;&#x442;&#x44C;",
                  "ba-videorecorder-controlbar.skip-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x442;&#x438;&#x442;&#x44C;.",
                  "ba-videorecorder.recorder-error": "&#x41F;&#x440;&#x43E;&#x438;&#x437;&#x43E;&#x448;&#x43B;&#x430; &#x43E;&#x448;&#x438;&#x431;&#x43A;&#x430;. &#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443; &#x43F;&#x43E;&#x437;&#x436;&#x435;. &#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-videorecorder.access-forbidden": "&#x414;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x43A; &#x43A;&#x430;&#x43C;&#x435;&#x440;&#x435; &#x431;&#x44B;&#x43B; &#x437;&#x430;&#x43F;&#x440;&#x435;&#x449;&#x435;&#x43D;. &#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-videorecorder.pick-covershot": "&#x412;&#x44B;&#x431;&#x435;&#x440;&#x438;&#x442;&#x435; &#x441;&#x43D;&#x438;&#x43C;&#x43E;&#x43A;.",
                  "ba-videorecorder.uploading": "&#x417;&#x430;&#x433;&#x440;&#x443;&#x437;&#x43A;&#x430;",
                  "ba-videorecorder.uploading-failed": "&#x41E;&#x448;&#x438;&#x431;&#x43A;&#x430; &#x437;&#x430;&#x433;&#x440;&#x443;&#x437;&#x43A;&#x438;: &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-videorecorder.verifying": "&#x41F;&#x440;&#x43E;&#x432;&#x435;&#x440;&#x43A;&#x430;",
                  "ba-videorecorder.verifying-failed": "&#x41E;&#x448;&#x438;&#x431;&#x43A;&#x430; &#x43F;&#x43E;&#x434;&#x442;&#x432;&#x435;&#x440;&#x436;&#x434;&#x435;&#x43D;&#x438;&#x44F;. &#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-videorecorder.rerecord-confirm": "&#x412;&#x44B; &#x434;&#x435;&#x439;&#x441;&#x442;&#x432;&#x438;&#x442;&#x435;&#x43B;&#x44C;&#x43D;&#x43E; &#x445;&#x43E;&#x442;&#x438;&#x442;&#x435; &#x43F;&#x435;&#x440;&#x435;&#x437;&#x430;&#x43F;&#x438;&#x441;&#x430;&#x442;&#x44C; &#x432;&#x438;&#x434;&#x435;&#x43E;?",
                  "ba-videorecorder.video_file_too_large": "&#x412;&#x430;&#x448; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x444;&#x430;&#x439;&#x43B; &#x441;&#x43B;&#x438;&#x448;&#x43A;&#x43E;&#x43C; &#x432;&#x435;&#x43B;&#x438;&#x43A; (%s) - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443; &#x441; &#x43C;&#x435;&#x43D;&#x44C;&#x448;&#x438;&#x43C; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x444;&#x430;&#x439;&#x43B;&#x43E;&#x43C;.",
                  "ba-videorecorder.unsupported_video_type": "&#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430; &#x437;&#x430;&#x433;&#x440;&#x443;&#x437;&#x438;&#x442;&#x435;: %s - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-videoplayer-playbutton.submit-video": "&#x41F;&#x43E;&#x434;&#x442;&#x432;&#x435;&#x440;&#x434;&#x438;&#x442;&#x44C; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.submit-video": "&#x41F;&#x43E;&#x434;&#x442;&#x432;&#x435;&#x440;&#x434;&#x438;&#x442;&#x44C; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-controlbar.rerecord": "&#x41F;&#x435;&#x440;&#x435;&#x434;&#x435;&#x43B;&#x430;&#x442;&#x44C;",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x435;&#x440;&#x435;&#x437;&#x430;&#x43F;&#x438;&#x441;&#x430;&#x442;&#x44C;",
                  "ba-videorecorder-controlbar.upload-covershot": "&#x417;&#x430;&#x433;&#x440;&#x443;&#x437;&#x438;&#x442;&#x44C;",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x437;&#x430;&#x433;&#x440;&#x443;&#x437;&#x438;&#x442;&#x44C; &#x43B;&#x438;&#x447;&#x43D;&#x443;&#x44E; &#x43E;&#x431;&#x43B;&#x43E;&#x436;&#x43A;&#x443;",
                  "ba-videorecorder.attach-error": "&#x22;&#x41D;&#x435; &#x443;&#x434;&#x430;&#x43B;&#x43E;&#x441;&#x44C; &#x43F;&#x43E;&#x43B;&#x443;&#x447;&#x438;&#x442;&#x44C; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x43A; &#x43A;&#x430;&#x43C;&#x435;&#x440;&#x435;. &#x412; &#x437;&#x430;&#x432;&#x438;&#x441;&#x438;&#x43C;&#x43E;&#x441;&#x442;&#x438; &#x43E;&#x442; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x430; &#x438;&#x43B;&#x438; &#x431;&#x440;&#x430;&#x443;&#x437;&#x435;&#x440;&#x430;, &#x432;&#x430;&#x43C; &#x43C;&#x43E;&#x436;&#x435;&#x442; &#x43F;&#x43E;&#x43D;&#x430;&#x434;&#x43E;&#x431;&#x438;&#x442;&#x44C;&#x441;&#x44F; &#x443;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; Flash &#x438;&#x43B;&#x438; &#x43F;&#x43E;&#x43B;&#x443;&#x447;&#x438;&#x442;&#x44C; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x43A; &#x441;&#x430;&#x439;&#x442;&#x443; &#x447;&#x435;&#x440;&#x435;&#x437; SSL.&#x22;",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "&#x412;&#x44B;&#x439;&#x442;&#x438; &#x438;&#x437; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x430; &#x43F;&#x43E;&#x43B;&#x43D;&#x43E;&#x433;&#x43E; &#x43E;&#x43A;&#x43D;&#x430;",
                  "ba-videoplayer-share.share": "&#x41F;&#x43E;&#x434;&#x435;&#x43B;&#x438;&#x442;&#x44C;&#x441;&#x44F; &#x441; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-chooser.record-screen": "&#x42D;&#x43A;&#x440;&#x430;&#x43D; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x438;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "&#x41F;&#x430;&#x443;&#x437;&#x430; &#x43D;&#x435; &#x43F;&#x43E;&#x434;&#x434;&#x435;&#x440;&#x436;&#x438;&#x432;&#x430;&#x435;&#x442;&#x441;&#x44F;",
                  "ba-videorecorder-chooser.record-audio": "&#x417;&#x430;&#x43F;&#x438;&#x441;&#x44C; &#x430;&#x443;&#x434;&#x438;&#x43E;",
                  "ba-videorecorder-controlbar.stop-available-after": "&#x41C;&#x438;&#x43D;&#x438;&#x43C;&#x430;&#x43B;&#x44C;&#x43D;&#x43E;&#x435; &#x432;&#x440;&#x435;&#x43C;&#x44F; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x438;: %d &#x441;&#x435;&#x43A;&#x443;&#x43D;&#x434;",
                  "ba-videorecorder-controlbar.cancel": "&#x41E;&#x442;&#x43C;&#x435;&#x43D;&#x430;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43E;&#x442;&#x43C;&#x435;&#x43D;&#x438;&#x442;&#x44C;.",
                  "ba-videorecorder.cancel-confirm": "&#x412;&#x44B; &#x434;&#x435;&#x439;&#x441;&#x442;&#x432;&#x438;&#x442;&#x435;&#x43B;&#x44C;&#x43D;&#x43E; &#x445;&#x43E;&#x442;&#x438;&#x442;&#x435; &#x43E;&#x442;&#x43C;&#x435;&#x43D;&#x438;&#x442;&#x44C; &#x437;&#x430;&#x433;&#x440;&#x443;&#x437;&#x43A;&#x443; &#x432;&#x438;&#x434;&#x435;&#x43E;?",
                  "ba-videoplayer-adslot.elapsed-time": "&#x423;&#x43A;&#x43E;&#x440;&#x43E;&#x447;&#x435;&#x43D;&#x43D;&#x43E;&#x435; &#x432;&#x440;&#x435;&#x43C;&#x44F;",
                  "ba-videoplayer-adslot.volume-button": "&#x423;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; &#x433;&#x440;&#x43E;&#x43C;&#x43A;&#x43E;&#x441;&#x442;&#x44C;",
                  "ba-videoplayer-adslot.volume-mute": "&#x41E;&#x442;&#x43A;&#x43B;&#x44E;&#x447;&#x438;&#x442;&#x44C; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer-adslot.volume-unmute": "&#x412;&#x43A;&#x43B;&#x44E;&#x447;&#x438;&#x442;&#x44C; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer-adslot.ad-will-end-after": "&#x41E;&#x431;&#x44A;&#x44F;&#x432;&#x43B;&#x435;&#x43D;&#x438;&#x435; &#x431;&#x443;&#x434;&#x435;&#x442; &#x437;&#x430;&#x432;&#x435;&#x440;&#x448;&#x435;&#x43D;&#x43E; &#x43F;&#x43E;&#x441;&#x43B;&#x435; %s",
                  "ba-videoplayer-adslot.can-skip-after": "&#x41F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x442;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x441;&#x43B;&#x435; %d",
                  "ba-videoplayer-adslot.skip-ad": "&#x41F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x442;&#x438;&#x442;&#x44C; &#x440;&#x435;&#x43A;&#x43B;&#x430;&#x43C;&#x443;",
                  "ba-videorecorder.software-required": "&#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x43D;&#x438;&#x436;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x443;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x43E;&#x432;&#x430;&#x442;&#x44C; &#x441;&#x43B;&#x435;&#x434;&#x443;&#x44E;&#x449;&#x438;&#x435; &#x442;&#x440;&#x435;&#x431;&#x43E;&#x432;&#x430;&#x43D;&#x438;&#x44F;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x440;&#x43E;&#x434;&#x43E;&#x43B;&#x436;&#x438;&#x442;&#x44C;.",
                  "ba-videorecorder.software-waiting": "&#x41E;&#x436;&#x438;&#x434;&#x430;&#x43D;&#x438;&#x435; &#x442;&#x440;&#x435;&#x431;&#x43E;&#x432;&#x430;&#x43D;&#x438;&#x439; &#x43A; &#x443;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x43A;&#x435; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x430;&#x446;&#x438;&#x438;. &#x412;&#x43E;&#x437;&#x43C;&#x43E;&#x436;&#x43D;&#x43E;, &#x432;&#x430;&#x43C; &#x43F;&#x440;&#x438;&#x434;&#x435;&#x442;&#x441;&#x44F; &#x43E;&#x431;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x443; &#x43F;&#x43E;&#x441;&#x43B;&#x435; &#x437;&#x430;&#x432;&#x435;&#x440;&#x448;&#x435;&#x43D;&#x438;&#x44F;.",
                  "ba-videoplayer-controlbar.close-tracks": "&#x417;&#x430;&#x43A;&#x440;&#x44B;&#x442;&#x44C; CC",
                  "ba-videoplayer-controlbar.show-tracks": "&#x41F;&#x43E;&#x43A;&#x430;&#x437;&#x430;&#x442;&#x44C; CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "&#x417;&#x430;&#x433;&#x440;&#x443;&#x437;&#x438;&#x442;&#x44C; &#x434;&#x43E;&#x440;&#x43E;&#x436;&#x43A;&#x438;",
                  "ba-videoplayer-tracks.select-text-track-language": "&#x42F;&#x437;&#x44B;&#x43A; &#x441;&#x443;&#x431;&#x442;&#x438;&#x442;&#x440;&#x43E;&#x432;",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x421;&#x43D;&#x430;&#x447;&#x430;&#x43B;&#x430; &#x432;&#x44B;&#x431;&#x435;&#x440;&#x438;&#x442;&#x435; &#x44F;&#x437;&#x44B;&#x43A;",
                  "ba-videoplayer-tracks.select-text-track-file": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x432;&#x44B;&#x431;&#x440;&#x430;&#x442;&#x44C; &#x444;&#x430;&#x439;&#x43B;",
                  "ba-videoplayer-tracks.back": "&#x43D;&#x430;&#x437;&#x430;&#x434;",
                  "ba-videorecorder.framerate-warning": "&#x427;&#x430;&#x441;&#x442;&#x43E;&#x442;&#x430; &#x43A;&#x430;&#x434;&#x440;&#x43E;&#x432; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x43E;&#x447;&#x435;&#x43D;&#x44C; &#x43D;&#x438;&#x437;&#x43A;&#x430;&#x44F;. &#x41C;&#x44B; &#x440;&#x435;&#x43A;&#x43E;&#x43C;&#x435;&#x43D;&#x434;&#x443;&#x435;&#x43C; &#x437;&#x430;&#x43A;&#x440;&#x44B;&#x442;&#x44C; &#x432;&#x441;&#x435; &#x434;&#x440;&#x443;&#x433;&#x438;&#x435; &#x43F;&#x440;&#x43E;&#x433;&#x440;&#x430;&#x43C;&#x43C;&#x44B; &#x438; &#x432;&#x43A;&#x43B;&#x430;&#x434;&#x43A;&#x438; &#x431;&#x440;&#x430;&#x443;&#x437;&#x435;&#x440;&#x430; &#x438;&#x43B;&#x438; &#x438;&#x441;&#x43F;&#x43E;&#x43B;&#x44C;&#x437;&#x43E;&#x432;&#x430;&#x442;&#x44C; &#x431;&#x43E;&#x43B;&#x435;&#x435; &#x431;&#x44B;&#x441;&#x442;&#x440;&#x44B;&#x439; &#x43A;&#x43E;&#x43C;&#x43F;&#x44C;&#x44E;&#x442;&#x435;&#x440;.",
                  "ba-videorecorder.upload-error-duration": "&#x414;&#x43B;&#x438;&#x43D;&#x430; &#x437;&#x430;&#x433;&#x440;&#x443;&#x436;&#x435;&#x43D;&#x43D;&#x43E;&#x433;&#x43E; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x43D;&#x435; &#x441;&#x43E;&#x43E;&#x442;&#x432;&#x435;&#x442;&#x441;&#x442;&#x432;&#x443;&#x435;&#x442; &#x442;&#x440;&#x435;&#x431;&#x43E;&#x432;&#x430;&#x43D;&#x438;&#x44F;&#x43C; - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-videorecorder.resolution-constraint-error": "&#x412;&#x44B;&#x431;&#x440;&#x430;&#x43D;&#x43D;&#x44B;&#x439; &#x444;&#x430;&#x439;&#x43B; &#x43D;&#x435; &#x441;&#x43E;&#x43E;&#x442;&#x432;&#x435;&#x442;&#x441;&#x442;&#x432;&#x443;&#x435;&#x442; &#x442;&#x440;&#x435;&#x431;&#x443;&#x435;&#x43C;&#x43E;&#x43C;&#x443; &#x440;&#x430;&#x437;&#x440;&#x435;&#x448;&#x435;&#x43D;&#x438;&#x44E; - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-videorecorder.orientation-portrait-required": "&#x41F;&#x43E;&#x432;&#x435;&#x440;&#x43D;&#x438;&#x442;&#x435; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E; &#x434;&#x43B;&#x44F; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x438; &#x432; &#x43F;&#x43E;&#x440;&#x442;&#x440;&#x435;&#x442;&#x43D;&#x43E;&#x43C; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x435;.",
                  "ba-videorecorder.orientation-landscape-required": "&#x41F;&#x43E;&#x432;&#x435;&#x440;&#x43D;&#x438;&#x442;&#x435; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E; &#x434;&#x43B;&#x44F; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x438; &#x432; &#x430;&#x43B;&#x44C;&#x431;&#x43E;&#x43C;&#x43D;&#x43E;&#x43C; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x435;.",
                  "ba-imageviewer-controlbar.rerecord-image": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C;?",
                  "ba-imageviewer-controlbar.submit-image": "&#x43F;&#x43E;&#x434;&#x442;&#x432;&#x435;&#x440;&#x434;&#x438;&#x442;&#x44C;",
                  "ba-imageviewer-controlbar.fullscreen-image": "&#x412;&#x43E;&#x439;&#x442;&#x438; &#x432; &#x43F;&#x43E;&#x43B;&#x43D;&#x43E;&#x44D;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x44B;&#x439; &#x440;&#x435;&#x436;&#x438;&#x43C;",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "&#x412;&#x44B;&#x445;&#x43E;&#x434; &#x438;&#x437; &#x43F;&#x43E;&#x43B;&#x43D;&#x43E;&#x44D;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x43E;&#x433;&#x43E; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x430;",
                  "ba-imageviewer.image-error": "&#x41F;&#x440;&#x43E;&#x438;&#x437;&#x43E;&#x448;&#x43B;&#x430; &#x43E;&#x448;&#x438;&#x431;&#x43A;&#x430;. &#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443; &#x43F;&#x43E;&#x437;&#x436;&#x435;. &#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-imagecapture-chooser.image-capture": "&#x417;&#x430;&#x445;&#x432;&#x430;&#x442; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x44F;",
                  "ba-imagecapture-chooser.upload-image": "&#x417;&#x430;&#x433;&#x440;&#x443;&#x437;&#x438;&#x442;&#x44C; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435;",
                  "ba-imagecapture-controlbar.settings": "&#x43D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-imagecapture-controlbar.camerahealthy": "&#x41E;&#x441;&#x432;&#x435;&#x449;&#x435;&#x43D;&#x438;&#x435; &#x445;&#x43E;&#x440;&#x43E;&#x448;&#x435;&#x435;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "&#x41E;&#x441;&#x432;&#x435;&#x449;&#x435;&#x43D;&#x438;&#x435; &#x43D;&#x435; &#x44F;&#x432;&#x43B;&#x44F;&#x435;&#x442;&#x441;&#x44F; &#x43E;&#x43F;&#x442;&#x438;&#x43C;&#x430;&#x43B;&#x44C;&#x43D;&#x44B;&#x43C;",
                  "ba-imagecapture-controlbar.record": "&#x417;&#x430;&#x445;&#x432;&#x430;&#x442;&#x438;&#x442;&#x44C;",
                  "ba-imagecapture-controlbar.record-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x441;&#x434;&#x435;&#x43B;&#x430;&#x442;&#x44C; &#x441;&#x43D;&#x438;&#x43C;&#x43E;&#x43A;.",
                  "ba-imagecapture-controlbar.rerecord": "&#x43F;&#x435;&#x440;&#x435;&#x434;&#x435;&#x43B;&#x44B;&#x432;&#x430;&#x442;&#x44C;",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C;.",
                  "ba-imagecapture-controlbar.cancel": "&#x41E;&#x442;&#x43C;&#x435;&#x43D;&#x430;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43E;&#x442;&#x43C;&#x435;&#x43D;&#x438;&#x442;&#x44C;.",
                  "ba-audioplayer-controlbar.audio-progress": "&#x41F;&#x440;&#x43E;&#x433;&#x440;&#x435;&#x441;&#x441;",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C;?",
                  "ba-audioplayer-controlbar.submit-audio": "&#x43F;&#x43E;&#x434;&#x442;&#x432;&#x435;&#x440;&#x434;&#x438;&#x442;&#x44C;",
                  "ba-audioplayer-controlbar.play-audio": "&#x418;&#x433;&#x440;&#x430;&#x442;&#x44C;",
                  "ba-audioplayer-controlbar.pause-audio": "&#x41F;&#x430;&#x443;&#x437;&#x430;",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "&#x41F;&#x430;&#x443;&#x437;&#x430; &#x43D;&#x435; &#x43F;&#x43E;&#x434;&#x434;&#x435;&#x440;&#x436;&#x438;&#x432;&#x430;&#x435;&#x442;&#x441;&#x44F;",
                  "ba-audioplayer-controlbar.elapsed-time": "&#x423;&#x43A;&#x43E;&#x440;&#x43E;&#x447;&#x435;&#x43D;&#x43D;&#x43E;&#x435; &#x432;&#x440;&#x435;&#x43C;&#x44F;",
                  "ba-audioplayer-controlbar.total-time": "&#x41E;&#x431;&#x449;&#x430;&#x44F; &#x434;&#x43B;&#x438;&#x43D;&#x430;",
                  "ba-audioplayer-controlbar.volume-button": "&#x423;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; &#x433;&#x440;&#x43E;&#x43C;&#x43A;&#x43E;&#x441;&#x442;&#x44C;",
                  "ba-audioplayer-controlbar.volume-mute": "&#x41E;&#x442;&#x43A;&#x43B;&#x44E;&#x447;&#x438;&#x442;&#x44C; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audioplayer-controlbar.volume-unmute": "&#x412;&#x43A;&#x43B;&#x44E;&#x447;&#x438;&#x442;&#x44C; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audioplayer-loader.tooltip": "Loading ...",
                  "ba-audioplayer.audio-error": "&#x41F;&#x440;&#x43E;&#x438;&#x437;&#x43E;&#x448;&#x43B;&#x430; &#x43E;&#x448;&#x438;&#x431;&#x43A;&#x430;. &#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443; &#x43F;&#x43E;&#x437;&#x436;&#x435;. &#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-audiorecorder-chooser.record-audio": "&#x417;&#x430;&#x43F;&#x438;&#x441;&#x44C; &#x430;&#x443;&#x434;&#x438;&#x43E;",
                  "ba-audiorecorder-chooser.upload-audio": "&#x417;&#x430;&#x433;&#x440;&#x443;&#x437;&#x438;&#x442;&#x44C; &#x430;&#x443;&#x434;&#x438;&#x43E;",
                  "ba-audiorecorder-controlbar.settings": "&#x43D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "&#x417;&#x432;&#x443;&#x43A; &#x445;&#x43E;&#x440;&#x43E;&#x448;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "&#x41D;&#x435;&#x432;&#x43E;&#x437;&#x43C;&#x43E;&#x436;&#x43D;&#x43E; &#x43F;&#x43E;&#x434;&#x43E;&#x431;&#x440;&#x430;&#x442;&#x44C; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audiorecorder-controlbar.record": "&#x437;&#x430;&#x43F;&#x438;&#x441;&#x44C;",
                  "ba-audiorecorder-controlbar.record-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x430;&#x442;&#x44C;.",
                  "ba-audiorecorder-controlbar.rerecord": "&#x43F;&#x435;&#x440;&#x435;&#x434;&#x435;&#x43B;&#x44B;&#x432;&#x430;&#x442;&#x44C;",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C;.",
                  "ba-audiorecorder-controlbar.stop": "&#x421;&#x442;&#x43E;&#x43F;",
                  "ba-audiorecorder-controlbar.stop-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43E;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C;&#x441;&#x44F;.",
                  "ba-audiorecorder-controlbar.stop-available-after": "&#x41C;&#x438;&#x43D;&#x438;&#x43C;&#x430;&#x43B;&#x44C;&#x43D;&#x43E;&#x435; &#x432;&#x440;&#x435;&#x43C;&#x44F; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x438;: %d &#x441;&#x435;&#x43A;&#x443;&#x43D;&#x434;",
                  "ba-audiorecorder-controlbar.cancel": "&#x41E;&#x442;&#x43C;&#x435;&#x43D;&#x430;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43E;&#x442;&#x43C;&#x435;&#x43D;&#x438;&#x442;&#x44C;.",
                  "ba-videoplayer-controlbar.player-speed": "&#x421;&#x43A;&#x43E;&#x440;&#x43E;&#x441;&#x442;&#x44C; &#x438;&#x433;&#x440;&#x43E;&#x43A;&#x430;",
                  "ba-videoplayer-controlbar.settings": "&#x43D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-videoplayer-controlbar.airplay": "&#x442;&#x440;&#x430;&#x43D;&#x441;&#x43B;&#x44F;&#x446;&#x438;&#x44F; &#x437;&#x432;&#x443;&#x43A;&#x43E;&#x437;&#x430;&#x43F;&#x438;&#x441;&#x438;",
                  "ba-videoplayer-controlbar.airplay-icon": "&#x417;&#x43D;&#x430;&#x447;&#x43E;&#x43A; Airplay.",
                  "ba-videoplayer.all-settings": "&#x412;&#x441;&#x435; &#x43D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-videoplayer.player-speed": "&#x421;&#x43A;&#x43E;&#x440;&#x43E;&#x441;&#x442;&#x44C; &#x438;&#x433;&#x440;&#x43E;&#x43A;&#x430;",
                  "ba-videoplayer.full-screen": "&#x41F;&#x43E;&#x43B;&#x43D;&#x43E;&#x44D;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x44B;&#x439;",
                  "ba-videorecorder-controlbar.add-stream": "&#x414;&#x43E;&#x431;&#x430;&#x432;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x442;&#x43E;&#x43A;",
                  "ba-videorecorder.switch-camera": "&#x41F;&#x435;&#x440;&#x435;&#x43A;&#x43B;&#x44E;&#x447;&#x438;&#x442;&#x44C; &#x43A;&#x430;&#x43C;&#x435;&#x440;&#x443;",
                  "ba-videorecorder.prepare-covershot": "&#x41F;&#x43E;&#x434;&#x433;&#x43E;&#x442;&#x43E;&#x432;&#x43A;&#x430; &#x43E;&#x431;&#x43B;&#x43E;&#x436;&#x435;&#x43A;",
                  "ba-videorecorder.prepare-thumbnails": "&#x41F;&#x43E;&#x434;&#x433;&#x43E;&#x442;&#x43E;&#x432;&#x43A;&#x430; &#x43F;&#x43E;&#x438;&#x441;&#x43A;&#x430; &#x43C;&#x438;&#x43D;&#x438;&#x430;&#x442;&#x44E;&#x440;",
                  "ba-videorecorder.adding-new-stream": "&#x414;&#x43E;&#x431;&#x430;&#x432;&#x43B;&#x435;&#x43D;&#x438;&#x435; &#x43D;&#x43E;&#x432;&#x43E;&#x433;&#x43E; &#x43F;&#x43E;&#x442;&#x43E;&#x43A;&#x430;",
                  "ba-imagecapture.recorder-error": "&#x41F;&#x440;&#x43E;&#x438;&#x437;&#x43E;&#x448;&#x43B;&#x430; &#x43E;&#x448;&#x438;&#x431;&#x43A;&#x430;. &#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443; &#x43F;&#x43E;&#x437;&#x436;&#x435;. &#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-imagecapture.attach-error": "&#x41C;&#x44B; &#x43D;&#x435; &#x441;&#x43C;&#x43E;&#x433;&#x43B;&#x438; &#x43F;&#x43E;&#x43B;&#x443;&#x447;&#x438;&#x442;&#x44C; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x43A; &#x43C;&#x435;&#x434;&#x438;&#x430;&#x438;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x439;&#x441;&#x443;. &#x412; &#x437;&#x430;&#x432;&#x438;&#x441;&#x438;&#x43C;&#x43E;&#x441;&#x442;&#x438; &#x43E;&#x442; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x430; &#x438; &#x431;&#x440;&#x430;&#x443;&#x437;&#x435;&#x440;&#x430;, &#x432;&#x430;&#x43C; &#x43C;&#x43E;&#x436;&#x435;&#x442; &#x43F;&#x43E;&#x442;&#x440;&#x435;&#x431;&#x43E;&#x432;&#x430;&#x442;&#x44C;&#x441;&#x44F; &#x443;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; Flash &#x438;&#x43B;&#x438; &#x43F;&#x43E;&#x43B;&#x443;&#x447;&#x438;&#x442;&#x44C; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x43A; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x435; &#x447;&#x435;&#x440;&#x435;&#x437; SSL.",
                  "ba-imagecapture.software-required": "&#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x43D;&#x438;&#x436;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x443;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x43E;&#x432;&#x430;&#x442;&#x44C; &#x441;&#x43B;&#x435;&#x434;&#x443;&#x44E;&#x449;&#x438;&#x435; &#x442;&#x440;&#x435;&#x431;&#x43E;&#x432;&#x430;&#x43D;&#x438;&#x44F;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x440;&#x43E;&#x434;&#x43E;&#x43B;&#x436;&#x438;&#x442;&#x44C;.",
                  "ba-imagecapture.software-waiting": "&#x412; &#x43E;&#x436;&#x438;&#x434;&#x430;&#x43D;&#x438;&#x438; &#x442;&#x440;&#x435;&#x431;&#x43E;&#x432;&#x430;&#x43D;&#x438;&#x439;, &#x43A;&#x43E;&#x442;&#x43E;&#x440;&#x44B;&#x435; &#x431;&#x443;&#x434;&#x443;&#x442; &#x443;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x44B; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x43E;&#x432;&#x430;&#x43D;&#x44B;. &#x412;&#x43E;&#x437;&#x43C;&#x43E;&#x436;&#x43D;&#x43E;, &#x432;&#x430;&#x43C; &#x43F;&#x440;&#x438;&#x434;&#x435;&#x442;&#x441;&#x44F; &#x43E;&#x431;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x443; &#x43F;&#x43E;&#x441;&#x43B;&#x435; &#x437;&#x430;&#x432;&#x435;&#x440;&#x448;&#x435;&#x43D;&#x438;&#x44F;.",
                  "ba-imagecapture.access-forbidden": "&#x414;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x43A; &#x421;&#x41C;&#x418; &#x431;&#x44B;&#x43B; &#x437;&#x430;&#x43F;&#x440;&#x435;&#x449;&#x435;&#x43D;. &#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-imagecapture.uploading": "&#x412;&#x44B;&#x433;&#x440;&#x443;&#x437;&#x43A;&#x430;",
                  "ba-imagecapture.uploading-failed": "&#x417;&#x430;&#x433;&#x440;&#x443;&#x437;&#x43A;&#x430; &#x43D;&#x435; &#x443;&#x434;&#x430;&#x43B;&#x430;&#x441;&#x44C; - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-imagecapture.upload-error-duration": "&#x414;&#x43B;&#x438;&#x43D;&#x430; &#x437;&#x430;&#x433;&#x440;&#x443;&#x436;&#x435;&#x43D;&#x43D;&#x43E;&#x433;&#x43E; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x44F; &#x43D;&#x435; &#x441;&#x43E;&#x43E;&#x442;&#x432;&#x435;&#x442;&#x441;&#x442;&#x432;&#x443;&#x435;&#x442; &#x442;&#x440;&#x435;&#x431;&#x43E;&#x432;&#x430;&#x43D;&#x438;&#x44F;&#x43C; - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-imagecapture.resolution-constraint-error": "&#x412;&#x44B;&#x431;&#x440;&#x430;&#x43D;&#x43D;&#x44B;&#x439; &#x432;&#x430;&#x43C;&#x438; &#x444;&#x430;&#x439;&#x43B; &#x43D;&#x435; &#x441;&#x43E;&#x43E;&#x442;&#x432;&#x435;&#x442;&#x441;&#x442;&#x432;&#x443;&#x435;&#x442; &#x442;&#x440;&#x435;&#x431;&#x443;&#x435;&#x43C;&#x43E;&#x43C;&#x443; &#x440;&#x430;&#x437;&#x440;&#x435;&#x448;&#x435;&#x43D;&#x438;&#x44E; - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-imagecapture.verifying": "&#x43F;&#x440;&#x43E;&#x432;&#x435;&#x440;&#x43A;&#x430;",
                  "ba-imagecapture.verifying-failed": "&#x41F;&#x440;&#x43E;&#x432;&#x435;&#x440;&#x43A;&#x430; &#x43D;&#x435; &#x443;&#x434;&#x430;&#x43B;&#x430;&#x441;&#x44C; - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-imagecapture.rerecord-confirm": "&#x412;&#x44B; &#x434;&#x435;&#x439;&#x441;&#x442;&#x432;&#x438;&#x442;&#x435;&#x43B;&#x44C;&#x43D;&#x43E; &#x445;&#x43E;&#x442;&#x438;&#x442;&#x435; &#x432;&#x435;&#x440;&#x43D;&#x443;&#x442;&#x44C; &#x441;&#x432;&#x43E;&#x439; &#x43E;&#x431;&#x440;&#x430;&#x437;?",
                  "ba-imagecapture.image_file_too_large": "&#x424;&#x430;&#x439;&#x43B; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x44F; &#x441;&#x43B;&#x438;&#x448;&#x43A;&#x43E;&#x43C; &#x432;&#x435;&#x43B;&#x438;&#x43A; (%s) - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443; &#x441; &#x43C;&#x435;&#x43D;&#x44C;&#x448;&#x438;&#x43C; &#x444;&#x430;&#x439;&#x43B;&#x43E;&#x43C; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x44F;.",
                  "ba-imagecapture.unsupported_image_type": "&#x417;&#x430;&#x433;&#x440;&#x443;&#x437;&#x438;&#x442;&#x435;: %s - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-imagecapture.orientation-portrait-required": "&#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43F;&#x43E;&#x432;&#x435;&#x440;&#x43D;&#x438;&#x442;&#x435; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E; &#x434;&#x43B;&#x44F; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x438; &#x432; &#x43F;&#x43E;&#x440;&#x442;&#x440;&#x435;&#x442;&#x43D;&#x43E;&#x43C; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x435;.",
                  "ba-imagecapture.orientation-landscape-required": "&#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43F;&#x43E;&#x432;&#x435;&#x440;&#x43D;&#x438;&#x442;&#x435; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x43E; &#x434;&#x43B;&#x44F; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x438; &#x432; &#x43B;&#x430;&#x43D;&#x434;&#x448;&#x430;&#x444;&#x442;&#x43D;&#x43E;&#x43C; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x435;.",
                  "ba-audiorecorder.recorder-error": "&#x41F;&#x440;&#x43E;&#x438;&#x437;&#x43E;&#x448;&#x43B;&#x430; &#x43E;&#x448;&#x438;&#x431;&#x43A;&#x430;. &#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443; &#x43F;&#x43E;&#x437;&#x436;&#x435;. &#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-audiorecorder.attach-error": "&#x41C;&#x44B; &#x43D;&#x435; &#x441;&#x43C;&#x43E;&#x433;&#x43B;&#x438; &#x43F;&#x43E;&#x43B;&#x443;&#x447;&#x438;&#x442;&#x44C; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x43A; &#x43C;&#x435;&#x434;&#x438;&#x430;&#x438;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x439;&#x441;&#x443;. &#x412; &#x437;&#x430;&#x432;&#x438;&#x441;&#x438;&#x43C;&#x43E;&#x441;&#x442;&#x438; &#x43E;&#x442; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x430; &#x438; &#x431;&#x440;&#x430;&#x443;&#x437;&#x435;&#x440;&#x430;, &#x432;&#x430;&#x43C; &#x43C;&#x43E;&#x436;&#x435;&#x442; &#x43F;&#x43E;&#x442;&#x440;&#x435;&#x431;&#x43E;&#x432;&#x430;&#x442;&#x44C;&#x441;&#x44F; &#x443;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; Flash &#x438;&#x43B;&#x438; &#x43F;&#x43E;&#x43B;&#x443;&#x447;&#x438;&#x442;&#x44C; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x43A; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x435; &#x447;&#x435;&#x440;&#x435;&#x437; SSL.",
                  "ba-audiorecorder.software-required": "&#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x43D;&#x438;&#x436;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x443;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x43E;&#x432;&#x430;&#x442;&#x44C; &#x441;&#x43B;&#x435;&#x434;&#x443;&#x44E;&#x449;&#x438;&#x435; &#x442;&#x440;&#x435;&#x431;&#x43E;&#x432;&#x430;&#x43D;&#x438;&#x44F;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x440;&#x43E;&#x434;&#x43E;&#x43B;&#x436;&#x438;&#x442;&#x44C;.",
                  "ba-audiorecorder.software-waiting": "&#x412; &#x43E;&#x436;&#x438;&#x434;&#x430;&#x43D;&#x438;&#x438; &#x442;&#x440;&#x435;&#x431;&#x43E;&#x432;&#x430;&#x43D;&#x438;&#x439;, &#x43A;&#x43E;&#x442;&#x43E;&#x440;&#x44B;&#x435; &#x431;&#x443;&#x434;&#x443;&#x442; &#x443;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x44B; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x43E;&#x432;&#x430;&#x43D;&#x44B;. &#x412;&#x43E;&#x437;&#x43C;&#x43E;&#x436;&#x43D;&#x43E;, &#x432;&#x430;&#x43C; &#x43F;&#x440;&#x438;&#x434;&#x435;&#x442;&#x441;&#x44F; &#x43E;&#x431;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x443; &#x43F;&#x43E;&#x441;&#x43B;&#x435; &#x437;&#x430;&#x432;&#x435;&#x440;&#x448;&#x435;&#x43D;&#x438;&#x44F;.",
                  "ba-audiorecorder.access-forbidden": "&#x414;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x43A; &#x421;&#x41C;&#x418; &#x431;&#x44B;&#x43B; &#x437;&#x430;&#x43F;&#x440;&#x435;&#x449;&#x435;&#x43D;. &#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-audiorecorder.uploading": "&#x412;&#x44B;&#x433;&#x440;&#x443;&#x437;&#x43A;&#x430;",
                  "ba-audiorecorder.uploading-failed": "&#x417;&#x430;&#x433;&#x440;&#x443;&#x437;&#x43A;&#x430; &#x43D;&#x435; &#x443;&#x434;&#x430;&#x43B;&#x430;&#x441;&#x44C; - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-audiorecorder.upload-error-duration": "&#x414;&#x43B;&#x438;&#x43D;&#x430; &#x437;&#x430;&#x433;&#x440;&#x443;&#x436;&#x435;&#x43D;&#x43D;&#x43E;&#x433;&#x43E; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x43D;&#x435; &#x441;&#x43E;&#x43E;&#x442;&#x432;&#x435;&#x442;&#x441;&#x442;&#x432;&#x443;&#x435;&#x442; &#x442;&#x440;&#x435;&#x431;&#x43E;&#x432;&#x430;&#x43D;&#x438;&#x44F;&#x43C; - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-audiorecorder.verifying": "&#x43F;&#x440;&#x43E;&#x432;&#x435;&#x440;&#x43A;&#x430;",
                  "ba-audiorecorder.verifying-failed": "&#x41F;&#x440;&#x43E;&#x432;&#x435;&#x440;&#x43A;&#x430; &#x43D;&#x435; &#x443;&#x434;&#x430;&#x43B;&#x430;&#x441;&#x44C; - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-audiorecorder.rerecord-confirm": "&#x412;&#x44B; &#x434;&#x435;&#x439;&#x441;&#x442;&#x432;&#x438;&#x442;&#x435;&#x43B;&#x44C;&#x43D;&#x43E; &#x445;&#x43E;&#x442;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x430;&#x443;&#x434;&#x438;&#x43E;?",
                  "ba-audiorecorder.cancel-confirm": "&#x412;&#x44B; &#x434;&#x435;&#x439;&#x441;&#x442;&#x432;&#x438;&#x442;&#x435;&#x43B;&#x44C;&#x43D;&#x43E; &#x445;&#x43E;&#x442;&#x438;&#x442;&#x435; &#x43E;&#x442;&#x43C;&#x435;&#x43D;&#x438;&#x442;&#x44C; &#x437;&#x430;&#x433;&#x440;&#x443;&#x437;&#x43A;&#x443; &#x430;&#x443;&#x434;&#x438;&#x43E;?",
                  "ba-audiorecorder.audio_file_too_large": "&#x412;&#x430;&#x448; &#x430;&#x443;&#x434;&#x438;&#x43E;&#x444;&#x430;&#x439;&#x43B; &#x441;&#x43B;&#x438;&#x448;&#x43A;&#x43E;&#x43C; &#x431;&#x43E;&#x43B;&#x44C;&#x448;&#x43E;&#x439; (%s) - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443; &#x441; &#x43C;&#x435;&#x43D;&#x44C;&#x448;&#x438;&#x43C; &#x430;&#x443;&#x434;&#x438;&#x43E;&#x444;&#x430;&#x439;&#x43B;&#x43E;&#x43C;.",
                  "ba-audiorecorder.unsupported_audio_type": "&#x417;&#x430;&#x433;&#x440;&#x443;&#x437;&#x438;&#x442;&#x435;: %s - &#x43D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435; &#x437;&#x434;&#x435;&#x441;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ba-common-settingsmenu.tooltip": "&#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x438;&#x433;&#x440;&#x430;&#x442;&#x44C;.",
                  "ba-common-settingsmenu.setting-menu": "&#x412;&#x441;&#x435; &#x43D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-common-settingsmenu.source-quality": "&#x41A;&#x430;&#x447;&#x435;&#x441;&#x442;&#x432;&#x43E; &#x438;&#x441;&#x442;&#x43E;&#x447;&#x43D;&#x438;&#x43A;&#x430;",
                  "ba-common-settingsmenu.player-speed": "&#x421;&#x43A;&#x43E;&#x440;&#x43E;&#x441;&#x442;&#x44C; &#x438;&#x433;&#x440;&#x43E;&#x43A;&#x430;",
                  "ba-common-settingsmenu.set-menu-option": "&#x423;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; &#x432;&#x430;&#x440;&#x438;&#x430;&#x43D;&#x442;",
                  "ba-common-settingsmenu.submit-video": "&#x41F;&#x43E;&#x434;&#x442;&#x432;&#x435;&#x440;&#x434;&#x438;&#x442;&#x44C; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-common-settingsmenu.picture-in-picture": "&#x41A;&#x430;&#x440;&#x442;&#x438;&#x43D;&#x43A;&#x430; &#x432; &#x43A;&#x430;&#x440;&#x442;&#x438;&#x43D;&#x43A;&#x435;",
                  "ba-common-settingsmenu.exit-fullscreen-video": "&#x412;&#x44B;&#x439;&#x442;&#x438; &#x438;&#x437; &#x43F;&#x43E;&#x43B;&#x43D;&#x43E;&#x44D;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x43E;&#x433;&#x43E; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x430;",
                  "ba-common-settingsmenu.fullscreen-video": "&#x412;&#x43E;&#x439;&#x442;&#x438; &#x432; &#x43F;&#x43E;&#x43B;&#x43D;&#x43E;&#x44D;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x44B;&#x439; &#x440;&#x435;&#x436;&#x438;&#x43C;",
                  "ba-videorecorder-chooser.multi-stream": "&#x41C;&#x43D;&#x43E;&#x433;&#x43E;&#x43F;&#x43E;&#x442;&#x43E;&#x447;&#x43D;&#x44B;&#x439;",
                  "ba-videorecorder-controlbar.pause-recorder": "&#x41F;&#x440;&#x438;&#x43E;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; &#x440;&#x435;&#x43A;&#x43E;&#x440;&#x434;&#x435;&#x440;",
                  "ba-videorecorder-controlbar.resume-recorder": "&#x420;&#x435;&#x43A;&#x43E;&#x440;&#x434;&#x435;&#x440; &#x440;&#x435;&#x437;&#x44E;&#x43C;&#x435;",
                  "ba-videorecorder.missing-track": "&#x41E;&#x442;&#x441;&#x443;&#x442;&#x441;&#x442;&#x432;&#x443;&#x435;&#x442; &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x43E;&#x434;&#x438;&#x43C;&#x430;&#x44F; &#x437;&#x432;&#x443;&#x43A;&#x43E;&#x432;&#x430;&#x44F; &#x438;&#x43B;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x434;&#x43E;&#x440;&#x43E;&#x436;&#x43A;&#x430;",
                  "ba-videorecorder.device-already-in-use": "&#x41A;&#x430;&#x43A; &#x43C;&#x438;&#x43D;&#x438;&#x43C;&#x443;&#x43C; &#x43E;&#x434;&#x43D;&#x43E; &#x438;&#x437; &#x432;&#x430;&#x448;&#x438;&#x445; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432; &#x432;&#x432;&#x43E;&#x434;&#x430; &#x443;&#x436;&#x435; &#x438;&#x441;&#x43F;&#x43E;&#x43B;&#x44C;&#x437;&#x443;&#x435;&#x442;&#x441;&#x44F;",
                  "ba-videorecorder.browser-permission-denied": "&#x411;&#x440;&#x430;&#x443;&#x437;&#x435;&#x440; &#x43E;&#x442;&#x43A;&#x430;&#x437;&#x430;&#x43B; &#x432; &#x440;&#x430;&#x437;&#x440;&#x435;&#x448;&#x435;&#x43D;&#x438;&#x438;, &#x43F;&#x440;&#x435;&#x434;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x44C;&#x442;&#x435; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x438; &#x43F;&#x435;&#x440;&#x435;&#x437;&#x430;&#x433;&#x440;&#x443;&#x437;&#x438;&#x442;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x443;",
                  "ba-audioplayer.all-settings": "&#x412;&#x441;&#x435; &#x43D;&#x430;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x43A;&#x438;",
                  "ba-videoplayer-controlbar.remaining-time": "&#x41E;&#x441;&#x442;&#x430;&#x432;&#x448;&#x435;&#x435;&#x441;&#x44F; &#x432;&#x440;&#x435;&#x43C;&#x44F;",
                  "ba-videoplayer-controlbar.select-frame": "&#x412;&#x44B;&#x431;&#x438;&#x440;&#x430;&#x442;&#x44C;",
                  "ba-videoplayer-controlbar.trim-video": "&#x41E;&#x442;&#x434;&#x435;&#x43B;&#x43A;&#x430;",
                  "ba-videoplayer-playbutton.trim": "&#x41E;&#x442;&#x434;&#x435;&#x43B;&#x43A;&#x430;",
                  "ba-videoplayer-playbutton.skip": "&#x41F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x43A;&#x430;&#x442;&#x44C;",
                  "ba-videorecorder-imagegallery.upload-covershot": "&#x417;&#x430;&#x433;&#x440;&#x443;&#x437;&#x438;&#x442;&#x44C; &#x43E;&#x431;&#x43B;&#x43E;&#x436;&#x43A;&#x443;",
                  "ba-videorecorder.pick-covershot-frame": "&#x412;&#x44B;&#x431;&#x435;&#x440;&#x438;&#x442;&#x435; &#x43A;&#x430;&#x434;&#x440; &#x434;&#x43B;&#x44F; &#x438;&#x441;&#x43F;&#x43E;&#x43B;&#x44C;&#x437;&#x43E;&#x432;&#x430;&#x43D;&#x438;&#x44F; &#x432; &#x43A;&#x430;&#x447;&#x435;&#x441;&#x442;&#x432;&#x435; &#x43E;&#x431;&#x43B;&#x43E;&#x436;&#x43A;&#x438;.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "&#x417;&#x430;&#x43F;&#x438;&#x441;&#x44C; &#x441; &#x44D;&#x43A;&#x440;&#x430;&#x43D;&#x430; &#x43D;&#x435; &#x43F;&#x43E;&#x434;&#x434;&#x435;&#x440;&#x436;&#x438;&#x432;&#x430;&#x435;&#x442;&#x441;&#x44F; &#x43D;&#x430; &#x44D;&#x442;&#x43E;&#x43C; &#x443;&#x441;&#x442;&#x440;&#x43E;&#x439;&#x441;&#x442;&#x432;&#x435;",
                  "ba-videorecorder.trim-prompt": "&#x412;&#x44B; &#x445;&#x43E;&#x442;&#x438;&#x442;&#x435; &#x43E;&#x431;&#x440;&#x435;&#x437;&#x430;&#x442;&#x44C; &#x432;&#x438;&#x434;&#x435;&#x43E;?",
                  "ba-videorecorder.trim-video": "&#x41F;&#x435;&#x440;&#x435;&#x43C;&#x435;&#x441;&#x442;&#x438;&#x442;&#x435; &#x43C;&#x430;&#x440;&#x43A;&#x435;&#x440;&#x44B; &#x43D;&#x430;&#x447;&#x430;&#x43B;&#x430; &#x438; &#x43A;&#x43E;&#x43D;&#x446;&#x430;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43E;&#x431;&#x440;&#x435;&#x437;&#x430;&#x442;&#x44C; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder.wait-for-trim": "&#x41E;&#x436;&#x438;&#x434;&#x430;&#x43D;&#x438;&#x435; &#x43A;&#x43E;&#x43C;&#x430;&#x43D;&#x434;&#x44B; &#x43E;&#x431;&#x440;&#x435;&#x437;&#x43A;&#x438; ...",
                  "ba-videorecorder-controlbar.no-video-source": "&#x41E;&#x442;&#x441;&#x443;&#x442;&#x441;&#x442;&#x432;&#x443;&#x435;&#x442; &#x434;&#x43E;&#x43F;&#x43E;&#x43B;&#x43D;&#x438;&#x442;&#x435;&#x43B;&#x44C;&#x43D;&#x44B;&#x439; &#x438;&#x441;&#x442;&#x43E;&#x447;&#x43D;&#x438;&#x43A; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x432;&#x445;&#x43E;&#x434;&#x430;",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x414;&#x43E;&#x43F;&#x43E;&#x43B;&#x43D;&#x438;&#x442;&#x435;&#x43B;&#x44C;&#x43D;&#x44B;&#x439; &#x43F;&#x43E;&#x442;&#x43E;&#x43A; &#x443;&#x436;&#x435; &#x432;&#x44B;&#x431;&#x440;&#x430;&#x43D;",
                  "ba-videorecorder.uploading-src-error": "&#x41D;&#x435;&#x432;&#x43E;&#x437;&#x43C;&#x43E;&#x436;&#x43D;&#x43E; &#x432;&#x43E;&#x441;&#x43F;&#x440;&#x43E;&#x438;&#x437;&#x432;&#x435;&#x441;&#x442;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E;, &#x437;&#x430;&#x433;&#x440;&#x443;&#x437;&#x43A;&#x430; &#x432;&#x441;&#x435; &#x435;&#x449;&#x435; &#x43F;&#x440;&#x43E;&#x434;&#x43E;&#x43B;&#x436;&#x430;&#x435;&#x442;&#x441;&#x44F;",
                  "ba-audiorecorder-controlbar.pause-recorder": "&#x41F;&#x440;&#x438;&#x43E;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; &#x440;&#x435;&#x43A;&#x43E;&#x440;&#x434;&#x435;&#x440;",
                  "ba-audiorecorder-controlbar.resume-recorder": "&#x420;&#x435;&#x43A;&#x43E;&#x440;&#x434;&#x435;&#x440; &#x440;&#x435;&#x437;&#x44E;&#x43C;&#x435;"
                },
                "language:sk": {
                  "ba-videoplayer-playbutton.tooltip": "Pre prehratie videa kliknite.",
                  "ba-videoplayer-playbutton.rerecord": "Znovu nahra&#x165;",
                  "ba-videoplayer-playbutton.submit-video": "Potvr&#x10F;te video",
                  "ba-videoplayer-loader.tooltip": "Nahr&#xE1;vanie...",
                  "ba-videoplayer-controlbar.change-resolution": "Zme&#x148;te rozl&#xED;&#x161;enie",
                  "ba-videoplayer-controlbar.video-progress": "Progres",
                  "ba-videoplayer-controlbar.rerecord-video": "Nahra&#x165; znovu?",
                  "ba-videoplayer-controlbar.submit-video": "Potvrdi&#x165;",
                  "ba-videoplayer-controlbar.play-video": "Prehra&#x165;",
                  "ba-videoplayer-controlbar.pause-video": "Pozastavi&#x165;",
                  "ba-videoplayer-controlbar.elapsed-time": "Uplynut&#xFD; &#x10D;as",
                  "ba-videoplayer-controlbar.total-time": "Celkov&#xE1; d&#x13A;&#x17E;ka",
                  "ba-videoplayer-controlbar.fullscreen-video": "Zobrazi&#x165; na cel&#xFA; obrazovku",
                  "ba-videoplayer-controlbar.volume-button": "Nastavi&#x165; hlasitos&#x165;",
                  "ba-videoplayer-controlbar.volume-mute": "Vypn&#xFA;&#x165; zvuk",
                  "ba-videoplayer-controlbar.volume-unmute": "Zapn&#xFA;&#x165; zvuk",
                  "ba-videoplayer.video-error": "Vyskytla sa chyba. Sk&#xFA;ste to znova.",
                  "ba-videorecorder-chooser.record-video": "Nahra&#x165; nov&#xE9; video",
                  "ba-videorecorder-chooser.upload-video": "Prilo&#x17E;i&#x165; existuj&#xFA;ce video",
                  "ba-videorecorder-controlbar.settings": "Nastavenia",
                  "ba-videorecorder-controlbar.camerahealthy": "Osvetlenie vyzer&#xE1; dobre",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Osvetlenie nie je optim&#xE1;lne",
                  "ba-videorecorder-controlbar.microphonehealthy": "Zvuk je v poriadku",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Nepodarilo sa zachyti&#x165; &#x17E;iaden zvuk",
                  "ba-videorecorder-controlbar.record": "Nahra&#x165;",
                  "ba-videorecorder-controlbar.record-tooltip": "Kliknite sem pre nahr&#xE1;vanie.",
                  "ba-videorecorder-controlbar.rerecord": "Znovu nahra&#x165;",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Kliknite sem pre zopakovanie nahr&#xE1;vania.",
                  "ba-videorecorder-controlbar.upload-covershot": "Prilo&#x17E;i&#x165;",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Kliknite sem pre nahratie vlastnej &#xFA;vodnej sn&#xED;mky",
                  "ba-videorecorder-controlbar.stop": "Zastavi&#x165;",
                  "ba-videorecorder-controlbar.stop-tooltip": "Kliknite sem pre zastavenie.",
                  "ba-videorecorder-controlbar.skip": "Presko&#x10D;i&#x165;",
                  "ba-videorecorder-controlbar.skip-tooltip": "Kliknite sem pre presko&#x10D;enie.",
                  "ba-videorecorder.recorder-error": "Vyskytla sa chyba. Kliknut&#xED;m sk&#xFA;ste znova.",
                  "ba-videorecorder.attach-error": "Nepodarilo sa n&#xE1;m z&#xED;ska&#x165; pr&#xED;stup k rozhraniu fotoapar&#xE1;tu. V z&#xE1;vislosti od zariadenia a prehliada&#x10D;a budete mo&#x17E;no musie&#x165; nain&#x161;talova&#x165; Flash alebo pristupova&#x165; na str&#xE1;nku cez protokol SSL.",
                  "ba-videorecorder.access-forbidden": "Pr&#xED;stup ku kamere bol zak&#xE1;zan&#xFD;. Kliknut&#xED;m sk&#xFA;ste znova.",
                  "ba-videorecorder.pick-covershot": "Vyberte si &#xFA;vodn&#xFA; sn&#xED;mku.",
                  "ba-videorecorder.uploading": "Nahr&#xE1;vanie",
                  "ba-videorecorder.uploading-failed": "Nahr&#xE1;vanie zlyhalo - kliknite sem pre zopakovanie.",
                  "ba-videorecorder.verifying": "Overovanie",
                  "ba-videorecorder.verifying-failed": "Overovanie zlyhalo - kliknite sem pre zopakovanie.",
                  "ba-videorecorder.rerecord-confirm": "Skuto&#x10D;ne chcete toto video prerobi&#x165;?",
                  "ba-videorecorder.video_file_too_large": "Va&#x161;e video je pr&#xED;li&#x161; dlh&#xE9; (%s) - kliknite sem pre zopakovanie s men&#x161;&#xED;m videos&#xFA;borom.",
                  "ba-videorecorder.unsupported_video_type": "Pros&#xED;m nahrajte: %s - kliknite sem pre zopakovanie.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Zru&#x161;i&#x165; zobrazenie na cel&#xFA; obrazovku",
                  "ba-videoplayer-share.share": "Zdie&#x13E;a&#x165;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Pozastavenie nie je mo&#x17E;n&#xE9;",
                  "ba-videorecorder-chooser.record-audio": "Nahra&#x165; zvuk",
                  "ba-videorecorder-controlbar.stop-available-after": "Minimum nahr&#xE1;vacieho &#x10D;asu je %d sek&#xFA;nd",
                  "ba-videorecorder-controlbar.cancel": "Zru&#x161;i&#x165;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Kliknite sem pre zru&#x161;enie.",
                  "ba-videorecorder.cancel-confirm": "Naozaj chcete zru&#x161;i&#x165; nahr&#xE1;vanie videa?",
                  "ba-videorecorder-chooser.record-screen": "Obrazovka nahr&#xE1;vania",
                  "ba-videoplayer-adslot.elapsed-time": "Uplynut&#xFD; &#x10D;as",
                  "ba-videoplayer-adslot.volume-button": "Nastavte hlasitos&#x165;",
                  "ba-videoplayer-adslot.volume-mute": "Stlmenie zvuku",
                  "ba-videoplayer-adslot.volume-unmute": "Zru&#x161;i&#x165; zvuk",
                  "ba-videoplayer-adslot.ad-will-end-after": "Reklama sa skon&#x10D;&#xED; po %s",
                  "ba-videoplayer-adslot.can-skip-after": "Presko&#x10D;i&#x165; za %d",
                  "ba-videoplayer-adslot.skip-ad": "Presko&#x10D;i&#x165; reklamu",
                  "ba-videorecorder.software-required": "Ak chcete pokra&#x10D;ova&#x165;, kliknite na ni&#x17E;&#x161;ie a nain&#x161;talujte / aktivujte nasleduj&#xFA;ce po&#x17E;iadavky.",
                  "ba-videorecorder.software-waiting": "&#x10C;ak&#xE1; sa na po&#x17E;iadavky na in&#x161;tal&#xE1;ciu / aktiv&#xE1;ciu. Po skon&#x10D;en&#xED; str&#xE1;nky mo&#x17E;no budete musie&#x165; obnovi&#x165; str&#xE1;nku.",
                  "ba-videoplayer-controlbar.close-tracks": "Zatvorte CC",
                  "ba-videoplayer-controlbar.show-tracks": "Zobrazi&#x165; CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Nahrajte textov&#xE9; s&#xFA;bory skladieb",
                  "ba-videoplayer-tracks.select-text-track-language": "Jazyk titulkov",
                  "ba-videoplayer-tracks.info-select-locale-first": "Najprv vyberte lokaliz&#xE1;ciu",
                  "ba-videoplayer-tracks.select-text-track-file": "Kliknut&#xED;m vyberte s&#xFA;bor",
                  "ba-videoplayer-tracks.back": "sp&#xE4;&#x165;",
                  "ba-videorecorder.framerate-warning": "R&#xFD;chlos&#x165; videoz&#xE1;znamu je ve&#x13E;mi n&#xED;zka. Odpor&#xFA;&#x10D;ame uzavrie&#x165; v&#x161;etky ostatn&#xE9; programy a karty prehliada&#x10D;a alebo pou&#x17E;i&#x165; r&#xFD;chlej&#x161;&#xED; po&#x10D;&#xED;ta&#x10D;.",
                  "ba-videorecorder.upload-error-duration": "D&#x13A;&#x17E;ka odovzdan&#xE9;ho videa nesp&#x13A;&#x148;a po&#x17E;iadavky - kliknite sem a sk&#xFA;ste to znova.",
                  "ba-videorecorder.resolution-constraint-error": "Zvolen&#xFD; s&#xFA;bor nezodpoved&#xE1; po&#x17E;adovan&#xE9;mu rozl&#xED;&#x161;eniu - kliknite sem a sk&#xFA;ste to znova.",
                  "ba-videorecorder.orientation-portrait-required": "Zariadenie m&#xF4;&#x17E;ete nat&#xE1;&#x10D;a&#x165; nat&#xE1;&#x10D;an&#xED;m v re&#x17E;ime na v&#xFD;&#x161;ku.",
                  "ba-videorecorder.orientation-landscape-required": "Nat&#xE1;&#x10D;ajte zariadenie tak, aby sa nahral v re&#x17E;ime na &#x161;&#xED;rku.",
                  "ba-imageviewer-controlbar.rerecord-image": "Prerobi&#x165;?",
                  "ba-imageviewer-controlbar.submit-image": "potvrdi&#x165;",
                  "ba-imageviewer-controlbar.fullscreen-image": "Zadajte cel&#xFA; obrazovku",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Ukon&#x10D;ite cel&#xFA; obrazovku",
                  "ba-imageviewer.image-error": "Vyskytla sa chyba. Sk&#xFA;ste to znovu nesk&#xF4;r pros&#xED;m. Kliknut&#xED;m sk&#xFA;ste znova.",
                  "ba-imagecapture-chooser.image-capture": "Zachy&#x165;te obr&#xE1;zok",
                  "ba-imagecapture-chooser.upload-image": "Nahra&#x165; obr&#xE1;zok",
                  "ba-imagecapture-controlbar.settings": "nastavenie",
                  "ba-imagecapture-controlbar.camerahealthy": "Osvetlenie je dobr&#xE9;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Osvetlenie nie je optim&#xE1;lne",
                  "ba-imagecapture-controlbar.record": "zajat&#xED;",
                  "ba-imagecapture-controlbar.record-tooltip": "Kliknite tu pre zachytenie.",
                  "ba-imagecapture-controlbar.rerecord": "prerobi&#x165;",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Kliknite tu pre op&#xE4;tovn&#xE9; spracovanie.",
                  "ba-imagecapture-controlbar.cancel": "Zru&#x161;i&#x165;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Kliknut&#xED;m tu zru&#x161;&#xED;te.",
                  "ba-audioplayer-controlbar.audio-progress": "pokrok",
                  "ba-audioplayer-controlbar.rerecord-audio": "Prerobi&#x165;?",
                  "ba-audioplayer-controlbar.submit-audio": "potvrdi&#x165;",
                  "ba-audioplayer-controlbar.play-audio": "hra&#x165;",
                  "ba-audioplayer-controlbar.pause-audio": "Pauza",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Pozastavenie nie je podporovan&#xE9;",
                  "ba-audioplayer-controlbar.elapsed-time": "Uplynut&#xFD; &#x10D;as",
                  "ba-audioplayer-controlbar.total-time": "Celkov&#xE1; d&#x13A;&#x17E;ka",
                  "ba-audioplayer-controlbar.volume-button": "Nastavte hlasitos&#x165;",
                  "ba-audioplayer-controlbar.volume-mute": "Stlmenie zvuku",
                  "ba-audioplayer-controlbar.volume-unmute": "Zru&#x161;i&#x165; zvuk",
                  "ba-audioplayer-loader.tooltip": "Na&#x10D;&#xED;tava...",
                  "ba-audioplayer.audio-error": "Vyskytla sa chyba. Sk&#xFA;ste to znovu nesk&#xF4;r pros&#xED;m. Kliknut&#xED;m sk&#xFA;ste znova.",
                  "ba-audiorecorder-chooser.record-audio": "Z&#xE1;znam zvuku",
                  "ba-audiorecorder-chooser.upload-audio": "Nahra&#x165; zvuk",
                  "ba-audiorecorder-controlbar.settings": "nastavenie",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Zvuk je dobr&#xFD;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Nepodar&#xED; sa zdvihn&#xFA;&#x165; &#x17E;iaden zvuk",
                  "ba-audiorecorder-controlbar.record": "rekord",
                  "ba-audiorecorder-controlbar.record-tooltip": "Kliknite tu pre nahr&#xE1;vanie.",
                  "ba-audiorecorder-controlbar.rerecord": "prerobi&#x165;",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Kliknite tu pre op&#xE4;tovn&#xE9; spracovanie.",
                  "ba-audiorecorder-controlbar.stop": "presta&#x165;",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Kliknut&#xED;m sem zastav&#xED;te.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Minim&#xE1;lny &#x10D;as nahr&#xE1;vania je %d sekundy",
                  "ba-audiorecorder-controlbar.cancel": "Zru&#x161;i&#x165;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Kliknut&#xED;m tu zru&#x161;&#xED;te.",
                  "ba-videoplayer-controlbar.player-speed": "R&#xFD;chlos&#x165; prehr&#xE1;va&#x10D;a",
                  "ba-videoplayer-controlbar.settings": "nastavenie",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Ikona Airplay.",
                  "ba-videoplayer.all-settings": "V&#x161;etky nastavenia",
                  "ba-videoplayer.player-speed": "R&#xFD;chlos&#x165; prehr&#xE1;va&#x10D;a",
                  "ba-videoplayer.full-screen": "Cel&#xE1; obrazovka",
                  "ba-videorecorder-controlbar.add-stream": "Prida&#x165; Stream",
                  "ba-videorecorder.switch-camera": "Prepnite fotoapar&#xE1;t",
                  "ba-videorecorder.prepare-covershot": "Pr&#xED;prava pokr&#xFD;va",
                  "ba-videorecorder.prepare-thumbnails": "Pr&#xED;prava vyh&#x13E;ad&#xE1;vania miniat&#xFA;r",
                  "ba-videorecorder.adding-new-stream": "Pridanie nov&#xE9;ho toku",
                  "ba-imagecapture.recorder-error": "Vyskytla sa chyba. Sk&#xFA;ste to znovu nesk&#xF4;r pros&#xED;m. Kliknite, ak chcete opakova&#x165; pokus.",
                  "ba-imagecapture.attach-error": "Nem&#xF4;&#x17E;eme z&#xED;ska&#x165; pr&#xED;stup k rozhraniu m&#xE9;di&#xED;. V z&#xE1;vislosti od zariadenia a prehliada&#x10D;a mo&#x17E;no budete musie&#x165; nain&#x161;talova&#x165; Flash alebo pristupova&#x165; na str&#xE1;nku cez SSL.",
                  "ba-imagecapture.software-required": "Ak chcete pokra&#x10D;ova&#x165;, kliknite ni&#x17E;&#x161;ie a nain&#x161;talujte / aktivujte nasleduj&#xFA;ce po&#x17E;iadavky.",
                  "ba-imagecapture.software-waiting": "&#x10C;akanie na in&#x161;tal&#xE1;ciu / aktiv&#xE1;ciu po&#x17E;iadaviek. Po dokon&#x10D;en&#xED; m&#xF4;&#x17E;ete potrebova&#x165; obnovi&#x165; str&#xE1;nku.",
                  "ba-imagecapture.access-forbidden": "Pr&#xED;stup k m&#xE9;di&#xE1;m bol zak&#xE1;zan&#xFD;. Kliknite, ak chcete opakova&#x165; pokus.",
                  "ba-imagecapture.uploading": "nahr&#xE1;vanie",
                  "ba-imagecapture.uploading-failed": "Nahr&#xE1;vanie zlyhalo - kliknut&#xED;m sem zopakujte pokus.",
                  "ba-imagecapture.upload-error-duration": "D&#x13A;&#x17E;ka nahran&#xE9;ho obr&#xE1;zka nesp&#x13A;&#x148;a po&#x17E;iadavky - kliknite sem a sk&#xFA;ste to znova.",
                  "ba-imagecapture.resolution-constraint-error": "Vybran&#xFD; s&#xFA;bor nezodpoved&#xE1; po&#x17E;adovan&#xE9;mu rozl&#xED;&#x161;eniu - kliknut&#xED;m sem zopakujte pokus.",
                  "ba-imagecapture.verifying": "overenie",
                  "ba-imagecapture.verifying-failed": "Overenie zlyhalo - kliknut&#xED;m sem zopakujte pokus.",
                  "ba-imagecapture.rerecord-confirm": "Naozaj chcete znova nasn&#xED;ma&#x165; svoj obr&#xE1;zok?",
                  "ba-imagecapture.image_file_too_large": "V&#xE1;&#x161; obrazov&#xFD; s&#xFA;bor je pr&#xED;li&#x161; ve&#x13E;k&#xFD; (%s) - kliknut&#xED;m sem sk&#xFA;ste znova s men&#x161;&#xED;m obr&#xE1;zkov&#xFD;m s&#xFA;borom.",
                  "ba-imagecapture.unsupported_image_type": "Nahrajte: %s - kliknite sem a sk&#xFA;ste to znova.",
                  "ba-imagecapture.orientation-portrait-required": "Ak chcete nahr&#xE1;va&#x165; v re&#x17E;ime na v&#xFD;&#x161;ku, oto&#x10D;te zariadenie.",
                  "ba-imagecapture.orientation-landscape-required": "Ak chcete nahr&#xE1;va&#x165; v re&#x17E;ime na &#x161;&#xED;rku, oto&#x10D;te zariadenie.",
                  "ba-audiorecorder.recorder-error": "Vyskytla sa chyba. Sk&#xFA;ste to znovu nesk&#xF4;r pros&#xED;m. Kliknite, ak chcete opakova&#x165; pokus.",
                  "ba-audiorecorder.attach-error": "Nem&#xF4;&#x17E;eme z&#xED;ska&#x165; pr&#xED;stup k rozhraniu m&#xE9;di&#xED;. V z&#xE1;vislosti od zariadenia a prehliada&#x10D;a mo&#x17E;no budete musie&#x165; nain&#x161;talova&#x165; Flash alebo pristupova&#x165; na str&#xE1;nku cez SSL.",
                  "ba-audiorecorder.software-required": "Ak chcete pokra&#x10D;ova&#x165;, kliknite ni&#x17E;&#x161;ie a nain&#x161;talujte / aktivujte nasleduj&#xFA;ce po&#x17E;iadavky.",
                  "ba-audiorecorder.software-waiting": "&#x10C;akanie na in&#x161;tal&#xE1;ciu / aktiv&#xE1;ciu po&#x17E;iadaviek. Po dokon&#x10D;en&#xED; m&#xF4;&#x17E;ete potrebova&#x165; obnovi&#x165; str&#xE1;nku.",
                  "ba-audiorecorder.access-forbidden": "Pr&#xED;stup k m&#xE9;di&#xE1;m bol zak&#xE1;zan&#xFD;. Kliknite, ak chcete opakova&#x165; pokus.",
                  "ba-audiorecorder.uploading": "nahr&#xE1;vanie",
                  "ba-audiorecorder.uploading-failed": "Nahr&#xE1;vanie zlyhalo - kliknut&#xED;m sem zopakujte pokus.",
                  "ba-audiorecorder.upload-error-duration": "D&#x13A;&#x17E;ka nahran&#xE9;ho zvuku nesp&#x13A;&#x148;a po&#x17E;iadavky - kliknite sem a sk&#xFA;ste to znova.",
                  "ba-audiorecorder.verifying": "overenie",
                  "ba-audiorecorder.verifying-failed": "Overenie zlyhalo - ak chcete pokus zopakova&#x165;, kliknite sem.",
                  "ba-audiorecorder.rerecord-confirm": "Naozaj chcete prepracova&#x165; zvuk?",
                  "ba-audiorecorder.cancel-confirm": "Naozaj chcete zru&#x161;i&#x165; nahr&#xE1;vanie zvuku?",
                  "ba-audiorecorder.audio_file_too_large": "V&#xE1;&#x161; zvukov&#xFD; s&#xFA;bor je pr&#xED;li&#x161; ve&#x13E;k&#xFD; (%s) - kliknite sem a sk&#xFA;ste znova s men&#x161;&#xED;m zvukov&#xFD;m s&#xFA;borom.",
                  "ba-audiorecorder.unsupported_audio_type": "Nahrajte: %s - kliknite sem a sk&#xFA;ste to znova.",
                  "ba-common-settingsmenu.tooltip": "Kliknut&#xED;m prehr&#xE1;te.",
                  "ba-common-settingsmenu.setting-menu": "V&#x161;etky nastavenia",
                  "ba-common-settingsmenu.source-quality": "Kvalita zdroja",
                  "ba-common-settingsmenu.player-speed": "R&#xFD;chlos&#x165; hr&#xE1;&#x10D;a",
                  "ba-common-settingsmenu.set-menu-option": "Nastavi&#x165; mo&#x17E;nos&#x165;",
                  "ba-common-settingsmenu.submit-video": "Potvr&#x10F;te video",
                  "ba-common-settingsmenu.picture-in-picture": "Obraz v obraze",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Ukon&#x10D;i&#x165; cel&#xFA; obrazovku",
                  "ba-common-settingsmenu.fullscreen-video": "Prejdite na cel&#xFA; obrazovku",
                  "ba-videorecorder-chooser.multi-stream": "Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Pozastavi&#x165; z&#xE1;znamn&#xED;k",
                  "ba-videorecorder-controlbar.resume-recorder": "Obnovte z&#xE1;znam",
                  "ba-videorecorder.missing-track": "Ch&#xFD;ba po&#x17E;adovan&#xE1; zvukov&#xE1; alebo obrazov&#xE1; stopa",
                  "ba-videorecorder.device-already-in-use": "Aspo&#x148; jedno z va&#x161;ich vstupn&#xFD;ch zariaden&#xED; sa u&#x17E; pou&#x17E;&#xED;va",
                  "ba-videorecorder.browser-permission-denied": "Prehliada&#x10D; zamietol povolenie, ude&#x13E;te pr&#xED;stup a znova na&#x10D;&#xED;tajte str&#xE1;nku",
                  "ba-audioplayer.all-settings": "V&#x161;etky nastavenia",
                  "ba-videoplayer-controlbar.remaining-time": "Zost&#xE1;vaj&#xFA;ci &#x10D;as",
                  "ba-videoplayer-controlbar.select-frame": "Vyberte",
                  "ba-videoplayer-controlbar.trim-video": "Oreza&#x165;",
                  "ba-videoplayer-playbutton.trim": "Oreza&#x165;",
                  "ba-videoplayer-playbutton.skip": "Presko&#x10D;i&#x165;",
                  "ba-videorecorder-imagegallery.upload-covershot": "Odovzdajte ob&#xE1;lku",
                  "ba-videorecorder.pick-covershot-frame": "Vyberte r&#xE1;m, ktor&#xFD; sa m&#xE1; pou&#x17E;i&#x165; ako kryc&#xED; z&#xE1;ber.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Rekord&#xE9;r obrazovky nie je t&#xFD;mto zariaden&#xED;m podporovan&#xFD;",
                  "ba-videorecorder.trim-prompt": "Chcete video oreza&#x165;?",
                  "ba-videorecorder.trim-video": "Posunut&#xED;m za&#x10D;iato&#x10D;n&#xFD;ch a koncov&#xFD;ch zna&#x10D;iek video upravte",
                  "ba-videorecorder.wait-for-trim": "&#x10C;ak&#xE1; sa na pr&#xED;kaz na orezanie ...",
                  "ba-videorecorder-controlbar.no-video-source": "Ch&#xFD;ba &#x10F;al&#x161;&#xED; zdroj vstupu videa",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x10E;al&#x161;&#xED; stream u&#x17E; bol vybrat&#xFD;",
                  "ba-videorecorder.uploading-src-error": "Teraz nie je mo&#x17E;n&#xE9; prehr&#xE1;va&#x165; video, nahr&#xE1;vanie st&#xE1;le prebieha",
                  "ba-audiorecorder-controlbar.pause-recorder": "Pozastavi&#x165; z&#xE1;znamn&#xED;k",
                  "ba-audiorecorder-controlbar.resume-recorder": "Obnovi&#x165; z&#xE1;znamn&#xED;k"
                },
                "language:sl": {
                  "ba-videoplayer-playbutton.tooltip": "Klikni za predvajanje.",
                  "ba-videoplayer-playbutton.rerecord": "Ponovno snemanje",
                  "ba-videoplayer-playbutton.submit-video": "Po&#x161;lji video",
                  "ba-videoplayer-loader.tooltip": "Nalaganje ...",
                  "ba-videoplayer-controlbar.change-resolution": "Spremeni resolucijo",
                  "ba-videoplayer-controlbar.video-progress": "Napredek",
                  "ba-videoplayer-controlbar.rerecord-video": "Ponovno snemanje?",
                  "ba-videoplayer-controlbar.submit-video": "Potrdi",
                  "ba-videoplayer-controlbar.play-video": "Predvajaj",
                  "ba-videoplayer-controlbar.pause-video": "Premor",
                  "ba-videoplayer-controlbar.elapsed-time": "Prete&#x10D;en &#x10D;as",
                  "ba-videoplayer-controlbar.total-time": "Skupna dol&#x17E;ina",
                  "ba-videoplayer-controlbar.fullscreen-video": "Celozaslonski na&#x10D;in",
                  "ba-videoplayer-controlbar.volume-button": "Nastavitve glasnosti",
                  "ba-videoplayer-controlbar.volume-mute": "Uti&#x161;aj zvok",
                  "ba-videoplayer-controlbar.volume-unmute": "Vklopi zvok",
                  "ba-videoplayer.video-error": "Pri&#x161;lo je do napake. Prosimo, poskusite kasneje. Klikni za ponovni poskus",
                  "ba-videorecorder-chooser.record-video": "Snemanje videa",
                  "ba-videorecorder-chooser.upload-video": "Nalaganje videa",
                  "ba-videorecorder-controlbar.settings": "Nastavitve",
                  "ba-videorecorder-controlbar.camerahealthy": "Svetloba je v redu",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Svetloba ni v redu",
                  "ba-videorecorder-controlbar.microphonehealthy": "Zvok je v redu",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Zvoka ni mogo&#x10D;e zajeti",
                  "ba-videorecorder-controlbar.record": "Snemanje",
                  "ba-videorecorder-controlbar.record-tooltip": "Klikni tukaj za snemanje.",
                  "ba-videorecorder-controlbar.rerecord": "Ponovno snemanje",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Klikni tukaj za ponovno snemanje.",
                  "ba-videorecorder-controlbar.upload-covershot": "Nalo&#x17E;i naslovno sliko",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Klikni tukaj, &#x10D;e &#x17E;eli&#x161; nalo&#x17E;iti naslovno sliko",
                  "ba-videorecorder-controlbar.stop": "Stop",
                  "ba-videorecorder-controlbar.stop-tooltip": "Klikni tukaj za zaustavitev snemanja.",
                  "ba-videorecorder-controlbar.skip": "Presko&#x10D;i",
                  "ba-videorecorder-controlbar.skip-tooltip": "Klikni tukaj, &#x10D;e &#x17E;eli&#x161; presko&#x10D;iti.",
                  "ba-videorecorder.recorder-error": "Pri&#x161;lo je do napake. Prosimo, poskusite kasneje. Klikni za ponovni poskus",
                  "ba-videorecorder.attach-error": "Ne moremo dostopati do medijskega vmesnika. Namestite Flash ali dostopajte do strani preko SSL-ja.",
                  "ba-videorecorder.access-forbidden": "Dostop do medija je bil prepovedan. Klikni za ponovni poskus.",
                  "ba-videorecorder.pick-covershot": "Izberi naslovno sliko",
                  "ba-videorecorder.uploading": "Nalaganje",
                  "ba-videorecorder.uploading-failed": "Nalaganje ni uspelo - klikni tukaj za ponovni poskus.",
                  "ba-videorecorder.verifying": "Preverjanje",
                  "ba-videorecorder.verifying-failed": "Preverjanje ni uspelo - klikni tukaj za ponovni poskus",
                  "ba-videorecorder.rerecord-confirm": "Ali res &#x17E;elite ponovno posneti video?",
                  "ba-videorecorder.video_file_too_large": "Va&#x161;a video datoteka je prevelika (%s) - klikni tukaj, da poskusite znova z manj&#x161;o video datoteko.",
                  "ba-videorecorder.unsupported_video_type": "Prosimo nalo&#x17E;ite: %s - klikni tukaj za ponovni poskus.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Zapusti celozaslonski na&#x10D;in",
                  "ba-videoplayer-share.share": "Deli",
                  "ba-videorecorder-chooser.record-screen": "Posnetek zaslona",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Premor ni podprt",
                  "ba-videorecorder-chooser.record-audio": "Snemanje zvoka",
                  "ba-videorecorder-controlbar.stop-available-after": "Minimalni snemalni &#x10D;as je %d sekund",
                  "ba-videorecorder-controlbar.cancel": "Prekli&#x10D;i",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Klikni tukaj za preklic.",
                  "ba-videorecorder.cancel-confirm": "Ali res &#x17E;elite preklicati prenos videoposnetka?",
                  "ba-videoplayer-adslot.elapsed-time": "Prete&#x10D;en &#x10D;as",
                  "ba-videoplayer-adslot.volume-button": "Nastavitve glasnosti",
                  "ba-videoplayer-adslot.volume-mute": "Uti&#x161;aj zvok",
                  "ba-videoplayer-adslot.volume-unmute": "Vklopi zvok",
                  "ba-videoplayer-adslot.ad-will-end-after": "Oglas se bo kon&#x10D;al po %s",
                  "ba-videoplayer-adslot.can-skip-after": "Presko&#x10D;i po %d",
                  "ba-videoplayer-adslot.skip-ad": "Presko&#x10D;i oglas",
                  "ba-videorecorder.software-required": "&#x10C;e &#x17E;elite nadaljevati, klikni spodaj, da namestite / aktivirate naslednje zahteve.",
                  "ba-videorecorder.software-waiting": "&#x10C;akamo, da se zahteve namestijo / aktivirajo. Po zaklju&#x10D;ku boste morda morali osve&#x17E;iti stran.",
                  "ba-videoplayer-controlbar.close-tracks": "Zapri CC",
                  "ba-videoplayer-controlbar.show-tracks": "Poka&#x17E;i CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Nalo&#x17E;i besedilne datoteke",
                  "ba-videoplayer-tracks.select-text-track-language": "Jezik podnapisov",
                  "ba-videoplayer-tracks.info-select-locale-first": "Najprej izberite jezik",
                  "ba-videoplayer-tracks.select-text-track-file": "Klikni, da izberete datoteko",
                  "ba-videoplayer-tracks.back": "nazaj",
                  "ba-videorecorder.framerate-warning": "Hitrost videa je zelo nizka. Priporo&#x10D;amo, da zaprete vse druge programe in zavihke brskalnika ali uporabite hitrej&#x161;i ra&#x10D;unalnik.",
                  "ba-videorecorder.upload-error-duration": "Dol&#x17E;ina nalo&#x17E;enega videoposnetka ne ustreza zahtevam - klikni tukaj za ponovni poskus.",
                  "ba-videorecorder.resolution-constraint-error": "Izbrana datoteka se ne ujema z zahtevano lo&#x10D;ljivostjo - klikni tukaj za ponovni poskus.",
                  "ba-videorecorder.orientation-portrait-required": "Za snemanje v pokon&#x10D;nem na&#x10D;inu obrnite napravo.",
                  "ba-videorecorder.orientation-landscape-required": "Za snemanje v le&#x17E;e&#x10D;em na&#x10D;inu obrnite napravo.",
                  "ba-imageviewer-controlbar.rerecord-image": "Ponovno snemanje?",
                  "ba-imageviewer-controlbar.submit-image": "Potrdi",
                  "ba-imageviewer-controlbar.fullscreen-image": "Celozaslonski na&#x10D;in",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Izhod iz celozaslonskega na&#x10D;ina",
                  "ba-imageviewer.image-error": "Pri&#x161;lo je do napake. Prosimo, poskusite kasneje. Klikni za ponovni poskus",
                  "ba-imagecapture-chooser.image-capture": "Zajem slike",
                  "ba-imagecapture-chooser.upload-image": "Nalo&#x17E;i sliko",
                  "ba-imagecapture-controlbar.settings": "Nastavitve",
                  "ba-imagecapture-controlbar.camerahealthy": "Svetloba je v redu",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Svetloba ni v redu",
                  "ba-imagecapture-controlbar.record": "Zajem",
                  "ba-imagecapture-controlbar.record-tooltip": "Klikni tukaj za zajem",
                  "ba-imagecapture-controlbar.rerecord": "Ponovno snemanje",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Klikni tukaj za ponovno snemanje.",
                  "ba-imagecapture-controlbar.cancel": "Prekli&#x10D;i",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Klikni tukaj za preklic.",
                  "ba-audioplayer-controlbar.audio-progress": "Napredek",
                  "ba-audioplayer-controlbar.rerecord-audio": "Ponovno snemanje?",
                  "ba-audioplayer-controlbar.submit-audio": "Potrdi",
                  "ba-audioplayer-controlbar.play-audio": "Predvajaj",
                  "ba-audioplayer-controlbar.pause-audio": "Pavza",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Premor ni podprt",
                  "ba-audioplayer-controlbar.elapsed-time": "Pete&#x10D;en &#x10D;as",
                  "ba-audioplayer-controlbar.total-time": "Skupna dol&#x17E;ina",
                  "ba-audioplayer-controlbar.volume-button": "Nastavitve glasnosti",
                  "ba-audioplayer-controlbar.volume-mute": "Uti&#x161;aj zvoj",
                  "ba-audioplayer-controlbar.volume-unmute": "Vklopi zvok",
                  "ba-audioplayer-loader.tooltip": "Nalaganje ...",
                  "ba-audioplayer.audio-error": "Pri&#x161;lo je do napake. Prosimo, poskusite kasneje. Klikni za ponovni poskus.",
                  "ba-audiorecorder-chooser.record-audio": "Snemanje zvoka",
                  "ba-audiorecorder-chooser.upload-audio": "Nalo&#x17E;i zvok",
                  "ba-audiorecorder-controlbar.settings": "Nastavitve",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Zvok je v redu",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Zvoka ni mogo&#x10D;e zajeti",
                  "ba-audiorecorder-controlbar.record": "Snemanje",
                  "ba-audiorecorder-controlbar.record-tooltip": "Klikni tukaj za snemanje.",
                  "ba-audiorecorder-controlbar.rerecord": "Ponovno snemanje",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Klikni tukaj za ponovno snemanje.",
                  "ba-audiorecorder-controlbar.stop": "Stop",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Klikni tukaj za zaustavitev snemanja.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Minimalni snemalni &#x10D;as je %d sekund",
                  "ba-audiorecorder-controlbar.cancel": "Prekli&#x10D;i",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Klikni tukaj za preklic.",
                  "ba-videoplayer-controlbar.player-speed": "Hitrost predvajalnika",
                  "ba-videoplayer-controlbar.settings": "Nastavitve",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay icon. Airplay ikona.",
                  "ba-videoplayer.all-settings": "Vse nastavitve",
                  "ba-videoplayer.player-speed": "Hitrost predvajalnika",
                  "ba-videoplayer.full-screen": "Celozaslonski na&#x10D;in",
                  "ba-videorecorder-controlbar.add-stream": "Add Stream",
                  "ba-videorecorder.switch-camera": "Zamenjaj kamero",
                  "ba-videorecorder.prepare-covershot": "Pripravljanje naslovne fotografije",
                  "ba-videorecorder.prepare-thumbnails": "Pripravljanje predogledne slike",
                  "ba-videorecorder.adding-new-stream": "Adding New Stream",
                  "ba-imagecapture.recorder-error": "Pri&#x161;lo je do napake. Prosimo, poskusite kasneje. Klikni za ponovni poskus.",
                  "ba-imagecapture.attach-error": "Ne moremo dostopati do medijskega vmesnika. Namestite Flash ali dostopajte do strani preko SSL-ja.",
                  "ba-imagecapture.software-required": "&#x10C;e &#x17E;elite nadaljevati, klikni spodaj, da namestite / aktivirate naslednje zahteve.",
                  "ba-imagecapture.software-waiting": "&#x10C;akamo, da se zahteve namestijo / aktivirajo. Po zaklju&#x10D;ku boste morda morali osve&#x17E;iti stran.",
                  "ba-imagecapture.access-forbidden": "Dostop do medija je bil prepovedan. Klikni za ponovni poskus.",
                  "ba-imagecapture.uploading": "Nalaganje",
                  "ba-imagecapture.uploading-failed": "Nalaganje ni uspelo - klikni tukaj za ponovni poskus.",
                  "ba-imagecapture.upload-error-duration": "Nalo&#x17E;ena slika ne ustreza zahtevam - klikni tukaj za ponovni poskus.",
                  "ba-imagecapture.resolution-constraint-error": "Izbrana datoteka se ne ujema z zahtevano lo&#x10D;ljivostjo - klikni tukaj za ponovni poskus.",
                  "ba-imagecapture.verifying": "Preverjanje",
                  "ba-imagecapture.verifying-failed": "Preverjanje ni uspelo - klikni tukaj za ponovni poskus.",
                  "ba-imagecapture.rerecord-confirm": "Ali res &#x17E;elite ponovno posneti sliko?",
                  "ba-imagecapture.image_file_too_large": "Va&#x161;a slikovna datoteka je prevelika (%s) - klikni tukaj, da poskusite ponovno z manj&#x161;o.",
                  "ba-imagecapture.unsupported_image_type": "Prosimo nalo&#x17E;ite: %s - klikni tukaj za ponovni poskus.",
                  "ba-imagecapture.orientation-portrait-required": "Za snemanje v pokon&#x10D;nem na&#x10D;inu obrnite napravo.",
                  "ba-imagecapture.orientation-landscape-required": "Za snemanje v le&#x17E;e&#x10D;em na&#x10D;inu obrnite napravo.",
                  "ba-audiorecorder.recorder-error": "Pri&#x161;lo je do napake. Prosimo, poskusite kasneje. Klikni za ponovni poskus.",
                  "ba-audiorecorder.attach-error": "Ne moremo dostopati do medijskega vmesnika. Namestite Flash ali dostopajte do strani preko SSL-ja.",
                  "ba-audiorecorder.software-required": "&#x10C;e &#x17E;elite nadaljevati, klikni spodaj, da namestite / aktivirate naslednje zahteve.",
                  "ba-audiorecorder.software-waiting": "&#x10C;akamo, da se zahteve namestijo / aktivirajo. Po zaklju&#x10D;ku boste morda morali osve&#x17E;iti stran.",
                  "ba-audiorecorder.access-forbidden": "Dostop do medija je bil prepovedan. Klikni za ponovni poskus.",
                  "ba-audiorecorder.uploading": "Nalaganje",
                  "ba-audiorecorder.uploading-failed": "Nalaganje ni uspelo - klikni tukaj za ponovni poskus.",
                  "ba-audiorecorder.upload-error-duration": "Dol&#x17E;ina nalo&#x17E;enega videoposnetka ne ustreza zahtevam - klikni tukaj za ponovni poskus.",
                  "ba-audiorecorder.verifying": "Preverjanje",
                  "ba-audiorecorder.verifying-failed": "Preverjanje ni uspelo - klikni tukaj za ponovni poskus.",
                  "ba-audiorecorder.rerecord-confirm": "Ali res &#x17E;elite obnoviti zvo&#x10D;ni posnetek?",
                  "ba-audiorecorder.cancel-confirm": "Ali res &#x17E;elite preklicati nalaganje va&#x161;ega zvo&#x10D;nega posnetka?",
                  "ba-audiorecorder.audio_file_too_large": "Va&#x161;a zvo&#x10D;na datoteka je prevelika (%s) - klikni tukaj, da poskusite ponovno z manj&#x161;o.",
                  "ba-audiorecorder.unsupported_audio_type": "Prosimo nalo&#x17E;ite: %s - klikni tukaj za ponovni poskus.",
                  "ba-common-settingsmenu.tooltip": "Klikni za predvajanje.",
                  "ba-common-settingsmenu.setting-menu": "Vse nastavitve",
                  "ba-common-settingsmenu.source-quality": "Kakovost vira",
                  "ba-common-settingsmenu.player-speed": "Hitrost predvajalnika",
                  "ba-common-settingsmenu.set-menu-option": "Mo&#x17E;nosti nastavitve",
                  "ba-common-settingsmenu.submit-video": "Potrdi video",
                  "ba-common-settingsmenu.picture-in-picture": "Slika v sliki",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Izhod iz celozaslonskega na&#x10D;ina",
                  "ba-common-settingsmenu.fullscreen-video": "Celozaslonski na&#x10D;in",
                  "ba-videorecorder-chooser.multi-stream": "Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Zaustavi snemalnik",
                  "ba-videorecorder-controlbar.resume-recorder": "Ponovno nadaljuj",
                  "ba-videorecorder.missing-track": "Zahtevan zvo&#x10D;ni ali video posnetek manjka",
                  "ba-videorecorder.device-already-in-use": "Vsaj ena od va&#x161;ih vhodnih naprav je &#x17E;e v uporabi",
                  "ba-videorecorder.browser-permission-denied": "Dovoljenje zavrnjeno s strani brskalnika, prosimo pridobite odobritev za dostop in ponovno nalo&#x17E;ite stran.",
                  "ba-audioplayer.all-settings": "Vse nastavitve",
                  "ba-videoplayer-controlbar.remaining-time": "Preostali &#x10D;as",
                  "ba-videoplayer-controlbar.select-frame": "Izberite",
                  "ba-videoplayer-controlbar.trim-video": "Obre&#x17E;ite",
                  "ba-videoplayer-playbutton.trim": "Obre&#x17E;ite",
                  "ba-videoplayer-playbutton.skip": "Presko&#x10D;i",
                  "ba-videorecorder-imagegallery.upload-covershot": "Nalo&#x17E;i ovitek",
                  "ba-videorecorder.pick-covershot-frame": "Izberite okvir, ki ga &#x17E;elite uporabiti kot posnetek.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Ta naprava ne podpira snemalnika zaslona",
                  "ba-videorecorder.trim-prompt": "Ali &#x17E;elite obrezati video?",
                  "ba-videorecorder.trim-video": "Premaknite za&#x10D;etni in kon&#x10D;ni ozna&#x10D;evalnik, da obre&#x17E;ete video",
                  "ba-videorecorder.wait-for-trim": "&#x10C;akanje na ukaz za obrezovanje ...",
                  "ba-videorecorder-controlbar.no-video-source": "Manjka dodaten video vhodni vir",
                  "ba-videorecorder-controlbar.stream-already-selected": "Dodatni tok je &#x17E;e izbran",
                  "ba-videorecorder.uploading-src-error": "Videoposnetka trenutno ni mogo&#x10D;e predvajati, nalaganje &#x161;e poteka",
                  "ba-audiorecorder-controlbar.pause-recorder": "Zaustavi snemalnik",
                  "ba-audiorecorder-controlbar.resume-recorder": "Snemalnik &#x17E;ivljenjepisov"
                },
                "language:sr": {
                  "ba-videoplayer-playbutton.tooltip": "&#x426;&#x43B;&#x438;&#x446;&#x43A; &#x442;&#x43E; &#x43F;&#x43B;&#x430;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E;.",
                  "ba-videoplayer-playbutton.rerecord": "&#x43F;&#x440;&#x435;&#x43F;&#x440;&#x430;&#x432;&#x438;&#x442;&#x438;",
                  "ba-videoplayer-playbutton.submit-video": "&#x43F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x438;&#x442;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-loader.tooltip": "&#x41B;&#x43E;&#x430;&#x434;&#x438;&#x43D;&#x433; &#x432;&#x438;&#x434;&#x435;&#x43E; ...",
                  "ba-videoplayer-controlbar.change-resolution": "&#x41F;&#x440;&#x43E;&#x43C;&#x435;&#x43D;&#x430; &#x440;&#x435;&#x437;&#x43E;&#x43B;&#x443;&#x446;&#x438;&#x458;&#x435;",
                  "ba-videoplayer-controlbar.video-progress": "&#x432;&#x438;&#x434;&#x435;&#x43E; &#x43D;&#x430;&#x43F;&#x440;&#x435;&#x434;&#x430;&#x43A;",
                  "ba-videoplayer-controlbar.rerecord-video": "&#x420;&#x435;&#x434;&#x43E; &#x432;&#x438;&#x434;&#x435;&#x43E;?",
                  "ba-videoplayer-controlbar.submit-video": "&#x43F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x438;&#x442;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.play-video": "&#x43F;&#x43B;&#x430;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.pause-video": "&#x43F;&#x430;&#x443;&#x437;&#x430; video",
                  "ba-videoplayer-controlbar.elapsed-time": "&#x415;&#x43B;&#x430;&#x441;&#x43F;&#x435;&#x434; &#x432;&#x440;&#x435;&#x43C;&#x435;",
                  "ba-videoplayer-controlbar.total-time": "&#x423;&#x43A;&#x443;&#x43F;&#x43D;&#x430; &#x434;&#x443;&#x436;&#x438;&#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-controlbar.fullscreen-video": "&#x415;&#x43D;&#x442;&#x435;&#x440; &#x444;&#x443;&#x43B;&#x43B;&#x441;&#x446;&#x440;&#x435;&#x435;&#x43D;",
                  "ba-videoplayer-controlbar.volume-button": "&#x41F;&#x43E;&#x434;&#x435;&#x448;&#x430;&#x432;&#x430;&#x45A;&#x435; &#x458;&#x430;&#x447;&#x438;&#x43D;&#x435; &#x437;&#x432;&#x443;&#x43A;&#x430;",
                  "ba-videoplayer-controlbar.volume-mute": "&#x43C;&#x443;&#x442;&#x435; &#x441;&#x43E;&#x443;&#x43D;&#x434;",
                  "ba-videoplayer-controlbar.volume-unmute": "&#x423;&#x43A;&#x459;&#x443;&#x447;&#x438; &#x437;&#x432;&#x443;&#x43A; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer.video-error": "&#x414;&#x43E;&#x448;&#x43B;&#x43E; &#x458;&#x435; &#x434;&#x43E; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x435;. &#x41C;&#x43E;&#x43B;&#x438;&#x43C;&#x43E;, &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x458;&#x442;&#x435; &#x43A;&#x430;&#x441;&#x43D;&#x438;&#x458;&#x435;. &#x426;&#x43B;&#x438;&#x446;&#x43A; &#x442;&#x43E; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x438;.",
                  "ba-videorecorder-chooser.record-video": "&#x421;&#x43D;&#x438;&#x43C;&#x438;&#x442;&#x435; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-chooser.upload-video": "&#x414;&#x43E;&#x434;&#x430;&#x458; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-controlbar.settings": "&#x41F;&#x43E;&#x434;&#x435;&#x448;&#x430;&#x432;&#x430;&#x45A;&#x430;",
                  "ba-videorecorder-controlbar.camerahealthy": "&#x41E;&#x441;&#x432;&#x435;&#x442;&#x459;&#x435;&#x45A;&#x435; &#x458;&#x435; &#x434;&#x43E;&#x431;&#x440;&#x43E;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "&#x41E;&#x441;&#x432;&#x435;&#x442;&#x459;&#x435;&#x45A;&#x435; &#x43D;&#x438;&#x458;&#x435; &#x43E;&#x43F;&#x442;&#x438;&#x43C;&#x430;&#x43B;&#x43D;&#x430;",
                  "ba-videorecorder-controlbar.microphonehealthy": "&#x417;&#x432;&#x443;&#x43A; &#x458;&#x435; &#x434;&#x43E;&#x431;&#x430;&#x440;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "&#x41D;&#x435; &#x43C;&#x43E;&#x433;&#x443; &#x443;&#x437;&#x435;&#x442;&#x438; &#x431;&#x438;&#x43B;&#x43E; &#x43A;&#x43E;&#x458;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videorecorder-controlbar.record": "&#x437;&#x430;&#x43F;&#x438;&#x441;",
                  "ba-videorecorder-controlbar.record-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x45A;&#x435;.",
                  "ba-videorecorder-controlbar.rerecord": "&#x43F;&#x440;&#x435;&#x43F;&#x440;&#x430;&#x432;&#x438;&#x442;&#x438;",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x43F;&#x43E;&#x43D;&#x430;&#x432;&#x459;&#x430;&#x45A;&#x435;.",
                  "ba-videorecorder-controlbar.upload-covershot": "&#x43E;&#x442;&#x43F;&#x440;&#x435;&#x43C;&#x430;&#x45A;&#x435;",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x440;&#x438;&#x43B;&#x430;&#x433;&#x43E;&#x452;&#x435;&#x43D;&#x443; &#x43D;&#x430;&#x441;&#x43B;&#x43E;&#x432;&#x43D;&#x443; &#x43C;&#x435;&#x442;&#x430;&#x43A;",
                  "ba-videorecorder-controlbar.stop": "&#x417;&#x430;&#x443;&#x441;&#x442;&#x430;&#x432;&#x438;&#x442;&#x438;",
                  "ba-videorecorder-controlbar.stop-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x441;&#x435; &#x437;&#x430;&#x443;&#x441;&#x442;&#x430;&#x432;&#x438;.",
                  "ba-videorecorder-controlbar.skip": "&#x43F;&#x440;&#x435;&#x441;&#x43A;&#x43E;&#x447;&#x438;&#x442;&#x438;",
                  "ba-videorecorder-controlbar.skip-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x43F;&#x440;&#x435;&#x441;&#x43A;&#x43E;&#x447;&#x438;&#x442;&#x435;.",
                  "ba-videorecorder.recorder-error": "&#x414;&#x43E;&#x448;&#x43B;&#x43E; &#x458;&#x435; &#x434;&#x43E; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x435;. &#x41C;&#x43E;&#x43B;&#x438;&#x43C;&#x43E;, &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x458;&#x442;&#x435; &#x43A;&#x430;&#x441;&#x43D;&#x438;&#x458;&#x435;. &#x426;&#x43B;&#x438;&#x446;&#x43A; &#x442;&#x43E; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x438;.",
                  "ba-videorecorder.attach-error": "&#x41C;&#x438; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F;&#x438; &#x438;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x458;&#x441; &#x43A;&#x430;&#x43C;&#x435;&#x440;&#x435;. &#x423; &#x437;&#x430;&#x432;&#x438;&#x441;&#x43D;&#x43E;&#x441;&#x442;&#x438; &#x43E;&#x434; &#x443;&#x440;&#x435;&#x452;&#x430;&#x458;&#x430; &#x438; &#x43F;&#x440;&#x435;&#x442;&#x440;&#x430;&#x436;&#x438;&#x432;&#x430;&#x447;&#x430;, &#x43C;&#x43E;&#x436;&#x434;&#x430; &#x45B;&#x435;&#x442;&#x435; &#x43C;&#x43E;&#x440;&#x430;&#x442;&#x438; &#x434;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; &#x424;&#x43B;&#x430;&#x441;&#x445; &#x438;&#x43B;&#x438; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F;&#x438;&#x43B;&#x438; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x438; &#x43F;&#x440;&#x435;&#x43A;&#x43E; &#x421;&#x421;&#x41B;.",
                  "ba-videorecorder.access-forbidden": "&#x41F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F; &#x43A;&#x430;&#x43C;&#x435;&#x440;&#x43E;&#x43C; &#x458;&#x435; &#x437;&#x430;&#x431;&#x440;&#x430;&#x45A;&#x435;&#x43D;&#x43E;. &#x426;&#x43B;&#x438;&#x446;&#x43A; &#x442;&#x43E; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x438;.",
                  "ba-videorecorder.pick-covershot": "&#x418;&#x437;&#x430;&#x431;&#x435;&#x440;&#x438;&#x442;&#x435; &#x446;&#x43E;&#x432;&#x435;&#x440;&#x441;&#x445;&#x43E;&#x442;.",
                  "ba-videorecorder.uploading": "&#x443;&#x43F;&#x43B;&#x43E;&#x430;&#x434;&#x438;&#x43D;&#x433;",
                  "ba-videorecorder.uploading-failed": "&#x423;&#x43F;&#x43B;&#x43E;&#x430;&#x434;&#x438;&#x43D;&#x433; &#x444;&#x430;&#x438;&#x43B;&#x435;&#x434; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-videorecorder.verifying": "&#x432;&#x435;&#x440;&#x438;&#x444;&#x438;&#x43A;&#x430;&#x446;&#x438;&#x458;&#x443;",
                  "ba-videorecorder.verifying-failed": "&#x41F;&#x440;&#x43E;&#x432;&#x435;&#x440;&#x430; &#x43D;&#x438;&#x458;&#x435; &#x443;&#x441;&#x43F;&#x435;&#x43B;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-videorecorder.rerecord-confirm": "&#x414;&#x430; &#x43B;&#x438; &#x437;&#x430;&#x438;&#x441;&#x442;&#x430; &#x436;&#x435;&#x43B;&#x438;&#x442;&#x435; &#x434;&#x430; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x435; &#x441;&#x432;&#x43E;&#x458; &#x432;&#x438;&#x434;&#x435;&#x43E;?",
                  "ba-videorecorder.video_file_too_large": "&#x412;&#x430;&#x448; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430; &#x458;&#x435; &#x43F;&#x440;&#x435;&#x432;&#x435;&#x43B;&#x438;&#x43A;&#x430; (%s) - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E; &#x441;&#x430; &#x43C;&#x430;&#x45A;&#x43E;&#x43C; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x444;&#x430;&#x458;&#x43B;.",
                  "ba-videorecorder.unsupported_video_type": "&#x41C;&#x43E;&#x43B;&#x438;&#x43C;&#x43E; &#x412;&#x430;&#x441; &#x434;&#x430; &#x443;&#x43F;&#x43B;&#x43E;&#x430;&#x434;: %&#x441; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "&#x418;&#x437;&#x43B;&#x430;&#x437; &#x438;&#x437; &#x446;&#x435;&#x43B;&#x43E;&#x433; &#x435;&#x43A;&#x440;&#x430;&#x43D;&#x430;",
                  "ba-videoplayer-share.share": "&#x41F;&#x43E;&#x434;&#x435;&#x43B;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-chooser.record-screen": "&#x421;&#x43D;&#x438;&#x43C;&#x430;&#x43A; &#x435;&#x43A;&#x440;&#x430;&#x43D;&#x430;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "&#x41F;&#x430;&#x443;&#x437;&#x430; &#x43D;&#x438;&#x458;&#x435; &#x43F;&#x43E;&#x434;&#x440;&#x436;&#x430;&#x43D;&#x430;",
                  "ba-videorecorder-chooser.record-audio": "&#x421;&#x43D;&#x438;&#x43C;&#x438;&#x442;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videorecorder-controlbar.stop-available-after": "&#x41C;&#x438;&#x43D;&#x438;&#x43C;&#x430;&#x43B;&#x43D;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x45A;&#x430; &#x458;&#x435; %d &#x441;&#x435;&#x43A;&#x443;&#x43D;&#x434;&#x438;",
                  "ba-videorecorder-controlbar.cancel": "&#x41F;&#x43E;&#x43D;&#x438;&#x448;&#x442;&#x438;&#x442;&#x438;, &#x43E;&#x442;&#x43A;&#x430;&#x437;&#x430;&#x442;&#x438;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43E;&#x442;&#x43A;&#x430;&#x437;&#x430;&#x43B;&#x438;.",
                  "ba-videorecorder.cancel-confirm": "&#x414;&#x430; &#x43B;&#x438; &#x437;&#x430;&#x438;&#x441;&#x442;&#x430; &#x436;&#x435;&#x43B;&#x438;&#x442;&#x435; &#x434;&#x430; &#x43E;&#x442;&#x43A;&#x430;&#x436;&#x435;&#x442;&#x435; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x43E;&#x442;&#x43F;&#x440;&#x435;&#x43C;&#x430;&#x45A;&#x435;?",
                  "ba-videoplayer-adslot.elapsed-time": "&#x415;&#x43B;&#x430;&#x441;&#x43F;&#x435;&#x434; &#x442;&#x438;&#x43C;&#x435;",
                  "ba-videoplayer-adslot.volume-button": "&#x41F;&#x43E;&#x434;&#x435;&#x441;&#x438;&#x442;&#x435; &#x458;&#x430;&#x447;&#x438;&#x43D;&#x443; &#x437;&#x432;&#x443;&#x43A;&#x430;",
                  "ba-videoplayer-adslot.volume-mute": "&#x418;&#x441;&#x43A;&#x459;&#x443;&#x447;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer-adslot.volume-unmute": "&#x423;&#x43A;&#x459;&#x443;&#x447;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer-adslot.ad-will-end-after": "&#x41E;&#x433;&#x43B;&#x430;&#x441; &#x45B;&#x435; &#x441;&#x435; &#x437;&#x430;&#x432;&#x440;&#x448;&#x438;&#x442;&#x438; &#x43D;&#x430;&#x43A;&#x43E;&#x43D; %&#x441;",
                  "ba-videoplayer-adslot.can-skip-after": "&#x41F;&#x440;&#x435;&#x441;&#x43A;&#x43E;&#x447;&#x438; &#x43F;&#x43E;&#x441;&#x43B;&#x435; %d",
                  "ba-videoplayer-adslot.skip-ad": "&#x41F;&#x440;&#x435;&#x441;&#x43A;&#x43E;&#x447;&#x438;&#x442;&#x435; &#x43E;&#x433;&#x43B;&#x430;&#x441;",
                  "ba-videorecorder.software-required": "&#x41C;&#x43E;&#x43B;&#x438;&#x43C;&#x43E; &#x434;&#x430; &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x438;&#x441;&#x43F;&#x43E;&#x434; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x43B;&#x438; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x43B;&#x438; &#x441;&#x43B;&#x435;&#x434;&#x435;&#x45B;&#x435; &#x437;&#x430;&#x445;&#x442;&#x435;&#x432;&#x435; &#x43A;&#x430;&#x43A;&#x43E; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43D;&#x430;&#x441;&#x442;&#x430;&#x432;&#x438;&#x43B;&#x438;.",
                  "ba-videorecorder.software-waiting": "&#x427;&#x435;&#x43A;&#x430; &#x441;&#x435; &#x437;&#x430;&#x445;&#x442;&#x435;&#x432; &#x43A;&#x43E;&#x458;&#x438; &#x442;&#x440;&#x435;&#x431;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x438; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x442;&#x438;. &#x41C;&#x43E;&#x436;&#x434;&#x430; &#x45B;&#x435;&#x442;&#x435; &#x43C;&#x43E;&#x440;&#x430;&#x442;&#x438; &#x43E;&#x441;&#x432;&#x435;&#x436;&#x438;&#x442;&#x438; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x443; &#x43D;&#x430;&#x43A;&#x43E;&#x43D; &#x437;&#x430;&#x432;&#x440;&#x448;&#x435;&#x442;&#x43A;&#x430;.",
                  "ba-videoplayer-controlbar.close-tracks": "&#x417;&#x430;&#x442;&#x432;&#x43E;&#x440;&#x438; &#x426;&#x426;",
                  "ba-videoplayer-controlbar.show-tracks": "&#x41F;&#x440;&#x438;&#x43A;&#x430;&#x436;&#x438; &#x426;&#x426;",
                  "ba-videoplayer-tracks.upload-text-tracks": "&#x414;&#x43E;&#x434;&#x430;&#x458; &#x442;&#x435;&#x43A;&#x441;&#x442;&#x443;&#x430;&#x43B;&#x43D;&#x435; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x435;",
                  "ba-videoplayer-tracks.select-text-track-language": "&#x408;&#x435;&#x437;&#x438;&#x43A; &#x442;&#x438;&#x442;&#x43B;&#x430;",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x41F;&#x440;&#x432;&#x43E; &#x438;&#x437;&#x430;&#x431;&#x435;&#x440;&#x438;&#x442;&#x435; &#x43B;&#x43E;&#x43A;&#x430;&#x43B;",
                  "ba-videoplayer-tracks.select-text-track-file": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x438;&#x437;&#x430;&#x431;&#x440;&#x430;&#x43B;&#x438; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x443;",
                  "ba-videoplayer-tracks.back": "&#x43D;&#x430;&#x437;&#x430;&#x434;",
                  "ba-videorecorder.framerate-warning": "&#x421;&#x442;&#x43E;&#x43F;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x43A;&#x430;&#x434;&#x440;&#x430; &#x458;&#x435; &#x432;&#x440;&#x43B;&#x43E; &#x43D;&#x438;&#x441;&#x43A;&#x430;. &#x41F;&#x440;&#x435;&#x43F;&#x43E;&#x440;&#x443;&#x447;&#x443;&#x458;&#x435;&#x43C;&#x43E; &#x434;&#x430; &#x437;&#x430;&#x442;&#x432;&#x430;&#x440;&#x430;&#x442;&#x435; &#x441;&#x432;&#x435; &#x434;&#x440;&#x443;&#x433;&#x435; &#x43F;&#x440;&#x43E;&#x433;&#x440;&#x430;&#x43C;&#x435; &#x438; &#x43A;&#x430;&#x440;&#x442;&#x438;&#x446;&#x435; &#x43F;&#x440;&#x435;&#x433;&#x43B;&#x435;&#x434;&#x430;&#x447;&#x430; &#x438;&#x43B;&#x438; &#x434;&#x430; &#x43A;&#x43E;&#x440;&#x438;&#x441;&#x442;&#x438;&#x442;&#x435; &#x431;&#x440;&#x436;&#x438; &#x440;&#x430;&#x447;&#x443;&#x43D;&#x430;&#x440;.",
                  "ba-videorecorder.upload-error-duration": "&#x414;&#x443;&#x436;&#x438;&#x43D;&#x430; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x441;&#x43D;&#x438;&#x43C;&#x43A;&#x430; &#x43D;&#x435; &#x438;&#x441;&#x43F;&#x443;&#x45A;&#x430;&#x432;&#x430; &#x443;&#x441;&#x43B;&#x43E;&#x432;&#x435; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438;.",
                  "ba-videorecorder.resolution-constraint-error": "&#x414;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430; &#x43A;&#x43E;&#x458;&#x443; &#x441;&#x442;&#x435; &#x43E;&#x434;&#x430;&#x431;&#x440;&#x430;&#x43B;&#x438; &#x43D;&#x435; &#x43E;&#x434;&#x433;&#x43E;&#x432;&#x430;&#x440;&#x430; &#x442;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43E;&#x458; &#x440;&#x435;&#x437;&#x43E;&#x43B;&#x443;&#x446;&#x438;&#x458;&#x438; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438;.",
                  "ba-videorecorder.orientation-portrait-required": "&#x420;&#x43E;&#x442;&#x438;&#x440;&#x430;&#x458;&#x442;&#x435; &#x443;&#x440;&#x435;&#x452;&#x430;&#x458; &#x437;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x45A;&#x435; &#x443; &#x43F;&#x43E;&#x440;&#x442;&#x440;&#x435;&#x442;&#x43D;&#x43E;&#x43C; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x443;.",
                  "ba-videorecorder.orientation-landscape-required": "&#x420;&#x43E;&#x442;&#x438;&#x440;&#x430;&#x458;&#x442;&#x435; &#x443;&#x440;&#x435;&#x452;&#x430;&#x458; &#x43A;&#x430;&#x43A;&#x43E; &#x431;&#x438;&#x441;&#x442;&#x435; &#x441;&#x43D;&#x438;&#x43C;&#x438;&#x43B;&#x438; &#x443; &#x43F;&#x435;&#x458;&#x437;&#x430;&#x436;&#x43D;&#x43E;&#x43C; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x443;.",
                  "ba-imageviewer-controlbar.rerecord-image": "&#x41F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;?",
                  "ba-imageviewer-controlbar.submit-image": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x438;",
                  "ba-imageviewer-controlbar.fullscreen-image": "&#x423;&#x43D;&#x435;&#x441;&#x438;&#x442;&#x435; &#x446;&#x435;&#x43E; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "&#x418;&#x437;&#x430;&#x45B;&#x438; &#x438;&#x437; &#x446;&#x435;&#x43B;&#x43E;&#x433; &#x435;&#x43A;&#x440;&#x430;&#x43D;&#x430;",
                  "ba-imageviewer.image-error": "&#x414;&#x43E;&#x448;&#x43B;&#x43E; &#x458;&#x435; &#x434;&#x43E; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x435;. &#x41C;&#x43E;&#x43B;&#x438;&#x43C;&#x43E;, &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x458;&#x442;&#x435; &#x43A;&#x430;&#x441;&#x43D;&#x438;&#x458;&#x435;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438;.",
                  "ba-imagecapture-chooser.image-capture": "&#x426;&#x430;&#x43F;&#x442;&#x443;&#x440;&#x435; &#x418;&#x43C;&#x430;&#x433;&#x435;",
                  "ba-imagecapture-chooser.upload-image": "&#x423;&#x447;&#x438;&#x442;&#x430;&#x458; &#x441;&#x43B;&#x438;&#x43A;&#x443;",
                  "ba-imagecapture-controlbar.settings": "&#x41F;&#x43E;&#x434;&#x435;&#x448;&#x430;&#x432;&#x430;&#x45A;&#x430;",
                  "ba-imagecapture-controlbar.camerahealthy": "&#x41E;&#x441;&#x432;&#x435;&#x442;&#x459;&#x435;&#x45A;&#x435; &#x458;&#x435; &#x434;&#x43E;&#x431;&#x440;&#x43E;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "&#x41E;&#x441;&#x432;&#x435;&#x442;&#x459;&#x435;&#x45A;&#x435; &#x43D;&#x438;&#x458;&#x435; &#x43E;&#x43F;&#x442;&#x438;&#x43C;&#x430;&#x43B;&#x43D;&#x43E;",
                  "ba-imagecapture-controlbar.record": "&#x421;&#x43D;&#x438;&#x43C;&#x430;&#x458;&#x442;&#x435;",
                  "ba-imagecapture-controlbar.record-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x441;&#x43D;&#x438;&#x43C;&#x438;&#x43B;&#x438;.",
                  "ba-imagecapture-controlbar.rerecord": "&#x41F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x438;&#x43B;&#x438;.",
                  "ba-imagecapture-controlbar.cancel": "&#x41F;&#x43E;&#x43D;&#x438;&#x448;&#x442;&#x438;&#x442;&#x438;, &#x43E;&#x442;&#x43A;&#x430;&#x437;&#x430;&#x442;&#x438;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43E;&#x442;&#x43A;&#x430;&#x437;&#x430;&#x43B;&#x438;.",
                  "ba-audioplayer-controlbar.audio-progress": "&#x41D;&#x430;&#x43F;&#x440;&#x435;&#x434;&#x430;&#x43A;",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#x41F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;?",
                  "ba-audioplayer-controlbar.submit-audio": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x438;",
                  "ba-audioplayer-controlbar.play-audio": "&#x418;&#x433;&#x440;&#x430;",
                  "ba-audioplayer-controlbar.pause-audio": "&#x41F;&#x430;&#x443;&#x437;&#x438;&#x440;&#x430;&#x458;",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "&#x41F;&#x430;&#x443;&#x437;&#x430; &#x43D;&#x438;&#x458;&#x435; &#x43F;&#x43E;&#x434;&#x440;&#x436;&#x430;&#x43D;&#x430;",
                  "ba-audioplayer-controlbar.elapsed-time": "&#x415;&#x43B;&#x430;&#x441;&#x43F;&#x435;&#x434; &#x442;&#x438;&#x43C;&#x435;",
                  "ba-audioplayer-controlbar.total-time": "&#x423;&#x43A;&#x443;&#x43F;&#x43D;&#x430; &#x434;&#x443;&#x436;&#x438;&#x43D;&#x430;",
                  "ba-audioplayer-controlbar.volume-button": "&#x41F;&#x43E;&#x434;&#x435;&#x441;&#x438;&#x442;&#x435; &#x458;&#x430;&#x447;&#x438;&#x43D;&#x443; &#x437;&#x432;&#x443;&#x43A;&#x430;",
                  "ba-audioplayer-controlbar.volume-mute": "&#x418;&#x441;&#x43A;&#x459;&#x443;&#x447;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audioplayer-controlbar.volume-unmute": "&#x423;&#x43A;&#x459;&#x443;&#x447;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audioplayer-loader.tooltip": "&#x423;&#x447;&#x438;&#x442;&#x430;&#x432;&#x430;&#x45A;&#x435; ...",
                  "ba-audioplayer.audio-error": "&#x414;&#x43E;&#x448;&#x43B;&#x43E; &#x458;&#x435; &#x434;&#x43E; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x435;. &#x41C;&#x43E;&#x43B;&#x438;&#x43C;&#x43E;, &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x458;&#x442;&#x435; &#x43A;&#x430;&#x441;&#x43D;&#x438;&#x458;&#x435;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438;.",
                  "ba-audiorecorder-chooser.record-audio": "&#x421;&#x43D;&#x438;&#x43C;&#x438;&#x442;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audiorecorder-chooser.upload-audio": "&#x423;&#x43F;&#x43B;&#x43E;&#x430;&#x434; &#x410;&#x443;&#x434;&#x438;&#x43E;",
                  "ba-audiorecorder-controlbar.settings": "&#x41F;&#x43E;&#x434;&#x435;&#x448;&#x430;&#x432;&#x430;&#x45A;&#x430;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "&#x417;&#x432;&#x443;&#x43A; &#x458;&#x435; &#x434;&#x43E;&#x431;&#x430;&#x440;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "&#x41D;&#x435; &#x43C;&#x43E;&#x433;&#x443; &#x43F;&#x43E;&#x434;&#x438;&#x45B;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audiorecorder-controlbar.record": "&#x417;&#x430;&#x43F;&#x438;&#x441;",
                  "ba-audiorecorder-controlbar.record-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x437;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x45A;&#x435;.",
                  "ba-audiorecorder-controlbar.rerecord": "&#x41F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x438;&#x43B;&#x438;.",
                  "ba-audiorecorder-controlbar.stop": "&#x417;&#x430;&#x443;&#x441;&#x442;&#x430;&#x432;&#x438;&#x442;&#x438;",
                  "ba-audiorecorder-controlbar.stop-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x437;&#x430;&#x443;&#x441;&#x442;&#x430;&#x432;&#x438;&#x43B;&#x438;.",
                  "ba-audiorecorder-controlbar.stop-available-after": "&#x41C;&#x438;&#x43D;&#x438;&#x43C;&#x430;&#x43B;&#x43D;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x45A;&#x430; &#x458;&#x435; %d &#x441;&#x435;&#x43A;&#x443;&#x43D;&#x434;&#x438;",
                  "ba-audiorecorder-controlbar.cancel": "&#x41F;&#x43E;&#x43D;&#x438;&#x448;&#x442;&#x438;&#x442;&#x438;, &#x43E;&#x442;&#x43A;&#x430;&#x437;&#x430;&#x442;&#x438;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43E;&#x442;&#x43A;&#x430;&#x437;&#x430;&#x43B;&#x438;.",
                  "ba-videoplayer-controlbar.player-speed": "&#x411;&#x440;&#x437;&#x438;&#x43D;&#x430; &#x438;&#x433;&#x440;&#x430;&#x447;&#x430;",
                  "ba-videoplayer-controlbar.settings": "&#x41F;&#x43E;&#x434;&#x435;&#x448;&#x430;&#x432;&#x430;&#x45A;&#x430;",
                  "ba-videoplayer-controlbar.airplay": "&#x410;&#x438;&#x440;&#x43F;&#x43B;&#x430;&#x438;",
                  "ba-videoplayer-controlbar.airplay-icon": "&#x410;&#x438;&#x440;&#x43F;&#x43B;&#x430;&#x438; &#x438;&#x446;&#x43E;&#x43D;.",
                  "ba-videoplayer.all-settings": "&#x421;&#x432;&#x430; &#x43F;&#x43E;&#x434;&#x435;&#x448;&#x430;&#x432;&#x430;&#x45A;&#x430;",
                  "ba-videoplayer.player-speed": "&#x411;&#x440;&#x437;&#x438;&#x43D;&#x430; &#x438;&#x433;&#x440;&#x430;&#x447;&#x430;",
                  "ba-videoplayer.full-screen": "&#x426;&#x435;&#x43E; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-videorecorder-controlbar.add-stream": "&#x410;&#x434;&#x434; &#x421;&#x442;&#x440;&#x435;&#x430;&#x43C;",
                  "ba-videorecorder.switch-camera": "&#x421;&#x432;&#x438;&#x442;&#x446;&#x445; &#x446;&#x430;&#x43C;&#x435;&#x440;&#x430;",
                  "ba-videorecorder.prepare-covershot": "&#x41F;&#x440;&#x438;&#x43F;&#x440;&#x435;&#x43C;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x43A;&#x430;",
                  "ba-videorecorder.prepare-thumbnails": "&#x41F;&#x440;&#x438;&#x43F;&#x440;&#x435;&#x43C;&#x430; &#x437;&#x430; &#x442;&#x440;&#x430;&#x436;&#x435;&#x45A;&#x435; &#x441;&#x43B;&#x438;&#x447;&#x438;&#x446;&#x430;",
                  "ba-videorecorder.adding-new-stream": "&#x414;&#x43E;&#x434;&#x430;&#x432;&#x430;&#x45A;&#x435; &#x43D;&#x43E;&#x432;&#x43E;&#x433; &#x442;&#x43E;&#x43A;&#x430;",
                  "ba-imagecapture.recorder-error": "&#x414;&#x43E;&#x448;&#x43B;&#x43E; &#x458;&#x435; &#x434;&#x43E; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x435;. &#x41C;&#x43E;&#x43B;&#x438;&#x43C;&#x43E;, &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x458;&#x442;&#x435; &#x43A;&#x430;&#x441;&#x43D;&#x438;&#x458;&#x435;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.attach-error": "&#x41D;&#x438;&#x441;&#x43C;&#x43E; &#x43C;&#x43E;&#x433;&#x43B;&#x438; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F;&#x438;&#x43C;&#x43E; &#x438;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x458;&#x441;&#x443; &#x43C;&#x435;&#x434;&#x438;&#x458;&#x430;. &#x423; &#x437;&#x430;&#x432;&#x438;&#x441;&#x43D;&#x43E;&#x441;&#x442;&#x438; &#x43E;&#x434; &#x443;&#x440;&#x435;&#x452;&#x430;&#x458;&#x430; &#x438; &#x43F;&#x440;&#x435;&#x442;&#x440;&#x430;&#x436;&#x438;&#x432;&#x430;&#x447;&#x430;, &#x43C;&#x43E;&#x436;&#x434;&#x430; &#x45B;&#x435;&#x442;&#x435; &#x43C;&#x43E;&#x440;&#x430;&#x442;&#x438; &#x434;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; &#x424;&#x43B;&#x430;&#x441;&#x445; &#x438;&#x43B;&#x438; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F;&#x438;&#x442;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x438; &#x43F;&#x440;&#x435;&#x43A;&#x43E; &#x421;&#x421;&#x41B;-&#x430;.",
                  "ba-imagecapture.software-required": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x438;&#x441;&#x43F;&#x43E;&#x434; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x43B;&#x438; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x43B;&#x438; &#x441;&#x43B;&#x435;&#x434;&#x435;&#x45B;&#x435; &#x437;&#x430;&#x445;&#x442;&#x435;&#x432;&#x435; &#x43A;&#x430;&#x43A;&#x43E; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43D;&#x430;&#x441;&#x442;&#x430;&#x432;&#x438;&#x43B;&#x438;.",
                  "ba-imagecapture.software-waiting": "&#x427;&#x435;&#x43A;&#x430;&#x45A;&#x435; &#x434;&#x430; &#x441;&#x435; &#x437;&#x430;&#x445;&#x442;&#x458;&#x435;&#x432;&#x438; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x458;&#x443; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x458;&#x443;. &#x41C;&#x43E;&#x436;&#x434;&#x430; &#x45B;&#x435;&#x442;&#x435; &#x43C;&#x43E;&#x440;&#x430;&#x442;&#x438; &#x434;&#x430; &#x43E;&#x441;&#x432;&#x435;&#x436;&#x438;&#x442;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x443; &#x43D;&#x430;&#x43A;&#x43E;&#x43D; &#x437;&#x430;&#x432;&#x440;&#x448;&#x435;&#x442;&#x43A;&#x430;.",
                  "ba-imagecapture.access-forbidden": "&#x41F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F; &#x43C;&#x435;&#x434;&#x438;&#x458;&#x438;&#x43C;&#x430; &#x431;&#x438;&#x43E; &#x458;&#x435; &#x437;&#x430;&#x431;&#x440;&#x430;&#x45A;&#x435;&#x43D;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.uploading": "&#x423;&#x43F;&#x43B;&#x43E;&#x430;&#x434;&#x438;&#x43D;&#x433;",
                  "ba-imagecapture.uploading-failed": "&#x41E;&#x442;&#x43F;&#x440;&#x435;&#x43C;&#x430;&#x45A;&#x435; &#x43D;&#x438;&#x458;&#x435; &#x443;&#x441;&#x43F;&#x435;&#x43B;&#x43E; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.upload-error-duration": "&#x414;&#x443;&#x436;&#x438;&#x43D;&#x430; &#x443;&#x447;&#x438;&#x442;&#x430;&#x43D;&#x435; &#x441;&#x43B;&#x438;&#x43A;&#x435; &#x43D;&#x435; &#x438;&#x441;&#x43F;&#x443;&#x45A;&#x430;&#x432;&#x430; &#x437;&#x430;&#x445;&#x442;&#x435;&#x432;&#x435; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.resolution-constraint-error": "&#x414;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430; &#x43A;&#x43E;&#x458;&#x443; &#x441;&#x442;&#x435; &#x438;&#x437;&#x430;&#x431;&#x440;&#x430;&#x43B;&#x438; &#x43D;&#x435; &#x43E;&#x434;&#x433;&#x43E;&#x432;&#x430;&#x440;&#x430; &#x437;&#x430;&#x445;&#x442;&#x435;&#x432;&#x430;&#x43D;&#x43E;&#x458; &#x440;&#x435;&#x437;&#x43E;&#x43B;&#x443;&#x446;&#x438;&#x458;&#x438; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.verifying": "&#x412;&#x435;&#x440;&#x438;&#x444;&#x438;&#x43A;&#x43E;&#x432;&#x430;&#x45A;&#x435;",
                  "ba-imagecapture.verifying-failed": "&#x412;&#x435;&#x440;&#x438;&#x444;&#x438;&#x43A;&#x430;&#x446;&#x438;&#x458;&#x430; &#x43D;&#x438;&#x458;&#x435; &#x443;&#x441;&#x43F;&#x435;&#x43B;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.rerecord-confirm": "&#x414;&#x430; &#x43B;&#x438; &#x437;&#x430;&#x438;&#x441;&#x442;&#x430; &#x436;&#x435;&#x43B;&#x438;&#x442;&#x435; &#x434;&#x430; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x440;&#x435;&#x443;&#x437;&#x43C;&#x435;&#x442;&#x435; &#x441;&#x43B;&#x438;&#x43A;&#x443;?",
                  "ba-imagecapture.image_file_too_large": "&#x414;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430; &#x441;&#x43B;&#x438;&#x43A;&#x435; &#x458;&#x435; &#x43F;&#x440;&#x435;&#x432;&#x435;&#x43B;&#x438;&#x43A;&#x430; (%&#x441;) - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E; &#x441;&#x430; &#x43C;&#x430;&#x45A;&#x43E;&#x43C; &#x441;&#x43B;&#x438;&#x43A;&#x43E;&#x43C;.",
                  "ba-imagecapture.unsupported_image_type": "&#x423;&#x447;&#x438;&#x442;&#x430;&#x458;&#x442;&#x435;: %&#x441; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-imagecapture.orientation-portrait-required": "&#x420;&#x43E;&#x442;&#x438;&#x440;&#x430;&#x458;&#x442;&#x435; &#x443;&#x440;&#x435;&#x452;&#x430;&#x458; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x43B;&#x438; &#x443; &#x43F;&#x43E;&#x440;&#x442;&#x440;&#x435;&#x442;&#x43D;&#x43E;&#x43C; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x443;.",
                  "ba-imagecapture.orientation-landscape-required": "&#x420;&#x43E;&#x442;&#x438;&#x440;&#x430;&#x458;&#x442;&#x435; &#x443;&#x440;&#x435;&#x452;&#x430;&#x458; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x43B;&#x438; &#x443; &#x43F;&#x435;&#x458;&#x437;&#x430;&#x436;&#x43D;&#x43E;&#x43C; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x443;.",
                  "ba-audiorecorder.recorder-error": "&#x414;&#x43E;&#x448;&#x43B;&#x43E; &#x458;&#x435; &#x434;&#x43E; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x435;. &#x41C;&#x43E;&#x43B;&#x438;&#x43C;&#x43E;, &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x458;&#x442;&#x435; &#x43A;&#x430;&#x441;&#x43D;&#x438;&#x458;&#x435;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-audiorecorder.attach-error": "&#x41D;&#x438;&#x441;&#x43C;&#x43E; &#x43C;&#x43E;&#x433;&#x43B;&#x438; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F;&#x438;&#x43C;&#x43E; &#x438;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x458;&#x441;&#x443; &#x43C;&#x435;&#x434;&#x438;&#x458;&#x430;. &#x423; &#x437;&#x430;&#x432;&#x438;&#x441;&#x43D;&#x43E;&#x441;&#x442;&#x438; &#x43E;&#x434; &#x443;&#x440;&#x435;&#x452;&#x430;&#x458;&#x430; &#x438; &#x43F;&#x440;&#x435;&#x442;&#x440;&#x430;&#x436;&#x438;&#x432;&#x430;&#x447;&#x430;, &#x43C;&#x43E;&#x436;&#x434;&#x430; &#x45B;&#x435;&#x442;&#x435; &#x43C;&#x43E;&#x440;&#x430;&#x442;&#x438; &#x434;&#x430; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x442;&#x435; &#x424;&#x43B;&#x430;&#x441;&#x445; &#x438;&#x43B;&#x438; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F;&#x438;&#x442;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x438; &#x43F;&#x440;&#x435;&#x43A;&#x43E; &#x421;&#x421;&#x41B;-&#x430;.",
                  "ba-audiorecorder.software-required": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x438;&#x441;&#x43F;&#x43E;&#x434; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x43B;&#x438; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x43B;&#x438; &#x441;&#x43B;&#x435;&#x434;&#x435;&#x45B;&#x435; &#x437;&#x430;&#x445;&#x442;&#x435;&#x432;&#x435; &#x43A;&#x430;&#x43A;&#x43E; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43D;&#x430;&#x441;&#x442;&#x430;&#x432;&#x438;&#x43B;&#x438;.",
                  "ba-audiorecorder.software-waiting": "&#x427;&#x435;&#x43A;&#x430;&#x45A;&#x435; &#x434;&#x430; &#x441;&#x435; &#x437;&#x430;&#x445;&#x442;&#x458;&#x435;&#x432;&#x438; &#x438;&#x43D;&#x441;&#x442;&#x430;&#x43B;&#x438;&#x440;&#x430;&#x458;&#x443; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x438;&#x440;&#x430;&#x458;&#x443;. &#x41C;&#x43E;&#x436;&#x434;&#x430; &#x45B;&#x435;&#x442;&#x435; &#x43C;&#x43E;&#x440;&#x430;&#x442;&#x438; &#x434;&#x430; &#x43E;&#x441;&#x432;&#x435;&#x436;&#x438;&#x442;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x443; &#x43D;&#x430;&#x43A;&#x43E;&#x43D; &#x437;&#x430;&#x432;&#x440;&#x448;&#x435;&#x442;&#x43A;&#x430;.",
                  "ba-audiorecorder.access-forbidden": "&#x41F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F; &#x43C;&#x435;&#x434;&#x438;&#x458;&#x438;&#x43C;&#x430; &#x431;&#x438;&#x43E; &#x458;&#x435; &#x437;&#x430;&#x431;&#x440;&#x430;&#x45A;&#x435;&#x43D;. &#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-audiorecorder.uploading": "&#x423;&#x43F;&#x43B;&#x43E;&#x430;&#x434;&#x438;&#x43D;&#x433;",
                  "ba-audiorecorder.uploading-failed": "&#x41E;&#x442;&#x43F;&#x440;&#x435;&#x43C;&#x430;&#x45A;&#x435; &#x43D;&#x438;&#x458;&#x435; &#x443;&#x441;&#x43F;&#x435;&#x43B;&#x43E; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-audiorecorder.upload-error-duration": "&#x414;&#x443;&#x436;&#x438;&#x43D;&#x430; &#x43F;&#x440;&#x435;&#x43D;&#x435;&#x441;&#x435;&#x43D;&#x43E;&#x433; &#x437;&#x432;&#x443;&#x43A;&#x430; &#x43D;&#x435; &#x438;&#x441;&#x43F;&#x443;&#x45A;&#x430;&#x432;&#x430; &#x437;&#x430;&#x445;&#x442;&#x435;&#x432;&#x435; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-audiorecorder.verifying": "&#x412;&#x435;&#x440;&#x438;&#x444;&#x438;&#x43A;&#x43E;&#x432;&#x430;&#x45A;&#x435;",
                  "ba-audiorecorder.verifying-failed": "&#x412;&#x435;&#x440;&#x438;&#x444;&#x438;&#x43A;&#x430;&#x446;&#x438;&#x458;&#x430; &#x43D;&#x438;&#x458;&#x435; &#x443;&#x441;&#x43F;&#x435;&#x43B;&#x430; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-audiorecorder.rerecord-confirm": "&#x414;&#x430; &#x43B;&#x438; &#x437;&#x430;&#x438;&#x441;&#x442;&#x430; &#x436;&#x435;&#x43B;&#x438;&#x442;&#x435; &#x434;&#x430; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x435; &#x437;&#x432;&#x443;&#x43A;?",
                  "ba-audiorecorder.cancel-confirm": "&#x414;&#x430; &#x43B;&#x438; &#x437;&#x430;&#x438;&#x441;&#x442;&#x430; &#x436;&#x435;&#x43B;&#x438;&#x442;&#x435; &#x434;&#x430; &#x43E;&#x442;&#x43A;&#x430;&#x436;&#x435;&#x442;&#x435; &#x443;&#x447;&#x438;&#x442;&#x430;&#x432;&#x430;&#x45A;&#x435; &#x437;&#x432;&#x443;&#x43A;&#x430;?",
                  "ba-audiorecorder.audio_file_too_large": "&#x412;&#x430;&#x448;&#x430; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x430; &#x458;&#x435; &#x43F;&#x440;&#x435;&#x432;&#x435;&#x43B;&#x438;&#x43A;&#x430; (%&#x441;) - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E; &#x441;&#x430; &#x43C;&#x430;&#x45A;&#x438;&#x43C; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x444;&#x430;&#x458;&#x43B;&#x43E;&#x43C;.",
                  "ba-audiorecorder.unsupported_audio_type": "&#x423;&#x447;&#x438;&#x442;&#x430;&#x458;&#x442;&#x435;: %&#x441; - &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x434;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ba-common-settingsmenu.tooltip": "&#x41A;&#x43B;&#x438;&#x43A;&#x43D;&#x438;&#x442;&#x435; &#x437;&#x430; &#x440;&#x435;&#x43F;&#x440;&#x43E;&#x434;&#x443;&#x43A;&#x446;&#x438;&#x458;&#x443;.",
                  "ba-common-settingsmenu.setting-menu": "&#x421;&#x432;&#x430; &#x43F;&#x43E;&#x434;&#x435;&#x448;&#x430;&#x432;&#x430;&#x45A;&#x430;",
                  "ba-common-settingsmenu.source-quality": "&#x41A;&#x432;&#x430;&#x43B;&#x438;&#x442;&#x435;&#x442; &#x438;&#x437;&#x432;&#x43E;&#x440;&#x430;",
                  "ba-common-settingsmenu.player-speed": "&#x411;&#x440;&#x437;&#x438;&#x43D;&#x430; &#x438;&#x433;&#x440;&#x430;&#x447;&#x430;",
                  "ba-common-settingsmenu.set-menu-option": "&#x41F;&#x43E;&#x441;&#x442;&#x430;&#x432;&#x438;&#x442;&#x435; &#x43E;&#x43F;&#x446;&#x438;&#x458;&#x443;",
                  "ba-common-settingsmenu.submit-video": "&#x41F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x438;&#x442;&#x435; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-common-settingsmenu.picture-in-picture": "&#x421;&#x43B;&#x438;&#x43A;&#x430; &#x443; &#x441;&#x43B;&#x438;&#x446;&#x438;",
                  "ba-common-settingsmenu.exit-fullscreen-video": "&#x418;&#x437;&#x430;&#x452;&#x438; &#x438;&#x437; &#x446;&#x435;&#x43B;&#x43E;&#x433; &#x435;&#x43A;&#x440;&#x430;&#x43D;&#x430;",
                  "ba-common-settingsmenu.fullscreen-video": "&#x423;&#x452;&#x438;&#x442;&#x435; &#x43D;&#x430; &#x446;&#x435;&#x43E; &#x435;&#x43A;&#x440;&#x430;&#x43D;",
                  "ba-videorecorder-chooser.multi-stream": "&#x41C;&#x443;&#x43B;&#x442;&#x438; &#x421;&#x442;&#x440;&#x435;&#x430;&#x43C;",
                  "ba-videorecorder-controlbar.pause-recorder": "&#x41F;&#x430;&#x443;&#x437;&#x438;&#x440;&#x430;&#x458; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x447;",
                  "ba-videorecorder-controlbar.resume-recorder": "&#x420;&#x435;&#x441;&#x443;&#x43C;&#x435; &#x420;&#x435;&#x446;&#x43E;&#x440;&#x434;&#x435;&#x440;",
                  "ba-videorecorder.missing-track": "&#x41D;&#x435;&#x434;&#x43E;&#x441;&#x442;&#x430;&#x458;&#x435; &#x43E;&#x431;&#x430;&#x432;&#x435;&#x437;&#x43D;&#x430; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x438;&#x43B;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x43D;&#x443;&#x43C;&#x435;&#x440;&#x430;",
                  "ba-videorecorder.device-already-in-use": "&#x411;&#x430;&#x440;&#x435;&#x43C; &#x458;&#x435;&#x434;&#x430;&#x43D; &#x43E;&#x434; &#x432;&#x430;&#x448;&#x438;&#x445; &#x443;&#x43B;&#x430;&#x437;&#x43D;&#x438;&#x445; &#x443;&#x440;&#x435;&#x452;&#x430;&#x458;&#x430; &#x441;&#x435; &#x432;&#x435;&#x45B; &#x43A;&#x43E;&#x440;&#x438;&#x441;&#x442;&#x438;",
                  "ba-videorecorder.browser-permission-denied": "&#x41F;&#x440;&#x435;&#x433;&#x43B;&#x435;&#x434;&#x430;&#x447; &#x458;&#x435; &#x43E;&#x434;&#x431;&#x438;&#x43E; &#x434;&#x43E;&#x437;&#x432;&#x43E;&#x43B;&#x443;, &#x434;&#x43E;&#x437;&#x432;&#x43E;&#x43B;&#x438;&#x442;&#x435; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F; &#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43D;&#x43E; &#x443;&#x447;&#x438;&#x442;&#x430;&#x432;&#x430;&#x45A;&#x435; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x435;",
                  "ba-audioplayer.all-settings": "&#x421;&#x432;&#x430; &#x43F;&#x43E;&#x434;&#x435;&#x448;&#x430;&#x432;&#x430;&#x45A;&#x430;",
                  "ba-videoplayer-controlbar.remaining-time": "&#x41F;&#x440;&#x435;&#x43E;&#x441;&#x442;&#x430;&#x43B;&#x43E; &#x432;&#x440;&#x435;&#x43C;&#x435;",
                  "ba-videoplayer-controlbar.select-frame": "&#x418;&#x437;&#x430;&#x431;&#x435;&#x440;&#x438;&#x442;&#x435;",
                  "ba-videoplayer-controlbar.trim-video": "&#x422;&#x440;&#x438;&#x43C;",
                  "ba-videoplayer-playbutton.trim": "&#x422;&#x440;&#x438;&#x43C;",
                  "ba-videoplayer-playbutton.skip": "&#x41F;&#x440;&#x435;&#x441;&#x43A;&#x43E;&#x447;&#x438;",
                  "ba-videorecorder-imagegallery.upload-covershot": "&#x423;&#x43F;&#x43B;&#x43E;&#x430;&#x434; &#x426;&#x43E;&#x432;&#x435;&#x440;",
                  "ba-videorecorder.pick-covershot-frame": "&#x418;&#x437;&#x430;&#x431;&#x435;&#x440;&#x438;&#x442;&#x435; &#x43E;&#x43A;&#x432;&#x438;&#x440; &#x43A;&#x43E;&#x458;&#x438; &#x45B;&#x435;&#x442;&#x435; &#x43A;&#x43E;&#x440;&#x438;&#x441;&#x442;&#x438;&#x442;&#x438; &#x43A;&#x430;&#x43E; &#x43D;&#x430;&#x441;&#x43B;&#x43E;&#x432;&#x43D;&#x443; &#x444;&#x43E;&#x442;&#x43E;&#x433;&#x440;&#x430;&#x444;&#x438;&#x458;&#x443;.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "&#x41E;&#x432;&#x430;&#x458; &#x443;&#x440;&#x435;&#x452;&#x430;&#x458; &#x43D;&#x435; &#x43F;&#x43E;&#x434;&#x440;&#x436;&#x430;&#x432;&#x430; &#x441;&#x43D;&#x438;&#x43C;&#x430;&#x447; &#x435;&#x43A;&#x440;&#x430;&#x43D;&#x430;",
                  "ba-videorecorder.trim-prompt": "&#x414;&#x430; &#x43B;&#x438; &#x436;&#x435;&#x43B;&#x438;&#x442;&#x435; &#x434;&#x430; &#x43E;&#x431;&#x440;&#x435;&#x436;&#x435;&#x442;&#x435; &#x432;&#x438;&#x434;&#x435;&#x43E;?",
                  "ba-videorecorder.trim-video": "&#x41F;&#x43E;&#x43C;&#x435;&#x440;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x447;&#x435;&#x442;&#x43D;&#x435; &#x438; &#x43A;&#x440;&#x430;&#x458;&#x45A;&#x435; &#x43C;&#x430;&#x440;&#x43A;&#x435;&#x440;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x438;&#x441;&#x435;&#x43A;&#x43B;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder.wait-for-trim": "&#x427;&#x435;&#x43A;&#x430; &#x441;&#x435; &#x43D;&#x430;&#x440;&#x435;&#x434;&#x431;&#x430; &#x437;&#x430; &#x442;&#x440;&#x438;&#x43C; ...",
                  "ba-videorecorder-controlbar.no-video-source": "&#x41D;&#x435;&#x434;&#x43E;&#x441;&#x442;&#x430;&#x458;&#x435; &#x434;&#x43E;&#x434;&#x430;&#x442;&#x43D;&#x438; &#x438;&#x437;&#x432;&#x43E;&#x440; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x443;&#x43B;&#x430;&#x437;&#x430;",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x414;&#x43E;&#x434;&#x430;&#x442;&#x43D;&#x438; &#x442;&#x43E;&#x43A; &#x458;&#x435; &#x432;&#x435;&#x45B; &#x438;&#x437;&#x430;&#x431;&#x440;&#x430;&#x43D;",
                  "ba-videorecorder.uploading-src-error": "&#x412;&#x438;&#x434;&#x435;&#x43E; &#x43D;&#x438;&#x458;&#x435; &#x43C;&#x43E;&#x433;&#x443;&#x45B;&#x435; &#x440;&#x435;&#x43F;&#x440;&#x43E;&#x434;&#x443;&#x43A;&#x43E;&#x432;&#x430;&#x442;&#x438;, &#x43E;&#x442;&#x43F;&#x440;&#x435;&#x43C;&#x430;&#x45A;&#x435; &#x458;&#x435; &#x458;&#x43E;&#x448; &#x443; &#x442;&#x43E;&#x43A;&#x443;",
                  "ba-audiorecorder-controlbar.pause-recorder": "&#x41F;&#x430;&#x443;&#x441;&#x435; &#x420;&#x435;&#x446;&#x43E;&#x440;&#x434;&#x435;&#x440;",
                  "ba-audiorecorder-controlbar.resume-recorder": "&#x421;&#x43D;&#x438;&#x43C;&#x430;&#x447; &#x436;&#x438;&#x432;&#x43E;&#x442;&#x43E;&#x43F;&#x438;&#x441;&#x430;"
                },
                "language:sv": {
                  "ba-videoplayer-playbutton.tooltip": "Klicka f&#xF6;r att spela upp video.",
                  "ba-videoplayer-playbutton.rerecord": "G&#xF6;ra om",
                  "ba-videoplayer-playbutton.submit-video": "bekr&#xE4;fta video",
                  "ba-videoplayer-loader.tooltip": "Laddar video ...",
                  "ba-videoplayer-controlbar.change-resolution": "&#xE4;ndra uppl&#xF6;sning",
                  "ba-videoplayer-controlbar.video-progress": "video framsteg",
                  "ba-videoplayer-controlbar.rerecord-video": "G&#xF6;r video?",
                  "ba-videoplayer-controlbar.submit-video": "bekr&#xE4;fta video",
                  "ba-videoplayer-controlbar.play-video": "Spela video",
                  "ba-videoplayer-controlbar.pause-video": "pause video",
                  "ba-videoplayer-controlbar.elapsed-time": "F&#xF6;rfluten tid",
                  "ba-videoplayer-controlbar.total-time": "Totala l&#xE4;ngden av video",
                  "ba-videoplayer-controlbar.fullscreen-video": "Ange fullscreen",
                  "ba-videoplayer-controlbar.volume-button": "inst&#xE4;llda volymen",
                  "ba-videoplayer-controlbar.volume-mute": "st&#xE4;nga av ljudet",
                  "ba-videoplayer-controlbar.volume-unmute": "s&#xE4;tta p&#xE5; ljudet",
                  "ba-videoplayer.video-error": "Ett fel har intr&#xE4;ffat. V&#xE4;nligen f&#xF6;rs&#xF6;k igen senare. Klicka f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-videorecorder-chooser.record-video": "Spela din video",
                  "ba-videorecorder-chooser.upload-video": "Ladda upp video",
                  "ba-videorecorder-controlbar.settings": "inst&#xE4;llningar",
                  "ba-videorecorder-controlbar.camerahealthy": "Belysning &#xE4;r bra",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Belysning &#xE4;r inte optimal",
                  "ba-videorecorder-controlbar.microphonehealthy": "Ljudet &#xE4;r bra",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Det g&#xE5;r inte att plocka upp n&#xE5;got ljud",
                  "ba-videorecorder-controlbar.record": "Spela in",
                  "ba-videorecorder-controlbar.record-tooltip": "Klicka h&#xE4;r f&#xF6;r att spela in.",
                  "ba-videorecorder-controlbar.rerecord": "G&#xF6;ra om",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Klicka h&#xE4;r f&#xF6;r att g&#xF6;ra om.",
                  "ba-videorecorder-controlbar.upload-covershot": "Ladda upp",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Klicka h&#xE4;r f&#xF6;r att ladda upp anpassade t&#xE4;cka skott",
                  "ba-videorecorder-controlbar.stop": "Sluta",
                  "ba-videorecorder-controlbar.stop-tooltip": "Klicka h&#xE4;r f&#xF6;r att stanna.",
                  "ba-videorecorder-controlbar.skip": "Hoppa",
                  "ba-videorecorder-controlbar.skip-tooltip": "Klicka h&#xE4;r f&#xF6;r att hoppa.",
                  "ba-videorecorder.recorder-error": "Ett fel har intr&#xE4;ffat. V&#xE4;nligen f&#xF6;rs&#xF6;k igen senare. Klicka f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-videorecorder.attach-error": "Vi kunde inte komma &#xE5;t kameragr&#xE4;nssnittet. Beroende p&#xE5; vilken enhet och webbl&#xE4;sare, kan du beh&#xF6;va installera Flash eller &#xF6;ppna sidan via SSL.",
                  "ba-videorecorder.access-forbidden": "&#xC5;tkomst till kameran var f&#xF6;rbjudet. Klicka f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-videorecorder.pick-covershot": "V&#xE4;lj en covershot.",
                  "ba-videorecorder.uploading": "uppladdning",
                  "ba-videorecorder.uploading-failed": "Uppladdning misslyckades - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-videorecorder.verifying": "verifiera",
                  "ba-videorecorder.verifying-failed": "Verifiera misslyckades - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-videorecorder.rerecord-confirm": "Vill du verkligen vill g&#xF6;ra om din video?",
                  "ba-videorecorder.video_file_too_large": "Videofilen &#xE4;r f&#xF6;r stor (%s) - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen med en mindre videofil.",
                  "ba-videorecorder.unsupported_video_type": "Ladda upp: %s - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Avsluta fullsk&#xE4;rmen",
                  "ba-videoplayer-share.share": "Dela video",
                  "ba-videorecorder-chooser.record-screen": "Inspelningssk&#xE4;rm",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Paus st&#xF6;ds inte",
                  "ba-videorecorder-chooser.record-audio": "Spela in ljud",
                  "ba-videorecorder-controlbar.stop-available-after": "Minsta inspelningstid &#xE4;r %d sekunder",
                  "ba-videorecorder-controlbar.cancel": "Annullera",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Klicka h&#xE4;r f&#xF6;r att avbryta.",
                  "ba-videorecorder.cancel-confirm": "Vill du verkligen avbryta din videouppladdning?",
                  "ba-videoplayer-adslot.elapsed-time": "F&#xF6;rfluten tid",
                  "ba-videoplayer-adslot.volume-button": "Ange volym",
                  "ba-videoplayer-adslot.volume-mute": "St&#xE4;ng ljudet",
                  "ba-videoplayer-adslot.volume-unmute": "Sl&#xE5; av ljudet",
                  "ba-videoplayer-adslot.ad-will-end-after": "Annonsen slutar efter %s",
                  "ba-videoplayer-adslot.can-skip-after": "Hoppa &#xF6;ver efter %d",
                  "ba-videoplayer-adslot.skip-ad": "Hoppa &#xF6;ver annonsen",
                  "ba-videorecorder.software-required": "V&#xE4;nligen klicka nedan f&#xF6;r att installera / aktivera f&#xF6;ljande krav f&#xF6;r att forts&#xE4;tta.",
                  "ba-videorecorder.software-waiting": "V&#xE4;ntar p&#xE5; att kraven ska installeras / aktiveras. Det kan h&#xE4;nda att du beh&#xF6;ver uppdatera sidan efter slutf&#xF6;randet.",
                  "ba-videoplayer-controlbar.close-tracks": "St&#xE4;ng CC",
                  "ba-videoplayer-controlbar.show-tracks": "Visa CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Ladda upp sp&#xE5;r textfiler",
                  "ba-videoplayer-tracks.select-text-track-language": "Textningsspr&#xE5;k",
                  "ba-videoplayer-tracks.info-select-locale-first": "V&#xE4;lj f&#xF6;rst platsen",
                  "ba-videoplayer-tracks.select-text-track-file": "Klicka f&#xF6;r att v&#xE4;lja fil",
                  "ba-videoplayer-tracks.back": "tillbaka",
                  "ba-videorecorder.framerate-warning": "Videorammen &#xE4;r mycket l&#xE5;ga. Vi rekommenderar att du st&#xE4;nger alla andra program och webbl&#xE4;sarflikar eller anv&#xE4;nder en snabbare dator.",
                  "ba-videorecorder.upload-error-duration": "L&#xE4;ngd p&#xE5; den uppladdade videon uppfyller inte kraven - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-videorecorder.resolution-constraint-error": "Filen du har valt matchar inte den &#xF6;nskade uppl&#xF6;sningen - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-videorecorder.orientation-portrait-required": "V&#xE4;nligen rotera enheten f&#xF6;r att spela in i st&#xE5;ende l&#xE4;ge.",
                  "ba-videorecorder.orientation-landscape-required": "V&#xE4;nligen rotera enheten f&#xF6;r att spela in i liggande l&#xE4;ge.",
                  "ba-imageviewer-controlbar.rerecord-image": "G&#xF6;ra om?",
                  "ba-imageviewer-controlbar.submit-image": "Bekr&#xE4;fta",
                  "ba-imageviewer-controlbar.fullscreen-image": "Ange fullsk&#xE4;rm",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Avsluta fullsk&#xE4;rmen",
                  "ba-imageviewer.image-error": "Ett fel har intr&#xE4;ffat. V&#xE4;nligen f&#xF6;rs&#xF6;k igen senare. Klicka f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-imagecapture-chooser.image-capture": "Capture Image",
                  "ba-imagecapture-chooser.upload-image": "Ladda upp bild",
                  "ba-imagecapture-controlbar.settings": "inst&#xE4;llningar",
                  "ba-imagecapture-controlbar.camerahealthy": "Belysning &#xE4;r bra",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Belysning &#xE4;r inte optimal",
                  "ba-imagecapture-controlbar.record": "F&#xE5;nga",
                  "ba-imagecapture-controlbar.record-tooltip": "Klicka h&#xE4;r f&#xF6;r att f&#xE5;nga.",
                  "ba-imagecapture-controlbar.rerecord": "G&#xF6;ra om",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Klicka h&#xE4;r f&#xF6;r att g&#xF6;ra om.",
                  "ba-imagecapture-controlbar.cancel": "Annullera",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Klicka h&#xE4;r f&#xF6;r att avbryta.",
                  "ba-audioplayer-controlbar.audio-progress": "Framsteg",
                  "ba-audioplayer-controlbar.rerecord-audio": "G&#xF6;ra om?",
                  "ba-audioplayer-controlbar.submit-audio": "Bekr&#xE4;fta",
                  "ba-audioplayer-controlbar.play-audio": "Spela",
                  "ba-audioplayer-controlbar.pause-audio": "Paus",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Paus st&#xF6;ds inte",
                  "ba-audioplayer-controlbar.elapsed-time": "F&#xF6;rfluten tid",
                  "ba-audioplayer-controlbar.total-time": "Total l&#xE4;ngd p&#xE5;",
                  "ba-audioplayer-controlbar.volume-button": "Ange volym",
                  "ba-audioplayer-controlbar.volume-mute": "St&#xE4;ng ljudet",
                  "ba-audioplayer-controlbar.volume-unmute": "Sl&#xE5; av ljudet",
                  "ba-audioplayer-loader.tooltip": "L&#xE4;ser in...",
                  "ba-audioplayer.audio-error": "Ett fel har intr&#xE4;ffat. V&#xE4;nligen f&#xF6;rs&#xF6;k igen senare. Klicka f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-audiorecorder-chooser.record-audio": "Spela in ljud",
                  "ba-audiorecorder-chooser.upload-audio": "Ladda upp ljud",
                  "ba-audiorecorder-controlbar.settings": "inst&#xE4;llningar",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Ljudet &#xE4;r bra",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Kan inte h&#xE4;mta n&#xE5;got ljud",
                  "ba-audiorecorder-controlbar.record": "Spela in",
                  "ba-audiorecorder-controlbar.record-tooltip": "Klicka h&#xE4;r f&#xF6;r att spela in.",
                  "ba-audiorecorder-controlbar.rerecord": "G&#xF6;ra om",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Klicka h&#xE4;r f&#xF6;r att g&#xF6;ra om.",
                  "ba-audiorecorder-controlbar.stop": "Sluta",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Klicka h&#xE4;r f&#xF6;r att sluta.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Minsta inspelningstid &#xE4;r %d sekunder",
                  "ba-audiorecorder-controlbar.cancel": "Annullera",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Klicka h&#xE4;r f&#xF6;r att avbryta.",
                  "ba-videoplayer-controlbar.player-speed": "Spelarens hastighet",
                  "ba-videoplayer-controlbar.settings": "inst&#xE4;llningar",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay-ikonen.",
                  "ba-videoplayer.all-settings": "Alla inst&#xE4;llningar",
                  "ba-videoplayer.player-speed": "Spelarens hastighet",
                  "ba-videoplayer.full-screen": "Fullsk&#xE4;rm",
                  "ba-videorecorder-controlbar.add-stream": "L&#xE4;gg till str&#xF6;m",
                  "ba-videorecorder.switch-camera": "Byt kamera",
                  "ba-videorecorder.prepare-covershot": "F&#xF6;rbereder t&#xE4;ckbilder",
                  "ba-videorecorder.prepare-thumbnails": "F&#xF6;rbereder s&#xF6;ker miniatyrbilder",
                  "ba-videorecorder.adding-new-stream": "L&#xE4;gger till ny str&#xF6;m",
                  "ba-imagecapture.recorder-error": "Ett fel har intr&#xE4;ffat. V&#xE4;nligen f&#xF6;rs&#xF6;k igen senare. Klicka f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-imagecapture.attach-error": "Vi kunde inte komma &#xE5;t mediegr&#xE4;nssnittet. Beroende p&#xE5; enhet och webbl&#xE4;sare kan du beh&#xF6;va installera Flash eller komma &#xE5;t sidan via SSL.",
                  "ba-imagecapture.software-required": "V&#xE4;nligen klicka nedan f&#xF6;r att installera / aktivera f&#xF6;ljande krav f&#xF6;r att forts&#xE4;tta.",
                  "ba-imagecapture.software-waiting": "V&#xE4;ntar p&#xE5; att kraven ska installeras / aktiveras. Det kan h&#xE4;nda att du beh&#xF6;ver uppdatera sidan efter slutf&#xF6;randet.",
                  "ba-imagecapture.access-forbidden": "Tillg&#xE5;ng till media var f&#xF6;rbjuden. Klicka f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-imagecapture.uploading": "uppladdning",
                  "ba-imagecapture.uploading-failed": "Uppladdning misslyckades - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-imagecapture.upload-error-duration": "L&#xE4;ngd p&#xE5; den uppladdade bilden uppfyller inte kraven - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-imagecapture.resolution-constraint-error": "Filen du har valt matchar inte den &#xF6;nskade uppl&#xF6;sningen - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-imagecapture.verifying": "verifiera",
                  "ba-imagecapture.verifying-failed": "Verifiering misslyckades - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-imagecapture.rerecord-confirm": "Vill du verkligen ta om bilden?",
                  "ba-imagecapture.image_file_too_large": "Din bildfil &#xE4;r f&#xF6;r stor (%s) - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen med en mindre bildfil.",
                  "ba-imagecapture.unsupported_image_type": "V&#xE4;nligen ladda upp: %s - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-imagecapture.orientation-portrait-required": "V&#xE4;nligen rotera enheten f&#xF6;r att spela in i st&#xE5;ende l&#xE4;ge.",
                  "ba-imagecapture.orientation-landscape-required": "V&#xE4;nligen rotera enheten f&#xF6;r att spela in i liggande l&#xE4;ge.",
                  "ba-audiorecorder.recorder-error": "Ett fel har intr&#xE4;ffat. V&#xE4;nligen f&#xF6;rs&#xF6;k igen senare. Klicka f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-audiorecorder.attach-error": "Vi kunde inte komma &#xE5;t mediegr&#xE4;nssnittet. Beroende p&#xE5; enhet och webbl&#xE4;sare kan du beh&#xF6;va installera Flash eller komma &#xE5;t sidan via SSL.",
                  "ba-audiorecorder.software-required": "V&#xE4;nligen klicka nedan f&#xF6;r att installera / aktivera f&#xF6;ljande krav f&#xF6;r att forts&#xE4;tta.",
                  "ba-audiorecorder.software-waiting": "V&#xE4;ntar p&#xE5; att kraven ska installeras / aktiveras. Det kan h&#xE4;nda att du beh&#xF6;ver uppdatera sidan efter slutf&#xF6;randet.",
                  "ba-audiorecorder.access-forbidden": "Tillg&#xE5;ng till media var f&#xF6;rbjuden. Klicka f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-audiorecorder.uploading": "uppladdning",
                  "ba-audiorecorder.uploading-failed": "Uppladdning misslyckades - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-audiorecorder.upload-error-duration": "L&#xE4;ngden p&#xE5; det uppladdade ljudet uppfyller inte kraven - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-audiorecorder.verifying": "verifiera",
                  "ba-audiorecorder.verifying-failed": "Verifiering misslyckades - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-audiorecorder.rerecord-confirm": "Vill du verkligen g&#xF6;ra om ditt ljud?",
                  "ba-audiorecorder.cancel-confirm": "Vill du verkligen avbryta din ljuduppladdning?",
                  "ba-audiorecorder.audio_file_too_large": "Din ljudfil &#xE4;r f&#xF6;r stor (%s) - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen med en mindre ljudfil.",
                  "ba-audiorecorder.unsupported_audio_type": "V&#xE4;nligen ladda upp: %s - klicka h&#xE4;r f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ba-common-settingsmenu.tooltip": "Klicka f&#xF6;r att spela.",
                  "ba-common-settingsmenu.setting-menu": "Alla inst&#xE4;llningar",
                  "ba-common-settingsmenu.source-quality": "K&#xE4;llkvalitet",
                  "ba-common-settingsmenu.player-speed": "Spelarens hastighet",
                  "ba-common-settingsmenu.set-menu-option": "St&#xE4;ll in alternativ",
                  "ba-common-settingsmenu.submit-video": "Bekr&#xE4;fta video",
                  "ba-common-settingsmenu.picture-in-picture": "Bild i bild",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Avsluta helsk&#xE4;rm",
                  "ba-common-settingsmenu.fullscreen-video": "G&#xE5; till helsk&#xE4;rm",
                  "ba-videorecorder-chooser.multi-stream": "Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "Pausa inspelaren",
                  "ba-videorecorder-controlbar.resume-recorder": "&#xC5;teruppta inspelare",
                  "ba-videorecorder.missing-track": "N&#xF6;dv&#xE4;ndigt ljud- eller videosp&#xE5;r saknas",
                  "ba-videorecorder.device-already-in-use": "Minst en av dina inmatningsenheter &#xE4;r redan i bruk",
                  "ba-videorecorder.browser-permission-denied": "Till&#xE5;telse nekad av webbl&#xE4;saren, v&#xE4;nligen ge &#xE5;tkomst och ladda om sidan",
                  "ba-audioplayer.all-settings": "Alla inst&#xE4;llningar",
                  "ba-videoplayer-controlbar.remaining-time": "&#xC5;terst&#xE5;ende tid",
                  "ba-videoplayer-controlbar.select-frame": "V&#xE4;lj",
                  "ba-videoplayer-controlbar.trim-video": "Trim",
                  "ba-videoplayer-playbutton.trim": "Trim",
                  "ba-videoplayer-playbutton.skip": "Hoppa",
                  "ba-videorecorder-imagegallery.upload-covershot": "Ladda upp omslaget",
                  "ba-videorecorder.pick-covershot-frame": "V&#xE4;lj en ram som ska anv&#xE4;ndas som omslagsbild.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Sk&#xE4;rminspelare st&#xF6;ds inte p&#xE5; den h&#xE4;r enheten",
                  "ba-videorecorder.trim-prompt": "Vill du klippa din video?",
                  "ba-videorecorder.trim-video": "Flytta start- och slutmark&#xF6;rerna f&#xF6;r att trimma din video",
                  "ba-videorecorder.wait-for-trim": "V&#xE4;ntar p&#xE5; trimkommando ...",
                  "ba-videorecorder-controlbar.no-video-source": "Saknar ytterligare videoing&#xE5;ngsk&#xE4;lla",
                  "ba-videorecorder-controlbar.stream-already-selected": "Ytterligare str&#xF6;m har redan valts",
                  "ba-videorecorder.uploading-src-error": "Det g&#xE5;r inte att spela upp video nu, uppladdning p&#xE5;g&#xE5;r fortfarande",
                  "ba-audiorecorder-controlbar.pause-recorder": "Pausa inspelare",
                  "ba-audiorecorder-controlbar.resume-recorder": "&#xC5;teruppta inspelaren"
                },
                "language:tl": {
                  "ba-videoplayer-playbutton.tooltip": "I-click upang i-play ang video.",
                  "ba-videoplayer-playbutton.rerecord": "Gawing muli",
                  "ba-videoplayer-playbutton.submit-video": "Kumpirmahin ang video",
                  "ba-videoplayer-loader.tooltip": "Nilo-load ang video ...",
                  "ba-videoplayer-controlbar.change-resolution": "Baguhin ang resolution",
                  "ba-videoplayer-controlbar.video-progress": "Pag-usad ng video",
                  "ba-videoplayer-controlbar.rerecord-video": "Gawing muli ang video?",
                  "ba-videoplayer-controlbar.submit-video": "Kumpirmahin ang video",
                  "ba-videoplayer-controlbar.play-video": "I-play ang video",
                  "ba-videoplayer-controlbar.pause-video": "I-pause ang video",
                  "ba-videoplayer-controlbar.elapsed-time": "Tiyak na oras",
                  "ba-videoplayer-controlbar.total-time": "Kabuuang haba ng video",
                  "ba-videoplayer-controlbar.fullscreen-video": "Pumasok sa fullscreen",
                  "ba-videoplayer-controlbar.volume-button": "Itakda ang lakas ng tunog",
                  "ba-videoplayer-controlbar.volume-mute": "I-mute ang tunog",
                  "ba-videoplayer-controlbar.volume-unmute": "I-unmute ang tunog",
                  "ba-videoplayer.video-error": "May naganap na error. Mangyaring subukan muli sa ibang pagkakataon. I-click upang subukang muli.",
                  "ba-videorecorder-chooser.record-video": "Kumuha ng video",
                  "ba-videorecorder-chooser.upload-video": "Mag-upload ng Video",
                  "ba-videorecorder-controlbar.settings": "Mga Setting",
                  "ba-videorecorder-controlbar.camerahealthy": "Ang pag-iilaw ay mabuti",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Ang pag-iilaw ay hindi pinakamainam",
                  "ba-videorecorder-controlbar.microphonehealthy": "Ang tunog ay mabuti",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "Walang nakukuhang anumang tunog",
                  "ba-videorecorder-controlbar.record": "Rekord",
                  "ba-videorecorder-controlbar.record-tooltip": "Mag-click dito upang i-record.",
                  "ba-videorecorder-controlbar.rerecord": "Gawing muli",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "Mag-click dito upang gawing muli.",
                  "ba-videorecorder-controlbar.upload-covershot": "Upload",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "Mag-click dito upang mag-upload ng angkop na cover shot",
                  "ba-videorecorder-controlbar.stop": "Itigil",
                  "ba-videorecorder-controlbar.stop-tooltip": "Mag-click dito upang itigil.",
                  "ba-videorecorder-controlbar.skip": "Laktawan",
                  "ba-videorecorder-controlbar.skip-tooltip": "Mag-click dito upang laktawan.",
                  "ba-videorecorder.recorder-error": "May naganap na error. Mangyaring subukan muli sa ibang pagkakataon. I-click upang subukang muli.",
                  "ba-videorecorder.attach-error": "Hindi namin mai-access ang interface ng camera. Depende sa device at browser, maaaring kailangan mong i-install ng Flash o ma-access ang pahina sa pamamagitan ng SSL.",
                  "ba-videorecorder.access-forbidden": "Ang access sa camera ay ipinagbabawal. I-click upang subukang muli.",
                  "ba-videorecorder.pick-covershot": "Pumili ng isang covershot.",
                  "ba-videorecorder.uploading": "Pag-upload",
                  "ba-videorecorder.uploading-failed": "Nabigo ang pag-upload - i-click dito upang subukang muli.",
                  "ba-videorecorder.verifying": "Bine-verify",
                  "ba-videorecorder.verifying-failed": "Ang pag-verify nabigo - i-click dito upang subukang muli.",
                  "ba-videorecorder.rerecord-confirm": "Nais mo ba talaga na gawing muli ang iyong video?",
                  "ba-videorecorder.video_file_too_large": "Ang iyong video file ay masyadong malaki (%s) - i-click dito upang subukang muli gamit ang mas maliit na file na video.",
                  "ba-videorecorder.unsupported_video_type": "Mangyaring i-upload: %s - i-click dito upang subukang muli.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Lumabas sa fullscreen",
                  "ba-videoplayer-share.share": "Ibahagi ang video",
                  "ba-videorecorder-chooser.record-screen": "Mag-record ng Screen",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Ang pause ang hindi suportado",
                  "ba-videorecorder-chooser.record-audio": "Mag-record ng Audio",
                  "ba-videorecorder-controlbar.stop-available-after": "Ang pinakamababa na oras ng pag-record ay %d segundo",
                  "ba-videorecorder-controlbar.cancel": "Kanselahin",
                  "ba-videorecorder-controlbar.cancel-tooltip": "Mag-click dito upang kanselahin.",
                  "ba-videorecorder.cancel-confirm": "Nais mo bang kanselahin ang iyong pag-upload ng video?",
                  "ba-videoplayer-adslot.elapsed-time": "Tiyak na oras",
                  "ba-videoplayer-adslot.volume-button": "Itakda ang lakas ng tunog",
                  "ba-videoplayer-adslot.volume-mute": "I-mute ang tunog",
                  "ba-videoplayer-adslot.volume-unmute": "I-unmute ang tunog",
                  "ba-videoplayer-adslot.ad-will-end-after": "Magwawakas ang ad matapos ang %s",
                  "ba-videoplayer-adslot.can-skip-after": "Laktawan pagkatapos %d",
                  "ba-videoplayer-adslot.skip-ad": "Laktawan ang ad",
                  "ba-videorecorder.software-required": "Mangyaring mag-click sa ibaba upang i-install / i-activate ang mga sumusunod na kinakailangan upang magpatuloy.",
                  "ba-videorecorder.software-waiting": "Naghihintay ng mga kinakailangan na mai-install / isinaaktibo. Maaaring kailanganin mong i-refresh ang pahina pagkatapos makumpleto.",
                  "ba-videoplayer-controlbar.close-tracks": "Isara ang CC",
                  "ba-videoplayer-controlbar.show-tracks": "Ipakita ang CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "Mag-upload ng mga track text file",
                  "ba-videoplayer-tracks.select-text-track-language": "Wika ng Subtitle",
                  "ba-videoplayer-tracks.info-select-locale-first": "Unang piliin ang lokal",
                  "ba-videoplayer-tracks.select-text-track-file": "I-click upang piliin ang file",
                  "ba-videoplayer-tracks.back": "Bumalik",
                  "ba-videorecorder.framerate-warning": "Napakababa ang rate ng video frame. Inirerekumenda namin ang pagsasara ng lahat ng iba pang mga programa at mga tab ng browser o upang gumamit ng mas mabilis na computer.",
                  "ba-videorecorder.upload-error-duration": "Ang haba ng na-upload na video ay hindi nakakatugon sa mga kinakailangan - mag-click dito upang subukang muli.",
                  "ba-videorecorder.resolution-constraint-error": "Ang file na napili mo ay hindi tumutugma sa kinakailangang resolution - mag-click dito upang subukang muli.",
                  "ba-videorecorder.orientation-portrait-required": "Mangyaring i-rotate ang iyong aparato upang i-record sa portrait mode.",
                  "ba-videorecorder.orientation-landscape-required": "Mangyaring i-rotate ang iyong aparato upang i-record sa landscape mode.",
                  "ba-imageviewer-controlbar.rerecord-image": "Gawing muli?",
                  "ba-imageviewer-controlbar.submit-image": "Kumpirmahin",
                  "ba-imageviewer-controlbar.fullscreen-image": "Ipasok ang fullscreen",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Lumabas sa fullscreen",
                  "ba-imageviewer.image-error": "May naganap na error. Mangyaring subukan muli sa ibang pagkakataon. I-click upang muling subukan.",
                  "ba-imagecapture-chooser.image-capture": "Makunan ang Imahe",
                  "ba-imagecapture-chooser.upload-image": "Mag-upload ng Larawan",
                  "ba-imagecapture-controlbar.settings": "Mga Setting",
                  "ba-imagecapture-controlbar.camerahealthy": "Ang pag-iilaw ay mabuti",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Ang pag-iilaw ay hindi sulit",
                  "ba-imagecapture-controlbar.record": "Kumuha",
                  "ba-imagecapture-controlbar.record-tooltip": "Mag-click dito upang makuha.",
                  "ba-imagecapture-controlbar.rerecord": "Gawing muli",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Mag-click dito upang gawing muli.",
                  "ba-imagecapture-controlbar.cancel": "Kanselahin",
                  "ba-imagecapture-controlbar.cancel-tooltip": "Mag-click dito upang kanselahin.",
                  "ba-audioplayer-controlbar.audio-progress": "Isinasagawa",
                  "ba-audioplayer-controlbar.rerecord-audio": "Gawing muli?",
                  "ba-audioplayer-controlbar.submit-audio": "Kumpirmahin",
                  "ba-audioplayer-controlbar.play-audio": "I-play",
                  "ba-audioplayer-controlbar.pause-audio": "I-pause",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Ang pause ay hindi suportado",
                  "ba-audioplayer-controlbar.elapsed-time": "Tiyak na oras",
                  "ba-audioplayer-controlbar.total-time": "Kabuuang haba ng",
                  "ba-audioplayer-controlbar.volume-button": "Itakda ang lakas ng tunog",
                  "ba-audioplayer-controlbar.volume-mute": "I-mute ang tunog",
                  "ba-audioplayer-controlbar.volume-unmute": "I-unmute ang tunog",
                  "ba-audioplayer-loader.tooltip": "Naglo-load ...",
                  "ba-audioplayer.audio-error": "May naganap na error. Mangyaring subukan muli sa ibang pagkakataon. I-click upang muling subukan.",
                  "ba-audiorecorder-chooser.record-audio": "Mag-record ng Audio",
                  "ba-audiorecorder-chooser.upload-audio": "Mag-upload ng Audio",
                  "ba-audiorecorder-controlbar.settings": "Mga Setting",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Ang tunog ay mabuti",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Walang makukuhag anumang tunog",
                  "ba-audiorecorder-controlbar.record": "Mag-record",
                  "ba-audiorecorder-controlbar.record-tooltip": "Mag-click dito upang mag-record.",
                  "ba-audiorecorder-controlbar.rerecord": "I-redo",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Mag-click dito upang gawing muli.",
                  "ba-audiorecorder-controlbar.stop": "Itigil",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Mag-click dito upang huminto.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Ang pinakamababa na oras ng pag-record ay %d segundo",
                  "ba-audiorecorder-controlbar.cancel": "Kanselahin",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "Mag-click dito upang kanselahin.",
                  "ba-videoplayer-controlbar.player-speed": "Bilis ng Video Player",
                  "ba-videoplayer-controlbar.settings": "Mga Settings",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Icon ng Airplay.",
                  "ba-videoplayer.all-settings": "Lahat ng mga settings",
                  "ba-videoplayer.player-speed": "Bilis ng Player",
                  "ba-videoplayer.full-screen": "Buong screen",
                  "ba-videorecorder-controlbar.add-stream": "Magdagdag ng Stream",
                  "ba-videorecorder.switch-camera": "Lumipat ng camera",
                  "ba-videorecorder.prepare-covershot": "Paghahanda ng mga cover shots",
                  "ba-videorecorder.prepare-thumbnails": "Paghahanda ng mga thumbnail",
                  "ba-videorecorder.adding-new-stream": "Pagdaragdag ng Bagong Stream",
                  "ba-imagecapture.recorder-error": "May naganap na error. Mangyaring subukan muli sa ibang pagkakataon. I-click upang muling subukan.",
                  "ba-imagecapture.attach-error": "Hindi namin ma-access ang media interface. Depende sa device at browser, maaaring kailangan mong i-install ang Flash o i-access ang pahina sa pamamagitan ng SSL.",
                  "ba-imagecapture.software-required": "Mangyaring mag-click sa ibaba upang i-install / i-activate ang mga sumusunod na kinakailangan upang magpatuloy.",
                  "ba-imagecapture.software-waiting": "Naghihintay para sa mga kinakailangan na mai-install / activate. Maaaring kailanganin mong i-refresh ang pahina pagkatapos makumpleto.",
                  "ba-imagecapture.access-forbidden": "Ipinagbabawal ang pag-access sa media. I-click upang muling subukan.",
                  "ba-imagecapture.uploading": "Pag-upload",
                  "ba-imagecapture.uploading-failed": "Nabigo ang pag-upload - mag-click dito upang subukang muli.",
                  "ba-imagecapture.upload-error-duration": "Ang haba ng na-upload na imahe ay hindi nakakatugon sa mga kinakailangan - mag-click dito upang subukang muli.",
                  "ba-imagecapture.resolution-constraint-error": "Ang file na napili mo ay hindi tumutugma sa kinakailangang resolution - mag-click dito upang subukang muli.",
                  "ba-imagecapture.verifying": "Pag-verify",
                  "ba-imagecapture.verifying-failed": "Nabigo ang pag-verify - mag-click dito upang subukang muli.",
                  "ba-imagecapture.rerecord-confirm": "Gusto mo ba talagang muling kunin ang iyong larawan?",
                  "ba-imagecapture.image_file_too_large": "Masyadong malaki ang file ng iyong larawan (%s) - mag-click dito upang subukang muli gamit ang isang mas maliit na file ng imahe.",
                  "ba-imagecapture.unsupported_image_type": "Mangyaring mag-upload: %s - mag-click dito upang subukang muli.",
                  "ba-imagecapture.orientation-portrait-required": "Mangyaring i-rotate ang iyong aparato upang i-record sa portrait mode.",
                  "ba-imagecapture.orientation-landscape-required": "Mangyaring i-rotate ang iyong aparato upang i-record sa landscape mode.",
                  "ba-audiorecorder.recorder-error": "May naganap na error. Mangyaring subukan muli sa ibang pagkakataon. I-click upang muling subukan.",
                  "ba-audiorecorder.attach-error": "Hindi namin ma-access ang media interface. Depende sa device at browser, maaaring kailangan mong i-install ang Flash o i-access ang pahina sa pamamagitan ng SSL.",
                  "ba-audiorecorder.software-required": "Mangyaring mag-click sa ibaba upang i-install / i-activate ang mga sumusunod na kinakailangan upang magpatuloy.",
                  "ba-audiorecorder.software-waiting": "Naghihintay para sa mga kinakailangan na mai-install / activate. Maaaring kailanganin mong i-refresh ang pahina pagkatapos makumpleto.",
                  "ba-audiorecorder.access-forbidden": "Ipinagbabawal ang pag-access sa media. I-click upang muling subukan.",
                  "ba-audiorecorder.uploading": "Pag-upload",
                  "ba-audiorecorder.uploading-failed": "Nabigo ang pag-upload - mag-click dito upang subukang muli.",
                  "ba-audiorecorder.upload-error-duration": "Ang haba ng na-upload na audio ay hindi nakakatugon sa mga kinakailangan - mag-click dito upang subukang muli.",
                  "ba-audiorecorder.verifying": "Pag-verify",
                  "ba-audiorecorder.verifying-failed": "Nabigo ang pag-verify - mag-click dito upang subukang muli.",
                  "ba-audiorecorder.rerecord-confirm": "Gusto mo bang gawing muli ang iyong audio?",
                  "ba-audiorecorder.cancel-confirm": "Nais mo bang kanselahin ang pag-upload ng iyong audio?",
                  "ba-audiorecorder.audio_file_too_large": "Ang iyong audio file ay masyadong malaki (%s) - mag-click dito upang subukang muli gamit ang isang mas maliit na audio file.",
                  "ba-audiorecorder.unsupported_audio_type": "Mangyaring mag-upload: %s - mag-click dito upang subukang muli.",
                  "ba-common-settingsmenu.tooltip": "Pindutin upang i-play.",
                  "ba-common-settingsmenu.setting-menu": "Mga Settings",
                  "ba-common-settingsmenu.source-quality": "Kalidad ng mapagkukunan",
                  "ba-common-settingsmenu.player-speed": "Bilis ng player",
                  "ba-common-settingsmenu.set-menu-option": "Magtakda ng Pagpipilian",
                  "ba-common-settingsmenu.submit-video": "I-confirm video",
                  "ba-common-settingsmenu.picture-in-picture": "Larawan sa larawan",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Umalis sa Fullscreen",
                  "ba-common-settingsmenu.fullscreen-video": "Pumasok sa fullscreen",
                  "ba-videorecorder-chooser.multi-stream": "Ang Multi Stream",
                  "ba-videorecorder-controlbar.pause-recorder": "I-pause and Recorder",
                  "ba-videorecorder-controlbar.resume-recorder": "I-resume Recorder",
                  "ba-videorecorder.missing-track": "Ang kinakailangan na audio or video tranck ay hindi makita",
                  "ba-videorecorder.device-already-in-use": "Hindi bababa sa isa sa iyong mga input device ang ginagamit na",
                  "ba-videorecorder.browser-permission-denied": "Ang pahintulot ay tinanggihan ng browser, mangyaring magbigay ng access at i-reload ang pahina",
                  "ba-audioplayer.all-settings": "Lahat ng mga setting",
                  "ba-videoplayer-controlbar.remaining-time": "Natitirang oras",
                  "ba-videoplayer-controlbar.select-frame": "Pumili",
                  "ba-videoplayer-controlbar.trim-video": "Putulin",
                  "ba-videoplayer-playbutton.trim": "Putulin",
                  "ba-videoplayer-playbutton.skip": "Laktawan",
                  "ba-videorecorder-imagegallery.upload-covershot": "I-upload ang Cover",
                  "ba-videorecorder.pick-covershot-frame": "Pumili ng isang frame na gagamitin bilang coverhot.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Ang screen recorder ay hindi suportado sa aparatong ito",
                  "ba-videorecorder.trim-prompt": "Nais mo bang i-trim ang iyong video?",
                  "ba-videorecorder.trim-video": "Ilipat ang mga panimulang at pagtatapos ng mga marker upang i-trim ang iyong video",
                  "ba-videorecorder.wait-for-trim": "Naghihintay para sa trim na utos ...",
                  "ba-videorecorder-controlbar.no-video-source": "Nawawalang karagdagang mapagkukunan ng pag-input ng video",
                  "ba-videorecorder-controlbar.stream-already-selected": "Napili na ang karagdagang stream",
                  "ba-videorecorder.uploading-src-error": "Hindi ma-play pabalik ang video ngayon, isinasagawa pa rin ang pag-upload",
                  "ba-audiorecorder-controlbar.pause-recorder": "I-pause ang Recorder",
                  "ba-audiorecorder-controlbar.resume-recorder": "Ipagpatuloy ang Recorder"
                },
                "language:tr": {
                  "ba-videoplayer-playbutton.tooltip": "video oynatmak i&#xE7;in t&#x131;klay&#x131;n&#x131;z.",
                  "ba-videoplayer-playbutton.rerecord": "yeniden yapmak",
                  "ba-videoplayer-playbutton.submit-video": "videoyu onayla",
                  "ba-videoplayer-loader.tooltip": "Video y&#xFC;kleniyor ...",
                  "ba-videoplayer-controlbar.change-resolution": "De&#x11F;i&#x15F;im &#xE7;&#xF6;z&#xFC;n&#xFC;rl&#xFC;&#x11F;&#xFC;",
                  "ba-videoplayer-controlbar.video-progress": "Video ilerleme",
                  "ba-videoplayer-controlbar.rerecord-video": "Videoyu Redo?",
                  "ba-videoplayer-controlbar.submit-video": "videoyu onayla",
                  "ba-videoplayer-controlbar.play-video": "Video oynatmak",
                  "ba-videoplayer-controlbar.pause-video": "Pause Video",
                  "ba-videoplayer-controlbar.elapsed-time": "Ge&#xE7;en zaman",
                  "ba-videoplayer-controlbar.total-time": "videonun toplam uzunlu&#x11F;u",
                  "ba-videoplayer-controlbar.fullscreen-video": "Tam ekran yap",
                  "ba-videoplayer-controlbar.volume-button": "Set hacmi",
                  "ba-videoplayer-controlbar.volume-mute": "sesi",
                  "ba-videoplayer-controlbar.volume-unmute": "sesi a&#xE7;",
                  "ba-videoplayer.video-error": "Bir hata, l&#xFC;tfen tekrar deneyiniz olu&#x15F;tu. Tekrar denemek i&#xE7;in t&#x131;klay&#x131;n.",
                  "ba-videorecorder-chooser.record-video": "Ki&#x15F;isel Video kay&#x131;t",
                  "ba-videorecorder-chooser.upload-video": "video",
                  "ba-videorecorder-controlbar.settings": "Ayarlar",
                  "ba-videorecorder-controlbar.camerahealthy": "Ayd&#x131;nlatma iyidir",
                  "ba-videorecorder-controlbar.cameraunhealthy": "Ayd&#x131;nlatma optimum de&#x11F;il",
                  "ba-videorecorder-controlbar.microphonehealthy": "Ses iyidir",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "herhangi bir ses pick up olamaz",
                  "ba-videorecorder-controlbar.record": "Kay&#x131;t",
                  "ba-videorecorder-controlbar.record-tooltip": "kaydetmek i&#xE7;in buraya t&#x131;klay&#x131;n.",
                  "ba-videorecorder-controlbar.rerecord": "yeniden yapmak",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "yinelemek i&#xE7;in buraya t&#x131;klay&#x131;n.",
                  "ba-videorecorder-controlbar.upload-covershot": "y&#xFC;kleme",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#xF6;zel kapak &#xE7;ekimi y&#xFC;klemek i&#xE7;in buraya t&#x131;klay&#x131;n",
                  "ba-videorecorder-controlbar.stop": "Dur",
                  "ba-videorecorder-controlbar.stop-tooltip": "durdurmak i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-videorecorder-controlbar.skip": "atlamak",
                  "ba-videorecorder-controlbar.skip-tooltip": "atlamak i&#xE7;in buraya t&#x131;klay&#x131;n.",
                  "ba-videorecorder.recorder-error": "Bir hata, l&#xFC;tfen tekrar deneyiniz olu&#x15F;tu. Tekrar denemek i&#xE7;in t&#x131;klay&#x131;n.",
                  "ba-videorecorder.attach-error": "Biz kamera aray&#xFC;z&#xFC; eri&#x15F;emedi. cihaz ve taray&#x131;c&#x131;ya ba&#x11F;l&#x131; olarak, Flash y&#xFC;klemek veya SSL ile sayfaya eri&#x15F;mek i&#xE7;in gerekebilir.",
                  "ba-videorecorder.access-forbidden": "Kameraya eri&#x15F;im yasakland&#x131;. Tekrar denemek i&#xE7;in t&#x131;klay&#x131;n.",
                  "ba-videorecorder.pick-covershot": "Bir covershot se&#xE7;in.",
                  "ba-videorecorder.uploading": "Y&#xFC;kleme",
                  "ba-videorecorder.uploading-failed": "Y&#xFC;kleme ba&#x15F;ar&#x131;s&#x131;z - yeniden denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-videorecorder.verifying": "Do&#x11F;rulama",
                  "ba-videorecorder.verifying-failed": "Ba&#x15F;ar&#x131;s&#x131;z kullan&#x131;ld&#x131;&#x11F;&#x131;n&#x131; do&#x11F;rulamak - yeniden denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-videorecorder.rerecord-confirm": "E&#x11F;er ger&#xE7;ekten video yinelemek istiyor musunuz?",
                  "ba-videorecorder.video_file_too_large": "Videonuz dosyas&#x131; &#xE7;ok b&#xFC;y&#xFC;k (%s) - k&#xFC;&#xE7;&#xFC;k bir video dosyas&#x131; ile tekrar denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-videorecorder.unsupported_video_type": "y&#xFC;kleyin: %s - yeniden denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "Tam ekrandan &#xE7;&#x131;k",
                  "ba-videoplayer-share.share": "Video payla&#x15F;",
                  "ba-videorecorder-chooser.record-screen": "Kay&#x131;t Ekran&#x131;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "Duraklat desteklenmiyor",
                  "ba-videorecorder-chooser.record-audio": "Ses kayd&#x131;",
                  "ba-videorecorder-controlbar.stop-available-after": "Minimum kay&#x131;t s&#xFC;resi %d saniye",
                  "ba-videorecorder-controlbar.cancel": "&#x130;ptal etmek",
                  "ba-videorecorder-controlbar.cancel-tooltip": "&#x130;ptal etmek i&#xE7;in buraya t&#x131;klay&#x131;n.",
                  "ba-videorecorder.cancel-confirm": "Video y&#xFC;klemenizi ger&#xE7;ekten iptal etmek istiyor musunuz?",
                  "ba-videoplayer-adslot.elapsed-time": "Ge&#xE7;en zaman",
                  "ba-videoplayer-adslot.volume-button": "Sesi ayarla",
                  "ba-videoplayer-adslot.volume-mute": "Sesi kapat",
                  "ba-videoplayer-adslot.volume-unmute": "Sesi a&#xE7;ma",
                  "ba-videoplayer-adslot.ad-will-end-after": "Reklam, %s sonra sona erecek",
                  "ba-videoplayer-adslot.can-skip-after": "%d sonra atla",
                  "ba-videoplayer-adslot.skip-ad": "Reklam&#x131; ge&#xE7;",
                  "ba-videorecorder.software-required": "Devam etmek i&#xE7;in a&#x15F;a&#x11F;&#x131;daki gereksinimleri y&#xFC;klemek / etkinle&#x15F;tirmek i&#xE7;in l&#xFC;tfen a&#x15F;a&#x11F;&#x131;ya t&#x131;klay&#x131;n.",
                  "ba-videorecorder.software-waiting": "Gereksinimlerin kurulmas&#x131; / etkinle&#x15F;tirilmesi i&#xE7;in bekleniyor. Tamamland&#x131;ktan sonra sayfay&#x131; yenilemeniz gerekebilir.",
                  "ba-videoplayer-controlbar.close-tracks": "CC&#x27;yi kapat",
                  "ba-videoplayer-controlbar.show-tracks": "CC g&#xF6;ster",
                  "ba-videoplayer-tracks.upload-text-tracks": "Par&#xE7;a metni dosyalar&#x131;n&#x131; y&#xFC;kle",
                  "ba-videoplayer-tracks.select-text-track-language": "Altyaz&#x131; Dili",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x130;lk yerel se&#xE7;",
                  "ba-videoplayer-tracks.select-text-track-file": "Dosya se&#xE7;mek i&#xE7;in t&#x131;klay&#x131;n",
                  "ba-videoplayer-tracks.back": "geri",
                  "ba-videorecorder.framerate-warning": "Video kare h&#x131;z&#x131; &#xE7;ok d&#xFC;&#x15F;&#xFC;k. Di&#x11F;er t&#xFC;m programlar&#x131; ve taray&#x131;c&#x131; sekmelerini kapatman&#x131;z&#x131; veya daha h&#x131;zl&#x131; bir bilgisayar kullanman&#x131;z&#x131; &#xF6;neririz.",
                  "ba-videorecorder.upload-error-duration": "Y&#xFC;klenen videonun uzunlu&#x11F;u gereksinimleri kar&#x15F;&#x131;lam&#x131;yor. Yeniden denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-videorecorder.resolution-constraint-error": "Se&#xE7;ti&#x11F;iniz dosya gerekli &#xE7;&#xF6;z&#xFC;n&#xFC;rl&#xFC;kle e&#x15F;le&#x15F;miyor. Yeniden denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-videorecorder.orientation-portrait-required": "L&#xFC;tfen portre modunda kay&#x131;t yapmak i&#xE7;in cihaz&#x131;n&#x131;z&#x131; d&#xF6;nd&#xFC;r&#xFC;n.",
                  "ba-videorecorder.orientation-landscape-required": "L&#xFC;tfen yatay modda kay&#x131;t yapmak i&#xE7;in cihaz&#x131;n&#x131;z&#x131; d&#xF6;nd&#xFC;r&#xFC;n.",
                  "ba-imageviewer-controlbar.rerecord-image": "Yeniden yap?",
                  "ba-imageviewer-controlbar.submit-image": "Onaylamak",
                  "ba-imageviewer-controlbar.fullscreen-image": "Tam ekran yap",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "Tam ekrandan &#xE7;&#x131;k",
                  "ba-imageviewer.image-error": "Bir hata olu&#x15F;tu, daha sonra tekrar deneyin. Yeniden denemek i&#xE7;in t&#x131;klay&#x131;n.",
                  "ba-imagecapture-chooser.image-capture": "G&#xF6;r&#xFC;nt&#xFC;y&#xFC; yakala",
                  "ba-imagecapture-chooser.upload-image": "Foto&#x11F;raf y&#xFC;kleniyor",
                  "ba-imagecapture-controlbar.settings": "Ayarlar",
                  "ba-imagecapture-controlbar.camerahealthy": "Ayd&#x131;nlatma iyidir",
                  "ba-imagecapture-controlbar.cameraunhealthy": "Ayd&#x131;nlatma optimal de&#x11F;il",
                  "ba-imagecapture-controlbar.record": "Ele ge&#xE7;irmek",
                  "ba-imagecapture-controlbar.record-tooltip": "Yakalamak i&#xE7;in buraya t&#x131;klay&#x131;n.",
                  "ba-imagecapture-controlbar.rerecord": "yeniden yapmak",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "Yeniden yapmak i&#xE7;in buraya t&#x131;klay&#x131;n.",
                  "ba-imagecapture-controlbar.cancel": "&#x130;ptal etmek",
                  "ba-imagecapture-controlbar.cancel-tooltip": "&#x130;ptal etmek i&#xE7;in buraya t&#x131;klay&#x131;n.",
                  "ba-audioplayer-controlbar.audio-progress": "&#x130;lerleme",
                  "ba-audioplayer-controlbar.rerecord-audio": "Yeniden yap?",
                  "ba-audioplayer-controlbar.submit-audio": "Onaylamak",
                  "ba-audioplayer-controlbar.play-audio": "Oyun",
                  "ba-audioplayer-controlbar.pause-audio": "Duraklat",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "Duraklat desteklenmiyor",
                  "ba-audioplayer-controlbar.elapsed-time": "Ge&#xE7;en zaman",
                  "ba-audioplayer-controlbar.total-time": "Toplam uzunlu&#x11F;u",
                  "ba-audioplayer-controlbar.volume-button": "Sesi ayarla",
                  "ba-audioplayer-controlbar.volume-mute": "Sesi kapat",
                  "ba-audioplayer-controlbar.volume-unmute": "Sesi a&#xE7; ses",
                  "ba-audioplayer-loader.tooltip": "Y&#xFC;kleniyor...",
                  "ba-audioplayer.audio-error": "Bir hata olu&#x15F;tu, daha sonra tekrar deneyin. Yeniden denemek i&#xE7;in t&#x131;klay&#x131;n.",
                  "ba-audiorecorder-chooser.record-audio": "Ses kayd&#x131;",
                  "ba-audiorecorder-chooser.upload-audio": "Ses y&#xFC;kle",
                  "ba-audiorecorder-controlbar.settings": "Ayarlar",
                  "ba-audiorecorder-controlbar.microphonehealthy": "Ses iyi",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "Ses al&#x131;nam&#x131;yor",
                  "ba-audiorecorder-controlbar.record": "Kay&#x131;t",
                  "ba-audiorecorder-controlbar.record-tooltip": "Kay&#x131;t i&#xE7;in buraya t&#x131;klay&#x131;n.",
                  "ba-audiorecorder-controlbar.rerecord": "yeniden yapmak",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "Yeniden yapmak i&#xE7;in buraya t&#x131;klay&#x131;n.",
                  "ba-audiorecorder-controlbar.stop": "durdurmak",
                  "ba-audiorecorder-controlbar.stop-tooltip": "Durdurmak i&#xE7;in buraya t&#x131;klay&#x131;n.",
                  "ba-audiorecorder-controlbar.stop-available-after": "Minimum kay&#x131;t s&#xFC;resi %d saniyedir",
                  "ba-audiorecorder-controlbar.cancel": "&#x130;ptal etmek",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "&#x130;ptal etmek i&#xE7;in buraya t&#x131;klay&#x131;n.",
                  "ba-videoplayer-controlbar.player-speed": "Oyuncu h&#x131;z&#x131;",
                  "ba-videoplayer-controlbar.settings": "Ayarlar",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay simgesi.",
                  "ba-videoplayer.all-settings": "T&#xFC;m ayarlar",
                  "ba-videoplayer.player-speed": "Oyuncu h&#x131;z&#x131;",
                  "ba-videoplayer.full-screen": "Tam ekran",
                  "ba-videorecorder-controlbar.add-stream": "Ak&#x131;&#x15F; ekle",
                  "ba-videorecorder.switch-camera": "Kamera de&#x11F;i&#x15F;tir",
                  "ba-videorecorder.prepare-covershot": "Kapak haz&#x131;rl&#x131;&#x11F;&#x131;",
                  "ba-videorecorder.prepare-thumbnails": "K&#xFC;&#xE7;&#xFC;k resim aramaya haz&#x131;rlan&#x131;yor",
                  "ba-videorecorder.adding-new-stream": "Yeni Ak&#x131;&#x15F; Ekleme",
                  "ba-imagecapture.recorder-error": "Bir hata olu&#x15F;tu, daha sonra tekrar deneyin. Yeniden denemek i&#xE7;in t&#x131;klay&#x131;n.",
                  "ba-imagecapture.attach-error": "Medya aray&#xFC;z&#xFC;ne eri&#x15F;emedik. Ayg&#x131;ta ve taray&#x131;c&#x131;ya ba&#x11F;l&#x131; olarak, Flash y&#xFC;klemeniz veya sayfaya SSL ile eri&#x15F;meniz gerekebilir.",
                  "ba-imagecapture.software-required": "Devam etmek i&#xE7;in a&#x15F;a&#x11F;&#x131;daki gereksinimleri kurmak / etkinle&#x15F;tirmek i&#xE7;in l&#xFC;tfen a&#x15F;a&#x11F;&#x131;ya t&#x131;klay&#x131;n.",
                  "ba-imagecapture.software-waiting": "Y&#xFC;klenmesi / etkinle&#x15F;tirilmesi i&#xE7;in gerekenler bekleniyor. Tamamland&#x131;ktan sonra sayfay&#x131; yenilemeniz gerekebilir.",
                  "ba-imagecapture.access-forbidden": "Medyaya eri&#x15F;im yasakland&#x131;. Yeniden denemek i&#xE7;in t&#x131;klay&#x131;n.",
                  "ba-imagecapture.uploading": "Y&#xFC;kleme",
                  "ba-imagecapture.uploading-failed": "Y&#xFC;kleme ba&#x15F;ar&#x131;s&#x131;z - tekrar denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-imagecapture.upload-error-duration": "Y&#xFC;klenen resmin uzunlu&#x11F;u gereksinimleri kar&#x15F;&#x131;lam&#x131;yor - yeniden denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-imagecapture.resolution-constraint-error": "Se&#xE7;ti&#x11F;iniz dosya gerekli &#xE7;&#xF6;z&#xFC;n&#xFC;rl&#xFC;k ile e&#x15F;le&#x15F;miyor - tekrar denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-imagecapture.verifying": "Do&#x11F;rulama",
                  "ba-imagecapture.verifying-failed": "Do&#x11F;rulama ba&#x15F;ar&#x131;s&#x131;z oldu - yeniden denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-imagecapture.rerecord-confirm": "Ger&#xE7;ekten imaj&#x131;n&#x131; tekrar almak istiyor musun?",
                  "ba-imagecapture.image_file_too_large": "Resim dosyan&#x131;z &#xE7;ok b&#xFC;y&#xFC;k (%s) - daha k&#xFC;&#xE7;&#xFC;k bir resim dosyas&#x131;yla tekrar denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-imagecapture.unsupported_image_type": "L&#xFC;tfen y&#xFC;kleyin: %s - yeniden denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-imagecapture.orientation-portrait-required": "Portre modunda kay&#x131;t yapmak i&#xE7;in l&#xFC;tfen cihaz&#x131;n&#x131;z&#x131; d&#xF6;nd&#xFC;r&#xFC;n.",
                  "ba-imagecapture.orientation-landscape-required": "Manzara modunda kay&#x131;t yapmak i&#xE7;in l&#xFC;tfen cihaz&#x131;n&#x131;z&#x131; d&#xF6;nd&#xFC;r&#xFC;n.",
                  "ba-audiorecorder.recorder-error": "Bir hata olu&#x15F;tu, daha sonra tekrar deneyin. Yeniden denemek i&#xE7;in t&#x131;klay&#x131;n.",
                  "ba-audiorecorder.attach-error": "Medya aray&#xFC;z&#xFC;ne eri&#x15F;emedik. Ayg&#x131;ta ve taray&#x131;c&#x131;ya ba&#x11F;l&#x131; olarak, Flash y&#xFC;klemeniz veya sayfaya SSL ile eri&#x15F;meniz gerekebilir.",
                  "ba-audiorecorder.software-required": "Devam etmek i&#xE7;in a&#x15F;a&#x11F;&#x131;daki gereksinimleri kurmak / etkinle&#x15F;tirmek i&#xE7;in l&#xFC;tfen a&#x15F;a&#x11F;&#x131;ya t&#x131;klay&#x131;n.",
                  "ba-audiorecorder.software-waiting": "Y&#xFC;klenmesi / etkinle&#x15F;tirilmesi i&#xE7;in gerekenler bekleniyor. Tamamland&#x131;ktan sonra sayfay&#x131; yenilemeniz gerekebilir.",
                  "ba-audiorecorder.access-forbidden": "Medyaya eri&#x15F;im yasakland&#x131;. Yeniden denemek i&#xE7;in t&#x131;klay&#x131;n.",
                  "ba-audiorecorder.uploading": "Y&#xFC;kleme",
                  "ba-audiorecorder.uploading-failed": "Y&#xFC;kleme ba&#x15F;ar&#x131;s&#x131;z - tekrar denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-audiorecorder.upload-error-duration": "Y&#xFC;klenen sesin uzunlu&#x11F;u gereksinimleri kar&#x15F;&#x131;lam&#x131;yor - yeniden denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-audiorecorder.verifying": "Do&#x11F;rulama",
                  "ba-audiorecorder.verifying-failed": "Do&#x11F;rulama ba&#x15F;ar&#x131;s&#x131;z oldu - yeniden denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-audiorecorder.rerecord-confirm": "Ger&#xE7;ekten sesini yeniden yapmak istiyor musun?",
                  "ba-audiorecorder.cancel-confirm": "Ses y&#xFC;klemenizi ger&#xE7;ekten iptal etmek istiyor musunuz?",
                  "ba-audiorecorder.audio_file_too_large": "Ses dosyan&#x131;z &#xE7;ok b&#xFC;y&#xFC;k (%s) - daha k&#xFC;&#xE7;&#xFC;k bir ses dosyas&#x131;yla tekrar denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-audiorecorder.unsupported_audio_type": "L&#xFC;tfen y&#xFC;kleyin: %s - yeniden denemek i&#xE7;in buray&#x131; t&#x131;klay&#x131;n.",
                  "ba-common-settingsmenu.tooltip": "Oynatmak i&#xE7;in t&#x131;klay&#x131;n.",
                  "ba-common-settingsmenu.setting-menu": "T&#xFC;m ayarlar",
                  "ba-common-settingsmenu.source-quality": "Kaynak kalitesi",
                  "ba-common-settingsmenu.player-speed": "Oyuncu h&#x131;z&#x131;",
                  "ba-common-settingsmenu.set-menu-option": "Se&#xE7;ene&#x11F;i ayarla",
                  "ba-common-settingsmenu.submit-video": "Videoyu onaylay&#x131;n",
                  "ba-common-settingsmenu.picture-in-picture": "Foto&#x11F;raf i&#xE7;inde foto&#x11F;raf",
                  "ba-common-settingsmenu.exit-fullscreen-video": "Tam ekrandan &#xE7;&#x131;k",
                  "ba-common-settingsmenu.fullscreen-video": "Tam ekran yap",
                  "ba-videorecorder-chooser.multi-stream": "&#xC7;oklu Ak&#x131;&#x15F;",
                  "ba-videorecorder-controlbar.pause-recorder": "Kaydediciyi Duraklat",
                  "ba-videorecorder-controlbar.resume-recorder": "Kaydediciyi Devam Ettir",
                  "ba-videorecorder.missing-track": "Gerekli ses veya video par&#xE7;as&#x131; eksik",
                  "ba-videorecorder.device-already-in-use": "Giri&#x15F; cihazlar&#x131;n&#x131;zdan en az biri zaten kullan&#x131;mda",
                  "ba-videorecorder.browser-permission-denied": "&#x130;zin taray&#x131;c&#x131; taraf&#x131;ndan reddedildi, l&#xFC;tfen eri&#x15F;im izni verin ve sayfay&#x131; yeniden y&#xFC;kleyin",
                  "ba-audioplayer.all-settings": "T&#xFC;m ayarlar",
                  "ba-videoplayer-controlbar.remaining-time": "Kalan s&#xFC;re",
                  "ba-videoplayer-controlbar.select-frame": "Se&#xE7;",
                  "ba-videoplayer-controlbar.trim-video": "k&#x131;rp",
                  "ba-videoplayer-playbutton.trim": "k&#x131;rp",
                  "ba-videoplayer-playbutton.skip": "atla",
                  "ba-videorecorder-imagegallery.upload-covershot": "Kapak Y&#xFC;kle",
                  "ba-videorecorder.pick-covershot-frame": "Kapak resmi olarak kullanmak i&#xE7;in bir &#xE7;er&#xE7;eve se&#xE7;in.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "Bu cihazda ekran kaydedici desteklenmiyor",
                  "ba-videorecorder.trim-prompt": "Videonuzu k&#x131;rpmak istiyor musunuz?",
                  "ba-videorecorder.trim-video": "Videonuzu k&#x131;rpmak i&#xE7;in ba&#x15F;lang&#x131;&#xE7; ve biti&#x15F; i&#x15F;aret&#xE7;ilerini hareket ettirin",
                  "ba-videorecorder.wait-for-trim": "Trim komutu bekleniyor...",
                  "ba-videorecorder-controlbar.no-video-source": "Ek video giri&#x15F; kayna&#x11F;&#x131; eksik",
                  "ba-videorecorder-controlbar.stream-already-selected": "Ek ak&#x131;&#x15F; zaten se&#xE7;ildi",
                  "ba-videorecorder.uploading-src-error": "Video &#x15F;u anda oynat&#x131;lam&#x131;yor, y&#xFC;kleme i&#x15F;lemi devam ediyor",
                  "ba-audiorecorder-controlbar.pause-recorder": "Kaydediciyi Duraklat",
                  "ba-audiorecorder-controlbar.resume-recorder": "Kaydediciyi S&#xFC;rd&#xFC;r"
                },
                "language:uk": {
                  "ba-videoplayer-playbutton.tooltip": "&#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x434;&#x43B;&#x44F; &#x432;&#x456;&#x434;&#x442;&#x432;&#x43E;&#x440;&#x435;&#x43D;&#x43D;&#x44F;.",
                  "ba-videoplayer-playbutton.rerecord": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438; &#x437;&#x430;&#x43F;&#x438;&#x441;",
                  "ba-videoplayer-playbutton.submit-video": "&#x41F;&#x456;&#x434;&#x442;&#x432;&#x435;&#x440;&#x434;&#x438;&#x442;&#x438; &#x432;&#x456;&#x434;&#x435;&#x43E;",
                  "ba-videoplayer-loader.tooltip": "&#x417;&#x430;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F;...",
                  "ba-videoplayer-controlbar.change-resolution": "&#x417;&#x43C;&#x456;&#x43D;&#x438;&#x442;&#x438; &#x440;&#x43E;&#x437;&#x434;&#x456;&#x43B;&#x44C;&#x43D;&#x443; &#x437;&#x434;&#x430;&#x442;&#x43D;&#x456;&#x441;&#x442;&#x44C;",
                  "ba-videoplayer-controlbar.video-progress": "&#x41F;&#x440;&#x43E;&#x433;&#x440;&#x435;&#x441;",
                  "ba-videoplayer-controlbar.rerecord-video": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;?",
                  "ba-videoplayer-controlbar.submit-video": "&#x41F;&#x456;&#x434;&#x442;&#x432;&#x435;&#x440;&#x434;&#x438;&#x442;&#x438;",
                  "ba-videoplayer-controlbar.play-video": "&#x412;&#x456;&#x434;&#x442;&#x432;&#x43E;&#x440;&#x438;&#x442;&#x438;",
                  "ba-videoplayer-controlbar.pause-video": "&#x41F;&#x440;&#x438;&#x437;&#x443;&#x43F;&#x438;&#x43D;&#x438;&#x442;&#x438;",
                  "ba-videoplayer-controlbar.elapsed-time": "&#x412;&#x438;&#x442;&#x440;&#x430;&#x447;&#x435;&#x43D;&#x438;&#x439; &#x447;&#x430;&#x441;",
                  "ba-videoplayer-controlbar.total-time": "&#x417;&#x430;&#x433;&#x430;&#x43B;&#x44C;&#x43D;&#x430; &#x442;&#x440;&#x438;&#x432;&#x430;&#x43B;&#x456;&#x441;&#x442;&#x44C;",
                  "ba-videoplayer-controlbar.fullscreen-video": "&#x423;&#x432;&#x456;&#x439;&#x442;&#x438; &#x434;&#x43E; &#x43F;&#x43E;&#x432;&#x43D;&#x43E;&#x435;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x43E;&#x433;&#x43E; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x443;",
                  "ba-videoplayer-controlbar.volume-button": "&#x412;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x438; &#x433;&#x443;&#x447;&#x43D;&#x456;&#x441;&#x442;&#x44C;",
                  "ba-videoplayer-controlbar.volume-mute": "&#x412;&#x438;&#x43C;&#x43A;&#x43D;&#x443;&#x442;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer-controlbar.volume-unmute": "&#x423;&#x432;&#x456;&#x43C;&#x43A;&#x43D;&#x443;&#x442;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer.video-error": "&#x412;&#x438;&#x43D;&#x438;&#x43A;&#x43B;&#x430; &#x43F;&#x43E;&#x43C;&#x438;&#x43B;&#x43A;&#x430;, &#x431;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x456;&#x442;&#x44C; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443; &#x43F;&#x456;&#x437;&#x43D;&#x456;&#x448;&#x435;. &#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-videorecorder-chooser.record-video": "&#x417;&#x430;&#x43F;&#x438;&#x441;&#x430;&#x442;&#x438; &#x432;&#x456;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-chooser.upload-video": "&#x412;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x438;&#x442;&#x438; &#x432;&#x456;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder-controlbar.settings": "&#x41D;&#x430;&#x43B;&#x430;&#x448;&#x442;&#x443;&#x432;&#x430;&#x43D;&#x43D;&#x44F;",
                  "ba-videorecorder-controlbar.camerahealthy": "&#x41E;&#x441;&#x432;&#x456;&#x442;&#x43B;&#x435;&#x43D;&#x43D;&#x44F; &#x445;&#x43E;&#x440;&#x43E;&#x448;&#x435;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "&#x41E;&#x441;&#x432;&#x456;&#x442;&#x43B;&#x435;&#x43D;&#x43D;&#x44F; &#x43D;&#x435; &#x454; &#x43E;&#x43F;&#x442;&#x438;&#x43C;&#x430;&#x43B;&#x44C;&#x43D;&#x438;&#x43C;",
                  "ba-videorecorder-controlbar.microphonehealthy": "&#x417;&#x432;&#x443;&#x43A; &#x445;&#x43E;&#x440;&#x43E;&#x448;&#x438;&#x439;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "&#x41D;&#x435; &#x432;&#x434;&#x430;&#x454;&#x442;&#x44C;&#x441;&#x44F; &#x440;&#x43E;&#x437;&#x43F;&#x456;&#x437;&#x43D;&#x430;&#x442;&#x438; &#x436;&#x43E;&#x434;&#x43D;&#x43E;&#x433;&#x43E; &#x437;&#x432;&#x443;&#x43A;&#x443;",
                  "ba-videorecorder-controlbar.record": "&#x417;&#x430;&#x43F;&#x438;&#x441;",
                  "ba-videorecorder-controlbar.record-tooltip": "&#x41A;&#x43B;&#x430;&#x446;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x430;&#x442;&#x438;.",
                  "ba-videorecorder-controlbar.rerecord": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "&#x41A;&#x43B;&#x430;&#x446;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-videorecorder-controlbar.upload-covershot": "&#x412;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x438;&#x442;&#x438; &#x43E;&#x431;&#x43A;&#x43B;&#x430;&#x434;&#x438;&#x43D;&#x43A;&#x443;",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#x41A;&#x43B;&#x430;&#x446;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x432;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x438;&#x442;&#x438; &#x432;&#x43B;&#x430;&#x441;&#x43D;&#x443; &#x43E;&#x431;&#x43A;&#x43B;&#x430;&#x434;&#x438;&#x43D;&#x43A;&#x443;",
                  "ba-videorecorder-controlbar.stop": "&#x417;&#x443;&#x43F;&#x438;&#x43D;&#x438;&#x442;&#x438;&#x441;&#x44F;",
                  "ba-videorecorder-controlbar.stop-tooltip": "&#x41A;&#x43B;&#x430;&#x446;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x437;&#x443;&#x43F;&#x438;&#x43D;&#x438;&#x442;&#x438;&#x441;&#x44F;.",
                  "ba-videorecorder-controlbar.skip": "&#x41F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x442;&#x438;&#x442;&#x438;",
                  "ba-videorecorder-controlbar.skip-tooltip": "&#x41A;&#x43B;&#x430;&#x446;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x43F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x442;&#x438;&#x442;&#x438;.",
                  "ba-videorecorder.recorder-error": "&#x412;&#x438;&#x43D;&#x438;&#x43A;&#x43B;&#x430; &#x43F;&#x43E;&#x43C;&#x438;&#x43B;&#x43A;&#x430;, &#x431;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x456;&#x442;&#x44C; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443; &#x43F;&#x456;&#x437;&#x43D;&#x456;&#x448;&#x435;. &#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-videorecorder.attach-error": "&#x41D;&#x435; &#x432;&#x434;&#x430;&#x43B;&#x43E;&#x441;&#x44F; &#x43E;&#x442;&#x440;&#x438;&#x43C;&#x430;&#x442;&#x438; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x443; &#x434;&#x43E; &#x43C;&#x443;&#x43B;&#x44C;&#x442;&#x438;&#x43C;&#x435;&#x434;&#x456;&#x439;&#x43D;&#x43E;&#x433;&#x43E; &#x456;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x439;&#x441;&#x443;. &#x417;&#x430;&#x43B;&#x435;&#x436;&#x43D;&#x43E; &#x432;&#x456;&#x434; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x440;&#x43E;&#x44E; &#x442;&#x430; &#x431;&#x440;&#x430;&#x443;&#x437;&#x435;&#x440;&#x430;, &#x432;&#x430;&#x43C;, &#x43C;&#x43E;&#x436;&#x43B;&#x438;&#x432;&#x43E;, &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x456;&#x434;&#x43D;&#x43E; &#x432;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x438; Flash &#x430;&#x431;&#x43E; &#x43E;&#x442;&#x440;&#x438;&#x43C;&#x430;&#x442;&#x438; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x434;&#x43E; &#x441;&#x442;&#x43E;&#x440;&#x456;&#x43D;&#x43A;&#x438; &#x447;&#x435;&#x440;&#x435;&#x437; SSL.",
                  "ba-videorecorder.access-forbidden": "&#x414;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x434;&#x43E; &#x43C;&#x443;&#x43B;&#x44C;&#x442;&#x438;&#x43C;&#x435;&#x434;&#x456;&#x430; &#x437;&#x430;&#x431;&#x43E;&#x440;&#x43E;&#x43D;&#x435;&#x43D;&#x438;&#x439;. &#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-videorecorder.pick-covershot": "&#x41E;&#x431;&#x435;&#x440;&#x456;&#x442;&#x44C; &#x43E;&#x431;&#x43A;&#x43B;&#x430;&#x434;&#x438;&#x43D;&#x43A;&#x443;.",
                  "ba-videorecorder.uploading": "&#x412;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F;",
                  "ba-videorecorder.uploading-failed": "&#x412;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x437;&#x430;&#x437;&#x43D;&#x430;&#x43B;&#x43E; &#x43D;&#x435;&#x432;&#x434;&#x430;&#x447;&#x456; - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442; &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-videorecorder.verifying": "&#x41F;&#x435;&#x440;&#x435;&#x432;&#x456;&#x440;&#x43A;&#x430;",
                  "ba-videorecorder.verifying-failed": "&#x41F;&#x435;&#x440;&#x435;&#x432;&#x456;&#x440;&#x43A;&#x430; &#x437;&#x430;&#x437;&#x43D;&#x430;&#x43B;&#x430; &#x43D;&#x435;&#x432;&#x434;&#x430;&#x447;&#x456; - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442; &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-videorecorder.rerecord-confirm": "&#x412;&#x438; &#x434;&#x456;&#x439;&#x441;&#x43D;&#x43E; &#x445;&#x43E;&#x447;&#x435;&#x442;&#x435; &#x43F;&#x435;&#x440;&#x435;&#x440;&#x43E;&#x431;&#x438;&#x442;&#x438; &#x441;&#x432;&#x43E;&#x454; &#x432;&#x456;&#x434;&#x435;&#x43E;?",
                  "ba-videorecorder.video_file_too_large": "&#x412;&#x430;&#x448; &#x432;&#x456;&#x434;&#x435;&#x43E;&#x444;&#x430;&#x439;&#x43B; &#x437;&#x430;&#x43D;&#x430;&#x434;&#x442;&#x43E; &#x432;&#x435;&#x43B;&#x438;&#x43A;&#x438;&#x439; (%s) - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x437;&#x43D;&#x43E;&#x432;&#x443; &#x437; &#x43C;&#x435;&#x43D;&#x448;&#x438;&#x43C; &#x432;&#x456;&#x434;&#x435;&#x43E;&#x444;&#x430;&#x439;&#x43B;&#x43E;&#x43C;.",
                  "ba-videorecorder.unsupported_video_type": "&#x411;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x432;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x442;&#x435;: %s - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442; &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "&#x412;&#x438;&#x439;&#x442;&#x438; &#x437; &#x43F;&#x43E;&#x432;&#x43D;&#x43E;&#x435;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x43E;&#x433;&#x43E; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x443;",
                  "ba-videoplayer-share.share": "&#x41F;&#x43E;&#x434;&#x456;&#x43B;&#x438;&#x442;&#x438;&#x441;&#x44C; &#x43C;&#x443;&#x43B;&#x44C;&#x442;&#x438;&#x43C;&#x435;&#x434;&#x456;&#x430;",
                  "ba-videorecorder-chooser.record-screen": "&#x417;&#x430;&#x43F;&#x438;&#x441; &#x435;&#x43A;&#x440;&#x430;&#x43D;&#x443;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "&#x41F;&#x430;&#x443;&#x437;&#x430; &#x43D;&#x435; &#x43F;&#x456;&#x434;&#x442;&#x440;&#x438;&#x43C;&#x443;&#x454;&#x442;&#x44C;&#x441;&#x44F;",
                  "ba-videorecorder-chooser.record-audio": "&#x417;&#x430;&#x43F;&#x438;&#x441; &#x430;&#x443;&#x434;&#x456;&#x43E;",
                  "ba-videorecorder-controlbar.stop-available-after": "&#x41C;&#x456;&#x43D;&#x456;&#x43C;&#x430;&#x43B;&#x44C;&#x43D;&#x438;&#x439; &#x447;&#x430;&#x441; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x443;: %d &#x441;&#x435;&#x43A;&#x443;&#x43D;&#x434;",
                  "ba-videorecorder-controlbar.cancel": "&#x421;&#x43A;&#x430;&#x441;&#x443;&#x432;&#x430;&#x442;&#x438;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "&#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442; &#x449;&#x43E;&#x431; &#x441;&#x43A;&#x430;&#x441;&#x443;&#x432;&#x430;&#x442;&#x438;.",
                  "ba-videorecorder.cancel-confirm": "&#x412;&#x438; &#x434;&#x456;&#x439;&#x441;&#x43D;&#x43E; &#x445;&#x43E;&#x447;&#x435;&#x442;&#x435; &#x441;&#x43A;&#x430;&#x441;&#x443;&#x432;&#x430;&#x442;&#x438; &#x432;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x432;&#x456;&#x434;&#x435;&#x43E;?",
                  "ba-videoplayer-adslot.elapsed-time": "&#x412;&#x438;&#x442;&#x440;&#x430;&#x447;&#x435;&#x43D;&#x438;&#x439; &#x447;&#x430;&#x441;",
                  "ba-videoplayer-adslot.volume-button": "&#x412;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x438; &#x433;&#x443;&#x447;&#x43D;&#x456;&#x441;&#x442;&#x44C;",
                  "ba-videoplayer-adslot.volume-mute": "&#x412;&#x438;&#x43C;&#x43A;&#x43D;&#x443;&#x442;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer-adslot.volume-unmute": "&#x423;&#x432;&#x456;&#x43C;&#x43A;&#x43D;&#x443;&#x442;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-videoplayer-adslot.ad-will-end-after": "&#x420;&#x435;&#x43A;&#x43B;&#x430;&#x43C;&#x430; &#x437;&#x430;&#x43A;&#x456;&#x43D;&#x447;&#x438;&#x442;&#x44C;&#x441;&#x44F; &#x447;&#x435;&#x440;&#x435;&#x437; %s",
                  "ba-videoplayer-adslot.can-skip-after": "&#x41F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x442;&#x438;&#x442;&#x438; &#x43F;&#x456;&#x441;&#x43B;&#x44F; %d",
                  "ba-videoplayer-adslot.skip-ad": "&#x41F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x442;&#x438;&#x442;&#x438; &#x440;&#x435;&#x43A;&#x43B;&#x430;&#x43C;&#x43D;&#x435; &#x43E;&#x433;&#x43E;&#x43B;&#x43E;&#x448;&#x435;&#x43D;&#x43D;&#x44F;",
                  "ba-videorecorder.software-required": "&#x411;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x43D;&#x438;&#x436;&#x447;&#x435;, &#x449;&#x43E;&#x431; &#x432;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x438; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x443;&#x432;&#x430;&#x442;&#x438; &#x43D;&#x430;&#x441;&#x442;&#x443;&#x43F;&#x43D;&#x456; &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x456;&#x434;&#x43D;&#x456; &#x437;&#x430;&#x441;&#x43E;&#x431;&#x438;, &#x449;&#x43E;&#x431; &#x43F;&#x440;&#x43E;&#x434;&#x43E;&#x432;&#x436;&#x438;&#x442;&#x438;.",
                  "ba-videorecorder.software-waiting": "&#x41E;&#x447;&#x456;&#x43A;&#x443;&#x432;&#x430;&#x43D;&#x43D;&#x44F; &#x432;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x43D;&#x44F; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x430;&#x446;&#x456;&#x457; &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x456;&#x434;&#x43D;&#x438;&#x445; &#x437;&#x430;&#x441;&#x43E;&#x431;&#x456;&#x432;. &#x41C;&#x43E;&#x436;&#x43B;&#x438;&#x432;&#x43E;, &#x432;&#x430;&#x43C; &#x434;&#x43E;&#x432;&#x435;&#x434;&#x435;&#x442;&#x44C;&#x441;&#x44F; &#x43F;&#x435;&#x440;&#x435;&#x437;&#x430;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x438;&#x442;&#x438; &#x441;&#x442;&#x43E;&#x440;&#x456;&#x43D;&#x43A;&#x443; &#x43F;&#x456;&#x441;&#x43B;&#x44F; &#x437;&#x430;&#x432;&#x435;&#x440;&#x448;&#x435;&#x43D;&#x43D;&#x44F;.",
                  "ba-videoplayer-controlbar.close-tracks": "&#x417;&#x430;&#x43A;&#x440;&#x438;&#x442;&#x438; CC",
                  "ba-videoplayer-controlbar.show-tracks": "&#x41F;&#x43E;&#x43A;&#x430;&#x437;&#x430;&#x442;&#x438; CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "&#x412;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x438;&#x442;&#x438; &#x442;&#x435;&#x43A;&#x441;&#x442;&#x43E;&#x432;&#x456; &#x444;&#x430;&#x439;&#x43B;&#x438; &#x434;&#x43E;&#x440;&#x456;&#x436;&#x43E;&#x43A;",
                  "ba-videoplayer-tracks.select-text-track-language": "&#x41C;&#x43E;&#x432;&#x430; &#x441;&#x443;&#x431;&#x442;&#x438;&#x442;&#x440;&#x456;&#x432;",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x421;&#x43F;&#x43E;&#x447;&#x430;&#x442;&#x43A;&#x443; &#x43E;&#x431;&#x435;&#x440;&#x456;&#x442;&#x44C; &#x43C;&#x43E;&#x432;&#x443;",
                  "ba-videoplayer-tracks.select-text-track-file": "&#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x434;&#x43B;&#x44F; &#x432;&#x438;&#x431;&#x43E;&#x440;&#x443; &#x444;&#x430;&#x439;&#x43B;&#x443;",
                  "ba-videoplayer-tracks.back": "&#x43D;&#x430;&#x437;&#x430;&#x434;",
                  "ba-videorecorder.framerate-warning": "&#x427;&#x430;&#x441;&#x442;&#x43E;&#x442;&#x430; &#x43A;&#x430;&#x434;&#x440;&#x456;&#x432; &#x432;&#x456;&#x434;&#x435;&#x43E; &#x454; &#x434;&#x443;&#x436;&#x435; &#x43D;&#x438;&#x437;&#x44C;&#x43A;&#x43E;&#x44E;. &#x41C;&#x438; &#x440;&#x435;&#x43A;&#x43E;&#x43C;&#x435;&#x43D;&#x434;&#x443;&#x454;&#x43C;&#x43E; &#x437;&#x430;&#x43A;&#x440;&#x438;&#x442;&#x438; &#x432;&#x441;&#x456; &#x456;&#x43D;&#x448;&#x456; &#x43F;&#x440;&#x43E;&#x433;&#x440;&#x430;&#x43C;&#x438; &#x442;&#x430; &#x432;&#x43A;&#x43B;&#x430;&#x434;&#x43A;&#x438; &#x431;&#x440;&#x430;&#x443;&#x437;&#x435;&#x440;&#x430; &#x430;&#x431;&#x43E; &#x432;&#x438;&#x43A;&#x43E;&#x440;&#x438;&#x441;&#x442;&#x43E;&#x432;&#x443;&#x432;&#x430;&#x442;&#x438; &#x43F;&#x43E;&#x442;&#x443;&#x436;&#x43D;&#x456;&#x448;&#x438;&#x439; &#x43A;&#x43E;&#x43C;&#x43F;&#x27;&#x44E;&#x442;&#x435;&#x440;.",
                  "ba-videorecorder.upload-error-duration": "&#x422;&#x440;&#x438;&#x432;&#x430;&#x43B;&#x456;&#x441;&#x442;&#x44C; &#x432;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43E;&#x433;&#x43E; &#x432;&#x456;&#x434;&#x435;&#x43E; &#x43D;&#x435; &#x432;&#x456;&#x434;&#x43F;&#x43E;&#x432;&#x456;&#x434;&#x430;&#x454; &#x432;&#x438;&#x43C;&#x43E;&#x433;&#x430;&#x43C; - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x449;&#x435; &#x440;&#x430;&#x437;.",
                  "ba-videorecorder.resolution-constraint-error": "&#x424;&#x430;&#x439;&#x43B;, &#x44F;&#x43A;&#x438;&#x439; &#x432;&#x438; &#x43E;&#x431;&#x440;&#x430;&#x43B;&#x438;, &#x43D;&#x435; &#x432;&#x456;&#x434;&#x43F;&#x43E;&#x432;&#x456;&#x434;&#x430;&#x454; &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x456;&#x434;&#x43D;&#x456;&#x439; &#x440;&#x43E;&#x437;&#x434;&#x456;&#x43B;&#x44C;&#x43D;&#x456;&#x439; &#x437;&#x434;&#x430;&#x442;&#x43D;&#x43E;&#x441;&#x442;&#x456; - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x449;&#x435; &#x440;&#x430;&#x437;.",
                  "ba-videorecorder.orientation-portrait-required": "&#x411;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43E;&#x431;&#x435;&#x440;&#x43D;&#x456;&#x442;&#x44C; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x440;&#x456;&#x439;, &#x449;&#x43E;&#x431; &#x440;&#x43E;&#x431;&#x438;&#x442;&#x438; &#x437;&#x430;&#x43F;&#x438;&#x441; &#x443; &#x43F;&#x43E;&#x440;&#x442;&#x440;&#x435;&#x442;&#x43D;&#x43E;&#x43C;&#x443; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x456;.",
                  "ba-videorecorder.orientation-landscape-required": "&#x411;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43E;&#x431;&#x435;&#x440;&#x43D;&#x456;&#x442;&#x44C; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x440;&#x456;&#x439;, &#x449;&#x43E;&#x431; &#x440;&#x43E;&#x431;&#x438;&#x442;&#x438; &#x437;&#x430;&#x43F;&#x438;&#x441; &#x443; &#x430;&#x43B;&#x44C;&#x431;&#x43E;&#x43C;&#x43D;&#x43E;&#x43C;&#x443; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x456;.",
                  "ba-imageviewer-controlbar.rerecord-image": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;?",
                  "ba-imageviewer-controlbar.submit-image": "&#x41F;&#x456;&#x434;&#x442;&#x432;&#x435;&#x440;&#x434;&#x438;&#x442;&#x438;",
                  "ba-imageviewer-controlbar.fullscreen-image": "&#x423;&#x432;&#x456;&#x439;&#x442;&#x438; &#x434;&#x43E; &#x43F;&#x43E;&#x432;&#x43D;&#x43E;&#x435;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x43E;&#x433;&#x43E; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x443;",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "&#x412;&#x438;&#x439;&#x442;&#x438; &#x437; &#x43F;&#x43E;&#x432;&#x43D;&#x43E;&#x435;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x43E;&#x433;&#x43E; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x443;",
                  "ba-imageviewer.image-error": "&#x412;&#x438;&#x43D;&#x438;&#x43A;&#x43B;&#x430; &#x43F;&#x43E;&#x43C;&#x438;&#x43B;&#x43A;&#x430;, &#x431;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x456;&#x442;&#x44C; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443; &#x43F;&#x456;&#x437;&#x43D;&#x456;&#x448;&#x435;. &#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-imagecapture-chooser.image-capture": "&#x417;&#x440;&#x43E;&#x431;&#x438;&#x442;&#x438; &#x437;&#x43D;&#x456;&#x43C;&#x43E;&#x43A;",
                  "ba-imagecapture-chooser.upload-image": "&#x412;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x438;&#x442;&#x438; &#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F;",
                  "ba-imagecapture-controlbar.settings": "&#x41D;&#x430;&#x43B;&#x430;&#x448;&#x442;&#x443;&#x432;&#x430;&#x43D;&#x43D;&#x44F;",
                  "ba-imagecapture-controlbar.camerahealthy": "&#x41E;&#x441;&#x432;&#x456;&#x442;&#x43B;&#x435;&#x43D;&#x43D;&#x44F; &#x445;&#x43E;&#x440;&#x43E;&#x448;&#x435;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "&#x41E;&#x441;&#x432;&#x456;&#x442;&#x43B;&#x435;&#x43D;&#x43D;&#x44F; &#x43D;&#x435; &#x454; &#x43E;&#x43F;&#x442;&#x438;&#x43C;&#x430;&#x43B;&#x44C;&#x43D;&#x438;&#x43C;",
                  "ba-imagecapture-controlbar.record": "&#x417;&#x430;&#x445;&#x43E;&#x43F;&#x438;&#x442;&#x438;",
                  "ba-imagecapture-controlbar.record-tooltip": "&#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x437;&#x430;&#x445;&#x43E;&#x43F;&#x438;&#x442;&#x438;.",
                  "ba-imagecapture-controlbar.rerecord": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "&#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-imagecapture-controlbar.cancel": "&#x421;&#x43A;&#x430;&#x441;&#x443;&#x432;&#x430;&#x442;&#x438;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "&#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43A;&#x430;&#x441;&#x443;&#x432;&#x430;&#x442;&#x438;.",
                  "ba-audioplayer-controlbar.audio-progress": "&#x41F;&#x440;&#x43E;&#x433;&#x440;&#x435;&#x441;",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;?",
                  "ba-audioplayer-controlbar.submit-audio": "&#x41F;&#x456;&#x434;&#x442;&#x432;&#x435;&#x440;&#x434;&#x438;&#x442;&#x438;",
                  "ba-audioplayer-controlbar.play-audio": "&#x412;&#x456;&#x434;&#x442;&#x432;&#x43E;&#x440;&#x438;&#x442;&#x438;",
                  "ba-audioplayer-controlbar.pause-audio": "&#x41F;&#x440;&#x438;&#x437;&#x443;&#x43F;&#x438;&#x43D;&#x438;&#x442;&#x438;",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "&#x41F;&#x430;&#x443;&#x437;&#x430; &#x43D;&#x435; &#x43F;&#x456;&#x434;&#x442;&#x440;&#x438;&#x43C;&#x443;&#x454;&#x442;&#x44C;&#x441;&#x44F;",
                  "ba-audioplayer-controlbar.elapsed-time": "&#x412;&#x438;&#x442;&#x440;&#x430;&#x447;&#x435;&#x43D;&#x438;&#x439; &#x447;&#x430;&#x441;",
                  "ba-audioplayer-controlbar.total-time": "&#x417;&#x430;&#x433;&#x430;&#x43B;&#x44C;&#x43D;&#x430; &#x442;&#x440;&#x438;&#x432;&#x430;&#x43B;&#x456;&#x441;&#x442;&#x44C;",
                  "ba-audioplayer-controlbar.volume-button": "&#x412;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x438; &#x433;&#x443;&#x447;&#x43D;&#x456;&#x441;&#x442;&#x44C;",
                  "ba-audioplayer-controlbar.volume-mute": "&#x412;&#x438;&#x43C;&#x43A;&#x43D;&#x443;&#x442;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audioplayer-controlbar.volume-unmute": "&#x423;&#x432;&#x456;&#x43C;&#x43A;&#x43D;&#x443;&#x442;&#x438; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audioplayer-loader.tooltip": "&#x417;&#x430;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F;...",
                  "ba-audioplayer.audio-error": "&#x412;&#x438;&#x43D;&#x438;&#x43A;&#x43B;&#x430; &#x43F;&#x43E;&#x43C;&#x438;&#x43B;&#x43A;&#x430;, &#x431;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x456;&#x442;&#x44C; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443; &#x43F;&#x456;&#x437;&#x43D;&#x456;&#x448;&#x435;. &#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-audiorecorder-chooser.record-audio": "&#x417;&#x430;&#x43F;&#x438;&#x441; &#x430;&#x443;&#x434;&#x456;&#x43E;",
                  "ba-audiorecorder-chooser.upload-audio": "&#x412;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x430;&#x443;&#x434;&#x456;&#x43E;",
                  "ba-audiorecorder-controlbar.settings": "&#x41D;&#x430;&#x43B;&#x430;&#x448;&#x442;&#x443;&#x432;&#x430;&#x43D;&#x43D;&#x44F;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "&#x417;&#x432;&#x443;&#x43A; &#x445;&#x43E;&#x440;&#x43E;&#x448;&#x438;&#x439;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "&#x41D;&#x435; &#x432;&#x434;&#x430;&#x454;&#x442;&#x44C;&#x441;&#x44F; &#x440;&#x43E;&#x437;&#x43F;&#x456;&#x437;&#x43D;&#x430;&#x442;&#x438; &#x436;&#x43E;&#x434;&#x435;&#x43D; &#x437;&#x432;&#x443;&#x43A;",
                  "ba-audiorecorder-controlbar.record": "&#x417;&#x430;&#x43F;&#x438;&#x441;",
                  "ba-audiorecorder-controlbar.record-tooltip": "&#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x443;&#x432;&#x430;&#x442;&#x438;.",
                  "ba-audiorecorder-controlbar.rerecord": "&#x41F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "&#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-audiorecorder-controlbar.stop": "&#x417;&#x443;&#x43F;&#x438;&#x43D;&#x438;&#x442;&#x438;",
                  "ba-audiorecorder-controlbar.stop-tooltip": "&#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x437;&#x443;&#x43F;&#x438;&#x43D;&#x438;&#x442;&#x438;.",
                  "ba-audiorecorder-controlbar.stop-available-after": "&#x41C;&#x456;&#x43D;&#x456;&#x43C;&#x430;&#x43B;&#x44C;&#x43D;&#x438;&#x439; &#x447;&#x430;&#x441; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x443; &#x441;&#x43A;&#x43B;&#x430;&#x434;&#x430;&#x454; %d &#x441;&#x435;&#x43A;&#x443;&#x43D;&#x434;",
                  "ba-audiorecorder-controlbar.cancel": "&#x421;&#x43A;&#x430;&#x441;&#x443;&#x432;&#x430;&#x442;&#x438;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "&#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43A;&#x430;&#x441;&#x443;&#x432;&#x430;&#x442;&#x438;.",
                  "ba-videoplayer-controlbar.player-speed": "&#x428;&#x432;&#x438;&#x434;&#x43A;&#x456;&#x441;&#x442;&#x44C; &#x43F;&#x440;&#x43E;&#x433;&#x440;&#x430;&#x432;&#x430;&#x447;&#x430;",
                  "ba-videoplayer-controlbar.settings": "&#x41D;&#x430;&#x43B;&#x430;&#x448;&#x442;&#x443;&#x432;&#x430;&#x43D;&#x43D;&#x44F;",
                  "ba-videoplayer-controlbar.airplay": "Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "&#x406;&#x43A;&#x43E;&#x43D;&#x43A;&#x430; Airplay.",
                  "ba-videoplayer.all-settings": "&#x423;&#x441;&#x456; &#x43D;&#x430;&#x43B;&#x430;&#x448;&#x442;&#x443;&#x432;&#x430;&#x43D;&#x43D;&#x44F;",
                  "ba-videoplayer.player-speed": "&#x428;&#x432;&#x438;&#x434;&#x43A;&#x456;&#x441;&#x442;&#x44C; &#x43F;&#x440;&#x43E;&#x433;&#x440;&#x430;&#x432;&#x430;&#x447;&#x430;",
                  "ba-videoplayer.full-screen": "&#x41F;&#x43E;&#x432;&#x43D;&#x43E;&#x435;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x438;&#x439; &#x440;&#x435;&#x436;&#x438;&#x43C;",
                  "ba-videorecorder-controlbar.add-stream": "&#x414;&#x43E;&#x434;&#x430;&#x442;&#x438; &#x442;&#x440;&#x430;&#x43D;&#x441;&#x43B;&#x44F;&#x446;&#x456;&#x44E;",
                  "ba-videorecorder.switch-camera": "&#x41F;&#x435;&#x440;&#x435;&#x43C;&#x43A;&#x43D;&#x443;&#x442;&#x438; &#x43A;&#x430;&#x43C;&#x435;&#x440;&#x443;",
                  "ba-videorecorder.prepare-covershot": "&#x41F;&#x456;&#x434;&#x433;&#x43E;&#x442;&#x43E;&#x432;&#x43A;&#x430; &#x43E;&#x431;&#x43A;&#x43B;&#x430;&#x434;&#x438;&#x43D;&#x43E;&#x43A;",
                  "ba-videorecorder.prepare-thumbnails": "&#x41F;&#x456;&#x434;&#x433;&#x43E;&#x442;&#x43E;&#x432;&#x43A;&#x430; &#x43F;&#x43E;&#x448;&#x443;&#x43A;&#x443; &#x435;&#x441;&#x43A;&#x456;&#x437;&#x456;&#x432;",
                  "ba-videorecorder.adding-new-stream": "&#x414;&#x43E;&#x434;&#x430;&#x432;&#x430;&#x43D;&#x43D;&#x44F; &#x43D;&#x43E;&#x432;&#x43E;&#x457; &#x442;&#x440;&#x430;&#x43D;&#x441;&#x43B;&#x44F;&#x446;&#x456;&#x457;",
                  "ba-imagecapture.recorder-error": "&#x412;&#x438;&#x43D;&#x438;&#x43A;&#x43B;&#x430; &#x43F;&#x43E;&#x43C;&#x438;&#x43B;&#x43A;&#x430;, &#x431;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x456;&#x442;&#x44C; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443; &#x43F;&#x456;&#x437;&#x43D;&#x456;&#x448;&#x435;. &#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-imagecapture.attach-error": "&#x41D;&#x435; &#x432;&#x434;&#x430;&#x43B;&#x43E;&#x441;&#x44F; &#x43E;&#x442;&#x440;&#x438;&#x43C;&#x430;&#x442;&#x438; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x443; &#x434;&#x43E; &#x43C;&#x443;&#x43B;&#x44C;&#x442;&#x438;&#x43C;&#x435;&#x434;&#x456;&#x439;&#x43D;&#x43E;&#x433;&#x43E; &#x456;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x439;&#x441;&#x443;. &#x417;&#x430;&#x43B;&#x435;&#x436;&#x43D;&#x43E; &#x432;&#x456;&#x434; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x440;&#x43E;&#x44E; &#x442;&#x430; &#x431;&#x440;&#x430;&#x443;&#x437;&#x435;&#x440;&#x430;, &#x432;&#x430;&#x43C;, &#x43C;&#x43E;&#x436;&#x43B;&#x438;&#x432;&#x43E;, &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x456;&#x434;&#x43D;&#x43E; &#x432;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x438; Flash &#x430;&#x431;&#x43E; &#x43E;&#x442;&#x440;&#x438;&#x43C;&#x430;&#x442;&#x438; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x434;&#x43E; &#x441;&#x442;&#x43E;&#x440;&#x456;&#x43D;&#x43A;&#x438; &#x447;&#x435;&#x440;&#x435;&#x437; SSL.",
                  "ba-imagecapture.software-required": "&#x411;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x43D;&#x438;&#x436;&#x447;&#x435;, &#x449;&#x43E;&#x431; &#x432;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x438; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x443;&#x432;&#x430;&#x442;&#x438; &#x43D;&#x430;&#x441;&#x442;&#x443;&#x43F;&#x43D;&#x456; &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x456;&#x434;&#x43D;&#x456; &#x437;&#x430;&#x441;&#x43E;&#x431;&#x438;, &#x449;&#x43E;&#x431; &#x43F;&#x440;&#x43E;&#x434;&#x43E;&#x432;&#x436;&#x438;&#x442;&#x438;.",
                  "ba-imagecapture.software-waiting": "&#x41E;&#x447;&#x456;&#x43A;&#x443;&#x432;&#x430;&#x43D;&#x43D;&#x44F; &#x432;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x43D;&#x44F; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x430;&#x446;&#x456;&#x457; &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x456;&#x434;&#x43D;&#x438;&#x445; &#x437;&#x430;&#x441;&#x43E;&#x431;&#x456;&#x432;. &#x41C;&#x43E;&#x436;&#x43B;&#x438;&#x432;&#x43E;, &#x432;&#x430;&#x43C; &#x434;&#x43E;&#x432;&#x435;&#x434;&#x435;&#x442;&#x44C;&#x441;&#x44F; &#x43F;&#x435;&#x440;&#x435;&#x437;&#x430;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x438;&#x442;&#x438; &#x441;&#x442;&#x43E;&#x440;&#x456;&#x43D;&#x43A;&#x443; &#x43F;&#x456;&#x441;&#x43B;&#x44F; &#x437;&#x430;&#x432;&#x435;&#x440;&#x448;&#x435;&#x43D;&#x43D;&#x44F;.",
                  "ba-imagecapture.access-forbidden": "&#x423; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x456; &#x434;&#x43E; &#x43A;&#x430;&#x43C;&#x435;&#x440;&#x438; &#x431;&#x443;&#x43B;&#x43E; &#x432;&#x456;&#x434;&#x43C;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x43E;. &#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-imagecapture.uploading": "&#x412;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F;",
                  "ba-imagecapture.uploading-failed": "&#x412;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x437;&#x430;&#x437;&#x43D;&#x430;&#x43B;&#x43E; &#x43D;&#x435;&#x432;&#x434;&#x430;&#x447;&#x456; - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442; &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x437;&#x43D;&#x43E;&#x432;&#x443;.",
                  "ba-imagecapture.upload-error-duration": "&#x420;&#x43E;&#x437;&#x43C;&#x456;&#x440; &#x432;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x443;&#x432;&#x430;&#x43D;&#x43E;&#x433;&#x43E; &#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x43D;&#x435; &#x432;&#x456;&#x434;&#x43F;&#x43E;&#x432;&#x456;&#x434;&#x430;&#x454; &#x432;&#x438;&#x43C;&#x43E;&#x433;&#x430;&#x43C; - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x449;&#x435; &#x440;&#x430;&#x437;.",
                  "ba-imagecapture.resolution-constraint-error": "&#x424;&#x430;&#x439;&#x43B;, &#x44F;&#x43A;&#x438;&#x439; &#x432;&#x438; &#x43E;&#x431;&#x440;&#x430;&#x43B;&#x438;, &#x43D;&#x435; &#x432;&#x456;&#x434;&#x43F;&#x43E;&#x432;&#x456;&#x434;&#x430;&#x454; &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x456;&#x434;&#x43D;&#x43E;&#x43C;&#x443; &#x440;&#x43E;&#x437;&#x448;&#x438;&#x440;&#x435;&#x43D;&#x43D;&#x44E; - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x449;&#x435; &#x440;&#x430;&#x437;.",
                  "ba-imagecapture.verifying": "&#x412;&#x435;&#x440;&#x438;&#x444;&#x456;&#x43A;&#x430;&#x446;&#x456;&#x44F;",
                  "ba-imagecapture.verifying-failed": "&#x412;&#x435;&#x440;&#x438;&#x444;&#x456;&#x43A;&#x430;&#x446;&#x456;&#x44F; &#x437;&#x430;&#x437;&#x43D;&#x430;&#x43B;&#x430; &#x43D;&#x435;&#x432;&#x434;&#x430;&#x447;&#x456; - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x449;&#x435; &#x440;&#x430;&#x437;.",
                  "ba-imagecapture.rerecord-confirm": "&#x412;&#x438; &#x434;&#x456;&#x439;&#x441;&#x43D;&#x43E; &#x445;&#x43E;&#x447;&#x435;&#x442;&#x435; &#x43F;&#x435;&#x440;&#x435;&#x437;&#x43D;&#x44F;&#x442;&#x438; &#x432;&#x430;&#x448;&#x435; &#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F;?",
                  "ba-imagecapture.image_file_too_large": "&#x412;&#x430;&#x448;&#x435; &#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x437;&#x430;&#x43D;&#x430;&#x434;&#x442;&#x43E; &#x432;&#x435;&#x43B;&#x438;&#x43A;&#x435; (%s) - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x449;&#x435; &#x440;&#x430;&#x437; &#x437; &#x43C;&#x435;&#x43D;&#x448;&#x438;&#x43C; &#x444;&#x430;&#x439;&#x43B;&#x43E;&#x43C; &#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F;.",
                  "ba-imagecapture.unsupported_image_type": "&#x411;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x432;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x442;&#x435;: %s - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x449;&#x435; &#x440;&#x430;&#x437;.",
                  "ba-imagecapture.orientation-portrait-required": "&#x411;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43E;&#x431;&#x435;&#x440;&#x43D;&#x456;&#x442;&#x44C; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x440;&#x456;&#x439;, &#x449;&#x43E;&#x431; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x443;&#x432;&#x430;&#x442;&#x438; &#x443; &#x43F;&#x43E;&#x440;&#x442;&#x440;&#x435;&#x442;&#x43D;&#x43E;&#x43C;&#x443; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x456;.",
                  "ba-imagecapture.orientation-landscape-required": "&#x411;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43E;&#x431;&#x435;&#x440;&#x43D;&#x456;&#x442;&#x44C; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x440;&#x456;&#x439;, &#x449;&#x43E;&#x431; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x443;&#x432;&#x430;&#x442;&#x438; &#x443; &#x430;&#x43B;&#x44C;&#x431;&#x43E;&#x43C;&#x43D;&#x43E;&#x43C;&#x443; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x456;.",
                  "ba-audiorecorder.recorder-error": "&#x412;&#x438;&#x43D;&#x438;&#x43A;&#x43B;&#x430; &#x43F;&#x43E;&#x43C;&#x438;&#x43B;&#x43A;&#x430;, &#x431;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x456;&#x442;&#x44C; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443; &#x43F;&#x456;&#x437;&#x43D;&#x456;&#x448;&#x435;. &#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-audiorecorder.attach-error": "&#x41D;&#x435; &#x432;&#x434;&#x430;&#x43B;&#x43E;&#x441;&#x44F; &#x43E;&#x442;&#x440;&#x438;&#x43C;&#x430;&#x442;&#x438; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x443; &#x434;&#x43E; &#x43C;&#x443;&#x43B;&#x44C;&#x442;&#x438;&#x43C;&#x435;&#x434;&#x456;&#x439;&#x43D;&#x43E;&#x433;&#x43E; &#x456;&#x43D;&#x442;&#x435;&#x440;&#x444;&#x435;&#x439;&#x441;&#x443;. &#x417;&#x430;&#x43B;&#x435;&#x436;&#x43D;&#x43E; &#x432;&#x456;&#x434; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x440;&#x43E;&#x44E; &#x442;&#x430; &#x431;&#x440;&#x430;&#x443;&#x437;&#x435;&#x440;&#x430;, &#x432;&#x430;&#x43C;, &#x43C;&#x43E;&#x436;&#x43B;&#x438;&#x432;&#x43E;, &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x456;&#x434;&#x43D;&#x43E; &#x432;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x438; Flash &#x430;&#x431;&#x43E; &#x43E;&#x442;&#x440;&#x438;&#x43C;&#x430;&#x442;&#x438; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x434;&#x43E; &#x441;&#x442;&#x43E;&#x440;&#x456;&#x43D;&#x43A;&#x438; &#x447;&#x435;&#x440;&#x435;&#x437; SSL.",
                  "ba-audiorecorder.software-required": "&#x411;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x43D;&#x438;&#x436;&#x447;&#x435;, &#x449;&#x43E;&#x431; &#x432;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x438; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x443;&#x432;&#x430;&#x442;&#x438; &#x43D;&#x430;&#x441;&#x442;&#x443;&#x43F;&#x43D;&#x456; &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x456;&#x434;&#x43D;&#x456; &#x437;&#x430;&#x441;&#x43E;&#x431;&#x438;, &#x449;&#x43E;&#x431; &#x43F;&#x440;&#x43E;&#x434;&#x43E;&#x432;&#x436;&#x438;&#x442;&#x438;.",
                  "ba-audiorecorder.software-waiting": "&#x41E;&#x447;&#x456;&#x43A;&#x443;&#x432;&#x430;&#x43D;&#x43D;&#x44F; &#x432;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x43D;&#x44F; / &#x430;&#x43A;&#x442;&#x438;&#x432;&#x430;&#x446;&#x456;&#x457; &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x456;&#x434;&#x43D;&#x438;&#x445; &#x437;&#x430;&#x441;&#x43E;&#x431;&#x456;&#x432;. &#x41C;&#x43E;&#x436;&#x43B;&#x438;&#x432;&#x43E;, &#x432;&#x430;&#x43C; &#x434;&#x43E;&#x432;&#x435;&#x434;&#x435;&#x442;&#x44C;&#x441;&#x44F; &#x43F;&#x435;&#x440;&#x435;&#x437;&#x430;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x438;&#x442;&#x438; &#x441;&#x442;&#x43E;&#x440;&#x456;&#x43D;&#x43A;&#x443; &#x43F;&#x456;&#x441;&#x43B;&#x44F; &#x437;&#x430;&#x432;&#x435;&#x440;&#x448;&#x435;&#x43D;&#x43D;&#x44F;.",
                  "ba-audiorecorder.access-forbidden": "&#x423; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x456; &#x434;&#x43E; &#x434;&#x438;&#x43A;&#x442;&#x43E;&#x444;&#x43E;&#x43D;&#x443; &#x431;&#x443;&#x43B;&#x43E; &#x432;&#x456;&#x434;&#x43C;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x43E;. &#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438;.",
                  "ba-audiorecorder.uploading": "&#x412;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F;",
                  "ba-audiorecorder.uploading-failed": "&#x412;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x437;&#x430;&#x437;&#x43D;&#x430;&#x43B;&#x43E; &#x43D;&#x435;&#x432;&#x434;&#x430;&#x447;&#x456; - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x449;&#x435; &#x440;&#x430;&#x437;.",
                  "ba-audiorecorder.upload-error-duration": "&#x422;&#x440;&#x438;&#x432;&#x430;&#x43B;&#x456;&#x441;&#x442;&#x44C; &#x432;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x443;&#x432;&#x430;&#x43D;&#x43E;&#x433;&#x43E; &#x430;&#x443;&#x434;&#x456;&#x43E; &#x43D;&#x435; &#x432;&#x456;&#x434;&#x43F;&#x43E;&#x432;&#x456;&#x434;&#x430;&#x454; &#x432;&#x438;&#x43C;&#x43E;&#x433;&#x430;&#x43C; - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x449;&#x435; &#x440;&#x430;&#x437;.",
                  "ba-audiorecorder.verifying": "&#x412;&#x435;&#x440;&#x438;&#x444;&#x456;&#x43A;&#x430;&#x446;&#x456;&#x44F;",
                  "ba-audiorecorder.verifying-failed": "&#x412;&#x435;&#x440;&#x438;&#x444;&#x456;&#x43A;&#x430;&#x446;&#x456;&#x44F; &#x437;&#x430;&#x437;&#x43D;&#x430;&#x43B;&#x430; &#x43D;&#x435;&#x432;&#x434;&#x430;&#x447;&#x456; - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x449;&#x435; &#x440;&#x430;&#x437;.",
                  "ba-audiorecorder.rerecord-confirm": "&#x412;&#x438; &#x441;&#x43F;&#x440;&#x430;&#x432;&#x434;&#x456; &#x431;&#x430;&#x436;&#x430;&#x454;&#x442;&#x435; &#x43F;&#x435;&#x440;&#x435;&#x437;&#x430;&#x43F;&#x438;&#x441;&#x430;&#x442;&#x438; &#x430;&#x443;&#x434;&#x456;&#x43E;?",
                  "ba-audiorecorder.cancel-confirm": "&#x412;&#x438; &#x441;&#x43F;&#x440;&#x430;&#x432;&#x434;&#x456; &#x431;&#x430;&#x436;&#x430;&#x454;&#x442;&#x435; &#x441;&#x43A;&#x430;&#x441;&#x443;&#x432;&#x430;&#x442;&#x438; &#x432;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x430;&#x443;&#x434;&#x456;&#x43E;?",
                  "ba-audiorecorder.audio_file_too_large": "&#x412;&#x430;&#x448; &#x430;&#x443;&#x434;&#x456;&#x43E;&#x444;&#x430;&#x439;&#x43B; &#x437;&#x430;&#x43D;&#x430;&#x434;&#x442;&#x43E; &#x432;&#x435;&#x43B;&#x438;&#x43A;&#x438;&#x439; (%s) - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x449;&#x435; &#x440;&#x430;&#x437; &#x437; &#x43C;&#x435;&#x43D;&#x448;&#x438;&#x43C; &#x430;&#x443;&#x434;&#x456;&#x43E;&#x444;&#x430;&#x439;&#x43B;&#x43E;&#x43C;.",
                  "ba-audiorecorder.unsupported_audio_type": "&#x411;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x432;&#x438;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x442;&#x435;: %s - &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x442;&#x443;&#x442;, &#x449;&#x43E;&#x431; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x432;&#x430;&#x442;&#x438; &#x449;&#x435; &#x440;&#x430;&#x437;.",
                  "ba-common-settingsmenu.tooltip": "&#x41D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x456;&#x442;&#x44C; &#x434;&#x43B;&#x44F; &#x432;&#x456;&#x434;&#x442;&#x432;&#x43E;&#x440;&#x435;&#x43D;&#x43D;&#x44F;.",
                  "ba-common-settingsmenu.setting-menu": "&#x412;&#x441;&#x456; &#x43D;&#x430;&#x43B;&#x430;&#x448;&#x442;&#x443;&#x432;&#x430;&#x43D;&#x43D;&#x44F;",
                  "ba-common-settingsmenu.source-quality": "&#x42F;&#x43A;&#x456;&#x441;&#x442;&#x44C; &#x434;&#x436;&#x435;&#x440;&#x435;&#x43B;&#x430;",
                  "ba-common-settingsmenu.player-speed": "&#x428;&#x432;&#x438;&#x434;&#x43A;&#x456;&#x441;&#x442;&#x44C; &#x432;&#x456;&#x434;&#x442;&#x432;&#x43E;&#x440;&#x435;&#x43D;&#x43D;&#x44F;",
                  "ba-common-settingsmenu.set-menu-option": "&#x412;&#x441;&#x442;&#x430;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x438; &#x43F;&#x430;&#x440;&#x430;&#x43C;&#x435;&#x442;&#x440;",
                  "ba-common-settingsmenu.submit-video": "&#x41F;&#x456;&#x434;&#x442;&#x432;&#x435;&#x440;&#x434;&#x438;&#x442;&#x438; &#x432;&#x456;&#x434;&#x435;&#x43E;",
                  "ba-common-settingsmenu.picture-in-picture": "&#x417;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x432; &#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x456;",
                  "ba-common-settingsmenu.exit-fullscreen-video": "&#x412;&#x438;&#x439;&#x442;&#x438; &#x437; &#x43F;&#x43E;&#x432;&#x43D;&#x43E;&#x435;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x43E;&#x433;&#x43E; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x443;",
                  "ba-common-settingsmenu.fullscreen-video": "&#x423;&#x432;&#x456;&#x439;&#x442;&#x438; &#x434;&#x43E; &#x43F;&#x43E;&#x432;&#x43D;&#x43E;&#x435;&#x43A;&#x440;&#x430;&#x43D;&#x43D;&#x43E;&#x433;&#x43E; &#x440;&#x435;&#x436;&#x438;&#x43C;&#x443;",
                  "ba-videorecorder-chooser.multi-stream": "&#x411;&#x430;&#x433;&#x430;&#x442;&#x43E;&#x43F;&#x43E;&#x442;&#x43E;&#x43A;&#x43E;&#x432;&#x438;&#x439;",
                  "ba-videorecorder-controlbar.pause-recorder": "&#x41F;&#x440;&#x438;&#x437;&#x443;&#x43F;&#x438;&#x43D;&#x438;&#x442;&#x438; &#x437;&#x430;&#x43F;&#x438;&#x441;",
                  "ba-videorecorder-controlbar.resume-recorder": "&#x41F;&#x440;&#x43E;&#x434;&#x43E;&#x432;&#x436;&#x438;&#x442;&#x438; &#x437;&#x430;&#x43F;&#x438;&#x441;",
                  "ba-videorecorder.missing-track": "&#x412;&#x456;&#x434;&#x441;&#x443;&#x442;&#x43D;&#x44F; &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x456;&#x434;&#x43D;&#x430; &#x437;&#x432;&#x443;&#x43A;&#x43E;&#x432;&#x430; &#x447;&#x438; &#x432;&#x456;&#x434;&#x435;&#x43E; &#x434;&#x43E;&#x440;&#x456;&#x436;&#x43A;&#x430;",
                  "ba-videorecorder.device-already-in-use": "&#x429;&#x43E;&#x43D;&#x430;&#x439;&#x43C;&#x435;&#x43D;&#x448;&#x435; &#x43E;&#x434;&#x438;&#x43D; &#x437; &#x432;&#x430;&#x448;&#x438;&#x445; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x440;&#x43E;&#x457;&#x432; &#x432;&#x432;&#x435;&#x434;&#x435;&#x43D;&#x43D;&#x44F; &#x432;&#x436;&#x435; &#x432;&#x438;&#x43A;&#x43E;&#x440;&#x438;&#x441;&#x442;&#x43E;&#x432;&#x443;&#x454;&#x442;&#x44C;&#x441;&#x44F;",
                  "ba-videorecorder.browser-permission-denied": "&#x423; &#x434;&#x43E;&#x437;&#x432;&#x43E;&#x43B;&#x456; &#x432;&#x456;&#x434;&#x43C;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x43E; &#x431;&#x440;&#x430;&#x443;&#x437;&#x435;&#x440;&#x43E;&#x43C;, &#x431;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43D;&#x430;&#x434;&#x430;&#x439;&#x442;&#x435; &#x434;&#x43E;&#x437;&#x432;&#x456;&#x43B; &#x442;&#x430; &#x43F;&#x435;&#x440;&#x435;&#x437;&#x430;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x442;&#x435; &#x441;&#x442;&#x43E;&#x440;&#x456;&#x43D;&#x43A;&#x443;",
                  "ba-audioplayer.all-settings": "&#x412;&#x441;&#x456; &#x43D;&#x430;&#x43B;&#x430;&#x448;&#x442;&#x443;&#x432;&#x430;&#x43D;&#x43D;&#x44F;",
                  "ba-videoplayer-controlbar.remaining-time": "&#x427;&#x430;&#x441;, &#x449;&#x43E; &#x437;&#x430;&#x43B;&#x438;&#x448;&#x438;&#x432;&#x441;&#x44F;",
                  "ba-videoplayer-controlbar.select-frame": "&#x412;&#x438;&#x431;&#x435;&#x440;&#x456;&#x442;&#x44C;",
                  "ba-videoplayer-controlbar.trim-video": "&#x41E;&#x431;&#x440;&#x456;&#x437;&#x430;&#x442;&#x438;",
                  "ba-videoplayer-playbutton.trim": "&#x41E;&#x431;&#x440;&#x456;&#x437;&#x430;&#x442;&#x438;",
                  "ba-videoplayer-playbutton.skip": "&#x41F;&#x440;&#x43E;&#x43F;&#x443;&#x441;&#x442;&#x438;&#x442;&#x438;",
                  "ba-videorecorder-imagegallery.upload-covershot": "&#x417;&#x430;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x438;&#x442;&#x438; &#x43E;&#x431;&#x43A;&#x43B;&#x430;&#x434;&#x438;&#x43D;&#x43A;&#x443;",
                  "ba-videorecorder.pick-covershot-frame": "&#x412;&#x438;&#x431;&#x435;&#x440;&#x456;&#x442;&#x44C; &#x43A;&#x430;&#x434;&#x440;, &#x44F;&#x43A;&#x438;&#x439; &#x43F;&#x43E;&#x442;&#x440;&#x456;&#x431;&#x43D;&#x43E; &#x432;&#x438;&#x43A;&#x43E;&#x440;&#x438;&#x441;&#x442;&#x43E;&#x432;&#x443;&#x432;&#x430;&#x442;&#x438; &#x44F;&#x43A; &#x43E;&#x431;&#x43A;&#x43B;&#x430;&#x434;&#x438;&#x43D;&#x43A;&#x443;.",
                  "ba-videorecorder.screen-recorder-is-not-supported": "&#x426;&#x435;&#x439; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x440;&#x456;&#x439; &#x43D;&#x435; &#x43F;&#x456;&#x434;&#x442;&#x440;&#x438;&#x43C;&#x443;&#x454; &#x440;&#x435;&#x454;&#x441;&#x442;&#x440;&#x430;&#x442;&#x43E;&#x440; &#x435;&#x43A;&#x440;&#x430;&#x43D;&#x443;",
                  "ba-videorecorder.trim-prompt": "&#x412;&#x438; &#x445;&#x43E;&#x447;&#x435;&#x442;&#x435; &#x43E;&#x431;&#x440;&#x456;&#x437;&#x430;&#x442;&#x438; &#x441;&#x432;&#x43E;&#x454; &#x432;&#x456;&#x434;&#x435;&#x43E;?",
                  "ba-videorecorder.trim-video": "&#x41F;&#x435;&#x440;&#x435;&#x43C;&#x456;&#x441;&#x442;&#x456;&#x442;&#x44C; &#x43C;&#x430;&#x440;&#x43A;&#x435;&#x440;&#x438; &#x43F;&#x43E;&#x447;&#x430;&#x442;&#x43A;&#x443; &#x442;&#x430; &#x43A;&#x456;&#x43D;&#x446;&#x44F;, &#x449;&#x43E;&#x431; &#x43E;&#x431;&#x440;&#x456;&#x437;&#x430;&#x442;&#x438; &#x432;&#x456;&#x434;&#x435;&#x43E;",
                  "ba-videorecorder.wait-for-trim": "&#x41E;&#x447;&#x456;&#x43A;&#x443;&#x432;&#x430;&#x43D;&#x43D;&#x44F; &#x43A;&#x43E;&#x43C;&#x430;&#x43D;&#x434;&#x438; &#x43E;&#x431;&#x440;&#x456;&#x437;&#x430;&#x43D;&#x43D;&#x44F; ...",
                  "ba-videorecorder-controlbar.no-video-source": "&#x412;&#x456;&#x434;&#x441;&#x443;&#x442;&#x43D;&#x454; &#x434;&#x43E;&#x434;&#x430;&#x442;&#x43A;&#x43E;&#x432;&#x435; &#x434;&#x436;&#x435;&#x440;&#x435;&#x43B;&#x43E; &#x432;&#x445;&#x456;&#x434;&#x43D;&#x43E;&#x433;&#x43E; &#x432;&#x456;&#x434;&#x435;&#x43E;&#x441;&#x438;&#x433;&#x43D;&#x430;&#x43B;&#x443;",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x414;&#x43E;&#x434;&#x430;&#x442;&#x43A;&#x43E;&#x432;&#x438;&#x439; &#x43F;&#x43E;&#x442;&#x456;&#x43A; &#x443;&#x436;&#x435; &#x432;&#x438;&#x431;&#x440;&#x430;&#x43D;&#x43E;",
                  "ba-videorecorder.uploading-src-error": "&#x41D;&#x435;&#x43C;&#x43E;&#x436;&#x43B;&#x438;&#x432;&#x43E; &#x432;&#x456;&#x434;&#x442;&#x432;&#x43E;&#x440;&#x438;&#x442;&#x438; &#x432;&#x456;&#x434;&#x435;&#x43E; &#x437;&#x430;&#x440;&#x430;&#x437;, &#x437;&#x430;&#x432;&#x430;&#x43D;&#x442;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x442;&#x440;&#x438;&#x432;&#x430;&#x454;",
                  "ba-audiorecorder-controlbar.pause-recorder": "&#x41F;&#x430;&#x443;&#x437;&#x430; &#x440;&#x435;&#x454;&#x441;&#x442;&#x440;&#x430;&#x442;&#x43E;&#x440;&#x430;",
                  "ba-audiorecorder-controlbar.resume-recorder": "&#x420;&#x435;&#x454;&#x441;&#x442;&#x440;&#x430;&#x442;&#x43E;&#x440; &#x440;&#x435;&#x437;&#x44E;&#x43C;&#x435;"
                },
                "language:zh-cn": {
                  "ba-videoplayer-playbutton.tooltip": "&#x70B9;&#x51FB;&#x64AD;&#x653E;",
                  "ba-videoplayer-playbutton.rerecord": "&#x91CD;&#x8BD5;",
                  "ba-videoplayer-playbutton.submit-video": "&#x786E;&#x5B9A;",
                  "ba-videoplayer-loader.tooltip": "&#x8BFB;&#x53D6;&#x4E2D;...",
                  "ba-videoplayer-controlbar.change-resolution": "&#x53D8;&#x66F4;&#x5206;&#x8FA8;&#x7387;",
                  "ba-videoplayer-controlbar.video-progress": "&#x8FDB;&#x5EA6;",
                  "ba-videoplayer-controlbar.rerecord-video": "&#x91CD;&#x8BD5;?",
                  "ba-videoplayer-controlbar.submit-video": "&#x786E;&#x8BA4;",
                  "ba-videoplayer-controlbar.play-video": "&#x64AD;&#x653E;",
                  "ba-videoplayer-controlbar.pause-video": "&#x6682;&#x505C;",
                  "ba-videoplayer-controlbar.elapsed-time": "&#x7ECF;&#x8FC7;&#x65F6;&#x95F4;",
                  "ba-videoplayer-controlbar.total-time": "&#x603B;&#x957F;&#x5EA6;",
                  "ba-videoplayer-controlbar.fullscreen-video": "&#x8FDB;&#x5165;&#x5168;&#x5C4F;",
                  "ba-videoplayer-controlbar.volume-button": "&#x8C03;&#x6574;&#x97F3;&#x91CF;",
                  "ba-videoplayer-controlbar.volume-mute": "&#x9759;&#x97F3;",
                  "ba-videoplayer-controlbar.volume-unmute": "&#x89E3;&#x9664;&#x9759;&#x97F3;",
                  "ba-videoplayer.video-error": "&#x9519;&#x8BEF;&#x53D1;&#x751F;&#xFF0C;&#x8BF7;&#x7A0D;&#x540E;&#x518D;&#x8BD5;(&#x70B9;&#x6211;)",
                  "ba-videorecorder-chooser.record-video": "&#x5F55;&#x5236;&#x5F71;&#x7247;",
                  "ba-videorecorder-chooser.upload-video": "&#x4E0A;&#x4F20;&#x5F71;&#x7247;",
                  "ba-videorecorder-controlbar.settings": "&#x8BBE;&#x7F6E;",
                  "ba-videorecorder-controlbar.camerahealthy": "&#x5149;&#x7EBF;&#x826F;&#x597D;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "&#x5149;&#x6E90;&#x4E0D;&#x4F73;",
                  "ba-videorecorder-controlbar.microphonehealthy": "&#x6536;&#x97F3;&#x826F;&#x597D;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "&#x6536;&#x97F3;&#x4E0D;&#x826F;",
                  "ba-videorecorder-controlbar.record": "&#x5F55;&#x5F71;",
                  "ba-videorecorder-controlbar.record-tooltip": "&#x70B9;&#x6211;&#x5F55;&#x5F71;",
                  "ba-videorecorder-controlbar.rerecord": "&#x91CD;&#x8BD5;",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "&#x70B9;&#x6211;&#x91CD;&#x8BD5;",
                  "ba-videorecorder-controlbar.upload-covershot": "&#x4E0A;&#x4F20;",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#x70B9;&#x6211;&#x4E0A;&#x4F20;&#x81EA;&#x8BA2;&#x7684;&#x5C01;&#x9762;",
                  "ba-videorecorder-controlbar.stop": "&#x505C;&#x6B62;",
                  "ba-videorecorder-controlbar.stop-tooltip": "&#x70B9;&#x6211;&#x505C;&#x6B62;",
                  "ba-videorecorder-controlbar.skip": "&#x7565;&#x8FC7;",
                  "ba-videorecorder-controlbar.skip-tooltip": "&#x70B9;&#x6211;&#x7565;&#x8FC7;",
                  "ba-videorecorder.recorder-error": "&#x9519;&#x8BEF;&#x53D1;&#x751F;&#xFF0C;&#x8BF7;&#x7A0D;&#x540E;&#x518D;&#x8BD5;(&#x70B9;&#x6211;)",
                  "ba-videorecorder.attach-error": "&#x65E0;&#x6CD5;&#x5B58;&#x53D6;&#x6444;&#x50CF;&#x5934;&#xFF0C;&#x53EF;&#x80FD;&#x662F;&#x6D4F;&#x89C8;&#x5668;&#x6216;&#x662F;&#x8BBE;&#x5907;&#x7684;&#x9650;&#x5236;&#xFF0C;&#x8BF7;&#x5C1D;&#x8BD5;&#x5B89;&#x88C5; Flash &#x5916;&#x6302;&#x7A0B;&#x5E8F;&#x6216;&#x900F;&#x8FC7;&#x5B89;&#x5168;&#x8FDE;&#x7EBF;&#x6765;&#x4F7F;&#x7528;&#x3002;",
                  "ba-videorecorder.access-forbidden": "&#x65E0;&#x6CD5;&#x5B58;&#x53D6;&#x6444;&#x50CF;&#x5934;&#xFF0C;&#x8BF7;&#x70B9;&#x6211;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-videorecorder.pick-covershot": "&#x8BF7;&#x6311;&#x9009;&#x4E00;&#x5F20;&#x5C01;&#x9762;",
                  "ba-videorecorder.uploading": "&#x4E0A;&#x4F20;&#x4E2D;",
                  "ba-videorecorder.uploading-failed": "&#x4E0A;&#x4F20;&#x5931;&#x8D25;&#xFF0C;&#x8BF7;&#x70B9;&#x6211;&#x91CD;&#x8BD5;",
                  "ba-videorecorder.verifying": "&#x9A8C;&#x8BC1;&#x4E2D;",
                  "ba-videorecorder.verifying-failed": "&#x9A8C;&#x8BC1;&#x5931;&#x8D25;&#xFF0C;&#x8BF7;&#x70B9;&#x6211;&#x91CD;&#x8BD5;",
                  "ba-videorecorder.rerecord-confirm": "&#x786E;&#x5B9A;&#x8981;&#x91CD;&#x65B0;&#x5F55;&#x5236;&#x60A8;&#x7684;&#x5F71;&#x7247;?",
                  "ba-videorecorder.video_file_too_large": "&#x60A8;&#x7684;&#x5F71;&#x7247;&#x8FC7;&#x5927; (%s) &#x8BF7;&#x70B9;&#x6211;&#x91CD;&#x65B0;&#x9009;&#x62E9;&#x5C0F;&#x4E00;&#x70B9;&#x5F71;&#x7247;&#x518D;&#x8BD5;&#x4E00;&#x6B21;&#x3002;",
                  "ba-videorecorder.unsupported_video_type": "&#x8BF7;&#x4F7F;&#x7528;&#x5F71;&#x7247;&#x683C;&#x5F0F;: %s - &#x70B9;&#x6211;&#x91CD;&#x8BD5;",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "&#x7ED3;&#x675F;&#x5168;&#x5C4F;&#x64AD;&#x653E;",
                  "ba-videoplayer-share.share": "&#x5206;&#x4EAB;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "&#x65E0;&#x6CD5;&#x6682;&#x505C;",
                  "ba-videorecorder-chooser.record-audio": "&#x5F55;&#x97F3;",
                  "ba-videorecorder-chooser.record-screen": "&#x8BB0;&#x5F55;&#x5C4F;&#x5E55;",
                  "ba-videorecorder-controlbar.stop-available-after": "&#x6700;&#x77ED;&#x8BB0;&#x5F55;&#x65F6;&#x95F4;&#x662F;%d&#x79D2;",
                  "ba-videorecorder-controlbar.cancel": "&#x53D6;&#x6D88;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "&#x70B9;&#x51FB;&#x8FD9;&#x91CC;&#x53D6;&#x6D88;&#x3002;",
                  "ba-videorecorder.cancel-confirm": "&#x4F60;&#x771F;&#x7684;&#x60F3;&#x53D6;&#x6D88;&#x4F60;&#x7684;&#x89C6;&#x9891;&#x4E0A;&#x4F20;&#xFF1F;",
                  "ba-videoplayer-adslot.elapsed-time": "&#x5443;&#x65F6;&#x95F4;",
                  "ba-videoplayer-adslot.volume-button": "&#x8BBE;&#x7F6E;&#x97F3;&#x91CF;",
                  "ba-videoplayer-adslot.volume-mute": "&#x9759;&#x97F3;",
                  "ba-videoplayer-adslot.volume-unmute": "&#x53D6;&#x6D88;&#x9759;&#x97F3;",
                  "ba-videoplayer-adslot.ad-will-end-after": "&#x5E7F;&#x544A;&#x5C06;&#x5728;%s&#x4E4B;&#x540E;&#x7ED3;&#x675F;",
                  "ba-videoplayer-adslot.can-skip-after": "&#x5728;%d&#x4E4B;&#x540E;&#x8DF3;&#x8FC7;",
                  "ba-videoplayer-adslot.skip-ad": "&#x8DF3;&#x8FC7;&#x5E7F;&#x544A;",
                  "ba-videorecorder.software-required": "&#x8BF7;&#x70B9;&#x51FB;&#x4E0B;&#x9762;&#x7684;&#x5B89;&#x88C5;/&#x6FC0;&#x6D3B;&#x4EE5;&#x4E0B;&#x8981;&#x6C42;&#x624D;&#x80FD;&#x7EE7;&#x7EED;&#x3002;",
                  "ba-videorecorder.software-waiting": "&#x7B49;&#x5F85;&#x8981;&#x6C42;&#x5B89;&#x88C5;/&#x6FC0;&#x6D3B;&#x3002;&#x5B8C;&#x6210;&#x540E;&#x53EF;&#x80FD;&#x9700;&#x8981;&#x5237;&#x65B0;&#x9875;&#x9762;&#x3002;",
                  "ba-videoplayer-controlbar.close-tracks": "&#x5173;&#x95ED;CC",
                  "ba-videoplayer-controlbar.show-tracks": "&#x663E;&#x793A;CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "&#x4E0A;&#x4F20;&#x66F2;&#x76EE;&#x6587;&#x672C;&#x6587;&#x4EF6;",
                  "ba-videoplayer-tracks.select-text-track-language": "&#x5B57;&#x5E55;&#x8BED;&#x8A00;",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x9996;&#x5148;&#x9009;&#x62E9;&#x533A;&#x57DF;&#x8BBE;&#x7F6E;",
                  "ba-videoplayer-tracks.select-text-track-file": "&#x5355;&#x51FB;&#x4EE5;&#x9009;&#x4E2D;&#x6587;&#x4EF6;",
                  "ba-videoplayer-tracks.back": "&#x80CC;&#x90E8;",
                  "ba-videorecorder.framerate-warning": "&#x89C6;&#x9891;&#x5E27;&#x7387;&#x975E;&#x5E38;&#x4F4E;&#x3002;&#x6211;&#x4EEC;&#x5EFA;&#x8BAE;&#x5173;&#x95ED;&#x6240;&#x6709;&#x5176;&#x4ED6;&#x7A0B;&#x5E8F;&#x548C;&#x6D4F;&#x89C8;&#x5668;&#x9009;&#x9879;&#x5361;&#x6216;&#x4F7F;&#x7528;&#x66F4;&#x5FEB;&#x7684;&#x8BA1;&#x7B97;&#x673A;&#x3002;",
                  "ba-videorecorder.upload-error-duration": "&#x4E0A;&#x4F20;&#x89C6;&#x9891;&#x7684;&#x957F;&#x5EA6;&#x4E0D;&#x7B26;&#x5408;&#x8981;&#x6C42; - &#x70B9;&#x51FB;&#x6B64;&#x5904;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-videorecorder.resolution-constraint-error": "&#x60A8;&#x9009;&#x62E9;&#x7684;&#x6587;&#x4EF6;&#x4E0E;&#x6240;&#x9700;&#x7684;&#x5206;&#x8FA8;&#x7387;&#x4E0D;&#x5339;&#x914D; - &#x5355;&#x51FB;&#x6B64;&#x5904;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-videorecorder.orientation-portrait-required": "&#x8BF7;&#x65CB;&#x8F6C;&#x8BBE;&#x5907;&#x4EE5;&#x7EB5;&#x5411;&#x6A21;&#x5F0F;&#x5F55;&#x5236;&#x3002;",
                  "ba-videorecorder.orientation-landscape-required": "&#x8BF7;&#x65CB;&#x8F6C;&#x8BBE;&#x5907;&#x4EE5;&#x6A2A;&#x5411;&#x6A21;&#x5F0F;&#x5F55;&#x5236;&#x3002;",
                  "ba-imageviewer-controlbar.rerecord-image": "&#x91CD;&#x505A;&#xFF1F;",
                  "ba-imageviewer-controlbar.submit-image": "&#x786E;&#x8BA4;",
                  "ba-imageviewer-controlbar.fullscreen-image": "&#x8F93;&#x5165;&#x5168;&#x5C4F;",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "&#x9000;&#x51FA;&#x5168;&#x5C4F;",
                  "ba-imageviewer.image-error": "&#x53D1;&#x751F;&#x4E86;&#x4E00;&#x4E2A;&#x9519;&#x8BEF;&#x3002;&#x8BF7;&#x7A0D;&#x540E;&#x91CD;&#x8BD5;&#x3002;&#x70B9;&#x51FB;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-imagecapture-chooser.image-capture": "&#x6355;&#x83B7;&#x56FE;&#x50CF;",
                  "ba-imagecapture-chooser.upload-image": "&#x4E0A;&#x4F20;&#x56FE;&#x7247;",
                  "ba-imagecapture-controlbar.settings": "&#x8BBE;&#x7F6E;",
                  "ba-imagecapture-controlbar.camerahealthy": "&#x7167;&#x660E;&#x5F88;&#x597D;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "&#x7167;&#x660E;&#x4E0D;&#x662F;&#x6700;&#x4F73;&#x7684;",
                  "ba-imagecapture-controlbar.record": "&#x6355;&#x83B7;",
                  "ba-imagecapture-controlbar.record-tooltip": "&#x70B9;&#x51FB;&#x6B64;&#x5904;&#x6355;&#x6349;&#x3002;",
                  "ba-imagecapture-controlbar.rerecord": "&#x91CD;&#x505A;",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "&#x70B9;&#x51FB;&#x8FD9;&#x91CC;&#x91CD;&#x505A;&#x3002;",
                  "ba-imagecapture-controlbar.cancel": "&#x53D6;&#x6D88;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "&#x70B9;&#x51FB;&#x8FD9;&#x91CC;&#x53D6;&#x6D88;&#x3002;",
                  "ba-audioplayer-controlbar.audio-progress": "&#x8FDB;&#x5C55;",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#x91CD;&#x505A;&#xFF1F;",
                  "ba-audioplayer-controlbar.submit-audio": "&#x786E;&#x8BA4;",
                  "ba-audioplayer-controlbar.play-audio": "&#x73A9;",
                  "ba-audioplayer-controlbar.pause-audio": "&#x6682;&#x505C;",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "&#x6682;&#x505C;&#x4E0D;&#x53D7;&#x652F;&#x6301;",
                  "ba-audioplayer-controlbar.elapsed-time": "&#x8282;&#x7701;&#x65F6;&#x95F4;",
                  "ba-audioplayer-controlbar.total-time": "&#x603B;&#x957F;&#x5EA6;",
                  "ba-audioplayer-controlbar.volume-button": "&#x8BBE;&#x5B9A;&#x97F3;&#x91CF;",
                  "ba-audioplayer-controlbar.volume-mute": "&#x9759;&#x97F3;",
                  "ba-audioplayer-controlbar.volume-unmute": "&#x53D6;&#x6D88;&#x9759;&#x97F3;",
                  "ba-audioplayer-loader.tooltip": "&#x8F7D;&#x5165;&#x4E2D;...",
                  "ba-audioplayer.audio-error": "&#x53D1;&#x751F;&#x4E86;&#x4E00;&#x4E2A;&#x9519;&#x8BEF;&#x3002;&#x8BF7;&#x7A0D;&#x540E;&#x91CD;&#x8BD5;&#x3002;&#x70B9;&#x51FB;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-audiorecorder-chooser.record-audio": "&#x5F55;&#x5236;&#x97F3;&#x9891;",
                  "ba-audiorecorder-chooser.upload-audio": "&#x4E0A;&#x4F20;&#x97F3;&#x9891;",
                  "ba-audiorecorder-controlbar.settings": "&#x8BBE;&#x7F6E;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "&#x58F0;&#x97F3;&#x5F88;&#x597D;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "&#x65E0;&#x6CD5;&#x63A5;&#x542C;&#x4EFB;&#x4F55;&#x58F0;&#x97F3;",
                  "ba-audiorecorder-controlbar.record": "&#x8BB0;&#x5F55;",
                  "ba-audiorecorder-controlbar.record-tooltip": "&#x70B9;&#x51FB;&#x8FD9;&#x91CC;&#x8BB0;&#x5F55;&#x3002;",
                  "ba-audiorecorder-controlbar.rerecord": "&#x91CD;&#x505A;",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "&#x70B9;&#x51FB;&#x8FD9;&#x91CC;&#x91CD;&#x505A;&#x3002;",
                  "ba-audiorecorder-controlbar.stop": "&#x505C;&#x6B62;",
                  "ba-audiorecorder-controlbar.stop-tooltip": "&#x70B9;&#x51FB;&#x6B64;&#x5904;&#x505C;&#x6B62;&#x3002;",
                  "ba-audiorecorder-controlbar.stop-available-after": "&#x6700;&#x77ED;&#x5F55;&#x5236;&#x65F6;&#x95F4;&#x4E3A;%d&#x79D2;",
                  "ba-audiorecorder-controlbar.cancel": "&#x53D6;&#x6D88;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "&#x70B9;&#x51FB;&#x8FD9;&#x91CC;&#x53D6;&#x6D88;&#x3002;",
                  "ba-videoplayer-controlbar.player-speed": "&#x7403;&#x5458;&#x901F;&#x5EA6;",
                  "ba-videoplayer-controlbar.settings": "&#x8BBE;&#x7F6E;",
                  "ba-videoplayer-controlbar.airplay": "&#x7684;Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay&#x56FE;&#x6807;&#x3002;",
                  "ba-videoplayer.all-settings": "&#x6240;&#x6709;&#x8BBE;&#x7F6E;",
                  "ba-videoplayer.player-speed": "&#x7403;&#x5458;&#x901F;&#x5EA6;",
                  "ba-videoplayer.full-screen": "&#x5168;&#x5C4F;",
                  "ba-videorecorder-controlbar.add-stream": "&#x6DFB;&#x52A0;&#x6D41;",
                  "ba-videorecorder.switch-camera": "&#x5207;&#x6362;&#x76F8;&#x673A;",
                  "ba-videorecorder.prepare-covershot": "&#x51C6;&#x5907;&#x70AE;&#x5F39;",
                  "ba-videorecorder.prepare-thumbnails": "&#x51C6;&#x5907;&#x5BFB;&#x627E;&#x7F29;&#x7565;&#x56FE;",
                  "ba-videorecorder.adding-new-stream": "&#x6DFB;&#x52A0;&#x65B0;&#x6D41;",
                  "ba-imagecapture.recorder-error": "&#x53D1;&#x751F;&#x4E86;&#x4E00;&#x4E2A;&#x9519;&#x8BEF;&#x3002;&#x8BF7;&#x7A0D;&#x540E;&#x91CD;&#x8BD5;&#x3002;&#x70B9;&#x51FB;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-imagecapture.attach-error": "&#x6211;&#x4EEC;&#x65E0;&#x6CD5;&#x8BBF;&#x95EE;&#x5A92;&#x4F53;&#x754C;&#x9762;&#x3002;&#x60A8;&#x53EF;&#x80FD;&#x9700;&#x8981;&#x5B89;&#x88C5;Flash&#x6216;&#x901A;&#x8FC7;SSL&#x8BBF;&#x95EE;&#x8BE5;&#x9875;&#x9762;&#xFF0C;&#x5177;&#x4F53;&#x53D6;&#x51B3;&#x4E8E;&#x8BBE;&#x5907;&#x548C;&#x6D4F;&#x89C8;&#x5668;&#x3002;",
                  "ba-imagecapture.software-required": "&#x8BF7;&#x5355;&#x51FB;&#x4E0B;&#x65B9;&#x4EE5;&#x5B89;&#x88C5;/&#x6FC0;&#x6D3B;&#x4EE5;&#x4E0B;&#x8981;&#x6C42;&#x4EE5;&#x7EE7;&#x7EED;&#x3002;",
                  "ba-imagecapture.software-waiting": "&#x7B49;&#x5F85;&#x5B89;&#x88C5;/&#x6FC0;&#x6D3B;&#x8981;&#x6C42;&#x3002;&#x60A8;&#x53EF;&#x80FD;&#x9700;&#x8981;&#x5728;&#x5B8C;&#x6210;&#x540E;&#x5237;&#x65B0;&#x9875;&#x9762;&#x3002;",
                  "ba-imagecapture.access-forbidden": "&#x7981;&#x6B62;&#x8BBF;&#x95EE;&#x5A92;&#x4F53;&#x3002;&#x70B9;&#x51FB;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-imagecapture.uploading": "&#x4E0A;&#x4F20;",
                  "ba-imagecapture.uploading-failed": "&#x4E0A;&#x4F20;&#x5931;&#x8D25; - &#x70B9;&#x51FB;&#x6B64;&#x5904;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-imagecapture.upload-error-duration": "&#x4E0A;&#x4F20;&#x56FE;&#x7247;&#x7684;&#x957F;&#x5EA6;&#x4E0D;&#x7B26;&#x5408;&#x8981;&#x6C42; - &#x70B9;&#x51FB;&#x6B64;&#x5904;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-imagecapture.resolution-constraint-error": "&#x60A8;&#x9009;&#x62E9;&#x7684;&#x6587;&#x4EF6;&#x4E0E;&#x6240;&#x9700;&#x7684;&#x5206;&#x8FA8;&#x7387;&#x4E0D;&#x5339;&#x914D; - &#x70B9;&#x51FB;&#x6B64;&#x5904;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-imagecapture.verifying": "&#x9A8C;&#x8BC1;",
                  "ba-imagecapture.verifying-failed": "&#x9A8C;&#x8BC1;&#x5931;&#x8D25; - &#x5355;&#x51FB;&#x6B64;&#x5904;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-imagecapture.rerecord-confirm": "&#x4F60;&#x771F;&#x7684;&#x60F3;&#x91CD;&#x62CD;&#x4F60;&#x7684;&#x5F62;&#x8C61;&#x5417;&#xFF1F;",
                  "ba-imagecapture.image_file_too_large": "&#x60A8;&#x7684;&#x56FE;&#x7247;&#x6587;&#x4EF6;&#x592A;&#x5927;&#xFF08;%s&#xFF09; - &#x70B9;&#x51FB;&#x6B64;&#x5904;&#x518D;&#x6B21;&#x5C1D;&#x8BD5;&#x4F7F;&#x7528;&#x8F83;&#x5C0F;&#x7684;&#x56FE;&#x7247;&#x6587;&#x4EF6;&#x3002;",
                  "ba-imagecapture.unsupported_image_type": "&#x8BF7;&#x4E0A;&#x4F20;&#xFF1A;%s  - &#x70B9;&#x51FB;&#x6B64;&#x5904;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-imagecapture.orientation-portrait-required": "&#x8BF7;&#x65CB;&#x8F6C;&#x8BBE;&#x5907;&#x4EE5;&#x7EB5;&#x5411;&#x6A21;&#x5F0F;&#x5F55;&#x5236;&#x3002;",
                  "ba-imagecapture.orientation-landscape-required": "&#x8BF7;&#x65CB;&#x8F6C;&#x60A8;&#x7684;&#x8BBE;&#x5907;&#x4EE5;&#x6A2A;&#x5411;&#x6A21;&#x5F0F;&#x5F55;&#x5236;&#x3002;",
                  "ba-audiorecorder.recorder-error": "&#x53D1;&#x751F;&#x4E86;&#x4E00;&#x4E2A;&#x9519;&#x8BEF;&#x3002;&#x8BF7;&#x7A0D;&#x540E;&#x91CD;&#x8BD5;&#x3002;&#x70B9;&#x51FB;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-audiorecorder.attach-error": "&#x6211;&#x4EEC;&#x65E0;&#x6CD5;&#x8BBF;&#x95EE;&#x5A92;&#x4F53;&#x754C;&#x9762;&#x3002;&#x60A8;&#x53EF;&#x80FD;&#x9700;&#x8981;&#x5B89;&#x88C5;Flash&#x6216;&#x901A;&#x8FC7;SSL&#x8BBF;&#x95EE;&#x8BE5;&#x9875;&#x9762;&#xFF0C;&#x5177;&#x4F53;&#x53D6;&#x51B3;&#x4E8E;&#x8BBE;&#x5907;&#x548C;&#x6D4F;&#x89C8;&#x5668;&#x3002;",
                  "ba-audiorecorder.software-required": "&#x8BF7;&#x5355;&#x51FB;&#x4E0B;&#x65B9;&#x4EE5;&#x5B89;&#x88C5;/&#x6FC0;&#x6D3B;&#x4EE5;&#x4E0B;&#x8981;&#x6C42;&#x4EE5;&#x7EE7;&#x7EED;&#x3002;",
                  "ba-audiorecorder.software-waiting": "&#x7B49;&#x5F85;&#x5B89;&#x88C5;/&#x6FC0;&#x6D3B;&#x8981;&#x6C42;&#x3002;&#x60A8;&#x53EF;&#x80FD;&#x9700;&#x8981;&#x5728;&#x5B8C;&#x6210;&#x540E;&#x5237;&#x65B0;&#x9875;&#x9762;&#x3002;",
                  "ba-audiorecorder.access-forbidden": "&#x7981;&#x6B62;&#x8BBF;&#x95EE;&#x5A92;&#x4F53;&#x3002;&#x70B9;&#x51FB;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-audiorecorder.uploading": "&#x4E0A;&#x4F20;",
                  "ba-audiorecorder.uploading-failed": "&#x4E0A;&#x4F20;&#x5931;&#x8D25; - &#x70B9;&#x51FB;&#x6B64;&#x5904;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-audiorecorder.upload-error-duration": "&#x4E0A;&#x4F20;&#x7684;&#x97F3;&#x9891;&#x957F;&#x5EA6;&#x4E0D;&#x7B26;&#x5408;&#x8981;&#x6C42; - &#x70B9;&#x51FB;&#x6B64;&#x5904;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-audiorecorder.verifying": "&#x9A8C;&#x8BC1;",
                  "ba-audiorecorder.verifying-failed": "&#x9A8C;&#x8BC1;&#x5931;&#x8D25; - &#x5355;&#x51FB;&#x6B64;&#x5904;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-audiorecorder.rerecord-confirm": "&#x4F60;&#x771F;&#x7684;&#x60F3;&#x8981;&#x91CD;&#x505A;&#x4F60;&#x7684;&#x97F3;&#x9891;&#x5417;&#xFF1F;",
                  "ba-audiorecorder.cancel-confirm": "&#x4F60;&#x771F;&#x7684;&#x60F3;&#x53D6;&#x6D88;&#x97F3;&#x9891;&#x4E0A;&#x4F20;&#x5417;&#xFF1F;",
                  "ba-audiorecorder.audio_file_too_large": "&#x60A8;&#x7684;&#x97F3;&#x9891;&#x6587;&#x4EF6;&#x592A;&#x5927;&#xFF08;%s&#xFF09; - &#x70B9;&#x51FB;&#x6B64;&#x5904;&#x518D;&#x6B21;&#x5C1D;&#x8BD5;&#x4F7F;&#x7528;&#x8F83;&#x5C0F;&#x7684;&#x97F3;&#x9891;&#x6587;&#x4EF6;&#x3002;",
                  "ba-audiorecorder.unsupported_audio_type": "&#x8BF7;&#x4E0A;&#x4F20;&#xFF1A;%s  - &#x70B9;&#x51FB;&#x6B64;&#x5904;&#x91CD;&#x8BD5;&#x3002;",
                  "ba-common-settingsmenu.tooltip": "&#x70B9;&#x51FB;&#x64AD;&#x653E;&#x3002;",
                  "ba-common-settingsmenu.setting-menu": "&#x6240;&#x6709;&#x8BBE;&#x5B9A;",
                  "ba-common-settingsmenu.source-quality": "&#x6E90;&#x8D28;&#x91CF;",
                  "ba-common-settingsmenu.player-speed": "&#x64AD;&#x653E;&#x901F;&#x5EA6;",
                  "ba-common-settingsmenu.set-menu-option": "&#x8BBE;&#x5B9A;&#x9009;&#x9879;",
                  "ba-common-settingsmenu.submit-video": "&#x786E;&#x8BA4;&#x5F71;&#x7247;",
                  "ba-common-settingsmenu.picture-in-picture": "&#x753B;&#x4E2D;&#x753B;",
                  "ba-common-settingsmenu.exit-fullscreen-video": "&#x9000;&#x51FA;&#x5168;&#x5C4F;",
                  "ba-common-settingsmenu.fullscreen-video": "&#x8FDB;&#x5165;&#x5168;&#x5C4F;",
                  "ba-videorecorder-chooser.multi-stream": "&#x591A;&#x6D41;",
                  "ba-videorecorder-controlbar.pause-recorder": "&#x6682;&#x505C;&#x8BB0;&#x5F55;&#x5668;",
                  "ba-videorecorder-controlbar.resume-recorder": "&#x7B80;&#x5386;&#x8BB0;&#x5F55;&#x5668;",
                  "ba-videorecorder.missing-track": "&#x7F3A;&#x5C11;&#x5FC5;&#x9700;&#x7684;&#x97F3;&#x9891;&#x6216;&#x89C6;&#x9891;&#x8F68;&#x9053;",
                  "ba-videorecorder.device-already-in-use": "&#x60A8;&#x7684;&#x81F3;&#x5C11;&#x4E00;&#x4E2A;&#x8F93;&#x5165;&#x8BBE;&#x5907;&#x5DF2;&#x5728;&#x4F7F;&#x7528;&#x4E2D;",
                  "ba-videorecorder.browser-permission-denied": "&#x6D4F;&#x89C8;&#x5668;&#x62D2;&#x7EDD;&#x6B64;&#x6743;&#x9650;&#xFF0C;&#x8BF7;&#x6388;&#x4E88;&#x8BBF;&#x95EE;&#x6743;&#x9650;&#x5E76;&#x91CD;&#x65B0;&#x52A0;&#x8F7D;&#x9875;&#x9762;",
                  "ba-audioplayer.all-settings": "&#x6240;&#x6709;&#x8BBE;&#x5B9A;",
                  "ba-videoplayer-controlbar.remaining-time": "&#x5269;&#x4F59;&#x65F6;&#x95F4;",
                  "ba-videoplayer-controlbar.select-frame": "&#x9009;&#x62E9;",
                  "ba-videoplayer-controlbar.trim-video": "&#x4FEE;&#x526A;",
                  "ba-videoplayer-playbutton.trim": "&#x4FEE;&#x526A;",
                  "ba-videoplayer-playbutton.skip": "&#x8DF3;&#x8FC7;",
                  "ba-videorecorder-imagegallery.upload-covershot": "&#x4E0A;&#x4F20;&#x5C01;&#x9762;",
                  "ba-videorecorder.pick-covershot-frame": "&#x9009;&#x62E9;&#x8981;&#x7528;&#x4F5C;&#x63A9;&#x62A4;&#x7684;&#x5E27;&#x3002;",
                  "ba-videorecorder.screen-recorder-is-not-supported": "&#x6B64;&#x8BBE;&#x5907;&#x4E0D;&#x652F;&#x6301;&#x5C4F;&#x5E55;&#x5F55;&#x50CF;&#x673A;",
                  "ba-videorecorder.trim-prompt": "&#x4F60;&#x60F3;&#x4FEE;&#x526A;&#x4F60;&#x7684;&#x89C6;&#x9891;&#x5417;&#xFF1F;",
                  "ba-videorecorder.trim-video": "&#x79FB;&#x52A8;&#x5F00;&#x59CB;&#x548C;&#x7ED3;&#x675F;&#x6807;&#x8BB0;&#x4EE5;&#x4FEE;&#x526A;&#x89C6;&#x9891;",
                  "ba-videorecorder.wait-for-trim": "&#x7B49;&#x5F85;&#x4FEE;&#x526A;&#x547D;&#x4EE4;...",
                  "ba-videorecorder-controlbar.no-video-source": "&#x7F3A;&#x5C11;&#x989D;&#x5916;&#x7684;&#x89C6;&#x9891;&#x8F93;&#x5165;&#x6E90;",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x5DF2;&#x9009;&#x62E9;&#x9644;&#x52A0;&#x6D41;",
                  "ba-videorecorder.uploading-src-error": "&#x73B0;&#x5728;&#x65E0;&#x6CD5;&#x64AD;&#x653E;&#x89C6;&#x9891;&#xFF0C;&#x4E0A;&#x4F20;&#x4ECD;&#x5728;&#x8FDB;&#x884C;&#x4E2D;",
                  "ba-audiorecorder-controlbar.pause-recorder": "&#x6682;&#x505C;&#x5F55;&#x97F3;&#x673A;",
                  "ba-audiorecorder-controlbar.resume-recorder": "&#x7B80;&#x5386;&#x8BB0;&#x5F55;&#x5668;"
                },
                "language:zh-tw": {
                  "ba-videoplayer-playbutton.tooltip": "&#x9EDE;&#x9078;&#x64AD;&#x653E;",
                  "ba-videoplayer-playbutton.rerecord": "&#x91CD;&#x8A66;",
                  "ba-videoplayer-playbutton.submit-video": "&#x78BA;&#x8A8D;",
                  "ba-videoplayer-loader.tooltip": "&#x8B80;&#x53D6;&#x4E2D;...",
                  "ba-videoplayer-controlbar.change-resolution": "&#x8B8A;&#x66F4;&#x89E3;&#x6790;&#x5EA6;",
                  "ba-videoplayer-controlbar.video-progress": "&#x9032;&#x5EA6;",
                  "ba-videoplayer-controlbar.rerecord-video": "&#x91CD;&#x8A66;?",
                  "ba-videoplayer-controlbar.submit-video": "&#x78BA;&#x8A8D;",
                  "ba-videoplayer-controlbar.play-video": "&#x64AD;&#x653E;",
                  "ba-videoplayer-controlbar.pause-video": "&#x66AB;&#x505C;",
                  "ba-videoplayer-controlbar.elapsed-time": "&#x7D93;&#x904E;&#x6642;&#x9593;",
                  "ba-videoplayer-controlbar.total-time": "&#x7E3D;&#x9577;&#x5EA6;",
                  "ba-videoplayer-controlbar.fullscreen-video": "&#x9032;&#x5165;&#x5168;&#x87A2;&#x5E55;",
                  "ba-videoplayer-controlbar.volume-button": "&#x8ABF;&#x6574;&#x97F3;&#x91CF;",
                  "ba-videoplayer-controlbar.volume-mute": "&#x975C;&#x97F3;",
                  "ba-videoplayer-controlbar.volume-unmute": "&#x89E3;&#x9664;&#x975C;&#x97F3;",
                  "ba-videoplayer.video-error": "&#x932F;&#x8AA4;&#x767C;&#x751F;&#xFF0C;&#x8ACB;&#x7A0D;&#x5F8C;&#x518D;&#x8A66;(&#x9EDE;&#x6211;)",
                  "ba-videorecorder-chooser.record-video": "&#x9304;&#x88FD;&#x5F71;&#x7247;",
                  "ba-videorecorder-chooser.upload-video": "&#x4E0A;&#x50B3;&#x5F71;&#x7247;",
                  "ba-videorecorder-controlbar.settings": "&#x8A2D;&#x5B9A;&#x503C;",
                  "ba-videorecorder-controlbar.camerahealthy": "&#x5149;&#x7DDA;&#x826F;&#x597D;",
                  "ba-videorecorder-controlbar.cameraunhealthy": "&#x5149;&#x6E90;&#x4E0D;&#x4F73;",
                  "ba-videorecorder-controlbar.microphonehealthy": "&#x6536;&#x97F3;&#x826F;&#x597D;",
                  "ba-videorecorder-controlbar.microphoneunhealthy": "&#x6536;&#x97F3;&#x4E0D;&#x826F;",
                  "ba-videorecorder-controlbar.record": "&#x9304;&#x5F71;",
                  "ba-videorecorder-controlbar.record-tooltip": "&#x9EDE;&#x6211;&#x9304;&#x5F71;",
                  "ba-videorecorder-controlbar.rerecord": "&#x91CD;&#x8A66;",
                  "ba-videorecorder-controlbar.rerecord-tooltip": "&#x9EDE;&#x6211;&#x91CD;&#x8A66;",
                  "ba-videorecorder-controlbar.upload-covershot": "&#x4E0A;&#x50B3;",
                  "ba-videorecorder-controlbar.upload-covershot-tooltip": "&#x9EDE;&#x6211;&#x4E0A;&#x50B3;&#x81EA;&#x8A02;&#x7684;&#x5C01;&#x9762;",
                  "ba-videorecorder-controlbar.stop": "&#x505C;&#x6B62;",
                  "ba-videorecorder-controlbar.stop-tooltip": "&#x9EDE;&#x6211;&#x505C;&#x6B62;",
                  "ba-videorecorder-controlbar.skip": "&#x7565;&#x904E;",
                  "ba-videorecorder-controlbar.skip-tooltip": "&#x9EDE;&#x6211;&#x7565;&#x904E;",
                  "ba-videorecorder.recorder-error": "&#x932F;&#x8AA4;&#x767C;&#x751F;&#xFF0C;&#x8ACB;&#x7A0D;&#x5F8C;&#x518D;&#x8A66;(&#x9EDE;&#x6211;)",
                  "ba-videorecorder.attach-error": "&#x7121;&#x6CD5;&#x5B58;&#x53D6;&#x651D;&#x5F71;&#x6A5F;&#xFF0C;&#x53EF;&#x80FD;&#x662F;&#x700F;&#x89BD;&#x5668;&#x6216;&#x662F;&#x88DD;&#x7F6E;&#x7684;&#x9650;&#x5236;&#xFF0C;&#x8ACB;&#x5617;&#x8A66;&#x5B89;&#x88DD; Flash &#x5916;&#x639B;&#x7A0B;&#x5F0F;&#x6216;&#x900F;&#x904E;&#x5B89;&#x5168;&#x9023;&#x7DDA;&#x4F86;&#x4F7F;&#x7528;&#x3002;",
                  "ba-videorecorder.access-forbidden": "&#x7121;&#x6CD5;&#x5B58;&#x53D6;&#x651D;&#x5F71;&#x6A5F;&#xFF0C;&#x8ACB;&#x9EDE;&#x6211;&#x91CD;&#x8A66;&#x3002;",
                  "ba-videorecorder.pick-covershot": "&#x8ACB;&#x6311;&#x9078;&#x4E00;&#x5F35;&#x5C01;&#x9762;",
                  "ba-videorecorder.uploading": "&#x4E0A;&#x50B3;&#x4E2D;",
                  "ba-videorecorder.uploading-failed": "&#x4E0A;&#x50B3;&#x5931;&#x6557;&#xFF0C;&#x8ACB;&#x9EDE;&#x6211;&#x91CD;&#x8A66;",
                  "ba-videorecorder.verifying": "&#x9A57;&#x8B49;&#x4E2D;",
                  "ba-videorecorder.verifying-failed": "&#x9A57;&#x8B49;&#x5931;&#x6557;&#xFF0C;&#x8ACB;&#x9EDE;&#x6211;&#x91CD;&#x8A66;",
                  "ba-videorecorder.rerecord-confirm": "&#x78BA;&#x5B9A;&#x8981;&#x91CD;&#x65B0;&#x9304;&#x88FD;&#x60A8;&#x7684;&#x5F71;&#x7247;?",
                  "ba-videorecorder.video_file_too_large": "&#x60A8;&#x7684;&#x5F71;&#x7247;&#x904E;&#x5927; (%s) &#x8ACB;&#x9EDE;&#x6211;&#x91CD;&#x65B0;&#x9078;&#x64C7;&#x5C0F;&#x4E00;&#x9EDE;&#x5F71;&#x7247;&#x518D;&#x8A66;&#x4E00;&#x6B21;&#x3002;",
                  "ba-videorecorder.unsupported_video_type": "&#x8ACB;&#x4F7F;&#x7528;&#x5F71;&#x7247;&#x683C;&#x5F0F;: %s - &#x9EDE;&#x6211;&#x91CD;&#x8A66;",
                  "ba-videoplayer-controlbar.exit-fullscreen-video": "&#x7D50;&#x675F;&#x5168;&#x87A2;&#x5E55;",
                  "ba-videoplayer-share.share": "&#x5206;&#x4EAB;",
                  "ba-videoplayer-controlbar.pause-video-disabled": "&#x7121;&#x6CD5;&#x66AB;&#x505C;",
                  "ba-videorecorder-chooser.record-audio": "&#x9304;&#x97F3;",
                  "ba-videorecorder-chooser.record-screen": "&#x8A18;&#x9304;&#x5C4F;&#x5E55;",
                  "ba-videorecorder-controlbar.stop-available-after": "&#x6700;&#x77ED;&#x8A18;&#x9304;&#x6642;&#x9593;&#x662F;%d&#x79D2;",
                  "ba-videorecorder-controlbar.cancel": "&#x53D6;&#x6D88;",
                  "ba-videorecorder-controlbar.cancel-tooltip": "&#x9EDE;&#x64CA;&#x9019;&#x88E1;&#x53D6;&#x6D88;&#x3002;",
                  "ba-videorecorder.cancel-confirm": "&#x4F60;&#x771F;&#x7684;&#x60F3;&#x53D6;&#x6D88;&#x4F60;&#x7684;&#x8996;&#x983B;&#x4E0A;&#x50B3;&#xFF1F;",
                  "ba-videoplayer-adslot.elapsed-time": "&#x5443;&#x6642;&#x9593;",
                  "ba-videoplayer-adslot.volume-button": "&#x8A2D;&#x7F6E;&#x97F3;&#x91CF;",
                  "ba-videoplayer-adslot.volume-mute": "&#x975C;&#x97F3;",
                  "ba-videoplayer-adslot.volume-unmute": "&#x53D6;&#x6D88;&#x975C;&#x97F3;",
                  "ba-videoplayer-adslot.ad-will-end-after": "&#x5EE3;&#x544A;&#x5C07;&#x5728;%s&#x4E4B;&#x5F8C;&#x7D50;&#x675F;",
                  "ba-videoplayer-adslot.can-skip-after": "&#x5728;%d&#x4E4B;&#x5F8C;&#x8DF3;&#x904E;",
                  "ba-videoplayer-adslot.skip-ad": "&#x8DF3;&#x904E;&#x5EE3;&#x544A;",
                  "ba-videorecorder.software-required": "&#x8ACB;&#x9EDE;&#x64CA;&#x4E0B;&#x9762;&#x7684;&#x5B89;&#x88DD;/&#x6FC0;&#x6D3B;&#x4EE5;&#x4E0B;&#x8981;&#x6C42;&#x624D;&#x80FD;&#x7E7C;&#x7E8C;&#x3002;",
                  "ba-videorecorder.software-waiting": "&#x7B49;&#x5F85;&#x8981;&#x6C42;&#x5B89;&#x88DD;/&#x6FC0;&#x6D3B;&#x3002;&#x5B8C;&#x6210;&#x5F8C;&#x53EF;&#x80FD;&#x9700;&#x8981;&#x5237;&#x65B0;&#x9801;&#x9762;&#x3002;",
                  "ba-videoplayer-controlbar.close-tracks": "&#x95DC;&#x9589;CC",
                  "ba-videoplayer-controlbar.show-tracks": "&#x986F;&#x793A;CC",
                  "ba-videoplayer-tracks.upload-text-tracks": "&#x4E0A;&#x50B3;&#x66F2;&#x76EE;&#x6587;&#x672C;&#x6587;&#x4EF6;",
                  "ba-videoplayer-tracks.select-text-track-language": "&#x5B57;&#x5E55;&#x8A9E;&#x8A00;",
                  "ba-videoplayer-tracks.info-select-locale-first": "&#x9996;&#x5148;&#x9078;&#x64C7;&#x5340;&#x57DF;&#x8A2D;&#x7F6E;",
                  "ba-videoplayer-tracks.select-text-track-file": "&#x55AE;&#x64CA;&#x4EE5;&#x9078;&#x4E2D;&#x6587;&#x4EF6;",
                  "ba-videoplayer-tracks.back": "&#x80CC;&#x90E8;",
                  "ba-videorecorder.framerate-warning": "&#x8996;&#x983B;&#x5E40;&#x7387;&#x975E;&#x5E38;&#x4F4E;&#x3002;&#x6211;&#x5011;&#x5EFA;&#x8B70;&#x95DC;&#x9589;&#x6240;&#x6709;&#x5176;&#x4ED6;&#x7A0B;&#x5E8F;&#x548C;&#x700F;&#x89BD;&#x5668;&#x9078;&#x9805;&#x5361;&#x6216;&#x4F7F;&#x7528;&#x66F4;&#x5FEB;&#x7684;&#x8A08;&#x7B97;&#x6A5F;&#x3002;",
                  "ba-videorecorder.upload-error-duration": "&#x4E0A;&#x50B3;&#x8996;&#x983B;&#x7684;&#x9577;&#x5EA6;&#x4E0D;&#x7B26;&#x5408;&#x8981;&#x6C42; - &#x9EDE;&#x64CA;&#x6B64;&#x8655;&#x91CD;&#x8A66;&#x3002;",
                  "ba-videorecorder.resolution-constraint-error": "&#x60A8;&#x9078;&#x64C7;&#x7684;&#x6587;&#x4EF6;&#x8207;&#x6240;&#x9700;&#x7684;&#x5206;&#x8FA8;&#x7387;&#x4E0D;&#x5339;&#x914D; - &#x55AE;&#x64CA;&#x6B64;&#x8655;&#x91CD;&#x8A66;&#x3002;",
                  "ba-videorecorder.orientation-portrait-required": "&#x8ACB;&#x65CB;&#x8F49;&#x8A2D;&#x5099;&#x4EE5;&#x7E31;&#x5411;&#x6A21;&#x5F0F;&#x9304;&#x88FD;&#x3002;",
                  "ba-videorecorder.orientation-landscape-required": "&#x8ACB;&#x65CB;&#x8F49;&#x8A2D;&#x5099;&#x4EE5;&#x6A6B;&#x5411;&#x6A21;&#x5F0F;&#x9304;&#x88FD;&#x3002;",
                  "ba-imageviewer-controlbar.rerecord-image": "&#x91CD;&#x505A;&#xFF1F;",
                  "ba-imageviewer-controlbar.submit-image": "&#x78BA;&#x8A8D;",
                  "ba-imageviewer-controlbar.fullscreen-image": "&#x8F38;&#x5165;&#x5168;&#x5C4F;",
                  "ba-imageviewer-controlbar.exit-fullscreen-image": "&#x9000;&#x51FA;&#x5168;&#x5C4F;",
                  "ba-imageviewer.image-error": "&#x767C;&#x751F;&#x4E86;&#x4E00;&#x500B;&#x932F;&#x8AA4;&#x3002;&#x8ACB;&#x7A0D;&#x5F8C;&#x91CD;&#x8A66;&#x3002;&#x9EDE;&#x64CA;&#x91CD;&#x8A66;&#x3002;",
                  "ba-imagecapture-chooser.image-capture": "&#x6355;&#x7372;&#x5716;&#x50CF;",
                  "ba-imagecapture-chooser.upload-image": "&#x4E0A;&#x50B3;&#x5716;&#x7247;",
                  "ba-imagecapture-controlbar.settings": "&#x8A2D;&#x7F6E;",
                  "ba-imagecapture-controlbar.camerahealthy": "&#x7167;&#x660E;&#x5F88;&#x597D;",
                  "ba-imagecapture-controlbar.cameraunhealthy": "&#x7167;&#x660E;&#x4E0D;&#x662F;&#x6700;&#x4F73;&#x7684;",
                  "ba-imagecapture-controlbar.record": "&#x6355;&#x7372;",
                  "ba-imagecapture-controlbar.record-tooltip": "&#x9EDE;&#x64CA;&#x6B64;&#x8655;&#x6355;&#x6349;&#x3002;",
                  "ba-imagecapture-controlbar.rerecord": "&#x91CD;&#x505A;",
                  "ba-imagecapture-controlbar.rerecord-tooltip": "&#x9EDE;&#x64CA;&#x9019;&#x88E1;&#x91CD;&#x505A;&#x3002;",
                  "ba-imagecapture-controlbar.cancel": "&#x53D6;&#x6D88;",
                  "ba-imagecapture-controlbar.cancel-tooltip": "&#x9EDE;&#x64CA;&#x9019;&#x88E1;&#x53D6;&#x6D88;&#x3002;",
                  "ba-audioplayer-controlbar.audio-progress": "&#x9032;&#x5C55;",
                  "ba-audioplayer-controlbar.rerecord-audio": "&#x91CD;&#x505A;&#xFF1F;",
                  "ba-audioplayer-controlbar.submit-audio": "&#x78BA;&#x8A8D;",
                  "ba-audioplayer-controlbar.play-audio": "&#x73A9;",
                  "ba-audioplayer-controlbar.pause-audio": "&#x66AB;&#x505C;",
                  "ba-audioplayer-controlbar.pause-audio-disabled": "&#x66AB;&#x505C;&#x4E0D;&#x53D7;&#x652F;&#x6301;",
                  "ba-audioplayer-controlbar.elapsed-time": "&#x7BC0;&#x7701;&#x6642;&#x9593;",
                  "ba-audioplayer-controlbar.total-time": "&#x7E3D;&#x9577;&#x5EA6;",
                  "ba-audioplayer-controlbar.volume-button": "&#x8A2D;&#x5B9A;&#x97F3;&#x91CF;",
                  "ba-audioplayer-controlbar.volume-mute": "&#x975C;&#x97F3;",
                  "ba-audioplayer-controlbar.volume-unmute": "&#x53D6;&#x6D88;&#x975C;&#x97F3;",
                  "ba-audioplayer-loader.tooltip": "&#x8F09;&#x5165;&#x4E2D;...",
                  "ba-audioplayer.audio-error": "&#x767C;&#x751F;&#x4E86;&#x4E00;&#x500B;&#x932F;&#x8AA4;&#x3002;&#x8ACB;&#x7A0D;&#x5F8C;&#x91CD;&#x8A66;&#x3002;&#x9EDE;&#x64CA;&#x91CD;&#x8A66;&#x3002;",
                  "ba-audiorecorder-chooser.record-audio": "&#x9304;&#x88FD;&#x97F3;&#x983B;",
                  "ba-audiorecorder-chooser.upload-audio": "&#x4E0A;&#x50B3;&#x97F3;&#x983B;",
                  "ba-audiorecorder-controlbar.settings": "&#x8A2D;&#x7F6E;",
                  "ba-audiorecorder-controlbar.microphonehealthy": "&#x8072;&#x97F3;&#x5F88;&#x597D;",
                  "ba-audiorecorder-controlbar.microphoneunhealthy": "&#x7121;&#x6CD5;&#x63A5;&#x807D;&#x4EFB;&#x4F55;&#x8072;&#x97F3;",
                  "ba-audiorecorder-controlbar.record": "&#x8A18;&#x9304;",
                  "ba-audiorecorder-controlbar.record-tooltip": "&#x9EDE;&#x64CA;&#x9019;&#x88E1;&#x8A18;&#x9304;&#x3002;",
                  "ba-audiorecorder-controlbar.rerecord": "&#x91CD;&#x505A;",
                  "ba-audiorecorder-controlbar.rerecord-tooltip": "&#x9EDE;&#x64CA;&#x9019;&#x88E1;&#x91CD;&#x505A;&#x3002;",
                  "ba-audiorecorder-controlbar.stop": "&#x505C;&#x6B62;",
                  "ba-audiorecorder-controlbar.stop-tooltip": "&#x9EDE;&#x64CA;&#x6B64;&#x8655;&#x505C;&#x6B62;&#x3002;",
                  "ba-audiorecorder-controlbar.stop-available-after": "&#x6700;&#x77ED;&#x9304;&#x88FD;&#x6642;&#x9593;&#x70BA;%d&#x79D2;",
                  "ba-audiorecorder-controlbar.cancel": "&#x53D6;&#x6D88;",
                  "ba-audiorecorder-controlbar.cancel-tooltip": "&#x9EDE;&#x64CA;&#x9019;&#x88E1;&#x53D6;&#x6D88;&#x3002;",
                  "ba-videoplayer-controlbar.player-speed": "&#x7403;&#x54E1;&#x901F;&#x5EA6;",
                  "ba-videoplayer-controlbar.settings": "&#x8A2D;&#x7F6E;",
                  "ba-videoplayer-controlbar.airplay": "&#x7684;Airplay",
                  "ba-videoplayer-controlbar.airplay-icon": "Airplay&#x5716;&#x6A19;&#x3002;",
                  "ba-videoplayer.all-settings": "&#x6240;&#x6709;&#x8A2D;&#x7F6E;",
                  "ba-videoplayer.player-speed": "&#x7403;&#x54E1;&#x901F;&#x5EA6;",
                  "ba-videoplayer.full-screen": "&#x5168;&#x5C4F;",
                  "ba-videorecorder-controlbar.add-stream": "&#x6DFB;&#x52A0;&#x6D41;",
                  "ba-videorecorder.switch-camera": "&#x5207;&#x63DB;&#x76F8;&#x6A5F;",
                  "ba-videorecorder.prepare-covershot": "&#x6E96;&#x5099;&#x7832;&#x5F48;",
                  "ba-videorecorder.prepare-thumbnails": "&#x6E96;&#x5099;&#x5C0B;&#x627E;&#x7E2E;&#x7565;&#x5716;",
                  "ba-videorecorder.adding-new-stream": "&#x6DFB;&#x52A0;&#x65B0;&#x6D41;",
                  "ba-imagecapture.recorder-error": "&#x767C;&#x751F;&#x4E86;&#x4E00;&#x500B;&#x932F;&#x8AA4;&#x3002;&#x8ACB;&#x7A0D;&#x5F8C;&#x91CD;&#x8A66;&#x3002;&#x9EDE;&#x64CA;&#x91CD;&#x8A66;&#x3002;",
                  "ba-imagecapture.attach-error": "&#x6211;&#x5011;&#x7121;&#x6CD5;&#x8A2A;&#x554F;&#x5A92;&#x9AD4;&#x754C;&#x9762;&#x3002;&#x60A8;&#x53EF;&#x80FD;&#x9700;&#x8981;&#x5B89;&#x88DD;Flash&#x6216;&#x901A;&#x904E;SSL&#x8A2A;&#x554F;&#x8A72;&#x9801;&#x9762;&#xFF0C;&#x5177;&#x9AD4;&#x53D6;&#x6C7A;&#x65BC;&#x8A2D;&#x5099;&#x548C;&#x700F;&#x89BD;&#x5668;&#x3002;",
                  "ba-imagecapture.software-required": "&#x8ACB;&#x55AE;&#x64CA;&#x4E0B;&#x65B9;&#x4EE5;&#x5B89;&#x88DD;/&#x6FC0;&#x6D3B;&#x4EE5;&#x4E0B;&#x8981;&#x6C42;&#x4EE5;&#x7E7C;&#x7E8C;&#x3002;",
                  "ba-imagecapture.software-waiting": "&#x7B49;&#x5F85;&#x5B89;&#x88DD;/&#x6FC0;&#x6D3B;&#x8981;&#x6C42;&#x3002;&#x60A8;&#x53EF;&#x80FD;&#x9700;&#x8981;&#x5728;&#x5B8C;&#x6210;&#x5F8C;&#x5237;&#x65B0;&#x9801;&#x9762;&#x3002;",
                  "ba-imagecapture.access-forbidden": "&#x7981;&#x6B62;&#x8A2A;&#x554F;&#x5A92;&#x9AD4;&#x3002;&#x9EDE;&#x64CA;&#x91CD;&#x8A66;&#x3002;",
                  "ba-imagecapture.uploading": "&#x4E0A;&#x50B3;",
                  "ba-imagecapture.uploading-failed": "&#x4E0A;&#x50B3;&#x5931;&#x6557; - &#x9EDE;&#x64CA;&#x6B64;&#x8655;&#x91CD;&#x8A66;&#x3002;",
                  "ba-imagecapture.upload-error-duration": "&#x4E0A;&#x50B3;&#x5716;&#x7247;&#x7684;&#x9577;&#x5EA6;&#x4E0D;&#x7B26;&#x5408;&#x8981;&#x6C42; - &#x9EDE;&#x64CA;&#x6B64;&#x8655;&#x91CD;&#x8A66;&#x3002;",
                  "ba-imagecapture.resolution-constraint-error": "&#x60A8;&#x9078;&#x64C7;&#x7684;&#x6587;&#x4EF6;&#x8207;&#x6240;&#x9700;&#x7684;&#x5206;&#x8FA8;&#x7387;&#x4E0D;&#x5339;&#x914D; - &#x9EDE;&#x64CA;&#x6B64;&#x8655;&#x91CD;&#x8A66;&#x3002;",
                  "ba-imagecapture.verifying": "&#x9A57;&#x8B49;",
                  "ba-imagecapture.verifying-failed": "&#x9A57;&#x8B49;&#x5931;&#x6557; - &#x55AE;&#x64CA;&#x6B64;&#x8655;&#x91CD;&#x8A66;&#x3002;",
                  "ba-imagecapture.rerecord-confirm": "&#x4F60;&#x771F;&#x7684;&#x60F3;&#x91CD;&#x62CD;&#x4F60;&#x7684;&#x5F62;&#x8C61;&#x55CE;&#xFF1F;",
                  "ba-imagecapture.image_file_too_large": "&#x60A8;&#x7684;&#x5716;&#x7247;&#x6587;&#x4EF6;&#x592A;&#x5927;&#xFF08;%s&#xFF09; - &#x9EDE;&#x64CA;&#x6B64;&#x8655;&#x518D;&#x6B21;&#x5617;&#x8A66;&#x4F7F;&#x7528;&#x8F03;&#x5C0F;&#x7684;&#x5716;&#x7247;&#x6587;&#x4EF6;&#x3002;",
                  "ba-imagecapture.unsupported_image_type": "&#x8ACB;&#x4E0A;&#x50B3;&#xFF1A;%s  - &#x9EDE;&#x64CA;&#x6B64;&#x8655;&#x91CD;&#x8A66;&#x3002;",
                  "ba-imagecapture.orientation-portrait-required": "&#x8ACB;&#x65CB;&#x8F49;&#x8A2D;&#x5099;&#x4EE5;&#x7E31;&#x5411;&#x6A21;&#x5F0F;&#x9304;&#x88FD;&#x3002;",
                  "ba-imagecapture.orientation-landscape-required": "&#x8ACB;&#x65CB;&#x8F49;&#x60A8;&#x7684;&#x8A2D;&#x5099;&#x4EE5;&#x6A6B;&#x5411;&#x6A21;&#x5F0F;&#x9304;&#x88FD;&#x3002;",
                  "ba-audiorecorder.recorder-error": "&#x767C;&#x751F;&#x4E86;&#x4E00;&#x500B;&#x932F;&#x8AA4;&#x3002;&#x8ACB;&#x7A0D;&#x5F8C;&#x91CD;&#x8A66;&#x3002;&#x9EDE;&#x64CA;&#x91CD;&#x8A66;&#x3002;",
                  "ba-audiorecorder.attach-error": "&#x6211;&#x5011;&#x7121;&#x6CD5;&#x8A2A;&#x554F;&#x5A92;&#x9AD4;&#x754C;&#x9762;&#x3002;&#x60A8;&#x53EF;&#x80FD;&#x9700;&#x8981;&#x5B89;&#x88DD;Flash&#x6216;&#x901A;&#x904E;SSL&#x8A2A;&#x554F;&#x8A72;&#x9801;&#x9762;&#xFF0C;&#x5177;&#x9AD4;&#x53D6;&#x6C7A;&#x65BC;&#x8A2D;&#x5099;&#x548C;&#x700F;&#x89BD;&#x5668;&#x3002;",
                  "ba-audiorecorder.software-required": "&#x8ACB;&#x55AE;&#x64CA;&#x4E0B;&#x65B9;&#x4EE5;&#x5B89;&#x88DD;/&#x6FC0;&#x6D3B;&#x4EE5;&#x4E0B;&#x8981;&#x6C42;&#x4EE5;&#x7E7C;&#x7E8C;&#x3002;",
                  "ba-audiorecorder.software-waiting": "&#x7B49;&#x5F85;&#x5B89;&#x88DD;/&#x6FC0;&#x6D3B;&#x8981;&#x6C42;&#x3002;&#x60A8;&#x53EF;&#x80FD;&#x9700;&#x8981;&#x5728;&#x5B8C;&#x6210;&#x5F8C;&#x5237;&#x65B0;&#x9801;&#x9762;&#x3002;",
                  "ba-audiorecorder.access-forbidden": "&#x7981;&#x6B62;&#x8A2A;&#x554F;&#x5A92;&#x9AD4;&#x3002;&#x9EDE;&#x64CA;&#x91CD;&#x8A66;&#x3002;",
                  "ba-audiorecorder.uploading": "&#x4E0A;&#x50B3;",
                  "ba-audiorecorder.uploading-failed": "&#x4E0A;&#x50B3;&#x5931;&#x6557; - &#x9EDE;&#x64CA;&#x6B64;&#x8655;&#x91CD;&#x8A66;&#x3002;",
                  "ba-audiorecorder.upload-error-duration": "&#x4E0A;&#x50B3;&#x7684;&#x97F3;&#x983B;&#x9577;&#x5EA6;&#x4E0D;&#x7B26;&#x5408;&#x8981;&#x6C42; - &#x9EDE;&#x64CA;&#x6B64;&#x8655;&#x91CD;&#x8A66;&#x3002;",
                  "ba-audiorecorder.verifying": "&#x9A57;&#x8B49;",
                  "ba-audiorecorder.verifying-failed": "&#x9A57;&#x8B49;&#x5931;&#x6557; - &#x55AE;&#x64CA;&#x6B64;&#x8655;&#x91CD;&#x8A66;&#x3002;",
                  "ba-audiorecorder.rerecord-confirm": "&#x4F60;&#x771F;&#x7684;&#x60F3;&#x8981;&#x91CD;&#x505A;&#x4F60;&#x7684;&#x97F3;&#x983B;&#x55CE;&#xFF1F;",
                  "ba-audiorecorder.cancel-confirm": "&#x4F60;&#x771F;&#x7684;&#x60F3;&#x53D6;&#x6D88;&#x97F3;&#x983B;&#x4E0A;&#x50B3;&#x55CE;&#xFF1F;",
                  "ba-audiorecorder.audio_file_too_large": "&#x60A8;&#x7684;&#x97F3;&#x983B;&#x6587;&#x4EF6;&#x592A;&#x5927;&#xFF08;%s&#xFF09; - &#x9EDE;&#x64CA;&#x6B64;&#x8655;&#x518D;&#x6B21;&#x5617;&#x8A66;&#x4F7F;&#x7528;&#x8F03;&#x5C0F;&#x7684;&#x97F3;&#x983B;&#x6587;&#x4EF6;&#x3002;",
                  "ba-audiorecorder.unsupported_audio_type": "&#x8ACB;&#x4E0A;&#x50B3;&#xFF1A;%s  - &#x9EDE;&#x64CA;&#x6B64;&#x8655;&#x91CD;&#x8A66;&#x3002;",
                  "ba-common-settingsmenu.tooltip": "&#x9EDE;&#x64CA;&#x64AD;&#x653E;&#x3002;",
                  "ba-common-settingsmenu.setting-menu": "&#x6240;&#x6709;&#x8A2D;&#x5B9A;",
                  "ba-common-settingsmenu.source-quality": "&#x6E90;&#x8CEA;&#x91CF;",
                  "ba-common-settingsmenu.player-speed": "&#x64AD;&#x653E;&#x901F;&#x5EA6;",
                  "ba-common-settingsmenu.set-menu-option": "&#x8A2D;&#x5B9A;&#x9078;&#x9805;",
                  "ba-common-settingsmenu.submit-video": "&#x78BA;&#x8A8D;&#x5F71;&#x7247;",
                  "ba-common-settingsmenu.picture-in-picture": "&#x756B;&#x4E2D;&#x756B;",
                  "ba-common-settingsmenu.exit-fullscreen-video": "&#x9000;&#x51FA;&#x5168;&#x5C4F;",
                  "ba-common-settingsmenu.fullscreen-video": "&#x9032;&#x5165;&#x5168;&#x5C4F;",
                  "ba-videorecorder-chooser.multi-stream": "&#x591A;&#x6D41;",
                  "ba-videorecorder-controlbar.pause-recorder": "&#x66AB;&#x505C;&#x8A18;&#x9304;&#x5668;",
                  "ba-videorecorder-controlbar.resume-recorder": "&#x7C21;&#x6B77;&#x8A18;&#x9304;&#x5668;",
                  "ba-videorecorder.missing-track": "&#x7F3A;&#x5C11;&#x5FC5;&#x9700;&#x7684;&#x97F3;&#x983B;&#x6216;&#x8996;&#x983B;&#x8ECC;&#x9053;",
                  "ba-videorecorder.device-already-in-use": "&#x60A8;&#x7684;&#x81F3;&#x5C11;&#x4E00;&#x500B;&#x8F38;&#x5165;&#x8A2D;&#x5099;&#x5DF2;&#x5728;&#x4F7F;&#x7528;&#x4E2D;",
                  "ba-videorecorder.browser-permission-denied": "&#x700F;&#x89BD;&#x5668;&#x62D2;&#x7D55;&#x6B64;&#x6B0A;&#x9650;&#xFF0C;&#x8ACB;&#x6388;&#x4E88;&#x8A2A;&#x554F;&#x6B0A;&#x9650;&#x4E26;&#x91CD;&#x65B0;&#x52A0;&#x8F09;&#x9801;&#x9762;",
                  "ba-audioplayer.all-settings": "&#x6240;&#x6709;&#x8A2D;&#x5B9A;",
                  "ba-videoplayer-controlbar.remaining-time": "&#x5269;&#x9918;&#x6642;&#x9593;",
                  "ba-videoplayer-controlbar.select-frame": "&#x9078;&#x64C7;",
                  "ba-videoplayer-controlbar.trim-video": "&#x4FEE;&#x526A;",
                  "ba-videoplayer-playbutton.trim": "&#x4FEE;&#x526A;",
                  "ba-videoplayer-playbutton.skip": "&#x8DF3;&#x904E;",
                  "ba-videorecorder-imagegallery.upload-covershot": "&#x4E0A;&#x50B3;&#x5C01;&#x9762;",
                  "ba-videorecorder.pick-covershot-frame": "&#x9078;&#x64C7;&#x8981;&#x7528;&#x4F5C;&#x63A9;&#x8B77;&#x7684;&#x5E40;&#x3002;",
                  "ba-videorecorder.screen-recorder-is-not-supported": "&#x6B64;&#x8A2D;&#x5099;&#x4E0D;&#x652F;&#x6301;&#x5C4F;&#x5E55;&#x9304;&#x50CF;&#x6A5F;",
                  "ba-videorecorder.trim-prompt": "&#x4F60;&#x60F3;&#x4FEE;&#x526A;&#x4F60;&#x7684;&#x8996;&#x983B;&#x55CE;&#xFF1F;",
                  "ba-videorecorder.trim-video": "&#x79FB;&#x52D5;&#x958B;&#x59CB;&#x548C;&#x7D50;&#x675F;&#x6A19;&#x8A18;&#x4EE5;&#x4FEE;&#x526A;&#x8996;&#x983B;",
                  "ba-videorecorder.wait-for-trim": "&#x7B49;&#x5F85;&#x4FEE;&#x526A;&#x547D;&#x4EE4;...",
                  "ba-videorecorder-controlbar.no-video-source": "&#x7F3A;&#x5C11;&#x984D;&#x5916;&#x7684;&#x8996;&#x983B;&#x8F38;&#x5165;&#x6E90;",
                  "ba-videorecorder-controlbar.stream-already-selected": "&#x5DF2;&#x9078;&#x64C7;&#x9644;&#x52A0;&#x6D41;",
                  "ba-videorecorder.uploading-src-error": "&#x73FE;&#x5728;&#x7121;&#x6CD5;&#x64AD;&#x653E;&#x8996;&#x983B;&#xFF0C;&#x4E0A;&#x50B3;&#x4ECD;&#x5728;&#x9032;&#x884C;&#x4E2D;",
                  "ba-audiorecorder-controlbar.pause-recorder": "&#x66AB;&#x505C;&#x9304;&#x97F3;&#x6A5F;",
                  "ba-audiorecorder-controlbar.resume-recorder": "&#x7C21;&#x6B77;&#x8A18;&#x9304;&#x5668;"
                }
              };
              for (var i in t) e.strings.register(t[i], [i]);
              return {};
            }), Scoped.define("module:AudioVisualization", ["base:Class", "base:Maths", "browser:Dom", "browser:Info"], function (t, o, i, r, a) {
              return t.extend({
                scoped: a
              }, function (r) {
                return {
                  constructor: function constructor(e, t) {
                    var i;
                    r.constructor.call(this), this.stream = e, this.recorder = null, this.theme = t.theme, t.recorder ? this.recorder = t.recorder : (i = window.AudioContext || window.webkitAudioContext, this.audioContext = new i()), this.createVisualizationCanvas(t.height, t.element), this.frameID = null;
                  },
                  createVisualizationCanvas: function createVisualizationCanvas(e, t) {
                    var i = e || 120,
                      r = t.firstElementChild || t.firstChild;
                    r.style.minHeight = i + "px", this.canvas = r.querySelector("canvas"), this.canvas.style.display = "block", this.canvas.width = parseFloat(window.getComputedStyle(r).width), this.canvas.height = i, this.canvasContext = this.canvas.getContext("2d");
                  },
                  _clearCanvas: function _clearCanvas() {
                    this.canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
                  },
                  initializeVisualEffect: function initializeVisualEffect() {
                    try {
                      var t;
                      this.recorder && (this._analyser = this.recorder._analyser, this.analyser = this._analyser._analyserNode, this.audioContext = this._analyser._audioContext, this.analyser.fftSize = 256), this.audioContext || this.stream ? ("suspended" === this.audioContext.state && i.userInteraction(function () {
                        this.audioContext.resume();
                      }, this), this.stream instanceof HTMLElement && (t = this.audioContext.createMediaElementSource(this.stream), this.analyser = this.audioContext.createAnalyser(), t.connect(this.analyser), this.analyser.fftSize = 256, this.analyser.connect(this.audioContext.destination)), this.bufferLength = this.analyser.frequencyBinCount, this.dataArray = new Uint8Array(this.analyser.frequencyBinCount), this.canvasWidth = this.canvas.width, this.canvasHeight = this.canvas.height, this.barWidth = this.canvasWidth / this.bufferLength * 2.5, this.barHeight = 0, this.x = 0, window.requestAnimationFrame || (window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (e, t) {
                        window.setTimeout(e, 1e3 / 60);
                      }, window.cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame || function (e) {
                        clearTimeout(e);
                      })) : console.warn("Seems there is limitation by browser to create AudioContext instance");
                    } catch (e) {
                      console.warn("Web Audio API not supported", e);
                    }
                  },
                  start: function start() {
                    this._renderFrame();
                  },
                  pause: function pause() {
                    this._cancelFrame();
                  },
                  stop: function stop() {
                    this._cancelFrame(), this._clearCanvas();
                  },
                  destroy: function destroy() {
                    this.canvas && this.canvas.remove(), r.destroy.call(this);
                  },
                  _renderFrame: function _renderFrame() {
                    switch (this.frameID = requestAnimationFrame(function () {
                      this._renderFrame();
                    }.bind(this)), this.analyser.getByteFrequencyData(this.dataArray), this.theme) {
                      case "red-bars":
                        this._drawRedBars();
                        break;
                      default:
                        this._drawBigBalloon();
                    }
                  },
                  _cancelFrame: function _cancelFrame() {
                    cancelAnimationFrame(this.frameID);
                  },
                  updateSourceStream: function updateSourceStream() {
                    this._cancelFrame(), this.initializeVisualEffect();
                  },
                  _drawRedBars: function _drawRedBars() {
                    this.x = 0, this.canvasContext.fillStyle = "#000", this.canvasContext.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
                    for (var e = 0; e < this.bufferLength; e++) {
                      this.barHeight = this.dataArray[e] / 2;
                      var t = this.barHeight + e / this.bufferLength * 25,
                        i = e / this.bufferLength * 250;
                      this.canvasContext.fillStyle = "rgb(" + t + "," + i + ",50)", this.canvasContext.fillRect(this.x, this.canvasHeight - this.barHeight, this.barWidth, this.barHeight), this.x += this.barWidth + 1;
                    }
                  },
                  _drawBigBalloon: function _drawBigBalloon() {
                    this.__canvasBackground(235), this.canvasContext.fillStyle = "#000";
                    var e = this.__getRMS();
                    this.canvasContext.fillStyle = this.__rgb(2 * e), this.__HfillEllipse(this.canvasWidth / 2, this.canvasHeight / 2, 5 * e, 5 * e);
                  },
                  __getRMS: function __getRMS() {
                    for (var e = 0, t = 0; t < this.bufferLength; t++) e += this.dataArray[t] * this.dataArray[t];
                    return e /= this.dataArray.length, e = Math.sqrt(e);
                  },
                  __canvasBackground: function __canvasBackground(e, t, i, r) {
                    this.canvasContext.fillStyle = void 0 === t ? this.__rgb(e, e, e) : void 0 === i && void 0 === r ? rgba(e, e, e, t) : void 0 === r ? this.__rgb(e, t, i) : this.__rgba(e, t, i, r), this.canvasContext.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
                  },
                  __HfillEllipse: function __HfillEllipse(e, t, i, r) {
                    void 0 === r && (r = i), this.__Hellipse(e, t, i, r), this.canvasContext.fill(), this.canvasContext.beginPath();
                  },
                  __Hellipse: function __Hellipse(e, t, i, r) {
                    "use strict";

                    void 0 === r && (r = i), this.canvasContext.beginPath();
                    for (var o = 0; o < 2 * Math.PI; o += Math.PI / 64) this.canvasContext.lineTo(e + Math.cos(o) * i / 2, t + Math.sin(o) * r / 2);
                    this.canvasContext.closePath();
                  },
                  __rgb: function __rgb(e, t, i) {
                    return void 0 === t && (t = e), void 0 === i && (i = e), "rgb(" + o.clamp(Math.round(e), 0, 255) + ", " + o.clamp(Math.round(t), 0, 255) + ", " + o.clamp(Math.round(i), 0, 255) + ")";
                  },
                  __rgba: function __rgba(e, t, i, r) {
                    return void 0 === t ? "rgb(" + o.clamp(Math.round(e), 0, 255) + ", " + o.clamp(Math.round(e), 0, 255) + ", " + o.clamp(Math.round(e), 0, 255) + ")" : void 0 === i ? "rgba(" + o.clamp(Math.round(e), 0, 255) + ", " + o.clamp(Math.round(e), 0, 255) + ", " + o.clamp(Math.round(e), 0, 255) + ", " + o.clamp(t, 0, 1) + ")" : void 0 === r ? "rgba(" + o.clamp(Math.round(e), 0, 255) + ", " + o.clamp(Math.round(t), 0, 255) + ", " + o.clamp(Math.round(i), 0, 255) + ", 1)" : "rgba(" + o.clamp(Math.round(e), 0, 255) + ", " + o.clamp(Math.round(t), 0, 255) + ", " + o.clamp(Math.round(i), 0, 255) + ", " + o.clamp(r, 0, 1) + ")";
                  }
                };
              }, {
                supported: function supported() {
                  return !(!window.AudioContext && !window.webkitAudioContext);
                }
              });
            }), Scoped.define("module:Common.Dynamics.Helperframe", ["dynamics:Dynamic", "base:Async", "base:Timers.Timer", "base:Objs", "browser:Events", "browser:Geometry", "browser:Info"], function (e, r, o, a, n, i, s, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  attrs: {
                    css: "ba-videorecorder",
                    framereversable: !0,
                    framedragable: !0,
                    frameresizeable: !1,
                    framepositionx: 5,
                    framepositiony: 5,
                    frameminwidth: 120,
                    frameminheight: 95,
                    initialpositionx: null,
                    initialpositiony: null,
                    initialwidth: null,
                    initialheight: null,
                    flipframe: !1,
                    frameproportional: !0,
                    framemainstyle: {
                      opacity: .5,
                      position: "absolute",
                      cursor: "pointer",
                      zIndex: 100
                    }
                  },
                  types: {
                    framereversable: "boolean",
                    framedragable: "boolean",
                    frameresizeable: "boolean",
                    frameproportional: "boolean",
                    framepositionx: "int",
                    framepositiony: "int",
                    frameminwidth: "int",
                    frameminheight: "int"
                  },
                  computed: {},
                  events: {
                    "change:framepositionx change:framepositiony change:framewidth change:frameheight": function changeFramepositionxChangeFramepositionyChangeFramewidthChangeFrameheight(e) {
                      "undefined" != typeof this.recorder && ("object" == typeof this.recorder._recorder && this.__visibleDimensions.accessible ? this.recorder._recorder.updateMultiStreamPosition(this.get("framepositionx"), this.get("framepositiony"), this.get("framewidth"), this.get("frameheight")) : this.recorder = this.__parent.recorder);
                    }
                  },
                  create: function create() {
                    var e,
                      t,
                      i = 0;
                    this.__parent = this.parent(), this.__initialSettings = {
                      reversable: this.get("framereversable"),
                      dragable: this.get("framedragable"),
                      resizeable: this.get("frameresizeable")
                    }, a.iter(this.get("framemainstyle"), function (e, t) {
                      this.activeElement().style[t] = e;
                    }, this), this.get("initialpositionx") && this.get("initialpositiony") || (this.set("initialpositionx", this.get("framepositionx")), this.set("initialpositiony", this.get("framepositiony"))), e = s.isTouchable() && !s.isDesktop() ? "touch" : "click", this._frameInteractionEventHandler = this.auto_destroy(new n()), this.recorder = this.__parent.recorder, this.player = this.__parent.player, this.__visibleDimensions = {}, this.__setHelperFrameDimensions(), this.__visibleDimensions.accessible || (t = new o({
                      context: this,
                      fire: function fire() {
                        this.recorder._recorder._videoTrackSettings && "object" == typeof this.recorder._recorder._videoTrackSettings.videoElement && t && (this.set("framewidth", this.__parent.get("addstreampositionwidth")), this.set("frameheight", this.__parent.get("addstreampositionheight")), this.get("initialwidth") && this.get("initialheight") || (this.set("initialwidth", this.get("framewidth")), this.set("initialheight", this.get("frameheight"))), this.fitFrameViewOnScreenVideo(), t.stop());
                      },
                      delay: 10,
                      destroy_on_stop: !0,
                      immediate: !0
                    })), this.recorder ? (this.recorder._recorder.on("multistream-camera-switched", function (e, t) {
                      this.__initialSettings.resizeable && this.__resizerElement && (this.set("frameresizeable", t), this.__resizerElement.style.display = t ? "none" : "block"), this.set("framewidth", e.width), this.set("frameheight", e.height);
                    }, this), this.get("framereversable") && this._frameInteractionEventHandler.on(this.activeElement(), e, function (e) {
                      1 === ++i && r.eventually(function () {
                        i = 0;
                      }, this, 400), 2 <= i && this.recorder.reverseCameraScreens();
                    }, this), this.get("framedragable") && this.addDragOption(this.__parent.activeElement()), this.get("frameresizeable") && this.addResize(s.isTouchable() && !s.isDesktop(), null, {
                      width: "7px",
                      height: "7px",
                      borderRight: "1px solid white",
                      borderBottom: "1px solid white",
                      bottom: 0,
                      right: 0,
                      position: "absolute",
                      cursor: "nwse-resize",
                      zIndex: 200
                    })) : this.player;
                  },
                  functions: {},
                  fitFrameViewOnScreenVideo: function fitFrameViewOnScreenVideo() {
                    var e,
                      t = this.recorder._recorder._videoTrackSettings;
                    t && (e = this.__parent.get("height") ? t.videoElement.height : t.videoInnerFrame.height, this.__vts || (this.__vts = t), this.__translate = i.padFitBoxInBox(t.width, t.height, t.videoElement.width, e), this.__resizing || (this.__visibleDimensions.x = this.__translate.offsetX + this.get("framepositionx") * this.__translate.scale, this.__visibleDimensions.y = this.__translate.offsetY + this.get("framepositiony") * this.__translate.scale), this.__visibleDimensions.width = this.get("framewidth") * this.__translate.scale, this.__visibleDimensions.height = this.get("frameheight") * this.__translate.scale, this.__visibleDimensions.accessible = !0, this.__dragging || this.__resizing || (this.__positions = {
                      initialX: this.__visibleDimensions.x,
                      initialY: this.__visibleDimensions.y,
                      currentX: this.__visibleDimensions.x,
                      currentY: this.__visibleDimensions.y,
                      bottomX: this.__visibleDimensions.x + this.__visibleDimensions.width,
                      bottomY: this.__visibleDimensions.y + this.__visibleDimensions.height,
                      xOffset: 0,
                      yOffset: 0
                    }), this.__setHelperFrameDimensions());
                  },
                  addDragOption: function addDragOption(e) {
                    this._draggingEvent = this.auto_destroy(new n());
                    var t = s.isTouchable() && !s.isDesktop(),
                      i = t ? "touchend" : "mouseup",
                      r = t ? "touchmove" : "mousemove",
                      o = t ? "touchstart" : "mousedown";
                    this._draggingEvent.on(e, i, this.__handleMouseEndEvent, this), this._draggingEvent.on(e, r, this.__handleMouseMoveEvent, this), this._draggingEvent.on(e, o, this.__handleMouseStartEvent, this);
                  },
                  addResize: function addResize(e, t, i) {
                    t = t || this.activeElement(), this.__resizerElement = document.createElement("div"), a.iter(i, function (e, t) {
                      this.__resizerElement.style[t] = e;
                    }, this), t.append(this.__resizerElement), this.__resizeEvent = this.auto_destroy(new n());
                  },
                  __handleMouseStartEvent: function __handleMouseStartEvent(e) {
                    e.preventDefault(), "undefined" != typeof this.__visibleDimensions.accessible ? (this.__dragging = e.target === this.activeElement(), this.__resizing = e.target === this.__resizerElement, "object" == typeof this.__positions && ("touchstart" === e.type ? (this.__positions.initialX = e.touches[0].clientX - this.__positions.xOffset, this.__positions.initialY = e.touches[0].clientY - this.__positions.yOffset) : (this.__dragging && (this.__positions.initialX = e.clientX - this.__positions.xOffset, this.__positions.initialY = e.clientY - this.__positions.yOffset), this.__positions.bottomX = this.__positions.initialX + this.__visibleDimensions.width, this.__positions.bottomY = this.__positions.initialY + this.__visibleDimensions.height))) : this.fitFrameViewOnScreenVideo();
                  },
                  __handleMouseMoveEvent: function __handleMouseMoveEvent(e) {
                    var t, i, r, o, a, n, s, x, c, d;
                    e.preventDefault(), (this.__dragging || this.__resizing) && (this.activeElement().style.cursor = "move", this.activeElement().style.opacity = "0", "touchmove" === e.type ? (this.__positions.currentX = e.touches[0].clientX - this.__positions.initialX, this.__positions.currentY = e.touches[0].clientY - this.__positions.initialY) : (this.__dragging && (this.__positions.currentX = e.clientX - this.__positions.initialX, this.__positions.currentY = e.clientY - this.__positions.initialY), this.__resizing && (t = e.clientX - this.__positions.bottomX, i = e.clientY - this.__positions.bottomY)), this.__dragging && (this.__positions.xOffset = this.__positions.currentX, this.__positions.yOffset = this.__positions.currentY, r = this.activeElement(), o = this.__positions.currentX, a = this.__positions.currentY, r.style.transform = "translate3d(" + o + "px, " + a + "px, 0)", this.set("framepositionx", this.__positions.currentX / this.__translate.scale + this.get("initialpositionx")), this.set("framepositiony", this.__positions.currentY / this.__translate.scale + this.get("initialpositiony"))), this.__resizing && (n = this.__visibleDimensions.width + t, s = this.get("frameproportional") ? n / this.__vts.aspectRatio : this.__visibleDimensions.height + i, this.__positions.bottomX = this.__positions.currentX + n, this.__positions.bottomY = this.__positions.currentY + s, this.set("framewidth", n / this.__translate.scale), this.set("frameheight", s / this.__translate.scale), this.fitFrameViewOnScreenVideo(), x = this.activeElement(), c = n, d = s, x.style.width = c, x.style.height = d));
                  },
                  __handleMouseEndEvent: function __handleMouseEndEvent(e) {
                    e.preventDefault(), (this.__dragging || this.__resizing) && (this.__resizing ? (this.__positions.bottomX = this.__positions.currentX + this.__visibleDimensions.width, this.__positions.bottomY = this.__positions.currentY + this.__visibleDimensions.height) : (this.__positions.initialX = this.__positions.currentX, this.__positions.initialY = this.__positions.currentY), this.activeElement().style.cursor = "pointer", this.activeElement().style.opacity = this.get("framemainstyle").opacity, this.__dragging = !1, this.__resizing = !1);
                  },
                  __setHelperFrameDimensions: function __setHelperFrameDimensions(e) {
                    (e = e || this.activeElement()) && (e.style.top = this.__visibleDimensions.y + "px", e.style.left = this.__visibleDimensions.x + "px", e.style.width = this.__visibleDimensions.width + "px", e.style.height = this.__visibleDimensions.height + "px");
                  }
                };
              }).register("ba-helperframe");
            }), Scoped.define("module:StickyHandler", ["base:Class", "base:Events.EventsMixin", "base:Maths", "browser:Events"], function (e, t, c, o, i) {
              return e.extend({
                scoped: i
              }, [t, function (r) {
                return {
                  constructor: function constructor(e, t, i) {
                    r.constructor.call(this), this.element = e, this.container = t, this.paused = i.paused || !1, this.events = this.auto_destroy(new o());
                  },
                  destroy: function destroy() {
                    this._elementObserver && this._elementObserver.disconnect(), this._containerObserver && this._containerObserver.disconnect(), r.destroy.call(this);
                  },
                  init: function init() {
                    this._initIntersectionObservers();
                  },
                  pause: function pause() {
                    this.paused = !0;
                  },
                  start: function start() {
                    this.paused = !1;
                  },
                  isDragging: function isDragging() {
                    return !!this.dragging;
                  },
                  stopDragging: function stopDragging() {
                    this.dragging = !1;
                  },
                  elementWasDragged: function elementWasDragged() {
                    return !!this.__elementWasDragged;
                  },
                  _initIntersectionObservers: function _initIntersectionObservers() {
                    var i = !0,
                      r = !0;
                    this._elementObserver = new IntersectionObserver(function (e, t) {
                      e.forEach(function (e) {
                        i ? i = !1 : e.isIntersecting || this.paused || (this.trigger("elementLeftView"), this._top && (this.element.style.top = this._top), this._left && (this.element.style.left = this._left), this._initEventListeners());
                      }.bind(this));
                    }.bind(this)), this._containerObserver = new IntersectionObserver(function (e, t) {
                      e.forEach(function (e) {
                        r ? r = !1 : e.isIntersecting && (this.trigger("containerEnteredView"), this.element.style.removeProperty("top"), this.element.style.removeProperty("left"), this.events.off(this.element, "mousedown touchstart"), this.dragging = !1);
                      }.bind(this));
                    }.bind(this)), this._elementObserver.observe(this.element), this._containerObserver.observe(this.container);
                  },
                  _initEventListeners: function _initEventListeners() {
                    var t, i, r, o;
                    function a(e) {
                      (e = e || window.event).preventDefault(), r = t - e.clientX, o = i - e.clientY, t = e.clientX, i = e.clientY, this.__elementWasDragged = !0, this.dragging = !0, this.element.style.top = c.clamp(this.element.offsetTop - o, 0, window.innerHeight - this.element.offsetHeight) + "px", this.element.style.left = c.clamp(this.element.offsetLeft - r, 0, window.innerWidth - this.element.offsetWidth) + "px", this._top = this.element.style.getPropertyValue("top"), this._left = this.element.style.getPropertyValue("left");
                    }
                    function n(e) {
                      (e = e || window.event).preventDefault(), r = t - e.touches[0].clientX, o = i - e.touches[0].clientY, t = e.touches[0].clientX, i = e.touches[0].clientY, this.__elementWasDragged = !0, this.dragging = !0, this.element.style.top = c.clamp(this.element.offsetTop - o, 0, window.innerHeight - this.element.offsetHeight) + "px", this.element.style.left = c.clamp(this.element.offsetLeft - r, 0, window.innerWidth - this.element.offsetWidth) + "px", this._top = this.element.style.getPropertyValue("top"), this._left = this.element.style.getPropertyValue("left");
                    }
                    function s() {
                      this.events.off(document, "mousemove mouseup");
                    }
                    function x() {
                      this.events.off(document, "touchmove touchend");
                    }
                    this.events.on(this.element, "mousedown", function (e) {
                      if ((e = e || window.event).preventDefault(), 0 !== e.button) return;
                      t = e.clientX, i = e.clientY, this.events.on(document, "mousemove", a, this), this.events.on(document, "mouseup", s, this);
                    }, this), this.events.on(this.element, "touchstart", function (e) {
                      (e = e || window.event).preventDefault(), t = e.touches[0].clientX, i = e.touches[0].clientY, this.events.on(document, "touchmove", n, this), this.events.on(document, "touchend", x, this);
                    }, this);
                  }
                };
              }]);
            }), Scoped.define("module:TrackTags", ["base:Class", "base:Objs", "base:Events.EventsMixin", "base:Async", "base:TimeFormat", "browser:Dom", "browser:Info", "browser:Events"], function (t, n, i, r, c, d, s, x, o) {
              return t.extend({
                scoped: o
              }, [i, function (t) {
                return {
                  constructor: function constructor(e, t) {
                    this._dyn = t, this._trackTags = t.get("tracktags"), this._video = t.__video, this._chapters = [], this._chapterLoadedTriggered = !1, this.hasThumbs = !1, t.set("tracktagssupport", this._trackTags && 0 < this._trackTags.length && "track" in document.createElement("track")), this._video && this._trackTags && 0 !== this._trackTags.length && (this._loadTrackTags(), t.get("tracktagsstyled") && this._setDefaultTrackOnPlay(), r.eventually(function () {
                      this._loadMetaTrackTags();
                    }, this));
                  },
                  showDurationThumb: function showDurationThumb(e, t, i) {
                    var r, o, a, n, s, x;
                    this._dyn.get("thumbcuelist")[e] && (r = this._dyn.get("thumbcuelist")[e], o = i || r.startTime + Math.round((r.startTime - r.endTime) / 2), n = (a = this.thumbContainer).querySelector("div"), s = a.querySelector("span"), x = t - Math.round(r.thumbWidth / 1.5) <= 0 ? 5 : t - Math.round(r.thumbWidth / 1.5), a.style.opacity = "0.85", a.style.left = x + "px", n.style.backgroundPositionX = "-" + r.positionX + "px", n.style.backgroundPositionY = "-" + r.positionY + "px", s.innerText = 0 < o ? c.format(c.ELAPSED_MINUTES_SECONDS, 1e3 * o) : "0:00");
                  },
                  hideDurationThumb: function hideDurationThumb() {
                    this.thumbContainer.style.opacity = "0.00";
                  },
                  _loadTrackTags: function _loadTrackTags() {
                    this._dyn.get("tracktagssupport") && n.iter(this._trackTags, function (t, i) {
                      var r = document.createElement("track"),
                        o = this.auto_destroy(new x());
                      try {
                        t.content && !t.src && (r.src = URL.createObjectURL(new Blob([t.content], {
                          type: "text/plain"
                        })));
                      } catch (e) {}
                      switch (t.kind) {
                        case "thumbnails":
                          r.id = this._dyn.get("css") + "-track-thumbnails", r.kind = "metadata", r.src || (r.src = t.src || null), r.mode = "hidden", this.__appendThumbnailTrackTags(t, i, r, o);
                          break;
                        case "chapters":
                          r.id = this._dyn.get("css") + "-track-chapters", r.kind = "chapters", r.src = t.src, r.mode = "hidden", this.__appendChaptersTrackTags(t, i, r, o);
                          break;
                        default:
                          r.id = this._dyn.get("css") + "-tack-" + i, r.kind = t.kind || "subtitles", r.label = t.label || "English", r.srclang = t.lang || "en", r.src || (r.src = t.src || null), this._dyn.set("hassubtitles", !0), this.__appendTextTrackTags(t, i, r, !0, o), 1 < this._trackTags.length && this._dyn.on("switch-track", function (e) {
                            this._dyn.set("tracktextvisible", !0), this._dyn.set("trackcuetext", null), this._setSelectedTag(e);
                          }, this);
                      }
                      this._video.appendChild(r);
                    }, this);
                  },
                  __appendTextTrackTags: function __appendTextTrackTags(e, t, i, r, o) {
                    e.enabled && r && (i.setAttribute("default", ""), this._dyn.set("tracktaglang", e.lang), this._dyn.set("tracktextvisible", !0)), i.setAttribute("data-selector", "track-tag"), o.on(i, "load", function () {
                      e.enabled && r ? (this.mode = "showing", this._video && (this._video.textTracks[t].mode = "showing"), r = !1) : (this.mode = "hidden", this._video && (this._video.textTracks[t].mode = "hidden"));
                    }, this);
                  },
                  __appendChaptersTrackTags: function __appendChaptersTrackTags(e, t, i, r) {
                    var o,
                      a,
                      n = this;
                    i.setAttribute("data-selector", "chapters-track-tag"), r.on(i, "load", function (e) {
                      this.hasChapters = !0, o = this.track, (a = o.cues) ? n.__generateChapters(a) : console.warn("Provided source for the chapters is not correct");
                    });
                  },
                  __appendThumbnailTrackTags: function __appendThumbnailTrackTags(e, t, i, r) {
                    var o,
                      a,
                      n,
                      s,
                      x,
                      c = this;
                    i.setAttribute("data-selector", "thumb-track-tag"), r.on(i, "load", function (e) {
                      (o = this.track).cues[0].text && (n = o.cues[0].text.split("#xywh="), x = n[0], s = o.cues[0].text.split("#xywh=")[1].split(","), (a = new Image()).src = x, r.on(a, "load", function () {
                        this.hasThumbs = !0;
                        var e = document.createElement("div"),
                          t = document.createElement("div"),
                          i = document.createElement("span");
                        d.elementAddClass(e, this._dyn.get("css") + "-seeking-thumb-container"), e.style.opacity = "0.00", t.style.height = +s[3] + "px", t.style.width = +s[2] + "px", t.style.backgroundImage = "url('" + x + "')", t.style.backgroundRepeat = "no-repeat", t.style.backgroundAttachment = "background-attachment", e.appendChild(t), e.appendChild(i), this._dyn.set("thumbimage", {
                          image: a,
                          url: a.src,
                          height: a.naturalHeight || a.height,
                          width: a.naturalWidth || a.width,
                          thumbWidth: Number(s[2]),
                          thumbHeight: Number(s[3])
                        }), this.thumbContainer = e, this.__generateThumbnails(o);
                      }, c));
                    });
                  },
                  __generateThumbnails: function __generateThumbnails(e) {
                    n.iter(e.cues, function (e, t) {
                      var i;
                      "object" == typeof e && (i = e.text.trim().split("#xywh=")[1].split(","), this.get("thumbcuelist").push({
                        startTime: e.startTime,
                        endTime: e.endTime,
                        positionX: i[0],
                        positionY: i[1],
                        thumbWidth: i[2],
                        thumbHeight: i[3]
                      }));
                    }, this._dyn);
                  },
                  __generateChapters: function __generateChapters(i) {
                    n.iter(i, function (e, t) {
                      "object" == typeof e && this._chapters.push({
                        index: t,
                        startTime: e.startTime,
                        endTime: e.endTime,
                        title: e.text
                      }), i.length !== this._chapters.length || this._chapterLoadedTriggered || (this._dyn.trigger("chaptercuesloaded", this._chapters, i.length), this._chapterLoadedTriggered = !0);
                    }, this);
                  },
                  _showTracksInCustomElement: function _showTracksInCustomElement(i, e) {
                    var r,
                      t = e || this._dyn.get("tracktaglang"),
                      o = this._dyn,
                      a = o.__video.currentTime;
                    i.language === t && (r = i.cues, n.iter(r, function (e, t) {
                      "object" == typeof r[t] && r[t] && (e.startTime < a && e.endTime > a && o.set("trackcuetext", e.text), e.onenter = function (e) {
                        i.mode = "hidden", o.get("tracktextvisible") && o.set("trackcuetext", this.text);
                      }, e.onexit = function (e) {
                        o.set("trackcuetext", null);
                      });
                    }, this));
                  },
                  _loadMetaTrackTags: function _loadMetaTrackTags() {
                    this._video && n.iter(this._video.textTracks, function (e, t) {
                      var i;
                      "object" == typeof this._video.textTracks[t] && this._video.textTracks[t] && ("metadata" === (i = this._video.textTracks[t]).kind && (i.mode = "hidden"), "chapters" === i.kind && (i.mode = "showing"));
                    }, this);
                  },
                  _setDefaultTrackOnPlay: function _setDefaultTrackOnPlay() {
                    this._dyn.player.once("playing", function () {
                      n.iter(this._trackTags, function (e, t) {
                        var i = this._video.textTracks[t];
                        "object" == typeof i && i && "showing" === i.mode && this._showTracksInCustomElement(i, i.language);
                      }, this);
                    }, this);
                  },
                  _setSelectedTag: function _setSelectedTag(i) {
                    var r = null,
                      o = null;
                    n.iter(this._video.textTracks, function (e, t) {
                      "object" == typeof (o = this._video.textTracks[t]) && o && (r = o.language === i.lang ? this._dyn.get("tracktagsstyled") ? "hidden" : "showing" : "disabled", this._dyn.get("tracktextvisible") || (r = "disabled"), o.mode = r, o.language === i.lang && this._triggerTrackChange(this._video, o, r, i.lang));
                    }, this);
                  },
                  _triggerTrackChange: function _triggerTrackChange(e, t, i, r) {
                    var o = e.querySelector("#" + t.id),
                      a = !0,
                      n = this.auto_destroy(new x());
                    t.oncuechange === undefined || (s.isInternetExplorer() || s.isEdge()) && this._dyn.get("tracktagsstyled") ? n(e, "timeupdate", function () {
                      i.length && (t.mode = i), this._dyn.get("tracktagsstyled") && this._showTracksInCustomElement(t, r);
                    }, this) : n.on(t, "cuechange", function () {
                      a && (i.length && (t.mode = i), this._dyn.get("tracktagsstyled") ? this._showTracksInCustomElement(t, r) : o && (o.mode = i), a = !1);
                    }, this);
                  }
                };
              }]);
            }), Scoped.define("module:StylesMixin", ["base:Objs"], function (t) {
              return {
                _applyStyles: function _applyStyles(i, r, e) {
                  t.iter(e, function (e, t) {
                    t in r || i.style.removeProperty(t);
                  }), t.extend(i.style, r);
                }
              };
            }), Scoped.define("module:Common.Dynamics.Settingsmenu", ["dynamics:Dynamic", "base:Objs", "base:Async", "base:Timers.Timer", "browser:Dom", "browser:Events", "module:Assets"], ["dynamics:Partials.ClickPartial", "dynamics:Partials.RepeatElementPartial"], function (Class, Objs, Async, Timer, Dom, DomEvents, Assets, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<div if="{{visiblesettings.length > 0}}" class="{{csscommon}}-settings-menu {{csstheme}}-settings-menu" role="settingsblock">\n    <div class="{{csscommon}}-settings-menu-overlay">\n        <div ba-if="{{root}}"\n             class="{{csscommon}}-settings-menu-item"\n             ba-repeat-element="{{setting :: visiblesettings}}"\n             title="{{string(setting.label)}}"\n             ba-click="{{select_setting(setting.id)}}"\n        >\n            <div class="{{csscommon}}-settings-menu-label" role="settingslabel">\n                {{string(setting.label) || setting.label}}\n            </div>\n\n            <div ba-if="{{setting.options}}" class="{{csscommon}}-settings-menu-value {{csscommon}}-setting-option-value"\n                 role="settingsvalue"\n            >\n                {{setting.value}}\n            </div>\n\n            <div ba-if="{{!setting.options}}" class="{{csscommon}}-settings-menu-value "\n                 role="settingicon"\n            >\n                <div ba-if="{{setting.showicon}}"\n                     style="{{setting.value ? setting.icontruestyle : setting.iconfalsestyle}}"\n                     class="{{csscommon}}-setting-menu-icon {{csscommon + (setting.value ? \'-setting-on\' : \'-setting-off\')}}">\n                    {{setting.value ? setting.trueicon : setting.falseicon}}\n                </div>\n            </div>\n\n        </div>\n\n        <div ba-if="{{!root}}">\n            <div class="{{csscommon}}-setting-menu-options-title {{csscommon}}-settings-menu-options-item"\n                 ba-click="{{show_root()}}"\n            > <div>{{ string(selected.label) || string(\'setting-menu\')}}</div></div>\n            <div\n                class="{{csscommon}}-settings-menu-options-item"\n                ba-repeat-element="{{option :: visiblesettings}}"\n                title="{{string(selected.label) || string(\'\')}}"\n                ba-click="{{select_value(option)}}"\n            >\n                <div>\n                    <i ba-if="{{option === selected.value}}" class="{{csscommon}}-icon-check"></i>\n                    {{option.label || option}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-common",
                    csscommon: "ba-commoncss",
                    cssplayer: "ba-player",
                    settings: [],
                    visiblesettings: [],
                    selected: null,
                    root: !0,
                    "default": {
                      value: !1,
                      label: "setting-item",
                      visible: !0,
                      mobileSupport: !0,
                      showicon: !0,
                      trueicon: "&#x2713;",
                      falseicon: "&#x2573;",
                      icontruestyle: "color: #5dbb96;",
                      iconfalsestyle: "color: #dd4b39"
                    },
                    predefined: {
                      player: [{
                        id: "playerspeeds",
                        label: "player-speed",
                        value: 1,
                        options: [.5, .75, 1, 1.25, 1.5, 1.75, 2],
                        func: function func(e, t) {
                          return "function" == typeof this.functions.set_speed && 0 < t ? (this.functions.set_speed.call(this, t), !0) : (console.error("Wrong argument or function provided"), !1);
                        }
                      }],
                      recorder: [{}]
                    }
                  },
                  computed: {
                    settings: function settings() {
                      var e = "object" != typeof this.__parent.recorder ? this.get("predefined").player : this.get("predefined").recorder;
                      return Objs.iter(e, function (e, t) {
                        !e.visible && "undefined" != typeof e.visible || this.addSetting(e);
                      }, this), this.get("settings");
                    }
                  },
                  events: {
                    "change:visiblesettings": function changeVisiblesettings(e) {
                      var t = Objs.peek(e);
                      "object" == typeof t && t ? (this.set("selected", null), t.hasOwnProperty("id") && this.set("root", !0)) : (this.set("root", !1), this._animateFade(!1, this.activeElement()));
                    }
                  },
                  functions: {
                    show_root: function show_root() {
                      this.switchToRoot();
                    },
                    select_setting: function select_setting(i) {
                      Objs.iter(this.get("settings"), function (e, t) {
                        e.id === i && this.build_setting(e, i);
                      }, this);
                    },
                    select_value: function select_value(e) {
                      this._setSettingWithMethod(e);
                    },
                    add_new_settings_item: function add_new_settings_item(e) {
                      this.addSetting(e);
                    },
                    update_new_settings_item: function update_new_settings_item(e, t) {
                      this.updateSetting(e, t);
                    },
                    remove_settings_item: function remove_settings_item(e) {
                      this.removeSetting(e);
                    }
                  },
                  create: function create() {
                    this.domEvents = this.auto_destroy(new DomEvents()), this.domEvents.on(document, "click touchstart", function (e) {
                      !this.activeElement().contains(e.target) && this.activeElement() && this.parent().set("settingsmenu_active", !1);
                    }, this);
                  },
                  build_setting: function build_setting(e, i) {
                    e && i ? 1 < Objs.count(e.options) ? (this.set("selected", e), this._buildChildMenu(e)) : Objs.iter(this.get("settings"), function (e, t) {
                      e.id === i && (e.value = !e.value, this.set("selected", e), this._setSettingWithMethod(!1, t));
                    }, this) : console.warn("At least on of the arguments are required");
                  },
                  switchToRoot: function switchToRoot() {
                    this.set("visiblesettings", this.get("settings"));
                  },
                  _buildChildMenu: function _buildChildMenu(e) {
                    this.set("selected", e), this.set("visiblesettings", e.options);
                  },
                  _setSettingWithMethod: function _setSettingWithMethod(i, e) {
                    "function" == typeof this.get("selected").func && "boolean" == typeof this.get("selected").func.call(this.__parent, this, i, e) && (this.get("selected").value = i || !this.get("selected").value, Objs.iter(this.get("settings"), function (e, t) {
                      this.get("selected") && e && this.get("selected").id === e.id && (i || (this.get("settings")[t].value = !this.get("settings")[t].value), this.get("settings")[t] = this.get("selected"), this.set("visiblesettings", []), this.set("visiblesettings", this.get("settings")));
                    }, this));
                  },
                  addSetting: function addSetting(t) {
                    "object" == typeof t ? (Objs.iter(this.get("settings"), function (e) {
                      e.id === t.id && this.removeSetting(e.id);
                    }, this), t.func && t.id ? "function" == typeof t.func ? this.mergeAndRebuildSettings(this.get("default"), t) : console.warn("Sorry func key has to be function type") : console.warn("Your added new setting missing mandatory `id`, `func` or `label` keys, please add them")) : console.warn("Sorry you should add new option as an Object");
                  },
                  updateSetting: function updateSetting(i, r) {
                    "object" == typeof r ? Objs.iter(this.get("settings"), function (e, t) {
                      e.id === i && (this.get("settings")[t] = Objs.tree_merge(this.get("settings")[t], r), this.set("visiblesettings", []), this.set("visiblesettings", this.get("settings")));
                    }, this) : console.warn("Sorry you should provide any new option as an Object");
                  },
                  removeSetting: function removeSetting(i) {
                    "string" == typeof i ? Objs.iter(this.get("settings"), function (e, t) {
                      e.id === i && (this.get("settings").splice(t), this.set("visiblesettings", []), this.set("visiblesettings", this.get("settings")));
                    }, this) : console.warn("Sorry you should provide setting ID");
                  },
                  mergeAndRebuildSettings: function mergeAndRebuildSettings(e, t) {
                    var i = Objs.tree_merge(e, t),
                      r = this.get("settings");
                    r.push(i), this.set("visiblesettings", []), this.set("visiblesettings", r), this.set("settings", r);
                  },
                  _animateFade: function _animateFade(e, t, i) {
                    var r, o, a, n;
                    i ? t.style.opacity = e ? "0" : "1" : (o = e ? 1 : 0, a = e ? -.1 : .1, n = e ? 0 : 1, t.style.opacity = o, r = this.auto_destroy(new Timer({
                      context: this,
                      fire: function fire() {
                        t.style.opacity = o, o += a, (e && o < n || !e && n < o) && (this.__animationInProcess = !1, r.destroy());
                      },
                      delay: 30,
                      immediate: !0
                    })));
                  }
                };
              }).register("ba-common-settingsmenu").registerFunctions({
                "visiblesettings.length > 0": function visiblesettingsLength0(obj) {
                  with (obj) return 0 < visiblesettings.length;
                },
                csscommon: function (_csscommon) {
                  function csscommon(_x4) {
                    return _csscommon.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                csstheme: function (_csstheme) {
                  function csstheme(_x5) {
                    return _csstheme.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                root: function (_root) {
                  function root(_x6) {
                    return _root.apply(this, arguments);
                  }
                  root.toString = function () {
                    return _root.toString();
                  };
                  return root;
                }(function (obj) {
                  with (obj) return root;
                }),
                visiblesettings: function (_visiblesettings) {
                  function visiblesettings(_x7) {
                    return _visiblesettings.apply(this, arguments);
                  }
                  visiblesettings.toString = function () {
                    return _visiblesettings.toString();
                  };
                  return visiblesettings;
                }(function (obj) {
                  with (obj) return visiblesettings;
                }),
                "string(setting.label)": function stringSettingLabel(obj) {
                  with (obj) return string(setting.label);
                },
                "select_setting(setting.id)": function select_settingSettingId(obj) {
                  with (obj) return select_setting(setting.id);
                },
                "string(setting.label) || setting.label": function stringSettingLabelSettingLabel(obj) {
                  with (obj) return string(setting.label) || setting.label;
                },
                "setting.options": function settingOptions(obj) {
                  with (obj) return setting.options;
                },
                "setting.value": function settingValue(obj) {
                  with (obj) return setting.value;
                },
                "!setting.options": function settingOptions(obj) {
                  with (obj) return !setting.options;
                },
                "setting.showicon": function settingShowicon(obj) {
                  with (obj) return setting.showicon;
                },
                "setting.value ? setting.icontruestyle : setting.iconfalsestyle": function settingValueSettingIcontruestyleSettingIconfalsestyle(obj) {
                  with (obj) return setting.value ? setting.icontruestyle : setting.iconfalsestyle;
                },
                "csscommon + (setting.value ? '-setting-on' : '-setting-off')": function csscommonSettingValueSettingOnSettingOff(obj) {
                  with (obj) return csscommon + (setting.value ? "-setting-on" : "-setting-off");
                },
                "setting.value ? setting.trueicon : setting.falseicon": function settingValueSettingTrueiconSettingFalseicon(obj) {
                  with (obj) return setting.value ? setting.trueicon : setting.falseicon;
                },
                "!root": function (_root2) {
                  function root(_x8) {
                    return _root2.apply(this, arguments);
                  }
                  root.toString = function () {
                    return _root2.toString();
                  };
                  return root;
                }(function (obj) {
                  with (obj) return !root;
                }),
                "show_root()": function (_show_root) {
                  function show_root(_x9) {
                    return _show_root.apply(this, arguments);
                  }
                  show_root.toString = function () {
                    return _show_root.toString();
                  };
                  return show_root;
                }(function (obj) {
                  with (obj) return show_root();
                }),
                "string(selected.label) || string('setting-menu')": function stringSelectedLabelStringSettingMenu(obj) {
                  with (obj) return string(selected.label) || string("setting-menu");
                },
                "string(selected.label) || string('')": function stringSelectedLabelString(obj) {
                  with (obj) return string(selected.label) || string("");
                },
                "select_value(option)": function select_valueOption(obj) {
                  with (obj) return select_value(option);
                },
                "option === selected.value": function optionSelectedValue(obj) {
                  with (obj) return option === selected.value;
                },
                "option.label || option": function optionLabelOption(obj) {
                  with (obj) return option.label || option;
                }
              }).attachStringTable(Assets.strings).addStrings({
                tooltip: "Click to play.",
                "setting-menu": "All settings",
                "source-quality": "Source quality",
                "player-speed": "Player speed",
                "set-menu-option": "Set option",
                "submit-video": "Confirm video",
                "picture-in-picture": "Picture in picture",
                "exit-fullscreen-video": "Exit fullscreen",
                "fullscreen-video": "Enter fullscreen"
              });
            }), Scoped.define("module:PopupHelper", ["base:Class", "base:Events.EventsMixin", "browser:Dom", "browser:Events"], function (e, t, i, r, o) {
              var a = e.extend({
                scoped: o
              }, [t, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.popupContainer = document.createElement("div"), this.backgroundContainer = document.createElement("div"), this.backgroundContainer.className = "ba-popup-helper-overlay-background", this.popupContainer.appendChild(this.backgroundContainer), this.overlayContainer = document.createElement("div"), this.overlayContainer.className = "ba-popup-helper-overlay", this.popupContainer.appendChild(this.overlayContainer), this.containerInner = document.createElement("div"), this.containerInner.className = "ba-popup-helper-overlay-inner", this.overlayContainer.appendChild(this.containerInner), this.domEvents = this.auto_destroy(new r()), this.domEvents.on(this.backgroundContainer, "click touchstart", function () {
                      this.hide();
                    }, this), this.domEvents.on(this.containerInner, "click touchstart", function (e) {
                      e.stopPropagation();
                    });
                  },
                  show: function show() {
                    return this.recursionProtection("show", function () {
                      i.elementAddClass(document.body, "ba-popup-helper-overlay-body"), document.body.appendChild(this.popupContainer), this.trigger("show");
                    });
                  },
                  hide: function hide() {
                    return this.recursionProtection("hide", function () {
                      var e = this.popupContainer;
                      this.trigger("hide"), document.body.removeChild(e), i.elementRemoveClass(document.body, "ba-popup-helper-overlay-body");
                    });
                  }
                };
              }], {
                mixin: function mixin(t) {
                  return {
                    constructor: function constructor(e) {
                      e = e || {}, this.__popup = new a(e.popup), this.__popup.on("hide", this.destroy, this), e.element = this.__popup.containerInner, t.constructor.call(this, e);
                    },
                    activate: function activate() {
                      this.__popup.show(), t.activate.call(this);
                    },
                    destroy: function destroy() {
                      this.__popup.hide(), this.__popup.destroy(), t.destroy.call(this);
                    }
                  };
                }
              });
              return a;
            }), Scoped.define("module:IframeHelper", ["dynamics:Dynamic", "base:Objs", "base:Types", "base:Net.Uri"], function (Dynamic, Objs, Types, Uri, scoped) {
              return Dynamic.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<iframe src="{{computeSrc()}}" style="width:100%;height:100%" allow="{{computeAllow()}}" scrolling="no" frameborder="0"></iframe>',
                  getAllowModifiers: function getAllowModifiers() {
                    return [];
                  },
                  getSrc: function getSrc() {
                    return "";
                  },
                  filteredAttrs: function filteredAttrs() {
                    return Objs.filter(this.properties().getAll(), function (e, t) {
                      return !Types.is_object(e) && !Types.is_array(e);
                    }, this);
                  },
                  functions: {
                    computeSrc: function computeSrc() {
                      return Uri.appendUriParams(this.getSrc(), this.filteredAttrs());
                    },
                    computeAllow: function computeAllow() {
                      return this.getAllowModifiers().map(function (e) {
                        return e + " *";
                      }).join("; ");
                    }
                  },
                  iframe: function iframe() {
                    return this.activeElement().querySelector("iframe");
                  },
                  _afterActivate: function _afterActivate() {
                    e._afterActivate.apply(this, arguments);
                    var t = this.iframe();
                    this.getAllowModifiers().forEach(function (e) {
                      t["allow" + e] = "allow" + e;
                    });
                  }
                };
              }).registerFunctions({
                "computeSrc()": function (_computeSrc) {
                  function computeSrc(_x10) {
                    return _computeSrc.apply(this, arguments);
                  }
                  computeSrc.toString = function () {
                    return _computeSrc.toString();
                  };
                  return computeSrc;
                }(function (obj) {
                  with (obj) return computeSrc();
                }),
                "computeAllow()": function (_computeAllow) {
                  function computeAllow(_x11) {
                    return _computeAllow.apply(this, arguments);
                  }
                  computeAllow.toString = function () {
                    return _computeAllow.toString();
                  };
                  return computeAllow;
                }(function (obj) {
                  with (obj) return computeAllow();
                })
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.Adplayer", ["dynamics:Dynamic", "base:TimeFormat", "base:Timers", "browser:Dom", "media:Player.VideoPlayerWrapper", "module:Assets"], function (Class, TimeFormat, Timers, Dom, VideoPlayerWrapper, Assets, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<video class="{{css}}-video" data-video="video"></video>\n<div class="{{cssplayer}}-ad-dashboard">\n    <div class="{{cssplayer}}-ad-click-tracker" ba-click="{{ad_clicked()}}"></div>\n    <div class="{{cssplayer}}-skipbutton-container" ba-click="{{skip_linear_ad()}}"  ba-show="{{skipbuttonvisible}}">\n        <p class="{{cssplayer}}-skipbutton">{{lefttillskip > 0 ? string(\'can-skip-after\').replace(\'%d\', lefttillskip) : string(\'skip-ad\')}}</p>\n    </div>\n\n    <div class="{{css}}-companion-ad-container" ba-show="{{companionadvisible}}">\n        <div class="{{css}}-close-companion-ad" ba-click="{{skip_companion_ad()}}">X</div>\n        <img class="{{css}}-companion-ad" src=""/>\n    </div>\n\n    <div class="{{cssplayer}}-ad-controlbar">\n\n        <div class="{{cssplayer}}-ad-time-container">\n            <div class="{{cssplayer}}-ad-time-value" title="{{string(\'elapsed-time\')}}">{{string(\'ad-will-end-after\').replace(\'%s\', formatTime(adduration))}}</div>\n        </div>\n\n        <div class="{{cssplayer}}-ad-volumebar">\n            <div data-selector="button-volume-bar" class="{{cssplayer}}-ad-volumebar-inner"\n                 onmousedown="{{startUpdateAdVolume(domEvent)}}"\n                 onmouseup="{{stopUpdateAdVolume(domEvent)}}"\n                 onmouseleave="{{stopUpdateAdVolume(domEvent)}}"\n                 onmousemove="{{progressUpdateAdVolume(domEvent)}}">\n                <div class="{{cssplayer}}-ad-volumebar-position" ba-styles="{{{width: Math.min(100, Math.round(advolume * 100)) + \'%\'}}}">\n                    <div class="{{cssplayer}}-ad-volumebar-button" title="{{string(\'volume-button\')}}"></div>\n                </div>\n            </div>\n        </div>\n\n        <div data-selector="button-icon-volume" class="{{cssplayer}}-ad-rightbutton-container" ba-click="{{toggle_ad_volume()}}" title="{{string(advolume > 0 ? \'volume-mute\' : \'volume-unmute\')}}">\n            <div class="{{cssplayer}}-ad-button-inner">\n                <i class="{{css + \'-icon-volume-\' + (advolume >= 0.5 ? \'up\' : (advolume > 0 ? \'down\' : \'off\')) }}"></i>\n            </div>\n        </div>\n\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-adplayer",
                    csscommon: "ba-commoncss",
                    cssplayer: "ba-player",
                    lefttillskip: -1,
                    adduration: 0,
                    duration: 0,
                    advolume: 1,
                    adplaying: !1,
                    companionadvisible: !1,
                    skipbuttonvisible: !1,
                    canskip: !1,
                    adskiped: !1,
                    disablepause: !1
                  },
                  functions: {
                    formatTime: function formatTime(e) {
                      return e = Math.max(e || 0, 1), TimeFormat.format(TimeFormat.ELAPSED_MINUTES_SECONDS, 1e3 * e);
                    },
                    startUpdateAdVolume: function startUpdateAdVolume(e) {
                      e[0].preventDefault(), this.set("_updateAdVolume", !0), this.call("progressUpdateAdVolume", e);
                    },
                    progressUpdateAdVolume: function progressUpdateAdVolume(e) {
                      var t,
                        i,
                        r,
                        o,
                        a = e[0];
                      a.preventDefault(), this.get("_updateAdVolume") && (t = a.clientX, i = a.currentTarget, r = Dom.elementOffset(i), o = Dom.elementDimensions(i), this.set("advolume", (t - r.left) / (o.width || 1)), this.trigger("advolume", this.get("advolume")));
                    },
                    stopUpdateAdVolume: function stopUpdateAdVolume(e) {
                      e[0].preventDefault(), this.set("_updateVolume", !1);
                    },
                    play_ad: function play_ad() {
                      this.trigger("playad");
                    },
                    pause_ad: function pause_ad() {
                      this.trigger("pausead"), this._pauseLinearAd();
                    },
                    toggle_ad_volume: function toggle_ad_volume() {
                      0 < this.get("advolume") ? (this.__oldVolume = this.get("advolume"), this.set("advolume", 0)) : this.set("advolume", this.__oldVolume || 1), this.trigger("advolume", this.get("advolume"));
                    },
                    skip_linear_ad: function skip_linear_ad() {
                      !this.get("canskip") && this._vast || (this.set("adskiped", !0), this._vast.trigger("resumeplayer"));
                    },
                    skip_companion_ad: function skip_companion_ad() {},
                    ad_clicked: function ad_clicked() {
                      this._vast.vastTracker && this._vast.vastTracker.clickAd();
                    }
                  },
                  create: function create() {
                    this._vast.once("vastready", function () {
                      this._adBehaviour();
                    }, this), this._vast.once("adcanceled", function () {
                      this._preroll._adSkipped();
                    }, this);
                  },
                  _adBehaviour: function _adBehaviour() {
                    var e,
                      t = this.activeElement().querySelector("video"),
                      i = this._vast.vastTracker.assetDuration,
                      r = this._vast.sources[0];
                    this._vast.skipAdAfter && 0 < this._vast.skipAdAfter && (this.set("skipbuttonvisible", !0), this.set("lefttillskip", this._vast.skipAdAfter)), this._attachLinearAd(t, r, i), this._vast.on("resumeplayer", function () {
                      this._stopLinearAd(), this._timer.weakDestroy(), this.get("adskiped") ? (this._vast.vastTracker.skipAd(), this._preroll._adSkipped()) : (this._vast.vastTracker.completeAd(), this._preroll._adFinished());
                    }, this), this.on("pausead", function () {
                      this._timer && this.__adPlayer && (this._timer.stop(), this.__adPlayer.pause(), this.set("adplaying", !1));
                    }), this.on("playad", function () {
                      this._timer && this.__adPlayer && (this._timer.start(), this.__adPlayer.play(), this.set("adplaying", !0));
                    }), this.on("advolume", function () {
                      this.__adPlayer && (e = Math.min(1, this.get("advolume")), this.__adPlayer.setVolume(e), this.__adPlayer.setMuted(e <= 0));
                    });
                  },
                  _attachLinearAd: function _attachLinearAd(e, t, i) {
                    VideoPlayerWrapper.create({
                      element: e,
                      source: t.src,
                      type: t.type
                    }).error(function (e) {
                      this._vast.trigger("resumeplayer");
                    }, this).success(function (e) {
                      this.__adPlayer = e, i = isNaN(i) ? this.get("maxadduration") : i, this.set("adduration", i), this._playLinearAd(), this._timer = new Timers.Timer({
                        context: this,
                        fire: this._timerFire,
                        delay: 1e3,
                        start: !0
                      });
                    }, this);
                  },
                  _timerFire: function _timerFire() {
                    var e = this.get("adduration"),
                      t = this.get("lefttillskip") || -1;
                    this.set("adduration", --e), 0 <= t && (this.set("skipbuttonvisible", !0), this.set("lefttillskip", --t), 0 == t && this.set("canskip", !0)), this._vast.vastTracker.setAdProgress(e), 0 === this.get("adduration") && this._vast.trigger("resumeplayer");
                  },
                  _playLinearAd: function _playLinearAd() {
                    this.__adPlayer.play(), this.set("adplaying", !0), this._vast.trigger("adplaying");
                  },
                  _pauseLinearAd: function _pauseLinearAd() {
                    this.get("adplaying") || (this.__adPlayer.pause(), this.set("adplaying", !1), this._vast.vastTracker.setAdPaused(!0), this._vast.trigger("adpaused"), this._vast.once("playad", function () {
                      this._vast.vastTracker.setAdPaused(!1);
                    }, this));
                  },
                  _stopLinearAd: function _stopLinearAd() {
                    this.__adPlayer && this.get("adplaying") && (this.__adPlayer.pause(), this.set("adplaying", !1));
                  },
                  skip_ad: function skip_ad() {
                    this.__adPlayer && this.trigger("resumeplayer");
                  }
                };
              }).register("ba-videoplayer-adslot").registerFunctions({
                css: function (_css) {
                  function css(_x12) {
                    return _css.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                cssplayer: function (_cssplayer) {
                  function cssplayer(_x13) {
                    return _cssplayer.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "ad_clicked()": function (_ad_clicked) {
                  function ad_clicked(_x14) {
                    return _ad_clicked.apply(this, arguments);
                  }
                  ad_clicked.toString = function () {
                    return _ad_clicked.toString();
                  };
                  return ad_clicked;
                }(function (obj) {
                  with (obj) return ad_clicked();
                }),
                "skip_linear_ad()": function (_skip_linear_ad) {
                  function skip_linear_ad(_x15) {
                    return _skip_linear_ad.apply(this, arguments);
                  }
                  skip_linear_ad.toString = function () {
                    return _skip_linear_ad.toString();
                  };
                  return skip_linear_ad;
                }(function (obj) {
                  with (obj) return skip_linear_ad();
                }),
                skipbuttonvisible: function (_skipbuttonvisible) {
                  function skipbuttonvisible(_x16) {
                    return _skipbuttonvisible.apply(this, arguments);
                  }
                  skipbuttonvisible.toString = function () {
                    return _skipbuttonvisible.toString();
                  };
                  return skipbuttonvisible;
                }(function (obj) {
                  with (obj) return skipbuttonvisible;
                }),
                "lefttillskip > 0 ? string('can-skip-after').replace('%d', lefttillskip) : string('skip-ad')": function lefttillskip0StringCanSkipAfterReplaceDLefttillskipStringSkipAd(obj) {
                  with (obj) return 0 < lefttillskip ? string("can-skip-after").replace("%d", lefttillskip) : string("skip-ad");
                },
                companionadvisible: function (_companionadvisible) {
                  function companionadvisible(_x17) {
                    return _companionadvisible.apply(this, arguments);
                  }
                  companionadvisible.toString = function () {
                    return _companionadvisible.toString();
                  };
                  return companionadvisible;
                }(function (obj) {
                  with (obj) return companionadvisible;
                }),
                "skip_companion_ad()": function (_skip_companion_ad) {
                  function skip_companion_ad(_x18) {
                    return _skip_companion_ad.apply(this, arguments);
                  }
                  skip_companion_ad.toString = function () {
                    return _skip_companion_ad.toString();
                  };
                  return skip_companion_ad;
                }(function (obj) {
                  with (obj) return skip_companion_ad();
                }),
                "string('elapsed-time')": function stringElapsedTime(obj) {
                  with (obj) return string("elapsed-time");
                },
                "string('ad-will-end-after').replace('%s', formatTime(adduration))": function stringAdWillEndAfterReplaceSFormatTimeAdduration(obj) {
                  with (obj) return string("ad-will-end-after").replace("%s", formatTime(adduration));
                },
                "startUpdateAdVolume(domEvent)": function startUpdateAdVolumeDomEvent(obj) {
                  with (obj) return startUpdateAdVolume(domEvent);
                },
                "stopUpdateAdVolume(domEvent)": function stopUpdateAdVolumeDomEvent(obj) {
                  with (obj) return stopUpdateAdVolume(domEvent);
                },
                "progressUpdateAdVolume(domEvent)": function progressUpdateAdVolumeDomEvent(obj) {
                  with (obj) return progressUpdateAdVolume(domEvent);
                },
                "{width: Math.min(100, Math.round(advolume * 100)) + '%'}": function widthMathMin100MathRoundAdvolume100(obj) {
                  with (obj) return {
                    width: Math.min(100, Math.round(100 * advolume)) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                "toggle_ad_volume()": function (_toggle_ad_volume) {
                  function toggle_ad_volume(_x19) {
                    return _toggle_ad_volume.apply(this, arguments);
                  }
                  toggle_ad_volume.toString = function () {
                    return _toggle_ad_volume.toString();
                  };
                  return toggle_ad_volume;
                }(function (obj) {
                  with (obj) return toggle_ad_volume();
                }),
                "string(advolume > 0 ? 'volume-mute' : 'volume-unmute')": function stringAdvolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < advolume ? "volume-mute" : "volume-unmute");
                },
                "css + '-icon-volume-' + (advolume >= 0.5 ? 'up' : (advolume > 0 ? 'down' : 'off'))": function cssIconVolumeAdvolume05UpAdvolume0DownOff(obj) {
                  with (obj) return css + "-icon-volume-" + (.5 <= advolume ? "up" : 0 < advolume ? "down" : "off");
                }
              }).attachStringTable(Assets.strings).addStrings({
                "elapsed-time": "Elapsed time",
                "volume-button": "Set volume",
                "volume-mute": "Mute sound",
                "volume-unmute": "Unmute sound",
                "ad-will-end-after": "Ad will end after %s",
                "can-skip-after": "Skip after %d",
                "skip-ad": "Skip ad"
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.Controlbar", ["dynamics:Dynamic", "base:TimeFormat", "base:Comparators", "base:Objs", "browser:Dom", "module:Assets", "browser:Info", "media:Player.Support", "base:Async", "base:Timers.Timer", "browser:Events"], ["dynamics:Partials.StylesPartial", "dynamics:Partials.ShowPartial", "dynamics:Partials.IfPartial", "dynamics:Partials.ClickPartial", "dynamics:Partials.RepeatElementPartial"], function (Class, TimeFormat, Comparators, Objs, Dom, Assets, Info, PlayerSupport, Async, Timer, DomEvents, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div class="{{cssplayer}}-dashboard {{activitydelta > hidebarafter && hideoninactivity ? (cssplayer + \'-dashboard-hidden\') : \'\'}}">\n    <div tabindex="{{skipinitial ? 2 : 1}}" data-selector="progress-bar-inner" class="{{css}}-progressbar {{activitydelta < 2500 || ismobile ? \'\' : (css + \'-progressbar-small\')}} {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}"\n         ba-hotkey:right="{{seek(position + skipseconds)}}"\n         ba-hotkey:left="{{seek(position - skipseconds)}}"\n         ba-hotkey:alt+right="{{seek(position + skipseconds * 3)}}"\n         ba-hotkey:alt+left="{{seek(position - skipseconds * 3)}}"\n         onmouseout="this.blur()"\n         ontouchstart="{{startUpdatePosition(domEvent)}}"\n         onmousedown="{{startUpdatePosition(domEvent)}}"\n    >\n        <div class="{{css}}-progressbar-chapters" ba-show="{{true}}">\n            <div class="{{css}}-chapters-list-container"\n                ba-repeat="{{chapter :: chapterslist}}"\n            >\n                <div\n                    class="{{css}}-chapters-list-item"\n                    data-selector="chapter-index-{{chapter.index}}"\n                    ba-styles="{{{left: Math.round(duration ? chapter.startTime / duration * 100 : 0) + \'%\'}}}"\n                    onmouseenter="{{showChapterText(chapter)}}"\n                    onmouseleave="{{hideChapterText()}}"\n                >\n                    <div class="{{css}}-chapters-item-text" ba-show="{{visibleindex === chapter.index && showchaptertext}}">\n                        {{chapter.title}}\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="{{css}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n        <div class="{{css}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'video-progress\')}}">\n            <div class="{{css}}-progressbar-button"></div>\n        </div>\n        <div class="{{css}}-progressbar-marker"\n             data-selector="trim-start-marker"\n             ba-if="{{trimmingmode}}"\n             ba-styles="{{{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + \'%\'}}}"\n        ></div>\n        <div class="{{css}}-progressbar-marker"\n             data-selector="trim-end-marker"\n             ba-if="{{trimmingmode}}"\n             ba-styles="{{{left: \'auto\', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + \'%\'}}}"\n        ></div>\n    </div>\n\n    <div class="{{css}}-backbar"></div>\n\n    <div class="{{css}}-controlbar">\n\n        <div tabindex="0" data-selector="submit-video-button"\n             ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n             class="{{css}}-leftbutton-container"\n             ba-if="{{submittable}}" ba-click="{{submit()}}">\n            <div class="{{css}}-button-inner">\n                {{string(\'submit-video\')}}\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-ccw"\n             ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n             class="{{css}}-leftbutton-container" ba-if="{{rerecordable}}"\n             ba-click="{{rerecord()}}" title="{{string(\'rerecord-video\')}}"\n        >\n            <div class="{{css}}-button-inner">\n                <i class="{{csscommon}}-icon-ccw"></i>\n            </div>\n        </div>\n\n        <div tabindex="{{skipinitial ? 0 : 2}}" data-selector="button-icon-play"\n             ba-hotkey:space^enter="{{toggle_player()}}" onmouseout="this.blur()"\n             class="{{css}}-leftbutton-container" title="{{string(\'play-video\')}}"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}" ba-if="{{!playing}}" ba-click="{{play()}}"\n        >\n            <div class="{{css}}-button-inner">\n                <i class="{{csscommon}}-icon-play"></i>\n            </div>\n        </div>\n\n        <div tabindex="{{skipinitial ? 0 : 2}}" data-selector="button-icon-pause"\n             ba-hotkey:space^enter="{{toggle_player()}}" onmouseout="this.blur()"\n             class="{{css}}-leftbutton-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}" ba-if="{{playing}}" ba-click="{{pause()}}"\n             title="{{disablepause ? string(\'pause-video-disabled\') : string(\'pause-video\')}}"\n        >\n            <div class="{{css}}-button-inner">\n                <i class="{{csscommon}}-icon-pause"></i>\n            </div>\n        </div>\n\n        <div class="{{css}}-time-container {{csscommon}}-clickable" ba-click="{{toggle_position_info()}}">\n            <div class="{{css}}-time-value"\n                 title="{{revertposition ? string(\'remaining-time\') : string(\'elapsed-time\')}}"\n            >\n                {{(revertposition && duration > 0) ? "-" : ""}}\n                {{(revertposition && duration > 0) ? (formatTime(duration - position)) : formatTime(position)}}\n            </div>\n            <div class="{{css}}-time-sep">/</div>\n            <div class="{{css}}-time-value {{css}}-time-total-duration" title="{{string(\'total-time\')}}">{{formatTime(duration || position)}}</div>\n        </div>\n\n        <div data-selector="video-title-block" class="{{css}}-title-container" ba-if="{{title}}">\n            <p class="{{css}}-title">\n                {{title}}\n            </p>\n        </div>\n\n        <div tabindex="12" class="{{css}}-rightbutton-container" ba-if="{{frameselectionmode}}">\n            <div data-selector="select-frame-button"\n                 onmouseout="this.blur()"\n                 ba-click="{{select_frame()}}"\n                 class="{{css}}-primary-button">\n                 {{string(\'select-frame\')}}\n            </div>\n        </div>\n\n        <div tabindex="12" class="{{css}}-rightbutton-container" ba-if="{{trimmingmode}}">\n            <div data-selector="trim-video-button"\n                 onmouseout="this.blur()"\n                 ba-click="{{trim()}}"\n                 class="{{css}}-primary-button">\n                 {{string(\'trim-video\')}}\n            </div>\n        </div>\n\n        <div tabindex="11" data-selector="button-icon-settings"\n             ba-hotkey:space^enter="{{toggle_settings_menu()}}" onmouseout="this.blur()"\n             class="{{css}}-rightbutton-container {{cssplayer}}-button-{{settingsmenuactive ? \'active\' : \'inactive\'}}"\n             onkeydown="{{tab_index_move(domEvent)}}"\n             ba-if="{{settingsmenubutton}}" ba-click="{{toggle_settings_menu()}}"\n             title="{{string(\'settings\')}}"\n        >\n            <div class="{{css}}-button-inner {{css}}-settings-button">\n                <i class="{{csscommon}}-icon-cog"></i>\n            </div>\n        </div>\n\n        <div tabindex="10" data-selector="cc-button-container"\n             ba-hotkey:space^enter="{{toggle_tracks()}}" onmouseout="this.blur()"\n             ba-if="{{(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload}}"\n             class="{{css}}-rightbutton-container {{cssplayer}}-button-{{tracktextvisible ? \'active\' : \'inactive\'}}"\n             title="{{ tracktextvisible ? string(\'close-tracks\') : string(\'show-tracks\')}}"\n             ba-click="{{toggle_tracks()}}"\n             onmouseover="{{hover_cc(true)}}"\n             onmouseleave="{{hover_cc(false)}}"\n        >\n            <div class="{{css}}-button-inner">\n                <i class="{{csscommon}}-icon-subtitle"></i>\n            </div>\n        </div>\n\n        <div tabindex=9 data-selector="button-icon-resize-full"\n             ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n             class="{{css}}-rightbutton-container"\n             onkeydown="{{tab_index_move(domEvent)}}" ba-if="{{fullscreen}}" ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-video\') : string(\'fullscreen-video\') }}">\n            <div class="{{css}}-button-inner">\n                <i class="{{csscommon}}-icon-resize-{{fullscreened ? \'small\' : \'full\'}}"></i>\n            </div>\n        </div>\n\n        <div tabindex="7" data-selector="button-airplay"\n             ba-hotkey:space^enter="{{show_airplay_devices()}}" onmouseout="this.blur()"\n             class="{{css}}-rightbutton-container"\n             ba-show="{{airplaybuttonvisible}}" ba-click="{{show_airplay_devices()}}">\n            <div class="{{css}}-airplay-container">\n                <svg width="16px" height="11px" viewBox="0 0 16 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n                    \n                    <title>{{string(\'airplay\')}}</title>\n                    <desc>{{string(\'airplay-icon\')}}</desc>\n                    <defs></defs>\n                    <g stroke="none" stroke-width="1" fill-rule="evenodd" sketch:type="MSPage">\n                        <path d="M4,11 L12,11 L8,7 L4,11 Z M14.5454545,0 L1.45454545,0 C0.654545455,0 0,0.5625 0,1.25 L0,8.75 C0,9.4375 0.654545455,10 1.45454545,10 L4.36363636,10 L4.36363636,8.75 L1.45454545,8.75 L1.45454545,1.25 L14.5454545,1.25 L14.5454545,8.75 L11.6363636,8.75 L11.6363636,10 L14.5454545,10 C15.3454545,10 16,9.4375 16,8.75 L16,1.25 C16,0.5625 15.3454545,0 14.5454545,0 L14.5454545,0 Z" sketch:type="MSShapeGroup"></path>\n                    </g>\n                </svg>\n            </div>\n        </div>\n\n        <div data-selector="button-chromecast" class="{{css}}-rightbutton-container {{css}}-cast-button-container" ba-show="{{castbuttonvisble}}">\n            <button tabindex="0" class="{{css}}-gcast-button" is="google-cast-button"></button>\n        </div>\n\n        <div tabindex="6" data-selector="button-stream-label"\n             ba-hotkey:space^enter="{{toggle_stream()}}" onmouseout="this.blur()"\n             class="{{css}}-rightbutton-container"\n             ba-if="{{streams.length > 1 && currentstream}}" ba-click="{{toggle_stream()}}"\n             title="{{string(\'change-resolution\')}}"\n        >\n            <div class="{{css}}-button-inner">\n                <span class="{{css}}-button-text">{{currentstream_label}}</span>\n            </div>\n        </div>\n\n        <div class="{{css}}-volumebar" ba-show="{{!hidevolumebar}}">\n            <div tabindex="5" data-selector="button-volume-bar"\n                 ba-hotkey:right="{{set_volume(volume + 0.1)}}" ba-hotkey:left="{{set_volume(volume - 0.1)}}"\n                 ba-hotkey:up="{{set_volume(1)}}" ba-hotkey:down="{{set_volume(0)}}"\n                 onmouseout="this.blur()"\n                 class="{{css}}-volumebar-inner"\n                 ontouchstart="{{startUpdateVolume(domEvent)}}"\n                 ontouchmove="{{progressUpdateVolume(domEvent)}}"\n                 ontouchend="{{stopUpdateVolume(domEvent); this.blur()}};"\n                 onmousedown="{{startUpdateVolume(domEvent)}}"\n                 onmouseup="{{stopUpdateVolume(domEvent)}}"\n                 onmouseleave="{{stopUpdateVolume(domEvent)}}"\n                 onmousemove="{{progressUpdateVolume(domEvent)}}"\n            >\n                <div class="{{css}}-volumebar-position" ba-styles="{{{width: Math.min(100, Math.round(volume * 100)) + \'%\'}}}">\n                    <div class="{{css}}-volumebar-button" title="{{string(\'volume-button\')}}"></div>\n                </div>\n            </div>\n        </div>\n\n        <div tabindex="4" data-selector="button-icon-volume"\n             ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n             class="{{css}}-rightbutton-container"\n             ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}"\n        >\n            <div class="{{css}}-button-inner">\n                <i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n            </div>\n        </div>\n\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-videoplayer",
                    csscommon: "ba-commoncss",
                    cssplayer: "ba-player",
                    duration: 0,
                    position: 0,
                    cached: 0,
                    volume: 1,
                    expandedprogress: !0,
                    playing: !1,
                    rerecordable: !1,
                    submittable: !1,
                    manuallypaused: !1,
                    streams: [],
                    currentstream: null,
                    fullscreen: !0,
                    fullscreened: !1,
                    activitydelta: 0,
                    hidebarafter: 5e3,
                    preventinteraction: !1,
                    revertposition: !1,
                    title: "",
                    settingsmenubutton: !1,
                    hoveredblock: !1,
                    allowtexttrackupload: !1,
                    thumbisvisible: !1,
                    chapterslist: [],
                    showchaptertext: !0,
                    visibleindex: -1
                  },
                  computed: {
                    "currentstream_label:currentstream": function currentstream_labelCurrentstream() {
                      var e = this.get("currentstream");
                      return e ? e.label ? e.label : PlayerSupport.resolutionToLabel(e.width, e.height) : "";
                    }
                  },
                  functions: {
                    formatTime: function formatTime(e) {
                      return e = Math.max(e || 0, .1), TimeFormat.format(TimeFormat.ELAPSED_MINUTES_SECONDS, 1e3 * e);
                    },
                    startUpdatePosition: function startUpdatePosition(e) {
                      var t, i;
                      this.get("disableseeking") || (e[0].preventDefault(), this.__parent.get("playing") || !this.__parent.player || this.get("manuallypaused") || this.__parent.player.play(), t = e[0].currentTarget, this.set("dimensions", t.getBoundingClientRect()), this.set("_updatePosition", !0), this.call("progressUpdatePosition", e[0]), (i = this.get("events")).on(document, "mousemove touchmove", function (e) {
                        e.preventDefault(), this.call("progressUpdatePosition", e);
                      }, this), i.on(document, "mouseup touchend", function (e) {
                        e.preventDefault(), this.call("stopUpdatePosition"), i.off(document, "mouseup touchend mousemove touchmove");
                      }, this));
                    },
                    progressUpdatePosition: function progressUpdatePosition(e) {
                      var t = this.__parent,
                        i = 0 === e.clientX ? 0 : e.clientX || e.targetTouches[0].clientX,
                        r = this.get("dimensions"),
                        o = -1,
                        o = i < r.left ? 0 : i > r.left + r.width ? 1 : (i - r.left) / (r.width || 1),
                        a = this.get("duration") * o;
                      if (this.get("_updatePosition") || "undefined" != typeof t.__trackTags) {
                        var n = t.player;
                        if ("undefined" != typeof t.__trackTags && this.__parent.__trackTags.hasThumbs) {
                          if (-1 < this.get("visibleindex") && this.get("showchaptertext")) return;
                          var s,
                            x = t.__trackTags,
                            c = t.get("thumbcuelist").length;
                          if (0 < a) {
                            for (var d = (s = Math.floor(c * o)) - 2; d < c; d++) if (t.get("thumbcuelist")[d]) {
                              var l = t.get("thumbcuelist")[d];
                              if (l.startTime < a && l.endTime > a) {
                                x.showDurationThumb(d, i, a);
                                break;
                              }
                            }
                          } else s = Math.floor(c * o), x.showDurationThumb(s, i);
                          this.set("thumbisvisible", !0), this.activeElement().appendChild(x.thumbContainer);
                        }
                        if (this.get("_updatePosition")) {
                          if (this.set("position", a), "undefined" != typeof n._broadcastingState && n._broadcastingState.googleCastConnected) return void n.trigger("google-cast-seeking", this.get("position"));
                          this.trigger("position", this.get("position"));
                        }
                      }
                    },
                    stopUpdatePosition: function stopUpdatePosition() {
                      this.set("_updatePosition", !1), this._hideThumb();
                    },
                    startUpdateVolume: function startUpdateVolume(e) {
                      e[0].preventDefault(), this.set("_updateVolume", !0), this.call("progressUpdateVolume", e);
                    },
                    progressUpdateVolume: function progressUpdateVolume(e) {
                      var t,
                        i,
                        r,
                        o,
                        a,
                        n = e[0];
                      n.preventDefault(), this.get("_updateVolume") && (t = n.clientX || n.targetTouches[0].clientX, i = n.currentTarget, r = Dom.elementOffset(i), o = Dom.elementDimensions(i), a = (t - r.left) / (o.width || 1), Dom.getRelativeCoordinates(i, e[0]), a = 1 < a ? 1 : a < 0 ? 0 : a, this.set("volume", a), this.trigger("volume", this.get("volume")));
                    },
                    stopUpdateVolume: function stopUpdateVolume(e) {
                      e[0].preventDefault(), this.set("_updateVolume", !1);
                    },
                    startVerticallyUpdateVolume: function startVerticallyUpdateVolume(e) {
                      e[0].preventDefault(), this.set("_updateVolume", !0), this.call("progressVerticallyUpdateVolume", e);
                    },
                    progressVerticallyUpdateVolume: function progressVerticallyUpdateVolume(e) {
                      var t,
                        i,
                        r,
                        o,
                        a,
                        n = e[0];
                      n.preventDefault(), this.get("_updateVolume") && (t = n.clientY || n.targetTouches[0].clientY, i = n.currentTarget, r = Dom.elementOffset(i), o = Dom.elementDimensions(i), a = 1 < (a = 1 - (t - r.top) / (o.height || 1)) ? 1 : a < 0 ? 0 : a, this.set("volume", a), this.trigger("volume", this.get("volume")));
                    },
                    showChapterText: function showChapterText(e) {
                      this.set("visibleindex", e.index), this._hideThumb();
                    },
                    hideChapterText: function hideChapterText() {
                      this.set("visibleindex", -1);
                    },
                    stopVerticallyUpdateVolume: function stopVerticallyUpdateVolume(e) {
                      e[0].preventDefault(), this.set("_updateVolume", !1);
                    },
                    play: function play() {
                      this.trigger("play");
                    },
                    pause: function pause() {
                      this.trigger("pause");
                    },
                    toggle_player: function toggle_player() {
                      this.trigger("toggle_player");
                    },
                    toggle_volume: function toggle_volume() {
                      0 < this.get("volume") ? (this.__oldVolume = this.get("volume"), this.set("volume", 0)) : this.set("volume", this.__oldVolume || 1), this.trigger("volume", this.get("volume"));
                    },
                    toggle_position_info: function toggle_position_info() {
                      this.set("revertposition", !this.get("revertposition"));
                    },
                    toggle_fullscreen: function toggle_fullscreen() {
                      this.trigger("fullscreen");
                    },
                    toggle_settings_menu: function toggle_settings_menu() {
                      this.trigger("settings_menu");
                    },
                    rerecord: function rerecord() {
                      this.trigger("rerecord");
                    },
                    seek: function seek(e) {
                      this.trigger("seek", e);
                    },
                    set_volume: function set_volume(e) {
                      this.trigger("set_volume", e);
                    },
                    submit: function submit() {
                      this.set("submittable", !1), this.set("rerecordable", !1), this.trigger("submit");
                    },
                    select_frame: function select_frame() {
                      var e = this.parent().player,
                        t = e.position(),
                        i = !1;
                      e.pause();
                      var r = new Timer({
                        context: this,
                        start: !1,
                        fire: function fire() {
                          e.setPosition(t), e.play(), e.pause(), e.loaded() && e.createSnapshotPromise().success(function (e) {
                            r.stop(), i || (i = !0, this.parent().trigger("image-selected", e));
                          }, this);
                        },
                        delay: 300,
                        fire_max: 5,
                        destroy_on_stop: !0
                      });
                      e.loaded() ? e.createSnapshotPromise().success(function (e) {
                        this.parent().trigger("image-selected", e);
                      }, this).error(function () {
                        r.start();
                      }, this) : r.start();
                    },
                    toggle_stream: function toggle_stream() {
                      var e = this.get("streams"),
                        i = e.length - 1;
                      e.forEach(function (e, t) {
                        Comparators.deepEqual(e, this.get("currentstream")) && (i = t);
                      }, this), this.set("currentstream", e[(i + 1) % e.length]);
                    },
                    show_airplay_devices: function show_airplay_devices() {
                      var e = this.__parent;
                      e.player._broadcastingState.airplayConnected && e._broadcasting.lookForAirplayDevices(e.player._element);
                    },
                    toggle_tracks: function toggle_tracks() {
                      return this.parent().toggleTrackTags();
                    },
                    hover_cc: function hover_cc(e) {
                      this.parent().get("settingsmenu_active") || Async.eventually(function () {
                        this.parent().set("tracksshowselection", e);
                      }, this, 300);
                    },
                    tab_index_move: function tab_index_move(e, t, i) {
                      this.trigger("tab_index_move", e[0], t, i);
                    },
                    hover_block: function hover_block(e) {
                      Async.eventually(function () {
                        this.parent().set("hoveredblock", e);
                      }, this, 300);
                    },
                    toggle_settings: function toggle_settings() {
                      this.trigger("toggle_settings");
                    },
                    trim: function trim() {
                      this.parent().trigger("video-trimmed", this.get("trimstart") || 0, this.get("trimend") || this.get("duration"));
                    },
                    addTrimmingEventListeners: function addTrimmingEventListeners() {
                      var i = this.get("events"),
                        e = this.activeElement().querySelector('[data-selector="trim-start-marker"]'),
                        t = this.activeElement().querySelector('[data-selector="trim-end-marker"]');
                      i.on(e, "mousedown touchstart", function (e) {
                        e.preventDefault(), e.stopPropagation();
                        var t = this.get("progressbarElement").getBoundingClientRect();
                        this.call("updateTrimStart", e, t), i.on(document, "mousemove touchmove", function (e) {
                          e.preventDefault(), this.call("updateTrimStart", e, t);
                        }, this), i.on(document, "mouseup touchend", function (e) {
                          e.preventDefault(), i.off(document, "mouseup touchend mousemove touchmove");
                        }, this);
                      }, this), i.on(t, "mousedown touchstart", function (e) {
                        e.preventDefault(), e.stopPropagation();
                        var t = this.get("progressbarElement").getBoundingClientRect();
                        this.call("updateTrimEnd", e, t), i.on(document, "mousemove touchmove", function (e) {
                          e.preventDefault(), this.call("updateTrimEnd", e, t);
                        }, this), i.on(document, "mouseup touchend", function (e) {
                          e.preventDefault(), i.off(document, "mouseup touchend mousemove touchmove");
                        }, this);
                      }, this);
                    },
                    updateTrimStart: function updateTrimStart(e, t) {
                      var i = this.call("calculatePosition", e, t),
                        r = this.get("trimend") || this.get("duration"),
                        o = this.get("timeminlimit") || 1;
                      r - o < i ? this.set("trimstart", r - o) : this.set("trimstart", i);
                    },
                    updateTrimEnd: function updateTrimEnd(e, t) {
                      var i = this.call("calculatePosition", e, t),
                        r = this.get("trimstart") || 0,
                        o = this.get("timeminlimit") || 1;
                      i < r + o ? this.set("trimend", r + o) : this.set("trimend", i);
                    },
                    getClientX: function getClientX(e) {
                      return 0 === e.clientX ? 0 : e.clientX || e.targetTouches[0].clientX;
                    },
                    calculatePosition: function calculatePosition(e, t) {
                      var i = this.call("getClientX", e),
                        r = -1,
                        r = i < t.left ? 0 : i > t.left + t.width ? 1 : (i - t.left) / (t.width || 1);
                      return this.get("duration") * r;
                    }
                  },
                  _hideThumb: function _hideThumb() {
                    "undefined" != typeof this.__parent.__trackTags && this.__parent.__trackTags.hasThumbs && this.get("thumbisvisible") && (this.set("thumbisvisible", !1), this.__parent.__trackTags.hideDurationThumb());
                  },
                  create: function create() {
                    this.set("ismobile", Info.isMobile()), this.set("events", new DomEvents()), this.set("progressbarElement", this.activeElement().querySelector('[data-selector="progress-bar-inner"]')), this.get("trimmingmode") && this.call("addTrimmingEventListeners");
                  }
                };
              }).register("ba-videoplayer-controlbar").registerFunctions({
                cssplayer: function (_cssplayer2) {
                  function cssplayer(_x20) {
                    return _cssplayer2.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer2.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "activitydelta > hidebarafter && hideoninactivity ? (cssplayer + '-dashboard-hidden') : ''": function activitydeltaHidebarafterHideoninactivityCssplayerDashboardHidden(obj) {
                  with (obj) return activitydelta > hidebarafter && hideoninactivity ? cssplayer + "-dashboard-hidden" : "";
                },
                "skipinitial ? 2 : 1": function skipinitial21(obj) {
                  with (obj) return skipinitial ? 2 : 1;
                },
                css: function (_css2) {
                  function css(_x21) {
                    return _css2.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css2.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "activitydelta < 2500 || ismobile ? '' : (css + '-progressbar-small')": function activitydelta2500IsmobileCssProgressbarSmall(obj) {
                  with (obj) return activitydelta < 2500 || ismobile ? "" : css + "-progressbar-small";
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "seek(position + skipseconds * 3)": function seekPositionSkipseconds3(obj) {
                  with (obj) return seek(position + 3 * skipseconds);
                },
                "seek(position - skipseconds * 3)": function seekPositionSkipseconds3(obj) {
                  with (obj) return seek(position - 3 * skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "true": function _true(obj) {
                  with (obj) return !0;
                },
                chapterslist: function (_chapterslist) {
                  function chapterslist(_x22) {
                    return _chapterslist.apply(this, arguments);
                  }
                  chapterslist.toString = function () {
                    return _chapterslist.toString();
                  };
                  return chapterslist;
                }(function (obj) {
                  with (obj) return chapterslist;
                }),
                "chapter.index": function chapterIndex(obj) {
                  with (obj) return chapter.index;
                },
                "{left: Math.round(duration ? chapter.startTime / duration * 100 : 0) + '%'}": function leftMathRoundDurationChapterStartTimeDuration1000(obj) {
                  with (obj) return {
                    left: Math.round(duration ? chapter.startTime / duration * 100 : 0) + "%"
                  };
                },
                "showChapterText(chapter)": function showChapterTextChapter(obj) {
                  with (obj) return showChapterText(chapter);
                },
                "hideChapterText()": function (_hideChapterText) {
                  function hideChapterText(_x23) {
                    return _hideChapterText.apply(this, arguments);
                  }
                  hideChapterText.toString = function () {
                    return _hideChapterText.toString();
                  };
                  return hideChapterText;
                }(function (obj) {
                  with (obj) return hideChapterText();
                }),
                "visibleindex === chapter.index && showchaptertext": function visibleindexChapterIndexShowchaptertext(obj) {
                  with (obj) return visibleindex === chapter.index && showchaptertext;
                },
                "chapter.title": function chapterTitle(obj) {
                  with (obj) return chapter.title;
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('video-progress')": function stringVideoProgress(obj) {
                  with (obj) return string("video-progress");
                },
                trimmingmode: function (_trimmingmode) {
                  function trimmingmode(_x24) {
                    return _trimmingmode.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + '%'}": function leftMathRoundDurationTrimstartTrimstartDuration1000(obj) {
                  with (obj) return {
                    left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + "%"
                  };
                },
                "{left: 'auto', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + '%'}": function leftAutoRight100MathRoundDurationTrimendTrimendDuration100100(obj) {
                  with (obj) return {
                    left: "auto",
                    right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + "%"
                  };
                },
                "submit()": function (_submit) {
                  function submit(_x25) {
                    return _submit.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable) {
                  function submittable(_x26) {
                    return _submittable.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecord()": function (_rerecord) {
                  function rerecord(_x27) {
                    return _rerecord.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable) {
                  function rerecordable(_x28) {
                    return _rerecordable.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-video')": function stringRerecordVideo(obj) {
                  with (obj) return string("rerecord-video");
                },
                csscommon: function (_csscommon2) {
                  function csscommon(_x29) {
                    return _csscommon2.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon2.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "skipinitial ? 0 : 2": function skipinitial02(obj) {
                  with (obj) return skipinitial ? 0 : 2;
                },
                "toggle_player()": function (_toggle_player) {
                  function toggle_player(_x30) {
                    return _toggle_player.apply(this, arguments);
                  }
                  toggle_player.toString = function () {
                    return _toggle_player.toString();
                  };
                  return toggle_player;
                }(function (obj) {
                  with (obj) return toggle_player();
                }),
                "string('play-video')": function stringPlayVideo(obj) {
                  with (obj) return string("play-video");
                },
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "!playing": function (_playing) {
                  function playing(_x31) {
                    return _playing.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "play()": function (_play) {
                  function play(_x32) {
                    return _play.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                playing: function (_playing2) {
                  function playing(_x33) {
                    return _playing2.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing2.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "pause()": function (_pause) {
                  function pause(_x34) {
                    return _pause.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "disablepause ? string('pause-video-disabled') : string('pause-video')": function disablepauseStringPauseVideoDisabledStringPauseVideo(obj) {
                  with (obj) return disablepause ? string("pause-video-disabled") : string("pause-video");
                },
                "toggle_position_info()": function (_toggle_position_info) {
                  function toggle_position_info(_x35) {
                    return _toggle_position_info.apply(this, arguments);
                  }
                  toggle_position_info.toString = function () {
                    return _toggle_position_info.toString();
                  };
                  return toggle_position_info;
                }(function (obj) {
                  with (obj) return toggle_position_info();
                }),
                "revertposition ? string('remaining-time') : string('elapsed-time')": function revertpositionStringRemainingTimeStringElapsedTime(obj) {
                  with (obj) return revertposition ? string("remaining-time") : string("elapsed-time");
                },
                '(revertposition && duration > 0) ? "-" : ""': function revertpositionDuration0(obj) {
                  with (obj) return revertposition && 0 < duration ? "-" : "";
                },
                "(revertposition && duration > 0) ? (formatTime(duration - position)) : formatTime(position)": function revertpositionDuration0FormatTimeDurationPositionFormatTimePosition(obj) {
                  with (obj) return revertposition && 0 < duration ? formatTime(duration - position) : formatTime(position);
                },
                "string('total-time')": function stringTotalTime(obj) {
                  with (obj) return string("total-time");
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                title: function (_title) {
                  function title(_x36) {
                    return _title.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                frameselectionmode: function (_frameselectionmode) {
                  function frameselectionmode(_x37) {
                    return _frameselectionmode.apply(this, arguments);
                  }
                  frameselectionmode.toString = function () {
                    return _frameselectionmode.toString();
                  };
                  return frameselectionmode;
                }(function (obj) {
                  with (obj) return frameselectionmode;
                }),
                "select_frame()": function (_select_frame) {
                  function select_frame(_x38) {
                    return _select_frame.apply(this, arguments);
                  }
                  select_frame.toString = function () {
                    return _select_frame.toString();
                  };
                  return select_frame;
                }(function (obj) {
                  with (obj) return select_frame();
                }),
                "string('select-frame')": function stringSelectFrame(obj) {
                  with (obj) return string("select-frame");
                },
                "trim()": function (_trim) {
                  function trim(_x39) {
                    return _trim.apply(this, arguments);
                  }
                  trim.toString = function () {
                    return _trim.toString();
                  };
                  return trim;
                }(function (obj) {
                  with (obj) return trim();
                }),
                "string('trim-video')": function stringTrimVideo(obj) {
                  with (obj) return string("trim-video");
                },
                "toggle_settings_menu()": function (_toggle_settings_menu) {
                  function toggle_settings_menu(_x40) {
                    return _toggle_settings_menu.apply(this, arguments);
                  }
                  toggle_settings_menu.toString = function () {
                    return _toggle_settings_menu.toString();
                  };
                  return toggle_settings_menu;
                }(function (obj) {
                  with (obj) return toggle_settings_menu();
                }),
                "settingsmenuactive ? 'active' : 'inactive'": function settingsmenuactiveActiveInactive(obj) {
                  with (obj) return settingsmenuactive ? "active" : "inactive";
                },
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                settingsmenubutton: function (_settingsmenubutton) {
                  function settingsmenubutton(_x41) {
                    return _settingsmenubutton.apply(this, arguments);
                  }
                  settingsmenubutton.toString = function () {
                    return _settingsmenubutton.toString();
                  };
                  return settingsmenubutton;
                }(function (obj) {
                  with (obj) return settingsmenubutton;
                }),
                "string('settings')": function stringSettings(obj) {
                  with (obj) return string("settings");
                },
                "toggle_tracks()": function (_toggle_tracks) {
                  function toggle_tracks(_x42) {
                    return _toggle_tracks.apply(this, arguments);
                  }
                  toggle_tracks.toString = function () {
                    return _toggle_tracks.toString();
                  };
                  return toggle_tracks;
                }(function (obj) {
                  with (obj) return toggle_tracks();
                }),
                "(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload": function tracktagsLength0ShowsubtitlebuttonAllowtexttrackupload(obj) {
                  with (obj) return 0 < tracktags.length && showsubtitlebutton || allowtexttrackupload;
                },
                "tracktextvisible ? 'active' : 'inactive'": function tracktextvisibleActiveInactive(obj) {
                  with (obj) return tracktextvisible ? "active" : "inactive";
                },
                "tracktextvisible ? string('close-tracks') : string('show-tracks')": function tracktextvisibleStringCloseTracksStringShowTracks(obj) {
                  with (obj) return tracktextvisible ? string("close-tracks") : string("show-tracks");
                },
                "hover_cc(true)": function hover_ccTrue(obj) {
                  with (obj) return hover_cc(!0);
                },
                "hover_cc(false)": function hover_ccFalse(obj) {
                  with (obj) return hover_cc(!1);
                },
                "toggle_fullscreen()": function (_toggle_fullscreen) {
                  function toggle_fullscreen(_x43) {
                    return _toggle_fullscreen.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                fullscreen: function (_fullscreen) {
                  function fullscreen(_x44) {
                    return _fullscreen.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-video') : string('fullscreen-video')": function fullscreenedStringExitFullscreenVideoStringFullscreenVideo(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-video") : string("fullscreen-video");
                },
                "fullscreened ? 'small' : 'full'": function fullscreenedSmallFull(obj) {
                  with (obj) return fullscreened ? "small" : "full";
                },
                "show_airplay_devices()": function (_show_airplay_devices) {
                  function show_airplay_devices(_x45) {
                    return _show_airplay_devices.apply(this, arguments);
                  }
                  show_airplay_devices.toString = function () {
                    return _show_airplay_devices.toString();
                  };
                  return show_airplay_devices;
                }(function (obj) {
                  with (obj) return show_airplay_devices();
                }),
                airplaybuttonvisible: function (_airplaybuttonvisible) {
                  function airplaybuttonvisible(_x46) {
                    return _airplaybuttonvisible.apply(this, arguments);
                  }
                  airplaybuttonvisible.toString = function () {
                    return _airplaybuttonvisible.toString();
                  };
                  return airplaybuttonvisible;
                }(function (obj) {
                  with (obj) return airplaybuttonvisible;
                }),
                "string('airplay')": function stringAirplay(obj) {
                  with (obj) return string("airplay");
                },
                "string('airplay-icon')": function stringAirplayIcon(obj) {
                  with (obj) return string("airplay-icon");
                },
                castbuttonvisble: function (_castbuttonvisble) {
                  function castbuttonvisble(_x47) {
                    return _castbuttonvisble.apply(this, arguments);
                  }
                  castbuttonvisble.toString = function () {
                    return _castbuttonvisble.toString();
                  };
                  return castbuttonvisble;
                }(function (obj) {
                  with (obj) return castbuttonvisble;
                }),
                "toggle_stream()": function (_toggle_stream) {
                  function toggle_stream(_x48) {
                    return _toggle_stream.apply(this, arguments);
                  }
                  toggle_stream.toString = function () {
                    return _toggle_stream.toString();
                  };
                  return toggle_stream;
                }(function (obj) {
                  with (obj) return toggle_stream();
                }),
                "streams.length > 1 && currentstream": function streamsLength1Currentstream(obj) {
                  with (obj) return 1 < streams.length && currentstream;
                },
                "string('change-resolution')": function stringChangeResolution(obj) {
                  with (obj) return string("change-resolution");
                },
                currentstream_label: function (_currentstream_label) {
                  function currentstream_label(_x49) {
                    return _currentstream_label.apply(this, arguments);
                  }
                  currentstream_label.toString = function () {
                    return _currentstream_label.toString();
                  };
                  return currentstream_label;
                }(function (obj) {
                  with (obj) return currentstream_label;
                }),
                "!hidevolumebar": function (_hidevolumebar) {
                  function hidevolumebar(_x50) {
                    return _hidevolumebar.apply(this, arguments);
                  }
                  hidevolumebar.toString = function () {
                    return _hidevolumebar.toString();
                  };
                  return hidevolumebar;
                }(function (obj) {
                  with (obj) return !hidevolumebar;
                }),
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "set_volume(1)": function set_volume1(obj) {
                  with (obj) return set_volume(1);
                },
                "set_volume(0)": function set_volume0(obj) {
                  with (obj) return set_volume(0);
                },
                "startUpdateVolume(domEvent)": function startUpdateVolumeDomEvent(obj) {
                  with (obj) return startUpdateVolume(domEvent);
                },
                "progressUpdateVolume(domEvent)": function progressUpdateVolumeDomEvent(obj) {
                  with (obj) return progressUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent); this.blur()": function stopUpdateVolumeDomEventThisBlur(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent)": function stopUpdateVolumeDomEvent(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "{width: Math.min(100, Math.round(volume * 100)) + '%'}": function widthMathMin100MathRoundVolume100(obj) {
                  with (obj) return {
                    width: Math.min(100, Math.round(100 * volume)) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                "toggle_volume()": function (_toggle_volume) {
                  function toggle_volume(_x51) {
                    return _toggle_volume.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                }
              }).attachStringTable(Assets.strings).addStrings({
                "video-progress": "Progress",
                "rerecord-video": "Redo?",
                "submit-video": "Confirm",
                "play-video": "Play",
                "pause-video": "Pause",
                "pause-video-disabled": "Pause not supported",
                "elapsed-time": "Elapsed time",
                "total-time": "Total length of",
                "fullscreen-video": "Enter fullscreen",
                "volume-button": "Set volume",
                "volume-mute": "Mute sound",
                "volume-unmute": "Unmute sound",
                "change-resolution": "Change resolution",
                "exit-fullscreen-video": "Exit fullscreen",
                "close-tracks": "Close CC",
                "show-tracks": "Show CC",
                "player-speed": "Player speed",
                settings: "Settings",
                airplay: "Airplay",
                "airplay-icon": "Airplay icon.",
                "remaining-time": "Remaining time",
                "select-frame": "Select",
                "trim-video": "Trim"
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.Loader", ["dynamics:Dynamic", "module:Assets"], function (Class, Assets, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<div class="{{cssplayer}}-loader-container">\n    <div data-selector="loader-block" class="{{cssplayer}}-loader-loader" title="{{string(\'tooltip\')}}">\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-videoplayer",
                    csscommon: "ba-commoncss",
                    cssplayer: "ba-player"
                  }
                };
              }).register("ba-videoplayer-loader").registerFunctions({
                cssplayer: function (_cssplayer3) {
                  function cssplayer(_x52) {
                    return _cssplayer3.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer3.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "string('tooltip')": function stringTooltip(obj) {
                  with (obj) return string("tooltip");
                }
              }).attachStringTable(Assets.strings).addStrings({
                tooltip: "Loading..."
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.Message", ["dynamics:Dynamic"], ["dynamics:Partials.ClickPartial"], function (Class, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div class="{{css}}-message-container" ba-click="{{click()}}">\n    <div data-selector="message-block" class=\'{{css}}-message-message\'>\n        <p> {{message}} </p>\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-videoplayer",
                    csscommon: "ba-commoncss",
                    cssplayer: "ba-player",
                    message: ""
                  },
                  functions: {
                    click: function click() {
                      this.trigger("click");
                    }
                  }
                };
              }).registerFunctions({
                css: function (_css3) {
                  function css(_x53) {
                    return _css3.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css3.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click) {
                  function click(_x54) {
                    return _click.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                message: function (_message) {
                  function message(_x55) {
                    return _message.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message;
                })
              }).register("ba-videoplayer-message");
            }), Scoped.define("module:VideoPlayer.Dynamics.Playbutton", ["dynamics:Dynamic", "base:TimeFormat", "module:Assets"], ["dynamics:Partials.ClickPartial"], function (Class, TimeFormat, Assets, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div tabindex="0" data-selector="play-button"\n     ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n     onkeydown="{{tab_index_move(domEvent, null, \'player-toggle-overlay\')}}"\n     class="{{css}}-playbutton-container" ba-click="{{play()}}" title="{{string(\'tooltip\')}}"\n>\n\t<div class="{{css}}-playbutton-button"></div>\n</div>\n<div ba-show="{{showduration && (duration != 0 && duration != undefined)}}" class="{{css}}-playbutton-duration">\n\t{{formatTime(duration)}}\n</div>\n<div class="{{css}}-rerecord-bar" ba-if="{{rerecordable || submittable}}">\n\t<div class="{{css}}-rerecord-backbar"></div>\n\t<div class="{{css}}-rerecord-frontbar">\n        <div class="{{css}}-rerecord-button-container" ba-if="{{submittable && !trimmingmode}}">\n            <div tabindex="0" data-selector="player-submit-button"\n                 ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 class="{{css}}-rerecord-button" onclick="{{submit()}}">\n                {{string(\'submit-video\')}}\n            </div>\n        </div>\n        <div class="{{css}}-rerecord-button-container" ba-if="{{rerecordable && !trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-rerecord-button"\n                 ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 class="{{css}}-rerecord-button" onclick="{{rerecord()}}">\n        \t\t{{string(\'rerecord\')}}\n        \t</div>\n        </div>\n        <div class="{{css}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-trim-button"\n                 ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n                 class="{{css}}-rerecord-button" onclick="{{play()}}">\n        \t\t{{string(\'trim\')}}\n        \t</div>\n        </div>\n        <div class="{{css}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-skip-button"\n                 ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n                 class="{{css}}-rerecord-button" onclick="{{skip()}}">\n        \t\t{{string(\'skip\')}}\n        \t</div>\n        </div>\n\t</div>\n</div>\n',
                  attrs: {
                    css: "ba-videoplayer",
                    csstheme: "ba-videoplayer",
                    csscommon: "ba-commoncss",
                    cssplayer: "ba-player",
                    rerecordable: !1,
                    submittable: !1,
                    showduration: !1
                  },
                  functions: {
                    play: function play() {
                      this.trigger("play");
                    },
                    skip: function skip() {
                      this.parent().trigger("skip");
                    },
                    submit: function submit() {
                      this.set("submittable", !1), this.set("rerecordable", !1), this.trigger("submit");
                    },
                    rerecord: function rerecord() {
                      this.trigger("rerecord");
                    },
                    tab_index_move: function tab_index_move(e, t, i) {
                      this.trigger("tab_index_move", e[0], t, i);
                    },
                    formatTime: function formatTime(e) {
                      return 3600 < (e = Math.max(e || 0, 1)) ? TimeFormat.format(TimeFormat.ELAPSED_HOURS_MINUTES_SECONDS, 1e3 * e) : TimeFormat.format(TimeFormat.ELAPSED_MINUTES_SECONDS, 1e3 * e);
                    }
                  }
                };
              }).register("ba-videoplayer-playbutton").registerFunctions({
                "play()": function (_play2) {
                  function play(_x56) {
                    return _play2.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play2.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'player-toggle-overlay')": function tab_index_moveDomEventNullPlayerToggleOverlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "player-toggle-overlay");
                },
                css: function (_css4) {
                  function css(_x57) {
                    return _css4.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css4.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "string('tooltip')": function stringTooltip(obj) {
                  with (obj) return string("tooltip");
                },
                "showduration && (duration != 0 && duration != undefined)": function showdurationDuration0DurationUndefined(obj) {
                  with (obj) return showduration && 0 != duration && duration != undefined;
                },
                "formatTime(duration)": function formatTimeDuration(obj) {
                  with (obj) return formatTime(duration);
                },
                "rerecordable || submittable": function rerecordableSubmittable(obj) {
                  with (obj) return rerecordable || submittable;
                },
                "submittable && !trimmingmode": function submittableTrimmingmode(obj) {
                  with (obj) return submittable && !trimmingmode;
                },
                "submit()": function (_submit2) {
                  function submit(_x58) {
                    return _submit2.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit2.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecordable && !trimmingmode": function rerecordableTrimmingmode(obj) {
                  with (obj) return rerecordable && !trimmingmode;
                },
                "rerecord()": function (_rerecord2) {
                  function rerecord(_x59) {
                    return _rerecord2.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord2.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                trimmingmode: function (_trimmingmode2) {
                  function trimmingmode(_x60) {
                    return _trimmingmode2.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode2.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "string('trim')": function stringTrim(obj) {
                  with (obj) return string("trim");
                },
                "skip()": function (_skip) {
                  function skip(_x61) {
                    return _skip.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                }
              }).attachStringTable(Assets.strings).addStrings({
                tooltip: "Click to play.",
                rerecord: "Redo",
                "submit-video": "Confirm video",
                trim: "Trim",
                skip: "Skip"
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.State", ["base:States.State", "base:Events.ListenMixin", "base:Objs"], function (t, i, r, o) {
              return t.extend({
                scoped: o
              }, [i, {
                dynamics: ["loader"],
                _start: function _start() {
                  this.dyn = this.host.dynamic, r.iter(r.extend({
                    loader: !1,
                    message: !1,
                    playbutton: !1,
                    controlbar: !1
                  }, r.objectify(this.dynamics)), function (e, t) {
                    this.dyn.set(t + "_active", e);
                  }, this), this.dyn.parent() && this.dyn.parent().record !== undefined && this.dyn.parent().host !== undefined && (this.dyn._isRecorder = !0, this.dyn._recorderDyn = this.dyn.parent(), this.dyn._recorderHost = this.dyn._recorderDyn.host), this._started();
                },
                _started: function _started() {},
                play: function play() {
                  this.dyn.set("autoplay", !0);
                },
                uploadTextTrack: function uploadTextTrack(t, i) {
                  try {
                    this.next("TextTrackUploading", {
                      file: t,
                      locale: i
                    });
                  } catch (e) {
                    console.warn("Error switch to text track uploading state. Message: ", e), this.nextPlayer();
                  }
                },
                nextPlayer: function nextPlayer() {
                  var e = this.dyn.parent();
                  "function" == typeof e.record ? e.host.state().next("Player") : this.next("LoadPlayer");
                },
                nextToChooser: function nextToChooser(e) {
                  var t = this.dyn;
                  return !!t._isRecorder && "function" == typeof t._recorderHost.next && (t._recorderHost.next("FatalError", {
                    message: e,
                    retry: "Chooser"
                  }), !0);
                }
              }]);
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.TextTrackUploading", ["module:VideoPlayer.Dynamics.PlayerStates.State", "browser:Upload.FileUploader", "browser:Upload.MultiUploader", "browser:Blobs", "base:Async", "base:Objs"], function (t, s, i, x, r, c, o) {
              return t.extend({
                scoped: o
              }, {
                _locals: ["file", "locale"],
                dynamics: ["text-tracks", "loading"],
                _started: function _started() {
                  this.uploadTextTrackFile(this._file, this._locale);
                },
                uploadTextTrackFile: function uploadTextTrackFile(i, r) {
                  var t,
                    o,
                    a,
                    n = this.dyn.parent();
                  "function" != typeof n.record && (n = this.dyn), o = n.get("tracktags"), filename = n.get("uploadoptions") ? {
                    url: n.get("uploadoptions").textTracks
                  } : {
                    url: "/text-track/" + i.value.split(/(\\|\/)/g).pop() + "/lang/" + r.lang + "/label/" + r.label
                  };
                  try {
                    (t = s.create(c.extend({
                      source: i,
                      data: {
                        lang: r.lang,
                        label: r.label
                      }
                    }, filename))).upload(), t.on("success", function (t) {
                      a = 1, n.set("tracktags", null), x.loadFileIntoString(i).success(function (e) {
                        t = 0 < t.length ? JSON.parse(t) : {
                          lang: r.lang,
                          label: r.label
                        }, o.push({
                          lang: t.lang,
                          label: t.label,
                          kind: "subtitles",
                          enabled: !0,
                          content: e
                        }), c.iter(o, function (e) {
                          a === o.length && (n.set("tracktags", o), this.nextPlayer()), a++;
                        }, this);
                      }, this);
                    }, this), t.on("error", function (e) {
                      var i = n.string("uploading-failed");
                      try {
                        e.forEach(function (e) {
                          for (var t in e) n.string("upload-error-" + t) && (i = this.dyn.string("upload-error-" + t));
                        }, this);
                      } catch (t) {}
                      n.set("player_active", !1), this.next("FatalError", {
                        message: i,
                        retry: "Player"
                      });
                    }, this), t.on("progress", function (e, t) {}, this);
                  } catch (e) {
                    console.warn("Error occurred during uploading text track files. Message: ", e);
                  }
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.FatalError", ["module:VideoPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["message"],
                _locals: ["message"],
                _started: function _started() {
                  this.dyn.set("message", this._message || this.dyn.string("video-error"));
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.Initial", ["module:VideoPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.dyn.set("imageelement_active", !1), this.dyn.set("videoelement_active", !1), this.dyn.get("ready") ? this.next("LoadPlayer") : this.listenOn(this.dyn, "change:ready", function () {
                    this.next("LoadPlayer");
                  });
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.LoadPlayer", ["module:VideoPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.listenOn(this.dyn, "error:poster", function () {
                    this.next("LoadPlayerDirectly");
                  }, this), this.listenOn(this.dyn, "image-attached", function () {
                    this.next("PosterReady");
                  }, this), this.dyn.reattachImage();
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.LoadPlayerDirectly", ["module:VideoPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.listenOn(this.dyn, "error:attach", function () {
                    this.next("LoadError");
                  }, this), this.listenOn(this.dyn, "error:poster", function () {
                    this.dyn.get("states").poster_error.ignore || this.next("PosterError");
                  }, this), this.listenOn(this.dyn, "attached", function () {
                    this.next("PosterReady");
                  }, this), this.dyn.reattachVideo();
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.LoadError", ["module:VideoPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["message"],
                _started: function _started() {
                  this.dyn.set("message", this.dyn.string("video-error")), this.listenOn(this.dyn, "message:click", function () {
                    this.next("Initial");
                  }, this);
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.PosterReady", ["module:VideoPlayer.Dynamics.PlayerStates.State", "module:PopupHelper", "base:Objs"], function (e, i, r, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["playbutton"],
                _started: function _started() {
                  !this.dyn.get("skipinitial") && this.dyn.get("preload") && this.dyn._attachVideo(!0), this.dyn.trigger("ready_to_play"), this.dyn.trigger("loaded"), this.listenOn(this.dyn, "error:poster", function () {
                    this.dyn.get("states").poster_error.ignore || this.dyn.get("popup") || this.next("PosterError");
                  }, this), (this.dyn.get("autoplay") || this.dyn.get("skipinitial")) && this.play();
                },
                play: function play() {
                  var e, t;
                  this.dyn.set("silent_attach", !1), this.dyn.get("sticky") && this.dyn.stickyHandler.start(), this.dyn.get("popup") ? (e = this.auto_destroy(new i()), t = this.auto_destroy(new this.dyn.cls({
                    element: e.containerInner,
                    attrs: r.extend(this.dyn.cloneAttrs(), this.dyn.popupAttrs())
                  })), this._delegatedPlayer = t, this.dyn.delegateEvents(null, t), e.on("hide", function () {
                    this._delegatedPlayer = null, t.destroy(), e.destroy();
                  }, this), e.show(), t.activate()) : this.next("Preroll");
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.Preroll", ["module:VideoPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: [],
                _started: function _started() {
                  this.dyn._prerollAd ? (this.dyn._prerollAd.once("finished", function () {
                    this.next("LoadVideo");
                  }, this), this.dyn._prerollAd.once("adskipped", function () {
                    this.next("LoadVideo");
                  }, this), this.dyn._prerollAd.executeAd({
                    width: this.dyn.videoWidth(),
                    height: this.dyn.videoHeight()
                  })) : this.next("LoadVideo");
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.PosterError", ["module:VideoPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["message"],
                _started: function _started() {
                  this.dyn.set("message", this.dyn.string("video-error")), this.listenOn(this.dyn, "message:click", function () {
                    this.next(this.dyn.get("states").poster_error.click_play ? "LoadVideo" : "LoadPlayer");
                  }, this);
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.LoadVideo", ["module:VideoPlayer.Dynamics.PlayerStates.State", "browser:Info", "browser:Dom", "base:Timers.Timer"], function (e, t, i, r, o) {
              return e.extend({
                scoped: o
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.dyn.get("videoelement_active") ? this.__loadVideo() : (this.listenOn(this.dyn, "error:attach", function () {
                    this.next("LoadError");
                  }, this), this.listenOn(this.dyn, "error:poster", function () {
                    this.dyn.get("states").poster_error.ignore || this.next("PosterError");
                  }, this), this.listenOn(this.dyn, "attached", function () {
                    this.__loadVideo();
                  }, this), this.dyn.reattachVideo());
                },
                __loadVideo: function __loadVideo() {
                  var e;
                  this.listenOn(this.dyn, "error:video", function () {
                    this.next("ErrorVideo");
                  }, this), this.listenOn(this.dyn, "playing", function () {
                    this.destroyed() || this.dyn.destroyed() || (this.dyn.get("autoseek") && this.dyn.execute("seek", this.dyn.get("autoseek")), this.next("PlayVideo"));
                  }, this), this.dyn.get("skipinitial") && !this.dyn.get("autoplay") ? this.next("PlayVideo") : (e = 10, this.auto_destroy(new r({
                    context: this,
                    fire: function fire() {
                      this.destroyed() || this.dyn.destroyed() || !this.dyn.player || this.dyn.player.play(), 0 === --e && this.next("PlayVideo");
                    },
                    delay: 200,
                    immediate: !0
                  })));
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.ErrorVideo", ["module:VideoPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["message"],
                _started: function _started() {
                  this.dyn.set("message", this.dyn.string("video-error")), this.listenOn(this.dyn, "message:click", function () {
                    this.nextToChooser(this.dyn.get("message")) || this.next("LoadVideo");
                  }, this);
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.PlayVideo", ["module:VideoPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["controlbar"],
                _started: function _started() {
                  this.dyn.set("autoplay", !1), this.dyn.get("loop") && this.dyn.set("skipinitial", !0), this.listenOn(this.dyn, "change:currentstream", function () {
                    this.dyn.set("autoplay", !0), this.dyn.set("autoseek", this.dyn.player.position()), this.dyn.reattachVideo(), this.next("LoadPlayer");
                  }, this), this.listenOn(this.dyn, "ended", function () {
                    this.dyn.set("autoseek", null), this.next("NextVideo");
                  }, this), this.listenOn(this.dyn, "change:buffering", function () {
                    this.dyn.set("loader_active", this.dyn.get("buffering"));
                  }, this), this.listenOn(this.dyn, "error:video", function () {
                    this.next("ErrorVideo");
                  }, this);
                },
                play: function play() {
                  this.dyn.get("playing") || this.dyn.player.play();
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.PlayerStates.NextVideo", ["module:VideoPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                _started: function _started() {
                  if (this.dyn.get("playlist")) {
                    var e,
                      t,
                      i = this.dyn.get("playlist"),
                      r = i.shift();
                    if (this.dyn.get("initialoptions").playlist.push(r), 0 < i.length) return e = i[0], this.dyn.set("poster", e.poster), this.dyn.set("source", e.source), this.dyn.set("sources", e.sources), this._playNext(e);
                    if (t = this.dyn.get("initialoptions").playlist, this.dyn.set("lastplaylistitem", !0), this.dyn.trigger("last-playlist-item"), this.dyn.set("playlist", t), this.dyn.get("initialoptions").playlist = [], e = t[0], this.dyn.set("poster", e.poster), this.dyn.set("source", e.source), this.dyn.set("sources", e.sources), this.dyn.get("loopall")) return this._playNext(e);
                    this.dyn.reattachVideo();
                  } else this.dyn.get("loopall") && (this.dyn.set("loop", !0), this.dyn.set("autoplay", !0), this.dyn.reattachVideo());
                  this.next("PosterReady");
                },
                _playNext: function _playNext(e) {
                  this.dyn.trigger("playlist-next", e), this.dyn.reattachVideo(), this.dyn.set("autoplay", !0), this.next("LoadPlayer");
                }
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.Share", ["dynamics:Dynamic", "module:Assets"], function (Class, Assets, scoped) {
              var SHARES = {
                facebook: "https://facebook.com/sharer/sharer.php?u=",
                twitter: "https://twitter.com/intent/tweet?text=",
                gplus: "https://plus.google.com/share?url="
              };
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<div class="{{cssplayer}}-share-action-container">\n    <div class="{{cssplayer}}-toggle-share-container">\n        <div class="{{cssplayer}}-button-inner" onclick="{{toggleShare()}}">\n            <i class="{{csscommon}}-icon-share"></i>\n        </div>\n    </div>\n    <div class="{{cssplayer}}-social-buttons-container">\n        <ul class="{{cssplayer}}-socials-list" ba-repeat="{{share :: shares}}">\n            <li class="{{cssplayer}}-single-social">\n                <div class="{{cssplayer}}-button-inner">\n                    <i class="{{csscommon}}-icon-{{share}}" onclick="{{shareMedia(share)}}"></i>\n                </div>\n            </li>\n        </ul>\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-videoplayer",
                    csscommon: "ba-commoncss",
                    cssplayer: "ba-player",
                    url: "",
                    shares: []
                  },
                  functions: {
                    shareMedia: function shareMedia(e) {
                      window.open(SHARES[e] + this.get("url"), "pop", "width=600 height=400");
                    },
                    toggleShare: function toggleShare() {}
                  }
                };
              }).register("ba-videoplayer-share").registerFunctions({
                cssplayer: function (_cssplayer4) {
                  function cssplayer(_x62) {
                    return _cssplayer4.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer4.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "toggleShare()": function (_toggleShare) {
                  function toggleShare(_x63) {
                    return _toggleShare.apply(this, arguments);
                  }
                  toggleShare.toString = function () {
                    return _toggleShare.toString();
                  };
                  return toggleShare;
                }(function (obj) {
                  with (obj) return toggleShare();
                }),
                csscommon: function (_csscommon3) {
                  function csscommon(_x64) {
                    return _csscommon3.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon3.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                shares: function (_shares) {
                  function shares(_x65) {
                    return _shares.apply(this, arguments);
                  }
                  shares.toString = function () {
                    return _shares.toString();
                  };
                  return shares;
                }(function (obj) {
                  with (obj) return shares;
                }),
                share: function (_share) {
                  function share(_x66) {
                    return _share.apply(this, arguments);
                  }
                  share.toString = function () {
                    return _share.toString();
                  };
                  return share;
                }(function (obj) {
                  with (obj) return share;
                }),
                "shareMedia(share)": function shareMediaShare(obj) {
                  with (obj) return shareMedia(share);
                }
              }).attachStringTable(Assets.strings).addStrings({
                share: "Share media"
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.Topmessage", ["dynamics:Dynamic"], function (Class, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: "\n<div class=\"{{css}}-topmessage-container\">\n    <div class='{{css}}-topmessage-background'>\n    </div>\n    <div data-selector=\"topmessage-message-block\" class='{{css}}-topmessage-message'>\n        {{topmessage}}\n    </div>\n</div>\n",
                  attrs: {
                    css: "ba-videoplayer",
                    csscommon: "ba-commoncss",
                    cssplayer: "ba-player",
                    topmessage: ""
                  }
                };
              }).registerFunctions({
                css: function (_css5) {
                  function css(_x67) {
                    return _css5.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css5.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                topmessage: function (_topmessage) {
                  function topmessage(_x68) {
                    return _topmessage.apply(this, arguments);
                  }
                  topmessage.toString = function () {
                    return _topmessage.toString();
                  };
                  return topmessage;
                }(function (obj) {
                  with (obj) return topmessage;
                })
              }).register("ba-videoplayer-topmessage");
            }), Scoped.define("module:VideoPlayer.Dynamics.Tracks", ["dynamics:Dynamic", "base:Objs", "base:Async", "module:Assets"], ["dynamics:Partials.ClickPartial", "dynamics:Partials.RepeatElementPartial"], function (Class, Objs, Async, Assets, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<div data-selector="text-tracks-overlay"\n     class="{{cssplayer}}-text-tracks-overlay\n     {{activitydelta > hidebarafter && hideoninactivity ? (cssplayer + \'-track-dashboard-hidden\') : \'\'}}\n">\n\n    <div data-selector="cue-content" ba-show="{{tracktagsstyled && trackcuetext}}" class="{{cssplayer}}-cue-content">\n        {{trackcuetext}}\n    </div>\n    <div class="{{csscommon}}-options-popup {{csscommon}}-options-list-{{tracksshowselection || trackselectorhovered ? \'visible\' : \'hidden\'}}">\n        <div ba-show="{{tracksshowselection || trackselectorhovered}}" tabindex="-1"\n             onmouseenter="{{hover_cc(domEvent, true)}}" onmouseover="{{hover_cc(domEvent, true)}}" onmouseleave="{{hover_cc(domEvent, false)}}"\n        >\n            <div data-selector="tracks-selector-list"\n                 class="{{csscommon}}-initial-options-list {{csscommon}}-tracks-selector-list {{csscommon}}-options-list-visible {{csscommon}}-options-list"\n                 ba-if="{{tracktags}}"\n            >\n                <div ba-repeat-element="{{track :: tracktags}}"\n                     class="{{csscommon}}-tracks-selector {{csscommon}}-options-list-item"\n                     ba-click="{{select_track(track)}}"\n                     ba-show="{{track.label && texttrackslength > 1}}"\n                >\n                    <div class="{{csscommon}}-inner-text">\n                        {{track.label}}\n                    </div>\n                </div>\n                <div data-selector="text-tracks-open-form-button"\n                     class="{{csscommon}}-options-list-item {{csscommon}}-open-next"\n                     ba-if="{{allowtexttrackupload}}" title="{{string(\'upload-text-tracks\')}}"\n                     onclick="{{move_to_option(domEvent, \'text-tracks-uploader-form\')}}"\n                >\n                    <div class="{{csscommon}}-inner-text">{{string(\'upload-text-tracks\')}}</div>\n                    <div class="{{csscommon}}-inner-icon"></div>\n                </div>\n            </div>\n\n            <div data-selector="text-tracks-uploader-form"\n                 class="{{csscommon}}-options-list-hidden {{csscommon}}-options-list {{csscommon}}-text-tracks-uploader-form"\n                 ba-if="{{allowtexttrackupload}}"\n            >\n                <div class="{{csscommon}}-full-width {{csscommon}}-options-list-item">\n                    <div data-selector="close-text-tracks-upload-form"\n                         title="{{string(\'back\')}}"\n                         class="{{csscommon}}-open-previous {{csscommon}}-text-left"\n                         onclick="{{move_to_option(domEvent)}}"\n                    >\n                        <div class="{{csscommon}}-inner-icon"></div>\n                        <div class="{{csscommon}}-inner-text">{{string(\'back\')}}</div>\n                    </div>\n                </div>\n\n                <div class="{{csscommon}}-full-width {{csscommon}}-options-list-item">\n                    <form class="{{csscommon}}-form {{csscommon}}-text-tracks-upload-form">\n                        <div class="{{csscommon}}-form-input {{csscommon}}-select-field {{csscommon}}-direction-pointer">\n                            <select data-selector="select-text-tracks-label" tabindex="-1"\n                                    class="{{csscommon}}-form-input {{csscommon}}-text-tracks-label-input"\n                                    name="{{csscommon}}-text-tracks-label-select"\n                                    onmousedown="{{prevent_un_hover(domEvent)}}"\n                                    onmousemove="{{prevent_un_hover(domEvent)}}"\n                                    onchange="{{selected_label_value(domEvent)}}"\n                            >\n                                <option disabled value selected>\n                                    {{string(\'select-text-track-language\')}}\n                                </option>\n                                <option ba-repeat-element="{{locale :: uploadlocales}}" value="{{locale.lang}}">\n                                    {{locale.label}}\n                                </option>\n                            </select>\n                        </div>\n                        <div class="{{csscommon}}-form-input {{csscommon}}-button" ba-show="{{chosenoption}}">\n                            <input type="file" data-selector="select-text-tracks-file"\n                                   title="{{chosenoption ? string(\'select-text-track-file\') : string(\'info-select-locale-first\')}}"\n                                   onchange="{{upload_text_track(domEvent)}}"\n                                   class="{{csscommon}}-text-tracks-file"\n                                   accept="{{acceptedtracktexts}}"\n                            />\n                            {{chosenoption ? string(\'select-text-track-file\') : string(\'info-select-locale-first\')}}\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-videoplayer",
                    csscommon: "ba-commoncss",
                    cssplayer: "ba-player",
                    trackcuetext: null,
                    acceptedtracktexts: "text/vtt,application/ttml+xml,type/subtype",
                    trackselectorhovered: !1,
                    texttrackslength: 0,
                    uploadtexttracksvisible: !1,
                    uploadlocales: [],
                    chosenoption: null
                  },
                  create: function create() {
                    Objs.iter(this.get("tracktags"), function (e) {
                      "subtitles" === e.kind && this.set("texttrackslength", this.get("texttrackslength") + 1);
                    }, this);
                  },
                  functions: {
                    select_track: function select_track(e) {
                      this.parent().set("trackselectorhovered", !1), this.parent().trigger("switch-track", e);
                    },
                    hover_cc: function hover_cc(e, t) {
                      if (!this.parent().get("settingsmenu_active")) {
                        if (t || e[0].target !== document.activeElement) return this.parent().set("trackselectorhovered", t);
                        Async.eventually(function () {
                          e[0].target.blur();
                        }, this, 500);
                      }
                    },
                    prevent_un_hover: function prevent_un_hover(e) {
                      var t, i;
                      return e[0].target.blur(), t = "." + this.parent().get("csscommon") + "-options-popup", (i = document.querySelector(t)) && i.focus(), this.parent().set("trackselectorhovered", !0);
                    },
                    selected_label_value: function selected_label_value(e) {
                      var t = e[0].target.options,
                        i = t[t.selectedIndex];
                      i.value ? this.set("chosenoption", {
                        lang: i.value,
                        label: i.text
                      }) : this.set("chosenoption", null);
                    },
                    upload_text_track: function upload_text_track(e) {
                      this.get("chosenoption") ? this.trigger("upload-text-tracks", e[0].target, this.get("chosenoption")) : console.warn("can not send empty label");
                    },
                    move_to_option: function move_to_option(e, t) {
                      this.trigger("move_to_option", e[0].target, t);
                    }
                  }
                };
              }).register("ba-videoplayer-tracks").registerFunctions({
                cssplayer: function (_cssplayer5) {
                  function cssplayer(_x69) {
                    return _cssplayer5.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer5.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "activitydelta > hidebarafter && hideoninactivity ? (cssplayer + '-track-dashboard-hidden') : ''": function activitydeltaHidebarafterHideoninactivityCssplayerTrackDashboardHidden(obj) {
                  with (obj) return activitydelta > hidebarafter && hideoninactivity ? cssplayer + "-track-dashboard-hidden" : "";
                },
                "tracktagsstyled && trackcuetext": function tracktagsstyledTrackcuetext(obj) {
                  with (obj) return tracktagsstyled && trackcuetext;
                },
                trackcuetext: function (_trackcuetext) {
                  function trackcuetext(_x70) {
                    return _trackcuetext.apply(this, arguments);
                  }
                  trackcuetext.toString = function () {
                    return _trackcuetext.toString();
                  };
                  return trackcuetext;
                }(function (obj) {
                  with (obj) return trackcuetext;
                }),
                csscommon: function (_csscommon4) {
                  function csscommon(_x71) {
                    return _csscommon4.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon4.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "tracksshowselection || trackselectorhovered ? 'visible' : 'hidden'": function tracksshowselectionTrackselectorhoveredVisibleHidden(obj) {
                  with (obj) return tracksshowselection || trackselectorhovered ? "visible" : "hidden";
                },
                "tracksshowselection || trackselectorhovered": function tracksshowselectionTrackselectorhovered(obj) {
                  with (obj) return tracksshowselection || trackselectorhovered;
                },
                "hover_cc(domEvent, true)": function hover_ccDomEventTrue(obj) {
                  with (obj) return hover_cc(domEvent, !0);
                },
                "hover_cc(domEvent, false)": function hover_ccDomEventFalse(obj) {
                  with (obj) return hover_cc(domEvent, !1);
                },
                tracktags: function (_tracktags) {
                  function tracktags(_x72) {
                    return _tracktags.apply(this, arguments);
                  }
                  tracktags.toString = function () {
                    return _tracktags.toString();
                  };
                  return tracktags;
                }(function (obj) {
                  with (obj) return tracktags;
                }),
                "select_track(track)": function select_trackTrack(obj) {
                  with (obj) return select_track(track);
                },
                "track.label && texttrackslength > 1": function trackLabelTexttrackslength1(obj) {
                  with (obj) return track.label && 1 < texttrackslength;
                },
                "track.label": function trackLabel(obj) {
                  with (obj) return track.label;
                },
                allowtexttrackupload: function (_allowtexttrackupload) {
                  function allowtexttrackupload(_x73) {
                    return _allowtexttrackupload.apply(this, arguments);
                  }
                  allowtexttrackupload.toString = function () {
                    return _allowtexttrackupload.toString();
                  };
                  return allowtexttrackupload;
                }(function (obj) {
                  with (obj) return allowtexttrackupload;
                }),
                "string('upload-text-tracks')": function stringUploadTextTracks(obj) {
                  with (obj) return string("upload-text-tracks");
                },
                "move_to_option(domEvent, 'text-tracks-uploader-form')": function move_to_optionDomEventTextTracksUploaderForm(obj) {
                  with (obj) return move_to_option(domEvent, "text-tracks-uploader-form");
                },
                "string('back')": function stringBack(obj) {
                  with (obj) return string("back");
                },
                "move_to_option(domEvent)": function move_to_optionDomEvent(obj) {
                  with (obj) return move_to_option(domEvent);
                },
                "prevent_un_hover(domEvent)": function prevent_un_hoverDomEvent(obj) {
                  with (obj) return prevent_un_hover(domEvent);
                },
                "selected_label_value(domEvent)": function selected_label_valueDomEvent(obj) {
                  with (obj) return selected_label_value(domEvent);
                },
                "string('select-text-track-language')": function stringSelectTextTrackLanguage(obj) {
                  with (obj) return string("select-text-track-language");
                },
                uploadlocales: function (_uploadlocales) {
                  function uploadlocales(_x74) {
                    return _uploadlocales.apply(this, arguments);
                  }
                  uploadlocales.toString = function () {
                    return _uploadlocales.toString();
                  };
                  return uploadlocales;
                }(function (obj) {
                  with (obj) return uploadlocales;
                }),
                "locale.lang": function localeLang(obj) {
                  with (obj) return locale.lang;
                },
                "locale.label": function localeLabel(obj) {
                  with (obj) return locale.label;
                },
                chosenoption: function (_chosenoption) {
                  function chosenoption(_x75) {
                    return _chosenoption.apply(this, arguments);
                  }
                  chosenoption.toString = function () {
                    return _chosenoption.toString();
                  };
                  return chosenoption;
                }(function (obj) {
                  with (obj) return chosenoption;
                }),
                "chosenoption ? string('select-text-track-file') : string('info-select-locale-first')": function chosenoptionStringSelectTextTrackFileStringInfoSelectLocaleFirst(obj) {
                  with (obj) return chosenoption ? string("select-text-track-file") : string("info-select-locale-first");
                },
                "upload_text_track(domEvent)": function upload_text_trackDomEvent(obj) {
                  with (obj) return upload_text_track(domEvent);
                },
                acceptedtracktexts: function (_acceptedtracktexts) {
                  function acceptedtracktexts(_x76) {
                    return _acceptedtracktexts.apply(this, arguments);
                  }
                  acceptedtracktexts.toString = function () {
                    return _acceptedtracktexts.toString();
                  };
                  return acceptedtracktexts;
                }(function (obj) {
                  with (obj) return acceptedtracktexts;
                })
              }).attachStringTable(Assets.strings).addStrings({
                "upload-text-tracks": "Upload track text files",
                "select-text-track-language": "Subtitle Language",
                "info-select-locale-first": "First select locale",
                "select-text-track-file": "Click to select file",
                back: "back"
              });
            }), Scoped.define("module:VideoPlayer.Dynamics.Player", ["dynamics:Dynamic", "module:Assets", "module:StickyHandler", "module:StylesMixin", "module:TrackTags", "browser:Info", "browser:Dom", "media:Player.VideoPlayerWrapper", "media:Player.Broadcasting", "base:Types", "base:Objs", "base:Strings", "base:Time", "base:Timers", "base:TimeFormat", "base:States.Host", "base:Classes.ClassRegistry", "base:Async", "module:VideoPlayer.Dynamics.PlayerStates.Initial", "module:VideoPlayer.Dynamics.PlayerStates", "module:Ads.AbstractVideoAdProvider", "browser:Events"], ["module:Common.Dynamics.Settingsmenu", "module:VideoPlayer.Dynamics.Playbutton", "module:VideoPlayer.Dynamics.Message", "module:VideoPlayer.Dynamics.Loader", "module:VideoPlayer.Dynamics.Share", "module:VideoPlayer.Dynamics.Controlbar", "module:VideoPlayer.Dynamics.Tracks", "dynamics:Partials.EventPartial", "dynamics:Partials.OnPartial", "dynamics:Partials.TogglePartial", "dynamics:Partials.StylesPartial", "dynamics:Partials.TemplatePartial", "dynamics:Partials.HotkeyPartial"], function (Class, Assets, StickyHandler, StylesMixin, TrackTags, Info, Dom, VideoPlayerWrapper, Broadcasting, Types, Objs, Strings, Time, Timers, TimeFormat, Host, ClassRegistry, Async, InitialState, PlayerStates, AdProvider, DomEvents, scoped) {
              return Class.extend({
                scoped: scoped
              }, [StylesMixin, function (r) {
                return {
                  template: '<div itemscope itemtype="http://schema.org/VideoObject"\n     class="{{css}}-container {{cssplayer}}-size-{{csssize}} {{iecss}}-{{ie8 ? \'ie8\' : \'noie8\'}} {{csstheme}}\n     {{cssplayer}}-{{fullscreened ? \'fullscreen\' : \'normal\'}}-view {{cssplayer}}-{{firefox ? \'firefox\' : \'common\'}}-browser\n     {{cssplayer}}-{{themecolor}}-color {{cssplayer}}-device-type-{{mobileview ? \'mobile\' : \'desktop\'}}\n     {{sticktoview ? csscommon + \'-sticky\' : \'\'}} {{sticktoview && fadeup ? csscommon + \'-fade-up\' : \'\'}}"\n     ba-on:mousemove="{{user_activity()}}"\n     ba-on:mousedown="{{user_activity(true)}}"\n     ba-on:touchstart="{{user_activity(true)}}"\n     ba-styles="{{containerSizingStyles}}"\n>\n    <meta itemprop="name" content="{{title || \'Video Player\'}}" />\n    <meta itemprop="description" content="{{description || \'Video Player\'}}" />\n    <meta itemprop="uploadDate" content="{{uploaddate}}" />\n    <div ba-show="{{(videoelement_active || !imageelement_active) && !silent_attach}}" class="{{css}}-video-container">\n        <video tabindex="-1" class="{{css}}-video {{csscommon}}-{{videofitstrategy}}-fit" data-video="video"\n               preload="{{preload ? \'auto\' : \'metadata\'}}"\n               ba-toggle:playsinline="{{!playfullscreenonmobile}}"\n        ></video>\n    </div>\n    <div ba-show="{{(imageelement_active && !videoelement_active) || silent_attach}}" class="{{css}}-poster-container">\n        <img tabindex="-1" data-image="image" alt="{{posteralt}}" class="{{csscommon}}-{{posterfitstrategy}}-fit"/>\n    </div>\n    <div class="{{css}}-overlay" ba-show="{{!showbuiltincontroller}}">\n        <div tabindex="-1" class="{{css}}-player-toggle-overlay" data-selector="player-toggle-overlay"\n             ba-hotkey:right="{{seek(position + skipseconds)}}" ba-hotkey:left="{{seek(position - skipseconds)}}"\n             ba-hotkey:alt+right="{{seek(position + skipseconds * 3)}}" ba-hotkey:alt+left="{{seek(position - skipseconds * 3)}}"\n             ba-hotkey:up="{{set_volume(volume + 0.1)}}" ba-hotkey:down="{{set_volume(volume - 0.1)}}"\n             ba-hotkey:space^enter="{{toggle_player()}}"\n             ba-on:mouseup="{{toggle_player()}}"\n             ba-on:touchend="{{toggle_player()}}"\n        ></div>\n        <ba-{{dyntrimmer}}\n            ba-show="{{trimmingmode && videoelement_active}}"\n            ba-playing="{{playing}}"\n            ba-startposition="{{=starttime}}"\n            ba-position="{{position}}"\n            ba-endposition="{{=endtime}}"\n            ba-minduration="{{timeminlimit}}"\n            ba-duration="{{duration}}"\n            ba-source="{{source}}"\n            ba-event:play="play"\n            ba-event:pause="pause"\n            ba-event:seek="seek"\n        ></ba-{{dyntrimmer}}>\n        <ba-{{dyncontrolbar}}\n            ba-css="{{csscontrolbar || css}}"\n            ba-cssplayer="{{cssplayer || css}}"\n            ba-csstheme="{{csstheme || css}}"\n            ba-themecolor="{{themecolor}}"\n            ba-template="{{tmplcontrolbar}}"\n            ba-show="{{controlbar_active && !hidecontrolbar}}"\n            ba-playing="{{playing}}"\n            ba-playwhenvisible="{{playwhenvisible}}"\n            ba-playerspeeds="{{playerspeeds}}"\n            ba-playercurrentspeed="{{playercurrentspeed}}"\n            ba-airplay="{{airplay}}"\n            ba-airplaybuttonvisible="{{airplaybuttonvisible}}"\n            ba-chromecast="{{chromecast}}"\n            ba-castbuttonvisble="{{castbuttonvisble}}"\n            ba-event:rerecord="rerecord"\n            ba-event:submit="submit"\n            ba-event:play="play"\n            ba-event:pause="pause"\n            ba-event:position="seek"\n            ba-event:volume="set_volume"\n            ba-event:set_speed="set_speed"\n            ba-event:settings_menu="toggle_settings_menu"\n            ba-event:fullscreen="toggle_fullscreen"\n            ba-event:toggle_player="toggle_player"\n            ba-event:tab_index_move="tab_index_move"\n            ba-event:seek="seek"\n            ba-event:set_volume="set_volume"\n            ba-event:toggle_tracks="toggle_tracks"\n            ba-tabindex="{{tabindex}}"\n            ba-showchaptertext="{{showchaptertext}}"\n            ba-chapterslist="{{chapterslist}}"\n            ba-tracktextvisible="{{tracktextvisible}}"\n            ba-tracktags="{{tracktags}}"\n            ba-showsubtitlebutton="{{hassubtitles && tracktagssupport}}"\n            ba-allowtexttrackupload="{{allowtexttrackupload}}"\n            ba-tracksshowselection="{{tracksshowselection}}"\n            ba-volume="{{volume}}"\n            ba-duration="{{duration}}"\n            ba-cached="{{buffered}}"\n            ba-title="{{title}}"\n            ba-position="{{position}}"\n            ba-activitydelta="{{activity_delta}}"\n            ba-hideoninactivity="{{hideoninactivity}}"\n            ba-hidebarafter="{{hidebarafter}}"\n            ba-rerecordable="{{rerecordable}}"\n            ba-submittable="{{submittable}}"\n            ba-frameselectionmode="{{frameselectionmode}}"\n            ba-timeminlimit="{{timeminlimit}}"\n            ba-streams="{{streams}}"\n            ba-currentstream="{{=currentstream}}"\n            ba-fullscreen="{{fullscreensupport && !nofullscreen}}"\n            ba-fullscreened="{{fullscreened}}"\n            ba-source="{{source}}"\n            ba-disablepause="{{disablepause}}"\n            ba-disableseeking="{{disableseeking}}"\n            ba-skipseconds="{{skipseconds}}"\n            ba-skipinitial="{{skipinitial}}"\n            ba-settingsmenubutton="{{showsettingsmenu}}"\n            ba-settingsmenuactive="{{settingsmenu_active}}"\n            ba-hidevolumebar="{{hidevolumebar}}"\n            ba-manuallypaused="{{manuallypaused}}"\n        ></ba-{{dyncontrolbar}}>\n\n        <ba-{{dyntracks}}\n            ba-css="{{csstracks || css}}"\n            ba-csstheme="{{csstheme || css}}"\n            ba-cssplayer="{{cssplayer || css}}"\n            ba-show="{{tracktagssupport || allowtexttrackupload}}"\n            ba-tracksshowselection="{{tracksshowselection}}"\n            ba-trackselectorhovered="{{trackselectorhovered}}"\n            ba-tracktags="{{tracktags}}"\n            ba-hidebarafter="{{hidebarafter}}"\n            ba-tracktagsstyled="{{tracktagsstyled}}"\n            ba-trackcuetext="{{trackcuetext}}"\n            ba-allowtexttrackupload="{{allowtexttrackupload}}"\n            ba-uploadtexttracksvisible="{{uploadtexttracksvisible}}"\n            ba-acceptedtracktexts="{{acceptedtracktexts}}"\n            ba-uploadlocales="{{uploadlocales}}"\n            ba-activitydelta="{{activity_delta}}"\n            ba-hideoninactivity="{{hideoninactivity}}"\n            ba-event:selected_label_value="selected_label_value"\n            ba-event:upload-text-tracks="upload_text_tracks"\n            ba-event:move_to_option="move_to_option"\n        ></ba-{{dyntracks}}>\n\n        <ba-{{dynsettingsmenu}}\n            ba-css="{{css}}"\n            ba-csstheme="{{csstheme || css}}"\n            ba-show="{{settingsmenu_active}}"\n            ba-template="{{tmplsettingsmenu}}"\n        ></ba-{{dynsettingsmenu}}>\n\n        <ba-{{dynplaybutton}}\n            ba-css="{{cssplaybutton || css}}"\n            ba-csstheme="{{csstheme || css}}"\n            ba-cssplayer="{{cssplayer || css}}"\n            ba-theme-color="{{themecolor}}"\n            ba-template="{{tmplplaybutton}}"\n            ba-show="{{playbutton_active}}"\n            ba-rerecordable="{{rerecordable}}"\n            ba-submittable="{{submittable}}"\n            ba-trimmingmode="{{trimmingmode}}"\n            ba-showduration="{{showduration}}"\n\t\t\t      ba-duration="{{duration}}"\n            ba-event:play="playbutton_click"\n            ba-event:rerecord="rerecord"\n            ba-event:submit="submit"\n            ba-event:tab_index_move="tab_index_move"\n        ></ba-{{dynplaybutton}}>\n\n        <ba-{{dynloader}}\n            ba-css="{{cssloader || css}}"\n            ba-csstheme="{{csstheme || css}}"\n            ba-cssplayer="{{cssplayer || css}}"\n            ba-theme-color="{{themecolor}}"\n            ba-template="{{tmplloader}}"\n            ba-playwhenvisible="{{playwhenvisible}}"\n            ba-show="{{loader_active}}"\n        ></ba-{{dynloader}}>\n\n        <ba-{{dynshare}}\n            ba-css="{{cssshare || css}}"\n            ba-csstheme="{{csstheme || css}}"\n            ba-cssplayer="{{cssplayer || css}}"\n            ba-theme-color="{{themecolor}}"\n            ba-template="{{tmplshare}}"\n            ba-show="{{sharevideourl && sharevideo.length > 0}}"\n            ba-url="{{sharevideourl}}"\n            ba-shares="{{sharevideo}}"\n        ></ba-{{dynshare}}>\n\n        <ba-{{dynmessage}}\n            ba-css="{{cssmessage || css}}"\n            ba-csstheme="{{csstheme || css}}"\n            ba-cssplayer="{{cssplayer || css}}"\n            ba-theme-color="{{themecolor}}"\n            ba-template="{{tmplmessage}}"\n            ba-show="{{message_active}}"\n            ba-message="{{message}}"\n            ba-event:click="message_click"\n        ></ba-{{dynmessage}}>\n\n        <ba-{{dyntopmessage}}\n            ba-css="{{csstopmessage || css}}"\n            ba-csstheme="{{csstheme || css}}"\n            ba-cssplayer="{{cssplayer || css}}"\n            ba-theme-color="{{themecolor}}"\n            ba-template="{{tmpltopmessage}}"\n            ba-show="{{topmessage}}"\n            ba-topmessage="{{topmessage}}"\n        ></ba-{{dyntopmessage}}>\n\n        <meta itemprop="caption" content="{{title}}" />\n        <meta itemprop="thumbnailUrl" content="{{thumbnailurl}}"/>\n        <meta itemprop="contentUrl" content="{{contenturl}}"/>\n    </div>\n    <div class="{{css}}-overlay" data-video="ad" style="display:none"></div>\n    <div ba-show="{{useAspectRatioFallback}}" ba-styles="{{aspectRatioFallback}}"></div>\n</div>\n',
                  attrs: {
                    css: "ba-videoplayer",
                    csscommon: "ba-commoncss",
                    cssplayer: "ba-player",
                    iecss: "ba-videoplayer",
                    cssplaybutton: "",
                    cssloader: "",
                    cssmessage: "",
                    csstopmessage: "",
                    csscontrolbar: "",
                    csstracks: "",
                    width: "",
                    height: "",
                    "popup-width": "",
                    "popup-height": "",
                    aspectratio: null,
                    "fallback-width": 320,
                    "fallback-height": 240,
                    theme: "",
                    csstheme: "",
                    themecolor: "",
                    dynplaybutton: "videoplayer-playbutton",
                    dynloader: "videoplayer-loader",
                    dynmessage: "videoplayer-message",
                    dyntopmessage: "videoplayer-topmessage",
                    dyncontrolbar: "videoplayer-controlbar",
                    dynshare: "videoplayer-share",
                    dyntracks: "videoplayer-tracks",
                    dynsettingsmenu: "common-settingsmenu",
                    dyntrimmer: "videorecorder-trimmer",
                    tmplplaybutton: "",
                    tmplloader: "",
                    tmplmessage: "",
                    tmplshare: "",
                    tmpltopmessage: "",
                    tmplcontrolbar: "",
                    tmpltracks: "",
                    tmplsettingsmenu: "",
                    poster: "",
                    source: "",
                    sources: [],
                    sourcefilter: {},
                    streams: [],
                    currentstream: null,
                    playlist: null,
                    volume: 1,
                    title: "",
                    description: "",
                    uploaddate: "",
                    contenturl: "",
                    thumbnailurl: "",
                    initialseek: null,
                    sharevideo: [],
                    sharevideourl: "",
                    visibilityfraction: .8,
                    reloadonplay: !1,
                    playonclick: !0,
                    pauseonclick: !0,
                    adprovider: null,
                    preroll: !1,
                    allowpip: !0,
                    rerecordable: !1,
                    submittable: !1,
                    autoplay: !1,
                    preload: !1,
                    loop: !1,
                    loopall: !1,
                    popup: !1,
                    nofullscreen: !1,
                    fullscreenmandatory: !1,
                    playfullscreenonmobile: !1,
                    fitonwidth: !1,
                    fitonheight: !1,
                    "popup-stretch": !1,
                    hideoninactivity: !0,
                    hidebarafter: 5e3,
                    preventinteraction: !1,
                    skipinitial: !1,
                    topmessage: "",
                    totalduration: null,
                    playwhenvisible: !1,
                    minwidth: 240,
                    minheight: 180,
                    maxwidth: null,
                    maxheight: null,
                    disablepause: !1,
                    disableseeking: !1,
                    tracktextvisible: !1,
                    airplay: !1,
                    chromecast: !1,
                    chromecastreceiverappid: null,
                    skipseconds: 5,
                    sticky: !1,
                    tracktags: [],
                    tracktagsstyled: !0,
                    tracktaglang: "en",
                    tracksshowselection: !1,
                    showchaptertext: !0,
                    thumbimage: {},
                    thumbcuelist: [],
                    showduration: !1,
                    showsettingsmenu: !0,
                    posteralt: "",
                    hidevolumebar: !1,
                    hidecontrolbar: !1,
                    allowtexttrackupload: !1,
                    uploadtexttracksvisible: !1,
                    acceptedtracktexts: null,
                    uploadlocales: [{
                      lang: "en",
                      label: "English"
                    }],
                    ttuploadervisible: !1,
                    videofitstrategy: "pad",
                    posterfitstrategy: "crop",
                    showbuiltincontroller: !1,
                    airplaybuttonvisible: !1,
                    castbuttonvisble: !1,
                    fullscreened: !1,
                    initialoptions: {
                      hideoninactivity: null,
                      volumelevel: null,
                      playlist: []
                    },
                    silent_attach: !1,
                    inpipmode: !1,
                    lastplaylistitem: !1,
                    manuallypaused: !1,
                    playedonce: !1,
                    preventinteractionstatus: !1,
                    ready: !0,
                    tracktagssupport: !1,
                    playbackcount: 0,
                    playbackended: 0,
                    currentchapterindex: 0,
                    chapterslist: [],
                    states: {
                      poster_error: {
                        ignore: !1,
                        click_play: !0
                      }
                    },
                    playerorientation: undefined,
                    forciblymuted: !1,
                    volumeafterinteraction: !1
                  },
                  types: {
                    allowpip: "boolean",
                    rerecordable: "boolean",
                    loop: "boolean",
                    loopall: "boolean",
                    autoplay: "boolean",
                    preload: "boolean",
                    ready: "boolean",
                    nofullscreen: "boolean",
                    fullscreenmandatory: "boolean",
                    preroll: "boolean",
                    hideoninactivity: "boolean",
                    hidebarafter: "integer",
                    preventinteraction: "boolean",
                    skipinitial: "boolean",
                    volume: "float",
                    popup: "boolean",
                    "popup-stretch": "boolean",
                    "popup-width": "int",
                    "popup-height": "int",
                    aspectratio: "float",
                    "fallback-width": "int",
                    "fallback-height": "int",
                    initialseek: "float",
                    fullscreened: "boolean",
                    sharevideo: "array",
                    sharevideourl: "string",
                    playfullscreenonmobile: "boolean",
                    themecolor: "string",
                    totalduration: "float",
                    playwhenvisible: "boolean",
                    playedonce: "boolean",
                    manuallypaused: "boolean",
                    minwidth: "int",
                    minheight: "int",
                    maxwidth: "int",
                    maxheight: "int",
                    disablepause: "boolean",
                    disableseeking: "boolean",
                    playonclick: "boolean",
                    pauseonclick: "boolean",
                    airplay: "boolean",
                    airplaybuttonvisible: "boolean",
                    chromecast: "boolean",
                    chromecastreceiverappid: "string",
                    skipseconds: "integer",
                    sticky: "boolean",
                    streams: "jsonarray",
                    sources: "jsonarray",
                    tracktags: "jsonarray",
                    tracktagsstyled: "boolean",
                    allowtexttrackupload: "boolean",
                    uploadtexttracksvisible: "boolean",
                    acceptedtracktexts: "string",
                    uploadlocales: "array",
                    playerspeeds: "array",
                    playercurrentspeed: "float",
                    showsettings: "boolean",
                    showduration: "boolean",
                    visibilityfraction: "float",
                    showchaptertext: "boolean",
                    title: "string",
                    description: "string",
                    uploaddate: "string",
                    contenturl: "string",
                    thumbnailurl: "string",
                    videofitstrategy: "string",
                    posterfitstrategy: "string"
                  },
                  extendables: ["states"],
                  scopes: {
                    settingsmenu: ">[tagname='ba-common-settingsmenu']"
                  },
                  events: {
                    "change:uploaddate": function changeUploaddate(e) {
                      "number" == typeof e && this.set("uploaddate", TimeFormat.format("yyyy-mm-dd", 1e3 * e));
                    },
                    "change:starttime": function changeStarttime(e) {
                      e > this.getCurrentPosition() && this.player.setPosition(e);
                    },
                    "change:endtime": function changeEndtime(e) {
                      e && e !== this.get("duration") ? (e < this.getCurrentPosition() && this.player.setPosition(e), this.get("_timeUpdateEventHandler") || this.set("_timeUpdateEventHandler", this.auto_destroy(new DomEvents())), this.get("_timeUpdateEventHandler").__callbacks.timeupdate || this.get("_timeUpdateEventHandler").on(this.player._element, "timeupdate", function () {
                        this.getCurrentPosition() >= this.get("endtime") && (this.player.trigger("ended"), this.get("loop") || this.player.pause());
                      }, this)) : this.get("_timeUpdateEventHandler") && this.get("_timeUpdateEventHandler").clear();
                    }
                  },
                  computed: {
                    "useAspectRatioFallback:width,height": function useAspectRatioFallbackWidthHeight(e, t) {
                      return e && !t && (Info.isSafari() || Info.isInternetExplorer());
                    },
                    "aspectRatioFallback:aspectratio,fallback-width,fallback-height": function aspectRatioFallbackAspectratioFallbackWidthFallbackHeight(e, t, i) {
                      return {
                        paddingTop: 100 / (e || t / i) + "%"
                      };
                    },
                    "containerSizingStyles:width,height,aspectratio,fallback-width,fallback-height": function containerSizingStylesWidthHeightAspectratioFallbackWidthFallbackHeight(e, t, i, r, o) {
                      var a,
                        n = {
                          minWidth: this.get("minwidth") + "px",
                          minHeight: this.get("minheight") + "px",
                          aspectRatio: i || r + "/" + o
                        };
                      return e && (n.width = "string" == typeof e && "%" === e[e.length - 1] ? e : e + "px"), t && (n.height = "string" == typeof t && "%" === t[t.length - 1] ? t : t + "px"), e || t ? !Info.isInternetExplorer() && !Info.isSafari() || e || ("string" == typeof t && "%" === t[t.length - 1] ? this.activeElement() && (a = t.slice(0, -1) / 100, new ResizeObserver(function (e) {
                        this.set("width", Math.floor(e[0].target.offsetHeight * a * (i || r / o)));
                      }.bind(this)).observe(this.activeElement()), n.width = Math.floor(this.activeElement().offsetHeight * a * (i || r / o)) + "px") : n.width = Math.floor(t * (i || r / o)) + "px") : (n.width = r + "px", n.height = o + "px"), this.get("maxwidth") && (n.maxWidth = this.get("maxwidth") + "px"), this.get("maxheight") && (n.maxHeight = this.get("maxheight") + "px"), this.activeElement() && this._applyStyles(this.activeElement(), n, this.__lastContainerSizingStyles), this.__lastContainerSizingStyles = n;
                    },
                    "buffering:buffered,position,last_position_change_delta,playing": function bufferingBufferedPositionLast_position_change_deltaPlaying() {
                      return this.get("playing") && this.get("buffered") < this.get("position") && 1e3 < this.get("last_position_change_delta");
                    }
                  },
                  remove_on_destroy: !0,
                  create: function create() {
                    var e;
                    this._validateParameters(), this.set("initialoptions", Objs.tree_merge(this.get("initialoptions"), {
                      volumelevel: this.get("volume")
                    })), this.get("fullscreenmandatory") && (document.fullscreenEnabled || document.mozFullscreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled || (this.set("skipinitial", !0), this.set("showbuiltincontroller", !0))), (Info.isMobile() || Info.isChromiumBased()) && (this.get("autoplay") || this.get("playwhenvisible")) && (this.set("volume", 0), this.set("forciblymuted", !0)), this.get("theme") && this.set("theme", this.get("theme").toLowerCase()), this.get("theme") in Assets.playerthemes && Objs.iter(Assets.playerthemes[this.get("theme")], function (e, t) {
                      this.isArgumentAttr(t) || this.set(t, e);
                    }, this), this.get("themecolor") || this.set("themecolor", "default"), this.get("adprovider") && (this._adProvider = this.get("adprovider"), Types.is_string(this._adProvider) && (this._adProvider = AdProvider.registry[this._adProvider]), this._adProvider && this.get("preroll") && (this._prerollAd = this._adProvider.newPrerollAd({
                      videoElement: this.activeElement().querySelector("[data-video='video']"),
                      adElement: this.activeElement().querySelector("[data-video='ad']"),
                      dynamic: this
                    }))), this.get("playlist") && (e = this.get("playlist")[0], this.set("poster", e.poster), this.set("source", e.source), this.set("sources", e.sources)), this.get("streams") && !this.get("currentstream") && this.set("currentstream", this.get("streams")[0]), this.get("preventinteraction") && !this.get("hideoninactivity") ? (this.set("hideoninactivity", !0), this.set("initialoptions", Objs.tree_merge(this.get("initialoptions"), {
                      hideoninactivity: !0
                    }))) : this.set("initialoptions", Objs.tree_merge(this.get("initialoptions"), {
                      hideoninactivity: this.get("hideoninactivity")
                    })), this.set("ie8", Info.isInternetExplorer() && Info.internetExplorerVersion() < 9), this.set("firefox", Info.isFirefox()), this.set("mobileview", Info.isMobile()), this.set("hidevolumebar", Info.isMobile() && Info.isiOS()), this.set("duration", this.get("totalduration") || 0), this.set("position", 0), this.set("buffered", 0), this.set("message", ""), this.set("fullscreensupport", !1), this.set("csssize", "normal"), this.set("loader_active", !1), this.set("playbutton_active", !1), this.set("controlbar_active", !1), this.set("message_active", !1), this.set("settingsmenu_active", !1), this.set("last_activity", Time.now()), this.set("activity_delta", 0), this.set("passed_after_play", 0), this.set("playing", !1), this.__attachRequested = !1, this.__activated = !1, this.__error = null, document.onkeydown && (this.activeElement().onkeydown = this._keyDownActivity.bind(this, this.activeElement())), this.on("change:tracktags", function () {
                      "undefined" != typeof this.__video && (this.__trackTags = new TrackTags({}, this));
                    }, this), this.host = new Host({
                      stateRegistry: new ClassRegistry(this.cls.playerStates())
                    }), (this.host.dynamic = this).host.initialize(InitialState), this._timer = new Timers.Timer({
                      context: this,
                      fire: this._timerFire,
                      delay: 100,
                      start: !0
                    }), this.activeElement().style.setProperty("display", "inline-block"), this._applyStyles(this.activeElement(), this.get("containerSizingStyles")), this.get("sticky") && (this.stickyHandler = this.auto_destroy(new StickyHandler(this.activeElement().firstChild, this.activeElement(), {
                      paused: !0
                    })), this.stickyHandler.init(), this.set("fadeup", !0), this.stickyHandler.on("elementLeftView", function () {
                      this.set("sticktoview", !0);
                    }, this), this.stickyHandler.on("containerEnteredView", function () {
                      this.set("sticktoview", !1), this.get("fadeup") && this.stickyHandler.elementWasDragged() && this.set("fadeup", !1);
                    }, this));
                  },
                  state: function state() {
                    return this.host.state();
                  },
                  videoAttached: function videoAttached() {
                    return !!this.player;
                  },
                  videoLoaded: function videoLoaded() {
                    return this.videoAttached() && this.player.loaded();
                  },
                  videoError: function videoError() {
                    return this.__error;
                  },
                  addSettingsMenuItem: function addSettingsMenuItem(e) {
                    this.__settingsMenu.execute("add_new_settings_item", e);
                  },
                  updateSettingsMenuItem: function updateSettingsMenuItem(e, t) {
                    this.__settingsMenu.execute("update_new_settings_item", e, t);
                  },
                  removeSettingsMenuItem: function removeSettingsMenuItem(e) {
                    this.__settingsMenu.execute("remove_settings_item", e);
                  },
                  toggle_pip: function toggle_pip() {
                    this.player.isInPIPMode() ? this.player.exitPIPMode() : this.player.enterPIPMode();
                  },
                  _error: function _error(e, t) {
                    this.__error = {
                      error_type: e,
                      error_code: t
                    }, this.trigger("error:" + e, t), this.trigger("error", e, t);
                  },
                  _clearError: function _clearError() {
                    this.__error = null;
                  },
                  _detachImage: function _detachImage() {
                    this.set("imageelement_active", !1);
                  },
                  _attachImage: function _attachImage() {
                    var e,
                      t,
                      i = "object" == typeof this.get("poster");
                    this.get("poster") ? (e = this.activeElement().querySelector("[data-image='image']"), this._clearError(), t = this, e.onerror = function () {
                      t.trigger("error:poster");
                    }, e.onload = function () {
                      t.set("imageelement_active", !0), t.trigger("image-attached");
                    }, e.src = i ? (window.URL || window.webkitURL).createObjectURL(this.get("poster")) : this.get("poster")) : this.trigger("error:poster");
                  },
                  _detachVideo: function _detachVideo() {
                    this.set("playing", !1), this.player && this.player.weakDestroy(), this._prerollAd && this._prerollAd.weakDestroy(), this.player = null, this.__video = null, this.set("videoelement_active", !1);
                  },
                  _validateParameters: function _validateParameters() {
                    var e = ["crop", "pad", "original"];
                    e.includes(this.get("videofitstrategy")) || console.warn("Invalid value for videofitstrategy: " + this.get("videofitstrategy") + "\nPossible values are: " + e.slice(0, -1).join(", ") + " or " + e.slice(-1)), e.includes(this.get("posterfitstrategy")) || console.warn("Invalid value for posterfitstrategy: " + this.get("posterfitstrategy") + "\nPossible values are: " + e.slice(0, -1).join(", ") + " or " + e.slice(-1)), (this.get("stretch") || this.get("stretchwidth") || this.get("stretchheight")) && console.warn("Stretch parameters were removed, please set width and/or height to 100% instead.");
                  },
                  getCurrentPosition: function getCurrentPosition() {
                    return this.videoAttached() ? this.player._element.currentTime : NaN;
                  },
                  _attachVideo: function _attachVideo(t) {
                    var i;
                    this.videoAttached() || (this.__activated ? (this.__attachRequested = !1, this.set("videoelement_active", !0), i = this.activeElement().querySelector("[data-video='video']"), this._clearError(), i.controls = this.get("showbuiltincontroller"), this.get("allowpip") || (i.disablePictureInPicture = !0), VideoPlayerWrapper.create(Objs.extend(this._getSources(), {
                      element: i,
                      onlyaudio: this.get("onlyaudio"),
                      preload: !!this.get("preload"),
                      loop: !!this.get("loop") || this.get("lastplaylistitem") && this.get("loopall"),
                      reloadonplay: !!this.get("playlist") || !!this.get("reloadonplay"),
                      fullscreenedElement: this.activeElement().childNodes[0],
                      loadmetadata: Info.isChrome() && this.get("skipinitial")
                    })).error(function (e) {
                      this.destroyed() || this._error("attach", e);
                    }, this).success(function (e) {
                      this.destroyed() || (this.player = e, this.__video = i, this.set("silent_attach", t || !1), this.get("chromecast") && (this.get("skipinitial") || this.set("skipinitial", !0), this._broadcasting = new Broadcasting({
                        player: e,
                        commonOptions: {
                          title: this.get("title"),
                          poster: this.player._element.poster,
                          currentPosition: this.get("position"),
                          chromecastReceiverAppId: this.get("chromecastreceiverappid")
                        },
                        castOptions: {
                          canControlVolume: !0,
                          canPause: !this.get("disablepause"),
                          canSeek: !this.get("disableseeking"),
                          displayName: this.get("title"),
                          duration: this.get("duration"),
                          imageUrl: this.player._element.poster,
                          isConnected: this.player._broadcastingState.googleCastConnected,
                          isMuted: !1,
                          isPaused: !this.get("playing")
                        },
                        airplayOptions: {}
                      }), Info.isChrome() && this.get("chromecast") && (this._broadcasting.attachGoggleCast(), this.player.on("cast-available", function (e) {
                        this.set("castbuttonvisble", e);
                      }, this), this.player.on("cast-loaded", function (e, t) {
                        0 < this.get("position") && (this._broadcasting.options.currentPosition = this.get("position")), this.get("playing") && this.stop(), e.isPaused || this.set("playing", !0);
                      }, this), this.player.on("cast-playpause", function (e) {
                        this.set("playing", !e);
                      }, this), this.player.on("cast-time-changed", function (e, t) {
                        Math.round(e / t * 100);
                        this.set("buffered", t), this.set("cahched", t), this.set("duration", t || 0), this.set("position", e);
                      }, this), this.player.on("proceed-when-ending-googlecast", function (e) {
                        this.player._broadcastingState.googleCastConnected = !1, this.set("playing", !1);
                      }, this)), Info.isSafari() && 9 <= Info.safariVersion() && window.WebKitPlaybackTargetAvailabilityEvent && this.get("airplay") && (this.set("airplaybuttonvisible", !0), this._broadcasting.attachAirplayEvent.call(this, i))), this.get("playwhenvisible") && (this.set("skipinitial", !0), this._playWhenVisible(i)), this.player.on("fullscreen-change", function (e) {
                        this.set("fullscreened", e), e || this.get("hideoninactivity") === this.get("initialoptions").hideoninactivity || this.set("hideoninactivity", this.get("initialoptions").hideoninactivity);
                      }, this), Info.isChromiumBased() && this.get("forciblymuted") && (i.isMuted = !0, Dom.userInteraction(function () {
                        this.set_volume(this.get("initialoptions").volumelevel), 0 < this.get("volume") && (i.isMuted = !1), this.set("forciblymuted", !1);
                      }, this)), this.player.on("postererror", function () {
                        this._error("poster");
                      }, this), this.player.on("playing", function () {
                        this.set("playing", !0), this.trigger("playing"), !1 === this.get("playedonce") ? this.set("playbackcount", 1) : this.set("playbackcount", this.get("playbackended") + 1);
                      }, this), this.player.on("error", function (e) {
                        this._error("video", e);
                      }, this), this.player.error() && this.player.trigger("error", this.player.error()), this.player.on("paused", function () {
                        this.set("playing", !1), this.trigger("paused");
                      }, this), this.player.on("ended", function () {
                        this.set("playing", !1), this.set("playedonce", !0), this.set("playbackended", this.get("playbackended") + 1), this.set("settingsmenu_active", !1), this.get("starttime") && this.player.setPosition(this.get("starttime") || 0), this.trigger("ended");
                      }, this), this.trigger("attached", e), this.player.once("loaded", function () {
                        var e = Math.min(1, this.get("volume"));
                        this.player.setVolume(e), this.player.setMuted(e <= 0), !this.__trackTags && this.get("tracktags").length && (this.__trackTags = new TrackTags({}, this)), (this.get("totalduration") || this.player.duration() < Infinity) && this.set("duration", this.get("totalduration") || this.player.duration()), this.set("fullscreensupport", this.player.supportsFullscreen(this.activeElement().childNodes[0])), this.on("chaptercuesloaded", function (e, t) {
                          this.set("chapterslist", e);
                        }, this), this.get("initialseek") && this.player.setPosition(this.get("initialseek")), this.get("allowpip") && this.addSettingsMenuItem({
                          id: "pip",
                          label: "Picture-in-Picture",
                          showicon: !0,
                          visible: this.player.supportsPIP(),
                          func: function func(e) {
                            return this.player.on("pip-mode-change", function (e, t) {
                              this.set("inpipmode", t), this.updateSettingsMenuItem("pip", {
                                value: t
                              });
                            }, this), !!this.toggle_pip();
                          }
                        });
                      }, this), this.player.loaded() && this.player.trigger("loaded"));
                    }, this)) : this.__attachRequested = !0);
                  },
                  _getSources: function _getSources() {
                    var t = this.get("currentstream") ? this.get("currentstream").filter : this.get("sourcefilter"),
                      i = this.get("poster"),
                      e = this.get("source"),
                      r = t ? Objs.filter(this.get("sources"), function (e) {
                        return Objs.subset_of(t, e);
                      }, this) : this.get("sources");
                    return Objs.iter(r, function (e) {
                      e.poster && (i = e.poster);
                    }), {
                      poster: i,
                      source: e,
                      sources: r
                    };
                  },
                  _afterActivate: function _afterActivate(e) {
                    r._afterActivate.call(this, e), this.__activated = !0, this.__settingsMenu = this.scopes.settingsmenu, this.__settingsMenu.get("settings") && this.set("hassettings", !0), this.__attachRequested && this._attachVideo();
                    var t = this.activeElement().querySelector('img[data-image="image"]'),
                      i = this.auto_destroy(new DomEvents());
                    i.on(t, "load", function () {
                      this.set("fallback-width", t.naturalWidth), this.set("fallback-height", t.naturalHeight), i.destroy();
                    }, this);
                  },
                  _playWhenVisible: function _playWhenVisible(e) {
                    var t = this;
                    Dom.isElementVisible(e, this.get("visibilityfraction")) && this.player.play(), this._visiblityScrollEvent = this.auto_destroy(new DomEvents()), this._visiblityScrollEvent.on(document, "scroll", function () {
                      t.get("playedonce") || t.get("manuallypaused") ? t.get("playing") && !Dom.isElementVisible(e, t.get("visibilityfraction")) && t.player.pause() : Dom.isElementVisible(e, t.get("visibilityfraction")) ? t.player.play() : t.get("playing") && t.player.pause();
                    });
                  },
                  toggleFullscreen: function toggleFullscreen() {
                    this.call("toggle_fullscreen");
                  },
                  getPlaybackCount: function getPlaybackCount() {
                    return this.get("playbackcount");
                  },
                  reattachVideo: function reattachVideo() {
                    this.set("reloadonplay", !0), this._detachVideo(), this._attachVideo();
                  },
                  reattachImage: function reattachImage() {
                    this._detachImage(), this._attachImage();
                  },
                  toggleTrackTags: function toggleTrackTags() {
                    var r, o, e, a;
                    this.__trackTags && (this.set("tracktextvisible", !this.get("tracktextvisible")), r = this.get("tracktextvisible"), o = this.get("tracktaglang"), e = this.get("tracktagsstyled"), a = r ? "showing" : "disabled", a = r && e ? "hidden" : a, !r && this.get("tracktagsstyled") && this.set("trackcuetext", null), Objs.iter(this.__video.textTracks, function (e, t) {
                      var i;
                      "object" != typeof this.__video.textTracks[t] || !this.__video.textTracks[t] || "metadata" !== (i = this.__video.textTracks[t]).kind && i.language === o && (i.mode = a, this.set("tracktextvisible", r), this.__trackTags._triggerTrackChange(this.__video, i, a, o));
                    }, this));
                  },
                  _keyDownActivity: function _keyDownActivity(e, t) {
                    var i;
                    this.get("preventinteractionstatus") || (32 !== (i = t.which || t.keyCode) && 37 !== i && 38 !== i && 39 !== i && 40 !== i || t.preventDefault(), 32 !== i && 13 !== i && 9 !== i || (this._resetActivity(), this.get("fullscreened") && this.get("hideoninactivity") && this.set("hideoninactivity", !1)), 9 === i && t.shiftKey ? (this._resetActivity(), this._findNextTabStop(e, t, function (e, t) {
                      e.focus();
                    }, -1)) : 9 === i && (this._resetActivity(), this._findNextTabStop(e, t, function (e, t) {
                      e.focus();
                    })));
                  },
                  _findNextTabStop: function _findNextTabStop(e, t, i, r) {
                    var o,
                      a,
                      n,
                      s,
                      x = o = 0,
                      c = r || 1,
                      d = t.target.tabIndex,
                      l = e.querySelectorAll("[tabindex]");
                    if (l = Array.prototype.slice.call(l, 0).filter(function (e) {
                      return (0 < e.clientWidth || 0 < e.clientHeight) && -1 !== e.tabIndex && (x <= e.tabIndex && (x = e.tabIndex), o >= e.tabIndex && (o = e.tabIndex), !0);
                    }), 1 === c && d === x || -1 === r && d === o || 0 === x) 1 < document.querySelectorAll("ba-videoplayer").length && (this.get("playing") && this.player.pause(), e.tabIndex = -1, e.blur());else {
                      for (var u = 0; u < l.length; u++) l[u] && (s = (n = l[u].tabIndex) - d, n < o || x < n || Math.sign(s) !== c || (!a || Math.abs(s) < Math.abs(a.tabIndex - d)) && (a = l[u]));
                      a && (t.preventDefault(), i(a, a.tabIndex));
                    }
                  },
                  _resetActivity: function _resetActivity() {
                    this.get("preventinteractionstatus") || this.set("last_activity", Time.now()), this.set("activity_delta", 0);
                  },
                  object_functions: ["play", "rerecord", "pause", "stop", "seek", "set_volume", "set_speed", "toggle_tracks"],
                  functions: {
                    user_activity: function user_activity(e) {
                      e && !this.get("volumeafterinteraction") && (this.set_volume(this.get("initialoptions").volumelevel), this.set("volumeafterinteraction", !0), this.get("forciblymuted") && this.set("forciblymuted", !1)), this.get("preventinteractionstatus") || this._resetActivity();
                    },
                    message_click: function message_click() {
                      this.trigger("message:click");
                    },
                    playbutton_click: function playbutton_click() {
                      this.host.state().play();
                    },
                    play: function play() {
                      this._delegatedPlayer ? this._delegatedPlayer.execute("play") : this.player && this.player._broadcastingState && this.player._broadcastingState.googleCastConnected ? this._broadcasting.player.trigger("play-google-cast") : (this.host.state().play(), this.set("manuallypaused", !1));
                    },
                    rerecord: function rerecord() {
                      this._delegatedPlayer ? this._delegatedPlayer.execute("rerecord") : this.get("rerecordable") && this.trigger("rerecord");
                    },
                    submit: function submit() {
                      this._delegatedPlayer ? this._delegatedPlayer.execute("submit") : this.get("submittable") && (this.trigger("submit"), this.set("submittable", !1), this.set("rerecordable", !1));
                    },
                    pause: function pause() {
                      if (!this.get("preventinteractionstatus")) if (this._delegatedPlayer) this._delegatedPlayer.execute("pause");else if (!this.get("disablepause")) {
                        if (this.get("playing")) {
                          if (this.player && this.player._broadcastingState && this.player._broadcastingState.googleCastConnected) return void this._broadcasting.player.trigger("pause-google-cast");
                          this.player.pause();
                        }
                        this.set("manuallypaused", !0);
                      }
                    },
                    stop: function stop() {
                      this.get("preventinteractionstatus") || (this._delegatedPlayer ? this._delegatedPlayer.execute("stop") : this.videoLoaded() && (this.get("playing") && this.player.pause(), this.player.setPosition(0), this.trigger("stopped")));
                    },
                    seek: function seek(e) {
                      this.get("preventinteractionstatus") || (this._delegatedPlayer ? this._delegatedPlayer.execute("seek", e) : this.get("disableseeking") || this.videoLoaded() && (e > this.player.duration() ? this.player.setPosition(this.player.duration() - this.get("skipseconds")) : this.get("starttime") && e < this.get("starttime") ? this.player.setPosition(this.get("starttime")) : (this.player.setPosition(e), this.trigger("seek", e))));
                    },
                    set_speed: function set_speed(e) {
                      this.player.setSpeed(e);
                    },
                    set_volume: function set_volume(e) {
                      this.get("preventinteractionstatus") || (this._delegatedPlayer ? this._delegatedPlayer.execute("set_volume", e) : (e = Math.min(1, e), this.player && this.player._broadcastingState && this.player._broadcastingState.googleCastConnected && this._broadcasting.player.trigger("change-google-cast-volume", e), this.set("volume", e), this.videoLoaded() && (this.player.setVolume(e), this.player.setMuted(e <= 0))));
                    },
                    toggle_settings_menu: function toggle_settings_menu() {
                      this.set("settingsmenu_active", !this.get("settingsmenu_active"));
                    },
                    toggle_fullscreen: function toggle_fullscreen() {
                      this.get("preventinteractionstatus") || (this._delegatedPlayer ? this._delegatedPlayer.execute("toggle_fullscreen") : this.player && (this.get("fullscreened") ? this.player.exitFullscreen() : Info.isSafari() ? this.player.enterFullscreen(this.activeElement().querySelector("video")) : this.player.enterFullscreen(this.activeElement().childNodes[0]), this.set("fullscreened", !this.get("fullscreened"))));
                    },
                    toggle_player: function toggle_player() {
                      this.get("sticky") && this.stickyHandler.isDragging() ? this.stickyHandler.stopDragging() : this.get("playing") && this.get("preventinteractionstatus") || (this._delegatedPlayer ? this._delegatedPlayer.execute("toggle_player") : this.get("playing") && this.get("pauseonclick") ? this.pause() : !this.get("playing") && this.get("playonclick") && this.play());
                    },
                    tab_index_move: function tab_index_move(e, t, i) {
                      var r, o, a, n;
                      this.get("preventinteractionstatus") || (a = e.which || e.keyCode, n = this.activeElement(), 13 === a || 32 === a ? i ? (o = "[data-selector='" + i + "']", (r = n.querySelector(o)) && Async.eventually(function () {
                        this.trigger("keyboardusecase", n), r.focus({
                          preventScroll: !1
                        });
                      }, this, 100)) : (o = '[data-video="video"]', r = n.querySelector(o), Async.eventually(function () {
                        this.trigger("keyboardusecase", n), r.focus({
                          preventScroll: !0
                        });
                      }, this, 100)) : 9 === a && t && (o = "[data-selector='" + t + "']", (r = n.querySelector(o)) && Async.eventually(function () {
                        this.trigger("keyboardusecase", n), r.focus({
                          preventScroll: !1
                        });
                      }, this, 100)));
                    },
                    upload_text_tracks: function upload_text_tracks(e, t) {
                      return this.host.state().uploadTextTrack(e, t);
                    },
                    move_to_option: function move_to_option(e, t) {
                      var i, r, o, a, n, s, x;
                      t = t || "initial-options-list", a = "." + (i = this.get("csscommon") + "-") + t, r = i + "options-list-hidden", o = i + "options-list-visible", n = this.activeElement().querySelector(a), x = this.activeElement().querySelector(i + "text-tracks-overlay"), Dom.elementHasClass(n, r) && (s = Dom.elementFindClosestParent(e, o, i + "text-tracks-overlay"), Dom.elementHasClass(s, o) && (Dom.elementReplaceClasses(n, r, o), Dom.elementReplaceClasses(s, o, r)), x ? x.focus({
                        preventScroll: !0
                      }) : s.focus({
                        preventScroll: !0
                      }));
                    },
                    toggle_interaction_option: function toggle_interaction_option(e) {
                      "boolean" == typeof e ? this.set("preventinteractionstatus", e) : this.set("preventinteractionstatus", !this.get("preventinteractionstatus"));
                    },
                    toggle_tracks: function toggle_tracks() {
                      this.toggleTrackTags(!this.get("tracktextvisible"));
                    }
                  },
                  destroy: function destroy() {
                    this._timer.destroy(), this.host.destroy(), this._detachVideo(), r.destroy.call(this);
                  },
                  _timerFire: function _timerFire() {
                    if (!this.destroyed()) {
                      try {
                        var t, i, r, o;
                        this.videoLoaded() && (t = Time.now(), this.set("activity_delta", t - this.get("last_activity")), (i = this.player.position()) === this.get("position") && !this.get("last_position_change") || this.set("last_position_change", t), this.get("preventinteraction") && (this.get("passed_after_play") < .001 ? this.set("passed_after_play", t) : (t - 1e3 < (r = t - this.get("passed_after_play")) && this.set("passed_after_play", r), this.get("hidebarafter") < r && this.get("playing") && !this.get("preventinteractionstatus") && this.set("preventinteractionstatus", !0))), this.set("last_position_change_delta", t - this.get("last_position_change")), this.set("position", i), this.set("buffered", this.player.buffered()), 0 < (o = this.player.duration()) && o < Infinity ? this.set("duration", this.player.duration()) : this.set("duration", this.get("totalduration") || i), this.set("fullscreened", this.player.isFullscreen(this.activeElement().childNodes[0])), this.get("hideoninactivity") && this.get("activity_delta") > this.get("hidebarafter") && this.set("settingsmenu_active", !1));
                      } catch (e) {}
                      try {
                        this._updateCSSSize();
                      } catch (e) {}
                    }
                  },
                  _updateCSSSize: function _updateCSSSize() {
                    var e = Dom.elementDimensions(this.activeElement()).width;
                    this.set("csssize", 400 < e ? "normal" : 320 < e ? "medium" : "small"), this.set("mobileview", e < 560);
                  },
                  videoHeight: function videoHeight() {
                    if (this.videoAttached()) return this.player.videoHeight();
                    var e = this.activeElement().querySelector("img");
                    if (e && e.height) {
                      var t = window.innerHeight || document.body.clientHeight;
                      return e.height > t ? t : e.height;
                    }
                    return NaN;
                  },
                  videoWidth: function videoWidth() {
                    if (this.videoAttached()) return this.player.videoWidth();
                    var e = this.activeElement().querySelector("img");
                    if (e && e.width) {
                      var t = window.innerWidth || document.body.clientWidth;
                      return e.width > t ? t : e.width;
                    }
                    return NaN;
                  },
                  aspectRatio: function aspectRatio() {
                    var e = this.videoHeight();
                    return this.videoWidth() / e;
                  },
                  isPortrait: function isPortrait() {
                    return this.aspectRatio() < 1;
                  },
                  isLandscape: function isLandscape() {
                    return !this.isPortrait();
                  },
                  parentWidth: function parentWidth() {
                    return Dom.elementDimensions(this.activeElement().parentElement).width;
                  },
                  parentHeight: function parentHeight() {
                    return Dom.elementDimensions(this.activeElement().parentElement).height;
                  },
                  parentAspectRatio: function parentAspectRatio() {
                    return this.parentWidth() / this.parentHeight();
                  },
                  cloneAttrs: function cloneAttrs() {
                    return Objs.map(this.attrs, function (e, t) {
                      return this.get(t);
                    }, this);
                  },
                  isHD: function isHD() {
                    if (this.videoAttached()) return 921600 <= this.videoWidth() * this.videoHeight();
                    var e;
                    if (null == this.get("stream") || "" === this.get("stream")) e = this.get("video_data").default_stream;else for (var t = 0; t < this.get("video_data").streams.length; t++) if (this.get("video_data").streams[t].token === this.get("stream")) return 921600 <= this.get("video_data").streams[t].video_width * this.get("video_data").streams[t].video_height;
                    return e ? 921600 <= e.video_width * e.video_height : undefined;
                  },
                  isSD: function isSD() {
                    return !this.isHD();
                  },
                  isMobile: function isMobile() {
                    return Info.isMobile();
                  },
                  popupAttrs: function popupAttrs() {
                    return {
                      autoplay: !0,
                      popup: !1,
                      width: this.get("popup-width"),
                      height: this.get("popup-height"),
                      stretch: this.get("popup-stretch")
                    };
                  }
                };
              }], {
                playerStates: function playerStates() {
                  return [PlayerStates];
                }
              }).register("ba-videoplayer").registerFunctions({
                css: function (_css6) {
                  function css(_x77) {
                    return _css6.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css6.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                cssplayer: function (_cssplayer6) {
                  function cssplayer(_x78) {
                    return _cssplayer6.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer6.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                csssize: function (_csssize) {
                  function csssize(_x79) {
                    return _csssize.apply(this, arguments);
                  }
                  csssize.toString = function () {
                    return _csssize.toString();
                  };
                  return csssize;
                }(function (obj) {
                  with (obj) return csssize;
                }),
                iecss: function (_iecss) {
                  function iecss(_x80) {
                    return _iecss.apply(this, arguments);
                  }
                  iecss.toString = function () {
                    return _iecss.toString();
                  };
                  return iecss;
                }(function (obj) {
                  with (obj) return iecss;
                }),
                "ie8 ? 'ie8' : 'noie8'": function ie8Ie8Noie8(obj) {
                  with (obj) return ie8 ? "ie8" : "noie8";
                },
                csstheme: function (_csstheme2) {
                  function csstheme(_x81) {
                    return _csstheme2.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme2.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                "fullscreened ? 'fullscreen' : 'normal'": function fullscreenedFullscreenNormal(obj) {
                  with (obj) return fullscreened ? "fullscreen" : "normal";
                },
                "firefox ? 'firefox' : 'common'": function firefoxFirefoxCommon(obj) {
                  with (obj) return firefox ? "firefox" : "common";
                },
                themecolor: function (_themecolor) {
                  function themecolor(_x82) {
                    return _themecolor.apply(this, arguments);
                  }
                  themecolor.toString = function () {
                    return _themecolor.toString();
                  };
                  return themecolor;
                }(function (obj) {
                  with (obj) return themecolor;
                }),
                "mobileview ? 'mobile' : 'desktop'": function mobileviewMobileDesktop(obj) {
                  with (obj) return mobileview ? "mobile" : "desktop";
                },
                "sticktoview ? csscommon + '-sticky' : ''": function sticktoviewCsscommonSticky(obj) {
                  with (obj) return sticktoview ? csscommon + "-sticky" : "";
                },
                "sticktoview && fadeup ? csscommon + '-fade-up' : ''": function sticktoviewFadeupCsscommonFadeUp(obj) {
                  with (obj) return sticktoview && fadeup ? csscommon + "-fade-up" : "";
                },
                "user_activity()": function (_user_activity) {
                  function user_activity(_x83) {
                    return _user_activity.apply(this, arguments);
                  }
                  user_activity.toString = function () {
                    return _user_activity.toString();
                  };
                  return user_activity;
                }(function (obj) {
                  with (obj) return user_activity();
                }),
                "user_activity(true)": function user_activityTrue(obj) {
                  with (obj) return user_activity(!0);
                },
                containerSizingStyles: function (_containerSizingStyles) {
                  function containerSizingStyles(_x84) {
                    return _containerSizingStyles.apply(this, arguments);
                  }
                  containerSizingStyles.toString = function () {
                    return _containerSizingStyles.toString();
                  };
                  return containerSizingStyles;
                }(function (obj) {
                  with (obj) return containerSizingStyles;
                }),
                "title || 'Video Player'": function titleVideoPlayer(obj) {
                  with (obj) return title || "Video Player";
                },
                "description || 'Video Player'": function descriptionVideoPlayer(obj) {
                  with (obj) return description || "Video Player";
                },
                uploaddate: function (_uploaddate) {
                  function uploaddate(_x85) {
                    return _uploaddate.apply(this, arguments);
                  }
                  uploaddate.toString = function () {
                    return _uploaddate.toString();
                  };
                  return uploaddate;
                }(function (obj) {
                  with (obj) return uploaddate;
                }),
                "(videoelement_active || !imageelement_active) && !silent_attach": function videoelement_activeImageelement_activeSilent_attach(obj) {
                  with (obj) return (videoelement_active || !imageelement_active) && !silent_attach;
                },
                csscommon: function (_csscommon5) {
                  function csscommon(_x86) {
                    return _csscommon5.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon5.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                videofitstrategy: function (_videofitstrategy) {
                  function videofitstrategy(_x87) {
                    return _videofitstrategy.apply(this, arguments);
                  }
                  videofitstrategy.toString = function () {
                    return _videofitstrategy.toString();
                  };
                  return videofitstrategy;
                }(function (obj) {
                  with (obj) return videofitstrategy;
                }),
                "preload ? 'auto' : 'metadata'": function preloadAutoMetadata(obj) {
                  with (obj) return preload ? "auto" : "metadata";
                },
                "!playfullscreenonmobile": function (_playfullscreenonmobile) {
                  function playfullscreenonmobile(_x88) {
                    return _playfullscreenonmobile.apply(this, arguments);
                  }
                  playfullscreenonmobile.toString = function () {
                    return _playfullscreenonmobile.toString();
                  };
                  return playfullscreenonmobile;
                }(function (obj) {
                  with (obj) return !playfullscreenonmobile;
                }),
                "(imageelement_active && !videoelement_active) || silent_attach": function imageelement_activeVideoelement_activeSilent_attach(obj) {
                  with (obj) return imageelement_active && !videoelement_active || silent_attach;
                },
                posteralt: function (_posteralt) {
                  function posteralt(_x89) {
                    return _posteralt.apply(this, arguments);
                  }
                  posteralt.toString = function () {
                    return _posteralt.toString();
                  };
                  return posteralt;
                }(function (obj) {
                  with (obj) return posteralt;
                }),
                posterfitstrategy: function (_posterfitstrategy) {
                  function posterfitstrategy(_x90) {
                    return _posterfitstrategy.apply(this, arguments);
                  }
                  posterfitstrategy.toString = function () {
                    return _posterfitstrategy.toString();
                  };
                  return posterfitstrategy;
                }(function (obj) {
                  with (obj) return posterfitstrategy;
                }),
                "!showbuiltincontroller": function (_showbuiltincontroller) {
                  function showbuiltincontroller(_x91) {
                    return _showbuiltincontroller.apply(this, arguments);
                  }
                  showbuiltincontroller.toString = function () {
                    return _showbuiltincontroller.toString();
                  };
                  return showbuiltincontroller;
                }(function (obj) {
                  with (obj) return !showbuiltincontroller;
                }),
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "seek(position + skipseconds * 3)": function seekPositionSkipseconds3(obj) {
                  with (obj) return seek(position + 3 * skipseconds);
                },
                "seek(position - skipseconds * 3)": function seekPositionSkipseconds3(obj) {
                  with (obj) return seek(position - 3 * skipseconds);
                },
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "toggle_player()": function (_toggle_player2) {
                  function toggle_player(_x92) {
                    return _toggle_player2.apply(this, arguments);
                  }
                  toggle_player.toString = function () {
                    return _toggle_player2.toString();
                  };
                  return toggle_player;
                }(function (obj) {
                  with (obj) return toggle_player();
                }),
                dyntrimmer: function (_dyntrimmer) {
                  function dyntrimmer(_x93) {
                    return _dyntrimmer.apply(this, arguments);
                  }
                  dyntrimmer.toString = function () {
                    return _dyntrimmer.toString();
                  };
                  return dyntrimmer;
                }(function (obj) {
                  with (obj) return dyntrimmer;
                }),
                "trimmingmode && videoelement_active": function trimmingmodeVideoelement_active(obj) {
                  with (obj) return trimmingmode && videoelement_active;
                },
                playing: function (_playing3) {
                  function playing(_x94) {
                    return _playing3.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing3.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                starttime: function (_starttime) {
                  function starttime(_x95) {
                    return _starttime.apply(this, arguments);
                  }
                  starttime.toString = function () {
                    return _starttime.toString();
                  };
                  return starttime;
                }(function (obj) {
                  with (obj) return starttime;
                }),
                position: function (_position) {
                  function position(_x96) {
                    return _position.apply(this, arguments);
                  }
                  position.toString = function () {
                    return _position.toString();
                  };
                  return position;
                }(function (obj) {
                  with (obj) return position;
                }),
                endtime: function (_endtime) {
                  function endtime(_x97) {
                    return _endtime.apply(this, arguments);
                  }
                  endtime.toString = function () {
                    return _endtime.toString();
                  };
                  return endtime;
                }(function (obj) {
                  with (obj) return endtime;
                }),
                timeminlimit: function (_timeminlimit) {
                  function timeminlimit(_x98) {
                    return _timeminlimit.apply(this, arguments);
                  }
                  timeminlimit.toString = function () {
                    return _timeminlimit.toString();
                  };
                  return timeminlimit;
                }(function (obj) {
                  with (obj) return timeminlimit;
                }),
                duration: function (_duration) {
                  function duration(_x99) {
                    return _duration.apply(this, arguments);
                  }
                  duration.toString = function () {
                    return _duration.toString();
                  };
                  return duration;
                }(function (obj) {
                  with (obj) return duration;
                }),
                source: function (_source) {
                  function source(_x100) {
                    return _source.apply(this, arguments);
                  }
                  source.toString = function () {
                    return _source.toString();
                  };
                  return source;
                }(function (obj) {
                  with (obj) return source;
                }),
                dyncontrolbar: function (_dyncontrolbar) {
                  function dyncontrolbar(_x101) {
                    return _dyncontrolbar.apply(this, arguments);
                  }
                  dyncontrolbar.toString = function () {
                    return _dyncontrolbar.toString();
                  };
                  return dyncontrolbar;
                }(function (obj) {
                  with (obj) return dyncontrolbar;
                }),
                "csscontrolbar || css": function csscontrolbarCss(obj) {
                  with (obj) return csscontrolbar || css;
                },
                "cssplayer || css": function cssplayerCss(obj) {
                  with (obj) return cssplayer || css;
                },
                "csstheme || css": function cssthemeCss(obj) {
                  with (obj) return csstheme || css;
                },
                tmplcontrolbar: function (_tmplcontrolbar) {
                  function tmplcontrolbar(_x102) {
                    return _tmplcontrolbar.apply(this, arguments);
                  }
                  tmplcontrolbar.toString = function () {
                    return _tmplcontrolbar.toString();
                  };
                  return tmplcontrolbar;
                }(function (obj) {
                  with (obj) return tmplcontrolbar;
                }),
                "controlbar_active && !hidecontrolbar": function controlbar_activeHidecontrolbar(obj) {
                  with (obj) return controlbar_active && !hidecontrolbar;
                },
                playwhenvisible: function (_playwhenvisible) {
                  function playwhenvisible(_x103) {
                    return _playwhenvisible.apply(this, arguments);
                  }
                  playwhenvisible.toString = function () {
                    return _playwhenvisible.toString();
                  };
                  return playwhenvisible;
                }(function (obj) {
                  with (obj) return playwhenvisible;
                }),
                playerspeeds: function (_playerspeeds) {
                  function playerspeeds(_x104) {
                    return _playerspeeds.apply(this, arguments);
                  }
                  playerspeeds.toString = function () {
                    return _playerspeeds.toString();
                  };
                  return playerspeeds;
                }(function (obj) {
                  with (obj) return playerspeeds;
                }),
                playercurrentspeed: function (_playercurrentspeed) {
                  function playercurrentspeed(_x105) {
                    return _playercurrentspeed.apply(this, arguments);
                  }
                  playercurrentspeed.toString = function () {
                    return _playercurrentspeed.toString();
                  };
                  return playercurrentspeed;
                }(function (obj) {
                  with (obj) return playercurrentspeed;
                }),
                airplay: function (_airplay) {
                  function airplay(_x106) {
                    return _airplay.apply(this, arguments);
                  }
                  airplay.toString = function () {
                    return _airplay.toString();
                  };
                  return airplay;
                }(function (obj) {
                  with (obj) return airplay;
                }),
                airplaybuttonvisible: function (_airplaybuttonvisible2) {
                  function airplaybuttonvisible(_x107) {
                    return _airplaybuttonvisible2.apply(this, arguments);
                  }
                  airplaybuttonvisible.toString = function () {
                    return _airplaybuttonvisible2.toString();
                  };
                  return airplaybuttonvisible;
                }(function (obj) {
                  with (obj) return airplaybuttonvisible;
                }),
                chromecast: function (_chromecast) {
                  function chromecast(_x108) {
                    return _chromecast.apply(this, arguments);
                  }
                  chromecast.toString = function () {
                    return _chromecast.toString();
                  };
                  return chromecast;
                }(function (obj) {
                  with (obj) return chromecast;
                }),
                castbuttonvisble: function (_castbuttonvisble2) {
                  function castbuttonvisble(_x109) {
                    return _castbuttonvisble2.apply(this, arguments);
                  }
                  castbuttonvisble.toString = function () {
                    return _castbuttonvisble2.toString();
                  };
                  return castbuttonvisble;
                }(function (obj) {
                  with (obj) return castbuttonvisble;
                }),
                tabindex: function (_tabindex) {
                  function tabindex(_x110) {
                    return _tabindex.apply(this, arguments);
                  }
                  tabindex.toString = function () {
                    return _tabindex.toString();
                  };
                  return tabindex;
                }(function (obj) {
                  with (obj) return tabindex;
                }),
                showchaptertext: function (_showchaptertext) {
                  function showchaptertext(_x111) {
                    return _showchaptertext.apply(this, arguments);
                  }
                  showchaptertext.toString = function () {
                    return _showchaptertext.toString();
                  };
                  return showchaptertext;
                }(function (obj) {
                  with (obj) return showchaptertext;
                }),
                chapterslist: function (_chapterslist2) {
                  function chapterslist(_x112) {
                    return _chapterslist2.apply(this, arguments);
                  }
                  chapterslist.toString = function () {
                    return _chapterslist2.toString();
                  };
                  return chapterslist;
                }(function (obj) {
                  with (obj) return chapterslist;
                }),
                tracktextvisible: function (_tracktextvisible) {
                  function tracktextvisible(_x113) {
                    return _tracktextvisible.apply(this, arguments);
                  }
                  tracktextvisible.toString = function () {
                    return _tracktextvisible.toString();
                  };
                  return tracktextvisible;
                }(function (obj) {
                  with (obj) return tracktextvisible;
                }),
                tracktags: function (_tracktags2) {
                  function tracktags(_x114) {
                    return _tracktags2.apply(this, arguments);
                  }
                  tracktags.toString = function () {
                    return _tracktags2.toString();
                  };
                  return tracktags;
                }(function (obj) {
                  with (obj) return tracktags;
                }),
                "hassubtitles && tracktagssupport": function hassubtitlesTracktagssupport(obj) {
                  with (obj) return hassubtitles && tracktagssupport;
                },
                allowtexttrackupload: function (_allowtexttrackupload2) {
                  function allowtexttrackupload(_x115) {
                    return _allowtexttrackupload2.apply(this, arguments);
                  }
                  allowtexttrackupload.toString = function () {
                    return _allowtexttrackupload2.toString();
                  };
                  return allowtexttrackupload;
                }(function (obj) {
                  with (obj) return allowtexttrackupload;
                }),
                tracksshowselection: function (_tracksshowselection) {
                  function tracksshowselection(_x116) {
                    return _tracksshowselection.apply(this, arguments);
                  }
                  tracksshowselection.toString = function () {
                    return _tracksshowselection.toString();
                  };
                  return tracksshowselection;
                }(function (obj) {
                  with (obj) return tracksshowselection;
                }),
                volume: function (_volume) {
                  function volume(_x117) {
                    return _volume.apply(this, arguments);
                  }
                  volume.toString = function () {
                    return _volume.toString();
                  };
                  return volume;
                }(function (obj) {
                  with (obj) return volume;
                }),
                buffered: function (_buffered) {
                  function buffered(_x118) {
                    return _buffered.apply(this, arguments);
                  }
                  buffered.toString = function () {
                    return _buffered.toString();
                  };
                  return buffered;
                }(function (obj) {
                  with (obj) return buffered;
                }),
                title: function (_title2) {
                  function title(_x119) {
                    return _title2.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title2.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                activity_delta: function (_activity_delta) {
                  function activity_delta(_x120) {
                    return _activity_delta.apply(this, arguments);
                  }
                  activity_delta.toString = function () {
                    return _activity_delta.toString();
                  };
                  return activity_delta;
                }(function (obj) {
                  with (obj) return activity_delta;
                }),
                hideoninactivity: function (_hideoninactivity) {
                  function hideoninactivity(_x121) {
                    return _hideoninactivity.apply(this, arguments);
                  }
                  hideoninactivity.toString = function () {
                    return _hideoninactivity.toString();
                  };
                  return hideoninactivity;
                }(function (obj) {
                  with (obj) return hideoninactivity;
                }),
                hidebarafter: function (_hidebarafter) {
                  function hidebarafter(_x122) {
                    return _hidebarafter.apply(this, arguments);
                  }
                  hidebarafter.toString = function () {
                    return _hidebarafter.toString();
                  };
                  return hidebarafter;
                }(function (obj) {
                  with (obj) return hidebarafter;
                }),
                rerecordable: function (_rerecordable2) {
                  function rerecordable(_x123) {
                    return _rerecordable2.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable2.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                submittable: function (_submittable2) {
                  function submittable(_x124) {
                    return _submittable2.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable2.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                frameselectionmode: function (_frameselectionmode2) {
                  function frameselectionmode(_x125) {
                    return _frameselectionmode2.apply(this, arguments);
                  }
                  frameselectionmode.toString = function () {
                    return _frameselectionmode2.toString();
                  };
                  return frameselectionmode;
                }(function (obj) {
                  with (obj) return frameselectionmode;
                }),
                streams: function (_streams) {
                  function streams(_x126) {
                    return _streams.apply(this, arguments);
                  }
                  streams.toString = function () {
                    return _streams.toString();
                  };
                  return streams;
                }(function (obj) {
                  with (obj) return streams;
                }),
                currentstream: function (_currentstream) {
                  function currentstream(_x127) {
                    return _currentstream.apply(this, arguments);
                  }
                  currentstream.toString = function () {
                    return _currentstream.toString();
                  };
                  return currentstream;
                }(function (obj) {
                  with (obj) return currentstream;
                }),
                "fullscreensupport && !nofullscreen": function fullscreensupportNofullscreen(obj) {
                  with (obj) return fullscreensupport && !nofullscreen;
                },
                fullscreened: function (_fullscreened) {
                  function fullscreened(_x128) {
                    return _fullscreened.apply(this, arguments);
                  }
                  fullscreened.toString = function () {
                    return _fullscreened.toString();
                  };
                  return fullscreened;
                }(function (obj) {
                  with (obj) return fullscreened;
                }),
                disablepause: function (_disablepause) {
                  function disablepause(_x129) {
                    return _disablepause.apply(this, arguments);
                  }
                  disablepause.toString = function () {
                    return _disablepause.toString();
                  };
                  return disablepause;
                }(function (obj) {
                  with (obj) return disablepause;
                }),
                disableseeking: function (_disableseeking) {
                  function disableseeking(_x130) {
                    return _disableseeking.apply(this, arguments);
                  }
                  disableseeking.toString = function () {
                    return _disableseeking.toString();
                  };
                  return disableseeking;
                }(function (obj) {
                  with (obj) return disableseeking;
                }),
                skipseconds: function (_skipseconds) {
                  function skipseconds(_x131) {
                    return _skipseconds.apply(this, arguments);
                  }
                  skipseconds.toString = function () {
                    return _skipseconds.toString();
                  };
                  return skipseconds;
                }(function (obj) {
                  with (obj) return skipseconds;
                }),
                skipinitial: function (_skipinitial) {
                  function skipinitial(_x132) {
                    return _skipinitial.apply(this, arguments);
                  }
                  skipinitial.toString = function () {
                    return _skipinitial.toString();
                  };
                  return skipinitial;
                }(function (obj) {
                  with (obj) return skipinitial;
                }),
                showsettingsmenu: function (_showsettingsmenu) {
                  function showsettingsmenu(_x133) {
                    return _showsettingsmenu.apply(this, arguments);
                  }
                  showsettingsmenu.toString = function () {
                    return _showsettingsmenu.toString();
                  };
                  return showsettingsmenu;
                }(function (obj) {
                  with (obj) return showsettingsmenu;
                }),
                settingsmenu_active: function (_settingsmenu_active) {
                  function settingsmenu_active(_x134) {
                    return _settingsmenu_active.apply(this, arguments);
                  }
                  settingsmenu_active.toString = function () {
                    return _settingsmenu_active.toString();
                  };
                  return settingsmenu_active;
                }(function (obj) {
                  with (obj) return settingsmenu_active;
                }),
                hidevolumebar: function (_hidevolumebar2) {
                  function hidevolumebar(_x135) {
                    return _hidevolumebar2.apply(this, arguments);
                  }
                  hidevolumebar.toString = function () {
                    return _hidevolumebar2.toString();
                  };
                  return hidevolumebar;
                }(function (obj) {
                  with (obj) return hidevolumebar;
                }),
                manuallypaused: function (_manuallypaused) {
                  function manuallypaused(_x136) {
                    return _manuallypaused.apply(this, arguments);
                  }
                  manuallypaused.toString = function () {
                    return _manuallypaused.toString();
                  };
                  return manuallypaused;
                }(function (obj) {
                  with (obj) return manuallypaused;
                }),
                dyntracks: function (_dyntracks) {
                  function dyntracks(_x137) {
                    return _dyntracks.apply(this, arguments);
                  }
                  dyntracks.toString = function () {
                    return _dyntracks.toString();
                  };
                  return dyntracks;
                }(function (obj) {
                  with (obj) return dyntracks;
                }),
                "csstracks || css": function csstracksCss(obj) {
                  with (obj) return csstracks || css;
                },
                "tracktagssupport || allowtexttrackupload": function tracktagssupportAllowtexttrackupload(obj) {
                  with (obj) return tracktagssupport || allowtexttrackupload;
                },
                trackselectorhovered: function (_trackselectorhovered) {
                  function trackselectorhovered(_x138) {
                    return _trackselectorhovered.apply(this, arguments);
                  }
                  trackselectorhovered.toString = function () {
                    return _trackselectorhovered.toString();
                  };
                  return trackselectorhovered;
                }(function (obj) {
                  with (obj) return trackselectorhovered;
                }),
                tracktagsstyled: function (_tracktagsstyled) {
                  function tracktagsstyled(_x139) {
                    return _tracktagsstyled.apply(this, arguments);
                  }
                  tracktagsstyled.toString = function () {
                    return _tracktagsstyled.toString();
                  };
                  return tracktagsstyled;
                }(function (obj) {
                  with (obj) return tracktagsstyled;
                }),
                trackcuetext: function (_trackcuetext2) {
                  function trackcuetext(_x140) {
                    return _trackcuetext2.apply(this, arguments);
                  }
                  trackcuetext.toString = function () {
                    return _trackcuetext2.toString();
                  };
                  return trackcuetext;
                }(function (obj) {
                  with (obj) return trackcuetext;
                }),
                uploadtexttracksvisible: function (_uploadtexttracksvisible) {
                  function uploadtexttracksvisible(_x141) {
                    return _uploadtexttracksvisible.apply(this, arguments);
                  }
                  uploadtexttracksvisible.toString = function () {
                    return _uploadtexttracksvisible.toString();
                  };
                  return uploadtexttracksvisible;
                }(function (obj) {
                  with (obj) return uploadtexttracksvisible;
                }),
                acceptedtracktexts: function (_acceptedtracktexts2) {
                  function acceptedtracktexts(_x142) {
                    return _acceptedtracktexts2.apply(this, arguments);
                  }
                  acceptedtracktexts.toString = function () {
                    return _acceptedtracktexts2.toString();
                  };
                  return acceptedtracktexts;
                }(function (obj) {
                  with (obj) return acceptedtracktexts;
                }),
                uploadlocales: function (_uploadlocales2) {
                  function uploadlocales(_x143) {
                    return _uploadlocales2.apply(this, arguments);
                  }
                  uploadlocales.toString = function () {
                    return _uploadlocales2.toString();
                  };
                  return uploadlocales;
                }(function (obj) {
                  with (obj) return uploadlocales;
                }),
                dynsettingsmenu: function (_dynsettingsmenu) {
                  function dynsettingsmenu(_x144) {
                    return _dynsettingsmenu.apply(this, arguments);
                  }
                  dynsettingsmenu.toString = function () {
                    return _dynsettingsmenu.toString();
                  };
                  return dynsettingsmenu;
                }(function (obj) {
                  with (obj) return dynsettingsmenu;
                }),
                tmplsettingsmenu: function (_tmplsettingsmenu) {
                  function tmplsettingsmenu(_x145) {
                    return _tmplsettingsmenu.apply(this, arguments);
                  }
                  tmplsettingsmenu.toString = function () {
                    return _tmplsettingsmenu.toString();
                  };
                  return tmplsettingsmenu;
                }(function (obj) {
                  with (obj) return tmplsettingsmenu;
                }),
                dynplaybutton: function (_dynplaybutton) {
                  function dynplaybutton(_x146) {
                    return _dynplaybutton.apply(this, arguments);
                  }
                  dynplaybutton.toString = function () {
                    return _dynplaybutton.toString();
                  };
                  return dynplaybutton;
                }(function (obj) {
                  with (obj) return dynplaybutton;
                }),
                "cssplaybutton || css": function cssplaybuttonCss(obj) {
                  with (obj) return cssplaybutton || css;
                },
                tmplplaybutton: function (_tmplplaybutton) {
                  function tmplplaybutton(_x147) {
                    return _tmplplaybutton.apply(this, arguments);
                  }
                  tmplplaybutton.toString = function () {
                    return _tmplplaybutton.toString();
                  };
                  return tmplplaybutton;
                }(function (obj) {
                  with (obj) return tmplplaybutton;
                }),
                playbutton_active: function (_playbutton_active) {
                  function playbutton_active(_x148) {
                    return _playbutton_active.apply(this, arguments);
                  }
                  playbutton_active.toString = function () {
                    return _playbutton_active.toString();
                  };
                  return playbutton_active;
                }(function (obj) {
                  with (obj) return playbutton_active;
                }),
                trimmingmode: function (_trimmingmode3) {
                  function trimmingmode(_x149) {
                    return _trimmingmode3.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode3.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                showduration: function (_showduration) {
                  function showduration(_x150) {
                    return _showduration.apply(this, arguments);
                  }
                  showduration.toString = function () {
                    return _showduration.toString();
                  };
                  return showduration;
                }(function (obj) {
                  with (obj) return showduration;
                }),
                dynloader: function (_dynloader) {
                  function dynloader(_x151) {
                    return _dynloader.apply(this, arguments);
                  }
                  dynloader.toString = function () {
                    return _dynloader.toString();
                  };
                  return dynloader;
                }(function (obj) {
                  with (obj) return dynloader;
                }),
                "cssloader || css": function cssloaderCss(obj) {
                  with (obj) return cssloader || css;
                },
                tmplloader: function (_tmplloader) {
                  function tmplloader(_x152) {
                    return _tmplloader.apply(this, arguments);
                  }
                  tmplloader.toString = function () {
                    return _tmplloader.toString();
                  };
                  return tmplloader;
                }(function (obj) {
                  with (obj) return tmplloader;
                }),
                loader_active: function (_loader_active) {
                  function loader_active(_x153) {
                    return _loader_active.apply(this, arguments);
                  }
                  loader_active.toString = function () {
                    return _loader_active.toString();
                  };
                  return loader_active;
                }(function (obj) {
                  with (obj) return loader_active;
                }),
                dynshare: function (_dynshare) {
                  function dynshare(_x154) {
                    return _dynshare.apply(this, arguments);
                  }
                  dynshare.toString = function () {
                    return _dynshare.toString();
                  };
                  return dynshare;
                }(function (obj) {
                  with (obj) return dynshare;
                }),
                "cssshare || css": function cssshareCss(obj) {
                  with (obj) return cssshare || css;
                },
                tmplshare: function (_tmplshare) {
                  function tmplshare(_x155) {
                    return _tmplshare.apply(this, arguments);
                  }
                  tmplshare.toString = function () {
                    return _tmplshare.toString();
                  };
                  return tmplshare;
                }(function (obj) {
                  with (obj) return tmplshare;
                }),
                "sharevideourl && sharevideo.length > 0": function sharevideourlSharevideoLength0(obj) {
                  with (obj) return sharevideourl && 0 < sharevideo.length;
                },
                sharevideourl: function (_sharevideourl) {
                  function sharevideourl(_x156) {
                    return _sharevideourl.apply(this, arguments);
                  }
                  sharevideourl.toString = function () {
                    return _sharevideourl.toString();
                  };
                  return sharevideourl;
                }(function (obj) {
                  with (obj) return sharevideourl;
                }),
                sharevideo: function (_sharevideo) {
                  function sharevideo(_x157) {
                    return _sharevideo.apply(this, arguments);
                  }
                  sharevideo.toString = function () {
                    return _sharevideo.toString();
                  };
                  return sharevideo;
                }(function (obj) {
                  with (obj) return sharevideo;
                }),
                dynmessage: function (_dynmessage) {
                  function dynmessage(_x158) {
                    return _dynmessage.apply(this, arguments);
                  }
                  dynmessage.toString = function () {
                    return _dynmessage.toString();
                  };
                  return dynmessage;
                }(function (obj) {
                  with (obj) return dynmessage;
                }),
                "cssmessage || css": function cssmessageCss(obj) {
                  with (obj) return cssmessage || css;
                },
                tmplmessage: function (_tmplmessage) {
                  function tmplmessage(_x159) {
                    return _tmplmessage.apply(this, arguments);
                  }
                  tmplmessage.toString = function () {
                    return _tmplmessage.toString();
                  };
                  return tmplmessage;
                }(function (obj) {
                  with (obj) return tmplmessage;
                }),
                message_active: function (_message_active) {
                  function message_active(_x160) {
                    return _message_active.apply(this, arguments);
                  }
                  message_active.toString = function () {
                    return _message_active.toString();
                  };
                  return message_active;
                }(function (obj) {
                  with (obj) return message_active;
                }),
                message: function (_message2) {
                  function message(_x161) {
                    return _message2.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message2.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message;
                }),
                dyntopmessage: function (_dyntopmessage) {
                  function dyntopmessage(_x162) {
                    return _dyntopmessage.apply(this, arguments);
                  }
                  dyntopmessage.toString = function () {
                    return _dyntopmessage.toString();
                  };
                  return dyntopmessage;
                }(function (obj) {
                  with (obj) return dyntopmessage;
                }),
                "csstopmessage || css": function csstopmessageCss(obj) {
                  with (obj) return csstopmessage || css;
                },
                tmpltopmessage: function (_tmpltopmessage) {
                  function tmpltopmessage(_x163) {
                    return _tmpltopmessage.apply(this, arguments);
                  }
                  tmpltopmessage.toString = function () {
                    return _tmpltopmessage.toString();
                  };
                  return tmpltopmessage;
                }(function (obj) {
                  with (obj) return tmpltopmessage;
                }),
                topmessage: function (_topmessage2) {
                  function topmessage(_x164) {
                    return _topmessage2.apply(this, arguments);
                  }
                  topmessage.toString = function () {
                    return _topmessage2.toString();
                  };
                  return topmessage;
                }(function (obj) {
                  with (obj) return topmessage;
                }),
                thumbnailurl: function (_thumbnailurl) {
                  function thumbnailurl(_x165) {
                    return _thumbnailurl.apply(this, arguments);
                  }
                  thumbnailurl.toString = function () {
                    return _thumbnailurl.toString();
                  };
                  return thumbnailurl;
                }(function (obj) {
                  with (obj) return thumbnailurl;
                }),
                contenturl: function (_contenturl) {
                  function contenturl(_x166) {
                    return _contenturl.apply(this, arguments);
                  }
                  contenturl.toString = function () {
                    return _contenturl.toString();
                  };
                  return contenturl;
                }(function (obj) {
                  with (obj) return contenturl;
                }),
                useAspectRatioFallback: function (_useAspectRatioFallback) {
                  function useAspectRatioFallback(_x167) {
                    return _useAspectRatioFallback.apply(this, arguments);
                  }
                  useAspectRatioFallback.toString = function () {
                    return _useAspectRatioFallback.toString();
                  };
                  return useAspectRatioFallback;
                }(function (obj) {
                  with (obj) return useAspectRatioFallback;
                }),
                aspectRatioFallback: function (_aspectRatioFallback) {
                  function aspectRatioFallback(_x168) {
                    return _aspectRatioFallback.apply(this, arguments);
                  }
                  aspectRatioFallback.toString = function () {
                    return _aspectRatioFallback.toString();
                  };
                  return aspectRatioFallback;
                }(function (obj) {
                  with (obj) return aspectRatioFallback;
                })
              }).attachStringTable(Assets.strings).addStrings({
                "video-error": "An error occurred, please try again later. Click to retry.",
                "all-settings": "All settings",
                "player-speed": "Player speed",
                "full-screen": "Full screen"
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.Chooser", ["dynamics:Dynamic", "module:Assets", "browser:Info"], ["dynamics:Partials.RepeatPartial", "dynamics:Partials.ClickPartial", "dynamics:Partials.IfPartial"], function (Class, Assets, Info, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<div class="{{css}}-chooser-container">\n\t<div ba-if="{{initialmessages.length > 0}}" class="{{csscommon}}-message-container">\n\t\t<ul ba-repeat="{{initialmessage :: initialmessages}}">\n\t\t\t<li ba-if="{{initialmessage.message}}"\n\t\t\t\tclass="{{csscommon}}-message-text {{csscommon}}-message-{{initialmessage.type ? initialmessage.type : \'default\'}}"\n\t\t\t>\n\t\t\t\t{{ initialmessage.message }}\n\t\t\t\t<span ba-if="{{initialmessage.id}}"\n\t\t\t\t\t  class="{{csscommon}}-action-button"\n\t\t\t\t\t  ba-click="close_message(initialmessage.id)"\n\t\t\t\t>\n\t\t\t\t\t<i class="{{csscommon}}-icon-cancel"></i>\n\t\t\t\t</span>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<div class="{{css}}-chooser-button-container">\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t tabindex="0" class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t     ba-click="{{click_action(action)}}"\n\t\t\t>\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   onclick="this.value=\'\'"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture="{{action.switchcamera}}" />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   />\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n',
                  attrs: {
                    css: "ba-videorecorder",
                    csscommon: "ba-commoncss",
                    cssrecorder: "ba-recorder",
                    allowrecord: !0,
                    allowupload: !0,
                    allowscreen: !1,
                    allowmultistreams: !1,
                    facecamera: !0,
                    primaryrecord: !0,
                    recordviafilecapture: !1,
                    allowcustomupload: !0,
                    allowedextensions: null,
                    onlyaudio: !1,
                    parentpopup: !1,
                    initialmessages: []
                  },
                  types: {
                    allowedextensions: "array",
                    recordviafilecapture: "boolean",
                    facecamera: "boolean",
                    parentpopup: "boolean",
                    initialmessages: "array"
                  },
                  collections: ["actions"],
                  create: function create() {
                    var i = "";
                    this.get("allowedextensions") && 0 < this.get("allowedextensions").length ? (Info.isEdge() || Info.isChrome() || Info.isOpera() || Info.isFirefox() && 42 <= Info.firefoxVersion() || Info.isInternetExplorer() && 10 <= Info.internetExplorerVersion()) && (i = "." + this.get("allowedextensions").join(",.")) : this.get("allowcustomupload") || (i = "video/*,video/mp4");
                    var e = [];
                    this.get("primaryrecord") ? (this.get("allowrecord") && e.push("record"), this.get("allowscreen") && e.push("screen"), this.get("allowmultistreams") && e.push("multistream"), this.get("allowupload") && e.push("upload")) : (this.get("allowscreen") && e.push("screen"), this.get("allowupload") && e.push("upload"), this.get("allowrecord") && e.push("record"), this.get("allowmultistreams") && e.push("multistream"));
                    var r = this.get("actions");
                    e.forEach(function (e, t) {
                      switch (e) {
                        case "record":
                          r.add({
                            type: "record",
                            index: t,
                            icon: this.get("onlyaudio") ? "volume-up" : "videocam",
                            label: this.string(this.get("onlyaudio") ? "record-audio" : "record-video"),
                            select: Info.isMobile() && !(Info.isAndroid() && Info.isCordova()) && this.get("recordviafilecapture"),
                            capture: !0,
                            accept: "video/*,video/mp4;capture=camcorder",
                            switchcamera: this.get("facecamera") ? "user" : "environment"
                          });
                          break;
                        case "upload":
                          r.add({
                            type: "upload",
                            index: t,
                            icon: "upload",
                            label: this.string("upload-video"),
                            select: !(Info.isiOS() && Info.isCordova() || this.get("parentpopup")),
                            accept: !Info.isMobile() || Info.isAndroid() && Info.isCordova() ? i : "video/*,video/mp4"
                          });
                          break;
                        case "screen":
                          r.add({
                            type: "screen",
                            index: t,
                            icon: "television",
                            label: this.string("record-screen")
                          });
                          break;
                        case "multistream":
                          r.add({
                            type: "multistream",
                            index: t,
                            icon: "plus",
                            label: this.string("multi-stream")
                          });
                      }
                    }, this);
                  },
                  functions: {
                    click_action: function click_action(e) {
                      var t;
                      e.get("select") || ("screen" !== e.get("type") && "multistream" !== e.get("type") ? Info.isMobile() && Info.isCordova() ? (t = this, Info.isAndroid() ? navigator.device.capture.captureVideo(function (e) {
                        t.trigger("upload", e[0]);
                      }, function (e) {}, {
                        limit: 1,
                        duration: this.get("timelimit")
                      }) : Info.isiOS() && navigator.camera.getPicture(function (e) {
                        t.trigger("upload", {
                          localURL: e,
                          fullPath: e
                        });
                      }, function (e) {}, {
                        destinationType: Camera.DestinationType.FILE_URI,
                        sourceType: Camera.PictureSourceType.PHOTOLIBRARY,
                        mediaType: Camera.MediaType.VIDEO
                      })) : this.trigger("record") : this.trigger("record-screen", "multistream" === e.get("type")));
                    },
                    select_file_action: function select_file_action(e, t) {
                      e.get("select") && this.trigger("upload", t[0].target);
                    },
                    close_message: function close_message(t) {
                      "undefined" != typeof Array.prototype.filter && this.set("initialmessages", this.get("initialmessages").filter(function (e) {
                        return e.id !== t;
                      }));
                    }
                  }
                };
              }).registerFunctions({
                css: function (_css7) {
                  function css(_x169) {
                    return _css7.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css7.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "initialmessages.length > 0": function initialmessagesLength0(obj) {
                  with (obj) return 0 < initialmessages.length;
                },
                csscommon: function (_csscommon6) {
                  function csscommon(_x170) {
                    return _csscommon6.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon6.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                initialmessages: function (_initialmessages) {
                  function initialmessages(_x171) {
                    return _initialmessages.apply(this, arguments);
                  }
                  initialmessages.toString = function () {
                    return _initialmessages.toString();
                  };
                  return initialmessages;
                }(function (obj) {
                  with (obj) return initialmessages;
                }),
                "initialmessage.message": function initialmessageMessage(obj) {
                  with (obj) return initialmessage.message;
                },
                "initialmessage.type ? initialmessage.type : 'default'": function initialmessageTypeInitialmessageTypeDefault(obj) {
                  with (obj) return initialmessage.type ? initialmessage.type : "default";
                },
                "initialmessage.id": function initialmessageId(obj) {
                  with (obj) return initialmessage.id;
                },
                actions: function (_actions) {
                  function actions(_x172) {
                    return _actions.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.switchcamera": function actionSwitchcamera(obj) {
                  with (obj) return action.switchcamera;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                }
              }).register("ba-videorecorder-chooser").attachStringTable(Assets.strings).addStrings({
                "record-video": "Record Video",
                "record-audio": "Record Audio",
                "record-screen": "Record Screen",
                "multi-stream": "Multi Stream",
                "upload-video": "Upload Video"
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.Controlbar", ["dynamics:Dynamic", "module:Assets", "base:Timers.Timer", "browser:Info"], ["dynamics:Partials.ShowPartial", "dynamics:Partials.RepeatPartial"], function (Class, Assets, Timer, Info, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<div class="{{css}}-dashboard">\n\t<div class="{{css}}-backbar"></div>\n\t<div data-selector="recorder-settings" class="{{css}}-settings" ba-show="{{settingsvisible && settingsopen}}">\n\t\t<div class="{{css}}-settings-backbar"></div>\n\t\t<div data-selector="settings-list-front" class="{{css}}-settings-front">\n\t\t\t<ul data-selector="add-new-stream" ba-if="{{videoselectnotification}}">\n\t\t\t\t<li>\n\t\t\t\t\t<div data-selector="single-camera-stream">\n\t\t\t\t\t\t<i class="ba-commoncss-icon-plus"></i> {{string(\'add-stream\')}}\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<div data-selector="single-camera-stream" class="{{csscommon}}-text-error">\n\t\t\t\t\t\t{{videoselectnotification}}\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<ul data-selector="add-new-stream" ba-show="{{showaddstreambutton && firefox && allowscreen}}">\n                <li>\n                    <div data-selector="single-camera-stream"\n                         class="{{css}}-add-stream"\n                         onclick="{{addNewStream()}}"\n                         onmouseenter="{{hover(string(\'add-stream\'))}}"\n                    >\n                        <i class="{{csscommon}}-icon-plus"></i> {{string(\'add-stream\')}}\n                    </div>\n                </li>\n\t\t\t</ul>\n\n\t\t\t<ul data-selector="add-new-stream" ba-show="{{showaddstreambutton && !firefox && !videoselectnotification}}" ba-repeat="{{camera :: cameras}}">\n\t\t\t\t<li ba-show="{{(camera.id !== selectedcamera) || allowscreen}}">\n\t\t\t\t\t<div data-selector="single-camera-stream"\n\t\t\t\t\t\t class="{{css}}-add-stream"\n\t\t\t\t\t\t onclick="{{addNewStream(camera.id)}}"\n\t\t\t\t\t\t onmouseenter="{{hover(string(\'add-stream\'))}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-plus"></i> {{camera.label}}\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\n\t\t\t</ul>\n\t\t\t<hr ba-show="{{(showaddstreambutton && !firefox) || (firefox && allowscreen)}}"/>\n\t\t\t<ul data-selector="camera-settings" ba-repeat="{{camera :: cameras}}" ba-show="{{!novideo && !allowscreen && !ismobile}}">\n\t\t\t\t<li onmouseenter="{{hover(string(\'select-camera\'))}}">\n\t\t\t\t\t<input tabindex="0"\n\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t   type=\'radio\' name=\'camera\' value="{{selectedcamera == camera.id}}"\n\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t/>\n\t\t\t\t\t<span></span>\n\t\t\t\t\t<label tabindex="0"\n\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t{{camera.label}}\n\t\t\t\t\t</label>\n\t\t\t\t </li>\n\t\t\t</ul>\n\t\t\t<hr ba-show="{{(!noaudio && !novideo) || !allowscreen}}"/>\n\t\t\t<ul data-selector="microphone-settings" ba-repeat="{{microphone :: microphones}}" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t<li tabindex="0"\n\t\t\t\t\tba-hotkey:space^enter="{{selectMicrophone(microphone.id)}}" onmouseout="this.blur()"\n\t\t\t\t\tonmouseenter="{{hover(string(\'select-audio-input\'))}}"\n\t\t\t\t\tonclick="{{selectMicrophone(microphone.id)}}"\n\t\t\t\t>\n\t\t\t\t\t<input type=\'radio\' name=\'microphone\' value="{{selectedmicrophone == microphone.id}}" />\n\t\t\t\t\t<span></span>\n\t\t\t\t\t<label>\n\t\t\t\t\t\t{{microphone.label}}\n\t\t\t\t\t</label>\n\t\t\t\t </li>\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n\t\t<div class="{{css}}-leftbutton-container" ba-show="{{settingsvisible && ismobile}}">\n\t\t\t<div data-selector="face-mode-toggle-icon" class="{{css}}-mobile-camera-switcher {{css}}-button-inner"\n\t\t\t\t onclick="{{toggleFaceMode()}}"\n\t\t\t\t onmouseenter="{{hover(string(\'switch-camera\'))}}"\n\t\t\t>\n\t\t\t\t<i class="{{csscommon}}-icon-arrows-cw"></i>\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-leftbutton-container" ba-show="{{settingsvisible}}">\n            <div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{settingsopen=!settingsopen}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="record-button-icon-cog" class="{{css}}-button-inner {{css}}-button-{{settingsopen ? \'selected\' : \'unselected\'}}"\n                 onclick="{{settingsopen=!settingsopen}}"\n                 onmouseenter="{{hover(string(\'settings\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                <i class="{{csscommon}}-icon-cog"></i>\n            </div>\n        </div>\n\n        <div class="{{css}}-lefticon-container" ba-show="{{settingsvisible && !novideo && !allowscreen}}">\n            <div data-selector="record-button-icon-videocam" class="{{csscommon}}-icon-inner"\n                 onmouseenter="{{hover(string(camerahealthy ? \'camerahealthy\' : \'cameraunhealthy\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                <i class="{{csscommon}}-icon-videocam {{csscommon}}-icon-state-{{camerahealthy ? \'good\' : \'bad\' }}"></i>\n            </div>\n        </div>\n\n        <div class="{{css}}-lefticon-container" ba-show="{{settingsvisible && !noaudio && !allowscreen}}">\n            <div data-selector="record-button-icon-mic" class="{{csscommon}}-icon-inner"\n                 onmouseenter="{{hover(string(microphonehealthy ? \'microphonehealthy\' : \'microphoneunhealthy\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                <i class="{{csscommon}}-icon-mic {{csscommon}}-icon-state-{{microphonehealthy ? \'good\' : \'bad\' }}"></i>\n            </div>\n        </div>\n\n        <div class="{{css}}-lefticon-container" ba-show="{{stopvisible && recordingindication}}">\n            <div data-selector="recording-indicator" class="{{css}}-recording-indication">\n            </div>\n        </div>\n\n        <div class="{{css}}-label-container" ba-show="{{controlbarlabel}}">\n        \t<div data-selector="record-label-block" class="{{css}}-label-label">\n        \t\t{{controlbarlabel}}\n        \t</div>\n        </div>\n\n        <div class="{{css}}-rightbutton-container" ba-show="{{recordvisible}}">\n        \t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="record-primary-button" class="{{css}}-button-primary"\n                 onclick="{{record()}}"\n                 onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n        \t\t{{string(\'record\')}}\n        \t</div>\n        </div>\n\n        <div class="{{css}}-rightbutton-container" ba-if="{{uploadcovershotvisible}}">\n        \t<div data-selector="covershot-primary-button" class="{{css}}-button-primary"\n                 onmouseenter="{{hover(string(\'upload-covershot-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                 <input type="file"\n\t\t\t\t       class="{{css}}-chooser-file"\n\t\t\t\t       style="height:100"\n\t\t\t\t       onchange="{{uploadCovershot(domEvent)}}"\n\t\t\t\t       accept="{{covershot_accept_string}}"\n\t\t\t\t />\n                 <span>\n        \t\t\t{{string(\'upload-covershot\')}}\n        \t\t</span>\n        \t</div>\n        </div>\n\n        <div class="{{css}}-rightbutton-container" ba-show="{{rerecordvisible}}">\n        \t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="rerecord-primary-button" class="{{css}}-button-primary"\n                 onclick="{{rerecord()}}"\n                 onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n        \t\t{{string(\'rerecord\')}}\n        \t</div>\n        </div>\n\n\t\t<div class="{{css}}-rightbutton-container" ba-show="{{cancelvisible}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="cancel-primary-button" class="{{css}}-button-primary"\n\t\t\t\t onclick="{{cancel()}}"\n\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t>\n\t\t\t\t{{string(\'cancel\')}}\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-rightbutton-container" ba-show="{{stopvisible}}">\n        \t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="stop-primary-button" class="{{css}}-button-primary {{mintimeindicator ? css + \'-disabled\': \'\'}}"\n\t\t\t\t title="{{mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\')}}"\n                 onclick="{{stop()}}"\n                 onmouseenter="{{hover( mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n        \t\t{{string(\'stop\')}}\n        \t</div>\n        </div>\n\n\t\t<div class="{{css}}-rightbutton-container" ba-show="{{pausable && !resumevisible && stopvisible}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="pause-primary-button" class="{{css}}-button-primary"\n\t\t\t\t title="{{string(\'pause-recorder\')}}"\n\t\t\t\t onclick="{{pause()}}"\n\t\t\t\t onmouseenter="{{hover(string(\'pause-recorder\'))}}"\n\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t>\n\t\t\t\t<i class="{{csscommon}}-icon-pause"></i>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="{{css}}-rightbutton-container" ba-show="{{pausable && resumevisible}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{resume()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="resume-primary-button" class="{{css}}-button-primary"\n\t\t\t\t title="{{string(\'resume-recorder\')}}"\n\t\t\t\t onclick="{{resume()}}"\n\t\t\t\t onmouseenter="{{hover(string(\'resume-recorder\'))}}"\n\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t>\n\t\t\t\t<i class="{{csscommon}}-icon-ccw"></i>\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-centerbutton-container" ba-show="{{skipvisible}}">\n        \t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{skip()}}"  onmouseout="this.blur()"\n\t\t\t\t data-selector="skip-primary-button" class="{{css}}-button-primary"\n                 onclick="{{skip()}}"\n                 onmouseenter="{{hover(string(\'skip-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n        \t\t{{string(\'skip\')}}\n        \t</div>\n        </div>\n\t</div>\n</div>\n',
                  attrs: {
                    css: "ba-videorecorder",
                    csscommon: "ba-commoncss",
                    cssrecorder: "ba-recorder",
                    hovermessage: "",
                    videoselectnotification: null,
                    ismobile: !1,
                    recordingindication: !0,
                    covershot_accept_string: "image/*,image/png,image/jpg,image/jpeg"
                  },
                  events: {
                    "change:settingsopen": function changeSettingsopen(e) {
                      if (e) {
                        var t = this.get("cameras").count();
                        if (this.get("cameras").count() < 1) this.set("videoselectnotification", this.string("no-video-source"));else {
                          if (1 < t && this.get("addstreamdeviceid")) return void this.set("videoselectnotification", this.string("stream-already-selected"));
                          this.get("cameras").iterate(function (e) {
                            1 === t && this.get("addstreamdeviceid") === e.data().id && this.set("videoselectnotification", this.string("stream-already-selected"));
                          }, this);
                        }
                      } else this.set("videoselectnotification", null);
                    }
                  },
                  create: function create() {
                    this.set("ismobile", Info.isMobile()), this.auto_destroy(new Timer({
                      context: this,
                      fire: function fire() {
                        this.set("recordingindication", !this.get("recordingindication") && !this.__parent.__paused);
                      },
                      delay: 500
                    }));
                  },
                  functions: {
                    selectCamera: function selectCamera(e) {
                      this.trigger("select-camera", e);
                    },
                    selectMicrophone: function selectMicrophone(e) {
                      this.trigger("select-microphone", e);
                    },
                    toggleFaceMode: function toggleFaceMode() {
                      this.trigger("toggle-face-mode");
                    },
                    addNewStream: function addNewStream(e) {
                      this.set("settingsopen", !1), this.set("hovermessage", ""), this.trigger("add-new-stream", e);
                    },
                    hover: function hover(e) {
                      this.set("hovermessage", e);
                    },
                    unhover: function unhover() {
                      this.set("hovermessage", "");
                    },
                    record: function record() {
                      this.trigger("invoke-record");
                    },
                    rerecord: function rerecord() {
                      this.trigger("invoke-rerecord");
                    },
                    stop: function stop() {
                      this.trigger("invoke-stop");
                    },
                    pause: function pause() {
                      this.trigger("invoke-pause");
                    },
                    resume: function resume() {
                      this.trigger("invoke-resume");
                    },
                    skip: function skip() {
                      this.trigger("invoke-skip");
                    },
                    cancel: function cancel() {
                      this.trigger("invoke-cancel");
                    },
                    uploadCovershot: function uploadCovershot(e) {
                      this.trigger("upload-covershot", e[0].target);
                    }
                  }
                };
              }).register("ba-videorecorder-controlbar").registerFunctions({
                css: function (_css8) {
                  function css(_x173) {
                    return _css8.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css8.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "settingsvisible && settingsopen": function settingsvisibleSettingsopen(obj) {
                  with (obj) return settingsvisible && settingsopen;
                },
                videoselectnotification: function (_videoselectnotification) {
                  function videoselectnotification(_x174) {
                    return _videoselectnotification.apply(this, arguments);
                  }
                  videoselectnotification.toString = function () {
                    return _videoselectnotification.toString();
                  };
                  return videoselectnotification;
                }(function (obj) {
                  with (obj) return videoselectnotification;
                }),
                "string('add-stream')": function stringAddStream(obj) {
                  with (obj) return string("add-stream");
                },
                csscommon: function (_csscommon7) {
                  function csscommon(_x175) {
                    return _csscommon7.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon7.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "showaddstreambutton && firefox && allowscreen": function showaddstreambuttonFirefoxAllowscreen(obj) {
                  with (obj) return showaddstreambutton && firefox && allowscreen;
                },
                "addNewStream()": function (_addNewStream) {
                  function addNewStream(_x176) {
                    return _addNewStream.apply(this, arguments);
                  }
                  addNewStream.toString = function () {
                    return _addNewStream.toString();
                  };
                  return addNewStream;
                }(function (obj) {
                  with (obj) return addNewStream();
                }),
                "hover(string('add-stream'))": function hoverStringAddStream(obj) {
                  with (obj) return hover(string("add-stream"));
                },
                "showaddstreambutton && !firefox && !videoselectnotification": function showaddstreambuttonFirefoxVideoselectnotification(obj) {
                  with (obj) return showaddstreambutton && !firefox && !videoselectnotification;
                },
                cameras: function (_cameras) {
                  function cameras(_x177) {
                    return _cameras.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "(camera.id !== selectedcamera) || allowscreen": function cameraIdSelectedcameraAllowscreen(obj) {
                  with (obj) return camera.id !== selectedcamera || allowscreen;
                },
                "addNewStream(camera.id)": function addNewStreamCameraId(obj) {
                  with (obj) return addNewStream(camera.id);
                },
                "camera.label": function cameraLabel(obj) {
                  with (obj) return camera.label;
                },
                "(showaddstreambutton && !firefox) || (firefox && allowscreen)": function showaddstreambuttonFirefoxFirefoxAllowscreen(obj) {
                  with (obj) return showaddstreambutton && !firefox || firefox && allowscreen;
                },
                "!novideo && !allowscreen && !ismobile": function novideoAllowscreenIsmobile(obj) {
                  with (obj) return !novideo && !allowscreen && !ismobile;
                },
                "hover(string('select-camera'))": function hoverStringSelectCamera(obj) {
                  with (obj) return hover(string("select-camera"));
                },
                "selectCamera(camera.id)": function selectCameraCameraId(obj) {
                  with (obj) return selectCamera(camera.id);
                },
                "selectedcamera == camera.id": function selectedcameraCameraId(obj) {
                  with (obj) return selectedcamera == camera.id;
                },
                "(!noaudio && !novideo) || !allowscreen": function noaudioNovideoAllowscreen(obj) {
                  with (obj) return !noaudio && !novideo || !allowscreen;
                },
                microphones: function (_microphones) {
                  function microphones(_x178) {
                    return _microphones.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                "!noaudio && !allowscreen": function noaudioAllowscreen(obj) {
                  with (obj) return !noaudio && !allowscreen;
                },
                "selectMicrophone(microphone.id)": function selectMicrophoneMicrophoneId(obj) {
                  with (obj) return selectMicrophone(microphone.id);
                },
                "hover(string('select-audio-input'))": function hoverStringSelectAudioInput(obj) {
                  with (obj) return hover(string("select-audio-input"));
                },
                "selectedmicrophone == microphone.id": function selectedmicrophoneMicrophoneId(obj) {
                  with (obj) return selectedmicrophone == microphone.id;
                },
                "microphone.label": function microphoneLabel(obj) {
                  with (obj) return microphone.label;
                },
                "settingsvisible && ismobile": function settingsvisibleIsmobile(obj) {
                  with (obj) return settingsvisible && ismobile;
                },
                "toggleFaceMode()": function (_toggleFaceMode) {
                  function toggleFaceMode(_x179) {
                    return _toggleFaceMode.apply(this, arguments);
                  }
                  toggleFaceMode.toString = function () {
                    return _toggleFaceMode.toString();
                  };
                  return toggleFaceMode;
                }(function (obj) {
                  with (obj) return toggleFaceMode();
                }),
                "hover(string('switch-camera'))": function hoverStringSwitchCamera(obj) {
                  with (obj) return hover(string("switch-camera"));
                },
                settingsvisible: function (_settingsvisible) {
                  function settingsvisible(_x180) {
                    return _settingsvisible.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                "unhover()": function (_unhover) {
                  function unhover(_x181) {
                    return _unhover.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                "settingsvisible && !novideo && !allowscreen": function settingsvisibleNovideoAllowscreen(obj) {
                  with (obj) return settingsvisible && !novideo && !allowscreen;
                },
                "hover(string(camerahealthy ? 'camerahealthy' : 'cameraunhealthy'))": function hoverStringCamerahealthyCamerahealthyCameraunhealthy(obj) {
                  with (obj) return hover(string(camerahealthy ? "camerahealthy" : "cameraunhealthy"));
                },
                "camerahealthy ? 'good' : 'bad'": function camerahealthyGoodBad(obj) {
                  with (obj) return camerahealthy ? "good" : "bad";
                },
                "settingsvisible && !noaudio && !allowscreen": function settingsvisibleNoaudioAllowscreen(obj) {
                  with (obj) return settingsvisible && !noaudio && !allowscreen;
                },
                "hover(string(microphonehealthy ? 'microphonehealthy' : 'microphoneunhealthy'))": function hoverStringMicrophonehealthyMicrophonehealthyMicrophoneunhealthy(obj) {
                  with (obj) return hover(string(microphonehealthy ? "microphonehealthy" : "microphoneunhealthy"));
                },
                "microphonehealthy ? 'good' : 'bad'": function microphonehealthyGoodBad(obj) {
                  with (obj) return microphonehealthy ? "good" : "bad";
                },
                "stopvisible && recordingindication": function stopvisibleRecordingindication(obj) {
                  with (obj) return stopvisible && recordingindication;
                },
                controlbarlabel: function (_controlbarlabel) {
                  function controlbarlabel(_x182) {
                    return _controlbarlabel.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                recordvisible: function (_recordvisible) {
                  function recordvisible(_x183) {
                    return _recordvisible.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record) {
                  function record(_x184) {
                    return _record.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                uploadcovershotvisible: function (_uploadcovershotvisible) {
                  function uploadcovershotvisible(_x185) {
                    return _uploadcovershotvisible.apply(this, arguments);
                  }
                  uploadcovershotvisible.toString = function () {
                    return _uploadcovershotvisible.toString();
                  };
                  return uploadcovershotvisible;
                }(function (obj) {
                  with (obj) return uploadcovershotvisible;
                }),
                "hover(string('upload-covershot-tooltip'))": function hoverStringUploadCovershotTooltip(obj) {
                  with (obj) return hover(string("upload-covershot-tooltip"));
                },
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                covershot_accept_string: function (_covershot_accept_string) {
                  function covershot_accept_string(_x186) {
                    return _covershot_accept_string.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                },
                rerecordvisible: function (_rerecordvisible) {
                  function rerecordvisible(_x187) {
                    return _rerecordvisible.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord3) {
                  function rerecord(_x188) {
                    return _rerecord3.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord3.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible) {
                  function cancelvisible(_x189) {
                    return _cancelvisible.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel) {
                  function cancel(_x190) {
                    return _cancel.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                },
                stopvisible: function (_stopvisible) {
                  function stopvisible(_x191) {
                    return _stopvisible.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                "stop()": function (_stop) {
                  function stop(_x192) {
                    return _stop.apply(this, arguments);
                  }
                  stop.toString = function () {
                    return _stop.toString();
                  };
                  return stop;
                }(function (obj) {
                  with (obj) return stop();
                }),
                "mintimeindicator ? css + '-disabled': ''": function mintimeindicatorCssDisabled(obj) {
                  with (obj) return mintimeindicator ? css + "-disabled" : "";
                },
                "mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip')": function mintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip");
                },
                "hover( mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip'))": function hoverMintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return hover(mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip"));
                },
                "string('stop')": function stringStop(obj) {
                  with (obj) return string("stop");
                },
                "pausable && !resumevisible && stopvisible": function pausableResumevisibleStopvisible(obj) {
                  with (obj) return pausable && !resumevisible && stopvisible;
                },
                "pause()": function (_pause2) {
                  function pause(_x193) {
                    return _pause2.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause2.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "string('pause-recorder')": function stringPauseRecorder(obj) {
                  with (obj) return string("pause-recorder");
                },
                "hover(string('pause-recorder'))": function hoverStringPauseRecorder(obj) {
                  with (obj) return hover(string("pause-recorder"));
                },
                "pausable && resumevisible": function pausableResumevisible(obj) {
                  with (obj) return pausable && resumevisible;
                },
                "resume()": function (_resume) {
                  function resume(_x194) {
                    return _resume.apply(this, arguments);
                  }
                  resume.toString = function () {
                    return _resume.toString();
                  };
                  return resume;
                }(function (obj) {
                  with (obj) return resume();
                }),
                "string('resume-recorder')": function stringResumeRecorder(obj) {
                  with (obj) return string("resume-recorder");
                },
                "hover(string('resume-recorder'))": function hoverStringResumeRecorder(obj) {
                  with (obj) return hover(string("resume-recorder"));
                },
                skipvisible: function (_skipvisible) {
                  function skipvisible(_x195) {
                    return _skipvisible.apply(this, arguments);
                  }
                  skipvisible.toString = function () {
                    return _skipvisible.toString();
                  };
                  return skipvisible;
                }(function (obj) {
                  with (obj) return skipvisible;
                }),
                "skip()": function (_skip2) {
                  function skip(_x196) {
                    return _skip2.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip2.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "hover(string('skip-tooltip'))": function hoverStringSkipTooltip(obj) {
                  with (obj) return hover(string("skip-tooltip"));
                },
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                }
              }).attachStringTable(Assets.strings).addStrings({
                settings: "Settings",
                camerahealthy: "Lighting is good",
                cameraunhealthy: "Lighting is not optimal",
                microphonehealthy: "Sound is good",
                microphoneunhealthy: "Cannot pick up any sound",
                record: "Record",
                "record-tooltip": "Click here to record.",
                rerecord: "Redo",
                "rerecord-tooltip": "Click here to redo.",
                "upload-covershot": "Upload Cover",
                "upload-covershot-tooltip": "Click here to upload custom cover shot",
                stop: "Stop",
                "stop-tooltip": "Click here to stop.",
                skip: "Skip",
                "skip-tooltip": "Click here to skip.",
                "stop-available-after": "Minimum recording time is %d seconds",
                cancel: "Cancel",
                "cancel-tooltip": "Click here to cancel.",
                "add-stream": "Add Stream",
                "pause-recorder": "Pause Recorder",
                "resume-recorder": "Resume Recorder",
                "no-video-source": "Missing additional video input source",
                "stream-already-selected": "Additional stream has been already selected"
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.Faceoutline", ["dynamics:Dynamic"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  template: '<svg viewBox="0 0 301 171" style="width:100%; height:100%; position: absolute; top: 0; left: 0">\n    <g>\n        <path fill="none" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-dasharray="3.0228,3.0228" d="M198.5,79.831c0,40.542-22.752,78.579-47.5,78.579c-24.749,0-47.5-38.036-47.5-78.579c0-40.543,17.028-68.24,47.5-68.24C185.057,11.591,198.5,39.288,198.5,79.831z"></path>\n    </g>\n</svg>'
                };
              }).registerFunctions({}).register("ba-videorecorder-faceoutline");
            }), Scoped.define("module:VideoRecorder.Dynamics.Imagegallery", ["dynamics:Dynamic", "media:Recorder.Support", "base:Collections.Collection", "base:Properties.Properties", "base:Timers.Timer", "browser:Dom", "browser:Info", "module:Assets"], ["dynamics:Partials.StylesPartial"], function (Class, RecorderSupport, Collection, Properties, Timer, Dom, Info, Assets, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (t) {
                return {
                  template: '<div ba-if="{{showslidercontainer}}">\n\t<div data-selector="slider-left-button" class="{{css}}-imagegallery-leftbutton">\n\t\t<div tabindex="0" data-selector="slider-left-inner-button"\n\t\t\t ba-hotkey:space^enter^left="{{left()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-button-inner" onclick="{{left()}}"\n\t\t>\n\t\t\t<i class="{{csscommon}}-icon-left-open"></i>\n\t\t</div>\n\t</div>\n\n\t<div data-selector="images-imagegallery-container" ba-repeat="{{image::images}}"\n\t\t class="{{css}}-imagegallery-container" data-gallery-container>\n\t\t<div tabindex="0" class="{{css}}-imagegallery-image"\n\t\t\t ba-hotkey:space^enter="{{select(image)}}" onmouseout="this.blur()"\n\t\t\t ba-styles="{{{left: image.left + \'px\', top: image.top + \'px\', width: image.width + \'px\', height: image.height + \'px\'}}}"\n\t\t\t onclick="{{select(image)}}"\n\t\t>\n\t\t\t<div class="{{css}}-imagegallery-image-compat" ba-show="{{ie10below}}"></div>\n\t\t</div>\n\t</div>\n\n\t<div data-selector="slider-right-button" class="{{css}}-imagegallery-rightbutton">\n\t\t<div tabindex="0" data-selector="slider-right-inner-button"\n\t\t\t ba-hotkey:space^enter^right="{{right()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-button-inner" onclick="{{right()}}"\n\t\t>\n\t\t\t<i class="{{csscommon}}-icon-right-open"></i>\n\t\t</div>\n\t</div>\n</div>\n\n<div ba-if="{{!showslidercontainer}}" class="{{css}}-chooser-container">\n\t<div data-selector="covershot-primary-button" class="{{css}}-chooser-button-container">\n\t\t<div class="{{css}}-chooser-button-0">\n\t\t\t<input type="file"\n\t\t\t\t   tabindex="0"\n\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t   accept="{{covershot_accept_string}}"\n\t\t\t\t   onchange="{{uploadCovershot(domEvent)}}"\n\t\t\t/>\n\t\t\t<i class="{{csscommon}}-icon-picture"></i>\n\t\t\t<span>\n\t\t\t{{string(\'upload-covershot\')}}\n\t\t</span>\n\t\t</div>\n\t</div>\n</div>\n',
                  attrs: {
                    css: "ba-videorecorder",
                    csscommon: "ba-commoncss",
                    cssrecorder: "ba-recorder",
                    imagecount: 3,
                    imagenativewidth: 0,
                    imagenativeheight: 0,
                    containerwidth: 0,
                    containerheight: 0,
                    containeroffset: 0,
                    images: {},
                    deltafrac: 1 / 8,
                    showslidercontainer: !0,
                    snapshots: [],
                    covershot_accept_string: "image/*,image/png,image/jpg,image/jpeg"
                  },
                  computed: {
                    "showslidercontainer:snapshots": function showslidercontainerSnapshots() {
                      return 0 < this.get("snapshots").length;
                    },
                    "imagewidth:imagecount,containerwidth,deltafrac": function imagewidthImagecountContainerwidthDeltafrac() {
                      return this.get("imagecount") <= 0 ? 0 : this.get("containerwidth") * (1 - this.get("deltafrac")) / this.get("imagecount");
                    },
                    "imagedelta:imagecount,containerwidth,deltafrac": function imagedeltaImagecountContainerwidthDeltafrac() {
                      return this.get("imagecount") <= 1 ? 0 : this.get("containerwidth") * this.get("deltafrac") / (this.get("imagecount") - 1);
                    },
                    "imageheight:imagewidth,imagenativewidth,imagenativeheight": function imageheightImagewidthImagenativewidthImagenativeheight() {
                      return this.get("imagenativeheight") * this.get("imagewidth") / this.get("imagenativewidth");
                    }
                  },
                  create: function create() {
                    this.set("ie10below", Info.isInternetExplorer() && Info.internetExplorerVersion() <= 10);
                    var e = this.auto_destroy(new Collection());
                    this.set("images", e), this.snapshotindex = 0, this._updateImageCount(), this.on("change:imagecount", this._updateImageCount, this), this.on("change:imagewidth change:imageheight change:imagedelta", this._recomputeImageBoxes, this), this.auto_destroy(new Timer({
                      context: this,
                      delay: 1e3,
                      fire: function fire() {
                        this.updateContainerSize();
                      }
                    }));
                  },
                  destroy: function destroy() {
                    0 < this.get("images").length && this.get("images").iterate(function (e) {
                      e.snapshotDisplay && this.parent().recorder && this.parent().recorder.removeSnapshotDisplay(e.snapshotDisplay);
                    }, this), t.destroy.call(this);
                  },
                  _updateImageCount: function _updateImageCount() {
                    for (var e = this.get("images"), t = this.get("imagecount"); e.count() < t;) {
                      var i = new Properties({
                        index: e.count()
                      });
                      this._recomputeImageBox(i), e.add(i);
                    }
                    for (; e.count() > t;) e.remove(e.getByIndex(e.count() - 1));
                  },
                  _recomputeImageBoxes: function _recomputeImageBoxes() {
                    this.get("images").iterate(function (e) {
                      this._recomputeImageBox(e);
                    }, this);
                  },
                  _recomputeImageBox: function _recomputeImageBox(e) {
                    var t, i, r, o, a, n, s, x, c, d;
                    !this.parent().recorder && this.get("snapshots").length < 1 || (i = !1, (r = this.parent().get("videometadata").ratio) || "undefined" == typeof this.parent().recorder._recorder || "undefined" != typeof this.parent().recorder._recorder._videoTrackSettings && ("undefined" != typeof (o = this.parent().recorder._recorder._videoTrackSettings).aspectRatio ? r = o.aspectRatio : "undefined" != typeof o.width && "undefined" != typeof o.height && (r = Math.round(o.width / o.height * 100) / 100)), r && (t = Math.floor(this.get("imagewidth") / r), this.get("containerheight") < t && 0 < t && (i = !0, t = Math.floor(.75 * this.get("containerheight")))), a = e.get("index"), n = t || this.get("imageheight"), s = i ? .75 * this.get("imagewidth") : this.get("imagewidth"), x = this.get("imagedelta"), c = this.get("containerheight"), d = this.get("containerwidth"), 1 < n && (1 === this.get("images").count() && (1 < r ? (s *= .45, n *= .45) : s *= .45), 2 === this.get("images").count() && r < 1 && (s *= .7), e.set("left", 1 === this.get("images").count() ? 1 + Math.round((d - s) / 2) : 1 + Math.round(a * (s + x))), e.set("top", 1 + Math.round((c - n) / 2)), e.set("width", 1 + Math.round(s)), e.set("height", 1 + Math.round(n)), e.snapshot && e.snapshotDisplay && (this.parent().recorder ? this.parent().recorder.updateSnapshotDisplay(e.snapshot, e.snapshotDisplay, e.get("left") + this.get("containeroffset"), e.get("top"), e.get("width"), e.get("height")) : RecorderSupport.updateSnapshotDisplay(e.snapshot, e.snapshotDisplay, e.get("left") + this.get("containeroffset"), e.get("top"), e.get("width"), e.get("height")))));
                  },
                  updateContainerSize: function updateContainerSize() {
                    var e,
                      t = this.activeElement().querySelector("[data-gallery-container]"),
                      i = Dom.elementOffset(t),
                      r = i;
                    this.parent().recorder ? r = Dom.elementOffset(this.parent().recorder._element) : (e = this.parent().activeElement().querySelector("video")) && (r = Dom.elementOffset(e));
                    var o = i.left - r.left,
                      a = Dom.elementDimensions(t);
                    this.set("containeroffset", o), this.set("containerheight", a.height), this.set("containerwidth", a.width);
                  },
                  _afterActivate: function _afterActivate(e) {
                    t._afterActivate.apply(this, arguments), this.updateContainerSize();
                  },
                  loadImageSnapshot: function loadImageSnapshot(e, t) {
                    e.snapshotDisplay && (this.parent().recorder ? this.parent().recorder.removeSnapshotDisplay(e.snapshotDisplay) : RecorderSupport.removeSnapshotDisplay(e.snapshotDisplay), e.snapshotDisplay = null);
                    var i = this.get("snapshots");
                    e.snapshot = i[(t % i.length + i.length) % i.length], e.snapshotDisplay = this.parent().recorder ? this.parent().recorder.createSnapshotDisplay(this.activeElement(), e.snapshot, e.get("left") + this.get("containeroffset"), e.get("top"), e.get("width"), e.get("height")) : RecorderSupport.createSnapshotDisplay(this.activeElement(), e.snapshot, e.get("left") + this.get("containeroffset"), e.get("top"), e.get("width"), e.get("height"));
                  },
                  loadSnapshots: function loadSnapshots() {
                    this.get("images").iterate(function (e) {
                      this.loadImageSnapshot(e, this.snapshotindex + e.get("index"));
                    }, this);
                  },
                  nextSnapshots: function nextSnapshots() {
                    this.snapshotindex += this.get("imagecount"), this.loadSnapshots();
                  },
                  prevSnapshots: function prevSnapshots() {
                    this.snapshotindex -= this.get("imagecount"), this.loadSnapshots();
                  },
                  functions: {
                    left: function left() {
                      this.prevSnapshots();
                    },
                    right: function right() {
                      this.nextSnapshots();
                    },
                    select: function select(e) {
                      this.trigger("image-selected", e.snapshot);
                    },
                    uploadCovershot: function uploadCovershot(e) {
                      this.trigger("upload-covershot", e[0].target);
                    }
                  }
                };
              }).registerFunctions({
                showslidercontainer: function (_showslidercontainer) {
                  function showslidercontainer(_x197) {
                    return _showslidercontainer.apply(this, arguments);
                  }
                  showslidercontainer.toString = function () {
                    return _showslidercontainer.toString();
                  };
                  return showslidercontainer;
                }(function (obj) {
                  with (obj) return showslidercontainer;
                }),
                css: function (_css9) {
                  function css(_x198) {
                    return _css9.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css9.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "left()": function (_left) {
                  function left(_x199) {
                    return _left.apply(this, arguments);
                  }
                  left.toString = function () {
                    return _left.toString();
                  };
                  return left;
                }(function (obj) {
                  with (obj) return left();
                }),
                csscommon: function (_csscommon8) {
                  function csscommon(_x200) {
                    return _csscommon8.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon8.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                images: function (_images) {
                  function images(_x201) {
                    return _images.apply(this, arguments);
                  }
                  images.toString = function () {
                    return _images.toString();
                  };
                  return images;
                }(function (obj) {
                  with (obj) return images;
                }),
                "select(image)": function selectImage(obj) {
                  with (obj) return select(image);
                },
                "{left: image.left + 'px', top: image.top + 'px', width: image.width + 'px', height: image.height + 'px'}": function leftImageLeftPxTopImageTopPxWidthImageWidthPxHeightImageHeightPx(obj) {
                  with (obj) return {
                    left: image.left + "px",
                    top: image.top + "px",
                    width: image.width + "px",
                    height: image.height + "px"
                  };
                },
                ie10below: function (_ie10below) {
                  function ie10below(_x202) {
                    return _ie10below.apply(this, arguments);
                  }
                  ie10below.toString = function () {
                    return _ie10below.toString();
                  };
                  return ie10below;
                }(function (obj) {
                  with (obj) return ie10below;
                }),
                "right()": function (_right) {
                  function right(_x203) {
                    return _right.apply(this, arguments);
                  }
                  right.toString = function () {
                    return _right.toString();
                  };
                  return right;
                }(function (obj) {
                  with (obj) return right();
                }),
                "!showslidercontainer": function (_showslidercontainer2) {
                  function showslidercontainer(_x204) {
                    return _showslidercontainer2.apply(this, arguments);
                  }
                  showslidercontainer.toString = function () {
                    return _showslidercontainer2.toString();
                  };
                  return showslidercontainer;
                }(function (obj) {
                  with (obj) return !showslidercontainer;
                }),
                covershot_accept_string: function (_covershot_accept_string2) {
                  function covershot_accept_string(_x205) {
                    return _covershot_accept_string2.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string2.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }).register("ba-videorecorder-imagegallery").attachStringTable(Assets.strings).addStrings({
                "upload-covershot": "Upload Cover"
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.Loader", ["dynamics:Dynamic", "module:Assets"], ["dynamics:Partials.ShowPartial"], function (Class, Assets, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div class="{{cssrecorder}}-loader-container">\n    <div data-selector="recorder-loader-block" class="{{cssrecorder}}-loader-loader" title="{{tooltip || \'\'}}">\n    </div>\n</div>\n<div data-selector="recorder-loader-label-container" class="{{cssrecorder}}-loader-label" ba-show="{{label}}">\n\t{{label}}\n</div>\n',
                  attrs: {
                    css: "ba-videorecorder",
                    csscommon: "ba-commoncss",
                    cssrecorder: "ba-recorder",
                    tooltip: "",
                    label: "",
                    message: "",
                    hovermessage: ""
                  }
                };
              }).registerFunctions({
                cssrecorder: function (_cssrecorder) {
                  function cssrecorder(_x206) {
                    return _cssrecorder.apply(this, arguments);
                  }
                  cssrecorder.toString = function () {
                    return _cssrecorder.toString();
                  };
                  return cssrecorder;
                }(function (obj) {
                  with (obj) return cssrecorder;
                }),
                "tooltip || ''": function (_tooltip) {
                  function tooltip(_x207) {
                    return _tooltip.apply(this, arguments);
                  }
                  tooltip.toString = function () {
                    return _tooltip.toString();
                  };
                  return tooltip;
                }(function (obj) {
                  with (obj) return tooltip || "";
                }),
                label: function (_label) {
                  function label(_x208) {
                    return _label.apply(this, arguments);
                  }
                  label.toString = function () {
                    return _label.toString();
                  };
                  return label;
                }(function (obj) {
                  with (obj) return label;
                })
              }).register("ba-videorecorder-loader").attachStringTable(Assets.strings).addStrings({});
            }), Scoped.define("module:VideoRecorder.Dynamics.Message", ["dynamics:Dynamic"], ["dynamics:Partials.ClickPartial"], function (Class, Templates, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div data-selector="recorder-message-container" class="{{css}}-message-container" ba-click="{{click()}}">\n    <div data-selector="recorder-message-block" class=\'{{css}}-message-message\'>\n        <p>\n            {{message || ""}}\n        </p>\n        <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n            <li>\n                <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                    {{link.title}}\n                </a>\n            </li>\n        </ul>\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-videorecorder",
                    csscommon: "ba-commoncss",
                    cssrecorder: "ba-recorder",
                    message: "",
                    links: null
                  },
                  functions: {
                    click: function click() {
                      this.trigger("click");
                    },
                    linkClick: function linkClick(e) {
                      this.trigger("link", e);
                    }
                  }
                };
              }).registerFunctions({
                css: function (_css10) {
                  function css(_x209) {
                    return _css10.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css10.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click2) {
                  function click(_x210) {
                    return _click2.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click2.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                'message || ""': function (_message3) {
                  function message(_x211) {
                    return _message3.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message3.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links) {
                  function links(_x212) {
                    return _links.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }).register("ba-videorecorder-message");
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.State", ["base:States.State", "base:Events.ListenMixin", "base:Objs"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, [t, {
                dynamics: [],
                _start: function _start() {
                  this.dyn = this.host.dynamic, i.iter(i.extend({
                    message: !1,
                    chooser: !1,
                    topmessage: !1,
                    controlbar: !1,
                    loader: !1,
                    imagegallery: !1,
                    helperframe: !1,
                    player: !1
                  }, i.objectify(this.dynamics)), function (e, t) {
                    this.dyn.set(t + "_active", e);
                  }, this), this.dyn.set("playertopmessage", ""), this.dyn.set("message_links", null), this.dyn._accessing_camera = !1, this._started();
                },
                _started: function _started() {},
                record: function record() {
                  this.dyn.set("autorecord", !0);
                },
                stop: function stop() {
                  this.dyn.scopes.player.execute("stop");
                },
                play: function play() {
                  this.dyn.scopes.player.execute("play");
                },
                pause: function pause() {
                  this.dyn.scopes.player.execute("pause");
                },
                rerecord: function rerecord() {},
                selectRecord: function selectRecord() {},
                selectRecordScreen: function selectRecordScreen(e) {},
                selectUpload: function selectUpload(e) {},
                uploadCovershot: function uploadCovershot(e) {},
                checkOrientation: function checkOrientation(e, t) {
                  if (t = t || "FatalError", this.dyn.get("media-orientation") && ("portrait" === this.dyn.get("media-orientation") && !e || "landscape" === this.dyn.get("media-orientation") && e)) {
                    this.dyn.set("recordvisible", !1);
                    var i = this.dyn.string("supported-mode").replace("%s", e ? "landscape" : "portrait");
                    return i += " " + this.dyn.string("re-choose-action"), this.next(t, {
                      message: i,
                      retry: "Chooser"
                    }), !1;
                  }
                  return !0;
                }
              }]);
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.FatalError", ["module:VideoRecorder.Dynamics.RecorderStates.State", "browser:Info", "base:Timers.Timer"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, {
                dynamics: ["message"],
                _locals: ["message", "retry"],
                _started: function _started() {
                  this.dyn.set("message", this._message || this.dyn.string("recorder-error")), this.dyn.set("shortMessage", this.dyn.get("message").length < 30), this.listenOn(this.dyn, "message-click", function () {
                    this._retry && this.next(this._retry);
                  });
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.ChooseAlternativeDevice", ["module:VideoRecorder.Dynamics.RecorderStates.State", "browser:Info"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, {
                dynamics: ["message"],
                _locals: ["message", "retry"],
                _started: function _started() {
                  this.dyn.set("controlbar_active", !0), this.dyn.set("message", this._message || this.dyn.string("recorder-error")), this.dyn.set("shortMessage", this.dyn.get("message").length < 30), this.listenOn(this.dyn, "message-click", function () {
                    this.next("Chooser");
                  }, this), "undefined" != typeof this.dyn.recorder._recorder && this.listenOn(this.dyn.recorder._recorder, "rebound", function () {
                    t.isChromiumBased() && this.next("CameraHasAccess");
                  }, this);
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.Initial", ["module:VideoRecorder.Dynamics.RecorderStates.State", "browser:Dom"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, {
                _started: function _started() {
                  this.dyn.set("is_initial_state", !0), this.dyn.set("verified", !1), this.dyn.set("playbacksource", null), this.dyn.set("playbackposter", null), this.dyn.set("player_active", !1), this.dyn._videoFileName = null, this.dyn._videoFile = null, this.dyn._videoFilePlaybackable = !1, this.dyn.__firstFrameSnapshot = null, this.dyn._initializeUploader(), this.dyn.get("recordermode") ? this.dyn.get("autorecord") || this.dyn.get("skipinitial") ? this.dyn.get("onlyaudio") ? t.userInteraction(function () {
                    this.eventualNext("RequiredSoftwareCheck");
                  }, this) : this.eventualNext("RequiredSoftwareCheck") : this.next("Chooser") : this.dyn.get("video") ? this.next("Player") : (console.warn("recordermode:false requires an existing video to be present and provided."), this.dyn.set("recordermode", !0));
                },
                _end: function _end() {
                  this.dyn.set("is_initial_state", !1);
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.Player", ["module:VideoRecorder.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                rerecord: function rerecord() {
                  this.dyn.trigger("rerecord"), this.dyn.set("recordermode", !0), this.next("Initial");
                },
                _started: function _started() {
                  this.dyn.set("player_active", !0), this.dyn.get("allowtexttrackupload") && this.dyn.set("uploadtexttracksvisible", !0);
                },
                _end: function _end() {
                  this.dyn.set("player_active", !1), this.dyn.set("uploadtexttracksvisible", !1);
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.Chooser", ["module:VideoRecorder.Dynamics.RecorderStates.State", "base:Strings", "base:Objs", "browser:Info", "module:PopupHelper", "media:Player.Support"], function (t, s, i, x, r, c, o) {
              return t.extend({
                scoped: o
              }, {
                dynamics: ["chooser"],
                _started: function _started() {
                  this.listenOn(this.dyn, "change:orientation change:currentorientation", function () {
                    var e = this.dyn.get("orientation"),
                      t = this.dyn.get("currentorientation"),
                      i = e && e !== t;
                    i && this.dyn.set("message", this.dyn.string("orientation-" + e + "-required")), this.dyn.set("message_active", i), this.dyn.set("chooser_active", !i);
                  }, this, {
                    initcall: !0
                  });
                },
                _popup: function _popup() {
                  var e = this.auto_destroy(new r()),
                    t = this.auto_destroy(new this.dyn.cls({
                      element: e.containerInner,
                      attrs: i.extend(this.dyn.cloneAttrs(), this.dyn.popupAttrs())
                    }));
                  this._delegatedRecorder = t, this.dyn.delegateEvents(null, t), e.on("hide", function () {
                    this._delegatedRecorder = null, t.destroy(), e.destroy();
                  }, this), e.show(), t.activate();
                },
                record: function record() {
                  this.dyn.get("popup") ? this._popup() : (this.dyn.set("autorecord", !0), this.selectRecord());
                },
                selectRecordScreen: function selectRecordScreen(e) {
                  this.dyn.get("popup") ? this._popup() : (this.dyn.set("record_media", e ? "multistream" : "screen"), this.next("RequiredSoftwareCheck"));
                },
                selectRecord: function selectRecord() {
                  this.dyn.get("popup") ? this._popup() : (this.dyn.set("record_media", "camera"), this.next("RequiredSoftwareCheck"));
                },
                selectUpload: function selectUpload(t) {
                  if (this.dyn.get("popup")) this._popup();else {
                    if (!(x.isMobile() && x.isAndroid() && x.isCordova())) {
                      if (this.dyn.get("allowedextensions")) {
                        var i = (t.files[0].name || "").toLowerCase(),
                          r = !1;
                        if (this.dyn.get("allowedextensions").forEach(function (e) {
                          s.ends_with(i, "." + e.toLowerCase()) && (r = !0);
                        }, this), !r) return void this.next("FatalError", {
                          message: this.dyn.string("unsupported_video_type").replace("%s", this.dyn.get("allowedextensions").join(" / ")),
                          retry: "Chooser"
                        });
                      }
                      if (this.dyn.get("filesizelimit") && t.files && 0 < t.files.length && t.files[0].size && t.files[0].size > this.dyn.get("filesizelimit")) {
                        var o = "KB",
                          a = Math.round(t.files[0].size / 1e3),
                          n = Math.round(this.dyn.get("filesizelimit") / 1e3);
                        return 999 < a && (o = "MB", a = Math.round(a / 1e3), n = Math.round(n / 1e3)), void this.next("FatalError", {
                          message: this.dyn.string("video_file_too_large").replace("%s", a + o + " / " + n + o),
                          retry: "Chooser"
                        });
                      }
                    }
                    try {
                      c.videoFileInfo(t.files[0]).success(function (e) {
                        "undefined" != typeof e.width && "undefined" != typeof e.height && !this.checkOrientation(1 < e.width / e.height) || (e.duration && this.dyn.get("enforce-duration") && (this.dyn.get("timeminlimit") && e.duration < this.dyn.get("timeminlimit") || this.dyn.get("timelimit") && e.duration > this.dyn.get("timelimit")) ? this.next("FatalError", {
                          message: this.dyn.string("upload-error-duration"),
                          retry: "Chooser"
                        }) : e.width && this.dyn.get("minuploadingwidth") && this.dyn.get("minuploadingwidth") > e.width || e.width && this.dyn.get("maxuploadingwidth") && this.dyn.get("maxuploadingwidth") < e.width || e.height && this.dyn.get("minuploadingheight") && this.dyn.get("minuploadingheight") > e.height || e.height && this.dyn.get("maxuploadingheight") && this.dyn.get("maxuploadingheight") < e.height ? this.next("FatalError", {
                          message: this.dyn.string("resolution-constraint-error"),
                          retry: "Chooser"
                        }) : (this.dyn._videoFilePlaybackable = !0, this.dyn.set("duration", e.duration), this._uploadFile(t)));
                      }, this).error(function (e) {
                        e.code === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED && (1 == this.dyn.get("allowtrim") && (this.dyn.set("allowtrim", !1), this.dyn.set("was_allowtrim", !0)), 1 == this.dyn.get("localplayback") && (this.dyn.set("localplayback", !1), this.dyn.set("was_localplayback", !0)), 1 == this.dyn.get("snapshotfromuploader") && (this.dyn.set("snapshotfromuploader", !1), this.dyn.set("was_snapshotfromuploader", !0)), this.dyn.set("media_src_not_supported", !0)), this._uploadFile(t);
                      }, this);
                    } catch (e) {
                      this._uploadFile(t);
                    }
                  }
                },
                _uploadFile: function _uploadFile(t) {
                  if (!this.__blocked) {
                    this.__blocked = !0, this.dyn.set("creation-type", x.isMobile() ? "mobile" : "upload");
                    try {
                      this.dyn._videoFileName = t.files[0].name, this.dyn._videoFile = t.files[0];
                    } catch (e) {}
                    this.dyn._prepareRecording().success(function () {
                      this.dyn.trigger("upload_selected", t), this.dyn._uploadVideoFile(t), this._setValueToEmpty(t), this.__blocked = !1, this.next("CovershotSelection");
                    }, this).error(function (e) {
                      this._setValueToEmpty(t), this.__blocked = !1, this.next("FatalError", {
                        message: e,
                        retry: "Chooser"
                      });
                    }, this);
                  }
                },
                _setValueToEmpty: function _setValueToEmpty(t) {
                  try {
                    t.value = "";
                  } catch (e) {}
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.CreateUploadCovershot", ["module:VideoRecorder.Dynamics.RecorderStates.State", "media:Recorder.Support", "base:Objs", "base:Timers.Timer", "browser:Dom", "browser:Events", "browser:Info", "base:Async"], function (e, n, s, x, c, d, t, l, i) {
              return e.extend({
                scoped: i
              }, {
                dynamics: ["loader", "message"],
                _started: function _started() {
                  this.dyn.set("cancancel", !0), this.dyn.set("loader_active", !0), this.dyn.set("topmessage", this.dyn.string("please-wait")), this.dyn.set("message", this.dyn.string("prepare-covershot")), this.dyn.get("cancancel") && this.dyn.get("allowcancel") && this.dyn.set("controlbar_active", !0);
                  try {
                    if (this.dyn.set("player_active", !1), !this.dyn._videoFile) return console.warn("Could not find source file to be able start player"), this.next("Trimming");
                    this.dyn.set("playbacksource", (window.URL || window.webkitURL).createObjectURL(this.dyn._videoFile));
                    var r = document.createElement("video"),
                      i = 0,
                      o = 0,
                      a = 1;
                    r.src = this.dyn.get("playbacksource"), r.setAttribute("preload", "metadata"), r.volume = 0, r.muted = !0, l.eventually(function () {
                      if (r.readyState < 1) return console.warn("Could not be able load video metadata"), this.next("Trimming");
                    }, this, 5e3);
                    var e = this.auto_destroy(new d());
                    e.on(r, "loadedmetadata", function (e) {
                      if ((o = r.duration) === Infinity || !o) return console.warn("Could not generate video covershots from uploaded file"), this.next("Trimming");
                      if (a = this._calculateSeekPeriod(o), !(0 < r.videoWidth && 0 < r.videoHeight)) return console.warn("Could not find video dimensions information to be able create covershot"), this.next("Trimming");
                      var t = r.videoWidth > r.videoHeight ? 80 : 35;
                      this.dyn.set("videometadata", s.tree_merge(this.dyn.get("videometadata"), {
                        height: r.videoHeight,
                        width: r.videoWidth,
                        ratio: +(r.videoWidth / r.videoHeight).toFixed(2),
                        thumbnails: {
                          width: t,
                          height: Math.floor(t / r.videoWidth * r.videoHeight)
                        }
                      })), this.__videoSeekTimer = new x({
                        context: this,
                        fire: function fire() {
                          r.volume < .1 || r.muted ? r.currentTime = i : r.volume = 0, i += a;
                        },
                        destroy_on_stop: !0,
                        delay: 500,
                        start: !0
                      });
                    }, this), this.dyn.get("selectfirstcovershotonskip") && !this.dyn.get("picksnapshots") ? e.on(r, "canplay", function (e) {
                      r.currentTime = 0;
                      var t = n.createSnapshot(this.dyn.get("snapshottype"), r, !0);
                      t && (this.dyn.get("snapshots")[0] = t, c.triggerDomEvent(r, "ended"));
                    }, this) : e.on(r, "seeked", function (e) {
                      var t,
                        i = n.createSnapshot(this.dyn.get("snapshottype"), r, !0);
                      i && (this.dyn.get("createthumbnails") && this.dyn.get("videometadata").thumbnails.images.push({
                        time: r.currentTime,
                        snap: i
                      }), this.dyn.get("snapshots").length < this.dyn.get("snapshotmax") ? this.dyn.get("snapshots").push(i) : (t = Math.floor(Math.random() * this.dyn.get("snapshotmax")), n.removeSnapshot(this.dyn.get("snapshots")[t]), this.dyn.get("snapshots")[t] = i)), r.currentTime + a >= o && (r.currentTime = r.currentTime + a, r.ended || c.triggerDomEvent(r, "ended"));
                    }, this), e.on(r, "ended", function (e) {
                      this.__videoSeekTimer.stop(), "function" == typeof r.remove ? r.remove() : r.style.display = "none", this.next("CovershotSelection");
                    }, this);
                  } catch (t) {
                    console.warn(t), this.next("Trimming");
                  }
                },
                stop: function stop() {
                  this.dyn.set("loader_active", !1), this.dyn.set("loaderlabel", ""), this.dyn.set("topmessage", "");
                },
                _calculateSeekPeriod: function _calculateSeekPeriod(e) {
                  return e < 15 ? 1 : e < 40 ? 3 : e < 100 ? 4 : Math.floor(e / 100) + 4;
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.RequiredSoftwareCheck", ["module:VideoRecorder.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.dyn.set("settingsvisible", !1), this.dyn.set("recordvisible", !1), this.dyn.set("rerecordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("skipvisible", !1), this.dyn.set("uploadcovershotvisible", !1), this.dyn.set("controlbarlabel", ""), this.dyn.set("loaderlabel", ""), this.listenOn(this.dyn, "error", function (e) {
                    this.next("FatalError", {
                      message: this.dyn.string("attach-error"),
                      retry: "Initial"
                    });
                  }, this), this.dyn._attachRecorder(), this.dyn && (this.dyn.on("message-link-click", function (e) {
                    e.execute(), this.next("RequiredSoftwareWait");
                  }, this), this.dyn._softwareDependencies().error(function (e) {
                    this.dyn.set("message_links", e), this.dyn.set("loader_active", !1), this.dyn.set("message_active", !0), this.dyn.set("message", this.dyn.string("software-required"));
                  }, this).success(function () {
                    this.next("CameraAccess");
                  }, this));
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.RequiredSoftwareWait", ["module:VideoRecorder.Dynamics.RecorderStates.State", "base:Promise", "browser:Dom"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, {
                dynamics: ["message"],
                _started: function _started() {
                  this.dyn.set("settingsvisible", !1), this.dyn.set("recordvisible", !1), this.dyn.set("rerecordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("skipvisible", !1), this.dyn.set("uploadcovershotvisible", !1), this.dyn.set("controlbarlabel", ""), this.dyn.set("loaderlabel", ""), this.dyn.set("message", this.dyn.string("software-waiting")), t.resilience(function () {
                    return i.isTabHidden() ? t.error("Not ready") : this.dyn._softwareDependencies();
                  }, this, 120, [], 1e3).success(function () {
                    this.next("CameraAccess");
                  }, this).error(function () {
                    this.next("RequiredSoftwareCheck");
                  }, this), this.dyn.on("message-click", function () {
                    this.next("RequiredSoftwareCheck");
                  }, this);
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.CameraAccess", ["module:VideoRecorder.Dynamics.RecorderStates.State", "base:Objs", "base:Types", "base:Timers.Timer", "base:Collections.Collection"], function (e, t, i, r, o, a) {
              return e.extend({
                scoped: a
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.dyn.set("settingsvisible", !0), this.dyn.set("recordvisible", !0), this.dyn.set("rerecordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("skipvisible", !1), this.dyn.set("uploadcovershotvisible", !1), this.dyn.set("controlbarlabel", ""), this.dyn.set("loaderlabel", ""), this.listenOn(this.dyn, "bound", function () {
                    if (this.dyn.set("creation-type", "webrtc"), this.dyn.get("onlyaudio") || "screen" === this.dyn.get("record_media") || "multistream" === this.dyn.get("record_media")) return this.dyn.get("allowmultistreams") && "multistream" === this.dyn.get("record_media") && this.dyn.recorder.enumerateDevices().success(function (e) {
                      this.set("cameras", new o(t.values(e.video))), this.trigger(i.is_empty(e.video) ? "no_camera" : "has_camera"), this._add_new_stream();
                    }, this.dyn), void this.next("CameraHasAccess");
                    var e = this.auto_destroy(new r({
                      start: !0,
                      delay: 100,
                      context: this,
                      fire: function fire() {
                        .01 <= this.dyn.blankLevel() && .01 <= this.dyn.deltaCoefficient() && (e.stop(), this.next("CameraHasAccess"));
                      }
                    }));
                  }, this), this.listenOn(this.dyn, "error", function (e) {
                    this.next("FatalError", {
                      message: this.dyn.string("attach-error"),
                      retry: "Initial"
                    });
                  }, this), this.listenOn(this.dyn, "access_forbidden", function (e) {
                    var t,
                      i = this.dyn.string("access-forbidden");
                    "string" != typeof e.name || "function" != typeof this.dyn.recorder.errorHandler || "object" == typeof (t = this.dyn.recorder.errorHandler(e.name)) && (t.userLevel ? i = this.dyn.string(t.key) : console.warn(t.message + ". Please inform us!")), this.next("FatalError", {
                      message: i,
                      retry: "Initial"
                    });
                  }, this), this.dyn._bindMedia();
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.CameraHasAccess", ["module:VideoRecorder.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["topmessage", "controlbar"],
                _started: function _started() {
                  this.checkOrientation(this.dyn.isPortrait(), "ChooseAlternativeDevice") && (this.dyn.trigger("ready_to_record"), this._preparePromise = null, 0 < this.dyn.get("countdown") && this.dyn.recorder && this.dyn.recorder.recordDelay(this.dyn.get("uploadoptions")) > 1e3 * this.dyn.get("countdown") && (this._preparePromise = this.dyn._prepareRecording()), this.dyn.get("pausable") && this.dyn.set("pausable", this.dyn.recorder.canPause()), this.dyn.set("hovermessage", ""), this.dyn.set("topmessage", ""), this.dyn.set("settingsvisible", !0), this.dyn.set("recordvisible", !0), this.dyn.set("rerecordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("skipvisible", !1), this.dyn.set("uploadcovershotvisible", !1), this.dyn.set("controlbarlabel", ""), this.dyn.set("isrecorderready", !0), this.dyn.get("autorecord") && this.next("RecordPrepare", {
                    preparePromise: this._preparePromise
                  }));
                },
                record: function record() {
                  this.dyn.get("autorecord") || this.dyn.get("audio-test-mandatory") && !this.dyn.get("microphonehealthy") && !this._preparePromise || this.next("RecordPrepare", {
                    preparePromise: this._preparePromise
                  });
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.RecordPrepare", ["module:VideoRecorder.Dynamics.RecorderStates.State", "base:Timers.Timer", "base:Time"], function (e, t, c, i) {
              return e.extend({
                scoped: i
              }, {
                dynamics: ["loader"],
                _locals: ["preparePromise"],
                _started: function _started() {
                  this.dyn.set("message", ""), this.dyn.set("loaderlabel", "");
                  var i = !1;
                  this.dyn._accessing_camera = !0, this._preparePromise = this._preparePromise || this.dyn._prepareRecording();
                  var r,
                    o,
                    a,
                    n,
                    s,
                    e = this.dyn.get("countdown") ? 1e3 * this.dyn.get("countdown") : 0,
                    x = this.dyn.recorder.recordDelay(this.dyn.get("uploadoptions")) || 0;
                  e ? (r = 1e3, o = 0, a = c.now(), n = a + Math.max(x, e), e < x ? (o = Math.min(500, x - e), r = (x - o) / e * 1e3) : this.dyn.set("loaderlabel", this.dyn.get("countdown")), s = new t({
                    context: this,
                    delay: 50,
                    fire: function fire() {
                      var e = c.now(),
                        t = Math.max(0, n - e);
                      o + a < e && (this.dyn.set("loaderlabel", "" + Math.ceil((t - o) / r)), this.dyn.trigger("countdown", Math.round((t - o) / r * 1e3))), n <= e && (this.dyn.set("loaderlabel", ""), s.stop()), t <= x && !i && (i = !0, this._startRecording());
                    }
                  }), this.auto_destroy(s)) : this._startRecording();
                },
                record: function record() {
                  this._startRecording();
                },
                _startRecording: function _startRecording() {
                  this._preparePromise.success(function () {
                    this.dyn._startRecording().success(function () {
                      this.next("Recording");
                    }, this).error(function (e) {
                      this.next("FatalError", {
                        message: e,
                        retry: "RequiredSoftwareCheck"
                      });
                    }, this);
                  }, this).error(function (e) {
                    this.next("FatalError", {
                      message: e,
                      retry: "RequiredSoftwareCheck"
                    });
                  }, this);
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.Recording", ["module:VideoRecorder.Dynamics.RecorderStates.State", "base:Timers.Timer", "base:Time", "base:TimeFormat", "base:Async", "browser:Info"], function (e, t, o, a, r, i, n) {
              return e.extend({
                scoped: n
              }, {
                dynamics: ["topmessage", "controlbar"],
                _started: function _started() {
                  this.dyn.set("hovermessage", ""), this.dyn.set("topmessage", ""), this.dyn._accessing_camera = !0, this.dyn.trigger("recording"), this.dyn.set("settingsvisible", !1), this.dyn.set("rerecordvisible", !1), this.dyn.set("recordvisible", !1), this.dyn.set("stopvisible", !0), this.dyn.set("skipvisible", !1), this.dyn.set("uploadcovershotvisible", !1), this._startTime = o.now(), this._stopping = !1, this.__timerDelay = 10, this._timer = this.auto_destroy(new t({
                    immediate: !0,
                    delay: this.__timerDelay,
                    context: this,
                    fire: this._timerFire
                  })), this._framerateWarning = !1;
                },
                _timerFire: function _timerFire() {
                  var e,
                    t,
                    i,
                    r = this.dyn.get("timelimit");
                  this.dyn.__paused || (e = o.now() - this.dyn.__pauseDelta, t = Math.max(0, r ? this._startTime + 1e3 * r - e : e - this._startTime), this.dyn.trigger("recording_progress", e - this._startTime, !!this.dyn.__paused), this.dyn.set("controlbarlabel", this.dyn.get("display-timer") ? a.format(a.ELAPSED_MINUTES_SECONDS, t) : ""), this.dyn.get("timeminlimit") && this.dyn.set("mintimeindicator", (o.now() - this._startTime) / 1e3 <= this.dyn.get("timeminlimit")), r && this._startTime + 1e3 * r <= e && (this._timer.stop(), this.stop()), this.dyn.get("framerate-warning") && this.dyn.averageFrameRate() && (i = this.dyn.averageFrameRate() < this.dyn.get("framerate-warning")) !== this._framerateWarning && ((this._framerateWarning = i) ? this.dyn.set("hovermessage", this.dyn.string("framerate-warning")) : this.dyn.set("hovermessage", "")));
                },
                stop: function stop() {
                  var e = this.dyn.get("timeminlimit");
                  if (e) {
                    var t = (o.now() - (this._startTime + this.dyn.__pauseDelta)) / 1e3;
                    if (t < e) {
                      var i = this.dyn.get("timelimit");
                      if (!i || t < i) return;
                    }
                  }
                  this._stopping || (this.dyn.set("loader_active", !0), this.dyn.set("controlbar_active", !1), this.dyn.set("topmessage_active", !1), this.dyn.set("message_active", !0), this.dyn.set("message", ""), this._stopping = !0, r.eventually(function () {
                    this.dyn._stopRecording().success(function () {
                      this._hasStopped(), this.next("CovershotSelection");
                    }, this).error(function (e) {
                      this.next("FatalError", {
                        message: e,
                        retry: "RequiredSoftwareCheck"
                      });
                    }, this);
                  }, this));
                },
                _hasStopped: function _hasStopped() {
                  this.dyn.set("duration", (o.now() - (this._startTime + this.dyn.__pauseDelta)) / 1e3), 0 < this.dyn.get("snapshots").length && this.dyn._showBackgroundSnapshot(), this.dyn._unbindMedia(), this.dyn.trigger("recording_stopped");
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.Trimming", ["module:VideoRecorder.Dynamics.RecorderStates.State", "base:Types"], function (e, i, t) {
              return e.extend({
                scoped: t
              }, {
                _started: function _started() {
                  !this.dyn.get("allowtrim") || this.dyn.get("duration") < this.dyn.get("timeminlimit") ? this.next("Uploading") : (this.dyn.get("trimoverlay") ? this.dyn._getFirstFrameSnapshot().success(function (e) {
                    this.showTrimmingOverlay(e);
                  }, this).error(function () {
                    this.showTrimmingOverlay(this.dyn.__backgroundSnapshot);
                  }, this) : (this.dyn.set("message_active", !0), this.dyn.set("message", this.dyn.string("wait-for-trim")), this.listenOnce(this.dyn, "manual-trim", function (e, t) {
                    i.isNumber(e) && 0 < e && this.dyn.set("starttime", e), i.isNumber(t) && t <= this.get("duration") && this.dyn.set("endtime", t), this.dyn.trigger("video-trimmed", this.dyn.get("starttime"), this.dyn.get("endtime"), this.dyn.get("duration")), this.next("Uploading");
                  })), this.dyn.trigger("ready-to-trim"));
                },
                showTrimmingOverlay: function showTrimmingOverlay(e) {
                  this._playerAttrs = this.dyn.get("playerattrs"), this.dyn.set("playerattrs", {
                    poster: e,
                    source: this.dyn._videoFile || this.dyn.recorder.localPlaybackSource(),
                    trimmingmode: !0,
                    hidecontrolbar: !0
                  }), this.dyn.set("playertopmessage", this.dyn.string("trim-prompt")), this.dyn.set("player_active", !0), this.listenOnce(this.dyn.scopes.player, "playing", function () {
                    this.dyn.scopes.player.set("skipinitial", !0), this.dyn.set("playertopmessage", this.dyn.string("trim-video"));
                  }), this.listenOnce(this.dyn.scopes.player, "video-trimmed skip", function (e) {
                    e && e.start && this.dyn.set("starttime", e.start), e && e.end && this.dyn.set("endtime", e.end), this.dyn.trigger("video-trimmed", this.dyn.get("starttime"), this.dyn.get("endtime"), this.dyn.get("duration")), this.hideTrimmingOverlay(), this.next("Uploading");
                  }, this);
                },
                hideTrimmingOverlay: function hideTrimmingOverlay() {
                  this.dyn.set("trimmingmode", !1), this.dyn.set("playerattrs", this._playerAttrs);
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.CovershotSelection", ["module:VideoRecorder.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                _started: function _started() {
                  !this.dyn.get("picksnapshots") && !this.dyn.get("custom-covershots") || this.dyn.get("onlyaudio") ? !this.dyn.get("snapshots") && this.dyn.get("snapshotfromuploader") || this.dyn.get("snapshotfrommobilecapture") && this.dyn.get("recordviafilecapture") ? this.dyn.get("selectfirstcovershotonskip") && (this.dyn.set("snapshotmax", 1), this.dyn.set("snapshots", []), this.next("CreateUploadCovershot")) : this._next(!0) : this.dyn.get("pickcovershotframe") ? this.dyn.recorder && this.dyn.recorder.supportsLocalPlayback() || this.dyn.get("snapshotfromuploader") && this.dyn._videoFile && this.dyn._videoFilePlaybackable ? this.next("CovershotSelectionFromPlayer") : this._next(!0) : this.dyn.get("snapshots") && 0 < this.dyn.get("snapshots").length ? this.next("CovershotSelectionFromGallery") : this.dyn.get("snapshotfromuploader") || this.dyn.get("snapshotfrommobilecapture") && this.dyn.get("recordviafilecapture") ? this.next("CreateUploadCovershot") : this._next(!0);
                },
                rerecord: function rerecord() {
                  this.dyn._hideBackgroundSnapshot(), this.dyn._detachRecorder(), this.dyn.trigger("rerecord"), this.dyn.set("recordermode", !0), this.next("Initial");
                },
                _next: function _next(e) {
                  e && this.dyn.get("selectfirstcovershotonskip") && this.dyn.get("snapshots") && this.dyn.get("snapshots")[0] && this.dyn._uploadCovershot(this.dyn.get("snapshots")[0]), 3 < this.dyn.get("videometadata").thumbnails.images.length && this.dyn.get("createthumbnails") ? this.next("UploadThumbnails") : this.next("Trimming");
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.CovershotSelectionFromGallery", ["module:VideoRecorder.Dynamics.RecorderStates.CovershotSelection"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["imagegallery", "topmessage", "controlbar"],
                _started: function _started() {
                  var e;
                  this.dyn.set("settingsvisible", !1), this.dyn.set("recordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("skipvisible", !this.dyn.get("picksnapshotmandatory")), this.dyn.set("controlbarlabel", ""), this.dyn.set("rerecordvisible", this.dyn.get("early-rerecord")), this.dyn.set("uploadcovershotvisible", this.dyn.get("custom-covershots")), this.dyn.set("hovermessage", ""), this.dyn.set("topmessage", this.dyn.string("pick-covershot")), this.dyn.set("isrecorderready", !1), 0 < this.dyn.get("snapshots").length && ((e = this.dyn.scope(">[tagname='ba-videorecorder-imagegallery']").materialize(!0)).loadSnapshots(), e.updateContainerSize()), this.listenOn(this.dyn, "invoke-skip", function () {
                    this._next(!0);
                  }, this), this.listenOn(this.dyn, "select-image", function (e) {
                    this.dyn._uploadCovershot(e), this._next(!1);
                  }, this);
                },
                uploadCovershot: function uploadCovershot(e) {
                  "undefined" != typeof e.files && e.files[0] && (e = e.files[0]), this.dyn._uploadCovershotFile(e), this._next(!1);
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.CovershotSelectionFromPlayer", ["module:VideoRecorder.Dynamics.RecorderStates.CovershotSelection"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                _started: function _started() {
                  this.dyn._getFirstFrameSnapshot().success(function (e) {
                    this.startFrameSelection(e);
                  }, this).error(function () {
                    this.startFrameSelection(this.dyn.__backgroundSnapshot);
                  }, this);
                },
                startFrameSelection: function startFrameSelection(e) {
                  this._playerattrs = this.dyn.get("playerattrs"), this.dyn.set("playerattrs", {
                    poster: e,
                    source: this.dyn._videoFile || this.dyn.recorder.localPlaybackSource(),
                    skipinitial: !0
                  }), this.dyn.set("frameselectionmode", !0), this.dyn.set("playertopmessage", this.dyn.string("pick-covershot-frame")), this.dyn.set("player_active", !0), this.listenOn(this.dyn.scopes.player, "image-selected", function (e) {
                    this.dyn._uploadCovershot(e), this._next(!1);
                  }, this);
                },
                endFrameSelection: function endFrameSelection() {
                  this.dyn.set("frameselectionmode", !1), this.dyn.set("playerattrs", this._playerattrs);
                },
                _end: function _end() {
                  this.endFrameSelection();
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.UploadThumbnails", ["module:VideoRecorder.Dynamics.RecorderStates.State", "base:Objs", "base:Promise", "base:Time", "base:TimeFormat", "media:WebRTC.Support", "browser:Events"], function (e, t, d, i, v, r, l, o) {
              return e.extend({
                scoped: o
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.dyn.set("loader_active", !0), this.dyn.set("loadlabel", "Thumbnails"), this.dyn.set("message", this.dyn.string("prepare-thumbnails")), this.dyn.set("hovermessage", ""), this.dyn.set("topmessage", ""), this._drawIntoCanvas(this.dyn.get("videometadata").thumbnails).success(function (e) {
                    this.dyn._uploadThumbnails(r.dataURItoBlob(e.toDataURL("image/jpg"))), this.dyn._uploadThumbnailTracks(new Blob(this._vttDescripitions, {
                      type: "text/vtt"
                    })), this.next("Trimming");
                  }, this).error(function (e) {
                    console.warn(e), this.next("Trimming");
                  }, this);
                },
                _drawIntoCanvas: function _drawIntoCanvas(e) {
                  var t = d.create(),
                    i = e.width,
                    r = e.height,
                    o = e.images.length,
                    a = 10 < e.images.length ? Math.ceil(o / 10) : 1,
                    n = document.createElement("canvas");
                  n.width = 1 < a ? 10 * i : i * o, n.height = a * r, this._vttDescripitions = [], this._vttDescripitions.push("WEBVTT \n\n");
                  var s,
                    x = n.getContext("2d");
                  try {
                    "undefined" != typeof e.images[0] && (this._imageEvent = this.auto_destroy(new l()), (s = s || new Image()).width = i, s.height = r, s.src = (window.URL || window.webkitURL).createObjectURL(e.images[0].snap), this._imageEvent.on(s, "load", function () {
                      this._recursivelyDrawImage(n, e, x, i, r, s, 0, t);
                    }, this), this._imageEvent.on(s, "error", function (e) {
                      throw "Error with loading thumbnail image. ".err;
                    }, this));
                  } catch (c) {
                    t.asyncError(c);
                  }
                  return t;
                },
                _recursivelyDrawImage: function _recursivelyDrawImage(e, t, i, r, o, a, n, s, x, c) {
                  if (x = x || 0, c = c || 0, n = n || 0, i.drawImage(a, x * r, c * o, r, o), 0 < n && n % 10 == 0 ? (c++, x = 0) : 0 !== n && x++, n++, "undefined" != typeof t.images[n] && t.images.length >= n) {
                    var d,
                      l,
                      u,
                      h,
                      p = n - 1,
                      b = n + 1,
                      m = Math.round((t.images[n].time - t.images[p].time) / 2),
                      g = t.images[p].time + m;
                    t.images[b + 1] || (m = 0), l = t.images[n].time + m, u = 0 === g ? "00:00:00" : v.format("HH:MM:ss", 1e3 * g), h = 0 === l ? "00:00:00" : v.format("HH:MM:ss", 1e3 * l), "undefined" != typeof t.images[b] && this._vttDescripitions.push(u + ".000 --\x3e " + h + ".000\n" + this.dyn.get("uploadoptions").thumbnail.url + "#xywh=" + x * r + "," + c * o + "," + r + "," + o + "\n\n"), (d = new Image()).width = r, d.height = o, d.src = (window.URL || window.webkitURL).createObjectURL(t.images[n].snap), this._imageEvent.on(d, "load", function () {
                      this._recursivelyDrawImage(e, t, i, r, o, d, n, s, x, c);
                    }, this), this._imageEvent.on(d, "error", function (e) {
                      throw "Error with loading thumbnail image. Error: ".err;
                    }, this);
                  } else {
                    if (!(t.images.length <= n)) throw "Could not draw all images";
                    s.asyncSuccess(e);
                  }
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.Uploading", ["module:VideoRecorder.Dynamics.RecorderStates.State", "base:Time", "base:Async", "base:Objs"], function (e, t, i, r, o) {
              return e.extend({
                scoped: o
              }, {
                dynamics: ["loader", "message"],
                _started: function _started() {
                  this.dyn.set("cancancel", !0), this.dyn.set("skipinitial", this.dyn.get("skipinitial") || this.dyn.get("skipinitialonrerecord")), this.dyn.set("settingsvisible", !1), this.dyn.set("recordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("loadlabel", ""), this.dyn.set("controlbarlabel", ""), this.dyn.set("isrecorderready", !1), this.dyn.trigger("uploading"), this.dyn.set("rerecordvisible", this.dyn.get("early-rerecord")), (this.dyn.get("early-rerecord") || this.dyn.get("cancancel") && this.dyn.get("allowcancel")) && this.dyn.set("controlbar_active", !0), this.dyn.set("hovermessage", ""), this.dyn.set("topmessage", ""), 1 != this.dyn.get("media_src_not_supported") || 1 != this.dyn.get("was_allowtrim") && 1 != this.dyn.get("was_localplayback") && 1 != this.dyn.get("was_snapshotfromuploader") ? this.dyn.set("uploading-message", this.dyn.string("uploading")) : this.dyn.set("uploading-message", this.dyn.string("uploading-src-error")), this.dyn.set("message", this.dyn.get("uploading-message")), this.dyn.set("playertopmessage", this.dyn.get("message"));
                  var e = this.dyn._dataUploader;
                  this.listenOn(e, "success", function () {
                    i.eventually(function () {
                      this.destroyed() || (this._finished(), this.next("Verifying"));
                    }, this);
                  }), this.listenOn(e, "error", function (e) {
                    var i = this.dyn.string("uploading-failed");
                    try {
                      e.forEach(function (e) {
                        for (var t in e) this.dyn.string("upload-error-" + t) && (i = this.dyn.string("upload-error-" + t));
                      }, this);
                    } catch (t) {}
                    this.dyn.set("player_active", !1), this.next("FatalError", {
                      message: i,
                      retry: this.dyn.recorderAttached() ? "Uploading" : "Initial"
                    });
                  }), this.listenOn(e, "progress", function (e, t) {
                    var i;
                    this.dyn.trigger("upload_progress", e, t), 0 !== t && 0 < t && 0 <= e && (i = Math.min(100, Math.round(e / t * 100)), isNaN(i) || (this.dyn.set("message", this.dyn.get("uploading-message") + ": " + i + "%"), this.dyn.set("playertopmessage", this.dyn.get("message"))));
                  }), this.dyn.get("localplayback") && (this.dyn.recorder && this.dyn.recorder.supportsLocalPlayback() || this.dyn._videoFilePlaybackable) && (this.dyn.recorder && this.dyn.recorder.supportsLocalPlayback() ? this.dyn.set("playbacksource", this.dyn.recorder.localPlaybackSource()) : this.dyn.set("playbacksource", (window.URL || window.webkitURL).createObjectURL(this.dyn._videoFile)), this.dyn.__lastCovershotUpload && this.dyn.recorder && this.dyn.set("playbackposter", this.dyn.recorder.snapshotToLocalPoster(this.dyn.__lastCovershotUpload)), this.dyn.set("loader_active", !1), this.dyn.set("message_active", !1), this.dyn._hideBackgroundSnapshot(), this.dyn.set("player_active", !0)), this.dyn.set("start-upload-time", t.now()), e.reset(), e.upload();
                },
                rerecord: function rerecord() {
                  this.dyn._hideBackgroundSnapshot(), this.dyn._detachRecorder(), this.dyn.trigger("rerecord"), this.dyn.set("recordermode", !0), this.next("Initial");
                },
                _finished: function _finished() {
                  this.dyn.set("cancancel", !1), this.dyn.trigger("uploaded"), this.dyn.set("end-upload-time", t.now());
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.RecorderStates.Verifying", ["module:VideoRecorder.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["loader", "message"],
                _started: function _started() {
                  this.dyn.set("loadlabel", ""), this.dyn.trigger("verifying"), this.dyn.set("message", this.dyn.string("verifying") + "..."), this.dyn.set("playertopmessage", this.dyn.get("message")), this.dyn.get("localplayback") && (this.dyn.recorder && this.dyn.recorder.supportsLocalPlayback() || this.dyn._videoFilePlaybackable) ? (this.dyn.set("loader_active", !1), this.dyn.set("message_active", !1)) : (this.dyn.set("rerecordvisible", this.dyn.get("early-rerecord")), this.dyn.get("early-rerecord") && this.dyn.set("controlbar_active", !0)), this.dyn._verifyRecording().success(function () {
                    this.dyn.trigger("verified"), this.dyn._hideBackgroundSnapshot(), this.dyn._detachRecorder(), this.dyn.get("recordings") && this.dyn.set("recordings", this.dyn.get("recordings") - 1), this.dyn.set("message", ""), this.dyn.set("playertopmessage", ""), this.dyn.set("verified", !0), this.next("Player");
                  }, this).error(function () {
                    this.dyn.set("player_active", !1), this.next("FatalError", {
                      message: this.dyn.string("verifying-failed"),
                      retry: this.dyn.recorderAttached() ? "Verifying" : "Initial"
                    });
                  }, this);
                },
                rerecord: function rerecord() {
                  this.dyn._hideBackgroundSnapshot(), this.dyn._detachRecorder(), this.dyn.trigger("rerecord"), this.dyn.set("recordermode", !0), this.next("Initial");
                }
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.Topmessage", ["dynamics:Dynamic"], function (Class, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: "\n<div class=\"{{css}}-topmessage-container\">\n    <div class='{{css}}-topmessage-background'>\n    </div>\n    <div data-selector=\"recorder-topmessage-block\" class='{{css}}-topmessage-message'>\n        {{topmessage}}\n    </div>\n</div>\n",
                  attrs: {
                    css: "ba-videorecorder",
                    csscommon: "ba-commoncss",
                    cssrecorder: "ba-recorder",
                    topmessage: ""
                  }
                };
              }).registerFunctions({
                css: function (_css11) {
                  function css(_x213) {
                    return _css11.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css11.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                topmessage: function (_topmessage3) {
                  function topmessage(_x214) {
                    return _topmessage3.apply(this, arguments);
                  }
                  topmessage.toString = function () {
                    return _topmessage3.toString();
                  };
                  return topmessage;
                }(function (obj) {
                  with (obj) return topmessage;
                })
              }).register("ba-videorecorder-topmessage");
            }), Scoped.define("module:VideoRecorder.Dynamics.Recorder", ["dynamics:Dynamic", "module:Assets", "module:StylesMixin", "browser:Info", "browser:Dom", "browser:Events", "browser:Upload.MultiUploader", "browser:Upload.FileUploader", "media:Recorder.VideoRecorderWrapper", "media:Recorder.Support", "media:WebRTC.Support", "base:Types", "base:Objs", "base:Strings", "base:Time", "base:Timers", "base:States.Host", "base:Classes.ClassRegistry", "base:Collections.Collection", "base:Promise", "module:VideoRecorder.Dynamics.RecorderStates.Initial", "module:VideoRecorder.Dynamics.RecorderStates"], ["module:VideoRecorder.Dynamics.Imagegallery", "module:VideoRecorder.Dynamics.Loader", "module:VideoRecorder.Dynamics.Controlbar", "module:VideoRecorder.Dynamics.Message", "module:VideoRecorder.Dynamics.Topmessage", "module:VideoRecorder.Dynamics.Chooser", "module:VideoRecorder.Dynamics.Faceoutline", "module:Common.Dynamics.Helperframe", "dynamics:Partials.ShowPartial", "dynamics:Partials.IfPartial", "dynamics:Partials.EventPartial", "dynamics:Partials.OnPartial", "dynamics:Partials.DataPartial", "dynamics:Partials.AttrsPartial", "dynamics:Partials.StylesPartial", "dynamics:Partials.TemplatePartial", "dynamics:Partials.HotkeyPartial"], function (Class, Assets, StylesMixin, Info, Dom, DomEvents, MultiUploader, FileUploader, VideoRecorderWrapper, RecorderSupport, WebRTCSupport, Types, Objs, Strings, Time, Timers, Host, ClassRegistry, Collection, Promise, InitialState, RecorderStates, scoped) {
              return Class.extend({
                scoped: scoped
              }, [StylesMixin, function (t) {
                return {
                  template: '\n<div data-selector="video-recorder-container" ba-show="{{!player_active}}"\n     class="{{css}}-container {{csstheme}} {{css}}-size-{{csssize}}\n     {{iecss}}-{{ie8 ? \'ie8\' : \'noie8\'}} {{css}}-{{ fullscreened ? \'fullscreen\' : \'normal\' }}-view\n     {{cssrecorder}}-{{ firefox ? \'firefox\' : \'common\'}}-browser\n     {{cssrecorder}}-{{themecolor}}-color" ba-styles="{{containerSizingStyles}}"\n>\n\n    <video tabindex="-1"\n\t\t   data-selector="recorder-status" class="{{css}}-video {{css}}-{{hasrecorder ? \'hasrecorder\' : \'norecorder\'}}"\n\t\t   data-video="video" playsinline disablePictureInPicture\n\t></video>\n\t<ba-videorecorder-faceoutline class="{{css}}-overlay" ba-if="{{faceoutline && hasrecorder && isrecorderready}}"></ba-videorecorder-faceoutline>\n    <div data-selector="recorder-overlay" class=\'{{cssrecorder}}-overlay\' ba-show="{{!hideoverlay}}" data-overlay="overlay">\n\t\t<ba-{{dynloader}}\n\t\t\tba-css="{{cssloader || css}}"\n\t\t\tba-cssrecorder="{{cssrecorder || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t\tba-template="{{tmplloader}}"\n\t\t\tba-show="{{loader_active}}"\n\t\t\tba-tooltip="{{loadertooltip}}"\n\t\t\tba-hovermessage="{{=hovermessage}}"\n\t\t\tba-label="{{loaderlabel}}"\n\t\t></ba-{{dynloader}}>\n\n\t\t<ba-{{dynmessage}}\n\t\t\tba-css="{{cssmessage || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t\tba-cssrecorder="{{cssrecorder || css}}"\n\t\t\tba-template="{{tmplmessage}}"\n\t\t\tba-show="{{message_active}}"\n\t\t\tba-message="{{message}}"\n\t\t\tba-links="{{message_links}}"\n\t\t\tba-event:click="message_click"\n\t\t\tba-event:link="message_link_click"\n\t\t></ba-{{dynmessage}}>\n\n\t\t<ba-{{dyntopmessage}}\n\t\t\tba-css="{{csstopmessage || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t\tba-cssrecorder="{{cssrecorder || css}}"\n\t\t\tba-template="{{tmpltopmessage}}"\n\t\t\tba-show="{{topmessage_active && (topmessage || hovermessage)}}"\n\t\t\tba-topmessage="{{hovermessage || topmessage}}"\n\t\t></ba-{{dyntopmessage}}>\n\n\t\t<ba-{{dynchooser}}\n\t\t\tba-if="{{chooser_active && !is_initial_state}}"\n\t\t\tba-onlyaudio="{{onlyaudio}}"\n\t\t\tba-facecamera="{{facecamera}}"\n\t\t\tba-recordviafilecapture="{{recordviafilecapture}}"\n\t\t\tba-css="{{csschooser || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t\tba-cssrecorder="{{cssrecorder || css}}"\n\t\t\tba-template="{{tmplchooser}}"\n\t\t\tba-allowscreen="{{allowscreen}}"\n\t\t\tba-allowmultistreams="{{allowmultistreams}}"\n\t\t\tba-parentpopup="{{popup}}"\n\t\t\tba-allowrecord="{{allowrecord}}"\n\t\t\tba-allowupload="{{allowupload}}"\n\t\t\tba-allowcustomupload="{{allowcustomupload}}"\n\t\t\tba-allowedextensions="{{allowedextensions}}"\n\t\t\tba-primaryrecord="{{primaryrecord}}"\n\t\t\tba-initialmessages="{{initialmessages}}"\n\t\t\tba-timelimit="{{timelimit}}"\n\t\t\tba-event:record="record_video"\n\t\t\tba-event:record-screen="record_screen"\n\t\t\tba-event:upload="video_file_selected"\n\t\t></ba-{{dynchooser}}>\n\n\t\t<ba-{{dynimagegallery}}\n\t\t\tba-if="{{imagegallery_active}}"\n\t\t\tba-css="{{cssimagegallery || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t\tba-cssrecorder="{{cssrecorder || css}}"\n\t\t\tba-template="{{tmplimagegallery}}"\n\t\t\tba-imagecount="{{gallerysnapshots}}"\n\t\t\tba-snapshots="{{=snapshots}}"\n\t\t\tba-imagenativewidth="{{nativeRecordingWidth}}"\n\t\t\tba-imagenativeheight="{{nativeRecordingHeight}}"\n\t\t\tba-event:image-selected="select_image"\n\t\t\tba-event:upload-covershot="upload_covershot"\n\t\t></ba-{{dynimagegallery}}>\n\n\t\t<ba-{{dyncontrolbar}}\n\t\t\tba-css="{{csscontrolbar || css}}"\n\t\t\tba-cssrecorder="{{cssrecorder || css}}"\n\t\t\tba-csstheme="{{csstheme || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t\tba-template="{{tmplcontrolbar}}"\n\t\t\tba-show="{{controlbar_active}}"\n\t\t\tba-cameras="{{cameras}}"\n\t\t\tba-microphones="{{microphones}}"\n\t\t\tba-noaudio="{{noaudio}}"\n\t\t\tba-novideo="{{onlyaudio}}"\n\t\t\tba-allowscreen="{{record_media===\'screen\' || record_media===\'multistream\'}}"\n\t\t\tba-selectedcamera="{{selectedcamera || 0}}"\n\t\t\tba-selectedmicrophone="{{selectedmicrophone || 0}}"\n\t\t\tba-addstreamdeviceid="{{addstreamdeviceid || null}}"\n\t\t\tba-showaddstreambutton="{{showaddstreambutton}}"\n\t\t\tba-camerahealthy="{{camerahealthy}}"\n\t\t\tba-microphonehealthy="{{microphonehealthy}}"\n\t\t\tba-hovermessage="{{=hovermessage}}"\n\t\t\tba-settingsvisible="{{settingsvisible}}"\n\t\t\tba-recordvisible="{{recordvisible}}"\n\t\t\tba-cancelvisible="{{allowcancel && cancancel}}"\n\t\t\tba-uploadcovershotvisible="{{uploadcovershotvisible}}"\n\t\t\tba-rerecordvisible="{{rerecordvisible}}"\n\t\t\tba-stopvisible="{{stopvisible}}"\n\t\t\tba-skipvisible="{{skipvisible}}"\n\t\t\tba-controlbarlabel="{{controlbarlabel}}"\n\t\t\tba-mintimeindicator="{{mintimeindicator}}"\n\t\t\tba-timeminlimit="{{timeminlimit}}"\n\t\t\tba-resumevisible="{{resumevisible}}"\n\t\t\tba-pausable="{{pausable}}"\n\t\t\tba-firefox="{{firefox}}"\n\t\t\tba-event:select-camera="select_camera"\n\t\t\tba-event:select-microphone="select_microphone"\n\t\t\tba-event:invoke-record="record"\n\t\t\tba-event:invoke-rerecord="rerecord"\n\t\t\tba-event:invoke-stop="stop"\n\t\t\tba-event:invoke-skip="invoke_skip"\n\t\t\tba-event:invoke-pause="pause_recorder"\n\t\t\tba-event:invoke-resume="resume"\n\t\t\tba-event:invoke-cancel="cancel"\n\t\t\tba-event:upload-covershot="upload_covershot"\n\t\t\tba-event:toggle-face-mode="toggle_face_mode"\n\t\t\tba-event:add-new-stream="add_new_stream"\n\t\t></ba-{{dyncontrolbar}}>\n\n\t\t<ba-{{dynhelperframe}}\n\t\t\tba-if="{{helperframe_active || framevisible}}"\n\t\t\tba-template="{{tmphelperframe}}"\n\t\t\tba-framereversable= "{{multistreamreversable}}"\n\t\t\tba-framedragable="{{multistreamdraggable}}"\n\t\t\tba-frameresizeable="{{multistreamresizeable}}"\n\t\t\tba-framepositionx="{{addstreampositionx}}"\n\t\t\tba-framepositiony="{{addstreampositiony}}"\n\t\t\tba-frameproportional="{{addstreamproportional}}"\n\t\t\tba-flipframe="{{flip-camera}}"\n\t\t></ba-{{dynhelperframe}}>\n\t</div>\n</div>\n\n\n<div data-selector="recorder-player" ba-if="{{player_active}}" ba-styles="{{containerSizingStyles}}">\n\t<span ba-show="{{ie8}}">&nbsp;</span>\n\t<ba-{{dynvideoplayer}}\n\t\tba-theme="{{theme || \'default\'}}"\n\t\tba-themecolor="{{themecolor}}"\n\t\tba-cssrecorder="{{cssrecorder || css}}"\n\t\tba-source="{{localplayback ? playbacksource : \'\'}}"\n\t\tba-poster="{{localplayback ? playbackposter : \'\'}}"\n\t\tba-hideoninactivity="{{false}}"\n\t\tba-showsettingsmenu="{{showplayersettingsmenu}}"\n\t\tba-onlyaudio="{{onlyaudio}}"\n\t\tba-attrs="{{playerattrs}}"\n\t\tba-data:id="player"\n\t\tba-width="100%"\n\t\tba-height="100%"\n\t\tba-totalduration="{{duration}}"\n\t\tba-rerecordable="{{rerecordable && (recordings === null || recordings > 0)}}"\n\t\tba-submittable="{{manualsubmit && verified}}"\n\t\tba-reloadonplay="{{true}}"\n\t\tba-autoplay="{{autoplay}}"\n\t\tba-nofullscreen="{{nofullscreen}}"\n\t\tba-topmessage="{{playertopmessage}}"\n\t\tba-allowtexttrackupload="{{allowtexttrackupload}}"\n\t\tba-uploadtexttracksvisible="{{uploadtexttracksvisible}}"\n\t\tba-snapshottype="{{snapshottype}}"\n\t\tba-tracktags="{{tracktags}}"\n\t\tba-tracktagsstyled="{{tracktagsstyled}}"\n\t\tba-trackcuetext="{{trackcuetext}}"\n\t\tba-acceptedtracktexts="{{acceptedtracktexts}}"\n\t\tba-sharevideo="{{sharevideo}}"\n\t\tba-videofitstrategy="{{videofitstrategy}}"\n\t\tba-posterfitstrategy="{{posterfitstrategy}}"\n\t\tba-event:loaded="ready_to_play"\n\t\tba-event:rerecord="rerecord"\n\t\tba-event:playing="playing"\n\t\tba-event:paused="paused"\n\t\tba-event:ended="ended"\n\t\tba-event:submit="manual_submit"\n\t\tba-event:upload-text-tracks="upload_text_tracks"\n\t\tba-tracksshowselection="{{tracksshowselection}}"\n\t\tba-trackselectorhovered="{{trackselectorhovered}}"\n\t\tba-uploadlocales="{{uploadlocales}}"\n\t\tba-frameselectionmode="{{frameselectionmode}}"\n\t\tba-timeminlimit="{{timeminlimit}}"\n\t\tba-event:selected_label_value="selected_label_value"\n\t\tba-event:move_to_option="move_to_option"\n\t>\n\t</ba-{{dynvideoplayer}}>\n</div>\n',
                  attrs: {
                    css: "ba-videorecorder",
                    csscommon: "ba-commoncss",
                    cssrecorder: "ba-recorder",
                    iecss: "ba-videorecorder",
                    cssimagegallery: "",
                    cssloader: "",
                    csscontrolbar: "",
                    cssmessage: "",
                    csstopmessage: "",
                    csschooser: "",
                    csshelperframe: "",
                    width: "",
                    height: "",
                    gallerysnapshots: 3,
                    "popup-width": "",
                    "popup-height": "",
                    theme: "",
                    csstheme: "",
                    themecolor: "",
                    dynimagegallery: "videorecorder-imagegallery",
                    dynloader: "videorecorder-loader",
                    dyncontrolbar: "videorecorder-controlbar",
                    dynmessage: "videorecorder-message",
                    dyntopmessage: "videorecorder-topmessage",
                    dynchooser: "videorecorder-chooser",
                    dynvideoplayer: "videoplayer",
                    dynhelperframe: "helperframe",
                    tmplimagegallery: "",
                    tmplloader: "",
                    tmplcontrolbar: "",
                    tmplmessage: "",
                    tmpltopmessage: "",
                    tmplchooser: "",
                    tmplhelperframe: "",
                    autorecord: !1,
                    autoplay: !1,
                    allowrecord: !0,
                    allowupload: !0,
                    minheight: 240,
                    minwidth: 320,
                    maxheight: null,
                    maxwidth: null,
                    allowcustomupload: !0,
                    "manual-upload": !1,
                    camerafacefront: !1,
                    fittodimensions: !1,
                    resizemode: null,
                    createthumbnails: !1,
                    primaryrecord: !0,
                    allowscreen: !1,
                    initialmessages: [],
                    screenrecordmandatory: !1,
                    nofullscreen: !1,
                    recordingwidth: undefined,
                    recordingheight: undefined,
                    minuploadingwidth: undefined,
                    maxuploadingwidth: undefined,
                    minuploadingheight: undefined,
                    maxuploadingheight: undefined,
                    countdown: 3,
                    snapshotmax: 15,
                    "framerate-warning": null,
                    framerate: null,
                    audiobitrate: null,
                    videobitrate: null,
                    snapshottype: "jpg",
                    picksnapshots: !0,
                    playbacksource: "",
                    screen: {},
                    playbackposter: "",
                    recordermode: !0,
                    skipinitial: !1,
                    skipinitialonrerecord: !1,
                    timelimit: null,
                    timeminlimit: null,
                    webrtcstreaming: !1,
                    webrtconmobile: !1,
                    webrtcstreamingifnecessary: !0,
                    "microphone-volume": 1,
                    "flip-camera": !1,
                    flipscreen: !1,
                    "early-rerecord": !1,
                    "custom-covershots": !1,
                    selectfirstcovershotonskip: !1,
                    picksnapshotmandatory: !1,
                    "media-orientation": null,
                    manualsubmit: !1,
                    allowedextensions: null,
                    filesizelimit: null,
                    faceoutline: !1,
                    "display-timer": !0,
                    pausable: !1,
                    sharevideo: [],
                    videofitstrategy: "pad",
                    posterfitstrategy: "crop",
                    simulate: !1,
                    onlyaudio: !1,
                    noaudio: !1,
                    "enforce-duration": null,
                    localplayback: !1,
                    uploadoptions: {},
                    playerattrs: {},
                    shortMessage: !0,
                    "cpu-friendly": !1,
                    rerecordable: !0,
                    allowcancel: !1,
                    recordings: null,
                    ready: !0,
                    orientation: !1,
                    popup: !1,
                    "popup-stretch": !1,
                    "audio-test-mandatory": !1,
                    snapshotfromuploader: !1,
                    snapshotfrommobilecapture: !1,
                    allowmultistreams: !1,
                    showaddstreambutton: !1,
                    multistreamreversable: !0,
                    multistreamdraggable: !0,
                    multistreamresizeable: !1,
                    addstreamproportional: !0,
                    addstreampositionx: 5,
                    addstreampositiony: 5,
                    addstreampositionwidth: 120,
                    addstreampositionheight: null,
                    addstreamminwidth: 120,
                    addstreamminheight: null,
                    addstreamdeviceid: null,
                    showsettingsmenu: !0,
                    showplayersettingsmenu: !0,
                    allowtexttrackupload: !1,
                    framevisible: !1,
                    uploadlocales: [{
                      lang: "en",
                      label: "English"
                    }],
                    tracktags: [],
                    hassubtitles: !1,
                    videometadata: {},
                    optionsinitialstate: {},
                    playerfallbackwidth: 320,
                    playerfallbackheight: 240,
                    pickcovershotframe: !1,
                    allowtrim: !1,
                    trimoverlay: !0
                  },
                  computed: {
                    "nativeRecordingWidth:recordingwidth,record_media": function nativeRecordingWidthRecordingwidthRecord_media() {
                      return this.get("recordingwidth") || ("screen" !== this.get("record_media") && "multistream" !== this.get("record_media") ? 640 : window.innerWidth || document.body.clientWidth);
                    },
                    "nativeRecordingHeight:recordingheight,record_media": function nativeRecordingHeightRecordingheightRecord_media() {
                      return this.get("recordingheight") || ("screen" !== this.get("record_media") && "multistream" !== this.get("record_media") ? 480 : window.innerHeight || document.body.clientHeight);
                    },
                    "containerSizingStyles:width,height,aspectratio,nativeRecordingWidth,nativeRecordingHeight,activated": function containerSizingStylesWidthHeightAspectratioNativeRecordingWidthNativeRecordingHeightActivated(e, t, i, r, o, a) {
                      var n,
                        s,
                        x = {
                          minWidth: this.get("minwidth") + "px",
                          minHeight: this.get("minheight") + "px",
                          aspectRatio: i || r + "/" + o
                        };
                      return e && (x.width = "string" == typeof e && "%" === e[e.length - 1] ? e : e + "px"), t && (x.height = "string" == typeof t && "%" === t[t.length - 1] ? t : t + "px"), e || t ? !Info.isInternetExplorer() && !Info.isSafari() || e && t || (e ? t || ("string" == typeof e && "%" === e[e.length - 1] ? a && (n = e.slice(0, -1) / 100, new ResizeObserver(function (e) {
                        this.set("height", Math.floor(e[0].target.offsetWidth * n / (i || r / o)));
                      }.bind(this)).observe(this.activeElement().parentElement), x.height = Math.floor(this.activeElement().parentElement.offsetWidth * n / (i || r / o)) + "px") : x.height = Math.floor(e / (i || r / o)) + "px") : "string" == typeof t && "%" === t[t.length - 1] ? a && (s = t.slice(0, -1) / 100, new ResizeObserver(function (e) {
                        this.set("width", Math.floor(e[0].target.offsetHeight * s * (i || r / o)));
                      }.bind(this)).observe(this.activeElement().parentElement), x.width = Math.floor(this.activeElement().parentElement.offsetHeight * s * (i || r / o)) + "px") : x.width = Math.floor(t * (i || r / o)) + "px") : (x.width = r + "px", x.height = o + "px"), this.get("maxwidth") && (x.maxWidth = this.get("maxwidth") + "px"), this.get("maxheight") && (x.maxHeight = this.get("maxheight") + "px"), this.activeElement() && this._applyStyles(this.activeElement(), x, this.__lastContainerSizingStyles), this.__lastContainerSizingStyles = x;
                    },
                    "canswitchcamera:recordviafilecapture": function canswitchcameraRecordviafilecapture() {
                      return !this.get("recordviafilecapture") && Info.isMobile();
                    }
                  },
                  scopes: {
                    player: ">[id='player']"
                  },
                  types: {
                    allowscreen: "boolean",
                    rerecordable: "boolean",
                    ready: "boolean",
                    fittodimensions: "boolean",
                    autorecord: "boolean",
                    autoplay: "boolean",
                    allowrecord: "boolean",
                    allowupload: "boolean",
                    allowcustomupload: "boolean",
                    primaryrecord: "boolean",
                    recordermode: "boolean",
                    nofullscreen: "boolean",
                    skipinitialonrerecord: "boolean",
                    picksnapshots: "boolean",
                    localplayback: "boolean",
                    camerafacefront: "boolean",
                    noaudio: "boolean",
                    skipinitial: "boolean",
                    popup: "boolean",
                    "popup-stretch": "boolean",
                    "popup-width": "int",
                    "popup-height": "int",
                    "enforce-duration": "bool",
                    webrtcstreaming: "boolean",
                    themecolor: "string",
                    webrtconmobile: "boolean",
                    "manual-upload": "boolean",
                    minwidth: "int",
                    minheight: "int",
                    maxwidth: "int",
                    maxheight: "int",
                    webrtcstreamingifnecessary: "boolean",
                    "microphone-volume": "float",
                    audiobitrate: "int",
                    videobitrate: "int",
                    minuploadingwidth: "int",
                    maxuploadingwidth: "int",
                    minuploadingheight: "int",
                    maxuploadingheight: "int",
                    "framerate-warning": "int",
                    snapshotfromuploader: "boolean",
                    snapshotfrommobilecapture: "boolean",
                    "flip-camera": "boolean",
                    flipscreen: "boolean",
                    faceoutline: "boolean",
                    "early-rerecord": "boolean",
                    "custom-covershots": "boolean",
                    picksnapshotmandatory: "boolean",
                    selectfirstcovershotonskip: "boolean",
                    manualsubmit: "boolean",
                    simulate: "boolean",
                    allowedextensions: "array",
                    onlyaudio: "boolean",
                    "cpu-friendly": "boolean",
                    allowcancel: "boolean",
                    "display-timer": "boolean",
                    "audio-test-mandatory": "boolean",
                    allowtexttrackupload: "boolean",
                    uploadlocales: "array",
                    allowmultistreams: "boolean",
                    pausable: "boolean",
                    sharevideo: "array",
                    multistreamreversable: "boolean",
                    multistreamdraggable: "boolean",
                    multistreamresizeable: "boolean",
                    addstreamproportional: "boolean",
                    addstreampositionx: "int",
                    addstreampositiony: "int",
                    addstreampositionwidth: "int",
                    addstreampositionheight: "int",
                    addstreamminwidth: "int",
                    addstreamminheight: "int",
                    showsettingsmenu: "boolean",
                    showplayersettingsmenu: "boolean",
                    initialmessages: "array",
                    screenrecordmandatory: "boolean",
                    "media-orientation": "string",
                    mandatoryresolutions: "array",
                    pickcovershotframe: "boolean",
                    allowtrim: "boolean",
                    trimoverlay: "boolean"
                  },
                  extendables: ["states"],
                  remove_on_destroy: !0,
                  events: {
                    "change:camerahealthy": function changeCamerahealthy(e) {
                      this.trigger("camerahealth", e);
                    },
                    "change:microphonehealthy": function changeMicrophonehealthy(e) {
                      this.trigger("microphonehealth", e);
                    },
                    "change:webrtconmobile": function changeWebrtconmobile() {
                      this.set("recordviafilecapture", Info.isMobile() && (!this.get("webrtconmobile") || !VideoRecorderWrapper.anySupport(this._videoRecorderWrapperOptions())));
                    },
                    "change:recordviafilecapture": function changeRecordviafilecapture() {
                      this.get("recordviafilecapture") && (this.set("skipinitial", !1), this.set("skipinitialonrerecord", !1), this.set("autorecord", !1), this._screenRecorderVerifier(!1));
                    }
                  },
                  create: function create() {
                    this._validateParameters(), WebRTCSupport.globals(), this.set("optionsinitialstate", {
                      autorecord: this.get("autorecord"),
                      skipinitial: this.get("skipinitial")
                    }), this.get("theme") && this.set("theme", this.get("theme").toLowerCase()), this.get("theme") in Assets.recorderthemes && Objs.iter(Assets.recorderthemes[this.get("theme")], function (e, t) {
                      this.isArgumentAttr(t) || this.set(t, e);
                    }, this), this.get("themecolor") || this.set("themecolor", "default"), this.get("pausable") && this.set("resumevisible", !1), this.set("ie8", Info.isInternetExplorer() && Info.internetExplorerVersion() < 9), this.set("hideoverlay", !1), this.set("firefox", Info.isFirefox()), this.set("canswitchcamera", !1), this.set("recordviafilecapture", Info.isMobile() && (!this.get("webrtconmobile") || !VideoRecorderWrapper.anySupport(this._videoRecorderWrapperOptions()))), this.get("recordviafilecapture") && (this.set("skipinitial", !1), this.set("skipinitialonrerecord", !1), this.set("autorecord", !1), this._screenRecorderVerifier(!1)), this.__attachRequested = !1, this.__activated = !1, this._bound = !1, this.__recording = !1, this.__error = null, this.host = new Host({
                      stateRegistry: new ClassRegistry(this.cls.recorderStates())
                    }), (this.host.dynamic = this).host.initialize(InitialState), this._timer = new Timers.Timer({
                      context: this,
                      fire: this._timerFire,
                      delay: 250,
                      start: !0
                    }), this.activeElement().style.setProperty("display", "inline-block"), this._applyStyles(this.activeElement(), this.get("containerSizingStyles")), this.__cameraResponsive = !0, this.__cameraSignal = !0, this._initSettings(), this.get("onlyaudio") && (this.set("allowupload", !1), this.set("orientation", !1), this.set("picksnapshots", this.get("custom-covershots"))), Info.isMobile() || this.set("orientation", !1), this.set("currentorientation", window.innerHeight > window.innerWidth ? "portrait" : "landscape"), this._screenRecorderVerifier();
                  },
                  state: function state() {
                    return this.host.state();
                  },
                  recorderAttached: function recorderAttached() {
                    return !!this.recorder;
                  },
                  videoError: function videoError() {
                    return this.__error;
                  },
                  _error: function _error(e, t) {
                    this.__error = {
                      error_type: e,
                      error_code: t
                    }, this.trigger("error:" + e, t), this.trigger("error", e, t);
                  },
                  _clearError: function _clearError() {
                    this.__error = null;
                  },
                  _detachRecorder: function _detachRecorder() {
                    this.recorder && this.recorder.weakDestroy(), this.recorder = null, this.set("hasrecorder", !1), this.set("autorecord", this.get("optionsinitialstate").autorecord);
                  },
                  _validateParameters: function _validateParameters() {
                    var e = ["crop", "pad", "original"];
                    e.includes(this.get("videofitstrategy")) || console.warn("Invalid value for videofitstrategy: " + this.get("videofitstrategy") + "\nPossible values are: " + e.slice(0, -1).join(", ") + " or " + e.slice(-1)), e.includes(this.get("posterfitstrategy")) || console.warn("Invalid value for posterfitstrategy: " + this.get("posterfitstrategy") + "\nPossible values are: " + e.slice(0, -1).join(", ") + " or " + e.slice(-1)), (this.get("stretch") || this.get("stretchwidth") || this.get("stretchheight")) && console.warn("Stretch parameters were removed, please set width and/or height to 100% instead.");
                  },
                  _videoRecorderWrapperOptions: function _videoRecorderWrapperOptions() {
                    var e = null,
                      t = this.get("resizemode");
                    return (this.get("allowscreen") && "screen" === this.get("record_media") || this.get("allowmultistreams") && "multistream" === this.get("record_media")) && (e = this.get("screen"), t = t || "none"), this.get("allowrecord") || !this.get("autorecord") && !this.get("skipinitial") || (this.get("allowscreen") || this.get("allowmultistreams")) && (this.set("record_media", this.get("allowscreen") ? "screen" : "multistream"), e = {}), {
                      simulate: this.get("simulate"),
                      recordVideo: !this.get("onlyaudio"),
                      screenResizeMode: this.get("screenresizemode"),
                      recordAudio: !this.get("noaudio"),
                      recordingWidth: this.get("nativeRecordingWidth"),
                      recordingHeight: this.get("nativeRecordingHeight"),
                      audioBitrate: "number" == typeof this.get("audiobitrate") ? this.get("audiobitrate") : undefined,
                      videoBitrate: "number" == typeof this.get("videobitrate") ? this.get("videobitrate") : undefined,
                      webrtcStreaming: !!this.get("webrtcstreaming"),
                      webrtcStreamingIfNecessary: !!this.get("webrtcstreamingifnecessary"),
                      localPlaybackRequested: this.get("localplayback"),
                      screen: e,
                      resizeMode: t,
                      framerate: this.get("framerate"),
                      flip: this.get("flip-camera"),
                      flipscreen: this.get("flipscreen"),
                      fittodimensions: this.get("fittodimensions"),
                      cpuFriendly: this.get("cpu-friendly")
                    };
                  },
                  _attachRecorder: function _attachRecorder() {
                    var e;
                    this.recorderAttached() || (this.__activated ? ("screen" === this.get("record_media") && "undefined" != typeof navigator.mediaDevices && "undefined" == typeof navigator.mediaDevices.getDisplayMedia && this.set("webrtcstreaming", !0), this.set("hasrecorder", !0), this.__attachRequested = !1, e = this.activeElement().querySelector("[data-video='video']"), this._clearError(), this.recorder = VideoRecorderWrapper.create(Objs.extend({
                      element: e
                    }, this._videoRecorderWrapperOptions())), this.recorder ? (this.trigger("attached"), this.set("pausable", this.get("pausable") && this.recorder.canPause())) : this._error("attach")) : this.__attachRequested = !0);
                  },
                  _softwareDependencies: function _softwareDependencies() {
                    return this.recorderAttached() && this.recorder ? this.recorder.softwareDependencies() : Promise.error("No recorder attached.");
                  },
                  _bindMedia: function _bindMedia() {
                    !this._bound && this.recorderAttached() && this.recorder && this.recorder.ready.success(function () {
                      this.recorder && (this.recorder.on("require_display", function () {
                        this.set("hideoverlay", !0);
                      }, this), this.recorder.bindMedia().error(function (e) {
                        this.trigger("access_forbidden", e), this.set("hideoverlay", !1), this.off("require_display", null, this), this._error("bind", e);
                      }, this).success(function () {
                        if (this.recorder) {
                          for (this.trigger("access_granted"), this.recorder.setVolumeGain(this.get("microphone-volume")), this.set("hideoverlay", !1), this.off("require_display", null, this), this.recorder.once("mainvideostreamended", function () {
                            this.trigger("mainvideostreamended");
                          }, this), this.recorder.enumerateDevices().success(function (e) {
                            this.recorder && (this.recorder.once("currentdevicesdetected", function (e) {
                              this.set("selectedcamera", e.video), this.set("selectedmicrophone", e.audio);
                            }, this), this.set("cameras", new Collection(Objs.values(e.video))), this.set("microphones", new Collection(Objs.values(e.audio))), this.trigger(Types.is_empty(e.video) ? "no_camera" : "has_camera"), this.trigger(Types.is_empty(e.audio) ? "no_microphone" : "has_microphone"), this.set("showaddstreambutton", this._showAddStreamButton()));
                          }, this), this.get("noaudio") || this.recorder.testSoundLevel(!0), this.set("devicetesting", !0); 0 < this.get("snapshots").length;) {
                            var e = this.get("snapshots").unshift();
                            this.recorder.removeSnapshot(e);
                          }
                          this._bound = !0, this.trigger("bound");
                        }
                      }, this));
                    }, this);
                  },
                  isWebrtcStreaming: function isWebrtcStreaming() {
                    return this.recorder && this.recorder.isWebrtcStreaming();
                  },
                  _showAddStreamButton: function _showAddStreamButton() {
                    return this.get("allowmultistreams") && (1 < this.get("cameras").count() || 1 <= this.get("cameras").count() && ("screen" !== this.get("record_media") || "multistream" !== this.get("record_media")));
                  },
                  _initSettings: function _initSettings() {
                    this.set("snapshots", []), this.thumbnails = [], this.__lastCovershotUpload = undefined, this.__pauseDelta = 0, this.set("starttime", undefined), this.set("endtime", undefined), this.set("duration", 0), this.set("videometadata", {
                      height: null,
                      width: null,
                      ratio: null,
                      thumbnails: {
                        mainimage: null,
                        images: []
                      }
                    });
                  },
                  _initializeUploader: function _initializeUploader() {
                    this._dataUploader && this._dataUploader.weakDestroy(), this._dataUploader = new MultiUploader();
                  },
                  _unbindMedia: function _unbindMedia() {
                    this._bound && (this.recorder.unbindMedia(), this._bound = !1);
                  },
                  _uploadCovershot: function _uploadCovershot(e) {
                    var t;
                    this.get("simulate") || (this.__lastCovershotUpload = e, (t = this.recorder ? this.recorder.createSnapshotUploader(e, this.get("snapshottype"), this.get("uploadoptions").image) : RecorderSupport.createSnapshotUploader(e, this.get("snapshottype"), this.get("uploadoptions").image)).upload(), this._dataUploader.addUploader(t));
                  },
                  _uploadCovershotFile: function _uploadCovershotFile(e) {
                    var t;
                    this.get("simulate") || (this.__lastCovershotUpload = e, (t = FileUploader.create(Objs.extend({
                      source: e
                    }, this.get("uploadoptions").image))).upload(), this._dataUploader.addUploader(t));
                  },
                  _uploadThumbnails: function _uploadThumbnails(e) {
                    var t;
                    this.get("simulate") || (this.set("videometadata", Objs.tree_merge(this.get("videometadata"), {
                      thumbnails: {
                        mainimage: e
                      }
                    })), (t = FileUploader.create(Objs.extend({
                      source: e
                    }, this.get("uploadoptions").thumbnail))).upload(), this._dataUploader.addUploader(t));
                  },
                  _uploadThumbnailTracks: function _uploadThumbnailTracks(e) {
                    var t;
                    this.get("simulate") || (t = FileUploader.create(Objs.extend({
                      source: e
                    }, this.get("uploadoptions").tracks)), this.get("uploadoptions").tracks.url && this.get("tracktags").push({
                      kind: "thumbnails",
                      src: this.get("uploadoptions").tracks.url
                    }), t.upload(), this._dataUploader.addUploader(t));
                  },
                  _uploadVideoFile: function _uploadVideoFile(e) {
                    var t;
                    this.get("simulate") || ((t = FileUploader.create(Objs.extend({
                      source: e
                    }, this.get("uploadoptions").video))).upload(), this._dataUploader.addUploader(t));
                  },
                  _prepareRecording: function _prepareRecording() {
                    return Promise.create(!0);
                  },
                  _startRecording: function _startRecording() {
                    return this.__recording ? Promise.error(!0) : (this.get("noaudio") || this.recorder.testSoundLevel(!1), this.set("devicetesting", !1), this.recorder.startRecord({
                      video: this.get("uploadoptions").video,
                      audio: this.get("uploadoptions").audio,
                      webrtcStreaming: this.get("uploadoptions").webrtcStreaming
                    }).success(function () {
                      this.__recording = !0, this.__recording_start_time = Time.now();
                    }, this));
                  },
                  _stopRecording: function _stopRecording() {
                    return this.__recording ? this.recorder.stopRecord({
                      video: this.get("uploadoptions").video,
                      audio: this.get("uploadoptions").audio,
                      webrtcStreaming: this.get("uploadoptions").webrtcStreaming
                    }).success(function (e) {
                      this.__recording = !1, e.upload(), this._dataUploader.addUploader(e);
                    }, this) : Promise.error(!0);
                  },
                  isRecording: function isRecording() {
                    return this.__recording;
                  },
                  _verifyRecording: function _verifyRecording() {
                    return Promise.create(!0);
                  },
                  _afterActivate: function _afterActivate(e) {
                    t._afterActivate.call(this, e), this.set("activated", !0), this.__activated = !0, this.__attachRequested && this._attachRecorder(), this.persistentTrigger("loaded");
                  },
                  _showBackgroundSnapshot: function _showBackgroundSnapshot() {
                    var e, t, i, r, o, a, n;
                    this.get("onlyaudio") || (this._hideBackgroundSnapshot(), this.get("snapshots") && this.get("selectfirstcovershotonskip") ? this.get("snapshots")[0] && (this.__backgroundSnapshot = this.get("snapshots")[0]) : this.__backgroundSnapshot = this.recorder.createSnapshot(this.get("snapshottype")), this.__backgroundSnapshot = this.recorder.createSnapshot(this.get("snapshottype")), e = this.activeElement().querySelector("[data-video]"), t = Dom.elementDimensions(e), this.__backgroundSnapshot && (o = r = 0, a = t.width, n = t.height, this.recorder._recorder._videoTrackSettings && "undefined" != typeof this.recorder._recorder._videoTrackSettings.videoInnerFrame && (a = (i = this.recorder._recorder._videoTrackSettings.videoInnerFrame).width || a, n = i.height || n, o = (t.width - a) / 2, r = (t.height - n) / 2), this.__backgroundSnapshotDisplay = this.recorder.createSnapshotDisplay(e, this.__backgroundSnapshot, o, r, a, n)));
                  },
                  _hideBackgroundSnapshot: function _hideBackgroundSnapshot() {
                    this.get("onlyaudio") || (this.__backgroundSnapshotDisplay && this.recorder.removeSnapshotDisplay(this.__backgroundSnapshotDisplay), delete this.__backgroundSnapshotDisplay, this.__backgroundSnapshot && this.recorder.removeSnapshot(this.__backgroundSnapshot), delete this.__backgroundSnapshot);
                  },
                  _getFirstFrameSnapshot: function _getFirstFrameSnapshot() {
                    if (this.__firstFrameSnapshot) return Promise.value(this.__firstFrameSnapshot);
                    if (!(this._videoFile || this.recorder && this.recorder.localPlaybackSource().src)) return Promise.error("No source to get the snapshot from");
                    var t = Promise.create(),
                      i = this._videoFile || this.recorder.localPlaybackSource().src;
                    return RecorderSupport.createSnapshotFromSource(URL.createObjectURL(i), this.get("snapshottype"), 0).success(function (e) {
                      this.__firstFrameSnapshot = e, t.asyncSuccess(e), URL.revokeObjectURL(i);
                    }, this).error(function (e) {
                      t.asyncError(e), URL.revokeObjectURL(i);
                    }, this), t;
                  },
                  toggleFaceOutline: function toggleFaceOutline(e) {
                    void 0 === e ? this.set("faceoutline", !this.get("faceoutline")) : this.set("faceoutline", e);
                  },
                  isMobile: function isMobile() {
                    return Info.isMobile();
                  },
                  object_functions: ["record", "rerecord", "record_screen", "stop", "play", "pause", "reset", "cancel", "pause_recorder", "resume", "upload_video", "upload_covershot", "select_camera", "select_microphone", "add_new_stream", "trim"],
                  functions: {
                    cancel: function cancel() {
                      confirm(this.stringUnicode("cancel-confirm")) && this.execute("reset");
                    },
                    record: function record() {
                      this._delegatedRecorder ? this._delegatedRecorder.execute("record") : this.host.state().record();
                    },
                    record_video: function record_video() {
                      this.host.state().selectRecord();
                    },
                    record_screen: function record_screen(e) {
                      this._delegatedRecorder ? this._delegatedRecorder.execute("record_screen") : this.host.state().selectRecordScreen(e);
                    },
                    pause_recorder: function pause_recorder() {
                      this._delegatedRecorder ? this._delegatedRecorder.execute("pause_recorder") : "undefined" != typeof this.recorder && (this.__paused = !0, this.__pauseStart = Time.now(), this.__recording = !1, this.recorder.pauseRecord(), this.recorder._recorder.once("paused", function (e) {
                        this.set("resumevisible", !0);
                      }, this));
                    },
                    resume: function resume() {
                      this._delegatedRecorder ? this._delegatedRecorder.execute("resume") : "undefined" != typeof this.recorder && this._resume();
                    },
                    video_file_selected: function video_file_selected(e) {
                      this.__selected_video_file = e, this.get("manual-upload") || this.execute("upload_video");
                    },
                    upload_video: function upload_video(e) {
                      this.host.state().selectUpload(e || this.__selected_video_file);
                    },
                    upload_covershot: function upload_covershot(e) {
                      this.host.state().uploadCovershot(e);
                    },
                    select_camera: function select_camera(e) {
                      this.recorder && (this.recorder.setCurrentDevices({
                        video: e
                      }), this.set("showaddstreambutton", this._showAddStreamButton()), this.set("selectedcamera", e));
                    },
                    select_microphone: function select_microphone(e) {
                      this.recorder && (this.recorder.setCurrentDevices({
                        audio: e
                      }), this.recorder.testSoundLevel(!0), this.set("selectedmicrophone", e)), this.set("microphonehealthy", !1);
                    },
                    toggle_face_mode: function toggle_face_mode() {
                      this.recorder && (this.recorder.setCameraFace(this.get("camerafacefront")), this.set("camerafacefront", !this.get("camerafacefront")));
                    },
                    add_new_stream: function add_new_stream(e) {
                      this._add_new_stream(e);
                    },
                    invoke_skip: function invoke_skip() {
                      this.trigger("invoke-skip");
                    },
                    select_image: function select_image(e) {
                      this.trigger("select-image", e);
                    },
                    rerecord: function rerecord() {
                      this._delegatedRecorder ? this._delegatedRecorder.execute("rerecord") : confirm(this.stringUnicode("rerecord-confirm")) && (this.host.state().rerecord(), this._initSettings());
                    },
                    stop: function stop() {
                      this._delegatedRecorder ? this._delegatedRecorder.execute("stop") : (this.__paused && this._resume(), this.host.state().stop());
                    },
                    play: function play() {
                      this._delegatedRecorder ? this._delegatedRecorder.execute("play") : this.host.state().play();
                    },
                    pause: function pause() {
                      this._delegatedRecorder ? this._delegatedRecorder.execute("pause") : this.host.state().pause();
                    },
                    message_click: function message_click() {
                      this.trigger("message-click");
                    },
                    message_link_click: function message_link_click(e) {
                      this.trigger("message-link-click", e);
                    },
                    playing: function playing() {
                      this.trigger("playing");
                    },
                    paused: function paused() {
                      this.trigger("paused");
                    },
                    ended: function ended() {
                      this.trigger("ended");
                    },
                    reset: function reset() {
                      this._delegatedRecorder ? this._delegatedRecorder.execute("reset") : this._stopRecording().callback(function () {
                        this._unbindMedia(), this._hideBackgroundSnapshot(), this._detachRecorder(), this._initSettings(), this.host.state().next("Initial");
                      }, this);
                    },
                    toggle_facemode: function toggle_facemode() {
                      this._toggleFaceMode();
                    },
                    trim: function trim(e, t) {
                      "Trimming" === this.host.state().state_name() && this.trigger("manual-trim", e, t);
                    },
                    manual_submit: function manual_submit() {
                      this.set("rerecordable", !1), this.set("manualsubmit", !1), this.trigger("manually_submitted");
                    },
                    ready_to_play: function ready_to_play() {
                      this.trigger("ready_to_play");
                    }
                  },
                  _resume: function _resume() {
                    this.__paused = !1, this.__pauseDelta += Time.now() - this.__pauseStart, this.__recording = !0, this.recorder.resumeRecord(), this.recorder._recorder.once("resumed", function () {
                      this.set("resumevisible", !1);
                    }, this);
                  },
                  destroy: function destroy() {
                    this._timer.destroy(), this.host.destroy(), this._detachRecorder(), t.destroy.call(this);
                  },
                  deltaCoefficient: function deltaCoefficient() {
                    return this.recorderAttached() ? this.recorder.deltaCoefficient() : null;
                  },
                  blankLevel: function blankLevel() {
                    return this.recorderAttached() ? this.recorder.blankLevel() : null;
                  },
                  lightLevel: function lightLevel() {
                    return this.recorderAttached() ? this.recorder.lightLevel() : null;
                  },
                  soundLevel: function soundLevel() {
                    return this.recorderAttached() ? this.recorder.soundLevel() : null;
                  },
                  _toggleFaceMode: function _toggleFaceMode() {
                    this.set("camerafacefront", !!this.get("camerafacefront"));
                  },
                  _timerFire: function _timerFire() {
                    if (!this.destroyed()) {
                      this.set("currentorientation", window.innerHeight > window.innerWidth ? "portrait" : "landscape");
                      try {
                        var t;
                        this.recorderAttached() && this.get("devicetesting") && (this.get("onlyaudio") || (t = this.lightLevel(), this.set("camerahealthy", 100 <= t && t <= 200)), !this.get("noaudio") && !this.get("microphonehealthy") && 1.01 <= this.soundLevel() && (this.set("microphonehealthy", !0), this.recorder.testSoundLevel(!1)));
                      } catch (e) {}
                      var i, r, o, a, n, s, x, c, d;
                      !this.get("onlyaudio") && this.get("picksnapshots") && this.__recording && this.__recording_start_time + 500 < Time.now() && (i = this.get("snapshots").length < this.get("snapshotmax") ? .25 : .05, Math.random() <= i && (r = this.recorder.createSnapshot(this.get("snapshottype"))) && (!this.get("videometadata").height && "undefined" != typeof Image && this.get("createthumbnails") && RecorderSupport.snapshotMetaData(r).success(function (e) {
                        var t = "landscape" === e.orientation ? 80 : 35;
                        this.set("videometadata", Objs.tree_merge(this.get("videometadata"), e)), this.set("videometadata", Objs.tree_merge(this.get("videometadata"), {
                          thumbnails: {
                            width: t,
                            height: Math.floor(t / e.width * e.height)
                          }
                        }));
                      }, this), this.get("snapshots").length < this.get("snapshotmax") ? this.get("snapshots").push(r) : (o = Math.floor(Math.random() * this.get("snapshotmax")), this.recorder.removeSnapshot(this.get("snapshots")[o]), this.get("snapshots")[o] = r), this.get("createthumbnails") && (a = Math.floor((Time.now() - this.__recording_start_time) / 1e3), n = 1 < this.get("videometadata").thumbnails.images.length ? this.get("videometadata").thumbnails.images.length - 1 : 0, (void 0 === (s = this.get("videometadata").thumbnails.images[n]) || a > s.time + 1) && this.get("videometadata").thumbnails.images.push({
                        time: a,
                        snap: r
                      }))));
                      try {
                        this.recorderAttached() && this._timer.fire_count() % 20 == 0 && this._accessing_camera && (x = .01 <= this.blankLevel()) !== this.__cameraSignal && (this.__cameraSignal = x, this.trigger(x ? "camera_signal" : "camera_nosignal")), this.recorderAttached() && this._timer.fire_count() % 20 == 10 && this._accessing_camera && (d = null === (c = this.recorder.deltaCoefficient()) || .5 <= c) !== this.__cameraResponsive && (this.__cameraResponsive = d, this.trigger(d ? "camera_responsive" : "camera_unresponsive"));
                      } catch (e) {}
                      this._updateCSSSize();
                    }
                  },
                  domDimensions: function domDimensions() {
                    return Dom.elementDimensions(this.activeElement().childNodes[0]);
                  },
                  _updateCSSSize: function _updateCSSSize() {
                    var e = this.domDimensions().width;
                    this.set("csssize", 400 < e ? "normal" : 300 < e ? "medium" : "small");
                  },
                  videoHeight: function videoHeight() {
                    var e = window.innerHeight || document.body.clientHeight;
                    if (this.recorderAttached()) {
                      var t = this.recorder.cameraHeight();
                      return e < t ? e : t;
                    }
                    return e;
                  },
                  videoWidth: function videoWidth() {
                    var e = window.innerWidth || document.body.clientWidth;
                    if (this.recorderAttached()) {
                      var t = this.recorder.cameraWidth();
                      return e < t ? e : t;
                    }
                    return e;
                  },
                  aspectRatio: function aspectRatio() {
                    return this.videoWidth() / this.videoHeight();
                  },
                  isPortrait: function isPortrait() {
                    return "undefined" != typeof this.recorder && "undefined" != typeof this.recorder._recorder._videoTrackSettings ? this.recorder._recorder._videoTrackSettings.aspectRatio < 1 : this.aspectRatio() < 1;
                  },
                  isLandscape: function isLandscape() {
                    return !this.isPortrait();
                  },
                  parentWidth: function parentWidth() {
                    return this.get("width") || Dom.elementDimensions(this.activeElement()).width;
                  },
                  parentHeight: function parentHeight() {
                    return this.get("height") || Dom.elementDimensions(this.activeElement()).height;
                  },
                  parentAspectRatio: function parentAspectRatio() {
                    return this.parentWidth() / this.parentHeight();
                  },
                  averageFrameRate: function averageFrameRate() {
                    return this.recorderAttached() ? this.recorder.averageFrameRate() : null;
                  },
                  cloneAttrs: function cloneAttrs() {
                    return Objs.map(this.attrs, function (e, t) {
                      return this.get(t);
                    }, this);
                  },
                  popupAttrs: function popupAttrs() {
                    return {
                      popup: !1,
                      width: this.get("popup-width"),
                      height: this.get("popup-height"),
                      stretch: this.get("popup-stretch")
                    };
                  },
                  imageUploaded: function imageUploaded() {
                    return !!this.__lastCovershotUpload;
                  },
                  audioUploaded: function audioUploaded() {
                    return this.recorder && this.recorder.localPlaybackSource() && !!this.recorder.localPlaybackSource().audiosrc;
                  },
                  _screenRecorderVerifier: function _screenRecorderVerifier(e) {
                    e && (this.set("allowscreen", !1), this.set("allowmultistreams", !1)), (this.get("allowscreen") || this.get("allowmultistreams")) && this.get("screenrecordmandatory") && !Info.isScreenRecorderSupported() && this.get("initialmessages").push({
                      id: "undefined" != typeof Date.now ? +Date.now() : 1498744,
                      message: this.string("screen-recorder-is-not-supported"),
                      type: "warning"
                    });
                  },
                  _add_new_stream: function _add_new_stream(o) {
                    var a,
                      i = this.recorder._recorder.stream().getTracks();
                    this.get("cameras").iterate(function (e) {
                      var t = e.data();
                      o = o || t.id, a || o !== t.id || (this.set("loadlabel", this.string("adding-new-stream")), this.set("loader_active", !0), this.recorder.addMultiStream(t, {
                        positionX: this.get("addstreampositionx"),
                        positionY: this.get("addstreampositiony"),
                        width: this.get("addstreampositionwidth"),
                        height: this.get("addstreampositionheight")
                      }, i).success(function (e) {
                        var t, i, r;
                        a = !0, this.set("addstreamdeviceid", o), this.get("addstreampositionheight") || (r = 1.333, "undefined" != typeof e.getTracks()[0] && ((i = e.getTracks()[0].getSettings()).aspectRatio ? r = i.aspectRatio : 0 < i.height && 0 < i.width && (r = Math.round(i.width / i.height * 100) / 100)), t = r ? this.get("addstreampositionwidth") / r : Math.round(this.get("addstreampositionwidth") / 1.33), this.set("addstreampositionheight", t)), this.set("loadlabel", ""), this.set("loader_active", !1), this.set("showaddstreambutton", !1), this.get("allowmultistreams") && (this.get("multistreamreversable") || this.get("multistreamdraggable") || this.get("multistreamresizeable")) && (this.set("helperframe_active", !0), this.set("framevisible", !0));
                      }, this).error(function (e) {
                        console.warn(e), this.set("loadlabel", e), this.set("loader_active", !1);
                      }, this));
                    }, this);
                  }
                };
              }], {
                recorderStates: function recorderStates() {
                  return [RecorderStates];
                }
              }).register("ba-videorecorder").registerFunctions({
                "!player_active": function (_player_active) {
                  function player_active(_x215) {
                    return _player_active.apply(this, arguments);
                  }
                  player_active.toString = function () {
                    return _player_active.toString();
                  };
                  return player_active;
                }(function (obj) {
                  with (obj) return !player_active;
                }),
                css: function (_css12) {
                  function css(_x216) {
                    return _css12.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css12.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                csstheme: function (_csstheme3) {
                  function csstheme(_x217) {
                    return _csstheme3.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme3.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                csssize: function (_csssize2) {
                  function csssize(_x218) {
                    return _csssize2.apply(this, arguments);
                  }
                  csssize.toString = function () {
                    return _csssize2.toString();
                  };
                  return csssize;
                }(function (obj) {
                  with (obj) return csssize;
                }),
                iecss: function (_iecss2) {
                  function iecss(_x219) {
                    return _iecss2.apply(this, arguments);
                  }
                  iecss.toString = function () {
                    return _iecss2.toString();
                  };
                  return iecss;
                }(function (obj) {
                  with (obj) return iecss;
                }),
                "ie8 ? 'ie8' : 'noie8'": function ie8Ie8Noie8(obj) {
                  with (obj) return ie8 ? "ie8" : "noie8";
                },
                "fullscreened ? 'fullscreen' : 'normal'": function fullscreenedFullscreenNormal(obj) {
                  with (obj) return fullscreened ? "fullscreen" : "normal";
                },
                cssrecorder: function (_cssrecorder2) {
                  function cssrecorder(_x220) {
                    return _cssrecorder2.apply(this, arguments);
                  }
                  cssrecorder.toString = function () {
                    return _cssrecorder2.toString();
                  };
                  return cssrecorder;
                }(function (obj) {
                  with (obj) return cssrecorder;
                }),
                "firefox ? 'firefox' : 'common'": function firefoxFirefoxCommon(obj) {
                  with (obj) return firefox ? "firefox" : "common";
                },
                themecolor: function (_themecolor2) {
                  function themecolor(_x221) {
                    return _themecolor2.apply(this, arguments);
                  }
                  themecolor.toString = function () {
                    return _themecolor2.toString();
                  };
                  return themecolor;
                }(function (obj) {
                  with (obj) return themecolor;
                }),
                containerSizingStyles: function (_containerSizingStyles2) {
                  function containerSizingStyles(_x222) {
                    return _containerSizingStyles2.apply(this, arguments);
                  }
                  containerSizingStyles.toString = function () {
                    return _containerSizingStyles2.toString();
                  };
                  return containerSizingStyles;
                }(function (obj) {
                  with (obj) return containerSizingStyles;
                }),
                "hasrecorder ? 'hasrecorder' : 'norecorder'": function hasrecorderHasrecorderNorecorder(obj) {
                  with (obj) return hasrecorder ? "hasrecorder" : "norecorder";
                },
                "faceoutline && hasrecorder && isrecorderready": function faceoutlineHasrecorderIsrecorderready(obj) {
                  with (obj) return faceoutline && hasrecorder && isrecorderready;
                },
                "!hideoverlay": function (_hideoverlay) {
                  function hideoverlay(_x223) {
                    return _hideoverlay.apply(this, arguments);
                  }
                  hideoverlay.toString = function () {
                    return _hideoverlay.toString();
                  };
                  return hideoverlay;
                }(function (obj) {
                  with (obj) return !hideoverlay;
                }),
                dynloader: function (_dynloader2) {
                  function dynloader(_x224) {
                    return _dynloader2.apply(this, arguments);
                  }
                  dynloader.toString = function () {
                    return _dynloader2.toString();
                  };
                  return dynloader;
                }(function (obj) {
                  with (obj) return dynloader;
                }),
                "cssloader || css": function cssloaderCss(obj) {
                  with (obj) return cssloader || css;
                },
                "cssrecorder || css": function cssrecorderCss(obj) {
                  with (obj) return cssrecorder || css;
                },
                tmplloader: function (_tmplloader2) {
                  function tmplloader(_x225) {
                    return _tmplloader2.apply(this, arguments);
                  }
                  tmplloader.toString = function () {
                    return _tmplloader2.toString();
                  };
                  return tmplloader;
                }(function (obj) {
                  with (obj) return tmplloader;
                }),
                loader_active: function (_loader_active2) {
                  function loader_active(_x226) {
                    return _loader_active2.apply(this, arguments);
                  }
                  loader_active.toString = function () {
                    return _loader_active2.toString();
                  };
                  return loader_active;
                }(function (obj) {
                  with (obj) return loader_active;
                }),
                loadertooltip: function (_loadertooltip) {
                  function loadertooltip(_x227) {
                    return _loadertooltip.apply(this, arguments);
                  }
                  loadertooltip.toString = function () {
                    return _loadertooltip.toString();
                  };
                  return loadertooltip;
                }(function (obj) {
                  with (obj) return loadertooltip;
                }),
                hovermessage: function (_hovermessage) {
                  function hovermessage(_x228) {
                    return _hovermessage.apply(this, arguments);
                  }
                  hovermessage.toString = function () {
                    return _hovermessage.toString();
                  };
                  return hovermessage;
                }(function (obj) {
                  with (obj) return hovermessage;
                }),
                loaderlabel: function (_loaderlabel) {
                  function loaderlabel(_x229) {
                    return _loaderlabel.apply(this, arguments);
                  }
                  loaderlabel.toString = function () {
                    return _loaderlabel.toString();
                  };
                  return loaderlabel;
                }(function (obj) {
                  with (obj) return loaderlabel;
                }),
                dynmessage: function (_dynmessage2) {
                  function dynmessage(_x230) {
                    return _dynmessage2.apply(this, arguments);
                  }
                  dynmessage.toString = function () {
                    return _dynmessage2.toString();
                  };
                  return dynmessage;
                }(function (obj) {
                  with (obj) return dynmessage;
                }),
                "cssmessage || css": function cssmessageCss(obj) {
                  with (obj) return cssmessage || css;
                },
                tmplmessage: function (_tmplmessage2) {
                  function tmplmessage(_x231) {
                    return _tmplmessage2.apply(this, arguments);
                  }
                  tmplmessage.toString = function () {
                    return _tmplmessage2.toString();
                  };
                  return tmplmessage;
                }(function (obj) {
                  with (obj) return tmplmessage;
                }),
                message_active: function (_message_active2) {
                  function message_active(_x232) {
                    return _message_active2.apply(this, arguments);
                  }
                  message_active.toString = function () {
                    return _message_active2.toString();
                  };
                  return message_active;
                }(function (obj) {
                  with (obj) return message_active;
                }),
                message: function (_message4) {
                  function message(_x233) {
                    return _message4.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message4.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message;
                }),
                message_links: function (_message_links) {
                  function message_links(_x234) {
                    return _message_links.apply(this, arguments);
                  }
                  message_links.toString = function () {
                    return _message_links.toString();
                  };
                  return message_links;
                }(function (obj) {
                  with (obj) return message_links;
                }),
                dyntopmessage: function (_dyntopmessage2) {
                  function dyntopmessage(_x235) {
                    return _dyntopmessage2.apply(this, arguments);
                  }
                  dyntopmessage.toString = function () {
                    return _dyntopmessage2.toString();
                  };
                  return dyntopmessage;
                }(function (obj) {
                  with (obj) return dyntopmessage;
                }),
                "csstopmessage || css": function csstopmessageCss(obj) {
                  with (obj) return csstopmessage || css;
                },
                tmpltopmessage: function (_tmpltopmessage2) {
                  function tmpltopmessage(_x236) {
                    return _tmpltopmessage2.apply(this, arguments);
                  }
                  tmpltopmessage.toString = function () {
                    return _tmpltopmessage2.toString();
                  };
                  return tmpltopmessage;
                }(function (obj) {
                  with (obj) return tmpltopmessage;
                }),
                "topmessage_active && (topmessage || hovermessage)": function topmessage_activeTopmessageHovermessage(obj) {
                  with (obj) return topmessage_active && (topmessage || hovermessage);
                },
                "hovermessage || topmessage": function hovermessageTopmessage(obj) {
                  with (obj) return hovermessage || topmessage;
                },
                dynchooser: function (_dynchooser) {
                  function dynchooser(_x237) {
                    return _dynchooser.apply(this, arguments);
                  }
                  dynchooser.toString = function () {
                    return _dynchooser.toString();
                  };
                  return dynchooser;
                }(function (obj) {
                  with (obj) return dynchooser;
                }),
                "chooser_active && !is_initial_state": function chooser_activeIs_initial_state(obj) {
                  with (obj) return chooser_active && !is_initial_state;
                },
                onlyaudio: function (_onlyaudio) {
                  function onlyaudio(_x238) {
                    return _onlyaudio.apply(this, arguments);
                  }
                  onlyaudio.toString = function () {
                    return _onlyaudio.toString();
                  };
                  return onlyaudio;
                }(function (obj) {
                  with (obj) return onlyaudio;
                }),
                facecamera: function (_facecamera) {
                  function facecamera(_x239) {
                    return _facecamera.apply(this, arguments);
                  }
                  facecamera.toString = function () {
                    return _facecamera.toString();
                  };
                  return facecamera;
                }(function (obj) {
                  with (obj) return facecamera;
                }),
                recordviafilecapture: function (_recordviafilecapture) {
                  function recordviafilecapture(_x240) {
                    return _recordviafilecapture.apply(this, arguments);
                  }
                  recordviafilecapture.toString = function () {
                    return _recordviafilecapture.toString();
                  };
                  return recordviafilecapture;
                }(function (obj) {
                  with (obj) return recordviafilecapture;
                }),
                "csschooser || css": function csschooserCss(obj) {
                  with (obj) return csschooser || css;
                },
                tmplchooser: function (_tmplchooser) {
                  function tmplchooser(_x241) {
                    return _tmplchooser.apply(this, arguments);
                  }
                  tmplchooser.toString = function () {
                    return _tmplchooser.toString();
                  };
                  return tmplchooser;
                }(function (obj) {
                  with (obj) return tmplchooser;
                }),
                allowscreen: function (_allowscreen) {
                  function allowscreen(_x242) {
                    return _allowscreen.apply(this, arguments);
                  }
                  allowscreen.toString = function () {
                    return _allowscreen.toString();
                  };
                  return allowscreen;
                }(function (obj) {
                  with (obj) return allowscreen;
                }),
                allowmultistreams: function (_allowmultistreams) {
                  function allowmultistreams(_x243) {
                    return _allowmultistreams.apply(this, arguments);
                  }
                  allowmultistreams.toString = function () {
                    return _allowmultistreams.toString();
                  };
                  return allowmultistreams;
                }(function (obj) {
                  with (obj) return allowmultistreams;
                }),
                popup: function (_popup2) {
                  function popup(_x244) {
                    return _popup2.apply(this, arguments);
                  }
                  popup.toString = function () {
                    return _popup2.toString();
                  };
                  return popup;
                }(function (obj) {
                  with (obj) return popup;
                }),
                allowrecord: function (_allowrecord) {
                  function allowrecord(_x245) {
                    return _allowrecord.apply(this, arguments);
                  }
                  allowrecord.toString = function () {
                    return _allowrecord.toString();
                  };
                  return allowrecord;
                }(function (obj) {
                  with (obj) return allowrecord;
                }),
                allowupload: function (_allowupload) {
                  function allowupload(_x246) {
                    return _allowupload.apply(this, arguments);
                  }
                  allowupload.toString = function () {
                    return _allowupload.toString();
                  };
                  return allowupload;
                }(function (obj) {
                  with (obj) return allowupload;
                }),
                allowcustomupload: function (_allowcustomupload) {
                  function allowcustomupload(_x247) {
                    return _allowcustomupload.apply(this, arguments);
                  }
                  allowcustomupload.toString = function () {
                    return _allowcustomupload.toString();
                  };
                  return allowcustomupload;
                }(function (obj) {
                  with (obj) return allowcustomupload;
                }),
                allowedextensions: function (_allowedextensions) {
                  function allowedextensions(_x248) {
                    return _allowedextensions.apply(this, arguments);
                  }
                  allowedextensions.toString = function () {
                    return _allowedextensions.toString();
                  };
                  return allowedextensions;
                }(function (obj) {
                  with (obj) return allowedextensions;
                }),
                primaryrecord: function (_primaryrecord) {
                  function primaryrecord(_x249) {
                    return _primaryrecord.apply(this, arguments);
                  }
                  primaryrecord.toString = function () {
                    return _primaryrecord.toString();
                  };
                  return primaryrecord;
                }(function (obj) {
                  with (obj) return primaryrecord;
                }),
                initialmessages: function (_initialmessages2) {
                  function initialmessages(_x250) {
                    return _initialmessages2.apply(this, arguments);
                  }
                  initialmessages.toString = function () {
                    return _initialmessages2.toString();
                  };
                  return initialmessages;
                }(function (obj) {
                  with (obj) return initialmessages;
                }),
                timelimit: function (_timelimit) {
                  function timelimit(_x251) {
                    return _timelimit.apply(this, arguments);
                  }
                  timelimit.toString = function () {
                    return _timelimit.toString();
                  };
                  return timelimit;
                }(function (obj) {
                  with (obj) return timelimit;
                }),
                dynimagegallery: function (_dynimagegallery) {
                  function dynimagegallery(_x252) {
                    return _dynimagegallery.apply(this, arguments);
                  }
                  dynimagegallery.toString = function () {
                    return _dynimagegallery.toString();
                  };
                  return dynimagegallery;
                }(function (obj) {
                  with (obj) return dynimagegallery;
                }),
                imagegallery_active: function (_imagegallery_active) {
                  function imagegallery_active(_x253) {
                    return _imagegallery_active.apply(this, arguments);
                  }
                  imagegallery_active.toString = function () {
                    return _imagegallery_active.toString();
                  };
                  return imagegallery_active;
                }(function (obj) {
                  with (obj) return imagegallery_active;
                }),
                "cssimagegallery || css": function cssimagegalleryCss(obj) {
                  with (obj) return cssimagegallery || css;
                },
                tmplimagegallery: function (_tmplimagegallery) {
                  function tmplimagegallery(_x254) {
                    return _tmplimagegallery.apply(this, arguments);
                  }
                  tmplimagegallery.toString = function () {
                    return _tmplimagegallery.toString();
                  };
                  return tmplimagegallery;
                }(function (obj) {
                  with (obj) return tmplimagegallery;
                }),
                gallerysnapshots: function (_gallerysnapshots) {
                  function gallerysnapshots(_x255) {
                    return _gallerysnapshots.apply(this, arguments);
                  }
                  gallerysnapshots.toString = function () {
                    return _gallerysnapshots.toString();
                  };
                  return gallerysnapshots;
                }(function (obj) {
                  with (obj) return gallerysnapshots;
                }),
                snapshots: function (_snapshots) {
                  function snapshots(_x256) {
                    return _snapshots.apply(this, arguments);
                  }
                  snapshots.toString = function () {
                    return _snapshots.toString();
                  };
                  return snapshots;
                }(function (obj) {
                  with (obj) return snapshots;
                }),
                nativeRecordingWidth: function (_nativeRecordingWidth) {
                  function nativeRecordingWidth(_x257) {
                    return _nativeRecordingWidth.apply(this, arguments);
                  }
                  nativeRecordingWidth.toString = function () {
                    return _nativeRecordingWidth.toString();
                  };
                  return nativeRecordingWidth;
                }(function (obj) {
                  with (obj) return nativeRecordingWidth;
                }),
                nativeRecordingHeight: function (_nativeRecordingHeight) {
                  function nativeRecordingHeight(_x258) {
                    return _nativeRecordingHeight.apply(this, arguments);
                  }
                  nativeRecordingHeight.toString = function () {
                    return _nativeRecordingHeight.toString();
                  };
                  return nativeRecordingHeight;
                }(function (obj) {
                  with (obj) return nativeRecordingHeight;
                }),
                dyncontrolbar: function (_dyncontrolbar2) {
                  function dyncontrolbar(_x259) {
                    return _dyncontrolbar2.apply(this, arguments);
                  }
                  dyncontrolbar.toString = function () {
                    return _dyncontrolbar2.toString();
                  };
                  return dyncontrolbar;
                }(function (obj) {
                  with (obj) return dyncontrolbar;
                }),
                "csscontrolbar || css": function csscontrolbarCss(obj) {
                  with (obj) return csscontrolbar || css;
                },
                "csstheme || css": function cssthemeCss(obj) {
                  with (obj) return csstheme || css;
                },
                tmplcontrolbar: function (_tmplcontrolbar2) {
                  function tmplcontrolbar(_x260) {
                    return _tmplcontrolbar2.apply(this, arguments);
                  }
                  tmplcontrolbar.toString = function () {
                    return _tmplcontrolbar2.toString();
                  };
                  return tmplcontrolbar;
                }(function (obj) {
                  with (obj) return tmplcontrolbar;
                }),
                controlbar_active: function (_controlbar_active) {
                  function controlbar_active(_x261) {
                    return _controlbar_active.apply(this, arguments);
                  }
                  controlbar_active.toString = function () {
                    return _controlbar_active.toString();
                  };
                  return controlbar_active;
                }(function (obj) {
                  with (obj) return controlbar_active;
                }),
                cameras: function (_cameras2) {
                  function cameras(_x262) {
                    return _cameras2.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras2.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                microphones: function (_microphones2) {
                  function microphones(_x263) {
                    return _microphones2.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones2.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                noaudio: function (_noaudio) {
                  function noaudio(_x264) {
                    return _noaudio.apply(this, arguments);
                  }
                  noaudio.toString = function () {
                    return _noaudio.toString();
                  };
                  return noaudio;
                }(function (obj) {
                  with (obj) return noaudio;
                }),
                "record_media==='screen' || record_media==='multistream'": function record_mediaScreenRecord_mediaMultistream(obj) {
                  with (obj) return "screen" === record_media || "multistream" === record_media;
                },
                "selectedcamera || 0": function selectedcamera0(obj) {
                  with (obj) return selectedcamera || 0;
                },
                "selectedmicrophone || 0": function selectedmicrophone0(obj) {
                  with (obj) return selectedmicrophone || 0;
                },
                "addstreamdeviceid || null": function addstreamdeviceidNull(obj) {
                  with (obj) return addstreamdeviceid || null;
                },
                showaddstreambutton: function (_showaddstreambutton) {
                  function showaddstreambutton(_x265) {
                    return _showaddstreambutton.apply(this, arguments);
                  }
                  showaddstreambutton.toString = function () {
                    return _showaddstreambutton.toString();
                  };
                  return showaddstreambutton;
                }(function (obj) {
                  with (obj) return showaddstreambutton;
                }),
                camerahealthy: function (_camerahealthy) {
                  function camerahealthy(_x266) {
                    return _camerahealthy.apply(this, arguments);
                  }
                  camerahealthy.toString = function () {
                    return _camerahealthy.toString();
                  };
                  return camerahealthy;
                }(function (obj) {
                  with (obj) return camerahealthy;
                }),
                microphonehealthy: function (_microphonehealthy) {
                  function microphonehealthy(_x267) {
                    return _microphonehealthy.apply(this, arguments);
                  }
                  microphonehealthy.toString = function () {
                    return _microphonehealthy.toString();
                  };
                  return microphonehealthy;
                }(function (obj) {
                  with (obj) return microphonehealthy;
                }),
                settingsvisible: function (_settingsvisible2) {
                  function settingsvisible(_x268) {
                    return _settingsvisible2.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible2.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                recordvisible: function (_recordvisible2) {
                  function recordvisible(_x269) {
                    return _recordvisible2.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible2.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "allowcancel && cancancel": function allowcancelCancancel(obj) {
                  with (obj) return allowcancel && cancancel;
                },
                uploadcovershotvisible: function (_uploadcovershotvisible2) {
                  function uploadcovershotvisible(_x270) {
                    return _uploadcovershotvisible2.apply(this, arguments);
                  }
                  uploadcovershotvisible.toString = function () {
                    return _uploadcovershotvisible2.toString();
                  };
                  return uploadcovershotvisible;
                }(function (obj) {
                  with (obj) return uploadcovershotvisible;
                }),
                rerecordvisible: function (_rerecordvisible2) {
                  function rerecordvisible(_x271) {
                    return _rerecordvisible2.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible2.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                stopvisible: function (_stopvisible2) {
                  function stopvisible(_x272) {
                    return _stopvisible2.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible2.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                skipvisible: function (_skipvisible2) {
                  function skipvisible(_x273) {
                    return _skipvisible2.apply(this, arguments);
                  }
                  skipvisible.toString = function () {
                    return _skipvisible2.toString();
                  };
                  return skipvisible;
                }(function (obj) {
                  with (obj) return skipvisible;
                }),
                controlbarlabel: function (_controlbarlabel2) {
                  function controlbarlabel(_x274) {
                    return _controlbarlabel2.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel2.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                mintimeindicator: function (_mintimeindicator) {
                  function mintimeindicator(_x275) {
                    return _mintimeindicator.apply(this, arguments);
                  }
                  mintimeindicator.toString = function () {
                    return _mintimeindicator.toString();
                  };
                  return mintimeindicator;
                }(function (obj) {
                  with (obj) return mintimeindicator;
                }),
                timeminlimit: function (_timeminlimit2) {
                  function timeminlimit(_x276) {
                    return _timeminlimit2.apply(this, arguments);
                  }
                  timeminlimit.toString = function () {
                    return _timeminlimit2.toString();
                  };
                  return timeminlimit;
                }(function (obj) {
                  with (obj) return timeminlimit;
                }),
                resumevisible: function (_resumevisible) {
                  function resumevisible(_x277) {
                    return _resumevisible.apply(this, arguments);
                  }
                  resumevisible.toString = function () {
                    return _resumevisible.toString();
                  };
                  return resumevisible;
                }(function (obj) {
                  with (obj) return resumevisible;
                }),
                pausable: function (_pausable) {
                  function pausable(_x278) {
                    return _pausable.apply(this, arguments);
                  }
                  pausable.toString = function () {
                    return _pausable.toString();
                  };
                  return pausable;
                }(function (obj) {
                  with (obj) return pausable;
                }),
                firefox: function (_firefox) {
                  function firefox(_x279) {
                    return _firefox.apply(this, arguments);
                  }
                  firefox.toString = function () {
                    return _firefox.toString();
                  };
                  return firefox;
                }(function (obj) {
                  with (obj) return firefox;
                }),
                dynhelperframe: function (_dynhelperframe) {
                  function dynhelperframe(_x280) {
                    return _dynhelperframe.apply(this, arguments);
                  }
                  dynhelperframe.toString = function () {
                    return _dynhelperframe.toString();
                  };
                  return dynhelperframe;
                }(function (obj) {
                  with (obj) return dynhelperframe;
                }),
                "helperframe_active || framevisible": function helperframe_activeFramevisible(obj) {
                  with (obj) return helperframe_active || framevisible;
                },
                tmphelperframe: function (_tmphelperframe) {
                  function tmphelperframe(_x281) {
                    return _tmphelperframe.apply(this, arguments);
                  }
                  tmphelperframe.toString = function () {
                    return _tmphelperframe.toString();
                  };
                  return tmphelperframe;
                }(function (obj) {
                  with (obj) return tmphelperframe;
                }),
                multistreamreversable: function (_multistreamreversable) {
                  function multistreamreversable(_x282) {
                    return _multistreamreversable.apply(this, arguments);
                  }
                  multistreamreversable.toString = function () {
                    return _multistreamreversable.toString();
                  };
                  return multistreamreversable;
                }(function (obj) {
                  with (obj) return multistreamreversable;
                }),
                multistreamdraggable: function (_multistreamdraggable) {
                  function multistreamdraggable(_x283) {
                    return _multistreamdraggable.apply(this, arguments);
                  }
                  multistreamdraggable.toString = function () {
                    return _multistreamdraggable.toString();
                  };
                  return multistreamdraggable;
                }(function (obj) {
                  with (obj) return multistreamdraggable;
                }),
                multistreamresizeable: function (_multistreamresizeable) {
                  function multistreamresizeable(_x284) {
                    return _multistreamresizeable.apply(this, arguments);
                  }
                  multistreamresizeable.toString = function () {
                    return _multistreamresizeable.toString();
                  };
                  return multistreamresizeable;
                }(function (obj) {
                  with (obj) return multistreamresizeable;
                }),
                addstreampositionx: function (_addstreampositionx) {
                  function addstreampositionx(_x285) {
                    return _addstreampositionx.apply(this, arguments);
                  }
                  addstreampositionx.toString = function () {
                    return _addstreampositionx.toString();
                  };
                  return addstreampositionx;
                }(function (obj) {
                  with (obj) return addstreampositionx;
                }),
                addstreampositiony: function (_addstreampositiony) {
                  function addstreampositiony(_x286) {
                    return _addstreampositiony.apply(this, arguments);
                  }
                  addstreampositiony.toString = function () {
                    return _addstreampositiony.toString();
                  };
                  return addstreampositiony;
                }(function (obj) {
                  with (obj) return addstreampositiony;
                }),
                addstreamproportional: function (_addstreamproportional) {
                  function addstreamproportional(_x287) {
                    return _addstreamproportional.apply(this, arguments);
                  }
                  addstreamproportional.toString = function () {
                    return _addstreamproportional.toString();
                  };
                  return addstreamproportional;
                }(function (obj) {
                  with (obj) return addstreamproportional;
                }),
                "flip-camera": function flipCamera(obj) {
                  with (obj) return flip - camera;
                },
                player_active: function (_player_active2) {
                  function player_active(_x288) {
                    return _player_active2.apply(this, arguments);
                  }
                  player_active.toString = function () {
                    return _player_active2.toString();
                  };
                  return player_active;
                }(function (obj) {
                  with (obj) return player_active;
                }),
                ie8: function (_ie) {
                  function ie8(_x289) {
                    return _ie.apply(this, arguments);
                  }
                  ie8.toString = function () {
                    return _ie.toString();
                  };
                  return ie8;
                }(function (obj) {
                  with (obj) return ie8;
                }),
                dynvideoplayer: function (_dynvideoplayer) {
                  function dynvideoplayer(_x290) {
                    return _dynvideoplayer.apply(this, arguments);
                  }
                  dynvideoplayer.toString = function () {
                    return _dynvideoplayer.toString();
                  };
                  return dynvideoplayer;
                }(function (obj) {
                  with (obj) return dynvideoplayer;
                }),
                "theme || 'default'": function themeDefault(obj) {
                  with (obj) return theme || "default";
                },
                "localplayback ? playbacksource : ''": function localplaybackPlaybacksource(obj) {
                  with (obj) return localplayback ? playbacksource : "";
                },
                "localplayback ? playbackposter : ''": function localplaybackPlaybackposter(obj) {
                  with (obj) return localplayback ? playbackposter : "";
                },
                "false": function _false(obj) {
                  with (obj) return !1;
                },
                showplayersettingsmenu: function (_showplayersettingsmenu) {
                  function showplayersettingsmenu(_x291) {
                    return _showplayersettingsmenu.apply(this, arguments);
                  }
                  showplayersettingsmenu.toString = function () {
                    return _showplayersettingsmenu.toString();
                  };
                  return showplayersettingsmenu;
                }(function (obj) {
                  with (obj) return showplayersettingsmenu;
                }),
                playerattrs: function (_playerattrs) {
                  function playerattrs(_x292) {
                    return _playerattrs.apply(this, arguments);
                  }
                  playerattrs.toString = function () {
                    return _playerattrs.toString();
                  };
                  return playerattrs;
                }(function (obj) {
                  with (obj) return playerattrs;
                }),
                duration: function (_duration2) {
                  function duration(_x293) {
                    return _duration2.apply(this, arguments);
                  }
                  duration.toString = function () {
                    return _duration2.toString();
                  };
                  return duration;
                }(function (obj) {
                  with (obj) return duration;
                }),
                "rerecordable && (recordings === null || recordings > 0)": function rerecordableRecordingsNullRecordings0(obj) {
                  with (obj) return rerecordable && (null === recordings || 0 < recordings);
                },
                "manualsubmit && verified": function manualsubmitVerified(obj) {
                  with (obj) return manualsubmit && verified;
                },
                "true": function _true(obj) {
                  with (obj) return !0;
                },
                autoplay: function (_autoplay) {
                  function autoplay(_x294) {
                    return _autoplay.apply(this, arguments);
                  }
                  autoplay.toString = function () {
                    return _autoplay.toString();
                  };
                  return autoplay;
                }(function (obj) {
                  with (obj) return autoplay;
                }),
                nofullscreen: function (_nofullscreen) {
                  function nofullscreen(_x295) {
                    return _nofullscreen.apply(this, arguments);
                  }
                  nofullscreen.toString = function () {
                    return _nofullscreen.toString();
                  };
                  return nofullscreen;
                }(function (obj) {
                  with (obj) return nofullscreen;
                }),
                playertopmessage: function (_playertopmessage) {
                  function playertopmessage(_x296) {
                    return _playertopmessage.apply(this, arguments);
                  }
                  playertopmessage.toString = function () {
                    return _playertopmessage.toString();
                  };
                  return playertopmessage;
                }(function (obj) {
                  with (obj) return playertopmessage;
                }),
                allowtexttrackupload: function (_allowtexttrackupload3) {
                  function allowtexttrackupload(_x297) {
                    return _allowtexttrackupload3.apply(this, arguments);
                  }
                  allowtexttrackupload.toString = function () {
                    return _allowtexttrackupload3.toString();
                  };
                  return allowtexttrackupload;
                }(function (obj) {
                  with (obj) return allowtexttrackupload;
                }),
                uploadtexttracksvisible: function (_uploadtexttracksvisible2) {
                  function uploadtexttracksvisible(_x298) {
                    return _uploadtexttracksvisible2.apply(this, arguments);
                  }
                  uploadtexttracksvisible.toString = function () {
                    return _uploadtexttracksvisible2.toString();
                  };
                  return uploadtexttracksvisible;
                }(function (obj) {
                  with (obj) return uploadtexttracksvisible;
                }),
                snapshottype: function (_snapshottype) {
                  function snapshottype(_x299) {
                    return _snapshottype.apply(this, arguments);
                  }
                  snapshottype.toString = function () {
                    return _snapshottype.toString();
                  };
                  return snapshottype;
                }(function (obj) {
                  with (obj) return snapshottype;
                }),
                tracktags: function (_tracktags3) {
                  function tracktags(_x300) {
                    return _tracktags3.apply(this, arguments);
                  }
                  tracktags.toString = function () {
                    return _tracktags3.toString();
                  };
                  return tracktags;
                }(function (obj) {
                  with (obj) return tracktags;
                }),
                tracktagsstyled: function (_tracktagsstyled2) {
                  function tracktagsstyled(_x301) {
                    return _tracktagsstyled2.apply(this, arguments);
                  }
                  tracktagsstyled.toString = function () {
                    return _tracktagsstyled2.toString();
                  };
                  return tracktagsstyled;
                }(function (obj) {
                  with (obj) return tracktagsstyled;
                }),
                trackcuetext: function (_trackcuetext3) {
                  function trackcuetext(_x302) {
                    return _trackcuetext3.apply(this, arguments);
                  }
                  trackcuetext.toString = function () {
                    return _trackcuetext3.toString();
                  };
                  return trackcuetext;
                }(function (obj) {
                  with (obj) return trackcuetext;
                }),
                acceptedtracktexts: function (_acceptedtracktexts3) {
                  function acceptedtracktexts(_x303) {
                    return _acceptedtracktexts3.apply(this, arguments);
                  }
                  acceptedtracktexts.toString = function () {
                    return _acceptedtracktexts3.toString();
                  };
                  return acceptedtracktexts;
                }(function (obj) {
                  with (obj) return acceptedtracktexts;
                }),
                sharevideo: function (_sharevideo2) {
                  function sharevideo(_x304) {
                    return _sharevideo2.apply(this, arguments);
                  }
                  sharevideo.toString = function () {
                    return _sharevideo2.toString();
                  };
                  return sharevideo;
                }(function (obj) {
                  with (obj) return sharevideo;
                }),
                videofitstrategy: function (_videofitstrategy2) {
                  function videofitstrategy(_x305) {
                    return _videofitstrategy2.apply(this, arguments);
                  }
                  videofitstrategy.toString = function () {
                    return _videofitstrategy2.toString();
                  };
                  return videofitstrategy;
                }(function (obj) {
                  with (obj) return videofitstrategy;
                }),
                posterfitstrategy: function (_posterfitstrategy2) {
                  function posterfitstrategy(_x306) {
                    return _posterfitstrategy2.apply(this, arguments);
                  }
                  posterfitstrategy.toString = function () {
                    return _posterfitstrategy2.toString();
                  };
                  return posterfitstrategy;
                }(function (obj) {
                  with (obj) return posterfitstrategy;
                }),
                tracksshowselection: function (_tracksshowselection2) {
                  function tracksshowselection(_x307) {
                    return _tracksshowselection2.apply(this, arguments);
                  }
                  tracksshowselection.toString = function () {
                    return _tracksshowselection2.toString();
                  };
                  return tracksshowselection;
                }(function (obj) {
                  with (obj) return tracksshowselection;
                }),
                trackselectorhovered: function (_trackselectorhovered2) {
                  function trackselectorhovered(_x308) {
                    return _trackselectorhovered2.apply(this, arguments);
                  }
                  trackselectorhovered.toString = function () {
                    return _trackselectorhovered2.toString();
                  };
                  return trackselectorhovered;
                }(function (obj) {
                  with (obj) return trackselectorhovered;
                }),
                uploadlocales: function (_uploadlocales3) {
                  function uploadlocales(_x309) {
                    return _uploadlocales3.apply(this, arguments);
                  }
                  uploadlocales.toString = function () {
                    return _uploadlocales3.toString();
                  };
                  return uploadlocales;
                }(function (obj) {
                  with (obj) return uploadlocales;
                }),
                frameselectionmode: function (_frameselectionmode3) {
                  function frameselectionmode(_x310) {
                    return _frameselectionmode3.apply(this, arguments);
                  }
                  frameselectionmode.toString = function () {
                    return _frameselectionmode3.toString();
                  };
                  return frameselectionmode;
                }(function (obj) {
                  with (obj) return frameselectionmode;
                })
              }).attachStringTable(Assets.strings).addStrings({
                "recorder-error": "An error occurred, please try again later. Click to retry.",
                "attach-error": "We could not access the media interface. Depending on the device and browser, you might need to access the page via SSL.",
                "software-required": "Please click below to install / activate the following requirements in order to proceed.",
                "software-waiting": "Waiting for the requirements to be installed / activated. You might need to refresh the page after completion.",
                "access-forbidden": "Access to the media was forbidden. Click to retry.",
                "pick-covershot": "Pick a covershot.",
                "pick-covershot-frame": "Select a frame to use as covershot.",
                "framerate-warning": "The video frame rate is very low. We recommend closing all other programs and browser tabs or to use a faster computer.",
                uploading: "Uploading",
                "uploading-src-error": "Unable to play back video now, uploading is still in progress",
                "uploading-failed": "Uploading failed - click here to retry.",
                "upload-error-duration": "Length of the uploaded video does not meet the requirements - click here to retry.",
                "resolution-constraint-error": "The file you've selected does not match the required resolution - click here to retry.",
                verifying: "Verifying",
                "verifying-failed": "Verifying failed - click here to retry.",
                "rerecord-confirm": "Do you really want to redo your video?",
                "cancel-confirm": "Do you really want to cancel your video upload?",
                video_file_too_large: "Your video file is too large (%s) - click here to try again with a smaller video file.",
                unsupported_video_type: "Please upload: %s - click here to retry.",
                "orientation-portrait-required": "Please rotate your device to record in portrait mode.",
                "orientation-landscape-required": "Please rotate your device to record in landscape mode.",
                "switch-camera": "Switch camera",
                "prepare-covershot": "Preparing covershots",
                "prepare-thumbnails": "Preparing seeking thumbnails",
                "adding-new-stream": "Adding New Stream",
                "missing-track": "Required audio or video track is missing",
                "device-already-in-use": "At least one of your input devices are already in use",
                "browser-permission-denied": "Permission denied by browser, please grant access and reload page",
                "screen-recorder-is-not-supported": "Screen recorder is not supported on this device",
                "trim-prompt": "Do you want to trim your video?",
                "trim-video": "Move the start and end markers to trim your video",
                "wait-for-trim": "Waiting for trim command...",
                "supported-mode": "Media resolution should be in '%s' mode.",
                "re-choose-action": "Please click to choose another input device or retry action."
              });
            }), Scoped.define("module:VideoRecorder.Dynamics.Trimmer", ["dynamics:Dynamic", "browser:Events", "base:Promise"], function (Class, DomEvents, Promise, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<div class="{{csstrimmer}}-container {{csscommon}}-accent-color-bg">\n    \n    <button ba-click="{{togglePlay()}}" class="{{csstrimmer}}-button-play" aria-label="{{playing || wasPlaying ? \'Pause\' : \'Play\'}}">\n        <i class="{{csscommon + \'-icon-\' + (playing || wasPlaying ? \'pause\' : \'play\')}} {{csscommon}}-accent-color"></i>\n    </button>\n    \n    <div\n        class="{{csstrimmer}}-progress-bar"\n        ontouchstart="{{handleProgressBarClick(event)}}"\n        onmousedown="{{handleProgressBarClick(event)}}"\n        data-selector="progressbar"\n    >\n        \n        <div\n            class="{{csstrimmer}}-snapshots"\n            data-selector="snapshots"\n        ></div>\n        \n        <div\n            class="{{csstrimmer}}-playhead"\n            style="left: calc({{duration ? position / duration * 100 : 0}}% - 1px)"\n        ></div>\n        \n        <div\n            class="{{csstrimmer}}-selection {{csscommon}}-accent-color-border"\n            ontouchstart="{{handleSelectionClick(event)}}"\n            onmousedown="{{handleSelectionClick(event)}}"\n            data-selector="selection"\n            style="\n                left: calc({{duration && startposition ? startposition / duration * 100 : 0}}% - 4px);\n                right: calc({{100 - (duration && endposition ? endposition / duration * 100 : 100)}}% - 4px);\n            "\n        ></div>\n    </div>\n    \n    <div class="{{csstrimmer}}-right-button-container">\n        \n        <button\n            class="{{csscommon}}-{{trimButtonEnabled ? \'accent-color-bg\' : \'disabled\'}} {{csstrimmer}}-button-trim"\n            ba-click="{{trim()}}"\n        >Trim</button>\n        \n        <button\n            class="{{csstrimmer}}-button-skip"\n            ba-click="{{skip()}}"\n        >Skip</button>\n    </div>\n</div>',
                  attrs: {
                    csscommon: "ba-commoncss",
                    csstrimmer: "ba-videorecorder-trimmer"
                  },
                  computed: {
                    "trimButtonEnabled:startposition,endposition,duration": function trimButtonEnabledStartpositionEndpositionDuration(e, t, i) {
                      return 0 !== e && null !== e || t !== i && null !== t;
                    }
                  },
                  events: {
                    "change:progress-bar-width": function changeProgressBarWidth() {
                      this.call("updateThumbnails");
                    }
                  },
                  destroy: function destroy() {
                    this._progressBarResizeObserver && this._progressBarResizeObserver.disconnect(), e.destroy.call(this);
                  },
                  functions: {
                    skip: function skip() {
                      this.chainedTrigger("skip");
                    },
                    trim: function trim() {
                      this.chainedTrigger("video-trimmed", {
                        start: this.get("startposition"),
                        end: this.get("endposition")
                      });
                    },
                    togglePlay: function togglePlay() {
                      this.trigger(this.get("playing") ? "pause" : "play");
                    },
                    handleSelectionClick: function handleSelectionClick(e) {
                      var t, i, r, o, a;
                      e.preventDefault(), "mousedown" === e.type && 0 !== e.button || (t = this.call("getClientX", e), i = e.target.getBoundingClientRect(), r = e.target.clientLeft, o = t >= i.left && t <= i.left + r, a = t >= i.right - r && t <= i.right, (o || a) && (e.stopPropagation(), o ? this.call("attachUpdatePositionEventListeners", t, "startposition") : this.call("attachUpdatePositionEventListeners", t, "endposition")));
                    },
                    handleProgressBarClick: function handleProgressBarClick(e) {
                      var t, i, r, o;
                      e.preventDefault(), "mousedown" === e.type && 0 !== e.button || (r = (t = this.call("getClientX", e)) <= (i = this._selectionElement.getBoundingClientRect()).left, o = t >= i.right, r ? this.call("attachUpdatePositionEventListeners", t, "startposition") : o ? this.call("attachUpdatePositionEventListeners", t, "endposition") : (this.get("playing") && (this.set("wasPlaying", !0), this.trigger("pause")), this.call("attachUpdatePositionEventListeners", t, "position")));
                    },
                    attachUpdatePositionEventListeners: function attachUpdatePositionEventListeners(e, t) {
                      this.call("updatePosition", e, t);
                      var i = this._events;
                      i.on(document, "mousemove touchmove", function (e) {
                        e.preventDefault(), this.call("updatePosition", this.call("getClientX", e), t);
                      }, this), i.on(document, "mouseup touchend", function (e) {
                        e.preventDefault(), this.get("wasPlaying") && (this.trigger("play"), setTimeout(function () {
                          this.set("wasPlaying", !1);
                        }.bind(this), 100)), i.off(document, "mouseup touchend mousemove touchmove");
                      }, this);
                    },
                    updatePosition: function updatePosition(e, t) {
                      var i = this.call("getCurrentPosition", e),
                        r = this.get("minduration") || 1;
                      switch (t) {
                        case "position":
                          this.trigger("seek", i);
                          break;
                        case "startposition":
                          var o = this.get("endposition") || this.get("duration");
                          o - r < i ? this.set(t, o - r) : this.set(t, i);
                          break;
                        case "endposition":
                          var a = this.get("startposition") || 0;
                          i < a + r ? this.set(t, a + r) : this.set(t, i);
                      }
                    },
                    getClientX: function getClientX(e) {
                      return 0 === e.clientX ? 0 : e.clientX || e.targetTouches[0].clientX;
                    },
                    getCurrentPosition: function getCurrentPosition(e) {
                      var t = this._progressBarElement.getBoundingClientRect(),
                        i = e < t.left ? 0 : e > t.left + t.width ? 1 : (e - t.left) / (t.width || 1);
                      return this.get("duration") * i;
                    },
                    updateThumbnails: function updateThumbnails() {
                      Promise.conditional(!this._internalVideoElement, function () {
                        var e = Promise.create(),
                          t = document.createElement("video"),
                          i = this.get("source").src || this.get("source");
                        return t.src = URL.createObjectURL(i), t.addEventListener("loadedmetadata", function () {
                          this._internalVideoElement = t, this._canvasHeight = 34, this._canvasWidth = this._canvasHeight * t.videoWidth / t.videoHeight, this._canvases = [], this._canvases.push(this.call("createNewCanvas")), this.call("drawSnapshot", this._canvases[0], 0).success(function () {
                            e.asyncSuccess(t);
                          });
                        }.bind(this)), e;
                      }.bind(this), this._internalVideoElement).success(function (e) {
                        0 !== this._progressBarElement.clientWidth && this.call("drawSnapshotRecursive", 1);
                      }, this);
                    },
                    createNewCanvas: function createNewCanvas() {
                      var e = document.createElement("canvas");
                      return e.height = this._canvasHeight, e.width = this._canvasWidth, this._snapshotsElement.appendChild(e), e;
                    },
                    drawSnapshot: function drawSnapshot(e, t) {
                      var i = Promise.create();
                      return this._internalVideoElement.currentTime = t, this._events.on(this._internalVideoElement, "seeked", function () {
                        e.getContext("2d").drawImage(this._internalVideoElement, 0, 0, e.width, e.height), this._events.off(this._internalVideoElement, "seeked"), i.asyncSuccess();
                      }, this), i;
                    },
                    drawSnapshotRecursive: function drawSnapshotRecursive(e) {
                      e * this._canvasWidth > this._progressBarElement.clientWidth || (e + 1 >= this._canvases.length && this._canvases.push(this.call("createNewCanvas")), this.call("drawSnapshot", this._canvases[e], this.get("duration") * (e * this._canvasWidth / this._progressBarElement.clientWidth)).success(function () {
                        this.call("drawSnapshotRecursive", ++e);
                      }, this));
                    }
                  },
                  create: function create() {
                    "string" != typeof this.get("source") && (this._events = this.auto_destroy(new DomEvents()), this._progressBarElement = this.activeElement().querySelector("[data-selector='progressbar'"), this._selectionElement = this.activeElement().querySelector("[data-selector='selection']"), this._snapshotsElement = this.activeElement().querySelector("[data-selector='snapshots']"), this._progressBarResizeObserver = new ResizeObserver(function (e) {
                      e.forEach(function (e) {
                        e.contentRect.width !== this.get("progress-bar-width") && this.set("progress-bar-width", e.contentRect.width);
                      }.bind(this));
                    }.bind(this)), this._progressBarResizeObserver.observe(this._progressBarElement), this.call("updateThumbnails"));
                  }
                };
              }).register("ba-videorecorder-trimmer").registerFunctions({
                csstrimmer: function (_csstrimmer) {
                  function csstrimmer(_x311) {
                    return _csstrimmer.apply(this, arguments);
                  }
                  csstrimmer.toString = function () {
                    return _csstrimmer.toString();
                  };
                  return csstrimmer;
                }(function (obj) {
                  with (obj) return csstrimmer;
                }),
                csscommon: function (_csscommon9) {
                  function csscommon(_x312) {
                    return _csscommon9.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon9.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "togglePlay()": function (_togglePlay) {
                  function togglePlay(_x313) {
                    return _togglePlay.apply(this, arguments);
                  }
                  togglePlay.toString = function () {
                    return _togglePlay.toString();
                  };
                  return togglePlay;
                }(function (obj) {
                  with (obj) return togglePlay();
                }),
                "playing || wasPlaying ? 'Pause' : 'Play'": function playingWasPlayingPausePlay(obj) {
                  with (obj) return playing || wasPlaying ? "Pause" : "Play";
                },
                "csscommon + '-icon-' + (playing || wasPlaying ? 'pause' : 'play')": function csscommonIconPlayingWasPlayingPausePlay(obj) {
                  with (obj) return csscommon + "-icon-" + (playing || wasPlaying ? "pause" : "play");
                },
                "handleProgressBarClick(event)": function handleProgressBarClickEvent(obj) {
                  with (obj) return handleProgressBarClick(event);
                },
                "duration ? position / duration * 100 : 0": function durationPositionDuration1000(obj) {
                  with (obj) return duration ? position / duration * 100 : 0;
                },
                "handleSelectionClick(event)": function handleSelectionClickEvent(obj) {
                  with (obj) return handleSelectionClick(event);
                },
                "duration && startposition ? startposition / duration * 100 : 0": function durationStartpositionStartpositionDuration1000(obj) {
                  with (obj) return duration && startposition ? startposition / duration * 100 : 0;
                },
                "100 - (duration && endposition ? endposition / duration * 100 : 100)": function durationEndpositionEndpositionDuration100100(obj) {
                  with (obj) return 100 - (duration && endposition ? endposition / duration * 100 : 100);
                },
                "trimButtonEnabled ? 'accent-color-bg' : 'disabled'": function trimButtonEnabledAccentColorBgDisabled(obj) {
                  with (obj) return trimButtonEnabled ? "accent-color-bg" : "disabled";
                },
                "trim()": function (_trim2) {
                  function trim(_x314) {
                    return _trim2.apply(this, arguments);
                  }
                  trim.toString = function () {
                    return _trim2.toString();
                  };
                  return trim;
                }(function (obj) {
                  with (obj) return trim();
                }),
                "skip()": function (_skip3) {
                  function skip(_x315) {
                    return _skip3.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip3.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                })
              });
            }), Scoped.define("module:ImageViewer.Dynamics.Controlbar", ["dynamics:Dynamic", "module:Assets", "browser:Info"], ["dynamics:Partials.ShowPartial", "dynamics:Partials.IfPartial", "dynamics:Partials.ClickPartial"], function (Class, Assets, Info, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div class="{{css}}-dashboard {{activitydelta > 5000 && hideoninactivity ? (css + \'-dashboard-hidden\') : \'\'}}">\n\t<div class="{{css}}-backbar"></div>\n\n\t<div class="{{css}}-controlbar">\n\n        <div tabindex="0" data-selector="submit-image-button"\n\t\t\t ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-leftbutton-container"\n\t\t\t ba-if="{{submittable}}" ba-click="{{submit()}}">\n            <div class="{{css}}-button-inner">\n                {{string(\'submit-image\')}}\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-ccw"\n\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-leftbutton-container" ba-if="{{rerecordable}}"\n\t\t\t ba-click="{{rerecord()}}" title="{{string(\'rerecord-image\')}}"\n\t\t>\n            <div class="{{css}}-button-inner">\n                <i class="{{csscommon}}-icon-ccw"></i>\n            </div>\n        </div>\n\n\t\t<div data-selector="image-title-block" class="{{css}}-image-title-container" ba-if="{{title}}">\n\t\t\t<p class="{{css}}-image-title">\n\t\t\t\t{{title}}\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div tabindex="8" data-selector="button-icon-resize-full"\n\t\t\t ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-rightbutton-container"\n\t\t\t onkeydown="{{tab_index_move(domEvent)}}" ba-if="{{fullscreen}}"\n\t\t\t ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-image\') : string(\'fullscreen-image\') }}">\n\t\t\t<div class="{{css}}-button-inner">\n\t\t\t\t<i class="{{csscommon}}-icon-resize-{{fullscreened ? \'small\' : \'full\'}}"></i>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n</div>\n',
                  attrs: {
                    css: "ba-imageviewer",
                    rerecordable: !1,
                    submittable: !1,
                    fullscreen: !0,
                    fullscreened: !1,
                    activitydelta: 0,
                    title: ""
                  },
                  functions: {
                    toggle_fullscreen: function toggle_fullscreen() {
                      this.trigger("fullscreen");
                    },
                    rerecord: function rerecord() {
                      this.trigger("rerecord");
                    },
                    submit: function submit() {
                      this.set("submittable", !1), this.set("rerecordable", !1), this.trigger("submit");
                    },
                    tab_index_move: function tab_index_move(e, t, i) {
                      this.trigger("tab_index_move", e[0], t, i);
                    }
                  },
                  create: function create() {
                    this.set("ismobile", Info.isMobile());
                  }
                };
              }).register("ba-imageviewer-controlbar").registerFunctions({
                css: function (_css13) {
                  function css(_x316) {
                    return _css13.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css13.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "activitydelta > 5000 && hideoninactivity ? (css + '-dashboard-hidden') : ''": function activitydelta5000HideoninactivityCssDashboardHidden(obj) {
                  with (obj) return 5e3 < activitydelta && hideoninactivity ? css + "-dashboard-hidden" : "";
                },
                "submit()": function (_submit3) {
                  function submit(_x317) {
                    return _submit3.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit3.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable3) {
                  function submittable(_x318) {
                    return _submittable3.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable3.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-image')": function stringSubmitImage(obj) {
                  with (obj) return string("submit-image");
                },
                "rerecord()": function (_rerecord4) {
                  function rerecord(_x319) {
                    return _rerecord4.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord4.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable3) {
                  function rerecordable(_x320) {
                    return _rerecordable3.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable3.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-image')": function stringRerecordImage(obj) {
                  with (obj) return string("rerecord-image");
                },
                csscommon: function (_csscommon10) {
                  function csscommon(_x321) {
                    return _csscommon10.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon10.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                title: function (_title3) {
                  function title(_x322) {
                    return _title3.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title3.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "toggle_fullscreen()": function (_toggle_fullscreen2) {
                  function toggle_fullscreen(_x323) {
                    return _toggle_fullscreen2.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen2.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                fullscreen: function (_fullscreen2) {
                  function fullscreen(_x324) {
                    return _fullscreen2.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen2.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-image') : string('fullscreen-image')": function fullscreenedStringExitFullscreenImageStringFullscreenImage(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-image") : string("fullscreen-image");
                },
                "fullscreened ? 'small' : 'full'": function fullscreenedSmallFull(obj) {
                  with (obj) return fullscreened ? "small" : "full";
                }
              }).attachStringTable(Assets.strings).addStrings({
                "rerecord-image": "Redo?",
                "submit-image": "Confirm",
                "fullscreen-image": "Enter fullscreen",
                "exit-fullscreen-image": "Exit fullscreen"
              });
            }), Scoped.define("module:ImageViewer.Dynamics.Message", ["dynamics:Dynamic"], ["dynamics:Partials.ClickPartial"], function (Class, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div class="{{css}}-message-container" ba-click="{{click()}}">\n    <div data-selector="message-block" class=\'{{css}}-message-message\'>\n        {{message}}\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-imageviewer",
                    message: ""
                  },
                  functions: {
                    click: function click() {
                      this.trigger("click");
                    }
                  }
                };
              }).registerFunctions({
                css: function (_css14) {
                  function css(_x325) {
                    return _css14.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css14.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click3) {
                  function click(_x326) {
                    return _click3.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click3.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                message: function (_message5) {
                  function message(_x327) {
                    return _message5.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message5.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message;
                })
              }).register("ba-imageviewer-message");
            }), Scoped.define("module:ImageViewer.Dynamics.Topmessage", ["dynamics:Dynamic"], function (Class, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: "\n<div class=\"{{css}}-topmessage-container\">\n    <div class='{{css}}-topmessage-background'>\n    </div>\n    <div data-selector=\"topmessage-message-block\" class='{{css}}-topmessage-message'>\n        {{topmessage}}\n    </div>\n</div>\n",
                  attrs: {
                    css: "ba-imageviewer",
                    topmessage: ""
                  }
                };
              }).registerFunctions({
                css: function (_css15) {
                  function css(_x328) {
                    return _css15.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css15.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                topmessage: function (_topmessage4) {
                  function topmessage(_x329) {
                    return _topmessage4.apply(this, arguments);
                  }
                  topmessage.toString = function () {
                    return _topmessage4.toString();
                  };
                  return topmessage;
                }(function (obj) {
                  with (obj) return topmessage;
                })
              }).register("ba-imageviewer-topmessage");
            }), Scoped.define("module:ImageViewer.Dynamics.ImageViewer", ["dynamics:Dynamic", "module:Assets", "browser:Info", "browser:Dom", "base:Types", "base:Objs", "base:Strings", "base:Time", "base:Timers", "base:Classes.ClassRegistry", "base:Async", "browser:Events"], ["module:ImageViewer.Dynamics.Message", "module:ImageViewer.Dynamics.Controlbar", "dynamics:Partials.EventPartial", "dynamics:Partials.OnPartial", "dynamics:Partials.TemplatePartial", "dynamics:Partials.HotkeyPartial"], function (Class, Assets, Info, Dom, Types, Objs, Strings, Time, Timers, ClassRegistry, Async, DomEvents, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (t) {
                return {
                  template: '<div itemscope itemtype="http://schema.org/ImageObject"\n    class="{{css}}-container {{css}}-size-{{csssize}} {{iecss}}-{{ie8 ? \'ie8\' : \'noie8\'}}\n    {{csstheme}} {{css}}-{{ fullscreened ? \'fullscreen\' : \'normal\' }}-view {{css}}-{{ firefox ? \'firefox\' : \'common\'}}-browser\n    {{css}}-{{themecolor}}-color"\n    ba-on:mousemove="{{user_activity()}}"\n    ba-on:mousedown="{{user_activity(true)}}"\n    ba-on:touchstart="{{user_activity(true)}}"\n\tba-styles="{{widthHeightStyles}}"\n>\n    <img tabindex="-1" class="{{css}}-image" data-image="image" />\n    <div class="{{css}}-overlay">\n\t    <ba-{{dyncontrolbar}}\n\t\t    ba-css="{{csscontrolbar || css}}"\n\t\t\tba-csscommon="{{csscommon || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t    ba-template="{{tmplcontrolbar}}"\n\t\t    ba-show="{{controlbar_active}}"\n\t\t    ba-event:rerecord="rerecord"\n\t\t    ba-event:submit="submit"\n\t\t    ba-event:fullscreen="toggle_fullscreen"\n\t\t\tba-event:tab_index_move="tab_index_move"\n\t\t\tba-tabindex="{{tabindex}}"\n\t\t    ba-title="{{title}}"\n\t\t    ba-activitydelta="{{activity_delta}}"\n\t\t    ba-hideoninactivity="{{hideoninactivity}}"\n\t\t    ba-rerecordable="{{rerecordable}}"\n\t\t    ba-submittable="{{submittable}}"\n\t\t    ba-fullscreen="{{fullscreensupport && !nofullscreen}}"\n            ba-fullscreened="{{fullscreened}}"\n            ba-source="{{source}}"\n\t\t></ba-{{dyncontrolbar}}>\n\n\t\t<ba-{{dynmessage}}\n\t\t    ba-css="{{cssmessage || css}}"\n\t\t\tba-csscommon="{{csscommon || css}}"\n\t\t\tba-theme-color="{{themecolor}}"\n\t\t    ba-template="{{tmplmessage}}"\n\t\t    ba-show="{{message_active}}"\n\t\t    ba-message="{{message}}"\n\t\t    ba-event:click="message_click"\n\t\t></ba-{{dynmessage}}>\n\n\t\t<ba-{{dyntopmessage}}\n\t\t    ba-css="{{csstopmessage || css}}"\n\t\t\tba-csscommon="{{csscommon || css}}"\n\t\t\tba-theme-color="{{themecolor}}"\n\t\t    ba-template="{{tmpltopmessage}}"\n\t\t    ba-show="{{topmessage}}"\n\t\t    ba-topmessage="{{topmessage}}"\n\t\t></ba-{{dyntopmessage}}>\n\t\t\n\t\t<meta itemprop="caption" content="{{title}}" />\n\t\t<meta itemprop="thumbnailUrl" content="{{poster}}"/>\n\t\t<meta itemprop="contentUrl" content="{{source}}"/>\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-imageviewer",
                    csscommon: "ba-commoncss",
                    iecss: "ba-imageviewer",
                    cssmessage: "",
                    csstopmessage: "",
                    csscontrolbar: "",
                    width: "",
                    height: "",
                    "popup-width": "",
                    "popup-height": "",
                    theme: "",
                    csstheme: "",
                    themecolor: "",
                    dynmessage: "imageviewer-message",
                    dyntopmessage: "imageviewer-topmessage",
                    dyncontrolbar: "imageviewer-controlbar",
                    tmplmessage: "",
                    tmpltopmessage: "",
                    tmplcontrolbar: "",
                    source: "",
                    title: "",
                    fullscreened: !1,
                    visibilityfraction: .8,
                    rerecordable: !1,
                    submittable: !1,
                    popup: !1,
                    nofullscreen: !1,
                    ready: !0,
                    stretch: !1,
                    "popup-stretch": !1,
                    hideoninactivity: !0,
                    topmessage: "",
                    closebuttonvisible: !1,
                    customcaptionvisible: !1,
                    initialoptions: {
                      hideoninactivity: null
                    }
                  },
                  types: {
                    rerecordable: "boolean",
                    ready: "boolean",
                    nofullscreen: "boolean",
                    stretch: "boolean",
                    hideoninactivity: "boolean",
                    popup: "boolean",
                    "popup-stretch": "boolean",
                    "popup-width": "int",
                    "popup-height": "int",
                    fullscreened: "boolean",
                    themecolor: "string",
                    closebuttonvisible: "boolean",
                    customcaptionvisible: "boolean"
                  },
                  computed: {
                    "widthHeightStyles:width,height": function widthHeightStylesWidthHeight() {
                      var e = {},
                        t = this.get("width"),
                        i = this.get("height");
                      return t && (e.width = t + ((t + "").match(/^\d+$/g) ? "px" : "")), i && (e.height = i + ((i + "").match(/^\d+$/g) ? "px" : "")), e;
                    }
                  },
                  events: {
                    "change:source": function changeSource() {
                      var e = this.image();
                      e && (e.src = this.get("source"));
                    }
                  },
                  remove_on_destroy: !0,
                  create: function create() {
                    this.get("theme") && this.set("theme", this.get("theme").toLowerCase()), this.get("theme") in Assets.imageviewerthemes && Objs.iter(Assets.imageviewerthemes[this.get("theme")], function (e, t) {
                      this.isArgumentAttr(t) || this.set(t, e);
                    }, this), this.get("themecolor") || this.set("themecolor", "default"), this.set("ie8", Info.isInternetExplorer() && Info.internetExplorerVersion() < 9), this.set("firefox", Info.isFirefox()), this.set("message", ""), this.set("fullscreensupport", Dom.elementSupportsFullscreen(this.activeElement())), this.set("csssize", "normal"), this.set("controlbar_active", this.get("fullscreensupport") || this.get("submittable") || this.get("rerecordable")), this.set("message_active", !1), this.set("last_activity", Time.now()), this.set("activity_delta", 0), this.__currentStretch = null, this.__imageViewer = {}, this.set("initialoptions", {
                      hideoninactivity: this.get("hideoninactivity")
                    }), this.activeElement().onkeydown = this._keyDownActivity.bind(this, this.activeElement()), this.on("change:stretch", function () {
                      this._updateStretch();
                    }, this), this._timer = new Timers.Timer({
                      context: this,
                      fire: this._timerFire,
                      delay: 100,
                      start: !0
                    });
                  },
                  _keyDownActivity: function _keyDownActivity(e, t) {
                    var i = t.which || t.keyCode;
                    32 !== i && 37 !== i && 38 !== i && 39 !== i && 40 !== i || t.preventDefault(), 32 !== i && 13 !== i && 9 !== i || (this._resetActivity(), this.get("fullscreened") && this.get("hideoninactivity") && this.set("hideoninactivity", !1)), 9 === i && t.shiftKey ? (this._resetActivity(), this._findNextTabStop(e, t, function (e, t) {
                      e.focus();
                    }, -1)) : 9 === i && (this._resetActivity(), this._findNextTabStop(e, t, function (e, t) {
                      e.focus();
                    }));
                  },
                  _findNextTabStop: function _findNextTabStop(e, t, i, r) {
                    var o,
                      a,
                      n,
                      s,
                      x = o = 0,
                      c = r || 1,
                      d = t.target.tabIndex,
                      l = e.querySelectorAll("[tabindex]");
                    if (l = Array.prototype.slice.call(l, 0).filter(function (e) {
                      return (0 < e.clientWidth || 0 < e.clientHeight) && -1 !== e.tabIndex && (x <= e.tabIndex && (x = e.tabIndex), o >= e.tabIndex && (o = e.tabIndex), !0);
                    }), 1 === c && d === x || -1 === r && d === o || 0 === x) 1 < document.querySelectorAll("ba-imageviewer").length && (e.tabIndex = -1, e.blur());else {
                      for (var u = 0; u < l.length; u++) l[u] && (s = (n = l[u].tabIndex) - d, n < o || x < n || Math.sign(s) !== c || (!a || Math.abs(s) < Math.abs(a.tabIndex - d)) && (a = l[u]));
                      a && (t.preventDefault(), i(a, a.tabIndex));
                    }
                  },
                  _afterActivate: function _afterActivate(e) {
                    t._afterActivate.call(this, e), this.image().src = this.get("source");
                  },
                  _resetActivity: function _resetActivity() {
                    this.set("last_activity", Time.now()), this.set("activity_delta", 0);
                  },
                  object_functions: ["rerecord"],
                  functions: {
                    user_activity: function user_activity(e) {
                      this.set("last_activity", Time.now()), this.set("activity_delta", 0);
                    },
                    message_click: function message_click() {
                      this.trigger("message:click");
                    },
                    rerecord: function rerecord() {
                      this.get("rerecordable") && this.trigger("rerecord");
                    },
                    toggle_fullscreen: function toggle_fullscreen() {
                      this.get("fullscreened") && this.__imageViewer.imageWrapper ? this._close_image() : this._open_image();
                    },
                    submit: function submit() {
                      this.get("submittable") && (this.trigger("submit"), this.set("submittable", !1), this.set("rerecordable", !1));
                    },
                    tab_index_move: function tab_index_move(e, t, i) {
                      var r,
                        o,
                        a = e.which || e.keyCode,
                        n = this.activeElement();
                      13 === a || 32 === a ? i ? (o = "[data-selector='" + i + "']", (r = n.querySelector(o)) && Async.eventually(function () {
                        this.trigger("keyboardusecase", n), r.focus({
                          preventScroll: !1
                        });
                      }, this, 100)) : (o = '[data-image="image"]', r = n.querySelector(o), Async.eventually(function () {
                        this.trigger("keyboardusecase", n), r.focus({
                          preventScroll: !0
                        });
                      }, this, 100)) : 9 === a && t && (o = "[data-selector='" + t + "']", (r = n.querySelector(o)) && Async.eventually(function () {
                        this.trigger("keyboardusecase", n), r.focus({
                          preventScroll: !1
                        });
                      }, this, 100));
                    }
                  },
                  destroy: function destroy() {
                    this._timer.destroy(), this.host.destroy(), t.destroy.call(this);
                  },
                  _open_image: function _open_image(e) {
                    var t;
                    this.__imageViewer.counter = 0, this.__imageViewer.imageViewer = document.createElement("div"), this.__imageViewer.imageWrapper = document.createElement("div"), this.__imageViewer.imageWrapper.className = this.get("css") + "-image-viewer-wrapper", this.__imageViewer.overlayElement = document.createElement("div"), this.__imageViewer.overlayElement.className = this.get("css") + "-image-viewer-overlay", this.__imageViewer.image = document.createElement("img"), this.__imageViewer.image.className = this.get("css") + "-image-viewer-expanded", this.__imageViewer.image.src = e || this.get("source"), this.get("customcaptionvisible") && (this.__imageViewer.title = document.createElement("div"), this.__imageViewer.title.className = this.get("css") + "-image-viewer-title", t = document.createTextNode(this.get("title")), this.__imageViewer.title.appendChild(t)), this.get("closebuttonvisible") && (this.__imageViewer.closeButton = document.createElement("div"), this.__imageViewer.closeButton.className = this.get("css") + "-close-button", this.__imageViewer.closeButton.tabIndex = 0, this.__imageViewer.clickEvent = this.auto_destroy(new DomEvents()), this.__imageViewer.clickEvent.on(this.__imageViewer.closeButton, "click", function () {
                      this._close_image();
                    }, this), this.__imageViewer.clickEvent.on(this.__imageViewer.closeButton, "keydown", function () {
                      this._close_image();
                    }, this)), this.__imageViewer.bodyOverlay = document.querySelector("ba-imageviewer"), this.__imageViewer.imageViewer.appendChild(this.__imageViewer.overlayElement), this.__imageViewer.imageViewer.appendChild(this.__imageViewer.image), this.get("customcaptionvisible") && this.__imageViewer.imageViewer.appendChild(this.__imageViewer.title), this.get("closebuttonvisible") && this.__imageViewer.imageViewer.appendChild(this.__imageViewer.closeButton), this.__imageViewer.bodyOverlay.parentNode.insertBefore(this.__imageViewer.imageWrapper, this.__imageViewer.bodyOverlay), this.__imageViewer.imageViewer.style.opacity = 0, this.__imageViewer.imageWrapper.appendChild(this.__imageViewer.imageViewer), this.__imageViewer.fadeInCounter = new Timers.Timer({
                      context: this,
                      fire: this.__fadeIn,
                      delay: 40,
                      start: !0
                    }), this.set("hideoninactivity", !1), this.set("fullscreened", !0);
                  },
                  _close_image: function _close_image() {
                    this.set("fullscreened", !1), this.set("hideoninactivity", this.get("initialoptions").hideoninactivity), this.__imageViewer.fadeInCounter = new Timers.Timer({
                      context: this,
                      fire: this.__fadeOut,
                      delay: 20,
                      start: !0
                    });
                  },
                  __fadeIn: function __fadeIn() {
                    this.__imageViewer.fadeInCounter && (this.__imageViewer.fadeInCounter.destroyed() || (this.__imageViewer.counter < 1.05 ? (this.__imageViewer.imageViewer.style.opacity = this.__imageViewer.counter, this.__imageViewer.counter += .05) : (this.__imageViewer.imageViewer.opacity = 1, this.__imageViewer.fadeInCounter.stop())));
                  },
                  __fadeOut: function __fadeOut() {
                    this.__imageViewer.fadeInCounter && (this.__imageViewer.fadeInCounter.destroyed() || (0 < this.__imageViewer.counter ? (this.__imageViewer.imageViewer.style.opacity = this.__imageViewer.counter, this.__imageViewer.counter -= .05) : (this.__imageViewer.fadeInCounter.stop(), this.__imageViewer.bodyOverlay.parentNode.removeChild(this.__imageViewer.imageWrapper))));
                  },
                  _timerFire: function _timerFire() {
                    if (!this.destroyed()) {
                      try {
                        this.set("activity_delta", Time.now() - this.get("last_activity"));
                      } catch (e) {}
                      try {
                        this._updateStretch();
                      } catch (e) {}
                      try {
                        this._updateCSSSize();
                      } catch (e) {}
                    }
                  },
                  _updateCSSSize: function _updateCSSSize() {
                    var e = Dom.elementDimensions(this.activeElement()).width;
                    this.set("csssize", 400 < e ? "normal" : 300 < e ? "medium" : "small");
                  },
                  image: function image() {
                    return this.activeElement().querySelector("img");
                  },
                  imageHeight: function imageHeight() {
                    var e = this.image().height,
                      t = window.innerHeight || document.body.clientHeight;
                    return !this._image() || t < e ? t : e;
                  },
                  imageWidth: function imageWidth() {
                    var e = window.innerWidth || document.body.clientWidth,
                      t = this.image().width;
                    return !this._image() || e < t ? e : t;
                  },
                  aspectRatio: function aspectRatio() {
                    var e = this.imageHeight();
                    return this.imageWidth() / e;
                  },
                  parentWidth: function parentWidth() {
                    return Dom.elementDimensions(this.activeElement().parentElement).width;
                  },
                  parentHeight: function parentHeight() {
                    return Dom.elementDimensions(this.activeElement().parentElement).height;
                  },
                  parentAspectRatio: function parentAspectRatio() {
                    return this.parentWidth() / this.parentHeight();
                  },
                  _updateStretch: function _updateStretch() {
                    var e,
                      t,
                      i = null;
                    this.get("stretch") && (e = this.aspectRatio(), isFinite(e) && (t = this.parentAspectRatio(), isFinite(t) ? (e < t && (i = "height"), t < e && (i = "width")) : t === Infinity && (i = "height"))), this.__currentStretch !== i && (this.__currentStretch && Dom.elementRemoveClass(this.activeElement(), this.get("css") + "-stretch-" + this.__currentStretch), i && Dom.elementAddClass(this.activeElement(), this.get("css") + "-stretch-" + i)), this.__currentStretch = i;
                  },
                  cloneAttrs: function cloneAttrs() {
                    return Objs.map(this.attrs, function (e, t) {
                      return this.get(t);
                    }, this);
                  },
                  popupAttrs: function popupAttrs() {
                    return {
                      popup: !1,
                      width: this.get("popup-width"),
                      height: this.get("popup-height"),
                      stretch: this.get("popup-stretch")
                    };
                  }
                };
              }, {}).register("ba-imageviewer").registerFunctions({
                css: function (_css16) {
                  function css(_x330) {
                    return _css16.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css16.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                csssize: function (_csssize3) {
                  function csssize(_x331) {
                    return _csssize3.apply(this, arguments);
                  }
                  csssize.toString = function () {
                    return _csssize3.toString();
                  };
                  return csssize;
                }(function (obj) {
                  with (obj) return csssize;
                }),
                iecss: function (_iecss3) {
                  function iecss(_x332) {
                    return _iecss3.apply(this, arguments);
                  }
                  iecss.toString = function () {
                    return _iecss3.toString();
                  };
                  return iecss;
                }(function (obj) {
                  with (obj) return iecss;
                }),
                "ie8 ? 'ie8' : 'noie8'": function ie8Ie8Noie8(obj) {
                  with (obj) return ie8 ? "ie8" : "noie8";
                },
                csstheme: function (_csstheme4) {
                  function csstheme(_x333) {
                    return _csstheme4.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme4.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                "fullscreened ? 'fullscreen' : 'normal'": function fullscreenedFullscreenNormal(obj) {
                  with (obj) return fullscreened ? "fullscreen" : "normal";
                },
                "firefox ? 'firefox' : 'common'": function firefoxFirefoxCommon(obj) {
                  with (obj) return firefox ? "firefox" : "common";
                },
                themecolor: function (_themecolor3) {
                  function themecolor(_x334) {
                    return _themecolor3.apply(this, arguments);
                  }
                  themecolor.toString = function () {
                    return _themecolor3.toString();
                  };
                  return themecolor;
                }(function (obj) {
                  with (obj) return themecolor;
                }),
                "user_activity()": function (_user_activity2) {
                  function user_activity(_x335) {
                    return _user_activity2.apply(this, arguments);
                  }
                  user_activity.toString = function () {
                    return _user_activity2.toString();
                  };
                  return user_activity;
                }(function (obj) {
                  with (obj) return user_activity();
                }),
                "user_activity(true)": function user_activityTrue(obj) {
                  with (obj) return user_activity(!0);
                },
                widthHeightStyles: function (_widthHeightStyles) {
                  function widthHeightStyles(_x336) {
                    return _widthHeightStyles.apply(this, arguments);
                  }
                  widthHeightStyles.toString = function () {
                    return _widthHeightStyles.toString();
                  };
                  return widthHeightStyles;
                }(function (obj) {
                  with (obj) return widthHeightStyles;
                }),
                dyncontrolbar: function (_dyncontrolbar3) {
                  function dyncontrolbar(_x337) {
                    return _dyncontrolbar3.apply(this, arguments);
                  }
                  dyncontrolbar.toString = function () {
                    return _dyncontrolbar3.toString();
                  };
                  return dyncontrolbar;
                }(function (obj) {
                  with (obj) return dyncontrolbar;
                }),
                "csscontrolbar || css": function csscontrolbarCss(obj) {
                  with (obj) return csscontrolbar || css;
                },
                "csscommon || css": function csscommonCss(obj) {
                  with (obj) return csscommon || css;
                },
                tmplcontrolbar: function (_tmplcontrolbar3) {
                  function tmplcontrolbar(_x338) {
                    return _tmplcontrolbar3.apply(this, arguments);
                  }
                  tmplcontrolbar.toString = function () {
                    return _tmplcontrolbar3.toString();
                  };
                  return tmplcontrolbar;
                }(function (obj) {
                  with (obj) return tmplcontrolbar;
                }),
                controlbar_active: function (_controlbar_active2) {
                  function controlbar_active(_x339) {
                    return _controlbar_active2.apply(this, arguments);
                  }
                  controlbar_active.toString = function () {
                    return _controlbar_active2.toString();
                  };
                  return controlbar_active;
                }(function (obj) {
                  with (obj) return controlbar_active;
                }),
                tabindex: function (_tabindex2) {
                  function tabindex(_x340) {
                    return _tabindex2.apply(this, arguments);
                  }
                  tabindex.toString = function () {
                    return _tabindex2.toString();
                  };
                  return tabindex;
                }(function (obj) {
                  with (obj) return tabindex;
                }),
                title: function (_title4) {
                  function title(_x341) {
                    return _title4.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title4.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                activity_delta: function (_activity_delta2) {
                  function activity_delta(_x342) {
                    return _activity_delta2.apply(this, arguments);
                  }
                  activity_delta.toString = function () {
                    return _activity_delta2.toString();
                  };
                  return activity_delta;
                }(function (obj) {
                  with (obj) return activity_delta;
                }),
                hideoninactivity: function (_hideoninactivity2) {
                  function hideoninactivity(_x343) {
                    return _hideoninactivity2.apply(this, arguments);
                  }
                  hideoninactivity.toString = function () {
                    return _hideoninactivity2.toString();
                  };
                  return hideoninactivity;
                }(function (obj) {
                  with (obj) return hideoninactivity;
                }),
                rerecordable: function (_rerecordable4) {
                  function rerecordable(_x344) {
                    return _rerecordable4.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable4.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                submittable: function (_submittable4) {
                  function submittable(_x345) {
                    return _submittable4.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable4.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "fullscreensupport && !nofullscreen": function fullscreensupportNofullscreen(obj) {
                  with (obj) return fullscreensupport && !nofullscreen;
                },
                fullscreened: function (_fullscreened2) {
                  function fullscreened(_x346) {
                    return _fullscreened2.apply(this, arguments);
                  }
                  fullscreened.toString = function () {
                    return _fullscreened2.toString();
                  };
                  return fullscreened;
                }(function (obj) {
                  with (obj) return fullscreened;
                }),
                source: function (_source2) {
                  function source(_x347) {
                    return _source2.apply(this, arguments);
                  }
                  source.toString = function () {
                    return _source2.toString();
                  };
                  return source;
                }(function (obj) {
                  with (obj) return source;
                }),
                dynmessage: function (_dynmessage3) {
                  function dynmessage(_x348) {
                    return _dynmessage3.apply(this, arguments);
                  }
                  dynmessage.toString = function () {
                    return _dynmessage3.toString();
                  };
                  return dynmessage;
                }(function (obj) {
                  with (obj) return dynmessage;
                }),
                "cssmessage || css": function cssmessageCss(obj) {
                  with (obj) return cssmessage || css;
                },
                tmplmessage: function (_tmplmessage3) {
                  function tmplmessage(_x349) {
                    return _tmplmessage3.apply(this, arguments);
                  }
                  tmplmessage.toString = function () {
                    return _tmplmessage3.toString();
                  };
                  return tmplmessage;
                }(function (obj) {
                  with (obj) return tmplmessage;
                }),
                message_active: function (_message_active3) {
                  function message_active(_x350) {
                    return _message_active3.apply(this, arguments);
                  }
                  message_active.toString = function () {
                    return _message_active3.toString();
                  };
                  return message_active;
                }(function (obj) {
                  with (obj) return message_active;
                }),
                message: function (_message6) {
                  function message(_x351) {
                    return _message6.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message6.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message;
                }),
                dyntopmessage: function (_dyntopmessage3) {
                  function dyntopmessage(_x352) {
                    return _dyntopmessage3.apply(this, arguments);
                  }
                  dyntopmessage.toString = function () {
                    return _dyntopmessage3.toString();
                  };
                  return dyntopmessage;
                }(function (obj) {
                  with (obj) return dyntopmessage;
                }),
                "csstopmessage || css": function csstopmessageCss(obj) {
                  with (obj) return csstopmessage || css;
                },
                tmpltopmessage: function (_tmpltopmessage3) {
                  function tmpltopmessage(_x353) {
                    return _tmpltopmessage3.apply(this, arguments);
                  }
                  tmpltopmessage.toString = function () {
                    return _tmpltopmessage3.toString();
                  };
                  return tmpltopmessage;
                }(function (obj) {
                  with (obj) return tmpltopmessage;
                }),
                topmessage: function (_topmessage5) {
                  function topmessage(_x354) {
                    return _topmessage5.apply(this, arguments);
                  }
                  topmessage.toString = function () {
                    return _topmessage5.toString();
                  };
                  return topmessage;
                }(function (obj) {
                  with (obj) return topmessage;
                }),
                poster: function (_poster) {
                  function poster(_x355) {
                    return _poster.apply(this, arguments);
                  }
                  poster.toString = function () {
                    return _poster.toString();
                  };
                  return poster;
                }(function (obj) {
                  with (obj) return poster;
                })
              }).attachStringTable(Assets.strings).addStrings({
                "image-error": "An error occurred, please try again later. Click to retry."
              });
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.State", ["base:States.State", "base:Events.ListenMixin", "base:Objs"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, [t, {
                dynamics: [],
                _start: function _start() {
                  this.dyn = this.host.dynamic, i.iter(i.extend({
                    message: !1,
                    chooser: !1,
                    topmessage: !1,
                    controlbar: !1,
                    loader: !1
                  }, i.objectify(this.dynamics)), function (e, t) {
                    this.dyn.set(t + "_active", e);
                  }, this), this.dyn.set("playertopmessage", ""), this.dyn.set("message_links", null), this.dyn._accessing_camera = !1, this._started();
                },
                _started: function _started() {},
                record: function record() {
                  this.dyn.set("autorecord", !0);
                },
                rerecord: function rerecord() {},
                selectRecord: function selectRecord() {},
                selectUpload: function selectUpload(e) {}
              }]);
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.FatalError", ["module:ImageCapture.Dynamics.RecorderStates.State", "browser:Info", "base:Timers.Timer"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, {
                dynamics: ["message"],
                _locals: ["message", "retry"],
                _started: function _started() {
                  this.dyn.set("message", this._message || this.dyn.string("recorder-error")), this.dyn.set("shortMessage", this.dyn.get("message").length < 30), this.listenOn(this.dyn, "message-click", function () {
                    this._retry && this.next(this._retry);
                  });
                }
              });
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.Initial", ["module:ImageCapture.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                _started: function _started() {
                  this.dyn.set("is_initial_state", !0), this.dyn.set("verified", !1), this.dyn.set("playbacksource", null), this.dyn.set("player_active", !1), this.dyn._imageFileName = null, this.dyn._imageFile = null, this.dyn._imageFilePlaybackable = !1, this.dyn._initializeUploader(), this.dyn.get("recordermode") ? this.dyn.get("autorecord") || this.dyn.get("skipinitial") ? this.eventualNext("RequiredSoftwareCheck") : this.next("Chooser") : this.dyn.get("image") ? this.next("Player") : (console.warn("recordermode:false requires an existing video to be present and provided."), this.dyn.set("recordermode", !0));
                },
                _end: function _end() {
                  this.dyn.set("is_initial_state", !1);
                }
              });
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.Player", ["module:ImageCapture.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                rerecord: function rerecord() {
                  this.dyn.trigger("rerecord"), this.dyn.set("recordermode", !0), this.next("Initial");
                },
                _started: function _started() {
                  this.dyn.set("player_active", !0);
                },
                _end: function _end() {
                  this.dyn.set("player_active", !1);
                }
              });
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.Chooser", ["module:ImageCapture.Dynamics.RecorderStates.State", "base:Strings", "browser:Info", "media:Player.Support"], function (t, s, x, c, i) {
              return t.extend({
                scoped: i
              }, {
                dynamics: ["chooser"],
                _started: function _started() {
                  this.listenOn(this.dyn, "change:orientation change:currentorientation", function () {
                    var e = this.dyn.get("orientation"),
                      t = this.dyn.get("currentorientation"),
                      i = e && e !== t;
                    i && this.dyn.set("message", this.dyn.string("orientation-" + e + "-required")), this.dyn.set("message_active", i), this.dyn.set("chooser_active", !i);
                  }, this, {
                    initcall: !0
                  });
                },
                record: function record() {
                  this.dyn.set("autorecord", !0), this.selectRecord();
                },
                selectRecord: function selectRecord() {
                  this.dyn.set("record_media", "camera"), this.next("RequiredSoftwareCheck");
                },
                selectUpload: function selectUpload(t) {
                  if (!(x.isMobile() && x.isAndroid() && x.isCordova())) {
                    if (this.dyn.get("allowedextensions")) {
                      var i = (t.files[0].name || "").toLowerCase(),
                        r = !1;
                      if (this.dyn.get("allowedextensions").forEach(function (e) {
                        s.ends_with(i, "." + e.toLowerCase()) && (r = !0);
                      }, this), !r) return void this.next("FatalError", {
                        message: this.dyn.string("unsupported_image_type").replace("%s", this.dyn.get("allowedextensions").join(" / ")),
                        retry: "Chooser"
                      });
                    }
                    if (this.dyn.get("filesizelimit") && t.files && 0 < t.files.length && t.files[0].size && t.files[0].size > this.dyn.get("filesizelimit")) {
                      var o = "KB",
                        a = Math.round(t.files[0].size / 1e3),
                        n = Math.round(this.dyn.get("filesizelimit") / 1e3);
                      return 999 < a && (o = "MB", a = Math.round(a / 1e3), n = Math.round(n / 1e3)), void this.next("FatalError", {
                        message: this.dyn.string("image_file_too_large").replace("%s", a + o + " / " + n + o),
                        retry: "Chooser"
                      });
                    }
                  }
                  try {
                    c.imageFileInfo(t.files[0]).success(function (e) {
                      e.width && this.dyn.get("minuploadingwidth") && this.dyn.get("minuploadingwidth") > e.width || e.width && this.dyn.get("maxuploadingwidth") && this.dyn.get("maxuploadingwidth") < e.width || e.height && this.dyn.get("minuploadingheight") && this.dyn.get("minuploadingheight") > e.height || e.height && this.dyn.get("maxuploadingheight") && this.dyn.get("maxuploadingheight") < e.height ? this.next("FatalError", {
                        message: this.dyn.string("resolution-constraint-error"),
                        retry: "Chooser"
                      }) : (this.dyn._imageFilePlaybackable = !0, this._uploadFile(t));
                    }, this).error(function () {
                      this._uploadFile(t);
                    }, this);
                  } catch (e) {
                    this._uploadFile(t);
                  }
                },
                _uploadFile: function _uploadFile(t) {
                  this.dyn.set("creation-type", x.isMobile() ? "mobile" : "upload");
                  try {
                    this.dyn._imageFileName = t.files[0].name, this.dyn._imageFile = t.files[0];
                  } catch (e) {}
                  this.dyn._prepareRecording().success(function () {
                    this.dyn.trigger("upload_selected", t), this.dyn._uploadImageFile(t), this.next("Uploading");
                  }, this).error(function (e) {
                    this.next("FatalError", {
                      message: e,
                      retry: "Chooser"
                    });
                  }, this);
                }
              });
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.RequiredSoftwareCheck", ["module:ImageCapture.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.dyn.set("settingsvisible", !1), this.dyn.set("recordvisible", !1), this.dyn.set("rerecordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("controlbarlabel", ""), this.dyn.set("loaderlabel", ""), this.listenOn(this.dyn, "error", function (e) {
                    this.next("FatalError", {
                      message: this.dyn.string("attach-error"),
                      retry: "Initial"
                    });
                  }, this), this.dyn._attachRecorder(), this.dyn && (this.dyn.on("message-link-click", function (e) {
                    e.execute(), this.next("RequiredSoftwareWait");
                  }, this), this.dyn._softwareDependencies().error(function (e) {
                    this.dyn.set("message_links", e), this.dyn.set("loader_active", !1), this.dyn.set("message_active", !0), this.dyn.set("message", this.dyn.string("software-required"));
                  }, this).success(function () {
                    this.next("CameraAccess");
                  }, this));
                }
              });
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.RequiredSoftwareWait", ["module:ImageCapture.Dynamics.RecorderStates.State", "base:Promise", "browser:Dom"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, {
                dynamics: ["message"],
                _started: function _started() {
                  this.dyn.set("settingsvisible", !1), this.dyn.set("recordvisible", !1), this.dyn.set("rerecordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("controlbarlabel", ""), this.dyn.set("loaderlabel", ""), this.dyn.set("message", this.dyn.string("software-waiting")), t.resilience(function () {
                    return i.isTabHidden() ? t.error("Not ready") : this.dyn._softwareDependencies();
                  }, this, 120, [], 1e3).success(function () {
                    this.next("CameraAccess");
                  }, this).error(function () {
                    this.next("RequiredSoftwareCheck");
                  }, this), this.dyn.on("message-click", function () {
                    this.next("RequiredSoftwareCheck");
                  }, this);
                }
              });
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.CameraAccess", ["module:ImageCapture.Dynamics.RecorderStates.State", "base:Timers.Timer"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.dyn.set("settingsvisible", !0), this.dyn.set("recordvisible", !0), this.dyn.set("rerecordvisible", !1), this.dyn.set("controlbarlabel", ""), this.dyn.set("loaderlabel", ""), this.listenOn(this.dyn, "bound", function () {
                    this.dyn.set("creation-type", "webrtc");
                    var e = this.auto_destroy(new t({
                      start: !0,
                      delay: 100,
                      context: this,
                      fire: function fire() {
                        .01 <= this.dyn.blankLevel() && .01 <= this.dyn.deltaCoefficient() && (e.stop(), this.next("CameraHasAccess"));
                      }
                    }));
                  }, this), this.listenOn(this.dyn, "error", function (e) {
                    this.next("FatalError", {
                      message: this.dyn.string("attach-error"),
                      retry: "Initial"
                    });
                  }, this), this.listenOn(this.dyn, "access_forbidden", function () {
                    this.next("FatalError", {
                      message: this.dyn.string("access-forbidden"),
                      retry: "Initial"
                    });
                  }, this), this.dyn._bindMedia();
                }
              });
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.CameraHasAccess", ["module:ImageCapture.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["topmessage", "controlbar"],
                _started: function _started() {
                  this.dyn.trigger("ready_to_record"), this._preparePromise = null, 0 < this.dyn.get("countdown") && this.dyn.recorder && this.dyn.recorder.recordDelay(this.dyn.get("uploadoptions")) > 1e3 * this.dyn.get("countdown") && (this._preparePromise = this.dyn._prepareRecording()), this.dyn.set("hovermessage", ""), this.dyn.set("topmessage", ""), this.dyn.set("settingsvisible", !0), this.dyn.set("recordvisible", !0), this.dyn.set("rerecordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("controlbarlabel", ""), this.dyn.get("autorecord") && this.next("RecordPrepare", {
                    preparePromise: this._preparePromise
                  });
                },
                record: function record() {
                  this.dyn.get("autorecord") || this.next("RecordPrepare", {
                    preparePromise: this._preparePromise
                  });
                }
              });
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.RecordPrepare", ["module:ImageCapture.Dynamics.RecorderStates.State", "base:Timers.Timer", "base:Time"], function (e, t, c, i) {
              return e.extend({
                scoped: i
              }, {
                dynamics: ["loader"],
                _locals: ["preparePromise"],
                _started: function _started() {
                  this.dyn.set("message", ""), this.dyn.set("loaderlabel", "");
                  var i = !1;
                  this.dyn._accessing_camera = !0, this._preparePromise = this._preparePromise || this.dyn._prepareRecording();
                  var r,
                    o,
                    a,
                    n,
                    s,
                    e = this.dyn.get("countdown") ? 1e3 * this.dyn.get("countdown") : 0,
                    x = this.dyn.recorder.recordDelay(this.dyn.get("uploadoptions")) || 0;
                  e ? (r = 1e3, o = 0, a = c.now(), n = a + Math.max(x, e), e < x ? (o = Math.min(500, x - e), r = (x - o) / e * 1e3) : this.dyn.set("loaderlabel", this.dyn.get("countdown")), s = new t({
                    context: this,
                    delay: 50,
                    fire: function fire() {
                      var e = c.now(),
                        t = Math.max(0, n - e);
                      o + a < e && (this.dyn.set("loaderlabel", "" + Math.ceil((t - o) / r)), this.dyn.trigger("countdown", Math.round((t - o) / r * 1e3))), n <= e && (this.dyn.set("loaderlabel", ""), s.stop()), t <= x && !i && (i = !0, this._startRecording());
                    }
                  }), this.auto_destroy(s)) : this._startRecording();
                },
                record: function record() {
                  this._startRecording();
                },
                _startRecording: function _startRecording() {
                  this.next("Recording");
                }
              });
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.Recording", ["module:ImageCapture.Dynamics.RecorderStates.State", "base:Timers.Timer", "base:Time", "base:TimeFormat", "base:Async"], function (e, t, i, r, o, a) {
              return e.extend({
                scoped: a
              }, {
                dynamics: ["topmessage", "controlbar"],
                _started: function _started() {
                  this.dyn.set("hovermessage", ""), this.dyn.set("topmessage", ""), this.dyn._accessing_camera = !0, this.dyn.trigger("recording"), this.dyn.set("settingsvisible", !1), this.dyn.set("rerecordvisible", !1), this.dyn.set("recordvisible", !1), this.dyn._captureImage(), this.dyn._uploadCapture(), this.dyn._unbindMedia(), this.next("Uploading");
                }
              });
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.Uploading", ["module:ImageCapture.Dynamics.RecorderStates.State", "base:Time", "base:Async", "base:Objs"], function (e, t, i, r, o) {
              return e.extend({
                scoped: o
              }, {
                dynamics: ["loader", "message"],
                _started: function _started() {
                  this.dyn.set("cancancel", !0), this.dyn.set("skipinitial", this.dyn.get("skipinitial") || this.dyn.get("skipinitialonrerecord")), this.dyn.set("settingsvisible", !1), this.dyn.set("recordvisible", !1), this.dyn.set("loadlabel", ""), this.dyn.set("controlbarlabel", ""), this.dyn.trigger("uploading"), this.dyn.set("rerecordvisible", this.dyn.get("early-rerecord")), this.dyn.get("early-rerecord") && this.dyn.set("controlbar_active", !0), this.dyn.set("hovermessage", ""), this.dyn.set("topmessage", ""), this.dyn.set("message", this.dyn.string("uploading")), this.dyn.set("playertopmessage", this.dyn.get("message"));
                  var e = this.dyn._dataUploader;
                  this.listenOn(e, "success", function () {
                    i.eventually(function () {
                      this.destroyed() || (this._finished(), this.next("Verifying"));
                    }, this);
                  }), this.listenOn(e, "error", function (e) {
                    var i = this.dyn.string("uploading-failed");
                    try {
                      e.forEach(function (e) {
                        for (var t in e) this.dyn.string("upload-error-" + t) && (i = this.dyn.string("upload-error-" + t));
                      }, this);
                    } catch (t) {}
                    this.dyn.set("player_active", !1), this.next("FatalError", {
                      message: i,
                      retry: this.dyn.recorderAttached() ? "Uploading" : "Initial"
                    });
                  }), this.listenOn(e, "progress", function (e, t) {
                    var i;
                    this.dyn.trigger("upload_progress", e, t), 0 !== t && 0 < t && 0 <= e && (i = Math.min(100, Math.round(e / t * 100)), isNaN(i) || (this.dyn.set("message", this.dyn.string("uploading") + ": " + i + "%"), this.dyn.set("playertopmessage", this.dyn.get("message"))));
                  }), this.dyn.get("localplayback") && (this.dyn.recorder && this.dyn.recorder.supportsLocalPlayback() || this.dyn._imageFilePlaybackable) && (this.dyn.recorder && this.dyn.recorder.supportsLocalPlayback() ? this.dyn.set("playbacksource", this.dyn.recorder.localPlaybackSource()) : this.dyn.set("playbacksource", (window.URL || window.webkitURL).createObjectURL(this.dyn._imageFile)), this.dyn.set("loader_active", !1), this.dyn.set("message_active", !1), this.dyn.set("player_active", !0)), this.dyn.set("start-upload-time", t.now()), e.reset(), e.upload();
                },
                rerecord: function rerecord() {
                  this.dyn._detachRecorder(), this.dyn.trigger("rerecord"), this.dyn.set("recordermode", !0), this.next("Initial");
                },
                _finished: function _finished() {
                  this.dyn.set("cancancel", !1), this.dyn.trigger("uploaded"), this.dyn.set("end-upload-time", t.now());
                }
              });
            }), Scoped.define("module:ImageCapture.Dynamics.RecorderStates.Verifying", ["module:ImageCapture.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["loader", "message"],
                _started: function _started() {
                  this.dyn.set("loadlabel", ""), this.dyn.trigger("verifying"), this.dyn.set("message", this.dyn.string("verifying") + "..."), this.dyn.set("playertopmessage", this.dyn.get("message")), this.dyn.get("localplayback") && (this.dyn.recorder && this.dyn.recorder.supportsLocalPlayback() || this.dyn._imageFilePlaybackable) ? (this.dyn.set("loader_active", !1), this.dyn.set("message_active", !1)) : (this.dyn.set("rerecordvisible", this.dyn.get("early-rerecord")), this.dyn.get("early-rerecord") && this.dyn.set("controlbar_active", !0)), this.dyn._verifyRecording().success(function () {
                    this.dyn.trigger("verified"), this.dyn._detachRecorder(), this.dyn.get("recordings") && this.dyn.set("recordings", this.dyn.get("recordings") - 1), this.dyn.set("message", ""), this.dyn.set("playertopmessage", ""), this.dyn.set("verified", !0), this.next("Player");
                  }, this).error(function () {
                    this.dyn.set("player_active", !1), this.next("FatalError", {
                      message: this.dyn.string("verifying-failed"),
                      retry: this.dyn.recorderAttached() ? "Verifying" : "Initial"
                    });
                  }, this);
                },
                rerecord: function rerecord() {
                  this.dyn._detachRecorder(), this.dyn.trigger("rerecord"), this.dyn.set("recordermode", !0), this.next("Initial");
                }
              });
            }), Scoped.define("module:ImageCapture.Dynamics.Chooser", ["dynamics:Dynamic", "module:Assets", "browser:Info"], ["dynamics:Partials.ClickPartial", "dynamics:Partials.IfPartial"], function (Class, Assets, Info, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<div class="{{css}}-chooser-container">\n\t<div class="{{css}}-chooser-button-container">\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t tabindex="0" class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t     ba-click="{{click_action(action)}}"\n\t\t\t>\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   />\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n',
                  attrs: {
                    css: "ba-imagecapture",
                    allowrecord: !0,
                    allowupload: !0,
                    primaryrecord: !0,
                    recordviafilecapture: !1,
                    allowcustomupload: !0,
                    allowedextensions: null
                  },
                  types: {
                    allowedextensions: "array",
                    recordviafilecapture: "boolean"
                  },
                  collections: ["actions"],
                  create: function create() {
                    var i = "";
                    this.get("allowedextensions") && 0 < this.get("allowedextensions").length ? (Info.isEdge() || Info.isChrome() || Info.isOpera() || Info.isFirefox() && 42 <= Info.firefoxVersion() || Info.isInternetExplorer() && 10 <= Info.internetExplorerVersion()) && (i = "." + this.get("allowedextensions").join(",.")) : this.get("allowcustomupload") || (i = "image/*,image/png");
                    var e = [];
                    this.get("primaryrecord") ? (this.get("allowrecord") && e.push("record"), this.get("allowupload") && e.push("upload")) : (this.get("allowupload") && e.push("upload"), this.get("allowrecord") && e.push("record"));
                    var r = this.get("actions");
                    e.forEach(function (e, t) {
                      switch (e) {
                        case "record":
                          r.add({
                            type: "record",
                            index: t,
                            icon: "videocam",
                            label: this.string("capture-image"),
                            select: Info.isMobile() && !(Info.isAndroid() && Info.isCordova()) && this.get("recordviafilecapture"),
                            capture: !0,
                            accept: "image/*,image/png;capture=camcorder"
                          });
                          break;
                        case "upload":
                          r.add({
                            type: "upload",
                            index: t,
                            icon: "upload",
                            label: this.string("upload-image"),
                            select: !(Info.isiOS() && Info.isCordova()),
                            accept: !Info.isMobile() || Info.isAndroid() && Info.isCordova() ? i : "image/*,image/png"
                          });
                      }
                    }, this);
                  },
                  functions: {
                    click_action: function click_action(e) {
                      var t;
                      e.get("select") || (Info.isMobile() && Info.isCordova() ? (t = this, Info.isAndroid() ? navigator.device.capture.captureImage(function (e) {
                        t.trigger("upload", e[0]);
                      }, function (e) {}, {
                        limit: 1
                      }) : Info.isiOS() && navigator.camera.getPicture(function (e) {
                        t.trigger("upload", {
                          localURL: e,
                          fullPath: e
                        });
                      }, function (e) {}, {
                        destinationType: Camera.DestinationType.FILE_URI,
                        sourceType: Camera.PictureSourceType.PHOTOLIBRARY,
                        mediaType: Camera.MediaType.IMAGE
                      })) : this.trigger("record"));
                    },
                    select_file_action: function select_file_action(e, t) {
                      e.get("select") && this.trigger("upload", t[0].target);
                    }
                  }
                };
              }).registerFunctions({
                css: function (_css17) {
                  function css(_x356) {
                    return _css17.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css17.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                actions: function (_actions2) {
                  function actions(_x357) {
                    return _actions2.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions2.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                csscommon: function (_csscommon11) {
                  function csscommon(_x358) {
                    return _csscommon11.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon11.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                }
              }).register("ba-imagecapture-chooser").attachStringTable(Assets.strings).addStrings({
                "image-capture": "Capture Image",
                "upload-image": "Upload Image"
              });
            }), Scoped.define("module:ImageCapture.Dynamics.Controlbar", ["dynamics:Dynamic", "module:Assets", "base:Timers.Timer"], ["dynamics:Partials.ShowPartial", "dynamics:Partials.RepeatPartial"], function (Class, Assets, Timer, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<div class="{{css}}-dashboard">\n\t<div class="{{css}}-backbar"></div>\n\t<div data-selector="recorder-settings" class="{{css}}-settings" ba-show="{{settingsvisible && settingsopen}}">\n\t\t<div class="{{css}}-settings-backbar"></div>\n\t\t<div data-selector="settings-list-front" class="{{css}}-settings-front">\n\t\t\t<ul data-selector="camera-settings" ba-repeat="{{camera :: cameras}}">\n\t\t\t\t<li>\n\t\t\t\t\t<input tabindex="0"\n\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t   type=\'radio\' name=\'camera\' value="{{selectedcamera == camera.id}}" onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t/>\n\t\t\t\t\t<span></span>\n\t\t\t\t\t<label tabindex="0"\n\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t{{camera.label}}\n\t\t\t\t\t</label>\n\t\t\t\t </li>\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n        <div class="{{css}}-leftbutton-container" ba-show="{{settingsvisible}}">\n            <div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{settingsopen=!settingsopen}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="record-button-icon-cog" class="{{css}}-button-inner {{css}}-button-{{settingsopen ? \'selected\' : \'unselected\'}}"\n                 onclick="{{settingsopen=!settingsopen}}"\n                 onmouseenter="{{hover(string(\'settings\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                <i class="{{csscommon}}-icon-cog"></i>\n            </div>\n        </div>\n\n        <div class="{{css}}-lefticon-container" ba-show="{{settingsvisible}}">\n            <div data-selector="record-button-icon-videocam" class="{{csscommon}}-icon-inner"\n                 onmouseenter="{{hover(string(camerahealthy ? \'camerahealthy\' : \'cameraunhealthy\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                <i class="{{csscommon}}-icon-videocam {{csscommon}}-icon-state-{{camerahealthy ? \'good\' : \'bad\' }}"></i>\n            </div>\n        </div>\n\n        <div class="{{css}}-label-container" ba-show="{{controlbarlabel}}">\n        \t<div data-selector="record-label-block" class="{{css}}-label-label">\n        \t\t{{controlbarlabel}}\n        \t</div>\n        </div>\n\n        <div class="{{css}}-rightbutton-container" ba-show="{{recordvisible}}">\n        \t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="record-primary-button" class="{{css}}-button-primary"\n                 onclick="{{record()}}"\n                 onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n        \t\t{{string(\'record\')}}\n        \t</div>\n        </div>\n\n        <div class="{{css}}-rightbutton-container" ba-show="{{rerecordvisible}}">\n        \t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="rerecord-primary-button" class="{{css}}-button-primary"\n                 onclick="{{rerecord()}}"\n                 onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n        \t\t{{string(\'rerecord\')}}\n        \t</div>\n        </div>\n\n\t\t<div class="{{css}}-rightbutton-container" ba-show="{{cancelvisible}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="cancel-primary-button" class="{{css}}-button-primary"\n\t\t\t\t onclick="{{cancel()}}"\n\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t>\n\t\t\t\t{{string(\'cancel\')}}\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n</div>\n',
                  attrs: {
                    css: "ba-imagecapture",
                    hovermessage: ""
                  },
                  functions: {
                    selectCamera: function selectCamera(e) {
                      this.trigger("select-camera", e);
                    },
                    hover: function hover(e) {
                      this.set("hovermessage", e);
                    },
                    unhover: function unhover() {
                      this.set("hovermessage", "");
                    },
                    record: function record() {
                      this.trigger("invoke-record");
                    },
                    rerecord: function rerecord() {
                      this.trigger("invoke-rerecord");
                    },
                    cancel: function cancel() {
                      this.trigger("invoke-cancel");
                    }
                  }
                };
              }).register("ba-imagecapture-controlbar").registerFunctions({
                css: function (_css18) {
                  function css(_x359) {
                    return _css18.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css18.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "settingsvisible && settingsopen": function settingsvisibleSettingsopen(obj) {
                  with (obj) return settingsvisible && settingsopen;
                },
                cameras: function (_cameras3) {
                  function cameras(_x360) {
                    return _cameras3.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras3.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "selectCamera(camera.id)": function selectCameraCameraId(obj) {
                  with (obj) return selectCamera(camera.id);
                },
                "selectedcamera == camera.id": function selectedcameraCameraId(obj) {
                  with (obj) return selectedcamera == camera.id;
                },
                "camera.label": function cameraLabel(obj) {
                  with (obj) return camera.label;
                },
                settingsvisible: function (_settingsvisible3) {
                  function settingsvisible(_x361) {
                    return _settingsvisible3.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible3.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                "unhover()": function (_unhover2) {
                  function unhover(_x362) {
                    return _unhover2.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover2.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                csscommon: function (_csscommon12) {
                  function csscommon(_x363) {
                    return _csscommon12.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon12.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "hover(string(camerahealthy ? 'camerahealthy' : 'cameraunhealthy'))": function hoverStringCamerahealthyCamerahealthyCameraunhealthy(obj) {
                  with (obj) return hover(string(camerahealthy ? "camerahealthy" : "cameraunhealthy"));
                },
                "camerahealthy ? 'good' : 'bad'": function camerahealthyGoodBad(obj) {
                  with (obj) return camerahealthy ? "good" : "bad";
                },
                controlbarlabel: function (_controlbarlabel3) {
                  function controlbarlabel(_x364) {
                    return _controlbarlabel3.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel3.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                recordvisible: function (_recordvisible3) {
                  function recordvisible(_x365) {
                    return _recordvisible3.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible3.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record2) {
                  function record(_x366) {
                    return _record2.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record2.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                rerecordvisible: function (_rerecordvisible3) {
                  function rerecordvisible(_x367) {
                    return _rerecordvisible3.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible3.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord5) {
                  function rerecord(_x368) {
                    return _rerecord5.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord5.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible2) {
                  function cancelvisible(_x369) {
                    return _cancelvisible2.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible2.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel2) {
                  function cancel(_x370) {
                    return _cancel2.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel2.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                }
              }).attachStringTable(Assets.strings).addStrings({
                settings: "Settings",
                camerahealthy: "Lighting is good",
                cameraunhealthy: "Lighting is not optimal",
                record: "Capture",
                "record-tooltip": "Click here to capture.",
                rerecord: "Redo",
                "rerecord-tooltip": "Click here to redo.",
                cancel: "Cancel",
                "cancel-tooltip": "Click here to cancel."
              });
            }), Scoped.define("module:ImageCapture.Dynamics.Faceoutline", ["dynamics:Dynamic"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  template: '<svg viewBox="0 0 301 171" style="width:100%; height:100%; position: absolute; top: 0; left: 0">\n    <g>\n        <path fill="none" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-dasharray="3.0228,3.0228" d="M198.5,79.831c0,40.542-22.752,78.579-47.5,78.579c-24.749,0-47.5-38.036-47.5-78.579c0-40.543,17.028-68.24,47.5-68.24C185.057,11.591,198.5,39.288,198.5,79.831z"></path>\n    </g>\n</svg>'
                };
              }).registerFunctions({}).register("ba-imagecapture-faceoutline");
            }), Scoped.define("module:ImageCapture.Dynamics.Loader", ["dynamics:Dynamic", "module:Assets"], ["dynamics:Partials.ShowPartial"], function (Class, Assets, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div class="{{css}}-loader-container">\n    <div data-selector="recorder-loader-block" class="{{css}}-loader-loader" title="{{tooltip || \'\'}}">\n    </div>\n</div>\n<div data-selector="recorder-loader-label-container" class="{{css}}-loader-label" ba-show="{{label}}">\n\t{{label}}\n</div>\n',
                  attrs: {
                    css: "ba-imagecapture",
                    tooltip: "",
                    label: "",
                    message: "",
                    hovermessage: ""
                  }
                };
              }).registerFunctions({
                css: function (_css19) {
                  function css(_x371) {
                    return _css19.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css19.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "tooltip || ''": function (_tooltip2) {
                  function tooltip(_x372) {
                    return _tooltip2.apply(this, arguments);
                  }
                  tooltip.toString = function () {
                    return _tooltip2.toString();
                  };
                  return tooltip;
                }(function (obj) {
                  with (obj) return tooltip || "";
                }),
                label: function (_label2) {
                  function label(_x373) {
                    return _label2.apply(this, arguments);
                  }
                  label.toString = function () {
                    return _label2.toString();
                  };
                  return label;
                }(function (obj) {
                  with (obj) return label;
                })
              }).register("ba-imagecapture-loader").attachStringTable(Assets.strings).addStrings({});
            }), Scoped.define("module:ImageCapture.Dynamics.Message", ["dynamics:Dynamic"], ["dynamics:Partials.ClickPartial"], function (Class, Templates, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div data-selector="recorder-message-container" class="{{css}}-message-container" ba-click="{{click()}}">\n    <div data-selector="recorder-message-block" class=\'{{css}}-message-message\'>\n        <p>\n            {{message || ""}}\n        </p>\n        <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n            <li>\n                <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                    {{link.title}}\n                </a>\n            </li>\n        </ul>\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-imagecapture",
                    message: "",
                    links: null
                  },
                  functions: {
                    click: function click() {
                      this.trigger("click");
                    },
                    linkClick: function linkClick(e) {
                      this.trigger("link", e);
                    }
                  }
                };
              }).registerFunctions({
                css: function (_css20) {
                  function css(_x374) {
                    return _css20.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css20.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click4) {
                  function click(_x375) {
                    return _click4.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click4.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                'message || ""': function (_message7) {
                  function message(_x376) {
                    return _message7.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message7.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links2) {
                  function links(_x377) {
                    return _links2.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links2.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }).register("ba-imagecapture-message");
            }), Scoped.define("module:ImageCapture.Dynamics.Topmessage", ["dynamics:Dynamic"], function (Class, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: "\n<div class=\"{{css}}-topmessage-container\">\n    <div class='{{css}}-topmessage-background'>\n    </div>\n    <div data-selector=\"recorder-topmessage-block\" class='{{css}}-topmessage-message'>\n        {{topmessage}}\n    </div>\n</div>\n",
                  attrs: {
                    css: "ba-imagecapture",
                    topmessage: ""
                  }
                };
              }).registerFunctions({
                css: function (_css21) {
                  function css(_x378) {
                    return _css21.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css21.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                topmessage: function (_topmessage6) {
                  function topmessage(_x379) {
                    return _topmessage6.apply(this, arguments);
                  }
                  topmessage.toString = function () {
                    return _topmessage6.toString();
                  };
                  return topmessage;
                }(function (obj) {
                  with (obj) return topmessage;
                })
              }).register("ba-imagecapture-topmessage");
            }), Scoped.define("module:ImageCapture.Dynamics.Recorder", ["dynamics:Dynamic", "module:Assets", "browser:Info", "browser:Dom", "browser:Upload.MultiUploader", "browser:Upload.FileUploader", "media:ImageRecorder.ImageRecorderWrapper", "base:Types", "base:Objs", "base:Strings", "base:Time", "base:Timers", "base:States.Host", "base:Classes.ClassRegistry", "base:Collections.Collection", "base:Promise", "module:ImageCapture.Dynamics.RecorderStates.Initial", "module:ImageCapture.Dynamics.RecorderStates"], ["module:ImageCapture.Dynamics.Loader", "module:ImageCapture.Dynamics.Controlbar", "module:ImageCapture.Dynamics.Message", "module:ImageCapture.Dynamics.Topmessage", "module:ImageCapture.Dynamics.Chooser", "module:ImageCapture.Dynamics.Faceoutline", "dynamics:Partials.ShowPartial", "dynamics:Partials.IfPartial", "dynamics:Partials.EventPartial", "dynamics:Partials.OnPartial", "dynamics:Partials.DataPartial", "dynamics:Partials.AttrsPartial", "dynamics:Partials.StylesPartial", "dynamics:Partials.TemplatePartial", "dynamics:Partials.HotkeyPartial"], function (Class, Assets, Info, Dom, MultiUploader, FileUploader, ImageRecorderWrapper, Types, Objs, Strings, Time, Timers, Host, ClassRegistry, Collection, Promise, InitialState, RecorderStates, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (t) {
                return {
                  template: '\n<div data-selector="capture-container" ba-show="{{!player_active}}"\n     class="{{css}}-container {{css}}-size-{{csssize}} {{iecss}}-{{ie8 ? \'ie8\' : \'noie8\'}} {{csstheme}}\n     \t{{css}}-{{ fullscreened ? \'fullscreen\' : \'normal\' }}-view {{css}}-{{ firefox ? \'firefox\' : \'common\'}}-browser\n    \t{{css}}-{{themecolor}}-color"\n     ba-styles="{{widthHeightStyles}}"\n>\n\n    <img tabindex="-1" data-selector="recorder-status" class="{{css}}-video {{css}}-{{hasrecorder ? \'hasrecorder\' : \'norecorder\'}}" data-image="image" />\n\t<ba-imagecapture-faceoutline class="{{css}}-overlay" ba-if="{{faceoutline && hasrecorder}}">\n\t</ba-imagecapture-faceoutline>\n    <div data-selector="recorder-overlay" class=\'{{css}}-overlay\' ba-show="{{!hideoverlay}}" data-overlay="overlay">\n\t\t<ba-{{dynloader}}\n\t\t    ba-css="{{cssloader || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t    ba-template="{{tmplloader}}"\n\t\t    ba-show="{{loader_active}}"\n\t\t    ba-tooltip="{{loadertooltip}}"\n\t\t\tba-hovermessage="{{=hovermessage}}"\n\t\t    ba-label="{{loaderlabel}}"\n\t\t></ba-{{dynloader}}>\n\n\t\t<ba-{{dynmessage}}\n\t\t    ba-css="{{cssmessage || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t    ba-template="{{tmplmessage}}"\n\t\t    ba-show="{{message_active}}"\n\t\t    ba-message="{{message}}"\n\t\t\tba-links="{{message_links}}"\n\t\t    ba-event:click="message_click"\n\t\t\tba-event:link="message_link_click"\n\t\t></ba-{{dynmessage}}>\n\n\t\t<ba-{{dyntopmessage}}\n\t\t    ba-css="{{csstopmessage || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t    ba-template="{{tmpltopmessage}}"\n\t\t    ba-show="{{topmessage_active && (topmessage || hovermessage)}}"\n\t\t    ba-topmessage="{{hovermessage || topmessage}}"\n\t\t></ba-{{dyntopmessage}}>\n\n\t\t<ba-{{dynchooser}}\n\t\t\tba-recordviafilecapture="{{recordviafilecapture}}"\n\t\t    ba-css="{{csschooser || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t    ba-template="{{tmplchooser}}"\n\t\t    ba-if="{{chooser_active && !is_initial_state}}"\n\t\t    ba-allowrecord="{{allowrecord}}"\n\t\t    ba-allowupload="{{allowupload}}"\n\t\t    ba-allowcustomupload="{{allowcustomupload}}"\n\t\t    ba-allowedextensions="{{allowedextensions}}"\n\t\t    ba-primaryrecord="{{primaryrecord}}"\n\t\t    ba-event:record="capture_image"\n\t\t    ba-event:upload="upload_image"\n\t\t></ba-{{dynchooser}}>\n\n\t\t<ba-{{dyncontrolbar}}\n\t\t    ba-css="{{csscontrolbar || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t    ba-template="{{tmplcontrolbar}}"\n\t\t    ba-show="{{controlbar_active}}"\n\t\t    ba-cameras="{{cameras}}"\n\t\t    ba-selectedcamera="{{selectedcamera || 0}}"\n\t\t    ba-camerahealthy="{{camerahealthy}}"\n\t\t    ba-hovermessage="{{=hovermessage}}"\n\t\t    ba-settingsvisible="{{settingsvisible}}"\n\t\t    ba-recordvisible="{{recordvisible}}"\n\t\t\tba-cancelvisible="{{allowcancel && cancancel}}"\n\t\t    ba-rerecordvisible="{{rerecordvisible}}"\n\t\t    ba-controlbarlabel="{{controlbarlabel}}"\n\t\t    ba-event:select-camera="select_camera"\n\t\t    ba-event:invoke-record="record"\n\t\t    ba-event:invoke-rerecord="rerecord"\n\t\t></ba-{{dyncontrolbar}}>\n    </div>\n</div>\n\n<div data-selector="recorder-player" ba-if="{{player_active}}" ba-styles="{{widthHeightStyles}}">\n\t<span ba-show="{{ie8}}">&nbsp;</span>\n\t<ba-{{dynimageviewer}}\n\t    ba-theme="{{theme || \'default\'}}"\n        ba-themecolor="{{themecolor}}"\n        ba-source="{{playbacksource}}"\n        ba-hideoninactivity="{{false}}"\n        ba-stretch="{{stretch}}"\n        ba-attrs="{{playerattrs}}"\n        ba-data:id="player"\n        ba-width="{{width}}"\n        ba-height="{{height}}"\n        ba-rerecordable="{{rerecordable && (recordings === null || recordings > 0)}}"\n        ba-submittable="{{manualsubmit && verified}}"\n        ba-nofullscreen="{{nofullscreen}}"\n        ba-event:rerecord="rerecord"\n        ba-event:submit="manual_submit"\n\t>\n\t</ba-{{dynimageviewer}}>\n</div>\n',
                  attrs: {
                    css: "ba-imagecapture",
                    csscommon: "ba-commoncss",
                    iecss: "ba-imagecapture",
                    cssimagegallery: "",
                    cssloader: "",
                    csscontrolbar: "",
                    cssmessage: "",
                    csstopmessage: "",
                    csschooser: "",
                    width: "",
                    height: "",
                    gallerysnapshots: 3,
                    theme: "",
                    csstheme: "",
                    dynloader: "imagecapture-loader",
                    dyncontrolbar: "imagecapture-controlbar",
                    dynmessage: "imagecapture-message",
                    dyntopmessage: "imagecapture-topmessage",
                    dynchooser: "imagecapture-chooser",
                    dynimageviewer: "imageviewer",
                    tmplloader: "",
                    tmplcontrolbar: "",
                    tmplmessage: "",
                    tmpltopmessage: "",
                    tmplchooser: "",
                    autorecord: !1,
                    allowrecord: !0,
                    allowupload: !0,
                    allowcustomupload: !0,
                    camerafacefront: !1,
                    primaryrecord: !0,
                    nofullscreen: !1,
                    recordingwidth: undefined,
                    recordingheight: undefined,
                    minuploadingwidth: undefined,
                    maxuploadingwidth: undefined,
                    minuploadingheight: undefined,
                    maxuploadingheight: undefined,
                    countdown: 3,
                    webrtconmobile: "boolean",
                    snapshottype: "jpg",
                    playbacksource: "",
                    recordermode: !0,
                    skipinitial: !1,
                    skipinitialonrerecord: !1,
                    "flip-camera": !1,
                    "early-rerecord": !1,
                    manualsubmit: !1,
                    allowedextensions: null,
                    filesizelimit: null,
                    faceoutline: !1,
                    simulate: !1,
                    localplayback: !1,
                    uploadoptions: {},
                    playerattrs: {},
                    shortMessage: !0,
                    rerecordable: !0,
                    recordings: null,
                    ready: !0,
                    orientation: !1,
                    stretch: !1
                  },
                  computed: {
                    "nativeRecordingWidth:recordingwidth,record_media": function nativeRecordingWidthRecordingwidthRecord_media() {
                      return this.get("recordingwidth") || ("screen" !== this.get("record_media") ? 640 : window.innerWidth || document.body.clientWidth);
                    },
                    "nativeRecordingHeight:recordingheight,record_media": function nativeRecordingHeightRecordingheightRecord_media() {
                      return this.get("recordingheight") || ("screen" !== this.get("record_media") ? 480 : window.innerHeight || document.body.clientHeight);
                    },
                    "widthHeightStyles:width,height": function widthHeightStylesWidthHeight() {
                      var e = {},
                        t = this.get("width"),
                        i = this.get("height");
                      return t && (e.width = t + ((t + "").match(/^\d+$/g) ? "px" : "")), i && (e.height = i + ((i + "").match(/^\d+$/g) ? "px" : "")), e;
                    },
                    "canswitchcamera:recordviafilecapture": function canswitchcameraRecordviafilecapture() {
                      return !this.get("recordviafilecapture") && Info.isMobile();
                    }
                  },
                  scopes: {
                    player: ">[id='player']"
                  },
                  types: {
                    rerecordable: "boolean",
                    ready: "boolean",
                    stretch: "boolean",
                    autorecord: "boolean",
                    allowrecord: "boolean",
                    allowupload: "boolean",
                    allowcustomupload: "boolean",
                    primaryrecord: "boolean",
                    recordermode: "boolean",
                    nofullscreen: "boolean",
                    skipinitialonrerecord: "boolean",
                    localplayback: "boolean",
                    camerafacefront: "boolean",
                    skipinitial: "boolean",
                    minuploadingwidth: "int",
                    maxuploadingwidth: "int",
                    minuploadingheight: "int",
                    maxuploadingheight: "int",
                    webrtconmobile: "boolean",
                    "flip-camera": "boolean",
                    faceoutline: "boolean",
                    "early-rerecord": "boolean",
                    manualsubmit: "boolean",
                    simulate: "boolean",
                    allowedextensions: "array"
                  },
                  extendables: ["states"],
                  remove_on_destroy: !0,
                  events: {
                    "change:camerahealthy": function changeCamerahealthy(e) {
                      this.trigger("camerahealth", e);
                    },
                    "change:webrtconmobile": function changeWebrtconmobile() {
                      this.set("recordviafilecapture", Info.isMobile() && (!this.get("webrtconmobile") || !ImageRecorderWrapper.anySupport(this._imageCaptureWrapperOptions())));
                    },
                    "change:recordviafilecapture": function changeRecordviafilecapture() {
                      this.get("recordviafilecapture") && (this.set("skipinitial", !1), this.set("skipinitialonrerecord", !1), this.set("allowscreen", !1), this.set("autorecord", !1));
                    }
                  },
                  create: function create() {
                    this.get("theme") && this.set("theme", this.get("theme").toLowerCase()), this.get("theme") in Assets.recorderthemes && Objs.iter(Assets.recorderthemes[this.get("theme")], function (e, t) {
                      this.isArgumentAttr(t) || this.set(t, e);
                    }, this), this.set("ie8", Info.isInternetExplorer() && Info.internetExplorerVersion() < 9), this.set("hideoverlay", !1), this.set("canswitchcamera", !1), this.set("recordviafilecapture", Info.isMobile() && (!this.get("webrtconmobile") || !ImageRecorderWrapper.anySupport(this._imageCaptureWrapperOptions()))), this.get("recordviafilecapture") && (this.set("skipinitial", !1), this.set("skipinitialonrerecord", !1), this.set("autorecord", !1)), this.__attachRequested = !1, this.__activated = !1, this._bound = !1, this.__recording = !1, this.__error = null, this.__currentStretch = null, this.on("change:stretch", function () {
                      this._updateStretch();
                    }, this), this.host = new Host({
                      stateRegistry: new ClassRegistry(this.cls.recorderStates())
                    }), (this.host.dynamic = this).host.initialize(InitialState), this._timer = new Timers.Timer({
                      context: this,
                      fire: this._timerFire,
                      delay: 250,
                      start: !0
                    }), this.__cameraResponsive = !0, this.__cameraSignal = !0, Info.isMobile() || this.set("orientation", !1), this.set("currentorientation", window.innerHeight > window.innerWidth ? "portrait" : "landscape");
                  },
                  state: function state() {
                    return this.host.state();
                  },
                  recorderAttached: function recorderAttached() {
                    return !!this.recorder;
                  },
                  imageError: function imageError() {
                    return this.__error;
                  },
                  _error: function _error(e, t) {
                    this.__error = {
                      error_type: e,
                      error_code: t
                    }, this.trigger("error:" + e, t), this.trigger("error", e, t);
                  },
                  _clearError: function _clearError() {
                    this.__error = null;
                  },
                  _detachRecorder: function _detachRecorder() {
                    this.recorder && this.recorder.weakDestroy(), this.recorder = null, this.set("hasrecorder", !1);
                  },
                  _imageCaptureWrapperOptions: function _imageCaptureWrapperOptions() {
                    return {
                      simulate: this.get("simulate"),
                      localPlaybackRequested: this.get("localplayback"),
                      flip: this.get("flip-camera")
                    };
                  },
                  _attachRecorder: function _attachRecorder() {
                    var e;
                    this.recorderAttached() || (this.__activated ? (this.set("hasrecorder", !0), this.__attachRequested = !1, e = this.activeElement().querySelector("[data-image='image']"), this._clearError(), this.recorder = ImageRecorderWrapper.create(Objs.extend({
                      element: e
                    }, this._imageCaptureWrapperOptions())), this.recorder ? this.trigger("attached") : this._error("attach")) : this.__attachRequested = !0);
                  },
                  _softwareDependencies: function _softwareDependencies() {
                    return this.recorderAttached() && this.recorder ? this.recorder.softwareDependencies() : Promise.error("No recorder attached.");
                  },
                  _bindMedia: function _bindMedia() {
                    !this._bound && this.recorderAttached() && this.recorder && this.recorder.ready.success(function () {
                      this.recorder.on("require_display", function () {
                        this.set("hideoverlay", !0);
                      }, this), this.recorder.bindMedia().error(function (e) {
                        this.trigger("access_forbidden", e), this.set("hideoverlay", !1), this.off("require_display", null, this), this._error("bind", e);
                      }, this).success(function () {
                        this.trigger("access_granted"), this.set("hideoverlay", !1), this.off("require_display", null, this), this.recorder.enumerateDevices().success(function (e) {
                          var t = this.recorder.currentDevices();
                          this.set("selectedcamera", t.video), this.set("cameras", new Collection(Objs.values(e.video)));
                        }, this), this.set("devicetesting", !0), this._updateStretch(), this._bound = !0, this.trigger("bound");
                      }, this);
                    }, this);
                  },
                  _initializeUploader: function _initializeUploader() {
                    this._dataUploader && this._dataUploader.weakDestroy(), this._dataUploader = new MultiUploader();
                  },
                  _unbindMedia: function _unbindMedia() {
                    this._bound && (this.recorder.unbindMedia(), this._bound = !1);
                  },
                  _uploadImageFile: function _uploadImageFile(e) {
                    var t;
                    this.get("simulate") || ((t = FileUploader.create(Objs.extend({
                      source: e
                    }, this.get("uploadoptions").image))).upload(), this._dataUploader.addUploader(t));
                  },
                  _prepareRecording: function _prepareRecording() {
                    return Promise.create(!0);
                  },
                  _captureImage: function _captureImage() {
                    this._snapshot = this.recorder.createSnapshot(this.get("snapshottype"));
                  },
                  _uploadCapture: function _uploadCapture() {
                    var e;
                    this.get("simulate") || ((e = this.recorder.createSnapshotUploader(this._snapshot, this.get("snapshottype"), this.get("uploadoptions").image)).upload(), this._dataUploader.addUploader(e));
                  },
                  _verifyRecording: function _verifyRecording() {
                    return Promise.create(!0);
                  },
                  _afterActivate: function _afterActivate(e) {
                    t._afterActivate.call(this, e), this.__activated = !0, this.__attachRequested && this._attachRecorder(), this.persistentTrigger("loaded");
                  },
                  object_functions: ["record", "rerecord", "reset"],
                  functions: {
                    record: function record() {
                      this.host.state().record();
                    },
                    record_image: function record_image() {
                      this.host.state().selectRecord();
                    },
                    upload_image: function upload_image(e) {
                      this.host.state().selectUpload(e);
                    },
                    select_camera: function select_camera(e) {
                      this.recorder && (this.recorder.setCurrentDevices({
                        video: e
                      }), this.set("selectedcamera", e));
                    },
                    select_camera_face: function select_camera_face(e) {
                      this.recorder && (this.recorder.setCameraFace(e), this.set("camerafacefront", e));
                    },
                    rerecord: function rerecord() {
                      confirm(this.stringUnicode("rerecord-confirm")) && this.host.state().rerecord();
                    },
                    message_click: function message_click() {
                      this.trigger("message-click");
                    },
                    message_link_click: function message_link_click(e) {
                      this.trigger("message-link-click", e);
                    },
                    reset: function reset() {
                      this._stopRecording().callback(function () {
                        this._unbindMedia(), this._detachRecorder(), this.host.state().next("Initial");
                      }, this);
                    },
                    manual_submit: function manual_submit() {
                      this.set("rerecordable", !1), this.set("manualsubmit", !1), this.trigger("manually_submitted");
                    },
                    ready_to_play: function ready_to_play() {
                      this.trigger("ready_to_play");
                    }
                  },
                  destroy: function destroy() {
                    this._timer.destroy(), this.host.destroy(), this._detachRecorder(), t.destroy.call(this);
                  },
                  deltaCoefficient: function deltaCoefficient() {
                    return this.recorderAttached() ? this.recorder.deltaCoefficient() : null;
                  },
                  blankLevel: function blankLevel() {
                    return this.recorderAttached() ? this.recorder.blankLevel() : null;
                  },
                  lightLevel: function lightLevel() {
                    return this.recorderAttached() ? this.recorder.lightLevel() : null;
                  },
                  _timerFire: function _timerFire() {
                    if (!this.destroyed()) {
                      this.set("currentorientation", window.innerHeight > window.innerWidth ? "portrait" : "landscape");
                      try {
                        var t;
                        this.recorderAttached() && this.get("devicetesting") && (t = this.lightLevel(), this.set("camerahealthy", 100 <= t && t <= 200));
                      } catch (e) {}
                      try {
                        var i, r, o;
                        this.recorderAttached() && this._timer.fire_count() % 20 == 0 && this._accessing_camera && (i = .01 <= this.blankLevel()) !== this.__cameraSignal && (this.__cameraSignal = i, this.trigger(i ? "camera_signal" : "camera_nosignal")), this.recorderAttached() && this._timer.fire_count() % 20 == 10 && this._accessing_camera && (o = null === (r = this.recorder.deltaCoefficient()) || .5 <= r) !== this.__cameraResponsive && (this.__cameraResponsive = o, this.trigger(o ? "camera_responsive" : "camera_unresponsive"));
                      } catch (e) {}
                      this._updateStretch(), this._updateCSSSize();
                    }
                  },
                  _updateCSSSize: function _updateCSSSize() {
                    var e = Dom.elementDimensions(this.activeElement()).width;
                    this.set("csssize", 400 < e ? "normal" : 300 < e ? "medium" : "small");
                  },
                  imageHeight: function imageHeight() {
                    return this.recorderAttached() ? this.recorder.cameraHeight() : NaN;
                  },
                  imageWidth: function imageWidth() {
                    return this.recorderAttached() ? this.recorder.cameraWidth() : NaN;
                  },
                  aspectRatio: function aspectRatio() {
                    return this.imageWidth() / this.imageHeight();
                  },
                  parentWidth: function parentWidth() {
                    return this.get("width") || Dom.elementDimensions(this.activeElement()).width;
                  },
                  parentHeight: function parentHeight() {
                    return this.get("height") || Dom.elementDimensions(this.activeElement()).height;
                  },
                  parentAspectRatio: function parentAspectRatio() {
                    return this.parentWidth() / this.parentHeight();
                  },
                  _updateStretch: function _updateStretch() {
                    var e,
                      t,
                      i = null;
                    this.get("stretch") && (e = this.aspectRatio(), isFinite(e) && (t = this.parentAspectRatio(), isFinite(t) ? (e < t && (i = "height"), t < e && (i = "width")) : t === Infinity && (i = "height"))), this.__currentStretch !== i && (this.__currentStretch && Dom.elementRemoveClass(this.activeElement(), this.get("css") + "-stretch-" + this.__currentStretch), i && Dom.elementAddClass(this.activeElement(), this.get("css") + "-stretch-" + i)), this.__currentStretch = i;
                  }
                };
              }, {
                recorderStates: function recorderStates() {
                  return [RecorderStates];
                }
              }).register("ba-imagecapture").registerFunctions({
                "!player_active": function (_player_active3) {
                  function player_active(_x380) {
                    return _player_active3.apply(this, arguments);
                  }
                  player_active.toString = function () {
                    return _player_active3.toString();
                  };
                  return player_active;
                }(function (obj) {
                  with (obj) return !player_active;
                }),
                css: function (_css22) {
                  function css(_x381) {
                    return _css22.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css22.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                csssize: function (_csssize4) {
                  function csssize(_x382) {
                    return _csssize4.apply(this, arguments);
                  }
                  csssize.toString = function () {
                    return _csssize4.toString();
                  };
                  return csssize;
                }(function (obj) {
                  with (obj) return csssize;
                }),
                iecss: function (_iecss4) {
                  function iecss(_x383) {
                    return _iecss4.apply(this, arguments);
                  }
                  iecss.toString = function () {
                    return _iecss4.toString();
                  };
                  return iecss;
                }(function (obj) {
                  with (obj) return iecss;
                }),
                "ie8 ? 'ie8' : 'noie8'": function ie8Ie8Noie8(obj) {
                  with (obj) return ie8 ? "ie8" : "noie8";
                },
                csstheme: function (_csstheme5) {
                  function csstheme(_x384) {
                    return _csstheme5.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme5.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                "fullscreened ? 'fullscreen' : 'normal'": function fullscreenedFullscreenNormal(obj) {
                  with (obj) return fullscreened ? "fullscreen" : "normal";
                },
                "firefox ? 'firefox' : 'common'": function firefoxFirefoxCommon(obj) {
                  with (obj) return firefox ? "firefox" : "common";
                },
                themecolor: function (_themecolor4) {
                  function themecolor(_x385) {
                    return _themecolor4.apply(this, arguments);
                  }
                  themecolor.toString = function () {
                    return _themecolor4.toString();
                  };
                  return themecolor;
                }(function (obj) {
                  with (obj) return themecolor;
                }),
                widthHeightStyles: function (_widthHeightStyles2) {
                  function widthHeightStyles(_x386) {
                    return _widthHeightStyles2.apply(this, arguments);
                  }
                  widthHeightStyles.toString = function () {
                    return _widthHeightStyles2.toString();
                  };
                  return widthHeightStyles;
                }(function (obj) {
                  with (obj) return widthHeightStyles;
                }),
                "hasrecorder ? 'hasrecorder' : 'norecorder'": function hasrecorderHasrecorderNorecorder(obj) {
                  with (obj) return hasrecorder ? "hasrecorder" : "norecorder";
                },
                "faceoutline && hasrecorder": function faceoutlineHasrecorder(obj) {
                  with (obj) return faceoutline && hasrecorder;
                },
                "!hideoverlay": function (_hideoverlay2) {
                  function hideoverlay(_x387) {
                    return _hideoverlay2.apply(this, arguments);
                  }
                  hideoverlay.toString = function () {
                    return _hideoverlay2.toString();
                  };
                  return hideoverlay;
                }(function (obj) {
                  with (obj) return !hideoverlay;
                }),
                dynloader: function (_dynloader3) {
                  function dynloader(_x388) {
                    return _dynloader3.apply(this, arguments);
                  }
                  dynloader.toString = function () {
                    return _dynloader3.toString();
                  };
                  return dynloader;
                }(function (obj) {
                  with (obj) return dynloader;
                }),
                "cssloader || css": function cssloaderCss(obj) {
                  with (obj) return cssloader || css;
                },
                tmplloader: function (_tmplloader3) {
                  function tmplloader(_x389) {
                    return _tmplloader3.apply(this, arguments);
                  }
                  tmplloader.toString = function () {
                    return _tmplloader3.toString();
                  };
                  return tmplloader;
                }(function (obj) {
                  with (obj) return tmplloader;
                }),
                loader_active: function (_loader_active3) {
                  function loader_active(_x390) {
                    return _loader_active3.apply(this, arguments);
                  }
                  loader_active.toString = function () {
                    return _loader_active3.toString();
                  };
                  return loader_active;
                }(function (obj) {
                  with (obj) return loader_active;
                }),
                loadertooltip: function (_loadertooltip2) {
                  function loadertooltip(_x391) {
                    return _loadertooltip2.apply(this, arguments);
                  }
                  loadertooltip.toString = function () {
                    return _loadertooltip2.toString();
                  };
                  return loadertooltip;
                }(function (obj) {
                  with (obj) return loadertooltip;
                }),
                hovermessage: function (_hovermessage2) {
                  function hovermessage(_x392) {
                    return _hovermessage2.apply(this, arguments);
                  }
                  hovermessage.toString = function () {
                    return _hovermessage2.toString();
                  };
                  return hovermessage;
                }(function (obj) {
                  with (obj) return hovermessage;
                }),
                loaderlabel: function (_loaderlabel2) {
                  function loaderlabel(_x393) {
                    return _loaderlabel2.apply(this, arguments);
                  }
                  loaderlabel.toString = function () {
                    return _loaderlabel2.toString();
                  };
                  return loaderlabel;
                }(function (obj) {
                  with (obj) return loaderlabel;
                }),
                dynmessage: function (_dynmessage4) {
                  function dynmessage(_x394) {
                    return _dynmessage4.apply(this, arguments);
                  }
                  dynmessage.toString = function () {
                    return _dynmessage4.toString();
                  };
                  return dynmessage;
                }(function (obj) {
                  with (obj) return dynmessage;
                }),
                "cssmessage || css": function cssmessageCss(obj) {
                  with (obj) return cssmessage || css;
                },
                tmplmessage: function (_tmplmessage4) {
                  function tmplmessage(_x395) {
                    return _tmplmessage4.apply(this, arguments);
                  }
                  tmplmessage.toString = function () {
                    return _tmplmessage4.toString();
                  };
                  return tmplmessage;
                }(function (obj) {
                  with (obj) return tmplmessage;
                }),
                message_active: function (_message_active4) {
                  function message_active(_x396) {
                    return _message_active4.apply(this, arguments);
                  }
                  message_active.toString = function () {
                    return _message_active4.toString();
                  };
                  return message_active;
                }(function (obj) {
                  with (obj) return message_active;
                }),
                message: function (_message8) {
                  function message(_x397) {
                    return _message8.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message8.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message;
                }),
                message_links: function (_message_links2) {
                  function message_links(_x398) {
                    return _message_links2.apply(this, arguments);
                  }
                  message_links.toString = function () {
                    return _message_links2.toString();
                  };
                  return message_links;
                }(function (obj) {
                  with (obj) return message_links;
                }),
                dyntopmessage: function (_dyntopmessage4) {
                  function dyntopmessage(_x399) {
                    return _dyntopmessage4.apply(this, arguments);
                  }
                  dyntopmessage.toString = function () {
                    return _dyntopmessage4.toString();
                  };
                  return dyntopmessage;
                }(function (obj) {
                  with (obj) return dyntopmessage;
                }),
                "csstopmessage || css": function csstopmessageCss(obj) {
                  with (obj) return csstopmessage || css;
                },
                tmpltopmessage: function (_tmpltopmessage4) {
                  function tmpltopmessage(_x400) {
                    return _tmpltopmessage4.apply(this, arguments);
                  }
                  tmpltopmessage.toString = function () {
                    return _tmpltopmessage4.toString();
                  };
                  return tmpltopmessage;
                }(function (obj) {
                  with (obj) return tmpltopmessage;
                }),
                "topmessage_active && (topmessage || hovermessage)": function topmessage_activeTopmessageHovermessage(obj) {
                  with (obj) return topmessage_active && (topmessage || hovermessage);
                },
                "hovermessage || topmessage": function hovermessageTopmessage(obj) {
                  with (obj) return hovermessage || topmessage;
                },
                dynchooser: function (_dynchooser2) {
                  function dynchooser(_x401) {
                    return _dynchooser2.apply(this, arguments);
                  }
                  dynchooser.toString = function () {
                    return _dynchooser2.toString();
                  };
                  return dynchooser;
                }(function (obj) {
                  with (obj) return dynchooser;
                }),
                recordviafilecapture: function (_recordviafilecapture2) {
                  function recordviafilecapture(_x402) {
                    return _recordviafilecapture2.apply(this, arguments);
                  }
                  recordviafilecapture.toString = function () {
                    return _recordviafilecapture2.toString();
                  };
                  return recordviafilecapture;
                }(function (obj) {
                  with (obj) return recordviafilecapture;
                }),
                "csschooser || css": function csschooserCss(obj) {
                  with (obj) return csschooser || css;
                },
                tmplchooser: function (_tmplchooser2) {
                  function tmplchooser(_x403) {
                    return _tmplchooser2.apply(this, arguments);
                  }
                  tmplchooser.toString = function () {
                    return _tmplchooser2.toString();
                  };
                  return tmplchooser;
                }(function (obj) {
                  with (obj) return tmplchooser;
                }),
                "chooser_active && !is_initial_state": function chooser_activeIs_initial_state(obj) {
                  with (obj) return chooser_active && !is_initial_state;
                },
                allowrecord: function (_allowrecord2) {
                  function allowrecord(_x404) {
                    return _allowrecord2.apply(this, arguments);
                  }
                  allowrecord.toString = function () {
                    return _allowrecord2.toString();
                  };
                  return allowrecord;
                }(function (obj) {
                  with (obj) return allowrecord;
                }),
                allowupload: function (_allowupload2) {
                  function allowupload(_x405) {
                    return _allowupload2.apply(this, arguments);
                  }
                  allowupload.toString = function () {
                    return _allowupload2.toString();
                  };
                  return allowupload;
                }(function (obj) {
                  with (obj) return allowupload;
                }),
                allowcustomupload: function (_allowcustomupload2) {
                  function allowcustomupload(_x406) {
                    return _allowcustomupload2.apply(this, arguments);
                  }
                  allowcustomupload.toString = function () {
                    return _allowcustomupload2.toString();
                  };
                  return allowcustomupload;
                }(function (obj) {
                  with (obj) return allowcustomupload;
                }),
                allowedextensions: function (_allowedextensions2) {
                  function allowedextensions(_x407) {
                    return _allowedextensions2.apply(this, arguments);
                  }
                  allowedextensions.toString = function () {
                    return _allowedextensions2.toString();
                  };
                  return allowedextensions;
                }(function (obj) {
                  with (obj) return allowedextensions;
                }),
                primaryrecord: function (_primaryrecord2) {
                  function primaryrecord(_x408) {
                    return _primaryrecord2.apply(this, arguments);
                  }
                  primaryrecord.toString = function () {
                    return _primaryrecord2.toString();
                  };
                  return primaryrecord;
                }(function (obj) {
                  with (obj) return primaryrecord;
                }),
                dyncontrolbar: function (_dyncontrolbar4) {
                  function dyncontrolbar(_x409) {
                    return _dyncontrolbar4.apply(this, arguments);
                  }
                  dyncontrolbar.toString = function () {
                    return _dyncontrolbar4.toString();
                  };
                  return dyncontrolbar;
                }(function (obj) {
                  with (obj) return dyncontrolbar;
                }),
                "csscontrolbar || css": function csscontrolbarCss(obj) {
                  with (obj) return csscontrolbar || css;
                },
                tmplcontrolbar: function (_tmplcontrolbar4) {
                  function tmplcontrolbar(_x410) {
                    return _tmplcontrolbar4.apply(this, arguments);
                  }
                  tmplcontrolbar.toString = function () {
                    return _tmplcontrolbar4.toString();
                  };
                  return tmplcontrolbar;
                }(function (obj) {
                  with (obj) return tmplcontrolbar;
                }),
                controlbar_active: function (_controlbar_active3) {
                  function controlbar_active(_x411) {
                    return _controlbar_active3.apply(this, arguments);
                  }
                  controlbar_active.toString = function () {
                    return _controlbar_active3.toString();
                  };
                  return controlbar_active;
                }(function (obj) {
                  with (obj) return controlbar_active;
                }),
                cameras: function (_cameras4) {
                  function cameras(_x412) {
                    return _cameras4.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras4.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "selectedcamera || 0": function selectedcamera0(obj) {
                  with (obj) return selectedcamera || 0;
                },
                camerahealthy: function (_camerahealthy2) {
                  function camerahealthy(_x413) {
                    return _camerahealthy2.apply(this, arguments);
                  }
                  camerahealthy.toString = function () {
                    return _camerahealthy2.toString();
                  };
                  return camerahealthy;
                }(function (obj) {
                  with (obj) return camerahealthy;
                }),
                settingsvisible: function (_settingsvisible4) {
                  function settingsvisible(_x414) {
                    return _settingsvisible4.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible4.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                recordvisible: function (_recordvisible4) {
                  function recordvisible(_x415) {
                    return _recordvisible4.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible4.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "allowcancel && cancancel": function allowcancelCancancel(obj) {
                  with (obj) return allowcancel && cancancel;
                },
                rerecordvisible: function (_rerecordvisible4) {
                  function rerecordvisible(_x416) {
                    return _rerecordvisible4.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible4.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                controlbarlabel: function (_controlbarlabel4) {
                  function controlbarlabel(_x417) {
                    return _controlbarlabel4.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel4.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                player_active: function (_player_active4) {
                  function player_active(_x418) {
                    return _player_active4.apply(this, arguments);
                  }
                  player_active.toString = function () {
                    return _player_active4.toString();
                  };
                  return player_active;
                }(function (obj) {
                  with (obj) return player_active;
                }),
                ie8: function (_ie2) {
                  function ie8(_x419) {
                    return _ie2.apply(this, arguments);
                  }
                  ie8.toString = function () {
                    return _ie2.toString();
                  };
                  return ie8;
                }(function (obj) {
                  with (obj) return ie8;
                }),
                dynimageviewer: function (_dynimageviewer) {
                  function dynimageviewer(_x420) {
                    return _dynimageviewer.apply(this, arguments);
                  }
                  dynimageviewer.toString = function () {
                    return _dynimageviewer.toString();
                  };
                  return dynimageviewer;
                }(function (obj) {
                  with (obj) return dynimageviewer;
                }),
                "theme || 'default'": function themeDefault(obj) {
                  with (obj) return theme || "default";
                },
                playbacksource: function (_playbacksource) {
                  function playbacksource(_x421) {
                    return _playbacksource.apply(this, arguments);
                  }
                  playbacksource.toString = function () {
                    return _playbacksource.toString();
                  };
                  return playbacksource;
                }(function (obj) {
                  with (obj) return playbacksource;
                }),
                "false": function _false(obj) {
                  with (obj) return !1;
                },
                stretch: function (_stretch) {
                  function stretch(_x422) {
                    return _stretch.apply(this, arguments);
                  }
                  stretch.toString = function () {
                    return _stretch.toString();
                  };
                  return stretch;
                }(function (obj) {
                  with (obj) return stretch;
                }),
                playerattrs: function (_playerattrs2) {
                  function playerattrs(_x423) {
                    return _playerattrs2.apply(this, arguments);
                  }
                  playerattrs.toString = function () {
                    return _playerattrs2.toString();
                  };
                  return playerattrs;
                }(function (obj) {
                  with (obj) return playerattrs;
                }),
                width: function (_width) {
                  function width(_x424) {
                    return _width.apply(this, arguments);
                  }
                  width.toString = function () {
                    return _width.toString();
                  };
                  return width;
                }(function (obj) {
                  with (obj) return width;
                }),
                height: function (_height) {
                  function height(_x425) {
                    return _height.apply(this, arguments);
                  }
                  height.toString = function () {
                    return _height.toString();
                  };
                  return height;
                }(function (obj) {
                  with (obj) return height;
                }),
                "rerecordable && (recordings === null || recordings > 0)": function rerecordableRecordingsNullRecordings0(obj) {
                  with (obj) return rerecordable && (null === recordings || 0 < recordings);
                },
                "manualsubmit && verified": function manualsubmitVerified(obj) {
                  with (obj) return manualsubmit && verified;
                },
                nofullscreen: function (_nofullscreen2) {
                  function nofullscreen(_x426) {
                    return _nofullscreen2.apply(this, arguments);
                  }
                  nofullscreen.toString = function () {
                    return _nofullscreen2.toString();
                  };
                  return nofullscreen;
                }(function (obj) {
                  with (obj) return nofullscreen;
                })
              }).attachStringTable(Assets.strings).addStrings({
                "recorder-error": "An error occurred, please try again later. Click to retry.",
                "attach-error": "We could not access the media interface. Depending on the device and browser, you might need to access the page via SSL.",
                "software-required": "Please click below to install / activate the following requirements in order to proceed.",
                "software-waiting": "Waiting for the requirements to be installed / activated. You might need to refresh the page after completion.",
                "access-forbidden": "Access to the media was forbidden. Click to retry.",
                uploading: "Uploading",
                "uploading-failed": "Uploading failed - click here to retry.",
                "upload-error-duration": "Length of the uploaded image does not meet the requirements - click here to retry.",
                "resolution-constraint-error": "The file you've selected does not match the required resolution - click here to retry.",
                verifying: "Verifying",
                "verifying-failed": "Verifying failed - click here to retry.",
                "rerecord-confirm": "Do you really want to retake your image?",
                image_file_too_large: "Your image file is too large (%s) - click here to try again with a smaller image file.",
                unsupported_image_type: "Please upload: %s - click here to retry.",
                "orientation-portrait-required": "Please rotate your device to record in portrait mode.",
                "orientation-landscape-required": "Please rotate your device to record in landscape mode."
              });
            }), Scoped.define("module:AudioPlayer.Dynamics.Controlbar", ["dynamics:Dynamic", "base:TimeFormat", "browser:Dom", "module:Assets", "browser:Info", "browser:Events"], ["dynamics:Partials.StylesPartial", "dynamics:Partials.ShowPartial", "dynamics:Partials.IfPartial", "dynamics:Partials.ClickPartial"], function (Class, TimeFormat, Dom, Assets, Info, DomEvents, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div class="{{css}}-dashboard">\n\t<div tabindex="2" data-selector="progress-bar-inner" class="{{css}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}"\n\t\t ba-hotkey:right="{{seek(position + skipseconds)}}"\n\t\t ba-hotkey:left="{{seek(position - skipseconds)}}"\n         ba-hotkey:alt+right="{{seek(position + skipseconds * 3)}}"\n         ba-hotkey:alt+left="{{seek(position - skipseconds * 3)}}"\n\t\t onmouseout="this.blur()"\n\t\t ontouchstart="{{startUpdatePosition(domEvent)}}"\n\t\t onmousedown="{{startUpdatePosition(domEvent)}}"\n\t>\n\t\t<div class="{{css}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n\t\t<div class="{{css}}-progressbar-position"\n\t\t\t ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}"\n\t\t\t title="{{string(\'audio-progress\')}}"\n\t\t>\n\t\t\t<div class="{{css}}-progressbar-button"></div>\n\t\t</div>\n\t</div>\n\n\t<div class="{{css}}-backbar"></div>\n\n\t<div class="{{css}}-controlbar">\n\n        <div tabindex="0" data-selector="submit-audio-button"\n\t\t\t ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-leftbutton-container"\n\t\t\t ba-if="{{submittable}}" ba-click="{{submit()}}">\n            <div class="{{css}}-button-inner">\n                {{string(\'submit-audio\')}}\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-ccw"\n\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-leftbutton-container" ba-if="{{rerecordable}}"\n\t\t\t ba-click="{{rerecord()}}" title="{{string(\'rerecord-audio\')}}"\n\t\t>\n            <div class="{{css}}-button-inner">\n                <i class="{{csscommon}}-icon-ccw"></i>\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-play"\n\t\t\t onmouseout="this.blur()"\n\t\t\t class="{{css}}-leftbutton-container" title="{{string(\'play-audio\')}}"\n\t\t\t onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}" ba-if="{{!playing}}" ba-click="{{play()}}"\n\t\t>\n            <div class="{{css}}-button-inner">\n                <i class="{{csscommon}}-icon-play"></i>\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-pause"\n\t\t\t onmouseout="this.blur()"\n\t\t\t class="{{css}}-leftbutton-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n\t\t\t onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}" ba-if="{{playing}}" ba-click="{{pause()}}"\n\t\t\t title="{{disablepause ? string(\'pause-audio-disabled\') : string(\'pause-audio\')}}"\n\t\t>\n            <div class="{{css}}-button-inner">\n                <i class="{{csscommon}}-icon-pause"></i>\n            </div>\n        </div>\n\n\t\t<div class="{{css}}-time-container">\n\t\t\t<div class="{{css}}-time-value" title="{{string(\'elapsed-time\')}}">{{formatTime(position)}}</div>\n\t\t\t<div class="{{css}}-time-sep">/</div>\n\t\t\t<div class="{{css}}-time-value" title="{{string(\'total-time\')}}">{{formatTime(duration || position)}}</div>\n\t\t</div>\n\n\t\t<div data-selector="audio-title-block" class="{{css}}-title-container" ba-if="{{title}}">\n\t\t\t<p class="{{css}}-title">\n\t\t\t\t{{title}}\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class="{{css}}-volumebar">\n\t\t\t<div tabindex="5" data-selector="button-volume-bar"\n\t\t\t\t ba-hotkey:right="{{set_volume(volume + 0.1)}}" ba-hotkey:left="{{set_volume(volume - 0.1)}}"\n\t\t\t\t ba-hotkey:up="{{set_volume(1)}}" ba-hotkey:down="{{set_volume(0)}}"\n\t\t\t\t onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-volumebar-inner"\n\t\t\t\t ontouchstart="{{startUpdateVolume(domEvent)}}"\n\t\t\t\t ontouchmove="{{progressUpdateVolume(domEvent)}}"\n\t\t\t\t ontouchend="{{stopUpdateVolume(domEvent); this.blur()}};"\n\t\t\t\t onmousedown="{{startUpdateVolume(domEvent)}}"\n                 onmouseup="{{stopUpdateVolume(domEvent)}}"\n                 onmouseleave="{{stopUpdateVolume(domEvent)}}"\n                 onmousemove="{{progressUpdateVolume(domEvent)}}"\n\t\t\t>\n\t\t\t\t<div class="{{css}}-volumebar-position" ba-styles="{{{width: Math.min(100, Math.round(volume * 100)) + \'%\'}}}">\n\t\t\t\t    <div class="{{css}}-volumebar-button" title="{{string(\'volume-button\')}}"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div tabindex="4" data-selector="button-icon-volume"\n\t\t\t ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-rightbutton-container"\n\t\t\t ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}">\n\t\t\t<div class="{{css}}-button-inner">\n\t\t\t\t<i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n</div>\n',
                  attrs: {
                    css: "ba-audioplayer",
                    csscommon: "ba-commoncss",
                    cssplayer: "ba-player",
                    csstheme: "ba-audiooplayer-default-theme",
                    duration: 0,
                    position: 0,
                    cached: 0,
                    volume: 1,
                    manuallypaused: !1,
                    expandedprogress: !0,
                    playing: !1,
                    rerecordable: !1,
                    submittable: !1,
                    title: ""
                  },
                  functions: {
                    formatTime: function formatTime(e) {
                      return e = Math.max(e || 0, .1), TimeFormat.format(TimeFormat.ELAPSED_MINUTES_SECONDS, 1e3 * e);
                    },
                    startUpdatePosition: function startUpdatePosition(e) {
                      var t, i;
                      this.get("disableseeking") || (e[0].preventDefault(), this.__parent.get("playing") || !this.__parent.player || this.get("manuallypaused") || this.__parent.player.play(), t = e[0].currentTarget, this.set("dimensions", t.getBoundingClientRect()), this.set("_updatePosition", !0), this.call("progressUpdatePosition", e[0]), (i = this.get("events")).on(document, "mousemove touchmove", function (e) {
                        e.preventDefault(), this.call("progressUpdatePosition", e);
                      }, this), i.on(document, "mouseup touchend", function (e) {
                        e.preventDefault(), this.call("stopUpdatePosition"), i.off(document, "mouseup touchend mousemove touchmove");
                      }, this));
                    },
                    progressUpdatePosition: function progressUpdatePosition(e) {
                      var t, i, r, o, a;
                      this.get("dimensions") && ((t = e[0] || e).preventDefault(), o = (i = 0 === t.clientX ? 0 : t.clientX || t.targetTouches[0].clientX) < (r = this.get("dimensions")).left ? 0 : i > r.left + r.width ? 1 : (i - r.left) / (r.width || 1), a = this.get("duration") * o, this.get("_updatePosition") && (this.set("position", a), this.trigger("position", this.get("position"))));
                    },
                    stopUpdatePosition: function stopUpdatePosition() {
                      this.set("_updatePosition", !1);
                    },
                    startUpdateVolume: function startUpdateVolume(e) {
                      e[0].preventDefault(), this.set("_updateVolume", !0), this.call("progressUpdateVolume", e);
                    },
                    progressUpdateVolume: function progressUpdateVolume(e) {
                      var t,
                        i,
                        r,
                        o,
                        a = e[0];
                      a.preventDefault(), this.get("_updateVolume") && (t = a.clientX, i = a.currentTarget, r = Dom.elementOffset(i), o = Dom.elementDimensions(i), this.set("volume", (t - r.left) / (o.width || 1)), this.trigger("volume", this.get("volume")));
                    },
                    stopUpdateVolume: function stopUpdateVolume(e) {
                      e[0].preventDefault(), this.set("_updateVolume", !1);
                    },
                    startVerticallyUpdateVolume: function startVerticallyUpdateVolume(e) {
                      e[0].preventDefault(), this.set("_updateVolume", !0), this.call("progressVerticallyUpdateVolume", e);
                    },
                    progressVerticallyUpdateVolume: function progressVerticallyUpdateVolume(e) {
                      var t,
                        i,
                        r,
                        o,
                        a = e[0];
                      a.preventDefault(), this.get("_updateVolume") && (t = a.pageY, i = a.currentTarget, r = Dom.elementOffset(i), o = Dom.elementDimensions(i), this.set("volume", 1 - (t - r.top) / o.height), this.trigger("volume", this.get("volume")));
                    },
                    stopVerticallyUpdateVolume: function stopVerticallyUpdateVolume(e) {
                      e[0].preventDefault(), this.set("_updateVolume", !1);
                    },
                    play: function play() {
                      this.trigger("play");
                    },
                    pause: function pause() {
                      this.trigger("pause");
                    },
                    toggle_volume: function toggle_volume() {
                      0 < this.get("volume") ? (this.__oldVolume = this.get("volume"), this.set("volume", 0)) : this.set("volume", this.__oldVolume || 1), this.trigger("volume", this.get("volume"));
                    },
                    rerecord: function rerecord() {
                      this.trigger("rerecord");
                    },
                    seek: function seek(e) {
                      this.trigger("seek", e);
                    },
                    set_volume: function set_volume(e) {
                      this.trigger("set_volume", e);
                    },
                    submit: function submit() {
                      this.set("submittable", !1), this.set("rerecordable", !1), this.trigger("submit");
                    },
                    tab_index_move: function tab_index_move(e, t, i) {
                      this.trigger("tab_index_move", e[0], t, i);
                    }
                  },
                  create: function create() {
                    this.set("ismobile", Info.isMobile()), this.set("events", new DomEvents());
                  }
                };
              }).register("ba-audioplayer-controlbar").registerFunctions({
                css: function (_css23) {
                  function css(_x427) {
                    return _css23.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css23.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "seek(position + skipseconds * 3)": function seekPositionSkipseconds3(obj) {
                  with (obj) return seek(position + 3 * skipseconds);
                },
                "seek(position - skipseconds * 3)": function seekPositionSkipseconds3(obj) {
                  with (obj) return seek(position - 3 * skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('audio-progress')": function stringAudioProgress(obj) {
                  with (obj) return string("audio-progress");
                },
                "submit()": function (_submit4) {
                  function submit(_x428) {
                    return _submit4.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit4.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable5) {
                  function submittable(_x429) {
                    return _submittable5.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable5.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-audio')": function stringSubmitAudio(obj) {
                  with (obj) return string("submit-audio");
                },
                "rerecord()": function (_rerecord6) {
                  function rerecord(_x430) {
                    return _rerecord6.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord6.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable5) {
                  function rerecordable(_x431) {
                    return _rerecordable5.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable5.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-audio')": function stringRerecordAudio(obj) {
                  with (obj) return string("rerecord-audio");
                },
                csscommon: function (_csscommon13) {
                  function csscommon(_x432) {
                    return _csscommon13.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon13.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "string('play-audio')": function stringPlayAudio(obj) {
                  with (obj) return string("play-audio");
                },
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "!playing": function (_playing4) {
                  function playing(_x433) {
                    return _playing4.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing4.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "play()": function (_play3) {
                  function play(_x434) {
                    return _play3.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play3.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                playing: function (_playing5) {
                  function playing(_x435) {
                    return _playing5.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing5.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "pause()": function (_pause3) {
                  function pause(_x436) {
                    return _pause3.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause3.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "disablepause ? string('pause-audio-disabled') : string('pause-audio')": function disablepauseStringPauseAudioDisabledStringPauseAudio(obj) {
                  with (obj) return disablepause ? string("pause-audio-disabled") : string("pause-audio");
                },
                "string('elapsed-time')": function stringElapsedTime(obj) {
                  with (obj) return string("elapsed-time");
                },
                "formatTime(position)": function formatTimePosition(obj) {
                  with (obj) return formatTime(position);
                },
                "string('total-time')": function stringTotalTime(obj) {
                  with (obj) return string("total-time");
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                title: function (_title5) {
                  function title(_x437) {
                    return _title5.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title5.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "set_volume(1)": function set_volume1(obj) {
                  with (obj) return set_volume(1);
                },
                "set_volume(0)": function set_volume0(obj) {
                  with (obj) return set_volume(0);
                },
                "startUpdateVolume(domEvent)": function startUpdateVolumeDomEvent(obj) {
                  with (obj) return startUpdateVolume(domEvent);
                },
                "progressUpdateVolume(domEvent)": function progressUpdateVolumeDomEvent(obj) {
                  with (obj) return progressUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent); this.blur()": function stopUpdateVolumeDomEventThisBlur(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent)": function stopUpdateVolumeDomEvent(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "{width: Math.min(100, Math.round(volume * 100)) + '%'}": function widthMathMin100MathRoundVolume100(obj) {
                  with (obj) return {
                    width: Math.min(100, Math.round(100 * volume)) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                "toggle_volume()": function (_toggle_volume2) {
                  function toggle_volume(_x438) {
                    return _toggle_volume2.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume2.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                }
              }).attachStringTable(Assets.strings).addStrings({
                "audio-progress": "Progress",
                "rerecord-audio": "Redo?",
                "submit-audio": "Confirm",
                "play-audio": "Play",
                "pause-audio": "Pause",
                "pause-audio-disabled": "Pause not supported",
                "elapsed-time": "Elapsed time",
                "total-time": "Total length of",
                "volume-button": "Set volume",
                "volume-mute": "Mute sound",
                "volume-unmute": "Unmute sound"
              });
            }), Scoped.define("module:AudioPlayer.Dynamics.Loader", ["dynamics:Dynamic", "module:Assets"], function (Class, Assets, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div class="{{cssplayer}}-loader-container">\n    <div data-selector="loader-block" class="{{cssplayer}}-loader-loader" title="{{string(\'tooltip\')}}">\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-audioplayer"
                  }
                };
              }).register("ba-audioplayer-loader").registerFunctions({
                cssplayer: function (_cssplayer7) {
                  function cssplayer(_x439) {
                    return _cssplayer7.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer7.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "string('tooltip')": function stringTooltip(obj) {
                  with (obj) return string("tooltip");
                }
              }).attachStringTable(Assets.strings).addStrings({
                tooltip: "Loading..."
              });
            }), Scoped.define("module:AudioPlayer.Dynamics.Message", ["dynamics:Dynamic"], ["dynamics:Partials.ClickPartial"], function (Class, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div class="{{css}}-message-container" ba-click="{{click()}}">\n    <div data-selector="message-block" class=\'{{css}}-message-message\'>\n        <p> {{message}} </p>\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-audioplayer",
                    message: ""
                  },
                  functions: {
                    click: function click() {
                      this.trigger("click");
                    }
                  }
                };
              }).registerFunctions({
                css: function (_css24) {
                  function css(_x440) {
                    return _css24.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css24.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click5) {
                  function click(_x441) {
                    return _click5.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click5.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                message: function (_message9) {
                  function message(_x442) {
                    return _message9.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message9.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message;
                })
              }).register("ba-audioplayer-message");
            }), Scoped.define("module:AudioPlayer.Dynamics.PlayerStates.State", ["base:States.State", "base:Events.ListenMixin", "base:Objs"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, [t, {
                dynamics: [],
                _start: function _start() {
                  this.dyn = this.host.dynamic, i.iter(i.extend({
                    loader: !1,
                    message: !1,
                    controlbar: !1
                  }, i.objectify(this.dynamics)), function (e, t) {
                    this.dyn.set(t + "_active", e);
                  }, this), this.dyn.parent() && "undefined" !== this.dyn.parent().record && "undefined" !== this.dyn.parent().host && (this.dyn._isRecorder = !0, this.dyn._recorderDyn = this.dyn.parent(), this.dyn._recorderHost = this.dyn._recorderDyn.host), this._started();
                },
                _started: function _started() {},
                play: function play() {
                  this.dyn.set("autoplay", !0);
                },
                nextToChooser: function nextToChooser(e) {
                  var t = this.dyn;
                  return !!t._isRecorder && "function" == typeof t._recorderHost.next && (t._recorderHost.next("FatalError", {
                    message: e,
                    retry: "Chooser"
                  }), !0);
                }
              }]);
            }), Scoped.define("module:AudioPlayer.Dynamics.PlayerStates.FatalError", ["module:AudioPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["message"],
                _locals: ["message"],
                _started: function _started() {
                  this.dyn.set("message", this._message || this.dyn.string("audio-error"));
                }
              });
            }), Scoped.define("module:AudioPlayer.Dynamics.PlayerStates.Initial", ["module:AudioPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.dyn.set("audioelement_active", !1), this.dyn.get("ready") ? this.next("LoadPlayer") : this.listenOn(this.dyn, "change:ready", function () {
                    this.next("LoadPlayer");
                  });
                }
              });
            }), Scoped.define("module:AudioPlayer.Dynamics.Player", ["dynamics:Dynamic", "module:Assets", "module:AudioVisualization", "browser:Info", "browser:Dom", "media:AudioPlayer.AudioPlayerWrapper", "base:Types", "base:Objs", "base:Strings", "base:Time", "base:Timers", "base:States.Host", "base:Classes.ClassRegistry", "base:Async", "module:AudioPlayer.Dynamics.PlayerStates.Initial", "module:AudioPlayer.Dynamics.PlayerStates", "browser:Events"], ["module:Common.Dynamics.Settingsmenu", "module:AudioPlayer.Dynamics.Message", "module:AudioPlayer.Dynamics.Loader", "module:AudioPlayer.Dynamics.Controlbar", "dynamics:Partials.EventPartial", "dynamics:Partials.OnPartial", "dynamics:Partials.TogglePartial", "dynamics:Partials.StylesPartial", "dynamics:Partials.TemplatePartial", "dynamics:Partials.HotkeyPartial"], function (Class, Assets, AudioVisualization, Info, Dom, AudioPlayerWrapper, Types, Objs, Strings, Time, Timers, Host, ClassRegistry, Async, InitialState, PlayerStates, DomEvents, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (t) {
                return {
                  template: '<div itemscope itemtype="http://schema.org/AudioObject"\n    class="{{css}}-container {{cssplayer}}-size-{{csssize}} {{iecss}}-{{ie8 ? \'ie8\' : \'noie8\'}} {{csstheme}}\n    {{cssplayer}}-normal-view {{cssplayer}}-common-browser {{cssplayer}}-{{themecolor}}-color\n    {{cssplayer}}-{{title ? \'has-title\' : \'no-title\'}} {{visualeffectvisible ? cssplayer + \'-visual-effect-applied\' : \'\'}}"\n\tba-styles="{{widthHeightStyles}}"\n>\n\t<canvas data-selector="audio-canvas" class="{{csstheme}}-audio-canvas" ba-on:click="{{toggle_player()}}"></canvas>\n    <audio crossorigin="anonymous" tabindex="-1" class="{{css}}-audio" data-audio="audio"></audio>\n    <div class="{{css}}-overlay">\n\t\t<div tabindex="-1" class="{{css}}-player-toggle-overlay" data-selector="player-toggle-overlay"\n\t\t\t ba-hotkey:right="{{seek(position + skipseconds)}}" ba-hotkey:left="{{seek(position - skipseconds)}}"\n\t\t\t ba-hotkey:alt+right="{{seek(position + skipseconds * 3)}}" ba-hotkey:alt+left="{{seek(position - skipseconds * 3)}}"\n\t\t\t ba-hotkey:up="{{set_volume(volume + 0.1)}}" ba-hotkey:down="{{set_volume(volume - 0.1)}}"\n\t\t\t ba-hotkey:space^enter="{{toggle_player()}}"\n\t\t\t ba-on:click="{{toggle_player()}}"\n\t\t></div>\n\t    <ba-{{dyncontrolbar}}\n\t\t    ba-css="{{csscontrolbar || css}}"\n\t\t\tba-cssplayer="{{cssplayer || css}}"\n\t\t\tba-csscommon="{{csscommon || css}}"\n\t\t\tba-csstheme="{{csstheme || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t    ba-template="{{tmplcontrolbar}}"\n\t\t    ba-show="{{controlbar_active}}"\n\t\t    ba-playing="{{playing}}"\n\t\t\tba-playwhenvisible="{{playwhenvisible}}"\n\t\t    ba-event:rerecord="rerecord"\n\t\t    ba-event:submit="submit"\n\t\t    ba-event:play="play"\n\t\t    ba-event:pause="pause"\n\t\t    ba-event:position="seek"\n\t\t    ba-event:volume="set_volume"\n\t\t\tba-event:tab_index_move="tab_index_move"\n\t\t\tba-event:seek="seek"\n\t\t\tba-event:set_volume="set_volume"\n\t\t\tba-event:settings_menu="toggle_settings_menu"\n\t\t\tba-tabindex="{{tabindex}}"\n\t\t    ba-volume="{{volume}}"\n\t\t    ba-duration="{{duration}}"\n\t\t    ba-cached="{{buffered}}"\n\t\t    ba-title="{{title}}"\n\t\t    ba-position="{{position}}"\n\t\t    ba-rerecordable="{{rerecordable}}"\n\t\t    ba-submittable="{{submittable}}"\n            ba-source="{{source}}"\n\t\t\tba-disablepause="{{disablepause}}"\n\t\t\tba-disableseeking="{{disableseeking}}"\n\t\t\tba-skipseconds="{{skipseconds}}"\n\t\t\tba-settingsmenubutton="{{showsettingsmenu}}"\n\t\t\tba-settingsmenuactive="{{settingsmenu_active}}"\n\t\t></ba-{{dyncontrolbar}}>\n\n\t\t<ba-{{dynloader}}\n\t\t    ba-css="{{cssloader || css}}"\n\t\t\tba-cssplayer="{{cssplayer || css}}"\n\t\t\tba-csscommon="{{csscommon || css}}"\n\t\t\tba-theme-color="{{themecolor}}"\n\t\t    ba-template="{{tmplloader}}"\n\t\t\tba-playwhenvisible="{{playwhenvisible}}"\n\t\t    ba-show="{{loader_active}}"\n\t\t></ba-{{dynloader}}>\n\n\t\t<ba-{{dynmessage}}\n\t\t    ba-css="{{cssmessage || css}}"\n\t\t\tba-cssplayer="{{cssplayer || css}}"\n\t\t\tba-csscommon="{{csscommon || css}}"\n\t\t\tba-theme-color="{{themecolor}}"\n\t\t    ba-template="{{tmplmessage}}"\n\t\t    ba-show="{{message_active}}"\n\t\t    ba-message="{{message}}"\n\t\t    ba-event:click="message_click"\n\t\t></ba-{{dynmessage}}>\n\n\t\t<ba-{{dynsettingsmenu}}\n\t\t\tba-css="{{css}}"\n\t\t\tba-csstheme="{{csstheme || css}}"\n\t\t\tba-show="{{settingsmenu_active}}"\n\t\t\tba-template="{{tmplsettingsmenu}}"\n\t\t></ba-{{dynsettingsmenu}}>\n\n\t\t<meta itemprop="caption" content="{{title}}" />\n\t\t<meta itemprop="contentUrl" content="{{source}}"/>\n\t</div>\n</div>\n',
                  attrs: {
                    css: "ba-audioplayer",
                    csscommon: "ba-commoncss",
                    cssplayer: "ba-player",
                    iecss: "ba-audioplayer",
                    cssloader: "",
                    cssmessage: "",
                    csscontrolbar: "",
                    width: "",
                    height: "",
                    theme: "",
                    csstheme: "",
                    themecolor: "",
                    dynloader: "audioplayer-loader",
                    dynmessage: "audioplayer-message",
                    dyncontrolbar: "audioplayer-controlbar",
                    dynsettingsmenu: "common-settingsmenu",
                    tmplloader: "",
                    tmplmessage: "",
                    tmplcontrolbar: "",
                    tmplsettingsmenu: "",
                    source: "",
                    sources: [],
                    sourcefilter: {},
                    playlist: null,
                    volume: 1,
                    title: "",
                    initialseek: null,
                    visibilityfraction: .8,
                    unmuted: !1,
                    reloadonplay: !1,
                    playonclick: !0,
                    pauseonclick: !0,
                    rerecordable: !1,
                    submittable: !1,
                    autoplay: !1,
                    preload: !1,
                    loop: !1,
                    loopall: !1,
                    ready: !0,
                    totalduration: null,
                    playwhenvisible: !1,
                    playedonce: !1,
                    manuallypaused: !1,
                    disablepause: !1,
                    disableseeking: !1,
                    postervisible: !1,
                    showsettingsmenu: !0,
                    visualeffectvisible: !1,
                    visualeffectsupported: !1,
                    visualeffectheight: null,
                    visualeffectminheight: 120,
                    visualeffecttheme: "red-bars",
                    skipseconds: 5,
                    initialoptions: {
                      volumelevel: null,
                      playlist: []
                    },
                    lastplaylistitem: !1,
                    forciblymuted: !1,
                    volumeafterinteraction: !1
                  },
                  types: {
                    rerecordable: "boolean",
                    loop: "boolean",
                    loopall: "boolean",
                    autoplay: "boolean",
                    preload: "boolean",
                    ready: "boolean",
                    volume: "float",
                    initialseek: "float",
                    themecolor: "string",
                    totalduration: "float",
                    playwhenvisible: "boolean",
                    playedonce: "boolean",
                    manuallypaused: "boolean",
                    disablepause: "boolean",
                    disableseeking: "boolean",
                    playonclick: "boolean",
                    pauseonclick: "boolean",
                    showsettings: "boolean",
                    skipseconds: "integer",
                    visualeffectvisible: "boolean",
                    visualeffectmode: "string",
                    visualeffectheight: "integer"
                  },
                  extendables: ["states"],
                  scopes: {
                    settingsmenu: ">[tagname='ba-common-settingsmenu']"
                  },
                  computed: {
                    "widthHeightStyles:width,height": function widthHeightStylesWidthHeight() {
                      var e = {},
                        t = this.get("width"),
                        i = this.get("height");
                      return t && (e.width = t + ((t + "").match(/^\d+$/g) ? "px" : "")), i && (e.height = i + ((i + "").match(/^\d+$/g) ? "px" : "")), e;
                    },
                    "buffering:buffered,position,last_position_change_delta,playing": function bufferingBufferedPositionLast_position_change_deltaPlaying() {
                      return this.get("playing") && this.get("buffered") < this.get("position") && 1e3 < this.get("last_position_change_delta");
                    }
                  },
                  events: {
                    "change:visualeffectsupported": function changeVisualeffectsupported(e) {
                      !e && this.audioVisualization && this.audioVisualization.destroy();
                    }
                  },
                  remove_on_destroy: !0,
                  create: function create() {
                    var e;
                    this.get("visualeffectvisible") && (!this.get("height") || this.get("height") < this.get("visualeffectminheight")) && this.set("height", this.get("visualeffectminheight")), this.set("initialoptions", Objs.tree_merge(this.get("initialoptions"), {
                      volumelevel: this.get("volume")
                    })), this.get("theme") && this.set("theme", this.get("theme").toLowerCase()), this.get("theme") in Assets.audioplayerthemes && Objs.iter(Assets.audioplayerthemes[this.get("theme")], function (e, t) {
                      this.isArgumentAttr(t) || this.set(t, e);
                    }, this), this.get("themecolor") || this.set("themecolor", "default"), this.get("playlist") && (e = this.get("playlist")[0], this.set("source", e.source), this.set("sources", e.sources)), this.set("ie8", Info.isInternetExplorer() && Info.internetExplorerVersion() < 9), this.set("duration", this.get("totalduration") || 0), this.set("position", 0), this.set("buffered", 0), this.set("message", ""), this.set("csssize", "normal"), this.set("loader_active", !1), this.set("controlbar_active", !1), this.set("message_active", !1), this.set("playing", !1), this.__attachRequested = !1, this.__activated = !1, this.__error = null, this.activeElement().onkeydown = this._keyDownActivity.bind(this, this.activeElement()), this.host = new Host({
                      stateRegistry: new ClassRegistry(this.cls.playerStates())
                    }), (this.host.dynamic = this).host.initialize(InitialState), this._timer = new Timers.Timer({
                      context: this,
                      fire: this._timerFire,
                      delay: 100,
                      start: !0
                    });
                  },
                  state: function state() {
                    return this.host.state();
                  },
                  audioAttached: function audioAttached() {
                    return !!this.player;
                  },
                  audioLoaded: function audioLoaded() {
                    return this.audioAttached() && this.player.loaded();
                  },
                  audioError: function audioError() {
                    return this.__error;
                  },
                  _error: function _error(e, t) {
                    this.__error = {
                      error_type: e,
                      error_code: t
                    }, this.trigger("error:" + e, t), this.trigger("error", e, t);
                  },
                  _clearError: function _clearError() {
                    this.__error = null;
                  },
                  _detachAudio: function _detachAudio() {
                    this.set("playing", !1), this.player && this.player.weakDestroy(), this.player = null, this.__audio = null, this.set("audioelement_active", !1);
                  },
                  _attachAudio: function _attachAudio() {
                    var i;
                    this.audioAttached() || (this.__activated ? (this.__attachRequested = !1, this.set("audioelement_active", !0), i = this.activeElement().querySelector("[data-audio='audio']"), this._clearError(), AudioPlayerWrapper.create(Objs.extend(this._getSources(), {
                      element: i,
                      preload: !!this.get("preload"),
                      loop: !!this.get("loop") || this.get("lastplaylistitem") && this.get("loopall"),
                      reloadonplay: !!this.get("reloadonplay")
                    })).error(function (e) {
                      this.destroyed() || this._error("attach", e);
                    }, this).success(function (t) {
                      if (!this.destroyed()) {
                        if (this.player = t, this.__audio = i, this.get("visualeffectvisible") && AudioVisualization.supported() && !this.audioVisualization) {
                          this.get("height") && this.get("height") > this.get("visualeffectminheight") ? this.set("visualeffectheight", this.get("height")) : this.get("visualeffectheight") < this.get("visualeffectminheight") && this.set("visualeffectheight", this.get("visualeffectminheight")), this.audioVisualization = new AudioVisualization(i, {
                            height: this.get("visualeffectheight"),
                            element: this.activeElement(),
                            theme: this.get("visualeffecttheme")
                          });
                          try {
                            this.audioVisualization.initializeVisualEffect(), this.set("visualeffectsupported", !0);
                          } catch (e) {
                            this.set("visualeffectsupported", !1), console.warn(e);
                          }
                        }
                        this.get("visualeffectvisible") && this.audioVisualization && (this.player.on("playing", function () {
                          this.audioVisualization.start();
                        }, this), this.player.on("paused", function () {
                          this.audioVisualization.pause();
                        }, this), this.player.on("ended", function () {
                          this.audioVisualization.stop();
                        }, this)), this.get("playwhenvisible") && this._playWhenVisible(i), Info.isChromiumBased() && this.get("forciblymuted") && (i.isMuted = !0, Dom.userInteraction(function () {
                          this.set_volume(this.get("initialoptions").volumelevel), 0 < this.get("volume") && (i.isMuted = !1), this.set("forciblymuted", !1);
                        }, this)), this.player.on("playing", function () {
                          this.set("playing", !0), this.trigger("playing");
                        }, this), this.player.on("error", function (e) {
                          this._error("audio", e);
                        }, this), this.player.error() && this.player.trigger("error", this.player.error()), this.player.on("paused", function () {
                          this.set("playing", !1), this.trigger("paused");
                        }, this), this.player.on("ended", function () {
                          this.set("playing", !1), this.set("playedonce", !0), this.set("settingsmenu_active", !1), this.trigger("ended");
                        }, this), this.trigger("attached", t), this.player.once("loaded", function () {
                          var e = Math.min(1, this.get("volume"));
                          this.player.setVolume(e), this.player.setMuted(e <= 0), this.trigger("loaded"), this.trigger("ready_to_play"), (this.get("totalduration") || this.player.duration() < Infinity) && this.set("duration", this.get("totalduration") || this.player.duration()), this.get("initialseek") && this.player.setPosition(this.get("initialseek"));
                        }, this), this.player.loaded() && this.player.trigger("loaded");
                      }
                    }, this)) : this.__attachRequested = !0);
                  },
                  _getSources: function _getSources() {
                    var t = this.get("sourcefilter");
                    return {
                      source: this.get("source"),
                      sources: t ? Objs.filter(this.get("sources"), function (e) {
                        return Objs.subset_of(t, e);
                      }, this) : this.get("sources")
                    };
                  },
                  _afterActivate: function _afterActivate(e) {
                    t._afterActivate.call(this, e), this.__activated = !0, this.__attachRequested && this._attachAudio(), this.__settingsMenu = this.scopes.settingsmenu, this.__settingsMenu.get("settings") && this.set("hassettings", !0);
                  },
                  _playWhenVisible: function _playWhenVisible(e) {
                    var t = this;
                    Dom.isElementVisible(e, this.get("visibilityfraction")) && this.player.play(), this._visiblityScrollEvent = this.auto_destroy(new DomEvents()), this._visiblityScrollEvent.on(document, "scroll", function () {
                      t.get("playedonce") || t.get("manuallypaused") ? t.get("playing") && !Dom.isElementVisible(e, t.get("visibilityfraction")) && t.player.pause() : Dom.isElementVisible(e, t.get("visibilityfraction")) ? t.player.play() : t.get("playing") && t.player.pause();
                    });
                  },
                  reattachAudio: function reattachAudio() {
                    this.set("reloadonplay", !0), this._detachAudio(), this._attachAudio();
                  },
                  _keyDownActivity: function _keyDownActivity(e, t) {
                    var i = t.which || t.keyCode;
                    32 !== i && 37 !== i && 38 !== i && 39 !== i && 40 !== i || t.preventDefault(), 9 === i && t.shiftKey ? this._findNextTabStop(e, t, function (e, t) {
                      e.focus();
                    }, -1) : 9 === i && this._findNextTabStop(e, t, function (e, t) {
                      e.focus();
                    });
                  },
                  _findNextTabStop: function _findNextTabStop(e, t, i, r) {
                    var o,
                      a,
                      n,
                      s,
                      x = o = 0,
                      c = r || 1,
                      d = t.target.tabIndex,
                      l = e.querySelectorAll("[tabindex]");
                    if (l = Array.prototype.slice.call(l, 0).filter(function (e) {
                      return (0 < e.clientWidth || 0 < e.clientHeight) && -1 !== e.tabIndex && (x <= e.tabIndex && (x = e.tabIndex), o >= e.tabIndex && (o = e.tabIndex), !0);
                    }), 1 === c && d === x || -1 === r && d === o || 0 === x) 1 < document.querySelectorAll("ba-audioplayer").length && (this.get("playing") && this.player.pause(), e.tabIndex = -1, e.blur());else {
                      for (var u = 0; u < l.length; u++) l[u] && (s = (n = l[u].tabIndex) - d, n < o || x < n || Math.sign(s) !== c || (!a || Math.abs(s) < Math.abs(a.tabIndex - d)) && (a = l[u]));
                      a && (t.preventDefault(), i(a, a.tabIndex));
                    }
                  },
                  object_functions: ["play", "rerecord", "pause", "stop", "seek", "set_volume"],
                  functions: {
                    message_click: function message_click() {
                      this.trigger("message:click");
                    },
                    play: function play() {
                      this.host.state().play(), this.set("manuallypaused", !1);
                    },
                    rerecord: function rerecord() {
                      this.get("rerecordable") && this.trigger("rerecord");
                    },
                    submit: function submit() {
                      this.get("submittable") && (this.trigger("submit"), this.set("submittable", !1), this.set("rerecordable", !1));
                    },
                    pause: function pause() {
                      this.get("disablepause") || (this.get("playing") && this.player.pause(), this.get("playwhenvisible") && this.set("manuallypaused", !0));
                    },
                    stop: function stop() {
                      this.audioLoaded() && (this.get("playing") && this.player.pause(), this.player.setPosition(0), this.trigger("stopped"));
                    },
                    seek: function seek(e) {
                      this.get("disableseeking") || this.audioLoaded() && (e > this.player.duration() ? this.player.setPosition(this.player.duration() - this.get("skipseconds")) : (this.player.setPosition(e), this.trigger("seek", e)));
                    },
                    set_volume: function set_volume(e) {
                      e = (e = Math.min(1, e)) <= 0 ? 0 : e, this.set("volume", e), this.audioLoaded() && (this.player.setVolume(e), this.player.setMuted(e <= 0));
                    },
                    tab_index_move: function tab_index_move(e, t, i) {
                      var r,
                        o,
                        a = e.which || e.keyCode,
                        n = this.activeElement();
                      13 === a || 32 === a ? i ? (o = "[data-selector='" + i + "']", (r = n.querySelector(o)) && Async.eventually(function () {
                        this.trigger("keyboardusecase", n), r.focus({
                          preventScroll: !1
                        });
                      }, this, 100)) : (o = '[data-audio="audio"]', r = n.querySelector(o), Async.eventually(function () {
                        this.trigger("keyboardusecase", n), r.focus({
                          preventScroll: !0
                        });
                      }, this, 100)) : 9 === a && t && (o = "[data-selector='" + t + "']", (r = n.querySelector(o)) && Async.eventually(function () {
                        this.trigger("keyboardusecase", n), r.focus({
                          preventScroll: !1
                        });
                      }, this, 100));
                    },
                    toggle_settings_menu: function toggle_settings_menu() {
                      this.set("settingsmenu_active", !this.get("settingsmenu_active"));
                    },
                    toggle_player: function toggle_player() {
                      this.get("playing") && this.get("pauseonclick") ? this.pause() : !this.get("playing") && this.get("playonclick") && this.play();
                    }
                  },
                  destroy: function destroy() {
                    this._timer.destroy(), this.host.destroy(), this._detachAudio(), t.destroy.call(this);
                  },
                  _timerFire: function _timerFire() {
                    if (!this.destroyed()) {
                      try {
                        var t, i, r;
                        this.audioLoaded() && (t = Time.now(), (i = this.player.position()) === this.get("position") && !this.get("last_position_change") || this.set("last_position_change", t), this.set("last_position_change_delta", t - this.get("last_position_change")), this.set("position", i), this.set("buffered", this.player.buffered()), r = this.player.duration(), this.get("totalduration") ? this.set("duration", this.get("totalduration")) : 0 < r && r < Infinity ? this.set("duration", this.player.duration()) : this.set("duration", i));
                      } catch (e) {}
                      try {
                        this._updateCSSSize();
                      } catch (e) {}
                    }
                  },
                  _updateCSSSize: function _updateCSSSize() {
                    var e = Dom.elementDimensions(this.activeElement()).width;
                    this.set("csssize", 400 < e ? "normal" : 300 < e ? "medium" : "small");
                  },
                  cloneAttrs: function cloneAttrs() {
                    return Objs.map(this.attrs, function (e, t) {
                      return this.get(t);
                    }, this);
                  }
                };
              }, {
                playerStates: function playerStates() {
                  return [PlayerStates];
                }
              }).register("ba-audioplayer").registerFunctions({
                css: function (_css25) {
                  function css(_x443) {
                    return _css25.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css25.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                cssplayer: function (_cssplayer8) {
                  function cssplayer(_x444) {
                    return _cssplayer8.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer8.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                csssize: function (_csssize5) {
                  function csssize(_x445) {
                    return _csssize5.apply(this, arguments);
                  }
                  csssize.toString = function () {
                    return _csssize5.toString();
                  };
                  return csssize;
                }(function (obj) {
                  with (obj) return csssize;
                }),
                iecss: function (_iecss5) {
                  function iecss(_x446) {
                    return _iecss5.apply(this, arguments);
                  }
                  iecss.toString = function () {
                    return _iecss5.toString();
                  };
                  return iecss;
                }(function (obj) {
                  with (obj) return iecss;
                }),
                "ie8 ? 'ie8' : 'noie8'": function ie8Ie8Noie8(obj) {
                  with (obj) return ie8 ? "ie8" : "noie8";
                },
                csstheme: function (_csstheme6) {
                  function csstheme(_x447) {
                    return _csstheme6.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme6.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                themecolor: function (_themecolor5) {
                  function themecolor(_x448) {
                    return _themecolor5.apply(this, arguments);
                  }
                  themecolor.toString = function () {
                    return _themecolor5.toString();
                  };
                  return themecolor;
                }(function (obj) {
                  with (obj) return themecolor;
                }),
                "title ? 'has-title' : 'no-title'": function titleHasTitleNoTitle(obj) {
                  with (obj) return title ? "has-title" : "no-title";
                },
                "visualeffectvisible ? cssplayer + '-visual-effect-applied' : ''": function visualeffectvisibleCssplayerVisualEffectApplied(obj) {
                  with (obj) return visualeffectvisible ? cssplayer + "-visual-effect-applied" : "";
                },
                widthHeightStyles: function (_widthHeightStyles3) {
                  function widthHeightStyles(_x449) {
                    return _widthHeightStyles3.apply(this, arguments);
                  }
                  widthHeightStyles.toString = function () {
                    return _widthHeightStyles3.toString();
                  };
                  return widthHeightStyles;
                }(function (obj) {
                  with (obj) return widthHeightStyles;
                }),
                "toggle_player()": function (_toggle_player3) {
                  function toggle_player(_x450) {
                    return _toggle_player3.apply(this, arguments);
                  }
                  toggle_player.toString = function () {
                    return _toggle_player3.toString();
                  };
                  return toggle_player;
                }(function (obj) {
                  with (obj) return toggle_player();
                }),
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "seek(position + skipseconds * 3)": function seekPositionSkipseconds3(obj) {
                  with (obj) return seek(position + 3 * skipseconds);
                },
                "seek(position - skipseconds * 3)": function seekPositionSkipseconds3(obj) {
                  with (obj) return seek(position - 3 * skipseconds);
                },
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                dyncontrolbar: function (_dyncontrolbar5) {
                  function dyncontrolbar(_x451) {
                    return _dyncontrolbar5.apply(this, arguments);
                  }
                  dyncontrolbar.toString = function () {
                    return _dyncontrolbar5.toString();
                  };
                  return dyncontrolbar;
                }(function (obj) {
                  with (obj) return dyncontrolbar;
                }),
                "csscontrolbar || css": function csscontrolbarCss(obj) {
                  with (obj) return csscontrolbar || css;
                },
                "cssplayer || css": function cssplayerCss(obj) {
                  with (obj) return cssplayer || css;
                },
                "csscommon || css": function csscommonCss(obj) {
                  with (obj) return csscommon || css;
                },
                "csstheme || css": function cssthemeCss(obj) {
                  with (obj) return csstheme || css;
                },
                tmplcontrolbar: function (_tmplcontrolbar5) {
                  function tmplcontrolbar(_x452) {
                    return _tmplcontrolbar5.apply(this, arguments);
                  }
                  tmplcontrolbar.toString = function () {
                    return _tmplcontrolbar5.toString();
                  };
                  return tmplcontrolbar;
                }(function (obj) {
                  with (obj) return tmplcontrolbar;
                }),
                controlbar_active: function (_controlbar_active4) {
                  function controlbar_active(_x453) {
                    return _controlbar_active4.apply(this, arguments);
                  }
                  controlbar_active.toString = function () {
                    return _controlbar_active4.toString();
                  };
                  return controlbar_active;
                }(function (obj) {
                  with (obj) return controlbar_active;
                }),
                playing: function (_playing6) {
                  function playing(_x454) {
                    return _playing6.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing6.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                playwhenvisible: function (_playwhenvisible2) {
                  function playwhenvisible(_x455) {
                    return _playwhenvisible2.apply(this, arguments);
                  }
                  playwhenvisible.toString = function () {
                    return _playwhenvisible2.toString();
                  };
                  return playwhenvisible;
                }(function (obj) {
                  with (obj) return playwhenvisible;
                }),
                tabindex: function (_tabindex3) {
                  function tabindex(_x456) {
                    return _tabindex3.apply(this, arguments);
                  }
                  tabindex.toString = function () {
                    return _tabindex3.toString();
                  };
                  return tabindex;
                }(function (obj) {
                  with (obj) return tabindex;
                }),
                volume: function (_volume2) {
                  function volume(_x457) {
                    return _volume2.apply(this, arguments);
                  }
                  volume.toString = function () {
                    return _volume2.toString();
                  };
                  return volume;
                }(function (obj) {
                  with (obj) return volume;
                }),
                duration: function (_duration3) {
                  function duration(_x458) {
                    return _duration3.apply(this, arguments);
                  }
                  duration.toString = function () {
                    return _duration3.toString();
                  };
                  return duration;
                }(function (obj) {
                  with (obj) return duration;
                }),
                buffered: function (_buffered2) {
                  function buffered(_x459) {
                    return _buffered2.apply(this, arguments);
                  }
                  buffered.toString = function () {
                    return _buffered2.toString();
                  };
                  return buffered;
                }(function (obj) {
                  with (obj) return buffered;
                }),
                title: function (_title6) {
                  function title(_x460) {
                    return _title6.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title6.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                position: function (_position2) {
                  function position(_x461) {
                    return _position2.apply(this, arguments);
                  }
                  position.toString = function () {
                    return _position2.toString();
                  };
                  return position;
                }(function (obj) {
                  with (obj) return position;
                }),
                rerecordable: function (_rerecordable6) {
                  function rerecordable(_x462) {
                    return _rerecordable6.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable6.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                submittable: function (_submittable6) {
                  function submittable(_x463) {
                    return _submittable6.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable6.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                source: function (_source3) {
                  function source(_x464) {
                    return _source3.apply(this, arguments);
                  }
                  source.toString = function () {
                    return _source3.toString();
                  };
                  return source;
                }(function (obj) {
                  with (obj) return source;
                }),
                disablepause: function (_disablepause2) {
                  function disablepause(_x465) {
                    return _disablepause2.apply(this, arguments);
                  }
                  disablepause.toString = function () {
                    return _disablepause2.toString();
                  };
                  return disablepause;
                }(function (obj) {
                  with (obj) return disablepause;
                }),
                disableseeking: function (_disableseeking2) {
                  function disableseeking(_x466) {
                    return _disableseeking2.apply(this, arguments);
                  }
                  disableseeking.toString = function () {
                    return _disableseeking2.toString();
                  };
                  return disableseeking;
                }(function (obj) {
                  with (obj) return disableseeking;
                }),
                skipseconds: function (_skipseconds2) {
                  function skipseconds(_x467) {
                    return _skipseconds2.apply(this, arguments);
                  }
                  skipseconds.toString = function () {
                    return _skipseconds2.toString();
                  };
                  return skipseconds;
                }(function (obj) {
                  with (obj) return skipseconds;
                }),
                showsettingsmenu: function (_showsettingsmenu2) {
                  function showsettingsmenu(_x468) {
                    return _showsettingsmenu2.apply(this, arguments);
                  }
                  showsettingsmenu.toString = function () {
                    return _showsettingsmenu2.toString();
                  };
                  return showsettingsmenu;
                }(function (obj) {
                  with (obj) return showsettingsmenu;
                }),
                settingsmenu_active: function (_settingsmenu_active2) {
                  function settingsmenu_active(_x469) {
                    return _settingsmenu_active2.apply(this, arguments);
                  }
                  settingsmenu_active.toString = function () {
                    return _settingsmenu_active2.toString();
                  };
                  return settingsmenu_active;
                }(function (obj) {
                  with (obj) return settingsmenu_active;
                }),
                dynloader: function (_dynloader4) {
                  function dynloader(_x470) {
                    return _dynloader4.apply(this, arguments);
                  }
                  dynloader.toString = function () {
                    return _dynloader4.toString();
                  };
                  return dynloader;
                }(function (obj) {
                  with (obj) return dynloader;
                }),
                "cssloader || css": function cssloaderCss(obj) {
                  with (obj) return cssloader || css;
                },
                tmplloader: function (_tmplloader4) {
                  function tmplloader(_x471) {
                    return _tmplloader4.apply(this, arguments);
                  }
                  tmplloader.toString = function () {
                    return _tmplloader4.toString();
                  };
                  return tmplloader;
                }(function (obj) {
                  with (obj) return tmplloader;
                }),
                loader_active: function (_loader_active4) {
                  function loader_active(_x472) {
                    return _loader_active4.apply(this, arguments);
                  }
                  loader_active.toString = function () {
                    return _loader_active4.toString();
                  };
                  return loader_active;
                }(function (obj) {
                  with (obj) return loader_active;
                }),
                dynmessage: function (_dynmessage5) {
                  function dynmessage(_x473) {
                    return _dynmessage5.apply(this, arguments);
                  }
                  dynmessage.toString = function () {
                    return _dynmessage5.toString();
                  };
                  return dynmessage;
                }(function (obj) {
                  with (obj) return dynmessage;
                }),
                "cssmessage || css": function cssmessageCss(obj) {
                  with (obj) return cssmessage || css;
                },
                tmplmessage: function (_tmplmessage5) {
                  function tmplmessage(_x474) {
                    return _tmplmessage5.apply(this, arguments);
                  }
                  tmplmessage.toString = function () {
                    return _tmplmessage5.toString();
                  };
                  return tmplmessage;
                }(function (obj) {
                  with (obj) return tmplmessage;
                }),
                message_active: function (_message_active5) {
                  function message_active(_x475) {
                    return _message_active5.apply(this, arguments);
                  }
                  message_active.toString = function () {
                    return _message_active5.toString();
                  };
                  return message_active;
                }(function (obj) {
                  with (obj) return message_active;
                }),
                message: function (_message10) {
                  function message(_x476) {
                    return _message10.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message10.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message;
                }),
                dynsettingsmenu: function (_dynsettingsmenu2) {
                  function dynsettingsmenu(_x477) {
                    return _dynsettingsmenu2.apply(this, arguments);
                  }
                  dynsettingsmenu.toString = function () {
                    return _dynsettingsmenu2.toString();
                  };
                  return dynsettingsmenu;
                }(function (obj) {
                  with (obj) return dynsettingsmenu;
                }),
                tmplsettingsmenu: function (_tmplsettingsmenu2) {
                  function tmplsettingsmenu(_x478) {
                    return _tmplsettingsmenu2.apply(this, arguments);
                  }
                  tmplsettingsmenu.toString = function () {
                    return _tmplsettingsmenu2.toString();
                  };
                  return tmplsettingsmenu;
                }(function (obj) {
                  with (obj) return tmplsettingsmenu;
                })
              }).attachStringTable(Assets.strings).addStrings({
                "audio-error": "An error occurred, please try again later. Click to retry.",
                "all-settings": "All settings"
              });
            }), Scoped.define("module:AudioPlayer.Dynamics.PlayerStates.LoadPlayer", ["module:AudioPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.listenOn(this.dyn, "error:attach", function () {
                    this.next("LoadError");
                  }, this), this.listenOn(this.dyn, "attached", function () {
                    this.next("LoadAudio");
                  }, this), this.dyn.reattachAudio();
                }
              });
            }), Scoped.define("module:AudioPlayer.Dynamics.PlayerStates.LoadError", ["module:AudioPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["message"],
                _started: function _started() {
                  this.dyn.set("message", this.dyn.string("audio-error")), this.listenOn(this.dyn, "message:click", function () {
                    this.next("LoadPlayer");
                  }, this);
                }
              });
            }), Scoped.define("module:AudioPlayer.Dynamics.PlayerStates.LoadAudio", ["module:AudioPlayer.Dynamics.PlayerStates.State", "browser:Info", "browser:Dom", "base:Timers.Timer"], function (t, i, r, o, a) {
              return t.extend({
                scoped: a
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.dyn.get("audioelement_active") ? this.__loadAudio() : (this.listenOn(this.dyn, "error:attach", function () {
                    this.next("LoadError");
                  }, this), this.listenOn(this.dyn, "attached", function () {
                    this.__loadAudio();
                  }, this), this.dyn.reattachAudio());
                },
                __loadAudio: function __loadAudio() {
                  var i;
                  this.listenOn(this.dyn, "error:audio", function () {
                    this.next("ErrorAudio");
                  }, this), this.listenOn(this.dyn, "playing", function () {
                    this.destroyed() || this.dyn.destroyed() || (this.dyn.get("autoseek") && this.dyn.execute("seek", this.dyn.get("autoseek")), this.next("PlayAudio"));
                  }, this), this.dyn.get("autoplay") ? (i = 10, this.auto_destroy(new o({
                    context: this,
                    fire: function fire() {
                      if (!this.destroyed() && !this.dyn.destroyed() && this.dyn.player) try {
                        var t = this.dyn.player.play();
                        t && t.success(function () {
                          this.next("PlayAudio");
                        });
                      } catch (e) {}
                      0 === --i && this.next("PlayAudio");
                    },
                    delay: 200,
                    immediate: !0
                  }))) : this.next("PlayAudio");
                }
              });
            }), Scoped.define("module:AudioPlayer.Dynamics.PlayerStates.ErrorAudio", ["module:AudioPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["message"],
                _started: function _started() {
                  this.dyn.set("message", this.dyn.string("audio-error")), this.listenOn(this.dyn, "message:click", function () {
                    this.nextToChooser(this.dyn.get("message")) ? this.next("Initial") : this.next("LoadAudio");
                  }, this);
                }
              });
            }), Scoped.define("module:AudioPlayer.Dynamics.PlayerStates.PlayAudio", ["module:AudioPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["controlbar"],
                _started: function _started() {
                  this.dyn.trigger("loaded"), this.dyn.set("autoplay", !1), this.listenOn(this.dyn, "ended", function () {
                    this.dyn.set("autoseek", null), this.next("NextAudio");
                  }, this), this.listenOn(this.dyn, "change:buffering", function () {
                    this.dyn.set("loader_active", this.dyn.get("buffering"));
                  }, this), this.listenOn(this.dyn, "error:audio", function () {
                    this.next("ErrorAudio");
                  }, this);
                },
                play: function play() {
                  this.dyn.get("playing") || this.dyn.player.play();
                }
              });
            }), Scoped.define("module:AudioPlayer.Dynamics.PlayerStates.NextAudio", ["module:AudioPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                _started: function _started() {
                  if (this.dyn.get("playlist")) {
                    var e,
                      t,
                      i = this.dyn.get("playlist"),
                      r = i.shift();
                    if (this.dyn.get("initialoptions").playlist.push(r), 0 < i.length) return e = i[0], this.dyn.set("source", e.source), this.dyn.set("sources", e.sources), this._playNext(e);
                    if (t = this.dyn.get("initialoptions").playlist, this.dyn.set("lastplaylistitem", !0), this.dyn.trigger("last-playlist-item"), this.dyn.set("playlist", t), this.dyn.get("initialoptions").playlist = [], e = t[0], this.dyn.set("source", e.source), this.dyn.set("sources", e.sources), this.dyn.get("loopall")) return this._playNext(e);
                    this.dyn.reattachAudio();
                  } else this.dyn.get("loopall") && (this.dyn.set("loop", !0), this.dyn.set("autoplay", !0), this.dyn.reattachAudio());
                  this.next("LoadAudio");
                },
                _playNext: function _playNext(e) {
                  this.dyn.trigger("playlist-next", e), this.dyn.set("autoplay", !0), this.next("LoadAudio");
                }
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.Chooser", ["dynamics:Dynamic", "module:Assets", "browser:Info"], ["dynamics:Partials.ClickPartial", "dynamics:Partials.IfPartial"], function (Class, Assets, Info, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<div class="{{css}}-chooser-container">\n\t<div class="{{css}}-chooser-button-container">\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t tabindex="0" class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t     ba-click="{{click_action(action)}}"\n\t\t\t>\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   />\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n',
                  attrs: {
                    css: "ba-audiorecorder",
                    cssrecorder: "ba-recorder",
                    allowrecord: !0,
                    allowupload: !0,
                    primaryrecord: !0,
                    recordviafilecapture: !1,
                    allowcustomupload: !0,
                    allowedextensions: null
                  },
                  types: {
                    allowedextensions: "array",
                    recordviafilecapture: "boolean"
                  },
                  collections: ["actions"],
                  create: function create() {
                    var i = "";
                    this.get("allowedextensions") && 0 < this.get("allowedextensions").length ? (Info.isEdge() || Info.isChrome() || Info.isOpera() || Info.isFirefox() && 42 <= Info.firefoxVersion() || Info.isInternetExplorer() && 10 <= Info.internetExplorerVersion()) && (i = "." + this.get("allowedextensions").join(",.")) : this.get("allowcustomupload") || (i = "audio/*,audio/mp3");
                    var e = [];
                    this.get("primaryrecord") ? (this.get("allowrecord") && e.push("record"), this.get("allowupload") && e.push("upload")) : (this.get("allowupload") && e.push("upload"), this.get("allowrecord") && e.push("record"));
                    var r = this.get("actions");
                    e.forEach(function (e, t) {
                      switch (e) {
                        case "record":
                          r.add({
                            type: "record",
                            index: t,
                            icon: "volume-up",
                            label: this.string("record-audio"),
                            select: Info.isMobile() && !(Info.isAndroid() && Info.isCordova()) && this.get("recordviafilecapture"),
                            capture: !0,
                            accept: "audio/*,audio/mp3;capture=camcorder"
                          });
                          break;
                        case "upload":
                          r.add({
                            type: "upload",
                            index: t,
                            icon: "upload",
                            label: this.string("upload-audio"),
                            select: !(Info.isiOS() && Info.isCordova()),
                            accept: !Info.isMobile() || Info.isAndroid() && Info.isCordova() ? i : "audio/*,audio/mp3"
                          });
                      }
                    }, this);
                  },
                  functions: {
                    click_action: function click_action(e) {
                      var t;
                      e.get("select") || (Info.isMobile() && Info.isCordova() ? (t = this, Info.isAndroid() ? navigator.device.capture.captureAudio(function (e) {
                        t.trigger("upload", e[0]);
                      }, function (e) {}, {
                        limit: 1,
                        duration: this.get("timelimit")
                      }) : Info.isiOS() && navigator.camera.getPicture(function (e) {
                        t.trigger("upload", {
                          localURL: e,
                          fullPath: e
                        });
                      }, function (e) {}, {
                        destinationType: Camera.DestinationType.FILE_URI,
                        sourceType: Camera.PictureSourceType.PHOTOLIBRARY,
                        mediaType: Camera.MediaType.AUDIO
                      })) : this.trigger("record"));
                    },
                    select_file_action: function select_file_action(e, t) {
                      e.get("select") && this.trigger("upload", t[0].target);
                    }
                  }
                };
              }).registerFunctions({
                css: function (_css26) {
                  function css(_x479) {
                    return _css26.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css26.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                actions: function (_actions3) {
                  function actions(_x480) {
                    return _actions3.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions3.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                csscommon: function (_csscommon14) {
                  function csscommon(_x481) {
                    return _csscommon14.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon14.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                }
              }).register("ba-audiorecorder-chooser").attachStringTable(Assets.strings).addStrings({
                "record-audio": "Record Audio",
                "upload-audio": "Upload Audio"
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.Controlbar", ["dynamics:Dynamic", "module:Assets", "base:Timers.Timer"], ["dynamics:Partials.ShowPartial", "dynamics:Partials.RepeatPartial"], function (Class, Assets, Timer, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '<div class="{{css}}-dashboard">\n\t<div class="{{css}}-backbar"></div>\n\t<div data-selector="recorder-settings" class="{{css}}-settings" ba-show="{{settingsvisible && settingsopen}}">\n\t\t<div class="{{css}}-settings-backbar"></div>\n\t\t<div data-selector="settings-list-front" class="{{css}}-settings-front">\n\t\t\t<ul data-selector="microphone-settings" ba-repeat="{{microphone :: microphones}}">\n\t\t\t\t<li tabindex="0"\n\t\t\t\t\tba-hotkey:space^enter="{{selectMicrophone(microphone.id)}}" onmouseout="this.blur()"\n\t\t\t\t\tonclick="{{selectMicrophone(microphone.id)}}"\n\t\t\t\t>\n\t\t\t\t\t<input type=\'radio\' name=\'microphone\' value="{{selectedmicrophone == microphone.id}}" />\n\t\t\t\t\t<span></span>\n\t\t\t\t\t<label>\n\t\t\t\t\t\t{{microphone.label}}\n\t\t\t\t\t</label>\n\t\t\t\t </li>\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n        <div class="{{css}}-leftbutton-container" ba-show="{{settingsvisible}}">\n            <div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{settingsopen=!settingsopen}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="record-button-icon-cog" class="{{css}}-button-inner {{css}}-button-{{settingsopen ? \'selected\' : \'unselected\'}}"\n                 onclick="{{settingsopen=!settingsopen}}"\n                 onmouseenter="{{hover(string(\'settings\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                <i class="{{csscommon}}-icon-cog"></i>\n            </div>\n        </div>\n\n        <div class="{{css}}-lefticon-container" ba-show="{{settingsvisible}}">\n            <div data-selector="record-button-icon-mic" class="{{csscommon}}-icon-inner"\n                 onmouseenter="{{hover(string(microphonehealthy ? \'microphonehealthy\' : \'microphoneunhealthy\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                <i class="{{csscommon}}-icon-mic {{csscommon}}-icon-state-{{microphonehealthy ? \'good\' : \'bad\' }}"></i>\n            </div>\n        </div>\n\n        <div class="{{css}}-lefticon-container" ba-show="{{stopvisible && recordingindication}}">\n            <div data-selector="recording-indicator" class="{{css}}-recording-indication">\n            </div>\n        </div>\n\n        <div class="{{css}}-label-container" ba-show="{{controlbarlabel}}">\n        \t<div data-selector="record-label-block" class="{{css}}-label-label">\n        \t\t{{controlbarlabel}}\n        \t</div>\n        </div>\n\n        <div class="{{css}}-rightbutton-container" ba-show="{{recordvisible}}">\n        \t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="record-primary-button" class="{{css}}-button-primary"\n                 onclick="{{record()}}"\n                 onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n        \t\t{{string(\'record\')}}\n        \t</div>\n        </div>\n\n        <div class="{{css}}-rightbutton-container" ba-show="{{rerecordvisible}}">\n        \t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="rerecord-primary-button" class="{{css}}-button-primary"\n                 onclick="{{rerecord()}}"\n                 onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n        \t\t{{string(\'rerecord\')}}\n        \t</div>\n        </div>\n\n\t\t<div class="{{css}}-rightbutton-container" ba-show="{{cancelvisible}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="cancel-primary-button" class="{{css}}-button-primary"\n\t\t\t\t onclick="{{cancel()}}"\n\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t>\n\t\t\t\t{{string(\'cancel\')}}\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-rightbutton-container" ba-show="{{stopvisible}}">\n        \t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="stop-primary-button" class="{{css}}-button-primary {{mintimeindicator ? css + \'-disabled\': \'\'}}"\n\t\t\t\t title="{{mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\')}}"\n                 onclick="{{stop()}}"\n                 onmouseenter="{{hover( mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n        \t\t{{string(\'stop\')}}\n        \t</div>\n        </div>\n\n\t\t<div class="{{css}}-rightbutton-container" ba-show="{{pausable && !resumevisible && stopvisible}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="pause-primary-button" class="{{css}}-button-primary"\n\t\t\t\t title="{{string(\'pause-recorder\')}}"\n\t\t\t\t onclick="{{pause()}}"\n\t\t\t\t onmouseenter="{{hover(string(\'pause-recorder\'))}}"\n\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t>\n\t\t\t\t<i class="{{csscommon}}-icon-pause"></i>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="{{css}}-rightbutton-container" ba-show="{{pausable && resumevisible}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{resume()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="resume-primary-button" class="{{css}}-button-primary"\n\t\t\t\t title="{{string(\'resume-recorder\')}}"\n\t\t\t\t onclick="{{resume()}}"\n\t\t\t\t onmouseenter="{{hover(string(\'resume-recorder\'))}}"\n\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t>\n\t\t\t\t<i class="{{csscommon}}-icon-ccw"></i>\n\t\t\t</div>\n\t\t</div>\n\n\n\t</div>\n</div>\n',
                  attrs: {
                    css: "ba-audiorecorder",
                    csscommon: "ba-commoncss",
                    cssrecorder: "ba-recorder",
                    hovermessage: "",
                    recordingindication: !0
                  },
                  create: function create() {
                    this.auto_destroy(new Timer({
                      context: this,
                      fire: function fire() {
                        this.set("recordingindication", !this.get("recordingindication") && !this.__parent.__paused);
                      },
                      delay: 500
                    }));
                  },
                  functions: {
                    selectMicrophone: function selectMicrophone(e) {
                      this.set("settingsopen", !1), this.trigger("select-microphone", e);
                    },
                    hover: function hover(e) {
                      this.set("hovermessage", e);
                    },
                    unhover: function unhover() {
                      this.set("hovermessage", "");
                    },
                    record: function record() {
                      this.trigger("invoke-record");
                    },
                    rerecord: function rerecord() {
                      this.trigger("invoke-rerecord");
                    },
                    pause: function pause() {
                      this.trigger("invoke-pause");
                    },
                    resume: function resume() {
                      this.trigger("invoke-resume");
                    },
                    stop: function stop() {
                      this.trigger("invoke-stop");
                    },
                    cancel: function cancel() {
                      this.trigger("invoke-cancel");
                    }
                  }
                };
              }).register("ba-audiorecorder-controlbar").registerFunctions({
                css: function (_css27) {
                  function css(_x482) {
                    return _css27.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css27.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "settingsvisible && settingsopen": function settingsvisibleSettingsopen(obj) {
                  with (obj) return settingsvisible && settingsopen;
                },
                microphones: function (_microphones3) {
                  function microphones(_x483) {
                    return _microphones3.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones3.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                "selectMicrophone(microphone.id)": function selectMicrophoneMicrophoneId(obj) {
                  with (obj) return selectMicrophone(microphone.id);
                },
                "selectedmicrophone == microphone.id": function selectedmicrophoneMicrophoneId(obj) {
                  with (obj) return selectedmicrophone == microphone.id;
                },
                "microphone.label": function microphoneLabel(obj) {
                  with (obj) return microphone.label;
                },
                settingsvisible: function (_settingsvisible5) {
                  function settingsvisible(_x484) {
                    return _settingsvisible5.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible5.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                "unhover()": function (_unhover3) {
                  function unhover(_x485) {
                    return _unhover3.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover3.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                csscommon: function (_csscommon15) {
                  function csscommon(_x486) {
                    return _csscommon15.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon15.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "hover(string(microphonehealthy ? 'microphonehealthy' : 'microphoneunhealthy'))": function hoverStringMicrophonehealthyMicrophonehealthyMicrophoneunhealthy(obj) {
                  with (obj) return hover(string(microphonehealthy ? "microphonehealthy" : "microphoneunhealthy"));
                },
                "microphonehealthy ? 'good' : 'bad'": function microphonehealthyGoodBad(obj) {
                  with (obj) return microphonehealthy ? "good" : "bad";
                },
                "stopvisible && recordingindication": function stopvisibleRecordingindication(obj) {
                  with (obj) return stopvisible && recordingindication;
                },
                controlbarlabel: function (_controlbarlabel5) {
                  function controlbarlabel(_x487) {
                    return _controlbarlabel5.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel5.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                recordvisible: function (_recordvisible5) {
                  function recordvisible(_x488) {
                    return _recordvisible5.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible5.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record3) {
                  function record(_x489) {
                    return _record3.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record3.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                rerecordvisible: function (_rerecordvisible5) {
                  function rerecordvisible(_x490) {
                    return _rerecordvisible5.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible5.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord7) {
                  function rerecord(_x491) {
                    return _rerecord7.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord7.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible3) {
                  function cancelvisible(_x492) {
                    return _cancelvisible3.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible3.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel3) {
                  function cancel(_x493) {
                    return _cancel3.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel3.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                },
                stopvisible: function (_stopvisible3) {
                  function stopvisible(_x494) {
                    return _stopvisible3.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible3.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                "stop()": function (_stop2) {
                  function stop(_x495) {
                    return _stop2.apply(this, arguments);
                  }
                  stop.toString = function () {
                    return _stop2.toString();
                  };
                  return stop;
                }(function (obj) {
                  with (obj) return stop();
                }),
                "mintimeindicator ? css + '-disabled': ''": function mintimeindicatorCssDisabled(obj) {
                  with (obj) return mintimeindicator ? css + "-disabled" : "";
                },
                "mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip')": function mintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip");
                },
                "hover( mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip'))": function hoverMintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return hover(mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip"));
                },
                "string('stop')": function stringStop(obj) {
                  with (obj) return string("stop");
                },
                "pausable && !resumevisible && stopvisible": function pausableResumevisibleStopvisible(obj) {
                  with (obj) return pausable && !resumevisible && stopvisible;
                },
                "pause()": function (_pause4) {
                  function pause(_x496) {
                    return _pause4.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause4.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "string('pause-recorder')": function stringPauseRecorder(obj) {
                  with (obj) return string("pause-recorder");
                },
                "hover(string('pause-recorder'))": function hoverStringPauseRecorder(obj) {
                  with (obj) return hover(string("pause-recorder"));
                },
                "pausable && resumevisible": function pausableResumevisible(obj) {
                  with (obj) return pausable && resumevisible;
                },
                "resume()": function (_resume2) {
                  function resume(_x497) {
                    return _resume2.apply(this, arguments);
                  }
                  resume.toString = function () {
                    return _resume2.toString();
                  };
                  return resume;
                }(function (obj) {
                  with (obj) return resume();
                }),
                "string('resume-recorder')": function stringResumeRecorder(obj) {
                  with (obj) return string("resume-recorder");
                },
                "hover(string('resume-recorder'))": function hoverStringResumeRecorder(obj) {
                  with (obj) return hover(string("resume-recorder"));
                }
              }).attachStringTable(Assets.strings).addStrings({
                settings: "Settings",
                microphonehealthy: "Sound is good",
                microphoneunhealthy: "Cannot pick up any sound",
                record: "Record",
                "record-tooltip": "Click here to record.",
                rerecord: "Redo",
                "rerecord-tooltip": "Click here to redo.",
                stop: "Stop",
                "stop-tooltip": "Click here to stop.",
                "stop-available-after": "Minimum recording time is %d seconds",
                cancel: "Cancel",
                "cancel-tooltip": "Click here to cancel.",
                "pause-recorder": "Pause Recorder",
                "resume-recorder": "Resume Recorder"
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.Loader", ["dynamics:Dynamic", "module:Assets"], ["dynamics:Partials.ShowPartial"], function (Class, Assets, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div class="{{cssrecorder}}-loader-container">\n    <div data-selector="recorder-loader-block" class="{{cssrecorder}}-loader-loader" title="{{tooltip || \'\'}}">\n    </div>\n</div>\n<div data-selector="recorder-loader-label-container" class="{{cssrecorder}}-loader-label" ba-show="{{label}}">\n\t{{label}}\n</div>\n',
                  attrs: {
                    css: "ba-audiorecorder",
                    tooltip: "",
                    label: "",
                    message: "",
                    hovermessage: ""
                  }
                };
              }).registerFunctions({
                cssrecorder: function (_cssrecorder3) {
                  function cssrecorder(_x498) {
                    return _cssrecorder3.apply(this, arguments);
                  }
                  cssrecorder.toString = function () {
                    return _cssrecorder3.toString();
                  };
                  return cssrecorder;
                }(function (obj) {
                  with (obj) return cssrecorder;
                }),
                "tooltip || ''": function (_tooltip3) {
                  function tooltip(_x499) {
                    return _tooltip3.apply(this, arguments);
                  }
                  tooltip.toString = function () {
                    return _tooltip3.toString();
                  };
                  return tooltip;
                }(function (obj) {
                  with (obj) return tooltip || "";
                }),
                label: function (_label3) {
                  function label(_x500) {
                    return _label3.apply(this, arguments);
                  }
                  label.toString = function () {
                    return _label3.toString();
                  };
                  return label;
                }(function (obj) {
                  with (obj) return label;
                })
              }).register("ba-audiorecorder-loader").attachStringTable(Assets.strings).addStrings({});
            }), Scoped.define("module:AudioRecorder.Dynamics.Message", ["dynamics:Dynamic"], ["dynamics:Partials.ClickPartial"], function (Class, Templates, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (e) {
                return {
                  template: '\n<div data-selector="recorder-message-container" class="{{css}}-message-container" ba-click="{{click()}}">\n    <div data-selector="recorder-message-block" class=\'{{css}}-message-message\'>\n        <p>\n            {{message || ""}}\n        </p>\n        <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n            <li>\n                <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                    {{link.title}}\n                </a>\n            </li>\n        </ul>\n    </div>\n</div>\n',
                  attrs: {
                    css: "ba-audiorecorder",
                    message: "",
                    links: null
                  },
                  functions: {
                    click: function click() {
                      this.trigger("click");
                    },
                    linkClick: function linkClick(e) {
                      this.trigger("link", e);
                    }
                  }
                };
              }).registerFunctions({
                css: function (_css28) {
                  function css(_x501) {
                    return _css28.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css28.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click6) {
                  function click(_x502) {
                    return _click6.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click6.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                'message || ""': function (_message11) {
                  function message(_x503) {
                    return _message11.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message11.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links3) {
                  function links(_x504) {
                    return _links3.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links3.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }).register("ba-audiorecorder-message");
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.State", ["base:States.State", "base:Events.ListenMixin", "base:Objs"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, [t, {
                dynamics: [],
                _start: function _start() {
                  this.dyn = this.host.dynamic, i.iter(i.extend({
                    message: !1,
                    chooser: !1,
                    controlbar: !1,
                    loader: !1
                  }, i.objectify(this.dynamics)), function (e, t) {
                    this.dyn.set(t + "_active", e);
                  }, this), this.dyn.set("message_links", null), this.dyn._accessing_microphone = !1, this._started();
                },
                _started: function _started() {},
                record: function record() {
                  this.dyn.set("autorecord", !0);
                },
                stop: function stop() {
                  this.dyn.scopes.player.execute("stop");
                },
                play: function play() {
                  this.dyn.scopes.player.execute("play");
                },
                pause: function pause() {
                  this.dyn.scopes.player.execute("pause");
                },
                rerecord: function rerecord() {},
                selectRecord: function selectRecord() {},
                selectUpload: function selectUpload(e) {}
              }]);
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.FatalError", ["module:AudioRecorder.Dynamics.RecorderStates.State", "browser:Info", "base:Timers.Timer"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, {
                dynamics: ["message"],
                _locals: ["message", "retry"],
                _started: function _started() {
                  this.dyn.set("message", this._message || this.dyn.string("recorder-error")), this.dyn.set("shortMessage", this.dyn.get("message").length < 30), this.listenOn(this.dyn, "message-click", function () {
                    this._retry && this.next(this._retry);
                  });
                }
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.Initial", ["module:AudioRecorder.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                _started: function _started() {
                  this.dyn.set("is_initial_state", !0), this.dyn.set("verified", !1), this.dyn.set("playbacksource", null), this.dyn.set("player_active", !1), this.dyn._audioFileName = null, this.dyn._audioFile = null, this.dyn._audioFilePlaybackable = !1, this.dyn._initializeUploader(), this.dyn.get("recordermode") ? this.dyn.get("autorecord") || this.dyn.get("skipinitial") ? this.eventualNext("RequiredSoftwareCheck") : this.next("Chooser") : this.dyn.get("audio") ? this.next("Player") : (console.warn("recordermode:false requires an existing audio to be present and provided."), this.dyn.set("recordermode", !0));
                },
                _end: function _end() {
                  this.dyn.set("is_initial_state", !1);
                }
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.Recorder", ["dynamics:Dynamic", "module:Assets", "module:AudioVisualization", "browser:Info", "browser:Dom", "browser:Upload.MultiUploader", "browser:Upload.FileUploader", "media:AudioRecorder.AudioRecorderWrapper", "media:WebRTC.Support", "base:Types", "base:Objs", "base:Strings", "base:Time", "base:Timers", "base:States.Host", "base:Classes.ClassRegistry", "base:Collections.Collection", "base:Promise", "module:AudioRecorder.Dynamics.RecorderStates.Initial", "module:AudioRecorder.Dynamics.RecorderStates"], ["module:AudioRecorder.Dynamics.Loader", "module:AudioRecorder.Dynamics.Controlbar", "module:AudioRecorder.Dynamics.Message", "module:AudioRecorder.Dynamics.Chooser", "dynamics:Partials.ShowPartial", "dynamics:Partials.IfPartial", "dynamics:Partials.EventPartial", "dynamics:Partials.OnPartial", "dynamics:Partials.DataPartial", "dynamics:Partials.AttrsPartial", "dynamics:Partials.StylesPartial", "dynamics:Partials.TemplatePartial", "dynamics:Partials.HotkeyPartial"], function (Class, Assets, AudioVisualization, Info, Dom, MultiUploader, FileUploader, AudioRecorderWrapper, WebRTCSupport, Types, Objs, Strings, Time, Timers, Host, ClassRegistry, Collection, Promise, InitialState, RecorderStates, scoped) {
              return Class.extend({
                scoped: scoped
              }, function (t) {
                return {
                  template: '\n<div data-selector="audio-recorder-container" ba-show="{{!player_active}}"\n     class="{{css}}-container {{csstheme}} {{css}}-size-{{csssize}} {{iecss}}-{{ie8 ? \'ie8\' : \'noie8\'}}\n     \t{{cssrecorder}}-{{ firefox ? \'firefox\' : \'common\'}}-browser {{cssaudio}}\n    \t{{cssrecorder}}-{{themecolor}}-color"\n     ba-styles="{{widthHeightStyles}}"\n>\n\n\t<canvas data-selector="visualization-canvas" class="{{css}}-visualization-canvas"></canvas>\n    <audio tabindex="-1" data-selector="recorder-status" class="{{css}}-audio {{css}}-{{hasrecorder ? \'hasrecorder\' : \'norecorder\'}}" data-audio="audio" playsinline></audio>\n    <div data-selector="audio-recorder-overlay" class=\'{{cssrecorder}}-overlay\' ba-show="{{!hideoverlay}}" data-overlay="overlay">\n\t\t<ba-{{dynloader}}\n\t\t    ba-css="{{cssloader || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t\tba-cssrecorder="{{cssrecorder || css}}"\n\t\t\tba-cssrecorder="{{cssrecorder || css}}"\n\t\t    ba-template="{{tmplloader}}"\n\t\t    ba-show="{{loader_active}}"\n\t\t    ba-tooltip="{{loadertooltip}}"\n\t\t\tba-hovermessage="{{=hovermessage}}"\n\t\t    ba-label="{{loaderlabel}}"\n\t\t></ba-{{dynloader}}>\n\n\t\t<ba-{{dynmessage}}\n\t\t    ba-css="{{cssmessage || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t\tba-cssrecorder="{{cssrecorder || css}}"\n\t\t    ba-template="{{tmplmessage}}"\n\t\t    ba-show="{{message_active}}"\n\t\t    ba-message="{{message}}"\n\t\t\tba-links="{{message_links}}"\n\t\t    ba-event:click="message_click"\n\t\t\tba-event:link="message_link_click"\n\t\t></ba-{{dynmessage}}>\n\n\t\t<ba-{{dynchooser}}\n\t\t\tba-recordviafilecapture="{{recordviafilecapture}}"\n\t\t    ba-css="{{csschooser || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t\tba-cssrecorder="{{cssrecorder || css}}"\n\t\t    ba-template="{{tmplchooser}}"\n\t\t    ba-if="{{chooser_active && !is_initial_state}}"\n\t\t    ba-allowrecord="{{allowrecord}}"\n\t\t    ba-allowupload="{{allowupload}}"\n\t\t    ba-allowcustomupload="{{allowcustomupload}}"\n\t\t    ba-allowedextensions="{{allowedextensions}}"\n\t\t    ba-primaryrecord="{{primaryrecord}}"\n\t\t    ba-timelimit="{{timelimit}}"\n\t\t    ba-event:record="record_audio"\n\t\t    ba-event:upload="upload_audio"\n\t\t></ba-{{dynchooser}}>\n\n\t\t<ba-{{dyncontrolbar}}\n\t\t    ba-css="{{csscontrolbar || css}}"\n\t\t\tba-csstheme="{{csstheme || css}}"\n\t\t\tba-themecolor="{{themecolor}}"\n\t\t\tba-cssrecorder="{{cssrecorder || css}}"\n\t\t    ba-template="{{tmplcontrolbar}}"\n\t\t    ba-show="{{controlbar_active}}"\n\t\t    ba-microphones="{{microphones}}"\n\t\t\tba-pausable="{{pausable}}"\n\t\t\tba-resumevisible="{{resumevisible}}"\n\t\t\tba-selectedmicrophone="{{selectedmicrophone || 0}}"\n\t\t    ba-microphonehealthy="{{microphonehealthy}}"\n\t\t    ba-hovermessage="{{=hovermessage}}"\n\t\t    ba-settingsvisible="{{settingsvisible}}"\n\t\t    ba-recordvisible="{{recordvisible}}"\n\t\t\tba-cancelvisible="{{allowcancel && cancancel}}"\n\t\t    ba-rerecordvisible="{{rerecordvisible}}"\n\t\t    ba-stopvisible="{{stopvisible}}"\n\t\t    ba-controlbarlabel="{{controlbarlabel}}"\n\t\t\tba-mintimeindicator="{{mintimeindicator}}"\n\t\t\tba-timeminlimit="{{timeminlimit}}"\n\t\t    ba-event:select-microphone="select_microphone"\n\t\t    ba-event:invoke-record="record"\n\t\t    ba-event:invoke-rerecord="rerecord"\n\t\t    ba-event:invoke-stop="stop"\n\t\t\tba-event:invoke-pause="pause_recorder"\n\t\t\tba-event:invoke-resume="resume"\n\t\t></ba-{{dyncontrolbar}}>\n    </div>\n</div>\n\n<div data-selector="recorder-player" ba-if="{{player_active}}" ba-styles="{{widthHeightStyles}}">\n\t<span ba-show="{{ie8}}">&nbsp;</span>\n\t<ba-{{dynaudioplayer}}\n\t    ba-theme="{{theme || \'default\'}}"\n        ba-themecolor="{{themecolor}}"\n        ba-source="{{playbacksource}}"\n        ba-hideoninactivity="{{false}}"\n\t\tba-visualeffectheight="{{visualeffectheight}}"\n\t\tba-visualeffecttheme="{{visualeffecttheme}}"\n        ba-attrs="{{playerattrs}}"\n        ba-data:id="player"\n        ba-width="{{width}}"\n        ba-height="{{height}}"\n        ba-totalduration="{{duration}}"\n        ba-rerecordable="{{rerecordable && (recordings === null || recordings > 0)}}"\n        ba-submittable="{{manualsubmit && verified}}"\n        ba-reloadonplay="{{true}}"\n        ba-autoplay="{{autoplay}}"\n\t\tba-visualeffectvisible="{{visualeffectvisible}}"\n\t\tba-event:loaded="ready_to_play"\n        ba-event:rerecord="rerecord"\n        ba-event:playing="playing"\n        ba-event:paused="paused"\n        ba-event:ended="ended"\n        ba-event:submit="manual_submit"\n\t>\n\t</ba-{{dynaudioplayer}}>\n</div>\n',
                  attrs: {
                    css: "ba-videorecorder",
                    cssaudio: "ba-audiorecorder",
                    cssrecorder: "ba-recorder",
                    csscommon: "ba-commoncss",
                    iecss: "ba-audiorecorder",
                    cssimagegallery: "",
                    cssloader: "",
                    csscontrolbar: "",
                    cssmessage: "",
                    csstopmessage: "",
                    csschooser: "",
                    width: "",
                    height: "",
                    gallerysnapshots: 3,
                    theme: "",
                    csstheme: "",
                    dynloader: "audiorecorder-loader",
                    dyncontrolbar: "audiorecorder-controlbar",
                    dynmessage: "audiorecorder-message",
                    dynchooser: "audiorecorder-chooser",
                    dynaudioplayer: "audioplayer",
                    tmplloader: "",
                    tmplcontrolbar: "",
                    tmplmessage: "",
                    tmplchooser: "",
                    autorecord: !1,
                    autoplay: !1,
                    allowrecord: !0,
                    allowupload: !0,
                    allowcustomupload: !0,
                    primaryrecord: !0,
                    countdown: 3,
                    audiobitrate: null,
                    playbacksource: "",
                    recordermode: !0,
                    skipinitial: !1,
                    skipinitialonrerecord: !1,
                    timelimit: null,
                    timeminlimit: null,
                    webrtcstreaming: !1,
                    webrtconmobile: !1,
                    webrtcstreamingifnecessary: !0,
                    "microphone-volume": 1,
                    "early-rerecord": !1,
                    manualsubmit: !1,
                    allowedextensions: null,
                    filesizelimit: null,
                    "display-timer": !0,
                    pausable: !1,
                    visualeffectvisible: !0,
                    visualeffectsupported: !1,
                    visualeffectheight: null,
                    visualeffectminheight: 120,
                    visualeffecttheme: "red-bars",
                    simulate: !1,
                    "enforce-duration": null,
                    localplayback: !1,
                    uploadoptions: {},
                    playerattrs: {},
                    shortMessage: !0,
                    rerecordable: !0,
                    allowcancel: !1,
                    recordings: null,
                    ready: !0,
                    "audio-test-mandatory": !1
                  },
                  scopes: {
                    player: ">[id='player']"
                  },
                  computed: {
                    "widthHeightStyles:width,height": function widthHeightStylesWidthHeight() {
                      var e = {},
                        t = this.get("width"),
                        i = this.get("height");
                      return t && (e.width = t + ((t + "").match(/^\d+$/g) ? "px" : "")), i && (e.height = i + ((i + "").match(/^\d+$/g) ? "px" : "")), e;
                    }
                  },
                  types: {
                    rerecordable: "boolean",
                    ready: "boolean",
                    autorecord: "boolean",
                    autoplay: "boolean",
                    allowrecord: "boolean",
                    allowupload: "boolean",
                    allowcustomupload: "boolean",
                    primaryrecord: "boolean",
                    recordermode: "boolean",
                    skipinitialonrerecord: "boolean",
                    localplayback: "boolean",
                    skipinitial: "boolean",
                    pausable: "boolean",
                    "enforce-duration": "bool",
                    webrtcstreaming: "boolean",
                    webrtconmobile: "boolean",
                    webrtcstreamingifnecessary: "boolean",
                    "microphone-volume": "float",
                    audiobitrate: "int",
                    "early-rerecord": "boolean",
                    manualsubmit: "boolean",
                    simulate: "boolean",
                    allowedextensions: "array",
                    allowcancel: "boolean",
                    "display-timer": "boolean",
                    "audio-test-mandatory": "boolean",
                    visualeffectvisible: "boolean"
                  },
                  extendables: ["states"],
                  remove_on_destroy: !0,
                  events: {
                    "change:microphonehealthy": function changeMicrophonehealthy(e) {
                      this.trigger("microphonehealth", e);
                    },
                    "change:webrtconmobile": function changeWebrtconmobile() {
                      this.set("recordviafilecapture", Info.isMobile() && (!this.get("webrtconmobile") || !AudioRecorderWrapper.anySupport(this._audioRecorderWrapperOptions())));
                    },
                    "change:recordviafilecapture": function changeRecordviafilecapture() {
                      this.get("recordviafilecapture") && (this.set("skipinitial", !1), this.set("skipinitialonrerecord", !1), this.set("autorecord", !1));
                    },
                    "change:visualeffectsupported": function changeVisualeffectsupported(e) {
                      !e && this.audioVisualization && this.audioVisualization.destroy();
                    }
                  },
                  create: function create() {
                    WebRTCSupport.globals(), this.get("theme") && this.set("theme", this.get("theme").toLowerCase()), this.get("theme") in Assets.recorderthemes && Objs.iter(Assets.recorderthemes[this.get("theme")], function (e, t) {
                      this.isArgumentAttr(t) || this.set(t, e);
                    }, this), this.set("ie8", Info.isInternetExplorer() && Info.internetExplorerVersion() < 9), this.set("hideoverlay", !1), this.set("recordviafilecapture", Info.isMobile() && (!this.get("webrtconmobile") || !AudioRecorderWrapper.anySupport(this._audioRecorderWrapperOptions()))), this.get("recordviafilecapture") && (this.set("skipinitial", !1), this.set("skipinitialonrerecord", !1), this.set("autorecord", !1)), this.get("pausable") && this.set("resumevisible", !1), this.__attachRequested = !1, this.__activated = !1, this._bound = !1, this.__recording = !1, this.__error = null, this.host = new Host({
                      stateRegistry: new ClassRegistry(this.cls.recorderStates())
                    }), (this.host.dynamic = this).host.initialize(InitialState), this._timer = new Timers.Timer({
                      context: this,
                      fire: this._timerFire,
                      delay: 250,
                      start: !0
                    }), this._initSettings();
                  },
                  state: function state() {
                    return this.host.state();
                  },
                  recorderAttached: function recorderAttached() {
                    return !!this.recorder;
                  },
                  audioError: function audioError() {
                    return this.__error;
                  },
                  _error: function _error(e, t) {
                    this.__error = {
                      error_type: e,
                      error_code: t
                    }, this.trigger("error:" + e, t), this.trigger("error", e, t);
                  },
                  _clearError: function _clearError() {
                    this.__error = null;
                  },
                  _detachRecorder: function _detachRecorder() {
                    this.recorder && this.recorder.weakDestroy(), this.recorder = null, this.set("hasrecorder", !1);
                  },
                  _audioRecorderWrapperOptions: function _audioRecorderWrapperOptions() {
                    return {
                      simulate: this.get("simulate"),
                      audioBitrate: this.get("audiobitrate"),
                      webrtcStreaming: !!this.get("webrtcstreaming"),
                      webrtcStreamingIfNecessary: !!this.get("webrtcstreamingifnecessary"),
                      localPlaybackRequested: this.get("localplayback")
                    };
                  },
                  _attachRecorder: function _attachRecorder() {
                    var e;
                    this.recorderAttached() || (this.__activated ? (this.set("hasrecorder", !0), this.__attachRequested = !1, e = this.activeElement().querySelector("[data-audio='audio']"), this._clearError(), this.recorder = AudioRecorderWrapper.create(Objs.extend({
                      element: e
                    }, this._audioRecorderWrapperOptions())), this.recorder ? (this.trigger("attached"), this.set("pausable", this.get("pausable") && this.recorder.canPause())) : this._error("attach")) : this.__attachRequested = !0);
                  },
                  _softwareDependencies: function _softwareDependencies() {
                    return this.recorderAttached() && this.recorder ? this.recorder.softwareDependencies() : Promise.error("No recorder attached.");
                  },
                  _bindMedia: function _bindMedia() {
                    !this._bound && this.recorderAttached() && this.recorder && this.recorder.ready.success(function () {
                      this.recorder.on("require_display", function () {
                        this.set("hideoverlay", !0);
                      }, this), this.recorder.bindMedia().error(function (e) {
                        this.trigger("access_forbidden", e), this.set("hideoverlay", !1), this.off("require_display", null, this), this._error("bind", e);
                      }, this).success(function () {
                        var t;
                        this.trigger("access_granted"), this.recorder.setVolumeGain(this.get("microphone-volume")), this.set("hideoverlay", !1), this.off("require_display", null, this), this.get("visualeffectvisible") && AudioVisualization.supported() && (this.get("height") && this.get("height") > this.get("visualeffectminheight") ? this.set("visualeffectheight", this.get("height")) : this.get("visualeffectheight") < this.get("visualeffectminheight") && this.set("visualeffectheight", this.get("visualeffectminheight")), this.audioVisualization = new AudioVisualization(this.recorder._recorder.stream(), {
                          element: this.activeElement(),
                          recorder: this.recorder,
                          height: this.get("visualeffectheight"),
                          theme: this.get("visualeffecttheme")
                        }), t = new Timers.Timer({
                          context: this,
                          immediate: !0,
                          delay: 50,
                          fire: function fire() {
                            if (this.recorder._analyser) {
                              try {
                                this.audioVisualization.initializeVisualEffect(), this.audioVisualization.start(), this.set("visualeffectsupported", !0);
                              } catch (e) {
                                this.set("visualeffectsupported", !1), console.warn(e);
                              }
                              t.stop();
                            }
                          }
                        }), this.auto_destroy(t)), this.recorder.enumerateDevices().success(function (e) {
                          var t = this.recorder.currentDevices();
                          this.set("selectedmicrophone", t.audio), this.set("microphones", new Collection(Objs.values(e.audio)));
                        }, this), this.recorder.testSoundLevel(!0), this.set("devicetesting", !0), this._bound = !0, this.trigger("bound");
                      }, this);
                    }, this);
                  },
                  isWebrtcStreaming: function isWebrtcStreaming() {
                    return this.recorder && this.recorder.isWebrtcStreaming();
                  },
                  _initSettings: function _initSettings() {
                    this.set("duration", 0);
                  },
                  _initializeUploader: function _initializeUploader() {
                    this._dataUploader && this._dataUploader.weakDestroy(), this._dataUploader = new MultiUploader();
                  },
                  _unbindMedia: function _unbindMedia() {
                    this._bound && (this.recorder.unbindMedia(), this._bound = !1);
                  },
                  _uploadAudioFile: function _uploadAudioFile(e) {
                    var t;
                    this.get("simulate") || ((t = FileUploader.create(Objs.extend({
                      source: e
                    }, this.get("uploadoptions").audio))).upload(), this._dataUploader.addUploader(t));
                  },
                  _prepareRecording: function _prepareRecording() {
                    return Promise.create(!0);
                  },
                  _startRecording: function _startRecording() {
                    return this.__recording ? Promise.error(!0) : (this.set("devicetesting", !1), this.recorder.startRecord({
                      audio: this.get("uploadoptions").audio,
                      webrtcStreaming: this.get("uploadoptions").webrtcStreaming
                    }).success(function () {
                      this.__recording = !0, this.__recording_start_time = Time.now();
                    }, this));
                  },
                  _stopRecording: function _stopRecording() {
                    return this.__recording ? (this.audioVisualization && this.audioVisualization.stop(), this.recorder.stopRecord({
                      audio: this.get("uploadoptions").audio,
                      webrtcStreaming: this.get("uploadoptions").webrtcStreaming
                    }).success(function (e) {
                      this.__recording = !1, e.upload(), this._dataUploader.addUploader(e);
                    }, this)) : Promise.error(!0);
                  },
                  isRecording: function isRecording() {
                    return this.__recording;
                  },
                  _verifyRecording: function _verifyRecording() {
                    return Promise.create(!0);
                  },
                  _afterActivate: function _afterActivate(e) {
                    t._afterActivate.call(this, e), this.__activated = !0, this.__attachRequested && this._attachRecorder(), this.persistentTrigger("loaded");
                  },
                  object_functions: ["record", "rerecord", "stop", "play", "pause", "reset", "pause_recorder", "resume"],
                  functions: {
                    cancel: function cancel() {
                      confirm(this.stringUnicode("cancel-confirm")) && this.execute("reset");
                    },
                    record: function record() {
                      this.host.state().record();
                    },
                    record_audio: function record_audio() {
                      this.host.state().selectRecord();
                    },
                    upload_audio: function upload_audio(e) {
                      this.host.state().selectUpload(e);
                    },
                    select_microphone: function select_microphone(e) {
                      this.recorder && (this.recorder.setCurrentDevices({
                        audio: e
                      }), this.recorder.testSoundLevel(!0), this.set("selectedmicrophone", e), this.audioVisualization && this.recorder._recorder.on("bound", function () {
                        this.audioVisualization.updateSourceStream();
                      }, this)), this.set("microphonehealthy", !1);
                    },
                    rerecord: function rerecord() {
                      confirm(this.stringUnicode("rerecord-confirm")) && (this.host.state().rerecord(), this._initSettings());
                    },
                    stop: function stop() {
                      this.__paused && this._resume(), this.host.state().stop();
                    },
                    pause_recorder: function pause_recorder() {
                      "undefined" != typeof this.recorder && (this.recorder.pauseRecord(), this.recorder._recorder.once("paused", function () {
                        this.__paused = !0, this.__recording = !1, this.set("resumevisible", !0);
                      }, this));
                    },
                    resume: function resume() {
                      "undefined" != typeof this.recorder && this._resume();
                    },
                    play: function play() {
                      this.host.state().play();
                    },
                    pause: function pause() {
                      this.host.state().pause();
                    },
                    message_click: function message_click() {
                      this.trigger("message-click");
                    },
                    message_link_click: function message_link_click(e) {
                      this.trigger("message-link-click", e);
                    },
                    playing: function playing() {
                      this.trigger("playing");
                    },
                    paused: function paused() {
                      this.trigger("paused");
                    },
                    ended: function ended() {
                      this.trigger("ended");
                    },
                    reset: function reset() {
                      this._stopRecording().callback(function () {
                        this._unbindMedia(), this._detachRecorder(), this._initSettings(), this.host.state().next("Initial");
                      }, this);
                    },
                    manual_submit: function manual_submit() {
                      this.set("rerecordable", !1), this.set("manualsubmit", !1), this.trigger("manually_submitted");
                    },
                    ready_to_play: function ready_to_play() {
                      this.trigger("ready_to_play");
                    }
                  },
                  _resume: function _resume() {
                    this.__paused = !1, this.__recording = !0, this.recorder.resumeRecord(), this.recorder._recorder.once("resumed", function () {
                      this.set("resumevisible", !1);
                    }, this);
                  },
                  destroy: function destroy() {
                    this._timer.destroy(), this.host.destroy(), this._detachRecorder(), t.destroy.call(this);
                  },
                  soundLevel: function soundLevel() {
                    return this.recorderAttached() ? this.recorder.soundLevel() : null;
                  },
                  _timerFire: function _timerFire() {
                    if (!this.destroyed()) {
                      try {
                        this.recorderAttached() && this.get("devicetesting") && !this.get("microphonehealthy") && 1.01 <= this.soundLevel() && (this.set("microphonehealthy", !0), this.recorder.testSoundLevel(!1));
                      } catch (e) {}
                      this._updateCSSSize();
                    }
                  },
                  _updateCSSSize: function _updateCSSSize() {
                    var e = Dom.elementDimensions(this.activeElement()).width;
                    this.set("csssize", 400 < e ? "normal" : 300 < e ? "medium" : "small");
                  },
                  parentWidth: function parentWidth() {
                    return this.get("width") || Dom.elementDimensions(this.activeElement()).width;
                  },
                  parentHeight: function parentHeight() {
                    return this.get("height") || Dom.elementDimensions(this.activeElement()).height;
                  },
                  parentAspectRatio: function parentAspectRatio() {
                    return this.parentWidth() / this.parentHeight();
                  }
                };
              }, {
                recorderStates: function recorderStates() {
                  return [RecorderStates];
                }
              }).register("ba-audiorecorder").registerFunctions({
                "!player_active": function (_player_active5) {
                  function player_active(_x505) {
                    return _player_active5.apply(this, arguments);
                  }
                  player_active.toString = function () {
                    return _player_active5.toString();
                  };
                  return player_active;
                }(function (obj) {
                  with (obj) return !player_active;
                }),
                css: function (_css29) {
                  function css(_x506) {
                    return _css29.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css29.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                csstheme: function (_csstheme7) {
                  function csstheme(_x507) {
                    return _csstheme7.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme7.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                csssize: function (_csssize6) {
                  function csssize(_x508) {
                    return _csssize6.apply(this, arguments);
                  }
                  csssize.toString = function () {
                    return _csssize6.toString();
                  };
                  return csssize;
                }(function (obj) {
                  with (obj) return csssize;
                }),
                iecss: function (_iecss6) {
                  function iecss(_x509) {
                    return _iecss6.apply(this, arguments);
                  }
                  iecss.toString = function () {
                    return _iecss6.toString();
                  };
                  return iecss;
                }(function (obj) {
                  with (obj) return iecss;
                }),
                "ie8 ? 'ie8' : 'noie8'": function ie8Ie8Noie8(obj) {
                  with (obj) return ie8 ? "ie8" : "noie8";
                },
                cssrecorder: function (_cssrecorder4) {
                  function cssrecorder(_x510) {
                    return _cssrecorder4.apply(this, arguments);
                  }
                  cssrecorder.toString = function () {
                    return _cssrecorder4.toString();
                  };
                  return cssrecorder;
                }(function (obj) {
                  with (obj) return cssrecorder;
                }),
                "firefox ? 'firefox' : 'common'": function firefoxFirefoxCommon(obj) {
                  with (obj) return firefox ? "firefox" : "common";
                },
                cssaudio: function (_cssaudio) {
                  function cssaudio(_x511) {
                    return _cssaudio.apply(this, arguments);
                  }
                  cssaudio.toString = function () {
                    return _cssaudio.toString();
                  };
                  return cssaudio;
                }(function (obj) {
                  with (obj) return cssaudio;
                }),
                themecolor: function (_themecolor6) {
                  function themecolor(_x512) {
                    return _themecolor6.apply(this, arguments);
                  }
                  themecolor.toString = function () {
                    return _themecolor6.toString();
                  };
                  return themecolor;
                }(function (obj) {
                  with (obj) return themecolor;
                }),
                widthHeightStyles: function (_widthHeightStyles4) {
                  function widthHeightStyles(_x513) {
                    return _widthHeightStyles4.apply(this, arguments);
                  }
                  widthHeightStyles.toString = function () {
                    return _widthHeightStyles4.toString();
                  };
                  return widthHeightStyles;
                }(function (obj) {
                  with (obj) return widthHeightStyles;
                }),
                "hasrecorder ? 'hasrecorder' : 'norecorder'": function hasrecorderHasrecorderNorecorder(obj) {
                  with (obj) return hasrecorder ? "hasrecorder" : "norecorder";
                },
                "!hideoverlay": function (_hideoverlay3) {
                  function hideoverlay(_x514) {
                    return _hideoverlay3.apply(this, arguments);
                  }
                  hideoverlay.toString = function () {
                    return _hideoverlay3.toString();
                  };
                  return hideoverlay;
                }(function (obj) {
                  with (obj) return !hideoverlay;
                }),
                dynloader: function (_dynloader5) {
                  function dynloader(_x515) {
                    return _dynloader5.apply(this, arguments);
                  }
                  dynloader.toString = function () {
                    return _dynloader5.toString();
                  };
                  return dynloader;
                }(function (obj) {
                  with (obj) return dynloader;
                }),
                "cssloader || css": function cssloaderCss(obj) {
                  with (obj) return cssloader || css;
                },
                "cssrecorder || css": function cssrecorderCss(obj) {
                  with (obj) return cssrecorder || css;
                },
                tmplloader: function (_tmplloader5) {
                  function tmplloader(_x516) {
                    return _tmplloader5.apply(this, arguments);
                  }
                  tmplloader.toString = function () {
                    return _tmplloader5.toString();
                  };
                  return tmplloader;
                }(function (obj) {
                  with (obj) return tmplloader;
                }),
                loader_active: function (_loader_active5) {
                  function loader_active(_x517) {
                    return _loader_active5.apply(this, arguments);
                  }
                  loader_active.toString = function () {
                    return _loader_active5.toString();
                  };
                  return loader_active;
                }(function (obj) {
                  with (obj) return loader_active;
                }),
                loadertooltip: function (_loadertooltip3) {
                  function loadertooltip(_x518) {
                    return _loadertooltip3.apply(this, arguments);
                  }
                  loadertooltip.toString = function () {
                    return _loadertooltip3.toString();
                  };
                  return loadertooltip;
                }(function (obj) {
                  with (obj) return loadertooltip;
                }),
                hovermessage: function (_hovermessage3) {
                  function hovermessage(_x519) {
                    return _hovermessage3.apply(this, arguments);
                  }
                  hovermessage.toString = function () {
                    return _hovermessage3.toString();
                  };
                  return hovermessage;
                }(function (obj) {
                  with (obj) return hovermessage;
                }),
                loaderlabel: function (_loaderlabel3) {
                  function loaderlabel(_x520) {
                    return _loaderlabel3.apply(this, arguments);
                  }
                  loaderlabel.toString = function () {
                    return _loaderlabel3.toString();
                  };
                  return loaderlabel;
                }(function (obj) {
                  with (obj) return loaderlabel;
                }),
                dynmessage: function (_dynmessage6) {
                  function dynmessage(_x521) {
                    return _dynmessage6.apply(this, arguments);
                  }
                  dynmessage.toString = function () {
                    return _dynmessage6.toString();
                  };
                  return dynmessage;
                }(function (obj) {
                  with (obj) return dynmessage;
                }),
                "cssmessage || css": function cssmessageCss(obj) {
                  with (obj) return cssmessage || css;
                },
                tmplmessage: function (_tmplmessage6) {
                  function tmplmessage(_x522) {
                    return _tmplmessage6.apply(this, arguments);
                  }
                  tmplmessage.toString = function () {
                    return _tmplmessage6.toString();
                  };
                  return tmplmessage;
                }(function (obj) {
                  with (obj) return tmplmessage;
                }),
                message_active: function (_message_active6) {
                  function message_active(_x523) {
                    return _message_active6.apply(this, arguments);
                  }
                  message_active.toString = function () {
                    return _message_active6.toString();
                  };
                  return message_active;
                }(function (obj) {
                  with (obj) return message_active;
                }),
                message: function (_message12) {
                  function message(_x524) {
                    return _message12.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message12.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message;
                }),
                message_links: function (_message_links3) {
                  function message_links(_x525) {
                    return _message_links3.apply(this, arguments);
                  }
                  message_links.toString = function () {
                    return _message_links3.toString();
                  };
                  return message_links;
                }(function (obj) {
                  with (obj) return message_links;
                }),
                dynchooser: function (_dynchooser3) {
                  function dynchooser(_x526) {
                    return _dynchooser3.apply(this, arguments);
                  }
                  dynchooser.toString = function () {
                    return _dynchooser3.toString();
                  };
                  return dynchooser;
                }(function (obj) {
                  with (obj) return dynchooser;
                }),
                recordviafilecapture: function (_recordviafilecapture3) {
                  function recordviafilecapture(_x527) {
                    return _recordviafilecapture3.apply(this, arguments);
                  }
                  recordviafilecapture.toString = function () {
                    return _recordviafilecapture3.toString();
                  };
                  return recordviafilecapture;
                }(function (obj) {
                  with (obj) return recordviafilecapture;
                }),
                "csschooser || css": function csschooserCss(obj) {
                  with (obj) return csschooser || css;
                },
                tmplchooser: function (_tmplchooser3) {
                  function tmplchooser(_x528) {
                    return _tmplchooser3.apply(this, arguments);
                  }
                  tmplchooser.toString = function () {
                    return _tmplchooser3.toString();
                  };
                  return tmplchooser;
                }(function (obj) {
                  with (obj) return tmplchooser;
                }),
                "chooser_active && !is_initial_state": function chooser_activeIs_initial_state(obj) {
                  with (obj) return chooser_active && !is_initial_state;
                },
                allowrecord: function (_allowrecord3) {
                  function allowrecord(_x529) {
                    return _allowrecord3.apply(this, arguments);
                  }
                  allowrecord.toString = function () {
                    return _allowrecord3.toString();
                  };
                  return allowrecord;
                }(function (obj) {
                  with (obj) return allowrecord;
                }),
                allowupload: function (_allowupload3) {
                  function allowupload(_x530) {
                    return _allowupload3.apply(this, arguments);
                  }
                  allowupload.toString = function () {
                    return _allowupload3.toString();
                  };
                  return allowupload;
                }(function (obj) {
                  with (obj) return allowupload;
                }),
                allowcustomupload: function (_allowcustomupload3) {
                  function allowcustomupload(_x531) {
                    return _allowcustomupload3.apply(this, arguments);
                  }
                  allowcustomupload.toString = function () {
                    return _allowcustomupload3.toString();
                  };
                  return allowcustomupload;
                }(function (obj) {
                  with (obj) return allowcustomupload;
                }),
                allowedextensions: function (_allowedextensions3) {
                  function allowedextensions(_x532) {
                    return _allowedextensions3.apply(this, arguments);
                  }
                  allowedextensions.toString = function () {
                    return _allowedextensions3.toString();
                  };
                  return allowedextensions;
                }(function (obj) {
                  with (obj) return allowedextensions;
                }),
                primaryrecord: function (_primaryrecord3) {
                  function primaryrecord(_x533) {
                    return _primaryrecord3.apply(this, arguments);
                  }
                  primaryrecord.toString = function () {
                    return _primaryrecord3.toString();
                  };
                  return primaryrecord;
                }(function (obj) {
                  with (obj) return primaryrecord;
                }),
                timelimit: function (_timelimit2) {
                  function timelimit(_x534) {
                    return _timelimit2.apply(this, arguments);
                  }
                  timelimit.toString = function () {
                    return _timelimit2.toString();
                  };
                  return timelimit;
                }(function (obj) {
                  with (obj) return timelimit;
                }),
                dyncontrolbar: function (_dyncontrolbar6) {
                  function dyncontrolbar(_x535) {
                    return _dyncontrolbar6.apply(this, arguments);
                  }
                  dyncontrolbar.toString = function () {
                    return _dyncontrolbar6.toString();
                  };
                  return dyncontrolbar;
                }(function (obj) {
                  with (obj) return dyncontrolbar;
                }),
                "csscontrolbar || css": function csscontrolbarCss(obj) {
                  with (obj) return csscontrolbar || css;
                },
                "csstheme || css": function cssthemeCss(obj) {
                  with (obj) return csstheme || css;
                },
                tmplcontrolbar: function (_tmplcontrolbar6) {
                  function tmplcontrolbar(_x536) {
                    return _tmplcontrolbar6.apply(this, arguments);
                  }
                  tmplcontrolbar.toString = function () {
                    return _tmplcontrolbar6.toString();
                  };
                  return tmplcontrolbar;
                }(function (obj) {
                  with (obj) return tmplcontrolbar;
                }),
                controlbar_active: function (_controlbar_active5) {
                  function controlbar_active(_x537) {
                    return _controlbar_active5.apply(this, arguments);
                  }
                  controlbar_active.toString = function () {
                    return _controlbar_active5.toString();
                  };
                  return controlbar_active;
                }(function (obj) {
                  with (obj) return controlbar_active;
                }),
                microphones: function (_microphones4) {
                  function microphones(_x538) {
                    return _microphones4.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones4.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                pausable: function (_pausable2) {
                  function pausable(_x539) {
                    return _pausable2.apply(this, arguments);
                  }
                  pausable.toString = function () {
                    return _pausable2.toString();
                  };
                  return pausable;
                }(function (obj) {
                  with (obj) return pausable;
                }),
                resumevisible: function (_resumevisible2) {
                  function resumevisible(_x540) {
                    return _resumevisible2.apply(this, arguments);
                  }
                  resumevisible.toString = function () {
                    return _resumevisible2.toString();
                  };
                  return resumevisible;
                }(function (obj) {
                  with (obj) return resumevisible;
                }),
                "selectedmicrophone || 0": function selectedmicrophone0(obj) {
                  with (obj) return selectedmicrophone || 0;
                },
                microphonehealthy: function (_microphonehealthy2) {
                  function microphonehealthy(_x541) {
                    return _microphonehealthy2.apply(this, arguments);
                  }
                  microphonehealthy.toString = function () {
                    return _microphonehealthy2.toString();
                  };
                  return microphonehealthy;
                }(function (obj) {
                  with (obj) return microphonehealthy;
                }),
                settingsvisible: function (_settingsvisible6) {
                  function settingsvisible(_x542) {
                    return _settingsvisible6.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible6.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                recordvisible: function (_recordvisible6) {
                  function recordvisible(_x543) {
                    return _recordvisible6.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible6.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "allowcancel && cancancel": function allowcancelCancancel(obj) {
                  with (obj) return allowcancel && cancancel;
                },
                rerecordvisible: function (_rerecordvisible6) {
                  function rerecordvisible(_x544) {
                    return _rerecordvisible6.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible6.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                stopvisible: function (_stopvisible4) {
                  function stopvisible(_x545) {
                    return _stopvisible4.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible4.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                controlbarlabel: function (_controlbarlabel6) {
                  function controlbarlabel(_x546) {
                    return _controlbarlabel6.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel6.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                mintimeindicator: function (_mintimeindicator2) {
                  function mintimeindicator(_x547) {
                    return _mintimeindicator2.apply(this, arguments);
                  }
                  mintimeindicator.toString = function () {
                    return _mintimeindicator2.toString();
                  };
                  return mintimeindicator;
                }(function (obj) {
                  with (obj) return mintimeindicator;
                }),
                timeminlimit: function (_timeminlimit3) {
                  function timeminlimit(_x548) {
                    return _timeminlimit3.apply(this, arguments);
                  }
                  timeminlimit.toString = function () {
                    return _timeminlimit3.toString();
                  };
                  return timeminlimit;
                }(function (obj) {
                  with (obj) return timeminlimit;
                }),
                player_active: function (_player_active6) {
                  function player_active(_x549) {
                    return _player_active6.apply(this, arguments);
                  }
                  player_active.toString = function () {
                    return _player_active6.toString();
                  };
                  return player_active;
                }(function (obj) {
                  with (obj) return player_active;
                }),
                ie8: function (_ie3) {
                  function ie8(_x550) {
                    return _ie3.apply(this, arguments);
                  }
                  ie8.toString = function () {
                    return _ie3.toString();
                  };
                  return ie8;
                }(function (obj) {
                  with (obj) return ie8;
                }),
                dynaudioplayer: function (_dynaudioplayer) {
                  function dynaudioplayer(_x551) {
                    return _dynaudioplayer.apply(this, arguments);
                  }
                  dynaudioplayer.toString = function () {
                    return _dynaudioplayer.toString();
                  };
                  return dynaudioplayer;
                }(function (obj) {
                  with (obj) return dynaudioplayer;
                }),
                "theme || 'default'": function themeDefault(obj) {
                  with (obj) return theme || "default";
                },
                playbacksource: function (_playbacksource2) {
                  function playbacksource(_x552) {
                    return _playbacksource2.apply(this, arguments);
                  }
                  playbacksource.toString = function () {
                    return _playbacksource2.toString();
                  };
                  return playbacksource;
                }(function (obj) {
                  with (obj) return playbacksource;
                }),
                "false": function _false(obj) {
                  with (obj) return !1;
                },
                visualeffectheight: function (_visualeffectheight) {
                  function visualeffectheight(_x553) {
                    return _visualeffectheight.apply(this, arguments);
                  }
                  visualeffectheight.toString = function () {
                    return _visualeffectheight.toString();
                  };
                  return visualeffectheight;
                }(function (obj) {
                  with (obj) return visualeffectheight;
                }),
                visualeffecttheme: function (_visualeffecttheme) {
                  function visualeffecttheme(_x554) {
                    return _visualeffecttheme.apply(this, arguments);
                  }
                  visualeffecttheme.toString = function () {
                    return _visualeffecttheme.toString();
                  };
                  return visualeffecttheme;
                }(function (obj) {
                  with (obj) return visualeffecttheme;
                }),
                playerattrs: function (_playerattrs3) {
                  function playerattrs(_x555) {
                    return _playerattrs3.apply(this, arguments);
                  }
                  playerattrs.toString = function () {
                    return _playerattrs3.toString();
                  };
                  return playerattrs;
                }(function (obj) {
                  with (obj) return playerattrs;
                }),
                width: function (_width2) {
                  function width(_x556) {
                    return _width2.apply(this, arguments);
                  }
                  width.toString = function () {
                    return _width2.toString();
                  };
                  return width;
                }(function (obj) {
                  with (obj) return width;
                }),
                height: function (_height2) {
                  function height(_x557) {
                    return _height2.apply(this, arguments);
                  }
                  height.toString = function () {
                    return _height2.toString();
                  };
                  return height;
                }(function (obj) {
                  with (obj) return height;
                }),
                duration: function (_duration4) {
                  function duration(_x558) {
                    return _duration4.apply(this, arguments);
                  }
                  duration.toString = function () {
                    return _duration4.toString();
                  };
                  return duration;
                }(function (obj) {
                  with (obj) return duration;
                }),
                "rerecordable && (recordings === null || recordings > 0)": function rerecordableRecordingsNullRecordings0(obj) {
                  with (obj) return rerecordable && (null === recordings || 0 < recordings);
                },
                "manualsubmit && verified": function manualsubmitVerified(obj) {
                  with (obj) return manualsubmit && verified;
                },
                "true": function _true(obj) {
                  with (obj) return !0;
                },
                autoplay: function (_autoplay2) {
                  function autoplay(_x559) {
                    return _autoplay2.apply(this, arguments);
                  }
                  autoplay.toString = function () {
                    return _autoplay2.toString();
                  };
                  return autoplay;
                }(function (obj) {
                  with (obj) return autoplay;
                }),
                visualeffectvisible: function (_visualeffectvisible) {
                  function visualeffectvisible(_x560) {
                    return _visualeffectvisible.apply(this, arguments);
                  }
                  visualeffectvisible.toString = function () {
                    return _visualeffectvisible.toString();
                  };
                  return visualeffectvisible;
                }(function (obj) {
                  with (obj) return visualeffectvisible;
                })
              }).attachStringTable(Assets.strings).addStrings({
                "recorder-error": "An error occurred, please try again later. Click to retry.",
                "attach-error": "We could not access the media interface. Depending on the device and browser, you might need to access the page via SSL.",
                "software-required": "Please click below to install / activate the following requirements in order to proceed.",
                "software-waiting": "Waiting for the requirements to be installed / activated. You might need to refresh the page after completion.",
                "access-forbidden": "Access to the media was forbidden. Click to retry.",
                uploading: "Uploading",
                "uploading-failed": "Uploading failed - click here to retry.",
                "upload-error-duration": "Length of the uploaded audio does not meet the requirements - click here to retry.",
                verifying: "Verifying",
                "verifying-failed": "Verifying failed - click here to retry.",
                "rerecord-confirm": "Do you really want to redo your audio?",
                "cancel-confirm": "Do you really want to cancel your audio upload?",
                audio_file_too_large: "Your audio file is too large (%s) - click here to try again with a smaller audio file.",
                unsupported_audio_type: "Please upload: %s - click here to retry.",
                "uploading-src-error": "Unable to play back audio now, uploading is still in progress",
                "missing-track": "Required audio track is missing",
                "device-already-in-use": "At least one of your input devices are already in use",
                "browser-permission-denied": "Permission denied by browser, please grant access and reload page"
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.Player", ["module:AudioRecorder.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                rerecord: function rerecord() {
                  this.dyn.trigger("rerecord"), this.dyn.set("recordermode", !0), this.next("Initial");
                },
                _started: function _started() {
                  this.dyn.set("player_active", !0);
                },
                _end: function _end() {
                  this.dyn.set("player_active", !1);
                }
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.Chooser", ["module:AudioRecorder.Dynamics.RecorderStates.State", "base:Strings", "browser:Info", "media:Player.Support"], function (t, s, x, c, i) {
              return t.extend({
                scoped: i
              }, {
                dynamics: ["chooser"],
                record: function record() {
                  this.dyn.set("autorecord", !0), this.selectRecord();
                },
                selectRecord: function selectRecord() {
                  this.dyn.set("record_media", "microphone"), this.next("RequiredSoftwareCheck");
                },
                selectUpload: function selectUpload(t) {
                  if (!(x.isMobile() && x.isAndroid() && x.isCordova())) {
                    if (this.dyn.get("allowedextensions")) {
                      var i = (t.files[0].name || "").toLowerCase(),
                        r = !1;
                      if (this.dyn.get("allowedextensions").forEach(function (e) {
                        s.ends_with(i, "." + e.toLowerCase()) && (r = !0);
                      }, this), !r) return void this.next("FatalError", {
                        message: this.dyn.string("unsupported_audio_type").replace("%s", this.dyn.get("allowedextensions").join(" / ")),
                        retry: "Chooser"
                      });
                    }
                    if (this.dyn.get("filesizelimit") && t.files && 0 < t.files.length && t.files[0].size && t.files[0].size > this.dyn.get("filesizelimit")) {
                      var o = "KB",
                        a = Math.round(t.files[0].size / 1e3),
                        n = Math.round(this.dyn.get("filesizelimit") / 1e3);
                      return 999 < a && (o = "MB", a = Math.round(a / 1e3), n = Math.round(n / 1e3)), void this.next("FatalError", {
                        message: this.dyn.string("audio_file_too_large").replace("%s", a + o + " / " + n + o),
                        retry: "Chooser"
                      });
                    }
                  }
                  try {
                    c.audioFileInfo(t.files[0]).success(function (e) {
                      e.duration && this.dyn.get("enforce-duration") && (this.dyn.get("timeminlimit") && e.duration < this.dyn.get("timeminlimit") || this.dyn.get("timelimit") && e.duration > this.dyn.get("timelimit")) ? this.next("FatalError", {
                        message: this.dyn.string("upload-error-duration"),
                        retry: "Chooser"
                      }) : (this.dyn._audioFilePlaybackable = !0, this.dyn.set("duration", e.duration), this._uploadFile(t));
                    }, this).error(function (e) {
                      e.code === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED && (this.dyn.get("localplayback") && (this.dyn.set("localplayback", !1), this.dyn.set("was_localplayback", !0)), this.dyn.set("media_src_not_supported", !0)), this._uploadFile(t);
                    }, this);
                  } catch (e) {
                    this._uploadFile(t);
                  }
                },
                _uploadFile: function _uploadFile(t) {
                  this.dyn.set("creation-type", x.isMobile() ? "mobile" : "upload");
                  try {
                    this.dyn._audioFileName = t.files[0].name, this.dyn._audioFile = t.files[0];
                  } catch (e) {}
                  this.dyn._prepareRecording().success(function () {
                    this.dyn.trigger("upload_selected", t), this.dyn._uploadAudioFile(t), this._setValueToEmpty(t), this.next("Uploading");
                  }, this).error(function (e) {
                    this._setValueToEmpty(t), this.next("FatalError", {
                      message: e,
                      retry: "Chooser"
                    });
                  }, this);
                },
                _setValueToEmpty: function _setValueToEmpty(t) {
                  try {
                    t.value = "";
                  } catch (e) {}
                }
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.RequiredSoftwareCheck", ["module:AudioRecorder.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.dyn.set("settingsvisible", !1), this.dyn.set("recordvisible", !1), this.dyn.set("rerecordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("skipvisible", !1), this.dyn.set("controlbarlabel", ""), this.dyn.set("loaderlabel", ""), this.listenOn(this.dyn, "error", function (e) {
                    this.next("FatalError", {
                      message: this.dyn.string("attach-error"),
                      retry: "Initial"
                    });
                  }, this), this.dyn._attachRecorder(), this.dyn && (this.dyn.on("message-link-click", function (e) {
                    e.execute(), this.next("RequiredSoftwareWait");
                  }, this), this.dyn._softwareDependencies().error(function (e) {
                    this.dyn.set("message_links", e), this.dyn.set("loader_active", !1), this.dyn.set("message_active", !0), this.dyn.set("message", this.dyn.string("software-required"));
                  }, this).success(function () {
                    this.next("MicrophoneAccess");
                  }, this));
                }
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.RequiredSoftwareWait", ["module:AudioRecorder.Dynamics.RecorderStates.State", "base:Promise", "browser:Dom"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, {
                dynamics: ["message"],
                _started: function _started() {
                  this.dyn.set("settingsvisible", !1), this.dyn.set("recordvisible", !1), this.dyn.set("rerecordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("controlbarlabel", ""), this.dyn.set("loaderlabel", ""), this.dyn.set("message", this.dyn.string("software-waiting")), t.resilience(function () {
                    return i.isTabHidden() ? t.error("Not ready") : this.dyn._softwareDependencies();
                  }, this, 120, [], 1e3).success(function () {
                    this.next("MicrophoneAccess");
                  }, this).error(function () {
                    this.next("RequiredSoftwareCheck");
                  }, this), this.dyn.on("message-click", function () {
                    this.next("RequiredSoftwareCheck");
                  }, this);
                }
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.MicrophoneAccess", ["module:AudioRecorder.Dynamics.RecorderStates.State", "base:Timers.Timer"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, {
                dynamics: ["loader"],
                _started: function _started() {
                  this.dyn.set("settingsvisible", !0), this.dyn.set("recordvisible", !0), this.dyn.set("rerecordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("controlbarlabel", ""), this.dyn.set("loaderlabel", ""), this.listenOn(this.dyn, "bound", function () {
                    this.dyn.set("creation-type", "webrtc"), this.next("MicrophoneHasAccess");
                  }, this), this.listenOn(this.dyn, "error", function (e) {
                    this.next("FatalError", {
                      message: this.dyn.string("attach-error"),
                      retry: "Initial"
                    });
                  }, this), this.listenOn(this.dyn, "access_forbidden", function () {
                    this.next("FatalError", {
                      message: this.dyn.string("access-forbidden"),
                      retry: "Initial"
                    });
                  }, this), this.dyn._bindMedia();
                }
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.MicrophoneHasAccess", ["module:AudioRecorder.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["controlbar"],
                _started: function _started() {
                  this.dyn.trigger("ready_to_record"), this._preparePromise = null, 0 < this.dyn.get("countdown") && this.dyn.recorder && this.dyn.recorder.recordDelay(this.dyn.get("uploadoptions")) > 1e3 * this.dyn.get("countdown") && (this._preparePromise = this.dyn._prepareRecording()), this.dyn.get("pausable") && this.dyn.set("pausable", this.dyn.recorder.canPause()), this.dyn.set("hovermessage", ""), this.dyn.set("settingsvisible", !0), this.dyn.set("recordvisible", !0), this.dyn.set("rerecordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("controlbarlabel", ""), this.dyn.get("autorecord") && this.next("RecordPrepare", {
                    preparePromise: this._preparePromise
                  });
                },
                record: function record() {
                  this.dyn.get("autorecord") || this.dyn.get("audio-test-mandatory") && !this.dyn.get("microphonehealthy") && !this._preparePromise || this.next("RecordPrepare", {
                    preparePromise: this._preparePromise
                  });
                }
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.RecordPrepare", ["module:AudioRecorder.Dynamics.RecorderStates.State", "base:Timers.Timer", "base:Time"], function (e, t, c, i) {
              return e.extend({
                scoped: i
              }, {
                dynamics: ["loader"],
                _locals: ["preparePromise"],
                _started: function _started() {
                  this.dyn.set("message", ""), this.dyn.set("loaderlabel", "");
                  var i = !1;
                  this.dyn._accessing_microphone = !0, this._preparePromise = this._preparePromise || this.dyn._prepareRecording();
                  var r,
                    o,
                    a,
                    n,
                    s,
                    e = this.dyn.get("countdown") ? 1e3 * this.dyn.get("countdown") : 0,
                    x = this.dyn.recorder.recordDelay(this.dyn.get("uploadoptions")) || 0;
                  e ? (r = 1e3, o = 0, a = c.now(), n = a + Math.max(x, e), e < x ? (o = Math.min(500, x - e), r = (x - o) / e * 1e3) : this.dyn.set("loaderlabel", this.dyn.get("countdown")), s = new t({
                    context: this,
                    delay: 50,
                    fire: function fire() {
                      var e = c.now(),
                        t = Math.max(0, n - e);
                      o + a < e && (this.dyn.set("loaderlabel", "" + Math.ceil((t - o) / r)), this.dyn.trigger("countdown", Math.round((t - o) / r * 1e3))), n <= e && (this.dyn.set("loaderlabel", ""), s.stop()), t <= x && !i && (i = !0, this._startRecording());
                    }
                  }), this.auto_destroy(s)) : this._startRecording();
                },
                record: function record() {
                  this._startRecording();
                },
                _startRecording: function _startRecording() {
                  this._preparePromise.success(function () {
                    this.dyn._startRecording().success(function () {
                      this.next("Recording");
                    }, this).error(function (e) {
                      this.next("FatalError", {
                        message: e,
                        retry: "RequiredSoftwareCheck"
                      });
                    }, this);
                  }, this).error(function (e) {
                    this.next("FatalError", {
                      message: e,
                      retry: "RequiredSoftwareCheck"
                    });
                  }, this);
                }
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.Recording", ["module:AudioRecorder.Dynamics.RecorderStates.State", "base:Timers.Timer", "base:Time", "base:TimeFormat", "base:Async", "browser:Info"], function (e, t, r, o, a, i, n) {
              return e.extend({
                scoped: n
              }, {
                dynamics: ["controlbar"],
                _started: function _started() {
                  this.dyn.set("hovermessage", ""), this.dyn.set("topmessage", ""), this.dyn._accessing_microphone = !0, this.dyn.trigger("recording"), this.dyn.set("settingsvisible", !1), this.dyn.set("rerecordvisible", !1), this.dyn.set("recordvisible", !1), this.dyn.set("stopvisible", !0), this._startTime = r.now(), this._stopping = !1, this.__firedTimes = 0, this.__pauseDelta = 0, this.__timerDelay = 10, this._timer = this.auto_destroy(new t({
                    immediate: !0,
                    delay: this.__timerDelay,
                    context: this,
                    fire: this._timerFire
                  }));
                },
                _timerFire: function _timerFire() {
                  this.__firedTimes += 1;
                  var e = this.dyn.get("timelimit"),
                    t = r.now() - this.__pauseDelta,
                    i = Math.max(0, e ? this._startTime + 1e3 * e - t : t - this._startTime);
                  this.dyn.trigger("recording_progress", t - this._startTime, !!this.dyn.__paused), this.dyn.set("controlbarlabel", this.dyn.get("display-timer") ? o.format(o.ELAPSED_MINUTES_SECONDS, i) : ""), this.dyn.__paused && (this.__pauseDelta += this.__timerDelay), this.dyn.get("timeminlimit") && this.dyn.set("mintimeindicator", (r.now() - this._startTime) / 1e3 <= this.dyn.get("timeminlimit")), e && this._startTime + 1e3 * e <= t && (this._timer.stop(), this.stop());
                },
                stop: function stop() {
                  var e = this.dyn.get("timeminlimit");
                  if (e) {
                    var t = (r.now() - this._startTime - this.__pauseDelta) / 1e3;
                    if (t < e) {
                      var i = this.dyn.get("timelimit");
                      if (!i || t < i) return;
                    }
                  }
                  this._stopping || (this.dyn.set("loader_active", !0), this.dyn.set("controlbar_active", !1), this.dyn.set("message_active", !0), this.dyn.set("message", ""), this._stopping = !0, a.eventually(function () {
                    this.dyn._stopRecording().success(function () {
                      this._hasStopped(), this.next("Uploading");
                    }, this).error(function (e) {
                      this.next("FatalError", {
                        message: e,
                        retry: "RequiredSoftwareCheck"
                      });
                    }, this);
                  }, this));
                },
                _hasStopped: function _hasStopped() {
                  this.dyn.set("duration", (r.now() - this._startTime - this.__pauseDelta) / 1e3), this.dyn._unbindMedia(), this.dyn.trigger("recording_stopped");
                }
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.Uploading", ["module:AudioRecorder.Dynamics.RecorderStates.State", "base:Time", "base:Async", "base:Objs"], function (e, t, i, r, o) {
              return e.extend({
                scoped: o
              }, {
                dynamics: ["loader", "message"],
                _started: function _started() {
                  this.dyn.set("cancancel", !0), this.dyn.set("skipinitial", this.dyn.get("skipinitial") || this.dyn.get("skipinitialonrerecord")), this.dyn.set("settingsvisible", !1), this.dyn.set("recordvisible", !1), this.dyn.set("stopvisible", !1), this.dyn.set("loadlabel", ""), this.dyn.set("controlbarlabel", ""), this.dyn.trigger("uploading"), this.dyn.set("rerecordvisible", this.dyn.get("early-rerecord")), this.dyn.get("media_src_not_supported") && this.dyn.get("was_localplayback") ? this.dyn.set("uploading-message", this.dyn.string("uploading-src-error")) : this.dyn.set("uploading-message", this.dyn.string("uploading")), this.dyn.get("early-rerecord") && this.dyn.set("controlbar_active", !0), this.dyn.set("hovermessage", ""), this.dyn.set("message", this.dyn.get("uploading-message"));
                  var e = this.dyn._dataUploader;
                  this.listenOn(e, "success", function () {
                    i.eventually(function () {
                      this.destroyed() || (this._finished(), this.next("Verifying"));
                    }, this);
                  }), this.listenOn(e, "error", function (e) {
                    var i = this.dyn.string("uploading-failed");
                    try {
                      e.forEach(function (e) {
                        for (var t in e) this.dyn.string("upload-error-" + t) && (i = this.dyn.string("upload-error-" + t));
                      }, this);
                    } catch (t) {}
                    this.dyn.set("player_active", !1), this.next("FatalError", {
                      message: i,
                      retry: this.dyn.recorderAttached() ? "Uploading" : "Initial"
                    });
                  }), this.listenOn(e, "progress", function (e, t) {
                    var i;
                    this.dyn.trigger("upload_progress", e, t), 0 !== t && 0 < t && 0 <= e && (i = Math.min(100, Math.round(e / t * 100)), isNaN(i) || (this.dyn.set("message", this.dyn.get("uploading-message") + ": " + i + "%"), this.dyn.set("playertopmessage", this.dyn.get("message"))));
                  }), this.dyn.get("localplayback") && (this.dyn.recorder && this.dyn.recorder.supportsLocalPlayback() || this.dyn._audioFilePlaybackable) && (this.dyn.recorder && this.dyn.recorder.supportsLocalPlayback() ? this.dyn.set("playbacksource", this.dyn.recorder.localPlaybackSource()) : this.dyn.set("playbacksource", (window.URL || window.webkitURL).createObjectURL(this.dyn._audioFile)), this.dyn.set("loader_active", !1), this.dyn.set("message_active", !1), this.dyn.set("player_active", !0)), this.dyn.set("start-upload-time", t.now()), e.reset(), e.upload();
                },
                rerecord: function rerecord() {
                  this.dyn._detachRecorder(), this.dyn.trigger("rerecord"), this.dyn.set("recordermode", !0), this.next("Initial");
                },
                _finished: function _finished() {
                  this.dyn.set("cancancel", !1), this.dyn.trigger("uploaded"), this.dyn.set("end-upload-time", t.now());
                }
              });
            }), Scoped.define("module:AudioRecorder.Dynamics.RecorderStates.Verifying", ["module:AudioRecorder.Dynamics.RecorderStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["loader", "message"],
                _started: function _started() {
                  this.dyn.set("loadlabel", ""), this.dyn.trigger("verifying"), this.dyn.set("message", this.dyn.string("verifying") + "..."), this.dyn.set("playertopmessage", this.dyn.get("message")), this.dyn.get("localplayback") && (this.dyn.recorder && this.dyn.recorder.supportsLocalPlayback() || this.dyn._audioFilePlaybackable) ? (this.dyn.set("loader_active", !1), this.dyn.set("message_active", !1)) : (this.dyn.set("rerecordvisible", this.dyn.get("early-rerecord")), this.dyn.get("early-rerecord") && this.dyn.set("controlbar_active", !0)), this.dyn._verifyRecording().success(function () {
                    this.dyn.trigger("verified"), this.dyn._detachRecorder(), this.dyn.get("recordings") && this.dyn.set("recordings", this.dyn.get("recordings") - 1), this.dyn.set("message", ""), this.dyn.set("verified", !0), this.next("Player");
                  }, this).error(function () {
                    this.dyn.set("player_active", !1), this.next("FatalError", {
                      message: this.dyn.string("verifying-failed"),
                      retry: this.dyn.recorderAttached() ? "Verifying" : "Initial"
                    });
                  }, this);
                },
                rerecord: function rerecord() {
                  this.dyn._detachRecorder(), this.dyn.trigger("rerecord"), this.dyn.set("recordermode", !0), this.next("Initial");
                }
              });
            });
          }.call(Scoped), function () {
            var Scoped = this.subScope();
            Scoped.binding("browser", "root:BetaJS.Browser"), Scoped.binding("dynamics", "root:BetaJS.Dynamics"), Scoped.binding("module", "root:BetaJS.MediaComponents"), Scoped.extend("module:Assets.playerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                csstheme: function (_csstheme8) {
                  function csstheme(_x561) {
                    return _csstheme8.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme8.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                "activitydelta > hidebarafter && hideoninactivity ? (cssplayer + '-dashboard-hidden') : ''": function activitydeltaHidebarafterHideoninactivityCssplayerDashboardHidden(obj) {
                  with (obj) return activitydelta > hidebarafter && hideoninactivity ? cssplayer + "-dashboard-hidden" : "";
                },
                title: function (_title7) {
                  function title(_x562) {
                    return _title7.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title7.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit5) {
                  function submit(_x563) {
                    return _submit5.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit5.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable7) {
                  function submittable(_x564) {
                    return _submittable7.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable7.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecord()": function (_rerecord8) {
                  function rerecord(_x565) {
                    return _rerecord8.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord8.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable7) {
                  function rerecordable(_x566) {
                    return _rerecordable7.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable7.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-video')": function stringRerecordVideo(obj) {
                  with (obj) return string("rerecord-video");
                },
                csscommon: function (_csscommon16) {
                  function csscommon(_x567) {
                    return _csscommon16.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon16.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "skipinitial ? 0 : 1": function skipinitial01(obj) {
                  with (obj) return skipinitial ? 0 : 1;
                },
                "play()": function (_play4) {
                  function play(_x568) {
                    return _play4.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play4.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "!playing": function (_playing7) {
                  function playing(_x569) {
                    return _playing7.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing7.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "string('play-video')": function stringPlayVideo(obj) {
                  with (obj) return string("play-video");
                },
                "pause()": function (_pause5) {
                  function pause(_x570) {
                    return _pause5.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause5.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                playing: function (_playing8) {
                  function playing(_x571) {
                    return _playing8.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing8.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "disablepause ? string('pause-video-disabled') : string('pause-video')": function disablepauseStringPauseVideoDisabledStringPauseVideo(obj) {
                  with (obj) return disablepause ? string("pause-video-disabled") : string("pause-video");
                },
                "toggle_position_info()": function (_toggle_position_info2) {
                  function toggle_position_info(_x572) {
                    return _toggle_position_info2.apply(this, arguments);
                  }
                  toggle_position_info.toString = function () {
                    return _toggle_position_info2.toString();
                  };
                  return toggle_position_info;
                }(function (obj) {
                  with (obj) return toggle_position_info();
                }),
                "revertposition ? string('remaining-time') : string('elapsed-time')": function revertpositionStringRemainingTimeStringElapsedTime(obj) {
                  with (obj) return revertposition ? string("remaining-time") : string("elapsed-time");
                },
                '(revertposition && duration > 0) ? "-" : ""': function revertpositionDuration0(obj) {
                  with (obj) return revertposition && 0 < duration ? "-" : "";
                },
                "(revertposition && duration > 0) ? formatTime(duration - position) : formatTime(position)": function revertpositionDuration0FormatTimeDurationPositionFormatTimePosition(obj) {
                  with (obj) return revertposition && 0 < duration ? formatTime(duration - position) : formatTime(position);
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                trimmingmode: function (_trimmingmode4) {
                  function trimmingmode(_x573) {
                    return _trimmingmode4.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode4.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "trim()": function (_trim3) {
                  function trim(_x574) {
                    return _trim3.apply(this, arguments);
                  }
                  trim.toString = function () {
                    return _trim3.toString();
                  };
                  return trim;
                }(function (obj) {
                  with (obj) return trim();
                }),
                "string('trim-video')": function stringTrimVideo(obj) {
                  with (obj) return string("trim-video");
                },
                frameselectionmode: function (_frameselectionmode4) {
                  function frameselectionmode(_x575) {
                    return _frameselectionmode4.apply(this, arguments);
                  }
                  frameselectionmode.toString = function () {
                    return _frameselectionmode4.toString();
                  };
                  return frameselectionmode;
                }(function (obj) {
                  with (obj) return frameselectionmode;
                }),
                "select_frame()": function (_select_frame2) {
                  function select_frame(_x576) {
                    return _select_frame2.apply(this, arguments);
                  }
                  select_frame.toString = function () {
                    return _select_frame2.toString();
                  };
                  return select_frame;
                }(function (obj) {
                  with (obj) return select_frame();
                }),
                "string('select-frame')": function stringSelectFrame(obj) {
                  with (obj) return string("select-frame");
                },
                "toggle_settings_menu()": function (_toggle_settings_menu2) {
                  function toggle_settings_menu(_x577) {
                    return _toggle_settings_menu2.apply(this, arguments);
                  }
                  toggle_settings_menu.toString = function () {
                    return _toggle_settings_menu2.toString();
                  };
                  return toggle_settings_menu;
                }(function (obj) {
                  with (obj) return toggle_settings_menu();
                }),
                cssplayer: function (_cssplayer9) {
                  function cssplayer(_x578) {
                    return _cssplayer9.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer9.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "settingsmenuactive ? 'active' : 'inactive'": function settingsmenuactiveActiveInactive(obj) {
                  with (obj) return settingsmenuactive ? "active" : "inactive";
                },
                settingsmenubutton: function (_settingsmenubutton2) {
                  function settingsmenubutton(_x579) {
                    return _settingsmenubutton2.apply(this, arguments);
                  }
                  settingsmenubutton.toString = function () {
                    return _settingsmenubutton2.toString();
                  };
                  return settingsmenubutton;
                }(function (obj) {
                  with (obj) return settingsmenubutton;
                }),
                "string('settings')": function stringSettings(obj) {
                  with (obj) return string("settings");
                },
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                "toggle_tracks()": function (_toggle_tracks2) {
                  function toggle_tracks(_x580) {
                    return _toggle_tracks2.apply(this, arguments);
                  }
                  toggle_tracks.toString = function () {
                    return _toggle_tracks2.toString();
                  };
                  return toggle_tracks;
                }(function (obj) {
                  with (obj) return toggle_tracks();
                }),
                "(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload": function tracktagsLength0ShowsubtitlebuttonAllowtexttrackupload(obj) {
                  with (obj) return 0 < tracktags.length && showsubtitlebutton || allowtexttrackupload;
                },
                "tracktextvisible ? 'active' : 'inactive'": function tracktextvisibleActiveInactive(obj) {
                  with (obj) return tracktextvisible ? "active" : "inactive";
                },
                "tracktextvisible ? string('close-tracks') : string('show-tracks')": function tracktextvisibleStringCloseTracksStringShowTracks(obj) {
                  with (obj) return tracktextvisible ? string("close-tracks") : string("show-tracks");
                },
                "hover_cc(true)": function hover_ccTrue(obj) {
                  with (obj) return hover_cc(!0);
                },
                "hover_cc(false)": function hover_ccFalse(obj) {
                  with (obj) return hover_cc(!1);
                },
                "toggle_fullscreen()": function (_toggle_fullscreen3) {
                  function toggle_fullscreen(_x581) {
                    return _toggle_fullscreen3.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen3.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                fullscreen: function (_fullscreen3) {
                  function fullscreen(_x582) {
                    return _fullscreen3.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen3.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-video') : string('fullscreen-video')": function fullscreenedStringExitFullscreenVideoStringFullscreenVideo(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-video") : string("fullscreen-video");
                },
                "fullscreened ? 'small' : 'full'": function fullscreenedSmallFull(obj) {
                  with (obj) return fullscreened ? "small" : "full";
                },
                "show_airplay_devices()": function (_show_airplay_devices2) {
                  function show_airplay_devices(_x583) {
                    return _show_airplay_devices2.apply(this, arguments);
                  }
                  show_airplay_devices.toString = function () {
                    return _show_airplay_devices2.toString();
                  };
                  return show_airplay_devices;
                }(function (obj) {
                  with (obj) return show_airplay_devices();
                }),
                airplaybuttonvisible: function (_airplaybuttonvisible3) {
                  function airplaybuttonvisible(_x584) {
                    return _airplaybuttonvisible3.apply(this, arguments);
                  }
                  airplaybuttonvisible.toString = function () {
                    return _airplaybuttonvisible3.toString();
                  };
                  return airplaybuttonvisible;
                }(function (obj) {
                  with (obj) return airplaybuttonvisible;
                }),
                castbuttonvisble: function (_castbuttonvisble3) {
                  function castbuttonvisble(_x585) {
                    return _castbuttonvisble3.apply(this, arguments);
                  }
                  castbuttonvisble.toString = function () {
                    return _castbuttonvisble3.toString();
                  };
                  return castbuttonvisble;
                }(function (obj) {
                  with (obj) return castbuttonvisble;
                }),
                "toggle_stream()": function (_toggle_stream2) {
                  function toggle_stream(_x586) {
                    return _toggle_stream2.apply(this, arguments);
                  }
                  toggle_stream.toString = function () {
                    return _toggle_stream2.toString();
                  };
                  return toggle_stream;
                }(function (obj) {
                  with (obj) return toggle_stream();
                }),
                "streams.length > 1 && currentstream": function streamsLength1Currentstream(obj) {
                  with (obj) return 1 < streams.length && currentstream;
                },
                "string('change-resolution')": function stringChangeResolution(obj) {
                  with (obj) return string("change-resolution");
                },
                currentstream_label: function (_currentstream_label2) {
                  function currentstream_label(_x587) {
                    return _currentstream_label2.apply(this, arguments);
                  }
                  currentstream_label.toString = function () {
                    return _currentstream_label2.toString();
                  };
                  return currentstream_label;
                }(function (obj) {
                  with (obj) return currentstream_label;
                }),
                "!hidevolumebar": function (_hidevolumebar3) {
                  function hidevolumebar(_x588) {
                    return _hidevolumebar3.apply(this, arguments);
                  }
                  hidevolumebar.toString = function () {
                    return _hidevolumebar3.toString();
                  };
                  return hidevolumebar;
                }(function (obj) {
                  with (obj) return !hidevolumebar;
                }),
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "startUpdateVolume(domEvent)": function startUpdateVolumeDomEvent(obj) {
                  with (obj) return startUpdateVolume(domEvent);
                },
                "progressUpdateVolume(domEvent)": function progressUpdateVolumeDomEvent(obj) {
                  with (obj) return progressUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent); this.blur()": function stopUpdateVolumeDomEventThisBlur(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent)": function stopUpdateVolumeDomEvent(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + '%'}": function widthMathCeil1MathMin99MathRoundVolume100(obj) {
                  with (obj) return {
                    width: Math.ceil(1 + Math.min(99, Math.round(100 * volume))) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                "toggle_volume()": function (_toggle_volume3) {
                  function toggle_volume(_x589) {
                    return _toggle_volume3.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume3.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('video-progress')": function stringVideoProgress(obj) {
                  with (obj) return string("video-progress");
                },
                css: function (_css30) {
                  function css(_x590) {
                    return _css30.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css30.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + '%'}": function leftMathRoundDurationTrimstartTrimstartDuration1000(obj) {
                  with (obj) return {
                    left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + "%"
                  };
                },
                "{left: 'auto', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + '%'}": function leftAutoRight100MathRoundDurationTrimendTrimendDuration100100(obj) {
                  with (obj) return {
                    left: "auto",
                    right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + "%"
                  };
                }
              }), Parser.registerFunctions({
                "play()": function (_play5) {
                  function play(_x591) {
                    return _play5.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play5.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'player-toggle-overlay')": function tab_index_moveDomEventNullPlayerToggleOverlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "player-toggle-overlay");
                },
                cssplayer: function (_cssplayer10) {
                  function cssplayer(_x592) {
                    return _cssplayer10.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer10.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "string('tooltip')": function stringTooltip(obj) {
                  with (obj) return string("tooltip");
                },
                "showduration && (duration != 0 && duration != undefined)": function showdurationDuration0DurationUndefined(obj) {
                  with (obj) return showduration && 0 != duration && duration != undefined;
                },
                css: function (_css31) {
                  function css(_x593) {
                    return _css31.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css31.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "formatTime(duration)": function formatTimeDuration(obj) {
                  with (obj) return formatTime(duration);
                },
                "rerecordable || submittable": function rerecordableSubmittable(obj) {
                  with (obj) return rerecordable || submittable;
                },
                "submittable && !trimmingmode": function submittableTrimmingmode(obj) {
                  with (obj) return submittable && !trimmingmode;
                },
                "submit()": function (_submit6) {
                  function submit(_x594) {
                    return _submit6.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit6.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecordable && !trimmingmode": function rerecordableTrimmingmode(obj) {
                  with (obj) return rerecordable && !trimmingmode;
                },
                "rerecord()": function (_rerecord9) {
                  function rerecord(_x595) {
                    return _rerecord9.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord9.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                trimmingmode: function (_trimmingmode5) {
                  function trimmingmode(_x596) {
                    return _trimmingmode5.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode5.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "string('trim')": function stringTrim(obj) {
                  with (obj) return string("trim");
                },
                "skip()": function (_skip4) {
                  function skip(_x597) {
                    return _skip4.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip4.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                }
              }), {
                modern: {
                  css: "ba-videoplayer",
                  csstheme: "ba-player-theme-modern",
                  cssplayer: "ba-player",
                  tmplcontrolbar: '<div data-selector="video-title-block" class="{{csstheme}}-title-container {{activitydelta > hidebarafter && hideoninactivity ? (cssplayer + \'-dashboard-hidden\') : \'\'}}" ba-if="{{title}}">\n\t<p class="{{csstheme}}-title">\n\t\t{{title}}\n\t</p>\n</div>\n\n<div class="{{csstheme}}-dashboard {{activitydelta > hidebarafter && hideoninactivity ? (cssplayer + \'-dashboard-hidden\') : \'\'}}">\n\n\t<div tabindex="0" data-selector="submit-video-button"\n\t\t ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n\t\t class="{{csstheme}}-leftbutton-container"\n\t\t ba-if="{{submittable}}" ba-click="{{submit()}}"\n\t>\n\t\t<div class="{{csstheme}}-button-inner">\n\t\t\t{{string(\'submit-video\')}}\n\t\t</div>\n\t</div>\n\n\t<div tabindex="0" data-selector="button-icon-ccw"\n\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t class="{{csstheme}}-leftbutton-container"\n\t\t ba-if="{{rerecordable}}" ba-click="{{rerecord()}}" title="{{string(\'rerecord-video\')}}"\n\t>\n\t\t<div class="{{csstheme}}-button-inner">\n\t\t\t<i class="{{csscommon}}-icon-ccw"></i>\n\t\t</div>\n\t</div>\n\n\t<div tabindex="{{skipinitial ? 0 : 1}}" data-selector="button-icon-play"\n\t\t ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n\t\t onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}"\n\t\t class="{{csstheme}}-leftbutton-container"\n\t\t ba-if="{{!playing}}" ba-click="{{play()}}" title="{{string(\'play-video\')}}"\n\t>\n\t\t<div class="{{csstheme}}-button-inner">\n\t\t\t<i class="{{csscommon}}-icon-play"></i>\n\t\t</div>\n\t</div>\n\n\t<div tabindex="{{skipinitial ? 0 : 1}}" data-selector="button-icon-pause"\n\t\t ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n\t\t onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}"\n\t\t class="{{csstheme}}-leftbutton-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n\t\t ba-if="{{playing}}" ba-click="{{pause()}}" title="{{disablepause ? string(\'pause-video-disabled\') : string(\'pause-video\')}}"\n\t>\n\t\t<div class="{{csstheme}}-button-inner">\n\t\t\t<i class="{{csscommon}}-icon-pause"></i>\n\t\t</div>\n\t</div>\n\t<div class="{{csstheme}}-time-container">\n\t\t<div class="{{csstheme}}-time-value {{csscommon}}-clickable" ba-click="{{toggle_position_info()}}"\n\t\t\t title="{{revertposition ? string(\'remaining-time\') : string(\'elapsed-time\')}}"\n\t\t>\n\t\t\t<span class="{{csstheme}}-time-position">\n                {{(revertposition && duration > 0) ? "-" : ""}}\n\t\t\t\t{{(revertposition && duration > 0) ? formatTime(duration - position) : formatTime(position)}} /\n\t\t\t</span>{{formatTime(duration || position)}}\n\t\t</div>\n\t</div>\n\n\t<div tabindex="11" class="{{csstheme}}-primary-button-container {{csstheme}}-rightbutton-container" ba-if="{{trimmingmode}}">\n\t\t<div data-selector="trim-button"\n\t\t\t onmouseout="this.blur()"\n\t\t\t ba-click="{{trim()}}"\n\t\t\t class="{{csstheme}}-primary-button {{csstheme}}-button-inner">\n\t\t\t {{string(\'trim-video\')}}\n\t\t</div>\n\t</div>\n\n\t<div tabindex="11" class="{{csstheme}}-primary-button-container {{csstheme}}-rightbutton-container" ba-if="{{frameselectionmode}}">\n\t\t<div data-selector="select-frame-button"\n\t\t\t onmouseout="this.blur()"\n\t\t\t ba-click="{{select_frame()}}"\n\t\t\t class="{{csstheme}}-primary-button {{csstheme}}-button-inner">\n\t\t\t {{string(\'select-frame\')}}\n\t\t</div>\n\t</div>\n\n\t<div tabindex="10" data-selector="button-icon-settings"\n\t\t ba-hotkey:space^enter="{{toggle_settings_menu()}}" onmouseout="this.blur()"\n\t\t class="{{csstheme}}-rightbutton-container {{cssplayer}}-button-{{settingsmenuactive ? \'active\' : \'inactive\'}}"\n\t\t ba-if="{{settingsmenubutton}}" ba-click="{{toggle_settings_menu()}}"\n\t\t title="{{string(\'settings\')}}"\n\t\t onkeydown="{{tab_index_move(domEvent)}}"\n\t>\n\t\t<div class="{{csstheme}}-button-inner {{csstheme}}-settings-button">\n\t\t\t<i class="{{csscommon}}-icon-cog"></i>\n\t\t</div>\n\t</div>\n\n\t<div tabindex="9" data-selector="cc-button-container"\n\t\t ba-hotkey:space^enter="{{toggle_tracks()}}" onmouseout="this.blur()"\n\t\t ba-if="{{(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload}}"\n\t\t class="{{csstheme}}-rightbutton-container  {{cssplayer}}-button-{{tracktextvisible ? \'active\' : \'inactive\'}}"\n\t\t title="{{tracktextvisible ? string(\'close-tracks\') : string(\'show-tracks\')}}"\n\t\t ba-click="{{toggle_tracks()}}"\n\t\t onmouseover="{{hover_cc(true)}}"\n\t\t onmouseleave="{{hover_cc(false)}}"\n\t>\n\t\t<div class="{{csstheme}}-button-inner {{csstheme}}-subtitle-button-inner">\n\t\t\t<i class="{{csscommon}}-icon-subtitle"></i>\n\t\t</div>\n\t</div>\n\n\n\t<div tabindex="8" data-selector="button-icon-resize-full"\n\t\t ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n\t\t onkeydown="{{tab_index_move(domEvent)}}"\n\t\t class="{{csstheme}}-rightbutton-container"\n\t\t ba-if="{{fullscreen}}" ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-video\') : string(\'fullscreen-video\') }}"\n\t>\n\t\t<div class="{{csstheme}}-button-inner {{csstheme}}-full-screen-btn-inner">\n\t\t\t<i class="{{csscommon}}-icon-resize-{{fullscreened ? \'small\' : \'full\'}}"></i>\n\t\t</div>\n\t</div>\n\n\t<div tabindex="7" data-selector="button-airplay"\n\t\t ba-hotkey:space^enter="{{show_airplay_devices()}}" onmouseout="this.blur()"\n\t\t class="{{csstheme}}-rightbutton-container {{cssplayer}}-airplay-container" ba-show="{{airplaybuttonvisible}}"\n\t\t ba-click="{{show_airplay_devices()}}"\n\t>\n\t\t<svg width="16px" height="11px" viewBox="0 0 16 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n\t\t\t\n\t\t\t<title>Airplay</title>\n\t\t\t<desc>Airplay icon.</desc>\n\t\t\t<defs></defs>\n\t\t\t<g stroke="none" stroke-width="1" fill-rule="evenodd" sketch:type="MSPage">\n\t\t\t\t<path d="M4,11 L12,11 L8,7 L4,11 Z M14.5454545,0 L1.45454545,0 C0.654545455,0 0,0.5625 0,1.25 L0,8.75 C0,9.4375 0.654545455,10 1.45454545,10 L4.36363636,10 L4.36363636,8.75 L1.45454545,8.75 L1.45454545,1.25 L14.5454545,1.25 L14.5454545,8.75 L11.6363636,8.75 L11.6363636,10 L14.5454545,10 C15.3454545,10 16,9.4375 16,8.75 L16,1.25 C16,0.5625 15.3454545,0 14.5454545,0 L14.5454545,0 Z" sketch:type="MSShapeGroup"></path>\n\t\t\t</g>\n\t\t</svg>\n\t</div>\n\n\t<div data-selector="button-chromecast" class="{{csstheme}}-rightbutton-container {{csstheme}}-cast-button-container" ba-show="{{castbuttonvisble}}">\n\t\t<button tabindex="6" class="{{csstheme}}-gcast-button" is="google-cast-button"></button>\n\t</div>\n\n\t<div tabindex="5" data-selector="button-stream-label"\n\t\t ba-hotkey:space^enter="{{toggle_stream()}}" onmouseout="this.blur()"\n\t\t class="{{csstheme}}-rightbutton-container" ba-if="{{streams.length > 1 && currentstream}}"\n\t\t ba-click="{{toggle_stream()}}" title="{{string(\'change-resolution\')}}"\n\t>\n\t\t<div class="{{csstheme}}-button-inner">\n\t\t\t<span class="{{csstheme}}-button-text">{{currentstream_label}}</span>\n\t\t</div>\n\t</div>\n\n\t<div class="{{csstheme}}-volumebar" ba-show="{{!hidevolumebar}}">\n\t\t<div tabindex="4" data-selector="button-volume-bar"\n\t\t\t ba-hotkey:right="{{set_volume(volume + 0.1)}}"\n\t\t\t ba-hotkey:left="{{set_volume(volume - 0.1)}}"\n\t\t\t onmouseout="this.blur()"\n\t\t\t class="{{csstheme}}-volumebar-inner"\n\t\t\t ontouchstart="{{startUpdateVolume(domEvent)}}"\n\t\t\t ontouchmove="{{progressUpdateVolume(domEvent)}}"\n\t\t\t ontouchend="{{stopUpdateVolume(domEvent); this.blur()}};"\n\t\t\t onmousedown="{{startUpdateVolume(domEvent)}}"\n\t\t\t onmouseup="{{stopUpdateVolume(domEvent)}}"\n\t\t\t onmouseleave="{{stopUpdateVolume(domEvent)}}"\n\t\t\t onmousemove="{{progressUpdateVolume(domEvent)}}"\n\t\t>\n\t\t\t<div class="{{csstheme}}-volumebar-position" ba-styles="{{{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + \'%\'}}}" title="{{string(\'volume-button\')}}"></div>\n\t\t</div>\n\t</div>\n\n\t<div tabindex="3" data-selector="button-icon-volume"\n\t\t ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n\t\t class="{{csstheme}}-rightbutton-container {{csstheme}}-volume-button-container"\n\t\t ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}"\n\t>\n\t\t<div class="{{csstheme}}-button-inner">\n\t\t\t<i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n\t\t</div>\n\t</div>\n\n\t<div class="{{csstheme}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}">\n\t\t<div tabindex="2" data-selector="progress-bar-inner"\n\t\t\t ba-hotkey:right="{{seek(position + skipseconds)}}"\n\t\t\t ba-hotkey:left="{{seek(position - skipseconds)}}"\n\t\t\t onmouseout="this.blur()"\n\t\t\t class="{{csstheme}}-progressbar-inner"\n\t\t\t ontouchstart="{{startUpdatePosition(domEvent)}}"\n\t\t\t onmousedown="{{startUpdatePosition(domEvent)}}"\n\t\t>\n\t\t\t<div class="{{csstheme}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n\t\t\t<div class="{{csstheme}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'video-progress\')}}"></div>\n\t\t\t<div class="{{css}}-progressbar-marker"\n\t\t\t\tdata-selector="trim-start-marker"\n\t\t\t\tba-if="{{trimmingmode}}"\n\t\t\t\tba-styles="{{{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + \'%\'}}}"\n\t\t\t></div>\n\t\t\t<div class="{{css}}-progressbar-marker"\n\t\t\t\tdata-selector="trim-end-marker"\n\t\t\t\tba-if="{{trimmingmode}}"\n\t\t\t\tba-styles="{{{left: \'auto\', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + \'%\'}}}"\n\t\t\t></div>\n\t\t</div>\n\t</div>\n',
                  tmplplaybutton: '\n<div tabindex="0" data-selector="play-button"\n     ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n     onkeydown="{{tab_index_move(domEvent, null, \'player-toggle-overlay\')}}"\n     class="{{cssplayer}}-playbutton-container" ba-click="{{play()}}" title="{{string(\'tooltip\')}}"\n>\n\t<div class="{{cssplayer}}-playbutton-button"></div>\n</div>\n<div ba-show="{{showduration && (duration != 0 && duration != undefined)}}" class="{{css}}-playbutton-duration">\n    {{formatTime(duration)}}\n</div>\n\n<div class="{{cssplayer}}-rerecord-bar" ba-if="{{rerecordable || submittable}}">\n\t<div class="{{cssplayer}}-rerecord-backbar"></div>\n\t<div class="{{cssplayer}}-rerecord-frontbar">\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{submittable && !trimmingmode}}">\n            <div tabindex="0" data-selector="player-submit-button"\n                 ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{submit()}}">\n                {{string(\'submit-video\')}}\n            </div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{rerecordable && !trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-rerecord-button"\n                 ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{rerecord()}}">\n        \t\t{{string(\'rerecord\')}}\n        \t</div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-trim-button"\n                 ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{play()}}">\n        \t\t{{string(\'trim\')}}\n        \t</div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-skip-button"\n                 ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{skip()}}">\n        \t\t{{string(\'skip\')}}\n        \t</div>\n        </div>\n\t</div>\n</div>\n',
                  cssloader: ie8 ? "ba-videoplayer" : "",
                  cssmessage: "ba-videoplayer",
                  cssplaybutton: ie8 ? "ba-videoplayer" : ""
                }
              };
            }), Scoped.extend("module:Assets.recorderthemes", ["dynamics:Parser"], function (Parser) {
              return Parser.registerFunctions({
                css: function (_css32) {
                  function css(_x598) {
                    return _css32.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css32.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "initialmessages.length > 0": function initialmessagesLength0(obj) {
                  with (obj) return 0 < initialmessages.length;
                },
                csscommon: function (_csscommon17) {
                  function csscommon(_x599) {
                    return _csscommon17.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon17.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                initialmessages: function (_initialmessages3) {
                  function initialmessages(_x600) {
                    return _initialmessages3.apply(this, arguments);
                  }
                  initialmessages.toString = function () {
                    return _initialmessages3.toString();
                  };
                  return initialmessages;
                }(function (obj) {
                  with (obj) return initialmessages;
                }),
                "initialmessage.message": function initialmessageMessage(obj) {
                  with (obj) return initialmessage.message;
                },
                "initialmessage.type ? initialmessage.type : 'default'": function initialmessageTypeInitialmessageTypeDefault(obj) {
                  with (obj) return initialmessage.type ? initialmessage.type : "default";
                },
                "initialmessage.id": function initialmessageId(obj) {
                  with (obj) return initialmessage.id;
                },
                "actions.first().get('icon')": function actionsFirstGetIcon(obj) {
                  with (obj) return actions.first().get("icon");
                },
                actions: function (_actions4) {
                  function actions(_x601) {
                    return _actions4.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions4.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                }
              }), {
                modern: {
                  css: "ba-videorecorder",
                  csstheme: "ba-recorder-theme-modern",
                  cssrecorder: "ba-recorder",
                  cssloader: "ba-videorecorder",
                  tmplchooser: '<div class="{{css}}-chooser-container">\n\t<div ba-if="{{initialmessages.length > 0}}" class="{{csscommon}}-message-container">\n\t\t<ul ba-repeat="{{initialmessage :: initialmessages}}">\n\t\t\t<li ba-if="{{initialmessage.message}}"\n\t\t\t\tclass="{{csscommon}}-message-text {{csscommon}}-message-{{initialmessage.type ? initialmessage.type : \'default\'}}"\n\t\t\t>\n\t\t\t\t{{ initialmessage.message }}\n\t\t\t\t<span ba-if="{{initialmessage.id}}"\n\t\t\t\t\t  class="{{csscommon}}-action-button"\n\t\t\t\t\t  ba-click="close_message(initialmessage.id)"\n\t\t\t\t>\n\t\t\t\t\t<i class="{{csscommon}}-icon-cancel"></i>\n\t\t\t\t</span>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\n\t<div class="{{css}}-chooser-button-container">\n\n\t\t<div class="{{css}}-chooser-icon-container">\n\t\t\t<i class="{{csscommon}}-icon-{{actions.first().get(\'icon\')}}"></i>\n\t\t</div>\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div tabindex="0"\n\t\t\t\tba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t\t ba-click="{{click_action(action)}}"\n\t\t\t>\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t/>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n'
                }
              };
            }), Scoped.extend("module:Assets.imageviewerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                css: function (_css33) {
                  function css(_x602) {
                    return _css33.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css33.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "activitydelta > 5000 && hideoninactivity ? (css + '-dashboard-hidden') : ''": function activitydelta5000HideoninactivityCssDashboardHidden(obj) {
                  with (obj) return 5e3 < activitydelta && hideoninactivity ? css + "-dashboard-hidden" : "";
                },
                title: function (_title8) {
                  function title(_x603) {
                    return _title8.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title8.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit7) {
                  function submit(_x604) {
                    return _submit7.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit7.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable8) {
                  function submittable(_x605) {
                    return _submittable8.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable8.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-image')": function stringSubmitImage(obj) {
                  with (obj) return string("submit-image");
                },
                "rerecord()": function (_rerecord10) {
                  function rerecord(_x606) {
                    return _rerecord10.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord10.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable8) {
                  function rerecordable(_x607) {
                    return _rerecordable8.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable8.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-image')": function stringRerecordImage(obj) {
                  with (obj) return string("rerecord-image");
                },
                csscommon: function (_csscommon18) {
                  function csscommon(_x608) {
                    return _csscommon18.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon18.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "toggle_fullscreen()": function (_toggle_fullscreen4) {
                  function toggle_fullscreen(_x609) {
                    return _toggle_fullscreen4.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen4.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                fullscreen: function (_fullscreen4) {
                  function fullscreen(_x610) {
                    return _fullscreen4.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen4.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-image') : string('fullscreen-image')": function fullscreenedStringExitFullscreenImageStringFullscreenImage(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-image") : string("fullscreen-image");
                },
                "fullscreened ? 'small' : 'full'": function fullscreenedSmallFull(obj) {
                  with (obj) return fullscreened ? "small" : "full";
                }
              }), {
                modern: {
                  css: "ba-imageviewer",
                  csstheme: "ba-imageviewer-theme-modern",
                  tmplcontrolbar: '<div data-selector="image-title-block" class="{{css}}-image-title-container {{activitydelta > 5000 && hideoninactivity ? (css + \'-dashboard-hidden\') : \'\'}}" ba-if="{{title}}">\n\t<p class="{{css}}-image-title">\n\t\t{{title}}\n\t</p>\n</div>\n\n<div class="{{css}}-dashboard {{activitydelta > 5000 && hideoninactivity ? (css + \'-dashboard-hidden\') : \'\'}}">\n\n    <div tabindex="0" data-selector="submit-image-button"\n\t\t ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n\t\t class="{{css}}-leftbutton-container"\n\t\t ba-if="{{submittable}}" ba-click="{{submit()}}"\n\t>\n        <div class="{{css}}-button-inner">\n        \t{{string(\'submit-image\')}}\n        </div>\n    </div>\n\n    <div tabindex="0" data-selector="button-icon-ccw"\n\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t class="{{css}}-leftbutton-container"\n\t\t ba-if="{{rerecordable}}" ba-click="{{rerecord()}}" title="{{string(\'rerecord-image\')}}"\n\t>\n    \t<div class="{{css}}-button-inner">\n    \t\t<i class="{{csscommon}}-icon-ccw"></i>\n    \t</div>\n    </div>\n\n\t<div tabindex="8" data-selector="button-icon-resize-full"\n\t\t ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n\t\t onkeydown="{{tab_index_move(domEvent)}}"\n\t\t class="{{css}}-rightbutton-container"\n\t\tba-if="{{fullscreen}}" ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-image\') : string(\'fullscreen-image\') }}"\n\t>\n\t\t<div class="{{css}}-button-inner {{css}}-full-screen-btn-inner">\n\t\t\t<i class="{{csscommon}}-icon-resize-{{fullscreened ? \'small\' : \'full\'}}"></i>\n\t\t</div>\n\t</div>\n\n\n</div>\n',
                  cssloader: ie8 ? "ba-imageviewer" : "",
                  cssmessage: "ba-imageviewer"
                }
              };
            }), Scoped.extend("module:Assets.audioplayerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                csstheme: function (_csstheme9) {
                  function csstheme(_x611) {
                    return _csstheme9.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme9.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                title: function (_title9) {
                  function title(_x612) {
                    return _title9.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title9.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit8) {
                  function submit(_x613) {
                    return _submit8.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit8.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable9) {
                  function submittable(_x614) {
                    return _submittable9.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable9.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-audio')": function stringSubmitAudio(obj) {
                  with (obj) return string("submit-audio");
                },
                "rerecord()": function (_rerecord11) {
                  function rerecord(_x615) {
                    return _rerecord11.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord11.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable9) {
                  function rerecordable(_x616) {
                    return _rerecordable9.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable9.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-audio')": function stringRerecordAudio(obj) {
                  with (obj) return string("rerecord-audio");
                },
                csscommon: function (_csscommon19) {
                  function csscommon(_x617) {
                    return _csscommon19.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon19.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "play()": function (_play6) {
                  function play(_x618) {
                    return _play6.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play6.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "!playing": function (_playing9) {
                  function playing(_x619) {
                    return _playing9.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing9.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "string('play-audio')": function stringPlayAudio(obj) {
                  with (obj) return string("play-audio");
                },
                "pause()": function (_pause6) {
                  function pause(_x620) {
                    return _pause6.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause6.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                playing: function (_playing10) {
                  function playing(_x621) {
                    return _playing10.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing10.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "disablepause ? string('pause-audio-disabled') : string('pause-audio')": function disablepauseStringPauseAudioDisabledStringPauseAudio(obj) {
                  with (obj) return disablepause ? string("pause-audio-disabled") : string("pause-audio");
                },
                "string('elapsed-time')": function stringElapsedTime(obj) {
                  with (obj) return string("elapsed-time");
                },
                "formatTime(position)": function formatTimePosition(obj) {
                  with (obj) return formatTime(position);
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "startUpdateVolume(domEvent)": function startUpdateVolumeDomEvent(obj) {
                  with (obj) return startUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent)": function stopUpdateVolumeDomEvent(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "progressUpdateVolume(domEvent)": function progressUpdateVolumeDomEvent(obj) {
                  with (obj) return progressUpdateVolume(domEvent);
                },
                "{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + '%'}": function widthMathCeil1MathMin99MathRoundVolume100(obj) {
                  with (obj) return {
                    width: Math.ceil(1 + Math.min(99, Math.round(100 * volume))) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                "toggle_volume()": function (_toggle_volume4) {
                  function toggle_volume(_x622) {
                    return _toggle_volume4.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume4.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "stopUpdatePosition(domEvent)": function stopUpdatePositionDomEvent(obj) {
                  with (obj) return stopUpdatePosition(domEvent);
                },
                "progressUpdatePosition(domEvent)": function progressUpdatePositionDomEvent(obj) {
                  with (obj) return progressUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('audio-progress')": function stringAudioProgress(obj) {
                  with (obj) return string("audio-progress");
                }
              }), {
                modern: {
                  css: "ba-audioplayer",
                  csstheme: "ba-player-theme-modern",
                  tmplcontrolbar: '<div data-selector="audio-title-block" class="{{csstheme}}-title-container " ba-if="{{title}}">\n\t<p class="{{csstheme}}-title">\n\t\t{{title}}\n\t</p>\n</div>\n\n<div class="{{csstheme}}-dashboard ">\n\n    <div tabindex="0" data-selector="submit-audio-button"\n\t\t ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n\t\t class="{{csstheme}}-leftbutton-container"\n\t\t ba-if="{{submittable}}" ba-click="{{submit()}}"\n\t>\n        <div class="{{csstheme}}-button-inner">\n        \t{{string(\'submit-audio\')}}\n        </div>\n    </div>\n\n    <div tabindex="0" data-selector="button-icon-ccw"\n\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t class="{{csstheme}}-leftbutton-container"\n\t\t ba-if="{{rerecordable}}" ba-click="{{rerecord()}}" title="{{string(\'rerecord-audio\')}}"\n\t>\n    \t<div class="{{csstheme}}-button-inner">\n    \t\t<i class="{{csscommon}}-icon-ccw"></i>\n    \t</div>\n    </div>\n\n\t<div tabindex="0" data-selector="button-icon-play"\n\t\t ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n\t\t onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}"\n\t\t class="{{csstheme}}-leftbutton-container"\n\t\t ba-if="{{!playing}}" ba-click="{{play()}}" title="{{string(\'play-audio\')}}"\n\t>\n\t\t<div class="{{csstheme}}-button-inner">\n\t\t\t<i class="{{csscommon}}-icon-play"></i>\n\t\t</div>\n\t</div>\n\n\t<div tabindex="0" data-selector="button-icon-pause"\n\t\t ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n\t\t onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}"\n\t\t class="{{csstheme}}-leftbutton-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n\t\t ba-if="{{playing}}" ba-click="{{pause()}}" title="{{disablepause ? string(\'pause-audio-disabled\') : string(\'pause-audio\')}}"\n\t>\n\t\t<div class="{{csstheme}}-button-inner">\n\t\t\t<i class="{{csscommon}}-icon-pause"></i>\n\t\t</div>\n\t</div>\n\t<div class="{{csstheme}}-time-container">\n\t\t<div class="{{csstheme}}-time-value" title="{{string(\'elapsed-time\')}}">{{formatTime(position)}}/{{formatTime(duration || position)}}</div>\n\t</div>\n\n\n\t<div class="{{csstheme}}-volumebar">\n\t\t<div tabindex="4" data-selector="button-volume-bar"\n\t\t\t ba-hotkey:right="{{set_volume(volume + 0.1)}}"\n\t\t\t ba-hotkey:left="{{set_volume(volume - 0.1)}}"\n\t\t\t onmouseout="this.blur()"\n\t\t\t class="{{csstheme}}-volumebar-inner"\n\t\t\t onmousedown="{{startUpdateVolume(domEvent)}}"\n\t\t\t onmouseup="{{stopUpdateVolume(domEvent)}}"\n\t\t\t onmouseleave="{{stopUpdateVolume(domEvent)}}"\n\t\t\t onmousemove="{{progressUpdateVolume(domEvent)}}"\n\t\t>\n\t\t\t<div class="{{csstheme}}-volumebar-position" ba-styles="{{{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + \'%\'}}}" title="{{string(\'volume-button\')}}"></div>\n\t\t</div>\n\t</div>\n\n\t<div tabindex="3" data-selector="button-icon-volume"\n\t\t ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n\t\t class="{{csstheme}}-rightbutton-container {{csstheme}}-volume-button-container"\n\t\t ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}"\n\t>\n\t\t<div class="{{csstheme}}-button-inner">\n\t\t\t<i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n\t\t</div>\n\t</div>\n\n\t<div class="{{csstheme}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}">\n\t\t<div tabindex="2" data-selector="progress-bar-inner"\n\t\t\t ba-hotkey:right="{{seek(position + skipseconds)}}"\n\t\t\t ba-hotkey:left="{{seek(position - skipseconds)}}"\n\t\t\t onmouseout="this.blur()"\n\t\t\t class="{{csstheme}}-progressbar-inner"\n\t\t     onmousedown="{{startUpdatePosition(domEvent)}}"\n\t\t     onmouseup="{{stopUpdatePosition(domEvent)}}"\n\t\t     onmouseleave="{{stopUpdatePosition(domEvent)}}"\n\t\t     onmousemove="{{progressUpdatePosition(domEvent)}}"\n\t\t>\n\t\t<div class="{{csstheme}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n\t\t<div class="{{csstheme}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'audio-progress\')}}"></div>\n\t</div>\n</div>\n',
                  cssloader: ie8 ? "ba-audioplayer" : "",
                  cssmessage: "ba-audioplayer",
                  cssplaybutton: ie8 ? "ba-audioplayer" : ""
                }
              };
            }), Scoped.extend("module:Assets.audiorecorderthemes", ["dynamics:Parser"], function (Parser) {
              return Parser.registerFunctions({
                css: function (_css34) {
                  function css(_x623) {
                    return _css34.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css34.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                csscommon: function (_csscommon20) {
                  function csscommon(_x624) {
                    return _csscommon20.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon20.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "actions.first().get('icon')": function actionsFirstGetIcon(obj) {
                  with (obj) return actions.first().get("icon");
                },
                actions: function (_actions5) {
                  function actions(_x625) {
                    return _actions5.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions5.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                }
              }), {
                modern: {
                  css: "ba-audiorecorder",
                  csstheme: "ba-audiorecorder-theme-modern",
                  cssrecorder: "ba-recorder",
                  cssloader: "ba-audiorecorder",
                  tmplchooser: '<div class="{{css}}-chooser-container">\n\n\t<div class="{{css}}-chooser-button-container">\n\n\t\t<div class="{{css}}-chooser-icon-container">\n\t\t\t<i class="{{csscommon}}-icon-{{actions.first().get(\'icon\')}}"></i>\n\t\t</div>\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div tabindex="0"\n\t\t\t\tba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t\t ba-click="{{click_action(action)}}"\n\t\t\t>\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t/>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n'
                }
              };
            });
          }.call(Scoped), function () {
            var Scoped = this.subScope();
            Scoped.binding("browser", "root:BetaJS.Browser"), Scoped.binding("dynamics", "root:BetaJS.Dynamics"), Scoped.binding("module", "root:BetaJS.MediaComponents"), Scoped.extend("module:Assets.playerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                csstheme: function (_csstheme10) {
                  function csstheme(_x626) {
                    return _csstheme10.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme10.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                "activitydelta > hidebarafter && hideoninactivity ? (cssplayer + '-dashboard-hidden') : ''": function activitydeltaHidebarafterHideoninactivityCssplayerDashboardHidden(obj) {
                  with (obj) return activitydelta > hidebarafter && hideoninactivity ? cssplayer + "-dashboard-hidden" : "";
                },
                title: function (_title10) {
                  function title(_x627) {
                    return _title10.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title10.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit9) {
                  function submit(_x628) {
                    return _submit9.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit9.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable10) {
                  function submittable(_x629) {
                    return _submittable10.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable10.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecord()": function (_rerecord12) {
                  function rerecord(_x630) {
                    return _rerecord12.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord12.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable10) {
                  function rerecordable(_x631) {
                    return _rerecordable10.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable10.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-video')": function stringRerecordVideo(obj) {
                  with (obj) return string("rerecord-video");
                },
                csscommon: function (_csscommon21) {
                  function csscommon(_x632) {
                    return _csscommon21.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon21.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "skipinitial ? 0 : 1": function skipinitial01(obj) {
                  with (obj) return skipinitial ? 0 : 1;
                },
                "play()": function (_play7) {
                  function play(_x633) {
                    return _play7.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play7.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "!playing": function (_playing11) {
                  function playing(_x634) {
                    return _playing11.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing11.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "string('play-video')": function stringPlayVideo(obj) {
                  with (obj) return string("play-video");
                },
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "pause()": function (_pause7) {
                  function pause(_x635) {
                    return _pause7.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause7.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                playing: function (_playing12) {
                  function playing(_x636) {
                    return _playing12.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing12.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "disablepause ? string('pause-video-disabled') : string('pause-video')": function disablepauseStringPauseVideoDisabledStringPauseVideo(obj) {
                  with (obj) return disablepause ? string("pause-video-disabled") : string("pause-video");
                },
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                "toggle_position_info()": function (_toggle_position_info3) {
                  function toggle_position_info(_x637) {
                    return _toggle_position_info3.apply(this, arguments);
                  }
                  toggle_position_info.toString = function () {
                    return _toggle_position_info3.toString();
                  };
                  return toggle_position_info;
                }(function (obj) {
                  with (obj) return toggle_position_info();
                }),
                "revertposition ? string('remaining-time') : string('elapsed-time')": function revertpositionStringRemainingTimeStringElapsedTime(obj) {
                  with (obj) return revertposition ? string("remaining-time") : string("elapsed-time");
                },
                'revertposition ? "-" : ""': function (_revertposition) {
                  function revertposition(_x638) {
                    return _revertposition.apply(this, arguments);
                  }
                  revertposition.toString = function () {
                    return _revertposition.toString();
                  };
                  return revertposition;
                }(function (obj) {
                  with (obj) return revertposition ? "-" : "";
                }),
                "revertposition ? formatTime(duration - position) : formatTime(position)": function revertpositionFormatTimeDurationPositionFormatTimePosition(obj) {
                  with (obj) return revertposition ? formatTime(duration - position) : formatTime(position);
                },
                "string('total-time')": function stringTotalTime(obj) {
                  with (obj) return string("total-time");
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                "toggle_volume()": function (_toggle_volume5) {
                  function toggle_volume(_x639) {
                    return _toggle_volume5.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume5.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                },
                "!hidevolumebar": function (_hidevolumebar4) {
                  function hidevolumebar(_x640) {
                    return _hidevolumebar4.apply(this, arguments);
                  }
                  hidevolumebar.toString = function () {
                    return _hidevolumebar4.toString();
                  };
                  return hidevolumebar;
                }(function (obj) {
                  with (obj) return !hidevolumebar;
                }),
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "startUpdateVolume(domEvent)": function startUpdateVolumeDomEvent(obj) {
                  with (obj) return startUpdateVolume(domEvent);
                },
                "progressUpdateVolume(domEvent)": function progressUpdateVolumeDomEvent(obj) {
                  with (obj) return progressUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent); this.blur()": function stopUpdateVolumeDomEventThisBlur(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent)": function stopUpdateVolumeDomEvent(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + '%'}": function widthMathCeil1MathMin99MathRoundVolume100(obj) {
                  with (obj) return {
                    width: Math.ceil(1 + Math.min(99, Math.round(100 * volume))) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                "toggle_stream()": function (_toggle_stream3) {
                  function toggle_stream(_x641) {
                    return _toggle_stream3.apply(this, arguments);
                  }
                  toggle_stream.toString = function () {
                    return _toggle_stream3.toString();
                  };
                  return toggle_stream;
                }(function (obj) {
                  with (obj) return toggle_stream();
                }),
                "streams.length > 1 && currentstream": function streamsLength1Currentstream(obj) {
                  with (obj) return 1 < streams.length && currentstream;
                },
                "string('change-resolution')": function stringChangeResolution(obj) {
                  with (obj) return string("change-resolution");
                },
                currentstream_label: function (_currentstream_label3) {
                  function currentstream_label(_x642) {
                    return _currentstream_label3.apply(this, arguments);
                  }
                  currentstream_label.toString = function () {
                    return _currentstream_label3.toString();
                  };
                  return currentstream_label;
                }(function (obj) {
                  with (obj) return currentstream_label;
                }),
                "show_airplay_devices()": function (_show_airplay_devices3) {
                  function show_airplay_devices(_x643) {
                    return _show_airplay_devices3.apply(this, arguments);
                  }
                  show_airplay_devices.toString = function () {
                    return _show_airplay_devices3.toString();
                  };
                  return show_airplay_devices;
                }(function (obj) {
                  with (obj) return show_airplay_devices();
                }),
                cssplayer: function (_cssplayer11) {
                  function cssplayer(_x644) {
                    return _cssplayer11.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer11.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                airplaybuttonvisible: function (_airplaybuttonvisible4) {
                  function airplaybuttonvisible(_x645) {
                    return _airplaybuttonvisible4.apply(this, arguments);
                  }
                  airplaybuttonvisible.toString = function () {
                    return _airplaybuttonvisible4.toString();
                  };
                  return airplaybuttonvisible;
                }(function (obj) {
                  with (obj) return airplaybuttonvisible;
                }),
                castbuttonvisble: function (_castbuttonvisble4) {
                  function castbuttonvisble(_x646) {
                    return _castbuttonvisble4.apply(this, arguments);
                  }
                  castbuttonvisble.toString = function () {
                    return _castbuttonvisble4.toString();
                  };
                  return castbuttonvisble;
                }(function (obj) {
                  with (obj) return castbuttonvisble;
                }),
                "toggle_fullscreen()": function (_toggle_fullscreen5) {
                  function toggle_fullscreen(_x647) {
                    return _toggle_fullscreen5.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen5.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                fullscreen: function (_fullscreen5) {
                  function fullscreen(_x648) {
                    return _fullscreen5.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen5.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-video') : string('fullscreen-video')": function fullscreenedStringExitFullscreenVideoStringFullscreenVideo(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-video") : string("fullscreen-video");
                },
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                "fullscreened ? 'small' : 'full'": function fullscreenedSmallFull(obj) {
                  with (obj) return fullscreened ? "small" : "full";
                },
                "toggle_tracks()": function (_toggle_tracks3) {
                  function toggle_tracks(_x649) {
                    return _toggle_tracks3.apply(this, arguments);
                  }
                  toggle_tracks.toString = function () {
                    return _toggle_tracks3.toString();
                  };
                  return toggle_tracks;
                }(function (obj) {
                  with (obj) return toggle_tracks();
                }),
                "(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload": function tracktagsLength0ShowsubtitlebuttonAllowtexttrackupload(obj) {
                  with (obj) return 0 < tracktags.length && showsubtitlebutton || allowtexttrackupload;
                },
                "tracktextvisible ? 'active' : 'inactive'": function tracktextvisibleActiveInactive(obj) {
                  with (obj) return tracktextvisible ? "active" : "inactive";
                },
                "tracktextvisible ? string('close-tracks') : string('show-tracks')": function tracktextvisibleStringCloseTracksStringShowTracks(obj) {
                  with (obj) return tracktextvisible ? string("close-tracks") : string("show-tracks");
                },
                "hover_cc(true)": function hover_ccTrue(obj) {
                  with (obj) return hover_cc(!0);
                },
                "hover_cc(false)": function hover_ccFalse(obj) {
                  with (obj) return hover_cc(!1);
                },
                settingsmenubutton: function (_settingsmenubutton3) {
                  function settingsmenubutton(_x650) {
                    return _settingsmenubutton3.apply(this, arguments);
                  }
                  settingsmenubutton.toString = function () {
                    return _settingsmenubutton3.toString();
                  };
                  return settingsmenubutton;
                }(function (obj) {
                  with (obj) return settingsmenubutton;
                }),
                "toggle_settings_menu()": function (_toggle_settings_menu3) {
                  function toggle_settings_menu(_x651) {
                    return _toggle_settings_menu3.apply(this, arguments);
                  }
                  toggle_settings_menu.toString = function () {
                    return _toggle_settings_menu3.toString();
                  };
                  return toggle_settings_menu;
                }(function (obj) {
                  with (obj) return toggle_settings_menu();
                }),
                "settingsmenuactive ? 'active' : 'inactive'": function settingsmenuactiveActiveInactive(obj) {
                  with (obj) return settingsmenuactive ? "active" : "inactive";
                },
                "string('settings')": function stringSettings(obj) {
                  with (obj) return string("settings");
                },
                trimmingmode: function (_trimmingmode6) {
                  function trimmingmode(_x652) {
                    return _trimmingmode6.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode6.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "trim()": function (_trim4) {
                  function trim(_x653) {
                    return _trim4.apply(this, arguments);
                  }
                  trim.toString = function () {
                    return _trim4.toString();
                  };
                  return trim;
                }(function (obj) {
                  with (obj) return trim();
                }),
                "string('trim-video')": function stringTrimVideo(obj) {
                  with (obj) return string("trim-video");
                },
                frameselectionmode: function (_frameselectionmode5) {
                  function frameselectionmode(_x654) {
                    return _frameselectionmode5.apply(this, arguments);
                  }
                  frameselectionmode.toString = function () {
                    return _frameselectionmode5.toString();
                  };
                  return frameselectionmode;
                }(function (obj) {
                  with (obj) return frameselectionmode;
                }),
                "select_frame()": function (_select_frame3) {
                  function select_frame(_x655) {
                    return _select_frame3.apply(this, arguments);
                  }
                  select_frame.toString = function () {
                    return _select_frame3.toString();
                  };
                  return select_frame;
                }(function (obj) {
                  with (obj) return select_frame();
                }),
                "string('select-frame')": function stringSelectFrame(obj) {
                  with (obj) return string("select-frame");
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "seek(position + skipseconds * 3)": function seekPositionSkipseconds3(obj) {
                  with (obj) return seek(position + 3 * skipseconds);
                },
                "seek(position - skipseconds * 3)": function seekPositionSkipseconds3(obj) {
                  with (obj) return seek(position - 3 * skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('video-progress')": function stringVideoProgress(obj) {
                  with (obj) return string("video-progress");
                },
                "{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + '%'}": function leftMathRoundDurationTrimstartTrimstartDuration1000(obj) {
                  with (obj) return {
                    left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + "%"
                  };
                },
                "{left: 'auto', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + '%'}": function leftAutoRight100MathRoundDurationTrimendTrimendDuration100100(obj) {
                  with (obj) return {
                    left: "auto",
                    right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + "%"
                  };
                }
              }), Parser.registerFunctions({
                "play()": function (_play8) {
                  function play(_x656) {
                    return _play8.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play8.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'player-toggle-overlay')": function tab_index_moveDomEventNullPlayerToggleOverlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "player-toggle-overlay");
                },
                cssplayer: function (_cssplayer12) {
                  function cssplayer(_x657) {
                    return _cssplayer12.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer12.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "string('tooltip')": function stringTooltip(obj) {
                  with (obj) return string("tooltip");
                },
                "showduration && (duration != 0 && duration != undefined)": function showdurationDuration0DurationUndefined(obj) {
                  with (obj) return showduration && 0 != duration && duration != undefined;
                },
                css: function (_css35) {
                  function css(_x658) {
                    return _css35.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css35.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "formatTime(duration)": function formatTimeDuration(obj) {
                  with (obj) return formatTime(duration);
                },
                "rerecordable || submittable": function rerecordableSubmittable(obj) {
                  with (obj) return rerecordable || submittable;
                },
                "submittable && !trimmingmode": function submittableTrimmingmode(obj) {
                  with (obj) return submittable && !trimmingmode;
                },
                "submit()": function (_submit10) {
                  function submit(_x659) {
                    return _submit10.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit10.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecordable && !trimmingmode": function rerecordableTrimmingmode(obj) {
                  with (obj) return rerecordable && !trimmingmode;
                },
                "rerecord()": function (_rerecord13) {
                  function rerecord(_x660) {
                    return _rerecord13.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord13.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                trimmingmode: function (_trimmingmode7) {
                  function trimmingmode(_x661) {
                    return _trimmingmode7.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode7.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "string('trim')": function stringTrim(obj) {
                  with (obj) return string("trim");
                },
                "skip()": function (_skip5) {
                  function skip(_x662) {
                    return _skip5.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip5.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                }
              }), {
                cube: {
                  css: "ba-videoplayer",
                  csstheme: "ba-player-cube-theme",
                  cssplayer: "ba-player",
                  tmplcontrolbar: '\n<div data-selector="video-title-block" class="{{csstheme}}-title-block {{activitydelta > hidebarafter && hideoninactivity ? (cssplayer + \'-dashboard-hidden\') : \'\'}}" ba-if="{{title}}">\n    <p class="{{csstheme}}-title">\n        {{title}}\n    </p>\n</div>\n\n<div class="{{csstheme}}-dashboard {{activitydelta > hidebarafter && hideoninactivity ? (cssplayer + \'-dashboard-hidden\') : \'\'}}">\n\n    <div class="{{csstheme}}-left-block">\n\n        <div tabindex="0" data-selector="submit-video-button"\n             ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container" ba-if="{{submittable}}" ba-click="{{submit()}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                {{string(\'submit-video\')}}\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-ccw"\n             ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container" ba-if="{{rerecordable}}"\n             ba-click="{{rerecord()}}" title="{{string(\'rerecord-video\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-ccw"></i>\n            </div>\n        </div>\n\n        <div tabindex="{{skipinitial ? 0 : 1}}" data-selector="button-icon-play"\n             ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container"\n             ba-if="{{!playing}}" ba-click="{{play()}}" title="{{string(\'play-video\')}}"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-play"></i>\n            </div>\n        </div>\n\n        <div tabindex="{{skipinitial ? 0 : 1 }}" data-selector="button-icon-pause"\n             ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n             ba-if="{{playing}}" ba-click="{{pause()}}" title="{{disablepause ? string(\'pause-video-disabled\') : string(\'pause-video\')}}"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-pause"></i>\n            </div>\n        </div>\n    </div>\n\n    <div class="{{csstheme}}-right-block">\n        <div class="{{csstheme}}-button-container {{csstheme}}-timer-container {{csscommon}}-clickable"\n             ba-click="{{toggle_position_info()}}"\n        >\n            <div class="{{csstheme}}-time-container">\n                <div class="{{csstheme}}-time-value"\n                     title="{{revertposition ? string(\'remaining-time\') : string(\'elapsed-time\')}}"\n                >\n                    {{revertposition ? "-" : ""}}\n                    {{revertposition ? formatTime(duration - position) : formatTime(position)}}\n                </div>\n            </div>\n            <p> / </p>\n            <div class="{{csstheme}}-time-container">\n                <div class="{{csstheme}}-time-value" title="{{string(\'total-time\')}}">{{formatTime(duration || position)}}</div>\n            </div>\n        </div>\n\n        <div tabindex="3" data-selector="button-icon-volume"\n             ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container"\n             ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}">\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n            </div>\n        </div>\n\n        <div class="{{csstheme}}-volumebar" ba-show="{{!hidevolumebar}}">\n            <div tabindex="4" data-selector="button-volume-bar"\n                 ba-hotkey:right="{{set_volume(volume + 0.1)}}"\n                 ba-hotkey:left="{{set_volume(volume - 0.1)}}"\n                 onmouseout="this.blur()"\n                 class="{{csstheme}}-volumebar-inner"\n                 ontouchstart="{{startUpdateVolume(domEvent)}}"\n                 ontouchmove="{{progressUpdateVolume(domEvent)}}"\n                 ontouchend="{{stopUpdateVolume(domEvent); this.blur()}};"\n                 onmousedown="{{startUpdateVolume(domEvent)}}"\n                 onmouseup="{{stopUpdateVolume(domEvent)}}"\n                 onmouseleave="{{stopUpdateVolume(domEvent)}}"\n                 onmousemove="{{progressUpdateVolume(domEvent)}}">\n                <div class="{{csstheme}}-volumebar-position" ba-styles="{{{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + \'%\'}}}" title="{{string(\'volume-button\')}}"></div>\n            </div>\n        </div>\n\n        <div tabindex="5" data-selector="button-stream-label"\n             ba-hotkey:space^enter="{{toggle_stream()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container" ba-if="{{streams.length > 1 && currentstream}}"\n             ba-click="{{toggle_stream()}}" title="{{string(\'change-resolution\')}}"\n        >\n            <div class="{{csstheme}}-button-inner {{csstheme}}-stream-label-container">\n                <div class="{{csstheme}}-button-text {{csstheme}}-stream-label">\n                    <span>{{currentstream_label}}</span>\n                </div>\n            </div>\n        </div>\n\n        <div tabindex="6" data-selector="button-airplay"\n             ba-hotkey:space^enter="{{show_airplay_devices()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container {{cssplayer}}-airplay-container"\n             ba-show="{{airplaybuttonvisible}}" ba-click="{{show_airplay_devices()}}">\n            <svg width="16px" height="11px" viewBox="0 0 16 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n                \n                <title>Airplay</title>\n                <desc>Airplay icon.</desc>\n                <defs></defs>\n                <g stroke="none" stroke-width="1" fill-rule="evenodd" sketch:type="MSPage">\n                    <path d="M4,11 L12,11 L8,7 L4,11 Z M14.5454545,0 L1.45454545,0 C0.654545455,0 0,0.5625 0,1.25 L0,8.75 C0,9.4375 0.654545455,10 1.45454545,10 L4.36363636,10 L4.36363636,8.75 L1.45454545,8.75 L1.45454545,1.25 L14.5454545,1.25 L14.5454545,8.75 L11.6363636,8.75 L11.6363636,10 L14.5454545,10 C15.3454545,10 16,9.4375 16,8.75 L16,1.25 C16,0.5625 15.3454545,0 14.5454545,0 L14.5454545,0 Z" sketch:type="MSShapeGroup"></path>\n                </g>\n            </svg>\n        </div>\n\n        <div tabindex="7" data-selector="button-chromecast" onmouseout="this.blur()" class="{{csstheme}}-button-container {{csstheme}}-cast-button-container" ba-show="{{castbuttonvisble}}">\n            <button class="{{csstheme}}-gcast-button" is="google-cast-button"></button>\n        </div>\n\n        <div tabindex="8" data-selector="button-icon-resize-full"\n             ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container" ba-if={{fullscreen}}\n             ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-video\') : string(\'fullscreen-video\') }}"\n             onkeydown="{{tab_index_move(domEvent)}}"\n        >\n            <div class="{{csstheme}}-button-inner {{csstheme}}-full-screen-btn-inner">\n                <i class="{{csscommon}}-icon-resize-{{fullscreened ? \'small\' : \'full\'}}"></i>\n            </div>\n        </div>\n\n        <div tabindex="9" data-selector="cc-button-container"\n             ba-hotkey:space^enter="{{toggle_tracks()}}" onmouseout="this.blur()"\n             ba-if="{{(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload}}"\n             class="{{csstheme}}-button-container  {{cssplayer}}-button-{{tracktextvisible ? \'active\' : \'inactive\'}}"\n             title="{{tracktextvisible ? string(\'close-tracks\') : string(\'show-tracks\')}}"\n             ba-click="{{toggle_tracks()}}"\n             onmouseover="{{hover_cc(true)}}"\n             onmouseleave="{{hover_cc(false)}}"\n             onkeydown="{{tab_index_move(domEvent)}}"\n        >\n            <div class="{{csstheme}}-button-inner {{csstheme}}-subtitle-button-inner">\n                <i class="{{csscommon}}-icon-subtitle"></i>\n            </div>\n        </div>\n\n        <div tabindex="10" data-selector="button-icon-settings" ba-if="{{settingsmenubutton}}"\n             ba-hotkey:space^enter="{{toggle_settings_menu()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container {{cssplayer}}-button-{{settingsmenuactive ? \'active\' : \'inactive\'}}"\n             ba-click="{{toggle_settings_menu()}}"\n             title="{{string(\'settings\')}}"\n             onkeydown="{{tab_index_move(domEvent)}}"\n        >\n            <div class="{{csstheme}}-button-inner {{csstheme}}-settings-button">\n                <i class="{{csscommon}}-icon-cog"></i>\n            </div>\n        </div>\n\n        <div tabindex="11" class="{{csstheme}}-button-container" ba-if="{{trimmingmode}}">\n            <div data-selector="trim-button"\n                 onmouseout="this.blur()"\n                 ba-click="{{trim()}}"\n                 class="{{csstheme}}-button-inner {{csstheme}}-primary-button">\n                 {{string(\'trim-video\')}}\n            </div>\n        </div>\n\n        <div tabindex="11" class="{{csstheme}}-button-container" ba-if="{{frameselectionmode}}">\n            <div data-selector="select-frame-button"\n                 onmouseout="this.blur()"\n                 ba-click="{{select_frame()}}"\n                 class="{{csstheme}}-button-inner {{csstheme}}-primary-button">\n                 {{string(\'select-frame\')}}\n            </div>\n        </div>\n    </div>\n\n    <div class="{{csstheme}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}">\n        <div tabindex="2" data-selector="progress-bar-inner"\n             ba-hotkey:right="{{seek(position + skipseconds)}}"\n             ba-hotkey:left="{{seek(position - skipseconds)}}"\n             ba-hotkey:alt+right="{{seek(position + skipseconds * 3)}}"\n             ba-hotkey:alt+left="{{seek(position - skipseconds * 3)}}"\n             onmouseout="this.blur()"\n             class="{{csstheme}}-progressbar-inner"\n             ontouchstart="{{startUpdatePosition(domEvent)}}"\n             onmousedown="{{startUpdatePosition(domEvent)}}"\n        >\n\n            <div class="{{csstheme}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n            <div class="{{csstheme}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'video-progress\')}}"></div>\n            <div class="{{csstheme}}-progressbar-marker"\n                data-selector="trim-start-marker"\n                ba-if="{{trimmingmode}}"\n                ba-styles="{{{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + \'%\'}}}"\n            ></div>\n            <div class="{{csstheme}}-progressbar-marker"\n                    data-selector="trim-end-marker"\n                    ba-if="{{trimmingmode}}"\n                    ba-styles="{{{left: \'auto\', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + \'%\'}}}"\n            ></div>\n        </div>\n    </div>\n\n</div>\n',
                  tmplplaybutton: '\n<div tabindex="0" data-selector="play-button"\n     ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n     onkeydown="{{tab_index_move(domEvent, null, \'player-toggle-overlay\')}}"\n     class="{{cssplayer}}-playbutton-container" ba-click="{{play()}}" title="{{string(\'tooltip\')}}"\n>\n\t<div class="{{cssplayer}}-playbutton-button"></div>\n</div>\n<div ba-show="{{showduration && (duration != 0 && duration != undefined)}}" class="{{css}}-playbutton-duration">\n    {{formatTime(duration)}}\n</div>\n\n<div class="{{cssplayer}}-rerecord-bar" ba-if="{{rerecordable || submittable}}">\n\t<div class="{{cssplayer}}-rerecord-backbar"></div>\n\t<div class="{{cssplayer}}-rerecord-frontbar">\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{submittable && !trimmingmode}}">\n            <div tabindex="0" data-selector="player-submit-button"\n                 ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{submit()}}">\n                {{string(\'submit-video\')}}\n            </div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{rerecordable && !trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-rerecord-button"\n                 ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{rerecord()}}">\n        \t\t{{string(\'rerecord\')}}\n        \t</div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-trim-button"\n                 ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{play()}}">\n        \t\t{{string(\'trim\')}}\n        \t</div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-skip-button"\n                 ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{skip()}}">\n        \t\t{{string(\'skip\')}}\n        \t</div>\n        </div>\n\t</div>\n</div>\n',
                  cssloader: ie8 ? "ba-videoplayer" : "",
                  cssmessage: "ba-videoplayer",
                  cssplaybutton: ie8 ? "ba-videoplayer" : ""
                }
              };
            }), Scoped.extend("module:Assets.recorderthemes", ["dynamics:Parser"], function (Parser) {
              return Parser.registerFunctions({
                csstheme: function (_csstheme11) {
                  function csstheme(_x663) {
                    return _csstheme11.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme11.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                css: function (_css36) {
                  function css(_x664) {
                    return _css36.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css36.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "settingsvisible && settingsopen": function settingsvisibleSettingsopen(obj) {
                  with (obj) return settingsvisible && settingsopen;
                },
                videoselectnotification: function (_videoselectnotification2) {
                  function videoselectnotification(_x665) {
                    return _videoselectnotification2.apply(this, arguments);
                  }
                  videoselectnotification.toString = function () {
                    return _videoselectnotification2.toString();
                  };
                  return videoselectnotification;
                }(function (obj) {
                  with (obj) return videoselectnotification;
                }),
                "string('add-stream')": function stringAddStream(obj) {
                  with (obj) return string("add-stream");
                },
                csscommon: function (_csscommon22) {
                  function csscommon(_x666) {
                    return _csscommon22.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon22.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "showaddstreambutton && firefox && allowscreen": function showaddstreambuttonFirefoxAllowscreen(obj) {
                  with (obj) return showaddstreambutton && firefox && allowscreen;
                },
                "addNewStream()": function (_addNewStream2) {
                  function addNewStream(_x667) {
                    return _addNewStream2.apply(this, arguments);
                  }
                  addNewStream.toString = function () {
                    return _addNewStream2.toString();
                  };
                  return addNewStream;
                }(function (obj) {
                  with (obj) return addNewStream();
                }),
                "hover(string('add-stream'))": function hoverStringAddStream(obj) {
                  with (obj) return hover(string("add-stream"));
                },
                "showaddstreambutton && !firefox": function showaddstreambuttonFirefox(obj) {
                  with (obj) return showaddstreambutton && !firefox;
                },
                cameras: function (_cameras5) {
                  function cameras(_x668) {
                    return _cameras5.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras5.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "(camera.id !== selectedcamera) || allowscreen": function cameraIdSelectedcameraAllowscreen(obj) {
                  with (obj) return camera.id !== selectedcamera || allowscreen;
                },
                "addNewStream(camera.id)": function addNewStreamCameraId(obj) {
                  with (obj) return addNewStream(camera.id);
                },
                "camera.label": function cameraLabel(obj) {
                  with (obj) return camera.label;
                },
                "(showaddstreambutton && !firefox) || (firefox && allowscreen)": function showaddstreambuttonFirefoxFirefoxAllowscreen(obj) {
                  with (obj) return showaddstreambutton && !firefox || firefox && allowscreen;
                },
                "!novideo && !allowscreen && !ismobile": function novideoAllowscreenIsmobile(obj) {
                  with (obj) return !novideo && !allowscreen && !ismobile;
                },
                "hover(string('select-camera'))": function hoverStringSelectCamera(obj) {
                  with (obj) return hover(string("select-camera"));
                },
                "selectCamera(camera.id)": function selectCameraCameraId(obj) {
                  with (obj) return selectCamera(camera.id);
                },
                "selectedcamera == camera.id": function selectedcameraCameraId(obj) {
                  with (obj) return selectedcamera == camera.id;
                },
                "(!noaudio && !novideo) || !allowscreen": function noaudioNovideoAllowscreen(obj) {
                  with (obj) return !noaudio && !novideo || !allowscreen;
                },
                microphones: function (_microphones5) {
                  function microphones(_x669) {
                    return _microphones5.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones5.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                "!noaudio && !allowscreen": function noaudioAllowscreen(obj) {
                  with (obj) return !noaudio && !allowscreen;
                },
                "selectMicrophone(microphone.id)": function selectMicrophoneMicrophoneId(obj) {
                  with (obj) return selectMicrophone(microphone.id);
                },
                "hover(string('select-audio-input'))": function hoverStringSelectAudioInput(obj) {
                  with (obj) return hover(string("select-audio-input"));
                },
                "selectedmicrophone == microphone.id": function selectedmicrophoneMicrophoneId(obj) {
                  with (obj) return selectedmicrophone == microphone.id;
                },
                "microphone.label": function microphoneLabel(obj) {
                  with (obj) return microphone.label;
                },
                rerecordvisible: function (_rerecordvisible7) {
                  function rerecordvisible(_x670) {
                    return _rerecordvisible7.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible7.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord14) {
                  function rerecord(_x671) {
                    return _rerecord14.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord14.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "unhover()": function (_unhover4) {
                  function unhover(_x672) {
                    return _unhover4.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover4.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible4) {
                  function cancelvisible(_x673) {
                    return _cancelvisible4.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible4.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel4) {
                  function cancel(_x674) {
                    return _cancel4.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel4.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                },
                "stopvisible && recordingindication": function stopvisibleRecordingindication(obj) {
                  with (obj) return stopvisible && recordingindication;
                },
                settingsvisible: function (_settingsvisible7) {
                  function settingsvisible(_x675) {
                    return _settingsvisible7.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible7.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                ismobile: function (_ismobile) {
                  function ismobile(_x676) {
                    return _ismobile.apply(this, arguments);
                  }
                  ismobile.toString = function () {
                    return _ismobile.toString();
                  };
                  return ismobile;
                }(function (obj) {
                  with (obj) return ismobile;
                }),
                "toggleFaceMode()": function (_toggleFaceMode2) {
                  function toggleFaceMode(_x677) {
                    return _toggleFaceMode2.apply(this, arguments);
                  }
                  toggleFaceMode.toString = function () {
                    return _toggleFaceMode2.toString();
                  };
                  return toggleFaceMode;
                }(function (obj) {
                  with (obj) return toggleFaceMode();
                }),
                "hover(string('switch-camera'))": function hoverStringSwitchCamera(obj) {
                  with (obj) return hover(string("switch-camera"));
                },
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                "hover(string(microphonehealthy ? 'microphonehealthy' : 'microphoneunhealthy'))": function hoverStringMicrophonehealthyMicrophonehealthyMicrophoneunhealthy(obj) {
                  with (obj) return hover(string(microphonehealthy ? "microphonehealthy" : "microphoneunhealthy"));
                },
                "microphonehealthy ? 'good' : 'bad'": function microphonehealthyGoodBad(obj) {
                  with (obj) return microphonehealthy ? "good" : "bad";
                },
                "!novideo && !allowscreen": function novideoAllowscreen(obj) {
                  with (obj) return !novideo && !allowscreen;
                },
                "hover(string(camerahealthy ? 'camerahealthy' : 'cameraunhealthy'))": function hoverStringCamerahealthyCamerahealthyCameraunhealthy(obj) {
                  with (obj) return hover(string(camerahealthy ? "camerahealthy" : "cameraunhealthy"));
                },
                "camerahealthy ? 'good' : 'bad'": function camerahealthyGoodBad(obj) {
                  with (obj) return camerahealthy ? "good" : "bad";
                },
                cssrecorder: function (_cssrecorder5) {
                  function cssrecorder(_x678) {
                    return _cssrecorder5.apply(this, arguments);
                  }
                  cssrecorder.toString = function () {
                    return _cssrecorder5.toString();
                  };
                  return cssrecorder;
                }(function (obj) {
                  with (obj) return cssrecorder;
                }),
                recordvisible: function (_recordvisible7) {
                  function recordvisible(_x679) {
                    return _recordvisible7.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible7.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record4) {
                  function record(_x680) {
                    return _record4.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record4.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                stopvisible: function (_stopvisible5) {
                  function stopvisible(_x681) {
                    return _stopvisible5.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible5.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                "controlbarlabel && !rerecordvisible": function controlbarlabelRerecordvisible(obj) {
                  with (obj) return controlbarlabel && !rerecordvisible;
                },
                controlbarlabel: function (_controlbarlabel7) {
                  function controlbarlabel(_x682) {
                    return _controlbarlabel7.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel7.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                "pausable && !resumevisible": function pausableResumevisible(obj) {
                  with (obj) return pausable && !resumevisible;
                },
                "stop()": function (_stop3) {
                  function stop(_x683) {
                    return _stop3.apply(this, arguments);
                  }
                  stop.toString = function () {
                    return _stop3.toString();
                  };
                  return stop;
                }(function (obj) {
                  with (obj) return stop();
                }),
                "string('pause-recorder')": function stringPauseRecorder(obj) {
                  with (obj) return string("pause-recorder");
                },
                "pause()": function (_pause8) {
                  function pause(_x684) {
                    return _pause8.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause8.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "hover(string('pause-recorder'))": function hoverStringPauseRecorder(obj) {
                  with (obj) return hover(string("pause-recorder"));
                },
                "pausable && resumevisible": function pausableResumevisible(obj) {
                  with (obj) return pausable && resumevisible;
                },
                "resume()": function (_resume3) {
                  function resume(_x685) {
                    return _resume3.apply(this, arguments);
                  }
                  resume.toString = function () {
                    return _resume3.toString();
                  };
                  return resume;
                }(function (obj) {
                  with (obj) return resume();
                }),
                "string('resume-recorder')": function stringResumeRecorder(obj) {
                  with (obj) return string("resume-recorder");
                },
                "hover(string('resume-recorder'))": function hoverStringResumeRecorder(obj) {
                  with (obj) return hover(string("resume-recorder"));
                },
                "mintimeindicator ? css + '-disabled': ''": function mintimeindicatorCssDisabled(obj) {
                  with (obj) return mintimeindicator ? css + "-disabled" : "";
                },
                "mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip')": function mintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip");
                },
                "hover(mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip'))": function hoverMintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return hover(mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip"));
                },
                "string('stop')": function stringStop(obj) {
                  with (obj) return string("stop");
                },
                skipvisible: function (_skipvisible3) {
                  function skipvisible(_x686) {
                    return _skipvisible3.apply(this, arguments);
                  }
                  skipvisible.toString = function () {
                    return _skipvisible3.toString();
                  };
                  return skipvisible;
                }(function (obj) {
                  with (obj) return skipvisible;
                }),
                "skip()": function (_skip6) {
                  function skip(_x687) {
                    return _skip6.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip6.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "hover(string('skip-tooltip'))": function hoverStringSkipTooltip(obj) {
                  with (obj) return hover(string("skip-tooltip"));
                },
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                },
                uploadcovershotvisible: function (_uploadcovershotvisible3) {
                  function uploadcovershotvisible(_x688) {
                    return _uploadcovershotvisible3.apply(this, arguments);
                  }
                  uploadcovershotvisible.toString = function () {
                    return _uploadcovershotvisible3.toString();
                  };
                  return uploadcovershotvisible;
                }(function (obj) {
                  with (obj) return uploadcovershotvisible;
                }),
                "hover(string('upload-covershot-tooltip'))": function hoverStringUploadCovershotTooltip(obj) {
                  with (obj) return hover(string("upload-covershot-tooltip"));
                },
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                covershot_accept_string: function (_covershot_accept_string3) {
                  function covershot_accept_string(_x689) {
                    return _covershot_accept_string3.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string3.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                showslidercontainer: function (_showslidercontainer3) {
                  function showslidercontainer(_x690) {
                    return _showslidercontainer3.apply(this, arguments);
                  }
                  showslidercontainer.toString = function () {
                    return _showslidercontainer3.toString();
                  };
                  return showslidercontainer;
                }(function (obj) {
                  with (obj) return showslidercontainer;
                }),
                css: function (_css37) {
                  function css(_x691) {
                    return _css37.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css37.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "left()": function (_left2) {
                  function left(_x692) {
                    return _left2.apply(this, arguments);
                  }
                  left.toString = function () {
                    return _left2.toString();
                  };
                  return left;
                }(function (obj) {
                  with (obj) return left();
                }),
                csscommon: function (_csscommon23) {
                  function csscommon(_x693) {
                    return _csscommon23.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon23.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                images: function (_images2) {
                  function images(_x694) {
                    return _images2.apply(this, arguments);
                  }
                  images.toString = function () {
                    return _images2.toString();
                  };
                  return images;
                }(function (obj) {
                  with (obj) return images;
                }),
                "select(image)": function selectImage(obj) {
                  with (obj) return select(image);
                },
                "{left: image.left + 'px', top: image.top + 'px', width: image.width + 'px', height: image.height + 'px'}": function leftImageLeftPxTopImageTopPxWidthImageWidthPxHeightImageHeightPx(obj) {
                  with (obj) return {
                    left: image.left + "px",
                    top: image.top + "px",
                    width: image.width + "px",
                    height: image.height + "px"
                  };
                },
                "right()": function (_right2) {
                  function right(_x695) {
                    return _right2.apply(this, arguments);
                  }
                  right.toString = function () {
                    return _right2.toString();
                  };
                  return right;
                }(function (obj) {
                  with (obj) return right();
                }),
                "!showslidercontainer": function (_showslidercontainer4) {
                  function showslidercontainer(_x696) {
                    return _showslidercontainer4.apply(this, arguments);
                  }
                  showslidercontainer.toString = function () {
                    return _showslidercontainer4.toString();
                  };
                  return showslidercontainer;
                }(function (obj) {
                  with (obj) return !showslidercontainer;
                }),
                covershot_accept_string: function (_covershot_accept_string4) {
                  function covershot_accept_string(_x697) {
                    return _covershot_accept_string4.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string4.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                css: function (_css38) {
                  function css(_x698) {
                    return _css38.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css38.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "initialmessages.length > 0": function initialmessagesLength0(obj) {
                  with (obj) return 0 < initialmessages.length;
                },
                csscommon: function (_csscommon24) {
                  function csscommon(_x699) {
                    return _csscommon24.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon24.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                initialmessages: function (_initialmessages4) {
                  function initialmessages(_x700) {
                    return _initialmessages4.apply(this, arguments);
                  }
                  initialmessages.toString = function () {
                    return _initialmessages4.toString();
                  };
                  return initialmessages;
                }(function (obj) {
                  with (obj) return initialmessages;
                }),
                "initialmessage.message": function initialmessageMessage(obj) {
                  with (obj) return initialmessage.message;
                },
                "initialmessage.type ? initialmessage.type : 'default'": function initialmessageTypeInitialmessageTypeDefault(obj) {
                  with (obj) return initialmessage.type ? initialmessage.type : "default";
                },
                "initialmessage.id": function initialmessageId(obj) {
                  with (obj) return initialmessage.id;
                },
                actions: function (_actions6) {
                  function actions(_x701) {
                    return _actions6.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions6.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.switchcamera": function actionSwitchcamera(obj) {
                  with (obj) return action.switchcamera;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                },
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                }
              }), Parser.registerFunctions({
                cssrecorder: function (_cssrecorder6) {
                  function cssrecorder(_x702) {
                    return _cssrecorder6.apply(this, arguments);
                  }
                  cssrecorder.toString = function () {
                    return _cssrecorder6.toString();
                  };
                  return cssrecorder;
                }(function (obj) {
                  with (obj) return cssrecorder;
                }),
                "click()": function (_click7) {
                  function click(_x703) {
                    return _click7.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click7.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                "shortMessage ? 'short-message' : 'long-message'": function shortMessageShortMessageLongMessage(obj) {
                  with (obj) return shortMessage ? "short-message" : "long-message";
                },
                'message || ""': function (_message13) {
                  function message(_x704) {
                    return _message13.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message13.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links4) {
                  function links(_x705) {
                    return _links4.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links4.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }), {
                cube: {
                  css: "ba-videorecorder",
                  cssrecorder: "ba-recorder",
                  csstheme: "ba-recorder-theme-cube",
                  cssmessage: "ba-videorecorder-theme-cube",
                  cssloader: "ba-videorecorder",
                  tmplcontrolbar: '<div class="{{csstheme}}-dashboard">\n\n\t<div class="{{css}}-settings-front">\n\n\t\t\n\t\t<div data-selector="recorder-settings" class="{{css}}-settings" ba-show="{{settingsvisible && settingsopen}}">\n\t\t\t<div data-selector="settings-list-front" class="{{css}}-bubble-info">\n\t\t\t\t<ul data-selector="add-new-stream" ba-if="{{videoselectnotification}}">\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div data-selector="single-camera-stream">\n\t\t\t\t\t\t\t<i class="ba-commoncss-icon-plus"></i> {{string(\'add-stream\')}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div data-selector="single-camera-stream" class="{{csscommon}}-text-error">\n\t\t\t\t\t\t\t{{videoselectnotification}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<ul data-selector="add-new-stream" ba-show="{{showaddstreambutton && firefox && allowscreen}}">\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div data-selector="single-camera-stream"\n\t\t\t\t\t\t\t class="{{css}}-add-stream"\n\t\t\t\t\t\t\t onclick="{{addNewStream()}}"\n\t\t\t\t\t\t\t onmouseenter="{{hover(string(\'add-stream\'))}}"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-plus"></i> {{string(\'add-stream\')}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\n\t\t\t\t<ul data-selector="add-new-stream" ba-show="{{showaddstreambutton && !firefox}}" ba-repeat="{{camera :: cameras}}">\n\t\t\t\t\t<li ba-show="{{(camera.id !== selectedcamera) || allowscreen}}">\n\t\t\t\t\t\t<div data-selector="single-camera-stream"\n\t\t\t\t\t\t\t class="{{css}}-add-stream"\n\t\t\t\t\t\t\t onclick="{{addNewStream(camera.id)}}"\n\t\t\t\t\t\t\t onmouseenter="{{hover(string(\'add-stream\'))}}"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-plus"></i> {{camera.label}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<hr ba-show="{{(showaddstreambutton && !firefox) || (firefox && allowscreen)}}"/>\n\t\t\t\t<ul data-selector="camera-settings" ba-repeat="{{camera :: cameras}}" ba-show="{{!novideo && !allowscreen && !ismobile}}">\n\t\t\t\t\t<li onmouseenter="{{hover(string(\'select-camera\'))}}">\n\t\t\t\t\t\t<input tabindex="0"\n\t\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n                               type=\'radio\'\n\t\t\t\t\t\t\t   name=\'camera\' value="{{selectedcamera == camera.id}}" onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t/>\n\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t<label tabindex="0" ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t{{camera.label}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<hr ba-show="{{(!noaudio && !novideo) || !allowscreen}}"/>\n\t\t\t\t<ul data-selector="microphone-settings" ba-repeat="{{microphone :: microphones}}" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t\t<li tabindex="0"\n\t\t\t\t\t\tba-hotkey:space^enter="{{selectMicrophone(microphone.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\tonmouseenter="{{hover(string(\'select-audio-input\'))}}"\n\t\t\t\t\t\tonclick="{{selectMicrophone(microphone.id)}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<input type=\'radio\' name=\'microphone\' value="{{selectedmicrophone == microphone.id}}" />\n\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t{{microphone.label}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n\t\t<div class="{{css}}-controlbar-center-section">\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{rerecordvisible}}">\n\t\t\t\t<div tabindex="0" data-selector="rerecord-primary-button"\n\t\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t\t class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{rerecord()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'rerecord\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{cancelvisible}}">\n\t\t\t\t<div tabindex="0" data-selector="cancel-primary-button"\n\t\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t\t class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{cancel()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t{{string(\'cancel\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-controlbar-left-section">\n\n\t\t\t<div class="{{css}}-indicator-container" ba-show="{{stopvisible && recordingindication}}">\n\t\t\t\t<div data-selector="recording-indicator" class="{{css}}-recording-indication"></div>\n\t\t\t</div>\n\n\t\t\t<div ba-show="{{settingsvisible}}">\n\n\t\t\t\t<div class="{{css}}-button" ba-show="{{ismobile}}">\n\t\t\t\t\t<div data-selector="face-mode-toggle-icon" class="{{css}}-mobile-camera-switcher {{css}}-button-inner {{css}}-button-unselected"\n\t\t\t\t\t\t onclick="{{toggleFaceMode()}}"\n\t\t\t\t\t\t onmouseenter="{{hover(string(\'switch-camera\'))}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-arrows-cw"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="{{css}}-button">\n\t\t\t\t\t<div tabindex="0" ba-hotkey:space^enter="{{settingsopen=!settingsopen}}"\n\t\t\t\t\t\t data-selector="record-button-icon-cog" class="{{css}}-button-inner {{css}}-button-{{settingsopen ? \'selected\' : \'unselected\' }}"\n\t\t\t\t\t\t onmouseout="this.blur()"\n\t\t\t\t\t\t onclick="{{settingsopen=!settingsopen}}"\n\t\t\t\t\t\t onmouseenter="{{hover(string(\'settings\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}" >\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-cog"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="{{css}}-button" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t\t<div data-selector="record-button-icon-mic" class="{{css}}-button-inner"\n\t\t\t\t\t\t onmouseenter="{{hover(string(microphonehealthy ? \'microphonehealthy\' : \'microphoneunhealthy\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-mic {{csscommon}}-icon-state-{{microphonehealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="{{css}}-button" ba-show="{{!novideo && !allowscreen}}">\n\t\t\t\t\t<div data-selector="record-button-icon-videocam" class="{{css}}-button-inner"\n\t\t\t\t\t\t onmouseenter="{{hover(string(camerahealthy ? \'camerahealthy\' : \'cameraunhealthy\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-videocam {{csscommon}}-icon-state-{{ camerahealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="{{cssrecorder}}-controlbar-right-section">\n\n\t\t\t<div class="{{css}}-rightbutton-container" ba-show="{{recordvisible}}">\n\t\t\t\t<div tabindex="0" data-selector="record-primary-button"\n\t\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t\t class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{record()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t{{string(\'record\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-stop-container" ba-show="{{stopvisible}}">\n\t\t\t<div class="{{css}}-timer-container">\n\t\t\t\t<div class="{{css}}-label-container" ba-show="{{controlbarlabel && !rerecordvisible}}">\n\t\t\t\t\t<div data-selector="record-label-block" class="{{css}}-label {{css}}-button-primary">\n\t\t\t\t\t\t{{controlbarlabel}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-stop-button-container">\n\n\t\t\t\t<div class="{{css}}-button">\n                    <div tabindex="0" ba-show="{{pausable && !resumevisible}}"\n                         ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n                         data-selector="pause-primary-button" class="{{css}}-button"\n                         title="{{string(\'pause-recorder\')}}"\n                         onclick="{{pause()}}"\n                         onmouseenter="{{hover(string(\'pause-recorder\'))}}"\n                         onmouseleave="{{unhover()}}"\n                    >\n                        <i class="{{csscommon}}-icon-pause"></i>\n                    </div>\n\n                    <div tabindex="0" ba-show="{{pausable && resumevisible}}"\n                         ba-hotkey:space^enter="{{resume()}}" onmouseout="this.blur()"\n                         data-selector="resume-primary-button" class="{{css}}-button"\n                         title="{{string(\'resume-recorder\')}}"\n                         onclick="{{resume()}}"\n                         onmouseenter="{{hover(string(\'resume-recorder\'))}}"\n                         onmouseleave="{{unhover()}}"\n                    >\n                        <i class="{{csscommon}}-icon-ccw"></i>\n                    </div>\n\t\t\t\t</div>\n\n\t\t\t\t<div tabindex="0" data-selector="stop-primary-button"\n\t\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t\t class="{{css}}-button-primary {{mintimeindicator ? css + \'-disabled\': \'\'}}"\n\t\t\t\t\t title="{{mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\')}}"\n\t\t\t\t\t onclick="{{stop()}}"\n\t\t\t\t\t onmouseenter="{{hover(mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'stop\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\n        <div class="{{css}}-centerbutton-container" ba-show="{{skipvisible}}">\n            <div tabindex="0" data-selector="skip-primary-button"\n\t\t\t\t ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-button-primary"\n                 onclick="{{skip()}}"\n                 onmouseenter="{{hover(string(\'skip-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                {{string(\'skip\')}}\n            </div>\n        </div>\n\n\n        <div class="{{css}}-rightbutton-container" ba-if="{{uploadcovershotvisible}}">\n            <div data-selector="covershot-primary-button" class="{{css}}-button-primary"\n                 onmouseenter="{{hover(string(\'upload-covershot-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                <input type="file"\n                       class="{{css}}-chooser-file"\n                       style="height:100px"\n                       onchange="{{uploadCovershot(domEvent)}}"\n                       accept="{{covershot_accept_string}}" />\n                <span>\n                    {{string(\'upload-covershot\')}}\n                </span>\n            </div>\n        </div>\n\n\t</div>\n\n</div>\n',
                  tmplimagegallery: '<div ba-if="{{showslidercontainer}}" data-selector="image-gallery" class="{{css}}-image-gallery-container">\n\t<div data-selector="slider-left-button" class="{{css}}-imagegallery-leftbutton">\n\t\t<div tabindex="0" data-selector="slider-left-inner-button"\n\t\t\t ba-hotkey:space^enter^left="{{left()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-button-inner" onclick="{{left()}}"\n\t\t>\n\t\t\t<i class="{{csscommon}}-icon-left-open"></i>\n\t\t</div>\n\t</div>\n\n\t<div data-selector="images-imagegallery-container" ba-repeat="{{image::images}}" class="{{css}}-imagegallery-container" data-gallery-container>\n\t\t<div tabindex="0" data-selector="imagegallery-selected-image"\n\t\t\t ba-hotkey:space^enter="{{select(image)}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-image"\n\t\t\t ba-styles="{{{left: image.left + \'px\', top: image.top + \'px\', width: image.width + \'px\', height: image.height + \'px\'}}}"\n\t\t\t onclick="{{select(image)}}"\n\t\t>\n\t\t</div>\n\t</div>\n\n\t<div data-selector="slider-right-button" class="{{css}}-imagegallery-rightbutton">\n\t\t<div tabindex="0" data-selector="slider-right-inner-button"\n\t\t\t ba-hotkey:space^enter^right="{{right()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-button-inner"\n\t\t\t onclick="{{right()}}"\n\t\t>\n\t\t\t<i class="{{csscommon}}-icon-right-open"></i>\n\t\t</div>\n\t</div>\n</div>\n\n<div ba-if="{{!showslidercontainer}}" class="{{css}}-chooser-container">\n\t<div data-selector="covershot-primary-button" class="{{css}}-chooser-button-container">\n\t\t<div class="{{css}}-chooser-button-0">\n\t\t\t<input type="file"\n\t\t\t\t   tabindex="0"\n\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t   accept="{{covershot_accept_string}}"\n\t\t\t\t   onchange="{{uploadCovershot(domEvent)}}"\n\t\t\t/>\n\t\t\t<i class="{{csscommon}}-icon-picture"></i>\n\t\t\t<span>\n\t\t\t{{string(\'upload-covershot\')}}\n\t\t</span>\n\t\t</div>\n\t</div>\n</div>\n',
                  tmplchooser: '<div class="{{css}}-chooser-container">\n\t<div ba-if="{{initialmessages.length > 0}}" class="{{csscommon}}-message-container">\n\t\t<ul ba-repeat="{{initialmessage :: initialmessages}}">\n\t\t\t<li ba-if="{{initialmessage.message}}"\n\t\t\t\tclass="{{csscommon}}-message-text {{csscommon}}-message-{{initialmessage.type ? initialmessage.type : \'default\'}}"\n\t\t\t>\n\t\t\t\t{{ initialmessage.message }}\n\t\t\t\t<span ba-if="{{initialmessage.id}}"\n\t\t\t\t\t  class="{{csscommon}}-action-button"\n\t\t\t\t\t  ba-click="close_message(initialmessage.id)"\n\t\t\t\t>\n\t\t\t\t\t<i class="{{csscommon}}-icon-cancel"></i>\n\t\t\t\t</span>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\n\t<div class="{{css}}-chooser-button-container">\n\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t\t ba-click="{{click_action(action)}}">\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture="{{action.switchcamera}}" />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t/>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n',
                  tmplmessage: '<div data-selector="recorder-message-container" class="{{cssrecorder}}-message-container" ba-click="{{click()}}">\n    <div class="{{cssrecorder}}-top-inner-message-container {{cssrecorder}}-{{shortMessage ? \'short-message\' : \'long-message\'}}">\n        <div class="{{cssrecorder}}-first-inner-message-container">\n            <div class="{{cssrecorder}}-second-inner-message-container">\n                <div class="{{cssrecorder}}-third-inner-message-container">\n                    <div class="{{cssrecorder}}-fourth-inner-message-container">\n                        <div data-selector="recorder-message-block" class=\'{{cssrecorder}}-message-message\'>\n                            <p>\n                                {{message || ""}}\n                            </p>\n                            <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n                                <li>\n                                    <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                                        {{link.title}}\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n'
                }
              };
            }), Scoped.extend("module:Assets.imageviewerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                css: function (_css39) {
                  function css(_x706) {
                    return _css39.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css39.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "activitydelta > 5000 && hideoninactivity ? (css + '-dashboard-hidden') : ''": function activitydelta5000HideoninactivityCssDashboardHidden(obj) {
                  with (obj) return 5e3 < activitydelta && hideoninactivity ? css + "-dashboard-hidden" : "";
                },
                title: function (_title11) {
                  function title(_x707) {
                    return _title11.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title11.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit11) {
                  function submit(_x708) {
                    return _submit11.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit11.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable11) {
                  function submittable(_x709) {
                    return _submittable11.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable11.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-image')": function stringSubmitImage(obj) {
                  with (obj) return string("submit-image");
                },
                "rerecord()": function (_rerecord15) {
                  function rerecord(_x710) {
                    return _rerecord15.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord15.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable11) {
                  function rerecordable(_x711) {
                    return _rerecordable11.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable11.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-image')": function stringRerecordImage(obj) {
                  with (obj) return string("rerecord-image");
                },
                csscommon: function (_csscommon25) {
                  function csscommon(_x712) {
                    return _csscommon25.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon25.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "toggle_fullscreen()": function (_toggle_fullscreen6) {
                  function toggle_fullscreen(_x713) {
                    return _toggle_fullscreen6.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen6.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                fullscreen: function (_fullscreen6) {
                  function fullscreen(_x714) {
                    return _fullscreen6.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen6.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-image') : string('fullscreen-image')": function fullscreenedStringExitFullscreenImageStringFullscreenImage(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-image") : string("fullscreen-image");
                },
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                "fullscreened ? 'small' : 'full'": function fullscreenedSmallFull(obj) {
                  with (obj) return fullscreened ? "small" : "full";
                }
              }), {
                cube: {
                  css: "ba-imageviewer",
                  csstheme: "ba-imageviewer-cube-theme",
                  tmplcontrolbar: '\n<div data-selector="image-title-block" class="{{css}}-image-title-block {{activitydelta > 5000 && hideoninactivity ? (css + \'-dashboard-hidden\') : \'\'}}" ba-if="{{title}}">\n    <p class="{{css}}-image-title">\n        {{title}}\n    </p>\n</div>\n\n<div class="{{css}}-dashboard {{activitydelta > 5000 && hideoninactivity ? (css + \'-dashboard-hidden\') : \'\'}}">\n\n    <div class="{{css}}-left-block">\n\n        <div tabindex="0" data-selector="submit-image-button"\n             ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n             class="{{css}}-button-container" ba-if="{{submittable}}" ba-click="{{submit()}}"\n        >\n            <div class="{{css}}-button-inner">\n                {{string(\'submit-image\')}}\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-ccw"\n             ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n             class="{{css}}-button-container" ba-if="{{rerecordable}}"\n             ba-click="{{rerecord()}}" title="{{string(\'rerecord-image\')}}"\n        >\n            <div class="{{css}}-button-inner">\n                <i class="{{csscommon}}-icon-ccw"></i>\n            </div>\n        </div>\n\n    </div>\n\n    <div class="{{css}}-right-block">\n        <div tabindex="8" data-selector="button-icon-resize-full"\n             ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n             class="{{css}}-button-container" ba-if={{fullscreen}}\n             ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-image\') : string(\'fullscreen-image\') }}"\n             onkeydown="{{tab_index_move(domEvent)}}"\n        >\n            <div class="{{css}}-button-inner {{css}}-full-screen-btn-inner">\n                <i class="{{csscommon}}-icon-resize-{{fullscreened ? \'small\' : \'full\'}}"></i>\n            </div>\n        </div>\n\n    </div>\n\n</div>\n',
                  cssloader: ie8 ? "ba-imageviewer" : "",
                  cssmessage: "ba-imageviewer"
                }
              };
            }), Scoped.extend("module:Assets.audioplayerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                csstheme: function (_csstheme12) {
                  function csstheme(_x715) {
                    return _csstheme12.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme12.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                title: function (_title12) {
                  function title(_x716) {
                    return _title12.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title12.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit12) {
                  function submit(_x717) {
                    return _submit12.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit12.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable12) {
                  function submittable(_x718) {
                    return _submittable12.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable12.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-audio')": function stringSubmitAudio(obj) {
                  with (obj) return string("submit-audio");
                },
                "rerecord()": function (_rerecord16) {
                  function rerecord(_x719) {
                    return _rerecord16.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord16.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable12) {
                  function rerecordable(_x720) {
                    return _rerecordable12.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable12.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-audio')": function stringRerecordAudio(obj) {
                  with (obj) return string("rerecord-audio");
                },
                csscommon: function (_csscommon26) {
                  function csscommon(_x721) {
                    return _csscommon26.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon26.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "play()": function (_play9) {
                  function play(_x722) {
                    return _play9.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play9.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "!playing": function (_playing13) {
                  function playing(_x723) {
                    return _playing13.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing13.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "string('play-audio')": function stringPlayAudio(obj) {
                  with (obj) return string("play-audio");
                },
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "pause()": function (_pause9) {
                  function pause(_x724) {
                    return _pause9.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause9.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                playing: function (_playing14) {
                  function playing(_x725) {
                    return _playing14.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing14.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "disablepause ? string('pause-audio-disabled') : string('pause-audio')": function disablepauseStringPauseAudioDisabledStringPauseAudio(obj) {
                  with (obj) return disablepause ? string("pause-audio-disabled") : string("pause-audio");
                },
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                "string('elapsed-time')": function stringElapsedTime(obj) {
                  with (obj) return string("elapsed-time");
                },
                "formatTime(position)": function formatTimePosition(obj) {
                  with (obj) return formatTime(position);
                },
                "string('total-time')": function stringTotalTime(obj) {
                  with (obj) return string("total-time");
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                "toggle_volume()": function (_toggle_volume6) {
                  function toggle_volume(_x726) {
                    return _toggle_volume6.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume6.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                },
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "startUpdateVolume(domEvent)": function startUpdateVolumeDomEvent(obj) {
                  with (obj) return startUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent)": function stopUpdateVolumeDomEvent(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "progressUpdateVolume(domEvent)": function progressUpdateVolumeDomEvent(obj) {
                  with (obj) return progressUpdateVolume(domEvent);
                },
                "{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + '%'}": function widthMathCeil1MathMin99MathRoundVolume100(obj) {
                  with (obj) return {
                    width: Math.ceil(1 + Math.min(99, Math.round(100 * volume))) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "seek(position + skipseconds * 3)": function seekPositionSkipseconds3(obj) {
                  with (obj) return seek(position + 3 * skipseconds);
                },
                "seek(position - skipseconds * 3)": function seekPositionSkipseconds3(obj) {
                  with (obj) return seek(position - 3 * skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "stopUpdatePosition(domEvent)": function stopUpdatePositionDomEvent(obj) {
                  with (obj) return stopUpdatePosition(domEvent);
                },
                "progressUpdatePosition(domEvent)": function progressUpdatePositionDomEvent(obj) {
                  with (obj) return progressUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('audio-progress')": function stringAudioProgress(obj) {
                  with (obj) return string("audio-progress");
                }
              }), {
                cube: {
                  css: "ba-audioplayer",
                  csstheme: "ba-player-cube-theme",
                  tmplcontrolbar: '\n<div data-selector="audio-title-block" class="{{csstheme}}-title-block " ba-if="{{title}}">\n    <p class="{{csstheme}}-title">\n        {{title}}\n    </p>\n</div>\n\n<div class="{{csstheme}}-dashboard ">\n\n    <div class="{{csstheme}}-left-block">\n\n        <div tabindex="0" data-selector="submit-audio-button"\n             ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container" ba-if="{{submittable}}" ba-click="{{submit()}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                {{string(\'submit-audio\')}}\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-ccw"\n             ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container" ba-if="{{rerecordable}}"\n             ba-click="{{rerecord()}}" title="{{string(\'rerecord-audio\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-ccw"></i>\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-play"\n             ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container"\n             ba-if="{{!playing}}" ba-click="{{play()}}" title="{{string(\'play-audio\')}}"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-play"></i>\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-pause"\n             ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n             ba-if="{{playing}}" ba-click="{{pause()}}" title="{{disablepause ? string(\'pause-audio-disabled\') : string(\'pause-audio\')}}"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-pause"></i>\n            </div>\n        </div>\n    </div>\n\n    <div class="{{csstheme}}-right-block">\n        <div class="{{csstheme}}-button-container {{csstheme}}-timer-container">\n            <div class="{{csstheme}}-time-container">\n                <div class="{{csstheme}}-time-value" title="{{string(\'elapsed-time\')}}">{{formatTime(position)}}</div>\n            </div>\n            <p> / </p>\n            <div class="{{csstheme}}-time-container">\n                <div class="{{csstheme}}-time-value" title="{{string(\'total-time\')}}">{{formatTime(duration || position)}}</div>\n            </div>\n        </div>\n\n        <div tabindex="3" data-selector="button-icon-volume"\n             ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container"\n             ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}">\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n            </div>\n        </div>\n\n        <div class="{{csstheme}}-volumebar">\n            <div tabindex="4" data-selector="button-volume-bar"\n                 ba-hotkey:right="{{set_volume(volume + 0.1)}}"\n                 ba-hotkey:left="{{set_volume(volume - 0.1)}}"\n                 onmouseout="this.blur()"\n                 class="{{csstheme}}-volumebar-inner"\n                 onmousedown="{{startUpdateVolume(domEvent)}}"\n                 onmouseup="{{stopUpdateVolume(domEvent)}}"\n                 onmouseleave="{{stopUpdateVolume(domEvent)}}"\n                 onmousemove="{{progressUpdateVolume(domEvent)}}">\n                <div class="{{csstheme}}-volumebar-position" ba-styles="{{{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + \'%\'}}}" title="{{string(\'volume-button\')}}"></div>\n            </div>\n        </div>\n\n    </div>\n\n    <div class="{{csstheme}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}">\n        <div tabindex="2" data-selector="progress-bar-inner"\n             ba-hotkey:right="{{seek(position + skipseconds)}}"\n             ba-hotkey:left="{{seek(position - skipseconds)}}"\n             ba-hotkey:alt+right="{{seek(position + skipseconds * 3)}}"\n             ba-hotkey:alt+left="{{seek(position - skipseconds * 3)}}"\n             onmouseout="this.blur()"\n             class="{{csstheme}}-progressbar-inner"\n             onmousedown="{{startUpdatePosition(domEvent)}}"\n             onmouseup="{{stopUpdatePosition(domEvent)}}"\n             onmouseleave="{{stopUpdatePosition(domEvent)}}"\n             onmousemove="{{progressUpdatePosition(domEvent)}}">\n\n            <div class="{{csstheme}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n            <div class="{{csstheme}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'audio-progress\')}}"></div>\n        </div>\n    </div>\n\n</div>\n',
                  cssloader: ie8 ? "ba-audioplayer" : "",
                  cssmessage: "ba-audioplayer",
                  cssplaybutton: ie8 ? "ba-audioplayer" : ""
                }
              };
            }), Scoped.extend("module:Assets.audiorecorderthemes", ["dynamics:Parser"], function (Parser) {
              return Parser.registerFunctions({
                csstheme: function (_csstheme13) {
                  function csstheme(_x727) {
                    return _csstheme13.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme13.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                css: function (_css40) {
                  function css(_x728) {
                    return _css40.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css40.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "settingsvisible && settingsopen": function settingsvisibleSettingsopen(obj) {
                  with (obj) return settingsvisible && settingsopen;
                },
                cameras: function (_cameras6) {
                  function cameras(_x729) {
                    return _cameras6.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras6.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "selectCamera(camera.id)": function selectCameraCameraId(obj) {
                  with (obj) return selectCamera(camera.id);
                },
                "selectedcamera == camera.id": function selectedcameraCameraId(obj) {
                  with (obj) return selectedcamera == camera.id;
                },
                "camera.label": function cameraLabel(obj) {
                  with (obj) return camera.label;
                },
                microphones: function (_microphones6) {
                  function microphones(_x730) {
                    return _microphones6.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones6.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                audio: function (_audio) {
                  function audio(_x731) {
                    return _audio.apply(this, arguments);
                  }
                  audio.toString = function () {
                    return _audio.toString();
                  };
                  return audio;
                }(function (obj) {
                  with (obj) return audio;
                }),
                "selectMicrophone(microphone.id)": function selectMicrophoneMicrophoneId(obj) {
                  with (obj) return selectMicrophone(microphone.id);
                },
                "selectedmicrophone == microphone.id": function selectedmicrophoneMicrophoneId(obj) {
                  with (obj) return selectedmicrophone == microphone.id;
                },
                "microphone.label": function microphoneLabel(obj) {
                  with (obj) return microphone.label;
                },
                rerecordvisible: function (_rerecordvisible8) {
                  function rerecordvisible(_x732) {
                    return _rerecordvisible8.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible8.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord17) {
                  function rerecord(_x733) {
                    return _rerecord17.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord17.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "unhover()": function (_unhover5) {
                  function unhover(_x734) {
                    return _unhover5.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover5.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible5) {
                  function cancelvisible(_x735) {
                    return _cancelvisible5.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible5.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel5) {
                  function cancel(_x736) {
                    return _cancel5.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel5.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                },
                settingsvisible: function (_settingsvisible8) {
                  function settingsvisible(_x737) {
                    return _settingsvisible8.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible8.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                csscommon: function (_csscommon27) {
                  function csscommon(_x738) {
                    return _csscommon27.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon27.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "!noaudio && !allowscreen": function noaudioAllowscreen(obj) {
                  with (obj) return !noaudio && !allowscreen;
                },
                "hover(string(microphonehealthy ? 'microphonehealthy' : 'microphoneunhealthy'))": function hoverStringMicrophonehealthyMicrophonehealthyMicrophoneunhealthy(obj) {
                  with (obj) return hover(string(microphonehealthy ? "microphonehealthy" : "microphoneunhealthy"));
                },
                "microphonehealthy ? 'good' : 'bad'": function microphonehealthyGoodBad(obj) {
                  with (obj) return microphonehealthy ? "good" : "bad";
                },
                "hover(string(camerahealthy ? 'camerahealthy' : 'cameraunhealthy'))": function hoverStringCamerahealthyCamerahealthyCameraunhealthy(obj) {
                  with (obj) return hover(string(camerahealthy ? "camerahealthy" : "cameraunhealthy"));
                },
                "camerahealthy ? 'good' : 'bad'": function camerahealthyGoodBad(obj) {
                  with (obj) return camerahealthy ? "good" : "bad";
                },
                recordvisible: function (_recordvisible8) {
                  function recordvisible(_x739) {
                    return _recordvisible8.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible8.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record5) {
                  function record(_x740) {
                    return _record5.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record5.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                stopvisible: function (_stopvisible6) {
                  function stopvisible(_x741) {
                    return _stopvisible6.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible6.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                "controlbarlabel && !rerecordvisible": function controlbarlabelRerecordvisible(obj) {
                  with (obj) return controlbarlabel && !rerecordvisible;
                },
                controlbarlabel: function (_controlbarlabel8) {
                  function controlbarlabel(_x742) {
                    return _controlbarlabel8.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel8.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                "stop()": function (_stop4) {
                  function stop(_x743) {
                    return _stop4.apply(this, arguments);
                  }
                  stop.toString = function () {
                    return _stop4.toString();
                  };
                  return stop;
                }(function (obj) {
                  with (obj) return stop();
                }),
                "mintimeindicator ? css + '-disabled': ''": function mintimeindicatorCssDisabled(obj) {
                  with (obj) return mintimeindicator ? css + "-disabled" : "";
                },
                "mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip')": function mintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip");
                },
                "hover(mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip'))": function hoverMintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return hover(mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip"));
                },
                "string('stop')": function stringStop(obj) {
                  with (obj) return string("stop");
                },
                skipvisible: function (_skipvisible4) {
                  function skipvisible(_x744) {
                    return _skipvisible4.apply(this, arguments);
                  }
                  skipvisible.toString = function () {
                    return _skipvisible4.toString();
                  };
                  return skipvisible;
                }(function (obj) {
                  with (obj) return skipvisible;
                }),
                "skip()": function (_skip7) {
                  function skip(_x745) {
                    return _skip7.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip7.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "hover(string('skip-tooltip'))": function hoverStringSkipTooltip(obj) {
                  with (obj) return hover(string("skip-tooltip"));
                },
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                },
                uploadcovershotvisible: function (_uploadcovershotvisible4) {
                  function uploadcovershotvisible(_x746) {
                    return _uploadcovershotvisible4.apply(this, arguments);
                  }
                  uploadcovershotvisible.toString = function () {
                    return _uploadcovershotvisible4.toString();
                  };
                  return uploadcovershotvisible;
                }(function (obj) {
                  with (obj) return uploadcovershotvisible;
                }),
                "hover(string('upload-covershot-tooltip'))": function hoverStringUploadCovershotTooltip(obj) {
                  with (obj) return hover(string("upload-covershot-tooltip"));
                },
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                covershot_accept_string: function (_covershot_accept_string5) {
                  function covershot_accept_string(_x747) {
                    return _covershot_accept_string5.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string5.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                css: function (_css41) {
                  function css(_x748) {
                    return _css41.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css41.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                actions: function (_actions7) {
                  function actions(_x749) {
                    return _actions7.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions7.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                },
                csscommon: function (_csscommon28) {
                  function csscommon(_x750) {
                    return _csscommon28.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon28.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                }
              }), Parser.registerFunctions({
                css: function (_css42) {
                  function css(_x751) {
                    return _css42.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css42.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click8) {
                  function click(_x752) {
                    return _click8.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click8.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                "shortMessage ? 'short-message' : 'long-message'": function shortMessageShortMessageLongMessage(obj) {
                  with (obj) return shortMessage ? "short-message" : "long-message";
                },
                'message || ""': function (_message14) {
                  function message(_x753) {
                    return _message14.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message14.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links5) {
                  function links(_x754) {
                    return _links5.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links5.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }), {
                cube: {
                  css: "ba-audiorecorder",
                  csstheme: "ba-audiorecorder-theme-cube",
                  cssmessage: "ba-audiorecorder-message-theme-cube",
                  cssrecorder: "ba-recorder",
                  tmplcontrolbar: '<div class="{{csstheme}}-dashboard">\n\n\t<div class="{{css}}-settings-front">\n\n\t\t\n\t\t<div data-selector="recorder-settings" class="{{css}}-settings" ba-show="{{settingsvisible && settingsopen}}">\n\t\t\t<div data-selector="settings-list-front" class="{{css}}-bubble-info">\n\t\t\t\t<ul data-selector="camera-settings" ba-repeat="{{camera :: cameras}}">\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<input tabindex="0"\n\t\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n                               type=\'radio\'\n\t\t\t\t\t\t\t   name=\'camera\' value="{{selectedcamera == camera.id}}" onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t/>\n\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t<label tabindex="0" ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t{{camera.label}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<ul data-selector="microphone-settings" ba-repeat="{{microphone :: microphones}}" ba-show="{{audio}}">\n\t\t\t\t\t<li tabindex="0"\n\t\t\t\t\t\tba-hotkey:space^enter="{{selectMicrophone(microphone.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\tonclick="{{selectMicrophone(microphone.id)}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<input type=\'radio\' name=\'microphone\' value="{{selectedmicrophone == microphone.id}}" />\n\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t{{microphone.label}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n\t\t<div class="{{css}}-controlbar-center-section">\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{rerecordvisible}}">\n\t\t\t\t<div tabindex="0" data-selector="rerecord-primary-button"\n\t\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t\t class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{rerecord()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'rerecord\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{cancelvisible}}">\n\t\t\t\t<div tabindex="0" data-selector="cancel-primary-button"\n\t\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t\t class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{cancel()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t{{string(\'cancel\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-controlbar-left-section" ba-show="{{settingsvisible}}">\n\n            <div class="{{css}}-button" ba-show="{{settingsvisible}}">\n\n\t\t\t\t<div tabindex="0" ba-hotkey:space^enter="{{settingsopen=!settingsopen}}"\n\t\t\t\t\t data-selector="record-button-icon-cog" class="{{css}}-button-inner {{css}}-button-{{settingsopen ? \'selected\' : \'unselected\' }}"\n\t\t\t\t\t onclick="{{settingsopen=!settingsopen}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'settings\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}" >\n\t\t\t\t\t<i class="{{csscommon}}-icon-cog"></i>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-button" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t<div data-selector="record-button-icon-mic" class="{{css}}-button-inner"\n\t\t\t\t\tonmouseenter="{{hover(string(microphonehealthy ? \'microphonehealthy\' : \'microphoneunhealthy\'))}}"\n\t\t\t\t\tonmouseleave="{{unhover()}}">\n\t\t\t\t\t<i class="{{csscommon}}-icon-mic {{csscommon}}-icon-state-{{microphonehealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-button" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t<div data-selector="record-button-icon-audiocam" class="{{css}}-button-inner"\n\t\t\t\t\tonmouseenter="{{hover(string(camerahealthy ? \'camerahealthy\' : \'cameraunhealthy\'))}}"\n\t\t\t\t\tonmouseleave="{{unhover()}}">\n                    <i class="{{csscommon}}-icon-audiocam {{csscommon}}-icon-state-{{ camerahealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="{{css}}-controlbar-right-section">\n\n\t\t\t<div class="{{css}}-rightbutton-container" ba-show="{{recordvisible}}">\n\t\t\t\t<div tabindex="0" data-selector="record-primary-button"\n\t\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t\t class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{record()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t{{string(\'record\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-stop-container" ba-show="{{stopvisible}}">\n\t\t\t<div class="{{css}}-timer-container">\n\t\t\t\t<div class="{{css}}-label-container" ba-show="{{controlbarlabel && !rerecordvisible}}">\n\t\t\t\t\t<div data-selector="record-label-block" class="{{css}}-label {{css}}-button-primary">\n\t\t\t\t\t\t{{controlbarlabel}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-stop-button-container">\n\t\t\t\t<div tabindex="0" data-selector="stop-primary-button"\n\t\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="stop-primary-button" class="{{css}}-button-primary {{mintimeindicator ? css + \'-disabled\': \'\'}}"\n\t\t\t\t\t title="{{mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\')}}"\n\t\t\t\t\t onclick="{{stop()}}"\n\t\t\t\t\t onmouseenter="{{hover(mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t{{string(\'stop\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-centerbutton-container" ba-show="{{skipvisible}}">\n            <div tabindex="0" data-selector="skip-primary-button"\n\t\t\t\t ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-button-primary"\n                 onclick="{{skip()}}"\n                 onmouseenter="{{hover(string(\'skip-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                {{string(\'skip\')}}\n            </div>\n        </div>\n\n\n        <div class="{{css}}-rightbutton-container" ba-if="{{uploadcovershotvisible}}">\n            <div data-selector="covershot-primary-button" class="{{css}}-button-primary"\n                 onmouseenter="{{hover(string(\'upload-covershot-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                <input type="file"\n                       class="{{css}}-chooser-file"\n                       style="height:100px"\n                       onchange="{{uploadCovershot(domEvent)}}"\n                       accept="{{covershot_accept_string}}" />\n                <span>\n                    {{string(\'upload-covershot\')}}\n                </span>\n            </div>\n        </div>\n\n\t</div>\n\n</div>\n',
                  tmplchooser: '<div class="{{css}}-chooser-container">\n\n\t<div class="{{css}}-chooser-button-container">\n\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t\t ba-click="{{click_action(action)}}">\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t/>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>',
                  tmplmessage: '<div data-selector="recorder-message-container" class="{{css}}-message-container" ba-click="{{click()}}">\n    <div class="{{css}}-top-inner-message-container {{css}}-{{shortMessage ? \'short-message\' : \'long-message\'}}">\n        <div class="{{css}}-first-inner-message-container">\n            <div class="{{css}}-second-inner-message-container">\n                <div class="{{css}}-third-inner-message-container">\n                    <div class="{{css}}-fourth-inner-message-container">\n                        <div data-selector="recorder-message-block" class=\'{{css}}-message-message\'>\n                            <p>\n                                {{message || ""}}\n                            </p>\n                            <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n                                <li>\n                                    <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                                        {{link.title}}\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n'
                }
              };
            });
          }.call(Scoped), function () {
            var Scoped = this.subScope();
            Scoped.binding("browser", "root:BetaJS.Browser"), Scoped.binding("dynamics", "root:BetaJS.Dynamics"), Scoped.binding("module", "root:BetaJS.MediaComponents"), Scoped.extend("module:Assets.playerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                csstheme: function (_csstheme14) {
                  function csstheme(_x755) {
                    return _csstheme14.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme14.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                "activitydelta > hidebarafter && hideoninactivity ? (cssplayer + '-dashboard-hidden') : ''": function activitydeltaHidebarafterHideoninactivityCssplayerDashboardHidden(obj) {
                  with (obj) return activitydelta > hidebarafter && hideoninactivity ? cssplayer + "-dashboard-hidden" : "";
                },
                title: function (_title13) {
                  function title(_x756) {
                    return _title13.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title13.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "!hidevolumebar": function (_hidevolumebar5) {
                  function hidevolumebar(_x757) {
                    return _hidevolumebar5.apply(this, arguments);
                  }
                  hidevolumebar.toString = function () {
                    return _hidevolumebar5.toString();
                  };
                  return hidevolumebar;
                }(function (obj) {
                  with (obj) return !hidevolumebar;
                }),
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "startUpdateVolume(domEvent)": function startUpdateVolumeDomEvent(obj) {
                  with (obj) return startUpdateVolume(domEvent);
                },
                "progressUpdateVolume(domEvent)": function progressUpdateVolumeDomEvent(obj) {
                  with (obj) return progressUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent); this.blur()": function stopUpdateVolumeDomEventThisBlur(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent)": function stopUpdateVolumeDomEvent(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + '%'}": function widthMathCeil1MathMin99MathRoundVolume100(obj) {
                  with (obj) return {
                    width: Math.ceil(1 + Math.min(99, Math.round(100 * volume))) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                "skipinitial ? 0 : 1": function skipinitial01(obj) {
                  with (obj) return skipinitial ? 0 : 1;
                },
                "toggle_volume()": function (_toggle_volume7) {
                  function toggle_volume(_x758) {
                    return _toggle_volume7.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume7.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                },
                "submit()": function (_submit13) {
                  function submit(_x759) {
                    return _submit13.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit13.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable13) {
                  function submittable(_x760) {
                    return _submittable13.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable13.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecord()": function (_rerecord18) {
                  function rerecord(_x761) {
                    return _rerecord18.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord18.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable13) {
                  function rerecordable(_x762) {
                    return _rerecordable13.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable13.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-video')": function stringRerecordVideo(obj) {
                  with (obj) return string("rerecord-video");
                },
                csscommon: function (_csscommon29) {
                  function csscommon(_x763) {
                    return _csscommon29.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon29.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "skipinitial ? 0 : 3": function skipinitial03(obj) {
                  with (obj) return skipinitial ? 0 : 3;
                },
                "play()": function (_play10) {
                  function play(_x764) {
                    return _play10.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play10.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "!playing": function (_playing15) {
                  function playing(_x765) {
                    return _playing15.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing15.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "string('play-video')": function stringPlayVideo(obj) {
                  with (obj) return string("play-video");
                },
                "pause()": function (_pause10) {
                  function pause(_x766) {
                    return _pause10.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause10.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                playing: function (_playing16) {
                  function playing(_x767) {
                    return _playing16.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing16.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "disablepause ? string('pause-video-disabled') : string('pause-video')": function disablepauseStringPauseVideoDisabledStringPauseVideo(obj) {
                  with (obj) return disablepause ? string("pause-video-disabled") : string("pause-video");
                },
                "toggle_position_info()": function (_toggle_position_info4) {
                  function toggle_position_info(_x768) {
                    return _toggle_position_info4.apply(this, arguments);
                  }
                  toggle_position_info.toString = function () {
                    return _toggle_position_info4.toString();
                  };
                  return toggle_position_info;
                }(function (obj) {
                  with (obj) return toggle_position_info();
                }),
                "revertposition ? string('remaining-time') : string('elapsed-time')": function revertpositionStringRemainingTimeStringElapsedTime(obj) {
                  with (obj) return revertposition ? string("remaining-time") : string("elapsed-time");
                },
                '(revertposition && duration > 0) ? "-" : ""': function revertpositionDuration0(obj) {
                  with (obj) return revertposition && 0 < duration ? "-" : "";
                },
                "(revertposition && duration > 0) ? formatTime(duration - position) : formatTime(position)": function revertpositionDuration0FormatTimeDurationPositionFormatTimePosition(obj) {
                  with (obj) return revertposition && 0 < duration ? formatTime(duration - position) : formatTime(position);
                },
                "toggle_settings_menu()": function (_toggle_settings_menu4) {
                  function toggle_settings_menu(_x769) {
                    return _toggle_settings_menu4.apply(this, arguments);
                  }
                  toggle_settings_menu.toString = function () {
                    return _toggle_settings_menu4.toString();
                  };
                  return toggle_settings_menu;
                }(function (obj) {
                  with (obj) return toggle_settings_menu();
                }),
                cssplayer: function (_cssplayer13) {
                  function cssplayer(_x770) {
                    return _cssplayer13.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer13.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "settingsmenuactive ? 'active' : 'inactive'": function settingsmenuactiveActiveInactive(obj) {
                  with (obj) return settingsmenuactive ? "active" : "inactive";
                },
                settingsmenubutton: function (_settingsmenubutton4) {
                  function settingsmenubutton(_x771) {
                    return _settingsmenubutton4.apply(this, arguments);
                  }
                  settingsmenubutton.toString = function () {
                    return _settingsmenubutton4.toString();
                  };
                  return settingsmenubutton;
                }(function (obj) {
                  with (obj) return settingsmenubutton;
                }),
                "string('settings')": function stringSettings(obj) {
                  with (obj) return string("settings");
                },
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                "toggle_tracks()": function (_toggle_tracks4) {
                  function toggle_tracks(_x772) {
                    return _toggle_tracks4.apply(this, arguments);
                  }
                  toggle_tracks.toString = function () {
                    return _toggle_tracks4.toString();
                  };
                  return toggle_tracks;
                }(function (obj) {
                  with (obj) return toggle_tracks();
                }),
                "(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload": function tracktagsLength0ShowsubtitlebuttonAllowtexttrackupload(obj) {
                  with (obj) return 0 < tracktags.length && showsubtitlebutton || allowtexttrackupload;
                },
                "tracktextvisible ? 'active' : 'inactive'": function tracktextvisibleActiveInactive(obj) {
                  with (obj) return tracktextvisible ? "active" : "inactive";
                },
                "tracktextvisible ? string('close-tracks') : string('show-tracks')": function tracktextvisibleStringCloseTracksStringShowTracks(obj) {
                  with (obj) return tracktextvisible ? string("close-tracks") : string("show-tracks");
                },
                "hover_cc(true)": function hover_ccTrue(obj) {
                  with (obj) return hover_cc(!0);
                },
                "hover_cc(false)": function hover_ccFalse(obj) {
                  with (obj) return hover_cc(!1);
                },
                "toggle_fullscreen()": function (_toggle_fullscreen7) {
                  function toggle_fullscreen(_x773) {
                    return _toggle_fullscreen7.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen7.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                fullscreen: function (_fullscreen7) {
                  function fullscreen(_x774) {
                    return _fullscreen7.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen7.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-video') : string('fullscreen-video')": function fullscreenedStringExitFullscreenVideoStringFullscreenVideo(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-video") : string("fullscreen-video");
                },
                "fullscreened ? 'resize-minimize' : 'resize-full'": function fullscreenedResizeMinimizeResizeFull(obj) {
                  with (obj) return fullscreened ? "resize-minimize" : "resize-full";
                },
                trimmingmode: function (_trimmingmode8) {
                  function trimmingmode(_x775) {
                    return _trimmingmode8.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode8.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "trim()": function (_trim5) {
                  function trim(_x776) {
                    return _trim5.apply(this, arguments);
                  }
                  trim.toString = function () {
                    return _trim5.toString();
                  };
                  return trim;
                }(function (obj) {
                  with (obj) return trim();
                }),
                "string('trim-video')": function stringTrimVideo(obj) {
                  with (obj) return string("trim-video");
                },
                frameselectionmode: function (_frameselectionmode6) {
                  function frameselectionmode(_x777) {
                    return _frameselectionmode6.apply(this, arguments);
                  }
                  frameselectionmode.toString = function () {
                    return _frameselectionmode6.toString();
                  };
                  return frameselectionmode;
                }(function (obj) {
                  with (obj) return frameselectionmode;
                }),
                "select_frame()": function (_select_frame4) {
                  function select_frame(_x778) {
                    return _select_frame4.apply(this, arguments);
                  }
                  select_frame.toString = function () {
                    return _select_frame4.toString();
                  };
                  return select_frame;
                }(function (obj) {
                  with (obj) return select_frame();
                }),
                "string('select-frame')": function stringSelectFrame(obj) {
                  with (obj) return string("select-frame");
                },
                "show_airplay_devices()": function (_show_airplay_devices4) {
                  function show_airplay_devices(_x779) {
                    return _show_airplay_devices4.apply(this, arguments);
                  }
                  show_airplay_devices.toString = function () {
                    return _show_airplay_devices4.toString();
                  };
                  return show_airplay_devices;
                }(function (obj) {
                  with (obj) return show_airplay_devices();
                }),
                airplaybuttonvisible: function (_airplaybuttonvisible5) {
                  function airplaybuttonvisible(_x780) {
                    return _airplaybuttonvisible5.apply(this, arguments);
                  }
                  airplaybuttonvisible.toString = function () {
                    return _airplaybuttonvisible5.toString();
                  };
                  return airplaybuttonvisible;
                }(function (obj) {
                  with (obj) return airplaybuttonvisible;
                }),
                castbuttonvisble: function (_castbuttonvisble5) {
                  function castbuttonvisble(_x781) {
                    return _castbuttonvisble5.apply(this, arguments);
                  }
                  castbuttonvisble.toString = function () {
                    return _castbuttonvisble5.toString();
                  };
                  return castbuttonvisble;
                }(function (obj) {
                  with (obj) return castbuttonvisble;
                }),
                "toggle_stream()": function (_toggle_stream4) {
                  function toggle_stream(_x782) {
                    return _toggle_stream4.apply(this, arguments);
                  }
                  toggle_stream.toString = function () {
                    return _toggle_stream4.toString();
                  };
                  return toggle_stream;
                }(function (obj) {
                  with (obj) return toggle_stream();
                }),
                "streams.length > 1 && currentstream": function streamsLength1Currentstream(obj) {
                  with (obj) return 1 < streams.length && currentstream;
                },
                "string('change-resolution')": function stringChangeResolution(obj) {
                  with (obj) return string("change-resolution");
                },
                currentstream_label: function (_currentstream_label4) {
                  function currentstream_label(_x783) {
                    return _currentstream_label4.apply(this, arguments);
                  }
                  currentstream_label.toString = function () {
                    return _currentstream_label4.toString();
                  };
                  return currentstream_label;
                }(function (obj) {
                  with (obj) return currentstream_label;
                }),
                "string('total-time')": function stringTotalTime(obj) {
                  with (obj) return string("total-time");
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('video-progress')": function stringVideoProgress(obj) {
                  with (obj) return string("video-progress");
                },
                "{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + '%'}": function leftMathRoundDurationTrimstartTrimstartDuration1000(obj) {
                  with (obj) return {
                    left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + "%"
                  };
                },
                "{left: 'auto', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + '%'}": function leftAutoRight100MathRoundDurationTrimendTrimendDuration100100(obj) {
                  with (obj) return {
                    left: "auto",
                    right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + "%"
                  };
                }
              }), Parser.registerFunctions({
                csstheme: function (_csstheme15) {
                  function csstheme(_x784) {
                    return _csstheme15.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme15.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                "click()": function (_click9) {
                  function click(_x785) {
                    return _click9.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click9.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                'message || ""': function (_message15) {
                  function message(_x786) {
                    return _message15.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message15.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                })
              }), Parser.registerFunctions({
                "play()": function (_play11) {
                  function play(_x787) {
                    return _play11.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play11.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'player-toggle-overlay')": function tab_index_moveDomEventNullPlayerToggleOverlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "player-toggle-overlay");
                },
                cssplayer: function (_cssplayer14) {
                  function cssplayer(_x788) {
                    return _cssplayer14.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer14.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "string('tooltip')": function stringTooltip(obj) {
                  with (obj) return string("tooltip");
                },
                "showduration && (duration != 0 && duration != undefined)": function showdurationDuration0DurationUndefined(obj) {
                  with (obj) return showduration && 0 != duration && duration != undefined;
                },
                css: function (_css43) {
                  function css(_x789) {
                    return _css43.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css43.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "formatTime(duration)": function formatTimeDuration(obj) {
                  with (obj) return formatTime(duration);
                },
                "rerecordable || submittable": function rerecordableSubmittable(obj) {
                  with (obj) return rerecordable || submittable;
                },
                "submittable && !trimmingmode": function submittableTrimmingmode(obj) {
                  with (obj) return submittable && !trimmingmode;
                },
                "submit()": function (_submit14) {
                  function submit(_x790) {
                    return _submit14.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit14.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecordable && !trimmingmode": function rerecordableTrimmingmode(obj) {
                  with (obj) return rerecordable && !trimmingmode;
                },
                "rerecord()": function (_rerecord19) {
                  function rerecord(_x791) {
                    return _rerecord19.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord19.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                trimmingmode: function (_trimmingmode9) {
                  function trimmingmode(_x792) {
                    return _trimmingmode9.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode9.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "string('trim')": function stringTrim(obj) {
                  with (obj) return string("trim");
                },
                "skip()": function (_skip8) {
                  function skip(_x793) {
                    return _skip8.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip8.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                }
              }), {
                space: {
                  css: "ba-videoplayer",
                  csstheme: "ba-player-space-theme",
                  cssplayer: "ba-player",
                  tmplcontrolbar: '<div class="{{csstheme}}-title-container {{activitydelta > hidebarafter && hideoninactivity ? (cssplayer + \'-dashboard-hidden\') : \'\'}}">\n    <div class="{{csstheme}}-title" ba-if="{{title}}">\n        <p>{{title}}</p>\n    </div>\n\n    <div class="{{csstheme}}-volumebar" ba-show="{{!hidevolumebar}}">\n        <div tabindex="2" data-selector="button-volume-bar"\n             ba-hotkey:right="{{set_volume(volume + 0.1)}}"\n             ba-hotkey:left="{{set_volume(volume - 0.1)}}"\n             onmouseout="this.blur()"\n             class="{{csstheme}}-volumebar-inner"\n             ontouchstart="{{startUpdateVolume(domEvent)}}"\n             ontouchmove="{{progressUpdateVolume(domEvent)}}"\n             ontouchend="{{stopUpdateVolume(domEvent); this.blur()}};"\n             onmousedown="{{startUpdateVolume(domEvent)}}"\n             onmouseup="{{stopUpdateVolume(domEvent)}}"\n             onmouseleave="{{stopUpdateVolume(domEvent)}}"\n             onmousemove="{{progressUpdateVolume(domEvent)}}"\n        >\n            <div class="{{csstheme}}-volumebar-position" ba-styles="{{{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + \'%\'}}}" title="{{string(\'volume-button\')}}"></div>\n        </div>\n    </div>\n\n    <div tabindex="{{skipinitial ? 0 : 1}}" data-selector="button-icon-volume"\n         ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n         class="{{csstheme}}-rightbutton-container"\n         ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}"\n    >\n        <div class="{{csstheme}}-button-inner">\n            <i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n        </div>\n    </div>\n</div>\n\n<div class="{{csstheme}}-dashboard {{activitydelta > hidebarafter && hideoninactivity ? (cssplayer + \'-dashboard-hidden\') : \'\'}}">\n\n    <div class="{{csstheme}}-controlbar-footer">\n        <div tabindex="0" data-selector="submit-video-button"\n             ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-leftbutton-container" ba-if="{{submittable}}"  ba-click="{{submit()}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                {{string(\'submit-video\')}}\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-ccw"\n             ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-leftbutton-container" ba-if="{{rerecordable}}"\n             ba-click="{{rerecord()}}" title="{{string(\'rerecord-video\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-ccw"></i>\n            </div>\n        </div>\n\n        <div tabindex="{{skipinitial ? 0 : 3}}" data-selector="button-icon-play"\n             ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}"\n             class="{{csstheme}}-leftbutton-container" ba-if="{{!playing}}" ba-click="{{play()}}" title="{{string(\'play-video\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-play"></i>\n            </div>\n        </div>\n\n        <div tabindex="{{skipinitial ? 0 : 3}}" data-selector="button-icon-pause"\n             ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}"\n             class="{{csstheme}}-leftbutton-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n             ba-if="{{playing}}" ba-click="{{pause()}}" title="{{disablepause ? string(\'pause-video-disabled\') : string(\'pause-video\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-pause"></i>\n            </div>\n        </div>\n\n        <div class="{{csstheme}}-time-container {{csscommon}}-clickable" ba-click="{{toggle_position_info()}}">\n            <div class="{{csstheme}}-time-value"\n                 title="{{revertposition ? string(\'remaining-time\') : string(\'elapsed-time\')}}"\n            >\n                {{(revertposition && duration > 0) ? "-" : ""}}\n                {{(revertposition && duration > 0) ? formatTime(duration - position) : formatTime(position)}}\n            </div>\n        </div>\n\n        <div tabindex="11" data-selector="button-icon-settings"\n             ba-hotkey:space^enter="{{toggle_settings_menu()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-rightbutton-container {{csstheme}}-settings-button-container {{cssplayer}}-button-{{settingsmenuactive ? \'active\' : \'inactive\'}}"\n             ba-if="{{settingsmenubutton}}" ba-click="{{toggle_settings_menu()}}"\n             title="{{string(\'settings\')}}"\n             onkeydown="{{tab_index_move(domEvent)}}"\n        >\n            <div class="{{csstheme}}-button-inner {{csstheme}}-settings-button">\n                <i class="{{csscommon}}-icon-cog"></i>\n            </div>\n        </div>\n\n        <div tabindex="10" data-selector="cc-button-container"\n             ba-hotkey:space^enter="{{toggle_tracks()}}" onmouseout="this.blur()"\n             ba-if="{{(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload}}"\n             class="{{csstheme}}-rightbutton-container {{csstheme}}-cc-button-container {{cssplayer}}-button-{{tracktextvisible ? \'active\' : \'inactive\'}}"\n             title="{{tracktextvisible ? string(\'close-tracks\') : string(\'show-tracks\')}}"\n             ba-click="{{toggle_tracks()}}"\n             onmouseover="{{hover_cc(true)}}"\n             onmouseleave="{{hover_cc(false)}}"\n        >\n            <div class="{{csstheme}}-button-inner {{csstheme}}-subtitle-button-inner">\n                <i class="{{csscommon}}-icon-subtitle"></i>\n            </div>\n        </div>\n\n        <div tabindex="9" data-selector="button-icon-resize-full"\n             ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n             onkeydown="{{tab_index_move(domEvent)}}"\n             class="{{csstheme}}-rightbutton-container"\n             ba-if="{{fullscreen}}" ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-video\') : string(\'fullscreen-video\') }}"\n        >\n            <div class="{{csstheme}}-button-inner {{csstheme}}-full-screen-btn-inner">\n                <i class="{{csscommon}}-icon-{{fullscreened ? \'resize-minimize\' : \'resize-full\'}}"></i>\n            </div>\n        </div>\n\n        <div tabindex="8" class="{{csstheme}}-rightbutton-container" ba-if="{{trimmingmode}}">\n            <div data-selector="trim-button"\n                 onmouseout="this.blur()"\n                 ba-click="{{trim()}}"\n                 class="{{csstheme}}-primary-button {{csstheme}}-button-inner">\n                 {{string(\'trim-video\')}}\n            </div>\n        </div>\n\n        <div tabindex="8" class="{{csstheme}}-rightbutton-container" ba-if="{{frameselectionmode}}">\n            <div data-selector="select-frame-button"\n                 onmouseout="this.blur()"\n                 ba-click="{{select_frame()}}"\n                 class="{{csstheme}}-primary-button {{csstheme}}-button-inner">\n                 {{string(\'select-frame\')}}\n            </div>\n        </div>\n\n        <div tabindex="7" data-selector="button-airplay"\n             ba-hotkey:space^enter="{{show_airplay_devices()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-rightbutton-container {{cssplayer}}-airplay-container"\n             ba-show="{{airplaybuttonvisible}}" ba-click="{{show_airplay_devices()}}"\n        >\n            <svg width="16px" height="11px" viewBox="0 0 16 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n                \n                <title>Airplay</title>\n                <desc>Airplay icon.</desc>\n                <defs></defs>\n                <g stroke="none" stroke-width="1" fill-rule="evenodd" sketch:type="MSPage">\n                    <path d="M4,11 L12,11 L8,7 L4,11 Z M14.5454545,0 L1.45454545,0 C0.654545455,0 0,0.5625 0,1.25 L0,8.75 C0,9.4375 0.654545455,10 1.45454545,10 L4.36363636,10 L4.36363636,8.75 L1.45454545,8.75 L1.45454545,1.25 L14.5454545,1.25 L14.5454545,8.75 L11.6363636,8.75 L11.6363636,10 L14.5454545,10 C15.3454545,10 16,9.4375 16,8.75 L16,1.25 C16,0.5625 15.3454545,0 14.5454545,0 L14.5454545,0 Z" sketch:type="MSShapeGroup"></path>\n                </g>\n            </svg>\n        </div>\n\n        <div data-selector="button-chromecast" class="{{csstheme}}-rightbutton-container {{csstheme}}-cast-button-container" ba-show="{{castbuttonvisble}}">\n            <button tabindex="6" class="{{csstheme}}-gcast-button" is="google-cast-button"></button>\n        </div>\n\n        <div tabindex="5" data-selector="button-stream-label"\n             ba-hotkey:space^enter="{{toggle_stream()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-rightbutton-container"\n             ba-if="{{streams.length > 1 && currentstream}}" ba-click="{{toggle_stream()}}" title="{{string(\'change-resolution\')}}"\n        >\n            <div class="{{csstheme}}-button-inner {{csstheme}}-stream-label-container">\n                <span class="{{csstheme}}-button-text {{csstheme}}-stream-label">{{currentstream_label}}</span>\n            </div>\n        </div>\n\n        <div class="{{csstheme}}-time-container {{csstheme}}-rightbutton-container {{csstheme}}-right-time-container">\n            <div class="{{csstheme}}-time-value" title="{{string(\'total-time\')}}">{{formatTime(duration || position)}}</div>\n        </div>\n\n        <div class="{{csstheme}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}">\n            <div tabindex="4" data-selector="progress-bar-inner"\n                 ba-hotkey:right="{{seek(position + skipseconds)}}"\n                 ba-hotkey:left="{{seek(position - skipseconds)}}"\n                 onmouseout="this.blur()"\n                 class="{{csstheme}}-progressbar-inner"\n                 ontouchstart="{{startUpdatePosition(domEvent)}}"\n                 onmousedown="{{startUpdatePosition(domEvent)}}"\n            >\n\n                <div class="{{csstheme}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n                <div class="{{csstheme}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'video-progress\')}}">\n                </div>\n                <div class="{{csstheme}}-progressbar-marker"\n                    data-selector="trim-start-marker"\n                    ba-if="{{trimmingmode}}"\n                    ba-styles="{{{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + \'%\'}}}"\n                ></div>\n                <div class="{{csstheme}}-progressbar-marker"\n                    data-selector="trim-end-marker"\n                    ba-if="{{trimmingmode}}"\n                    ba-styles="{{{left: \'auto\', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + \'%\'}}}"\n                ></div>\n            </div>\n        </div>\n\n    </div>\n\n</div>\n',
                  tmplmessage: '<div class="{{csstheme}}-message-container" ba-click="{{click()}}">\n    <div data-selector="message-block" class="{{csstheme}}-first-inner-message-container">\n        <div class="{{csstheme}}-second-inner-message-container">\n            <div class="{{csstheme}}-third-inner-message-container">\n                <div class="{{csstheme}}-fourth-inner-message-container">\n                    <div class=\'{{csstheme}}-message-message\'>\n                        {{message || ""}}\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n',
                  tmplplaybutton: '\n<div tabindex="0" data-selector="play-button"\n     ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n     onkeydown="{{tab_index_move(domEvent, null, \'player-toggle-overlay\')}}"\n     class="{{cssplayer}}-playbutton-container" ba-click="{{play()}}" title="{{string(\'tooltip\')}}"\n>\n\t<div class="{{cssplayer}}-playbutton-button"></div>\n</div>\n<div ba-show="{{showduration && (duration != 0 && duration != undefined)}}" class="{{css}}-playbutton-duration">\n    {{formatTime(duration)}}\n</div>\n\n<div class="{{cssplayer}}-rerecord-bar" ba-if="{{rerecordable || submittable}}">\n\t<div class="{{cssplayer}}-rerecord-backbar"></div>\n\t<div class="{{cssplayer}}-rerecord-frontbar">\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{submittable && !trimmingmode}}">\n            <div tabindex="0" data-selector="player-submit-button"\n                 ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{submit()}}">\n                {{string(\'submit-video\')}}\n            </div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{rerecordable && !trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-rerecord-button"\n                 ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{rerecord()}}">\n        \t\t{{string(\'rerecord\')}}\n        \t</div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-trim-button"\n                 ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{play()}}">\n        \t\t{{string(\'trim\')}}\n        \t</div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-skip-button"\n                 ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{skip()}}">\n        \t\t{{string(\'skip\')}}\n        \t</div>\n        </div>\n\t</div>\n</div>\n',
                  cssloader: ie8 ? "ba-videoplayer" : "",
                  cssmessage: "ba-videoplayer",
                  cssplaybutton: ie8 ? "ba-videoplayer" : ""
                }
              };
            }), Scoped.extend("module:Assets.recorderthemes", ["dynamics:Parser"], function (Parser) {
              return Parser.registerFunctions({
                css: function (_css44) {
                  function css(_x794) {
                    return _css44.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css44.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                topmessage: function (_topmessage7) {
                  function topmessage(_x795) {
                    return _topmessage7.apply(this, arguments);
                  }
                  topmessage.toString = function () {
                    return _topmessage7.toString();
                  };
                  return topmessage;
                }(function (obj) {
                  with (obj) return topmessage;
                })
              }), Parser.registerFunctions({
                csstheme: function (_csstheme16) {
                  function csstheme(_x796) {
                    return _csstheme16.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme16.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                css: function (_css45) {
                  function css(_x797) {
                    return _css45.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css45.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "settingsvisible && settingsopen": function settingsvisibleSettingsopen(obj) {
                  with (obj) return settingsvisible && settingsopen;
                },
                videoselectnotification: function (_videoselectnotification3) {
                  function videoselectnotification(_x798) {
                    return _videoselectnotification3.apply(this, arguments);
                  }
                  videoselectnotification.toString = function () {
                    return _videoselectnotification3.toString();
                  };
                  return videoselectnotification;
                }(function (obj) {
                  with (obj) return videoselectnotification;
                }),
                "string('add-stream')": function stringAddStream(obj) {
                  with (obj) return string("add-stream");
                },
                csscommon: function (_csscommon30) {
                  function csscommon(_x799) {
                    return _csscommon30.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon30.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "showaddstreambutton && firefox && allowscreen": function showaddstreambuttonFirefoxAllowscreen(obj) {
                  with (obj) return showaddstreambutton && firefox && allowscreen;
                },
                "addNewStream()": function (_addNewStream3) {
                  function addNewStream(_x800) {
                    return _addNewStream3.apply(this, arguments);
                  }
                  addNewStream.toString = function () {
                    return _addNewStream3.toString();
                  };
                  return addNewStream;
                }(function (obj) {
                  with (obj) return addNewStream();
                }),
                "hover(string('add-stream'))": function hoverStringAddStream(obj) {
                  with (obj) return hover(string("add-stream"));
                },
                "showaddstreambutton && !firefox": function showaddstreambuttonFirefox(obj) {
                  with (obj) return showaddstreambutton && !firefox;
                },
                cameras: function (_cameras7) {
                  function cameras(_x801) {
                    return _cameras7.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras7.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "(camera.id !== selectedcamera) || allowscreen": function cameraIdSelectedcameraAllowscreen(obj) {
                  with (obj) return camera.id !== selectedcamera || allowscreen;
                },
                "addNewStream(camera.id)": function addNewStreamCameraId(obj) {
                  with (obj) return addNewStream(camera.id);
                },
                "camera.label": function cameraLabel(obj) {
                  with (obj) return camera.label;
                },
                "(showaddstreambutton && !firefox) || (firefox && allowscreen)": function showaddstreambuttonFirefoxFirefoxAllowscreen(obj) {
                  with (obj) return showaddstreambutton && !firefox || firefox && allowscreen;
                },
                "!novideo && !allowscreen && !ismobile": function novideoAllowscreenIsmobile(obj) {
                  with (obj) return !novideo && !allowscreen && !ismobile;
                },
                "hover(string('select-camera'))": function hoverStringSelectCamera(obj) {
                  with (obj) return hover(string("select-camera"));
                },
                "selectCamera(camera.id)": function selectCameraCameraId(obj) {
                  with (obj) return selectCamera(camera.id);
                },
                "selectedcamera == camera.id": function selectedcameraCameraId(obj) {
                  with (obj) return selectedcamera == camera.id;
                },
                "(!noaudio && !novideo) || !allowscreen": function noaudioNovideoAllowscreen(obj) {
                  with (obj) return !noaudio && !novideo || !allowscreen;
                },
                microphones: function (_microphones7) {
                  function microphones(_x802) {
                    return _microphones7.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones7.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                "!noaudio && !allowscreen": function noaudioAllowscreen(obj) {
                  with (obj) return !noaudio && !allowscreen;
                },
                "selectMicrophone(microphone.id)": function selectMicrophoneMicrophoneId(obj) {
                  with (obj) return selectMicrophone(microphone.id);
                },
                "hover(string('select-audio-input'))": function hoverStringSelectAudioInput(obj) {
                  with (obj) return hover(string("select-audio-input"));
                },
                "selectedmicrophone == microphone.id": function selectedmicrophoneMicrophoneId(obj) {
                  with (obj) return selectedmicrophone == microphone.id;
                },
                "microphone.label": function microphoneLabel(obj) {
                  with (obj) return microphone.label;
                },
                rerecordvisible: function (_rerecordvisible9) {
                  function rerecordvisible(_x803) {
                    return _rerecordvisible9.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible9.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord20) {
                  function rerecord(_x804) {
                    return _rerecord20.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord20.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "unhover()": function (_unhover6) {
                  function unhover(_x805) {
                    return _unhover6.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover6.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible6) {
                  function cancelvisible(_x806) {
                    return _cancelvisible6.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible6.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel6) {
                  function cancel(_x807) {
                    return _cancel6.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel6.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                },
                "stopvisible && recordingindication": function stopvisibleRecordingindication(obj) {
                  with (obj) return stopvisible && recordingindication;
                },
                settingsvisible: function (_settingsvisible9) {
                  function settingsvisible(_x808) {
                    return _settingsvisible9.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible9.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                ismobile: function (_ismobile2) {
                  function ismobile(_x809) {
                    return _ismobile2.apply(this, arguments);
                  }
                  ismobile.toString = function () {
                    return _ismobile2.toString();
                  };
                  return ismobile;
                }(function (obj) {
                  with (obj) return ismobile;
                }),
                "toggleFaceMode()": function (_toggleFaceMode3) {
                  function toggleFaceMode(_x810) {
                    return _toggleFaceMode3.apply(this, arguments);
                  }
                  toggleFaceMode.toString = function () {
                    return _toggleFaceMode3.toString();
                  };
                  return toggleFaceMode;
                }(function (obj) {
                  with (obj) return toggleFaceMode();
                }),
                "hover(string('switch-camera'))": function hoverStringSwitchCamera(obj) {
                  with (obj) return hover(string("switch-camera"));
                },
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                "hover(string(microphonehealthy ? 'microphonehealthy' : 'microphoneunhealthy'))": function hoverStringMicrophonehealthyMicrophonehealthyMicrophoneunhealthy(obj) {
                  with (obj) return hover(string(microphonehealthy ? "microphonehealthy" : "microphoneunhealthy"));
                },
                "microphonehealthy ? 'good' : 'bad'": function microphonehealthyGoodBad(obj) {
                  with (obj) return microphonehealthy ? "good" : "bad";
                },
                "!novideo && !allowscreen": function novideoAllowscreen(obj) {
                  with (obj) return !novideo && !allowscreen;
                },
                "hover(string(camerahealthy ? 'camerahealthy' : 'cameraunhealthy'))": function hoverStringCamerahealthyCamerahealthyCameraunhealthy(obj) {
                  with (obj) return hover(string(camerahealthy ? "camerahealthy" : "cameraunhealthy"));
                },
                "camerahealthy ? 'good' : 'bad'": function camerahealthyGoodBad(obj) {
                  with (obj) return camerahealthy ? "good" : "bad";
                },
                cssrecorder: function (_cssrecorder7) {
                  function cssrecorder(_x811) {
                    return _cssrecorder7.apply(this, arguments);
                  }
                  cssrecorder.toString = function () {
                    return _cssrecorder7.toString();
                  };
                  return cssrecorder;
                }(function (obj) {
                  with (obj) return cssrecorder;
                }),
                stopvisible: function (_stopvisible7) {
                  function stopvisible(_x812) {
                    return _stopvisible7.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible7.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                "pausable && !resumevisible": function pausableResumevisible(obj) {
                  with (obj) return pausable && !resumevisible;
                },
                "stop()": function (_stop5) {
                  function stop(_x813) {
                    return _stop5.apply(this, arguments);
                  }
                  stop.toString = function () {
                    return _stop5.toString();
                  };
                  return stop;
                }(function (obj) {
                  with (obj) return stop();
                }),
                "string('pause-recorder')": function stringPauseRecorder(obj) {
                  with (obj) return string("pause-recorder");
                },
                "pause()": function (_pause11) {
                  function pause(_x814) {
                    return _pause11.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause11.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "hover(string('pause-recorder'))": function hoverStringPauseRecorder(obj) {
                  with (obj) return hover(string("pause-recorder"));
                },
                "pausable && resumevisible": function pausableResumevisible(obj) {
                  with (obj) return pausable && resumevisible;
                },
                "resume()": function (_resume4) {
                  function resume(_x815) {
                    return _resume4.apply(this, arguments);
                  }
                  resume.toString = function () {
                    return _resume4.toString();
                  };
                  return resume;
                }(function (obj) {
                  with (obj) return resume();
                }),
                "string('resume-recorder')": function stringResumeRecorder(obj) {
                  with (obj) return string("resume-recorder");
                },
                "hover(string('resume-recorder'))": function hoverStringResumeRecorder(obj) {
                  with (obj) return hover(string("resume-recorder"));
                },
                recordvisible: function (_recordvisible9) {
                  function recordvisible(_x816) {
                    return _recordvisible9.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible9.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record6) {
                  function record(_x817) {
                    return _record6.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record6.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                "controlbarlabel && !rerecordvisible": function controlbarlabelRerecordvisible(obj) {
                  with (obj) return controlbarlabel && !rerecordvisible;
                },
                controlbarlabel: function (_controlbarlabel9) {
                  function controlbarlabel(_x818) {
                    return _controlbarlabel9.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel9.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                "mintimeindicator ? css + '-disabled': ''": function mintimeindicatorCssDisabled(obj) {
                  with (obj) return mintimeindicator ? css + "-disabled" : "";
                },
                "mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip')": function mintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip");
                },
                "hover(mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip'))": function hoverMintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return hover(mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip"));
                },
                "string('stop')": function stringStop(obj) {
                  with (obj) return string("stop");
                },
                skipvisible: function (_skipvisible5) {
                  function skipvisible(_x819) {
                    return _skipvisible5.apply(this, arguments);
                  }
                  skipvisible.toString = function () {
                    return _skipvisible5.toString();
                  };
                  return skipvisible;
                }(function (obj) {
                  with (obj) return skipvisible;
                }),
                "skip()": function (_skip9) {
                  function skip(_x820) {
                    return _skip9.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip9.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "hover(string('skip-tooltip'))": function hoverStringSkipTooltip(obj) {
                  with (obj) return hover(string("skip-tooltip"));
                },
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                },
                uploadcovershotvisible: function (_uploadcovershotvisible5) {
                  function uploadcovershotvisible(_x821) {
                    return _uploadcovershotvisible5.apply(this, arguments);
                  }
                  uploadcovershotvisible.toString = function () {
                    return _uploadcovershotvisible5.toString();
                  };
                  return uploadcovershotvisible;
                }(function (obj) {
                  with (obj) return uploadcovershotvisible;
                }),
                "hover(string('upload-covershot-tooltip'))": function hoverStringUploadCovershotTooltip(obj) {
                  with (obj) return hover(string("upload-covershot-tooltip"));
                },
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                covershot_accept_string: function (_covershot_accept_string6) {
                  function covershot_accept_string(_x822) {
                    return _covershot_accept_string6.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string6.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                showslidercontainer: function (_showslidercontainer5) {
                  function showslidercontainer(_x823) {
                    return _showslidercontainer5.apply(this, arguments);
                  }
                  showslidercontainer.toString = function () {
                    return _showslidercontainer5.toString();
                  };
                  return showslidercontainer;
                }(function (obj) {
                  with (obj) return showslidercontainer;
                }),
                css: function (_css46) {
                  function css(_x824) {
                    return _css46.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css46.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "left()": function (_left3) {
                  function left(_x825) {
                    return _left3.apply(this, arguments);
                  }
                  left.toString = function () {
                    return _left3.toString();
                  };
                  return left;
                }(function (obj) {
                  with (obj) return left();
                }),
                csscommon: function (_csscommon31) {
                  function csscommon(_x826) {
                    return _csscommon31.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon31.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                images: function (_images3) {
                  function images(_x827) {
                    return _images3.apply(this, arguments);
                  }
                  images.toString = function () {
                    return _images3.toString();
                  };
                  return images;
                }(function (obj) {
                  with (obj) return images;
                }),
                "select(image)": function selectImage(obj) {
                  with (obj) return select(image);
                },
                "{left: image.left + 'px', top: image.top + 'px', width: image.width + 'px', height: image.height + 'px'}": function leftImageLeftPxTopImageTopPxWidthImageWidthPxHeightImageHeightPx(obj) {
                  with (obj) return {
                    left: image.left + "px",
                    top: image.top + "px",
                    width: image.width + "px",
                    height: image.height + "px"
                  };
                },
                "right()": function (_right3) {
                  function right(_x828) {
                    return _right3.apply(this, arguments);
                  }
                  right.toString = function () {
                    return _right3.toString();
                  };
                  return right;
                }(function (obj) {
                  with (obj) return right();
                }),
                "!showslidercontainer": function (_showslidercontainer6) {
                  function showslidercontainer(_x829) {
                    return _showslidercontainer6.apply(this, arguments);
                  }
                  showslidercontainer.toString = function () {
                    return _showslidercontainer6.toString();
                  };
                  return showslidercontainer;
                }(function (obj) {
                  with (obj) return !showslidercontainer;
                }),
                covershot_accept_string: function (_covershot_accept_string7) {
                  function covershot_accept_string(_x830) {
                    return _covershot_accept_string7.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string7.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                css: function (_css47) {
                  function css(_x831) {
                    return _css47.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css47.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "initialmessages.length > 0": function initialmessagesLength0(obj) {
                  with (obj) return 0 < initialmessages.length;
                },
                csscommon: function (_csscommon32) {
                  function csscommon(_x832) {
                    return _csscommon32.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon32.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                initialmessages: function (_initialmessages5) {
                  function initialmessages(_x833) {
                    return _initialmessages5.apply(this, arguments);
                  }
                  initialmessages.toString = function () {
                    return _initialmessages5.toString();
                  };
                  return initialmessages;
                }(function (obj) {
                  with (obj) return initialmessages;
                }),
                "initialmessage.message": function initialmessageMessage(obj) {
                  with (obj) return initialmessage.message;
                },
                "initialmessage.type ? initialmessage.type : 'default'": function initialmessageTypeInitialmessageTypeDefault(obj) {
                  with (obj) return initialmessage.type ? initialmessage.type : "default";
                },
                "initialmessage.id": function initialmessageId(obj) {
                  with (obj) return initialmessage.id;
                },
                actions: function (_actions8) {
                  function actions(_x834) {
                    return _actions8.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions8.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.switchcamera": function actionSwitchcamera(obj) {
                  with (obj) return action.switchcamera;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                },
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                }
              }), Parser.registerFunctions({
                cssrecorder: function (_cssrecorder8) {
                  function cssrecorder(_x835) {
                    return _cssrecorder8.apply(this, arguments);
                  }
                  cssrecorder.toString = function () {
                    return _cssrecorder8.toString();
                  };
                  return cssrecorder;
                }(function (obj) {
                  with (obj) return cssrecorder;
                }),
                "click()": function (_click10) {
                  function click(_x836) {
                    return _click10.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click10.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                "shortMessage ? 'short-message' : 'long-message'": function shortMessageShortMessageLongMessage(obj) {
                  with (obj) return shortMessage ? "short-message" : "long-message";
                },
                'message || ""': function (_message16) {
                  function message(_x837) {
                    return _message16.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message16.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links6) {
                  function links(_x838) {
                    return _links6.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links6.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }), {
                space: {
                  css: "ba-videorecorder",
                  csstheme: "ba-recorder-theme-space",
                  cssrecorder: "ba-recorder",
                  cssmessage: "ba-videorecorder",
                  cssloader: "ba-videorecorder",
                  tmpltopmessage: '<div class="{{css}}-topmessage-container">\n    <div data-selector="recorder-topmessage-block" class=\'{{css}}-topmessage-message\'>\n        {{topmessage}}\n    </div>\n</div>\n',
                  tmplcontrolbar: '<div class="{{csstheme}}-dashboard">\n\n\t<div class="{{css}}-settings-front">\n\n\t\t\n\t\t<div data-selector="recorder-settings" class="{{css}}-settings" ba-show="{{settingsvisible && settingsopen}}">\n\t\t\t<div class="{{css}}-bubble-info">\n\t\t\t\t<ul data-selector="add-new-stream" ba-if="{{videoselectnotification}}">\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div data-selector="single-camera-stream">\n\t\t\t\t\t\t\t<i class="ba-commoncss-icon-plus"></i> {{string(\'add-stream\')}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div data-selector="single-camera-stream" class="{{csscommon}}-text-error">\n\t\t\t\t\t\t\t{{videoselectnotification}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\n\t\t\t\t<ul data-selector="add-new-stream" ba-show="{{showaddstreambutton && firefox && allowscreen}}">\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div data-selector="single-camera-stream"\n\t\t\t\t\t\t\t class="{{css}}-add-stream"\n\t\t\t\t\t\t\t onclick="{{addNewStream()}}"\n\t\t\t\t\t\t\t onmouseenter="{{hover(string(\'add-stream\'))}}"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-plus"></i> {{string(\'add-stream\')}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\n\t\t\t\t<ul data-selector="add-new-stream" ba-show="{{showaddstreambutton && !firefox}}" ba-repeat="{{camera :: cameras}}">\n\t\t\t\t\t<li ba-show="{{(camera.id !== selectedcamera) || allowscreen}}">\n\t\t\t\t\t\t<div data-selector="single-camera-stream"\n\t\t\t\t\t\t\t class="{{css}}-add-stream"\n\t\t\t\t\t\t\t onclick="{{addNewStream(camera.id)}}"\n\t\t\t\t\t\t\t onmouseenter="{{hover(string(\'add-stream\'))}}"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-plus"></i> {{camera.label}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\n\t\t\t\t</ul>\n\t\t\t\t<hr ba-show="{{(showaddstreambutton && !firefox) || (firefox && allowscreen)}}"/>\n\n\t\t\t\t<ul data-selector="camera-settings" ba-repeat="{{camera :: cameras}}" ba-show="{{!novideo && !allowscreen && !ismobile}}">\n\t\t\t\t\t<li onmouseenter="{{hover(string(\'select-camera\'))}}">\n\t\t\t\t\t\t<input tabindex="0"\n\t\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t   type=\'radio\' name=\'camera\' value="{{selectedcamera == camera.id}}"\n\t\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t/>\n\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t<label onclick="{{selectCamera(camera.id)}}" ba-hotkey:space^enter="{{selectCamera(camera.id)}}">\n\t\t\t\t\t\t\t{{camera.label}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<hr ba-show="{{(!noaudio && !novideo) || !allowscreen}}"/>\n\t\t\t\t<ul data-selector="microphone-settings" ba-repeat="{{microphone :: microphones}}" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t\t<li tabindex="0"\n\t\t\t\t\t\tba-hotkey:space^enter="{{selectMicrophone(microphone.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\tonmouseenter="{{hover(string(\'select-audio-input\'))}}"\n\t\t\t\t\t\tonclick="{{selectMicrophone(microphone.id)}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<input type=\'radio\' name=\'microphone\' value="{{selectedmicrophone == microphone.id}}" />\n\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t{{microphone.label}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n\t\t<div class="{{css}}-controlbar-center-section">\n\n\t\t\t<div data-selector="rerecord-primary-button" class="{{css}}-button-container" ba-show="{{rerecordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t\t class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{rerecord()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'rerecord\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div data-selector="cancel-primary-button" class="{{css}}-button-container" ba-show="{{cancelvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t\t class="{{css}}-button-primary" onclick="{{cancel()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'cancel\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-controlbar-left-section">\n\n\t\t\t<div class="{{css}}-indicator-container" ba-show="{{stopvisible && recordingindication}}">\n\t\t\t\t<div data-selector="recording-indicator" class="{{css}}-recording-indication"></div>\n\t\t\t</div>\n\n\t\t\t<div ba-show="{{settingsvisible}}">\n\n\t\t\t\t<div class="{{css}}-circle-button"  ba-show="{{ismobile}}">\n\t\t\t\t\t<div data-selector="face-mode-toggle-icon"\n\t\t\t\t\t\t class="{{css}}-mobile-camera-switcher {{css}}-button-inner {{css}}-button-circle-unselected"\n\t\t\t\t\t\t onclick="{{toggleFaceMode()}}"\n\t\t\t\t\t\t onmouseenter="{{hover(string(\'switch-camera\'))}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-arrows-cw"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="{{css}}-circle-button">\n\t\t\t\t\t<div tabindex="0"\n\t\t\t\t\t\t ba-hotkey:space^enter="{{settingsopen=!settingsopen}}" onmouseout="this.blur()"\n\t\t\t\t\t\t data-selector="record-button-icon-cog"\n\t\t\t\t\t\t class="{{css}}-button-inner {{css}}-button-circle-{{settingsopen ? \'selected\' : \'unselected\' }}"\n\t\t\t\t\t\t onclick="{{settingsopen=!settingsopen}}"\n\t\t\t\t\t\t onmouseenter="{{hover(string(\'settings\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-cog"></i>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class="{{css}}-circle-button" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t\t<div data-selector="record-button-icon-mic" class="{{css}}-button-inner"\n\t\t\t\t\t\t onmouseenter="{{hover(string(microphonehealthy ? \'microphonehealthy\' : \'microphoneunhealthy\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-mic {{csscommon}}-icon-state-{{microphonehealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="{{css}}-circle-button" ba-show="{{!novideo && !allowscreen}}">\n\t\t\t\t\t<div data-selector="record-button-icon-videocam" class="{{css}}-button-inner"\n\t\t\t\t\t\t onmouseenter="{{hover(string(camerahealthy ? \'camerahealthy\' : \'cameraunhealthy\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-videocam {{csscommon}}-icon-state-{{ camerahealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{cssrecorder}}-controlbar-right-section">\n\n\t\t\t<div class="{{css}}-rightbutton-container {{css}}-pause-button-container" ba-show="{{stopvisible}}">\n\t\t\t\t<div class="{{css}}-circle-button">\n                    <div tabindex="0" data-selector="pause-primary-button"  ba-show="{{pausable && !resumevisible}}"\n                         ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n                         data-selector="pause-primary-button" class="{{css}}-button-inner"\n                         title="{{string(\'pause-recorder\')}}"\n                         onclick="{{pause()}}"\n                         onmouseenter="{{hover(string(\'pause-recorder\'))}}"\n                         onmouseleave="{{unhover()}}"\n                    >\n                        <i class="{{csscommon}}-icon-pause"></i>\n                    </div>\n\n                    <div tabindex="0" data-selector="resume-primary-button"  ba-show="{{pausable && resumevisible}}"\n                         ba-hotkey:space^enter="{{resume()}}" onmouseout="this.blur()"\n                         data-selector="resume-primary-button" class="{{css}}-button-inner"\n                         title="{{string(\'resume-recorder\')}}"\n                         onclick="{{resume()}}"\n                         onmouseenter="{{hover(string(\'resume-recorder\'))}}"\n                         onmouseleave="{{unhover()}}"\n                    >\n                        <i class="{{csscommon}}-icon-ccw"></i>\n                    </div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-rightbutton-container" ba-show="{{recordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="record-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{record()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'record\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-stop-container" ba-show="{{stopvisible}}">\n\n\t\t\t<div class="{{css}}-timer-container">\n\t\t\t\t<div class="{{css}}-label-container" ba-show="{{controlbarlabel && !rerecordvisible}}">\n\t\t\t\t\t<div data-selector="record-label-block" class="{{css}}-label {{css}}-button-primary">\n\t\t\t\t\t\t{{controlbarlabel}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-stop-button-container">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="stop-primary-button"\n\t\t\t\t\t class="{{css}}-button-primary {{mintimeindicator ? css + \'-disabled\': \'\'}}"\n\t\t\t\t\t title="{{mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\')}}"\n\t\t\t\t\t onclick="{{stop()}}"\n\t\t\t\t\t onmouseenter="{{hover(mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'stop\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-centerbutton-container" ba-show="{{skipvisible}}">\n            <div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="skip-primary-button" class="{{css}}-button-primary"\n                 onclick="{{skip()}}"\n                 onmouseenter="{{hover(string(\'skip-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                {{string(\'skip\')}}\n            </divi>\n        </div>\n\n\n        <div class="{{css}}-rightbutton-container" ba-if="{{uploadcovershotvisible}}">\n            <div data-selector="covershot-primary-button" class="{{css}}-button-primary"\n                 onmouseenter="{{hover(string(\'upload-covershot-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                <input type="file"\n                       class="{{css}}-chooser-file"\n                       style="height:100px"\n                       onchange="{{uploadCovershot(domEvent)}}"\n                       accept="{{covershot_accept_string}}" />\n                <span>\n                    {{string(\'upload-covershot\')}}\n                </span>\n            </div>\n        </div>\n\n\t</div>\n\n</div>\n',
                  tmplimagegallery: '<div ba-if="{{showslidercontainer}}" data-selector="image-gallery" class="{{css}}-image-gallery-container">\n\t<div data-selector="slider-left-button" class="{{css}}-imagegallery-leftbutton">\n\t\t<div tabindex="0" data-selector="slider-left-inner-button"\n\t\t\t ba-hotkey:space^enter^left="{{left()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-button-inner" onclick="{{left()}}"\n\t\t>\n\t\t\t<i class="{{csscommon}}-icon-left-open"></i>\n\t\t</div>\n\t</div>\n\n\t<div data-selector="images-imagegallery-container" ba-repeat="{{image::images}}" class="{{css}}-imagegallery-container" data-gallery-container>\n\t\t<div tabindex="0" data-selector="imagegallery-selected-image"\n\t\t\t ba-hotkey:space^enter="{{select(image)}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-image"\n\t\t\t ba-styles="{{{left: image.left + \'px\', top: image.top + \'px\', width: image.width + \'px\', height: image.height + \'px\'}}}"\n\t\t\t onclick="{{select(image)}}"\n\t\t>\n\t\t</div>\n\t</div>\n\n\t<div data-selector="slider-right-button" class="{{css}}-imagegallery-rightbutton">\n\t\t<div tabindex="0" data-selector="slider-right-inner-button"\n\t\t\t ba-hotkey:space^enter^right="{{right()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-button-inner"\n\t\t\t onclick="{{right()}}"\n\t\t>\n\t\t\t<i class="{{csscommon}}-icon-right-open"></i>\n\t\t</div>\n\t</div>\n</div>\n\n<div ba-if="{{!showslidercontainer}}" class="{{css}}-chooser-container">\n\t<div data-selector="covershot-primary-button" class="{{css}}-chooser-button-container">\n\t\t<div class="{{css}}-chooser-button-0">\n\t\t\t<input type="file"\n\t\t\t\t   tabindex="0"\n\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t   accept="{{covershot_accept_string}}"\n\t\t\t\t   onchange="{{uploadCovershot(domEvent)}}"\n\t\t\t/>\n\t\t\t<i class="{{csscommon}}-icon-picture"></i>\n\t\t\t<span>\n\t\t\t{{string(\'upload-covershot\')}}\n\t\t</span>\n\t\t</div>\n\t</div>\n</div>\n',
                  tmplchooser: '<div class="{{css}}-chooser-container">\n\t<div ba-if="{{initialmessages.length > 0}}" class="{{csscommon}}-message-container">\n\t\t<ul ba-repeat="{{initialmessage :: initialmessages}}">\n\t\t\t<li ba-if="{{initialmessage.message}}"\n\t\t\t\tclass="{{csscommon}}-message-text {{csscommon}}-message-{{initialmessage.type ? initialmessage.type : \'default\'}}"\n\t\t\t>\n\t\t\t\t{{ initialmessage.message }}\n\t\t\t\t<span ba-if="{{initialmessage.id}}"\n\t\t\t\t\t  class="{{csscommon}}-action-button"\n\t\t\t\t\t  ba-click="close_message(initialmessage.id)"\n\t\t\t\t>\n\t\t\t\t\t<i class="{{csscommon}}-icon-cancel"></i>\n\t\t\t\t</span>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\n\t<div class="{{css}}-chooser-button-container">\n\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t\t ba-click="{{click_action(action)}}">\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture="{{action.switchcamera}}" />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t/>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n',
                  tmplmessage: '<div data-selector="recorder-message-container" class="{{cssrecorder}}-message-container" ba-click="{{click()}}">\n    <div class="{{cssrecorder}}-top-inner-message-container {{cssrecorder}}-{{shortMessage ? \'short-message\' : \'long-message\'}}">\n        <div class="{{cssrecorder}}-first-inner-message-container">\n            <div class="{{cssrecorder}}-second-inner-message-container">\n                <div class="{{cssrecorder}}-third-inner-message-container">\n                    <div class="{{cssrecorder}}-fourth-inner-message-container">\n                        <div data-selector="recorder-message-block" class=\'{{cssrecorder}}-message-message\'>\n                            <p>\n                                {{message || ""}}\n                            </p>\n                            <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n                                <li>\n                                    <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                                        {{link.title}}\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n'
                }
              };
            }), Scoped.extend("module:Assets.imageviewerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                css: function (_css48) {
                  function css(_x839) {
                    return _css48.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css48.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "activitydelta > 5000 && hideoninactivity ? (css + '-dashboard-hidden') : ''": function activitydelta5000HideoninactivityCssDashboardHidden(obj) {
                  with (obj) return 5e3 < activitydelta && hideoninactivity ? css + "-dashboard-hidden" : "";
                },
                title: function (_title14) {
                  function title(_x840) {
                    return _title14.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title14.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit15) {
                  function submit(_x841) {
                    return _submit15.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit15.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable14) {
                  function submittable(_x842) {
                    return _submittable14.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable14.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-image')": function stringSubmitImage(obj) {
                  with (obj) return string("submit-image");
                },
                "rerecord()": function (_rerecord21) {
                  function rerecord(_x843) {
                    return _rerecord21.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord21.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable14) {
                  function rerecordable(_x844) {
                    return _rerecordable14.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable14.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-image')": function stringRerecordImage(obj) {
                  with (obj) return string("rerecord-image");
                },
                csscommon: function (_csscommon33) {
                  function csscommon(_x845) {
                    return _csscommon33.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon33.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "toggle_fullscreen()": function (_toggle_fullscreen8) {
                  function toggle_fullscreen(_x846) {
                    return _toggle_fullscreen8.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen8.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                fullscreen: function (_fullscreen8) {
                  function fullscreen(_x847) {
                    return _fullscreen8.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen8.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-image') : string('fullscreen-image')": function fullscreenedStringExitFullscreenImageStringFullscreenImage(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-image") : string("fullscreen-image");
                },
                "fullscreened ? 'resize-minimize' : 'resize-full'": function fullscreenedResizeMinimizeResizeFull(obj) {
                  with (obj) return fullscreened ? "resize-minimize" : "resize-full";
                }
              }), Parser.registerFunctions({
                css: function (_css49) {
                  function css(_x848) {
                    return _css49.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css49.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click11) {
                  function click(_x849) {
                    return _click11.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click11.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                'message || ""': function (_message17) {
                  function message(_x850) {
                    return _message17.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message17.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                })
              }), {
                space: {
                  css: "ba-imageviewer",
                  csstheme: "ba-imageviewer-space-theme",
                  tmplcontrolbar: '<div class="{{css}}-image-title-container {{activitydelta > 5000 && hideoninactivity ? (css + \'-dashboard-hidden\') : \'\'}}">\n    <div class="{{css}}-title" ba-if="{{title}}">\n        <p>{{title}}</p>\n    </div>\n\n</div>\n\n<div class="{{css}}-dashboard {{activitydelta > 5000 && hideoninactivity ? (css + \'-dashboard-hidden\') : \'\'}}">\n\n    <div class="{{css}}-controlbar-footer">\n        <div tabindex="0" data-selector="submit-image-button"\n             ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n             class="{{css}}-leftbutton-container" ba-if="{{submittable}}"  ba-click="{{submit()}}"\n        >\n           <div class="{{css}}-button-inner">\n               {{string(\'submit-image\')}}\n           </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-ccw"\n             ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n             class="{{css}}-leftbutton-container" ba-if="{{rerecordable}}"\n             ba-click="{{rerecord()}}" title="{{string(\'rerecord-image\')}}"\n        >\n           <div class="{{css}}-button-inner">\n               <i class="{{csscommon}}-icon-ccw"></i>\n           </div>\n        </div>\n\n        <div tabindex="8" data-selector="button-icon-resize-full"\n             ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n             onkeydown="{{tab_index_move(domEvent)}}"\n             class="{{css}}-rightbutton-container"\n             ba-if="{{fullscreen}}" ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-image\') : string(\'fullscreen-image\') }}"\n        >\n            <div class="{{css}}-button-inner {{css}}-full-screen-btn-inner">\n                <i class="{{csscommon}}-icon-{{fullscreened ? \'resize-minimize\' : \'resize-full\'}}"></i>\n            </div>\n        </div>\n\n    </div>\n\n</div>\n',
                  tmplmessage: '<div class="{{css}}-message-container" ba-click="{{click()}}">\n    <div data-selector="message-block" class="{{css}}-first-inner-message-container">\n        <div class="{{css}}-second-inner-message-container">\n            <div class="{{css}}-third-inner-message-container">\n                <div class="{{css}}-fourth-inner-message-container">\n                    <div class=\'{{css}}-message-message\'>\n                        {{message || ""}}\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n',
                  cssloader: ie8 ? "ba-imageviewer" : "",
                  cssmessage: "ba-imageviewer"
                }
              };
            }), Scoped.extend("module:Assets.audioplayerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                csstheme: function (_csstheme17) {
                  function csstheme(_x851) {
                    return _csstheme17.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme17.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                title: function (_title15) {
                  function title(_x852) {
                    return _title15.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title15.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "startUpdateVolume(domEvent)": function startUpdateVolumeDomEvent(obj) {
                  with (obj) return startUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent)": function stopUpdateVolumeDomEvent(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "progressUpdateVolume(domEvent)": function progressUpdateVolumeDomEvent(obj) {
                  with (obj) return progressUpdateVolume(domEvent);
                },
                "{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + '%'}": function widthMathCeil1MathMin99MathRoundVolume100(obj) {
                  with (obj) return {
                    width: Math.ceil(1 + Math.min(99, Math.round(100 * volume))) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                "toggle_volume()": function (_toggle_volume8) {
                  function toggle_volume(_x853) {
                    return _toggle_volume8.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume8.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                },
                "submit()": function (_submit16) {
                  function submit(_x854) {
                    return _submit16.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit16.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable15) {
                  function submittable(_x855) {
                    return _submittable15.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable15.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-audio')": function stringSubmitAudio(obj) {
                  with (obj) return string("submit-audio");
                },
                "rerecord()": function (_rerecord22) {
                  function rerecord(_x856) {
                    return _rerecord22.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord22.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable15) {
                  function rerecordable(_x857) {
                    return _rerecordable15.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable15.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-audio')": function stringRerecordAudio(obj) {
                  with (obj) return string("rerecord-audio");
                },
                csscommon: function (_csscommon34) {
                  function csscommon(_x858) {
                    return _csscommon34.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon34.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "play()": function (_play12) {
                  function play(_x859) {
                    return _play12.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play12.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "!playing": function (_playing17) {
                  function playing(_x860) {
                    return _playing17.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing17.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "string('play-audio')": function stringPlayAudio(obj) {
                  with (obj) return string("play-audio");
                },
                "pause()": function (_pause12) {
                  function pause(_x861) {
                    return _pause12.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause12.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                playing: function (_playing18) {
                  function playing(_x862) {
                    return _playing18.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing18.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "disablepause ? string('pause-audio-disabled') : string('pause-audio')": function disablepauseStringPauseAudioDisabledStringPauseAudio(obj) {
                  with (obj) return disablepause ? string("pause-audio-disabled") : string("pause-audio");
                },
                "string('elapsed-time')": function stringElapsedTime(obj) {
                  with (obj) return string("elapsed-time");
                },
                "formatTime(position)": function formatTimePosition(obj) {
                  with (obj) return formatTime(position);
                },
                "string('total-time')": function stringTotalTime(obj) {
                  with (obj) return string("total-time");
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "stopUpdatePosition(domEvent)": function stopUpdatePositionDomEvent(obj) {
                  with (obj) return stopUpdatePosition(domEvent);
                },
                "progressUpdatePosition(domEvent)": function progressUpdatePositionDomEvent(obj) {
                  with (obj) return progressUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('audio-progress')": function stringAudioProgress(obj) {
                  with (obj) return string("audio-progress");
                }
              }), Parser.registerFunctions({
                css: function (_css50) {
                  function css(_x863) {
                    return _css50.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css50.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click12) {
                  function click(_x864) {
                    return _click12.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click12.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                'message || ""': function (_message18) {
                  function message(_x865) {
                    return _message18.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message18.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                })
              }), {
                space: {
                  css: "ba-audioplayer",
                  csstheme: "ba-player-space-theme",
                  tmplcontrolbar: '<div class="{{csstheme}}-title-container ">\n    <div class="{{csstheme}}-title" ba-if="{{title}}">\n        <p>{{title}}</p>\n    </div>\n\n    <div class="{{csstheme}}-volumebar">\n        <div tabindex="2" data-selector="button-volume-bar"\n             ba-hotkey:right="{{set_volume(volume + 0.1)}}"\n             ba-hotkey:left="{{set_volume(volume - 0.1)}}"\n             onmouseout="this.blur()"\n             class="{{csstheme}}-volumebar-inner"\n             onmousedown="{{startUpdateVolume(domEvent)}}"\n             onmouseup="{{stopUpdateVolume(domEvent)}}"\n             onmouseleave="{{stopUpdateVolume(domEvent)}}"\n             onmousemove="{{progressUpdateVolume(domEvent)}}"\n        >\n            <div class="{{csstheme}}-volumebar-position" ba-styles="{{{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + \'%\'}}}" title="{{string(\'volume-button\')}}"></div>\n        </div>\n    </div>\n\n    <div tabindex="0" data-selector="button-icon-volume"\n         ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n         class="{{csstheme}}-rightbutton-container"\n         ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}"\n    >\n        <div class="{{csstheme}}-button-inner">\n            <i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n        </div>\n    </div>\n</div>\n\n<div class="{{csstheme}}-dashboard ">\n\n    <div class="{{csstheme}}-controlbar-footer">\n        <div tabindex="0" data-selector="submit-audio-button"\n             ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-leftbutton-container" ba-if="{{submittable}}"  ba-click="{{submit()}}"\n        >\n           <div class="{{csstheme}}-button-inner">\n               {{string(\'submit-audio\')}}\n           </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-ccw"\n             ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-leftbutton-container" ba-if="{{rerecordable}}"\n             ba-click="{{rerecord()}}" title="{{string(\'rerecord-audio\')}}"\n        >\n           <div class="{{csstheme}}-button-inner">\n               <i class="{{csscommon}}-icon-ccw"></i>\n           </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-play"\n             ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}"\n             class="{{csstheme}}-leftbutton-container" ba-if="{{!playing}}" ba-click="{{play()}}" title="{{string(\'play-audio\')}}"\n        >\n           <div class="{{csstheme}}-button-inner">\n               <i class="{{csscommon}}-icon-play"></i>\n           </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-pause"\n             ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}"\n             class="{{csstheme}}-leftbutton-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n             ba-if="{{playing}}" ba-click="{{pause()}}" title="{{disablepause ? string(\'pause-audio-disabled\') : string(\'pause-audio\')}}"\n        >\n           <div class="{{csstheme}}-button-inner">\n               <i class="{{csscommon}}-icon-pause"></i>\n           </div>\n        </div>\n\n        <div class="{{csstheme}}-time-container">\n           <div class="{{csstheme}}-time-value" title="{{string(\'elapsed-time\')}}">{{formatTime(position)}}</div>\n        </div>\n\n        <div class="{{csstheme}}-time-container {{csstheme}}-rightbutton-container {{csstheme}}-right-time-container">\n           <div class="{{csstheme}}-time-value" title="{{string(\'total-time\')}}">{{formatTime(duration || position)}}</div>\n        </div>\n\n        <div class="{{csstheme}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}">\n           <div tabindex="4" data-selector="progress-bar-inner"\n                ba-hotkey:right="{{seek(position + skipseconds)}}"\n                ba-hotkey:left="{{seek(position - skipseconds)}}"\n                onmouseout="this.blur()"\n                class="{{csstheme}}-progressbar-inner"\n                onmousedown="{{startUpdatePosition(domEvent)}}"\n                onmouseup="{{stopUpdatePosition(domEvent)}}"\n                onmouseleave="{{stopUpdatePosition(domEvent)}}"\n                onmousemove="{{progressUpdatePosition(domEvent)}}"\n           >\n\n               <div class="{{csstheme}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n               <div class="{{csstheme}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'audio-progress\')}}">\n                   <div class="{{csstheme}}-progressbar-button"></div>\n               </div>\n           </div>\n        </div>\n\n    </div>\n\n</div>\n',
                  tmplmessage: '<div class="{{css}}-message-container" ba-click="{{click()}}">\n    <div data-selector="message-block" class="{{css}}-first-inner-message-container">\n        <div class="{{css}}-second-inner-message-container">\n            <div class="{{css}}-third-inner-message-container">\n                <div class="{{css}}-fourth-inner-message-container">\n                    <div class=\'{{css}}-message-message\'>\n                        {{message || ""}}\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n',
                  cssloader: ie8 ? "ba-audioplayer" : "",
                  cssmessage: "ba-audioplayer"
                }
              };
            }), Scoped.extend("module:Assets.audiorecorderthemes", ["dynamics:Parser"], function (Parser) {
              return Parser.registerFunctions({
                css: function (_css51) {
                  function css(_x866) {
                    return _css51.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css51.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                topmessage: function (_topmessage8) {
                  function topmessage(_x867) {
                    return _topmessage8.apply(this, arguments);
                  }
                  topmessage.toString = function () {
                    return _topmessage8.toString();
                  };
                  return topmessage;
                }(function (obj) {
                  with (obj) return topmessage;
                })
              }), Parser.registerFunctions({
                csstheme: function (_csstheme18) {
                  function csstheme(_x868) {
                    return _csstheme18.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme18.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                css: function (_css52) {
                  function css(_x869) {
                    return _css52.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css52.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "settingsvisible && settingsopen": function settingsvisibleSettingsopen(obj) {
                  with (obj) return settingsvisible && settingsopen;
                },
                cameras: function (_cameras8) {
                  function cameras(_x870) {
                    return _cameras8.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras8.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "selectCamera(camera.id)": function selectCameraCameraId(obj) {
                  with (obj) return selectCamera(camera.id);
                },
                "selectedcamera == camera.id": function selectedcameraCameraId(obj) {
                  with (obj) return selectedcamera == camera.id;
                },
                "camera.label": function cameraLabel(obj) {
                  with (obj) return camera.label;
                },
                microphones: function (_microphones8) {
                  function microphones(_x871) {
                    return _microphones8.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones8.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                audio: function (_audio2) {
                  function audio(_x872) {
                    return _audio2.apply(this, arguments);
                  }
                  audio.toString = function () {
                    return _audio2.toString();
                  };
                  return audio;
                }(function (obj) {
                  with (obj) return audio;
                }),
                "selectMicrophone(microphone.id)": function selectMicrophoneMicrophoneId(obj) {
                  with (obj) return selectMicrophone(microphone.id);
                },
                "selectedmicrophone == microphone.id": function selectedmicrophoneMicrophoneId(obj) {
                  with (obj) return selectedmicrophone == microphone.id;
                },
                "microphone.label": function microphoneLabel(obj) {
                  with (obj) return microphone.label;
                },
                rerecordvisible: function (_rerecordvisible10) {
                  function rerecordvisible(_x873) {
                    return _rerecordvisible10.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible10.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord23) {
                  function rerecord(_x874) {
                    return _rerecord23.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord23.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "unhover()": function (_unhover7) {
                  function unhover(_x875) {
                    return _unhover7.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover7.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible7) {
                  function cancelvisible(_x876) {
                    return _cancelvisible7.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible7.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel7) {
                  function cancel(_x877) {
                    return _cancel7.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel7.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                },
                settingsvisible: function (_settingsvisible10) {
                  function settingsvisible(_x878) {
                    return _settingsvisible10.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible10.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                csscommon: function (_csscommon35) {
                  function csscommon(_x879) {
                    return _csscommon35.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon35.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "!noaudio && !allowscreen": function noaudioAllowscreen(obj) {
                  with (obj) return !noaudio && !allowscreen;
                },
                "hover(string(microphonehealthy ? 'microphonehealthy' : 'microphoneunhealthy'))": function hoverStringMicrophonehealthyMicrophonehealthyMicrophoneunhealthy(obj) {
                  with (obj) return hover(string(microphonehealthy ? "microphonehealthy" : "microphoneunhealthy"));
                },
                "microphonehealthy ? 'good' : 'bad'": function microphonehealthyGoodBad(obj) {
                  with (obj) return microphonehealthy ? "good" : "bad";
                },
                "hover(string(camerahealthy ? 'camerahealthy' : 'cameraunhealthy'))": function hoverStringCamerahealthyCamerahealthyCameraunhealthy(obj) {
                  with (obj) return hover(string(camerahealthy ? "camerahealthy" : "cameraunhealthy"));
                },
                "camerahealthy ? 'good' : 'bad'": function camerahealthyGoodBad(obj) {
                  with (obj) return camerahealthy ? "good" : "bad";
                },
                recordvisible: function (_recordvisible10) {
                  function recordvisible(_x880) {
                    return _recordvisible10.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible10.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record7) {
                  function record(_x881) {
                    return _record7.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record7.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                stopvisible: function (_stopvisible8) {
                  function stopvisible(_x882) {
                    return _stopvisible8.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible8.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                "controlbarlabel && !rerecordvisible": function controlbarlabelRerecordvisible(obj) {
                  with (obj) return controlbarlabel && !rerecordvisible;
                },
                controlbarlabel: function (_controlbarlabel10) {
                  function controlbarlabel(_x883) {
                    return _controlbarlabel10.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel10.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                "stop()": function (_stop6) {
                  function stop(_x884) {
                    return _stop6.apply(this, arguments);
                  }
                  stop.toString = function () {
                    return _stop6.toString();
                  };
                  return stop;
                }(function (obj) {
                  with (obj) return stop();
                }),
                "mintimeindicator ? css + '-disabled': ''": function mintimeindicatorCssDisabled(obj) {
                  with (obj) return mintimeindicator ? css + "-disabled" : "";
                },
                "mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip')": function mintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip");
                },
                "hover(mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip'))": function hoverMintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return hover(mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip"));
                },
                "string('stop')": function stringStop(obj) {
                  with (obj) return string("stop");
                },
                skipvisible: function (_skipvisible6) {
                  function skipvisible(_x885) {
                    return _skipvisible6.apply(this, arguments);
                  }
                  skipvisible.toString = function () {
                    return _skipvisible6.toString();
                  };
                  return skipvisible;
                }(function (obj) {
                  with (obj) return skipvisible;
                }),
                "skip()": function (_skip10) {
                  function skip(_x886) {
                    return _skip10.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip10.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "hover(string('skip-tooltip'))": function hoverStringSkipTooltip(obj) {
                  with (obj) return hover(string("skip-tooltip"));
                },
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                },
                uploadcovershotvisible: function (_uploadcovershotvisible6) {
                  function uploadcovershotvisible(_x887) {
                    return _uploadcovershotvisible6.apply(this, arguments);
                  }
                  uploadcovershotvisible.toString = function () {
                    return _uploadcovershotvisible6.toString();
                  };
                  return uploadcovershotvisible;
                }(function (obj) {
                  with (obj) return uploadcovershotvisible;
                }),
                "hover(string('upload-covershot-tooltip'))": function hoverStringUploadCovershotTooltip(obj) {
                  with (obj) return hover(string("upload-covershot-tooltip"));
                },
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                covershot_accept_string: function (_covershot_accept_string8) {
                  function covershot_accept_string(_x888) {
                    return _covershot_accept_string8.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string8.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                css: function (_css53) {
                  function css(_x889) {
                    return _css53.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css53.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                actions: function (_actions9) {
                  function actions(_x890) {
                    return _actions9.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions9.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                },
                csscommon: function (_csscommon36) {
                  function csscommon(_x891) {
                    return _csscommon36.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon36.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                }
              }), Parser.registerFunctions({
                css: function (_css54) {
                  function css(_x892) {
                    return _css54.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css54.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click13) {
                  function click(_x893) {
                    return _click13.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click13.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                "shortMessage ? 'short-message' : 'long-message'": function shortMessageShortMessageLongMessage(obj) {
                  with (obj) return shortMessage ? "short-message" : "long-message";
                },
                'message || ""': function (_message19) {
                  function message(_x894) {
                    return _message19.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message19.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links7) {
                  function links(_x895) {
                    return _links7.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links7.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }), {
                space: {
                  css: "ba-audiorecorder",
                  csstheme: "ba-audiorecorder-theme-space",
                  cssrecorder: "ba-recorder",
                  cssmessage: "ba-audiorecorder",
                  cssloader: "ba-audiorecorder",
                  tmpltopmessage: '<div class="{{css}}-topmessage-container">\n    <div data-selector="recorder-topmessage-block" class=\'{{css}}-topmessage-message\'>\n        {{topmessage}}\n    </div>\n</div>\n',
                  tmplcontrolbar: '<div class="{{csstheme}}-dashboard">\n\n\t<div class="{{css}}-settings-front">\n\n\t\t\n\t\t<div data-selector="recorder-settings" class="{{css}}-settings" ba-show="{{settingsvisible && settingsopen}}">\n\t\t\t<div class="{{css}}-bubble-info">\n\t\t\t\t<ul data-selector="camera-settings" ba-repeat="{{camera :: cameras}}">\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<input tabindex="0"\n\t\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t   type=\'radio\' name=\'camera\' value="{{selectedcamera == camera.id}}"\n\t\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t/>\n\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t<label onclick="{{selectCamera(camera.id)}}" ba-hotkey:space^enter="{{selectCamera(camera.id)}}">\n\t\t\t\t\t\t\t{{camera.label}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<ul data-selector="record-button-icon-cog" ba-repeat="{{microphone :: microphones}}" ba-show="{{audio}}">\n\t\t\t\t\t<li tabindex="0"\n\t\t\t\t\t\tba-hotkey:space^enter="{{selectMicrophone(microphone.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\tonclick="{{selectMicrophone(microphone.id)}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<input type=\'radio\' name=\'microphone\' value="{{selectedmicrophone == microphone.id}}" />\n\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t{{microphone.label}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n\t\t<div class="{{css}}-controlbar-center-section">\n\n\t\t\t<div data-selector="rerecord-primary-button" class="{{css}}-button-container" ba-show="{{rerecordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t\t class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{rerecord()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'rerecord\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div data-selector="cancel-primary-button" class="{{css}}-button-container" ba-show="{{cancelvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t\t class="{{css}}-button-primary" onclick="{{cancel()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'cancel\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-controlbar-left-section" ba-show="{{settingsvisible}}">\n\n            <div class="{{css}}-circle-button" ba-show="{{settingsvisible}}">\n\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{settingsopen=!settingsopen}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="record-button-icon-cog" class="{{css}}-button-inner {{css}}-button-circle-{{settingsopen ? \'selected\' : \'unselected\' }}"\n\t\t\t\t\t onclick="{{settingsopen=!settingsopen}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'settings\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t<i class="{{csscommon}}-icon-cog"></i>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-circle-button" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t<div data-selector="record-button-icon-mic" class="{{css}}-button-inner"\n\t\t\t\t\tonmouseenter="{{hover(string(microphonehealthy ? \'microphonehealthy\' : \'microphoneunhealthy\'))}}"\n\t\t\t\t\tonmouseleave="{{unhover()}}">\n\t\t\t\t\t<i class="{{csscommon}}-icon-mic {{csscommon}}-icon-state-{{microphonehealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-circle-button" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t<div data-selector="record-button-icon-audiocam" class="{{css}}-button-inner"\n\t\t\t\t\tonmouseenter="{{hover(string(camerahealthy ? \'camerahealthy\' : \'cameraunhealthy\'))}}"\n\t\t\t\t\tonmouseleave="{{unhover()}}">\n                    <i class="{{csscommon}}-icon-audiocam {{csscommon}}-icon-state-{{ camerahealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="{{css}}-controlbar-right-section">\n\n\t\t\t<div class="{{css}}-rightbutton-container" ba-show="{{recordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="record-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{record()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'record\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-stop-container" ba-show="{{stopvisible}}">\n\n\t\t\t<div class="{{css}}-timer-container">\n\t\t\t\t<div class="{{css}}-label-container" ba-show="{{controlbarlabel && !rerecordvisible}}">\n\t\t\t\t\t<div data-selector="record-label-block" class="{{css}}-label {{css}}-button-primary">\n\t\t\t\t\t\t{{controlbarlabel}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-stop-button-container">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="stop-primary-button"\n\t\t\t\t\t class="{{css}}-button-primary {{mintimeindicator ? css + \'-disabled\': \'\'}}"\n\t\t\t\t\t title="{{mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\')}}"\n\t\t\t\t\t onclick="{{stop()}}"\n\t\t\t\t\t onmouseenter="{{hover(mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'stop\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-centerbutton-container" ba-show="{{skipvisible}}">\n            <div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="skip-primary-button" class="{{css}}-button-primary"\n                 onclick="{{skip()}}"\n                 onmouseenter="{{hover(string(\'skip-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                {{string(\'skip\')}}\n            </divi>\n        </div>\n\n\n        <div class="{{css}}-rightbutton-container" ba-if="{{uploadcovershotvisible}}">\n            <div data-selector="covershot-primary-button" class="{{css}}-button-primary"\n                 onmouseenter="{{hover(string(\'upload-covershot-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                <input type="file"\n                       class="{{css}}-chooser-file"\n                       style="height:100px"\n                       onchange="{{uploadCovershot(domEvent)}}"\n                       accept="{{covershot_accept_string}}" />\n                <span>\n                    {{string(\'upload-covershot\')}}\n                </span>\n            </div>\n        </div>\n\n\t</div>\n\n</div>\n',
                  tmplchooser: '<div class="{{css}}-chooser-container">\n\n\t<div class="{{css}}-chooser-button-container">\n\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t\t ba-click="{{click_action(action)}}">\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t/>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>',
                  tmplmessage: '<div data-selector="recorder-message-container" class="{{css}}-message-container" ba-click="{{click()}}">\n    <div class="{{css}}-top-inner-message-container {{css}}-{{shortMessage ? \'short-message\' : \'long-message\'}}">\n        <div class="{{css}}-first-inner-message-container">\n            <div class="{{css}}-second-inner-message-container">\n                <div class="{{css}}-third-inner-message-container">\n                    <div class="{{css}}-fourth-inner-message-container">\n                        <div data-selector="recorder-message-block" class=\'{{css}}-message-message\'>\n                            <p>\n                                {{message || ""}}\n                            </p>\n                            <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n                                <li>\n                                    <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                                        {{link.title}}\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n'
                }
              };
            });
          }.call(Scoped), function () {
            var Scoped = this.subScope();
            Scoped.binding("browser", "root:BetaJS.Browser"), Scoped.binding("dynamics", "root:BetaJS.Dynamics"), Scoped.binding("module", "root:BetaJS.MediaComponents"), Scoped.extend("module:Assets.playerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                csstheme: function (_csstheme19) {
                  function csstheme(_x896) {
                    return _csstheme19.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme19.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                "activitydelta > hidebarafter && hideoninactivity ? (cssplayer + '-dashboard-hidden') : ''": function activitydeltaHidebarafterHideoninactivityCssplayerDashboardHidden(obj) {
                  with (obj) return activitydelta > hidebarafter && hideoninactivity ? cssplayer + "-dashboard-hidden" : "";
                },
                "toggle_fullscreen()": function (_toggle_fullscreen9) {
                  function toggle_fullscreen(_x897) {
                    return _toggle_fullscreen9.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen9.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                fullscreen: function (_fullscreen9) {
                  function fullscreen(_x898) {
                    return _fullscreen9.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen9.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-video') : string('fullscreen-video')": function fullscreenedStringExitFullscreenVideoStringFullscreenVideo(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-video") : string("fullscreen-video");
                },
                csscommon: function (_csscommon37) {
                  function csscommon(_x899) {
                    return _csscommon37.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon37.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "fullscreened ? 'small' : 'full'": function fullscreenedSmallFull(obj) {
                  with (obj) return fullscreened ? "small" : "full";
                },
                "toggle_volume()": function (_toggle_volume9) {
                  function toggle_volume(_x900) {
                    return _toggle_volume9.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume9.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                },
                "!hidevolumebar": function (_hidevolumebar6) {
                  function hidevolumebar(_x901) {
                    return _hidevolumebar6.apply(this, arguments);
                  }
                  hidevolumebar.toString = function () {
                    return _hidevolumebar6.toString();
                  };
                  return hidevolumebar;
                }(function (obj) {
                  with (obj) return !hidevolumebar;
                }),
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "startUpdateVolume(domEvent)": function startUpdateVolumeDomEvent(obj) {
                  with (obj) return startUpdateVolume(domEvent);
                },
                "progressUpdateVolume(domEvent)": function progressUpdateVolumeDomEvent(obj) {
                  with (obj) return progressUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent); this.blur()": function stopUpdateVolumeDomEventThisBlur(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent)": function stopUpdateVolumeDomEvent(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + '%'}": function widthMathCeil1MathMin99MathRoundVolume100(obj) {
                  with (obj) return {
                    width: Math.ceil(1 + Math.min(99, Math.round(100 * volume))) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                title: function (_title16) {
                  function title(_x902) {
                    return _title16.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title16.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit17) {
                  function submit(_x903) {
                    return _submit17.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit17.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable16) {
                  function submittable(_x904) {
                    return _submittable16.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable16.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "skipinitial ? 0 : -1": function skipinitial01(obj) {
                  with (obj) return skipinitial ? 0 : -1;
                },
                "play()": function (_play13) {
                  function play(_x905) {
                    return _play13.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play13.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "!playing": function (_playing19) {
                  function playing(_x906) {
                    return _playing19.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing19.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "string('play-video')": function stringPlayVideo(obj) {
                  with (obj) return string("play-video");
                },
                "pause()": function (_pause13) {
                  function pause(_x907) {
                    return _pause13.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause13.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                playing: function (_playing20) {
                  function playing(_x908) {
                    return _playing20.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing20.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "disablepause ? string('pause-video-disabled') : string('pause-video')": function disablepauseStringPauseVideoDisabledStringPauseVideo(obj) {
                  with (obj) return disablepause ? string("pause-video-disabled") : string("pause-video");
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('video-progress')": function stringVideoProgress(obj) {
                  with (obj) return string("video-progress");
                },
                trimmingmode: function (_trimmingmode10) {
                  function trimmingmode(_x909) {
                    return _trimmingmode10.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode10.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + '%'}": function leftMathRoundDurationTrimstartTrimstartDuration1000(obj) {
                  with (obj) return {
                    left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + "%"
                  };
                },
                "{left: 'auto', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + '%'}": function leftAutoRight100MathRoundDurationTrimendTrimendDuration100100(obj) {
                  with (obj) return {
                    left: "auto",
                    right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + "%"
                  };
                },
                "rerecord()": function (_rerecord24) {
                  function rerecord(_x910) {
                    return _rerecord24.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord24.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable16) {
                  function rerecordable(_x911) {
                    return _rerecordable16.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable16.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-video')": function stringRerecordVideo(obj) {
                  with (obj) return string("rerecord-video");
                },
                "toggle_position_info()": function (_toggle_position_info5) {
                  function toggle_position_info(_x912) {
                    return _toggle_position_info5.apply(this, arguments);
                  }
                  toggle_position_info.toString = function () {
                    return _toggle_position_info5.toString();
                  };
                  return toggle_position_info;
                }(function (obj) {
                  with (obj) return toggle_position_info();
                }),
                "revertposition ? string('remaining-time') : string('elapsed-time')": function revertpositionStringRemainingTimeStringElapsedTime(obj) {
                  with (obj) return revertposition ? string("remaining-time") : string("elapsed-time");
                },
                '(revertposition && duration > 0) ? "-" : ""': function revertpositionDuration0(obj) {
                  with (obj) return revertposition && 0 < duration ? "-" : "";
                },
                "(revertposition && duration > 0) ? formatTime(duration - position) : formatTime(position)": function revertpositionDuration0FormatTimeDurationPositionFormatTimePosition(obj) {
                  with (obj) return revertposition && 0 < duration ? formatTime(duration - position) : formatTime(position);
                },
                "string('total-time')": function stringTotalTime(obj) {
                  with (obj) return string("total-time");
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                "toggle_stream()": function (_toggle_stream5) {
                  function toggle_stream(_x913) {
                    return _toggle_stream5.apply(this, arguments);
                  }
                  toggle_stream.toString = function () {
                    return _toggle_stream5.toString();
                  };
                  return toggle_stream;
                }(function (obj) {
                  with (obj) return toggle_stream();
                }),
                "streams.length > 1 && currentstream": function streamsLength1Currentstream(obj) {
                  with (obj) return 1 < streams.length && currentstream;
                },
                "string('change-resolution')": function stringChangeResolution(obj) {
                  with (obj) return string("change-resolution");
                },
                currentstream_label: function (_currentstream_label5) {
                  function currentstream_label(_x914) {
                    return _currentstream_label5.apply(this, arguments);
                  }
                  currentstream_label.toString = function () {
                    return _currentstream_label5.toString();
                  };
                  return currentstream_label;
                }(function (obj) {
                  with (obj) return currentstream_label;
                }),
                "show_airplay_devices()": function (_show_airplay_devices5) {
                  function show_airplay_devices(_x915) {
                    return _show_airplay_devices5.apply(this, arguments);
                  }
                  show_airplay_devices.toString = function () {
                    return _show_airplay_devices5.toString();
                  };
                  return show_airplay_devices;
                }(function (obj) {
                  with (obj) return show_airplay_devices();
                }),
                cssplayer: function (_cssplayer15) {
                  function cssplayer(_x916) {
                    return _cssplayer15.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer15.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                airplaybuttonvisible: function (_airplaybuttonvisible6) {
                  function airplaybuttonvisible(_x917) {
                    return _airplaybuttonvisible6.apply(this, arguments);
                  }
                  airplaybuttonvisible.toString = function () {
                    return _airplaybuttonvisible6.toString();
                  };
                  return airplaybuttonvisible;
                }(function (obj) {
                  with (obj) return airplaybuttonvisible;
                }),
                castbuttonvisble: function (_castbuttonvisble6) {
                  function castbuttonvisble(_x918) {
                    return _castbuttonvisble6.apply(this, arguments);
                  }
                  castbuttonvisble.toString = function () {
                    return _castbuttonvisble6.toString();
                  };
                  return castbuttonvisble;
                }(function (obj) {
                  with (obj) return castbuttonvisble;
                }),
                "toggle_settings_menu()": function (_toggle_settings_menu5) {
                  function toggle_settings_menu(_x919) {
                    return _toggle_settings_menu5.apply(this, arguments);
                  }
                  toggle_settings_menu.toString = function () {
                    return _toggle_settings_menu5.toString();
                  };
                  return toggle_settings_menu;
                }(function (obj) {
                  with (obj) return toggle_settings_menu();
                }),
                "settingsmenuactive ? 'visible' : 'hidden'": function settingsmenuactiveVisibleHidden(obj) {
                  with (obj) return settingsmenuactive ? "visible" : "hidden";
                },
                settingsmenubutton: function (_settingsmenubutton5) {
                  function settingsmenubutton(_x920) {
                    return _settingsmenubutton5.apply(this, arguments);
                  }
                  settingsmenubutton.toString = function () {
                    return _settingsmenubutton5.toString();
                  };
                  return settingsmenubutton;
                }(function (obj) {
                  with (obj) return settingsmenubutton;
                }),
                "string('settings')": function stringSettings(obj) {
                  with (obj) return string("settings");
                },
                "trim()": function (_trim6) {
                  function trim(_x921) {
                    return _trim6.apply(this, arguments);
                  }
                  trim.toString = function () {
                    return _trim6.toString();
                  };
                  return trim;
                }(function (obj) {
                  with (obj) return trim();
                }),
                "string('trim-video')": function stringTrimVideo(obj) {
                  with (obj) return string("trim-video");
                },
                frameselectionmode: function (_frameselectionmode7) {
                  function frameselectionmode(_x922) {
                    return _frameselectionmode7.apply(this, arguments);
                  }
                  frameselectionmode.toString = function () {
                    return _frameselectionmode7.toString();
                  };
                  return frameselectionmode;
                }(function (obj) {
                  with (obj) return frameselectionmode;
                }),
                "select_frame()": function (_select_frame5) {
                  function select_frame(_x923) {
                    return _select_frame5.apply(this, arguments);
                  }
                  select_frame.toString = function () {
                    return _select_frame5.toString();
                  };
                  return select_frame;
                }(function (obj) {
                  with (obj) return select_frame();
                }),
                "string('select-frame')": function stringSelectFrame(obj) {
                  with (obj) return string("select-frame");
                },
                "toggle_tracks()": function (_toggle_tracks5) {
                  function toggle_tracks(_x924) {
                    return _toggle_tracks5.apply(this, arguments);
                  }
                  toggle_tracks.toString = function () {
                    return _toggle_tracks5.toString();
                  };
                  return toggle_tracks;
                }(function (obj) {
                  with (obj) return toggle_tracks();
                }),
                "(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload": function tracktagsLength0ShowsubtitlebuttonAllowtexttrackupload(obj) {
                  with (obj) return 0 < tracktags.length && showsubtitlebutton || allowtexttrackupload;
                },
                "tracktextvisible ? 'active' : 'inactive'": function tracktextvisibleActiveInactive(obj) {
                  with (obj) return tracktextvisible ? "active" : "inactive";
                },
                "tracktextvisible ? string('close-tracks') : string('show-tracks')": function tracktextvisibleStringCloseTracksStringShowTracks(obj) {
                  with (obj) return tracktextvisible ? string("close-tracks") : string("show-tracks");
                },
                "hover_cc(true)": function hover_ccTrue(obj) {
                  with (obj) return hover_cc(!0);
                },
                "hover_cc(false)": function hover_ccFalse(obj) {
                  with (obj) return hover_cc(!1);
                }
              }), Parser.registerFunctions({
                "play()": function (_play14) {
                  function play(_x925) {
                    return _play14.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play14.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'player-toggle-overlay')": function tab_index_moveDomEventNullPlayerToggleOverlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "player-toggle-overlay");
                },
                cssplayer: function (_cssplayer16) {
                  function cssplayer(_x926) {
                    return _cssplayer16.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer16.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "string('tooltip')": function stringTooltip(obj) {
                  with (obj) return string("tooltip");
                },
                "showduration && (duration != 0 && duration != undefined)": function showdurationDuration0DurationUndefined(obj) {
                  with (obj) return showduration && 0 != duration && duration != undefined;
                },
                css: function (_css55) {
                  function css(_x927) {
                    return _css55.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css55.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "formatTime(duration)": function formatTimeDuration(obj) {
                  with (obj) return formatTime(duration);
                },
                "rerecordable || submittable": function rerecordableSubmittable(obj) {
                  with (obj) return rerecordable || submittable;
                },
                "submittable && !trimmingmode": function submittableTrimmingmode(obj) {
                  with (obj) return submittable && !trimmingmode;
                },
                "submit()": function (_submit18) {
                  function submit(_x928) {
                    return _submit18.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit18.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecordable && !trimmingmode": function rerecordableTrimmingmode(obj) {
                  with (obj) return rerecordable && !trimmingmode;
                },
                "rerecord()": function (_rerecord25) {
                  function rerecord(_x929) {
                    return _rerecord25.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord25.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                trimmingmode: function (_trimmingmode11) {
                  function trimmingmode(_x930) {
                    return _trimmingmode11.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode11.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "string('trim')": function stringTrim(obj) {
                  with (obj) return string("trim");
                },
                "skip()": function (_skip11) {
                  function skip(_x931) {
                    return _skip11.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip11.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                }
              }), {
                minimalist: {
                  css: "ba-videoplayer",
                  csstheme: "ba-player-minimalist-theme",
                  cssplayer: "ba-player",
                  tmplcontrolbar: '<div class="{{csstheme}}-dashboard {{activitydelta > hidebarafter && hideoninactivity ? (cssplayer + \'-dashboard-hidden\') : \'\'}}">\n\n    <div class=\'{{csstheme}}-controlbar-header\'>\n        <div class="{{csstheme}}-controlbar-header-icons-block">\n\n            <div class="{{csstheme}}-right-block">\n\n                <div tabindex="1" data-selector="button-icon-resize-full"\n                     ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n                     onkeydown="{{tab_index_move(domEvent)}}"\n                     class="{{csstheme}}-button-container"\n                     ba-if="{{fullscreen}}" ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-video\') : string(\'fullscreen-video\') }}"\n                >\n                    <div class="{{csstheme}}-button-inner {{csstheme}}-full-screen-btn-inner">\n                        <i class="{{csscommon}}-icon-resize-{{fullscreened ? \'small\' : \'full\'}}"></i>\n                    </div>\n                </div>\n\n                <div tabindex="2" data-selector="button-icon-volume"\n                     ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n                     class="{{csstheme}}-button-container" ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}"\n                >\n                    <div class="{{csstheme}}-button-inner">\n                        <i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n                    </div>\n                </div>\n\n                <div class="{{csstheme}}-volumebar" ba-show="{{!hidevolumebar}}">\n                    <div tabindex="3" data-selector="button-volume-bar"\n                         ba-hotkey:right="{{set_volume(volume + 0.1)}}"\n                         ba-hotkey:left="{{set_volume(volume - 0.1)}}"\n                         onmouseout="this.blur()"\n                         class="{{csstheme}}-volumebar-inner"\n                         ontouchstart="{{startUpdateVolume(domEvent)}}"\n                         ontouchmove="{{progressUpdateVolume(domEvent)}}"\n                         ontouchend="{{stopUpdateVolume(domEvent); this.blur()}};"\n                         onmousedown="{{startUpdateVolume(domEvent)}}"\n                         onmouseup="{{stopUpdateVolume(domEvent)}}"\n                         onmouseleave="{{stopUpdateVolume(domEvent)}}"\n                         onmousemove="{{progressUpdateVolume(domEvent)}}"\n                    >\n                        <div class="{{csstheme}}-volumebar-position" ba-styles="{{{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + \'%\'}}}" title="{{string(\'volume-button\')}}"></div>\n                    </div>\n                </div>\n\n            </div>\n\n        </div>\n\n\n        <div class="{{csstheme}}-controlbar-header-title-block" ba-if="{{title}}">\n            <div class="{{csstheme}}-title"><p>{{title}}</p></div>\n        </div>\n    </div>\n\n    <div class="{{csstheme}}-controlbar-footer">\n\n        <div class="{{csstheme}}-controlbar-top-block">\n\n            <div tabindex="0" data-selector="submit-video-button"\n                 ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 class="{{csstheme}}-button-container" ba-if="{{submittable}}"  ba-click="{{submit()}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    {{string(\'submit-video\')}}\n                </div>\n            </div>\n\n            <div tabindex="{{skipinitial ? 0 : -1}}" data-selector="button-icon-play"\n                 ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n                 onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}"\n                 class="{{csstheme}}-button-container" ba-if="{{!playing}}" ba-click="{{play()}}" title="{{string(\'play-video\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon}}-icon-play"></i>\n                </div>\n            </div>\n\n            <div tabindex="{{skipinitial ? 0 : -1}}" data-selector="button-icon-pause"\n                 ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n                 onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}"\n                 class="{{csstheme}}-button-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n                 ba-if="{{playing}}" ba-click="{{pause()}}" title="{{disablepause ? string(\'pause-video-disabled\') : string(\'pause-video\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i tabindex="0" class="{{csscommon}}-icon-pause"></i>\n                </div>\n            </div>\n\n        </div>\n        <div class="{{csstheme}}-controlbar-middle-block">\n\n            <div class="{{csstheme}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}">\n                <div tabindex="4" data-selector="progress-bar-inner"\n                     ba-hotkey:right="{{seek(position + skipseconds)}}"\n                     ba-hotkey:left="{{seek(position - skipseconds)}}"\n                     onmouseout="this.blur()"\n                     class="{{csstheme}}-progressbar-inner"\n                     ontouchstart="{{startUpdatePosition(domEvent)}}"\n                     onmousedown="{{startUpdatePosition(domEvent)}}"\n                >\n\n                    <div class="{{csstheme}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n                    <div class="{{csstheme}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'video-progress\')}}">\n                        <div class="{{csstheme}}-progressbar-button"></div>\n                    </div>\n                    <div class="{{csstheme}}-progressbar-marker"\n                        data-selector="trim-start-marker"\n                        ba-if="{{trimmingmode}}"\n                        ba-styles="{{{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + \'%\'}}}"\n                    ></div>\n                    <div class="{{csstheme}}-progressbar-marker"\n                        data-selector="trim-end-marker"\n                        ba-if="{{trimmingmode}}"\n                        ba-styles="{{{left: \'auto\', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + \'%\'}}}"\n                    ></div>\n                </div>\n            </div>\n\n        </div>\n        <div class="{{csstheme}}-controlbar-bottom-block">\n            <div tabindex="0" data-selector="button-icon-ccw"\n                 ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 class="{{csstheme}}-button-container {{csstheme}}-player-rerecord"\n                 ba-if="{{rerecordable}}" ba-click="{{rerecord()}}" title="{{string(\'rerecord-video\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon}}-icon-ccw"></i>\n                </div>\n            </div>\n\n            <div class="{{csstheme}}-button-container {{csstheme}}-time-container {{csscommon}}-clickable"\n                 ba-click="{{toggle_position_info()}}"\n            >\n                <div class="{{csstheme}}-time-value"\n                     title="{{revertposition ? string(\'remaining-time\') : string(\'elapsed-time\')}}"\n                >\n                    {{(revertposition && duration > 0) ? "-" : ""}}\n                    {{(revertposition && duration > 0) ? formatTime(duration - position) : formatTime(position)}}\n                </div>\n                <p> / </p>\n                <div class="{{csstheme}}-time-value" title="{{string(\'total-time\')}}">{{formatTime(duration || position)}}</div>\n            </div>\n\n            <div tabindex="5" data-selector="button-stream-label"\n                 ba-hotkey:space^enter="{{toggle_stream()}}" onmouseout="this.blur()"\n                 class="{{csstheme}}-button-container" ba-if="{{streams.length > 1 && currentstream}}"\n                 ba-click="{{toggle_stream()}}" title="{{string(\'change-resolution\')}}"\n            >\n                <div class="{{csstheme}}-button-inner {{csstheme}}-stream-label-container">\n                    <span class="{{csstheme}}-button-text {{csstheme}}-stream-label">{{currentstream_label}}</span>\n                </div>\n            </div>\n            <div tabindex="6" data-selector="button-airplay"\n                 ba-hotkey:space^enter="{{show_airplay_devices()}}" onmouseout="this.blur()"\n                 class="{{csstheme}}-button-container {{cssplayer}}-airplay-container"\n                 ba-show="{{airplaybuttonvisible}}" ba-click="{{show_airplay_devices()}}"\n            >\n                <svg width="16px" height="11px" viewBox="0 0 16 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n                    \n                    <title>Airplay</title>\n                    <desc>Airplay icon.</desc>\n                    <defs></defs>\n                    <g stroke="none" stroke-width="1" fill-rule="evenodd" sketch:type="MSPage">\n                        <path d="M4,11 L12,11 L8,7 L4,11 Z M14.5454545,0 L1.45454545,0 C0.654545455,0 0,0.5625 0,1.25 L0,8.75 C0,9.4375 0.654545455,10 1.45454545,10 L4.36363636,10 L4.36363636,8.75 L1.45454545,8.75 L1.45454545,1.25 L14.5454545,1.25 L14.5454545,8.75 L11.6363636,8.75 L11.6363636,10 L14.5454545,10 C15.3454545,10 16,9.4375 16,8.75 L16,1.25 C16,0.5625 15.3454545,0 14.5454545,0 L14.5454545,0 Z" sketch:type="MSShapeGroup"></path>\n                    </g>\n                </svg>\n            </div>\n\n            <div tabindex="7" data-selector="button-chromecast" onmouseout="this.blur()" class="{{csstheme}}-button-container {{csstheme}}-cast-button-container" ba-show="{{castbuttonvisble}}">\n                <button class="{{csstheme}}-gcast-button" is="google-cast-button"></button>\n            </div>\n\n            <div tabindex="10" data-selector="button-icon-settings"\n                 ba-hotkey:space^enter="{{toggle_settings_menu()}}" onmouseout="this.blur()"\n                 class="{{csstheme}}-right-button-container {{cssplayer}}-settings-{{settingsmenuactive ? \'visible\' : \'hidden\'}}"\n                 ba-if="{{settingsmenubutton}}" ba-click="{{toggle_settings_menu()}}"\n                 title="{{string(\'settings\')}}"\n                 onkeydown="{{tab_index_move(domEvent)}}"\n            >\n                <div class="{{csstheme}}-settings-button">\n                    <i class="{{csscommon}}-icon-cog"></i>\n                </div>\n            </div>\n\n            <div tabindex="9" class="{{csstheme}}-primary-button-container {{csstheme}}-right-button-container" ba-if="{{trimmingmode}}">\n                <div data-selector="trim-button"\n                     onmouseout="this.blur()"\n                     ba-click="{{trim()}}"\n                     class="{{csstheme}}-primary-button {{csstheme}}-button-inner">\n                     {{string(\'trim-video\')}}\n                </div>\n            </div>\n\n            <div tabindex="9" class="{{csstheme}}-primary-button-container {{csstheme}}-right-button-container" ba-if="{{frameselectionmode}}">\n                <div data-selector="select-frame-button"\n                     onmouseout="this.blur()"\n                     ba-click="{{select_frame()}}"\n                     class="{{csstheme}}-primary-button {{csstheme}}-button-inner">\n                     {{string(\'select-frame\')}}\n                </div>\n            </div>\n\n            <div tabindex="8" data-selector="cc-button-container"\n                 ba-hotkey:space^enter="{{toggle_tracks()}}" onmouseout="this.blur()"\n                 ba-if="{{(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload}}"\n                 ba-click="{{toggle_tracks()}}"\n                 class="{{csstheme}}-right-button-container {{cssplayer}}-button-{{tracktextvisible ? \'active\' : \'inactive\'}}"\n                 title="{{ tracktextvisible ? string(\'close-tracks\') : string(\'show-tracks\')}}"\n                 onmouseover="{{hover_cc(true)}}" onmouseleave="{{hover_cc(false)}}"\n            >\n                <div class="{{csstheme}}-subtitle-button-inner">\n                    <i class="{{csscommon}}-icon-subtitle"></i>\n                </div>\n            </div>\n\n\n        </div>\n    </div>\n\n</div>\n',
                  tmplplaybutton: '\n<div tabindex="0" data-selector="play-button"\n     ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n     onkeydown="{{tab_index_move(domEvent, null, \'player-toggle-overlay\')}}"\n     class="{{cssplayer}}-playbutton-container" ba-click="{{play()}}" title="{{string(\'tooltip\')}}"\n>\n\t<div class="{{cssplayer}}-playbutton-button"></div>\n</div>\n<div ba-show="{{showduration && (duration != 0 && duration != undefined)}}" class="{{css}}-playbutton-duration">\n    {{formatTime(duration)}}\n</div>\n\n<div class="{{cssplayer}}-rerecord-bar" ba-if="{{rerecordable || submittable}}">\n\t<div class="{{cssplayer}}-rerecord-backbar"></div>\n\t<div class="{{cssplayer}}-rerecord-frontbar">\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{submittable && !trimmingmode}}">\n            <div tabindex="0" data-selector="player-submit-button"\n                 ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{submit()}}">\n                {{string(\'submit-video\')}}\n            </div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{rerecordable && !trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-rerecord-button"\n                 ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{rerecord()}}">\n        \t\t{{string(\'rerecord\')}}\n        \t</div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-trim-button"\n                 ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{play()}}">\n        \t\t{{string(\'trim\')}}\n        \t</div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-skip-button"\n                 ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{skip()}}">\n        \t\t{{string(\'skip\')}}\n        \t</div>\n        </div>\n\t</div>\n</div>\n',
                  cssloader: ie8 ? "ba-videoplayer" : "",
                  cssmessage: "ba-videoplayer",
                  cssplaybutton: ie8 ? "ba-videoplayer" : ""
                }
              };
            }), Scoped.extend("module:Assets.recorderthemes", ["dynamics:Parser"], function (Parser) {
              return Parser.registerFunctions({
                css: function (_css56) {
                  function css(_x932) {
                    return _css56.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css56.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                topmessage: function (_topmessage9) {
                  function topmessage(_x933) {
                    return _topmessage9.apply(this, arguments);
                  }
                  topmessage.toString = function () {
                    return _topmessage9.toString();
                  };
                  return topmessage;
                }(function (obj) {
                  with (obj) return topmessage;
                })
              }), Parser.registerFunctions({
                csstheme: function (_csstheme20) {
                  function csstheme(_x934) {
                    return _csstheme20.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme20.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                css: function (_css57) {
                  function css(_x935) {
                    return _css57.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css57.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "stopvisible && recordingindication": function stopvisibleRecordingindication(obj) {
                  with (obj) return stopvisible && recordingindication;
                },
                settingsvisible: function (_settingsvisible11) {
                  function settingsvisible(_x936) {
                    return _settingsvisible11.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible11.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                ismobile: function (_ismobile3) {
                  function ismobile(_x937) {
                    return _ismobile3.apply(this, arguments);
                  }
                  ismobile.toString = function () {
                    return _ismobile3.toString();
                  };
                  return ismobile;
                }(function (obj) {
                  with (obj) return ismobile;
                }),
                "toggleFaceMode()": function (_toggleFaceMode4) {
                  function toggleFaceMode(_x938) {
                    return _toggleFaceMode4.apply(this, arguments);
                  }
                  toggleFaceMode.toString = function () {
                    return _toggleFaceMode4.toString();
                  };
                  return toggleFaceMode;
                }(function (obj) {
                  with (obj) return toggleFaceMode();
                }),
                "hover(string('switch-camera'))": function hoverStringSwitchCamera(obj) {
                  with (obj) return hover(string("switch-camera"));
                },
                csscommon: function (_csscommon38) {
                  function csscommon(_x939) {
                    return _csscommon38.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon38.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                settingsopen: function (_settingsopen) {
                  function settingsopen(_x940) {
                    return _settingsopen.apply(this, arguments);
                  }
                  settingsopen.toString = function () {
                    return _settingsopen.toString();
                  };
                  return settingsopen;
                }(function (obj) {
                  with (obj) return settingsopen;
                }),
                videoselectnotification: function (_videoselectnotification4) {
                  function videoselectnotification(_x941) {
                    return _videoselectnotification4.apply(this, arguments);
                  }
                  videoselectnotification.toString = function () {
                    return _videoselectnotification4.toString();
                  };
                  return videoselectnotification;
                }(function (obj) {
                  with (obj) return videoselectnotification;
                }),
                "string('add-stream')": function stringAddStream(obj) {
                  with (obj) return string("add-stream");
                },
                "showaddstreambutton && firefox && allowscreen": function showaddstreambuttonFirefoxAllowscreen(obj) {
                  with (obj) return showaddstreambutton && firefox && allowscreen;
                },
                "addNewStream()": function (_addNewStream4) {
                  function addNewStream(_x942) {
                    return _addNewStream4.apply(this, arguments);
                  }
                  addNewStream.toString = function () {
                    return _addNewStream4.toString();
                  };
                  return addNewStream;
                }(function (obj) {
                  with (obj) return addNewStream();
                }),
                "hover(string('add-stream'))": function hoverStringAddStream(obj) {
                  with (obj) return hover(string("add-stream"));
                },
                "showaddstreambutton && !firefox": function showaddstreambuttonFirefox(obj) {
                  with (obj) return showaddstreambutton && !firefox;
                },
                cameras: function (_cameras9) {
                  function cameras(_x943) {
                    return _cameras9.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras9.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "(camera.id !== selectedcamera) || allowscreen": function cameraIdSelectedcameraAllowscreen(obj) {
                  with (obj) return camera.id !== selectedcamera || allowscreen;
                },
                "addNewStream(camera.id)": function addNewStreamCameraId(obj) {
                  with (obj) return addNewStream(camera.id);
                },
                "camera.label": function cameraLabel(obj) {
                  with (obj) return camera.label;
                },
                "(showaddstreambutton && !firefox) || (firefox && allowscreen)": function showaddstreambuttonFirefoxFirefoxAllowscreen(obj) {
                  with (obj) return showaddstreambutton && !firefox || firefox && allowscreen;
                },
                "!novideo && !allowscreen && !ismobile": function novideoAllowscreenIsmobile(obj) {
                  with (obj) return !novideo && !allowscreen && !ismobile;
                },
                "hover(string('select-camera'))": function hoverStringSelectCamera(obj) {
                  with (obj) return hover(string("select-camera"));
                },
                "selectedcamera == camera.id": function selectedcameraCameraId(obj) {
                  with (obj) return selectedcamera == camera.id;
                },
                "selectCamera(camera.id)": function selectCameraCameraId(obj) {
                  with (obj) return selectCamera(camera.id);
                },
                "(!noaudio && !novideo) || !allowscreen": function noaudioNovideoAllowscreen(obj) {
                  with (obj) return !noaudio && !novideo || !allowscreen;
                },
                microphones: function (_microphones9) {
                  function microphones(_x944) {
                    return _microphones9.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones9.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                "!noaudio && !allowscreen": function noaudioAllowscreen(obj) {
                  with (obj) return !noaudio && !allowscreen;
                },
                "selectMicrophone(microphone.id)": function selectMicrophoneMicrophoneId(obj) {
                  with (obj) return selectMicrophone(microphone.id);
                },
                "hover(string('select-audio-input'))": function hoverStringSelectAudioInput(obj) {
                  with (obj) return hover(string("select-audio-input"));
                },
                "selectedmicrophone == microphone.id": function selectedmicrophoneMicrophoneId(obj) {
                  with (obj) return selectedmicrophone == microphone.id;
                },
                "microphone.label": function microphoneLabel(obj) {
                  with (obj) return microphone.label;
                },
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                "unhover()": function (_unhover8) {
                  function unhover(_x945) {
                    return _unhover8.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover8.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                "hover(string(microphonehealthy ? 'microphonehealthy' : 'microphoneunhealthy'))": function hoverStringMicrophonehealthyMicrophonehealthyMicrophoneunhealthy(obj) {
                  with (obj) return hover(string(microphonehealthy ? "microphonehealthy" : "microphoneunhealthy"));
                },
                "microphonehealthy ? 'good' : 'bad'": function microphonehealthyGoodBad(obj) {
                  with (obj) return microphonehealthy ? "good" : "bad";
                },
                "!novideo && !allowscreen": function novideoAllowscreen(obj) {
                  with (obj) return !novideo && !allowscreen;
                },
                "hover(string(camerahealthy ? 'camerahealthy' : 'cameraunhealthy'))": function hoverStringCamerahealthyCamerahealthyCameraunhealthy(obj) {
                  with (obj) return hover(string(camerahealthy ? "camerahealthy" : "cameraunhealthy"));
                },
                "camerahealthy ? 'good' : 'bad'": function camerahealthyGoodBad(obj) {
                  with (obj) return camerahealthy ? "good" : "bad";
                },
                stopvisible: function (_stopvisible9) {
                  function stopvisible(_x946) {
                    return _stopvisible9.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible9.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                controlbarlabel: function (_controlbarlabel11) {
                  function controlbarlabel(_x947) {
                    return _controlbarlabel11.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel11.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                rerecordvisible: function (_rerecordvisible11) {
                  function rerecordvisible(_x948) {
                    return _rerecordvisible11.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible11.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord26) {
                  function rerecord(_x949) {
                    return _rerecord26.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord26.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible8) {
                  function cancelvisible(_x950) {
                    return _cancelvisible8.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible8.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel8) {
                  function cancel(_x951) {
                    return _cancel8.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel8.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                },
                recordvisible: function (_recordvisible11) {
                  function recordvisible(_x952) {
                    return _recordvisible11.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible11.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record8) {
                  function record(_x953) {
                    return _record8.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record8.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                "stop()": function (_stop7) {
                  function stop(_x954) {
                    return _stop7.apply(this, arguments);
                  }
                  stop.toString = function () {
                    return _stop7.toString();
                  };
                  return stop;
                }(function (obj) {
                  with (obj) return stop();
                }),
                "mintimeindicator ? css + '-disabled': ''": function mintimeindicatorCssDisabled(obj) {
                  with (obj) return mintimeindicator ? css + "-disabled" : "";
                },
                "mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip')": function mintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip");
                },
                "hover(mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip'))": function hoverMintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return hover(mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip"));
                },
                "string('stop')": function stringStop(obj) {
                  with (obj) return string("stop");
                },
                "pausable && !resumevisible": function pausableResumevisible(obj) {
                  with (obj) return pausable && !resumevisible;
                },
                "string('pause-recorder')": function stringPauseRecorder(obj) {
                  with (obj) return string("pause-recorder");
                },
                "pause()": function (_pause14) {
                  function pause(_x955) {
                    return _pause14.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause14.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "hover(string('pause-recorder'))": function hoverStringPauseRecorder(obj) {
                  with (obj) return hover(string("pause-recorder"));
                },
                "pausable && resumevisible": function pausableResumevisible(obj) {
                  with (obj) return pausable && resumevisible;
                },
                "resume()": function (_resume5) {
                  function resume(_x956) {
                    return _resume5.apply(this, arguments);
                  }
                  resume.toString = function () {
                    return _resume5.toString();
                  };
                  return resume;
                }(function (obj) {
                  with (obj) return resume();
                }),
                "string('resume-recorder')": function stringResumeRecorder(obj) {
                  with (obj) return string("resume-recorder");
                },
                "hover(string('resume-recorder'))": function hoverStringResumeRecorder(obj) {
                  with (obj) return hover(string("resume-recorder"));
                },
                skipvisible: function (_skipvisible7) {
                  function skipvisible(_x957) {
                    return _skipvisible7.apply(this, arguments);
                  }
                  skipvisible.toString = function () {
                    return _skipvisible7.toString();
                  };
                  return skipvisible;
                }(function (obj) {
                  with (obj) return skipvisible;
                }),
                "skip()": function (_skip12) {
                  function skip(_x958) {
                    return _skip12.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip12.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "hover(string('skip-tooltip'))": function hoverStringSkipTooltip(obj) {
                  with (obj) return hover(string("skip-tooltip"));
                },
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                },
                uploadcovershotvisible: function (_uploadcovershotvisible7) {
                  function uploadcovershotvisible(_x959) {
                    return _uploadcovershotvisible7.apply(this, arguments);
                  }
                  uploadcovershotvisible.toString = function () {
                    return _uploadcovershotvisible7.toString();
                  };
                  return uploadcovershotvisible;
                }(function (obj) {
                  with (obj) return uploadcovershotvisible;
                }),
                "hover(string('upload-covershot-tooltip'))": function hoverStringUploadCovershotTooltip(obj) {
                  with (obj) return hover(string("upload-covershot-tooltip"));
                },
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                covershot_accept_string: function (_covershot_accept_string9) {
                  function covershot_accept_string(_x960) {
                    return _covershot_accept_string9.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string9.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                showslidercontainer: function (_showslidercontainer7) {
                  function showslidercontainer(_x961) {
                    return _showslidercontainer7.apply(this, arguments);
                  }
                  showslidercontainer.toString = function () {
                    return _showslidercontainer7.toString();
                  };
                  return showslidercontainer;
                }(function (obj) {
                  with (obj) return showslidercontainer;
                }),
                css: function (_css58) {
                  function css(_x962) {
                    return _css58.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css58.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "left()": function (_left4) {
                  function left(_x963) {
                    return _left4.apply(this, arguments);
                  }
                  left.toString = function () {
                    return _left4.toString();
                  };
                  return left;
                }(function (obj) {
                  with (obj) return left();
                }),
                csscommon: function (_csscommon39) {
                  function csscommon(_x964) {
                    return _csscommon39.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon39.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                images: function (_images4) {
                  function images(_x965) {
                    return _images4.apply(this, arguments);
                  }
                  images.toString = function () {
                    return _images4.toString();
                  };
                  return images;
                }(function (obj) {
                  with (obj) return images;
                }),
                "select(image)": function selectImage(obj) {
                  with (obj) return select(image);
                },
                "{left: image.left + 'px', top: image.top + 'px', width: image.width + 'px', height: image.height + 'px'}": function leftImageLeftPxTopImageTopPxWidthImageWidthPxHeightImageHeightPx(obj) {
                  with (obj) return {
                    left: image.left + "px",
                    top: image.top + "px",
                    width: image.width + "px",
                    height: image.height + "px"
                  };
                },
                "right()": function (_right4) {
                  function right(_x966) {
                    return _right4.apply(this, arguments);
                  }
                  right.toString = function () {
                    return _right4.toString();
                  };
                  return right;
                }(function (obj) {
                  with (obj) return right();
                }),
                "!showslidercontainer": function (_showslidercontainer8) {
                  function showslidercontainer(_x967) {
                    return _showslidercontainer8.apply(this, arguments);
                  }
                  showslidercontainer.toString = function () {
                    return _showslidercontainer8.toString();
                  };
                  return showslidercontainer;
                }(function (obj) {
                  with (obj) return !showslidercontainer;
                }),
                covershot_accept_string: function (_covershot_accept_string10) {
                  function covershot_accept_string(_x968) {
                    return _covershot_accept_string10.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string10.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                css: function (_css59) {
                  function css(_x969) {
                    return _css59.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css59.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "initialmessages.length > 0": function initialmessagesLength0(obj) {
                  with (obj) return 0 < initialmessages.length;
                },
                csscommon: function (_csscommon40) {
                  function csscommon(_x970) {
                    return _csscommon40.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon40.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                initialmessages: function (_initialmessages6) {
                  function initialmessages(_x971) {
                    return _initialmessages6.apply(this, arguments);
                  }
                  initialmessages.toString = function () {
                    return _initialmessages6.toString();
                  };
                  return initialmessages;
                }(function (obj) {
                  with (obj) return initialmessages;
                }),
                "initialmessage.message": function initialmessageMessage(obj) {
                  with (obj) return initialmessage.message;
                },
                "initialmessage.type ? initialmessage.type : 'default'": function initialmessageTypeInitialmessageTypeDefault(obj) {
                  with (obj) return initialmessage.type ? initialmessage.type : "default";
                },
                "initialmessage.id": function initialmessageId(obj) {
                  with (obj) return initialmessage.id;
                },
                actions: function (_actions10) {
                  function actions(_x972) {
                    return _actions10.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions10.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.switchcamera": function actionSwitchcamera(obj) {
                  with (obj) return action.switchcamera;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                },
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                }
              }), Parser.registerFunctions({
                cssrecorder: function (_cssrecorder9) {
                  function cssrecorder(_x973) {
                    return _cssrecorder9.apply(this, arguments);
                  }
                  cssrecorder.toString = function () {
                    return _cssrecorder9.toString();
                  };
                  return cssrecorder;
                }(function (obj) {
                  with (obj) return cssrecorder;
                }),
                "click()": function (_click14) {
                  function click(_x974) {
                    return _click14.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click14.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                "shortMessage ? 'short-message' : 'long-message'": function shortMessageShortMessageLongMessage(obj) {
                  with (obj) return shortMessage ? "short-message" : "long-message";
                },
                'message || ""': function (_message20) {
                  function message(_x975) {
                    return _message20.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message20.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links8) {
                  function links(_x976) {
                    return _links8.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links8.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }), {
                minimalist: {
                  css: "ba-videorecorder",
                  csstheme: "ba-recorder-theme-minimalist",
                  cssrecorder: "ba-recorder",
                  cssmessage: "ba-videorecorder",
                  cssloader: "ba-videorecorder",
                  tmpltopmessage: '<div data-selector="recorder-topmessage-block" class="{{css}}-topmessage-container">\n    <div class=\'{{css}}-topmessage-message\'>\n        {{topmessage}}\n    </div>\n</div>',
                  tmplcontrolbar: '<div class="{{csstheme}}-dashboard">\n\n\t\n\t<div class="{{css}}-settings-left-sidebar">\n\n\t\t<div class="{{css}}-controlbar-left-section">\n\n\t\t\t<div class="{{css}}-indicator-container" ba-show="{{stopvisible && recordingindication}}">\n\t\t\t\t<div data-selector="recording-indicator" class="{{css}}-recording-indication"></div>\n\t\t\t</div>\n\n            <div ba-show="{{settingsvisible}}">\n\n\t\t\t\t\n\t\t\t\t<div data-selector="recorder-settings" class="{{css}}-settings {{css}}-settings-button-container">\n\n\t\t\t\t\t<div class="{{css}}-circle-button" ba-show="{{ismobile}}">\n\t\t\t\t\t\t<div data-selector="face-mode-toggle-icon"\n\t\t\t\t\t\t\t class="{{css}}-mobile-camera-switcher {{css}}-button-inner {{css}}-button-circle-unselected"\n\t\t\t\t\t\t\t onclick="{{toggleFaceMode()}}"\n\t\t\t\t\t\t\t onmouseenter="{{hover(string(\'switch-camera\'))}}"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-arrows-cw"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div data-selector="settings-list-front" class="{{css}}-circle-button" ba-show="{{settingsvisible}}">\n\n\t\t\t\t\t\t<div class="{{css}}-bubble-info-container" ba-show="{{settingsopen}}">\n\t\t\t\t\t\t\t<div class="{{css}}-bubble-info">\n\t\t\t\t\t\t\t\t<ul data-selector="add-new-stream" ba-if="{{videoselectnotification}}">\n\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t<div data-selector="single-camera-stream">\n\t\t\t\t\t\t\t\t\t\t\t<i class="ba-commoncss-icon-plus"></i> {{string(\'add-stream\')}}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t<div data-selector="single-camera-stream" class="{{csscommon}}-text-error">\n\t\t\t\t\t\t\t\t\t\t\t{{videoselectnotification}}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t\t\t\t<ul data-selector="add-new-stream" ba-show="{{showaddstreambutton && firefox && allowscreen}}">\n\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t<div data-selector="single-camera-stream"\n\t\t\t\t\t\t\t\t\t\t\t class="{{css}}-add-stream"\n\t\t\t\t\t\t\t\t\t\t\t onclick="{{addNewStream()}}"\n\t\t\t\t\t\t\t\t\t\t\t onmouseenter="{{hover(string(\'add-stream\'))}}"\n\t\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-plus"></i> {{string(\'add-stream\')}}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t\t\t\t<ul data-selector="add-new-stream" ba-show="{{showaddstreambutton && !firefox}}" ba-repeat="{{camera :: cameras}}">\n\t\t\t\t\t\t\t\t\t<li ba-show="{{(camera.id !== selectedcamera) || allowscreen}}">\n\t\t\t\t\t\t\t\t\t\t<div data-selector="single-camera-stream"\n\t\t\t\t\t\t\t\t\t\t\t class="{{css}}-add-stream"\n\t\t\t\t\t\t\t\t\t\t\t onclick="{{addNewStream(camera.id)}}"\n\t\t\t\t\t\t\t\t\t\t\t onmouseenter="{{hover(string(\'add-stream\'))}}"\n\t\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-plus"></i> {{camera.label}}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</li>\n\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t<hr ba-show="{{(showaddstreambutton && !firefox) || (firefox && allowscreen)}}"/>\n\n\t\t\t\t\t\t\t\t<ul data-selector="camera-settings" ba-repeat="{{camera :: cameras}}" ba-show="{{!novideo && !allowscreen && !ismobile}}">\n\t\t\t\t\t\t\t\t\t<li onmouseenter="{{hover(string(\'select-camera\'))}}">\n\t\t\t\t\t\t\t\t\t\t<input tabindex="0" onmouseout="this.blur()"\n\t\t\t\t\t\t\t\t\t\t\t   type=\'radio\' name=\'camera\' value="{{selectedcamera == camera.id}}" onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t\t\t\t\t<label tabindex="0" onmouseout="this.blur()" onclick="{{selectCamera(camera.id)}}">\n\t\t\t\t\t\t\t\t\t\t\t{{camera.label}}\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t<hr ba-show="{{(!noaudio && !novideo) || !allowscreen}}"/>\n\t\t\t\t\t\t\t\t<ul data-selector="microphone-settings" ba-repeat="{{microphone :: microphones}}" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t\t\t\t\t\t<li tabindex="0"\n\t\t\t\t\t\t\t\t\t\tba-hotkey:space^enter="{{selectMicrophone(microphone.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t\t\t\tonmouseenter="{{hover(string(\'select-audio-input\'))}}"\n\t\t\t\t\t\t\t\t\t\tonclick="{{selectMicrophone(microphone.id)}}"\n\t\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t\t<input type=\'radio\' name=\'microphone\' value="{{selectedmicrophone == microphone.id}}" />\n\t\t\t\t\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t\t{{microphone.label}}\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div tabindex="0"\n\t\t\t\t\t\t\t ba-hotkey:space^enter="{{settingsopen=!settingsopen}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t data-selector="record-button-icon-cog"\n\t\t\t\t\t\t\t class="{{css}}-button-inner {{css}}-button-circle-{{settingsopen ? \'selected\' : \'unselected\' }}"\n\t\t\t\t\t\t\t onclick="{{settingsopen=!settingsopen}}"\n\t\t\t\t\t\t\t onmouseenter="{{hover(string(\'settings\'))}}"\n\t\t\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-cog"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="{{css}}-circle-button" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t\t\t<div data-selector="record-button-icon-mic" class="{{css}}-button-inner"\n\t\t\t\t\t\t\t onmouseenter="{{hover(string(microphonehealthy ? \'microphonehealthy\' : \'microphoneunhealthy\'))}}"\n\t\t\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-mic {{csscommon}}-icon-state-{{microphonehealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="{{css}}-circle-button" ba-show="{{!novideo && !allowscreen}}">\n\t\t\t\t\t\t<div data-selector="record-button-icon-videocam" class="{{css}}-button-inner"\n\t\t\t\t\t\t\t onmouseenter="{{hover(string(camerahealthy ? \'camerahealthy\' : \'cameraunhealthy\'))}}"\n\t\t\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-videocam {{csscommon}}-icon-state-{{ camerahealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t<div class="{{css}}-controlbar-middle-section">\n\n\t\t<div class="{{css}}-timer-container" ba-show="{{stopvisible}}">\n\t\t\t<div class="{{css}}-label-container" ba-show="{{controlbarlabel}}">\n\t\t\t\t<div data-selector="record-label-block" class="{{css}}-label {{css}}-button-primary">\n\t\t\t\t\t{{controlbarlabel}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n\t\t<div class="{{css}}-controlbar-center-section">\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{rerecordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="rerecord-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{rerecord()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'rerecord\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{cancelvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="cancel-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{cancel()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'cancel\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-primary-button-container" ba-show="{{recordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="record-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{record()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'record\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-stop-container" ba-show="{{stopvisible}}">\n\n\t\t\t<div class="{{css}}-stop-button-container">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="stop-primary-button" class="{{css}}-button-primary {{mintimeindicator ? css + \'-disabled\': \'\'}}"\n\t\t\t\t\t title="{{mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\')}}"\n\t\t\t\t\t onclick="{{stop()}}"\n\t\t\t\t\t onmouseenter="{{hover(mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'stop\')}}\n\t\t\t\t</div>\n\t\t\t\t<div tabindex="0" data-selector="pause-primary-button"  ba-show="{{pausable && !resumevisible}}"\n\t\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="pause-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t title="{{string(\'pause-recorder\')}}"\n\t\t\t\t\t onclick="{{pause()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'pause-recorder\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t<i class="{{csscommon}}-icon-pause"></i>\n\t\t\t\t</div>\n\n\t\t\t\t<div tabindex="0" data-selector="resume-primary-button"  ba-show="{{pausable && resumevisible}}"\n\t\t\t\t\t ba-hotkey:space^enter="{{resume()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="resume-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t title="{{string(\'resume-recorder\')}}"\n\t\t\t\t\t onclick="{{resume()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'resume-recorder\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t<i class="{{csscommon}}-icon-ccw"></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-centerbutton-container" ba-show="{{skipvisible}}">\n            <div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="skip-primary-button" class="{{css}}-button-primary"\n                 onclick="{{skip()}}"\n                 onmouseenter="{{hover(string(\'skip-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                {{string(\'skip\')}}\n            </div>\n        </div>\n\n\n        <div class="{{css}}-rightbutton-container" ba-if="{{uploadcovershotvisible}}">\n            <div data-selector="covershot-primary-button" class="{{css}}-button-primary"\n                 onmouseenter="{{hover(string(\'upload-covershot-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                <input type="file"\n                       class="{{css}}-chooser-file"\n                       style="height:100px"\n                       onchange="{{uploadCovershot(domEvent)}}"\n                       accept="{{covershot_accept_string}}" />\n                <span>\n                    {{string(\'upload-covershot\')}}\n                </span>\n            </div>\n        </div>\n\n\t</div>\n\n</div>\n',
                  tmplimagegallery: '<div ba-if="{{showslidercontainer}}" data-selector="image-gallery" class="{{css}}-image-gallery-container">\n\t<div data-selector="slider-left-button" class="{{css}}-imagegallery-leftbutton">\n\t\t<div tabindex="0" data-selector="slider-left-inner-button"\n\t\t\t ba-hotkey:space^enter^left="{{left()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-button-inner" onclick="{{left()}}"\n\t\t>\n\t\t\t<i class="{{csscommon}}-icon-left-open"></i>\n\t\t</div>\n\t</div>\n\n\t<div data-selector="images-imagegallery-container" ba-repeat="{{image::images}}" class="{{css}}-imagegallery-container" data-gallery-container>\n\t\t<div tabindex="0" data-selector="imagegallery-selected-image"\n\t\t\t ba-hotkey:space^enter="{{select(image)}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-image"\n\t\t\t ba-styles="{{{left: image.left + \'px\', top: image.top + \'px\', width: image.width + \'px\', height: image.height + \'px\'}}}"\n\t\t\t onclick="{{select(image)}}"\n\t\t>\n\t\t</div>\n\t</div>\n\n\t<div data-selector="slider-right-button" class="{{css}}-imagegallery-rightbutton">\n\t\t<div tabindex="0" data-selector="slider-right-inner-button"\n\t\t\t ba-hotkey:space^enter^right="{{right()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-button-inner"\n\t\t\t onclick="{{right()}}"\n\t\t>\n\t\t\t<i class="{{csscommon}}-icon-right-open"></i>\n\t\t</div>\n\t</div>\n</div>\n\n<div ba-if="{{!showslidercontainer}}" class="{{css}}-chooser-container">\n\t<div data-selector="covershot-primary-button" class="{{css}}-chooser-button-container">\n\t\t<div class="{{css}}-chooser-button-0">\n\t\t\t<input type="file"\n\t\t\t\t   tabindex="0"\n\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t   accept="{{covershot_accept_string}}"\n\t\t\t\t   onchange="{{uploadCovershot(domEvent)}}"\n\t\t\t/>\n\t\t\t<i class="{{csscommon}}-icon-picture"></i>\n\t\t\t<span>\n\t\t\t{{string(\'upload-covershot\')}}\n\t\t</span>\n\t\t</div>\n\t</div>\n</div>\n',
                  tmplchooser: '<div class="{{css}}-chooser-container">\n\t<div ba-if="{{initialmessages.length > 0}}" class="{{csscommon}}-message-container">\n\t\t<ul ba-repeat="{{initialmessage :: initialmessages}}">\n\t\t\t<li ba-if="{{initialmessage.message}}"\n\t\t\t\tclass="{{csscommon}}-message-text {{csscommon}}-message-{{initialmessage.type ? initialmessage.type : \'default\'}}"\n\t\t\t>\n\t\t\t\t{{ initialmessage.message }}\n\t\t\t\t<span ba-if="{{initialmessage.id}}"\n\t\t\t\t\t  class="{{csscommon}}-action-button"\n\t\t\t\t\t  ba-click="close_message(initialmessage.id)"\n\t\t\t\t>\n\t\t\t\t\t<i class="{{csscommon}}-icon-cancel"></i>\n\t\t\t\t</span>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\n\t<div class="{{css}}-chooser-button-container">\n\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t\t ba-click="{{click_action(action)}}">\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture="{{action.switchcamera}}" />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t/>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n',
                  tmplmessage: '<div data-selector="recorder-message-container" class="{{cssrecorder}}-message-container" ba-click="{{click()}}">\n    <div class="{{cssrecorder}}-top-inner-message-container {{cssrecorder}}-{{shortMessage ? \'short-message\' : \'long-message\'}}">\n        <div class="{{cssrecorder}}-first-inner-message-container">\n            <div class="{{cssrecorder}}-second-inner-message-container">\n                <div class="{{cssrecorder}}-third-inner-message-container">\n                    <div class="{{cssrecorder}}-fourth-inner-message-container">\n                        <div data-selector="recorder-message-block" class=\'{{cssrecorder}}-message-message\'>\n                            <p>\n                                {{message || ""}}\n                            </p>\n                            <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n                                <li>\n                                    <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                                        {{link.title}}\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n'
                }
              };
            }), Scoped.extend("module:Assets.imageviewerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                css: function (_css60) {
                  function css(_x977) {
                    return _css60.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css60.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "activitydelta > 5000 && hideoninactivity ? (css + '-dashboard-hidden') : ''": function activitydelta5000HideoninactivityCssDashboardHidden(obj) {
                  with (obj) return 5e3 < activitydelta && hideoninactivity ? css + "-dashboard-hidden" : "";
                },
                "toggle_fullscreen()": function (_toggle_fullscreen10) {
                  function toggle_fullscreen(_x978) {
                    return _toggle_fullscreen10.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen10.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                fullscreen: function (_fullscreen10) {
                  function fullscreen(_x979) {
                    return _fullscreen10.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen10.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-image') : string('fullscreen-image')": function fullscreenedStringExitFullscreenImageStringFullscreenImage(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-image") : string("fullscreen-image");
                },
                csscommon: function (_csscommon41) {
                  function csscommon(_x980) {
                    return _csscommon41.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon41.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "fullscreened ? 'small' : 'full'": function fullscreenedSmallFull(obj) {
                  with (obj) return fullscreened ? "small" : "full";
                },
                title: function (_title17) {
                  function title(_x981) {
                    return _title17.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title17.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit19) {
                  function submit(_x982) {
                    return _submit19.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit19.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable17) {
                  function submittable(_x983) {
                    return _submittable17.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable17.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-image')": function stringSubmitImage(obj) {
                  with (obj) return string("submit-image");
                },
                "rerecord()": function (_rerecord27) {
                  function rerecord(_x984) {
                    return _rerecord27.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord27.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable17) {
                  function rerecordable(_x985) {
                    return _rerecordable17.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable17.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-image')": function stringRerecordImage(obj) {
                  with (obj) return string("rerecord-image");
                }
              }), {
                minimalist: {
                  css: "ba-imageviewer",
                  csstheme: "ba-imageviewer-minimalist-theme",
                  tmplcontrolbar: '<div class="{{css}}-dashboard {{activitydelta > 5000 && hideoninactivity ? (css + \'-dashboard-hidden\') : \'\'}}">\n\n    <div class=\'{{css}}-controlbar-header\'>\n        <div class="{{css}}-controlbar-header-icons-block">\n\n            <div class="{{css}}-right-block">\n\n                <div tabindex="1" data-selector="button-icon-resize-full"\n                     ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n                     onkeydown="{{tab_index_move(domEvent)}}"\n                     class="{{css}}-button-container"\n                     ba-if="{{fullscreen}}" ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-image\') : string(\'fullscreen-image\') }}"\n                >\n                    <div class="{{css}}-button-inner {{css}}-full-screen-btn-inner">\n                        <i class="{{csscommon}}-icon-resize-{{fullscreened ? \'small\' : \'full\'}}"></i>\n                    </div>\n                </div>\n\n            </div>\n\n        </div>\n\n\n        <div class="{{css}}-controlbar-header-title-block" ba-if="{{title}}">\n            <div class="{{css}}-title"><p>{{title}}</p></div>\n        </div>\n    </div>\n\n    <div class="{{css}}-controlbar-footer">\n\n        <div class="{{css}}-controlbar-top-block">\n\n            <div tabindex="0" data-selector="submit-image-button"\n                 ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 class="{{css}}-button-container" ba-if="{{submittable}}"  ba-click="{{submit()}}"\n            >\n                <div class="{{css}}-button-inner">\n                    {{string(\'submit-image\')}}\n                </div>\n            </div>\n\n        </div>\n        <div class="{{css}}-controlbar-bottom-block">\n            <div tabindex="0" data-selector="button-icon-ccw"\n                 ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 class="{{css}}-button-container {{css}}-player-rerecord"\n                 ba-if="{{rerecordable}}" ba-click="{{rerecord()}}" title="{{string(\'rerecord-image\')}}"\n            >\n                <div class="{{css}}-button-inner">\n                    <i class="{{csscommon}}-icon-ccw"></i>\n                </div>\n            </div>\n\n        </div>\n    </div>\n\n</div>\n',
                  cssloader: ie8 ? "ba-imageviewer" : "",
                  cssmessage: "ba-imageviewer"
                }
              };
            }), Scoped.extend("module:Assets.audioplayerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                csstheme: function (_csstheme21) {
                  function csstheme(_x986) {
                    return _csstheme21.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme21.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                "toggle_volume()": function (_toggle_volume10) {
                  function toggle_volume(_x987) {
                    return _toggle_volume10.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume10.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                },
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "startUpdateVolume(domEvent)": function startUpdateVolumeDomEvent(obj) {
                  with (obj) return startUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent)": function stopUpdateVolumeDomEvent(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "progressUpdateVolume(domEvent)": function progressUpdateVolumeDomEvent(obj) {
                  with (obj) return progressUpdateVolume(domEvent);
                },
                "{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + '%'}": function widthMathCeil1MathMin99MathRoundVolume100(obj) {
                  with (obj) return {
                    width: Math.ceil(1 + Math.min(99, Math.round(100 * volume))) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                title: function (_title18) {
                  function title(_x988) {
                    return _title18.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title18.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit20) {
                  function submit(_x989) {
                    return _submit20.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit20.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable18) {
                  function submittable(_x990) {
                    return _submittable18.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable18.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-audio')": function stringSubmitAudio(obj) {
                  with (obj) return string("submit-audio");
                },
                "play()": function (_play15) {
                  function play(_x991) {
                    return _play15.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play15.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "!playing": function (_playing21) {
                  function playing(_x992) {
                    return _playing21.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing21.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "string('play-audio')": function stringPlayAudio(obj) {
                  with (obj) return string("play-audio");
                },
                csscommon: function (_csscommon42) {
                  function csscommon(_x993) {
                    return _csscommon42.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon42.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "pause()": function (_pause15) {
                  function pause(_x994) {
                    return _pause15.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause15.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                playing: function (_playing22) {
                  function playing(_x995) {
                    return _playing22.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing22.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "disablepause ? string('pause-audio-disabled') : string('pause-audio')": function disablepauseStringPauseAudioDisabledStringPauseAudio(obj) {
                  with (obj) return disablepause ? string("pause-audio-disabled") : string("pause-audio");
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "stopUpdatePosition(domEvent)": function stopUpdatePositionDomEvent(obj) {
                  with (obj) return stopUpdatePosition(domEvent);
                },
                "progressUpdatePosition(domEvent)": function progressUpdatePositionDomEvent(obj) {
                  with (obj) return progressUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('audio-progress')": function stringAudioProgress(obj) {
                  with (obj) return string("audio-progress");
                },
                "rerecord()": function (_rerecord28) {
                  function rerecord(_x996) {
                    return _rerecord28.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord28.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable18) {
                  function rerecordable(_x997) {
                    return _rerecordable18.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable18.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-audio')": function stringRerecordAudio(obj) {
                  with (obj) return string("rerecord-audio");
                },
                "string('elapsed-time')": function stringElapsedTime(obj) {
                  with (obj) return string("elapsed-time");
                },
                "formatTime(position)": function formatTimePosition(obj) {
                  with (obj) return formatTime(position);
                },
                "string('total-time')": function stringTotalTime(obj) {
                  with (obj) return string("total-time");
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                }
              }), {
                minimalist: {
                  css: "ba-audioplayer",
                  csstheme: "ba-player-minimalist-theme",
                  tmplcontrolbar: '<div class="{{csstheme}}-dashboard ">\n\n    <div class=\'{{csstheme}}-controlbar-header\'>\n        <div class="{{csstheme}}-controlbar-header-icons-block">\n\n            <div class="{{csstheme}}-right-block">\n\n                <div tabindex="2" data-selector="button-icon-volume"\n                     ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n                     class="{{csstheme}}-button-container" ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}"\n                >\n                    <div class="{{csstheme}}-button-inner">\n                        <i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n                    </div>\n                </div>\n\n                <div class="{{csstheme}}-volumebar">\n                    <div tabindex="3" data-selector="button-volume-bar"\n                         ba-hotkey:right="{{set_volume(volume + 0.1)}}"\n                         ba-hotkey:left="{{set_volume(volume - 0.1)}}"\n                         onmouseout="this.blur()"\n                         class="{{csstheme}}-volumebar-inner"\n                         onmousedown="{{startUpdateVolume(domEvent)}}"\n                         onmouseup="{{stopUpdateVolume(domEvent)}}"\n                         onmouseleave="{{stopUpdateVolume(domEvent)}}"\n                         onmousemove="{{progressUpdateVolume(domEvent)}}"\n                    >\n                        <div class="{{csstheme}}-volumebar-position" ba-styles="{{{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + \'%\'}}}" title="{{string(\'volume-button\')}}"></div>\n                    </div>\n                </div>\n\n            </div>\n\n        </div>\n\n\n        <div class="{{csstheme}}-controlbar-header-title-block" ba-if="{{title}}">\n            <div class="{{csstheme}}-title"><p>{{title}}</p></div>\n        </div>\n    </div>\n\n    <div class="{{csstheme}}-controlbar-footer">\n\n        <div class="{{csstheme}}-controlbar-top-block">\n\n            <div tabindex="0" data-selector="submit-audio-button"\n                 ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 class="{{csstheme}}-button-container" ba-if="{{submittable}}"  ba-click="{{submit()}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    {{string(\'submit-audio\')}}\n                </div>\n            </div>\n\n            <div tabindex="0" data-selector="button-icon-play"\n                 ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n                 onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}"\n                 class="{{csstheme}}-button-container" ba-if="{{!playing}}" ba-click="{{play()}}" title="{{string(\'play-audio\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon}}-icon-play"></i>\n                </div>\n            </div>\n\n            <div tabindex="0" data-selector="button-icon-pause"\n                 ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n                 onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}"\n                 class="{{csstheme}}-button-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n                 ba-if="{{playing}}" ba-click="{{pause()}}" title="{{disablepause ? string(\'pause-audio-disabled\') : string(\'pause-audio\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i tabindex="0" class="{{csscommon}}-icon-pause"></i>\n                </div>\n            </div>\n\n        </div>\n        <div class="{{csstheme}}-controlbar-middle-block">\n\n            <div class="{{csstheme}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}">\n                <div tabindex="4" data-selector="progress-bar-inner"\n                     ba-hotkey:right="{{seek(position + skipseconds)}}"\n                     ba-hotkey:left="{{seek(position - skipseconds)}}"\n                     onmouseout="this.blur()"\n                     class="{{csstheme}}-progressbar-inner"\n                     onmousedown="{{startUpdatePosition(domEvent)}}"\n                     onmouseup="{{stopUpdatePosition(domEvent)}}"\n                     onmouseleave="{{stopUpdatePosition(domEvent)}}"\n                     onmousemove="{{progressUpdatePosition(domEvent)}}"\n                >\n\n                    <div class="{{csstheme}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n                    <div class="{{csstheme}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'audio-progress\')}}">\n                        <div class="{{csstheme}}-progressbar-button"></div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n        <div class="{{csstheme}}-controlbar-bottom-block">\n            <div tabindex="0" data-selector="button-icon-ccw"\n                 ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 class="{{csstheme}}-button-container {{csstheme}}-player-rerecord"\n                 ba-if="{{rerecordable}}" ba-click="{{rerecord()}}" title="{{string(\'rerecord-audio\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon}}-icon-ccw"></i>\n                </div>\n            </div>\n\n            <div class="{{csstheme}}-button-container {{csstheme}}-time-container">\n                <div class="{{csstheme}}-time-value" title="{{string(\'elapsed-time\')}}">{{formatTime(position)}}</div>\n                <p> / </p>\n                <div class="{{csstheme}}-time-value" title="{{string(\'total-time\')}}">{{formatTime(duration || position)}}</div>\n            </div>\n\n        </div>\n    </div>\n\n</div>\n',
                  cssloader: ie8 ? "ba-audioplayer" : "",
                  cssmessage: "ba-audioplayer",
                  cssplaybutton: ie8 ? "ba-audioplayer" : ""
                }
              };
            }), Scoped.extend("module:Assets.audiorecorderthemes", ["dynamics:Parser"], function (Parser) {
              return Parser.registerFunctions({
                css: function (_css61) {
                  function css(_x998) {
                    return _css61.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css61.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                topmessage: function (_topmessage10) {
                  function topmessage(_x999) {
                    return _topmessage10.apply(this, arguments);
                  }
                  topmessage.toString = function () {
                    return _topmessage10.toString();
                  };
                  return topmessage;
                }(function (obj) {
                  with (obj) return topmessage;
                })
              }), Parser.registerFunctions({
                csstheme: function (_csstheme22) {
                  function csstheme(_x1000) {
                    return _csstheme22.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme22.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                css: function (_css62) {
                  function css(_x1001) {
                    return _css62.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css62.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                settingsvisible: function (_settingsvisible12) {
                  function settingsvisible(_x1002) {
                    return _settingsvisible12.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible12.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                settingsopen: function (_settingsopen2) {
                  function settingsopen(_x1003) {
                    return _settingsopen2.apply(this, arguments);
                  }
                  settingsopen.toString = function () {
                    return _settingsopen2.toString();
                  };
                  return settingsopen;
                }(function (obj) {
                  with (obj) return settingsopen;
                }),
                cameras: function (_cameras10) {
                  function cameras(_x1004) {
                    return _cameras10.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras10.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "selectedcamera == camera.id": function selectedcameraCameraId(obj) {
                  with (obj) return selectedcamera == camera.id;
                },
                "selectCamera(camera.id)": function selectCameraCameraId(obj) {
                  with (obj) return selectCamera(camera.id);
                },
                "camera.label": function cameraLabel(obj) {
                  with (obj) return camera.label;
                },
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                "unhover()": function (_unhover9) {
                  function unhover(_x1005) {
                    return _unhover9.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover9.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                csscommon: function (_csscommon43) {
                  function csscommon(_x1006) {
                    return _csscommon43.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon43.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "!noaudio && !allowscreen": function noaudioAllowscreen(obj) {
                  with (obj) return !noaudio && !allowscreen;
                },
                "settingsvisible && settingsopen && audio": function settingsvisibleSettingsopenAudio(obj) {
                  with (obj) return settingsvisible && settingsopen && audio;
                },
                microphones: function (_microphones10) {
                  function microphones(_x1007) {
                    return _microphones10.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones10.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                audio: function (_audio3) {
                  function audio(_x1008) {
                    return _audio3.apply(this, arguments);
                  }
                  audio.toString = function () {
                    return _audio3.toString();
                  };
                  return audio;
                }(function (obj) {
                  with (obj) return audio;
                }),
                "selectMicrophone(microphone.id)": function selectMicrophoneMicrophoneId(obj) {
                  with (obj) return selectMicrophone(microphone.id);
                },
                "selectedmicrophone == microphone.id": function selectedmicrophoneMicrophoneId(obj) {
                  with (obj) return selectedmicrophone == microphone.id;
                },
                "microphone.label": function microphoneLabel(obj) {
                  with (obj) return microphone.label;
                },
                "hover(string(microphonehealthy ? 'microphonehealthy' : 'microphoneunhealthy'))": function hoverStringMicrophonehealthyMicrophonehealthyMicrophoneunhealthy(obj) {
                  with (obj) return hover(string(microphonehealthy ? "microphonehealthy" : "microphoneunhealthy"));
                },
                "microphonehealthy ? 'good' : 'bad'": function microphonehealthyGoodBad(obj) {
                  with (obj) return microphonehealthy ? "good" : "bad";
                },
                "hover(string(camerahealthy ? 'camerahealthy' : 'cameraunhealthy'))": function hoverStringCamerahealthyCamerahealthyCameraunhealthy(obj) {
                  with (obj) return hover(string(camerahealthy ? "camerahealthy" : "cameraunhealthy"));
                },
                "camerahealthy ? 'good' : 'bad'": function camerahealthyGoodBad(obj) {
                  with (obj) return camerahealthy ? "good" : "bad";
                },
                stopvisible: function (_stopvisible10) {
                  function stopvisible(_x1009) {
                    return _stopvisible10.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible10.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                controlbarlabel: function (_controlbarlabel12) {
                  function controlbarlabel(_x1010) {
                    return _controlbarlabel12.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel12.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                rerecordvisible: function (_rerecordvisible12) {
                  function rerecordvisible(_x1011) {
                    return _rerecordvisible12.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible12.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord29) {
                  function rerecord(_x1012) {
                    return _rerecord29.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord29.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible9) {
                  function cancelvisible(_x1013) {
                    return _cancelvisible9.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible9.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel9) {
                  function cancel(_x1014) {
                    return _cancel9.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel9.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                },
                recordvisible: function (_recordvisible12) {
                  function recordvisible(_x1015) {
                    return _recordvisible12.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible12.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record9) {
                  function record(_x1016) {
                    return _record9.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record9.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                "stop()": function (_stop8) {
                  function stop(_x1017) {
                    return _stop8.apply(this, arguments);
                  }
                  stop.toString = function () {
                    return _stop8.toString();
                  };
                  return stop;
                }(function (obj) {
                  with (obj) return stop();
                }),
                "mintimeindicator ? css + '-disabled': ''": function mintimeindicatorCssDisabled(obj) {
                  with (obj) return mintimeindicator ? css + "-disabled" : "";
                },
                "mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip')": function mintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip");
                },
                "hover(mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip'))": function hoverMintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return hover(mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip"));
                },
                "string('stop')": function stringStop(obj) {
                  with (obj) return string("stop");
                },
                skipvisible: function (_skipvisible8) {
                  function skipvisible(_x1018) {
                    return _skipvisible8.apply(this, arguments);
                  }
                  skipvisible.toString = function () {
                    return _skipvisible8.toString();
                  };
                  return skipvisible;
                }(function (obj) {
                  with (obj) return skipvisible;
                }),
                "skip()": function (_skip13) {
                  function skip(_x1019) {
                    return _skip13.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip13.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "hover(string('skip-tooltip'))": function hoverStringSkipTooltip(obj) {
                  with (obj) return hover(string("skip-tooltip"));
                },
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                },
                uploadcovershotvisible: function (_uploadcovershotvisible8) {
                  function uploadcovershotvisible(_x1020) {
                    return _uploadcovershotvisible8.apply(this, arguments);
                  }
                  uploadcovershotvisible.toString = function () {
                    return _uploadcovershotvisible8.toString();
                  };
                  return uploadcovershotvisible;
                }(function (obj) {
                  with (obj) return uploadcovershotvisible;
                }),
                "hover(string('upload-covershot-tooltip'))": function hoverStringUploadCovershotTooltip(obj) {
                  with (obj) return hover(string("upload-covershot-tooltip"));
                },
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                covershot_accept_string: function (_covershot_accept_string11) {
                  function covershot_accept_string(_x1021) {
                    return _covershot_accept_string11.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string11.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                css: function (_css63) {
                  function css(_x1022) {
                    return _css63.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css63.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                actions: function (_actions11) {
                  function actions(_x1023) {
                    return _actions11.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions11.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                },
                csscommon: function (_csscommon44) {
                  function csscommon(_x1024) {
                    return _csscommon44.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon44.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                }
              }), Parser.registerFunctions({
                css: function (_css64) {
                  function css(_x1025) {
                    return _css64.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css64.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click15) {
                  function click(_x1026) {
                    return _click15.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click15.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                "shortMessage ? 'short-message' : 'long-message'": function shortMessageShortMessageLongMessage(obj) {
                  with (obj) return shortMessage ? "short-message" : "long-message";
                },
                'message || ""': function (_message21) {
                  function message(_x1027) {
                    return _message21.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message21.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links9) {
                  function links(_x1028) {
                    return _links9.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links9.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }), {
                minimalist: {
                  css: "ba-audiorecorder",
                  csstheme: "ba-audiorecorder-theme-minimalist",
                  cssrecorder: "ba-recorder",
                  cssmessage: "ba-audiorecorder",
                  cssloader: "ba-audiorecorder",
                  tmpltopmessage: '<div data-selector="recorder-topmessage-block" class="{{css}}-topmessage-container">\n    <div class=\'{{css}}-topmessage-message\'>\n        {{topmessage}}\n    </div>\n</div>',
                  tmplcontrolbar: '<div class="{{csstheme}}-dashboard">\n\n\t\n\t<div class="{{css}}-settings-left-sidebar">\n\n\t\t<div class="{{css}}-controlbar-left-section" ba-show="{{settingsvisible}}">\n\n\t\t\t\n\t\t\t<div data-selector="recorder-settings" class="{{css}}-settings {{css}}-settings-button-container">\n\n\t\t\t\t<div data-selector="settings-list-front" class="{{css}}-circle-button" ba-show="{{settingsvisible}}">\n\n\t\t\t\t\t<div class="{{css}}-bubble-info" ba-show="{{settingsopen}}" >\n\t\t\t\t\t\t<ul data-selector="camera-settings" ba-repeat="{{camera :: cameras}}">\n\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t<input tabindex="0" onmouseout="this.blur()"\n\t\t\t\t\t\t\t\t\t   type=\'radio\' name=\'camera\' value="{{selectedcamera == camera.id}}" onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t\t\t<label tabindex="0" onmouseout="this.blur()" onclick="{{selectCamera(camera.id)}}">\n\t\t\t\t\t\t\t\t\t{{camera.label}}\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div tabindex="0"\n\t\t\t\t\t\t ba-hotkey:space^enter="{{settingsopen=!settingsopen}}" onmouseout="this.blur()"\n\t\t\t\t\t\t data-selector="record-button-icon-cog"\n\t\t\t\t\t\t class="{{css}}-button-inner {{css}}-button-circle-{{settingsopen ? \'selected\' : \'unselected\' }}"\n\t\t\t\t\t\t onclick="{{settingsopen=!settingsopen}}"\n\t\t\t\t\t\t onmouseenter="{{hover(string(\'settings\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-cog"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\n                <div class="{{css}}-circle-button" ba-show="{{!noaudio && !allowscreen}}">\n\n                    <div class="{{css}}-bubble-info" ba-show="{{settingsvisible && settingsopen && audio }}">\n                        <ul data-selector="microphone-settings" ba-repeat="{{microphone :: microphones}}" ba-show="{{audio}}">\n                            <li tabindex="0"\n\t\t\t\t\t\t\t\tba-hotkey:space^enter="{{selectMicrophone(microphone.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t\tonclick="{{selectMicrophone(microphone.id)}}"\n\t\t\t\t\t\t\t>\n                                <input type=\'radio\' name=\'microphone\' value="{{selectedmicrophone == microphone.id}}" />\n                                <span></span>\n                                <label>\n                                    {{microphone.label}}\n                                </label>\n                            </li>\n                        </ul>\n                    </div>\n\n                    <div data-selector="record-button-icon-mic" class="{{css}}-button-inner"\n                         onmouseenter="{{hover(string(microphonehealthy ? \'microphonehealthy\' : \'microphoneunhealthy\'))}}"\n                         onmouseleave="{{unhover()}}">\n                        <i class="{{csscommon}}-icon-mic {{csscommon}}-icon-state-{{microphonehealthy ? \'good\' : \'bad\' }}"></i>\n                    </div>\n                </div>\n\n                <div class="{{css}}-circle-button" ba-show="{{!noaudio && !allowscreen}}">\n                    <div data-selector="record-button-icon-audiocam" class="{{css}}-button-inner"\n                         onmouseenter="{{hover(string(camerahealthy ? \'camerahealthy\' : \'cameraunhealthy\'))}}"\n                         onmouseleave="{{unhover()}}">\n                        <i class="{{csscommon}}-icon-audiocam {{csscommon}}-icon-state-{{ camerahealthy ? \'good\' : \'bad\' }}"></i>\n                    </div>\n                </div>\n\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t<div class="{{css}}-controlbar-middle-section">\n\n\t\t<div class="{{css}}-timer-container" ba-show="{{stopvisible}}">\n\t\t\t<div class="{{css}}-label-container" ba-show="{{controlbarlabel}}">\n\t\t\t\t<div data-selector="record-label-block" class="{{css}}-label {{css}}-button-primary">\n\t\t\t\t\t{{controlbarlabel}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n\t\t<div class="{{css}}-controlbar-center-section">\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{rerecordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="rerecord-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{rerecord()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'rerecord\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{cancelvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="cancel-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{cancel()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'cancel\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-primary-button-container" ba-show="{{recordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="record-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{record()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'record\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-stop-container" ba-show="{{stopvisible}}">\n\n\t\t\t<div class="{{css}}-stop-button-container">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="stop-primary-button" class="{{css}}-button-primary {{mintimeindicator ? css + \'-disabled\': \'\'}}"\n\t\t\t\t\t title="{{mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\')}}"\n\t\t\t\t\t onclick="{{stop()}}"\n\t\t\t\t\t onmouseenter="{{hover(mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'stop\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-centerbutton-container" ba-show="{{skipvisible}}">\n            <div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="skip-primary-button" class="{{css}}-button-primary"\n                 onclick="{{skip()}}"\n                 onmouseenter="{{hover(string(\'skip-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                {{string(\'skip\')}}\n            </div>\n        </div>\n\n\n        <div class="{{css}}-rightbutton-container" ba-if="{{uploadcovershotvisible}}">\n            <div data-selector="covershot-primary-button" class="{{css}}-button-primary"\n                 onmouseenter="{{hover(string(\'upload-covershot-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                <input type="file"\n                       class="{{css}}-chooser-file"\n                       style="height:100px"\n                       onchange="{{uploadCovershot(domEvent)}}"\n                       accept="{{covershot_accept_string}}" />\n                <span>\n                    {{string(\'upload-covershot\')}}\n                </span>\n            </div>\n        </div>\n\n\t</div>\n\n</div>\n',
                  tmplchooser: '<div class="{{css}}-chooser-container">\n\n\t<div class="{{css}}-chooser-button-container">\n\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t\t ba-click="{{click_action(action)}}">\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t/>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>',
                  tmplmessage: '<div data-selector="recorder-message-container" class="{{css}}-message-container" ba-click="{{click()}}">\n    <div class="{{css}}-top-inner-message-container {{css}}-{{shortMessage ? \'short-message\' : \'long-message\'}}">\n        <div class="{{css}}-first-inner-message-container">\n            <div class="{{css}}-second-inner-message-container">\n                <div class="{{css}}-third-inner-message-container">\n                    <div class="{{css}}-fourth-inner-message-container">\n                        <div data-selector="recorder-message-block" class=\'{{css}}-message-message\'>\n                            <p>\n                                {{message || ""}}\n                            </p>\n                            <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n                                <li>\n                                    <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                                        {{link.title}}\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n'
                }
              };
            });
          }.call(Scoped), function () {
            var Scoped = this.subScope();
            Scoped.binding("browser", "root:BetaJS.Browser"), Scoped.binding("dynamics", "root:BetaJS.Dynamics"), Scoped.binding("module", "root:BetaJS.MediaComponents"), Scoped.extend("module:Assets.playerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                csstheme: function (_csstheme23) {
                  function csstheme(_x1029) {
                    return _csstheme23.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme23.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                "activitydelta > hidebarafter && hideoninactivity ? (cssplayer + '-dashboard-hidden') : ''": function activitydeltaHidebarafterHideoninactivityCssplayerDashboardHidden(obj) {
                  with (obj) return activitydelta > hidebarafter && hideoninactivity ? cssplayer + "-dashboard-hidden" : "";
                },
                title: function (_title19) {
                  function title(_x1030) {
                    return _title19.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title19.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit21) {
                  function submit(_x1031) {
                    return _submit21.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit21.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable19) {
                  function submittable(_x1032) {
                    return _submittable19.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable19.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecord()": function (_rerecord30) {
                  function rerecord(_x1033) {
                    return _rerecord30.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord30.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable19) {
                  function rerecordable(_x1034) {
                    return _rerecordable19.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable19.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-video')": function stringRerecordVideo(obj) {
                  with (obj) return string("rerecord-video");
                },
                csscommon: function (_csscommon45) {
                  function csscommon(_x1035) {
                    return _csscommon45.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon45.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "skipinitial ? 0 : 1": function skipinitial01(obj) {
                  with (obj) return skipinitial ? 0 : 1;
                },
                "play()": function (_play16) {
                  function play(_x1036) {
                    return _play16.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play16.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "!playing": function (_playing23) {
                  function playing(_x1037) {
                    return _playing23.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing23.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "string('play-video')": function stringPlayVideo(obj) {
                  with (obj) return string("play-video");
                },
                "pause()": function (_pause16) {
                  function pause(_x1038) {
                    return _pause16.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause16.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                playing: function (_playing24) {
                  function playing(_x1039) {
                    return _playing24.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing24.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "disablepause ? string('pause-video-disabled') : string('pause-video')": function disablepauseStringPauseVideoDisabledStringPauseVideo(obj) {
                  with (obj) return disablepause ? string("pause-video-disabled") : string("pause-video");
                },
                "toggle_volume()": function (_toggle_volume11) {
                  function toggle_volume(_x1040) {
                    return _toggle_volume11.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume11.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                },
                "!hidevolumebar": function (_hidevolumebar7) {
                  function hidevolumebar(_x1041) {
                    return _hidevolumebar7.apply(this, arguments);
                  }
                  hidevolumebar.toString = function () {
                    return _hidevolumebar7.toString();
                  };
                  return hidevolumebar;
                }(function (obj) {
                  with (obj) return !hidevolumebar;
                }),
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "startVerticallyUpdateVolume(domEvent)": function startVerticallyUpdateVolumeDomEvent(obj) {
                  with (obj) return startVerticallyUpdateVolume(domEvent);
                },
                "progressVerticallyUpdateVolume(domEvent)": function progressVerticallyUpdateVolumeDomEvent(obj) {
                  with (obj) return progressVerticallyUpdateVolume(domEvent);
                },
                "stopVerticallyUpdateVolume(domEvent); this.blur()": function stopVerticallyUpdateVolumeDomEventThisBlur(obj) {
                  with (obj) return stopVerticallyUpdateVolume(domEvent);
                },
                "stopVerticallyUpdateVolume(domEvent)": function stopVerticallyUpdateVolumeDomEvent(obj) {
                  with (obj) return stopVerticallyUpdateVolume(domEvent);
                },
                "{height: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + '%'}": function heightMathCeil1MathMin99MathRoundVolume100(obj) {
                  with (obj) return {
                    height: Math.ceil(1 + Math.min(99, Math.round(100 * volume))) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                "toggle_position_info()": function (_toggle_position_info6) {
                  function toggle_position_info(_x1042) {
                    return _toggle_position_info6.apply(this, arguments);
                  }
                  toggle_position_info.toString = function () {
                    return _toggle_position_info6.toString();
                  };
                  return toggle_position_info;
                }(function (obj) {
                  with (obj) return toggle_position_info();
                }),
                "revertposition ? string('remaining-time') : string('elapsed-time')": function revertpositionStringRemainingTimeStringElapsedTime(obj) {
                  with (obj) return revertposition ? string("remaining-time") : string("elapsed-time");
                },
                '(revertposition && duration > 0) ? "-" : ""': function revertpositionDuration0(obj) {
                  with (obj) return revertposition && 0 < duration ? "-" : "";
                },
                "(revertposition && duration > 0) ? formatTime(duration - position) : formatTime(position)": function revertpositionDuration0FormatTimeDurationPositionFormatTimePosition(obj) {
                  with (obj) return revertposition && 0 < duration ? formatTime(duration - position) : formatTime(position);
                },
                "toggle_settings_menu()": function (_toggle_settings_menu6) {
                  function toggle_settings_menu(_x1043) {
                    return _toggle_settings_menu6.apply(this, arguments);
                  }
                  toggle_settings_menu.toString = function () {
                    return _toggle_settings_menu6.toString();
                  };
                  return toggle_settings_menu;
                }(function (obj) {
                  with (obj) return toggle_settings_menu();
                }),
                cssplayer: function (_cssplayer17) {
                  function cssplayer(_x1044) {
                    return _cssplayer17.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer17.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "settingsmenuactive ? 'active' : 'inactive'": function settingsmenuactiveActiveInactive(obj) {
                  with (obj) return settingsmenuactive ? "active" : "inactive";
                },
                settingsmenubutton: function (_settingsmenubutton6) {
                  function settingsmenubutton(_x1045) {
                    return _settingsmenubutton6.apply(this, arguments);
                  }
                  settingsmenubutton.toString = function () {
                    return _settingsmenubutton6.toString();
                  };
                  return settingsmenubutton;
                }(function (obj) {
                  with (obj) return settingsmenubutton;
                }),
                "string('settings')": function stringSettings(obj) {
                  with (obj) return string("settings");
                },
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                "toggle_tracks()": function (_toggle_tracks6) {
                  function toggle_tracks(_x1046) {
                    return _toggle_tracks6.apply(this, arguments);
                  }
                  toggle_tracks.toString = function () {
                    return _toggle_tracks6.toString();
                  };
                  return toggle_tracks;
                }(function (obj) {
                  with (obj) return toggle_tracks();
                }),
                "(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload": function tracktagsLength0ShowsubtitlebuttonAllowtexttrackupload(obj) {
                  with (obj) return 0 < tracktags.length && showsubtitlebutton || allowtexttrackupload;
                },
                "tracktextvisible ? 'active' : 'inactive'": function tracktextvisibleActiveInactive(obj) {
                  with (obj) return tracktextvisible ? "active" : "inactive";
                },
                "tracktextvisible ? string('close-tracks') : string('show-tracks')": function tracktextvisibleStringCloseTracksStringShowTracks(obj) {
                  with (obj) return tracktextvisible ? string("close-tracks") : string("show-tracks");
                },
                "hover_cc(true)": function hover_ccTrue(obj) {
                  with (obj) return hover_cc(!0);
                },
                "hover_cc(false)": function hover_ccFalse(obj) {
                  with (obj) return hover_cc(!1);
                },
                "toggle_fullscreen()": function (_toggle_fullscreen11) {
                  function toggle_fullscreen(_x1047) {
                    return _toggle_fullscreen11.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen11.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                fullscreen: function (_fullscreen11) {
                  function fullscreen(_x1048) {
                    return _fullscreen11.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen11.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-video') : string('fullscreen-video')": function fullscreenedStringExitFullscreenVideoStringFullscreenVideo(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-video") : string("fullscreen-video");
                },
                "fullscreened ? 'small' : 'full'": function fullscreenedSmallFull(obj) {
                  with (obj) return fullscreened ? "small" : "full";
                },
                trimmingmode: function (_trimmingmode12) {
                  function trimmingmode(_x1049) {
                    return _trimmingmode12.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode12.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "trim()": function (_trim7) {
                  function trim(_x1050) {
                    return _trim7.apply(this, arguments);
                  }
                  trim.toString = function () {
                    return _trim7.toString();
                  };
                  return trim;
                }(function (obj) {
                  with (obj) return trim();
                }),
                "string('trim-video')": function stringTrimVideo(obj) {
                  with (obj) return string("trim-video");
                },
                frameselectionmode: function (_frameselectionmode8) {
                  function frameselectionmode(_x1051) {
                    return _frameselectionmode8.apply(this, arguments);
                  }
                  frameselectionmode.toString = function () {
                    return _frameselectionmode8.toString();
                  };
                  return frameselectionmode;
                }(function (obj) {
                  with (obj) return frameselectionmode;
                }),
                "select_frame()": function (_select_frame6) {
                  function select_frame(_x1052) {
                    return _select_frame6.apply(this, arguments);
                  }
                  select_frame.toString = function () {
                    return _select_frame6.toString();
                  };
                  return select_frame;
                }(function (obj) {
                  with (obj) return select_frame();
                }),
                "string('select-frame')": function stringSelectFrame(obj) {
                  with (obj) return string("select-frame");
                },
                "show_airplay_devices()": function (_show_airplay_devices6) {
                  function show_airplay_devices(_x1053) {
                    return _show_airplay_devices6.apply(this, arguments);
                  }
                  show_airplay_devices.toString = function () {
                    return _show_airplay_devices6.toString();
                  };
                  return show_airplay_devices;
                }(function (obj) {
                  with (obj) return show_airplay_devices();
                }),
                airplaybuttonvisible: function (_airplaybuttonvisible7) {
                  function airplaybuttonvisible(_x1054) {
                    return _airplaybuttonvisible7.apply(this, arguments);
                  }
                  airplaybuttonvisible.toString = function () {
                    return _airplaybuttonvisible7.toString();
                  };
                  return airplaybuttonvisible;
                }(function (obj) {
                  with (obj) return airplaybuttonvisible;
                }),
                castbuttonvisble: function (_castbuttonvisble7) {
                  function castbuttonvisble(_x1055) {
                    return _castbuttonvisble7.apply(this, arguments);
                  }
                  castbuttonvisble.toString = function () {
                    return _castbuttonvisble7.toString();
                  };
                  return castbuttonvisble;
                }(function (obj) {
                  with (obj) return castbuttonvisble;
                }),
                "toggle_stream()": function (_toggle_stream6) {
                  function toggle_stream(_x1056) {
                    return _toggle_stream6.apply(this, arguments);
                  }
                  toggle_stream.toString = function () {
                    return _toggle_stream6.toString();
                  };
                  return toggle_stream;
                }(function (obj) {
                  with (obj) return toggle_stream();
                }),
                "streams.length > 1 && currentstream": function streamsLength1Currentstream(obj) {
                  with (obj) return 1 < streams.length && currentstream;
                },
                "string('change-resolution')": function stringChangeResolution(obj) {
                  with (obj) return string("change-resolution");
                },
                currentstream_label: function (_currentstream_label6) {
                  function currentstream_label(_x1057) {
                    return _currentstream_label6.apply(this, arguments);
                  }
                  currentstream_label.toString = function () {
                    return _currentstream_label6.toString();
                  };
                  return currentstream_label;
                }(function (obj) {
                  with (obj) return currentstream_label;
                }),
                "string('total-time')": function stringTotalTime(obj) {
                  with (obj) return string("total-time");
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('video-progress')": function stringVideoProgress(obj) {
                  with (obj) return string("video-progress");
                },
                "{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + '%'}": function leftMathRoundDurationTrimstartTrimstartDuration1000(obj) {
                  with (obj) return {
                    left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + "%"
                  };
                },
                "{left: 'auto', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + '%'}": function leftAutoRight100MathRoundDurationTrimendTrimendDuration100100(obj) {
                  with (obj) return {
                    left: "auto",
                    right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + "%"
                  };
                }
              }), Parser.registerFunctions({
                "play()": function (_play17) {
                  function play(_x1058) {
                    return _play17.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play17.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'player-toggle-overlay')": function tab_index_moveDomEventNullPlayerToggleOverlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "player-toggle-overlay");
                },
                cssplayer: function (_cssplayer18) {
                  function cssplayer(_x1059) {
                    return _cssplayer18.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer18.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "string('tooltip')": function stringTooltip(obj) {
                  with (obj) return string("tooltip");
                },
                "showduration && (duration != 0 && duration != undefined)": function showdurationDuration0DurationUndefined(obj) {
                  with (obj) return showduration && 0 != duration && duration != undefined;
                },
                css: function (_css65) {
                  function css(_x1060) {
                    return _css65.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css65.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "formatTime(duration)": function formatTimeDuration(obj) {
                  with (obj) return formatTime(duration);
                },
                "rerecordable || submittable": function rerecordableSubmittable(obj) {
                  with (obj) return rerecordable || submittable;
                },
                "submittable && !trimmingmode": function submittableTrimmingmode(obj) {
                  with (obj) return submittable && !trimmingmode;
                },
                "submit()": function (_submit22) {
                  function submit(_x1061) {
                    return _submit22.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit22.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecordable && !trimmingmode": function rerecordableTrimmingmode(obj) {
                  with (obj) return rerecordable && !trimmingmode;
                },
                "rerecord()": function (_rerecord31) {
                  function rerecord(_x1062) {
                    return _rerecord31.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord31.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                trimmingmode: function (_trimmingmode13) {
                  function trimmingmode(_x1063) {
                    return _trimmingmode13.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode13.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "string('trim')": function stringTrim(obj) {
                  with (obj) return string("trim");
                },
                "skip()": function (_skip14) {
                  function skip(_x1064) {
                    return _skip14.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip14.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                }
              }), {
                theatre: {
                  css: "ba-videoplayer",
                  csstheme: "ba-player-theatre-theme",
                  csscommon: "ba-commoncss",
                  cssplayer: "ba-player",
                  tmplcontrolbar: '<div data-selector="video-title-block" class="{{csstheme}}-title-container {{activitydelta > hidebarafter && hideoninactivity ? (cssplayer + \'-dashboard-hidden\') : \'\'}}"  ba-if="{{title}}">\n    <p class="{{csstheme}}-title">\n        {{title}}\n    </p>\n</div>\n<div class="{{csstheme}}-dashboard {{activitydelta > hidebarafter && hideoninactivity ? (cssplayer + \'-dashboard-hidden\') : \'\'}}">\n\n    <div class="{{csstheme}}-left-block">\n\n        <div tabindex="0" data-selector="submit-video-button"\n             ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-leftbutton-container"\n             ba-if="{{submittable}}"  ba-click="{{submit()}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                {{string(\'submit-video\')}}\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-ccw"\n             ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-leftbutton-container"\n             ba-if="{{rerecordable}}" ba-click="{{rerecord()}}"\n             title="{{string(\'rerecord-video\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-ccw"></i>\n            </div>\n        </div>\n\n        <div tabindex="{{skipinitial ? 0 : 1}}" data-selector="button-icon-play"\n             ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}"\n             class="{{csstheme}}-button-container"\n             ba-if="{{!playing}}" ba-click="{{play()}}" title="{{string(\'play-video\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-play"></i>\n            </div>\n        </div>\n\n        <div tabindex="{{skipinitial ? 0 : 1}}" data-selector="button-icon-pause"\n             ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}"\n             class="{{csstheme}}-button-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n             ba-if="{{playing}}" ba-click="{{pause()}}" title="{{disablepause ? string(\'pause-video-disabled\') : string(\'pause-video\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-pause"></i>\n            </div>\n        </div>\n\n        <div class="{{csstheme}}-volume-icon-container">\n\n            <div tabindex="2" data-selector="button-icon-volume"\n                 ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n                 class="{{csstheme}}-button-container"\n                 ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n                </div>\n            </div>\n\n            <div class="{{csstheme}}-volumebar" ba-show="{{!hidevolumebar}}">\n                <div tabindex="-1" data-selector="button-volume-bar"\n                     ba-hotkey:up="{{set_volume(volume + 0.1)}}"\n                     ba-hotkey:down="{{set_volume(volume - 0.1)}}"\n                     onmouseout="this.blur()"\n                     class="{{csstheme}}-volumebar-inner"\n                     ontouchstart="{{startVerticallyUpdateVolume(domEvent)}}"\n                     ontouchmove="{{progressVerticallyUpdateVolume(domEvent)}}"\n                     ontouchend="{{stopVerticallyUpdateVolume(domEvent); this.blur()}};"\n                     onmousedown="{{startVerticallyUpdateVolume(domEvent)}}"\n                     onmouseup="{{stopVerticallyUpdateVolume(domEvent)}}"\n                     onmouseleave="{{stopVerticallyUpdateVolume(domEvent)}}"\n                     onmousemove="{{progressVerticallyUpdateVolume(domEvent)}}"\n                >\n                    <div class="{{csstheme}}-volumebar-position" ba-styles="{{{height: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + \'%\'}}}" title="{{string(\'volume-button\')}}"></div>\n                </div>\n            </div>\n        </div>\n\n        <div class="{{csstheme}}-time-container {{csscommon}}-clickable" ba-click="{{toggle_position_info()}}">\n            <div class="{{csstheme}}-time-value"\n                 title="{{revertposition ? string(\'remaining-time\') : string(\'elapsed-time\')}}"\n            >\n                {{(revertposition && duration > 0) ? "-" : ""}}\n                {{(revertposition && duration > 0) ? formatTime(duration - position) : formatTime(position)}}\n            </div>\n        </div>\n    </div>\n\n    <div class="{{csstheme}}-right-block">\n\n        <div tabindex="10" data-selector="button-icon-settings"\n             ba-hotkey:space^enter="{{toggle_settings_menu()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-rightbutton-container {{csstheme}}-settings-button-container {{cssplayer}}-button-{{settingsmenuactive ? \'active\' : \'inactive\'}}"\n             ba-if="{{settingsmenubutton}}" ba-click="{{toggle_settings_menu()}}"\n             title="{{string(\'settings\')}}"\n             onkeydown="{{tab_index_move(domEvent)}}"\n        >\n            <div class="{{csstheme}}-button-inner {{csstheme}}-settings-button-inner">\n                <i class="{{csscommon}}-icon-cog"></i>\n            </div>\n        </div>\n\n        <div tabindex="9" data-selector="cc-button-container"\n             ba-hotkey:space^enter="{{toggle_tracks()}}" onmouseout="this.blur()"\n             ba-if="{{(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload}}"\n             class="{{csstheme}}-rightbutton-container {{csstheme}}-cc-button-container {{cssplayer}}-button-{{tracktextvisible ? \'active\' : \'inactive\'}}"\n             title="{{ tracktextvisible ? string(\'close-tracks\') : string(\'show-tracks\')}}"\n             ba-click="{{toggle_tracks()}}"\n             onmouseover="{{hover_cc(true)}}"\n             onmouseleave="{{hover_cc(false)}}"\n        >\n            <div class="{{csstheme}}-button-inner {{csstheme}}-subtitle-button-inner">\n                <i class="{{csscommon}}-icon-subtitle"></i>\n            </div>\n        </div>\n\n        <div tabindex="8" data-selector="button-icon-resize-full"\n             ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n             onkeydown="{{tab_index_move(domEvent)}}"\n             class="{{csstheme}}-button-container {{csstheme}}-fullscreen-icon-container"\n             ba-if="{{fullscreen}}" ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-video\') : string(\'fullscreen-video\') }}"\n        >\n            <div class="{{csstheme}}-button-inner {{csstheme}}-full-screen-btn-inner">\n                <i class="{{csscommon}}-icon-resize-{{fullscreened ? \'small\' : \'full\'}}"></i>\n            </div>\n        </div>\n\n        <div tabindex="7" class="{{csstheme}}-button-container" ba-if="{{trimmingmode}}">\n            <div data-selector="trim-button"\n                 onmouseout="this.blur()"\n                 ba-click="{{trim()}}"\n                 class="{{csstheme}}-primary-button {{csstheme}}-button-inner">\n                 {{string(\'trim-video\')}}\n            </div>\n        </div>\n\n        <div tabindex="7" class="{{csstheme}}-button-container" ba-if="{{frameselectionmode}}">\n            <div data-selector="select-frame-button"\n                 onmouseout="this.blur()"\n                 ba-click="{{select_frame()}}"\n                 class="{{csstheme}}-primary-button {{csstheme}}-button-inner">\n                 {{string(\'select-frame\')}}\n            </div>\n        </div>\n\n        <div tabindex="6" data-selector="button-airplay"\n             ba-hotkey:space^enter="{{show_airplay_devices()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container {{cssplayer}}-airplay-container"\n             ba-show="{{airplaybuttonvisible}}" ba-click="{{show_airplay_devices()}}"\n        >\n            <svg width="16px" height="11px" viewBox="0 0 16 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n                \n                <title>Airplay</title>\n                <desc>Airplay icon.</desc>\n                <defs></defs>\n                <g stroke="none" stroke-width="1" fill-rule="evenodd" sketch:type="MSPage">\n                    <path d="M4,11 L12,11 L8,7 L4,11 Z M14.5454545,0 L1.45454545,0 C0.654545455,0 0,0.5625 0,1.25 L0,8.75 C0,9.4375 0.654545455,10 1.45454545,10 L4.36363636,10 L4.36363636,8.75 L1.45454545,8.75 L1.45454545,1.25 L14.5454545,1.25 L14.5454545,8.75 L11.6363636,8.75 L11.6363636,10 L14.5454545,10 C15.3454545,10 16,9.4375 16,8.75 L16,1.25 C16,0.5625 15.3454545,0 14.5454545,0 L14.5454545,0 Z" sketch:type="MSShapeGroup"></path>\n                </g>\n            </svg>\n        </div>\n\n        <div data-selector="button-chromecast" class="{{csstheme}}-button-container {{csstheme}}-cast-button-container" ba-show="{{castbuttonvisble}}">\n            <button tabindex="0" class="{{csstheme}}-gcast-button" is="google-cast-button"></button>\n        </div>\n\n        <div tabindex="5" data-selector="button-stream-label"\n             ba-hotkey:space^enter="{{toggle_stream()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-button-container {{csstheme}}-stream-label-container"\n             ba-if="{{streams.length > 1 && currentstream}}" ba-click="{{toggle_stream()}}" title="{{string(\'change-resolution\')}}"\n        >\n            <div class="{{csstheme}}-button-inner {{csstheme}}-stream-label-container">\n                <span class="{{csstheme}}-button-text {{csstheme}}-stream-label">{{currentstream_label}}</span>\n            </div>\n        </div>\n\n        <div class="{{csstheme}}-time-container {{csstheme}}-right-time-container">\n            <div class="{{csstheme}}-time-value" title="{{string(\'total-time\')}}">{{formatTime(duration || position)}}</div>\n        </div>\n\n    </div>\n\n    <div class="{{csstheme}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}">\n        <div tabindex="4" data-selector="progress-bar-inner"\n             ba-hotkey:right="{{seek(position + skipseconds)}}"\n             ba-hotkey:left="{{seek(position - skipseconds)}}"\n             onmouseout="this.blur()"\n             class="{{csstheme}}-progressbar-inner"\n             ontouchstart="{{startUpdatePosition(domEvent)}}"\n             onmousedown="{{startUpdatePosition(domEvent)}}"\n        >\n\n            <div class="{{csstheme}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n            <div class="{{csstheme}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'video-progress\')}}">\n                <div class="{{csstheme}}-progressbar-button"></div>\n            </div>\n            <div class="{{csstheme}}-progressbar-marker"\n                data-selector="trim-start-marker"\n                ba-if="{{trimmingmode}}"\n                ba-styles="{{{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + \'%\'}}}"\n            ></div>\n            <div class="{{csstheme}}-progressbar-marker"\n                data-selector="trim-end-marker"\n                ba-if="{{trimmingmode}}"\n                ba-styles="{{{left: \'auto\', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + \'%\'}}}"\n            ></div>\n        </div>\n    </div>\n\n</div>\n',
                  tmplplaybutton: '\n<div tabindex="0" data-selector="play-button"\n     ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n     onkeydown="{{tab_index_move(domEvent, null, \'player-toggle-overlay\')}}"\n     class="{{cssplayer}}-playbutton-container" ba-click="{{play()}}" title="{{string(\'tooltip\')}}"\n>\n\t<div class="{{cssplayer}}-playbutton-button"></div>\n</div>\n<div ba-show="{{showduration && (duration != 0 && duration != undefined)}}" class="{{css}}-playbutton-duration">\n    {{formatTime(duration)}}\n</div>\n\n<div class="{{cssplayer}}-rerecord-bar" ba-if="{{rerecordable || submittable}}">\n\t<div class="{{cssplayer}}-rerecord-backbar"></div>\n\t<div class="{{cssplayer}}-rerecord-frontbar">\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{submittable && !trimmingmode}}">\n            <div tabindex="0" data-selector="player-submit-button"\n                 ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{submit()}}">\n                {{string(\'submit-video\')}}\n            </div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{rerecordable && !trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-rerecord-button"\n                 ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{rerecord()}}">\n        \t\t{{string(\'rerecord\')}}\n        \t</div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-trim-button"\n                 ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{play()}}">\n        \t\t{{string(\'trim\')}}\n        \t</div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-skip-button"\n                 ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{skip()}}">\n        \t\t{{string(\'skip\')}}\n        \t</div>\n        </div>\n\t</div>\n</div>\n',
                  cssloader: ie8 ? "ba-videoplayer" : "",
                  cssmessage: "ba-videoplayer",
                  cssplaybutton: ie8 ? "ba-videoplayer" : ""
                }
              };
            }), Scoped.extend("module:Assets.recorderthemes", ["dynamics:Parser"], function (Parser) {
              return Parser.registerFunctions({
                csstheme: function (_csstheme24) {
                  function csstheme(_x1065) {
                    return _csstheme24.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme24.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                css: function (_css66) {
                  function css(_x1066) {
                    return _css66.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css66.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "settingsvisible && settingsopen": function settingsvisibleSettingsopen(obj) {
                  with (obj) return settingsvisible && settingsopen;
                },
                videoselectnotification: function (_videoselectnotification5) {
                  function videoselectnotification(_x1067) {
                    return _videoselectnotification5.apply(this, arguments);
                  }
                  videoselectnotification.toString = function () {
                    return _videoselectnotification5.toString();
                  };
                  return videoselectnotification;
                }(function (obj) {
                  with (obj) return videoselectnotification;
                }),
                "string('add-stream')": function stringAddStream(obj) {
                  with (obj) return string("add-stream");
                },
                csscommon: function (_csscommon46) {
                  function csscommon(_x1068) {
                    return _csscommon46.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon46.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "showaddstreambutton && firefox && allowscreen": function showaddstreambuttonFirefoxAllowscreen(obj) {
                  with (obj) return showaddstreambutton && firefox && allowscreen;
                },
                "addNewStream()": function (_addNewStream5) {
                  function addNewStream(_x1069) {
                    return _addNewStream5.apply(this, arguments);
                  }
                  addNewStream.toString = function () {
                    return _addNewStream5.toString();
                  };
                  return addNewStream;
                }(function (obj) {
                  with (obj) return addNewStream();
                }),
                "hover(string('add-stream'))": function hoverStringAddStream(obj) {
                  with (obj) return hover(string("add-stream"));
                },
                "showaddstreambutton && !firefox": function showaddstreambuttonFirefox(obj) {
                  with (obj) return showaddstreambutton && !firefox;
                },
                cameras: function (_cameras11) {
                  function cameras(_x1070) {
                    return _cameras11.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras11.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "(camera.id !== selectedcamera) || allowscreen": function cameraIdSelectedcameraAllowscreen(obj) {
                  with (obj) return camera.id !== selectedcamera || allowscreen;
                },
                "addNewStream(camera.id)": function addNewStreamCameraId(obj) {
                  with (obj) return addNewStream(camera.id);
                },
                "camera.label": function cameraLabel(obj) {
                  with (obj) return camera.label;
                },
                "(showaddstreambutton && !firefox) || (firefox && allowscreen)": function showaddstreambuttonFirefoxFirefoxAllowscreen(obj) {
                  with (obj) return showaddstreambutton && !firefox || firefox && allowscreen;
                },
                "!novideo && !allowscreen && !ismobile": function novideoAllowscreenIsmobile(obj) {
                  with (obj) return !novideo && !allowscreen && !ismobile;
                },
                "hover(string('select-camera'))": function hoverStringSelectCamera(obj) {
                  with (obj) return hover(string("select-camera"));
                },
                "selectCamera(camera.id)": function selectCameraCameraId(obj) {
                  with (obj) return selectCamera(camera.id);
                },
                "selectedcamera == camera.id": function selectedcameraCameraId(obj) {
                  with (obj) return selectedcamera == camera.id;
                },
                "(!noaudio && !novideo) || !allowscreen": function noaudioNovideoAllowscreen(obj) {
                  with (obj) return !noaudio && !novideo || !allowscreen;
                },
                microphones: function (_microphones11) {
                  function microphones(_x1071) {
                    return _microphones11.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones11.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                "!noaudio && !allowscreen": function noaudioAllowscreen(obj) {
                  with (obj) return !noaudio && !allowscreen;
                },
                "selectMicrophone(microphone.id)": function selectMicrophoneMicrophoneId(obj) {
                  with (obj) return selectMicrophone(microphone.id);
                },
                "hover(string('select-audio-input'))": function hoverStringSelectAudioInput(obj) {
                  with (obj) return hover(string("select-audio-input"));
                },
                "selectedmicrophone == microphone.id": function selectedmicrophoneMicrophoneId(obj) {
                  with (obj) return selectedmicrophone == microphone.id;
                },
                "microphone.label": function microphoneLabel(obj) {
                  with (obj) return microphone.label;
                },
                rerecordvisible: function (_rerecordvisible13) {
                  function rerecordvisible(_x1072) {
                    return _rerecordvisible13.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible13.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord32) {
                  function rerecord(_x1073) {
                    return _rerecord32.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord32.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "unhover()": function (_unhover10) {
                  function unhover(_x1074) {
                    return _unhover10.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover10.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible10) {
                  function cancelvisible(_x1075) {
                    return _cancelvisible10.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible10.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel10) {
                  function cancel(_x1076) {
                    return _cancel10.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel10.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                },
                "stopvisible && recordingindication": function stopvisibleRecordingindication(obj) {
                  with (obj) return stopvisible && recordingindication;
                },
                settingsvisible: function (_settingsvisible13) {
                  function settingsvisible(_x1077) {
                    return _settingsvisible13.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible13.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                ismobile: function (_ismobile4) {
                  function ismobile(_x1078) {
                    return _ismobile4.apply(this, arguments);
                  }
                  ismobile.toString = function () {
                    return _ismobile4.toString();
                  };
                  return ismobile;
                }(function (obj) {
                  with (obj) return ismobile;
                }),
                "toggleFaceMode()": function (_toggleFaceMode5) {
                  function toggleFaceMode(_x1079) {
                    return _toggleFaceMode5.apply(this, arguments);
                  }
                  toggleFaceMode.toString = function () {
                    return _toggleFaceMode5.toString();
                  };
                  return toggleFaceMode;
                }(function (obj) {
                  with (obj) return toggleFaceMode();
                }),
                "hover(string('switch-camera'))": function hoverStringSwitchCamera(obj) {
                  with (obj) return hover(string("switch-camera"));
                },
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                "hover(string(microphonehealthy ? 'microphonehealthy' : 'microphoneunhealthy'))": function hoverStringMicrophonehealthyMicrophonehealthyMicrophoneunhealthy(obj) {
                  with (obj) return hover(string(microphonehealthy ? "microphonehealthy" : "microphoneunhealthy"));
                },
                "microphonehealthy ? 'good' : 'bad'": function microphonehealthyGoodBad(obj) {
                  with (obj) return microphonehealthy ? "good" : "bad";
                },
                "!novideo && !allowscreen": function novideoAllowscreen(obj) {
                  with (obj) return !novideo && !allowscreen;
                },
                "hover(string(camerahealthy ? 'camerahealthy' : 'cameraunhealthy'))": function hoverStringCamerahealthyCamerahealthyCameraunhealthy(obj) {
                  with (obj) return hover(string(camerahealthy ? "camerahealthy" : "cameraunhealthy"));
                },
                "camerahealthy ? 'good' : 'bad'": function camerahealthyGoodBad(obj) {
                  with (obj) return camerahealthy ? "good" : "bad";
                },
                cssrecorder: function (_cssrecorder10) {
                  function cssrecorder(_x1080) {
                    return _cssrecorder10.apply(this, arguments);
                  }
                  cssrecorder.toString = function () {
                    return _cssrecorder10.toString();
                  };
                  return cssrecorder;
                }(function (obj) {
                  with (obj) return cssrecorder;
                }),
                recordvisible: function (_recordvisible13) {
                  function recordvisible(_x1081) {
                    return _recordvisible13.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible13.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record10) {
                  function record(_x1082) {
                    return _record10.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record10.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                stopvisible: function (_stopvisible11) {
                  function stopvisible(_x1083) {
                    return _stopvisible11.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible11.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                "controlbarlabel && !rerecordvisible": function controlbarlabelRerecordvisible(obj) {
                  with (obj) return controlbarlabel && !rerecordvisible;
                },
                controlbarlabel: function (_controlbarlabel13) {
                  function controlbarlabel(_x1084) {
                    return _controlbarlabel13.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel13.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                "pausable && !resumevisible": function pausableResumevisible(obj) {
                  with (obj) return pausable && !resumevisible;
                },
                "stop()": function (_stop9) {
                  function stop(_x1085) {
                    return _stop9.apply(this, arguments);
                  }
                  stop.toString = function () {
                    return _stop9.toString();
                  };
                  return stop;
                }(function (obj) {
                  with (obj) return stop();
                }),
                "string('pause-recorder')": function stringPauseRecorder(obj) {
                  with (obj) return string("pause-recorder");
                },
                "pause()": function (_pause17) {
                  function pause(_x1086) {
                    return _pause17.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause17.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "hover(string('pause-recorder'))": function hoverStringPauseRecorder(obj) {
                  with (obj) return hover(string("pause-recorder"));
                },
                "pausable && resumevisible": function pausableResumevisible(obj) {
                  with (obj) return pausable && resumevisible;
                },
                "resume()": function (_resume6) {
                  function resume(_x1087) {
                    return _resume6.apply(this, arguments);
                  }
                  resume.toString = function () {
                    return _resume6.toString();
                  };
                  return resume;
                }(function (obj) {
                  with (obj) return resume();
                }),
                "string('resume-recorder')": function stringResumeRecorder(obj) {
                  with (obj) return string("resume-recorder");
                },
                "hover(string('resume-recorder'))": function hoverStringResumeRecorder(obj) {
                  with (obj) return hover(string("resume-recorder"));
                },
                "mintimeindicator ? css + '-disabled': ''": function mintimeindicatorCssDisabled(obj) {
                  with (obj) return mintimeindicator ? css + "-disabled" : "";
                },
                "mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip')": function mintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip");
                },
                "hover(mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip'))": function hoverMintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return hover(mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip"));
                },
                "string('stop')": function stringStop(obj) {
                  with (obj) return string("stop");
                },
                skipvisible: function (_skipvisible9) {
                  function skipvisible(_x1088) {
                    return _skipvisible9.apply(this, arguments);
                  }
                  skipvisible.toString = function () {
                    return _skipvisible9.toString();
                  };
                  return skipvisible;
                }(function (obj) {
                  with (obj) return skipvisible;
                }),
                "skip()": function (_skip15) {
                  function skip(_x1089) {
                    return _skip15.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip15.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "hover(string('skip-tooltip'))": function hoverStringSkipTooltip(obj) {
                  with (obj) return hover(string("skip-tooltip"));
                },
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                },
                uploadcovershotvisible: function (_uploadcovershotvisible9) {
                  function uploadcovershotvisible(_x1090) {
                    return _uploadcovershotvisible9.apply(this, arguments);
                  }
                  uploadcovershotvisible.toString = function () {
                    return _uploadcovershotvisible9.toString();
                  };
                  return uploadcovershotvisible;
                }(function (obj) {
                  with (obj) return uploadcovershotvisible;
                }),
                "hover(string('upload-covershot-tooltip'))": function hoverStringUploadCovershotTooltip(obj) {
                  with (obj) return hover(string("upload-covershot-tooltip"));
                },
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                covershot_accept_string: function (_covershot_accept_string12) {
                  function covershot_accept_string(_x1091) {
                    return _covershot_accept_string12.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string12.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                showslidercontainer: function (_showslidercontainer9) {
                  function showslidercontainer(_x1092) {
                    return _showslidercontainer9.apply(this, arguments);
                  }
                  showslidercontainer.toString = function () {
                    return _showslidercontainer9.toString();
                  };
                  return showslidercontainer;
                }(function (obj) {
                  with (obj) return showslidercontainer;
                }),
                css: function (_css67) {
                  function css(_x1093) {
                    return _css67.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css67.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "left()": function (_left5) {
                  function left(_x1094) {
                    return _left5.apply(this, arguments);
                  }
                  left.toString = function () {
                    return _left5.toString();
                  };
                  return left;
                }(function (obj) {
                  with (obj) return left();
                }),
                csscommon: function (_csscommon47) {
                  function csscommon(_x1095) {
                    return _csscommon47.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon47.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                images: function (_images5) {
                  function images(_x1096) {
                    return _images5.apply(this, arguments);
                  }
                  images.toString = function () {
                    return _images5.toString();
                  };
                  return images;
                }(function (obj) {
                  with (obj) return images;
                }),
                "select(image)": function selectImage(obj) {
                  with (obj) return select(image);
                },
                "{left: image.left + 'px', top: image.top + 'px', width: image.width + 'px', height: image.height + 'px'}": function leftImageLeftPxTopImageTopPxWidthImageWidthPxHeightImageHeightPx(obj) {
                  with (obj) return {
                    left: image.left + "px",
                    top: image.top + "px",
                    width: image.width + "px",
                    height: image.height + "px"
                  };
                },
                "right()": function (_right5) {
                  function right(_x1097) {
                    return _right5.apply(this, arguments);
                  }
                  right.toString = function () {
                    return _right5.toString();
                  };
                  return right;
                }(function (obj) {
                  with (obj) return right();
                }),
                "!showslidercontainer": function (_showslidercontainer10) {
                  function showslidercontainer(_x1098) {
                    return _showslidercontainer10.apply(this, arguments);
                  }
                  showslidercontainer.toString = function () {
                    return _showslidercontainer10.toString();
                  };
                  return showslidercontainer;
                }(function (obj) {
                  with (obj) return !showslidercontainer;
                }),
                covershot_accept_string: function (_covershot_accept_string13) {
                  function covershot_accept_string(_x1099) {
                    return _covershot_accept_string13.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string13.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                css: function (_css68) {
                  function css(_x1100) {
                    return _css68.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css68.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "initialmessages.length > 0": function initialmessagesLength0(obj) {
                  with (obj) return 0 < initialmessages.length;
                },
                csscommon: function (_csscommon48) {
                  function csscommon(_x1101) {
                    return _csscommon48.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon48.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                initialmessages: function (_initialmessages7) {
                  function initialmessages(_x1102) {
                    return _initialmessages7.apply(this, arguments);
                  }
                  initialmessages.toString = function () {
                    return _initialmessages7.toString();
                  };
                  return initialmessages;
                }(function (obj) {
                  with (obj) return initialmessages;
                }),
                "initialmessage.message": function initialmessageMessage(obj) {
                  with (obj) return initialmessage.message;
                },
                "initialmessage.type ? initialmessage.type : 'default'": function initialmessageTypeInitialmessageTypeDefault(obj) {
                  with (obj) return initialmessage.type ? initialmessage.type : "default";
                },
                "initialmessage.id": function initialmessageId(obj) {
                  with (obj) return initialmessage.id;
                },
                actions: function (_actions12) {
                  function actions(_x1103) {
                    return _actions12.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions12.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.switchcamera": function actionSwitchcamera(obj) {
                  with (obj) return action.switchcamera;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                },
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                }
              }), Parser.registerFunctions({
                cssrecorder: function (_cssrecorder11) {
                  function cssrecorder(_x1104) {
                    return _cssrecorder11.apply(this, arguments);
                  }
                  cssrecorder.toString = function () {
                    return _cssrecorder11.toString();
                  };
                  return cssrecorder;
                }(function (obj) {
                  with (obj) return cssrecorder;
                }),
                "click()": function (_click16) {
                  function click(_x1105) {
                    return _click16.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click16.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                "shortMessage ? 'short-message' : 'long-message'": function shortMessageShortMessageLongMessage(obj) {
                  with (obj) return shortMessage ? "short-message" : "long-message";
                },
                'message || ""': function (_message22) {
                  function message(_x1106) {
                    return _message22.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message22.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links10) {
                  function links(_x1107) {
                    return _links10.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links10.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }), {
                theatre: {
                  css: "ba-videorecorder",
                  csstheme: "ba-recorder-theme-theatre",
                  cssrecorder: "ba-recorder",
                  cssmessage: "ba-videorecorder",
                  cssloader: "ba-videorecorder",
                  tmplcontrolbar: '<div class="{{csstheme}}-dashboard">\n\n\t<div class="{{css}}-settings-front">\n\n\t\t\n\t\t<div data-selector="recorder-settings" class="{{css}}-settings" ba-show="{{settingsvisible && settingsopen}}">\n\t\t\t<div class="{{css}}-bubble-info">\n\t\t\t\t<ul data-selector="add-new-stream" ba-if="{{videoselectnotification}}">\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div data-selector="single-camera-stream">\n\t\t\t\t\t\t\t<i class="ba-commoncss-icon-plus"></i> {{string(\'add-stream\')}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div data-selector="single-camera-stream" class="{{csscommon}}-text-error">\n\t\t\t\t\t\t\t{{videoselectnotification}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\n\t\t\t\t<ul data-selector="add-new-stream" ba-show="{{showaddstreambutton && firefox && allowscreen}}">\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div data-selector="single-camera-stream"\n\t\t\t\t\t\t\t class="{{css}}-add-stream"\n\t\t\t\t\t\t\t onclick="{{addNewStream()}}"\n\t\t\t\t\t\t\t onmouseenter="{{hover(string(\'add-stream\'))}}"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-plus"></i> {{string(\'add-stream\')}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\n\t\t\t\t<ul data-selector="add-new-stream" ba-show="{{showaddstreambutton && !firefox}}" ba-repeat="{{camera :: cameras}}">\n\t\t\t\t\t<li ba-show="{{(camera.id !== selectedcamera) || allowscreen}}">\n\t\t\t\t\t\t<div data-selector="single-camera-stream"\n\t\t\t\t\t\t\t class="{{css}}-add-stream"\n\t\t\t\t\t\t\t onclick="{{addNewStream(camera.id)}}"\n\t\t\t\t\t\t\t onmouseenter="{{hover(string(\'add-stream\'))}}"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-plus"></i> {{camera.label}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\n\t\t\t\t<hr ba-show="{{(showaddstreambutton && !firefox) || (firefox && allowscreen)}}"/>\n\n\t\t\t\t<ul data-selector="camera-settings" ba-repeat="{{camera :: cameras}}" ba-show="{{!novideo && !allowscreen && !ismobile}}">\n\t\t\t\t\t<li onmouseenter="{{hover(string(\'select-camera\'))}}">\n\t\t\t\t\t\t<input tabindex="0"\n\t\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t   type=\'radio\' name=\'camera\'\n\t\t\t\t\t\t\t   value="{{selectedcamera == camera.id}}"\n\t\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t/>\n\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t<label tabindex="0"\n\t\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t{{camera.label}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<hr ba-show="{{(!noaudio && !novideo) || !allowscreen}}"/>\n\t\t\t\t<ul data-selector="microphone-settings" ba-repeat="{{microphone :: microphones}}" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t\t<li tabindex="0"\n\t\t\t\t\t\tba-hotkey:space^enter="{{selectMicrophone(microphone.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\tonmouseenter="{{hover(string(\'select-audio-input\'))}}"\n\t\t\t\t\t\tonclick="{{selectMicrophone(microphone.id)}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<input type=\'radio\' name=\'microphone\' value="{{selectedmicrophone == microphone.id}}" />\n\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t{{microphone.label}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n\t\t<div class="{{css}}-controlbar-center-section">\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{rerecordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="rerecord-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{rerecord()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'rerecord\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{cancelvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="cancel-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{cancel()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'cancel\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-controlbar-left-section">\n\n\t\t\t<div class="{{css}}-indicator-container" ba-show="{{stopvisible && recordingindication}}">\n\t\t\t\t<div data-selector="recording-indicator" class="{{css}}-recording-indication"></div>\n\t\t\t</div>\n\n\t\t\t<div ba-show="{{settingsvisible}}">\n\n\t\t\t\t<div class="{{css}}-button" ba-show="{{ismobile}}">\n                    <div data-selector="face-mode-toggle-icon"\n                         class="{{css}}-button-inner {{css}}-button-circle-unselected"\n                         onclick="{{toggleFaceMode()}}"\n                         onmouseenter="{{hover(string(\'switch-camera\'))}}"\n                    >\n                        <i class="{{csscommon}}-icon-arrows-cw"></i>\n                    </div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="{{css}}-button">\n\n\t\t\t\t\t<div tabindex="0"\n\t\t\t\t\t\t ba-hotkey:space^enter="{{settingsopen=!settingsopen}}" onmouseout="this.blur()"\n\t\t\t\t\t\t data-selector="record-button-icon-cog"\n\t\t\t\t\t\t class="{{css}}-button-inner {{css}}-button-{{settingsopen ? \'selected\' : \'unselected\' }}"\n\t\t\t\t\t\t onclick="{{settingsopen=!settingsopen}}"\n\t\t\t\t\t\t onmouseenter="{{hover(string(\'settings\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-cog"></i>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class="{{css}}-button" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t\t<div data-selector="record-button-icon-mic" class="{{css}}-button-inner"\n\t\t\t\t\t\t onmouseenter="{{hover(string(microphonehealthy ? \'microphonehealthy\' : \'microphoneunhealthy\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-mic {{csscommon}}-icon-state-{{microphonehealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="{{css}}-button" ba-show="{{!novideo && !allowscreen}}">\n\t\t\t\t\t<div data-selector="record-button-icon-videocam" class="{{css}}-button-inner"\n\t\t\t\t\t\t onmouseenter="{{hover(string(camerahealthy ? \'camerahealthy\' : \'cameraunhealthy\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}">\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-videocam {{csscommon}}-icon-state-{{ camerahealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{cssrecorder}}-controlbar-right-section">\n\n\t\t\t<div class="{{css}}-rightbutton-container" ba-show="{{recordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="record-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{record()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'record\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-stop-container" ba-show="{{stopvisible}}">\n\n\t\t\t<div class="{{css}}-timer-container">\n\t\t\t\t<div class="{{css}}-label-container" ba-show="{{controlbarlabel && !rerecordvisible}}">\n\t\t\t\t\t<div data-selector="record-label-block" class="{{css}}-label {{css}}-button-primary">\n\t\t\t\t\t\t{{controlbarlabel}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-stop-button-container">\n\n\t\t\t\t<div class="{{css}}-button">\n\t\t\t\t\t<div tabindex="0" ba-show="{{pausable && !resumevisible}}"\n\t\t\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t\t\t data-selector="pause-primary-button" class="{{css}}-button"\n\t\t\t\t\t\t title="{{string(\'pause-recorder\')}}"\n\t\t\t\t\t\t onclick="{{pause()}}"\n\t\t\t\t\t\t onmouseenter="{{hover(string(\'pause-recorder\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-pause"></i>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div tabindex="0" ba-show="{{pausable && resumevisible}}"\n\t\t\t\t\t\t ba-hotkey:space^enter="{{resume()}}" onmouseout="this.blur()"\n\t\t\t\t\t\t data-selector="resume-primary-button" class="{{css}}-button"\n\t\t\t\t\t\t title="{{string(\'resume-recorder\')}}"\n\t\t\t\t\t\t onclick="{{resume()}}"\n\t\t\t\t\t\t onmouseenter="{{hover(string(\'resume-recorder\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-ccw"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="stop-primary-button"\n\t\t\t\t\t class="{{css}}-button-primary {{mintimeindicator ? css + \'-disabled\': \'\'}}"\n\t\t\t\t\t title="{{mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\')}}"\n\t\t\t\t\t onclick="{{stop()}}"\n\t\t\t\t\t onmouseenter="{{hover(mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'stop\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-centerbutton-container" ba-show="{{skipvisible}}">\n            <div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="skip-primary-button" class="{{css}}-button-primary"\n                 onclick="{{skip()}}"\n                 onmouseenter="{{hover(string(\'skip-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                {{string(\'skip\')}}\n            </div>\n        </div>\n\n\n        <div class="{{css}}-rightbutton-container" ba-if="{{uploadcovershotvisible}}">\n            <div data-selector="covershot-primary-button" class="{{css}}-button-primary"\n                 onmouseenter="{{hover(string(\'upload-covershot-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                <input type="file"\n                       class="{{css}}-chooser-file"\n                       style="height:100px"\n                       onchange="{{uploadCovershot(domEvent)}}"\n                       accept="{{covershot_accept_string}}" />\n                <span>\n                    {{string(\'upload-covershot\')}}\n                </span>\n            </div>\n        </div>\n\n\t</div>\n\n</div>\n',
                  tmplimagegallery: '<div ba-if="{{showslidercontainer}}" data-selector="image-gallery" class="{{css}}-image-gallery-container">\n\t<div data-selector="slider-left-button" class="{{css}}-imagegallery-leftbutton">\n\t\t<div tabindex="0" data-selector="slider-left-inner-button"\n\t\t\t ba-hotkey:space^enter^left="{{left()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-button-inner" onclick="{{left()}}"\n\t\t>\n\t\t\t<i class="{{csscommon}}-icon-left-open"></i>\n\t\t</div>\n\t</div>\n\n\t<div data-selector="images-imagegallery-container" ba-repeat="{{image::images}}" class="{{css}}-imagegallery-container" data-gallery-container>\n\t\t<div tabindex="0" data-selector="imagegallery-selected-image"\n\t\t\t ba-hotkey:space^enter="{{select(image)}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-image"\n\t\t\t ba-styles="{{{left: image.left + \'px\', top: image.top + \'px\', width: image.width + \'px\', height: image.height + \'px\'}}}"\n\t\t\t onclick="{{select(image)}}"\n\t\t>\n\t\t</div>\n\t</div>\n\n\t<div data-selector="slider-right-button" class="{{css}}-imagegallery-rightbutton">\n\t\t<div tabindex="0" data-selector="slider-right-inner-button"\n\t\t\t ba-hotkey:space^enter^right="{{right()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-button-inner"\n\t\t\t onclick="{{right()}}"\n\t\t>\n\t\t\t<i class="{{csscommon}}-icon-right-open"></i>\n\t\t</div>\n\t</div>\n</div>\n\n<div ba-if="{{!showslidercontainer}}" class="{{css}}-chooser-container">\n\t<div data-selector="covershot-primary-button" class="{{css}}-chooser-button-container">\n\t\t<div class="{{css}}-chooser-button-0">\n\t\t\t<input type="file"\n\t\t\t\t   tabindex="0"\n\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t   accept="{{covershot_accept_string}}"\n\t\t\t\t   onchange="{{uploadCovershot(domEvent)}}"\n\t\t\t/>\n\t\t\t<i class="{{csscommon}}-icon-picture"></i>\n\t\t\t<span>\n\t\t\t{{string(\'upload-covershot\')}}\n\t\t</span>\n\t\t</div>\n\t</div>\n</div>\n',
                  tmplchooser: '<div class="{{css}}-chooser-container">\n\t<div ba-if="{{initialmessages.length > 0}}" class="{{csscommon}}-message-container">\n\t\t<ul ba-repeat="{{initialmessage :: initialmessages}}">\n\t\t\t<li ba-if="{{initialmessage.message}}"\n\t\t\t\tclass="{{csscommon}}-message-text {{csscommon}}-message-{{initialmessage.type ? initialmessage.type : \'default\'}}"\n\t\t\t>\n\t\t\t\t{{ initialmessage.message }}\n\t\t\t\t<span ba-if="{{initialmessage.id}}"\n\t\t\t\t\t  class="{{csscommon}}-action-button"\n\t\t\t\t\t  ba-click="close_message(initialmessage.id)"\n\t\t\t\t>\n\t\t\t\t\t<i class="{{csscommon}}-icon-cancel"></i>\n\t\t\t\t</span>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\n\t<div class="{{css}}-chooser-button-container">\n\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t\t ba-click="{{click_action(action)}}">\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture="{{action.switchcamera}}" />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t/>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n',
                  tmplmessage: '<div data-selector="recorder-message-container" class="{{cssrecorder}}-message-container" ba-click="{{click()}}">\n    <div class="{{cssrecorder}}-top-inner-message-container {{cssrecorder}}-{{shortMessage ? \'short-message\' : \'long-message\'}}">\n        <div class="{{cssrecorder}}-first-inner-message-container">\n            <div class="{{cssrecorder}}-second-inner-message-container">\n                <div class="{{cssrecorder}}-third-inner-message-container">\n                    <div class="{{cssrecorder}}-fourth-inner-message-container">\n                        <div data-selector="recorder-message-block" class=\'{{cssrecorder}}-message-message\'>\n                            <p>\n                                {{message || ""}}\n                            </p>\n                            <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n                                <li>\n                                    <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                                        {{link.title}}\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n'
                }
              };
            }), Scoped.extend("module:Assets.imageviewerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                css: function (_css69) {
                  function css(_x1108) {
                    return _css69.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css69.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "activitydelta > 5000 && hideoninactivity ? (css + '-dashboard-hidden') : ''": function activitydelta5000HideoninactivityCssDashboardHidden(obj) {
                  with (obj) return 5e3 < activitydelta && hideoninactivity ? css + "-dashboard-hidden" : "";
                },
                title: function (_title20) {
                  function title(_x1109) {
                    return _title20.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title20.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit23) {
                  function submit(_x1110) {
                    return _submit23.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit23.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable20) {
                  function submittable(_x1111) {
                    return _submittable20.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable20.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-image')": function stringSubmitImage(obj) {
                  with (obj) return string("submit-image");
                },
                "rerecord()": function (_rerecord33) {
                  function rerecord(_x1112) {
                    return _rerecord33.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord33.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable20) {
                  function rerecordable(_x1113) {
                    return _rerecordable20.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable20.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-image')": function stringRerecordImage(obj) {
                  with (obj) return string("rerecord-image");
                },
                csscommon: function (_csscommon49) {
                  function csscommon(_x1114) {
                    return _csscommon49.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon49.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "toggle_fullscreen()": function (_toggle_fullscreen12) {
                  function toggle_fullscreen(_x1115) {
                    return _toggle_fullscreen12.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen12.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                fullscreen: function (_fullscreen12) {
                  function fullscreen(_x1116) {
                    return _fullscreen12.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen12.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-image') : string('fullscreen-image')": function fullscreenedStringExitFullscreenImageStringFullscreenImage(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-image") : string("fullscreen-image");
                },
                "fullscreened ? 'small' : 'full'": function fullscreenedSmallFull(obj) {
                  with (obj) return fullscreened ? "small" : "full";
                }
              }), {
                theatre: {
                  css: "ba-imageviewer",
                  csstheme: "ba-imageviewer-theatre-theme",
                  tmplcontrolbar: '<div data-selector="image-title-block" class="{{css}}-image-title-container {{activitydelta > 5000 && hideoninactivity ? (css + \'-dashboard-hidden\') : \'\'}}"  ba-if="{{title}}">\n    <p class="{{css}}-image-title">\n        {{title}}\n    </p>\n</div>\n<div class="{{css}}-dashboard {{activitydelta > 5000 && hideoninactivity ? (css + \'-dashboard-hidden\') : \'\'}}">\n\n    <div class="{{css}}-left-block">\n\n        <div tabindex="0" data-selector="submit-image-button"\n             ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n             class="{{css}}-leftbutton-container"\n             ba-if="{{submittable}}"  ba-click="{{submit()}}"\n        >\n            <div class="{{css}}-button-inner">\n                {{string(\'submit-image\')}}\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-ccw"\n             ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n             class="{{css}}-leftbutton-container"\n             ba-if="{{rerecordable}}" ba-click="{{rerecord()}}"\n             title="{{string(\'rerecord-image\')}}"\n        >\n            <div class="{{css}}-button-inner">\n                <i class="{{csscommon}}-icon-ccw"></i>\n            </div>\n        </div>\n\n    </div>\n\n    <div class="{{css}}-right-block">\n\n        <div tabindex="8" data-selector="button-icon-resize-full"\n             ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n             onkeydown="{{tab_index_move(domEvent)}}"\n             class="{{css}}-button-container {{css}}-fullscreen-icon-container"\n             ba-if="{{fullscreen}}" ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-image\') : string(\'fullscreen-image\') }}"\n        >\n            <div class="{{css}}-button-inner {{css}}-full-screen-btn-inner">\n                <i class="{{csscommon}}-icon-resize-{{fullscreened ? \'small\' : \'full\'}}"></i>\n            </div>\n        </div>\n\n\n    </div>\n\n</div>\n',
                  cssloader: ie8 ? "ba-imageviewer" : "",
                  cssmessage: "ba-imageviewer"
                }
              };
            }), Scoped.extend("module:Assets.audioplayerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                csstheme: function (_csstheme25) {
                  function csstheme(_x1117) {
                    return _csstheme25.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme25.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                title: function (_title21) {
                  function title(_x1118) {
                    return _title21.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title21.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "submit()": function (_submit24) {
                  function submit(_x1119) {
                    return _submit24.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit24.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable21) {
                  function submittable(_x1120) {
                    return _submittable21.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable21.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-audio')": function stringSubmitAudio(obj) {
                  with (obj) return string("submit-audio");
                },
                "rerecord()": function (_rerecord34) {
                  function rerecord(_x1121) {
                    return _rerecord34.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord34.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable21) {
                  function rerecordable(_x1122) {
                    return _rerecordable21.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable21.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-audio')": function stringRerecordAudio(obj) {
                  with (obj) return string("rerecord-audio");
                },
                csscommon: function (_csscommon50) {
                  function csscommon(_x1123) {
                    return _csscommon50.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon50.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "play()": function (_play18) {
                  function play(_x1124) {
                    return _play18.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play18.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "!playing": function (_playing25) {
                  function playing(_x1125) {
                    return _playing25.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing25.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "string('play-audio')": function stringPlayAudio(obj) {
                  with (obj) return string("play-audio");
                },
                "pause()": function (_pause18) {
                  function pause(_x1126) {
                    return _pause18.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause18.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                playing: function (_playing26) {
                  function playing(_x1127) {
                    return _playing26.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing26.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "disablepause ? string('pause-audio-disabled') : string('pause-audio')": function disablepauseStringPauseAudioDisabledStringPauseAudio(obj) {
                  with (obj) return disablepause ? string("pause-audio-disabled") : string("pause-audio");
                },
                "toggle_volume()": function (_toggle_volume12) {
                  function toggle_volume(_x1128) {
                    return _toggle_volume12.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume12.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                },
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "startVerticallyUpdateVolume(domEvent)": function startVerticallyUpdateVolumeDomEvent(obj) {
                  with (obj) return startVerticallyUpdateVolume(domEvent);
                },
                "stopVerticallyUpdateVolume(domEvent)": function stopVerticallyUpdateVolumeDomEvent(obj) {
                  with (obj) return stopVerticallyUpdateVolume(domEvent);
                },
                "progressVerticallyUpdateVolume(domEvent)": function progressVerticallyUpdateVolumeDomEvent(obj) {
                  with (obj) return progressVerticallyUpdateVolume(domEvent);
                },
                "{height: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + '%'}": function heightMathCeil1MathMin99MathRoundVolume100(obj) {
                  with (obj) return {
                    height: Math.ceil(1 + Math.min(99, Math.round(100 * volume))) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                "string('elapsed-time')": function stringElapsedTime(obj) {
                  with (obj) return string("elapsed-time");
                },
                "formatTime(position)": function formatTimePosition(obj) {
                  with (obj) return formatTime(position);
                },
                "string('total-time')": function stringTotalTime(obj) {
                  with (obj) return string("total-time");
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "stopUpdatePosition(domEvent)": function stopUpdatePositionDomEvent(obj) {
                  with (obj) return stopUpdatePosition(domEvent);
                },
                "progressUpdatePosition(domEvent)": function progressUpdatePositionDomEvent(obj) {
                  with (obj) return progressUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('audio-progress')": function stringAudioProgress(obj) {
                  with (obj) return string("audio-progress");
                }
              }), {
                theatre: {
                  css: "ba-audioplayer",
                  csstheme: "ba-player-theatre-theme",
                  tmplcontrolbar: '<div data-selector="audio-title-block" class="{{csstheme}}-title-container "  ba-if="{{title}}">\n    <p class="{{csstheme}}-title">\n        {{title}}\n    </p>\n</div>\n<div class="{{csstheme}}-dashboard ">\n\n    <div class="{{csstheme}}-left-block">\n\n        <div tabindex="0" data-selector="submit-audio-button"\n             ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-leftbutton-container"\n             ba-if="{{submittable}}"  ba-click="{{submit()}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                {{string(\'submit-audio\')}}\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-ccw"\n             ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n             class="{{csstheme}}-leftbutton-container"\n             ba-if="{{rerecordable}}" ba-click="{{rerecord()}}"\n             title="{{string(\'rerecord-audio\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-ccw"></i>\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-play"\n             ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}"\n             class="{{csstheme}}-button-container"\n             ba-if="{{!playing}}" ba-click="{{play()}}" title="{{string(\'play-audio\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-play"></i>\n            </div>\n        </div>\n\n        <div tabindex="0" data-selector="button-icon-pause"\n             ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n             onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}"\n             class="{{csstheme}}-button-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n             ba-if="{{playing}}" ba-click="{{pause()}}" title="{{disablepause ? string(\'pause-audio-disabled\') : string(\'pause-audio\')}}"\n        >\n            <div class="{{csstheme}}-button-inner">\n                <i class="{{csscommon}}-icon-pause"></i>\n            </div>\n        </div>\n\n        <div class="{{csstheme}}-volume-icon-container">\n\n            <div tabindex="2" data-selector="button-icon-volume"\n                 ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n                 class="{{csstheme}}-button-container"\n                 ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n                </div>\n            </div>\n\n            <div class="{{csstheme}}-volumebar">\n                <div tabindex="-1" data-selector="button-volume-bar"\n                     ba-hotkey:up="{{set_volume(volume + 0.1)}}"\n                     ba-hotkey:down="{{set_volume(volume - 0.1)}}"\n                     onmouseout="this.blur()"\n                     class="{{csstheme}}-volumebar-inner"\n                     onmousedown="{{startVerticallyUpdateVolume(domEvent)}}"\n                     onmouseup="{{stopVerticallyUpdateVolume(domEvent)}}"\n                     onmouseleave="{{stopVerticallyUpdateVolume(domEvent)}}"\n                     onmousemove="{{progressVerticallyUpdateVolume(domEvent)}}"\n                >\n                    <div class="{{csstheme}}-volumebar-position" ba-styles="{{{height: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + \'%\'}}}" title="{{string(\'volume-button\')}}"></div>\n                </div>\n            </div>\n        </div>\n\n        <div class="{{csstheme}}-time-container">\n            <div class="{{csstheme}}-time-value" title="{{string(\'elapsed-time\')}}">{{formatTime(position)}}</div>\n        </div>\n    </div>\n\n    <div class="{{csstheme}}-right-block">\n\n        <div class="{{csstheme}}-time-container {{csstheme}}-right-time-container">\n            <div class="{{csstheme}}-time-value" title="{{string(\'total-time\')}}">{{formatTime(duration || position)}}</div>\n        </div>\n\n    </div>\n\n    <div class="{{csstheme}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}">\n        <div tabindex="4" data-selector="progress-bar-inner"\n             ba-hotkey:right="{{seek(position + skipseconds)}}"\n             ba-hotkey:left="{{seek(position - skipseconds)}}"\n             onmouseout="this.blur()"\n             class="{{csstheme}}-progressbar-inner"\n             onmousedown="{{startUpdatePosition(domEvent)}}"\n             onmouseup="{{stopUpdatePosition(domEvent)}}"\n             onmouseleave="{{stopUpdatePosition(domEvent)}}"\n             onmousemove="{{progressUpdatePosition(domEvent)}}"\n        >\n\n            <div class="{{csstheme}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n            <div class="{{csstheme}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'audio-progress\')}}">\n                <div class="{{csstheme}}-progressbar-button"></div>\n            </div>\n        </div>\n    </div>\n\n</div>\n',
                  cssloader: ie8 ? "ba-audioplayer" : "",
                  cssmessage: "ba-audioplayer",
                  cssplaybutton: ie8 ? "ba-audioplayer" : ""
                }
              };
            }), Scoped.extend("module:Assets.audiorecorderthemes", ["dynamics:Parser"], function (Parser) {
              return Parser.registerFunctions({
                csstheme: function (_csstheme26) {
                  function csstheme(_x1129) {
                    return _csstheme26.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme26.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                css: function (_css70) {
                  function css(_x1130) {
                    return _css70.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css70.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "settingsvisible && settingsopen": function settingsvisibleSettingsopen(obj) {
                  with (obj) return settingsvisible && settingsopen;
                },
                cameras: function (_cameras12) {
                  function cameras(_x1131) {
                    return _cameras12.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras12.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "selectCamera(camera.id)": function selectCameraCameraId(obj) {
                  with (obj) return selectCamera(camera.id);
                },
                "selectedcamera == camera.id": function selectedcameraCameraId(obj) {
                  with (obj) return selectedcamera == camera.id;
                },
                "camera.label": function cameraLabel(obj) {
                  with (obj) return camera.label;
                },
                microphones: function (_microphones12) {
                  function microphones(_x1132) {
                    return _microphones12.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones12.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                audio: function (_audio4) {
                  function audio(_x1133) {
                    return _audio4.apply(this, arguments);
                  }
                  audio.toString = function () {
                    return _audio4.toString();
                  };
                  return audio;
                }(function (obj) {
                  with (obj) return audio;
                }),
                "selectMicrophone(microphone.id)": function selectMicrophoneMicrophoneId(obj) {
                  with (obj) return selectMicrophone(microphone.id);
                },
                "selectedmicrophone == microphone.id": function selectedmicrophoneMicrophoneId(obj) {
                  with (obj) return selectedmicrophone == microphone.id;
                },
                "microphone.label": function microphoneLabel(obj) {
                  with (obj) return microphone.label;
                },
                rerecordvisible: function (_rerecordvisible14) {
                  function rerecordvisible(_x1134) {
                    return _rerecordvisible14.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible14.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord35) {
                  function rerecord(_x1135) {
                    return _rerecord35.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord35.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "unhover()": function (_unhover11) {
                  function unhover(_x1136) {
                    return _unhover11.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover11.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible11) {
                  function cancelvisible(_x1137) {
                    return _cancelvisible11.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible11.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel11) {
                  function cancel(_x1138) {
                    return _cancel11.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel11.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                },
                settingsvisible: function (_settingsvisible14) {
                  function settingsvisible(_x1139) {
                    return _settingsvisible14.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible14.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                csscommon: function (_csscommon51) {
                  function csscommon(_x1140) {
                    return _csscommon51.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon51.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "!noaudio && !allowscreen": function noaudioAllowscreen(obj) {
                  with (obj) return !noaudio && !allowscreen;
                },
                "hover(string(microphonehealthy ? 'microphonehealthy' : 'microphoneunhealthy'))": function hoverStringMicrophonehealthyMicrophonehealthyMicrophoneunhealthy(obj) {
                  with (obj) return hover(string(microphonehealthy ? "microphonehealthy" : "microphoneunhealthy"));
                },
                "microphonehealthy ? 'good' : 'bad'": function microphonehealthyGoodBad(obj) {
                  with (obj) return microphonehealthy ? "good" : "bad";
                },
                "hover(string(camerahealthy ? 'camerahealthy' : 'cameraunhealthy'))": function hoverStringCamerahealthyCamerahealthyCameraunhealthy(obj) {
                  with (obj) return hover(string(camerahealthy ? "camerahealthy" : "cameraunhealthy"));
                },
                "camerahealthy ? 'good' : 'bad'": function camerahealthyGoodBad(obj) {
                  with (obj) return camerahealthy ? "good" : "bad";
                },
                recordvisible: function (_recordvisible14) {
                  function recordvisible(_x1141) {
                    return _recordvisible14.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible14.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record11) {
                  function record(_x1142) {
                    return _record11.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record11.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                stopvisible: function (_stopvisible12) {
                  function stopvisible(_x1143) {
                    return _stopvisible12.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible12.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                "controlbarlabel && !rerecordvisible": function controlbarlabelRerecordvisible(obj) {
                  with (obj) return controlbarlabel && !rerecordvisible;
                },
                controlbarlabel: function (_controlbarlabel14) {
                  function controlbarlabel(_x1144) {
                    return _controlbarlabel14.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel14.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                "stop()": function (_stop10) {
                  function stop(_x1145) {
                    return _stop10.apply(this, arguments);
                  }
                  stop.toString = function () {
                    return _stop10.toString();
                  };
                  return stop;
                }(function (obj) {
                  with (obj) return stop();
                }),
                "mintimeindicator ? css + '-disabled': ''": function mintimeindicatorCssDisabled(obj) {
                  with (obj) return mintimeindicator ? css + "-disabled" : "";
                },
                "mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip')": function mintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip");
                },
                "hover(mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip'))": function hoverMintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return hover(mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip"));
                },
                "string('stop')": function stringStop(obj) {
                  with (obj) return string("stop");
                },
                skipvisible: function (_skipvisible10) {
                  function skipvisible(_x1146) {
                    return _skipvisible10.apply(this, arguments);
                  }
                  skipvisible.toString = function () {
                    return _skipvisible10.toString();
                  };
                  return skipvisible;
                }(function (obj) {
                  with (obj) return skipvisible;
                }),
                "skip()": function (_skip16) {
                  function skip(_x1147) {
                    return _skip16.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip16.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "hover(string('skip-tooltip'))": function hoverStringSkipTooltip(obj) {
                  with (obj) return hover(string("skip-tooltip"));
                },
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                },
                uploadcovershotvisible: function (_uploadcovershotvisible10) {
                  function uploadcovershotvisible(_x1148) {
                    return _uploadcovershotvisible10.apply(this, arguments);
                  }
                  uploadcovershotvisible.toString = function () {
                    return _uploadcovershotvisible10.toString();
                  };
                  return uploadcovershotvisible;
                }(function (obj) {
                  with (obj) return uploadcovershotvisible;
                }),
                "hover(string('upload-covershot-tooltip'))": function hoverStringUploadCovershotTooltip(obj) {
                  with (obj) return hover(string("upload-covershot-tooltip"));
                },
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                covershot_accept_string: function (_covershot_accept_string14) {
                  function covershot_accept_string(_x1149) {
                    return _covershot_accept_string14.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string14.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                css: function (_css71) {
                  function css(_x1150) {
                    return _css71.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css71.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                actions: function (_actions13) {
                  function actions(_x1151) {
                    return _actions13.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions13.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                },
                csscommon: function (_csscommon52) {
                  function csscommon(_x1152) {
                    return _csscommon52.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon52.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                }
              }), Parser.registerFunctions({
                css: function (_css72) {
                  function css(_x1153) {
                    return _css72.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css72.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click17) {
                  function click(_x1154) {
                    return _click17.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click17.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                "shortMessage ? 'short-message' : 'long-message'": function shortMessageShortMessageLongMessage(obj) {
                  with (obj) return shortMessage ? "short-message" : "long-message";
                },
                'message || ""': function (_message23) {
                  function message(_x1155) {
                    return _message23.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message23.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links11) {
                  function links(_x1156) {
                    return _links11.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links11.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }), {
                theatre: {
                  css: "ba-audiorecorder",
                  csstheme: "ba-audiorecorder-theme-theatre",
                  cssrecorder: "ba-recorder",
                  cssmessage: "ba-audiorecorder",
                  cssloader: "ba-audiorecorder",
                  tmplcontrolbar: '<div class="{{csstheme}}-dashboard">\n\n\t<div class="{{css}}-settings-front">\n\n\t\t\n\t\t<div data-selector="recorder-settings" class="{{css}}-settings" ba-show="{{settingsvisible && settingsopen}}">\n\t\t\t<div class="{{css}}-bubble-info">\n\t\t\t\t<ul data-selector="camera-settings" ba-repeat="{{camera :: cameras}}">\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<input tabindex="0"\n\t\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t   type=\'radio\' name=\'camera\'\n\t\t\t\t\t\t\t   value="{{selectedcamera == camera.id}}"\n\t\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t/>\n\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t<label tabindex="0"\n\t\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t{{camera.label}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<ul data-selector="microphone-settings" ba-repeat="{{microphone :: microphones}}" ba-show="{{audio}}">\n\t\t\t\t\t<li tabindex="0"\n\t\t\t\t\t\tba-hotkey:space^enter="{{selectMicrophone(microphone.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\tonclick="{{selectMicrophone(microphone.id)}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<input type=\'radio\' name=\'microphone\' value="{{selectedmicrophone == microphone.id}}" />\n\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t{{microphone.label}}\n\t\t\t\t\t\t</label>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n\t\t<div class="{{css}}-controlbar-center-section">\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{rerecordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="rerecord-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{rerecord()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'rerecord\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{cancelvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="cancel-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{cancel()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'cancel\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-controlbar-left-section" ba-show="{{settingsvisible}}">\n\n            <div class="{{css}}-button" ba-show="{{settingsvisible}}">\n\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{settingsopen=!settingsopen}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="record-button-icon-cog"\n\t\t\t\t\t class="{{css}}-button-inner {{css}}-button-{{settingsopen ? \'selected\' : \'unselected\' }}"\n\t\t\t\t\t onclick="{{settingsopen=!settingsopen}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'settings\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t<i class="{{csscommon}}-icon-cog"></i>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-button" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t<div data-selector="record-button-icon-mic" class="{{css}}-button-inner"\n\t\t\t\t\tonmouseenter="{{hover(string(microphonehealthy ? \'microphonehealthy\' : \'microphoneunhealthy\'))}}"\n\t\t\t\t\tonmouseleave="{{unhover()}}">\n\t\t\t\t\t<i class="{{csscommon}}-icon-mic {{csscommon}}-icon-state-{{microphonehealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-button" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t<div data-selector="record-button-icon-audiocam" class="{{css}}-button-inner"\n\t\t\t\t\tonmouseenter="{{hover(string(camerahealthy ? \'camerahealthy\' : \'cameraunhealthy\'))}}"\n\t\t\t\t\tonmouseleave="{{unhover()}}">\n                    <i class="{{csscommon}}-icon-audiocam {{csscommon}}-icon-state-{{ camerahealthy ? \'good\' : \'bad\' }}"></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="{{css}}-controlbar-right-section">\n\n\t\t\t<div class="{{css}}-rightbutton-container" ba-show="{{recordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="record-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{record()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'record\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-stop-container" ba-show="{{stopvisible}}">\n\n\t\t\t<div class="{{css}}-timer-container">\n\t\t\t\t<div class="{{css}}-label-container" ba-show="{{controlbarlabel && !rerecordvisible}}">\n\t\t\t\t\t<div data-selector="record-label-block" class="{{css}}-label {{css}}-button-primary">\n\t\t\t\t\t\t{{controlbarlabel}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-stop-button-container">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="stop-primary-button"\n\t\t\t\t\t class="{{css}}-button-primary {{mintimeindicator ? css + \'-disabled\': \'\'}}"\n\t\t\t\t\t title="{{mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\')}}"\n\t\t\t\t\t onclick="{{stop()}}"\n\t\t\t\t\t onmouseenter="{{hover(mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'stop\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-centerbutton-container" ba-show="{{skipvisible}}">\n            <div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="skip-primary-button" class="{{css}}-button-primary"\n                 onclick="{{skip()}}"\n                 onmouseenter="{{hover(string(\'skip-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                {{string(\'skip\')}}\n            </div>\n        </div>\n\n\n        <div class="{{css}}-rightbutton-container" ba-if="{{uploadcovershotvisible}}">\n            <div data-selector="covershot-primary-button" class="{{css}}-button-primary"\n                 onmouseenter="{{hover(string(\'upload-covershot-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                <input type="file"\n                       class="{{css}}-chooser-file"\n                       style="height:100px"\n                       onchange="{{uploadCovershot(domEvent)}}"\n                       accept="{{covershot_accept_string}}" />\n                <span>\n                    {{string(\'upload-covershot\')}}\n                </span>\n            </div>\n        </div>\n\n\t</div>\n\n</div>\n',
                  tmplchooser: '<div class="{{css}}-chooser-container">\n\n\t<div class="{{css}}-chooser-button-container">\n\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t\t ba-click="{{click_action(action)}}">\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t/>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>',
                  tmplmessage: '<div data-selector="recorder-message-container" class="{{css}}-message-container" ba-click="{{click()}}">\n    <div class="{{css}}-top-inner-message-container {{css}}-{{shortMessage ? \'short-message\' : \'long-message\'}}">\n        <div class="{{css}}-first-inner-message-container">\n            <div class="{{css}}-second-inner-message-container">\n                <div class="{{css}}-third-inner-message-container">\n                    <div class="{{css}}-fourth-inner-message-container">\n                        <div data-selector="recorder-message-block" class=\'{{css}}-message-message\'>\n                            <p>\n                                {{message || ""}}\n                            </p>\n                            <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n                                <li>\n                                    <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                                        {{link.title}}\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n'
                }
              };
            });
          }.call(Scoped), function () {
            var Scoped = this.subScope();
            Scoped.binding("browser", "root:BetaJS.Browser"), Scoped.binding("dynamics", "root:BetaJS.Dynamics"), Scoped.binding("module", "root:BetaJS.MediaComponents"), Scoped.extend("module:Assets.playerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                csstheme: function (_csstheme27) {
                  function csstheme(_x1157) {
                    return _csstheme27.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme27.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                "activitydelta > hidebarafter && hideoninactivity ? (cssplayer + '-dashboard-hidden') : ''": function activitydeltaHidebarafterHideoninactivityCssplayerDashboardHidden(obj) {
                  with (obj) return activitydelta > hidebarafter && hideoninactivity ? cssplayer + "-dashboard-hidden" : "";
                },
                csscommon: function (_csscommon53) {
                  function csscommon(_x1158) {
                    return _csscommon53.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon53.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "toggle_position_info()": function (_toggle_position_info7) {
                  function toggle_position_info(_x1159) {
                    return _toggle_position_info7.apply(this, arguments);
                  }
                  toggle_position_info.toString = function () {
                    return _toggle_position_info7.toString();
                  };
                  return toggle_position_info;
                }(function (obj) {
                  with (obj) return toggle_position_info();
                }),
                "revertposition ? string('remaining-time') : string('elapsed-time')": function revertpositionStringRemainingTimeStringElapsedTime(obj) {
                  with (obj) return revertposition ? string("remaining-time") : string("elapsed-time");
                },
                'revertposition ? "-" : ""': function (_revertposition2) {
                  function revertposition(_x1160) {
                    return _revertposition2.apply(this, arguments);
                  }
                  revertposition.toString = function () {
                    return _revertposition2.toString();
                  };
                  return revertposition;
                }(function (obj) {
                  with (obj) return revertposition ? "-" : "";
                }),
                "revertposition ? formatTime(duration - position) : formatTime(position)": function revertpositionFormatTimeDurationPositionFormatTimePosition(obj) {
                  with (obj) return revertposition ? formatTime(duration - position) : formatTime(position);
                },
                "string('total-time')": function stringTotalTime(obj) {
                  with (obj) return string("total-time");
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "skipinitial ? 2 : 1": function skipinitial21(obj) {
                  with (obj) return skipinitial ? 2 : 1;
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('video-progress')": function stringVideoProgress(obj) {
                  with (obj) return string("video-progress");
                },
                "string('elapsed-time')": function stringElapsedTime(obj) {
                  with (obj) return string("elapsed-time");
                },
                "formatTime(position)": function formatTimePosition(obj) {
                  with (obj) return formatTime(position);
                },
                trimmingmode: function (_trimmingmode14) {
                  function trimmingmode(_x1161) {
                    return _trimmingmode14.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode14.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + '%'}": function leftMathRoundDurationTrimstartTrimstartDuration1000(obj) {
                  with (obj) return {
                    left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + "%"
                  };
                },
                "{left: 'auto', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + '%'}": function leftAutoRight100MathRoundDurationTrimendTrimendDuration100100(obj) {
                  with (obj) return {
                    left: "auto",
                    right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + "%"
                  };
                },
                "submit()": function (_submit25) {
                  function submit(_x1162) {
                    return _submit25.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit25.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable22) {
                  function submittable(_x1163) {
                    return _submittable22.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable22.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecord()": function (_rerecord36) {
                  function rerecord(_x1164) {
                    return _rerecord36.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord36.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable22) {
                  function rerecordable(_x1165) {
                    return _rerecordable22.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable22.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-video')": function stringRerecordVideo(obj) {
                  with (obj) return string("rerecord-video");
                },
                "skipinitial ? 0 : 2": function skipinitial02(obj) {
                  with (obj) return skipinitial ? 0 : 2;
                },
                "play()": function (_play19) {
                  function play(_x1166) {
                    return _play19.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play19.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "!playing": function (_playing27) {
                  function playing(_x1167) {
                    return _playing27.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing27.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "string('play-video')": function stringPlayVideo(obj) {
                  with (obj) return string("play-video");
                },
                "pause()": function (_pause19) {
                  function pause(_x1168) {
                    return _pause19.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause19.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                playing: function (_playing28) {
                  function playing(_x1169) {
                    return _playing28.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing28.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "disablepause ? string('pause-video-disabled') : string('pause-video')": function disablepauseStringPauseVideoDisabledStringPauseVideo(obj) {
                  with (obj) return disablepause ? string("pause-video-disabled") : string("pause-video");
                },
                "toggle_volume()": function (_toggle_volume13) {
                  function toggle_volume(_x1170) {
                    return _toggle_volume13.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume13.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                },
                "!hidevolumebar": function (_hidevolumebar8) {
                  function hidevolumebar(_x1171) {
                    return _hidevolumebar8.apply(this, arguments);
                  }
                  hidevolumebar.toString = function () {
                    return _hidevolumebar8.toString();
                  };
                  return hidevolumebar;
                }(function (obj) {
                  with (obj) return !hidevolumebar;
                }),
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "startUpdateVolume(domEvent)": function startUpdateVolumeDomEvent(obj) {
                  with (obj) return startUpdateVolume(domEvent);
                },
                "progressUpdateVolume(domEvent)": function progressUpdateVolumeDomEvent(obj) {
                  with (obj) return progressUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent); this.blur()": function stopUpdateVolumeDomEventThisBlur(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent)": function stopUpdateVolumeDomEvent(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + '%'}": function widthMathCeil1MathMin99MathRoundVolume100(obj) {
                  with (obj) return {
                    width: Math.ceil(1 + Math.min(99, Math.round(100 * volume))) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                title: function (_title22) {
                  function title(_x1172) {
                    return _title22.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title22.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "toggle_stream()": function (_toggle_stream7) {
                  function toggle_stream(_x1173) {
                    return _toggle_stream7.apply(this, arguments);
                  }
                  toggle_stream.toString = function () {
                    return _toggle_stream7.toString();
                  };
                  return toggle_stream;
                }(function (obj) {
                  with (obj) return toggle_stream();
                }),
                "streams.length > 1 && currentstream": function streamsLength1Currentstream(obj) {
                  with (obj) return 1 < streams.length && currentstream;
                },
                "string('change-resolution')": function stringChangeResolution(obj) {
                  with (obj) return string("change-resolution");
                },
                currentstream_label: function (_currentstream_label7) {
                  function currentstream_label(_x1174) {
                    return _currentstream_label7.apply(this, arguments);
                  }
                  currentstream_label.toString = function () {
                    return _currentstream_label7.toString();
                  };
                  return currentstream_label;
                }(function (obj) {
                  with (obj) return currentstream_label;
                }),
                "show_airplay_devices()": function (_show_airplay_devices7) {
                  function show_airplay_devices(_x1175) {
                    return _show_airplay_devices7.apply(this, arguments);
                  }
                  show_airplay_devices.toString = function () {
                    return _show_airplay_devices7.toString();
                  };
                  return show_airplay_devices;
                }(function (obj) {
                  with (obj) return show_airplay_devices();
                }),
                cssplayer: function (_cssplayer19) {
                  function cssplayer(_x1176) {
                    return _cssplayer19.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer19.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                airplaybuttonvisible: function (_airplaybuttonvisible8) {
                  function airplaybuttonvisible(_x1177) {
                    return _airplaybuttonvisible8.apply(this, arguments);
                  }
                  airplaybuttonvisible.toString = function () {
                    return _airplaybuttonvisible8.toString();
                  };
                  return airplaybuttonvisible;
                }(function (obj) {
                  with (obj) return airplaybuttonvisible;
                }),
                castbuttonvisble: function (_castbuttonvisble8) {
                  function castbuttonvisble(_x1178) {
                    return _castbuttonvisble8.apply(this, arguments);
                  }
                  castbuttonvisble.toString = function () {
                    return _castbuttonvisble8.toString();
                  };
                  return castbuttonvisble;
                }(function (obj) {
                  with (obj) return castbuttonvisble;
                }),
                "toggle_settings_menu()": function (_toggle_settings_menu7) {
                  function toggle_settings_menu(_x1179) {
                    return _toggle_settings_menu7.apply(this, arguments);
                  }
                  toggle_settings_menu.toString = function () {
                    return _toggle_settings_menu7.toString();
                  };
                  return toggle_settings_menu;
                }(function (obj) {
                  with (obj) return toggle_settings_menu();
                }),
                "settingsmenuactive ? 'active' : 'inactive'": function settingsmenuactiveActiveInactive(obj) {
                  with (obj) return settingsmenuactive ? "active" : "inactive";
                },
                settingsmenubutton: function (_settingsmenubutton7) {
                  function settingsmenubutton(_x1180) {
                    return _settingsmenubutton7.apply(this, arguments);
                  }
                  settingsmenubutton.toString = function () {
                    return _settingsmenubutton7.toString();
                  };
                  return settingsmenubutton;
                }(function (obj) {
                  with (obj) return settingsmenubutton;
                }),
                "string('settings')": function stringSettings(obj) {
                  with (obj) return string("settings");
                },
                "tab_index_move(domEvent)": function tab_index_moveDomEvent(obj) {
                  with (obj) return tab_index_move(domEvent);
                },
                "toggle_fullscreen()": function (_toggle_fullscreen13) {
                  function toggle_fullscreen(_x1181) {
                    return _toggle_fullscreen13.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen13.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                "fullscreened ? 'active' : 'inactive'": function fullscreenedActiveInactive(obj) {
                  with (obj) return fullscreened ? "active" : "inactive";
                },
                fullscreen: function (_fullscreen13) {
                  function fullscreen(_x1182) {
                    return _fullscreen13.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen13.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-video') : string('fullscreen-video')": function fullscreenedStringExitFullscreenVideoStringFullscreenVideo(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-video") : string("fullscreen-video");
                },
                "fullscreened ? 'small' : 'full'": function fullscreenedSmallFull(obj) {
                  with (obj) return fullscreened ? "small" : "full";
                },
                "toggle_tracks()": function (_toggle_tracks7) {
                  function toggle_tracks(_x1183) {
                    return _toggle_tracks7.apply(this, arguments);
                  }
                  toggle_tracks.toString = function () {
                    return _toggle_tracks7.toString();
                  };
                  return toggle_tracks;
                }(function (obj) {
                  with (obj) return toggle_tracks();
                }),
                "(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload": function tracktagsLength0ShowsubtitlebuttonAllowtexttrackupload(obj) {
                  with (obj) return 0 < tracktags.length && showsubtitlebutton || allowtexttrackupload;
                },
                "tracktextvisible ? 'active' : 'inactive'": function tracktextvisibleActiveInactive(obj) {
                  with (obj) return tracktextvisible ? "active" : "inactive";
                },
                "tracktextvisible ? string('close-tracks') : string('show-tracks')": function tracktextvisibleStringCloseTracksStringShowTracks(obj) {
                  with (obj) return tracktextvisible ? string("close-tracks") : string("show-tracks");
                },
                "hover_cc(true)": function hover_ccTrue(obj) {
                  with (obj) return hover_cc(!0);
                },
                "hover_cc(false)": function hover_ccFalse(obj) {
                  with (obj) return hover_cc(!1);
                },
                "trim()": function (_trim8) {
                  function trim(_x1184) {
                    return _trim8.apply(this, arguments);
                  }
                  trim.toString = function () {
                    return _trim8.toString();
                  };
                  return trim;
                }(function (obj) {
                  with (obj) return trim();
                }),
                "string('trim-video')": function stringTrimVideo(obj) {
                  with (obj) return string("trim-video");
                },
                frameselectionmode: function (_frameselectionmode9) {
                  function frameselectionmode(_x1185) {
                    return _frameselectionmode9.apply(this, arguments);
                  }
                  frameselectionmode.toString = function () {
                    return _frameselectionmode9.toString();
                  };
                  return frameselectionmode;
                }(function (obj) {
                  with (obj) return frameselectionmode;
                }),
                "select_frame()": function (_select_frame7) {
                  function select_frame(_x1186) {
                    return _select_frame7.apply(this, arguments);
                  }
                  select_frame.toString = function () {
                    return _select_frame7.toString();
                  };
                  return select_frame;
                }(function (obj) {
                  with (obj) return select_frame();
                }),
                "string('select-frame')": function stringSelectFrame(obj) {
                  with (obj) return string("select-frame");
                }
              }), Parser.registerFunctions({
                "play()": function (_play20) {
                  function play(_x1187) {
                    return _play20.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play20.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'player-toggle-overlay')": function tab_index_moveDomEventNullPlayerToggleOverlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "player-toggle-overlay");
                },
                cssplayer: function (_cssplayer20) {
                  function cssplayer(_x1188) {
                    return _cssplayer20.apply(this, arguments);
                  }
                  cssplayer.toString = function () {
                    return _cssplayer20.toString();
                  };
                  return cssplayer;
                }(function (obj) {
                  with (obj) return cssplayer;
                }),
                "string('tooltip')": function stringTooltip(obj) {
                  with (obj) return string("tooltip");
                },
                "showduration && (duration != 0 && duration != undefined)": function showdurationDuration0DurationUndefined(obj) {
                  with (obj) return showduration && 0 != duration && duration != undefined;
                },
                css: function (_css73) {
                  function css(_x1189) {
                    return _css73.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css73.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "formatTime(duration)": function formatTimeDuration(obj) {
                  with (obj) return formatTime(duration);
                },
                "rerecordable || submittable": function rerecordableSubmittable(obj) {
                  with (obj) return rerecordable || submittable;
                },
                "submittable && !trimmingmode": function submittableTrimmingmode(obj) {
                  with (obj) return submittable && !trimmingmode;
                },
                "submit()": function (_submit26) {
                  function submit(_x1190) {
                    return _submit26.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit26.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                "string('submit-video')": function stringSubmitVideo(obj) {
                  with (obj) return string("submit-video");
                },
                "rerecordable && !trimmingmode": function rerecordableTrimmingmode(obj) {
                  with (obj) return rerecordable && !trimmingmode;
                },
                "rerecord()": function (_rerecord37) {
                  function rerecord(_x1191) {
                    return _rerecord37.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord37.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                trimmingmode: function (_trimmingmode15) {
                  function trimmingmode(_x1192) {
                    return _trimmingmode15.apply(this, arguments);
                  }
                  trimmingmode.toString = function () {
                    return _trimmingmode15.toString();
                  };
                  return trimmingmode;
                }(function (obj) {
                  with (obj) return trimmingmode;
                }),
                "string('trim')": function stringTrim(obj) {
                  with (obj) return string("trim");
                },
                "skip()": function (_skip17) {
                  function skip(_x1193) {
                    return _skip17.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip17.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                }
              }), {
                elevate: {
                  css: "ba-videoplayer",
                  csstheme: "ba-player-elevate-theme",
                  cssplayer: "ba-player",
                  tmplcontrolbar: '\n<div class="{{csstheme}}-dashboard {{activitydelta > hidebarafter && hideoninactivity ? (cssplayer + \'-dashboard-hidden\') : \'\'}}">\n\n    <div class="{{csstheme}}-top-block">\n\n        <div class="{{csstheme}}-top-left-block {{csscommon}}-clickable" ba-click="{{toggle_position_info()}}">\n            <div class="{{csstheme}}-time-container {{csstheme}}-left-time-container">\n                <div class="{{csstheme}}-time-value"\n                     title="{{revertposition ? string(\'remaining-time\') : string(\'elapsed-time\')}}"\n                >\n                    {{revertposition ? "-" : ""}}\n                    {{revertposition ? formatTime(duration - position) : formatTime(position)}}\n                </div>\n            </div>\n        </div>\n\n        <div class="{{csstheme}}-top-right-block">\n\n            <div class="{{csstheme}}-time-container {{csstheme}}-right-time-container">\n                <div class="{{csstheme}}-time-value" title="{{string(\'total-time\')}}">{{formatTime(duration || position)}}</div>\n            </div>\n\n        </div>\n\n        <div class="{{csstheme}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}">\n            <div tabindex="{{skipinitial ? 2 : 1}}"\n                 ba-hotkey:right="{{seek(position + skipseconds)}}"\n                 ba-hotkey:left="{{seek(position - skipseconds)}}"\n                 onmouseout="this.blur()"\n                 data-selector="progress-bar-inner" class="{{csstheme}}-progressbar-inner"\n                 ontouchstart="{{startUpdatePosition(domEvent)}}"\n                 onmousedown="{{startUpdatePosition(domEvent)}}"\n            >\n\n                <div class="{{csstheme}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n                <div class="{{csstheme}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'video-progress\')}}">\n                    <div class="{{csstheme}}-progressbar-button-description" style="display: none">\n                        <div class="{{csstheme}}-current-stream-screen-shot">\n                            <img src=""/>\n                        </div>\n                        <div class="{{csstheme}}-time-container">\n                            <div class="{{csstheme}}-time-value" title="{{string(\'elapsed-time\')}}">{{formatTime(position)}}</div>\n                        </div>\n                    </div>\n                    <div class="{{csstheme}}-progressbar-button"></div>\n                </div>\n                <div class="{{csstheme}}-progressbar-marker"\n                    data-selector="trim-start-marker"\n                    ba-if="{{trimmingmode}}"\n                    ba-styles="{{{left: Math.round(duration && trimstart ? trimstart / duration * 100 : 0) + \'%\'}}}"\n                ></div>\n                <div class="{{csstheme}}-progressbar-marker"\n                    data-selector="trim-end-marker"\n                    ba-if="{{trimmingmode}}"\n                    ba-styles="{{{left: \'auto\', right: 100 - Math.round(duration && trimend ? trimend / duration * 100 : 100) + \'%\'}}}"\n                ></div>\n            </div>\n        </div>\n\n    </div>\n\n    <div class="{{csstheme}}-bottom-block">\n\n        <div class="{{csstheme}}-left-block">\n\n            <div tabindex="0" ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 data-selector="submit-video-button" class="{{csstheme}}-leftbutton-container"\n                 ba-if="{{submittable}}"  ba-click="{{submit()}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    {{string(\'submit-video\')}}\n                </div>\n            </div>\n\n            <div tabindex="0" ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 data-selector="button-icon-ccw" class="{{csstheme}}-leftbutton-container"\n                 ba-if="{{rerecordable}}" ba-click="{{rerecord()}}" title="{{string(\'rerecord-video\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon}}-icon-ccw"></i>\n                </div>\n            </div>\n\n            <div tabindex="{{skipinitial ? 0 : 2}}" ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n                 onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}"\n                 data-selector="button-icon-play" class="{{csstheme}}-button-container"\n                 ba-if="{{!playing}}" ba-click="{{play()}}" title="{{string(\'play-video\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon}}-icon-play"></i>\n                </div>\n            </div>\n\n            <div tabindex="{{skipinitial ? 0 : 2}}" ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n                 onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}"\n                 data-selector="button-icon-pause" class="{{csstheme}}-button-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n                 ba-if="{{playing}}" ba-click="{{pause()}}" title="{{disablepause ? string(\'pause-video-disabled\') : string(\'pause-video\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon}}-icon-pause"></i>\n                </div>\n            </div>\n\n            <div tabindex="3" ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n                 data-selector="button-icon-volume" class="{{csstheme}}-button-container"\n                 ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n                </div>\n            </div>\n\n            <div class="{{csstheme}}-volumebar" ba-show="{{!hidevolumebar}}">\n                <div tabindex="4"\n                     ba-hotkey:right="{{set_volume(volume + 0.1)}}"\n                     ba-hotkey:left="{{set_volume(volume - 0.1)}}"\n                     onmouseout="this.blur()"\n                     data-selector="button-volume-bar" class="{{csstheme}}-volumebar-inner"\n                     ontouchstart="{{startUpdateVolume(domEvent)}}"\n                     ontouchmove="{{progressUpdateVolume(domEvent)}}"\n                     ontouchend="{{stopUpdateVolume(domEvent); this.blur()}};"\n                     onmousedown="{{startUpdateVolume(domEvent)}}"\n                     onmouseup="{{stopUpdateVolume(domEvent)}}"\n                     onmouseleave="{{stopUpdateVolume(domEvent)}}"\n                     onmousemove="{{progressUpdateVolume(domEvent)}}"\n                >\n                    <div class="{{csstheme}}-volumebar-position" ba-styles="{{{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + \'%\'}}}" title="{{string(\'volume-button\')}}"></div>\n                </div>\n            </div>\n\n        </div>\n\n        <div class="{{csstheme}}-center-block">\n            <div data-selector="video-title-block" class="{{csstheme}}-title-block" ba-if="{{title}}">\n                <p class="{{csstheme}}-title">\n                    {{title}}\n                </p>\n            </div>\n        </div>\n\n        <div class="{{csstheme}}-right-block">\n\n            <div tabindex="5" ba-hotkey:space^enter="{{toggle_stream()}}" onmouseout="this.blur()"\n                 data-selector="button-stream-label" class="{{csstheme}}-button-container"\n                 ba-if="{{streams.length > 1 && currentstream}}" ba-click="{{toggle_stream()}}" title="{{string(\'change-resolution\')}}"\n            >\n                <div class="{{csstheme}}-button-inner {{csstheme}}-stream-label-container">\n                    <span class="{{csstheme}}-button-text {{csstheme}}-stream-label">{{currentstream_label}}</span>\n                </div>\n            </div>\n\n            <div tabindex="6" ba-hotkey:space^enter="{{show_airplay_devices()}}" onmouseout="this.blur()"\n                 data-selector="button-airplay" class="{{csstheme}}-button-container {{cssplayer}}-airplay-container"\n                 ba-show="{{airplaybuttonvisible}}" ba-click="{{show_airplay_devices()}}"\n            >\n                <svg width="16px" height="11px" viewBox="0 0 16 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n                    \n                    <title>Airplay</title>\n                    <desc>Airplay icon.</desc>\n                    <defs></defs>\n                    <g stroke="none" stroke-width="1" fill-rule="evenodd" sketch:type="MSPage">\n                        <path d="M4,11 L12,11 L8,7 L4,11 Z M14.5454545,0 L1.45454545,0 C0.654545455,0 0,0.5625 0,1.25 L0,8.75 C0,9.4375 0.654545455,10 1.45454545,10 L4.36363636,10 L4.36363636,8.75 L1.45454545,8.75 L1.45454545,1.25 L14.5454545,1.25 L14.5454545,8.75 L11.6363636,8.75 L11.6363636,10 L14.5454545,10 C15.3454545,10 16,9.4375 16,8.75 L16,1.25 C16,0.5625 15.3454545,0 14.5454545,0 L14.5454545,0 Z" sketch:type="MSShapeGroup"></path>\n                    </g>\n                </svg>\n            </div>\n\n            <div data-selector="button-chromecast" class="{{csstheme}}-button-container {{csstheme}}-cast-button-container"\n                 ba-show="{{castbuttonvisble}}">\n                <button tabindex="7" class="{{csstheme}}-gcast-button" is="google-cast-button"></button>\n            </div>\n\n            <div tabindex="8" data-selector="button-icon-settings"\n                 ba-hotkey:space^enter="{{toggle_settings_menu()}}" onmouseout="this.blur()"\n                 class="{{csstheme}}-button-container {{cssplayer}}-button-{{settingsmenuactive ? \'active\' : \'inactive\'}}"\n                 ba-if="{{settingsmenubutton}}" ba-click="{{toggle_settings_menu()}}"\n                 title="{{string(\'settings\')}}"\n                 onkeydown="{{tab_index_move(domEvent)}}"\n            >\n                <div class="{{csstheme}}-button-inner  {{csstheme}}-settings-button">\n                    <i class="{{csscommon}}-icon-cog"></i>\n                </div>\n            </div>\n\n            <div tabindex="9" data-selector="button-icon-resize-full"\n                 ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n                 class="{{csstheme}}-button-container  {{cssplayer}}-button-{{fullscreened ? \'active\' : \'inactive\'}}"\n                 ba-if="{{fullscreen}}" ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-video\') : string(\'fullscreen-video\') }}"\n            >\n                <div class="{{csstheme}}-button-inner {{csstheme}}-full-screen-btn-inner">\n                    <i class="{{csscommon}}-icon-resize-{{fullscreened ? \'small\' : \'full\'}}"></i>\n                </div>\n            </div>\n\n            <div tabindex="10" data-selector="cc-button-container"\n                 ba-hotkey:space^enter="{{toggle_tracks()}}" onmouseout="this.blur()"\n                 ba-if="{{(tracktags.length > 0 && showsubtitlebutton) || allowtexttrackupload}}"\n                 class="{{csstheme}}-button-container  {{cssplayer}}-button-{{tracktextvisible ? \'active\' : \'inactive\'}}"\n                 title="{{tracktextvisible ? string(\'close-tracks\') : string(\'show-tracks\')}}"\n                 ba-click="{{toggle_tracks()}}"\n                 onmouseover="{{hover_cc(true)}}"\n                 onmouseleave="{{hover_cc(false)}}"\n            >\n                <div class="{{csstheme}}-button-inner {{csstheme}}-subtitle-button-inner">\n                    <i class="{{csscommon}}-icon-subtitle"></i>\n                </div>\n            </div>\n\n            <div tabindex="11" class="{{csstheme}}-primary-button-container {{csstheme}}-button-container" ba-if="{{trimmingmode}}">\n                <div data-selector="trim-button"\n                     onmouseout="this.blur()"\n                     ba-click="{{trim()}}"\n                     class="{{csstheme}}-primary-button {{csstheme}}-button-inner">\n                     {{string(\'trim-video\')}}\n                </div>\n            </div>\n\n            <div tabindex="11" class="{{csstheme}}-primary-button-container {{csstheme}}-button-container" ba-if="{{frameselectionmode}}">\n                <div data-selector="select-frame-button"\n                     onmouseout="this.blur()"\n                     ba-click="{{select_frame()}}"\n                     class="{{csstheme}}-primary-button {{csstheme}}-button-inner">\n                     {{string(\'select-frame\')}}\n                </div>\n            </div>\n\n        </div>\n\n    </div>\n</div>\n',
                  tmplplaybutton: '\n<div tabindex="0" data-selector="play-button"\n     ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n     onkeydown="{{tab_index_move(domEvent, null, \'player-toggle-overlay\')}}"\n     class="{{cssplayer}}-playbutton-container" ba-click="{{play()}}" title="{{string(\'tooltip\')}}"\n>\n\t<div class="{{cssplayer}}-playbutton-button"></div>\n</div>\n<div ba-show="{{showduration && (duration != 0 && duration != undefined)}}" class="{{css}}-playbutton-duration">\n    {{formatTime(duration)}}\n</div>\n\n<div class="{{cssplayer}}-rerecord-bar" ba-if="{{rerecordable || submittable}}">\n\t<div class="{{cssplayer}}-rerecord-backbar"></div>\n\t<div class="{{cssplayer}}-rerecord-frontbar">\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{submittable && !trimmingmode}}">\n            <div tabindex="0" data-selector="player-submit-button"\n                 ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{submit()}}">\n                {{string(\'submit-video\')}}\n            </div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{rerecordable && !trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-rerecord-button"\n                 ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{rerecord()}}">\n        \t\t{{string(\'rerecord\')}}\n        \t</div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-trim-button"\n                 ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{play()}}">\n        \t\t{{string(\'trim\')}}\n        \t</div>\n        </div>\n        <div class="{{cssplayer}}-rerecord-button-container" ba-if="{{trimmingmode}}">\n        \t<div tabindex="0" data-selector="player-skip-button"\n                 ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n                 class="{{cssplayer}}-rerecord-button" onclick="{{skip()}}">\n        \t\t{{string(\'skip\')}}\n        \t</div>\n        </div>\n\t</div>\n</div>\n',
                  cssloader: ie8 ? "ba-videoplayer" : "",
                  cssmessage: "ba-videoplayer",
                  cssplaybutton: ie8 ? "ba-videoplayer" : ""
                }
              };
            }), Scoped.extend("module:Assets.recorderthemes", ["dynamics:Parser"], function (Parser) {
              return Parser.registerFunctions({
                css: function (_css74) {
                  function css(_x1194) {
                    return _css74.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css74.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                topmessage: function (_topmessage11) {
                  function topmessage(_x1195) {
                    return _topmessage11.apply(this, arguments);
                  }
                  topmessage.toString = function () {
                    return _topmessage11.toString();
                  };
                  return topmessage;
                }(function (obj) {
                  with (obj) return topmessage;
                })
              }), Parser.registerFunctions({
                csstheme: function (_csstheme28) {
                  function csstheme(_x1196) {
                    return _csstheme28.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme28.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                css: function (_css75) {
                  function css(_x1197) {
                    return _css75.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css75.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "stopvisible && recordingindication": function stopvisibleRecordingindication(obj) {
                  with (obj) return stopvisible && recordingindication;
                },
                settingsvisible: function (_settingsvisible15) {
                  function settingsvisible(_x1198) {
                    return _settingsvisible15.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible15.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                ismobile: function (_ismobile5) {
                  function ismobile(_x1199) {
                    return _ismobile5.apply(this, arguments);
                  }
                  ismobile.toString = function () {
                    return _ismobile5.toString();
                  };
                  return ismobile;
                }(function (obj) {
                  with (obj) return ismobile;
                }),
                "toggleFaceMode()": function (_toggleFaceMode6) {
                  function toggleFaceMode(_x1200) {
                    return _toggleFaceMode6.apply(this, arguments);
                  }
                  toggleFaceMode.toString = function () {
                    return _toggleFaceMode6.toString();
                  };
                  return toggleFaceMode;
                }(function (obj) {
                  with (obj) return toggleFaceMode();
                }),
                "hover(string('switch-camera'))": function hoverStringSwitchCamera(obj) {
                  with (obj) return hover(string("switch-camera"));
                },
                csscommon: function (_csscommon54) {
                  function csscommon(_x1201) {
                    return _csscommon54.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon54.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                settingsopen: function (_settingsopen3) {
                  function settingsopen(_x1202) {
                    return _settingsopen3.apply(this, arguments);
                  }
                  settingsopen.toString = function () {
                    return _settingsopen3.toString();
                  };
                  return settingsopen;
                }(function (obj) {
                  with (obj) return settingsopen;
                }),
                videoselectnotification: function (_videoselectnotification6) {
                  function videoselectnotification(_x1203) {
                    return _videoselectnotification6.apply(this, arguments);
                  }
                  videoselectnotification.toString = function () {
                    return _videoselectnotification6.toString();
                  };
                  return videoselectnotification;
                }(function (obj) {
                  with (obj) return videoselectnotification;
                }),
                "string('add-stream')": function stringAddStream(obj) {
                  with (obj) return string("add-stream");
                },
                "showaddstreambutton && firefox && allowscreen": function showaddstreambuttonFirefoxAllowscreen(obj) {
                  with (obj) return showaddstreambutton && firefox && allowscreen;
                },
                "addNewStream()": function (_addNewStream6) {
                  function addNewStream(_x1204) {
                    return _addNewStream6.apply(this, arguments);
                  }
                  addNewStream.toString = function () {
                    return _addNewStream6.toString();
                  };
                  return addNewStream;
                }(function (obj) {
                  with (obj) return addNewStream();
                }),
                "hover(string('add-stream'))": function hoverStringAddStream(obj) {
                  with (obj) return hover(string("add-stream"));
                },
                "showaddstreambutton && !firefox": function showaddstreambuttonFirefox(obj) {
                  with (obj) return showaddstreambutton && !firefox;
                },
                cameras: function (_cameras13) {
                  function cameras(_x1205) {
                    return _cameras13.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras13.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "(camera.id !== selectedcamera) || allowscreen": function cameraIdSelectedcameraAllowscreen(obj) {
                  with (obj) return camera.id !== selectedcamera || allowscreen;
                },
                "addNewStream(camera.id)": function addNewStreamCameraId(obj) {
                  with (obj) return addNewStream(camera.id);
                },
                "camera.label": function cameraLabel(obj) {
                  with (obj) return camera.label;
                },
                "(showaddstreambutton && !firefox) || (firefox && allowscreen)": function showaddstreambuttonFirefoxFirefoxAllowscreen(obj) {
                  with (obj) return showaddstreambutton && !firefox || firefox && allowscreen;
                },
                "!novideo && !allowscreen && !ismobile": function novideoAllowscreenIsmobile(obj) {
                  with (obj) return !novideo && !allowscreen && !ismobile;
                },
                "hover(string('select-camera'))": function hoverStringSelectCamera(obj) {
                  with (obj) return hover(string("select-camera"));
                },
                "selectCamera(camera.id)": function selectCameraCameraId(obj) {
                  with (obj) return selectCamera(camera.id);
                },
                "selectedcamera == camera.id": function selectedcameraCameraId(obj) {
                  with (obj) return selectedcamera == camera.id;
                },
                "(!noaudio && !novideo) || !allowscreen": function noaudioNovideoAllowscreen(obj) {
                  with (obj) return !noaudio && !novideo || !allowscreen;
                },
                microphones: function (_microphones13) {
                  function microphones(_x1206) {
                    return _microphones13.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones13.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                "!noaudio && !allowscreen": function noaudioAllowscreen(obj) {
                  with (obj) return !noaudio && !allowscreen;
                },
                "selectMicrophone(microphone.id)": function selectMicrophoneMicrophoneId(obj) {
                  with (obj) return selectMicrophone(microphone.id);
                },
                "hover(string('select-audio-input'))": function hoverStringSelectAudioInput(obj) {
                  with (obj) return hover(string("select-audio-input"));
                },
                "selectedmicrophone == microphone.id": function selectedmicrophoneMicrophoneId(obj) {
                  with (obj) return selectedmicrophone == microphone.id;
                },
                "microphone.label": function microphoneLabel(obj) {
                  with (obj) return microphone.label;
                },
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                "unhover()": function (_unhover12) {
                  function unhover(_x1207) {
                    return _unhover12.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover12.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                "hover(string(microphonehealthy ? 'microphonehealthy' : 'microphoneunhealthy'))": function hoverStringMicrophonehealthyMicrophonehealthyMicrophoneunhealthy(obj) {
                  with (obj) return hover(string(microphonehealthy ? "microphonehealthy" : "microphoneunhealthy"));
                },
                "microphonehealthy ? 'good' : 'bad'": function microphonehealthyGoodBad(obj) {
                  with (obj) return microphonehealthy ? "good" : "bad";
                },
                "!novideo && !allowscreen": function novideoAllowscreen(obj) {
                  with (obj) return !novideo && !allowscreen;
                },
                "hover(string(camerahealthy ? 'camerahealthy' : 'cameraunhealthy'))": function hoverStringCamerahealthyCamerahealthyCameraunhealthy(obj) {
                  with (obj) return hover(string(camerahealthy ? "camerahealthy" : "cameraunhealthy"));
                },
                "camerahealthy ? 'good' : 'bad'": function camerahealthyGoodBad(obj) {
                  with (obj) return camerahealthy ? "good" : "bad";
                },
                stopvisible: function (_stopvisible13) {
                  function stopvisible(_x1208) {
                    return _stopvisible13.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible13.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                controlbarlabel: function (_controlbarlabel15) {
                  function controlbarlabel(_x1209) {
                    return _controlbarlabel15.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel15.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                rerecordvisible: function (_rerecordvisible15) {
                  function rerecordvisible(_x1210) {
                    return _rerecordvisible15.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible15.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord38) {
                  function rerecord(_x1211) {
                    return _rerecord38.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord38.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible12) {
                  function cancelvisible(_x1212) {
                    return _cancelvisible12.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible12.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel12) {
                  function cancel(_x1213) {
                    return _cancel12.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel12.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                },
                recordvisible: function (_recordvisible15) {
                  function recordvisible(_x1214) {
                    return _recordvisible15.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible15.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record12) {
                  function record(_x1215) {
                    return _record12.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record12.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                "stop()": function (_stop11) {
                  function stop(_x1216) {
                    return _stop11.apply(this, arguments);
                  }
                  stop.toString = function () {
                    return _stop11.toString();
                  };
                  return stop;
                }(function (obj) {
                  with (obj) return stop();
                }),
                "mintimeindicator ? css + '-disabled': ''": function mintimeindicatorCssDisabled(obj) {
                  with (obj) return mintimeindicator ? css + "-disabled" : "";
                },
                "mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip')": function mintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip");
                },
                "hover(mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip'))": function hoverMintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return hover(mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip"));
                },
                "string('stop')": function stringStop(obj) {
                  with (obj) return string("stop");
                },
                "pausable && !resumevisible": function pausableResumevisible(obj) {
                  with (obj) return pausable && !resumevisible;
                },
                "string('pause-recorder')": function stringPauseRecorder(obj) {
                  with (obj) return string("pause-recorder");
                },
                "pause()": function (_pause20) {
                  function pause(_x1217) {
                    return _pause20.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause20.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "hover(string('pause-recorder'))": function hoverStringPauseRecorder(obj) {
                  with (obj) return hover(string("pause-recorder"));
                },
                "pausable && resumevisible": function pausableResumevisible(obj) {
                  with (obj) return pausable && resumevisible;
                },
                "resume()": function (_resume7) {
                  function resume(_x1218) {
                    return _resume7.apply(this, arguments);
                  }
                  resume.toString = function () {
                    return _resume7.toString();
                  };
                  return resume;
                }(function (obj) {
                  with (obj) return resume();
                }),
                "string('resume-recorder')": function stringResumeRecorder(obj) {
                  with (obj) return string("resume-recorder");
                },
                "hover(string('resume-recorder'))": function hoverStringResumeRecorder(obj) {
                  with (obj) return hover(string("resume-recorder"));
                },
                skipvisible: function (_skipvisible11) {
                  function skipvisible(_x1219) {
                    return _skipvisible11.apply(this, arguments);
                  }
                  skipvisible.toString = function () {
                    return _skipvisible11.toString();
                  };
                  return skipvisible;
                }(function (obj) {
                  with (obj) return skipvisible;
                }),
                "skip()": function (_skip18) {
                  function skip(_x1220) {
                    return _skip18.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip18.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "hover(string('skip-tooltip'))": function hoverStringSkipTooltip(obj) {
                  with (obj) return hover(string("skip-tooltip"));
                },
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                },
                uploadcovershotvisible: function (_uploadcovershotvisible11) {
                  function uploadcovershotvisible(_x1221) {
                    return _uploadcovershotvisible11.apply(this, arguments);
                  }
                  uploadcovershotvisible.toString = function () {
                    return _uploadcovershotvisible11.toString();
                  };
                  return uploadcovershotvisible;
                }(function (obj) {
                  with (obj) return uploadcovershotvisible;
                }),
                "hover(string('upload-covershot-tooltip'))": function hoverStringUploadCovershotTooltip(obj) {
                  with (obj) return hover(string("upload-covershot-tooltip"));
                },
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                covershot_accept_string: function (_covershot_accept_string15) {
                  function covershot_accept_string(_x1222) {
                    return _covershot_accept_string15.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string15.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                showslidercontainer: function (_showslidercontainer11) {
                  function showslidercontainer(_x1223) {
                    return _showslidercontainer11.apply(this, arguments);
                  }
                  showslidercontainer.toString = function () {
                    return _showslidercontainer11.toString();
                  };
                  return showslidercontainer;
                }(function (obj) {
                  with (obj) return showslidercontainer;
                }),
                css: function (_css76) {
                  function css(_x1224) {
                    return _css76.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css76.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "left()": function (_left6) {
                  function left(_x1225) {
                    return _left6.apply(this, arguments);
                  }
                  left.toString = function () {
                    return _left6.toString();
                  };
                  return left;
                }(function (obj) {
                  with (obj) return left();
                }),
                csscommon: function (_csscommon55) {
                  function csscommon(_x1226) {
                    return _csscommon55.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon55.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                images: function (_images6) {
                  function images(_x1227) {
                    return _images6.apply(this, arguments);
                  }
                  images.toString = function () {
                    return _images6.toString();
                  };
                  return images;
                }(function (obj) {
                  with (obj) return images;
                }),
                "select(image)": function selectImage(obj) {
                  with (obj) return select(image);
                },
                "{left: image.left + 'px', top: image.top + 'px', width: image.width + 'px', height: image.height + 'px'}": function leftImageLeftPxTopImageTopPxWidthImageWidthPxHeightImageHeightPx(obj) {
                  with (obj) return {
                    left: image.left + "px",
                    top: image.top + "px",
                    width: image.width + "px",
                    height: image.height + "px"
                  };
                },
                "right()": function (_right6) {
                  function right(_x1228) {
                    return _right6.apply(this, arguments);
                  }
                  right.toString = function () {
                    return _right6.toString();
                  };
                  return right;
                }(function (obj) {
                  with (obj) return right();
                }),
                "!showslidercontainer": function (_showslidercontainer12) {
                  function showslidercontainer(_x1229) {
                    return _showslidercontainer12.apply(this, arguments);
                  }
                  showslidercontainer.toString = function () {
                    return _showslidercontainer12.toString();
                  };
                  return showslidercontainer;
                }(function (obj) {
                  with (obj) return !showslidercontainer;
                }),
                covershot_accept_string: function (_covershot_accept_string16) {
                  function covershot_accept_string(_x1230) {
                    return _covershot_accept_string16.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string16.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                css: function (_css77) {
                  function css(_x1231) {
                    return _css77.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css77.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "initialmessages.length > 0": function initialmessagesLength0(obj) {
                  with (obj) return 0 < initialmessages.length;
                },
                csscommon: function (_csscommon56) {
                  function csscommon(_x1232) {
                    return _csscommon56.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon56.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                initialmessages: function (_initialmessages8) {
                  function initialmessages(_x1233) {
                    return _initialmessages8.apply(this, arguments);
                  }
                  initialmessages.toString = function () {
                    return _initialmessages8.toString();
                  };
                  return initialmessages;
                }(function (obj) {
                  with (obj) return initialmessages;
                }),
                "initialmessage.message": function initialmessageMessage(obj) {
                  with (obj) return initialmessage.message;
                },
                "initialmessage.type ? initialmessage.type : 'default'": function initialmessageTypeInitialmessageTypeDefault(obj) {
                  with (obj) return initialmessage.type ? initialmessage.type : "default";
                },
                "initialmessage.id": function initialmessageId(obj) {
                  with (obj) return initialmessage.id;
                },
                actions: function (_actions14) {
                  function actions(_x1234) {
                    return _actions14.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions14.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.switchcamera": function actionSwitchcamera(obj) {
                  with (obj) return action.switchcamera;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                },
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                }
              }), Parser.registerFunctions({
                cssrecorder: function (_cssrecorder12) {
                  function cssrecorder(_x1235) {
                    return _cssrecorder12.apply(this, arguments);
                  }
                  cssrecorder.toString = function () {
                    return _cssrecorder12.toString();
                  };
                  return cssrecorder;
                }(function (obj) {
                  with (obj) return cssrecorder;
                }),
                "click()": function (_click18) {
                  function click(_x1236) {
                    return _click18.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click18.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                "shortMessage ? 'short-message' : 'long-message'": function shortMessageShortMessageLongMessage(obj) {
                  with (obj) return shortMessage ? "short-message" : "long-message";
                },
                'message || ""': function (_message24) {
                  function message(_x1237) {
                    return _message24.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message24.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links12) {
                  function links(_x1238) {
                    return _links12.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links12.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }), {
                elevate: {
                  css: "ba-videorecorder",
                  csstheme: "ba-recorder-theme-elevate",
                  cssrecorder: "ba-recorder",
                  cssmessage: "ba-videorecorder",
                  cssloader: "ba-videorecorder",
                  tmpltopmessage: '<div class="{{css}}-topmessage-container">\n    <div data-selector="recorder-topmessage-block" class=\'{{css}}-topmessage-message\'>\n        {{topmessage}}\n    </div>\n</div>\n',
                  tmplcontrolbar: '<div class="{{csstheme}}-dashboard">\n\n\t\n\t<div class="{{css}}-settings-left-sidebar">\n\n\t\t<div class="{{css}}-indicator-container" ba-show="{{stopvisible && recordingindication}}">\n\t\t\t<div data-selector="recording-indicator" class="{{css}}-recording-indication"></div>\n\t\t</div>\n\n\t\t<div class="{{css}}-controlbar-left-section" ba-show="{{settingsvisible}}">\n\n\t\t\t\n\t\t\t<div data-selector="recorder-settings" class="{{css}}-settings {{css}}-settings-button-container">\n\n\t\t\t\t<div class="{{css}}-circle-button" ba-show="{{ismobile}}">\n\t\t\t\t\t<div data-selector="face-mode-toggle-icon" class="{{css}}-mobile-camera-switcher {{css}}-button-inner"\n\t\t\t\t\t\t onclick="{{toggleFaceMode()}}"\n\t\t\t\t\t\t onmouseenter="{{hover(string(\'switch-camera\'))}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-arrows-cw"></i>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="{{css}}-circle-button" ba-show="{{settingsvisible}}">\n\n\t\t\t\t\t<div class="{{css}}-bubble-info" ba-show="{{settingsopen}}">\n\t\t\t\t\t\t<ul data-selector="add-new-stream" ba-if="{{videoselectnotification}}">\n\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t<div data-selector="single-camera-stream">\n\t\t\t\t\t\t\t\t\t<i class="ba-commoncss-icon-plus"></i> {{string(\'add-stream\')}}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t<div data-selector="single-camera-stream" class="{{csscommon}}-text-error">\n\t\t\t\t\t\t\t\t\t{{videoselectnotification}}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t\t<ul data-selector="add-new-stream" ba-show="{{showaddstreambutton && firefox && allowscreen}}">\n\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t<div data-selector="single-camera-stream"\n\t\t\t\t\t\t\t\t\t class="{{css}}-add-stream"\n\t\t\t\t\t\t\t\t\t onclick="{{addNewStream()}}"\n\t\t\t\t\t\t\t\t\t onmouseenter="{{hover(string(\'add-stream\'))}}"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-plus"></i> {{string(\'add-stream\')}}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t\t<ul data-selector="add-new-stream" ba-show="{{showaddstreambutton && !firefox}}" ba-repeat="{{camera :: cameras}}">\n\t\t\t\t\t\t\t<li ba-show="{{(camera.id !== selectedcamera) || allowscreen}}">\n\t\t\t\t\t\t\t\t<div data-selector="single-camera-stream"\n\t\t\t\t\t\t\t\t\t class="{{css}}-add-stream"\n\t\t\t\t\t\t\t\t\t onclick="{{addNewStream(camera.id)}}"\n\t\t\t\t\t\t\t\t\t onmouseenter="{{hover(string(\'add-stream\'))}}"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t<i class="{{csscommon}}-icon-plus"></i> {{camera.label}}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t<hr ba-show="{{(showaddstreambutton && !firefox) || (firefox && allowscreen)}}"/>\n\n\t\t\t\t\t\t<ul data-selector="camera-settings" ba-repeat="{{camera :: cameras}}" ba-show="{{!novideo && !allowscreen && !ismobile}}">\n\t\t\t\t\t\t\t<li onmouseenter="{{hover(string(\'select-camera\'))}}">\n\t\t\t\t\t\t\t\t<input tabindex="0"\n\t\t\t\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t\t\t   type=\'radio\' name=\'camera\' value="{{selectedcamera == camera.id}}"\n\t\t\t\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t\t\t<label tabindex="0"\n\t\t\t\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t{{camera.label}}\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t<hr ba-show="{{(!noaudio && !novideo) || !allowscreen}}"/>\n\t\t\t\t\t\t<ul data-selector="microphone-settings" ba-repeat="{{microphone :: microphones}}" ba-show="{{!noaudio && !allowscreen}}">\n\t\t\t\t\t\t\t<li tabindex="0"\n\t\t\t\t\t\t\t\tba-hotkey:space^enter="{{selectMicrophone(microphone.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t\tonmouseenter="{{hover(string(\'select-audio-input\'))}}"\n\t\t\t\t\t\t\t\tonclick="{{selectMicrophone(microphone.id)}}"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<input type=\'radio\' name=\'microphone\' value="{{selectedmicrophone == microphone.id}}" />\n\t\t\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t{{microphone.label}}\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div tabindex="0"\n\t\t\t\t\t\t ba-hotkey:space^enter="{{settingsopen=!settingsopen}}" onmouseout="this.blur()"\n\t\t\t\t\t\t data-selector="record-button-icon-cog"\n\t\t\t\t\t\t class="{{css}}-button-inner {{css}}-button-circle-{{settingsopen ? \'selected\' : \'unselected\' }}"\n\t\t\t\t\t\t onclick="{{settingsopen=!settingsopen}}"\n\t\t\t\t\t\t onmouseenter="{{hover(string(\'settings\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-cog"></i>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n                <div class="{{css}}-circle-button" ba-show="{{!noaudio && !allowscreen}}">\n\n                    <div data-selector="record-button-icon-mic" class="{{css}}-button-inner"\n                         onmouseenter="{{hover(string(microphonehealthy ? \'microphonehealthy\' : \'microphoneunhealthy\'))}}"\n                         onmouseleave="{{unhover()}}">\n                        <i class="{{csscommon}}-icon-mic {{csscommon}}-icon-state-{{microphonehealthy ? \'good\' : \'bad\' }}"></i>\n                    </div>\n                </div>\n\n                <div class="{{css}}-circle-button" ba-show="{{!novideo && !allowscreen}}">\n                    <div data-selector="record-button-icon-videocam" class="{{css}}-button-inner"\n                         onmouseenter="{{hover(string(camerahealthy ? \'camerahealthy\' : \'cameraunhealthy\'))}}"\n                         onmouseleave="{{unhover()}}">\n                        <i class="{{csscommon}}-icon-videocam {{csscommon}}-icon-state-{{ camerahealthy ? \'good\' : \'bad\' }}"></i>\n                    </div>\n                </div>\n\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t<div class="{{css}}-controlbar-middle-section">\n\n\t\t<div class="{{css}}-timer-container" ba-show="{{stopvisible}}">\n\t\t\t<div class="{{css}}-label-container" ba-show="{{controlbarlabel}}">\n\t\t\t\t<div data-selector="record-label-block" class="{{css}}-label {{css}}-button-primary">\n\t\t\t\t\t{{controlbarlabel}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n\t\t<div class="{{css}}-controlbar-center-section">\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{rerecordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="rerecord-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{rerecord()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'rerecord\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{cancelvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="cancel-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{cancel()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'cancel\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-primary-button-container" ba-show="{{recordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="record-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{record()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'record\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-stop-container" ba-show="{{stopvisible}}">\n\n\t\t\t<div class="{{css}}-stop-button-container">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="stop-primary-button" class="{{css}}-button-primary {{mintimeindicator ? css + \'-disabled\': \'\'}}"\n\t\t\t\t\t title="{{mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\')}}"\n\t\t\t\t\t onclick="{{stop()}}"\n\t\t\t\t\t onmouseenter="{{hover(mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'stop\')}}\n\t\t\t\t</div>\n\n                <div tabindex="0" data-selector="pause-primary-button"  ba-show="{{pausable && !resumevisible}}"\n                     ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n                     data-selector="pause-primary-button" class="{{css}}-button-primary"\n                     title="{{string(\'pause-recorder\')}}"\n                     onclick="{{pause()}}"\n                     onmouseenter="{{hover(string(\'pause-recorder\'))}}"\n                     onmouseleave="{{unhover()}}"\n                >\n                    <i class="{{csscommon}}-icon-pause"></i>\n                </div>\n\n                <div tabindex="0" data-selector="resume-primary-button"  ba-show="{{pausable && resumevisible}}"\n                     ba-hotkey:space^enter="{{resume()}}" onmouseout="this.blur()"\n                     data-selector="resume-primary-button" class="{{css}}-button-primary"\n                     title="{{string(\'resume-recorder\')}}"\n                     onclick="{{resume()}}"\n                     onmouseenter="{{hover(string(\'resume-recorder\'))}}"\n                     onmouseleave="{{unhover()}}"\n                >\n                    <i class="{{csscommon}}-icon-ccw"></i>\n                </div>\n\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-centerbutton-container" ba-show="{{skipvisible}}">\n            <div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="skip-primary-button" class="{{css}}-button-primary"\n                 onclick="{{skip()}}"\n                 onmouseenter="{{hover(string(\'skip-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                {{string(\'skip\')}}\n            </div>\n        </div>\n\n\n        <div class="{{css}}-rightbutton-container" ba-if="{{uploadcovershotvisible}}">\n            <div data-selector="covershot-primary-button" class="{{css}}-button-primary"\n                 onmouseenter="{{hover(string(\'upload-covershot-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                <input type="file"\n                       class="{{css}}-chooser-file"\n                       style="height:100px"\n                       onchange="{{uploadCovershot(domEvent)}}"\n                       accept="{{covershot_accept_string}}" />\n                <span>\n                    {{string(\'upload-covershot\')}}\n                </span>\n            </div>\n        </div>\n\n\t</div>\n\n</div>\n',
                  tmplimagegallery: '<div ba-if="{{showslidercontainer}}" data-selector="image-gallery" class="{{css}}-image-gallery-container">\n\t<div data-selector="slider-left-button" class="{{css}}-imagegallery-leftbutton">\n\t\t<div tabindex="0" data-selector="slider-left-inner-button"\n\t\t\t ba-hotkey:space^enter^left="{{left()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-button-inner" onclick="{{left()}}"\n\t\t>\n\t\t\t<i class="{{csscommon}}-icon-left-open"></i>\n\t\t</div>\n\t</div>\n\n\t<div data-selector="images-imagegallery-container" ba-repeat="{{image::images}}" class="{{css}}-imagegallery-container" data-gallery-container>\n\t\t<div tabindex="0" data-selector="imagegallery-selected-image"\n\t\t\t ba-hotkey:space^enter="{{select(image)}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-image"\n\t\t\t ba-styles="{{{left: image.left + \'px\', top: image.top + \'px\', width: image.width + \'px\', height: image.height + \'px\'}}}"\n\t\t\t onclick="{{select(image)}}"\n\t\t>\n\t\t</div>\n\t</div>\n\n\t<div data-selector="slider-right-button" class="{{css}}-imagegallery-rightbutton">\n\t\t<div tabindex="0" data-selector="slider-right-inner-button"\n\t\t\t ba-hotkey:space^enter^right="{{right()}}" onmouseout="this.blur()"\n\t\t\t class="{{css}}-imagegallery-button-inner"\n\t\t\t onclick="{{right()}}"\n\t\t>\n\t\t\t<i class="{{csscommon}}-icon-right-open"></i>\n\t\t</div>\n\t</div>\n</div>\n\n<div ba-if="{{!showslidercontainer}}" class="{{css}}-chooser-container">\n\t<div data-selector="covershot-primary-button" class="{{css}}-chooser-button-container">\n\t\t<div class="{{css}}-chooser-button-0">\n\t\t\t<input type="file"\n\t\t\t\t   tabindex="0"\n\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t   accept="{{covershot_accept_string}}"\n\t\t\t\t   onchange="{{uploadCovershot(domEvent)}}"\n\t\t\t/>\n\t\t\t<i class="{{csscommon}}-icon-picture"></i>\n\t\t\t<span>\n\t\t\t{{string(\'upload-covershot\')}}\n\t\t</span>\n\t\t</div>\n\t</div>\n</div>\n',
                  tmplchooser: '<div class="{{css}}-chooser-container">\n\t<div ba-if="{{initialmessages.length > 0}}" class="{{csscommon}}-message-container">\n\t\t<ul ba-repeat="{{initialmessage :: initialmessages}}">\n\t\t\t<li ba-if="{{initialmessage.message}}"\n\t\t\t\tclass="{{csscommon}}-message-text {{csscommon}}-message-{{initialmessage.type ? initialmessage.type : \'default\'}}"\n\t\t\t>\n\t\t\t\t{{ initialmessage.message }}\n\t\t\t\t<span ba-if="{{initialmessage.id}}"\n\t\t\t\t\t  class="{{csscommon}}-action-button"\n\t\t\t\t\t  ba-click="close_message(initialmessage.id)"\n\t\t\t\t>\n\t\t\t\t\t<i class="{{csscommon}}-icon-cancel"></i>\n\t\t\t\t</span>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\n\t<div class="{{css}}-chooser-button-container">\n\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t\t ba-click="{{click_action(action)}}">\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture="{{action.switchcamera}}" />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t/>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n',
                  tmplmessage: '<div data-selector="recorder-message-container" class="{{cssrecorder}}-message-container" ba-click="{{click()}}">\n    <div class="{{cssrecorder}}-top-inner-message-container {{cssrecorder}}-{{shortMessage ? \'short-message\' : \'long-message\'}}">\n        <div class="{{cssrecorder}}-first-inner-message-container">\n            <div class="{{cssrecorder}}-second-inner-message-container">\n                <div class="{{cssrecorder}}-third-inner-message-container">\n                    <div class="{{cssrecorder}}-fourth-inner-message-container">\n                        <div data-selector="recorder-message-block" class=\'{{cssrecorder}}-message-message\'>\n                            <p>\n                                {{message || ""}}\n                            </p>\n                            <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n                                <li>\n                                    <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                                        {{link.title}}\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n'
                }
              };
            }), Scoped.extend("module:Assets.imageviewerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                css: function (_css78) {
                  function css(_x1239) {
                    return _css78.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css78.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "activitydelta > 5000 && hideoninactivity ? (css + '-dashboard-hidden') : ''": function activitydelta5000HideoninactivityCssDashboardHidden(obj) {
                  with (obj) return 5e3 < activitydelta && hideoninactivity ? css + "-dashboard-hidden" : "";
                },
                "submit()": function (_submit27) {
                  function submit(_x1240) {
                    return _submit27.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit27.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable23) {
                  function submittable(_x1241) {
                    return _submittable23.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable23.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-image')": function stringSubmitImage(obj) {
                  with (obj) return string("submit-image");
                },
                "rerecord()": function (_rerecord39) {
                  function rerecord(_x1242) {
                    return _rerecord39.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord39.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable23) {
                  function rerecordable(_x1243) {
                    return _rerecordable23.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable23.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-image')": function stringRerecordImage(obj) {
                  with (obj) return string("rerecord-image");
                },
                csscommon: function (_csscommon57) {
                  function csscommon(_x1244) {
                    return _csscommon57.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon57.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                title: function (_title23) {
                  function title(_x1245) {
                    return _title23.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title23.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                }),
                "toggle_fullscreen()": function (_toggle_fullscreen14) {
                  function toggle_fullscreen(_x1246) {
                    return _toggle_fullscreen14.apply(this, arguments);
                  }
                  toggle_fullscreen.toString = function () {
                    return _toggle_fullscreen14.toString();
                  };
                  return toggle_fullscreen;
                }(function (obj) {
                  with (obj) return toggle_fullscreen();
                }),
                fullscreen: function (_fullscreen14) {
                  function fullscreen(_x1247) {
                    return _fullscreen14.apply(this, arguments);
                  }
                  fullscreen.toString = function () {
                    return _fullscreen14.toString();
                  };
                  return fullscreen;
                }(function (obj) {
                  with (obj) return fullscreen;
                }),
                "fullscreened ? string('exit-fullscreen-image') : string('fullscreen-image')": function fullscreenedStringExitFullscreenImageStringFullscreenImage(obj) {
                  with (obj) return fullscreened ? string("exit-fullscreen-image") : string("fullscreen-image");
                },
                "fullscreened ? 'small' : 'full'": function fullscreenedSmallFull(obj) {
                  with (obj) return fullscreened ? "small" : "full";
                }
              }), {
                elevate: {
                  css: "ba-imageviewer",
                  csstheme: "ba-imageviewer-elevate-theme",
                  tmplcontrolbar: '\n<div class="{{css}}-dashboard {{activitydelta > 5000 && hideoninactivity ? (css + \'-dashboard-hidden\') : \'\'}}">\n\n    <div class="{{css}}-bottom-block">\n\n        <div class="{{css}}-left-block">\n\n            <div tabindex="0" ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 data-selector="submit-image-button" class="{{css}}-leftbutton-container"\n                 ba-if="{{submittable}}"  ba-click="{{submit()}}"\n            >\n                <div class="{{css}}-button-inner">\n                    {{string(\'submit-image\')}}\n                </div>\n            </div>\n\n            <div tabindex="0" ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 data-selector="button-icon-ccw" class="{{css}}-leftbutton-container"\n                 ba-if="{{rerecordable}}" ba-click="{{rerecord()}}" title="{{string(\'rerecord-image\')}}"\n            >\n                <div class="{{css}}-button-inner">\n                    <i class="{{csscommon}}-icon-ccw"></i>\n                </div>\n            </div>\n\n        </div>\n\n        <div class="{{css}}-center-block">\n            <div data-selector="image-title-block" class="{{css}}-image-title-block" ba-if="{{title}}">\n                <p class="{{css}}-image-title">\n                    {{title}}\n                </p>\n            </div>\n        </div>\n\n        <div class="{{css}}-right-block">\n\n            <div tabindex="8" data-selector="button-icon-resize-full"\n                 ba-hotkey:space^enter="{{toggle_fullscreen()}}" onmouseout="this.blur()"\n                 class="{{css}}-button-container"\n                 ba-if="{{fullscreen}}" ba-click="{{toggle_fullscreen()}}" title="{{ fullscreened ? string(\'exit-fullscreen-image\') : string(\'fullscreen-image\') }}"\n            >\n                <div class="{{css}}-button-inner {{css}}-full-screen-btn-inner">\n                    <i class="{{csscommon}}-icon-resize-{{fullscreened ? \'small\' : \'full\'}}"></i>\n                </div>\n            </div>\n\n        </div>\n\n    </div>\n</div>\n',
                  cssloader: ie8 ? "ba-imageviewer" : "",
                  cssmessage: "ba-imageviewer"
                }
              };
            }), Scoped.extend("module:Assets.audioplayerthemes", ["browser:Info", "dynamics:Parser"], function (Info, Parser) {
              var ie8 = Info.isInternetExplorer() && Info.internetExplorerVersion() <= 8;
              return Parser.registerFunctions({
                csstheme: function (_csstheme29) {
                  function csstheme(_x1248) {
                    return _csstheme29.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme29.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                "string('elapsed-time')": function stringElapsedTime(obj) {
                  with (obj) return string("elapsed-time");
                },
                "formatTime(position)": function formatTimePosition(obj) {
                  with (obj) return formatTime(position);
                },
                "string('total-time')": function stringTotalTime(obj) {
                  with (obj) return string("total-time");
                },
                "formatTime(duration || position)": function formatTimeDurationPosition(obj) {
                  with (obj) return formatTime(duration || position);
                },
                "disableseeking ? cssplayer + '-disabled' : ''": function disableseekingCssplayerDisabled(obj) {
                  with (obj) return disableseeking ? cssplayer + "-disabled" : "";
                },
                "seek(position + skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position + skipseconds);
                },
                "seek(position - skipseconds)": function seekPositionSkipseconds(obj) {
                  with (obj) return seek(position - skipseconds);
                },
                "startUpdatePosition(domEvent)": function startUpdatePositionDomEvent(obj) {
                  with (obj) return startUpdatePosition(domEvent);
                },
                "stopUpdatePosition(domEvent)": function stopUpdatePositionDomEvent(obj) {
                  with (obj) return stopUpdatePosition(domEvent);
                },
                "progressUpdatePosition(domEvent)": function progressUpdatePositionDomEvent(obj) {
                  with (obj) return progressUpdatePosition(domEvent);
                },
                "{width: Math.round(duration ? cached / duration * 100 : 0) + '%'}": function widthMathRoundDurationCachedDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? cached / duration * 100 : 0) + "%"
                  };
                },
                "{width: Math.round(duration ? position / duration * 100 : 0) + '%'}": function widthMathRoundDurationPositionDuration1000(obj) {
                  with (obj) return {
                    width: Math.round(duration ? position / duration * 100 : 0) + "%"
                  };
                },
                "string('audio-progress')": function stringAudioProgress(obj) {
                  with (obj) return string("audio-progress");
                },
                "submit()": function (_submit28) {
                  function submit(_x1249) {
                    return _submit28.apply(this, arguments);
                  }
                  submit.toString = function () {
                    return _submit28.toString();
                  };
                  return submit;
                }(function (obj) {
                  with (obj) return submit();
                }),
                submittable: function (_submittable24) {
                  function submittable(_x1250) {
                    return _submittable24.apply(this, arguments);
                  }
                  submittable.toString = function () {
                    return _submittable24.toString();
                  };
                  return submittable;
                }(function (obj) {
                  with (obj) return submittable;
                }),
                "string('submit-audio')": function stringSubmitAudio(obj) {
                  with (obj) return string("submit-audio");
                },
                "rerecord()": function (_rerecord40) {
                  function rerecord(_x1251) {
                    return _rerecord40.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord40.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                rerecordable: function (_rerecordable24) {
                  function rerecordable(_x1252) {
                    return _rerecordable24.apply(this, arguments);
                  }
                  rerecordable.toString = function () {
                    return _rerecordable24.toString();
                  };
                  return rerecordable;
                }(function (obj) {
                  with (obj) return rerecordable;
                }),
                "string('rerecord-audio')": function stringRerecordAudio(obj) {
                  with (obj) return string("rerecord-audio");
                },
                csscommon: function (_csscommon58) {
                  function csscommon(_x1253) {
                    return _csscommon58.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon58.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "play()": function (_play21) {
                  function play(_x1254) {
                    return _play21.apply(this, arguments);
                  }
                  play.toString = function () {
                    return _play21.toString();
                  };
                  return play;
                }(function (obj) {
                  with (obj) return play();
                }),
                "tab_index_move(domEvent, null, 'button-icon-pause')": function tab_index_moveDomEventNullButtonIconPause(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-pause");
                },
                "!playing": function (_playing29) {
                  function playing(_x1255) {
                    return _playing29.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing29.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return !playing;
                }),
                "string('play-audio')": function stringPlayAudio(obj) {
                  with (obj) return string("play-audio");
                },
                "pause()": function (_pause21) {
                  function pause(_x1256) {
                    return _pause21.apply(this, arguments);
                  }
                  pause.toString = function () {
                    return _pause21.toString();
                  };
                  return pause;
                }(function (obj) {
                  with (obj) return pause();
                }),
                "tab_index_move(domEvent, null, 'button-icon-play')": function tab_index_moveDomEventNullButtonIconPlay(obj) {
                  with (obj) return tab_index_move(domEvent, null, "button-icon-play");
                },
                "disablepause ? cssplayer + '-disabled' : ''": function disablepauseCssplayerDisabled(obj) {
                  with (obj) return disablepause ? cssplayer + "-disabled" : "";
                },
                playing: function (_playing30) {
                  function playing(_x1257) {
                    return _playing30.apply(this, arguments);
                  }
                  playing.toString = function () {
                    return _playing30.toString();
                  };
                  return playing;
                }(function (obj) {
                  with (obj) return playing;
                }),
                "disablepause ? string('pause-audio-disabled') : string('pause-audio')": function disablepauseStringPauseAudioDisabledStringPauseAudio(obj) {
                  with (obj) return disablepause ? string("pause-audio-disabled") : string("pause-audio");
                },
                "toggle_volume()": function (_toggle_volume14) {
                  function toggle_volume(_x1258) {
                    return _toggle_volume14.apply(this, arguments);
                  }
                  toggle_volume.toString = function () {
                    return _toggle_volume14.toString();
                  };
                  return toggle_volume;
                }(function (obj) {
                  with (obj) return toggle_volume();
                }),
                "string(volume > 0 ? 'volume-mute' : 'volume-unmute')": function stringVolume0VolumeMuteVolumeUnmute(obj) {
                  with (obj) return string(0 < volume ? "volume-mute" : "volume-unmute");
                },
                "csscommon + '-icon-volume-' + (volume >= 0.5 ? 'up' : (volume > 0 ? 'down' : 'off'))": function csscommonIconVolumeVolume05UpVolume0DownOff(obj) {
                  with (obj) return csscommon + "-icon-volume-" + (.5 <= volume ? "up" : 0 < volume ? "down" : "off");
                },
                "set_volume(volume + 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume + .1);
                },
                "set_volume(volume - 0.1)": function set_volumeVolume01(obj) {
                  with (obj) return set_volume(volume - .1);
                },
                "startUpdateVolume(domEvent)": function startUpdateVolumeDomEvent(obj) {
                  with (obj) return startUpdateVolume(domEvent);
                },
                "stopUpdateVolume(domEvent)": function stopUpdateVolumeDomEvent(obj) {
                  with (obj) return stopUpdateVolume(domEvent);
                },
                "progressUpdateVolume(domEvent)": function progressUpdateVolumeDomEvent(obj) {
                  with (obj) return progressUpdateVolume(domEvent);
                },
                "{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + '%'}": function widthMathCeil1MathMin99MathRoundVolume100(obj) {
                  with (obj) return {
                    width: Math.ceil(1 + Math.min(99, Math.round(100 * volume))) + "%"
                  };
                },
                "string('volume-button')": function stringVolumeButton(obj) {
                  with (obj) return string("volume-button");
                },
                title: function (_title24) {
                  function title(_x1259) {
                    return _title24.apply(this, arguments);
                  }
                  title.toString = function () {
                    return _title24.toString();
                  };
                  return title;
                }(function (obj) {
                  with (obj) return title;
                })
              }), {
                elevate: {
                  css: "ba-audioplayer",
                  csstheme: "ba-player-elevate-theme",
                  tmplcontrolbar: '\n<div class="{{csstheme}}-dashboard ">\n\n    <div class="{{csstheme}}-top-block">\n\n        <div class="{{csstheme}}-top-left-block">\n            <div class="{{csstheme}}-time-container {{csstheme}}-left-time-container">\n                <div class="{{csstheme}}-time-value" title="{{string(\'elapsed-time\')}}">{{formatTime(position)}}</div>\n            </div>\n        </div>\n\n        <div class="{{csstheme}}-top-right-block">\n\n            <div class="{{csstheme}}-time-container {{csstheme}}-right-time-container">\n                <div class="{{csstheme}}-time-value" title="{{string(\'total-time\')}}">{{formatTime(duration || position)}}</div>\n            </div>\n\n        </div>\n\n        <div class="{{csstheme}}-progressbar {{disableseeking ? cssplayer + \'-disabled\' : \'\'}}">\n            <div tabindex="2"\n                 ba-hotkey:right="{{seek(position + skipseconds)}}"\n                 ba-hotkey:left="{{seek(position - skipseconds)}}"\n                 onmouseout="this.blur()"\n                 data-selector="progress-bar-inner" class="{{csstheme}}-progressbar-inner"\n                 onmousedown="{{startUpdatePosition(domEvent)}}"\n                 onmouseup="{{stopUpdatePosition(domEvent)}}"\n                 onmouseleave="{{stopUpdatePosition(domEvent)}}"\n                 onmousemove="{{progressUpdatePosition(domEvent)}}"\n            >\n\n                <div class="{{csstheme}}-progressbar-cache" ba-styles="{{{width: Math.round(duration ? cached / duration * 100 : 0) + \'%\'}}}"></div>\n                <div class="{{csstheme}}-progressbar-position" ba-styles="{{{width: Math.round(duration ? position / duration * 100 : 0) + \'%\'}}}" title="{{string(\'audio-progress\')}}">\n                    <div class="{{csstheme}}-progressbar-button-description" style="display: none">\n                        <div class="{{csstheme}}-time-container">\n                            <div class="{{csstheme}}-time-value" title="{{string(\'elapsed-time\')}}">{{formatTime(position)}}</div>\n                        </div>\n                    </div>\n                    <div class="{{csstheme}}-progressbar-button"></div>\n                </div>\n            </div>\n        </div>\n\n    </div>\n\n    <div class="{{csstheme}}-bottom-block">\n\n        <div class="{{csstheme}}-left-block">\n\n            <div tabindex="0" ba-hotkey:space^enter="{{submit()}}" onmouseout="this.blur()"\n                 data-selector="submit-audio-button" class="{{csstheme}}-leftbutton-container"\n                 ba-if="{{submittable}}"  ba-click="{{submit()}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    {{string(\'submit-audio\')}}\n                </div>\n            </div>\n\n            <div tabindex="0" ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n                 data-selector="button-icon-ccw" class="{{csstheme}}-leftbutton-container"\n                 ba-if="{{rerecordable}}" ba-click="{{rerecord()}}" title="{{string(\'rerecord-audio\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon}}-icon-ccw"></i>\n                </div>\n            </div>\n\n            <div tabindex="0" ba-hotkey:space^enter="{{play()}}" onmouseout="this.blur()"\n                 onkeydown="{{tab_index_move(domEvent, null, \'button-icon-pause\')}}"\n                 data-selector="button-icon-play" class="{{csstheme}}-button-container"\n                 ba-if="{{!playing}}" ba-click="{{play()}}" title="{{string(\'play-audio\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon}}-icon-play"></i>\n                </div>\n            </div>\n\n            <div tabindex="0" ba-hotkey:space^enter="{{pause()}}" onmouseout="this.blur()"\n                 onkeydown="{{tab_index_move(domEvent, null, \'button-icon-play\')}}"\n                 data-selector="button-icon-pause" class="{{csstheme}}-button-container {{disablepause ? cssplayer + \'-disabled\' : \'\'}}"\n                 ba-if="{{playing}}" ba-click="{{pause()}}" title="{{disablepause ? string(\'pause-audio-disabled\') : string(\'pause-audio\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon}}-icon-pause"></i>\n                </div>\n            </div>\n\n            <div tabindex="3" ba-hotkey:space^enter="{{toggle_volume()}}" onmouseout="this.blur()"\n                 data-selector="button-icon-volume" class="{{csstheme}}-button-container"\n                 ba-click="{{toggle_volume()}}" title="{{string(volume > 0 ? \'volume-mute\' : \'volume-unmute\')}}"\n            >\n                <div class="{{csstheme}}-button-inner">\n                    <i class="{{csscommon + \'-icon-volume-\' + (volume >= 0.5 ? \'up\' : (volume > 0 ? \'down\' : \'off\')) }}"></i>\n                </div>\n            </div>\n\n            <div class="{{csstheme}}-volumebar">\n                <div tabindex="4"\n                     ba-hotkey:right="{{set_volume(volume + 0.1)}}"\n                     ba-hotkey:left="{{set_volume(volume - 0.1)}}"\n                     onmouseout="this.blur()"\n                     data-selector="button-volume-bar" class="{{csstheme}}-volumebar-inner"\n                     onmousedown="{{startUpdateVolume(domEvent)}}"\n                     onmouseup="{{stopUpdateVolume(domEvent)}}"\n                     onmouseleave="{{stopUpdateVolume(domEvent)}}"\n                     onmousemove="{{progressUpdateVolume(domEvent)}}"\n                >\n                    <div class="{{csstheme}}-volumebar-position" ba-styles="{{{width: Math.ceil(1+Math.min(99, Math.round(volume * 100))) + \'%\'}}}" title="{{string(\'volume-button\')}}"></div>\n                </div>\n            </div>\n\n        </div>\n\n        <div class="{{csstheme}}-center-block">\n            <div data-selector="audio-title-block" class="{{csstheme}}-title-block" ba-if="{{title}}">\n                <p class="{{csstheme}}-title">\n                    {{title}}\n                </p>\n            </div>\n        </div>\n\n    </div>\n</div>\n',
                  cssloader: ie8 ? "ba-audioplayer" : "",
                  cssmessage: "ba-audioplayer",
                  cssplaybutton: ie8 ? "ba-audioplayer" : ""
                }
              };
            }), Scoped.extend("module:Assets.audiorecorderthemes", ["dynamics:Parser"], function (Parser) {
              return Parser.registerFunctions({
                css: function (_css79) {
                  function css(_x1260) {
                    return _css79.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css79.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                topmessage: function (_topmessage12) {
                  function topmessage(_x1261) {
                    return _topmessage12.apply(this, arguments);
                  }
                  topmessage.toString = function () {
                    return _topmessage12.toString();
                  };
                  return topmessage;
                }(function (obj) {
                  with (obj) return topmessage;
                })
              }), Parser.registerFunctions({
                csstheme: function (_csstheme30) {
                  function csstheme(_x1262) {
                    return _csstheme30.apply(this, arguments);
                  }
                  csstheme.toString = function () {
                    return _csstheme30.toString();
                  };
                  return csstheme;
                }(function (obj) {
                  with (obj) return csstheme;
                }),
                css: function (_css80) {
                  function css(_x1263) {
                    return _css80.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css80.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                settingsvisible: function (_settingsvisible16) {
                  function settingsvisible(_x1264) {
                    return _settingsvisible16.apply(this, arguments);
                  }
                  settingsvisible.toString = function () {
                    return _settingsvisible16.toString();
                  };
                  return settingsvisible;
                }(function (obj) {
                  with (obj) return settingsvisible;
                }),
                settingsopen: function (_settingsopen4) {
                  function settingsopen(_x1265) {
                    return _settingsopen4.apply(this, arguments);
                  }
                  settingsopen.toString = function () {
                    return _settingsopen4.toString();
                  };
                  return settingsopen;
                }(function (obj) {
                  with (obj) return settingsopen;
                }),
                cameras: function (_cameras14) {
                  function cameras(_x1266) {
                    return _cameras14.apply(this, arguments);
                  }
                  cameras.toString = function () {
                    return _cameras14.toString();
                  };
                  return cameras;
                }(function (obj) {
                  with (obj) return cameras;
                }),
                "selectCamera(camera.id)": function selectCameraCameraId(obj) {
                  with (obj) return selectCamera(camera.id);
                },
                "selectedcamera == camera.id": function selectedcameraCameraId(obj) {
                  with (obj) return selectedcamera == camera.id;
                },
                "camera.label": function cameraLabel(obj) {
                  with (obj) return camera.label;
                },
                "settingsopen=!settingsopen": function settingsopenSettingsopen(obj) {
                  with (obj) return settingsopen = !settingsopen;
                },
                "settingsopen ? 'selected' : 'unselected'": function settingsopenSelectedUnselected(obj) {
                  with (obj) return settingsopen ? "selected" : "unselected";
                },
                "hover(string('settings'))": function hoverStringSettings(obj) {
                  with (obj) return hover(string("settings"));
                },
                "unhover()": function (_unhover13) {
                  function unhover(_x1267) {
                    return _unhover13.apply(this, arguments);
                  }
                  unhover.toString = function () {
                    return _unhover13.toString();
                  };
                  return unhover;
                }(function (obj) {
                  with (obj) return unhover();
                }),
                csscommon: function (_csscommon59) {
                  function csscommon(_x1268) {
                    return _csscommon59.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon59.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "!noaudio && !allowscreen": function noaudioAllowscreen(obj) {
                  with (obj) return !noaudio && !allowscreen;
                },
                "settingsvisible && settingsopen && audio": function settingsvisibleSettingsopenAudio(obj) {
                  with (obj) return settingsvisible && settingsopen && audio;
                },
                microphones: function (_microphones14) {
                  function microphones(_x1269) {
                    return _microphones14.apply(this, arguments);
                  }
                  microphones.toString = function () {
                    return _microphones14.toString();
                  };
                  return microphones;
                }(function (obj) {
                  with (obj) return microphones;
                }),
                audio: function (_audio5) {
                  function audio(_x1270) {
                    return _audio5.apply(this, arguments);
                  }
                  audio.toString = function () {
                    return _audio5.toString();
                  };
                  return audio;
                }(function (obj) {
                  with (obj) return audio;
                }),
                "selectMicrophone(microphone.id)": function selectMicrophoneMicrophoneId(obj) {
                  with (obj) return selectMicrophone(microphone.id);
                },
                "selectedmicrophone == microphone.id": function selectedmicrophoneMicrophoneId(obj) {
                  with (obj) return selectedmicrophone == microphone.id;
                },
                "microphone.label": function microphoneLabel(obj) {
                  with (obj) return microphone.label;
                },
                "hover(string(microphonehealthy ? 'microphonehealthy' : 'microphoneunhealthy'))": function hoverStringMicrophonehealthyMicrophonehealthyMicrophoneunhealthy(obj) {
                  with (obj) return hover(string(microphonehealthy ? "microphonehealthy" : "microphoneunhealthy"));
                },
                "microphonehealthy ? 'good' : 'bad'": function microphonehealthyGoodBad(obj) {
                  with (obj) return microphonehealthy ? "good" : "bad";
                },
                "hover(string(camerahealthy ? 'camerahealthy' : 'cameraunhealthy'))": function hoverStringCamerahealthyCamerahealthyCameraunhealthy(obj) {
                  with (obj) return hover(string(camerahealthy ? "camerahealthy" : "cameraunhealthy"));
                },
                "camerahealthy ? 'good' : 'bad'": function camerahealthyGoodBad(obj) {
                  with (obj) return camerahealthy ? "good" : "bad";
                },
                stopvisible: function (_stopvisible14) {
                  function stopvisible(_x1271) {
                    return _stopvisible14.apply(this, arguments);
                  }
                  stopvisible.toString = function () {
                    return _stopvisible14.toString();
                  };
                  return stopvisible;
                }(function (obj) {
                  with (obj) return stopvisible;
                }),
                controlbarlabel: function (_controlbarlabel16) {
                  function controlbarlabel(_x1272) {
                    return _controlbarlabel16.apply(this, arguments);
                  }
                  controlbarlabel.toString = function () {
                    return _controlbarlabel16.toString();
                  };
                  return controlbarlabel;
                }(function (obj) {
                  with (obj) return controlbarlabel;
                }),
                rerecordvisible: function (_rerecordvisible16) {
                  function rerecordvisible(_x1273) {
                    return _rerecordvisible16.apply(this, arguments);
                  }
                  rerecordvisible.toString = function () {
                    return _rerecordvisible16.toString();
                  };
                  return rerecordvisible;
                }(function (obj) {
                  with (obj) return rerecordvisible;
                }),
                "rerecord()": function (_rerecord41) {
                  function rerecord(_x1274) {
                    return _rerecord41.apply(this, arguments);
                  }
                  rerecord.toString = function () {
                    return _rerecord41.toString();
                  };
                  return rerecord;
                }(function (obj) {
                  with (obj) return rerecord();
                }),
                "hover(string('rerecord-tooltip'))": function hoverStringRerecordTooltip(obj) {
                  with (obj) return hover(string("rerecord-tooltip"));
                },
                "string('rerecord')": function stringRerecord(obj) {
                  with (obj) return string("rerecord");
                },
                cancelvisible: function (_cancelvisible13) {
                  function cancelvisible(_x1275) {
                    return _cancelvisible13.apply(this, arguments);
                  }
                  cancelvisible.toString = function () {
                    return _cancelvisible13.toString();
                  };
                  return cancelvisible;
                }(function (obj) {
                  with (obj) return cancelvisible;
                }),
                "cancel()": function (_cancel13) {
                  function cancel(_x1276) {
                    return _cancel13.apply(this, arguments);
                  }
                  cancel.toString = function () {
                    return _cancel13.toString();
                  };
                  return cancel;
                }(function (obj) {
                  with (obj) return cancel();
                }),
                "hover(string('cancel-tooltip'))": function hoverStringCancelTooltip(obj) {
                  with (obj) return hover(string("cancel-tooltip"));
                },
                "string('cancel')": function stringCancel(obj) {
                  with (obj) return string("cancel");
                },
                recordvisible: function (_recordvisible16) {
                  function recordvisible(_x1277) {
                    return _recordvisible16.apply(this, arguments);
                  }
                  recordvisible.toString = function () {
                    return _recordvisible16.toString();
                  };
                  return recordvisible;
                }(function (obj) {
                  with (obj) return recordvisible;
                }),
                "record()": function (_record13) {
                  function record(_x1278) {
                    return _record13.apply(this, arguments);
                  }
                  record.toString = function () {
                    return _record13.toString();
                  };
                  return record;
                }(function (obj) {
                  with (obj) return record();
                }),
                "hover(string('record-tooltip'))": function hoverStringRecordTooltip(obj) {
                  with (obj) return hover(string("record-tooltip"));
                },
                "string('record')": function stringRecord(obj) {
                  with (obj) return string("record");
                },
                "stop()": function (_stop12) {
                  function stop(_x1279) {
                    return _stop12.apply(this, arguments);
                  }
                  stop.toString = function () {
                    return _stop12.toString();
                  };
                  return stop;
                }(function (obj) {
                  with (obj) return stop();
                }),
                "mintimeindicator ? css + '-disabled': ''": function mintimeindicatorCssDisabled(obj) {
                  with (obj) return mintimeindicator ? css + "-disabled" : "";
                },
                "mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip')": function mintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip");
                },
                "hover(mintimeindicator ? string('stop-available-after').replace('%d', timeminlimit) : string('stop-tooltip'))": function hoverMintimeindicatorStringStopAvailableAfterReplaceDTimeminlimitStringStopTooltip(obj) {
                  with (obj) return hover(mintimeindicator ? string("stop-available-after").replace("%d", timeminlimit) : string("stop-tooltip"));
                },
                "string('stop')": function stringStop(obj) {
                  with (obj) return string("stop");
                },
                skipvisible: function (_skipvisible12) {
                  function skipvisible(_x1280) {
                    return _skipvisible12.apply(this, arguments);
                  }
                  skipvisible.toString = function () {
                    return _skipvisible12.toString();
                  };
                  return skipvisible;
                }(function (obj) {
                  with (obj) return skipvisible;
                }),
                "skip()": function (_skip19) {
                  function skip(_x1281) {
                    return _skip19.apply(this, arguments);
                  }
                  skip.toString = function () {
                    return _skip19.toString();
                  };
                  return skip;
                }(function (obj) {
                  with (obj) return skip();
                }),
                "hover(string('skip-tooltip'))": function hoverStringSkipTooltip(obj) {
                  with (obj) return hover(string("skip-tooltip"));
                },
                "string('skip')": function stringSkip(obj) {
                  with (obj) return string("skip");
                },
                uploadcovershotvisible: function (_uploadcovershotvisible12) {
                  function uploadcovershotvisible(_x1282) {
                    return _uploadcovershotvisible12.apply(this, arguments);
                  }
                  uploadcovershotvisible.toString = function () {
                    return _uploadcovershotvisible12.toString();
                  };
                  return uploadcovershotvisible;
                }(function (obj) {
                  with (obj) return uploadcovershotvisible;
                }),
                "hover(string('upload-covershot-tooltip'))": function hoverStringUploadCovershotTooltip(obj) {
                  with (obj) return hover(string("upload-covershot-tooltip"));
                },
                "uploadCovershot(domEvent)": function uploadCovershotDomEvent(obj) {
                  with (obj) return uploadCovershot(domEvent);
                },
                covershot_accept_string: function (_covershot_accept_string17) {
                  function covershot_accept_string(_x1283) {
                    return _covershot_accept_string17.apply(this, arguments);
                  }
                  covershot_accept_string.toString = function () {
                    return _covershot_accept_string17.toString();
                  };
                  return covershot_accept_string;
                }(function (obj) {
                  with (obj) return covershot_accept_string;
                }),
                "string('upload-covershot')": function stringUploadCovershot(obj) {
                  with (obj) return string("upload-covershot");
                }
              }), Parser.registerFunctions({
                css: function (_css81) {
                  function css(_x1284) {
                    return _css81.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css81.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                actions: function (_actions15) {
                  function actions(_x1285) {
                    return _actions15.apply(this, arguments);
                  }
                  actions.toString = function () {
                    return _actions15.toString();
                  };
                  return actions;
                }(function (obj) {
                  with (obj) return actions;
                }),
                "click_action(action)": function click_actionAction(obj) {
                  with (obj) return click_action(action);
                },
                "action.index": function actionIndex(obj) {
                  with (obj) return action.index;
                },
                "action.select && action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && action.capture;
                },
                "select_file_action(action, domEvent)": function select_file_actionActionDomEvent(obj) {
                  with (obj) return select_file_action(action, domEvent);
                },
                "action.accept": function actionAccept(obj) {
                  with (obj) return action.accept;
                },
                "action.select && !action.capture": function actionSelectActionCapture(obj) {
                  with (obj) return action.select && !action.capture;
                },
                "action.label": function actionLabel(obj) {
                  with (obj) return action.label;
                },
                csscommon: function (_csscommon60) {
                  function csscommon(_x1286) {
                    return _csscommon60.apply(this, arguments);
                  }
                  csscommon.toString = function () {
                    return _csscommon60.toString();
                  };
                  return csscommon;
                }(function (obj) {
                  with (obj) return csscommon;
                }),
                "action.icon": function actionIcon(obj) {
                  with (obj) return action.icon;
                }
              }), Parser.registerFunctions({
                css: function (_css82) {
                  function css(_x1287) {
                    return _css82.apply(this, arguments);
                  }
                  css.toString = function () {
                    return _css82.toString();
                  };
                  return css;
                }(function (obj) {
                  with (obj) return css;
                }),
                "click()": function (_click19) {
                  function click(_x1288) {
                    return _click19.apply(this, arguments);
                  }
                  click.toString = function () {
                    return _click19.toString();
                  };
                  return click;
                }(function (obj) {
                  with (obj) return click();
                }),
                "shortMessage ? 'short-message' : 'long-message'": function shortMessageShortMessageLongMessage(obj) {
                  with (obj) return shortMessage ? "short-message" : "long-message";
                },
                'message || ""': function (_message25) {
                  function message(_x1289) {
                    return _message25.apply(this, arguments);
                  }
                  message.toString = function () {
                    return _message25.toString();
                  };
                  return message;
                }(function (obj) {
                  with (obj) return message || "";
                }),
                "links && links.length > 0": function linksLinksLength0(obj) {
                  with (obj) return links && 0 < links.length;
                },
                links: function (_links13) {
                  function links(_x1290) {
                    return _links13.apply(this, arguments);
                  }
                  links.toString = function () {
                    return _links13.toString();
                  };
                  return links;
                }(function (obj) {
                  with (obj) return links;
                }),
                "linkClick(link)": function linkClickLink(obj) {
                  with (obj) return linkClick(link);
                },
                "link.title": function linkTitle(obj) {
                  with (obj) return link.title;
                }
              }), {
                elevate: {
                  css: "ba-audiorecorder",
                  csstheme: "ba-audiorecorder-theme-elevate",
                  cssrecorder: "ba-recorder",
                  cssmessage: "ba-audiorecorder",
                  cssloader: "ba-audiorecorder",
                  tmpltopmessage: '<div class="{{css}}-topmessage-container">\n    <div data-selector="recorder-topmessage-block" class=\'{{css}}-topmessage-message\'>\n        {{topmessage}}\n    </div>\n</div>\n',
                  tmplcontrolbar: '<div class="{{csstheme}}-dashboard">\n\n\t\n\t<div class="{{css}}-settings-left-sidebar">\n\n\t\t<div class="{{css}}-controlbar-left-section" ba-show="{{settingsvisible}}">\n\n\t\t\t\n\t\t\t<div data-selector="recorder-settings" class="{{css}}-settings {{css}}-settings-button-container">\n\n\t\t\t\t<div class="{{css}}-circle-button" ba-show="{{settingsvisible}}">\n\n\t\t\t\t\t<div class="{{css}}-bubble-info" ba-show="{{settingsopen}}" >\n\t\t\t\t\t\t<ul data-selector="camera-settings" ba-repeat="{{camera :: cameras}}">\n\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t<input tabindex="0"\n\t\t\t\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t\t\t   type=\'radio\' name=\'camera\' value="{{selectedcamera == camera.id}}"\n\t\t\t\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t\t<span></span>\n\t\t\t\t\t\t\t\t<label tabindex="0"\n\t\t\t\t\t\t\t\t\t   ba-hotkey:space^enter="{{selectCamera(camera.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t\t\t   onclick="{{selectCamera(camera.id)}}"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t{{camera.label}}\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div tabindex="0"\n\t\t\t\t\t\t ba-hotkey:space^enter="{{settingsopen=!settingsopen}}" onmouseout="this.blur()"\n\t\t\t\t\t\t data-selector="record-button-icon-cog"\n\t\t\t\t\t\t class="{{css}}-button-inner {{css}}-button-circle-{{settingsopen ? \'selected\' : \'unselected\' }}"\n\t\t\t\t\t\t onclick="{{settingsopen=!settingsopen}}"\n\t\t\t\t\t\t onmouseenter="{{hover(string(\'settings\'))}}"\n\t\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class="{{csscommon}}-icon-cog"></i>\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\n                <div class="{{css}}-circle-button" ba-show="{{!noaudio && !allowscreen}}">\n\n                    <div class="{{css}}-bubble-info" ba-show="{{settingsvisible && settingsopen && audio }}">\n                        <ul data-selector="microphone-settings" ba-repeat="{{microphone :: microphones}}" ba-show="{{audio}}">\n                            <li tabindex="0"\n\t\t\t\t\t\t\t\tba-hotkey:space^enter="{{selectMicrophone(microphone.id)}}" onmouseout="this.blur()"\n\t\t\t\t\t\t\t\tonclick="{{selectMicrophone(microphone.id)}}"\n\t\t\t\t\t\t\t>\n                                <input type=\'radio\' name=\'microphone\' value="{{selectedmicrophone == microphone.id}}" />\n                                <span></span>\n                                <label>\n                                    {{microphone.label}}\n                                </label>\n                            </li>\n                        </ul>\n                    </div>\n\n                    <div data-selector="record-button-icon-mic" class="{{css}}-button-inner"\n                         onmouseenter="{{hover(string(microphonehealthy ? \'microphonehealthy\' : \'microphoneunhealthy\'))}}"\n                         onmouseleave="{{unhover()}}">\n                        <i class="{{csscommon}}-icon-mic {{csscommon}}-icon-state-{{microphonehealthy ? \'good\' : \'bad\' }}"></i>\n                    </div>\n                </div>\n\n                <div class="{{css}}-circle-button" ba-show="{{!noaudio && !allowscreen}}">\n                    <div data-selector="record-button-icon-audiocam" class="{{css}}-button-inner"\n                         onmouseenter="{{hover(string(camerahealthy ? \'camerahealthy\' : \'cameraunhealthy\'))}}"\n                         onmouseleave="{{unhover()}}">\n                        <i class="{{csscommon}}-icon-audiocam {{csscommon}}-icon-state-{{ camerahealthy ? \'good\' : \'bad\' }}"></i>\n                    </div>\n                </div>\n\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t<div class="{{css}}-controlbar-middle-section">\n\n\t\t<div class="{{css}}-timer-container" ba-show="{{stopvisible}}">\n\t\t\t<div class="{{css}}-label-container" ba-show="{{controlbarlabel}}">\n\t\t\t\t<div data-selector="record-label-block" class="{{css}}-label {{css}}-button-primary">\n\t\t\t\t\t{{controlbarlabel}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t</div>\n\n\t\n\t<div data-selector="controlbar" class="{{css}}-controlbar">\n\n\t\t<div class="{{css}}-controlbar-center-section">\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{rerecordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{rerecord()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="rerecord-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{rerecord()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'rerecord-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'rerecord\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-button-container" ba-show="{{cancelvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{cancel()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="cancel-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{cancel()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'cancel-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'cancel\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class="{{css}}-primary-button-container" ba-show="{{recordvisible}}">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{record()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="record-primary-button" class="{{css}}-button-primary"\n\t\t\t\t\t onclick="{{record()}}"\n\t\t\t\t\t onmouseenter="{{hover(string(\'record-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'record\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class="{{css}}-stop-container" ba-show="{{stopvisible}}">\n\n\t\t\t<div class="{{css}}-stop-button-container">\n\t\t\t\t<div tabindex="0"\n\t\t\t\t\t ba-hotkey:space^enter="{{stop()}}" onmouseout="this.blur()"\n\t\t\t\t\t data-selector="stop-primary-button" class="{{css}}-button-primary {{mintimeindicator ? css + \'-disabled\': \'\'}}"\n\t\t\t\t\t title="{{mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\')}}"\n\t\t\t\t\t onclick="{{stop()}}"\n\t\t\t\t\t onmouseenter="{{hover(mintimeindicator ? string(\'stop-available-after\').replace(\'%d\', timeminlimit) : string(\'stop-tooltip\'))}}"\n\t\t\t\t\t onmouseleave="{{unhover()}}"\n\t\t\t\t>\n\t\t\t\t\t{{string(\'stop\')}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n        <div class="{{css}}-centerbutton-container" ba-show="{{skipvisible}}">\n            <div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{skip()}}" onmouseout="this.blur()"\n\t\t\t\t data-selector="skip-primary-button" class="{{css}}-button-primary"\n                 onclick="{{skip()}}"\n                 onmouseenter="{{hover(string(\'skip-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}"\n\t\t\t>\n                {{string(\'skip\')}}\n            </div>\n        </div>\n\n\n        <div class="{{css}}-rightbutton-container" ba-if="{{uploadcovershotvisible}}">\n            <div data-selector="covershot-primary-button" class="{{css}}-button-primary"\n                 onmouseenter="{{hover(string(\'upload-covershot-tooltip\'))}}"\n                 onmouseleave="{{unhover()}}">\n                <input type="file"\n                       class="{{css}}-chooser-file"\n                       style="height:100px"\n                       onchange="{{uploadCovershot(domEvent)}}"\n                       accept="{{covershot_accept_string}}" />\n                <span>\n                    {{string(\'upload-covershot\')}}\n                </span>\n            </div>\n        </div>\n\n\t</div>\n\n</div>\n',
                  tmplchooser: '<div class="{{css}}-chooser-container">\n\n\t<div class="{{css}}-chooser-button-container">\n\n\t\t<div ba-repeat="{{action :: actions}}">\n\t\t\t<div tabindex="0"\n\t\t\t\t ba-hotkey:space^enter="{{click_action(action)}}" onmouseout="this.blur()"\n\t\t\t\t class="{{css}}-chooser-button-{{action.index}}"\n\t\t\t\t ba-click="{{click_action(action)}}">\n\t\t\t\t<input ba-if="{{action.select && action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t\t   capture />\n\t\t\t\t<input ba-if="{{action.select && !action.capture}}"\n\t\t\t\t\t   type="file"\n\t\t\t\t\t   class="{{css}}-chooser-file"\n\t\t\t\t\t   onchange="{{select_file_action(action, domEvent)}}"\n\t\t\t\t\t   accept="{{action.accept}}"\n\t\t\t\t/>\n\t\t\t\t<span>\n\t\t\t\t\t{{action.label}}\n\t\t\t\t</span>\n\t\t\t\t<i class="{{csscommon}}-icon-{{action.icon}}"\n\t\t\t\t   ba-if="{{action.icon}}"></i>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>',
                  tmplmessage: '<div data-selector="recorder-message-container" class="{{css}}-message-container" ba-click="{{click()}}">\n    <div class="{{css}}-top-inner-message-container {{css}}-{{shortMessage ? \'short-message\' : \'long-message\'}}">\n        <div class="{{css}}-first-inner-message-container">\n            <div class="{{css}}-second-inner-message-container">\n                <div class="{{css}}-third-inner-message-container">\n                    <div class="{{css}}-fourth-inner-message-container">\n                        <div data-selector="recorder-message-block" class=\'{{css}}-message-message\'>\n                            <p>\n                                {{message || ""}}\n                            </p>\n                            <ul ba-if="{{links && links.length > 0}}" ba-repeat="{{link :: links}}">\n                                <li>\n                                    <a href="javascript:;" ba-click="{{linkClick(link)}}">\n                                        {{link.title}}\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n'
                }
              };
            });
          }.call(Scoped), function () {
            var Scoped = this.subScope();
            Scoped.binding("browser", "root:BetaJS.Browser"), Scoped.binding("base", "root:BetaJS"), Scoped.binding("module", "global:ZiggeoApi.V2"), Scoped.binding("private", "root:ZiggeoApi.V2"), Scoped.binding("media", "root:BetaJS.Media"), Scoped.binding("mediacomponents", "root:BetaJS.MediaComponents"), Scoped.binding("dynamics", "root:BetaJS.Dynamics"), Scoped.define("module:", function () {
              return {
                guid: "6c65838a-53fd-4fd1-8d48-e571a0500135"
              };
            }), Scoped.define("private:Core", function () {
              return {
                servers: {
                  local: {
                    whitedomains: ["*"],
                    "server.api.server.public.domain": "localhost:91",
                    "server.api.server.public.protocol": "http",
                    "assets.api.server.public.domain": "localhost:92",
                    "assets.api.server.public.protocol": "http",
                    "embed.api.server.public.domain": "localhost:93",
                    "embed.api.server.public.protocol": "http",
                    "analytics.api.server.public.domain": "localhost:1197",
                    "analytics.api.server.public.protocol": "http",
                    "server.js-api.server.public.domain": "localhost:1197",
                    "server.js-api.server.public.protocol": "http",
                    "embed-cdn.api.server.public.domain": "localhost:7342",
                    "embed-cdn.api.server.public.protocol": "http",
                    "media-cdn.api.server.public.domain": "localhost:7343",
                    "media-cdn.api.server.public.protocol": "http",
                    "streaming-cdn.api.server.public.domain": "localhost:90",
                    "streaming-cdn.api.server.public.protocol": "http",
                    "webserver.public.domain": "localhost:98",
                    "webserver.public.protocol": "http",
                    "web-api-server.public.domain": "localhost:96",
                    "web-api-server.public.protocol": "http",
                    "cdn-api-server.public.domain": "localhost:2396",
                    "cdn-api-server.public.protocol": "http",
                    "hosted.pages.server.public.domain": "localhost:99",
                    "hosted.pages.server.public.protocol": "http",
                    "wowza.api.record.rtmp.protocol": "rtmp",
                    "wowza.api.record.rtmp.domain": "localhost",
                    "wowza.api.record.rtmp.path": "record/_definst_",
                    "wowza.api.record.rtmp.audiopath": "audiorecord/_definst_",
                    "wowza.api.record.webrtc.wssurl": "wss://localhost:4444/webrtc-session.json",
                    "wowza.api.record.webrtc.app": "webrtcziggeo",
                    "wowza.api.record.webrtc.audioapp": "webrtcziggeoaudio",
                    prefix: "",
                    location: "Home",
                    account_number_prefix: "01",
                    "server.default-date-format": "M j, Y",
                    "server.default-time-format": "h:i a",
                    regions: {
                      other: {
                        prefix: "r1",
                        location: "Somewhere",
                        account_number_prefix: "02",
                        "server.api.server.public.domain": "localhost:191",
                        "embed.api.server.public.domain": "localhost:193",
                        "analytics.api.server.public.domain": "localhost:2197",
                        "server.js-api.server.public.domain": "localhost:2197",
                        "embed-cdn.api.server.public.domain": "localhost:11193",
                        "streaming-cdn.api.server.public.domain": "localhost:190",
                        "webserver.public.domain": "localhost:198",
                        "web-api-server.public.domain": "localhost:196",
                        "cdn-api-server.public.domain": "localhost:23196",
                        "hosted.pages.server.public.domain": "localhost:199",
                        "server.default-date-format": "d-m-Y",
                        "server.default-time-format": "H:i"
                      }
                    },
                    tags: {
                      local: !0,
                      development: !0
                    }
                  },
                  production: {
                    whitedomains: ["*.ziggeo.com", "ziggeo.com", "localhost"],
                    "server.api.server.public.domain": "srv-api.ziggeo.com",
                    "server.api.server.public.protocol": "https",
                    "assets.api.server.public.domain": "assets.ziggeo.com",
                    "assets.api.server.public.protocol": "https",
                    "embed.api.server.public.domain": "embed-api.ziggeo.com",
                    "embed.api.server.public.protocol": "https",
                    "analytics.api.server.public.domain": "api-us-east-1.ziggeo.com",
                    "analytics.api.server.public.protocol": "https",
                    "server.js-api.server.public.domain": "api-us-east-1.ziggeo.com",
                    "server.js-api.server.public.protocol": "https",
                    "embed-cdn.api.server.public.domain": "video-cdn.ziggeo.com",
                    "embed-cdn.api.server.public.protocol": "https",
                    "streaming-cdn.api.server.public.domain": "streaming-cdn.ziggeo.com",
                    "streaming-cdn.api.server.public.protocol": "https",
                    "media-cdn.api.server.public.domain": "media-cdn.ziggeo.com",
                    "media-cdn.api.server.public.protocol": "https",
                    "webserver.public.domain": "ziggeo.com",
                    "webserver.public.protocol": "https",
                    "web-api-server.public.domain": "webapi.ziggeo.com",
                    "web-api-server.public.protocol": "https",
                    "cdn-api-server.public.domain": "cdnapi.ziggeo.com",
                    "cdn-api-server.public.protocol": "https",
                    "hosted.pages.server.public.domain": "ziggeo.io",
                    "hosted.pages.server.public.protocol": "https",
                    "wowza.api.record.rtmp.protocol": "rtmps",
                    "wowza.api.record.rtmp.domain": "wowza.ziggeo.com",
                    "wowza.api.record.rtmp.path": "record/_definst_",
                    "wowza.api.record.rtmp.audiopath": "audiorecord/_definst_",
                    "wowza.api.record.webrtc.wssurl": "wss://wowza.ziggeo.com:443/webrtc-session.json",
                    "wowza.api.record.webrtc.app": "webrtcziggeo",
                    "wowza.api.record.webrtc.audioapp": "webrtcziggeoaudio",
                    prefix: "",
                    location: "U.S. / International",
                    account_number_prefix: "01",
                    "server.default-date-format": "M j, Y",
                    "server.default-time-format": "h:i a",
                    regions: {
                      "eu-west-1": {
                        prefix: "r1",
                        location: "Ireland / EU",
                        account_number_prefix: "02",
                        "server.api.server.public.domain": "srv-api-eu-west-1.ziggeo.com",
                        "embed.api.server.public.domain": "embed-api-eu-west-1.ziggeo.com",
                        "analytics.api.server.public.domain": "api-eu-west-1.ziggeo.com",
                        "server.js-api.server.public.domain": "api-eu-west-1.ziggeo.com",
                        "embed-cdn.api.server.public.domain": "video-cdn-eu-west-1.ziggeo.com",
                        "streaming-cdn.api.server.public.domain": "streaming-cdn-eu-west-1.ziggeo.com",
                        "media-cdn.api.server.public.domain": "media-cdn-eu-west-1.ziggeo.com",
                        "webserver.public.domain": "eu-west-1.ziggeo.com",
                        "web-api-server.public.domain": "webapi-eu-west-1.ziggeo.com",
                        "cdn-api-server.public.domain": "cdnapi-eu-west-1.ziggeo.com",
                        "hosted.pages.server.public.domain": "eu-west-1.ziggeo.io",
                        "wowza.api.record.rtmp.domain": "wowza-eu-west-1.ziggeo.com",
                        "wowza.api.record.webrtc.wssurl": "wss://wowza-eu-west-1.ziggeo.com:443/webrtc-session.json",
                        "server.default-date-format": "d-m-Y",
                        "server.default-time-format": "H:i"
                      }
                    },
                    tags: {
                      production: !0
                    }
                  },
                  development: {
                    whitedomains: ["*.ziggeo.com", "ziggeo.com", "localhost"],
                    "server.api.server.public.domain": "srv-api-dev.ziggeo.com",
                    "server.api.server.public.protocol": "https",
                    "assets.api.server.public.domain": "assets-dev.ziggeo.com",
                    "assets.api.server.public.protocol": "https",
                    "embed.api.server.public.domain": "embed-api-dev.ziggeo.com",
                    "embed.api.server.public.protocol": "https",
                    "analytics.api.server.public.domain": "api-us-east-1-dev.ziggeo.com",
                    "analytics.api.server.public.protocol": "https",
                    "embed-cdn.api.server.public.domain": "video-dev-cdn.ziggeo.com",
                    "embed-cdn.api.server.public.protocol": "https",
                    "server.js-api.server.public.domain": "api-us-east-1-dev.ziggeo.com",
                    "server.js-api.server.public.protocol": "https",
                    "streaming-cdn.api.server.public.domain": "streaming-cdn-dev.ziggeo.com",
                    "streaming-cdn.api.server.public.protocol": "https",
                    "media-cdn.api.server.public.domain": "media-cdn-dev.ziggeo.com",
                    "media-cdn.api.server.public.protocol": "https",
                    "webserver.public.domain": "www-dev.ziggeo.com",
                    "webserver.public.protocol": "https",
                    "web-api-server.public.domain": "webapi-dev.ziggeo.com",
                    "web-api-server.public.protocol": "https",
                    "cdn-api-server.public.domain": "cdnapi-dev.ziggeo.com",
                    "cdn-api-server.public.protocol": "https",
                    "hosted.pages.server.public.domain": "dev.ziggeo.io",
                    "hosted.pages.server.public.protocol": "https",
                    "wowza.api.record.rtmp.protocol": "rtmps",
                    "wowza.api.record.rtmp.domain": "wowza-dev.ziggeo.com",
                    "wowza.api.record.rtmp.path": "record/_definst_",
                    "wowza.api.record.rtmp.audiopath": "audiorecord/_definst_",
                    "wowza.api.record.webrtc.wssurl": "wss://wowza-dev.ziggeo.com:443/webrtc-session.json",
                    "wowza.api.record.webrtc.app": "webrtcziggeo",
                    "wowza.api.record.webrtc.audioapp": "webrtcziggeoaudio",
                    prefix: "",
                    location: "U.S. (US Law)",
                    account_number_prefix: "01",
                    "server.default-date-format": "M j, Y",
                    "server.default-time-format": "h:i a",
                    regions: {
                      "eu-west-1": {
                        prefix: "r1",
                        location: "Ireland (European Law)",
                        account_number_prefix: "02",
                        "server.api.server.public.domain": "srv-api-dev-eu-west-1.ziggeo.com",
                        "embed.api.server.public.domain": "embed-api-dev-eu-west-1.ziggeo.com",
                        "analytics.api.server.public.domain": "api-eu-west-1.ziggeo.com",
                        "embed-cdn.api.server.public.domain": "video-dev-cdn-eu-west-1.ziggeo.com",
                        "server.js-api.server.public.domain": "api-eu-west-1.ziggeo.com",
                        "streaming-cdn.api.server.public.domain": "streaming-cdn-dev-eu-west-1.ziggeo.com",
                        "media-cdn.api.server.public.domain": "media-cdn-dev-eu-west-1.ziggeo.com",
                        "webserver.public.domain": "dev-eu-west-1.ziggeo.com",
                        "web-api-server.public.domain": "webapi-dev-eu-west-1.ziggeo.com",
                        "cdn-api-server.public.domain": "cdnapi-dev-eu-west-1.ziggeo.com",
                        "hosted.pages.server.public.domain": "dev-eu-west-1.ziggeo.io",
                        "wowza.api.record.rtmp.domain": "wowza-dev-eu-west-1.ziggeo.com",
                        "wowza.api.record.webrtc.wssurl": "wss://wowza-dev-eu-west-1.ziggeo.com:443/webrtc-session.json",
                        "server.default-date-format": "d-m-Y",
                        "server.default-time-format": "H:i"
                      }
                    },
                    tags: {
                      development: !0
                    }
                  }
                },
                models: {
                  session_cookie_prefix: "i07af2jp98rvoctt26y5egy3"
                },
                revision: {
                  version: 1,
                  revision: 39,
                  latest: !0,
                  prerelease: !1
                },
                video: {
                  iframe: {
                    "allow-player-mods": ["speakers", "autoplay", "fullscreen"],
                    "allow-recorder-mods": ["speakers", "autoplay", "fullscreen", "microphone", "camera", "usermedia"],
                    "allow-audio-player-mods": ["speakers", "autoplay", "fullscreen"],
                    "allow-audio-recorder-mods": ["speakers", "autoplay", "fullscreen", "microphone", "usermedia"],
                    "allow-image-viewer-mods": ["fullscreen"],
                    "allow-image-capture-mods": ["fullscreen", "camera", "usermedia"]
                  }
                }
              };
            }), Scoped.define("private:Application.Connect", ["base:Class", "base:Objs", "base:Ajax.AjaxWrapper"], ["browser:Ajax.IframePostmessageAjax", "browser:Ajax.JsonpScriptAjax", "browser:Ajax.XDomainRequestAjax", "browser:Ajax.XmlHttpRequestAjax"], function (e, i, r, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.application = e, this.ajax = new r({
                      sendContentType: !1,
                      contentType: "urlencoded",
                      resilience: 5,
                      resilience_delay: 2500,
                      resilience_filter: function resilience_filter(e) {
                        return 400 <= e.status_code() && e.status_code() < 500;
                      },
                      wrapStatus: !0,
                      wrapStatusParam: "_wrapstatus",
                      noCache: !0,
                      noCacheParam: "_nocache"
                    });
                  },
                  destroy: function destroy() {
                    this.ajax.destroy(), t.destroy.call(this);
                  },
                  rawRequest: function rawRequest(e, t) {
                    return this.ajax.execute({
                      method: t.method,
                      data: t.data,
                      query: t.query,
                      uri: e,
                      resilience: t.resilience,
                      sendContentType: t.sendContentType
                    });
                  },
                  request: function request(e, t) {
                    return this.rawRequest(this.application.urls.httpApiResourceUrl(e, t), t);
                  },
                  apiRequest: function apiRequest(e, t) {
                    return this.rawRequest(this.application.urls.apiResourceUrl(e, t), i.extend({
                      sendContentType: !0
                    }, t));
                  }
                };
              });
            }), Scoped.define("private:Application.Data", ["base:Properties.Properties", "base:Objs", "browser:Cookies", "private:Core", "browser:Upload.FileUploader", "dynamics:Parser"], ["browser:Upload.ChunkedFileUploader"], function (e, o, r, a, n, s, t) {
              return e.extend({
                scoped: t
              }, function (i) {
                return {
                  constructor: function constructor(e, t) {
                    if (i.constructor.call(this), t = t || {}, this.set("token", t.token), !this.get("token")) throw "You need to specify an application token when creating an application";
                    this.set("webrtc_streaming", "boolean" == typeof t.webrtc_streaming && t.webrtc_streaming), this.set("webrtc_streaming_if_necessary", "boolean" != typeof t.webrtc_streaming_if_necessary || t.webrtc_streaming_if_necessary), this.set("webrtc_on_mobile", "boolean" == typeof t.webrtc_on_mobile && t.webrtc_on_mobile), this.set("track_tags", Array.isArray(t.track_tags) ? t.track_tags : []), this.set("auth", "boolean" == typeof t.auth && t.auth), this.set("analytics", "boolean" != typeof t.analytics || t.analytics), this.set("google_analytics", "boolean" == typeof t.google_analytics && t.google_analytics), this.set("google_analytics_track", "undefined" != typeof t.google_analytics_track ? t.google_analytics_track : ["init_application", "embedding_loaded", "record_start", "record_end", "rerecord_confirm", "upload_start"]), this.compute("cookie_key", function () {
                      return a.models.session_cookie_prefix + this.get("token");
                    }, ["token"]), this.set("cookie_value", this.get("auth") ? r.get(this.get("cookie_key")) : ""), this.on("change:cookie_value", function (e) {
                      this.get("auth") && r.set(this.get("cookie_key"), e);
                    }, this), this.set("testing_application", !1), this.set("debug", "debug" in t && t.debug !== undefined ? t.debug : a.revision.prerelease), this.set("chrome_extension_id", t.chrome_extension_id), this.set("opera_extension_id", t.opera_extension_id), this.set("chrome_extension_install_link", t.chrome_extension_install_link), this.set("opera_extension_install_link", t.opera_extension_install_link), t.disable_secure_templates && (s.secureMode = !1);
                  },
                  getUploaderConfig: function getUploaderConfig(e, t, i) {
                    var r = {
                      url: e,
                      serverSupportPostMessage: !0,
                      resilience: 5
                    };
                    return t && (r.source = t), o.extend(r, i);
                  },
                  getUploader: function getUploader(e, t, i) {
                    return n.create(this.getUploaderConfig(e, t, i));
                  },
                  getSignedUploaderConfig: function getSignedUploaderConfig(e, t, i) {
                    return this.getUploaderConfig(e, i, {
                      data: t
                    });
                  },
                  getSignedUploader: function getSignedUploader(e, t, i) {
                    return n.create(this.getSignedUploaderConfig(e, t, i));
                  }
                };
              });
            }), Scoped.define("private:Application.Debugger", ["base:Class", "base:Timers.Timer", "browser:Events"], function (e, i, r, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.application = e, this.__events = this.auto_destroy(new r()), this.__events.on(window, "error", function (e) {
                      this.__logError({
                        message: e.message,
                        source: e.filename,
                        lineno: e.lineno,
                        colno: e.colno,
                        time: e.timeStamp
                      });
                    }, this), this.__queue = [], this.__quota = 25, this.__timer = this.auto_destroy(new i({
                      context: this,
                      fire: this.__pushErrors,
                      delay: 5e3
                    }));
                  },
                  __logError: function __logError(e) {
                    this.__queue.length >= this.__quota || this.__queue.push(e);
                  },
                  __pushErrors: function __pushErrors() {
                    var e;
                    0 !== this.__queue.length && (e = this.__queue, this.__queue = [], this.__quota -= e.length, this.application.connect.request("/debugger", {
                      data: {
                        events: JSON.stringify(e)
                      },
                      method: "POST"
                    }));
                  }
                };
              });
            }), Scoped.define("module:Device", ["base:Events.Events", "base:Functions", "base:Async", "base:Promise", "media:Recorder.WebRTCVideoRecorderWrapper", "media:WebRTC.Support", "browser:Info", "private:Core"], function (e, t, i, r, o, a, n, s) {
              var x = function x(e, t) {
                  try {
                    return e();
                  } catch (i) {
                    return t || !1;
                  }
                },
                c = new e(),
                d = {
                  info: x(function () {
                    return {
                      location: document.location.href,
                      userAgent: navigator.userAgent,
                      device: n.formatDevice(),
                      os: n.formatOS(),
                      browser: n.formatBrowser(),
                      version: n.formatBrowserVersion(),
                      revision: s.revision
                    };
                  }, {}),
                  on: t.as_method(c.on, c),
                  webrtc: x(function () {
                    return o.supported({});
                  }),
                  cameras: null,
                  microphones: null,
                  camera_count: null,
                  microphone_count: null
                },
                l = function l() {
                  d.devices = null, c.persistentTrigger("device_error");
                };
              return d.media = function () {
                if ("devices" in d) return d.devices ? r.value(d.devices) : r.error("failed");
                var i = r.create();
                try {
                  a.enumerateMediaSources().success(function (e) {
                    var t;
                    i.asyncSuccess(e), t = e, d.devices = t, d.cameras = t.video, d.microphones = t.audio, d.camera_count = t.videoCount, d.microphone_count = t.audioCount, c.persistentTrigger("device_info", d.cameras, d.microphones, d.camera_count, d.microphone_count), c.persistentTrigger(0 < d.camera_count ? "has_camera" : "no_camera"), c.persistentTrigger(0 < d.microphone_count ? "has_microphone" : "no_microphone");
                  }).error(function () {
                    i.asyncError("failed"), l();
                  });
                } catch (e) {
                  i.asyncError("failed"), l();
                }
                return i;
              }, d;
            }), Scoped.define("module:Locale", ["base:Classes.LocaleAggregator", "base:Classes.LocaleTable", "browser:Info", "mediacomponents:Assets"], function (e, t, i, r) {
              var o = new e(),
                a = new t();
              return o.register(a), o.register(r.strings), o.setWeakLocale(i.language()), {
                setLocale: function setLocale(e) {
                  o.setLocale(e);
                },
                mainLocale: a,
                mediaLocale: r.strings
              };
            }), Scoped.define("private:Logger", [], function () {
              return {
                __console: function __console(e, t) {
                  try {
                    console && console[e] && console[e].apply(console, t);
                  } catch (i) {}
                  return this;
                },
                warn: function warn() {
                  return this.__console("warn", arguments);
                },
                log: function log() {
                  return this.__console("log", arguments);
                }
              };
            }), Scoped.define("private:Environment", ["private:Logger", "private:Core", "browser:Info", "browser:Loader", "base:Objs", "base:Types", "base:Net.Uri"], function (e, t, i, r, o, a, n) {
              t.revision.prerelease && e.warn("You are currently using a prerelease version of the Ziggeo JS SDK. We suggest using the stable revision for production use, and prereleases for staging environments and tests only.");
              var s = !!Scoped.getGlobal("ZiggeoLocal") || !!Scoped.getGlobal("ZiggeoWeb") && -1 === location.hostname.indexOf("ziggeo.com"),
                x = !1;
              s || (x = !0);
              try {
                0 !== location.protocol.indexOf("file") || i.isCordova() || e.warn("In order to use Ziggeo's recording technology, this page needs to be served via https. The file:// protocol is not supported. For more details contact us at support@ziggeo.com");
              } catch (k) {}
              try {
                0 === location.protocol.indexOf("https") ? window.location !== window.parent.location && 0 === document.referrer.indexOf("https") && e.warn("Accessing the camera and the microphone on insecure origins (HTTP) is deprecated, and future browser versions will stop to support insecure origins. We highly recommend upgrading to SSL (HTTPS). For more details contact us at support@ziggeo.com") : 0 === location.protocol.indexOf("http") && e.warn("Accessing the camera and the microphone on insecure origins (HTTP) is deprecated, and future browser versions will stop to support insecure origins. We highly recommend upgrading to SSL (HTTPS). For more details contact us at support@ziggeo.com");
              } catch (k) {}
              var c = !s,
                d = s || !!Scoped.getGlobal("ZiggeoDev") || !!Scoped.getGlobal("ZiggeoWeb") && c && -1 !== location.hostname.indexOf("dev"),
                l = !d,
                u = s ? "local" : l ? "production" : "development",
                h = o.clone(t.servers[u], 1),
                p = {};
              if (l && (p.cdn = h["assets.api.server.public.domain"].replace("assets.", "assets-cdn.")), p.normal = h["assets.api.server.public.domain"], s) try {
                window.location.hostname && /^\d+\.\d+\.\d+\.\d+$/.test(window.location.hostname) && (h = o.map(h, function (e) {
                  return a.is_string(e) ? e.replace("localhost", window.location.hostname) : e;
                }), p.local = h["assets.api.server.public.domain"]);
              } catch (k) {}
              var b,
                m = h["assets.api.server.public.domain"],
                g = "/v" + t.revision.version + "-r" + t.revision.revision + "/",
                v = x ? "https" : "http";
              for (var f in p) try {
                var y = p[f],
                  _ = r.findScript(y);
                if (_ && -1 !== _.src.indexOf("ziggeo.js")) {
                  var E = n.parse(_.src),
                    v = x ? "https" : E.protocol,
                    m = E.host;
                  E.port && (m += ":" + E.port), g = E.directory;
                  break;
                }
              } catch (k) {}
              return b = v + "://" + m + g, {
                isLocal: s,
                isServer: c,
                isDevelopment: d,
                isProduction: l,
                environment: u,
                serverEnvironments: t.servers,
                servers: h,
                serversByToken: function serversByToken(t) {
                  var i = o.clone(h, -1);
                  return o.iter(h.regions, function (e) {
                    0 === t.indexOf(e.prefix) && (i = o.extend(i, e));
                  }), i;
                },
                assetsDomain: m,
                assetsPath: g,
                assetsBase: b,
                sslRequired: x
              };
            }), Scoped.define("private:Application.Urls", ["base:Class", "base:Objs", "base:Sort", "base:Types", "base:Comparators", "base:Net.Uri", "base:Async", "browser:Info", "media:WebRTC.RecorderWrapper", "private:Environment"], function (e, i, r, t, o, a, n, s, x, c, d) {
              return e.extend({
                scoped: d
              }, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.application = e, this.__servers = c.serversByToken(this.application.data.get("token"));
                  },
                  httpApiBaseUrl: function httpApiBaseUrl() {
                    return (c.sslRequired ? "https" : "http") + "://" + this.__servers["embed.api.server.public.domain"];
                  },
                  httpStreamingBaseUrl: function httpStreamingBaseUrl() {
                    return (c.sslRequired ? "https" : "http") + "://" + this.__servers["embed-cdn.api.server.public.domain"];
                  },
                  apiStreamingBaseUrl: function apiStreamingBaseUrl() {
                    return (c.sslRequired ? "https" : "http") + "://" + this.__servers["media-cdn.api.server.public.domain"];
                  },
                  webrtcStreamingApp: function webrtcStreamingApp(e) {
                    return this.__servers["wowza.api.record.webrtc.app"] + (e || "");
                  },
                  wssUrl: function wssUrl() {
                    return this.__servers["wowza.api.record.webrtc.wssurl"];
                  },
                  webrtcAudioStreamingApp: function webrtcAudioStreamingApp(e) {
                    return this.__servers["wowza.api.record.webrtc.audioapp"] + (e || "");
                  },
                  httpApiAppUrl: function httpApiAppUrl() {
                    return this.httpApiBaseUrl() + "/v1/applications/" + this.application.data.get("token");
                  },
                  apiBaseUrl: function apiBaseUrl() {
                    return (c.isLocal ? "http" : "https") + "://" + this.__servers["server.js-api.server.public.domain"];
                  },
                  apiAppUrl: function apiAppUrl() {
                    return this.apiBaseUrl() + "/embed/v1/applications/" + this.application.data.get("token");
                  },
                  apiResourceUrl: function apiResourceUrl(e, t) {
                    return this.resourceUrl(this.apiAppUrl(), e, i.extend({
                      auth: !0
                    }, t));
                  },
                  httpApiResourceUrl: function httpApiResourceUrl(e, t) {
                    return this.resourceUrl(this.httpApiAppUrl(), e, i.extend({
                      auth: !0
                    }, t));
                  },
                  httpStreamingAppUrl: function httpStreamingAppUrl() {
                    return this.httpStreamingBaseUrl() + "/v1/applications/" + this.application.data.get("token");
                  },
                  httpStreamingResourceUrl: function httpStreamingResourceUrl(e, t) {
                    return this.resourceUrl(this.httpStreamingAppUrl(), e, t);
                  },
                  apiStreamingAppUrl: function apiStreamingAppUrl() {
                    return this.apiStreamingBaseUrl() + "/v1/applications/" + this.application.data.get("token");
                  },
                  apiStreamingResourceUrl: function apiStreamingResourceUrl(e, t) {
                    return this.resourceUrl(this.apiStreamingAppUrl(), e, t);
                  },
                  urlParams: function urlParams(e) {
                    e = e || {};
                    var t = i.extend({}, i.filter(e.params, function (e, t) {
                      return null !== e && "" !== e;
                    }));
                    return e.auth && this.application.data.get("auth") && ((t = i.extend(t, i.filter(e.auth, function (e, t) {
                      return null !== e && "" !== e;
                    })))[this.application.data.get("cookie_key")] = this.application.data.get("cookie_value")), r.sort_object(t, o.byValue);
                  },
                  hostedBaseUrl: function hostedBaseUrl() {
                    return (c.sslRequired ? "https" : "http") + "://" + this.__servers["hosted.pages.server.public.domain"];
                  },
                  hostedUrl: function hostedUrl(e) {
                    return this.hostedBaseUrl() + e;
                  },
                  resourceUrl: function resourceUrl(e, t, i) {
                    return a.appendUriParams(e + (t && 0 !== t.indexOf("/") ? "/" : "") + t, this.urlParams(i));
                  }
                };
              });
            }), Scoped.define("module:Config", ["private:Environment", "base:Properties.Properties", "base:Functions"], function (e, t, i) {
              var r = new t();
              return {
                set: i.as_method(r.set, r),
                get: i.as_method(r.get, r)
              };
            }), Scoped.define("module:Ads", ["mediacomponents:Ads.AdSenseVideoAdProvider", "mediacomponents:Ads.VastVideoAdProvider"], function (e, t) {
              return {
                AdSenseVideoAdProvider: e,
                VastVideoAdProvider: t
              };
            }), Scoped.define("module:Supplementary", ["base:Async"], function (o) {
              return {
                eventInvokeCallback: function eventInvokeCallback(e, t, i) {
                  try {
                    e.apply(t, i);
                  } catch (r) {
                    o.eventually(function () {
                      throw console.warn(r, e, t, i), r;
                    });
                  }
                }
              };
            }), Scoped.define("module:AudioPlayerStates.Initial", ["mediacomponents:AudioPlayer.Dynamics.PlayerStates.Initial"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  dynamics: ["loader"],
                  _started: function _started() {
                    this.dyn.get("audio_data") && 4 === this.dyn.get("audio_data").state ? this.next("AudioProcessing") : e._started.call(this);
                  }
                };
              });
            }), Scoped.define("module:AudioPlayerStates.AudioProcessing", ["mediacomponents:AudioPlayer.Dynamics.PlayerStates.State", "base:Time", "base:Timers.Timer"], function (e, r, t, i) {
              return e.extend({
                scoped: i
              }, function (e) {
                return {
                  dynamics: ["loader", "message"],
                  _started: function _started() {
                    this.dyn.set("message", this.dyn.string("audio-processing")), this.__audio = this.dyn.get("audio"), this.__shareaudio = this.dyn.get("shareaudio"), this.dyn.set("shareaudio", []), this.dyn.application.audios.watch(this.__audio, {
                      auth: this.dyn.get("auth"),
                      maxage: 2500
                    }, this.dyn.__audioUpdate, this.dyn), this.dyn.set("start-processing-time", r.now()), this.dyn._track("audio_processing_start"), this.auto_destroy(new t({
                      delay: 100,
                      context: this,
                      fire: function fire() {
                        var e = 1e3;
                        this.dyn.get("duration") && 1e3 < this.dyn.get("duration") / 60 * 1e3 && (e = this.dyn.get("duration") / 60 * 1e3);
                        var t = (r.now() - this.dyn.get("start-processing-time")) / e,
                          i = 1 - 1 / (1 + Math.sqrt(Math.sqrt(t)));
                        this.dyn.trigger("processing", i), this.dyn.parent() && this.dyn.parent().trigger("processing", i);
                      }
                    }));
                  },
                  _end: function _end() {
                    this.dyn.set("shareaudio", this.__shareaudio), this.dyn.application.audios.unwatch(this.__audio, this.dyn), this.dyn.set("end-processing-time", r.now()), this.dyn._track("audio_processing_end", {
                      media_time: this.dyn.get("end-processing-time") - this.dyn.get("start-processing-time")
                    }), this.dyn.trigger("processed"), this.dyn.parent() && this.dyn.parent().trigger("processed"), e._end.call(this);
                  }
                };
              });
            }), Scoped.define("module:AudioPlayerStates.PlayAudio", ["mediacomponents:AudioPlayer.Dynamics.PlayerStates.PlayAudio"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  _started: function _started() {
                    e._started.call(this), this.dyn._track("audio_play_start");
                  }
                };
              });
            }), Scoped.define("module:AudioRecorderStates.Recording", ["mediacomponents:AudioRecorder.Dynamics.RecorderStates.Recording"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  _started: function _started() {
                    e._started.call(this), this.dyn._track("audio_record_start");
                  },
                  _hasStopped: function _hasStopped() {
                    e._hasStopped.call(this), this.dyn._track("audio_record_end", {
                      media_time: this.dyn.get("duration")
                    });
                  }
                };
              });
            }), Scoped.define("module:AudioRecorderStates.Chooser", ["mediacomponents:AudioRecorder.Dynamics.RecorderStates.Chooser"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  _uploadFile: function _uploadFile(e) {
                    t._uploadFile.call(this, e), this.dyn._track("audio_upload_start", {
                      data_size: e.size
                    });
                  }
                };
              });
            }), Scoped.define("module:AudioRecorderStates.Uploading", ["mediacomponents:AudioRecorder.Dynamics.RecorderStates.Uploading", "base:Time"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, function (e) {
                return {
                  _started: function _started() {
                    e._started.call(this), this.dyn.__had_processed = !1, this.dyn._track("audio_uploading_start", {
                      data_size: this.dyn._dataUploader.totalBytes()
                    });
                  },
                  _finished: function _finished() {
                    e._finished.call(this), this.dyn._track("audio_uploading_end", {
                      media_time: this.dyn.get("end-upload-time") - this.dyn.get("start-upload-time"),
                      data_size: this.dyn._dataUploader.totalBytes(),
                      bandwidth: this.dyn._dataUploader.totalBytes() / (this.dyn.get("end-upload-time") - this.dyn.get("start-upload-time"))
                    }), this.dyn._track("upstream_bandwidth", {
                      media_time: this.dyn.get("end-upload-time") - this.dyn.get("start-upload-time"),
                      data_size: this.dyn._dataUploader.totalBytes(),
                      bandwidth: this.dyn._dataUploader.totalBytes() / (this.dyn.get("end-upload-time") - this.dyn.get("start-upload-time"))
                    }), this.dyn.setProp("playerattrs.forcerefresh", t.now());
                  }
                };
              });
            }), Scoped.define("module:ImageRecorderStates.Recording", ["mediacomponents:ImageCapture.Dynamics.RecorderStates.Recording"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  _started: function _started() {
                    e._started.call(this), this.dyn._track("image_record_start");
                  },
                  _hasStopped: function _hasStopped() {
                    e._hasStopped.call(this), this.dyn._track("image_record_end", {
                      media_time: this.dyn.get("duration")
                    });
                  }
                };
              });
            }), Scoped.define("module:ImageRecorderStates.Chooser", ["mediacomponents:ImageCapture.Dynamics.RecorderStates.Chooser"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  _uploadFile: function _uploadFile(e) {
                    t._uploadFile.call(this, e), this.dyn._track("image_upload_start", {
                      data_size: e.size
                    });
                  }
                };
              });
            }), Scoped.define("module:ImageRecorderStates.Uploading", ["mediacomponents:ImageCapture.Dynamics.RecorderStates.Uploading", "base:Time"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, function (e) {
                return {
                  _started: function _started() {
                    e._started.call(this), this.dyn.__had_processed = !1, this.dyn._track("image_uploading_start", {
                      data_size: this.dyn._dataUploader.totalBytes()
                    });
                  },
                  _finished: function _finished() {
                    e._finished.call(this), this.dyn._track("image_uploading_end", {
                      media_time: this.dyn.get("end-upload-time") - this.dyn.get("start-upload-time"),
                      data_size: this.dyn._dataUploader.totalBytes(),
                      bandwidth: this.dyn._dataUploader.totalBytes() / (this.dyn.get("end-upload-time") - this.dyn.get("start-upload-time"))
                    }), this.dyn._track("upstream_bandwidth", {
                      media_time: this.dyn.get("end-upload-time") - this.dyn.get("start-upload-time"),
                      data_size: this.dyn._dataUploader.totalBytes(),
                      bandwidth: this.dyn._dataUploader.totalBytes() / (this.dyn.get("end-upload-time") - this.dyn.get("start-upload-time"))
                    }), this.dyn.setProp("playerattrs.forcerefresh", t.now());
                  }
                };
              });
            }), Scoped.define("module:PlayerStates.Initial", ["mediacomponents:VideoPlayer.Dynamics.PlayerStates.Initial"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  dynamics: ["loader"],
                  _started: function _started() {
                    this.dyn.get("video_data") && 4 === this.dyn.get("video_data").state ? this.next("VideoProcessing") : e._started.call(this);
                  }
                };
              });
            }), Scoped.define("module:PlayerStates.PosterError", ["mediacomponents:VideoPlayer.Dynamics.PlayerStates.State"], function (e, t) {
              return e.extend({
                scoped: t
              }, {
                dynamics: ["loader"],
                _fail: function _fail() {
                  4 !== this.dyn.get("video_data").state ? window.navigator.onLine ? (this.dyn.set("loader_active", !1), this.dyn.set("message_active", !0), this.dyn.set("message", this.dyn.string("video-access-error")), this.listenOn(this.dyn, "message:click", function () {
                    this.next("LoadPlayer");
                  }, this)) : this.next("LoadError") : this.next("VideoProcessing");
                },
                _started: function _started() {
                  !0 !== this.dyn.get("video_status") ? this.listenOn(this.dyn, "change:video_status", function () {
                    !0 === this.dyn.get("video_status") && this._fail();
                  }) : this._fail();
                }
              });
            }), Scoped.define("module:PlayerStates.VideoProcessing", ["mediacomponents:VideoPlayer.Dynamics.PlayerStates.State", "base:Time", "base:Timers.Timer"], function (e, r, t, i) {
              return e.extend({
                scoped: i
              }, function (e) {
                return {
                  dynamics: ["loader", "message"],
                  _started: function _started() {
                    this.dyn.set("message", this.dyn.string("video-processing")), this.__video = this.dyn.get("video"), this.__sharevideo = this.dyn.get("sharevideo"), this.dyn.set("sharevideo", []), this.dyn.application.videos.watch(this.__video, {
                      auth: this.dyn.get("auth"),
                      maxage: 2500
                    }, this.dyn.__videoUpdate, this.dyn), this.dyn.set("start-processing-time", r.now()), this.dyn._track("processing_start"), this.auto_destroy(new t({
                      delay: 100,
                      context: this,
                      fire: function fire() {
                        var e = 1e3;
                        this.dyn.get("duration") && 1e3 < this.dyn.get("duration") / 60 * 1e3 && (e = this.dyn.get("duration") / 60 * 1e3);
                        var t = (r.now() - this.dyn.get("start-processing-time")) / e,
                          i = 1 - 1 / (1 + Math.sqrt(Math.sqrt(t)));
                        this.dyn.trigger("processing", i), this.dyn.parent() && this.dyn.parent().trigger("processing", i);
                      }
                    }));
                  },
                  _end: function _end() {
                    this.dyn.set("sharevideo", this.__sharevideo), this.dyn.application.videos.unwatch(this.__video, this.dyn), this.dyn.set("end-processing-time", r.now()), this.dyn._track("processing_end", {
                      media_time: this.dyn.get("end-processing-time") - this.dyn.get("start-processing-time")
                    }), this.dyn.trigger("processed"), this.dyn.parent() && this.dyn.parent().trigger("processed"), e._end.call(this);
                  }
                };
              });
            }), Scoped.define("module:PlayerStates.PlayVideo", ["mediacomponents:VideoPlayer.Dynamics.PlayerStates.PlayVideo"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  _started: function _started() {
                    e._started.call(this), this.dyn._track("play_start");
                  }
                };
              });
            }), Scoped.define("module:RecorderStates.Recording", ["mediacomponents:VideoRecorder.Dynamics.RecorderStates.Recording"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (e) {
                return {
                  _started: function _started() {
                    e._started.call(this), this.dyn._track("record_start");
                  },
                  _hasStopped: function _hasStopped() {
                    this.dyn._requiresDeviceOrientation && (this.dyn._rotation = this.dyn._readDeviceOrientation()), e._hasStopped.call(this), this.dyn._track("record_end", {
                      media_time: this.dyn.get("duration")
                    });
                  }
                };
              });
            }), Scoped.define("module:RecorderStates.Chooser", ["mediacomponents:VideoRecorder.Dynamics.RecorderStates.Chooser"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  _uploadFile: function _uploadFile(e) {
                    t._uploadFile.call(this, e), this.dyn._track("upload_start", {
                      data_size: e.size
                    });
                  }
                };
              });
            }), Scoped.define("module:RecorderStates.CovershotSelection", ["mediacomponents:VideoRecorder.Dynamics.RecorderStates.CovershotSelection"], function (e, t) {
              return e.extend({
                scoped: t
              }, function (t) {
                return {
                  _nextUploading: function _nextUploading(e) {
                    this.dyn._track(e ? "cover_skip" : "cover_select"), t._nextUploading.call(this, e);
                  }
                };
              });
            }), Scoped.define("module:RecorderStates.Uploading", ["mediacomponents:VideoRecorder.Dynamics.RecorderStates.Uploading", "base:Time"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, function (e) {
                return {
                  _started: function _started() {
                    e._started.call(this), this.dyn.__had_processed = !1, this.dyn._track("uploading_start", {
                      data_size: this.dyn._dataUploader.totalBytes()
                    });
                  },
                  _finished: function _finished() {
                    e._finished.call(this), this.dyn._track("uploading_end", {
                      media_time: this.dyn.get("end-upload-time") - this.dyn.get("start-upload-time"),
                      data_size: this.dyn._dataUploader.totalBytes(),
                      bandwidth: this.dyn._dataUploader.totalBytes() / (this.dyn.get("end-upload-time") - this.dyn.get("start-upload-time"))
                    }), this.dyn._track("upstream_bandwidth", {
                      media_time: this.dyn.get("end-upload-time") - this.dyn.get("start-upload-time"),
                      data_size: this.dyn._dataUploader.totalBytes(),
                      bandwidth: this.dyn._dataUploader.totalBytes() / (this.dyn.get("end-upload-time") - this.dyn.get("start-upload-time"))
                    }), this.dyn.setProp("playerattrs.forcerefresh", t.now());
                  }
                };
              });
            }), Scoped.define("private:Application.VideosApiMixin", function () {
              return {
                index: function index(e, t, i) {
                  return this.application.connect.request("/videos/", {
                    method: "GET",
                    auth: t,
                    resilience: i,
                    data: e
                  });
                },
                destroy: function destroy(e, t, i) {
                  return this.application.connect.request("/videos/" + e, {
                    method: "DELETE",
                    auth: t,
                    resilience: i
                  });
                },
                create: function create(e, t, i) {
                  return this.application.connect.request("/videos", {
                    method: "POST",
                    auth: t,
                    resilience: i,
                    data: e
                  });
                },
                _create: function _create(e, t, i) {
                  return this.application.connect.request("/videos/videos-upload-url", {
                    method: "POST",
                    auth: t,
                    resilience: i,
                    data: e
                  });
                },
                update: function update(e, t, i, r) {
                  return this.application.connect.request("/videos/" + e, {
                    method: "POST",
                    auth: i,
                    resilience: r,
                    data: t
                  });
                },
                _playback: function _playback(e, t, i, r) {
                  return this.application.connect.request("/videos/" + e + "/playback", {
                    method: "POST",
                    auth: i,
                    resilience: r,
                    data: t
                  });
                },
                get: function get(e, t, i) {
                  return this.application.connect.request("/videos/" + e, {
                    method: "GET",
                    auth: t,
                    resilience: i
                  });
                }
              };
            }), Scoped.define("private:Application.Videos", ["base:Class", "base:Promise", "base:Objs", "base:Time", "base:Async", "base:Types", "base:Net.HttpHeader", "base:Ids", "base:Comparators", "media:Player.Support", "private:Application.VideosApiMixin"], function (e, a, x, c, d, l, t, n, u, s, i, r) {
              return e.extend({
                scoped: r
              }, [i, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.application = e, this.__cache = {};
                  },
                  imageUrl: function imageUrl(e, t) {
                    t = t || {};
                    var i = "videos/" + e + "/image";
                    return this.application.urls.httpStreamingResourceUrl(i, {
                      auth: t.auth,
                      params: x.extend({
                        refresh: this.refreshToken(e)
                      }, t.params)
                    });
                  },
                  publicVideoUrl: function publicVideoUrl(e) {
                    return this.application.urls.hostedUrl("/v/" + e);
                  },
                  iframeVideoUrl: function iframeVideoUrl(e) {
                    return this.application.urls.hostedUrl("/p/" + e);
                  },
                  iframeRecorderUrl: function iframeRecorderUrl() {
                    return this.application.urls.hostedUrl("/r/" + this.application.data.get("token"));
                  },
                  videoUrl: function videoUrl(e, t) {
                    var i = "videos/" + e + "/" + ((t = t || {}).download ? "download_video.mp4" : "video.mp4");
                    return this.application.urls.httpStreamingResourceUrl(i, {
                      auth: t.auth,
                      params: x.extend({
                        refresh: this.refreshToken(e)
                      }, t.params)
                    });
                  },
                  refreshToken: function refreshToken(e) {
                    try {
                      var t = this.cache(e, {
                        weak: !0
                      }).value();
                      return !t || t.submission_date === t.resubmission_date || 86400 < c.now() / 1e3 - t.resubmission_date ? null : t.resubmission_date;
                    } catch (i) {
                      return null;
                    }
                  },
                  __cacheGet: function __cacheGet(e) {
                    return this.__cache[e] || (this.__cache[e] = {
                      ready: !1,
                      data: null,
                      error: null,
                      last_update: null,
                      auth: null,
                      next_update: null,
                      next_update_timer: null,
                      updating: !1,
                      promises: [],
                      watchers: {}
                    }), this.__cache[e];
                  },
                  __cacheUpdate: function __cacheUpdate(n, e) {
                    var s = this.__cacheGet(n);
                    if (!(s.updating || s.next_update && s.next_update <= e)) {
                      s.next_update && (d.clearEventually(s.next_update_timer), s.next_update = null);
                      var t = c.now();
                      if (t < e) return s.next_update = e, void (s.next_update_timer = d.eventually(function () {
                        this.__cacheUpdate(n);
                      }, this, e - t));
                      s.updating = !0, this.get(n, s.auth).callback(function (t, i) {
                        s.ready = !0, s.updating = !1;
                        var e = c.now(),
                          r = s.last_update ? e - s.last_update : null;
                        s.last_update = e, s.next_update = null;
                        var o = s.data,
                          a = t;
                        s.data = i, s.error = t, d.clearEventually(s.next_update_timer), x.iter(s.promises, function (e) {
                          e.asyncCallback(t, i);
                        }, this), s.promises = [], l.is_empty(s.watchers) || ((!t || t.equals(a)) && u.deepEqual(i, o, 10) || x.iter(s.watchers, function (e) {
                          e.callback.call(e.context, t, i);
                        }, this), null === r ? x.iter(s.watchers, function (e) {
                          e.weak || (r = null === r ? e.initialage : Math.min(e.initialage, r));
                        }, this) : r *= 2, null !== r && (x.iter(s.watchers, function (e) {
                          !e.weak && e.maxage && (r = Math.min(r, e.maxage));
                        }, this), this.__cacheUpdate(n, e + r)));
                      }, this);
                    }
                  },
                  cacheInvalidate: function cacheInvalidate(e) {
                    this.__cacheGet(e).ready = !1;
                  },
                  cache: function cache(e, t) {
                    var i = this.__cacheGet(e);
                    if ((t = x.extend({
                      auth: null,
                      weak: !1,
                      force: !1,
                      age: null
                    }, t)).weak && !i.ready) return a.error(!0);
                    if (i.ready && !t.force && (!t.age || now - i.last_update < t.age)) return i.data ? a.value(i.data) : a.error(i.error);
                    t.auth && (i.auth = t.auth);
                    var r = a.create();
                    return i.promises.push(r), this.__cacheUpdate(e), r;
                  },
                  watch: function watch(e, t, i, r) {
                    var o = this.__cacheGet(e);
                    (t = x.extend({
                      auth: null,
                      weak: !1,
                      maxage: null,
                      initialage: 1e3
                    }, t)).auth && (o.auth = t.auth), o.watchers[n.objectId(r)] = {
                      context: r,
                      callback: i,
                      weak: t.weak,
                      maxage: t.maxage,
                      age: t.initialage
                    }, t.weak || this.__cacheUpdate(e, t.initialage + c.now());
                  },
                  unwatch: function unwatch(e, t) {
                    delete this.__cacheGet(e).watchers[n.objectId(t)];
                  },
                  createByUpload: function createByUpload(o) {
                    return this._create(x.extend(x.clone(o.data, 1), {
                      create_stream: !0,
                      image_url: !!o.image_data,
                      audio_url: !!o.audio_data
                    }), o.auth, 5).mapSuccess(function (i) {
                      var r = a.create(),
                        e = this.application.streams.signedDataUploader(i.video.token, i.stream.token, {
                          auth: o.auth,
                          video_data: o.video_data,
                          audio_data: o.audio_data,
                          image_data: o.image_data,
                          url_data: i.url_data
                        });
                      return o.progress && e.on("progress", o.progress, o.context), e.on("error", function (e) {
                        r.asyncError(e);
                      }, this), e.on("success", function () {
                        var e = o.video_data instanceof Blob ? o.video_data : o.video_data.files[0];
                        s.videoFileInfo(e).callback(function (e, t) {
                          this.application.streams._confirm(i.video.token, i.stream.token, {
                            duration: t ? t.duration : 0
                          }, o.auth, 50).forwardCallback(r);
                        }, this);
                      }, this), e.upload(), r;
                    }, this);
                  }
                };
              }]);
            }), Scoped.define("private:Application.StreamsApiMixin", function () {
              return {
                index: function index(e, t, i, r) {
                  return this.application.connect.request("/videos/" + e + "/streams/", {
                    method: "GET",
                    auth: i,
                    resilience: r,
                    data: t
                  });
                },
                destroy: function destroy(e, t, i, r) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t, {
                    method: "DELETE",
                    auth: i,
                    resilience: r
                  });
                },
                create: function create(e, t, i, r) {
                  return this.application.connect.request("/videos/" + e + "/streams", {
                    method: "POST",
                    auth: i,
                    resilience: r,
                    data: t
                  });
                },
                _create: function _create(e, t, i, r) {
                  return this.application.connect.request("/videos/" + e + "/streams/streams-upload-url", {
                    method: "POST",
                    auth: i,
                    resilience: r,
                    data: t
                  });
                },
                accept: function accept(e, t, i, r) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t + "/accept", {
                    method: "POST",
                    auth: i,
                    resilience: r
                  });
                },
                _image_attach: function _image_attach(e, t, i, r, o) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t + "/imageattach", {
                    method: "POST",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                },
                _audio_attach: function _audio_attach(e, t, i, r, o) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t + "/audioattach", {
                    method: "POST",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                },
                _recorder_submit: function _recorder_submit(e, t, i, r, o) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t + "/recordersubmit", {
                    method: "POST",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                },
                _uploader_state: function _uploader_state(e, t, i, r) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t + "/uploaderstate", {
                    method: "GET",
                    auth: i,
                    resilience: r
                  });
                },
                _subtitle_attach: function _subtitle_attach(e, t, i, r) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t + "/subtitleattach", {
                    method: "POST",
                    auth: i,
                    resilience: r
                  });
                },
                _confirm: function _confirm(e, t, i, r, o, a) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t + "/confirm-video", {
                    method: "POST",
                    auth: r,
                    resilience: o,
                    data: i,
                    query: a
                  });
                },
                _confirm_image: function _confirm_image(e, t, i, r, o) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t + "/confirm-image", {
                    method: "POST",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                },
                _confirm_audio: function _confirm_audio(e, t, i, r, o) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t + "/confirm-audio", {
                    method: "POST",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                },
                _get_video_upload_urls: function _get_video_upload_urls(e, t, i, r, o) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t + "/video-upload-urls", {
                    method: "GET",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                },
                _get_image_upload_urls: function _get_image_upload_urls(e, t, i, r, o) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t + "/image-upload-urls", {
                    method: "GET",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                },
                _get_audio_upload_urls: function _get_audio_upload_urls(e, t, i, r, o) {
                  return this.application.connect.request("/videos/" + e + "/streams/" + t + "/audio-upload-urls", {
                    method: "GET",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                }
              };
            }), Scoped.define("private:Application.Streams", ["base:Class", "base:Objs", "private:Application.StreamsApiMixin", "browser:Upload.MultiUploader"], function (e, t, i, o, r) {
              return e.extend({
                scoped: r
              }, [i, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.application = e;
                  },
                  imageUrl: function imageUrl(e, t, i) {
                    i = i || {};
                    var r = "videos/" + e + "/streams/" + t + "/image";
                    return this.application.urls.httpStreamingResourceUrl(r, {
                      auth: i.auth,
                      params: i.params
                    });
                  },
                  videoUrl: function videoUrl(e, t, i) {
                    var r = "videos/" + e + "/streams/" + t + "/" + ((i = i || {}).download ? "download_video.mp4" : "video.mp4");
                    return this.application.urls.httpStreamingResourceUrl(r, {
                      auth: i.auth,
                      params: i.params
                    });
                  },
                  videoAttachUrl: function videoAttachUrl(e, t, i) {
                    return this.application.urls.httpApiResourceUrl("/videos/" + e + "/streams/" + t + "/videoattach", {
                      auth: i
                    });
                  },
                  videoAttachUploaderConfig: function videoAttachUploaderConfig(e, t, i, r) {
                    return this.application.data.getUploaderConfig(this.videoAttachUrl(e, t, i), r);
                  },
                  videoAttachUploader: function videoAttachUploader(e, t, i, r) {
                    return this.application.data.getUploader(this.videoAttachUrl(e, t, i), r);
                  },
                  imageAttachUrl: function imageAttachUrl(e, t, i) {
                    return this.application.urls.httpApiResourceUrl("/videos/" + e + "/streams/" + t + "/imageattach", {
                      auth: i
                    });
                  },
                  imageAttachUploaderConfig: function imageAttachUploaderConfig(e, t, i, r) {
                    return this.application.data.getUploaderConfig(this.imageAttachUrl(e, t, i), r, {
                      nonessential: !1
                    });
                  },
                  imageAttachUploader: function imageAttachUploader(e, t, i, r) {
                    return this.application.data.getUploader(this.imageAttachUrl(e, t, i), r, {
                      essential: !1
                    });
                  },
                  audioAttachUrl: function audioAttachUrl(e, t, i) {
                    return this.application.urls.httpApiResourceUrl("/videos/" + e + "/streams/" + t + "/audioattach", {
                      auth: i
                    });
                  },
                  subtitleAttachUrl: function subtitleAttachUrl(e, t, i) {
                    return this.application.urls.httpApiResourceUrl("/videos/" + e + "/streams/" + t + "/subtitleattach", {
                      auth: i
                    });
                  },
                  audioAttachUploaderConfig: function audioAttachUploaderConfig(e, t, i, r) {
                    return this.application.data.getUploaderConfig(this.audioAttachUrl(e, t, i), r);
                  },
                  subtitleAttachUploaderUrl: function subtitleAttachUploaderUrl(e, t, i) {
                    return this.subtitleAttachUrl(e, t, i);
                  },
                  audioAttachUploader: function audioAttachUploader(e, t, i, r) {
                    return this.application.data.getUploader(this.audioAttachUrl(e, t, i), r);
                  },
                  webrtcStreamName: function webrtcStreamName(e, t, i) {
                    return "applications___" + this.application.data.get("token") + "___videos___" + e + "___streams___" + t + "___video";
                  },
                  dataUploader: function dataUploader(e, t, i) {
                    var r = new o();
                    return i.video_data && r.addUploader(this.videoAttachUploader(e, t, i.auth, i.video_data)), i.audio_data && r.addUploader(this.audioAttachUploader(e, t, i.auth, i.audio_data)), i.image_data && r.addUploader(this.imageAttachUploader(e, t, i.auth, i.image_data)), r;
                  },
                  signedDataUploader: function signedDataUploader(e, t, i) {
                    var r = new o();
                    return i.video_data && r.addUploader(this.application.data.getSignedUploader(i.url_data.url, i.url_data.fields, i.video_data)), i.audio_data && r.addUploader(this.application.data.getSignedUploader(i.audio_url_data.url, i.audio_url_data.fields, i.audio_data)), i.image_data && r.addUploader(this.application.data.getSignedUploader(i.image_url_data.url, i.image_url_data.fields, i.image_data)), r;
                  }
                };
              }]);
            }), Scoped.define("private:Application.AudiosApiMixin", function () {
              return {
                index: function index(e, t, i) {
                  return this.application.connect.apiRequest("/audios/", {
                    method: "GET",
                    auth: t,
                    resilience: i,
                    data: e
                  });
                },
                destroy: function destroy(e, t, i) {
                  return this.application.connect.apiRequest("/audios/" + e, {
                    method: "DELETE",
                    auth: t,
                    resilience: i
                  });
                },
                create: function create(e, t, i) {
                  return this.application.connect.apiRequest("/audios", {
                    method: "POST",
                    auth: t,
                    resilience: i,
                    data: e
                  });
                },
                update: function update(e, t, i, r) {
                  return this.application.connect.apiRequest("/audios/" + e, {
                    method: "POST",
                    auth: i,
                    resilience: r,
                    data: t
                  });
                },
                get: function get(e, t, i) {
                  return this.application.connect.apiRequest("/audios/" + e, {
                    method: "GET",
                    auth: t,
                    resilience: i
                  });
                }
              };
            }), Scoped.define("private:Application.Audios", ["base:Class", "base:Promise", "base:Objs", "base:Time", "base:Async", "base:Types", "base:Net.HttpHeader", "base:Ids", "base:Comparators", "media:Player.Support", "private:Application.AudiosApiMixin"], function (e, a, x, c, d, l, t, n, u, s, i, r) {
              return e.extend({
                scoped: r
              }, [i, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.application = e, this.__cache = {};
                  },
                  audioUrl: function audioUrl(e, t) {
                    var i = "audios/" + e + "/" + ((t = t || {}).download ? "download_audio.aac" : "audio.aac");
                    return this.application.urls.apiStreamingResourceUrl(i, {
                      auth: t.auth,
                      params: x.extend({
                        refresh: this.refreshToken(e)
                      }, t.params)
                    });
                  },
                  refreshToken: function refreshToken(e) {
                    try {
                      var t = this.cache(e, {
                        weak: !0
                      }).value();
                      return !t || t.submission_date === t.resubmission_date || 86400 < c.now() / 1e3 - t.resubmission_date ? null : t.resubmission_date;
                    } catch (i) {
                      return null;
                    }
                  },
                  __cacheGet: function __cacheGet(e) {
                    return this.__cache[e] || (this.__cache[e] = {
                      ready: !1,
                      data: null,
                      error: null,
                      last_update: null,
                      auth: null,
                      next_update: null,
                      next_update_timer: null,
                      updating: !1,
                      promises: [],
                      watchers: {}
                    }), this.__cache[e];
                  },
                  __cacheUpdate: function __cacheUpdate(n, e) {
                    var s = this.__cacheGet(n);
                    if (!(s.updating || s.next_update && s.next_update <= e)) {
                      s.next_update && (d.clearEventually(s.next_update_timer), s.next_update = null);
                      var t = c.now();
                      if (t < e) return s.next_update = e, void (s.next_update_timer = d.eventually(function () {
                        this.__cacheUpdate(n);
                      }, this, e - t));
                      s.updating = !0, this.get(n, s.auth).callback(function (t, i) {
                        i = i && i.audio ? i.audio : i, s.ready = !0, s.updating = !1;
                        var e = c.now(),
                          r = s.last_update ? e - s.last_update : null;
                        s.last_update = e, s.next_update = null;
                        var o = s.data,
                          a = t;
                        s.data = i, s.error = t, d.clearEventually(s.next_update_timer), x.iter(s.promises, function (e) {
                          e.asyncCallback(t, i);
                        }, this), s.promises = [], l.is_empty(s.watchers) || ((!t || t.equals(a)) && u.deepEqual(i, o, 10) || x.iter(s.watchers, function (e) {
                          e.callback.call(e.context, t, i);
                        }, this), null === r ? x.iter(s.watchers, function (e) {
                          e.weak || (r = null === r ? e.initialage : Math.min(e.initialage, r));
                        }, this) : r *= 2, null !== r && (x.iter(s.watchers, function (e) {
                          !e.weak && e.maxage && (r = Math.min(r, e.maxage));
                        }, this), this.__cacheUpdate(n, e + r)));
                      }, this);
                    }
                  },
                  cacheInvalidate: function cacheInvalidate(e) {
                    this.__cacheGet(e).ready = !1;
                  },
                  cache: function cache(e, t) {
                    var i = this.__cacheGet(e);
                    if ((t = x.extend({
                      auth: null,
                      weak: !1,
                      force: !1,
                      age: null
                    }, t)).weak && !i.ready) return a.error(!0);
                    if (i.ready && !t.force && (!t.age || now - i.last_update < t.age)) return i.data ? a.value(i.data) : a.error(i.error);
                    t.auth && (i.auth = t.auth);
                    var r = a.create();
                    return i.promises.push(r), this.__cacheUpdate(e), r;
                  },
                  watch: function watch(e, t, i, r) {
                    var o = this.__cacheGet(e);
                    (t = x.extend({
                      auth: null,
                      weak: !1,
                      maxage: null,
                      initialage: 1e3
                    }, t)).auth && (o.auth = t.auth), o.watchers[n.objectId(r)] = {
                      context: r,
                      callback: i,
                      weak: t.weak,
                      maxage: t.maxage,
                      age: t.initialage
                    }, t.weak || this.__cacheUpdate(e, t.initialage + c.now());
                  },
                  unwatch: function unwatch(e, t) {
                    delete this.__cacheGet(e).watchers[n.objectId(t)];
                  },
                  createByUpload: function createByUpload(o) {
                    return this.create(x.extend(x.clone(o.data, 1), {
                      create_stream: !0
                    }), o.auth, 5).mapSuccess(function (i) {
                      var r = a.create(),
                        e = this.application.data.getSignedUploader(i.url_data.url, i.url_data.fields, o.audio_data);
                      return o.progress && e.on("progress", o.progress, o.context), e.on("error", function (e) {
                        r.asyncError(e);
                      }, this), e.on("success", function () {
                        var e = o.audio_data instanceof Blob ? o.audio_data : o.audio_data.files[0];
                        s.audioFileInfo(e).callback(function (e, t) {
                          this.application.audio_streams.confirm(i.audio.token, i.audio_stream.token, {
                            duration: t ? t.duration : 0
                          }, o.auth, 50).forwardCallback(r);
                        }, this);
                      }, this), e.upload(), r;
                    }, this);
                  }
                };
              }]);
            }), Scoped.define("private:Application.AudioStreamsApiMixin", function () {
              return {
                index: function index(e, t, i, r) {
                  return this.application.connect.apiRequest("/audios/" + e + "/streams/", {
                    method: "GET",
                    auth: i,
                    resilience: r,
                    data: t
                  });
                },
                destroy: function destroy(e, t, i, r) {
                  return this.application.connect.apiRequest("/audios/" + e + "/streams/" + t, {
                    method: "DELETE",
                    auth: i,
                    resilience: r
                  });
                },
                create: function create(e, t, i, r) {
                  return this.application.connect.apiRequest("/audios/" + e + "/streams", {
                    method: "POST",
                    auth: i,
                    resilience: r,
                    data: t
                  });
                },
                confirm: function confirm(e, t, i, r, o) {
                  return this.application.connect.apiRequest("/audios/" + e + "/streams/" + t + "/confirm", {
                    method: "POST",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                },
                submit: function submit(e, t, i, r, o) {
                  return this.application.connect.apiRequest("/audios/" + e + "/streams/" + t + "/submit", {
                    method: "POST",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                },
                get: function get(e, t, i, r) {
                  return this.application.connect.apiRequest("/audios/" + e + "/streams/" + t, {
                    method: "GET",
                    auth: i,
                    resilience: r
                  });
                },
                _get_audio_upload_urls: function _get_audio_upload_urls(e, t, i, r, o) {
                  return this.application.connect.apiRequest("/audios/" + e + "/streams/" + t + "/audio-upload-urls", {
                    method: "GET",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                }
              };
            }), Scoped.define("private:Application.AudioStreams", ["base:Class", "base:Objs", "private:Application.AudioStreamsApiMixin"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, [i, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.application = e;
                  },
                  audioUrl: function audioUrl(e, t, i) {
                    var r = "audios/" + e + "/streams/" + t + "/" + ((i = i || {}).download ? "download_audio.aac" : "audio.aac");
                    return this.application.urls.apiStreamingResourceUrl(r, {
                      auth: i.auth,
                      params: i.params
                    });
                  },
                  webrtcStreamName: function webrtcStreamName(e, t, i) {
                    return "applications___" + this.application.data.get("token") + "___audios___" + e + "___streams___" + t + "___audio";
                  }
                };
              }]);
            }), Scoped.define("private:Application.ImagesApiMixin", function () {
              return {
                index: function index(e, t, i) {
                  return this.application.connect.apiRequest("/images/", {
                    method: "GET",
                    auth: t,
                    resilience: i,
                    data: e
                  });
                },
                destroy: function destroy(e, t, i) {
                  return this.application.connect.apiRequest("/images/" + e, {
                    method: "DELETE",
                    auth: t,
                    resilience: i
                  });
                },
                create: function create(e, t, i) {
                  return this.application.connect.apiRequest("/images", {
                    method: "POST",
                    auth: t,
                    resilience: i,
                    data: e
                  });
                },
                update: function update(e, t, i, r) {
                  return this.application.connect.apiRequest("/images/" + e, {
                    method: "POST",
                    auth: i,
                    resilience: r,
                    data: t
                  });
                },
                get: function get(e, t, i) {
                  return this.application.connect.apiRequest("/images/" + e, {
                    method: "GET",
                    auth: t,
                    resilience: i
                  });
                }
              };
            }), Scoped.define("private:Application.Images", ["base:Class", "base:Promise", "base:Objs", "base:Time", "base:Async", "base:Net.HttpHeader", "base:Ids", "base:Comparators", "private:Application.ImagesApiMixin"], function (e, o, x, c, d, t, a, l, i, r) {
              return e.extend({
                scoped: r
              }, [i, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.application = e, this.__cache = {};
                  },
                  imageUrl: function imageUrl(e, t) {
                    var i = "images/" + e + "/" + ((t = t || {}).download ? "download_image.mp4" : "image.mp4");
                    return this.application.urls.apiStreamingResourceUrl(i, {
                      auth: t.auth,
                      params: x.extend({
                        refresh: this.refreshToken(e)
                      }, t.params)
                    });
                  },
                  refreshToken: function refreshToken(e) {
                    try {
                      var t = this.cache(e, {
                        weak: !0
                      }).value();
                      return !t || t.submission_date === t.resubmission_date || 86400 < c.now() / 1e3 - t.resubmission_date ? null : t.resubmission_date;
                    } catch (i) {
                      return null;
                    }
                  },
                  __cacheGet: function __cacheGet(e) {
                    return this.__cache[e] || (this.__cache[e] = {
                      ready: !1,
                      data: null,
                      error: null,
                      last_update: null,
                      auth: null,
                      next_update: null,
                      next_update_timer: null,
                      updating: !1,
                      promises: [],
                      watchers: {}
                    }), this.__cache[e];
                  },
                  __cacheUpdate: function __cacheUpdate(n, e) {
                    var s = this.__cacheGet(n);
                    if (!(s.updating || s.next_update && s.next_update <= e)) {
                      s.next_update && (d.clearEventually(s.next_update_timer), s.next_update = null);
                      var t = c.now();
                      if (t < e) return s.next_update = e, void (s.next_update_timer = d.eventually(function () {
                        this.__cacheUpdate(n);
                      }, this, e - t));
                      s.updating = !0, this.get(n, s.auth).callback(function (t, i) {
                        i = i && i.image ? i.image : i, s.ready = !0, s.updating = !1;
                        var e = c.now(),
                          r = s.last_update ? e - s.last_update : null;
                        s.last_update = e, s.next_update = null;
                        var o = s.data,
                          a = t;
                        s.data = i, s.error = t, d.clearEventually(s.next_update_timer), x.iter(s.promises, function (e) {
                          e.asyncCallback(t, i);
                        }, this), (!t || t.equals(a)) && l.deepEqual(i, o, 10) || x.iter(s.watchers, function (e) {
                          e.callback.call(e.context, t, i);
                        }, this), null === r ? x.iter(s.watchers, function (e) {
                          e.weak || (r = null === r ? e.initialage : Math.min(e.initialage, r));
                        }, this) : r *= 2, null !== r && (x.iter(s.watchers, function (e) {
                          !e.weak && e.maxage && (r = Math.min(r, e.maxage));
                        }, this), this.__cacheUpdate(n, e + r));
                      }, this);
                    }
                  },
                  cacheInvalidate: function cacheInvalidate(e) {
                    this.__cacheGet(e).ready = !1;
                  },
                  cache: function cache(e, t) {
                    var i = this.__cacheGet(e);
                    if ((t = x.extend({
                      auth: null,
                      weak: !1,
                      force: !1,
                      age: null
                    }, t)).weak && !i.ready) return o.error(!0);
                    if (i.ready && !t.force && (!t.age || now - i.last_update < t.age)) return i.data ? o.value(i.data) : o.error(i.error);
                    t.auth && (i.auth = t.auth);
                    var r = o.create();
                    return i.promises.push(r), this.__cacheUpdate(e), r;
                  },
                  watch: function watch(e, t, i, r) {
                    var o = this.__cacheGet(e);
                    (t = x.extend({
                      auth: null,
                      weak: !1,
                      maxage: null,
                      initialage: 1e3
                    }, t)).auth && (o.auth = t.auth), o.watchers[a.objectId(r)] = {
                      context: r,
                      callback: i,
                      weak: t.weak,
                      maxage: t.maxage,
                      age: t.initialage
                    }, t.weak || this.__cacheUpdate(e, t.initialage + c.now());
                  },
                  unwatch: function unwatch(e, t) {
                    delete this.__cacheGet(e).watchers[a.objectId(t)];
                  },
                  createByUpload: function createByUpload(r) {
                    return this.create(x.extend(x.clone(r.data, 1), {
                      create_stream: !0
                    }), r.auth).mapSuccess(function (e) {
                      var t = o.create(),
                        i = this.application.image_streams.dataUploader(e.image.token, e.stream.token, {
                          auth: r.auth,
                          image_data: r.image_data
                        });
                      return r.progress && i.on("progress", r.progress, r.context), i.on("error", function (e) {
                        t.asyncError(e);
                      }, this), i.on("success", function () {
                        this.application.image_streams.submit(e.image.token, e.stream.token, null, r.auth, 50).forwardCallback(t);
                      }, this), i.upload(), t;
                    }, this);
                  }
                };
              }]);
            }), Scoped.define("private:Application.ImageStreamsApiMixin", function () {
              return {
                index: function index(e, t, i, r) {
                  return this.application.connect.apiRequest("/images/" + e + "/streams/", {
                    method: "GET",
                    auth: i,
                    resilience: r,
                    data: t
                  });
                },
                destroy: function destroy(e, t, i, r) {
                  return this.application.connect.apiRequest("/images/" + e + "/streams/" + t, {
                    method: "DELETE",
                    auth: i,
                    resilience: r
                  });
                },
                create: function create(e, t, i, r) {
                  return this.application.connect.apiRequest("/images/" + e + "/streams", {
                    method: "POST",
                    auth: i,
                    resilience: r,
                    data: t
                  });
                },
                confirm: function confirm(e, t, i, r, o) {
                  return this.application.connect.apiRequest("/images/" + e + "/streams/" + t + "/submit", {
                    method: "POST",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                },
                submit: function submit(e, t, i, r, o) {
                  return this.application.connect.apiRequest("/images/" + e + "/streams/" + t + "/submit", {
                    method: "POST",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                },
                get: function get(e, t, i, r) {
                  return this.application.connect.apiRequest("/images/" + e + "/streams/" + t, {
                    method: "GET",
                    auth: i,
                    resilience: r
                  });
                },
                _get_image_upload_urls: function _get_image_upload_urls(e, t, i, r, o) {
                  return this.application.connect.apiRequest("/images/" + e + "/streams/" + t + "/image-upload-urls", {
                    method: "GET",
                    auth: r,
                    resilience: o,
                    data: i
                  });
                }
              };
            }), Scoped.define("private:Application.ImageStreams", ["base:Class", "base:Objs", "private:Application.ImageStreamsApiMixin"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, [i, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.application = e;
                  },
                  imageUrl: function imageUrl(e, t, i) {
                    var r = "images/" + e + "/streams/" + t + "/" + ((i = i || {}).download ? "download_image.mp4" : "image.mp4");
                    return this.application.urls.apiStreamingResourceUrl(r, {
                      auth: i.auth,
                      params: i.params
                    });
                  },
                  webrtcStreamName: function webrtcStreamName(e, t, i) {
                    return "applications___" + this.application.data.get("token") + "___images___" + e + "___streams___" + t + "___image";
                  },
                  dataUploader: function dataUploader(e, t, i) {
                    return this.imageAttachUploader(e, t, i.auth, i.image_data);
                  }
                };
              }]);
            }), Scoped.define("private:Application.AnalyticsApiMixin", function () {
              return {
                _push: function _push(e, t, i) {
                  return this.application.connect.apiRequest("/scitylana/kcart", {
                    method: "POST",
                    auth: t,
                    resilience: i,
                    data: e
                  });
                }
              };
            }), Scoped.define("private:Application.Analytics", ["base:Class", "base:Events.EventsMixin", "base:Objs", "base:Time", "base:Timers.Timer", "browser:Info", "private:Application.AnalyticsApiMixin", "private:Core", "private:Environment", "private:Logger"], function (e, t, n, s, i, r, o, x, a, c, d) {
              var l = s.now();
              return e.extend({
                scoped: d
              }, [t, o, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.application = e, this.__google_analytics_events = {}, e.data.get("google_analytics") && (this.__google_analytics_events = n.objectify(e.data.get("google_analytics_track"))), this.__queue = [], this.__trackFailed = 0, this.__trackSuccess = 0, this.application.data.get("analytics") && (this.__timer = this.auto_destroy(new i({
                      context: this,
                      fire: this.__pushEvents,
                      delay: 5e3
                    })));
                  },
                  _generateEvent: function _generateEvent(e, t, i, r, o, a) {
                    return a = a || s.now(), i = i || {}, r = r || {}, o = o || {}, {
                      tokens: n.extend({
                        application_token: this.application.data.get("token")
                      }, i),
                      client: {
                        type: "web",
                        version: "v" + x.revision.version + "-" + x.revision.revision,
                        revision: x.revision.revision,
                        sdk_version: e
                      },
                      environment: {
                        location: document.location.href,
                        time: a - l
                      },
                      device: {
                        navigator_appname: navigator.appName,
                        navigator_appcodename: navigator.appCodeName,
                        navigator_appversion: navigator.appVersion,
                        navigator_cookieenabled: navigator.cookieEnabled,
                        navigator_language: navigator.language || navigator.userLanguage || "",
                        navigator_platform: navigator.platform,
                        navigator_useragent: navigator.userAgent,
                        navigator_window_chrome: "chrome" in window,
                        navigator_window_opera: "opera" in window
                      },
                      event: {
                        time: a,
                        type: t,
                        media_time: r.media_time || null,
                        embed_type: r.embed_type || null,
                        data_size: r.data_size || null,
                        bandwidth: r.bandwidth || null
                      },
                      media: {
                        duration: o.duration || null,
                        width: o.width || null,
                        height: o.height || null,
                        tags: o.tags ? o.tags.join(",") : null,
                        creation_type: o.creation_type || null,
                        hd: o.width && o.height && 921600 <= o.width * o.height
                      }
                    };
                  },
                  track: function track(e, t, i, r, o, a) {
                    try {
                      var n = this._generateEvent(e, t, i, r, o, a);
                      this.application.data.get("analytics") && this.__queue.push(n), this.__google_analytics_events[t] && ga("send", "event", "Ziggeo", t, "Ziggeo Campaign", r.media_time || o.duration || r.data_size || undefined), this.trigger("track", n);
                    } catch (s) {}
                  },
                  userTrack: function userTrack(e) {
                    this.track("2", e);
                  },
                  __pushEvents: function __pushEvents() {
                    var e;
                    this.application.data.get("analytics") && 0 !== this.__queue.length && (10 < this.__trackFailed && this.__trackSuccess / this.__trackFailed < .5 || (e = this.__queue, this.__queue = [], this._push({
                      events: JSON.stringify(e)
                    }).error(function () {
                      this.__trackFailed++, this.__queue = e.concat(this.__queue);
                    }, this).success(function () {
                      this.__trackSuccess++;
                    }, this)));
                  }
                };
              }]);
            }), Scoped.define("module:Application", ["base:Class", "base:Objs", "base:Events.EventsMixin", "base:Events.Events", "base:Async", "base:Promise", "browser:Dom", "module:Locale", "private:Application.Data", "private:Application.Urls", "private:Application.Connect", "private:Application.Videos", "private:Application.Streams", "private:Application.Audios", "private:Application.AudioStreams", "private:Application.Images", "private:Application.ImageStreams", "private:Application.Analytics", "private:Application.Debugger", "module:Supplementary"], function (e, i, t, r, o, a, n, s, x, c, d, l, u, h, p, b, m, g, v, f, y) {
              s.mainLocale.register({
                error_503: "We are maintaining our service. We will be back shortly.",
                error_404: "We cannot recognize your api key. Please make sure to specify it in your website's header.",
                error_401: "You are not allowed to access the application from this site.",
                error_412: "You need to confirm / upgrade your account.",
                error_unknown: "An unknown error occurred. Our team has been notified and will resolve the issue."
              }, "application");
              var _ = e.extend({
                scoped: y
              }, [t, function (t) {
                return {
                  constructor: function constructor(e) {
                    t.constructor.call(this), this.__authCache = {}, this.data = this.auto_destroy(new x(this, e)), this.data.get("debug") && (this.debug = this.auto_destroy(new v(this))), this.urls = this.auto_destroy(new c(this)), this.connect = this.auto_destroy(new d(this)), this.videos = this.auto_destroy(new l(this)), this.streams = this.auto_destroy(new u(this)), this.audios = this.auto_destroy(new h(this)), this.audio_streams = this.auto_destroy(new p(this)), this.images = this.auto_destroy(new b(this)), this.image_streams = this.auto_destroy(new m(this)), this.analytics = this.auto_destroy(new g(this)), this.embed_events = this.auto_destroy(new r()), this.embed_events._invokeCallback = f.eventInvokeCallback, this._invokeCallback = f.eventInvokeCallback, this.cls.register(this), this.__init();
                  },
                  destroy: function destroy() {
                    this.cls.unregister(this), t.destroy.call(this);
                  },
                  __init: function __init() {
                    this.connect.request("session", {
                      method: "POST",
                      params: {
                        noauth: !this.data.get("auth")
                      },
                      resilience: 5
                    }).success(function (e) {
                      this.data.set("cookie_changed", e.token !== this.data.get("cookie_value")), this.data.set("cookie_value", e.token), this.data.set("testing_application", e.testing_application), this.data.set("ready", !0), this.analytics.track("2", "init_application", {}), n.ready(function () {
                        o.eventually(function () {
                          this.persistentTrigger("ready");
                        }, this);
                      }, this);
                    }, this).error(function (e) {
                      this.data.set("error", e.status_code());
                      var t = s.mainLocale.get("error_" + e.status_code(), "application");
                      this.data.set("error_message", t || s.mainLocale.get("error_unknown", "application")), this.persistentTrigger("error", e.status_code(), this.data.get("error_message"));
                    }, this);
                  },
                  authMediaReady: function authMediaReady(e, t, i) {
                    if (t && e) {
                      var r = e.client_auth || e.server_auth;
                      if (r && !this.__authCache[r]) return this[i].get(t, {
                        auth: e
                      }).callback(function () {
                        this.__authCache[r] = !0;
                      }, this);
                    }
                    return a.value(!0);
                  },
                  authVideoReady: function authVideoReady(e, t) {
                    return this.authMediaReady(e, t, "videos");
                  },
                  authAudioReady: function authAudioReady(e, t) {
                    return this.authMediaReady(e, t, "audios");
                  }
                };
              }], {
                __default: null,
                __instances: {},
                __deferred: 0,
                events: new r(),
                setDefault: function setDefault(e) {
                  this.__default = e, this.events.trigger("set-default", e);
                },
                getDefault: function getDefault() {
                  return this.__default;
                },
                getByToken: function getByToken(e) {
                  return this.__instances[e];
                },
                instanceByToken: function instanceByToken(e, t) {
                  return this.getByToken(e) || new this(i.extend({
                    token: e
                  }, t));
                },
                register: function register(e) {
                  var t = e.data.get("token");
                  if (t in this.__instances) throw "Application Instance already existing for this application token.";
                  this.__instances[t] = e, this.__default || this.setDefault(e);
                },
                unregister: function unregister(e) {
                  var t = e.data.get("token");
                  this.__instances[t] === e && delete this.__instances[t], this.getDefault() === e && this.setDefault(null);
                },
                isDeferred: function isDeferred() {
                  return 0 < this.__deferred;
                },
                defer: function defer() {
                  this.__deferred++;
                },
                undefer: function undefer() {
                  this.__deferred--, 0 === this.__deferred && this.events.trigger("undefer");
                },
                onUndefer: function onUndefer(e, t) {
                  this.isDeferred() ? this.events.once("undefer", e, t) : e.call(t || this);
                }
              });
              return Scoped.getGlobal("ZiggeoDefer") && _.__deferred++, _;
            }), Scoped.define("private:Dynamics", ["dynamics:DomObserver", "dynamics:Parser", "dynamics:Registries", "base:Async", "browser:Dom", "module:Application"], function (e, t, i, r, o, a) {
              t.secureMode = !0;
              var n = new e({
                allowed_dynamics: ["ziggeoplayer", "ziggeorecorder", "ziggeoaudioplayer", "ziggeoaudiorecorder", "ziggeoimageviewer", "ziggeoimagecapture", "ziggeoiframeplayer", "ziggeoiframerecorder"],
                enabled: !(i.prefixes.ziggeo = !0)
              });
              return o.ready(function () {
                r.eventually(function () {
                  a.onUndefer(function () {
                    n.enable();
                  });
                });
              }), {
                domObserver: n
              };
            }), Scoped.define("private:ZiggeoDynamicMixin", ["module:Application", "base:Types"], function (e, t) {
              return {
                _obtainApplication: function _obtainApplication() {
                  this.get("application") && (this.application = t.is_string(this.get("application")) ? e.instanceByToken(this.get("application")) : this.get("application")), this.application = this.application || e.getDefault();
                },
                _deferActivate: function _deferActivate() {
                  return this._obtainApplication(), !(this.application || !this.get("lazy-application") || (e.events.once("set-default", function (e) {
                    this.application = e, this.activate();
                  }, this), 0));
                }
              };
            }), Scoped.define("module:AudioPlayer", ["mediacomponents:AudioPlayer.Dynamics.Player", "private:Logger", "module:Application", "base:Types", "module:AudioPlayerStates", "base:Net.HttpHeader", "module:Locale", "module:Supplementary", "base:Objs", "base:Time", "base:Promise", "base:TimeFormat", "private:ZiggeoDynamicMixin"], function (e, i, t, r, o, a, n, s, d, x, c, l, u, h) {
              return e.extend({
                scoped: h
              }, [u, function (e) {
                return {
                  attrs: {
                    "client-auth": null,
                    "server-auth": null,
                    "intermediate-token": null,
                    audio: null,
                    stream: null,
                    application: null,
                    forcerefresh: !1,
                    pauseonplay: !1
                  },
                  types: {
                    playlist: "array",
                    pauseonplay: "bool",
                    "lazy-application": "bool"
                  },
                  create: function create() {
                    if (this._invokeCallback = s.eventInvokeCallback, this.get("source") || 0 < this.get("sources").length) return e.create.call(this);
                    this.set("ready", !1), this.__playlist = this.get("playlist"), this.set("playlist", null), e.create.call(this), this.set("auth", {
                      client_auth: this.get("client-auth"),
                      server_auth: this.get("server-auth"),
                      intermediate_token: this.get("intermediate-token")
                    }), this.set("application_status", null), this.set("audio_status", null);
                  },
                  _notifications: {
                    _activate: "_createWithApplication"
                  },
                  _createWithApplication: function _createWithApplication() {
                    var e, t;
                    this._obtainApplication(), this.application ? this.application.data.get("auth") || !this.get("client-auth") && !this.get("server-auth") ? (this.application.embed_events.delegateEvents(null, this, null, [this]), this.__playlist && (this.set("playlist", this.__playlist.map(function (e) {
                      return this.__sourceByAudio(e);
                    }, this)), e = this.get("playlist")[0], this.set("source", e.source), this.set("audio", e.token), this.on("playlist-next", function (e) {
                      this.set("audio", e.token);
                    }, this)), t = this.parent() && this.parent().record !== undefined && this.parent().host !== undefined, this.listenOn(this.application, "ready", function () {
                      this.application.authAudioReady(this.get("auth"), this.get("audio")).callback(function () {
                        this.set("application_status", !0), this.get("playlist") ? (this.__setAudioSources(), this.set("ready", !0)) : t ? this.application.audios.get(this.get("audio"), {
                          auth: this.get("auth")
                        }).callback(function (e, t) {
                          t && 4 === t.state ? (this.get("source") || this.__setAudioSources(), this.state().next("AudioProcessing")) : this.get("source") || this.__setAudioSources(), this.set("ready", !0);
                        }, this) : (this.get("source") || this.__setAudioSources(), this.set("ready", !0)), this._track("embedding_loaded");
                      }, this);
                    }, this).listenOn(this.application, "error", function (e, t) {
                      this.set("application_status", !1), this.state().next("FatalError", {
                        message: t
                      });
                    }, this), this.get("pauseonplay") && this.application.embed_events.on("playing", function (e) {
                      e !== this && this.get("playing") && this.execute("pause");
                    }, this), this.set("tracktags", this.application.data.get("track_tags"))) : i.warn("You are specifying auth tokens on your embedding yet your application is initialized with auth = false.") : i.warn("No application (token) defined. We need an application (token) to include an embedding.");
                  },
                  destroy: function destroy() {
                    this.application.embed_events.off(null, null, this), e.destroy.call(this);
                  },
                  events: {
                    "change:audio": function changeAudio() {
                      var e;
                      this.host && (this.set("stream", null), e = 0 <= this.host.state().state_name().indexOf("Error"), this.__setAudioSources(), e && this.host.next("Initial"));
                    },
                    paused: function paused() {
                      this._track("audio_play_pause", {
                        media_time: this.get("position")
                      });
                    },
                    playing: function playing() {
                      this._track("audio_play_playing", {
                        media_time: this.get("position")
                      });
                    },
                    ended: function ended() {
                      this._track("audio_play_end", {
                        media_time: this.get("duration")
                      });
                    },
                    seek: function seek(e) {
                      this._track("audio_play_seek", {
                        media_time: e
                      });
                    }
                  },
                  __setAudioSources: function __setAudioSources() {
                    this.get("audio") && this.get("application_status") && (this.get("stream") || this.set("refresh_token", this.application.audios.refreshToken(this.get("audio"))), this.__setSources(), this.application.audios.cache(this.get("audio"), {
                      auth: this.get("auth")
                    }).callback(this.__audioUpdate, this), this.get("ready") && this.reattachAudio());
                  },
                  __sourceByAudio: function __sourceByAudio(t, e) {
                    var i = this.get("audio_data");
                    i && i.duration && this.set("duration", i.duration);
                    var r = d.filter(i && i.streams ? i.streams : [], function (e) {
                      return (e.token === i.original_stream.token || e.parent_stream === i.original_stream.token) && 5 === e.state && 3 === e.streamable;
                    }, this);
                    if (this.get("playlist") && (r = [], e = null), e || r.length < 2) {
                      var o = e ? this.application.audio_streams : this.application.audios,
                        a = [t];
                      return e && a.push(e), a.push({
                        auth: this.get("auth"),
                        params: {
                          force_refresh: this.get("forcerefresh")
                        }
                      }), {
                        source: o.audioUrl.apply(o, a),
                        token: t
                      };
                    }
                    var n = [],
                      s = [],
                      x = {
                        force_refresh: this.get("forcerefresh"),
                        auth: this.get("auth")
                      };
                    d.iter(r, function (e) {
                      n.push({
                        src: this.application.audio_streams.audioUrl(t, e.token, x),
                        token: e.token
                      }), s.push({
                        filter: {
                          token: e.token
                        }
                      });
                    }, this);
                    var c = s[0];
                    return {
                      source: null,
                      sources: n,
                      streams: s,
                      currentstream: c,
                      token: t
                    };
                  },
                  __setSources: function __setSources() {
                    this.setAll(this.__sourceByAudio(this.get("audio"), this.get("stream")));
                  },
                  __audioUpdate: function __audioUpdate(e, t) {
                    if (!this.destroyed()) if (e) this.set("audio_status", !1), e.status_code() === a.HTTP_STATUS_NOT_FOUND ? this.state().next("FatalError", {
                      message: this.string("audio-not-found")
                    }) : e.status_code() === a.HTTP_STATUS_FORBIDDEN ? this.state().next("FatalError", {
                      message: this.string("audio-access-forbidden")
                    }) : this.state().next("LoadError");else {
                      if (this.set("audio_data", t), this.get("title") || this.set("title", t.title), this.set("totalduration", t.duration), !1 === t.approved && !this.get("intermediate-token")) return void this.state().next("FatalError", {
                        message: t.moderation_reason || this.string("audio-rejected")
                      });
                      if (t.state < 4) return void this.state().next("FatalError", {
                        message: this.string("audio-unknown-error")
                      });
                      if (this.set("audio_status", !0), 4 === t.state) return void ("AudioProcessing" !== this.state().state_name() && this.state().next("AudioProcessing"));
                      if ("AudioProcessing" === this.state().state_name()) return this.set("refresh_token", this.application.audios.refreshToken(this.get("audio"))), this.set("forcerefresh", x.now()), this.__setSources(), void this.state().next("LoadPlayer");
                      if (!this.get("stream") && !this.get("refresh_token") && this.application.audios.refreshToken(this.get("audio"))) return this.set("refresh_token", this.application.audios.refreshToken(this.get("audio"))), this.__setSources(), void this.state().next("LoadPlayer");
                      this.__setSources();
                    }
                  },
                  _track: function _track(e, t, i) {
                    var r, o;
                    this.application && (r = x.now(), (o = c.create()).success(function () {
                      this.application.analytics.track("2", e, {
                        audio_token: this.get("audio_data").token,
                        stream_token: this.get("stream") ? this.get("stream") : undefined
                      }, d.extend({
                        embed_type: "player"
                      }, t), d.extend({
                        duration: this.get("audio_data").duration || this.get("duration"),
                        tags: this.get("audio_data").tags
                      }, i), r);
                    }, this), this.get("audio_data") ? o.asyncSuccess() : this.once("change:audio_data", function () {
                      o.asyncSuccess();
                    }, this));
                  }
                };
              }], function (e) {
                return {
                  playerStates: function playerStates() {
                    return e.playerStates.call(this).concat([o]);
                  }
                };
              }).register("ba-ziggeoaudioplayer").register("ziggeoaudioplayer").attachStringTable(n.mainLocale).addStrings({
                "audio-not-found": "We could not find the specified audio file.",
                "audio-access-forbidden": "You are not permitted to access this audio file.",
                "audio-unknown-error": "We cannot access this audio at the moment. Please try again later.",
                "audio-rejected": "The audio has been rejected.",
                "audio-processing": "The audio is processing - stay tuned.",
                "audio-access-error": "The audio is currently under moderation. You may click to retry."
              });
            }), Scoped.define("module:PopupAudioPlayer", ["module:AudioPlayer", "mediacomponents:PopupHelper"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, t.mixin);
            }), Scoped.define("module:AudioRecorder", ["mediacomponents:AudioRecorder.Dynamics.Recorder", "module:Application", "module:Device", "private:Logger", "private:Environment", "module:AudioRecorderStates", "base:Types", "base:MediaTypes", "base:Time", "base:Strings", "module:Locale", "module:Supplementary", "base:Objs", "base:Promise", "base:Async", "browser:Events", "browser:Info", "private:ZiggeoDynamicMixin"], function (AudioRecorder, Application, Device, Logger, Environment, AudioRecorderStates, Types, MediaTypes, Time, Strings, Locale, Supplementary, Objs, Promise, Async, DomEvents, Info, ZiggeoDynamicMixin, scoped) {
              return AudioRecorder.extend({
                scoped: scoped
              }, [ZiggeoDynamicMixin, function (t) {
                return {
                  template: t.template.replace('"overlay">', '"overlay"><a class="ziggeo-v2-testing" ba-if="{{testing}}" href="https://ziggeo.com/pricing" target="_blank"></a>'),
                  attrs: {
                    dynaudioplayer: "ziggeoaudioplayer",
                    "audio-profile": null,
                    "meta-profile": null,
                    "client-auth": null,
                    "server-auth": null,
                    "intermediate-token": null,
                    application: null,
                    audio: null,
                    description: null,
                    title: null,
                    tags: null,
                    "custom-data": null,
                    key: null,
                    "expiration-days": null,
                    "force-overwrite": null,
                    "recover-streams": null,
                    "input-bind": null,
                    "form-accept": null,
                    playermodeifexists: !1,
                    rerecordableifexists: !1
                  },
                  types: {
                    tags: "array",
                    "custom-data": "object",
                    "expiration-days": "int",
                    "delete-old-streams": "bool",
                    "force-overwrite": "bool",
                    "recover-streams": "bool",
                    "lazy-application": "bool",
                    playermodeifexists: "bool",
                    rerecordableifexists: "bool"
                  },
                  events: {
                    rerecord: function rerecord() {
                      this.__inputBindElement && (this.__inputBindElement.value = ""), this.get("form-accept") && this._formAcceptEvents.on(document.querySelector(this.get("form-accept")), "submit", function (e) {
                        e.preventDefault();
                      });
                    },
                    processed: function processed() {
                      this.__had_processed = !0;
                    }
                  },
                  create: function create() {
                    this._invokeCallback = Supplementary.eventInvokeCallback, this.set("ready", !1), t.create.call(this), this.get("audio") && !this.get("key") && Strings.starts_with(this.get("audio"), "_") && this.set("key", Strings.strip_start(this.get("audio"), "_")), this.get("simulate") && this.set("localplayback", !0), this.set("auth", {
                      client_auth: this.get("client-auth"),
                      server_auth: this.get("server-auth"),
                      intermediate_token: this.get("intermediate-token")
                    }), this.set("application_status", null), this.__hadInitialaudio = !!this.get("audio"), this.get("audio") || (this.set("playermodeifexists", !1), this.set("rerecordableifexists", !1), this.get("form-accept") && (this._formAcceptEvents = this.auto_destroy(new DomEvents()), this._formAcceptEvents.on(document.querySelector(this.get("form-accept")), "submit", function (e) {
                      e.preventDefault();
                    }))), this.on("rerecord", function () {
                      this._track("rerecord_confirm");
                    }, this), this.__had_processed = !1, this.scopes.player.on("change:audio_data", function (e) {
                      this.set("audio_data", e);
                      var t = e.streams.find(function (e) {
                        return e.token === this.get("stream");
                      }, this);
                      t && this.set("stream_data", t);
                    }, this);
                  },
                  _notifications: {
                    _activate: "_createWithApplication"
                  },
                  _deferActivate: function _deferActivate() {
                    if (this._obtainApplication(), (this.application || !this.get("lazy-application")) && !this.get("playermodeifexists") && !this.get("rerecordableifexists")) return !1;
                    var t = Promise.create();
                    return this.application ? t.asyncSuccess(!0) : Application.events.once("set-default", function (e) {
                      this.application = e, t.asyncSuccess(!0);
                    }, this), (this.get("playermodeifexists") || this.get("rerecordableifexists")) && (t = t.mapSuccess(function (t) {
                      return this.application.audios.get(this.get("audio") || (this.get("key") ? "_" + this.get("key") : null), {
                        auth: this.get("auth")
                      }).success(function (e) {
                        return e && "EMPTY" !== e.state_string && (this.get("playermodeifexists") && this.set("recordermode", !1), this.get("rerecordableifexists") || this.set("rerecordable", !1)), !this.get("audio") && this.get("key") && this.set("audio", "_" + this.get("key")), this.set("playermodeifexists", !1), this.set("rerecordableifexists", !1), t;
                      }, this);
                    }, this).mapError(function (e) {
                      return this.get("audio") && 404 === e.status_code() && this.set("audio", null), this.set("playermodeifexists", !1), this.set("rerecordableifexists", !1), Promise.value(!0);
                    }, this)), t.success(this.activate, this), !0;
                  },
                  _createWithApplication: function _createWithApplication() {
                    this._obtainApplication(), this.application ? this.application.data.get("auth") || !this.get("client-auth") && !this.get("server-auth") ? (this.application.embed_events.delegateEvents(null, this, null, [this]), this.application.on("ready", function () {
                      this.set("application_status", !0), this.set("ready", !0), this.set("testing", this.application.data.get("testing_application"));
                    }, this).on("error", function (e, t) {
                      this.set("application_status", !1), this.state().next("FatalError", {
                        message: t
                      });
                    }, this), this.set("playerattrs", {
                      application: this.application,
                      "client-auth": this.get("client-auth"),
                      "server-auth": this.get("server-auth"),
                      "intermediate-token": this.get("intermediate-token"),
                      audio: this.get("audio"),
                      "force-refresh": Time.now()
                    }), this._track("audio_embedding_loaded"), this.set("webrtcstreaming", this.application.data.get("webrtc_streaming")), this.set("webrtcstreamingifnecessary", this.application.data.get("webrtc_streaming_if_necessary")), this.set("webrtconmobile", this.application.data.get("webrtc_on_mobile")), Info.isSafari() && Info.isDesktop() && !this.get("webrtcstreaming") && !this.get("webrtcstreamingifnecessary") && this.set("webrtcstreamingifnecessary", !0), !this.get("webrtcstreaming") && !this.get("webrtcstreamingifnecessary") || this.get("timeminlimit") || this.set("timeminlimit", 5), this._updateUrls()) : Logger.warn("You are specifying auth tokens on your embedding yet your application is initialized with auth = false.") : Logger.warn("No application (token) defined. We need an application (token) to include an embedding.");
                  },
                  _track: function _track(e, t, i) {
                    this.application.analytics.track("2", e, {
                      audio_token: this.get("audio"),
                      stream_token: this.get("stream")
                    }, Objs.extend({
                      embed_type: this.__hadInitialaudio ? "rerecorder" : "recorder"
                    }, t), Objs.extend({
                      creation_type: this.get("creation-type"),
                      duration: this.get("duration"),
                      tags: this.get("tags")
                    }, i));
                  },
                  functions: {
                    reset: function reset() {
                      this.get("audio") && !this.__hadInitialaudio && this.set("audio", null), this.__had_processed = !1, t.functions.reset.call(this);
                    },
                    ready_to_play: function ready_to_play() {
                      this.__had_processed || (this.trigger("processing", 1), this.trigger("processed")), t.functions.ready_to_play.call(this);
                    }
                  },
                  _updateUrls: function _updateUrls(e) {
                    this.set("playerattrs.audio", this.get("audio")), this.set("uploadoptions", {
                      webrtcStreaming: {
                        wssUrl: this.get("webrtcstreaming") || this.get("webrtcstreamingifnecessary") ? this.application.urls.wssUrl() : undefined,
                        streamInfo: this.get("webrtcstreaming") || this.get("webrtcstreamingifnecessary") ? {
                          applicationName: this.application.urls.webrtcStreamingApp(Info.isFirefox() ? "udp" : ""),
                          streamName: this.application.streams.webrtcStreamName(this.get("audio"), this.get("stream"), this.get("auth"))
                        } : undefined,
                        delay: 4750,
                        stopDelay: 2750
                      },
                      audio: e ? Objs.extend({
                        resilienceCheck: function resilienceCheck(e) {
                          return !e || !e.duration;
                        }
                      }, this.application.data.getSignedUploaderConfig(e.url, e.fields)) : undefined
                    });
                  },
                  __createParams: function __createParams() {
                    var e = {};
                    try {
                      var t = this.activeElement().cloneNode();
                      t.innerHTML = "", e = t.outerHTML;
                    } catch (i) {}
                    return {
                      description: this.get("description"),
                      title: this.get("title"),
                      tags: this.get("tags") ? this.get("tags").join(",") : undefined,
                      data: this.get("custom-data") ? JSON.stringify(this.get("custom-data")) : undefined,
                      key: this.get("key"),
                      expiration_days: this.get("expiration-days"),
                      delete_old_streams: this.get("delete-old-streams"),
                      force_overwrite: this.get("force-overwrite"),
                      audio_profile: this.get("audio-profile"),
                      meta_profile: this.get("meta-profile"),
                      enforce_duration: this.get("enforce-duration"),
                      recover_streams: this.get("recover-streams"),
                      max_duration: this.get("timelimit"),
                      user_language: navigator.language || navigator.userLanguage,
                      audio_file_name: this._audioFileName,
                      device_info: Objs.extend({
                        api_version: 2,
                        embed_code: e,
                        media_source: this.__getMediaSource(),
                        capture_type: this.__getCaptureType()
                      }, Device.info)
                    };
                  },
                  __recordingTypeParams: function __recordingTypeParams() {
                    var e = {
                      create_stream: !0
                    };
                    if (this.recorder) {
                      try {
                        var t = this.recorder._recorder._recorder._mediaRecorder.mimeType;
                        t && Objs.extend(e, {
                          audio_type: MediaTypes.getExtension(t)
                        });
                      } catch (i) {}
                      return Objs.extend(e, {
                        webrtc_recording: !0,
                        webrtc_streaming: this.isWebrtcStreaming()
                      });
                    }
                    return this._audioFile && Objs.extend(e, {
                      audio_type: Strings.last_after(this._audioFile.name, ".")
                    }), e;
                  },
                  __getMediaSource: function __getMediaSource() {
                    return this.__recordingTypeParams().webrtc_recording ? "record" : "upload";
                  },
                  __getCaptureType: function __getCaptureType() {
                    var e = this.__recordingTypeParams();
                    return e.webrtc_streaming ? "webrtc_streaming" : e.webrtc_recording ? "webrtc" : "file_capture";
                  },
                  _prepareRecording: function _prepareRecording() {
                    return this.get("audio") ? this.application.audio_streams.create(this.get("audio"), this.__recordingTypeParams(), this.get("auth"), 5).mapSuccess(function (e) {
                      this.set("stream", e.audio_stream.token), this.set("stream_data", e.audio_stream), this._updateUrls(e.url_data);
                    }, this) : this.application.audios.create(Objs.extend(this.__createParams(), this.__recordingTypeParams()), this.get("auth"), 5).mapSuccess(function (e) {
                      this.set("audio", e.audio.token), this.set("audio_data", e.audio), this.set("stream", e.audio_stream.token), this.set("stream_data", e.audio_stream), this._updateUrls(e.url_data);
                    }, this);
                  },
                  _verifyRecording: function _verifyRecording() {
                    var e = Promise.create();
                    return Async.eventually(function () {
                      this.get("audio") && (this.get("simulate") ? Promise.value(!0) : this.application.audio_streams.confirm(this.get("audio"), this.get("stream"), {
                        duration: this.get("duration")
                      }, this.get("auth"), 50)).success(function () {
                        this.__inputBindElement && (this.__inputBindElement.value = this.get("audio")), this.get("form-accept") && this._formAcceptEvents.off(document.querySelector(this.get("form-accept")), "submit"), this.application.audios.cacheInvalidate(this.get("audio"));
                      }, this).forwardCallback(e);
                    }, this, 2500), e;
                  },
                  _afterActivate: function _afterActivate(e) {
                    t._afterActivate.apply(this, arguments), this.get("input-bind") && (this.__inputBindElement = document.getElementsByName(this.get("input-bind"))[0], this.__inputBindElement || (this.__inputBindElement = document.createElement("input"), this.__inputBindElement.type = "hidden", this.__inputBindElement.id = this.get("input-bind"), this.__inputBindElement.name = this.get("input-bind"), e.parentElement.appendChild(this.__inputBindElement)), this.get("audio") && (this.__inputBindElement.value = this.get("audio")));
                  }
                };
              }], function (e) {
                return {
                  recorderStates: function recorderStates() {
                    return e.recorderStates.call(this).concat([AudioRecorderStates]);
                  }
                };
              }).register("ba-ziggeoaudiorecorder").register("ziggeoaudiorecorder").registerFunctions({
                testing: function (_testing) {
                  function testing(_x1291) {
                    return _testing.apply(this, arguments);
                  }
                  testing.toString = function () {
                    return _testing.toString();
                  };
                  return testing;
                }(function (obj) {
                  with (obj) return testing;
                })
              }).attachStringTable(Locale.mainLocale).addStrings({});
            }), Scoped.define("module:PopupAudioRecorder", ["module:AudioRecorder", "mediacomponents:PopupHelper"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, t.mixin);
            }), Scoped.define("module:IframePlayer", ["mediacomponents:IframeHelper", "private:Core", "private:ZiggeoDynamicMixin"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, [i, {
                getAllowModifiers: function getAllowModifiers() {
                  return t.video.iframe["allow-player-mods"];
                },
                getSrc: function getSrc() {
                  return this.application.videos.iframeVideoUrl(this.get("video"));
                }
              }]).register("ba-ziggeoiframeplayer").register("ziggeoiframeplayer");
            }), Scoped.define("module:IframeRecorder", ["mediacomponents:IframeHelper", "private:Core", "private:ZiggeoDynamicMixin"], function (e, t, i, r) {
              return e.extend({
                scoped: r
              }, [i, {
                getAllowModifiers: function getAllowModifiers() {
                  return t.video.iframe["allow-recorder-mods"];
                },
                getSrc: function getSrc() {
                  return this.application.videos.iframeRecorderUrl();
                }
              }]).register("ba-ziggeoiframerecorder").register("ziggeoiframerecorder");
            }), Scoped.define("module:ImageCapture", ["mediacomponents:ImageCapture.Dynamics.Recorder", "module:Application", "module:Device", "private:Logger", "private:Environment", "module:ImageRecorderStates", "base:Types", "base:Time", "base:Strings", "module:Locale", "module:Supplementary", "base:Objs", "base:Promise", "base:Async", "browser:Events", "browser:Info", "private:ZiggeoDynamicMixin"], function (ImageCapture, Application, Device, Logger, Environment, ImageRecorderStates, Types, Time, Strings, Locale, Supplementary, Objs, Promise, Async, DomEvents, Info, ZiggeoDynamicMixin, scoped) {
              return ImageCapture.extend({
                scoped: scoped
              }, [ZiggeoDynamicMixin, function (t) {
                return {
                  template: t.template.replace('"overlay">', '"overlay"><a class="ziggeo-v2-testing" ba-if="{{testing}}" href="https://ziggeo.com/pricing" target="_blank"></a>'),
                  attrs: {
                    dynimageviewer: "ziggeoimageviewer",
                    "effect-profile": null,
                    "preview-effect-profile": null,
                    "image-profile": null,
                    "meta-profile": null,
                    "client-auth": null,
                    "server-auth": null,
                    "intermediate-token": null,
                    application: null,
                    image: null,
                    description: null,
                    title: null,
                    tags: null,
                    "custom-data": null,
                    key: null,
                    "auto-crop": null,
                    "auto-pad": null,
                    "expiration-days": null,
                    "force-overwrite": null,
                    "recover-streams": null,
                    "input-bind": null,
                    "form-accept": null,
                    playermodeifexists: !1,
                    rerecordableifexists: !1
                  },
                  types: {
                    tags: "array",
                    "custom-data": "object",
                    "auto-crop": "bool",
                    "auto-pad": "bool",
                    "expiration-days": "int",
                    "delete-old-streams": "bool",
                    "force-overwrite": "bool",
                    "recover-streams": "bool",
                    "effect-profile": "array",
                    "lazy-application": "bool",
                    playermodeifexists: "bool",
                    rerecordableifexists: "bool"
                  },
                  events: {
                    rerecord: function rerecord() {
                      this.__inputBindElement && (this.__inputBindElement.value = ""), this.get("form-accept") && this._formAcceptEvents.on(document.querySelector(this.get("form-accept")), "submit", function (e) {
                        e.preventDefault();
                      });
                    },
                    processed: function processed() {
                      this.__had_processed = !0;
                    }
                  },
                  create: function create() {
                    this._invokeCallback = Supplementary.eventInvokeCallback, this.set("ready", !1), t.create.call(this), this.get("image") && !this.get("key") && Strings.starts_with(this.get("image"), "_") && this.set("key", Strings.strip_start(this.get("image"), "_")), this.get("simulate") && this.set("localplayback", !0), Types.is_string(this.get("effect-profile")) && this.set("effect-profile", Types.parseArray(this.get("effect-profile"))), this.set("auth", {
                      client_auth: this.get("client-auth"),
                      server_auth: this.get("server-auth"),
                      intermediate_token: this.get("intermediate-token")
                    }), this.set("application_status", null), this.__hadInitialimage = !!this.get("image"), this.get("image") || (this.set("playermodeifexists", !1), this.set("rerecordableifexists", !1), this.get("form-accept") && (this._formAcceptEvents = this.auto_destroy(new DomEvents()), this._formAcceptEvents.on(document.querySelector(this.get("form-accept")), "submit", function (e) {
                      e.preventDefault();
                    }))), this.on("rerecord", function () {
                      this._track("rerecord_confirm");
                    }, this), this.__had_processed = !1, this.scopes.player.on("change:image_data", function (e) {
                      this.set("image_data", e);
                      var t = e.streams.find(function (e) {
                        return e.token === this.get("stream");
                      }, this);
                      t && this.set("stream_data", t);
                    }, this);
                  },
                  _notifications: {
                    _activate: "_createWithApplication"
                  },
                  _deferActivate: function _deferActivate() {
                    if (this._obtainApplication(), (this.application || !this.get("lazy-application")) && !this.get("playermodeifexists") && !this.get("rerecordableifexists")) return !1;
                    var t = Promise.create();
                    return this.application ? t.asyncSuccess(!0) : Application.events.once("set-default", function (e) {
                      this.application = e, t.asyncSuccess(!0);
                    }, this), (this.get("playermodeifexists") || this.get("rerecordableifexists")) && (t = t.mapSuccess(function (t) {
                      return this.application.images.get(this.get("image") || (this.get("key") ? "_" + this.get("key") : null), {
                        auth: this.get("auth")
                      }).success(function (e) {
                        return e && "EMPTY" !== e.state_string && (this.get("playermodeifexists") && this.set("recordermode", !1), this.get("rerecordableifexists") || this.set("rerecordable", !1)), !this.get("image") && this.get("key") && this.set("image", "_" + this.get("key")), this.set("playermodeifexists", !1), this.set("rerecordableifexists", !1), t;
                      }, this);
                    }, this).mapError(function (e) {
                      return this.get("image") && 404 === e.status_code() && this.set("image", null), this.set("playermodeifexists", !1), this.set("rerecordableifexists", !1), Promise.value(!0);
                    })), t.success(this.activate, this), !0;
                  },
                  _createWithApplication: function _createWithApplication() {
                    this._obtainApplication(), this.application ? this.application.data.get("auth") || !this.get("client-auth") && !this.get("server-auth") ? (this.application.embed_events.delegateEvents(null, this, null, [this]), this.application.on("ready", function () {
                      this.set("application_status", !0), this.set("ready", !0), this.set("testing", this.application.data.get("testing_application"));
                    }, this).on("error", function (e, t) {
                      this.set("application_status", !1), this.state().next("FatalError", {
                        message: t
                      });
                    }, this), this.set("playerattrs", {
                      application: this.application,
                      "effect-profile": this.get("preview-effect-profile"),
                      "client-auth": this.get("client-auth"),
                      "server-auth": this.get("server-auth"),
                      "intermediate-token": this.get("intermediate-token"),
                      image: this.get("image"),
                      "force-refresh": Time.now()
                    }), this._track("image_embedding_loaded"), this._updateUrls()) : Logger.warn("You are specifying auth tokens on your embedding yet your application is initialized with auth = false.") : Logger.warn("No application (token) defined. We need an application (token) to include an embedding.");
                  },
                  _track: function _track(e, t, i) {
                    this.application.analytics.track("2", e, {
                      image_token: this.get("image"),
                      stream_token: this.get("stream")
                    }, Objs.extend({
                      embed_type: this.__hadInitialimage ? "rerecorder" : "recorder"
                    }, t), Objs.extend({
                      creation_type: this.get("creation-type"),
                      width: this.get("recordingwidth"),
                      height: this.get("recordingheight"),
                      tags: this.get("tags")
                    }, i));
                  },
                  functions: {
                    reset: function reset() {
                      this.get("image") && !this.__hadInitialimage && this.set("image", null), this.__had_processed = !1, t.functions.reset.call(this);
                    },
                    ready_to_play: function ready_to_play() {
                      this.__had_processed || (this.trigger("processing", 1), this.trigger("processed")), t.functions.ready_to_play.call(this);
                    }
                  },
                  _updateUrls: function _updateUrls() {
                    this.set("playerattrs.image", this.get("image")), this.set("uploadoptions", {
                      image: this.application.image_streams.attachUploaderConfig(this.get("image"), this.get("stream"), this.get("auth"))
                    });
                  },
                  _readDeviceOrientation: function _readDeviceOrientation() {
                    return window.orientation + 90 || undefined;
                  },
                  __createParams: function __createParams() {
                    var e = {};
                    try {
                      var t = this.activeElement().cloneNode();
                      t.innerHTML = "", e = t.outerHTML;
                    } catch (i) {}
                    return {
                      description: this.get("description"),
                      title: this.get("title"),
                      tags: this.get("tags") ? this.get("tags").join(",") : undefined,
                      data: this.get("custom-data") ? JSON.stringify(this.get("custom-data")) : undefined,
                      key: this.get("key"),
                      auto_crop: this.get("auto-crop"),
                      auto_pad: this.get("auto-pad"),
                      expiration_days: this.get("expiration-days"),
                      delete_old_streams: this.get("delete-old-streams"),
                      effect_profile: this.get("effect-profile") ? this.get("effect-profile").join(",") : undefined,
                      force_overwrite: this.get("force-overwrite"),
                      image_profile: this.get("image-profile"),
                      meta_profile: this.get("meta-profile"),
                      recover_streams: this.get("recover-streams"),
                      user_language: navigator.language || navigator.userLanguage,
                      image_file_name: this._imageFileName,
                      device_info: Objs.extend({
                        api_version: 2,
                        embed_code: e
                      }, Device.info)
                    };
                  },
                  _prepareRecording: function _prepareRecording() {
                    return this._requiresDeviceOrientation = Info.isMobile() && Info.isiOS() && window.orientation !== undefined && this.recorder, this.get("image") ? this.application.image_streams.create(this.get("image"), {}, this.get("auth")).mapSuccess(function (e) {
                      this.set("stream", e.token), this.set("stream_data", e), this._updateUrls();
                    }, this) : this.application.images.create(Objs.extend(this.__createParams(), {}), this.get("auth")).mapSuccess(function (e) {
                      this.set("image", e.image.token), this.set("image_data", e.image), this.set("stream", e.stream.token), this.set("stream_data", e.stream), this._updateUrls();
                    }, this);
                  },
                  _verifyRecording: function _verifyRecording() {
                    var e = Promise.create();
                    return Async.eventually(function () {
                      this.get("image") && (this.get("simulate") ? Promise.value(!0) : this.application.streams._recorder_submit(this.get("image"), this.get("stream"), {
                        rotation: this._requiresDeviceOrientation ? this._readDeviceOrientation() : undefined
                      }, this.get("auth"), 50)).success(function () {
                        this.__inputBindElement && (this.__inputBindElement.value = this.get("image")), this.get("form-accept") && this._formAcceptEvents.off(document.querySelector(this.get("form-accept")), "submit"), this.application.images.cacheInvalidate(this.get("image"));
                      }, this).forwardCallback(e);
                    }, this, 2500), e;
                  },
                  _afterActivate: function _afterActivate(e) {
                    t._afterActivate.apply(this, arguments), this.get("input-bind") && (this.__inputBindElement = document.getElementsByName(this.get("input-bind"))[0], this.__inputBindElement || (this.__inputBindElement = document.createElement("input"), this.__inputBindElement.type = "hidden", this.__inputBindElement.id = this.get("input-bind"), this.__inputBindElement.name = this.get("input-bind"), e.parentElement.appendChild(this.__inputBindElement)), this.get("image") && (this.__inputBindElement.value = this.get("image")));
                  }
                };
              }], function (e) {
                return {
                  recorderStates: function recorderStates() {
                    return e.recorderStates.call(this).concat([ImageRecorderStates]);
                  }
                };
              }).register("ba-ziggeoimagecapture").register("ziggeoimagecapture").registerFunctions({
                testing: function (_testing2) {
                  function testing(_x1292) {
                    return _testing2.apply(this, arguments);
                  }
                  testing.toString = function () {
                    return _testing2.toString();
                  };
                  return testing;
                }(function (obj) {
                  with (obj) return testing;
                })
              }).attachStringTable(Locale.mainLocale).addStrings({});
            }), Scoped.define("module:PopupImageCapture", ["module:ImageCapture", "mediacomponents:PopupHelper"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, t.mixin);
            }), Scoped.define("module:ImageViewer", ["mediacomponents:ImageViewer.Dynamics.ImageViewer", "private:Logger", "module:Application", "base:Types", "base:Net.HttpHeader", "module:Locale", "module:Supplementary", "base:Objs", "base:Time", "base:Promise", "base:TimeFormat", "private:ZiggeoDynamicMixin"], function (e, t, i, r, o, a, n, d, s, x, c, l, u) {
              return e.extend({
                scoped: u
              }, [l, function (e) {
                return {
                  attrs: {
                    "stream-width": null,
                    "stream-height": null,
                    "effect-profile": null,
                    "client-auth": null,
                    "server-auth": null,
                    "intermediate-token": null,
                    image: null,
                    stream: null,
                    application: null,
                    forcerefresh: !1
                  },
                  types: {
                    "lazy-application": "bool"
                  },
                  create: function create() {
                    if (this._invokeCallback = n.eventInvokeCallback, this.get("source") || 0 < this.get("sources").length) return e.create.call(this);
                    this.set("ready", !1), this.get("effect-profile") && r.is_array(this.get("effect-profile")) && this.set("effect-profile", this.get("effect-profile")[0]), e.create.call(this), this.set("auth", {
                      client_auth: this.get("client-auth"),
                      server_auth: this.get("server-auth"),
                      intermediate_token: this.get("intermediate-token")
                    }), this.set("application_status", null), this.set("image_status", null);
                  },
                  _notifications: {
                    _activate: "_createWithApplication"
                  },
                  _obtainApplication: function _obtainApplication() {
                    this.get("application") && (this.application = r.is_string(this.get("application")) ? i.instanceByToken(this.get("application")) : this.get("application")), this.application = this.application || i.getDefault();
                  },
                  _createWithApplication: function _createWithApplication() {
                    this._obtainApplication(), this.application ? this.application.data.get("auth") || !this.get("client-auth") && !this.get("server-auth") ? (this.application.embed_events.delegateEvents(null, this, null, [this]), this.application.on("ready", function () {
                      this.set("application_status", !0), this.get("source") || this.__setImageSources(), this.set("ready", !0), this._track("image_embedding_loaded");
                    }, this).on("error", function (e, t) {
                      this.set("application_status", !1), this.state().next("FatalError", {
                        message: t
                      });
                    }, this)) : t.warn("You are specifying auth tokens on your embedding yet your application is initialized with auth = false.") : t.warn("No application (token) defined. We need an application (token) to include an embedding.");
                  },
                  destroy: function destroy() {
                    this.application.embed_events.off(null, null, this), e.destroy.call(this);
                  },
                  events: {
                    "change:image": function changeImage() {
                      this.set("stream", null), this.__setImageSources();
                    }
                  },
                  __setImageSources: function __setImageSources() {
                    this.get("image") && this.get("application_status") && (this.set("shareimageurl", this.application.images.publicImageUrl(this.get("image")).replace("http://", "https://")), this.get("stream") || this.set("refresh_token", this.application.images.refreshToken(this.get("image"))), this.__setSources(), this.application.images.cache(this.get("image"), {
                      auth: this.get("auth")
                    }).callback(this.__imageUpdate, this), this.get("ready") && this.reattachImage());
                  },
                  __sourceByImage: function __sourceByImage(t, e) {
                    var i = this.get("image_data"),
                      r = d.filter(i && i.streams ? i.streams : [], function (e) {
                        return !(e.token !== i.original_stream.token && e.parent_stream !== i.original_stream.token || 5 !== e.state || 3 !== e.streamable || this.get("effect-profile") && e.effect_profile !== this.get("effect-profile"));
                      }, this);
                    if (e || this.get("stream-width") || this.get("stream-height") || r.length < 2) {
                      var o = e ? this.application.image_streams : this.application.images,
                        a = [t];
                      return e && a.push(e), a.push({
                        auth: this.get("auth"),
                        params: {
                          stream_width: this.get("stream-width"),
                          stream_height: this.get("stream-height"),
                          effect_profile: this.get("effect-profile"),
                          force_refresh: this.get("forcerefresh")
                        }
                      }), {
                        source: o.imageUrl.apply(o, a),
                        token: t
                      };
                    }
                    var n = [],
                      s = [],
                      x = {
                        effect_profile: this.get("effect-profile"),
                        force_refresh: this.get("forcerefresh"),
                        auth: this.get("auth")
                      };
                    d.iter(r, function (e) {
                      n.push({
                        src: this.application.image_streams.imageUrl(t, e.token, x),
                        token: e.token
                      }), s.push({
                        width: e.image_width,
                        height: e.image_height,
                        filter: {
                          token: e.token
                        }
                      });
                    }, this);
                    var c = s[0];
                    return {
                      source: null,
                      sources: n,
                      streams: s,
                      currentstream: c,
                      token: t
                    };
                  },
                  __setSources: function __setSources() {
                    this.setAll(this.__sourceByImage(this.get("image"), this.get("stream")));
                  },
                  __imageUpdate: function __imageUpdate(e, t) {
                    if (!this.destroyed()) if (e) this.set("image_status", !1), e.status_code() === o.HTTP_STATUS_NOT_FOUND ? this.state().next("FatalError", {
                      message: this.string("image-not-found")
                    }) : e.status_code() === o.HTTP_STATUS_FORBIDDEN ? this.state().next("FatalError", {
                      message: this.string("image-access-forbidden")
                    }) : this.state().next("FatalError", {
                      message: this.string("image-unknown-error")
                    });else {
                      if (this.set("image_data", t), this.get("title") || this.set("title", t.title), this.set("totalduration", t.duration), !1 === t.approved && !this.get("intermediate-token")) return void this.state().next("FatalError", {
                        message: t.moderation_reason || this.string("image-rejected")
                      });
                      if (t.state < 4) return void this.state().next("FatalError", {
                        message: this.string("image-unknown-error")
                      });
                      if (this.set("image_status", !0), 4 === t.state) return void ("ImageProcessing" !== this.state().state_name() && this.state().next("ImageProcessing"));
                      if (this.get("effect-profile")) {
                        var i = !1;
                        if (d.iter(t.streams, function (e) {
                          e.effect_profile === this.get("effect-profile") && 4 < e.state && (i = !0);
                        }, this), !i) return void ("ImageProcessing" !== this.state().state_name() && this.state().next("ImageProcessing"));
                        if ("ImageProcessing" === this.state().state_name()) return this.set("forcerefresh", s.now()), this.__setSources(), void this.state().next("LoadPlayer");
                      }
                      if ("ImageProcessing" === this.state().state_name()) return this.set("refresh_token", this.application.images.refreshToken(this.get("image"))), this.set("forcerefresh", s.now()), this.__setSources(), void this.state().next("LoadPlayer");
                      if (!this.get("stream") && !this.get("refresh_token") && this.application.images.refreshToken(this.get("image"))) return this.set("refresh_token", this.application.images.refreshToken(this.get("image"))), this.__setSources(), void this.state().next("LoadPlayer");
                      this.__setSources();
                    }
                  },
                  _track: function _track(e, t, i) {
                    var r, o;
                    this.application && (r = s.now(), (o = x.create()).success(function () {
                      this.application.analytics.track("2", e, {
                        image_token: this.get("image_data").token,
                        stream_token: this.get("stream") ? this.get("stream") : undefined
                      }, d.extend({
                        embed_type: "player"
                      }, t), d.extend({
                        width: this.get("stream") ? this.get("stream").width : this.imageWidth(),
                        height: this.get("stream") ? this.get("stream").height : this.imageHeight(),
                        tags: this.get("image_data").tags
                      }, i), r);
                    }, this), this.get("image_data") ? o.asyncSuccess() : this.once("change:image_data", function () {
                      o.asyncSuccess();
                    }, this));
                  }
                };
              }]).register("ba-ziggeoimageviewer").register("ziggeoimageviewer").attachStringTable(a.mainLocale).addStrings({
                "image-not-found": "We could not find the specified image file.",
                "image-access-forbidden": "You are not permitted to access this image file.",
                "image-unknown-error": "We cannot access this image at the moment. Please try again later.",
                "image-rejected": "The image has been rejected.",
                "image-processing": "The image is processing - stay tuned.",
                "image-access-error": "The image is currently under moderation. You may click to retry."
              });
            }), Scoped.define("module:PopupImageViewer", ["module:ImageViewer", "mediacomponents:PopupHelper"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, t.mixin);
            }), Scoped.define("module:Player", ["mediacomponents:VideoPlayer.Dynamics.Player", "private:Logger", "module:Application", "base:Types", "module:PlayerStates", "base:Net.HttpHeader", "module:Locale", "module:Supplementary", "base:Objs", "base:Time", "base:Promise", "base:TimeFormat", "private:ZiggeoDynamicMixin"], function (e, i, t, r, o, n, a, s, l, x, c, d, u, h) {
              return e.extend({
                scoped: h
              }, [u, function (e) {
                return {
                  attrs: {
                    "stream-width": null,
                    "stream-height": null,
                    "effect-profile": null,
                    "client-auth": null,
                    "server-auth": null,
                    "intermediate-token": null,
                    video: null,
                    stream: null,
                    application: null,
                    forcerefresh: !1,
                    pauseonplay: !1,
                    "audio-transcription-as-subtitles": !1
                  },
                  types: {
                    playlist: "array",
                    pauseonplay: "bool",
                    "lazy-application": "bool",
                    "audio-transcription-as-subtitles": "bool"
                  },
                  create: function create() {
                    if (this._invokeCallback = s.eventInvokeCallback, this.get("source") || 0 < this.get("sources").length) return e.create.call(this);
                    this.set("ready", !1), this.__playlist = this.get("playlist"), this.set("playlist", null), this.get("effect-profile") && r.is_array(this.get("effect-profile")) && this.set("effect-profile", this.get("effect-profile")[0]), e.create.call(this), this.set("auth", {
                      client_auth: this.get("client-auth"),
                      server_auth: this.get("server-auth"),
                      intermediate_token: this.get("intermediate-token")
                    }), this.set("application_status", null), this.set("video_status", null);
                  },
                  _notifications: {
                    _activate: "_createWithApplication"
                  },
                  _createWithApplication: function _createWithApplication() {
                    var e, t;
                    this._obtainApplication(), this.application ? this.application.data.get("auth") || !this.get("client-auth") && !this.get("server-auth") ? (this.application.embed_events.delegateEvents(null, this, null, [this]), this.__playlist && (this.set("playlist", this.__playlist.map(function (e) {
                      return this.__sourceByVideo(e);
                    }, this)), e = this.get("playlist")[0], this.set("poster", e.poster), this.set("source", e.source), this.set("video", e.token), this.on("playlist-next", function (e) {
                      this.set("video", e.token);
                    }, this)), t = this.parent() && this.parent().record !== undefined && this.parent().host !== undefined && !this.get("postersource"), this.listenOn(this.application, "ready", function () {
                      this.application.authVideoReady(this.get("auth"), this.get("video")).callback(function () {
                        this.set("application_status", !0), this.get("playlist") ? (this.__setVideoSources(), this.set("ready", !0)) : t ? this.application.videos.get(this.get("video"), {
                          auth: this.get("auth")
                        }).callback(function (e, t) {
                          t && 4 === t.state ? (this.get("source") || this.__setVideoSources(), this.state().next("VideoProcessing")) : this.get("source") || this.__setVideoSources(), this.set("ready", !0);
                        }, this) : (this.get("source") || this.__setVideoSources(), this.set("ready", !0)), this._track("embedding_loaded");
                      }, this);
                    }, this).listenOn(this.application, "error", function (e, t) {
                      this.set("application_status", !1), this.state().next("FatalError", {
                        message: t
                      });
                    }, this), this.get("pauseonplay") && this.application.embed_events.on("playing", function (e) {
                      e !== this && this.get("playing") && this.execute("pause");
                    }, this), this.set("tracktags", this.application.data.get("track_tags"))) : i.warn("You are specifying auth tokens on your embedding yet your application is initialized with auth = false.") : i.warn("No application (token) defined. We need an application (token) to include an embedding.");
                  },
                  destroy: function destroy() {
                    this.application.embed_events.off(null, null, this), e.destroy.call(this);
                  },
                  getSubtitle: function getSubtitle() {
                    var e = this.get("video_data").streams[0].audio_transcription;
                    return !!e && this.__audioTranscriptionToVTT(e.words, e.times);
                  },
                  events: {
                    "change:video": function changeVideo() {
                      var e;
                      this.host && (this.set("stream", null), e = 0 <= this.host.state().state_name().indexOf("Error"), this.__setVideoSources(), e && this.host.next("Initial"));
                    },
                    paused: function paused() {
                      this._track("play_pause", {
                        media_time: this.get("position")
                      });
                    },
                    playing: function playing() {
                      this._track("play_playing", {
                        media_time: this.get("position")
                      });
                    },
                    ended: function ended() {
                      this._track("play_end", {
                        media_time: this.get("duration")
                      });
                    },
                    seek: function seek(e) {
                      this._track("play_seek", {
                        media_time: e
                      });
                    }
                  },
                  __setShareVideoUrl: function __setShareVideoUrl(e) {
                    this.set("sharevideourl", this.application.videos.iframeVideoUrl(e).replace("http://", "https://"));
                  },
                  __setVideoSources: function __setVideoSources() {
                    this.get("video") && this.get("application_status") && (this.__setShareVideoUrl(this.get("video")), this.get("stream") || this.set("refresh_token", this.application.videos.refreshToken(this.get("video"))), this.__setSources(), this.application.videos.cache(this.get("video"), {
                      auth: this.get("auth")
                    }).callback(this.__videoUpdate, this), this.get("ready") && this.reattachVideo());
                  },
                  __sourceByVideo: function __sourceByVideo(t, e) {
                    var i = this.get("video_data");
                    i && null !== i.title && this.set("posteralt", i.title), i && i.duration && i.duration && this.set("duration", i.duration), i && i.description && this.set("description", i.description), i && ("undefined" != typeof i.created && this.set("uploaddate", i.created), "undefined" != typeof i.embed_image_url && this.set("thumbnailurl", "https://" + i.embed_image_url), "undefined" != typeof i.embed_video_url && this.set("contenturl", "https://" + i.embed_video_url));
                    var r = this.get("effect-profile");
                    i && i.default_stream && i.default_stream.effect_profile && !this.get("effect-profile") && (r = i.default_stream.effect_profile);
                    var o = l.filter(i && i.streams ? i.streams : [], function (e) {
                      return !(e.token !== i.original_stream.token && e.parent_stream !== i.original_stream.token || 5 !== e.state || 3 !== e.streamable || (r || e.effect_profile) && e.effect_profile !== r);
                    }, this);
                    if (this.get("playlist") && (o = [], e = null), i && "_" === this.get("video")[0] && this.__setShareVideoUrl(i.token), e || this.get("stream-width") || this.get("stream-height") || o.length < 2) {
                      var a = e ? this.application.streams : this.application.videos,
                        n = [t];
                      return e && n.push(e), n.push({
                        auth: this.get("auth"),
                        params: {
                          stream_width: this.get("stream-width"),
                          stream_height: this.get("stream-height"),
                          effect_profile: this.get("effect-profile"),
                          force_refresh: this.get("forcerefresh")
                        }
                      }), {
                        poster: this.get("poster") || a.imageUrl.apply(a, n),
                        source: a.videoUrl.apply(a, n),
                        token: t
                      };
                    }
                    var s = [],
                      x = [],
                      c = {
                        effect_profile: this.get("effect-profile"),
                        force_refresh: this.get("forcerefresh"),
                        auth: this.get("auth")
                      };
                    l.iter(o, function (e) {
                      s.push({
                        src: this.application.streams.videoUrl(t, e.token, c),
                        poster: this.application.streams.imageUrl(t, e.token, c),
                        token: e.token
                      }), x.push({
                        width: e.video_width,
                        height: e.video_height,
                        filter: {
                          token: e.token
                        }
                      });
                    }, this);
                    var d = x[0];
                    return {
                      poster: null,
                      source: null,
                      sources: s,
                      streams: x,
                      currentstream: d,
                      token: t
                    };
                  },
                  __setSources: function __setSources() {
                    this.set("uploadoptions", {
                      textTracks: this.application.streams.subtitleAttachUploaderUrl(this.get("video"), this.get("stream") || this.properties().getProp("video_data.original_stream.token"), this.get("auth"))
                    }), this.setAll(this.__sourceByVideo(this.get("video"), this.get("stream")));
                  },
                  __audioTranscriptionToVTT: function __audioTranscriptionToVTT(e, t, i) {
                    i = i || 5;
                    for (var r = e.length, o = 0, a = ["WEBVTT"]; o < r;) {
                      var n = t[o].start,
                        s = t[o].end,
                        x = [e[o]];
                      for (o++, j = i - 1; 0 < j && o < r;) s = t[o].end, x.push(e[o]), o++, j--;
                      a.push(""), a.push(d.format("HH:MM:ss.l", n) + " --\x3e " + d.format("HH:MM:ss.l", s)), a.push(x.join(" "));
                    }
                    return a.join("\n");
                  },
                  __videoUpdate: function __videoUpdate(e, t) {
                    if (!this.destroyed()) if (e) this.set("video_status", !1), e.status_code() === n.HTTP_STATUS_NOT_FOUND ? this.state().next("FatalError", {
                      message: this.string("video-not-found")
                    }) : e.status_code() === n.HTTP_STATUS_FORBIDDEN ? this.state().next("FatalError", {
                      message: this.string("video-access-forbidden")
                    }) : this.state().next("LoadError");else {
                      this.set("video_data", t);
                      var i = [];
                      try {
                        var r = t.default_stream.audio_transcription || t.original_stream.audio_transcription;
                        r && this.get("audio-transcription-as-subtitles") && i.push({
                          lang: "en",
                          kind: "subtitles",
                          label: "Transcription",
                          content: this.__audioTranscriptionToVTT(r.words, r.times)
                        });
                        var o = t.default_stream.subtitles || t.original_stream.subtitles;
                        o && l.iter(o, function (e, t) {
                          i.push({
                            lang: t,
                            kind: "subtitles",
                            label: e.label,
                            content: e.data
                          });
                        });
                      } catch (s) {}
                      if (this.set("tracktags", this.get("tracktags").concat(i)), this.get("title") || this.set("title", t.title), this.set("totalduration", t.duration), !1 === t.approved && !this.get("intermediate-token")) return void this.state().next("FatalError", {
                        message: t.moderation_reason || this.string("video-rejected")
                      });
                      if (t.state < 4) return void this.state().next("FatalError", {
                        message: this.string("video-unknown-error")
                      });
                      if (this.set("video_status", !0), 4 === t.state) return void ("VideoProcessing" !== this.state().state_name() && this.state().next("VideoProcessing"));
                      if (this.get("effect-profile")) {
                        var a = !1;
                        if (l.iter(t.streams, function (e) {
                          e.effect_profile === this.get("effect-profile") && 4 < e.state && (a = !0);
                        }, this), !a) return void ("VideoProcessing" !== this.state().state_name() && this.state().next("VideoProcessing"));
                        if ("VideoProcessing" === this.state().state_name()) return this.set("forcerefresh", x.now()), this.__setSources(), void this.state().next("LoadPlayer");
                      }
                      if ("VideoProcessing" === this.state().state_name()) return this.set("refresh_token", this.application.videos.refreshToken(this.get("video"))), this.set("forcerefresh", x.now()), this.__setSources(), void this.state().next("LoadPlayer");
                      if (!this.get("stream") && !this.get("refresh_token") && this.application.videos.refreshToken(this.get("video"))) return this.set("refresh_token", this.application.videos.refreshToken(this.get("video"))), this.__setSources(), void this.state().next("LoadPlayer");
                      this.__setSources();
                    }
                  },
                  _track: function _track(e, t, i) {
                    var r, o;
                    this.application && (r = x.now(), (o = c.create()).success(function () {
                      this.application.analytics.track("2", e, {
                        video_token: this.get("video_data").token,
                        stream_token: this.get("stream") ? this.get("stream") : undefined
                      }, l.extend({
                        embed_type: "player"
                      }, t), l.extend({
                        duration: this.get("video_data").duration || this.get("duration"),
                        width: this.get("stream") ? this.get("stream").width : this.videoWidth(),
                        height: this.get("stream") ? this.get("stream").height : this.videoHeight(),
                        tags: this.get("video_data").tags
                      }, i), r);
                    }, this), this.get("video_data") ? o.asyncSuccess() : this.once("change:video_data", function () {
                      o.asyncSuccess();
                    }, this));
                  }
                };
              }], function (e) {
                return {
                  playerStates: function playerStates() {
                    return e.playerStates.call(this).concat([o]);
                  }
                };
              }).register("ba-ziggeoplayer").register("ziggeoplayer").attachStringTable(a.mainLocale).addStrings({
                "video-not-found": "We could not find the specified video file.",
                "video-access-forbidden": "You are not permitted to access this video file.",
                "video-unknown-error": "We cannot access this video at the moment. Please try again later.",
                "video-rejected": "The video has been rejected.",
                "video-processing": "The video is processing - stay tuned.",
                "video-access-error": "The video is currently under moderation. You may click to retry."
              });
            }), Scoped.define("module:PopupPlayer", ["module:Player", "mediacomponents:PopupHelper"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, t.mixin);
            }), Scoped.define("module:Recorder", ["mediacomponents:VideoRecorder.Dynamics.Recorder", "module:Application", "module:Device", "private:Logger", "private:Environment", "module:RecorderStates", "base:Types", "base:MediaTypes", "base:Time", "base:Strings", "module:Locale", "module:Supplementary", "base:Objs", "base:Promise", "base:Async", "browser:Events", "browser:Info", "private:ZiggeoDynamicMixin"], function (Recorder, Application, Device, Logger, Environment, RecorderStates, Types, MediaTypes, Time, Strings, Locale, Supplementary, Objs, Promise, Async, DomEvents, Info, ZiggeoDynamicMixin, scoped) {
              return Recorder.extend({
                scoped: scoped
              }, [ZiggeoDynamicMixin, function (t) {
                return {
                  template: t.template.replace('"overlay">', '"overlay"><a class="ziggeo-v2-testing" ba-if="{{testing}}" href="https://ziggeo.com/pricing" target="_blank"></a>'),
                  attrs: {
                    dynvideoplayer: "ziggeoplayer",
                    "effect-profile": null,
                    "preview-effect-profile": null,
                    "video-profile": null,
                    "meta-profile": null,
                    "client-auth": null,
                    "server-auth": null,
                    "intermediate-token": null,
                    application: null,
                    video: null,
                    description: null,
                    title: null,
                    tags: null,
                    "custom-data": null,
                    key: null,
                    "auto-crop": null,
                    "default-image-selector": .1,
                    "auto-pad": null,
                    "expiration-days": null,
                    "force-overwrite": null,
                    "recover-streams": null,
                    "transcript-language": "en-US",
                    "input-bind": null,
                    "form-accept": null,
                    playermodeifexists: !1,
                    rerecordableifexists: !1,
                    chrome_extension_id: null,
                    opera_extension_id: null,
                    chrome_extension_install_link: null,
                    opera_extension_install_link: null
                  },
                  types: {
                    tags: "array",
                    "custom-data": "object",
                    "auto-crop": "bool",
                    "auto-pad": "bool",
                    "expiration-days": "int",
                    "delete-old-streams": "bool",
                    "force-overwrite": "bool",
                    "recover-streams": "bool",
                    "default-image-selector": "float",
                    "effect-profile": "array",
                    "lazy-application": "bool",
                    playermodeifexists: "bool",
                    rerecordableifexists: "bool"
                  },
                  events: {
                    rerecord: function rerecord() {
                      this.__inputBindElement && (this.__inputBindElement.value = ""), this.get("form-accept") && this._formAcceptEvents.on(document.querySelector(this.get("form-accept")), "submit", function (e) {
                        e.preventDefault();
                      });
                    },
                    processed: function processed() {
                      this.__had_processed = !0;
                    }
                  },
                  create: function create() {
                    this._invokeCallback = Supplementary.eventInvokeCallback, this.set("ready", !1), t.create.call(this), this.get("video") && !this.get("key") && Strings.starts_with(this.get("video"), "_") && this.set("key", Strings.strip_start(this.get("video"), "_")), this.get("simulate") && this.set("localplayback", !0), Types.is_string(this.get("effect-profile")) && this.set("effect-profile", Types.parseArray(this.get("effect-profile"))), this.set("auth", {
                      client_auth: this.get("client-auth"),
                      server_auth: this.get("server-auth"),
                      intermediate_token: this.get("intermediate-token")
                    }), this.set("application_status", null), this.__hadInitialVideo = !!this.get("video"), this.get("video") || (this.set("playermodeifexists", !1), this.set("rerecordableifexists", !1), this.get("form-accept") && (this._formAcceptEvents = this.auto_destroy(new DomEvents()), this._formAcceptEvents.on(document.querySelector(this.get("form-accept")), "submit", function (e) {
                      e.preventDefault();
                    }))), this.on("rerecord", function () {
                      this._track("rerecord_confirm");
                    }, this), this.__had_processed = !1, this.scopes.player.on("change:video_data", function (e) {
                      this.set("video_data", e);
                      var t = e.streams.find(function (e) {
                        return e.token === this.get("stream");
                      }, this);
                      t && this.set("stream_data", t);
                    }, this);
                  },
                  _notifications: {
                    _activate: "_createWithApplication"
                  },
                  _deferActivate: function _deferActivate() {
                    if (this._obtainApplication(), (this.application || !this.get("lazy-application")) && !this.get("playermodeifexists") && !this.get("rerecordableifexists")) return !1;
                    var t = Promise.create();
                    return this.application ? t.asyncSuccess(!0) : Application.events.once("set-default", function (e) {
                      this.application = e, t.asyncSuccess(!0);
                    }, this), (this.get("playermodeifexists") || this.get("rerecordableifexists")) && (t = t.mapSuccess(function (t) {
                      return this.application.videos.get(this.get("video") || (this.get("key") ? "_" + this.get("key") : null), {
                        auth: this.get("auth")
                      }).mapSuccess(function (e) {
                        return e && "EMPTY" !== e.state_string && (this.get("playermodeifexists") && this.set("recordermode", !1), this.get("rerecordableifexists") || this.set("rerecordable", !1)), !this.get("video") && this.get("key") && this.set("video", "_" + this.get("key")), this.set("playermodeifexists", !1), this.set("rerecordableifexists", !1), t;
                      }, this);
                    }, this).mapError(function (e) {
                      return this.get("video") && 404 === e.status_code() && this.set("video", null), this.set("playermodeifexists", !1), this.set("rerecordableifexists", !1), Promise.value(!0);
                    }, this)), t.success(this.activate, this), !0;
                  },
                  _createWithApplication: function _createWithApplication() {
                    this._obtainApplication(), this.application ? this.application.data.get("auth") || !this.get("client-auth") && !this.get("server-auth") ? (this.get("chrome_extension_id") && !this.get("chrome_extension_install_link") && this.set("chrome_extension_install_link", "https://chrome.google.com/webstore/detail/" + this.get("chrome_extension_id")), this.set("screen", {
                      chromeExtensionId: this.get("chrome_extension_id") || this.application.data.get("chrome_extension_id"),
                      operaExtensionId: this.get("opera_extension_id") || this.application.data.get("opera_extension_id"),
                      chromeExtensionInstallLink: this.get("chrome_extension_install_link") || this.application.data.get("chrome_extension_install_link"),
                      operaExtensionInstallLink: this.get("opera_extension_install_link") || this.application.data.get("opera_extension_install_link")
                    }), this.application.embed_events.delegateEvents(null, this, null, [this]), this.application.on("ready", function () {
                      this.set("application_status", !0), this.set("ready", !0), this.set("testing", this.application.data.get("testing_application"));
                    }, this).on("error", function (e, t) {
                      this.set("application_status", !1), this.state().next("FatalError", {
                        message: t
                      });
                    }, this), this.set("playerattrs", {
                      application: this.application,
                      "effect-profile": this.get("preview-effect-profile"),
                      "client-auth": this.get("client-auth"),
                      "server-auth": this.get("server-auth"),
                      "intermediate-token": this.get("intermediate-token"),
                      video: this.get("video"),
                      "force-refresh": Time.now()
                    }), this._track("embedding_loaded"), this.set("webrtcstreaming", this.application.data.get("webrtc_streaming")), this.set("webrtcstreamingifnecessary", this.application.data.get("webrtc_streaming_if_necessary")), this.set("webrtconmobile", this.application.data.get("webrtc_on_mobile")), Info.isSafari() && Info.isDesktop() && !this.get("webrtcstreaming") && !this.get("webrtcstreamingifnecessary") && this.set("webrtcstreamingifnecessary", !0), !this.get("webrtcstreaming") && !this.get("webrtcstreamingifnecessary") || this.get("timeminlimit") || this.set("timeminlimit", 5), this._updateUrls()) : Logger.warn("You are specifying auth tokens on your embedding yet your application is initialized with auth = false.") : Logger.warn("No application (token) defined. We need an application (token) to include an embedding.");
                  },
                  _track: function _track(e, t, i) {
                    this.application.analytics.track("2", e, {
                      video_token: this.get("video"),
                      stream_token: this.get("stream")
                    }, Objs.extend({
                      embed_type: this.__hadInitialVideo ? "rerecorder" : "recorder"
                    }, t), Objs.extend({
                      creation_type: this.get("creation-type"),
                      duration: this.get("duration"),
                      width: this.get("recordingwidth"),
                      height: this.get("recordingheight"),
                      tags: this.get("tags")
                    }, i));
                  },
                  functions: {
                    reset: function reset() {
                      this.get("video") && !this.__hadInitialVideo && this.set("video", null), this.__had_processed = !1, t.functions.reset.call(this);
                    },
                    ready_to_play: function ready_to_play() {
                      this.__had_processed || (this.trigger("processing", 1), this.trigger("processed")), t.functions.ready_to_play.call(this);
                    }
                  },
                  _updateUrls: function _updateUrls(e, t, i) {
                    this.set("playerattrs.video", this.get("video")), this.set("uploadoptions", {
                      webrtcStreaming: {
                        wssUrl: this.get("webrtcstreaming") || this.get("webrtcstreamingifnecessary") ? this.application.urls.wssUrl() : undefined,
                        streamInfo: this.get("webrtcstreaming") || this.get("webrtcstreamingifnecessary") ? {
                          applicationName: this.application.urls.webrtcStreamingApp(Info.isFirefox() ? "udp" : ""),
                          streamName: this.application.streams.webrtcStreamName(this.get("video"), this.get("stream"), this.get("auth"))
                        } : undefined,
                        delay: 4750,
                        stopDelay: 2750
                      },
                      image: t ? this.application.data.getSignedUploaderConfig(t.url, t.fields) : undefined,
                      video: e ? Objs.extend({
                        resilienceCheck: function resilienceCheck(e) {
                          return !e || !e.duration;
                        }
                      }, this.application.data.getSignedUploaderConfig(e.url, e.fields)) : undefined,
                      audio: i ? this.application.data.getSignedUploaderConfig(i.url, i.fields) : undefined,
                      textTracks: this.application.streams.subtitleAttachUploaderUrl(this.get("video"), this.get("stream"), this.get("auth"))
                    });
                  },
                  _readDeviceOrientation: function _readDeviceOrientation() {
                    var e = this.recorder.getCameraFacingMode();
                    switch (window.orientation) {
                      case 0:
                        return 90;
                      case 90:
                        return "environment" === e ? 0 : 180;
                      case -90:
                        return "environment" === e ? 180 : 0;
                      case 180:
                        return 270;
                    }
                  },
                  __createParams: function __createParams() {
                    var e = {};
                    try {
                      var t = this.activeElement().cloneNode();
                      t.innerHTML = "", e = t.outerHTML;
                    } catch (i) {}
                    return {
                      description: this.get("description"),
                      title: this.get("title"),
                      tags: this.get("tags") ? this.get("tags").join(",") : undefined,
                      data: this.get("custom-data") ? JSON.stringify(this.get("custom-data")) : undefined,
                      key: this.get("key"),
                      auto_crop: this.get("auto-crop"),
                      auto_pad: this.get("auto-pad"),
                      only_audio: this.get("onlyaudio"),
                      expiration_days: this.get("expiration-days"),
                      delete_old_streams: this.get("delete-old-streams"),
                      effect_profile: this.get("effect-profile") ? this.get("effect-profile").join(",") : undefined,
                      force_overwrite: this.get("force-overwrite"),
                      video_profile: this.get("video-profile"),
                      meta_profile: this.get("meta-profile"),
                      enforce_duration: this.get("enforce-duration"),
                      recover_streams: this.get("recover-streams"),
                      max_duration: this.get("timelimit"),
                      user_language: navigator.language || navigator.userLanguage,
                      video_file_name: this._videoFileName,
                      transcript_language: "auto" == this.get("transcript-language").toLowerCase() ? navigator.language || navigator.userLanguage : this.get("transcript-language"),
                      default_image_selector: this.get("default-image-selector"),
                      device_info: Objs.extend({
                        api_version: 2,
                        embed_code: e,
                        media_source: this.__getMediaSource(),
                        capture_type: this.__getCaptureType()
                      }, Device.info)
                    };
                  },
                  __recordingTypeParams: function __recordingTypeParams() {
                    var e = {
                      create_stream: !0
                    };
                    if (this.recorder) {
                      try {
                        var t = this.recorder._recorder._recorder._mediaRecorder.mimeType;
                        t && Objs.extend(e, {
                          video_type: MediaTypes.getExtension(t)
                        });
                      } catch (i) {}
                      return Objs.extend(e, {
                        webrtc_recording: !0,
                        webrtc_streaming: this.isWebrtcStreaming(),
                        audio_url: !this.isWebrtcStreaming(),
                        image_url: !0
                      });
                    }
                    return this._videoFile && Objs.extend(e, {
                      video_type: Strings.last_after(this._videoFile.name, ".")
                    }), this.get("snapshotfromuploader") ? Objs.extend(e, {
                      image_url: !0
                    }) : e;
                  },
                  __getMediaSource: function __getMediaSource() {
                    var e = this.__recordingTypeParams();
                    return "screen" == this.get("record_media") ? "screen" : !0 === e.webrtc_recording ? "record" : "upload";
                  },
                  __getCaptureType: function __getCaptureType() {
                    var e = this.__recordingTypeParams();
                    return !0 === e.webrtc_streaming ? "webrtc_streaming" : !0 === e.webrtc_recording ? "webrtc" : "file_capture";
                  },
                  _prepareRecording: function _prepareRecording() {
                    return this._requiresDeviceOrientation = Info.isMobile() && Info.isiOS() && window.orientation !== undefined && this.isWebrtcStreaming(), this.get("video") ? this.application.streams._create(this.get("video"), this.__recordingTypeParams(), this.get("auth"), 5).mapSuccess(function (e) {
                      this.set("stream", e.stream.token), this.set("stream_data", e.stream), this._updateUrls(e.url_data, e.image_url_data, e.audio_url_data);
                    }, this) : this.application.videos._create(Objs.extend(this.__createParams(), this.__recordingTypeParams()), this.get("auth"), 5).mapSuccess(function (e) {
                      this.set("video", e.video.token), this.set("video_data", e.video), this.set("stream", e.stream.token), this.set("stream_data", e.stream), this._updateUrls(e.url_data, e.image_url_data, e.audio_url_data);
                    }, this);
                  },
                  _verifyRecording: function _verifyRecording() {
                    var i = Promise.create();
                    return Async.eventually(function () {
                      var e, t;
                      this.get("video") && (e = {
                        duration: this.get("duration")
                      }, t = {}, this._requiresDeviceOrientation && Objs.extend(e, {
                        rotation: this._readDeviceOrientation()
                      }), this.get("starttime") && Objs.extend(e, {
                        start_time: this.get("starttime")
                      }), this.get("endtime") && Objs.extend(e, {
                        end_time: this.get("endtime")
                      }), this.imageUploaded() && Objs.extend(t, {
                        confirm_image: !0
                      }), this.audioUploaded() && Objs.extend(t, {
                        confirm_audio: !0
                      }), (this.get("simulate") ? Promise.value(!0) : this.application.streams._confirm(this.get("video"), this.get("stream"), e, this.get("auth"), 50, t)).success(function () {
                        this.__inputBindElement && (this.__inputBindElement.value = this.get("video")), this.get("form-accept") && this._formAcceptEvents.off(document.querySelector(this.get("form-accept")), "submit"), this.application.videos.cacheInvalidate(this.get("video"));
                      }, this).forwardCallback(i));
                    }, this, 2500), i;
                  },
                  _afterActivate: function _afterActivate(e) {
                    t._afterActivate.apply(this, arguments), this.get("input-bind") && (this.__inputBindElement = document.getElementsByName(this.get("input-bind"))[0], this.__inputBindElement || (this.__inputBindElement = document.createElement("input"), this.__inputBindElement.type = "hidden", this.__inputBindElement.id = this.get("input-bind"), this.__inputBindElement.name = this.get("input-bind"), e.parentElement.appendChild(this.__inputBindElement)), this.get("video") && (this.__inputBindElement.value = this.get("video")));
                  }
                };
              }], function (e) {
                return {
                  recorderStates: function recorderStates() {
                    return e.recorderStates.call(this).concat([RecorderStates]);
                  }
                };
              }).register("ba-ziggeorecorder").register("ziggeorecorder").registerFunctions({
                testing: function (_testing3) {
                  function testing(_x1293) {
                    return _testing3.apply(this, arguments);
                  }
                  testing.toString = function () {
                    return _testing3.toString();
                  };
                  return testing;
                }(function (obj) {
                  with (obj) return testing;
                })
              }).attachStringTable(Locale.mainLocale).addStrings({});
            }), Scoped.define("module:PopupRecorder", ["module:Recorder", "mediacomponents:PopupHelper"], function (e, t, i) {
              return e.extend({
                scoped: i
              }, t.mixin);
            });
          }.call(Scoped), function () {
            var e = this.subScope();
            e.binding("module", "global:ZiggeoApi.V2"), e.extend("module:", function () {
              return {};
            }), e.extend("module:Locale", ["module:Locale"], function (e) {
              var t = {
                "language:ar": {
                  "application.error_503": "&#x646;&#x62D;&#x646; &#x641;&#x64A; &#x642;&#x64A;&#x62F; &#x62A;&#x637;&#x648;&#x64A;&#x631; &#x62E;&#x62F;&#x645;&#x62A;&#x646;&#x627;. &#x633;&#x62A;&#x639;&#x648;&#x62F; &#x645;&#x642;&#x627;&#x637;&#x639; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x642;&#x631;&#x64A;&#x628;&#x627;.",
                  "application.error_404": "&#x644;&#x627; &#x64A;&#x645;&#x643;&#x646;&#x646;&#x627; &#x627;&#x644;&#x62A;&#x639;&#x631;&#x641; &#x639;&#x644;&#x649; &#x645;&#x641;&#x62A;&#x627;&#x62D; &#x648;&#x627;&#x62C;&#x647;&#x629; &#x628;&#x631;&#x645;&#x62C;&#x629; &#x627;&#x644;&#x62A;&#x637;&#x628;&#x64A;&#x642;&#x627;&#x62A;. &#x627;&#x644;&#x631;&#x62C;&#x627;&#x621; &#x627;&#x644;&#x62A;&#x623;&#x643;&#x62F; &#x645;&#x646; &#x62A;&#x62D;&#x62F;&#x64A;&#x62F;&#x647; &#x641;&#x64A; &#x639;&#x646;&#x648;&#x627;&#x646; &#x645;&#x648;&#x642;&#x639;&#x643; &#x627;&#x644;&#x625;&#x644;&#x643;&#x62A;&#x631;&#x648;&#x646;&#x64A;.",
                  "application.error_401": "&#x644;&#x627; &#x64A;&#x633;&#x645;&#x62D; &#x644;&#x643; &#x628;&#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x627;&#x644;&#x62A;&#x637;&#x628;&#x64A;&#x642; &#x645;&#x646; &#x647;&#x630;&#x627; &#x627;&#x644;&#x645;&#x648;&#x642;&#x639;.",
                  "application.error_412": "&#x62A;&#x62D;&#x62A;&#x627;&#x62C; &#x625;&#x644;&#x649; &#x62A;&#x623;&#x643;&#x64A;&#x62F; / &#x62A;&#x631;&#x642;&#x64A;&#x629; &#x62D;&#x633;&#x627;&#x628;&#x643;.",
                  "application.error_unknown": "&#x62D;&#x62F;&#x62B; &#x62E;&#x637;&#x623; &#x63A;&#x64A;&#x631; &#x645;&#x639;&#x631;&#x648;&#x641;. &#x62A;&#x645; &#x625;&#x639;&#x644;&#x627;&#x645; &#x641;&#x631;&#x64A;&#x642;&#x646;&#x627; &#x648;&#x633;&#x64A;&#x62D;&#x644; &#x627;&#x644;&#x645;&#x634;&#x643;&#x644;&#x629;.",
                  "ziggeoplayer.video-not-found": "&#x62A;&#x639;&#x630;&#x631; &#x627;&#x644;&#x639;&#x62B;&#x648;&#x631; &#x639;&#x644;&#x649; &#x645;&#x644;&#x641; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x627;&#x644;&#x645;&#x62D;&#x62F;&#x62F;.",
                  "ziggeoplayer.video-access-forbidden": "&#x644;&#x627; &#x64A;&#x633;&#x645;&#x62D; &#x644;&#x643; &#x628;&#x627;&#x644;&#x62F;&#x62E;&#x648;&#x644; &#x625;&#x644;&#x649; &#x645;&#x644;&#x641; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x647;&#x630;&#x627;.",
                  "ziggeoplayer.video-unknown-error": "&#x644;&#x627; &#x64A;&#x645;&#x643;&#x646;&#x646;&#x627; &#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x647;&#x630;&#x627; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x641;&#x64A; &#x627;&#x644;&#x648;&#x642;&#x62A; &#x627;&#x644;&#x62D;&#x627;&#x644;&#x64A;. &#x627;&#x644;&#x631;&#x62C;&#x627;&#x621; &#x645;&#x639;&#x627;&#x648;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629; &#x641;&#x64A; &#x648;&#x642;&#x62A; &#x644;&#x627;&#x62D;&#x642;.",
                  "ziggeoplayer.video-rejected": "&#x62A;&#x645; &#x631;&#x641;&#x636; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648;.",
                  "ziggeoplayer.video-processing": "&#x64A;&#x62A;&#x645; &#x645;&#x639;&#x627;&#x644;&#x62C;&#x629; &#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; - &#x627;&#x644;&#x631;&#x62C;&#x627;&#x621; &#x627;&#x644;&#x627;&#x646;&#x62A;&#x638;&#x627;&#x631;.",
                  "ziggeoplayer.video-access-error": "&#x627;&#x644;&#x641;&#x64A;&#x62F;&#x64A;&#x648; &#x642;&#x64A;&#x62F; &#x627;&#x644;&#x645;&#x631;&#x627;&#x62C;&#x639;&#x629; &#x62D;&#x627;&#x644;&#x64A;&#x627;. &#x64A;&#x645;&#x643;&#x646;&#x643; &#x627;&#x644;&#x646;&#x642;&#x631; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ziggeoaudioplayer.audio-not-found": "&#x644;&#x645; &#x646;&#x62A;&#x645;&#x643;&#x646; &#x645;&#x646; &#x627;&#x644;&#x639;&#x62B;&#x648;&#x631; &#x639;&#x644;&#x649; &#x645;&#x644;&#x641; &#x627;&#x644;&#x635;&#x648;&#x62A; &#x627;&#x644;&#x645;&#x62D;&#x62F;&#x62F;.",
                  "ziggeoaudioplayer.audio-access-forbidden": "&#x644;&#x627; &#x64A;&#x633;&#x645;&#x62D; &#x644;&#x643; &#x644;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x647;&#x630;&#x627; &#x627;&#x644;&#x645;&#x644;&#x641; &#x627;&#x644;&#x635;&#x648;&#x62A;&#x64A;.",
                  "ziggeoaudioplayer.audio-unknown-error": "&#x644;&#x627; &#x64A;&#x645;&#x643;&#x646;&#x646;&#x627; &#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x647;&#x630;&#x627; &#x627;&#x644;&#x635;&#x648;&#x62A; &#x641;&#x64A; &#x627;&#x644;&#x648;&#x642;&#x62A; &#x627;&#x644;&#x62D;&#x627;&#x644;&#x64A;. &#x627;&#x644;&#x631;&#x62C;&#x627;&#x621; &#x645;&#x639;&#x627;&#x648;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629; &#x641;&#x64A; &#x648;&#x642;&#x62A; &#x644;&#x627;&#x62D;&#x642;.",
                  "ziggeoaudioplayer.audio-rejected": "&#x62A;&#x645; &#x631;&#x641;&#x636; &#x627;&#x644;&#x635;&#x648;&#x62A;.",
                  "ziggeoaudioplayer.audio-processing": "&#x627;&#x644;&#x635;&#x648;&#x62A; &#x642;&#x64A;&#x62F; &#x627;&#x644;&#x645;&#x639;&#x627;&#x644;&#x62C;&#x629; - &#x62A;&#x631;&#x642;&#x628;&#x648;&#x627;.",
                  "ziggeoaudioplayer.audio-access-error": "&#x627;&#x644;&#x635;&#x648;&#x62A; &#x62D;&#x627;&#x644;&#x64A;&#x627; &#x62A;&#x62D;&#x62A; &#x627;&#x644;&#x625;&#x634;&#x631;&#x627;&#x641;. &#x64A;&#x645;&#x643;&#x646;&#x643; &#x627;&#x644;&#x646;&#x642;&#x631; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;.",
                  "ziggeoimageviewer.image-not-found": "&#x644;&#x645; &#x646;&#x62A;&#x645;&#x643;&#x646; &#x645;&#x646; &#x627;&#x644;&#x639;&#x62B;&#x648;&#x631; &#x639;&#x644;&#x649; &#x645;&#x644;&#x641; &#x627;&#x644;&#x635;&#x648;&#x631;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x62F;&#x62F;.",
                  "ziggeoimageviewer.image-access-forbidden": "&#x644;&#x627; &#x64A;&#x633;&#x645;&#x62D; &#x644;&#x643; &#x644;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x645;&#x644;&#x641; &#x627;&#x644;&#x635;&#x648;&#x631;&#x629; &#x647;&#x630;&#x627;.",
                  "ziggeoimageviewer.image-unknown-error": "&#x644;&#x627; &#x64A;&#x645;&#x643;&#x646;&#x646;&#x627; &#x627;&#x644;&#x648;&#x635;&#x648;&#x644; &#x625;&#x644;&#x649; &#x647;&#x630;&#x647; &#x627;&#x644;&#x635;&#x648;&#x631;&#x629; &#x641;&#x64A; &#x627;&#x644;&#x648;&#x642;&#x62A; &#x627;&#x644;&#x62D;&#x627;&#x644;&#x64A;. &#x627;&#x644;&#x631;&#x62C;&#x627;&#x621; &#x645;&#x639;&#x627;&#x648;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629; &#x641;&#x64A; &#x648;&#x642;&#x62A; &#x644;&#x627;&#x62D;&#x642;.",
                  "ziggeoimageviewer.image-rejected": "&#x62A;&#x645; &#x631;&#x641;&#x636; &#x627;&#x644;&#x635;&#x648;&#x631;&#x629;.",
                  "ziggeoimageviewer.image-processing": "&#x627;&#x644;&#x635;&#x648;&#x631;&#x629; &#x642;&#x64A;&#x62F; &#x627;&#x644;&#x645;&#x639;&#x627;&#x644;&#x62C;&#x629; - &#x62A;&#x631;&#x642;&#x628;&#x648;&#x627;.",
                  "ziggeoimageviewer.image-access-error": "&#x627;&#x644;&#x635;&#x648;&#x631;&#x629; &#x642;&#x64A;&#x62F; &#x627;&#x644;&#x627;&#x639;&#x62A;&#x62F;&#x627;&#x644; &#x62D;&#x627;&#x644;&#x64A;&#x627;. &#x64A;&#x645;&#x643;&#x646;&#x643; &#x627;&#x644;&#x646;&#x642;&#x631; &#x644;&#x625;&#x639;&#x627;&#x62F;&#x629; &#x627;&#x644;&#x645;&#x62D;&#x627;&#x648;&#x644;&#x629;."
                },
                "language:az": {
                  "application.error_503": "Hal haz&#x131;rda texniki xidm&#x259;t g&#xF6;st&#x259;ririk. Video tezlikl&#x259; geri qaytar&#x131;lacaq.",
                  "application.error_404": "Sizin AP&#x130; a&#xE7;ar&#x131; m&#xFC;&#x259;yy&#x259;n ed&#x259; bilm&#x259;dik. Z&#x259;hm&#x259;t olmasa a&#xE7;ar&#x131; veb s&#x259;hif&#x259;nin ba&#x15F;l&#x131;q hiss&#x259;sind&#x259; qeyd edin.",
                  "application.error_401": "Sizin t&#x259;tbiq&#x259; bu veb s&#x259;hif&#x259;d&#x259;n daxil olman&#x131;za icaz&#x259; yoxdur.",
                  "application.error_412": "Siz&#x259; hesab&#x131;n&#x131;z&#x131; t&#x259;sdiq etm&#x259;k / y&#xFC;ks&#x259;ltm&#x259;k g&#x259;r&#x259;kdir.",
                  "application.error_unknown": "Bilinm&#x259;y&#x259;n s&#x259;hv ba&#x15F; verdi. Bizim komandaya x&#x259;b&#x259;r verildi v&#x259; m&#x259;s&#x259;l&#x259;ni h&#x259;ll etm&#x259;y&#x259; &#xE7;al&#x131;&#x15F;&#x131;r&#x131;q.",
                  "ziggeoplayer.video-not-found": "Sor&#x11F;u edilmi&#x15F; video fayl&#x131;n&#x131; tapa bilm&#x259;dik.",
                  "ziggeoplayer.video-access-forbidden": "Sizin bu video fayla daxil olmaq &#xFC;&#xE7;&#xFC;n icaz&#x259;niz yoxdur.",
                  "ziggeoplayer.video-unknown-error": "Biz hal-haz&#x131;rda bu video fayla daxil ola bilm&#x259;dik. Z&#x259;hm&#x259;t olmasa bir az sonra yenid&#x259;n c&#x259;hd edin.",
                  "ziggeoplayer.video-rejected": "Video r&#x259;dd edildi.",
                  "ziggeoplayer.video-processing": "Video emal olunur - biraz g&#xF6;zl&#x259;yin.",
                  "ziggeoplayer.video-access-error": "Video hal haz&#x131;rda emal olunur. Yenid&#x259;n yoxlamaq &#xFC;&#xE7;&#xFC;n basa bil&#x259;rsiz.",
                  "ziggeoaudioplayer.audio-not-found": "G&#xF6;st&#x259;ril&#x259;n s&#x259;s s&#x259;n&#x259;dini tapa bilm&#x259;dik.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Bu s&#x259;s s&#x259;n&#x259;din&#x259; daxil olma&#x11F;&#x131;n&#x131;za icaz&#x259; verilmir.",
                  "ziggeoaudioplayer.audio-unknown-error": "Haz&#x131;rda bu s&#x259;si &#x259;ld&#x259; ed&#x259; bilm&#x259;rik. Z&#x259;hm&#x259;t olmasa bir az sonra yen&#x259; c&#x259;hd edin.",
                  "ziggeoaudioplayer.audio-rejected": "S&#x259;s r&#x259;dd edildi.",
                  "ziggeoaudioplayer.audio-processing": "S&#x259;s i&#x15F;l&#x259;nir - bizi izl&#x259;yin.",
                  "ziggeoaudioplayer.audio-access-error": "S&#x259;s haz&#x131;rda moderasiya alt&#x131;ndad&#x131;r. Yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n klikl&#x259;y&#x259; bil&#x259;rsiniz.",
                  "ziggeoimageviewer.image-not-found": "G&#xF6;st&#x259;ril&#x259;n &#x15F;&#x259;kil s&#x259;n&#x259;dini tapa bilm&#x259;dik.",
                  "ziggeoimageviewer.image-access-forbidden": "Bu &#x15F;&#x259;kil s&#x259;n&#x259;din&#x259; daxil olma&#x11F;&#x131;n&#x131;za icaz&#x259; verilmir.",
                  "ziggeoimageviewer.image-unknown-error": "Haz&#x131;rda bu &#x15F;&#x259;kil&#x259; daxil ola bilm&#x259;rik. Z&#x259;hm&#x259;t olmasa bir az sonra yen&#x259; c&#x259;hd edin.",
                  "ziggeoimageviewer.image-rejected": "&#x15E;&#x259;kil r&#x259;dd edildi.",
                  "ziggeoimageviewer.image-processing": "&#x15E;&#x259;kil i&#x15F;l&#x259;nir - bizi izl&#x259;yin.",
                  "ziggeoimageviewer.image-access-error": "&#x15E;&#x259;kil haz&#x131;rda moderasiya alt&#x131;ndad&#x131;r. Yenid&#x259;n c&#x259;hd etm&#x259;k &#xFC;&#xE7;&#xFC;n klikl&#x259;y&#x259; bil&#x259;rsiniz."
                },
                "language:bg": {
                  "application.error_503": "&#x41D;&#x438;&#x435; &#x43F;&#x43E;&#x434;&#x434;&#x44A;&#x440;&#x436;&#x430;&#x43C;&#x435; &#x43D;&#x430;&#x448;&#x430;&#x442;&#x430; &#x443;&#x441;&#x43B;&#x443;&#x433;&#x430;. &#x412;&#x438;&#x434;&#x435;&#x43E; &#x449;&#x435; &#x441;&#x435; &#x432;&#x44A;&#x440;&#x43D;&#x435; &#x441;&#x43A;&#x43E;&#x440;&#x43E;.",
                  "application.error_404": "&#x41D;&#x438;&#x435; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x440;&#x430;&#x437;&#x43F;&#x43E;&#x437;&#x43D;&#x430;&#x435; &#x432;&#x430;&#x448;&#x438;&#x44F; &#x43A;&#x43B;&#x44E;&#x447; API. &#x41C;&#x43E;&#x43B;&#x44F;, &#x43D;&#x435; &#x437;&#x430;&#x431;&#x440;&#x430;&#x432;&#x44F;&#x439;&#x442;&#x435; &#x434;&#x430; &#x433;&#x43E; &#x43F;&#x43E;&#x441;&#x43E;&#x447;&#x438;&#x442;&#x435; &#x432; &#x437;&#x430;&#x433;&#x43B;&#x430;&#x432;&#x43A;&#x430;&#x442;&#x430; &#x43D;&#x430; &#x443;&#x435;&#x431;&#x441;&#x430;&#x439;&#x442;&#x430; &#x441;&#x438;.",
                  "application.error_401": "&#x41D;&#x435; &#x435; &#x440;&#x430;&#x437;&#x440;&#x435;&#x448;&#x435;&#x43D;&#x43E; &#x437;&#x430; &#x434;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x434;&#x43E; &#x43F;&#x440;&#x438;&#x43B;&#x43E;&#x436;&#x435;&#x43D;&#x438;&#x435;&#x442;&#x43E; &#x43E;&#x442; &#x442;&#x43E;&#x437;&#x438; &#x441;&#x430;&#x439;&#x442;.",
                  "application.error_412": "&#x422;&#x440;&#x44F;&#x431;&#x432;&#x430; &#x434;&#x430; &#x43F;&#x43E;&#x442;&#x432;&#x44A;&#x440;&#x434;&#x438;&#x442;&#x435; / &#x44A;&#x43F;&#x433;&#x440;&#x435;&#x439;&#x434; &#x432;&#x430;&#x448;&#x438;&#x44F; &#x430;&#x43A;&#x430;&#x443;&#x43D;&#x442;.",
                  "application.error_unknown": "&#x412;&#x44A;&#x437;&#x43D;&#x438;&#x43A;&#x43D;&#x430; &#x43D;&#x435;&#x438;&#x437;&#x432;&#x435;&#x441;&#x442;&#x43D;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430;. &#x41D;&#x430;&#x448;&#x438;&#x44F;&#x442; &#x435;&#x43A;&#x438;&#x43F; &#x435; &#x431;&#x438;&#x43B; &#x443;&#x432;&#x435;&#x434;&#x43E;&#x43C;&#x435;&#x43D; &#x438; &#x449;&#x435; &#x440;&#x435;&#x448;&#x438; &#x43F;&#x440;&#x43E;&#x431;&#x43B;&#x435;&#x43C;&#x430;.",
                  "ziggeoplayer.video-not-found": "&#x41D;&#x438;&#x435; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435; &#x434;&#x430; &#x43D;&#x430;&#x43C;&#x435;&#x440;&#x438; &#x434;&#x430;&#x434;&#x435;&#x43D; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x444;&#x430;&#x439;&#x43B;.",
                  "ziggeoplayer.video-access-forbidden": "&#x41D;&#x44F;&#x43C;&#x430;&#x442;&#x435; &#x43F;&#x440;&#x430;&#x432;&#x43E; &#x43D;&#x430; &#x434;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x434;&#x43E; &#x442;&#x430;&#x437;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x444;&#x430;&#x439;&#x43B;.",
                  "ziggeoplayer.video-unknown-error": "&#x41D;&#x438;&#x435; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x43C; &#x434;&#x430; &#x43F;&#x43E;&#x43B;&#x443;&#x447;&#x438;&#x442;&#x435; &#x434;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x434;&#x43E; &#x442;&#x43E;&#x437;&#x438; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x43A;&#x43B;&#x438;&#x43F; &#x432; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442;&#x430;. &#x41C;&#x43E;&#x43B;&#x44F;, &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x439;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;-&#x43A;&#x44A;&#x441;&#x43D;&#x43E;.",
                  "ziggeoplayer.video-rejected": "&#x412;&#x438;&#x434;&#x435;&#x43E;&#x442;&#x43E; &#x435; &#x431;&#x438;&#x43B;&#x43E; &#x43E;&#x442;&#x445;&#x432;&#x44A;&#x440;&#x43B;&#x435;&#x43D;&#x43E;.",
                  "ziggeoplayer.video-processing": "&#x412;&#x438;&#x434;&#x435;&#x43E;&#x442;&#x43E; &#x435; &#x43E;&#x431;&#x440;&#x430;&#x431;&#x43E;&#x442;&#x43A;&#x430; - &#x43E;&#x441;&#x442;&#x430;&#x43D;&#x435;&#x442;&#x435; &#x43D;&#x430; &#x43B;&#x438;&#x43D;&#x438;&#x44F;.",
                  "ziggeoplayer.video-access-error": "&#x412;&#x438;&#x434;&#x435;&#x43E;&#x442;&#x43E; &#x435; &#x432; &#x43F;&#x440;&#x43E;&#x446;&#x435;&#x441; &#x43D;&#x430; &#x443;&#x43C;&#x435;&#x440;&#x435;&#x43D;&#x43E;&#x441;&#x442;. &#x41C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x434;&#x430; &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ziggeoaudioplayer.audio-not-found": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x430;&#x445;&#x43C;&#x435; &#x434;&#x430; &#x43D;&#x430;&#x43C;&#x435;&#x440;&#x438;&#x43C; &#x43F;&#x43E;&#x441;&#x43E;&#x447;&#x435;&#x43D;&#x438;&#x44F; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x444;&#x430;&#x439;&#x43B;.",
                  "ziggeoaudioplayer.audio-access-forbidden": "&#x41D;&#x44F;&#x43C;&#x430;&#x442;&#x435; &#x434;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x434;&#x43E; &#x442;&#x43E;&#x437;&#x438; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x444;&#x430;&#x439;&#x43B;.",
                  "ziggeoaudioplayer.audio-unknown-error": "&#x412; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442;&#x430; &#x43D;&#x44F;&#x43C;&#x430;&#x43C;&#x435; &#x434;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x434;&#x43E; &#x442;&#x43E;&#x432;&#x430; &#x430;&#x443;&#x434;&#x438;&#x43E;. &#x41C;&#x43E;&#x43B;&#x44F;, &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x439;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;-&#x43A;&#x44A;&#x441;&#x43D;&#x43E;.",
                  "ziggeoaudioplayer.audio-rejected": "&#x410;&#x443;&#x434;&#x438;&#x43E;&#x442;&#x43E; &#x435; &#x43E;&#x442;&#x445;&#x432;&#x44A;&#x440;&#x43B;&#x435;&#x43D;&#x43E;.",
                  "ziggeoaudioplayer.audio-processing": "&#x410;&#x443;&#x434;&#x438;&#x43E;&#x442;&#x43E; &#x441;&#x435; &#x43E;&#x431;&#x440;&#x430;&#x431;&#x43E;&#x442;&#x432;&#x430; - &#x441;&#x43B;&#x435;&#x434;&#x435;&#x442;&#x435;.",
                  "ziggeoaudioplayer.audio-access-error": "&#x412; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442;&#x430; &#x430;&#x443;&#x434;&#x438;&#x43E;&#x442;&#x43E; &#x435; &#x43F;&#x43E;&#x434; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x430;&#x446;&#x438;&#x44F;. &#x41C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x434;&#x430; &#x449;&#x440;&#x430;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ziggeoimageviewer.image-not-found": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x430;&#x445;&#x43C;&#x435; &#x434;&#x430; &#x43D;&#x430;&#x43C;&#x435;&#x440;&#x438;&#x43C; &#x43F;&#x43E;&#x441;&#x43E;&#x447;&#x435;&#x43D;&#x438;&#x44F; &#x444;&#x430;&#x439;&#x43B; &#x441; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435;.",
                  "ziggeoimageviewer.image-access-forbidden": "&#x41D;&#x44F;&#x43C;&#x430;&#x442;&#x435; &#x434;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x434;&#x43E; &#x442;&#x43E;&#x437;&#x438; &#x444;&#x430;&#x439;&#x43B; &#x441; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x44F;.",
                  "ziggeoimageviewer.image-unknown-error": "&#x412; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442;&#x430; &#x43D;&#x44F;&#x43C;&#x430;&#x43C;&#x435; &#x434;&#x43E;&#x441;&#x442;&#x44A;&#x43F; &#x434;&#x43E; &#x442;&#x43E;&#x432;&#x430; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435;. &#x41C;&#x43E;&#x43B;&#x44F;, &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x439;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E; &#x43F;&#x43E;-&#x43A;&#x44A;&#x441;&#x43D;&#x43E;.",
                  "ziggeoimageviewer.image-rejected": "&#x418;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435;&#x442;&#x43E; &#x435; &#x43E;&#x442;&#x445;&#x432;&#x44A;&#x440;&#x43B;&#x435;&#x43D;&#x43E;.",
                  "ziggeoimageviewer.image-processing": "&#x418;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435;&#x442;&#x43E; &#x441;&#x435; &#x43E;&#x431;&#x440;&#x430;&#x431;&#x43E;&#x442;&#x432;&#x430; - &#x441;&#x43B;&#x435;&#x434;&#x435;&#x442;&#x435;.",
                  "ziggeoimageviewer.image-access-error": "&#x412; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442;&#x430; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435;&#x442;&#x43E; &#x435; &#x43F;&#x43E;&#x434; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x430;&#x446;&#x438;&#x44F;. &#x41C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x434;&#x430; &#x449;&#x440;&#x430;&#x43A;&#x43D;&#x435;&#x442;&#x435;, &#x437;&#x430; &#x434;&#x430; &#x43E;&#x43F;&#x438;&#x442;&#x430;&#x442;&#x435; &#x43E;&#x442;&#x43D;&#x43E;&#x432;&#x43E;."
                },
                "language:cat": {
                  "application.error_503": "Estem mantenint el nostre servei. V&#xED;deos estaran de tornada aviat.",
                  "application.error_404": "No podem recon&#xE8;ixer la clau d&#x27;API. Si us plau assegureu-vos d&#x27;especificar que a la cap&#xE7;alera de la seva p&#xE0;gina web.",
                  "application.error_401": "No se li permet accedir a l&#x27;aplicaci&#xF3; des d&#x27;aquest lloc.",
                  "application.error_412": "Cal confirmar / actualitzar el seu compte.",
                  "application.error_unknown": "S&#x27;ha produ&#xEF;t un error desconegut. El nostre equip ha estat notificat i resoldr&#xE0; el problema.",
                  "ziggeoplayer.video-not-found": "No hem trobat el fitxer de v&#xED;deo especificat.",
                  "ziggeoplayer.video-access-forbidden": "No se li permet accedir a aquest arxiu de v&#xED;deo.",
                  "ziggeoplayer.video-unknown-error": "No podem accedir a aquest v&#xED;deo en el moment. Siusplau, intenta-ho m&#xE9;s tard.",
                  "ziggeoplayer.video-rejected": "El v&#xED;deo ha estat rebutjat.",
                  "ziggeoplayer.video-processing": "El v&#xED;deo est&#xE0; processant - estigueu atents.",
                  "ziggeoplayer.video-access-error": "El v&#xED;deo est&#xE0; actualment a la moderaci&#xF3;. Podeu fer clic per tornar a intentar-ho.",
                  "ziggeoaudioplayer.audio-not-found": "No hem pogut trobar el fitxer d&#x27;&#xE0;udio especificat.",
                  "ziggeoaudioplayer.audio-access-forbidden": "No teniu perm&#xED;s per accedir a aquest fitxer d&#x27;&#xE0;udio.",
                  "ziggeoaudioplayer.audio-unknown-error": "De moment no podem accedir a aquest &#xE0;udio. Siusplau, intenta-ho m&#xE9;s tard.",
                  "ziggeoaudioplayer.audio-rejected": "S&#x27;ha rebutjat l&#x27;&#xE0;udio.",
                  "ziggeoaudioplayer.audio-processing": "L&#x2019;&#xE0;udio s&#x2019;est&#xE0; processant. Estigueu atents.",
                  "ziggeoaudioplayer.audio-access-error": "Actualment l&#x2019;&#xE0;udio est&#xE0; moderat. Podeu fer clic per tornar-ho a provar.",
                  "ziggeoimageviewer.image-not-found": "No hem pogut trobar el fitxer d&#x27;imatge especificat.",
                  "ziggeoimageviewer.image-access-forbidden": "No teniu perm&#xED;s per accedir a aquest fitxer d&#x27;imatge.",
                  "ziggeoimageviewer.image-unknown-error": "De moment no podem accedir a aquesta imatge. Siusplau, intenta-ho m&#xE9;s tard.",
                  "ziggeoimageviewer.image-rejected": "La imatge ha estat rebutjada.",
                  "ziggeoimageviewer.image-processing": "La imatge s&#x27;est&#xE0; processant; estigueu atents.",
                  "ziggeoimageviewer.image-access-error": "Actualment, la imatge est&#xE0; moderada. Podeu fer clic per tornar-ho a provar."
                },
                "language:cs": {
                  "application.error_503": "Moment&#xE1;ln&#x11B; na slu&#x17E;b&#x11B; pracujeme, zkuste to pros&#xED;m za chv&#xED;li.",
                  "application.error_404": "Nepoda&#x159;ilo se rozpoznat V&#xE1;&#x161; api kl&#xED;&#x10D;. Zkontrolujte pros&#xED;m, &#x17E;e je uveden v hlavi&#x10D;ce Va&#x161;&#xED; webov&#xE9; str&#xE1;nky.",
                  "application.error_401": "Z t&#xE9;to str&#xE1;nky nem&#xE1;te povolen p&#x159;&#xED;stup k aplikaci.",
                  "application.error_412": "Mus&#xED;te potvrdit / upgradovat sv&#x16F;j &#xFA;&#x10D;et.",
                  "application.error_unknown": "Nastala neo&#x10D;ek&#xE1;van&#xE1; chyba. N&#xE1;&#x161; t&#xFD;m byl informov&#xE1;n a pokus&#xED; se tento probl&#xE9;m brzy vy&#x159;e&#x161;it.",
                  "ziggeoaudioplayer.audio-not-found": "Nepoda&#x159;ilo se naj&#xED;t specifikovan&#xFD; audio soubor.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Nem&#xE1;te p&#x159;&#xED;stup k tomuto audio souboru.",
                  "ziggeoaudioplayer.audio-unknown-error": "Moment&#xE1;ln&#x11B; se n&#xE1;m z&#xED;skat toto audio. Zkuste to pros&#xED;m za chv&#xED;li.",
                  "ziggeoaudioplayer.audio-rejected": "Toto audio bylo zam&#xED;tnut&#xE9;.",
                  "ziggeoaudioplayer.audio-processing": "Toto audio se zpracov&#xE1;v&#xE1; - vy&#x10D;kejte pros&#xED;m.",
                  "ziggeoaudioplayer.audio-access-error": "Toto audio &#x10D;ek&#xE1; na schv&#xE1;len&#xED;. M&#x16F;&#x17E;ete kliknout a zkusit to znovu.",
                  "ziggeoimageviewer.image-not-found": "Nepoda&#x159;ilo se n&#xE1;m naj&#xED;t specifikovan&#xFD; obr&#xE1;zek.",
                  "ziggeoimageviewer.image-access-forbidden": "Nem&#xE1;te p&#x159;&#xED;stup k tomuto obr&#xE1;zku.",
                  "ziggeoimageviewer.image-unknown-error": "Nepoda&#x159;ilo se n&#xE1;m z&#xED;skat tento obr&#xE1;zek. Zkuste to pros&#xED;m za chv&#xED;li.",
                  "ziggeoimageviewer.image-rejected": "Obr&#xE1;zek byl zam&#xED;tnut.",
                  "ziggeoimageviewer.image-processing": "Obr&#xE1;zek se zpracov&#xE1;v&#xE1; - vy&#x10D;kejte pros&#xED;m.",
                  "ziggeoimageviewer.image-access-error": "Tento obr&#xE1;zek &#x10D;ek&#xE1; na schv&#xE1;len&#xED;. M&#x16F;&#x17E;ete kliknout a zkusit to znovu.",
                  "ziggeoplayer.video-not-found": "Nepoda&#x159;ilo se naj&#xED;t video.",
                  "ziggeoplayer.video-access-forbidden": "Nem&#xE1;te p&#x159;&#xED;stup k tomuto video souboru.",
                  "ziggeoplayer.video-unknown-error": "Moment&#xE1;ln&#x11B; se n&#xE1;m z&#xED;skat toto video. Zkuste to pros&#xED;m za chv&#xED;li.",
                  "ziggeoplayer.video-rejected": "Toto video bylo zam&#xED;tnut&#xE9;.",
                  "ziggeoplayer.video-processing": "Toto video se zpracov&#xE1;v&#xE1; - vy&#x10D;kejte pros&#xED;m.",
                  "ziggeoplayer.video-access-error": "Toto video &#x10D;ek&#xE1; na schv&#xE1;len&#xED;. M&#x16F;&#x17E;ete kliknout a zkusit to znovu."
                },
                "language:da": {
                  "application.error_503": "Vi fastholder vores service. Videoer er snart tilbage.",
                  "application.error_404": "Vi kan ikke genkende din API n&#xF8;gle. S&#xF8;rg for at angive det i din hjemmeside overskrift.",
                  "application.error_401": "Du har ikke tilladelse til at f&#xE5; adgang til programmet fra dette site.",
                  "application.error_412": "Du skal bekr&#xE6;fte / opgradere din konto.",
                  "application.error_unknown": "En ukendt fejl opstod. Vores hold er blevet anmeldt og vil l&#xF8;se problemet.",
                  "ziggeoplayer.video-not-found": "Vi kunne ikke finde den angivne videofil.",
                  "ziggeoplayer.video-access-forbidden": "Det er ikke tilladt at f&#xE5; adgang til denne video-fil.",
                  "ziggeoplayer.video-unknown-error": "Vi kan ikke f&#xE5; adgang til denne video i &#xF8;jeblikket. Pr&#xF8;v igen senere.",
                  "ziggeoplayer.video-rejected": "Videoen er blevet afvist.",
                  "ziggeoplayer.video-processing": "Videoen behandles - Stay tuned.",
                  "ziggeoplayer.video-access-error": "Videoen er i &#xF8;jeblikket under moderation. Du kan klikke for at pr&#xF8;ve igen.",
                  "ziggeoaudioplayer.audio-not-found": "Vi kunne ikke finde den angivne lydfil.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Du har ikke adgang til denne lydfil.",
                  "ziggeoaudioplayer.audio-unknown-error": "Vi kan ikke f&#xE5; adgang til denne lyd i &#xF8;jeblikket. Pr&#xF8;v igen senere.",
                  "ziggeoaudioplayer.audio-rejected": "Lyden er blevet afvist.",
                  "ziggeoaudioplayer.audio-processing": "Lyden behandles - hold dig opdateret.",
                  "ziggeoaudioplayer.audio-access-error": "Lyden er i &#xF8;jeblikket under moderering. Du kan klikke for at pr&#xF8;ve igen.",
                  "ziggeoimageviewer.image-not-found": "Vi kunne ikke finde den angivne billedfil.",
                  "ziggeoimageviewer.image-access-forbidden": "Du har ikke adgang til denne billedfil.",
                  "ziggeoimageviewer.image-unknown-error": "Vi kan ikke f&#xE5; adgang til dette billede i &#xF8;jeblikket. Pr&#xF8;v igen senere.",
                  "ziggeoimageviewer.image-rejected": "Billedet er afvist.",
                  "ziggeoimageviewer.image-processing": "Billedet behandles - hold dig opdateret.",
                  "ziggeoimageviewer.image-access-error": "Billedet er i &#xF8;jeblikket under moderering. Du kan klikke for at pr&#xF8;ve igen."
                },
                "language:de": {
                  "application.error_503": "Das System wird gerade gewartet. Die Videofunktion ist in K&#xFC;rze wieder aktiv.",
                  "application.error_404": "Der API Schl&#xFC;ssel wurde nicht gefunden. Bitte &#xFC;berpr&#xFC;fen.",
                  "application.error_401": "Der Zugriff auf die Applikation wurde verweigert.",
                  "application.error_412": "Ihr Account muss best&#xE4;tigt bzw. f&#xFC;r weitere Videos freigeschaltet werden.",
                  "application.error_unknown": "Ein unbekannter Fehler ist aufgetreten. Unser Team wurde dar&#xFC;ber informiert und wird das Problem l&#xF6;sen.",
                  "ziggeoaudioplayer.audio-not-found": "Das angegebene Audio konnte nicht gefunden werden.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Der Zugriff auf das angegebene Audio wurde verweigert.",
                  "ziggeoaudioplayer.audio-unknown-error": "Auf das angegebene Audio kann zur Zeit nicht zugegriffen werden. Bitte zu einem sp&#xE4;teren Zeitpunkt erneut versuchen.",
                  "ziggeoaudioplayer.audio-rejected": "Das Audio wurde nicht freigegeben.",
                  "ziggeoaudioplayer.audio-processing": "Das Audio wird gerade verarbeitet, bitte kurz warten.",
                  "ziggeoaudioplayer.audio-access-error": "Das Audio wird gerade moderiert, bitte etwas sp&#xE4;ter erneut versuchen.",
                  "ziggeoimageviewer.image-not-found": "Das angegebene Bild konnte nicht gefunden werden.",
                  "ziggeoimageviewer.image-access-forbidden": "Der Zugriff auf das angegebene Bild wurde verweigert.",
                  "ziggeoimageviewer.image-unknown-error": "Auf das angegebene Bild kann zur Zeit nicht zugegriffen werden. Bitte zu einem sp&#xE4;teren Zeitpunkt erneut versuchen.",
                  "ziggeoimageviewer.image-rejected": "Das Bild wurde nicht freigegeben.",
                  "ziggeoimageviewer.image-processing": "Das Bild wird gerade verarbeitet, bitte kurz warten.",
                  "ziggeoimageviewer.image-access-error": "Das Bild wird gerade moderiert, bitte etwas sp&#xE4;ter erneut versuchen.",
                  "ziggeoplayer.video-not-found": "Das angegebene Video konnte nicht gefunden werden.",
                  "ziggeoplayer.video-access-forbidden": "Der Zugriff auf das angegebene Video wurde verweigert.",
                  "ziggeoplayer.video-unknown-error": "Auf das angegebene Video kann zur Zeit nicht zugegriffen werden. Bitte zu einem sp&#xE4;teren Zeitpunkt erneut versuchen.",
                  "ziggeoplayer.video-rejected": "Das Video wurde nicht freigegeben.",
                  "ziggeoplayer.video-processing": "Das Video wird gerade verarbeitet, bitte kurz warten.",
                  "ziggeoplayer.video-access-error": "Das Video wird gerade moderiert, bitte etwas sp&#xE4;ter erneut versuchen."
                },
                "language:el": {
                  "application.error_503": "&#x3A0;&#x3C1;&#x3B1;&#x3B3;&#x3BC;&#x3B1;&#x3C4;&#x3BF;&#x3C0;&#x3BF;&#x3B9;&#x3BF;&#x3CD;&#x3BC;&#x3B5; &#x3B5;&#x3C1;&#x3B3;&#x3B1;&#x3C3;&#x3AF;&#x3B5;&#x3C2; &#x3C3;&#x3C5;&#x3BD;&#x3C4;&#x3AE;&#x3C1;&#x3B7;&#x3C3;&#x3B7;&#x3C2;. &#x3A4;&#x3B1; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF; &#x3B8;&#x3B1; &#x3B5;&#x3C0;&#x3B1;&#x3BD;&#x3AD;&#x3BB;&#x3B8;&#x3BF;&#x3C5;&#x3BD; &#x3C3;&#x3CD;&#x3BD;&#x3C4;&#x3BF;&#x3BC;&#x3B1;.",
                  "application.error_404": "&#x394;&#x3B5;&#x3BD; &#x3BC;&#x3C0;&#x3BF;&#x3C1;&#x3BF;&#x3CD;&#x3BC;&#x3B5; &#x3BD;&#x3B1; &#x3B1;&#x3BD;&#x3B1;&#x3B3;&#x3C9;&#x3C1;&#x3AF;&#x3C3;&#x3BF;&#x3C5;&#x3BC;&#x3B5; &#x3C4;&#x3BF; &#x3BA;&#x3BB;&#x3B5;&#x3B9;&#x3B4;&#x3AF; &#x3C3;&#x3B1;&#x3C2; &#x3B3;&#x3B9;&#x3B1; &#x3C4;&#x3BF; api. &#x3A0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3B1;&#x3BB;&#x3BF;&#x3CD;&#x3BC;&#x3B5; &#x3B2;&#x3B5;&#x3B2;&#x3B1;&#x3B9;&#x3C9;&#x3B8;&#x3B5;&#x3AF;&#x3C4;&#x3B5; &#x3CC;&#x3C4;&#x3B9; &#x3C4;&#x3BF; &#x3AD;&#x3C7;&#x3B5;&#x3C4;&#x3B5; &#x3BF;&#x3C1;&#x3AF;&#x3C3;&#x3B5;&#x3B9; &#x3C3;&#x3C4;&#x3B7;&#x3BD; &#x3B5;&#x3C0;&#x3B9;&#x3BA;&#x3B5;&#x3C6;&#x3B1;&#x3BB;&#x3AF;&#x3B4;&#x3B1; &#x3C4;&#x3B7;&#x3C2; &#x3B9;&#x3C3;&#x3C4;&#x3BF;&#x3C3;&#x3B5;&#x3BB;&#x3AF;&#x3B4;&#x3B1;&#x3C2; &#x3C3;&#x3B1;&#x3C2;.",
                  "application.error_401": "&#x394;&#x3B5;&#x3BD; &#x3B5;&#x3C0;&#x3B9;&#x3C4;&#x3C1;&#x3AD;&#x3C0;&#x3B5;&#x3C4;&#x3B1;&#x3B9; &#x3B7; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3C4;&#x3B7;&#x3BD; &#x3B5;&#x3C6;&#x3B1;&#x3C1;&#x3BC;&#x3BF;&#x3B3;&#x3AE; &#x3B1;&#x3C0;&#x3CC; &#x3B1;&#x3C5;&#x3C4;&#x3CC; &#x3C4;&#x3BF; site.",
                  "application.error_412": "&#x3A0;&#x3C1;&#x3AD;&#x3C0;&#x3B5;&#x3B9; &#x3BD;&#x3B1; &#x3B5;&#x3C0;&#x3B9;&#x3B2;&#x3B5;&#x3B2;&#x3B1;&#x3B9;&#x3CE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; / &#x3B1;&#x3BD;&#x3B1;&#x3B2;&#x3B1;&#x3B8;&#x3BC;&#x3AF;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3C4;&#x3BF;&#x3BD; &#x3BB;&#x3BF;&#x3B3;&#x3B1;&#x3C1;&#x3B9;&#x3B1;&#x3C3;&#x3BC;&#x3CC; &#x3C3;&#x3B1;&#x3C2;.",
                  "application.error_unknown": "&#x3A3;&#x3C5;&#x3BD;&#x3AD;&#x3B2;&#x3B5;&#x3B9; &#x3AD;&#x3BD;&#x3B1; &#x3AC;&#x3B3;&#x3BD;&#x3C9;&#x3C3;&#x3C4;&#x3BF; &#x3BB;&#x3AC;&#x3B8;&#x3BF;&#x3C2;. &#x397; &#x3BF;&#x3BC;&#x3AC;&#x3B4;&#x3B1; &#x3BC;&#x3B1;&#x3C2; &#x3AD;&#x3C7;&#x3B5;&#x3B9; &#x3B5;&#x3B9;&#x3B4;&#x3BF;&#x3C0;&#x3BF;&#x3B9;&#x3B7;&#x3B8;&#x3B5;&#x3AF; &#x3BA;&#x3B1;&#x3B9; &#x3B8;&#x3B1; &#x3B5;&#x3C0;&#x3B9;&#x3BB;&#x3CD;&#x3C3;&#x3B5;&#x3B9; &#x3C4;&#x3BF; &#x3C0;&#x3C1;&#x3CC;&#x3B2;&#x3BB;&#x3B7;&#x3BC;&#x3B1;.",
                  "ziggeoplayer.video-not-found": "&#x394;&#x3B5;&#x3BD; &#x3BC;&#x3C0;&#x3BF;&#x3C1;&#x3AD;&#x3C3;&#x3B1;&#x3BC;&#x3B5; &#x3BD;&#x3B1; &#x3B2;&#x3C1;&#x3BF;&#x3CD;&#x3BC;&#x3B5; &#x3C4;&#x3BF; &#x3C3;&#x3C5;&#x3B3;&#x3BA;&#x3B5;&#x3BA;&#x3C1;&#x3B9;&#x3BC;&#x3AD;&#x3BD;&#x3BF; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF;.",
                  "ziggeoplayer.video-access-forbidden": "&#x394;&#x3B5;&#x3BD; &#x3C3;&#x3B1;&#x3C2; &#x3B5;&#x3C0;&#x3B9;&#x3C4;&#x3C1;&#x3AD;&#x3C0;&#x3B5;&#x3C4;&#x3B1;&#x3B9; &#x3B7; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3B5; &#x3B1;&#x3C5;&#x3C4;&#x3CC; &#x3C4;&#x3BF; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF;.",
                  "ziggeoplayer.video-unknown-error": "&#x391;&#x3C5;&#x3C4;&#x3BB;&#x3B7; &#x3C4;&#x3B7; &#x3C3;&#x3C4;&#x3B9;&#x3B3;&#x3BC;&#x3AE; &#x3B4;&#x3B5;&#x3BD; &#x3B5;&#x3AF;&#x3BD;&#x3B1;&#x3B9; &#x3B4;&#x3C5;&#x3BD;&#x3B1;&#x3C4;&#x3AE; &#x3B7; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3B5; &#x3B1;&#x3C5;&#x3C4;&#x3BF; &#x3C4;&#x3BF; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF;. &#x3A0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3B1;&#x3BB;&#x3BF;&#x3CD;&#x3BC;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3C4;&#x3B5; &#x3B1;&#x3C1;&#x3B3;&#x3CC;&#x3C4;&#x3B5;&#x3C1;&#x3B1;.",
                  "ziggeoplayer.video-rejected": "&#x3A4;&#x3BF; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF; &#x3B1;&#x3C0;&#x3BF;&#x3C1;&#x3C1;&#x3AF;&#x3C6;&#x3B8;&#x3B7;&#x3BA;&#x3B5;.",
                  "ziggeoplayer.video-processing": "&#x393;&#x3AF;&#x3BD;&#x3B5;&#x3C4;&#x3B1;&#x3B9; &#x3B5;&#x3C0;&#x3B5;&#x3BE;&#x3B5;&#x3C1;&#x3B3;&#x3B1;&#x3C3;&#x3AF;&#x3B1; &#x3C4;&#x3BF;&#x3C5; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF;. &#x3A0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3B1;&#x3BB;&#x3CE; &#x3C0;&#x3B5;&#x3C1;&#x3B9;&#x3BC;&#x3AD;&#x3BD;&#x3B5;&#x3C4;&#x3B5;.",
                  "ziggeoplayer.video-access-error": "&#x3A4;&#x3BF; &#x3B2;&#x3AF;&#x3BD;&#x3C4;&#x3B5;&#x3BF; &#x3B5;&#x3BB;&#x3AD;&#x3B3;&#x3C7;&#x3B5;&#x3C4;&#x3B1;&#x3B9; &#x3C9;&#x3C2; &#x3C0;&#x3C1;&#x3BF;&#x3C2; &#x3C4;&#x3BF; &#x3C0;&#x3B5;&#x3C1;&#x3B9;&#x3B5;&#x3C7;&#x3CC;&#x3BC;&#x3B5;&#x3BD;&#x3CC; &#x3C4;&#x3BF;&#x3C5;. &#x39C;&#x3C0;&#x3BF;&#x3C1;&#x3B5;&#x3AF;&#x3C4;&#x3B5; &#x3BD;&#x3B1; &#x3BA;&#x3AC;&#x3BD;&#x3B5;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3BE;&#x3B1;&#x3BD;&#x3B1;&#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3C4;&#x3B5;.",
                  "ziggeoaudioplayer.audio-not-found": "&#x394;&#x3B5;&#x3BD; &#x3AE;&#x3C4;&#x3B1;&#x3BD; &#x3B4;&#x3C5;&#x3BD;&#x3B1;&#x3C4;&#x3AE; &#x3B7; &#x3B5;&#x3CD;&#x3C1;&#x3B5;&#x3C3;&#x3B7; &#x3C4;&#x3BF;&#x3C5; &#x3BA;&#x3B1;&#x3B8;&#x3BF;&#x3C1;&#x3B9;&#x3C3;&#x3BC;&#x3AD;&#x3BD;&#x3BF;&#x3C5; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF;&#x3C5; &#x3AE;&#x3C7;&#x3BF;&#x3C5;.",
                  "ziggeoaudioplayer.audio-access-forbidden": "&#x394;&#x3B5;&#x3BD; &#x3B5;&#x3C0;&#x3B9;&#x3C4;&#x3C1;&#x3AD;&#x3C0;&#x3B5;&#x3C4;&#x3B1;&#x3B9; &#x3B7; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3B5; &#x3B1;&#x3C5;&#x3C4;&#x3CC; &#x3C4;&#x3BF; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF; &#x3AE;&#x3C7;&#x3BF;&#x3C5;.",
                  "ziggeoaudioplayer.audio-unknown-error": "&#x394;&#x3B5;&#x3BD; &#x3BC;&#x3C0;&#x3BF;&#x3C1;&#x3BF;&#x3CD;&#x3BC;&#x3B5; &#x3BD;&#x3B1; &#x3B1;&#x3C0;&#x3BF;&#x3BA;&#x3C4;&#x3AE;&#x3C3;&#x3BF;&#x3C5;&#x3BC;&#x3B5; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3B5; &#x3B1;&#x3C5;&#x3C4;&#x3CC;&#x3BD; &#x3C4;&#x3BF;&#x3BD; &#x3AE;&#x3C7;&#x3BF; &#x3B1;&#x3C5;&#x3C4;&#x3AE;&#x3BD; &#x3C4;&#x3B7; &#x3C3;&#x3C4;&#x3B9;&#x3B3;&#x3BC;&#x3AE;. &#x3A0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3B1;&#x3BB;&#x3CE; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3AC;&#x3B8;&#x3B7;&#x3C3;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC; &#x3B1;&#x3C1;&#x3B3;&#x3CC;&#x3C4;&#x3B5;&#x3C1;&#x3B1;.",
                  "ziggeoaudioplayer.audio-rejected": "&#x39F; &#x3AE;&#x3C7;&#x3BF;&#x3C2; &#x3B1;&#x3C0;&#x3BF;&#x3C1;&#x3C1;&#x3AF;&#x3C6;&#x3B8;&#x3B7;&#x3BA;&#x3B5;.",
                  "ziggeoaudioplayer.audio-processing": "&#x39F; &#x3AE;&#x3C7;&#x3BF;&#x3C2; &#x3B5;&#x3C0;&#x3B5;&#x3BE;&#x3B5;&#x3C1;&#x3B3;&#x3AC;&#x3B6;&#x3B5;&#x3C4;&#x3B1;&#x3B9; - &#x3BC;&#x3B5;&#x3AF;&#x3BD;&#x3B5;&#x3C4;&#x3B5; &#x3C3;&#x3C5;&#x3BD;&#x3C4;&#x3BF;&#x3BD;&#x3B9;&#x3C3;&#x3BC;&#x3AD;&#x3BD;&#x3BF;&#x3B9;.",
                  "ziggeoaudioplayer.audio-access-error": "&#x39F; &#x3AE;&#x3C7;&#x3BF;&#x3C2; &#x3B2;&#x3C1;&#x3AF;&#x3C3;&#x3BA;&#x3B5;&#x3C4;&#x3B1;&#x3B9; &#x3C5;&#x3C0;&#x3CC; &#x3B5;&#x3C0;&#x3BF;&#x3C0;&#x3C4;&#x3B5;&#x3AF;&#x3B1;. &#x39C;&#x3C0;&#x3BF;&#x3C1;&#x3B5;&#x3AF;&#x3C4;&#x3B5; &#x3BD;&#x3B1; &#x3BA;&#x3AC;&#x3BD;&#x3B5;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;.",
                  "ziggeoimageviewer.image-not-found": "&#x394;&#x3B5;&#x3BD; &#x3AE;&#x3C4;&#x3B1;&#x3BD; &#x3B4;&#x3C5;&#x3BD;&#x3B1;&#x3C4;&#x3AE; &#x3B7; &#x3B5;&#x3CD;&#x3C1;&#x3B5;&#x3C3;&#x3B7; &#x3C4;&#x3BF;&#x3C5; &#x3BA;&#x3B1;&#x3B8;&#x3BF;&#x3C1;&#x3B9;&#x3C3;&#x3BC;&#x3AD;&#x3BD;&#x3BF;&#x3C5; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF;&#x3C5; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1;&#x3C2;.",
                  "ziggeoimageviewer.image-access-forbidden": "&#x394;&#x3B5;&#x3BD; &#x3B5;&#x3C0;&#x3B9;&#x3C4;&#x3C1;&#x3AD;&#x3C0;&#x3B5;&#x3C4;&#x3B1;&#x3B9; &#x3B7; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3B5; &#x3B1;&#x3C5;&#x3C4;&#x3CC; &#x3C4;&#x3BF; &#x3B1;&#x3C1;&#x3C7;&#x3B5;&#x3AF;&#x3BF; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1;&#x3C2;.",
                  "ziggeoimageviewer.image-unknown-error": "&#x394;&#x3B5;&#x3BD; &#x3BC;&#x3C0;&#x3BF;&#x3C1;&#x3BF;&#x3CD;&#x3BC;&#x3B5; &#x3BD;&#x3B1; &#x3AD;&#x3C7;&#x3BF;&#x3C5;&#x3BC;&#x3B5; &#x3C0;&#x3C1;&#x3CC;&#x3C3;&#x3B2;&#x3B1;&#x3C3;&#x3B7; &#x3C3;&#x3B5; &#x3B1;&#x3C5;&#x3C4;&#x3AE;&#x3BD; &#x3C4;&#x3B7;&#x3BD; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1; &#x3B1;&#x3C5;&#x3C4;&#x3AE; &#x3C4;&#x3B7; &#x3C3;&#x3C4;&#x3B9;&#x3B3;&#x3BC;&#x3AE;. &#x3A0;&#x3B1;&#x3C1;&#x3B1;&#x3BA;&#x3B1;&#x3BB;&#x3CE; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3AC;&#x3B8;&#x3B7;&#x3C3;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC; &#x3B1;&#x3C1;&#x3B3;&#x3CC;&#x3C4;&#x3B5;&#x3C1;&#x3B1;.",
                  "ziggeoimageviewer.image-rejected": "&#x397; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1; &#x3B1;&#x3C0;&#x3BF;&#x3C1;&#x3C1;&#x3AF;&#x3C6;&#x3B8;&#x3B7;&#x3BA;&#x3B5;.",
                  "ziggeoimageviewer.image-processing": "&#x397; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1; &#x3B5;&#x3C0;&#x3B5;&#x3BE;&#x3B5;&#x3C1;&#x3B3;&#x3AC;&#x3B6;&#x3B5;&#x3C4;&#x3B1;&#x3B9; - &#x3BC;&#x3B5;&#x3AF;&#x3BD;&#x3B5;&#x3C4;&#x3B5; &#x3C3;&#x3C5;&#x3BD;&#x3C4;&#x3BF;&#x3BD;&#x3B9;&#x3C3;&#x3BC;&#x3AD;&#x3BD;&#x3BF;&#x3B9;.",
                  "ziggeoimageviewer.image-access-error": "&#x397; &#x3B5;&#x3B9;&#x3BA;&#x3CC;&#x3BD;&#x3B1; &#x3B2;&#x3C1;&#x3AF;&#x3C3;&#x3BA;&#x3B5;&#x3C4;&#x3B1;&#x3B9; &#x3C5;&#x3C0;&#x3CC; &#x3B5;&#x3C0;&#x3BF;&#x3C0;&#x3C4;&#x3B5;&#x3AF;&#x3B1;. &#x39C;&#x3C0;&#x3BF;&#x3C1;&#x3B5;&#x3AF;&#x3C4;&#x3B5; &#x3BD;&#x3B1; &#x3BA;&#x3AC;&#x3BD;&#x3B5;&#x3C4;&#x3B5; &#x3BA;&#x3BB;&#x3B9;&#x3BA; &#x3B3;&#x3B9;&#x3B1; &#x3BD;&#x3B1; &#x3C0;&#x3C1;&#x3BF;&#x3C3;&#x3C0;&#x3B1;&#x3B8;&#x3AE;&#x3C3;&#x3B5;&#x3C4;&#x3B5; &#x3BE;&#x3B1;&#x3BD;&#x3AC;."
                },
                "language:es": {
                  "application.error_503": "Nuestro servicio se encuentra en mantenimiento. Los v&#xED;deos estar&#xE1;n de vuelta pronto.",
                  "application.error_404": "No podemos reconocer la clave de la API. Por favor aseg&#xFA;rese de especificarla en la cabecera de su p&#xE1;gina web.",
                  "application.error_401": "No tiene permitido acceder a la aplicaci&#xF3;n desde este sitio.",
                  "application.error_412": "Es necesario confirmar / actualizar su cuenta.",
                  "application.error_unknown": "Ocurri&#xF3; un error desconocido. Nuestro equipo ha sido notificado y resolver&#xE1; el problema.",
                  "ziggeoaudioplayer.audio-not-found": "No hemos podido encontrar el archivo de audio especificado.",
                  "ziggeoaudioplayer.audio-access-forbidden": "No se le permite acceder a este archivo de audio.",
                  "ziggeoaudioplayer.audio-unknown-error": "No podemos acceder a este audio por el momento. Por favor, int&#xE9;ntelo de nuevo m&#xE1;s tarde.",
                  "ziggeoaudioplayer.audio-rejected": "El audio ha sido rechazado.",
                  "ziggeoaudioplayer.audio-processing": "El audio est&#xE1; siendo procesado - estad atentos.",
                  "ziggeoaudioplayer.audio-access-error": "EL audio est&#xE1; actualmente en moderaci&#xF3;n. Puede hacer clic para volver a intentarlo.",
                  "ziggeoimageviewer.image-not-found": "No hemos podido encontrar el archivo de imagen especificado.",
                  "ziggeoimageviewer.image-access-forbidden": "No se le permite acceder a esta imagen.",
                  "ziggeoimageviewer.image-unknown-error": "No podemos acceder a esta imagen por el momento. Por favor, int&#xE9;ntelo de nuevo m&#xE1;s tarde.",
                  "ziggeoimageviewer.image-rejected": "La imagen ha sido rechazada.",
                  "ziggeoimageviewer.image-processing": "La imagen est&#xE1; siendo procesada - estad atentos.",
                  "ziggeoimageviewer.image-access-error": "La imagen est&#xE1; actualmente en moderaci&#xF3;n. Puede hacer clic para volver a intentarlo.",
                  "ziggeoplayer.video-not-found": "No hemos podido encontrar el archivo de v&#xED;deo especificado.",
                  "ziggeoplayer.video-access-forbidden": "No se le permite acceder a este archivo de v&#xED;deo.",
                  "ziggeoplayer.video-unknown-error": "No podemos acceder a este v&#xED;deo por el momento. Por favor, int&#xE9;ntelo de nuevo m&#xE1;s tarde.",
                  "ziggeoplayer.video-rejected": "El v&#xED;deo ha sido rechazado.",
                  "ziggeoplayer.video-processing": "El v&#xED;deo est&#xE1; siendo procesado - estad atentos.",
                  "ziggeoplayer.video-access-error": "El v&#xED;deo est&#xE1; actualmente en moderaci&#xF3;n. Puede hacer clic para volver a intentarlo."
                },
                "language:fi": {
                  "application.error_503": "Huoltokatkos. Yrit&#xE4; kohta uudestaan.",
                  "application.error_404": "Ep&#xE4;kelpo API-avain. Muista lis&#xE4;t&#xE4; se sivuston otsikkoskriptiin.",
                  "application.error_401": "Ei oikeutta k&#xE4;ytt&#xE4;&#xE4; sovellusta t&#xE4;lt&#xE4; sivustolta.",
                  "application.error_412": "Tili t&#xE4;ytyy vahvistaa tai p&#xE4;ivitt&#xE4;&#xE4;.",
                  "application.error_unknown": "Tuntematon virhe. Tiimillemme on tehty ilmoitus ja he aloittavat ongelmanratkaisun.",
                  "ziggeoaudioplayer.audio-not-found": "M&#xE4;&#xE4;ritelty&#xE4; &#xE4;&#xE4;nitiedostoa ei l&#xF6;ydy.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Ei oikeutta k&#xE4;ytt&#xE4;&#xE4; t&#xE4;t&#xE4; &#xE4;&#xE4;nitiedostoa.",
                  "ziggeoaudioplayer.audio-unknown-error": "T&#xE4;t&#xE4; &#xE4;&#xE4;nitiedostoa ei voi k&#xE4;ytt&#xE4;&#xE4; t&#xE4;ll&#xE4; hetkell&#xE4;. Yrit&#xE4; uudelleen my&#xF6;hemmin.",
                  "ziggeoaudioplayer.audio-rejected": "&#xC4;&#xE4;nitiedosto on hyl&#xE4;tty.",
                  "ziggeoaudioplayer.audio-processing": "&#xC4;&#xE4;nitiedostoa k&#xE4;sitell&#xE4;&#xE4;n - odota sulkematta.",
                  "ziggeoaudioplayer.audio-access-error": "&#xC4;&#xE4;nitiedosto on moderoitavana. Yrit&#xE4; uudelleen klikkaamalla.",
                  "ziggeoimageviewer.image-not-found": "M&#xE4;&#xE4;ritelty&#xE4; kuvaa ei l&#xF6;ydy.",
                  "ziggeoimageviewer.image-access-forbidden": "Ei oikeutta k&#xE4;ytt&#xE4;&#xE4; t&#xE4;t&#xE4; kuvaa.",
                  "ziggeoimageviewer.image-unknown-error": "T&#xE4;t&#xE4; kuvaa ei voi k&#xE4;ytt&#xE4;&#xE4; t&#xE4;ll&#xE4; hetkell&#xE4;. Yrit&#xE4; uudelleen my&#xF6;hemmin.",
                  "ziggeoimageviewer.image-rejected": "Kuva on hyl&#xE4;tty.",
                  "ziggeoimageviewer.image-processing": "Kuvaa k&#xE4;sitell&#xE4;&#xE4;n - odota sulkematta.",
                  "ziggeoimageviewer.image-access-error": "Kuva on moderoitavana. Yrit&#xE4; uudelleen klikkaamalla.",
                  "ziggeoplayer.video-not-found": "M&#xE4;&#xE4;ritelty&#xE4; videota ei l&#xF6;ydy.",
                  "ziggeoplayer.video-access-forbidden": "Ei oikeutta k&#xE4;ytt&#xE4;&#xE4; t&#xE4;t&#xE4; videota.",
                  "ziggeoplayer.video-unknown-error": "T&#xE4;t&#xE4; videota ei voi k&#xE4;ytt&#xE4;&#xE4; t&#xE4;ll&#xE4; hetkell&#xE4;. Yrit&#xE4; uudelleen my&#xF6;hemmin.",
                  "ziggeoplayer.video-rejected": "Video on hyl&#xE4;tty.",
                  "ziggeoplayer.video-processing": "Videota k&#xE4;sitell&#xE4;&#xE4;n - odota sulkematta.",
                  "ziggeoplayer.video-access-error": "Video on moderoitavana. Yrit&#xE4; uudelleen klikkaamalla."
                },
                "language:fr": {
                  "application.error_503": "Notre service est en maintenance ou service en maintenance. Les vid&#xE9;os seront bient&#xF4;t de retours.",
                  "application.error_404": "Nous ne pouvons lire ou reconnaitre votre cl&#xE9; API. Assurez vous qu&#x2019;elle soit connect&#xE9;e avec l&#x2019;ent&#xEA;te du site web.",
                  "application.error_401": "Vous n&#x2019;&#xEA;tes pas autoris&#xE9; &#xE0; acc&#xE9;der &#xE0; l&#x2019;application depuis ce site.",
                  "application.error_412": "Vous devez confirmer/ veuillez mettre &#xE0; jour votre compte.",
                  "application.error_unknown": "Une erreur s&#x2019;est produite, notre &#xE9;quipe a &#xE9;t&#xE9; pr&#xE9;venue et interviendra dans les meilleurs d&#xE9;lais.",
                  "ziggeoaudioplayer.audio-not-found": "Nous n&#x27;avons pas pu trouver le fichier audio sp&#xE9;cifi&#xE9;.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Vous n&#x27;&#xEA;tes pas autoris&#xE9; &#xE0; acc&#xE9;der &#xE0; ce fichier audio.",
                  "ziggeoaudioplayer.audio-unknown-error": "Nous ne pouvons pas acc&#xE9;der &#xE0; cet audio pour le moment. Veuillez r&#xE9;essayer plus tard.",
                  "ziggeoaudioplayer.audio-rejected": "L&#x27;audio a &#xE9;t&#xE9; rejet&#xE9;.",
                  "ziggeoaudioplayer.audio-processing": "L&#x27;audio est en cours de traitement - restez &#xE0; l&#x27;&#xE9;coute.",
                  "ziggeoaudioplayer.audio-access-error": "L&#x27;audio est actuellement en cours de mod&#xE9;ration. Vous pouvez cliquer pour r&#xE9;essayer.",
                  "ziggeoimageviewer.image-not-found": "Nous n&#x27;avons pas pu trouver le fichier image sp&#xE9;cifi&#xE9;.",
                  "ziggeoimageviewer.image-access-forbidden": "Vous n&#x27;&#xEA;tes pas autoris&#xE9; &#xE0; acc&#xE9;der &#xE0; ce fichier image.",
                  "ziggeoimageviewer.image-unknown-error": "Nous ne pouvons pas acc&#xE9;der &#xE0; cette image pour le moment. Veuillez r&#xE9;essayer plus tard.",
                  "ziggeoimageviewer.image-rejected": "L&#x27;image a &#xE9;t&#xE9; rejet&#xE9;e.",
                  "ziggeoimageviewer.image-processing": "L&#x27;image est en cours de traitement - restez &#xE0; l&#x27;&#xE9;coute.",
                  "ziggeoimageviewer.image-access-error": "L&#x27;image est actuellement en cours de mod&#xE9;ration. Vous pouvez cliquer pour r&#xE9;essayer.",
                  "ziggeoplayer.video-not-found": "Nous ne pouvons trouver votre fichier vid&#xE9;o.",
                  "ziggeoplayer.video-access-forbidden": "Vous n&#x2019;&#xEA;tes pas autoris&#xE9; &#xE0; accede &#xE0; ce fichier vid&#xE9;o.",
                  "ziggeoplayer.video-unknown-error": "Nous ne pouvons pas acc&#xE9;der &#xE0; cette vid&#xE9;o pour le moment - R&#xE9;essayez plus tard.",
                  "ziggeoplayer.video-rejected": "La vid&#xE9;o a &#xE9;t&#xE9; rejet&#xE9;e.",
                  "ziggeoplayer.video-processing": "La vid&#xE9;o est en cours de traitement - restez &#xE0; l&#x27;&#xE9;coute.",
                  "ziggeoplayer.video-access-error": "La vid&#xE9;o est en cours de mod&#xE9;ration. Vous pouvez cliquer pour r&#xE9;essayer."
                },
                "language:hi": {
                  "application.error_503": "&#x939;&#x92E; &#x905;&#x92A;&#x928;&#x940; &#x938;&#x947;&#x935;&#x93E; &#x915;&#x94B; &#x92C;&#x928;&#x93E;&#x90F; &#x930;&#x916;&#x924;&#x947; &#x939;&#x948;&#x902; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x91C;&#x932;&#x94D;&#x926; &#x939;&#x940; &#x935;&#x93E;&#x92A;&#x938; &#x906; &#x91C;&#x93E;&#x90F;&#x902;&#x917;&#x947;",
                  "application.error_404": "&#x939;&#x92E; &#x906;&#x92A;&#x915;&#x940; &#x90F;&#x92A;&#x940;&#x906;&#x908; &#x915;&#x941;&#x902;&#x91C;&#x940; &#x915;&#x94B; &#x928;&#x939;&#x940;&#x902; &#x92A;&#x939;&#x91A;&#x93E;&#x928; &#x938;&#x915;&#x924;&#x947; &#x915;&#x943;&#x92A;&#x92F;&#x93E; &#x907;&#x938;&#x947; &#x905;&#x92A;&#x928;&#x940; &#x935;&#x947;&#x92C;&#x938;&#x93E;&#x907;&#x91F; &#x915;&#x947; &#x939;&#x947;&#x921;&#x930; &#x92E;&#x947;&#x902; &#x928;&#x93F;&#x930;&#x94D;&#x926;&#x93F;&#x937;&#x94D;&#x91F; &#x915;&#x930;&#x928;&#x93E; &#x938;&#x941;&#x928;&#x93F;&#x936;&#x94D;&#x91A;&#x93F;&#x924; &#x915;&#x930;&#x947;&#x902;",
                  "application.error_401": "&#x906;&#x92A;&#x915;&#x94B; &#x907;&#x938; &#x938;&#x93E;&#x907;&#x91F; &#x938;&#x947; &#x906;&#x935;&#x947;&#x926;&#x928; &#x924;&#x915; &#x92A;&#x939;&#x941;&#x902;&#x91A;&#x928;&#x947; &#x915;&#x940; &#x905;&#x928;&#x941;&#x92E;&#x924;&#x93F; &#x928;&#x939;&#x940;&#x902; &#x939;&#x948;&#x964;",
                  "application.error_412": "&#x906;&#x92A;&#x915;&#x94B; &#x905;&#x92A;&#x928;&#x947; &#x916;&#x93E;&#x924;&#x947; &#x915;&#x940; &#x92A;&#x941;&#x937;&#x94D;&#x91F;&#x93F; / &#x905;&#x92A;&#x917;&#x94D;&#x930;&#x947;&#x921; &#x915;&#x930;&#x928;&#x947; &#x915;&#x940; &#x906;&#x935;&#x936;&#x94D;&#x92F;&#x915;&#x924;&#x93E; &#x939;&#x948;&#x964;",
                  "application.error_unknown": "&#x90F;&#x915; &#x905;&#x91C;&#x94D;&#x91E;&#x93E;&#x924; &#x924;&#x94D;&#x930;&#x941;&#x91F;&#x93F; &#x939;&#x941;&#x908; &#x939;&#x92E;&#x93E;&#x930;&#x940; &#x91F;&#x940;&#x92E; &#x915;&#x94B; &#x938;&#x942;&#x91A;&#x93F;&#x924; &#x915;&#x93F;&#x92F;&#x93E; &#x917;&#x92F;&#x93E; &#x939;&#x948; &#x914;&#x930; &#x907;&#x938; &#x92E;&#x941;&#x926;&#x94D;&#x926;&#x947; &#x915;&#x94B; &#x939;&#x932; &#x915;&#x930;&#x947;&#x917;&#x93E;&#x964;",
                  "ziggeoplayer.video-not-found": "&#x939;&#x92E;&#x947;&#x902; &#x928;&#x93F;&#x930;&#x94D;&#x926;&#x93F;&#x937;&#x94D;&#x91F; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x928;&#x939;&#x940;&#x902; &#x92E;&#x93F;&#x932;&#x940;&#x964;",
                  "ziggeoplayer.video-access-forbidden": "&#x906;&#x92A;&#x915;&#x94B; &#x907;&#x938; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x915;&#x94B; &#x90F;&#x915;&#x94D;&#x938;&#x947;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x940; &#x905;&#x928;&#x941;&#x92E;&#x924;&#x93F; &#x928;&#x939;&#x940;&#x902; &#x939;&#x948;&#x964;",
                  "ziggeoplayer.video-unknown-error": "&#x939;&#x92E; &#x907;&#x938; &#x938;&#x92E;&#x92F; &#x907;&#x938; &#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x915;&#x94B; &#x90F;&#x915;&#x94D;&#x938;&#x947;&#x938; &#x928;&#x939;&#x940;&#x902; &#x915;&#x930; &#x938;&#x915;&#x924;&#x947;&#x964; &#x92C;&#x93E;&#x926; &#x92E;&#x947;&#x902; &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ziggeoplayer.video-rejected": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x915;&#x94B; &#x905;&#x938;&#x94D;&#x935;&#x940;&#x915;&#x93E;&#x930; &#x915;&#x930; &#x926;&#x93F;&#x92F;&#x93E; &#x917;&#x92F;&#x93E; &#x939;&#x948;&#x964;",
                  "ziggeoplayer.video-processing": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x92A;&#x94D;&#x930;&#x94B;&#x938;&#x947;&#x938;&#x93F;&#x902;&#x917; &#x939;&#x948; - &#x926;&#x947;&#x916;&#x924;&#x947; &#x930;&#x939;&#x947;&#x902;",
                  "ziggeoplayer.video-access-error": "&#x935;&#x940;&#x921;&#x93F;&#x92F;&#x94B; &#x935;&#x930;&#x94D;&#x924;&#x92E;&#x93E;&#x928; &#x92E;&#x947;&#x902; &#x92E;&#x949;&#x921;&#x930;&#x947;&#x936;&#x928; &#x915;&#x947; &#x905;&#x902;&#x924;&#x930;&#x94D;&#x917;&#x924; &#x939;&#x948; &#x906;&#x92A; &#x92B;&#x93F;&#x930; &#x938;&#x947; &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930; &#x938;&#x915;&#x924;&#x947; &#x939;&#x948;&#x902;&#x964;",
                  "ziggeoaudioplayer.audio-not-found": "&#x939;&#x92E;&#x947;&#x902; &#x928;&#x93F;&#x930;&#x94D;&#x926;&#x93F;&#x937;&#x94D;&#x91F; &#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x928;&#x939;&#x940;&#x902; &#x92E;&#x93F;&#x932;&#x940;&#x964;",
                  "ziggeoaudioplayer.audio-access-forbidden": "&#x906;&#x92A;&#x915;&#x94B; &#x907;&#x938; &#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x924;&#x915; &#x92A;&#x939;&#x941;&#x901;&#x91A;&#x928;&#x947; &#x915;&#x940; &#x905;&#x928;&#x941;&#x92E;&#x924;&#x93F; &#x928;&#x939;&#x940;&#x902; &#x939;&#x948;&#x964;",
                  "ziggeoaudioplayer.audio-unknown-error": "&#x939;&#x92E; &#x907;&#x938; &#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x915;&#x94B; &#x907;&#x938; &#x938;&#x92E;&#x92F; &#x90F;&#x915;&#x94D;&#x938;&#x947;&#x938; &#x928;&#x939;&#x940;&#x902; &#x915;&#x930; &#x938;&#x915;&#x924;&#x947;&#x964; &#x92C;&#x93E;&#x926; &#x92E;&#x947;&#x902; &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ziggeoaudioplayer.audio-rejected": "&#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x915;&#x94B; &#x916;&#x93E;&#x930;&#x93F;&#x91C; &#x915;&#x930; &#x926;&#x93F;&#x92F;&#x93E; &#x917;&#x92F;&#x93E; &#x939;&#x948;&#x964;",
                  "ziggeoaudioplayer.audio-processing": "&#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x92A;&#x94D;&#x930;&#x938;&#x902;&#x938;&#x94D;&#x915;&#x930;&#x923; &#x939;&#x948; - &#x926;&#x947;&#x916;&#x924;&#x947; &#x930;&#x939;&#x947;&#x902;&#x964;",
                  "ziggeoaudioplayer.audio-access-error": "&#x935;&#x930;&#x94D;&#x924;&#x92E;&#x93E;&#x928; &#x92E;&#x947;&#x902; &#x911;&#x921;&#x93F;&#x92F;&#x94B; &#x92E;&#x949;&#x921;&#x930;&#x947;&#x936;&#x928; &#x915;&#x947; &#x905;&#x902;&#x924;&#x930;&#x94D;&#x917;&#x924; &#x939;&#x948;&#x964; &#x906;&#x92A; &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930; &#x938;&#x915;&#x924;&#x947; &#x939;&#x948;&#x902;&#x964;",
                  "ziggeoimageviewer.image-not-found": "&#x939;&#x92E;&#x947;&#x902; &#x928;&#x93F;&#x930;&#x94D;&#x926;&#x93F;&#x937;&#x94D;&#x91F; &#x91B;&#x935;&#x93F; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x928;&#x939;&#x940;&#x902; &#x92E;&#x93F;&#x932;&#x940;&#x964;",
                  "ziggeoimageviewer.image-access-forbidden": "&#x906;&#x92A;&#x915;&#x94B; &#x907;&#x938; &#x91B;&#x935;&#x93F; &#x92B;&#x93C;&#x93E;&#x907;&#x932; &#x924;&#x915; &#x92A;&#x939;&#x941;&#x901;&#x91A;&#x928;&#x947; &#x915;&#x940; &#x905;&#x928;&#x941;&#x92E;&#x924;&#x93F; &#x928;&#x939;&#x940;&#x902; &#x939;&#x948;&#x964;",
                  "ziggeoimageviewer.image-unknown-error": "&#x939;&#x92E; &#x907;&#x938; &#x938;&#x92E;&#x92F; &#x907;&#x938; &#x91B;&#x935;&#x93F; &#x924;&#x915; &#x928;&#x939;&#x940;&#x902; &#x92A;&#x939;&#x941;&#x902;&#x91A; &#x938;&#x915;&#x924;&#x947; &#x939;&#x948;&#x902;&#x964; &#x92C;&#x93E;&#x926; &#x92E;&#x947;&#x902; &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x947;&#x902;&#x964;",
                  "ziggeoimageviewer.image-rejected": "&#x91B;&#x935;&#x93F; &#x915;&#x94B; &#x905;&#x938;&#x94D;&#x935;&#x940;&#x915;&#x93E;&#x930; &#x915;&#x930; &#x926;&#x93F;&#x92F;&#x93E; &#x917;&#x92F;&#x93E; &#x939;&#x948;&#x964;",
                  "ziggeoimageviewer.image-processing": "&#x91B;&#x935;&#x93F; &#x92A;&#x94D;&#x930;&#x938;&#x902;&#x938;&#x94D;&#x915;&#x930;&#x923; &#x939;&#x948; - &#x926;&#x947;&#x916;&#x924;&#x947; &#x930;&#x939;&#x947;&#x902;&#x964;",
                  "ziggeoimageviewer.image-access-error": "&#x935;&#x930;&#x94D;&#x924;&#x92E;&#x93E;&#x928; &#x92E;&#x947;&#x902; &#x91B;&#x935;&#x93F; &#x92E;&#x949;&#x921;&#x930;&#x947;&#x936;&#x928; &#x915;&#x947; &#x905;&#x902;&#x924;&#x930;&#x94D;&#x917;&#x924; &#x939;&#x948;&#x964; &#x906;&#x92A; &#x92A;&#x941;&#x928;: &#x92A;&#x94D;&#x930;&#x92F;&#x93E;&#x938; &#x915;&#x930;&#x928;&#x947; &#x915;&#x947; &#x932;&#x93F;&#x90F; &#x915;&#x94D;&#x932;&#x93F;&#x915; &#x915;&#x930; &#x938;&#x915;&#x924;&#x947; &#x939;&#x948;&#x902;&#x964;"
                },
                "language:hr": {
                  "application.error_503": "Dr&#x17E;imo na&#x161;e usluge. Video &#x107;e se uskoro vratiti.",
                  "application.error_404": "Ne mo&#x17E;emo prepoznati svoj API klju&#x10D;. Obavezno nazna&#x10D;iti to u va&#x161;e web stranice napada&#x10D;a.",
                  "application.error_401": "Ne mogu pristupiti aplikacija s ove stranice.",
                  "application.error_412": "Morate potvrditi / nadograditi svoj ra&#x10D;un.",
                  "application.error_unknown": "Do&#x161;lo je do nepoznate pogre&#x161;ke. Na&#x161; tim je obavije&#x161;ten i da &#x107;e rije&#x161;iti problem.",
                  "ziggeoplayer.video-not-found": "Nismo mogli prona&#x107;i navedenu datoteku videozapisa.",
                  "ziggeoplayer.video-access-forbidden": "Ne smiju pristupiti ovom video datoteku.",
                  "ziggeoplayer.video-unknown-error": "Ne mogu pristupiti ovaj video u tom trenutku. Molimo poku&#x161;ajte ponovo kasnije.",
                  "ziggeoplayer.video-rejected": "Video je odbijen.",
                  "ziggeoplayer.video-processing": "Video obra&#x111;uje - Stay tuned.",
                  "ziggeoplayer.video-access-error": "Spot je trenutno u umjerenim koli&#x10D;inama. Mo&#x17E;ete kliknuti na ponovni poku&#x161;aj.",
                  "ziggeoaudioplayer.audio-not-found": "Nismo mogli prona&#x107;i navedenu audio datoteku.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Nije vam dozvoljen pristup ovoj audio datoteci.",
                  "ziggeoaudioplayer.audio-unknown-error": "Trenutno ne mo&#x17E;emo pristupiti ovom zvuku. Molimo poku&#x161;ajte ponovo kasnije.",
                  "ziggeoaudioplayer.audio-rejected": "Zvuk je odbijen.",
                  "ziggeoaudioplayer.audio-processing": "Zvuk se obra&#x111;uje - pratite nas.",
                  "ziggeoaudioplayer.audio-access-error": "Zvuk je trenutno pod moderiranjem. Mo&#x17E;ete kliknuti za ponovni poku&#x161;aj.",
                  "ziggeoimageviewer.image-not-found": "Nismo mogli prona&#x107;i navedenu datoteku slike.",
                  "ziggeoimageviewer.image-access-forbidden": "Nije vam dozvoljen pristup ovoj slikovnoj datoteci.",
                  "ziggeoimageviewer.image-unknown-error": "Trenutno ne mo&#x17E;emo pristupiti ovoj slici. Molimo poku&#x161;ajte ponovo kasnije.",
                  "ziggeoimageviewer.image-rejected": "Slika je odbijena.",
                  "ziggeoimageviewer.image-processing": "Slika se obra&#x111;uje - pratite nas.",
                  "ziggeoimageviewer.image-access-error": "Trenutno se slika moderira. Mo&#x17E;ete kliknuti za ponovni poku&#x161;aj."
                },
                "language:hu": {
                  "application.error_503": "Mi fenntart&#xE1;sa a szolg&#xE1;ltat&#xE1;st. Vide&#xF3; hamarosan visszat&#xE9;r.",
                  "application.error_404": "Nem lehet felismerni az API-kulcsot. K&#xE9;rj&#xFC;k, hogy adja meg a webhely fejl&#xE9;c&#xE9;ben.",
                  "application.error_401": "&#xD6;n nem jogosult hozz&#xE1;f&#xE9;rni az alkalmaz&#xE1;s ezen az oldalon.",
                  "application.error_412": "Meg kell er&#x151;s&#xED;tenie / friss&#xED;tse a sz&#xE1;mla.",
                  "application.error_unknown": "Ismeretlen hiba t&#xF6;rt&#xE9;nt. Csapatunk m&#xE1;r bejelentett, &#xE9;s megoldja a probl&#xE9;m&#xE1;t.",
                  "ziggeoplayer.video-not-found": "Nem tal&#xE1;ltunk a megadott vide&#xF3; f&#xE1;jlt.",
                  "ziggeoplayer.video-access-forbidden": "&#xD6;n nem jogosult hozz&#xE1;f&#xE9;rni a vide&#xF3; f&#xE1;jlt.",
                  "ziggeoplayer.video-unknown-error": "Nem tudjuk el&#xE9;rni ezt a vide&#xF3;t a pillanatban. K&#xE9;rlek, pr&#xF3;b&#xE1;ld &#xFA;jra k&#xE9;s&#x151;bb.",
                  "ziggeoplayer.video-rejected": "A vide&#xF3; elutas&#xED;t&#xE1;sra ker&#xFC;lt.",
                  "ziggeoplayer.video-processing": "A vide&#xF3; feldolgoz&#xE1;s - a h&#xED;rad&#xE1;sokat.",
                  "ziggeoplayer.video-access-error": "A vide&#xF3; jelenleg a moder&#xE1;l&#xE1;s. Lehet kattint&#xE1;ssal &#xFA;jra.",
                  "ziggeoaudioplayer.audio-not-found": "Nem tal&#xE1;lhat&#xF3; a megadott hangf&#xE1;jl.",
                  "ziggeoaudioplayer.audio-access-forbidden": "&#xD6;n nem f&#xE9;rhet hozz&#xE1; ehhez az audio f&#xE1;jlhoz.",
                  "ziggeoaudioplayer.audio-unknown-error": "Jelenleg nem &#xE9;rhetj&#xFC;k el ezt a hanganyagot. K&#xE9;rlek, pr&#xF3;b&#xE1;ld &#xFA;jra k&#xE9;s&#x151;bb.",
                  "ziggeoaudioplayer.audio-rejected": "A hangot elutas&#xED;tott&#xE1;k.",
                  "ziggeoaudioplayer.audio-processing": "A hang feldolgoz&#xE1;sa folyamatban van - maradjon vel&#xFC;nk.",
                  "ziggeoaudioplayer.audio-access-error": "A hang jelenleg moder&#xE1;l&#xE1;s alatt &#xE1;ll. Kattintson az &#xFA;jrapr&#xF3;b&#xE1;lkoz&#xE1;shoz.",
                  "ziggeoimageviewer.image-not-found": "Nem tal&#xE1;lhat&#xF3; a megadott k&#xE9;pf&#xE1;jl.",
                  "ziggeoimageviewer.image-access-forbidden": "&#xD6;n nem f&#xE9;rhet hozz&#xE1; ehhez a k&#xE9;pf&#xE1;jlhoz.",
                  "ziggeoimageviewer.image-unknown-error": "Jelenleg nem tudunk hozz&#xE1;f&#xE9;rni ehhez a k&#xE9;phez. K&#xE9;rlek, pr&#xF3;b&#xE1;ld &#xFA;jra k&#xE9;s&#x151;bb.",
                  "ziggeoimageviewer.image-rejected": "A k&#xE9;pet elutas&#xED;tott&#xE1;k.",
                  "ziggeoimageviewer.image-processing": "A k&#xE9;p feldolgoz&#xE1;sa folyamatban van - maradjon vel&#xFC;nk.",
                  "ziggeoimageviewer.image-access-error": "A k&#xE9;p jelenleg moder&#xE1;l&#xE1;s alatt &#xE1;ll. Kattintson az &#xFA;jrapr&#xF3;b&#xE1;lkoz&#xE1;shoz."
                },
                "language:id": {
                  "application.error_503": "Kami menjaga layanan kami. Video akan segera kembali.",
                  "application.error_404": "Kami tidak dapat mengenali kunci api Anda. Pastikan untuk menentukannya di header situs web Anda.",
                  "application.error_401": "Anda tidak diizinkan mengakses aplikasi dari situs ini.",
                  "application.error_412": "Anda perlu mengkonfirmasi / meningkatkan akun Anda.",
                  "application.error_unknown": "Terjadi kesalahan yang tidak diketahui. Tim kami telah diberi tahu dan akan menyelesaikan masalah ini.",
                  "ziggeoaudioplayer.audio-not-found": "Kami tidak dapat menemukan file audio yang ditentukan.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Anda tidak diizinkan untuk mengakses file audio ini.",
                  "ziggeoaudioplayer.audio-unknown-error": "Saat ini kami tidak dapat mengakses audio ini. Silahkan coba lagi nanti.",
                  "ziggeoaudioplayer.audio-rejected": "Audio telah ditolak.",
                  "ziggeoaudioplayer.audio-processing": "Audio sedang diproses - nantikan.",
                  "ziggeoaudioplayer.audio-access-error": "Audio saat ini sedang dalam moderasi. Anda bisa mengklik untuk mencoba lagi.",
                  "ziggeoimageviewer.image-not-found": "Kami tidak dapat menemukan file gambar yang ditentukan.",
                  "ziggeoimageviewer.image-access-forbidden": "Anda tidak diizinkan mengakses file gambar ini.",
                  "ziggeoimageviewer.image-unknown-error": "Saat ini kami tidak dapat mengakses gambar ini. Silahkan coba lagi nanti.",
                  "ziggeoimageviewer.image-rejected": "Gambar telah ditolak.",
                  "ziggeoimageviewer.image-processing": "Gambar sedang diproses - nantikan.",
                  "ziggeoimageviewer.image-access-error": "Gambar saat ini sedang dalam moderasi. Anda bisa mengklik untuk mencoba lagi.",
                  "ziggeoplayer.video-not-found": "Kami tidak dapat menemukan file video yang ditentukan.",
                  "ziggeoplayer.video-access-forbidden": "Anda tidak diizinkan mengakses file video ini.",
                  "ziggeoplayer.video-unknown-error": "Saat ini kami tidak dapat mengakses video ini. Silakan coba lagi nanti.",
                  "ziggeoplayer.video-rejected": "Video telah ditolak",
                  "ziggeoplayer.video-processing": "Video sedang diproses - nantikan.",
                  "ziggeoplayer.video-access-error": "Video saat ini sedang dalam moderasi. Anda bisa mengklik untuk mencoba lagi."
                },
                "language:it": {
                  "application.error_503": "Il nostro servizio &#xE8; in fase di manutenzione. I video torneranno presto.",
                  "application.error_404": "Non riusciamo a riconoscere la tua chiave API. Assicurati di specificarla nell&#x27;intestazione del tuo sito web.",
                  "application.error_401": "Non &#xE8; consentito accedere all&#x27;applicazione da questo sito.",
                  "application.error_412": "&#xC8; necessario confermare / aggiornare il tuo account.",
                  "application.error_unknown": "Si &#xE8; verificato un errore sconosciuto. La nostra squadra &#xE8; stata notifica e dovr&#xE0; risolvere il problema.",
                  "ziggeoaudioplayer.audio-not-found": "Non &#xE8; stato possibile trovare l&#x27;archivio audio specificato.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Non &#xE8; possibile accedere a questo archivio audio.",
                  "ziggeoaudioplayer.audio-unknown-error": "Non &#xE8; possibile accedere a questo audio per il momento. Riprova pi&#xF9; tardi.",
                  "ziggeoaudioplayer.audio-rejected": "L&#x27;audio &#xE8; stato rifiutato.",
                  "ziggeoaudioplayer.audio-processing": "L&#x27;audio &#xE8; in fase di elaborazione - rimani in attesa.",
                  "ziggeoaudioplayer.audio-access-error": "L&#x27;audio &#xE8; in fase di moderazione. &#xC8; possibile fare clic per riprovare.",
                  "ziggeoimageviewer.image-not-found": "Non &#xE8; stato possibile trovare l&#x27;archivio di immagini specificato.",
                  "ziggeoimageviewer.image-access-forbidden": "Non hai i permessi necessari per accedere a questa immagine.",
                  "ziggeoimageviewer.image-unknown-error": "Non possiamo accedere a questa immagine per il momento. Riprova pi&#xF9; tardi.",
                  "ziggeoimageviewer.image-rejected": "L&#x27;immagine &#xE8; stata rifiutata.",
                  "ziggeoimageviewer.image-processing": "L&#x27;immagine &#xE8; in fase di elaborazione - rimani in attesa.",
                  "ziggeoimageviewer.image-access-error": "L&#x27;immagine &#xE8; in fase di moderazione. &#xC8; possibile fare clic per riprovare.",
                  "ziggeoplayer.video-not-found": "Non siamo riusciti a trovare il file video specificato.",
                  "ziggeoplayer.video-access-forbidden": "Non &#xE8; consentito accedere a questo file video.",
                  "ziggeoplayer.video-unknown-error": "Non possiamo accedere a questo video in questo momento. Per favore riprova pi&#xF9; tardi.",
                  "ziggeoplayer.video-rejected": "Il video &#xE8; stato rifiutato.",
                  "ziggeoplayer.video-processing": "Il video &#xE8; in fase di elaborazione - rimani in attesa.",
                  "ziggeoplayer.video-access-error": "Il video &#xE8; attualmente in fase di moderazione. &#xC8; possibile fare clic per riprovare."
                },
                "language:ja": {
                  "application.error_503": "&#x305F;&#x3060;&#x4ECA;&#x30E1;&#x30F3;&#x30C6;&#x30CA;&#x30F3;&#x30B9;&#x4E2D;&#x3067;&#x3059;&#x3002;&#x3057;&#x3070;&#x3089;&#x304F;&#x304A;&#x5F85;&#x3061;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "application.error_404": "API&#x30AD;&#x30FC;&#x3092;&#x8A8D;&#x8B58;&#x3067;&#x304D;&#x307E;&#x305B;&#x3093;&#x3002; &#x5FC5;&#x305A;&#x6307;&#x5B9A;&#x306E;API&#x30AD;&#x30FC;&#x3092;&#x30A6;&#x30A7;&#x30D6;&#x30B5;&#x30A4;&#x30C8;&#x306E;&#x30D8;&#x30C3;&#x30C0;&#x30FC;&#x306B;&#x8A2D;&#x5B9A;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "application.error_401": "&#x3053;&#x306E;&#x30B5;&#x30A4;&#x30C8;&#x304B;&#x3089;&#x30A2;&#x30D7;&#x30EA;&#x30B1;&#x30FC;&#x30B7;&#x30E7;&#x30F3;&#x306B;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x3059;&#x308B;&#x3053;&#x3068;&#x306F;&#x8A31;&#x53EF;&#x3055;&#x308C;&#x3066;&#x3044;&#x307E;&#x305B;&#x3093;&#x3002;",
                  "application.error_412": "&#x30A2;&#x30AB;&#x30A6;&#x30F3;&#x30C8;&#x3092;&#x78BA;&#x8A8D;/&#x30A2;&#x30C3;&#x30D7;&#x30B0;&#x30EC;&#x30FC;&#x30C9;&#x3059;&#x308B;&#x5FC5;&#x8981;&#x304C;&#x3042;&#x308A;&#x307E;&#x3059;&#x3002;",
                  "application.error_unknown": "&#x4E0D;&#x660E;&#x306A;&#x30A8;&#x30E9;&#x30FC;&#x304C;&#x767A;&#x751F;&#x3057;&#x307E;&#x3057;&#x305F;&#x3002; &#x3053;&#x306E;&#x554F;&#x984C;&#x306E;&#x30C8;&#x30E9;&#x30D6;&#x30EB;&#x30B7;&#x30E5;&#x30FC;&#x30C6;&#x30A3;&#x30F3;&#x30B0;&#x3092;&#x884C;&#x3046;&#x3088;&#x3046;&#x30C1;&#x30FC;&#x30E0;&#x306B;&#x901A;&#x77E5;&#x304C;&#x3055;&#x308C;&#x307E;&#x3057;&#x305F;&#x3002;",
                  "ziggeoaudioplayer.audio-not-found": "&#x6307;&#x5B9A;&#x3055;&#x308C;&#x305F;&#x97F3;&#x58F0;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x304C;&#x898B;&#x3064;&#x304B;&#x308A;&#x307E;&#x305B;&#x3093;&#x3067;&#x3057;&#x305F;&#x3002;",
                  "ziggeoaudioplayer.audio-access-forbidden": "&#x3053;&#x306E;&#x97F3;&#x58F0;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x3078;&#x306E;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x306F;&#x8A31;&#x53EF;&#x3055;&#x308C;&#x3066;&#x3044;&#x307E;&#x305B;&#x3093;&#x3002;",
                  "ziggeoaudioplayer.audio-unknown-error": "&#x73FE;&#x5728;&#x3053;&#x306E;&#x97F3;&#x58F0;&#x306B;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x3067;&#x304D;&#x307E;&#x305B;&#x3093;&#x3002;&#x5F8C;&#x3067;&#x3082;&#x3046;&#x4E00;&#x5EA6;&#x3084;&#x308A;&#x76F4;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ziggeoaudioplayer.audio-rejected": "&#x97F3;&#x58F0;&#x304C;&#x62D2;&#x5426;&#x3055;&#x308C;&#x307E;&#x3057;&#x305F;&#x3002;",
                  "ziggeoaudioplayer.audio-processing": "&#x97F3;&#x58F0;&#x306E;&#x51E6;&#x7406;&#x4E2D;&#x3067;&#x3059; - &#x3057;&#x3070;&#x3089;&#x304F;&#x304A;&#x5F85;&#x3061;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ziggeoaudioplayer.audio-access-error": "&#x3053;&#x306E;&#x97F3;&#x58F0;&#x306F;&#x627F;&#x8A8D;&#x3092;&#x5F85;&#x3063;&#x3066;&#x3044;&#x307E;&#x3059;&#x3002;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3067;&#x304D;&#x307E;&#x3059;&#x3002;",
                  "ziggeoimageviewer.image-not-found": "&#x6307;&#x5B9A;&#x3055;&#x308C;&#x305F;&#x753B;&#x50CF;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x304C;&#x898B;&#x3064;&#x304B;&#x308A;&#x307E;&#x305B;&#x3093;&#x3067;&#x3057;&#x305F;&#x3002;",
                  "ziggeoimageviewer.image-access-forbidden": "&#x3053;&#x306E;&#x753B;&#x50CF;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x3078;&#x306E;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x306F;&#x8A31;&#x53EF;&#x3055;&#x308C;&#x3066;&#x3044;&#x307E;&#x305B;&#x3093;&#x3002;",
                  "ziggeoimageviewer.image-unknown-error": "&#x73FE;&#x5728;&#x3053;&#x306E;&#x753B;&#x50CF;&#x306B;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x3067;&#x304D;&#x307E;&#x305B;&#x3093;&#x3002;&#x5F8C;&#x3067;&#x3082;&#x3046;&#x4E00;&#x5EA6;&#x3084;&#x308A;&#x76F4;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ziggeoimageviewer.image-rejected": "&#x753B;&#x50CF;&#x306F;&#x62D2;&#x5426;&#x3055;&#x308C;&#x307E;&#x3057;&#x305F;&#x3002;",
                  "ziggeoimageviewer.image-processing": "&#x753B;&#x50CF;&#x306E;&#x51E6;&#x7406;&#x4E2D;&#x3067;&#x3059; - &#x3057;&#x3070;&#x3089;&#x304F;&#x304A;&#x5F85;&#x3061;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ziggeoimageviewer.image-access-error": "&#x3053;&#x306E;&#x753B;&#x50CF;&#x306F;&#x627F;&#x8A8D;&#x3092;&#x5F85;&#x3063;&#x3066;&#x3044;&#x307E;&#x3059;&#x3002;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3067;&#x304D;&#x307E;&#x3059;&#x3002;",
                  "ziggeoplayer.video-not-found": "&#x6307;&#x5B9A;&#x3055;&#x308C;&#x305F;&#x52D5;&#x753B;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x304C;&#x898B;&#x3064;&#x304B;&#x308A;&#x307E;&#x305B;&#x3093;&#x3067;&#x3057;&#x305F;&#x3002;",
                  "ziggeoplayer.video-access-forbidden": "&#x3053;&#x306E;&#x52D5;&#x753B;&#x30D5;&#x30A1;&#x30A4;&#x30EB;&#x3078;&#x306E;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x306F;&#x8A31;&#x53EF;&#x3055;&#x308C;&#x3066;&#x3044;&#x307E;&#x305B;&#x3093;&#x3002;",
                  "ziggeoplayer.video-unknown-error": "&#x73FE;&#x5728;&#x3053;&#x306E;&#x52D5;&#x753B;&#x306B;&#x30A2;&#x30AF;&#x30BB;&#x30B9;&#x3067;&#x304D;&#x307E;&#x305B;&#x3093;&#x3002;&#x5F8C;&#x3067;&#x3082;&#x3046;&#x4E00;&#x5EA6;&#x3084;&#x308A;&#x76F4;&#x3057;&#x3066;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ziggeoplayer.video-rejected": "&#x52D5;&#x753B;&#x306F;&#x62D2;&#x5426;&#x3055;&#x308C;&#x307E;&#x3057;&#x305F;&#x3002;",
                  "ziggeoplayer.video-processing": "&#x52D5;&#x753B;&#x306E;&#x51E6;&#x7406;&#x4E2D;&#x3067;&#x3059; - &#x3057;&#x3070;&#x3089;&#x304F;&#x304A;&#x5F85;&#x3061;&#x304F;&#x3060;&#x3055;&#x3044;&#x3002;",
                  "ziggeoplayer.video-access-error": "&#x3053;&#x306E;&#x52D5;&#x753B;&#x306F;&#x627F;&#x8A8D;&#x3092;&#x5F85;&#x3063;&#x3066;&#x3044;&#x307E;&#x3059;&#x3002;&#x30AF;&#x30EA;&#x30C3;&#x30AF;&#x3057;&#x3066;&#x518D;&#x8A66;&#x884C;&#x3067;&#x304D;&#x307E;&#x3059;&#x3002;"
                },
                "language:mk": {
                  "application.error_503": "&#x41D;&#x430;&#x448;&#x438;&#x442;&#x435; &#x443;&#x441;&#x43B;&#x443;&#x433;&#x438; &#x441;&#x435; &#x43F;&#x43E;&#x434; &#x43E;&#x434;&#x434;&#x440;&#x436;&#x443;&#x432;&#x430;&#x45A;&#x435;. &#x40C;&#x435; &#x441;&#x435; &#x432;&#x440;&#x430;&#x442;&#x438;&#x43C;&#x435; &#x43D;&#x430;&#x441;&#x43A;&#x43E;&#x440;&#x43E;.",
                  "application.error_404": "&#x41D;&#x435;&#x43C;&#x43E;&#x436;&#x435;&#x43C;&#x435; &#x434;&#x430; &#x433;&#x43E; &#x43F;&#x440;&#x435;&#x43F;&#x43E;&#x437;&#x43D;&#x430;&#x435;&#x43C;&#x435; &#x432;&#x430;&#x448;&#x438;&#x43E;&#x442; &#x410;&#x41F;&#x418; &#x43A;&#x43B;&#x443;&#x447;. &#x411;&#x438;&#x434;&#x435;&#x442;&#x435; &#x441;&#x438;&#x433;&#x443;&#x440;&#x43D;&#x438; &#x434;&#x435;&#x43A;&#x430; &#x435; &#x43D;&#x430;&#x432;&#x435;&#x434;&#x435;&#x43D; &#x432;&#x43E; &#x445;&#x435;&#x434;&#x435;&#x440;&#x43E;&#x442; &#x43D;&#x430; &#x432;&#x430;&#x448;&#x430;&#x442;&#x430; &#x441;&#x442;&#x440;&#x430;&#x43D;&#x438;&#x446;&#x430;.",
                  "application.error_401": "&#x412;&#x438;&#x435; &#x43D;&#x435; &#x441;&#x435; &#x434;&#x43E;&#x437;&#x432;&#x43E;&#x43B;&#x435;&#x43D;&#x438; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x442;&#x435; &#x434;&#x43E; &#x430;&#x43F;&#x43B;&#x438;&#x43A;&#x430;&#x446;&#x438;&#x458;&#x430;&#x442;&#x430; &#x43E;&#x434; &#x43E;&#x432;&#x43E;&#x458; &#x441;&#x430;&#x458;&#x442;",
                  "application.error_412": "&#x41C;&#x43E;&#x440;&#x430;&#x442;&#x435; &#x434;&#x430; &#x433;&#x43E; &#x43F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x438;&#x442;&#x435; / &#x430;&#x436;&#x443;&#x440;&#x438;&#x440;&#x430;&#x442;&#x435; &#x432;&#x430;&#x448;&#x438;&#x43E;&#x442; &#x430;&#x43A;&#x430;&#x443;&#x43D;&#x442;.",
                  "application.error_unknown": "&#x41D;&#x435;&#x43F;&#x43E;&#x437;&#x43D;&#x430;&#x442;&#x430; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x430; &#x441;&#x435; &#x441;&#x43B;&#x443;&#x447;&#x438;. &#x41D;&#x430;&#x448;&#x438;&#x43E;&#x442; &#x442;&#x438;&#x43C; &#x435; &#x438;&#x437;&#x432;&#x435;&#x441;&#x442;&#x435;&#x43D; &#x438; &#x433;&#x43E; &#x438;&#x437;&#x440;&#x435;&#x448;&#x438; &#x43F;&#x440;&#x43E;&#x431;&#x43B;&#x435;&#x43C;&#x43E;&#x442;.",
                  "ziggeoaudioplayer.audio-not-found": "&#x41D;&#x435;&#x43C;&#x43E;&#x436;&#x435;&#x432;&#x43C;&#x435; &#x434;&#x430; &#x433;&#x43E; &#x43D;&#x430;&#x458;&#x434;&#x435;&#x43C;&#x435; &#x438;&#x437;&#x431;&#x440;&#x430;&#x43D;&#x438;&#x43E;&#x442; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x444;&#x430;&#x458;&#x43B;.",
                  "ziggeoaudioplayer.audio-access-forbidden": "&#x41D;&#x435; &#x441;&#x442;&#x435; &#x434;&#x43E;&#x437;&#x432;&#x43E;&#x43B;&#x435;&#x43D;&#x438; &#x434;&#x430; &#x433;&#x43E; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x43E;&#x458; &#x444;&#x430;&#x458;&#x43B;.",
                  "ziggeoaudioplayer.audio-unknown-error": "&#x41D;&#x435;&#x43C;&#x43E;&#x436;&#x435;&#x432;&#x43C;&#x435; &#x434;&#x430; &#x433;&#x43E; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x43C;&#x435; &#x430;&#x443;&#x434;&#x438;&#x43E;&#x442;&#x43E; &#x432;&#x43E; &#x43E;&#x432;&#x43E;&#x458; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442;. &#x412;&#x435; &#x43C;&#x43E;&#x43B;&#x438;&#x43C;&#x435;, &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x458;&#x442;&#x435; &#x43F;&#x43E;&#x434;&#x43E;&#x446;&#x43D;&#x430;.",
                  "ziggeoaudioplayer.audio-rejected": "&#x410;&#x443;&#x434;&#x438;&#x43E;&#x442;&#x43E; &#x435; &#x43E;&#x434;&#x431;&#x438;&#x435;&#x43D;&#x43E;.",
                  "ziggeoaudioplayer.audio-processing": "&#x410;&#x443;&#x434;&#x438;&#x43E;&#x442;&#x43E; &#x441;&#x435; &#x43F;&#x440;&#x43E;&#x446;&#x435;&#x441;&#x438;&#x440;&#x430; - &#x43E;&#x441;&#x442;&#x430;&#x43D;&#x435;&#x442;&#x435; &#x432;&#x43E; &#x442;&#x435;&#x43A;.",
                  "ziggeoaudioplayer.audio-access-error": "&#x410;&#x443;&#x434;&#x438;&#x43E;&#x442;&#x43E; &#x435; &#x43F;&#x43E;&#x434; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x430;&#x446;&#x438;&#x458;&#x430;. &#x41C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x434;&#x430; &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x430;&#x43A;.",
                  "ziggeoimageviewer.image-not-found": "&#x41D;&#x435;&#x43C;&#x43E;&#x436;&#x435;&#x432;&#x43C;&#x435; &#x434;&#x430; &#x458;&#x430; &#x43D;&#x430;&#x458;&#x434;&#x435;&#x43C;&#x435; &#x438;&#x437;&#x431;&#x440;&#x430;&#x43D;&#x430;&#x442;&#x430; &#x441;&#x43B;&#x438;&#x43A;&#x430;.",
                  "ziggeoimageviewer.image-access-forbidden": "&#x41D;&#x435; &#x441;&#x442;&#x435; &#x434;&#x43E;&#x437;&#x432;&#x43E;&#x43B;&#x435;&#x43D;&#x438; &#x434;&#x430; &#x458;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x442;&#x435; &#x441;&#x43B;&#x438;&#x43A;&#x430;&#x442;&#x430;.",
                  "ziggeoimageviewer.image-unknown-error": "&#x41D;&#x435;&#x43C;&#x43E;&#x436;&#x435;&#x432;&#x43C;&#x435; &#x434;&#x430; &#x458;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x43C;&#x435; &#x441;&#x43B;&#x438;&#x43A;&#x430;&#x442;&#x430; &#x432;&#x43E; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442;&#x43E;&#x432;. &#x412;&#x435; &#x43C;&#x43E;&#x43B;&#x438;&#x43C;&#x435;, &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x458;&#x442;&#x435; &#x43F;&#x43E;&#x434;&#x43E;&#x446;&#x43D;&#x430;.",
                  "ziggeoimageviewer.image-rejected": "&#x421;&#x43B;&#x438;&#x43A;&#x430;&#x442;&#x430; &#x435; &#x43E;&#x434;&#x431;&#x438;&#x435;&#x43D;&#x430;.",
                  "ziggeoimageviewer.image-processing": "&#x421;&#x43B;&#x438;&#x43A;&#x430;&#x442;&#x430; &#x441;&#x435; &#x43F;&#x440;&#x43E;&#x446;&#x435;&#x441;&#x438;&#x440;&#x430; - &#x43E;&#x441;&#x442;&#x430;&#x43D;&#x435;&#x442;&#x435; &#x432;&#x43E; &#x442;&#x435;&#x43A;.",
                  "ziggeoimageviewer.image-access-error": "&#x421;&#x43B;&#x438;&#x43A;&#x430;&#x442;&#x430; &#x435; &#x43F;&#x43E;&#x434; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x430;&#x446;&#x438;&#x458;&#x430;. &#x41C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x434;&#x430; &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x430;&#x43A;.",
                  "ziggeoplayer.video-not-found": "&#x41D;&#x435;&#x43C;&#x43E;&#x436;&#x435;&#x432;&#x43C;&#x435; &#x434;&#x430; &#x433;&#x43E; &#x43D;&#x430;&#x458;&#x434;&#x435;&#x43C;&#x435; &#x438;&#x437;&#x431;&#x440;&#x430;&#x43D;&#x438;&#x43E;&#x442; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x444;&#x430;&#x458;&#x43B;.",
                  "ziggeoplayer.video-access-forbidden": "&#x412;&#x438;&#x435; &#x43D;&#x435; &#x441;&#x442;&#x435; &#x434;&#x43E;&#x437;&#x432;&#x43E;&#x43B;&#x435;&#x43D;&#x438; &#x434;&#x430; &#x433;&#x43E; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x43E;&#x458; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x444;&#x430;&#x458;&#x43B;.",
                  "ziggeoplayer.video-unknown-error": "&#x41D;&#x435;&#x43C;&#x43E;&#x436;&#x435;&#x432;&#x43C;&#x435; &#x434;&#x430; &#x433;&#x43E; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x430;&#x43F;&#x438;&#x43C;&#x435; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x442;&#x43E; &#x432;&#x43E; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442;&#x43E;&#x432;. &#x412;&#x435; &#x43C;&#x43E;&#x43B;&#x438;&#x43C;&#x435;, &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x458;&#x442;&#x435; &#x43F;&#x43E;&#x434;&#x43E;&#x446;&#x43D;&#x430;.",
                  "ziggeoplayer.video-rejected": "&#x412;&#x438;&#x434;&#x435;&#x43E;&#x442;&#x43E; &#x435; &#x43E;&#x434;&#x431;&#x438;&#x435;&#x43D;&#x43E;.",
                  "ziggeoplayer.video-processing": "&#x412;&#x438;&#x434;&#x435;&#x43E;&#x442;&#x43E; &#x441;&#x435; &#x43F;&#x440;&#x43E;&#x446;&#x435;&#x441;&#x438;&#x440;&#x430; - &#x43E;&#x441;&#x442;&#x430;&#x43D;&#x435;&#x442;&#x435; &#x432;&#x43E; &#x442;&#x435;&#x43A;.",
                  "ziggeoplayer.video-access-error": "&#x412;&#x438;&#x434;&#x435;&#x43E;&#x442;&#x43E; &#x435; &#x43F;&#x43E;&#x434; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x430;&#x446;&#x438;&#x458;&#x430;. &#x41C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x434;&#x430; &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x431;&#x430;&#x442;&#x435; &#x43F;&#x430;&#x43A;."
                },
                "language:nl": {
                  "application.error_503": "Wij handhaven onze service. Video&#x27;s zullen snel terug zijn.",
                  "application.error_404": "We kunnen niet herkent uw API-sleutel. Zorg ervoor om het te specificeren in de header van uw website.",
                  "application.error_401": "Het is niet toegestaan &#x200B;&#x200B;om de toepassing van deze site.",
                  "application.error_412": "Je nodig hebt om te bevestigen / uw account upgraden.",
                  "application.error_unknown": "Er is een onbekende fout opgetreden. Ons team is aangemeld en zal het probleem op te lossen.",
                  "ziggeoaudioplayer.audio-not-found": "We konden het opgegeven audiobestand niet vinden.",
                  "ziggeoaudioplayer.audio-access-forbidden": "U heeft geen toegang tot dit audiobestand.",
                  "ziggeoaudioplayer.audio-unknown-error": "We hebben momenteel geen toegang tot deze audio. Probeer het later opnieuw.",
                  "ziggeoaudioplayer.audio-rejected": "De audio is afgewezen.",
                  "ziggeoaudioplayer.audio-processing": "De audio wordt verwerkt - even geduld aub.",
                  "ziggeoaudioplayer.audio-access-error": "De audio wordt momenteel gemodereerd. U kunt klikken om het opnieuw te proberen.",
                  "ziggeoimageviewer.image-not-found": "We konden het opgegeven afbeeldingsbestand niet vinden.",
                  "ziggeoimageviewer.image-access-forbidden": "U heeft geen toegang tot dit afbeeldingsbestand.",
                  "ziggeoimageviewer.image-unknown-error": "We hebben momenteel geen toegang tot deze afbeelding. Probeer het later opnieuw.",
                  "ziggeoimageviewer.image-rejected": "De afbeelding is afgewezen.",
                  "ziggeoimageviewer.image-processing": "Het beeld wordt verwerkt - even geduld aub.",
                  "ziggeoimageviewer.image-access-error": "De afbeelding wordt momenteel gemodereerd. U kunt klikken om het opnieuw te proberen.",
                  "ziggeoplayer.video-not-found": "We konden het opgegeven video-bestand niet vinden.",
                  "ziggeoplayer.video-access-forbidden": "U bent niet toegestaan &#x200B;&#x200B;om toegang tot dit videobestand.",
                  "ziggeoplayer.video-unknown-error": "We hebben geen toegang tot deze video op dit moment. Probeer het later opnieuw.",
                  "ziggeoplayer.video-rejected": "De video is geweigerd.",
                  "ziggeoplayer.video-processing": "De video wordt verwerkt - even geduld aub.",
                  "ziggeoplayer.video-access-error": "De video is momenteel in matiging. U kunt klikken om opnieuw te proberen."
                },
                "language:no": {
                  "application.error_503": "Vi opprettholder v&#xE5;r tjeneste. Videoer vil v&#xE6;re tilbake snart.",
                  "application.error_404": "Vi kan ikke gjenkjenne din API-n&#xF8;kkel. Vennligst s&#xF8;rg for &#xE5; spesifisere det i nettstedets spissen.",
                  "application.error_401": "Du har ikke lov til &#xE5; f&#xE5; tilgang til programmet fra denne siden.",
                  "application.error_412": "Du m&#xE5; bekrefte / oppgradere kontoen din.",
                  "application.error_unknown": "En ukjent feil oppstod. V&#xE5;rt team har blitt informert og l&#xF8;se problemet.",
                  "ziggeoplayer.video-not-found": "Vi kunne ikke finne den angitte videofilen.",
                  "ziggeoplayer.video-access-forbidden": "Du har ikke tillatelse til &#xE5; f&#xE5; tilgang til denne videofilen.",
                  "ziggeoplayer.video-unknown-error": "Vi har ikke tilgang til denne videoen i &#xF8;yeblikket. Pr&#xF8;v igjen senere.",
                  "ziggeoplayer.video-rejected": "Videoen har blitt avvist.",
                  "ziggeoplayer.video-processing": "Videoen behandler - f&#xF8;lg med.",
                  "ziggeoplayer.video-access-error": "Videoen er under moderering. Du kan klikke for &#xE5; pr&#xF8;ve igjen.",
                  "ziggeoaudioplayer.audio-not-found": "Vi kunne ikke finne den spesifiserte lydfilen.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Du har ikke tilgang til denne lydfilen.",
                  "ziggeoaudioplayer.audio-unknown-error": "Vi har ikke tilgang til denne lyden for &#xF8;yeblikket. Pr&#xF8;v igjen senere.",
                  "ziggeoaudioplayer.audio-rejected": "Lyden er avvist.",
                  "ziggeoaudioplayer.audio-processing": "Lyden behandles - f&#xF8;lg med.",
                  "ziggeoaudioplayer.audio-access-error": "Lyden er for tiden under moderering. Du kan klikke for &#xE5; pr&#xF8;ve p&#xE5; nytt.",
                  "ziggeoimageviewer.image-not-found": "Vi kunne ikke finne den spesifiserte bildefilen.",
                  "ziggeoimageviewer.image-access-forbidden": "Du har ikke tilgang til denne bildefilen.",
                  "ziggeoimageviewer.image-unknown-error": "Vi kan ikke f&#xE5; tilgang til dette bildet for &#xF8;yeblikket. Pr&#xF8;v igjen senere.",
                  "ziggeoimageviewer.image-rejected": "Bildet er avvist.",
                  "ziggeoimageviewer.image-processing": "Bildet er under behandling - f&#xF8;lg med.",
                  "ziggeoimageviewer.image-access-error": "Bildet er for tiden under moderering. Du kan klikke for &#xE5; pr&#xF8;ve p&#xE5; nytt."
                },
                "language:pl": {
                  "application.error_503": "Serwisujemy nasz&#x105; us&#x142;ug&#x119;. Nied&#x142;ugo wracamy!",
                  "application.error_404": "Nie mo&#x17C;emy rozpozna&#x107; Twojego klucza API. Pami&#x119;taj, aby poda&#x107; go w nag&#x142;&#xF3;wku witryny.",
                  "application.error_401": "Nie masz uprawnie&#x144;, aby uzyska&#x107; dost&#x119;p do aplikacji z tej strony.",
                  "application.error_412": "Musisz potwierdzi&#x107; / ulepszy&#x107; konto.",
                  "application.error_unknown": "Wyst&#x105;pi&#x142; nieznany b&#x142;&#x105;d. Nasz zesp&#xF3;&#x142; zosta&#x142; powiadomiony i b&#x119;dzie rozwi&#x105;zywa&#x107; problem.",
                  "ziggeoaudioplayer.audio-not-found": "Nie mo&#x17C;na znale&#x17A;&#x107;&#xA0;okre&#x15B;lnego pliku audio.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Nie masz uprawnie&#x144;, aby uzyska&#x107; dost&#x119;p do tego pliku audio.",
                  "ziggeoaudioplayer.audio-unknown-error": "Nie mo&#x17C;na aktualnie uzyska&#x107; dost&#x119;pu do tego pliku audio. Spr&#xF3;buj ponownie p&#xF3;&#x17A;niej.",
                  "ziggeoaudioplayer.audio-rejected": "Audio zosta&#x142;o odrzucone.",
                  "ziggeoaudioplayer.audio-processing": "Audio jest przetwarzane.",
                  "ziggeoaudioplayer.audio-access-error": "Audio jest obecnie w moderacji. Kliknij, aby ponowi&#x107;.",
                  "ziggeoimageviewer.image-not-found": "Nie mo&#x17C;na znale&#x17A;&#x107; okre&#x15B;lonego pliku zdj&#x119;cia.",
                  "ziggeoimageviewer.image-access-forbidden": "Nie masz uprawnie&#x144;, aby uzyska&#x107; dost&#x119;p do tego zdj&#x119;cia.",
                  "ziggeoimageviewer.image-unknown-error": "Nie mo&#x17C;na aktualnie uzyska&#x107; dost&#x119;pu do tego zdj&#x119;cia. Spr&#xF3;buj ponownie p&#xF3;&#x17A;niej.",
                  "ziggeoimageviewer.image-rejected": "Zdj&#x119;cie zosta&#x142;o odrzucone.",
                  "ziggeoimageviewer.image-processing": "Przetwarzanie zdj&#x119;cia.",
                  "ziggeoimageviewer.image-access-error": "Zdj&#x119;cie jest obecnie w moderacji. Kliknij, aby ponowi&#x107;.",
                  "ziggeoplayer.video-not-found": "Nie mo&#x17C;na znale&#x17A;&#x107; okre&#x15B;lonego pliku wideo.",
                  "ziggeoplayer.video-access-forbidden": "Nie masz wystarczaj&#x105;cych uprawnie&#x144;, aby uzyska&#x107; dost&#x119;p do tego pliku wideo. Spr&#xF3;buj ponownie p&#xF3;&#x17A;niej.",
                  "ziggeoplayer.video-unknown-error": "Nie mo&#x17C;emy uzyska&#x107; obecnie dost&#x119;pu do tego filmu. Spr&#xF3;buj ponownie p&#xF3;&#x17A;niej.",
                  "ziggeoplayer.video-rejected": "Film zosta&#x142; odrzucony.",
                  "ziggeoplayer.video-processing": "Film jest przetwarzany.",
                  "ziggeoplayer.video-access-error": "Film jest obecnie w moderacji. Kliknij, aby ponowi&#x107; pr&#xF3;b&#x119;."
                },
                "language:pt-br": {
                  "application.error_503": "Nosso servi&#xE7;o est&#xE1; em manuten&#xE7;&#xE3;o. Estaremos de volta em breve.",
                  "application.error_404": "N&#xE3;o conseguimos reconhecer a sua chave de API. Por favor, certifique-se de especific&#xE1;-la no cabe&#xE7;alho do seu site.",
                  "application.error_401": "Voc&#xEA; n&#xE3;o tem permiss&#xE3;o para acessar o aplicativo a partir deste site.",
                  "application.error_412": "Voc&#xEA; precisa confirmar / atualizar a sua conta.",
                  "application.error_unknown": "Ocorreu um erro desconhecido. Nossa equipe foi notificada e ir&#xE1; resolver o problema.",
                  "ziggeoaudioplayer.audio-not-found": "N&#xF3;s n&#xE3;o encontramos o arquivo de &#xE1;udio especificado.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Voc&#xEA; n&#xE3;o tem permiss&#xE3;o para acessar esse arquivo de &#xE1;udio.",
                  "ziggeoaudioplayer.audio-unknown-error": "N&#xF3;s n&#xE3;o conseguimos acessar esse &#xE1;udio no momento. Por favor tente novamente mais tarde.",
                  "ziggeoaudioplayer.audio-rejected": "O &#xE1;udio foi rejeitado.",
                  "ziggeoaudioplayer.audio-processing": "O &#xE1;udio est&#xE1; sendo processado - fique atento.",
                  "ziggeoaudioplayer.audio-access-error": "O &#xE1;udio est&#xE1; sob modera&#xE7;&#xE3;o. Voc&#xEA; pode clicar para tentar novamente.",
                  "ziggeoimageviewer.image-not-found": "N&#xF3;s n&#xE3;o encontramos esse arquivo espec&#xED;fico de imagem.",
                  "ziggeoimageviewer.image-access-forbidden": "Voc&#xEA; n&#xE3;o tem permiss&#xE3;o para acessar esse arquivo de imagem.",
                  "ziggeoimageviewer.image-unknown-error": "N&#xF3;s n&#xE3;o conseguimos acessar essa imagem no momento. Por favor tente novamente mais tarde.",
                  "ziggeoimageviewer.image-rejected": "A imagem foi rejeitada.",
                  "ziggeoimageviewer.image-processing": "A imagem est&#xE1; sendo processada - fique atento.",
                  "ziggeoimageviewer.image-access-error": "A imagem est&#xE1; sob modera&#xE7;&#xE3;o. Voc&#xEA; pode clicar para tentar novamente.",
                  "ziggeoplayer.video-not-found": "N&#xE3;o foi poss&#xED;vel encontrar o arquivo de v&#xED;deo especificado.",
                  "ziggeoplayer.video-access-forbidden": "Voc&#xEA; n&#xE3;o tem permiss&#xE3;o para acessar esse arquivo de v&#xED;deo.",
                  "ziggeoplayer.video-unknown-error": "N&#xE3;o podemos acessar este v&#xED;deo no momento. Por favor, tente novamente mais tarde.",
                  "ziggeoplayer.video-rejected": "O v&#xED;deo foi rejeitado.",
                  "ziggeoplayer.video-processing": "O v&#xED;deo est&#xE1; sendo processado - fique de olho.",
                  "ziggeoplayer.video-access-error": "O v&#xED;deo est&#xE1; em modera&#xE7;&#xE3;o. Voc&#xEA; pode clicar para tentar novamente."
                },
                "language:pt": {
                  "application.error_503": "O nosso servi&#xE7;o est&#xE1; em manuten&#xE7;&#xE3;o. Os v&#xED;deos voltar&#xE3;o em breve.",
                  "application.error_404": "N&#xE3;o reconhecemos sua chave de API. Certifique-se de especific&#xE1;-la no cabe&#xE7;alho de seu site.",
                  "application.error_401": "N&#xE3;o tem permiss&#xF5;es para aceder a esta aplica&#xE7;&#xE3;o.",
                  "application.error_412": "Tem de confirmar / atualizar a sua conta.",
                  "application.error_unknown": "Ocorreu um erro desconhecido. A nossa equipa foi notificada e ir&#xE1; resolver o problema.",
                  "ziggeoplayer.video-not-found": "N&#xE3;o foi poss&#xED;vel encontrar o v&#xED;deo especificado.",
                  "ziggeoplayer.video-access-forbidden": "N&#xE3;o tem permiss&#xF5;es para aceder a este v&#xED;deo.",
                  "ziggeoplayer.video-unknown-error": "N&#xE3;o conseguimos aceder a este v&#xED;deo neste momento. Por favor, tente de novo mais tarde.",
                  "ziggeoplayer.video-rejected": "O v&#xED;deo foi rejeitado.",
                  "ziggeoplayer.video-processing": "O v&#xED;deo est&#xE1; em processamento - fique atento.",
                  "ziggeoplayer.video-access-error": "O v&#xED;deo est&#xE1; atualmente sob modera&#xE7;&#xE3;o. Pode clicar para tentar novamente.",
                  "ziggeoaudioplayer.audio-not-found": "N&#xE3;o foi poss&#xED;vel encontrar o arquivo de &#xE1;udio especificado.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Voc&#xEA; n&#xE3;o tem permiss&#xE3;o para acessar este arquivo de &#xE1;udio.",
                  "ziggeoaudioplayer.audio-unknown-error": "N&#xE3;o podemos acessar este &#xE1;udio no momento. Por favor, tente novamente mais tarde.",
                  "ziggeoaudioplayer.audio-rejected": "O &#xE1;udio foi rejeitado.",
                  "ziggeoaudioplayer.audio-processing": "O &#xE1;udio est&#xE1; sendo processado - fique ligado.",
                  "ziggeoaudioplayer.audio-access-error": "O &#xE1;udio est&#xE1; atualmente sob modera&#xE7;&#xE3;o. Voc&#xEA; pode clicar para tentar novamente.",
                  "ziggeoimageviewer.image-not-found": "N&#xE3;o foi poss&#xED;vel encontrar o arquivo de imagem especificado.",
                  "ziggeoimageviewer.image-access-forbidden": "Voc&#xEA; n&#xE3;o tem permiss&#xE3;o para acessar este arquivo de imagem.",
                  "ziggeoimageviewer.image-unknown-error": "N&#xE3;o podemos acessar esta imagem no momento. Por favor, tente novamente mais tarde.",
                  "ziggeoimageviewer.image-rejected": "A imagem foi rejeitada.",
                  "ziggeoimageviewer.image-processing": "A imagem est&#xE1; sendo processada - fique atento.",
                  "ziggeoimageviewer.image-access-error": "A imagem est&#xE1; atualmente sob modera&#xE7;&#xE3;o. Voc&#xEA; pode clicar para tentar novamente."
                },
                "language:ro": {
                  "application.error_503": "Ne men&#x21B;inem serviciul nostru. Videoclipurile vor reveni &#xEE;n cur&#xE2;nd.",
                  "application.error_404": "Noi nu putem recunoaste cheia API-ului. Asigura&#x21B;i-v&#x103; c&#x103; specifica&#x21B;i acest lucru &#xEE;n antetul site-ului.",
                  "application.error_401": "Nu ave&#x21B;i permisiunea de a accesa aplica&#x21B;ia de pe acest site.",
                  "application.error_412": "Trebuie s&#x103; confirma&#x21B;i / actualiza&#x21B;i contul.",
                  "application.error_unknown": "A ap&#x103;rut o eroare necunoscut&#x103;. Echipa noastr&#x103; a fost notificat&#x103; &#x219;i va rezolva problema.",
                  "ziggeoplayer.video-not-found": "Nu am putut g&#x103;si fi&#x219;ierul video specificat.",
                  "ziggeoplayer.video-access-forbidden": "Nu ave&#x21B;i permisiunea de a accesa acest fi&#x219;ier video.",
                  "ziggeoplayer.video-unknown-error": "Noi nu putem avea acces la acest video la acest moment. V&#x103; rug&#x103;m s&#x103; &#xEE;ncerca&#x21B;i din nou mai t&#xE2;rziu.",
                  "ziggeoplayer.video-rejected": "Videoclipul a fost respins.",
                  "ziggeoplayer.video-processing": "Videoclipul se proceseaz&#x103; - V&#x103; rug&#x103;m s&#x103; a&#x219;tepta&#x21B;i.",
                  "ziggeoplayer.video-access-error": "Video este &#xEE;n prezent &#xEE;n curs de moderare. Ave&#x21B;i dreptul s&#x103; face&#x21B;i clic pentru a &#xEE;ncerca din nou.",
                  "ziggeoaudioplayer.audio-not-found": "Nu am putut g&#x103;si fi&#x219;ierul audio specificat.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Nu ave&#x21B;i permisiunea de a accesa acest fi&#x219;ier audio.",
                  "ziggeoaudioplayer.audio-unknown-error": "Nu putem accesa acest fi&#x219;ier audio &#xEE;n acest moment. V&#x103; rug&#x103;m s&#x103; &#xEE;ncerca&#x21B;i din nou mai t&#xE2;rziu.",
                  "ziggeoaudioplayer.audio-rejected": "Sunetul a fost respins.",
                  "ziggeoaudioplayer.audio-processing": "Sunetul se proceseaz&#x103; - V&#x103; rug&#x103;m s&#x103; a&#x219;tepta&#x21B;i.",
                  "ziggeoaudioplayer.audio-access-error": "Sunetul este &#xEE;n prezent sub moderare. Pute&#x21B;i face clic pentru a &#xEE;ncerca din nou.",
                  "ziggeoimageviewer.image-not-found": "Nu am putut g&#x103;si fi&#x219;ierul imagine specificat.",
                  "ziggeoimageviewer.image-access-forbidden": "Nu ave&#x21B;i permisiunea de a accesa acest fi&#x219;ier imagine.",
                  "ziggeoimageviewer.image-unknown-error": "Nu putem accesa aceast&#x103; imagine &#xEE;n acest moment. V&#x103; rug&#x103;m s&#x103; &#xEE;ncerca&#x21B;i din nou mai t&#xE2;rziu.",
                  "ziggeoimageviewer.image-rejected": "Imaginea a fost respins&#x103;.",
                  "ziggeoimageviewer.image-processing": "Imaginea se proceseaz&#x103; - V&#x103; rug&#x103;m s&#x103; a&#x219;tepta&#x21B;i.",
                  "ziggeoimageviewer.image-access-error": "Imaginea este &#xEE;n prezent &#xEE;n curs de moderare. Pute&#x21B;i face clic pentru a &#xEE;ncerca din nou."
                },
                "language:ru": {
                  "application.error_503": "&#x41C;&#x44B; &#x43D;&#x430; &#x442;&#x435;&#x445;&#x43D;&#x438;&#x447;&#x435;&#x441;&#x43A;&#x43E;&#x43C; &#x43E;&#x431;&#x441;&#x43B;&#x443;&#x436;&#x438;&#x432;&#x430;&#x43D;&#x438;&#x438;. &#x412;&#x438;&#x434;&#x435;&#x43E; &#x441;&#x43A;&#x43E;&#x440;&#x43E; &#x432;&#x435;&#x440;&#x43D;&#x443;&#x442;&#x441;&#x44F;.",
                  "application.error_404": "&#x41C;&#x44B; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x43C; &#x440;&#x430;&#x441;&#x43F;&#x43E;&#x437;&#x43D;&#x430;&#x442;&#x44C; &#x432;&#x430;&#x448; &#x43A;&#x43B;&#x44E;&#x447; api. &#x41D;&#x435; &#x437;&#x430;&#x431;&#x443;&#x434;&#x44C;&#x442;&#x435; &#x443;&#x43A;&#x430;&#x437;&#x430;&#x442;&#x44C; &#x435;&#x433;&#x43E; &#x432; &#x437;&#x430;&#x433;&#x43E;&#x43B;&#x43E;&#x432;&#x43A;&#x435; &#x441;&#x432;&#x43E;&#x435;&#x433;&#x43E; &#x432;&#x435;&#x431;-&#x441;&#x430;&#x439;&#x442;&#x430;.",
                  "application.error_401": "&#x423; &#x432;&#x430;&#x441; &#x43D;&#x435;&#x442; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x430; &#x43A; &#x43F;&#x440;&#x438;&#x43B;&#x43E;&#x436;&#x435;&#x43D;&#x438;&#x44E; &#x441; &#x44D;&#x442;&#x43E;&#x433;&#x43E; &#x441;&#x430;&#x439;&#x442;&#x430;.",
                  "application.error_412": "&#x412;&#x430;&#x43C; &#x43D;&#x435;&#x43E;&#x431;&#x445;&#x43E;&#x434;&#x438;&#x43C;&#x43E; &#x43F;&#x43E;&#x434;&#x442;&#x432;&#x435;&#x440;&#x434;&#x438;&#x442;&#x44C; / &#x43E;&#x431;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x44C; &#x441;&#x432;&#x43E;&#x44E; &#x443;&#x447;&#x435;&#x442;&#x43D;&#x443;&#x44E; &#x437;&#x430;&#x43F;&#x438;&#x441;&#x44C;.",
                  "application.error_unknown": "&#x41F;&#x440;&#x43E;&#x438;&#x437;&#x43E;&#x448;&#x43B;&#x430; &#x43D;&#x435;&#x438;&#x437;&#x432;&#x435;&#x441;&#x442;&#x43D;&#x430;&#x44F; &#x43E;&#x448;&#x438;&#x431;&#x43A;&#x430;. &#x41D;&#x430;&#x448;&#x430; &#x43A;&#x43E;&#x43C;&#x430;&#x43D;&#x434;&#x430; &#x43F;&#x43E;&#x43B;&#x443;&#x447;&#x438;&#x43B;&#x430; &#x443;&#x432;&#x435;&#x434;&#x43E;&#x43C;&#x43B;&#x435;&#x43D;&#x438;&#x435; &#x438; &#x43C;&#x44B; &#x440;&#x435;&#x448;&#x438;&#x43C; &#x43F;&#x440;&#x43E;&#x431;&#x43B;&#x435;&#x43C;&#x443;.",
                  "ziggeoplayer.video-not-found": "&#x41D;&#x435; &#x443;&#x434;&#x430;&#x43B;&#x43E;&#x441;&#x44C; &#x43D;&#x430;&#x439;&#x442;&#x438; &#x443;&#x43A;&#x430;&#x437;&#x430;&#x43D;&#x43D;&#x44B;&#x439; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x444;&#x430;&#x439;&#x43B;.",
                  "ziggeoplayer.video-access-forbidden": "&#x412;&#x430;&#x43C; &#x43D;&#x435; &#x440;&#x430;&#x437;&#x440;&#x435;&#x448;&#x435;&#x43D; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x43A; &#x44D;&#x442;&#x43E;&#x43C;&#x443; &#x432;&#x438;&#x434;&#x435;&#x43E;&#x444;&#x430;&#x439;&#x43B;&#x443;.",
                  "ziggeoplayer.video-unknown-error": "&#x412; &#x43D;&#x430;&#x441;&#x442;&#x43E;&#x44F;&#x449;&#x435;&#x435; &#x432;&#x440;&#x435;&#x43C;&#x44F; &#x443; &#x43D;&#x430;&#x441; &#x43D;&#x435;&#x442; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x430; &#x43A; &#x44D;&#x442;&#x43E;&#x43C;&#x443; &#x432;&#x438;&#x434;&#x435;&#x43E;. &#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443; &#x43F;&#x43E;&#x437;&#x436;&#x435;.",
                  "ziggeoplayer.video-rejected": "&#x412;&#x438;&#x434;&#x435;&#x43E; &#x43E;&#x442;&#x43A;&#x43B;&#x43E;&#x43D;&#x435;&#x43D;&#x43E;.",
                  "ziggeoplayer.video-processing": "&#x412;&#x438;&#x434;&#x435;&#x43E; &#x43E;&#x431;&#x440;&#x430;&#x431;&#x430;&#x442;&#x44B;&#x432;&#x430;&#x435;&#x442;&#x441;&#x44F; - &#x441;&#x43B;&#x435;&#x434;&#x438;&#x442;&#x435; &#x437;&#x430; &#x43E;&#x431;&#x43D;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x438;&#x44F;&#x43C;&#x438;.",
                  "ziggeoplayer.video-access-error": "&#x412; &#x43D;&#x430;&#x441;&#x442;&#x43E;&#x44F;&#x449;&#x435;&#x435; &#x432;&#x440;&#x435;&#x43C;&#x44F; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x43D;&#x430; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x430;&#x446;&#x438;&#x438;. &#x41D;&#x430;&#x436;&#x43C;&#x438;&#x442;&#x435;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ziggeoaudioplayer.audio-not-found": "&#x41D;&#x435; &#x443;&#x434;&#x430;&#x43B;&#x43E;&#x441;&#x44C; &#x43D;&#x430;&#x439;&#x442;&#x438; &#x443;&#x43A;&#x430;&#x437;&#x430;&#x43D;&#x43D;&#x44B;&#x439; &#x430;&#x443;&#x434;&#x438;&#x43E;&#x444;&#x430;&#x439;&#x43B;.",
                  "ziggeoaudioplayer.audio-access-forbidden": "&#x423; &#x432;&#x430;&#x441; &#x43D;&#x435;&#x442; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x430; &#x43A; &#x44D;&#x442;&#x43E;&#x43C;&#x443; &#x430;&#x443;&#x434;&#x438;&#x43E;&#x444;&#x430;&#x439;&#x43B;&#x443;.",
                  "ziggeoaudioplayer.audio-unknown-error": "&#x412; &#x43D;&#x430;&#x441;&#x442;&#x43E;&#x44F;&#x449;&#x438;&#x439; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442; &#x43C;&#x44B; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x43C; &#x43F;&#x43E;&#x43B;&#x443;&#x447;&#x438;&#x442;&#x44C; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x43A; &#x44D;&#x442;&#x43E;&#x43C;&#x443; &#x430;&#x443;&#x434;&#x438;&#x43E;. &#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443; &#x43F;&#x43E;&#x437;&#x436;&#x435;.",
                  "ziggeoaudioplayer.audio-rejected": "&#x410;&#x443;&#x434;&#x438;&#x43E; &#x431;&#x44B;&#x43B;&#x43E; &#x43E;&#x442;&#x43A;&#x43B;&#x43E;&#x43D;&#x435;&#x43D;&#x43E;.",
                  "ziggeoaudioplayer.audio-processing": "&#x410;&#x443;&#x434;&#x438;&#x43E; &#x43E;&#x431;&#x440;&#x430;&#x431;&#x430;&#x442;&#x44B;&#x432;&#x430;&#x435;&#x442;&#x441;&#x44F; - &#x441;&#x43B;&#x435;&#x434;&#x438;&#x442;&#x435; &#x437;&#x430; &#x43E;&#x431;&#x43D;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x438;&#x44F;&#x43C;&#x438;.",
                  "ziggeoaudioplayer.audio-access-error": "&#x410;&#x443;&#x434;&#x438;&#x43E; &#x432; &#x43D;&#x430;&#x441;&#x442;&#x43E;&#x44F;&#x449;&#x435;&#x435; &#x432;&#x440;&#x435;&#x43C;&#x44F; &#x43F;&#x440;&#x43E;&#x445;&#x43E;&#x434;&#x438;&#x442; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x430;&#x446;&#x438;&#x44E;. &#x412;&#x44B; &#x43C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x43D;&#x430;&#x436;&#x430;&#x442;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;.",
                  "ziggeoimageviewer.image-not-found": "&#x41D;&#x435; &#x443;&#x434;&#x430;&#x43B;&#x43E;&#x441;&#x44C; &#x43D;&#x430;&#x439;&#x442;&#x438; &#x443;&#x43A;&#x430;&#x437;&#x430;&#x43D;&#x43D;&#x44B;&#x439; &#x444;&#x430;&#x439;&#x43B; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x44F;.",
                  "ziggeoimageviewer.image-access-forbidden": "&#x423; &#x432;&#x430;&#x441; &#x43D;&#x435;&#x442; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x430; &#x43A; &#x44D;&#x442;&#x43E;&#x43C;&#x443; &#x444;&#x430;&#x439;&#x43B;&#x443; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x44F;.",
                  "ziggeoimageviewer.image-unknown-error": "&#x412; &#x43D;&#x430;&#x441;&#x442;&#x43E;&#x44F;&#x449;&#x438;&#x439; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442; &#x43C;&#x44B; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x43C; &#x43F;&#x43E;&#x43B;&#x443;&#x447;&#x438;&#x442;&#x44C; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x43A; &#x44D;&#x442;&#x43E;&#x43C;&#x443; &#x438;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x44E;. &#x41F;&#x43E;&#x436;&#x430;&#x43B;&#x443;&#x439;&#x441;&#x442;&#x430;, &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x435; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443; &#x43F;&#x43E;&#x437;&#x436;&#x435;.",
                  "ziggeoimageviewer.image-rejected": "&#x418;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435; &#x431;&#x44B;&#x43B;&#x43E; &#x43E;&#x442;&#x43A;&#x43B;&#x43E;&#x43D;&#x435;&#x43D;&#x43E;.",
                  "ziggeoimageviewer.image-processing": "&#x418;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435; &#x43E;&#x431;&#x440;&#x430;&#x431;&#x430;&#x442;&#x44B;&#x432;&#x430;&#x435;&#x442;&#x441;&#x44F; - &#x441;&#x43B;&#x435;&#x434;&#x438;&#x442;&#x435; &#x437;&#x430; &#x43E;&#x431;&#x43D;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x438;&#x44F;&#x43C;&#x438;.",
                  "ziggeoimageviewer.image-access-error": "&#x418;&#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x438;&#x435; &#x432; &#x43D;&#x430;&#x441;&#x442;&#x43E;&#x44F;&#x449;&#x435;&#x435; &#x432;&#x440;&#x435;&#x43C;&#x44F; &#x43F;&#x440;&#x43E;&#x445;&#x43E;&#x434;&#x438;&#x442; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x430;&#x446;&#x438;&#x44E;. &#x412;&#x44B; &#x43C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x43D;&#x430;&#x436;&#x430;&#x442;&#x44C;, &#x447;&#x442;&#x43E;&#x431;&#x44B; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x44C; &#x43F;&#x43E;&#x43F;&#x44B;&#x442;&#x43A;&#x443;."
                },
                "language:sk": {
                  "application.error_503": "T&#xFA;to slu&#x17E;bu pr&#xE1;ve vylep&#x161;ujeme. Mo&#x17E;nos&#x165; nahrania video&#x17E;ivotopisu bude dostupn&#xE1; u&#x17E; onedlho. T&#xFA;to slu&#x17E;bu pr&#xE1;ve vylep&#x161;ujeme. Mo&#x17E;nos&#x165; nahrania video&#x17E;ivotopisu bude op&#xE4;tovne spusten&#xE1; u&#x17E; onedlho.",
                  "application.error_404": "Nedar&#xED; sa n&#xE1;m rozpozna&#x165; V&#xE1;&#x161; API k&#x13E;&#xFA;&#x10D;. Uistite sa, pros&#xED;m, &#x10D;i ho m&#xE1;te v hlavi&#x10D;ke V&#xE1;&#x161;ho webu.",
                  "application.error_401": "Nem&#xE1;te pr&#xED;stup k aplik&#xE1;cii na tejto str&#xE1;nke.",
                  "application.error_412": "Mus&#xED;te potvrdi&#x165; / aktualizova&#x165; svoj &#xFA;&#x10D;et.",
                  "application.error_unknown": "Vyskytla sa nezn&#xE1;ma chyba. N&#xE1;&#x161; t&#xED;m bol upozornen&#xFD; a bude tento probl&#xE9;m rie&#x161;i&#x165;.",
                  "ziggeoplayer.video-not-found": "Nepodarilo sa n&#xE1;m n&#xE1;js&#x165; zadan&#xFD; video s&#xFA;bor.",
                  "ziggeoplayer.video-access-forbidden": "K tomuto video s&#xFA;boru nem&#xE1;te povolen&#xFD; pr&#xED;stup.",
                  "ziggeoplayer.video-unknown-error": "K tomuto videu nem&#xE1;me moment&#xE1;lne pr&#xED;stup. Sk&#xFA;ste nesk&#xF4;r pros&#xED;m.",
                  "ziggeoplayer.video-rejected": "Video bolo zamietnut&#xE9;.",
                  "ziggeoplayer.video-processing": "Video sa spracov&#xE1;va.",
                  "ziggeoplayer.video-access-error": "Video je moment&#xE1;lne pou&#x17E;&#xED;van&#xE9;. Kliknut&#xED;m sk&#xFA;ste znova.",
                  "ziggeoaudioplayer.audio-not-found": "Zadan&#xFD; zvukov&#xFD; s&#xFA;bor sa n&#xE1;m nepodarilo n&#xE1;js&#x165;.",
                  "ziggeoaudioplayer.audio-access-forbidden": "K tomuto zvukov&#xE9;mu s&#xFA;boru nem&#xE1;te pr&#xED;stup.",
                  "ziggeoaudioplayer.audio-unknown-error": "Moment&#xE1;lne nem&#xE1;me pr&#xED;stup k tomuto zvuku. Sk&#xFA;ste nesk&#xF4;r pros&#xED;m.",
                  "ziggeoaudioplayer.audio-rejected": "Zvuk bol odmietnut&#xFD;.",
                  "ziggeoaudioplayer.audio-processing": "Zvuk sa spracov&#xE1;va - zosta&#x148;te naladen&#xED;.",
                  "ziggeoaudioplayer.audio-access-error": "Zvuk je moment&#xE1;lne v moderovan&#xED;. Kliknut&#xED;m to m&#xF4;&#x17E;ete sk&#xFA;si&#x165; znova.",
                  "ziggeoimageviewer.image-not-found": "Nepodarilo sa n&#xE1;m n&#xE1;js&#x165; zadan&#xFD; obrazov&#xFD; s&#xFA;bor.",
                  "ziggeoimageviewer.image-access-forbidden": "K tomuto s&#xFA;boru obr&#xE1;zka nem&#xE1;te pr&#xED;stup.",
                  "ziggeoimageviewer.image-unknown-error": "Moment&#xE1;lne nem&#xE1;me pr&#xED;stup k tomuto obr&#xE1;zku. Sk&#xFA;ste nesk&#xF4;r pros&#xED;m.",
                  "ziggeoimageviewer.image-rejected": "Obr&#xE1;zok bol odmietnut&#xFD;.",
                  "ziggeoimageviewer.image-processing": "Obr&#xE1;zok sa spracov&#xE1;va - zosta&#x148;te naladen&#xED;.",
                  "ziggeoimageviewer.image-access-error": "Obr&#xE1;zok je moment&#xE1;lne v moderovan&#xED;. Kliknut&#xED;m to m&#xF4;&#x17E;ete sk&#xFA;si&#x165; znova."
                },
                "language:sl": {
                  "application.error_503": "Na&#x161;a storitev je v vzdr&#x17E;evanju. Kmalu se vrnemo.",
                  "application.error_404": "Ne moremo prepoznati va&#x161;ega API klju&#x10D;a. Prosimo, navedite ga v glavi va&#x161;ega spletnega mesta.",
                  "application.error_401": "Do te aplikacije ne morete dostopati s te spletne strani.",
                  "application.error_412": "Ra&#x10D;un morate potrditi / nadgraditi.",
                  "application.error_unknown": "Pri&#x161;lo je do neznane napake. Na&#x161; tim je o te&#x17E;avi obve&#x161;&#x10D;en in jo bo odpravil.",
                  "ziggeoaudioplayer.audio-not-found": "Navedene zvo&#x10D;ne datotete nismo na&#x161;li.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Do te zvo&#x10D;ne datoteke nimate dostopa.",
                  "ziggeoaudioplayer.audio-unknown-error": "Trenutno ne moremo dostopati do zvo&#x10D;ne datoteke. Prosimo, poskusite kasneje.",
                  "ziggeoaudioplayer.audio-rejected": "Zvok je bil zavrnjen.",
                  "ziggeoaudioplayer.audio-processing": "Zvok je v obdelavi - ostanite z nami.",
                  "ziggeoaudioplayer.audio-access-error": "Zvok je v obdelavi. Klikni za ponovni poskus.",
                  "ziggeoimageviewer.image-not-found": "Navedene slikovne datoteke nismo na&#x161;li.",
                  "ziggeoimageviewer.image-access-forbidden": "Do te slikovne datoteke nimate dostopa.",
                  "ziggeoimageviewer.image-unknown-error": "Trenutno ne moremo dostopati do slikovne datoteke. Prosimo, poskusite kasneje.",
                  "ziggeoimageviewer.image-rejected": "Slika je bila zavrnjena.",
                  "ziggeoimageviewer.image-processing": "Slika je v obdelavi - ostanite z nami.",
                  "ziggeoimageviewer.image-access-error": "Slika je v obdelavi. Klikni za ponovni poskus.",
                  "ziggeoplayer.video-not-found": "Navedene video datoteke nismo na&#x161;li.",
                  "ziggeoplayer.video-access-forbidden": "Do te video datoteke nimate dostopa.",
                  "ziggeoplayer.video-unknown-error": "Trenutno ne moremo dostopati do video datoteke. Prosimo, poskusite kasneje.",
                  "ziggeoplayer.video-rejected": "Video je bil zavrnjen.",
                  "ziggeoplayer.video-processing": "Video je v obdelavi - ostanite z nami.",
                  "ziggeoplayer.video-access-error": "Video je v obdelavi - ostanite z nami."
                },
                "language:sr": {
                  "application.error_503": "&#x41C;&#x438; &#x441;&#x43C;&#x43E; &#x43E;&#x434;&#x440;&#x436;&#x430;&#x432;&#x430;&#x45A;&#x435; &#x43D;&#x430;&#x448;&#x435; &#x443;&#x441;&#x43B;&#x443;&#x433;&#x435;. &#x412;&#x438;&#x434;&#x435;&#x43E; &#x45B;&#x435; &#x441;&#x435; &#x432;&#x440;&#x430;&#x442;&#x438;&#x442;&#x438; &#x443;&#x441;&#x43A;&#x43E;&#x440;&#x43E;.",
                  "application.error_404": "&#x41D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x43C;&#x43E; &#x43F;&#x440;&#x435;&#x43F;&#x43E;&#x437;&#x43D;&#x430;&#x442;&#x438; &#x43A;&#x459;&#x443;&#x447; &#x410;&#x41F;&#x418;-&#x458;&#x430;. &#x423;&#x432;&#x435;&#x440;&#x438;&#x442;&#x435; &#x441;&#x435; &#x434;&#x430; &#x458;&#x435; &#x43D;&#x430;&#x432;&#x435;&#x434;&#x435;&#x442;&#x435; &#x443; &#x437;&#x430;&#x433;&#x43B;&#x430;&#x432;&#x459;&#x443; &#x432;&#x430;&#x448;&#x435;&#x433; &#x432;&#x435;&#x431;-&#x441;&#x430;&#x458;&#x442;&#x430;.",
                  "application.error_401": "&#x41D;&#x438;&#x441;&#x442;&#x435; &#x434;&#x43E;&#x437;&#x432;&#x43E;&#x459;&#x435;&#x43D; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F; &#x430;&#x43F;&#x43B;&#x438;&#x43A;&#x430;&#x446;&#x438;&#x458;&#x443; &#x441;&#x430; &#x43E;&#x432;&#x43E;&#x433; &#x441;&#x430;&#x458;&#x442;&#x430;.",
                  "application.error_412": "&#x41F;&#x43E;&#x442;&#x440;&#x435;&#x431;&#x43D;&#x43E; &#x458;&#x435; &#x434;&#x430; &#x43F;&#x43E;&#x442;&#x432;&#x440;&#x434;&#x438;&#x442;&#x435; / &#x43D;&#x430;&#x434;&#x43E;&#x433;&#x440;&#x430;&#x434;&#x438;&#x442;&#x435; &#x43D;&#x430;&#x43B;&#x43E;&#x433;.",
                  "application.error_unknown": "&#x41D;&#x435;&#x43F;&#x43E;&#x437;&#x43D;&#x430;&#x442;&#x435; &#x433;&#x440;&#x435;&#x448;&#x43A;&#x435;. &#x41D;&#x430;&#x448; &#x442;&#x438;&#x43C; &#x458;&#x435; &#x43E;&#x431;&#x430;&#x432;&#x435;&#x448;&#x442;&#x435;&#x43D; &#x438; &#x434;&#x430; &#x45B;&#x435; &#x440;&#x435;&#x448;&#x438;&#x442;&#x438; &#x43F;&#x440;&#x43E;&#x431;&#x43B;&#x435;&#x43C;.",
                  "ziggeoplayer.video-not-found": "&#x41D;&#x438;&#x441;&#x43C;&#x43E; &#x43C;&#x43E;&#x433;&#x43B;&#x438; &#x43D;&#x430;&#x45B;&#x438; &#x43D;&#x430;&#x432;&#x435;&#x434;&#x435;&#x43D;&#x443; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x444;&#x430;&#x458;&#x43B;.",
                  "ziggeoplayer.video-access-forbidden": "&#x41D;&#x438;&#x458;&#x435; &#x432;&#x430;&#x43C; &#x434;&#x43E;&#x437;&#x432;&#x43E;&#x459;&#x435;&#x43D;&#x43E; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F;&#x435; &#x43E;&#x432;&#x43E;&#x43C; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x444;&#x430;&#x458;&#x43B;.",
                  "ziggeoplayer.video-unknown-error": "&#x41C;&#x438; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x43C;&#x43E; &#x434;&#x430; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F;&#x438;&#x442;&#x435; &#x43E;&#x432;&#x43E;&#x43C; &#x432;&#x438;&#x434;&#x435;&#x43E; &#x443; &#x43E;&#x432;&#x43E;&#x43C; &#x442;&#x440;&#x435;&#x43D;&#x443;&#x442;&#x43A;&#x443;. &#x41F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x458;&#x442;&#x435; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E; &#x43A;&#x430;&#x441;&#x43D;&#x438;&#x458;&#x435;.",
                  "ziggeoplayer.video-rejected": "&#x412;&#x438;&#x434;&#x435;&#x43E; &#x458;&#x435; &#x43E;&#x434;&#x431;&#x438;&#x458;&#x435;&#x43D;.",
                  "ziggeoplayer.video-processing": "&#x412;&#x438;&#x434;&#x435;&#x43E; &#x43E;&#x431;&#x440;&#x430;&#x452;&#x443;&#x458;&#x435; - &#x441;&#x442;&#x430;&#x438; &#x442;&#x443;&#x43D;&#x435;&#x434;.",
                  "ziggeoplayer.video-access-error": "&#x412;&#x438;&#x434;&#x435;&#x43E; &#x458;&#x435; &#x442;&#x440;&#x435;&#x43D;&#x443;&#x442;&#x43D;&#x43E; &#x443; &#x444;&#x430;&#x437;&#x438; &#x443;&#x43C;&#x435;&#x440;&#x435;&#x43D;&#x43E;&#x441;&#x442;&#x438;. &#x41C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x434;&#x430; &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x434;&#x430; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x435;.",
                  "ziggeoaudioplayer.audio-not-found": "&#x41D;&#x438;&#x441;&#x43C;&#x43E; &#x43C;&#x43E;&#x433;&#x43B;&#x438; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x43D;&#x430;&#x452;&#x435;&#x43C;&#x43E; &#x43D;&#x430;&#x432;&#x435;&#x434;&#x435;&#x43D;&#x443; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x443;.",
                  "ziggeoaudioplayer.audio-access-forbidden": "&#x41D;&#x438;&#x458;&#x435; &#x432;&#x430;&#x43C; &#x434;&#x43E;&#x437;&#x432;&#x43E;&#x459;&#x435;&#x43D; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F; &#x43E;&#x432;&#x43E;&#x458; &#x430;&#x443;&#x434;&#x438;&#x43E; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x446;&#x438;.",
                  "ziggeoaudioplayer.audio-unknown-error": "&#x422;&#x440;&#x435;&#x43D;&#x443;&#x442;&#x43D;&#x43E; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x43C;&#x43E; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F;&#x438;&#x442;&#x438; &#x43E;&#x432;&#x43E;&#x43C; &#x437;&#x432;&#x443;&#x43A;&#x443;. &#x41F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x458;&#x442;&#x435; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E; &#x43A;&#x430;&#x441;&#x43D;&#x438;&#x458;&#x435;.",
                  "ziggeoaudioplayer.audio-rejected": "&#x417;&#x432;&#x443;&#x43A; &#x458;&#x435; &#x43E;&#x434;&#x431;&#x438;&#x458;&#x435;&#x43D;.",
                  "ziggeoaudioplayer.audio-processing": "&#x417;&#x432;&#x443;&#x43A; &#x441;&#x435; &#x43E;&#x431;&#x440;&#x430;&#x452;&#x443;&#x458;&#x435; - &#x43F;&#x440;&#x430;&#x442;&#x438;&#x442;&#x435; &#x43D;&#x430;&#x441;.",
                  "ziggeoaudioplayer.audio-access-error": "&#x417;&#x432;&#x443;&#x43A; &#x458;&#x435; &#x442;&#x440;&#x435;&#x43D;&#x443;&#x442;&#x43D;&#x43E; &#x43F;&#x43E;&#x434; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x438;&#x440;&#x430;&#x45A;&#x435;&#x43C;. &#x41C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x434;&#x430; &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;.",
                  "ziggeoimageviewer.image-not-found": "&#x41D;&#x438;&#x441;&#x43C;&#x43E; &#x43C;&#x43E;&#x433;&#x43B;&#x438; &#x434;&#x430; &#x43F;&#x440;&#x43E;&#x43D;&#x430;&#x452;&#x435;&#x43C;&#x43E; &#x43D;&#x430;&#x432;&#x435;&#x434;&#x435;&#x43D;&#x443; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x43A;&#x443; &#x441;&#x43B;&#x438;&#x43A;&#x435;.",
                  "ziggeoimageviewer.image-access-forbidden": "&#x41D;&#x438;&#x458;&#x435; &#x432;&#x430;&#x43C; &#x434;&#x43E;&#x437;&#x432;&#x43E;&#x459;&#x435;&#x43D; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F; &#x43E;&#x432;&#x43E;&#x458; &#x434;&#x430;&#x442;&#x43E;&#x442;&#x435;&#x446;&#x438; &#x441;&#x43B;&#x438;&#x43A;&#x435;.",
                  "ziggeoimageviewer.image-unknown-error": "&#x422;&#x440;&#x435;&#x43D;&#x443;&#x442;&#x43D;&#x43E; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x43C;&#x43E; &#x43F;&#x440;&#x438;&#x441;&#x442;&#x443;&#x43F;&#x438;&#x442;&#x438; &#x43E;&#x432;&#x43E;&#x458; &#x441;&#x43B;&#x438;&#x446;&#x438;. &#x41F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x458;&#x442;&#x435; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E; &#x43A;&#x430;&#x441;&#x43D;&#x438;&#x458;&#x435;.",
                  "ziggeoimageviewer.image-rejected": "&#x421;&#x43B;&#x438;&#x43A;&#x430; &#x458;&#x435; &#x43E;&#x434;&#x431;&#x438;&#x458;&#x435;&#x43D;&#x430;.",
                  "ziggeoimageviewer.image-processing": "&#x421;&#x43B;&#x438;&#x43A;&#x430; &#x441;&#x435; &#x43E;&#x431;&#x440;&#x430;&#x452;&#x443;&#x458;&#x435; - &#x43F;&#x440;&#x430;&#x442;&#x438;&#x442;&#x435; &#x43D;&#x430;&#x441;.",
                  "ziggeoimageviewer.image-access-error": "&#x421;&#x43B;&#x438;&#x43A;&#x430; &#x458;&#x435; &#x442;&#x440;&#x435;&#x43D;&#x443;&#x442;&#x43D;&#x43E; &#x43F;&#x43E;&#x434; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x438;&#x440;&#x430;&#x45A;&#x435;&#x43C;. &#x41C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x434;&#x430; &#x43A;&#x43B;&#x438;&#x43A;&#x43D;&#x435;&#x442;&#x435; &#x434;&#x430; &#x431;&#x438;&#x441;&#x442;&#x435; &#x43F;&#x43E;&#x43A;&#x443;&#x448;&#x430;&#x43B;&#x438; &#x43F;&#x43E;&#x43D;&#x43E;&#x432;&#x43E;."
                },
                "language:sv": {
                  "application.error_503": "Just nu underh&#xE5;ller vi v&#xE5;r tj&#xE4;nst. Vi &#xE4;r snart tillbaka.",
                  "application.error_404": "Vi k&#xE4;nner inte igen din API-nyckel. V&#xE4;nligen kontrollera att den finns i webbplatsens sidhuvud.",
                  "application.error_401": "Du har inte tillg&#xE5;ng till applikationen fr&#xE5;n denna sida.",
                  "application.error_412": "Du m&#xE5;ste bekr&#xE4;fta / uppgradera ditt konto.",
                  "application.error_unknown": "Ett ok&#xE4;nt fel uppstod. V&#xE5;rt team har informerats och jobbar p&#xE5; att l&#xF6;sa problemet.",
                  "ziggeoaudioplayer.audio-not-found": "Vi kunde inte hitta den valda ljudfilen.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Du har inte tillg&#xE5;ng till den valda ljudfilen.",
                  "ziggeoaudioplayer.audio-unknown-error": "Vi kan f&#xF6;r n&#xE4;rvarande inte komma &#xE5;t den valda ljudfilen. V&#xE4;nligen f&#xF6;rs&#xF6;k igen senare.",
                  "ziggeoaudioplayer.audio-rejected": "Ljudet har nekats.",
                  "ziggeoaudioplayer.audio-processing": "Ljudet bearbetas - h&#xE4;ng kvar.",
                  "ziggeoaudioplayer.audio-access-error": "Ljudet modereras f&#xF6;r n&#xE4;rvarande. Klicka f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ziggeoimageviewer.image-not-found": "Vi kunde inte hitta den valda bildfilen.",
                  "ziggeoimageviewer.image-access-forbidden": "Du har inte tillg&#xE5;ng till den valda bildfilen.",
                  "ziggeoimageviewer.image-unknown-error": "Vi kan f&#xF6;r n&#xE4;rvarande inte komma &#xE5;t den valda bildfilen. V&#xE4;nligen f&#xF6;rs&#xF6;k igen senare.",
                  "ziggeoimageviewer.image-rejected": "Bilden har nekats.",
                  "ziggeoimageviewer.image-processing": "Bilden bearbetas - h&#xE4;ng kvar.",
                  "ziggeoimageviewer.image-access-error": "Bilden modereras f&#xF6;r n&#xE4;rvarande. Klicka f&#xF6;r att f&#xF6;rs&#xF6;ka igen.",
                  "ziggeoplayer.video-not-found": "Vi kunde inte hitta den valda videofilen.",
                  "ziggeoplayer.video-access-forbidden": "Du har inte tillg&#xE5;ng till den valda videofilen.",
                  "ziggeoplayer.video-unknown-error": "Vi kan f&#xF6;r n&#xE4;rvarande inte komma &#xE5;t den valda videofilen. V&#xE4;nligen f&#xF6;rs&#xF6;k igen senare.",
                  "ziggeoplayer.video-rejected": "Videon har nekats.",
                  "ziggeoplayer.video-processing": "Videon bearbetas - h&#xE4;ng kvar.",
                  "ziggeoplayer.video-access-error": "Videon modereras f&#xF6;r n&#xE4;rvarande. Klicka f&#xF6;r att f&#xF6;rs&#xF6;ka igen."
                },
                "language:tl": {
                  "application.error_503": "Kasalukuyan naming pinapanatili ang aming serbisyo. Video ay maaaring bumalik sa lalong madaling panahon.",
                  "application.error_404": "Hindi namin makilala ang iyong api key. Mangyaring siguraduhin na tukuyin ito sa header ng iyong website.",
                  "application.error_401": "Hindi ka pinapayagang i-access ang application mula sa site na ito.",
                  "application.error_412": "Kailangan mong kumpirmahin / i-upgrade ang iyong account.",
                  "application.error_unknown": "Isang hindi matukoy na error ang naganap. Ang aming koponan ay aabisuhan at kukumpirmahing malutas ang isyu.",
                  "ziggeoaudioplayer.audio-not-found": "Hindi namin makita ang tinutukoy na audio file.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Ikaw ay hindi pinapayagan na ma-access ang audio file na ito.",
                  "ziggeoaudioplayer.audio-unknown-error": "Hindi namin ma-access ang video sa sandaling ito. Subukang muli mamaya.",
                  "ziggeoaudioplayer.audio-rejected": "Ang audio na ito ay tinanggihan.",
                  "ziggeoaudioplayer.audio-processing": "Ang audio ay pinoproseso - manatiling nakatutok.",
                  "ziggeoaudioplayer.audio-access-error": "Ang audio na ito ay kasalukuyang sumasailalim sa moderasyon. Maaari mong i-click upang subukang muli.",
                  "ziggeoimageviewer.image-not-found": "Hindi namin makita ang tinutukoy na imahe.",
                  "ziggeoimageviewer.image-access-forbidden": "Ikaw ay hindi pinapayagan na ma-access ang imaheng ito.",
                  "ziggeoimageviewer.image-unknown-error": "Hindi namin ma-access ang imahe sa sandaling ito. Subukang muli mamaya.",
                  "ziggeoimageviewer.image-rejected": "Ang imaheng ito ay tinanggihan.",
                  "ziggeoimageviewer.image-processing": "Ang imahe ay pinoproseso - manatiling nakatutok.",
                  "ziggeoimageviewer.image-access-error": "Ang imaheng ito ay kasalukuyang sumasailalim sa moderasyon. Maari mong i-click upang subukang muli.",
                  "ziggeoplayer.video-not-found": "Hindi kami makahanap ng ang tinukoy na file na video.",
                  "ziggeoplayer.video-access-forbidden": "Ikaw ay hindi pinapayagan na ma-access ang video file na ito.",
                  "ziggeoplayer.video-unknown-error": "Hindi namin ma-access ang video sa sandaling ito. Subukang muli mamaya.",
                  "ziggeoplayer.video-rejected": "Ang video na ito ay tinanggihan.",
                  "ziggeoplayer.video-processing": "Ang video ay pinoproseso - manatiling nakatutok.",
                  "ziggeoplayer.video-access-error": "Ang video na ito ay kasalukuyang sumasailalim sa moderasyon. Maaari mong i-click upang subukang muli."
                },
                "language:tr": {
                  "application.error_503": "Biz hizmetimizi s&#xFC;rd&#xFC;rmekteyiz. Videolar geri yak&#x131;nda olacak.",
                  "application.error_404": "Biz API anahtar&#x131;n&#x131; tan&#x131;yamaz. Web sitenizin ba&#x15F;l&#x131;&#x11F;&#x131;nda bunu belirtmek i&#xE7;in emin olun.",
                  "application.error_401": "Bu siteden uygulamaya eri&#x15F;mek i&#xE7;in izin verilmez.",
                  "application.error_412": "Sen / onaylamak hesab&#x131;n&#x131;z&#x131; y&#xFC;kseltmeniz gerekir.",
                  "application.error_unknown": "Bilinmeyen bir hata olu&#x15F;tu. Ekibimiz tebli&#x11F; edilmi&#x15F; ve sorunu &#xE7;&#xF6;zecektir.",
                  "ziggeoplayer.video-not-found": "Biz Belirtilen video dosyas&#x131;n&#x131; bulamad&#x131;.",
                  "ziggeoplayer.video-access-forbidden": "Bu g&#xF6;r&#xFC;nt&#xFC;l&#xFC; dosyaya eri&#x15F;mek i&#xE7;in izin verilmez.",
                  "ziggeoplayer.video-unknown-error": "Biz &#x15F;u anda bu videoyu eri&#x15F;emiyor. L&#xFC;tfen daha sonra tekrar deneyiniz.",
                  "ziggeoplayer.video-rejected": "Video reddedildi.",
                  "ziggeoplayer.video-processing": "Video i&#x15F;leme - bizi izlemeye devam edin.",
                  "ziggeoplayer.video-access-error": "Video &#x131;l&#x131;ml&#x131;l&#x131;k a&#x15F;amas&#x131;ndad&#x131;r. Tekrar denemek i&#xE7;in t&#x131;klayabilirsiniz.",
                  "ziggeoaudioplayer.audio-not-found": "Belirtilen ses dosyas&#x131;n&#x131; bulamad&#x131;k.",
                  "ziggeoaudioplayer.audio-access-forbidden": "Bu ses dosyas&#x131;na eri&#x15F;im izniniz yok.",
                  "ziggeoaudioplayer.audio-unknown-error": "&#x15E;u anda bu sese eri&#x15F;emiyoruz. L&#xFC;tfen daha sonra tekrar deneyiniz.",
                  "ziggeoaudioplayer.audio-rejected": "Ses reddedildi.",
                  "ziggeoaudioplayer.audio-processing": "Ses i&#x15F;leniyor - bizi izlemeye devam edin.",
                  "ziggeoaudioplayer.audio-access-error": "Ses &#x15F;u anda denetleniyor. Yeniden denemek i&#xE7;in t&#x131;klayabilirsiniz.",
                  "ziggeoimageviewer.image-not-found": "Belirtilen g&#xF6;r&#xFC;nt&#xFC; dosyas&#x131;n&#x131; bulamad&#x131;k.",
                  "ziggeoimageviewer.image-access-forbidden": "Bu g&#xF6;r&#xFC;nt&#xFC; dosyas&#x131;na eri&#x15F;im izniniz yok.",
                  "ziggeoimageviewer.image-unknown-error": "Bu resme &#x15F;u anda eri&#x15F;emiyoruz. L&#xFC;tfen daha sonra tekrar deneyiniz.",
                  "ziggeoimageviewer.image-rejected": "G&#xF6;r&#xFC;nt&#xFC; reddedildi.",
                  "ziggeoimageviewer.image-processing": "G&#xF6;r&#xFC;nt&#xFC; i&#x15F;leniyor - bizi izlemeye devam edin.",
                  "ziggeoimageviewer.image-access-error": "G&#xF6;r&#xFC;nt&#xFC; &#x15F;u anda denetleniyor. Yeniden denemek i&#xE7;in t&#x131;klayabilirsiniz."
                },
                "language:uk": {
                  "application.error_503": "&#x41C;&#x438; &#x43F;&#x456;&#x434;&#x442;&#x440;&#x438;&#x43C;&#x443;&#x454;&#x43C;&#x43E; &#x43D;&#x430;&#x448; &#x441;&#x435;&#x440;&#x432;&#x456;&#x441;. &#x41C;&#x438; &#x441;&#x43A;&#x43E;&#x440;&#x43E; &#x43F;&#x43E;&#x432;&#x435;&#x440;&#x43D;&#x435;&#x43C;&#x43E;&#x441;&#x44C;.",
                  "application.error_404": "&#x41C;&#x438; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x43C;&#x43E; &#x440;&#x43E;&#x437;&#x43F;&#x456;&#x437;&#x43D;&#x430;&#x442;&#x438; &#x432;&#x430;&#x448; &#x43A;&#x43B;&#x44E;&#x447; API. &#x411;&#x443;&#x434;&#x44C; &#x43B;&#x430;&#x441;&#x43A;&#x430;, &#x43E;&#x431;&#x43E;&#x432;&#x2019;&#x44F;&#x437;&#x43A;&#x43E;&#x432;&#x43E; &#x432;&#x43A;&#x430;&#x436;&#x456;&#x442;&#x44C; &#x446;&#x435; &#x443; &#x437;&#x430;&#x433;&#x43E;&#x43B;&#x43E;&#x432;&#x43A;&#x443; &#x432;&#x435;&#x431;-&#x441;&#x430;&#x439;&#x442;&#x443;.",
                  "application.error_401": "&#x412;&#x438; &#x43D;&#x435; &#x43C;&#x430;&#x454;&#x442;&#x435; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x443; &#x434;&#x43E; &#x43F;&#x440;&#x43E;&#x433;&#x440;&#x430;&#x43C;&#x438; &#x437; &#x446;&#x44C;&#x43E;&#x433;&#x43E; &#x432;&#x435;&#x431;-&#x441;&#x430;&#x439;&#x442;&#x443;.",
                  "application.error_412": "&#x412;&#x430;&#x43C; &#x43F;&#x43E;&#x442;&#x440;&#x456;&#x431;&#x43D;&#x43E; &#x43F;&#x456;&#x434;&#x442;&#x432;&#x435;&#x440;&#x434;&#x438;&#x442;&#x438; / &#x43E;&#x43D;&#x43E;&#x432;&#x438;&#x442;&#x438; &#x441;&#x432;&#x456;&#x439; &#x440;&#x430;&#x445;&#x443;&#x43D;&#x43E;&#x43A;.",
                  "application.error_unknown": "&#x421;&#x442;&#x430;&#x43B;&#x430;&#x441;&#x44F; &#x43D;&#x435;&#x432;&#x456;&#x434;&#x43E;&#x43C;&#x430; &#x43F;&#x43E;&#x43C;&#x438;&#x43B;&#x43A;&#x430;. &#x41D;&#x430;&#x448;&#x430; &#x43A;&#x43E;&#x43C;&#x430;&#x43D;&#x434;&#x430; &#x43E;&#x442;&#x440;&#x438;&#x43C;&#x430;&#x43B;&#x430; &#x43F;&#x43E;&#x432;&#x456;&#x434;&#x43E;&#x43C;&#x43B;&#x435;&#x43D;&#x43D;&#x44F; &#x442;&#x430; &#x432;&#x438;&#x440;&#x456;&#x448;&#x438;&#x442;&#x44C; &#x43F;&#x440;&#x43E;&#x431;&#x43B;&#x435;&#x43C;&#x443;.",
                  "ziggeoaudioplayer.audio-not-found": "&#x41D;&#x435; &#x432;&#x434;&#x430;&#x43B;&#x43E;&#x441;&#x44F; &#x437;&#x43D;&#x430;&#x439;&#x442;&#x438; &#x432;&#x43A;&#x430;&#x437;&#x430;&#x43D;&#x438;&#x439; &#x430;&#x443;&#x434;&#x456;&#x43E;&#x444;&#x430;&#x439;&#x43B;.",
                  "ziggeoaudioplayer.audio-access-forbidden": "&#x412;&#x438; &#x43D;&#x435; &#x43C;&#x430;&#x454;&#x442;&#x435; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x443; &#x434;&#x43E; &#x446;&#x44C;&#x43E;&#x433;&#x43E; &#x430;&#x443;&#x434;&#x456;&#x43E;&#x444;&#x430;&#x439;&#x43B;&#x443;.",
                  "ziggeoaudioplayer.audio-unknown-error": "&#x41D;&#x430; &#x434;&#x430;&#x43D;&#x438;&#x439; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442; &#x43C;&#x438; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x43C;&#x43E; &#x43E;&#x442;&#x440;&#x438;&#x43C;&#x430;&#x442;&#x438; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x434;&#x43E; &#x446;&#x44C;&#x43E;&#x433;&#x43E; &#x430;&#x443;&#x434;&#x456;&#x43E;. &#x411;&#x443;&#x434;&#x44C;-&#x43B;&#x430;&#x441;&#x43A;&#x430; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x439;&#x442;&#x435; &#x43F;&#x456;&#x437;&#x43D;&#x456;&#x448;&#x435;.",
                  "ziggeoaudioplayer.audio-rejected": "&#x410;&#x443;&#x434;&#x456;&#x43E; &#x432;&#x456;&#x434;&#x445;&#x438;&#x43B;&#x435;&#x43D;&#x43E;.",
                  "ziggeoaudioplayer.audio-processing": "&#x410;&#x443;&#x434;&#x456;&#x43E; &#x43E;&#x431;&#x440;&#x43E;&#x431;&#x43B;&#x44F;&#x454;&#x442;&#x44C;&#x441;&#x44F; - &#x441;&#x442;&#x435;&#x436;&#x442;&#x435; &#x437;&#x430; &#x43E;&#x43D;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x43D;&#x44F;&#x43C;&#x438;.",
                  "ziggeoaudioplayer.audio-access-error": "&#x41D;&#x430;&#x440;&#x430;&#x437;&#x456; &#x430;&#x443;&#x434;&#x456;&#x43E; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x443;&#x454;&#x442;&#x44C;&#x441;&#x44F;. &#x412;&#x438; &#x43C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x443;&#x442;&#x438;, &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;.",
                  "ziggeoimageviewer.image-not-found": "&#x41D;&#x435; &#x432;&#x434;&#x430;&#x43B;&#x43E;&#x441;&#x44F; &#x437;&#x43D;&#x430;&#x439;&#x442;&#x438; &#x432;&#x43A;&#x430;&#x437;&#x430;&#x43D;&#x438;&#x439; &#x444;&#x430;&#x439;&#x43B; &#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F;.",
                  "ziggeoimageviewer.image-access-forbidden": "&#x412;&#x438; &#x43D;&#x435; &#x43C;&#x430;&#x454;&#x442;&#x435; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x443; &#x434;&#x43E; &#x446;&#x44C;&#x43E;&#x433;&#x43E; &#x444;&#x430;&#x439;&#x43B;&#x443; &#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F;.",
                  "ziggeoimageviewer.image-unknown-error": "&#x41D;&#x430; &#x434;&#x430;&#x43D;&#x438;&#x439; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442; &#x43C;&#x438; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x43C;&#x43E; &#x43E;&#x442;&#x440;&#x438;&#x43C;&#x430;&#x442;&#x438; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x434;&#x43E; &#x446;&#x44C;&#x43E;&#x433;&#x43E; &#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F;. &#x411;&#x443;&#x434;&#x44C;-&#x43B;&#x430;&#x441;&#x43A;&#x430; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x439;&#x442;&#x435; &#x43F;&#x456;&#x437;&#x43D;&#x456;&#x448;&#x435;.",
                  "ziggeoimageviewer.image-rejected": "&#x417;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x432;&#x456;&#x434;&#x445;&#x438;&#x43B;&#x435;&#x43D;&#x43E;.",
                  "ziggeoimageviewer.image-processing": "&#x417;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x43E;&#x431;&#x440;&#x43E;&#x431;&#x43B;&#x44F;&#x454;&#x442;&#x44C;&#x441;&#x44F; - &#x441;&#x442;&#x435;&#x436;&#x442;&#x435; &#x437;&#x430; &#x43E;&#x43D;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x43D;&#x44F;&#x43C;&#x438;.",
                  "ziggeoimageviewer.image-access-error": "&#x41D;&#x430;&#x440;&#x430;&#x437;&#x456; &#x437;&#x43E;&#x431;&#x440;&#x430;&#x436;&#x435;&#x43D;&#x43D;&#x44F; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x443;&#x454;&#x442;&#x44C;&#x441;&#x44F;. &#x412;&#x438; &#x43C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x443;&#x442;&#x438;, &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;.",
                  "ziggeoplayer.video-not-found": "&#x41D;&#x435; &#x432;&#x434;&#x430;&#x43B;&#x43E;&#x441;&#x44F; &#x437;&#x43D;&#x430;&#x439;&#x442;&#x438; &#x432;&#x43A;&#x430;&#x437;&#x430;&#x43D;&#x438;&#x439; &#x432;&#x456;&#x434;&#x435;&#x43E;&#x444;&#x430;&#x439;&#x43B;.",
                  "ziggeoplayer.video-access-forbidden": "&#x412;&#x438; &#x43D;&#x435; &#x43C;&#x430;&#x454;&#x442;&#x435; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F;&#x443; &#x434;&#x43E; &#x446;&#x44C;&#x43E;&#x433;&#x43E; &#x432;&#x456;&#x434;&#x435;&#x43E;&#x444;&#x430;&#x439;&#x43B;&#x443;.",
                  "ziggeoplayer.video-unknown-error": "&#x41D;&#x430; &#x434;&#x430;&#x43D;&#x438;&#x439; &#x43C;&#x43E;&#x43C;&#x435;&#x43D;&#x442; &#x43C;&#x438; &#x43D;&#x435; &#x43C;&#x43E;&#x436;&#x435;&#x43C;&#x43E; &#x43E;&#x442;&#x440;&#x438;&#x43C;&#x430;&#x442;&#x438; &#x434;&#x43E;&#x441;&#x442;&#x443;&#x43F; &#x434;&#x43E; &#x446;&#x44C;&#x43E;&#x433;&#x43E; &#x432;&#x456;&#x434;&#x435;&#x43E;. &#x411;&#x443;&#x434;&#x44C;-&#x43B;&#x430;&#x441;&#x43A;&#x430; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;&#x439;&#x442;&#x435; &#x43F;&#x456;&#x437;&#x43D;&#x456;&#x448;&#x435;.",
                  "ziggeoplayer.video-rejected": "&#x412;&#x456;&#x434;&#x435;&#x43E; &#x432;&#x456;&#x434;&#x445;&#x438;&#x43B;&#x435;&#x43D;&#x43E;.",
                  "ziggeoplayer.video-processing": "&#x412;&#x456;&#x434;&#x435;&#x43E; &#x43E;&#x431;&#x440;&#x43E;&#x431;&#x43B;&#x44F;&#x454;&#x442;&#x44C;&#x441;&#x44F; - &#x441;&#x442;&#x435;&#x436;&#x442;&#x435; &#x437;&#x430; &#x43E;&#x43D;&#x43E;&#x432;&#x43B;&#x435;&#x43D;&#x43D;&#x44F;&#x43C;&#x438;.",
                  "ziggeoplayer.video-access-error": "&#x41D;&#x430;&#x440;&#x430;&#x437;&#x456; &#x432;&#x456;&#x434;&#x435;&#x43E; &#x43C;&#x43E;&#x434;&#x435;&#x440;&#x443;&#x454;&#x442;&#x44C;&#x441;&#x44F;. &#x412;&#x438; &#x43C;&#x43E;&#x436;&#x435;&#x442;&#x435; &#x43D;&#x430;&#x442;&#x438;&#x441;&#x43D;&#x443;&#x442;&#x438;, &#x449;&#x43E;&#x431; &#x43F;&#x43E;&#x432;&#x442;&#x43E;&#x440;&#x438;&#x442;&#x438; &#x441;&#x43F;&#x440;&#x43E;&#x431;&#x443;."
                },
                "language:zh-cn": {
                  "application.error_503": "&#x670D;&#x52A1;&#x5668;&#x6B63;&#x5728;&#x7EF4;&#x62A4;&#x4E2D;&#xFF0C;&#x7A0D;&#x540E;&#x5C31;&#x4F1A;&#x6062;&#x590D;&#x3002;",
                  "application.error_404": "&#x6211;&#x4EEC;&#x65E0;&#x6CD5;&#x9A8C;&#x8BC1;&#x60A8;&#x7684;&#x5E94;&#x7528;&#x91D1;&#x94A5;&#xFF0C;&#x8BF7;&#x786E;&#x5B9A;&#x60A8;&#x6709;&#x5728;&#x7F51;&#x7AD9;&#x914D;&#x7F6E;&#x53C2;&#x6570;&#x4E2D;&#x6B63;&#x786E;&#x6307;&#x5B9A;&#x4E86;&#x91D1;&#x94A5;&#x3002;",
                  "application.error_401": "&#x672A;&#x7ECF;&#x6388;&#x6743;&#x7684;&#x5E94;&#x7528;&#xFF0C;&#x8BF7;&#x786E;&#x8BA4;&#x3002;",
                  "application.error_412": "&#x60A8;&#x5FC5;&#x987B;&#x786E;&#x8BA4;/&#x66F4;&#x65B0;&#x60A8;&#x7684;&#x5E10;&#x6237;&#x3002;",
                  "application.error_unknown": "&#x53D1;&#x751F;&#x4E86;&#x672A;&#x77E5;&#x7684;&#x9519;&#x8BEF;&#xFF0C;&#x5DF2;&#x901A;&#x77E5;&#x5DE5;&#x4F5C;&#x56E2;&#x961F;&#x6765;&#x6392;&#x9664;&#x6B64;&#x95EE;&#x9898;&#x3002;",
                  "ziggeoplayer.video-not-found": "&#x65E0;&#x6CD5;&#x627E;&#x5230;&#x8BE5;&#x5F71;&#x7247;&#x3002;",
                  "ziggeoplayer.video-access-forbidden": "&#x672A;&#x6388;&#x6743;&#x5B58;&#x53D6;&#x6B64;&#x5F71;&#x7247;&#x3002;",
                  "ziggeoplayer.video-unknown-error": "&#x6682;&#x65F6;&#x65E0;&#x6CD5;&#x5B58;&#x53D6;&#x6B64;&#x5F71;&#x7247;&#xFF0C;&#x8BF7;&#x7A0D;&#x540E;&#x518D;&#x8BD5;&#x3002;",
                  "ziggeoplayer.video-rejected": "&#x62D2;&#x7EDD;&#x5B58;&#x53D6;&#x5F71;&#x7247;&#x3002;",
                  "ziggeoplayer.video-processing": "&#x5F71;&#x7247;&#x5904;&#x7406;&#x4E2D;&#xFF0C;&#x8BF7;&#x7A0D;&#x5019;&#x3002;",
                  "ziggeoplayer.video-access-error": "&#x5F71;&#x7247;&#x6B63;&#x5728;&#x8F6C;&#x6863;&#x4E2D;&#xFF0C;&#x8BF7;&#x7A0D;&#x540E;&#x518D;&#x8BD5;&#x3002;",
                  "ziggeoaudioplayer.audio-not-found": "&#x6211;&#x4EEC;&#x627E;&#x4E0D;&#x5230;&#x6307;&#x5B9A;&#x7684;&#x97F3;&#x9891;&#x6587;&#x4EF6;&#x3002;",
                  "ziggeoaudioplayer.audio-access-forbidden": "&#x60A8;&#x65E0;&#x6743;&#x8BBF;&#x95EE;&#x6B64;&#x97F3;&#x9891;&#x6587;&#x4EF6;&#x3002;",
                  "ziggeoaudioplayer.audio-unknown-error": "&#x76EE;&#x524D;&#x6211;&#x4EEC;&#x65E0;&#x6CD5;&#x8BBF;&#x95EE;&#x6B64;&#x97F3;&#x9891;&#x3002;&#x8BF7;&#x7A0D;&#x540E;&#x518D;&#x8BD5;&#x3002;",
                  "ziggeoaudioplayer.audio-rejected": "&#x97F3;&#x9891;&#x5DF2;&#x88AB;&#x62D2;&#x7EDD;&#x3002;",
                  "ziggeoaudioplayer.audio-processing": "&#x97F3;&#x9891;&#x6B63;&#x5728;&#x5904;&#x7406;-&#x656C;&#x8BF7;&#x671F;&#x5F85;&#x3002;",
                  "ziggeoaudioplayer.audio-access-error": "&#x97F3;&#x9891;&#x5F53;&#x524D;&#x5904;&#x4E8E;&#x4E2D;&#x7B49;&#x72B6;&#x6001;&#x3002;&#x60A8;&#x53EF;&#x4EE5;&#x5355;&#x51FB;&#x91CD;&#x8BD5;&#x3002;",
                  "ziggeoimageviewer.image-not-found": "&#x6211;&#x4EEC;&#x627E;&#x4E0D;&#x5230;&#x6307;&#x5B9A;&#x7684;&#x56FE;&#x50CF;&#x6587;&#x4EF6;&#x3002;",
                  "ziggeoimageviewer.image-access-forbidden": "&#x60A8;&#x65E0;&#x6743;&#x8BBF;&#x95EE;&#x6B64;&#x56FE;&#x50CF;&#x6587;&#x4EF6;&#x3002;",
                  "ziggeoimageviewer.image-unknown-error": "&#x6211;&#x4EEC;&#x76EE;&#x524D;&#x65E0;&#x6CD5;&#x8BBF;&#x95EE;&#x8BE5;&#x56FE;&#x50CF;&#x3002;&#x8BF7;&#x7A0D;&#x540E;&#x518D;&#x8BD5;&#x3002;",
                  "ziggeoimageviewer.image-rejected": "&#x56FE;&#x7247;&#x5DF2;&#x88AB;&#x62D2;&#x7EDD;&#x3002;",
                  "ziggeoimageviewer.image-processing": "&#x56FE;&#x7247;&#x6B63;&#x5728;&#x5904;&#x7406;-&#x8BF7;&#x7EE7;&#x7EED;&#x5173;&#x6CE8;&#x3002;",
                  "ziggeoimageviewer.image-access-error": "&#x8BE5;&#x56FE;&#x50CF;&#x5F53;&#x524D;&#x5904;&#x4E8E;&#x5BA1;&#x6838;&#x72B6;&#x6001;&#x3002;&#x60A8;&#x53EF;&#x4EE5;&#x5355;&#x51FB;&#x91CD;&#x8BD5;&#x3002;"
                },
                "language:zh-tw": {
                  "application.error_503": "&#x4F3A;&#x670D;&#x5668;&#x6B63;&#x5728;&#x7DAD;&#x8B77;&#x4E2D;&#xFF0C;&#x670D;&#x52D9;&#x7A0D;&#x5F8C;&#x5C31;&#x6703;&#x6062;&#x5FA9;&#x3002;",
                  "application.error_404": "&#x6211;&#x5011;&#x7121;&#x6CD5;&#x9A57;&#x8B49;&#x60A8;&#x7684; API &#x91D1;&#x9470;&#xFF0C;&#x8ACB;&#x78BA;&#x5B9A;&#x60A8;&#x6709;&#x5728;&#x7DB2;&#x7AD9;&#x914D;&#x7F6E;&#x53C3;&#x6578;&#x4E2D;&#x6B63;&#x78BA;&#x6307;&#x5B9A;&#x4E86;&#x91D1;&#x9470;&#x3002;",
                  "application.error_401": "&#x672A;&#x7D93;&#x6388;&#x6B0A;&#x7684;&#x61C9;&#x7528;&#xFF0C;&#x8ACB;&#x78BA;&#x8A8D;&#x3002;",
                  "application.error_412": "&#x60A8;&#x5FC5;&#x9808;&#x78BA;&#x8A8D;/&#x66F4;&#x65B0;&#x60A8;&#x7684;&#x5E33;&#x865F;&#x3002;",
                  "application.error_unknown": "&#x767C;&#x751F;&#x4E86;&#x672A;&#x77E5;&#x7684;&#x932F;&#x8AA4;&#xFF0C;&#x5DF2;&#x901A;&#x77E5;&#x5DE5;&#x4F5C;&#x5718;&#x968A;&#x4F86;&#x6392;&#x9664;&#x6B64;&#x554F;&#x984C;&#x3002;",
                  "ziggeoplayer.video-not-found": "&#x7121;&#x6CD5;&#x627E;&#x5230;&#x8A72;&#x5F71;&#x7247;&#x3002;",
                  "ziggeoplayer.video-access-forbidden": "&#x672A;&#x6388;&#x6B0A;&#x5B58;&#x53D6;&#x6B64;&#x5F71;&#x7247;&#x3002;",
                  "ziggeoplayer.video-unknown-error": "&#x66AB;&#x6642;&#x7121;&#x6CD5;&#x5B58;&#x53D6;&#x6B64;&#x5F71;&#x7247;&#xFF0C;&#x8ACB;&#x7A0D;&#x5F8C;&#x518D;&#x8A66;&#x3002;",
                  "ziggeoplayer.video-rejected": "&#x62D2;&#x7D55;&#x5B58;&#x53D6;&#x5F71;&#x7247;&#x3002;",
                  "ziggeoplayer.video-processing": "&#x5F71;&#x7247;&#x8655;&#x7406;&#x4E2D;&#xFF0C;&#x8ACB;&#x7A0D;&#x5019;&#x3002;",
                  "ziggeoplayer.video-access-error": "&#x5F71;&#x7247;&#x6B63;&#x5728;&#x8F49;&#x6A94;&#x4E2D;&#xFF0C;&#x8ACB;&#x7A0D;&#x5F8C;&#x518D;&#x8A66;&#x3002;",
                  "ziggeoaudioplayer.audio-not-found": "&#x6211;&#x5011;&#x627E;&#x4E0D;&#x5230;&#x6307;&#x5B9A;&#x7684;&#x97F3;&#x983B;&#x6587;&#x4EF6;&#x3002;",
                  "ziggeoaudioplayer.audio-access-forbidden": "&#x60A8;&#x7121;&#x6B0A;&#x8A2A;&#x554F;&#x6B64;&#x97F3;&#x983B;&#x6587;&#x4EF6;&#x3002;",
                  "ziggeoaudioplayer.audio-unknown-error": "&#x76EE;&#x524D;&#x6211;&#x5011;&#x7121;&#x6CD5;&#x8A2A;&#x554F;&#x6B64;&#x97F3;&#x983B;&#x3002;&#x8ACB;&#x7A0D;&#x5F8C;&#x518D;&#x8A66;&#x3002;",
                  "ziggeoaudioplayer.audio-rejected": "&#x97F3;&#x983B;&#x5DF2;&#x88AB;&#x62D2;&#x7D55;&#x3002;",
                  "ziggeoaudioplayer.audio-processing": "&#x97F3;&#x983B;&#x6B63;&#x5728;&#x8655;&#x7406;-&#x656C;&#x8ACB;&#x671F;&#x5F85;&#x3002;",
                  "ziggeoaudioplayer.audio-access-error": "&#x97F3;&#x983B;&#x7576;&#x524D;&#x8655;&#x65BC;&#x4E2D;&#x7B49;&#x72C0;&#x614B;&#x3002;&#x60A8;&#x53EF;&#x4EE5;&#x55AE;&#x64CA;&#x91CD;&#x8A66;&#x3002;",
                  "ziggeoimageviewer.image-not-found": "&#x6211;&#x5011;&#x627E;&#x4E0D;&#x5230;&#x6307;&#x5B9A;&#x7684;&#x5716;&#x50CF;&#x6587;&#x4EF6;&#x3002;",
                  "ziggeoimageviewer.image-access-forbidden": "&#x60A8;&#x7121;&#x6B0A;&#x8A2A;&#x554F;&#x6B64;&#x5716;&#x50CF;&#x6587;&#x4EF6;&#x3002;",
                  "ziggeoimageviewer.image-unknown-error": "&#x6211;&#x5011;&#x76EE;&#x524D;&#x7121;&#x6CD5;&#x8A2A;&#x554F;&#x8A72;&#x5716;&#x50CF;&#x3002;&#x8ACB;&#x7A0D;&#x5F8C;&#x518D;&#x8A66;&#x3002;",
                  "ziggeoimageviewer.image-rejected": "&#x5716;&#x7247;&#x5DF2;&#x88AB;&#x62D2;&#x7D55;&#x3002;",
                  "ziggeoimageviewer.image-processing": "&#x5716;&#x7247;&#x6B63;&#x5728;&#x8655;&#x7406;-&#x8ACB;&#x7E7C;&#x7E8C;&#x95DC;&#x6CE8;&#x3002;",
                  "ziggeoimageviewer.image-access-error": "&#x8A72;&#x5716;&#x50CF;&#x7576;&#x524D;&#x8655;&#x65BC;&#x5BE9;&#x6838;&#x72C0;&#x614B;&#x3002;&#x60A8;&#x53EF;&#x4EE5;&#x55AE;&#x64CA;&#x91CD;&#x8A66;&#x3002;"
                }
              };
              for (var i in t) e.mainLocale.register(t[i], [i]);
              return {};
            });
          }.call(Scoped), Scoped.detach(!0), oldScoped && oldScoped.attach();
        }.call(this);
        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(128), __webpack_require__(333)(module));

      /***/
    }, /* 335 */
    /***/function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(129);

      /***/
    }
    /******/])
  );
});